/* ============================================================
   CONFIGURATOR BENCH LIB
   assets/configurator-bench-lib.js

   Bench configurator runtime. Mirrors configurator-pool-lib.js pattern:
     - Lightweight controllers stay in this IIFE.
     - Big objects (BenchRenderer, BenchEngine) are exposed directly
       via global.X = {...} so the section's inline boot() can call
       them after exposing window.STATE/THREE/etc.

   Public API exposed on window:
     window.BenchLib            controller (boot, state, handlers)
     window.BenchRenderer       Three.js bench mesh builder
     window.BenchEngine         scene / camera / renderer setup
     window.BenchHandles        drag-handle DOM positioning
     window.BenchBoQ            BoQ formulas (kvh, tst, ror)

   Dependencies (must be on window before any method call):
     window.THREE, window.OrbitControls   (from section module script)
     window.BENCH_BOOT                        (CFG_BOOT payload)
     window.Configurator                   (core: bus, units, log)
   ============================================================ */

(function (global) {
  'use strict';

  var VERSION = 'bench-v423-twisttour';   /* v423 (Marek 2026-11-04 13:3x on the twist bench: the cheeks stay as they are, next the voice tour step): THE TWIST BENCH IN THE TOUR -- its step (clip bench-tour-twist, leva-workers voice run 72, 21 languages) after the bed: framed from the front, the layout switch pulsed and tapped three times -- the slats turning into armchairs, into chairs round the side table, back into the bench (each turn its own 2.4 s animation); TOUR_ORDER + 54; the bed's clip re-voiced without its 'and the newest design'; the bills of every type identical to bench-v422-cheeks */
  /* previous: 'bench-v422-cheeks';   /* v422 (Marek 2026-11-04 13:08 on the twist bench: Ano, bocni cela): THE END CHEEKS -- a quarter disc R 2h (600 / US 24 in.) of the same panel at each end of the rod, round the back's foot (the floor edge the slat's depth, the back edge 2h up, the arc down to the seat's front corner), 3 washers from the end slat, the end washer + nut + cap nut outside it; it stands on its flat edge and never turns, so the nut is tightened against a part that stays put and every slat still turns; the length handle = the bench overall (cheeks included, the slats' count from what is left: 34 at 1.80); billed: the two cheeks interlocked in the cutting plan (712 x 984 mm), +6 washers, the coat, the rod longer; the PDF: a sheet Side panel x2 (bench_wave_rib, existing key) dimensioned + the same QR, the cutting plan with the cheeks' block; the DXF the slat + the cheek side by side (leva-twist-bench-mm.dxf / -inch.dxf); the bills of every other type identical to bench-v421-dxfqr * / */
  /* previous: 'bench-v421-dxfqr';   /* v421 (Marek 2026-11-04 12:08 on the twist bench: DXF ma byt stazitelne jen pomoci QR na blueprints kde je profil tvaru s tagem DXF for downloading, nekde v rohu sheet): no public ?dxf link any more -- when the PDF is made the slat's DXF is stored in leva-share (share-v5) and the QR on the slat sheet is its own unguessable link https://leva-share.long-cloud-d006.workers.dev/f/<id> (the file straight to the phone); the QR in the sheet's top right corner with a dark tag DXF for download (bench_rtb_dxf) and the units; the same file reuses its link * / */
  /* previous: 'bench-v420-podrefs';   /* v420 (Marek 2026-11-04 11:48 "A priprav opet expanzi referencnich projektu - alespon 30, z toho 24 x kitchen pod. V ruznych kombinacich, provedeni. 20 USA, 5 x canada 5 x EU"): THE GARDEN POD'S REFERENCE DESIGNS +30 -- 24 kitchen pods (k9 .. k32: the four counter looks, the six claddings, the three roofs, the three foundations, the seven colours incl. shou sugi ban, 3 / 4 / 5 bays with their equipment, the shelf, four shut) and 6 fitness pods (gf5 .. gf10: lengths, claddings, roofs, J-hooks / dip bars); 20 in the US (36 more towns on the pods' list), 5 in Canada (new: ca: true, REF_PLACES_CA / REF_POOL_CA, US lumber, the document's country CA -- bench-liquid-v90 bref-v5), 5 in Europe (10 more towns); refApply resets the pods' slider second half (kpExt: a design does not save it) * / */
  /* previous: var VERSION = 'bench-v419-twistpanel';   /* v419 (renumbered: the GARDEN POD thread's v417 / v418 came first) (Marek 2026-11-04 11:01-11:15 on the twist bench: animace bez zdvihani -- tvar nechat, pokud se bez nazdvihnuti otacet neda; do blueprints presne okotovany tvar do vsech detailu + QR kod na stazeni DXF tvaru; v rozpoctu chybi deskovy material, realne mnozstvi ft2 / m2 s co nejmensim prorezem, doplnit do BOQ; loziska prodrazi -> he chose 3 washers between two slats): the turn without the lift (no profile can turn in place and still hold a person on its front edge); the catalogue row EGP04001 EDGE-GLUED SOLID WOOD PANEL 40 mm / 1 1/2 in. billed by m2 of the cutting plan (two slats head to toe interlocked, 712 x 872 mm a pair, the offcut only the arches and roundings); 3 M16 washers FAT16001 between every two slats instead of the bearings (9 mm, US 3/8 in.); the PDF part sheets: the slat dimensioned in every detail (+ its QR to the DXF) and the cutting plan; ?dxf=rtb-slat&u=mm|in downloads the DXF *-/ */
  /* previous: 'bench-v418-hingeiso';   /* v418 (Marek 2026-11-04 11:24 "Nejsem si tedy jisty tim tvarem / nakresem pantu. Mohl bys tam udelat i izometricky pohled na samostatny pant?"): THE HINGE ON ITS OWN, ISOMETRIC -- a second gallows sheet after the shop sheet: one hinge as built and pulled apart along its pin (the post dashed, the mounting plate with its four holes, the lug, the lower knuckle with the pin standing up, the sleeve with its bore welded to a stub of the mast), seen from the front, left and above, with the plate's / lug's / knuckle's / sleeve's / pin's sizes; _drawPartSheet draws P.faces (filled white back to front, so nearer parts hide what is behind; outline-only and dashed ones); key configurator.view_iso passed (bench-liquid-v88); the model and the bills unchanged from bench-v417-galsheet * / */
  /* previous: var VERSION = 'bench-v417-galsheet';   /* v417 (Marek 2026-11-04 10:58 "Vzpera u sibenice nesedi presne na plochy vertikalniho a horizontalniho profilu. Udelat do blueprints samostatny vykres teto konstrukce vcetne kloubu a upinaci patky (kazda na 4 vruty)."): THE GARDEN POD FITNESS'S GALLOWS -- the brace a mitred solid (a sheet: one end flat on the mast's face, the other flat on the arm's underside; was a box stopped short of both), a hook plate under the arm with the bag's shackle in its hole, each hinge in two parts (the pin's knuckle on the strap, the mast's sleeve over it), the post plates' four screws 15 mm from the plates' ends (the driver clear of the knuckle); THE GALLOWS' SHOP SHEET in the PDF (and so on the drawings page) -- the side elevation with the hinges' chain, the mast, the arm, the hook's reach, the brace's legs and cut lengths, detail A the hinge from above (x5: the post, plate, strap, knuckle, pin, the mast out and stowed with its swing), detail B the mounting plate from the front (x5: its four holes dimensioned, the screw's name); _drawPartSheet: dashed / axis polylines, bold / sized / right-aligned texts; keys pdf_part_gallows / pdf_part_hinge / pdf_part_post_plate (new, 21 locales), elevation_side / pdf_ortho_* passed (bench-liquid-v87); the bills of every type identical to bench-v416-twistanim in both units *-/ */
  /* previous: var VERSION = 'bench-v416-twistanim';   /* v416 (Marek 2026-11-04 10:43 on the twist bench: pri prepinani tvaru udelej vzdy pomalou animaci prechodu): a layout switch is a slow transition, 3 s -- the whole bench lifted about 13 cm on its rod (a turning slat's corner would dig into the floor), every slat that changes position turned about the rod to its new one (90 or 180 deg, eased), set down again; a new switch mid-way carries on from where the slats are *-/ */
  /* previous: 'bench-v415-gpswing';   /* v415 (Marek 2026-11-04 09:44; on top of the BENCHES thread's bench-v414-twist): THE GARDEN POD FITNESS, ROUND 8 -- the heavy bag on a swing-out gallows (square steel tube mast + arm, a 45 deg brace, two heavy pin hinges whose plates sit on the front left corner post's inner face, four 6x80 each): stowed the arm runs along the pod a little inward and the bag hangs inside past the pulley (the battle rope coiled under it, the bench now standing in front of the wall rack), out the arm stands square to the pod's axis and the bag hangs in front; a 43 in. TV on a 360 deg swivel ceiling mount in the middle (the 2x6 blocking moved off the stored barbell, its socket on the back header teed off the run); the slider's second half on the fitness too: the gallows swings out and the TV turns 25 deg, the rest of the equipment out only at the slider's end; the hammer on the ground beside the tyre, the tyre a real tractor tyre (its section turned, chevron lugs), the battle rope's two ends waved each its own way (one flatter and further); every + disc level or upright (the roof's and the kitchen bays' no longer slanted); the gallows, its hinges, the TV and its mount on MISSING; the bills of every type but 35 / 53 identical to bench-v414-twist in both units * / */
  /* previous: var VERSION = 'bench-v414-twist';   /* v414 (Marek 2026-11-04 09:48 with a reel 'This Bench Transforms With a Simple Twist': muzes postavit dalsi variantu tuto lavici? -- he chose the layout switch and slats of an edge-glued 40 mm panel): TYPE 54, BENCHES & LOUNGE, the twist bench -- identical L-profiled slats on one M16 rod, a thrust bearing between every two; every slat turns by 90 deg to stand on another face with the rod at the same height: seat, armrest (the back tipped forward, 0.60 high, 0.25 past the seat) or table (the back laid down, the front face a top at 0.60); the info-bar switch Bench > Armrests > Side table, the length sets the slats; the panel and the bearings NOT BILLED (MISSING) *-/ */
  /* previous: 'bench-v413-cutpanel';   /* v413 (Marek 2026-11-03 23:46, batch 2): THE SECTION TOOL ON EVERY TYPE of the bench engine -- the rail's cut button (the house line's cut planes, _benchCutKit: X / Y / Z, the side switch, the distance, the arrow dragged) on every type, not the playhouses' only; off on the plan and on another type; the eye's old stage-4 slice gone from its cycle (the sofa: 3 > its seating set); an instanced mesh clipped, not capped; THE GARDEN PODS' PANEL CLADDINGS on the cladding switch after the boards (KP_PCLAD: fibre cement FCP00003 1200 x 600 and corten FVC00101 1000 x 2000 on the upright battens with open joints over them, the battens taped black and a UV-stable black membrane in place of INS00002 (both missing); corrugated steel ROR12004 on the battens laid across, +15 %; fixings by the area FAS55050 12 / FAS00225 6 / 10 a m2; the corner boards and the kitchen's back trims folded of the panel, FAS00225 drawn; the flap's panels on its stiles / blocking); the bills of every type but 35 / 53 identical to bench-v412-gpreal in both units * / */
  /* previous: var VERSION = 'bench-v412-gpreal';   /* v412 (Marek 2026-11-03 23:46, three screenshots): THE GARDEN POD, ROUND 6 -- the corners: the band board the roof's full width over the corner boards' tops and the rakes' ends (the rakes end behind it, the corner boards stop at its foot); the + discs drawn as the core's cycler (two turning arrows, disc f.cyc) on the bays, roof, shelf and the wall bars; the counter's look on the bar's first switch (KP_LOOKS: panels / timber / stone / inox -- the frame with it; the new inox finish: cement board + FVS00101 bonded with FEC00031, the concrete slab; the face's disc gone); the eye's second stage on the pods = the frame only (KP_FRAME_KEEP + the frame's fasteners, the flap's frame on its slider); the green roof the full width (no kerbs: a perforated aluminium edge angle round the roof, missing), its sedum plants and gravel stones drawn (instanced); the kitchen's slider in two halves (the flap, then the drawers out unevenly and the doors open: STATE.kpExt, a view); the grill's hood rounded with end caps, a handle, a thermometer, a sloped control panel with skirted knobs; shou sugi ban on the brush (the pods only: COLOR_SCHEMES.ssb, the cladding on mats.kpClad charred, the frame natural); the bills of every type but 35 / 53 identical to bench-v411-gpcase in both units */
  /* previous: var VERSION = 'bench-v411-gpcase';   /* v411 (Marek 2026-11-03 22:03 "Ty cerne listy vne rohu jsou na co? Predstavoval bych si ze ram vyklopnych dveri bude uvnitr, takze bude konstrukce seamless. Fitness take muzes jeste zuzit ... Chceme to max kompaktni. Cinky a zavazi mohou byt nad sebou, zavazi na olympijskou bench mohou byt na plochou ke stene - mozna tedy case na prumer zavazi plus dvere"): SEAMLESS CORNERS (both types) -- the flap between the end walls (its frame and cladding 2 x (Z1 - 2x3) - 1 cm wide, the catches inside its rail), the band's rails between the end walls' skins, the band board between the corner boards; a 2x3 cleat KVH40060 on each post's front face at its outer edge (6x100 into the post), the end walls' OSB / battens / cladding on to it, a cladding board on the front edge (over the cleat and the skin, flush with the flap's face, 18 ga nails into the cleat and the rails); no black corner trims (the front ones gone, the kitchen's back ones in the cladding's colour); THE FITNESS A CASE -- 0.50 m / US 20 in. deep (a plate's 0.45 m + 5 cm; was 1.45), the struts' feet on the posts (no blocks), one middle stud an end wall; the wall rack 46 cm wide on the posts (the plates on one peg, the kettlebells over them, the dumbbells over those front to back); the bench stored standing on its wheels by the pulley; the pulley column 28 cm; the barbell's hooks between the rafters' hangers; the wall bars 0.60 m / US 24 in. on two wall rails screwed into the posts; the bills of every type but 35 / 53 identical to bench-v410-gpflat in both units */
  /* previous: var VERSION = 'bench-v410-gpflat';   ( v410 (Marek 2026-11-03 21:41 "Ale oba moduly muzou byt daleko uzsi. Kuchyn na nejsirsiho modulu plus 15 cm. Rovna strecha. I fitness ma byt koncipovany tak, ze lavicka atd se vlozi na sirku. Lana prosim zvlnena, lnena, cerne rucky na konci. Zebrik kovovy, vyloznik dole i s olympijskou tyci. Boxovaci pytel realisticky tvar, barva hnedocervena. Jednorucky, kettlebelly na drzaku na stene (na druhe nez je kladka). Lavicka s moznosti nastaveni uhlu zad. Take realisticke."): GARDEN POD NARROWER, ITS ROOF LEVEL -- the kitchen (35) 0.80 m / US 31 in. deep (the back wall's studs + the modules' gap + depth + 15 cm / 6 in.; was 0.90), the fitness (53) 1.45 m / US 57 in. (the bench 1.30 m across + 15 cm; was 1.80); the roof at 2 deg for both (was 5: level to the eye, the water still runs off); the fitness: the steel wall bars (black, the rungs round) with the pull-up bar always on top and on the + disc the J-hooks low (0.95 m, the default; the barbell with two plates on them over the bench, flat for the bench press) or the dip bars + the rings (the bench along the wall bars, its back raised 40 deg) -- the pull-up + dip set and the J-hooks both billed (MISSING); a wall rack on the right end wall (two uprights on the studs, 3 x 6x80 each; a kettlebell shelf, a dumbbell shelf, two plate pegs with the plates) for the dumbbells FMC00021 and the kettlebells (the plate tree gone); the heavy bag its real shape (rounded ends, seams, the top cap) in brown-red on four chains to a swivel; the adjustable bench drawn real (a steel spine on two feet, wheels, a handle, the seat on its post, the back hinged on its bracket); the battle rope manila / hemp in waves on the ground with black grips (coiled as a helix in front of the rack when shut); the kitchen's and the other types' code paths unchanged but the kitchen's two sizes (its bill follows); the bills of every other type identical to bench-v409-gpfit2 in both units ) */
  /* previous: var VERSION = 'bench-v409-gpfit2';   ( v409 (Marek 2026-11-03 20:01 "U fitness varianty bys mohl udelat oboustranne otviratelne dvere, pytel zavesit dovnitr na stred. Na jeden bok dovnitr pripevnit kladkostroj. Na vnejsi kratke strane dat multifunkcni zebrik ... hrazda / s bradly a na stridacku take vylozniky na velkou osu (drepy bench). Dovnitr by se mela vlezt take multifunkcni fitness lavicka (u kladkostroje). Zkus jeste upravit model a take doplnit chybejici polozky."; question panels: both long sides lift-up flaps that make a roof when open, the zones round the pod for kettlebells / bands / the tyre + hammer / battle ropes, all in the BoQ, the equipment shown inside and out when open; 1.8 m / 6 ft deep; 20:08 "On pak slouzi spise pro uskladneni veci ... Pri otevreni ... lavicka by se premistila k hrazde, vyloznikum"): GARDEN POD FITNESS 2 (type 53) -- 1.80 m (US 6 ft) deep, the length on the top switch (Length 2.70 / 3.15 / 3.60 m, US 9 / 10.5 / 12 ft; the button shows it), the header 2.20 m (US 7 ft 3 in.) over the deck; NO BACK WALL: the back the front's mirror (posts, header, band, flap with its hinges, struts, knobs, catches -- the front's own code run with x mirrored, MX), the rafters hung in hangers between the two headers, the roof from band to band (drip, rakes), the end walls between the posts (studs under the wall bars' stiles + the pulley's in the middle), the back corner trims as the front's; the flap slider moves both flaps; power on the back posts (socket, switch, junction box, two wall lights) with the LED strip under the back header; INSIDE (stored when shut): rubber tiles, the heavy bag FMC00022 in the middle on a 2x6 blocking, the cable pulley FMC00016 (GYM MACHINE 1) on the left end wall + its attachments, the plate tree + bumper plates, the dumbbells FMC00021, the kettlebells, the barbell FMC00027 on two hooks FMC00028 under the rafters, the bench at the pulley, the battle rope coiled; OUTSIDE: the wall bars on the right end wall (4 brackets, 6x120 into the studs) with the pull-up + dip bars (the rings FMC00026 from the pull-up bar) or the J-hooks on its + disc (STATE.kpLad); the tyre + sledgehammer in the front zone; OPEN (from 45 deg): the bench out at the wall bars (under the bar on the J-hooks), the kettlebells in the front zone, the battle rope out from its anchor on the back base beam, the bands on the wall bars, the barbell on the J-hooks; every item without a catalogue row on MISSING; the treadmill / rower stations, the back-wall pull-up bar and the bay discs of v407 gone; the kitchen (type 35) and the bills of the other types identical to bench-v408-ig2asm in both units ) */
  /* previous: var VERSION = 'bench-v408-ig2asm';   ( v408 (Marek 2026-11-03 18:28 "Nedelej mi animaci. Udelej mi odkaz, kde po zmacknuti play zmizi veskere jine UI prvky, nebude se menit pruhlednost, nebudou se animovat spojovaci prvky. Vsechno ostatni zustat tak jak v assembly steps. Obraz nahraju a upravim sam."; 18:34 "Jeste udelej to, ze se po sestaveni bude mirne houpat, normalnim tempem."): THE ?ig2=asm BUILD RECORDING -- e.g. https://www.theleva.com/products/swings?variant=55513216647511&ig2=asm: the PLAY bottom centre; the tap hides the whole page but the 3D stage (display none, the stage full screen, the page's own framing), 2 s later the assembly steps run first to last with the button's own fly-in (_stagedAnimate) but no see-through (no fade, no glow) and the fasteners in place without a fly-in (a step of fasteners alone at once, no pause), 1.7 s + 0.5 s a step with wood; then the built view, and a swing (chains drawn) sways round the chains' tops +-7 deg at its pendulum period (2-3 s) until reload; the park bench / sofa / bed step by step without the fly-in (any other type with no staged steps held built); _stagedAnimate returns its length; the section THE ?ig2=asm BUILD RECORDING below _ig2Run; the bills of all types identical to bench-v407-gpfit in both units; on top of bench-v407-gpfit ) */
  /* previous: var VERSION = 'bench-v407-gpfit';   ( v407 (Marek 2026-11-03 18:12 "Dalsi krok"; question panels: GARDEN POD with the variants Kitchen and Fitness, the handle garden-pod, the stations hrazda + kruhy / boxovaci pytel / cinky + osa ve stojanu / veslo a pas ulozene, the pull-up bar on the end wall outside): TYPE 53 GARDEN POD FITNESS (PRODUCT_TYPES['garden-pod'] = PRODUCT_TYPES['kitchen-pod'] = [35, 53], SKU BENCH-T53) -- the kitchen pod's shell, foundation, cladding, roof, flap slider and power without the counter; rubber tiles on the deck (MISSING); along the back wall 3 / 4 / 5 stations on the top switch, each on its + disc: dumbbells on their stand FMC00021, a barbell FMC00027 on two hooks FMC00028 at the studs (one a pod, the bar inside the walls), a heavy bag FMC00022 on a 2x6 blocking between two rafters (its hanger MISSING), a folded treadmill FMC00019, a folded rower FMC00020; the length the stations' (no uprights); a 60 cm pull-up bar FMC00024 on two brackets on the right end wall's outside (three 6x120 each into the corner post / an end stud, the arms rising 15 deg, the bar ~2.1 m over the ground), gymnastic rings FMC00026 on straps from it; the socket by the treadmill over the stations; the counter frame toggle hidden; the kitchen and the bills of the other types identical to bench-v406-kpframe) */
  /* previous: var VERSION = 'bench-v406-kpframe';   ( v406 (Marek 2026-11-03 16:10 "Zrusit zalozku otevrena, dat nad spodni listu posuvnik, kterym uzivatel plynule otevre / Zrusit vycet reziva na mobilu / Moduly ... cislo"; 16:12 question panel: prepinac drevo / ocel, 4. tlacitko Ram): THE KITCHEN POD'S FLAP ON A SLIDER AND ITS COUNTER'S FRAME (type 35) -- the flap 0 .. 85 deg on a slider centred over the info bar (STATE.kpAng; the + discs and the bottle's door from 45 deg; a rebuild while it moves, Undo / prefs when let go); the first toggle = the counter's frame Timber frame > Steel frame (STATE.kpFrame: galvanized studs WDD00502 50 x 100 / US 1 5/8 x 3 5/8 in. for the uprights, cross members, rails, headers, sills, ledger and sleeper; the joints cut and folded with four 4.8x19 FAS48019 a joint (billed), 4.8x19 from inside the profile into the deck and the wall's studs (drawn), the drop ear under the ledger's flange, the face on wing tip screws FAS55038; the bays to the studs' width); a cement board heat shield FCB00013 + FAT16012 on the back wall's studs behind a grill / kamado / pizza oven / burner (both frames, 60 cm / US 24 in. up, holes round the boxes); the wood frame: the grill's and burner's insulated jacket MISSING; the pod's options in ?cfg= links (v405 left them out); the bar: Lumber (not on a phone) | Foundation | Cladding | Frame | Modules (a number to tap); the bills of the other types identical to bench-v405-kpopts in both units ) */
  /* previous: var VERSION = 'bench-v405-kpopts';   ( v405 (Marek 2026-11-03 15:07 "navrhni co bychom mohli uzivatelsky editovat... Hlavne konstrukcni specifika a materialy"; question panel: all four + 15:12 "skoky po modulech. Zvolit si 3/4/5"): THE KITCHEN POD'S OPTIONS (type 35) -- the bays' number on the top switch (STATE.kpN 3 > 4 > 5, each bay its kind's own width, the length theirs, at most 3.60 m / US 12 ft, no grips); the foundation on the third (kpFound: ground screws > precast pads > poured footings + wet-set U anchors, the greenhouses' v399); the cladding on the fourth (kpClad: horizontal boards on upright battens > upright boards on battens laid across + a raking batten, 2x3 blocking in the flap > board & batten: a 1x3 strip FVW02660 over every joint); + discs: the shelf on the back wall (kpShelf: a 2x6 on 6x6 in. brackets FAT00005 at the studs, the wall lights over it, none over the hot bays), the roof's covering on the roof (kpRoof: standing seam > EPDM > green roof in 2x4 kerbs, its layers missing), the counter's finish on its face (kpFin: acacia + panel > FOU00027 slab + stone veneer on FCB00013 > granite + wood face); the boxes' studs clear of the end walls on a short pod; the grill body to the top's real thickness; the bills of the other types identical to bench-v404-ig2de in both units ) */
  /* previous: var VERSION = 'bench-v404-ig2de';   ( v404 (Marek 2026-10-31 17:44: "Udelej mi tu pergola swing i v de. Poslu Andreasovi jestli nad zacne propagovat"): THE ?ig2 PERGOLA SWING REEL IN GERMAN -- https://www.theleva.com/de/products/swings?ig2: the voice and subtitles already follow the page's language (de clips ig2-swing-intro / -edit / -ai made by leva-workers voice run 69, Theo Teacher; ig-assembly, ig-budget, ig-outro were there); now the units of the run follow the voice's market (English = US as before, any other language = metric, the page's units back at the end) and the assistant step plays the live chip WHAT COSTS THE MOST in the page's language (ai.js v3.00 LevaAI.demo o.live: the chip, ai.cost_intro + ai.scope_intro, the live project card in the page's currency) instead of only opening the drawer; the English reel unchanged; on top of bench-v403-dhmodern ) */
  /* previous: var VERSION = 'bench-v403-dhmodern'; */   /* v403 (Marek 2026-10-30 20:31 "Dalsi krok" -- KENNELS slot 5; question panel: the roof deck as a flat roof): TYPE 51 THE MODERN DOG HOUSE, KENNEL variant 5 (/products/kennel, PRODUCT_TYPES.kennel = [41, 44, 47, 48, 51]) -- the classic dog house's build (_phLayout, DH) for the dog on the slider: the 2x6 floor frame (DMC) 25 cm (US 10 in.) up on four 4x4 legs in deck blocks inside its corners (two 6x120 through the rim, two through the end joist into each); the stilt house's mono-pitch path with 2x4 rafters (their seat screws by the depth they go through), horizontal wood cladding FVW01351 straight on the studs (rows clipped to each wall's outline less the doorway and the plates' notches, 28 screws a m2; the trims' and casing's nails off the rows' gaps), corner boards, a casing round the doorway; the toggle OFF: 14 deg standing seam; ON (the default): THE ROOF DECK -- 3 deg, rafters at <= 40 cm, 2x6 eave rims on the tails, OSB, EPDM turned down under the drip edge (MISSING, m2), a floating deck (38x38 sleepers over the rafters, decking across), a guard of 38x38 balusters on the rims / rake boards with a 2x4 cap rail (0.6 of the dog, at least 30 cm / US 12 in.), open at the ramp; the ramp off the right eave at 25 deg: 2x6 stringers in joist hangers FAT00009 on the rim (FAS38038), level feet on deck blocks, decking, a 20x40 cleat a board; cedar, charcoal trims and roof in the default scheme; VARIANT_KEYS[50] set apart (built as v399, renumbered over the parallel v399-v402); on top of bench-v402-phfound */
  /* previous: var VERSION = 'bench-v402-phfound'; */   /* v402 (Marek 2026-10-30 20:27 "Stavby udelej variantni zalozeni, i na vrutech. Prepinani dole v banneru"): THE PLAYHOUSES' FOUNDATION ON A SWITCH -- every PLAYHOUSES type (26-32 + the castle) on the info bar's last switch Ground screws > Precast pads > Concrete pads (the gazebo's three and labels; STATE.phFound, null = the type's own: the houses on deck blocks, the forts on ground screws); _phAnyLayout runs each layout through _phFoundPass at the same heights: a post on a ground screw -> into a deck block's socket (its U head + nails gone) or onto a poured footing with a wet-set U anchor FCO00004; a house on deck blocks -> U heads under the joists just inside the rims (the siding covers the rims), the usable joist nearest the first / last block and each block between 60 cm apart, 12 nails into the joist (after the frame), the porch posts' feet flush with the frame; footings 40 x 40 x 80 cm with concrete FCO00002, 4 bars FCO00003, gravel, geotextile FEC00003, a formwork lump FCO00007, holes FEE00001; steps keyed by the foundation (blocks / footings / U heads / the frame in one step); the castle's and the foundation's keys also in Undo and the saved prefs; the default bills of all types unchanged; on top of bench-v401-hoopco */
  /* previous: var VERSION = 'bench-v401-hoopco';   ( v401 (Marek 2026-10-30 20:27 "Co ve variante 7 ?"; question panel: the Hoop Coop): TYPE 52 THE HOOP COOP, COOP variant 7 (/products/coop, PRODUCT_TYPES.coop + 52) -- the backyard coop's house alone (_coLayout, run off) stood inside a walk-in run COPIED from the hoop house (type 38): ground screws + U heads, a 4x6 base, 35 mm galvanized tube hoops <= 1.20 m apart, hold-down strap pieces, 2x6 hip boards, a ridge purlin, framed end walls with the door in the front one; ADAPTED: hardware cloth instead of the film (the arc, the hip boards, the sides to the ground, the end walls, the door), the coop's apron, a tarp over the house's end; the tube, the cross connectors, the hog rings and the tarp on MISSING; the house GAP_B in from the back end wall, centred (WALK either side); hens 2-12, the run 3.00-4.20 m wide (US 10-14 ft) on the toggle; the playhouse builder draws tubes, cylinder sheets and strap pieces (the greenhouse builder's) ) */
  /* previous: var VERSION = 'bench-v400-kppanel'; */   /* v400 (Marek 2026-10-30 20:45 "Obrazky nedelat. Udelam sam"): THE KITCHEN POD'S COUNTER FACE (type 35) -- mats.kpPanel both sides: the painted face's sheet has the basis (z, y, x), left-handed, so the extrusion's faces came out turned in and the back cap z-fought with the counter frame (a hatched face in the renders); now a plain dark face from both sides; on top of bench-v399-ghfound */
  /* previous: var VERSION = 'bench-v399-ghfound';   ( v399 (Marek 2026-10-30 20:30 "Dalsi krok. Urcite prepinani"; question panel: zaklady prvni): THE GREENHOUSES' FOUNDATION on a switch (STATE.ghFound, all six types): ground screws + U heads (as before) | precast pads (FCO00012 on a gravel bed, the base resting on them) | poured footings (concrete, rebar, formwork, geotextile, gravel; a wet-set U anchor FCO00004) -- the gazebo's / pergola's three, the same labels; the base's underside on the pads' / anchors' top (_ghYBB), the piers where the ground screws were; their steps at the start of every staged assembly (screws: none drawn, the steps drop out)) */
  /* previous: var VERSION = 'bench-v398-cstowers';   ( v398 (Marek 2026-10-30 18:10 "Ale kdyz jsem mluvil o towers, tak jsem myslel primo se strechou. Muzes to udelat tak ze misto strechy budou vysoke veze bez strechy, ale trosku rozmanitejsi vizual. Prepinac monkey bar spojit se slides, bude se cyklovat slides / monkey bar / monkey bar+slide / nothing a misto monkey bar prepinac na tvar vezi - nizka / se strechou / vysoka / kombinace"): THE CASTLE'S TOWERS AND PLAY (PLAYHOUSES 8, type 50) -- the toggle cycles the play Slide > Monkey Bars > All > None (BL.csPlay / csPlayLabel / cycleCsPlay over phSlide + csMb); the second switch the towers' look Low > Roof > Tall > Mixed (STATE.csLook, default 'roof': every tower the keep's pyramid roof; 'tall': no roof, walls to 1.60 m over the deck with 25 cm merlons, head + top rails, a window in each free wall, boards over the openings, a door with its head toward each bridge, a 1x6 band under the crenels; 'mix': the keep roofed, the last tower tall, the third low); the roofs a per-tower roofOn(); the bills of the other types unchanged; on top of bench-v397-barnco ) */
  /* previous: var VERSION = 'bench-v397-barnco';   ( v397 (Marek 2026-10-30 18:01 "Dalsi krok"; question panel: the Barn Coop, the exploded view on the coops only): TYPE 49 THE BARN COOP, COOP variant 6 (/products/coop, PRODUCT_TYPES.coop + 49) -- the backyard coop's _coLayout (the house raised at the back, the run in front, the same doors, nest boxes, roosts, ramp, hardware cloth and apron) under the little barn's gambrel (_brLayout): trusses of four 2x4 segments with OSB gussets at <= 60 cm over the house and the run, on the side beams (two toe screws a foot), the roof's OSB / shingles / caps / drip edge on its four planes, the fascia, the rake trims; the partition's gable studs, its siding, the back vent and the run's front cloth to the gambrel; barn red with white trims by default; its exploded view as the other coops' ) */
  /* previous: var VERSION = 'bench-v396-dhdouble'; */   /* v396 (Marek 2026-10-30 18:01 "Dalsi krok" -- KENNELS slot 4): TYPE 48 THE DOUBLE DOG HOUSE, KENNEL variant 4 (/products/kennel, PRODUCT_TYPES.kennel = [41, 44, 47, 48]) -- the classic dog house's build for two dogs of the slider's size: two rooms side by side (each the classic's inside width, its doorway clear of the partition and the corner), a 2x4 partition along the middle from the floor up under the ridge board (it carries it: no ties), built flat, fixed down into the joists, into a stud of each gable (side.split) and up into the ridge, OSB on its left face (OSB25001 + FAS50060 by rate); two doorways in the front gable, each in the middle of its room (wall() takes opening.us), a casing round each; the floor on 2x6 rims + joists (DDC); the porch on the toggle (off) as the classic's; the gables' split grid drops a stud landing on the split's or an end's; on top of bench-v395-explode */
  /* previous: var VERSION = 'bench-v395-explode';   ( v395 (Marek 2026-10-30 16:32: "Udelej i exploded view, stejne pravidla jako u ADU. Udelej jednu variantu coop white, a jednu svetle drevo."): THE COOPS' EXPLODED VIEW -- the walk's step 1 the exploded view with its slider (0..4, 2), step 2 back together, the items from 3, the house line's planner (_asmSpread / setExplode) for a coop's pieces; the backyard coop white by default, the cupola coop light wood (beech siding and doors, white trims); the cupola coop's run top laid on from above ) */
  /* previous: var VERSION = 'bench-v394-cs6'; */   /* v394 (Marek 2026-10-30 16:30 "Varianta castle, udelej prepinanim dole ruzne varianty. 2 veze / 3 veze do L, bez ruckovaci nastavby. Celkem treba 6 variant"): THE CASTLE'S SIX VARIANTS (PLAYHOUSES 8, type 50) -- the plan on the info bar's top switch: 2 towers + a bridge (as v389) > 3 towers in a row (two bridges, two gates) > an L (the keep at the corner, a bridge along X and one along Z, each arm's bridge on its own grip, the towers keep their size); the monkey bars (FMC00032) on their own switch (off: the right tower walled all round); _csLayout made generic over the towers (rims, joists, deck runs, walls, braces, rails per arm; the L's Z rims inside-screwed to the back rim), the 2-tower castle unchanged; the slide stays on the toggle; on top of bench-v393-ghbench */
  /* previous: var VERSION = 'bench-v393-ghbench';   ( v393 (Marek 2026-10-30 16:30 "Dalsi krok"; question panel: pestebni stoly uvnitr, krokev navic v kazdem poli): THE GROWING BENCHES in every greenhouse (33 / 36 / 38 / 40 / 43 / 45) on the info bar's top switch (STATE.ghBench, off): 2x3 legs + rails at the top and the lower shelf, 1x4 slats across, 80 cm (US 32 in.) high, 60 cm (US 24 in.) deep, along the side walls (one side when the path would be under 70 cm / US 28 in.), the lean-to's front wall, the Victorian's bay; _ghLayout = _ghLayout0 + _ghBenches over its g.benchSpec; four steps at the end of each staged assembly; THE OLD-WINDOW GREENHOUSE's mid-bay rafters: a pair in the middle of every sash bay (on the top plate, a 6x120 seat screw), the one under a vent stops at the purlin (two 6x120 through it), the purlins / eave blocks / fascia screws per half bay ) */
  /* previous: var VERSION = 'bench-v392-dhrun';   ( v392 (Marek 2026-10-30 16:25 "Dalsi krok" -- KENNELS slot 3): TYPE 47 THE DOG KENNEL WITH RUN, KENNEL variant 3 (/products/kennel, PRODUCT_TYPES.kennel = [41, 44, 47]) -- the classic dog house's build with its porch grown into a welded-wire run under the same roof: the run 2.5 of the dog long (at least 1.20 m / US 4 ft), the walls 1.40 of the dog clear over its decking (at least 60 cm / US 24 in.), the width fits a 40 cm (US 16 in.) gate; 2x4 side studs on the decking at <= 60 cm toed into the rim and the plate, a 2x4 front rail between the 4x4 posts, the coop's gate under it (two strap hinges, a barrel bolt MISSING); welded wire 2 x 4 in. 14 ga (MISSING, m2 / ft2) on the sides, the gable and the gate, staples FAS10000 by the lines; the run on the toggle (off: the classic dog house); on top of bench-v391-cupola ) */
  /* previous: var VERSION = 'bench-v391-cupola';   ( v391 (Marek 2026-10-30 14:30 "Udelej i variantu jakou mame na main product picture" + the picture; 14:45 question panel: the run's top in hardware cloth, the name Cupola Coop): TYPE 46 THE CUPOLA COOP, COOP variant 5 (/products/coop, PRODUCT_TYPES.coop = [34, 37, 39, 42, 46]) -- the product picture's coop on the backyard coop's _coLayout: the house alone (7 ft walls, a 40 deg gable, the back gable closed), a cupola with a weathervane (MISSING) on its ridge (saddles screwed into the ridge board, siding, corner posts, louvers, a pyramid roof), in the back wall a small access door under a window with hardware cloth, a casing round both and two shutters, the pop door + ramp in the left wall, the partition closed; the run on the left (-X) under the house's eave: its own posts on ground screws, 4x6 beams (white), 2x4 joists + an end plate, hardware cloth on top, sides and end and round the house's floor, mid rails, knee braces, the run door next to the house, the apron; the hens 2-10 (4) set the house (width from the area, depth the backyard coop's house), L the depth on the grips, W the whole width (the run's length); on top of bench-v390-gholdwin ) */
  /* previous: var VERSION = 'bench-v390-gholdwin';   ( v390 (Marek 2026-10-30 "Dalsi krok" -- GREENHOUSES slot 6; asked: the old windows in the walls, the roof the gable's polycarbonate; their size on the slider): TYPE 45 THE OLD-WINDOW GREENHOUSE (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33, 36, 38, 40, 43, 45]) -- the gable greenhouse with its walls of reclaimed sashes: one stock size on the info bar's slider (60 x 90 .. 90 x 150 cm, US 24 x 36 .. 36 x 60 in.; 75 x 120 / 30 x 48 unless set), on the framing's outside face, their top under the rafters; the plan snaps to whole sashes (n along the sides, m across the back's full width), the front the gable's door with a run of sashes from each corner and panel siding strips by the door; a DOUBLE stud under every joint (each sash on its own stud, three 6x80 through each inner stile, two through the bottom rail into the sill girt), the rafters over the joints; panel siding under the band all round, twinwall on the gable triangles, the roof and the door; 1x4 corner boards, sill and head boards, battens over the joints (TIM20100, screwed 6x80 / nailed into the stiles); the sashes drawn, on missing by the piece; _ghOldLayout through _ghLayout, its own staged assembly ) */
  /* previous: var VERSION = 'bench-v389-castle';   ( v389 (Marek 2026-10-30 "Slo by udelat neco jako castle? Muze byt jednoduchy tvar ale veze s hernimi prvky"; question panel: two towers + a bridge; slide, climbing wall, monkey bars): TYPE 50 THE CASTLE, PLAYHOUSES variant 8 (/products/playhouses, PRODUCT_TYPES.playhouses = [26..32, 50]; 45-49 left to the parallel threads) -- its own pipeline _csLayout / _csSteps through _phAnyLayout / _phSteps: one long fort deck 1.22 m (US 4 ft) up on eight 4x4 posts on ground screws, a tower at each end (T 1.20-1.80 m, US 4-6 ft, the front / back grips) and the bridge between them (1.20-2.40 m, US 4-8 ft, the side grips) as the wall walk over the open gate; crenellated 1x6 walls on 2x4 rails (the towers 20 cm higher); the keep (left) up to a 2x6 ring with a 50 deg pyramid roof (OSB as quads, underlay, shingles, hip caps, PH_ROOF grey); the play fort's ladder at the keep's front, the slide off its left side on the toggle (MISSING), a climbing wall at the right tower's front at 65 deg with bolt-on holds (MISSING), monkey bars off its right side on the catalogue's FMC00032; M16 rods through post + rim at 0.15 / 0.62 of the rim's depth; the bills of types 1-44 identical to bench-v388-dhinsul in both units; on top of bench-v388-dhinsul ) */
  /* previous: var VERSION = 'bench-v388-dhinsul';   ( v388 (Marek 2026-10-30 14:43 "Dalsi krok" -- KENNELS slot 2): TYPE 44 THE INSULATED DOG HOUSE, KENNEL variant 2 (/products/kennel, PRODUCT_TYPES.kennel = [41, 44]) -- the classic dog house's _phLayout (DH / DHC) with two rooms: a windbreak entry in front (0.7 of the dog deep, at least the doorway + 5 cm / US 2 in.) and the sleeping room behind it (1.45 of the dog), a framed 2x4 partition between them (built flat as one frame, stood up under the lined ceiling 1 cm short, screwed down into a joist under it, up into a ceiling joist over it, at the ends into a stud of each side wall); the front doorway at the right end of the front gable (its kings + 4x4 header screwed together first), the partition's opening at the left end (W fits both + 5 cm); 50 mm (US 2 in.) XPS INS00503 between the floor joists, the wall studs, the partition's and the ceiling joists, bonded with adhesive foam FCP00005 (a can for 6 m2); a flat ceiling on 2x4 ceiling joists (the cottage's rafter ties + one inside each gable + one over the partition); 15 mm (US 5/8 in.) OSB lining OSB25001 on the ceiling, walls and both faces of the partition, 5x60 by rate; the flap on the toggle (on): a clear PVC strip curtain under a 1x4 batten screwed into the doorway's header (MISSING, m2); no porch; the dog 25-80 cm on the slider; on top of bench-v387-ghvict ) */
  /* previous: var VERSION = 'bench-v387-ghvict';   ( v387 (Marek 2026-10-30 "Dalsi krok" -- GREENHOUSES slot 5; asked: ONE end a polygon, the other square with the door; polycarbonate, the knee wall on by default): TYPE 43 THE VICTORIAN GREENHOUSE (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33, 36, 38, 40, 43]) -- the gable greenhouse with its back end half a regular octagon (three walls of a = W (sqrt2 - 1)): mitred base, plates and fascia round the bay, two bevelled studs at each bay corner; the roof over the bay half an octagonal pavilion at the gable's 30 deg -- a 6x6 hub (KVH16160) at the octagon's centre, the ridge from it to the front, four 2x4 hips (dropped, a level seat on the plates' corner), jack rafters on the side studs behind the hub and two a bay facet (cheek-cut to the hips, the gazebo's lofts); purlins and vents between the common pairs; ridge + hip caps, a corner board over each bay corner; W 2.40 - 3.60 m (US 8 - 12 ft), L 3.00 - 6.60 m incl. the bay (US 10 - 22 ft), default 3.00 x 4.20 (10 x 14 ft); the knee wall on (its toggle as the gable's); _ghVictLayout through _ghLayout, its own staged assembly; _buildGreenhouse draws lofts ) */
  /* previous: var VERSION = 'bench-v386-leanco';   ( v386 (Marek 2026-10-30 13:27 "Dalsi krok", chose the lean-to coop for COOP slot 4 in the question panel): TYPE 42 THE LEAN-TO COOP, COOP variant 4 (/products/coop, PRODUCT_TYPES.coop = [34, 37, 39, 42]) -- the backyard coop's _coLayout against a house wall: one 20 deg slope falling away from the house (the modern house's mono roof: one-piece rafters with a birdsmouth on each beam, a fly rafter of the same piece on each beam's end -- the side beams run on past both ends under them; no ridge, no ties, no caps), the left posts / beam / wall up to the roof's line, its own posts on ground screws 5 cm (US 2 in.) off the house (self-supporting); at the house an endwall flashing ROR00013 (its leg up the house wall, a roofing nail into each rafter) and reinforced angle brackets FAT00005 under the high beam (its ends past the walls, every run bay; 5x40 up into it, two concrete screw anchors FAS10075 into the wall), a 1x4 closer over the gap at the back (and a front without the run); no window (the back's raked vent is the air), no side corner boards and no apron on the house side; the house wall drawn as context (see-through, not billed, not in AR); the hens 2-12 (6) and the run on the toggle as the backyard coop's; on top of bench-v385-doghouse ) */
  /* previous: var VERSION = 'bench-v385-doghouse';   ( v385 (Marek 2026-10-30 13:28: "Produkt mame zalozeny. Muzes naplanovat varianty kennel a zacit s vyrobou konfiguratoru"): TYPE 41 THE CLASSIC DOG HOUSE, KENNEL variant 1 (/products/kennel, PRODUCT_TYPES.kennel = [41]) -- the cottage's _phLayout at a dog's scale (DH constants over PH through _phU, DHC codes through PHk): the dog's height at the withers on the slider (25-80 cm, US 10-32 in.; 55 cm / US 22 in.) sizes the doorway (0.6 x 0.75 of it), the inside (1.75 x 1.35 of it), the walls (>= 1.05 of it, over the doorway's header) and the porch (0.8 of it, >= 40 cm / US 16 in.), sizes in 5 cm / US 2 in. steps, L / W on the grips up to 60 cm / US 2 ft more; four deck blocks, a 2x4 floor frame on edge + OSB, 2x4 walls under a flat 2x4 top plate (the side walls) / 2x4 top plates (the gables), the doorway in the front gable framed as the cottage's window on the bottom plate (no sill, no door, no windows, no shutters), a 35 deg gable of 2x4 rafters on a 2x6 ridge board with no ties, OSB + underlay + shingles + caps, drip edge, fascia + rake boards, panel siding, corner boards, a casing round the doorway; the porch on the toggle (off) with a 6x80 up through each knee brace into the plate; the coop's farmhouse colours; the cottage's steps with the dog house's codes (_phStepsBase(DHC)); on top of bench-v384-ghaframe ) */
  /* previous: var VERSION = 'bench-v384-ghaframe';   ( v384 (Marek 2026-10-30 "Dalsi krok" -- GREENHOUSES slot 4; asked: a pure A down to the base, about 60 deg, glazed in polycarbonate as the gable): TYPE 40 THE A-FRAME GREENHOUSE (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33, 36, 38, 40]) -- the gable greenhouse without its side walls: 2x4 rafter pairs at 60 deg seated on the side beams (an 8x200 a seat) up to a 2x8 ridge board (KVH60200), purlins <= 1.20 m (US 4 ft) down the slopes, triangular end walls of 2x4 studs cut to the end rafters (girts, the door in the front: kings, jacks, header, a cripple to the ridge), twinwall on both slopes from the ridge to past the rafters' feet and on the end triangles, the ridge cap, rake boards down to the base, the gable's casings, door, roof vents and openers, the base / ground screws / gravel floor as the gable's; W 3.60 - 4.80 m (US 12 - 16 ft: the full 1.93 m door needs 3.60 under 60 deg slopes), L 2.40 - 6.00 m, default 3.60 x 3.60 (12 x 12 ft); no knee wall (its toggle hidden); _ghAframeLayout through _ghLayout, its own 43-step assembly ) */
  /* previous: var VERSION = 'bench-v383-walkin';   ( v383 (Marek 2026-10-30 12:04 "Dalsi krok", chose the walk-in coop for COOP slot 3 in the question panel): TYPE 39 THE WALK-IN COOP, COOP variant 3 (/products/coop, PRODUCT_TYPES.coop = [34, 37, 39]) -- the backyard coop's _coLayout with the walk-in's constants (WI, through _coU): 8 ft (2.44 m) post-and-beam walls, so the run door is a full person door (2.07 m) and the house a walk-in shed with a 30 in. (76 cm) access door 1.84 m tall under a 2x4 header; the house floor 16 in. (0.42 m) up, no run rails under it (the floor beams take their place); a 24 x 18 in. window; the hens 6-20 (10) on the coop's slider, W 1.80-3.00 m (US 6-10 ft), L to 7.20 m (US 24 ft), the run >= 1.80 m (US 6 ft); knee braces on every run post, extra 2x4 studs in a wide front; the run on the toggle as the backyard coop's; the access door on 3 ledges and 3 strap hinges; on top of bench-v382-kpserv ) */
  /* previous: var VERSION = 'bench-v382-kpserv';   ( v382 (Marek 2026-10-30 "Dalsi krok" on the KITCHEN POD; question panel: gas from an LPG bottle in a cabinet, water / waste / power drawn and billed inside the pod up to its connection points): TYPE 35 THE KITCHEN POD'S SERVICES -- GAS: the bottle FOU00026 in the cabinet of the first gas appliance with a door (its door open 95 deg with the flap open, the cabinet drawn as a shell, its flange a frame), the regulator GAP00001, the 400 mm pigtail GAP00006 through the cabinet's back to a 3-way manifold GAP00002 in the gap behind it, a 1/2 in. line GAP00004 a gas appliance up the back gap and along it over the modules (risers ordered so no leg crosses another), elbows GAP00005, a ball valve GAP00003 under the grill / burner / pizza oven and a hose GAP00006 up to it (the pizza oven's through a hole in the top); at most three gas appliances (the bays' cycle and saved choices keep to it); WATER / WASTE a sink at a time inside its cabinet (a shell): PEX 16 SMR00121 from under the deck to a drop ear SMW00201 on the ledger (two 5x40), a braided hose SMN00202 to the tap's tail (through the top in front of the ledger), the siphon SMH00322, a 32 mm PP HT waste SMR00321 down through the cabinet and the deck (a jog clear of the joists: SMP00321 two a turn); POWER: a junction box EEJ00001 on the back wall (the house's cable ends there), cable EEE00001 along the wall's cavity through the studs and down / up beside a stud to an outdoor socket EES00005 + switch EEL00002 over a drawer / door bay, a socket behind each fridge (its back 7 cm off the wall now), two wall lights EEW00001, up along a rafter to the LED driver EEC00007 on the header's back face and the LED strip EEC00006 under the header; every box two 5x40 FAS50040 into a stud; NOT BILLED (no catalogue row): pipe clips, cable clips, the 1/2 in. water ball valve at the connection point; MATERIALS + SMR00121 / SMR00321 / GAP00004 (m); on top of bench-v381-ghhoop ) */
  /* previous: var VERSION = 'bench-v381-ghhoop';   ( v381 (Marek 2026-10-30 "Dalsi krok" -- GREENHOUSES slot 3; asked: galvanized steel tube hoops, a round arc): TYPE 38 THE HOOP HOUSE (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33, 36, 38]) -- a film tunnel on the greenhouses' base: 35 mm (US 1 3/8 in.) galvanized tube hoops (a round arc on straight legs up the base's outer faces to 0.90 m / US 3 ft over it, the end ones in the end walls' plane, <= 1.20 m / US 4 ft), cut pieces of a hold-down strap FAT00012 round the legs (two to the base, one to the hip board; 5x40 FAS50040), 2x6 hip boards outside the legs, a ridge purlin tube under the crowns with cross connectors, 2x4 end walls under the end hoops (studs / kings / cripples cut to the arc, a strap over the hoop onto each), the door in the front one (the gable's, the film stapled on it, FAS10000), greenhouse film over the hoops and hip boards, lock channel + wiggle wire on the hip boards, end hoops and end walls (4.8x19 self-drilling FAS48019 into the hoops), roll-up sides (a curtain to a roll bar, a crank at the front; down / rolled up on the info bar's toggle), the piers in the hoops' bays, a soil floor; the tube, the film, the channel, the wire, the cross connectors and the cranks NO CATALOGUE ROW (missing); W 3.00 - 4.20 m (US 10 - 14 ft), L 2.40 - 7.20 m (US 8 - 24 ft); _ghHoopLayout through _ghLayout, its own 38-step assembly (a step of a missing item named from the locales) ) */
  /* previous: var VERSION = 'bench-v380-kpequip';   ( v380 (Marek 2026-10-30 "Dalsi krok" on the KITCHEN POD; asked: the equipment by a tap on the module (a + disc over each bay, as the gazebo's sides), add the fridge FOU00024, the side burner FOU00021, the kamado FOU00018, the pizza oven FOU00020): TYPE 35 THE KITCHEN POD'S EQUIPMENT -- a + disc in front of the worktop's edge over each bay (3D, the flap open) cycles the bay: grill (over the door + drawer combo) > sink + tap (over a double / single door) > kamado (a glazed egg through a round cutout) > side burner > tabletop pizza oven (over a single / double door) > fridge (in place of a module, up under the top) > drawers > door > double door > trash, each kind with its own bay width (the modules', 50 cm / US 20 in. for the kamado and the pizza oven, the fridge's 60 cm / US 24 in.), only the kinds the length still takes; the number of bays still from the length (a fifth / sixth bay only with 5 cm left over); STATE.kpKinds by bay (null = the default), in designs, Undo, the reference designs; a drop-in's bay: its 2x4 header laid flat under its body (was a 2x2 section), the fridge's bay without a rail; the sink's cutout 5 mm further back (clear of the rail, metric); every item billed, its own step (a step drops out when nothing of it is drawn); on top of bench-v379-tractor ) */
  /* previous: var VERSION = 'bench-v379-tractor';   ( v379 (Marek 2026-10-30 10:42 "Dalsi krok" -- COOP slot 2 as planned): TYPE 37 THE CHICKEN TRACTOR, COOP variant 2 (/products/coop, PRODUCT_TYPES.coop = [34, 37]) -- its own _ctLayout on the playhouses' pipeline (PH_TYPES + 37, a step table of its own, the coop's colours and hardware cloth): a movable A-frame on two 2x8 skids (the handles past the front), 2x4 legs at 60 deg on the skids under a 2x6 ridge board, floor ties / roosts / collar ties between the legs, the hen house up in the A at the back (OSB floor 22 in. up, the back gable round an access door with a vent over it, the partition round the pop door + ramp, nest boxes inside in the back right corner, a shingled roof), the run in hardware cloth on the slopes and the front gable round a run door; the hens on the slider (2-6) size it (10 ft2 a hen over the footprint, 2 ft2 of house floor, the roosts by the headroom over them), two 10 in. wheels on a threaded rod axle on the toggle; the slopes' hardware cloth as quads (the build draws a 'mesh' quad in the cloth), the wheels as hw cylinders across X (cylX); MISSING: the hardware cloth, the barrel bolts, the wheels; on top of bench-v378-ghlean (the GREENHOUSES thread; v376 the KITCHEN POD took type 35, v378 the lean-to greenhouse 36) ) */
  /* previous: var VERSION = 'bench-v378-ghlean';   ( v378 (Marek 2026-10-30 10:11: "Muzes pokracovat" -- GREENHOUSES slot 2; asked: its own back wall, self-supporting, tied to the house by a few angle brackets and a flashing; the door in an end wall): TYPE 36 THE LEAN-TO GREENHOUSE (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33, 36]; the numbers between went to other threads in parallel) -- the gable greenhouse's build against a house wall: the base's end beams the full width (the back beam 5 cm / US 2 in. off the house), a 1.83 m (US 6 ft) front wall, a back wall up to the roof's high end (no glazing), end walls with end studs up to the end rafters, the door in the right end wall towards the back (hinged on its front side), one 20 deg slope (rafters with a birdsmouth on both plates, blocks over both walls, purlins, the vents under its top edge), an endwall flashing ROR00013 over the roof's top edge, reinforced angle brackets FAT00005 to the house (<= 1.20 m / US 4 ft; 5x40 into the stud, two 10x75 concrete screw anchors FAS10075 into the wall), 1x4 closer boards over the gap at the ends, the knee wall on the toggle; the house wall drawn as context (see-through, not billed, not in AR); _ghLeanLayout through _ghLayout, the 51-step assembly (52 with the knee wall; the gable's stays 52 / 53) ) */
  /* previous: var VERSION = 'bench-v377-phwhite';   ( v377 (Marek 2026-10-30 10:41, PLAYHOUSES): "Udelej 3 ze 4 ivory jako ciste bile, je to moc sede." -- the default scheme: the cottage, stilt house, A-frame and modern house walls pure white (0xffffff), the barn alone ivory, lighter and warmer (0xf8f0dc) with its blue doors; _phPaint lifts the emissive of the near-white paints (luminance > 0.92: walls, trims) to 0.3 (0.12 greyed them in the shade; the white wood scheme lifts 0.55); the pastel schemes unchanged; on top of bench-v376-kitchenpod (the KITCHEN POD thread) ) */
  /* previous: var VERSION = 'bench-v376-kitchenpod';   ( v376 (Marek 2026-10-30 09:52-09:55: "tady neni moc co konfigurovat, krome delky a vybaveni. Tak bych to spise udelal jako jednoduchy konfigurator (styl bench)"; "produkt zalozeny, muzes stavet ... Asi jedna"): TYPE 35 THE KITCHEN POD, /products/kitchen-pod (PRODUCT_TYPES['kitchen-pod'] = [35], SKU BENCH-T35) -- a closed timber box after the bbq_zen_garden reference whose whole front lifts on gas struts into a roof over the counter: ground screws + U heads under a 4x6 base, 2x6 joists in hangers, a 1x6 deck; 2x4 back + end walls (raking plates), 4x4 front posts under a 4x6 header; OSB, membrane, battens, horizontal wood cladding, black corner trims; a 5 deg mono roof of 2x6 rafters hung off the header (birdsmouth on the back plate), OSB, underlay, standing seam, drip edge, black fascia / rakes / band; the flap a clad 2x3 frame on strap hinges, two gas struts from 2x4 blocks in the end walls (NO CATALOGUE ROW: NOT BILLED), knobs + ball catches, open 85 deg / shut on the info bar's toggle; the counter: 2x4 frame, panel-siding face with the stainless modules' cutouts, an acacia top, the grill head over a door + drawer combo, the sink + tap over a double door, drawers / trash / door as the length allows; L 2.40-3.60 m (US 8-12 ft) on the footprint's grips, the depth fixed 0.90 m (US 3 ft); _kpLayout the single source of the model, the bill and the 55-step assembly; on top of bench-v375-coop ) */
  /* previous: var VERSION = 'bench-v375-coop';   ( v375 (Marek 2026-10-29 14:24 / 2026-10-30 09:10: "Coop mame zalozeny, muzes spustit a vytvaret varianty"; chose the swing engine and the Backyard Coop first): TYPE 34 THE BACKYARD COOP, COOP variant 1 (/products/coop, PRODUCT_TYPES.coop = [34]) -- its own _coLayout on the playhouses' pipeline (_phAnyLayout, _buildPlayhouse, _computePlayhouse, a step table of its own): the hens on the slider (2-12) size the house (4 ft2 a hen) and the run (10 ft2 a hen), the run on the toggle; 4x4 posts on ground screws + U heads, 4x6 side beams, the house floor 2 ft up on 4x6 floor beams + 2x6 joists + OSB, 2x4 walls between the posts, a 30 deg gable roof over house and run (shingles), panel siding, an access door, a pop door with its ramp, a window and the back gable as vents in hardware cloth, nest boxes off the right wall, roosts on cleats; the run's rails, front frame, mesh door, knee braces, hardware cloth + a buried apron; the coop's farmhouse colours (CO_PALETTES) and a wire-grid material; MISSING: the hardware cloth (by area) and the barrel bolts; on top of bench-v374-phivory ) */
  /* previous: var VERSION = 'bench-v374-phivory';   ( v374 (Marek 2026-10-30 10:10 / 10:11, PLAYHOUSES): "Udelej colors default redesign - vetsinu konstrukci udelej ivory / white color, ruzova, zelena, modra jako doplnkova. Vybrane dve stavby udelej ve variante svetle drevo - buk." -- THE DEFAULT SCHEME (pine) ivory walls 0xf3ecda, white trims, pink door, green shutters, blue slide, the barn ivory with blue doors (phBarnDoor, the scheme's barnDoor, else its walls'), the modern house ivory; the play fort (29) and the tree fort (32) in the default scheme with natural light beech fort boards (PH_BEECH 0xe0bb92); the brush's other schemes keep the v371 pastels; "Strom u stromoveho domku ... udelej ho jako referencni, staci 30%" -- the store's tree (and the drawn trunk) 30 % see-through without depth write (applyVizStage, ph-tree); on top of bench-v373-ghgable (the GREENHOUSES thread, status/greenhouse.md) ) */
  /* previous: var VERSION = 'bench-v373-ghgable';   ( v373 (Marek 2026-10-30 09:11: "Greenhouse zalozeny, muzes spustit vyrobu variant"; 2026-10-29 chose the swing engine and the GABLE first): TYPE 33 THE GABLE GREENHOUSE, GREENHOUSES slot 1 (/products/greenhouse, PRODUCT_TYPES['greenhouse'] = [33]) -- ground screws + U heads under a 4x6 base, a gravel floor, 2x4 walls (girts, the door's kings / jacks / header in the front gable), a 30 deg gable roof (rafters in line with the studs, ridge board, ties, eave blocks, purlins), 8 mm twinwall polycarbonate on walls + roof (no catalogue row: NOT BILLED), aluminium tape, sealing screws, a metal ridge cap, 1x4 fascia / rake / casings, corner boards, a glazed 2x3 door on strap hinges, roof vents on automatic openers (NOT BILLED), the knee wall (panel siding + belt board) on the info bar's toggle; _ghLayout the single source of the model, the bill and the 53-step assembly (52 without the knee wall) ) */
  /* previous: var VERSION = 'bench-v372-roofgrey';   ( v372 (Marek 2026-10-30 09:19): "Strechy na stavbach udelej svetle sede. U vsech." -- PH_ROOF 0xc5c9ce, every playhouse's roof light grey on every scheme (the shingles' texture tinted from it, the standing seam), the palettes' roof / barnRoof gone; "U varianty 7 neni glb strom uprostred stavby ... podle analyzy objemu glb, kde skutecne strom stoji" -- the store's tree GLB holds two small meshes beside the tree (tree_plamatisate_0, tree_twig_0, a plant and a twig on the ground ~0.6 of its height to the side): merged in, they were the lowest vertices, so the trunk's axis was taken there (the tree stood ~6 m off the fort's opening) and they lifted the trunk's foot; _phTreeLoad keeps only the meshes at least a quarter of the tallest one's height -- the trunk's axis 0.0002 / 0.0099 of the height, checked against cross-sections of the trunk at 1-25 % of its height and in the harness with the real GLB (the trunk through the opening's middle, its foot at y 0) */
  /* previous: var VERSION = 'bench-v371-pastel';   ( v371 (Marek 2026-10-30 00:53: "Udelej stavby spise v pastelovych tonech, jemnejsich. Kombinace bile, ruzove, zelene a modre"): THE PLAYHOUSES' COLOURS PASTEL -- PH_PALETTES rewritten, every scheme of the brush only white / pink / green / blue, soft: pine (default) powder blue walls, white trims, pink door, mint shutters, rose roof, mint slide; birch blush pink + blue door + sage roof; oak mint + pink door + blue shutters + dusty blue roof; khaki white + blue trims + sage roof; white white + pink trims / shutters + blue door + rose roof; grey pale blue + mint door + pink shutters + dusty blue roof; the little barn pink (or mint / blue) under a roof of another pastel, the modern house mint / pink / blue; the frame keeps the scheme's wood; nothing else changed ) */
  /* previous: var VERSION = 'bench-v370-phroof';   ( v370 (Marek 2026-10-29 23:38: "Ok, dalsi krok" -- the roof switch proposed in the v369 review, "Kdyz tak mozna switch na pultovou"): GABLE <> MONO-PITCH on the stilt house (27) and the play fort (29) -- the info bar's top switch (roof_v1 / roof_v4, the pergola's / arbor's keys), STATE.phRoof ('mono' or null = gable; a design key, saved with the design, a reference design's rf); the modern house's 14 deg mono roof on each: 4x6 beams at two heights running on past the gables under the fly rafters, one-piece 2x6 KVH60160 rafters with a birdsmouth on each beam, roof OSB + underlay + standing seam ROR12003 (clips FAS60100) + drip edge, 1x6 KVR14024 fascia and rake boards; the stilt house's walls / siding / corner boards and porch posts up to the beam of their side, the play fort's posts up to theirs, 2x4 gable ties between the posts' inner faces under the beams (screwed through the posts) carrying the knee braces and the swing beam; part sheets Rafter / Fascia; the gable defaults bill exactly as v369 ) */
  /* previous: var VERSION = 'bench-v369-phkids';   ( v369 (Marek 2026-10-29 22:29, PLAYHOUSES review of all seven): KIDS' COLOURS -- a cheerful set per colour scheme for walls, trims, doors, shutters, roof, slide (PH_PALETTES, _phPaint, the brush repaints without a rebuild); THE STORE'S TREE in the tree fort (tree_without_leaves_low_poly.glb, the configurators' scenery tree: its trunk sized to the slider at the deck, its first branch over the walls; the drawn trunk until it loads); DOORS AJAR, SHUTTERS OFF THE WALL each at its own angle (_phLeaves, drawn only) and every leaf a node of its own on its hinge in the AR file (extras.leaf) -- the AR page's walk-through opens them; THE SECTION TOOL of the house line (configurator-ui cutPlanes copied: the rail's cf-btn-cut, X / Y / Z, the arrow to drag) on the playhouses; the assembly orders checked on all seven types -- the A-frame's door / window framing after its gable studs (the horizontals and their screws came first), the cripples over its headers a step of their own, the ridge board after the rafters, the play fort's gable braces after the ties, the ball catch on the door's boards ) */
  /* previous: var VERSION = 'bench-v368-treefort';   ( v368 (Marek 2026-10-29 20:25: "Dalsi krok" -- PLAYHOUSES slot 7, the last of the plan): TYPE 32 THE TREE FORT (/products/playhouses variant 7, PRODUCT_TYPES['playhouses'] = [26, 27, 28, 29, 30, 31, 32]) -- its own _tfLayout: the play fort's open deck round a living tree on four posts of its own (ground screws + U heads, 2x6 rims bolted through the posts, joists at <= 40 cm / US 16 in.), nothing fixed to the tree: the trunk's opening framed with trimmers, two 2x6 headers and (where the trimmers stand wider apart than the joists' spacing) a tail joist each side, the decking cut back 5 cm (US 2 in.) clear of the trunk; a 2x4 knee brace lapped on each post's two outer faces under the rims (two screws into the post, one up into the rim); the play fort's walls (2x4 rails, pointed 1x6 boards), ladder and slide (the info bar's toggle, MISSING in the catalogue); the trunk's diameter on the slider, 15-45 cm (US 6-18 in.); the tree drawn see-through (the customer's own, not billed, left out of the framing, the 2D dimensions and the AR file); on top of bench-v367-barn ) */
  /* previous: var VERSION = 'bench-v367-barn';   ( v367 (Marek 2026-10-29 19:18: "Dalsi krok" -- PLAYHOUSES slot 6 as planned): TYPE 31 THE LITTLE BARN (/products/playhouses variant 6, PRODUCT_TYPES['playhouses'] = [26, 27, 28, 29, 30, 31]) -- its own _brLayout: the cottage's floor and 2x4 walls (2x4 top plates) under a tall gambrel: trusses of four 2x4 segments (66 / 22 deg) with OSB gussets (5x40), toe-screwed feet, gable studs, OSB + underlay + shingles + caps + drip edge, 1x4 fascia and rake trims; double doors and a hayloft door over them in the front gable (T&G leaves, strap hinges, a knob + ball catch each), windows in the sides and the back; the loft on the toggle (2x6 joists beside the trusses + one behind the gable studs, OSB floor, guard rails on posts each side of the 2x6 / 2x4 ladder); the siding and doors drawn barn red, the trims white. Also the cottage's / stilt house's screw crossings fixed (the porch's rim-end screws, the plates' screws clear of the floor's and the cripples', the top plates' screws near the faces, the gable studs' toe screws apart, the shutters' hinge leaves between the casing nails); on top of bench-v366-modern ) */
  /* previous: var VERSION = 'bench-v366-modern';   ( v366 (Marek 2026-10-29 18:38: "Dalsi krok" -- PLAYHOUSES slot 5 as planned): TYPE 30 THE MODERN HOUSE (/products/playhouses variant 5, PRODUCT_TYPES['playhouses'] = [26, 27, 28, 29, 30]) -- its own _mdLayout: the cottage's floor on deck blocks, walls, door and porch (the toggle) under a 14 deg mono-pitch roof falling from the left wall to the right: 4x6 beams at two heights running on past the gables to carry the fly rafters, one-piece 2x6 KVH60160 rafters with a birdsmouth on each beam (8x200 down into each), no ridge / ties, gable studs, roof OSB + underlay + the metal sheet ROR12003 as standing seam (clips FAS60100 5 a m2) + drip edge, 1x6 KVR14024 fascia and rake boards; a wide 91 x 46 window in the high wall, a square one in the back, no shutters; the skin drawn charcoal; MATERIALS + ROR12003 (m2) -- the gazebo's / pergola's standing seam went out as whole m2 before; on top of bench-v365-playfort ) */
  /* previous: var VERSION = 'bench-v365-playfort';   ( v365 (Marek 2026-10-29 17:37: "Dalsi krok" -- PLAYHOUSES slot 4 as planned): TYPE 29 THE PLAY FORT (/products/playhouses variant 4, PRODUCT_TYPES['playhouses'] = [26, 27, 28, 29]) -- its own _pfLayout: four 4x4 posts on ground screws + U heads up to the roof, the deck 1.22 m (US 4 ft) up on 2x6 rims bolted round the posts (M16 rods) + joists + decking, fort walls of pointed 1x6 KVR14024 boards on 2x4 rails (the front open for the ladder, the right side for the slide), the cottage's 40 deg shingled gable on 4x6 beams with ties and knee braces, the stilt house's ladder and slide (MISSING), and on the info bar's toggle the swings -- a 4x8 beam on the ties out through the back gable to the kids' set's A-frame 2.50 m (US 8 ft) behind, two board seats on chains; W / L 1.20-2.40 m (US 4-8 ft), default 1.50 x 1.50; _isPhType() for the playhouse types; name = the new key configurator.bench_v29, the toggle the existing configurator.nearby_type_swings; on top of bench-v364-aframe ) */
  /* previous: var VERSION = 'bench-v364-aframe';   ( v364 (Marek 2026-10-29 16:39: "Dalsi krok" -- PLAYHOUSES slot 3 as planned): TYPE 28 THE A-FRAME HUT (/products/playhouses variant 3, PRODUCT_TYPES['playhouses'] = [26, 27, 28]) -- its own _afLayout (the playhouses' builder / bill / steps through _phAnyLayout): the cottage's floor on deck blocks, a 2x6 KVH60160 sill flat on each rim (FAS60120), 60 deg 2x4 rafter pairs at <= 60 cm cut level on the sills (2 toe screws FAS60080) and plumb on a 2x6 ridge board, collar ties >= 1.15 m over the floor, OSB + underlay + shingles + caps + drip edge down to the foot, rake boards on fly rafters, the gables framed to the end rafters (door 60 wide as high as the rafters let it, a 46 x 46 window at the back), panel siding + a skirt over the rims, the porch on the toggle -- the floor, the sills and the roof 90 cm (US 3 ft) on over its decking; W 2.10-3.00 m (US 7-10 ft); name = the existing key configurator.a_frame; on top of bench-v363-stilt ) */
  /* previous: var VERSION = 'bench-v363-stilt';   ( v363 (Marek 2026-10-29 15:33: "Dalsi krok" -- PLAYHOUSES slot 2 as planned): TYPE 27 THE STILT HOUSE (/products/playhouses variant 2, PRODUCT_TYPES['playhouses'] = [26, 27]) -- the cottage's house with its floor 1.22 m (US 4 ft) up: 4x4 posts in U heads FGR00002 on ground screws FGR00001 (12 nails FAS38038 each), a 4x6 KVH10160 frame on their tops (2 x 8x260 FAS80260 down into each post; the joists, end and front beams 8x200 FAS80200 through the 4x6), 2x4 diagonals on the posts' outer faces (sides + back) and knee braces under the front beam, the porch posts one piece from the ground to the roof beam, a 90 cm (US 3 ft) guard -- 2x4 rails, 38x38 KVH03838 balusters <= 8.5 cm clear, a 2x4 post on the front wall each side --, the ladder at the front between two 4x4 posts bolted to the front beam (M16 rods FAT16010 + washers + cap nuts), 2x6 rails at 75 deg, 2x4 treads <= 28 cm; the slide off the right side on the toggle (no catalogue row: MISSING, drawn as its HDPE shape); on top of bench-v362-cottage ) */
  /* previous: var VERSION = 'bench-v362-cottage';   ( v362 (Marek 2026-10-29 14:18: "Zalozil jsem produkt playhouses. Muzes na nem zacit pracovat - preklady, popisy, varianty a samotne konfiguratory. Cena 20$ each"; chose the swing engine and the Cottage first): TYPE 26 THE COTTAGE, PLAYHOUSES slot 1 (/products/playhouses, PRODUCT_TYPES['playhouses'] = [26]) -- deck blocks, a 2x6 floor frame + OSB, 2x4 walls under 4x6 beams / 2x4 gable plates, a 40 deg gable roof (2x4 rafters, ridge board, ties, fly rafters, OSB, underlay, shingles + caps, drip edge, fascia), panel siding FCP00009 with corner boards + casings, a ledge-and-brace T&G door on strap hinges (dummy knob + ball catch, no lock), open board shutters at the three windows (no glass), the porch on the toggle (posts, braces, decking); L / W on the footprint's grips; every framing screw / nail drawn + billed, the sheets' fixings by rate; MATERIALS + OSB25001, FCP00009, FVW09619, FVW02660 and the units of KVR14619 (m2) / ROR00009 (m) -- those two went out to the budget as whole numbers; on top of bench-v361-ig2swing) */
  /* previous: 'bench-v361-ig2swing';   /* v361 (2026-10-29, Marek 10:27: "Dalsi reel bude na tema swing, varianta 5 - lavice s pergolou nad. Priprav prosim reel vcetne voice over, muzes otevrit i agenta AI. Na ukazku boq."): THE ?ig2 PERGOLA SWING REEL -- on SWINGS' ?ig2 page the PLAY runs a voiced reel of the pergola swing (T17) under 60 s: the hook (new clip ig2-swing-intro) over the exploded turn, the seat stretched 1.52 > 2.44 m with the pergola following + planks > slats + the gap + the cushion (new ig2-swing-edit), the assembly walk (frame + seat), the BoQ (the tight budget step), the AI assistant's project card from the budget (new ig2-swing-ai, ai.js v2.88 LevaAI.demo), the outro turn; ?ig2=8 keeps the 8-second story; leva-workers voice run 64. v360 (2026-10-27, Marek: the canvas lower on an upright screen, every configurator -- the router's canvas-h-v1): on ?ig the PLAY 12 px above the info bar / the backrest-tilt slider, not over them. v359 (2026-10-27, AI reel thread, Marek 2026-10-27 10:38: "Tlacitko play dej na stred dolu, ale po zmacknuti, dve vteriny nic, pak spustit. Tlacitko mezitim schovat - plati pro vsechny prispevky pro ig, ktere budeme delat"): on ?ig / ?ig2 the PLAY bottom centre, hidden at the tap, the reel / story 2 s later (as core-v763). v358 (Marek 2026-10-26 21:10: Chci DNES publikovat reel na tema cinema garden bar. Udelej mi prosim max 60 sec ?ig2 na garden structure ktery ukaze editaci, assembly, AR i budget; 21:11: idealne pouzit stopy MP3 ktere uz mame, ale na zacatek urcite konkretne ke garden cinema, klidne udelej nove i jinde): THE ?ig2 CINEMA BAR REEL -- on GARDEN STRUCTURES' ?ig2 page the PLAY runs a voiced reel of the cinema bar alone (under 60 s): the hook (new clip ig2-cinema-intro) over the exploded turn of the 8-second story, the length dragged + the screen rolled down (ig-garden-bar), the colours (ig-bench-colors), the assembly walk (ig-assembly), the AR window with its QR (new clip ig2-cinema-ar), the budget -- the stores + cheapest, a framing item's card -- tighter (ig-budget), the outro turn (ig-outro); the PLAY out of the video while it plays; the 8-second story stays on ?ig2=8 and on the other products' ?ig2; leva-workers voice run 60; on top of bench-v357-mbconf */
  /* previous: 'bench-v357-mbconf';   /* v357 (Marek 2026-10-26 18:35: kroky assembly po jednom kroku, texty z BOQ vcetne prekladu; lepe rozvrhnout pohyb komponentu -- obklad z boku na steny; doplnit chybejici radky do BOQ katalogu; 18:54: prepinani tvaru L pravy / L levy / U bar / I tvar, sklon strechy, tvar strechy, vyska, krytina on / off -- default jak to ma autor): THE BAR (type 25) ONE CATALOGUE ITEM A STEP (MB_STEPS: the step's caption is that item's name from the central BoQ in the page's language, its size from the sheet's note; the slab's making drawn for its own steps -- the dig, the geotextile, the formwork, the spacers, the mesh -- MB_PROC; the coating step lights the timber); every part flies in its own way (the cladding's layers from outside along the face's normal, the studs from their wall's outer side, the roof and the top from above, the stools from the garden); the four missing rows in the catalogue now (FCP00010 stone veneer, FFC00008 tile edge trim, FEC00047 hedge panels, FAS75100 the plates' concrete screws) + the stone's and the tiles' adhesive, the membrane, the grout and the LED supply drawn; THE OPTIONS (Adam's build the default): the counter L right (the return at -Z) / L left / U / I on the info bar's toggle, the roof mono-pitch / gable (2x8 rafters KVH60200, a ridge cap ROR00009), its pitch on a slider, the height 2.10 .. 3.00 m on the other slider, the sheets on / off; on top of bench-v356-gardenbar */
  /* previous: 'bench-v356-gardenbar';   /* v356 (Marek 2026-10-26 18:06: z varianty 6 v garden structure samostatny produkt spoluprace GARDEN BAR, v garden structure zrusit; royalty commission a affiliate shopping list po prihlaseni autora; drawer s autorem): the bar T25 is sold on its own product GARDEN BAR (/products/garden-bar, PRODUCT_TYPES['garden-bar'] = [25]) and left GARDEN STRUCTURES; a design of the bar opened on GARDEN STRUCTURES goes to GARDEN BAR (_openOnOwnProduct); its ?ig tour takes the garden hook; A ROYALTY PRODUCT (the product's vendor is the author, not LEVA -- BENCH_BOOT.vendor): the PDF button skips the token step and goes straight to the export, so the purchase gate decides -- a buyer of the variant gets the PDF, anyone else 'Purchase to unlock' (tokens never open it: the author is paid from the sale), as the firewood rack (rack-v9-purchase); on top of bench-v355-mcbar */
  /* previous: 'bench-v355-mcbar';   /* v355 (marketing thread, Marek 2026-10-26 15:29: Udelej variantu BAR jako prvni v garden structure, rovnou tam u ni udelej drawer autora spoluprace jako u Matta; 15:30: bar je udelany z drevene konstrukce, oblozena dlazbou, kamennym obkladem): TYPE 25 THE BAR -- Adam's (@mancavebartender) garden bar as a GARDEN STRUCTURES variant: a concrete slab, 4x4 posts on post bases, 4x8 beams falling 10 deg to the back, 2x6 purlins, black corrugated sheets; a T&G back wall with hedge panels; the L-shaped counter a 2x4 stud frame round the front posts, cement board + split-face stone outside, the top marine ply + cement board + tiles, an LED strip under the lip; stools, a string of bulbs; the return (L / straight) on the info-bar toggle; on top of bench-v354-acaciatop */
  /* previous: 'bench-v354-acaciatop';   /* v354 (Marek 2026-10-23 12:27 + 12:29: carpentry connectors docela drahe -- proc tolik spoju, nedaji se nahradit normalnim spojovacim materialem?; proc excavation, kdyz jsou pod konci dlazdice?; deska ma byt deska do exterieru, bez spojovaciho materialu na ni -- his pick: masiv akat): THE CINEMA BAR'S TOP one acacia butcher block FOU00034 (new catalogue row, by the metre, 25 in. / 635 mm deep, 1 1/2 in. / 38 mm, up to 12 ft / 4 m a piece), fixed from below by pocket screws FAS50060 up through the rails' inner faces, oiled (MFP00002) -- no board top, no screw on the top; THE BAR'S BRACES screwed to the rails and footrests (2 screws for each former M16 rod: FAS60100, US FAS50060) -- the rods, washers and cap nuts stay only on the frame (rails / footrests to the posts, ties, struts); NO EXCAVATION FEE00001 under pavers or precast blocks (the cinema bar's tiles, the arbor's pavers and deck blocks, the gazebo's and pergola's precast pads -- their shallow beds are dug by hand with the paver), only under poured footings; on top of bench-v353-bartop */
  /* previous: 'bench-v353-bartop';   /* v353 (Marek 2026-10-23 10:43: u cinema bar mame nastavenou cenu worktop na 49 dolaru za ft2, celou castku to docela navysuje, hledani nic nenaslo -- jak to udelat aby u tohoto projektu byla barova deska za rozumne penize a existovaly vysledky vyhledavani; mas volnou ruku): THE CINEMA BAR'S TOP OF BOARDS -- the outdoor kitchen's granite slab FOU00027 (an estimate only, no store sells it as searched) and its adhesive beads FEC00031 gone; the top is 2x6 boards KVH60160 laid ACROSS the bar on the two rails (the bar's own lumber, priced from the stores), 2 - 8 mm apart, each screwed down 2 x 6x100 FAS60100 into each rail; the same 42 in. top, the same overhangs; its assembly: the boards, then their screws; on top of bench-v352-ig2wide */
  /* previous: 'bench-v352-ig2wide';   /* v352 (Marek 2026-10-23 09:25: jeste trosku vice exploded on pak exploded off - plynule vratit zpet. Assembly ok): the ?ig2 story's exploded view wider (from the middle 100 %, up by the height 85 %, was 70 / 60), apart 0.2 - 1.3 s, held to 1.65, back together slowly and smoothly 1.65 - 3.25 s (a smootherstep, no jolt at either end), the camera stepped back 85 % with it; the assembly as it was; on top of bench-v351-ig2 */
  /* previous: 'bench-v351-ig2';   /* v351 (Marek 2026-10-23 09:05: kratky exploded view on - pak off, a zaroven rotace cinema bar. Pak animace skladby - assembly mode. Pri spusteni play voice guide. Ale bez voice guide. Treba s kodem stranky ?ig2. Dam to jako 8 vterinove video na stories): THE ?ig2 STORY -- on a ?ig2 page the PLAY runs an 8-second silent show instead of the tour: the cinema bar flies apart and back together during one turn round it, then is taken down and built again in its assembly order; no voice, no subtitles -- see THE ?ig2 STORY by the tour's button; on top of bench-v350-gzfields */
  /* previous: 'bench-v350-gzfields';   /* v350 (GARDEN STRUCTURE thread, Marek 2026-10-22 14:54: U altanu by to chtelo dodelat podobny system vyplni pole jako u pergoly. Nechat jak to je ted ale s moznosti nahrazeni vyplne pres celou vysku na kazdem poli zvlast. Muzes dodelat co chybi): THE GAZEBO'S SIDES -- a + / - disc on the ground at every side (the pergola's), a tap swaps that side between its railing (the entrance: open) and the infill over the whole height (the switch's slats / boards at the slider's gap, a head rail under the plate, the railing's top rail the middle one); THE PART SHEETS of the cinema bar (rafters, braces, struts), the raised bed (the trellis braces; the cold frame's posts, rafters, sash stiles, battens) and the garden arbor (heads, braces, slats, rafters, battens, the arch segments with their radii and blank, the lapped posts) in the PDF; on top of bench-v349-gpufree */
  /* previous: 'bench-v349-gpufree';   /* v349 (Marek 2026-10-22 14:30: byl jsem na truhliku s kridly a najednou se objevil banner z bench -- konfigurator nikde, bile pozadi; zmizela i mapa, nefunguje refresh): the GPU memory filled up -- every rebuild left the old model's nested geometry (the edge lines of every part, everything inside a part's group) on the graphics card, about 120 pieces a rebuild on the raised bed and a rebuild on every frame of a drag, so after a few reels the tablet's GPU ran out, Chrome dropped the 3D (and the map with it) and blocked 3D for the site until a restart; now every removed part is disposed down to its last child, and a lost / restored WebGL context is written to the log; on top of bench-v348-cardfilter */
  /* previous: 'bench-v348-cardfilter';   /* v348 (Marek 2026-10-22 14:17: IG funguje dobre, jeste udelej na ukazku filtr na item detail, zapni prvni a treti): the budget step's item card -- once run down to its offers, the store filter shown: the FIRST and the THIRD store tile tapped on (pulsed, then the card's own tap), the filtered offers held, then the filter put back as the card had it (its Amazon preselection kept) and the card shut; on top of bench-v347-tourlangs */
  /* previous: 'bench-v347-tourlangs';   /* v347 (Marek 2026-10-22 13:59: opet se neotevrel drawer s vhodnou polozkou -- u cinema bar treba DIMENSIONAL LUMBER KVH16160; 14:00: udelat pruvodce ve vsech 21 jazycich pro garden structures, benches, swings): the budget step's framing row was in a COLLAPSED section of the drawer (budget-core collapses every section but the first) -- it is found there now, its section opened for the step and shut again after; THE TOUR IN THE PAGE'S LANGUAGE: the ?ig reel in every language (the bed reel stays English), the product's hook first in every language, GARDEN STRUCTURES' web tour = its reel (it has no per-type steps), the 21 voices listed, the subtitles in the language of the clip that plays (English where a clip of the language is missing); on top of bench-v346-gardenig */
  /* previous: 'bench-v346-gardenig';   /* v346 (GARDEN STRUCTURE thread, Marek 2026-10-22 13:21: nejpopularnejsi vyvyseny zahon s kridly, pergola a cinema bar -- zahon rozmery + otevrit kridlo; pergola vypln mezi tramy, zmena strechy, zaklad; cinema bar delka, animace platna a assembly steps; u budgetu otevrit nejaky framing item): the GARDEN STRUCTURES ?ig reel -- the cold frame (rb-wings: length + width dragged, a wing lifted, ig-garden-bed), the pergola's infill (as v339), its roof AND foundation (ig-garden-roof), the cinema bar (gs-bar: length dragged, the screen rolled down, ig-garden-bar) and its assembly walk on that same bar, the budget opening a FRAMING item (dimensional lumber -- it always has store offers; else the second item as before); on top of bench-v345-boqrows */
  /* previous: 'bench-v345-boqrows';   /* v345 (GARDEN STRUCTURE thread, Marek 2026-10-22 13:04: Ano, muzes dale. Pridat BOQ polozky): the three MISSING items have catalogue rows now (EXECUTION 2, written 2026-10-22 with his OK) and are billed -- FMC00043 PROJECTOR CEILING MOUNT (the cinema bar, 1), FAS60040 CONCRETE SCREW ANCHOR 6 x 40 / 1/4 x 1 3/4 in. (the garden arbor's post bases into the pavers, 2 a base), FAS10000 STAINLESS STAPLES 10 mm / 3/8 in. (the cold frame's vinyl, as drawn); GARDEN STRUCTURES has no missing item left; on top of bench-v344-refpool */
  /* previous: 'bench-v344-refpool';   /* v344 (Marek's REF runs 2026-10-22 08:49-08:58, LOG #352-354: GARDEN STRUCTURES 69 + 1 failed, BENCHES 34 + 1, SWINGS 21 + 7 -- the designs whose lists ran out failed or landed within 30 km of a pin): REF_POOL_US (108 towns over the lower 48 states) and REF_POOL_EU (54 towns), handed to every design as r.pool -- the snippet's bref-v4 takes the pool's town farthest from every pin when the design's own list has none left; on top of bench-v343-pesheets */
  /* previous: 'bench-v343-pesheets';   /* v343 (GARDEN STRUCTURE thread, Marek 2026-10-22 09:27: Ano, pokracuj -- the next steps): the gable pergola's RAKES 30 cm (US 12 in.) past the gable ends as its eaves -- the side beams run through over the corner posts and on (the front / back beams between them, as the flat roof's), the ridge, the end rafter pairs and the covering out to them; the PDF's PART SHEETS of the pergola and the gazebo -- every shaped timber (a cut not square) once per shape, its outline, every edge, the angles, how many and how many mirrored; on top of bench-v342-refspread */
  /* previous: 'bench-v342-refspread';   /* v342 (Marek's REF run 2026-10-22 07:13, LOG #348: 70 published, but 18 US designs of the cinema bar / pergola landed within 30 km of a pin -- every town of their lists was taken, 8 of them 0 km on top of one): REF_PLACES[19] + 10 towns, REF_PLACES[24] + 24 towns, none near the big cities the other types took; on top of bench-v341-fpgold */
  /* previous: 'bench-v341-fpgold';   /* v341 (Marek 2026-10-22 00:25: Udelej footprint square stejny jako je footprint strechy u Adu ... V nasi zlate barve, mensi drag pointy. Aplikuj to ... napric vsemi produkty): the copied kit's footprint as the kit's ui-v352 -- gold outline, 3 % fill, a trace behind the model, smaller pucks (the pergola's / arbor's footprint); on top of bench-v340-gsref */
  /* previous: 'bench-v340-gsref';   /* v340 (GARDEN STRUCTURE thread, Marek 2026-10-22 00:28: A jeste udelat 50 references designs napric spojenymi staty a 20 napric evropou): GARDEN STRUCTURES' reference designs 15 -> 70 -- 50 in the US (built in US lumber) and 20 in Europe (eu: true, built metric, REF_PLACES_EU with the country code); the pergola's ids e1..e3 -> v1..v3 and the sunbed's s1..s3 -> o1..o3 (they shared their Firestore documents with the pergola swing's / the sofa's); on top of bench-v339-gardenig */
  /* previous: 'bench-v339-gardenig';   /* v339 (GARDEN STRUCTURE thread, Marek 2026-10-21 23:43: A udelej i ?ig pruvodce): the GARDEN STRUCTURES ?ig reel -- its own hook ig-intro-garden over a cut of every garden type (also the first clip of its English web tour), the pergola's infill step (ig-garden-infill: fields filled on their + discs, the five kinds, the spacing on the slider), its roof step (ig-roof: the footprint dragged, flat > gable > hip, the covering on), then the build, the budget, the assistant, the outro as every reel; leva-workers voice run 52; on top of bench-v338-pefills */
  /* previous: 'bench-v338-pefills';   /* v338 (GARDEN STRUCTURE thread, Marek 2026-10-21 23:18 with two photos: Udelej jeste dva typy vyplni - krome horizontal a vertical a trellis jeste tyto dve kombinovane vyplne.. Vse musi mit odpovidajici spojovaci material a vse ve vykazu vymer (idealne pouzit to co uz mame); 23:21: U vertical slats mas navic jednu vyztuhu take svislou na vnitrni strane - podle me je zbytecna (i u trellis je tam asi pozustatek z horizontal). Mozna spise na vysku pridat jeste jeden horizontalni profil - v zavislosti na hustote ... Plati pak i u horizontalnich; 23:22: slats / profily by mely byt az na vnejsi roh nohy daneho pole): the pergola's infill kinds 5 -- + SLATS + TRELLIS (horizontal slats, a trellis band on top) and X + TRELLIS (a rail panel with X braces, a trellis over it), every piece from the existing 40x60 KVH40060 with its screws; no stile behind vertical slats / the trellis; the stiles (horizontal) and the rails (vertical) by the slats' density; the members to the far edge of the field's posts (the corner); on top of bench-v337-shelterfp */
  /* previous: 'bench-v337-shelterfp';   /* v337 (GARDEN STRUCTURE thread, Marek 2026-10-21 22:56: Ale terciky plus nechat na podlaze, jako u shelters Udelat prepinani plus minus / Footprint points neodpovidaji tomu jak to mame treba u shelters (velikost a umisteni points - mame tam i inverzni points v rozich. Musime udrzet jednotne ui napric produkty ! Nejak to zapasat a sahat tam v techto pripadech. / A udelat slider pro nastaveni roztece slats. Kdyz jsou vertikalni, tak musi byt horizontalni nosne profily - okopiruj to jak to mame v shelters): the pergola's and the arbor's footprint IS the shelter's -- the kit's handles (configurator-ui.js handles()) copied in as _fpHandles: the 'primary' ghost, olive corner pucks + white edge pucks, 30 px grips, the house kota while dragging; the + / - discs on the ground as the shelter's post-wall dots; the infill's spacing on the slider (10 - 200 mm as the shelter's); vertical slats on the shelter's level rails KVH10060 (foot, head, every <= 1.20 m); on top of bench-v336-footprint */
  /* previous: 'bench-v336-footprint';   /* v336 (GARDEN STRUCTURE thread, Marek 2026-10-21 22:11: Udelej to tak, ze jsou vyplne vzdy pres cele pole, ono ukotvit ty polovicni by nebylo jednoduche. Takze udelat stejne jako jsou u shelter / Drag pointy rozmer udelej u paty konstrukci, na jedne strane mas drag point vys nez na druhe / Odstranit i prepinani ctverec / rectangle, ukazovat u drag koty at ma uzivatel predstavu - mozna by bylo lepsi udelat proste footprint drag pointy na stredech (stejny footprint jak byva u shelter. Udelej to stejne i u varianty 3. A drag pointy u ostatnich vizualne udelat mensi (velikost uchopovani muze zustat stejna)): the pergola's infill always the whole field (+ : empty <> full), its + at the field's middle; no Square / Rectangle switch; THE PERGOLA AND THE GARDEN ARBOR on a FOOTPRINT on the ground (the kit's light-structure ghost, gold) with a grip at each side's middle and the size beside the nearer grip of each pair; on top of bench-v335-igbudget */
  /* previous: 'bench-v335-igbudget';   /* bench-v335 (Marek 2026-10-21 21:56 + 21:59: titulky jsou schovane za drawers, neotevira se drawer s item detail -- vzdy vybrat druhou polozku v rozpoctu; a doplnit i do IG pred otevrenim budgetu exploded a par kroku assembly, jak je mame ted (u varianty 1), i v beznem pruvodci): the tour's subtitle over every open drawer (the budget, an item's card, the assistant ...: in the page's body, fixed, 100001); the ?ig reel's budget step as the container's (container-v559..v563): the dashboard held, the price bar's 3 stores + CHEAPEST as a preview, a run down to the budget's SECOND item, its card opened, held until loaded, run down to its offers, shut, the bar put back; a step may run past its voice (hold, as container-v559); the reel's build step on the product's first variant -- the park bench: exploded, pocket holes, the frame, the seat, the arms, the backrest flying in, its planks, built -- and the same walk in the whole tour after the park bench (tour-assembly) */
  /* previous: 'bench-v334-pergola';   /* v334 (GARDEN STRUCTURE thread, Marek 2026-10-21 21:23 with three pergola photos: Ted udelame pergolu. Sloupy, pri vetsich roztecich pridat sloupky, udelat variantu ctvercovou. Moznost vyplne poli mezi sloupy jako to mame u shelter - jen s rozdilem ze i tlacitko plus bude cyklovat - cela vypln, leva pulka, prava pulka, prazdne. Prepinani slats horizontalni a vertikalni a treti typ miz. Tri tvary kryti - flat / gable / hip a krytina on / off; asked: a Rectangle / Square switch, the covering standing seam on boards): TYPE 24 THE PERGOLA, GARDEN STRUCTURE slot 5 -- 6x6 posts (more on a long side), 6x6 beams mitred round the top, 4x4 knee braces, flat / gable / hip roofs with the covering on / off, the infill of every field on its + button, three infill kinds; on top of bench-v333-gagrid * / */
  /* previous: var VERSION = 'bench-v333-gagrid'; */
  /* previous: 'bench-v329-gzopts';   /* v329 (GARDEN STRUCTURE thread, Marek 2026-10-21 18:59 on the v328 gazebo: mame to vsechno do posledniho sroubku? Udelej to s moznosti zmeny krytiny a zmeny zalozeni (vruty / prefa patky / odlevane patky jako mame na ADU); pridat moznost vyplne slats -- dva profily, jak je ted a vice prkno, i s posuvnikem roztece; strechu i plech; asfaltovemu sindeli texturu jako na jinych projektech; 19:03 vypln take dolu, LUMBER u gazeba nemusi byt): the gazebo's FOUNDATION on the toggle (ground screws > precast pads FCO00012 > poured footings 400 x 400 as the ADU's piers: concrete, 4 bars, formwork, gravel, geotextile, a wet-set U anchor FCO00004), its COVERING on a switch (asphalt shingle with the tiny / shelters shingle texture | standing seam ROR12003, the house line's 530 pans, clips), its INFILL on a switch (2x2 slats | 1x4 boards TIM20100) with the clear gap on the slider (10 - 120 mm, US 3/8 - 4 3/4 in.); the hip caps' fixings billed (2 roofing nails a cap shingle / sealing screws FAS00225 on metal); on top of bench-v328-gazebo */
  /* previous: 'bench-v328-gazebo';   /* v328 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:59 with two photos of timber gazebos: dalsi structure / varianta je gazebo. Prepinani mezi 4 boky (ctvercovy) a 6 boky tvar. Valbova konstrukce strechy): TYPE 23 the gazebo, GARDEN STRUCTURE slot 4 -- hexagon / square on the info bar's switch, its width across the flats on the handle (2.40 - 4.20 m, US 8 - 14 ft); ground screws + U heads, 4x4 posts, a flush deck (2x6 rims, a 4x6 middle beam, 2x6 joists in hangers, 5/4x6 decking notched round the posts), 4x6 plates mitred over the posts, a hipped roof (2x6 hips to a 6x6 king post, jacks in pairs, T&G boards, underlay, shingles, hip caps, drip edge), a 2x4 railing with 2x2 balusters on all sides but the entrance; every screw and nail of the timber drawn and billed; on top of bench-v327-rbknee */
  /* previous: 'bench-v327-rbknee';   /* v327 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:49: udelej nizsi sloup pod sikmymi profily konstrukce, aby se clovek mohl lepe dostavat k hline -- zbytecne vysoky odskok): the cold frame's posts 5 cm (US 2 in.) over the cap instead of 15 cm (US 6 in.) -- the rafters' foot, the eave rails and the wings 10 cm lower, the eave rail's top 14 cm over the cap (was 24); the vinyl's staples on the post's outer face: one in the middle of the short stub; on top of bench-v326-rbonewing */
  /* previous: 'bench-v326-rbonewing';   /* v326 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:36: u truhliku s folii jeste udelej jen jedno kridlo zvednute v open rezimu): the cold frame's OPEN raises ONE wing only -- the front one (1 + 1), the front one nearer the view (2 + 2); the others stay shut on their lid supports (every wing keeps its own pair of supports, billed as before); and (17:44: nechme profily, jen ho defaultne udelejme vetsi - pak ram nebude vypadat tak masivne) the cold frame opens 2.40 x 1.30 m (US 8 x 4 ft, 2 + 2 wings; was 1.20 x 1.20), the frame's sections unchanged; on top of bench-v325-rbview */
  /* previous: 'bench-v325-rbview';   /* v325 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:27: folii / vinyl na zahone udelej opacity 10%, at je pruhledna; vyvyseny zahon je extremne zoom in, musi byt primerene; udelej pri zapnuti varianty 2 defaultne vyvyseny zahon s trellis): the cold frame's vinyl 10 % opaque (its material said 30 %, but the viz stage set it opaque -- now capped there, as the modern swing's cloth); the wings framed again when opened; the raised bed opens as the basic bed WITH its trellis (an older saved 'off' no longer counts); its framing: the box framed as if at least FIT.MIN_H tall and with more air round it (FIT.TYPE[20]) -- no more a bed filling the stage; on top of bench-v324-projmount */
  /* previous: 'bench-v324-projmount';   /* v324 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:18: promitacku dej na konstrukci u stresni casti - cinema bar): the projector off the counter -- hung upside down on a low ceiling mount under the FRONT eave beam, centred on the screen, its lens to the screen over the stools and the counter; the mount's plate 4 x 6x80 FAS60080 up into the beam (billed), the mount itself drawn, NOT BILLED (no catalogue row, MISSING); on top of bench-v323-notips */
  /* previous: 'bench-v323-notips';   /* v323 (Marek 2026-10-21 17:15 with a screenshot of the cinema bar's SCREEN toggle and a black 'Screen' bubble beside it: jsou dvakrat screen na obrazovce - ten tooltip tam nemusi vubec byt, plati pro vsechny takove prvky ovladani): the info bar's labelled switches (the toggle, the second switch) draw no tooltip -- the runtime CSS hides their ::after; on top of bench-v322-arborfound */
  /* previous: 'bench-v322-arborfound';   /* v322 (GARDEN STRUCTURE thread, Marek 2026-10-21 17:00 on the v321 garden arbor: krokve nejsou dobre pridelene k hrebeni, vruty jsou jak jsi z boku maji byt z vrchu krokve do hrebeneveho profilu; zaklad ma byt prepinany - dlazdice, nebo kotvy s vruty, nebo prefabrikovane patky do kterych sloup presne zapadne, z boq nebo pridat): the rafters fixed to the ridge board by 2 x 6x100 FAS60100 each from the rafter's top, square to the slope, into the board (no side toe screws); the foundation on the toggle: pavers + post bases (as v321) / ground screws FGR00001 + U heads FGR00002 (as v320) / precast deck blocks FCO00012 the post sits in; the arbor's roof, width and foundation in a shared design; on top of bench-v321-arborpave */
  /* previous: 'bench-v321-arborpave';   /* v321 (GARDEN STRUCTURE thread, Marek 2026-10-21 15:23 on the v320 garden arbor with the gable pergola photo again: dlazbu dat jen pod nohy, misto zalozeni na vrutech; sedlovou strechu spis udelat tak, ze bude mit masivnejsi krokve (samozrejme pozednici pod) a battens vodorovne vedouci pres krokve): each post on a concrete paver SFF00002 500 x 500 on gravel in an adjustable post base FFP01001 (its 2 concrete screws drawn, NOT BILLED -- no catalogue row short enough), no ground screws, no path, no toggle; 15:30 the heads, the wall plates and the braces of the posts' 4x4 (Marek: pricne horni profily / pozednice a vzpery udelat ze stejneho profilu jako jsou sloupky); the gable roof on 4x4 wall plates along the heads, 2x6 rafters at <= 60 cm birdsmouthed over them with plumb tails (never on a head), a 2x8 ridge board, 40x60 battens level across the rafters at <= 20 cm; on top of bench-v320-arbor */
  /* previous: 'bench-v320-arbor';   /* v320 (GARDEN STRUCTURE thread, Marek 2026-10-21 14:07 with two photos -- a flat-topped arbor over stepping tiles, a gable pergola under slats: dalsi projekt - pruchod na zahrade primarne urceny pro popinave rostliny, dva typy - rovny a sedlovy, editace delky a sirky, vyska standardni bez drag point, menit se bude jen strecha; asked: the sides podle obrazku, celo drevena = late; the posts prefabrikovana, mozna dlazdice + zemni vruty): TYPE 22 the garden arbor, GARDEN STRUCTURE slot 3 -- 4x4 posts on ground screws FGR00001 + U heads FGR00002, a raked 2x6 head across each pair of posts with 2x4 knee braces, 40x60 laths up both sides, the roof on the info bar's switch: flat (2x4 slats along on the heads) or gable 35 deg (2x4 rafters on each head, a 2x6 ridge board, 2x4 purlins), the path's concrete tiles SFF00002 on the toggle; L / W on the handles, no height point; every screw / nail drawn + billed; on top of bench-v319-trelscr */
  /* previous: 'bench-v319-trelscr';   /* v319 (GARDEN STRUCTURE thread, Marek 2026-10-21 13:15 with a close-up of the trellis brace's top at the post: vruty bych dal spise nad sebe, svisle, a tak aby byly co nejvice uprostred vzper i sloupu): each brace's 2 x 6x100 into the post now one over the other in a plumb line at the middle of the brace's part over the post (a quarter of the post from its axis), at 30 % / 70 % of the brace's width -- no longer side by side; on top of bench-v318-floatbed */
  /* previous: 'bench-v318-floatbed';   /* v318 (BENCHES & LOUNGE, Marek 2026-10-21 09:44 with the IFC + A3 drawings of the floating ash bed made here on 2026-10-19: je mozne z nej udelat dalsi polozku do produktu bench & lounge?; chose: only the width editable, a ready-made slatted base + the electrics billed): TYPE 21 the floating bed -- a hidden 4x4 spruce frame on 4 black legs 45 cm in, ash 40 mm side + foot panels and a headboard as wide as the bed + 2 nightstands on wall laths, 2 nightstands of ash 20 mm with push-to-open drawers, an LED groove round the headboard's back, a socket + switch over each nightstand, 2 slatted bases + the mattress; width by the mattress (140 - 200 x 200, US Full - King; bedMW shared with the bed); every screw / anchor drawn + billed, the ash / ply / HDF / slides / confirmats / brackets / small screws / LED profile / slatted bases / plates on MISSING; MATERIALS EEE00001 m, FEC00043 l (the budget publishes litres); on top of bench-v317-trelout */
  /* previous: 'bench-v317-trelout';   /* v317 (GARDEN STRUCTURE thread, Marek 2026-10-21 09:27 on the trellis: sikme vzpery davaji vetsi smysl instalovat vnejsi strany; u sloupu na vnitrni strane 2 + 2 profily zakryvaci z vrchu, v nicem nejsou ukotvene, tam vubec byt nemusi): TYPE 20 basic + trellis -- the end posts' A-braces on their outer face, over the short wall (feet on the long caps' ends); the short walls' caps only over the wall -- 80x60 KVH08060 flat (US 2x3 KVH40060, 1 in. proud), the post rising behind them, no notch and no loose strips; on top of bench-v316-trellis */
  /* previous: 'bench-v316-trellis';   /* v316 (GARDEN STRUCTURE thread, Marek 2026-10-21 09:05 with a photo of a cattle-panel trellis on a raised bed: udelej jeste u prvni varianty moznost zapnuti takoveto konstrukce, od ni vedou provazky / drate, nemusi byt v BOQ): TYPE 20 basic -- a trellis on the toggle: a 4x4 post at the middle of each short wall (run on up through a notch in the cap, screwed to the boards as the bed's posts) + in the soil at <= 2.40 m between them, a 4x4 beam on top 1.50 m (US 5 ft) over the cap (2 x FAS80200 into each post), each post braced across the bed by a pair of 2x4 KVH10060 (an A on its face, level seats on the long caps; 2 x FAS60100 into the post, a FAS80200 down through the foot); strings to a wire over the soil drawn, not billed; on top of bench-v315-coldframe */
  /* previous: 'bench-v315-coldframe';   /* v315 (GARDEN STRUCTURE thread, Marek 2026-10-21 07:31 on the raised bed's cold frame: s kridly ma spatny stit -- stit tvori ram, ktery vede ve vnitrni casti v rozich, spojeny hrebenem, nejmasivnejsi profily (2x2 az 3x3 podle velikosti); kridla ne tak masivni ram; folie jen sponkami?; kridla neotevirat uplne, funkcni vzpera na ~70 %; chose: the bed's corner posts on up, staples + a batten round the wing's edge): TYPE 20 wings -- the corner posts 80x80 KVH08080 (US 4x4 KVH10100) run up through a notch in the cap 15 cm (US 6 in.) over it, their tops cut to the pitch; end gables of the same section on them (2 x FAS60160 into each post), meeting under the ridge of the same section (FAS60120 into each rafter); eave rails of the same section between the end rafters, bevelled flush with them (2 x FAS60160 an end); a middle frame for 2 + 2 (posts under the eave rails); no king posts, no gable battens -- the gables' and the long sides' vinyl stapled, folded onto the cap; light 30x30 KVH03030 sashes (US 2x2), their vinyl stapled, 1x2 battens round the edge only (FAS50040, US FAS55050); the wings open 70 % of the way and stop on lid supports FAT00023 (body on the rafter, rod on a stile), drawn and animated; staples drawn, NOT BILLED (MISSING); on top of bench-v314-raisedbed */
  /* previous: 'bench-v314-raisedbed';   /* v314 (GARDEN STRUCTURE thread, Marek 2026-10-21 01:51 with three photos: dalsi structure bude vyvyseny zahon -- nizky az vysoky, pyramidovy a s otviranymi kridly, ramem vyplnenym vinyl sheets; prepinani variant v banneru (obycejny, pyramida, s kridly), editovat vyska, sirka, delka; u kridel rozmery, aby ram daval smysl, delsi 2 + 2 kridla): TYPE 20 the raised bed, GARDEN STRUCTURE variant 2 -- 2x8 board walls on 4x4 posts with a 2x6 cap (1 - 5 courses), a pyramid of one-course tiers 20 cm in (2 - 5), or the bed with a cold frame (2x3 gables + king posts, a 2x4 ridge, 2x2 sashes with clear vinyl under 1x2 battens on door hinges, 1 + 1 or 2 + 2 past 1.50 m) that opens on the toggle, swung slowly; the mode on the info bar's switch, L / W / courses on the handles; geotextile PFG00001 + soil SFF00004 billed; MATERIALS units for SFF00004 (m3, the planter's soil too), PFG00001 (m2), OEB00001 (m); on top of bench-v313-igsubs */
  /* previous: 'bench-v309-bartruss';   /* bench-v309 (Marek 21:45 + 21:46 on the cinema bar, type 19: mezi krajnimi sloupy po obou stranach profily, stul celistva pracovni deska; stejne profily tesne nad zemi jako opierka na nohy; uprostred a na krajich vzpery sikmo nahoru na desku; profily na bocnicich ve vysce desky odstranit): the counter's bearer pairs on the frames are gone; 2x8 rails on the posts' X faces front + back at the counter and the same 2x8 footrests on the sills, each through-bolted (2 M16 a post); 2x6 braces lapped on their inner faces, /\/\ a side (from the footrest at the posts and at the middle up to the slab at the quarter points), 1-2 M16 rods a lap, the heads cut level under the slab; the worktop one slab FOU00027 30 mm (US 1 1/4 in.) post face to post face, 25 cm past the front rail, 10 cm past the back one, bedded on construction adhesive FEC00031; on top of bench-v308-mfled */
  /* previous: 'bench-v308-mfled';   /* bench-v308 (Marek 21:49 on the modern swing: jeste jinou alternativu, opet se tremi frames, ale krajni budou mit chybejici jednu nohu (jedna levou, druha pravou); uprostred techto frames po cele delce z vnitrni strany drazky s listou a led svetly; vzpery ted budou hrat i roli statickou -- chose: the LED only on the 2 outer frames, the blocks on M16 rods): the third top 'LED' -- 3 portals, the front one without its +z post, the back one without its -z post; their beams held at the free end by the block over the middle post, every block on 2 M16 rods through the outer beam, the block and the middle beam (no block screws); a routed groove up the inner face of the outer posts and along their beams' underside with an LED profile (MISSING, not billed) and a 24 V strip EEC00006, a 24 V power supply EEC00007 on each outer post (2 x FAS45070); the info-bar switch Blocks > Fabric > LED */
  /* previous: 'bench-v307-armbrace';   /* bench-v307 (Marek 18:30 on the A-frame swing, variant 3, and the kids' set's bench: nejsem si jisty jak se fixuje sklon zadni casti, se sedaci casti ma jen spoj pres hranu -- mela by tak fungovat asi podrucka; chose: the armrest holds it, 15-50 deg): the flat 2x4 armrest now runs back to the back -- its inner part (over the seat) cut along the back's plank face, its outer 38 mm (over the arm posts) on alongside the back stile to the back's rear face, both cuts along the tilt -- and 2 x 4.5x70 stainless FAS45070 a side through it into the stile: seat frame, post, armrest and back make a triangle, the tilt is set when building; the mattress fits between the armrests; the seat's assembly 13 steps (the back and its hinges before the armrests) */
  /* previous: 'bench-v306-barframe';   /* bench-v306 (Marek 2026-10-20 21:15 on the cinema bar: platno dat na krajni profil aby mohlo byt spustene i nize, protoze barovy pult ma byt soucasti konstrukce; vzpery sikme u spodni casti vyssi, sirsi zakladnu; stat na dlazbe, 4 dlazdice 500 x 500 v sestave / BOQ): type 19 -- the sill 2.40 on 4 concrete tiles SFF00002 on gravel (no cast footings, no anchors), the kickers up to 1.2 m on the post from 0.90 out, the counter between the posts on the frames (a 2x8 bearer pair per frame clamping post + both kickers with M16 rods, 2x8 rails in joist hangers, 2x6 joists in joist hangers, 4 boards), the screen on the back eave beam's outer face with its image's bottom on a slider (0.40 m up), the projector at the counter's back edge */
  /* previous: 'bench-v305-kfends';   /* bench-v305 (Marek 18:30 on the kids' set, variant 4: vrchni nosny profil precniva zbytecne hodne pres kraje, konce okrasne tvarovane; vzpery na bokach seriznute podle vnejsi hrany noznych A profilu -- spodni delsi i vrchni): the 4x8 beam ends 10 cm (US 4 in.) past the legs' outer faces (was 26 cm), its underside an ogee up to 43 % of the depth at each tip; the collar and the spreader cut flush along the legs' outer edges (trapezoids, billed at the long edge; were boxes 3 cm past the bottom corner) */
  /* previous: 'bench-v302-mfweave5';   /* bench-v302 (Marek 2026-10-20 20:36: nevidim ten prepinac, kdy masivni vzpery budou nahrazene mensimi a mezi nimi budou pruhy latky; u teto druhe varianty misto 3 frames jich bude 5): the modern swing's weave on 5 portals (4 gaps, slats alternating pattern A / B, toe-screwed 2 x 6x100 FAS60100 an end -- the gaps close before a screw could go through a beam), its own assembly order; the blocks / fabric switch moves from the level button to its own info-bar toggle (snippet) */
  /* previous: 'bench-v301-modernswing';   /* bench-v301 (Marek 2026-10-20 20:02-20:10 with three ogrodowe_flow shots: zalozeni na vruty / betonove patky, ukotveni U, sedaci cast pro 2-3, tri paralelni konstrukce se vzperami mezi frames -- spalky ne v ose, ale kousek od sebe; prepnuti na vice mensich s provlecenou latkou cik cak; default seda): TYPE 18 the modern swing -- 3 portals of 6x6, ground screws + U heads / footings + U anchors on the info-bar toggle, staggered 6x6 blocks between the beams or (level button) 2x4 slats with a woven strip of shade cloth TST00003, the sofa seat on chain V's from the middle beam; colour scheme grey */
  /* previous: 'bench-v300-seatscrews';   /* bench-v300 (Marek 2026-10-20 18:13: dalsi krok, at to sedi): the bench-style porch seat (the A-frame swing T8, the kids' set's bench T13) draws all its screws -- frame 8x100, planks 5x60 from the top / the face, back frame 8x100, armrests 6x100 -- from one list the bill counts; the strap hinges carry FAT00022; the folding mattress one piece; the seat's assembly a step per group + a step per its screws (12) */
  /* previous: 'bench-v299-kidsframe';   /* bench-v299 (Marek 2026-10-20 17:46-17:48 with the nongdikpok render: klasickou houpacku bez strechy jako alternativu varianty 4 -- prepinani vice houpacek pro deti, nebo lavicky; nosnou konstrukci varianty 4 podle detailu obrazku, prijde mi lepsi; chose the beam clamped between the legs and the render's bench): the kids' swing set (type 13) on new A-frames -- 2x6 legs splayed 19 deg hugging the 4x8 beam, M16 rods through leg - beam - leg, a 2x6 collar inside and a 2x6 spreader outside each frame on rods, 2x4 knee braces from the beam's sides to the collar; the info-bar toggle = its swings (1-3) / the A-frame swing's bench (back tilt slider, mattress button) */
  /* previous: 'bench-v298-pergolamass';   /* bench-v298 (Marek 2026-10-20 17:28: varianta 5 swings defaultne bila; trosku sirsi, muze zvetsit i profily lavicky aby byla masivnejsi -- chose a longer seat + the frame and armrests 2x6): the pergola swing white on entering it; its seat 1.22 .. 2.44 m (US 4 .. 8 ft), default 2.00; the seat's frame, side posts and armrests 2x6 KVH60160 (corners 8x160, armrests 6x160), the posts' joints M16 rods with washers + cap nuts; the back panel stays 2x4 */
  /* previous: 'bench-v297-waveseams';   /* bench-v297 (Marek 2026-10-20 17:26: mensi spary na bocnicich, at to neni tak videt, spise naznak toho jak se bocnice tvori): the wave lounger's panel boards drawn with faint seam lines (22 % of the normal edge), the panel's outline crisp on both faces */
  /* previous: 'bench-v296-pergola';   /* bench-v296 (Marek 2026-10-20 16:17, the samodzielni.usiebie reel resent: dalsi swing ze seznamu -- houpacka s pergolou): TYPE 17 the pergola swing -- 4 posts 6x6 KVH16160 (for the reel's 13x13) 205 long in post bases FAT00017 on concrete footings, a head across each pair (170), 2 beams along on the heads (15 cm past the posts), 2x6 KVH60160 rafters on edge notched over the beams with the Hollywood scroll on the tails, a knee brace from every post into its head and its beam, the classic porch seat hung from the two rafters over its chains; the seat's length on the handle, the pergola follows (35 cm to a post); every screw / nail / anchor drawn and billed */
  /* previous: 'bench-v295-waveribs';   /* bench-v295 (Marek 2026-10-20 16:20: Wave lounger -- bocnice vic zapustene, ne az na kraji, treba 15 cm; jak jsou bocnice vyrobene; rozvest bocnice i v PDF): the side panels 15 cm (US 6 in.) in from the slat ends (12 % of a lounger under 1.25 m), each 2 layers of 1x4 -- upright inside, across outside -- glued, a finish nail FAS18032 at every other crossing, cut to the outline; every nail / slat screw / connector screw drawn and billed; assembly 0/8; the PDF gets 3 panel sheets (outline, upright boards, boards across with their lengths) */
  /* previous: 'bench-v294-softpulse';   /* bench-v294 (voice tour thread, as core-v724 -- Marek 2026-10-20: jen jemne zvyrazneni, nikde cerveny nadech): the tour's highlight one soft grey pulse, no red ring; bench-v293 (Marek 2026-10-20 15:11: lehatko i single, sirka 0,7, jedno pole): the sunbed's width from 0.70 m (US 28 in.); up to 1.00 m (US 40 in.) ONE bay -- no middle 2x4, middle batten / prop / rack, middle hinge bolt or middle leg, the slats on the side ledgers only; REF s4 a single */
  /* previous: 'bench-v292-sbflush';   /* bench-v292 (Marek 2026-10-20 14:31: druhy dragpoint u hlavove casti je zbytecny; vrchni plocha planks musi licovat s vrchni plochou ramu): the sunbed -- the slats' top flush with the frame's top (40 mm up, US 1 1/4 in.): the middle 2x4, the ledgers, the backrest, its legs, racks and props ride up with them (the middle 2x4 now hangs between the end boards); the backrest's drag point gone (the slider sets the angle) */
  /* previous: 'bench-v291-sbprops';   /* bench-v291 (Marek 2026-10-20 14:21: kloub / kotva spise ve vrchni casti, v profilu hlavove casti kde jsou ted zarezy; vzperu otocit k ramu u hlavy, ne ke stredu): the sunbed's props hang on M10 bolts through the backrest's battens (0.36 Lb from the hinge, the top end rounded), their feet towards the head in 6 mm notches of 2x4 racks laid flat low in the frame (by the sides from the head legs, by the middle 2x4), 3 x FAS80100 each; searched per size: the props stand 30-80 deg; the battens plain again */
  /* previous: 'bench-v290-sblegs';   /* bench-v290 (Marek 2026-10-20 13:19-13:21: glitching cerne prvky u vzpery -- co to je; uhel vzpery vyresit lepe, zkus to jinak; dodelat nohy ctvercoveho profilu z vnitrni strany ramu, ram par cm nad zemi, pocet noh podle zatizeni): the sunbed -- the dark notch marks (z-fighting with the batten's underside) replaced by notches really cut out of the battens (6 mm); the positions 0/30/45/60/75 (his pick) with the props' bolts and lengths searched per size: props 46-100 deg (were 30-102); legs 4x4 inside the frame, the frame 5 cm (US 2 in.) up: 4 corners + 2 sides + 1 by the middle 2x4 (adult), 4 (kids), FAS80100 into them; the stop blocks gone (the head legs carry the battens) */
  /* previous: 'bench-v289-sblocknut';   /* bench-v289 (Marek 2026-10-20 13:13: jak je myslena podpera hlavy, mame vse v boq? pokud chybi polozka, doplnit): the sunbed's six M10 bolts are pivots (3 hinges, 3 props) -- a plain nut works loose as they turn, so each gets a nylon-insert lock nut in place of the set's plain nut: no catalogue row, NOT BILLED, logged (status MISSING) */
  /* previous: 'bench-v288-sunbed';   /* bench-v288 (Marek 2026-10-20 11:35-11:41: dalsi prvek ze seznamu -- the double sunbed of the reel: ram profil na vysku 2x6, uprostred 2x4, latky zapustene, opera hlavy jedna pres celou sirku, sirka editovatelna, detska varianta): TYPE 16 -- a 2x6 box on the ground, a 2x4 under the middle, 2x2 ledgers, 1x4 slats across the width, the backrest hinged on M10 bolts, three props into notches at 0 / 15 / 30 / 45 / 60 deg (the slider + its drag point), the width on its drag point, the kids' size on the level button */
  /* previous: 'bench-v287-nobudgetbtn';   /* bench-v287 (Marek 2026-10-20 11:39: odstranit u techto konfiguratoru tlacitko budget v pravem banneru, mame ho dole v plovoucim): the snippet drops #cf-btn-budget (bench-liquid-v8); the tour outros light and point at the floating icons' budget button instead */
  /* previous: 'bench-v286-gbposts';   /* bench-v286 (Marek 2026-10-20 11:19: podrucky ne plne, vytahnout jen prubezne profily neprerusene sedakem; podrucka stejne siroky profil, pocket holes, koncove hrany licovat s celou lavici): type 15 armrests -- only the full-height boards rise over the seat (no fillers on the seat layers), the cap flush with the bench's front and back, each post pocket-screwed up into the cap from its inner face (FAS50060, 1 a post) */
  /* previous: 'bench-v285-gbarms';   /* bench-v285 (Marek 2026-10-20 09:15: u lavice z 2x4 varianta v banneru -- bocni strany vyssi, nahore jakoby podrucka, vysku tahnout v rozumnem rozmezi; defaultne barva svetleho dreva, birch moc svetla, i pro swings): type 15 armrests on the toggle + their height handle 0.15-0.30 over the seat; the default colour pine (light wood) for every type, pine first in the colour cycle */
  /* previous: 'bench-v284-2x4bench';   /* bench-v284 (Marek 2026-10-20 01:51: pokracuj dalsi variantou -- the first of the backlog, 00:09 with a reel: jednoducha, ciste lepena lavicka, user edituje jen delku): TYPE 15 the 2x4 bench -- 6 seat boards on edge, solid glued legs of 11 layers at the ends, glue + brads (brads NOT BILLED, no row), built layer by layer, 3 REF designs */
  /* previous: 'bench-v283-split';   /* bench-v283 (Marek 2026-10-20 00:21: oddelime houpacky a benches, je toho moc): one lib, two Shopify products -- SWINGS (/products/swings: porch, Hollywood, A-frame, kids) and BENCHES (the rest); a ?cfg design of a type the page does not sell opens on the product that sells it; productOfType() */
  /* previous: 'bench-v282-porchfill';   /* bench-v282 (Marek 2026-10-19 19:14: jak pridelame prkna a slats, ne vruty shora -- chose: vule 1 mm na koncich, natrit konce pred montazi, hrebicek do kazde filety): type 7 back fill 2 mm shorter than groove to groove, its end grain + the fillets' faces in the coating (the coating on the fill's step), one 18 ga brad a fillet (drawn, NOT BILLED: no catalogue row) */
  /* previous: 'bench-v281-porchframe';   /* bench-v281 (Marek 2026-10-19 18:42 with a photo: podrucku a bocni profil ramu operne casti jako na obrazku; ve spodnim banneru prepnuti planks / slats ve vyplni zad a nad tim posuvnik roztece, i pro sedak, hustsi): type 7 side frames of two upright posts + the armrest, the back panel inboard, fill toggle + gap slider */
  /* previous: 'bench-v280-igreel';   /* bench-v280 (voice tour thread, as core-v720 -- Marek 2026-10-19: ig prezentace ve vsech projektech do 60 vterin): the ?ig reel -- the hook over quick cuts of every type, the sofa's colours, the Hollywood's back down to a day bed, the assembly, the budget, the assistant, the outro; the hook opens every English tour; bench-v279 (Marek 2026-10-19: vruty zezadu do operky trci ven; vypln planks v operadle zapustit v drazkach profilu operadla; na sedak planks, ne battens): type 7 armrest screws horizontal, back slats in the rails' grooves with fillets, 1x4 seat planks */
  /* previous: 'bench-v278-porchclassic';   /* bench-v278 (Marek 2026-10-19: udelej variantu 2 v tomto provedeni -- his photo of a classic porch swing; ne jako klon sofa): type 7 = the classic porch swing */
  /* was bench-v277 (Marek 2026-10-16 16:08: zkratit prazdne pauzy -- u 4 nekolikrat tvar z upright na bed a voice over davno zmizel; assembly houpacky rychlejsi; 10 cerne izolacni vrstvy z vnitrku, krizovanim, zustat vevnitr): the show hurries once its voice has ended, the tour's assembly faster, the planter liner flies in from inside */
  /* was bench-v276 (Marek 2026-10-16 15:14: nove hlasove klipy po pridani postele; s ?ig post pro socialni site, pruvodce tomu prizpusobit; jen EN): the bed in the voice tour, a bed-only tour on an English ?ig page with the bed on, 3 bed reference designs */
  /* was bench-v275 (Marek 2026-10-16 09:51: zadni zada postele ve dvou dalsich variantach stejnym tlacitkem -- svisle slats, a chaoticky sikmo pres sebe planks, jeden row jednim smerem (ne rovnobezne), druhe rows opacnym; tenke profily v hranach hlavniho profilu; kolikove spoje, slats na ose hlavniho profilu): the headboard toggle cycles rails / slats / crossed boards / off */
  /* was bench-v274 (Marek 2026-10-16: celo i vyssi s vice profily pri tazeni do vysky; drag point sirky v prednim rohu v nohach na matraci): the headboard to 2.00 m, a middle rail more each time an opening passes 30 cm; the width dot on the mattress's foot corner */
  /* was bench-v273 (Marek: 14. varianta postel -- konstrukce a spoje jako sofa, masivni ctvercovy profil, celo on / off, vyska cela, sirka po beznych sirkach matraci, pevny lamelovy rost v ramu, bila matrace): type 14, the bed */

  /* ----------------------------------------------------------
     STATE  (metric internally; UI formats to imperial if needed)
     ---------------------------------------------------------- */
  var STATE = {
    /* Bench geometry: L = seat length along Z, W = seat depth along X,
       H = total height (incl. backrest) along Y. Defaults match the
       2x4 Modern Easy Plans bench (66" x 27.5" x ~48" overall). */
    L: 1.524,        /* seat length (m) — 5 ft, comfortable 2-seater */
    W: 0.699,        /* seat depth  (m), along X */
    H: 0.880,        /* total height incl. backrest (m), along Y */
    variant: 1,      /* 1..5 — top variant switcher (Park / Picnic / Heavy / Gabion / Block) */
    backrestVisible: true, /* Park Bench: with backrest (true) vs without (false) */
    backH: 0.2438,   /* top rail height above seat (m) — 0.8 ft default — DRAGGABLE via H handle */
    lvl:     1,      /* 1 = adult (default), 2 = children (smaller profiles + lower seat) */
    backRakeDeg: 10, /* backrest tilt (deg from vertical, dragging back) — 0..20 */
    view: '3d',      /* '3d' | '2d' — cycled by cf-btn-view */
    vizStage: 1,     /* Visualisation stage within current view, cycled by cf-btn-viz.
                        3D stages (3 total):
                          • 1 = classic full build + asset picking (default)
                          • 2 = inspection (structure 30 %, fasteners 100 %)
                          • 3 = profiles (color-coded lumber categories)
                        2D stages (3 total):
                          • 1 = top-down plan
                          • 2 = side elevation (bokorys)
                          • 3 = front elevation (nárys)
                        Switching view always resets vizStage to 1. */
    isMetric: true,
    assemblyStep: 0, /* 0=composed, 1=exploded, 2=empty, 3=frame, 4=+decking, 5=+posts, 6=+rails, 7=+rafters, 8=+battens, 9=composed */
    bodyVisible: false, /* scale-reference person (175 cm) — off by default */
    cutOffset: null,    /* section-cut plane position: absolute world coord on the cut axis; null = centre */
    mfFound: 'screw',     /* v301 the modern swing: 'screw' (ground screws) | 'concrete' (footings) */
    mfWeave: false,       /* v301 the modern swing: blocks (false) | the slats with the woven shade cloth (true) */
    mfCant: false,        /* v308 its third top (blocks only): the outer portals one post short, the blocks on rods, LED grooves */
    rtbMode: 'bench',     /* v414 the twist bench: bench | chairs | table */
    colorMode: 'pine',    /* v285 (was birch) a COLOR_SCHEMES key -- cf-btn-colors cycles them (independent of vizStage) */
    slats: 0,           /* sofa vertical slats cycle index 0..14 (0 = none); variant 2 only */
    slatGap: 0.038,     /* sofa: clear gap between slats (m); variant 2 only */
    bodyX: null,        /* world X (null → default seatDepth/2 + 0.40) */
    bodyZ: null,        /* world Z (null → default 0) */
    opacity2D: 0.45,    /* fill opacity in 2D views — adjustable via slider, range 0..0.80 */
    swingBack: 30,      /* Hollywood swing: backrest tilt, deg from vertical (15 upright .. 90 bed) */
    swingRoof: 'gable', /* Hollywood swing roof: 'none' | 'gable' | 'mono' */
    swingPitch: 25,     /* Hollywood swing roof pitch, deg */
    swingCushion: null, /* Hollywood swing mattress (FOU00016): null = AUTO (on in the Bed band), true / false = the user's choice */
    porchH: 2.44,       /* porch swing (type 7): the beam underside above the floor, m */
    adiBack: 25         /* Adirondack (type 9): back slats from vertical, deg (15..35) */
  };
  /* Expose STATE on window for shared modules that might read it.
     The PDF exporter's generic flow (triggered by passing
     {title, rows}) doesn't actually need STATE — but other shared
     modules might. Cheap to expose. */
  global.STATE = STATE;
  var DEFAULTS = { L: 1.524, W: 0.699, H: 0.880, variant: 1, lvl: 1, backRakeDeg: 10, backrestVisible: true, backH: 0.2438 };
  /* Length is user-draggable (along Z). Width (seat depth) and height
     are derived from the variant's geometry — kept in STATE for engine
     compatibility (dimensions, person scaling, BoQ totals). Drag of W
     and H is suppressed at the handle level. */
  /* Length is the only draggable dimension on the Park Bench. L is the
     OVERALL outside length of the bench (post-to-post, outer faces).
       min 3 ft = 0.914 m → compact 1-person seat
       max 6 ft = 1.829 m → comfortable 3-person bench
     W (depth) and H (height) are not user-adjustable for this variant. */
  var RANGES = {
    L:           { min: 0.762,  max: 1.8288 },  /* 2.5–6 ft */
    W:           { min: 0.368,  max: 1.391  },  /* 4–15 deck planks */
    H:           { min: 0.450,  max: 1.200  },
    backH:       { min: 0.18288, max: 0.55 },  /* top rail height above seat (0.6–1.8 ft) */
    backRakeDeg: { min: 0,      max: 20     }
  };

  /* ── SOFA (variant 2) — Woodbrew "Outdoor Lounge Sofa" derivative.
     Massive 6×6 (KVH16160) frame: 4 corner posts + perimeter top rails
     (arms + back) + lower seat-box rails. Length grows in 0.80 m cushion
     modules: 1 module = compact, 4 modules = 3.20 m. Default 2 modules.
     Seat-support joists (2×4) and cushions come in a later increment. */
  var SOFA = {
    POST:      0.100,   /* 4×4 post + rail cross-section (KVH10100) — the
                           Woodbrew plans use 4×4 framing; 6×6 looked far
                           too massive for furniture. */
    CUSHION:   0.80,    /* one cushion module length */
    MODULES_DEFAULT: 2,
    MODULES_MIN: 1,
    MODULES_MAX: 4,
    DEPTH:     0.699,   /* front-to-back (27½") */
    ARM_TOP:   0.559,   /* top of arms / overall height (22") */
    SEAT_TOP:  0.330,   /* top of seat-box lower rail (cushion sits on joists above) */
    POST_CODE: 'KVH10100',
    RAIL_CODE: 'KVH10100',
    seatJoistCode: 'KVH10060'  /* 2×4 seat support — used in the later increment */
  };
  /* Sofa overall outside length = modules × cushion + the two end posts.
     min/max as world metres, used for the L drag range when variant 2. */
  SOFA.L_MIN = SOFA.MODULES_MIN * SOFA.CUSHION + SOFA.POST * 2;
  SOFA.L_MAX = SOFA.MODULES_MAX * SOFA.CUSHION + SOFA.POST * 2;
  SOFA.L_DEFAULT = SOFA.MODULES_DEFAULT * SOFA.CUSHION + SOFA.POST * 2;
  /* Top-frame height is user-draggable on the sofa via the H handle
     (edits STATE.H directly — unlike Park Bench where H = backrest height).
     STATE.H is the ABSOLUTE top-frame height; the editable quantity the
     user sees is the height ABOVE the seat (0.6–1.0 ft), default 0.8 ft. */
  SOFA.ABOVE_MIN = 0.18288;   /* 0.6 ft above seat */
  SOFA.ABOVE_MAX = 0.30480;   /* 1.0 ft above seat */
  SOFA.ABOVE_DEF = 0.24384;   /* 0.8 ft above seat (default) */
  SOFA.H_MIN = SOFA.SEAT_TOP + SOFA.ABOVE_MIN;
  SOFA.H_MAX = SOFA.SEAT_TOP + SOFA.ABOVE_MAX;
  /* Default top-frame height = seat + 0.8 ft above it. */
  SOFA.ARM_TOP = SOFA.SEAT_TOP + SOFA.ABOVE_DEF;
  /* Level-2 (two-row backrest) telescoping height. The H handle drives the
     TOP rail height (STATE.H). The MIDDLE rail follows at half that gap,
     clamped to 0.6–1.0 ft above the seat. So as you drag:
       • both rows rise together until the middle hits its 1.0 ft cap, then
       • only the top keeps rising, up to ~2.2 m total.            */
  SOFA.H_MIN_L2 = SOFA.SEAT_TOP + 2 * SOFA.ABOVE_MIN;   /* both at 0.6 ft */
  SOFA.H_MAX_L2 = 2.20;                                  /* top up to ~2.2 m */
  SOFA.H_DEF_L1 = SOFA.SEAT_TOP + SOFA.ABOVE_DEF;        /* single frame, 0.8 ft */
  SOFA.H_DEF_L2 = SOFA.SEAT_TOP + 2 * SOFA.ABOVE_DEF;    /* top at 1.6 ft, mid 0.8 ft */

  /* Vertical decorative/shading SLATS on the sofa frame's outer faces.
     The Slats button cycles: none → 7 side-configs with the 38mm batten →
     the same 7 with the 30mm batten → none. Side configs (1..7):
       1 back, 2 left, 3 right, 4 both sides, 5 back+left, 6 back+right,
       7 all. Slats run from 15 cm above ground up to the top rails. */
  SOFA.SLAT_PROFILES = ['KVH03838', 'KVH03030'];  /* strong first, then slim */
  SOFA.SLAT_GROUND   = 0.15;     /* bottom of slats above ground (m) */
  SOFA.SLAT_SIDE_LABELS = ['none', 'back', 'left', 'right', 'both-sides',
                           'back+left', 'back+right', 'all-3',
                           'top', 'top+back', 'top+left', 'top+right',
                           'top+sides', 'top+back+left', 'top+back+right', 'all-4'];
  /* bit flags for which faces carry slats. TOP slats are only reachable on tall
     (> 6 ft) lvl-2 assemblies, where a top FRONT long rail exists to fix to. */
  SOFA.SLAT_BACK = 1, SOFA.SLAT_LEFT = 2, SOFA.SLAT_RIGHT = 4, SOFA.SLAT_TOP = 8;
  SOFA.SLAT_SIDE_BITS = [
    0,                                              /* 0 none */
    SOFA.SLAT_BACK,                                 /* 1 back */
    SOFA.SLAT_LEFT,                                 /* 2 left */
    SOFA.SLAT_RIGHT,                                /* 3 right */
    SOFA.SLAT_LEFT | SOFA.SLAT_RIGHT,               /* 4 both sides */
    SOFA.SLAT_BACK | SOFA.SLAT_LEFT,                /* 5 back+left */
    SOFA.SLAT_BACK | SOFA.SLAT_RIGHT,               /* 6 back+right */
    SOFA.SLAT_BACK | SOFA.SLAT_LEFT | SOFA.SLAT_RIGHT, /* 7 all 3 */
    /* 8..15 — front combinations (tall assemblies only) */
    SOFA.SLAT_TOP,                                                  /* 8  top */
    SOFA.SLAT_TOP | SOFA.SLAT_BACK,                                 /* 9  top+back */
    SOFA.SLAT_TOP | SOFA.SLAT_LEFT,                                 /* 10 top+left */
    SOFA.SLAT_TOP | SOFA.SLAT_RIGHT,                                /* 11 top+right */
    SOFA.SLAT_TOP | SOFA.SLAT_LEFT | SOFA.SLAT_RIGHT,               /* 12 top+sides */
    SOFA.SLAT_TOP | SOFA.SLAT_BACK | SOFA.SLAT_LEFT,                /* 13 top+back+left */
    SOFA.SLAT_TOP | SOFA.SLAT_BACK | SOFA.SLAT_RIGHT,               /* 14 top+back+right */
    SOFA.SLAT_TOP | SOFA.SLAT_BACK | SOFA.SLAT_LEFT | SOFA.SLAT_RIGHT /* 15 all 4 */
  ];
  /* How many side configs are reachable: 7 normally, 15 when a top FRONT
     rail exists (tall lvl-2). */
  SOFA.slatSideCount = function (tall) { return tall ? 15 : 7; };
  SOFA.slatCycleMax  = function (tall) { return 2 * SOFA.slatSideCount(tall); };  /* 14 or 30 */
  /* Decode a cycle index → { profile, bits } (0 = none). `tall` enables the
     front face + its combinations. */
  SOFA.slatState = function (idx, tall) {
    idx = idx | 0;
    if (idx <= 0) return { profile: null, bits: 0 };
    var N = SOFA.slatSideCount(tall);
    var profIdx = (idx <= N) ? 0 : 1;       /* first N strong, next N slim */
    var sideIdx = (idx <= N) ? idx : (idx - N);
    return { profile: SOFA.SLAT_PROFILES[profIdx], bits: SOFA.SLAT_SIDE_BITS[sideIdx] };
  };
  SOFA.SLAT_CYCLE_MAX = 14;   /* default (non-tall); use slatCycleMax(tall) when height is known */
  /* Tall lvl-2 assembly: has the top FRONT long rail (height > 6 ft), so the
     front face can carry slats. Drives the extended slat cycle. */
  SOFA.isTall = function (s) {
    s = s || {};
    return ((s.variant | 0) === 2) && (s.lvl === 2) && ((s.H || SOFA.ARM_TOP) > 1.8288);
  };
  /* Gap (clear space) between adjacent slats, in metres — adjustable on the
     sofa via the repurposed tilt slider. */
  SOFA.GAP_MIN = 0.010;   /* 10 mm */
  SOFA.GAP_MAX = 0.120;   /* 120 mm */
  SOFA.GAP_DEF = 0.038;   /* 38 mm (≈ one batten width) */
  /* Inner LEDGER battens on the long lower rails (front + back) that carry
     the mattress base ("rošt"). Positioned so the rošt's 2×4 top sits about
     1 inch below the top face of the lower rails (recess holds the mattress).
     ROST_THICK = the 2×4 board thickness laid flat (nominal 38 mm). */
  SOFA.LEDGER_CODE     = 'KVH03838';   /* 38×38 batten */
  SOFA.LEDGER_W        = 0.038;
  SOFA.ROST_THICK      = 0.038;        /* 2×4 thickness laid flat */
  SOFA.ROST_CLEARANCE  = 0.0254;       /* 1 inch: rošt top below rail top */
  /* Rošt (mattress base): 2×4 boards laid flat, running front-to-back
     (across X), resting on the ledgers, spread along the length (Z) with a
     ~2 inch gap. Not fastened (no fixings in BoQ). Count adapts to length. */
  SOFA.ROST_CODE  = 'KVH10060';        /* 2×4 */
  SOFA.ROST_WIDTH = 0.089;             /* board flat width along Z (nominal 2×4) */
  SOFA.ROST_GAP   = 0.0508;            /* ~2 inch gap between boards */
  /* Mattress (seat cushion) — 8 cm thick, sandy-beige fabric, laid on the
     rošt in the recess. Splits along the length: one cushion up to 159 cm,
     then one more per additional 80 cm (160 → 2, 240 → 3 …). A small gap
     keeps split cushions visually apart. */
  SOFA.MAT_THICK   = 0.08;             /* mattress thickness (m) */
  SOFA.MAT_SPLIT   = 0.80;             /* split unit (m): 1 up to 159, 2 at 160 */
  SOFA.MAT_GAP     = 0.032;            /* gap between split cushions (m) */
  SOFA.MAT_INSET   = 0.006;            /* clearance from the frame inner faces */
  /* Joinery: corner joints are made with large wooden dowels + glue (no
     metal). A self-centering dowel jig drills 3 holes per joint face.
     Dowels are 12 mm (≈ 1/2") for the massive 4×4 frame; 3 per corner. */
  SOFA.DOWEL_DIA   = 0.012;            /* 12 mm ≈ 1/2" */
  SOFA.DOWEL_LEN   = 0.080;            /* 80 mm embedment per member */
  /* Rošt 2×4 boards are LOOSE-LAID on the ledgers — no fasteners. */
  SOFA.LEDGER_SCREW_CODE = 'FAS50060'; /* 5×60 wood screw — ledger 38×38 into long rail (~1/30 cm) */
  SOFA.SLAT_SCREW_CODE   = 'FAS50060'; /* 5×60 wood screw — slat into rail (at each rail crossing) */
  SOFA.DOWEL_PER_JOINT = 3;            /* 3 dowels per corner joint */
  /* Throw pillows against the back: one per 60 cm of length, oblong
     60 × 40 cm, ~15 cm thick, two alternating colours. */
  SOFA.PILLOW_W   = 0.55;   /* width along the length (Z) -- v263: the sewn, stuffed pillow (no GLB) */
  SOFA.PILLOW_H   = 0.50;   /* height (Y) */
  SOFA.PILLOW_T   = 0.19;   /* thickness at the middle (X) */
  SOFA.PILLOW_PER = 0.85;   /* one pillow per 85 cm */
  SOFA.PILLOW_SCALE = 1.1;  /* uniform scale applied to the GLB pillow model */

  /* ── WAVE BENCH (variant 3) — long chaise-arc "wave lounger".
     Long chaise-arc side ribs (Wangen) carry spruce slats that follow an
     undulating body-contour profile. The arc lands on the ground at both
     ends (the ends ARE the legs). The rib is a slender band that follows the
     wave, solid where it meets the ground. Ten shape presets are cycled from
     the info-bar toggle so the closest silhouette to the reference can be
     chosen. Width (Z) grows 1..4 up to 2.5 m; ribs are added along it.
     Ribs + slats are 1" planed boards (TIM20100); connectors are 2×4. */
  /* v258: the four rows added to the central catalogue (2026-10-14) */
  var CAT_NEW = { GLUE: 'FEC00043', STRAP_HINGE: 'FAT00022', LID_STAY: 'FAT00023', SOIL: 'SFF00004', GLUE_L_M2: 0.2 };
  var WAVE = {
    DEPTH:       1.90,     /* lounger length (X) — pool sun-lounger */
    L_MIN:       0.65,     /* width (Z): 1 module */
    L_MAX:       2.50,     /* width (Z): up to 4 modules */
    L_DEFAULT:   1.30,
    SEAT_LEN:    0.60,
    PRESETS:     5,        /* recline variants — headrest low→high */
    WANGE_COUNT: 3,        /* legacy — rib count is now length-driven */
    LAYERS:      4,        /* 4 cross-glued board layers per rib */
    BOARD_T:     0.020,    /* 1" board thickness → TIM20100 */
    BOARD_W:     0.100,    /* board width (100 mm) → TIM20100 */
    WANGE_T:     0.080,    /* laminated rib thickness along Z (= LAYERS × 20) */
    BAND_V:      0.120,    /* rib band vertical depth (slender lounger rail) */
    LEG_TX:      0.080,    /* vertical leg horizontal width at each end */
    SLAT_T:      0.020,    /* spruce slat thickness (off the contour) */
    SLAT_W:      0.070,    /* slat width along the contour tangent */
    SLAT_ANGLE_MAX: 1.48,  /* ≈85° — slats cover the seat AND the steep backrest */
    GAP_MIN:     0.006,    /* slat spacing (roztec) min (6 mm) */
    GAP_MAX:     0.060,    /* slat spacing max (60 mm) */
    GAP_DEF:     0.014,    /* default slat gap (14 mm) */
    /* v263 (Marek: the profile like the Hollywood seat, the ends straight
       down to the base, Upright -> Bed, the bed at bed height, a mattress
       last): the rib's top = the Hollywood seat line for a back tilt;
       the five postures are stops on it (the toggle), the line morphs
       between them; the hips at HIP_Y, the mattress MAT_T thick */
    STOPS:       [15, 28, 44, 62, 90],
    BACK_DEF:    44,       /* v264: the posture is a SLIDER 15 (upright) .. 90 (bed), as the Hollywood's */
    GAPS:        [0.008, 0.014, 0.020, 0.030, 0.045],   /* v264: the slat spacing on the info-bar toggle */
    R_TOE:       0.25,     /* v264: the front runs down in an arc to the ground, plumb at the end (3 o'clock, clockwise) */
    R_HEAD:      0.20,     /* v264: the head rolls back to level (12 o'clock, counter-clockwise);
                              v267 (Marek: the end arc behind the head is not tangent, make it
                              bigger): 0.12 -> 0.20, and the same arc runs on, bare, to 9 o'clock,
                              tangent into the rib's plumb back edge (no corner) */
    HIP_Y:       0.38,     /* v264: the bed's slats at ~0.40 (Marek: lying surface ~40 cm) */
    BED_FROM:    75,       /* v271: the slider's Bed band (SWING_BACK_BANDS[3]): only there the slats run down the back edge to the ground */
    MAT_T:       0.10,
    SLAT_MAX:    1.62,     /* the slats run up the back to ~93 deg */
    CONNECT_T:   0.038,    /* cross-connector 2×4 thickness (Y) */
    CONNECT_W:   0.089,    /* cross-connector 2×4 width (X) */
    /* BoQ codes — all from the central sheet (no invented codes). */
    WANGE_CODE:   'TIM20100',
    SLAT_CODE:    'TIM20100',
    CONNECT_CODE: 'KVH10060',
    SLAT_SCREW:   'FAS50060',   /* 5×60 — slat into rib */
    STRUCT_SCREW: 'FAS80100',   /* 8x100 - connectors into ribs */
    /* v295 (Marek 2026-10-20 16:20: bocnice vic zapustene, ne az na kraji,
       treba 15 cm; jak jsou bocnice vyrobene -- chose 2 vrstvy 1x4 krizem):
       the outer panels' outer faces INSET from the slat ends; a panel = an
       inner layer of 1x4 upright side by side + an outer layer of 1x4
       across, glued face to face, a finish nail at every other crossing,
       the outline cut after the glue has set */
    INSET: 0.15, INSET_US: 0.1524, INSET_K: 0.12,   /* under 1.25 m wide 12 % of the width (it stands steady) */
    RIB_SPAN: 0.90,             /* the panels at most this far apart (centres) */
    BOARD_T_US: 0.01905, BOARD_W_US: 0.0889,        /* 1x4 actual */
    STOCK_OVER: 0.020,          /* a board laid 20 mm over its finished length, cut to the outline after */
    NAIL: 'FAS18032', NAIL_LEN: 0.032, NAIL_LEN_US: 0.03175, NAIL_EDGE: 0.05,   /* 1.8 x 32 stainless finish nail: 20 through + 12 in; kept 50 mm from the outline (the slat screws) */
    SLAT_SCREW_LEN: 0.060, SLAT_SCREW_LEN_US: 0.0635,
    CONN_IN: 0.05,              /* the foot connectors 50 mm in from the panel's end (clear of the slat screws) */
    SEAM_K: 0.22                /* v297 the boards' seams at 22 % of the normal edge line (a hint) */
  };
  /* v295 the panel boards: 1x4, metric / US actual */
  function _waveProf(s) {
    if ((s || STATE).isMetric === false) return { bt: WAVE.BOARD_T_US, bw: WAVE.BOARD_W_US };
    return { bt: WAVE.BOARD_T, bw: WAVE.BOARD_W };
  }
  /* v295 THE PANEL'S BOARDS: the region under the contour (dense, x rising,
     plumb at both ends) laid with upright boards side by side (the inner
     layer) and boards across stacked from the ground (the outer layer),
     each cut to the outline; the crossings for the nails. Every piece as a
     polygon [[x,y],...] in the panel's plane. */
  function _waveRibBoards(dense, bt, bw) {
    var X = [], Y = [], i, k;
    for (i = 0; i < dense.length; i++) {
      var px = dense[i].x, py = dense[i].y, n = X.length;
      if (n && px <= X[n - 1] + 1e-7) { if (py > Y[n - 1]) Y[n - 1] = py; }   /* plumb runs: their top */
      else { X.push(px); Y.push(py); }
    }
    var nE = X.length, x0 = X[0], x1 = X[nE - 1], yMax = 0;
    for (i = 0; i < nE; i++) if (Y[i] > yMax) yMax = Y[i];
    function Yat(x) {
      if (x <= x0) return Y[0];
      if (x >= x1) return Y[nE - 1];
      var a = 0, b = nE - 1;
      while (b - a > 1) { var m = (a + b) >> 1; if (X[m] <= x) a = m; else b = m; }
      var f = (x - X[a]) / ((X[b] - X[a]) || 1);
      return Y[a] + (Y[b] - Y[a]) * f;
    }
    function r4(v) { return Math.round(v * 10000) / 10000; }
    /* the inner layer: upright boards from the back end, the last one ripped */
    var vert = [], nV = Math.ceil((x1 - x0) / bw - 1e-6);
    for (i = 0; i < nV; i++) {
      var xa = x0 + i * bw, xb = Math.min(x1, xa + bw), poly = [[xa, 0], [xb, 0], [xb, Yat(xb)]], top = Math.max(Yat(xa), Yat(xb));
      for (k = nE - 1; k >= 0; k--) if (X[k] > xa + 1e-6 && X[k] < xb - 1e-6) { poly.push([X[k], Y[k]]); if (Y[k] > top) top = Y[k]; }
      poly.push([xa, Yat(xa)]);
      vert.push({ n: i + 1, xa: xa, xb: xb, w: xb - xa, len: top, stock: r4(top + WAVE.STOCK_OVER), poly: poly });
    }
    /* the outer layer: boards across from the ground up, the top one
       ripped; a row the contour dips into is cut in two (or more) pieces */
    var hor = [], nH = Math.ceil(yMax / bw - 1e-6), j, cnt = 0;
    for (j = 0; j < nH; j++) {
      var ya = j * bw, yb = Math.min(yMax, ya + bw), runs = [], inRun = (Y[0] > ya + 1e-6), xl = x0;
      for (k = 1; k < nE; k++) {
        var fa = Y[k - 1] - ya, fb = Y[k] - ya;
        if (inRun && fb <= 1e-6) { runs.push([xl, X[k - 1] + (X[k] - X[k - 1]) * fa / ((fa - fb) || 1)]); inRun = false; }
        else if (!inRun && fb > 1e-6) { xl = (fa < -1e-9) ? X[k - 1] + (X[k] - X[k - 1]) * (-fa) / ((fb - fa) || 1) : X[k - 1]; inRun = true; }
      }
      if (inRun) runs.push([xl, x1]);
      for (var r = 0; r < runs.length; r++) {
        var rl = runs[r][0], rr = runs[r][1];
        if (rr - rl < 0.03) continue;
        /* the top: min(contour, yb) at the run's ends, every contour vertex
           in it and every crossing of yb */
        var xs = [rl, rr];
        for (k = 0; k < nE; k++) if (X[k] > rl && X[k] < rr) xs.push(X[k]);
        for (k = 1; k < nE; k++) { var ga = Y[k - 1] - yb, gb = Y[k] - yb; if ((ga < 0) !== (gb < 0) && Math.abs(gb - ga) > 1e-12) { var xc = X[k - 1] + (X[k] - X[k - 1]) * (-ga) / (gb - ga); if (xc > rl && xc < rr) xs.push(xc); } }
        xs.sort(function (p, q) { return p - q; });
        var tp = [], hiTop = ya;
        for (k = 0; k < xs.length; k++) { var ty = Math.min(Yat(xs[k]), yb); if (ty > hiTop) hiTop = ty; tp.push([xs[k], Math.max(ya, ty)]); }
        if (hiTop - ya < 0.005) continue;
        /* drop the inner points of a flat run along yb */
        var tq = [];
        for (k = 0; k < tp.length; k++) {
          var flatPrev = k > 0 && Math.abs(tp[k - 1][1] - yb) < 1e-7, flatNext = k < tp.length - 1 && Math.abs(tp[k + 1][1] - yb) < 1e-7;
          if (Math.abs(tp[k][1] - yb) < 1e-7 && flatPrev && flatNext) continue;
          tq.push(tp[k]);
        }
        var hp = [[rl, ya], [rr, ya]];
        for (k = tq.length - 1; k >= 0; k--) { var lastP = hp[hp.length - 1]; if (Math.abs(lastP[0] - tq[k][0]) > 1e-7 || Math.abs(lastP[1] - tq[k][1]) > 1e-7) hp.push(tq[k]); }
        if (Math.abs(hp[hp.length - 1][0] - rl) < 1e-7 && Math.abs(hp[hp.length - 1][1] - ya) < 1e-7) hp.pop();
        cnt++;
        hor.push({ n: cnt, row: j + 1, ya: ya, yb: yb, xl: rl, xr: rr, len: rr - rl, stock: r4(rr - rl + WAVE.STOCK_OVER), poly: hp });
      }
    }
    /* the nails: every other crossing (a chequer), the crossing's centre
       NAIL_EDGE clear of the outline */
    function edgeDist(px, py) {
      var d = py, q;                                                       /* the ground */
      for (q = 1; q < dense.length; q++) {
        var ax = dense[q - 1].x, ay = dense[q - 1].y, ex = dense[q].x - ax, ey = dense[q].y - ay, l2 = ex * ex + ey * ey;
        var t = l2 > 0 ? Math.max(0, Math.min(1, ((px - ax) * ex + (py - ay) * ey) / l2)) : 0;
        var dx = px - ax - t * ex, dy = py - ay - t * ey, dd = Math.sqrt(dx * dx + dy * dy);
        if (dd < d) d = dd;
      }
      return d;
    }
    var nails = [];
    for (i = 0; i < vert.length; i++) for (j = 0; j < nH; j++) {
      if ((i + j) % 2) continue;
      var cx = (vert[i].xa + vert[i].xb) / 2, cy = j * bw + Math.min(bw, yMax - j * bw) / 2;
      if (vert[i].w < 0.03 || cy >= Yat(cx)) continue;
      if (edgeDist(cx, cy) < WAVE.NAIL_EDGE) continue;
      nails.push({ x: cx, y: cy });
    }
    var stockM = 0;
    for (i = 0; i < vert.length; i++) stockM += vert[i].stock;
    for (i = 0; i < hor.length; i++) stockM += hor[i].stock;
    return { vert: vert, hor: hor, nails: nails, stockM: stockM, x0: x0, x1: x1, yMax: yMax, nRows: nH, Yat: Yat };
  }
  /* Lounger side profiles traced from Marek's own SmartDraw drawing: a high
     back (headrest) on the left, a smooth S-descent through the body to a low
     foot on the right, sitting on a flat base — a solid side cheek (Wange) on
     the ground, matching the reference DIY build. Scaled to 1.90 m length /
     ~0.90 m back per the drawing's dimensions. Variants 1→5 raise the back
     (more reclined → more upright). x centred (±DEPTH/2), y = height. */
  var WAVE_PROFILES = {
    1: [[-0.950, 0.779], [-0.777, 0.762], [-0.605, 0.764], [-0.432, 0.730], [-0.259, 0.634], [-0.086, 0.493], [0.086, 0.409], [0.259, 0.354], [0.432, 0.307], [0.605, 0.281], [0.777, 0.273], [0.950, 0.276]],
    2: [[-0.950, 0.834], [-0.777, 0.815], [-0.605, 0.817], [-0.432, 0.778], [-0.259, 0.671], [-0.086, 0.512], [0.086, 0.417], [0.259, 0.354], [0.432, 0.307], [0.605, 0.281], [0.777, 0.273], [0.950, 0.276]],
    3: [[-0.950, 0.889], [-0.777, 0.868], [-0.605, 0.870], [-0.432, 0.827], [-0.259, 0.708], [-0.086, 0.531], [0.086, 0.426], [0.259, 0.354], [0.432, 0.307], [0.605, 0.281], [0.777, 0.273], [0.950, 0.276]],
    4: [[-0.950, 0.944], [-0.777, 0.921], [-0.605, 0.923], [-0.432, 0.876], [-0.259, 0.745], [-0.086, 0.550], [0.086, 0.435], [0.259, 0.354], [0.432, 0.307], [0.605, 0.281], [0.777, 0.273], [0.950, 0.276]],
    5: [[-0.950, 0.999], [-0.777, 0.974], [-0.605, 0.976], [-0.432, 0.924], [-0.259, 0.782], [-0.086, 0.569], [0.086, 0.443], [0.259, 0.354], [0.432, 0.307], [0.605, 0.281], [0.777, 0.273], [0.950, 0.276]]
  };
  /* Clamp the shape index to the available presets. */
  function _waveLvl(s) {
    var l = ((s || STATE).lvl | 0) || 1;
    if (l < 1) l = 1; if (l > WAVE.PRESETS) l = WAVE.PRESETS;
    return l;
  }
  /* Contour control points (metres) for a back-angle preset — read straight
     from the DXF-derived profile table. x already centred (±DEPTH/2), y is
     height above the ground. */
  function _waveContour(idx) {
    idx = idx | 0; if (idx < 1) idx = 1; if (idx > WAVE.PRESETS) idx = WAVE.PRESETS;
    var raw = WAVE_PROFILES[idx] || WAVE_PROFILES[1], out = [], i;
    for (i = 0; i < raw.length; i++) out.push({ x: raw[i][0], y: raw[i][1] });
    return out;
  }
  /* Catmull-Rom point between p1..p2 (t∈0..1) with neighbours p0,p3. */
  function _waveCR(p0, p1, p2, p3, t) {
    var t2 = t * t, t3 = t2 * t;
    return {
      x: 0.5 * ((2 * p1.x) + (-p0.x + p2.x) * t +
           (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 +
           (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3),
      y: 0.5 * ((2 * p1.y) + (-p0.y + p2.y) * t +
           (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 +
           (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3)
    };
  }
  /* Dense smooth polyline through the contour control points. */
  function _waveSamples(pts, perSeg) {
    perSeg = perSeg || 24;
    var out = [], n = pts.length, i, j;
    for (i = 0; i < n - 1; i++) {
      var p0 = pts[i - 1] || pts[i];
      var p1 = pts[i];
      var p2 = pts[i + 1];
      var p3 = pts[i + 2] || pts[i + 1];
      for (j = 0; j < perSeg; j++) out.push(_waveCR(p0, p1, p2, p3, j / perSeg));
    }
    out.push(pts[n - 1]);
    return out;
  }
  /* Cumulative arc length of a dense polyline → { cum:[], total }. */
  function _waveArc(dense) {
    var cum = [0], tot = 0, i;
    for (i = 1; i < dense.length; i++) {
      var dx = dense[i].x - dense[i - 1].x, dy = dense[i].y - dense[i - 1].y;
      tot += Math.sqrt(dx * dx + dy * dy);
      cum.push(tot);
    }
    return { cum: cum, total: tot };
  }
  /* Point + unit tangent at arc-length s along a dense polyline. */
  function _wavePointAtArc(dense, cum, s) {
    var last = cum.length - 1;
    if (s <= 0) s = 0;
    if (s >= cum[last]) s = cum[last];
    var i = 1;
    while (i < cum.length && cum[i] < s) i++;
    if (i > last) i = last;
    var a = dense[i - 1], b = dense[i];
    var segLen = cum[i] - cum[i - 1];
    var f = (segLen > 1e-9) ? (s - cum[i - 1]) / segLen : 0;
    var dx = b.x - a.x, dy = b.y - a.y;
    var dl = Math.sqrt(dx * dx + dy * dy) || 1;
    return { x: a.x + dx * f, y: a.y + dy * f, tx: dx / dl, ty: dy / dl };
  }
  /* Filled area under the contour (trapezoid) — one rib plate face (m²). */
  function _waveArea(dense) {
    var A = 0, i;
    for (i = 1; i < dense.length; i++) {
      A += (dense[i - 1].y + dense[i].y) / 2 * (dense[i].x - dense[i - 1].x);
    }
    return Math.abs(A);
  }
  /* Interpolate the contour height at an x position (dense is x-monotone). */
  function _waveYAt(dense, x) {
    if (x <= dense[0].x) return dense[0].y;
    var last = dense.length - 1;
    if (x >= dense[last].x) return dense[last].y;
    var i;
    for (i = 1; i < dense.length; i++) {
      if (dense[i].x >= x) {
        var a = dense[i - 1], b = dense[i];
        var f = (b.x - a.x) ? (x - a.x) / (b.x - a.x) : 0;
        return a.y + (b.y - a.y) * f;
      }
    }
    return dense[last].y;
  }
  /* Overall rib height = highest contour point for the active preset. */
  function _waveTopY(lvl) {
    var pts = _waveContour(lvl), m = 0, i;
    for (i = 0; i < pts.length; i++) if (pts[i].y > m) m = pts[i].y;
    return m;
  }
  /* Number of ribs (Wangen) scales with length: 2 (ends only) up to 4,
     targeting ≤ ~0.9 m between ribs. */
  function _waveRibCount(L) {
    return Math.max(2, Math.min(4, Math.ceil((L || WAVE.L_DEFAULT) / 0.90) + 1));
  }
  /* v257: ONE layout for the renderer and the bill (they counted the slats
     differently before): the ribs' z, the slats laid tangent to the contour
     at even arc length, the two 2x4 connectors at the feet, the rib face
     area and outline length (coating, glue). */
  /* v263: the posture's back tilt (a stop, or the morph in between while
     the toggle animates) */
  function _waveBeta(s) {
    s = s || STATE;
    if (typeof s._waveBetaAnim === 'number') return s._waveBetaAnim;
    var b = +s.waveBack;
    if (!isFinite(b)) b = WAVE.STOPS[_waveLvl(s) - 1];                 /* an older saved design: its toggle stop */
    return Math.max(15, Math.min(90, b));
  }
  /* v264 (Marek): the mattress only at the Bed end, as the Hollywood's --
     AUTO from 75 deg, the side button an explicit choice */
  function _waveCushionOn(s) {
    s = s || STATE;
    if (s.swingCushion === true || s.swingCushion === false) return s.swingCushion;
    return _waveBeta(s) >= 75;
  }
  function _waveLayout(s) {
    s = s || STATE;
    var L = s.L || WAVE.L_DEFAULT, idx = _waveLvl(s), i;
    /* the Hollywood seat line (toe -> head), the hips (the dip's end) at
       HIP_Y, the footprint centred; dense = head -> toe (x rising) */
    var ax = _swingAxis(_waveBeta(s)), apts = ax.pts, la = apts.length - 1;
    var dyW = WAVE.HIP_Y - ax.elems[2].y1, raw = [], q;
    /* v264 (Marek): both ends run on in smooth arcs -- the head rolls back
       counter-clockwise to level (12 o'clock), the front runs down
       clockwise until it stands plumb (3 o'clock) and on to the ground;
       the slats cover all of it */
    var hp = apts[la], hph = hp.phi, hx = hp.x, hy = hp.y + dyW, headCurl = 0;
    var headExt = [], Rh = WAVE.R_HEAD;
    if (hph < Math.PI - 0.01) {
      var nH = Math.max(3, Math.ceil((Math.PI - hph) * Rh / 0.02)), dh = (Math.PI - hph) / nH;
      for (q = 1; q <= nH; q++) {
        hx += Rh * (Math.sin(hph + dh) - Math.sin(hph)); hy -= Rh * (Math.cos(hph + dh) - Math.cos(hph)); hph += dh;
        headExt.push({ x: hx, y: hy });
      }
      headCurl = (Math.PI - hp.phi) * Rh;
    }
    /* v267: on past level to 9 o'clock -- the rib's back edge then drops
       plumb from the arc's end, tangent to it */
    var phB = Math.max(hph, Math.PI), nB = Math.max(4, Math.ceil((1.5 * Math.PI - phB) * Rh / 0.02)), dB = (1.5 * Math.PI - phB) / nB;
    for (q = 1; q <= nB; q++) {
      hx += Rh * (Math.sin(phB + dB) - Math.sin(phB)); hy -= Rh * (Math.cos(phB + dB) - Math.cos(phB)); phB += dB;
      headExt.push({ x: hx, y: hy });
    }
    /* v268 (Marek: late u hlavy az po konec oblouku, at se i u bed listy
       tvori az k zemi na obou stranach): the head mirrors the toe -- the
       plumb back edge down to the ground is part of the contour, and the
       slats run over the whole of it, ground to ground */
    var headV = 0;
    if (hy > 0.004) { var nVh = Math.max(1, Math.ceil(hy / 0.03)), y0h = hy; for (q = 1; q <= nVh; q++) headExt.push({ x: hx, y: y0h * (1 - q / nVh) }); headV = y0h; }
    var headBare = headV + (1.5 * Math.PI - Math.max(hp.phi, Math.PI)) * Rh;   /* contour from the ground at the back up to the level point */
    var tp = apts[0], th0 = tp.phi - Math.PI, tx = tp.x, ty = tp.y + dyW, toeExt = [];
    var Rt = Math.min(WAVE.R_TOE, (ty - 0.002) / Math.max(0.05, Math.cos(th0)));
    var nT = Math.max(3, Math.ceil((th0 + Math.PI / 2) * Rt / 0.02)), dtt = (th0 + Math.PI / 2) / nT, th = th0;
    for (q = 1; q <= nT; q++) {
      tx += Rt * (Math.sin(th) - Math.sin(th - dtt)); ty += Rt * (Math.cos(th - dtt) - Math.cos(th)); th -= dtt;
      toeExt.push({ x: tx, y: ty });
    }
    var toeArcLen = (th0 + Math.PI / 2) * Rt;
    if (ty > 0.004) { var nV = Math.max(1, Math.ceil(ty / 0.03)), y0v = ty; for (q = 1; q <= nV; q++) toeExt.push({ x: tx, y: y0v * (1 - q / nV) }); }
    for (i = headExt.length - 1; i >= 0; i--) raw.push(headExt[i]);
    for (i = la; i >= 0; i--) raw.push({ x: apts[i].x, y: apts[i].y + dyW });
    for (i = 0; i < toeExt.length; i++) raw.push(toeExt[i]);
    var dxW = -(raw[0].x + raw[raw.length - 1].x) / 2, dense = [];
    for (i = 0; i < raw.length; i++) dense.push({ x: raw[i].x + dxW, y: raw[i].y });
    var arcI = _waveArc(dense), arc = arcI.total;
    var matA = headBare + headCurl + 0.02, matB = arc - toeArcLen - (ty > 0.004 ? ty : 0) - 0.02;   /* the mattress: from the head roll to the front arc */
    /* v295 the panels: 2 x 1x4 thick, the outer ones' outer faces INSET from
       the slat ends (15 cm / US 6 in., 12 % of a narrower lounger's width),
       at most RIB_SPAN apart */
    var Pw = _waveProf(s), bt = Pw.bt, bw = Pw.bw, wt = 2 * bt;
    var inset = Math.min((s.isMetric === false) ? WAVE.INSET_US : WAVE.INSET, WAVE.INSET_K * L);
    var zEnd = L / 2 - inset - wt / 2, zStart = -zEnd, ribs = [];
    var ribN = Math.max(2, Math.min(4, Math.ceil((zEnd - zStart) / WAVE.RIB_SPAN - 1e-6) + 1));
    for (i = 0; i < ribN; i++) ribs.push(zStart + (zEnd - zStart) * i / (ribN - 1));
    var gap = (s.slatGap != null) ? s.slatGap : WAVE.GAP_DEF;
    gap = Math.max(WAVE.GAP_MIN, Math.min(WAVE.GAP_MAX, gap));
    /* v268: the slats over the whole contour, from the ground behind the head to the ground at the front.
       v271 (Marek: latovani jen na konec oblouku na 9 hodinach -- postel az
       po zem, lounge max na konec radiusu): the plumb back edge below the
       head arc is slatted only in the Bed band; below it the slats start
       at the arc's end (9 o'clock) */
    var slat0 = (_waveBeta(s) >= WAVE.BED_FROM) ? 0 : headV;
    var slatCC = WAVE.SLAT_W + gap, arcS = arc - slat0, steps = Math.max(2, Math.floor(arcS / slatCC)), margin = WAVE.SLAT_W * 0.5, slats = [];
    for (i = 0; i <= steps; i++) {
      var P = _wavePointAtArc(dense, arcI.cum, slat0 + margin + ((arcS - 2 * margin) * i) / steps);
      var ang = Math.atan2(P.ty, P.tx);
      if (Math.abs(ang) > WAVE.SLAT_MAX) continue;          /* safety: skip any steep bit */
      var nx = -P.ty, ny = P.tx;                            /* the up normal */
      slats.push({ x: P.x + nx * (WAVE.SLAT_T / 2), y: P.y + ny * (WAVE.SLAT_T / 2), ang: ang });
    }
    var last = dense.length - 1;
    /* the 2x4 connectors at both feet, CUT TO FIT between the solid ribs
       (a piece per bay, screwed through the ribs), inside the rib ends */
    var xFr = dense[last].x;                                          /* v264: the rib's front edge at the connector's height (the front arc) */
    for (i = last; i > 0; i--) if (dense[i].y >= 0.10 + WAVE.CONNECT_T) { xFr = dense[i].x; break; }
    /* v295 the connectors CONN_IN inside the panel's ends (the slat screws
       there stay clear), every other bay's stepped inward by a connector's
       width + 20 mm: a middle panel's screws into one bay's connector then
       miss the next bay's connector end against the other face */
    var cIn = WAVE.CONNECT_W / 2 + WAVE.CONN_IN, cStep = WAVE.CONNECT_W + 0.02;
    var cxs = [dense[0].x + cIn, Math.min(dense[last].x, xFr) - cIn], conns = [], c;
    for (c = 0; c < cxs.length; c++) for (i = 0; i < ribN - 1; i++) {
      var z0 = ribs[i] + wt / 2, z1 = ribs[i + 1] - wt / 2, xo = (i % 2) ? (c ? -cStep : cStep) : 0;
      conns.push({ x: cxs[c] + xo, y: 0.10, z: (z0 + z1) / 2, len: z1 - z0, bay: i, z0: z0, z1: z1 });
    }
    var area = _waveArea(dense), perim = arc + dense[0].y + dense[last].y + Math.abs(dense[last].x - dense[0].x);
    var topY = 0;
    for (i = 0; i <= last; i++) if (dense[i].y > topY) topY = dense[i].y;
    var cushion = _waveCushionOn(s);
    /* v295 THE PANEL BOARDS (the same for every panel) and THE FASTENERS,
       drawn = billed: the nails from the inner layer's free face through it
       into the outer layer; the connectors 2 x 8x100 a end through the
       panel from its far face; the slats 2 x 5x60 a panel, one into each
       layer, staggered along the slat */
    var rb = _waveRibBoards(dense, bt, bw), screws = [], r, k2;
    var nailLen = (s.isMetric === false) ? WAVE.NAIL_LEN_US : WAVE.NAIL_LEN;
    var slatLen = (s.isMetric === false) ? WAVE.SLAT_SCREW_LEN_US : WAVE.SLAT_SCREW_LEN;
    for (r = 0; r < ribN; r++) {
      var zr = ribs[r], sgr = (zr < -1e-6) ? -1 : 1;                   /* the outer (across) layer on the side away from the middle */
      for (k2 = 0; k2 < rb.nails.length; k2++)
        screws.push({ kind: 'nail', code: WAVE.NAIL, x: rb.nails[k2].x, y: rb.nails[k2].y, z: zr - sgr * bt, dir: [0, 0, sgr], len: nailLen, r: 0.0009 });
      for (k2 = 0; k2 < slats.length; k2++) {
        var sq = slats[k2], ca = Math.cos(sq.ang), sa = Math.sin(sq.ang), hx0 = sq.x - sa * WAVE.SLAT_T / 2, hy0 = sq.y + ca * WAVE.SLAT_T / 2;
        for (var ly = -1; ly <= 1; ly += 2)
          screws.push({ kind: 'slat', code: WAVE.SLAT_SCREW, x: hx0 + ly * ca * WAVE.SLAT_W / 4, y: hy0 + ly * sa * WAVE.SLAT_W / 4, z: zr + ly * bt / 2, dir: [sa, -ca, 0], len: slatLen });
      }
    }
    for (k2 = 0; k2 < conns.length; k2++) {
      var cq = conns[k2];
      for (var en = 0; en < 2; en++) {
        var zRib = ribs[cq.bay + en], face = en ? zRib + wt / 2 : zRib - wt / 2;
        for (var cs2 = -1; cs2 <= 1; cs2 += 2)
          screws.push({ kind: 'conn', code: WAVE.STRUCT_SCREW, x: cq.x + cs2 * WAVE.CONNECT_W / 4, y: cq.y, z: face, dir: [0, 0, en ? -1 : 1], len: 0.10 });
      }
    }
    return { L: L, idx: idx, beta: _waveBeta(s), ribN: ribN, ribs: ribs, dense: dense, cum: arcI.cum, arc: arc, gap: gap, slats: slats, conns: conns, area: area, perim: perim,
             bt: bt, bw: bw, wt: wt, inset: inset, rb: rb, screws: screws,
             cushion: cushion, matA: matA, matB: matB, depth: dense[last].x - dense[0].x, height: topY + WAVE.SLAT_T + (cushion ? WAVE.MAT_T : 0),
             jx: ax.elems[3].x1 + dxW, jy: ax.elems[3].y1 + dyW, jphi: ax.elems[3].phi1 };   /* the seat-back junction (the crease's end), for the pillows */
  }
  /* the build order: ribs, connectors, slats */
  var WAVE_STEPS = [
    { parts: [], codes: [] },
    { parts: ['wave-rib-v'], codes: ['TIM20100'] },                /* v295 each panel's inner layer: 1x4 upright side by side */
    { parts: ['wave-rib-h'], codes: ['TIM20100', 'FEC00043'] },    /* the outer layer glued across it */
    { parts: ['wave-hw-screw-nail'], codes: ['FAS18032'] },        /* a finish nail at every other crossing; the outline cut once the glue has set */
    { parts: ['wave-connector'], codes: ['KVH10060'] },
    { parts: ['wave-hw-screw-conn'], codes: ['FAS80100'] },
    { parts: ['wave-slat'], codes: ['TIM20100'] },
    { parts: ['wave-hw-screw-slat'], codes: ['FAS50060'] },
    { parts: ['cushion'], codes: ['FOU00016'] }                    /* v263: the mattress last */
  ];

  /* -- HOLLYWOOD SWING (variant 4) -----------------------------------
     Built to Marek's GARDEN SWING documentation (sheets 101-106, M1.01-
     M1.05, Andreas Trattner's design):
     SEAT (M1.05): two solid S-shaped side cheeks 3.02, 60 thick, a 200
       band, glued up from 60x200 members (KVH60200) and cut -- billed as
       the cheek's outline area over the 200 width; 15 slats 3.01 45x120
       (TIM45120) spanning the cheeks, screwed through the cheeks into
       their ends (2 x FAS80100 each end); eye bolts (FAT00003) in the
       cheek at the head and at the front foot, a chain (FAT00004) from
       each to one swing hanger (FAT00002) on the beam -- a V per side.
       The SEAT LINE is straights joined by arcs tangent to them: front
       foot (a rolled-down toe), seat, crease, back, head roll. The slider
       morphs the WHOLE line from upright (15 deg: short steep back, tight
       crease, big head roll, hooked toe) to a bed (90 deg: long flat back,
       wide crease, open head, flat toe). The docs' seat = 25 deg.
     STAND (M1.04): two X-frames of 100x100 legs 2.02 (KVH10100, 2.46 m
       stock, feet 1730 apart, 66 deg, crossing under the beam, half-lapped
       on an M16 threaded rod FAT16010 with nuts, washers, cap nuts); the 100x200 beam 2.01 (KVH10200) let
       into the crossing, underside at 1980, screwed FAS80180 (2 per leg);
       a 100x100 cross rail 2.03 between the legs at 440 (2 x FAS80180 per
       end); 40x60 knee braces 2.04 (KVH40060) beam-to-leg along the beam,
       2 per end (2 x FAS60100 each). No ground sill in the design.
     ROOF (M1.03): gable 15 deg (handle 10-30) or mono-pitch; frames every
       725 along the beam: a 160x80 curved bracket 1.02 (KVH16080) over the
       beam carrying two 100x80 rafters 1.01 (KVH10080) each 1085 long; at
       the two end frames 160x40 curved brackets 1.03 (KVH16040) from the
       leg tops to the rafters instead; 20x100 boards 1.04 (TIM20100) along
       the roof at 100 gauge, 20x100 fascia battens 1.05 on the rakes;
       breathable underlay ROR00008 (nailed), asphalt shingle ROR00001
       (FAS00318 20/m2, ridge caps), drip edge ROD00050 on the eaves and
       gable flashing ROD06030 on the rakes (detail A), FEC00038 sealant.
       Bracket to beam FAS80180 (2), rafters to bracket FAS80100 (2 each),
       boards to rafters FAS50060 (2 per crossing), fascia FAS50060 @300.
     Width (Z) = SEAT width on the L handle, docs 1.84 m; stand, beam and
     roof follow. Sections follow the unit system (US actual sizes in
     imperial, rebuilt on the toggle). */
  var SWING = {
    L_MIN:      1.00,
    L_MAX:      2.40,
    L_DEFAULT:  1.96,    /* outer seat width (docs 1960, slats 1840 between the cheeks) */
    /* SEAT LINE = the AXIS of the cheek band (the slats sit on it, the
       band is +-band/2 either side, round caps at both ends), a chain of
       5 tangent elements, each with a length and a turn (radius = length /
       turn, a straight when the turn is 0): toe rise, seat, dip, crease,
       back. SEAT = Marek's GLB (Garden_Swing.glb, fitted to 2 mm; metres,
       x = depth with the toe at +x, y above the ground, the beam at x = 0),
       BED = the flat lounger. The slider morphs EVERY element between the
       two: its radius and its length, plus the start point and heading;
       below 23 the morph is extrapolated (the back steeper). */
    BACK_MIN:   15,
    BACK_MAX:   90,
    BACK_DEF:   23,      /* the GLB's back: 23 deg from vertical */
    SEAT: { x: 0.7778, y: 0.5160, phi: 131.22,
            len: [0.5883, 0.2396, 0.2162, 0.4169, 0.5572],
            turn: [58.28, 7.95, -8.53, -63.06, -23.33] },
    BED:  { x: 1.1300, y: 0.6000, phi: 176.00,            /* the bed is LONGER: 2.26 on the axis (+ the caps) for a whole body, feet up */
            len: [0.6200, 0.3600, 0.3200, 0.4000, 0.5600],
            turn: [4.00, 0, 0, 0, 0] },
    EYE_HEAD:   [0.955, 0],   /* eye bolts ON the axis, near the ends (Marek; the GLB had 0.91 / 0.10, 40 under) */
    EYE_TOE:    [0.045, 0],
    SLAT_MARGIN: 0.07,   /* first / last slat centre from the axis ends (GLB: 15 slats) */
    SEAT_Y:     0,       /* the outline already stands at its height */
    CHEEK_T:    0.060,
    SLAT_W:     0.120,
    SLAT_T:     0.045,
    SLAT_GAP:   0.014,
    SLAT_ANGLE_MAX: 1.48,
    MID_CHEEK_OVER: 2.00,   /* a third cheek in the middle above this width */
    EYE_OUT:    0.02,
    HANGER_DROP: 0.06,
    LINK_PITCH: 0.022,
    /* stand (docs) */
    FOOT_HALF:  0.812,   /* leg centre at the foot (GLB: outer face 0.867), crossing at 1.82 */
    LEG_ANGLE:  66,
    LEG_STOCK:  2.46,
    LEG_TOP:    2.245,   /* flat leg top without a roof; with one the legs are cut on the deck underside (GLB) */
    BEAM_BOT:   1.98,
    BEAM_H:     0.20,
    BEAM_W:     0.10,
    RAIL_Y:     0.49,    /* rail centre (GLB 440..540) */
    SIDE_GAP:   0.34,    /* seat side -> leg centre, less half a leg */
    OVERHANG:   0.29,    /* beam beyond the leg centre */
    BRACE_LEN:  0.42,
    /* roof (docs) */
    ROOF_ORDER: ['gable', 'mono'],   /* v232: always a roof (Marek), the toggle swaps the type */
    ROOF_DEF:   'gable',
    PITCH: { gable: { min: 10, max: 30, def: 15 }, mono: { min: 8, max: 25, def: 15 } },
    ROOF_RUN:   1.03,    /* ridge -> eave, horizontal */
    ROOF_Z_OVER: 0.125,  /* boards beyond the beam ends */
    FRAME_SP:   0.725,
    FRAME_IN:   0.285,   /* (unused since v230: the end frames sit flush on the legs' outer faces) */
    RAFTER_D:   0.10,    /* 100x80 standing: 100 deep, 80 wide */
    RAFTER_W:   0.08,
    BRACKET_D:  0.16,    /* 160x80 */
    BRACKET_W:  0.08,
    BRACKET_HALF: 0.65,
    ENDBR_D:    0.16,    /* 160x40 */
    ENDBR_W:    0.04,
    ENDBR_LEN:  0.705,
    BOARD_T:    0.020,
    BOARD_W:    0.100,
    BOARD_GAUGE: 0.100,
    SHINGLE_T:  0.005,
    SHINGLE_EXP: 0.143,
    CAP_W:      0.165,
    /* codes (all in the central sheet) */
    /* fasteners mapped to the joints per Marek's BoQ of the original GARDEN
       SWING (D.xlsx, 2026-10-13): the crossing on an M16 threaded rod with
       nuts, washers and cap nuts; beam 8x260; rails 8x180; knee braces
       8x160 + 6x80; struts 6x120; hangers 6x160; slats 6x100; boards
       nailed 70; shingles + underlay on roofing nails; flashings on A2
       5.5x50; every timber face coated (MFP00002, m2). */
    /* v264 (Marek: a thicker cheek, laminated, the slats in a groove, the
       joints hidden): FOUR layers of 1x4 boards (segments, joints staggered,
       glued FEC00043): L1 inner with the GROOVE cut through it (one board
       thick, the slats' ends sit in it), L2 + L3 the core, screwed together
       (5x60) and through into the slats' ends (6x100, 2 an end), L4 the
       cover glued over the screw heads. 80 thick (US 3 in.). Over 2.00 m a
       middle support under the slats (3 layers), the slats screwed down. */
    CHEEK_CODE:  'TIM20100',
    CHEEK_LAYERS: 4, CHEEK_WASTE: 1.25, SUP_LAYERS: 3, SUP_D: 0.12,
    LAM_SCREW:   'FAS50060', LAM_PITCH: 0.25,
    SLAT_CODE:   'TIM45120',
    SLAT_SCREW:  'FAS60100',   /* 6x100 through the core (40) into the slat's end, 2 per end; the middle support's 2 a slat */
    ROD_CODE:    'FAT16010',   /* M16 threaded rod (m) through each crossing */
    ROD_LEN:     0.225,        /* 2 legs x 100 + nuts (docs 225) */
    NUT_CODE:    'FAT16011',   /* 2 per crossing */
    WASHER_CODE: 'FAT16001',   /* 4 per crossing */
    CAPNUT_CODE: 'FAT16002',   /* 4 per crossing (both rod ends, both faces) */
    BEAM_SCREW:  'FAS80260',   /* 8x260 through the beam into the crossing, 2 per end + 1 per bracket */
    STRUT_SCREW: 'FAS60120',   /* 6x120 struts to the legs, 2 each */
    HANGER_SCREW:'FAS60160',   /* 6x160 hanger plates into the beam, 2 each */
    KNEE_SCREW:  'FAS80160',   /* 8x160 knee brace to the leg, 2 each */
    KNEE_SCREW2: 'FAS60080',   /* 6x80 knee brace to the beam, 1 each */
    COAT_CODE:   'MFP00002',   /* exposed wood coating, m2 of timber */
    HANGER_CODE: 'FAT00002',
    EYE_CODE:    'FAT00003',
    CHAIN_CODE:  'FAT00004',
    LEG_CODE:    'KVH10100',
    BEAM_CODE:   'KVH10200',
    RAIL_CODE:   'KVH10100',
    BRACE_CODE:  'KVH40060',
    LEG_SCREW:   'FAS80180',   /* 8x180: rail ends + brackets */
    RAFTER_CODE: 'KVH10080',
    BRACKET_CODE:'KVH16080',
    ENDBR_CODE:  'KVH16040',
    BOARD_CODE:  'TIM20100',
    FASCIA_CODE: 'TIM20100',
    RAFTER_SCREW:'FAS80100',
    BOARD_NAIL:  'FAS70000',   /* 70 nails, boards to rafters, 2 per crossing */
    UL_CODE:     'ROR00008',
    SHINGLE_CODE:'ROR00001',
    SHINGLE_NAIL:'FAS00318',   /* shingles 4 per piece + the underlay 12 / m2 */
    DRIP_CODE:   'ROD00050',   /* drip edge 50 on the eaves */
    VERGE_CODE:  'ROD06030',   /* gable flashing 60x30 on the rakes */
    EDGE_FIX:    'FAS55050',   /* A2 5.5x50 for the flashings @ 1.0 m */
    SEALANT:     'FEC00038',
    /* rates */
    UL_NAIL_M2: 12,
    SHINGLE_NAIL_M2: 20,
    RIDGE_STRIP_W: 0.30,       /* underlay strip over the ridge */
    UL_LAP:     1.10,
    WASTE:      1.05,
    EDGE_FIX_SP: 1.00,
    SEALANT_PER_M: 12
  };
  /* ------------------------------------------------------------------
     VARIANT 5 -- PICNIC SET (slot 5, was the Gabion placeholder). The
     classic US A-frame picnic table in the park bench's style: 2x6 top
     boards and seat boards (KVH60120, 60x120 / 1 1/2 x 5 1/2), 2x6 legs
     splayed LEG_ANGLE, a 2x6 seat brace through both legs at seat height
     carrying a seat on each side, a 2x4 cleat (KVH10060) under the top at
     each frame + one in the middle, two 2x4 diagonal braces from the
     middle cleat to the seat braces, M10x130 bolts through leg + cleat /
     leg + brace (FAT10002, 2 per joint), 6x100 screws (FAS60100) for the
     boards and braces. The L handle = length. The level button = the
     kids' size (lvl 2: 2x4 boards, top 550 / seat 320).
     _picnicLayout(STATE) is the single source: the renderer draws it, the
     BoQ sums it. */
  var PICNIC = {
    L_MIN: 1.20, L_MAX: 2.40, L_DEFAULT: 1.83,      /* 6 ft */
    KID_L_MIN: 0.90, KID_L_MAX: 1.50, KID_L_DEFAULT: 1.20,
    TOP_Y: 0.76, SEAT_Y: 0.45,                       /* top faces */
    KID_TOP_Y: 0.55, KID_SEAT_Y: 0.32,
    GAP: 0.010,                                      /* between boards */
    TOP_N: 5, SEAT_N: 2,                             /* boards (kids: 6 / 2 of 2x4) */
    LEG_ANGLE: 22,                                   /* from vertical */
    FRAME_IN: 0.30,                                  /* frame centre from each end */
    LEG_TOP_IN: 0.08,                                /* leg centre inside the top edge */
    SEAT_CLEAR: 0.02,                                /* seat board clear of the leg */
    CLEAT_IN: 0.03,                                  /* cleat shorter than the top, each side */
    BOARD_CODE: 'KVH60120', KID_BOARD_CODE: 'KVH10060',
    CLEAT_CODE: 'KVH10060',
    BOLT_CODE: 'FAT10002', SCREW_CODE: 'FAS60100',
    BOLTS_PER_JOINT: 2, SCREWS_PER_BOARD_END: 2,
    /* SEPARATE BENCHES (v256, the info-bar toggle): two free-standing
       benches of the same seat boards on 2x4 A-frames (legs splayed
       BENCH_ANGLE across the bench, a top cleat, a low rail), a middle
       cleat with two diagonals cut to the rails; the end frames BENCH_IN
       from the ends, outside the table's frames. The table keeps its
       A-frames, the seat braces become cross braces between its legs. */
    BENCH_ANGLE: 15, BENCH_IN: 0.12, BENCH_RAIL_Y: 0.12, BENCH_TOP_IN: 0.01,
    /* v261 (Marek): the separate benches stand clear of the table so they
       read as loose pieces, each turned a little (under 5 deg, each its own
       way) and shifted along it */
    SEP_OUT: 0.18, SEP_YAW: [3.5, -2.2], SEP_DZ: [0.05, -0.04]
  };
  function _picnicSep(s) { return ((s || STATE).picnicSeparate === true); }
  /* a diagonal brace in the Y-Z plane CUT TO FIT: level under yTop, plumb
     at z = 0 (where its pair meets it), plumb at zIn (the face it lands on);
     the axis runs (0, yTop) -> (zIn, yB); w = its width. pts = the outline
     (z, y), len = the long point along the axis. */
  function _picnicCutDiag(yTop, zIn, yB, w) {
    function clipHalf(poly, f) {   /* keep f(p) >= 0 (Sutherland-Hodgman, one plane) */
      var out = [], n = poly.length, q;
      for (q = 0; q < n; q++) {
        var A = poly[q], B = poly[(q + 1) % n], fa = f(A), fb = f(B);
        if (fa >= 0) out.push(A);
        if ((fa >= 0) !== (fb >= 0)) { var t = fa / (fa - fb); out.push([A[0] + t * (B[0] - A[0]), A[1] + t * (B[1] - A[1])]); }
      }
      return out;
    }
    var sg = (zIn < 0) ? -1 : 1, j;
    var dz = zIn, dy = yB - yTop, dl = Math.sqrt(dz * dz + dy * dy), uz = dz / dl, uy = dy / dl, nz = -uy, ny = uz, hw2 = w / 2;
    var e0 = [-uz * 0.3, yTop - uy * 0.3], e1 = [zIn + uz * 0.3, yB + uy * 0.3];
    var pts = [[e0[0] + nz * hw2, e0[1] + ny * hw2], [e1[0] + nz * hw2, e1[1] + ny * hw2], [e1[0] - nz * hw2, e1[1] - ny * hw2], [e0[0] - nz * hw2, e0[1] - ny * hw2]];
    pts = clipHalf(pts, function (p) { return yTop - p[1]; });          /* under the cleat */
    pts = clipHalf(pts, function (p) { return sg * p[0]; });            /* its own side of z = 0 */
    pts = clipHalf(pts, function (p) { return sg * (zIn - p[0]); });    /* up to the face it lands on */
    var pMin = 1e9, pMax = -1e9;
    for (j = 0; j < pts.length; j++) { var pr = pts[j][0] * uz + pts[j][1] * uy; if (pr < pMin) pMin = pr; if (pr > pMax) pMax = pr; }
    return { y0: yTop, z0: 0, y1: yB, z1: zIn, pts: pts, len: pMax - pMin };
  }
  function _picnicKid(s) { return ((s || STATE).lvl | 0) === 2; }
  /* sections by unit system: 2x6 / 2x4 catalog metric, actual US sizes imperial */
  function _picnicProf(s) {
    s = s || STATE;
    var imp = (s.isMetric === false), kid = _picnicKid(s);
    var b = imp ? (kid ? { t: 0.038, w: 0.089 } : { t: 0.038, w: 0.1397 })
                : (kid ? { t: 0.060, w: 0.100 } : { t: 0.060, w: 0.120 });
    var c = imp ? { t: 0.038, w: 0.089 } : { t: 0.060, w: 0.100 };
    return { bT: b.t, bW: b.w, cT: c.t, cW: c.w, kid: kid,
             boardCode: kid ? PICNIC.KID_BOARD_CODE : PICNIC.BOARD_CODE, cleatCode: PICNIC.CLEAT_CODE };
  }
  /* The picnic set's build order (staged like the swings): 1 the two end
     frames (legs, top cleats, seat braces, bolts), 2 the top boards, 3 the
     middle cleat + the diagonal braces, 4 the seat boards. The codes follow
     the size (the kids' set is all 2x4). */
  function _picnicSteps(s) {
    var P = _picnicProf(s), sep = _picnicSep(s);
    function uniq(a) { var o = []; for (var i = 0; i < a.length; i++) if (o.indexOf(a[i]) < 0) o.push(a[i]); return o; }
    /* v259: as the park bench -- every group of parts, then its fasteners
       as a step of their own (drawn, driven in) */
    return [
      { parts: [], codes: [] },
      { parts: ['picnic-leg', 'picnic-cleat', 'picnic-brace'], codes: uniq([P.boardCode, P.cleatCode]) },
      { parts: ['picnic-hw-bolt'], codes: [PICNIC.BOLT_CODE] },
      { parts: ['picnic-top'], codes: [P.boardCode] },
      { parts: ['picnic-hw-screw-top'], codes: [PICNIC.SCREW_CODE] },
      { parts: ['picnic-cleat-mid', 'picnic-diag'], codes: [P.cleatCode] },
      { parts: ['picnic-hw-screw-diag'], codes: [PICNIC.SCREW_CODE] },
      /* separate benches only (no parts otherwise -> the steps drop out) */
      { parts: ['picnic-bench-leg', 'picnic-bench-cleat', 'picnic-bench-rail'], codes: [P.cleatCode] },
      { parts: ['picnic-hw-bench-bolt', 'picnic-hw-screw-rail'], codes: [PICNIC.BOLT_CODE, PICNIC.SCREW_CODE] },
      { parts: ['picnic-seat'], codes: [P.boardCode] },
      { parts: ['picnic-hw-screw-seat'], codes: [PICNIC.SCREW_CODE] },
      { parts: ['picnic-bench-cleat-mid', 'picnic-bench-diag'], codes: sep ? [P.cleatCode] : [] },
      { parts: ['picnic-hw-screw-bdiag'], codes: [PICNIC.SCREW_CODE] }
    ];
  }
  function _picnicRange(s) {
    return _picnicKid(s) ? { min: PICNIC.KID_L_MIN, max: PICNIC.KID_L_MAX } : { min: PICNIC.L_MIN, max: PICNIC.L_MAX };
  }
  function _picnicLayout(s) {
    s = s || STATE;
    var P = _picnicProf(s), R = _picnicRange(s), i, j;
    var L = s.L || (P.kid ? PICNIC.KID_L_DEFAULT : PICNIC.L_DEFAULT);
    if (L < R.min) L = R.min; if (L > R.max) L = R.max;
    var topY = P.kid ? PICNIC.KID_TOP_Y : PICNIC.TOP_Y, seatY = P.kid ? PICNIC.KID_SEAT_Y : PICNIC.SEAT_Y;
    var topN = P.kid ? 6 : PICNIC.TOP_N, gap = PICNIC.GAP;
    var D = Math.PI / 180, a = PICNIC.LEG_ANGLE * D, ta = Math.tan(a), ca = Math.cos(a);
    var topW = topN * P.bW + (topN - 1) * gap;
    /* top boards along Z */
    var tops = [];
    for (i = 0; i < topN; i++) tops.push({ x: -topW / 2 + P.bW / 2 + i * (P.bW + gap), y: topY - P.bT / 2 });
    /* frames: two near the ends, cleats at zF, legs on the outer face */
    var zF = L / 2 - PICNIC.FRAME_IN;
    if (zF < 0.15) zF = L / 2 - 0.12;
    var frames = [-zF, zF];
    var cleatL = topW - 2 * PICNIC.CLEAT_IN, cleatY = topY - P.bT - P.cW / 2;
    var cleats = [];
    for (i = 0; i < frames.length; i++) cleats.push({ z: frames[i], y: cleatY, len: cleatL });
    cleats.push({ z: 0, y: cleatY, len: cleatL, mid: true });
    /* legs: 2x6 in the frame plane, flat cuts top (under the boards) and foot */
    var yLegTop = topY - P.bT, xTop = topW / 2 - PICNIC.LEG_TOP_IN, xFoot = xTop + yLegTop * ta;
    var hw = P.bW / (2 * ca), legLen = yLegTop / ca + P.bW * ta;
    var legs = [], sx, zOff = P.cT / 2 + P.bT / 2;
    for (i = 0; i < frames.length; i++) {
      var zL = frames[i] + (frames[i] < 0 ? -zOff : zOff);
      for (sx = -1; sx <= 1; sx += 2) {
        legs.push({ z: zL, sx: sx, len: legLen,
                    pts: [[sx * (xFoot - hw), 0], [sx * (xFoot + hw), 0], [sx * (xTop + hw), yLegTop], [sx * (xTop - hw), yLegTop]] });
      }
    }
    /* seat braces 2x6 on edge through the legs at seat height; seats outside the legs */
    var braceY = seatY - P.bT - P.bW / 2;
    var xLegAtBrace = xFoot - braceY * ta + hw;
    var xSeatIn = xLegAtBrace + PICNIC.SEAT_CLEAR;
    var seatN = PICNIC.SEAT_N, seatW = seatN * P.bW + (seatN - 1) * gap;
    var xSeatOut = xSeatIn + seatW, braceL = 2 * xSeatOut;
    var sep = _picnicSep(s);
    /* separate benches: the table's seat braces become cross braces just
       past its legs; the benches move out SEP_OUT (v261) */
    if (sep) { braceL = 2 * (xLegAtBrace + (P.bW / 2) * ta + 0.02); xSeatIn += PICNIC.SEP_OUT; xSeatOut = xSeatIn + seatW; }   /* past the leg's outer edge at the brace's bottom */
    var braces = [];
    for (i = 0; i < frames.length; i++) braces.push({ z: frames[i], y: braceY, len: braceL });
    var seats = [];
    for (sx = -1; sx <= 1; sx += 2) for (j = 0; j < seatN; j++) seats.push({ x: sx * (xSeatIn + P.bW / 2 + j * (P.bW + gap)), y: seatY - P.bT / 2 });
    /* diagonal 2x4 braces: middle cleat -> each seat brace, in the Y-Z plane
       at x = 0, CUT TO FIT (v255, as the swings' knee braces): level under
       the middle cleat, plumb where the two meet at z = 0, plumb against the
       seat brace's inner face. pts = the cut outline (z, y); len = the long
       point along the axis. */
    var diags = [], yCB = cleatY - P.cW / 2;
    for (i = 0; i < frames.length; i++) {
      var sg = (frames[i] < 0) ? -1 : 1;
      diags.push(_picnicCutDiag(yCB, frames[i] - sg * P.bT / 2, braceY, P.cW));
    }
    /* SEPARATE BENCHES: per side an A-frame bench at each end (cleat under
       the seat, two splayed 2x4 legs on its outer face, a low rail across
       them), a middle cleat, two diagonals cut to the rails */
    var bench = { legs: [], cleats: [], rails: [], diags: [], bolts: [], legLen: 0, out: xSeatOut, place: [] };
    if (sep) {
      var bA = PICNIC.BENCH_ANGLE * D, bta = Math.tan(bA), bca = Math.cos(bA);
      var hwB = P.cW / (2 * bca), yTopB = seatY - P.bT, xTopB = seatW / 2 - PICNIC.BENCH_TOP_IN - hwB, xFootB = xTopB + yTopB * bta;
      var legLenB = yTopB / bca + P.cW * bta, zB = L / 2 - PICNIC.BENCH_IN, bcY = yTopB - P.cW / 2, bcL = seatW - 2 * PICNIC.BENCH_TOP_IN;
      var rY = PICNIC.BENCH_RAIL_Y, rL = 2 * (xFootB - rY * bta + hwB + 0.02);
      bench.legLen = legLenB; bench.out = Math.max(xSeatOut, xSeatIn + seatW / 2 + xFootB + hwB);
      bench.place = [{ x: -(xSeatIn + seatW / 2), yaw: PICNIC.SEP_YAW[0], dz: PICNIC.SEP_DZ[0] },
                     { x: xSeatIn + seatW / 2, yaw: PICNIC.SEP_YAW[1], dz: PICNIC.SEP_DZ[1] }];   /* drawn turned + shifted, the bill unchanged */
      for (sx = -1; sx <= 1; sx += 2) {
        var xcB = sx * (xSeatIn + seatW / 2);
        for (var bz = -1; bz <= 1; bz += 2) {
          bench.cleats.push({ x: xcB, z: bz * zB, y: bcY, len: bcL });
          bench.rails.push({ x: xcB, z: bz * zB, y: rY, len: rL });
          var zLB = bz * (zB + P.cT);
          for (var lx = -1; lx <= 1; lx += 2) {
            bench.legs.push({ z: zLB, len: legLenB,
                              pts: [[xcB + lx * (xFootB - hwB), 0], [xcB + lx * (xFootB + hwB), 0], [xcB + lx * (xTopB + hwB), yTopB], [xcB + lx * (xTopB - hwB), yTopB]] });
            var xBc = xcB + lx * (xFootB - bcY * bta), zHB = zLB + bz * P.cT / 2;
            bench.bolts.push({ x: xBc - lx * 0.02, y: bcY, z: zHB }, { x: xBc + lx * 0.02, y: bcY, z: zHB });
            bench.legs[bench.legs.length - 1].railX = xcB + lx * (xFootB - rY * bta);   /* the leg's centre at the rail */
            bench.legs[bench.legs.length - 1].zFace = zHB; bench.legs[bench.legs.length - 1].bz = bz;
          }
          var dB = _picnicCutDiag(yTopB - P.cW, bz * (zB - P.cT / 2), rY, P.cW);
          dB.x = xcB;
          bench.diags.push(dB);
        }
        bench.cleats.push({ x: xcB, z: 0, y: bcY, len: bcL, mid: true });
      }
    }
    /* bolts: leg x cleat and leg x brace, 2 per joint, heads on the leg's outer face */
    var bolts = [];
    for (i = 0; i < legs.length; i++) {
      var lg = legs[i], zHead = lg.z + (lg.z < 0 ? -P.bT / 2 : P.bT / 2);
      var yc = cleatY, xc = lg.sx * (xFoot - yc * ta), yb = braceY, xb = lg.sx * (xFoot - yb * ta);
      bolts.push({ x: xc - lg.sx * 0.025, y: yc, z: zHead }, { x: xc + lg.sx * 0.025, y: yc, z: zHead });
      bolts.push({ x: xb - lg.sx * 0.03, y: yb, z: zHead }, { x: xb + lg.sx * 0.03, y: yb, z: zHead });
    }
    var boltN = legs.length * 2 * PICNIC.BOLTS_PER_JOINT + bench.bolts.length;
    /* v259 THE SCREWS, drawn (each its own assembly step after the parts it
       fixes) and counted from this list: head point (x, y, z), dir = into
       the wood, len; kind picks the step */
    var screws = [], SL = 0.10, q, k2, b2;
    function scr(kind, x, y, z, dx, dy, dz) { screws.push({ kind: kind, x: x, y: y, z: z, dir: [dx, dy, dz], len: SL }); }
    for (q = 0; q < tops.length; q++) for (k2 = 0; k2 < cleats.length; k2++)
      for (b2 = -1; b2 <= 1; b2 += 2) scr('top', tops[q].x + b2 * P.bW / 4, topY, cleats[k2].z, 0, -1, 0);   /* top boards into the cleats */
    for (q = 0; q < seats.length; q++) {
      var zs = [];
      if (sep) { for (k2 = 0; k2 < bench.cleats.length; k2++) if ((bench.cleats[k2].x < 0) === (seats[q].x < 0)) zs.push(bench.cleats[k2].z); }
      else { for (k2 = 0; k2 < braces.length; k2++) zs.push(braces[k2].z); }
      for (k2 = 0; k2 < zs.length; k2++) for (b2 = -1; b2 <= 1; b2 += 2) scr('seat', seats[q].x + b2 * P.bW / 4, seatY, zs[k2], 0, -1, 0);
    }
    function diagScrews(kind, dg, x0, yTop, zFaceOut, sgz) {
      /* top end: up through the diagonal into the middle cleat; lower end:
         through the brace / rail from its outer face into the diagonal */
      for (b2 = -1; b2 <= 1; b2 += 2) {
        scr(kind, x0 + b2 * P.cT / 4, yTop - 0.05, sgz * P.cT / 4, 0, 1, 0);   /* inside the middle cleat's half thickness */
        scr(kind, x0 + b2 * P.cT / 4, dg.y1 + b2 * 0.02, zFaceOut, 0, 0, -sgz);
      }
    }
    for (q = 0; q < diags.length; q++) { var sgq = (diags[q].z1 < 0) ? -1 : 1; diagScrews('diag', diags[q], 0, yCB, frames[q] + sgq * P.bT / 2, sgq); }
    for (q = 0; q < bench.diags.length; q++) { var bd2 = bench.diags[q], sgb = (bd2.z1 < 0) ? -1 : 1; diagScrews('bdiag', bd2, bd2.x, bd2.y0, sgb * (Math.abs(bd2.z1) + P.cT), sgb); }
    for (q = 0; q < bench.legs.length; q++) { var blq = bench.legs[q];
      for (b2 = -1; b2 <= 1; b2 += 2) scr('rail', blq.railX, PICNIC.BENCH_RAIL_Y + b2 * 0.025, blq.zFace, 0, 0, -blq.bz); }
    /* screws: top boards to the cleats, seat boards to the seat braces (or,
       separate, to the bench's three cleats), diagonals 2 a end, bench rails
       2 a leg */
    var screwN = screws.length;   /* v259: the drawn screws (same rules as before) */
    function sumLen(a) { return a.reduce(function (acc, d) { return acc + d.len; }, 0); }
    var boardM = (tops.length + seats.length) * L + braces.length * braceL + legs.length * legLen;
    var cleatM = cleats.length * cleatL + sumLen(diags) + sumLen(bench.cleats) + sumLen(bench.rails) + sumLen(bench.diags) + bench.legs.length * bench.legLen;
    return {
      P: P, L: L, topY: topY, seatY: seatY, topW: topW, tops: tops, cleats: cleats, legs: legs,
      braces: braces, seats: seats, diags: diags, bolts: bolts.concat([]), boltN: boltN, screwN: screwN,
      sep: sep, bench: bench, screws: screws,
      width: sep ? 2 * bench.out : braceL, height: topY,
      boardM: boardM, cleatM: cleatM,
      seatM: seats.length * L,
      /* the exposed-wood coating: every face of every piece, m2 (as the swings) */
      coat: boardM * 2 * (P.bT + P.bW) + cleatM * 2 * (P.cT + P.cW)
    };
  }
  var _swingLogKey = '';     /* last logged swing build summary */
  var _picnicLogKey = '';    /* last logged picnic build summary */
  var _waveLogKey = '';      /* last logged wave build summary */
  /* THE OUTLINES FROM THE GLB (Garden_Swing.glb): x,y pairs in metres; the
     bracket 1.02 and the two end brackets 1.03 are closed loops (the cheek
     is SWING.SEAT, the fitted axis chain). */
  var SWING_BRACKET = [-0.633,1.971,-0.657,1.987,-0.511,2.026,-0.049,2.026,-0.049,1.979,0.050,1.979,0.050,2.026,0.512,2.026,0.650,1.989,0.565,1.942,0.477,1.917,0.364,1.908,0.149,1.921,0.086,1.920,0.055,1.913,0.029,1.902,0.013,1.889,-0.005,1.866,-0.017,1.884,-0.038,1.902,-0.087,1.919,-0.158,1.921,-0.335,1.909,-0.433,1.910,-0.534,1.928,-0.621,1.964];
  var SWING_ENDBR = [[-0.387,1.998,-0.486,2.011,-0.571,2.011,-0.715,2.075,-0.470,2.141,-0.128,1.989,-0.054,1.823,-0.070,1.788,-0.177,1.835,-0.204,1.885,-0.256,1.939,-0.306,1.970,-0.365,1.992], [0.411,2.002,0.326,1.978,0.272,1.950,0.217,1.900,0.178,1.835,0.071,1.788,0.055,1.823,0.129,1.989,0.470,2.141,0.716,2.075,0.572,2.011,0.436,2.006]];
  /* The decorative END CUTS of the GLB (sheets 2.01 / 1.01), relative to
     the end: the beam underside as [distance from the end, height above the
     beam bottom / beamH] -- a leaning end face 90 deep, a cove to 140, a
     shoulder back to the full 200 at 205 from the end; the rafter tail as
     [distance from the tail end along the rafter, depth / rafD] -- 43 % at
     the end, a scroll to 88 %, full depth at 190 from the end. */
  var SWING_BEAM_END = [[0.000, 1.00], [0.017, 0.55], [0.042, 0.55], [0.048, 0.535], [0.061, 0.36], [0.070, 0.32], [0.078, 0.305], [0.098, 0.30], [0.159, 0.35], [0.171, 0.345], [0.184, 0.325], [0.189, 0.30], [0.194, 0.26], [0.203, 0.01], [0.205, 0.00]];
  var SWING_RAFTER_TAIL = [[0.000, 0.43], [0.030, 0.44], [0.055, 0.72], [0.070, 0.83], [0.090, 0.88], [0.140, 0.79], [0.160, 0.80], [0.175, 0.86], [0.190, 1.00]];
  var SWING_RAFTER_X = 1.046;   /* the rafter tail end from the ridge (the deck runs on to 1.08) */
  function _swingPairs(arr) { var o = [], i; for (i = 0; i < arr.length; i += 2) o.push({ x: arr[i], y: arr[i + 1] }); return o; }
  /* STAGED ASSEMBLY of the swing: step 0 = built, then the build order of
     the PDF (stand first, roof, then the seat hung last). Each step lists
     the part types that APPEAR with it and the codes its label names. */
  /* v264 (Marek): the SEAT first, laminated (the inner layers with the
     groove, their screws, the slats into the grooves, the slats' screws,
     the cover glued over them, the eye bolts), then the stand with its
     screws, the roof, the hanging and the mattress. The stand's steps are
     shared with the A-frame swing and the kids' set. */
  var SW_STAND = [
    { parts: ['swing-leg', 'swing-rail', 'swing-hw-bolt'], codes: ['KVH10100', 'FAT16010'] },             /* X-frames + rail */
    { parts: ['swing-hw-screw-rail'], codes: ['FAS80180'] },
    { parts: ['swing-beam', 'swing-brace'], codes: ['KVH10200', 'KVH40060'] },                            /* beam + braces */
    { parts: ['swing-hw-screw-beam', 'swing-hw-screw-knee'], codes: ['FAS80260', 'FAS80160', 'FAS60080'] }
  ];
  var SW_ROOF = [
    { parts: ['swing-roof-bracket', 'swing-roof-rafter', 'swing-roof-endbracket'], codes: ['KVH16080', 'KVH10080', 'KVH16040'] },
    { parts: ['swing-roof-board', 'swing-roof-fascia'], codes: ['TIM20100'] },
    { parts: ['swing-roof-shingle', 'swing-roof-ridge', 'swing-hw-drip', 'swing-hw-drip-flange', 'swing-hw-verge', 'swing-hw-verge-top'], codes: ['ROR00001', 'ROD00050', 'ROD06030'] }
  ];
  var SW_HANG = { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: ['FAT00002', 'FAS60160', 'FAT00004'] };
  var SWING_STEPS = [
    { parts: [], codes: [] },                                                                /* 0 built */
    { parts: ['swing-rib'], codes: ['TIM20100', 'FEC00043'] },                               /* 1 cheeks: L1 (groove) + core, glued */
    { parts: ['swing-hw-screw-lam'], codes: ['FAS50060'] },                                  /* 2 the core screwed */
    { parts: ['swing-slat'], codes: ['TIM45120'] },                                          /* 3 slats into the grooves */
    { parts: ['swing-hw-screw-slat', 'swing-hw-screw-mid'], codes: ['FAS60100'] },           /* 4 through the core into the slats */
    { parts: ['swing-rib-cover'], codes: ['TIM20100', 'FEC00043'] },                         /* 5 the cover glued over the heads */
    { parts: ['swing-hw-shank', 'swing-hw-eye'], codes: ['FAT00003'] },                      /* 6 eye bolts */
    SW_STAND[0], SW_STAND[1], SW_STAND[2], SW_STAND[3],                                      /* 7-10 stand */
    SW_ROOF[0], SW_ROOF[1], SW_ROOF[2],                                                      /* 11-13 roof */
    SW_HANG,                                                                                 /* 14 hanging */
    { parts: ['cushion'], codes: ['FOU00016'] }                                              /* 15 mattress */
  ];
  /* the step table: the Hollywood swing's or the porch swing's (type 7) */
  function _swingStepTable(s) { var v = ((s || STATE).variant | 0); return (v === 7) ? ((PORCH.STYLE7 === 'classic') ? PCL_STEPS : PORCH_STEPS) : (v === 8) ? FRAME_STEPS : (v === 9) ? ADI_STEPS : (v === 10) ? PLANTER_STEPS : (v === 11) ? TREE_STEPS : (v === 12) ? STORE_STEPS : (v === 13) ? (_kidsBench(s || STATE) ? KIDS_BENCH_STEPS : KIDS_STEPS) : (v === 6) ? BLOCK_STEPS : (v === 15) ? GB_STEPS : (v === 54) ? _rtbSteps(s || STATE) : (v === 16) ? SB_STEPS : (v === 17) ? PG_STEPS : (v === 18) ? (_mfWeave(s || STATE) ? MF_STEPS_W : (_mfCant(s || STATE) ? MF_STEPS_C : MF_STEPS)) : (v === 19) ? GS_STEPS : (v === 20) ? _rbSteps(s || STATE) : (v === 21) ? _fbSteps(s || STATE) : (v === 22) ? _gaSteps(s || STATE) : (v === 23) ? _gzSteps(s || STATE) : (v === 24) ? _peSteps(s || STATE) : (v === 25) ? MB_STEPS : _isPhType(v) ? _phSteps(s || STATE) : _isGhType(v) ? _ghSteps(s || STATE) : _isKpType(v) ? _kpSteps(s || STATE) : (v === 5) ? _picnicSteps(s || STATE) : (v === 3) ? WAVE_STEPS : SWING_STEPS; }
  /* the steps that apply: no roof -> no steps 3-5, no mattress -> no
     mattress step (the last one in both tables) */
  function _swingActiveSteps(s) {
    s = s || STATE;
    var ST = _swingStepTable(s), stand = _isStandType(s.variant);
    var out = [0], i, noRoof = stand && (_swingRoof(s) === 'none');
    /* the part types in the scene: a step none of whose parts is drawn
       (a back that is off, ...) drops out */
    var have = null;
    try {
      var bg = global.BenchEngine && global.BenchEngine.benchGroup;
      if (bg && bg.children.length) { have = {}; bg.children.forEach(function (c) { if (c.userData && c.userData.partType) have[c.userData.partType] = 1; }); }
    } catch (eH) { have = null; }
    for (i = 1; i < ST.length; i++) {
      if (noRoof && ST[i].parts.some(function (pt) { return pt.indexOf('swing-roof') === 0; })) continue;   /* v264: by part, the tables moved */
      if (ST[i].parts.indexOf('cushion') >= 0 && !((((s || STATE).variant | 0) === 3) ? _waveCushionOn(s) : _swingCushionOn(s))) continue;   /* the mattress step only with the mattress */
      if (have && ST[i].parts.length && !ST[i].parts.some(function (pt) { return have[pt]; })) continue;
      out.push(i);
    }
    return out;
  }
  function _swingLastStep(s) { var a = _swingActiveSteps(s); return a[a.length - 1]; }
  /* the step a swing part first shows at (0 = always) */
  function _swingPartStep(pt) {
    var i, j, ST = _swingStepTable(STATE);
    for (i = 1; i < ST.length; i++) for (j = 0; j < ST[i].parts.length; j++) if (ST[i].parts[j] === pt) return i;
    return 0;
  }
  /* the types with the swing's back tilt slider + mattress button */
  function _isSwingBackType(v) { v = v | 0; return v === 4 || v === 7 || v === 8; }
  /* the types with a staged build order table (_swingStepTable) */
  function _isStagedType(v) { v = v | 0; if (v === 7 && PORCH.STYLE7 === 'sofa') return false; return (v >= 3 && v <= 13) || v === 15 || v === 16 || v === 17 || v === 18 || v === 19 || v === 20 || v === 21 || v === 22 || v === 23 || v === 24 || v === 25 || v === 26 || v === 27 || v === 28 || v === 29 || v === 30 || v === 31 || v === 32 || v === 33 || v === 34 || v === 35 || v === 36 || v === 37 || v === 38 || v === 39 || v === 40 || v === 41 || v === 42 || v === 43 || v === 44 || v === CS_TYPE || v === 45 || v === 46 || v === 47 || v === 48 || v === 49 || v === 52 || v === 51 || v === 54; }   /* v396 + the double dog house */   /* v392 + the dog kennel with run */   /* v391 + the cupola coop */   /* v389 + the castle */   /* v388 + the insulated dog house */   /* v386 + the lean-to coop */   /* v385 + the classic dog house */   /* v383 + the walk-in coop */   /* v379 + the chicken tractor */   /* v376 + the kitchen pod */   /* v375 + the backyard coop */   /* v373 + the gable greenhouse */   /* v368 + the tree fort */   /* v367 + the little barn */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 + the cottage */   /* v355 + the bar */   /* v334 + the pergola */   /* v328 + the gazebo */   /* v284 + the 2x4 bench; v288 + the sunbed; v296 + the pergola swing */   /* every type but the park bench + sofa (their own sequences); v269: the porch swing in the sofa style runs the sofa's */
  /* the types on the Hollywood stand (roof toggle, pitch slider) */
  function _isStandType(v) { v = v | 0; return v === 4 || v === 8; }
  function _standLayout(s) { return (((s || STATE).variant | 0) === 8) ? _frameLayout(s) : _swingLayout(s); }

  /* The mattress: AUTO (null) shows it once the back lies down into the Bed
     band (Marek: pri vodorovnem ramu se muze objevit matrace), the button
     overrides it either way. */
  function _swingCushionOn(s) {
    s = s || STATE;
    if ((s.variant | 0) === 18) return true;   /* v301 the modern swing: the sofa seat's cushions always (its level button = the fabric weave) */
    if (s.swingCushion === true || s.swingCushion === false) return s.swingCushion;
    if (_porchStyle(s) === 'sofa' || _porchStyle(s) === 'classic') return true;   /* the sofa swing / v278 the classic swing: the cushion on by default */
    return _swingBack(s) >= 75;
  }
  function _swingBack(s) {
    var b = +((s || STATE).swingBack);
    if (!isFinite(b)) b = SWING.BACK_DEF;
    return Math.max(SWING.BACK_MIN, Math.min(_swingBackMax(s), b));
  }
  /* v261 (Marek): the bench-style porch seat (the A-frame swing, type 8)
     stops at Recline -- flat it was the Hollywood bed with the armrests
     still standing on it */
  function _swingBackMax(s) {
    var v = ((s || STATE).variant | 0);
    return (v === 8 || v === 13 || (v === 7 && _porchStyle(s) === 'bench')) ? PORCH.BACK_MAX : SWING.BACK_MAX;   /* v299 + the kids' set's bench */
  }
  function _swingRoof(s) {
    var r = (s || STATE).swingRoof;
    return (r === 'gable' || r === 'mono') ? r : SWING.ROOF_DEF;   /* an old saved 'none' becomes the default roof */
  }
  function _swingPitch(s) {
    var t = _swingRoof(s);
    if (t === 'none') return 0;
    var R = SWING.PITCH[t], p = +((s || STATE).swingPitch);
    if (!isFinite(p) || p <= 0) p = R.def;
    return Math.max(R.min, Math.min(R.max, p));
  }
  /* Sections by unit system: catalog metric sizes / actual US sizes. */
  function _swingProf(s) {
    if ((s || STATE).isMetric === false) {
      return { leg: 0.0889, beamW: 0.0889, beamH: 0.1842, cheekT: 4 * 0.01905, layerT: 0.01905, band: 0.1842,
               slatW: 0.1397, slatT: 0.0381, rafD: 0.0889, rafW: 0.0381, brD: 0.1397, brW: 0.0381,
               ebD: 0.1397, ebW: 0.0381, boardT: 0.0191, boardW: 0.0889, braceT: 0.0381, braceW: 0.0635 };
    }
    return { leg: 0.100, beamW: 0.100, beamH: 0.200, cheekT: 0.080, layerT: 0.020, band: 0.200,
             slatW: 0.120, slatT: 0.045, rafD: 0.100, rafW: 0.080, brD: 0.160, brW: 0.080,
             ebD: 0.160, ebW: 0.040, boardT: 0.020, boardW: 0.100, braceT: 0.040, braceW: 0.060 };
  }
  /* THE SEAT LINE: the axis chain for a back tilt beta (toe -> head), every
     point with its heading; the elements with their morphed radius / length. */
  function _swingAxis(beta) {
    var A = SWING.SEAT, B = SWING.BED, D = Math.PI / 180;
    var t = (beta - SWING.BACK_DEF) / (SWING.BACK_MAX - SWING.BACK_DEF);
    function mix(a, b) { return a + (b - a) * t; }
    var x = mix(A.x, B.x), y = mix(A.y, B.y), phi = mix(A.phi, B.phi) * D;
    var pts = [{ x: x, y: y, phi: phi }], elems = [], i, j;
    for (i = 0; i < A.len.length; i++) {
      var len = mix(A.len[i], B.len[i]), turn = mix(A.turn[i], B.turn[i]) * D;
      var n = Math.max(2, Math.ceil(len / 0.02)), k = turn / len, a = len / n;
      var el = { len: len, turn: turn / D, R: Math.abs(turn) > 1e-6 ? len / Math.abs(turn) : 0, x0: x, y0: y, phi0: phi };
      if (el.R) { var rr = 1 / k; el.cx = x - rr * Math.sin(phi); el.cy = y + rr * Math.cos(phi); }   /* the arc's centre, left of travel for a left turn */
      elems.push(el);
      for (j = 1; j <= n; j++) {
        if (Math.abs(k) < 1e-9) { x += a * Math.cos(phi); y += a * Math.sin(phi); }
        else {
          var R = 1 / k;
          x += R * (Math.sin(phi + k * a) - Math.sin(phi));
          y -= R * (Math.cos(phi + k * a) - Math.cos(phi));
          phi += k * a;
        }
        pts.push({ x: x, y: y, phi: phi });
      }
      el.x1 = x; el.y1 = y; el.phi1 = phi;
    }
    return { pts: pts, elems: elems };
  }
  /* The cheek for a tilt: axis +- half the band, round caps; dense = the
     axis head -> toe (the slats' line, normals up); the eye bolt points. */
  function _swingCheek(beta, band) {
    var ax = _swingAxis(beta), pts = ax.pts, H = (band || 0.2) / 2, i;
    function nUp(p) { return { x: Math.sin(p.phi), y: -Math.cos(p.phi) }; }
    var top = [], bot = [];
    for (i = 0; i < pts.length; i++) {
      var n = nUp(pts[i]);
      top.push({ x: pts[i].x + H * n.x, y: pts[i].y + H * n.y });
      bot.push({ x: pts[i].x - H * n.x, y: pts[i].y - H * n.y });
    }
    var pe = pts[pts.length - 1], p0 = pts[0], ne = nUp(pe), n0 = nUp(p0);
    var headCap = _capArc(pe, H, ne, { x: Math.cos(pe.phi), y: Math.sin(pe.phi) }, 10);
    var toeCap = _capArc(p0, H, { x: -n0.x, y: -n0.y }, { x: -Math.cos(p0.phi), y: -Math.sin(p0.phi) }, 10);
    var outline = top.concat(headCap, bot.slice().reverse(), toeCap);
    var dense = pts.slice().reverse().map(function (p) { return { x: p.x, y: p.y }; });
    var cum = [0], total = 0;
    for (i = 1; i < pts.length; i++) { total += Math.sqrt(Math.pow(pts[i].x - pts[i - 1].x, 2) + Math.pow(pts[i].y - pts[i - 1].y, 2)); cum.push(total); }
    function eye(spec) {
      var sTarget = spec[0] * total, j = 0;
      while (j < cum.length - 2 && cum[j + 1] < sTarget) j++;
      var f = (sTarget - cum[j]) / ((cum[j + 1] - cum[j]) || 1), q = pts[j], r = pts[j + 1];
      var p = { x: q.x + (r.x - q.x) * f, y: q.y + (r.y - q.y) * f, phi: q.phi + (r.phi - q.phi) * f }, n = nUp(p);
      return { x: p.x + spec[1] * n.x, y: p.y + spec[1] * n.y };
    }
    return { top: top, bot: bot, outline: outline, dense: dense, elems: ax.elems, axisLen: total,
             eyeHead: eye(SWING.EYE_HEAD), eyeToe: eye(SWING.EYE_TOE) };
  }
  function _swingNormals(dense) {
    var n = [], i, last = dense.length - 1;
    for (i = 0; i <= last; i++) {
      var a = dense[Math.max(0, i - 1)], b = dense[Math.min(last, i + 1)];
      var dx = b.x - a.x, dy = b.y - a.y, dl = Math.sqrt(dx * dx + dy * dy) || 1;
      n.push({ x: -dy / dl, y: dx / dl });
    }
    return n;
  }
  function _polyArea(pts) {
    var A = 0, i, j;
    for (i = 0, j = pts.length - 1; i < pts.length; j = i++) A += (pts[j].x + pts[i].x) * (pts[j].y - pts[i].y);
    return Math.abs(A) / 2;
  }
  /* A round cap closing a band between two end points. */
  function _capArc(c, r, u, v, n) {
    var out = [], k;
    for (k = 1; k < n; k++) {
      var th = Math.PI * k / n;
      out.push({ x: c.x + r * (u.x * Math.cos(th) + v.x * Math.sin(th)), y: c.y + r * (u.y * Math.cos(th) + v.y * Math.sin(th)) });
    }
    return out;
  }
  /* THE ROOF (sheet M1.03): frames on the beam, the planes over them. A
     plane: O (its upper edge at the ridge for the gable, lower edge at the
     low eave for the mono), d unit along the slope, len. */
  function _swingRoofLayout(s, P, beamLen, legs, zLeg, runIn) {
    var type = _swingRoof(s);
    if (type === 'none') return null;
    var D = Math.PI / 180, pitch = _swingPitch(s), a = pitch * D;
    var ta = Math.tan(a), ca = Math.cos(a), sa = Math.sin(a);
    var run = runIn || SWING.ROOF_RUN, rd = P.rafD;      /* the roof grows with the seat (the bed) so it covers it */
    var yBT = SWING.BEAM_BOT + P.beamH;                  /* beam top */
    var RL = beamLen + 2 * SWING.ROOF_Z_OVER;
    var zEnd = zLeg + P.leg / 2 + P.rafW / 2;            /* end frames flush with the legs' outer faces (GLB) */
    var nF = Math.max(2, Math.round(2 * zEnd / SWING.FRAME_SP) + 1), i;
    var frameZ = [];
    for (i = 0; i < nF; i++) frameZ.push(-zEnd + 2 * zEnd * i / (nF - 1));
    var ext = 0.05, xT = run + ext;
    var members = [], planes = [], topY, rafterLen, rakeN, eaveN, ridge = false;
    /* bracket 1.02: the GLB outline (hangs under the beam, notched over its
       bottom edge, the arms reaching out under the rafters); bracketLen =
       the 1305 blank of the docs */
    /* The GLB shapes are drawn for a 15 deg gable on 100 rafters: the
       bracket arms end on the rafter UNDERSIDE, the struts on the DECK
       (rafter top). A shear moves every point by the difference between
       the real line (pitch, type, section) and the GLB's 15 deg line, so
       the arms always end exactly on the rafters, the struts exactly on the
       deck (imperial rafters are thinner: without this the struts stood
       above the roof). The bracket's notch over the beam (|x| <= 0.05) stays. */
    var t15 = Math.tan(15 * D), G15_UNDER = 2.1635, G15_DECK = 2.2665;
    var xR = run + (SWING_RAFTER_X - SWING.ROOF_RUN), yR0 = yBT - 0.016;   /* the tail end 16 past the run; underside line 16 below the beam top at the ridge */
    var yLo = yR0 - run * ta;                                /* mono: underside at x = -run */
    function uM(x) { return yLo + (x + run) * ta; }
    function underY(x) { return (type === 'gable') ? yR0 - Math.abs(x) * ta : uM(x); }
    function deckY(x) { return underY(x) + rd / ca; }
    function shear(x) {
      var ax = Math.abs(x);
      if (ax <= 0.05) return 0;
      return underY(x) - (G15_UNDER - ax * t15);
    }
    function shearS(x) { return deckY(x) - (G15_DECK - Math.abs(x) * t15); }
    var bp = _swingPairs(SWING_BRACKET).map(function (q) { return [q.x, q.y + shear(q.x)]; });
    var bracketLen = 1.305 / Math.cos(a) * Math.cos(15 * D);
    members.push({ kind: 'bracket', code: SWING.BRACKET_CODE, w: P.brW, pts: bp, len: bracketLen });
    /* a rafter polygon in its own frame: u along the top from the ridge
       point O outward (unit d), v down into the rafter (unit n); the tail
       scroll of the GLB at the far end, the birdsmouth over the beam */
    function rafterPoly(O, d, n, Lt, notchX) {
      var pts = [[O.x, O.y], [O.x + Lt * d.x, O.y + Lt * d.y]], q, j;
      for (j = 0; j < SWING_RAFTER_TAIL.length; j++) {
        q = SWING_RAFTER_TAIL[j]; var uu = Lt - q[0], vv = rd * q[1];
        pts.push([O.x + uu * d.x + vv * n.x, O.y + uu * d.y + vv * n.y]);
      }
      /* the underside back to the notch over the beam (x = notchX), up to the beam top, to the ridge */
      var uN = (Math.abs(notchX - O.x) + rd * Math.abs(n.x)) / Math.abs(d.x);
      pts.push([O.x + uN * d.x + rd * n.x, O.y + uN * d.y + rd * n.y]);
      pts.push([notchX, yBT], [O.x, yBT]);
      return pts;
    }
    if (type === 'gable') {
      /* rafters 1.01 on the beam: top at the ridge yRT, the pair meeting
         over the beam, each tail with the GLB scroll */
      var yRT = yR0 + rd / ca;
      rafterLen = xR / ca;
      members.push({ kind: 'rafter', code: SWING.RAFTER_CODE, w: P.rafW, len: rafterLen,
                     pts: rafterPoly({ x: 0, y: yRT }, { x: ca, y: -sa }, { x: -sa, y: -ca }, rafterLen, 0.05) });
      members.push({ kind: 'rafter', code: SWING.RAFTER_CODE, w: P.rafW, len: rafterLen,
                     pts: rafterPoly({ x: 0, y: yRT }, { x: -ca, y: -sa }, { x: sa, y: -ca }, rafterLen, -0.05) });
      planes.push({ O: { x: 0, y: yRT }, d: { x: ca, y: -sa }, len: xT / ca });
      planes.push({ O: { x: 0, y: yRT }, d: { x: -ca, y: -sa }, len: xT / ca });
      rakeN = 4; eaveN = 2; ridge = true;
      topY = yRT + P.boardT + 2 * SWING.SHINGLE_T;
    } else {
      /* mono: one rafter over the beam rising to the front, the scroll on
         both tails, notched over the beam */
      rafterLen = (2 * xR) / ca;
      var dM = { x: ca, y: sa }, nM = { x: sa, y: -ca }, OM = { x: -xR, y: uM(-xR) + rd / ca }, mp = [], j2, q2;
      /* top edge low -> high, the high tail scroll, the underside back, the notch, the low tail scroll */
      mp.push([OM.x, OM.y], [OM.x + rafterLen * dM.x, OM.y + rafterLen * dM.y]);
      for (j2 = 0; j2 < SWING_RAFTER_TAIL.length; j2++) {
        q2 = SWING_RAFTER_TAIL[j2]; var u2 = rafterLen - q2[0], v2 = rd * q2[1];
        mp.push([OM.x + u2 * dM.x + v2 * nM.x, OM.y + u2 * dM.y + v2 * nM.y]);
      }
      var uN2 = (0.05 - OM.x - rd * sa) / ca, uN1 = (-0.05 - OM.x - rd * sa) / ca;
      mp.push([OM.x + uN2 * dM.x + rd * nM.x, OM.y + uN2 * dM.y + rd * nM.y], [0.05, yBT], [-0.05, yBT],
              [OM.x + uN1 * dM.x + rd * nM.x, OM.y + uN1 * dM.y + rd * nM.y]);
      for (j2 = SWING_RAFTER_TAIL.length - 1; j2 >= 0; j2--) {
        q2 = SWING_RAFTER_TAIL[j2]; var u3 = q2[0], v3 = rd * q2[1];
        mp.push([OM.x + u3 * dM.x + v3 * nM.x, OM.y + u3 * dM.y + v3 * nM.y]);
      }
      members.push({ kind: 'rafter', code: SWING.RAFTER_CODE, w: P.rafW, len: rafterLen, pts: mp });
      var yLT = OM.y;
      planes.push({ O: { x: -xT, y: uM(-xT) + rd / ca }, d: { x: ca, y: sa }, len: (2 * xT) / ca });
      rakeN = 2; eaveN = 2; ridge = false;
      topY = uM(-xT) + rd / ca + 2 * xT * ta + P.boardT + SWING.SHINGLE_T;
    }
    /* end brackets 1.03: the GLB struts, one per leg, standing on the leg
       tops IN the leg (flush with its outer face, the GLB), reaching the
       roof deck; sheared with the roof like the brackets (4) */
    var endBr = [];
    for (i = 0; i < legs.length; i++) {
      var lg = legs[i];
      var loop = SWING_ENDBR[lg.sx > 0 ? 1 : 0];
      endBr.push({ z: lg.sz * (zLeg + P.leg / 2 - P.ebW / 2), sx: lg.sx,
                   pts: _swingPairs(loop).map(function (q) { return [q.x, q.y + shearS(q.x)]; }) });
    }
    var deckA = 0;
    for (i = 0; i < planes.length; i++) deckA += planes[i].len * RL;
    var rakeLen = planes[0].len;
    return {
      type: type, pitch: pitch, a: a, run: run, RL: RL, frameZ: frameZ, members: members,
      planes: planes, rafterLen: rafterLen, bracketLen: bracketLen, endBr: endBr,
      deckA: deckA, eaveM: eaveN * RL, rakeM: rakeN * rakeLen, ridgeM: ridge ? RL : 0, ridge: ridge,
      topY: topY, rise: (type === 'gable') ? run * ta : 2 * run * ta,
      handle: (type === 'gable') ? { x: 0, y: topY + 0.06 } : { x: xT, y: topY + 0.06 }
    };
  }
  /* Everything the swing is made of, in one place: the renderer draws it
     and the BoQ sums it, so the bill can never drift from the model. */
  function _swingLayout(s) {
    s = s || STATE;
    var P = _swingProf(s), i, k;
    var L = s.L || SWING.L_DEFAULT;
    if (L < SWING.L_MIN) L = SWING.L_MIN; if (L > SWING.L_MAX) L = SWING.L_MAX;
    var beta = _swingBack(s);
    var ck = _swingCheek(beta, P.band);
    var dense = ck.dense, outline = ck.outline, bottom = ck.bot;
    var arcI = _waveArc(dense), arc = arcI.total, cum = arcI.cum;
    var band = P.band;
    var cheekArea = _polyArea(outline), cheekPerim = 0;
    for (i = 0; i < outline.length; i++) { var oA = outline[i], oB = outline[(i + 1) % outline.length]; cheekPerim += Math.sqrt((oB.x - oA.x) * (oB.x - oA.x) + (oB.y - oA.y) * (oB.y - oA.y)); }
    /* the cheek is cut from 60x200 blanks stacked in bands (3.02A/B/C):
       one blank per 200 of height, as long as the outline is in that band */
    var oyMin = 1e9, oyMax = -1e9;
    for (i = 0; i < outline.length; i++) { if (outline[i].y < oyMin) oyMin = outline[i].y; if (outline[i].y > oyMax) oyMax = outline[i].y; }
    var nStrip = Math.max(1, Math.ceil((oyMax - oyMin) / band - 0.02)), cheekBlanks = 0, cheekStrips = [], st;
    for (st = 0; st < nStrip; st++) {
      var ya = oyMin + st * band, yb2 = ya + band, xa = 1e9, xb = -1e9, j2;
      for (j2 = 0; j2 < outline.length; j2++) {
        var o1 = outline[j2], o2 = outline[(j2 + 1) % outline.length];
        var lo = Math.max(ya, Math.min(o1.y, o2.y)), hi = Math.min(yb2, Math.max(o1.y, o2.y));
        if (hi < lo) continue;
        var xs = [o1.x, o2.x];
        if (Math.abs(o2.y - o1.y) > 1e-9) {
          xs = [o1.x + (o2.x - o1.x) * (lo - o1.y) / (o2.y - o1.y), o1.x + (o2.x - o1.x) * (hi - o1.y) / (o2.y - o1.y)];
        }
        if (xs[0] < xa) xa = xs[0]; if (xs[1] < xa) xa = xs[1];
        if (xs[0] > xb) xb = xs[0]; if (xs[1] > xb) xb = xs[1];
      }
      if (xb > xa) { cheekBlanks += (xb - xa) + 0.05; cheekStrips.push((xb - xa) + 0.05); }
    }

    /* cheeks: the two outer ones (v264: laminated, see SWING); over 2.00 m
       a middle support under the slats */
    var ribT = P.cheekT, lt = P.layerT;
    var ribN = 2, midSup = (L > SWING.MID_CHEEK_OVER);
    var ribZ = [-L / 2 + ribT / 2, L / 2 - ribT / 2];
    var slatSpan = L - 2 * ribT;                         /* the clear span between the cheeks */
    var slatLen = slatSpan + 2 * lt;                     /* v264: the ends sit in the grooves of the inner layers */

    /* slats 45x120 at even arc length ALONG THE AXIS (their centre on it, as the GLB) */
    var cc = P.slatW + SWING.SLAT_GAP;
    var margin = SWING.SLAT_MARGIN;
    var steps = Math.max(2, Math.floor((arc - 2 * margin) / cc));
    var slats = [];
    for (i = 0; i <= steps; i++) {
      var sa0 = margin + ((arc - 2 * margin) * i) / steps;
      var pt = _wavePointAtArc(dense, cum, sa0);
      var ang = Math.atan2(pt.ty, pt.tx);
      if (Math.abs(ang) > SWING.SLAT_ANGLE_MAX) continue;
      slats.push({ x: pt.x, y: pt.y, ang: ang, s: sa0 });   /* on the cheek axis, band/2 under the top edge */
    }
    /* v264 THE GROOVE in the inner layer: the slats' line +- half a slat
       (+1 mm), stopped 12 mm past the first / last slat; THE SCREWS (drawn,
       counted): the lamination 5x60 from L3's outer face every LAM_PITCH,
       two rows clear of the groove; the slats' ends 6x100 through L3 + L2,
       2 an end; with the middle support 6x100 down through each slat */
    var nrmA = _swingNormals(dense), gw = P.slatT / 2 + 0.001;
    function atS(sv, off) {
      var j = 0;
      while (j < cum.length - 2 && cum[j + 1] < sv) j++;
      var f = (sv - cum[j]) / ((cum[j + 1] - cum[j]) || 1), a = dense[j], b = dense[j + 1], na = nrmA[j], nb = nrmA[j + 1];
      var nx = na.x + (nb.x - na.x) * f, ny = na.y + (nb.y - na.y) * f, nl = Math.sqrt(nx * nx + ny * ny) || 1;
      return { x: a.x + (b.x - a.x) * f + off * nx / nl, y: a.y + (b.y - a.y) * f + off * ny / nl, nx: nx / nl, ny: ny / nl };
    }
    var sG0 = Math.max(0.03, margin - P.slatW / 2 - 0.012), sG1 = Math.min(arc - 0.03, arc - margin + P.slatW / 2 + 0.012);
    function axisStrip(o0, o1, sA, sB) {   /* a strip between two offsets of the axis, square ends */
      var top = [], bot = [], n = Math.max(8, Math.ceil((sB - sA) / 0.02)), k;
      for (k = 0; k <= n; k++) { var sv = sA + (sB - sA) * k / n; top.push(atS(sv, o1)); bot.push(atS(sv, o0)); }
      return top.concat(bot.reverse()).map(function (q) { return { x: q.x, y: q.y }; });
    }
    var grooveHole = axisStrip(-gw, gw, sG0, sG1);
    var supOutline = midSup ? axisStrip(-P.slatT / 2 - SWING.SUP_D, -P.slatT / 2, sG0, sG1) : null;
    var supArea = supOutline ? _polyArea(supOutline) : 0;
    var seatScrews = [], sgc, kq;
    for (sgc = -1; sgc <= 1; sgc += 2) {
      var zL3 = sgc * (L / 2 - lt);                     /* L3's outer face (under the cover) */
      var nLam = Math.max(2, Math.floor(arc / SWING.LAM_PITCH));
      for (kq = 0; kq < nLam; kq++) {
        var sl0 = arc * (kq + 0.5) / nLam;
        for (var rw = -1; rw <= 1; rw += 2) {
          var pL = atS(sl0, rw * 0.62 * band / 2);
          seatScrews.push({ kind: 'lam', x: pL.x, y: pL.y, z: zL3 - sgc * 0.004, dir: [0, 0, -sgc], len: 0.06 });
        }
      }
      for (kq = 0; kq < slats.length; kq++) {
        var slq = slats[kq], ta = Math.cos(slq.ang), tb = Math.sin(slq.ang);
        for (var e2 = -1; e2 <= 1; e2 += 2)
          seatScrews.push({ kind: 'slat', x: slq.x + e2 * ta * P.slatW / 4, y: slq.y + e2 * tb * P.slatW / 4, z: zL3, dir: [0, 0, -sgc], len: 0.10 });
      }
    }
    if (midSup) for (kq = 0; kq < slats.length; kq++) {
      var slm = slats[kq], pm = atS(slm.s, P.slatT / 2);
      for (var e3 = -1; e3 <= 1; e3 += 2) seatScrews.push({ kind: 'mid', x: pm.x, y: pm.y, z: e3 * 0.018, dir: [-pm.nx, -pm.ny, 0], len: 0.10 });
    }

    /* STAND (shared with the A-frame swing, type 8): X-frames, beam,
       rails, knee braces and the roof -- _swingStand. THE ROOF RUN
       follows the seat: the bed is longer than the docs' seat, so the
       roof reaches 60 past the outline's ends (Marek) -- at least the
       docs' 1.03 */
    var sxMin = 1e9, sxMax = -1e9, sz;
    for (i = 0; i < outline.length; i++) { if (outline[i].x < sxMin) sxMin = outline[i].x; if (outline[i].x > sxMax) sxMax = outline[i].x; }
    var roofRun = Math.max(SWING.ROOF_RUN, Math.max(-sxMin, sxMax) + 0.06 - 0.05);
    var stand = _swingStand(s, P, L / 2 + SWING.SIDE_GAP + P.leg / 2, roofRun);
    var yBB = stand.beamBot, yBT = stand.beamTop, zA = stand.zA, beamLen = stand.beamLen, wh = stand.wh;
    var legs = stand.legs, rails = stand.rails, braces = stand.braces, yX = stand.yX;

    /* hanging: eyes at the band middle of the head and toe nodes, outside
       the outer cheeks; one hanger per side under the beam */
    var eyes = [], hangers = [], chains = [];
    var zEye = L / 2 + SWING.EYE_OUT;
    var hy = yBB - SWING.HANGER_DROP;
    var eyePts = [ck.eyeHead, ck.eyeToe];
    for (sz = -1; sz <= 1; sz += 2) {
      hangers.push({ x: 0, y: hy, z: sz * zEye });
      for (i = 0; i < eyePts.length; i++) {
        var ex = eyePts[i].x, ey = eyePts[i].y;
        eyes.push({ x: ex, y: ey, z: sz * zEye });
        chains.push({ a: { x: 0, y: hy, z: sz * zEye }, b: { x: ex, y: ey, z: sz * zEye },
                      len: Math.sqrt(ex * ex + (hy - ey) * (hy - ey)) });
      }
    }

    var roof = stand.roof;
    var xMin = 1e9, xMax = -1e9, topSeat = 0;
    for (i = 0; i < dense.length; i++) {
      if (dense[i].x < xMin) xMin = dense[i].x;
      if (dense[i].x > xMax) xMax = dense[i].x;
      if (dense[i].y > topSeat) topSeat = dense[i].y;
    }
    var depthAll = stand.depth;
    return {
      P: P, L: L, beta: beta, dense: dense, bottom: bottom, outline: outline, elems: ck.elems, axisLen: ck.axisLen, cheekPerim: cheekPerim, cheekArea: cheekArea, cheekBlanks: cheekBlanks, cheekStrips: cheekStrips,
      layerT: lt, grooveHole: grooveHole, midSup: midSup, supOutline: supOutline, supArea: supArea, slatLen: slatLen, seatScrews: seatScrews,
      cushion: _swingCushionOn(s), cushionT: 0.06,
      arc: arc, cum: cum, ribT: ribT, ribN: ribN, ribZ: ribZ, slatSpan: slatSpan, slats: slats,
      beamBot: yBB, beamTop: yBT, beamLen: beamLen, zA: zA, wh: wh, legs: legs, yX: yX,
      rails: rails, braces: braces, eyes: eyes, hangers: hangers, chains: chains, roof: roof,
      seatTopY: topSeat, seatXMin: xMin, seatXMax: xMax,
      depth: depthAll, height: stand.height
    };
  }
  /* THE STAND of the Hollywood swing (and of the A-frame swing, type 8):
     X-frames of legs from the foot at +-FOOT_HALF at LEG_ANGLE, the two
     legs of a frame crossing under the beam, the beam, the rails, the knee
     braces and the roof over it. zA = the frames' z (centre of the legs),
     roofRun = the roof's horizontal run from the ridge. */
  function _swingStand(s, P, zA, roofRun, opt) {
    var noRoof = !!(opt && opt.noRoof);                  /* the kids' swing set (type 13): no roof, flat leg tops */
    var i;
    var D = Math.PI / 180, th = SWING.LEG_ANGLE * D, ct = 1 / Math.tan(th);
    var wh = P.leg / Math.sin(th);                       /* horizontal width of a leg */
    var beamLen = 2 * (zA + SWING.OVERHANG);
    var legs = [], sz, sxx;
    var yTop = SWING.LEG_TOP, yBB = SWING.BEAM_BOT, yBT = yBB + P.beamH;

    function legCX(sgn, y) { return sgn * (SWING.FOOT_HALF - ct * y); }
    /* the legs rise between the rafters and are cut on the deck underside
       (the GLB: the top cut at the pitch, 2.23 at the inner corner) */
    var rType = noRoof ? 'none' : _swingRoof(s), rA = _swingPitch(s) * D, deck = null;
    if (rType !== 'none') {
      var rdc = P.rafD / Math.cos(rA), yR0d = yBT - 0.016, taD = Math.tan(rA);
      deck = (rType === 'gable') ? function (x) { return yR0d + rdc - Math.abs(x) * taD; }
                                 : function (x) { return yR0d - roofRun * taD + rdc + (x + roofRun) * taD; };
    }
    function legTopY(sgn, side) {           /* y where the leg edge (centre +- wh/2) meets the deck */
      if (!deck) return yTop;
      var y = yTop, q;
      for (q = 0; q < 6; q++) y = deck(legCX(sgn, y) + side * wh / 2);
      return y;
    }
    /* THE JOINTS (Marek: generated let-in joints): the two legs of a frame
       are HALF-LAPPED where they cross (each loses half its thickness in
       the crossing diamond, one on the front face, one on the back), and
       the rail is HOUSED 45 deep into each leg's inner edge. Every leg is
       drawn as pieces: {pts, z0, z1} in the leg's own thickness. */
    var railH = P.leg, railHalfIn = 0.045;
    function legEdgeX(sgn, e, y) { return sgn * (SWING.FOOT_HALF - ct * y) + e; }   /* e = +-wh/2 */
    function crossY(eA, eB) { return (2 * SWING.FOOT_HALF + eB - eA) / (2 * ct); }  /* leg A (-x) edge eA meets leg B (+x) edge eB */
    /* the inner edge of a leg with the rail pocket cut in, walked from yFrom up to yTo */
    function innerEdge(sgn, yFrom, yTo) {
      var eIn = -sgn * wh / 2, out = [], ya = SWING.RAIL_Y - railH / 2, yb = SWING.RAIL_Y + railH / 2;
      out.push([legEdgeX(sgn, eIn, yFrom), yFrom]);
      if (ya > yFrom && yb < yTo) {
        var xb = legEdgeX(sgn, eIn, SWING.RAIL_Y) + sgn * railHalfIn;
        out.push([legEdgeX(sgn, eIn, ya), ya], [xb, ya], [xb, yb], [legEdgeX(sgn, eIn, yb), yb]);
      }
      out.push([legEdgeX(sgn, eIn, yTo), yTo]);
      return out;
    }
    for (sz = -1; sz <= 1; sz += 2) {
      for (sxx = -1; sxx <= 1; sxx += 2) {
        var xf = legCX(sxx, 0), yI = legTopY(sxx, -1), yO = legTopY(sxx, 1);
        var xt = legCX(sxx, (yI + yO) / 2);
        var eIn = -sxx * wh / 2, eOut = sxx * wh / 2;
        /* the crossing diamond on this leg: its inner / outer edge meet the
           other leg's two edges at these heights */
        var oIn = (sxx < 0) ? crossY(eIn, -wh / 2) : crossY(-wh / 2, eIn);     /* inner edge, lower vertex */
        var oIn2 = (sxx < 0) ? crossY(eIn, wh / 2) : crossY(wh / 2, eIn);      /* inner edge, upper vertex */
        var oOut = (sxx < 0) ? crossY(eOut, -wh / 2) : crossY(-wh / 2, eOut);
        var oOut2 = (sxx < 0) ? crossY(eOut, wh / 2) : crossY(wh / 2, eOut);
        var yInLo = Math.min(oIn, oIn2), yInHi = Math.max(oIn, oIn2), yOutLo = Math.min(oOut, oOut2), yOutHi = Math.max(oOut, oOut2);
        /* the top corners: the leg is cut on the deck, so each edge has its
           own top (legTopY side +1 = the +wh/2 edge: outer on the +x leg, inner on the -x leg) */
        var yTopOuter = (sxx > 0) ? yO : yI, yTopInner = (sxx > 0) ? yI : yO;
        var topOut = [legEdgeX(sxx, eOut, yTopOuter), yTopOuter], topIn = [legEdgeX(sxx, eIn, yTopInner), yTopInner];
        /* full-length piece (with the pocket) */
        var full = [[legEdgeX(sxx, eOut, 0), 0]].concat(innerEdge(sxx, 0, yTopInner)).concat([topOut]);
        /* the lapped half: the piece below the diamond and the piece above it */
        var lower = [[legEdgeX(sxx, eOut, 0), 0]].concat(innerEdge(sxx, 0, yInLo)).concat([[legEdgeX(sxx, eOut, yOutLo), yOutLo]]);
        var upper = [[legEdgeX(sxx, eOut, yOutHi), yOutHi], [legEdgeX(sxx, eIn, yInHi), yInHi], topIn, topOut];
        var lapFront = (sxx < 0);                       /* leg A keeps its back half whole, leg B its front half */
        var h2 = P.leg / 2;
        var pieces = lapFront
          ? [{ pts: full, z0: -h2, z1: 0 }, { pts: lower, z0: 0, z1: h2 }, { pts: upper, z0: 0, z1: h2 }]
          : [{ pts: full, z0: 0, z1: h2 }, { pts: lower, z0: -h2, z1: 0 }, { pts: upper, z0: -h2, z1: 0 }];
        legs.push({ sx: sxx, sz: sz, z: sz * zA, len: SWING.LEG_STOCK, xTop: xt, pieces: pieces,
                    pts: [[xf - wh / 2, 0], [xf + wh / 2, 0], [legCX(sxx, yO) + wh / 2, yO], [legCX(sxx, yI) - wh / 2, yI]] });
      }
    }
    var yX = SWING.FOOT_HALF / ct;                       /* the crossing height */
    var rails = [], braces = [];
    for (sz = -1; sz <= 1; sz += 2) {
      var xr = Math.abs(legCX(1, SWING.RAIL_Y)) - wh / 2;
      rails.push({ z: sz * zA, y: SWING.RAIL_Y, half: xr + 0.045, len: 2 * xr + 0.09 });
      /* knee braces 2.04 along the beam: from the leg (at yBB - 0.35) to the
         beam underside 0.30 inboard, one on each face of the beam. v251
         (Marek: "musi byt serizle presne podle profilu, na kterem konci"):
         the ends CUT to what they meet -- plumb on the leg's inner face, level
         on the beam's side half way up it (screwed to it) -- drawn as that
         polygon in the y-z plane; billed at the long point. */
      for (sxx = -1; sxx <= 1; sxx += 2) {
        var zb0 = sz * (zA - P.leg / 2), yb0 = yBB - 0.33;
        var zb1 = sz * (zA - 0.36), yb1 = yBB;
        var bl = Math.sqrt((zb1 - zb0) * (zb1 - zb0) + (yb1 - yb0) * (yb1 - yb0));
        var dzb = (zb1 - zb0) / bl, dyb = (yb1 - yb0) / bl, nzb = -dyb, nyb = dzb, hb = P.braceW / 2;
        var yCut = yBB + P.beamH / 2, bpts = [], bk, longB = 0;
        for (bk = -1; bk <= 1; bk += 2) {
          var ez = zb0 + bk * nzb * hb, ey = yb0 + bk * nyb * hb;           /* this edge's line: (ez, ey) + t (dzb, dyb) */
          var tLeg = (zb0 - ez) / dzb, tTop = (yCut - ey) / dyb;
          var pA = [ez + tLeg * dzb, ey + tLeg * dyb], pB = [ez + tTop * dzb, ey + tTop * dyb];
          if (bk < 0) bpts.push(pA, pB); else bpts.push(pB, pA);
          longB = Math.max(longB, tTop - tLeg);
        }
        braces.push({ z0: zb0, y0: yb0, z1: zb1, y1: yb1, x: sxx * (P.beamW / 2 + P.braceT / 2),
                      pts: bpts, axisLen: bl, len: longB });
      }
    }
    var roof = noRoof ? null : _swingRoofLayout(s, P, beamLen, legs, zA, roofRun);
    var depth = 2 * (SWING.FOOT_HALF + wh / 2);
    if (roof) depth = Math.max(depth, 2 * (roofRun + 0.05));
    return { beamBot: yBB, beamTop: yBT, beamLen: beamLen, zA: zA, wh: wh, legs: legs, yX: yX, rails: rails, braces: braces,
             roof: roof, roofRun: roofRun, depth: depth, height: roof ? Math.max(SWING.LEG_TOP, roof.topY) : SWING.LEG_TOP };
  }

  /* ------------------------------------------------------------------
     TYPE 7 -- PORCH SWING (Marek 2026-10-13: a swing like the park bench,
     hung under a beam / under the roof). The park bench's 2x4 seat
     (KVH10060, 38 x 89; the same boards flat on top) on chains:
       - seat frame: two side rails the full depth, front + back rails
         between them, joists ~0.40 o.c.; 5 planks flat across the depth
       - arms: a 2x4 post outside each side rail at the front and at the
         back (M10 bolts FAT10002; at the front the eye bolt is the second
         one), a flat 2x4 armrest on the posts
       - back: its own 2x4 frame (stiles, rails, stretchers in line with
         the seat joists) with 6 planks, hinged at the seat's back top edge
         and held by the rear chains: the tilt slider swings it from 15 deg
         to 90 deg = flat, a bed with the seat (the mattress comes on there,
         as on the Hollywood swing). The 2 strap hinges have no catalogue
         row yet: NOT BILLED, logged.
       - hanging: per side a V of two chains (FAT00004) from the front eye
         bolt (arm post) and the rear eye bolt (near the top of the back
         stile) to one swing hanger (FAT00002, 2 x 6x160 FAS60160) in the
         beam, over the middle of the two eyes
       - the beam is the porch's own (drawn as context, not billed); its
         underside height is the height handle, 1.90 .. 3.60 m.
     X = depth (front +), Y = up, Z = width. _porchLayout(STATE) is the
     single source: the renderer draws it, the BoQ sums it. */
  var PORCH = {
    L_MIN: 0.90, L_MAX: 1.80, L_DEFAULT: 1.22,   /* 1 .. 3 seats */
    H_MIN: 1.90, H_MAX: 3.60, H_DEF: 2.44,       /* the beam underside above the floor */
    BACK_DEF: 20, BACK_MAX: 50,                  /* v261: up to Recline (bands: Recline 37-51) */
    SEAT_TOP: 0.45,
    SEAT_PLANKS: 5, BACK_PLANKS: 6, GAP: 0.010,
    JOIST_SP: 0.40,
    ARM_UP: 0.24,          /* armrest top above the seat */
    ARM_OVER: 0.03,        /* armrest beyond the front */
    EYE_DOWN: 0.06,        /* rear eye from the top end of the back */
    EYE_OUT: 0.025,
    CHAIN_SPARE: 0.15,     /* per chain: to level the seat / reset the recline */
    BEAM_W: 0.10, BEAM_H: 0.20, BEAM_OVER: 0.30,
    CUSHION_T: 0.08,
    FRAME_CODE: 'KVH10060',
    BOLT_CODE: 'FAT10002',     /* M10 x 130 with nut + washers */
    DECK_SCREW: 'FAS50060',    /* 5 x 60: planks, 2 per bearer */
    FRAME_SCREW: 'FAS80100',   /* 8 x 100: rail and joist ends, 2 each */
    ARM_SCREW: 'FAS60100',     /* 6 x 100: armrest into the post tops, 2 each */
    ARM_BACK_SCREW: 'FAS45070', ARM_BACK_LEN: 0.070,   /* v307 4.5 x 70 stainless: the armrest into the back stile, 2 a side */
    BRACE_MAX: 60              /* v307 up to this tilt the armrest braces the back (T8 / T13 stop at 50) */
  };
  function _porchH(s) {
    var h = +((s || STATE).porchH);
    if (!isFinite(h) || h <= 0) h = PORCH.H_DEF;
    return Math.max(PORCH.H_MIN, Math.min(PORCH.H_MAX, h));
  }
  /* opt.H = the hanging height (the beam underside) instead of
     STATE.porchH; opt.ringAt0 = the hangers at x = 0 (under a stand's beam)
     instead of the footprint centred on x = 0 */
  function _porchLayout(s, opt) {
    s = s || STATE;
    var pr = _lumber({ lvl: 1 }), t = pr.t, w = pr.w, pw = pr.plankW, pt = pr.plankT, g = PORCH.GAP, i, sz;
    var L = Math.max(PORCH.L_MIN, Math.min(PORCH.L_MAX, (+s.L) || PORCH.L_DEFAULT));
    var H = (opt && opt.H) || _porchH(s);
    var D = PORCH.SEAT_PLANKS * pw + (PORCH.SEAT_PLANKS - 1) * g;
    var seatTop = PORCH.SEAT_TOP, frameBot = seatTop - pt - w, frameY = seatTop - pt - w / 2;
    var boxes = [];   /* axis-aligned pieces: kind, centre, size along x / y / z, cut length */
    function box(kind, x, y, z, sx, sy, szz, len, id) { boxes.push({ kind: kind, x: x, y: y, z: z, sx: sx, sy: sy, sz: szz, len: len, id: id }); }
    /* SEAT FRAME: side rails the full depth, front + back rails between */
    var sideZ = L / 2 - t / 2;
    box('frame', 0, frameY, -sideZ, D, w, t, D, 'side-rail-l');
    box('frame', 0, frameY,  sideZ, D, w, t, D, 'side-rail-r');
    box('frame',  D / 2 - t / 2, frameY, 0, t, w, L - 2 * t, L - 2 * t, 'front-rail');
    box('frame', -D / 2 + t / 2, frameY, 0, t, w, L - 2 * t, L - 2 * t, 'back-rail');
    var span = L - 2 * t, nJ = Math.max(0, Math.round(span / PORCH.JOIST_SP) - 1), jz = [];
    for (i = 0; i < nJ; i++) {
      jz.push(-span / 2 + span * (i + 1) / (nJ + 1));
      box('joist', 0, frameY, jz[i], D - 2 * t, w, t, D - 2 * t, 'joist-' + (i + 1));
    }
    for (i = 0; i < PORCH.SEAT_PLANKS; i++) box('seat', -D / 2 + pw / 2 + i * (pw + g), seatTop - pt / 2, 0, pw, pt, L, L, 'seat-plank-' + (i + 1));
    /* v307 the back's tilt, needed by the armrests: up to BRACE_MAX they
       run back and brace it */
    var beta = _swingBack(s), br = beta * Math.PI / 180, sb = Math.sin(br), cb = Math.cos(br), braced = beta <= PORCH.BRACE_MAX;
    /* ARMS: posts outside the side rails, the armrest flat on top */
    var armTop = seatTop + PORCH.ARM_UP, postLen = armTop - pt - frameBot, postZ = L / 2 + t / 2, armL = D + PORCH.ARM_OVER;
    var bolts = [], eyeF = [];
    for (sz = -1; sz <= 1; sz += 2) {
      var sfx = (sz > 0) ? '-r' : '-l', xF = D / 2 - w / 2, xB = -D / 2 + w / 2;
      box('armpost', xF, frameBot + postLen / 2, sz * postZ, w, postLen, t, postLen, 'arm-post-front' + sfx);
      box('armpost', xB, frameBot + postLen / 2, sz * postZ, w, postLen, t, postLen, 'arm-post-back' + sfx);
      if (!braced) box('arm', PORCH.ARM_OVER / 2, armTop - pt / 2, sz * (L / 2 + t - pw / 2), armL, pt, pw, armL, 'armrest' + sfx);
      bolts.push({ x: xF, y: frameY - 0.025, z: sz * (L / 2 + t) });                                   /* front: a bolt + the eye bolt */
      bolts.push({ x: xB - 0.022, y: frameY, z: sz * (L / 2 + t) }, { x: xB + 0.022, y: frameY, z: sz * (L / 2 + t) });
      eyeF.push({ x: xF, y: frameY + 0.02, z: sz * (L / 2 + t + PORCH.EYE_OUT), face: sz * (L / 2 + t) });
    }
    /* BACK: hinged at the seat's back top edge (the plank face line); u
       runs up the back from the hinge, v is its normal toward the sitter. */
    var hx = -D / 2 - g / 2, hy = seatTop, u0 = g / 2;
    var B = PORCH.BACK_PLANKS * pw + (PORCH.BACK_PLANKS - 1) * g;
    function P(u, v) { return { x: hx - u * sb + v * cb, y: hy + u * cb + v * sb }; }
    var tilted = [];  /* back pieces: centre, size along v / u / z */
    function tb(kind, u, v, du, dv, z, dz, len, id) { var c = P(u, v); tilted.push({ kind: kind, x: c.x, y: c.y, z: z, sv: dv, su: du, sz: dz, len: len, id: id }); }
    var vF = -pt - w / 2;   /* the back frame's centre plane, behind the planks */
    tb('backframe', u0 + B / 2, vF, B, w, -sideZ, t, B, 'back-stile-l');
    tb('backframe', u0 + B / 2, vF, B, w,  sideZ, t, B, 'back-stile-r');
    tb('backframe', u0 + t / 2, vF, t, w, 0, L - 2 * t, L - 2 * t, 'back-rail-bottom');
    tb('backframe', u0 + B - t / 2, vF, t, w, 0, L - 2 * t, L - 2 * t, 'back-rail-top');
    for (i = 0; i < nJ; i++) tb('backframe', u0 + B / 2, vF, B - 2 * t, w, jz[i], t, B - 2 * t, 'back-stretcher-' + (i + 1));
    for (i = 0; i < PORCH.BACK_PLANKS; i++) tb('back', u0 + pw / 2 + i * (pw + g), -pt / 2, pw, pt, 0, L, L, 'back-plank-' + (i + 1));
    var hingeZ = Math.max(0.10, L / 2 - 0.15), hinges = [{ x: hx, y: hy, z: -hingeZ }, { x: hx, y: hy, z: hingeZ }];
    /* v307 THE ARMREST BRACES THE BACK (Marek 18:30: "se sedaci casti ma
       jen spoj pres hranu ... mela by tak fungovat asi podrucka"; chose: the
       armrest holds it, the tilt 15-50 set when building). The flat 2x4
       armrest runs on over the rear post to the back: its inner part (over
       the seat, z from the armrest's inner edge to the stile's outer face)
       cut along the back's plank face, its outer part (the posts' 38 mm)
       on alongside the stile's outer face to the back's rear face, both
       cuts along the tilt -- one board, notched. 2 x 4.5x70 stainless
       through that outer part into the stile at the armrest's mid-height:
       seat frame, post, armrest and back make a triangle, the hinge only
       turns until they are in. Billed at the board's long (top) edge. */
    var armPolys = [];
    if (braced) {
      var tnb = sb / cb, yAB = armTop - pt, yAM = armTop - pt / 2, xFr = D / 2 + PORCH.ARM_OVER, vR = -pt - w;
      var xv = function (y, v) { return hx - (y - hy) * tnb + v / cb; };   /* the back's line v (0 = the plank face) at height y */
      for (sz = -1; sz <= 1; sz += 2) {
        var sfa = (sz > 0) ? '-r' : '-l', zO = L / 2 + t, zI = L / 2 + t - pw;
        armPolys.push({ kind: 'arm', id: 'armrest' + sfa, len: Math.ceil((xFr - xv(armTop, vR)) * 1000) / 1000, parts: [
          { poly: [[xFr, yAB], [xFr, armTop], [xv(armTop, 0), armTop], [xv(yAB, 0), yAB]], c: sz * (zI + L / 2) / 2, t: L / 2 - zI },
          { poly: [[xFr, yAB], [xFr, armTop], [xv(armTop, vR), armTop], [xv(yAB, vR), yAB]], c: sz * (L / 2 + t / 2), t: t }
        ] });
      }
    }
    /* v300 THE SEAT'S SCREWS, drawn = billed (Marek: "dalsi krok, at to
       sedi"): a list the renderer draws and _porchSeatBoQ counts.
       - frame 8x100: 2 through each side rail into the front / back rail
         ends, 2 through the front / back rail into each joist end;
       - planks 5x60: 2 a plank a bearer, from the top (seat) / from the
         face (back);
       - back frame 8x100: 2 through each stile into the bottom / top rail
         ends, 2 through those rails into each stretcher end;
       - armrests 6x100: 2 into each post top. */
    var screws = [], yA = frameY - w / 4, yB = frameY + w / 4, j, k;
    function scr(part, code, x, y, z, d, len, r, id) { screws.push({ part: part, code: code, x: x, y: y, z: z, dir: d, len: len, r: r, id: id }); }
    function sF(x, y, z, d, id) { scr('porch-hw-screw-frame', PORCH.FRAME_SCREW, x, y, z, d, 0.10, 0.004, id); }
    for (sz = -1; sz <= 1; sz += 2) {
      [D / 2 - t / 2, -D / 2 + t / 2].forEach(function (xr, k) { sF(xr, yA, sz * L / 2, [0, 0, -sz], 'rail-' + k); sF(xr, yB, sz * L / 2, [0, 0, -sz], 'rail-' + k); });
    }
    for (i = 0; i < nJ; i++) for (sz = -1; sz <= 1; sz += 2) { sF(sz * D / 2, yA, jz[i], [-sz, 0, 0], 'joist-' + i); sF(sz * D / 2, yB, jz[i], [-sz, 0, 0], 'joist-' + i); }
    var bearZ = [-sideZ, sideZ].concat(jz);
    for (i = 0; i < PORCH.SEAT_PLANKS; i++) {
      var xc = -D / 2 + pw / 2 + i * (pw + g);
      for (j = 0; j < bearZ.length; j++) for (k = -1; k <= 1; k += 2) scr('porch-hw-screw-deck', PORCH.DECK_SCREW, xc + k * pw / 4, seatTop, bearZ[j], [0, -1, 0], 0.06, 0.0025, 'seat-' + i);
    }
    var dU = [-sb, cb, 0], dV = [-cb, -sb, 0];   /* up the back; into the back (away from the sitter) */
    function sB(part, code, u, v, z, d, len, r, id) { var c = P(u, v); scr(part, code, c.x, c.y, z, d, len, r, id); }
    for (i = 0; i < PORCH.BACK_PLANKS; i++) {
      var uc = u0 + pw / 2 + i * (pw + g);
      for (j = 0; j < bearZ.length; j++) for (k = -1; k <= 1; k += 2) sB('porch-hw-screw-backdeck', PORCH.DECK_SCREW, uc + k * pw / 4, 0, bearZ[j], dV, 0.06, 0.0025, 'back-' + i);
    }
    for (sz = -1; sz <= 1; sz += 2) [u0 + t / 2, u0 + B - t / 2].forEach(function (ur, k2) {
      for (var m = -1; m <= 1; m += 2) sB('porch-hw-screw-backframe', PORCH.FRAME_SCREW, ur, vF + m * w / 4, sz * L / 2, [0, 0, -sz], 0.10, 0.004, 'brail-' + k2);
    });
    for (i = 0; i < nJ; i++) for (k = -1; k <= 1; k += 2) {
      sB('porch-hw-screw-backframe', PORCH.FRAME_SCREW, u0, vF + k * w / 4, jz[i], dU, 0.10, 0.004, 'stretch-' + i);
      sB('porch-hw-screw-backframe', PORCH.FRAME_SCREW, u0 + B, vF + k * w / 4, jz[i], [-dU[0], -dU[1], 0], 0.10, 0.004, 'stretch-' + i);
    }
    for (sz = -1; sz <= 1; sz += 2) [D / 2 - w / 2, -D / 2 + w / 2].forEach(function (xp, k3) {
      for (var m = -1; m <= 1; m += 2) scr('porch-hw-screw-arm', PORCH.ARM_SCREW, xp + m * w / 4, armTop, sz * postZ, [0, -1, 0], 0.10, 0.003, 'arm-' + k3);
    });
    if (braced) for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2)   /* v307 the armrest into the stile, side by side across it */
      scr('porch-hw-screw-armback', PORCH.ARM_BACK_SCREW, xv(yAM, -pt - w / 2 + k * w / 4), yAM, sz * (L / 2 + t), [0, 0, -sz], PORCH.ARM_BACK_LEN, 0.00225, 'armback-' + (sz < 0 ? 'l' : 'r'));
    /* HANGING: the rear eyes near the top of the stiles, a V per side to
       one hanger over the middle of the two eyes */
    var pe = P(u0 + B - PORCH.EYE_DOWN, vF), eyeR = [], hangers = [], chains = [];
    var ringX = (eyeF[0].x + pe.x) / 2, ringY = H - SWING.HANGER_DROP;
    for (i = 0; i < 2; i++) {
      sz = (i === 0) ? -1 : 1;
      eyeR.push({ x: pe.x, y: pe.y, z: sz * (L / 2 + PORCH.EYE_OUT), face: sz * L / 2 });
      var hg = { x: ringX, y: ringY, z: sz * (L / 2 + t / 2 + PORCH.EYE_OUT) };
      hangers.push(hg);
      var ends = [eyeF[i], eyeR[i]], e;
      for (e = 0; e < 2; e++) {
        var a = ends[e], dx = hg.x - a.x, dy = hg.y - a.y, dz = hg.z - a.z;
        chains.push({ a: { x: a.x, y: a.y, z: a.z }, b: { x: hg.x, y: hg.y, z: hg.z }, len: Math.sqrt(dx * dx + dy * dy + dz * dz), rear: e === 1 });
      }
    }
    /* the mattress: a seat pad + a back pad (one folding mattress); flat
       they make the bed */
    var cushion = _swingCushionOn(s), CT = PORCH.CUSHION_T, padW = braced ? L - 2 * (pw - t) - 0.01 : L - 0.02;   /* v307 between the armrests */
    var pads = cushion ? {
      seat: { x: 0, y: seatTop + CT / 2, sx: D, sy: CT, sz: padW },
      back: (function () { var ua = u0 + CT * cb, c = P((ua + u0 + B) / 2, CT / 2); return { x: c.x, y: c.y, sv: CT, su: u0 + B - ua, sz: padW }; })()
    } : null;
    /* extents */
    var xMin = -D / 2, xMax = D / 2 + PORCH.ARM_OVER, cs = [[u0, 0], [u0, -pt - w], [u0 + B, 0], [u0 + B, -pt - w]];
    for (i = 0; i < cs.length; i++) { var cp = P(cs[i][0], cs[i][1]); if (cp.x < xMin) xMin = cp.x; }
    /* centre the footprint on x = 0 (the dimension lines are drawn about
       the origin): the whole swing shifts as the back tilts */
    var off = (opt && opt.ringAt0) ? -ringX : -(xMin + xMax) / 2, shx = function (o) { o.x += off; };
    boxes.forEach(shx); tilted.forEach(shx); bolts.forEach(shx); hinges.forEach(shx); screws.forEach(shx);
    eyeF.forEach(shx); eyeR.forEach(shx); hangers.forEach(shx);
    for (i = 0; i < chains.length; i++) { chains[i].a.x += off; chains[i].b.x += off; }
    if (pads) { pads.seat.x += off; pads.back.x += off; }
    armPolys.forEach(function (a) { a.parts.forEach(function (pp) { pp.poly.forEach(function (q) { q[0] += off; }); }); });
    ringX += off; hx += off; xMin += off; xMax += off;
    var frameM = 0, plankM = 0;
    for (i = 0; i < boxes.length; i++) { if (boxes[i].kind === 'seat') plankM += boxes[i].len; else frameM += boxes[i].len; }
    for (i = 0; i < tilted.length; i++) { if (tilted[i].kind === 'back') plankM += tilted[i].len; else frameM += tilted[i].len; }
    for (i = 0; i < armPolys.length; i++) frameM += armPolys[i].len;   /* v307 the braced armrests */
    return {
      L: L, H: H, D: D, B: B, beta: beta, betaRad: br, seatTop: seatTop, frameY: frameY, armTop: armTop,
      nJ: nJ, boxes: boxes, tilted: tilted, armPolys: armPolys, braced: braced, bolts: bolts, hinges: hinges, screws: screws, hingeX: hx, hingeY: hy,
      eyeF: eyeF, eyeR: eyeR, hangers: hangers, chains: chains, ringX: ringX, cushion: cushion, pads: pads,
      beam: { x: ringX, y: H + PORCH.BEAM_H / 2, sx: PORCH.BEAM_W, sy: PORCH.BEAM_H, sz: L + 2 * t + 2 * PORCH.BEAM_OVER },
      xMin: xMin, xMax: xMax, depth: xMax - xMin, seatFront: D / 2 + off, off: off, frameM: frameM, plankM: plankM, sec: { t: t, w: w }
    };
  }
  /* STAGED ASSEMBLY of the porch swing: frame, seat, arms, back, hanging,
     the mattress (only when it is on). */
  /* v300: every group, then the screws that fix it (the picnic recipe) */
  var PORCH_SEAT_STEPS = [
    { parts: ['porch-frame', 'porch-joist'], codes: ['KVH10060'] },
    { parts: ['porch-hw-screw-frame'], codes: ['FAS80100'] },
    { parts: ['porch-seat'], codes: ['KVH10060'] },
    { parts: ['porch-hw-screw-deck'], codes: ['FAS50060'] },
    { parts: ['porch-armpost', 'porch-hw-bolt'], codes: ['KVH10060', 'FAT10002'] },
    { parts: ['porch-backframe'], codes: ['KVH10060'] },
    { parts: ['porch-hw-screw-backframe'], codes: ['FAS80100'] },
    { parts: ['porch-back'], codes: ['KVH10060'] },
    { parts: ['porch-hw-screw-backdeck'], codes: ['FAS50060'] },
    { parts: ['swing-hw-hinge'], codes: ['FAT00022'] },
    { parts: ['porch-arm'], codes: ['KVH10060'] },                                          /* v307 the armrests after the back: they brace it */
    { parts: ['porch-hw-screw-arm', 'porch-hw-screw-armback'], codes: ['FAS60100', 'FAS45070'] },
    { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-shank', 'swing-hw-eye', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: ['FAT00002', 'FAT00003', 'FAT00004'] }
  ];
  var PORCH_STEPS = [{ parts: [], codes: [] }].concat(PORCH_SEAT_STEPS).concat([{ parts: ['cushion'], codes: ['FOU00016'] }]);
  var _porchLogKey = '';

  /* PORCH SWING STYLE (Marek 2026-10-14: "spise ve stylu bench varianta 3,
     ale ne tak masivni profil, bez moznosti sklopit operadlo -- zapamatuj si
     tu puvodni, mozna to vratime"). 'sofa' = type 7 is the storefront's
     sofa (variant 3) hung on chains: a box frame of lighter 2x3 / 2x4
     (KVH08060, 60x80 / 1 1/2 x 3 1/2) posts and rails, a slatted platform on
     ledgers, the sofa's mattress cushions and pillows, no back tilt.
     'bench' = the ORIGINAL type 7 (bench-v244..v248): the park bench seat
     with arms and a hinged back down to a bed -- _porchLayout, still used by
     the A-frame swing (type 8). Set STYLE7 back to 'bench' to return it. */
  /* v278: 'classic' = Marek's photo (2026-10-19, "ne jako klon sofa"):
     _porchClassicLayout below. 'sofa' (v249-v277) and 'bench' (v244-v248)
     stay in the code -- set STYLE7 back to either to return it. */
  PORCH.STYLE7 = 'classic';
  function _porchStyle(s) {
    if (((s || STATE).variant | 0) === 17) return 'classic';   /* v296 the pergola swing hangs the classic seat */
    if (((s || STATE).variant | 0) !== 7) return 'bench';
    return (PORCH.STYLE7 === 'sofa' || PORCH.STYLE7 === 'classic') ? PORCH.STYLE7 : 'bench';
  }
  var PSOFA = {
    L_MIN: 1.00, L_MAX: 2.10, L_DEFAULT: 1.60,
    DEPTH: 0.70,
    FRAME_BOT: 0.27,      /* the seat box underside above the floor (hung) */
    /* v269 (Marek: 2 - konstrukci stejne jako sofa, i napojeni profilu v
       rozich; prurez profilu ctverec, o palec mensi nez sofa; editace vysky
       operadla -- jeden operny profil, pri zvyseni dva = drag point vysky,
       skoncit, kdyz se vytvori druha rada; stejny montazni postup, typy
       spoju; animace: lavice, retezy, oka, pak tramy z vrchu): the sofa's
       frame in a 3x3 (KVH08080, 80 x 80 / US 2 1/2 in., the sofa's 4x4 one
       inch down); the back = the top rail's top above the seat box top, on
       the back drag point: one back rail up to BACK_ONE, then the middle
       row comes in (both openings equal) and the drag ends at BACK_MAX */
    BACK_MIN: 0.20, BACK_ONE: 0.32, BACK_MAX: 0.48, BACK_DEF: 0.48,
    CODE: 'KVH08080', LEDGER_CODE: 'KVH03838', ROST_CODE: 'TIM20100',
    SCREW: 'FAS50060', DOWEL: 'FAT00006'
  };
  /* the profile (square post / rail), the 2x2 ledger, the 1x4 platform board */
  function _psofaProf(s) {
    if ((s || STATE).isMetric === false) return { P: 0.0635, ld: 0.0381, rt: 0.01905, rw: 0.0889 };
    return { P: 0.080, ld: 0.038, rt: 0.020, rw: 0.100 };
  }
  function _psofaBack(s) {
    var b = +((s || STATE).psofaBack);
    if (!isFinite(b) || b <= 0) b = PSOFA.BACK_DEF;
    return Math.max(PSOFA.BACK_MIN, Math.min(PSOFA.BACK_MAX, b));
  }
  /* v269: the porch swing's frame for _sofaFrame (the same members, joints
     and platform as the sofa, the posts from the seat box underside -- it
     hangs), its cushions, the hanging and the beam; the bill reads it */
  /* v301 opt (the modern swing, type 18): H = the hanging height (the
     middle frame's beam underside), hangerScrew = the hangers' screws */
  function _porchSofaLayout(s, opt) {
    s = s || STATE;
    var Pr = _psofaProf(s), P = Pr.P, i, sz;
    var L = Math.max(PSOFA.L_MIN, Math.min(PSOFA.L_MAX, (+s.L) || PSOFA.L_DEFAULT));
    var H = (opt && opt.H) || _porchH(s), W = PSOFA.DEPTH, hL = L / 2, hW = W / 2;
    var yB = PSOFA.FRAME_BOT, seatTop = yB + P, back = _psofaBack(s), top = seatTop + back;
    var lvl2 = back > PSOFA.BACK_ONE + 1e-6, mid = lvl2 ? seatTop + back / 2 : null;   /* the middle rail's top: two equal openings */
    var innerL = L - 2 * P, innerW = W - 2 * P, postH = top - P - yB;
    /* the platform as the sofa's: 2x2 ledgers inside the long rails, the
       boards loose on them a little below the rails' top (the ledger kept
       inside the rail's depth) */
    var clr = Math.max(0, Math.min(0.0127, P - Pr.rt - Pr.ld - 0.004)), ledTop = seatTop - clr - Pr.rt;
    var ledN = Math.max(2, Math.floor(innerL / 0.30) + 1);
    var rcc = Pr.rw + SOFA.ROST_GAP, rSpan = Math.max(Pr.rw, innerL - Pr.rw), rN = Math.max(2, Math.floor(rSpan / rcc) + 1);
    /* the corner joints, 3 dowels + 2 pocket screws each (as the sofa):
       top back rail 2, top end rails 4, the seat box 8, the middle row 6 */
    var frameJoints = 2 + 4 + 8 + (lvl2 ? 6 : 0);
    var frameM = 4 * postH + innerL + 2 * W + 2 * innerL + 2 * innerW + (lvl2 ? innerL + 2 * innerW : 0);
    /* cushions: the sofa's split (one per 80 cm), the full depth on the seat box */
    var cushion = _swingCushionOn(s), matN = Math.max(1, Math.floor((L * 100) / (SOFA.MAT_SPLIT * 100)));
    var pillowN = cushion ? Math.max(1, Math.round(L / SOFA.PILLOW_PER)) : 0;
    /* hanging: the front eye bolts in the front posts' end faces at the seat
       box, the rear ones in the top end rails at the back (v270), a V per
       end to one hanger over the middle */
    var eo = PORCH.EYE_OUT, eyeF = [], eyeR = [], hangers = [], chains = [], yLo = seatTop - P / 2;
    for (i = 0; i < 2; i++) {
      sz = i ? 1 : -1;
      eyeF.push({ x: hW - P / 2, y: yLo, z: sz * (hL + eo), face: sz * hL });
      /* v270 (Marek: ukotveni na retez vzadu na hornim profilu, oko smeruje
         do boku): the rear eye bolt in the top end rail's outer side face,
         over the back post (beside the joint's middle dowel), its shank and
         eye pointing out to the side */
      eyeR.push({ x: -hW + P * 0.64, y: top - P / 2, z: sz * (hL + eo), face: sz * hL });
      var hg = { x: 0, y: H - SWING.HANGER_DROP, z: sz * (hL + eo) };
      hangers.push(hg);
      var ends = [eyeF[i], eyeR[i]], e;
      for (e = 0; e < 2; e++) {
        var a = ends[e], dx = hg.x - a.x, dy = hg.y - a.y, dz = hg.z - a.z;
        chains.push({ a: { x: a.x, y: a.y, z: a.z }, b: { x: hg.x, y: hg.y, z: hg.z }, len: Math.sqrt(dx * dx + dy * dy + dz * dz), rear: e === 1 });
      }
    }
    var ledM = 2 * innerL, rostM = rN * innerW;
    var coat = frameM * 4 * P + ledM * 4 * Pr.ld + rostM * 2 * (Pr.rt + Pr.rw);
    return {
      style: 'sofa', Pr: Pr, P: P, code: PSOFA.CODE, rostCode: PSOFA.ROST_CODE, L: L, H: H, W: W,
      yB: yB, seatTop: seatTop, back: back, top: top, lvl2: lvl2, mid: mid, innerL: innerL, innerW: innerW, postH: postH,
      ledTop: ledTop, ledN: ledN, ledM: ledM, rN: rN, rostM: rostM, frameJoints: frameJoints, frameM: frameM,
      dowels: frameJoints * SOFA.DOWEL_PER_JOINT, pocketScrews: frameJoints * 2, ledgerScrews: 2 * ledN,
      cushion: cushion, matN: matN, pillowN: pillowN,
      eyeF: eyeF, eyeR: eyeR, hangers: hangers, chains: chains, ringX: 0, hangerScrew: (opt && opt.hangerScrew) || null,
      beam: { x: 0, y: H + PORCH.BEAM_H / 2, sx: PORCH.BEAM_W, sy: PORCH.BEAM_H, sz: L + 2 * PORCH.BEAM_OVER },
      coat: coat, seatFront: hW, seatTop2: seatTop + SOFA.MAT_THICK, armTop: top, backX: -hW + P / 2,
      depth: W, xMin: -hW, xMax: hW
    };
  }
  /* ------------------------------------------------------------------
     v278 THE CLASSIC PORCH SWING (type 7; Marek 2026-10-19 with his photo:
     "udelej variantu 2 v tomto provedeni, ne jako klon sofa"). In 2x4
     (KVH10060, 38 x 89 / US 1 1/2 x 3 1/2):
       - the seat frame: 2 side rails the full depth, a front + a back rail
         between them, on edge, fixed with 2 x 8x100 FAS80100 a corner
         through the side rail;
       - the seat: 1x4 planks TIM20100 flat, FRONT TO BACK on the front and
         back rails, gaps ~12 mm, 2 x 5x60 FAS50060 a plank end (v279;
         v278 had 2x2 battens KVH03838);
       - v281 THE SIDE FRAMES (Marek's second photo, 2026-10-19 18:42): a
         front and a rear post upright outside each side rail, the 2x4's
         wide face to the front (89 across, 38 deep), each bolted through
         the side rail (2 x M10 FAT10002: 89 + 38 = 127); the armrest a 2x4
         flat on both posts' tops (2 x 6x100 FAS60100 into each), 30 mm past
         the front post, 10 mm behind the rear one. (v278/v279: the reclined
         stile was the side frame's back member; the armrest hung on it.)
       - THE BACK PANEL inboard of the side frames: a 2x4 stile reclined
         12 deg standing on each side rail's back end (its base cut to sit
         on it), bolted through the rear post (2 x M10); a bottom and a top
         back rail (2x4 on edge, the stiles' full depth) between the stiles
         (2 x 8x100 a rail end through the stile, driven before the rear
         posts go on); the stile's top 25 mm over the top rail; the fill on
         the rails' axis, its ends housed in a groove ploughed along each
         rail (12 mm / US 1/2 in. deep, the fill's thickness wide), glued
         fillets between (strips ripped from a 1x4, FEC00043) -- no screw
         through the fill (v279, Marek: vypln planks v operadle zapustit v
         drazkach profilu operadla). v281 the fill on the info-bar toggle:
         1x4 PLANKS or SLATS ripped two from a 1x4; its gap on the slider
         over the toggle (10 .. 80 mm), the seat planks' gap = x 0.35;
       - hung: the front eye bolt FAT00003 near the bottom of the front
         post, the rear one in the rear post just under the armrest, a chain
         V per side to one swing hanger FAT00002 (2 x FAS60160) straight
         above in the porch beam (context, not billed; its underside = the
         height handle);
       - a seat cushion FOU00016 (the level button), a throw pillow (decor,
         NOT BILLED as the other benches').
     X = depth (front +), Y = up, Z = width; the footprint centred on x = 0.
     _porchClassicLayout(STATE) is the single source: the renderer draws
     its pieces / fasteners, the BoQ sums them. */
  var PCL = {
    L_MIN: 1.07, L_MAX: 1.83, L_DEFAULT: 1.52,       /* 3 1/2 .. 6 ft, 5 ft */
    D: 0.52, SEAT_TOP: 0.45, ARM_UP: 0.24, ARM_OVER: 0.03,
    BACK_UP: 0.52,          /* the back's top above the seat */
    RECLINE: 12,            /* the back stiles from vertical, deg */
    SLAT_GAP: 0.012, BSLAT_GAP: 0.032, BRAIL_LO: 0.07,
    GROOVE: 0.012, GROOVE_US: 0.0127,   /* v279 the back rails' groove depth (the slats' ends, the fillets) */
    GAP_MIN: 0.010, GAP_MAX: 0.080, GAP_DEF: 0.032,   /* v281 the back fill's gap (the slider over the toggle) */
    SEAT_GAP_K: 0.35, SEAT_GAP_MIN: 0.006, SEAT_GAP_MAX: 0.025,   /* the seat planks' gap = the back's x 0.35 (denser) */
    ARM_BACK_OVER: 0.010, STILE_OVER: 0.025, STILE_BOLT_H: [0.035, 0.065],   /* armrest past the rear post; stile top over the top rail; the rear post-to-stile bolts above the side rail's top */
    KERF: 0.003,                        /* the saw kerf ripping the fillet strips */
    END_CLR: 0.001,                     /* v282 the fill's play at each groove bottom (the top rail goes on without a hammer) */
    BRAD_LEN: 0.030, BRAD_LEN_US: 0.03175, BRAD_R: 0.0006,   /* v282 one 18 ga brad a fillet: 12 through it + 18 into the rail (26 under the groove) */
    BRAD: 'BRAD NAIL, STAINLESS, 18 GA x 30 MM (US 1 1/4 IN.)',   /* v282 no catalogue row: NOT BILLED, logged (status MISSING) */
    EYE_LO: 0.03, EYE_ARM: 0.06,
    CUSHION_T: 0.08,
    FRAME_CODE: 'KVH10060', SLAT_CODE: 'TIM20100', BSLAT_CODE: 'TIM20100',   /* v279 the seat planks 1x4 (v278 KVH03838 2x2) */
    SLAT_SCREW: 'FAS50060', FRAME_SCREW: 'FAS80100', ARM_SCREW: 'FAS60100', ARM_BACK_SCREW: 'FAS60160', BOLT: 'FAT10002',
    PILLOW: 'THROW PILLOW (decor)'
  };
  /* the sections: the 2x4, the 2x2 seat slat, the 1x4 back slat */
  function _pclProf(s) {
    if ((s || STATE).isMetric === false) return { t: 0.0381, w: 0.0889, st: 0.0381, rt: 0.01905, rw: 0.0889 };
    return { t: 0.038, w: 0.089, st: 0.038, rt: 0.020, rw: 0.100 };
  }
  /* v281 the back fill (the toggle): 1x4 planks or slats ripped from it;
     its gap (the slider), clamped */
  function _pclFill(s) { return ((s || STATE).porchFill === 'slats') ? 'slats' : 'planks'; }
  function _pclGap(s) { var g = +(s || STATE).porchGap; if (!(g > 0)) g = PCL.GAP_DEF; return Math.max(PCL.GAP_MIN, Math.min(PCL.GAP_MAX, g)); }
  /* v296 opt (the pergola swing, type 17): H = the hanging height (the
     rafters' underside), ringAt0 = the hangers over x = 0 (not the
     footprint centred), hangerScrew = {code, len} into a lighter member */
  function _porchClassicLayout(s, opt) {
    s = s || STATE;
    var Pr = _pclProf(s), t = Pr.t, w = Pr.w, rt = Pr.rt, rw = Pr.rw, i, k, q, sz;
    /* v298 opt.frame (the pergola swing): the seat frame, the side posts and
       the armrests in a heavier section {t, w, code}, their screws {screw,
       armScrew} and through-rods (rod.over past each face) for the posts'
       joints; the back panel stays 2x4. opt.Lmin / Lmax its own length range */
    var FR = (opt && opt.frame) || null, ft = FR ? FR.t : t, fw = FR ? FR.w : w, fcode = FR ? FR.code : PCL.FRAME_CODE;
    var Lmin = (opt && opt.Lmin) || PCL.L_MIN, Lmax = (opt && opt.Lmax) || PCL.L_MAX;
    var L = Math.max(Lmin, Math.min(Lmax, (+s.L) || PCL.L_DEFAULT)), hL = L / 2;
    var H = (opt && opt.H) ? opt.H : _porchH(s), D = PCL.D;
    var fill = _pclFill(s), gT = _pclGap(s);
    var seatTop = PCL.SEAT_TOP, frameTop = seatTop - rt, frameBot = frameTop - fw, frameY = frameTop - fw / 2;   /* v279 the 1x4 plank on the frame */
    var pieces = [], screws = [], bolts = [];
    function box(kind, code, len, id, x, y, z, sx, sy, szz, rz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, sx, sy, szz, rz || 0] }); }
    function scr(kind, code, x, y, z, d, len) { screws.push({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: len }); }
    function bolt(x, y, z, d, thick) {
      if (FR && FR.rod) { var ov = FR.rod.over; bolts.push({ x: x, y: y, z: z - d[2] * ov, dir: d, len: thick + 2 * ov, r: 0.008, rod: true }); return; }   /* v298 an M16 rod, a washer + cap nut each end */
      bolts.push({ x: x, y: y, z: z, dir: d, len: 0.13, r: 0.005 });
    }
    /* THE SEAT FRAME */
    for (sz = -1; sz <= 1; sz += 2) box('frame', fcode, D, 'side-rail' + (sz < 0 ? '-l' : '-r'), 0, frameY, sz * (hL - ft / 2), D, fw, ft);
    /* v281 the front + back rails one thickness in from the side rails'
       ends: the posts sit on the corners and their bolts pass the side
       rail clear of the rails' ends (and of these screws) */
    var xRail = D / 2 - 1.5 * ft;
    box('frame', fcode, L - 2 * ft, 'front-rail', xRail, frameY, 0, ft, fw, L - 2 * ft);
    box('frame', fcode, L - 2 * ft, 'back-rail', -xRail, frameY, 0, ft, fw, L - 2 * ft);
    for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2) for (i = -1; i <= 1; i += 2) {
      if (FR) scr('frame', FR.screw.code, k * xRail, frameTop - 0.045 - (fw - 0.045) * ((i < 0) ? 0.22 : 0.65), sz * hL, [0, 0, -sz], FR.screw.len);   /* v298 the deeper frame: spread down it, clear of the plank screws */
      else scr('frame', PCL.FRAME_SCREW, k * xRail, frameTop - 0.0625 + i * 0.0125, sz * hL, [0, 0, -sz], 0.10);   /* through the side rail into the rail's end, under the plank screws' tips (-40 mm) */
    }
    /* THE SEAT: 1x4 planks flat, front to back on the front + back rails,
       the gaps equal (the side rails too), 2 screws a plank end; v281 the
       gap follows the back's spacing slider, denser (x SEAT_GAP_K) */
    var span = L - 2 * ft, gSt = Math.max(PCL.SEAT_GAP_MIN, Math.min(PCL.SEAT_GAP_MAX, gT * PCL.SEAT_GAP_K));
    var nS = Math.max(4, Math.round((span - gSt) / (rw + gSt))), gS = (span - nS * rw) / (nS + 1), seatM = 0;
    for (i = 0; i < nS; i++) {
      var zs = -span / 2 + gS + rw / 2 + i * (rw + gS);
      box('slat', PCL.SLAT_CODE, D, 'seat-plank-' + (i + 1), 0, frameTop + rt / 2, zs, D, rt, rw);
      seatM += D;
      for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) scr('slat', PCL.SLAT_SCREW, k * xRail, seatTop, zs + q * rw / 4, [0, -1, 0], 0.06);   /* 20 through the plank + 40 into the rail */
    }
    /* v281 THE SIDE FRAMES (Marek's photo): a front and a rear post upright
       outside each side rail, the 2x4's wide face to the front (89 across,
       38 deep), each bolted through the side rail (2 x M10: 89 + 38 = 127);
       the armrest a 2x4 flat on both posts' tops (2 x 6x100 into each),
       30 mm past the front post, 10 mm behind the rear one */
    var armTop = seatTop + PCL.ARM_UP, armBot = armTop - ft, postH = armBot - frameBot, zp = hL + fw / 2, zOut = hL + fw;
    var xPF = D / 2 - ft / 2, xPR = -D / 2 + ft / 2;
    for (sz = -1; sz <= 1; sz += 2) {
      var sfx = (sz < 0) ? '-l' : '-r';
      box('post', fcode, postH, 'front-post' + sfx, xPF, frameBot + postH / 2, sz * zp, ft, postH, fw);
      box('post', fcode, postH, 'rear-post' + sfx, xPR, frameBot + postH / 2, sz * zp, ft, postH, fw);
      for (i = -1; i <= 1; i += 2) {
        bolt(xPF, frameY + i * fw / 4, sz * zOut, [0, 0, -sz], fw + ft);                           /* the front post to the side rail */
        bolt(xPR, frameY + i * fw / 4, sz * zOut, [0, 0, -sz], fw + ft);                           /* the rear post to the side rail */
      }
    }
    /* THE BACK PANEL (inboard of the side frames): a reclined stile on each
       side rail's back end (its base cut to sit on it), bolted through the
       rear post (2 x M10); two rails on edge between the stiles; the fill
       (v281 planks or slats ripped from the 1x4) on the rails' axis, its
       ends housed in a groove along each rail, glued fillets between */
    var r = PCL.RECLINE * Math.PI / 180, sr = Math.sin(r), cr = Math.cos(r);
    var yb = frameTop - (w / 2) * sr, xb = -D / 2 + (w / 2) * cr;                 /* the base's front corner on the side rail top, its back corner at the frame's back */
    var backTop = seatTop + PCL.BACK_UP, Ls = (backTop - yb) / cr, zs0 = hL - t / 2;
    function P(u, v) { return { x: xb - u * sr + v * cr, y: yb + u * cr + v * sr }; }
    function uAt(y, v) { return (y - yb - v * sr) / cr; }
    for (sz = -1; sz <= 1; sz += 2) {
      var cS = P(Ls / 2, 0);
      box('stile', PCL.FRAME_CODE, Ls, 'back-stile' + (sz < 0 ? '-l' : '-r'), cS.x, cS.y, sz * zs0, w, Ls, t, r);
      for (i = 0; i < PCL.STILE_BOLT_H.length; i++) bolt(xPR, frameTop + PCL.STILE_BOLT_H[i], sz * zOut, [0, 0, -sz], fw + t);   /* the rear post to the stile */
    }
    var vr = 0, GD = (s.isMetric === false) ? PCL.GROOVE_US : PCL.GROOVE, Lin = L - 2 * t;
    var uB = uAt(seatTop + PCL.BRAIL_LO, vr) + t / 2, uT = Ls - PCL.STILE_OVER - t / 2;
    var rails = [{ u: uB, id: 'back-rail-bottom', kind: 'backrail-lo', uF: uB + t / 2 - GD / 2 }, { u: uT, id: 'back-rail-top', kind: 'backrail-hi', uF: uT - t / 2 + GD / 2 }];
    for (k = 0; k < rails.length; k++) {
      var cR = P(rails[k].u, vr);
      box(rails[k].kind, PCL.FRAME_CODE, Lin, rails[k].id, cR.x, cR.y, 0, w, t, Lin, r);
      for (sz = -1; sz <= 1; sz += 2) for (i = -1; i <= 1; i += 2) {
        var pr2 = P(rails[k].u, i * w / 4);
        scr(rails[k].kind, PCL.FRAME_SCREW, pr2.x, pr2.y, sz * hL, [0, 0, -sz], 0.10);          /* through the stile into the rail's end (before the rear posts go on) */
      }
    }
    var wS = (fill === 'slats') ? (rw - PCL.KERF) / 2 : rw;                       /* a slat = half a 1x4 */
    var u0 = uB + t / 2 - GD + PCL.END_CLR, u1 = uT - t / 2 + GD - PCL.END_CLR, bLen = u1 - u0;   /* groove bottom to groove bottom, v282 less 1 mm play at each end */
    var nB = Math.max(3, Math.round((Lin - gT) / (wS + gT))), gB = (Lin - nB * wS) / (nB + 1);
    var perLen = (fill === 'slats') ? bLen * Math.ceil(nB / 2) / nB : bLen;      /* the board each takes (2 slats a board) */
    var cB = P((u0 + u1) / 2, 0);
    for (i = 0; i < nB; i++) {
      var zb = -Lin / 2 + gB + wS / 2 + i * (wS + gB);
      box('backslat', PCL.BSLAT_CODE, perLen, 'back-' + (fill === 'slats' ? 'slat-' : 'plank-') + (i + 1), cB.x, cB.y, zb, rt, bLen, wS, r);
    }
    /* the fillets: rt x GD x gap, ripped from a 1x4 (nStrip strips a
       board width) -- billed as the board length they take */
    var nStrip = Math.max(1, Math.floor(rw / (GD + PCL.KERF))), nF = 0, fillM = 0;
    /* v282 one brad a fillet, square to its open face into the groove
       bottom (holds it while the glue sets): no catalogue row -- drawn,
       NOT BILLED (missing) */
    var brads = [], bradL = (s.isMetric === false) ? PCL.BRAD_LEN_US : PCL.BRAD_LEN;
    for (k = 0; k < rails.length; k++) {
      var cF = P(rails[k].uF, 0), uO = k ? uT - t / 2 : uB + t / 2, pO = P(uO, 0), dU = k ? 1 : -1;
      for (i = 0; i <= nB; i++) {
        var zf = -Lin / 2 + gB / 2 + i * (wS + gB);
        box(k ? 'fillet-hi' : 'fillet-lo', PCL.BSLAT_CODE, gB / nStrip, 'fillet-' + (k ? 'top-' : 'bottom-') + (i + 1), cF.x, cF.y, zf, rt, GD, gB, r);
        nF++; fillM += gB;
        brads.push({ kind: k ? 'fillet-hi' : 'fillet-lo', x: pO.x, y: pO.y, z: zf, dir: [-sr * dU, cr * dU, 0], len: bradL, r: PCL.BRAD_R });
      }
    }
    var glueL = Math.max(0.01, Math.ceil(fillM * (rt + 2 * GD) * CAT_NEW.GLUE_L_M2 * 100) / 100);   /* the fillets' bottom + sides in the groove */
    /* THE ARMRESTS on the posts */
    var xBack = xPR - ft / 2 - PCL.ARM_BACK_OVER, xFront = D / 2 + PCL.ARM_OVER, armL = xFront - xBack;
    for (sz = -1; sz <= 1; sz += 2) {
      box('arm', fcode, armL, 'armrest' + (sz < 0 ? '-l' : '-r'), (xFront + xBack) / 2, armTop - ft / 2, sz * zp, armL, ft, fw);
      for (k = 0; k < 2; k++) for (i = -1; i <= 1; i += 2)
        scr('arm', FR ? FR.armScrew.code : PCL.ARM_SCREW, k ? xPR : xPF, armTop, sz * (zp + i * fw / 4), [0, -1, 0], FR ? FR.armScrew.len : 0.10);   /* 38 through the armrest + 62 into the post's top (v298 the 2x6: 6x160) */
    }
    /* THE HANGING (as the photo): the front eye low on the front post, the
       rear one in the rear post just under the armrest, a V per side to
       one hanger straight above */
    var eo = PORCH.EYE_OUT, eyeF = [], eyeR = [], hangers = [], chains = [];
    var yR = armTop - PCL.EYE_ARM, ringX = (xPF + xPR) / 2;
    for (i = 0; i < 2; i++) {
      sz = i ? 1 : -1;
      eyeF.push({ x: xPF, y: frameBot + PCL.EYE_LO, z: sz * (zOut + eo), face: sz * zOut });
      eyeR.push({ x: xPR, y: yR, z: sz * (zOut + eo), face: sz * zOut });
      var hg = { x: ringX, y: H - SWING.HANGER_DROP, z: sz * (zOut + eo) };
      hangers.push(hg);
      var ends = [eyeF[i], eyeR[i]], e;
      for (e = 0; e < 2; e++) {
        var a = ends[e], dx = hg.x - a.x, dy = hg.y - a.y, dz = hg.z - a.z;
        chains.push({ a: { x: a.x, y: a.y, z: a.z }, b: { x: hg.x, y: hg.y, z: hg.z }, len: Math.sqrt(dx * dx + dy * dy + dz * dz), rear: e === 1 });
      }
    }
    /* the cushion between the stiles (to the bottom back rail), a pillow at one end */
    var cushion = _swingCushionOn(s), CT = PCL.CUSHION_T, cd = D / 2 - 0.005 - (P(uB - t / 2, w / 2).x + 0.006);
    var pad = cushion ? { x: D / 2 - 0.005 - cd / 2, y: seatTop + CT / 2, sx: cd, sy: CT, sz: Lin - 0.01 } : null;
    var cTop = seatTop + (cushion ? CT : 0), pB = P(uAt(cTop, w / 2), w / 2);
    var pillows = { n: 1, z0: -hL + t + 0.04, z1: -hL + t + 0.54, seatY: cTop, backX: pB.x, beta: r };
    /* extents, the footprint centred on x = 0 */
    var xMin = Math.min(P(Ls, -w / 2).x, xBack), xMax = xFront, off = (opt && opt.ringAt0) ? 0 : -(xMin + xMax) / 2;   /* v296 ringAt0: the posts' midpoint (the hangers) stays on x = 0 */
    pieces.forEach(function (pc) { pc.box[0] += off; });
    screws.forEach(function (f) { f.x += off; });
    bolts.forEach(function (f) { f.x += off; });
    brads.forEach(function (f) { f.x += off; });
    eyeF.forEach(function (o) { o.x += off; }); eyeR.forEach(function (o) { o.x += off; }); hangers.forEach(function (o) { o.x += off; });
    chains.forEach(function (c) { c.a.x += off; c.b.x += off; });
    if (pad) pad.x += off;
    pillows.backX += off; ringX += off;
    /* the bill's lengths; the coating = each piece's four long faces (the
       fillets sit in the groove); v282 + the fill's two end grains (coated
       before they go in the grooves) + each fillet's open face */
    var m = {}, coat = 0, coatEnds = 0;
    for (i = 0; i < pieces.length; i++) {
      var pc2 = pieces[i], bx = pieces[i].box, dims = [bx[3], bx[4], bx[5]].sort(function (aa, bb) { return aa - bb; });
      m[pc2.code] = (m[pc2.code] || 0) + pc2.len;
      if (pc2.kind.indexOf('fillet') !== 0) coat += 2 * (dims[0] + dims[1]) * dims[2];
      else coatEnds += bx[3] * bx[5];                                             /* rt x gap, between two boards */
      if (pc2.kind === 'backslat') coatEnds += 2 * bx[3] * bx[5];                 /* rt x board width, both ends */
    }
    coat += coatEnds;
    return {
      style: 'classic', Pr: Pr, L: L, H: H, D: D, seatTop: seatTop, frameY: frameY, armTop: armTop, recline: r, backTop: backTop,
      pieces: pieces, screws: screws, bolts: bolts, nSlats: nS, nBack: nB, meters: m, coat: coat,
      fill: fill, gapT: gT, gapBack: gB, gapSeat: gS, backW: wS,
      seatM: seatM, groove: GD, nFillet: nF, fillGap: gB, nStrip: nStrip, fillBoardM: fillM / nStrip, glueL: glueL,
      brads: brads, endClr: PCL.END_CLR, coatEnds: coatEnds,
      eyeF: eyeF, eyeR: eyeR, hangers: hangers, chains: chains, ringX: ringX, cushion: cushion, pad: pad, pillows: pillows,
      beam: { x: ringX, y: H + PORCH.BEAM_H / 2, sx: PORCH.BEAM_W, sy: PORCH.BEAM_H, sz: L + 2 * fw + 2 * PORCH.BEAM_OVER },
      xMin: xMin + off, xMax: xMax + off, depth: xMax - xMin, seatFront: D / 2 + off, off: off,
      hangerScrew: (opt && opt.hangerScrew) || null, zOut: zOut, pergola: !!(opt && opt.ringAt0),   /* v296 */
      rod: !!(FR && FR.rod), ft: ft, fw: fw, frameCode: fcode   /* v298 */
    };
  }
  /* v278 its staged assembly: each group, then its fasteners */
  var PCL_STEPS = [
    { parts: [], codes: [] },
    { parts: ['pcl-frame'], codes: ['KVH10060'] },
    { parts: ['pcl-hw-screw-frame'], codes: ['FAS80100'] },
    { parts: ['pcl-slat'], codes: ['TIM20100'] },                         /* v279 1x4 seat planks */
    { parts: ['pcl-hw-screw-slat'], codes: ['FAS50060'] },
    { parts: ['pcl-stile'], codes: ['KVH10060'] },                        /* v281 the back panel first: the stiles on the side rails */
    { parts: ['pcl-backrail-lo'], codes: ['KVH10060'] },                  /* v279 the bottom back rail with its groove */
    { parts: ['pcl-hw-screw-backrail-lo'], codes: ['FAS80100'] },
    { parts: ['pcl-backslat', 'pcl-fillet-lo', 'pcl-hw-brad-fillet-lo'], codes: ['TIM20100', 'MFP00002', 'FEC00043'] },   /* the fill in the bottom groove (v282 its ends coated first), its glued fillets, a brad each */
    { parts: ['pcl-backrail-hi', 'pcl-fillet-hi', 'pcl-hw-brad-fillet-hi'], codes: ['KVH10060', 'TIM20100', 'FEC00043'] },   /* the top rail, its fillets glued in at the spacing, down over the fill's tops, a brad each */
    { parts: ['pcl-hw-screw-backrail-hi'], codes: ['FAS80100'] },
    { parts: ['pcl-post'], codes: ['KVH10060'] },                         /* v281 the side frames: front + rear posts */
    { parts: ['pcl-hw-bolt'], codes: ['FAT10002'] },                      /* posts to the side rails, rear posts to the stiles */
    { parts: ['pcl-arm'], codes: ['KVH10060'] },
    { parts: ['pcl-hw-screw-arm'], codes: ['FAS60100'] },
    { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-shank', 'swing-hw-eye', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: ['FAT00002', 'FAT00003', 'FAT00004'] },
    { parts: ['cushion'], codes: ['FOU00016'] }
  ];
  /* the active type 7 layout: the classic swing, the sofa swing or the original bench seat */
  function _porchAny(s) { var st = _porchStyle(s); return (st === 'classic') ? _porchClassicLayout(s) : (st === 'sofa') ? _porchSofaLayout(s) : _porchLayout(s); }
  /* ------------------------------------------------------------------
     v296 TYPE 17 -- THE PERGOLA SWING (Marek 2026-10-20 16:17, his seven
     screenshots of the samodzielni.usiebie reel "Wymiary hustawki"):
       - 4 posts 13 x 13, 205 long -- the catalogue's 6x6 KVH16160 (160,
         US 5 1/2 in.) -- in post bases FAT00017 (2 concrete anchors
         FAS10075 + 12 nails FAS38038 a base) on concrete footings
         30 x 30 cm, 80 deep (US 12 x 12 x 32 in.) on 10 cm of gravel,
         5 cm proud;
       - a head across each pair of posts (the portal), 170 long, 10 cm past
         the posts, on their tops, 2 x 8x260 FAS80260 into each post;
       - 2 beams along on the heads, 15 cm past the posts (330 at the reel's
         180 seat), 2 x FAS80260 into each head;
       - rafters 200 x 13 x 6 = 2x6 KVH60160 on edge, notched 25 mm (US 1 in.)
         over the beams, both tails the Hollywood roof's scroll, two of them
         over the chains, the rest at most 0.60 apart, 2 x 8x200 FAS80200 a
         crossing down into the beam;
       - a knee brace (6x6) from every post into its head and into its beam,
         cut plumb on the post and level under the head / beam, 2 toe screws
         FAS80200 at each end from the brace's underside;
       - the classic porch seat (type 7, _porchClassicLayout) on its chain
         V's from a swing hanger under each of the two rafters (2 x 6x100
         FAS60100 -- the rafter is 160 deep); its length on the handle, the
         pergola follows it (35 cm from the seat's side frame to a post).
     X = depth (front +), Y = up, Z = along the seat; centred on 0.
     _pgLayout(STATE) is the single source: the renderer draws it, the bill
     sums it. */
  var PG = {
    POST_H: 2.05, POST_H_US: 2.0574,          /* 6 ft 9 in. */
    HEAD_L: 1.70, HEAD_L_US: 1.6764,          /* 5 ft 6 in. */
    HEAD_OVER: 0.10, HEAD_OVER_US: 0.1016,    /* the head past the post's outer face */
    BEAM_OVER: 0.15, BEAM_OVER_US: 0.1524,    /* the beam past the post's outer face */
    RAF_L: 2.00, RAF_L_US: 1.9812,            /* 6 ft 6 in. */
    NOTCH: 0.025, NOTCH_US: 0.0254, NOTCH_PLAY: 0.001,
    RAF_SP: 0.60,                             /* the rafters at most this far apart */
    RAF_END: 0.08,                            /* the outer rafter's face from the beam's end */
    SEAT_CLR: 0.35,                           /* the seat's side frame to a post's inner face */
    BRACE_X: 0.40, BRACE_X_US: 0.4064,        /* the portal braces' run along the head (the axis, from the post's face) */
    BRACE_Z: 0.50, BRACE_Z_US: 0.508,         /* the beam braces' run */
    TOE_D: 0.10,                              /* a toe screw starts this far along the brace's underside */
    SCREW_OFF: 0.04,                          /* two screws side by side, this far either side of the middle */
    FOOT: 0.30, FOOT_US: 0.3048, FOOT_D: 0.80, FOOT_D_US: 0.8128, FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GRAVEL: 0.10, GRAVEL_US: 0.1016,
    BASE_UP: 0.030, BASE_T: 0.004, BASE_FLANGE: 0.15,   /* the base lifts the post 30 mm, its flanges 150 up the post */
    L_DEF: 2.00,                               /* v298 (was the reel's 1.80) */
    POST: 'KVH16160', RAFTER: 'KVH60160', BASE: 'FAT00017', ANCHOR: 'FAS10075', BASE_NAIL: 'FAS38038',
    LONG_SCREW: 'FAS80260', SCREW: 'FAS80200', HANGER_SCREW: 'FAS60100',
    CONCRETE: 'FCO00002', DIG: 'FEE00001', GRAVEL_CODE: 'FCO00001'
  };
  /* the sections: the 6x6, the 2x6 on edge (metric / US actual) */
  function _pgProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.1397, rw: 0.0381, rh: 0.1397 };
    return { p: 0.160, rw: 0.060, rh: 0.160 };
  }
  function _pgU(s, k) { return ((s || STATE).isMetric === false && PG[k + '_US'] != null) ? PG[k + '_US'] : PG[k]; }
  function _pgLayout(s) {
    s = s || STATE;
    var Pr = _pgProf(s), p = Pr.p, hp = p / 2, rw = Pr.rw, rh = Pr.rh, us = (s.isMetric === false), i, k, q;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len100 = us ? 0.1016 : 0.10;
    /* the heights: the footing's top, the post's foot (on its base), its
       top, the head's top, the beam's top, the rafter's underside between
       the beams (it hangs the notch's depth below the beam's top), its top */
    var yF = _pgU(s, 'FOOT_UP'), yPB = yF + PG.BASE_UP, postH = _pgU(s, 'POST_H'), yPT = yPB + postH;
    var yHT = yPT + p, yBT = yHT + p, nD = _pgU(s, 'NOTCH'), yRB = yBT - nD, yRT = yRB + rh;
    /* THE SEAT first (its length sets the pergola's), its hangers under the rafters */
    /* v298 (Marek 17:28: trosku sirsi, i profily lavicky masivnejsi -- chose
       a longer seat, the frame + armrests 2x6): the seat 1.22 .. 2.44 (US 4 ..
       8 ft), its frame, side posts and armrests 2x6 KVH60160, the corners
       8x160 FAS80160, the armrests 6x160 FAS60160, the posts' joints M16
       rods (post 160 + rail 60 = 220: an M10 x 130 is too short) */
    var seat = _porchClassicLayout(s, { H: yRB, ringAt0: true, hangerScrew: { code: PG.HANGER_SCREW, len: len100 },
      Lmin: us ? 1.2192 : 1.22, Lmax: us ? 2.4384 : 2.44,
      frame: { t: us ? 0.0381 : 0.060, w: us ? 0.1397 : 0.160, code: PG.RAFTER, screw: { code: 'FAS80160', len: us ? 0.1524 : 0.16 }, armScrew: { code: 'FAS60160', len: us ? 0.127 : 0.16 }, rod: { over: 0.018 } } });
    var zSeat = seat.zOut, zh = Math.abs(seat.hangers[0].z);
    var headL = _pgU(s, 'HEAD_L'), xP = headL / 2 - _pgU(s, 'HEAD_OVER') - hp, zP = zSeat + PG.SEAT_CLR + hp;
    var beamL = 2 * (zP + hp + _pgU(s, 'BEAM_OVER')), rafL = _pgU(s, 'RAF_L');
    var pieces = [], screws = [], posts = [], feet = [], bases = [], sx, sz;
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function scr(kind, code, x, y, z, d, len, r) { screws.push({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: len, r: r }); }
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) posts.push({ x: sx * xP, z: sz * zP, sx: sx, sz: sz, id: (sx < 0 ? 'back' : 'front') + (sz < 0 ? '-l' : '-r') });
    /* THE GROUND WORKS: a footing under every post, its base, the anchors and nails */
    var fw = _pgU(s, 'FOOT'), fd = _pgU(s, 'FOOT_D'), gv = _pgU(s, 'GRAVEL'), bt = PG.BASE_T, fl = PG.BASE_FLANGE;
    var nailLen = us ? 0.0381 : 0.038;
    for (i = 0; i < posts.length; i++) {
      q = posts[i];
      feet.push({ x: q.x, z: q.z, w: fw, y0: -fd, y1: yF, g0: -fd - gv, id: q.id });
      bases.push({ x: q.x, z: q.z, y0: yF, y1: yPB, id: q.id });
      for (k = -1; k <= 1; k += 2) scr('anchor', PG.ANCHOR, q.x + k * (hp + 0.03), yF + bt, q.z - k * 0.05, [0, -1, 0], 0.075, 0.005);   /* through the base plate into the concrete */
      for (k = -1; k <= 1; k += 2) for (var nz = -1; nz <= 1; nz += 2) for (var ny = 0; ny < 3; ny++)
        scr('basenail', PG.BASE_NAIL, q.x + k * (hp + bt), yPB + 0.03 + ny * 0.045, q.z + nz * PG.SCREW_OFF, [-k, 0, 0], nailLen, 0.0019);   /* 6 a flange, through it into the post */
      box('post', PG.POST, postH, 'post-' + q.id, q.x, yPB + postH / 2, q.z, p, postH, p);
    }
    /* THE HEADS on the posts' tops; 2 screws down into each post (along the head, side by side) */
    for (sz = -1; sz <= 1; sz += 2) box('head', PG.POST, headL, 'head' + (sz < 0 ? '-l' : '-r'), 0, yPT + hp, sz * zP, headL, p, p);
    for (i = 0; i < posts.length; i++) { q = posts[i]; for (k = -1; k <= 1; k += 2) scr('head', PG.LONG_SCREW, q.x, yHT, q.z + k * PG.SCREW_OFF, [0, -1, 0], len260); }
    /* THE BEAMS on the heads; 2 screws down into each head (across the beam) */
    for (sx = -1; sx <= 1; sx += 2) box('beam', PG.POST, beamL, 'beam-' + (sx < 0 ? 'back' : 'front'), sx * xP, yHT + hp, 0, p, p, beamL);
    for (i = 0; i < posts.length; i++) { q = posts[i]; for (k = -1; k <= 1; k += 2) scr('beam', PG.LONG_SCREW, q.x + k * PG.SCREW_OFF, yBT, q.z, [0, -1, 0], len260); }
    /* THE KNEE BRACES: in its own plane, u from the corner (the post's
       inner face x the member's underside) inward, v up; the band +-p/2
       about the 45 deg axis from (0, -a) to (a, 0), cut plumb at u = 0 and
       level at v = 0; k2 = half the band's width along the cut */
    var k2 = hp * Math.SQRT2, toe = PG.TOE_D;
    function brace(kind, plane, q, a) {
      var xy = (plane === 'xy');
      var u0 = xy ? q.x - q.sx * hp : q.z - q.sz * hp, dI = xy ? -q.sx : -q.sz, v0 = xy ? yPT : yHT, c = xy ? q.z : q.x;
      function W(u, v) { return [u0 + dI * u, v0 + v]; }
      var pts = [W(0, -(a + k2)), W(0, -(a - k2)), W(a - k2, 0), W(a + k2, 0)];
      var long = Math.ceil((a + k2) * Math.SQRT2 * 100) / 100;
      pieces.push({ kind: kind, code: PG.POST, len: long, id: kind + '-' + q.id, poly: pts, plane: plane, c: c, t: p });
      var pA = W(toe, toe - a - k2), pB = W(a + k2 - toe, -toe), j;
      for (j = -1; j <= 1; j += 2) {
        var o = c + j * PG.SCREW_OFF;
        if (xy) { scr(kind, PG.SCREW, pA[0], pA[1], o, [-dI, 0, 0], len200); scr(kind, PG.SCREW, pB[0], pB[1], o, [0, 1, 0], len200); }
        else    { scr(kind, PG.SCREW, o, pA[1], pA[0], [0, 0, -dI], len200); scr(kind, PG.SCREW, o, pB[1], pB[0], [0, 1, 0], len200); }
      }
    }
    for (i = 0; i < posts.length; i++) { brace('brace-x', 'xy', posts[i], _pgU(s, 'BRACE_X')); brace('brace-z', 'zy', posts[i], _pgU(s, 'BRACE_Z')); }
    /* THE RAFTERS: two over the chains, the rest at most RAF_SP apart
       between them and out to the beams' ends */
    var zr = [], zEnd = beamL / 2 - PG.RAF_END - rw / 2, nIn = Math.max(1, Math.ceil(2 * zh / PG.RAF_SP - 1e-6));
    for (i = 0; i <= nIn; i++) zr.push(-zh + 2 * zh * i / nIn);
    if (zEnd > zh + rw) { var nOut = Math.max(1, Math.ceil((zEnd - zh) / PG.RAF_SP - 1e-6)); for (i = 1; i <= nOut; i++) { var zo = zh + (zEnd - zh) * i / nOut; zr.push(zo, -zo); } }
    zr.sort(function (a, b) { return a - b; });
    var tail = SWING_RAFTER_TAIL, hr = rafL / 2, nc = hp + PG.NOTCH_PLAY, rp = [[-hr, yRT], [hr, yRT]];
    for (k = 0; k < tail.length; k++) rp.push([hr - tail[k][0], yRT - rh * tail[k][1]]);
    rp.push([xP + nc, yRB], [xP + nc, yBT], [xP - nc, yBT], [xP - nc, yRB], [-xP + nc, yRB], [-xP + nc, yBT], [-xP - nc, yBT], [-xP - nc, yRB]);
    for (k = tail.length - 1; k >= 0; k--) rp.push([-hr + tail[k][0], yRT - rh * tail[k][1]]);
    for (i = 0; i < zr.length; i++) {
      pieces.push({ kind: 'rafter', code: PG.RAFTER, len: rafL, id: 'rafter-' + (i + 1), poly: rp, plane: 'xy', c: zr[i], t: rw, hang: Math.abs(Math.abs(zr[i]) - zh) < 1e-6 });
      for (sx = -1; sx <= 1; sx += 2) for (k = -1; k <= 1; k += 2) scr('rafter', PG.SCREW, sx * xP + k * PG.SCREW_OFF, yRT, zr[i], [0, -1, 0], len200);
    }
    /* the bill's quantities: timber by code, the ground works, the coating
       (every piece's four long faces) */
    var m = {}, coat = 0;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      coat += (pc.kind === 'rafter') ? 2 * (rw + rh) * pc.len : 4 * p * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    return {
      P: Pr, us: us, seat: seat, L: seat.L, pieces: pieces, screws: screws, posts: posts, feet: feet, bases: bases, meters: m, coat: coat,
      concreteM3: r3(posts.length * fw * fw * (fd + yF)), gravelM3: r3(posts.length * fw * fw * gv), digM3: r3(posts.length * fw * fw * (fd + gv)),
      xP: xP, zP: zP, zh: zh, zr: zr, headL: headL, beamL: beamL, rafL: rafL, postH: postH,
      yF: yF, yPB: yPB, yPT: yPT, yHT: yHT, yBT: yBT, yRB: yRB, yRT: yRT,
      height: yRT, depth: rafL, length: beamL
    };
  }
  /* its staged assembly: the ground works, the posts, the heads, the portal
     braces, the beams, their braces, the rafters -- each with its fasteners --
     then the classic seat's own steps, its hanging and the cushion */
  var PG_STEPS = [
    { parts: [], codes: [] },
    { parts: ['pg-footing'], codes: ['FEE00001', 'FCO00001', 'FCO00002'] },   /* the holes, the gravel, the concrete (its top drawn) */
    { parts: ['pg-base', 'pg-hw-screw-anchor'], codes: ['FAT00017', 'FAS10075'] },
    { parts: ['pg-post'], codes: ['KVH16160'] },
    { parts: ['pg-hw-screw-basenail'], codes: ['FAS38038'] },
    { parts: ['pg-head'], codes: ['KVH16160'] },
    { parts: ['pg-hw-screw-head'], codes: ['FAS80260'] },
    { parts: ['pg-brace-x'], codes: ['KVH16160'] },
    { parts: ['pg-hw-screw-brace-x'], codes: ['FAS80200'] },
    { parts: ['pg-beam'], codes: ['KVH16160'] },
    { parts: ['pg-hw-screw-beam'], codes: ['FAS80260'] },
    { parts: ['pg-brace-z'], codes: ['KVH16160'] },
    { parts: ['pg-hw-screw-brace-z'], codes: ['FAS80200'] },
    { parts: ['pg-rafter'], codes: ['KVH60160'] },
    { parts: ['pg-hw-screw-rafter'], codes: ['FAS80200'] }
  ].concat(PCL_STEPS.slice(1));


  /* ------------------------------------------------------------------
     TYPE 19 -- GARDEN STRUCTURE, variant 1: THE CINEMA BAR (bench-v303,
     Marek 2026-10-20 20:05 with his render: "Zkusis prosim udelat tento
     bar spolu s filmovym platnem jako prvni variantu produktu GARDEN
     STRUCTURE. Dej si zalezet na logice spoju.").
     v305 (Marek 21:15: "Platno dat na krajni profil, aby mohlo byt spustene
     i nize, protoze barovy pult ma byt soucasti konstrukce, nema byt
     samostatne. Vzpery sikme u spodni casti udelat vyssi, sirsi zakladnu.
     Ocekavam ze to bude stat na dlazbe, 4 velke dlazdice 500 x 500 jako
     soucast sestavy / BOQ."):
     X = across (the bar stools +X, the screen -X), Y = up, Z = along.
     THE END FRAME at each post (all in its X-Y plane):
       - two concrete tiles SFF00002 500 x 500 (US 20 x 20 in.) on 10 cm of
         compacted gravel, 3 cm proud, under the ends of a 6x6 SILL 2.40
         (US 8 ft); a DPC strip FFM00007 between tile and sill. The tiles
         carry it -- no cast footing, no anchor (a 50 mm tile takes none);
       - the 6x6 POST on the sill's middle, a hold down strap FAT00012 on
         each Z face across the joint (4 + 6 nails FAS38038);
       - two 6x6 KICKERS, the flared foot -- now from 10 cm inside the
         tile's centre (0.90 out) up to 1.20 above the sill on the post,
         cut level on the sill and plumb on the post, 2 toe screws FAS80200
         an end;
       - the TIE: a pair of 2x8 on the post's Z faces at 2.70 (US 9 ft),
         2 rods through tie - post - tie; two 6x6 STRUTS parallel to the
         roof, feet clamped between the tie boards (2 rods each), heads
         plumb on the post (2 toe screws);
       - the RIDGE (v312) a 6x10 KVH16240 on the post tops, 2 cm proud of
         the rafters (v311 a 2x8 on edge; 2 x FAS80320 a post), a 2x6 RIDGE BRACE on edge post -> ridge inward
         (2 screws an end); the EAVE BEAMS 6x6 on the tie ends (a FAS80260
         into each tie board).
     RAFTERS 2x6 KVH60160 in pairs at <= 60 cm: a birdsmouth on the eave
     beam (a screw down through it); v311 the upper end cut plumb against
     the ridge's face (the pair does not meet; the ridge's top between
     them, v312 2 cm over the rafters), 2 toe screws 6x80 from its sides
     into the ridge.
     THE BAR (v309) between the end posts: a 2x8 RAIL on each X face of the
     posts (front + back) under the worktop and the same 2x8 FOOTREST on
     the sills, each pair through-bolted at every post (2 M16 rods); 2x6
     BRACES lapped on their inner faces /\/\ (from the footrest at the
     posts and at the middle up to the slab at the quarter points -- v311
     3 heads past 4.26 m --, 1-2 rods a lap); the WORKTOP one slab FOU00027 30 mm (US 1 1/4 in., top 1.07 /
     42 in.) post face to post face, bedded on construction adhesive
     FEC00031 along the rails and on the braces' heads.
     THE SCREEN on the outer profile: the roller cassette on 2 brackets on
     the BACK eave beam's outer face (2 x FAS60080 each), the fabric outside
     the frame, so it rolls down past the bar; v311 a 2.35:1 screen
     FMC00009 as wide as the ties let it (a custom size, growing with L),
     its image's top 5 cm under the cassette -- rolled down only as far as
     the image needs; up / down on the toggle, rolled slowly. v324 the projector up on the
     roof's frame (Marek 17:18: "Promitacku dej na konstrukci u stresni
     casti"; v303 it stood on the counter's back edge): upside down on a
     low ceiling mount under the FRONT eave beam at the middle, its back
     flush with the beam's outer face, the lens towards the screen -- the
     light passes over the stools and the counter and under the bulbs to
     the image on the back eave beam; the mount's plate 4 x 6x80 FAS60080
     up into the beam, the mount NOT BILLED (MISSING). Stools 60 cm apart
     in front, a bulb string zig-zag under the rafters.
     L = the beams' length (the posts' centres 2 x OVER inside it, 2.70 ..
     4.80 m / 9 .. 16 ft). _gsLayout(STATE) is the single source. */
  var GS = {
    OVER: 0.25, OVER_US: 0.254,                   /* the beams past the posts' centres */
    S_MIN: 2.70, S_MIN_US: 2.7432, S_MAX: 4.80, S_MAX_US: 4.8768, S_DEF: 3.60, S_DEF_US: 3.6576,   /* the posts' centres */
    TIE_TOP: 2.70, TIE_TOP_US: 2.7432,            /* the ties' top (9 ft) */
    XE: 0.95, XE_US: 0.9652,                      /* the eave beams' centres from the middle */
    TIE_OVER: 0.03,                               /* the tie past the eave beam's outer face */
    PITCH: 35, NOTCH: 0.04, NOTCH_US: 0.0381,     /* the roof; the birdsmouth's depth at the heel */
    TAIL: 0.20, TAIL_US: 0.2032,                  /* the rafter past the eave beam's outer face */
    RAF_SP: 0.60, RAF_END: 0.03,                  /* the rafters at most this far apart; the outer one's face from the beams' ends */
    SILL_L: 2.40, SILL_L_US: 2.4384,              /* v305 the wider base: 8 ft */
    XF: 1.00, XF_US: 1.016,                       /* the tiles' centres across X (20 cm in from the sill's end) */
    SLAB: 0.50, SLAB_US: 0.508, SLAB_T: 0.05, SLAB_T_US: 0.0508,
    FOOT_UP: 0.03, FOOT_UP_US: 0.0254,            /* the tile's top over the ground */
    GRAVEL: 0.10, GRAVEL_US: 0.1016,              /* its compacted bed */
    KICK_IN: 0.10, KICK_IN_US: 0.1016,            /* the kicker's foot axis inside the tile's centre */
    KICK_H: 1.20, KICK_H_US: 1.2192,              /* v305 the kicker's axis meets the post's face this high over the sill */
    DPC_T: 0.002, DPC_L: 0.33,
    STRAP_W: 0.04, STRAP_L: 0.40, STRAP_T: 0.002, STRAP_LOW: 0.005,
    STRUT_CLR: 0.02,                              /* the strut's top edge clear of the eave beam at the tie's top */
    STRUT_END: 0.03,                              /* its foot cut plumb this far inside the tie's end */
    RB_RUN: 0.40, RB_RUN_US: 0.4064,              /* the ridge braces' run along the ridge */
    EAVE_SCREW_IN: 0.04,                          /* the eave screws inside the beam's centre (clear of the strut rods) */
    TOE_D: 0.10, SCREW_OFF: 0.04, ROD_OVER: 0.018,
    COUNTER_TOP: 1.07, COUNTER_TOP_US: 1.0668,    /* 42 in. */
    WT_T: 0.03, WT_T_US: 0.03175,                 /* v309 the worktop slab FOU00027: 30 mm (US 1 1/4 in.) -- v353 no longer used: the top is boards (ct thick) */
    TOP_GAP: 0.002,                               /* v353 the top's boards at least this far apart -- v354 no longer used */
    TOP_SCREW: 'FAS60100',                        /* v353 -- v354 no longer used */
    TOP: 'FOU00034',                              /* v354 the top: an acacia butcher block, by the metre (catalogue row 2026-10-23) */
    TOP_T: 0.038, TOP_T_US: 0.0381,               /* v354 38 mm / 1 1/2 in. */
    TOP_D: 0.635, TOP_D_US: 0.635,                /* v354 635 mm / 25 in. deep (the knees' overhang kept, the rest at the back) */
    TOP_MAX: 4.00, TOP_MAX_US: 3.6576,            /* v354 the longest piece sold (12 ft); longer = equal pieces, a 2 mm joint */
    TOP_POCKET: 'FAS50060', POCKET_SP: 0.40,      /* v354 pocket screws 5x60 (US #10 x 2 1/2 in.) up through the rails' inner faces, at most this far apart */
    BR_SCREW: 'FAS60100', BR_SCREW_US: 'FAS50060',/* v354 the braces' laps: 2 screws for each former rod -- 6x100 through 60 + 60; US #10 x 2 1/2 in. through 1 1/2 + 1 1/2 in. */
    WT_FRONT: 0.25, WT_FRONT_US: 0.254,           /* past the front rail's outer face (the knees at the stools) */
    WT_BACK: 0.10, WT_BACK_US: 0.1016,            /* past the back rail's outer face */
    WT_GAP: 0.003,                                /* its ends off the posts' faces */
    GLUE_T: 0.003, GLUE_W: 0.012, GLUE_M: 10,     /* the adhesive bed under the slab; metres of a 6 mm bead out of one 10 oz cartridge (as BLOCK) */
    ROD_EDGE: 0.035,                              /* a brace rod this far at least from the edges of the brace and of the member it laps */
    BR_RUN: 0.90,                                 /* v311 a bar brace's run at most this (one more head as L grows) */
    TOE_IN: 0.035, TOE_ANG: 37,                   /* v311 the rafter's toe screws: in from the plumb cut, angle off the rafter's face */
    RIDGE_UP: 0.02, RIDGE_UP_US: 0.01905,         /* v312 the ridge's top over the rafters' top edge at its faces */
    CAS_OUT: 0.065, CASSETTE: 0.10, FAB_BORDER: 0.05, SCREEN_CLR: 0.36, TOP_BLACK: 0.05, BR_T: 0.004,
    SCREEN_AR: 2.35,                              /* v311 the image 2.35:1, as wide as the ties let it */
    PROJ: [0.50, 0.10, 0.33],                     /* a projector: along Z, high, deep */
    PROJ_DROP: 0.06, PROJ_DROP_US: 0.0635,        /* v324 its ceiling mount: the drop between the plate and the cradle */
    PROJ_MOUNT: 'PROJECTOR CEILING MOUNT, LOW PROFILE, DROP 60 MM (US 2 1/2 IN.) -- the cinema bar\'s projector under the front eave beam',
    STOOL_SP: 0.60, STOOL_SEAT: 0.76, STOOL_SEAT_US: 0.762, STOOL_OUT: 0.22, STOOL_R: 0.19,
    LIGHT_SAG: 0.18, LIGHT_SP: 0.45, LIGHT_STRING: 14.6, LIGHT_IN: 0.10, LIGHT_FRAME: 0.25,
    POST: 'KVH16160', TIE: 'KVH60200', RAFTER: 'KVH60160', BOARD: 'KVH60160', RIDGE: 'KVH16240',
    ROD: 'FAT16010', WASHER: 'FAT16001', CAPNUT: 'FAT16002',
    SCREW: 'FAS80200', LONG_SCREW: 'FAS80260', RIDGE_SCREW: 'FAS80320', SCREEN_SCREW: 'FAS60080', TOE_SCREW: 'FAS60080',
    NAIL: 'FAS38038', STRAP: 'FAT00012', DPC: 'FFM00007', WORKTOP: 'FOU00027', GLUE: 'FEC00031',
    TILE: 'SFF00002', DIG: 'FEE00001', GRAVEL_CODE: 'FCO00001',
    SCREEN: 'FMC00009', PROJECTOR: 'FMC00008', STOOL: 'FMC00013', LIGHTS: 'EEC00008',
    PROJ_MOUNT_CODE: 'FMC00043'   /* v345 the projector's ceiling mount (catalogue row since 2026-10-22) */
  };
  /* the sections: 6x6, 2x8 (ties, the bar's rails and footrests), 2x6 (rafters, the ridge braces, the bar's braces), v312 the ridge 6x10 (gw x gh) -- metric / US actual */
  function _gsProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.1397, tt: 0.0381, tw: 0.1842, rw: 0.0381, rh: 0.1397, ct: 0.0381, cw: 0.1397, gw: 0.1397, gh: 0.2350 };
    return { p: 0.160, tt: 0.060, tw: 0.200, rw: 0.060, rh: 0.160, ct: 0.060, cw: 0.160, gw: 0.160, gh: 0.240 };
  }
  function _gsU(s, k) { return ((s || STATE).isMetric === false && GS[k + '_US'] != null) ? GS[k + '_US'] : GS[k]; }
  function _gsRange(s) { var o = 2 * _gsU(s, 'OVER'); return { min: _gsU(s, 'S_MIN') + o, max: _gsU(s, 'S_MAX') + o }; }
  function _gsDefL(s) { return _gsU(s, 'S_DEF') + 2 * _gsU(s, 'OVER'); }
  function _gsScreenOn(s) { return (s || STATE).gsScreen !== false; }
  /* keep a*x + b*y + c >= 0 of a convex polygon */
  function _gsClip(poly, h) {
    var out = [], n = poly.length, i;
    for (i = 0; i < n; i++) {
      var P = poly[i], Q = poly[(i + 1) % n], fp = h[0] * P[0] + h[1] * P[1] + h[2], fq = h[0] * Q[0] + h[1] * Q[1] + h[2];
      if (fp >= 0) out.push(P);
      if ((fp >= 0) !== (fq >= 0)) { var t = fp / (fp - fq); out.push([P[0] + t * (Q[0] - P[0]), P[1] + t * (Q[1] - P[1])]); }
    }
    return out;
  }
  /* v309 a convex polygon (either winding) moved in by m on every edge */
  function _gsInset(poly, m) {
    var n = poly.length, a2 = 0, q, out = poly;
    for (q = 0; q < n; q++) a2 += poly[q][0] * poly[(q + 1) % n][1] - poly[(q + 1) % n][0] * poly[q][1];
    var sg = (a2 >= 0) ? 1 : -1;
    for (q = 0; q < n && out.length >= 3; q++) {
      var P = poly[q], Q = poly[(q + 1) % n], ex = Q[0] - P[0], ey = Q[1] - P[1], el = Math.sqrt(ex * ex + ey * ey);
      if (el < 1e-9) continue;
      var nx = -ey / el * sg, ny = ex / el * sg;
      out = _gsClip(out, [nx, ny, -(nx * P[0] + ny * P[1]) - m]);
    }
    return out;
  }
  /* v309 the line C + t u inside a convex polygon: [t0, t1] */
  function _gsChord(poly, C, u) {
    var n = poly.length, a2 = 0, q, t0 = -1e9, t1 = 1e9;
    for (q = 0; q < n; q++) a2 += poly[q][0] * poly[(q + 1) % n][1] - poly[(q + 1) % n][0] * poly[q][1];
    var sg = (a2 >= 0) ? 1 : -1;
    for (q = 0; q < n; q++) {
      var P = poly[q], Q = poly[(q + 1) % n], nx = -(Q[1] - P[1]) * sg, ny = (Q[0] - P[0]) * sg;
      var nu = nx * u[0] + ny * u[1], rhs = nx * (P[0] - C[0]) + ny * (P[1] - C[1]);
      if (Math.abs(nu) < 1e-12) continue;
      if (nu > 0) t0 = Math.max(t0, rhs / nu); else t1 = Math.min(t1, rhs / nu);
    }
    return [t0, t1];
  }
  /* v311 the screen rolled to yb (the bottom bar's height): the fabric out
     of the cassette, the image on it (its border over the bar), the bar */
  function _gsSetRoll(R, yb) {
    var fv = Math.max(0.0005, R.top - yb), i0 = yb + R.bord, i1 = Math.min(R.top, i0 + R.ih), iv = Math.max(0.0005, i1 - i0);
    R.fab.scale.y = fv / R.fh; R.fab.position.y = (R.top + yb) / 2;
    R.img.scale.y = iv / R.ih; R.img.position.y = (i1 > i0) ? (i0 + i1) / 2 : R.top;
    R.bar.position.y = yb;
    [R.fab, R.img, R.bar].forEach(function (m) { if (m.userData) m.userData.basePos = m.position.clone(); });   /* build()'s assembly step puts each part back to its basePos */
  }
  function _gsLayout(s) {
    s = s || STATE;
    var Pr = _gsProf(s), p = Pr.p, hp = p / 2, tt = Pr.tt, tw = Pr.tw, rw = Pr.rw, rh = Pr.rh, ct = Pr.ct, cw = Pr.cw;
    var us = (s.isMetric === false), i, j, k, q, sx, sz;
    var R = _gsRange(s), L = +s.L;
    if (!isFinite(L) || L <= 0) L = _gsDefL(s);
    L = Math.max(R.min, Math.min(R.max, L));
    var over = _gsU(s, 'OVER'), S = L - 2 * over, zP = S / 2, ov = GS.ROD_OVER, toe = GS.TOE_D;
    var len200 = us ? 0.2032 : 0.20, len260 = us ? 0.254 : 0.26, len320 = us ? 0.3048 : 0.32, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], feet = [], dpc = [], straps = [], glue = [];
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function scr(kind, code, x, y, z, d, len, r) { fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: len, r: r || 0.004 }); }
    function rod(kind, x, y, z, d, len) { fas.push({ kind: kind, code: GS.ROD, x: x, y: y, z: z, dir: d, len: len, r: 0.008, rod: true }); }
    function zrod(kind, x, y, zf) { rod(kind, x, y, zf + (hp + tt + ov), [0, 0, -1], 2 * (hp + tt + ov)); }   /* through board - frame member - board */
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    /* THE HEIGHTS: the tile's top, the sill (on its DPC), the counter's
       top, the tie pair, the eave beams on the ties, the ridge board (v311:
       its top flush with the rafters' top edge at its faces; the rafters
       notched nD at the eave heel), the post's top under the ridge board */
    var yF = _gsU(s, 'FOOT_UP'), yS0 = yF + GS.DPC_T, yS1 = yS0 + p;
    var yC = _gsU(s, 'COUNTER_TOP');
    var yT1 = _gsU(s, 'TIE_TOP'), yT0 = yT1 - tw, yTm = (yT0 + yT1) / 2, yE1 = yT1 + p;
    var al = GS.PITCH * Math.PI / 180, tn = Math.tan(al), ca = Math.cos(al);
    var xE = _gsU(s, 'XE'), nD = _gsU(s, 'NOTCH'), xH = xE + hp;
    var hr = Pr.gw / 2, dv = rh / ca;                       /* v311 the ridge's half width (v312 the 6x10); a rafter's depth, plumb */
    var yR1 = yE1 - nD + tn * (xH - hr) + dv + _gsU(s, 'RIDGE_UP'), yR0 = yR1 - Pr.gh, postH = yR0 - yS1;   /* v312 2 cm over the rafters */
    function yu(x) { return yE1 - nD + tn * (xH - x); }   /* a rafter's underside line (x >= 0) */
    /* THE KICKER, in the frame's plane: u out from the post's face, v up from
       the sill's top; its axis from (0, Hk) to (Uk, 0), the band +-p/2 about
       it, cut plumb on the post (u = 0) and level on the sill (v = 0) */
    var sillL = _gsU(s, 'SILL_L'), xF = _gsU(s, 'XF'), sl = _gsU(s, 'SLAB'), slT = _gsU(s, 'SLAB_T'), gv = _gsU(s, 'GRAVEL');
    var Uk = xF - _gsU(s, 'KICK_IN') - hp, Hk = _gsU(s, 'KICK_H'), kl = Math.sqrt(Uk * Uk + Hk * Hk);
    var vU = Hk + hp * kl / Uk, uU = Uk + hp * kl / Hk, vL = Hk - hp * kl / Uk, uL = Uk - hp * kl / Hk;
    function kAxisU(v) { return Uk * (1 - v / Hk); }     /* the axis at the height v over the sill */
    function kTopV(u) { return vU * (1 - u / uU); }       /* the kicker's upper edge */
    var kLen = ceil2(Math.sqrt(uU * uU + vU * vU));
    var posts = [];
    for (sz = -1; sz <= 1; sz += 2) {
      var zf = sz * zP, nm = (sz < 0 ? 'l' : 'r');
      posts.push({ z: zf, sz: sz, id: nm });
      for (sx = -1; sx <= 1; sx += 2) {
        var side = nm + (sx < 0 ? '-back' : '-front');
        feet.push({ x: sx * xF, z: zf, w: sl, y0: yF - slT, y1: yF, g0: yF - slT - gv, id: side });
        dpc.push({ x: sx * xF, z: zf, id: side });
      }
      box('sill', GS.POST, ceil2(sillL), 'sill-' + nm, 0, (yS0 + yS1) / 2, zf, sillL, p, p);
      box('post', GS.POST, ceil2(postH), 'post-' + nm, 0, (yS1 + yR0) / 2, zf, p, postH, p);
      /* the hold down straps across the post / sill joint, 4 nails into the sill and 6 into the post each */
      for (k = -1; k <= 1; k += 2) {
        var zs = zf + k * (hp + GS.STRAP_T / 2), yb = yS0 + GS.STRAP_LOW;
        straps.push({ x: 0, y0: yb, y1: yb + GS.STRAP_L, z: zs, id: nm + (k < 0 ? '-in' : '-out') });
        var rows = [yS0 + 0.04, yS0 + 0.11, yS1 + 0.04, yS1 + 0.10, yS1 + 0.16];
        for (q = 0; q < rows.length; q++) for (j = -1; j <= 1; j += 2) scr('nail-strap', GS.NAIL, j * 0.01, rows[q], zf + k * (hp + GS.STRAP_T), [0, 0, -k], len38, 0.0019);
      }
      /* THE KICKERS, 2 toe screws at each end: at the post from the upper
         edge level into the post, at the sill from the upper edge down */
      for (sx = -1; sx <= 1; sx += 2) {
        var Wk = function (u, v) { return [sx * (hp + u), yS1 + v]; };
        var kp = [Wk(0, vU), Wk(uU, 0), Wk(uL, 0), Wk(0, vL)];
        poly('kicker', GS.POST, kLen, 'kicker-' + nm + (sx < 0 ? '-back' : '-front'), kp, 'xy', zf, p);
        var pA = Wk(toe, kTopV(toe)), uB = uU * (1 - toe / vU), pB = Wk(uB, toe);
        for (j = -1; j <= 1; j += 2) {
          scr('screw-kicker', GS.SCREW, pA[0], pA[1], zf + j * GS.SCREW_OFF, [-sx, 0, 0], len200);   /* through the kicker into the post */
          scr('screw-kicker', GS.SCREW, pB[0], pB[1], zf + j * GS.SCREW_OFF, [0, -1, 0], len200);    /* through the kicker into the sill */
        }
      }
      /* THE TIE PAIR + its 2 rods through the post */
      var tieL = 2 * (xH + GS.TIE_OVER);
      for (k = -1; k <= 1; k += 2) box('tie', GS.TIE, ceil2(tieL), 'tie-' + nm + (k < 0 ? '-in' : '-out'), 0, yTm, zf + k * (hp + tt / 2), tieL, tw, tt);
      for (k = -1; k <= 1; k += 2) zrod('tie', 0, yTm + k * tw / 4, zf);
      /* THE STRUTS: parallel to the rafters, the top edge passing the tie's
         top STRUT_CLR inside the eave beam; the head cut plumb on the post,
         the foot cut level at the tie's underside and plumb inside its end */
      var hv = hp / ca, xUp = xE - hp - GS.STRUT_CLR, yA0 = yT1 + tn * xUp - hv;
      var sTop = function (x) { return yA0 + hv - tn * x; }, sBot = function (x) { return yA0 - hv - tn * x; };
      var xPl = xH + GS.TIE_OVER - GS.STRUT_END, xLo = (yA0 - hv - yT0) / tn;
      for (sx = -1; sx <= 1; sx += 2) {
        var sp = [[hp, sBot(hp)], [hp, sTop(hp)], [xPl, sTop(xPl)], [xPl, yT0], [xLo, yT0]].map(function (P) { return [sx * P[0], P[1]]; });
        poly('strut', GS.POST, ceil2((xPl - hp) / ca), 'strut-' + nm + (sx < 0 ? '-back' : '-front'), sp, 'xy', zf, p);
        var xr1 = (yA0 - hv - yTm) / tn + 0.05, xr2 = xPl - 0.06, yr2 = (yT0 + Math.min(sTop(xr2), yT1)) / 2;
        zrod('strut', sx * xr1, yTm, zf);
        zrod('strut', sx * xr2, yr2, zf);
        for (j = -1; j <= 1; j += 2) scr('screw-strut', GS.SCREW, sx * (hp + toe), sTop(hp + toe), zf + j * GS.SCREW_OFF, [-sx, 0, 0], len200);
      }
      for (k = -1; k <= 1; k += 2) scr('screw-ridge', GS.RIDGE_SCREW, 0, yR1, zf + k * GS.SCREW_OFF, [0, -1, 0], len320);   /* v311 down through the ridge into the post (v312 8 cm in) */
      for (sx = -1; sx <= 1; sx += 2) for (k = -1; k <= 1; k += 2) scr('screw-eave', GS.LONG_SCREW, sx * (xE - GS.EAVE_SCREW_IN), yE1, zf + k * (hp + tt / 2), [0, -1, 0], len260);
      /* THE RIDGE BRACE (the Y-Z plane at x = 0) -- v311 a 2x6 on edge, 60
         thick across; 2 screws an end in its mid-plane, from its lower edge:
         level into the post, plumb up into the ridge board */
      var b = _gsU(s, 'RB_RUN'), k2 = (cw / 2) * Math.SQRT2, uz0 = sz * (zP - hp), dZ = -sz;
      var Wb = function (u, v) { return [uz0 + dZ * u, yR0 + v]; };
      var bp = [Wb(0, -(b + k2)), Wb(0, -(b - k2)), Wb(b - k2, 0), Wb(b + k2, 0)];
      poly('rbrace', GS.BOARD, ceil2((b + k2) * Math.SQRT2), 'rbrace-' + nm, bp, 'zy', 0, ct);
      for (j = 0; j < 2; j++) {
        var tA = 0.07 + 0.06 * j, qA = Wb(tA, tA - (b + k2)), qB = Wb(b + k2 - tA, -tA);
        scr('screw-rbrace', GS.SCREW, 0, qA[1], qA[0], [0, 0, -dZ], len200);
        scr('screw-rbrace', GS.SCREW, 0, qB[1], qB[0], [0, 1, 0], len200);
      }
    }
    /* THE BEAMS along Z */
    box('ridge', GS.RIDGE, ceil2(L), 'ridge', 0, (yR0 + yR1) / 2, 0, Pr.gw, Pr.gh, L);   /* v312 the ridge 6x10 (v311 a 2x8 on edge) */
    for (sx = -1; sx <= 1; sx += 2) box('eave', GS.POST, ceil2(L), 'eave-' + (sx < 0 ? 'back' : 'front'), sx * xE, (yT1 + yE1) / 2, 0, p, p, L);
    /* THE RAFTERS: pairs at most RAF_SP apart over the beams' length */
    var xTl = xH + _gsU(s, 'TAIL'), xSE = xH - nD / tn;
    /* v311 the upper end cut plumb against the ridge board's face (x = hr) */
    var rpR = [[hr, yu(hr) + dv], [xTl, yu(xTl) + dv], [xTl, yu(xTl)], [xH, yu(xH)], [xH, yE1], [xSE, yE1], [hr, yu(hr)]];
    var rpL = rpR.map(function (P) { return [-P[0], P[1]]; }).reverse();
    var rafL = ceil2((xTl - hr) / ca), zEnd = L / 2 - GS.RAF_END - rw / 2, nR = Math.max(1, Math.ceil(2 * zEnd / GS.RAF_SP - 1e-6)), zr = [];
    for (i = 0; i <= nR; i++) zr.push(-zEnd + 2 * zEnd * i / nR);
    var xe = (xSE + xH) / 2, tIn = GS.TOE_IN, tAn = GS.TOE_ANG * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xt = hr + tIn;
    for (i = 0; i < zr.length; i++) {
      poly('rafter', GS.RAFTER, rafL, 'rafter-' + (i + 1) + '-front', rpR, 'xy', zr[i], rw);
      poly('rafter', GS.RAFTER, rafL, 'rafter-' + (i + 1) + '-back', rpL, 'xy', zr[i], rw);
      for (sx = -1; sx <= 1; sx += 2) {
        scr('screw-rafter', GS.LONG_SCREW, sx * xe, yu(xe) + dv, zr[i], [0, -1, 0], len260);
        /* v311 2 toe screws 6x80 at the ridge: from each side face, across the plumb cut into the board */
        for (k = -1; k <= 1; k += 2) scr('screw-rtoe', GS.TOE_SCREW, sx * xt, yu(xt) + dv / 2 + k * 0.035, zr[i] + k * rw / 2, [-sx * tCo, 0, -k * tSi], len80);
      }
    }
    /* v309 THE BAR (Marek 21:45: "Barovy pult udelej tak, ze mezi krajnimi
       sloupy budou po obou stranach profily, a stul bude tvoreny celistvou
       pracovni deskou. Stejne profily mezi sloupy i tesne nad zem, jakoby
       operka na nohy cloveka na barove stolicce. Uprostred a na krajich pak
       muzes od techto profilu dat vzpery sikme nahoru prave na barovou
       desku." 21:46: the profiles on the frames at the counter's height
       away):
       - 2 RAILS 2x8 on the posts' X faces (front + back), from post's outer
         face to post's outer face, their top under the slab's adhesive bed;
         2 M16 rods through rail - post - rail at each post;
       - 2 FOOTRESTS, the same 2x8 the same way, lying on the sills (as low
         as they go: the sill runs under the post); 2 rods a post;
       - BRACES 2x6 lapped on the rail's and the footrest's inner faces,
         /\/\ on each side: from the footrest at each post and from its
         middle up to the slab at the quarter points; the heads cut level
         under the slab (they carry it), the feet plumb on the post's face or
         on each other; 1 - 2 M16 rods through every lap;
       - the TOP (v353, Marek 10:43: the granite worktop FOU00027 cost a lot
         and no store had it): 2x6 boards (the bar's own KVH60160) laid
         ACROSS the bar on the two rails, between the posts, 3 mm off their
         faces, 25 cm (US 10 in.) past the front rail for the knees, 10 cm
         (US 4 in.) past the back one, 2 - 8 mm apart, each screwed down
         with 2 x 6x100 FAS60100 into each rail -- no adhesive, no slab
         (was: one slab FOU00027 30 mm on beads of FEC00031) */
    var wtT = _gsU(s, 'TOP_T'), yWt0 = yC - wtT, yRt = yWt0, yRb = yRt - tw, yRm = (yRb + yRt) / 2;   /* v354 the acacia top's thickness (v353: the 2x6 boards') */
    var yFb = yS1, yFt = yFb + tw, yFm = (yFb + yFt) / 2;
    var zIn = zP - hp - tt, zi = zP - hp, nHd = Math.max(2, Math.ceil(zi / GS.BR_RUN - 1e-9)), bRun = zi / nHd, railL = 2 * (zP + hp), Lc = 2 * zi, wtL = Lc - 2 * GS.WT_GAP;
    var xRo = hp + tt, xFr = xRo + _gsU(s, 'WT_FRONT'), D = _gsU(s, 'TOP_D'), xB = xFr - D;   /* v354 the butcher block's own depth: the knees' overhang as before, the rest past the back rail */
    var glueM = 0, nBr = 0, brL = 0, nBrRod = 0, nBrScr = 0, rE = GS.ROD_EDGE;
    var brScrew = us ? GS.BR_SCREW_US : GS.BR_SCREW, brLen = us ? 0.0635 : 0.10;   /* v354 the braces' screws */
    function xrod(kind, y, z) { rod(kind, hp + tt + ov, y, z, [-1, 0, 0], 2 * (hp + tt + ov)); }   /* through rail - post - rail */
    function bead(id, x, z0, z1) { glue.push({ id: id, x: x, y: yRt + GS.GLUE_T / 2, z0: z0, z1: z1 }); glueM += z1 - z0; }
    for (sx = -1; sx <= 1; sx += 2) {
      var sn = (sx < 0 ? 'back' : 'front');
      box('rail', GS.TIE, ceil2(railL), 'rail-' + sn, sx * (hp + tt / 2), yRm, 0, tt, tw, railL);
      box('footrest', GS.TIE, ceil2(railL), 'footrest-' + sn, sx * (hp + tt / 2), yFm, 0, tt, tw, railL);   /* v353 no adhesive bead (a board top is screwed) */
    }
    for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2) { xrod('rail', yRm + k * tw / 4, sz * zP); xrod('footrest', yFm + k * tw / 4, sz * zP); }
    /* the braces in the (z, y) plane: each axis from node to node, the band
       cw wide, cut plumb at the nodes' z and level at the footrest's
       underside and at the slab */
    var bNd = [];   /* v311 feet and heads in turn from post to post: 2 heads, 3 past a run of BR_RUN */
    for (i = 0; i <= 2 * nHd; i++) bNd.push([-zi + i * bRun, (i % 2) ? yRt : yFm]);
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < 2 * nHd; i++) {
      var nA = bNd[i], nB = bNd[i + 1], ez = nB[0] - nA[0], ey = nB[1] - nA[1], el = Math.sqrt(ez * ez + ey * ey), uz = ez / el, uy = ey / el, bw2 = cw / 2, bX = 0.5;
      var bpl = [[nA[0] - uz * bX + uy * bw2, nA[1] - uy * bX - uz * bw2], [nB[0] + uz * bX + uy * bw2, nB[1] + uy * bX - uz * bw2],
                 [nB[0] + uz * bX - uy * bw2, nB[1] + uy * bX + uz * bw2], [nA[0] - uz * bX - uy * bw2, nA[1] - uy * bX + uz * bw2]];
      bpl = _gsClip(bpl, [1, 0, -Math.min(nA[0], nB[0])]);
      bpl = _gsClip(bpl, [-1, 0, Math.max(nA[0], nB[0])]);
      bpl = _gsClip(bpl, [0, 1, -yFb]);
      bpl = _gsClip(bpl, [0, -1, yRt]);
      var bts = bpl.map(function (P) { return P[0] * uz + P[1] * uy; }), bLen = ceil2(Math.max.apply(null, bts) - Math.min.apply(null, bts));
      var bid = 'brace-' + (sx < 0 ? 'back' : 'front') + '-' + (i + 1);
      poly('brace', GS.BOARD, bLen, bid, bpl, 'zy', sx * (hp - ct / 2), ct);
      nBr++; brL += bLen;
      /* its head under the top (v353 no adhesive bead on it any more) */
      /* the rods through each lap: inside the brace and the member it laps
         by rE; 2 along the brace when there is room, else 1 */
      var laps = [[yFb, yFt], [yRb, yRt]];
      for (q = 0; q < 2; q++) {
        var Rl = _gsInset(bpl, rE);
        Rl = _gsClip(Rl, [0, 1, -(laps[q][0] + rE)]);
        Rl = _gsClip(Rl, [0, -1, laps[q][1] - rE]);
        if (Rl.length < 3) continue;
        var cz = 0, cy = 0;
        for (j = 0; j < Rl.length; j++) { cz += Rl[j][0]; cy += Rl[j][1]; }
        cz /= Rl.length; cy /= Rl.length;
        var tr = _gsChord(Rl, [cz, cy], [uz, uy]), tm = (tr[0] + tr[1]) / 2, ns = (tr[1] - tr[0] >= 0.08) ? [-0.04, 0.04] : [0];
        /* v354 (Marek 12:27: proc tolik spoju, nedaji se nahradit normalnim spojovacim materialem?): 2 screws for each
           former M16 rod, a little either side of its axis, from the brace's inner face into the rail / footrest */
        for (j = 0; j < ns.length; j++) for (k = -1; k <= 1; k += 2) {
          var ta = tm + ns[j];
          scr('screw-brace', brScrew, sx * (hp - ct), cy + uy * ta + uz * k * 0.02, cz + uz * ta - uy * k * 0.02, [sx, 0, 0], brLen);
          nBrScr++;
        }
      }
    }
    /* v354 THE TOP (Marek 12:29: deska do exterieru, bez spojovaciho materialu
       na ni; his pick: masiv akat): one acacia butcher block FOU00034 between
       the posts, by the metre, in equal pieces up to TOP_MAX with a 2 mm joint;
       oiled with the frame (MFP00002); fixed from BELOW -- pocket screws
       FAS50060 up through each rail's inner face (30 mm under its top edge,
       15 deg off plumb) into the top, at most POCKET_SP apart, clear of the
       braces' heads (v353's 2x6 boards across the bar and their screws gone) */
    var wtA = 0, topN = Math.max(1, Math.ceil(wtL / _gsU(s, 'TOP_MAX') - 1e-9)), topGap = (topN > 1) ? 0.002 : 0, topLen = Math.round((wtL - (topN - 1) * topGap) / topN * 1000) / 1000;
    for (i = 0; i < topN; i++) {
      var tz = -wtL / 2 + topLen / 2 + i * (topLen + topGap);
      box('top', GS.TOP, topLen, 'top-' + (i + 1), (xB + xFr) / 2, yWt0 + wtT / 2, tz, D, wtT, topLen);
    }
    var pkN = Math.max(2, Math.ceil((wtL - 0.20) / GS.POCKET_SP - 1e-9) + 1), pkLen = us ? 0.0635 : 0.06, pkA = 15 * Math.PI / 180, nPk = 0;
    var heads = [];
    for (i = 1; i < bNd.length; i += 2) heads.push(bNd[i][0]);
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < pkN; i++) {
      var pz = -wtL / 2 + 0.10 + i * (wtL - 0.20) / (pkN - 1);
      if (heads.some(function (hz) { return Math.abs(hz - pz) < 0.12; })) continue;
      scr('screw-top', GS.TOP_POCKET, sx * hp, yRt - 0.03, pz, [sx * Math.sin(pkA), Math.cos(pkA), 0], pkLen);
      nPk++;
    }
    /* THE SCREEN on the back eave beam's outer face -- v311 (Marek 23:41:
       "proporcionalne zvetsovat i platno ... mozna je to atyp, ale proc ne";
       23:46: "uzsi bar = mensi platno = mene vysunute, at tam neni zvetsena
       cerna plocha"): the image as wide as the ties let it (2.35:1, a custom
       size), its top TOP_BLACK under the cassette -- the fabric rolls down
       only as far as the image needs */
    var ar = GS.SCREEN_AR, sW = 2 * zIn - GS.SCREEN_CLR, sH = sW / ar, sd = Math.round(sW * Math.sqrt(1 + 1 / (ar * ar)) / 0.0254);
    var xFace = -(xE + hp), xc = xFace - GS.CAS_OUT, fabW = sW + 2 * GS.FAB_BORDER, casL = fabW + 0.08;
    var yCas1 = yT1, yCas0 = yT1 - GS.CASSETTE;
    var yI1 = yCas0 - GS.TOP_BLACK, yI0 = yI1 - sH, yFab0 = yI0 - GS.FAB_BORDER;
    var screen = { on: _gsScreenOn(s), diag: sd, w: sW, h: sH, x: xc, face: xFace, fabW: fabW, casL: casL, yCas0: yCas0, yCas1: yCas1, yFab0: yFab0, yFab1: yCas0, yI0: yI0, yI1: yI1, dMin: yI0, dMax: yI0, brackets: [] };
    for (k = -1; k <= 1; k += 2) {
      var zb = k * (casL / 2 - 0.12);
      screen.brackets.push({ z: zb });
      for (j = 0; j < 2; j++) scr('screw-cassette', GS.SCREEN_SCREW, xFace - GS.BR_T, yT1 + 0.03 + j * 0.06, zb, [1, 0, 0], len80);   /* through the bracket's plate into the eave beam */
    }
    /* THE FURNITURE: v324 the projector upside down under the front eave
       beam at the middle (its back flush with the beam's outer face, the
       lens to the screen), on a ceiling mount: the plate on the beam's
       underside (4 screws up into it), the drop, the cradle on the
       projector -- the mount NOT BILLED; the stools in front */
    var pj = GS.PROJ, pmP = Math.min(0.12, p - 0.02), pmD = _gsU(s, 'PROJ_DROP'), pmT = GS.BR_T, yPj1 = yT1 - pmT - pmD - pmT, pmA = pmP / 2 - 0.025;
    var proj = { x: xE + hp - pj[2] / 2, y: yPj1 - pj[1] / 2, z: 0, w: pj[0], h: pj[1], d: pj[2], mount: { x: xE, y1: yT1, plate: pmP, drop: pmD, t: pmT } };
    for (j = -1; j <= 1; j += 2) for (k = -1; k <= 1; k += 2) scr('screw-projmount', GS.SCREEN_SCREW, xE + j * pmA, yT1, k * pmA, [0, 1, 0], len80);   /* through the plate up into the beam */
    var nSt = Math.max(1, Math.floor(Lc / GS.STOOL_SP + 1e-6)), stools = [], ySeat = _gsU(s, 'STOOL_SEAT');
    for (i = 0; i < nSt; i++) stools.push({ x: xFr + GS.STOOL_OUT, z: -(nSt - 1) / 2 * GS.STOOL_SP + i * GS.STOOL_SP, y: ySeat, r: GS.STOOL_R });
    /* THE LIGHTS: zig-zag from rafter to rafter between the frames, under the rafters */
    var zl = zr.filter(function (z) { return Math.abs(z) <= zP - GS.LIGHT_FRAME; }), lx = xE - GS.LIGHT_IN, ly = yu(lx) - 0.01, cable = [], bulbs = [], cabL = 0;
    for (i = 0; i + 1 < zl.length; i++) {
      var xa = (i % 2) ? lx : -lx, xb2 = -xa, n = 16;
      for (q = 0; q <= n; q++) {
        var f = q / n, P = [xa + (xb2 - xa) * f, ly - 4 * GS.LIGHT_SAG * f * (1 - f), zl[i] + (zl[i + 1] - zl[i]) * f];
        if (q > 0) { var Pp = cable[cable.length - 1]; cabL += Math.sqrt(Math.pow(P[0] - Pp[0], 2) + Math.pow(P[1] - Pp[1], 2) + Math.pow(P[2] - Pp[2], 2)); }
        if (q > 0 || i === 0) cable.push(P);
      }
    }
    var acc = 0;
    for (i = 1; i < cable.length; i++) {
      var A = cable[i - 1], B = cable[i], dl = Math.sqrt(Math.pow(B[0] - A[0], 2) + Math.pow(B[1] - A[1], 2) + Math.pow(B[2] - A[2], 2));
      acc += dl;
      if (acc >= GS.LIGHT_SP) { acc -= GS.LIGHT_SP; bulbs.push([B[0], B[1] - 0.03, B[2]]); }
    }
    var lightN = cable.length ? Math.max(1, Math.ceil(cabL / GS.LIGHT_STRING)) : 0;
    /* the bill's quantities: timber by code, the coating (the four long faces) */
    var m = {}, coat = 0;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0)) continue;
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      var sec = (pc.code === GS.POST) ? [p, p] : (pc.code === GS.TIE) ? [tt, tw] : (pc.code === GS.RIDGE) ? [Pr.gw, Pr.gh] : (pc.code === GS.TOP) ? [wtT, D] : [ct, cw];   /* v354 the acacia top oiled all round */
      coat += 2 * (sec[0] + sec[1]) * pc.len;
    }
    /* the rails' deflection under a 1 kN/m lean on the bar (shared by both rails), mm -- v309 over the longest panel (post - brace head - brace head) */
    var E = 11000e6, Ir = tt * Math.pow(tw, 3) / 12, wR = 500, sR = Math.max(2 * bRun, hp + bRun), deflR = 5 * wR * Math.pow(sR, 4) / (384 * E * Ir) * 1000;
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var nF = feet.length;
    return {
      P: Pr, us: us, L: L, S: S, zP: zP, pieces: pieces, fas: fas, feet: feet, dpc: dpc, straps: straps,
      glue: glue, glueM: r3(glueM), glueN: (glueM > 0) ? Math.max(1, Math.ceil(glueM / GS.GLUE_M - 1e-9)) : 0, worktopM2: wtA,   /* v353 both 0: the top is boards */
      topN: topN, topGap: topGap, topLen: topLen, topT: wtT, pockets: nPk, braceScrews: nBrScr,
      screen: screen, proj: proj, stools: stools, cable: cable, bulbs: bulbs, cableL: cabL, lightN: lightN, meters: m, coat: coat,
      missing: [],                                                                                 /* v345 the projector's ceiling mount billed (FMC00043) */
      tiles: nF, gravelM3: r3(nF * sl * sl * gv), digM3: 0,   /* v354 (Marek 12:29: proc excavation, kdyz jsou pod konci dlazdice?) no excavation: the four shallow beds are dug by hand as the tiles are laid (was nF * sl * sl * (slT - yF + gv) m3 of FEE00001) */
      xE: xE, xF: xF, sillL: sillL, postH: postH, zr: zr, rafL: rafL, pitch: GS.PITCH, D: D, Lc: Lc, wtL: wtL, railL: railL, deflR: deflR, panel: sR, braceHeads: nHd, braceRun: bRun,
      braceN: nBr, braceL: brL, braceRods: nBrRod,
      kLen: kLen, kTop: yS1 + vU, kFoot: hp + uU,
      yF: yF, yS1: yS1, yRb: yRb, yRt: yRt, yFt: yFt, yT0: yT0, yT1: yT1, yE1: yE1, yR0: yR0, yR1: yR1, yC: yC,
      height: yR1, depth: Math.max(2 * xTl, sillL), length: L, counterFront: xFr, counterBack: xB
    };
  }
  /* its staged assembly: the tiles, the foot, the post, the frame, the
     bar's footrests, rails and braces (v309), the roof frame, the rafters,
     the worktop on its adhesive, the screen, the lights, the furniture --
     each member, then its fasteners */
  var GS_STEPS = [
    { parts: [], codes: [] },
    { parts: ['gs-footing'], codes: ['FCO00001', 'SFF00002'] },   /* v354 no FEE00001 */
    { parts: ['gs-hw-dpc', 'gs-sill'], codes: ['FFM00007', 'KVH16160'] },
    { parts: ['gs-post'], codes: ['KVH16160'] },
    { parts: ['gs-hw-strap', 'gs-hw-nail-strap'], codes: ['FAT00012', 'FAS38038'] },
    { parts: ['gs-kicker'], codes: ['KVH16160'] },
    { parts: ['gs-hw-screw-kicker'], codes: ['FAS80200'] },
    { parts: ['gs-footrest', 'gs-hw-bolt-footrest'], codes: ['KVH60200', 'FAT16010', 'FAT16001', 'FAT16002'] },   /* v309 the footrests on the sills */
    { parts: ['gs-rail', 'gs-hw-bolt-rail'], codes: ['KVH60200', 'FAT16010'] },                                     /* the counter's rails */
    { parts: ['gs-brace', 'gs-hw-screw-brace'], codes: ['KVH60160', 'FAS60100'] },                                  /* the braces between them; v354 screwed (were M16 rods) */
    { parts: ['gs-tie', 'gs-hw-bolt-tie'], codes: ['KVH60200', 'FAT16010'] },
    { parts: ['gs-strut', 'gs-hw-bolt-strut'], codes: ['KVH16160', 'FAT16010'] },
    { parts: ['gs-hw-screw-strut'], codes: ['FAS80200'] },
    { parts: ['gs-ridge'], codes: ['KVH16240'] },                                                                   /* v312 the ridge 6x10 */
    { parts: ['gs-hw-screw-ridge'], codes: ['FAS80320'] },
    { parts: ['gs-rbrace'], codes: ['KVH60160'] },
    { parts: ['gs-hw-screw-rbrace'], codes: ['FAS80200'] },
    { parts: ['gs-eave'], codes: ['KVH16160'] },
    { parts: ['gs-hw-screw-eave'], codes: ['FAS80260'] },
    { parts: ['gs-rafter'], codes: ['KVH60160'] },
    { parts: ['gs-hw-screw-rafter', 'gs-hw-screw-rtoe'], codes: ['FAS80260', 'FAS60080'] },                       /* v311 + the toe screws at the ridge */
    { parts: ['gs-top'], codes: ['FOU00034'] },                                                                     /* v354 the acacia top (v353 2x6 boards; before, the adhesive FEC00031) */
    { parts: ['gs-hw-screw-top'], codes: ['FAS50060'] },                                                           /* v354 its pocket screws from below (v353 screws down; before, the slab FOU00027) */
    { parts: ['gs-hw-cassette', 'gs-hw-screw-cassette', 'gs-hw-fabric'], codes: ['FMC00009', 'FAS60080'] },
    { parts: ['gs-hw-lights'], codes: ['EEC00008'] },
    { parts: ['gs-hw-projector', 'gs-hw-projmount', 'gs-hw-screw-projmount', 'gs-hw-stool'], codes: ['FMC00008', 'FMC00043', 'FAS60080', 'FMC00013'] }   /* v324 + its mount under the front eave beam (v345 FMC00043) */
  ];

  /* ------------------------------------------------------------------
     TYPE 25 -- GARDEN STRUCTURE: THE BAR (bench-v355-mcbar, Marek
     2026-10-26 15:29: "Udelej variantu BAR jako prvni v garden structure,
     rovnou tam u ni udelej drawer autora spoluprace jako u Matta";
     15:30: "bar je udelany z drevene konstrukce, oblozena dlazbou,
     kamennym obkladem"). The author project of Adam (@mancavebartender,
     UK), drawn from his ten build photos: his own garden bar.
     X = across (the stools +X, the back wall -X), Y = up, Z = along.
       - A CONCRETE SLAB 10 cm (US 4 in.) FFM00001, 5 cm proud, on welded
         mesh sheets PBF30001 on spacers FFM00004, on 15 cm (US 6 in.) of
         compacted gravel FCO00001 on geotextile FEC00003; dug out FEE00001,
         edge formwork FFF00002 (one lump);
       - 100 x 100 POSTS KVH10100 (US 4x4) on bolt-down post bases FAT00017
         (4 concrete screws FAS10075 into the slab, 8 connector screws
         FAS50040 into the post), a front and a back post in every FRAME --
         two frames, three when the end frames stand more than 3.00 m (US
         10 ft) apart;
       - a 100 x 200 BEAM KVH10200 (US 4x8) across each frame on its two
         posts' tops (cut to the pitch), the roof falling 10 deg to the back;
         75 cm (US 2 1/2 ft) past the front post, 35 cm past the back one;
         its ends cut back underneath; 2 x 8x260 FAS80260 down into each post;
       - 2x6 PURLINS KVH60160 on edge along Z on the beams, <= 50 cm (US 20
         in.) apart, 90 cm (US 3 ft) past the end frames, their ends cut
         back underneath; an 8x260 down into every beam they cross;
       - black CORRUGATED SHEETS ROR12004 on the purlins (+15 % laps), a
         sealing screw FAS00225 every 20 cm along every purlin;
       - THE BACK WALL between the back posts: a 2x4 sole plate KVH10060 on
         sill seal INS01003 (concrete screws, MISSING), a top plate under
         the beams (2 toe screws 6x100 FAS60100 into each post), studs <= 60
         cm (US 2 ft) apart (2 nails FAS70000 each end), T&G boards
         KVR14619 across the bar side (2 nails at every post / stud), the
         hedge panels from 1.15 m up (MISSING);
       - THE COUNTER, L-shaped round the front posts (the return at the
         garden end -Z on the info-bar toggle): a stud frame of 2x4
         KVH10060 -- two walls 50 cm (US 20 in.) apart outside to inside,
         sole plates on sill seal (concrete screws, MISSING), studs <= 40 cm
         (US 16 in.), top plates, 2x4 joists on edge across under the top,
         2x4 braces on the bartender side; outside cement board FCB00013
         (screws FAT16012 every 20 cm) and split-face stone veneer
         (MISSING) on flexible adhesive FEC00018; the top 18 mm marine
         plywood FFW00003 (5x60 FAS50060), cement board, a 2K waterproofing
         FEC00025, tiles FFC00003 on FEC00018, grout SBG00001, an aluminium
         edge trim (MISSING), 3 cm past the stone; the tiles' top 1.10 m
         (US 43 in.); an LED strip EEC00006 + its supply EEC00007 under the
         lip;
       - bar stools FMC00013 60 cm apart in front, a string of bulbs
         EEC00008 zig-zag under the purlins; the timber coated MFP00002.
     L = the purlins' length (the roof), 3.60 .. 6.00 m (US 12 .. 20 ft).
     _mbLayout(STATE) is the single source. */
  var MB = {
    L: [3.60, 6.00], L_US: [3.6576, 6.096], L0: 4.80, L0_US: 4.8768,
    OVZ: 0.90, OVZ_US: 0.9144,                    /* the purlins past the end frames' centres */
    MID: 3.00, MID_US: 3.048,                     /* a middle frame past this */
    XF: 1.05, XF_US: 1.0668,                      /* the front / back posts' centres from the middle (2.10 m / 7 ft apart) */
    BOV_F: 0.75, BOV_F_US: 0.762, BOV_B: 0.35, BOV_B_US: 0.3556,   /* the beam past the front / back post's centre (along the slope's run) */
    END_CUT: 0.12,                                /* a beam's / purlin's underside this much shorter at each end */
    H_F: 2.40, H_F_US: 2.4384,                    /* the beam's underside over the front post's centre, over the slab */
    PITCH: 10,
    PUR_SP: 0.50, PUR_SP_US: 0.508, PUR_IN: 0.04, /* the purlins at most this far apart; the outer ones this far in from the beam's ends */
    SH_T: 0.018, SH_OV: 0.05, SH_WAVE: 0.076,     /* the corrugated sheet: its depth, past the outer purlins / the purlins' ends, its pitch (3 in.) */
    SLAB_T: 0.10, SLAB_T_US: 0.1016, GRAVEL: 0.15, GRAVEL_US: 0.1524, SLAB_UP: 0.05, SLAB_UP_US: 0.0508,
    SLAB_BACK: 0.20, SLAB_FRONT: 0.90, SLAB_FRONT_US: 0.9144, SLAB_END: 0.10, BED_OUT: 0.10,
    MESH_A: 6.0,                                  /* PBF30001: a 3.00 x 2.00 m sheet (US 20 x 8 ft) */
    BASE_UP: 0.03, BASE_W: 0.15, BASE_H: 0.18,    /* FAT00017: the post 3 cm over the slab, its sleeve */
    CD: 0.50, CD_US: 0.508,                       /* the counter: outer wall's face to inner wall's face */
    C_END: 0.40, C_END_US: 0.4064,                /* its ends inside the roof's */
    TOP: 1.10, TOP_US: 1.0922,                    /* the tiles' top over the slab (43 in.) */
    ST_SP: 0.40, ST_SP_US: 0.4064,                /* the counter's studs (16 in.) */
    BW_SP: 0.60, BW_SP_US: 0.6096,                /* the back wall's studs (24 in.) */
    ANCH_SP: 0.80,                                /* the sole plates' concrete screws */
    SEAL_T: 0.005,
    CB_T: 0.0125, CB_T_US: 0.0127, PLY_T: 0.018, PLY_T_US: 0.01905, MEM_T: 0.0015, ADH_T: 0.005, TILE_T: 0.010, TILE_T_US: 0.009525,
    STONE_T: 0.035, STONE_UP: 0.01, TOP_OUT: 0.03, TOP_IN: 0.05, TRIM_T: 0.002, LED_T: 0.006,
    TILE: 0.20,                                   /* the tile drawn 20 x 20 cm */
    HEDGE_Y: 1.15, HEDGE_Y_US: 1.1684, HEDGE_T: 0.04,
    WASTE_SH: 1.15, WASTE: 1.10, CONC_WASTE: 1.05,
    ADH_TILE: 4.0, ADH_STONE: 6.0, GROUT: 0.5, MEM_KG: 1.5, SPACER_M2: 2,
    SH_SCR_SP: 0.20, CB_SCR_SP: 0.20, PLY_SCR_SP: 0.20,
    STOOL_SP: 0.60, STOOL_OUT: 0.25, STOOL_SEAT: 0.76, STOOL_SEAT_US: 0.762, STOOL_R: 0.19, STOOL_END: 0.35,
    LIGHT_SAG: 0.15, LIGHT_SP: 0.45, LIGHT_STRING: 14.6, LIGHT_STEP: 0.80, LIGHT_IN: 0.30,
    POST: 'KVH10100', BEAM: 'KVH10200', PURLIN: 'KVH60160', STUD: 'KVH10060', BOARD: 'KVR14619',
    PBASE: 'FAT00017', ANCHOR: 'FAS10075', BASE_SCREW: 'FAS50040', BEAM_SCREW: 'FAS80260', PUR_SCREW: 'FAS80260',
    NAIL: 'FAS70000', TOE: 'FAS60100',
    SHEET: 'ROR12004', SH_SCREW: 'FAS00225',
    SEAL: 'INS01003', CB: 'FCB00013', CB_SCREW: 'FAT16012', PLY: 'FFW00003', PLY_SCREW: 'FAS50060',
    MEMBRANE: 'FEC00025', ADHESIVE: 'FEC00018', TILES: 'FFC00003', GROUT_CODE: 'SBG00001',
    CONCRETE: 'FFM00001', GRAVEL_CODE: 'FCO00001', GEOTEX: 'FEC00003', MESH: 'PBF30001', SPACER: 'FFM00004', FORMWORK: 'FFF00002', DIG: 'FEE00001',
    LED: 'EEC00006', PSU: 'EEC00007', LIGHTS: 'EEC00008', STOOL: 'FMC00013',
    /* v357 the rows added to the catalogue for the bar (Marek 18:35) and the gable's */
    STONE: 'FCP00010', TRIM: 'FFC00008', HEDGE: 'FEC00047', PLATE_ANCHOR: 'FAS75100', RAFTER: 'KVH60200', RIDGE: 'ROR00009',
    /* v357 the options */
    HR: [2.10, 3.00], HR_US: [2.1336, 3.048],       /* the height (the beam's / the tie's underside over the front post) on its slider, US 7 .. 10 ft */
    MIN_BACK: 1.95, MIN_BACK_US: 1.9812,           /* the mono-pitch's beam over the back post at least this over the slab (the pitch's max) */
    M_PITCH: [5, 25], G_PITCH: [15, 35], G_PITCH0: 25,   /* the pitch slider: mono-pitch / gable (the gable opens at 25) */
    OVG: 0.45, OVG_US: 0.4572,                     /* the gable's tie past the posts' centres, both sides */
    RIDGE_W: 0.25, RIDGE_SCR_SP: 0.30,             /* the ridge cap (ROR00009 250 mm), a screw each side every 30 cm */
    GROUT_W: 0.003, FORM_T: 0.025, COVER: 0.04, MESH_D: 0.008, MESH_SP: 0.15, MESH_SP_US: 0.1524,   /* the joints; the slab's formwork board, the mesh's cover and bars as drawn */
    PSU_D: 0.045, PSU_H: 0.04, PSU_L: 0.20         /* the LED's supply */
  };
  /* the sections (metric / US actual): the 4x4 post, the 4x8 beam, the 2x6 purlin, the 2x4 stud (sd across the wall, sw its other side), the 1x6 T&G board */
  function _mbProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.0889, bw: 0.0889, bh: 0.1842, pw: 0.0381, ph: 0.1397, sw: 0.0381, sd: 0.0889, bt: 0.01905, bf: 0.1397, rw: 0.0381, rh: 0.18415 };
    return { p: 0.100, bw: 0.100, bh: 0.200, pw: 0.060, ph: 0.160, sw: 0.060, sd: 0.100, bt: 0.019, bf: 0.146, rw: 0.060, rh: 0.200 };   /* v357 rw / rh: the gable's 2x8 rafter */
  }
  function _mbU(s, k) { return ((s || STATE).isMetric === false && MB[k + '_US'] != null) ? MB[k + '_US'] : MB[k]; }
  function _mbRange(s) { var r = _mbU(s, 'L'); return { min: r[0], max: r[1] }; }
  function _mbL(s) { s = s || STATE; var R = _mbRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _mbU(s, 'L0'))); }
  /* v357 (Marek 2026-10-26 18:54: prepinani tvaru L pravy / L levy / U bar / I tvar; sklon strechy, tvar strechy, vyska, krytina on / off -- ale default musi zustat jak to ma autor)
     THE BAR'S OPTIONS, every one defaulting to Adam's build:
       - the counter: L with its return at the right end (Adam's: the garden end -Z, the right hand seen from the stools), L left (+Z), U (both), I (none);
       - the roof: mono-pitch (Adam's, 10 deg to the back) or gable (a level tie beam on the posts, two 2x8 rafters a frame to a ridge, purlins + sheets
         on both slopes, a ridge cap); its pitch on a slider (mono 5 .. 25 deg, clamped so the beam's underside stays MIN_BACK over the slab at the back
         post; gable 15 .. 35, 25 to start);
       - the height: the beam's underside over the front post (mono) / the tie's underside (gable), 2.10 .. 3.00 m (US 7 .. 10 ft), Adam's 2.40;
       - the covering: corrugated sheets (Adam's) or open (purlins only). */
  var MB_SHAPES = ['Lr', 'Ll', 'U', 'I'];
  function _mbShape(s) { s = s || STATE; var v = s.mbShape; if (MB_SHAPES.indexOf(v) >= 0) return v; return (s.mbRet === false) ? 'I' : 'Lr'; }   /* a v355 save: mbRet false = straight */
  function _mbRets(s) { var sh = _mbShape(s); return { a: (sh === 'Lr' || sh === 'U'), b: (sh === 'Ll' || sh === 'U') }; }   /* a: the return at zA (-Z), b: at zB (+Z) */
  function _mbRet(s) { return _mbShape(s) !== 'I'; }
  function _mbRoof(s) { return ((s || STATE).mbRoof === 'gable') ? 'gable' : 'mono'; }
  function _mbCov(s) { return (s || STATE).mbCov !== false; }
  function _mbHRange(s) { var r = _mbU(s, 'HR'); return { min: r[0], max: r[1] }; }
  function _mbH(s) { s = s || STATE; var R = _mbHRange(s), v = +s.mbH; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _mbU(s, 'H_F'))); }
  function _mbPitchRange(s) {
    s = s || STATE;
    if (_mbRoof(s) === 'gable') return { min: MB.G_PITCH[0], max: MB.G_PITCH[1] };
    var P = _mbProf(s), run = 2 * _mbU(s, 'XF') + P.p / 2, mx = Math.atan(Math.max(0.01, _mbH(s) - _mbU(s, 'MIN_BACK')) / run) * 180 / Math.PI;
    return { min: MB.M_PITCH[0], max: Math.max(MB.M_PITCH[0], Math.min(MB.M_PITCH[1], Math.floor(mx + 1e-6))) };
  }
  function _mbPitch(s) {
    s = s || STATE;
    var R = _mbPitchRange(s), v = +s.mbPitch, d = (_mbRoof(s) === 'gable') ? MB.G_PITCH0 : MB.PITCH;
    return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : d));
  }
  function _mbLayout(s) {
    s = s || STATE;
    var P = _mbProf(s), us = (s.isMetric === false), L = _mbL(s), shape = _mbShape(s), R2 = _mbRets(s), ret = (shape !== 'I'), roof = _mbRoof(s), gab = (roof === 'gable'), cov = _mbCov(s), pitch = _mbPitch(s), i, j, k, q;
    var hp = P.p / 2, xF = _mbU(s, 'XF'), xB = -xF, ovz = _mbU(s, 'OVZ'), zE = L / 2 - ovz;
    var nFr = (2 * zE > _mbU(s, 'MID') + 1e-9) ? 3 : 2, zFr = [];
    for (i = 0; i < nFr; i++) zFr.push(-zE + 2 * zE * i / (nFr - 1));
    var pieces = [], fas = [], layers = [], bases = [], missing = [], proc = [], grout = [];
    var len260 = us ? 0.254 : 0.26, len100 = us ? 0.1016 : 0.10, len70 = us ? 0.0762 : 0.07, len60 = us ? 0.0635 : 0.06, len75 = us ? 0.0762 : 0.075, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.03175 : 0.032, len25 = 0.025;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function r2(v) { return Math.round(v * 100) / 100; }
    function r3(v) { return Math.round(v * 1000) / 1000; }
    function box(kind, code, len, id, x, y, z, bx, by, bz, extra) { var o = { kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }; if (extra) for (var e in extra) if (extra.hasOwnProperty(e)) o[e] = extra[e]; pieces.push(o); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function lay(kind, code, id, x, y, z, bx, by, bz, extra) { var o = { kind: kind, code: code, id: id, box: [x, y, z, bx, by, bz] }; if (extra) for (var e in extra) if (extra.hasOwnProperty(e)) o[e] = extra[e]; layers.push(o); }
    function scr(kind, code, x, y, z, d, len, r) { fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: len, r: r || 0.0035 }); }
    /* THE HEIGHTS: the slab's top, the post's foot, the roof line */
    var ySl = _mbU(s, 'SLAB_UP'), slT = _mbU(s, 'SLAB_T'), gv = _mbU(s, 'GRAVEL'), yPb = ySl + MB.BASE_UP;
    var al = pitch * Math.PI / 180, tn = Math.tan(al), ca = Math.cos(al), dv = gab ? P.bh : P.bh / ca;
    var hgt = _mbH(s), yHF = ySl + hgt;
    function yU(x) { return gab ? yHF : yHF + (x - xF) * tn; }   /* the beam's underside: under the gable the level tie, under the mono-pitch falling to the back */
    function yT(x) { return yU(x) + dv; }                     /* its top */
    var ovG = _mbU(s, 'OVG'), bx0 = gab ? xB - ovG : xB - _mbU(s, 'BOV_B'), bx1 = gab ? xF + ovG : xF + _mbU(s, 'BOV_F'), cut = MB.END_CUT;
    /* THE FRAMES: the post bases, the posts (their tops cut to the pitch), the beam */
    var nScrBase = 0;
    for (i = 0; i < nFr; i++) {
      var zf = zFr[i], fn = 'f' + (i + 1);
      for (k = 0; k < 2; k++) {
        var xp = k ? xF : xB, pid = fn + (k ? '-front' : '-back');
        bases.push({ x: xp, z: zf, y0: ySl, y1: yPb, w: MB.BASE_W, h: MB.BASE_H, id: pid });
        for (q = 0; q < 4; q++) scr('anchor', MB.ANCHOR, xp + ((q & 1) ? 1 : -1) * 0.055, ySl + 0.004, zf + ((q & 2) ? 1 : -1) * 0.055, [0, -1, 0], len75, 0.005);
        for (q = 0; q < 8; q++) { var sxq = (q < 4) ? 1 : -1; scr('screw-base', MB.BASE_SCREW, xp + sxq * (hp + 0.003), yPb + 0.03 + (q % 4) * 0.035, zf + ((q % 2) ? 0.02 : -0.02), [-sxq, 0, 0], len40, 0.0025); nScrBase++; }
        var ph0 = [[xp - hp, yPb], [xp + hp, yPb], [xp + hp, yU(xp + hp)], [xp - hp, yU(xp - hp)]];
        poly('post', MB.POST, ceil2(yU(xp + hp) - yPb), 'post-' + pid, ph0, 'xy', zf, P.p);
        for (q = -1; q <= 1; q += 2) scr('screw-beam', MB.BEAM_SCREW, xp + q * 0.025, yT(xp + q * 0.025), zf, [0, -1, 0], len260, 0.004);
      }
      var bp = [[bx0 + cut, yU(bx0 + cut)], [bx1 - cut, yU(bx1 - cut)], [bx1, yT(bx1)], [bx0, yT(bx0)]];
      poly('beam', MB.BEAM, ceil2((bx1 - bx0) / (gab ? 1 : ca)), 'beam-' + fn, bp, 'xy', zf, P.bw);
    }
    /* THE GABLE: on every tie two 2x8 rafters from its ends to the ridge over the middle (plumb cuts), 2 x 8x260 down into the tie at each foot,
       2 more through the ridge joint; the rafters' tops carry the purlins */
    var yRb = yT(bx1), rdv = P.rh / ca, xHalf = bx1;
    function yRt(x) { return yRb + (xHalf - Math.abs(x)) * tn + rdv; }   /* a rafter's top over x */
    if (gab) {
      var rL = ceil2(xHalf / ca);
      for (i = 0; i < nFr; i++) {
        for (k = -1; k <= 1; k += 2) {
          var xe = k * xHalf, yr0 = yRb + xHalf * tn;
          poly('rafter', MB.RAFTER, rL, 'rafter-f' + (i + 1) + (k < 0 ? '-back' : '-front'), [[xe, yRb], [0, yr0], [0, yr0 + rdv], [xe, yRb + rdv]], 'xy', zFr[i], P.rw);
          for (q = 0; q < 2; q++) scr('screw-rafter', MB.BEAM_SCREW, xe - k * (0.06 + q * 0.06), yRt(xe - k * (0.06 + q * 0.06)), zFr[i], [0, -1, 0], len260, 0.004);
          scr('screw-rafter', MB.BEAM_SCREW, -k * 0.012, yr0 + rdv * (0.30 + (k < 0 ? 0 : 0.40)), zFr[i], [k, 0, 0], len260, 0.004);
        }
      }
    }
    /* THE PURLINS on edge along Z on the beams' (the rafters') top, cut back underneath at the ends */
    var purs = [], nP = 0, px0, px1;
    function purlin(xpu, yb, nm) {
      var pc = cut * 0.8;
      purs.push({ x: xpu, y0: yb, y1: yb + P.ph });
      poly('purlin', MB.PURLIN, ceil2(L), nm, [[-L / 2 + pc, yb], [L / 2 - pc, yb], [L / 2, yb + P.ph], [-L / 2, yb + P.ph]], 'zy', xpu - P.pw / 2, P.pw);
      for (var jj = 0; jj < nFr; jj++) scr('screw-purlin', MB.PUR_SCREW, xpu, yb + P.ph, zFr[jj], [0, -1, 0], len260, 0.004);
      nP++;
    }
    if (gab) {
      var gx0 = xHalf - MB.PUR_IN - P.pw / 2, gx1 = P.pw / 2 + 0.01, nPs = Math.max(2, Math.ceil((gx0 - gx1) / _mbU(s, 'PUR_SP') - 1e-9) + 1);
      for (k = -1; k <= 1; k += 2) for (i = 0; i < nPs; i++) { var xg = k * (gx0 + (gx1 - gx0) * i / (nPs - 1)); purlin(xg, yRt(xg), 'purlin-' + (k < 0 ? 'b' : 'f') + (i + 1)); }
      px0 = -gx0; px1 = gx0;
    } else {
      px0 = bx0 + MB.PUR_IN + P.pw / 2; px1 = bx1 - MB.PUR_IN - P.pw / 2;
      var nPm = Math.max(2, Math.ceil((px1 - px0) / _mbU(s, 'PUR_SP') - 1e-9) + 1);
      for (i = 0; i < nPm; i++) { var xpm = px0 + (px1 - px0) * i / (nPm - 1); purlin(xpm, yT(xpm), 'purlin-' + (i + 1)); }
    }
    /* THE SHEETS on the purlins' tops (one plane a slope, the corrugations down it); a ridge cap over the gable's top */
    function ySh(x) { return (gab ? yRt(x) : yT(x)) + P.ph; }
    var sz0 = -L / 2 - MB.SH_OV, sz1 = L / 2 + MB.SH_OV, sheets = [], shA = 0, nShScr = 0, ridge = null, ridgeL = 0, nRidgeScr = 0;
    var sx0 = px0 - P.pw / 2 - MB.SH_OV, sx1 = gab ? 0 : px1 + P.pw / 2 + MB.SH_OV;
    var shRun = (sx1 - sx0) / ca, nShRow = Math.ceil((sz1 - sz0) / MB.SH_SCR_SP - 1e-9) + 1;
    if (cov) {
      sheets.push({ x0: sx0, x1: sx1, z0: sz0, z1: sz1, al: al, y0: ySh(sx0), t: MB.SH_T, wave: MB.SH_WAVE, mirror: gab });
      shA = shRun * (sz1 - sz0) * (gab ? 2 : 1);
      for (i = 0; i < purs.length; i++) for (j = 0; j < nShRow; j++) { scr('screw-sheet', MB.SH_SCREW, purs[i].x, ySh(purs[i].x) + MB.SH_T, sz0 + 0.05 + (sz1 - sz0 - 0.10) * j / (nShRow - 1), [0, -1, 0], len25, 0.003); nShScr++; }
      if (gab) {
        var yRg = ySh(0) + MB.SH_T, nRg = Math.ceil((sz1 - sz0) / MB.RIDGE_SCR_SP - 1e-9) + 1;
        ridge = { y: yRg, z0: sz0, z1: sz1, w: MB.RIDGE_W / 2, al: al };
        ridgeL = sz1 - sz0;
        for (k = -1; k <= 1; k += 2) for (j = 0; j < nRg; j++) { var xrs = k * MB.RIDGE_W * 0.32; scr('screw-ridge', MB.SH_SCREW, xrs, yRg - Math.abs(xrs) * tn + 0.004, sz0 + 0.05 + (sz1 - sz0 - 0.10) * j / (nRg - 1), [0, -1, 0], len25, 0.003); nRidgeScr++; }
      }
    }
    var sheet = sheets[0] || { x0: sx0, x1: sx1, z0: sz0, z1: sz1, al: al, y0: ySh(sx0), t: MB.SH_T, wave: MB.SH_WAVE, area: 0 };
    sheet.area = shA;
    /* THE BACK WALL between the back posts: per bay a sole plate (on sill seal), a top plate, studs; T&G boards over the bar side; the hedge panels */
    var sd = P.sd, sw = P.sw, xW = xB, yWs0 = ySl + MB.SEAL_T, yWs1 = yWs0 + sw, yWt1 = yU(xB - hp) - 0.002, yWt0 = yWt1 - sw;
    var sealM = 0, plateAnch = 0, nNail = 0, nToe = 0, bwStuds = [];
    for (i = 0; i + 1 < nFr; i++) {
      var za = zFr[i] + hp, zb = zFr[i + 1] - hp, zsa = zFr[i] + MB.BASE_W / 2 + 0.005, zsb = zFr[i + 1] - MB.BASE_W / 2 - 0.005, bn = 'b' + (i + 1);
      lay('seal', MB.SEAL, 'bw-seal-' + bn, xW, ySl + MB.SEAL_T / 2, (zsa + zsb) / 2, sd, MB.SEAL_T, zsb - zsa);
      sealM += zsb - zsa;
      box('wsole', MB.STUD, ceil2(zsb - zsa), 'bw-sole-' + bn, xW, (yWs0 + yWs1) / 2, (zsa + zsb) / 2, sd, sw, zsb - zsa);
      box('wtop', MB.STUD, ceil2(zb - za), 'bw-top-' + bn, xW, (yWt0 + yWt1) / 2, (za + zb) / 2, sd, sw, zb - za);
      for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) { scr('screw-wplate', MB.TOE, xW + q * 0.025, (yWt0 + yWt1) / 2, (k < 0 ? za : zb) - k * 0.05, [0, 0, k], len100); nToe++; }
      var nA = Math.max(2, Math.ceil((zsb - zsa - 0.30) / MB.ANCH_SP - 1e-9) + 1);
      for (q = 0; q < nA; q++) { var zan = zsa + 0.15 + (zsb - zsa - 0.30) * q / (nA - 1); scr('anchor-plate', MB.PLATE_ANCHOR, xW, yWs1, zan, [0, -1, 0], len100, 0.004); plateAnch++; }
      var nS = Math.max(1, Math.ceil((zb - za) / _mbU(s, 'BW_SP') - 1e-9)) - 1;
      for (q = 1; q <= nS; q++) {
        var zst = za + (zb - za) * q / (nS + 1);
        box('wstud', MB.STUD, ceil2(yWt0 - yWs1), 'bw-stud-' + bn + '-' + q, xW, (yWs1 + yWt0) / 2, zst, sd, yWt0 - yWs1, sw);
        bwStuds.push(zst);
        for (k = 0; k < 2; k++) for (j = -1; j <= 1; j += 2) { scr('nail-wstud', MB.NAIL, xW + j * 0.025, k ? yWt0 + 0.02 : yWs1 - 0.02, zst + (k ? 1 : -1) * 0.02, [0, k ? -1 : 1, 0], len70, 0.002); nNail++; }
      }
    }
    var xBo = xB + hp, bdZ0 = zFr[0] - hp, bdZ1 = zFr[nFr - 1] + hp, bdY0 = yWs0 + 0.02, bdY1 = yWt1, nBd = Math.max(1, Math.round((bdY1 - bdY0) / P.bf)), bdH = (bdY1 - bdY0) / nBd, bdA = (bdZ1 - bdZ0) * (bdY1 - bdY0);
    var supZ = zFr.concat(bwStuds), nBdNail = 0;
    for (i = 0; i < nBd; i++) {
      var yBd = bdY0 + bdH * (i + 0.5);
      lay('board', MB.BOARD, 'bw-board-' + (i + 1), xBo + P.bt / 2, yBd, (bdZ0 + bdZ1) / 2, P.bt, bdH - 0.003, bdZ1 - bdZ0, { timber: true });
      for (j = 0; j < supZ.length; j++) for (k = -1; k <= 1; k += 2) { scr('nail-board', MB.NAIL, xBo + P.bt, yBd + k * bdH * 0.25, supZ[j], [-1, 0, 0], len70, 0.002); nBdNail++; }
    }
    var hgY0 = Math.max(bdY0, ySl + _mbU(s, 'HEDGE_Y')), hgA = (bdZ1 - bdZ0) * Math.max(0, bdY1 - hgY0);
    if (bdY1 - hgY0 > 0.05) lay('hedge', MB.HEDGE, 'bw-hedge', xBo + P.bt + MB.HEDGE_T / 2, (hgY0 + bdY1) / 2, (bdZ0 + bdZ1) / 2, MB.HEDGE_T, bdY1 - hgY0, bdZ1 - bdZ0);
    else hgA = 0;
    /* THE COUNTER: the front run round the front posts (xI .. xO, zA .. zB); a return at the -Z end (a), at the +Z end (b) -- the shape's */
    var CD = _mbU(s, 'CD'), xO = xF + CD / 2, xI = xF - CD / 2, zA = -(L / 2 - _mbU(s, 'C_END')), zB = -zA, xR = xBo + P.bt + MB.HEDGE_T + 0.01;
    var ySt = ySl + _mbU(s, 'TOP'), tT = _mbU(s, 'TILE_T'), cbT = _mbU(s, 'CB_T'), plT = _mbU(s, 'PLY_T');
    var yFr1 = ySt - tT - MB.ADH_T - MB.MEM_T - cbT - plT, yFs0 = ySl + MB.SEAL_T, yFs1 = yFs0 + sw, yFt0 = yFr1 - sw;
    var cl = cbT + MB.STONE_T, posts = zFr.filter(function (z) { return z > zA + hp && z < zB - hp; }).map(function (z) { return { x: xF, z: z }; });
    var nStud = 0, nJoist = 0, nBrace = 0, cRuns = [];
    /* a wall: along 'z' (at x = c, the studs' face to face sd across X) or along 'x' (at z = c); from a0 to a1; n = its outward side (the studs slide in from it) */
    function wall(id, axis, c, a0, a1, n) {
      var Lw = a1 - a0, mid = (a0 + a1) / 2, sp = _mbU(s, 'ST_SP'), nn = Math.max(1, Math.ceil(Lw / sp - 1e-9)), st = [];
      function bx(kind, code, len, nm, a, y, la, h) { if (axis === 'z') box(kind, code, len, nm, c, y, a, sd, h, la, { n: n }); else box(kind, code, len, nm, a, y, c, la, h, sd, { n: n }); }
      if (axis === 'z') lay('cseal', MB.SEAL, id + '-seal', c, ySl + MB.SEAL_T / 2, mid, sd, MB.SEAL_T, Lw); else lay('cseal', MB.SEAL, id + '-seal', mid, ySl + MB.SEAL_T / 2, c, Lw, MB.SEAL_T, sd);
      sealM += Lw;
      bx('csole', MB.STUD, ceil2(Lw), id + '-sole', mid, (yFs0 + yFs1) / 2, Lw, sw);
      bx('ctop', MB.STUD, ceil2(Lw), id + '-top', mid, (yFt0 + yFr1) / 2, Lw, sw);
      for (q = 0; q <= nn; q++) {
        var a = a0 + sw / 2 + (Lw - sw) * q / nn;
        st.push(a);
        bx('cstud', MB.STUD, ceil2(yFt0 - yFs1), id + '-stud-' + (q + 1), a, (yFs1 + yFt0) / 2, sw, yFt0 - yFs1);
        nStud++;
        for (k = 0; k < 2; k++) for (j = -1; j <= 1; j += 2) {
          var yy = k ? yFt0 + 0.02 : yFs1 - 0.02, dd = [0, k ? -1 : 1, 0];
          if (axis === 'z') scr('nail-cstud', MB.NAIL, c + j * 0.025, yy, a, dd, len70, 0.002); else scr('nail-cstud', MB.NAIL, a, yy, c + j * 0.025, dd, len70, 0.002);
          nNail++;
        }
      }
      var nAn = Math.max(2, Math.ceil((Lw - 0.30) / MB.ANCH_SP - 1e-9) + 1);
      for (q = 0; q < nAn; q++) {
        var aa = a0 + 0.15 + Math.max(0, Lw - 0.30) * q / (nAn - 1);
        if (axis === 'z') scr('anchor-cplate', MB.PLATE_ANCHOR, c, yFs1, aa, [0, -1, 0], len100, 0.004); else scr('anchor-cplate', MB.PLATE_ANCHOR, aa, yFs1, c, [0, -1, 0], len100, 0.004);
        plateAnch++;
      }
      return st;
    }
    function nearPost(z) { return posts.some(function (p) { return Math.abs(p.z - z) < hp + sw / 2 + 0.01; }); }
    /* the front run */
    var stO = wall('c-out', 'z', xO - sd / 2, zA, zB, [1, 0]);
    wall('c-in', 'z', xI + sd / 2, zA, zB, [-1, 0]);
    wall('c-endB', 'x', zB - sd / 2, xI + sd, xO - sd, [0, 1]);
    wall('c-endA', 'x', zA + sd / 2, xI + sd, xO - sd, [0, -1]);
    cRuns.push({ x0: xI, x1: xO, z0: zA, z1: zB });
    /* its joists on edge across under the top at the outer wall's studs (clear of the posts) */
    var jL = CD - 2 * sd;
    for (q = 0; q < stO.length; q++) {
      var zj = stO[q];
      if (zj < zA + sd + sw || zj > zB - sd - sw || nearPost(zj)) continue;
      box('joist', MB.STUD, ceil2(jL), 'c-joist-' + (q + 1), xF, yFr1 - sd / 2, zj, jL, sd, sw);
      for (k = -1; k <= 1; k += 2) for (j = -1; j <= 1; j += 2) { scr('screw-joist', MB.TOE, xF + k * (jL / 2 - 0.04), yFr1 - 0.03 + j * 0.02, zj, [k, 0, 0], len100); nToe++; }
      nJoist++;
    }
    /* the returns: their outer wall flush with the run's end, the inner wall CD in, an end wall against the back wall */
    function retWall(t) {
      var sg = (t === 'a') ? -1 : 1, zo = (t === 'a') ? zA : zB, zi = zo - sg * CD;
      var stR = wall('r' + t + '-out', 'x', zo - sg * sd / 2, xR, xI, [0, sg]);
      wall('r' + t + '-in', 'x', zi + sg * sd / 2, xR, xI, [0, -sg]);
      wall('r' + t + '-end', 'z', xR + sd / 2, Math.min(zo, zi) + sd, Math.max(zo, zi) - sd, [-1, 0]);
      cRuns.push({ x0: xR, x1: xI, z0: Math.min(zo, zi), z1: Math.max(zo, zi) });
      for (q = 0; q < stR.length; q++) {
        var xj = stR[q];
        if (xj < xR + sd + sw || xj > xI - sw) continue;
        box('joist', MB.STUD, ceil2(jL), 'r' + t + '-joist-' + (q + 1), xj, yFr1 - sd / 2, (zo + zi) / 2, sw, sd, jL);
        for (k = -1; k <= 1; k += 2) for (j = -1; j <= 1; j += 2) { scr('screw-joist', MB.TOE, xj, yFr1 - 0.03 + j * 0.02, (zo + zi) / 2 + k * (jL / 2 - 0.04), [0, 0, k], len100); nToe++; }
        nJoist++;
      }
    }
    if (R2.a) retWall('a');
    if (R2.b) retWall('b');
    /* the braces on the bartender side of the inner wall, /\/\ from the sole to the top plate */
    var brZ0 = zA + (R2.a ? CD : 0) + 0.10, brZ1 = zB - (R2.b ? CD : 0) - 0.10, brH = yFt0 - yFs1, nBr = Math.max(2, Math.round((brZ1 - brZ0) / 1.0)), brRun = (brZ1 - brZ0) / nBr, xBr = xI - sw / 2;
    for (i = 0; i < nBr; i++) {
      var zb0 = brZ0 + i * brRun, zb1 = zb0 + brRun, up = (i % 2 === 0), yA0 = up ? yFs1 : yFt0, yA1 = up ? yFt0 : yFs1;
      var eL = Math.sqrt(brRun * brRun + brH * brH), uz = brRun / eL, uy = (yA1 - yA0) / eL, h2 = sd / 2;
      var bpl = [[zb0 + uy * h2, yA0 - uz * h2], [zb1 + uy * h2, yA1 - uz * h2], [zb1 - uy * h2, yA1 + uz * h2], [zb0 - uy * h2, yA0 + uz * h2]];
      bpl = _gsClip(bpl, [0, 1, -yFs1]); bpl = _gsClip(bpl, [0, -1, yFt0]);
      poly('cbrace', MB.STUD, ceil2(eL), 'c-brace-' + (i + 1), bpl, 'zy', xBr - sw / 2, sw);
      for (k = 0; k < 2; k++) for (j = -1; j <= 1; j += 2) {
        var yEnd = k ? yA1 : yA0, zq = k ? zb1 - 0.06 : zb0 + 0.06;
        scr('screw-cbrace', MB.TOE, xI - sw, yEnd + ((yEnd === yFs1) ? 0.04 : -0.04) + j * 0.02, zq, [1, 0, 0], len100);
        nToe++;
      }
      nBrace++;
    }
    /* the cladding on the outer faces: cement board, the stone's flexible adhesive, the stone on it (the corners wrap) */
    var faces = [], yCl0 = yFs0, yCl1 = yFr1, yStn0 = ySl + MB.STONE_UP;
    faces.push({ id: 'front', n: [1, 0], c: xO, a0: zA, a1: zB, ax: 'z' });
    faces.push({ id: 'endB', n: [0, 1], c: zB, a0: R2.b ? xR : xI, a1: xO, ax: 'x' });
    faces.push({ id: 'endA', n: [0, -1], c: zA, a0: R2.a ? xR : xI, a1: xO, ax: 'x' });
    var cbA = 0, stA = 0, nCbScr = 0, faceL = 0, stT = MB.STONE_T - MB.ADH_T;
    for (i = 0; i < faces.length; i++) {
      var F = faces[i], Lf = F.a1 - F.a0, sgn = (F.n[0] + F.n[1]), am = (F.a0 + F.a1) / 2;
      var cbC = F.c + sgn * cbT / 2, adC = F.c + sgn * (cbT + MB.ADH_T / 2), stC = F.c + sgn * (cbT + MB.ADH_T + stT / 2);
      var cbL = (F.ax === 'z') ? Lf + 2 * cbT : Lf, adL = (F.ax === 'z') ? Lf + 2 * (cbT + MB.ADH_T) : Lf, stL = (F.ax === 'z') ? Lf + 2 * cl : Lf, ex = { n: F.n };
      if (F.ax === 'z') {
        lay('cb', MB.CB, 'cb-' + F.id, cbC, (yCl0 + yCl1) / 2, am, cbT, yCl1 - yCl0, cbL, ex);
        lay('sadh', MB.ADHESIVE, 'sadh-' + F.id, adC, (yStn0 + yCl1) / 2, am, MB.ADH_T, yCl1 - yStn0, adL, ex);
        lay('stone', MB.STONE, 'stone-' + F.id, stC, (yStn0 + yCl1) / 2, am, stT, yCl1 - yStn0, stL, { stone: true, n: F.n });
      } else {
        lay('cb', MB.CB, 'cb-' + F.id, am, (yCl0 + yCl1) / 2, cbC, Lf, yCl1 - yCl0, cbT, ex);
        lay('sadh', MB.ADHESIVE, 'sadh-' + F.id, am, (yStn0 + yCl1) / 2, adC, Lf, yCl1 - yStn0, MB.ADH_T, ex);
        lay('stone', MB.STONE, 'stone-' + F.id, am, (yStn0 + yCl1) / 2, stC, Lf, yCl1 - yStn0, stT, { stone: true, n: F.n });
      }
      cbA += cbL * (yCl1 - yCl0); stA += stL * (yCl1 - yStn0); faceL += stL;
      /* the cement board's screws: every 20 cm up every stud, every 20 cm along both plates */
      var nUp = Math.max(2, Math.ceil((yCl1 - yCl0) / MB.CB_SCR_SP - 1e-9) + 1), stp = Math.max(1, Math.ceil(Lf / _mbU(s, 'ST_SP') - 1e-9));
      for (q = 0; q <= stp; q++) for (j = 0; j < nUp; j++) {
        var aq = F.a0 + 0.03 + (Lf - 0.06) * q / stp, yq = yCl0 + 0.03 + (yCl1 - yCl0 - 0.06) * j / (nUp - 1);
        if (F.ax === 'z') scr('screw-cb', MB.CB_SCREW, F.c + sgn * cbT, yq, aq, [-sgn, 0, 0], len32, 0.002); else scr('screw-cb', MB.CB_SCREW, aq, yq, F.c + sgn * cbT, [0, 0, -sgn], len32, 0.002);
        nCbScr++;
      }
    }
    /* THE TOP: the run (and each return) 3 cm past the stone outside, 5 cm past the inner wall; layers from the ply up, holes round the posts */
    var oo = cl + MB.TOP_OUT, ti = MB.TOP_IN;
    var tops = [{ x0: xI - ti, x1: xO + oo, z0: zA - oo, z1: zB + oo }];
    if (R2.a) tops.push({ x0: xR, x1: xI - ti, z0: zA - oo, z1: zA + CD + ti });
    if (R2.b) tops.push({ x0: xR, x1: xI - ti, z0: zB - CD - ti, z1: zB + oo });
    var topA = 0, trimL = 0;
    for (i = 0; i < tops.length; i++) topA += (tops[i].x1 - tops[i].x0) * (tops[i].z1 - tops[i].z0);
    var holeA = posts.length * P.p * P.p;
    topA -= holeA;
    var yPly0 = yFr1, yPly1 = yPly0 + plT, yCb1 = yPly1 + cbT, yMem1 = yCb1 + MB.MEM_T, yTl0 = yMem1 + MB.ADH_T;
    var nPlyScr = 0, nCbTopScr = 0;
    /* each slab of the top cut round the posts: whole between them, two strips beside each */
    function topBoxes(kind, code, y0, y1, extra) {
      for (var t = 0; t < tops.length; t++) {
        var T0 = tops[t], zc = [T0.z0], pz = posts.filter(function (p) { return t === 0 && p.z > T0.z0 && p.z < T0.z1; }).map(function (p) { return p.z; }).sort(function (a, b) { return a - b; });
        for (var u = 0; u < pz.length; u++) zc.push(pz[u] - hp - 0.003, pz[u] + hp + 0.003);
        zc.push(T0.z1);
        for (u = 0; u + 1 < zc.length; u += 2) if (zc[u + 1] - zc[u] > 0.001) lay(kind, code, kind + '-' + (t + 1) + '-' + (u / 2 + 1), (T0.x0 + T0.x1) / 2, (y0 + y1) / 2, (zc[u] + zc[u + 1]) / 2, T0.x1 - T0.x0, y1 - y0, zc[u + 1] - zc[u], extra);
        for (u = 0; u < pz.length; u++) {
          var zz0 = pz[u] - hp - 0.003, zz1 = pz[u] + hp + 0.003;
          if (xF - hp - 0.003 - T0.x0 > 0.001) lay(kind, code, kind + '-' + (t + 1) + '-p' + (u + 1) + 'a', (T0.x0 + xF - hp - 0.003) / 2, (y0 + y1) / 2, (zz0 + zz1) / 2, xF - hp - 0.003 - T0.x0, y1 - y0, zz1 - zz0, extra);
          if (T0.x1 - (xF + hp + 0.003) > 0.001) lay(kind, code, kind + '-' + (t + 1) + '-p' + (u + 1) + 'b', (xF + hp + 0.003 + T0.x1) / 2, (y0 + y1) / 2, (zz0 + zz1) / 2, T0.x1 - (xF + hp + 0.003), y1 - y0, zz1 - zz0, extra);
        }
      }
    }
    topBoxes('ply', MB.PLY, yPly0, yPly1);
    topBoxes('cbtop', MB.CB, yPly1, yCb1);
    topBoxes('mem', MB.MEMBRANE, yCb1, yMem1);
    topBoxes('tadh', MB.ADHESIVE, yMem1, yTl0);
    topBoxes('tile', MB.TILES, yTl0, ySt, { tile: true });
    /* the grout: the joints of the 20 cm tiles (keyed to the world, as the tiles' texture), filled flush */
    for (i = 0; i < tops.length; i++) {
      var Tg = tops[i], gw = MB.GROUT_W, e0;
      for (e0 = Math.ceil((Tg.x0 + 0.01) / MB.TILE) * MB.TILE; e0 < Tg.x1 - 0.01; e0 += MB.TILE) grout.push([e0, ySt + 0.0003, (Tg.z0 + Tg.z1) / 2, gw, 0.0012, Tg.z1 - Tg.z0]);
      for (e0 = Math.ceil((Tg.z0 + 0.01) / MB.TILE) * MB.TILE; e0 < Tg.z1 - 0.01; e0 += MB.TILE) grout.push([(Tg.x0 + Tg.x1) / 2, ySt + 0.0003, e0, Tg.x1 - Tg.x0, 0.0012, gw]);
    }
    /* the ply's screws: every 20 cm along the walls' top plates, 2 into every joist; the top's cement board on a 20 cm grid -- as drawn */
    function postAt(x, z) { return posts.some(function (p) { return Math.abs(p.x - x) < hp + 0.03 && Math.abs(p.z - z) < hp + 0.03; }); }
    function plyRow(axis, c, a0, a1) {
      var n = Math.max(2, Math.ceil((a1 - a0 - 0.10) / MB.PLY_SCR_SP - 1e-9) + 1);
      for (var u = 0; u < n; u++) {
        var a = a0 + 0.05 + (a1 - a0 - 0.10) * u / (n - 1), x = (axis === 'z') ? c : a, z = (axis === 'z') ? a : c;
        if (postAt(x, z)) continue;
        scr('screw-ply', MB.PLY_SCREW, x, yPly1, z, [0, -1, 0], len60, 0.0025); nPlyScr++;
      }
    }
    plyRow('z', xO - sd / 2, zA, zB); plyRow('z', xI + sd / 2, zA, zB);
    if (R2.a) { plyRow('x', zA + sd / 2, xR, xI); plyRow('x', zA + CD - sd / 2, xR, xI); }
    if (R2.b) { plyRow('x', zB - sd / 2, xR, xI); plyRow('x', zB - CD + sd / 2, xR, xI); }
    for (i = 0; i < pieces.length; i++) if (pieces[i].kind === 'joist') {
      var jb = pieces[i].box, alongX = jb[3] > jb[5];
      for (k = -1; k <= 1; k += 2) { scr('screw-ply', MB.PLY_SCREW, alongX ? jb[0] + k * jb[3] / 4 : jb[0], yPly1, alongX ? jb[2] : jb[2] + k * jb[5] / 4, [0, -1, 0], len60, 0.0025); nPlyScr++; }
    }
    for (i = 0; i < tops.length; i++) {
      var T1 = tops[i], nx = Math.max(2, Math.round((T1.x1 - T1.x0) / MB.CB_SCR_SP)), nz = Math.max(2, Math.round((T1.z1 - T1.z0) / MB.CB_SCR_SP));
      for (j = 0; j < nz; j++) for (k = 0; k < nx; k++) {
        var xs = T1.x0 + 0.05 + (T1.x1 - T1.x0 - 0.10) * k / (nx - 1), zs = T1.z0 + 0.05 + (T1.z1 - T1.z0 - 0.10) * j / (nz - 1);
        if (postAt(xs, zs)) continue;
        scr('screw-cbtop', MB.CB_SCREW, xs, yCb1, zs, [0, -1, 0], len32, 0.002); nCbTopScr++;
      }
    }
    /* the trim on the top's edges and the LED strip under its outer lip; the LED's supply under the top on the bartender side */
    var yTrim = (yPly0 + ySt) / 2, hTrim = ySt - yPly0, xTo = xO + oo, zTa = zA - oo, zTb = zB + oo, TT = MB.TRIM_T;
    var xEa = R2.a ? xR : xI - ti, xEb = R2.b ? xR : xI - ti, zIa = R2.a ? zA + CD + ti : zTa, zIb = R2.b ? zB - CD - ti : zTb;
    lay('trim', MB.TRIM, 'trim-front', xTo + TT / 2, yTrim, (zTa + zTb) / 2, TT, hTrim, zTb - zTa + 2 * TT, { n: [1, 0] });
    lay('trim', MB.TRIM, 'trim-endB', (xEb + xTo) / 2, yTrim, zTb + TT / 2, xTo - xEb, hTrim, TT, { n: [0, 1] });
    lay('trim', MB.TRIM, 'trim-endA', (xEa + xTo) / 2, yTrim, zTa - TT / 2, xTo - xEa, hTrim, TT, { n: [0, -1] });
    lay('trim', MB.TRIM, 'trim-in', xI - ti - TT / 2, yTrim, (zIa + zIb) / 2, TT, hTrim, zIb - zIa, { n: [-1, 0] });
    if (R2.a) lay('trim', MB.TRIM, 'trim-rinA', (xR + xI - ti) / 2, yTrim, zA + CD + ti + TT / 2, xI - ti - xR, hTrim, TT, { n: [0, 1] });
    if (R2.b) lay('trim', MB.TRIM, 'trim-rinB', (xR + xI - ti) / 2, yTrim, zB - CD - ti - TT / 2, xI - ti - xR, hTrim, TT, { n: [0, -1] });
    trimL = (zTb - zTa) + (xTo - xEb) + (xTo - xEa) + (zIb - zIa) + (R2.a ? xI - ti - xR : 0) + (R2.b ? xI - ti - xR : 0);
    var yLed = yPly0 - MB.LED_T / 2 - 0.004, ledM = 0, xLa = R2.a ? xR : xI, xLb = R2.b ? xR : xI;
    lay('led', MB.LED, 'led-front', xO + cl + 0.012, yLed, (zA - cl + zB + cl) / 2, 0.012, MB.LED_T, zB - zA + 2 * cl, { n: [1, 0] });
    lay('led', MB.LED, 'led-endB', (xLb + xO + cl) / 2, yLed, zB + cl + 0.012, xO + cl - xLb, MB.LED_T, 0.012, { n: [0, 1] });
    lay('led', MB.LED, 'led-endA', (xLa + xO + cl) / 2, yLed, zA - cl - 0.012, xO + cl - xLa, MB.LED_T, 0.012, { n: [0, -1] });
    ledM = (zB - zA + 2 * cl) + (xO + cl - xLb) + (xO + cl - xLa);
    lay('psu', MB.PSU, 'led-psu', xI - sw - MB.PSU_D / 2 - 0.005, yFr1 - 0.09, zB - (R2.b ? CD : 0) - 0.35, MB.PSU_D, MB.PSU_H, MB.PSU_L, { n: [-1, 0] });
    /* THE SLAB (and its bed: gravel, geotextile) */
    var slX0 = xB - hp - MB.SLAB_BACK, slX1 = xO + cl + _mbU(s, 'SLAB_FRONT'), slZ0 = -L / 2 + MB.SLAB_END, slZ1 = L / 2 - MB.SLAB_END;
    var slA = (slX1 - slX0) * (slZ1 - slZ0), bo = MB.BED_OUT, bedA = (slX1 - slX0 + 2 * bo) * (slZ1 - slZ0 + 2 * bo);
    var slab = { x0: slX0, x1: slX1, z0: slZ0, z1: slZ1, y0: ySl - slT, y1: ySl, g0: ySl - slT - gv, bo: bo };
    /* v357 the slab's making, drawn for its own assembly steps only: the dig (out of the ground), the geotextile (its floor and sides), the
       edge formwork (until the concrete is in), the spacers on the gravel and the mesh on them (inside the slab once it is poured) */
    var bx0b = slX0 - bo, bx1b = slX1 + bo, bz0b = slZ0 - bo, bz1b = slZ1 + bo, bcx = (bx0b + bx1b) / 2, bcz = (bz0b + bz1b) / 2, yG0 = slab.g0, yS0 = slab.y0, GT = 0.003;
    proc.push({ kind: 'dig', code: MB.DIG, id: 'dig', box: [bcx, (yG0 + 0.01) / 2, bcz, bx1b - bx0b + 0.04, 0.01 - yG0, bz1b - bz0b + 0.04], n: [0, -1] });
    proc.push({ kind: 'geo', code: MB.GEOTEX, id: 'geo-floor', box: [bcx, yG0 + GT / 2, bcz, bx1b - bx0b, GT, bz1b - bz0b], n: [0, 1] });
    proc.push({ kind: 'geo', code: MB.GEOTEX, id: 'geo-back', box: [bx0b + GT / 2, (yG0 + yS0) / 2, bcz, GT, yS0 - yG0, bz1b - bz0b], n: [0, 1] });
    proc.push({ kind: 'geo', code: MB.GEOTEX, id: 'geo-front', box: [bx1b - GT / 2, (yG0 + yS0) / 2, bcz, GT, yS0 - yG0, bz1b - bz0b], n: [0, 1] });
    proc.push({ kind: 'geo', code: MB.GEOTEX, id: 'geo-endA', box: [bcx, (yG0 + yS0) / 2, bz0b + GT / 2, bx1b - bx0b, yS0 - yG0, GT], n: [0, 1] });
    proc.push({ kind: 'geo', code: MB.GEOTEX, id: 'geo-endB', box: [bcx, (yG0 + yS0) / 2, bz1b - GT / 2, bx1b - bx0b, yS0 - yG0, GT], n: [0, 1] });
    var FT = MB.FORM_T, fy0 = yS0 - 0.02, fy1 = ySl + 0.03, scx = (slX0 + slX1) / 2, scz = (slZ0 + slZ1) / 2;
    proc.push({ kind: 'form', code: MB.FORMWORK, id: 'form-back', box: [slX0 - FT / 2, (fy0 + fy1) / 2, scz, FT, fy1 - fy0, slZ1 - slZ0 + 2 * FT], n: [-1, 0] });
    proc.push({ kind: 'form', code: MB.FORMWORK, id: 'form-front', box: [slX1 + FT / 2, (fy0 + fy1) / 2, scz, FT, fy1 - fy0, slZ1 - slZ0 + 2 * FT], n: [1, 0] });
    proc.push({ kind: 'form', code: MB.FORMWORK, id: 'form-endA', box: [scx, (fy0 + fy1) / 2, slZ0 - FT / 2, slX1 - slX0, fy1 - fy0, FT], n: [0, -1] });
    proc.push({ kind: 'form', code: MB.FORMWORK, id: 'form-endB', box: [scx, (fy0 + fy1) / 2, slZ1 + FT / 2, slX1 - slX0, fy1 - fy0, FT], n: [0, 1] });
    var spN = Math.ceil(slA * MB.SPACER_M2), spSp = Math.sqrt(slA / Math.max(1, spN)), spNx = Math.max(2, Math.round((slX1 - slX0 - 0.30) / spSp) + 1), spNz = Math.max(2, Math.ceil(spN / spNx)), CV = MB.COVER;
    for (i = 0; i < spNx; i++) for (j = 0; j < spNz; j++) proc.push({ kind: 'spacer', code: MB.SPACER, id: 'spacer-' + (i + 1) + '-' + (j + 1), box: [slX0 + 0.15 + (slX1 - slX0 - 0.30) * i / (spNx - 1), yS0 + CV / 2, slZ0 + 0.15 + (slZ1 - slZ0 - 0.30) * j / (spNz - 1), 0.04, CV, 0.04], n: [0, 1] });
    var msp = _mbU(s, 'MESH_SP'), mD = MB.MESH_D, mIn = 0.05, mesh = [];
    for (var mx = slX0 + mIn; mx <= slX1 - mIn + 1e-6; mx += msp) mesh.push([mx, yS0 + CV + mD / 2, scz, mD, mD, slZ1 - slZ0 - 2 * mIn]);
    for (var mz = slZ0 + mIn; mz <= slZ1 - mIn + 1e-6; mz += msp) mesh.push([scx, yS0 + CV + 1.5 * mD, mz, slX1 - slX0 - 2 * mIn, mD, mD]);
    /* THE STOOLS in front, the BULBS zig-zag under the purlins (under the gable: under its ties) */
    var xSt = xO + cl + MB.TOP_OUT + MB.STOOL_OUT, stZ0 = zA + MB.STOOL_END, stZ1 = zB - MB.STOOL_END, nSt = Math.max(1, Math.floor((stZ1 - stZ0) / MB.STOOL_SP + 1e-6) + 1), stools = [], ySeat = _mbU(s, 'STOOL_SEAT');
    for (i = 0; i < nSt; i++) stools.push({ x: xSt, z: (nSt === 1) ? 0 : stZ0 + (stZ1 - stZ0) * i / (nSt - 1), y: ySeat, r: MB.STOOL_R });
    var lxA = xB + MB.LIGHT_IN, lxB = xF - MB.LIGHT_IN * 0.5, nLs = Math.max(2, Math.round(2 * zE / MB.LIGHT_STEP)), cable = [], bulbs = [], cabL = 0;
    function yLt(x) { return gab ? yHF - 0.03 : yT(x) - 0.02; }
    for (i = 0; i < nLs; i++) {
      var za2 = -zE + 2 * zE * i / nLs, zb2 = -zE + 2 * zE * (i + 1) / nLs, xa = (i % 2) ? lxB : lxA, xb2 = (i % 2) ? lxA : lxB, nq = 14;
      for (q = 0; q <= nq; q++) {
        var f = q / nq, xq = xa + (xb2 - xa) * f, Pq = [xq, yLt(xa) + (yLt(xb2) - yLt(xa)) * f - 4 * MB.LIGHT_SAG * f * (1 - f), za2 + (zb2 - za2) * f];
        if (q > 0 || i === 0) {
          if (cable.length) { var Pp = cable[cable.length - 1]; cabL += Math.sqrt(Math.pow(Pq[0] - Pp[0], 2) + Math.pow(Pq[1] - Pp[1], 2) + Math.pow(Pq[2] - Pp[2], 2)); }
          cable.push(Pq);
        }
      }
    }
    var acc = 0;
    for (i = 1; i < cable.length; i++) {
      var A = cable[i - 1], B = cable[i], dl = Math.sqrt(Math.pow(B[0] - A[0], 2) + Math.pow(B[1] - A[1], 2) + Math.pow(B[2] - A[2], 2));
      acc += dl;
      if (acc >= MB.LIGHT_SP) { acc -= MB.LIGHT_SP; bulbs.push([B[0], B[1] - 0.03, B[2]]); }
    }
    var lightN = cable.length ? Math.max(1, Math.ceil(cabL / MB.LIGHT_STRING)) : 0;
    /* the bill's quantities: timber by code, the coating (every face of the frame timber, both faces of the boards) */
    var m = {}, coat = 0;
    for (i = 0; i < pieces.length; i++) {
      var pcI = pieces[i];
      if (pcI.sub || !(pcI.len > 0)) continue;
      m[pcI.code] = (m[pcI.code] || 0) + pcI.len;
      var sec = (pcI.code === MB.POST) ? [P.p, P.p] : (pcI.code === MB.BEAM) ? [P.bw, P.bh] : (pcI.code === MB.PURLIN) ? [P.pw, P.ph] : (pcI.code === MB.RAFTER) ? [P.rw, P.rh] : [sw, sd];
      coat += 2 * (sec[0] + sec[1]) * pcI.len;
    }
    coat += 2 * bdA;
    var yTop = gab ? (cov ? ridge.y + 0.01 : yRt(P.pw / 2) + P.ph) : ySh(sx1) + (cov ? MB.SH_T : 0);
    return {
      P: P, us: us, L: L, ret: ret, shape: shape, rets: R2, roof: roof, cov: cov, pitch: pitch, hgt: hgt, nFr: nFr, zFr: zFr, xF: xF, xB: xB, zE: zE, pieces: pieces, fas: fas, layers: layers, bases: bases, missing: missing,
      proc: proc, mesh: mesh, grout: grout, sheets: sheets, ridge: ridge, ridgeL: r2(ridgeL),
      purlins: purs, nP: nP, sheet: sheet, slab: slab, stools: stools, cable: cable, bulbs: bulbs, cableL: cabL, lightN: lightN,
      meters: m, coat: coat, sealM: r2(sealM),
      boardA: bdA, hedgeA: hgA, cbSideA: cbA, stoneA: stA, topA: topA, trimL: trimL, ledM: ledM,
      slabA: slA, bedA: bedA, concM3: r3(slA * slT * MB.CONC_WASTE), gravelM3: r3(bedA * gv), digM3: r3(bedA * (slT + gv - ySl)), geoA: r2(bedA + 2 * (slX1 - slX0 + slZ1 - slZ0 + 4 * bo) * gv),
      meshN: Math.max(1, Math.ceil(slA * 1.15 / MB.MESH_A - 1e-9)), spacerN: spNx * spNz,   /* v357 the spacers as drawn */
      nShScr: nShScr, nCbScr: nCbScr, nCbTopScr: nCbTopScr, nPlyScr: nPlyScr, plateAnch: plateAnch, nStud: nStud, nJoist: nJoist, nBrace: nBrace,
      xO: xO, xI: xI, xR: xR, zA: zA, zB: zB, CD: CD, ySt: ySt, yFr1: yFr1, ySl: ySl, yHF: yHF, cl: cl, xTop: xTo,
      height: yTop, depth: Math.max(slX1 - slX0, (bx1 - bx0)), length: L, roofA: shA, bx0: bx0, bx1: bx1
    };
  }
  /* v357 its staged assembly ONE CATALOGUE ITEM A STEP (Marek 18:35: kroky assembly po jednom kroku, texty z BOQ vcetne prekladu): the step's caption is
     that item's name from the central BoQ in the page's language; a step whose parts are not drawn (no rafters under the mono-pitch, no sheets when
     open, no return on the I) drops out. MB_PROC: the slab's making, drawn only while it is being made (_benchVisibleAtStep). */
  var MB_PROC = { 'mb-dig': 'own', 'mb-geo': 'slab', 'mb-form': 'slab', 'mb-spacer': 'slab', 'mb-mesh': 'slab' };
  var MB_STEPS = [
    { parts: [], codes: [] },
    { parts: ['mb-dig'], codes: ['FEE00001'] },
    { parts: ['mb-geo'], codes: ['FEC00003'] },
    { parts: ['mb-gravel'], codes: ['FCO00001'] },
    { parts: ['mb-form'], codes: ['FFF00002'] },
    { parts: ['mb-spacer'], codes: ['FFM00004'] },
    { parts: ['mb-mesh'], codes: ['PBF30001'] },
    { parts: ['mb-slab'], codes: ['FFM00001'] },
    { parts: ['mb-base'], codes: ['FAT00017'] },
    { parts: ['mb-hw-anchor'], codes: ['FAS10075'] },
    { parts: ['mb-post'], codes: ['KVH10100'] },
    { parts: ['mb-hw-screw-base'], codes: ['FAS50040'] },
    { parts: ['mb-beam'], codes: ['KVH10200'] },
    { parts: ['mb-hw-screw-beam'], codes: ['FAS80260'] },
    { parts: ['mb-rafter'], codes: ['KVH60200'] },
    { parts: ['mb-hw-screw-rafter'], codes: ['FAS80260'] },
    { parts: ['mb-purlin'], codes: ['KVH60160'] },
    { parts: ['mb-hw-screw-purlin'], codes: ['FAS80260'] },
    { parts: ['mb-sheet'], codes: ['ROR12004'] },
    { parts: ['mb-hw-screw-sheet'], codes: ['FAS00225'] },
    { parts: ['mb-ridge'], codes: ['ROR00009'] },
    { parts: ['mb-hw-screw-ridge'], codes: ['FAS00225'] },
    { parts: ['mb-seal'], codes: ['INS01003'] },
    { parts: ['mb-wsole'], codes: ['KVH10060'] },
    { parts: ['mb-hw-anchor-plate'], codes: ['FAS75100'] },
    { parts: ['mb-wstud'], codes: ['KVH10060'] },
    { parts: ['mb-wtop'], codes: ['KVH10060'] },
    { parts: ['mb-hw-screw-wplate'], codes: ['FAS60100'] },
    { parts: ['mb-hw-nail-wstud'], codes: ['FAS70000'] },
    { parts: ['mb-board'], codes: ['KVR14619'] },
    { parts: ['mb-hw-nail-board'], codes: ['FAS70000'] },
    { parts: [], codes: ['MFP00002'], highlight: ['mb-post', 'mb-beam', 'mb-rafter', 'mb-purlin', 'mb-board'] },   /* the coating: the timber in view lit, the rest faded */
    { parts: ['mb-hedge'], codes: ['FEC00047'] },
    { parts: ['mb-cseal'], codes: ['INS01003'] },
    { parts: ['mb-csole'], codes: ['KVH10060'] },
    { parts: ['mb-hw-anchor-cplate'], codes: ['FAS75100'] },
    { parts: ['mb-cstud'], codes: ['KVH10060'] },
    { parts: ['mb-ctop'], codes: ['KVH10060'] },
    { parts: ['mb-hw-nail-cstud'], codes: ['FAS70000'] },
    { parts: ['mb-joist'], codes: ['KVH10060'] },
    { parts: ['mb-hw-screw-joist'], codes: ['FAS60100'] },
    { parts: ['mb-cbrace'], codes: ['KVH10060'] },
    { parts: ['mb-hw-screw-cbrace'], codes: ['FAS60100'] },
    { parts: ['mb-cb'], codes: ['FCB00013'] },
    { parts: ['mb-hw-screw-cb'], codes: ['FAT16012'] },
    { parts: ['mb-sadh'], codes: ['FEC00018'] },
    { parts: ['mb-stone'], codes: ['FCP00010'] },
    { parts: ['mb-ply'], codes: ['FFW00003'] },
    { parts: ['mb-hw-screw-ply'], codes: ['FAS50060'] },
    { parts: ['mb-cbtop'], codes: ['FCB00013'] },
    { parts: ['mb-hw-screw-cbtop'], codes: ['FAT16012'] },
    { parts: ['mb-mem'], codes: ['FEC00025'] },
    { parts: ['mb-tadh'], codes: ['FEC00018'] },
    { parts: ['mb-trim'], codes: ['FFC00008'] },
    { parts: ['mb-tile'], codes: ['FFC00003'] },
    { parts: ['mb-grout'], codes: ['SBG00001'] },
    { parts: ['mb-led'], codes: ['EEC00006'] },
    { parts: ['mb-psu'], codes: ['EEC00007'] },
    { parts: ['mb-hw-lights'], codes: ['EEC00008'] },
    { parts: ['mb-hw-stool'], codes: ['FMC00013'] }
  ];

  /* ------------------------------------------------------------------
     TYPE 20 -- GARDEN STRUCTURE, variant 2: THE RAISED BED (bench-v314,
     Marek 2026-10-21 01:51 with three photos: "Dalsi structure bude
     vyvyseny zahon. Muze byt nizky az vysoky, pyramidovy a take s
     otviranymi kridly, ramem vyplnenym vinyl sheets. Prepinani mezi
     variantami v banneru (obycejny, pyramida, s kridly), editovat se da
     vyska, sirka, delka. U zakladniho provedeni vetsi variabilita
     zakladnich rozmeru, u kridel pak tak, aby prave ram s kridly daval
     smysl. Ale muze byt take delsi -- pri urcite zmene muze byt 2 + 2
     kridla.").
     X = across (W), Y = up, Z = along (L). Three modes on the info-bar
     switch (STATE.rbMode); L / W / N on the handles:
       - BASIC: walls of 2x8 boards KVH60200 on edge, 1 - 5 courses (20 cm
         / US 7 1/4 in. a course), the long walls through, the short ones
         between them; 4x4 posts KVH10100 inside the corners and along the
         walls at <= 1.20 m (US 4 ft), every board screwed to every post it
         crosses with 2 x 6x100 FAS60100; a 2x6 cap KVH60160 flat on top, 2
         cm proud outside, the long caps through, screwed into every post
         and into the boards between; geotextile PFG00001 under the soil
         (10 cm up the walls), the soil SFF00004 5 cm under the walls' top.
       - PYRAMID: tiers of one course each, every one 20 cm (US 8 in.) in
         from the one under it, 2 - 5 while the top one keeps 40 cm; each
         tier's posts run down to the ground through the soil below; no cap.
       - WINGS (bench-v315, Marek 07:31 on the v314 frame: "S kridly ma
         spatny stit. Stit tvori ram, ktery vede ve vnitrni casti v rozich.
         A je spojeny hrebenem. To by mely byt nejmasivnejsi profily ...
         Samotna kridla by pak nemusel byt az tak masivni ram ... folii jen
         jako pridelanou sponkami? ... Pri animaci kridla neotevirat uplne
         do konce a pridelat tam funkcni vzperu, ktera je necha otevrene
         treba na 70 % pro praci a sber"; chose: the bed's corner posts on
         up, staples + a batten round the wing's edge): the basic bed (1 - 4
         courses) whose corner posts are the cold frame's -- 80x80 KVH08080
         (US 4x4 KVH10100, no 3x3 in US stock), up through a notch in the
         cap 15 cm (US 6 in.) over it (v327 5 cm / US 2 in. -- Marek 17:49:
         "nizsi sloup pod sikmymi profily ... aby se clovek mohl lepe
         dostavat k hline"), their tops cut to the 30 deg pitch;
         on them the end gables' rafters of the same section (a plumb tail
         flush with the walls' inner face, 2 x 6x160 FAS60160 down into the
         post), meeting at the apex under the ridge of the same section (it
         sits in their notch, a 6x120 FAS60120 down into each rafter); an
         eave rail of the same section along each long side between the end
         rafters, its top bevelled flush with theirs (2 x FAS60160 through
         each end rafter into it); 2 + 2 wings past 1.50 m / 5 ft over a
         middle frame (posts at the long walls' middle under the eave rails,
         2 x FAS60120 down into each; its rafters against the rails' inner
         face, 2 x FAS60120 through the rail into each). The gables and the
         long sides under the eaves closed with clear vinyl OEB00001 on the
         frame's outer faces, stapled, folded onto the cap. Wings: a light
         sash of 30x30 KVH03030 (US 2x2 KVH03838; a 4.5x70 stainless
         through the rail into every stile), the vinyl stapled on it, 1x2
         battens KVL20040 round its edge only (5x40 FAS50040, US 5.5x50
         FAS55050), door hinges ODD00005 on the ridge's top (2 a wing, 3
         past 1.20 m; 3 + 3 screws 5x40). The toggle opens them 70 % of the
         way (~86 deg), where a lid support FAT00023 at each end gable (its
         body on the rafter's inner face, its rod under a stile of the wing)
         stops and holds them; swung slowly. The staples have no catalogue
         row: drawn, counted, NOT BILLED (MISSING). v326 (Marek 17:36: "jen
         jedno kridlo zvednute v open rezimu"): the toggle raises ONE wing --
         the front one, for 2 + 2 the front one at +Z (nearer the view); the
         rest stay shut, each still on its own lid supports.
     L = the walls' outer length, W = their outer width (the cap 2 cm out),
     N = courses / tiers. _rbLayout(STATE) is the single source. */
  var RB = {
    BASIC: { L: [0.90, 4.80], L_US: [0.9144, 4.8768], W: [0.60, 1.80], W_US: [0.6096, 1.8288], N: [1, 5], L0: 2.40, L0_US: 2.4384, W0: 1.20, W0_US: 1.2192, N0: 2 },
    PYR:   { L: [1.00, 3.00], L_US: [1.0160, 3.0480], W: [1.00, 3.00], W_US: [1.0160, 3.0480], N: [2, 5], L0: 1.60, L0_US: 1.8288, W0: 1.60, W0_US: 1.8288, N0: 4 },
    WINGS: { L: [0.90, 3.00], L_US: [0.9144, 3.0480], W: [0.90, 1.30], W_US: [0.9144, 1.2192], N: [1, 4], L0: 2.40, L0_US: 2.4384, W0: 1.30, W0_US: 1.2192, N0: 2 },   /* v326 opens 2.40 x 1.30 (US 8 x 4 ft; was 1.20 x 1.20): the 80x80 frame no longer looks massive on it (Marek 17:44) */
    STEP: 0.20, STEP_US: 0.2032,                  /* the pyramid's terrace */
    TOP_MIN: 0.40, TOP_MIN_US: 0.4064,            /* its top tier at least this */
    POST_SP: 1.20, POST_SP_US: 1.2192,            /* the posts along a wall at most this apart */
    OV: 0.02, OV_US: 0.01905,                     /* the cap past the walls' outer face */
    SOIL_DOWN: 0.05, SOIL_DOWN_US: 0.0508,        /* the soil under the walls' top */
    SOIL_DOWN_P: 0.03, SOIL_DOWN_P_US: 0.0254,    /* in a pyramid's tier */
    GEO_UP: 0.10,                                 /* the geotextile up the walls */
    PITCH: 30,                                    /* the cold frame */
    KNEE: 0.05, KNEE_US: 0.0508,                  /* v315 its posts this far over the cap (the rafters' outer foot); v327 5 cm / US 2 in. (was 15 / 6: Marek 17:49 -- a lower step to reach the soil) */
    SASH_OVH: 0.02, SASH_OVH_US: 0.01905,         /* the wing past the cap's outer edge */
    SASH_END: 0.01, SASH_END_US: 0.0127,          /* v315 the wing's ends past the gables' outer face */
    STILE_SP: 0.60, STILE_SP_US: 0.6096,          /* a wing's stiles at most this apart */
    BAT_SP: 0.30, BAT_SP_US: 0.3048,              /* the battens' screws */
    WING2: 1.50, WING2_US: 1.524,                 /* past this length 2 + 2 wings */
    WGAP: 0.004, HINGE3: 1.20, HLEAF_L: 0.089, HLEAF_W: 0.03, HLEAF_T: 0.002,
    VINYL_W: 1.40, VINYL_W_US: 1.3716,            /* the roll's width */
    VINYL_FOLD: 0.03,                             /* v315 the gable's vinyl folded onto the cap */
    OPEN_F: 0.70,                                 /* v315 open = 70 % of the way to the book pose (both standing, leaning on each other) */
    STAY_A: 0.09, STAY_AB: 0.24,                  /* v315 the lid support: its body this far from the hinges' axis (on the rafter), its rod this much further (on the wing) */
    STAPLE_SP: 0.10,                              /* v315 the vinyl's staples */
    BOARD: 'KVH60200', POST: 'KVH10100', CAP: 'KVH60160', FRAME: 'KVH08080', FRAME_US: 'KVH10100',
    SASH: 'KVH03030', SASH_US: 'KVH03838', BATTEN: 'KVL20040',
    GEO: 'PFG00001', SOIL: 'SFF00004', VINYL: 'OEB00001', HINGE: 'ODD00005', STAY: 'FAT00023',
    VINYL_OP: 0.10,                               /* v325 the cold frame's vinyl 10 % opaque (Marek: at je pruhledna) */
    WALL_SCREW: 'FAS60100', POST_SCREW: 'FAS60160', RIDGE_SCREW: 'FAS60120',
    SASH_SCREW: 'FAS45070', BAT_SCREW: 'FAS50040', BAT_SCREW_US: 'FAS55050', HINGE_SCREW: 'FAS50040',
    STAPLE: 'STAPLES, STAINLESS, 10 MM (US 3/8 IN., T50) -- the cold frame\'s vinyl', STAPLE_CODE: 'FAS10000',   /* v345 its catalogue row */
    TR_UP: 1.50, TR_UP_US: 1.524,                 /* v316 the trellis: its beam's top over the cap */
    TR_SPAN: 2.40, TR_SPAN_US: 2.4384,            /* its posts at most this apart (the middle ones stand in the soil) */
    TR_BRACE: 0.60, TR_BRACE_US: 0.6096,          /* its braces' top on the post over the cap */
    STR_SP: 0.25, STR_SP_US: 0.254,               /* its strings (drawn, not billed) */
    BRACE: 'KVH10060', BEAM_SCREW: 'FAS80200', BRACE_SCREW: 'FAS60100',
    END_CAP: 'KVH08060', END_CAP_US: 'KVH40060'   /* v317 with the trellis the short walls' caps only over the wall: 80x60 flat (US 2x3, 1 in. proud) */
  };
  /* the sections: 2x8 boards, 4x4 posts, 2x6 cap; the cold frame's 80x80
     (US 4x4) posts / rafters / ridge, 30x30 (US 2x2) sashes, 1x2 battens --
     metric / US actual */
  function _rbProf(s) {
    if ((s || STATE).isMetric === false) return { bt: 0.0381, bh: 0.1842, pp: 0.0889, ct: 0.0381, cw: 0.1397, f: 0.0889, sw: 0.0381, bat: 0.01905, baw: 0.0381, bw: 0.0889, bth: 0.0381, ecw: 0.0635 };
    return { bt: 0.060, bh: 0.200, pp: 0.100, ct: 0.060, cw: 0.160, f: 0.080, sw: 0.030, bat: 0.020, baw: 0.040, bw: 0.100, bth: 0.060, ecw: 0.080 };
  }
  function _rbU(s, k) { return ((s || STATE).isMetric === false && RB[k + '_US'] != null) ? RB[k + '_US'] : RB[k]; }
  function _rbMode(s) { var m = (s || STATE).rbMode; return (m === 'pyramid' || m === 'wings') ? m : 'basic'; }
  function _rbCfg(s) {
    s = s || STATE;
    var c = RB[{ basic: 'BASIC', pyramid: 'PYR', wings: 'WINGS' }[_rbMode(s)]], us = (s.isMetric === false);
    return { L: us ? c.L_US : c.L, W: us ? c.W_US : c.W, N: c.N, L0: us ? c.L0_US : c.L0, W0: us ? c.W0_US : c.W0, N0: c.N0 };
  }
  function _rbRange(s) { var c = _rbCfg(s); return { min: c.L[0], max: c.L[1] }; }
  function _rbWRange(s) { var c = _rbCfg(s); return { min: c.W[0], max: c.W[1] }; }
  function _rbL(s) { s = s || STATE; var c = _rbCfg(s), v = +s.L; return Math.max(c.L[0], Math.min(c.L[1], (isFinite(v) && v > 0) ? v : c.L0)); }
  function _rbW(s) { s = s || STATE; var c = _rbCfg(s), v = +s.rbW; return Math.max(c.W[0], Math.min(c.W[1], (isFinite(v) && v > 0) ? v : c.W0)); }
  function _rbNRange(s) {
    s = s || STATE;
    var c = _rbCfg(s), hi = c.N[1];
    if (_rbMode(s) === 'pyramid') hi = Math.max(c.N[0], Math.min(hi, 1 + Math.floor((Math.min(_rbL(s), _rbW(s)) - _rbU(s, 'TOP_MIN')) / (2 * _rbU(s, 'STEP')) + 1e-9)));
    return { min: c.N[0], max: hi };
  }
  function _rbN(s) { s = s || STATE; var c = _rbCfg(s), R = _rbNRange(s), v = Math.round(+s.rbN); return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : c.N0)); }
  function _rbOpen(s) { return _rbMode(s) === 'wings' && (s || STATE).rbOpen === true; }
  function _rbTrellis(s) { return _rbMode(s) === 'basic' && (s || STATE).rbTrellis !== false; }   /* v316; v325 on unless switched off (Marek: defaultne s trellis) */
  function _rbSpacedN(a, b, n) { var out = [], i; for (i = 0; i <= n; i++) out.push(a + (b - a) * i / n); return out; }
  function _rbSpaced(a, b, sp) { return _rbSpacedN(a, b, Math.max(1, Math.ceil((b - a) / sp - 1e-9))); }
  function _rbLayout(s) {
    s = s || STATE;
    var P = _rbProf(s), us = (s.isMetric === false), mode = _rbMode(s), L = _rbL(s), W = _rbW(s), N = _rbN(s);
    var bt = P.bt, bh = P.bh, pp = P.pp, ov = _rbU(s, 'OV'), i, j, k, q, sx;
    var len100 = us ? 0.1016 : 0.10, len120 = us ? 0.127 : 0.12, len160 = us ? 0.1524 : 0.16,
        len40 = us ? 0.0381 : 0.04, len70 = us ? 0.06985 : 0.07, len50 = us ? 0.0508 : 0.05, batSp = _rbU(s, 'BAT_SP');
    var wingsM = (mode === 'wings'), FR = _rbU(s, 'FRAME'), SASH = _rbU(s, 'SASH'), BATS = _rbU(s, 'BAT_SCREW'), lenBat = us ? len50 : len40;
    var pieces = [], fas = [], soil = [], vinyl = [], hinges = [], posts = [], wings = [], staples = [], stays = [], nHid = 0, strings = [], wires = [], trM = _rbTrellis(s), trl = null;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function tag(o, ex) { if (ex) for (var e in ex) if (ex.hasOwnProperty(e)) o[e] = ex[e]; return o; }
    function box(kind, code, len, id, x, y, z, bx, by, bz, ex) { pieces.push(tag({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }, ex)); }
    function poly(kind, code, len, id, pts, plane, c, t, ex) { pieces.push(tag({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }, ex)); }
    function scr(kind, code, x, y, z, d, ln, ex) { fas.push(tag({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: ln, r: 0.003 }, ex)); }
    function stp(x, y, z, dx, dy, dz, rz, ex) { staples.push(tag({ x: x, y: y, z: z, d: [dx, dy, dz], rz: rz }, ex)); }   /* v315 a staple: its crown along local x */
    /* A BOX of nC courses from y0: the long walls (along Z) through, the
       short ones between them; 4x4 posts inside the corners and along the
       walls at <= POST_SP, down to pB; 2 screws a board into every post it
       crosses (the short walls' a little closer together, clear of the long
       walls' in the corner posts). frm (v315, the cold frame): the corner
       posts are the frame's (P.f, they run on up -- coldFrame() draws them),
       mid: + one at the long walls' middle (an even count of bays) */
    function bed(Lo, Wo, y0, nC, pB, tg, frm, mid, tre) {
      var fc = frm ? P.f : pp, hl = Lo / 2, hw = Wo / 2, yT = y0 + nC * bh, xs = hw - bt - fc / 2, zs = hl - bt - fc / 2, zm = hl - bt - pp / 2;
      var nZ = Math.max(1, Math.ceil(2 * zs / _rbU(s, 'POST_SP') - 1e-9));
      if (mid && nZ % 2) nZ++;
      var zP = _rbSpacedN(-zs, zs, nZ), xP = _rbSpaced(-xs, xs, _rbU(s, 'POST_SP')), fposts = [], c, a;
      for (a = -1; a <= 1; a += 2) for (j = 0; j < zP.length; j++) {
        var isF = frm && (j === 0 || j === zP.length - 1 || (mid && Math.abs(zP[j]) < 1e-6)), ps = isF ? fc : pp, pid = tg + 'post-' + (a < 0 ? 'b' : 'f') + (j + 1);
        posts.push({ y0: pB, y1: yT, s: ps });
        if (isF) fposts.push({ x: a * (hw - bt - fc / 2), z: zP[j], a: a, id: pid });
        else box('post', RB.POST, ceil2(yT - pB), pid, a * (hw - bt - pp / 2), (pB + yT) / 2, zP[j], pp, yT - pB, pp);
      }
      var tposts = [], xCols = xP.slice();   /* v316 tre: the trellis' end posts at the short walls' middle (drawn by trellis()) */
      for (a = -1; a <= 1; a += 2) for (j = 1; j + 1 < xP.length; j++) {
        posts.push({ y0: pB, y1: yT, s: pp });
        if (tre && Math.abs(xP[j]) < 1e-6) { tposts.push({ x: 0, z: a * zm, a: a }); continue; }
        box('post', RB.POST, ceil2(yT - pB), tg + 'post-' + (a < 0 ? 'l' : 'r') + j, xP[j], (pB + yT) / 2, a * zm, pp, yT - pB, pp);
      }
      if (tre && !xP.some(function (x) { return Math.abs(x) < 1e-6; })) {
        xCols.push(0); xCols.sort(function (u, v) { return u - v; });
        for (a = -1; a <= 1; a += 2) { posts.push({ y0: pB, y1: yT, s: pp }); tposts.push({ x: 0, z: a * zm, a: a }); }
      }
      for (c = 0; c < nC; c++) {
        var yc = y0 + (c + 0.5) * bh;
        for (a = -1; a <= 1; a += 2) {
          box('board', RB.BOARD, ceil2(Lo), tg + 'board-' + (a < 0 ? 'b' : 'f') + (c + 1), a * (hw - bt / 2), yc, 0, bt, bh, Lo);
          for (j = 0; j < zP.length; j++) for (k = -1; k <= 1; k += 2) scr('screw-board', RB.WALL_SCREW, a * hw, yc + k * bh / 4, zP[j], [-a, 0, 0], len100);
        }
        for (a = -1; a <= 1; a += 2) {
          box('board', RB.BOARD, ceil2(Wo - 2 * bt), tg + 'board-' + (a < 0 ? 'l' : 'r') + (c + 1), 0, yc, a * (hl - bt / 2), Wo - 2 * bt, bh, bt);
          for (j = 0; j < xCols.length; j++) for (k = -1; k <= 1; k += 2) scr('screw-board', RB.WALL_SCREW, xCols[j], yc + k * bh * 0.12, a * hl, [0, 0, -a], len100);
        }
      }
      return { hl: hl, hw: hw, yT: yT, xi: hw - bt, zi: hl - bt, zP: zP, xP: xP, xs: xs, zs: zs, fc: fc, fposts: fposts, tposts: tposts, zm: zm, tre: !!tre };
    }
    /* THE CAP: 2x6 flat on the walls, OV proud outside; the long caps
       through, the short ones between; a screw into every post (where cap
       and post overlap) and into the boards' top edge between the posts.
       v315: notched round the cold frame's posts (the pieces left drawn as
       boxes, the first carries the board's length); by such a post the
       screw goes into the long wall's top edge */
    function cap(b) {
      var ct = P.ct, cw = P.cw, yC = b.yT + ct, hl = b.hl, hw = b.hw, Lc = 2 * (hl + ov), Ws = 2 * (hw + ov) - 2 * cw, a;
      var xm = hw - bt - pp / 2, zm = hl - bt - pp / 2, fh = b.fc / 2;
      var holes = b.fposts.map(function (F) { return [F.x - fh, F.x + fh, F.z - fh, F.z + fh]; }).concat(b.tposts.map(function (F) { return [F.x - pp / 2, F.x + pp / 2, F.z - pp / 2, F.z + pp / 2]; }));
      function capPc(id, len, x0, x1, z0, z1) {
        var zc = [z0, z1], n = 0, bI;
        holes.forEach(function (H) { if (H[1] > x0 + 1e-6 && H[0] < x1 - 1e-6) { if (H[2] > z0 && H[2] < z1) zc.push(H[2]); if (H[3] > z0 && H[3] < z1) zc.push(H[3]); } });
        zc.sort(function (u, v) { return u - v; });
        for (bI = 0; bI + 1 < zc.length; bI++) {
          var za = zc[bI], zb = zc[bI + 1], zq = (za + zb) / 2, xs0 = [[x0, x1]];
          if (zb - za < 1e-6) continue;
          holes.forEach(function (H) {
            if (!(H[2] < zq && H[3] > zq)) return;
            var nx = [];
            xs0.forEach(function (I) { if (H[1] <= I[0] || H[0] >= I[1]) nx.push(I); else { if (H[0] > I[0]) nx.push([I[0], H[0]]); if (H[1] < I[1]) nx.push([H[1], I[1]]); } });
            xs0 = nx;
          });
          xs0.forEach(function (I) {
            if (I[1] - I[0] < 1e-6) return;
            box('cap', RB.CAP, n ? 0 : len, id + (n ? '-' + n : ''), (I[0] + I[1]) / 2, b.yT + ct / 2, zq, I[1] - I[0], ct, zb - za);
            n++;
          });
        }
      }
      for (a = -1; a <= 1; a += 2) capPc('cap-' + (a < 0 ? 'b' : 'f'), ceil2(Lc), (a < 0) ? -(hw + ov) : hw + ov - cw, (a < 0) ? -(hw + ov - cw) : hw + ov, -(hl + ov), hl + ov);
      /* v317 (Marek 09:27 on the trellis: the cap's pieces beside its post
         "v nicem nejsou ukotvene ... tam vubec byt nemusi"): with the trellis
         the short walls' caps run only over the wall -- 80x60 flat (US 2x3,
         1 in. proud), their inner edge on the wall's inner face, the trellis
         post rising behind it: no notch, nothing loose */
      var ecw = P.ecw, EC = _rbU(s, 'END_CAP');
      if (b.tre) for (a = -1; a <= 1; a += 2) box('cap', EC, ceil2(Ws), 'cap-' + (a < 0 ? 'l' : 'r'), 0, b.yT + ct / 2, a * (hl - bt + ecw / 2), Ws, ct, ecw);
      else for (a = -1; a <= 1; a += 2) capPc('cap-' + (a < 0 ? 'l' : 'r'), ceil2(Ws), -(hw + ov - cw), hw + ov - cw, (a < 0) ? -(hl + ov) : hl + ov - cw, (a < 0) ? -(hl + ov - cw) : hl + ov);
      var cxm = (Math.max(hw + ov - cw, xm - pp / 2) + Math.min(hw + ov, xm + pp / 2)) / 2;
      var czm = (Math.max(hl + ov - cw, zm - pp / 2) + Math.min(hl + ov, zm + pp / 2)) / 2;
      for (a = -1; a <= 1; a += 2) for (j = 0; j < b.zP.length; j++) {
        var onF = b.fposts.some(function (F) { return F.a === a && Math.abs(F.z - b.zP[j]) < 1e-6; });
        scr('screw-cap', RB.WALL_SCREW, a * (onF ? hw - bt / 2 : cxm), yC, b.zP[j], [0, -1, 0], len100);
        if (j + 1 < b.zP.length) scr('screw-cap', RB.WALL_SCREW, a * (hw - bt / 2), yC, (b.zP[j] + b.zP[j + 1]) / 2, [0, -1, 0], len100);
      }
      for (a = -1; a <= 1; a += 2) for (j = 0; j + 1 < b.xP.length; j++) {
        if (j > 0) scr('screw-cap', RB.WALL_SCREW, b.xP[j], yC, a * (b.tre ? hl - bt / 2 : czm), [0, -1, 0], len100);
        scr('screw-cap', RB.WALL_SCREW, (b.xP[j] + b.xP[j + 1]) / 2, yC, a * (hl - bt / 2), [0, -1, 0], len100);
      }
      return yC;
    }
    /* THE COLD FRAME (mode 'wings', v315), in the planes of the gables:
       the rafter's underside through the post's outer top corner KNEE over
       the cap, its top = the sash's underside, the sash's top, the battens'
       top line through the hinges' axis (x = hr at the ridge's top edge) */
    function coldFrame(b, yC) {
      var al = RB.PITCH * Math.PI / 180, tn = Math.tan(al), ca = Math.cos(al), sa = Math.sin(al);
      var f = P.f, hr = f / 2, hw = b.hw, hl = b.hl, xpo = hw - bt, xpi = xpo - f, xs = xpo - f / 2, xOut = hw + ov, xS = xOut + _rbU(s, 'SASH_OVH');
      var sw = P.sw, bat = P.bat, baw = P.baw, stSp = RB.STAPLE_SP, yK = yC + _rbU(s, 'KNEE'), fo = RB.VINYL_FOLD;
      var yRb = function (x) { return yK + (xpo - x) * tn; };
      var ySb = function (x) { return yRb(x) + f / ca; };
      var ySt = function (x) { return ySb(x) + sw / ca; };
      var yBat = function (x) { return ySt(x) + bat / ca; };
      var yAx = yBat(hr), yR0 = yAx - f, yE0 = ySb(xpi) - f;   /* the eave rails' underside: the section's depth under the rafters' top at its inner edge */
      var zpo = hl - bt, zpi = zpo - f, zc = zpo - f / 2, zw = zpo + _rbU(s, 'SASH_END'), twoW = (2 * hl) > _rbU(s, 'WING2') + 1e-9;
      var gz = twoW ? [-zc, 0, zc] : [-zc, zc], rafL = ceil2(xpo / ca), xl = xpi - (yE0 - yRb(xpi)) / tn;
      function M(a, pts) { return pts.map(function (Pt) { return [a * Pt[0], Pt[1]]; }); }
      /* the frame's posts: the bed's corner posts on up, KNEE over the cap,
         their tops cut to the pitch; for 2 + 2 the long walls' middle ones
         up to the eave rail's underside */
      for (i = 0; i < b.fposts.length; i++) {
        var F = b.fposts[i], fMid = Math.abs(F.z) < 1e-6;
        poly('fpost', FR, ceil2(fMid ? yE0 : yRb(xpi)), F.id, M(F.a, fMid ? [[xpi, 0], [xpo, 0], [xpo, yE0], [xpi, yE0]] : [[xpi, 0], [xpo, 0], [xpo, yK], [xpi, yRb(xpi)]]), 'xy', F.z, f);
        for (k = 0; k < 2; k++) {   /* the vinyl's staples down its outer face(s), over the cap */
          var kys = (yK - yC >= 0.09) ? _rbSpaced(yC + 0.03, yK - 0.015, stSp) : [(yC + yK) / 2], kx = F.a * (xpo + 0.0014);   /* v327 a short stub: one staple in its middle */
          for (j = 0; j < kys.length; j++) {
            if (k === 0) stp(kx, kys[j], F.z, 0.001, 0.012, 0.0012, 0, { gable: 's' });
            else if (!fMid) stp(F.a * xs, kys[j], ((F.z < 0) ? -1 : 1) * (zpo + 0.0014), 0.0012, 0.012, 0.001, 0, { gable: 's' });
          }
        }
      }
      /* the eave rails: the frame's section between the end gables' rafters
         along the posts' tops, its top bevelled flush with the rafters' (the
         wings lie on it, the long sides' vinyl on its outer face); 2 screws
         through each end rafter into it, for 2 + 2 2 down into the middle
         post */
      for (sx = -1; sx <= 1; sx += 2) {
        poly('eave', FR, ceil2(2 * zpi), 'eave-' + (sx < 0 ? 'b' : 'f'), M(sx, [[xpi, yE0], [xpo, yE0], [xpo, ySb(xpo)], [xpi, ySb(xpi)]]), 'xy', 0, 2 * zpi);
        for (q = -1; q <= 1; q += 2) for (k = -1; k <= 1; k += 2) { var xe2 = xs + k * f / 4; scr('screw-eave', RB.POST_SCREW, sx * xe2, (yE0 + ySb(xe2)) / 2, q * zpo, [0, 0, -q], len160); }
        if (twoW) for (k = -1; k <= 1; k += 2) scr('screw-epost', RB.RIDGE_SCREW, sx * (xs + k * f / 4), ySb(xs + k * f / 4), 0, [0, -1, 0], len120);
        vinyl.push({ kind: 'side', sx: sx, x: sx * xpo, y0: yC, y1: ySb(xpo), z0: -zpo, z1: zpo, fold: fo, h: ySb(xpo) - yC + fo, w: 2 * zpo });
        var ezs = _rbSpaced(-zpi + 0.03, zpi - 0.03, stSp), fzs = _rbSpaced(-zpo + 0.03, zpo - 0.03, stSp);
        for (j = 0; j < ezs.length; j++) stp(sx * (xpo + 0.0014), (yE0 + ySb(xpo)) / 2, ezs[j], 0.001, 0.0012, 0.012, 0, { gable: 's' });
        for (j = 0; j < fzs.length; j++) stp(sx * (xpo + fo / 2), yC + 0.0014, fzs[j], 0.0012, 0.001, 0.012, 0, { gable: 's' });
      }
      /* the rafters: on the end posts a plumb tail flush with the walls'
         inner face; in the middle frame against the eave rail's inner face
         (a level cut at its underside); the pair meeting plumb under the
         ridge, which sits in their notch; 2 screws down through an end
         rafter into its post, 2 through the eave rail into a middle rafter,
         one down through the ridge into each rafter's tip. The end gables'
         outer faces: the vinyl, stapled along the rafters, its foot folded
         onto the cap and stapled */
      for (i = 0; i < gz.length; i++) {
        var gEnd = (i === 0 || i === gz.length - 1), gs = (gz[i] < 0) ? -1 : 1, gid = gEnd ? (gs < 0 ? 'l' : 'r') : 'm';
        for (sx = -1; sx <= 1; sx += 2) {
          if (gEnd) {
            poly('rafter', FR, rafL, 'rafter-' + gid + (sx < 0 ? '-b' : '-f'), M(sx, [[0, yRb(0)], [xpo, yK], [xpo, ySb(xpo)], [hr, ySb(hr)], [hr, yR0], [0, yR0]]), 'xy', gz[i], f);
            for (k = -1; k <= 1; k += 2) scr('screw-rpost', RB.POST_SCREW, sx * xs, ySb(xs), gz[i] + k * f / 4, [0, -1, 0], len160);
          } else {
            poly('rafter', FR, ceil2(Math.max(xl, xpi - hr) / ca), 'rafter-' + gid + (sx < 0 ? '-b' : '-f'), M(sx, [[0, yRb(0)], [xl, yE0], [xpi, yE0], [xpi, ySb(xpi)], [hr, ySb(hr)], [hr, yR0], [0, yR0]]), 'xy', gz[i], f);
            for (k = -1; k <= 1; k += 2) scr('screw-eave', RB.RIDGE_SCREW, sx * xpo, yE0 + 0.02, gz[i] + k * f / 4, [-sx, 0, 0], len120);
          }
          scr('screw-ridge', RB.RIDGE_SCREW, sx * hr / 2, yAx, gz[i], [0, -1, 0], len120);
        }
        if (!gEnd) continue;
        vinyl.push({ kind: 'gable', gs: gs, z: gs * zpo, y0: yC, fold: fo, pts: [[-xpo, yC], [xpo, yC], [xpo, ySb(xpo)], [hr, ySb(hr)], [-hr, ySb(hr)], [-xpo, ySb(xpo)]], h: ySb(hr) - yC + fo, w: 2 * xpo });
        for (sx = -1; sx <= 1; sx += 2) {
          var gxs = _rbSpaced(hr + 0.03, xpo - 0.03, stSp);
          for (j = 0; j < gxs.length; j++) stp(sx * gxs[j], ySb(gxs[j]) - f / (2 * ca), gs * (zpo + 0.0014), 0.012, 0.0012, 0.001, -sx * al, { gable: gid });
        }
        var cxs = _rbSpaced(-xpo + 0.03, xpo - 0.03, stSp);
        for (j = 0; j < cxs.length; j++) stp(cxs[j], yC + 0.0014, gs * (zpo + fo / 2), 0.012, 0.001, 0.0012, 0, { gable: gid });
      }
      /* the ridge, out to the wings' ends */
      box('ridge', FR, ceil2(2 * zw), 'ridge', 0, yAx - f / 2, 0, f, f, 2 * zw);
      /* THE WINGS: a light sash (top rail plumb against the ridge, bottom
         rail plumb at its outer edge, a stile at each end, one just inside
         each end gable for the lid support, the rest at <= STILE_SP), the
         vinyl stapled on it, 1x2 battens round its edge, door hinges on the
         ridge's top clear of the ridge's screws; open = turned 70 % of the
         way about the hinges' axis, held there by the lid supports */
      var segs = twoW ? [[-zw, -RB.WGAP / 2], [RB.WGAP / 2, zw]] : [[-zw, zw]];
      var x1 = hr + sw * ca, x2 = xS - sw * ca, xb1 = hr + baw * ca, xb2 = xS - baw * ca, slope = (xS - hr) / ca;
      var thFull = (90 + RB.PITCH) * Math.PI / 180 + Math.asin(Math.min(0.9, hr / slope)), thOpen = RB.OPEN_F * thFull;
      var stSpc = _rbU(s, 'STILE_SP'), hEnd = zpi - RB.HLEAF_L / 2 - 0.01, hMid = f / 2 + RB.HLEAF_L / 2 + 0.01;
      var wOpen = 'f' + segs.length;   /* v326 the one wing OPEN raises: the front one (2 + 2: the front one at +Z, nearer the view) */
      for (sx = -1; sx <= 1; sx += 2) for (q = 0; q < segs.length; q++) {
        var za = segs[q][0], zb = segs[q][1], wl = zb - za, wid = (sx < 0 ? 'b' : 'f') + (q + 1), ex = { wing: wid }, zm = (za + zb) / 2;
        var endA = Math.abs(za + zw) < 1e-6, endB = Math.abs(zb - zw) < 1e-6;   /* this end at an end gable (else at the middle frame) */
        wings.push({ id: wid, sx: sx, ax: sx * hr, ay: yAx, th: (wid === wOpen) ? sx * thOpen : 0, za: za, zb: zb, lift: wid === wOpen });   /* v326 only wOpen turns */
        poly('sash', SASH, ceil2(wl), 'sash-top-' + wid, M(sx, [[hr, ySb(hr)], [x1, ySb(x1)], [x1, ySt(x1)], [hr, ySt(hr)]]), 'xy', zm, wl, ex);
        poly('sash', SASH, ceil2(wl), 'sash-bottom-' + wid, M(sx, [[x2, ySb(x2)], [xS, ySb(xS)], [xS, ySt(xS)], [x2, ySt(x2)]]), 'xy', zm, wl, ex);
        var base = [za + sw / 2, zb - sw / 2], stZ, stL = ceil2((x2 - x1) / ca);
        if (endA) base.push(-zpi + sw / 2);
        if (endB) base.push(zpi - sw / 2);
        base.sort(function (u, v) { return u - v; });
        stZ = [base[0]];
        for (j = 1; j < base.length; j++) {
          var nIn = Math.max(1, Math.ceil((base[j] - base[j - 1]) / stSpc - 1e-9));
          for (k = 1; k <= nIn; k++) stZ.push(base[j - 1] + (base[j] - base[j - 1]) * k / nIn);
        }
        var ym1 = (ySb(hr) + ySt(hr)) / 2, ym2 = (ySb(xS) + ySt(xS)) / 2;
        for (j = 0; j < stZ.length; j++) {
          poly('sash', SASH, stL, 'sash-stile-' + wid + '-' + (j + 1), M(sx, [[x1, ySb(x1)], [x2, ySb(x2)], [x2, ySt(x2)], [x1, ySt(x1)]]), 'xy', stZ[j], sw, ex);
          scr('screw-sash', RB.SASH_SCREW, sx * hr, ym1, stZ[j], [sx * ca, -sa, 0], len70, ex);       /* through the top rail into the stile */
          scr('screw-sash', RB.SASH_SCREW, sx * xS, ym2, stZ[j], [-sx * ca, sa, 0], len70, ex);       /* through the bottom rail into the stile */
        }
        /* the hinges first (the top batten's screws keep clear of them) */
        var hzA = endA ? -hEnd : za + hMid - RB.WGAP / 2, hzB = endB ? hEnd : zb - hMid + RB.WGAP / 2;
        var hz = (wl > RB.HINGE3) ? [hzA, (hzA + hzB) / 2, hzB] : [hzA, hzB], xh = hr + 0.015 * ca;
        for (j = 0; j < hz.length; j++) {
          hinges.push({ wing: wid, sx: sx, z: hz[j], hr: hr, y: yAx, xh: xh, yh: yBat(xh), phi: al });
          for (k = -1; k <= 1; k++) {
            scr('screw-hinge', RB.HINGE_SCREW, sx * hr / 2, yAx + RB.HLEAF_T, hz[j] + k * 0.03, [0, -1, 0], len40);           /* its ridge leaf down into the ridge */
            scr('screw-hinge', RB.HINGE_SCREW, sx * xh, yBat(xh) + RB.HLEAF_T, hz[j] + k * 0.03, [0, -1, 0], len40, ex);      /* its wing leaf through the batten into the top rail */
          }
        }
        /* the vinyl, stapled: along both rails and the end stiles (under the
           battens -- counted), along every other stile (drawn) */
        vinyl.push({ kind: 'wing', wing: wid, sx: sx, x0: hr, x1: xS, za: za, zb: zb, xm: (hr + xS) / 2, ym: ySt((hr + xS) / 2), phi: al, sl: slope, wl: wl });
        var szs = _rbSpaced(za + 0.03, zb - 0.03, stSp), sxs = _rbSpaced(x1 + 0.03, x2 - 0.03, stSp), nx = sx * sa * 0.0013, ny = ca * 0.0013;
        nHid += 2 * szs.length + 2 * sxs.length;
        for (j = 1; j + 1 < stZ.length; j++) for (k = 0; k < sxs.length; k++) stp(sx * sxs[k] + nx, ySt(sxs[k]) + ny, stZ[j], 0.012, 0.001, 0.0012, -sx * al, ex);
        /* the battens over the vinyl's edge: top + bottom along the wing, one over each end stile between them */
        poly('batten', RB.BATTEN, ceil2(wl), 'batten-top-' + wid, M(sx, [[hr, ySt(hr)], [xb1, ySt(xb1)], [xb1, yBat(xb1)], [hr, yBat(hr)]]), 'xy', zm, wl, ex);
        poly('batten', RB.BATTEN, ceil2(wl), 'batten-bottom-' + wid, M(sx, [[xb2, ySt(xb2)], [xS, ySt(xS)], [xS, yBat(xS)], [xb2, yBat(xb2)]]), 'xy', zm, wl, ex);
        var bzs = _rbSpaced(za + 0.06, zb - 0.06, batSp), xtb = hr + baw * ca / 2, xbb = xS - baw * ca / 2;
        for (j = 0; j < bzs.length; j++) {
          var nearH = hz.some(function (h) { return Math.abs(h - bzs[j]) < 0.07; });
          if (!nearH) scr('screw-batten', BATS, sx * xtb, yBat(xtb), bzs[j], [0, -1, 0], lenBat, ex);
          scr('screw-batten', BATS, sx * xbb, yBat(xbb), bzs[j], [0, -1, 0], lenBat, ex);
        }
        for (k = 0; k < 2; k++) {
          var ze = (k === 0) ? za + baw / 2 : zb - baw / 2, zst = (k === 0) ? stZ[0] : stZ[stZ.length - 1], xe = _rbSpaced(xb1 + 0.03, xb2 - 0.03, batSp);
          poly('batten', RB.BATTEN, ceil2((xb2 - xb1) / ca), 'batten-end-' + wid + '-' + (k + 1), M(sx, [[xb1, ySt(xb1)], [xb2, ySt(xb2)], [xb2, yBat(xb2)], [xb1, yBat(xb1)]]), 'xy', ze, baw, ex);
          for (j = 0; j < xe.length; j++) scr('screw-batten', BATS, sx * xe[j], yBat(xe[j]), zst, [0, -1, 0], lenBat, ex);
        }
        /* the lid supports: at each end gable the wing meets -- the body's
           bracket on the rafter's inner face, the rod's under the stile just
           inside; open = the rod run out to its stop */
        var ux = sx * ca, uy = -sa, vx = sx * sa, vy = ca, Ax = sx * hr, uA = RB.STAY_A, uB = RB.STAY_A + RB.STAY_AB, vA = -(bat + sw + f / 2), vB = -(bat + sw) - 0.006, vP = -(bat + sw) - 0.002;
        var Ap = [Ax + uA * ux + vA * vx, yAx + uA * uy + vA * vy], Bp = [Ax + uB * ux + vB * vx, yAx + uB * uy + vB * vy], Bb = [Ax + uB * ux + vP * vx, yAx + uB * uy + vP * vy];
        var cT = Math.cos(sx * thOpen), sT = Math.sin(sx * thOpen), dBx = Bp[0] - Ax, dBy = Bp[1] - yAx, Bo = [Ax + dBx * cT - dBy * sT, yAx + dBx * sT + dBy * cT];
        var Lc = Math.sqrt((Bp[0] - Ap[0]) * (Bp[0] - Ap[0]) + (Bp[1] - Ap[1]) * (Bp[1] - Ap[1])), Lo = Math.sqrt((Bo[0] - Ap[0]) * (Bo[0] - Ap[0]) + (Bo[1] - Ap[1]) * (Bo[1] - Ap[1]));
        var Lb = Lc - 0.03, Lr = Lo - Lb + 0.015;
        if (endA) stays.push({ wing: wid, sx: sx, gs: -1, z: -(zpi - 0.012), zr: -zpi, a: Ap, b: Bp, bb: Bb, phi: al, lc: Lc, lo: Lo, lb: Lb, lr: Lr });
        if (endB) stays.push({ wing: wid, sx: sx, gs: 1, z: zpi - 0.012, zr: zpi, a: Ap, b: Bp, bb: Bb, phi: al, lc: Lc, lo: Lo, lb: Lb, lr: Lr });
      }
      return { top: yAx + RB.HLEAF_T, yAx: yAx, yR0: yR0, twoW: twoW, xOut: xOut, rafL: rafL, phi: al, ca: ca, sa: sa, thOpen: thOpen, thFull: thFull, slope: slope, f: f };
    }
    /* THE TRELLIS (mode 'basic' + the toggle, v316 -- Marek 09:05 with a
       photo of a cattle-panel trellis on a bed: "Udelej jeste u prvni
       varianty moznost zapnuti takoveto konstrukce.. od ni vedou provazky
       / drate (nemusi byt v BOQ)"): a 4x4 post at the middle of each short
       wall (in the bed's posts' row, run on up through a notch in the cap)
       and at <= TR_SPAN between them standing in the soil; a 4x4 beam on
       their tops (2 x 8x200 down into each); each post braced across the
       bed by a pair of 2x4s -- an A, plumb against each other at the post's
       axis, a level seat on the long caps; v317 an end post's on its outer
       face, over the short wall (Marek 09:27: "Sikme vzpery podle me davaji
       vetsi smysl instalovat vnejsi strany"), the short walls' caps then only
       over the wall (see cap())
       (2 x 6x100 through the brace into the post -- v319 one over the other
       in a plumb line at the middle of the brace's part over the post, Marek
       13:15: "nad sebe, svisle ... co nejvice uprostred vzper i sloupu";
       an 8x200 down through the
       foot, the cap and into the wall); strings from the beam down to a
       wire over the soil -- drawn, NOT billed (Marek) */
    function trellis(b, yC) {
      var hw = b.hw, hl = b.hl, yTop = yC + _rbU(s, 'TR_UP'), yP1 = yTop - pp, zE = b.zm, wb = P.bw, tb = P.bth;
      var nB = Math.max(1, Math.ceil(2 * zE / _rbU(s, 'TR_SPAN') - 1e-9)), tz = _rbSpacedN(-zE, zE, nB);
      var len200 = us ? 0.2032 : 0.20, yBr = yC + _rbU(s, 'TR_BRACE'), xb = hw - bt - 0.02, xToe = hw + ov - 0.01, lo = 0.05, hi = 1.5, th = 0.7, it;
      /* the braces' slope: the underside through (xb, the cap's top), the top edge through (the post's axis, yBr) */
      for (it = 0; it < 60; it++) { th = (lo + hi) / 2; if (yBr - yC - wb / Math.cos(th) - xb * Math.tan(th) > 0) lo = th; else hi = th; }
      var tnB = Math.tan(th), dV = wb / Math.cos(th), xT = Math.min(xToe, xb + dV / tnB - 0.002), braceL = ceil2(xT / Math.cos(th)), xf = hw - bt / 2 + 0.012;
      var topE = function (x) { return yBr - x * tnB; };
      for (k = 0; k < tz.length; k++) {
        var zp = tz[k], endP = (k === 0 || k === tz.length - 1), pid = endP ? (zp < 0 ? 'l' : 'r') : 'm' + k;
        if (!endP) posts.push({ y0: 0, y1: b.yT, s: pp });   /* a middle one stands in the soil */
        box('tpost', RB.POST, ceil2(yP1), 'tpost-' + pid, 0, yP1 / 2, zp, pp, yP1, pp);
        for (q = -1; q <= 1; q += 2) scr('screw-tbeam', RB.BEAM_SCREW, q * pp / 4, yTop, zp, [0, -1, 0], len200);
        var dC = (zp < -1e-6) ? -1 : 1, cz = zp + dC * (pp / 2 + tb / 2), fz = zp + dC * (pp / 2 + tb);   /* v317 on the end posts' outer face, over the short wall (Marek 09:27); a middle post's on its +Z face */
        for (sx = -1; sx <= 1; sx += 2) {
          var bp = [[0, yBr], [0, yBr - dV], [xb, yC], [xT, yC]];
          if (topE(xT) > yC + 0.001) bp.push([xT, topE(xT)]);
          poly('tbrace', RB.BRACE, braceL, 'tbrace-' + pid + (sx < 0 ? '-b' : '-f'), bp.map(function (Pt) { return [sx * Pt[0], Pt[1]]; }), 'xy', cz, tb);
          for (q = 0; q < 2; q++) scr('screw-tbrace', RB.BRACE_SCREW, sx * pp / 4, topE(pp / 4) - dV * (q === 0 ? 0.3 : 0.7), fz, [0, 0, -dC], len100);   /* v319 one over the other, plumb, at the middle of the brace's part over the post (x = a quarter of the post) and 30 / 70 % down the brace's depth there */
          scr('screw-tfoot', RB.BEAM_SCREW, sx * xf, topE(xf), cz, [0, -1, 0], len200);
        }
      }
      box('tbeam', RB.POST, ceil2(2 * (hl - bt)), 'tbeam', 0, yTop - pp / 2, 0, pp, pp, 2 * (hl - bt));
      /* the strings: from the beam down to a wire 8 cm over the soil, clear of the middle posts */
      var yS = b.yT - _rbU(s, 'SOIL_DOWN') + 0.08, sz0 = -zE + pp / 2 + 0.08, sz1 = zE - pp / 2 - 0.08, nS = Math.max(1, Math.ceil((sz1 - sz0) / _rbU(s, 'STR_SP') - 1e-9));
      for (k = 0; k <= nS; k++) {
        var zq = sz0 + (sz1 - sz0) * k / nS;
        if (tz.some(function (z2) { return Math.abs(z2 - zq) < pp / 2 + 0.03; })) continue;
        strings.push({ x: 0, z: zq, y0: yS, y1: yP1 });
      }
      wires.push({ x: 0, y: yS, z0: -zE + pp / 2, z1: zE - pp / 2 });
      return { top: yTop, posts: tz.length, braceL: braceL, deg: th * 180 / Math.PI };
    }
    /* THE MODES */
    var b, top, soilV = 0, frame = null, yWall, sdn;
    if (mode === 'pyramid') {
      var st = _rbU(s, 'STEP');
      sdn = _rbU(s, 'SOIL_DOWN_P');
      for (var tr = 0; tr < N; tr++) {   /* (bed() uses j / k) */
        var bk = bed(L - 2 * tr * st, W - 2 * tr * st, tr * bh, 1, 0, 't' + (tr + 1) + '-', false, false, false);
        if (tr === 0) b = bk;
        soil.push({ x0: -bk.xi, x1: bk.xi, z0: -bk.zi, z1: bk.zi, y0: tr * bh, y1: (tr + 1) * bh - sdn });
        soilV += 4 * bk.xi * bk.zi * (bh - sdn) + ((tr > 0) ? 4 * bk.hw * bk.hl * sdn : 0);
      }
      top = N * bh; yWall = top;
    } else {
      b = bed(L, W, 0, N, 0, '', wingsM, wingsM && L > _rbU(s, 'WING2') + 1e-9, trM);
      var yC = cap(b);
      sdn = _rbU(s, 'SOIL_DOWN');
      soil.push({ x0: -b.xi, x1: b.xi, z0: -b.zi, z1: b.zi, y0: 0, y1: b.yT - sdn });
      soilV += 4 * b.xi * b.zi * (b.yT - sdn);
      top = yC; yWall = b.yT;
      if (wingsM) { frame = coldFrame(b, yC); top = frame.top; }
      if (trM) trl = trellis(b, yC);
    }
    for (i = 0; i < posts.length; i++) soilV -= posts[i].s * posts[i].s * Math.max(0, posts[i].y1 - posts[i].y0 - sdn);   /* the posts stand in it */
    var gu = RB.GEO_UP, geo = { x0: -b.xi, x1: b.xi, z0: -b.zi, z1: b.zi };
    var geoA = Math.round((2 * b.xi + 2 * gu) * (2 * b.zi + 2 * gu) * 100) / 100;
    /* the vinyl off the roll (VINYL_W wide): a piece takes its long side
       when its short side fits the width; + 10 %, to 0.1 m */
    var VW = _rbU(s, 'VINYL_W'), vm = 0;
    for (i = 0; i < vinyl.length; i++) {
      var va = (vinyl[i].kind === 'wing') ? vinyl[i].sl : vinyl[i].h, vb = (vinyl[i].kind === 'wing') ? vinyl[i].wl : vinyl[i].w;
      var vs = Math.min(va, vb), vl = Math.max(va, vb);
      vm += (vs <= VW) ? vl : Math.ceil(vs / VW - 1e-9) * vl;
    }
    var vinylM = vinyl.length ? Math.ceil(vm * 1.1 * 10 - 1e-6) / 10 : 0;
    /* the bill's quantities: timber by code, the coating (the four long faces) */
    var SEC = {}, m = {}, coat = 0;
    SEC[RB.BOARD] = [bt, bh]; SEC[RB.POST] = [pp, pp]; SEC[RB.CAP] = [P.ct, P.cw]; SEC[FR] = [P.f, P.f]; SEC[SASH] = [P.sw, P.sw]; SEC[RB.BATTEN] = [P.bat, P.baw]; SEC[RB.BRACE] = [P.bth, P.bw]; SEC[_rbU(s, 'END_CAP')] = [P.ct, P.ecw];
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0)) continue;
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      var sec = SEC[pc.code] || [bt, bh];
      coat += 2 * (sec[0] + sec[1]) * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    return {
      P: P, us: us, mode: mode, L: L, W: W, N: N, nRange: _rbNRange(s), pieces: pieces, fas: fas, soil: soil, vinyl: vinyl, hinges: hinges, posts: posts,
      wings: wings, frame: frame, twoW: frame ? frame.twoW : false, open: _rbOpen(s), geo: geo, geoA: geoA, soilV: r3(Math.max(0, soilV)), vinylM: vinylM,
      staples: staples, nStaple: nHid + staples.length, stays: stays, trellis: trl, strings: strings, wires: wires,
      meters: m, coat: coat, base: b, yWall: yWall, top: top, height: trl ? Math.max(top, trl.top) : top, depth: W, length: L, courseH: bh
    };
  }
  /* its staged assembly: the geotextile, the posts (the cold frame's run
     on up), the boards, the cap, the soil; the cold frame: rafters + eave
     rails, ridge, the gables' / long sides' vinyl + staples, the sashes, their vinyl + staples, the
     battens, the hinges, the lid supports -- each member, then its
     fasteners (a step whose parts this mode does not draw drops out);
     the codes by the units (v315) */
  var _rbStepsC = {};
  function _rbSteps(s) {
    s = s || STATE;
    var wingsM = (_rbMode(s) === 'wings'), twoW = wingsM && _rbL(s) > _rbU(s, 'WING2') + 1e-9, key = _rbMode(s) + '|' + (s.isMetric === false) + '|' + twoW;
    if (_rbStepsC[key]) return _rbStepsC[key];
    var FR = _rbU(s, 'FRAME');
    return (_rbStepsC[key] = [
      { parts: [], codes: [] },
      { parts: ['rb-geo'], codes: [RB.GEO] },
      { parts: ['rb-post', 'rb-fpost', 'rb-tpost'], codes: (wingsM && FR !== RB.POST) ? [RB.POST, FR] : [RB.POST] },
      { parts: ['rb-board'], codes: [RB.BOARD] },
      { parts: ['rb-hw-screw-board'], codes: [RB.WALL_SCREW] },
      { parts: ['rb-cap'], codes: [RB.CAP] },
      { parts: ['rb-hw-screw-cap'], codes: [RB.WALL_SCREW] },
      { parts: ['rb-soil'], codes: [RB.SOIL] },
      { parts: ['rb-rafter', 'rb-eave'], codes: [FR] },
      { parts: ['rb-hw-screw-rpost', 'rb-hw-screw-eave', 'rb-hw-screw-epost'], codes: twoW ? [RB.POST_SCREW, RB.RIDGE_SCREW] : [RB.POST_SCREW] },
      { parts: ['rb-ridge'], codes: [FR] },
      { parts: ['rb-hw-screw-ridge'], codes: [RB.RIDGE_SCREW] },
      { parts: ['rb-hw-gvinyl', 'rb-hw-gstaple'], codes: [RB.VINYL, RB.STAPLE_CODE] },   /* v345 + the staples */
      { parts: ['rb-sash'], codes: [_rbU(s, 'SASH')] },
      { parts: ['rb-hw-screw-sash'], codes: [RB.SASH_SCREW] },
      { parts: ['rb-hw-vinyl', 'rb-hw-staple'], codes: [RB.VINYL, RB.STAPLE_CODE] },     /* v345 + the staples */
      { parts: ['rb-batten'], codes: [RB.BATTEN] },
      { parts: ['rb-hw-screw-batten'], codes: [_rbU(s, 'BAT_SCREW')] },
      { parts: ['rb-hw-hinge', 'rb-hw-screw-hinge'], codes: [RB.HINGE, RB.HINGE_SCREW] },
      { parts: ['rb-hw-stay'], codes: [RB.STAY] },
      { parts: ['rb-tbeam'], codes: [RB.POST] },                                              /* v316 the trellis */
      { parts: ['rb-hw-screw-tbeam'], codes: [RB.BEAM_SCREW] },
      { parts: ['rb-tbrace'], codes: [RB.BRACE] },
      { parts: ['rb-hw-screw-tbrace', 'rb-hw-screw-tfoot', 'rb-hw-string'], codes: [RB.BRACE_SCREW, RB.BEAM_SCREW] }
    ]);
  }

  /* ------------------------------------------------------------------
     v318 TYPE 21 -- BENCHES & LOUNGE: THE FLOATING BED (Marek 2026-10-21
     09:44 with the IFC + the A3 drawings made here on 2026-10-19, "Postel
     z jasanu -- vznasejici se postel 180 x 200 se stolky, jasan + smrk":
     "Je mozne z nej udelat dalsi polozku do produktu bench & lounge?";
     chose: only the width editable (the mattress sizes), a ready-made
     slatted base (MISSING) + the electrics billed). X = across, Y = up,
     Z = along; the head at -Z against a wall behind it:
       - a hidden spruce frame of 4x4 KVH10100 (cross beams at the head and
         the foot, long beams between them along the side panels, a
         crossbar over the foot legs, a centre beam in two pieces under
         the two slatted bases), its underside LEG over the floor on 4 legs
         REC in from the panels' faces (painted black): an 8x180 FAS80180
         a joint (2 at the foot corners), 2 down into each leg; 6 ribbed
         angle brackets 70x70x55 inside (MISSING) on 8 x FAS50040;
       - ash edge-glued panels 40 mm (MISSING): the side panels and the
         foot panel (over the side panels' ends) SIDE_H high from the
         frame's underside, screwed from inside through the beams (2 rows,
         6x120 FAS60120, US #14 x 4 in. FAS60100, at ~22 cm) + D3 glue
         FEC00043; the headboard as wide as the bed + its 2 nightstands,
         HB_H high, on 3 spruce laths KVH40060 laid flat (40 mm off the
         wall, 4.5x70 FAS45070 from behind), anchored through the middle
         lath (8 x FAS80160) and through the head beam + the bottom lath
         (12 x FAS80260), each with a wall plug FAS80060;
       - 2 nightstands NS_W x NS_D x NS_H of ash 20 mm (MISSING) on the
         headboard (6 x FAS50060 from behind) and the side panel (4 x
         FAS55050 from inside, under the slatted base), boards on
         confirmats (MISSING), a push-to-open drawer each: a 12 mm birch
         ply box with an HDF bottom (MISSING) on full-extension slides
         (MISSING), its ash front inset 1 mm;
       - an LED groove round the headboard's back (the top + both sides):
         a recessed aluminium profile (MISSING) with a 24 V strip EEC00006,
         a 75 W supply EEC00007 under the bed;
       - over each nightstand a 2-gang plate (MISSING) with a socket
         EES00001 + a switch EEL00001 in 2 boxes EEJ00001; cable EEE00001;
       - 2 slatted bases (MISSING; e.g. IKEA LONSET) on the frame, the
         mattress FMA00002 on them.
     The width = the mattress (140 - 200 x 200, US Full - King: the bed's
     lists from 140 cm / Full; STATE.bedMW shared with the bed, type 14).
     _fbLayout(STATE) is the single source. */
  var FB = {
    MW_MIN: 1.40, MW_DEF: 1.80, US_MIN: 54, US_DEF: 60,
    LEG: 0.20, LEG_US: 0.2032,                    /* the frame's underside over the floor */
    REC: 0.45, REC_US: 0.4572,                    /* the legs' faces in from the panels' faces */
    BASE_H: 0.09, BASE_H_US: 0.0889,              /* the slatted bases */
    MATT_T: 0.20, MATT_T_US: 0.2032,
    SIDE_H: 0.297, SIDE_H_US: 0.3048,             /* the side + foot panels from the frame's underside */
    HB_H: 0.90, HB_H_US: 0.9144,                  /* the headboard, from the same line */
    NS_W: 0.56, NS_W_US: 0.5588, NS_D: 0.50, NS_D_US: 0.508, NS_H: 0.196, NS_H_US: 0.1969,   /* a nightstand, its top flush with the panels' */
    SLIDE: 0.45, SLIDE_US: 0.4572, SLIDE_GAP: 0.0127, DRW_H: 0.12, DRW_H_US: 0.1143,
    ROW_SP: 0.22, ROW_SP_US: 0.2286, ROWS: [0.03, 0.07], ROWS_US: [0.0254, 0.0635],   /* the panels' screws */
    LATH_Y: [0.45, 1.00], LATH_Y_US: [0.4572, 0.9906], LATH_END: 0.06, LATH_END_US: 0.0635, LATH_SP: 0.40, LATH_SP_US: 0.4064,
    SOCK_Y: 0.70, SOCK_Y_US: 0.7112, PLATE_W: 0.152, PLATE_H: 0.082,
    LED_IN: 0.015, LED_W: 0.012, LED_T: 0.007,
    CABLE: 13, CABLE_US: 13.1064,                 /* m: 5 to the sockets, 8 to the switches + the supply */
    FRAME: 'KVH10100', LATH: 'KVH40060', MATT: 'FMA00002',
    JOINT_SCREW: 'FAS80180', BRK_SCREW: 'FAS50040', PANEL_SCREW: 'FAS60120', PANEL_SCREW_US: 'FAS60100',
    NS_HEAD_SCREW: 'FAS50060', NS_SIDE_SCREW: 'FAS55050', LATH_SCREW: 'FAS45070',
    WALL_SCREW: 'FAS80260', HB_WALL_SCREW: 'FAS80160', PLUG: 'FAS80060',
    LED: 'EEC00006', PSU: 'EEC00007', SOCKET: 'EES00001', SWITCH: 'EEL00001', BOX: 'EEJ00001', CABLE_CODE: 'EEE00001',
    M_ASH40: 'EDGE-GLUED HARDWOOD PANEL, ASH, 40 MM (US 1 1/2 IN.)',
    M_ASH20: 'EDGE-GLUED HARDWOOD PANEL, ASH, 20 MM (US 3/4 IN.)',
    M_PLY: 'BIRCH PLYWOOD 12 MM (US 1/2 IN.)',
    M_HDF: 'HDF BOARD 4 MM (US 1/8 IN.)',
    M_SLIDE: 'DRAWER SLIDES, BALL BEARING, FULL EXTENSION, PUSH-TO-OPEN, 450 MM (US 18 IN.), PAIR',
    M_CONF: 'CONFIRMAT SCREW 7 X 50 + CAP',
    M_BRK: 'RIBBED ANGLE BRACKET 70 X 70 X 55',
    M_S16: 'WOOD SCREW 3.5 X 16 (US #6 X 5/8 IN.)',
    M_S30: 'WOOD SCREW 3.5 X 30 (US #6 X 1 1/4 IN.)',
    M_S25: 'WOOD SCREW 4 X 25 (US #8 X 1 IN.)',
    M_LEDP: 'LED ALUMINIUM PROFILE, RECESSED, OPAL DIFFUSER (with end caps + clips)',
    M_BASE: 'SLATTED BED BASE, HALF THE MATTRESS WIDE (e.g. IKEA LONSET)',
    M_PLATE: 'WALL PLATE, 2-GANG'
  };
  /* the sections: the 4x4 frame, the ash 40 / 20 mm, the ply, the HDF, the laths (flat) -- metric / US actual */
  function _fbProf(s) {
    if ((s || STATE).isMetric === false) return { P: 0.0889, tp: 0.0381, ts: 0.01905, ply: 0.0127, hdf: 0.0032, lt: 0.0381, lw: 0.0635 };
    return { P: 0.100, tp: 0.040, ts: 0.020, ply: 0.012, hdf: 0.004, lt: 0.040, lw: 0.060 };
  }
  function _fbU(s, k) { return ((s || STATE).isMetric === false && FB[k + '_US'] != null) ? FB[k + '_US'] : FB[k]; }
  /* its mattress sizes: the bed's (type 14) from 140 cm / Full up */
  function _fbSizes(s) {
    var mn = ((s || STATE).isMetric === false) ? FB.US_MIN * 0.0254 - 1e-6 : FB.MW_MIN - 1e-6;
    return _bedSizes(s).filter(function (z) { return z.w >= mn; });
  }
  function _fbSize(s) {
    s = s || STATE;
    var sz = _fbSizes(s), w = +s.bedMW, best = 0, i;
    if (!isFinite(w) || w <= 0) w = (s.isMetric === false) ? FB.US_DEF * 0.0254 : FB.MW_DEF;
    for (i = 1; i < sz.length; i++) if (Math.abs(sz[i].w - w) < Math.abs(sz[best].w - w) - 1e-9) best = i;
    sz[best].i = best;
    return sz[best];
  }
  function _fbLayout(s) {
    s = s || STATE;
    var P = _fbProf(s), us = (s.isMetric === false), ms = _fbSize(s), Wm = ms.w, Lm = ms.l, i, j, k, q, a;
    var p = P.P, tp = P.tp, ts = P.ts, LEG = _fbU(s, 'LEG'), REC = _fbU(s, 'REC');
    var NSW = _fbU(s, 'NS_W'), NSD = _fbU(s, 'NS_D'), NSH = _fbU(s, 'NS_H'), HBH = _fbU(s, 'HB_H'), SH = _fbU(s, 'SIDE_H');
    var len180 = us ? 0.1778 : 0.18, len120 = us ? 0.127 : 0.12, len160 = us ? 0.1524 : 0.16, len40 = us ? 0.0381 : 0.04, len50 = us ? 0.0508 : 0.05,
        len60 = us ? 0.0635 : 0.06, len70 = us ? 0.06985 : 0.07, lenPan = us ? 0.1016 : 0.12;
    var pieces = [], fas = [], hw2 = [], plates = [], ash40 = 0, ash20 = 0, ply = 0, hdf = 0, nConf = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function tag(o, ex) { if (ex) for (var e in ex) if (ex.hasOwnProperty(e)) o[e] = ex[e]; return o; }
    /* a piece from its extents (x0 < x1 ...) */
    function box(kind, code, len, id, x0, x1, y0, y1, z0, z1, ex) { pieces.push(tag({ kind: kind, code: code, len: len, id: id, box: [(x0 + x1) / 2, (y0 + y1) / 2, (z0 + z1) / 2, x1 - x0, y1 - y0, z1 - z0] }, ex)); }
    function scr(kind, code, x, y, z, d, ln, ex) { fas.push(tag({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: ln, r: (ln > 0.15) ? 0.004 : 0.003 }, ex)); }
    /* hardware drawn as a box, not timber (brackets, slides, the LED, plates, the bases) */
    function hbox(kind, id, x0, x1, y0, y1, z0, z1, ex) { hw2.push(tag({ kind: kind, id: id, box: [(x0 + x1) / 2, (y0 + y1) / 2, (z0 + z1) / 2, x1 - x0, y1 - y0, z1 - z0] }, ex)); }
    function X(a2, u0, u1) { return (a2 < 0) ? [-u1, -u0] : [u0, u1]; }
    var hw = Wm / 2, zH = -Lm / 2, zF = Lm / 2, y0 = LEG, yF = LEG + p, yB = yF + _fbU(s, 'BASE_H'), yM = yB + _fbU(s, 'MATT_T');
    var ySide = LEG + SH, HBW = Wm + 2 * tp + 2 * NSW, yHB = LEG + HBH, ym = y0 + p / 2;
    var zc1 = zF + tp - REC, zc0 = zc1 - p, xl = hw + tp - REC - p / 2;   /* the crossbar over the foot legs; the legs' axis */
    /* THE FRAME: cross beams, long beams between them, the crossbar, the centre beam in 2; the legs */
    box('beam', FB.FRAME, ceil2(Wm), 'beam-head', -hw, hw, y0, yF, zH, zH + p);
    box('beam', FB.FRAME, ceil2(Wm), 'beam-foot', -hw, hw, y0, yF, zF - p, zF);
    for (a = -1; a <= 1; a += 2) { var xb = X(a, hw - p, hw); box('beam', FB.FRAME, ceil2(Lm - 2 * p), 'beam-' + (a < 0 ? 'l' : 'r'), xb[0], xb[1], y0, yF, zH + p, zF - p); }
    box('beam', FB.FRAME, ceil2(Wm - 2 * p), 'crossbar', -hw + p, hw - p, y0, yF, zc0, zc1);
    box('beam', FB.FRAME, ceil2(zc0 - zH - p), 'centre-head', -p / 2, p / 2, y0, yF, zH + p, zc0);
    box('beam', FB.FRAME, ceil2(zF - p - zc1), 'centre-foot', -p / 2, p / 2, y0, yF, zc1, zF - p);
    var legs = [];
    for (a = -1; a <= 1; a += 2) for (k = 0; k < 2; k++) {
      var lz = (k === 0) ? zH + p / 2 : (zc0 + zc1) / 2, lid = 'leg-' + (k ? 'foot' : 'head') + '-' + (a < 0 ? 'l' : 'r');
      legs.push({ x: a * xl, z: lz });
      box('leg', FB.FRAME, ceil2(LEG), lid, a * xl - p / 2, a * xl + p / 2, 0, y0, lz - p / 2, lz + p / 2, { black: 1 });
      for (q = -1; q <= 1; q += 2) scr('screw-leg', FB.JOINT_SCREW, a * xl, yF, lz + q * p / 4, [0, -1, 0], len180);   /* down through the beam into the leg */
    }
    /* the joints: one 8x180 through the cross member into the butting end (2 at the foot corners) */
    for (a = -1; a <= 1; a += 2) {
      scr('screw-joint', FB.JOINT_SCREW, a * (hw - p / 2), ym, zH, [0, 0, 1], len180);
      for (k = -1; k <= 1; k += 2) scr('screw-joint', FB.JOINT_SCREW, a * (hw - p / 2), ym + k * p / 5, zF, [0, 0, -1], len180);
      scr('screw-joint', FB.JOINT_SCREW, a * hw, ym, (zc0 + zc1) / 2, [-a, 0, 0], len180);
    }
    scr('screw-joint', FB.JOINT_SCREW, 0, ym + 0.02, zH, [0, 0, 1], len180);
    scr('screw-joint', FB.JOINT_SCREW, 0, ym + 0.02, zc1, [0, 0, -1], len180);
    scr('screw-joint', FB.JOINT_SCREW, 0, ym - 0.02, zc0, [0, 0, 1], len180);
    scr('screw-joint', FB.JOINT_SCREW, 0, ym - 0.02, zF, [0, 0, -1], len180);
    /* the angle brackets inside: the 4 corners + the crossbar's ends (its head side); 4 screws into each beam */
    var nBrk = 0;
    function bracket(cx, cz, ax, az, id) {
      var t3 = 0.003, bl = 0.07, bh = 0.055, sx = [cx, cx + ax * t3].sort(function (u, v) { return u - v; }), sz = [cz, cz + az * bl].sort(function (u, v) { return u - v; });
      hbox('bracket', id + '-a', sx[0], sx[1], ym - bh / 2, ym + bh / 2, sz[0], sz[1]);
      sx = [cx, cx + ax * bl].sort(function (u, v) { return u - v; }); sz = [cz, cz + az * t3].sort(function (u, v) { return u - v; });
      hbox('bracket', id + '-b', sx[0], sx[1], ym - bh / 2, ym + bh / 2, sz[0], sz[1]);
      for (var m2 = 0; m2 < 2; m2++) for (var n2 = -1; n2 <= 1; n2 += 2) {
        var dd = (m2 === 0) ? 0.02 : 0.05;
        scr('screw-brk', FB.BRK_SCREW, cx + ax * t3, ym + n2 * 0.013, cz + az * dd, [-ax, 0, 0], len40);
        scr('screw-brk', FB.BRK_SCREW, cx + ax * dd, ym + n2 * 0.013, cz + az * t3, [0, 0, -az], len40);
      }
      nBrk++;
    }
    for (a = -1; a <= 1; a += 2) {
      bracket(a * (hw - p), zH + p, -a, 1, 'bracket-head-' + (a < 0 ? 'l' : 'r'));
      bracket(a * (hw - p), zF - p, -a, -1, 'bracket-foot-' + (a < 0 ? 'l' : 'r'));
      bracket(a * (hw - p), zc0, -a, -1, 'bracket-crossbar-' + (a < 0 ? 'l' : 'r'));
    }
    /* THE PANELS (ash 40): the side panels, the foot panel over their ends; screwed from inside
       through the beams in 2 rows, clear of the joints and brackets; glued */
    for (a = -1; a <= 1; a += 2) { var xp = X(a, hw, hw + tp); box('panel', null, 0, 'side-' + (a < 0 ? 'l' : 'r'), xp[0], xp[1], y0, ySide, zH, zF); }
    box('panel', null, 0, 'foot', -hw - tp, hw + tp, y0, ySide, zF, zF + tp);
    ash40 += 2 * Lm * SH + (Wm + 2 * tp) * SH;
    var rows = _fbU(s, 'ROWS'), rsp = _fbU(s, 'ROW_SP'), PS = _fbU(s, 'PANEL_SCREW');
    function along(a0, a1, skip) { var n = Math.max(1, Math.round((a1 - a0) / rsp)), out = [], t, v; for (t = 0; t < n; t++) { v = a0 + (a1 - a0) * (t + 0.5) / n; if (!skip(v)) out.push(v); } return out; }
    var pz = along(zH + p, zF - p, function (z) { return (z < zH + p + 0.08) || (z > zF - p - 0.08) || (z > zc0 - 0.085 && z < zc1 + 0.02); });
    var px = along(-hw + p, hw - p, function (x) { return Math.abs(x) < 0.08 || Math.abs(x) > hw - p - 0.085; });
    for (j = 0; j < rows.length; j++) {
      for (a = -1; a <= 1; a += 2) for (k = 0; k < pz.length; k++) scr('screw-panel', PS, a * (hw - p), y0 + rows[j], pz[k], [a, 0, 0], lenPan);
      for (k = 0; k < px.length; k++) scr('screw-panel', PS, px[k], y0 + rows[j], zF - p, [0, 0, 1], lenPan);
    }
    var glueL = Math.max(0.01, Math.ceil((2 * Lm + Wm) * p * CAT_NEW.GLUE_L_M2 * 100) / 100);
    /* THE HEADBOARD (ash 40) on 3 laths laid flat behind it (the bottom one behind the head beam,
       the others LATH_END short of its ends -- the side LEDs' light passes), screwed from behind */
    box('head', null, 0, 'headboard', -HBW / 2, HBW / 2, y0, yHB, zH - tp, zH);
    ash40 += HBW * HBH;
    var lt = P.lt, lw = P.lw, lathY = _fbU(s, 'LATH_Y'), le = _fbU(s, 'LATH_END'), zl0 = zH - tp - lt, zl1 = zH - tp, laths = [];
    laths.push({ id: 'lath-bottom', x0: -hw, x1: hw, y: ym });
    laths.push({ id: 'lath-mid', x0: -HBW / 2 + le, x1: HBW / 2 - le, y: lathY[0] });
    laths.push({ id: 'lath-top', x0: -HBW / 2 + le, x1: HBW / 2 - le, y: lathY[1] });
    for (k = 0; k < laths.length; k++) {
      var Lt = laths[k], lxs = _rbSpaced(Lt.x0 + 0.05, Lt.x1 - 0.05, _fbU(s, 'LATH_SP'));
      box('lath', FB.LATH, ceil2(Lt.x1 - Lt.x0), Lt.id, Lt.x0, Lt.x1, Lt.y - lw / 2, Lt.y + lw / 2, zl0, zl1);
      for (j = 0; j < lxs.length; j++) scr('screw-lath', FB.LATH_SCREW, lxs[j], Lt.y + 0.012, zl0, [0, 0, 1], len70);
    }
    /* the wall: 12 (by the width) anchors through the head beam + the headboard + the bottom lath,
       8 through the headboard + the middle lath (behind the mattress and the nightstands) --
       drawn through the wood, billed at their length with a plug each */
    var nA = Math.max(6, Math.round(Wm / 0.15)), xa0 = hw - p - 0.085, ya = ym - 0.015, anchors = 0;
    for (k = 0; k < nA; k++) {
      var xa = -xa0 + 2 * xa0 * (k + 0.5) / nA;
      if (Math.abs(Math.abs(xa) - xl) < 0.015) xa += ((Math.abs(xa) > xl) ? 1 : -1) * (xa > 0 ? 1 : -1) * 0.03;
      scr('anchor-frame', FB.WALL_SCREW, xa, ya, zH + p, [0, 0, -1], p + tp + lt, { wall: 1 });
      anchors++;
    }
    var hbx = [-(hw + tp + NSW * 0.75), -(hw + tp + NSW * 0.25), -hw * 0.75, -hw * 0.25, hw * 0.25, hw * 0.75, hw + tp + NSW * 0.25, hw + tp + NSW * 0.75];
    for (k = 0; k < hbx.length; k++) { scr('anchor-hb', FB.HB_WALL_SCREW, hbx[k], lathY[0] - 0.008, zH, [0, 0, -1], tp + lt, { wall: 1 }); anchors++; }
    /* THE NIGHTSTANDS (ash 20): top + bottom over the full size, the sides between them (on
       confirmats, down through the boards into the sides' edges), the drawer: an inset front,
       a 12 mm ply box with an HDF bottom on full-extension slides */
    var xs0 = hw + tp, xs1 = xs0 + NSW, yN1 = ySide, yN0 = yN1 - NSH, zn1 = zH + NSD, SG = FB.SLIDE_GAP, SL = _fbU(s, 'SLIDE'), DH = _fbU(s, 'DRW_H'), gp = 0.001, pl = P.ply;
    for (a = -1; a <= 1; a += 2) {
      var sd = (a < 0) ? 'l' : 'r', u;
      u = X(a, xs0, xs1); box('ns', null, 0, 'ns-top-' + sd, u[0], u[1], yN1 - ts, yN1, zH, zn1);
      box('ns', null, 0, 'ns-bottom-' + sd, u[0], u[1], yN0, yN0 + ts, zH, zn1);
      u = X(a, xs0, xs0 + ts); box('ns', null, 0, 'ns-side-in-' + sd, u[0], u[1], yN0 + ts, yN1 - ts, zH, zn1);
      u = X(a, xs1 - ts, xs1); box('ns', null, 0, 'ns-side-out-' + sd, u[0], u[1], yN0 + ts, yN1 - ts, zH, zn1);
      u = X(a, xs0 + ts + gp, xs1 - ts - gp); box('front', null, 0, 'drawer-front-' + sd, u[0], u[1], yN0 + ts + gp, yN1 - ts - gp, zn1 - ts, zn1);
      ash20 += 2 * NSW * NSD + 2 * NSD * (NSH - 2 * ts) + (NSW - 2 * ts) * (NSH - 2 * ts);
      /* the drawer box behind the front: sides, front + back walls between them, the bottom inside */
      var bu0 = xs0 + ts + SG, bu1 = xs1 - ts - SG, bz0 = zn1 - ts - SL, bz1 = zn1 - ts, by0 = yN0 + ts + 0.01, by1 = by0 + DH;
      u = X(a, bu0, bu0 + pl); box('drawer', null, 0, 'drawer-side-a-' + sd, u[0], u[1], by0, by1, bz0, bz1);
      u = X(a, bu1 - pl, bu1); box('drawer', null, 0, 'drawer-side-b-' + sd, u[0], u[1], by0, by1, bz0, bz1);
      u = X(a, bu0 + pl, bu1 - pl); box('drawer', null, 0, 'drawer-back-' + sd, u[0], u[1], by0, by1, bz0, bz0 + pl);
      box('drawer', null, 0, 'drawer-wall-' + sd, u[0], u[1], by0, by1, bz1 - pl, bz1);
      box('hdf', null, 0, 'drawer-bottom-' + sd, u[0], u[1], by0 + 0.008, by0 + 0.008 + P.hdf, bz0 + pl, bz1 - pl);
      ply += 2 * SL * DH + 2 * (bu1 - bu0 - 2 * pl) * DH;
      hdf += (bu1 - bu0 - 2 * pl) * (SL - 2 * pl);
      for (k = 0; k < 2; k++) { u = (k === 0) ? X(a, xs0 + ts, xs0 + ts + SG) : X(a, xs1 - ts - SG, xs1 - ts); hbox('slide', 'slide-' + sd + '-' + (k + 1), u[0], u[1], by0 + 0.03, by0 + 0.065, bz0, bz1); }
      /* the confirmats: 2 a side board, top + bottom */
      for (k = 0; k < 2; k++) for (q = 0; q < 2; q++) {
        var cu = (k === 0) ? xs0 + ts / 2 : xs1 - ts / 2, cz = zH + NSD * (q ? 0.75 : 0.25);
        scr('confirmat', null, a * cu, yN1, cz, [0, -1, 0], 0.05, { r7: 1 });
        scr('confirmat', null, a * cu, yN0, cz, [0, 1, 0], 0.05, { r7: 1 });
        nConf += 2;
      }
      /* onto the headboard: 6 from behind (top, bottom, the sides' edges); onto the side panel: 4 from inside, under the slatted base */
      for (q = 0; q < 2; q++) {
        var tu = xs0 + NSW * (q ? 0.7 : 0.3);
        scr('screw-nshead', FB.NS_HEAD_SCREW, a * tu, yN1 - ts / 2, zH - tp, [0, 0, 1], len60);
        scr('screw-nshead', FB.NS_HEAD_SCREW, a * tu, yN0 + ts / 2, zH - tp, [0, 0, 1], len60);
      }
      scr('screw-nshead', FB.NS_HEAD_SCREW, a * (xs0 + ts / 2), (yN0 + yN1) / 2 - 0.02, zH - tp, [0, 0, 1], len60);
      scr('screw-nshead', FB.NS_HEAD_SCREW, a * (xs1 - ts / 2), (yN0 + yN1) / 2 - 0.02, zH - tp, [0, 0, 1], len60);
      for (q = 0; q < 2; q++) for (k = 0; k < 2; k++) scr('screw-nsside', FB.NS_SIDE_SCREW, a * hw, yN0 + ts + (k ? 0.05 : 0.015), zH + NSD * (q ? 0.75 : 0.25), [a, 0, 0], len50);
      /* the electrics over it: a 2-gang plate (socket + switch) on the headboard's face */
      plates.push({ x: a * (xs0 + NSW / 2), y: _fbU(s, 'SOCK_Y'), z: zH, sd: sd });
    }
    /* THE LED: the profile in the groove round the headboard's back (the top, both sides), the supply under the bed */
    var li = FB.LED_IN, lwd = FB.LED_W, ltk = FB.LED_T;
    hbox('led', 'led-top', -HBW / 2 + li, HBW / 2 - li, yHB - li - lwd, yHB - li, zH - tp, zH - tp + ltk);
    for (a = -1; a <= 1; a += 2) { var lu = X(a, HBW / 2 - li - lwd, HBW / 2 - li); hbox('led', 'led-' + (a < 0 ? 'l' : 'r'), lu[0], lu[1], y0, yHB - li - lwd, zH - tp, zH - tp + ltk); }
    var ledM = (HBW - 2 * li) + 2 * (HBH - li - lwd);
    hbox('psu', 'led-supply', -0.10, 0.10, 0.002, 0.052, zH + 0.25, zH + 0.35);
    /* THE SLATTED BASES (2, half the width each) on the frame, the mattress on them */
    var bases = [{ x0: -hw, x1: -0.002 }, { x0: 0.002, x1: hw }];
    var mat = { w: Wm, l: Lm, t: _fbU(s, 'MATT_T'), y: yB };
    /* the bill's quantities: timber by code, the coating (the ash both faces, the legs) */
    var m = {}, coat = 0;
    for (i = 0; i < pieces.length; i++) if (pieces[i].len > 0) m[pieces[i].code] = (m[pieces[i].code] || 0) + pieces[i].len;
    coat = 2 * (ash40 + ash20) + 4 * (4 * p * LEG);
    var r2 = function (v) { return Math.round(v * 100) / 100; };
    var missing = [
      { name: FB.M_ASH40, qty: r2(ash40), unit: 'm2' }, { name: FB.M_ASH20, qty: r2(ash20), unit: 'm2' },
      { name: FB.M_PLY, qty: r2(ply), unit: 'm2' }, { name: FB.M_HDF, qty: r2(hdf), unit: 'm2' },
      { name: FB.M_SLIDE, qty: 2, unit: 'pcs' }, { name: FB.M_CONF, qty: nConf, unit: 'pcs' }, { name: FB.M_BRK, qty: nBrk, unit: 'pcs' },
      { name: FB.M_S16, qty: 24, unit: 'pcs' }, { name: FB.M_S30, qty: 16, unit: 'pcs' }, { name: FB.M_S25, qty: 8, unit: 'pcs' },
      { name: FB.M_LEDP, qty: Math.ceil(ledM * 10 - 1e-6) / 10, unit: 'm' }, { name: FB.M_BASE, qty: 2, unit: 'pcs' }, { name: FB.M_PLATE, qty: 2, unit: 'pcs' }
    ];
    return {
      P: P, us: us, size: ms, W: HBW, L: Lm + tp + tp + lt, Wm: Wm, Lm: Lm, pieces: pieces, fas: fas, hwb: hw2, plates: plates, legs: legs, bases: bases, matt: mat,
      zH: zH, zF: zF, yF: yF, yB: yB, yM: yM, ySide: ySide, yHB: yHB, HBW: HBW, top: yHB, height: yHB, anchors: anchors,
      ledM: Math.ceil(ledM * 10 - 1e-6) / 10, glueL: glueL, cableM: _fbU(s, 'CABLE'), meters: m, coat: coat, missing: missing,
      ash40: ash40, ash20: ash20, zMid: (zH - tp - lt + zF + tp) / 2
    };
  }
  /* its staged assembly (the drawing's order): the frame + legs, its screws, the brackets, the
     panels, their screws, the headboard + laths, their screws, the nightstands, the drawers,
     onto the headboard, the LED, the headboard's anchors, the frame's anchors + the nightstands
     onto the side panels, the electrics, the slatted bases, the mattress (the codes by the units) */
  var _fbStepsC = {};
  function _fbSteps(s) {
    s = s || STATE;
    var key = String(s.isMetric === false);
    if (_fbStepsC[key]) return _fbStepsC[key];
    return (_fbStepsC[key] = [
      { parts: [], codes: [] },
      { parts: ['fb-beam', 'fb-leg'], codes: [FB.FRAME] },
      { parts: ['fb-hw-screw-joint', 'fb-hw-screw-leg'], codes: [FB.JOINT_SCREW] },
      { parts: ['fb-hw-bracket', 'fb-hw-screw-brk'], codes: [FB.BRK_SCREW] },
      { parts: ['fb-panel'], codes: [] },
      { parts: ['fb-hw-screw-panel'], codes: [_fbU(s, 'PANEL_SCREW')] },
      { parts: ['fb-head', 'fb-lath'], codes: [FB.LATH] },
      { parts: ['fb-hw-screw-lath'], codes: [FB.LATH_SCREW] },
      { parts: ['fb-ns', 'fb-hw-confirmat'], codes: [] },
      { parts: ['fb-drawer', 'fb-hdf', 'fb-front', 'fb-hw-slide'], codes: [] },
      { parts: ['fb-hw-screw-nshead'], codes: [FB.NS_HEAD_SCREW] },
      { parts: ['fb-hw-led', 'fb-hw-psu'], codes: [FB.LED, FB.PSU] },
      { parts: ['fb-hw-anchor-hb'], codes: [FB.HB_WALL_SCREW, FB.PLUG] },
      { parts: ['fb-hw-anchor-frame', 'fb-hw-screw-nsside'], codes: [FB.WALL_SCREW, FB.NS_SIDE_SCREW] },
      { parts: ['fb-hw-plate'], codes: [FB.SOCKET, FB.SWITCH, FB.BOX] },
      { parts: ['fb-hw-base'], codes: [] },
      { parts: ['fb-mattress'], codes: [FB.MATT] }
    ]);
  }
  /* ------------------------------------------------------------------
     v320 TYPE 22 -- GARDEN STRUCTURE, variant 3: THE GARDEN ARBOR (Marek
     2026-10-21 14:07 with two photos -- a flat-topped arbor over a path of
     stepping tiles, a gable pergola under slats: "Dalsi projekt - pruchod
     na zahrade primarne urceny pro popinave rostliny. Udelat dva typy -
     rovny a sedlovy tvar, moznost editace delky a sirky. Vyska vicemene
     standardni asi bez Drag point. Menit se bude jen strecha"; asked, the
     sides: "Udelej to podle obrazku ... primarne je to okrasny prvek, takze
     celo drevena = late"; the posts: "Prefabrikovana. Muze byt mozna i
     dlazdice + zemni vruty").
     v321 (Marek 15:23 on v320: "Dlazbu dat jen pod nohy, misto zalozeni na
     vrutech. Sedlovou strechu spis udelat tak, ze bude mit masivnejsi
     krokve (samozrejme pozednici pod) a battens vodorovne vedouci pres
     krokve"):
       - each POST 4x4 KVH10100 2.12 (US 7 ft) on a CONCRETE PAVER SFF00002
         500 x 500 (US 20 x 20 in.), its top 3 cm over the ground on 10 cm of
         gravel, in an adjustable post base FFP01001 (the post 30 mm up, 12
         connector nails FAS38038 through its flanges) held down by 2
         concrete screws (no catalogue row short enough for a 50 mm paver:
         drawn, NOT BILLED, MISSING); a pair across the path at each end and
         at <= 2.40 m (US 8 ft) between; no ground screws, no path tiles;
       - a HEAD across each pair (the portal): v321 a 4x4 KVH10100 as the
         posts (Marek 15:30: "Pricne horni profily / pozednice a vzpery
         udelat ze stejneho profilu jako jsou sloupky"; v320 a 2x6) on the
         posts' tops, 25 cm (US 10 in.) past their outer faces, its ends
         raked as the photo's; 2 x 8x260 FAS80260 down into each post;
       - KNEE BRACES in each portal, v321 4x4 KVH10100 too (v320 2x4), from
         the post's inner face up under the head at 45 deg (30 cm run, less
         on a narrow arbor); 2 x 6x160 FAS60160 toe screws at each end from
         its underside, side by side;
       - SIDE LATHS 40x60 KVH40060 (US 2x3) on edge across the posts' outer
         faces, <= 25 cm (US 10 in.) apart from 30 cm (US 12 in.) up to 15 cm
         under the heads -- the climbers' ladder; a 6.5x90 stainless FAS65090
         into every post;
       - THE ROOF on the info bar's switch (only the roof changes):
         FLAT -- 2x4 slats on edge along the path on the heads, one over each
         post line, the rest <= 30 cm apart out to the heads' ends, 25 cm past
         the end posts, raked ends; a 6x160 FAS60160 down into every head (v321; the 4x4 head is
         100 deep);
         GABLE (35 deg, v321) -- a 4x4 WALL PLATE KVH10100 along each side on
         the heads over the posts, 20 cm (US 8 in.) past the end posts (2 x
         8x160 FAS80160 down into each head); 2x6 RAFTERS KVH60160 at <= 60
         cm, one at each end of the plates and the rest between the heads
         (never on a head), birdsmouthed 4 cm (US 1 1/2 in.) over the plate
         with a 25 cm (US 10 in.) tail cut plumb, plumb against a 2x8 RIDGE
         BOARD KVH60200 on edge (its top flush with theirs); an 8x260
         FAS80260 (US 8x200 FAS80200) down through each seat into the plate,
         2 toe screws 6x80 FAS60080 at the ridge; 40x60 BATTENS KVH40060 on
         edge level along the path across the rafters, <= 20 cm (US 8 in.)
         apart, 3 cm past the end rafters, a 6x100 FAS60100 into every
         rafter.
     v322 (Marek 17:00 on v321: "Krokve nejsou dobre pridelene k hrebeni,
     vruty jsou jak jsi z boku maji byt z vrchu krokve do hrebeneveho
     profilu. Zaklad ma byt prepinany bud to bude stat na dlazdicich, nebo
     na kotvach s vruty, nebo muzeme pouzit i prefabrikovane patky, do
     kterych sloup presne zapadne"):
       - AT THE RIDGE 2 x 6x100 FAS60100 into each rafter from its top,
         square to the slope (as the battens' screws), through the plumb
         cut into the ridge board, 6 mm short of its middle (the other
         side's meet them there) -- no toe screws from the sides;
       - THE FOUNDATION on the toggle (STATE.gaFound): 'tile' the paver +
         post base of v321; 'screw' a GROUND SCREW FGR00001 76 x 1200 (US 3
         in. x 4 ft) a post, its head 5 cm (US 2 in.) up, with a U head
         FGR00002 (the post 30 mm up, 12 nails); 'block' a precast DECK
         BLOCK FCO00012 300 x 300 x 200 (US 12 x 12 x 8 in.) on 10 cm of
         gravel, 10 cm (US 4 in.) of it over the ground, the post standing 5
         cm (US 2 in.) down in its socket -- nothing to fix it with.
     X = across (W, front +), Y = up, Z = along the path (L); centred on 0.
     L / W = the posts' outer faces. _gaLayout(STATE) is the single source. */
  var GA = {
    L: [0.60, 4.80], L_US: [0.6096, 4.8768], W: [0.90, 2.40], W_US: [0.9144, 2.4384],
    L0: 0.90, L0_US: 0.9144, W0: 1.50, W0_US: 1.524,
    POST_H: 2.12, POST_H_US: 2.1336,             /* 7 ft */
    SPAN: 2.40, SPAN_US: 2.4384,                 /* the portals at most this far apart */
    TILE: 0.50, TILE_US: 0.508, TILE_T: 0.05, TILE_T_US: 0.0508,   /* the paver under each post (as the cinema bar's) */
    TILE_UP: 0.03, TILE_UP_US: 0.0254, GRAVEL: 0.10, GRAVEL_US: 0.1016,
    BASE_UP: 0.030, BASE_T: 0.004, BASE_FLANGE: 0.12, NAIL_OFF: 0.025,
    BASE_PL: 0.16, ANCHOR_OFF: 0.06, ANCHOR_LEN: 0.04, ANCHOR_LEN_US: 0.04445,   /* the base's foot plate along Z, its 2 concrete screws */
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.038, GS_R_US: 0.0381,   /* v322 the ground screw's head over the ground, FGR00001 76 (US 3 in.) */
    BLK: 0.30, BLK_US: 0.3048, BLK_TOP: 0.20, BLK_TOP_US: 0.2032, BLK_H: 0.20, BLK_H_US: 0.2032,   /* v322 the deck block FCO00012 (its top narrower) */
    BLK_UP: 0.10, BLK_UP_US: 0.1016, SOCK: 0.05, SOCK_US: 0.0508,   /* -- over the ground; the post's socket in its top */
    HEAD_OV: 0.25, HEAD_OV_US: 0.254,            /* the head past the posts' outer faces */
    SLAT_OV: 0.25, SLAT_OV_US: 0.254,            /* the flat roof's slats past the end posts' outer faces */
    RAKE: 0.6,                                   /* a raked end: its underside this share of the depth shorter */
    BRACE: 0.30, BRACE_US: 0.3048, BRACE_MIN: 0.15, BRACE_CLR: 0.15, TOE: 0.08,
    LATH_Y0: 0.30, LATH_Y0_US: 0.3048, LATH_SP: 0.25, LATH_SP_US: 0.254, LATH_TOP: 0.15, LATH_TOP_US: 0.1524,
    SLAT_SP: 0.30, SLAT_SP_US: 0.3048, SLAT_END: 0.07,
    PITCH: 35, TOE_IN: 0.035, TOE_ANG: 37, TOE_DY: 0.04,
    PLATE_OV: 0.20, PLATE_OV_US: 0.2032,         /* v321 the wall plates (+ ridge) past the end posts' outer faces */
    NOTCH: 0.04, NOTCH_US: 0.0381,               /* the birdsmouth's depth at the heel */
    TAIL: 0.25, TAIL_US: 0.254,                  /* the rafter past the plate's outer face */
    RAF_SP: 0.60, RAF_SP_US: 0.6096, RAF_END: 0.03,
    BAT_SP: 0.20, BAT_SP_US: 0.2032, BAT_RIDGE: 0.06, BAT_OV: 0.03,
    POST: 'KVH10100', HEAD: 'KVH10100', BRACE_CODE: 'KVH10100', LATH: 'KVH40060', SLAT: 'KVH10060',
    PLATE: 'KVH10100', RAFTER: 'KVH60160', RIDGE: 'KVH60200', BATTEN: 'KVH40060',
    BASE: 'FFP01001', NAIL: 'FAS38038', HEAD_SCREW: 'FAS80260', TOE_SCREW: 'FAS60160', LATH_SCREW: 'FAS65090',
    SLAT_SCREW: 'FAS60160', PLATE_SCREW: 'FAS80160', TOE_OFF: 0.025, RAFTER_SCREW: 'FAS80260', RAFTER_SCREW_US: 'FAS80200', RIDGE_SCREW: 'FAS60100', RIDGE_STOP: 0.006, BAT_SCREW: 'FAS60100',   /* v322 the ridge's screws from the rafters' tops (was RIDGE_TOE FAS60080 from the sides) */
    TILE_CODE: 'SFF00002', DIG: 'FEE00001', GRAVEL_CODE: 'FCO00001', GSCREW: 'FGR00001', UHEAD: 'FGR00002', BLOCK: 'FCO00012',   /* v322 the other two foundations */
    ANCHOR: 'CONCRETE SCREW ANCHOR 6 X 40 (US 1/4 X 1 3/4 IN.) -- the garden arbor\'s post bases into the 50 mm pavers', ANCHOR_CODE: 'FAS60040',   /* v345 its catalogue row */
    /* v331 THE ARCH (mode 'arch'; v332 the arched arbor): two layers of
       40x160 boards (US 2x6), blanks + a kerf, a board ARCH_FIT narrower than
       its nominal width, the arcs drawn every ARCH_STEP deg; 5x60 between the
       layers <= ARCH_SP apart and ARCH_CLR off the joints; v332 layer B's
       foot lapped LAP down into the post, 6x80 through the post into it */
    ARCH: 'KVH16040', ARCH_KERF: 0.01, ARCH_FIT: 0.004, ARCH_STEP: 3,
    ARCH_SP: 0.10, ARCH_CLR: 0.03, ARCH_SCREW: 'FAS50060', LAP: 0.30, LAP_US: 0.3048, LAP_SCREW: 'FAS60080',
    GRID_SCREW: 'FAS45070'                       /* v333 the trellis' uprights into the laths, 4.5x70 stainless (US #9 x 2 3/4 in.) */
  };
  /* the sections (metric / US actual): the 4x4 post / head / brace / wall
     plate (v321 the head and brace as the post: ht = hh = p), the 2x6
     rafter, the 2x4 slat, the 40x60 (US 2x3) lath / batten, the 2x8 ridge */
  function _gaProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.0889, ht: 0.0889, hh: 0.0889, st: 0.0381, sh: 0.0889, lt: 0.0381, lh: 0.0635, rw: 0.0381, rh: 0.1397, rgt: 0.0381, rgd: 0.1842, at: 0.0381, aw: 0.1397 };   /* v331 + the arch's board, 2x6 */
    return { p: 0.100, ht: 0.100, hh: 0.100, st: 0.060, sh: 0.100, lt: 0.040, lh: 0.060, rw: 0.060, rh: 0.160, rgt: 0.060, rgd: 0.200, at: 0.040, aw: 0.160 };   /* v331 + the arch's board, 40x160 */
  }
  function _gaU(s, k) { return ((s || STATE).isMetric === false && GA[k + '_US'] != null) ? GA[k + '_US'] : GA[k]; }
  function _gaMode(s) { var m = (s || STATE).gaMode; return (m === 'gable' || m === 'arch') ? m : 'flat'; }   /* v331 + 'arch' (the gable roof + an arch in every portal) */
  function _gaFound(s) { var f = (s || STATE).gaFound; return (f === 'screw' || f === 'block') ? f : 'tile'; }
  function _gaGrid(s) { return (s || STATE).gaGrid === true; }   /* v333 the trellis: an upright layer inside the side laths */   /* v322 the foundation: pavers | ground screws | deck blocks */
  function _gaRange(s) { var r = _gaU(s, 'L'); return { min: r[0], max: r[1] }; }
  function _gaWRange(s) { var r = _gaU(s, 'W'); return { min: r[0], max: r[1] }; }
  function _gaL(s) { s = s || STATE; var R = _gaRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _gaU(s, 'L0'))); }
  function _gaW(s) { s = s || STATE; var R = _gaWRange(s), v = +s.gaW; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _gaU(s, 'W0'))); }
  function _gaLayout(s) {
    s = s || STATE;
    var P = _gaProf(s), us = (s.isMetric === false), mode = _gaMode(s), L = _gaL(s), W = _gaW(s), i, j, k, q, sx;
    var p = P.p, hp = p / 2, ht = P.ht, hh = P.hh, st = P.st, sh = P.sh, lt = P.lt, lh = P.lh;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len100 = us ? 0.1016 : 0.10, len90 = us ? 0.0889 : 0.09, len80 = us ? 0.0762 : 0.08, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], tiles = [], bases = [], posts = [], gscrews = [], blocks = [], nAnchor = 0, found = _gaFound(s);
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function scr(kind, code, x, y, z, d, ln, r) { fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: d, len: ln, r: r || 0.003 }); }
    /* the heights: the foundation's top (the paver's / the ground screw's
       head / the deck block's), the post's foot (in its base -- v322 or down
       in the block's socket), its top = the head's underside, the head's top */
    var yF = (found === 'screw') ? _gaU(s, 'FOOT_UP') : (found === 'block') ? _gaU(s, 'BLK_UP') : _gaU(s, 'TILE_UP');
    var yPB = (found === 'block') ? yF - _gaU(s, 'SOCK') : yF + GA.BASE_UP, postH = _gaU(s, 'POST_H'), yPT = yPB + postH, yHT = yPT + hh;
    /* the portals: a pair of posts at each end and at <= SPAN between */
    var zs = L / 2 - hp, nB = Math.max(1, Math.ceil(2 * zs / _gaU(s, 'SPAN') - 1e-9)), zP = [], px = W / 2 - hp;
    for (i = 0; i <= nB; i++) zP.push(-zs + 2 * zs * i / nB);
    for (i = 0; i < zP.length; i++) for (sx = -1; sx <= 1; sx += 2) posts.push({ x: sx * px, z: zP[i], sx: sx, k: i, id: (sx < 0 ? 'b' : 'f') + (i + 1) });
    /* THE FOUNDATION (v322 on the toggle): 'tile' -- a PAVER under each
       post, the post base on it (2 concrete screws -- drawn, NOT BILLED);
       'screw' -- a GROUND SCREW, its U head on it; the post in the base / U
       head (6 nails a flange); 'block' -- a DECK BLOCK, the post down in its
       socket (nothing to fix) */
    var tl = _gaU(s, 'TILE'), tT = _gaU(s, 'TILE_T'), gv = _gaU(s, 'GRAVEL'), bt = GA.BASE_T, nOff = GA.NAIL_OFF, aLen = _gaU(s, 'ANCHOR_LEN');
    var bk = _gaU(s, 'BLK'), bkT = _gaU(s, 'BLK_TOP'), bkH = _gaU(s, 'BLK_H');
    for (i = 0; i < posts.length; i++) {
      q = posts[i];
      if (found === 'tile') {
        tiles.push({ x: q.x, z: q.z, w: tl, y0: yF - tT, y1: yF, id: 'tile-' + q.id });
        for (k = -1; k <= 1; k += 2) { scr('anchor', GA.ANCHOR_CODE, q.x, yF + bt, q.z + k * GA.ANCHOR_OFF, [0, -1, 0], aLen, 0.003); nAnchor++; }   /* v345 billed as drawn (FAS60040) */
      } else if (found === 'screw') {
        gscrews.push({ x: q.x, z: q.z, r: _gaU(s, 'GS_R'), y1: yF, id: q.id });
      } else {
        blocks.push({ x: q.x, z: q.z, w: bk, wt: bkT, y0: yF - bkH, y1: yF, id: 'block-' + q.id });
      }
      if (found !== 'block') {
        bases.push({ x: q.x, z: q.z, y0: yF, y1: yPB, id: q.id, u: (found === 'screw') });
        for (k = -1; k <= 1; k += 2) for (var nz = -1; nz <= 1; nz += 2) for (var ny = 0; ny < 3; ny++)
          scr('nail', GA.NAIL, q.x + k * (hp + bt), yPB + 0.02 + ny * 0.035, q.z + nz * nOff, [-k, 0, 0], len38, 0.0019);
      }
      if (mode === 'arch') {   /* v332 its +Z half cut away LAP down from the top: layer B of the arch laps in there (in (z, y), across X) */
        var lpY = yPT - _gaU(s, 'LAP');
        poly('post', GA.POST, ceil2(postH), 'post-' + q.id, [[q.z - hp, yPB], [q.z + hp, yPB], [q.z + hp, lpY], [q.z, lpY], [q.z, yPT], [q.z - hp, yPT]], 'zy', q.x, p);
      } else box('post', GA.POST, ceil2(postH), 'post-' + q.id, q.x, yPB + postH / 2, q.z, p, postH, p);
    }
    /* THE HEADS: across each pair on the posts' tops, raked ends; 2 screws down into each post (side by side along the head) */
    var ha = W / 2 + _gaU(s, 'HEAD_OV'), rk = GA.RAKE * hh;
    for (i = 0; i < zP.length && mode !== 'arch'; i++) {   /* v332 no heads on the arched arbor */
      poly('head', GA.HEAD, ceil2(2 * ha), 'head-' + (i + 1), [[-ha, yHT], [ha, yHT], [ha - rk, yPT], [-ha + rk, yPT]], 'xy', zP[i], ht);
      for (sx = -1; sx <= 1; sx += 2) for (k = -1; k <= 1; k += 2) scr('screw-head', GA.HEAD_SCREW, sx * px + k * 0.025, yHT, zP[i], [0, -1, 0], len260);
    }
    /* THE KNEE BRACES in each portal: (u, v) from the corner of the post's
       inner face and the head's underside, u inward, v up; the band +- half
       the 2x4's width about the 45 deg axis from (0, -a) to (a, 0), cut
       plumb on the post and level under the head; a toe screw at each end
       from the brace's underside (as the pergola swing's) */
    var bw = p, k2 = bw / 2 * Math.SQRT2, toe = GA.TOE;   /* v321 the 4x4 */
    var ba = Math.min(_gaU(s, 'BRACE'), Math.max(GA.BRACE_MIN, (W - 2 * p) / 2 - GA.BRACE_CLR - k2));
    for (i = 0; i < posts.length && mode !== 'arch'; i++) {   /* v332 nor braces (the arch stiffens the portal) */
      q = posts[i];
      var u0 = q.x - q.sx * hp, dI = -q.sx;
      var Wb = function (u, v) { return [u0 + dI * u, yPT + v]; };
      poly('brace', GA.BRACE_CODE, ceil2((ba + k2) * Math.SQRT2), 'brace-' + q.id, [Wb(0, -(ba + k2)), Wb(0, -(ba - k2)), Wb(ba - k2, 0), Wb(ba + k2, 0)], 'xy', q.z, ht);
      var pA = Wb(toe, toe - ba - k2), pB = Wb(ba + k2 - toe, -toe);
      for (k = -1; k <= 1; k += 2) {   /* v321 two an end, side by side (the slats' screws pass between) */
        scr('screw-brace', GA.TOE_SCREW, pA[0], pA[1], q.z + k * GA.TOE_OFF, [-dI, 0, 0], len160);
        scr('screw-brace', GA.TOE_SCREW, pB[0], pB[1], q.z + k * GA.TOE_OFF, [0, 1, 0], len160);
      }
    }
    /* THE SIDE LATHS: on edge across the posts' outer faces, the arbor's length; a screw into every post */
    var ly0 = _gaU(s, 'LATH_Y0'), ly1 = yPT - _gaU(s, 'LATH_TOP'), nLt = Math.max(1, Math.ceil((ly1 - ly0) / _gaU(s, 'LATH_SP') - 1e-9)), lys = [];
    for (i = 0; i <= nLt; i++) lys.push(ly0 + (ly1 - ly0) * i / nLt);
    for (sx = -1; sx <= 1 && mode !== 'arch'; sx += 2) for (j = 0; j < lys.length; j++) {   /* v332 the arched arbor's laths below, over the arches */
      box('lath', GA.LATH, ceil2(L), 'lath-' + (sx < 0 ? 'b' : 'f') + (j + 1), sx * (W / 2 + lt / 2), lys[j], 0, lt, lh, L);
      for (i = 0; i < zP.length; i++) scr('screw-lath', GA.LATH_SCREW, sx * (W / 2 + lt), lys[j], zP[i], [-sx, 0, 0], len90);
    }
    /* THE ROOF */
    var top = yHT, rafL = 0, ridge = null, nBat = 0, nRaf = 0, deg = 0, arch = null;   /* v331 + the arch's numbers (v332 the arched arbor's, after the roofs) */
    if (mode === 'flat') {
      /* 2x4 slats on edge along the path on the heads: one over each post line,
         the rest <= SLAT_SP apart between them and out to the heads' ends;
         raked ends (in (z, y)); a 6x160 down into every head (v321 in its
         middle, the braces' toe screws either side) */
      var hl = L / 2 + _gaU(s, 'SLAT_OV'), xEnd = ha - GA.SLAT_END - st / 2, ssp = _gaU(s, 'SLAT_SP'), xsl = [], rk2 = GA.RAKE * sh, ySB = yHT, yST = yHT + sh;
      var nIn = Math.max(1, Math.ceil(2 * px / ssp - 1e-9));
      for (i = 0; i <= nIn; i++) xsl.push(-px + 2 * px * i / nIn);
      if (xEnd > px + st + 0.01) {
        var nOut = Math.max(1, Math.ceil((xEnd - px) / ssp - 1e-9));
        for (i = 1; i <= nOut; i++) { var xo1 = px + (xEnd - px) * i / nOut; xsl.push(xo1, -xo1); }
      }
      xsl.sort(function (a, b) { return a - b; });
      for (j = 0; j < xsl.length; j++) {
        poly('slat', GA.SLAT, ceil2(2 * hl), 'slat-' + (j + 1), [[-hl, yST], [hl, yST], [hl - rk2, ySB], [-hl + rk2, ySB]], 'zy', xsl[j], st);
        for (i = 0; i < zP.length; i++) scr('screw-slat', GA.SLAT_SCREW, xsl[j], yST, zP[i], [0, -1, 0], len160);
      }
      top = yST;
    } else if (mode === 'gable') {
      /* GABLE (v321): the wall plates on the heads over the posts (2 screws
         down into every head, clear of the head's own screws), the 2x6
         rafters birdsmouthed over them -- the bottom edge yu(x) = yE1 + (xSE
         - x) tan, the heel on the plate's outer face NOTCH deep, the seat on
         its top, the tail TAIL past it cut plumb -- plumb against the ridge
         board's faces; at the plates' ends and between the heads, never on
         a head (the tails would cut it) */
      var th = GA.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th);
      var rw = P.rw, dV = P.rh / cs, xr = P.rgt / 2, plH = L / 2 + _gaU(s, 'PLATE_OV'), yE1 = yHT + p;
      var xH = px + hp, nD = _gaU(s, 'NOTCH'), xSE = xH - nD / tn, xTl = xH + _gaU(s, 'TAIL');
      var yu = function (x) { return yE1 + (xSE - x) * tn; }, yT0 = yu(xr) + dV;
      for (sx = -1; sx <= 1; sx += 2) {
        box('plate', GA.PLATE, ceil2(2 * plH), 'plate-' + (sx < 0 ? 'b' : 'f'), sx * px, yHT + hp, 0, p, p, 2 * plH);
        for (i = 0; i < zP.length; i++) for (k = -1; k <= 1; k += 2) scr('screw-plate', GA.PLATE_SCREW, sx * px + k * 0.04, yE1, zP[i], [0, -1, 0], us ? 0.1524 : 0.16);   /* v321 8x160 (the head 100 deep) */
      }
      var zEnd = plH - GA.RAF_END - rw / 2, zr = [-zEnd, zEnd], rsp = _gaU(s, 'RAF_SP');
      for (i = 0; i + 1 < zP.length; i++) {
        var bay = zP[i + 1] - zP[i], nR = Math.max(1, Math.ceil(bay / rsp - 1e-9));
        for (j = 0; j < nR; j++) zr.push(zP[i] + bay * (j + 0.5) / nR);
      }
      zr.sort(function (a, b) { return a - b; });
      nRaf = zr.length;
      rafL = ceil2((xTl - xr) / cs); deg = GA.PITCH;
      var rpR = [[xr, yu(xr) + dV], [xTl, yu(xTl) + dV], [xTl, yu(xTl)], [xH, yu(xH)], [xH, yE1], [xSE, yE1], [xr, yu(xr)]];
      var rpL = rpR.map(function (Pt) { return [-Pt[0], Pt[1]]; }).reverse();
      var xe = (xSE + xH) / 2, RS = _gaU(s, 'RAFTER_SCREW'), lenRS = (RS === 'FAS80260') ? len260 : len200;
      /* v322 at the ridge: 2 screws a rafter from its top, square to the
         slope, through the plumb cut into the board -- set back dR from the
         cut so that each stops RIDGE_STOP short of the board's middle (the
         other side's pair meets them there); a quarter of the rafter's
         thickness either side of its middle */
      var lenRg = len100, dR = lenRg * sn - (xr - GA.RIDGE_STOP);
      for (i = 0; i < zr.length; i++) for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', GA.RAFTER, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-b' : '-f'), (sx < 0) ? rpL : rpR, 'xy', zr[i], rw);
        scr('screw-rafter', RS, sx * xe, yu(xe) + dV, zr[i] - 0.25 * rw, [0, -1, 0], lenRS);
        for (k = -1; k <= 1; k += 2) scr('screw-ridge', GA.RIDGE_SCREW, sx * (xr + dR), yT0 - dR * tn, zr[i] + k * rw / 4, [-sx * sn, -cs, 0], lenRg);
      }
      /* the ridge board on edge along the path, its top flush with the rafters' */
      box('ridge', GA.RIDGE, ceil2(2 * plH), 'ridge', 0, yT0 - P.rgd / 2, 0, P.rgt, P.rgd, 2 * plH);
      ridge = { top: yT0, y0: yT0 - P.rgd };
      /* the battens: 40x60 on edge (square to the slope), level along the
         path across the rafters, <= BAT_SP apart from BAT_RIDGE off the
         ridge to the tails, BAT_OV past the end rafters; a screw through each
         into every rafter (a quarter of its thickness off the middle, clear
         of the seat's screw) */
      var bW = lt, bH = lh, bl = plH + GA.BAT_OV, Ssl = (xTl - xr) / cs, s0 = GA.BAT_RIDGE + bW / 2, s1 = Ssl - bW / 2 - 0.01;
      var nBt = Math.max(1, Math.ceil((s1 - s0) / _gaU(s, 'BAT_SP') - 1e-9)), bTop = yT0;
      for (sx = -1; sx <= 1; sx += 2) for (j = 0; j <= nBt; j++) {
        var sj = s0 + (s1 - s0) * j / nBt, ux = sx * cs, uy = -sn, nx = sx * sn, ny2 = cs;
        var Qx = sx * xr + ux * sj, Qy = yT0 + uy * sj, h2 = bW / 2;
        var pp2 = [[Qx - ux * h2, Qy - uy * h2], [Qx + ux * h2, Qy + uy * h2], [Qx + ux * h2 + nx * bH, Qy + uy * h2 + ny2 * bH], [Qx - ux * h2 + nx * bH, Qy - uy * h2 + ny2 * bH]];
        if (sx < 0) pp2.reverse();
        poly('batten', GA.BATTEN, ceil2(2 * bl), 'batten-' + (sx < 0 ? 'b' : 'f') + (j + 1), pp2, 'xy', 0, 2 * bl);
        bTop = Math.max(bTop, Qy - uy * h2 + ny2 * bH);
        nBat++;
        for (i = 0; i < zr.length; i++) scr('screw-batten', GA.BAT_SCREW, Qx + nx * bH, Qy + ny2 * bH, zr[i] + 0.25 * rw, [-nx, -ny2, 0], len100);
      }
      top = bTop;
    }
    /* v332 THE ARCHED ARBOR (mode 'arch'; Marek 2026-10-21 20:32 on v331:
       "Udelej ten arched ale asi bez krokvi, aby sloupy plynule navazovaly
       na oblouk. Najdi vhodny design a udelej to podle toho. Late potom na
       boku pokracuji plynule pres oblouk"): the classic arched garden arbor
       -- no heads, braces or roof; each portal's posts run on into a
       SEMICIRCULAR ARCH, its centre between the posts' tops, its intrados the
       posts' inner faces, its extrados their outer faces (the posts flow into
       it in the front view). Two layers of 40x160 KVH16040 (US 2x6) face to
       face, centred in the post's depth (80 of 100 mm, US 3 of 3 1/2 in.):
       A on the -Z side of n pieces, B on +Z of n + 1 (half pieces at the
       feet), every joint of one layer half a piece off the other's; each
       piece cut from a straight blank, n the fewest that fits the board;
       BILLED BY THE BLANKS + a kerf. THE FOOT, a half lap: each post's +Z half
       cut away LAP down from its top, layer B's foot piece runs on LAP
       straight down into it, layer A stands on the post's other half; 4 x
       6x80 FAS60080 (US 3 in.) from the post's -Z face through it into B's
       leg, on the post's inner quarter line (the laths' screws reach the
       middle only). 5x60 FAS50060 between the layers (as v331): at least 2
       between every two neighbouring joints, <= ARCH_SP apart, alternately
       from either face on two lines a quarter of the ring in from its edges,
       ARCH_CLR off the joints. THE LATHS go on from the sides over the
       arches: the same 40x60 on edge, evenly <= LATH_SP along the path from
       LATH_Y0 up one side, over the extrados and down the other; a 6.5x90
       FAS65090 into every post (a quarter of its depth off the lap's face) /
       into every arch, in the layer farther from a joint. f = the angle
       from the crown, + toward +X; +-90 deg the springing. */
    var gLys = [];   /* v333 the arched arbor's side laths (one side), for the trellis */
    if (mode === 'arch') {
      var aT = P.at, aWd = P.aw - GA.ARCH_FIT, yS = yPT, ri = px - hp, re = px + hp, rm = px, lap = _gaU(s, 'LAP'), stR = GA.ARCH_STEP * Math.PI / 180, hP = Math.PI / 2;
      var apt = function (r, f) { return [r * Math.sin(f), yS + r * Math.cos(f)]; };
      /* the ring between fa < fb, the extrados left to right, the intrados back; B's foot pieces with their straight legs */
      var ringP = function (fa, fb, legL, legR) {
        var pts = [], nS = Math.max(2, Math.ceil((fb - fa) / stR)), q3;
        if (legL) pts.push([-re, yS - lap]);
        for (q3 = 0; q3 <= nS; q3++) pts.push(apt(re, fa + (fb - fa) * q3 / nS));
        if (legR) { pts.push([re, yS - lap]); pts.push([ri, yS - lap]); }
        for (q3 = nS; q3 >= 0; q3--) pts.push(apt(ri, fa + (fb - fa) * q3 / nS));
        if (legL) pts.push([-ri, yS - lap]);
        return pts;
      };
      /* the shortest straight blank a piece fits in: every direction (0.5 deg) whose width the board covers */
      var blankOf = function (pts) {
        var best = null, kk, q3;
        for (kk = 0; kk < 360; kk++) {
          var th3 = kk * Math.PI / 360, ux3 = Math.cos(th3), uy3 = Math.sin(th3), l0 = 1e9, l1 = -1e9, w0 = 1e9, w1 = -1e9;
          for (q3 = 0; q3 < pts.length; q3++) {
            var lu = pts[q3][0] * ux3 + pts[q3][1] * uy3, lw = pts[q3][1] * ux3 - pts[q3][0] * uy3;
            if (lu < l0) l0 = lu; if (lu > l1) l1 = lu; if (lw < w0) w0 = lw; if (lw > w1) w1 = lw;
          }
          if (w1 - w0 <= aWd && (!best || l1 - l0 < best.len)) best = { len: l1 - l0, w: w1 - w0, th: th3 };
        }
        return best;
      };
      var layer = function (bd, legs) {
        var r = [], q3;
        for (q3 = 0; q3 + 1 < bd.length; q3++) {
          var pts3 = ringP(bd[q3], bd[q3 + 1], legs && q3 === 0, legs && q3 + 2 === bd.length), bl = blankOf(pts3);
          if (!bl) return null;
          r.push({ pts: pts3, bl: bl, fa: bd[q3], fb: bd[q3 + 1] });
        }
        return r;
      };
      var layA = null, layB = null, nArc = 0, jA = [], jB = [];
      for (var nTry = 2; nTry <= 16 && !layB; nTry++) {
        var dF = Math.PI / nTry, bA = [-hP], bB = [-hP];
        for (k = 1; k < nTry; k++) bA.push(-hP + k * dF);
        for (k = 1; k <= nTry; k++) bB.push(-hP + (k - 0.5) * dF);
        bA.push(hP); bB.push(hP);
        layA = layer(bA, false); layB = layA ? layer(bB, true) : null;
        if (layB) { nArc = nTry; jA = bA.slice(1, -1); jB = bB.slice(1, -1); }
      }
      if (layB) {
        /* the screws between the layers, the same in every portal */
        var jAll = jA.concat(jB).sort(function (a, b) { return a - b; }), zb = [-hP].concat(jAll, [hP]), dl = GA.ARCH_CLR / rm, lam = [], aq = (re - ri) / 4;
        var inP = function (pts, u, v, mg) {
          var cIn = false, nP = pts.length, i3, j3, dMin = 1e9;
          for (i3 = 0, j3 = nP - 1; i3 < nP; j3 = i3++) {
            var xi = pts[i3][0], yi = pts[i3][1], xj = pts[j3][0], yj = pts[j3][1];
            if (((yi > v) !== (yj > v)) && (u < (xj - xi) * (v - yi) / (yj - yi) + xi)) cIn = !cIn;
            var ex = xi - xj, ey = yi - yj, L2 = ex * ex + ey * ey, tt = L2 ? Math.max(0, Math.min(1, ((u - xj) * ex + (v - yj) * ey) / L2)) : 0;
            dMin = Math.min(dMin, Math.sqrt(Math.pow(u - xj - tt * ex, 2) + Math.pow(v - yj - tt * ey, 2)));
          }
          return cIn && dMin >= mg;
        };
        var at3 = function (ly, f3) { for (var q3 = 0; q3 < ly.length; q3++) if (f3 >= ly[q3].fa && f3 <= ly[q3].fb) return ly[q3]; return null; };
        for (q = 0; q + 1 < zb.length; q++) {
          var ua = zb[q] + dl, ub = zb[q + 1] - dl;
          if (ub <= ua) continue;
          var mz = Math.max(2, 1 + Math.ceil((ub - ua) * rm / GA.ARCH_SP - 1e-9));
          for (k = 0; k < mz; k++) {
            var fz = ua + (ub - ua) * k / (mz - 1), pA3 = at3(layA, fz), pB3 = at3(layB, fz), rr = (k % 2) ? [rm - aq, rm + aq] : [rm + aq, rm - aq];
            for (var r4 = 0; r4 < 2; r4++) {
              var pq = apt(rr[r4], fz);
              if (pA3 && pB3 && inP(pA3.pts, pq[0], pq[1], 0.008) && inP(pB3.pts, pq[0], pq[1], 0.008)) { lam.push({ u: pq[0], v: pq[1], side: (lam.length % 2) ? 1 : -1 }); break; }
            }
          }
        }
        var lenLam = us ? 0.0635 : 0.06, blankM = 0, wst = 0;
        for (i = 0; i < zP.length; i++) {
          var LY = [[layA, 'a', zP[i] - aT / 2], [layB, 'b', zP[i] + aT / 2]];
          for (j = 0; j < 2; j++) {
            var ly = LY[j][0];
            for (q = 0; q < ly.length; q++) {
              var pz = ly[q], bLen = ceil2(pz.bl.len + GA.ARCH_KERF), per = 0, n3 = pz.pts.length, i4;
              for (i4 = 0; i4 < n3; i4++) per += Math.sqrt(Math.pow(pz.pts[(i4 + 1) % n3][0] - pz.pts[i4][0], 2) + Math.pow(pz.pts[(i4 + 1) % n3][1] - pz.pts[i4][1], 2));
              pieces.push({ kind: 'arch', code: GA.ARCH, len: bLen, id: 'arch-' + (i + 1) + LY[j][1] + (q + 1), poly: pz.pts, plane: 'xy', c: LY[j][2], t: aT,
                            coatA: 2 * Math.abs(_gzArea(pz.pts)) + per * aT, blank: { len: bLen, w: pz.bl.w } });
              if (i === 0) { blankM += bLen; wst = Math.max(wst, pz.bl.w); }
            }
          }
          for (q = 0; q < lam.length; q++) scr('screw-arch', GA.ARCH_SCREW, lam[q].u, lam[q].v, zP[i] + lam[q].side * aT, [0, 0, -lam[q].side], lenLam, 0.0025);
          /* the laps: through the post's -Z half into B's leg */
          for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 4; k++) scr('screw-lap', GA.LAP_SCREW, sx * (px - p / 4), yS - lap * (k + 0.5) / 4, zP[i] - hp, [0, 0, 1], len80);
        }
        /* the laths: up one side, over the arches, down the other */
        var ly0a = _gaU(s, 'LATH_Y0'), hV = yS - ly0a, Tp = 2 * hV + Math.PI * re, nLa = Math.max(2, Math.ceil(Tp / _gaU(s, 'LATH_SP') - 1e-9)), nLat = 0;
        var jDist = function (jl, f3) { var d3 = 1e9; for (var q3 = 0; q3 < jl.length; q3++) d3 = Math.min(d3, Math.abs(jl[q3] - f3)); return d3; };
        for (j = 0; j <= nLa; j++) {
          var sP = Tp * j / nLa, lid = 'lath-' + (j + 1);
          if (sP <= hV + 1e-9 || sP >= hV + Math.PI * re - 1e-9) {   /* on a side: as the other roofs' laths */
            var sxL = (sP <= hV + 1e-9) ? -1 : 1, yL = (sxL < 0) ? ly0a + sP : ly0a + (Tp - sP);
            if (sxL < 0) gLys.push(yL);   /* v333 the trellis' crossings */
            box('lath', GA.LATH, ceil2(L), lid, sxL * (W / 2 + lt / 2), yL, 0, lt, lh, L);
            for (i = 0; i < zP.length; i++) scr('screw-lath', GA.LATH_SCREW, sxL * (W / 2 + lt), yL, zP[i] - hp / 2, [-sxL, 0, 0], len90);
          } else {   /* over the arch: the same section, square to the extrados */
            var fL = -hP + (sP - hV) / re, nxL = Math.sin(fL), nyL = Math.cos(fL), txL = nyL, tyL = -nxL, cr = re + lt / 2, a2 = lt / 2, b2 = lh / 2;
            var cxL = cr * nxL, cyL = yS + cr * nyL;
            poly('lath', GA.LATH, ceil2(L), lid, [[cxL - nxL * a2 - txL * b2, cyL - nyL * a2 - tyL * b2], [cxL - nxL * a2 + txL * b2, cyL - nyL * a2 + tyL * b2],
                                                   [cxL + nxL * a2 + txL * b2, cyL + nyL * a2 + tyL * b2], [cxL + nxL * a2 - txL * b2, cyL + nyL * a2 - tyL * b2]], 'xy', 0, L);
            var zL = (jDist(jA, fL) >= jDist(jB, fL)) ? -aT / 2 : aT / 2;
            for (i = 0; i < zP.length; i++) scr('screw-lath', GA.LATH_SCREW, (re + lt) * nxL, yS + (re + lt) * nyL, zP[i] + zL, [-nxL, -nyL, 0], len90);
          }
          nLat++;
        }
        top = yS + re + lt;
        arch = { n: nArc, pcs: layA.length + layB.length, blankM: Math.round(blankM * 100) / 100, arcM: Math.round(2 * Math.PI * rm * 100) / 100, ri: ri, re: re, lap: lap,
                 lam: lam.length, maxW: wst, laths: nLat };
      }
    }
    /* v333 THE TRELLIS (STATE.gaGrid on the info bar's infill switch; Marek
       2026-10-21 21:06: "Udelej jeste jeden prepinac a sice na vodorovne
       slats z vnejsi strany pridelat jeste jednu vrstvu kolmych slats,
       stejny profil z vnitrni strany (takze varianta bude s mrizi). U
       obloukove budou slats jen po zacatek radiusu"): with any roof a second
       layer of the laths' 40x60 KVH40060 (US 2x3) standing upright against
       the side laths' inner faces (in the posts' outer plane) in every bay
       between the posts, evenly <= LATH_SP centre to centre, the gaps to the
       posts as the gaps between them; from the lowest lath's underside to
       the top side lath's top -- on the arched arbor up to the springing,
       where the radius starts; a 4.5x70 stainless FAS45070 (US 2 3/4 in.) at
       every crossing, from the inside through the upright into the lath */
    var grid = null;
    if (_gaGrid(s)) {
      var gys = (mode === 'arch') ? gLys : lys;
      if (gys.length) {
        var gy0 = gys[0] - lh / 2, gy1 = (mode === 'arch') ? yPT : gys[gys.length - 1] + lh / 2, gLen = ceil2(gy1 - gy0), nG = 0, nGs = 0, lenG = us ? 0.06985 : 0.07;
        for (i = 0; i + 1 < zP.length; i++) {
          var gz0 = zP[i] + hp, gBw = zP[i + 1] - hp - gz0, mG = Math.max(1, Math.ceil((gBw + lh) / _gaU(s, 'LATH_SP') - 1e-9) - 1), gP = (gBw + lh) / (mG + 1);
          for (k = 1; k <= mG; k++) {
            var gzc = gz0 - lh / 2 + gP * k;
            for (sx = -1; sx <= 1; sx += 2) {
              box('grid', GA.LATH, gLen, 'grid-' + (sx < 0 ? 'b' : 'f') + (i + 1) + '-' + k, sx * (W / 2 - lt / 2), (gy0 + gy1) / 2, gzc, lt, gy1 - gy0, lh);
              nG++;
              for (j = 0; j < gys.length; j++) if (gys[j] <= gy1 - 0.02) { scr('screw-grid', GA.GRID_SCREW, sx * (W / 2 - lt), gys[j], gzc, [sx, 0, 0], lenG); nGs++; }
            }
          }
        }
        grid = { uprights: nG, screws: nGs, len: gLen };
      }
    }
    /* the bill's quantities: timber by code, the coating (every piece's four long faces; v331 an arch piece's two faces + its edges) */
    var SEC = {}, m = {}, coat = 0;
    SEC[GA.POST] = [p, p]; SEC[GA.HEAD] = [ht, hh]; SEC[GA.SLAT] = [st, sh]; SEC[GA.LATH] = [lt, lh]; SEC[GA.RIDGE] = [P.rgt, P.rgd];
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0)) continue;
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      var sec = SEC[pc.code] || [p, p];
      coat += (pc.coatA != null) ? pc.coatA : 2 * (sec[0] + sec[1]) * pc.len;   /* v331 the arch's pieces by their shape */
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    return {
      P: P, us: us, mode: mode, found: found, L: L, W: W, pieces: pieces, fas: fas, tiles: tiles, bases: bases, gscrews: gscrews, blocks: blocks, posts: posts, zP: zP,
      meters: m, coat: coat, tileN: tiles.length, blockN: blocks.length,
      gravelM3: r3(tiles.length * tl * tl * gv + blocks.length * bk * bk * gv),                                  /* under the pavers / the deck blocks */
      digM3: 0,   /* v354 no excavation FEE00001 under the pavers / deck blocks: their shallow beds are dug by hand as they are laid (was tiles + blocks x their bed's depth) */
      anchors: nAnchor, missing: [],   /* v345 the anchors billed (FAS60040) */
      yF: yF, yPB: yPB, yPT: yPT, yHT: yHT, postH: postH, headL: 2 * ha, brace: ba, laths: arch ? arch.laths : lys.length, rafL: rafL, rafters: nRaf, ridge: ridge, battens: nBat, deg: deg, arch: arch,
      top: top, height: top, depth: W, length: L, clear: W - 2 * p, grid: grid
    };
  }
  /* its staged assembly: the pavers (the beds, the gravel, the pavers),
     the post bases, the posts, their nails, the heads, their screws, the
     braces, their screws, the laths, their screws, then the roof -- flat:
     the slats, their screws; gable: the wall plates, their screws, the
     rafters, the seat screws, the ridge, the toe screws, the battens, their
     screws (a step whose parts this roof does not draw drops out) */
  var _gaStepsC = {};
  function _gaSteps(s) {
    s = s || STATE;
    var fnd = _gaFound(s), key = String(s.isMetric === false) + fnd;   /* v322 + the foundation (its step's names) */
    if (_gaStepsC[key]) return _gaStepsC[key];
    return (_gaStepsC[key] = [
      { parts: [], codes: [] },
      { parts: ['ga-tile'], codes: [GA.GRAVEL_CODE, GA.TILE_CODE] },   /* v354 no FEE00001 */
      { parts: ['ga-gscrew'], codes: [GA.GSCREW] },                                     /* v322 the ground screws */
      { parts: ['ga-block'], codes: [GA.GRAVEL_CODE, GA.BLOCK] },                        /* v322 the deck blocks; v354 no FEE00001 */
      { parts: ['ga-base', 'ga-hw-anchor'], codes: [(fnd === 'screw') ? GA.UHEAD : GA.BASE].concat((fnd === 'tile') ? [GA.ANCHOR_CODE] : []) },   /* v345 + the anchors into the pavers */
      { parts: ['ga-post'], codes: [GA.POST] },
      { parts: ['ga-hw-nail'], codes: [GA.NAIL] },
      { parts: ['ga-head'], codes: [GA.HEAD] },
      { parts: ['ga-hw-screw-head'], codes: [GA.HEAD_SCREW] },
      { parts: ['ga-brace'], codes: [GA.BRACE_CODE] },
      { parts: ['ga-hw-screw-brace'], codes: [GA.TOE_SCREW] },
      { parts: ['ga-arch'], codes: [GA.ARCH] },                                          /* v331 the arch's two layers (v332 before the laths that go over it) */
      { parts: ['ga-hw-screw-arch'], codes: [GA.ARCH_SCREW] },                           /* -- screwed together */
      { parts: ['ga-hw-screw-lap'], codes: [GA.LAP_SCREW] },                             /* v332 -- its feet lapped into the posts */
      { parts: ['ga-lath'], codes: [GA.LATH] },
      { parts: ['ga-hw-screw-lath'], codes: [GA.LATH_SCREW] },
      { parts: ['ga-grid'], codes: [GA.LATH] },                                          /* v333 the trellis' uprights */
      { parts: ['ga-hw-screw-grid'], codes: [GA.GRID_SCREW] },                           /* -- screwed to the laths */
      { parts: ['ga-slat'], codes: [GA.SLAT] },
      { parts: ['ga-hw-screw-slat'], codes: [GA.SLAT_SCREW] },
      { parts: ['ga-plate'], codes: [GA.PLATE] },
      { parts: ['ga-hw-screw-plate'], codes: [GA.PLATE_SCREW] },
      { parts: ['ga-rafter'], codes: [GA.RAFTER] },
      { parts: ['ga-hw-screw-rafter'], codes: [_gaU(s, 'RAFTER_SCREW')] },
      { parts: ['ga-ridge'], codes: [GA.RIDGE] },
      { parts: ['ga-hw-screw-ridge'], codes: [GA.RIDGE_SCREW] },                         /* v322 from the rafters' tops */
      { parts: ['ga-batten'], codes: [GA.BATTEN] },
      { parts: ['ga-hw-screw-batten'], codes: [GA.BAT_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v328 TYPE 23 -- GARDEN STRUCTURE 4: THE GAZEBO (Marek 2026-10-21 17:59
     with two photos of timber gazebos on a deck -- posts, a railing with
     balusters, lattice, a hipped roof of shingles: "Dalsi structure /
     varianta je gazebo. Prepinani mezi 4 boky (ctvercovy) a 6 boky tvar.
     Valbova konstrukce strechy."). The shape on the info bar's switch
     (STATE.gzN: 6 hexagon, the default | 4 square); S = the width across
     the flats at the posts' / plates' outer faces on the handle (2.40 -
     4.20 m, US 8 - 14 ft; default 3.00 / US 10 ft), the height fixed.
     Plan: X / Z, the flats' normals at phi(k) (k = 0 the entrance, +X for
     the square, 30 deg for the hexagon; both have a flat at +-Z), the
     vertices between them. Bottom up:
       - A GROUND SCREW FGR00001 76 x 1200 (US 3 in. x 4 ft) with a U HEAD
         FGR00002 under every post, under the middle beam (<= 1.50 m / US 5
         ft apart; for the square at its ends too) and under the middle of a
         rim longer than 2.00 m (US 6 1/2 ft); its head 5 cm (US 2 in.) up,
         the timber 30 mm over it, 12 nails FAS38038 through the flanges;
       - a 4x4 POST KVH10100 at every vertex (the square's square to its
         sides, the hexagon's facing the centre), up to the plates 2.10 m
         (US 7 ft) over the deck;
       - THE FLOOR flush on top: 2x6 RIMS KVH60160 between the posts on the
         posts' centre line (their ends cut to the post's face, 2 toe screws
         6x100 FAS60100 an end), a 4x6 MIDDLE BEAM KVH10160 along X through
         the centre (the hexagon's from post to post, 2 x 8x160 FAS80160
         through the post into each end; the square's between the rims, 2
         through the rim), 2x6 JOISTS KVH60160 along Z at <= 40 cm (US 16
         in.) from the beam to the rims, in JOIST HANGERS FAT00009 at both
         ends (4 nails FAS38038 into the header, 2 into the joist); DECKING
         TST00001 25 x 145 (US 5/4 x 6) along X, 5 mm (US 3/16 in.) apart,
         flush with the posts' outer faces (2 cm proud of the rims), notched
         round the posts, 2 stainless 5.5x50 FAS55050 into every joist /
         rim / beam it crosses;
       - 4x6 PLATES KVH10160 on edge on the posts' tops, mitred over each
         post, one 8x260 FAS80260 down into the post at each end;
       - THE HIPPED ROOF (30 deg): a HIP RAFTER 2x6 KVH60160 from each
         plate corner (birdsmouthed, its top dropped so its edges lie in
         the two roof planes) to a KING POST (HUB) cut from a 6x6 KVH16160
         to as many faces; JACK RAFTERS 2x6 in pairs either side of each
         flat's middle at <= 60 cm (US 2 ft), birdsmouthed on the plate,
         bevelled plumb against the hip; the tails 30 cm (US 12 in.) past
         the plates, cut plumb; an 8x260 (US 8x200 FAS80200) down through
         every seat, 2 toe screws 6x120 FAS60120 at the hub, 2 at the hip
         (US 6x100); T&G ROOF BOARDS KVR14619 19 mm (US 3/4 in.) on the
         rafters, 2 nails FAS70000 at every crossing; a BREATHABLE UNDERLAY
         ROR00008 (+10 % laps, 6 staples FAS63000 a m2), SHINGLES ROR00001
         (+10 %, 20 roofing nails FAS00318 a m2), RIDGE CAPS ROR00009 along
         the hips, DRIP EDGE ROM02401 along the eaves (a roofing nail every
         30 cm);
       - THE RAILING on every side but the entrance (k = 0): 2x4 rails
         KVH10060 on edge between the posts, their outer face flush with
         the deck's edge -- the top one's top 90 cm (US 36 in.) over the
         deck, the bottom one 8 cm (US 3 in.) up; 2 toe screws 6x100
         FAS60100 an end; 2x2 BALUSTERS KVH03838 on their inner face, <= 10
         cm (US 4 in.) clear, 4 cm (US 1 1/2 in.) over the deck, a 5x60
         FAS50060 into each rail.
     Every screw and nail of the timber drawn and billed; the roof boards'
     nails, the underlay's staples and the roofing nails billed by rate
     (not drawn). _gzLayout(STATE) is the single source; its pieces are
     planar polygons lofted along their normal (A face -> B face, the
     same corners) -- the bevelled and mitred ends in any plane. */
  var GZ = {
    S: [2.40, 4.20], S_US: [2.4384, 4.2672], S0: 3.00, S0_US: 3.048,
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.038, GS_R_US: 0.0381, U_UP: 0.030, U_T: 0.004, U_FL: 0.10,
    CLEAR: 2.10, CLEAR_US: 2.1336,                     /* the deck's top to the plates' underside (7 ft) */
    PITCH: 30, EAVE: 0.30, EAVE_US: 0.3048,            /* the roof's planes; the eaves this far past the plates' outer faces (level) */
    SEAT: 0.07, SEAT_US: 0.0635,                       /* a rafter's birdsmouth seat on the plate */
    RAF_SP: 0.60, RAF_SP_US: 0.6096, JOIST_SP: 0.40, JOIST_SP_US: 0.4064,
    PIER_SP: 1.50, PIER_SP_US: 1.524, RIM_SPAN: 2.00, RIM_SPAN_US: 1.9812,
    DECK_GAP: 0.005, DECK_GAP_US: 0.0048,
    RAIL_TOP: 0.90, RAIL_TOP_US: 0.9144, RAIL_LOW: 0.08, RAIL_LOW_US: 0.0762,
    BAL_GAP: 0.10, BAL_GAP_US: 0.1016, BAL_LOW: 0.04, BAL_LOW_US: 0.0381,
    HANG_L: 0.08, HANG_T: 0.002, SHINGLE_T: 0.006, CAP_W: 0.09, CAP_T: 0.004, DRIP_H: 0.055,
    POST: 'KVH10100', PLATE: 'KVH10160', BEAM: 'KVH10160', RIM: 'KVH60160', JOIST: 'KVH60160', RAFTER: 'KVH60160', HUB: 'KVH16160',
    RAIL: 'KVH10060', BALUSTER: 'KVH03838', DECK: 'TST00001', RBOARD: 'KVR14619',
    UNDERLAY: 'ROR00008', SHINGLE: 'ROR00001', HIP_CAP: 'ROR00009', DRIP: 'ROM02401',
    GSCREW: 'FGR00001', UHEAD: 'FGR00002', NAIL: 'FAS38038', HANGER: 'FAT00009',
    BEAM_SCREW: 'FAS80160', RIM_SCREW: 'FAS60100', DECK_SCREW: 'FAS55050', PLATE_SCREW: 'FAS80260',
    SEAT_SCREW: 'FAS80260', SEAT_SCREW_US: 'FAS80200', HUB_SCREW: 'FAS60120', JACK_SCREW: 'FAS60120', JACK_SCREW_US: 'FAS60100',
    RAIL_SCREW: 'FAS60100', BAL_SCREW: 'FAS50060', RB_NAIL: 'FAS70000', ROOF_NAIL: 'FAS00318', UL_STAPLE: 'FAS63000',
    SHINGLE_NAILS_M2: 20, UL_STAPLES_M2: 6, WASTE: 1.10, DRIP_FIX: 0.30,
    /* v329 the foundation on the toggle: precast pads (the arbor's deck blocks), poured footings (the ADU's piers) */
    BLK: 0.30, BLK_US: 0.3048, BLK_TOP: 0.20, BLK_TOP_US: 0.2032, BLK_H: 0.20, BLK_H_US: 0.2032, BLK_UP: 0.10, BLK_UP_US: 0.1016, SOCK: 0.05, SOCK_US: 0.0508, GRAVEL: 0.10, GRAVEL_US: 0.1016,
    PIER_W: 0.40, PIER_W_US: 0.4064, PIER_D: 0.80, PIER_D_US: 0.8128, PIER_UP: 0.10, PIER_UP_US: 0.1016, PIER_GRAVEL: 0.15, PIER_GRAVEL_US: 0.1524, BAR_COVER: 0.05,
    BLOCK: 'FCO00012', GRAVEL_CODE: 'FCO00001', DIG: 'FEE00001', CONCRETE: 'FCO00002', REBAR: 'FCO00003', FORMWORK: 'FCO00007', GEOTEX: 'FEC00003', UANCHOR: 'FCO00004',
    /* v329 the covering on a switch: asphalt shingle | standing seam (the house line's COV_SEAM: 530 pans, 22 x 25 seams, 5 clips a m2) */
    SEAM: 'ROR12003', SEAM_PAN: 0.53, SEAM_PAN_US: 0.4064, SEAM_W: 0.022, SEAM_H: 0.025, SEAM_T: 0.002, SEAM_CLIP: 'FAS60100', SEAM_CLIPS_M2: 5, SEAM_SCREW: 'FAS00225', SEAM_CAP_SP: 0.30,
    CAP_EXPO: 0.143, CAP_NAILS: 2, TAB: 0.333,         /* a cap shingle's exposure, its 2 nails; a 3-tab shingle's tab */
    /* v329 the infill on a switch: 2x2 slats | 1x4 boards, the clear gap on the slider */
    BOARD: 'TIM20100', BOARD_SCREW: 'FAS55050',
    GAP: [0.010, 0.120], GAP_US: [0.0095, 0.1207], GAP0: 0.08, GAP0_US: 0.0762
  };
  /* the sections (metric / US actual): the 4x4 post, the 4x6 plate +
     beam, the 2x6 rim / joist / rafter, the 5/4x6 decking, the 2x4 rail,
     the 2x2 baluster, the 6x6 hub, the roof boards' thickness */
  function _gzProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.0889, ph: 0.1397, jt: 0.0381, jh: 0.1397, bt: 0.0889, dk: 0.0254, dw: 0.1397, rw: 0.0381, rd: 0.1397, lt: 0.0381, lh: 0.0889, bal: 0.0381, hub: 0.1397, rb: 0.01905, bw: 0.0889, bwt: 0.01905 };
    return { p: 0.100, ph: 0.160, jt: 0.060, jh: 0.160, bt: 0.100, dk: 0.025, dw: 0.145, rw: 0.060, rd: 0.160, lt: 0.060, lh: 0.100, bal: 0.038, hub: 0.160, rb: 0.019, bw: 0.100, bwt: 0.020 };   /* v329 + the 1x4 board */
  }
  function _gzU(s, k) { return ((s || STATE).isMetric === false && GZ[k + '_US'] != null) ? GZ[k + '_US'] : GZ[k]; }
  function _gzN(s) { return ((s || STATE).gzN === 4) ? 4 : 6; }
  function _gzFound(s) { var f = (s || STATE).gzFound; return (f === 'block' || f === 'pier') ? f : 'screw'; }   /* v329 ground screws | precast pads | poured footings */
  function _gzCov(s) { return ((s || STATE).gzCov === 'seam') ? 'seam' : 'shingle'; }                            /* v329 asphalt shingle | standing seam */
  function _gzFill(s) { return ((s || STATE).gzFill === 'board') ? 'board' : 'bal'; }                              /* v329 2x2 slats | 1x4 boards */
  /* v350 a field (side) filled over its whole height: { gz1: 1, .. } (gz1 = the entrance) */
  function _gzFields(s) { var f = (s || STATE).gzFields; return (f && typeof f === 'object') ? f : {}; }
  function _gzGapRange(s) { var r = _gzU(s, 'GAP'); return { min: r[0], max: r[1] }; }
  function _gzGap(s) { s = s || STATE; var R = _gzGapRange(s), v = +s.gzGap; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _gzU(s, 'GAP0'))); }
  function _gzRange(s) { var r = _gzU(s, 'S'); return { min: r[0], max: r[1] }; }
  function _gzS(s) { s = s || STATE; var R = _gzRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _gzU(s, 'S0'))); }
  /* 3-vectors and 2-D polygons */
  function _v3(x, y, z) { return [x, y, z]; }
  function _vAdd(a, b) { return [a[0] + b[0], a[1] + b[1], a[2] + b[2]]; }
  function _vSc(a, k) { return [a[0] * k, a[1] * k, a[2] * k]; }
  function _vDot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function _vCross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function _vNorm(a) { var l = Math.sqrt(_vDot(a, a)) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
  /* keep a*u + b*v + c >= 0 (Sutherland-Hodgman, one edge) */
  function _gzClip(poly, a, b, c) {
    var out = [], n = poly.length, i;
    for (i = 0; i < n; i++) {
      var P = poly[i], Q = poly[(i + 1) % n], fp = a * P[0] + b * P[1] + c, fq = a * Q[0] + b * Q[1] + c;
      if (fp >= 0) out.push(P);
      if ((fp >= 0) !== (fq >= 0)) { var t = fp / (fp - fq); out.push([P[0] + (Q[0] - P[0]) * t, P[1] + (Q[1] - P[1]) * t]); }
    }
    return out;
  }
  function _gzArea(poly) { var a = 0, n = poly.length, i; for (i = 0; i < n; i++) { var P = poly[i], Q = poly[(i + 1) % n]; a += P[0] * Q[1] - Q[0] * P[1]; } return a / 2; }
  /* a convex polygon minus a convex one (both CCW): the convex pieces that
     are left -- outside the k-th edge of B, inside the ones before it */
  function _gzDiff(A, B) {
    var out = [], n = B.length, i, j;
    var bb = function (Pl) { var r = [1e9, -1e9, 1e9, -1e9]; Pl.forEach(function (Pt) { r[0] = Math.min(r[0], Pt[0]); r[1] = Math.max(r[1], Pt[0]); r[2] = Math.min(r[2], Pt[1]); r[3] = Math.max(r[3], Pt[1]); }); return r; };
    var ba = bb(A), bB = bb(B);
    if (ba[1] <= bB[0] + 1e-9 || bB[1] <= ba[0] + 1e-9 || ba[3] <= bB[2] + 1e-9 || bB[3] <= ba[2] + 1e-9) return [A];   /* apart: A whole */
    for (i = 0; i < n; i++) {
      var piece = A;
      for (j = 0; j <= i && piece.length >= 3; j++) {
        var P = B[j], Q = B[(j + 1) % n], ex = Q[0] - P[0], ey = Q[1] - P[1];
        /* inside of a CCW edge: cross(e, X - P) >= 0 */
        var a = -ey, b = ex, c = ey * P[0] - ex * P[1];
        piece = (j === i) ? _gzClip(piece, -a, -b, -c) : _gzClip(piece, a, b, c);
      }
      if (piece.length >= 3 && Math.abs(_gzArea(piece)) > 1e-6) out.push(piece);
    }
    return out;
  }
  /* v329 the asphalt shingle's look: tiny's _shingleTex (configurator-tiny-lib.js) copied
     literally -- course bands behind, colour-varied tabs in brick-offset rows;
     adapted only its repeat (1, 1: the lofted faces' UVs are in metres times
     the 3-tab size) and its cache */
  var _gzShTex = {};
  function _gzShingleTex(baseHex) {
    if (_gzShTex[baseHex]) return _gzShTex[baseHex];
    try {
      var doc = global.document; if (!doc || !doc.createElement) return null;
      var T = global.THREE;
      var cnv = doc.createElement('canvas'); cnv.width = 256; cnv.height = 256;
      var g = cnv.getContext('2d'); if (!g) return null;
      function sh(hex, ff) {
        var r = (hex >> 16) & 255, gg = (hex >> 8) & 255, b = hex & 255;
        r = Math.max(0, Math.min(255, Math.round(r * ff)));
        gg = Math.max(0, Math.min(255, Math.round(gg * ff)));
        b = Math.max(0, Math.min(255, Math.round(b * ff)));
        return 'rgb(' + r + ',' + gg + ',' + b + ')';
      }
      g.fillStyle = sh(baseHex, 0.55); g.fillRect(0, 0, 256, 256);
      var bandH = 64;
      for (var by = 0; by < 256; by += bandH) { g.fillStyle = sh(baseHex, 0.82); g.fillRect(0, by + 2, 256, bandH - 4); }
      var rows = 8, cols = 8, rh = 256 / rows, cw = 256 / cols;
      for (var r = 0; r < rows; r++) {
        var off = (r % 2) ? cw / 2 : 0;
        for (var c = -1; c <= cols; c++) {
          var x = c * cw + off, y = r * rh;
          var ff = 0.92 + ((r * 7 + (c + 1) * 3) % 5) * 0.03;
          g.fillStyle = sh(baseHex, ff);
          g.fillRect(x + 1.2, y + 1.2, cw - 2.4, rh - 2.4);
        }
      }
      var tex = new T.CanvasTexture(cnv);
      tex.wrapS = tex.wrapT = T.RepeatWrapping;
      tex.repeat.set(1, 1);
      if (T.SRGBColorSpace) tex.colorSpace = T.SRGBColorSpace;
      _gzShTex[baseHex] = tex;
      return tex;
    } catch (e) { return null; }
  }
  function _gzLayout(s) {
    s = s || STATE;
    var P = _gzProf(s), us = (s.isMetric === false), n = _gzN(s), S = _gzS(s), i, j, k, q;
    var p = P.p, hp = p / 2, ph = P.ph, jt = P.jt, jh = P.jh, bt = P.bt, dk = P.dk, dw = P.dw, rw = P.rw, rd = P.rd, lt = P.lt, lh = P.lh, bal = P.bal;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.1524 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10,
        len60 = us ? 0.0635 : 0.06, len50 = us ? 0.0508 : 0.05, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], gscrews = [], uheads = [], hangers = [], posts = [], piers = [], joistX = [], boards = [], jacks = [], rails = [];
    var UP = [0, 1, 0], X = [1, 0, 0], Z = [0, 0, 1];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function scr(kind, code, at, d, ln, r) { d = _vNorm(d); fas.push({ kind: kind, code: code, x: at[0], y: at[1], z: at[2], dir: d, len: ln, r: r || 0.003 }); }
    /* a planar piece: the polygon prof in (u, v) about o, lofted along
       N = U x V from nA to nB, cut by the planes { m, d } (keep m.P >= d)
       on each face -- A at nA, B at nB */
    function loft(kind, code, id, o, U, V, nA, nB, prof, planes, ex) {
      var N = _vCross(U, V), A = prof, B = prof, i2;
      for (i2 = 0; i2 < (planes || []).length; i2++) {
        var pl = planes[i2], a = _vDot(pl.m, U), b = _vDot(pl.m, V), c0 = _vDot(pl.m, o) - pl.d, mn = _vDot(pl.m, N);
        A = _gzClip(A, a, b, c0 + nA * mn);
        B = _gzClip(B, a, b, c0 + nB * mn);
      }
      if (A.length < 3 || B.length < 3) return null;
      if (A.length !== B.length) B = A;   /* (never by construction: a cut crosses the same edges on both faces) */
      if (_gzArea(A) < 0) { A = A.slice().reverse(); B = B.slice().reverse(); }
      var uMin = 1e9, uMax = -1e9;
      A.concat(B).forEach(function (Pt) { uMin = Math.min(uMin, Pt[0]); uMax = Math.max(uMax, Pt[0]); });
      var pc = { kind: kind, code: code, len: 0, id: id, o: o, U: U, V: V, N: N, nA: nA, nB: nB, A: A, B: B, uMin: uMin, uMax: uMax };
      if (ex) for (var e in ex) if (ex.hasOwnProperty(e)) pc[e] = ex[e];
      pieces.push(pc);
      return pc;
    }
    /* a world point inside a lofted piece (e: tolerance) */
    function insidePc(pc, W3, e) {
      var d = [W3[0] - pc.o[0], W3[1] - pc.o[1], W3[2] - pc.o[2]], u = _vDot(d, pc.U), v = _vDot(d, pc.V), nn = _vDot(d, pc.N);
      if (nn < pc.nA - e || nn > pc.nB + e) return false;
      var f = (pc.nB - pc.nA) ? Math.max(0, Math.min(1, (nn - pc.nA) / (pc.nB - pc.nA))) : 0, c2 = false, poly = pc.A.map(function (a, i2) { return [a[0] + (pc.B[i2][0] - a[0]) * f, a[1] + (pc.B[i2][1] - a[1]) * f]; }), i3, j3;
      for (i3 = 0, j3 = poly.length - 1; i3 < poly.length; j3 = i3++) {
        var xi = poly[i3][0], yi = poly[i3][1], xj = poly[j3][0], yj = poly[j3][1];
        if (((yi > v) !== (yj > v)) && (u < (xj - xi) * (v - yi) / (yj - yi) + xi)) c2 = !c2;
      }
      return c2;
    }
    /* the end of a piece (u) on its face n, cut by the vertical plane pl */
    function uAt(o, U, V, pl, nn, v) { var N = _vCross(U, V), a = _vDot(pl.m, U); return -(_vDot(pl.m, V) * v + _vDot(pl.m, o) - pl.d + nn * _vDot(pl.m, N)) / a; }
    var pin = Math.PI / n, cpn = Math.cos(pin), spn = Math.sin(pin), tpn = Math.tan(pin);
    var phi0 = (n === 4) ? 0 : Math.PI / 6;
    function phi(k2) { return phi0 + 2 * Math.PI * k2 / n; }
    function th(k2) { return phi(k2) + pin; }
    function dirA(a) { return [Math.cos(a), 0, Math.sin(a)]; }
    function nuK(k2) { return dirA(phi(k2)); }
    function tauK(k2) { var a = phi(k2); return [-Math.sin(a), 0, Math.cos(a)]; }
    function nthK(k2) { var a = th(k2); return [-Math.sin(a), 0, Math.cos(a)]; }   /* the left normal of the vertex's ray */
    var aO = S / 2, ac = aO - hp, Rc = ac / cpn;
    /* the heights */
    /* v329 the foundation's top: the ground screw's head / the deck block's top (the timber on it, a post down in its socket) / the poured footing's top */
    var found = _gzFound(s), cov = _gzCov(s), fill = _gzFill(s);
    var yH = (found === 'block') ? _gzU(s, 'BLK_UP') : (found === 'pier') ? _gzU(s, 'PIER_UP') : _gzU(s, 'FOOT_UP');
    var yB0 = (found === 'block') ? yH : yH + GZ.U_UP, yPB = (found === 'block') ? yH - _gzU(s, 'SOCK') : yB0;
    var yJT = yB0 + jh, yD = yJT + dk, yPT = yD + _gzU(s, 'CLEAR'), yT = yPT + ph;
    /* THE POSTS at the vertices (the square's square to its sides, the hexagon's facing the centre) */
    for (k = 0; k < n; k++) {
      var tk = th(k), C = [Rc * Math.cos(tk), 0, Rc * Math.sin(tk)], psi = (n === 4) ? 0 : tk;
      var e1 = dirA(psi), e2 = [-Math.sin(psi), 0, Math.cos(psi)];
      var sq = [[-1, -1], [1, -1], [1, 1], [-1, 1]].map(function (c2) { return [C[0] + hp * (c2[0] * e1[0] + c2[1] * e2[0]), C[2] + hp * (c2[0] * e1[2] + c2[1] * e2[2])]; });
      if (_gzArea(sq) < 0) sq.reverse();
      posts.push({ k: k, c: C, e1: e1, e2: e2, sq: sq, id: 'p' + (k + 1) });
      var pp = loft('post', GZ.POST, 'post-p' + (k + 1), [0, 0, 0], X, Z, -yPT, -yPB, sq, null);
      pp.len = ceil2(yPT - yPB);
    }
    /* the face of post k2 a member coming along d meets: keep the member outside it */
    function postFace(k2, d) {
      var Pq = posts[(k2 + n) % n], fs = [Pq.e1, _vSc(Pq.e1, -1), Pq.e2, _vSc(Pq.e2, -1)], best = null, bd = 9;
      fs.forEach(function (f) { var dd = _vDot(f, d); if (dd < bd) { bd = dd; best = f; } });
      return { m: best, d: _vDot(best, Pq.c) + hp };
    }
    /* THE FOUNDATION: a ground screw + U head under (x, z), the U head's
       flanges on the faces of a member w wide whose faces' normal is at
       angle a; 12 nails, the two flanges' columns staggered */
    var blocks = [], pours = [];
    function pier(id, x, z, a, w, kindNail) {
      piers.push({ x: x, z: z, id: id });
      /* v329 a deck block: the post down in its socket, a beam / rim on its top -- nothing to fix */
      if (found === 'block') { blocks.push({ x: x, z: z, a: a, w: _gzU(s, 'BLK'), wt: _gzU(s, 'BLK_TOP'), y0: yH - _gzU(s, 'BLK_H'), y1: yH, id: id }); return; }
      /* v329 a poured footing (its top 10 cm up) with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'pier') pours.push({ x: x, z: z, a: a, w: _gzU(s, 'PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _gzU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, a: a, w: w, y0: yH, y1: yB0, id: id, wet: (found === 'pier') });
      var nf = dirA(a), na = [-Math.sin(a), 0, Math.cos(a)], sd, cI, rI;
      for (sd = -1; sd <= 1; sd += 2) for (cI = -1; cI <= 1; cI += 2) for (rI = 0; rI < 3; rI++) {
        var off = cI * ((sd < 0) ? 0.022 : 0.034);
        var at = _vAdd(_vAdd([x, yB0 + 0.02 + rI * 0.025, z], _vSc(nf, sd * (w / 2 + GZ.U_T))), _vSc(na, off));
        scr(kindNail, GZ.NAIL, at, _vSc(nf, -sd), len38, 0.0019);
      }
    }
    for (k = 0; k < n; k++) pier('post-' + posts[k].id, posts[k].c[0], posts[k].c[2], Math.atan2(posts[k].e1[2], posts[k].e1[0]), p, 'nail-uhead');
    /* the joists' lines along Z (needed by the piers: those sit between them, clear of the hangers) */
    var hexB = (n === 6), jSp = _gzU(s, 'JOIST_SP'), xJ = hexB ? Rc : ac, mJ = Math.max(2, Math.ceil(2 * xJ / jSp - 1e-9));
    for (i = 1; i < mJ; i++) joistX.push(-xJ + 2 * xJ * i / mJ);
    var jLines = [-xJ].concat(joistX).concat([xJ]);
    function snapMid(v, lines) {
      var best = v, bd = 1e9, i3;
      for (i3 = 0; i3 + 1 < lines.length; i3++) { var mid = (lines[i3] + lines[i3 + 1]) / 2; if (Math.abs(mid - v) < bd) { bd = Math.abs(mid - v); best = mid; } }
      return best;
    }
    /* THE RIMS between the posts on their centre line, the ends cut to the posts' faces; 2 toe screws an end */
    var rimPieces = [];
    for (k = 0; k < n; k++) {
      var nu = nuK(k), tau = tauK(k), oR = _vSc(nu, ac), big = Rc + 1;
      var plE = postFace(k, tau), plS = postFace(k - 1, _vSc(tau, -1));
      var rp = loft('rim', GZ.RIM, 'rim-' + (k + 1), oR, tau, UP, -jt / 2, jt / 2, [[-big, yB0], [big, yB0], [big, yJT], [-big, yJT]], [plE, plS]);
      rp.len = ceil2(rp.uMax - rp.uMin);
      rimPieces.push(rp);
      /* the toe screws: from the inner face (N = -nu: n = +jt/2) 4 cm before the end, 25 deg towards the outside, into the post */
      var Nr = rp.N, ang = Math.min(25 * Math.PI / 180, Math.asin((jt - 0.006) / len100));   /* the tip stays within the member's band (the post) */
      for (q = -1; q <= 1; q += 2) {
        var plQ = (q > 0) ? plE : plS;
        for (j = 0; j < 2; j++) {
          var vS = yB0 + jh * (j ? 0.68 : 0.32), uE = uAt(oR, tau, UP, plQ, jt / 2, vS) - q * 0.04;
          var at = _vAdd(_vAdd(_vAdd(oR, _vSc(tau, uE)), [0, vS, 0]), _vSc(Nr, jt / 2));
          scr('screw-rim', GZ.RIM_SCREW, at, _vAdd(_vSc(tau, q * Math.cos(ang)), _vSc(Nr, -Math.sin(ang))), len100);
        }
      }
    }
    /* THE MIDDLE BEAM along X: the hexagon's between the posts at +-X (2 x
       8x160 through each post into its end), the square's between the
       rims (2 through the rim); piers <= PIER_SP apart (the square's at
       its ends too) */
    var xb = hexB ? Rc - hp : ac - jt / 2;
    var rimIn = []; for (k = 0; k < n; k++) rimIn.push({ m: _vSc(nuK(k), -1), d: -(ac - jt / 2) });
    var beam = loft('beam', GZ.BEAM, 'beam', [0, 0, 0], X, UP, -bt / 2, bt / 2, [[-xb, yB0], [xb, yB0], [xb, yJT], [-xb, yJT]], rimIn);   /* the hexagon's ends: between the rims at the post */
    beam.len = ceil2(beam.uMax - beam.uMin);
    for (q = -1; q <= 1; q += 2) for (j = 0; j < 2; j++) {
      var xS = q * (hexB ? Rc + hp : ac + jt / 2);
      scr('screw-beam', GZ.BEAM_SCREW, [xS, yB0 + jh * (j ? 0.68 : 0.32), (j ? 1 : -1) * 0.015], [-q, 0, 0], len160);
    }
    var pierSp = _gzU(s, 'PIER_SP');
    if (hexB) {
      var nSeg = Math.max(1, Math.ceil(2 * Rc / pierSp - 1e-9));
      for (i = 1; i < nSeg; i++) pier('beam-' + i, snapMid(-Rc + 2 * Rc * i / nSeg, jLines), 0, Math.PI / 2, bt, 'nail-uhead');
    } else {
      var xe = xb - hp - 0.01, nSq = Math.max(1, Math.ceil(2 * xe / pierSp - 1e-9));
      for (i = 0; i <= nSq; i++) {
        var xq = -xe + 2 * xe * i / nSq;
        if (i > 0 && i < nSq) xq = snapMid(xq, jLines);
        else xq = Math.max(-xe, Math.min(xe, (xq < 0) ? (jLines[0] + jLines[1]) / 2 : (jLines[jLines.length - 2] + jLines[jLines.length - 1]) / 2));
        pier('beam-' + (i + 1), xq, 0, Math.PI / 2, bt, 'nail-uhead');
      }
    }
    /* a pier under the middle of a long rim (not one the beam ends on) */
    var rimSpan = _gzU(s, 'RIM_SPAN');
    for (k = 0; k < n; k++) {
      var nuP = nuK(k);
      if (!hexB && Math.abs(nuP[2]) < 0.5) continue;   /* the square's +-X rims: the beam's end piers beside their middle */
      if (rimPieces[k].uMax - rimPieces[k].uMin > rimSpan) {
        /* at its middle, between the joists that hang on it */
        var tauP = tauK(k), hits = [rimPieces[k].uMin, rimPieces[k].uMax];
        if (Math.abs(tauP[0]) > 1e-6) joistX.forEach(function (xx) { var uu = (xx - ac * nuP[0]) / tauP[0]; if (uu > rimPieces[k].uMin && uu < rimPieces[k].uMax) hits.push(uu); });
        hits.sort(function (a3, b3) { return a3 - b3; });
        var uP = snapMid(0, hits);
        pier('rim-' + (k + 1), nuP[0] * ac + tauP[0] * uP, nuP[2] * ac + tauP[2] * uP, phi(k), jt, 'nail-uhead');
      }
    }
    /* THE JOISTS along Z at <= JOIST_SP, from the beam's faces to the
       rims' inner faces (a post corner in the way: to its face), a
       hanger at each end */
    var joistPieces = [];
    for (i = 1; i < mJ; i++) {
      var xj = joistX[i - 1];
      for (q = -1; q <= 1; q += 2) {
        var oJ = [xj, 0, 0], planesJ = rimIn.slice(0);
        posts.forEach(function (Pq) {
          var ext = hp * (Math.abs(Pq.e1[0]) + Math.abs(Pq.e2[0]));
          if (Math.abs(xj - Pq.c[0]) < ext + jt / 2 && Pq.c[2] * q > 0) planesJ.push(postFace(Pq.k, [0, 0, q]));
        });
        var prof = (q > 0) ? [[bt / 2, yB0], [Rc + 1, yB0], [Rc + 1, yJT], [bt / 2, yJT]] : [[-Rc - 1, yB0], [-bt / 2, yB0], [-bt / 2, yJT], [-Rc - 1, yJT]];
        var jp = loft('joist', GZ.JOIST, 'joist-' + i + (q < 0 ? 'b' : 'f'), oJ, Z, UP, -jt / 2, jt / 2, prof, planesJ);
        if (!jp) continue;
        jp.len = ceil2(jp.uMax - jp.uMin);
        joistPieces.push(jp);
        /* the hangers: at the beam's face and at the far end (its plane: whichever cut it there) */
        var endA = (q > 0) ? Math.max.apply(null, jp.A.map(function (Pt) { return Pt[0]; })) : Math.min.apply(null, jp.A.map(function (Pt) { return Pt[0]; }));
        var endB = (q > 0) ? Math.max.apply(null, jp.B.map(function (Pt) { return Pt[0]; })) : Math.min.apply(null, jp.B.map(function (Pt) { return Pt[0]; }));
        var uFar = (q > 0) ? Math.min(endA, endB) : Math.max(endA, endB);   /* a skewed end (a slanted rim): the hanger at its shorter face */
        [{ u: q * bt / 2, sg: -q, hdr: 'beam' }, { u: uFar, sg: q, hdr: 'rim' }].forEach(function (H) {
          var hg = { o: oJ, U: Z, V: UP, N: jp.N, u: H.u, sg: H.sg, y0: yB0, h: jh * 0.85, w: jt, id: jp.id + '-' + H.hdr };
          hangers.push(hg);
          /* 2 nails into the joist (one a side), 4 into the header (two a flange) */
          var Nj = jp.N;
          for (var sd = -1; sd <= 1; sd += 2) {
            var uSide = (H.hdr === 'beam') ? H.u : ((sd < 0) ? endA : endB), uc = uSide - H.sg * GZ.HANG_L * 0.5;   /* this face's end */
            scr('nail-hanger', GZ.NAIL, _vAdd(_vAdd(oJ, [0, yB0 + jh * 0.35, uc]), _vSc(Nj, sd * (jt / 2 + GZ.HANG_T))), _vSc(Nj, -sd), len38, 0.0019);
            for (var r2 = 0; r2 < 2; r2++) {
              var nOff = sd * (jt / 2 + 0.016), vN = yB0 + jh * (r2 ? 0.62 : 0.28), uH;
              if (H.hdr === 'beam') uH = H.u;
              else {
                var Pn = _vAdd(_vAdd(oJ, _vSc(Nj, nOff)), [0, vN, 0]), ok = true;
                uH = null;
                /* the far end on this lateral line: the nearest cutting plane */
                rimIn.forEach(function (pl) {   /* the rims' faces only (a post there: checked below) */
                  var a3 = _vDot(pl.m, Z); if (Math.abs(a3) < 1e-6) return;
                  var u3 = -(_vDot(pl.m, Pn) - pl.d) / a3;
                  if ((q > 0 && u3 > bt / 2 && (uH === null || u3 < uH)) || (q < 0 && u3 < -bt / 2 && (uH === null || u3 > uH))) uH = u3;
                });
                if (uH === null) ok = false;
                if (!ok) continue;
              }
              var atN = _vAdd(_vAdd(oJ, [0, vN, uH - H.sg * 0.002]), _vSc(Nj, nOff)), tipN = _vAdd(atN, [0, 0, H.sg * 0.03]), inN = _vAdd(atN, [0, 0, H.sg * 0.006]);
              var inHdr = function (W3) { return pieces.some(function (pc5) { return (pc5.kind === 'rim' || pc5.kind === 'post') && insidePc(pc5, W3, 0); }); };
              if (H.hdr === 'rim' && !(inHdr(tipN) && inHdr(inN))) continue;   /* the rim ends at a post there: no nail */
              scr('nail-hanger', GZ.NAIL, atN, _vSc(Z, H.sg), len38, 0.0019);
            }
          }
        });
      }
    }
    /* THE DECKING along X, flush with the posts' outer faces, notched round
       the posts (the hexagon's deck cut at each post's outer face) */
    var gap = _gzU(s, 'DECK_GAP'), deckPoly = [];
    for (k = 0; k < n; k++) { var tv = th(k), rv = aO / cpn; deckPoly.push([rv * Math.cos(tv), rv * Math.sin(tv)]); }
    if (_gzArea(deckPoly) < 0) deckPoly.reverse();
    if (hexB) posts.forEach(function (Pq) { deckPoly = _gzClip(deckPoly, -Pq.e1[0], -Pq.e1[2], _vDot(Pq.e1, Pq.c) + hp); });
    /* the supports under the deck in plan: rims, joists, beam */
    function planOf(pc) {
      var cs = [[pc.A, pc.nA], [pc.B, pc.nB]], out = [];
      cs.forEach(function (cc) {
        var us2 = cc[0].map(function (Pt) { return Pt[0]; }), u0 = Math.min.apply(null, us2), u1 = Math.max.apply(null, us2);
        [u0, u1].forEach(function (uu) { var W3 = _vAdd(_vAdd(pc.o, _vSc(pc.U, uu)), _vSc(pc.N, cc[1])); out.push([W3[0], W3[2]]); });
      });
      var ctr = [0, 0]; out.forEach(function (Pt) { ctr[0] += Pt[0] / 4; ctr[1] += Pt[1] / 4; });
      out.sort(function (a3, b3) { return Math.atan2(a3[1] - ctr[1], a3[0] - ctr[0]) - Math.atan2(b3[1] - ctr[1], b3[0] - ctr[0]); });
      return out;
    }
    function inPoly2(poly, x, z) {
      var c2 = false, nn = poly.length, i2, j2;
      for (i2 = 0, j2 = nn - 1; i2 < nn; j2 = i2++) {
        var xi = poly[i2][0], zi = poly[i2][1], xj2 = poly[j2][0], zj = poly[j2][1];
        if (((zi > z) !== (zj > z)) && (x < (xj2 - xi) * (z - zi) / (zj - zi) + xi)) c2 = !c2;
      }
      return c2;
    }
    function edgeDist(poly, x, z) {
      var d = 1e9, nn = poly.length, i2;
      for (i2 = 0; i2 < nn; i2++) {
        var A2 = poly[i2], B2 = poly[(i2 + 1) % nn], vx = B2[0] - A2[0], vz = B2[1] - A2[1], L2 = vx * vx + vz * vz, t = L2 ? ((x - A2[0]) * vx + (z - A2[1]) * vz) / L2 : 0;
        t = Math.max(0, Math.min(1, t));
        d = Math.min(d, Math.hypot(x - (A2[0] + t * vx), z - (A2[1] + t * vz)));
      }
      return d;
    }
    var supports = rimPieces.concat(joistPieces).concat([beam]).map(planOf);
    var nBd = Math.ceil((2 * aO + gap) / (dw + gap) - 1e-9), deckN = 0, deckScr = 0;
    for (j = 0; j < nBd; j++) {
      var zc = -aO + dw / 2 + j * (dw + gap), z0 = zc - dw / 2, z1 = Math.min(aO, zc + dw / 2);
      var strip = [[-Rc - 1, z0], [Rc + 1, z0], [Rc + 1, z1], [-Rc - 1, z1]];
      for (k = 0; k < deckPoly.length; k++) {
        var Pd = deckPoly[k], Qd = deckPoly[(k + 1) % deckPoly.length], exd = Qd[0] - Pd[0], ezd = Qd[1] - Pd[1];
        strip = _gzClip(strip, -ezd, exd, ezd * Pd[0] - exd * Pd[1]);
      }
      if (strip.length < 3) continue;
      var parts2 = [strip];
      posts.forEach(function (Pq) {
        var nx = [];
        parts2.forEach(function (pc2) { _gzDiff(pc2, Pq.sq).forEach(function (r3) { nx.push(r3); }); });
        parts2 = nx;
      });
      if (!parts2.length) continue;
      var xMin = 1e9, xMax = -1e9;
      parts2.forEach(function (pc2) { pc2.forEach(function (Pt) { xMin = Math.min(xMin, Pt[0]); xMax = Math.max(xMax, Pt[0]); }); });
      parts2.forEach(function (pc2, ip) {
        var dp = loft('deck', ip ? null : GZ.DECK, 'deck-' + (j + 1) + (ip ? '-' + ip : ''), [0, 0, 0], X, Z, -yD, -yJT, pc2, null);
        if (dp && !ip) dp.len = ceil2(xMax - xMin);
      });
      boards.push({ z: zc, w: z1 - z0, x0: xMin, x1: xMax, parts: parts2 });
      deckN++;
      /* its screws: 2 at every joist / rim / beam it crosses (on the board, 2 cm clear of its ends, over the support) */
      var zs2 = (z1 - z0 > dw * 0.6) ? [zc - dw / 4, zc + dw / 4] : [(z0 + z1) / 2];
      var seen = [];
      zs2.forEach(function (zz) {
        var cand = joistX.slice(0);
        for (var k3 = 0; k3 < n; k3++) { var nk = nuK(k3); if (Math.abs(nk[0]) > 1e-6) cand.push((ac - zz * nk[2]) / nk[0]); }
        cand.forEach(function (xx) {
          var onB = parts2.some(function (pc2) { return inPoly2(pc2, xx, zz) && edgeDist(pc2, xx, zz) > 0.012; });
          if (!onB) return;
          var onS = supports.some(function (sp) { return inPoly2(sp, xx, zz) && edgeDist(sp, xx, zz) > 0.008; });
          if (!onS) return;
          if (seen.some(function (sv) { return Math.abs(sv[0] - xx) < 0.03 && Math.abs(sv[1] - zz) < 0.01; })) return;
          seen.push([xx, zz]);
          scr('screw-deck', GZ.DECK_SCREW, [xx, yD, zz], [0, -1, 0], len50, 0.0025);
          deckScr++;
        });
      });
    }
    /* THE PLATES on the posts' tops, mitred over each post; one 8x260 down into the post at each end */
    var uV = ac * tpn;
    for (k = 0; k < n; k++) {
      var nuL = nuK(k), tauL = tauK(k), oP = _vSc(nuL, ac);
      var plp = loft('plate', GZ.PLATE, 'plate-' + (k + 1), oP, tauL, UP, -hp, hp, [[-Rc - 1, yPT], [Rc + 1, yPT], [Rc + 1, yT], [-Rc - 1, yT]],
                     [{ m: _vSc(nthK(k), -1), d: 0 }, { m: nthK(k - 1), d: 0 }]);
      plp.len = ceil2(plp.uMax - plp.uMin);
      for (q = -1; q <= 1; q += 2) scr('screw-plate', GZ.PLATE_SCREW, _vAdd(_vAdd(oP, _vSc(tauL, q * (uV - 0.03))), [0, yT, 0]), [0, -1, 0], len260);
    }
    /* THE ROOF: the rafters' top plane of each flat at the horizontal
       distance d from the centre: yF(d); hap = the rafter's top over the
       plate's outer top edge (its birdsmouth SEAT deep into the plate) */
    var al = GZ.PITCH * Math.PI / 180, ta = Math.tan(al), ca = Math.cos(al), sa = Math.sin(al);
    var dv = rd / ca, seat = _gzU(s, 'SEAT'), hap = dv - seat * ta, eave = _gzU(s, 'EAVE'), dE = aO + eave;
    function yF(d) { return yT + hap + (aO - d) * ta; }
    var hubA = (n === 4) ? P.hub / 2 : P.hub / 2 * Math.cos(Math.PI / 6);
    /* the hips: in the vertical plane of each vertex, their top dropped so their edges lie in the planes */
    var tbH = cpn * ta, dvh = rd * Math.sqrt(1 + tbH * tbH), drop = rw / 2 * spn * ta, rO = aO / cpn, rE = dE / cpn;
    function yHt(r) { return yF(r * cpn) - drop; }
    function yHb(r) { return yHt(r) - dvh; }
    var hipBotHub = yHb(hubA), seatScr = _gzU(s, 'SEAT_SCREW'), lenSeat = us ? len200 : len260;
    var hubTop = yF(hubA / cpn), hubBot = hipBotHub - 0.04;
    var hubPoly = [];
    for (k = 0; k < n; k++) { var aH = phi(k), rH = hubA / cpn; hubPoly.push([rH * Math.cos(aH), rH * Math.sin(aH)]); }
    if (_gzArea(hubPoly) < 0) hubPoly.reverse();
    var hub = loft('hub', GZ.HUB, 'hub', [0, 0, 0], X, Z, -hubTop, -hubBot, hubPoly, null);
    hub.len = ceil2(hubTop - hubBot);
    var hipL = 0;
    for (k = 0; k < n; k++) {
      var Uh = dirA(th(k)), nh = yT - yHb(rO), rS = rO - Math.max(0, nh) / tbH;
      var profH = (nh > 0) ? [[rE, yHb(rE)], [rE, yHt(rE)], [hubA, yHt(hubA)], [hubA, yHb(hubA)], [rS, yT], [rO, yT], [rO, yHb(rO)]]
                           : [[rE, yHb(rE)], [rE, yHt(rE)], [hubA, yHt(hubA)], [hubA, yHb(hubA)]];
      var hpc = loft('hip', GZ.RAFTER, 'hip-' + (k + 1), [0, 0, 0], Uh, UP, -rw / 2, rw / 2, profH, null);
      hpc.len = ceil2((rE - hubA) * Math.sqrt(1 + tbH * tbH));
      hipL += hpc.len;
      var rm = (rS + rO) / 2;
      scr('screw-seat', seatScr, [Uh[0] * rm, yHt(rm), Uh[2] * rm], [0, -1, 0], lenSeat);
      /* 2 toe screws into the hub, 30 deg inwards, one high on one side, one low on the other */
      for (q = -1; q <= 1; q += 2) {
        var rT = hubA + 0.06, yT2 = (yHt(rT) + yHb(rT)) / 2 + q * dvh * 0.2, Nh = hpc.N;
        var atH = _vAdd(_vAdd(_vSc(Uh, rT), [0, yT2, 0]), _vSc(Nh, q * rw / 2));
        scr('screw-hub', GZ.HUB_SCREW, atH, _vAdd(_vSc(Uh, -Math.cos(Math.PI / 6)), _vSc(Nh, -q * Math.sin(Math.PI / 6))), len120);
      }
    }
    /* the jacks: pairs either side of each flat's middle, as many as keep
       them (and the last one and the hip) <= RAF_SP apart at the plate */
    var hw = aO * tpn, mJk = Math.max(1, Math.ceil(hw / _gzU(s, 'RAF_SP') - 0.5 - 1e-9)), gJ = hw / (mJk + 0.5);
    var jkScr = _gzU(s, 'JACK_SCREW'), lenJk = us ? len100 : len120;
    for (k = 0; k < n; k++) {
      var nuJ = nuK(k), tauJ = tauK(k);
      for (i = 1; i <= mJk; i++) for (q = -1; q <= 1; q += 2) {
        var e = q * (i - 0.5) * gJ, oK = _vSc(tauJ, e);
        /* its hip: k for e > 0 (keep P.n_th <= -rw/2), k-1 for e < 0 (keep >= rw/2) */
        var Nth = (q > 0) ? nthK(k) : nthK(k - 1), plH = (q > 0) ? { m: _vSc(Nth, -1), d: rw / 2 } : { m: Nth, d: rw / 2 };
        var profJ = [[dE, yF(dE) - dv], [dE, yF(dE)], [0.02, yF(0.02)], [0.02, yF(0.02) - dv], [aO - seat, yT], [aO, yT], [aO, yF(aO) - dv]];
        var jk = loft('jack', GZ.RAFTER, 'jack-' + (k + 1) + '-' + (q < 0 ? 'l' : 'r') + i, oK, nuJ, UP, -rw / 2, rw / 2, profJ, [plH]);
        if (!jk) continue;
        jk.len = ceil2((dE - jk.uMin) / ca);
        jk.dTop = jk.uMin;
        jacks.push({ k: k, e: e, d0: jk.dTop, id: jk.id });
        var dm = aO - seat / 2;
        scr('screw-seat', seatScr, _vAdd(_vAdd(oK, _vSc(nuJ, dm)), [0, yF(dm), 0]), [0, -1, 0], lenSeat);
        /* 2 toe screws into the hip: the tip at the hip's centre plane, the head on the far face */
        var Nk = jk.N, dC = (Math.min.apply(null, jk.A.map(function (Pt) { return Pt[0]; })) + Math.min.apply(null, jk.B.map(function (Pt) { return Pt[0]; }))) / 2;
        var sgA = Math.min(0.95, (rw / 2) * (1 + cpn) / lenJk), aJ = Math.asin(sgA), sideS = (q > 0) ? 1 : -1;
        var dirJ = _vAdd(_vSc(nuJ, -Math.cos(aJ)), _vSc(Nk, sideS * Math.sin(aJ)));
        for (j = 0; j < 2; j++) {
          var Pend = _vAdd(oK, _vSc(nuJ, dC));
          var Ttip = _vAdd(Pend, _vSc(Nth, (q > 0 ? 1 : -1) * rw / 2));
          var yTip = yHt(Math.sqrt(Ttip[0] * Ttip[0] + Ttip[2] * Ttip[2])) - dvh * (j ? 0.62 : 0.32);
          var Sst = _vAdd([Ttip[0], yTip, Ttip[2]], _vSc(dirJ, -lenJk));
          scr('screw-jack', jkScr, Sst, dirJ, lenJk);
        }
      }
    }
    /* the roof boards, the shingles, the caps, the drip edge: in each
       flat's plane (U along the eave towards the k-1 vertex, V up the
       slope, N out); the apex at the centre on the rafters' top plane;
       a face B raised plumb so the slabs meet on the hips */
    var apex = [0, yF(0), 0], rbT = P.rb, shT = (cov === 'seam') ? GZ.SEAM_T : GZ.SHINGLE_T, roofA = 0, rbNails = 0, eaveL = 0, nRbRow = 0, nSeam = 0;
    var seamPan = _gzU(s, 'SEAM_PAN'), capUp = (cov === 'seam') ? GZ.SEAM_H : 0;   /* v329 the caps over the seams */
    for (k = 0; k < n; k++) {
      var nuF = nuK(k), tauF = tauK(k), Uf = _vSc(tauF, -1), Vf = [-nuF[0] * ca, sa, -nuF[2] * ca];
      var E1 = [rE * Math.cos(th(k - 1)), yF(dE), rE * Math.sin(th(k - 1))], E2 = [rE * Math.cos(th(k)), yF(dE), rE * Math.sin(th(k))];
      var toUV = function (W3) { var dd = [W3[0] - apex[0], W3[1] - apex[1], W3[2] - apex[2]]; return [_vDot(dd, Uf), _vDot(dd, Vf)]; };
      var tri = [toUV(E1), toUV(E2), [0, 0]];
      var lift = function (poly, h) { return poly.map(function (Pt) { return [Pt[0], Pt[1] + h * ta]; }); };
      var area = Math.abs(_gzArea(tri));
      roofA += area;
      var rbA = tri, rbB = lift(tri, rbT);
      var mk = function (kind, code, id, A3, B3, n0, n1) {
        var pc3 = { kind: kind, code: code, len: 0, id: id, o: apex, U: Uf, V: Vf, N: _vCross(Uf, Vf), nA: n0, nB: n1, A: A3, B: B3, roof: true };
        if (_gzArea(pc3.A) < 0) { pc3.A = pc3.A.slice().reverse(); pc3.B = pc3.B.slice().reverse(); }
        pieces.push(pc3);
        return pc3;
      };
      mk('rboard', null, 'roof-boards-' + (k + 1), rbA, rbB, 0, rbT);
      /* v329 the covering: the shingles (their texture at the real 3-tab size: a tab 333 wide, a course 143) or the standing seam's pans */
      var cvp = mk('cover', null, 'cover-' + (k + 1), lift(tri, rbT), lift(tri, rbT + shT), rbT, rbT + shT);
      cvp.cov = cov;
      if (cov === 'shingle') cvp.uvS = [1 / (8 * GZ.TAB), 1 / (8 * GZ.CAP_EXPO)];
      else {
        /* the seams up the slope every pan from the flat's middle, cut by its hips */
        var triC = (_gzArea(tri) < 0) ? tri.slice().reverse() : tri, uLo = Math.min(tri[0][0], tri[1][0]), uHi = Math.max(tri[0][0], tri[1][0]), sW = GZ.SEAM_W;
        for (var uS = -Math.floor((-uLo) / seamPan) * seamPan; uS <= uHi + 1e-9; uS += seamPan) {
          var bandS = [[uS - sW / 2, -50], [uS + sW / 2, -50], [uS + sW / 2, 50], [uS - sW / 2, 50]];
          for (var e5 = 0; e5 < 3; e5++) {
            var P5 = triC[e5], Q5 = triC[(e5 + 1) % 3], ex5 = Q5[0] - P5[0], ey5 = Q5[1] - P5[1];
            bandS = _gzClip(bandS, -ey5, ex5, ey5 * P5[0] - ex5 * P5[1]);
          }
          if (bandS.length < 3 || Math.abs(_gzArea(bandS)) < 1e-5) continue;
          mk('seam', null, 'seam-' + (k + 1) + '-' + (++nSeam), lift(bandS, rbT + shT), lift(bandS, rbT + shT + GZ.SEAM_H), rbT + shT, rbT + shT + GZ.SEAM_H);
        }
      }
      /* the hip caps: a band along each sloping edge of this flat, on the covering (v329 over the seams) */
      var cw = GZ.CAP_W, cT = GZ.CAP_T, h0 = rbT + shT + capUp;
      [[tri[0], tri[2]], [tri[1], tri[2]]].forEach(function (ed, ie) {
        var a4 = ed[0], b4 = ed[1], ex4 = b4[0] - a4[0], ey4 = b4[1] - a4[1], l4 = Math.hypot(ex4, ey4), nx4 = -ey4 / l4, ny4 = ex4 / l4;
        var mid = [(a4[0] + b4[0]) / 2 + nx4 * 0.01, (a4[1] + b4[1]) / 2 + ny4 * 0.01];
        if (!(Math.abs(_gzArea(tri)) > 0) || !inPoly2(tri, mid[0], mid[1])) { nx4 = -nx4; ny4 = -ny4; }   /* into the flat */
        /* v330 one width all the way up (Marek: maji byt rovne), cut at the flat's middle (u = 0) so this flat's two never overlap near the apex */
        var ov4 = 0.004, band = [[a4[0] - nx4 * ov4, a4[1] - ny4 * ov4], [b4[0] - nx4 * ov4, b4[1] - ny4 * ov4], [b4[0] + nx4 * cw, b4[1] + ny4 * cw], [a4[0] + nx4 * cw, a4[1] + ny4 * cw]];   /* 4 mm over the hip: no seam */
        band = (a4[0] < 0) ? _gzClip(band, -1, 0, 0) : _gzClip(band, 1, 0, 0);
        if (band.length < 3) return;
        var cpc = mk('cap', null, 'cap-' + (k + 1) + '-' + (ie + 1), lift(band, h0), lift(band, h0 + cT), h0, h0 + cT);
        if (cov === 'shingle') cpc.uvS = [1 / (8 * GZ.TAB), 1 / (8 * GZ.CAP_EXPO)];   /* v330 the caps are shingles: the same texture */
      });
      /* the drip edge: a strip on the boards' plumb eave edge */
      var eL = Math.hypot(E2[0] - E1[0], E2[2] - E1[2]);
      eaveL += eL;
      var Ud = _vNorm([E1[0] - E2[0], 0, E1[2] - E2[2]]), od = _vAdd(E2, _vSc(nuF, 0.0015));
      loft('drip', null, 'drip-' + (k + 1), od, Ud, UP, 0, 0.0012, [[0, -0.03], [eL, -0.03], [eL, rbT / ca + 0.004], [0, rbT / ca + 0.004]], null, { roof: true });
      /* the roof boards' nails: rows of the board width up the slope, 2 at every rafter (hips + jacks) under the row */
      var slopeL = (dE) / ca, rows = Math.ceil(slopeL / (us ? 0.1397 : 0.146) - 1e-9);
      for (j = 0; j < rows; j++) {
        var dRow = dE - (j + 0.5) * (us ? 0.1397 : 0.146) * ca, cnt = 2;
        jacks.forEach(function (jq) { if (jq.k === k && dRow >= jq.d0 && dRow <= dE) cnt++; });
        rbNails += 2 * cnt;
        nRbRow++;
      }
    }
    var capL = hipL + 0.30;   /* the caps run the hips (+ the apex cap over their meeting) */
    /* v329 the caps' fixings: 2 roofing nails a cap shingle (one a course); on metal 2 sealing screws every 30 cm along each hip */
    var capPieces = (cov === 'shingle') ? Math.ceil(capL / GZ.CAP_EXPO - 1e-9) : 0, capNails = GZ.CAP_NAILS * capPieces, capScrews = 0;   /* v330 a cap piece = a tab of the same shingle */
    if (cov === 'seam') for (k = 0; k < n; k++) capScrews += 2 * (Math.ceil((hipL / n) / GZ.SEAM_CAP_SP - 1e-9) + 1);
    /* THE RAILING on every side but the entrance: 2x4 rails between the
       posts, their outer face flush with the deck's edge (the hexagon's
       then meet the post's face across its whole thickness), 2x2
       balusters on their inner face */
    var balN = 0, aRl = aO - lt / 2, yR1 = yD + _gzU(s, 'RAIL_TOP'), yR0 = yD + _gzU(s, 'RAIL_LOW'), bG = _gzGap(s), yBl = yD + _gzU(s, 'BAL_LOW'), gapReal = 0;   /* v329 the gap from the slider */
    /* v350 (Marek 2026-10-22 14:54: U altanu by to chtelo dodelat podobny
       system vyplni pole jako u pergoly. Nechat jak to je ted ale s moznosti
       nahrazeni vyplne pres celou vysku na kazdem poli zvlast): every side
       has its + / - disc on the ground (the pergola's, DOT_OUT out from the
       deck's edge); a FULL side keeps its two rails (the railing's top one
       the middle rail now), gets a HEAD RAIL under the plate (the same 2x4,
       2 toe screws an end) and its infill (the switch's kind, the slider's
       gap) runs from the railing's foot up to the plate, fixed into all
       three rails; the entrance (gz1) is open unless it is full */
    var GF = _gzFields(s), fields = [], fullN = 0;
    for (k = 0; k < n; k++) {
      var gidF = 'gz' + (k + 1), fullF = !!GF[gidF], nuD = nuK(k), rD = aO + PE.DOT_OUT;
      fields.push({ id: gidF, side: k, state: fullF ? 1 : 0, at: [nuD[0] * rD, 0.03, nuD[2] * rD] });
      if (k === 0 && !fullF) continue;
      if (fullF) fullN++;
      var nuR = nuK(k), tauR = tauK(k), oRl = _vSc(nuR, aRl), plRE = postFace(k, tauR), plRS = postFace((k + n - 1) % n, _vSc(tauR, -1));
      var NRl = _vCross(tauR, UP), bigR = Rc + 1, yFT = fullF ? yPT : yR1;
      var railsK = [[yR0, yR0 + lh, 'low'], [yR1 - lh, yR1, 'top']];
      if (fullF) railsK.push([yPT - lh, yPT, 'head']);
      railsK.forEach(function (rr) {
        var rlp = loft('rail', GZ.RAIL, 'rail-' + (k + 1) + '-' + rr[2], oRl, tauR, UP, -lt / 2, lt / 2, [[-bigR, rr[0]], [bigR, rr[0]], [bigR, rr[1]], [-bigR, rr[1]]], [plRE, plRS]);
        rlp.len = ceil2(rlp.uMax - rlp.uMin);
        rails.push(rlp);
        for (q = -1; q <= 1; q += 2) {
          var plQ2 = (q > 0) ? plRE : plRS;
          for (j = 0; j < 2; j++) {
            var vR = rr[0] + lh * (j ? 0.7 : 0.3), uR = uAt(oRl, tauR, UP, plQ2, lt / 2, vR) - q * 0.04, ang2 = Math.min(25 * Math.PI / 180, Math.asin((lt - 0.006) / len100));
            var atR = _vAdd(_vAdd(_vAdd(oRl, _vSc(tauR, uR)), [0, vR, 0]), _vSc(NRl, lt / 2));
            scr('screw-rail', GZ.RAIL_SCREW, atR, _vAdd(_vSc(tauR, q * Math.cos(ang2)), _vSc(NRl, -Math.sin(ang2))), len100);
          }
        }
      });
      /* the infill on the rails' inner face, evenly between the posts at
         the slider's clear gap (v329: 2x2 slats, a 5x60 into each rail; or
         1x4 boards, 2 stainless 5.5x50 into each rail) */
      var rTop = rails[rails.length - 1], u0b = -1e9, u1b = 1e9;
      [rTop.A, rTop.B].forEach(function (pl2) { var us3 = pl2.map(function (Pt) { return Pt[0]; }); u0b = Math.max(u0b, Math.min.apply(null, us3)); u1b = Math.min(u1b, Math.max.apply(null, us3)); });
      var fW = (fill === 'board') ? P.bw : bal, fT = (fill === 'board') ? P.bwt : bal, fCode = (fill === 'board') ? GZ.BOARD : GZ.BALUSTER;
      var span = u1b - u0b, nBal = Math.max(1, Math.round((span - bG) / (fW + bG))), gB = (span - nBal * fW) / (nBal + 1);
      gapReal = Math.max(gapReal, gB);
      for (i = 0; i < nBal; i++) {
        var ub = u0b + gB + fW / 2 + i * (fW + gB);
        var blp = loft('infill', fCode, 'infill-' + (k + 1) + '-' + (i + 1), oRl, tauR, UP, lt / 2, lt / 2 + fT, [[ub - fW / 2, yBl], [ub + fW / 2, yBl], [ub + fW / 2, yFT], [ub - fW / 2, yFT]], null);
        blp.len = ceil2(yFT - yBl);
        balN++;
        (fullF ? [yR0 + lh / 2, yR1 - lh / 2, yPT - lh / 2] : [yR0 + lh / 2, yR1 - lh / 2]).forEach(function (vb) {
          var offs = (fill === 'board') ? [-fW / 4, fW / 4] : [0];
          offs.forEach(function (du) {
            scr('screw-fill', (fill === 'board') ? GZ.BOARD_SCREW : GZ.BAL_SCREW, _vAdd(_vAdd(_vAdd(oRl, _vSc(tauR, ub + du)), [0, vb, 0]), _vSc(NRl, lt / 2 + fT)), _vSc(NRl, -1), (fill === 'board') ? len50 : len60, 0.0025);
          });
        });
      }
    }
    /* the bill's quantities: timber by code, the coating (every timber piece's long faces + the roof boards' underside) */
    var SEC = {}, m = {}, coat = 0;
    SEC[GZ.POST] = [p, p]; SEC[GZ.PLATE] = [p, ph]; SEC[GZ.RIM] = [jt, jh]; SEC[GZ.HUB] = [P.hub, P.hub]; SEC[GZ.RAIL] = [lt, lh]; SEC[GZ.BALUSTER] = [bal, bal]; SEC[GZ.DECK] = [dk, dw]; SEC[GZ.BOARD] = [P.bwt, P.bw];
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      var sec = SEC[pc.code] || [p, p];
      coat += 2 * (sec[0] + sec[1]) * pc.len;
    }
    coat += roofA;
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var Wx = (n === 4) ? S : 2 * aO / cpn;
    var top = Math.max(yF(0) + (rbT + shT + capUp + GZ.CAP_T) / ca, hubTop);
    /* v329 the foundation's quantities: the blocks' gravel + beds; the footings' concrete (proud + down to PIER_D), 4 bars, gravel, geotextile, beds */
    var bkW = _gzU(s, 'BLK'), gvB = _gzU(s, 'GRAVEL'), pW = _gzU(s, 'PIER_W'), pD = _gzU(s, 'PIER_D'), pG = _gzU(s, 'PIER_GRAVEL');
    var fq = {
      blockN: blocks.length, pourN: pours.length,
      gravel: r3(blocks.length * bkW * bkW * gvB + pours.length * pW * pW * pG),
      dig: r3(pours.length * pW * pW * (pD + pG)),   /* v354 only the poured footings' holes: the precast pads' beds are dug by hand as they are set */
      concrete: r3(pours.length * pW * pW * (pD + yH)),
      rebar: Math.round(pours.length * 4 * (pD + yH - 2 * GZ.BAR_COVER) * 100) / 100,
      geotex: Math.round(pours.length * pW * pW * 100) / 100
    };
    return {
      P: P, us: us, n: n, S: S, W: Wx, pieces: pieces, fas: fas, gscrews: gscrews, uheads: uheads, hangers: hangers, posts: posts, piers: piers,
      found: found, cov: cov, fill: fill, gap: bG, gapReal: gapReal, blocks: blocks, pours: pours, fq: fq, capNails: capNails, capScrews: capScrews, seams: nSeam,   /* v329 */
      fields: fields, fullN: fullN,   /* v350 the sides' discs, the full ones */
      capPieces: capPieces, capShA: Math.round(capPieces * GZ.TAB * GZ.CAP_EXPO * 100) / 100,   /* v330 the shingle caps' area */
      joists: joistPieces.length, joistX: joistX, boards: deckN, deckScrews: deckScr, jacks: jacks.length, jackSp: gJ, hips: n, rails: rails.length, balusters: balN,
      meters: m, coat: coat, roofA: r3(roofA), rbNails: rbNails, capL: capL, eaveL: r3(eaveL), dripFix: n * (Math.ceil(eaveL / n / GZ.DRIP_FIX - 1e-9) + 1),
      yH: yH, yB0: yB0, yJT: yJT, yD: yD, yPT: yPT, yT: yT, aO: aO, ac: ac, Rc: Rc, apex: yF(0), apexTop: yF(0) + (rbT + shT) / ca, hubTop: hubTop, pitch: GZ.PITCH, th0: th(0),
      top: top, height: top, length: S, depth: Wx, missing: []
    };
  }
  /* its staged assembly: the ground screws, the U heads, the posts, the
     beam, the rims, their nails, the joists in their hangers, the decking,
     its screws, the plates, the hub + hips, the jacks, the roof boards,
     the underlay + shingles + drip edge, the caps, the rails, the
     balusters (a step whose parts are not drawn drops out) */
  var _gzStepsC = {};
  function _gzSteps(s) {
    s = s || STATE;
    var fnd = _gzFound(s), cov = _gzCov(s), fill = _gzFill(s), key = String(s.isMetric === false) + fnd + cov + fill;   /* v329 + the foundation, covering, infill */
    if (_gzStepsC[key]) return _gzStepsC[key];
    return (_gzStepsC[key] = [
      { parts: [], codes: [] },
      { parts: ['gz-gscrew'], codes: [GZ.GSCREW] },
      { parts: ['gz-block'], codes: [GZ.GRAVEL_CODE, GZ.BLOCK] },                                                   /* v329 precast pads; v354 no FEE00001 */
      { parts: ['gz-pour'], codes: [GZ.DIG, GZ.GRAVEL_CODE, GZ.GEOTEX, GZ.FORMWORK, GZ.REBAR, GZ.CONCRETE] },     /* v329 poured footings */
      { parts: ['gz-uhead'], codes: [(fnd === 'pier') ? GZ.UANCHOR : GZ.UHEAD] },
      { parts: ['gz-post'], codes: [GZ.POST] },
      { parts: ['gz-beam', 'gz-hw-screw-beam'], codes: [GZ.BEAM, GZ.BEAM_SCREW] },
      { parts: ['gz-rim', 'gz-hw-screw-rim'], codes: [GZ.RIM, GZ.RIM_SCREW] },
      { parts: ['gz-hw-nail-uhead'], codes: [GZ.NAIL] },
      { parts: ['gz-hanger', 'gz-joist', 'gz-hw-nail-hanger'], codes: [GZ.HANGER, GZ.JOIST, GZ.NAIL] },
      { parts: ['gz-deck'], codes: [GZ.DECK] },
      { parts: ['gz-hw-screw-deck'], codes: [GZ.DECK_SCREW] },
      { parts: ['gz-plate', 'gz-hw-screw-plate'], codes: [GZ.PLATE, GZ.PLATE_SCREW] },
      { parts: ['gz-hub', 'gz-hip', 'gz-hw-screw-hub'], codes: [GZ.HUB, GZ.RAFTER, GZ.HUB_SCREW] },
      { parts: ['gz-jack', 'gz-hw-screw-seat', 'gz-hw-screw-jack'], codes: [GZ.RAFTER, _gzU(s, 'SEAT_SCREW'), _gzU(s, 'JACK_SCREW')] },
      { parts: ['gz-rboard'], codes: [GZ.RBOARD, GZ.RB_NAIL] },
      { parts: ['gz-cover', 'gz-seam', 'gz-drip'], codes: (cov === 'seam') ? [GZ.UNDERLAY, GZ.SEAM, GZ.SEAM_CLIP, GZ.DRIP, GZ.ROOF_NAIL] : [GZ.UNDERLAY, GZ.SHINGLE, GZ.DRIP, GZ.ROOF_NAIL] },
      { parts: ['gz-cap'], codes: (cov === 'seam') ? [GZ.HIP_CAP, GZ.SEAM_SCREW] : [GZ.SHINGLE, GZ.ROOF_NAIL] },   /* v330 the shingle caps: shingles */
      { parts: ['gz-rail', 'gz-hw-screw-rail'], codes: [GZ.RAIL, GZ.RAIL_SCREW] },
      { parts: ['gz-infill', 'gz-hw-screw-fill'], codes: (fill === 'board') ? [GZ.BOARD, GZ.BOARD_SCREW] : [GZ.BALUSTER, GZ.BAL_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v334 TYPE 24 -- GARDEN STRUCTURE 5: THE PERGOLA (Marek 2026-10-21 21:23
     with three photos -- a hot tub under a 6x6 hipped pergola with knee
     braces and a metal roof, a corner pergola with slatted walls under a
     flat top of rafters, a pergola on a deck under heavy rafters: "Ted
     udelame pergolu. Sloupy, pri vetsich roztecich pridat sloupky, udelat
     variantu ctvercovou. Moznost vyplne poli mezi sloupy jako to mame u
     shelter - jen s rozdilem ze i tlacitko plus bude cyklovat - cela
     vypln, leva pulka, prava pulka, prazdne. Prepinani slats horizontalni
     a vertikalni a treti typ miz. Tri tvary kryti - flat / gable / hip a
     krytina on / off."; asked -- the square: a Rectangle / Square switch,
     the square on one handle; the covering: standing seam on boards as the
     gazebo's). v336 (Marek 22:11): the infill always over the whole field,
     no shape switch -- the length and the width on the footprint's grips.
     X = across (W), Y = up, Z = along (L), centred; L / W = the posts' and
     beams' outer faces, 2.40 - 4.80 m (US 8 - 16 ft), 3.00 x 3.00 (US 10 x
     10 ft) to start. _peLayout(STATE) is the single source; its pieces are
     planar polygons lofted along their normal (as the gazebo's).
       - THE FOUNDATION on the toggle: a GROUND SCREW FGR00004 102 x 1500
         (US 4 in. x 5 ft) with a U HEAD FGR00002 | a PRECAST FOOTING
         FCO00009 400 x 400 (US 16 x 16 in.) on 10 cm of gravel, 10 cm of it
         up, an ADJUSTABLE POST BASE 6x6 FFP01601 on it held by 2 concrete
         screws FAS10075 | a POURED FOOTING 40 x 40 x 80 (the ADU's piers:
         concrete, 4 bars, gravel, geotextile, formwork) with a wet-set
         H POST ANCHOR 6x6 FFP01002; the post 3 cm over the base, 12
         connector nails FAS38038 through its flanges;
       - 6x6 POSTS KVH16160 at the corners and between them at <= 3.00 m
         (US 10 ft) along every side, 2.40 m (US 8 ft) up to the beams;
       - 6x6 BEAMS KVH16160 on the posts' tops round the four sides, flush
         with the posts' outer faces, mitred over the corner posts; 8x260
         FAS80260 down into every post (one a beam at a corner, two over a
         post between);
       - 4x4 KNEE BRACES KVH10100 at 45 deg in every side's plane from every
         post towards its neighbours, 60 cm (US 2 ft) runs (less on a short
         bay), 2 toe screws 6x160 FAS60160 an end;
       - THE ROOF on the switch, FLAT / GABLE / HIP, and its covering on /
         off (the covering: T&G boards KVR14619 + underlay ROR00008 +
         standing seam ROR12003 with its clips, the caps ROR00009 on the
         ridge / hips with sealing screws, the drip edge ROM02401 round it):
         FLAT -- 2x8 RAFTERS KVH60200 across on the side beams, 30 cm (US 12
           in.) past them, an 8x260 down into each beam; open: <= 40 cm (US
           16 in.) apart, raked ends; covered: <= 60 cm, the front posts
           taller so the roof falls 3 deg to the back;
         GABLE (25 deg) -- the ridge along Z, a 2x8 RIDGE BOARD KVH60200,
           2x6 RAFTERS KVH60160 in pairs <= 60 cm (US 2 ft) apart,
           birdsmouthed on the side beams with a 30 cm (US 12 in.) tail, an
           8x260 (US 8x200 FAS80200) through each seat, 2 x 6x100 FAS60100
           from the top into the ridge; a 6x6 TIE KVH16160 across at every
           post between the corners (2 x 8x260 through the beam into each
           end);
         HIP (25 deg) -- the ridge along the longer side (a short block on
           the square), 2x6 HIPS from the corners to its ends (2 x 8x160
           FAS80160 through the ridge into each), 2x6 COMMONS / JACKS on
           every side <= 60 cm apart (the jacks cut against the hips, 2 toe
           screws 6x120 FAS60120 (US 6x100) into the hip), a KING rafter at
           each end against the ridge's end; ties as the gable's;
       - THE INFILL in every field between two posts on the "+" button
         (v336: empty <> full, the whole field; v337 a + / - disc on the
         ground) of the infill switch's kind, 40x60 KVH40060 (US 2x3) on
         the posts' outer faces from 10 cm (US 4 in.) up to the beams, the
         clear gap on the slider (v337: 10 - 200 mm, 40 to start, as the
         shelter's): HORIZONTAL slats; VERTICAL slats on the shelter's level
         rails KVH10060 (foot, head, every <= 1.20 m); TRELLIS -- laths both
         ways, the openings the gap; v338 SLATS + TRELLIS -- horizontal slats,
         a 60 cm trellis band on top; X + TRELLIS -- a rail panel with X
         braces, the trellis over it; the members over the posts to their
         far edges; stiles / rails by the density; a 40x60 STILE in the posts' plane at the field's middle
         where a field is longer than 1.50 m, 2 toe screws
         6x100 FAS60100 into the beam; a 6.5x90 stainless FAS65090 where a
         member crosses a post, a 4.5x70 FAS45070 where it crosses a stile
         or the layer under it. */
  var PE = {
    S: [2.40, 4.80], S_US: [2.4384, 4.8768], S0: 3.00, S0_US: 3.048,
    SPAN: 3.00, SPAN_US: 3.048, POST_H: 2.40, POST_H_US: 2.4384,
    BASE_UP: 0.03, U_T: 0.004, U_FL: 0.12,
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.051, GS_R_US: 0.0508,
    FTG: 0.40, FTG_US: 0.4064, FTG_TOP: 0.30, FTG_TOP_US: 0.3048, FTG_H: 0.20, FTG_H_US: 0.2032, FTG_UP: 0.10, FTG_UP_US: 0.1016, GRAVEL: 0.10, GRAVEL_US: 0.1016,
    PIER_W: 0.40, PIER_W_US: 0.4064, PIER_D: 0.80, PIER_D_US: 0.8128, PIER_UP: 0.10, PIER_UP_US: 0.1016, PIER_GRAVEL: 0.15, PIER_GRAVEL_US: 0.1524, BAR_COVER: 0.05,
    BRACE: 0.60, BRACE_US: 0.6096, BRACE_MIN: 0.30, BRACE_CLR: 0.12, TOE: 0.08, TOE_OFF: 0.025,
    PITCH: 25, EAVE: 0.30, EAVE_US: 0.3048, SEAT: 0.07, SEAT_US: 0.0635,
    RAF_SP: 0.60, RAF_SP_US: 0.6096, OPEN_SP: 0.40, OPEN_SP_US: 0.4064, FLAT_OV: 0.30, FLAT_OV_US: 0.3048, RAKE: 0.6, FALL: 3,
    RAKE_OV: 0.30, RAKE_OV_US: 0.3048,   /* v343 the gable's rakes this far past the gable ends (the posts' outer faces), as its eaves */
    FILL_Y0: 0.10, FILL_Y0_US: 0.1016, STILE_SPAN: 1.50,
    GAP: [0.01, 0.20], GAP_US: [0.009525, 0.2032], GAP0: 0.04, GAP0_US: 0.0381,   /* v337 the infill's clear gap on the slider -- the shelter's POST_WALL_GAP (10 - 200, 40 mm) */
    RAIL: 'KVH10060', RAIL_STEP: 1.20, RAIL_STEP_US: 1.2192,   /* v337 vertical slats on level rails as the shelter's (POST_WALL.rail, railStep) */
    HLAT_BAND: 0.60, HLAT_BAND_US: 0.6096, LAT_GAP: 0.09, LAT_GAP_US: 0.0889, XRAIL_Y: 0.90, XRAIL_Y_US: 0.9144,   /* v338 SLATS + TRELLIS: the trellis band on top, its openings; X + TRELLIS: the middle rail's centre over the ground */
    DOT_R: 0.18, DOT_OUT: 0.40,   /* v337 the + / - disc on the ground: the shelter's PW_DOT (360 across, 400 out from the post line) */
    POST: 'KVH16160', BEAM: 'KVH16160', TIE: 'KVH16160', BRACE_CODE: 'KVH10100', FRAFTER: 'KVH60200', RAFTER: 'KVH60160', RIDGE: 'KVH60200', SLAT: 'KVH40060',
    GSCREW: 'FGR00004', UHEAD: 'FGR00002', FOOTING: 'FCO00009', PBASE: 'FFP01601', HANCHOR: 'FFP01002', ANCHOR: 'FAS10075', NAIL: 'FAS38038',
    GRAVEL_CODE: 'FCO00001', DIG: 'FEE00001', CONCRETE: 'FCO00002', REBAR: 'FCO00003', FORMWORK: 'FCO00007', GEOTEX: 'FEC00003',
    BEAM_SCREW: 'FAS80260', TIE_SCREW: 'FAS80260', BRACE_SCREW: 'FAS60160', FRAF_SCREW: 'FAS80260',
    SEAT_SCREW: 'FAS80260', SEAT_SCREW_US: 'FAS80200', RIDGE_SCREW: 'FAS60100', HIP_SCREW: 'FAS80160', JACK_SCREW: 'FAS60120', JACK_SCREW_US: 'FAS60100',
    RBOARD: 'KVR14619', RB_NAIL: 'FAS70000', UNDERLAY: 'ROR00008', UL_STAPLE: 'FAS63000', SEAM: 'ROR12003', SEAM_CLIP: 'FAS60100', SEAM_SCREW: 'FAS00225',
    CAP: 'ROR00009', DRIP: 'ROM02401', ROOF_NAIL: 'FAS00318',
    SEAM_PAN: 0.53, SEAM_PAN_US: 0.4064, SEAM_W: 0.022, SEAM_H: 0.025, SEAM_T: 0.002, SEAM_CLIPS_M2: 5, SEAM_CAP_SP: 0.30, CAP_W: 0.12, CAP_T: 0.002,
    UL_STAPLES_M2: 6, WASTE: 1.10, DRIP_FIX: 0.30, RB_W: 0.146, RB_W_US: 0.1397,
    FILL_POST_SCREW: 'FAS65090', FILL_SCREW: 'FAS45070', STILE_SCREW: 'FAS60100'
  };
  /* the sections (metric / US actual): the 6x6 post / beam / tie, the 4x4
     brace, the 2x6 rafter / hip, the 2x8 flat rafter / ridge, the roof
     boards, the 40x60 (US 2x3) infill member */
  function _peProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.1397, b: 0.0889, rw: 0.0381, rd: 0.1397, fd: 0.1842, rgt: 0.0381, rb: 0.01905, st: 0.0381, sh: 0.0635, railT: 0.0381, railH: 0.0889 };
    return { p: 0.16, b: 0.10, rw: 0.06, rd: 0.16, fd: 0.20, rgt: 0.06, rb: 0.019, st: 0.04, sh: 0.06, railT: 0.06, railH: 0.10 };   /* v337 + the rail KVH10060 laid flat (US 2x4) */
  }
  function _peU(s, k) { return ((s || STATE).isMetric === false && PE[k + '_US'] != null) ? PE[k + '_US'] : PE[k]; }
  function _peRoof(s) { var r = (s || STATE).peRoof; return (r === 'gable' || r === 'hip') ? r : 'flat'; }
  function _peCov(s) { return (s || STATE).peCov === true; }                                                             /* the covering on / off */
  function _peFillT(s) { var f = (s || STATE).peFillT; return (f === 'v' || f === 'lat' || f === 'hlat' || f === 'xlat') ? f : 'h'; }   /* horizontal | vertical | trellis | v338 slats + trellis | X + trellis */
  function _peFound(s) { var f = (s || STATE).peFound; return (f === 'block' || f === 'pier') ? f : 'screw'; }
  function _peRange(s) { var r = _peU(s, 'S'); return { min: r[0], max: r[1] }; }
  function _peL(s) { s = s || STATE; var R = _peRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _peU(s, 'S0'))); }
  function _peW(s) { s = s || STATE; var R = _peRange(s), v = +s.peW; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _peU(s, 'S0'))); }   /* v336 its own grips, no square switch */
  function _peFields(s) { var f = (s || STATE).peFields; return (f && typeof f === 'object') ? f : {}; }
  function _peGapRange(s) { var r = _peU(s, 'GAP'); return { min: r[0], max: r[1] }; }
  function _peGap(s) { s = s || STATE; var R = _peGapRange(s), v = +s.peGap; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _peU(s, 'GAP0'))); }   /* v337 the slider */
  function _peLayout(s) {
    s = s || STATE;
    var P = _peProf(s), us = (s.isMetric === false), L = _peL(s), W = _peW(s), roof = _peRoof(s), cov = _peCov(s), fT = _peFillT(s), found = _peFound(s), i, j, k, q;
    var p = P.p, hp = p / 2, b = P.b, rw = P.rw, st = P.st, sh = P.sh, fd = P.fd;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len160b = us ? 0.1524 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10,
        len90 = us ? 0.0889 : 0.09, len80 = us ? 0.0762 : 0.08, len70 = us ? 0.06985 : 0.07, len75 = us ? 0.0762 : 0.075, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], gscrews = [], bases = [], blocks = [], pours = [], posts = [], fields = [], nAnchor = 0;
    var UP = [0, 1, 0], X = [1, 0, 0], Z = [0, 0, 1];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function scr(kind, code, at, d, ln, r) { d = _vNorm(d); fas.push({ kind: kind, code: code, x: at[0], y: at[1], z: at[2], dir: d, len: ln, r: r || 0.003 }); }
    /* a planar piece (as the gazebo's): prof in (u, v) about o, lofted along N = U x V from nA to nB, cut by the planes { m, d } (keep m.P >= d) on each face */
    function loft(kind, code, id, o, U, V, nA, nB, prof, planes, ex) {
      var N = _vCross(U, V), A = prof, B = prof, i2;
      for (i2 = 0; i2 < (planes || []).length; i2++) {
        var pl = planes[i2], a = _vDot(pl.m, U), b2 = _vDot(pl.m, V), c0 = _vDot(pl.m, o) - pl.d, mn = _vDot(pl.m, N);
        A = _gzClip(A, a, b2, c0 + nA * mn);
        B = _gzClip(B, a, b2, c0 + nB * mn);
      }
      if (A.length < 3 || B.length < 3) return null;
      if (A.length !== B.length) B = A;
      if (_gzArea(A) < 0) { A = A.slice().reverse(); B = B.slice().reverse(); }
      var uMin = 1e9, uMax = -1e9;
      A.concat(B).forEach(function (Pt) { uMin = Math.min(uMin, Pt[0]); uMax = Math.max(uMax, Pt[0]); });
      var pc = { kind: kind, code: code, len: 0, id: id, o: o, U: U, V: V, N: N, nA: nA, nB: nB, A: A, B: B, uMin: uMin, uMax: uMax };
      if (ex) for (var e in ex) if (ex.hasOwnProperty(e)) pc[e] = ex[e];
      pieces.push(pc);
      return pc;
    }
    function W3(o, U, V, N, u, v, n) { return [o[0] + U[0] * u + V[0] * v + N[0] * n, o[1] + U[1] * u + V[1] * v + N[1] * n, o[2] + U[2] * u + V[2] * v + N[2] * n]; }
    /* a world point inside a lofted piece (e: tolerance) */
    function insidePc(pc, P3, e) {
      var d = [P3[0] - pc.o[0], P3[1] - pc.o[1], P3[2] - pc.o[2]], u = _vDot(d, pc.U), v = _vDot(d, pc.V), nn = _vDot(d, pc.N);
      if (nn < pc.nA - e || nn > pc.nB + e) return false;
      var f = (pc.nB - pc.nA) ? Math.max(0, Math.min(1, (nn - pc.nA) / (pc.nB - pc.nA))) : 0, c2 = false, poly = pc.A.map(function (a, i2) { return [a[0] + (pc.B[i2][0] - a[0]) * f, a[1] + (pc.B[i2][1] - a[1]) * f]; }), i3, j3;
      for (i3 = 0, j3 = poly.length - 1; i3 < poly.length; j3 = i3++) {
        var xi = poly[i3][0], yi = poly[i3][1], xj = poly[j3][0], yj = poly[j3][1];
        if (((yi > v) !== (yj > v)) && (u < (xj - xi) * (v - yi) / (yj - yi) + xi)) c2 = !c2;
      }
      return c2;
    }
    /* a screw's whole shank in the wood of the given pieces (sampled every 3 mm) */
    function inWood(S3, dir, ln, pcs) {
      for (var t = 0.004; t <= ln - 0.001 + 1e-9; t += 0.003) {
        var Q = [S3[0] + dir[0] * t, S3[1] + dir[1] * t, S3[2] + dir[2] * t];
        if (!pcs.some(function (pc) { return insidePc(pc, Q, 0.0005); })) return false;
      }
      return true;
    }
    /* THE HEIGHTS: the foundation's top, the posts' feet, the beams'
       underside (the covered flat roof: rising to the front, its fall) */
    var yH = (found === 'block') ? _peU(s, 'FTG_UP') : (found === 'pier') ? _peU(s, 'PIER_UP') : _peU(s, 'FOOT_UP');
    var yPB = yH + PE.BASE_UP, yPT0 = yPB + _peU(s, 'POST_H'), hx = W / 2 - hp, hz = L / 2 - hp;
    var tf = (roof === 'flat' && cov) ? Math.tan(PE.FALL * Math.PI / 180) : 0;
    function yS(z) { return yPT0 + (z + hz) * tf; }
    /* THE POSTS: the corners, and between them at <= SPAN on every side */
    var span = _peU(s, 'SPAN'), nX = Math.max(1, Math.ceil(2 * hx / span - 1e-9)), nZ = Math.max(1, Math.ceil(2 * hz / span - 1e-9)), xs = [], zs = [];
    for (i = 0; i <= nX; i++) xs.push(-hx + 2 * hx * i / nX);
    for (i = 0; i <= nZ; i++) zs.push(-hz + 2 * hz * i / nZ);
    for (i = 0; i <= nX; i++) { posts.push({ x: xs[i], z: hz, id: 'f' + (i + 1) }); posts.push({ x: xs[i], z: -hz, id: 'b' + (i + 1) }); }
    for (i = 1; i < nZ; i++) { posts.push({ x: hx, z: zs[i], id: 'r' + i }); posts.push({ x: -hx, z: zs[i], id: 'l' + i }); }
    var postPcs = [];
    posts.forEach(function (Pq) {
      var sq = [[Pq.x - hp, Pq.z - hp], [Pq.x + hp, Pq.z - hp], [Pq.x + hp, Pq.z + hp], [Pq.x - hp, Pq.z + hp]];
      var slT = (tf > 0) && Math.abs(Math.abs(Pq.x) - hx) < 1e-6, top = slT ? yS(Pq.z + hp) : yS(Pq.z);   /* under a sloping side beam: its top cut along the slope */
      var pp = slT ? loft('post', PE.POST, 'post-' + Pq.id, [0, 0, 0], Z, UP, -(Pq.x + hp), -(Pq.x - hp), [[Pq.z - hp, yPB], [Pq.z + hp, yPB], [Pq.z + hp, yS(Pq.z + hp)], [Pq.z - hp, yS(Pq.z - hp)]], null)
                   : loft('post', PE.POST, 'post-' + Pq.id, [0, 0, 0], X, Z, -top, -yPB, sq, null);   /* (the sloping one lofted across X, its profile in (z, y)) */
      pp.len = ceil2(top - yPB);
      postPcs.push(pp);
      /* the foundation under it, the base on it (12 nails through its two flanges), 2 concrete screws through the base's foot into a precast footing */
      if (found === 'block') blocks.push({ x: Pq.x, z: Pq.z, w: _peU(s, 'FTG'), wt: _peU(s, 'FTG_TOP'), y0: yH - _peU(s, 'FTG_H'), y1: yH, id: Pq.id });
      else if (found === 'pier') pours.push({ x: Pq.x, z: Pq.z, w: _peU(s, 'PIER_W'), y1: yH, id: Pq.id });
      else gscrews.push({ x: Pq.x, z: Pq.z, r: _peU(s, 'GS_R'), y1: yH, id: Pq.id });
      bases.push({ x: Pq.x, z: Pq.z, y0: yH, y1: yPB, w: p, id: Pq.id, kind: found });
      for (var sd = -1; sd <= 1; sd += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr('nail', PE.NAIL, [Pq.x + sd * (hp + PE.U_T), yPB + 0.02 + rI * 0.03, Pq.z + cI * ((sd < 0) ? 0.03 : 0.045)], [-sd, 0, 0], len38, 0.0019);
      if (found === 'block') for (var aI = -1; aI <= 1; aI += 2) { scr('anchor', PE.ANCHOR, [Pq.x, yH + PE.U_T, Pq.z + aI * (hp + 0.035)], [0, -1, 0], len75, 0.004); nAnchor++; }
    });
    /* THE BEAMS round the four sides on the posts' tops, flush with their
       outer faces, mitred over the corners (the side beams sloping with a
       covered flat roof); 8x260 down into the posts */
    var big = Math.max(L, W) + 1, beamPcs = [], flatB = (roof === 'flat' || roof === 'gable');
    /* v343 the gable's rakes (Marek: ano, pokracuj -- the end rafters were flush with the front / back beams): its side beams too run through and RAKE_OV past the corner posts, carrying the end rafter pairs out there */
    var rkO = (roof === 'gable') ? _peU(s, 'RAKE_OV') : 0, LB = L / 2 + rkO;
    /* v334 a flat roof: the side beams run the whole length over the corner posts, the front / back beams between them (2 x 8x260 through the side beam into each end) */
    if (flatB) {
      for (var sx2 = -1; sx2 <= 1; sx2 += 2) {
        var bS2 = loft('beam', PE.BEAM, 'beam-' + (sx2 < 0 ? 'l' : 'r'), [sx2 * hx, 0, 0], Z, UP, -hp, hp, [[-LB, yS(-LB)], [LB, yS(LB)], [LB, yS(LB) + p], [-LB, yS(-LB) + p]], null);
        bS2.len = ceil2(2 * LB * Math.sqrt(1 + tf * tf));
        beamPcs.push(bS2);
      }
      for (var sz2 = -1; sz2 <= 1; sz2 += 2) {
        var yF2 = yS(sz2 * hz), bF2 = loft('beam', PE.BEAM, 'beam-' + (sz2 < 0 ? 'b' : 'f'), [0, 0, sz2 * hz], X, UP, -hp, hp, [[-(hx - hp), yF2], [hx - hp, yF2], [hx - hp, yF2 + p], [-(hx - hp), yF2 + p]], null);
        bF2.len = ceil2(2 * (hx - hp));
        beamPcs.push(bF2);
        for (sx2 = -1; sx2 <= 1; sx2 += 2) for (var k6 = 0; k6 < 2; k6++) scr('screw-beam', PE.BEAM_SCREW, [sx2 * (hx + hp), yF2 + p * (k6 ? 0.68 : 0.32), sz2 * hz + (k6 ? 0.03 : -0.03)], [-sx2, 0, 0], len260);
      }
    }
    for (var sx = -1; sx <= 1 && !flatB; sx += 2) {
      var bpS = loft('beam', PE.BEAM, 'beam-' + (sx < 0 ? 'l' : 'r'), [sx * hx, 0, 0], Z, UP, -hp, hp, [[-big, yS(-big)], [big, yS(big)], [big, yS(big) + p], [-big, yS(-big) + p]],
                     [{ m: [sx, 0, -1], d: hx - hz }, { m: [sx, 0, 1], d: hx - hz }]);
      bpS.len = ceil2((bpS.uMax - bpS.uMin) * Math.sqrt(1 + tf * tf));
      beamPcs.push(bpS);
    }
    for (var sz = -1; sz <= 1 && !flatB; sz += 2) {
      var yFb = yS(sz * hz);
      var bpF = loft('beam', PE.BEAM, 'beam-' + (sz < 0 ? 'b' : 'f'), [0, 0, sz * hz], X, UP, -hp, hp, [[-big, yFb], [big, yFb], [big, yFb + p], [-big, yFb + p]],
                     [{ m: [-1, 0, sz], d: hz - hx }, { m: [1, 0, sz], d: hz - hx }]);
      bpF.len = ceil2(bpF.uMax - bpF.uMin);
      beamPcs.push(bpF);
    }
    posts.forEach(function (Pq) {
      var cx = Math.abs(Math.abs(Pq.x) - hx) < 1e-6, cz = Math.abs(Math.abs(Pq.z) - hz) < 1e-6, sgx = (Pq.x < 0) ? -1 : 1, sgz = (Pq.z < 0) ? -1 : 1, zz;
      if (cx && cz && flatB) {
        for (k = -1; k <= 1; k += 2) { zz = Pq.z + k * 0.04; scr('screw-beam', PE.BEAM_SCREW, [Pq.x, yS(zz) + p, zz], [0, -1, 0], len260); }   /* both into the side beam over it */
      } else if (cx && cz) {
        zz = sgz * (hz - 0.045); scr('screw-beam', PE.BEAM_SCREW, [Pq.x, yS(zz) + p, zz], [0, -1, 0], len260);
        scr('screw-beam', PE.BEAM_SCREW, [sgx * (hx - 0.045), yS(Pq.z) + p, Pq.z], [0, -1, 0], len260);
      } else if (cx) {
        for (k = -1; k <= 1; k += 2) { zz = Pq.z + k * 0.04; scr('screw-beam', PE.BEAM_SCREW, [Pq.x, yS(zz) + p, zz], [0, -1, 0], len260); }
      } else {
        for (k = -1; k <= 1; k += 2) scr('screw-beam', PE.BEAM_SCREW, [Pq.x + k * 0.04, yS(Pq.z) + p, Pq.z], [0, -1, 0], len260);
      }
    });
    /* THE TIES (gable, hip): a 6x6 across at every post between the side
       beams' corners, between the beams' inner faces; 2 x 8x260 through
       the beam into each end */
    var nTie = 0;
    if (roof !== 'flat') for (i = 1; i < nZ; i++) {
      var tz = zs[i];
      var tp = loft('tie', PE.TIE, 'tie-' + i, [0, 0, tz], X, UP, -hp, hp, [[-(hx - hp), yPT0], [hx - hp, yPT0], [hx - hp, yPT0 + p], [-(hx - hp), yPT0 + p]], null);
      tp.len = ceil2(2 * (hx - hp));
      nTie++;
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-tie', PE.TIE_SCREW, [sx * (hx + hp), yPT0 + p * (k ? 0.68 : 0.32), tz + (k ? 0.03 : -0.03)], [-sx, 0, 0], len260);
    }
    /* THE KNEE BRACES: in every side's plane from every post towards its
       neighbours -- the band +- half the 4x4's width about the 45 deg axis
       from (0, -a) to (a, 0) off the post's face and the beam's underside,
       cut plumb on the post and along the beam; 2 toe screws an end (as the
       arbor's) */
    var bk = b / 2 * Math.SQRT2, toe = PE.TOE, nBrace = 0, braceRun = 1e9;
    function braceSide(axisX, posU, crd, under, o, U) {
      var N = _vCross(U, UP), bay = (crd[crd.length - 1] - crd[0]) / (crd.length - 1);
      var ba = Math.min(_peU(s, 'BRACE'), Math.max(PE.BRACE_MIN, (bay - p) / 2 - PE.BRACE_CLR - bk));
      braceRun = Math.min(braceRun, ba);
      crd.forEach(function (c, ic) {
        [-1, 1].forEach(function (dI) {
          if ((dI < 0 && ic === 0) || (dI > 0 && ic === crd.length - 1)) return;
          var uf = c + dI * hp, yf = under(uf);
          var Wb = function (du, dv) { var uu = uf + dI * du; return [uu, ((dv === 0) ? under(uu) : yf + dv)]; };
          var prof = [Wb(0, -(ba + bk)), Wb(0, -(ba - bk)), Wb(ba - bk, 0), Wb(ba + bk, 0)];
          var bp = loft('brace', PE.BRACE_CODE, 'brace-' + posU + (ic + 1) + (dI < 0 ? 'a' : 'b'), o, U, UP, -b / 2, b / 2, prof, null);
          bp.len = ceil2((ba + bk) * Math.SQRT2);
          nBrace++;
          var pA = [uf + dI * toe, yf + toe - ba - bk], pB = [uf + dI * (ba + bk - toe), under(uf + dI * (ba + bk - toe)) - toe];
          for (var kk = -1; kk <= 1; kk += 2) {
            scr('screw-brace', PE.BRACE_SCREW, W3(o, U, UP, N, pA[0], pA[1], kk * PE.TOE_OFF), _vSc(U, -dI), len160);
            scr('screw-brace', PE.BRACE_SCREW, W3(o, U, UP, N, pB[0], pB[1], kk * PE.TOE_OFF), UP, len160);
          }
        });
      });
    }
    for (sx = -1; sx <= 1; sx += 2) braceSide(false, (sx < 0) ? 'l' : 'r', zs, yS, [sx * hx, 0, 0], Z);
    for (var sz = -1; sz <= 1; sz += 2) (function (sz2) { braceSide(true, (sz2 < 0) ? 'b' : 'f', xs, function () { return yS(sz2 * hz); }, [0, 0, sz2 * hz], X); })(sz);
    /* THE ROOF */
    var yBT = yPT0 + p, top = yS(hz) + p, roofA = 0, facets = [], capL = 0, nRaf = 0, nHip = 0, ridgeL = 0, rafSp = 0, pitch = 0;
    var al = PE.PITCH * Math.PI / 180, ta = Math.tan(al), ca = Math.cos(al), sa = Math.sin(al), seatScr = _peU(s, 'SEAT_SCREW'), lenSeat = us ? len200 : len260;
    var rd = P.rd, dv = rd / ca, seat = _peU(s, 'SEAT'), hap = dv - seat * ta, eave = _peU(s, 'EAVE'), xr = P.rgt / 2, rafPcs = [], ridgePc = null;
    if (roof === 'flat') {
      /* 2x8 rafters across on the side beams, past them by FLAT_OV; open:
         raked ends, <= OPEN_SP; covered: plumb ends, <= RAF_SP, on the
         sloping beams; an 8x260 down into each beam */
      var ov = _peU(s, 'FLAT_OV'), sp = cov ? _peU(s, 'RAF_SP') : _peU(s, 'OPEN_SP'), ha = W / 2 + ov, rk = cov ? 0 : PE.RAKE * fd;
      var zE = L / 2 - rw / 2, nR = Math.max(1, Math.ceil(2 * zE / sp - 1e-9));
      rafSp = 2 * zE / nR;
      for (i = 0; i <= nR; i++) {
        var zr = -zE + 2 * zE * i / nR, ySd = yS(zr) + p, yEb = (Math.abs(zr) > hz - hp + rw / 2 - 1e-9) ? yS(((zr < 0) ? -1 : 1) * hz) + p : -1e9;
        var y0r = Math.max(ySd, yEb), y1r = y0r + fd, onEnd = (yEb > ySd + 1e-6);   /* the back end of a falling roof: on the back beam */
        var rp = loft('frafter', PE.FRAFTER, 'rafter-' + (i + 1), [0, 0, zr], X, UP, -rw / 2, rw / 2, [[-ha, y1r], [ha, y1r], [ha - rk, y0r], [-ha + rk, y0r]], null);
        rp.len = ceil2(2 * ha);
        nRaf++;
        for (sx = -1; sx <= 1; sx += 2) scr('screw-frafter', PE.FRAF_SCREW, [onEnd ? sx * (hx - hp - 0.08) : sx * hx, y1r, zr], [0, -1, 0], len260);
      }
      top = yS(hz) + p + fd;
      if (cov) {
        var fa = Math.atan(tf);
        facets.push({ nu: [0, 0, -1], sa: Math.sin(fa), ca: Math.cos(fa), ta: tf, o: [0, yS(0) + p + fd, 0],
                      pts: [[-ha, yS(-L / 2) + p + fd, -L / 2], [ha, yS(-L / 2) + p + fd, -L / 2], [ha, yS(L / 2) + p + fd, L / 2], [-ha, yS(L / 2) + p + fd, L / 2]], tops: [], edges: [0, 1, 2, 3] });
      }
    } else if (roof === 'gable') {
      /* GABLE: the ridge along Z, the rafters' top plane yF(d) (d off the ridge's line) */
      pitch = PE.PITCH;
      var aO = W / 2, dE = aO + eave, yE = yBT + hap;
      var yF = function (d) { return yE + (aO - d) * ta; }, yRt = yF(xr);
      ridgePc = loft('ridge', PE.RIDGE, 'ridge', [0, 0, 0], Z, UP, -xr, xr, [[-LB, yRt - fd], [LB, yRt - fd], [LB, yRt], [-LB, yRt]], null);   /* v343 out to the rakes */
      ridgePc.len = ceil2(2 * LB);
      ridgeL = 2 * LB;
      var zEg = LB - rw / 2, spG = _peU(s, 'RAF_SP'), nRg = Math.max(1, Math.ceil(2 * zEg / spG - 1e-9)), lenRg = len100, dR = lenRg * sa - (xr - 0.006);
      rafSp = 2 * zEg / nRg;
      for (i = 0; i <= nRg; i++) for (sx = -1; sx <= 1; sx += 2) {
        var zg = -zEg + 2 * zEg * i / nRg, Ug = [sx, 0, 0];
        var profG = [[dE, yF(dE) - dv], [dE, yF(dE)], [xr, yF(xr)], [xr, yF(xr) - dv], [aO - seat, yBT], [aO, yBT], [aO, yF(aO) - dv]];
        var rg = loft('rafter', PE.RAFTER, 'rafter-' + (i + 1) + (sx < 0 ? 'l' : 'r'), [0, 0, zg], Ug, UP, -rw / 2, rw / 2, profG, null);
        rg.len = ceil2((dE - xr) / ca);
        rafPcs.push(rg);
        nRaf++;
        scr('screw-seat', seatScr, [sx * (aO - seat / 2), yF(aO - seat / 2), zg - rw / 4], [0, -1, 0], lenSeat);
        for (k = -1; k <= 1; k += 2) scr('screw-ridge', PE.RIDGE_SCREW, [sx * (xr + dR), yRt - dR * ta, zg + k * rw / 4], [-sx * sa, -ca, 0], lenRg);
      }
      top = yRt + 0.005;
      for (sx = -1; sx <= 1; sx += 2) {
        facets.push({ nu: [sx, 0, 0], sa: sa, ca: ca, ta: ta, o: [0, yF(0), 0],
                      pts: [[sx * dE, yF(dE), -LB], [sx * dE, yF(dE), LB], [0, yF(0), LB], [0, yF(0), -LB]], tops: [[2, 3]], edges: [0, 1, 3] });   /* v343 out to the rakes */
      }
      capL = 2 * LB;
    } else {
      /* HIP: the ridge along the longer side (a, its half A at the plates'
         outer faces; c across, B), r0 = A - B its half length (0: the
         square -- a short block); in world: swap = the ridge along X */
      pitch = PE.PITCH;
      var swap = (W > L + 1e-9), A = (swap ? W : L) / 2, B = (swap ? L : W) / 2, r0 = A - B;
      var ea = swap ? X : Z, ec = swap ? Z : X;
      var wp = function (a, y, c) { return swap ? [a, y, c] : [c, y, a]; };
      var yE2 = yBT + hap, yFh = function (d) { return yE2 + (B - d) * ta; }, yFe = function (d) { return yE2 + (A - d) * ta; };
      var eR = xr + rw * 0.71 + 0.01, rL = r0 + eR, yRh = yFh(xr), spH = _peU(s, 'RAF_SP');
      /* the ridge, its ends cut by the end planes */
      ridgePc = loft('ridge', PE.RIDGE, 'ridge', [0, 0, 0], ea, UP, -xr, xr, [[-rL, yRh - fd], [rL, yRh - fd], [rL, yRh], [-rL, yRh]],
                     [{ m: _vAdd(_vSc(UP, -1), _vSc(ea, -ta)), d: -(yE2 + A * ta) }, { m: _vAdd(_vSc(UP, -1), _vSc(ea, ta)), d: -(yE2 + A * ta) }]);
      ridgePc.len = ceil2(2 * rL);
      ridgeL = 2 * r0;
      /* the hips: in the vertical plane of each corner's diagonal, their top dropped so their edges lie in the planes */
      var cpn = Math.SQRT1_2, tbH = cpn * ta, dvh = rd * Math.sqrt(1 + tbH * tbH), drop = rw / 2 * cpn * ta;
      var yHt = function (rho) { return yFh(rho * cpn) - drop; }, yHb = function (rho) { return yHt(rho) - dvh; };
      var hips = {}, rhoO = B / cpn, rhoE = (B + eave) / cpn, nhH = yBT - yHb(rhoO), rhoS = rhoO - Math.max(0, nhH) / tbH, lenHip = len160b;
      for (var sA = -1; sA <= 1; sA += 2) for (var sC = -1; sC <= 1; sC += 2) {
        var P0 = wp(sA * r0, 0, 0), Uh = _vNorm(_vAdd(_vSc(ea, sA), _vSc(ec, sC)));
        var profH = (nhH > 0) ? [[rhoE, yHb(rhoE)], [rhoE, yHt(rhoE)], [0, yHt(0)], [0, yHb(0)], [rhoS, yBT], [rhoO, yBT], [rhoO, yHb(rhoO)]]
                              : [[rhoE, yHb(rhoE)], [rhoE, yHt(rhoE)], [0, yHt(0)], [0, yHb(0)]];
        /* the end against the ridge's side (c >= xr); on the square also against the other hip (a >= 0) -- two cuts, so the hip in two lofts split where the cuts swap (each exact) */
        var hipId = 'hip-' + (sA < 0 ? 'a' : 'b') + (sC < 0 ? 'l' : 'r'), plC = { m: _vSc(ec, sC), d: xr }, hpc, hpcS = null;
        if (r0 > 0.02) hpc = loft('hip', PE.RAFTER, hipId, P0, Uh, UP, -rw / 2, rw / 2, profH, [plC]);
        else {
          var kS = sC * sA, nSt = -kS * xr / (2 * cpn);
          hpc = loft('hip', PE.RAFTER, hipId, P0, Uh, UP, (kS > 0) ? nSt : -rw / 2, (kS > 0) ? rw / 2 : nSt, profH, [plC]);
          hpcS = loft('hip', null, hipId + '-cut', P0, Uh, UP, (kS > 0) ? -rw / 2 : nSt, (kS > 0) ? nSt : rw / 2, profH, [{ m: _vSc(ea, sA), d: r0 }]);
        }
        hpc.len = ceil2((rhoE - hpc.uMin) * Math.sqrt(1 + tbH * tbH));
        hips[sA + ',' + sC] = { pc: hpc, pcS: hpcS, P0: P0, Uh: Uh, nH: _vNorm(_vAdd(_vSc(ea, sA), _vSc(ec, -sC))) };
        nHip++;
        capL += (rhoE - 0) * Math.sqrt(1 + tbH * tbH);
        var rm = (rhoS + rhoO) / 2;
        if (nhH > 0) scr('screw-seat', seatScr, _vAdd(_vAdd(P0, _vSc(Uh, rm)), [0, yHt(rm), 0]), [0, -1, 0], lenSeat);
        /* 2 screws from the ridge's far face along the hip into it */
        var rho1 = xr / cpn, H1 = _vAdd(P0, _vSc(Uh, rho1)), tBack = 2 * xr / cpn;
        for (k = 0; k < 2; k++) {
          var yh = (yHt(rho1) + yHb(rho1)) / 2 + (k ? 0.2 : -0.2) * dvh * 0.5;
          var Sh = _vAdd([H1[0], yh, H1[2]], _vSc(Uh, -tBack + 0.002));
          scr('screw-hip', PE.HIP_SCREW, Sh, Uh, lenHip);
        }
      }
      capL += ridgeL;
      /* the commons / jacks on the long sides (d = |c|), the king + jacks on the ends (d = |a|) */
      var hipPcsAll = Object.keys(hips).map(function (kk) { return hips[kk].pc; });
      var jkScr = _peU(s, 'JACK_SCREW'), lenJk = us ? len100 : len120, lenRg2 = len100, dR2 = lenRg2 * sa - (xr - 0.006);
      var rafter = function (id, o, U, Aout, dInner, planes, hipK, sign) {
        var yP = function (d) { return yE2 + (Aout - d) * ta; }, dEo = Aout + eave;
        var profR = [[dEo, yP(dEo) - dv], [dEo, yP(dEo)], [dInner, yP(dInner)], [dInner, yP(dInner) - dv], [Aout - seat, yBT], [Aout, yBT], [Aout, yP(Aout) - dv]];
        var rpc = loft('rafter', PE.RAFTER, id, o, U, UP, -rw / 2, rw / 2, profR, planes);
        if (!rpc) return null;
        rpc.len = ceil2((dEo - rpc.uMin) / ca);
        rafPcs.push(rpc);
        nRaf++;
        var N = rpc.N, dm = Aout - seat / 2;
        scr('screw-seat', seatScr, _vAdd(_vAdd(o, _vSc(U, dm)), [0, yP(dm), -0]).map(function (v, i5) { return v + N[i5] * (-rw / 4); }), [0, -1, 0], lenSeat);
        if (!hipK || rpc.uMin <= dInner + 0.002) {
          /* it reaches the ridge (its side or its end): 2 screws from its top into it */
          for (var k5 = -1; k5 <= 1; k5 += 2) {
            var dd = dInner + dR2;
            scr('screw-ridge', PE.RIDGE_SCREW, _vAdd(_vAdd(_vAdd(o, _vSc(U, dd)), [0, yP(dd), 0]), _vSc(N, k5 * rw / 4)), _vAdd(_vSc(U, -sa), [0, -ca, 0]), lenRg2);
          }
        } else {
          /* a jack: 2 toe screws from its side into the hip -- the tip in the hip's middle plane, the head on its face (the side that keeps the shank in the wood) */
          var H = hips[hipK], dC = (Math.min.apply(null, rpc.A.map(function (Pt) { return Pt[0]; })) + Math.min.apply(null, rpc.B.map(function (Pt) { return Pt[0]; }))) / 2;
          var Pend = _vAdd(o, _vSc(U, dC)), sgA = Math.min(0.95, (rw / 2) * (1 + cpn) / lenJk), aJ = Math.asin(sgA);
          var Ttip = _vAdd(Pend, _vSc(H.nH, -sign * rw / 2));
          var rhoT = _vDot(_vAdd(Ttip, _vSc(H.P0, -1)), H.Uh);
          for (var j5 = 0; j5 < 2; j5++) {
            var yTip = yHt(rhoT) - dvh * (j5 ? 0.62 : 0.32), done = false;
            [1, -1].forEach(function (sideS) {
              if (done) return;
              var dirJ = _vAdd(_vSc(U, -Math.cos(aJ)), _vSc(N, sideS * Math.sin(aJ)));
              var Sst = _vAdd([Ttip[0], yTip, Ttip[2]], _vSc(dirJ, -lenJk));
              if (inWood(Sst, dirJ, lenJk, [rpc, H.pc].concat(H.pcS ? [H.pcS] : []))) { scr('screw-jack', jkScr, Sst, dirJ, lenJk); done = true; }
            });
          }
        }
        return rpc;
      };
      /* the long sides */
      var mJk = Math.max(1, Math.ceil(A / spH - 0.5 - 1e-9)), gJ = A / (mJk + 0.5);
      rafSp = gJ;
      for (sC = -1; sC <= 1; sC += 2) for (i = 1; i <= mJk; i++) for (q = -1; q <= 1; q += 2) {
        var e = q * (i - 0.5) * gJ, sAe = (e < 0) ? -1 : 1, Hk = hips[sAe + ',' + sC];
        /* keep -nH.(P - P0) >= rw/2 (this side of the hip) */
        var mPl = _vSc(Hk.nH, -1), plJ = { m: mPl, d: rw / 2 + _vDot(mPl, Hk.P0) };
        var isJack = (Math.abs(e) > r0 - rw);
        rafter('rafter-' + (sC < 0 ? 'l' : 'r') + (q < 0 ? 'a' : 'b') + i, wp(e, 0, 0), _vSc(ec, sC), B, xr, [plJ], isJack ? (sAe + ',' + sC) : null, -1);
      }
      /* the ends: the king rafter against the ridge's end, jacks either side */
      var mE = Math.max(1, Math.ceil(B / spH - 1e-9)), gE = B / mE;
      for (sA = -1; sA <= 1; sA += 2) for (j = -(mE - 1); j <= mE - 1; j++) {
        var cj = j * gE;
        if (j === 0) { rafter('rafter-' + (sA < 0 ? 'a' : 'b') + '0', wp(0, 0, 0), _vSc(ea, sA), A, rL, null, null, 0); continue; }
        var sCj = (cj < 0) ? -1 : 1, Hj = hips[sA + ',' + sCj], plE = { m: Hj.nH, d: rw / 2 + _vDot(Hj.nH, Hj.P0) };
        rafter('rafter-' + (sA < 0 ? 'a' : 'b') + (j < 0 ? 'l' : 'r') + Math.abs(j), wp(0, 0, cj), _vSc(ea, sA), A, rL, [plE], sA + ',' + sCj, 1);
      }
      top = yRh + 0.005;
      /* the facets: the long sides (trapezoids), the ends (triangles) */
      var yLo = yE2 - eave * ta, apexY = yE2 + B * ta;
      for (sC = -1; sC <= 1; sC += 2) {
        var ptsL = [wp(-(A + eave), yLo, sC * (B + eave)), wp(A + eave, yLo, sC * (B + eave)), wp(r0, apexY, 0), wp(-r0, apexY, 0)];
        if (r0 < 1e-6) ptsL.pop();
        facets.push({ nu: _vSc(ec, sC), sa: sa, ca: ca, ta: ta, o: wp(0, apexY, 0), pts: ptsL, tops: (r0 < 1e-6) ? [[1, 2], [2, 0]] : [[1, 2], [2, 3], [3, 0]], edges: [0] });
      }
      for (sA = -1; sA <= 1; sA += 2) {
        facets.push({ nu: _vSc(ea, sA), sa: sa, ca: ca, ta: ta, o: wp(sA * r0, apexY, 0),
                      pts: [wp(sA * (A + eave), yLo, -(B + eave)), wp(sA * (A + eave), yLo, B + eave), wp(sA * r0, apexY, 0)], tops: [[1, 2], [2, 0]], edges: [0] });
      }
    }
    /* THE COVERING (on): in each facet's plane (U along the eave, V up
       the slope, N out) -- the boards, the pans, their seams, the caps over
       the ridge / hips, the drip edge round the eaves and rakes */
    var rbT = P.rb, shT = PE.SEAM_T, seamPan = _peU(s, 'SEAM_PAN'), nSeam = 0, dripL = 0, nCap = 0, capScrews = 0;
    if (cov) facets.forEach(function (F, iF) {
      var N = _vNorm(_vAdd(_vSc(F.nu, F.sa), _vSc(UP, F.ca))), Vf = _vNorm(_vAdd(_vSc(F.nu, -F.ca), _vSc(UP, F.sa))), Uf = _vCross(Vf, N);
      var toUV = function (P3) { var dd = [P3[0] - F.o[0], P3[1] - F.o[1], P3[2] - F.o[2]]; return [_vDot(dd, Uf), _vDot(dd, Vf)]; };
      var poly = F.pts.map(toUV), polyC = (_gzArea(poly) < 0) ? poly.slice().reverse() : poly;
      var inP2 = function (pl, u, v) { var c2 = false, i3, j3; for (i3 = 0, j3 = pl.length - 1; i3 < pl.length; j3 = i3++) { var xi = pl[i3][0], yi = pl[i3][1], xj = pl[j3][0], yj = pl[j3][1]; if (((yi > v) !== (yj > v)) && (u < (xj - xi) * (v - yi) / (yj - yi) + xi)) c2 = !c2; } return c2; };
      var lift = function (pl, h) { return pl.map(function (Pt) { return [Pt[0], Pt[1] + h * F.ta]; }); };
      roofA += Math.abs(_gzArea(polyC));
      var mk = function (kind, id, A3, B3, n0, n1) {
        var pc3 = { kind: kind, code: null, len: 0, id: id, o: F.o, U: Uf, V: Vf, N: N, nA: n0, nB: n1, A: A3, B: B3, roof: true };
        if (_gzArea(pc3.A) < 0) { pc3.A = pc3.A.slice().reverse(); pc3.B = pc3.B.slice().reverse(); }
        pieces.push(pc3);
        return pc3;
      };
      mk('rboard', 'roof-boards-' + (iF + 1), polyC, lift(polyC, rbT), 0, rbT);
      mk('cover', 'cover-' + (iF + 1), lift(polyC, rbT), lift(polyC, rbT + shT), rbT, rbT + shT);
      /* the seams up the slope every pan, cut by the facet */
      var uLo = Math.min.apply(null, polyC.map(function (Pt) { return Pt[0]; })), uHi = Math.max.apply(null, polyC.map(function (Pt) { return Pt[0]; })), sW = PE.SEAM_W;
      for (var uS = Math.ceil(uLo / seamPan) * seamPan; uS <= uHi + 1e-9; uS += seamPan) {
        var bandS = [[uS - sW / 2, -50], [uS + sW / 2, -50], [uS + sW / 2, 50], [uS - sW / 2, 50]];
        for (var e5 = 0; e5 < polyC.length; e5++) {
          var P5 = polyC[e5], Q5 = polyC[(e5 + 1) % polyC.length], ex5 = Q5[0] - P5[0], ey5 = Q5[1] - P5[1];
          bandS = _gzClip(bandS, -ey5, ex5, ey5 * P5[0] - ex5 * P5[1]);
        }
        if (bandS.length < 3 || Math.abs(_gzArea(bandS)) < 1e-5) continue;
        mk('seam', 'seam-' + (iF + 1) + '-' + (++nSeam), lift(bandS, rbT + shT), lift(bandS, rbT + shT + PE.SEAM_H), rbT + shT, rbT + shT + PE.SEAM_H);
      }
      /* the caps: a band along each top edge (ridge / hip), into the facet, over the seams */
      var h0 = rbT + shT + PE.SEAM_H, cw = PE.CAP_W;
      F.tops.forEach(function (ed, ie) {
        var a4 = poly[ed[0]], b4 = poly[ed[1]], ex4 = b4[0] - a4[0], ey4 = b4[1] - a4[1], l4 = Math.hypot(ex4, ey4), nx4 = -ey4 / l4, ny4 = ex4 / l4;
        if (!inP2(polyC, (a4[0] + b4[0]) / 2 + nx4 * 0.02, (a4[1] + b4[1]) / 2 + ny4 * 0.02)) { nx4 = -nx4; ny4 = -ny4; }   /* into the facet */
        var band = [[a4[0] - nx4 * 0.004, a4[1] - ny4 * 0.004], [b4[0] - nx4 * 0.004, b4[1] - ny4 * 0.004], [b4[0] + nx4 * cw, b4[1] + ny4 * cw], [a4[0] + nx4 * cw, a4[1] + ny4 * cw]];
        mk('cap', 'cap-' + (iF + 1) + '-' + (ie + 1), lift(band, h0), lift(band, h0 + PE.CAP_T), h0, h0 + PE.CAP_T);
        nCap++;
      });
      /* the drip edge: a strip on the boards' edge along each eave / rake (U the edge, V up square to it, N out) */
      F.edges.forEach(function (ei) {
        var Pa = F.pts[ei], Pb = F.pts[(ei + 1) % F.pts.length], ue = _vNorm([Pb[0] - Pa[0], Pb[1] - Pa[1], Pb[2] - Pa[2]]), lE = Math.hypot(Pb[0] - Pa[0], Pb[1] - Pa[1], Pb[2] - Pa[2]);
        var ve = _vNorm(_vAdd(UP, _vSc(ue, -_vDot(UP, ue)))), ne = _vCross(ue, ve), mid = [(Pa[0] + Pb[0]) / 2, 0, (Pa[2] + Pb[2]) / 2];
        var outw = (_vDot(ne, _vAdd(mid, [-F.o[0], 0, -F.o[2]])) < 0) ? -1 : 1;   /* N pointing out of the roof */
        var od = _vAdd(Pa, _vSc(ne, outw * 0.0015));
        loft('drip', null, 'drip-' + (iF + 1) + '-' + (ei + 1), od, ue, ve, (outw > 0) ? 0 : -0.0012, (outw > 0) ? 0.0012 : 0, [[0, -0.03], [lE, -0.03], [lE, rbT / F.ca + 0.004], [0, rbT / F.ca + 0.004]], null, { roof: true });
        dripL += lE;
      });
    });
    if (cov && roof !== 'flat') capScrews = 2 * (Math.ceil(capL / PE.SEAM_CAP_SP - 1e-9) + nCap);
    if (cov) top = Math.max(top, facets.reduce(function (mx, F) { return Math.max(mx, Math.max.apply(null, F.pts.map(function (P3) { return P3[1]; }))); }, 0) + (rbT + shT + PE.SEAM_H + PE.CAP_T) / ((roof === 'flat') ? 1 : ca));
    /* THE INFILL: the fields between the posts on each side (the "+"
       buttons) -- t is the viewer's right standing outside the side, u the
       side's axis, n the loft's normal (sN: out) */
    var sides = [
      { key: 'f', ax: 'x', crd: xs, pos: L / 2, t: 1, sN: 1, U: X, o: [0, 0, 0], under: function () { return yS(hz); } },
      { key: 'b', ax: 'x', crd: xs, pos: -L / 2, t: -1, sN: -1, U: X, o: [0, 0, 0], under: function () { return yS(-hz); } },
      { key: 'r', ax: 'z', crd: zs, pos: W / 2, t: -1, sN: -1, U: Z, o: [0, 0, 0], under: yS },
      { key: 'l', ax: 'z', crd: zs, pos: -W / 2, t: 1, sN: 1, U: Z, o: [0, 0, 0], under: yS }
    ];
    var FM = _peFields(s), gapS = _peGap(s), latP = sh + gapS, yB = Math.max(_peU(s, 'FILL_Y0'), yPB + 0.03), nStile = 0, nFillPc = 0, nRail = 0, railT = P.railT, railH = P.railH;   /* v337 the gap on the slider (the trellis: its openings); the infill at least 3 cm over the posts' feet (a rail's lower screws in the post on the footings) */
    sides.forEach(function (SD) {
      var N = _vCross(SD.U, UP), n0 = (SD.ax === 'x') ? SD.pos : -SD.pos, sN = SD.sN, crd = SD.crd, nF = crd.length - 1;
      var band = function (k2) { var a2 = n0 + sN * k2 * st, b3 = n0 + sN * (k2 + 1) * st; return [Math.min(a2, b3), Math.max(a2, b3)]; };   /* k2 = 0: layer 1, 1: layer 2, -1: the stile */
      for (var fI = 0; fI < nF; fI++) {
        /* v336 (Marek 22:11: vyplne vzdy pres cele pole): a field is empty or full (an older half = full) */
        var c0 = crd[fI], c1 = crd[fI + 1], mid = (c0 + c1) / 2, idx = (SD.t > 0) ? fI + 1 : nF - fI, id = SD.key + idx, stt = FM[id] ? 1 : 0;
        /* v337 (Marek 22:56: terciky plus nechat na podlaze, jako u shelters): its + / - disc on the ground at the field's middle, DOT_OUT out from the posts' outer faces */
        var oP3 = ((SD.pos > 0) ? 1 : -1) * PE.DOT_OUT;
        var bp3 = (SD.ax === 'x') ? [mid, 0.03, SD.pos + oP3] : [SD.pos + oP3, 0.03, mid];
        fields.push({ id: id, side: SD.key, state: stt, at: bp3 });
        if (!stt) continue;
        /* v338 (Marek 23:22: slats / profily by mely byt az na vnejsi roh
           nohy daneho pole): the members run on over the field's posts to
           their far edges (the corner on a corner post); where the next field
           of the side is filled too the two meet at the post's middle */
        var fPrev = (fI > 0) && !!FM[SD.key + ((SD.t > 0) ? fI : nF - fI + 1)], fNext = (fI < nF - 1) && !!FM[SD.key + ((SD.t > 0) ? fI + 2 : nF - fI - 1)];
        var u0 = fPrev ? c0 : c0 - hp, u1 = fNext ? c1 : c1 + hp;
        var yT = Math.min(SD.under(u0), SD.under(u1));
        var sup = [{ u: c0 + 0.035, post: true }, { u: c1 - 0.035, post: true }];
        /* v338 (Marek 23:21: U vertical slats mas navic jednu vyztuhu take
           svislou na vnitrni strane - podle me je zbytecna (i u trellis ...).
           Mozna spise na vysku pridat jeste jeden horizontalni profil - v
           zavislosti na hustote ... Plati pak i u horizontalnich): the STILES
           only behind level members that hang between the posts (horizontal
           slats, slats + trellis, X + trellis), as many as the density asks --
           STILE_SPAN 1.50 at the 40 mm gap's density (0.6), shorter as the
           slats close up (x 0.6 / density, down to half); none behind
           vertical slats or the trellis */
        var dens = sh / (sh + gapS), kD = Math.max(0.5, Math.min(1, 0.6 / dens));
        var nSt = (fT === 'h' || fT === 'hlat' || fT === 'xlat') ? Math.max(0, Math.ceil((c1 - c0 - p) / (PE.STILE_SPAN * kD) - 1e-9) - 1) : 0;
        var stU = [], jS;
        for (jS = 1; jS <= nSt; jS++) {
          var uS = c0 + (c1 - c0) * jS / (nSt + 1), bS = band(-1), ySt = SD.under;
          var stilePc = loft('stile', PE.SLAT, 'stile-' + id + ((nSt > 1) ? '-' + jS : ''), SD.o, SD.U, UP, bS[0], bS[1], [[uS - sh / 2, yB], [uS + sh / 2, yB], [uS + sh / 2, ySt(uS + sh / 2)], [uS - sh / 2, ySt(uS - sh / 2)]], null);
          stilePc.len = ceil2(ySt(uS) - yB);
          nStile++;
          for (var sS = -1; sS <= 1; sS += 2) {
            var aT = 35 * Math.PI / 180, uSt = uS + sS * sh / 2, ySt0 = Math.min(ySt(uS - sh / 2), ySt(uS + sh / 2)) - 0.06;
            scr('screw-stile', PE.STILE_SCREW, W3(SD.o, SD.U, UP, N, uSt, ySt0, (bS[0] + bS[1]) / 2), _vAdd(_vSc(SD.U, -sS * Math.sin(aT)), _vSc(UP, Math.cos(aT))), len100);
          }
          sup.push({ u: uS, post: false });
          stU.push(uS);
        }
        var l1 = band(0), l2 = band(1);
        var hor = function (y0, y1, tag) {   /* a horizontal member in layer 1 and its screws into the supports */
          var hp2 = loft('fill1', PE.SLAT, 'fill-' + id + '-' + tag, SD.o, SD.U, UP, l1[0], l1[1], [[u0, y0], [u1, y0], [u1, y1], [u0, y1]], null);
          hp2.len = ceil2(u1 - u0);
          nFillPc++;
          sup.forEach(function (S2) {
            var nOut = (sN > 0) ? l1[1] : l1[0];
            scr('screw-fill', S2.post ? PE.FILL_POST_SCREW : PE.FILL_SCREW, W3(SD.o, SD.U, UP, N, S2.u, (y0 + y1) / 2, nOut), _vSc(N, -sN), S2.post ? len90 : len70, 0.0025);
          });
          return (y0 + y1) / 2;
        };
        /* v337 the vertical slats stand on the rails (layer 2 = past the rail's thickness) */
        if (fT === 'v') { var aV = n0 + sN * railT, bV = n0 + sN * (railT + st); l2 = [Math.min(aV, bV), Math.max(aV, bV)]; }
        var ver = function (uc, ys2, tag, yb0) {   /* a vertical member in layer 2 (from yb0, else the infill's foot), a screw into every horizontal it crosses */
          var yTop = SD.under(uc), yBot = (yb0 != null) ? yb0 : yB;
          var vp = loft('fill2', PE.SLAT, 'fill-' + id + '-' + tag, SD.o, SD.U, UP, l2[0], l2[1], [[uc - sh / 2, yBot], [uc + sh / 2, yBot], [uc + sh / 2, yTop], [uc - sh / 2, yTop]], null);
          vp.len = ceil2(yTop - yBot);
          nFillPc++;
          var nOut2 = (sN > 0) ? l2[1] : l2[0];
          ys2.forEach(function (yc) { scr('screw-fill2', PE.FILL_SCREW, W3(SD.o, SD.U, UP, N, uc, yc, nOut2), _vSc(N, -sN), len70, 0.0025); });
        };
        /* v337 (Marek 22:56: Kdyz jsou vertikalni, tak musi byt horizontalni
           nosne profily - okopiruj to jak to mame v shelters): the shelter's
           LEVEL RAILS -- POST_WALL.rail KVH10060 (US 2x4) laid flat on the
           posts' outer faces, one at the foot, one at the head and one every
           <= RAIL_STEP 1.20 m (US 4 ft) between, evenly (the shelter's yR) --
           v338 the step shorter as the slats close up (x 0.6 / density, down
           to half: more rails under a denser, heavier screen); 2 x 6.5x90
           FAS65090 a post */
        var rbR = [Math.min(n0, n0 + sN * railT), Math.max(n0, n0 + sN * railT)];
        var rail = function (yc, tag) {
          var rp = loft('rail', PE.RAIL, 'rail-' + id + '-' + tag, SD.o, SD.U, UP, rbR[0], rbR[1], [[u0, yc - railH / 2], [u1, yc - railH / 2], [u1, yc + railH / 2], [u0, yc + railH / 2]], null);
          rp.len = ceil2(u1 - u0);
          nRail++;
          var nOutR = (sN > 0) ? rbR[1] : rbR[0];
          sup.forEach(function (S2) {
            for (var kR = -1; kR <= 1; kR += 2) {
              var stUs = !S2.post && us;
              scr('screw-rail', stUs ? PE.FILL_SCREW : PE.FILL_POST_SCREW, W3(SD.o, SD.U, UP, N, S2.u, yc + kR * railH / 4, nOutR), _vSc(N, -sN), stUs ? len70 : len90, 0.0025);
            }
          });
          return yc;
        };
        /* v338 X + TRELLIS: a pair of X braces in a panel -- brace A in layer 1
           between the rails (rail centre to rail centre, its ends on the post
           / stile: 6.5x90 FAS65090 into a post, 4.5x70 FAS45070 into a stile),
           brace B in layer 2 over both rails (a 4.5x70 into each rail and one
           through A at the crossing); both 40x60 KVH40060 billed by their
           length along the axis */
        var cen = function (P0) { var a = 0, cx = 0, cy = 0, iC; for (iC = 0; iC < P0.length; iC++) { var q1 = P0[iC], q2 = P0[(iC + 1) % P0.length], cr = q1[0] * q2[1] - q2[0] * q1[1]; a += cr; cx += (q1[0] + q2[0]) * cr; cy += (q1[1] + q2[1]) * cr; } return (Math.abs(a) < 1e-9) ? null : { a: Math.abs(a / 2), u: cx / (3 * a), v: cy / (3 * a) }; };
        var clipBox = function (P0, ua, ub, va, vb) { var Q = _gzClip(P0, 1, 0, -ua); Q = _gzClip(Q, -1, 0, ub); Q = _gzClip(Q, 0, 1, -va); return _gzClip(Q, 0, -1, vb); };
        var strip = function (pa, pb) { var du = pb[0] - pa[0], dv = pb[1] - pa[1], dl = Math.sqrt(du * du + dv * dv), eu = du / dl, ev = dv / dl, nu = -ev * sh / 2, nv = eu * sh / 2, ex = 0.30;
          return { e: [eu, ev], P: [[pa[0] - eu * ex + nu, pa[1] - ev * ex + nv], [pa[0] - eu * ex - nu, pa[1] - ev * ex - nv], [pb[0] + eu * ex - nu, pb[1] + ev * ex - nv], [pb[0] + eu * ex + nu, pb[1] + ev * ex + nv]] }; };
        var lenOn = function (P0, e) { var lo = 1e9, hi = -1e9; P0.forEach(function (q) { var d = q[0] * e[0] + q[1] * e[1]; lo = Math.min(lo, d); hi = Math.max(hi, d); }); return hi - lo; };
        var supAt = function (uc) {   /* the support under a panel end: a post (its face) or a stile */
          var isPost = Math.abs(uc - u0) < 1e-6 || Math.abs(uc - u1) < 1e-6, cP = (Math.abs(uc - u0) < 1e-6) ? c0 : c1;
          return isPost ? { a: cP - hp + 0.012, b: cP + hp - 0.012, post: true } : { a: uc - sh / 2 + 0.006, b: uc + sh / 2 - 0.006, post: false };
        };
        var xPair = function (ua, ub, yRb, yRm, tag) {
          var yb1 = yRb + sh / 2, yt1 = yRm - sh / 2;
          var sA = strip([ua, yRb], [ub, yRm]), PA = clipBox(sA.P, ua, ub, yb1, yt1);
          var sB = strip([ua, yRm], [ub, yRb]), PB = clipBox(sB.P, ua, ub, yRb - sh / 2, yRm + sh / 2);
          if (PA.length < 3 || PB.length < 3) return;
          var pA = loft('xbrace', PE.SLAT, 'xbrace-' + id + '-' + tag + 'a', SD.o, SD.U, UP, l1[0], l1[1], PA, null);
          var pB = loft('xbrace', PE.SLAT, 'xbrace-' + id + '-' + tag + 'b', SD.o, SD.U, UP, l2[0], l2[1], PB, null);
          if (!pA || !pB) return;
          pA.len = ceil2(lenOn(PA, sA.e)); pB.len = ceil2(lenOn(PB, sB.e));
          nFillPc += 2;
          var o1 = (sN > 0) ? l1[1] : l1[0], o2 = (sN > 0) ? l2[1] : l2[0];
          [supAt(ua), supAt(ub)].forEach(function (S3) {   /* A's ends into the post / the stile (half the stile's face is this panel's: a small wedge, still a screw) */
            var c3 = cen(clipBox(PA, S3.a, S3.b, -1e3, 1e3));
            if (c3 && c3.a > 1.5e-4) scr('screw-xbrace', S3.post ? PE.FILL_POST_SCREW : PE.FILL_SCREW, W3(SD.o, SD.U, UP, N, c3.u, c3.v, o1), _vSc(N, -sN), S3.post ? len90 : len70, 0.0025);
          });
          [[yRb - sh / 2 + 0.006, yb1 - 0.006], [yt1 + 0.006, yRm + sh / 2 - 0.006]].forEach(function (R3) {   /* B's ends into the rails */
            var c4 = cen(clipBox(PB, -1e3, 1e3, R3[0], R3[1]));
            if (c4 && c4.a > 4e-4) scr('screw-xbrace', PE.FILL_SCREW, W3(SD.o, SD.U, UP, N, c4.u, c4.v, o2), _vSc(N, -sN), len70, 0.0025);
          });
          scr('screw-xbrace', PE.FILL_SCREW, W3(SD.o, SD.U, UP, N, (ua + ub) / 2, (yRb + yRm) / 2, o2), _vSc(N, -sN), len70, 0.0025);   /* B into A at the crossing */
        };
        var hs = [], m2, kk2;
        if (fT === 'h') {
          m2 = Math.max(1, Math.floor((yT - yB + gapS) / (sh + gapS)));
          for (kk2 = 0; kk2 < m2; kk2++) { var yy = (m2 > 1) ? yB + (yT - yB - sh) * kk2 / (m2 - 1) : yB; hor(yy, yy + sh, 'h' + (kk2 + 1)); }
        } else if (fT === 'hlat') {
          /* v338 SLATS + TRELLIS (Marek's first photo): horizontal slats at the
             slider's gap up to a trellis band HLAT_BAND 0.60 m (US 2 ft) high
             under the beam, the band's openings LAT_GAP 90 mm (US 3 1/2 in.):
             its level laths in layer 1 (the top slat its lowest), its uprights
             in layer 2 from the top slat up, a screw at every crossing */
          var bandH = Math.min(_peU(s, 'HLAT_BAND'), (yT - yB) * 0.45), ySp = yT - bandH, lastC = 0;
          m2 = Math.max(1, Math.floor((ySp - yB + gapS) / (sh + gapS)));
          for (kk2 = 0; kk2 < m2; kk2++) { var yh = (m2 > 1) ? yB + (ySp - yB - sh) * kk2 / (m2 - 1) : ySp - sh; lastC = hor(yh, yh + sh, 'h' + (kk2 + 1)); }
          var yL0 = ySp - sh, PL = sh + _peU(s, 'LAT_GAP'), mL = Math.max(2, Math.round((yT - sh - yL0) / PL) + 1), hsL = [lastC];
          for (kk2 = 1; kk2 < mL; kk2++) { var yl2 = yL0 + (yT - sh - yL0) * kk2 / (mL - 1); hsL.push(hor(yl2, yl2 + sh, 't' + kk2)); }
          var mVL = Math.max(2, Math.round((u1 - u0 - sh) / PL) + 1);
          for (kk2 = 0; kk2 < mVL; kk2++) ver(u0 + sh / 2 + (u1 - u0 - sh) * kk2 / (mVL - 1), hsL, 'v' + (kk2 + 1), yL0);
        } else if (fT === 'xlat') {
          /* v338 X + TRELLIS (Marek's second photo): a bottom rail and a middle
             rail (its centre XRAIL_Y 0.90 m / US 3 ft up) in layer 1, an X in
             every panel between the field's ends and its stiles, the trellis
             over the middle rail (its openings the slider's gap): level laths
             in layer 1, uprights in layer 2 from the middle rail's top */
          var yMc = Math.max(yB + 2 * sh + 0.30, Math.min(yT - 0.40, _peU(s, 'XRAIL_Y'))), yRb = yB + sh / 2;
          hor(yB, yB + sh, 'rb');
          hor(yMc - sh / 2, yMc + sh / 2, 'rm');
          var yX0 = yMc - sh / 2, mX = Math.max(2, Math.round((yT - sh - yX0) / latP) + 1), hsX = [];
          for (kk2 = 1; kk2 < mX; kk2++) { var yx = yX0 + (yT - sh - yX0) * kk2 / (mX - 1); hsX.push(hor(yx, yx + sh, 't' + kk2)); }
          var mVX = Math.max(2, Math.round((u1 - u0 - sh) / latP) + 1);
          for (kk2 = 0; kk2 < mVX; kk2++) ver(u0 + sh / 2 + (u1 - u0 - sh) * kk2 / (mVX - 1), hsX, 'v' + (kk2 + 1), yMc + sh / 2);
          var cuts = [u0].concat(stU).concat([u1]);
          for (var pX = 0; pX + 1 < cuts.length; pX++) xPair(cuts[pX], cuts[pX + 1], yRb, yMc, 'p' + (pX + 1));
        } else {
          if (fT === 'v') {
            var rTot = yT - yB, nR = Math.max(2, Math.ceil(rTot / (_peU(s, 'RAIL_STEP') * kD) - 1e-9) + 1), gR = rTot / (nR - 1);
            for (kk2 = 0; kk2 < nR; kk2++) hs.push(rail(yB + Math.min(rTot - railH / 2, Math.max(railH / 2, kk2 * gR)), 'r' + (kk2 + 1)));
          }
          else {
            m2 = Math.max(2, Math.round((yT - yB - sh) / latP) + 1);
            for (kk2 = 0; kk2 < m2; kk2++) { var yl = yB + (yT - yB - sh) * kk2 / (m2 - 1); hs.push(hor(yl, yl + sh, 'h' + (kk2 + 1))); }
          }
          var pitchV = (fT === 'v') ? sh + gapS : latP, mV = Math.max(2, (fT === 'v') ? Math.floor((u1 - u0 + gapS) / (sh + gapS)) : Math.round((u1 - u0 - sh) / pitchV) + 1);
          for (kk2 = 0; kk2 < mV; kk2++) ver(u0 + sh / 2 + (u1 - u0 - sh) * kk2 / (mV - 1), hs, 'v' + (kk2 + 1));
        }
      }
    });
    /* the bill's quantities: timber by code, the coating (the timber's long faces, the roof boards' underside) */
    var SEC = {}, m = {}, coat = 0;
    SEC[PE.POST] = [p, p]; SEC[PE.BRACE_CODE] = [b, b]; SEC[PE.FRAFTER] = [rw, fd]; SEC[PE.RAFTER] = [rw, rd]; SEC[PE.SLAT] = [st, sh]; SEC[PE.RAIL] = [railT, railH];
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      var sec = SEC[pc.code] || [p, p];
      coat += 2 * (sec[0] + sec[1]) * pc.len;
    }
    coat += roofA;
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var ftW = _peU(s, 'FTG'), gvB = _peU(s, 'GRAVEL'), pW = _peU(s, 'PIER_W'), pD = _peU(s, 'PIER_D'), pG = _peU(s, 'PIER_GRAVEL');
    var fq = {
      blockN: blocks.length, pourN: pours.length,
      gravel: r3(blocks.length * ftW * ftW * gvB + pours.length * pW * pW * pG),
      dig: r3(pours.length * pW * pW * (pD + pG)),   /* v354 only the poured footings' holes: the precast footings' beds are dug by hand as they are set */
      concrete: r3(pours.length * pW * pW * (pD + yH)),
      rebar: Math.round(pours.length * 4 * (pD + yH - 2 * PE.BAR_COVER) * 100) / 100,
      geotex: Math.round(pours.length * pW * pW * 100) / 100
    };
    return {
      P: P, us: us, L: L, W: W, roof: roof, cov: cov, fillT: fT, found: found, pieces: pieces, fas: fas, gscrews: gscrews, bases: bases, blocks: blocks, pours: pours,
      posts: posts, xs: xs, zs: zs, fields: fields, fq: fq, anchors: nAnchor, ties: nTie, braces: nBrace, braceRun: braceRun, rafters: nRaf, hips: nHip, rafSp: rafSp, ridgeL: ridgeL, pitch: pitch,
      roofA: r3(roofA), seams: nSeam, capL: Math.round(capL * 100) / 100, capScrews: capScrews, dripL: Math.round(dripL * 100) / 100, dripFix: Math.ceil(dripL / PE.DRIP_FIX - 1e-9) + facets.length,
      stiles: nStile, fillPcs: nFillPc, rails: nRail, gap: gapS, meters: m, coat: coat, yH: yH, yPB: yPB, yPT: yPT0, yBT: yBT, fall: tf ? PE.FALL : 0,
      top: top, height: top, length: L, depth: W, missing: []
    };
  }
  /* its staged assembly (a step whose parts are not drawn drops out) */
  var _peStepsC = {}, _peFieldsLast = null;
  function _peSteps(s) {
    s = s || STATE;
    var fnd = _peFound(s), key = String(s.isMetric === false) + fnd;
    if (_peStepsC[key]) return _peStepsC[key];
    return (_peStepsC[key] = [
      { parts: [], codes: [] },
      { parts: ['pe-gscrew'], codes: [PE.GSCREW] },
      { parts: ['pe-block'], codes: [PE.GRAVEL_CODE, PE.FOOTING] },   /* v354 no FEE00001 */
      { parts: ['pe-pour'], codes: [PE.DIG, PE.GRAVEL_CODE, PE.GEOTEX, PE.FORMWORK, PE.REBAR, PE.CONCRETE] },
      { parts: ['pe-base', 'pe-hw-anchor'], codes: [(fnd === 'block') ? PE.PBASE : (fnd === 'pier') ? PE.HANCHOR : PE.UHEAD, PE.ANCHOR] },
      { parts: ['pe-post'], codes: [PE.POST] },
      { parts: ['pe-hw-nail'], codes: [PE.NAIL] },
      { parts: ['pe-beam', 'pe-hw-screw-beam'], codes: [PE.BEAM, PE.BEAM_SCREW] },
      { parts: ['pe-tie', 'pe-hw-screw-tie'], codes: [PE.TIE, PE.TIE_SCREW] },
      { parts: ['pe-brace', 'pe-hw-screw-brace'], codes: [PE.BRACE_CODE, PE.BRACE_SCREW] },
      { parts: ['pe-frafter', 'pe-hw-screw-frafter'], codes: [PE.FRAFTER, PE.FRAF_SCREW] },
      { parts: ['pe-ridge'], codes: [PE.RIDGE] },
      { parts: ['pe-hip', 'pe-hw-screw-hip'], codes: [PE.RAFTER, PE.HIP_SCREW] },
      { parts: ['pe-rafter', 'pe-hw-screw-seat', 'pe-hw-screw-ridge', 'pe-hw-screw-jack'], codes: [PE.RAFTER, _peU(s, 'SEAT_SCREW'), PE.RIDGE_SCREW, _peU(s, 'JACK_SCREW')] },
      { parts: ['pe-rboard'], codes: [PE.RBOARD, PE.RB_NAIL] },
      { parts: ['pe-cover', 'pe-seam', 'pe-drip'], codes: [PE.UNDERLAY, PE.SEAM, PE.SEAM_CLIP, PE.DRIP, PE.ROOF_NAIL] },
      { parts: ['pe-cap'], codes: [PE.CAP, PE.SEAM_SCREW] },
      { parts: ['pe-stile', 'pe-hw-screw-stile'], codes: [PE.SLAT, PE.STILE_SCREW] },
      { parts: ['pe-rail', 'pe-hw-screw-rail'], codes: [PE.RAIL, PE.FILL_POST_SCREW, PE.FILL_SCREW] },   /* v337 the level rails (vertical slats) */
      { parts: ['pe-fill1', 'pe-hw-screw-fill'], codes: [PE.SLAT, PE.FILL_POST_SCREW, PE.FILL_SCREW] },
      { parts: ['pe-xbrace', 'pe-hw-screw-xbrace'], codes: [PE.SLAT, PE.FILL_POST_SCREW, PE.FILL_SCREW] },   /* v338 X + trellis: the X braces */
      { parts: ['pe-fill2', 'pe-hw-screw-fill2'], codes: [PE.SLAT, PE.FILL_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v362 TYPE 26 -- PLAYHOUSES, variant 1: THE COTTAGE (Marek 2026-10-29
     14:11-14:18: "Udelame playhouses stejnym zpusobem jako swings. Ruzne
     provedeni, kombinace"; chose the swing engine, PLAYHOUSES the product,
     $20 a variant; the Cottage first -- the Stilt House is its body on posts).
     A kids' playhouse in the US DIY manner, every piece a catalogue item:
       - FOUNDATION: precast deck blocks FCO00012 on gravel FCO00001 under
         the two side rims, <= 1.20 m (US 4 ft) apart; with the porch its
         two posts stand in the front blocks' sockets;
       - FLOOR: 2x6 KVH60160 side rims along the length, 2x6 joists across
         at <= 40 cm (US 16 in.), two 6x160 FAS60160 through the rim into
         each end; the floor OSB25002 18 mm (US 23/32 in.) screwed FAS50060
         by rate;
       - WALLS 2x4 KVH10060 at <= 60 cm (US 24 in.) on 2x4 bottom plates,
         the floor's top to the plates' top 1.52 m (US 5 ft); the side walls
         carry a 4x6 KVH10160 beam as their top plate (it runs on over the
         porch to its post), the gable walls a 2x4 top plate; the door in
         the front gable (60 x 130, US 24 x 53 in., a 2x6 header on jacks),
         a window 46 x 46 (US 18 x 18 in.) in both side walls and the back
         gable, its sill 61 cm (US 24 in.) over the floor -- no glass (kids);
       - ROOF: 40 deg gable, 2x4 rafters at <= 60 cm (US 24 in.) with a
         birdsmouth on the beams, plumb against a 2x6 ridge board; a 2x4
         rafter tie at every pair but over the gable walls; the eaves 20 cm
         (US 8 in.) past the siding, fly rafters 15 cm (US 6 in.) past the
         gables; OSB25001 15 mm (US 5/8 in.), underlay ROR00008, asphalt
         shingle ROR00001 + cap shingles, drip edge ROM02401; 1x4 TIM20100
         fascia + rake boards;
       - SIDING: panel siding FCP00009 (T1-11 style) straight on the studs,
         FVW02660 corner boards, 1x4 casings round the door and windows;
       - DOOR: a ledge-and-brace door of 1x4 T&G FVW09619 on two strap
         hinges FAT00022, a dummy knob ODD00016 and a ball catch ODD00017
         (no lock: a child can always get out);
       - SHUTTERS: two board shutters a window, open against the wall;
       - PORCH (the info bar's toggle, on): 90 cm (US 3 ft) deep -- the side
         rims and the beams run on, two 4x4 KVH10100 posts with 2x4 knee
         braces, 2x6 joists, decking TST00001 along the length.
     X = across (W, +X the right side seen from the porch), Y up, Z along
     the ridge (L, +Z the front with the door). L / W = the framing's outer
     faces of the house; the porch lies past +L/2. _phLayout(STATE) is the
     single source of the model and the bill. */
  var PH = {
    W: [1.50, 2.40], W_US: [1.524, 2.4384], W0: 1.80, W0_US: 1.8288,
    L: [1.50, 3.00], L_US: [1.524, 3.048], L0: 1.80, L0_US: 1.8288,
    BLK: 0.30, BLK_US: 0.3048, BLK_TOP: 0.20, BLK_TOP_US: 0.2032, BLK_H: 0.20, BLK_H_US: 0.2032, BLK_UP: 0.10, BLK_UP_US: 0.1016,
    SOCK: 0.05, SOCK_US: 0.0508, GRAVEL: 0.10, GRAVEL_US: 0.1016, BLK_SP: 1.20, BLK_SP_US: 1.2192,
    JOIST_SP: 0.40, JOIST_SP_US: 0.4064, STUD_SP: 0.60, STUD_SP_US: 0.6096, RAF_SP: 0.60, RAF_SP_US: 0.6096, GSTUD_SP: 0.30, GSTUD_SP_US: 0.3048,
    WALL_H: 1.52, WALL_H_US: 1.524,                      /* the floor's top to the plates' top (5 ft) */
    DOOR_W: 0.60, DOOR_W_US: 0.6096, DOOR_CLR: 0.01, DOOR_CLR_US: 0.0095,
    WIN: 0.46, WIN_US: 0.4572, WIN_SILL: 0.61, WIN_SILL_US: 0.6096,
    KNOB_Y: 0.80, KNOB_Y_US: 0.8128,
    PITCH: 40, EAVE: 0.20, EAVE_US: 0.2032, RAKE: 0.15, RAKE_US: 0.1524,
    PORCH: 0.90, PORCH_US: 0.9144, BRACE: 0.30, BRACE_US: 0.3048,
    DECK_GAP: 0.005, DECK_GAP_US: 0.0048, FIX_SP: 0.40, FIX_SP_US: 0.4064,
    SHUT_GAP: 0.01, SHUT_GAP_US: 0.0095,
    WASTE: 1.10, SHEATH_SCR_M2: 15, SIDING_SCR_M2: 20, SHINGLE_NAILS_M2: 20, UL_STAPLES_M2: 6, DRIP_FIX: 0.30,
    CAP_W: 0.30, CAP_EXPO: 0.143, CAP_NAILS: 2, TAB: 0.333, EXPO: 0.143, SHINGLE_T: 0.006,
    BLOCK: 'FCO00012', GRAVEL_CODE: 'FCO00001', DIG: 'FEE00001',
    RIM: 'KVH60160', JOIST: 'KVH60160', HEADER: 'KVH60160', RIDGE: 'KVH60160',
    STUD: 'KVH10060', RAFTER: 'KVH10060', BEAM: 'KVH10160', POST: 'KVH10100',
    FLOOR: 'OSB25002', ROOF: 'OSB25001', SIDING: 'FCP00009', TRIM: 'FVW02660', BOARD: 'TIM20100', TG: 'FVW09619', DECK: 'TST00001',
    UNDERLAY: 'ROR00008', SHINGLE: 'ROR00001', DRIP: 'ROM02401',
    HINGE: 'FAT00022', KNOB: 'ODD00016', CATCH: 'ODD00017',
    JOIST_SCREW: 'FAS60160', PLATE_SCREW: 'FAS60160', STUD_SCREW: 'FAS60120', FRAME_SCREW: 'FAS60100', BEAM_SCREW: 'FAS80200',
    SEAT_SCREW: 'FAS80200', RIDGE_TOE: 'FAS60080', TIE_SCREW: 'FAS60080', TIE_DOWN: 'FAS60120', BRACE_SCREW: 'FAS60160',
    SHEATH_SCREW: 'FAS50060', SIDING_SCREW: 'FAS55050', FASCIA_SCREW: 'FAS55050', DECK_SCREW: 'FAS55050',
    TRIM_NAIL: 'FAS18032', HINGE_SCREW: 'FAS50040', ROOF_NAIL: 'FAS00318', UL_STAPLE: 'FAS63000',
    /* v363 PLAYHOUSES 2, the stilt house (type 27): the cottage on posts --
       the floor's top 1.22 m (US 4 ft) up, the posts on ground screws in U
       heads (the gazebo's), a 4x6 frame on their tops, outer diagonals, a
       guarded porch, the ladder at its front, the slide off its right side */
    DECK_H: 1.22, DECK_H_US: 1.2192,
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.038, GS_R_US: 0.0381, U_UP: 0.030, U_T: 0.004, U_FL: 0.15,
    POST_SP: 1.20, POST_SP_US: 1.2192,
    GUARD: 0.90, GUARD_US: 0.9144, RAIL_LOW: 0.05, RAIL_LOW_US: 0.0508, BAL_CLR: 0.085, BAL_CLR_US: 0.0857, BAL_T: 0.038, BAL_T_US: 0.0381,
    LAD_W: 0.60, LAD_W_US: 0.6096, LAD_ANG: 75, LAD_RISE: 0.28, LAD_RISE_US: 0.2794,
    SLIDE_W: 0.56, SLIDE_W_US: 0.5588, SLIDE_ANG: 33, SLIDE_TOP: 0.30, SLIDE_TOP_US: 0.3048, SLIDE_EXIT: 0.28, SLIDE_EXIT_US: 0.2794, SLIDE_RUN: 0.35, SLIDE_RUN_US: 0.3556,
    SLIDE_LIP: 0.08, SLIDE_BED: 0.015, SLIDE_WALL: 0.20, SLIDE_WT: 0.015,
    GSCREW: 'FGR00001', UHEAD: 'FGR00002', UNAIL: 'FAS38038', FBEAM_SCREW: 'FAS80260', RAIL_SCREW: 'FAS60120', WPOST_SCREW: 'FAS60100', WPOST_SCREW_US: 'FAS60080',
    BAL: 'KVH03838', BAL_SCREW: 'FAS50060', ROD: 'FAT16010', WASHER: 'FAT16001', CAPNUT: 'FAT16002',
    SLIDE_NAME: 'PLAYGROUND WAVE SLIDE, HDPE, 8 FT (FOR A 4 FT DECK), WITH ITS MOUNTING HARDWARE'
  };
  /* the sections (metric / US actual): 2x6 joist (t x h), 2x4 stud (t x
     depth), 4x6 beam, 4x4 post, the floor / roof OSB, the siding, the 1x
     trim (t, corner board width, casing width), the T&G board (t, width,
     cover), the decking, the 2x6 ridge */
  function _phProf(s) {
    if ((s || STATE).isMetric === false) return { jt: 0.0381, jh: 0.1397, st: 0.0381, sd: 0.0889, bw: 0.0889, bh: 0.1397, p: 0.0889, fl: 0.0183, rs: 0.0159, sg: 0.0087,
      tt: 0.01905, tw: 0.0635, cw: 0.0889, gb: 0.01905, gw: 0.0889, gc: 0.0826, dk: 0.0254, dw: 0.1397, rgt: 0.0381, rgd: 0.1397 };
    return { jt: 0.060, jh: 0.160, st: 0.060, sd: 0.100, bw: 0.100, bh: 0.160, p: 0.100, fl: 0.018, rs: 0.015, sg: 0.011,
      tt: 0.020, tw: 0.060, cw: 0.100, gb: 0.019, gw: 0.096, gc: 0.086, dk: 0.025, dw: 0.145, rgt: 0.060, rgd: 0.160 };
  }
  function _phU(s, k) { s = s || STATE; var v = s.variant | 0, T = ((v === 41 || v === 44 || v === 47 || v === 48 || v === 51) && DH[k] != null) ? DH : PH;   /* v403 + the modern dog house (51) */ return (s.isMetric === false && T[k + '_US'] != null) ? T[k + '_US'] : T[k]; }   /* v385 the dog house's own first; v388 + the insulated one (44); v392 + the kennel with run (47) */
  /* ------------------------------------------------------------------
     v385 TYPE 41 -- KENNEL 1: THE CLASSIC DOG HOUSE (Marek 2026-10-30
     13:28: "Produkt mame zalozeny. Muzes naplanovat varianty kennel a
     zacit s vyrobou konfiguratoru" -- KENNEL the way of COOP: one product,
     its variants on this engine, no floorplans). The cottage's build
     (_phLayout) at a dog's scale: these constants over PH (_phU looks here
     first for type 41), these codes over PH's (DHC, through PHk):
       - THE DOG on the slider: its height at the shoulder (the withers),
         25-80 cm (US 10-32 in.), 55 cm (US 22 in.) unless set. The house
         follows the usual US sizing: the doorway 3/4 of it high and 0.6 of
         it wide (whole cm / in.), inside 1.75 of it deep (stretched out)
         and 1.35 wide (curled up), the walls at least 1.05 of it and over
         the doorway's header; sizes in 5 cm (US 2 in.) steps. L / W on the
         footprint's grips from there up to 60 cm (US 2 ft) more; the
         slider fits them to the dog again.
       - FLOOR: four concrete deck blocks (the cottage's), a 2x4 frame on
         edge -- rims and joists at <= 40 cm (US 16 in.) -- and OSB.
       - WALLS: 2x4 at <= 60 cm (US 24 in.); the side walls under a flat
         2x4 top plate (the cottage's 4x6 beam), the gables under 2x4 top
         plates. The doorway in the front gable framed as the cottage's
         window -- kings, a 2x4 header on edge, cripples over it -- its
         sill the bottom plate (a 6 cm / US 1 1/2 in. threshold that keeps
         the bedding in). No door leaf, no windows.
       - ROOF: 35 deg gable, 2x4 rafters at <= 60 cm (a 6x160 down through
         each into the plate), a 2x6 ridge board, fly rafters; no ties
         over the dog's head (the span is short: the ridge board, the OSB
         and the gables hold it). OSB, underlay, shingles + caps, drip
         edge, 1x4 fascia and rake boards; 15 cm (US 6 in.) eaves, 10 cm
         (US 4 in.) rakes; gable studs every 20 cm (US 8 in.) from the middle.
       - SKIN: panel siding, corner boards, a casing round the doorway.
       - PORCH on the info bar's toggle (off): the cottage's at the dog's
         depth (0.8 of its height, at least 40 cm / US 16 in.) -- the rims
         and the top plates on to two 4x4 posts on deck blocks, decking,
         the roof over it, 2x4 knee braces.
     The coop's farmhouse colours (CO_PALETTES). */
  var DH_TYPE = 41;
  /* ------------------------------------------------------------------
     v388 TYPE 44 -- KENNEL 2: THE INSULATED DOG HOUSE (Marek 2026-10-30
     "Dalsi krok" -- the slot plan's second: two rooms, insulated walls /
     floor / roof, a door flap on the toggle). The classic dog house's
     build (the same DH / DHC through _phLayout) with:
       - TWO ROOMS: a windbreak entry in front (as deep as 0.7 of the dog,
         at least the doorway + 5 cm / US 2 in.) and the sleeping room
         behind it (1.45 of the dog deep -- smaller than the classic's, it
         keeps the dog's heat), a framed 2x4 partition between them. The
         front doorway at the right end of the front gable, the
         partition's opening at the left end: the wind never reaches the
         bed. W fits both openings side by side (+ 5 cm / US 2 in.).
       - INSULATION: 50 mm (US 2 in.) XPS boards (INS00503) between the
         floor joists, the wall studs, the partition's studs and the
         ceiling joists, bonded in with low expansion adhesive foam
         (FCP00005, a can for 6 m2).
       - A FLAT CEILING: 2x4 ceiling joists on the side plates (the
         cottage's rafter ties, an end one inside each gable, one over the
         partition) -- the attic over it stays cold and dry.
       - LINING: 15 mm (US 5/8 in.) OSB (OSB25001) on the ceiling joists,
         the walls and both faces of the partition, 5x60 screws (15 a m2).
       - The front doorway's kings and header screwed together first and
         stood on the plate (the outer king sits against the corner's end
         stud); the partition built flat as one frame and stood up under
         the lined ceiling (1 cm / US 3/8 in. short), screwed down into a
         joist under it, up into the ceiling joist over it, at the ends
         into a stud of each side wall.
       - THE FLAP on the toggle (on): a clear PVC strip curtain inside the
         doorway under a 1x4 batten screwed into the header -- no
         catalogue row yet (MISSING, billed by m2).
     No porch. The classic's colours, sizes in 5 cm (US 2 in.) steps. */
  var DI_TYPE = 44;
  /* ------------------------------------------------------------------
     v392 TYPE 47 -- KENNEL 3: THE DOG KENNEL WITH RUN (Marek 2026-10-30
     16:25 "Dalsi krok" -- the slot plan's third: the house + a welded-wire
     run under the same roof, the run on the toggle). The classic dog
     house's build (DH / DHC through _phLayout) with its porch grown into
     a run:
       - THE RUN in front of the doorway, 2.5 of the dog long (at least
         1.20 m / US 4 ft), the house's width (at least a 40 cm / US 16 in.
         gate + the posts): the rims and the side plates on to two 4x4
         posts at the front corners (deck blocks), joists + decking, the
         roof over it, a 2x4 knee brace from each post up under its plate.
       - THE WALLS 1.40 of the dog clear over the run's decking (the dog
         stands up in it): the house grows with them.
       - THE SIDES: 2x4 studs on the decking at <= 60 cm (US 24 in.) from
         the house's corner board to the brace, toed down into the rim, up
         into the plate; welded wire on the outside from the rim's
         underside to the plate's top, stapled.
       - THE FRONT: a 2x4 rail on edge between the posts, flush with their
         faces, its top the plates' (a 6x160 through the plate, one through
         the post into each end); welded wire over the gable above it; a
         gate under it -- the coop's run door (a flat 2x4 frame, a brace
         rising from the hinge side, welded wire on its face), two strap
         hinges on the left post, a barrel bolt (MISSING).
       - The welded wire 2 x 4 in. (50 x 100 mm) 14 ga, galvanized -- no
         catalogue row yet (MISSING, by m2 / ft2); the staples FAS10000 by
         the lines they hold (the coop's).
     The toggle off: the classic dog house. The classic's colours, sizes
     in 5 cm (US 2 in.) steps. */
  var KR_TYPE = 47;
  var KR = { MESH_NAME: 'WELDED WIRE FENCE 2 X 4 IN. (50 X 100 MM), 14 GA (2 MM), GALVANIZED -- THE DOG RUN' };
  /* ------------------------------------------------------------------
     v396 TYPE 48 -- KENNEL 4: THE DOUBLE DOG HOUSE (Marek 2026-10-30
     18:01 "Dalsi krok" -- the slot plan's fourth: two dogs, two rooms,
     two doorways). The classic dog house's build (DH through _phLayout)
     for two dogs of the slider's size side by side:
       - TWO ROOMS, each as wide as the classic's inside (1.35 of the dog,
         and its doorway + kings clear of the partition and the corner),
         as deep; W = both + the side walls + the partition.
       - THE PARTITION along the middle, under the ridge: a 2x4 frame
         (bottom plate, studs at <= 60 cm, a top plate right under the
         ridge board) built flat, stood up between the gables -- 6x160
         down through the floor into each joist it crosses, three 6x120
         from each end stud into a stud of the gable (side.split: the
         gables' grid each side of it), 6x100 up through its top plate
         into the ridge board; 15 mm (US 5/8 in.) OSB on its left face
         (OSB25001, 5x60 FAS50060 15 a m2). It carries the ridge: the roof
         needs no ties over the dogs.
       - TWO DOORWAYS in the front gable, each in the middle of its room
         (the classic's framing: kings, a 4x4 header under the top plate),
         a casing round each.
       - THE FLOOR on 2x6 rims and joists (the cottage's KVH60160, DDC):
         the joists span both rooms.
       - THE PORCH on the toggle (off) as the classic's, across the front.
     The classic's colours, sizes in 5 cm (US 2 in.) steps. */
  var DD_TYPE = 48;
  /* ------------------------------------------------------------------
     v403 TYPE 51 -- KENNEL 5: THE MODERN DOG HOUSE (Marek 2026-10-30
     20:31 "Dalsi krok" -- the slot plan's fifth; question panel: the roof
     deck as a flat roof). The classic dog house's build (DH through
     _phLayout) with the stilt house's mono-pitch roof path:
       - THE DOG on the slider as the classic's (doorway, walls, L / W).
       - LEGS: the floor frame on 2x6 rims and joists (DMC, the double's)
         25 cm (US 10 in.) off the ground, four 4x4 legs inside its
         corners standing in deck blocks; two 6x120 through the rim and
         two through the end joist into each.
       - WALLS: the classic's 2x4 framing (the left wall up by the roof's
         rise), clad in horizontal wood boards FVW01351 135 x 15 mm (US
         5 1/2 x 5/8 in.) straight on the studs, 28 screws a m2 by rate;
         corner boards, a casing round the doorway.
       - ROOF, the toggle OFF: 14 deg mono-pitch falling to the right --
         2x4 rafters at <= 60 cm with a birdsmouth on each wall's plate,
         fly rafters on the plates' ends, OSB, underlay, standing seam,
         1x6 fascia and rake boards, drip edge.
       - THE ROOF DECK on the toggle (ON): the roof at 3 deg, its rafters
         at <= 40 cm, a 2x6 rim on the tails of both eaves (two 6x120
         into each tail); OSB, an EPDM membrane in one piece turned down
         over the edges under the drip edge (no catalogue row yet:
         MISSING, by m2); the deck floats on it -- 38x38 sleepers over
         the rafters, decking across them (two stainless screws a board at
         each sleeper), no screw through the membrane; THE GUARD boxes it
         in: 38x38 balusters on the rims' and the rake boards' outer faces
         (<= 8.5 cm / US 3 3/8 in. clear, two screws each), a 2x4 cap rail
         flat on their tops, 0.6 of the dog over the deck (at least 30 cm
         / US 12 in.), open at the ramp; THE RAMP off the right (low)
         eave at 25 deg: two 2x6 stringers in joist hangers FAT00009 on
         the rim (six connector nails each), their feet cut level on deck
         blocks, decking across them, a 20x40 cleat on every board.
     The modern look in the default scheme: cedar boards, charcoal trims
     and roof. Sizes in 5 cm (US 2 in.) steps. */
  var DM_TYPE = 51;
  var DM = {
    LEG_UP: 0.25, LEG_UP_US: 0.254, DECK_PITCH: 3, RAF_SP: 0.40, RAF_SP_US: 0.4064,
    CLAD_COV: 0.125, CLAD_COV_US: 0.127, CLAD_T: 0.015, CLAD_T_US: 0.0159, CLAD_SCR_M2: 28,
    K_GUARD: 0.60, GUARD_MIN: 0.30, GUARD_MIN_US: 0.3048, BAL: 0.038, BAL_US: 0.0381, BAL_CLR: 0.085, BAL_CLR_US: 0.0857,
    K_RAMP_W: 0.80, RAMP_W_MIN: 0.40, RAMP_W_MIN_US: 0.4064, RAMP_ANG: 25, CL_T: 0.020, CL_T_US: 0.01905, CL_W: 0.040, CL_W_US: 0.0381,
    EPDM_T: 0.0012, EPDM_TURN: 0.06, EPDM_TURN_US: 0.0635,
    SLEEPER: 'KVH03838', BALUSTER: 'KVH03838', RAIL: 'KVH10060', ERIM: 'KVH60160', STRINGER: 'KVH60160', CLEAT: 'KVL20040',
    HANGER: 'FAT00009', HANGER_NAIL: 'FAS38038', CLAD: 'FVW01351', CLAD_SCREW: 'FAS55050', CLEAT_SCREW: 'FAS45070',
    BAL_SCREW: 'FAS60080', BAL_SCREW_R: 'FAS60100', RAIL_SCREW: 'FAS60100', ERIM_SCREW: 'FAS60120', LEG_SCREW: 'FAS60120',
    EPDM_NAME: 'EPDM ROOFING MEMBRANE 1.2 MM (45 MIL), ONE PIECE -- THE DOG HOUSE ROOF DECK, LOOSE-LAID, TURNED DOWN OVER THE EDGES UNDER THE DRIP EDGE'
  };
  function _dmU(s, k) { return ((s || STATE).isMetric === false && DM[k + '_US'] != null) ? DM[k + '_US'] : DM[k]; }
  function _phIsDm(s) { return ((s || STATE).variant | 0) === DM_TYPE; }
  function _dmDeck(s) { s = s || STATE; return _phIsDm(s) && s.knDeck !== false; }   /* v403 its roof deck on the toggle (on) */
  var DH = {
    DOG: [0.25, 0.80], DOG_US: [0.254, 0.8128], DOG0: 0.55, DOG0_US: 0.5588, DOG_Q: 0.01, DOG_Q_US: 0.0254,
    STEP: 0.05, STEP_US: 0.0508, Q: 0.01, Q_US: 0.0254, GROW: 0.60, GROW_US: 0.6096,
    K_DEEP: 1.75, K_WIDE: 1.35, K_WALL: 1.05, K_DW: 0.60, K_DH: 0.75, K_PORCH: 0.80,
    DOOR_MIN: 0.18, DOOR_MIN_US: 0.1778, PORCH_MIN: 0.40, PORCH_MIN_US: 0.4064,
    EAVE: 0.15, EAVE_US: 0.1524, RAKE: 0.10, RAKE_US: 0.1016, BRACE: 0.15, BRACE_US: 0.1524, GSTUD_SP: 0.20, GSTUD_SP_US: 0.2032,
    /* v388 the insulated dog house: the sleeping room 1.45 of the dog deep, the entry 0.7 (at least the doorway + 5 cm), the openings 5 cm past each other, the partition 1 cm short of the ceiling */
    K_SLEEP: 1.45, K_VEST: 0.70, VEST_CLR: 0.05, VEST_CLR_US: 0.0508, OVL: 0.05, OVL_US: 0.0508, TOP_GAP: 0.01, TOP_GAP_US: 0.0095,
    XPS_T: 0.05, XPS_T_US: 0.0508, FLAP_W: 0.10, FLAP_W_US: 0.1016,
    /* v392 the kennel with run: the run 2.5 of the dog long (at least 1.20 m), the dog's 1.40 clear over its decking (at least 60 cm /
       US 24 in.: a gate a hand gets through), the side studs at <= 60 cm, the gate at least 40 cm wide, 1 cm (US 3/8 in.) clear round it */
    K_RUN: 2.5, RUN_MIN: 1.20, RUN_MIN_US: 1.2192, K_RUN_H: 1.40, RUN_H_MIN: 0.60, RUN_H_MIN_US: 0.6096, KSTUD_SP: 0.60, KSTUD_SP_US: 0.6096,
    GATE_MIN: 0.40, GATE_MIN_US: 0.4064, GATE_CLR: 0.01, GATE_CLR_US: 0.0095
  };
  /* its codes: the 2x4 rims, joists and flat top plates (KVH10060), the doorway's 4x4 header (KVH10100), 6x120 through a 2x4 (FAS60120), a 6x160 down each rafter */
  var DHC = (function () { var o = Object.create(PH); o.RIM = PH.STUD; o.JOIST = PH.STUD; o.BEAM = PH.STUD; o.HEADER = PH.POST; o.JOIST_SCREW = PH.STUD_SCREW; o.BEAM_SCREW = PH.STUD_SCREW; o.SEAT_SCREW = PH.PLATE_SCREW; o.PITCH = 35; return o; })();
  /* v396 the double dog house's: the classic's with the cottage's 2x6 rims and joists (KVH60160 -- they span both rooms) */
  var DDC = (function () { var o = Object.create(DHC); o.RIM = PH.RIM; o.JOIST = PH.JOIST; return o; })();
  /* v403 the modern dog house's: the double's (2x6 rims + joists on its four legs), the 2x4 rafters of the classic */
  var DMC = Object.create(DDC);
  /* v388 the insulated dog house's own items: the XPS, its adhesive foam, the OSB lining (+ its screws by rate); the flap no catalogue row yet */
  var DI = { XPS: 'INS00503', FOAM: 'FCP00005', FOAM_M2: 6, LINING: 'OSB25001', LIN_SCREW: 'FAS50060', LIN_SCR_M2: 15,
             FLAP_NAME: 'PVC STRIP CURTAIN 2 MM (5/64 IN.), CLEAR -- THE DOG DOOR FLAP, CUT INTO STRIPS' };
  function _phIsDh(s) { var v = ((s || STATE).variant | 0); return v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE; }   /* v403 + the modern dog house */   /* v396 + the double dog house */   /* v392 + the kennel with run */   /* v388 + the insulated dog house */
  function _phIsKr(s) { return ((s || STATE).variant | 0) === KR_TYPE; }
  function _phIsDd(s) { return ((s || STATE).variant | 0) === DD_TYPE; }   /* v396 the double dog house */
  function _krRun(s) { s = s || STATE; return _phIsKr(s) && s.phPorch !== false; }   /* v392 its run on the toggle (on) */
  function _phIsDi(s) { return ((s || STATE).variant | 0) === DI_TYPE; }
  function _dhFlap(s) { s = s || STATE; return _phIsDi(s) && s.knFlap !== false; }   /* v388 its flap on the toggle (on) */
  /* the dog's height at the withers: whole cm, US whole inches */
  function _dhDog(s) {
    s = s || STATE;
    var R = _phU(s, 'DOG'), q = _phU(s, 'DOG_Q'), v = +s.knDog;
    if (!(isFinite(v) && v > 0)) v = _phU(s, 'DOG0');
    v = Math.round(v / q) * q;
    return Math.round(Math.max(R[0], Math.min(R[1], v)) * 10000) / 10000;
  }
  /* what the dog asks for: the doorway, the walls' height, the house's least L / W (framing), the porch's depth */
  function _dhDims(s) {
    s = s || STATE;
    var P = _phProf(s), H = _dhDog(s), q = _phU(s, 'Q'), S = _phU(s, 'STEP');
    function upQ(v) { return Math.round(Math.ceil(v / q - 1e-6) * q * 10000) / 10000; }
    function upS(v) { return Math.round(Math.ceil(v / S - 1e-6) * S * 10000) / 10000; }
    var doorW = Math.max(_phU(s, 'DOOR_MIN'), upQ(DH.K_DW * H)), doorH = upQ(DH.K_DH * H);
    if (_phIsDi(s)) {
      /* v388 the insulated dog house: the partition's opening (under the lined ceiling, 1 cm short) as high as the doorway asks;
         inside: the walls' lining; the sleeping room + the partition (2x4 + a lining each face) + the entry; W: both openings
         beside each other (each by its corner: an end stud + a king), 5 cm past each other */
      var rsI = P.rs;
      var wallHi = upQ(Math.max(DH.K_WALL * H, P.st + doorH + P.p + P.st + rsI + _phU(s, 'TOP_GAP')));
      var Ds = upQ(DH.K_SLEEP * H), Dv = upQ(Math.max(DH.K_VEST * H, doorW + _phU(s, 'VEST_CLR')));
      var Li = upS(2 * (P.sd + rsI) + Ds + (P.sd + 2 * rsI) + Dv);
      var Wi = upS(Math.max(DH.K_WIDE * H + 2 * (P.sd + rsI), 2 * P.sd + 2 * doorW + 4 * P.st + rsI + _phU(s, 'OVL')));
      return { dog: H, doorW: doorW, doorH: doorH, wallH: wallHi, L: Li, W: Wi, porch: 0, Ds: Ds, Dv: Dv, insul: true };
    }
    var wallH = upQ(Math.max(DH.K_WALL * H, P.st + doorH + P.p + P.st));                         /* the bottom plate, the doorway, its 4x4 header, the top plate */
    var L = upS(DH.K_DEEP * H + 2 * P.sd);
    var W = upS(Math.max(DH.K_WIDE * H + 2 * P.sd, doorW + 4 * P.st + 2 * P.sd + 0.01));         /* -- and room for the kings and the corner studs */
    var porch = upS(Math.max(_phU(s, 'PORCH_MIN'), DH.K_PORCH * H));
    if (_phIsDd(s)) {
      /* v396 the double dog house: two rooms of the classic's inside width beside each other + the partition (a 2x4's depth); each
         room also fits its doorway between the kings, 5 mm clear of the partition's stud and of the corner's end stud */
      W = upS(Math.max(2 * DH.K_WIDE * H + 3 * P.sd, 4 * (doorW / 2 + 2 * P.st + 0.005) + 3 * P.sd));
      return { dog: H, doorW: doorW, doorH: doorH, wallH: wallH, L: L, W: W, porch: porch, dbl: true };
    }
    if (_krRun(s)) {
      /* v392 the kennel with run: the dog's 1.40 clear between the run's decking and the side plates' underside (the floor's OSB
         under the house's walls, the decking on the same joists); W fits the gate between the 4x4 posts; the run by the dog */
      wallH = upQ(Math.max(wallH, Math.max(DH.K_RUN_H * H, _phU(s, 'RUN_H_MIN')) + P.st + P.dk - P.fl));
      W = upS(Math.max(W, _phU(s, 'GATE_MIN') + 2 * P.p + 2 * _phU(s, 'GATE_CLR')));
      porch = upS(Math.max(_phU(s, 'RUN_MIN'), DH.K_RUN * H));
      return { dog: H, doorW: doorW, doorH: doorH, wallH: wallH, L: L, W: W, porch: porch, run: true };
    }
    return { dog: H, doorW: doorW, doorH: doorH, wallH: wallH, L: L, W: W, porch: porch };
  }
  function _dhRange(s) { var D = _dhDims(s); return { min: D.L, max: Math.round((D.L + _phU(s, 'GROW')) * 10000) / 10000 }; }
  function _dhWRange(s) { var D = _dhDims(s); return { min: D.W, max: Math.round((D.W + _phU(s, 'GROW')) * 10000) / 10000 }; }
  /* its line in the debug log (what the dog got) and the NOT BILLED lines (none expected) */
  function _dhLog(g, bq) {
    if (g.insul) _dbg('[dh] insulated dog house: sleeping room ' + g.dogDs.toFixed(3) + ' deep (inside ' + (g.zP - g.P.sd / 2 - g.P.rs + g.L / 2 - g.P.sd - g.P.rs).toFixed(3) + '), entry ' + g.dogDv.toFixed(3) +
         ', partition at z ' + g.zP.toFixed(3) + ' (its opening at x ' + g.uPo.toFixed(3) + ', ' + g.dogDoorW.toFixed(3) + ' x ' + g.dogPDoorH.toFixed(3) + '), doorway at x ' + g.uD.toFixed(3) + ' (openings ' + g.dogOvl.toFixed(3) + ' past each other), inside width ' + (g.W - 2 * (g.P.sd + g.P.rs)).toFixed(3) +
         ', ceiling ' + (g.yPT - g.P.rs - g.yF).toFixed(3) + ' over the floor (' + g.ties + ' ceiling joists), XPS ' + g.insA.toFixed(2) + ' m2 (' + g.insN + ' boards), lining ' + g.linA.toFixed(2) + ' m2, flap ' + (g.flap ? 'ON ' + g.flapA.toFixed(3) + ' m2 (MISSING)' : 'OFF'));   /* v388 */
    if (g.dbl) _dbg('[dh] double dog house: doorways at x ' + g.uDs.map(function (u) { return u.toFixed(3); }).join(' / ') + ' (' + g.dogDoorW.toFixed(3) + ' wide), rooms ' + (g.W / 2 - 1.5 * g.P.sd).toFixed(3) + ' wide inside, partition ' + g.ddMid.h.toFixed(3) + ' high (floor to the ridge board) x ' + (g.ddMid.z1 - g.ddMid.z0).toFixed(3) + ', ' + g.ddStuds + ' studs, its OSB ' + g.ddLinA.toFixed(2) + ' m2');   /* v396 */
    if (g.dmod) _dbg('[dh] modern dog house: ' + g.dmLegs + ' legs (frame ' + g.yB.toFixed(3) + ' off the ground), cladding ' + g.cladA.toFixed(2) + ' m2, roof ' + g.pitch + ' deg ' + g.roofCov + (g.dmDeck ? ', ROOF DECK: EPDM ' + g.dmEpdmA.toFixed(2) + ' m2 (MISSING), ' + g.dmSleepers + ' sleepers, ' + g.dmDeckBoards + ' boards, guard ' + g.dmG.toFixed(3) + ' over the deck (' + g.dmBal + ' balusters, ' + g.dmRails + ' rails), ramp ' + g.dmRamp.w.toFixed(3) + ' wide x ' + g.dmRamp.len.toFixed(3) + ' at ' + g.dmRamp.ang + ' deg (deck ' + g.dmRamp.top.toFixed(3) + ' up, foot ' + g.dmRamp.run.toFixed(3) + ' out), ' + g.dmRBoards + ' boards, ' + g.dmCleats + ' cleats, ' + g.dmHangers + ' hangers' : ', roof deck OFF'));   /* v403 */
    if (g.krun) _dbg('[dh] kennel with run: run ' + g.PD.toFixed(3) + ' long (to z ' + g.zF.toFixed(3) + '), ' + (g.yBm - g.yJ1 - g.P.dk).toFixed(3) + ' clear over its decking (dog x ' + ((g.yBm - g.yJ1 - g.P.dk) / g.dogH).toFixed(2) + '), ' +
         g.kStuds + ' side studs at z ' + g.krZs.map(function (z) { return z.toFixed(3); }).join(' / ') + ', gate ' + g.gate.w.toFixed(3) + ' x ' + g.gate.h.toFixed(3) + ', welded wire ' + g.krMeshA.toFixed(2) + ' m2 (staple lines ' + g.krStapleL.toFixed(2) + ' m), ' + g.hinges + ' hinges, ' + g.krBolts + ' barrel bolt');   /* v392 */
    _dbg('[dh] ' + (g.insul ? 'insulated' : g.krun ? 'run' : g.dbl ? 'double' : g.dmod ? 'modern' : 'classic') + ' dog house: dog ' + g.dogH.toFixed(3) + ' at the withers -> doorway ' + g.dogDoorW.toFixed(3) + ' x ' + g.dogDoorH.toFixed(3) + ' over the bottom plate, ' +
         g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (least ' + g.dogLmin.toFixed(3) + ' x ' + g.dogWmin.toFixed(3) + ', inside ' + (g.L - 2 * g.P.sd).toFixed(3) + ' x ' + (g.W - 2 * g.P.sd).toFixed(3) + '); floor ' + g.yF.toFixed(3) +
         ', plates ' + g.yPT.toFixed(3) + ' (walls ' + (g.yPT - g.yF).toFixed(3) + '), ridge top ' + g.ridgeTop.toFixed(3) + ', porch ' + (g.porch ? 'ON ' + g.PD.toFixed(3) : 'OFF') + ', ' + g.blocks.length + ' deck blocks, ' +
         g.joists.length + ' joists, ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.ties + ' ties, ' + g.gStuds + ' gable studs, siding ' + g.sidingA.toFixed(2) + ' m2, roof ' + g.roofA.toFixed(2) + ' m2, ' +
         g.fas.length + ' fasteners; ' + Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
    if (!(bq.missing || []).length) _dbg('[dh] NOT BILLED: none');
    for (var i = 0; i < (bq.missing || []).length; i++) _dbg('[dh] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
  }
  function _phStilt(s) { return ((s || STATE).variant | 0) === 27; }   /* v363 the stilt house */
  function _phSlide(s) { return (_phStilt(s) || _phIsTf(s) || _phIsCs(s)) && (s || STATE).phSlide !== false; }   /* v389 + the castle's */   /* v363 -- its slide on the toggle (on); v368 + the tree fort's */
  function _phPorch(s) { if (_phIsDi(s) || _phIsDm(s)) return false;   /* v403 the modern dog house: its roof deck on the toggle instead */ return _phStilt(s) || (s || STATE).phPorch !== false; }   /* v363 the stilt house always has its porch (the ladder lands on it); v388 the insulated dog house never (its entry is inside) */
  /* v370 the roof on the info bar's top switch: gable (the default) <> mono-pitch -- the stilt house and the play fort */
  function _phRoofMono(s) { s = s || STATE; var v = s.variant | 0; if (v === DM_TYPE) return true; return (v === 27 || v === 29) && s.phRoof === 'mono'; }   /* v403 the modern dog house always mono-pitch */
  var PH_TYPES = [26, 27, 28, 29, 30, 31, 32, 34, 37, 39, 41, 42, 44, 46, 47, 48, 49, 52, 51];   /* v403 + the modern dog house (51: the classic's layout on legs, mono-pitch, the roof deck) */   /* v401 + the hoop coop (52: the backyard coop's house inside the hoop house's run) */   /* v397 + the barn coop (49: the backyard coop's layout under a gambrel) */   /* v396 + the double dog house (48: the classic's layout, two rooms) */   /* v392 + the dog kennel with run (47: the classic's layout, its porch a run) */   /* v391 + the cupola coop (46: the backyard coop's layout) */   /* v388 + the insulated dog house (44: the classic's layout, two rooms, insulated, lined) */   /* v386 + the lean-to coop (42: the backyard coop's layout) */   /* v385 + the classic dog house (41: the cottage's layout at a dog's scale) */   /* v383 + the walk-in coop (39: the backyard coop's layout) */   /* v379 + the chicken tractor (37, its own layout) */   /* v375 + the backyard coop (34: the playhouses' pipeline, its own layout) */   /* v368 the playhouse types (32 the tree fort) */   /* v367 (31 the little barn) */   /* v366 (30 the modern house) */   /* v365 (29 the play fort) */
  function _isPhType(v) { return PH_TYPES.indexOf(v | 0) >= 0; }
  function _phRange(s) { var v = ((s || STATE).variant | 0); if (v === CS_TYPE) return _csRange(s || STATE); if (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE) return _dhRange(s || STATE); if (v === 34 || v === 39 || v === 42 || v === 46 || v === 49 || v === 52) return _coRange(s || STATE); if (v === 37) return _ctRange(s || STATE); var r = (v === 29) ? _pfU(s, 'L') : (v === 32) ? _tfU(s, 'L') : _phU(s, 'L'); return { min: r[0], max: r[1] }; }   /* v368 the tree fort: 1.80-2.40 m (US 6-8 ft) */   /* v365 the play fort: 1.20-2.40 m (US 4-8 ft) */
  function _phWRange(s) { var v = ((s || STATE).variant | 0); if (v === CS_TYPE) return _csWRange(s || STATE); if (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE) return _dhWRange(s || STATE); if (v === 34 || v === 39 || v === 42 || v === 46 || v === 49 || v === 52) return _coWRange(s || STATE); if (v === 37) return _ctWRange(s || STATE); var r = (v === 28) ? _afU(s, 'W') : (v === 29) ? _pfU(s, 'W') : (v === 32) ? _tfU(s, 'W') : _phU(s, 'W'); return { min: r[0], max: r[1] }; }   /* v364 the A-frame: 2.10-3.00 m (US 7-10 ft) */
  function _phL0(s) { var v = ((s || STATE).variant | 0); if (v === CS_TYPE) return _csL0(s || STATE); if (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE) return _dhRange(s || STATE).min; if (v === 34 || v === 39 || v === 42 || v === 46 || v === 49 || v === 52) return _coRange(s || STATE).min; if (v === 37) return _ctRange(s || STATE).min; return (v === 29) ? _pfU(s, 'L0') : (v === 32) ? _tfU(s, 'L0') : _phU(s, 'L0'); }   /* v368 the tree fort: 2.10 m / US 7 ft */   /* v365 the play fort: 1.50 m / US 5 ft */
  function _phW0(s) { var v = ((s || STATE).variant | 0); if (v === CS_TYPE) return _csW0(s || STATE); if (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE) return _dhWRange(s || STATE).min; if (v === 46) return _cuWRange(s || STATE).min; if (v === 34 || v === 39 || v === 42 || v === 49 || v === 52) return _coU(s, 'W0'); if (v === 37) return _ctU(s, 'W0'); return (v === 28) ? _afU(s, 'W0') : (v === 29) ? _pfU(s, 'W0') : (v === 32) ? _tfU(s, 'W0') : _phU(s, 'W0'); }
  function _phL(s) { s = s || STATE; var R = _phRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _phL0(s))); }
  function _phW(s) { s = s || STATE; var R = _phWRange(s), v = +s.phW; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _phW0(s))); }
  /* the stud grid of a wall from u0 to u1 (stud centres): one at each end,
     the rest at multiples of the spacing from u0 */
  function _phGrid(u0, u1, sp, t) {
    var out = [u0 + t / 2], k;
    for (k = 1; u0 + k * sp < u1 - t - 0.02; k++) out.push(u0 + k * sp);
    out.push(u1 - t / 2);
    return out;
  }
  function _phArea(poly) { var a = 0, n = poly.length, i; for (i = 0; i < n; i++) { var P = poly[i], Q = poly[(i + 1) % n]; a += P[0] * Q[1] - Q[0] * P[1]; } return Math.abs(a / 2); }
  function _phLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), porch = _phPorch(s), L = _phL(s), W = _phW(s), i, j, k, sx, sz, q;
    /* v385 the dog house: the cottage at a dog's scale -- 2x4 rims and joists on edge, a flat 2x4 top plate for the beam (DHC's codes), its own sizes (_dhDims) */
    var dh = _phIsDh(s), dd = _phIsDd(s), dm = _phIsDm(s), dmDeck = _dmDeck(s), PHk = dd ? DDC : dm ? DMC : dh ? DHC : PH, D = dh ? _dhDims(s) : null;   /* v403 the modern dog house: DMC (2x6 rims + joists on legs) */   /* v396 the double dog house: DDC (2x6 rims + joists) */
    if (dh) P = Object.assign({}, P, (dd || dm) ? { bw: P.sd, bh: P.st } : { jh: P.sd, bw: P.sd, bh: P.st });
    if (dm) P.sg = _dmU(s, 'CLAD_T');   /* v403 its skin: the wood cladding's thickness (every offset past the studs follows it) */
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, p = P.p, sg = P.sg, tt = P.tt, cw = P.cw, tw = P.tw;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.0318 : 0.032;
    var lenBm = dh ? len120 : len200, lenJ = dh ? len120 : len160, lenSeat = dh ? len160 : len200;   /* v385 the dog house: through a 2x4, not a 4x6 / 2x6 */
    /* v388 the insulated dog house: the lining's thickness, the XPS's; the partition's middle (z), the front doorway's middle (x, at the
       right end), the partition opening's (the left end); the partition's top under the lined ceiling, 1 cm short */
    var di = _phIsDi(s), rsL = P.rs, ti = _phU(s, 'XPS_T'), glI = W / 2 - P.sd;
    var kr = _phIsKr(s) && porch;   /* v392 the kennel with run: its porch is the run */
    var zP = di ? L / 2 - P.sd - 2 * rsL - D.Dv - P.sd / 2 : 0, uD = di ? glI - 2 * P.st - D.doorW / 2 : 0, uPo = di ? -(glI - rsL) + 2 * P.st + D.doorW / 2 : 0;
    var uDd = dd ? (W / 2 - P.sd / 2) / 2 : 0, uDs = dd ? [-uDd, uDd] : [uD];   /* v396 the double dog house: each doorway in the middle of its room (between the partition and the side wall) */
    var insA = 0, insN = 0, linA = 0, flapA = 0;
    var snapY = function (y) { return y; };   /* v403 a nail into the modern dog house's cladding: off the gaps between its rows (set with them) */
    var cladA = 0, dmEpdmA = 0, dmSleepers = 0, dmDeckBoards = 0, dmBal = 0, dmRails = 0, dmHangers = 0, dmRBoards = 0, dmCleats = 0, dmG = 0, dmRamp = null;   /* v403 the modern dog house's cladding, roof deck, guard, ramp */
    var pieces = [], fas = [], blocks = [], hw = [], coat = 0, hinges = 0;
    var stilt = _phStilt(s), slide = _phSlide(s), gscrews = [], uheads = [], missing = [];   /* v363 the stilt house */
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function rod(kind, x, y, z, d, ln) { fas.push({ kind: kind, code: PHk.ROD, x: x, y: y, z: z, dir: d, len: ln, r: 0.008, rod: true }); }   /* v363 an M16 rod (a washer + cap nut each end) */
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    /* v367 a screw at the first of its spots whose shank keeps 3 mm off every fastener placed so far (the play fort's) */
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, m, q2;
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var f = fas[q2], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* THE HEIGHTS: the blocks' top, the joists' top, the floor, the plates'
       top (= the beams' top = the rafters' seat), the side walls' studs up
       to the beams' underside, the gable walls' up to their top plates */
    /* v363 the stilt house: the frame's underside = the floor's top 1.22 m (US 4 ft) less the OSB and the 4x6 (as deep as a 2x6) */
    var yBk = _phU(s, 'BLK_UP');   /* v403 the deck blocks' top (the modern dog house's legs stand in them, its frame higher) */
    var yB = stilt ? _phU(s, 'DECK_H') - P.fl - jh : dm ? _dmU(s, 'LEG_UP') : yBk, yJ1 = yB + jh, yF = yJ1 + P.fl, yPT = yF + (dh ? D.wallH : _phU(s, 'WALL_H'));   /* v385 the dog house: its walls by the dog */
    var yH = _phU(s, 'FOOT_UP'), yPB = yH + PHk.U_UP;   /* v363 the ground screw's head, the post's foot in its U head */
    var yP0 = yF + st, yBm = yPT - bh, yGT = yPT - st;
    var PD = porch ? (dh ? D.porch : _phU(s, 'PORCH')) : 0, zF = L / 2 + PD;   /* v385 the dog house: its porch by the dog */
    /* v392 the kennel with run: its side studs' z -- the first against the house's corner board, the last clear of the knee brace,
       evenly at <= 60 cm (US 24 in.) between (known before the decking: no deck screw under a stud's foot) */
    var krZs = [];
    if (kr) {
      var kz0 = L / 2 + sg + P.tt + 0.002 + sd / 2, kz1 = zF - P.p - (_phU(s, 'BRACE') + sd / 2 * Math.SQRT2) - 0.02 - sd / 2;
      var nks = (kz1 > kz0 + 0.05) ? Math.max(1, Math.ceil((kz1 - kz0) / _phU(s, 'KSTUD_SP') - 1e-9)) : 0;
      for (i = 0; i <= nks; i++) krZs.push(nks ? kz0 + (kz1 - kz0) * i / nks : kz0);
    }
    function underStud(x, z) { return kr && Math.abs(x) > W / 2 - st - 0.008 && krZs.some(function (zk) { return Math.abs(z - zk) < sd / 2 + 0.008; }); }
    /* the roof's line: the rafters' underside yR(x) = yPT + (xh - |x|) tan,
       the seat on the beam from xh to the beam's outer face (its depth a
       third of the rafter's plumb depth at most) */
    /* v370 THE MONO-PITCH ROOF ON THE SWITCH (the stilt house; Marek 2026-10-29 22:29 / 23:38: jine typy strech nez sedlova ... switch
       na pultovou): the modern house's -- 14 deg falling from the left wall to the right, the left wall and its beam up by the rise, a
       one-piece 2x6 rafter with a birdsmouth on each beam, the beams on past both gables under the fly rafters, the standing seam on
       OSB + underlay, 1x6 fascia and rake boards; yR(x) = yPT + (xh - x) tan (no |x|) */
    var mono = _phRoofMono(s), FB = _pfBoard(s), fbT = FB.t, fbW = FB.w;
    /* v403 the modern dog house: 2x4 rafters (rjh), 14 deg -- 3 deg under its roof deck, its eaves' 2x6 rims (jt) in the fascia's place */
    var rjh = dm ? sd : jh, mPitch = dmDeck ? DM.DECK_PITCH : MD.PITCH, eT = dmDeck ? jt : fbT;
    var th = (mono ? mPitch : PHk.PITCH) * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = (mono ? rjh : sd) / cs;
    var seat = Math.min(bw, dV / (3 * tn)), xh = W / 2 - seat, xr = P.rgt / 2;
    var xiL = -W / 2 + bw, xL0 = xiL - seat;   /* mono: the high (left) beam's inner face, its seat's start */
    var xa = W / 2 + sg, xo = xa + _phU(s, 'EAVE'), xe = xo + (mono ? eT : tt);
    var yR = mono ? function (x) { return yPT + (xh - x) * tn; } : function (x) { return yPT + (xh - Math.abs(x)) * tn; };
    function yT(x) { return yR(x) + dV; }
    var rgTop = yT(xr), rgBot = rgTop - P.rgd;
    var yPTL = mono ? yR(xL0) : yPT;
    function yPTs(sx2) { return (mono && sx2 < 0) ? yPTL : yPT; }   /* each side beam's top */
    function yBms(sx2) { return yPTs(sx2) - bh; }                     /* -- and underside */
    var rkM = _phU(s, 'RAKE'), zFbM = -(L / 2 + sg + rkM) + st / 2, zFfM = (porch ? zF : L / 2 + sg) + rkM - st / 2, zBb = zFbM - st / 2, zBf = zFfM + st / 2;   /* mono: the fly rafters, the beams' ends under them */

    /* THE FOUNDATION: deck blocks under each side rim from the back to the
       front (with the porch the last one under its post) */
    var bl = _phU(s, 'BLK'), blT = _phU(s, 'BLK_TOP'), blH = _phU(s, 'BLK_H'), sock = _phU(s, 'SOCK'), gv = _phU(s, 'GRAVEL');
    var zRimEnd = porch ? zF - p : L / 2;
    /* v363 the stilt house: a ground screw + U head under every post, 12 connector nails, the flanges on the post's X faces (the gazebo's pier) */
    var len38 = us ? 0.0381 : 0.038, len260 = us ? 0.254 : 0.26, sPosts = [];
    function pier(x, z, id) {
      gscrews.push({ x: x, z: z, r: _phU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yPB, w: p, id: id });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr('nail-uhead', PHk.UNAIL, x + sd2 * (p / 2 + PHk.U_T), yPB + 0.02 + rI * 0.025, z + cI * ((sd2 < 0) ? 0.022 : 0.034), [-sd2, 0, 0], len38, 0.0019);
    }
    if (stilt) for (sx = -1; sx <= 1; sx += 2) {
      /* the posts under each side beam: the back corner, the house's front corner, between them <= 1.20 m (US 4 ft) */
      var zs0 = -L / 2 + p / 2, zs1 = L / 2 - p / 2, ns = Math.max(1, Math.ceil((zs1 - zs0) / _phU(s, 'POST_SP') - 1e-9));
      for (i = 0; i <= ns; i++) {
        var zsp = zs0 + (zs1 - zs0) * i / ns, xsp = sx * (W / 2 - p / 2), sid0 = (sx < 0 ? 'l' : 'r') + (i + 1);
        sPosts.push({ x: xsp, z: zsp, sx: sx, id: sid0 });
        pier(xsp, zsp, 'spost-' + sid0);
        box('post', PHk.POST, ceil2(yB - yPB), 'spost-' + sid0, xsp, (yPB + yB) / 2, zsp, p, yB - yPB, p);
        coat += 4 * p * (yB - yPB);
      }
    }
    /* v403 THE MODERN DOG HOUSE'S LEGS: a 4x4 inside each corner of the floor frame (against the rim and the end joist), standing
       in a deck block, its top flush with the joists' (under the floor's OSB) */
    var dmLegs = [];
    if (dm) for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      var lgx = sx * (W / 2 - jt - p / 2), lgz = sz * (L / 2 - jt - p / 2), lgid = (sx < 0 ? 'l' : 'r') + (sz < 0 ? 'b' : 'f'), lgY0 = yBk - sock;
      blocks.push({ x: lgx, z: lgz, w: bl, wt: blT, y0: yBk - blH, y1: yBk, a: 0, id: 'leg-' + lgid, post: true });
      box('post', PHk.POST, ceil2(yJ1 - lgY0), 'leg-' + lgid, lgx, (lgY0 + yJ1) / 2, lgz, p, yJ1 - lgY0, p);
      coat += 4 * p * (yB - yBk);   /* its foot out in the open */
      dmLegs.push({ x: lgx, z: lgz, sx: sx, sz: sz });
    }
    if (!stilt && !dm) for (sx = -1; sx <= 1; sx += 2) {
      var zb0 = -L / 2 + bl / 2, zb1 = porch ? zF - p / 2 : L / 2 - bl / 2, nb = Math.max(1, Math.ceil((zb1 - zb0) / _phU(s, 'BLK_SP') - 1e-9));
      for (i = 0; i <= nb; i++) {
        var post = porch && i === nb, zbk = zb0 + (zb1 - zb0) * i / nb;
        blocks.push({ x: sx * (W / 2 - (post ? p : jt) / 2), z: zbk, w: bl, wt: blT, y0: yB - blH, y1: yB, a: 0, id: (sx < 0 ? 'l' : 'r') + (i + 1), post: post });
      }
    }
    /* THE PORCH POSTS in the front blocks' sockets, up to the beams */
    var posts = [];
    if (porch) for (sx = -1; sx <= 1; sx += 2) {
      var pX = sx * (W / 2 - p / 2), pZ = zF - p / 2, pY0 = stilt ? yPB : yB - sock;   /* v363 the stilt house: from its U head on a ground screw, one piece up to the roof beam */
      posts.push({ x: pX, z: pZ, sx: sx });
      if (stilt) { pier(pX, pZ, 'post-' + (sx < 0 ? 'l' : 'r')); sPosts.push({ x: pX, z: pZ, sx: sx, id: (sx < 0 ? 'l' : 'r') + 'p', porch: true }); }
      box('post', PHk.POST, ceil2(yBms(sx) - pY0), 'post-' + (sx < 0 ? 'l' : 'r'), pX, (pY0 + yBms(sx)) / 2, pZ, p, yBms(sx) - pY0, p);   /* v370 mono: the left one the taller */
    }
    /* THE FLOOR FRAME: the side rims (under the side walls, on through the
       porch to its posts), the joists across between them -- the house's
       at <= 40 cm from its back to its front end, the porch's from a joist
       against the house's front one to one between the posts */
    if (!stilt) for (sx = -1; sx <= 1; sx += 2) {
      box('rim', PHk.RIM, ceil2(zRimEnd + L / 2), 'rim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, (zRimEnd - L / 2) / 2, jt, jh, zRimEnd + L / 2);
      if (porch) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * (W / 2 - jt / 2), yB + jh * (0.2 + 0.6 * k), zF, [0, 0, -1], len160);   /* v385 PH: a 6x160 through the 4x4 also on the dog house */   /* through the post into the rim's end (v367 over / under the front joist's own two) */
    }
    /* v363 the stilt house: a 4x6 KVH10160 side beam on the posts' tops
       (flush with their outer faces, as wide as the post) from the back to
       the porch post; that post's two 8x200 into its end */
    var zSB = zF - p;
    if (stilt) for (sx = -1; sx <= 1; sx += 2) {
      box('fbeam', PHk.BEAM, ceil2(zSB + L / 2), 'fbeam-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), yB + bh / 2, (zSB - L / 2) / 2, bw, bh, zSB + L / 2);
      coat += 2 * (bw + bh) * (zSB + L / 2);
      for (k = 0; k < 2; k++) scr('screw-ebeam', PHk.BEAM_SCREW, sx * (W / 2 - bw / 2), yB + bh * (0.2 + 0.6 * k), zF, [0, 0, -1], len200);
    }
    /* the joists (v363 the stilt house: between the side beams, the first a 4x6 end beam at the back, the porch's last a 4x6 front beam between its posts) */
    var jw = stilt ? W - 2 * bw : W - 2 * jt;
    var joists = [], jz0 = stilt ? -L / 2 + bw / 2 : -L / 2 + jt / 2, jz1 = L / 2 - jt / 2, nj = Math.max(1, Math.ceil((jz1 - jz0) / _phU(s, 'JOIST_SP') - 1e-9));
    if (di) {   /* v388 the insulated dog house: a joist under the partition, the rest evenly each side of it */
      var nja = Math.max(1, Math.ceil((zP - jz0) / _phU(s, 'JOIST_SP') - 1e-9)), njb = Math.max(1, Math.ceil((jz1 - zP) / _phU(s, 'JOIST_SP') - 1e-9));
      for (i = 0; i <= nja; i++) joists.push({ z: jz0 + (zP - jz0) * i / nja, w: jw, porch: false, beam: false, part: i === nja });
      for (i = 1; i <= njb; i++) joists.push({ z: zP + (jz1 - zP) * i / njb, w: jw, porch: false, beam: false });
    } else
    for (i = 0; i <= nj; i++) joists.push({ z: jz0 + (jz1 - jz0) * i / nj, w: jw, porch: false, beam: stilt && i === 0 });
    if (porch) {
      var pz0 = L / 2 + jt / 2, pz1 = stilt ? zF - bw / 2 : zF - jt / 2, np = Math.max(1, Math.ceil((pz1 - pz0) / _phU(s, 'JOIST_SP') - 1e-9));
      for (i = 0; i <= np; i++) joists.push({ z: pz0 + (pz1 - pz0) * i / np, w: (i === np) ? W - 2 * p : jw, porch: true, front: i === np, beam: stilt && i === np });
    }
    var jLines = [];   /* v363 the z of every screw driven along X through a side beam / porch post (the beams' screws down keep clear of them) */
    for (i = 0; i < joists.length; i++) {
      q = joists[i];
      if (q.beam) {
        box('fbeam', PHk.BEAM, ceil2(q.w), q.front ? 'ebeam-f' : 'ebeam-b', 0, yB + bh / 2, q.z, q.w, bh, bw);
        coat += 2 * (bw + bh) * q.w;
        /* through the side beam (the back) / the porch post (the front) into its end: two 8x200 one over the other (clear of the porch post's own two / the corner boards' nails) */
        for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-ebeam', PHk.BEAM_SCREW, sx * W / 2, yB + bh * (q.front ? 0.4 + 0.2 * k : 0.35 + 0.3 * k), q.z, [-sx, 0, 0], len200);
        if (!q.front) jLines.push(q.z);
        continue;
      }
      box('joist', PHk.JOIST, ceil2(q.w), 'joist-' + (i + 1), 0, yB + jh / 2, q.z, q.w, jh, jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) if (dh && q.front) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.4 + 0.2 * k), q.z, [-sx, 0, 0], len160);   /* v385 the dog house's porch front: a 6x160 through the 4x4 post, between the post's two into the rim */
        else scr('screw-joist', stilt ? PHk.BEAM_SCREW : PHk.JOIST_SCREW, sx * W / 2, yB + jh * (dh ? 0.2 + 0.4 * k : 0.3 + 0.4 * k), q.z, [-sx, 0, 0], stilt ? len200 : lenJ);   /* v385 the dog house: lower (clear of the porch decking's screws) */   /* v363 the stilt house: 8x200 through the 4x6 */
      jLines.push(q.z);
    }
    /* v403 the modern dog house's legs: two 6x120 through the side rim into each, two through the end joist */
    dmLegs.forEach(function (lg) {
      for (var k6 = 0; k6 < 2; k6++) {
        scr('screw-leg', DM.LEG_SCREW, lg.sx * W / 2, yB + jh * (0.20 + 0.40 * k6), lg.z, [-lg.sx, 0, 0], len120);   /* (the end joist's own two through the rim beside them) */
        scr('screw-leg', DM.LEG_SCREW, lg.x, yB + jh * (0.40 + 0.40 * k6), lg.sz * L / 2, [0, 0, -lg.sz], len120);   /* between those heights: clear of both */
      }
    });
    /* v363 the side beams down into each post: two 8x260 FAS80260, side by
       side across the beam -- or along it where a joist's screws pass there */
    if (stilt) sPosts.forEach(function (q2) {
      if (q2.porch) return;
      var clear = function (zz) { return jLines.every(function (zl) { return Math.abs(zl - zz) > 0.012; }); };
      var pts = clear(q2.z) ? [[q2.x - p / 4.5, q2.z], [q2.x + p / 4.5, q2.z]] : [[q2.x, q2.z - p / 4], [q2.x, q2.z + p / 4]];
      if (!clear(pts[0][1]) || !clear(pts[1][1])) pts = [[q2.x, q2.z - 0.035], [q2.x, q2.z + 0.035]];
      pts.forEach(function (pt) { scr('screw-fbeam', PHk.FBEAM_SCREW, pt[0], yJ1, pt[1], [0, -1, 0], len260); });
    });
    /* v363 THE DIAGONALS: a 2x4 flat on the posts' outer faces between each
       two posts along a side (the porch post too) and across the back, cut
       plumb at the posts' outer edges, over the U heads' flanges and under
       the beams; two 6x120 through it into each post. And a 2x4 knee brace
       from each porch post under the front beam (the cottage's). */
    var nXb = 0;
    function diag(id, plane, c, o, a0, a1, up, lap0, lap1) {   /* lap0 / lap1: how much of its end post it covers (a post shared by two bays: half each) */
      /* the band's half-height measured plumb (hv) and its centre line's rise (dyc) depend on each other: a few rounds settle them */
      var yLo = yPB + PHk.U_FL + 0.03, yHi = yB - 0.07, du = a1 - a0, hv = sd / 2, dyc = 0, it;   /* its top screws under the beam's 8x260 down into the post */
      for (it = 0; it < 8; it++) { dyc = (yHi - yLo) - 2 * hv; hv = (sd / 2) * Math.sqrt(1 + (dyc / du) * (dyc / du)); }
      var c0 = up ? yLo + hv : yHi - hv, c1 = up ? yHi - hv : yLo + hv;
      var pts = [[a0, c0 - hv], [a1, c1 - hv], [a1, c1 + hv], [a0, c0 + hv]];
      poly('xbrace', PHk.STUD, ceil2(Math.sqrt(du * du + dyc * dyc) + sd * Math.abs(dyc / du)), id, pts, plane, c, st);
      coat += 2 * (st + sd) * Math.sqrt(du * du + dyc * dyc);
      nXb++;
      [0.3, 0.7].forEach(function (f) {
        [a0 + f * lap0, a1 - f * lap1].forEach(function (u) {
          var yc = c0 + (c1 - c0) * (u - a0) / du, st0 = (plane === 'zy') ? [c + o * st / 2, yc, u] : [u, yc, c + o * st / 2];
          scr('screw-xbrace', PHk.STUD_SCREW, st0[0], st0[1], st0[2], (plane === 'zy') ? [-o, 0, 0] : [0, 0, -o], len120);
        });
      });
    }
    if (stilt) {
      for (sx = -1; sx <= 1; sx += 2) {
        var side = sPosts.filter(function (q3) { return q3.sx === sx; }).sort(function (a, b) { return a.z - b.z; });
        for (i = 0; i + 1 < side.length; i++) {
          var f0 = (i === 0), f1 = (i + 2 === side.length);   /* the end posts: a full lap; a shared one: to its middle */
          diag('xbrace-' + (sx < 0 ? 'l' : 'r') + (i + 1), 'zy', sx * (W / 2 + st / 2), sx, f0 ? side[i].z - p / 2 : side[i].z, f1 ? side[i + 1].z + p / 2 : side[i + 1].z, (i % 2) === ((sx < 0) ? 1 : 0), f0 ? p : p / 2, f1 ? p : p / 2);   /* the left side starts high at the back, the right low: the back diagonal (low at the left) meets each high / low the other way */
        }
      }
      diag('xbrace-b', 'xy', -(L / 2 + st / 2), -1, -W / 2, W / 2, true, p, p);
      /* the knee braces under the front beam, in its plane, butting the porch post's inner face */
      var kba = _phU(s, 'BRACE'), kbk = sd / 2 * Math.SQRT2;
      for (sx = -1; sx <= 1; sx += 2) {
        var kwb = (function (sx2) { return function (u, v) { return [sx2 * (W / 2 - p) - sx2 * u, yB + v]; }; })(sx);
        var kpts = [kwb(0, -(kba + kbk)), kwb(0, -(kba - kbk)), kwb(kba - kbk, 0), kwb(kba + kbk, 0)];
        if (sx > 0) kpts.reverse();
        poly('kbrace', PHk.STUD, ceil2((kba + kbk) * Math.SQRT2), 'kbrace-' + (sx < 0 ? 'l' : 'r'), kpts, 'xy', zF - bw / 2, st);
        coat += 2 * (st + sd) * (kba + kbk) * Math.SQRT2;
        var kA = kwb(0.06, 0.06 - kba - kbk), kB = kwb(kba + kbk - 0.06, -0.06);
        scr('screw-kbrace', PHk.BRACE_SCREW, kA[0], kA[1], zF - bw / 2, [sx, 0, 0], len160);
        scr('screw-kbrace', PHk.BRACE_SCREW, kB[0], kB[1], zF - bw / 2, [0, 1, 0], len160);
        coat += 4 * p * (yB - yPB);   /* the porch post's foot */
      }
    }
    /* v388 the insulated dog house: XPS between the joists (between the rims), flush with their tops, bonded in with the adhesive foam */
    if (di) {
      var fjz = joists.map(function (q2) { return q2.z; }).sort(function (a, b) { return a - b; });
      for (i = 0; i + 1 < fjz.length; i++) {
        var fza = fjz[i] + jt / 2, fzb = fjz[i + 1] - jt / 2;
        if (fzb - fza < 0.02) continue;
        box('finsul', DI.XPS, 0, 'finsul-' + (i + 1), 0, yJ1 - ti / 2, (fza + fzb) / 2, W - 2 * jt, ti, fzb - fza);
        insA += (W - 2 * jt) * (fzb - fza); insN++;
      }
    }
    /* the floor's OSB over the house's frame (billed by area) */
    pieces.push({ kind: 'floor', code: PHk.FLOOR, len: 0, id: 'floor', box: [0, yJ1 + P.fl / 2, 0, W, P.fl, L] });
    var floorA = W * L;
    /* THE PORCH'S DECKING along the length, from the front wall's siding to
       the porch's edge (the boards at the posts end against them), two
       stainless screws a board at every porch joist */
    var deckBoards = 0;
    if (porch) {
      var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((W + dg) / (P.dw + dg) - 1e-9)), dz0 = L / 2 + sg;
      for (i = 0; i < nd; i++) {
        var dx0 = -W / 2 + i * (P.dw + dg), dx1 = Math.min(W / 2, dx0 + P.dw);
        if (dx1 - dx0 < 0.02) continue;
        var atPost = (dx0 < -W / 2 + p - 1e-6) || (dx1 > W / 2 - p + 1e-6), dz1 = atPost ? zF - p : zF;
        box('deck', PHk.DECK, ceil2(dz1 - dz0), 'deck-' + (i + 1), (dx0 + dx1) / 2, yJ1 + P.dk / 2, (dz0 + dz1) / 2, dx1 - dx0, P.dk, dz1 - dz0);
        coat += (2 * (dx1 - dx0) + 2 * P.dk) * (dz1 - dz0);
        deckBoards++;
        for (j = 0; j < joists.length; j++) {
          if (!joists[j].porch || joists[j].z < dz0 || joists[j].z > dz1) continue;
          for (k = -1; k <= 1; k += 2) if (!underStud((dx0 + dx1) / 2 + k * (dx1 - dx0) / 4, joists[j].z)) scr('screw-deck', PHk.DECK_SCREW, (dx0 + dx1) / 2 + k * (dx1 - dx0) / 4, yJ1 + P.dk, joists[j].z, [0, -1, 0], len50);   /* v392 none under the run's studs */
        }
      }
    }

    /* THE WALLS. A wall is framed along its own axis u (z on the side
       walls, x on the gables): the grid's studs, a window's kings + header
       + sill + cripples, the door's kings + jacks + header. at(u, y, n)
       maps a wall point (n = 0 the wall's middle, + out) to the world. */
    var stuff = dh ? { win: D.doorW, sill: st } : { win: _phU(s, 'WIN'), sill: _phU(s, 'WIN_SILL') };   /* v385 the dog house: 'the window' is its doorway, on the bottom plate */
    var yWS = yF + stuff.sill, yWT = dh ? yGT - P.p : yWS + stuff.win, RO = _phU(s, 'DOOR_W') + 2 * _phU(s, 'DOOR_CLR'), yHd = yGT - jh;
    function wall(id, side, u0, u1, yTop, opening, topKind, yPl) {
      if (yPl == null) yPl = yPT;   /* v370 the top member's top (mono: the high wall's beam) */
      /* side: { ax: 'z'|'x', c: the wall's middle on the other axis, o: +1 / -1 outward } */
      var hs = (side.ax === 'z'), plates = [], studs = _phGrid(u0, u1, _phU(s, 'STUD_SP'), st), keep = [], m;
      /* v388 a stud where a partition meets this wall (side.split): the grid evenly each side of it */
      if (side.split != null) studs = _phGrid(u0, side.split + st / 2, _phU(s, 'STUD_SP'), st).concat(_phGrid(side.split - st / 2, u1, _phU(s, 'STUD_SP'), st).slice(1));
      /* v396 a grid stud that lands on the split's or an end's (the grid's last step right at its margin) drops out */
      if (side.split != null) studs = studs.filter(function (u4) { var an = [u0 + st / 2, u1 - st / 2, side.split]; return an.some(function (a4) { return Math.abs(u4 - a4) < 1e-9; }) || an.every(function (a4) { return Math.abs(u4 - a4) >= st + 0.005; }); });
      /* v388 the kinds on a map (side.km: the insulated dog house's doorway frame, its partition) -- the cottage's own without one */
      var KM = side.km || {};
      function kk(k) { return KM[k] || ((k === 'king') ? 'stud' : k); }   /* the kings are studs unless mapped */
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); kind = kk(kind); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kk(kind), code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var half = opening ? opening.w / 2 : 0, door = opening && opening.door, uc = opening ? (opening.u || 0) : 0;   /* v388 uc: the opening's middle (0 but the insulated dog house's) */
      var ucs = opening ? (opening.us || [uc]) : [];   /* v396 the double dog house: a doorway each room (opening.us: their middles) */
      var oL = opening ? (door ? half + 2 * st : half + st) : 0;   /* the kings' outer faces */
      for (m = 0; m < studs.length; m++) if (!opening || ucs.every(function (u4) { return Math.abs(studs[m] - u4) > oL + st / 2 - 1e-6; })) keep.push(studs[m]);
      var stTop = yTop;   /* the studs' tops: the beam's underside / the top plate's */
      /* the bottom plate (cut out under the door) + its screws down into the frame between the studs */
      if (door) plates.push([u0, -half], [half, u1]); else plates.push([u0, u1]);
      var plateHalf = [];
      for (m = 0; m < plates.length; m++) {
        var pa = plates[m][0], pb = plates[m][1];
        bx('plate', PHk.STUD, ceil2(pb - pa), id + '-plate-' + (m + 1), (pa + pb) / 2, yF + st / 2, 0, pb - pa, st, sd);
        plateHalf.push([pa, pb]);
      }
      /* every stud (grid + kings): up through the plate, its top fixed (beam: one 8x200 down; top plate: two 6x120 down) */
      var full = keep.slice(), kings = [];   /* v388 the kings round the opening's middle */
      ucs.forEach(function (u4) { kings.push(u4 - (oL - st / 2), u4 + (oL - st / 2)); });   /* v396 -- round each doorway's */
      if (opening) Array.prototype.push.apply(full, kings);
      full.sort(function (a, b) { return a - b; });
      for (m = 0; m < full.length; m++) {
        var u = full[m];
        bx((kings.indexOf(u) >= 0) ? 'king' : 'stud', PHk.STUD, ceil2(stTop - yP0), id + '-stud-' + (m + 1), u, (yP0 + stTop) / 2, 0, st, stTop - yP0, sd);
        for (var e = -1; e <= 1; e += 2) sc('screw-stud', PHk.STUD_SCREW, u, yF, e * sd / 4, 0, 1, 0, len120);
        if (topKind === 'beam') sc('screw-beam', PHk.BEAM_SCREW, u, yPl, 0, 0, -1, 0, lenBm);   /* v385 the dog house: 6x120 through its flat 2x4 */
        else for (e = -1; e <= 1; e += 2) sc('screw-tplate', PHk.STUD_SCREW, u, yPl, e * 0.4 * sd, 0, -1, 0, len120);   /* v367 near the faces: clear of a header's screws through the kings */
      }
      /* the plate's screws: between the studs, into the rim / end joist */
      /* v367 between every member (the studs, a window's lower cripples), clear of the floor's own screws */
      var dogO = !!(opening && opening.dog);   /* v385 the dog's doorway: on the bottom plate, no sill, no cripples under it */
      var crLo = (opening && !door && !dogO) ? studs.filter(function (u2) { return Math.abs(u2) < half - st / 2; }) : [];
      if (opening && !door && !dogO && !crLo.length) crLo = [0];
      var mem = full.concat(crLo).sort(function (a, b) { return a - b; }), nPl = (side.nPl != null) ? side.nPl : (stilt && (side.ax === 'z' || side.c < 0)) ? sd / 2 - bw / 2 : sd / 2 - jt / 2;   /* v388 side.nPl: the partition's joist right under its middle */
      for (m = 0; m + 1 < mem.length; m++) {
        var um = (mem[m] + mem[m + 1]) / 2, onPl = plateHalf.some(function (h2) { return um > h2[0] + 0.03 && um < h2[1] - 0.03; });
        if (onPl && mem[m + 1] - mem[m] > 0.15) scrClear(kk('screw-plate'), PHk.PLATE_SCREW, [um, um + 0.02, um - 0.02, um + 0.04, um - 0.04].map(function (u3) { return at(u3, yP0, nPl); }), [0, -1, 0], len160);   /* over the rim / end joist under the plate's outer part (v363 the stilt house: the 4x6's middle -- the beam's screws down pass beside it) */
      }
      if (opening && !door && !dogO) {
        /* THE WINDOW: a 2x4 header on edge at the outer face, a flat 2x4 sill, cripples under / over at the grid (or one in the middle) */
        var hdT = yWT + sd, cr = studs.filter(function (u2) { return Math.abs(u2) < half - st / 2; });
        if (!cr.length) cr = [0];
        bx('stud', PHk.STUD, ceil2(2 * half), id + '-whead', 0, yWT + sd / 2, sd / 2 - st / 2, 2 * half, sd, st);
        bx('stud', PHk.STUD, ceil2(2 * half), id + '-wsill', 0, yWS - st / 2, 0, 2 * half, st, sd);
        for (e = -1; e <= 1; e += 2) for (var f2 = 0; f2 < 2; f2++) {
          sc('screw-frame', PHk.STUD_SCREW, e * oL, yWT + sd * (0.3 + 0.4 * f2), sd / 2 - st / 2, -e, 0, 0, len120);
          sc('screw-frame', PHk.STUD_SCREW, e * oL, yWS - st / 2, (f2 ? 1 : -1) * sd / 4, -e, 0, 0, len120);
        }
        for (m = 0; m < cr.length; m++) {
          bx('stud', PHk.STUD, ceil2(yWS - st - yP0), id + '-cripple-lo-' + (m + 1), cr[m], (yP0 + yWS - st) / 2, 0, st, yWS - st - yP0, sd);
          if (stTop - hdT > 0.03) bx('stud', PHk.STUD, ceil2(stTop - hdT), id + '-cripple-hi-' + (m + 1), cr[m], (hdT + stTop) / 2, 0, st, stTop - hdT, sd);
          for (e = -1; e <= 1; e += 2) {
            sc('screw-stud', PHk.STUD_SCREW, cr[m], yF, e * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', PHk.STUD_SCREW, cr[m], yWS, ((e < 0) ? -0.4 : 0.1) * sd, 0, -1, 0, len120);   /* v367 near the faces: clear of the sill's screws through the kings */
          }
          if (stTop - hdT > 0.03) {
            if (topKind === 'beam') sc('screw-beam', PHk.BEAM_SCREW, cr[m], yPl, 0, 0, -1, 0, lenBm);
            else for (e = -1; e <= 1; e += 2) sc('screw-tplate', PHk.STUD_SCREW, cr[m], yPl, e * 0.4 * sd, 0, -1, 0, len120);
          }
        }
      }
      if (dogO) {
        /* v385 THE DOG'S DOORWAY: the bottom plate runs on as its threshold; a 4x4 header the wall's full depth between the kings,
           right under the top plate (the doorway's top = its underside): two 6x120 through each king into its end, two 6x80 down
           through the top plate into it */
        var hdP = P.p;
        ucs.forEach(function (u4, i4) {   /* v396 each doorway's (the second's ids -2) */
          bx('header', PHk.HEADER, ceil2(2 * half), id + '-dhead' + (i4 ? '-' + (i4 + 1) : ''), u4, stTop - hdP / 2, 0, 2 * half, hdP, sd);   /* v388 uc */
          for (var e5 = -1; e5 <= 1; e5 += 2) for (var f3 = 0; f3 < 2; f3++) sc('screw-frame', PHk.FRAME_SCREW, u4 + e5 * oL, stTop - hdP * (0.3 + 0.4 * f3), (f3 ? 1 : -1) * sd / 4, -e5, 0, 0, len100);   /* 6x100: a narrow doorway's from both sides stay apart */
          for (e5 = -1; e5 <= 1; e5 += 2) sc('screw-tplate', PH.TIE_SCREW, u4 + e5 * half / 2, yPl, 0, 0, -1, 0, len80);
        });
      }
      if (door) {
        /* THE DOOR: jacks under a 2x6 header (on edge, the outer face) that fills up to the top plate */
        for (e = -1; e <= 1; e += 2) {
          var uj = e * (half + st / 2);
          bx('stud', PHk.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (var e2 = -1; e2 <= 1; e2 += 2) sc('screw-stud', PHk.STUD_SCREW, uj, yF, e2 * sd / 4, 0, 1, 0, len120);
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', PHk.FRAME_SCREW, e * (half + 2 * st), yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, len100);
          for (f2 = 0; f2 < 2; f2++) sc('screw-frame', PHk.STUD_SCREW, e * oL, yHd + jh * (0.3 + 0.4 * f2), sd / 2 - jt / 2, -e, 0, 0, len120);
        }
        bx('header', PHk.HEADER, ceil2(2 * (half + st)), id + '-header', 0, yHd + jh / 2, sd / 2 - jt / 2, 2 * (half + st), jh, jt);
      }
      /* v388 THE INSULATED DOG HOUSE'S XPS (side.ins: its kind): a board in each bay between the members, from the bottom plate up to
         the top member, flush with the wall's inside face -- the air gap behind it at the siding; none in the opening (its header fills
         the wall over it) */
      if (side.ins) for (m = 0; m + 1 < full.length; m++) {
        var ia = full[m] + st / 2, ib = full[m + 1] - st / 2;
        if (ib - ia < 0.02 || (opening && full[m] === kings[0] && full[m + 1] === kings[1])) continue;
        bx(side.ins, DI.XPS, 0, id + '-ins-' + (m + 1), (ia + ib) / 2, (yP0 + stTop) / 2, -sd / 2 + ti / 2, ib - ia, stTop - yP0, ti);
        insA += (ib - ia) * (stTop - yP0); insN++;
      }
      return { studs: studs, full: full, kings: kings };
    }
    /* the side walls (x = +- W/2, full length, the beam on top) */
    var sideIds = [];
    for (sx = -1; sx <= 1; sx += 2) {
      var sid = 'side-' + (sx < 0 ? 'l' : 'r'), yBmS = yBms(sx), yPS = yPTs(sx);   /* v370 mono: the left wall up by the roof's rise */
      wall(sid, di ? { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx, split: zP, ins: 'winsul' } : { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx }, -L / 2, L / 2, yBmS, dh ? null : { w: stuff.win }, 'beam', yPS);   /* v385 the dog house: no windows */   /* v388 the insulated one: a stud where the partition meets it, XPS */
      sideIds.push(sid);
      /* the beam: from the back to the porch's front (over its post) -- v370 mono: from the back fly rafter to the front one */
      if (mono) box('beam', PHk.BEAM, ceil2(zBf - zBb), 'beam-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), yBmS + bh / 2, (zBb + zBf) / 2, bw, bh, zBf - zBb);
      else box('beam', PHk.BEAM, ceil2(zF + L / 2), 'beam-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), yBm + bh / 2, (zF - L / 2) / 2, bw, bh, zF + L / 2);
      if (mono) coat += 2 * (bw + bh) * ((zBf - zF) + (-L / 2 - zBb));   /* its ends out in the open */
      if (porch) {
        /* the beam down into its post, two 8x200 */
        for (k = -1; k <= 1; k += 2) scr('screw-beam', PHk.BEAM_SCREW, sx * (W / 2 - p / 2) + k * p / 5, yPS, zF - p / 2, [0, -1, 0], lenBm);
        /* a 2x4 knee brace from the post's back face up under the beam at 45 deg (toward the house) */
        var ba = _phU(s, 'BRACE'), bk = P.sd / 2 * Math.SQRT2, zP = zF - p, wb = (function (yb0) { return function (u, v) { return [zP - u, yb0 + v]; }; })(yBmS);
        poly('brace', PHk.STUD, ceil2((ba + bk) * Math.SQRT2), 'brace-' + (sx < 0 ? 'l' : 'r'),
          [wb(0, -(ba + bk)), wb(0, -(ba - bk)), wb(ba - bk, 0), wb(ba + bk, 0)], 'zy', sx * (W / 2 - bw / 2), st);
        coat += 2 * (st + sd) * (ba + bk) * Math.SQRT2;
        var tA = wb(0.06, 0.06 - ba - bk), tB = wb(ba + bk - 0.06, -0.06);
        scr('screw-brace', PHk.BRACE_SCREW, sx * (W / 2 - bw / 2), tA[1], tA[0], [0, 0, 1], len160);
        if (dh) scr('screw-brace', PH.TIE_SCREW, sx * (W / 2 - bw / 2), tB[1], tB[0], [0, 1, 0], len80);   /* v385 the dog house: a 6x80 up into its flat 2x4 plate */
        else scr('screw-brace', PHk.BRACE_SCREW, sx * (W / 2 - bw / 2), tB[1], tB[0], [0, 1, 0], len160);
        coat += 4 * p * (yBmS - yB) + 2 * (bw + bh) * PD;   /* the posts and the beams' open part */
      }
    }
    /* the gable walls (between the side walls, a 2x4 top plate): the back with a window, the front with the door */
    var gl = W / 2 - sd;
    for (sz = -1; sz <= 1; sz += 2) {
      var gid = (sz < 0) ? 'back' : 'front';
      var gSide = { ax: 'x', c: sz * (L / 2 - sd / 2), o: sz };
      if (di) { gSide.ins = 'winsul'; if (sz > 0) gSide.km = { king: 'dking', header: 'dheader', 'screw-frame': 'screw-dframe' }; }   /* v388 the insulated dog house: XPS; the doorway's kings + header a frame of their own (screwed together first) */
      if (dd) gSide.split = 0;   /* v396 the double dog house: a stud each gable where the partition meets it */
      wall(gid, gSide, -gl, gl, yGT, dh ? ((sz < 0) ? null : dd ? { w: stuff.win, dog: true, us: uDs } : { w: stuff.win, dog: true, u: uD }) : (sz < 0) ? { w: stuff.win } : { w: RO, door: true }, 'tplate');   /* v396 the double's two doorways */   /* v385 the dog house: its doorway in the front, no back window */   /* v388 uD: the insulated one's at the right end */
      box('tplate', PHk.STUD, ceil2(2 * gl), gid + '-tplate', 0, yPT - st / 2, sz * (L / 2 - sd / 2), 2 * gl, st, sd);
      /* the corners: three 6x100 from the gable's end stud into the side wall's */
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) {
        if (di && sz > 0 && sx > 0) { scr('screw-frame', us ? PHk.FRAME_SCREW : PHk.STUD_SCREW, W / 2, yP0 + 0.10 + (yGT - yP0 - 0.20) * 0.5 * k, L / 2 - st / 2, [-1, 0, 0], us ? len100 : len120); continue; }   /* v388 the insulated dog house's front right corner: from the side wall's outside (the doorway's king stands against the gable's end stud) -- 6x120 (US 6x100) */
        scr('screw-frame', PHk.FRAME_SCREW, sx * (gl - st), dh ? yP0 + 0.10 + (yGT - yP0 - 0.20) * 0.5 * k : yP0 + (yGT - yP0) * (0.2 + 0.3 * k), sz * (L / 2 - st / 2), [sx, 0, 0], len100);   /* v385 the dog house: its low walls -- 10 cm clear of the stud screws up and the top's down */
      }
    }

    if (!mono) {
      /* THE ROOF FRAME: the rafter pairs at <= 60 cm from the back gable to
         the front one (and on over the porch to its front), the ridge board,
         a fly rafter past each gable */
      var zA = -L / 2 + st / 2, zB = L / 2 - st / 2, nr = Math.max(1, Math.ceil((zB - zA) / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
      if (di) {   /* v388 the insulated dog house: a pair just in front of the partition (its ceiling joist over the partition), the rest evenly each side */
        var zPr = zP + st, nra = Math.max(1, Math.ceil((zPr - zA) / _phU(s, 'RAF_SP') - 1e-9)), nrb = Math.max(1, Math.ceil((zB - zPr) / _phU(s, 'RAF_SP') - 1e-9));
        for (i = 0; i <= nra; i++) zr.push({ z: zA + (zPr - zA) * i / nra, gable: i === 0, part: i === nra });
        for (i = 1; i <= nrb; i++) zr.push({ z: zPr + (zB - zPr) * i / nrb, gable: i === nrb });
      } else
      for (i = 0; i <= nr; i++) zr.push({ z: zA + (zB - zA) * i / nr, gable: (i === 0 || i === nr) });
      if (porch) {
        var zC = zF - st / 2, nrp = Math.max(1, Math.ceil((zC - zB) / _phU(s, 'RAF_SP') - 1e-9));
        for (i = 1; i <= nrp; i++) zr.push({ z: zB + (zC - zB) * i / nrp, gable: false });
      }
      var rk = _phU(s, 'RAKE'), zFb = -(L / 2 + sg + rk) + st / 2, zFf = (porch ? zF : L / 2 + sg) + rk - st / 2;
      var rafL = ceil2((xo - xr) / cs);
      function rafPts(sxx, notch) {
        var pts = notch ? [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]]
                        : [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)]];
        pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
        if (sxx < 0) pts.reverse();
        return pts;
      }
      var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2;
      function ridgeToes(kind, code, zq) {
        var flyO = dh && (kind === 'screw-fly'), ko = (zq < 0) ? -1 : 1;   /* v385 the dog house: a fly rafter's both from its outer face (the coop's -- the rake board covers the other) */
        for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) {
          if (flyO) scr(kind, code, s3 * xtq, yTm + s3 * 0.025 * ((k3 < 0) ? 1 : 1 / 3), zq + ko * st / 2, [-s3 * tCo, 0, -ko * tSi], len80);
          else scr(kind, code, s3 * xtq, yTm + k3 * s3 * 0.025, zq + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
        }
      }
      for (i = 0; i < zr.length; i++) {
        for (sx = -1; sx <= 1; sx += 2) {
          poly('rafter', PHk.RAFTER, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx, true), 'xy', zr[i].z, st);
          var xm = (xh + W / 2) / 2;
          scr('screw-seat', PHk.SEAT_SCREW, sx * xm, yT(xm), zr[i].z, [0, -1, 0], lenSeat);   /* v385 the dog house: a 6x160 into its flat 2x4 */
        }
        ridgeToes('screw-rtoe', PHk.RIDGE_TOE, zr[i].z);
      }
      var flies = [zFb, zFf];
      for (i = 0; i < 2; i++) {
        for (sx = -1; sx <= 1; sx += 2) poly('fly', PHk.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rafPts(sx, false), 'xy', flies[i], st);
        ridgeToes('screw-fly', PHk.RIDGE_TOE, flies[i]);
      }
      coat += 4 * 2 * (st + sd) * rafL;   /* the fly rafters */
      var zR0 = zFb - st / 2, zR1 = zFf + st / 2, roofLen = zR1 - zR0;
      box('ridge', PHk.RIDGE, ceil2(roofLen), 'ridge', 0, rgTop - P.rgd / 2, (zR0 + zR1) / 2, P.rgt, P.rgd, roofLen);
      /* THE RAFTER TIES: 2x4 on edge on the beams beside every pair but over
         the gable walls, square ends where the rafter's top still clears it */
      var xt = xh + (dV - sd - 0.01) / tn, nTies = 0, cjz = [];
      for (i = 0; i < zr.length; i++) {
        if (zr[i].gable || (dh && !di)) continue;   /* v385 the dog house: none over the dog's head */   /* v388 the insulated one's: its ceiling joists */
        var zt = zr[i].part ? zP : zr[i].z - ((zr[i].z > 0) ? 1 : -1) * st;   /* v388 the partition's pair: its joist over the partition */
        cjz.push(zt);
        box('tie', PHk.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
        nTies++;
        for (sx = -1; sx <= 1; sx += 2) {
          for (k = 0; k < 2; k++) {
            var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
            scr('screw-tie', PHk.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt + ((zr[i].z > zt) ? -1 : 1) * st / 2, [0, 0, (zr[i].z > zt) ? 1 : -1], len80);
          }
          scr('screw-tie', PHk.TIE_DOWN, sx * Math.max(W / 2 - bw + 0.012, xt - 0.04), yPT + sd, zt, [0, -1, 0], len120);   /* v367 between the toe screws (the play fort's) */
        }
      }
      /* v388 the insulated dog house: a ceiling joist inside each gable (against its studs) -- the lining's edge on it; a 6x120 down
         into the plate at each end */
      if (di) for (sz = -1; sz <= 1; sz += 2) {
        var zE = sz * (L / 2 - sd - st / 2);
        cjz.push(zE);
        box('tie', PHk.STUD, ceil2(2 * xt), 'tie-e' + (sz < 0 ? 'b' : 'f'), 0, yPT + sd / 2, zE, 2 * xt, sd, st);
        nTies++;
        for (sx = -1; sx <= 1; sx += 2) scr('screw-tie', PHk.TIE_DOWN, sx * Math.max(W / 2 - bw + 0.012, xt - 0.04), yPT + sd, zE, [0, -1, 0], len120);
      }
      /* THE GABLE STUDS over each gable's top plate (every 30 cm, US 12 in.,
         from the middle), up to the end rafter's underside; a toe screw each
         side at the foot, one through the end rafter at the head */
      var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0;
      for (sz = -1; sz <= 1; sz += 2) {
        for (k = 1; ; k++) {
          var gx = k * gsp;
          if (gx + st / 2 > gl - st - 0.005 || yR(gx + st / 2) - yPT < 0.06) break;
          for (sx = -1; sx <= 1; sx += 2) {
            var gx0 = sx * (gx - st / 2), gx1 = sx * (gx + st / 2), gpts = [[gx0, yPT], [gx1, yPT], [gx1, yR(gx1)], [gx0, yR(gx0)]];
            if (sx < 0) gpts.reverse();
            poly('gstud', PHk.STUD, ceil2(yR(gx - st / 2) - yPT), 'gstud-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r') + k, gpts, 'xy', sz * (L / 2 - sd / 2), sd);
            gStuds++;
            for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', PHk.FRAME_SCREW, sx * gx + e3 * st / 2, yPT + ((dh && us) ? 0.055 : 0.04), sz * (L / 2 - sd / 2) + e3 * sd / 4, [-e3 * 0.5, -0.87, 0], len100);   /* v385 the dog house US: its tip in the plate (the coop's) */   /* v367 the two toes one in front of the other (they crossed) */
            scr('screw-gstud', PHk.FRAME_SCREW, sx * gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);   /* toe from the outside up into the end rafter */
          }
        }
      }

      /* v392 THE KENNEL'S RUN (after the roof frame: its screws keep clear of the rafters' seat screws). The sides: a 2x4 stud
         on the decking at each krZs, flush with the rim's outer face, toed down through the decking into the rim and up into the
         side plate (two each end, from the run's side). The front: a 2x4 rail on edge between the posts, its top the plates', its
         face the posts' -- a 6x160 through the plate and one through the post into each end. The gate under it (the coop's run
         door): a flat 2x4 frame -- stiles, a top + bottom rail, a brace rising from the hinge side -- two 6x160 through each stile
         into each rail's end, the brace toed into the rails; two strap hinges onto the left post's face, a barrel bolt (MISSING).
         The welded wire on the outside: each side from the rim's underside to the plate's top (from the house's corner board to
         the front post's face), the gable from the rail's underside up to the rafters and the ridge board, the gate's face;
         stapled round each sheet and along the studs (the coop's rate) */
      var krMeshA = 0, krStapleL = 0, krBolts = 0, krGate = null, kmo = CO.MESH_OFF, kmt = CO.MESH_T;
      function krMesh(id, pts, plane, c) {
        pieces.push({ kind: 'mesh', code: null, len: 0, id: id, poly: pts, plane: plane, c: c, t: kmt, holes: null });
        var a = _phArea(pts), q;
        for (q = 0; q < pts.length; q++) { var A = pts[q], B = pts[(q + 1) % pts.length]; krStapleL += Math.sqrt((B[0] - A[0]) * (B[0] - A[0]) + (B[1] - A[1]) * (B[1] - A[1])); }
        krMeshA += a;
      }
      if (kr) {
        var kyD = yJ1 + P.dk, kH = yBm - kyD;
        var kTA = Math.asin(Math.min(0.5, (st - 0.01) / len100)), kTB = Math.asin(Math.min(0.5, (st - 0.01) / len80));
        for (sx = -1; sx <= 1; sx += 2) krZs.forEach(function (zk, ik) {
          var kid = 'kstud-' + (sx < 0 ? 'l' : 'r') + (ik + 1), kxi = sx * (W / 2 - st);
          box('kstud', PHk.STUD, ceil2(kH), kid, sx * (W / 2 - st / 2), kyD + kH / 2, zk, st, kH, sd);
          coat += 2 * (st + sd) * kH;
          krStapleL += kH;   /* the wire stapled along it */
          [[0.025, 0.035, 0.015], [-0.025, -0.035, -0.015]].forEach(function (dzs) {
            scrClear('screw-kstud', PHk.FRAME_SCREW, dzs.map(function (dz) { return [kxi, kyD + 0.035, zk + dz]; }), [sx * Math.sin(kTA), -Math.cos(kTA), 0], len100);   /* down through the decking into the rim */
            scrClear('screw-kstud', PH.TIE_SCREW, dzs.map(function (dz) { return [kxi, yBm - 0.04, zk + dz]; }), [sx * Math.sin(kTB), Math.cos(kTB), 0], len80);       /* up into the plate */
          });
        });
        /* the front rail */
        var kr0 = W / 2 - p, kry = yPT - sd / 2, krz = zF - st / 2;
        box('krail', PHk.STUD, ceil2(2 * kr0), 'krail-f', 0, kry, krz, 2 * kr0, sd, st);
        coat += 2 * (st + sd) * 2 * kr0;
        for (sx = -1; sx <= 1; sx += 2) {
          scr('screw-krail', PHk.JOIST_SCREW, sx * W / 2, yBm + bh / 2, krz + st / 4, [-sx, 0, 0], len160);           /* through the plate (in front of the end rafter's seat screw) */
          scr('screw-krail', PHk.JOIST_SCREW, sx * W / 2, (yPT - sd + yBm) / 2, krz + st / 4, [-sx, 0, 0], len160);   /* through the post */
        }
        /* the gate */
        var gclr = _phU(s, 'GATE_CLR'), lx0 = -kr0 + gclr, lx1 = kr0 - gclr, ly0 = kyD + gclr, ly1 = yPT - sd - gclr, lz = zF - st / 2;
        krGate = { w: lx1 - lx0, h: ly1 - ly0 };
        box('gframe', PHk.STUD, ceil2(ly1 - ly0), 'gate-stile-l', lx0 + sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
        box('gframe', PHk.STUD, ceil2(ly1 - ly0), 'gate-stile-r', lx1 - sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
        box('gframe', PHk.STUD, ceil2(lx1 - lx0 - 2 * sd), 'gate-rail-b', (lx0 + lx1) / 2, ly0 + sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
        box('gframe', PHk.STUD, ceil2(lx1 - lx0 - 2 * sd), 'gate-rail-t', (lx0 + lx1) / 2, ly1 - sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
        coat += 2 * (st + sd) * (2 * (ly1 - ly0) + 2 * (lx1 - lx0 - 2 * sd));
        [ly0 + sd / 2, ly1 - sd / 2].forEach(function (yq) {
          for (var e13 = -1; e13 <= 1; e13 += 2) {
            scr('screw-gate', PHk.JOIST_SCREW, lx0, yq + e13 * sd / 4, lz, [1, 0, 0], len160);
            scr('screw-gate', PHk.JOIST_SCREW, lx1, yq + e13 * sd / 4, lz, [-1, 0, 0], len160);
          }
        });
        var bA = [lx0 + sd, ly0 + sd], bB = [lx1 - sd, ly1 - sd], bdx = bB[0] - bA[0], bdy = bB[1] - bA[1], bdl = Math.sqrt(bdx * bdx + bdy * bdy);
        var bnx = -bdy / bdl * sd / 2, bny = bdx / bdl * sd / 2, bex = bdx / bdl * sd, bey = bdy / bdl * sd;
        var bpb = [[bA[0] - bex + bnx, bA[1] - bey + bny], [bA[0] - bex - bnx, bA[1] - bey - bny], [bB[0] + bex - bnx, bB[1] + bey - bny], [bB[0] + bex + bnx, bB[1] + bey + bny]];
        bpb = _gzClip(bpb, 1, 0, -(lx0 + sd)); bpb = _gzClip(bpb, -1, 0, lx1 - sd); bpb = _gzClip(bpb, 0, 1, -(ly0 + sd)); bpb = _gzClip(bpb, 0, -1, ly1 - sd);
        if (_gzArea(bpb) < 0) bpb.reverse();
        poly('gframe', PHk.STUD, ceil2(bdl + sd), 'gate-brace', bpb, 'xy', lz, st);
        coat += 2 * (st + sd) * bdl;
        var hV = sd / 2 * bdl / bdx, yBa = bA[1] + 0.07 * bdy / bdx, yBb = bB[1] - 0.07 * bdy / bdx;
        scr('screw-gate', PH.TIE_SCREW, bA[0] + 0.07, Math.max(ly0 + sd + 0.005, yBa - hV + 0.012), lz, [0, -1, 0], len80);   /* down through the brace's foot into the bottom rail */
        scr('screw-gate', PH.TIE_SCREW, bB[0] - 0.07, Math.min(ly1 - sd - 0.005, yBb + hV - 0.012), lz, [0, 1, 0], len80);    /* up through its head into the top rail */
        krMesh('mesh-gate', [[lx0, ly0], [lx1, ly0], [lx1, ly1], [lx0, ly1]], 'xy', zF + kmo + kmt / 2);
        var rhl = 0.30, rhw = 0.035, rhT = 0.003, zHw = zF + kmo + kmt + 0.002;
        [ly0 + sd / 2, ly1 - sd / 2].forEach(function (hy, qi) {
          hw.push({ kind: 'hinge', code: PHk.HINGE, box: [lx0 + rhl / 2 - 0.02, hy, zHw + rhT / 2, rhl, rhw, rhT], id: 'gate-hinge-' + (qi * 2) });
          hw.push({ kind: 'hinge', code: null, box: [-W / 2 + p / 2, hy, zHw + rhT / 2, p * 0.8, rhw * 1.6, rhT], id: 'gate-hinge-leaf-' + (qi * 2) });
          hinges++;
          for (var h5 = 0; h5 < 3; h5++) {
            scr('screw-hinge', PHk.HINGE_SCREW, lx0 + 0.01 + h5 * 0.11, hy, zHw + rhT, [0, 0, -1], len40, 0.0022);
            var hx5 = -W / 2 + p / 2 + (h5 - 1) * 0.02, hy5 = hy + (h5 - 1) * 0.012;
            scrClear('screw-hinge', PHk.HINGE_SCREW, [[hx5, hy5], [hx5, hy5 - 0.006], [hx5 + 0.008, hy5], [hx5 - 0.008, hy5]].map(function (c6) { return [c6[0], c6[1], zHw + rhT]; }), [0, 0, -1], len40, 0.0022);
          }
        });
        hw.push({ kind: 'bolt', code: null, box: [lx1, (ly0 + ly1) / 2, zF + kmo + 0.009, 0.11, 0.03, 0.014], id: 'gate-bolt' });
        krBolts++;
        /* the welded wire: the sides, the gable over the rail */
        var kzM = L / 2 + sg + tt + 0.002;
        for (sx = -1; sx <= 1; sx += 2) krMesh('mesh-s' + (sx < 0 ? 'l' : 'r'), [[kzM, yB], [zF, yB], [zF, yPT], [kzM, yPT]], 'zy', sx * (W / 2 + kmo + kmt / 2));
        krMesh('mesh-f', [[-W / 2, yPT - sd], [W / 2, yPT - sd], [W / 2, yPT], [xh, yPT], [xr, yR(xr)], [xr, rgBot], [-xr, rgBot], [-xr, yR(xr)], [-xh, yPT], [-W / 2, yPT]], 'xy', zF + kmo + kmt / 2);
        missing.push(us ? { name: KR.MESH_NAME, qty: Math.round(krMeshA * PH.WASTE * 10.7639 * 100) / 100, unit: 'ft2' } : { name: KR.MESH_NAME, qty: Math.round(krMeshA * PH.WASTE * 100) / 100, unit: 'm2' });
        missing.push({ name: CO.BOLT_NAME, qty: krBolts, unit: 'pcs' });
      }

      /* v396 THE DOUBLE DOG HOUSE'S PARTITION along the middle (after the roof frame: its screws keep clear of the rafters' toe
         screws in the ridge board): a 2x4 frame between the gables' inner faces -- the bottom plate on the floor, studs at <= 60 cm,
         the top plate right under the ridge board (it carries it) -- built flat (two 6x120 through each plate into each stud's end),
         stood up: 6x120 down through the plate and the floor into each joist it crosses (beside the studs), three 6x100 from each
         end stud into the gable's stud there, 6x100 up through the top plate into the ridge board between the studs; OSB on its
         left face from the floor up to the ridge board */
      var ddLinA = 0, ddStuds = 0, ddMid = null;
      if (dd) {
        var mz0 = -(L / 2 - sd), mz1 = L / 2 - sd, myT = rgBot, mH = myT - st - yP0, rsM = P.rs;
        var mzs = _phGrid(mz0, mz1, _phU(s, 'STUD_SP'), st);
        box('mplate', PHk.STUD, ceil2(mz1 - mz0), 'mid-plate', 0, yF + st / 2, 0, sd, st, mz1 - mz0);
        box('mtplate', PHk.STUD, ceil2(mz1 - mz0), 'mid-tplate', 0, myT - st / 2, 0, sd, st, mz1 - mz0);
        mzs.forEach(function (zq, iq) {
          box('mstud', PHk.STUD, ceil2(mH), 'mid-stud-' + (iq + 1), 0, yP0 + mH / 2, zq, sd, mH, st);
          ddStuds++;
          for (var e7 = -1; e7 <= 1; e7 += 2) {
            scr('screw-mframe', PHk.STUD_SCREW, e7 * sd / 4, yF, zq, [0, 1, 0], len120);     /* up through the bottom plate */
            scr('screw-mframe', PHk.STUD_SCREW, e7 * sd / 4, myT, zq, [0, -1, 0], len120);   /* down through the top plate */
          }
        });
        var offStud = function (zq) { return mzs.every(function (z8) { return Math.abs(zq - z8) > st / 2 + 0.008; }); };
        joists.forEach(function (q8) {
          if (q8.z < mz0 + 0.03 || q8.z > mz1 - 0.03) return;
          var cz = [0, 0.01, -0.01, jt / 2 - 0.006, -(jt / 2 - 0.006)].map(function (dz) { return q8.z + dz; }).filter(offStud);   /* within the joist's thickness, beside the studs */
          if (cz.length) scrClear('screw-mfix', PHk.STUD_SCREW, cz.map(function (zq) { return [0, yP0, zq]; }), [0, -1, 0], len120);   /* down into the joist */
        });
        for (k = 0; k < 3; k++) {
          var myk = yP0 + 0.10 + (yGT - yP0 - 0.20) * 0.5 * k;
          scr('screw-mfix', PHk.FRAME_SCREW, 0, myk, mz0 + st, [0, 0, -1], len100);   /* the back end stud into the back gable's */
          scr('screw-mfix', PHk.FRAME_SCREW, 0, myk, mz1 - st, [0, 0, 1], len100);    /* the front's into the front gable's */
        }
        for (i = 0; i + 1 < mzs.length; i++) {
          var zmid = (mzs[i] + mzs[i + 1]) / 2, gap = mzs[i + 1] - mzs[i] - st;
          if (gap < 0.05) continue;
          scrClear('screw-mridge', PHk.FRAME_SCREW, [0, 0.02, -0.02, 0.04, -0.04].filter(function (dz) { return Math.abs(dz) < gap / 2 - 0.01; }).map(function (dz) { return [0, myT - st, zmid + dz]; }), [0, 1, 0], len100);   /* up into the ridge board */
        }
        box('mlining', DI.LINING, 0, 'mid-lining', -(sd / 2 + rsM / 2), (yF + myT) / 2, 0, rsM, myT - yF, mz1 - mz0);
        ddLinA = (myT - yF) * (mz1 - mz0);
        ddMid = { z0: mz0, z1: mz1, h: myT - yF, studs: mzs.length };
      }

      /* THE ROOF'S LAYERS: the OSB from the ridge line to past the fascia,
         the shingles over the underlay (drawn as one surface), the drip edge;
         the eave fascia on the tails, a rake board on each fly rafter */
      var rs = P.rs, rsV = rs / cs, slope = xe / cs, ze0 = zR0 - tt, ze1 = zR1 + tt, eLen = ze1 - ze0;
      for (sx = -1; sx <= 1; sx += 2) {
        var sp = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) + rsV], [0, yT(0) + rsV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) sp.reverse();
        poly('sheath', PHk.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), sp, 'xy', (ze0 + ze1) / 2, eLen);
        /* the shingles: a surface over the OSB, 1 cm past it (the course bands along the eave) */
        var xs1 = xe + 0.01, ysh = rsV + 0.003;
        pieces.push({ kind: 'cover', code: PHk.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r'),
          quad: [[0, yT(0) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze1 + 0.01], [0, yT(0) + ysh, ze1 + 0.01]],
          uv: [[(ze0 - 0.01) / (8 * PHk.TAB), xs1 / cs / (8 * PHk.EXPO)], [(ze0 - 0.01) / (8 * PHk.TAB), 0], [(ze1 + 0.01) / (8 * PHk.TAB), 0], [(ze1 + 0.01) / (8 * PHk.TAB), xs1 / cs / (8 * PHk.EXPO)]] });
        /* the eave fascia on the tails (flush with the rafters' top), two stainless screws a tail */
        box('fascia', PHk.BOARD, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, (zR0 + zR1) / 2, tt, cw, roofLen);
        coat += 2 * (tt + cw) * roofLen;
        for (i = 0; i < zr.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PHk.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), zr[i].z, [-sx, 0, 0], len50);
        for (i = 0; i < 2; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PHk.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), flies[i], [-sx, 0, 0], len50);
        /* the drip edge along the eave (drawn as its face) */
        pieces.push({ kind: 'drip', code: PHk.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
        /* the rake boards: on each fly rafter's outer face, flush with its top */
        for (i = 0; i < 2; i++) {
          var zc2 = (i === 0) ? zR0 - tt / 2 : zR1 + tt / 2, cwV = cw / cs;
          var rpb = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) - cwV], [0, yT(0) - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
          if (sx < 0) rpb.reverse();
          poly('fascia', PHk.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rpb, 'xy', zc2, tt);
          coat += 2 * (tt + cw) * slope;
          var fx = fixPts(0.08, xo - 0.04, _phU(s, 'FIX_SP'));
          for (k = 0; k < fx.length; k++) scr('screw-fascia', PHk.FASCIA_SCREW, sx * fx[k], yT(fx[k]) - cwV / 2, (i === 0) ? zR0 - tt : zR1 + tt, [0, 0, (i === 0) ? 1 : -1], len50);
          var dpb = [[0, yT(0) + rsV], [xe, yT(xe) + rsV], [xe, yT(xe) + rsV - 0.055], [0, yT(0) + rsV - 0.055]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
          if (sx < 0) dpb.reverse();
          poly('drip', PHk.DRIP, 0, 'drip-r' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), dpb, 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
        }
      }
      /* the cap shingles along the ridge (two strips, drawn over the peak) */
      var capH = PHk.CAP_W / 2;
      for (sx = -1; sx <= 1; sx += 2) {
        var cx1 = capH * cs, ycap = rsV + 0.008;
        pieces.push({ kind: 'cover', code: PHk.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
          quad: [[0, yT(0) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT(0) + ycap, ze1]],
          uv: [[ze0 / PHk.CAP_EXPO / 8, 0.12], [ze0 / PHk.CAP_EXPO / 8, 0], [ze1 / PHk.CAP_EXPO / 8, 0], [ze1 / PHk.CAP_EXPO / 8, 0.12]] });
      }
      var roofA = 2 * slope * eLen, capA = eLen * PHk.CAP_W, capNails = Math.ceil(eLen / PHk.CAP_EXPO) * PHk.CAP_NAILS;
      var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PHk.DRIP_FIX);

      /* THE SIDING straight on the studs, from the rims' underside: the side
         walls up to the rafters' underside, the gables up to the rafters' top
         (a notch for the ridge board); the openings cut out */
      var y0 = yB, ySide = yR(xa) - 0.005, yTrim = yR(xa + tt) - 0.005, sidingA = 0, hW = stuff.win / 2;
      for (sx = -1; sx <= 1; sx += 2) {
        var so = [[-L / 2, y0], [L / 2, y0], [L / 2, ySide], [-L / 2, ySide]], sh1 = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]];
        poly('siding', PHk.SIDING, 0, 'siding-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg, dh ? null : [sh1]);   /* v385 the dog house: no window */
        sidingA += _phArea(so) - (dh ? 0 : _phArea(sh1));
      }
      /* (with the porch the front gable's siding stops on the decking -- the
         rims and the porch joists run on under it -- and the door is a notch) */
      var y0f = porch ? yJ1 + P.dk : y0;
      for (sz = -1; sz <= 1; sz += 2) {
        var xr2 = P.rgt / 2 + 0.002, yb2 = (sz > 0) ? y0f : y0, go, gh = null, gh2 = null;
        var gTop = [[xa, yT(xa)], [xr2, yT(xr2)], [xr2, rgBot], [-xr2, rgBot], [-xr2, yT(xr2)], [-xa, yT(xa)]];
        if (sz < 0) { go = [[-xa, yb2], [xa, yb2]].concat(gTop); gh = dh ? null : [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]]; }   /* v385 the dog house: a plain back */
        else if (dh) {   /* v385 the dog house's front: the doorway a hole over the bottom plate (with the porch on the decking, notched round the top plates running on) */
          go = porch ? [[-xa, yb2], [xa, yb2], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [xa, yPT]].concat(gTop, [[-xa, yPT], [-(W / 2 - bw), yPT], [-(W / 2 - bw), yBm], [-xa, yBm]])
                     : [[-xa, yb2], [xa, yb2]].concat(gTop);
          gh = [[uDs[0] - hW, yWS], [uDs[0] + hW, yWS], [uDs[0] + hW, yWT], [uDs[0] - hW, yWT]];   /* v388 uD (0 but the insulated one's) */
          if (dd) gh2 = [[uDs[1] - hW, yWS], [uDs[1] + hW, yWS], [uDs[1] + hW, yWT], [uDs[1] - hW, yWT]];   /* v396 the double's second doorway */
        }
        else if (porch) go = [[-xa, yb2], [-RO / 2, yb2], [-RO / 2, yHd], [RO / 2, yHd], [RO / 2, yb2], [xa, yb2], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [xa, yPT]]
                           .concat(gTop, [[-xa, yPT], [-(W / 2 - bw), yPT], [-(W / 2 - bw), yBm], [-xa, yBm]]);   /* notched round the beams running on to the porch */
        else { go = [[-xa, yb2], [xa, yb2]].concat(gTop); gh = [[-RO / 2, yF], [RO / 2, yF], [RO / 2, yHd], [-RO / 2, yHd]]; }
        poly('siding', PHk.SIDING, 0, 'siding-' + (sz < 0 ? 'b' : 'f'), go, 'xy', sz * (L / 2 + sg / 2), sg, gh ? (gh2 ? [gh, gh2] : [gh]) : null);   /* v396 + gh2 */
        sidingA += _phArea(go) - (gh ? _phArea(gh) : 0) - (gh2 ? _phArea(gh2) : 0);
      }
      coat += sidingA;
      /* THE CORNER BOARDS: two a corner, the gable's lapping the side's edge, up to the side siding's top */
      var cH = yTrim - y0, nTrim = 0;
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var gy0 = (sz > 0) ? y0f : y0, gH = ((sz > 0 && porch) ? yBm : yTrim) - gy0;
        box('trim', PHk.TRIM, ceil2(gH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), gy0 + gH / 2, sz * (L / 2 + sg + tt / 2), tw, gH, tt);
        box('trim', PHk.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), y0 + cH / 2, sz * (L / 2 + sg - tw / 2), tt, cH, tw);
        nTrim += 2;
        coat += 2 * (tt + tw) * (cH + gH);
        var ty = fixPts(y0 + 0.08, yTrim - 0.08, _phU(s, 'FIX_SP')), tyg = fixPts(gy0 + 0.08, gy0 + gH - 0.08, _phU(s, 'FIX_SP'));
        for (k = 0; k < tyg.length; k++) scr('nail-trim', PHk.TRIM_NAIL, sx * (xa + tt - tw / 2), tyg[k], sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
        for (k = 0; k < ty.length; k++) scr('nail-trim', PHk.TRIM_NAIL, sx * (xa + tt), ty[k], sz * (L / 2 + sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
      }
    } else {
      /* v370 THE MONO-PITCH ROOF (the modern house's, _mdLayout): one-piece 2x6 rafters at <= 60 cm from the back gable to the front
         one (and on over the porch to its front), a fly rafter on each beam end -- all the same piece: the tails cut plumb, a birdsmouth
         on each beam, one 8x200 down into each beam; no ridge, no ties; gable studs over each gable's top plate up to the end rafter */
      var rafSp = dmDeck ? _dmU(s, 'RAF_SP') : _phU(s, 'RAF_SP');   /* v403 the modern dog house's roof deck: its sleepers on rafters at <= 40 cm */
      var zA = -L / 2 + st / 2, zB = L / 2 - st / 2, nr = Math.max(1, Math.ceil((zB - zA) / rafSp - 1e-9)), zr = [];
      for (i = 0; i <= nr; i++) zr.push({ z: zA + (zB - zA) * i / nr, gable: (i === 0 || i === nr) });
      if (porch) {
        var zC = zF - st / 2, nrp = Math.max(1, Math.ceil((zC - zB) / _phU(s, 'RAF_SP') - 1e-9));
        for (i = 1; i <= nrp; i++) zr.push({ z: zB + (zC - zB) * i / nrp, gable: false });
      }
      var rafL = ceil2(2 * xo / cs + rjh * tn), rafC = dm ? PHk.RAFTER : MD.RAFTER;   /* v403 the modern dog house: one-piece 2x4 rafters */
      var rafPts = [[-xo, yR(-xo)], [xL0, yPTL], [xiL, yPTL], [xiL, yR(xiL)], [xh, yPT], [W / 2, yPT], [W / 2, yR(W / 2)], [xo, yR(xo)], [xo, yT(xo)], [-xo, yT(-xo)]];
      var xmR = W / 2 - 0.28 * seat, xmL = xL0 + 0.28 * seat;
      /* v403 the modern dog house's 2x4 rafters over its flat 2x4 plates: the longest of 6x160 / 120 / 100 / 80 that stays in the plate
         (at least 15 mm into it, 8 mm off its underside) -- its code by its length */
      var seatLen = function (dAb) { var c4 = [len160, len120, len100, len80], m4; for (m4 = 0; m4 < c4.length; m4++) if (c4[m4] <= dAb + bh - 0.008 && c4[m4] >= dAb + 0.015) return c4[m4]; return len100; };
      var scode6 = function (ln) { return (ln === len160) ? 'FAS60160' : (ln === len120) ? 'FAS60120' : (ln === len100) ? 'FAS60100' : 'FAS60080'; };
      var lsR = dm ? seatLen(yT(xmR) - yPT) : len200, lsL = dm ? seatLen(yT(xmL) - yPTL) : len200;
      var seatScrews = function (kind, zq) {
        scr(kind, dm ? scode6(lsR) : PHk.SEAT_SCREW, xmR, yT(xmR), zq, [0, -1, 0], lsR);
        scr(kind, dm ? scode6(lsL) : PHk.SEAT_SCREW, xmL, yT(xmL), zq, [0, -1, 0], lsL);
      };
      for (i = 0; i < zr.length; i++) {
        poly('mrafter', rafC, rafL, 'rafter-' + (i + 1), rafPts, 'xy', zr[i].z, st);
        seatScrews('screw-seat', zr[i].z);
      }
      var flies = [zFbM, zFfM];
      for (i = 0; i < 2; i++) {
        poly('mfly', rafC, rafL, 'fly-' + (i ? 'f' : 'b'), rafPts, 'xy', flies[i], st);
        seatScrews('screw-mfly', flies[i]);
      }
      coat += 2 * 2 * (st + rjh) * rafL;   /* the fly rafters */
      var nTies = 0, gsp = _phU(s, 'GSTUD_SP'), gStuds = 0;
      for (sz = -1; sz <= 1; sz += 2) {
        for (k = 1; ; k++) {
          var gx = xh - k * gsp, gx0 = gx - st / 2, gx1 = gx + st / 2;
          if (gx0 < -gl + 0.005) break;
          if (yR(gx1) - yPT < 0.06) continue;
          poly('gstud', PHk.STUD, ceil2(yR(gx0) - yPT), 'gstud-' + (sz < 0 ? 'b' : 'f') + k, [[gx0, yPT], [gx1, yPT], [gx1, yR(gx1)], [gx0, yR(gx0)]], 'xy', sz * (L / 2 - sd / 2), sd);
          gStuds++;
          for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', (dm && us) ? 'FAS60080' : PHk.FRAME_SCREW, gx + e3 * st / 2, yPT + 0.04, sz * (L / 2 - sd / 2) + e3 * sd / 4, [-e3 * 0.5, -0.87, 0], (dm && us) ? len80 : len100);   /* the two toes one in front of the other */   /* v403 the modern dog house in US units: 3 in. (its plate 1 1/2 in.) */
          scr('screw-gstud', PHk.FRAME_SCREW, gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);   /* toe from the outside up into the end rafter */
        }
      }
      /* THE ROOF'S LAYERS: the OSB to past the fascia, the metal sheet over the underlay (one surface) with a standing seam every pan,
         the drip edge round it; the 1x6 fascia on the tails, a rake board on each fly rafter (and the beam's end under it) */
      var rs = P.rs, rsV = rs / cs, slope = 2 * xe / cs, zR0 = zBb, zR1 = zBf, roofLen = zR1 - zR0, ze0 = zR0 - fbT, ze1 = zR1 + fbT, eLen = ze1 - ze0;
      poly('sheath', PHk.ROOF, 0, 'sheath', [[-xe, yT(-xe)], [xe, yT(xe)], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (ze0 + ze1) / 2, eLen);
      var mT = MD.SEAM_T / cs, sH = MD.SEAM_H / cs, xsM = xe + 0.01;
      var yC = function (x) { return yT(x) + rsV + 0.002; };
      var nPan = 1;
      if (!dmDeck) {   /* v403 (the modern dog house's roof deck: the EPDM below instead) */
      poly('mcover', MD.SEAM, 0, 'cover', [[-xsM, yC(-xsM)], [xsM, yC(xsM)], [xsM, yC(xsM) + mT], [-xsM, yC(-xsM) + mT]], 'xy', (ze0 + ze1) / 2, eLen + 0.02);
      var pan = _mdU(s, 'SEAM_PAN');
      nPan = Math.max(1, Math.ceil((eLen + 0.02) / pan - 1e-9));
      for (k = 1; k < nPan; k++) poly('seam', null, 0, 'seam-' + k, [[-xsM, yC(-xsM) + mT], [xsM, yC(xsM) + mT], [xsM, yC(xsM) + mT + sH], [-xsM, yC(-xsM) + mT + sH]], 'xy', ze0 - 0.01 + (eLen + 0.02) * k / nPan, MD.SEAM_W);
      }
      var tails = zr.map(function (r2) { return r2.z; }).concat(flies), dOff = dmDeck ? DM.EPDM_T : 0;   /* v403 the drip edge out over the membrane's turn-down */
      for (sx = -1; sx <= 1; sx += 2) {
        var yFt = (sx > 0) ? yT(xe) : yT(-xo);   /* flush with the rafters' top at the tails (the high side's under the OSB's edge) */
        if (dmDeck) {
          /* v403 THE ROOF DECK'S EAVE RIM: a 2x6 on the tails in the fascia's place (the guard's balusters screw into its lower part,
             the ramp hangs on the right one), two 6x120 through it into each tail */
          box('erim', DM.ERIM, ceil2(roofLen), 'erim-' + (sx < 0 ? 'l' : 'r'), sx * (xo + jt / 2), yFt - jh / 2, (zR0 + zR1) / 2, jt, jh, roofLen);
          coat += 2 * (jt + jh) * roofLen;
          for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-erim', DM.ERIM_SCREW, sx * xe, yFt - dV * (0.25 + 0.30 * k), tails[i], [-sx, 0, 0], len120);   /* (over the rake boards' screws into the fly rafters) */
        } else {
        box('mfascia', MD.FASCIA, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + fbT / 2), yFt - fbW / 2, (zR0 + zR1) / 2, fbT, fbW, roofLen);
        coat += 2 * (fbT + fbW) * roofLen;
        for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PHk.FASCIA_SCREW, sx * xe, yFt - (dm ? dV * (0.22 + 0.36 * k) : fbW * (0.25 + 0.35 * k)), tails[i], [-sx, 0, 0], len50);   /* v403 the modern dog house: within its 2x4 tails */
        }
        pieces.push({ kind: 'drip', code: PHk.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + dOff + 0.0015), yT(sx * xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      }
      var fbV = fbW / cs;
      for (i = 0; i < 2; i++) {
        var zc2 = (i === 0) ? zR0 - fbT / 2 : zR1 + fbT / 2;
        poly('mfascia', MD.FASCIA, ceil2(slope + fbW * tn), 'rake-' + (i ? 'f' : 'b'), [[-xe, yT(-xe) - fbV], [xe, yT(xe) - fbV], [xe, yT(xe)], [-xe, yT(-xe)]], 'xy', zc2, fbT);
        coat += 2 * (fbT + fbW) * slope;
        var fx = fixPts(-xo + 0.06, xo - 0.06, _phU(s, 'FIX_SP'));
        for (k = 0; k < fx.length; k++) scr('screw-fascia', PHk.FASCIA_SCREW, fx[k], yT(fx[k]) - fbV / 2, (i === 0) ? zR0 - fbT : zR1 + fbT, [0, 0, (i === 0) ? 1 : -1], len50);
        poly('drip', PHk.DRIP, 0, 'drip-r' + (i ? 'f' : 'b'), [[-xe, yT(-xe) + rsV - 0.055], [xe, yT(xe) + rsV - 0.055], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (i === 0) ? ze0 - dOff - 0.0015 : ze1 + dOff + 0.0015, 0.003);
      }
      var roofA = slope * eLen, capA = 0, capNails = 0, dripL = 2 * eLen + 2 * slope, dripNails = Math.ceil(dripL / PHk.DRIP_FIX);
      var topM = yC(-xsM) + mT + sH + 0.005;
      /* THE SIDING straight on the studs, from the rims' underside up to the rafters' underside on the side walls, to their top on the
         gables (notched round the beams running past them); the openings cut out (the cottage's: a window each side and in the back) */
      var y0 = yB, sidingA = 0, hW = stuff.win / 2;
      var ySideAt = function (xx) { return Math.min(yR(xx), yR((xx > 0) ? W / 2 : -W / 2)) - 0.005; };   /* under the lowest rafter underside over that face */
      var y0f = porch ? yJ1 + P.dk : y0;
      if (dm) {
        /* v403 THE MODERN DOG HOUSE'S CLADDING: horizontal boards (FVW01351) straight on the studs, every wall's rows from the rims'
           underside (one coursing all round), each row the wall's outline clipped to its band less the openings -- the side walls up to
           the rafters' underside, the gables up to their top (notched round the plates running past), the doorway cut out */
        var cov = _dmU(s, 'CLAD_COV');
        snapY = function (y) { var r7 = ((y - y0) % cov + cov) % cov; if (r7 > cov - 0.0045) return y - (r7 - (cov - 0.0045)); if (r7 < 0.0015) return y + (0.0015 - r7); return y; };
        var cladRows = function (id, outline, holes, plane, c) {
          var yLo = y0, yHi = Math.max.apply(null, outline.map(function (q7) { return q7[1]; })), k7;
          for (k7 = 0; yLo + k7 * cov < yHi - 0.005; k7++) {
            var ya7 = yLo + k7 * cov, yb7 = Math.min(ya7 + cov - 0.003, yHi);
            var band = _gzClip(_gzClip(outline, 0, 1, -ya7), 0, -1, yb7);
            if (band.length < 3 || Math.abs(_gzArea(band)) < 1e-5) continue;
            var parts = [band];
            holes.forEach(function (h7) { parts = [].concat.apply([], parts.map(function (pc7) { return _gzDiff(pc7, h7); })); });
            parts = parts.filter(function (pc7) { return Math.abs(_gzArea(pc7)) > 1e-5; });
            parts.forEach(function (pc7, i7) { poly('siding', DM.CLAD, 0, id + '-' + (k7 + 1) + (i7 ? '-' + (i7 + 1) : ''), pc7, plane, c, sg); });
          }
          cladA += _phArea(outline) - holes.reduce(function (a7, h7) { return a7 + _phArea(h7); }, 0);
        };
        for (sx = -1; sx <= 1; sx += 2) {
          var ySdC = ySideAt(sx * xa);
          cladRows('clad-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, y0], [L / 2, y0], [L / 2, ySdC], [-L / 2, ySdC]], [], 'zy', sx * (W / 2 + sg / 2));
        }
        for (sz = -1; sz <= 1; sz += 2) {
          var gHoles = [[[W / 2 - bw, yBms(1)], [xa, yBms(1)], [xa, yPT], [W / 2 - bw, yPT]], [[-xa, yBms(-1)], [-(W / 2 - bw), yBms(-1)], [-(W / 2 - bw), yPTL], [-xa, yPTL]]];
          if (sz > 0) gHoles.push([[uD - hW, yWS], [uD + hW, yWS], [uD + hW, yWT], [uD - hW, yWT]]);
          cladRows('clad-' + (sz < 0 ? 'b' : 'f'), [[-xa, y0], [xa, y0], [xa, yT(xa)], [-xa, yT(-xa)]], gHoles, 'xy', sz * (L / 2 + sg / 2));
        }
        coat += cladA;
      } else {
      for (sx = -1; sx <= 1; sx += 2) {
        var ySd = ySideAt(sx * xa), so = [[-L / 2, y0], [L / 2, y0], [L / 2, ySd], [-L / 2, ySd]], sh1 = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]];
        poly('siding', PHk.SIDING, 0, 'siding-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg, [sh1]);
        sidingA += _phArea(so) - _phArea(sh1);
      }
      for (sz = -1; sz <= 1; sz += 2) {
        var yb2 = (sz > 0) ? y0f : y0, go = [[-xa, yb2]], gh = null;
        if (sz > 0 && porch) go.push([-RO / 2, yb2], [-RO / 2, yHd], [RO / 2, yHd], [RO / 2, yb2]);   /* the door a notch over the decking */
        go.push([xa, yb2], [xa, yBms(1)], [W / 2 - bw, yBms(1)], [W / 2 - bw, yPT], [xa, yPT], [xa, yT(xa)], [-xa, yT(-xa)],
                [-xa, yPTL], [-(W / 2 - bw), yPTL], [-(W / 2 - bw), yBms(-1)], [-xa, yBms(-1)]);
        if (sz < 0) gh = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]];
        else if (!porch) gh = [[-RO / 2, yF], [RO / 2, yF], [RO / 2, yHd], [-RO / 2, yHd]];
        poly('siding', PHk.SIDING, 0, 'siding-' + (sz < 0 ? 'b' : 'f'), go, 'xy', sz * (L / 2 + sg / 2), sg, gh ? [gh] : null);
        sidingA += _phArea(go) - (gh ? _phArea(gh) : 0);
      }
      coat += sidingA;
      }
      /* THE CORNER BOARDS: two a corner -- the gable's up to under the beam running past it, the side's up to the side siding's top */
      var nTrim = 0;
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var gy0 = (sz > 0) ? y0f : y0, gH = yBms(sx) - gy0, yTr = ySideAt(sx * (xa + tt)), cH = yTr - y0;
        box('trim', PHk.TRIM, ceil2(gH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), gy0 + gH / 2, sz * (L / 2 + sg + tt / 2), tw, gH, tt);
        box('trim', PHk.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), y0 + cH / 2, sz * (L / 2 + sg - tw / 2), tt, cH, tw);
        nTrim += 2;
        coat += 2 * (tt + tw) * (cH + gH);
        var ty = fixPts(y0 + 0.08, yTr - 0.08, _phU(s, 'FIX_SP')), tyg = fixPts(gy0 + 0.08, gy0 + gH - 0.08, _phU(s, 'FIX_SP'));
        for (k = 0; k < tyg.length; k++) scr('nail-trim', PHk.TRIM_NAIL, sx * (xa + tt - tw / 2), snapY(tyg[k]), sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
        for (k = 0; k < ty.length; k++) scr('nail-trim', PHk.TRIM_NAIL, sx * (xa + tt), snapY(ty[k]), sz * (L / 2 + sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
      }
      /* v403 THE MODERN DOG HOUSE'S ROOF DECK (its toggle): the EPDM over the OSB in one piece, turned down over the rims and the rake
         boards under the drip edge; the deck floats on it (no screw through it) -- 38x38 sleepers over the rafters, decking across them;
         the guard boxes it in -- 38x38 balusters on the rims' and the rake boards' outer faces, a 2x4 cap rail flat on their tops, open
         at the ramp; the ramp off the right (low) eave -- two 2x6 stringers in joist hangers on the rim, their feet cut level on deck
         blocks, decking across them, a cleat on every board */
      if (dmDeck) {
        var yOs = function (x) { return yT(x) + rsV; }, mV = DM.EPDM_T / cs, yMm = function (x) { return yOs(x) + mV; };
        var slT = _dmU(s, 'BAL'), slV = slT / cs, dkV = P.dk / cs, ySl = function (x) { return yMm(x) + slV; }, yDk = function (x) { return ySl(x) + dkV; };
        var turn = _dmU(s, 'EPDM_TURN'), zM = (ze0 + ze1) / 2;
        poly('epdm', null, 0, 'epdm', [[-xe, yOs(-xe)], [xe, yOs(xe)], [xe, yMm(xe)], [-xe, yMm(-xe)]], 'xy', zM, eLen);
        for (sx = -1; sx <= 1; sx += 2) box('epdm', null, 0, 'epdm-e-' + (sx < 0 ? 'l' : 'r'), sx * (xe + DM.EPDM_T / 2), yOs(sx * xe) - turn / 2, zM, DM.EPDM_T, turn, eLen);
        for (i = 0; i < 2; i++) poly('epdm', null, 0, 'epdm-r' + (i ? 'f' : 'b'), [[-xe, yOs(-xe) - turn], [xe, yOs(xe) - turn], [xe, yOs(xe)], [-xe, yOs(-xe)]], 'xy', i ? ze1 + DM.EPDM_T / 2 : ze0 - DM.EPDM_T / 2, DM.EPDM_T);
        dmEpdmA = roofA + (2 * eLen + 2 * slope) * turn;
        missing.push(us ? { name: DM.EPDM_NAME, qty: Math.round(dmEpdmA * PH.WASTE * 10.7639 * 100) / 100, unit: 'ft2' } : { name: DM.EPDM_NAME, qty: Math.round(dmEpdmA * PH.WASTE * 100) / 100, unit: 'm2' });
        /* the sleepers: one over each rafter and fly rafter, the roof's width less 1 cm each end */
        var slX0 = -xe + 0.01, slX1 = xe - 0.01;
        tails.forEach(function (zq, i8) {
          poly('sleeper', DM.SLEEPER, ceil2((slX1 - slX0) / cs), 'sleeper-' + (i8 + 1), [[slX0, yMm(slX0)], [slX1, yMm(slX1)], [slX1, ySl(slX1)], [slX0, ySl(slX0)]], 'xy', zq, slT);
          coat += 4 * slT * (slX1 - slX0) / cs;
          dmSleepers++;
        });
        /* the decking across them (along the eaves), the last two ripped to share what is left; two stainless screws a board at each sleeper */
        var dgD = _phU(s, 'DECK_GAP'), dkx0 = -xe + 0.005, dkx1 = xe - 0.005, zd0 = ze0 + 0.005, zd1 = ze1 - 0.005, spanD = dkx1 - dkx0;
        var ndk = Math.max(1, Math.ceil((spanD + dgD) / (P.dw + dgD) - 1e-9)), wds = [], remD = spanD - (ndk - 1) * (P.dw + dgD);
        for (i = 0; i < ndk; i++) wds.push(P.dw);
        if (ndk === 1) wds[0] = spanD; else if (remD >= 0.04) wds[ndk - 1] = remD; else { wds[ndk - 2] = wds[ndk - 1] = (P.dw + remD) / 2; }
        var bxa = dkx0;
        for (i = 0; i < ndk; i++) {
          var bxb = bxa + wds[i];
          poly('rdeck', PHk.DECK, ceil2(zd1 - zd0), 'rdeck-' + (i + 1), [[bxa, ySl(bxa)], [bxb, ySl(bxb)], [bxb, yDk(bxb)], [bxa, yDk(bxa)]], 'xy', (zd0 + zd1) / 2, zd1 - zd0);
          coat += (2 * (bxb - bxa) + 2 * P.dk) * (zd1 - zd0);
          dmDeckBoards++;
          for (j = 0; j < tails.length; j++) for (k = -1; k <= 1; k += 2) { var xqD = (bxa + bxb) / 2 + k * (bxb - bxa) / 4; scr('screw-rdeck', PHk.DECK_SCREW, xqD, yDk(xqD), tails[j], [0, -1, 0], len50); }
          bxa = bxb + dgD;
        }
        /* THE GUARD: 0.6 of the dog over the deck (at least 30 cm / US 12 in.), balusters <= 8.5 cm (US 3 3/8 in.) clear on the eaves'
           rims (two 6x80 into the rim's lower part, under the tails) and on the rake boards (two through the board into the fly rafter /
           the rim's end), the cap rail a 2x4 flat over them (one 6x100 down into each) -- the eaves' level, run over the corners, the
           rakes' between them on the deck's fall; the right eave open where the ramp lands */
        var Sst = _phU(s, 'STEP'), Qg = _phU(s, 'Q'), G = Math.max(_dmU(s, 'GUARD_MIN'), Math.round(Math.ceil(DM.K_GUARD * D.dog / Qg - 1e-6) * Qg * 10000) / 10000), bT = slT, bClr = _dmU(s, 'BAL_CLR'), offB = DM.EPDM_T + 0.003 + 0.001, rlT = st, rlW = sd;
        var wR = Math.max(_dmU(s, 'RAMP_W_MIN'), Math.ceil(DM.K_RAMP_W * D.dog / Sst - 1e-6) * Sst), zRm = zM, zO0 = zRm - wR / 2 - 0.04, zO1 = zRm + wR / 2 + 0.04;
        var bxc = function (sx2) { return sx2 * (xe + offB + bT / 2); }, bzc = function (sz2) { return (sz2 > 0) ? ze1 + offB + bT / 2 : ze0 - offB - bT / 2; };
        var rowOf = function (a0, a1) { var n9 = Math.max(1, Math.ceil((a1 - a0 - bT) / (bT + bClr) - 1e-9)), out9 = [], m9; for (m9 = 0; m9 <= n9; m9++) out9.push(a0 + bT / 2 + (a1 - a0 - bT) * m9 / n9); return out9; };
        var lsB = function (thru, mem) { return (len100 <= thru + mem - 0.005 && len100 >= thru + 0.012) ? len100 : len80; };   /* through the baluster, the gap, (the rake board) -- into the member */
        for (sx = -1; sx <= 1; sx += 2) {
          var yFtB = (sx > 0) ? yT(xe) : yT(-xo), yRb = yFtB - jh, yBt = yDk(sx * xe) + G, zSeg = (sx > 0) ? [[zR0, zO0], [zO1, zR1]] : [[zR0, zR1]];   /* along the rim (its ends under the rake boards) */
          zSeg.forEach(function (sg9, i9) {
            rowOf(sg9[0], sg9[1]).forEach(function (zq, j9) {
              box('gbal', DM.BALUSTER, ceil2(yBt - rlT - (yRb + 0.005)), 'gbal-' + (sx < 0 ? 'l' : 'r') + (i9 + 1) + '-' + (j9 + 1), bxc(sx), (yRb + 0.005 + yBt - rlT) / 2, zq, bT, yBt - rlT - (yRb + 0.005), bT);
              coat += 4 * bT * (yBt - rlT - yRb);
              dmBal++;
              for (k = 0; k < 2; k++) scr('screw-gbal', DM.BAL_SCREW, sx * (xe + offB + bT), yRb + 0.015 + 0.03 * k, zq, [-sx, 0, 0], len80);
              scr('screw-trail', DM.RAIL_SCREW, bxc(sx), yBt, zq, [0, -1, 0], len100);
            });
          });
          var zr0 = bzc(-1) - rlW / 2, zr1 = bzc(1) + rlW / 2, rSeg = (sx > 0) ? [[zr0, zO0], [zO1, zr1]] : [[zr0, zr1]];
          rSeg.forEach(function (sg9, i9) {
            box('trail', DM.RAIL, ceil2(sg9[1] - sg9[0]), 'trail-' + (sx < 0 ? 'l' : 'r') + (rSeg.length > 1 ? i9 + 1 : ''), bxc(sx), yBt - rlT / 2, (sg9[0] + sg9[1]) / 2, rlW, rlT, sg9[1] - sg9[0]);
            coat += 2 * (rlT + rlW) * (sg9[1] - sg9[0]);
            dmRails++;
          });
        }
        var xg0 = bxc(-1) + rlW / 2, xg1 = bxc(1) - rlW / 2, yGt = function (x) { return yDk(x) + G; };
        for (sz = -1; sz <= 1; sz += 2) {
          poly('trail', DM.RAIL, ceil2((xg1 - xg0) / cs), 'trail-' + (sz < 0 ? 'b' : 'f'), [[xg0, yGt(xg0) - rlT / cs], [xg1, yGt(xg1) - rlT / cs], [xg1, yGt(xg1)], [xg0, yGt(xg0)]], 'xy', bzc(sz), rlW);
          coat += 2 * (rlT + rlW) * (xg1 - xg0) / cs;
          dmRails++;
          rowOf(xg0, xg1).forEach(function (xq, j9) {
            var yb9 = yT(xq) - fbV + 0.01, yt9 = yGt(xq) - rlT / cs;
            box('gbal', DM.BALUSTER, ceil2(yt9 - yb9), 'gbal-' + (sz < 0 ? 'b' : 'f') + (j9 + 1), xq, (yb9 + yt9) / 2, bzc(sz), bT, yt9 - yb9, bT);
            coat += 4 * bT * (yt9 - yb9);
            dmBal++;
            var thruR = bT + offB + fbT, lnR = lsB(thruR, st), z9 = bzc(sz) + sz * bT / 2, yr9 = yR(Math.max(-xo, Math.min(xo, xq)));
            [0.22, 0.72].forEach(function (f10) {   /* (clear of the rake board's own screws) */
              var y10 = yr9 + dV * f10;
              scrClear('screw-gbal', (lnR === len100) ? DM.BAL_SCREW_R : DM.BAL_SCREW, [[xq, y10, z9], [xq + 0.012, y10, z9], [xq - 0.012, y10, z9], [xq, y10 + 0.012, z9], [xq, y10 - 0.012, z9], [xq + 0.012, y10 + 0.012, z9], [xq - 0.012, y10 - 0.012, z9]], [0, 0, -sz], lnR);
            });
            scr('screw-trail', DM.RAIL_SCREW, xq, yGt(xq), bzc(sz), [0, -1, 0], len100);
          });
        }
        dmG = G;
        topM = yGt(-xe) + 0.005;
        /* THE RAMP: its surface meets the deck's at the right eave, 25 deg down to deck blocks; the stringers' heads in joist hangers
           on the rim (four connector nails into the rim, one each side into the stringer), clear of the membrane's turn-down */
        var ra = DM.RAMP_ANG * Math.PI / 180, rCs = Math.cos(ra), rSn = Math.sin(ra), rTn = Math.tan(ra);
        var xH = xe + offB + 0.002, yTop0 = yDk(xe) - P.dk / rCs, yBot0 = yTop0 - jh / rCs, yG = yBk;
        var xBt = xH + (yBot0 - yG) / rTn, xTp = xH + (yTop0 - yG) / rTn, sZr = [zRm - wR / 2 + st / 2, zRm + wR / 2 - st / 2];
        var hy0 = yBot0 - 0.02, hy1 = Math.min(yBot0 + 0.07, yOs(xe) - turn - 0.005), len38 = us ? 0.0381 : 0.038, lenC = us ? 0.0699 : 0.07;
        sZr.forEach(function (zq, i9) {
          var hid = (i9 ? 'f' : 'b');
          box('rhanger', DM.HANGER, 0, 'ramp-hanger-' + hid, xe + 0.001, (hy0 + hy1) / 2, zq, 0.002, hy1 - hy0, st + 0.06);
          for (var e9 = -1; e9 <= 1; e9 += 2) box('rhanger', null, 0, 'ramp-hanger-' + hid + (e9 < 0 ? '-a' : '-b'), (xe + 0.002 + xH + 0.06) / 2, (hy0 + hy1) / 2, zq + e9 * (st / 2 + 0.001), xH + 0.058 - xe, hy1 - hy0, 0.002);
          dmHangers++;
          for (e9 = -1; e9 <= 1; e9 += 2) for (k = 0; k < 2; k++) {
            var yN = hy0 + 0.015 + (hy1 - hy0 - 0.03) * k, zN = zq + e9 * (st / 2 + 0.015);
            scrClear('nail-rhanger', DM.HANGER_NAIL, [[xe + 0.003, yN, zN], [xe + 0.003, yN + 0.008, zN], [xe + 0.003, yN - 0.008, zN], [xe + 0.003, yN, zN + e9 * 0.008]], [-1, 0, 0], len38, 0.0019);   /* (its head on the flange) */
          }
          for (e9 = -1; e9 <= 1; e9 += 2) scr('nail-rstr', DM.HANGER_NAIL, xH + 0.03, hy0 + (hy1 - hy0) * ((e9 < 0) ? 0.35 : 0.70), zq + e9 * (st / 2 + 0.003), [0, 0, -e9], len38, 0.0019);   /* (its head on the side plate; the two at different heights) */
          poly('rstr', DM.STRINGER, ceil2(Math.sqrt((xTp - xH) * (xTp - xH) + (yTop0 - yG) * (yTop0 - yG))), 'ramp-stringer-' + hid, [[xH, yBot0], [xBt, yG], [xTp, yG], [xH, yTop0]], 'xy', zq, st);
          coat += 2 * (st + jh) * (xTp - xH) / rCs;
          blocks.push({ x: (xBt + xTp) / 2, z: zq, w: bl, wt: blT, y0: yG - blH, y1: yG, a: 0, id: 'ramp-' + hid, post: false });
        });
        var rAt = function (sl, nn) { return [xH + rCs * sl + rSn * nn, yTop0 - rSn * sl + rCs * nn]; };
        var sMax = (yTop0 - yG) / rSn, sMaxB = (yTop0 - yG - 0.045 * rCs) / rSn, ctW = _dmU(s, 'CL_W'), ctT = _dmU(s, 'CL_T');   /* the boards stop where the stringer under them is 4.5 cm deep (their screws stay in it; its toe below) */
        for (var slb = 0.003; slb < sMaxB - 0.04; slb += P.dw + dgD) {
          var slc = Math.min(slb + P.dw, sMaxB);
          dmRBoards++;
          poly('rboard', PHk.DECK, ceil2(wR), 'ramp-board-' + dmRBoards, [rAt(slb, 0), rAt(slc, 0), rAt(slc, P.dk), rAt(slb, P.dk)], 'xy', zRm, wR);
          coat += (2 * (slc - slb) + 2 * P.dk) * wR;
          sZr.forEach(function (zq) { [0.25, 0.75].forEach(function (f9) { var pt9 = rAt(slb + (slc - slb) * f9, P.dk); scr('screw-rboard', PHk.DECK_SCREW, pt9[0], pt9[1], zq, [-rSn, -rCs, 0], len50); }); });
          if (slc - slb > 0.08) {
            var smc = (slb + slc) / 2;
            dmCleats++;
            poly('rcleat', DM.CLEAT, ceil2(wR - 0.02), 'ramp-cleat-' + dmCleats, [rAt(smc - ctW / 2, P.dk), rAt(smc + ctW / 2, P.dk), rAt(smc + ctW / 2, P.dk + ctT), rAt(smc - ctW / 2, P.dk + ctT)], 'xy', zRm, wR - 0.02);
            coat += 2 * (ctW + ctT) * (wR - 0.02);
            sZr.forEach(function (zq) { var pt9 = rAt(smc, P.dk + ctT); scr('screw-rcleat', DM.CLEAT_SCREW, pt9[0], pt9[1], zq, [-rSn, -rCs, 0], lenC, 0.00225); });
          }
        }
        dmRamp = { w: wR, len: sMax, run: xTp - xH, top: yDk(xe), ang: DM.RAMP_ANG, x1: xTp };
      }
    }
    /* THE CASINGS: 1x4 round each opening on the siding (jambs, a head over
       them, a sill under a window); two finish nails every 40 cm */
    function casing(id, ax, cN, o, u0, u1, v0, v1, sillToo, onKings) {   /* v385 onKings: the jambs' nails over the opening's kings (the dog house's doorway) */
      /* ax 'x': a gable (u = x), 'z': a side wall (u = z); cN the siding's outer face, o outward */
      var n0 = cN + o * tt / 2, list = [];
      list.push(['jamb-a', u0 - cw / 2, v0, v1, cw]); list.push(['jamb-b', u1 + cw / 2, v0, v1, cw]);
      list.push(['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]);
      if (sillToo) list.push(['sill', (u0 + u1) / 2, v0 - cw, v0, u1 - u0 + 2 * cw]);
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head' || c4[0] === 'sill'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        if (ax === 'x') box('casing', PHk.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        else box('casing', PHk.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], n0, yc, c4[1], tt, dy, du);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts2 = horiz ? (onKings ? fixPts(u0 - 0.5 * st, u1 + 0.5 * st, _phU(s, 'FIX_SP')) : fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP'))) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));   /* v385 onKings: the head's / sill's nails over the kings and the header between them */
        pts2.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) {
            var uu = horiz ? w2 : (onKings ? ((c4[0] === 'jamb-a') ? u0 - (0.5 + 0.2 * e4) * st : u1 + (0.5 + 0.2 * e4) * st) : c4[1] + e4 * cw / 4), yy = snapY(horiz ? yc + e4 * dy / 4 : w2);   /* v403 snapY: off the cladding's gaps */
            if (ax === 'x') scr('nail-trim', PHk.TRIM_NAIL, uu, yy, cN + o * tt, [0, 0, -o], len32, 0.0012);
            else scr('nail-trim', PHk.TRIM_NAIL, cN + o * tt, yy, uu, [-o, 0, 0], len32, 0.0012);
          }
        });
      });
    }
    if (dd) uDs.forEach(function (u6, i6) { casing(i6 ? 'casing-d2' : 'casing-d', 'x', L / 2 + sg, 1, u6 - hW, u6 + hW, yWS, yWT, !porch, true); });   /* v396 the double dog house: round each doorway */
    else if (dh) casing('casing-d', 'x', L / 2 + sg, 1, uD - hW, uD + hW, yWS, yWT, !porch, true);   /* v388 uD */   /* v385 the dog house: round its doorway only (a sill under it unless it stands on the porch's decking) */
    else {
    for (sx = -1; sx <= 1; sx += 2) casing('casing-' + (sx < 0 ? 'l' : 'r'), 'z', sx * xa, sx, -hW, hW, yWS, yWT, true);
    casing('casing-b', 'x', -(L / 2 + sg), -1, -hW, hW, yWS, yWT, true);
    casing('casing-d', 'x', L / 2 + sg, 1, -RO / 2, RO / 2, porch ? y0f : yF, yHd, false);
    }

    /* v388 THE INSULATED DOG HOUSE'S INSIDE (from the inside, the house closed): the ceiling's XPS between its joists (bonded in,
       the edges cut to the roof's slope), the OSB lining on the ceiling joists, on the side walls (full length), on the gables between
       them (the doorway cut out); THE PARTITION -- built flat as one frame (its plates, studs, the opening's kings and 4x4 header, the
       wall's own screws) and stood up under the lined ceiling, 1 cm short: down into the joist under it, up through the lining into
       the ceiling joist over it, the right end into the side wall's stud, the left from the opening through its king and end stud;
       its XPS, its lining each face; THE FLAP inside the doorway under a 1x4 batten screwed through the lining into the header */
    var yCl = yPT - rsL, gIn = glI - rsL, yPtT = yCl - _phU(s, 'TOP_GAP'), yWTp = yPtT - st - P.p, zLin = L / 2 - sd - rsL, flap = _dhFlap(s), pWl = null;
    var len60 = us ? 0.0635 : 0.06;
    if (di && !mono) {
      var cz = cjz.slice().sort(function (a, b) { return a - b; }), xbv = xh - ti / tn, yEdge = yR(glI) - 0.002;
      var cpts = (yEdge >= yPT + ti) ? [[-glI, yPT], [glI, yPT], [glI, yPT + ti], [-glI, yPT + ti]]
                                     : [[-glI, yPT], [glI, yPT], [glI, yEdge], [xbv, yPT + ti], [-xbv, yPT + ti], [-glI, yEdge]];
      for (i = 0; i + 1 < cz.length; i++) {
        var cza = cz[i] + st / 2, czb = cz[i + 1] - st / 2;
        if (czb - cza < 0.02) continue;
        poly('cinsul', DI.XPS, 0, 'cinsul-' + (i + 1), cpts, 'xy', (cza + czb) / 2, czb - cza);
        insA += 2 * glI * (czb - cza); insN++;
      }
      box('clining', DI.LINING, 0, 'clining', 0, yPT - rsL / 2, 0, 2 * glI, rsL, L - 2 * sd);
      linA += 2 * glI * (L - 2 * sd);
      for (sx = -1; sx <= 1; sx += 2) {
        box('wlining', DI.LINING, 0, 'wlining-' + (sx < 0 ? 'l' : 'r'), sx * (glI - rsL / 2), (yF + yCl) / 2, 0, rsL, yCl - yF, L - 2 * sd);
        linA += (yCl - yF) * (L - 2 * sd);
      }
      box('wlining', DI.LINING, 0, 'wlining-b', 0, (yF + yCl) / 2, -(L / 2 - sd - rsL / 2), 2 * gIn, yCl - yF, rsL);
      linA += 2 * gIn * (yCl - yF);
      var wfo = [[-gIn, yF], [gIn, yF], [gIn, yCl], [-gIn, yCl]], wfh = [[uD - hW, yWS], [uD + hW, yWS], [uD + hW, yWT], [uD - hW, yWT]];
      poly('wlining', DI.LINING, 0, 'wlining-f', wfo, 'xy', L / 2 - sd - rsL / 2, rsL, [wfh]);
      linA += _phArea(wfo) - _phArea(wfh);
      /* the partition */
      pWl = wall('part', { ax: 'x', c: zP, o: 1, nPl: 0, ins: 'pinsul', km: { plate: 'pplate', stud: 'pstud', king: 'pstud', header: 'pheader', 'screw-stud': 'screw-pframe', 'screw-tplate': 'screw-pframe', 'screw-frame': 'screw-pframe', 'screw-plate': 'screw-pfix' } },
                 -gIn, gIn, yPtT - st, { w: D.doorW, dog: true, u: uPo }, 'tplate', yPtT);
      box('ptplate', PHk.STUD, ceil2(2 * gIn), 'part-tplate', 0, yPtT - st / 2, zP, 2 * gIn, st, sd);
      /* (their tips in the side wall's stud between its own screws: up from the plate 6x120 (US 5 in.), down from the top plate) */
      var yEl = yF + len120 + 0.015, yEh = Math.min(yPtT - st - 0.06, yPT - lenBm - 0.015), yOh = yWTp - 0.03;
      for (k = 0; k < 3; k++) scr('screw-pfix', PHk.STUD_SCREW, gIn - st, yEl + (yEh - yEl) * 0.5 * k, zP, [1, 0, 0], len120);   /* the right end: through its end stud + the lining into the side wall's stud */
      if (yOh - yEl < 0.04) scr('screw-pfix', PHk.PLATE_SCREW, -gIn + 2 * st, (yEl + yOh) / 2, zP, [-1, 0, 0], len160);
      else for (k = 0; k < 2; k++) scr('screw-pfix', PHk.PLATE_SCREW, -gIn + 2 * st, yEl + (yOh - yEl) * k, zP, [-1, 0, 0], len160);   /* the left: from the opening through its king, end stud + the lining */
      for (var pm = 0; pm + 1 < pWl.full.length; pm++) {
        var pa2 = pWl.full[pm] + st / 2, pb2 = pWl.full[pm + 1] - st / 2;   /* the bay's clear width */
        if (pb2 - pa2 < 0.05 || (pWl.full[pm] === pWl.kings[0] && pWl.full[pm + 1] === pWl.kings[1])) continue;   /* (not over the opening: its header) */
        var npu = Math.max(1, Math.round((pb2 - pa2) / 0.30));   /* about every 30 cm (US 12 in.) */
        for (var pk = 0; pk < npu; pk++) {
          var um2 = pa2 + (pb2 - pa2) * (pk + 0.5) / npu;
          scrClear('screw-pfix', PHk.PLATE_SCREW, [um2, um2 + 0.015, um2 - 0.015].map(function (u3) { return [u3, yPtT - st, zP]; }), [0, 1, 0], len160);   /* up through the plate, the gap, the lining into the ceiling joist */
        }
      }
      var pfo = [[-gIn, yF], [gIn, yF], [gIn, yCl], [-gIn, yCl]], pfh = [[uPo - hW, yWS], [uPo + hW, yWS], [uPo + hW, yWTp], [uPo - hW, yWTp]];
      for (sz = -1; sz <= 1; sz += 2) {
        poly('plining', DI.LINING, 0, 'plining-' + (sz < 0 ? 'b' : 'f'), pfo, 'xy', zP + sz * (sd / 2 + rsL / 2), rsL, [pfh]);
        linA += _phArea(pfo) - _phArea(pfh);
      }
      /* the flap: a PVC strip curtain (strips about 10 cm / US 4 in.), its top clamped under a 1x4 batten on the lining over the
         doorway, 5x60 screws through the batten, the curtain and the lining into the 4x4 header */
      if (flap) {
        var fbL = D.doorW + 2 * st, yFb0 = yWT + 0.005, zFb = zLin - 0.002 - tt / 2;
        box('fbatten', PHk.BOARD, ceil2(fbL), 'flap-batten', uD, yFb0 + cw / 2, zFb, fbL, cw, tt);
        var fw = D.doorW + 0.04, fy0 = yWS + 0.012, fy1 = yWT + 0.06, nfs = Math.max(2, Math.round(fw / _phU(s, 'FLAP_W')));
        for (k = 0; k < nfs; k++) box('flap', null, 0, 'flap-' + (k + 1), uD - fw / 2 + (k + 0.5) * fw / nfs, (fy0 + fy1) / 2, zLin - 0.001, fw / nfs - 0.003, fy1 - fy0, 0.002);
        flapA = fw * (fy1 - fy0);
        missing.push({ name: DI.FLAP_NAME, qty: Math.round(flapA * PH.WASTE * 1000) / 1000, unit: 'm2' });
        var nfx = (D.doorW >= 0.25) ? 3 : 2;
        for (k = 0; k < nfx; k++) scr('screw-flap', PHk.SHEATH_SCREW, uD - hW + 0.03 + (2 * hW - 0.06) * k / (nfx - 1), yFb0 + cw / 2, zFb - tt / 2, [0, 0, 1], len60);
      }
    }

    /* THE DOOR: T&G boards upright, three 1x4 ledges + two braces on the
       inside (the braces rise from the hinge side), finish nails from the
       ledges, two strap hinges on the left (onto the casing), a knob, a
       ball catch at the top on the latch side */
    var gw = P.gw, gc = P.gc, gb = P.gb, dW = _phU(s, 'DOOR_W'), nDb = dh ? 0 : Math.max(2, Math.round(dW / gc)), lw = dh ? 0 : nDb * gc + (gw - gc);   /* v385 the dog house: no door */
    var dy0 = yF + _phU(s, 'DOOR_CLR'), dy1 = yHd - _phU(s, 'DOOR_CLR'), dH = dy1 - dy0, zD1 = L / 2 + sg, zD0 = zD1 - gb, zL0 = zD0 - tt;
    if (!dh) {   /* v385 the dog house: an open doorway */
    for (i = 0; i < nDb; i++) {
      var bxc = -lw / 2 + gw / 2 + i * gc;
      box('door', PHk.TG, ceil2(dH), 'door-board-' + (i + 1), bxc - (gw - gc) / 2, (dy0 + dy1) / 2, (zD0 + zD1) / 2, gc, dH, gb);   /* drawn at its cover (the tongue sits in the next board's groove) */
    }
    coat += 2 * (gb + gw) * dH * nDb;
    var ledY = [dy0 + 0.12, (dy0 + dy1) / 2, dy1 - 0.12], ledW = lw - 0.04;
    for (k = 0; k < 3; k++) {
      box('ledge', PHk.BOARD, ceil2(ledW), 'door-ledge-' + (k + 1), 0, ledY[k], (zD0 + zL0) / 2, ledW, cw, tt);
      coat += 2 * (tt + cw) * ledW;
      for (i = 0; i < nDb; i++) for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-door', PHk.TRIM_NAIL, -lw / 2 + gw / 2 + i * gc, ledY[k] + e5 * cw / 4, zL0, [0, 0, 1], len32, 0.0012);
    }
    function braceBetween(idB, xA, yA, xB, yB2) {
      /* a 1x4 from (xA, yA) to (xB, yB2) between two ledges, cut level against them */
      var dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
      var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('ledge', PHk.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zD0 + zL0) / 2, tt);
      coat += 2 * (tt + cw) * dl;
      for (var m2 = 0; m2 < nDb; m2++) {
        var xq = -lw / 2 + gw / 2 + m2 * gc, tq = (xq - xA) / dx;
        if (tq > 0.05 && tq < 0.95) scr('nail-door', PHk.TRIM_NAIL, xq, yA + dy * tq, zL0, [0, 0, 1], len32, 0.0012);
      }
    }
    braceBetween('door-brace-1', -ledW / 2 + 0.06, ledY[0] + cw / 2, ledW / 2 - 0.06, ledY[1] - cw / 2);
    braceBetween('door-brace-2', -ledW / 2 + 0.06, ledY[1] + cw / 2, ledW / 2 - 0.06, ledY[2] - cw / 2);
    /* the strap hinges on the outside: a strap over the boards at the top and bottom ledge, a leaf on the casing */
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k += 2) {
      var hy = ledY[k];
      hw.push({ kind: 'hinge', code: PHk.HINGE, box: [-lw / 2 + hingeLen / 2, hy, zD1 + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-RO / 2 - cw / 2, hy, zD1 + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', PHk.HINGE_SCREW, -lw / 2 + 0.04 + i * 0.10, hy, zD1 + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', PHk.HINGE_SCREW, -RO / 2 - cw / 2, hy + (i - 1) * hingeW * 0.5, zD1 + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: PHk.KNOB, cyl: [lw / 2 - 0.07, yF + _phU(s, 'KNOB_Y'), zD1, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: PHk.CATCH, box: [lw / 2 - 0.03, dy1 - 0.03, zD0 - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });
    }

    /* THE SHUTTERS: two a window, open flat against the siding beside its
       casing -- three T&G boards on two 1x4 ledges (now outward), a strap
       hinge each across onto the casing */
    var shGap = _phU(s, 'SHUT_GAP'), shW = 3 * gc + (gw - gc), shY0 = yWS - 0.02, shY1 = yWT + 0.02, shH = shY1 - shY0;
    var wins = dh ? [] : [{ ax: 'z', cN: W / 2 + sg, o: 1, id: 'r' }, { ax: 'z', cN: -(W / 2 + sg), o: -1, id: 'l' }, { ax: 'x', cN: -(L / 2 + sg), o: -1, id: 'b' }];   /* v385 the dog house: no shutters */
    function at2(w, u, y, n) { return (w.ax === 'z') ? [w.o * (Math.abs(w.cN) + n), y, u] : [u, y, w.o * (Math.abs(w.cN) + n)]; }
    function bx2(w, kind, code, len, id2, u, y, n, du, dy, dn) { var Pt = at2(w, u, y, n); if (w.ax === 'z') box(kind, code, len, id2, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, id2, Pt[0], Pt[1], Pt[2], du, dy, dn); }
    function sc2(w, kind, code, u, y, n, ln, r) { var Pt = at2(w, u, y, n), dd = (w.ax === 'z') ? [-w.o, 0, 0] : [0, 0, -w.o]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln, r); }
    var nShut = 0;
    wins.forEach(function (w) {
      for (var e6 = -1; e6 <= 1; e6 += 2) {
        var u0s = e6 * (hW + cw + shGap), u1s = u0s + e6 * shW, uc = (u0s + u1s) / 2;
        for (var b6 = 0; b6 < 3; b6++) {
          var ub = u0s + e6 * (gw / 2 + b6 * gc);
          bx2(w, 'shutter', PHk.TG, ceil2(shH), 'shutter-' + w.id + e6 + '-' + (b6 + 1), ub - e6 * (gw - gc) / 2, (shY0 + shY1) / 2, 0.002 + gb / 2, gc, shH, gb);
        }
        coat += 2 * (gb + gw) * shH * 3;
        var sly = [shY0 + 0.10, shY1 - 0.10];   /* v367 the ledges (and their hinges) off the casing's nails (they met) */
        for (var l6 = 0; l6 < 2; l6++) {
          bx2(w, 'sledge', PHk.BOARD, ceil2(shW - 0.02), 'shutter-ledge-' + w.id + e6 + '-' + (l6 + 1), uc, sly[l6], 0.002 + gb + tt / 2, shW - 0.02, cw, tt);
          coat += 2 * (tt + cw) * (shW - 0.02);
          for (b6 = 0; b6 < 3; b6++) for (var e7 = -1; e7 <= 1; e7 += 2) sc2(w, 'nail-shutter', PHk.TRIM_NAIL, u0s + e6 * (gw / 2 + b6 * gc), sly[l6] + e7 * cw / 4, 0.002 + gb + tt, len32, 0.0012);
          /* the hinge: a strap on the ledge, its leaf on the casing */
          var hs0 = u0s + e6 * 0.01, hs1 = u0s + e6 * 0.18, hsc = (hs0 + hs1) / 2, hsl = Math.abs(hs1 - hs0), hcu = e6 * (hW + st / 2);   /* its leaf over the king stud */
          var hp2 = at2(w, hsc, sly[l6], 0.002 + gb + tt + 0.0015), hp3 = at2(w, hcu, sly[l6], tt + 0.0015);
          hw.push({ kind: 'shinge', code: PHk.HINGE, box: (w.ax === 'z') ? [hp2[0], hp2[1], hp2[2], 0.003, 0.03, hsl] : [hp2[0], hp2[1], hp2[2], hsl, 0.03, 0.003], id: 'shutter-hinge-' + w.id + e6 + l6 });
          hw.push({ kind: 'shinge', code: null, box: (w.ax === 'z') ? [hp3[0], hp3[1], hp3[2], 0.003, 0.048, cw * 0.8] : [hp3[0], hp3[1], hp3[2], cw * 0.8, 0.048, 0.003], id: 'shutter-hinge-leaf-' + w.id + e6 + l6 });
          hinges++;
          for (var h6 = 0; h6 < 3; h6++) {
            sc2(w, 'screw-shinge', PHk.HINGE_SCREW, hs0 + (hs1 - hs0) * (0.15 + 0.35 * h6), sly[l6], 0.002 + gb + tt + 0.003, len40, 0.0022);
            sc2(w, 'screw-shinge', PHk.HINGE_SCREW, hcu + e6 * (h6 - 1) * 0.008, sly[l6] + (h6 - 1) * 0.012, tt + 0.003, len40, 0.0022);
          }
        }
        nShut++;
      }
    });

    /* v363 THE STILT HOUSE'S PORCH GUARD, LADDER AND SLIDE. The guard 90 cm
       (US 3 ft) over the deck: 2x4 rails on edge flush with the porch's
       outer faces (the bottom one 5 cm / 2 in. over the deck), 38x38
       KVH03838 balusters on their inner faces <= 8.5 cm (US 3 3/8 in.)
       clear (under the 3.5 in. head-entrapment size); the front's ladder
       opening 60 cm (US 2 ft) between two 4x4 posts bolted to the front
       beam's outer face (two M16 rods each), the rails running on over
       them; each side's rails from a 2x4 post screwed to the front wall
       to the porch post; the right side open for the slide (the toggle).
       The ladder: 2x6 rails at 75 deg lapped on the opening posts, 2x4
       treads <= 28 cm (US 11 in.) apart. The slide is no catalogue item
       yet (MISSING) -- drawn as its HDPE bed and walls. */
    var yD = yJ1 + P.dk, nBal = 0, nTread = 0, nRail = 0, extX = W / 2, extZ = zF;   /* extX / extZ: the plan's reach (the slide, the ladder's foot) */
    if (stilt) {
      var yG1 = yD + _phU(s, 'GUARD'), yRL0 = yD + _phU(s, 'RAIL_LOW'), bt3 = _phU(s, 'BAL_T'), clr = _phU(s, 'BAL_CLR'), ow = _phU(s, 'LAD_W');
      var len60 = us ? 0.0635 : 0.06, wpCode = _phU(s, 'WPOST_SCREW'), wpLen = us ? len80 : len100;   /* the side rail into its wall post: 6x100 (US 6x80 -- the 2x4s are thinner) */
      var yRm = [yRL0 + sd / 2, yG1 - sd / 2];
      var railBox = function (id, x, y, z, dx, dz) { box('rail', PHk.STUD, ceil2(Math.max(dx, dz)), id, x, y, z, dx, sd, dz); coat += 2 * (st + sd) * Math.max(dx, dz); nRail++; };
      var balBox = function (id, x, z) { box('baluster', PHk.BAL, ceil2(yG1 - yRL0), id, x, (yRL0 + yG1) / 2, z, bt3, yG1 - yRL0, bt3); coat += 4 * bt3 * (yG1 - yRL0); nBal++; };
      /* the ladder's posts on the front beam's outer face, two M16 rods each through post + beam (a washer + cap nut each end) */
      for (sx = -1; sx <= 1; sx += 2) {
        var rpx = sx * (ow / 2 + p / 2);
        box('rpost', PHk.POST, ceil2(yG1 - yB), 'rpost-' + (sx < 0 ? 'l' : 'r'), rpx, (yB + yG1) / 2, zF + p / 2, p, yG1 - yB, p);
        coat += 4 * p * (yG1 - yB);
        for (k = 0; k < 2; k++) rod('bolt-rpost', rpx, yB + bh * (0.3 + 0.4 * k), zF + p + 0.02, [0, 0, -1], p + bw + 0.04);
      }
      /* the front: each half's rails from its porch post on over its ladder post, the balusters from the opening's edge (n balusters, n gaps) */
      for (sx = -1; sx <= 1; sx += 2) {
        var fx0 = ow / 2, fx1 = W / 2 - p, fl0 = fx1 - fx0, fid = (sx < 0 ? 'l' : 'r');
        for (k = 0; k < 2; k++) {
          railBox('rail-f' + fid + (k + 1), sx * (fx0 + fx1) / 2, yRm[k], zF - st / 2, fl0, st);
          for (var e8 = -1; e8 <= 1; e8 += 2) scr('screw-rail', PHk.JOIST_SCREW, sx * W / 2, yRm[k] + e8 * 0.03, zF - st / 2, [-sx, 0, 0], len160);   /* through the porch post into its end */
          scr('screw-rail', PHk.RAIL_SCREW, sx * (ow / 2 + 0.05), yRm[k], zF - st, [0, 0, 1], len120);   /* from inside into the ladder post, clear of the balusters */
          scr('screw-rail', PHk.RAIL_SCREW, sx * (ow / 2 + 0.072), yRm[k], zF - st, [0, 0, 1], len120);
        }
        var nf = Math.max(1, Math.ceil(fl0 / (bt3 + clr) - 1e-9)), gf = fl0 / nf - bt3;
        for (i = 0; i < nf; i++) {
          var bxf = sx * (fx0 + bt3 / 2 + i * (bt3 + gf));
          balBox('bal-f' + fid + (i + 1), bxf, zF - st - bt3 / 2);
          for (k = 0; k < 2; k++) scr('screw-baluster', PHk.BAL_SCREW, bxf, yRm[k], zF - st - bt3, [0, 0, 1], len60);
        }
      }
      /* the sides: a 2x4 post on the front wall (two 6x160 through the siding into the side wall's end stud), the rails lapped on it to the porch post */
      var zw = L / 2 + sg;
      for (sx = -1; sx <= 1; sx += 2) {
        var sid2 = (sx < 0 ? 'l' : 'r'), wpx = sx * (W / 2 - 1.5 * st);
        box('wpost', PHk.STUD, ceil2(yG1 - yD), 'wpost-' + sid2, wpx, (yD + yG1) / 2, zw + sd / 2, st, yG1 - yD, sd);
        coat += 2 * (st + sd) * (yG1 - yD);
        for (k = 0; k < 2; k++) scr('screw-wpost', PHk.JOIST_SCREW, wpx, yD + (yG1 - yD) * (0.25 + 0.5 * k), zw + sd, [0, 0, -1], len160);
        if (sx > 0 && slide) continue;   /* the slide's side: open */
        var sz0 = zw + tt, sz1 = zF - p, sl0 = sz1 - sz0;   /* from the gable's corner board's face (lapped on the wall post past it) */
        for (k = 0; k < 2; k++) {
          railBox('rail-s' + sid2 + (k + 1), sx * (W / 2 - st / 2), yRm[k], (sz0 + sz1) / 2, st, sl0);
          for (e8 = -1; e8 <= 1; e8 += 2) {
            scr('screw-rail', PHk.JOIST_SCREW, sx * (W / 2 - st / 2), yRm[k] + e8 * 0.012, zF, [0, 0, -1], len160);   /* through the porch post into its end */
            scr('screw-rail', wpCode, sx * W / 2, yRm[k], zw + sd * (0.5 + e8 * 0.2), [-sx, 0, 0], wpLen);   /* into the wall post */
          }
        }
        var sb0 = zw + sd, sLr = sz1 - sb0, ns2 = Math.max(1, Math.ceil((sLr - clr) / (bt3 + clr) - 1e-9)), gs2 = (sLr - ns2 * bt3) / (ns2 + 1);
        for (i = 0; i < ns2; i++) {
          var bzs = sb0 + gs2 + bt3 / 2 + i * (bt3 + gs2);
          balBox('bal-s' + sid2 + (i + 1), sx * (W / 2 - st - bt3 / 2), bzs);
          for (k = 0; k < 2; k++) scr('screw-baluster', PHk.BAL_SCREW, sx * (W / 2 - st - bt3), yRm[k], bzs, [sx, 0, 0], len60);
        }
      }
      /* the ladder: its rails' back edge from the front beam's face at the deck down and out at 75 deg, level cuts at the deck and the ground */
      var lAng = PHk.LAD_ANG * Math.PI / 180, lct = 1 / Math.tan(lAng), lhw = jh / Math.sin(lAng);
      var lz = function (y) { return zF + (yD - y) * lct; };
      for (sx = -1; sx <= 1; sx += 2) {
        var lpts = [[lz(yD), yD], [lz(yD) + lhw, yD], [lz(0) + lhw, 0], [lz(0), 0]];
        poly('lrail', PHk.RIM, ceil2(yD / Math.sin(lAng) + jh * lct), 'lrail-' + (sx < 0 ? 'l' : 'r'), lpts, 'zy', sx * (ow / 2 - jt / 2), jt);
        coat += 2 * (jt + jh) * yD / Math.sin(lAng);
        [yD - 0.03, yB + 0.07].forEach(function (yq) {   /* the lower one between the post's two rods */
          var zq0 = Math.max(zF, lz(yq)), zq1 = Math.min(zF + p, lz(yq) + lhw);
          scr('screw-lrail', PHk.RAIL_SCREW, sx * (ow / 2 - jt), yq, (zq0 + zq1) / 2, [sx, 0, 0], len120);   /* from its inside into the ladder post */
        });
      }
      extZ = lz(0) + lhw;
      var nT = Math.max(2, Math.ceil(yD / _phU(s, 'LAD_RISE') - 1e-9)), rise = yD / nT, twd = ow - 2 * jt;
      for (k = 1; k < nT; k++) {
        var ytc = yD - k * rise - st / 2, ztc = lz(ytc) + lhw / 2;
        box('tread', PHk.STUD, ceil2(twd), 'tread-' + k, 0, ytc, ztc, twd, st, sd);
        coat += 2 * (st + sd) * twd;
        nTread++;
        for (sx = -1; sx <= 1; sx += 2) for (e8 = -1; e8 <= 1; e8 += 2) scr('screw-tread', PHk.RAIL_SCREW, sx * ow / 2, ytc, ztc + e8 * sd / 4, [-sx, 0, 0], len120);
      }
      /* the slide off the right side, centred in its opening: a lip on the deck, a flat start, the chute at 33 deg, a run-out on a skirt to the ground */
      if (slide) {
        var zsl = (zw + sd + zF - p) / 2, wsl = _phU(s, 'SLIDE_W'), sbd = PHk.SLIDE_BED, swh = PHk.SLIDE_WALL, swt = PHk.SLIDE_WT;
        var sAng = PHk.SLIDE_ANG * Math.PI / 180, sx0 = W / 2 - PHk.SLIDE_LIP, sx1 = W / 2 + _phU(s, 'SLIDE_TOP'), syE = _phU(s, 'SLIDE_EXIT'), syT = yD + sbd;
        var sx2 = sx1 + (syT - syE) / Math.tan(sAng), sx3 = sx2 + _phU(s, 'SLIDE_RUN');
        poly('slide', null, 0, 'slide-bed', [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx3, syE - sbd], [sx3, syE], [sx2, syE], [sx1, syT], [sx0, syT]], 'xy', zsl, wsl - 2 * swt);
        for (k = -1; k <= 1; k += 2)
          poly('slide', null, 0, 'slide-wall-' + (k < 0 ? 'b' : 'f'), [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx2, 0], [sx3, 0], [sx3, syE + swh], [sx2, syE + swh], [sx1, syT + swh], [sx0, syT + swh]], 'xy', zsl + k * (wsl / 2 - swt / 2), swt);
        missing.push({ name: PHk.SLIDE_NAME, qty: 1, unit: 'pcs' });
        extX = sx3;
      }
    }

    if (dmRamp) extX = Math.max(extX, dmRamp.x1 + 0.05);   /* v403 the modern dog house's ramp out to the right */
    /* the bill's quantities: timber by code (+ the boards, trims, decking by length) */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var bury = blH - yBk;   /* v403 the blocks' depth from their top (the modern dog house's frame is higher) -- the others' yB = yBk */
    return {
      P: P, us: us, porch: porch, L: L, W: W, PD: PD, zF: zF, pieces: pieces, fas: fas, blocks: blocks, hw: hw, posts: posts, joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: floorA, roofA: roofA, sidingA: sidingA, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: r3(blocks.length * bl * bl * gv), digM3: r3(blocks.length * bl * bl * (bury + gv)), hinges: hinges, shutters: nShut, deckBoards: deckBoards,
      ties: nTies, gStuds: gStuds, trims: nTrim, doorBoards: nDb, doorW: lw, doorH: dH, RO: RO, win: stuff.win,
      yB: yB, yJ1: yJ1, yF: yF, yPT: yPT, yBm: yBm, yHd: yHd, yWS: yWS, ridgeTop: mono ? yT(-xe) : rgTop, pitch: mono ? mPitch : PHk.PITCH, rafL: rafL, roofLen: eLen, slope: slope,   /* v403 mPitch: 14 (3 under the modern dog house's deck) */
      top: mono ? topM : yT(0) + rsV + 0.01, height: mono ? topM : yT(0) + rsV + 0.01, depth: W, length: L + PD,
      mono: mono, roofCov: dmDeck ? 'epdm' : mono ? 'seam' : 'shingle', yPTL: yPTL, seams: mono ? nPan - 1 : 0,   /* v370 the roof on the switch */   /* v403 the modern dog house's deck: EPDM (MISSING), no underlay */
      stilt: stilt, slide: slide, gscrews: gscrews, uheads: uheads, missing: missing, yD: yD, extX: extX, extZ: extZ, sPosts: sPosts.length, xBraces: nXb, balusters: nBal, treads: nTread, rails: nRail,   /* v363 the stilt house */
      dog: dh, dogH: dh ? D.dog : 0, dogDoorW: dh ? D.doorW : 0, dogDoorH: dh ? yWT - yWS : 0, dogLmin: dh ? D.L : 0, dogWmin: dh ? D.W : 0, knobs: dh ? 0 : null, catches: dh ? 0 : null,   /* v385 the dog house */
      insul: di, flap: di && flap, zP: zP, uD: uD, uPo: uPo, dogDs: di ? D.Ds : 0, dogDv: di ? D.Dv : 0, dogPDoorH: di ? yWTp - yWS : 0, dogOvl: di ? (uD - hW) - (uPo + hW) : 0,   /* v388 the insulated dog house */
      insA: insA, insN: insN, linA: linA, flapA: flapA,
      krun: kr, kStuds: krZs.length * (kr ? 2 : 0), krZs: krZs, gate: krGate, krMeshA: krMeshA, krStapleL: krStapleL, krBolts: krBolts,   /* v392 the kennel with run */
      dbl: dd, uDs: uDs, ddMid: ddMid, ddLinA: ddLinA, ddStuds: ddStuds,   /* v396 the double dog house */
      dmod: dm, dmDeck: dmDeck, cladA: cladA, dmLegs: dmLegs.length, dmEpdmA: dmEpdmA, dmSleepers: dmSleepers, dmDeckBoards: dmDeckBoards, dmBal: dmBal, dmRails: dmRails, dmHangers: dmHangers, dmRBoards: dmRBoards, dmCleats: dmCleats, dmG: dmG, dmRamp: dmRamp,   /* v403 the modern dog house */
      extra: dm ? (function () { var ex = {}; ex[DM.CLAD] = Math.round(cladA * PH.WASTE * 100) / 100; ex[DM.CLAD_SCREW] = Math.ceil(cladA * DM.CLAD_SCR_M2); if (dmHangers) ex[DM.HANGER] = dmHangers; return ex; })() : dd ? (function () { var ex = {}; ex[DI.LINING] = Math.round(ddLinA * PH.WASTE * 100) / 100; ex[DI.LIN_SCREW] = Math.ceil(ddLinA * DI.LIN_SCR_M2); return ex; })() : kr ? (function () { var ex = {}; ex[CO.STAPLE] = Math.ceil(krStapleL / _coU(s, 'STAPLE_SP') - 1e-9); return ex; })() : di ? (function () { var ex = {}; ex[DI.XPS] = Math.round(insA * PH.WASTE * 100) / 100; ex[DI.FOAM] = Math.ceil(insA / DI.FOAM_M2 - 1e-9); ex[DI.LINING] = Math.round(linA * PH.WASTE * 100) / 100; ex[DI.LIN_SCREW] = Math.ceil(linA * DI.LIN_SCR_M2); return ex; })() : null   /* -- by area: the XPS + its foam, the lining + its screws */
    };
  }
  /* its staged assembly: one catalogue item a step, the screws that fix
     it the step after (a step whose parts this build does not draw -- the
     porch's without it -- drops out) */
  var _phStepsC = {};
  /* v369 (Marek 2026-10-29 22:29: zrevidovat assembly postupy -- the A-frame's window frame: its horizontals and their screws came long
     before the uprights): one table, then each type's own moves, cached per type; checked by the harness (every part touches what is
     already built, no screw goes into a member that comes later) on all seven types */
  function _phSteps(s) {
    var v = ((s || STATE).variant | 0), fK = _phFound(s || STATE), key = v + (fK ? ':' + fK : '');   /* v402 + the playhouses' foundation */
    if (_phStepsC[key]) return _phStepsC[key];
    if (v === CS_TYPE) return (_phStepsC[key] = _phFoundSteps(_csSteps(), fK, 'screw'));   /* v389 the castle: its own table */
    if (v === 34 || v === 39 || v === 42 || v === 46 || v === 49 || v === 52) return (_phStepsC[key] = _xpWithHead(_coSteps()));   /* v401 + the hoop coop */   /* v397 + the barn coop */   /* v395 + the exploded view, back together */   /* v391 + the cupola coop */   /* v386 + the lean-to coop */   /* v375 the backyard coop: its own table; v383 + the walk-in coop (the same parts) */
    if (v === 37) return (_phStepsC[key] = _xpWithHead(_ctSteps()));   /* v395 + the exploded view, back together */   /* v379 the chicken tractor: its own */
    var B = _phStepsBase((v === DD_TYPE) ? DDC : (v === DM_TYPE) ? DMC : (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE) ? DHC : null);   /* v403 the modern: DMC */   /* v396 the double: DDC (2x6 rims + joists) */   /* v385 the dog house: the cottage's steps with its codes */   /* v388 + the insulated one */   /* v392 + the kennel with run */
    if (v === DH_TYPE || v === DI_TYPE || v === KR_TYPE || v === DD_TYPE || v === DM_TYPE) B.forEach(function (st2) { if (st2.parts[0] === 'ph-hw-screw-brace' || st2.parts[0] === 'ph-hw-screw-tplate') st2.codes = st2.codes.concat([PH.TIE_SCREW]); });   /* -- its 6x80s: the porch braces' up into the plate, the top plate's down into the doorway's header */
    if (v === DI_TYPE) {
      /* v388 the insulated dog house: the floor's XPS before its OSB; the doorway's kings + header screwed together and stood on the
         plate before the studs; the inside once the house is closed -- the walls' and the ceiling's XPS, the ceiling's lining, the
         walls', the partition (one frame, its own screws, then fixed in place), its XPS and lining, the flap */
      var ins = function (after, list) {
        for (var i3 = 0; i3 < B.length; i3++) if (B[i3].parts.indexOf(after) >= 0) break;
        Array.prototype.splice.apply(B, [i3 + 1, 0].concat(list));
      };
      ins('ph-hw-screw-joist', [{ parts: ['ph-finsul'], codes: [DI.XPS, DI.FOAM] }]);
      ins('ph-hw-screw-plate', [{ parts: ['ph-dking', 'ph-dheader'], codes: [DHC.STUD, DHC.HEADER] }, { parts: ['ph-hw-screw-dframe'], codes: [DHC.FRAME_SCREW] }]);
      ins('ph-hw-nail-trim', [
        { parts: ['ph-winsul'], codes: [DI.XPS, DI.FOAM] },
        { parts: ['ph-cinsul'], codes: [DI.XPS, DI.FOAM] },
        { parts: ['ph-clining'], codes: [DI.LINING, DI.LIN_SCREW] },
        { parts: ['ph-wlining'], codes: [DI.LINING, DI.LIN_SCREW] },
        { parts: ['ph-pplate', 'ph-pstud', 'ph-pheader', 'ph-ptplate'], codes: [DHC.STUD, DHC.HEADER] },
        { parts: ['ph-hw-screw-pframe'], codes: [DHC.STUD_SCREW, DHC.FRAME_SCREW, PH.TIE_SCREW] },
        { parts: ['ph-hw-screw-pfix'], codes: [DHC.PLATE_SCREW, DHC.STUD_SCREW] },
        { parts: ['ph-pinsul'], codes: [DI.XPS, DI.FOAM] },
        { parts: ['ph-plining'], codes: [DI.LINING, DI.LIN_SCREW] },
        { parts: ['ph-fbatten', 'ph-flap'], codes: [DHC.BOARD] },
        { parts: ['ph-hw-screw-flap'], codes: [DHC.SHEATH_SCREW] }
      ]);
    }
    if (v === DD_TYPE) {
      /* v396 the double dog house: its partition once the walls stand (the frame, its own screws, fixed down + to the gables),
         its screws up into the ridge board once that is on, its OSB with the inside work after the trims */
      var insD = function (after, list) {
        for (var i5 = 0; i5 < B.length; i5++) if (B[i5].parts.indexOf(after) >= 0) break;
        Array.prototype.splice.apply(B, [i5 + 1, 0].concat(list));
      };
      insD('ph-hw-screw-tplate', [
        { parts: ['ph-mplate', 'ph-mstud', 'ph-mtplate'], codes: [DDC.STUD] },
        { parts: ['ph-hw-screw-mframe'], codes: [DDC.STUD_SCREW] },
        { parts: ['ph-hw-screw-mfix'], codes: [DDC.STUD_SCREW, DDC.FRAME_SCREW] }
      ]);
      insD('ph-hw-screw-rtoe', [{ parts: ['ph-hw-screw-mridge'], codes: [DDC.FRAME_SCREW] }]);
      insD('ph-hw-nail-trim', [{ parts: ['ph-mlining'], codes: [DI.LINING, DI.LIN_SCREW] }]);
    }
    if (v === DM_TYPE) {
      /* v403 the modern dog house: its legs fixed once the frame is round them; its 2x4 rafters (their seat screws by the depth they
         go through); the roof deck's eave rims before the OSB, the EPDM before the drip edge, then the deck, the guard; its cladding;
         the ramp once the house is done -- the hangers on the rim, the stringers in them, the boards, the cleats */
      var insM = function (after, list, before) {
        for (var i6 = 0; i6 < B.length; i6++) if (B[i6].parts.indexOf(after) >= 0) break;
        Array.prototype.splice.apply(B, [before ? i6 : i6 + 1, 0].concat(list));
      };
      B.forEach(function (st6) {
        if (st6.parts[0] === 'ph-mrafter' || st6.parts[0] === 'ph-mfly') st6.codes = [DMC.RAFTER];
        if (st6.parts[0] === 'ph-hw-screw-seat' || st6.parts[0] === 'ph-hw-screw-mfly') st6.codes = ['FAS60120', 'FAS60100'];
        if (st6.parts[0] === 'ph-siding') st6.codes = [DM.CLAD, DM.CLAD_SCREW];
      });
      insM('ph-hw-screw-joist', [{ parts: ['ph-hw-screw-leg'], codes: [DM.LEG_SCREW] }]);
      insM('ph-sheath', [{ parts: ['ph-erim'], codes: [DM.ERIM] }, { parts: ['ph-hw-screw-erim'], codes: [DM.ERIM_SCREW] }], true);
      insM('ph-hw-screw-fascia', [{ parts: ['ph-epdm'], codes: [] }]);
      insM('ph-drip', [
        { parts: ['ph-sleeper'], codes: [DM.SLEEPER] },
        { parts: ['ph-rdeck'], codes: [DMC.DECK] },
        { parts: ['ph-hw-screw-rdeck'], codes: [DMC.DECK_SCREW] },
        { parts: ['ph-gbal'], codes: [DM.BALUSTER] },
        { parts: ['ph-hw-screw-gbal'], codes: [DM.BAL_SCREW, DM.BAL_SCREW_R] },
        { parts: ['ph-trail'], codes: [DM.RAIL] },
        { parts: ['ph-hw-screw-trail'], codes: [DM.RAIL_SCREW] }
      ]);
      insM('ph-hw-nail-trim', [
        { parts: ['ph-rhanger'], codes: [DM.HANGER] },
        { parts: ['ph-hw-nail-rhanger'], codes: [DM.HANGER_NAIL] },
        { parts: ['ph-rstr'], codes: [DM.STRINGER] },
        { parts: ['ph-hw-nail-rstr'], codes: [DM.HANGER_NAIL] },
        { parts: ['ph-rboard'], codes: [DMC.DECK] },
        { parts: ['ph-hw-screw-rboard'], codes: [DMC.DECK_SCREW] },
        { parts: ['ph-rcleat'], codes: [DM.CLEAT] },
        { parts: ['ph-hw-screw-rcleat'], codes: [DM.CLEAT_SCREW] }
      ]);
    }
    if (v === KR_TYPE) {
      /* v392 the kennel with run: the run's studs and its front rail once the plates and the knee braces are on; the gate after
         the trims -- its frame, its screws, the welded wire (the run's and the gate's), the hinges, the barrel bolt */
      var insK = function (after, list) {
        for (var i4 = 0; i4 < B.length; i4++) if (B[i4].parts.indexOf(after) >= 0) break;
        Array.prototype.splice.apply(B, [i4 + 1, 0].concat(list));
      };
      insK('ph-hw-screw-brace', [
        { parts: ['ph-kstud'], codes: [DHC.STUD] },
        { parts: ['ph-hw-screw-kstud'], codes: [DHC.FRAME_SCREW, PH.TIE_SCREW] },
        { parts: ['ph-krail'], codes: [DHC.STUD] },
        { parts: ['ph-hw-screw-krail'], codes: [DHC.JOIST_SCREW] }
      ]);
      insK('ph-hw-nail-trim', [
        { parts: ['ph-gframe'], codes: [DHC.STUD] },
        { parts: ['ph-hw-screw-gate'], codes: [DHC.JOIST_SCREW, PH.TIE_SCREW] },
        { parts: ['ph-mesh'], codes: [CO.STAPLE] }
      ]);
      insK('ph-catch', [{ parts: ['ph-bolt'], codes: [] }]);
    }
    function mv(names, after) {
      var moved = [], i;
      for (i = B.length - 1; i >= 0; i--) if (B[i].parts.length && names.indexOf(B[i].parts[0]) >= 0) moved.unshift(B.splice(i, 1)[0]);
      for (i = 0; i < B.length; i++) if (B[i].parts.indexOf(after) >= 0) break;
      if (i >= B.length) { B = B.concat(moved); return; }
      Array.prototype.splice.apply(B, [i + 1, 0].concat(moved));
    }
    if (v === 28) mv(['ph-stud', 'ph-hw-screw-stud', 'ph-header', 'ph-hw-screw-frame'], 'ph-hw-screw-gstud');   /* (the cripples over the headers follow them) */   /* the A-frame: its door / window framing between the gable studs, after them */
    if (v === 29) mv(['ph-tbrace', 'ph-hw-screw-tbrace'], 'ph-hw-screw-mtie');                                   /* the play fort: the gable braces' tops on the ties */
    return (_phStepsC[key] = fK ? _phFoundSteps(B, fK, _phFoundDef(s || STATE)) : B);
  }
  /* v402 a playhouse's steps with its foundation: the blocks, the footings, the U heads (or the footings' wet-set anchors), the joists'
     U-head nails once the joists lie in them */
  function _phFoundSteps(B, f, nat) {
    function at(part) { for (var q = 0; q < B.length; q++) if (B[q].parts.indexOf(part) >= 0) return q; return -1; }
    if (at('ph-block') < 0) B.splice(1, 0, { parts: ['ph-block'], codes: [PH.DIG, PH.GRAVEL_CODE, PH.BLOCK] });
    if (at('ph-pour') < 0) B.splice(at('ph-block') + 1, 0, { parts: ['ph-pour'], codes: [PH.DIG, PH.GRAVEL_CODE, PH.GEOTEX, PH.FORMWORK, PH.REBAR, PH.CONCRETE] });
    var iu = at('ph-uhead');
    if (iu >= 0) B[iu] = { parts: B[iu].parts, codes: [(f === 'pier') ? PH.UANCHOR : PH.UHEAD] };
    var ij = at('ph-joist');
    if (ij >= 0 && at('ph-hw-nail-ujoist') < 0) B.splice(ij + 1, 0, { parts: ['ph-hw-nail-ujoist'], codes: [PH.UNAIL] });
    if (nat === 'block' && f !== 'block' && at('ph-rim') >= 0 && ij >= 0) {
      /* a house on U heads under its joists: the frame (joists + rims) set on them in one step, nailed in, then the porch posts on
         the rims' ends */
      var jS = B.splice(at('ph-joist'), 2), ir2 = at('ph-rim');
      B[ir2] = { parts: ['ph-joist', 'ph-rim'], codes: jS[0].codes.concat(B[ir2].codes) };
      B.splice(ir2 + 1, 0, jS[1]);
      var pS = B.splice(at('ph-post'), 1);
      Array.prototype.splice.apply(B, [at('ph-hw-nail-ujoist') + 1, 0].concat(pS));
    }
    return B;
  }

  function _phStepsBase(Kt) {
    var K = Kt || PH;   /* v385 the dog house: its own codes (DHC) on the same steps */
    return ([
      { parts: [], codes: [] },
      { parts: ['ph-block'], codes: [K.DIG, K.GRAVEL_CODE, K.BLOCK] },
      { parts: ['ph-gscrew'], codes: [K.GSCREW] },                                   /* v363 the stilt house: the ground screws, */
      { parts: ['ph-uhead'], codes: [K.UHEAD] },                                     /* -- their U heads */
      { parts: ['ph-post'], codes: [K.POST] },
      { parts: ['ph-hw-nail-uhead'], codes: [K.UNAIL] },                             /* -- the posts nailed in the U heads */
      { parts: ['ph-fbeam'], codes: [K.BEAM] },                                      /* -- the 4x6 frame on them */
      { parts: ['ph-hw-screw-fbeam', 'ph-hw-screw-ebeam'], codes: [K.FBEAM_SCREW, K.BEAM_SCREW] },
      { parts: ['ph-rim'], codes: [K.RIM] },
      { parts: ['ph-frim'], codes: [K.RIM] },                                        /* v365 the play fort: its rims round the posts, */
      { parts: ['ph-hw-bolt-frim'], codes: [K.ROD, K.WASHER, K.CAPNUT] },          /* -- bolted through the posts */
      { parts: ['ph-hw-screw-frim'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-joist'], codes: [K.JOIST] },
      { parts: ['ph-hw-screw-joist'], codes: [K.JOIST_SCREW, K.BEAM_SCREW] },
      { parts: ['ph-tblock'], codes: [K.JOIST] },                                    /* v368 the tree fort: the opening's corner blocks */
      { parts: ['ph-hw-screw-tblock'], codes: [AF.TOE] },
      { parts: ['ph-xbrace'], codes: [K.STUD] },                                     /* v363 -- the diagonals */
      { parts: ['ph-hw-screw-xbrace'], codes: [K.STUD_SCREW] },
      { parts: ['ph-kbrace'], codes: [K.STUD] },                                     /* -- the front's knee braces */
      { parts: ['ph-hw-screw-tkbrace'], codes: [K.STUD_SCREW, K.FRAME_SCREW] },     /* v368 the tree fort's: lapped on the posts */
      { parts: ['ph-hw-screw-kbrace'], codes: [K.BRACE_SCREW] },
      { parts: ['ph-floor'], codes: [K.FLOOR, K.SHEATH_SCREW] },
      { parts: ['ph-deck'], codes: [K.DECK] },
      { parts: ['ph-hw-screw-deck'], codes: [K.DECK_SCREW] },
      { parts: ['ph-tbeam'], codes: [K.BEAM] },                                      /* v365 the play fort: the roof beams on the posts, */
      { parts: ['ph-hw-screw-tbeam'], codes: [K.FBEAM_SCREW] },
      { parts: ['ph-tbrace'], codes: [K.STUD] },                                     /* -- the knee braces under them */
      { parts: ['ph-hw-screw-tbrace'], codes: [K.BRACE_SCREW] },
      { parts: ['ph-sill'], codes: [AF.SILL] },                                       /* v364 the A-frame: its sills, */
      { parts: ['ph-hw-screw-sill'], codes: [AF.SILL_SCREW] },
      { parts: ['ph-plate'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-plate'], codes: [K.PLATE_SCREW] },
      { parts: ['ph-stud'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-stud'], codes: [K.STUD_SCREW] },
      { parts: ['ph-header'], codes: [K.HEADER] },
      { parts: ['ph-hw-screw-frame'], codes: [K.FRAME_SCREW, K.STUD_SCREW] },
      { parts: ['ph-tplate'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-tplate'], codes: [K.STUD_SCREW] },
      { parts: ['ph-beam'], codes: [K.BEAM] },
      { parts: ['ph-hw-screw-beam'], codes: [K.BEAM_SCREW] },
      { parts: ['ph-brace'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-brace'], codes: [K.BRACE_SCREW] },
      { parts: ['ph-rafter'], codes: [K.RAFTER] },
      { parts: ['ph-ridge'], codes: [K.RIDGE] },                                     /* v369 the ridge board between the standing rafters (it hung in the air before them) */
      { parts: ['ph-mrafter'], codes: [MD.RAFTER] },                                  /* v366 the modern house: its one-piece 2x6 rafters */
      { parts: ['ph-gusset'], codes: [K.ROOF] },                                     /* v367 the little barn: its trusses' gussets, */
      { parts: ['ph-hw-screw-gusset'], codes: [BR.GUS_SCREW] },
      { parts: ['ph-hw-screw-seat'], codes: [K.SEAT_SCREW, AF.TOE] },   /* v364 + the A-frame's toe screws */
      { parts: ['ph-hw-screw-rtoe'], codes: [K.RIDGE_TOE] },
      { parts: ['ph-fly'], codes: [K.RAFTER] },
      { parts: ['ph-hw-screw-fly'], codes: [K.RIDGE_TOE] },
      { parts: ['ph-mfly'], codes: [MD.RAFTER] },                                     /* v366 -- its fly rafters on the beams' ends, */
      { parts: ['ph-hw-screw-mfly'], codes: [K.SEAT_SCREW] },
      { parts: ['ph-tie'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-tie'], codes: [K.TIE_SCREW, K.TIE_DOWN] },
      { parts: ['ph-hw-screw-mtie'], codes: [K.JOIST_SCREW] },                       /* v370 the mono play fort's gable ties through its posts */
      { parts: ['ph-gstud'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-gstud'], codes: [K.FRAME_SCREW] },
      { parts: ['ph-cstud'], codes: [K.STUD] },                                      /* v369 the A-frame: the cripples over its door / window headers, */
      { parts: ['ph-hw-screw-cstud'], codes: [K.FRAME_SCREW] },                      /* -- toed down into the header, up into the ridge */
      { parts: ['ph-ljoist'], codes: [K.JOIST] },                                    /* v367 -- the loft's joists, */
      { parts: ['ph-hw-screw-ljoist'], codes: [K.FRAME_SCREW, AF.TOE] },
      { parts: ['ph-lfloor'], codes: [K.FLOOR, K.SHEATH_SCREW] },                   /* -- its floor, */
      { parts: ['ph-lpost'], codes: [K.STUD] },                                      /* -- its guard's posts */
      { parts: ['ph-hw-screw-lpost'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-grail'], codes: [K.STUD] },                                      /* -- and rails */
      { parts: ['ph-hw-screw-grail'], codes: [K.RAIL_SCREW, K.WPOST_SCREW_US] },
      { parts: ['ph-sheath'], codes: [K.ROOF, K.SHEATH_SCREW] },
      { parts: ['ph-fascia'], codes: [K.BOARD] },
      { parts: ['ph-mfascia'], codes: [MD.FASCIA] },                                  /* v366 -- its 1x6 fascia + rake boards */
      { parts: ['ph-hw-screw-fascia'], codes: [K.FASCIA_SCREW] },
      { parts: ['ph-drip'], codes: [K.DRIP, K.ROOF_NAIL] },
      { parts: ['ph-cover'], codes: [K.UNDERLAY, K.UL_STAPLE, K.SHINGLE, K.ROOF_NAIL] },
      { parts: ['ph-mcover', 'ph-seam'], codes: [K.UNDERLAY, K.UL_STAPLE, MD.SEAM, MD.SEAM_CLIP] },   /* v366 -- its standing seam */
      { parts: ['ph-siding'], codes: [K.SIDING, K.SIDING_SCREW] },
      { parts: ['ph-trim'], codes: [K.TRIM] },
      { parts: ['ph-casing'], codes: [K.BOARD] },
      { parts: ['ph-hw-nail-trim'], codes: [K.TRIM_NAIL] },
      { parts: ['ph-door'], codes: [K.TG] },
      { parts: ['ph-ledge'], codes: [K.BOARD] },
      { parts: ['ph-hw-nail-door'], codes: [K.TRIM_NAIL] },
      { parts: ['ph-hinge'], codes: [K.HINGE] },
      { parts: ['ph-hw-screw-hinge'], codes: [K.HINGE_SCREW] },
      { parts: ['ph-knob'], codes: [K.KNOB] },
      { parts: ['ph-catch'], codes: [K.CATCH] },
      { parts: ['ph-shutter'], codes: [K.TG] },
      { parts: ['ph-sledge'], codes: [K.BOARD] },
      { parts: ['ph-hw-nail-shutter'], codes: [K.TRIM_NAIL] },
      { parts: ['ph-shinge'], codes: [K.HINGE] },
      { parts: ['ph-hw-screw-shinge'], codes: [K.HINGE_SCREW] },
      { parts: ['ph-rpost'], codes: [K.POST] },                                      /* v363 the stilt house: the ladder's posts, */
      { parts: ['ph-hw-bolt-rpost'], codes: [K.ROD, K.WASHER, K.CAPNUT] },         /* -- bolted to the front beam */
      { parts: ['ph-wpost'], codes: [K.STUD] },                                      /* -- the guard's posts on the front wall */
      { parts: ['ph-hw-screw-wpost'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-rail'], codes: [K.STUD] },                                       /* -- the guard's rails */
      { parts: ['ph-hw-screw-rail'], codes: [K.JOIST_SCREW, K.RAIL_SCREW, K.WPOST_SCREW, K.WPOST_SCREW_US] },
      { parts: ['ph-baluster'], codes: [K.BAL] },                                    /* -- its balusters */
      { parts: ['ph-hw-screw-baluster'], codes: [K.BAL_SCREW] },
      { parts: ['ph-fboard'], codes: [PF.BOARD] },                                    /* v365 the play fort: its fort boards */
      { parts: ['ph-hw-screw-fboard'], codes: [PF.BOARD_SCREW] },
      { parts: ['ph-lrail'], codes: [K.RIM] },                                       /* -- the ladder's rails */
      { parts: ['ph-hw-screw-lrail'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-hw-screw-blrail'], codes: [K.RAIL_SCREW, K.WPOST_SCREW_US] },   /* v367 the barn's ladder rails into the guard's posts */
      { parts: ['ph-tread'], codes: [K.STUD] },                                      /* -- its treads */
      { parts: ['ph-hw-screw-tread'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-slide'], codes: [] },                                             /* -- the slide (MISSING in the catalogue) */
      { parts: ['ph-sleg'], codes: [KF.LEG] },                                        /* v365 the play fort's swings: the A-frame's legs, */
      { parts: ['ph-scollar', 'ph-sspread', 'ph-hw-bolt-scollar', 'ph-hw-bolt-sspread'], codes: [KF.LEG, K.ROD, K.WASHER, K.CAPNUT] },   /* -- its collar + spreader */
      { parts: ['ph-sbeam', 'ph-hw-bolt-sapex', 'ph-hw-bolt-sbeam'], codes: [PF.SBEAM, K.ROD, K.WASHER, K.CAPNUT] },                  /* -- the beam on the ties into the A-frame */
      { parts: ['ph-sbrace'], codes: [KF.BRACE] },                                    /* -- its knee braces */
      { parts: ['ph-hw-screw-sbrace'], codes: [KF.SCREW] },
      { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: [SWING.HANGER_CODE, SWING.HANGER_SCREW, SWING.CHAIN_CODE] },   /* -- the hangers + chains */
      { parts: ['kids-seat', 'swing-hw-shank', 'swing-hw-eye'], codes: [KIDS.SEAT_CODE, SWING.EYE_CODE] }                                /* -- the seats on their eye bolts */
    ]);
  }
  /* ------------------------------------------------------------------
     v373 TYPE 33 -- GREENHOUSES, variant 1: THE GABLE GREENHOUSE (Marek
     2026-10-29 14:24: the greenhouse "jako SWINGS" -- one product, its
     types as variants on this engine, the GABLE first; 2026-10-30 09:11
     "Greenhouse zalozeny, muzes spustit vyrobu variant"). A free-standing
     timber greenhouse in the US DIY manner, every piece a catalogue item
     where the catalogue has one:
       - FOUNDATION: ground screws FGR00001 in U heads FGR00002 (12
         connector nails FAS38038 each) under the 4x6 base -- under both
         side beams 25 cm in from the corners and <= 1.80 m (US 6 ft)
         apart, one under each end beam's middle once it is 2.70 m (US
         9 ft) wide or more; no concrete, and it holds the light frame
         down in the wind;
       - BASE: 4x6 KVH10160 on edge -- the side beams the full length, the
         end beams between them, two 8x200 FAS80200 through each corner;
         inside it the floor dug 10 cm (US 4 in.) and filled with gravel;
       - WALLS: 2x4 KVH10060 studs at <= 60 cm (US 24 in.) between a 2x4
         bottom plate and a single top plate, 1.83 m (US 6 ft) over the
         base; a 2x4 girt across every bay at mid-height (with the knee
         wall a second one at its top), toe-screwed at both ends; the door
         in the front gable: kings up to the end rafters, jacks under a
         flat 2x4 header, a cripple over it;
       - ROOF: 30 deg gable, 2x4 rafters in line with the studs, a
         birdsmouth on the top plate and an 8x200 down into it, plumb
         against a 2x6 KVH60160 ridge board; 2x4 rafter ties on the top
         plates at every other pair (<= 1.22 m, US 4 ft), eave blocks
         between the rafters over the side walls, a 2x4 purlin across
         every bay at mid-slope; gable studs at 60 cm (US 24 in.) up to
         the end rafters;
       - GLAZING: 8 mm (US 5/16 in.) twinwall polycarbonate on the walls,
         gables and roof, its flutes running down; the upper edges sealed
         with aluminium tape FEC00033, the lower ones with vented tape; EPDM
         sealing screws FAS00225 by rate; a folded metal ridge cap ROR00009.
         The sheet, the vented tape and the vent openers have no catalogue
         row yet: drawn, listed as NOT BILLED (missing);
       - TRIM: 1x4 TIM20100 fascia on the rafter tails, rake boards on the
         gables, casings round the door; corner boards FVW02660;
       - DOOR: a 2x3 KVH40060 frame (stiles, three rails, two braces)
         glazed outside, on three strap hinges FAT00022, a knob ODD00016
         and a ball catch ODD00017;
       - ROOF VENTS: a 2x3 sash glazed on top in a rafter bay 20 cm (US
         8 in.) under the ridge (its hinges clear of the ridge cap), between a 2x4 header and the bay's purlin, on two strap
         hinges, held open by an automatic wax opener; vents for a sixth
         of the floor, split between the slopes;
       - KNEE WALL (the info bar's toggle, off): the bottom 60 cm (US 2 ft)
         panel siding FCP00009 instead of the glazing, a girt at its top
         and a 1x4 belt board over the joint.
     X = across (W, +X the right side seen from the door), Y up, Z along
     the ridge (L, +Z the front with the door). L / W = the base's outer
     faces. _ghLayout(STATE) is the single source of the model and the
     bill; sheets (glazing, siding, the cap) are outlines in their own
     (u, v) plane, members off the axes are oriented boxes (obox). */
  var GH = {
    W: [1.80, 3.60], W_US: [1.8288, 3.6576], W0: 2.40, W0_US: 2.4384,
    L: [2.40, 6.00], L_US: [2.4384, 6.096], L0: 3.00, L0_US: 3.048,
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.038, GS_R_US: 0.0381, U_UP: 0.030, U_T: 0.004, U_FL: 0.15,
    PIER_SP: 1.80, PIER_SP_US: 1.8288, PIER_IN: 0.25, PIER_IN_US: 0.254, MID_PIER_W: 2.70, MID_PIER_W_US: 2.7432,
    GRAVEL_T: 0.10, GRAVEL_T_US: 0.1016,
    STUD_SP: 0.60, STUD_SP_US: 0.6096,
    WALL_H: 1.83, WALL_H_US: 1.8288, KNEE_H: 0.60, KNEE_H_US: 0.6096,
    DOOR_W: 0.76, DOOR_W_US: 0.762, DOOR_H: 1.93, DOOR_H_US: 1.9304, DOOR_CLR: 0.01, DOOR_CLR_US: 0.0095,
    KNOB_Y: 1.00, KNOB_Y_US: 1.016, DOOR_MID: 0.95, DOOR_MID_US: 0.9652,
    PITCH: 30, EAVE: 0.10, EAVE_US: 0.1016, GL_T: 0.008, GL_OVER: 0.04, GL_OVER_US: 0.0381, GLAZE_OP: 0.28,
    VENT_S0: 0.20, VENT_S0_US: 0.2032, VENT_GAP: 0.005, VENT_ANG: 20, VENT_RATIO: 1 / 6,
    CAP_W: 0.125, CAP_W_US: 0.127, CAP_T: 0.002, CAP_FIX: 0.30, CAP_FIX_US: 0.3048,
    FIX_SP: 0.40, FIX_SP_US: 0.4064, WASTE: 1.10, GL_SCR_M2: 8, SIDING_SCR_M2: 20,
    GSCREW: 'FGR00001', UHEAD: 'FGR00002', UNAIL: 'FAS38038', DIG: 'FEE00001', GRAVEL: 'FCO00001',
    BASE: 'KVH10160', BASE_SCREW: 'FAS80200', STUD: 'KVH10060', RIDGE: 'KVH60160', FRAME: 'KVH40060',
    BOARD: 'TIM20100', TRIM: 'FVW02660', SIDING: 'FCP00009', CAP: 'ROR00009', TAPE: 'FEC00033',
    GL_SCREW: 'FAS00225', SIDING_SCREW: 'FAS55050', FASCIA_SCREW: 'FAS55050', TRIM_NAIL: 'FAS18032',
    STUD_SCREW: 'FAS60120', FRAME_SCREW: 'FAS60100', TOE: 'FAS60080', SEAT_SCREW: 'FAS80200', TIE_SCREW: 'FAS60080', TIE_DOWN: 'FAS60120',
    HINGE: 'FAT00022', HINGE_SCREW: 'FAS50040', KNOB: 'ODD00016', CATCH: 'ODD00017',
    POLY_NAME: 'TWINWALL POLYCARBONATE SHEET 8 MM (5/16 IN.), UV PROTECTED',
    VTAPE_NAME: 'POLYCARBONATE VENTED (BREATHER) TAPE FOR THE LOWER EDGES',
    OPENER_NAME: 'AUTOMATIC GREENHOUSE VENT OPENER (WAX CYLINDER)',
    /* v378 THE LEAN-TO (type 36): its depth off the house on the side grips (1.80 - 3.00 m, US 6 - 10 ft; 2.40 / 8 ft), the slope, the gap to the house wall,
       the brackets (FAT00005 145 x 145, US 6 x 6 in., <= 1.20 m / 4 ft apart), the endwall flashing's legs, the house wall drawn as context */
    LW: [1.80, 3.00], LW_US: [1.8288, 3.048], LW0: 2.40, LW0_US: 2.4384, LPITCH: 20, LGAP: 0.05, LGAP_US: 0.0508,
    BRK_SP: 1.20, BRK_SP_US: 1.2192, BRK_L: 0.145, BRK_L_US: 0.1524, BRK_W: 0.055, BRK_T: 0.003,
    FLASH_W: 0.10, FLASH_W_US: 0.1016, FLASH_UP: 0.15, FLASH_UP_US: 0.1524, HOUSE_T: 0.25,
    FLASH: 'ROR00013', BRACKET: 'FAT00005', BRK_SCREW: 'FAS50040', ANCHOR: 'FAS10075',
    /* v381 THE HOOP HOUSE (type 38): its width (3.00 - 4.20 m, US 10 - 14 ft; 3.00 / 10 ft) and length (2.40 - 7.20 m, US 8 - 24 ft; 3.60 / 12 ft) on the grips,
       the hoops' tube (35 mm, US 1 3/8 in.) <= 1.20 m (US 4 ft) apart, their legs to 0.90 m (US 3 ft) over the base, the strap pieces (40 mm wide, 3 cm / US 1 in. tabs),
       the film, the lock channel (30 x 15 mm, fixed <= 30 cm / US 1 ft), the door's staples (10 cm / US 4 in.); the items with no catalogue row by name */
    HW: [3.00, 4.20], HW_US: [3.048, 4.2672], HW0: 3.00, HW0_US: 3.048, HL: [2.40, 7.20], HL_US: [2.4384, 7.3152], HL0: 3.60, HL0_US: 3.6576,
    HOOP_SP: 1.20, HOOP_SP_US: 1.2192, TUBE_D: 0.035, TUBE_D_US: 0.0349, SIDE_H: 0.90, SIDE_H_US: 0.9144,
    STRAP_W: 0.04, STRAP_T: 0.002, STRAP_TAB: 0.03, STRAP_TAB_US: 0.0254, FILM_T: 0.0015, CH_W: 0.03, CH_H: 0.015, CH_FIX: 0.30, CH_FIX_US: 0.3048, STAPLE_SP: 0.10, STAPLE_SP_US: 0.1016,
    HSTRAP: 'FAT00012', HSTRAP_SCREW: 'FAS50040', CH_SCREW_S: 'FAS48019', STAPLE: 'FAS10000',
    TUBE_NAME: 'GALVANIZED STEEL TUBE 35 MM (1 3/8 IN.) -- THE HOOPS (BENT ON A HOOP BENDER), THE RIDGE PURLIN, THE ROLL BARS',
    FILM_NAME: 'GREENHOUSE FILM 6 MIL (150 MICRON), UV STABILIZED',
    CHANNEL_NAME: 'ALUMINUM LOCK CHANNEL (BASE FOR THE WIGGLE WIRE)',
    WIRE_NAME: 'WIGGLE WIRE (SPRING LOCK INSERT), PVC COATED',
    XCONN_NAME: 'CROSS CONNECTOR CLAMP 35 MM (1 3/8 IN.) -- THE RIDGE PURLIN TO THE HOOPS',
    CRANK_NAME: 'ROLL-UP SIDE CRANK (GEAR BOX) FOR A 35 MM (1 3/8 IN.) ROLL BAR',
    /* v384 THE A-FRAME (type 40): 60 deg slopes down to the base; its width 3.60 - 4.80 m (US 12 - 16 ft; the full door from 3.60), 3.60 / 12 ft, its length the gable's range, 3.60 / 12 ft;
       the vent's length down the slope (70 cm, US 28 in.), the purlins below it <= 1.20 m (US 4 ft) apart; the ridge a 2x8 (the 2x4's plumb cut at 60 deg is 20 cm deep) */
    AW: [3.60, 4.80], AW_US: [3.6576, 4.8768], AW0: 3.60, AW0_US: 3.6576, AL0: 3.60, AL0_US: 3.6576, APITCH: 60,
    AVENT_L: 0.70, AVENT_L_US: 0.7112, APUR_SP: 1.20, APUR_SP_US: 1.2192, ARIDGE: 'KVH60200',
    /* v387 THE VICTORIAN (type 43): its width 2.40 - 3.60 m (US 8 - 12 ft), 3.00 / 10 ft; its length incl. the bay 3.00 - 6.60 m (US 10 - 22 ft), 4.20 / 14 ft */
    VW: [2.40, 3.60], VW_US: [2.4384, 3.6576], VW0: 3.00, VW0_US: 3.048, VL: [3.00, 6.60], VL_US: [3.048, 6.7056], VL0: 4.20, VL0_US: 4.2672,
    /* v390 THE OLD-WINDOW GREENHOUSE (type 45): the sashes' stock sizes (w x h) on the slider (75 x 120 cm / US 30 x 48 in. unless set), their thickness, the gap between two,
       the stiles / top rail, the bottom rail, the muntins; the plan in whole sashes (its default about the gable's 3.00 x 2.40 m / US 10 x 8 ft) */
    OW_SIZES: [[0.60, 0.90], [0.60, 1.20], [0.75, 1.20], [0.90, 1.20], [0.90, 1.50]],
    OW_SIZES_US: [[0.6096, 0.9144], [0.6096, 1.2192], [0.762, 1.2192], [0.9144, 1.2192], [0.9144, 1.524]], OW_I0: 2,
    OW_T: 0.035, OW_T_US: 0.0349, OW_GAP: 0.006, OW_GAP_US: 0.0064, OW_STILE: 0.055, OW_STILE_US: 0.0572, OW_RAILB: 0.075, OW_RAILB_US: 0.0762, OW_MUN: 0.02, OW_MUN_US: 0.0191,
    OL0: 3.00, OL0_US: 3.048, OW0: 2.40, OW0_US: 2.4384,
    SASH_NAME: 'RECLAIMED WOOD WINDOW SASH, GLAZED',
    /* v392 THE GROWING BENCHES: the top's height over the floor, the depth, the shelf's top, the legs' spacing, the slats' gap, the path left between two,
       the shortest bench, the narrowest, the gap to the walls' framing, to the end walls, the door's approach kept clear, the A-frame's headroom over the top */
    BN_H: 0.80, BN_H_US: 0.8128, BN_D: 0.60, BN_D_US: 0.6096, BN_SH: 0.20, BN_SH_US: 0.2032, BN_LEG_SP: 1.20, BN_LEG_SP_US: 1.2192, BN_GAP: 0.02, BN_GAP_US: 0.0191,
    BN_PATH: 0.70, BN_PATH_US: 0.7112, BN_MIN: 0.60, BN_MIN_US: 0.6096, BN_DMIN: 0.30, BN_DMIN_US: 0.3048, BN_CLR: 0.02, BN_CLR_US: 0.0191, BN_END: 0.05, BN_END_US: 0.0508,
    BN_APP: 0.80, BN_APP_US: 0.8128, BN_HEAD: 0.05, BN_HEAD_US: 0.0508,
    /* v399 THE FOUNDATION on its switch (the gazebo's GZ values): the precast pad's base / top / height / its top over the ground, its gravel bed; the poured footing's width,
       depth, its top over the ground, its gravel, the bars' cover; the codes */
    FD_BLK: 0.30, FD_BLK_US: 0.3048, FD_BLK_TOP: 0.20, FD_BLK_TOP_US: 0.2032, FD_BLK_H: 0.20, FD_BLK_H_US: 0.2032, FD_BLK_UP: 0.10, FD_BLK_UP_US: 0.1016, FD_GRAVEL: 0.10, FD_GRAVEL_US: 0.1016,
    FD_PIER_W: 0.40, FD_PIER_W_US: 0.4064, FD_PIER_D: 0.80, FD_PIER_D_US: 0.8128, FD_PIER_UP: 0.10, FD_PIER_UP_US: 0.1016, FD_PIER_GRAVEL: 0.15, FD_PIER_GRAVEL_US: 0.1524, FD_BAR_COVER: 0.05,
    FD_BLOCK: 'FCO00012', FD_CONCRETE: 'FCO00002', FD_REBAR: 'FCO00003', FD_FORMWORK: 'FCO00007', FD_GEOTEX: 'FEC00003', FD_UANCHOR: 'FCO00004'
  };
  /* the sections (metric / US actual): 2x4 (st x sd), the 4x6 base (bw x
     bh), the 2x6 ridge, the 2x3 frame (ft deep x fw wide), the 1x4 board
     (tt x cw), the corner board's width, the siding, the glazing */
  function _ghProf(s) {
    if ((s || STATE).isMetric === false) return { st: 0.0381, sd: 0.0889, bw: 0.0889, bh: 0.1397, rgt: 0.0381, rgd: 0.1397, ft: 0.0381, fw: 0.0635,
      tt: 0.01905, cw: 0.0889, tw: 0.0635, sg: 0.0087, gl: GH.GL_T };
    return { st: 0.060, sd: 0.100, bw: 0.100, bh: 0.160, rgt: 0.060, rgd: 0.160, ft: 0.040, fw: 0.060,
      tt: 0.020, cw: 0.100, tw: 0.060, sg: 0.011, gl: GH.GL_T };
  }
  function _ghU(s, k) { return ((s || STATE).isMetric === false && GH[k + '_US'] != null) ? GH[k + '_US'] : GH[k]; }
  var GH_TYPES = [33, 36, 38, 40, 43, 45];   /* v373 the greenhouse types (33 the gable; v378 36 the lean-to; v381 38 the hoop house; v384 40 the A-frame; v387 43 the Victorian; v390 45 the old-window greenhouse) */
  function _isGhType(v) { return GH_TYPES.indexOf(v | 0) >= 0; }
  function _ghKnee(s) { return (s || STATE).ghKnee === true && !_ghHoop(s); }   /* the knee wall on the info bar's toggle (off); v381 the hoop house: its roll-up sides on the same key (_ghRoll) */
  function _ghRange(s) { if (_ghOld(s)) return _ghOldR(s, false); var r = _ghU(s, _ghHoop(s) ? 'HL' : _ghVict(s) ? 'VL' : 'L'); return { min: r[0], max: r[1] }; }   /* v381 the hoop house: its own */
  function _ghWRange(s) { if (_ghOld(s)) return _ghOldR(s, true); var r = _ghU(s, _ghHoop(s) ? 'HW' : _ghVict(s) ? 'VW' : _ghAframe(s) ? 'AW' : _ghLean(s) ? 'LW' : 'W'); return { min: r[0], max: r[1] }; }   /* v378 the lean-to: its depth off the house; v381 the hoop house: its width */
  function _ghL(s) { s = s || STATE; if (_ghOld(s)) return _ghOldSnap(s, false); var R = _ghRange(s), v = +s.L; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _ghU(s, _ghHoop(s) ? 'HL0' : _ghVict(s) ? 'VL0' : _ghAframe(s) ? 'AL0' : 'L0'))); }
  function _ghW(s) { s = s || STATE; if (_ghOld(s)) return _ghOldSnap(s, true); var R = _ghWRange(s), v = +s.ghW; return Math.max(R.min, Math.min(R.max, (isFinite(v) && v > 0) ? v : _ghU(s, _ghHoop(s) ? 'HW0' : _ghVict(s) ? 'VW0' : _ghAframe(s) ? 'AW0' : _ghLean(s) ? 'LW0' : 'W0'))); }
  /* a twinwall sheet's flute ends: the length of its edges facing up the
     flutes (solid tape) and down them (vented tape). up = +1: the flutes
     rise along +v (the walls), -1: along -v (the roof, v down the slope) */
  function _ghTape(pts, holes, up) {
    var out = { solid: 0, vent: 0 };
    function ring(R, sign) {
      var a = 0, n = R.length, i;
      for (i = 0; i < n; i++) { var A = R[i], B = R[(i + 1) % n]; a += A[0] * B[1] - B[0] * A[1]; }
      var ccw = (a > 0) ? 1 : -1;
      for (i = 0; i < n; i++) {
        var A2 = R[i], B2 = R[(i + 1) % n], du = B2[0] - A2[0], dv = B2[1] - A2[1], ln = Math.sqrt(du * du + dv * dv);
        if (ln < 1e-6) continue;
        var nv = -du / ln * ccw * sign * up;   /* the outward normal's share along the flutes, + = their upper end */
        if (nv > 0.2) out.solid += ln; else if (nv < -0.2) out.vent += ln;
      }
    }
    ring(pts, 1);
    (holes || []).forEach(function (h) { ring(h, -1); });
    return out;
  }
  /* ------------------------------------------------------------------
     v392 THE GROWING BENCHES (Marek 2026-10-30 "Dalsi krok", question
     panel: pestebni stoly uvnitr) -- staging along the walls inside every
     greenhouse, on the info bar's top switch (off unless switched on):
       - a bench: 2x3 legs (KVH40060) <= 1.20 m (US 4 ft) apart, their
         narrow face along the bench; two 2x3 rails on edge at the top and
         two at the lower shelf on the legs' outer faces, two 6x80 a joint;
         1x4 slats (TIM20100) across the depth on the rails, a 2 cm (US
         3/4 in.) gap, two stainless 5.5x50 a slat end into each rail; the lower
         shelf's slats between the legs;
       - the top 80 cm (US 32 in.) over the floor, 60 cm (US 24 in.)
         deep, the shelf's top 20 cm (US 8 in.); 2 cm (US 3/4 in.) off the
         walls' framing, 5 cm (US 2 in.) off the end walls;
       - each layout gives its runs (g.benchSpec: the back edge's line,
         the side that is inward, the doors' approach to keep clear); a
         pair of benches leaves a path of at least 70 cm (US 28 in.), or
         one side only (the right), or a narrower one; a run shorter than
         60 cm (US 2 ft) gets none.
     Billed by length (the frame, the boards), every screw as drawn, the
     coating over every face. */
  function _ghBenchOn(s) { return (s || STATE).ghBench === true; }
  /* v399 THE FOUNDATION on its switch: 'screw' ground screws + U heads (the base's underside FOOT_UP over the ground), 'block' precast pads
     (the base resting on their top, FD_BLK_UP), 'pier' poured footings (their top FD_PIER_UP, a wet-set U anchor up to the base) */
  function _ghFound(s) { var f = (s || STATE).ghFound; return (f === 'block' || f === 'pier') ? f : 'screw'; }
  function _ghYBB(s) { var f = _ghFound(s); return (f === 'block') ? _ghU(s, 'FD_BLK_UP') : (f === 'pier') ? _ghU(s, 'FD_PIER_UP') + GH.U_UP : _ghU(s, 'FOOT_UP'); }
  function _ghYH(s, yBB) { var f = _ghFound(s); return (f === 'block') ? yBB : (f === 'pier') ? _ghU(s, 'FD_PIER_UP') : yBB - GH.U_UP; }
  function _ghBenches(s, g) {
    var B = g.benchSpec;
    g.benches = 0; g.benchL = 0;
    if (!B || !B.runs || !B.runs.length) return;
    var us = (s.isMetric === false), P = g.P, ft = P.ft, fw = P.fw, tt = P.tt, cw = P.cw;
    var H = _ghU(s, 'BN_H'), D0 = _ghU(s, 'BN_D'), SH = _ghU(s, 'BN_SH'), sp = _ghU(s, 'BN_LEG_SP'), gap = _ghU(s, 'BN_GAP');
    var pathMin = _ghU(s, 'BN_PATH'), lMin = _ghU(s, 'BN_MIN'), dMin = _ghU(s, 'BN_DMIN');
    var len80 = us ? 0.0762 : 0.08, len50 = us ? 0.0508 : 0.05, yF = (B.yF != null) ? B.yF : 0.005, clr = 0.003;
    var pieces = g.pieces, fas = g.fas, i, k, m;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function scr(kind, code, Pt, d, ln) { fas.push({ kind: kind, code: code, x: Pt[0], y: Pt[1], z: Pt[2], dir: d, len: ln, r: 0.003 }); }
    /* the pair: both sides when the path stays, else the right one alone (narrower when it must) */
    var pairD = D0, pairBoth = true;
    if (B.inner != null && B.inner - 2 * D0 < pathMin) {
      pairBoth = false;
      pairD = Math.min(D0, B.inner - pathMin);
    }
    var made = [];
    for (i = 0; i < B.runs.length; i++) {
      var R = B.runs[i], D = (R.D != null) ? Math.min(R.D, D0) : D0;
      if (R.pair) { if (!pairBoth && R.pair !== 'r') continue; D = Math.min(D, pairD); }
      if (!(D >= dMin - 1e-9)) continue;
      /* the doors' approach: a keep-out the bench's footprint across the run crosses cuts the run (the longer piece stays) */
      var n0 = Math.min(R.c, R.c + R.o * D), n1 = Math.max(R.c, R.c + R.o * D), a = R.a, b = R.b;
      for (k = 0; k < (B.keep || []).length; k++) {
        var K = B.keep[k], kn0 = (R.ax === 'z') ? K.x0 : K.z0, kn1 = (R.ax === 'z') ? K.x1 : K.z1, ku0 = (R.ax === 'z') ? K.z0 : K.x0, ku1 = (R.ax === 'z') ? K.z1 : K.x1;
        if (kn1 <= n0 || kn0 >= n1 || ku1 <= a || ku0 >= b) continue;
        if (ku0 - a >= b - ku1) b = Math.min(b, ku0); else a = Math.max(a, ku1);
      }
      if (b - a < lMin - 1e-9) continue;
      made.push({ R: R, D: D, a: a, b: b });
    }
    var log = [];
    for (m = 0; m < made.length; m++) {
      var M = made[m], R2 = M.R, Dm = M.D, ua = M.a, Lb = M.b - M.a, id = 'bench-' + (R2.id || (m + 1));
      var at = function (u, n, y) { return (R2.ax === 'z') ? [R2.c + R2.o * n, y, u] : [u, y, R2.c + R2.o * n]; };
      var bxw = function (kind, code, len, sid, u, n, y, du, dn, dy) { var Pt = at(u, n, y); pieces.push({ kind: kind, code: code, len: len, id: sid, box: (R2.ax === 'z') ? [Pt[0], Pt[1], Pt[2], dn, dy, du] : [Pt[0], Pt[1], Pt[2], du, dy, dn] }); };
      var dN = (R2.ax === 'z') ? [R2.o, 0, 0] : [0, 0, R2.o], dNi = [-dN[0], 0, -dN[2]], DOWN = [0, -1, 0];
      var yTop = yF + H, yShelf = yF + SH;
      /* the legs */
      var nLeg = Math.max(2, Math.ceil((Lb - ft) / sp - 1e-9) + 1), legU = [];
      for (k = 0; k < nLeg; k++) legU.push(ua + ft / 2 + (Lb - ft) * k / (nLeg - 1));
      var legN = [ft + fw / 2, Dm - ft - fw / 2];
      for (k = 0; k < nLeg; k++) for (var e = 0; e < 2; e++) bxw('bleg', GH.FRAME, ceil2(H - tt), id + '-leg-' + (k + 1) + (e ? 'f' : 'b'), legU[k], legN[e], yF + (H - tt) / 2, ft, fw, H - tt);
      /* the rails: back and front, at the top and at the shelf; two 6x80 through each into every leg */
      var levels = [{ y1: yTop - tt, nm: 't' }, { y1: yShelf - tt, nm: 's' }];
      for (var lv = 0; lv < 2; lv++) {
        var y1 = levels[lv].y1, y0 = y1 - fw;
        for (e = 0; e < 2; e++) {
          bxw('brail', GH.FRAME, ceil2(Lb), id + '-rail-' + levels[lv].nm + (e ? 'f' : 'b'), ua + Lb / 2, e ? Dm - ft / 2 : ft / 2, (y0 + y1) / 2, Lb, ft, fw);
          for (k = 0; k < nLeg; k++) for (var f2 = 0; f2 < 2; f2++) scr('screw-brail', GH.TOE, at(legU[k], e ? Dm : 0, y0 + fw * (f2 ? 0.4 : 0.2)), e ? dNi : dN, len80);
        }
      }
      /* the top's slats across the depth, flush with the bench's ends */
      var nS = Math.max(2, Math.floor((Lb + gap) / (cw + gap) + 1e-9)), nSl = 0;
      function slat(sid, u, y) {
        bxw('bslat', GH.BOARD, ceil2(Dm), sid, u, Dm / 2, y - tt / 2, cw, Dm, tt);
        nSl++;
        for (var e2 = 0; e2 < 2; e2++) for (var f3 = -1; f3 <= 1; f3 += 2) scr('screw-bslat', GH.FASCIA_SCREW, at(u + f3 * cw / 4, e2 ? Dm - ft / 2 : ft / 2, y), DOWN, len50);
      }
      for (k = 0; k < nS; k++) slat(id + '-slat-' + (k + 1), ua + cw / 2 + (Lb - cw) * k / (nS - 1), yTop);
      /* the shelf's slats between the legs */
      for (k = 0; k + 1 < nLeg; k++) {
        var s0 = legU[k] + ft / 2 + clr, sl = legU[k + 1] - ft / 2 - clr - s0;
        if (sl < cw) continue;
        var n2 = Math.max(1, Math.floor((sl + gap) / (cw + gap) + 1e-9));
        for (var j = 0; j < n2; j++) slat(id + '-shelf-' + (k + 1) + '-' + (j + 1), (n2 === 1) ? s0 + sl / 2 : s0 + cw / 2 + (sl - cw) * j / (n2 - 1), yShelf);
      }
      g.benches++; g.benchL += Lb;
      log.push(id + ' ' + Lb.toFixed(3) + ' x ' + Dm.toFixed(3) + ' (' + nLeg + ' leg pairs, ' + nSl + ' slats)');
    }
    /* the bill: the frame and the boards by length, the coating over every face */
    var per = {}; per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!/^b(leg|rail|slat)$/.test(pc.kind)) continue;
      g.meters[pc.code] = (g.meters[pc.code] || 0) + pc.len;
      g.coat += per[pc.code] * pc.len;
    }
    g.benchLog = made.length ? 'benches: ' + log.join(', ') + ', top ' + (yF + H).toFixed(3) + ' over the floor, shelf ' + (yF + SH).toFixed(3) : 'benches: no wall long enough';
  }
  /* the layouts' single source, the benches over it when they are on */
  function _ghLayout(s) {
    s = s || STATE;
    var g = _ghLayout0(s);
    if (_ghBenchOn(s)) _ghBenches(s, g);
    /* v399 the foundation's quantities (the gazebo's): the pads' gravel beds; the footings' concrete (proud + down to FD_PIER_D), 4 bars, gravel, geotextile, their holes */
    var bkW = _ghU(s, 'FD_BLK'), gvB = _ghU(s, 'FD_GRAVEL'), pW = _ghU(s, 'FD_PIER_W'), pD = _ghU(s, 'FD_PIER_D'), pG = _ghU(s, 'FD_PIER_GRAVEL'), yHp = _ghU(s, 'FD_PIER_UP');
    var nBk = (g.blocks || []).length, nPo = (g.pours || []).length, r3f = function (v) { return Math.round(v * 1000) / 1000; };
    g.fq = { blockN: nBk, pourN: nPo, gravel: r3f(nBk * bkW * bkW * gvB + nPo * pW * pW * pG), dig: r3f(nPo * pW * pW * (pD + pG)), concrete: r3f(nPo * pW * pW * (pD + yHp)),
             rebar: Math.round(nPo * 4 * (pD + yHp - 2 * GH.FD_BAR_COVER) * 100) / 100, geotex: Math.round(nPo * pW * pW * 100) / 100 };
    return g;
  }
  function _ghLayout0(s) {
    s = s || STATE;
    if (_ghLean(s)) return _ghLeanLayout(s);   /* v378 the lean-to: its own layout, the same output */
    if (_ghHoop(s)) return _ghHoopLayout(s);   /* v381 the hoop house: its own layout, the same output */
    if (_ghAframe(s)) return _ghAframeLayout(s);   /* v384 the A-frame: its own layout, the same output */
    if (_ghVict(s)) return _ghVictLayout(s);   /* v387 the Victorian: its own layout, the same output */
    if (_ghOld(s)) return _ghOldLayout(s);   /* v390 the old-window greenhouse: its own layout, the same output */
    var P = _ghProf(s), us = (s.isMetric === false), knee = _ghKnee(s), L = _ghL(s), W = _ghW(s), i, j, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, gl = P.gl, tt = P.tt, cw = P.cw, tw = P.tw, ft = P.ft, fw = P.fw, sg = P.sg;
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { pieces.push({ kind: kind, code: code, len: len, id: id, obox: { c: c, u: u, v: v, n: n, d: [du, dv, dn] } }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function add3(A, B, f) { return [A[0] + B[0] * f, A[1] + B[1] * f, A[2] + B[2] * f]; }
    /* a sheet: an outline (+ holes) in its own (u, v) plane, o its origin, U / V / N its axes (U x V = N, out), t thick, up its flutes */
    function sheet(kind, code, id, pts, holes, o, U, V, N, t, up) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      var tp = (up != null) ? _ghTape(pts, holes, up) : { solid: 0, vent: 0 };
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: tp });
      return area;
    }
    /* THE HEIGHTS: the base's underside and top, the studs' foot (on the
       bottom plate), the top plate's top / underside, the knee wall's top */
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st, yPT = yBt + _ghU(s, 'WALL_H'), yTP0 = yPT - st, yK = yBt + _ghU(s, 'KNEE_H');
    var yGm = knee ? ((yK + st / 2) + yTP0) / 2 : (yP0 + yTP0) / 2;   /* the mid girt's centre (over the knee girt with the knee wall) */
    var girtYs = knee ? [yK, yGm] : [yGm];
    /* THE ROOF'S LINE: the rafters' underside yR(x) (the birdsmouth's heel
       at xh on the top plate), their top yT(x), the ridge board */
    var th = GH.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th), dV = sd / cs;
    var seat = Math.min(sd, dV / (3 * tn)), xh = W / 2 - seat, xr = P.rgt / 2;
    var xa = W / 2 + gl, xo = xa + _ghU(s, 'EAVE'), xe = xo + tt;
    function yR(x) { return yPT + (xh - Math.abs(x)) * tn; }
    function yT(x) { return yR(x) + dV; }
    var rgTop = yT(xr), rgBot = rgTop - P.rgd;
    /* the roof's frame per side: o the ridge line on the rafters' top, V down the slope, N out of the roof, U so that U x V = N */
    function rf(sx2) { return { o: [0, yT(0), 0], U: [0, 0, sx2], V: [sx2 * cs, -sn, 0], N: [sx2 * sn, cs, 0] }; }
    function rw(F, u, v, n) { return [F.o[0] + F.U[0] * u + F.V[0] * v + F.N[0] * n, F.o[1] + F.U[1] * u + F.V[1] * v + F.N[1] * n, F.o[2] + F.U[2] * u + F.V[2] * v + F.N[2] * n]; }

    /* THE FOUNDATION: a ground screw + U head under the side beams and the
       wide end beams' middles; 12 connector nails into the beam's faces */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _ghU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (W / 2 - bw / 2), zp0 + (zp1 - zp0) * i / np, true, (sx < 0 ? 'l' : 'r') + (i + 1));
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, (sz < 0 ? 'b' : 'f') + 'm');
    /* THE BASE: the side beams the full length, the end beams between them */
    for (sx = -1; sx <= 1; sx += 2) box('base', GH.BASE, ceil2(L), 'base-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
    var ebL = W - 2 * bw;
    for (sz = -1; sz <= 1; sz += 2) {
      box('base', GH.BASE, ceil2(ebL), 'base-' + (sz < 0 ? 'b' : 'f'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), ebL, bh, bw);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * W / 2, yBB + bh * (0.3 + 0.4 * k), sz * (L / 2 - bw / 2), [-sx, 0, 0], len200);
    }
    /* THE GRAVEL FLOOR inside the base (dug, filled flush with the ground) */
    var gT = _ghU(s, 'GRAVEL_T'), giW = W - 2 * bw, giL = L - 2 * bw;
    pieces.push({ kind: 'gravel', code: GH.GRAVEL, len: 0, id: 'gravel', box: [0, 0.005 - gT / 2, 0, giW, gT, giL] });
    var gravelM3 = giW * giL * gT;

    /* THE WALLS, framed flat and stood up: a wall along its own axis u (z
       on the side walls, x on the gables); at(u, y, n) maps a wall point
       (n = 0 the wall's middle, + out) to the world */
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;   /* the door's rough opening, the kings' outer faces */
    var gl2 = W / 2 - sd;   /* the gable walls between the side walls */
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yR(oL) - 0.03 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var hdUp = (yHt > yTP0 - 0.005);   /* the header over the top plate's line: the plate stops at the kings, they run up to the end rafter */
    var nGirt = 0, nStud = 0;
    function wall(id, side, u0, u1, grid, door) {
      /* side: { ax: 'z'|'x', c: the wall's middle on the other axis, o: +1 / -1 outward } */
      var hs = (side.ax === 'z'), m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var plates = door ? [[u0, -half], [half, u1]] : [[u0, u1]];
      for (m = 0; m < plates.length; m++) bx('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, 0, plates[m][1] - plates[m][0], st, sd);
      var studs = grid.filter(function (u) { return !door || Math.abs(u) > oL + st / 2 + 0.10; });
      var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
      /* the studs: up through the bottom plate, the top plate over them */
      for (m = 0; m < studs.length; m++) {
        bx('stud', GH.STUD, ceil2(yTP0 - yP0), id + '-stud-' + (m + 1), studs[m], (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
        nStud++;
        for (e = -1; e <= 1; e += 2) {
          sc('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
          sc('screw-tplate', GH.STUD_SCREW, studs[m], yPT, e * sd / 4, 0, -1, 0, len120);
        }
      }
      if (door) {
        /* THE DOOR: the kings (up to the end rafter when the header rises over the plate), the jacks, the flat header, a cripple over it */
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
          if (hdUp) {
            var ka = uk - st / 2, kb = uk + st / 2, kp = [[ka, yP0], [kb, yP0], [kb, yR(kb)], [ka, yR(ka)]];
            if (!hs) poly('king', GH.STUD, ceil2(Math.max(yR(ka), yR(kb)) - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), kp, 'xy', side.c, sd);
            sc('screw-gstud', GH.FRAME_SCREW, uk, yR(uk) - 0.035, sd / 2 - 0.005, 0, 0.95, -0.31, len100);   /* from the outside up into the end rafter */
          } else {
            bx('king', GH.STUD, ceil2(yTP0 - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), uk, (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
            for (f2 = -1; f2 <= 1; f2 += 2) sc('screw-tplate', GH.STUD_SCREW, uk, yPT, f2 * sd / 4, 0, -1, 0, len120);
          }
          bx('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            sc('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);   /* through the king into the header's end */
          }
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);   /* the king into the jack (US: 3 in., two 1 1/2 in. members) */
          nStud += 2;
        }
        bx('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 0, 2 * (half + st), st, sd);
      }
      /* the top plate (stopped at the kings when the header rises past it) */
      var tps = (door && hdUp) ? [[u0, -oL], [oL, u1]] : [[u0, u1]];
      for (m = 0; m < tps.length; m++) if (tps[m][1] - tps[m][0] > 0.03) bx('tplate', GH.STUD, ceil2(tps[m][1] - tps[m][0]), id + '-tplate-' + (m + 1), (tps[m][0] + tps[m][1]) / 2, yPT - st / 2, 0, tps[m][1] - tps[m][0], st, sd);
      /* the members along the wall, in order; the bottom plate's screws between them, the girts across the bays */
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < -half && b > half;
        if (!isDoor && clr > 0.12) sc('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        for (var gy = 0; gy < girtYs.length; gy++) {
          var yc = girtYs[gy];
          bx('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, 0, clr, st, sd);
          nGirt++;
          for (e = -1; e <= 1; e += 2) {
            var ue = (e < 0) ? a + st / 2 + 0.035 : b - st / 2 - 0.035, du2 = (e < 0) ? -0.8 : 0.8;
            sc('screw-girt', GH.TOE, ue, yc + st / 2, e * sd / 4, du2, -0.6, 0, len80);   /* from the girt's top face (the two ends off each other: the next bay's meet the same stud) */
            sc('screw-girt', GH.TOE, ue, yc + e * st / 4, -sd / 2, du2, 0, 0.6, len80);   /* from its inner face */
          }
        }
      }
      return { studs: studs, kings: kings };
    }
    /* the side walls (the full length, their studs and the rafters on one 60 cm / 24 in. grid from the back) */
    var sGrid = _phGrid(-L / 2, L / 2, _ghU(s, 'STUD_SP'), st);
    for (sx = -1; sx <= 1; sx += 2) wall('side-' + (sx < 0 ? 'l' : 'r'), { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx }, -L / 2, L / 2, sGrid, false);
    /* the gable walls between them, their studs from the middle (the gable studs above go on in line); the door in the front */
    var gsp = _ghU(s, 'STUD_SP'), gGrid = [-(gl2 - st / 2), gl2 - st / 2];
    for (k = 0; k * gsp < gl2 - st - 0.12; k++) { gGrid.push(k * gsp); if (k) gGrid.push(-k * gsp); }
    gGrid.sort(function (a, b) { return a - b; });
    for (sz = -1; sz <= 1; sz += 2) {
      var gid = (sz < 0) ? 'back' : 'front';
      wall(gid, { ax: 'x', c: sz * (L / 2 - sd / 2), o: sz }, -gl2, gl2, gGrid, sz > 0);
      /* the corners: three 6x100 from the gable's end stud into the side wall's */
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) scr('screw-corner', GH.FRAME_SCREW, sx * (gl2 - st), yP0 + (yTP0 - yP0) * (0.15 + 0.35 * k), sz * (L / 2 - st / 2), [sx, 0, 0], len100);
    }

    /* THE ROOF FRAME: a rafter pair over every side-wall stud (the end
       pairs over the gable walls), the ridge board between them */
    var zr = sGrid.map(function (z, ii, A) { return { z: z, gable: (ii === 0 || ii === A.length - 1) }; });
    var rafL = ceil2((xo - xr) / cs);
    function rafPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2;
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', GH.STUD, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zr[i].z, st);
        var xm = (xh + W / 2) / 2;
        scr('screw-seat', GH.SEAT_SCREW, sx * xm, yT(xm), zr[i].z, [0, -1, 0], len200);
      }
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr('screw-rtoe', GH.TOE, s3 * xtq, yTm + k3 * s3 * 0.025, zr[i].z + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
    }
    box('ridge', GH.RIDGE, ceil2(L), 'ridge', 0, rgTop - P.rgd / 2, 0, P.rgt, P.rgd, L);
    /* THE RAFTER TIES: 2x4 on edge on the top plates beside every other
       pair (not over the gables), square ends short of the eave blocks */
    var xt = Math.min(xh + (dV - sd - 0.01) / tn, W / 2 - st - 0.005), nTies = 0;
    for (i = 1; i < zr.length - 1; i += 2) {
      var zt = zr[i].z - ((zr[i].z > 0) ? 1 : -1) * st, zsd = (zr[i].z > zt) ? 1 : -1;
      box('tie', GH.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
      nTies++;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) {
          var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
          scr('screw-tie', GH.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt - zsd * st / 2, [0, 0, zsd], len80);
        }
        scr('screw-tie', GH.TIE_DOWN, sx * (xt + (W / 2 - sd)) / 2, yPT + sd, zt, [0, -1, 0], len120);
      }
    }
    /* THE EAVE BLOCKS between the rafters over the side walls (up to the roof's line), two toe screws down into the plate */
    var nEb = 0;
    for (i = 0; i + 1 < zr.length; i++) {
      var zb0 = zr[i].z + st / 2, zb1 = zr[i + 1].z - st / 2, zbc = (zb0 + zb1) / 2, ebc = zb1 - zb0;
      if (ebc < 0.03) continue;
      for (sx = -1; sx <= 1; sx += 2) {
        var ep = [[W / 2 - st, yPT], [W / 2, yPT], [W / 2, yT(W / 2)], [W / 2 - st, yT(W / 2 - st)]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) ep.reverse();
        poly('eblock', GH.STUD, ceil2(ebc), 'eblock-' + (i + 1) + (sx < 0 ? '-l' : '-r'), ep, 'xy', zbc, ebc);
        nEb++;
        for (k = -1; k <= 1; k += 2) scr('screw-eblock', GH.TOE, sx * (W / 2 - st), yPT + 0.042, zbc + k * ebc / 4, [sx * 0.45, -0.893, 0], len80);
      }
    }
    /* THE GABLE STUDS on the gable top plates in line with the wall studs
       (the middle one up under the ridge board), a cripple on the door's
       header; toe screws at the foot, one up into the end rafter */
    var gStuds = 0;
    for (sz = -1; sz <= 1; sz += 2) {
      var gcz = sz * (L / 2 - sd / 2);
      for (k = 0; k < gGrid.length; k++) {
        var gx = gGrid[k], ax2 = Math.abs(gx), onHd = (sz > 0) && ax2 < half - st / 2, inKing = (sz > 0) && !onHd && ax2 < oL + st / 2 + 0.005;
        if (ax2 > gl2 - st - 0.005) continue;                       /* the end studs: under the side walls' rafters */
        if (sz > 0 && !hdUp) {
          /* the header under the top plate: a cripple up to the plate, the gable studs over it everywhere */
          if (onHd && yTP0 - yHt > 0.05) { box('cripple', GH.STUD, ceil2(yTP0 - yHt), 'cripple-' + Math.round(gx * 100), gx, (yHt + yTP0) / 2, gcz, st, yTP0 - yHt, sd); gStuds++; }
          onHd = false; inKing = false;
        }
        if (inKing) continue;                                       /* the kings' place */
        var gy0 = onHd ? yHt : yPT;
        if (ax2 < xr + st / 2 + 1e-6) {
          /* the middle: square under the ridge board */
          if (rgBot - gy0 < 0.06) continue;
          box(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(rgBot - gy0), 'gstud-' + (sz < 0 ? 'b' : 'f') + '0', 0, (gy0 + rgBot) / 2, gcz, st, rgBot - gy0, sd);
          scr('screw-gstud', GH.FRAME_SCREW, 0, rgBot - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);
        } else {
          var ga = gx - st / 2, gb = gx + st / 2;
          if (Math.min(yR(ga), yR(gb)) - gy0 < 0.06) continue;
          var gp = [[ga, gy0], [gb, gy0], [gb, yR(gb)], [ga, yR(ga)]];
          poly(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(Math.max(yR(ga), yR(gb)) - gy0), 'gstud-' + (sz < 0 ? 'b' : 'f') + (gx < 0 ? 'l' : 'r') + Math.round(ax2 * 100), gp, 'xy', gcz, sd);
          scr('screw-gstud', GH.FRAME_SCREW, gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);
        }
        gStuds++;
        for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', us ? GH.TOE : GH.FRAME_SCREW, gx + e3 * st / 2, gy0 + 0.04, gcz + e3 * 3 * sd / 8, [-e3 * 0.5, -0.87, 0], us ? len80 : len100);   /* toed down into the plate / header, the two off each other and off the plate's own screws at +-sd/4 (US: 3 in. into a 1 1/2 in. plate) */
      }
    }

    /* THE PURLINS: a 2x4 on edge across every bay at mid-slope, flush with
       the rafters' top, two toe screws an end; the VENTS' bays get a header
       under the ridge (the vent between it and the purlin) */
    var vWall = (W / 2) / cs, vP = vWall / 2, vH = _ghU(s, 'VENT_S0') + st / 2, gap = GH.VENT_GAP;
    var nb = zr.length - 1, floorA = giW * giL, ventA = (gsp) * Math.max(0.05, vP - vH), nVps = Math.max(1, Math.ceil(floorA * GH.VENT_RATIO / ventA / 2 - 1e-9));
    var inner = [];
    for (i = 1; i < nb - 1; i++) inner.push(i);
    if (!inner.length) for (i = 0; i < nb; i++) inner.push(i);
    nVps = Math.min(nVps, inner.length);
    var ventBays = [];
    for (i = 0; i < nVps; i++) ventBays.push(inner[Math.min(inner.length - 1, Math.floor((i + 0.5) * inner.length / nVps))]);
    var nPur = 0, vents = [];
    function rblock(kind, id, F, i0, v, sx2) {
      var z0b = zr[i0].z + st / 2, z1b = zr[i0 + 1].z - st / 2, clr2 = z1b - z0b, uc = sx2 * (z0b + z1b) / 2;
      obox(kind, GH.STUD, ceil2(clr2), id, rw(F, uc, v, -sd / 2), F.U, F.V, F.N, clr2, st, sd);
      for (var e4 = -1; e4 <= 1; e4 += 2) {
        var ub = uc + e4 * (clr2 / 2 - 0.035), du3 = e4 * 0.8;
        var pA = rw(F, ub, v + st / 2, -sd / 2 + e4 * sd / 4), dA = [F.U[0] * du3 - F.V[0] * 0.6, F.U[1] * du3 - F.V[1] * 0.6, F.U[2] * du3 - F.V[2] * 0.6];
        var pB = rw(F, ub, v + e4 * st / 4, -sd), dB = [F.U[0] * du3 + F.N[0] * 0.6, F.U[1] * du3 + F.N[1] * 0.6, F.U[2] * du3 + F.N[2] * 0.6];
        scr('screw-purlin', GH.TOE, pA[0], pA[1], pA[2], dA, len80);
        scr('screw-purlin', GH.TOE, pB[0], pB[1], pB[2], dB, len80);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      var F0 = rf(sx);
      for (i = 0; i < nb; i++) {
        if (zr[i + 1].z - zr[i].z - st < 0.05) continue;
        rblock('purlin', 'purlin-' + (i + 1) + (sx < 0 ? '-l' : '-r'), F0, i, vP, sx);
        nPur++;
        if (ventBays.indexOf(i) >= 0) {
          rblock('vhead', 'vhead-' + (i + 1) + (sx < 0 ? '-l' : '-r'), F0, i, vH, sx);
          vents.push({ sx: sx, i: i, z0: zr[i].z, z1: zr[i + 1].z });
        }
      }
    }

    /* THE FASCIA on the rafter tails (to past the rake boards), two stainless screws a tail */
    var zfE = L / 2 + gl + tt, eLen = 2 * zfE;
    for (sx = -1; sx <= 1; sx += 2) {
      box('fascia', GH.BOARD, ceil2(eLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, 0, tt, cw, eLen);
      for (i = 0; i < zr.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', GH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), zr[i].z, [-sx, 0, 0], len50);
    }

    /* THE SKIN: the knee wall's siding, the glazing over it (or from the
       base's underside without it); the sides up under the rafter tails,
       the gables up to the rafters' top, the door's opening cut out */
    var polyA = 0, sidingA = 0, tapeS = 0, tapeV = 0, ySide = yR(xa) - 0.003, yG0 = knee ? yK : yBB, t0 = knee ? sg : gl;   /* the sides up under the rafter tails (the plate and the eave blocks close the wall over it) */
    function tally(area, sh) { polyA += area; tapeS += sh.tape.solid; tapeV += sh.tape.vent; }
    for (sx = -1; sx <= 1; sx += 2) {
      var Us = [0, 0, -sx], Vs = [0, 1, 0], Ns = [sx, 0, 0], Os = [sx * W / 2, 0, 0];
      var gpS = [[-L / 2, yG0], [L / 2, yG0], [L / 2, ySide], [-L / 2, ySide]];
      tally(sheet('glaze-wall', null, 'glaze-' + (sx < 0 ? 'l' : 'r'), gpS, null, Os, Us, Vs, Ns, gl, 1), sheets[sheets.length - 1]);
      if (knee) sidingA += sheet('siding', GH.SIDING, 'siding-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, yBB], [L / 2, yBB], [L / 2, yK], [-L / 2, yK]], null, Os, Us, Vs, Ns, sg, null);
    }
    var ag = W / 2 + gl;
    for (sz = -1; sz <= 1; sz += 2) {
      var Ug = [sz, 0, 0], Vg = [0, 1, 0], Ng = [0, 0, sz], Og = [0, 0, sz * L / 2], gTop = [[ag, yT(ag)], [0, yT(0)], [-ag, yT(ag)]], gpG, ghH = null;
      if (sz < 0 || knee === false) {
        gpG = [[-ag, yG0], [ag, yG0]].concat(gTop);
        if (sz > 0) ghH = [[[-half, yBt], [half, yBt], [half, yHd], [-half, yHd]]];
      } else gpG = [[-ag, yK], [-half, yK], [-half, yHd], [half, yHd], [half, yK], [ag, yK]].concat(gTop);
      tally(sheet('glaze-wall', null, 'glaze-' + (sz < 0 ? 'b' : 'f'), gpG, ghH, Og, Ug, Vg, Ng, gl, 1), sheets[sheets.length - 1]);
      if (knee) {
        var as2 = W / 2 + sg, spG = (sz < 0) ? [[-as2, yBB], [as2, yBB], [as2, yK], [-as2, yK]]
                                             : [[-as2, yBB], [as2, yBB], [as2, yK], [half, yK], [half, yBt], [-half, yBt], [-half, yK], [-as2, yK]];
        sidingA += sheet('siding', GH.SIDING, 'siding-' + (sz < 0 ? 'b' : 'f'), spG, null, Og, Ug, Vg, Ng, sg, null);
      }
    }
    /* the roof's glazing per slope: from the ridge line to past the fascia, the vents cut out */
    var vEnd = xe / cs + _ghU(s, 'GL_OVER'), uR = L / 2 + gl;
    for (sx = -1; sx <= 1; sx += 2) {
      var F1 = rf(sx), rh = [];
      for (j = 0; j < vents.length; j++) if (vents[j].sx === sx) {
        var hu0 = (sx > 0) ? vents[j].z0 : -vents[j].z1, hu1 = (sx > 0) ? vents[j].z1 : -vents[j].z0;
        rh.push([[hu0, vH], [hu0, vP], [hu1, vP], [hu1, vH]]);
      }
      tally(sheet('glaze-roof', null, 'glaze-roof-' + (sx < 0 ? 'l' : 'r'), [[-uR, 0], [-uR, vEnd], [uR, vEnd], [uR, 0]], rh, F1.o, F1.U, F1.V, F1.N, gl, -1), sheets[sheets.length - 1]);
      /* the ridge cap over it, its sealing screws along both legs */
      var capW = _ghU(s, 'CAP_W');
      sheet('cap', GH.CAP, 'cap-' + (sx < 0 ? 'l' : 'r'), [[-zfE, 0], [-zfE, capW], [zfE, capW], [zfE, 0]], null, add3(F1.o, F1.N, gl), F1.U, F1.V, F1.N, GH.CAP_T, null);
    }
    var capScrews = 2 * (Math.ceil(eLen / _ghU(s, 'CAP_FIX') - 1e-9) + 1);

    /* THE CORNER BOARDS: two a corner over the skin, the gable's lapping the side's edge */
    var xaT = W / 2 + t0, zaT = L / 2 + t0, nTrim = 0;
    var cTop = Math.min(ySide, yT(xaT + tt) + gl / cs - cw / cs - 0.002), cH = cTop - yBB;   /* up to the side glazing's top / the rake board's underside (it laps the gable's board) */
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      box('trim', GH.TRIM, ceil2(cH), 'trim-g-' + sx + sz, sx * (xaT + tt - tw / 2), yBB + cH / 2, sz * (zaT + tt / 2), tw, cH, tt);
      box('trim', GH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xaT + tt / 2), yBB + cH / 2, sz * (zaT - tw / 2), tt, cH, tw);
      nTrim += 2;
      var ty = fixPts(yBB + 0.08, cTop - 0.08, _ghU(s, 'FIX_SP'));
      for (k = 0; k < ty.length; k++) {
        scr('nail-trim', GH.TRIM_NAIL, sx * (xaT + tt - tw / 2), ty[k], sz * (zaT + tt), [0, 0, -sz], len32, 0.0012);
        scr('nail-trim', GH.TRIM_NAIL, sx * (xaT + tt), ty[k], sz * (zaT - tw / 2), [-sx, 0, 0], len32, 0.0012);
      }
    }
    /* THE RAKE BOARDS on the gables over the glazing's top edge, flush with the roof's glazing; screwed into the end rafters */
    var glV = gl / cs, cwV = cw / cs, rakeL = ceil2(xo / cs);
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var rp = [[0, yT(0) + glV], [xo, yT(xo) + glV], [xo, yT(xo) + glV - cwV], [0, yT(0) + glV - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) rp.reverse();
      poly('rake', GH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), rp, 'xy', sz * (L / 2 + gl + tt / 2), tt);
      var rx = fixPts(0.10, xo - 0.05, _ghU(s, 'FIX_SP'));
      for (k = 0; k < rx.length; k++) scr('screw-rake', GH.FASCIA_SCREW, sx * rx[k], yT(rx[k]) - 0.03, sz * (L / 2 + gl + tt), [0, 0, -sz], len50);
    }
    /* THE CASINGS round the door (jambs + head) and, with the knee wall, the belt boards over its joint */
    var zC = L / 2 + t0;
    var casL = [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, RO + 2 * cw]];
    casL.forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
      var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
      pts2.forEach(function (w2) {
        for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-trim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);   /* the head's into the door's header */
      });
    });
    var nBelt = 0;
    if (knee) {
      var beltPieces = [];
      for (sx = -1; sx <= 1; sx += 2) beltPieces.push({ ax: 'z', c: sx * (W / 2 + sg + tt / 2), o: sx, a: -(zaT - tw), b: zaT - tw, id: 'belt-' + (sx < 0 ? 'l' : 'r') });
      var xb = xaT + tt - tw;
      beltPieces.push({ ax: 'x', c: -(L / 2 + sg + tt / 2), o: -1, a: -xb, b: xb, id: 'belt-b' });
      beltPieces.push({ ax: 'x', c: L / 2 + sg + tt / 2, o: 1, a: -xb, b: -(half + cw), id: 'belt-fl' });
      beltPieces.push({ ax: 'x', c: L / 2 + sg + tt / 2, o: 1, a: half + cw, b: xb, id: 'belt-fr' });
      beltPieces.forEach(function (bp) {
        var bl2 = bp.b - bp.a, bm2 = (bp.a + bp.b) / 2;
        if (bl2 < 0.05) return;
        if (bp.ax === 'z') box('belt', GH.BOARD, ceil2(bl2), bp.id, bp.c, yK, bm2, tt, cw, bl2); else box('belt', GH.BOARD, ceil2(bl2), bp.id, bm2, yK, bp.c, bl2, cw, tt);
        nBelt++;
        fixPts(bp.a + 0.05, bp.b - 0.05, _ghU(s, 'FIX_SP')).forEach(function (w3) {
          for (var e6 = -1; e6 <= 1; e6 += 2) {
            var yy3 = yK + e6 * Math.min(cw / 4, st / 2 - 0.006), nf = bp.c + bp.o * tt / 2;   /* into the knee girt behind */
            if (bp.ax === 'z') scr('nail-trim', GH.TRIM_NAIL, nf, yy3, w3, [-bp.o, 0, 0], len32, 0.0012); else scr('nail-trim', GH.TRIM_NAIL, w3, yy3, nf, [0, 0, -bp.o], len32, 0.0012);
          }
        });
      });
    }

    /* THE DOOR: a 2x3 frame -- the stiles, three rails, two braces rising
       from the hinge side -- in the opening, flush outside with the walls'
       framing, its glazing outside; three strap hinges on the left onto the
       casing, a knob, a ball catch at the top on the latch side */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-door', GH.STUD_SCREW, sx * dW / 2, railY[k] + e7 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA, yB2) {
      /* from the hinge side's bottom corner to the latch side's top one, cut level against the rails */
      var xA = -dW / 2 + fw, xB = dW / 2 - fw, dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xA); pb = _gzClip(pb, -1, 0, xB);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      /* a screw up / down through each rail into the brace's end */
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    var dgA = sheet('glaze-door', null, 'glaze-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1);
    tally(dgA, sheets[sheets.length - 1]);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [-dW / 2 + hingeLen / 2, hy, zD1 + gl + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-half - cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, -dW / 2 + 0.035 + i * 0.10, hy, zD1 + gl + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, -half - cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [dW / 2 - fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + gl, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [dW / 2 - 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* THE ROOF VENTS: the sash's glazing over the opening (resting on the
       rafters' and headers' middles), its 2x3 frame inside the opening,
       hinged at the top on two straps over the header, open VENT_ANG on
       the opener (drawn, no catalogue row) */
    var aV = GH.VENT_ANG * Math.PI / 180, ca = Math.cos(aV), sa = Math.sin(aV), ventAreaSum = 0;
    for (j = 0; j < vents.length; j++) {
      var vt = vents[j], F2 = rf(vt.sx), vid = 'vent-' + (vt.i + 1) + (vt.sx < 0 ? '-l' : '-r');
      var uA = (vt.sx > 0) ? vt.z0 : -vt.z1, uB = (vt.sx > 0) ? vt.z1 : -vt.z0;
      /* the sash's frame: rotated about the hinge line (v = vH, n = gl) */
      var V2 = [F2.V[0] * ca + F2.N[0] * sa, F2.V[1] * ca + F2.N[1] * sa, F2.V[2] * ca + F2.N[2] * sa];
      var N2 = [-F2.V[0] * sa + F2.N[0] * ca, -F2.V[1] * sa + F2.N[1] * ca, -F2.V[2] * sa + F2.N[2] * ca];
      var Hl = rw(F2, 0, vH, gl);
      var sw = function (u, dv, dn) { return [Hl[0] + F2.U[0] * u + V2[0] * dv + N2[0] * dn, Hl[1] + F2.U[1] * u + V2[1] * dv + N2[1] * dn, Hl[2] + F2.U[2] * u + V2[2] * dv + N2[2] * dn]; };
      var gu0 = uA + gap, gu1 = uB - gap, gv1 = vP - vH - gap;                                   /* the glazing: to near the rafters' / purlin's middles */
      var fu0 = uA + st / 2 + gap, fu1 = uB - st / 2 - gap, fv0 = st / 2 + gap, fv1 = vP - vH - st / 2 - gap, fL = fv1 - fv0, fWd = fu1 - fu0;   /* the frame: in the opening */
      for (k = -1; k <= 1; k += 2) {
        var usc = (k < 0) ? fu0 + fw / 2 : fu1 - fw / 2;
        obox('vframe', GH.FRAME, ceil2(fL), vid + '-stile-' + (k < 0 ? 'a' : 'b'), sw(usc, (fv0 + fv1) / 2, -gl - ft / 2), F2.U, V2, N2, fw, fL, ft);
      }
      var vRails = [fv0 + fw / 2, fv1 - fw / 2];
      for (k = 0; k < 2; k++) {
        obox('vframe', GH.FRAME, ceil2(fWd - 2 * fw), vid + '-rail-' + (k + 1), sw((fu0 + fu1) / 2, vRails[k], -gl - ft / 2), F2.U, V2, N2, fWd - 2 * fw, fw, ft);
        for (var e8 = -1; e8 <= 1; e8 += 2) for (var e9 = -1; e9 <= 1; e9 += 2) {
          var pv = sw((e8 < 0) ? fu0 : fu1, vRails[k] + e9 * fw / 4, -gl - ft / 2);
          scr('screw-vframe', GH.STUD_SCREW, pv[0], pv[1], pv[2], [-e8 * F2.U[0], -e8 * F2.U[1], -e8 * F2.U[2]], len120);
        }
      }
      var sgA = sheet('glaze-vent', null, vid + '-glaze', [[gu0, 0], [gu0, gv1], [gu1, gv1], [gu1, 0]].map(function (Pt) { return [Pt[0], Pt[1] + gap]; }), null, sw(0, 0, -gl), F2.U, V2, N2, gl, -1);
      tally(sgA, sheets[sheets.length - 1]);
      ventAreaSum += (uB - uA) * (vP - vH);
      /* two strap hinges: the strap down the sash over its top rail, the leaf up the roof over the header */
      for (k = -1; k <= 1; k += 2) {
        var hu = (k < 0) ? gu0 + 0.08 : gu1 - 0.08, hLs = 0.18, hLb = 0.06;   /* the leaf below the ridge cap */
        obox('vhinge', GH.HINGE, 0, vid + '-hinge-' + (k < 0 ? 'a' : 'b'), sw(hu, gap + hLs / 2, hT / 2), F2.U, V2, N2, hingeW, hLs, hT);
        obox('vhinge', null, 0, vid + '-hinge-leaf-' + (k < 0 ? 'a' : 'b'), rw(F2, hu, vH - hLb / 2, gl + hT / 2), F2.U, F2.V, F2.N, hingeW * 1.6, hLb, hT);
        hinges++;
        for (i = 0; i < 3; i++) {
          var hp1 = sw(hu, gap + st / 2 + fw * (0.15 + 0.35 * i), hT), hp2 = rw(F2, hu + (i - 1) * 0.01, vH - 0.015, gl + hT);
          scr('screw-vhinge', GH.HINGE_SCREW, hp1[0], hp1[1], hp1[2], [-N2[0], -N2[1], -N2[2]], len40, 0.0022);
          scr('screw-vhinge', GH.HINGE_SCREW, hp2[0], hp2[1], hp2[2], [-F2.N[0], -F2.N[1], -F2.N[2]], len40, 0.0022);
        }
      }
      /* the opener: from the purlin's up-slope face (inside) to the sash's bottom rail */
      var oA = rw(F2, (uA + uB) / 2, vP - st / 2 - 0.02, -sd * 0.7), oB = sw((uA + uB) / 2, vRails[1], -gl - ft);
      var od = [oB[0] - oA[0], oB[1] - oA[1], oB[2] - oA[2]], oLn = Math.sqrt(od[0] * od[0] + od[1] * od[1] + od[2] * od[2]), oU = [od[0] / oLn, od[1] / oLn, od[2] / oLn];
      var oX = F2.U, oN = [oU[1] * oX[2] - oU[2] * oX[1], oU[2] * oX[0] - oU[0] * oX[2], oU[0] * oX[1] - oU[1] * oX[0]];
      obox('opener', null, 0, vid + '-opener', [(oA[0] + oB[0]) / 2, (oA[1] + oB[1]) / 2, (oA[2] + oB[2]) / 2], oX, oU, oN, 0.03, oLn, 0.03);
    }
    if (polyA > 0) missing.push({ name: GH.POLY_NAME, qty: Math.round(polyA * GH.WASTE * 100) / 100, unit: 'm2' });
    if (tapeV > 0) missing.push({ name: GH.VTAPE_NAME, qty: Math.round(tapeV * 100) / 100, unit: 'm' });
    if (vents.length) missing.push({ name: GH.OPENER_NAME, qty: vents.length, unit: 'pcs' });

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    var m3 = {}, coat = sidingA;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.RIDGE] = 2 * (P.rgt + P.rgd); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw); per[GH.TRIM] = 2 * (tt + tw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    /* v392 the benches' runs: along both side walls inside the framing, the door's approach kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bX = W / 2 - sd - bClr, bZ = L / 2 - sd - bEnd;
    var benchSpec = { inner: 2 * bX, runs: [{ id: 'l', ax: 'z', c: -bX, o: 1, a: -bZ, b: bZ, pair: 'l' }, { id: 'r', ax: 'z', c: bX, o: -1, a: -bZ, b: bZ, pair: 'r' }],
                      keep: [{ x0: -half - 0.05, x1: half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    return {
      P: P, us: us, knee: knee, L: L, W: W, benchSpec: benchSpec, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing,
      meters: m3, coat: coat, polyA: polyA, sidingA: sidingA, tapeSolid: tapeS, tapeVent: tapeV, capL: eLen, capScrews: capScrews, hinges: hinges,
      gravelM3: r3(gravelM3), digM3: r3(gravelM3), floorA: floorA, rafters: zr, ties: nTies, eBlocks: nEb, gStuds: gStuds, girts: nGirt, studs: nStud, purlins: nPur,
      vents: vents.length, ventA: ventAreaSum, trims: nTrim, belts: nBelt, doorW: dW, doorH: dH, RO: RO, hdUp: hdUp,
      yBB: yBB, yBt: yBt, yPT: yPT, yK: yK, ridgeTop: rgTop, pitch: GH.PITCH, rafL: rafL, roofLen: eLen, slope: vEnd,
      top: yT(0) + gl / cs + 0.01, height: yT(0) + gl / cs + 0.01, depth: W, length: L, extX: xe + _ghU(s, 'GL_OVER') * cs, extZ: zfE
    };
  }
  /* ------------------------------------------------------------------
     v378 TYPE 36 -- GREENHOUSES, variant 2: THE LEAN-TO GREENHOUSE (Marek
     2026-10-30 10:11 "Muzes pokracovat" -- slot 2 of the plan; asked:
     its own back wall, self-supporting on its ground screws, tied to the
     house by a few angle brackets under an endwall flashing; the door in
     an end wall). The gable greenhouse's build against a house wall:
       - FOUNDATION as the gable's (ground screws + U heads under the long
         beams, one under each end beam's middle from 2.70 m / US 9 ft);
         the BASE here with the end beams the full width and the long ones
         between them -- the back beam's outer face LGAP (5 cm, US 2 in.)
         off the house, so the corner screws go in from the ends;
       - WALLS: the front wall 1.83 m (US 6 ft) as the gable's sides; the
         back wall up to the roof's high end, two girts, no glazing (the
         house is behind it); the end walls between them up to the front's
         plate line, end studs over it up to the end rafters; the door in
         the right end wall (+Z) towards the back, where the roof is high,
         a 10 cm bay off the end stud (the corner's screws);
       - ROOF: one 20 deg slope from the back to the front, 2x4 rafters in
         line with the studs, a birdsmouth on both plates (level seats: no
         thrust), an 8x200 down through each seat, blocks between them over
         both walls, purlins at mid-slope, the vents under its high end;
       - AT THE HOUSE: an endwall flashing ROR00013 from the house wall
         (its leg up the wall under the cladding) over the roof's top edge,
         sealing screws through its roof leg; reinforced angle brackets
         FAT00005 from the back wall's studs to the house wall, <= 1.20 m
         (US 4 ft) -- three 5x40 into the stud, two 10x75 concrete screw
         anchors FAS10075 into a masonry wall; a 1x4 closer board over the
         gap at each end;
       - the glazing, the trims, the door (hinged on its front side, so it
         opens away from the house), the vents and the knee wall as the
         gable's.
     The house wall is drawn as context only (see-through, not billed, not
     in AR). X = across (-X the house, +X the front), Y up, Z along the
     house (+Z the end with the door). L / W = the base's outer faces. */
  function _ghLean(s) { return (((s || STATE).variant) | 0) === 36; }   /* the numbers between 33 and 36 went to other threads */
  function _ghLeanLayout(s) {
    s = s || STATE;
    var P = _ghProf(s), us = (s.isMetric === false), knee = _ghKnee(s), L = _ghL(s), W = _ghW(s), i, j, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, gl = P.gl, tt = P.tt, cw = P.cw, tw = P.tw, ft = P.ft, fw = P.fw, sg = P.sg;
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08, len75 = us ? 0.0762 : 0.075,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { pieces.push({ kind: kind, code: code, len: len, id: id, obox: { c: c, u: u, v: v, n: n, d: [du, dv, dn] } }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function add3(A, B, f) { return [A[0] + B[0] * f, A[1] + B[1] * f, A[2] + B[2] * f]; }
    function sheet(kind, code, id, pts, holes, o, U, V, N, t, up) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      var tp = (up != null) ? _ghTape(pts, holes, up) : { solid: 0, vent: 0 };
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: tp });
      return area;
    }
    /* THE HOUSE: the back wall's outer face xB, the house wall's face xH */
    var gapH = _ghU(s, 'LGAP'), xB = -W / 2, xH = xB - gapH;
    /* THE HEIGHTS (as the gable's): the base, the studs' foot, the front wall's plate, the knee wall's top */
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st, yPT = yBt + _ghU(s, 'WALL_H'), yTP0 = yPT - st, yK = yBt + _ghU(s, 'KNEE_H');
    var yGm = knee ? ((yK + st / 2) + yTP0) / 2 : (yP0 + yTP0) / 2;
    var girtYs = knee ? [yK, yGm] : [yGm];
    /* THE ROOF'S LINE: the rafters' underside yR(x) rising from the front
       plate's birdsmouth to the back, their top yT(x); the back plate's top
       yPB under the back seat (the same seat as the front's) */
    var th = GH.LPITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th), dV = sd / cs;
    var seat = Math.min(sd, dV / (3 * tn)), xh = W / 2 - seat;
    var xa = W / 2 + gl, xo = xa + _ghU(s, 'EAVE'), xe = xo + tt;
    function yR(x) { return yPT + (xh - x) * tn; }
    function yT(x) { return yR(x) + dV; }
    var xcB = xB + sd - seat, yPB = yR(xcB), yTB0 = yPB - st;
    var bClr = yTB0 - yP0, bGirts = (bClr > 2.2) ? [yP0 + bClr / 3, yP0 + 2 * bClr / 3] : [(yP0 + yTB0) / 2];
    /* the roof's frame: o its top edge at the back on the rafters' top, U along the house, V down the slope, N out */
    var F = { o: [xB, yT(xB), 0], U: [0, 0, 1], V: [cs, -sn, 0], N: [sn, cs, 0] };
    function rw(u, v, n) { return [F.o[0] + F.U[0] * u + F.V[0] * v + F.N[0] * n, F.o[1] + F.U[1] * u + F.V[1] * v + F.N[1] * n, F.o[2] + F.U[2] * u + F.V[2] * v + F.N[2] * n]; }

    /* THE FOUNDATION: a ground screw + U head under the long beams and the wide end beams' middles */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _ghU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (W / 2 - bw / 2), zp0 + (zp1 - zp0) * i / np, true, (sx < 0 ? 'k' : 'f') + (i + 1));
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, (sz < 0 ? 'l' : 'r') + 'm');
    /* THE BASE: the end beams the full width, the long beams between them; two 8x200 through each end beam into the long one's end */
    for (sz = -1; sz <= 1; sz += 2) box('base', GH.BASE, ceil2(W), 'base-' + (sz < 0 ? 'l' : 'r'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), W, bh, bw);
    var lbL = L - 2 * bw;
    for (sx = -1; sx <= 1; sx += 2) {
      box('base', GH.BASE, ceil2(lbL), 'base-' + (sx < 0 ? 'k' : 'f'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, lbL);
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * (W / 2 - bw / 2), yBB + bh * (0.3 + 0.4 * k), sz * L / 2, [0, 0, -sz], len200);
    }
    /* THE GRAVEL FLOOR inside the base */
    var gT = _ghU(s, 'GRAVEL_T'), giW = W - 2 * bw, giL = L - 2 * bw;
    pieces.push({ kind: 'gravel', code: GH.GRAVEL, len: 0, id: 'gravel', box: [0, 0.005 - gT / 2, 0, giW, gT, giL] });
    var gravelM3 = giW * giL * gT;

    /* THE WALLS, framed flat and stood up: u along the wall (z on the long
       walls, x on the end walls), yTop its plate's top, dc the door's
       middle (null: none), gYs its girts */
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;
    var e0 = xB + sd, e1 = W / 2 - sd;                 /* the end walls between the back and front walls */
    var xD = e0 + st + 0.105 + oL;                     /* the door's middle: towards the back, a 10 cm bay past the end stud */
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yR(xD + oL) - 0.03 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var hdUp = (yHt > yTP0 - 0.005);
    var nGirt = 0, nStud = 0;
    function wall(id, side, u0, u1, grid, dc, yTop, gYs) {
      var hs = (side.ax === 'z'), door = (dc != null), yTp0 = yTop - st, m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var plates = door ? [[u0, dc - half], [dc + half, u1]] : [[u0, u1]];
      for (m = 0; m < plates.length; m++) bx('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, 0, plates[m][1] - plates[m][0], st, sd);
      var studs = grid.filter(function (u) { return !door || Math.abs(u - dc) > oL + st / 2 + 0.10; });
      var kings = door ? [dc - (oL - st / 2), dc + (oL - st / 2)] : [];
      for (m = 0; m < studs.length; m++) {
        bx('stud', GH.STUD, ceil2(yTp0 - yP0), id + '-stud-' + (m + 1), studs[m], (yP0 + yTp0) / 2, 0, st, yTp0 - yP0, sd);
        nStud++;
        for (e = -1; e <= 1; e += 2) {
          sc('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
          sc('screw-tplate', GH.STUD_SCREW, studs[m], yTop, e * sd / 4, 0, -1, 0, len120);
        }
      }
      if (door) {
        /* THE DOOR: the kings (up to the end rafter when the header rises over the plate), the jacks, the flat header */
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = dc + e * (half + st / 2);
          if (hdUp) {
            var ka = uk - st / 2, kb = uk + st / 2, kp = [[ka, yP0], [kb, yP0], [kb, yR(kb)], [ka, yR(ka)]];
            if (!hs) poly('king', GH.STUD, ceil2(Math.max(yR(ka), yR(kb)) - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), kp, 'xy', side.c, sd);
            sc('screw-gstud', GH.FRAME_SCREW, uk, yR(uk) - 0.035, sd / 2 - 0.005, 0, 0.95, -0.31, len100);   /* from the outside up into the end rafter */
          } else {
            bx('king', GH.STUD, ceil2(yTp0 - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), uk, (yP0 + yTp0) / 2, 0, st, yTp0 - yP0, sd);
            for (f2 = -1; f2 <= 1; f2 += 2) sc('screw-tplate', GH.STUD_SCREW, uk, yTop, f2 * sd / 4, 0, -1, 0, len120);
          }
          bx('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            sc('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', GH.STUD_SCREW, dc + e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);   /* through the king into the header's end */
          }
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, dc + e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);   /* the king into the jack */
          nStud += 2;
        }
        bx('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', dc, yHd + st / 2, 0, 2 * (half + st), st, sd);
      }
      /* the top plate (stopped at the kings when the header rises past it) */
      var tps = (door && hdUp) ? [[u0, dc - oL], [dc + oL, u1]] : [[u0, u1]];
      for (m = 0; m < tps.length; m++) if (tps[m][1] - tps[m][0] > 0.03) bx('tplate', GH.STUD, ceil2(tps[m][1] - tps[m][0]), id + '-tplate-' + (m + 1), (tps[m][0] + tps[m][1]) / 2, yTop - st / 2, 0, tps[m][1] - tps[m][0], st, sd);
      /* the bottom plate's screws between the members, the girts across the bays */
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < dc - half && b > dc + half;
        if (!isDoor && clr > 0.12) sc('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        for (var gy = 0; gy < gYs.length; gy++) {
          var yc = gYs[gy];
          bx('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, 0, clr, st, sd);
          nGirt++;
          for (e = -1; e <= 1; e += 2) {
            var ue = (e < 0) ? a + st / 2 + Math.min(0.035, clr / 4) : b - st / 2 - Math.min(0.035, clr / 4), du2 = (e < 0) ? -0.8 : 0.8;
            sc('screw-girt', GH.TOE, ue, yc + st / 2, e * sd / 4, du2, -0.6, 0, len80);   /* from the girt's top face */
            sc('screw-girt', GH.TOE, ue, yc + e * st / 4, -sd / 2, du2, 0, 0.6, len80);   /* from its inner face */
          }
        }
      }
      return { studs: studs, kings: kings };
    }
    /* the long walls: the front (low) and the back (up to the roof's high end), their studs and the rafters on one grid */
    var sGrid = _phGrid(-L / 2, L / 2, _ghU(s, 'STUD_SP'), st);
    wall('front', { ax: 'z', c: W / 2 - sd / 2, o: 1 }, -L / 2, L / 2, sGrid, null, yPT, girtYs);
    var wB = wall('back', { ax: 'z', c: xB + sd / 2, o: -1 }, -L / 2, L / 2, sGrid, null, yPB, bGirts);
    /* the end walls between them, their studs from the back; the door in the right one */
    var gsp = _ghU(s, 'STUD_SP'), gGrid = [];
    for (k = 0; e0 + st / 2 + k * gsp < e1 - st / 2 - 0.12; k++) gGrid.push(e0 + st / 2 + k * gsp);
    gGrid.push(e1 - st / 2);
    for (sz = -1; sz <= 1; sz += 2) {
      wall('end-' + (sz < 0 ? 'l' : 'r'), { ax: 'x', c: sz * (L / 2 - sd / 2), o: sz }, e0, e1, gGrid, (sz > 0) ? xD : null, yPT, girtYs);
      /* the corners: three 6x100 from the end wall's end studs into the long walls' (clear of the girts) */
      for (k = 0; k < 3; k++) {
        var yCo = yP0 + (yTP0 - yP0) * [0.15, 0.40, 0.85][k];
        scr('screw-corner', GH.FRAME_SCREW, e0 + st, yCo, sz * (L / 2 - st / 2), [-1, 0, 0], len100);
        scr('screw-corner', GH.FRAME_SCREW, e1 - st, yCo, sz * (L / 2 - st / 2), [1, 0, 0], len100);
      }
    }

    /* THE ROOF FRAME: a rafter over every long-wall stud, a birdsmouth on
       both plates, an 8x200 down through each seat */
    var zr = sGrid.map(function (z, ii, A) { return { z: z, gable: (ii === 0 || ii === A.length - 1) }; });
    var rafL = ceil2((xo - xB) / cs);
    var rafPts = [[xB, yR(xB)], [xB, yT(xB)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT], [xB + sd, yR(xB + sd)], [xB + sd, yPB], [xcB, yPB]];
    var xmF = (xh + W / 2) / 2, xmB = (xcB + xB + sd) / 2;
    for (i = 0; i < zr.length; i++) {
      poly('rafter', GH.STUD, rafL, 'rafter-' + (i + 1), rafPts, 'xy', zr[i].z, st);
      scr('screw-seat', GH.SEAT_SCREW, xmF, yT(xmF), zr[i].z, [0, -1, 0], len200);
      scr('screw-seat', GH.SEAT_SCREW, xmB, yT(xmB), zr[i].z, [0, -1, 0], len200);
    }
    /* THE BLOCKS between the rafters over both walls (up to the roof's line), two toe screws down into the plate */
    var nEb = 0;
    for (i = 0; i + 1 < zr.length; i++) {
      var zb0 = zr[i].z + st / 2, zb1 = zr[i + 1].z - st / 2, zbc = (zb0 + zb1) / 2, ebc = zb1 - zb0;
      if (ebc < 0.03) continue;
      poly('eblock', GH.STUD, ceil2(ebc), 'eblock-' + (i + 1) + '-f', [[W / 2 - st, yPT], [W / 2, yPT], [W / 2, yT(W / 2)], [W / 2 - st, yT(W / 2 - st)]], 'xy', zbc, ebc);
      poly('eblock', GH.STUD, ceil2(ebc), 'eblock-' + (i + 1) + '-k', [[xB, yPB], [xB + st, yPB], [xB + st, yT(xB + st)], [xB, yT(xB)]], 'xy', zbc, ebc);
      nEb += 2;
      for (k = -1; k <= 1; k += 2) {
        scr('screw-eblock', GH.TOE, W / 2 - st, yPT + 0.042, zbc + k * ebc / 4, [0.45, -0.893, 0], len80);
        scr('screw-eblock', GH.TOE, xB + st, yPB + 0.042, zbc + k * ebc / 4, [-0.45, -0.893, 0], len80);
      }
    }
    /* THE END STUDS over the end walls' plates up to the end rafters (a
       cripple on the door's header); toe screws at the foot, one up into
       the end rafter */
    var gStuds = 0;
    for (sz = -1; sz <= 1; sz += 2) {
      var gcz = sz * (L / 2 - sd / 2), dr = (sz > 0), pos = gGrid.filter(function (g2) { return !dr || Math.abs(g2 - xD) >= half - st / 2; });
      if (dr) pos.push(xD);   /* over the header: one cripple in its middle */
      pos.sort(function (a, b) { return a - b; });
      for (k = 0; k < pos.length; k++) {
        var gx = pos[k], dx2 = Math.abs(gx - xD), onHd = dr && dx2 < half - st / 2;
        if (dr && !onHd && dx2 <= oL + st / 2 + 0.10) continue;    /* the kings' place, and the wall's studs kept off the door */
        if (dr && !hdUp && onHd) {
          /* the header under the plate: a cripple up to the plate, the end stud over it */
          if (yTP0 - yHt > 0.05) { box('cripple', GH.STUD, ceil2(yTP0 - yHt), 'cripple-' + Math.round(gx * 100), gx, (yHt + yTP0) / 2, gcz, st, yTP0 - yHt, sd); gStuds++; }
          onHd = false;
        }
        var gy0 = onHd ? yHt : yPT, ga = gx - st / 2, gb = gx + st / 2;
        if (Math.min(yR(ga), yR(gb)) - gy0 < 0.06) continue;
        var gp = [[ga, gy0], [gb, gy0], [gb, yR(gb)], [ga, yR(ga)]];
        poly(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(Math.max(yR(ga), yR(gb)) - gy0), 'gstud-' + (sz < 0 ? 'l' : 'r') + Math.round((gx - xB) * 100), gp, 'xy', gcz, sd);
        scr('screw-gstud', GH.FRAME_SCREW, gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);
        gStuds++;
        for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', us ? GH.TOE : GH.FRAME_SCREW, gx + e3 * st / 2, gy0 + 0.04, gcz + e3 * 3 * sd / 8, [-e3 * 0.5, -0.87, 0], us ? len80 : len100);
      }
    }

    /* THE PURLINS across every bay at mid-slope; the VENTS' bays a header under the roof's top edge */
    var vP = W / cs / 2, vH = _ghU(s, 'VENT_S0') + st / 2, gap = GH.VENT_GAP;
    var nb = zr.length - 1, floorA = giW * giL, ventA = gsp * Math.max(0.05, vP - vH), nVs = Math.max(1, Math.ceil(floorA * GH.VENT_RATIO / ventA - 1e-9));
    var inner = [];
    for (i = 1; i < nb - 1; i++) inner.push(i);
    if (!inner.length) for (i = 0; i < nb; i++) inner.push(i);
    nVs = Math.min(nVs, inner.length);
    var ventBays = [];
    for (i = 0; i < nVs; i++) ventBays.push(inner[Math.min(inner.length - 1, Math.floor((i + 0.5) * inner.length / nVs))]);
    var nPur = 0, vents = [];
    function rblock(kind, id, i0, v) {
      var z0b = zr[i0].z + st / 2, z1b = zr[i0 + 1].z - st / 2, clr2 = z1b - z0b, uc = (z0b + z1b) / 2;
      obox(kind, GH.STUD, ceil2(clr2), id, rw(uc, v, -sd / 2), F.U, F.V, F.N, clr2, st, sd);
      for (var e4 = -1; e4 <= 1; e4 += 2) {
        var ub = uc + e4 * (clr2 / 2 - 0.035), du3 = e4 * 0.8;
        var pA = rw(ub, v + st / 2, -sd / 2 + e4 * sd / 4), dA = [F.U[0] * du3 - F.V[0] * 0.6, F.U[1] * du3 - F.V[1] * 0.6, F.U[2] * du3 - F.V[2] * 0.6];
        var pB = rw(ub, v + e4 * st / 4, -sd), dB = [F.U[0] * du3 + F.N[0] * 0.6, F.U[1] * du3 + F.N[1] * 0.6, F.U[2] * du3 + F.N[2] * 0.6];
        scr('screw-purlin', GH.TOE, pA[0], pA[1], pA[2], dA, len80);
        scr('screw-purlin', GH.TOE, pB[0], pB[1], pB[2], dB, len80);
      }
    }
    for (i = 0; i < nb; i++) {
      if (zr[i + 1].z - zr[i].z - st < 0.05) continue;
      rblock('purlin', 'purlin-' + (i + 1), i, vP);
      nPur++;
      if (ventBays.indexOf(i) >= 0) {
        rblock('vhead', 'vhead-' + (i + 1), i, vH);
        vents.push({ i: i, z0: zr[i].z, z1: zr[i + 1].z });
      }
    }

    /* THE FASCIA on the rafter tails (past the rake boards), two stainless screws a tail */
    var zfE = L / 2 + gl + tt, eLen = 2 * zfE;
    box('fascia', GH.BOARD, ceil2(eLen), 'fascia', xo + tt / 2, yT(xe) - cw / 2, 0, tt, cw, eLen);
    for (i = 0; i < zr.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', GH.FASCIA_SCREW, xe, yT(xe) - cw * (0.25 + 0.35 * k), zr[i].z, [-1, 0, 0], len50);

    /* THE SKIN: the knee wall's siding, the glazing over it; the front up
       under the rafter tails, the ends up to the rafters' top from the back
       wall's face (the house closes the back), the door cut out */
    var polyA = 0, sidingA = 0, tapeS = 0, tapeV = 0, ySide = yR(xa) - 0.003, yG0 = knee ? yK : yBB, t0 = knee ? sg : gl;
    function tally() { var sh = sheets[sheets.length - 1]; polyA += sh.area; tapeS += sh.tape.solid; tapeV += sh.tape.vent; }
    var Us = [0, 0, -1], Vs = [0, 1, 0], Ns = [1, 0, 0], Os = [W / 2, 0, 0];
    sheet('glaze-wall', null, 'glaze-f', [[-L / 2, yG0], [L / 2, yG0], [L / 2, ySide], [-L / 2, ySide]], null, Os, Us, Vs, Ns, gl, 1); tally();
    if (knee) sidingA += sheet('siding', GH.SIDING, 'siding-f', [[-L / 2, yBB], [L / 2, yBB], [L / 2, yK], [-L / 2, yK]], null, Os, Us, Vs, Ns, sg, null);
    var ag = W / 2 + gl, as2 = W / 2 + sg;
    for (sz = -1; sz <= 1; sz += 2) {
      var mp = function (A) { return A.map(function (Pt) { return [sz * Pt[0], Pt[1]]; }); };
      var Ug = [sz, 0, 0], Vg = [0, 1, 0], Ng = [0, 0, sz], Og = [0, 0, sz * L / 2], gTop = [[ag, yT(ag)], [xB, yT(xB)]], gpG, ghH = null;
      if (sz < 0 || knee === false) {
        gpG = [[xB, yG0], [ag, yG0]].concat(gTop);
        if (sz > 0) ghH = [mp([[xD - half, yBt], [xD + half, yBt], [xD + half, yHd], [xD - half, yHd]])];
      } else gpG = [[xB, yK], [xD - half, yK], [xD - half, yHd], [xD + half, yHd], [xD + half, yK], [ag, yK]].concat(gTop);
      sheet('glaze-wall', null, 'glaze-' + (sz < 0 ? 'l' : 'r'), mp(gpG), ghH, Og, Ug, Vg, Ng, gl, 1); tally();
      if (knee) {
        var spG = (sz < 0) ? [[xB, yBB], [as2, yBB], [as2, yK], [xB, yK]]
                           : [[xB, yBB], [as2, yBB], [as2, yK], [xD + half, yK], [xD + half, yBt], [xD - half, yBt], [xD - half, yK], [xB, yK]];
        sidingA += sheet('siding', GH.SIDING, 'siding-' + (sz < 0 ? 'l' : 'r'), mp(spG), null, Og, Ug, Vg, Ng, sg, null);
      }
    }
    /* the roof's glazing: from its top edge at the back wall to past the fascia, the vents cut out */
    var vEnd = (xe - xB) / cs + _ghU(s, 'GL_OVER'), uR = L / 2 + gl, rh = [];
    for (j = 0; j < vents.length; j++) rh.push([[vents[j].z0, vH], [vents[j].z0, vP], [vents[j].z1, vP], [vents[j].z1, vH]]);
    sheet('glaze-roof', null, 'glaze-roof', [[-uR, 0], [-uR, vEnd], [uR, vEnd], [uR, 0]], rh, F.o, F.U, F.V, F.N, gl, -1); tally();
    /* THE ENDWALL FLASHING: its roof leg over the glazing's top edge from
       the house wall, its leg up the wall (under the house's cladding);
       sealing screws through the roof leg */
    var flW = _ghU(s, 'FLASH_W'), flUp = _ghU(s, 'FLASH_UP'), v0f = -gapH / cs, yw0 = yT(xB) + gapH * tn + gl / cs;
    sheet('flash', null, 'flash-roof', [[-zfE, v0f], [-zfE, flW], [zfE, flW], [zfE, v0f]], null, add3(F.o, F.N, gl), F.U, F.V, F.N, GH.CAP_T, null);
    sheet('flash', null, 'flash-wall', [[-zfE, yw0], [zfE, yw0], [zfE, yw0 + flUp], [-zfE, yw0 + flUp]], null, [xH, 0, 0], [0, 0, -1], [0, 1, 0], [1, 0, 0], GH.CAP_T, null);
    var flScrews = Math.ceil(eLen / _ghU(s, 'CAP_FIX') - 1e-9) + 1;

    /* THE CORNER BOARDS at the front corners: two a corner over the skin, the end's lapping the front's edge */
    var xaT = W / 2 + t0, zaT = L / 2 + t0, nTrim = 0, glV = gl / cs, cwV = cw / cs;
    var cTop = Math.min(ySide, yT(xaT + tt) + glV - cwV - 0.002), cH = cTop - yBB;
    for (sz = -1; sz <= 1; sz += 2) {
      box('trim', GH.TRIM, ceil2(cH), 'trim-e-' + sz, xaT + tt - tw / 2, yBB + cH / 2, sz * (zaT + tt / 2), tw, cH, tt);
      box('trim', GH.TRIM, ceil2(cH), 'trim-f-' + sz, xaT + tt / 2, yBB + cH / 2, sz * (zaT - tw / 2), tt, cH, tw);
      nTrim += 2;
      var ty = fixPts(yBB + 0.08, cTop - 0.08, _ghU(s, 'FIX_SP'));
      for (k = 0; k < ty.length; k++) {
        scr('nail-trim', GH.TRIM_NAIL, xaT + tt - tw / 2, ty[k], sz * (zaT + tt), [0, 0, -sz], len32, 0.0012);
        scr('nail-trim', GH.TRIM_NAIL, xaT + tt, ty[k], sz * (zaT - tw / 2), [-1, 0, 0], len32, 0.0012);
      }
    }
    /* THE CLOSER BOARDS at the back corners: a 1x4 on each end from the
       house wall over the gap and the glazing's back edge, up to the rake
       board; nailed into the back wall's end stud / the base */
    function yRk(x) { return yT(x) + glV - cwV; }   /* the rake board's underside */
    var nClose = 0, xCn = xH + cw - 0.025;
    for (sz = -1; sz <= 1; sz += 2) {
      var zCl = sz * (L / 2 + t0 + tt / 2), clTop = yRk(xH + cw);
      poly('closer', GH.BOARD, ceil2(yRk(xH) - yBB), 'closer-' + (sz < 0 ? 'l' : 'r'), [[xH, yBB], [xH + cw, yBB], [xH + cw, yRk(xH + cw)], [xH, yRk(xH)]], 'xy', zCl, tt);
      nClose++;
      fixPts(yBB + 0.06, clTop - 0.06, _ghU(s, 'FIX_SP')).forEach(function (yn) {
        if (yn > yPB - 0.01 && yn < yR(xCn) + 0.02) yn = yPB - 0.03;   /* not into the gap between the back plate and the end rafter */
        scr('nail-trim', GH.TRIM_NAIL, xCn, yn, sz * (L / 2 + t0 + tt), [0, 0, -sz], len32, 0.0012);
      });
    }
    /* THE RAKE BOARDS on the ends over the glazing's top edge, flush with the roof's glazing, from the house wall; screwed into the end rafters */
    var rakeL = ceil2((xo - xH) / cs);
    for (sz = -1; sz <= 1; sz += 2) {
      var rp = [[xH, yT(xH) + glV], [xo, yT(xo) + glV], [xo, yT(xo) + glV - cwV], [xH, yT(xH) + glV - cwV]];
      poly('rake', GH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'l' : 'r'), rp, 'xy', sz * (L / 2 + gl + tt / 2), tt);
      var rx = fixPts(xB + 0.10, xo - 0.05, _ghU(s, 'FIX_SP'));
      for (k = 0; k < rx.length; k++) scr('screw-rake', GH.FASCIA_SCREW, rx[k], yT(rx[k]) - 0.03, sz * (L / 2 + gl + tt), [0, 0, -sz], len50);
    }
    /* THE CASINGS round the door (jambs + head) and, with the knee wall, the belt boards over its joint */
    var zC = L / 2 + t0;
    var casL = [['jamb-l', xD - half - cw / 2, yBt, yHd, cw], ['jamb-r', xD + half + cw / 2, yBt, yHd, cw], ['head', xD, yHd, yHd + cw, RO + 2 * cw]];
    casL.forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
      var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
      pts2.forEach(function (w2) {
        for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-trim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);
      });
    });
    var nBelt = 0;
    if (knee) {
      var xb2 = xaT + tt - tw, beltPieces = [{ ax: 'z', c: W / 2 + sg + tt / 2, o: 1, a: -(zaT - tw), b: zaT - tw, id: 'belt-f' }];
      beltPieces.push({ ax: 'x', c: -(L / 2 + sg + tt / 2), o: -1, a: xH + cw, b: xb2, id: 'belt-l' });
      beltPieces.push({ ax: 'x', c: L / 2 + sg + tt / 2, o: 1, a: xH + cw, b: xD - half - cw, id: 'belt-rk' });
      beltPieces.push({ ax: 'x', c: L / 2 + sg + tt / 2, o: 1, a: xD + half + cw, b: xb2, id: 'belt-rf' });
      beltPieces.forEach(function (bp) {
        var bl2 = bp.b - bp.a, bm2 = (bp.a + bp.b) / 2;
        if (bl2 < 0.05) return;
        if (bp.ax === 'z') box('belt', GH.BOARD, ceil2(bl2), bp.id, bp.c, yK, bm2, tt, cw, bl2); else box('belt', GH.BOARD, ceil2(bl2), bp.id, bm2, yK, bp.c, bl2, cw, tt);
        nBelt++;
        fixPts(bp.a + 0.05, bp.b - 0.05, _ghU(s, 'FIX_SP')).forEach(function (w3) {
          for (var e6 = -1; e6 <= 1; e6 += 2) {
            var yy3 = yK + e6 * Math.min(cw / 4, st / 2 - 0.006), nf = bp.c + bp.o * tt / 2;   /* into the knee girt behind */
            if (bp.ax === 'z') scr('nail-trim', GH.TRIM_NAIL, nf, yy3, w3, [-bp.o, 0, 0], len32, 0.0012); else scr('nail-trim', GH.TRIM_NAIL, w3, yy3, nf, [0, 0, -bp.o], len32, 0.0012);
          }
        });
      });
    }

    /* THE DOOR: the gable's 2x3 frame in the opening, its glazing outside;
       hinged on its front side (it opens away from the house): three strap
       hinges onto the casing, the braces rising from that side; a knob, a
       ball catch on the latch side */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), xD + sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), xD, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-door', GH.STUD_SCREW, xD + sx * dW / 2, railY[k] + e7 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA, yB2) {
      /* from the hinge side's bottom corner to the latch side's top one, cut level against the rails */
      var xA = xD + dW / 2 - fw, xZ = xD - dW / 2 + fw, dx = xZ - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xZ + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xZ); pb = _gzClip(pb, -1, 0, xA);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    sheet('glaze-door', null, 'glaze-door', [[xD - dW / 2, yD0], [xD + dW / 2, yD0], [xD + dW / 2, yD1], [xD - dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1); tally();
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [xD + dW / 2 - hingeLen / 2, hy, zD1 + gl + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [xD + half + cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, xD + dW / 2 - 0.035 - i * 0.10, hy, zD1 + gl + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, xD + half + cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [xD - dW / 2 + fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + gl, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [xD - dW / 2 + 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* THE ROOF VENTS (the gable's): the sash's glazing over the opening,
       its 2x3 frame inside it, hinged at the top on two straps over the
       header, open VENT_ANG on the opener (drawn, no catalogue row) */
    var aV = GH.VENT_ANG * Math.PI / 180, ca = Math.cos(aV), sa = Math.sin(aV), ventAreaSum = 0;
    for (j = 0; j < vents.length; j++) {
      var vt = vents[j], vid = 'vent-' + (vt.i + 1);
      var uA = vt.z0, uB = vt.z1;
      var V2 = [F.V[0] * ca + F.N[0] * sa, F.V[1] * ca + F.N[1] * sa, F.V[2] * ca + F.N[2] * sa];
      var N2 = [-F.V[0] * sa + F.N[0] * ca, -F.V[1] * sa + F.N[1] * ca, -F.V[2] * sa + F.N[2] * ca];
      var Hl = rw(0, vH, gl);
      var sw = function (u, dv, dn) { return [Hl[0] + F.U[0] * u + V2[0] * dv + N2[0] * dn, Hl[1] + F.U[1] * u + V2[1] * dv + N2[1] * dn, Hl[2] + F.U[2] * u + V2[2] * dv + N2[2] * dn]; };
      var gu0 = uA + gap, gu1 = uB - gap, gv1 = vP - vH - gap;
      var fu0 = uA + st / 2 + gap, fu1 = uB - st / 2 - gap, fv0 = st / 2 + gap, fv1 = vP - vH - st / 2 - gap, fL = fv1 - fv0, fWd = fu1 - fu0;
      for (k = -1; k <= 1; k += 2) {
        var usc = (k < 0) ? fu0 + fw / 2 : fu1 - fw / 2;
        obox('vframe', GH.FRAME, ceil2(fL), vid + '-stile-' + (k < 0 ? 'a' : 'b'), sw(usc, (fv0 + fv1) / 2, -gl - ft / 2), F.U, V2, N2, fw, fL, ft);
      }
      var vRails = [fv0 + fw / 2, fv1 - fw / 2];
      for (k = 0; k < 2; k++) {
        obox('vframe', GH.FRAME, ceil2(fWd - 2 * fw), vid + '-rail-' + (k + 1), sw((fu0 + fu1) / 2, vRails[k], -gl - ft / 2), F.U, V2, N2, fWd - 2 * fw, fw, ft);
        for (var e8 = -1; e8 <= 1; e8 += 2) for (var e9 = -1; e9 <= 1; e9 += 2) {
          var pv = sw((e8 < 0) ? fu0 : fu1, vRails[k] + e9 * fw / 4, -gl - ft / 2);
          scr('screw-vframe', GH.STUD_SCREW, pv[0], pv[1], pv[2], [-e8 * F.U[0], -e8 * F.U[1], -e8 * F.U[2]], len120);
        }
      }
      sheet('glaze-vent', null, vid + '-glaze', [[gu0, 0], [gu0, gv1], [gu1, gv1], [gu1, 0]].map(function (Pt) { return [Pt[0], Pt[1] + gap]; }), null, sw(0, 0, -gl), F.U, V2, N2, gl, -1); tally();
      ventAreaSum += (uB - uA) * (vP - vH);
      for (k = -1; k <= 1; k += 2) {
        var hu = (k < 0) ? gu0 + 0.08 : gu1 - 0.08, hLs = 0.18, hLb = 0.06;
        obox('vhinge', GH.HINGE, 0, vid + '-hinge-' + (k < 0 ? 'a' : 'b'), sw(hu, gap + hLs / 2, hT / 2), F.U, V2, N2, hingeW, hLs, hT);
        obox('vhinge', null, 0, vid + '-hinge-leaf-' + (k < 0 ? 'a' : 'b'), rw(hu, vH - hLb / 2, gl + hT / 2), F.U, F.V, F.N, hingeW * 1.6, hLb, hT);
        hinges++;
        for (i = 0; i < 3; i++) {
          var hp1 = sw(hu, gap + st / 2 + fw * (0.15 + 0.35 * i), hT), hp2 = rw(hu + (i - 1) * 0.01, vH - 0.015, gl + hT);
          scr('screw-vhinge', GH.HINGE_SCREW, hp1[0], hp1[1], hp1[2], [-N2[0], -N2[1], -N2[2]], len40, 0.0022);
          scr('screw-vhinge', GH.HINGE_SCREW, hp2[0], hp2[1], hp2[2], [-F.N[0], -F.N[1], -F.N[2]], len40, 0.0022);
        }
      }
      var oA = rw((uA + uB) / 2, vP - st / 2 - 0.02, -sd * 0.7), oB = sw((uA + uB) / 2, vRails[1], -gl - ft);
      var od = [oB[0] - oA[0], oB[1] - oA[1], oB[2] - oA[2]], oLn = Math.sqrt(od[0] * od[0] + od[1] * od[1] + od[2] * od[2]), oU = [od[0] / oLn, od[1] / oLn, od[2] / oLn];
      var oX = F.U, oN = [oU[1] * oX[2] - oU[2] * oX[1], oU[2] * oX[0] - oU[0] * oX[2], oU[0] * oX[1] - oU[1] * oX[0]];
      obox('opener', null, 0, vid + '-opener', [(oA[0] + oB[0]) / 2, (oA[1] + oB[1]) / 2, (oA[2] + oB[2]) / 2], oX, oU, oN, 0.03, oLn, 0.03);
    }

    /* THE BRACKETS to the house: a reinforced angle on the back wall's
       studs under its plate, <= BRK_SP apart (both end studs), its leg
       along the stud's side towards the middle and the other flat on the
       house wall; three 5x40 into the stud, two concrete screw anchors
       into the wall */
    var brkL = _ghU(s, 'BRK_L'), brkW = GH.BRK_W, brkT = GH.BRK_T, nBrk = 0, yb = yTB0 - 0.12;
    var bS = wB.studs.slice().sort(function (a, b) { return a - b; }), nT = Math.max(1, Math.ceil((L - st) / _ghU(s, 'BRK_SP') - 1e-9)), chosen = [];
    for (k = 0; k <= nT; k++) {
      var zt2 = -L / 2 + st / 2 + (L - st) * k / nT, best = null;
      bS.forEach(function (z) { if (best == null || Math.abs(z - zt2) < Math.abs(best - zt2)) best = z; });
      if (best != null && chosen.indexOf(best) < 0) chosen.push(best);
    }
    chosen.forEach(function (zs) {
      var dz = (zs > 0) ? -1 : 1, zf = zs + dz * st / 2, bid = 'bracket-' + (nBrk + 1);
      hw.push({ kind: 'bracket', code: GH.BRACKET, box: [xH + brkL / 2, yb, zf + dz * brkT / 2, brkL, brkW, brkT], id: bid });
      hw.push({ kind: 'bracket', code: null, box: [xH + brkT / 2, yb, zf + dz * brkL / 2, brkT, brkW, brkL], id: bid + '-wall' });
      for (var q = 0; q < 3; q++) scr('screw-bracket', GH.BRK_SCREW, xB + 0.02 + 0.025 * q, yb + ((q % 2) ? 0.012 : -0.012), zf + dz * brkT, [0, 0, -dz], len40, 0.0022);
      for (q = 0; q < 2; q++) scr('screw-anchor', GH.ANCHOR, xH + brkT, yb, zf + dz * (0.06 + 0.055 * q), [-1, 0, 0], len75, 0.005);
      nBrk++;
    });
    /* THE HOUSE WALL: context only (see-through, not billed, not in AR) */
    var hTop = yT(xB) + 0.9, hZ = L / 2 + 0.9;
    pieces.push({ kind: 'house', code: null, len: 0, id: 'house-wall', box: [xH - GH.HOUSE_T / 2, (hTop - 0.1) / 2, 0, GH.HOUSE_T, hTop + 0.1, 2 * hZ] });

    if (polyA > 0) missing.push({ name: GH.POLY_NAME, qty: Math.round(polyA * GH.WASTE * 100) / 100, unit: 'm2' });
    if (tapeV > 0) missing.push({ name: GH.VTAPE_NAME, qty: Math.round(tapeV * 100) / 100, unit: 'm' });
    if (vents.length) missing.push({ name: GH.OPENER_NAME, qty: vents.length, unit: 'pcs' });

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    var m3 = {}, coat = sidingA;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw); per[GH.TRIM] = 2 * (tt + tw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; }, top = yT(xB) + gl / cs + 0.01;
    /* v392 the benches' run: along the front wall (the house behind the back one), the door's approach in the right end wall kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bX = W / 2 - sd - bClr, bZ = L / 2 - sd - bEnd;
    var benchSpec = { runs: [{ id: 'f', ax: 'z', c: bX, o: -1, a: -bZ, b: bZ }], keep: [{ x0: xD - half - 0.05, x1: xD + half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    return {
      P: P, us: us, knee: knee, lean: true, L: L, W: W, benchSpec: benchSpec, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing,
      meters: m3, coat: coat, polyA: polyA, sidingA: sidingA, tapeSolid: tapeS, tapeVent: tapeV, capL: eLen, capScrews: flScrews, hinges: hinges, brackets: nBrk, closers: nClose,
      gravelM3: r3(gravelM3), digM3: r3(gravelM3), floorA: floorA, rafters: zr, ties: 0, eBlocks: nEb, gStuds: gStuds, girts: nGirt, studs: nStud, purlins: nPur,
      vents: vents.length, ventA: ventAreaSum, trims: nTrim, belts: nBelt, doorW: dW, doorH: dH, RO: RO, hdUp: hdUp, xD: xD,
      yBB: yBB, yBt: yBt, yPT: yPT, yPB: yPB, yK: yK, ridgeTop: yT(xB), pitch: GH.LPITCH, rafL: rafL, roofLen: eLen, slope: vEnd, gapH: gapH,
      top: top, height: top, depth: W, length: L, extX: Math.max(xe + _ghU(s, 'GL_OVER') * cs, W / 2 + gapH + GH.HOUSE_T), extZ: zfE
    };
  }
  /* ------------------------------------------------------------------
     v381 TYPE 38 -- GREENHOUSES, variant 3: THE HOOP HOUSE (Marek
     2026-10-30 "Dalsi krok" -- slot 3 of the plan; asked: galvanized
     steel tube hoops on the gable's base, a round arc -- one bent piece a
     hoop). A film tunnel on the greenhouses' base:
       - FOUNDATION + BASE as the gable's (ground screws + U heads, the 4x6
         side beams the full length, the end beams between them); the side
         piers here in the hoops' bays, clear of their straps; two 8x200 at
         each corner beside the end hoop's leg; no gravel: a soil floor to
         plant in;
       - HOOPS: a 35 mm (US 1 3/8 in.) galvanized tube (NO CATALOGUE ROW),
         a round arc on two straight legs: the legs on the side beams'
         outer faces from the base's underside up to SIDE_H (0.90 m, US
         3 ft) over it, the arc over the width; the end hoops in the end
         walls' plane, the inner ones <= 1.20 m (US 4 ft) apart; every leg
         tied by cut pieces of a hold-down strap FAT00012 (three a strap,
         a 5x40 through each tab) -- two to the base, one to the hip board;
       - HIP BOARDS: a 2x6 on each side outside the legs under the arc's
         spring line;
       - RIDGE PURLIN: a tube under the crowns from end hoop to end hoop, a
         cross connector at every hoop (NO CATALOGUE ROW);
       - END WALLS: 2x4 framing on the end beams up under the end hoop
         (the studs, kings and cripples cut to the arc, a strap over the
         hoop onto each top), no stud in the middle (the purlin's end), a
         girt line or two; the door in the front one (+Z), the gable's;
       - COVER: greenhouse film (NO CATALOGUE ROW) over the hoops and the
         hip boards into an aluminium lock channel on the hip boards and
         on the end hoops, the end walls' film into channels on their
         corner studs and bottom plates, battened by the door's casings;
         the channel and its wiggle wire NO CATALOGUE ROW, their screws
         billed (5x40 into the wood, 4.8x19 self-drilling into the hoops);
       - ROLL-UP SIDES: a curtain from the hip board's lower channel to a
         roll bar (the tube) at the base, rolled up under the hip board by
         a crank at the front (NO CATALOGUE ROW); down / rolled up on the
         info bar's toggle (the knee wall's state key);
       - the door: the gable's 2x3 frame, the film stapled on it
         (stainless staples FAS10000), the casings over the film's edges,
         three strap hinges, a knob, a ball catch.
     X across, Y up, Z along (+Z the door). L / W = the base's outer
     faces; the hoops' legs, hip boards and roll bars outside it. */
  function _ghHoop(s) { return (((s || STATE).variant) | 0) === 38; }
  function _ghRoll(s) { return _ghHoop(s) && (s || STATE).ghKnee === true; }   /* the roll-up sides on the knee wall's toggle (its state key): down / rolled up */
  function _ghHoopLayout(s) {
    s = s || STATE;
    var P = _ghProf(s), us = (s.isMetric === false), roll = _ghRoll(s), L = _ghL(s), W = _ghW(s), i, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, tt = P.tt, cw = P.cw, ft = P.ft, fw = P.fw, ht = P.rgt, hb = P.rgd;
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032, len19 = us ? 0.01905 : 0.019;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function scr(kind, code, x, y, z, d2, ln, rr2) { var n = Math.sqrt(d2[0] * d2[0] + d2[1] * d2[1] + d2[2] * d2[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d2[0] / n, d2[1] / n, d2[2] / n], len: ln, r: rr2 || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function cross(A, B) { return [A[1] * B[2] - A[2] * B[1], A[2] * B[0] - A[0] * B[2], A[0] * B[1] - A[1] * B[0]]; }
    /* a tube along a polyline (no catalogue row: no code, its length to the missing list) */
    function tube(kind, id, pts, rad, fly) {
      var l = 0, q;
      for (q = 1; q < pts.length; q++) l += Math.sqrt(Math.pow(pts[q][0] - pts[q - 1][0], 2) + Math.pow(pts[q][1] - pts[q - 1][1], 2) + Math.pow(pts[q][2] - pts[q - 1][2], 2));
      pieces.push({ kind: kind, code: null, len: 0, id: id, tube: { pts: pts, r: rad }, tl: l, fly: fly || null });
      return l;
    }
    /* a flat film (an outline in its own (u, v) plane, as the gable's sheets) and an arc of a cylinder about (cx, cy) along z */
    function sheet(kind, id, pts, holes, o, U, V, N, t) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      sheets.push({ kind: kind, code: null, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: { solid: 0, vent: 0 } });
      return area;
    }
    function cyl(kind, id, cx, cy, rad, a0, a1, z0, z1) {
      var area = rad * (a1 - a0) * (z1 - z0);
      sheets.push({ kind: kind, code: null, id: id, cyl: { c: [cx, cy], R: rad, a0: a0, a1: a1, z0: z0, z1: z1 }, area: area, tape: { solid: 0, vent: 0 }, N: [0, 1, 0] });
      return area;
    }
    /* THE HEIGHTS: the base's underside and top, the studs' foot, the arc's spring line yS (the legs' top) */
    var d = _ghU(s, 'TUBE_D'), r = d / 2, T2 = GH.STRAP_T, TB = _ghU(s, 'STRAP_TAB'), SW = GH.STRAP_W, FT = GH.FILM_T, chW = GH.CH_W, chH = GH.CH_H;
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st, yS = yBt + _ghU(s, 'SIDE_H');
    var R = W / 2 + r, Ro = W / 2 + d, Ri = W / 2;   /* the hoops' centre line, outer and inner faces about (0, yS) */
    function yArc(x, rad) { return yS + Math.sqrt(Math.max(0, rad * rad - x * x)); }
    /* THE HOOPS' PLACES: the end ones in the end walls' plane, the inner ones evenly between */
    var zH = L / 2 - sd / 2, nb = Math.max(1, Math.ceil(2 * zH / _ghU(s, 'HOOP_SP') - 1e-9)), zs = [];
    for (i = 0; i <= nb; i++) zs.push(-zH + 2 * zH * i / nb);

    /* THE FOUNDATION: the gable's ground screws + U heads; the side ones at the
       ends and in the hoops' bays (<= 1.80 m, US 6 ft), the end beams' middles */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), psp = _ghU(s, 'PIER_SP'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, pz = [zp0], cur = zp0, mids = [];
    for (i = 0; i < nb; i++) mids.push((zs[i] + zs[i + 1]) / 2);
    while (zp1 - cur > psp + 1e-9) {
      var nxt = null;
      for (i = 0; i < mids.length; i++) if (mids[i] > cur + 0.30 && mids[i] < zp1 - 0.30 && mids[i] - cur <= psp + 1e-9) nxt = mids[i];
      if (nxt == null) break;
      pz.push(nxt); cur = nxt;
    }
    pz.push(zp1);
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < pz.length; i++) pier(sx * (W / 2 - bw / 2), pz[i], true, (sx < 0 ? 'l' : 'r') + (i + 1));
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, (sz < 0 ? 'b' : 'f') + 'm');
    /* THE BASE: the side beams the full length, the end beams between them; two 8x200 at each corner, beside the end hoop's leg, between its straps */
    for (sx = -1; sx <= 1; sx += 2) box('base', GH.BASE, ceil2(L), 'base-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
    var ebL = W - 2 * bw;
    for (sz = -1; sz <= 1; sz += 2) {
      box('base', GH.BASE, ceil2(ebL), 'base-' + (sz < 0 ? 'b' : 'f'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), ebL, bh, bw);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * W / 2, (yBB + yBt) / 2, sz * (L / 2 - ((k === 0) ? bw - 0.012 : 0.012)), [-sx, 0, 0], len200);
    }

    /* THE HOOPS: the legs straight up the base's outer faces, the round arc over the width (one bent tube) */
    var nA = 72, tubeL = 0, hoopL = 0;   /* 2.5 deg chords: < 0.5 mm off the round */
    function arcPts(rad, zc, a0, a1) { var out = [], q; for (q = 0; q <= nA; q++) { var a = a0 + (a1 - a0) * q / nA; out.push([rad * Math.cos(a), yS + rad * Math.sin(a), zc]); } return out; }
    var yL0 = yBB + 0.005;
    for (i = 0; i <= nb; i++) {
      hoopL = tube('hoop', 'hoop-' + (i + 1), [[R, yL0, zs[i]]].concat(arcPts(R, zs[i], 0, Math.PI)).concat([[-R, yL0, zs[i]]]), r, [0, 1, 0]);
      tubeL += hoopL;
    }
    /* THE STRAPS: a cut piece of the hold-down strap round a tube, its loop
       over the tube, a 5x40 through each tab into the face it lies on.
       C the tube's centre at the strap, A its axis, Nn the face's normal
       (towards the tube); dn: the screws' way in (default -Nn) */
    var nStrap = 0;
    function hat(kind, id, C, A, Nn, dn) {
      var Tt = cross(Nn, A), O = [C[0] - Nn[0] * r, C[1] - Nn[1] * r, C[2] - Nn[2] * r], e = r + TB;
      var pts = [[-e, 0], [-r, 0], [-r, d], [r, d], [r, 0], [e, 0], [e, T2], [r + T2, T2], [r + T2, d + T2], [-(r + T2), d + T2], [-(r + T2), T2], [-e, T2]];
      hw.push({ kind: kind, code: GH.HSTRAP, hat: { o: O, t: Tt, n: Nn, a: A, pts: pts, w: SW }, id: id, fly: [Nn[0], Nn[1], Nn[2]] });
      nStrap++;
      for (var e2 = -1; e2 <= 1; e2 += 2) {
        var tc = e2 * (r + T2 + (TB - T2) / 2), P2 = [O[0] + Tt[0] * tc + Nn[0] * T2, O[1] + Tt[1] * tc + Nn[1] * T2, O[2] + Tt[2] * tc + Nn[2] * T2];
        scr('screw-' + kind, GH.HSTRAP_SCREW, P2[0], P2[1], P2[2], dn || [-Nn[0], -Nn[1], -Nn[2]], len40, 0.0025);
      }
    }
    var yHipM = yS - hb / 2;
    for (i = 0; i <= nb; i++) for (sx = -1; sx <= 1; sx += 2) {
      var hid = 'hoop-' + (i + 1) + (sx < 0 ? 'l' : 'r');
      hat('hstrap', hid + '-base-1', [sx * R, yBB + 0.04, zs[i]], [0, 1, 0], [sx, 0, 0]);
      hat('hstrap', hid + '-base-2', [sx * R, yBt - 0.04, zs[i]], [0, 1, 0], [sx, 0, 0]);
      hat('hstrap', hid + '-hip', [sx * R, yHipM, zs[i]], [0, 1, 0], [-sx, 0, 0]);
    }
    /* THE HIP BOARDS: a 2x6 on each side outside the legs, its top on the arc's spring line */
    for (sx = -1; sx <= 1; sx += 2) box('hipb', GH.RIDGE, ceil2(L), 'hip-' + (sx < 0 ? 'l' : 'r'), sx * (Ro + ht / 2), yS - hb / 2, 0, ht, hb, L);
    /* THE RIDGE PURLIN under the crowns, a cross connector at every hoop */
    var yPu = yS + R - d;
    tubeL += tube('rpurlin', 'ridge-purlin', [[0, yPu, -zH - r], [0, yPu, zH + r]], r, [0, 1, 0]);
    for (i = 0; i <= nb; i++) hw.push({ kind: 'xconn', code: null, box: [0, yS + R - r, zs[i], 0.055, d + 0.03, 0.05], id: 'xconn-' + (i + 1), fly: [0, 1, 0] });

    /* THE END WALLS, framed flat and stood up on the end beams under the end
       hoop (4 mm in from the legs): the studs, kings and cripples cut to the
       hoop's underside, a strap over the hoop onto each top (the corner
       studs' tops under its steep side: none); no stud in the middle (the
       purlin's end); the door in the front one */
    var g0 = 0.004, u0 = -(W / 2 - g0), u1 = W / 2 - g0;
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yArc(oL, Ri) - 0.10 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var gsp = _ghU(s, 'STUD_SP'), sym = [];
    for (k = 0; gsp / 2 + k * gsp < u1 - 1.5 * st - 0.10; k++) sym.push(gsp / 2 + k * gsp);
    var grid = sym.map(function (u) { return -u; }).reverse().concat(sym);
    grid = [u0 + st / 2].concat(grid).concat([u1 - st / 2]);
    var yGa = (yP0 + yS) / 2, yGb = yS + 0.60, nGirt = 0, nStud = 0, nSad = 0;
    var gStudL = 0;
    function topPoly(xa, xb, y0) { var pts = [[xa, y0], [xb, y0]], q, nq = 6; for (q = 0; q <= nq; q++) { var x = xb + (xa - xb) * q / nq; pts.push([x, yArc(x, Ri)]); } return pts; }
    function endWall(sz2, door) {
      var id = 'end-' + (sz2 < 0 ? 'b' : 'f'), zc = sz2 * (L / 2 - sd / 2), m, e, f2;
      function bxW(kind, code, len, sid, u, y, du, dy) { box(kind, code, len, sid, u, y, zc, du, dy, sd); }
      function scW(kind, code, u, y, n, du, dy, dn, ln) { scr(kind, code, u, y, zc + sz2 * n, [du, dy, sz2 * dn], ln); }
      function member(kind, sid, u, y0) {
        var pts = topPoly(u - st / 2, u + st / 2, y0), yTop = Math.max(yArc(u - st / 2, Ri), yArc(u + st / 2, Ri));
        poly(kind, GH.STUD, ceil2(yTop - y0), sid, pts, 'xy', zc, sd);
        gStudL += yTop - y0;
        return pts;
      }
      /* a strap over the hoop onto a member's top: the hoop's point above its middle, the screws straight down */
      function saddle(sid, u) {
        var cth = Math.max(-1, Math.min(1, u / R)), th = Math.acos(cth), sth = Math.sin(th);
        hat('sstrap', sid, [R * cth, yS + R * sth, sz2 * zH], [-sth, cth, 0], [cth, sth, 0], [0, -1, 0]);
        nSad++;
      }
      var plates = door ? [[u0, -half], [half, u1]] : [[u0, u1]];
      for (m = 0; m < plates.length; m++) bxW('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, plates[m][1] - plates[m][0], st);
      var studs = grid.filter(function (u) { return !door || Math.abs(u) > oL + st / 2 + 0.10; });
      var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
      for (m = 0; m < studs.length; m++) {
        member('gstud', id + '-stud-' + (m + 1), studs[m], yP0);
        nStud++;
        for (e = -1; e <= 1; e += 2) scW('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
        if (m > 0 && m < studs.length - 1) saddle(id + '-stud-' + (m + 1) + '-strap', studs[m]);
      }
      if (door) {
        /* THE DOOR: the kings up to the hoop, the jacks, the flat header, two cripples over it (clear of the purlin's end) */
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
          member('king', id + '-king-' + (e < 0 ? 'l' : 'r'), uk, yP0);
          saddle(id + '-king-' + (e < 0 ? 'l' : 'r') + '-strap', uk);
          bxW('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, st, yHd - yP0);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            scW('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            scW('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            scW('screw-frame', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);   /* through the king into the header's end */
          }
          for (f2 = 0; f2 < 3; f2++) scW('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);   /* the king into the jack */
          nStud += 2;
          var uc = e * (half / 2 + 0.02);
          member('cripple', id + '-cripple-' + (e < 0 ? 'l' : 'r'), uc, yHt);
          saddle(id + '-cripple-' + (e < 0 ? 'l' : 'r') + '-strap', uc);
          for (f2 = -1; f2 <= 1; f2 += 2) scW('screw-cripple', GH.STUD_SCREW, uc, yHd, f2 * sd / 4, 0, 1, 0, len120);   /* up through the header */
        }
        bxW('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 2 * (half + st), st);
      }
      /* the bottom plate's screws between the members, the girts across the bays (under both members' tops) */
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < -half && b > half;
        if (!isDoor && clr > 0.12) scW('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        var yLow = Math.min(yArc(a + st / 2, Ri), yArc(b - st / 2, Ri));
        [yGa, yGb].forEach(function (yc, gy) {
          if (yc + st / 2 + 0.03 > yLow) return;
          bxW('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, clr, st);
          nGirt++;
          for (var e3 = -1; e3 <= 1; e3 += 2) {
            var ue = (e3 < 0) ? a + st / 2 + Math.min(0.035, clr / 4) : b - st / 2 - Math.min(0.035, clr / 4), du2 = (e3 < 0) ? -0.8 : 0.8;
            scW('screw-girt', GH.TOE, ue, yc + st / 2, e3 * sd / 4, du2, -0.6, 0, len80);   /* from the girt's top face */
            scW('screw-girt', GH.TOE, ue, yc + e3 * st / 4, -sd / 2, du2, 0, 0.6, len80);   /* from its inner face */
          }
        });
      }
      return { studs: studs, kings: kings, full: full };
    }
    var ewB = endWall(-1, false), ewF = endWall(1, true);

    /* THE LOCK CHANNEL (no catalogue row): two on each hip board's outer face
       (the roof's film above, the curtain below), one over each end hoop
       (the roof's and the end's films), the end walls' sides (the corner
       studs) and bottoms (the plates); 5x40 into the wood, 4.8x19
       self-drilling into the hoops, <= 30 cm (US 1 ft) */
    var chL = 0, wireL = 0, chSp = _ghU(s, 'CH_FIX'), yC1 = yS - chW / 2 - 0.008, yC2 = yS - hb + chW / 2 + 0.008;
    for (sx = -1; sx <= 1; sx += 2) {
      [yC1, yC2].forEach(function (yc, q) {
        box('channel', null, 0, 'channel-hip-' + (sx < 0 ? 'l' : 'r') + (q + 1), sx * (Ro + ht + chH / 2), yc, 0, chH, chW, L);
        chL += L; wireL += L;
        fixPts(-L / 2 + 0.05, L / 2 - 0.05, chSp).forEach(function (zf) { scr('screw-chw', GH.HSTRAP_SCREW, sx * (Ro + ht + chH), yc, zf, [-sx, 0, 0], len40, 0.0025); });
      });
    }
    var aCh0 = 0.03, rCh = Ro + T2 + chH / 2, sadAng = [];   /* the arc's channel on the hoop over the straps' loops (2 mm) */
    for (k = 0; k < ewF.full.length; k++) if (Math.abs(ewF.full[k]) < u1 - st) sadAng.push(Math.acos(Math.max(-1, Math.min(1, ewF.full[k] / R))));
    for (k = 0; k < ewB.full.length; k++) if (Math.abs(ewB.full[k]) < u1 - st) sadAng.push(Math.acos(Math.max(-1, Math.min(1, ewB.full[k] / R))));
    sadAng.push(Math.acos((half / 2 + 0.02) / R), Math.acos(-(half / 2 + 0.02) / R));
    for (sz = -1; sz <= 1; sz += 2) {
      var arcL = rCh * (Math.PI - 2 * aCh0);
      tube('channel', 'channel-arc-' + (sz < 0 ? 'b' : 'f'), arcPts(rCh, sz * zH, aCh0, Math.PI - aCh0), chH / 2, [0, 1, 0]);
      chL += arcL; wireL += 2 * arcL;   /* two wires: the roof's film and the end's */
      var nF = Math.max(2, Math.ceil(arcL / chSp - 1e-9));
      for (k = 0; k <= nF; k++) {
        var aF = aCh0 + 0.04 + (Math.PI - 2 * aCh0 - 0.08) * k / nF, near = sadAng.filter(function (a2) { return Math.abs(a2 - aF) < 0.045 / R; });
        if (near.length) aF = near[0] + ((aF >= near[0]) ? 1 : -1) * 0.05 / R;
        scr('screw-chs', GH.CH_SCREW_S, (Ro + T2 + chH) * Math.cos(aF), yS + (Ro + T2 + chH) * Math.sin(aF), sz * zH, [-Math.cos(aF), -Math.sin(aF), 0], len19, 0.0024);
      }
      /* the end wall: its corner studs' faces, its bottom plate's face (stopped at the door's casings) */
      var ew = (sz < 0) ? ewB : ewF, zF = sz * (L / 2 + chH / 2), zS = sz * (L / 2 + chH), girtYs = [yGa, yGb];
      for (sx = -1; sx <= 1; sx += 2) {
        var xc = sx * (u1 - st / 2), yTopC = yArc(Math.abs(xc) + chW / 2, Ri) - 0.01, hC = yTopC - yP0;
        box('channel', null, 0, 'channel-end-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r'), xc, (yP0 + yTopC) / 2, zF, chW, hC, chH);
        chL += hC; wireL += hC;
        fixPts(yP0 + 0.12, yTopC - 0.05, chSp).forEach(function (yf) {   /* clear of the stud's screws up through the plate */
          girtYs.forEach(function (gy2) { if (Math.abs(yf - gy2) < 0.06) yf = gy2 + ((yf >= gy2) ? 0.07 : -0.07); });
          scr('screw-chw', GH.HSTRAP_SCREW, xc, yf, zS, [0, 0, -sz], len40, 0.0025);
        });
      }
      var bot = (sz > 0) ? [[u0, -(half + cw) - 0.005], [half + cw + 0.005, u1]] : [[u0, u1]];
      bot.forEach(function (bs, q) {
        var bl = bs[1] - bs[0];
        box('channel', null, 0, 'channel-bot-' + (sz < 0 ? 'b' : 'f') + (q + 1), (bs[0] + bs[1]) / 2, yBt + st / 2, zF, bl, chW, chH);
        chL += bl; wireL += bl;
        fixPts(bs[0] + 0.05, bs[1] - 0.05, chSp).forEach(function (xf) {
          ew.full.forEach(function (um2) { if (Math.abs(xf - um2) < 0.025) xf = um2 + ((xf >= um2) ? 0.035 : -0.035); });
          scr('screw-chw', GH.HSTRAP_SCREW, xf, yBt + st / 2, zS, [0, 0, -sz], len40, 0.0025);
        });
      });
    }

    /* THE FILM: over the hoops (the arc, the length of the base) and over each
       hip board into its upper channel; the end walls from their bottom
       channel up to the arc (the door cut out, its edges under the casings) */
    var filmA = 0;
    filmA += cyl('film-roof', 'film-roof', 0, yS, Ro + FT / 2, 0, Math.PI, -L / 2, L / 2);
    for (sx = -1; sx <= 1; sx += 2) {
      var xs0 = sx * Ro, xs1 = sx * (Ro + ht);
      filmA += sheet('film-roof', 'film-hip-top-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, Math.min(xs0, xs1)], [L / 2, Math.min(xs0, xs1)], [L / 2, Math.max(xs0, xs1)], [-L / 2, Math.max(xs0, xs1)]], null, [0, yS, 0], [0, 0, 1], [1, 0, 0], [0, 1, 0], FT);
      filmA += sheet('film-roof', 'film-hip-side-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, yC1], [L / 2, yC1], [L / 2, yS + FT], [-L / 2, yS + FT]], null, [xs1, 0, 0], [0, 0, -sx], [0, 1, 0], [sx, 0, 0], FT);
    }
    var nArc = 48, yF0 = yBt + st / 2;
    for (sz = -1; sz <= 1; sz += 2) {
      var arcO = [];
      for (k = 0; k <= nArc; k++) { var aE = Math.PI * k / nArc; arcO.push([Ro * Math.cos(aE), yS + Ro * Math.sin(aE)]); }
      var ePts = (sz > 0) ? [[-Ro, yF0], [-half, yF0], [-half, yHd], [half, yHd], [half, yF0], [Ro, yF0]] : [[-Ro, yF0], [Ro, yF0]];
      ePts = ePts.concat(arcO);
      filmA += sheet('film-end', 'film-end-' + (sz < 0 ? 'b' : 'f'), ePts.map(function (Pt) { return [sz * Pt[0], Pt[1]]; }), null, [0, 0, sz * L / 2], [sz, 0, 0], [0, 1, 0], [0, 0, sz], FT);
    }
    /* THE ROLL-UP SIDES: the curtain from the lower channel down to the roll
       bar at the base (rolled up: the bar and the film round it under the hip
       board), the bar past the front end to its crank */
    var xRB = Ro + ht + 0.003 + r, rr = r + 0.015, xRR = Ro + ht + 0.003 + rr, yRB = yBB + r + 0.01, yRR = yS - hb - rr + 0.004, zRB0 = -L / 2, zRB1 = L / 2 + 0.12, curH = yC2 - yRB;
    for (sx = -1; sx <= 1; sx += 2) {
      var sid2 = (sx < 0 ? 'l' : 'r'), xb2 = roll ? xRR : xRB, yb2 = roll ? yRR : yRB;
      tubeL += tube('rollbar', 'rollbar-' + sid2, [[sx * xb2, yb2, zRB0], [sx * xb2, yb2, zRB1]], r, [sx, 0, 0]);
      if (roll) tube('roll', 'roll-' + sid2, [[sx * xRR, yRR, -L / 2], [sx * xRR, yRR, L / 2]], rr, [sx, 0, 0]);
      else sheet('curtain', 'curtain-' + sid2, [[-L / 2, yRB], [L / 2, yRB], [L / 2, yC2], [-L / 2, yC2]], null, [sx * (Ro + ht + 0.002), 0, 0], [0, 0, -sx], [0, 1, 0], [sx, 0, 0], FT);
      filmA += curH * L;
      var zG = zRB1 + 0.035;
      hw.push({ kind: 'crank', code: null, box: [sx * xb2, yb2, zG, 0.07, 0.09, 0.07], id: 'crank-' + sid2, fly: [0, 0, 1] });
      hw.push({ kind: 'crank', code: null, box: [sx * (xb2 + 0.02), yb2 + 0.045 + 0.13, zG + 0.025, 0.016, 0.26, 0.016], id: 'crank-handle-' + sid2, fly: [0, 0, 1] });
    }

    /* THE CASINGS round the door (jambs + head) over the end film's cut edges */
    var zC = L / 2 + FT;
    var casL = [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, RO + 2 * cw]];
    casL.forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
      var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
      pts2.forEach(function (w2) {
        for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-trim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);
      });
    });

    /* THE DOOR: the gable's 2x3 frame in the opening, the film stapled on its
       face; three strap hinges onto the casing, a knob, a ball catch */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-door', GH.STUD_SCREW, sx * dW / 2, railY[k] + e7 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA, yB2) {
      var xA = dW / 2 - fw, xZ = -dW / 2 + fw, dx = xZ - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xZ + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xZ); pb = _gzClip(pb, -1, 0, xA);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    var doorA = sheet('film-door', 'film-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], FT);
    filmA += doorA;
    var staples = Math.ceil((2 * (dW + dH) + 3 * rW) / _ghU(s, 'STAPLE_SP') - 1e-9);   /* round the frame and along the rails */
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [dW / 2 - hingeLen / 2, hy, zD1 + FT + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [half + cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, dW / 2 - 0.035 - i * 0.10, hy, zD1 + FT + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, half + cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [-dW / 2 + fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + FT, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [-dW / 2 + 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* NOT IN THE CATALOGUE YET: the tube, the film, the channel and its wire, the cross connectors, the cranks */
    function r2(v) { return Math.round(v * 100) / 100; }
    missing.push({ name: GH.TUBE_NAME, qty: r2(Math.ceil(tubeL * 100 - 1e-6) / 100), unit: 'm' });
    missing.push({ name: GH.FILM_NAME, qty: r2(filmA * GH.WASTE), unit: 'm2' });
    missing.push({ name: GH.CHANNEL_NAME, qty: r2(chL), unit: 'm' });
    missing.push({ name: GH.WIRE_NAME, qty: r2(wireL), unit: 'm' });
    missing.push({ name: GH.XCONN_NAME, qty: nb + 1, unit: 'pcs' });
    missing.push({ name: GH.CRANK_NAME, qty: 2, unit: 'pcs' });

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    var m3 = {}, coat = 0;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.RIDGE] = 2 * (ht + hb); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    /* v392 the benches' runs: inside the side beams (the hoops outside them), on the soil, the door's approach kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bX = W / 2 - bw - bClr, bZ = L / 2 - sd - bEnd;
    var benchSpec = { yF: 0, inner: 2 * bX, runs: [{ id: 'l', ax: 'z', c: -bX, o: 1, a: -bZ, b: bZ, pair: 'l' }, { id: 'r', ax: 'z', c: bX, o: -1, a: -bZ, b: bZ, pair: 'r' }],
                      keep: [{ x0: -half - 0.05, x1: half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    return {
      P: P, us: us, knee: false, roll: roll, hoop: true, L: L, W: W, benchSpec: benchSpec, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing,
      meters: m3, coat: coat, polyA: 0, sidingA: 0, tapeSolid: 0, tapeVent: 0, capL: 0, capScrews: 0, hinges: hinges, brackets: 0,
      gravelM3: 0, digM3: 0, floorA: L * W, hoops: nb + 1, hoopSp: 2 * zH / nb, hoopL: hoopL, straps: nStrap, saddles: nSad, strapBuy: Math.ceil(nStrap / 3), staples: staples,
      filmA: filmA, tubeL: tubeL, chL: chL, wireL: wireL, xconn: nb + 1, piers: pz.length, studs: nStud, girts: nGirt, gStudL: gStudL,
      doorW: dW, doorH: dH, RO: RO, yBB: yBB, yBt: yBt, yS: yS, R: R, rafters: [], vents: 0, ventA: 0, trims: 0, belts: 0,
      top: yS + Ro + T2 + chH, height: yS + Ro + T2 + chH, depth: W, length: L, extX: xRR + rr + 0.01, extZ: zRB1 + 0.075
    };
  }
  var _ghHoopStepsC = null;
  function _ghHoopSteps(s) {
    if (_ghHoopStepsC) return _ghHoopStepsC;
    return (_ghHoopStepsC = [
      { parts: [], codes: [] },
      { parts: ['gh-block'], codes: [GH.GRAVEL, GH.FD_BLOCK] },                                                          /* v399 precast pads */
      { parts: ['gh-pour'], codes: [GH.DIG, GH.GRAVEL, GH.FD_GEOTEX, GH.FD_FORMWORK, GH.FD_REBAR, GH.FD_CONCRETE] },     /* v399 poured footings */
      { parts: ['gh-gscrew'], codes: [GH.GSCREW] },
      { parts: ['gh-uhead'], codes: [GH.UHEAD] },
      { parts: ['gh-uanchor'], codes: [GH.FD_UANCHOR] },   /* v399 the footings' wet-set anchors */
      { parts: ['gh-base'], codes: [GH.BASE] },
      { parts: ['gh-hw-screw-base'], codes: [GH.BASE_SCREW] },
      { parts: ['gh-hw-nail-uhead'], codes: [GH.UNAIL] },
      { parts: ['gh-hoop'], codes: [], lk: ['bench_gh_hoops'] },           /* the tube: no catalogue row -- the step's name from the locales */
      { parts: ['gh-hipb'], codes: [GH.RIDGE] },
      { parts: ['gh-hstrap'], codes: [GH.HSTRAP] },
      { parts: ['gh-hw-screw-hstrap'], codes: [GH.HSTRAP_SCREW] },
      { parts: ['gh-rpurlin', 'gh-xconn'], codes: [], lk: ['roof_ridge'] },
      { parts: ['gh-plate'], codes: [GH.STUD] },
      { parts: ['gh-gstud', 'gh-king', 'gh-jack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-stud'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-header'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-frame'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['gh-cripple'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-cripple'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-plate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-girt'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-girt'], codes: [GH.TOE] },
      { parts: ['gh-sstrap'], codes: [GH.HSTRAP] },
      { parts: ['gh-hw-screw-sstrap'], codes: [GH.HSTRAP_SCREW] },
      { parts: ['gh-channel'], codes: [], lk: ['bench_gh_channel'] },
      { parts: ['gh-hw-screw-chw', 'gh-hw-screw-chs'], codes: [GH.HSTRAP_SCREW, GH.CH_SCREW_S] },
      { parts: ['gh-film-roof'], codes: [], lk: ['bench_gh_film'] },
      { parts: ['gh-film-end'], codes: [], lk: ['bench_gh_film'] },
      { parts: ['gh-casing'], codes: [GH.BOARD] },
      { parts: ['gh-hw-nail-trim'], codes: [GH.TRIM_NAIL] },
      { parts: ['gh-rollbar', 'gh-curtain', 'gh-roll', 'gh-crank'], codes: [], lk: ['bench_gh_roll'] },
      { parts: ['gh-dframe'], codes: [GH.FRAME] },
      { parts: ['gh-dbrace'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-door'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-film-door'], codes: [GH.STAPLE], lk: ['bench_gh_film'] },
      { parts: ['gh-hinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-hinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-knob'], codes: [GH.KNOB] },
      { parts: ['gh-catch'], codes: [GH.CATCH] },
      { parts: ['gh-bleg', 'gh-brail'], codes: [GH.FRAME], lk: ['bench_gh_tables'] },   /* v392 the benches (off: not drawn, the steps drop out) */
      { parts: ['gh-hw-screw-brail'], codes: [GH.TOE] },
      { parts: ['gh-bslat'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-bslat'], codes: [GH.FASCIA_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v384 TYPE 40 -- GREENHOUSES, variant 4: THE A-FRAME GREENHOUSE
     (Marek 2026-10-30 "Dalsi krok" -- slot 4 of the plan; asked: a pure A
     down to the base (about 60 deg), glazed in polycarbonate as the
     gable). The gable greenhouse without its side walls:
       - FOUNDATION, BASE and GRAVEL FLOOR as the gable's;
       - ROOF = WALLS: 2x4 rafter pairs at 60 deg on the 60 cm (US 24 in.)
         grid, each foot a level seat centred on the side beam (an 8x200
         down through it), the tops plumb against a 2x8 ridge board (its
         depth = the rafter's plumb cut), toe screws into it; purlins down
         each slope <= 1.20 m (US 4 ft) apart, the top row 70 cm (US 28 in.)
         under the vent headers;
       - END WALLS: triangles of 2x4 studs on a bottom plate on the end
         beams, cut to the end rafters (the middle one square under the
         ridge), a girt line or two; the door in the front one (the
         gable's: kings to the end rafter, jacks, header, a cripple up to
         the ridge) -- the full 1.93 m (US 6 ft 4 in.) door from 3.60 m
         (US 12 ft) wide, so the width runs 3.60 - 4.80 m (US 12 - 16 ft);
       - SKIN: 8 mm twinwall on both slopes from the ridge to past the
         rafters' feet, the end triangles from the base's underside, the
         vents cut out; the ridge cap; rake boards over the slopes' edges
         down to the base; the casings, the door, the vents and their
         openers as the gable's. No knee wall (no walls to clad).
     X across, Y up, Z along (+Z the door). L / W = the base's outer faces. */
  function _ghAframe(s) { return (((s || STATE).variant) | 0) === 40; }
  function _ghAframeLayout(s) {
    s = s || STATE;
    var P = _ghProf(s), us = (s.isMetric === false), L = _ghL(s), W = _ghW(s), i, j, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, gl = P.gl, tt = P.tt, cw = P.cw, ft = P.ft, fw = P.fw;
    var rgt = us ? 0.0381 : 0.060, rgd = us ? 0.1842 : 0.200;   /* the 2x8 ridge board */
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { pieces.push({ kind: kind, code: code, len: len, id: id, obox: { c: c, u: u, v: v, n: n, d: [du, dv, dn] } }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function add3(A, B, f) { return [A[0] + B[0] * f, A[1] + B[1] * f, A[2] + B[2] * f]; }
    function sheet(kind, code, id, pts, holes, o, U, V, N, t, up) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      var tp = (up != null) ? _ghTape(pts, holes, up) : { solid: 0, vent: 0 };
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: tp });
      return area;
    }
    /* THE HEIGHTS: the base's underside and top, the studs' foot */
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st;
    /* THE SLOPES: each rafter's foot a level seat centred on the side beam
       (xi its inner corner, xo the outer), its underside yR(x), its top yT(x);
       the ridge board between the plumb cuts */
    var th = GH.APITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th), dV = sd / cs, ws = sd / sn;
    var xi = W / 2 - bw / 2 - ws / 2, xo = xi + ws;
    function yR(x) { return yBt + (xi - Math.abs(x)) * tn; }
    function yT(x) { return yBt + (xo - Math.abs(x)) * tn; }
    var xr = rgt / 2, rgTop = yT(xr), rgBot = rgTop - rgd;
    /* the roof's frame per side: o the ridge line on the rafters' top, V down the slope, N out of the roof, U so that U x V = N */
    function rf(sx2) { return { o: [0, yT(0), 0], U: [0, 0, sx2], V: [sx2 * cs, -sn, 0], N: [sx2 * sn, cs, 0] }; }
    function rw(F, u, v, n) { return [F.o[0] + F.U[0] * u + F.V[0] * v + F.N[0] * n, F.o[1] + F.U[1] * u + F.V[1] * v + F.N[1] * n, F.o[2] + F.U[2] * u + F.V[2] * v + F.N[2] * n]; }

    /* THE FOUNDATION (the gable's): a ground screw + U head under the side
       beams and the wide end beams' middles; 12 connector nails a head */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _ghU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (W / 2 - bw / 2), zp0 + (zp1 - zp0) * i / np, true, (sx < 0 ? 'l' : 'r') + (i + 1));
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, (sz < 0 ? 'b' : 'f') + 'm');
    /* THE BASE: the side beams the full length, the end beams between them */
    for (sx = -1; sx <= 1; sx += 2) box('base', GH.BASE, ceil2(L), 'base-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
    var ebL = W - 2 * bw;
    for (sz = -1; sz <= 1; sz += 2) {
      box('base', GH.BASE, ceil2(ebL), 'base-' + (sz < 0 ? 'b' : 'f'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), ebL, bh, bw);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * W / 2, yBB + bh * (0.3 + 0.4 * k), sz * (L / 2 - bw / 2), [-sx, 0, 0], len200);
    }
    /* THE GRAVEL FLOOR inside the base (dug, filled flush with the ground) */
    var gT = _ghU(s, 'GRAVEL_T'), giW = W - 2 * bw, giL = L - 2 * bw;
    pieces.push({ kind: 'gravel', code: GH.GRAVEL, len: 0, id: 'gravel', box: [0, 0.005 - gT / 2, 0, giW, gT, giL] });
    var gravelM3 = giW * giL * gT;

    /* THE RAFTERS: a pair on every 60 cm (US 24 in.) grid line, the end
       pairs flush with the base's ends; an 8x200 down through each seat
       into the side beam, two toe screws a rafter into the ridge board */
    var sGrid = _phGrid(-L / 2, L / 2, _ghU(s, 'STUD_SP'), st);
    var zr = sGrid.map(function (z, ii, A) { return { z: z, gable: (ii === 0 || ii === A.length - 1) }; });
    var rafL = ceil2((xo - xr) / cs);
    function rafPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [xo, yBt], [xi, yBt]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2, xSeat = W / 2 - bw / 2;
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', GH.STUD, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zr[i].z, st);
        scr('screw-seat', GH.SEAT_SCREW, sx * xSeat, yT(xSeat), zr[i].z, [0, -1, 0], len200);
      }
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr('screw-rtoe', GH.TOE, s3 * xtq, yTm + k3 * s3 * 0.025, zr[i].z + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
    }
    box('ridge', GH.ARIDGE, ceil2(L), 'ridge', 0, rgTop - rgd / 2, 0, rgt, rgd, L);

    /* THE END WALLS: framed flat and stood up on the end beams under the end
       rafters -- a bottom plate (stopped where the rafter's foot comes down
       on it), studs on the 60 cm (US 24 in.) grid from the middle cut to the
       end rafters' underside (the middle one square under the ridge board),
       a girt line or two; the door in the front one */
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yR(oL) - 0.03 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var gsp = _ghU(s, 'STUD_SP'), gGrid = [0];
    for (k = 1; yR(k * gsp + st / 2) - yP0 >= 0.25; k++) gGrid.push(k * gsp, -k * gsp);
    gGrid.sort(function (a, b) { return a - b; });
    var pE = xi - st / tn - 0.005, yGs = [yBt + 0.90, yBt + 1.80], nGirt = 0, nStud = 0, gStuds = 0;
    function mTop(u) { return (Math.abs(u) < 1e-6) ? rgBot : Math.min(yR(u - st / 2), yR(u + st / 2)); }
    function endWall(sz2, door) {
      var id = (sz2 < 0) ? 'back' : 'front', zc = sz2 * (L / 2 - sd / 2), m, e, f2;
      function bxW(kind, code, len, sid, u, y, du, dy) { box(kind, code, len, sid, u, y, zc, du, dy, sd); }
      function scW(kind, code, u, y, n, du, dy, dn, ln) { scr(kind, code, u, y, zc + sz2 * n, [du, dy, sz2 * dn], ln); }
      /* a member up to the end rafter (square under the ridge in the middle), a 6x100 from outside up into it */
      function member(kind, sid, u, y0) {
        if (Math.abs(u) < 1e-6) {
          box(kind, GH.STUD, ceil2(rgBot - y0), sid, 0, (y0 + rgBot) / 2, zc, st, rgBot - y0, sd);
          scr('screw-gstud', GH.FRAME_SCREW, 0, rgBot - 0.035, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);   /* up into the ridge board */
        } else {
          var ga = u - st / 2, gb = u + st / 2;
          poly(kind, GH.STUD, ceil2(Math.max(yR(ga), yR(gb)) - y0), sid, [[ga, y0], [gb, y0], [gb, yR(gb)], [ga, yR(ga)]], 'xy', zc, sd);
          scr('screw-gstud', GH.FRAME_SCREW, u, yR(u) - 0.035, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);   /* from the outside up into the end rafter */
        }
        gStuds++;
      }
      var plates = door ? [[-pE, -half], [half, pE]] : [[-pE, pE]];
      for (m = 0; m < plates.length; m++) bxW('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, plates[m][1] - plates[m][0], st);
      var studs = gGrid.filter(function (u) { return !door || Math.abs(u) > oL + st / 2 + 0.10; });
      var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
      for (m = 0; m < studs.length; m++) {
        member('gstud', id + '-stud-' + Math.round(studs[m] * 100), studs[m], yP0);
        nStud++;
        for (e = -1; e <= 1; e += 2) scW('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
      }
      if (door) {
        /* THE DOOR: the kings up to the end rafter, the jacks, the flat header, a cripple up to the ridge board */
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
          member('king', id + '-king-' + (e < 0 ? 'l' : 'r'), uk, yP0);
          bxW('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, st, yHd - yP0);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            scW('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            scW('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            scW('screw-frame', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);   /* through the king into the header's end */
          }
          for (f2 = 0; f2 < 3; f2++) scW('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);   /* the king into the jack */
          nStud += 2;
        }
        bxW('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 2 * (half + st), st);
        member('cripple', id + '-cripple', 0, yHt);
        for (f2 = -1; f2 <= 1; f2 += 2) scW('screw-cripple', GH.STUD_SCREW, 0, yHd, f2 * sd / 4, 0, 1, 0, len120);   /* up through the header */
      }
      /* the bottom plate's screws between the members and past the last ones; the girts across the bays (under both members' tops) */
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      var segs = [[-pE, full[0] - st / 2]].concat([[full[full.length - 1] + st / 2, pE]]);
      segs.forEach(function (sg2) {
        if (sg2[1] - sg2[0] < 0.12) return;
        var us2 = (sg2[0] + sg2[1]) / 2, cap2 = W / 2 - len200 - 0.02;   /* clear of the base's corner screws (8x200 in from the side beam) */
        if (Math.abs(us2) > cap2) us2 = (us2 < 0 ? -1 : 1) * cap2;
        if (us2 - sg2[0] > 0.03 && sg2[1] - us2 > 0.03) scW('screw-plate', GH.STUD_SCREW, us2, yP0, 0, 0, -1, 0, len120);
      });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < -half && b > half;
        if (!isDoor && clr > 0.12) scW('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        var yLow = Math.min(mTop(a), mTop(b));
        yGs.forEach(function (yc, gy) {
          if (yc + st / 2 + 0.04 > yLow) return;
          bxW('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, clr, st);
          nGirt++;
          for (var e3 = -1; e3 <= 1; e3 += 2) {
            var ue = (e3 < 0) ? a + st / 2 + Math.min(0.035, clr / 4) : b - st / 2 - Math.min(0.035, clr / 4), du2 = (e3 < 0) ? -0.8 : 0.8;
            scW('screw-girt', GH.TOE, ue, yc + st / 2, e3 * sd / 4, du2, -0.6, 0, len80);   /* from the girt's top face */
            scW('screw-girt', GH.TOE, ue, yc + e3 * st / 4, -sd / 2, du2, 0, 0.6, len80);   /* from its inner face */
          }
        });
      }
    }
    endWall(-1, false);
    endWall(1, true);

    /* THE PURLINS: 2x4 across every bay down each slope, the top row 70 cm
       (US 28 in.) under the vent headers, the rest <= 1.20 m (US 4 ft)
       apart to the feet; two toe screws an end; the VENTS' bays get a
       header under the ridge (the vent between it and the top purlin) */
    var vFoot = xo / cs, vH = _ghU(s, 'VENT_S0') + st / 2, vP = vH + _ghU(s, 'AVENT_L'), gap = GH.VENT_GAP;
    var nRows = Math.max(1, Math.ceil((vFoot - vP) / _ghU(s, 'APUR_SP') - 1e-9)), pStep = (vFoot - vP) / nRows, pRows = [];
    for (k = 0; k < nRows; k++) pRows.push(vP + k * pStep);
    var nb = zr.length - 1, floorA = giW * giL, ventA = gsp * Math.max(0.05, vP - vH), nVps = Math.max(1, Math.ceil(floorA * GH.VENT_RATIO / ventA / 2 - 1e-9));
    var inner = [];
    for (i = 1; i < nb - 1; i++) inner.push(i);
    if (!inner.length) for (i = 0; i < nb; i++) inner.push(i);
    nVps = Math.min(nVps, inner.length);
    var ventBays = [];
    for (i = 0; i < nVps; i++) ventBays.push(inner[Math.min(inner.length - 1, Math.floor((i + 0.5) * inner.length / nVps))]);
    var nPur = 0, vents = [];
    function rblock(kind, id, F, i0, v, sx2) {
      var z0b = zr[i0].z + st / 2, z1b = zr[i0 + 1].z - st / 2, clr2 = z1b - z0b, uc = sx2 * (z0b + z1b) / 2;
      obox(kind, GH.STUD, ceil2(clr2), id, rw(F, uc, v, -sd / 2), F.U, F.V, F.N, clr2, st, sd);
      for (var e4 = -1; e4 <= 1; e4 += 2) {
        var ub = uc + e4 * (clr2 / 2 - 0.035), du3 = e4 * 0.8;
        var pA = rw(F, ub, v + st / 2, -sd / 2 + e4 * sd / 4), dA = [F.U[0] * du3 - F.V[0] * 0.6, F.U[1] * du3 - F.V[1] * 0.6, F.U[2] * du3 - F.V[2] * 0.6];
        var pB = rw(F, ub, v + e4 * st / 4, -sd), dB = [F.U[0] * du3 + F.N[0] * 0.6, F.U[1] * du3 + F.N[1] * 0.6, F.U[2] * du3 + F.N[2] * 0.6];
        scr('screw-purlin', GH.TOE, pA[0], pA[1], pA[2], dA, len80);
        scr('screw-purlin', GH.TOE, pB[0], pB[1], pB[2], dB, len80);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      var F0 = rf(sx);
      for (i = 0; i < nb; i++) {
        if (zr[i + 1].z - zr[i].z - st < 0.05) continue;
        for (k = 0; k < pRows.length; k++) { rblock('purlin', 'purlin-' + (i + 1) + '-' + (k + 1) + (sx < 0 ? '-l' : '-r'), F0, i, pRows[k], sx); nPur++; }
        if (ventBays.indexOf(i) >= 0) {
          rblock('vhead', 'vhead-' + (i + 1) + (sx < 0 ? '-l' : '-r'), F0, i, vH, sx);
          vents.push({ sx: sx, i: i, z0: zr[i].z, z1: zr[i + 1].z });
        }
      }
    }

    /* THE SKIN: the end triangles from the base's underside up to the
       rafters' top (the door's opening cut out); each slope from the ridge
       line to past the rafters' feet, the vents cut out; the ridge cap */
    var polyA = 0, tapeS = 0, tapeV = 0;
    function tally(area, sh) { polyA += area; tapeS += sh.tape.solid; tapeV += sh.tape.vent; }
    var xw = W / 2;
    for (sz = -1; sz <= 1; sz += 2) {
      var Ug = [sz, 0, 0], Vg = [0, 1, 0], Ng = [0, 0, sz], Og = [0, 0, sz * L / 2];
      var gpG = [[-xw, yBB], [xw, yBB], [xw, yT(xw)], [0, yT(0)], [-xw, yT(xw)]], ghH = (sz > 0) ? [[[-half, yBt], [half, yBt], [half, yHd], [-half, yHd]]] : null;
      tally(sheet('glaze-wall', null, 'glaze-' + (sz < 0 ? 'b' : 'f'), gpG, ghH, Og, Ug, Vg, Ng, gl, 1), sheets[sheets.length - 1]);
    }
    var vEnd = vFoot + _ghU(s, 'GL_OVER'), uR = L / 2 + gl, zfE = L / 2 + gl + tt, eLen = 2 * zfE;
    for (sx = -1; sx <= 1; sx += 2) {
      var F1 = rf(sx), rh = [];
      for (j = 0; j < vents.length; j++) if (vents[j].sx === sx) {
        var hu0 = (sx > 0) ? vents[j].z0 : -vents[j].z1, hu1 = (sx > 0) ? vents[j].z1 : -vents[j].z0;
        rh.push([[hu0, vH], [hu0, vP], [hu1, vP], [hu1, vH]]);
      }
      tally(sheet('glaze-roof', null, 'glaze-roof-' + (sx < 0 ? 'l' : 'r'), [[-uR, 0], [-uR, vEnd], [uR, vEnd], [uR, 0]], rh, F1.o, F1.U, F1.V, F1.N, gl, -1), sheets[sheets.length - 1]);
      var capW = _ghU(s, 'CAP_W');
      sheet('cap', GH.CAP, 'cap-' + (sx < 0 ? 'l' : 'r'), [[-zfE, 0], [-zfE, capW], [zfE, capW], [zfE, 0]], null, add3(F1.o, F1.N, gl), F1.U, F1.V, F1.N, GH.CAP_T, null);
    }
    var capScrews = 2 * (Math.ceil(eLen / _ghU(s, 'CAP_FIX') - 1e-9) + 1);
    /* THE RAKE BOARDS over the slopes' edges from the ridge to the base (cut
       level at the slope glazing's lower edge), flush with the slope's
       glazing; screwed into the end rafters */
    var glV = gl / cs, cwV = cw / cs, yRk0 = yBt - _ghU(s, 'GL_OVER') * sn, xt1 = xo + (yBt - yRk0 + glV) / tn, xb1 = xt1 - cwV / tn, rakeL = ceil2(xt1 / cs);
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var rp = [[0, yT(0) + glV], [xt1, yRk0], [xb1, yRk0], [0, yT(0) + glV - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) rp.reverse();
      poly('rake', GH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), rp, 'xy', sz * (L / 2 + gl + tt / 2), tt);
      var rx = fixPts(0.10, xo - 0.08, _ghU(s, 'FIX_SP'));
      for (k = 0; k < rx.length; k++) scr('screw-rake', GH.FASCIA_SCREW, sx * rx[k], yT(rx[k]) - 0.03, sz * (L / 2 + gl + tt), [0, 0, -sz], len50);
    }
    /* THE CASINGS round the door (jambs + head) */
    var zC = L / 2 + gl;
    var casL = [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, RO + 2 * cw]];
    casL.forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
      var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
      pts2.forEach(function (w2) {
        for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-trim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);
      });
    });

    /* THE DOOR (the gable's): a 2x3 frame in the opening, its glazing
       outside; three strap hinges on the left onto the casing, a knob, a
       ball catch at the top on the latch side */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-door', GH.STUD_SCREW, sx * dW / 2, railY[k] + e7 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA, yB2) {
      var xA = -dW / 2 + fw, xB = dW / 2 - fw, dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xA); pb = _gzClip(pb, -1, 0, xB);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    var dgA = sheet('glaze-door', null, 'glaze-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1);
    tally(dgA, sheets[sheets.length - 1]);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [-dW / 2 + hingeLen / 2, hy, zD1 + gl + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-half - cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, -dW / 2 + 0.035 + i * 0.10, hy, zD1 + gl + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, -half - cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [dW / 2 - fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + gl, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [dW / 2 - 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* THE ROOF VENTS (the gable's): the sash's glazing over the opening,
       its 2x3 frame inside it, hinged at the top on two straps over the
       header, open VENT_ANG on the opener (drawn, no catalogue row) */
    var aV = GH.VENT_ANG * Math.PI / 180, ca = Math.cos(aV), sa = Math.sin(aV), ventAreaSum = 0;
    for (j = 0; j < vents.length; j++) {
      var vt = vents[j], F2 = rf(vt.sx), vid = 'vent-' + (vt.i + 1) + (vt.sx < 0 ? '-l' : '-r');
      var uA = (vt.sx > 0) ? vt.z0 : -vt.z1, uB = (vt.sx > 0) ? vt.z1 : -vt.z0;
      var V2 = [F2.V[0] * ca + F2.N[0] * sa, F2.V[1] * ca + F2.N[1] * sa, F2.V[2] * ca + F2.N[2] * sa];
      var N2 = [-F2.V[0] * sa + F2.N[0] * ca, -F2.V[1] * sa + F2.N[1] * ca, -F2.V[2] * sa + F2.N[2] * ca];
      var Hl = rw(F2, 0, vH, gl);
      var sw = function (u, dv, dn) { return [Hl[0] + F2.U[0] * u + V2[0] * dv + N2[0] * dn, Hl[1] + F2.U[1] * u + V2[1] * dv + N2[1] * dn, Hl[2] + F2.U[2] * u + V2[2] * dv + N2[2] * dn]; };
      var gu0 = uA + gap, gu1 = uB - gap, gv1 = vP - vH - gap;
      var fu0 = uA + st / 2 + gap, fu1 = uB - st / 2 - gap, fv0 = st / 2 + gap, fv1 = vP - vH - st / 2 - gap, fL = fv1 - fv0, fWd = fu1 - fu0;
      for (k = -1; k <= 1; k += 2) {
        var usc = (k < 0) ? fu0 + fw / 2 : fu1 - fw / 2;
        obox('vframe', GH.FRAME, ceil2(fL), vid + '-stile-' + (k < 0 ? 'a' : 'b'), sw(usc, (fv0 + fv1) / 2, -gl - ft / 2), F2.U, V2, N2, fw, fL, ft);
      }
      var vRails = [fv0 + fw / 2, fv1 - fw / 2];
      for (k = 0; k < 2; k++) {
        obox('vframe', GH.FRAME, ceil2(fWd - 2 * fw), vid + '-rail-' + (k + 1), sw((fu0 + fu1) / 2, vRails[k], -gl - ft / 2), F2.U, V2, N2, fWd - 2 * fw, fw, ft);
        for (var e8 = -1; e8 <= 1; e8 += 2) for (var e9 = -1; e9 <= 1; e9 += 2) {
          var pv = sw((e8 < 0) ? fu0 : fu1, vRails[k] + e9 * fw / 4, -gl - ft / 2);
          scr('screw-vframe', GH.STUD_SCREW, pv[0], pv[1], pv[2], [-e8 * F2.U[0], -e8 * F2.U[1], -e8 * F2.U[2]], len120);
        }
      }
      var sgA = sheet('glaze-vent', null, vid + '-glaze', [[gu0, 0], [gu0, gv1], [gu1, gv1], [gu1, 0]].map(function (Pt) { return [Pt[0], Pt[1] + gap]; }), null, sw(0, 0, -gl), F2.U, V2, N2, gl, -1);
      tally(sgA, sheets[sheets.length - 1]);
      ventAreaSum += (uB - uA) * (vP - vH);
      for (k = -1; k <= 1; k += 2) {
        var hu = (k < 0) ? gu0 + 0.08 : gu1 - 0.08, hLs = 0.18, hLb = 0.06;
        obox('vhinge', GH.HINGE, 0, vid + '-hinge-' + (k < 0 ? 'a' : 'b'), sw(hu, gap + hLs / 2, hT / 2), F2.U, V2, N2, hingeW, hLs, hT);
        obox('vhinge', null, 0, vid + '-hinge-leaf-' + (k < 0 ? 'a' : 'b'), rw(F2, hu, vH - hLb / 2, gl + hT / 2), F2.U, F2.V, F2.N, hingeW * 1.6, hLb, hT);
        hinges++;
        for (i = 0; i < 3; i++) {
          var hp1 = sw(hu, gap + st / 2 + fw * (0.15 + 0.35 * i), hT), hp2 = rw(F2, hu + (i - 1) * 0.01, vH - 0.015, gl + hT);
          scr('screw-vhinge', GH.HINGE_SCREW, hp1[0], hp1[1], hp1[2], [-N2[0], -N2[1], -N2[2]], len40, 0.0022);
          scr('screw-vhinge', GH.HINGE_SCREW, hp2[0], hp2[1], hp2[2], [-F2.N[0], -F2.N[1], -F2.N[2]], len40, 0.0022);
        }
      }
      var oA = rw(F2, (uA + uB) / 2, vP - st / 2 - 0.02, -sd * 0.7), oB = sw((uA + uB) / 2, vRails[1], -gl - ft);
      var od = [oB[0] - oA[0], oB[1] - oA[1], oB[2] - oA[2]], oLn = Math.sqrt(od[0] * od[0] + od[1] * od[1] + od[2] * od[2]), oU = [od[0] / oLn, od[1] / oLn, od[2] / oLn];
      var oX = F2.U, oN = [oU[1] * oX[2] - oU[2] * oX[1], oU[2] * oX[0] - oU[0] * oX[2], oU[0] * oX[1] - oU[1] * oX[0]];
      obox('opener', null, 0, vid + '-opener', [(oA[0] + oB[0]) / 2, (oA[1] + oB[1]) / 2, (oA[2] + oB[2]) / 2], oX, oU, oN, 0.03, oLn, 0.03);
    }
    if (polyA > 0) missing.push({ name: GH.POLY_NAME, qty: Math.round(polyA * GH.WASTE * 100) / 100, unit: 'm2' });
    if (tapeV > 0) missing.push({ name: GH.VTAPE_NAME, qty: Math.round(tapeV * 100) / 100, unit: 'm' });
    if (vents.length) missing.push({ name: GH.OPENER_NAME, qty: vents.length, unit: 'pcs' });

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    var m3 = {}, coat = 0;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.ARIDGE] = 2 * (rgt + rgd); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    /* v392 the benches' runs: their back edge where the rafters' underside is BN_HEAD over the top, the door's approach kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bZ = L / 2 - sd - bEnd;
    var bX = Math.min(W / 2 - bw - bClr, xi - (0.005 + _ghU(s, 'BN_H') + _ghU(s, 'BN_HEAD') - yBt) / tn);
    var benchSpec = { inner: 2 * bX, runs: [{ id: 'l', ax: 'z', c: -bX, o: 1, a: -bZ, b: bZ, pair: 'l' }, { id: 'r', ax: 'z', c: bX, o: -1, a: -bZ, b: bZ, pair: 'r' }],
                      keep: [{ x0: -half - 0.05, x1: half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    return {
      P: P, us: us, knee: false, aframe: true, L: L, W: W, benchSpec: benchSpec, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing,
      meters: m3, coat: coat, polyA: polyA, sidingA: 0, tapeSolid: tapeS, tapeVent: tapeV, capL: eLen, capScrews: capScrews, hinges: hinges, brackets: 0,
      gravelM3: r3(gravelM3), digM3: r3(gravelM3), floorA: floorA, rafters: zr, ties: 0, eBlocks: 0, gStuds: gStuds, girts: nGirt, studs: nStud, purlins: nPur, purlinRows: nRows,
      vents: vents.length, ventA: ventAreaSum, trims: 0, belts: 0, doorW: dW, doorH: dH, RO: RO, hdUp: true,
      yBB: yBB, yBt: yBt, yPT: yBt, yK: yBt, ridgeTop: rgTop, pitch: GH.APITCH, rafL: rafL, roofLen: eLen, slope: vEnd,
      top: yT(0) + gl / cs + 0.01, height: yT(0) + gl / cs + 0.01, depth: W, length: L, extX: xt1 + 0.01, extZ: zfE
    };
  }
  var _ghAframeStepsC = null;
  function _ghAframeSteps(s) {
    if (_ghAframeStepsC) return _ghAframeStepsC;
    return (_ghAframeStepsC = [
      { parts: [], codes: [] },
      { parts: ['gh-block'], codes: [GH.GRAVEL, GH.FD_BLOCK] },                                                          /* v399 precast pads */
      { parts: ['gh-pour'], codes: [GH.DIG, GH.GRAVEL, GH.FD_GEOTEX, GH.FD_FORMWORK, GH.FD_REBAR, GH.FD_CONCRETE] },     /* v399 poured footings */
      { parts: ['gh-gscrew'], codes: [GH.GSCREW] },
      { parts: ['gh-uhead'], codes: [GH.UHEAD] },
      { parts: ['gh-uanchor'], codes: [GH.FD_UANCHOR] },   /* v399 the footings' wet-set anchors */
      { parts: ['gh-base'], codes: [GH.BASE] },
      { parts: ['gh-hw-screw-base'], codes: [GH.BASE_SCREW] },
      { parts: ['gh-hw-nail-uhead'], codes: [GH.UNAIL] },
      { parts: ['gh-gravel'], codes: [GH.DIG, GH.GRAVEL] },
      { parts: ['gh-rafter'], codes: [GH.STUD] },
      { parts: ['gh-ridge'], codes: [GH.ARIDGE] },
      { parts: ['gh-hw-screw-seat'], codes: [GH.SEAT_SCREW] },
      { parts: ['gh-hw-screw-rtoe'], codes: [GH.TOE] },
      { parts: ['gh-plate'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-plate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-gstud', 'gh-king', 'gh-jack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-stud'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-header'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-frame'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['gh-cripple'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-cripple'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-gstud'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-girt'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-girt'], codes: [GH.TOE] },
      { parts: ['gh-purlin', 'gh-vhead'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-purlin'], codes: [GH.TOE] },
      { parts: ['gh-glaze-wall'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-glaze-roof'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-cap'], codes: [GH.CAP, GH.GL_SCREW] },
      { parts: ['gh-rake', 'gh-casing'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-rake'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-hw-nail-trim'], codes: [GH.TRIM_NAIL] },
      { parts: ['gh-dframe'], codes: [GH.FRAME] },
      { parts: ['gh-dbrace'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-door'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-door'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-hinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-hinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-knob'], codes: [GH.KNOB] },
      { parts: ['gh-catch'], codes: [GH.CATCH] },
      { parts: ['gh-vframe'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-vframe'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-vent'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-vhinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-vhinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-opener'], codes: [] },
      { parts: ['gh-bleg', 'gh-brail'], codes: [GH.FRAME], lk: ['bench_gh_tables'] },   /* v392 the benches (off: not drawn, the steps drop out) */
      { parts: ['gh-hw-screw-brail'], codes: [GH.TOE] },
      { parts: ['gh-bslat'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-bslat'], codes: [GH.FASCIA_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v387 TYPE 43 -- GREENHOUSES, variant 5: THE VICTORIAN GREENHOUSE
     (Marek 2026-10-30 "Dalsi krok" -- slot 5 of the plan; asked: ONE end a
     polygon, the other square with the door; polycarbonate as the gable,
     the knee wall on by default). The gable greenhouse with its back end
     half a regular octagon:
       - THE PLAN: the gable's rectangle in front; at the back three walls
         of the octagon whose flats are W apart (each a = W (sqrt2 - 1),
         45 deg to the next), so the roof over them -- the gable's 30 deg
         all round -- is half an octagonal pavilion: its centre C (W / 2 in
         front of the back wall) is the ridge's back end;
       - FOUNDATION: ground screws + U heads under the side beams and the
         back beam's middle; the base's beams mitred round the bay (two
         8x200 a corner, along the next beam's axis); GRAVEL inside;
       - WALLS: 2x4 on mitred plates along the sides and the bay; at each bay
         corner two studs bevelled 22.5 deg to the mitre; girts at mid
         height and the knee wall's top; the front gable with the door, its
         studs and corners as the gable's;
       - ROOF: common pairs on the side studs in front of C, the 2x6 ridge
         board from a 6x6 hub (KVH16160) at C to the front; four 2x4 hips
         from the hub to the bay corners (dropped to the facets, a level seat
         on the plates' corner, tails cut to the fascia); jack rafters on the
         side studs behind C and two a bay facet, cheek-cut to the hips;
         purlins and roof vents between the common pairs; mitred fascia all
         round;
       - SKIN: twinwall on every wall and roof facet (the knee wall's siding
         under it, on by default), the ridge and the hips capped, a corner
         board over each bay corner; the door, casings, rake boards, vents
         and openers as the gable's.
     X across, Y up, Z along (+Z the front with the door, -Z the bay). L =
     the base's outer length incl. the bay, W its width. A facet k (0 the
     right side, 1 2 3 the bay's right / back / left, 4 the left side): n
     its outward normal, t along it (t = (n.z, 0, -n.x)), p = (P - C).n,
     q = (P - C).t; corner c joins facets c and c + 1 on the radial line
     at -22.5 - 45 c deg; every mitre is that radial plane. */
  function _ghVict(s) { return (((s || STATE).variant) | 0) === 43; }
  function _ghVictLayout(s) {
    s = s || STATE;
    var P = _ghProf(s), us = (s.isMetric === false), knee = _ghKnee(s), L = _ghL(s), W = _ghW(s), i, j, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, gl = P.gl, tt = P.tt, cw = P.cw, tw = P.tw, ft = P.ft, fw = P.fw, sg = P.sg;
    var hb = us ? 0.1397 : 0.160, hh = hb / 2;   /* the 6x6 hub */
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    var UP = [0, 1, 0];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { pieces.push({ kind: kind, code: code, len: len, id: id, obox: { c: c, u: u, v: v, n: n, d: [du, dv, dn] } }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function scr3(kind, code, Pt, d, ln, r) { scr(kind, code, Pt[0], Pt[1], Pt[2], d, ln, r); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function add3(A, B, f) { return [A[0] + B[0] * f, A[1] + B[1] * f, A[2] + B[2] * f]; }
    function sheet(kind, code, id, pts, holes, o, U, V, N, t, up) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      var tp = (up != null) ? _ghTape(pts, holes, up) : { solid: 0, vent: 0 };
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: tp });
      return area;
    }
    /* a lofted member (the gazebo's): an outline in (U, V) pushed along N = U x V from nA to nB, cut by planes (kept: m.P >= d) */
    function loft(kind, code, id, o, U, V, nA, nB, prof, planes) {
      var N = _vCross(U, V), A = prof, B = prof, i2;
      for (i2 = 0; i2 < (planes || []).length; i2++) {
        var pl = planes[i2], a = _vDot(pl.m, U), b2 = _vDot(pl.m, V), c0 = _vDot(pl.m, o) - pl.d, mn = _vDot(pl.m, N);
        A = _gzClip(A, a, b2, c0 + nA * mn);
        B = _gzClip(B, a, b2, c0 + nB * mn);
      }
      if (A.length < 3 || B.length < 3) return null;
      if (A.length !== B.length) B = A;
      if (_gzArea(A) < 0) { A = A.slice().reverse(); B = B.slice().reverse(); }
      var uMin = 1e9, uMax = -1e9;
      A.concat(B).forEach(function (Pt) { uMin = Math.min(uMin, Pt[0]); uMax = Math.max(uMax, Pt[0]); });
      var pc = { kind: kind, code: code, len: 0, id: id, o: o, U: U, V: V, N: N, nA: nA, nB: nB, A: A, B: B, uMin: uMin, uMax: uMax };
      pieces.push(pc);
      return pc;
    }
    /* THE HEIGHTS (the gable's) */
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st, yPT = yBt + _ghU(s, 'WALL_H'), yTP0 = yPT - st, yK = yBt + _ghU(s, 'KNEE_H');
    var yGm = knee ? ((yK + st / 2) + yTP0) / 2 : (yP0 + yTP0) / 2;
    var girtYs = knee ? [yK, yGm] : [yGm];
    /* THE ROOF'S LINE (the gable's, p for x on every facet) */
    var th = GH.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th), dV = sd / cs;
    var seat = Math.min(sd, dV / (3 * tn)), xh = W / 2 - seat, xr = P.rgt / 2;
    var xa = W / 2 + gl, xo = xa + _ghU(s, 'EAVE'), xe = xo + tt;
    function yR(x) { return yPT + (xh - Math.abs(x)) * tn; }
    function yT(x) { return yR(x) + dV; }
    var rgTop = yT(xr), rgBot = rgTop - P.rgd, yA = yT(0);
    function rf(sx2) { return { o: [0, yT(0), 0], U: [0, 0, sx2], V: [sx2 * cs, -sn, 0], N: [sx2 * sn, cs, 0] }; }
    function rw(F, u, v, n) { return [F.o[0] + F.U[0] * u + F.V[0] * v + F.N[0] * n, F.o[1] + F.U[1] * u + F.V[1] * v + F.N[1] * n, F.o[2] + F.U[2] * u + F.V[2] * v + F.N[2] * n]; }

    /* THE PLAN: the bay's depth dB and facet a, its back zB, the octagon's centre C, the junction zJ */
    var R2 = Math.SQRT2, T22 = Math.tan(Math.PI / 8), C22 = Math.cos(Math.PI / 8), S22 = Math.sin(Math.PI / 8);
    var dB = W * (1 - 1 / R2), aB = W * (R2 - 1), zB = -L / 2, zJ = zB + dB, zP = zB + W / 2, C3 = [0, 0, zP];
    var FA = [], FN = ['r', 'br', 'b', 'bl', 'l'];
    for (k = 0; k < 5; k++) {
      var thk = -k * Math.PI / 4, nk0 = [Math.cos(thk), 0, Math.sin(thk)];
      if (Math.abs(nk0[0]) < 1e-12) nk0[0] = 0;
      if (Math.abs(nk0[2]) < 1e-12) nk0[2] = 0;
      FA.push({ n: nk0, t: [nk0[2], 0, -nk0[0]], q0: (k === 0) ? -(L / 2 - zP) : -aB / 2, q1: (k === 4) ? (L / 2 - zP) : aB / 2 });
    }
    var CR = [];
    for (k = 0; k < 4; k++) {
      var thc = -Math.PI / 8 - k * Math.PI / 4, rv0 = [Math.cos(thc), 0, Math.sin(thc)];
      CR.push({ rv: rv0, l: [-rv0[2], 0, rv0[0]], R: (W / 2) / C22 });
    }
    function lside(c, kk) { var l0 = CR[c].l, sg2 = (_vDot(l0, FA[kk].n) > 0) ? 1 : -1; return [l0[0] * sg2, 0, l0[2] * sg2]; }
    function fp(kk, p, q, y) { var F = FA[kk]; return [C3[0] + F.n[0] * p + F.t[0] * q, y, C3[2] + F.n[2] * p + F.t[2] * q]; }
    function fdir(kk, du, dy, dn) { var F = FA[kk]; return [F.t[0] * du + F.n[0] * dn, dy, F.t[2] * du + F.n[2] * dn]; }
    function miter(c, kk) { var l = lside(c, kk); return { m: l, d: _vDot(l, C3) }; }
    /* a member along facet kk (the gazebo's loft: u = q, v = y, n = p), its corner ends mitred */
    function band(kind, code, id, kk, pIn, pOut, y0, y1, qa, qb, ea, eb) {
      var ext = 0.6, pl = [];
      if (ea) pl.push(miter(kk - 1, kk));
      if (eb) pl.push(miter(kk, kk));
      var pc = loft(kind, code, id, C3, FA[kk].t, UP, pIn, pOut, [[ea ? qa - ext : qa, y0], [eb ? qb + ext : qb, y0], [eb ? qb + ext : qb, y1], [ea ? qa - ext : qa, y1]], pl);
      if (pc) pc.len = ceil2(qb - qa);
      return pc;
    }
    var cornerA = function (kk) { return kk >= 1; }, cornerB = function (kk) { return kk <= 3; };

    /* THE FOUNDATION: ground screws + U heads under the side beams, the back beam's middle and the wide front beam's */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), zp0 = zJ + pin, zp1 = L / 2 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _ghU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (W / 2 - bw / 2), zp0 + (zp1 - zp0) * i / np, true, (sx < 0 ? 'l' : 'r') + (i + 1));
    pier(0, zB + bw / 2, false, 'bm');
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) pier(0, L / 2 - bw / 2, false, 'fm');
    /* THE BASE: the side beams to the front, the front beam between them; the bay's beams mitred */
    for (k = 0; k < 5; k++) band('base', GH.BASE, 'base-' + FN[k], k, W / 2 - bw, W / 2, yBB, yBt, FA[k].q0, FA[k].q1, cornerA(k), cornerB(k));
    var ebL = W - 2 * bw;
    box('base', GH.BASE, ceil2(ebL), 'base-f', 0, (yBB + yBt) / 2, L / 2 - bw / 2, ebL, bh, bw);
    for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * W / 2, yBB + bh * (0.3 + 0.4 * k), L / 2 - bw / 2, [-sx, 0, 0], len200);
    /* the bay's corners: two 8x200 from the next beam's face along this one's axis (the right corners into the right, the left into the left) */
    for (var c = 0; c < 4; c++) {
      var fa = (c <= 1) ? c + 1 : c, fb = (c <= 1) ? c : c + 1, dB3 = (c <= 1) ? _vSc(FA[fb].t, -1) : FA[fb].t;
      var na = FA[fa].n, nb2 = FA[fb].n, ra = W / 2, rb = W / 2 - bw / 2, det = na[0] * nb2[2] - na[2] * nb2[0];
      var Xs = (ra * nb2[2] - na[2] * rb) / det, Zs = (na[0] * rb - ra * nb2[0]) / det;
      for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, C3[0] + Xs, yBB + bh * (0.3 + 0.4 * k), C3[2] + Zs, dB3, len200);
    }
    /* THE GRAVEL FLOOR inside the base */
    var gT = _ghU(s, 'GRAVEL_T'), rin = (W / 2 - bw) / C22;
    var inner = [[-(W / 2 - bw), L / 2 - bw], [W / 2 - bw, L / 2 - bw]];
    for (c = 0; c < 4; c++) inner.push([C3[0] + CR[c].rv[0] * rin, C3[2] + CR[c].rv[2] * rin]);
    var floorA = _phArea(inner);
    loft('gravel', GH.GRAVEL, 'gravel', [0, 0, 0], [1, 0, 0], [0, 0, -1], 0.005 - gT, 0.005, inner.map(function (Pt) { return [Pt[0], -Pt[1]]; }), null);
    var gravelM3 = floorA * gT;

    /* THE FRONT WALL (the gable's): framed flat between the side walls, the door in it */
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;
    var gl2 = W / 2 - sd;
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yR(oL) - 0.03 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var hdUp = (yHt > yTP0 - 0.005);
    var nGirt = 0, nStud = 0;
    function wall(id, side, u0, u1, grid, door) {
      var hs = (side.ax === 'z'), m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var plates = door ? [[u0, -half], [half, u1]] : [[u0, u1]];
      for (m = 0; m < plates.length; m++) bx('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, 0, plates[m][1] - plates[m][0], st, sd);
      var studs = grid.filter(function (u) { return !door || Math.abs(u) > oL + st / 2 + 0.10; });
      var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
      for (m = 0; m < studs.length; m++) {
        bx('stud', GH.STUD, ceil2(yTP0 - yP0), id + '-stud-' + (m + 1), studs[m], (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
        nStud++;
        for (e = -1; e <= 1; e += 2) {
          sc('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
          sc('screw-tplate', GH.STUD_SCREW, studs[m], yPT, e * sd / 4, 0, -1, 0, len120);
        }
      }
      if (door) {
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
          if (hdUp) {
            var ka = uk - st / 2, kb = uk + st / 2, kp = [[ka, yP0], [kb, yP0], [kb, yR(kb)], [ka, yR(ka)]];
            if (!hs) poly('king', GH.STUD, ceil2(Math.max(yR(ka), yR(kb)) - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), kp, 'xy', side.c, sd);
            sc('screw-gstud', GH.FRAME_SCREW, uk, yR(uk) - 0.035, sd / 2 - 0.005, 0, 0.95, -0.31, len100);
          } else {
            bx('king', GH.STUD, ceil2(yTP0 - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), uk, (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
            for (f2 = -1; f2 <= 1; f2 += 2) sc('screw-tplate', GH.STUD_SCREW, uk, yPT, f2 * sd / 4, 0, -1, 0, len120);
          }
          bx('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            sc('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);
          }
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);
          nStud += 2;
        }
        bx('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 0, 2 * (half + st), st, sd);
      }
      var tps = (door && hdUp) ? [[u0, -oL], [oL, u1]] : [[u0, u1]];
      for (m = 0; m < tps.length; m++) if (tps[m][1] - tps[m][0] > 0.03) bx('tplate', GH.STUD, ceil2(tps[m][1] - tps[m][0]), id + '-tplate-' + (m + 1), (tps[m][0] + tps[m][1]) / 2, yPT - st / 2, 0, tps[m][1] - tps[m][0], st, sd);
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < -half && b > half;
        if (!isDoor && clr > 0.12) sc('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        for (var gy = 0; gy < girtYs.length; gy++) {
          var yc = girtYs[gy];
          bx('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, 0, clr, st, sd);
          nGirt++;
          for (e = -1; e <= 1; e += 2) {
            var ue = (e < 0) ? a + st / 2 + 0.035 : b - st / 2 - 0.035, du2 = (e < 0) ? -0.8 : 0.8;
            sc('screw-girt', GH.TOE, ue, yc + st / 2, e * sd / 4, du2, -0.6, 0, len80);
            sc('screw-girt', GH.TOE, ue, yc + e * st / 4, -sd / 2, du2, 0, 0.6, len80);
          }
        }
      }
      return { studs: studs, kings: kings };
    }
    var gsp = _ghU(s, 'STUD_SP'), gGrid = [-(gl2 - st / 2), gl2 - st / 2];
    for (k = 0; k * gsp < gl2 - st - 0.12; k++) { gGrid.push(k * gsp); if (k) gGrid.push(-k * gsp); }
    gGrid.sort(function (a, b) { return a - b; });
    wall('front', { ax: 'x', c: L / 2 - sd / 2, o: 1 }, -gl2, gl2, gGrid, true);
    for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) scr('screw-corner', GH.FRAME_SCREW, sx * (gl2 - st), yP0 + (yTP0 - yP0) * (0.15 + 0.35 * k), L / 2 - st / 2, [sx, 0, 0], len100);

    /* THE SIDE AND BAY WALLS: mitred plates, the studs (two bevelled at each bay corner), girts between them */
    var bvl = st + sd * T22;   /* a bevelled stud's outer face */
    var sideZ = [];   /* the side studs' z (the rafters / jacks over them), from the front */
    for (k = 0; ; k++) {
      var zg = (k === 0) ? L / 2 - st / 2 : L / 2 - k * gsp;
      if (zg - st / 2 < zJ + bvl + 0.05) break;
      sideZ.push(zg);
    }
    function wsc(kind, code, kk, q, y, n, du, dy, dn, ln) { scr3(kind, code, fp(kk, W / 2 - sd / 2 + n, q, y), fdir(kk, du, dy, dn), ln); }
    for (k = 0; k < 5; k++) {
      var F = FA[k], wid = 'wall-' + FN[k];
      band('plate', GH.STUD, wid + '-plate', k, W / 2 - sd, W / 2, yBt, yBt + st, F.q0, F.q1, cornerA(k), cornerB(k));
      band('tplate', GH.STUD, wid + '-tplate', k, W / 2 - sd, W / 2, yPT - st, yPT, F.q0, F.q1, cornerA(k), cornerB(k));
      var mem = [];   /* the members along the wall: their square faces' extent [qa, qb], their centre q */
      if (cornerA(k)) {
        band('stud', GH.STUD, wid + '-bstud-a', k, W / 2 - sd, W / 2, yP0, yTP0, F.q0, F.q0 + bvl, true, false).len = ceil2(yTP0 - yP0);
        mem.push({ qa: F.q0 + sd * T22, qb: F.q0 + bvl, q: F.q0 + sd * T22 + st / 2 });
      }
      var qs = [];
      if (k === 0) qs = sideZ.map(function (z) { return zP - z; });
      else if (k === 4) qs = sideZ.map(function (z) { return z - zP; });
      else {
        var qL = F.q0 + bvl, qR = F.q1 - bvl, nIn = Math.max(1, Math.ceil((qR - qL) / gsp - 1e-9));
        for (j = 1; j < nIn; j++) qs.push(qL + (qR - qL) * j / nIn);
      }
      qs.forEach(function (q) {
        obox('stud', GH.STUD, ceil2(yTP0 - yP0), wid + '-stud-' + Math.round(q * 1000), fp(k, W / 2 - sd / 2, q, (yP0 + yTP0) / 2), F.t, UP, F.n, st, yTP0 - yP0, sd);
        mem.push({ qa: q - st / 2, qb: q + st / 2, q: q });
      });
      if (cornerB(k)) {
        band('stud', GH.STUD, wid + '-bstud-b', k, W / 2 - sd, W / 2, yP0, yTP0, F.q1 - bvl, F.q1, false, true).len = ceil2(yTP0 - yP0);
        mem.push({ qa: F.q1 - bvl, qb: F.q1 - sd * T22, q: F.q1 - sd * T22 - st / 2 });
      }
      mem.sort(function (a, b) { return a.q - b.q; });
      for (j = 0; j < mem.length; j++) {
        nStud++;
        for (var e = -1; e <= 1; e += 2) {
          wsc('screw-stud', GH.STUD_SCREW, k, mem[j].q, yBt, e * sd / 4, 0, 1, 0, len120);
          wsc('screw-tplate', GH.STUD_SCREW, k, mem[j].q, yPT, e * sd / 4, 0, -1, 0, len120);
        }
      }
      for (j = 0; j + 1 < mem.length; j++) {
        var ga = mem[j].qb, gb = mem[j + 1].qa, clr2 = gb - ga, gm = (ga + gb) / 2;
        if (clr2 > 0.12) wsc('screw-plate', GH.STUD_SCREW, k, gm, yP0, 0, 0, -1, 0, len120);
        if (clr2 < 0.05) continue;
        for (var gy2 = 0; gy2 < girtYs.length; gy2++) {
          var yc2 = girtYs[gy2];
          obox('girt', GH.STUD, ceil2(clr2), wid + '-girt-' + (j + 1) + '-' + (gy2 + 1), fp(k, W / 2 - sd / 2, gm, yc2), F.t, UP, F.n, clr2, st, sd);
          nGirt++;
          for (e = -1; e <= 1; e += 2) {
            var ue2 = (e < 0) ? ga + 0.035 : gb - 0.035, du3 = (e < 0) ? -0.8 : 0.8;
            wsc('screw-girt', GH.TOE, k, ue2, yc2 + st / 2, e * sd / 4, du3, -0.6, 0, len80);
            wsc('screw-girt', GH.TOE, k, ue2, yc2 + e * st / 4, -sd / 2, du3, 0, 0.6, len80);
          }
        }
      }
    }

    /* THE ROOF FRAME: the common pairs in front of the hub (the front pair over the front wall), the ridge board from the hub */
    var commons = sideZ.filter(function (z) { return z - st / 2 >= zP + hh + 0.002; }).sort(function (a, b) { return a - b; });
    var zr = commons.map(function (z) { return { z: z, gable: (Math.abs(z - (L / 2 - st / 2)) < 1e-6) }; });
    var rafL = ceil2((xo - xr) / cs);
    function rafPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2, xm = (xh + W / 2) / 2;
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', GH.STUD, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zr[i].z, st);
        scr('screw-seat', GH.SEAT_SCREW, sx * xm, yT(xm), zr[i].z, [0, -1, 0], len200);
      }
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr('screw-rtoe', GH.TOE, s3 * xtq, yTm + k3 * s3 * 0.025, zr[i].z + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
    }
    var rgZ0 = zP + hh, rgLen = L / 2 - rgZ0;
    box('ridge', GH.RIDGE, ceil2(rgLen), 'ridge', 0, rgTop - P.rgd / 2, (rgZ0 + L / 2) / 2, P.rgt, P.rgd, rgLen);
    /* THE HUB at C: a 6x6 block, its top under the facets at its corners, its foot under the hips' and the ridge's */
    var tanH = tn * C22, cH = Math.cos(Math.atan(tanH)), dVh = sd / cH, drop = tn * S22 * st / 2;
    function yHT(r) { return yA - r * C22 * tn - drop; }
    function yHB(r) { return yHT(r) - dVh; }
    var hubTop = yA - hh * R2 * tn - 0.004, hubBot = Math.min(yHB(hh / C22 + 0.05), rgBot) - 0.03;
    var hubPc = loft('hub', GZ.HUB, 'hub', [0, 0, zP], [1, 0, 0], [0, 0, -1], hubBot, hubTop, [[-hh, -hh], [hh, -hh], [hh, hh], [-hh, hh]], null);
    hubPc.len = ceil2(hubTop - hubBot);
    for (sx = -1; sx <= 1; sx += 2) scr('screw-hub', GH.STUD_SCREW, sx * P.rgt / 2, rgBot + ((sx < 0) ? 0.075 : 0.045), rgZ0 + 0.04, [-sx * 0.15, -0.3, -0.94], len120);   /* the ridge toed into the hub (the two at different heights, not crossing) */
    /* THE HIPS: 2x4 from the hub's face to the fascia's corner, the top dropped to the facets, a level seat on the plates' corner */
    var nHips = 0, hipLs = [];
    for (c = 0; c < 4; c++) {
      var rv = CR[c].rv, Rv = CR[c].R, Nh = _vCross(rv, UP), rT = xo / C22 + 0.10, rS = 0.005;
      var rHeel = Rv - Math.max(0, yPT - yHB(Rv)) / tanH;
      var prof = (yHB(Rv) < yPT - 0.002)
        ? [[rS, yHB(rS)], [rHeel, yPT], [Rv, yPT], [Rv, yHB(Rv)], [rT, yHB(rT)], [rT, yHT(rT)], [rS, yHT(rS)]]
        : [[rS, yHB(rS)], [rT, yHB(rT)], [rT, yHT(rT)], [rS, yHT(rS)]];
      var hubPl = (c === 0) ? { m: [1, 0, 0], d: hh } : (c === 3) ? { m: [-1, 0, 0], d: hh } : { m: [0, 0, -1], d: -(zP - hh) };
      var plH = [hubPl];
      [c, c + 1].forEach(function (kk) { var nn = FA[kk].n; plH.push({ m: [-nn[0], 0, -nn[2]], d: -_vDot(nn, C3) - xo }); });
      var hp = loft('hip', GH.STUD, 'hip-' + (c + 1), C3, rv, UP, -st / 2, st / 2, prof, plH);
      if (!hp) continue;
      hp.len = ceil2((hp.uMax - hp.uMin) * Math.sqrt(1 + tanH * tanH));
      nHips++;
      /* its end at the hub: the radius on its centre line where it meets the face */
      var rFace = (c === 0 || c === 3) ? hh / Math.abs(rv[0]) : hh / Math.abs(rv[2]);
      for (k = -1; k <= 1; k += 2) {
        var rq = rFace + 0.045, Ph = add3([C3[0] + rv[0] * rq, yHT(rq), C3[2] + rv[2] * rq], Nh, k * 0.012);
        scr3('screw-hub', GH.TOE, Ph, [-rv[0] * 0.8, -0.6, -rv[2] * 0.8], len80);   /* 6x80: short of the next hip's in the hub */
      }
      /* its seat: two 8x200 down through it into the corner's bevelled studs, one each side of the mitre */
      var rSe = (rHeel + Rv) / 2;
      for (k = -1; k <= 1; k += 2) scr3('screw-hseat', GH.SEAT_SCREW, add3([C3[0] + rv[0] * rSe, yHT(rSe), C3[2] + rv[2] * rSe], Nh, k * 0.015), [0, -1, 0], len200);
      hipLs.push(hp.len);
    }
    /* THE JACKS: cheek-cut to the hip's side, seated on the plate like the commons, two 6x120 toed into the hip */
    var jacks = [];
    function jack(kk, q, overStud, id) {
      var F = FA[kk], cc = (q > 0) ? kk : kk - 1, l = lside(cc, kk), ln = _vDot(l, F.n), lt = _vDot(l, F.t);
      var pC = (st / 2 - q * lt) / ln, pCmax = pC + (st / 2) * Math.abs(lt / ln);
      if (xo - pCmax < 0.25) return null;
      var pIn = Math.max(0.02, pC - (st / 2) * Math.abs(lt / ln) - 0.10);
      var prof = [[pIn, yR(pIn)], [pIn, yT(pIn)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]];
      var jp = loft('hjack', GH.STUD, id, fp(kk, 0, q, 0), F.n, UP, -st / 2, st / 2, prof, [{ m: l, d: _vDot(l, C3) + st / 2 }]);
      if (!jp) return null;
      jp.len = ceil2((jp.uMax - jp.uMin) / cs);
      if (overStud) scr3('screw-seat', GH.SEAT_SCREW, fp(kk, xm, q, yT(xm)), [0, -1, 0], len200);
      else scr3('screw-jseat', GH.STUD_SCREW, fp(kk, xm, q, yT(xm)), [0, -1, 0], len120);
      /* up the slope, 30 / 40 deg into the wood (30 deg: level at this pitch) -- stopping short of the hip's middle */
      [[0.12, 30], [0.30, 40]].forEach(function (dq) {   /* the tip 0.12 / 0.30 of the half thickness short of the hip's middle (the other side's jacks meet it there too) */
        var al = dq[1] * Math.PI / 180, hc = cs * Math.cos(al) + sn * Math.sin(al), vc = sn * Math.cos(al) - cs * Math.sin(al);
        var dl = len120 * 0.97 * hc - (st / 2 - st * dq[0]) / Math.abs(ln);
        scr3('screw-jack', GH.STUD_SCREW, fp(kk, pC + dl, q, yT(pC + dl)), [-F.n[0] * hc, vc, -F.n[2] * hc], len120);
      });
      jacks.push({ k: kk, q: q });
      return jp;
    }
    var sideJ = [];
    sideZ.forEach(function (z) {
      if (z + st / 2 > zP - hh - 0.002) return;
      var okR = jack(0, zP - z, true, 'jack-r-' + Math.round(z * 1000)), okL = jack(4, z - zP, true, 'jack-l-' + Math.round(z * 1000));
      if (okR && okL) sideJ.push(z);
    });
    for (k = 1; k <= 3; k++) for (var qj = -1; qj <= 1; qj += 2) jack(k, qj * aB / 4, false, 'jack-' + FN[k] + (qj < 0 ? '-a' : '-b'));
    /* THE RAFTER TIES (the gable's): every other common pair, not the front one */
    var xt = Math.min(xh + (dV - sd - 0.01) / tn, W / 2 - st - 0.005), nTies = 0;
    for (i = 1; i < zr.length - 1; i += 2) {
      var zt = zr[i].z - ((zr[i].z > 0) ? 1 : -1) * st, zsd = (zr[i].z > zt) ? 1 : -1;
      box('tie', GH.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
      nTies++;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) {
          var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
          scr('screw-tie', GH.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt - zsd * st / 2, [0, 0, zsd], len80);
        }
        scr('screw-tie', GH.TIE_DOWN, sx * (xt + (W / 2 - sd)) / 2, yPT + sd, zt, [0, -1, 0], len120);
      }
    }
    /* THE EAVE BLOCKS: between the side members (commons + jacks) over the side walls, between a bay facet's two jacks */
    var nEb = 0, sideM = commons.concat(sideJ).sort(function (a, b) { return a - b; });
    for (i = 0; i + 1 < sideM.length; i++) {
      var zb0 = sideM[i] + st / 2, zb1 = sideM[i + 1] - st / 2, zbc = (zb0 + zb1) / 2, ebc = zb1 - zb0;
      if (ebc < 0.03) continue;
      for (sx = -1; sx <= 1; sx += 2) {
        var ep = [[W / 2 - st, yPT], [W / 2, yPT], [W / 2, yT(W / 2)], [W / 2 - st, yT(W / 2 - st)]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) ep.reverse();
        poly('eblock', GH.STUD, ceil2(ebc), 'eblock-' + (i + 1) + (sx < 0 ? '-l' : '-r'), ep, 'xy', zbc, ebc);
        nEb++;
        for (k = -1; k <= 1; k += 2) scr('screw-eblock', GH.TOE, sx * (W / 2 - st), yPT + 0.042, zbc + k * ebc / 4, [sx * 0.45, -0.893, 0], len80);
      }
    }
    for (k = 1; k <= 3; k++) {
      var Fk = FA[k], qe = aB / 4 - st / 2;
      if (2 * qe < 0.03) continue;
      var ebp = loft('eblock', GH.STUD, 'eblock-' + FN[k], C3, Fk.n, UP, -qe, qe, [[W / 2 - st, yPT], [W / 2, yPT], [W / 2, yT(W / 2)], [W / 2 - st, yT(W / 2 - st)]], null);
      if (ebp) { ebp.len = ceil2(2 * qe); nEb++; }
      for (j = -1; j <= 1; j += 2) scr3('screw-eblock', GH.TOE, fp(k, W / 2 - st, j * qe / 2, yPT + 0.042), [Fk.n[0] * 0.45, -0.893, Fk.n[2] * 0.45], len80);
    }
    /* THE FRONT GABLE'S STUDS (the gable's) */
    var gStuds = 0, gcz = L / 2 - sd / 2;
    for (k = 0; k < gGrid.length; k++) {
      var gx = gGrid[k], ax2 = Math.abs(gx), onHd = ax2 < half - st / 2, inKing = !onHd && ax2 < oL + st / 2 + 0.005;
      if (ax2 > gl2 - st - 0.005) continue;
      if (!hdUp) {
        if (onHd && yTP0 - yHt > 0.05) { box('cripple', GH.STUD, ceil2(yTP0 - yHt), 'cripple-' + Math.round(gx * 100), gx, (yHt + yTP0) / 2, gcz, st, yTP0 - yHt, sd); gStuds++; }
        onHd = false; inKing = false;
      }
      if (inKing) continue;
      var gy0 = onHd ? yHt : yPT;
      if (ax2 < xr + st / 2 + 1e-6) {
        if (rgBot - gy0 < 0.06) continue;
        box(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(rgBot - gy0), 'gstud-f0', 0, (gy0 + rgBot) / 2, gcz, st, rgBot - gy0, sd);
        scr('screw-gstud', GH.FRAME_SCREW, 0, rgBot - 0.035, L / 2 - 0.005, [0, 0.95, -0.31], len100);
      } else {
        var gxa = gx - st / 2, gxb = gx + st / 2;
        if (Math.min(yR(gxa), yR(gxb)) - gy0 < 0.06) continue;
        poly(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(Math.max(yR(gxa), yR(gxb)) - gy0), 'gstud-f' + (gx < 0 ? 'l' : 'r') + Math.round(ax2 * 100), [[gxa, gy0], [gxb, gy0], [gxb, yR(gxb)], [gxa, yR(gxa)]], 'xy', gcz, sd);
        scr('screw-gstud', GH.FRAME_SCREW, gx, yR(gx) - 0.035, L / 2 - 0.005, [0, 0.95, -0.31], len100);
      }
      gStuds++;
      for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', us ? GH.TOE : GH.FRAME_SCREW, gx + e3 * st / 2, gy0 + 0.04, gcz + e3 * 3 * sd / 8, [-e3 * 0.5, -0.87, 0], us ? len80 : len100);
    }

    /* THE PURLINS + VENTS between the common pairs (the gable's) */
    var vWall = (W / 2) / cs, vP = vWall / 2, vH = _ghU(s, 'VENT_S0') + st / 2, gap = GH.VENT_GAP;
    var nb = Math.max(0, zr.length - 1), ventA = gsp * Math.max(0.05, vP - vH), nVps = Math.max(1, Math.ceil(floorA * GH.VENT_RATIO / ventA / 2 - 1e-9));
    var innerB = [];
    for (i = 1; i < nb - 1; i++) innerB.push(i);
    if (!innerB.length) for (i = 0; i < nb; i++) innerB.push(i);
    nVps = Math.min(nVps, innerB.length);
    var ventBays = [];
    for (i = 0; i < nVps; i++) ventBays.push(innerB[Math.min(innerB.length - 1, Math.floor((i + 0.5) * innerB.length / nVps))]);
    var nPur = 0, vents = [];
    function rblock(kind, id, F2, i0, v, sx2) {
      var z0b = zr[i0].z + st / 2, z1b = zr[i0 + 1].z - st / 2, clr3 = z1b - z0b, uc = sx2 * (z0b + z1b) / 2;
      obox(kind, GH.STUD, ceil2(clr3), id, rw(F2, uc, v, -sd / 2), F2.U, F2.V, F2.N, clr3, st, sd);
      for (var e4 = -1; e4 <= 1; e4 += 2) {
        var ub = uc + e4 * (clr3 / 2 - 0.035), du4 = e4 * 0.8;
        var pA = rw(F2, ub, v + st / 2, -sd / 2 + e4 * sd / 4), dA = [F2.U[0] * du4 - F2.V[0] * 0.6, F2.U[1] * du4 - F2.V[1] * 0.6, F2.U[2] * du4 - F2.V[2] * 0.6];
        var pB = rw(F2, ub, v + e4 * st / 4, -sd), dB2 = [F2.U[0] * du4 + F2.N[0] * 0.6, F2.U[1] * du4 + F2.N[1] * 0.6, F2.U[2] * du4 + F2.N[2] * 0.6];
        scr('screw-purlin', GH.TOE, pA[0], pA[1], pA[2], dA, len80);
        scr('screw-purlin', GH.TOE, pB[0], pB[1], pB[2], dB2, len80);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      var F0 = rf(sx);
      for (i = 0; i < nb; i++) {
        if (zr[i + 1].z - zr[i].z - st < 0.05) continue;
        rblock('purlin', 'purlin-' + (i + 1) + (sx < 0 ? '-l' : '-r'), F0, i, vP, sx);
        nPur++;
        if (ventBays.indexOf(i) >= 0) {
          rblock('vhead', 'vhead-' + (i + 1) + (sx < 0 ? '-l' : '-r'), F0, i, vH, sx);
          vents.push({ sx: sx, i: i, z0: zr[i].z, z1: zr[i + 1].z });
        }
      }
    }

    /* THE FASCIA all round, mitred at the bay's corners; two stainless screws a common / jack tail */
    var zfE = L / 2 + gl + tt;
    for (k = 0; k < 5; k++) {
      var qa3 = (k === 0) ? -(zfE - zP) : -xe * T22, qb3 = (k === 4) ? (zfE - zP) : xe * T22;
      band('fascia', GH.BOARD, 'fascia-' + FN[k], k, xo, xe, yT(xe) - cw, yT(xe), qa3, qb3, cornerA(k), cornerB(k));
    }
    commons.concat(sideJ).forEach(function (z) {
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-fascia', GH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), z, [-sx, 0, 0], len50);
    });
    jacks.forEach(function (jq) {
      if (jq.k === 0 || jq.k === 4) return;
      for (k = 0; k < 2; k++) scr3('screw-fascia', GH.FASCIA_SCREW, fp(jq.k, xe, jq.q, yT(xe) - cw * (0.25 + 0.35 * k)), [-FA[jq.k].n[0], 0, -FA[jq.k].n[2]], len50);
    });

    /* THE SKIN: the knee wall's siding (on by default), the glazing over it; the walls up under the tails, the front gable to the rafters' top */
    var polyA = 0, sidingA = 0, tapeS = 0, tapeV = 0, ySide = yR(xa) - 0.003, yG0 = knee ? yK : yBB, t0 = knee ? sg : gl;
    function tally(area, sh) { polyA += area; tapeS += sh.tape.solid; tapeV += sh.tape.vent; }
    for (sx = -1; sx <= 1; sx += 2) {
      var Us = [0, 0, -sx], Vs = [0, 1, 0], Ns = [sx, 0, 0], Os = [sx * W / 2, 0, 0], uA = (sx > 0) ? -L / 2 : zJ, uB = (sx > 0) ? -zJ : L / 2;
      tally(sheet('glaze-wall', null, 'glaze-' + (sx < 0 ? 'l' : 'r'), [[uA, yG0], [uB, yG0], [uB, ySide], [uA, ySide]], null, Os, Us, Vs, Ns, gl, 1), sheets[sheets.length - 1]);
      if (knee) sidingA += sheet('siding', GH.SIDING, 'siding-' + (sx < 0 ? 'l' : 'r'), [[uA, yBB], [uB, yBB], [uB, yK], [uA, yK]], null, Os, Us, Vs, Ns, sg, null);
    }
    for (k = 1; k <= 3; k++) {
      var Ob = fp(k, W / 2, 0, 0);
      tally(sheet('glaze-wall', null, 'glaze-' + FN[k], [[-aB / 2, yG0], [aB / 2, yG0], [aB / 2, ySide], [-aB / 2, ySide]], null, Ob, FA[k].t, UP, FA[k].n, gl, 1), sheets[sheets.length - 1]);
      if (knee) sidingA += sheet('siding', GH.SIDING, 'siding-' + FN[k], [[-aB / 2, yBB], [aB / 2, yBB], [aB / 2, yK], [-aB / 2, yK]], null, Ob, FA[k].t, UP, FA[k].n, sg, null);
    }
    var ag = W / 2 + gl;
    (function () {
      var Ug = [1, 0, 0], Vg = [0, 1, 0], Ng = [0, 0, 1], Og = [0, 0, L / 2], gTop = [[ag, yT(ag)], [0, yT(0)], [-ag, yT(ag)]], gpG, ghH = null;
      if (knee === false) { gpG = [[-ag, yG0], [ag, yG0]].concat(gTop); ghH = [[[-half, yBt], [half, yBt], [half, yHd], [-half, yHd]]]; }
      else gpG = [[-ag, yK], [-half, yK], [-half, yHd], [half, yHd], [half, yK], [ag, yK]].concat(gTop);
      tally(sheet('glaze-wall', null, 'glaze-f', gpG, ghH, Og, Ug, Vg, Ng, gl, 1), sheets[sheets.length - 1]);
      if (knee) {
        var as2 = W / 2 + sg;
        sidingA += sheet('siding', GH.SIDING, 'siding-f', [[-as2, yBB], [as2, yBB], [as2, yK], [half, yK], [half, yBt], [-half, yBt], [-half, yK], [-as2, yK]], null, Og, Ug, Vg, Ng, sg, null);
      }
    })();
    /* the roof's glazing: the side slopes from the ridge to past the fascia, back to the hips; the bay's facets up to C; the vents cut out */
    var vEnd = xe / cs + _ghU(s, 'GL_OVER'), uR = L / 2 + gl, hE = vEnd * cs * T22, capW = _ghU(s, 'CAP_W');
    for (sx = -1; sx <= 1; sx += 2) {
      var F1 = rf(sx), rh = [];
      for (j = 0; j < vents.length; j++) if (vents[j].sx === sx) {
        var hu0 = (sx > 0) ? vents[j].z0 : -vents[j].z1, hu1 = (sx > 0) ? vents[j].z1 : -vents[j].z0;
        rh.push([[hu0, vH], [hu0, vP], [hu1, vP], [hu1, vH]]);
      }
      var rp0 = (sx > 0) ? [[zP, 0], [uR, 0], [uR, vEnd], [zP - hE, vEnd]] : [[-uR, 0], [-zP, 0], [-(zP - hE), vEnd], [-uR, vEnd]];
      tally(sheet('glaze-roof', null, 'glaze-roof-' + (sx < 0 ? 'l' : 'r'), rp0, rh, F1.o, F1.U, F1.V, F1.N, gl, -1), sheets[sheets.length - 1]);
    }
    function bayRF(kk) { var nn = FA[kk].n; return { o: [0, yA, zP], U: [-FA[kk].t[0], 0, -FA[kk].t[2]], V: [nn[0] * cs, -sn, nn[2] * cs], N: [nn[0] * sn, cs, nn[2] * sn] }; }
    for (k = 1; k <= 3; k++) {
      var Fb = bayRF(k);
      tally(sheet('glaze-roof', null, 'glaze-roof-' + FN[k], [[0, 0], [hE, vEnd], [-hE, vEnd]], null, Fb.o, Fb.U, Fb.V, Fb.N, gl, -1), sheets[sheets.length - 1]);
    }
    /* the caps: the ridge's (a strip down each slope) from C to the front, each hip's (a strip on each facet beside it) */
    for (sx = -1; sx <= 1; sx += 2) {
      var Fc = rf(sx), cp = (sx > 0) ? [[zP, 0], [zfE, 0], [zfE, capW], [zP, capW]] : [[-zfE, 0], [-zP, 0], [-zP, capW], [-zfE, capW]];
      sheet('cap', GH.CAP, 'cap-' + (sx < 0 ? 'l' : 'r'), cp, null, add3(Fc.o, Fc.N, gl), Fc.U, Fc.V, Fc.N, GH.CAP_T, null);
    }
    function hipCap(id, Fr, u0, sgn) {
      var nl = Math.sqrt(1 + cs * T22 * cs * T22), nI = [sgn / nl, cs * T22 / nl], E0 = [u0, 0], E1 = [u0 - sgn * hE, vEnd];
      sheet('cap', GH.CAP, id, [E0, E1, [E1[0] + nI[0] * capW, E1[1] + nI[1] * capW], [E0[0] + nI[0] * capW, E0[1] + nI[1] * capW]], null, add3(Fr.o, Fr.N, gl), Fr.U, Fr.V, Fr.N, GH.CAP_T, null);
    }
    hipCap('cap-hip-r', rf(1), zP, 1);
    hipCap('cap-hip-l', rf(-1), -zP, -1);
    for (k = 1; k <= 3; k++) { hipCap('cap-hip-' + FN[k] + '-a', bayRF(k), 0, -1); hipCap('cap-hip-' + FN[k] + '-b', bayRF(k), 0, 1); }
    var hipCapL = vEnd * Math.sqrt(1 + cs * T22 * cs * T22), fix = _ghU(s, 'CAP_FIX');
    var capL = (zfE - zP) + 4 * hipCapL;
    var capScrews = 2 * (Math.ceil((zfE - zP) / fix - 1e-9) + 1) + 4 * 2 * (Math.ceil(hipCapL / fix - 1e-9) + 1);

    /* THE CORNER BOARDS: the front's two a corner (the gable's), one over each bay corner (stainless screws into its bevelled studs) */
    var xaT = W / 2 + t0, zaT = L / 2 + t0, nTrim = 0;
    var cTop = Math.min(ySide, yT(xaT + tt) + gl / cs - cw / cs - 0.002), cHt = cTop - yBB;
    for (sx = -1; sx <= 1; sx += 2) {
      box('trim', GH.TRIM, ceil2(cHt), 'trim-g-' + sx, sx * (xaT + tt - tw / 2), yBB + cHt / 2, zaT + tt / 2, tw, cHt, tt);
      box('trim', GH.TRIM, ceil2(cHt), 'trim-s-' + sx, sx * (xaT + tt / 2), yBB + cHt / 2, zaT - tw / 2, tt, cHt, tw);
      nTrim += 2;
      var ty = fixPts(yBB + 0.08, cTop - 0.08, _ghU(s, 'FIX_SP'));
      for (k = 0; k < ty.length; k++) {
        scr('nail-trim', GH.TRIM_NAIL, sx * (xaT + tt - tw / 2), ty[k], zaT + tt, [0, 0, -1], len32, 0.0012);
        scr('nail-trim', GH.TRIM_NAIL, sx * (xaT + tt), ty[k], zaT - tw / 2, [-sx, 0, 0], len32, 0.0012);
      }
    }
    var offT = t0 / C22 + tt / 2, rOut = CR[0].R + offT + tt / 2 + 0.03;
    var cTopB = Math.min(ySide, yHB(rOut) - 0.004), cHb = cTopB - yBB;
    for (c = 0; c < 4; c++) {
      var rvc = CR[c].rv, lc = CR[c].l, Vx = C3[0] + rvc[0] * CR[c].R, Vz = C3[2] + rvc[2] * CR[c].R;
      obox('trim', GH.TRIM, ceil2(cHb), 'trim-c' + (c + 1), [Vx + rvc[0] * offT, yBB + cHb / 2, Vz + rvc[2] * offT], lc, UP, rvc, tw, cHb, tt);
      nTrim++;
      var tyb = fixPts(yBB + 0.08, cTopB - 0.08, _ghU(s, 'FIX_SP'));
      for (k = 0; k < tyb.length; k++) {
        var lo = ((k % 2) ? 1 : -1) * 0.013;
        scr('screw-ctrim', GH.FASCIA_SCREW, Vx + rvc[0] * (offT + tt / 2) + lc[0] * lo, tyb[k], Vz + rvc[2] * (offT + tt / 2) + lc[2] * lo, [-rvc[0], 0, -rvc[2]], len50);
      }
    }
    /* THE RAKE BOARDS on the front gable (the gable's) */
    var glV = gl / cs, cwV = cw / cs, rakeL = ceil2(xo / cs);
    for (sx = -1; sx <= 1; sx += 2) {
      var rp = [[0, yT(0) + glV], [xo, yT(xo) + glV], [xo, yT(xo) + glV - cwV], [0, yT(0) + glV - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) rp.reverse();
      poly('rake', GH.BOARD, rakeL, 'rake-f' + (sx < 0 ? '-l' : '-r'), rp, 'xy', L / 2 + gl + tt / 2, tt);
      var rx = fixPts(0.10, xo - 0.05, _ghU(s, 'FIX_SP'));
      for (k = 0; k < rx.length; k++) scr('screw-rake', GH.FASCIA_SCREW, sx * rx[k], yT(rx[k]) - 0.03, L / 2 + gl + tt, [0, 0, -1], len50);
    }
    /* THE CASINGS round the door; the belt boards over the knee wall's joint all round */
    var zC = L / 2 + t0;
    [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, RO + 2 * cw]].forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc4 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc4, zC + tt / 2, du, dy, tt);
      var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
      pts2.forEach(function (w2) {
        for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-trim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);
      });
    });
    var nBelt = 0;
    if (knee) {
      var yy3o = Math.min(cw / 4, st / 2 - 0.006), bEnd = (tw / 2) * C22 + 0.02;
      var xb = xaT + tt - tw;
      [[-xb, -(half + cw), 'belt-fl'], [half + cw, xb, 'belt-fr']].forEach(function (bp) {
        var bl2 = bp[1] - bp[0], bm2 = (bp[0] + bp[1]) / 2;
        if (bl2 < 0.05) return;
        box('belt', GH.BOARD, ceil2(bl2), bp[2], bm2, yK, L / 2 + sg + tt / 2, bl2, cw, tt);
        nBelt++;
        fixPts(bp[0] + 0.05, bp[1] - 0.05, _ghU(s, 'FIX_SP')).forEach(function (w3) {
          for (var e6 = -1; e6 <= 1; e6 += 2) scr('nail-trim', GH.TRIM_NAIL, w3, yK + e6 * yy3o, L / 2 + sg + tt, [0, 0, -1], len32, 0.0012);
        });
      });
      for (k = 0; k < 5; k++) {
        var Fq = FA[k], ba = (k === 0) ? -(zaT - tw - zP) : Fq.q0 + bEnd, bb = (k === 4) ? (zaT - tw - zP) : Fq.q1 - bEnd;
        if (bb - ba < 0.05) continue;
        obox('belt', GH.BOARD, ceil2(bb - ba), 'belt-' + FN[k], fp(k, W / 2 + sg + tt / 2, (ba + bb) / 2, yK), Fq.t, UP, Fq.n, bb - ba, cw, tt);
        nBelt++;
        fixPts(ba + 0.05, bb - 0.05, _ghU(s, 'FIX_SP')).forEach(function (w4) {
          for (var e7 = -1; e7 <= 1; e7 += 2) scr3('nail-trim', GH.TRIM_NAIL, fp(k, W / 2 + sg + tt, w4, yK + e7 * yy3o), [-Fq.n[0], 0, -Fq.n[2]], len32, 0.0012);
        });
      }
    }

    /* THE DOOR (the gable's) */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e8 = -1; e8 <= 1; e8 += 2) scr('screw-door', GH.STUD_SCREW, sx * dW / 2, railY[k] + e8 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA2, yB2) {
      var xA = -dW / 2 + fw, xB = dW / 2 - fw, dx = xB - xA, dy = yB2 - yA2, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext2 = fw * 1.5, ax0 = xA - ux * ext2, ay0 = yA2 - uy * ext2, bx0 = xB + ux * ext2, by0 = yB2 + uy * ext2;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA2); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xA); pb = _gzClip(pb, -1, 0, xB);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA2 + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA2 - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    var dgA = sheet('glaze-door', null, 'glaze-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1);
    tally(dgA, sheets[sheets.length - 1]);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [-dW / 2 + hingeLen / 2, hy, zD1 + gl + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-half - cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, -dW / 2 + 0.035 + i * 0.10, hy, zD1 + gl + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, -half - cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [dW / 2 - fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + gl, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [dW / 2 - 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* THE ROOF VENTS (the gable's) */
    var aV = GH.VENT_ANG * Math.PI / 180, ca = Math.cos(aV), sa = Math.sin(aV), ventAreaSum = 0;
    for (j = 0; j < vents.length; j++) {
      var vt = vents[j], F2 = rf(vt.sx), vid = 'vent-' + (vt.i + 1) + (vt.sx < 0 ? '-l' : '-r');
      var uA2 = (vt.sx > 0) ? vt.z0 : -vt.z1, uB2 = (vt.sx > 0) ? vt.z1 : -vt.z0;
      var V2 = [F2.V[0] * ca + F2.N[0] * sa, F2.V[1] * ca + F2.N[1] * sa, F2.V[2] * ca + F2.N[2] * sa];
      var N2 = [-F2.V[0] * sa + F2.N[0] * ca, -F2.V[1] * sa + F2.N[1] * ca, -F2.V[2] * sa + F2.N[2] * ca];
      var Hl = rw(F2, 0, vH, gl);
      var sw = function (u, dv, dn) { return [Hl[0] + F2.U[0] * u + V2[0] * dv + N2[0] * dn, Hl[1] + F2.U[1] * u + V2[1] * dv + N2[1] * dn, Hl[2] + F2.U[2] * u + V2[2] * dv + N2[2] * dn]; };
      var gu0 = uA2 + gap, gu1 = uB2 - gap, gv1 = vP - vH - gap;
      var fu0 = uA2 + st / 2 + gap, fu1 = uB2 - st / 2 - gap, fv0 = st / 2 + gap, fv1 = vP - vH - st / 2 - gap, fL = fv1 - fv0, fWd = fu1 - fu0;
      for (k = -1; k <= 1; k += 2) {
        var usc = (k < 0) ? fu0 + fw / 2 : fu1 - fw / 2;
        obox('vframe', GH.FRAME, ceil2(fL), vid + '-stile-' + (k < 0 ? 'a' : 'b'), sw(usc, (fv0 + fv1) / 2, -gl - ft / 2), F2.U, V2, N2, fw, fL, ft);
      }
      var vRails = [fv0 + fw / 2, fv1 - fw / 2];
      for (k = 0; k < 2; k++) {
        obox('vframe', GH.FRAME, ceil2(fWd - 2 * fw), vid + '-rail-' + (k + 1), sw((fu0 + fu1) / 2, vRails[k], -gl - ft / 2), F2.U, V2, N2, fWd - 2 * fw, fw, ft);
        for (var e9 = -1; e9 <= 1; e9 += 2) for (var e10 = -1; e10 <= 1; e10 += 2) {
          var pv = sw((e9 < 0) ? fu0 : fu1, vRails[k] + e10 * fw / 4, -gl - ft / 2);
          scr('screw-vframe', GH.STUD_SCREW, pv[0], pv[1], pv[2], [-e9 * F2.U[0], -e9 * F2.U[1], -e9 * F2.U[2]], len120);
        }
      }
      var sgA = sheet('glaze-vent', null, vid + '-glaze', [[gu0, 0], [gu0, gv1], [gu1, gv1], [gu1, 0]].map(function (Pt) { return [Pt[0], Pt[1] + gap]; }), null, sw(0, 0, -gl), F2.U, V2, N2, gl, -1);
      tally(sgA, sheets[sheets.length - 1]);
      ventAreaSum += (uB2 - uA2) * (vP - vH);
      for (k = -1; k <= 1; k += 2) {
        var hu = (k < 0) ? gu0 + 0.08 : gu1 - 0.08, hLs = 0.18, hLb = 0.06;
        obox('vhinge', GH.HINGE, 0, vid + '-hinge-' + (k < 0 ? 'a' : 'b'), sw(hu, gap + hLs / 2, hT / 2), F2.U, V2, N2, hingeW, hLs, hT);
        obox('vhinge', null, 0, vid + '-hinge-leaf-' + (k < 0 ? 'a' : 'b'), rw(F2, hu, vH - hLb / 2, gl + hT / 2), F2.U, F2.V, F2.N, hingeW * 1.6, hLb, hT);
        hinges++;
        for (i = 0; i < 3; i++) {
          var hp1 = sw(hu, gap + st / 2 + fw * (0.15 + 0.35 * i), hT), hp2 = rw(F2, hu + (i - 1) * 0.01, vH - 0.015, gl + hT);
          scr('screw-vhinge', GH.HINGE_SCREW, hp1[0], hp1[1], hp1[2], [-N2[0], -N2[1], -N2[2]], len40, 0.0022);
          scr('screw-vhinge', GH.HINGE_SCREW, hp2[0], hp2[1], hp2[2], [-F2.N[0], -F2.N[1], -F2.N[2]], len40, 0.0022);
        }
      }
      var oA = rw(F2, (uA2 + uB2) / 2, vP - st / 2 - 0.02, -sd * 0.7), oB = sw((uA2 + uB2) / 2, vRails[1], -gl - ft);
      var od = [oB[0] - oA[0], oB[1] - oA[1], oB[2] - oA[2]], oLn = Math.sqrt(od[0] * od[0] + od[1] * od[1] + od[2] * od[2]), oU = [od[0] / oLn, od[1] / oLn, od[2] / oLn];
      var oX = F2.U, oN = [oU[1] * oX[2] - oU[2] * oX[1], oU[2] * oX[0] - oU[0] * oX[2], oU[0] * oX[1] - oU[1] * oX[0]];
      obox('opener', null, 0, vid + '-opener', [(oA[0] + oB[0]) / 2, (oA[1] + oB[1]) / 2, (oA[2] + oB[2]) / 2], oX, oU, oN, 0.03, oLn, 0.03);
    }
    if (polyA > 0) missing.push({ name: GH.POLY_NAME, qty: Math.round(polyA * GH.WASTE * 100) / 100, unit: 'm2' });
    if (tapeV > 0) missing.push({ name: GH.VTAPE_NAME, qty: Math.round(tapeV * 100) / 100, unit: 'm' });
    if (vents.length) missing.push({ name: GH.OPENER_NAME, qty: vents.length, unit: 'pcs' });

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    var m3 = {}, coat = sidingA;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.RIDGE] = 2 * (P.rgt + P.rgd); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw); per[GH.TRIM] = 2 * (tt + tw); per[GZ.HUB] = 4 * hb;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    /* v392 the benches' runs: the sides from where their corner clears the bay's diagonal walls (BN_CLR off their framing), one across the bay's back wall
       (as long as its ends clear the diagonals), the door's approach kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bX = W / 2 - sd - bClr, bZ = L / 2 - sd - bEnd, bZs = zP - T22 * bX, bXb = T22 * bX;
    var benchSpec = { inner: 2 * bX, runs: [{ id: 'l', ax: 'z', c: -bX, o: 1, a: bZs, b: bZ, pair: 'l' }, { id: 'r', ax: 'z', c: bX, o: -1, a: bZs, b: bZ, pair: 'r' },
                                            { id: 'b', ax: 'x', c: zB + sd + bClr, o: 1, a: -bXb, b: bXb }],
                      keep: [{ x0: -half - 0.05, x1: half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    return {
      P: P, us: us, knee: knee, L: L, W: W, benchSpec: benchSpec, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing, victorian: true,
      meters: m3, coat: coat, polyA: polyA, sidingA: sidingA, tapeSolid: tapeS, tapeVent: tapeV, capL: capL, capScrews: capScrews, hinges: hinges,
      gravelM3: r3(gravelM3), digM3: r3(gravelM3), floorA: floorA, rafters: zr, ties: nTies, eBlocks: nEb, gStuds: gStuds, girts: nGirt, studs: nStud, purlins: nPur,
      vents: vents.length, ventA: ventAreaSum, trims: nTrim, belts: nBelt, doorW: dW, doorH: dH, RO: RO, hdUp: hdUp, hips: nHips, jacks: jacks.length, bayDepth: dB, bayFacet: aB, apexZ: zP,
      yBB: yBB, yBt: yBt, yPT: yPT, yK: yK, ridgeTop: rgTop, pitch: GH.PITCH, rafL: rafL, roofLen: rgLen, slope: vEnd, hubTop: hubTop,
      top: yT(0) + gl / cs + 0.01, height: yT(0) + gl / cs + 0.01, depth: W, length: L, extX: xe + _ghU(s, 'GL_OVER') * cs, extZ: Math.max(zfE, L / 2 + (xe - W / 2) + _ghU(s, 'GL_OVER') * cs)
    };
  }
  var _ghVictStepsC = null;
  function _ghVictSteps(s) {
    if (_ghVictStepsC) return _ghVictStepsC;
    return (_ghVictStepsC = [
      { parts: [], codes: [] },
      { parts: ['gh-block'], codes: [GH.GRAVEL, GH.FD_BLOCK] },                                                          /* v399 precast pads */
      { parts: ['gh-pour'], codes: [GH.DIG, GH.GRAVEL, GH.FD_GEOTEX, GH.FD_FORMWORK, GH.FD_REBAR, GH.FD_CONCRETE] },     /* v399 poured footings */
      { parts: ['gh-gscrew'], codes: [GH.GSCREW] },
      { parts: ['gh-uhead'], codes: [GH.UHEAD] },
      { parts: ['gh-uanchor'], codes: [GH.FD_UANCHOR] },   /* v399 the footings' wet-set anchors */
      { parts: ['gh-base'], codes: [GH.BASE] },
      { parts: ['gh-hw-screw-base'], codes: [GH.BASE_SCREW] },
      { parts: ['gh-hw-nail-uhead'], codes: [GH.UNAIL] },
      { parts: ['gh-gravel'], codes: [GH.DIG, GH.GRAVEL] },
      { parts: ['gh-plate'], codes: [GH.STUD] },
      { parts: ['gh-stud', 'gh-king', 'gh-jack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-stud'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-header'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-frame'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['gh-tplate'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tplate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-plate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-corner'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-girt'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-girt'], codes: [GH.TOE] },
      { parts: ['gh-rafter'], codes: [GH.STUD] },
      { parts: ['gh-ridge'], codes: [GH.RIDGE] },
      { parts: ['gh-hw-screw-seat'], codes: [GH.SEAT_SCREW] },
      { parts: ['gh-hw-screw-rtoe'], codes: [GH.TOE] },
      { parts: ['gh-hub'], codes: [GZ.HUB], lk: ['pdf_part_hub'] },
      { parts: ['gh-hip'], codes: [GH.STUD], lk: ['pdf_part_hip_rafter'] },
      { parts: ['gh-hw-screw-hub', 'gh-hw-screw-hseat'], codes: [GH.STUD_SCREW, GH.TOE, GH.SEAT_SCREW] },
      { parts: ['gh-hjack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-jack', 'gh-hw-screw-jseat'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-tie'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tie'], codes: [GH.TIE_SCREW, GH.TIE_DOWN] },
      { parts: ['gh-eblock'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-eblock'], codes: [GH.TOE] },
      { parts: ['gh-gstud', 'gh-cripple'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-gstud'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-purlin', 'gh-vhead'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-purlin'], codes: [GH.TOE] },
      { parts: ['gh-fascia'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-fascia'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-siding'], codes: [GH.SIDING, GH.SIDING_SCREW] },
      { parts: ['gh-glaze-wall'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-glaze-roof'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-cap'], codes: [GH.CAP, GH.GL_SCREW] },
      { parts: ['gh-trim'], codes: [GH.TRIM] },
      { parts: ['gh-hw-screw-ctrim'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-rake', 'gh-casing', 'gh-belt'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-rake'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-hw-nail-trim'], codes: [GH.TRIM_NAIL] },
      { parts: ['gh-dframe'], codes: [GH.FRAME] },
      { parts: ['gh-dbrace'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-door'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-door'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-hinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-hinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-knob'], codes: [GH.KNOB] },
      { parts: ['gh-catch'], codes: [GH.CATCH] },
      { parts: ['gh-vframe'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-vframe'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-vent'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-vhinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-vhinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-opener'], codes: [] },
      { parts: ['gh-bleg', 'gh-brail'], codes: [GH.FRAME], lk: ['bench_gh_tables'] },   /* v392 the benches (off: not drawn, the steps drop out) */
      { parts: ['gh-hw-screw-brail'], codes: [GH.TOE] },
      { parts: ['gh-bslat'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-bslat'], codes: [GH.FASCIA_SCREW] }
    ]);
  }
  /* ------------------------------------------------------------------
     v390 TYPE 45 -- GREENHOUSES, variant 6: THE OLD-WINDOW GREENHOUSE
     (Marek 2026-10-30 "Dalsi krok" -- slot 6 of the plan; asked: the old
     windows in the WALLS, the roof the gable's polycarbonate; their size
     on the SLIDER). The gable greenhouse with its walls of reclaimed
     sashes:
       - THE SASHES: one stock size for the whole house on the info bar's
         slider (60 x 90, 60 x 120, 75 x 120, 90 x 120, 90 x 150 cm; US
         24 x 36, 24 x 48, 30 x 48, 36 x 48, 36 x 60 in.; 75 x 120 / 30 x
         48 unless set), 35 mm (US 1 3/8 in.) thick, painted, 2 - 3 x 2 - 4
         lites; each on the OUTSIDE face of the framing, its top just under
         the rafters, the next one 6 mm (US 1/4 in.) off. Drawn, no
         catalogue row: on missing by the piece (the owner's or salvaged);
       - THE PLAN snaps to whole sashes: n of them along the side walls
         (2.40 - 6.00 m, US 8 - 20 ft), m across the back's full width
         (1.80 - 3.60 m, US 6 - 12 ft); the front the gable's door in the
         middle, a run of sashes from each corner as far as a double stud
         still clears the door's king, panel siding between;
       - FRAMING as the gable's (ground screws, base, gravel, plates, 2x4
         studs, the door's kings / jacks / header, rafters, ridge, ties,
         eave blocks, gable studs, purlins, roof vents, fascia), with a
         DOUBLE stud under every joint between two sashes -- each sash on
         its own stud: three 6x80 through each inner stile, two through
         its bottom rail into the sill girt (the corner stiles held by the
         corner boards' screws); the pair screwed together twice; a sill
         girt on the sashes' bottom edge, a knee girt when the wall under
         them is tall, a mid girt in the front's siding strips; the rafters
         over the joints;
       - SKIN: panel siding FCP00009 under the sashes all round (the
         front's strips by the door up to the band's top), 8 mm twinwall
         on the gable triangles over them, on the roof, the door and the
         vents as the gable's;
       - TRIM, 1x4 TIM20100 over the sashes' face, screwed 6x80 through to
         the framing: the corner boards, a sill board over the sashes'
         bottom edge, a head board over their top on the gables; a batten
         over every joint nailed into both stiles; the door's casings and
         the rake boards as the gable's.
     X across, Y up, Z along (+Z the door). L / W = the base's outer faces. */
  function _ghOld(s) { return (((s || STATE).variant) | 0) === 45; }
  /* the sash: its stock size (the slider's index), the gap between two */
  function _ghWin(s) {
    s = s || STATE;
    var S = _ghU(s, 'OW_SIZES'), i = (s.ghWin != null && isFinite(+s.ghWin)) ? Math.max(0, Math.min(S.length - 1, Math.round(+s.ghWin))) : GH.OW_I0;
    return { i: i, w: S[i][0], h: S[i][1], g: _ghU(s, 'OW_GAP'), n: S.length };
  }
  /* the plan in whole sashes: along the side walls (wide = false) or across the back (true), within the gable's ranges +-10 cm */
  function _ghOldCount(s, wide) {
    var Wn = _ghWin(s), R = _ghU(s, wide ? 'W' : 'L'), m = Wn.w + Wn.g;
    var n0 = Math.max(2, Math.ceil((R[0] - 0.10 + Wn.g) / m - 1e-9)), n1 = Math.floor((R[1] + 0.10 + Wn.g) / m + 1e-9);
    return { min: n0, max: Math.max(n0, n1), m: m, g: Wn.g };
  }
  function _ghOldR(s, wide) { var C = _ghOldCount(s, wide); return { min: Math.round((C.min * C.m - C.g) * 100000) / 100000, max: Math.round((C.max * C.m - C.g) * 100000) / 100000 }; }
  function _ghOldSnap(s, wide) {
    s = s || STATE;
    var C = _ghOldCount(s, wide), v = wide ? +s.ghW : +s.L;
    if (!(isFinite(v) && v > 0)) v = _ghU(s, wide ? 'OW0' : 'OL0');
    var n = Math.max(C.min, Math.min(C.max, Math.round((v + C.g) / C.m)));
    return Math.round((n * C.m - C.g) * 100000) / 100000;
  }
  function _ghOldLayout(s) {
    s = s || STATE;
    var P = _ghProf(s), us = (s.isMetric === false), L = _ghL(s), W = _ghW(s), Wn = _ghWin(s), i, j, k, sx, sz;
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, gl = P.gl, tt = P.tt, cw = P.cw, ft = P.ft, fw = P.fw, sg = P.sg;
    var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { pieces.push({ kind: kind, code: code, len: len, id: id, obox: { c: c, u: u, v: v, n: n, d: [du, dv, dn] } }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function add3(A, B, f) { return [A[0] + B[0] * f, A[1] + B[1] * f, A[2] + B[2] * f]; }
    function avoid(u, list, d) { for (var q = 0; q < list.length; q++) if (Math.abs(u - list[q]) < d) return false; return true; }
    function sheet(kind, code, id, pts, holes, o, U, V, N, t, up) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      var tp = (up != null) ? _ghTape(pts, holes, up) : { solid: 0, vent: 0 };
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area, tape: tp });
      return area;
    }
    /* THE HEIGHTS as the gable's: the base, the studs' foot, the top plate */
    var yBB = _ghYBB(s), yBt = yBB + bh, yP0 = yBt + st, yPT = yBt + _ghU(s, 'WALL_H'), yTP0 = yPT - st;
    /* THE ROOF'S LINE as the gable's, the eave measured from the sashes' face */
    var th = GH.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), sn = Math.sin(th), dV = sd / cs;
    var seat = Math.min(sd, dV / (3 * tn)), xh = W / 2 - seat, xr = P.rgt / 2;
    var ww = Wn.w, wh = Wn.h, wg = Wn.g, mod = ww + wg, wt = _ghU(s, 'OW_T'), sw = _ghU(s, 'OW_STILE'), rb = _ghU(s, 'OW_RAILB'), mw = _ghU(s, 'OW_MUN');
    var xa = W / 2 + wt, xo = xa + _ghU(s, 'EAVE'), xe = xo + tt;
    function yR(x) { return yPT + (xh - Math.abs(x)) * tn; }
    function yT(x) { return yR(x) + dV; }
    var rgTop = yT(xr), rgBot = rgTop - P.rgd;
    function rf(sx2) { return { o: [0, yT(0), 0], U: [0, 0, sx2], V: [sx2 * cs, -sn, 0], N: [sx2 * sn, cs, 0] }; }
    function rw(F, u, v, n) { return [F.o[0] + F.U[0] * u + F.V[0] * v + F.N[0] * n, F.o[1] + F.U[1] * u + F.V[1] * v + F.N[1] * n, F.o[2] + F.U[2] * u + F.V[2] * v + F.N[2] * n]; }
    /* THE WINDOW BAND: the sashes' top just under the rafters at their face, their bottom a sash lower; the girts' heights */
    var yWt = yR(xa) - 0.003, yWb = yWt - wh, kneeTop = yWb - st / 2;
    var gK = (kneeTop - yP0 > 0.75) ? [(yP0 + kneeTop) / 2] : [];
    var girtWin = gK.concat([yWb]), girtStrip = girtWin.concat([(yWb + yTP0) / 2]);
    var nL = Math.round((L + wg) / mod), nW = Math.round((W + wg) / mod);

    /* THE FOUNDATION as the gable's */
    var found = _ghFound(s), yH = _ghYH(s, yBB), blocks = [], pours = [];   /* v399 the foundation on its switch */
    function pier(x, z, alongZ, id) {
      /* v399 a precast pad: the base resting on its top -- nothing to fix; a poured footing with a wet-set U anchor, or a ground screw with a U head */
      if (found === 'block') { blocks.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_BLK'), wt: _ghU(s, 'FD_BLK_TOP'), y0: yH - _ghU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }
      if (found === 'pier') pours.push({ x: x, z: z, a: alongZ ? 0 : Math.PI / 2, w: _ghU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
        else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
      }
    }
    var pin = _ghU(s, 'PIER_IN'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _ghU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (W / 2 - bw / 2), zp0 + (zp1 - zp0) * i / np, true, (sx < 0 ? 'l' : 'r') + (i + 1));
    if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, (sz < 0 ? 'b' : 'f') + 'm');
    for (sx = -1; sx <= 1; sx += 2) box('base', GH.BASE, ceil2(L), 'base-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
    var ebL = W - 2 * bw;
    for (sz = -1; sz <= 1; sz += 2) {
      box('base', GH.BASE, ceil2(ebL), 'base-' + (sz < 0 ? 'b' : 'f'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), ebL, bh, bw);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', GH.BASE_SCREW, sx * W / 2, yBB + bh * (0.3 + 0.4 * k), sz * (L / 2 - bw / 2), [-sx, 0, 0], len200);
    }
    var gT = _ghU(s, 'GRAVEL_T'), giW = W - 2 * bw, giL = L - 2 * bw;
    pieces.push({ kind: 'gravel', code: GH.GRAVEL, len: 0, id: 'gravel', box: [0, 0.005 - gT / 2, 0, giW, gT, giL] });
    var gravelM3 = giW * giL * gT;

    /* THE WALLS, framed flat and stood up (the gable's), each on its own
       list of studs: a double one under every joint between two sashes */
    var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, RO = 2 * half, oL = half + 2 * st;
    var gl2 = W / 2 - sd;
    var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yR(oL) - 0.03 - st - _ghU(s, 'DOOR_CLR') - yD0;
    var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHt = yHd + st;
    var hdUp = (yHt > yTP0 - 0.005);
    /* the front's runs of sashes: from each corner inwards as far as the run's inner double stud clears the door's king */
    var kF = 0;
    for (k = nW; k >= 1; k--) if (W / 2 - k * ww - (k - 1) * wg - wg / 2 - st >= oL - 1e-6) { kF = k; break; }
    var jIn = kF ? W / 2 - kF * mod + wg / 2 : 0;
    var nGirt = 0, nStud = 0, nDbl = 0, mem = {};
    function wall(id, side, u0, u1, studs, door, girtsAt) {
      var hs = (side.ax === 'z'), m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var plates = door ? [[u0, -half], [half, u1]] : [[u0, u1]];
      for (m = 0; m < plates.length; m++) bx('plate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, 0, plates[m][1] - plates[m][0], st, sd);
      var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
      for (m = 0; m < studs.length; m++) {
        bx('stud', GH.STUD, ceil2(yTP0 - yP0), id + '-stud-' + (m + 1), studs[m], (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
        nStud++;
        for (e = -1; e <= 1; e += 2) {
          sc('screw-stud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
          sc('screw-tplate', GH.STUD_SCREW, studs[m], yPT, e * sd / 4, 0, -1, 0, len120);
        }
      }
      /* a double stud: the pair screwed together twice in the window band (between the sashes' own screws) */
      for (m = 0; m + 1 < studs.length; m++) if (Math.abs(studs[m + 1] - studs[m] - st) < 0.002) {
        nDbl++;
        for (f2 = 0; f2 < 2; f2++) sc('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, studs[m] - st / 2, yWb + wh * (f2 ? 0.69 : 0.31), -sd / 4, 1, 0, 0, us ? len80 : len100);
      }
      if (door) {
        /* THE DOOR's frame as the gable's: the kings (up to the end rafter when the header rises over the plate), the jacks, the flat header */
        for (e = -1; e <= 1; e += 2) {
          var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
          if (hdUp) {
            var ka = uk - st / 2, kb = uk + st / 2, kp = [[ka, yP0], [kb, yP0], [kb, yR(kb)], [ka, yR(ka)]];
            if (!hs) poly('king', GH.STUD, ceil2(Math.max(yR(ka), yR(kb)) - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), kp, 'xy', side.c, sd);
            sc('screw-gstud', GH.FRAME_SCREW, uk, yR(uk) - 0.035, sd / 2 - 0.005, 0, 0.95, -0.31, len100);
          } else {
            bx('king', GH.STUD, ceil2(yTP0 - yP0), id + '-king-' + (e < 0 ? 'l' : 'r'), uk, (yP0 + yTP0) / 2, 0, st, yTP0 - yP0, sd);
            for (f2 = -1; f2 <= 1; f2 += 2) sc('screw-tplate', GH.STUD_SCREW, uk, yPT, f2 * sd / 4, 0, -1, 0, len120);
          }
          bx('jack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (f2 = -1; f2 <= 1; f2 += 2) {
            sc('screw-stud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-stud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);
          }
          for (f2 = 0; f2 < 3; f2++) {
            var ykj = yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), gAll = girtWin.concat(girtStrip);
            for (var gq = 0; gq < gAll.length; gq++) if (Math.abs(ykj - gAll[gq]) < 0.05) ykj = gAll[gq] + ((ykj < gAll[gq]) ? -0.055 : 0.055);   /* clear of the strips' girts' toe screws */
            sc('screw-frame', us ? GH.TOE : GH.FRAME_SCREW, e * oL, ykj, 0, -e, 0, 0, us ? len80 : len100);
          }
          nStud += 2;
        }
        bx('header', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 0, 2 * (half + st), st, sd);
      }
      var tps = (door && hdUp) ? [[u0, -oL], [oL, u1]] : [[u0, u1]];
      for (m = 0; m < tps.length; m++) if (tps[m][1] - tps[m][0] > 0.03) bx('tplate', GH.STUD, ceil2(tps[m][1] - tps[m][0]), id + '-tplate-' + (m + 1), (tps[m][0] + tps[m][1]) / 2, yPT - st / 2, 0, tps[m][1] - tps[m][0], st, sd);
      var full = studs.concat(kings).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < full.length; m++) {
        var a = full[m], b = full[m + 1], um = (a + b) / 2, clr = b - a - st, isDoor = door && a < -half && b > half;
        if (!isDoor && clr > 0.12) sc('screw-plate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
        if (isDoor || clr < 0.05) continue;
        var gys = girtsAt(um);
        for (var gy = 0; gy < gys.length; gy++) {
          var yc = gys[gy];
          bx('girt', GH.STUD, ceil2(clr), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, 0, clr, st, sd);
          nGirt++;
          for (e = -1; e <= 1; e += 2) {
            var ue = (e < 0) ? a + st / 2 + 0.035 : b - st / 2 - 0.035, du2 = (e < 0) ? -0.8 : 0.8;
            sc('screw-girt', GH.TOE, ue, yc + st / 2, e * sd / 4, du2, -0.6, 0, len80);
            sc('screw-girt', GH.TOE, ue, yc + e * st / 4, -sd / 2, du2, 0, 0.6, len80);
          }
        }
      }
      mem[id] = full;
    }
    /* the side walls: n sashes along, a double stud under each joint, the end studs at the corners */
    var sJ = [], sStuds = [-(L / 2 - st / 2)];
    for (j = 1; j < nL; j++) sJ.push(-L / 2 + j * mod - wg / 2);
    sJ.forEach(function (z) { sStuds.push(z - st / 2, z + st / 2); });
    sStuds.push(L / 2 - st / 2);
    for (sx = -1; sx <= 1; sx += 2) wall('side-' + (sx < 0 ? 'l' : 'r'), { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx }, -L / 2, L / 2, sStuds, false, function () { return girtWin; });
    /* the back: m sashes across its full width (the corner ones on the side walls' end studs) */
    var bJ = [], bStuds = [-(gl2 - st / 2)];
    for (j = 1; j < nW; j++) bJ.push(-W / 2 + j * mod - wg / 2);
    bJ.forEach(function (x) { bStuds.push(x - st / 2, x + st / 2); });
    bStuds.push(gl2 - st / 2);
    wall('back', { ax: 'x', c: -(L / 2 - sd / 2), o: -1 }, -gl2, gl2, bStuds, false, function () { return girtWin; });
    /* the front: the door, the runs from the corners, the siding strips by the door (studs <= 60 cm / US 24 in.) */
    var fJ = [], fStuds = [-(gl2 - st / 2), gl2 - st / 2], ssp = _ghU(s, 'STUD_SP');
    for (sx = -1; sx <= 1; sx += 2) {
      for (j = 1; j <= kF; j++) fJ.push(sx * (W / 2 - j * mod + wg / 2));
      var cK = oL - st / 2, cO = kF ? Math.abs(jIn) - st / 2 : gl2 - st / 2, nAdd = Math.max(0, Math.ceil((cO - cK) / ssp - 1e-9) - 1);
      for (k = 1; k <= nAdd; k++) fStuds.push(sx * (cK + (cO - cK) * k / (nAdd + 1)));
    }
    fJ.forEach(function (x) { fStuds.push(x - st / 2, x + st / 2); });
    fStuds.sort(function (a, b) { return a - b; });
    wall('front', { ax: 'x', c: L / 2 - sd / 2, o: 1 }, -gl2, gl2, fStuds, true, function (um) { return (kF && Math.abs(um) > Math.abs(jIn)) ? girtWin : girtStrip; });
    /* the corners: three 6x100 from the gable's end stud into the side wall's */
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) scr('screw-corner', GH.FRAME_SCREW, sx * (gl2 - st), yP0 + (yTP0 - yP0) * (0.15 + 0.35 * k), sz * (L / 2 - st / 2), [sx, 0, 0], len100);

    /* THE ROOF FRAME as the gable's: a rafter pair over every joint of the side walls (and over the end studs), the ridge board */
    var zr = [{ z: -(L / 2 - st / 2), gable: true }].concat(sJ.map(function (z) { return { z: z, gable: false }; })).concat([{ z: L / 2 - st / 2, gable: true }]);
    /* v392 (Marek: krokev navic v kazdem poli) THE VENTS' BAYS chosen here, the sash bays' as the gable's (the vents for a sixth of the floor, in the inner bays):
       a MID RAFTER pair in the middle of every sash bay, on the top plate; the one under a vent stops at the purlin (the vent keeps the whole bay) */
    var vWall = (W / 2) / cs, vP = vWall / 2, vH = _ghU(s, 'VENT_S0') + st / 2, gap = GH.VENT_GAP;
    var nb = zr.length - 1, bayW = (nb > 2) ? zr[2].z - zr[1].z - st : zr[1].z - zr[0].z - st;
    var floorA = giW * giL, ventA = bayW * Math.max(0.05, vP - vH), nVps = Math.max(1, Math.ceil(floorA * GH.VENT_RATIO / ventA / 2 - 1e-9));
    var inner = [];
    for (i = 1; i < nb - 1; i++) inner.push(i);
    if (!inner.length) for (i = 0; i < nb; i++) inner.push(i);
    nVps = Math.min(nVps, inner.length);
    var ventBays = [];
    for (i = 0; i < nVps; i++) ventBays.push(inner[Math.min(inner.length - 1, Math.floor((i + 0.5) * inner.length / nVps))]);
    var zm = [];
    for (i = 0; i < nb; i++) zm.push({ z: (zr[i].z + zr[i + 1].z) / 2, b: i, short: ventBays.indexOf(i) >= 0 });
    var allZ = zr.map(function (q) { return q.z; }).concat(zm.map(function (q) { return q.z; })).sort(function (a2, b2) { return a2 - b2; });
    var rafL = ceil2((xo - xr) / cs);
    function rafPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2;
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', GH.STUD, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zr[i].z, st);
        var xm = (xh + W / 2) / 2;
        scr('screw-seat', GH.SEAT_SCREW, sx * xm, yT(xm), zr[i].z, [0, -1, 0], len200);
      }
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr('screw-rtoe', GH.TOE, s3 * xtq, yTm + k3 * s3 * 0.025, zr[i].z + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
    }
    /* v392 the mid rafters: the joints' rafter (or, under a vent, from its tail up to the purlin's lower face, cut square to the slope); a 6x120 down through
       the seat near its heel into the top plate (no stud under it), the full ones toed into the ridge board */
    var vc = vP + st / 2, x0c = vc * cs, srafL = ceil2((xo - x0c) / cs + dV * sn), dSeat = us ? 0.008 : 0.035, nMid = 0, nShort = 0;
    function srafPts(sxx) {
      var pts = [[x0c - sd * sn, yT(x0c) - sd * cs], [x0c, yT(x0c)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    for (i = 0; i < zm.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        if (zm[i].short) poly('rafter', GH.STUD, srafL, 'rafter-m' + (zm[i].b + 1) + (sx < 0 ? '-l' : '-r'), srafPts(sx), 'xy', zm[i].z, st);
        else poly('rafter', GH.STUD, rafL, 'rafter-m' + (zm[i].b + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zm[i].z, st);
        scr('screw-seat', GH.STUD_SCREW, sx * (xh + dSeat), yT(xh + dSeat), zm[i].z, [0, -1, 0], len120);
      }
      nMid++;
      if (zm[i].short) { nShort++; continue; }
      for (var s4 = -1; s4 <= 1; s4 += 2) for (var k4 = -1; k4 <= 1; k4 += 2) scr('screw-rtoe', GH.TOE, s4 * xtq, yTm + k4 * s4 * 0.025, zm[i].z + k4 * st / 2, [-s4 * tCo, 0, -k4 * tSi], len80);
    }
    box('ridge', GH.RIDGE, ceil2(L), 'ridge', 0, rgTop - P.rgd / 2, 0, P.rgt, P.rgd, L);
    var xt = Math.min(xh + (dV - sd - 0.01) / tn, W / 2 - st - 0.005), nTies = 0;
    for (i = 1; i < zr.length - 1; i += 2) {
      var zt = zr[i].z - ((zr[i].z > 0) ? 1 : -1) * st, zsd = (zr[i].z > zt) ? 1 : -1;
      box('tie', GH.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
      nTies++;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) {
          var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
          scr('screw-tie', GH.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt - zsd * st / 2, [0, 0, zsd], len80);
        }
        scr('screw-tie', GH.TIE_DOWN, sx * (xt + (W / 2 - sd)) / 2, yPT + sd, zt, [0, -1, 0], len120);
      }
    }
    var nEb = 0;
    for (i = 0; i + 1 < allZ.length; i++) {   /* v392 between every two rafters (the mid ones too) */
      var zb0 = allZ[i] + st / 2, zb1 = allZ[i + 1] - st / 2, zbc = (zb0 + zb1) / 2, ebc = zb1 - zb0;
      if (ebc < 0.03) continue;
      for (sx = -1; sx <= 1; sx += 2) {
        var ep = [[W / 2 - st, yPT], [W / 2, yPT], [W / 2, yT(W / 2)], [W / 2 - st, yT(W / 2 - st)]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) ep.reverse();
        poly('eblock', GH.STUD, ceil2(ebc), 'eblock-' + (i + 1) + (sx < 0 ? '-l' : '-r'), ep, 'xy', zbc, ebc);
        nEb++;
        for (k = -1; k <= 1; k += 2) scr('screw-eblock', GH.TOE, sx * (W / 2 - st), yPT + 0.042, zbc + k * ebc / 4, [sx * 0.45, -0.893, 0], len80);
      }
    }
    /* THE GABLE STUDS over the top plates on the gable's 60 cm (US 24 in.) grid from the middle (the door's cripple over its header) */
    var gsp = ssp, aGrid = [-(gl2 - st / 2), gl2 - st / 2];
    for (k = 0; k * gsp < gl2 - st - 0.12; k++) { aGrid.push(k * gsp); if (k) aGrid.push(-k * gsp); }
    aGrid.sort(function (a, b) { return a - b; });
    var gStuds = 0;
    for (sz = -1; sz <= 1; sz += 2) {
      var gcz = sz * (L / 2 - sd / 2);
      for (k = 0; k < aGrid.length; k++) {
        var gx = aGrid[k], ax2 = Math.abs(gx), onHd = (sz > 0) && ax2 < half - st / 2, inKing = (sz > 0) && !onHd && ax2 < oL + st / 2 + 0.005;
        if (ax2 > gl2 - st - 0.005) continue;
        if (sz > 0 && !hdUp) {
          if (onHd && yTP0 - yHt > 0.05) { box('cripple', GH.STUD, ceil2(yTP0 - yHt), 'cripple-' + Math.round(gx * 100), gx, (yHt + yTP0) / 2, gcz, st, yTP0 - yHt, sd); gStuds++; }
          onHd = false; inKing = false;
        }
        if (inKing) continue;
        var gy0 = onHd ? yHt : yPT;
        if (ax2 < xr + st / 2 + 1e-6) {
          if (rgBot - gy0 < 0.06) continue;
          box(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(rgBot - gy0), 'gstud-' + (sz < 0 ? 'b' : 'f') + '0', 0, (gy0 + rgBot) / 2, gcz, st, rgBot - gy0, sd);
          scr('screw-gstud', GH.FRAME_SCREW, 0, rgBot - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);
        } else {
          var ga = gx - st / 2, gb = gx + st / 2;
          if (Math.min(yR(ga), yR(gb)) - gy0 < 0.06) continue;
          var gp = [[ga, gy0], [gb, gy0], [gb, yR(gb)], [ga, yR(ga)]];
          poly(onHd ? 'cripple' : 'gstud', GH.STUD, ceil2(Math.max(yR(ga), yR(gb)) - gy0), 'gstud-' + (sz < 0 ? 'b' : 'f') + (gx < 0 ? 'l' : 'r') + Math.round(ax2 * 100), gp, 'xy', gcz, sd);
          scr('screw-gstud', GH.FRAME_SCREW, gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);
        }
        gStuds++;
        for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', us ? GH.TOE : GH.FRAME_SCREW, gx + e3 * st / 2, gy0 + 0.04, gcz + e3 * 3 * sd / 8, [-e3 * 0.5, -0.87, 0], us ? len80 : len100);
      }
    }

    /* THE PURLINS AND THE VENTS' HEADERS as the gable's (the vents for a sixth of the floor, in the inner bays) */
    /* v392 the vents' bays: chosen with the rafters (above) */
    var nPur = 0, vents = [];
    function rblock(kind, id, F, za, zb, v, sx2) {   /* v392 between the rafters at za and zb */
      var z0b = za + st / 2, z1b = zb - st / 2, clr2 = z1b - z0b, uc = sx2 * (z0b + z1b) / 2;
      obox(kind, GH.STUD, ceil2(clr2), id, rw(F, uc, v, -sd / 2), F.U, F.V, F.N, clr2, st, sd);
      for (var e4 = -1; e4 <= 1; e4 += 2) {
        var ub = uc + e4 * (clr2 / 2 - 0.035), du3 = e4 * 0.8;
        var pA = rw(F, ub, v + st / 2, -sd / 2 + e4 * sd / 4), dA = [F.U[0] * du3 - F.V[0] * 0.6, F.U[1] * du3 - F.V[1] * 0.6, F.U[2] * du3 - F.V[2] * 0.6];
        var pB = rw(F, ub, v + e4 * st / 4, -sd), dB = [F.U[0] * du3 + F.N[0] * 0.6, F.U[1] * du3 + F.N[1] * 0.6, F.U[2] * du3 + F.N[2] * 0.6];
        scr('screw-purlin', GH.TOE, pA[0], pA[1], pA[2], dA, len80);
        scr('screw-purlin', GH.TOE, pB[0], pB[1], pB[2], dB, len80);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      var F0 = rf(sx);
      for (i = 0; i < nb; i++) {
        if (zr[i + 1].z - zr[i].z - st < 0.05) continue;
        var sd3 = (sx < 0 ? '-l' : '-r');
        if (ventBays.indexOf(i) >= 0) {
          /* v392 a vent's bay: the purlin and the header across the whole bay, the short mid rafter under the purlin (two 6x120 down the slope through it into its end) */
          rblock('purlin', 'purlin-' + (i + 1) + sd3, F0, zr[i].z, zr[i + 1].z, vP, sx);
          nPur++;
          rblock('vhead', 'vhead-' + (i + 1) + sd3, F0, zr[i].z, zr[i + 1].z, vH, sx);
          vents.push({ sx: sx, i: i, z0: zr[i].z, z1: zr[i + 1].z });
          for (k = 0; k < 2; k++) { var pTm = rw(F0, sx * zm[i].z, vP - st / 2, -sd * (k ? 0.55 : 0.3)); scr('screw-purlin', GH.STUD_SCREW, pTm[0], pTm[1], pTm[2], F0.V, len120); }
        } else {
          /* v392 the purlin in two: either side of the mid rafter */
          rblock('purlin', 'purlin-' + (i + 1) + 'a' + sd3, F0, zr[i].z, zm[i].z, vP, sx);
          rblock('purlin', 'purlin-' + (i + 1) + 'b' + sd3, F0, zm[i].z, zr[i + 1].z, vP, sx);
          nPur += 2;
        }
      }
    }
    /* THE FASCIA as the gable's */
    var zfE = L / 2 + gl + tt, eLen = 2 * zfE;
    for (sx = -1; sx <= 1; sx += 2) {
      box('fascia', GH.BOARD, ceil2(eLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, 0, tt, cw, eLen);
      for (i = 0; i < allZ.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', GH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), allZ[i], [-sx, 0, 0], len50);   /* v392 + the mid rafters' tails */
    }

    /* THE SKIN: the panel siding under the sashes all round (the front's
       strips by the door up to the band's top, the door cut out); the
       twinwall on the gable triangles over the band, the roof, its cap */
    var polyA = 0, sidingA = 0, tapeS = 0, tapeV = 0, as2 = W / 2 + sg;
    function tally(area, sh) { polyA += area; tapeS += sh.tape.solid; tapeV += sh.tape.vent; }
    for (sx = -1; sx <= 1; sx += 2) sidingA += sheet('siding', GH.SIDING, 'siding-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, yBB], [L / 2, yBB], [L / 2, yWb], [-L / 2, yWb]], null, [sx * W / 2, 0, 0], [0, 0, -sx], [0, 1, 0], [sx, 0, 0], sg, null);
    sidingA += sheet('siding', GH.SIDING, 'siding-b', [[-as2, yBB], [as2, yBB], [as2, yWb], [-as2, yWb]], null, [0, 0, -L / 2], [-1, 0, 0], [0, 1, 0], [0, 0, -1], sg, null);
    var fOp = [{ x0: -half, x1: half, y: yBt }];
    for (sx = -1; sx <= 1; sx += 2) for (j = 0; j < kF; j++) {
      var xA = W / 2 - (j + 1) * ww - j * wg, xB = (j === 0) ? as2 : W / 2 - j * mod;
      fOp.push((sx > 0) ? { x0: xA, x1: xB, y: yWb } : { x0: -xB, x1: -xA, y: yWb });
    }
    fOp.sort(function (a, b) { return b.x1 - a.x1; });
    var fpts = [[-as2, yBB], [as2, yBB]], cxo = as2;
    function fpush(Pt) { var q = fpts[fpts.length - 1]; if (Math.abs(q[0] - Pt[0]) > 1e-9 || Math.abs(q[1] - Pt[1]) > 1e-9) fpts.push(Pt); }
    fOp.forEach(function (op) {
      if (op.x1 < cxo - 1e-9) { fpush([cxo, yWt]); fpush([op.x1, yWt]); }
      fpush([op.x1, op.y]); fpush([op.x0, op.y]); cxo = op.x0;
    });
    if (cxo > -as2 + 1e-9) { fpush([cxo, yWt]); fpush([-as2, yWt]); }
    sidingA += sheet('siding', GH.SIDING, 'siding-f', fpts, null, [0, 0, L / 2], [1, 0, 0], [0, 1, 0], [0, 0, 1], sg, null);
    var ag = W / 2 + wt, gTop = [[ag, yT(ag)], [0, yT(0)], [-ag, yT(ag)]];
    tally(sheet('glaze-wall', null, 'glaze-b', [[-ag, yWt], [ag, yWt]].concat(gTop), null, [0, 0, -L / 2], [-1, 0, 0], [0, 1, 0], [0, 0, -1], gl, 1), sheets[sheets.length - 1]);
    var gpF = (yHd > yWt + 0.005) ? [[-ag, yWt], [-half, yWt], [-half, yHd], [half, yHd], [half, yWt], [ag, yWt]].concat(gTop) : [[-ag, yWt], [ag, yWt]].concat(gTop);
    tally(sheet('glaze-wall', null, 'glaze-f', gpF, null, [0, 0, L / 2], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1), sheets[sheets.length - 1]);
    var vEnd = xe / cs + _ghU(s, 'GL_OVER'), uR = L / 2 + gl;
    for (sx = -1; sx <= 1; sx += 2) {
      var F1 = rf(sx), rh = [];
      for (j = 0; j < vents.length; j++) if (vents[j].sx === sx) {
        var hu0 = (sx > 0) ? vents[j].z0 : -vents[j].z1, hu1 = (sx > 0) ? vents[j].z1 : -vents[j].z0;
        rh.push([[hu0, vH], [hu0, vP], [hu1, vP], [hu1, vH]]);
      }
      tally(sheet('glaze-roof', null, 'glaze-roof-' + (sx < 0 ? 'l' : 'r'), [[-uR, 0], [-uR, vEnd], [uR, vEnd], [uR, 0]], rh, F1.o, F1.U, F1.V, F1.N, gl, -1), sheets[sheets.length - 1]);
      var capW = _ghU(s, 'CAP_W');
      sheet('cap', GH.CAP, 'cap-' + (sx < 0 ? 'l' : 'r'), [[-zfE, 0], [-zfE, capW], [zfE, capW], [zfE, 0]], null, add3(F1.o, F1.N, gl), F1.U, F1.V, F1.N, GH.CAP_T, null);
    }
    var capScrews = 2 * (Math.ceil(eLen / _ghU(s, 'CAP_FIX') - 1e-9) + 1);

    /* THE SASHES: stiles, rails, muntins, a pane in each lite; three 6x80
       through each inner stile into its stud, two through the bottom rail
       into the sill girt (the corner stiles held by the corner boards' screws) */
    var nWin = 0, cols = (ww > 0.85) ? 3 : 2, rows = Math.max(2, Math.round(wh / 0.42)), lw = (ww - 2 * sw - (cols - 1) * mw) / cols, lh = (wh - rb - sw - (rows - 1) * mw) / rows, gPane = 0.003;
    var bandYs = [0.12, 0.5, 0.88].map(function (f) { return yWb + rb + (wh - rb - sw) * f; });
    function sash(face, ua, ub, id, scrA, scrB) {
      function pt(u, y, n) { return (face.ax === 'z') ? [face.s * (W / 2 + n), y, u] : [u, y, face.s * (L / 2 + n)]; }
      function mb(kind, u0, u1, y0, y1, idp) {
        var C = pt((u0 + u1) / 2, (y0 + y1) / 2, wt / 2);
        if (face.ax === 'z') box(kind, null, 0, id + idp, C[0], C[1], C[2], wt, y1 - y0, u1 - u0); else box(kind, null, 0, id + idp, C[0], C[1], C[2], u1 - u0, y1 - y0, wt);
      }
      mb('sash', ua, ua + sw, yWb, yWt, '-stile-a');
      mb('sash', ub - sw, ub, yWb, yWt, '-stile-b');
      mb('sash', ua + sw, ub - sw, yWb, yWb + rb, '-rail-b');
      mb('sash', ua + sw, ub - sw, yWt - sw, yWt, '-rail-t');
      var vu = [], c2, r2;
      for (c2 = 1; c2 < cols; c2++) { var m0 = ua + sw + c2 * lw + (c2 - 1) * mw; vu.push(m0); mb('muntin', m0, m0 + mw, yWb + rb, yWt - sw, '-mv' + c2); }
      var lo = [ua + sw].concat(vu.map(function (m1) { return m1 + mw; })), hi = vu.concat([ub - sw]);
      for (r2 = 1; r2 < rows; r2++) { var y0m = yWb + rb + r2 * lh + (r2 - 1) * mw; for (c2 = 0; c2 < cols; c2++) mb('muntin', lo[c2], hi[c2], y0m, y0m + mw, '-mh' + r2 + '-' + c2); }
      for (r2 = 0; r2 < rows; r2++) for (c2 = 0; c2 < cols; c2++) {
        var py0 = yWb + rb + r2 * (lh + mw), py1 = py0 + lh, o3, U3, N3, q0, q1;
        if (face.ax === 'z') { o3 = [face.s * (W / 2 + wt / 2 - gPane / 2), 0, 0]; U3 = [0, 0, -face.s]; N3 = [face.s, 0, 0]; q0 = -face.s * lo[c2]; q1 = -face.s * hi[c2]; }
        else { o3 = [0, 0, face.s * (L / 2 + wt / 2 - gPane / 2)]; U3 = [face.s, 0, 0]; N3 = [0, 0, face.s]; q0 = face.s * lo[c2]; q1 = face.s * hi[c2]; }
        var uu0 = Math.min(q0, q1), uu1 = Math.max(q0, q1);
        sheets.push({ kind: 'glass', code: null, id: id + '-pane-' + r2 + '-' + c2, pts: [[uu0, py0], [uu1, py0], [uu1, py1], [uu0, py1]], holes: null, o: o3, U: U3, V: [0, 1, 0], N: N3, t: gPane, area: (uu1 - uu0) * (py1 - py0), tape: { solid: 0, vent: 0 } });
      }
      function sScr(u, y) { var A = pt(u, y, wt), d = (face.ax === 'z') ? [-face.s, 0, 0] : [0, 0, -face.s]; scr('screw-sash', GH.TOE, A[0], A[1], A[2], d, len80); }
      if (scrA != null) bandYs.forEach(function (y) { sScr(scrA, y); });
      if (scrB != null) bandYs.forEach(function (y) { sScr(scrB, y); });
      sScr(ua + ww / 4, yWb + st / 4); sScr(ub - ww / 4, yWb + st / 4);
      nWin++;
    }
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < nL; i++) {
      var za = -L / 2 + i * mod, zb = za + ww;
      sash({ ax: 'z', s: sx }, za, zb, 'sash-' + (sx < 0 ? 'l' : 'r') + (i + 1), i ? za - wg / 2 + st / 2 : null, (i < nL - 1) ? zb + wg / 2 - st / 2 : null);
    }
    for (i = 0; i < nW; i++) {
      var xa2 = -W / 2 + i * mod, xb2 = xa2 + ww;
      sash({ ax: 'x', s: -1 }, xa2, xb2, 'sash-b' + (i + 1), i ? xa2 - wg / 2 + st / 2 : null, (i < nW - 1) ? xb2 + wg / 2 - st / 2 : null);
    }
    for (sx = -1; sx <= 1; sx += 2) for (j = 0; j < kF; j++) {
      var xr0 = W / 2 - (j + 1) * ww - j * wg, xr1 = W / 2 - j * mod;   /* the right run's; the left one mirrored */
      if (sx > 0) sash({ ax: 'x', s: 1 }, xr0, xr1, 'sash-fr' + (j + 1), xr0 - wg / 2 + st / 2, j ? xr1 + wg / 2 - st / 2 : null);
      else sash({ ax: 'x', s: 1 }, -xr1, -xr0, 'sash-fl' + (j + 1), j ? -xr1 - wg / 2 + st / 2 : null, -xr0 + wg / 2 - st / 2);
    }
    var szTxt = us ? Math.round(ww / 0.0254) + ' X ' + Math.round(wh / 0.0254) + ' IN.' : Math.round(ww * 100) + ' X ' + Math.round(wh * 100) + ' CM';
    missing.push({ name: GH.SASH_NAME + ', ' + szTxt, qty: nWin, unit: 'pcs' });

    /* THE TRIM: 1x4 over the sashes' face, screwed 6x80 through to the framing */
    var xaT = W / 2 + wt, zaT = L / 2 + wt, nTrim = 0, trimFix = _ghU(s, 'FIX_SP');
    var cTopS = yR(xaT + tt) - 0.003, cTopG = yWt - cw / 2;
    function tScr(x, y, z, d) { scr('screw-trim', GH.TOE, x, y, z, d, len80); }
    /* the corner boards: the gable's board lapping the side's edge, the side's up under the rafter tail, the gable's up to the head board */
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      box('trim', GH.BOARD, ceil2(cTopG - yBB), 'trim-g-' + sx + sz, sx * (xaT + tt - cw / 2), (yBB + cTopG) / 2, sz * (zaT + tt / 2), cw, cTopG - yBB, tt);
      box('trim', GH.BOARD, ceil2(cTopS - yBB), 'trim-s-' + sx + sz, sx * (xaT + tt / 2), (yBB + cTopS) / 2, sz * (zaT - cw / 2), tt, cTopS - yBB, cw);
      nTrim += 2;
      fixPts(yBB + 0.08, cTopG - 0.08, trimFix).forEach(function (y) { tScr(sx * (W / 2 - 0.012), y, sz * (zaT + tt), [0, 0, -sz]); });
      fixPts(yBB + 0.13, cTopS - 0.08, trimFix).forEach(function (y) { tScr(sx * (xaT + tt), y, sz * (L / 2 - 0.012), [-sx, 0, 0]); });
    }
    /* screws at the bays' middles (the girts behind, clear of the studs' and girts' own) */
    function bayScr(M, a, b, cb) {
      for (var q = 0; q + 1 < M.length; q++) {
        var a2 = M[q] + st / 2, b2 = M[q + 1] - st / 2, cl2 = b2 - a2, um2 = (a2 + b2) / 2;
        if (cl2 < 0.25 || um2 < a + 0.03 || um2 > b - 0.03) continue;
        ((cl2 > 0.7) ? [um2 - cl2 / 4, um2 + cl2 / 4] : [um2]).forEach(cb);
      }
    }
    /* the sill boards over the sashes' bottom edge (between the corner boards; the front's to the door's casings) */
    var nBelt = 0, yBs = yWb - st / 4, xbE = xaT + tt - cw;
    var belts = [];
    for (sx = -1; sx <= 1; sx += 2) belts.push({ ax: 'z', c: sx * (xaT + tt / 2), o: sx, a: -(zaT - cw), b: zaT - cw, id: 'belt-' + (sx < 0 ? 'l' : 'r'), mem: mem['side-' + (sx < 0 ? 'l' : 'r')] });
    belts.push({ ax: 'x', c: -(zaT + tt / 2), o: -1, a: -xbE, b: xbE, id: 'belt-b', mem: mem.back });
    belts.push({ ax: 'x', c: zaT + tt / 2, o: 1, a: -xbE, b: -(half + cw), id: 'belt-fl', mem: mem.front });
    belts.push({ ax: 'x', c: zaT + tt / 2, o: 1, a: half + cw, b: xbE, id: 'belt-fr', mem: mem.front });
    belts.forEach(function (bp) {
      var bl2 = bp.b - bp.a, bm2 = (bp.a + bp.b) / 2;
      if (bl2 < 0.05) return;
      if (bp.ax === 'z') box('belt', GH.BOARD, ceil2(bl2), bp.id, bp.c, yWb, bm2, tt, cw, bl2); else box('belt', GH.BOARD, ceil2(bl2), bp.id, bm2, yWb, bp.c, bl2, cw, tt);
      nBelt++;
      var nf = bp.c + bp.o * tt / 2;
      bayScr(bp.mem, bp.a, bp.b, function (w3) { if (bp.ax === 'z') tScr(nf, yBs, w3, [-bp.o, 0, 0]); else tScr(w3, yBs, nf, [0, 0, -bp.o]); });
    });
    /* the head boards over the sashes' top on the gables (the sides' tops are under the rafter tails), screwed into the top plate */
    var nHead = 0, yHs = yPT - st / 2, heads = [{ c: -(zaT + tt / 2), o: -1, a: -(xaT + tt), b: xaT + tt, id: 'head-b', mem: mem.back },
      { c: zaT + tt / 2, o: 1, a: -(xaT + tt), b: -(half + cw), id: 'head-fl', mem: mem.front }, { c: zaT + tt / 2, o: 1, a: half + cw, b: xaT + tt, id: 'head-fr', mem: mem.front }];
    heads.forEach(function (hp) {
      var hl = hp.b - hp.a;
      if (hl < 0.05) return;
      box('head', GH.BOARD, ceil2(hl), hp.id, (hp.a + hp.b) / 2, yWt, hp.c, hl, cw, tt);
      nHead++;
      bayScr(hp.mem, hp.a, hp.b, function (w3) { if (avoid(w3, aGrid, st / 2 + 0.07) && Math.abs(w3) > oL + 0.05) tScr(w3, yHs, hp.c + hp.o * tt / 2, [0, 0, -hp.o]); });
    });
    /* the battens over the joints, nailed into both stiles (the front's run ends into its own sash only) */
    var nBat = 0;
    function batten(face, u, yA, yB, id, sides) {
      var bl3 = yB - yA;
      if (bl3 < 0.05) return;
      if (face.ax === 'z') box('batten', GH.BOARD, ceil2(bl3), id, face.s * (xaT + tt / 2), (yA + yB) / 2, u, tt, bl3, cw);
      else box('batten', GH.BOARD, ceil2(bl3), id, u, (yA + yB) / 2, face.s * (zaT + tt / 2), cw, bl3, tt);
      nBat++;
      fixPts(yA + 0.05, yB - 0.05, trimFix).forEach(function (y) {
        sides.forEach(function (e) {
          var uu = u + e * (wg / 2 + 0.008);
          if (face.ax === 'z') scr('nail-trim', GH.TRIM_NAIL, face.s * (xaT + tt), y, uu, [-face.s, 0, 0], len32, 0.0012);
          else scr('nail-trim', GH.TRIM_NAIL, uu, y, face.s * (zaT + tt), [0, 0, -face.s], len32, 0.0012);
        });
      });
    }
    for (sx = -1; sx <= 1; sx += 2) sJ.forEach(function (z, q) { batten({ ax: 'z', s: sx }, z, yWb + cw / 2, cTopS, 'batten-' + (sx < 0 ? 'l' : 'r') + (q + 1), [-1, 1]); });
    bJ.forEach(function (x, q) { batten({ ax: 'x', s: -1 }, x, yWb + cw / 2, cTopG, 'batten-b' + (q + 1), [-1, 1]); });
    fJ.forEach(function (x, q) { batten({ ax: 'x', s: 1 }, x, yWb + cw / 2, cTopG, 'batten-f' + (q + 1), (Math.abs(Math.abs(x) - Math.abs(jIn)) < 1e-6) ? [(x > 0) ? 1 : -1] : [-1, 1]); });
    /* THE RAKE BOARDS as the gable's */
    var glV = gl / cs, cwV = cw / cs, rakeL = ceil2(xo / cs);
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var rp = [[0, yT(0) + glV], [xo, yT(xo) + glV], [xo, yT(xo) + glV - cwV], [0, yT(0) + glV - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) rp.reverse();
      poly('rake', GH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), rp, 'xy', sz * (L / 2 + gl + tt / 2), tt);
      var rx = fixPts(0.10, xo - 0.05, _ghU(s, 'FIX_SP'));
      for (k = 0; k < rx.length; k++) scr('screw-rake', GH.FASCIA_SCREW, sx * rx[k], yT(rx[k]) - 0.03, sz * (L / 2 + gl + tt), [0, 0, -sz], len50);
    }
    /* THE CASINGS round the door on the siding's plane, screwed into the jacks / kings and the header */
    var zC = L / 2 + sg;
    var casL = [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, RO + 2 * cw]];
    casL.forEach(function (c4) {
      var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
      box('casing', GH.BOARD, ceil2(horiz ? du : dy), 'casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
      if (horiz) fixPts(-(oL - len120) + 0.04, oL - len120 - 0.04, trimFix).filter(function (w2) { return avoid(w2, aGrid, st / 2 + 0.07); }).forEach(function (w2) { tScr(w2, yHd + st / 2, zC + tt, [0, 0, -1]); });
      else fixPts(c4[2] + 0.08, c4[3] - 0.06, trimFix).forEach(function (w2) { for (var e5 = -1; e5 <= 1; e5 += 2) tScr(c4[1] + e5 * cw / 4, w2, zC + tt, [0, 0, -1]); });
    });

    /* THE DOOR as the gable's */
    var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2, hinges = 0;
    var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
    for (sx = -1; sx <= 1; sx += 2) box('dframe', GH.FRAME, ceil2(dH), 'door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
    for (k = 0; k < 3; k++) {
      box('dframe', GH.FRAME, ceil2(rW), 'door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
      for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-door', GH.STUD_SCREW, sx * dW / 2, railY[k] + e7 * fw / 4, zDc, [-sx, 0, 0], len120);
    }
    function dbrace(idB, yA, yB2) {
      var xA = -dW / 2 + fw, xB = dW / 2 - fw, dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
      var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xA); pb = _gzClip(pb, -1, 0, xB);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('dbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
      var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
      if (xLo.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
      if (xHi.length) scr('screw-door', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
    }
    dbrace('door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
    dbrace('door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
    var dgA = sheet('glaze-door', null, 'glaze-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], null, [0, 0, zD1], [1, 0, 0], [0, 1, 0], [0, 0, 1], gl, 1);
    tally(dgA, sheets[sheets.length - 1]);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k++) {
      var hy = railY[k];
      hw.push({ kind: 'hinge', code: GH.HINGE, box: [-dW / 2 + hingeLen / 2, hy, zD1 + gl + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-half - cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', GH.HINGE_SCREW, -dW / 2 + 0.035 + i * 0.10, hy, zD1 + gl + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', GH.HINGE_SCREW, -half - cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: GH.KNOB, cyl: [dW / 2 - fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + gl, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: GH.CATCH, box: [dW / 2 - 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* THE ROOF VENTS as the gable's */
    var aV = GH.VENT_ANG * Math.PI / 180, ca = Math.cos(aV), sa = Math.sin(aV), ventAreaSum = 0;
    for (j = 0; j < vents.length; j++) {
      var vt = vents[j], F2 = rf(vt.sx), vid = 'vent-' + (vt.i + 1) + (vt.sx < 0 ? '-l' : '-r');
      var uA = (vt.sx > 0) ? vt.z0 : -vt.z1, uB = (vt.sx > 0) ? vt.z1 : -vt.z0;
      var V2 = [F2.V[0] * ca + F2.N[0] * sa, F2.V[1] * ca + F2.N[1] * sa, F2.V[2] * ca + F2.N[2] * sa];
      var N2 = [-F2.V[0] * sa + F2.N[0] * ca, -F2.V[1] * sa + F2.N[1] * ca, -F2.V[2] * sa + F2.N[2] * ca];
      var Hl = rw(F2, 0, vH, gl);
      var sw2 = function (u, dv, dn) { return [Hl[0] + F2.U[0] * u + V2[0] * dv + N2[0] * dn, Hl[1] + F2.U[1] * u + V2[1] * dv + N2[1] * dn, Hl[2] + F2.U[2] * u + V2[2] * dv + N2[2] * dn]; };
      var gu0 = uA + gap, gu1 = uB - gap, gv1 = vP - vH - gap;
      var fu0 = uA + st / 2 + gap, fu1 = uB - st / 2 - gap, fv0 = st / 2 + gap, fv1 = vP - vH - st / 2 - gap, fL = fv1 - fv0, fWd = fu1 - fu0;
      for (k = -1; k <= 1; k += 2) {
        var usc = (k < 0) ? fu0 + fw / 2 : fu1 - fw / 2;
        obox('vframe', GH.FRAME, ceil2(fL), vid + '-stile-' + (k < 0 ? 'a' : 'b'), sw2(usc, (fv0 + fv1) / 2, -gl - ft / 2), F2.U, V2, N2, fw, fL, ft);
      }
      var vRails = [fv0 + fw / 2, fv1 - fw / 2];
      for (k = 0; k < 2; k++) {
        obox('vframe', GH.FRAME, ceil2(fWd - 2 * fw), vid + '-rail-' + (k + 1), sw2((fu0 + fu1) / 2, vRails[k], -gl - ft / 2), F2.U, V2, N2, fWd - 2 * fw, fw, ft);
        for (var e8 = -1; e8 <= 1; e8 += 2) for (var e9 = -1; e9 <= 1; e9 += 2) {
          var pv = sw2((e8 < 0) ? fu0 : fu1, vRails[k] + e9 * fw / 4, -gl - ft / 2);
          scr('screw-vframe', GH.STUD_SCREW, pv[0], pv[1], pv[2], [-e8 * F2.U[0], -e8 * F2.U[1], -e8 * F2.U[2]], len120);
        }
      }
      var sgA = sheet('glaze-vent', null, vid + '-glaze', [[gu0, 0], [gu0, gv1], [gu1, gv1], [gu1, 0]].map(function (Pt) { return [Pt[0], Pt[1] + gap]; }), null, sw2(0, 0, -gl), F2.U, V2, N2, gl, -1);
      tally(sgA, sheets[sheets.length - 1]);
      ventAreaSum += (uB - uA) * (vP - vH);
      for (k = -1; k <= 1; k += 2) {
        var hu = (k < 0) ? gu0 + 0.08 : gu1 - 0.08, hLs = 0.18, hLb = 0.06;
        obox('vhinge', GH.HINGE, 0, vid + '-hinge-' + (k < 0 ? 'a' : 'b'), sw2(hu, gap + hLs / 2, hT / 2), F2.U, V2, N2, hingeW, hLs, hT);
        obox('vhinge', null, 0, vid + '-hinge-leaf-' + (k < 0 ? 'a' : 'b'), rw(F2, hu, vH - hLb / 2, gl + hT / 2), F2.U, F2.V, F2.N, hingeW * 1.6, hLb, hT);
        hinges++;
        for (i = 0; i < 3; i++) {
          var hp1 = sw2(hu, gap + st / 2 + fw * (0.15 + 0.35 * i), hT), hp2 = rw(F2, hu + (i - 1) * 0.01, vH - 0.015, gl + hT);
          scr('screw-vhinge', GH.HINGE_SCREW, hp1[0], hp1[1], hp1[2], [-N2[0], -N2[1], -N2[2]], len40, 0.0022);
          scr('screw-vhinge', GH.HINGE_SCREW, hp2[0], hp2[1], hp2[2], [-F2.N[0], -F2.N[1], -F2.N[2]], len40, 0.0022);
        }
      }
      var oA = rw(F2, (uA + uB) / 2, vP - st / 2 - 0.02, -sd * 0.7), oB = sw2((uA + uB) / 2, vRails[1], -gl - ft);
      var od = [oB[0] - oA[0], oB[1] - oA[1], oB[2] - oA[2]], oLn = Math.sqrt(od[0] * od[0] + od[1] * od[1] + od[2] * od[2]), oU = [od[0] / oLn, od[1] / oLn, od[2] / oLn];
      var oX = F2.U, oN = [oU[1] * oX[2] - oU[2] * oX[1], oU[2] * oX[0] - oU[0] * oX[2], oU[0] * oX[1] - oU[1] * oX[0]];
      obox('opener', null, 0, vid + '-opener', [(oA[0] + oB[0]) / 2, (oA[1] + oB[1]) / 2, (oA[2] + oB[2]) / 2], oX, oU, oN, 0.03, oLn, 0.03);
    }
    if (polyA > 0) missing.push({ name: GH.POLY_NAME, qty: Math.round(polyA * GH.WASTE * 100) / 100, unit: 'm2' });
    if (tapeV > 0) missing.push({ name: GH.VTAPE_NAME, qty: Math.round(tapeV * 100) / 100, unit: 'm' });
    if (vents.length) missing.push({ name: GH.OPENER_NAME, qty: vents.length, unit: 'pcs' });

    /* the bill's quantities as the gable's (the sashes carry no code: neither billed nor coated) */
    var m3 = {}, coat = sidingA;
    var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.RIDGE] = 2 * (P.rgt + P.rgd); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw); per[GH.TRIM] = 2 * (tt + P.tw);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    /* v392 the benches' runs: along both side walls inside the framing, the door's approach kept clear */
    var bClr = _ghU(s, 'BN_CLR'), bEnd = _ghU(s, 'BN_END'), bApp = _ghU(s, 'BN_APP'), bX = W / 2 - sd - bClr, bZ = L / 2 - sd - bEnd;
    var benchSpec = { inner: 2 * bX, runs: [{ id: 'l', ax: 'z', c: -bX, o: 1, a: -bZ, b: bZ, pair: 'l' }, { id: 'r', ax: 'z', c: bX, o: -1, a: -bZ, b: bZ, pair: 'r' }],
                      keep: [{ x0: -half - 0.05, x1: half + 0.05, z0: L / 2 - sd - bApp, z1: L / 2 }] };
    return {
      benchSpec: benchSpec, mids: nMid, midsShort: nShort,
      P: P, us: us, knee: true, oldwin: true, L: L, W: W, pieces: pieces, fas: fas, hw: hw, sheets: sheets, gscrews: gscrews, uheads: uheads, found: found, blocks: blocks, pours: pours, missing: missing,
      meters: m3, coat: coat, polyA: polyA, sidingA: sidingA, tapeSolid: tapeS, tapeVent: tapeV, capL: eLen, capScrews: capScrews, hinges: hinges,
      gravelM3: r3(gravelM3), digM3: r3(gravelM3), floorA: floorA, rafters: zr, ties: nTies, eBlocks: nEb, gStuds: gStuds, girts: nGirt, studs: nStud, purlins: nPur,
      vents: vents.length, ventA: ventAreaSum, trims: nTrim, belts: nBelt, heads: nHead, battens: nBat, doorW: dW, doorH: dH, RO: RO, hdUp: hdUp,
      windows: nWin, winW: ww, winH: wh, winI: Wn.i, nSide: nL, nBack: nW, nFront: 2 * kF, dbl: nDbl, yWb: yWb, yWt: yWt,
      yBB: yBB, yBt: yBt, yPT: yPT, yK: yWb, ridgeTop: rgTop, pitch: GH.PITCH, rafL: rafL, roofLen: eLen, slope: vEnd,
      top: yT(0) + gl / cs + 0.01, height: yT(0) + gl / cs + 0.01, depth: W, length: L, extX: xe + _ghU(s, 'GL_OVER') * cs, extZ: zfE
    };
  }
  /* its staged assembly: the gable's order, the sashes after the siding (their screws next), the trims after the glazing */
  var _ghOldStepsC = null;
  function _ghOldSteps(s) {
    if (_ghOldStepsC) return _ghOldStepsC;
    return (_ghOldStepsC = [
      { parts: [], codes: [] },
      { parts: ['gh-block'], codes: [GH.GRAVEL, GH.FD_BLOCK] },                                                          /* v399 precast pads */
      { parts: ['gh-pour'], codes: [GH.DIG, GH.GRAVEL, GH.FD_GEOTEX, GH.FD_FORMWORK, GH.FD_REBAR, GH.FD_CONCRETE] },     /* v399 poured footings */
      { parts: ['gh-gscrew'], codes: [GH.GSCREW] },
      { parts: ['gh-uhead'], codes: [GH.UHEAD] },
      { parts: ['gh-uanchor'], codes: [GH.FD_UANCHOR] },   /* v399 the footings' wet-set anchors */
      { parts: ['gh-base'], codes: [GH.BASE] },
      { parts: ['gh-hw-screw-base'], codes: [GH.BASE_SCREW] },
      { parts: ['gh-hw-nail-uhead'], codes: [GH.UNAIL] },
      { parts: ['gh-gravel'], codes: [GH.DIG, GH.GRAVEL] },
      { parts: ['gh-plate'], codes: [GH.STUD] },
      { parts: ['gh-stud', 'gh-king', 'gh-jack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-stud'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-header'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-frame'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['gh-tplate'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tplate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-plate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-corner'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-girt'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-girt'], codes: [GH.TOE] },
      { parts: ['gh-rafter'], codes: [GH.STUD] },
      { parts: ['gh-ridge'], codes: [GH.RIDGE] },
      { parts: ['gh-hw-screw-seat'], codes: [GH.SEAT_SCREW, GH.STUD_SCREW] },   /* v392 + the mid rafters' */
      { parts: ['gh-hw-screw-rtoe'], codes: [GH.TOE] },
      { parts: ['gh-tie'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tie'], codes: [GH.TIE_SCREW, GH.TIE_DOWN] },
      { parts: ['gh-eblock'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-eblock'], codes: [GH.TOE] },
      { parts: ['gh-gstud', 'gh-cripple'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-gstud'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-purlin', 'gh-vhead'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-purlin'], codes: [GH.TOE, GH.STUD_SCREW] },   /* v392 + through the vents' purlins into the short mid rafters */
      { parts: ['gh-fascia'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-fascia'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-siding'], codes: [GH.SIDING, GH.SIDING_SCREW] },
      { parts: ['gh-sash', 'gh-muntin', 'gh-glass'], codes: [], lk: ['windows'] },   /* the reclaimed sashes: no catalogue row -- the step's name from the locales */
      { parts: ['gh-hw-screw-sash'], codes: [GH.TOE] },
      { parts: ['gh-glaze-wall'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-glaze-roof'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-cap'], codes: [GH.CAP, GH.GL_SCREW] },
      { parts: ['gh-trim', 'gh-belt', 'gh-head', 'gh-casing'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-trim'], codes: [GH.TOE] },
      { parts: ['gh-batten'], codes: [GH.BOARD] },
      { parts: ['gh-hw-nail-trim'], codes: [GH.TRIM_NAIL] },
      { parts: ['gh-rake'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-rake'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-dframe'], codes: [GH.FRAME] },
      { parts: ['gh-dbrace'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-door'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-door'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-hinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-hinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-knob'], codes: [GH.KNOB] },
      { parts: ['gh-catch'], codes: [GH.CATCH] },
      { parts: ['gh-vframe'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-vframe'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-vent'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-vhinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-vhinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-opener'], codes: [] },
      { parts: ['gh-bleg', 'gh-brail'], codes: [GH.FRAME], lk: ['bench_gh_tables'] },   /* v392 the benches (off: not drawn, the steps drop out) */
      { parts: ['gh-hw-screw-brail'], codes: [GH.TOE] },
      { parts: ['gh-bslat'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-bslat'], codes: [GH.FASCIA_SCREW] }
    ]);
  }
  /* its staged assembly: one catalogue item a step, the screws that fix it
     the step after (a step whose parts this build does not draw -- the knee
     wall's without it -- drops out); the glazing steps name the tape and
     the sealing screws while the sheet has no catalogue row */
  var _ghStepsC = null;
  function _ghSteps(s) {
    if (_ghHoop(s)) return _ghHoopSteps(s);   /* v381 the hoop house: its own */
    if (_ghAframe(s)) return _ghAframeSteps(s);   /* v384 the A-frame: its own */
    if (_ghVict(s)) return _ghVictSteps(s);   /* v387 the Victorian: its own */
    if (_ghOld(s)) return _ghOldSteps(s);   /* v390 the old-window greenhouse: its own */
    if (_ghStepsC) return _ghStepsC;
    return (_ghStepsC = [
      { parts: [], codes: [] },
      { parts: ['gh-block'], codes: [GH.GRAVEL, GH.FD_BLOCK] },                                                          /* v399 precast pads */
      { parts: ['gh-pour'], codes: [GH.DIG, GH.GRAVEL, GH.FD_GEOTEX, GH.FD_FORMWORK, GH.FD_REBAR, GH.FD_CONCRETE] },     /* v399 poured footings */
      { parts: ['gh-gscrew'], codes: [GH.GSCREW] },
      { parts: ['gh-uhead'], codes: [GH.UHEAD] },
      { parts: ['gh-uanchor'], codes: [GH.FD_UANCHOR] },   /* v399 the footings' wet-set anchors */
      { parts: ['gh-base'], codes: [GH.BASE] },
      { parts: ['gh-hw-screw-base'], codes: [GH.BASE_SCREW] },
      { parts: ['gh-hw-nail-uhead'], codes: [GH.UNAIL] },
      { parts: ['gh-gravel'], codes: [GH.DIG, GH.GRAVEL] },
      { parts: ['gh-plate'], codes: [GH.STUD] },
      { parts: ['gh-stud', 'gh-king', 'gh-jack'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-stud'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-header'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-frame'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['gh-tplate'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tplate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-plate'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-hw-screw-corner'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-girt'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-girt'], codes: [GH.TOE] },
      { parts: ['gh-bracket'], codes: [GH.BRACKET] },                  /* v378 the lean-to: the brackets to the house, */
      { parts: ['gh-hw-screw-bracket'], codes: [GH.BRK_SCREW] },       /* -- into the back wall's studs, */
      { parts: ['gh-hw-screw-anchor'], codes: [GH.ANCHOR] },           /* -- into the house wall */
      { parts: ['gh-rafter'], codes: [GH.STUD] },
      { parts: ['gh-ridge'], codes: [GH.RIDGE] },
      { parts: ['gh-hw-screw-seat'], codes: [GH.SEAT_SCREW] },
      { parts: ['gh-hw-screw-rtoe'], codes: [GH.TOE] },
      { parts: ['gh-tie'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-tie'], codes: [GH.TIE_SCREW, GH.TIE_DOWN] },
      { parts: ['gh-eblock'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-eblock'], codes: [GH.TOE] },
      { parts: ['gh-gstud', 'gh-cripple'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-gstud'], codes: [GH.FRAME_SCREW] },
      { parts: ['gh-purlin', 'gh-vhead'], codes: [GH.STUD] },
      { parts: ['gh-hw-screw-purlin'], codes: [GH.TOE] },
      { parts: ['gh-fascia'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-fascia'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-siding'], codes: [GH.SIDING, GH.SIDING_SCREW] },
      { parts: ['gh-glaze-wall'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-glaze-roof'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-cap'], codes: [GH.CAP, GH.GL_SCREW] },
      { parts: ['gh-flash'], codes: [GH.FLASH, GH.GL_SCREW] },         /* v378 the lean-to's endwall flashing */
      { parts: ['gh-trim'], codes: [GH.TRIM] },
      { parts: ['gh-rake', 'gh-casing', 'gh-belt', 'gh-closer'], codes: [GH.BOARD] },   /* v378 + the lean-to's closer boards */
      { parts: ['gh-hw-screw-rake'], codes: [GH.FASCIA_SCREW] },
      { parts: ['gh-hw-nail-trim'], codes: [GH.TRIM_NAIL] },
      { parts: ['gh-dframe'], codes: [GH.FRAME] },
      { parts: ['gh-dbrace'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-door'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-door'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-hinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-hinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-knob'], codes: [GH.KNOB] },
      { parts: ['gh-catch'], codes: [GH.CATCH] },
      { parts: ['gh-vframe'], codes: [GH.FRAME] },
      { parts: ['gh-hw-screw-vframe'], codes: [GH.STUD_SCREW] },
      { parts: ['gh-glaze-vent'], codes: [GH.TAPE, GH.GL_SCREW] },
      { parts: ['gh-vhinge'], codes: [GH.HINGE] },
      { parts: ['gh-hw-screw-vhinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['gh-opener'], codes: [] },
      { parts: ['gh-bleg', 'gh-brail'], codes: [GH.FRAME], lk: ['bench_gh_tables'] },   /* v392 the benches (off: not drawn, the steps drop out) */
      { parts: ['gh-hw-screw-brail'], codes: [GH.TOE] },
      { parts: ['gh-bslat'], codes: [GH.BOARD] },
      { parts: ['gh-hw-screw-bslat'], codes: [GH.FASCIA_SCREW] }
    ]);
  }
  var _ghLogKey = '';
  /* the twinwall's flutes: a light sheet with a faint line every 2 cm (one tile = 4 cm of the sheet's u) */
  var _ghFlute = null;
  function _ghFluteTex() {
    if (_ghFlute) return _ghFlute;
    try {
      var doc = global.document; if (!doc || !doc.createElement) return null;
      var T = global.THREE;
      var cnv = doc.createElement('canvas'); cnv.width = 64; cnv.height = 4;
      var g = cnv.getContext('2d'); if (!g) return null;
      g.fillStyle = 'rgb(246,250,251)'; g.fillRect(0, 0, 64, 4);
      g.fillStyle = 'rgb(214,222,226)'; g.fillRect(0, 0, 2, 4); g.fillRect(32, 0, 2, 4);
      var tex = new T.CanvasTexture(cnv);
      tex.wrapS = tex.wrapT = T.RepeatWrapping;
      tex.repeat.set(1 / 0.04, 1);
      if (T.SRGBColorSpace) tex.colorSpace = T.SRGBColorSpace;
      _ghFlute = tex;
      return tex;
    } catch (e) { return null; }
  }
  /* ------------------------------------------------------------------
     v376 TYPE 35 -- KITCHEN POD, variant 1 (Marek 2026-10-30 09:52:
     "tady neni moc co konfigurovat, krome delky a vybaveni. Tak bych to
     spise udelal jako jednoduchy konfigurator (styl bench)"; 09:55
     "produkt zalozeny, muzes stavet ... Asi jedna [varianta]"). A compact
     outdoor kitchen after the bbq_zen_garden reference: a closed timber
     box whose whole front lifts on gas struts into a roof over the
     counter. One type; the cladding's look on the colour brush, the front
     open / shut on the info bar's toggle, the length on the footprint's
     grips (the depth fixed).
       - FOUNDATION: ground screws FGR00001 in U heads FGR00002 (12 nails
         FAS38038 each) under the front and back beams, 25 cm (US 10 in.)
         in from the ends and <= 1.80 m (US 6 ft) apart;
       - BASE: 4x6 KVH10160 on edge -- front and back beams the full
         length, end beams between them (2 x FAS80200 a corner); 2x6
         KVH60160 joists at <= 60 cm (US 24 in.) in joist hangers FAT00009
         (6 nails each); a deck of 1x6 KVR14024 boards (2 x FAS55050 a
         support), the front row cut between the posts;
       - WALLS on the deck: the back wall the full length, the end walls
         between it and the front posts, 2x4 KVH10060 studs at <= 60 cm,
         single top plates -- the end walls' raking under the end rafters;
         4x4 KVH10100 front posts on the front beam carry a 4x6 header the
         full length; outside OSB25001 15 mm (US 5/8 in.), the breathable
         membrane INS00002, 30x50 battens FVF00301 over the studs and the
         wood cladding FVW01351 in horizontal rows; FVW02660 corner trims;
       - ROOF: a 5 deg mono-pitch falling to the back -- 2x6 KVH60160
         rafters at <= 60 cm hung in joist hangers off the header, a
         birdsmouth on the back wall's plate (8x200 down), 12 cm (US 5 in.)
         past it; OSB25002 18 mm (US 23/32 in.), the underlay ROR00008,
         standing seam ROR12003 (clips), drip edge ROM02401; 1x6 fascia and
         rake boards; the front band: two 2x3 KVH40060 rails on the header's
         face and a cladding board over them, flush with the flap;
       - THE FLAP: the whole front from the base's underside up to the
         band -- a 2x3 frame on edge (rails, stiles at <= 60 cm, a stile
         where each strut sits) clad like the walls, on strap hinges
         FAT00022 on the band (6 screws each), two gas struts from a 2x4
         block in each end wall (NO CATALOGUE ROW: NOT BILLED), two knobs
         ODD00016 and two ball catches ODD00017; open 85 deg as a roof
         over the counter, shut on the toggle;
       - THE COUNTER along the back wall: 2x4 uprights at the bays, rails
         between them under the top (the grill's bay a lower header under
         its body), a ledger on the back wall, cross members, a sleeper and
         front sills on the deck that carry the stainless drop-in modules;
         panel siding FCP00009 on its face with the modules' cutouts; an
         acacia top FOU00034 the inner length; the grill head FOU00017 over
         a door + drawer combo FOU00031, the sink FOU00022 + mixer tap
         FOU00025 over a double door FOU00029, as many drawer FOU00030 /
         trash FOU00033 / door FOU00032 modules as the length takes.
     X = across (+X the front with the flap), Y up, Z along (L). L / D =
     the framing's outer faces (the skin outside them). _kpLayout(STATE)
     is the single source of the model, the bill and the assembly. */
  var KP = {
    L: [2.40, 3.60], L_US: [2.4384, 3.6576], L0: 3.00, L0_US: 3.048, D: 0.80, D_US: 0.7874,   /* v410 (Marek 2026-11-03 21:41 "Kuchyn na nejsirsiho modulu plus 15 cm"): the back wall's studs + the modules' gap + depth + 15 cm / 6 in. (was 0.90 / 36 in.) */
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508, GS_R: 0.038, GS_R_US: 0.0381, U_UP: 0.030, U_T: 0.004, U_FL: 0.15,
    PIER_SP: 1.80, PIER_SP_US: 1.8288, PIER_IN: 0.25, PIER_IN_US: 0.254,
    SP: 0.60, SP_US: 0.6096, FIX_SP: 0.40, FIX_SP_US: 0.4064,
    HDR_TOP: 1.95, HDR_TOP_US: 1.9558, PITCH: 2, OV_B: 0.12, OV_B_US: 0.127,   /* v410 ("Rovna strecha"): 2 deg (was 5) -- level to the eye, the water still runs off */
    TOP_H: 0.914, TOP_H_US: 0.9144, MOD_GAP: 0.04, MOD_GAP_US: 0.0381, MOD_H: 0.52, MOD_H_US: 0.5207, MOD_D: 0.51, MOD_D_US: 0.508,
    GRILL_W: 0.74, GRILL_W_US: 0.7366, GRILL_D: 0.46, GRILL_D_US: 0.4572, GRILL_H: 0.20, GRILL_H_US: 0.2032,
    LID_W: 0.81, LID_W_US: 0.8128, LID_D: 0.56, LID_D_US: 0.5588, LID_H: 0.22, LID_H_US: 0.2286,
    SINK_W: 0.38, SINK_W_US: 0.381, SINK_H: 0.18, SINK_H_US: 0.1778,
    FRIDGE_W: 0.60, FRIDGE_W_US: 0.6096, FRIDGE_DOOR: 0.03, KAM_RX: 0.235, KAM_RY: 0.28, KAM_UP: 0.12,
    BURN_W: 0.30, BURN_D: 0.46, BURN_H: 0.12, BURN_PW: 0.33, BURN_PD: 0.52, PIZZA_W: 0.50, PIZZA_D: 0.48, PIZZA_H: 0.30, DISC_R: 0.10, DISC_TILT: 50,
    OPEN: 85, FLAP_GAP: 0.005, STRUT_BX: 0.25, STRUT_BY: 0.75, STRUT_FY: 0.30, STRUT_IN: 0.03, STRUT_BODY: 0.45, STRUT_BR: 0.012,
    HINGE_LEAF: 0.06, HINGE_STRAP: 0.30, HINGE_W: 0.035, HINGE_T: 0.003,
    SEAM_PAN: 0.53, SEAM_PAN_US: 0.4064, SEAM_W: 0.022, SEAM_H: 0.025, SEAM_T: 0.002,
    WASTE: 1.10, CLAD_SCR_M2: 28, SHEATH_SCR_M2: 15, STAPLES_M2: 6, SEAM_CLIPS_M2: 5, DRIP_FIX: 0.30, PANEL_SCR_M2: 20,
    GSCREW: 'FGR00001', UHEAD: 'FGR00002', UNAIL: 'FAS38038',
    BASE: 'KVH10160', JOIST: 'KVH60160', HANGER: 'FAT00009', DECK: 'KVR14024', STUD: 'KVH10060', POST: 'KVH10100', FRAME: 'KVH40060',
    WALL_OSB: 'OSB25001', ROOF_OSB: 'OSB25002', MEMB: 'INS00002', BATTEN: 'FVF00301', CLAD: 'FVW01351', TRIM: 'FVW02660', BOARD: 'KVR14024',
    UNDERLAY: 'ROR00008', SEAM: 'ROR12003', DRIP: 'ROM02401', PANEL: 'FCP00009',
    TOP: 'FOU00034', GRILL: 'FOU00017', SINK: 'FOU00022', TAP: 'FOU00025', COMBO: 'FOU00031', DDOOR: 'FOU00029', DRAWER: 'FOU00030', SDOOR: 'FOU00032', TRASH: 'FOU00033',
    FRIDGE: 'FOU00024', BURNER: 'FOU00021', KAMADO: 'FOU00018', PIZZA: 'FOU00020',
    BOTTLE_R: 0.1525, BOTTLE_H: 0.457, REG_H: 0.025, MAN_W: 0.10, MAN_D: 0.035, MAN_H: 0.05, VALVE_L: 0.05, GAS_MAX: 3,
    BOTTLE: 'FOU00026', REGULATOR: 'GAP00001', MANIFOLD: 'GAP00002', GASVALVE: 'GAP00003', GASLINE: 'GAP00004', GASELBOW: 'GAP00005', GASHOSE: 'GAP00006',
    PEX: 'SMR00121', DROPEAR: 'SMW00201', FLEXI: 'SMN00202', DRAIN: 'SMR00321', DBEND: 'SMP00321', SIPHON: 'SMH00322',
    CABLE: 'EEE00001', JBOX: 'EEJ00001', SOCKET: 'EES00005', SWITCH: 'EEL00002', WLIGHT: 'EEW00001', PSU: 'EEC00007', LED: 'EEC00006',
    HINGE: 'FAT00022', KNOB: 'ODD00016', CATCH: 'ODD00017',
    BASE_SCREW: 'FAS80200', DECK_SCREW: 'FAS55050', PLATE_SCREW: 'FAS60120', STUD_SCREW: 'FAS60120', FRAME_SCREW: 'FAS60100', LONG_SCREW: 'FAS60160', TOE: 'FAS60080',
    SEAT_SCREW: 'FAS80200', SHEATH_SCREW: 'FAS50060', STAPLE: 'FAS63000', CLAD_SCREW: 'FAS55050', FASCIA_SCREW: 'FAS55050', RAKE_SCREW: 'FAS45070',
    TRIM_NAIL: 'FAS18032', CLIP_SCREW: 'FAS60100', ROOF_NAIL: 'FAS00318', HINGE_SCREW: 'FAS55050', BRACKET_SCREW: 'FAS50040',
    STRUT_NAME: 'GAS STRUT (GAS SPRING) FOR A LIFT-UP FLAP, 1200 N, WITH BALL-SOCKET BRACKETS', STRUT: 'FAT00025',   /* v405 the row exists */
    /* v405 the foundation on its switch (the greenhouses' v399 values and codes) */
    FD_BLK: 0.30, FD_BLK_US: 0.3048, FD_BLK_TOP: 0.20, FD_BLK_TOP_US: 0.2032, FD_BLK_H: 0.20, FD_BLK_H_US: 0.2032, FD_BLK_UP: 0.10, FD_BLK_UP_US: 0.1016, FD_GRAVEL: 0.10, FD_GRAVEL_US: 0.1016,
    FD_PIER_W: 0.40, FD_PIER_W_US: 0.4064, FD_PIER_D: 0.80, FD_PIER_D_US: 0.8128, FD_PIER_UP: 0.10, FD_PIER_UP_US: 0.1016, FD_PIER_GRAVEL: 0.15, FD_PIER_GRAVEL_US: 0.1524, FD_BAR_COVER: 0.05,
    FD_BLOCK: 'FCO00012', FD_CONCRETE: 'FCO00002', FD_REBAR: 'FCO00003', FD_FORMWORK: 'FCO00007', FD_GEOTEX: 'FEC00003', FD_UANCHOR: 'FCO00004', GRAVEL: 'FCO00001', DIG: 'FEE00001',
    /* v405 the shelf over the counter (a + disc on the back wall): a 2x6 laid flat (its top SHELF_UP over the worktop) on 6x6 in. angle brackets at the studs */
    SHELF_UP: 0.58, SHELF_UP_US: 0.5842, SHELF_BR: 'FAT00005', SHELF_SCREW: 'FAS48019', SHELF_BRS: 0.145, SHELF_BRS_US: 0.1524, SHELF_HOT: 0.05,
    /* v405 the roof's covering (a + disc on the roof): standing seam | EPDM loose-laid under the drip edge | an extensive green roof
       (sedum) in 2x4 kerbs over the end rafters and the header, a gravel strip and a perforated stop at the low eave */
    EPDM_T: 0.0012, RGRAVEL: 'ROR00004', GR_H: 0.10, GR_H_US: 0.1016, GR_SUB: 0.06, GR_SUB_US: 0.0635, GR_GRAVEL: 0.10, GR_GRAVEL_US: 0.1016,   /* v412 the gravel strip 10 cm / 4 in. (was 15): the green the most of the roof */  GR_UP: 0.12, KERB_FIX: 0.45, KERB_FIX_US: 0.4572,
    EPDM_NAME: 'EPDM ROOFING MEMBRANE 1.2 MM (45 MIL), ONE PIECE -- THE KITCHEN POD ROOF, LOOSE-LAID, TURNED DOWN UNDER THE DRIP EDGE',
    GR_MEMB_NAME: 'ROOT-RESISTANT EPDM ROOFING MEMBRANE 1.2 MM (45 MIL) FOR A GREEN ROOF, ONE PIECE, TURNED UP THE EDGE ANGLES',   /* v412 no kerbs */
    GR_MAT_NAME: 'GREEN ROOF DRAINAGE AND FILTER MAT (DIMPLED SHEET + GEOTEXTILE)',
    GR_SUB_NAME: 'EXTENSIVE GREEN ROOF SUBSTRATE (LIGHTWEIGHT MINERAL MIX)',
    GR_SEDUM_NAME: 'PRE-GROWN SEDUM MAT',
    UVMEMB_NAME: 'UV-STABLE BLACK FACADE MEMBRANE FOR OPEN-JOINT CLADDING (IN PLACE OF THE BREATHER MEMBRANE)',   /* v413 */
    PTAPE_NAME: 'EPDM FACADE BATTEN TAPE, BLACK, 60 MM (2 3/8 IN.), UNDER THE OPEN JOINTS OF FACADE PANELS',   /* v413 the fibre cement / corten claddings */
    GR_STOP_NAME: 'GREEN ROOF EDGE AND GRAVEL STOP, PERFORATED ALUMINIUM ANGLE 120 MM, WITH ITS SCREWS',   /* v412 round the roof's edge (was the gravel stop only) */
    /* v405 the counter's finish (a + disc on its face): acacia top + painted panel | concrete top (the worktop slab) + stone veneer on
       cement board | granite top + wood boards */
    SLAB_T: 0.03, SLAB_T_US: 0.03048, WORKTOP: 'FOU00027', CBOARD: 'FCB00013', CB_SCREW: 'FAT16012', CB_SCR_M2: 20, STONE_ADH: 'FEC00018', STONE_ADH_M2: 6, STONE_T: 0.035, STONE_T_US: 0.0381, FLANGE_M: 0.012, STONE: 'FCP00010', INOX: 'FVS00101', INOX_T: 0.001, INOX_T_US: 0.000912, INOX_GLUE: 'FEC00031', INOX_GLUE_M2: 0.5,   /* v412 the inox look: brushed stainless panels (1 mm / 20 ga) bonded on the cement board, a cartridge of the polymer adhesive a 2 m2 */   /* the natural stone veneer panel (35 mm, adhered to cement board) */
    GRANITE_NAME: 'GRANITE WORKTOP SLAB 30 MM (1 1/4 IN.), POLISHED, SEALED, WITH THE APPLIANCE AND SINK CUTOUTS',
    /* v406 the counter's frame on the info bar's toggle: galvanized steel studs (the drywall system's 50 x 100, 0.6 mm; US 1 5/8 x
       3 5/8 in.), every steel joint cut and folded with four 4.8x19 framing screws (billed), 4.8x19 from inside the profile into the
       wood (drawn), the faces on wing tip screws; behind a hot bay a cement board heat shield on the back wall's studs (both frames) */
    MST_W: 0.05, MST_W_US: 0.0413, MST_D: 0.10, MST_D_US: 0.0921, MSTUD: 'WDD00502', MS_SCREW: 'FAS48019', MS_JOINT_SCR: 4, WING_SCREW: 'FAS55038',
    SHIELD_H: 0.60, SHIELD_H_US: 0.6096, SHIELD_T: 0.0125, SHIELD_T_US: 0.0127, SHIELD_IN: 0.05,
    JACKET_NAME: 'INSULATED GRILL JACKET (THE GRILL MAKER\'S) FOR A BUILT-IN GRILL IN A WOOD FRAME',
    BJACKET_NAME: 'INSULATED JACKET (THE MAKER\'S) FOR A BUILT-IN SIDE BURNER IN A WOOD FRAME',
    /* v407 GARDEN POD -- THE FITNESS (type 53): its equipment (catalogue FMC rows) and its sizes; rubber tiles on the deck (v409 below) */
    DUMBBELLS: 'FMC00021', BARBELL: 'FMC00027', BAR_RACK: 'FMC00028', BAG: 'FMC00022', RINGS: 'FMC00026',
    BAR_L: 2.20, BAR_L_US: 2.1336, BAR_R: 0.014,
    DB: [0.55, 0.42, 0.80],   /* the dumbbells' stand: its length, depth, height */
    BAG_D: 0.35, BAG_H: 1.20, BAG_UP: 0.45, PB_R: 0.016, RING_R: 0.1175, RING_T: 0.014, RING_SP: 0.23,
    MAT_T: 0.02, MAT_NAME: 'RUBBER GYM FLOOR TILE 20 MM (3/4 IN.), INTERLOCKING -- THE FITNESS POD\'S DECK',
    BAGHANG_NAME: 'HEAVY BAG HANGER: SHACKLE, SWIVEL AND CHAIN ON THE GALLOWS ARM\'S HOOK PLATE',   /* v415 (was: an eye bolt through the blocking) */
    /* v409 THE FITNESS 2 (Marek 2026-11-03 20:01 / 20:08; question panels: a lift-up flap on both long sides, a roof when open; 1.8 m /
       6 ft deep): the pod 1.80 m (US 6 ft) deep, its length on the number (3 / 4 / 5: 2.70 / 3.15 / 3.60 m, US 9 / 10 1/2 / 12 ft), the
       header 2.20 m (US 7 ft 3 in.) over the deck; the back the front's mirror (no back wall); the wall bars on the right end wall
       outside; the cable pulley on the left one inside; the sizes of the equipment drawn (x along the wall, z out from it, y up) */
    FP_D: 0.50, FP_D_US: 0.508, FP_HDR: 2.20, FP_HDR_US: 2.2098,   /* v411 (Marek 22:03 "max kompaktni ... case na prumer zavazi plus dvere"): a plate's 0.45 m + 5 cm (US 20 in.; v410 1.45, v409 1.80) */
    FP_LEN: { 3: 2.70, 4: 3.15, 5: 3.60 }, FP_LEN_US: { 3: 2.7432, 4: 3.2004, 5: 3.6576 },
    LAD_W: 0.60, LAD_W_US: 0.6096, LAD_H: 2.40,   /* v411 the end wall's width (was 1.00 / 40 in.) */ LAD_H_US: 2.4384, LAD_OFF: 0.06, LAD_SW: 0.045, LAD_SD: 0.09, RUNG_R: 0.016, RUNG_SP: 0.15, LAD_BRY: [0.55, 2.05],
    JH_Y: 0.95, JH_L: 0.16, PU_Y: 2.28, PU_OUT: 0.55, DIP_Y: 1.25, DIP_L: 0.50, DIP_SP: 0.56,   /* v410 the J-hooks low (the bench press: "vyloznik dole i s olympijskou tyci") */
    PUL: [0.28, 0.42, 1.85], BENCH: [1.30, 0.42, 0.45],   /* v411 a slim pulley column (the struts by it), the bench's feet 42 cm */ KB_R: [0.085, 0.095, 0.105], BENCH_TILT: 40,   /* v410 the bench's back raised so far by the dip bars */
    WRACK: [0.46, 0.42, 1.20], WR_KB: 0.55, WR_DB: 0.90, WR_PEG: 0.26, WR_PX: 0,   /* v411 narrow: the plates on one peg, the kettlebells over them, the dumbbells over those ("Cinky a zavazi mohou byt nad sebou") */   /* v410 the wall rack on the right end wall: width, depth, height; the kettlebells' shelf, the dumbbells' shelf, the plate pegs over the tiles */
    TYRE_R: 0.60, TYRE_RI: 0.33, TYRE_H: 0.28, HAM_L: 0.90, ROPE_R: 0.019, ROPE_OUT: 2.20, ROPE_SP: 0.50,
    PULLEY: 'FMC00016',   /* GYM MACHINE 1: the wall-mounted cable pulley (Marek's plan, 2026-11-03 20:05) */
    LADDER_NAME: 'WALL BARS (STALL BARS) LADDER, STEEL, POWDER-COATED, 2.40 x 0.60 M (US 8 FT x 24 IN.), WITH 2 WALL RAILS',
    PUDIP_NAME: 'PULL-UP BAR AND DIP BARS ATTACHMENTS FOR WALL BARS, HOOK-ON (ANY RUNG)',
    JHOOK_NAME: 'J-HOOKS FOR WALL BARS (BARBELL HOLDERS FOR SQUAT / BENCH PRESS), HOOK-ON (ANY RUNG), PAIR',
    BENCH_NAME: 'ADJUSTABLE WEIGHT BENCH, THE BACK FLAT TO 85 DEG (INCLINE / DECLINE)',
    PLATES_NAME: 'OLYMPIC BUMPER PLATE SET, 50 MM (2 IN.) HOLE: 2 x 5 / 10 / 15 / 20 KG (2 x 10 / 25 / 35 / 45 LB)',
    WRACK_NAME: 'WALL STORAGE RACK, STEEL, 46 CM (18 IN.) WIDE: A DUMBBELL SHELF, A KETTLEBELL SHELF, A PLATE PEG 50 MM (2 IN.)',
    KB_NAME: 'KETTLEBELL SET 8 / 12 / 16 KG (18 / 26 / 35 LB)',
    CATT_NAME: 'CABLE PULLEY ATTACHMENTS: TRICEPS ROPE, 2 D-HANDLES, STRAIGHT BAR',
    BANDS_NAME: 'RESISTANCE BANDS (EXPANDERS), SET OF 5 STRENGTHS',
    ROPE_NAME: 'BATTLE ROPE 38 MM x 12 M (1 1/2 IN. x 40 FT), MANILA / HEMP, BLACK GRIPS, WITH ITS ANCHOR STRAP',
    RANCH_NAME: 'BATTLE ROPE ANCHOR: GALVANIZED EYE PLATE ON THE BACK BASE BEAM',
    TYRE_NAME: 'TRAINING TYRE (A USED TRACTOR TYRE), ABOUT 1.20 M (4 FT) ACROSS',
    HAMMER_NAME: 'SLEDGEHAMMER 8 KG (18 LB) FOR THE TYRE',
    /* v415 (Marek 2026-11-04 09:44) THE BAG'S SWING-OUT GALLOWS: square steel tube (SHS) mast + arm, a lighter brace at 45 deg under the
       arm (its run), two heavy pin hinges (the knuckle's radius, height) on the front left corner post; THE TV in the middle on a 360 deg
       swivel ceiling mount (43 in.: width, height, depth; the pole's drop from the mount plate to its top; its centre off the pole; the
       turn at the slider's end, toward the bag); the hammer's head (its height on the ground) */
    GAL_A: 0.07, GAL_A_US: 0.0635, GAL_B: 0.05, GAL_B_US: 0.0508, GAL_KR: 0.02, GAL_KH: 0.10, GAL_BR: 0.36,
    GAL_HP: [0.07, 0.07, 0.008, 0.025, 0.007],   /* v417 the bag's hook plate under the arm: along it, its height, thickness; the hole's centre over the plate's foot, its radius */
    GAL_PIN: 0.009,   /* v417 the hinge pin's radius (18 mm) */
    GAL_SEC: ['SHS 70 x 70 x 4', 'SHS 50 x 50 x 4'], GAL_SEC_US: ['HSS 2 1/2 x 2 1/2 x 3/16', 'HSS 2 x 2 x 3/16'],   /* v417 the tubes on the gallows' sheet */
    TV_X: 0.09, TV_SOCK_Z: 0.30, TV: [0.97, 0.57, 0.06], TV_DROP: 0.08, TV_OFF: 0.065, TV_TURN: 25, HAM_HD: 0.07,
    GALLOWS_NAME: 'HEAVY BAG SWING-OUT GALLOWS, WELDED STEEL: SHS 70 x 70 x 4 MM (2 1/2 x 2 1/2 x 3/16 IN.) MAST 1.8 M AND ARM 0.7 M, SHS 50 x 50 x 4 MM (2 x 2 x 3/16 IN.) BRACE, HOOK PLATE, POWDER-COATED BLACK',
    GHINGE_NAME: 'HEAVY PIN HINGE FOR A SWING GATE POST: WELD-ON KNUCKLE + SCREW-ON POST PLATE, 150 KG (330 LB)',
    TV_NAME: 'TV 43 IN. (109 CM), 4K SMART, FOR A COVERED OUTDOOR SPACE',
    TVMOUNT_NAME: 'TV CEILING MOUNT, 360 DEG SWIVEL, POLE ABOUT 35 CM (14 IN.), VESA UP TO 200 x 200, FOR 26-55 IN. TVS'
  };
  /* the sections (metric / US actual): 2x4 (st x sd), 4x6 (bw x bh), 4x4
     post p, 2x6 (jt x jh), 2x3 (ft x fw), batten (bt x bwd), cladding (tc,
     row cw), 1x6 board (tb x wb), wall / roof OSB, panel siding, trim (tt x
     tw), the acacia top (topT x topD) */
  function _kpProf(s) {
    if ((s || STATE).isMetric === false) return { st: 0.0381, sd: 0.0889, bw: 0.0889, bh: 0.1397, p: 0.0889, jt: 0.0381, jh: 0.1397, ft: 0.0381, fw: 0.0635,
      bt: 0.0381, bwd: 0.0381, tc: 0.0159, cw: 0.1397, tb: 0.01905, wb: 0.1397, ow: 0.0159, orf: 0.0183, pt: 0.0087, tt: 0.01905, tw: 0.0635, topT: 0.0381, topD: 0.635 };
    return { st: 0.060, sd: 0.100, bw: 0.100, bh: 0.160, p: 0.100, jt: 0.060, jh: 0.160, ft: 0.040, fw: 0.060,
      bt: 0.030, bwd: 0.050, tc: 0.015, cw: 0.135, tb: 0.024, wb: 0.140, ow: 0.015, orf: 0.018, pt: 0.011, tt: 0.020, tw: 0.060, topT: 0.038, topD: 0.635 };
  }
  function _kpU(s, k) { return ((s || STATE).isMetric === false && KP[k + '_US'] != null) ? KP[k + '_US'] : KP[k]; }
  var KP_TYPES = [35, 53];   /* v376 the kitchen pod types (v407 GARDEN POD: 35 Kitchen, 53 Fitness) */
  function _kpIsFp(s) { return ((s || STATE).variant | 0) === 53; }   /* v407 the fitness: no counter (v409 its own shell: _kpD, FP_LEN, FP_HDR) */
  function _kpD(s) { return _kpU(s, _kpIsFp(s) ? 'FP_D' : 'D'); }   /* v409 the depth: the fitness's 1.80 m / US 6 ft */
  function _kpLad(s) { var l = (s || STATE).kpLad; return (l === 'dip' || l === 'pull') ? 'dip' : 'hooks'; }   /* v409 the wall bars' attachment on its + disc (v410: the J-hooks low with the barbell | the dip bars + the rings; the pull-up bar always) */
  function _isKpType(v) { return KP_TYPES.indexOf(v | 0) >= 0; }
  /* v406 (Marek 2026-11-03 16:10 "Zrusit zalozku otevrena, dat nad spodni listu posuvnik, kterym uzivatel plynule otevre"): the flap's
     angle 0 (shut) .. KP.OPEN on a slider over the info bar (STATE.kpAng; a design without it: open = KP.OPEN, kpOpen false = 0) */
  function _kpAng(s) { s = s || STATE; var a = +s.kpAng; if (s.kpAng == null || !isFinite(a)) a = (s.kpOpen === false) ? 0 : KP.OPEN; return Math.max(0, Math.min(KP.OPEN, a)); }
  function _kpOpen(s) { return _kpAng(s) >= 45; }   /* open enough for the + discs */
  /* v412 (Marek 23:46 "posuvnik muze zaroven ovladat dvere i zasuvky / dvirka - do poloviny delky se odklopi hlavni dvere, v druhe polovine
     se vysouvaji zasuvky (nestejnomerne) a otevoraji dvirka (at je videt pb bomba jako ted)"): the kitchen's second half of the slider --
     0 .. 1, the drawers out (each its own way and time) and the doors open; only with the flap fully open; a view, not saved (the default:
     all out, as the bottle showed before) */
  function _kpExt(s) { s = s || STATE; if (_kpAng(s) < KP.OPEN - 0.5) return 0;   /* v415 the fitness too: its bag's gallows, the TV, then the equipment out */ var e = +s.kpExt; if (s.kpExt == null || !isFinite(e)) return 1; return Math.max(0, Math.min(1, e)); }
  /* v406 the counter's frame on the info bar (Marek 2026-11-03: prepinac drevo / ocel): 'wood' 2x4s | 'steel' galvanized studs WDD00502 */
  function _kpFrame(s) { return ((s || STATE).kpFrame === 'steel') ? 'steel' : 'wood'; }
  function _kpCst(s) { return (_kpFrame(s) === 'steel') ? _kpU(s, 'MST_W') : _kpProf(s).st; }   /* the counter's uprights' width */
  function _kpCsd(s) { return (_kpFrame(s) === 'steel') ? _kpU(s, 'MST_D') : _kpProf(s).sd; }   /* -- their depth */
  /* v405 THE FOUNDATION on the third switch (the greenhouses' v399): 'screw' ground screws + U heads, 'block' precast pads (the base on
     their top), 'pier' poured footings with a wet-set U anchor up to the base */
  /* v405 THE CLADDING on the fourth switch: 'h' horizontal boards on upright battens, 'v' upright boards on battens laid across,
     'bb' the same + a 1x3 strip over every joint (board & batten) */
  function _kpClad(s) { var c = (s || STATE).kpClad; return (c === 'v' || c === 'bb' || KP_PCLAD[c]) ? c : 'h'; }
  /* v413 (Marek 2026-11-03 23:46 "neexistuje i nejaky panelovy material pouzitelny na tyto stavby? At nepouzivame jen drevo"): THE PANEL
     CLADDINGS on the cladding switch after the boards -- fibre cement FCP00003 (1200 x 600, open joints, on the upright battens), corten
     FVC00101 (1000 x 2000, open joints, on the upright battens), corrugated steel ROR12004 (ribs upright, on the battens laid across, the
     sheets side-lapped: +15 %); their fixings by the area (the container's 6 sealing screws a m2 for corten; 12 A2 screws a m2 for the
     fibre cement, 10 sealing screws for the corrugated); the corner boards and the kitchen's back trims folded of the same panel; the
     battens behind open joints taped black (MISSING) */
  var KP_PCLAD = {
    fc:     { kind: 'pfc', code: 'FCP00003', fix: 'FAS55050', fixM2: 12, w: 1.20, w_us: 1.2192, h: 0.60, h_us: 0.6096, gap: 0.008, waste: 1.10, tape: true, key: 'mc_cov_fibre_cement', en: 'Fibre cement sheet' },
    corten: { kind: 'pcor', code: 'FVC00101', fix: 'FAS00225', fixM2: 6, w: 1.00, w_us: 1.016, h: 2.00, h_us: 2.032, gap: 0.008, waste: 1.10, tape: true, key: 'sauna_fac_4', en: 'Corten' },
    corr:   { kind: 'pcorr', code: 'ROR12004', fix: 'FAS00225', fixM2: 10, rib: 0.0762, waste: 1.15, across: true, key: 'mc_cov_corrugated', en: 'Corrugated sheet' }
  };
  var KP_CLAD_ORDER = ['h', 'v', 'bb', 'fc', 'corten', 'corr'];
  function _kpRoof(s) { var r = (s || STATE).kpRoof; return (r === 'epdm' || r === 'green') ? r : 'seam'; }   /* v405 the roof's covering: its + disc on the roof */
  function _kpFin(s) { var f = (s || STATE).kpFin; return (f === 'concrete' || f === 'granite' || f === 'inox') ? f : 'acacia'; }
  /* v412 (Marek 23:46 "prepinani provedeni dvirek udelej vse jen v prepinaci v liste (kde je ted dreveny ram a ocelovy ram). Muze tam byt
     klidne vice pozic, ale idealne takove, ktere se v praxi pouzivaji a davaji smysl"): THE COUNTER'S LOOK on the bar's first switch, the
     frame and the finish together -- panels (timber frame, painted panel siding, acacia top), timber (timber frame, a board face, granite
     top), stone (steel frame, cement board + natural stone veneer, concrete slab), inox (steel frame, cement board + brushed stainless
     panels bonded on, concrete slab); the + disc on the face gone */
  var KP_LOOKS = [{ id: 'panel', frame: 'wood', fin: 'acacia', key: 'cladding_panel', en: 'Panels' }, { id: 'timber', frame: 'wood', fin: 'granite', key: 'bbq_v2', en: 'Timber' },
    { id: 'stone', frame: 'steel', fin: 'concrete', key: 'gb_stone', en: 'Stone' }, { id: 'inox', frame: 'steel', fin: 'inox', key: 'pool_surface_inox', en: 'Inox' }];
  /* v412 the pods' frame stage (the eye's second): what stays -- the frame, the foundation, the flap's frame + hinges + struts, the frame's fasteners */
  var KP_FRAME_KEEP = { 'kp-base': 1, 'kp-joist': 1, 'kp-post': 1, 'kp-plate': 1, 'kp-rplate': 1, 'kp-tplate': 1, 'kp-stud': 1, 'kp-estud': 1, 'kp-header': 1, 'kp-rafter': 1,
    'kp-hanger': 1, 'kp-rhanger': 1, 'kp-brail': 1, 'kp-ecleat': 1, 'kp-fframe': 1, 'kp-sblock': 1, 'kp-fblock': 1, 'kp-cframe': 1, 'kp-sframe': 1, 'kp-gscrew': 1,
    'kp-uhead': 1, 'kp-uanchor': 1, 'kp-pour': 1, 'kp-block': 1, 'kp-hinge': 1, 'kp-strut': 1, 'kp-sbracket': 1, 'kp-catch': 1 };
  function _kpFrameKeep(pt) {
    if (KP_FRAME_KEEP[pt]) return true;
    var m = /^kp-hw-(?:screw|nail)-(.+)$/.exec(pt || '');
    return !!m && !/^(cclad|trim|bstrip|fstrip|batten|rake|fascia|deck|kerb|shelf|shelfbr|wlight|jbox|psu|ebox|pulley|wrack|lbrk|ranchor|bhook|dropear|pcorner|ptrim|ghinge|tvmount)$/.test(m[1]);   /* v413 + the panels' corners (v415 + the gallows' hinges, the TV's mount) */
  }
  function _kpLookI(s) { var f = _kpFin(s), i; for (i = 0; i < KP_LOOKS.length; i++) if (KP_LOOKS[i].fin === f) return i; return 0; }   /* v405 the counter's top + face: its + disc on the face */
  function _kpShelf(s) { return (s || STATE).kpShelf === true; }   /* v405 the shelf over the counter: its + disc on the back wall */
  function _kpFound(s) { var f = (s || STATE).kpFound; return (f === 'block' || f === 'pier') ? f : 'screw'; }
  function _kpYBB(s) { var f = _kpFound(s); return (f === 'block') ? _kpU(s, 'FD_BLK_UP') : (f === 'pier') ? _kpU(s, 'FD_PIER_UP') + KP.U_UP : _kpU(s, 'FOOT_UP'); }
  function _kpYH(s, yBB) { var f = _kpFound(s); return (f === 'block') ? yBB : (f === 'pier') ? _kpU(s, 'FD_PIER_UP') : yBB - KP.U_UP; }
  /* v405 (Marek 2026-11-03 15:12 "nakonec mozna udelal skoky po modulech. Zvolit si 3/4/5, a kazdy cyklovanim bude definovat delku cele
     kitchen. Dava to variabilitu, jednoduche UI a jasny vysledek"): the bays' number on the top switch (STATE.kpN 3 / 4 / 5), every bay
     its kind's own width (the module's cutout, the fridge's), an upright between -- the length follows, no grips; at most KP.L[1] (3.60 m /
     US 12 ft: the flap's two struts), a kind that would pass it skipped on the bay's disc */
  var KP_N0 = { 3: ['grill', 'drawer', 'sink'], 4: ['trash', 'grill', 'drawer', 'sink'], 5: ['trash', 'grill', 'drawer', 'sink', 'drawer'] };
  function _kpN(s) { var n = (s || STATE).kpN | 0; return (n === 3 || n === 5) ? n : 4; }
  function _kpLmax(s) { return _kpU(s, 'L')[1]; }
  function _kpLOf(s, kinds) { if (_kpIsFp(s)) return _kpU(s, 'FP_LEN')[_kpN(s)]; var P = _kpProf(s), us = ((s || STATE).isMetric === false), t = 0, i; for (i = 0; i < kinds.length; i++) t += _kpNat(us, kinds[i]); return t + (kinds.length + 1) * _kpCst(s) + 2 * P.sd; }   /* v406 the uprights as the frame makes them (v409 the fitness: its length on the number) */
  /* the bays' kinds: the number's defaults, each bay's choice (STATE.kpKinds by index) taken while the length and the gas allow -- the
     narrowing ones first, so the order of the choices does not matter */
  function _kpKindsOf(s) {
    s = s || STATE;
    if (_kpIsFp(s)) return [];   /* v409 the fitness: no bays */
    var us = (s.isMetric === false), base = KP_N0[_kpN(s)].slice(), kk = Array.isArray(s.kpKinds) ? s.kpKinds : [], KL = KP_KINDS, i, pass;
    for (pass = 0; pass < 2; pass++) for (i = 0; i < base.length; i++) {
      var want = kk[i], cur = base[i];
      if (typeof want !== 'string' || KL.indexOf(want) < 0 || want === cur) continue;
      var dL = _kpNat(us, want) - _kpNat(us, cur), dG = (KP_GAS[want] ? 1 : 0) - (KP_GAS[cur] ? 1 : 0);
      if (pass === 0 && (dL > 1e-9 || dG > 0)) continue;
      var tryK = base.slice(); tryK[i] = want;
      if (_kpKindsOK(s, tryK)) base[i] = want;   /* v407 the cap, the gas (_kpKindsOK) */
    }
    return base;
  }
  function _kpL(s) { return _kpLOf(s, _kpKindsOf(s)); }
  function _kpRange(s) { var l = _kpL(s); return { min: l, max: l }; }   /* v405 the length is the bays' (the floating bed's way) */
  function _kpWRange(s) { var d = _kpD(s); return { min: d, max: d }; }   /* the depth is fixed */
  /* v405 a design saved before the switch: its number from its length (the v379 rule: the grill and the sink, then a drawer, a trash
     drawer, a drawer while they fit with 5 cm to spare) */
  function _kpNFromLen(s, Lx) {
    var P = _kpProf(s), us = ((s || STATE).isMetric === false), Li = (+Lx || _kpU(s, 'L0')) - 2 * P.sd, used = _kpNat(us, 'grill') + _kpNat(us, 'sink') + 3 * P.st, n = 2, ex = ['drawer', 'trash', 'drawer'], k;
    for (k = 0; k < ex.length; k++) { var w = _kpNat(us, ex[k]) + P.st; if (used + w + 0.05 <= Li + 1e-6) { used += w; n++; } }
    return Math.max(3, Math.min(5, n));
  }
  function _kpW(s) { return _kpD(s); }
  /* v379 the counter's equipment, a bay at a time (the + disc on the
     worktop cycles it): a drop-in on the top over its module, a module
     alone, or the fridge in place of a module */
  var KP_KINDS = ['grill', 'sink', 'kamado', 'burner', 'pizza', 'fridge', 'drawer', 'door', 'ddoor', 'trash'];
  /* the kinds a pod can take: the length's cap, the gas bottle's manifold (v409 the fitness: no bays) */
  function _kpKindsOK(s, kinds) {
    if (_kpIsFp(s)) return true;
    var L = _kpLOf(s, kinds), nG = 0, i;
    for (i = 0; i < kinds.length; i++) if (KP_GAS[kinds[i]]) nG++;
    return !(L > _kpLmax(s) + 1e-6 || nG > KP.GAS_MAX);
  }
  function _kpModW(us, f) { return ({ combo: us ? 0.762 : 0.765, ddoor: us ? 0.7112 : 0.710, drawer: us ? 0.4064 : 0.405, sdoor: us ? 0.4064 : 0.405, trash: us ? 0.3556 : 0.355 })[f] || 0; }
  var KP_MOD_CODE = { combo: KP.COMBO, ddoor: KP.DDOOR, drawer: KP.DRAWER, sdoor: KP.SDOOR, trash: KP.TRASH };
  var KP_GAS = { grill: 1, burner: 1, pizza: 1 };   /* v382 the kinds on the gas bottle (at most KP.GAS_MAX: its 3-way manifold) */
  var KP_SVC_BOX = { manifold: 1, dropear: 1, jbox: 1, socket: 1, 'switch': 1, wlight: 1, psu: 1 };   /* v382 the services' boxes: pieces drawn by _buildKitchenPod's services */
  /* the kamado's cutout: the egg's radius where it passes the top's face, 3 mm free */
  function _kpKamCut() { var q = KP.KAM_UP / KP.KAM_RY; return KP.KAM_RX * Math.sqrt(1 - q * q) + 0.003; }
  /* what kind k takes in a bay w wide between the uprights (st): { front: the module under it (null: the face closed), top: the drop-in / tabletop
     item, fridge } -- or null when it does not fit (the top items kept inside the uprights' centres) */
  function _kpFit(us, k, w, st) {
    var e = 1e-6, fits = function (f) { return w + e >= _kpModW(us, f); };
    var cab = fits('ddoor') ? 'ddoor' : fits('sdoor') ? 'sdoor' : null;
    switch (k) {
      case 'grill':  return fits('combo') ? { front: 'combo', top: 'grill' } : null;
      case 'sink':   return fits('sdoor') ? { front: cab, top: 'sink' } : null;
      case 'kamado': return (w + e >= 2 * _kpKamCut() && w + st - 0.02 + e >= 2 * KP.KAM_RX) ? { front: cab, top: 'kamado' } : null;
      case 'burner': return (w + e >= KP.BURN_W + 0.02 && w + st - 0.02 + e >= KP.BURN_PW) ? { front: cab, top: 'burner' } : null;
      case 'pizza':  return (w + st - 0.02 + e >= KP.PIZZA_W) ? { front: cab, top: 'pizza' } : null;
      case 'fridge': return (w + e >= (us ? KP.FRIDGE_W_US : KP.FRIDGE_W) + 0.004) ? { front: null, top: null, fridge: true } : null;
      case 'drawer': return fits('drawer') ? { front: 'drawer', top: null } : null;
      case 'door':   return fits('sdoor') ? { front: 'sdoor', top: null } : null;
      case 'ddoor':  return fits('ddoor') ? { front: 'ddoor', top: null } : null;
      case 'trash':  return fits('trash') ? { front: 'trash', top: null } : null;
    }
    return null;
  }
  /* a kind's own bay width (its module's; the fridge's; the kamado and the
     pizza oven a 50 cm / US 20 in. bay over a single door) */
  function _kpNat(us, k) {
    switch (k) {
      case 'grill': return _kpModW(us, 'combo');
      case 'sink': case 'ddoor': return _kpModW(us, 'ddoor');
      case 'kamado': case 'pizza': return us ? 0.508 : 0.50;
      case 'fridge': return (us ? KP.FRIDGE_W_US : KP.FRIDGE_W) + 0.004;
      case 'trash': return _kpModW(us, 'trash');
    }
    return _kpModW(us, 'sdoor');   /* burner, drawer, door */
  }
  /* the counter's bays left to right (v405: their number on the top switch, each its kind's own width -- _kpKindsOf); kind0 the
     number's default; what is left of the inner length (none but rounding) spread over the bays */
  function _kpBays(s, Li, st) {
    var us = ((s || STATE).isMetric === false), kinds = _kpKindsOf(s), base = KP_N0[_kpN(s)], bays = [], used = (kinds.length + 1) * st, nGas = 0, k;
    for (k = 0; k < kinds.length; k++) { bays.push({ kind0: base[k], kind: kinds[k] }); used += _kpNat(us, kinds[k]); if (KP_GAS[kinds[k]]) nGas++; }
    var spare = (Li - used) / bays.length;
    for (k = 0; k < bays.length; k++) {
      var bk = bays[k], f;
      bk.w = _kpNat(us, bk.kind) + spare;
      f = _kpFit(us, bk.kind, bk.w, st) || { front: null, top: null };
      bk.key = bk.kind; bk.front = f.front; bk.top = f.top; bk.fridge = !!f.fridge;
      bk.mw = f.front ? _kpModW(us, f.front) : f.fridge ? (us ? KP.FRIDGE_W_US : KP.FRIDGE_W) : 0;
      bk.code = f.front ? KP_MOD_CODE[f.front] : null;
    }
    bays.Li = Li; bays.used = used; bays.nGas = nGas;
    return bays;
  }
  function _kpLayout(s) {
    s = s || STATE;
    var P = _kpProf(s), us = (s.isMetric === false), ang = _kpAng(s), open = _kpOpen(s), L = _kpL(s), D = _kpD(s), i, j, k, sx, sz;
    var steelF = (_kpFrame(s) === 'steel'), cst = _kpCst(s), csd = _kpCsd(s);   /* v406 the counter frame's section */
    var fit = _kpIsFp(s);   /* v407 GARDEN POD Fitness: no counter (v409 no back wall: the back the front's mirror -- MX below) */
    var st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, p = P.p, jt = P.jt, jh = P.jh, ft = P.ft, fw = P.fw, bt = P.bt, bwd = P.bwd, tc = P.tc, cw = P.cw, tb = P.tb, wb = P.wb;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.1524 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len70 = us ? 0.0699 : 0.07, len60 = us ? 0.0635 : 0.06, len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], gscrews = [], uheads = [], sheets = [], missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    /* v409 THE MIRROR: the fitness's back side is the front's own code run again with MX = -1 (x mirrored, the roof's line read at
       the mirrored x -- yL / yT), its ids + mid ('-k') */
    var MX = 1, mid = '';
    function mv(v) { return [MX * v[0], v[1], v[2]]; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id + mid, box: [MX * x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { if (MX < 0 && plane === 'xy') pts = pts.map(function (q) { return [-q[0], q[1]]; }).reverse(); pieces.push({ kind: kind, code: code, len: len, id: id + mid, poly: pts, plane: plane, c: c, t: t }); }
    function obox(kind, code, len, id, c, u, v, n, du, dv, dn) { var n1 = mv(n); if (MX < 0) n1 = [-n1[0], -n1[1], -n1[2]]; pieces.push({ kind: kind, code: code, len: len, id: id + mid, obox: { c: mv(c), u: mv(u), v: mv(v), n: n1, d: [du, dv, dn] } }); }   /* mirrored: n turned back (a right-handed basis: the faces outward) */
    function scr0(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function scr(kind, code, x, y, z, d, ln, r) { scr0(kind, code, MX * x, y, z, mv(d), ln, r); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    /* a screw at the first of its spots whose shank keeps 3 mm off every fastener placed so far (the modern house's) */
    function scrClear(kind, code, cands, d, ln, r) {
      var d1 = mv(d), nn = Math.sqrt(d1[0] * d1[0] + d1[1] * d1[1] + d1[2] * d1[2]) || 1, dd = [d1[0] / nn, d1[1] / nn, d1[2] / nn], rr = r || 0.003, m, q2;
      for (m = 0; m < cands.length; m++) {
        var c0 = mv(cands[m]), c1 = [c0[0] + dd[0] * ln, c0[1] + dd[1] * ln, c0[2] + dd[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var f = fas[q2], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr0(kind, code, c0[0], c0[1], c0[2], dd, ln, r); return true; }
      }
      var cq = mv(cands[0]);
      scr0(kind, code, cq[0], cq[1], cq[2], dd, ln, r);
      return false;
    }
    function sheet(kind, code, id, pts, holes, o, U, V, N, t) {
      var area = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) area -= _phArea(holes[q]);
      sheets.push({ kind: kind, code: code, id: id, pts: pts, holes: (holes && holes.length) ? holes : null, o: o, U: U, V: V, N: N, t: t, area: area });
      return area;
    }
    var fixSp = _kpU(s, 'FIX_SP'), sp = _kpU(s, 'SP');
    var X0 = -D / 2, X1 = D / 2, Z1 = L / 2, ext = P.ow + bt + tc;   /* the walls' skin past the framing: OSB, batten, cladding (the membrane thin) */
    var clad = _kpClad(s);   /* v405 the cladding on the fourth switch: 'h' horizontal boards, 'v' upright boards, 'bb' board & batten */
    var PCm = KP_PCLAD[clad] || null, upB = (clad === 'h' || !!(PCm && !PCm.across)), cladP = 0;
    var pTapeL = 0;   /* v413 the black tape on the battens / stiles behind open joints */
    var pLen = us ? 0.0254 : 0.025, pFixC = 'FAS00225';   /* the folded corners' sealing screws FAS00225 25 mm / 1 in. (every panel) */   /* v413 a panel cladding (upB: on the upright battens) */
    var pW = PCm ? (us ? (PCm.w_us || 0) : (PCm.w || 0)) : 0, pH = PCm ? (us ? (PCm.h_us || 0) : (PCm.h || 0)) : 0, pG = PCm ? (PCm.gap || 0) : 0;
    /* the panels' spans from a to b, each <= w long, the joints on the supports (sup) where one is near enough */
    function pSpans(a, b, sup, w) {
      if (!w) return [[a, b]];
      var out = [], cur = a, S = (sup || []).slice().sort(function (p1, p2) { return p1 - p2; });
      while (cur < b - 0.01) {
        var tg = cur + w, end = b, q;
        if (tg < b - 0.05) { end = tg; for (q = S.length - 1; q >= 0; q--) if (S[q] <= tg + 1e-6 && S[q] > cur + Math.min(0.30, w / 2)) { end = S[q]; break; } }
        out.push([cur, end]); cur = end;
      }
      return out;
    }
    /* THE LEVELS: the base's underside / top, the deck's top, the header */
    var yBB = _kpYBB(s), yBt = yBB + bh, yF = yBt + tb, yHt = yF + _kpU(s, fit ? 'FP_HDR' : 'HDR_TOP'), yHb = yHt - bh;   /* v409 the fitness's higher */
    /* THE ROOF'S LINE: the rafters hung off the header's back face xHb (their top flush with its top), falling to the back */
    var th = KP.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = jh / cs, oV = P.orf / cs, xHb = X1 - bw;
    function yL(x) { return yHt - dV - (xHb - MX * x) * tn; }   /* the rafters' underside (v409 MX: the back side's x mirrored) */
    function yT(x) { return yL(x) + dV; }                   /* their top = the roof's plane under the OSB */
    var xBi = X0 + (fit ? p : sd), yPB = yL(xBi), Zi = Z1 - sd, Li = 2 * Zi;   /* the back wall's inner face, its plate's top (the seat); the inner length (v409 the fitness: the back posts' inner face) */
    var yHtK = yT(X0), yHbK = yHtK - bh;   /* v409 the fitness's back header: its top the roof's plane at its outer face (the plane falls to the back) */
    var stV = st / cs, wbV = wb / cs;
    /* the skins (walls, flap) start just over the base's top, clear of the U heads' flanges: the base shows as a plinth */
    var uFl = Math.min(KP.U_FL, bh - 0.004), ySk0 = Math.max(yBt - 0.005, yBB + uFl + 0.002);

    /* THE FOUNDATION: a ground screw + U head under the front and back beams, 12 nails into the beam's faces (v405 or a precast pad,
       or a poured footing + wet-set U anchor: the switch) */
    var found = _kpFound(s), yH = _kpYH(s, yBB), blocks = [], pours = [];
    var jGrid = _phGrid(-Z1, Z1, sp, jt).slice(1, -1).filter(function (z) { return Math.abs(z) < Z1 - bw - jt / 2 - 0.02; });
    function offJoists(z) {   /* a pier's U head (and its inner flange) kept off the joists' ends (v405 a pad's top: off their hangers' seats) */
      var need = ((found === 'block') ? _kpU(s, 'FD_BLK_TOP') / 2 + 0.0015 : bw / 2) + jt / 2 + 0.015, q;
      for (q = 0; q < jGrid.length; q++) if (Math.abs(z - jGrid[q]) < need) z = jGrid[q] + ((z >= jGrid[q]) ? need : -need);
      return Math.max(-Z1 + bw, Math.min(Z1 - bw, z));
    }
    function pier(x, z, id) {
      if (found === 'block') { blocks.push({ x: x, z: z, a: 0, w: _kpU(s, 'FD_BLK'), wt: _kpU(s, 'FD_BLK_TOP'), y0: yH - _kpU(s, 'FD_BLK_H'), y1: yH, id: id }); return; }   /* v405 the base resting on it: nothing to fix */
      if (found === 'pier') pours.push({ x: x, z: z, a: 0, w: _kpU(s, 'FD_PIER_W'), y1: yH, id: id });
      else gscrews.push({ x: x, z: z, r: _kpU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yBB, w: bw, a: 0, id: id, wet: (found === 'pier') });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
        scr('nail-uhead', KP.UNAIL, x + sd2 * (bw / 2 + KP.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
      }
    }
    var pin = _kpU(s, 'PIER_IN'), zp0 = -Z1 + pin, zp1 = Z1 - pin, np = Math.max(1, Math.ceil((zp1 - zp0) / _kpU(s, 'PIER_SP') - 1e-9));
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i <= np; i++) pier(sx * (X1 - bw / 2), offJoists(zp0 + (zp1 - zp0) * i / np), (sx < 0 ? 'b' : 'f') + (i + 1));
    /* THE BASE: the front and back beams the full length, the end beams between them */
    for (sx = -1; sx <= 1; sx += 2) box('base', KP.BASE, ceil2(L), 'base-' + (sx < 0 ? 'b' : 'f'), sx * (X1 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
    var ebL = D - 2 * bw;
    for (sz = -1; sz <= 1; sz += 2) {
      box('base', KP.BASE, ceil2(ebL), 'base-' + (sz < 0 ? 'l' : 'r'), 0, (yBB + yBt) / 2, sz * (Z1 - bw / 2), ebL, bh, bw);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-base', KP.BASE_SCREW, sx * X1, yBB + bh * (0.3 + 0.4 * k), sz * (Z1 - bw / 2), [-sx, 0, 0], len200);
    }
    /* THE JOISTS between the beams at <= 60 cm, in joist hangers (4 nails into the beam, 2 into the joist) */
    var nHang = 0, hT = 0.0015, jL = D - 2 * bw;
    function hanger(id, x, yTop, z, ox, h, w, hk) {
      hk = hk || 'hanger';   /* the joists' 'hanger', the rafters' 'rhanger' (their own assembly step, after the header) */
      /* a U hanger on a face at x (ox = +1 its member runs to +x): the seat under the member, the sides, the flanges on the face */
      box(hk, KP.HANGER, 0, id, x + ox * 0.03, yTop - h - hT / 2, z, 0.06, hT, w + 2 * hT);
      for (var e = -1; e <= 1; e += 2) {
        box(hk, null, 0, id + '-s' + e, x + ox * 0.03, yTop - h / 2 - 0.01, z + e * (w / 2 + hT / 2), 0.06, h - 0.02, hT);
        box(hk, null, 0, id + '-f' + e, x + ox * hT / 2, yTop - h / 2 - 0.01, z + e * (w / 2 + 0.02), hT, h - 0.02, 0.03);
        for (var r2 = 0; r2 < 2; r2++) scr('nail-' + hk, KP.UNAIL, x + ox * hT, yTop - h * (0.3 + 0.4 * r2), z + e * (w / 2 + 0.02), [-ox, 0, 0], len38, 0.0019);
        scr('nail-' + hk, KP.UNAIL, x + ox * 0.035, yTop - h * (0.5 + 0.12 * e), z + e * (w / 2 + hT), [0, 0, -e], len38, 0.0019);   /* the two off each other in height */
      }
      nHang++;
    }
    for (i = 0; i < jGrid.length; i++) {
      box('joist', KP.JOIST, ceil2(jL), 'joist-' + (i + 1), 0, yBt - jh / 2, jGrid[i], jL, jh, jt);
      hanger('hanger-j' + (i + 1) + 'b', X0 + bw, yBt, jGrid[i], 1, jh, jt);
      hanger('hanger-j' + (i + 1) + 'f', X1 - bw, yBt, jGrid[i], -1, jh, jt);
    }
    /* THE DECK: 1x6 boards along the length from the front, the gaps even; the front row between the posts */
    var nRow = Math.max(1, Math.floor((D + 0.003) / (wb + 0.003))), gp = (nRow > 1) ? (D - nRow * wb) / (nRow - 1) : 0;
    var supZ = jGrid.slice(0), deckRows = [];
    /* the counter's uprights (their toe screws land in the deck there): a deck screw within reach of one is left out */
    var upZ = [], upX = X0 + sd + _kpU(s, 'MOD_GAP') + _kpU(s, 'MOD_D') - P.pt - (steelF ? csd / 2 : 0.065), zu = -(Z1 - sd) + cst / 2;   /* v406 the frame's uprights */
    upZ.push(zu); _kpBays(s, 2 * (Z1 - sd), cst).forEach(function (b) { zu += cst + b.w; upZ.push(zu); });
    for (i = 0; i < nRow; i++) {
      var xr1 = X1 - i * (wb + gp), xr0 = xr1 - wb, zd = (i === 0 || (fit && i === nRow - 1)) ? Z1 - p : Z1, xc = (xr0 + xr1) / 2;   /* v409 the fitness: the back row between its posts too */
      box('deck', KP.DECK, ceil2(2 * zd), 'deck-' + (i + 1), xc, yBt + tb / 2, 0, wb, tb, 2 * zd);
      deckRows.push([xr0, xr1]);
      for (j = 0; j < supZ.length; j++) {
        if (Math.abs(supZ[j]) > zd - 0.03) continue;
        for (k = -1; k <= 1; k += 2) {
          var dsx = xc + k * wb / 4, dsz = supZ[j] + k * 0.008;
          if (Math.abs(dsx - upX) < 0.03 && upZ.some(function (u) { return Math.abs(u - dsz) < 0.03; })) continue;
          scr('screw-deck', KP.DECK_SCREW, dsx, yF, dsz, [0, -1, 0], len50);
        }
      }
    }

    /* a spot over a deck board near x (the screws down through a sill land in a board, not in a gap) */
    function deckX(x) {
      var best = x, bd = 1e9;
      for (var q = 0; q < deckRows.length; q++) { var a = deckRows[q][0] + 0.012, b = deckRows[q][1] - 0.012, c = Math.max(a, Math.min(b, x)); if (Math.abs(c - x) < bd) { bd = Math.abs(c - x); best = c; } }
      return best;
    }
    /* THE FRONT POSTS (4x4) on the front beam up to the header, 4 toe screws each (v409 the fitness's back posts: the same mirrored, up
       to its back header) */
    function sidePosts(yHb) {
    for (sz = -1; sz <= 1; sz += 2) {
      box('post', KP.POST, ceil2(yHb - yBt), 'post-' + (sz < 0 ? 'l' : 'r'), X1 - p / 2, (yBt + yHb) / 2, sz * (Z1 - p / 2), p, yHb - yBt, p);
      for (k = -1; k <= 1; k += 2) {
        scr('screw-post', KP.FRAME_SCREW, X1 - p / 2 + k * p / 4, yBt + 0.045, sz * (Z1 - p), [0, -0.8, sz * 0.6], len100);   /* from the inner face down into the front beam */
        scrClear('screw-post', KP.FRAME_SCREW, [[X1, yBt + 0.07, sz * (Z1 - p * (0.5 + 0.2 * k))], [X1, yBt + 0.07, sz * (Z1 - p * (0.5 + 0.35 * k))], [X1, yBt + 0.08, sz * (Z1 - p * (0.5 + 0.1 * k))]], [-0.45, -0.89, 0], len100);  /* from the front face, clear of the inner face's pair */
      }
    }
    }
    sidePosts(yHb);
    if (fit) { MX = -1; mid = '-k'; sidePosts(yHbK); MX = 1; mid = ''; }
    /* THE BACK WALL: the full length on the deck, its plate at the rafters' seat; studs on a 60 cm (US 24 in.) grid, the rafters over them */
    var bGrid = _phGrid(-Z1, Z1, sp, st), yP0 = yF + st, yTP0 = yPB - st;
    if (!fit) {   /* v409 the fitness: no back wall (bGrid: the rafters') */
    box('plate', KP.STUD, ceil2(L), 'plate-b', X0 + sd / 2, yF + st / 2, 0, sd, st, L);
    box('tplate', KP.STUD, ceil2(L), 'tplate-b', X0 + sd / 2, yPB - st / 2, 0, sd, st, L);
    for (i = 0; i < bGrid.length; i++) {
      box('stud', KP.STUD, ceil2(yTP0 - yP0), 'stud-b' + (i + 1), X0 + sd / 2, (yP0 + yTP0) / 2, bGrid[i], sd, yTP0 - yP0, st);
      for (k = -1; k <= 1; k += 2) {
        scr('screw-stud', KP.STUD_SCREW, X0 + sd / 2 + k * sd / 4, yF, bGrid[i], [0, 1, 0], len120);
        scr('screw-tplate', KP.STUD_SCREW, X0 + sd / 2 + k * sd / 4, yPB, bGrid[i], [0, -1, 0], len120);
      }
      if (i + 1 < bGrid.length) scr('screw-plate', KP.PLATE_SCREW, X0 + sd / 2, yP0, (bGrid[i] + bGrid[i + 1]) / 2, [0, -1, 0], len120);
    }
    }
    /* THE END WALLS between the back wall and the posts: a stud at the back, studs at <= 60 cm to the post, the raking plate under the end rafter */
    var eFirst = xBi + st / 2, ePost = xHb + p / 2, nE = Math.max(1, Math.ceil((ePost - eFirst) / sp - 1e-9)), eStuds = [];
    if (fit) { var sLad = _kpU(s, 'LAD_W') / 2 - KP.LAD_SW / 2; eStuds = (X1 - p / 2 > 0.60) ? [-sLad, 0, sLad] : [0]; }   /* v409 the fitness: between its posts, the pulley's in the middle (v411 at 0.50 m deep the posts carry the wall bars' rails) */
    else for (k = 0; k < nE; k++) eStuds.push(eFirst + (ePost - eFirst) * k / nE);
    var xSB = fit ? X1 - p / 2 : X1 + fw + tc - KP.STRUT_BX;   /* the gas strut's lower bracket (v411 the fitness's 0.50 m: on the post's inner face, no block) */
    var sbA = -1e9;
    for (k = 0; k < eStuds.length && !fit; k++) if (eStuds[k] + st / 2 < xSB - 0.03) sbA = Math.max(sbA, eStuds[k] + st / 2);
    var nEStud = 0;
    for (sz = -1; sz <= 1; sz += 2) {
      var ez = sz * (Z1 - sd / 2), eid = (sz < 0) ? 'l' : 'r';
      box('plate', KP.STUD, ceil2(xHb - xBi), 'plate-' + eid, (xBi + xHb) / 2, yF + st / 2, ez, xHb - xBi, st, sd);
      poly('rplate', KP.STUD, ceil2((xHb - xBi) / cs), 'rplate-' + eid, [[xBi, yL(xBi) - stV], [xHb, yL(xHb) - stV], [xHb, yL(xHb)], [xBi, yL(xBi)]], 'xy', ez, sd);
      for (k = 0; k < eStuds.length; k++) {
        var ea = eStuds[k] - st / 2, eb = eStuds[k] + st / 2;
        poly('estud', KP.STUD, ceil2(yL(eb) - stV - yP0), 'estud-' + eid + (k + 1), [[ea, yP0], [eb, yP0], [eb, yL(eb) - stV], [ea, yL(ea) - stV]], 'xy', ez, sd);
        nEStud++;
        for (var e2 = -1; e2 <= 1; e2 += 2) {
          scr('screw-stud', KP.STUD_SCREW, eStuds[k], yF, ez + e2 * sd / 4, [0, 1, 0], len120);
          scr('screw-tplate', KP.STUD_SCREW, eStuds[k], yL(eStuds[k]), ez + e2 * sd / 4, [0, -1, 0], len120);
        }
        if (k + 1 < eStuds.length) scr('screw-plate', KP.PLATE_SCREW, (eStuds[k] + eStuds[k + 1]) / 2, yP0, ez, [0, -1, 0], len120);
      }
      scrClear('screw-plate', KP.PLATE_SCREW, [0, 0.02, -0.02, 0.03, -0.03].map(function (dz) { return [(eStuds[eStuds.length - 1] + xHb) / 2, yP0, ez + dz]; }), [0, -1, 0], len120);   /* v410 off the base's screws (the fitness, US) */
      if (fit) scrClear('screw-plate', KP.PLATE_SCREW, [0, 0.02, -0.02, 0.03, -0.03].map(function (dz) { return [(xBi + eStuds[0] - st / 2) / 2, yP0, ez + dz]; }), [0, -1, 0], len120);   /* v409 the back post's bay (v410 off the base's screws: US) */
      /* the corner: three 6x100 from the end wall's first stud into the back wall's end stud */
      if (!fit) for (k = 0; k < 3; k++) scr('screw-corner', KP.FRAME_SCREW, xBi + st, yP0 + (yL(xBi) - stV - yP0) * (0.15 + 0.35 * k), sz * (Z1 - st / 2), [-1, 0, 0], len100);
      /* the plates' front ends into the post: 6x160 from the post's front face (v409 the fitness: their back ends the same into the back post) */
      for (var sw = 0; sw < (fit ? 2 : 1); sw++) {
        if (sw) { MX = -1; mid = '-k'; }
        scrClear('screw-post-wall', KP.LONG_SCREW, [[X1, yF + st / 2, ez + sz * 0.025], [X1, yF + st / 2, ez - sz * 0.025], [X1, yF + st / 2, ez + sz * 0.035], [X1, yF + st / 2, ez]], [-1, 0, 0], len160);   /* clear of the post's toe screws */
        scrClear('screw-post-wall', KP.LONG_SCREW, [[X1, yL(xHb) - stV / 2 - 0.01, ez + sz * 0.025], [X1, yL(xHb) - stV / 2 - 0.01, ez - sz * 0.025]], [-1, 0, 0], len160);   /* off the header's screws down into the post */
        MX = 1; mid = '';
      }
    }

    /* THE HEADER: a 4x6 on edge on the posts the full length, two 8x200 down into each post (v409 the fitness's back header the same) */
    function sideHeader(yHb, yHt) {
      box('header', KP.BASE, ceil2(L), 'header', X1 - bw / 2, (yHb + yHt) / 2, 0, bw, bh, L);
      for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2) scr('screw-header', KP.BASE_SCREW, X1 - bw / 2 + k * bw / 4, yHt, sz * (Z1 - p / 2), [0, -1, 0], len200);
    }
    sideHeader(yHb, yHt);
    if (fit) { MX = -1; mid = '-k'; sideHeader(yHbK, yHtK); MX = 1; mid = ''; }

    /* THE FRONT BAND and THE PIVOT: two 2x3 rails on edge on the header's face (the top one under the roof OSB's edge),
       a cladding board over them flush with the flap; the flap hangs under it, its hinge line at the band's foot */
    var cladA = 0, nBlock = 0, zS = Zi - KP.STRUT_IN;
    function sideBand(yHt) {   /* v409 the fitness's back band the same (yHt: its header's top) */
    var yR1t = Math.min(yT(X1), yT(X1 + fw)), yB1 = yT(X1 + fw) + oV, yB0 = yB1 - cw;   /* v409 the rail's top under the roof's plane over its width */
    /* v411 (Marek 2026-11-03 22:03 "ram vyklopnych dveri bude uvnitr, takze bude konstrukce seamless"): the flap between the end
       walls, which run on to its face -- the band's rails between the end walls' skins, the band board and the flap between the corner
       boards (5 mm free each side) */
    var xp = X1 + fw + tc, yp = yB0 - KP.FLAP_GAP / 2, yFt = yB0 - KP.FLAP_GAP, yFb = ySk0, Hf = yFt - yFb, Wf = 2 * (Z1 - ft) - 0.01;
    var Wb = 2 * (Z1 + ext + tb), Wr = 2 * Z1;   /* v412 (Marek 23:46 "proc jsou v rohu defekty, deska tam vystupuje az ke krytine"): the band board the roof's full width, over the corner boards' tops and the rakes' ends */
    box('brail', KP.FRAME, ceil2(Wr), 'brail-1', X1 + fw / 2, yR1t - ft / 2, 0, fw, ft, Wr);
    box('brail', KP.FRAME, ceil2(Wr), 'brail-2', X1 + fw / 2, yB0 + ft / 2, 0, fw, ft, Wr);
    var bzs = fixPts(-Z1 + 0.15, Z1 - 0.15, fixSp);   /* clear of the header's screws over the posts */
    for (k = 0; k < bzs.length; k++) {
      scr('screw-brail', KP.FRAME_SCREW, X1 + fw, Math.min(yHt, yR1t) - 0.012, bzs[k], [-1, 0, 0], len100);
      scr('screw-brail', KP.FRAME_SCREW, X1 + fw, yB0 + ft * 0.25, bzs[k] + 0.03, [-1, 0, 0], len100);
    }
    box('band', KP.CLAD, 0, 'band', X1 + fw + tc / 2, (yB0 + yB1) / 2, 0, tc, cw - 0.002, Wb);
    cladA += Wb * cw;
    /* v411 THE CORNERS: a 2x3 cleat on each post's front face at its outer edge (under the band's rails; 6x100 into the post), the end
       wall's skin on to it; a cladding board on the front edge over the cleat and the skin, flush with the flap's face, finish nails into
       the cleat and the rails */
    for (sz = -1; sz <= 1; sz += 2) {
      var zc0 = sz * (Z1 - ft / 2), yCl1 = yB0 - 0.001;
      box('ecleat', KP.FRAME, ceil2(yCl1 - yBt), 'ecleat-' + (sz < 0 ? 'l' : 'r'), X1 + fw / 2, (yBt + yCl1) / 2, zc0, fw, yCl1 - yBt, ft);
      fixPts(yBt + 0.16, yCl1 - 0.12, 0.45).forEach(function (yq) { scrClear('screw-ecleat', KP.FRAME_SCREW, [0, 0.03, -0.03, 0.05].map(function (dy) { return [X1 + fw, yq + dy, zc0 - sz * 0.006]; }), [-1, 0, 0], len100); });
      var zcb0 = sz * (Z1 - ft), zcb1 = sz * (Z1 + ext), yCb1 = yB0, hCb = yCb1 - ySk0;   /* v412 up to the band's foot */
      box(PCm ? PCm.kind : 'clad', PCm ? PCm.code : KP.CLAD, 0, 'clad-corner-' + (sz < 0 ? 'l' : 'r'), X1 + fw + tc / 2, (ySk0 + yCb1) / 2, (zcb0 + zcb1) / 2, tc, hCb, ft + ext);   /* v413 a panel cladding: the corner folded of the panel */
      if (PCm) cladP += (ft + ext) * hCb; else cladA += (ft + ext) * hCb;
      fixPts(ySk0 + 0.08, yCb1 - 0.04, fixSp).forEach(function (yq) { scrClear(PCm ? 'screw-pcorner' : 'nail-cclad', PCm ? pFixC : KP.TRIM_NAIL, [0, 0.015, -0.015].map(function (dy) { return [X1 + fw + tc, yq + dy, sz * (Z1 - 0.012)]; }), [-1, 0, 0], PCm ? pLen : len32, PCm ? 0.0025 : 0.0012); });
    }

    /* the strut blocks now that the pivot is known (the strut's foot STRUT_BY under the pivot) */
    var ySB = yp - KP.STRUT_BY;
    if (sbA > -1e8) for (sz = -1; sz <= 1; sz += 2) {
      var bL = xHb - sbA, ezb = sz * (Z1 - sd / 2);
      box('sblock', KP.STUD, ceil2(bL), 'sblock-' + (sz < 0 ? 'l' : 'r'), (sbA + xHb) / 2, ySB, ezb, bL, st, sd);
      nBlock++;
      for (k = -1; k <= 1; k += 2) {
        scr('screw-toe', KP.TOE, sbA + 0.035, ySB + st / 2, ezb + k * sd / 4, [-0.8, -0.6, 0], len80);
        scr('screw-toe', KP.TOE, xHb - 0.035, ySB + st / 2, ezb + k * sd / 4, [0.8, -0.6, 0], len80);
      }
    }
    return { yR1t: yR1t, yB1: yB1, yB0: yB0, xp: xp, yp: yp, yFt: yFt, yFb: yFb, Hf: Hf, Wf: Wf, ySB: ySB };
    }
    var SF = sideBand(yHt), SK = null, yR1t = SF.yR1t, yB1 = SF.yB1, yB0 = SF.yB0, xp = SF.xp, yp = SF.yp, yFt = SF.yFt, yFb = SF.yFb, Hf = SF.Hf, Wf = SF.Wf, ySB = SF.ySB;
    if (fit) { MX = -1; mid = '-k'; SK = sideBand(yHtK); MX = 1; mid = ''; }

    /* THE RAFTERS: 2x6 at <= 60 cm over the back wall's studs, hung off the header, a birdsmouth on the back plate */
    var ovB = _kpU(s, 'OV_B'), x0 = X0 - ovB, xRb = X0 + bw;   /* v409 the fitness: hung between its headers (xRb the back one's inner face) */
    var rafPts = fit ? [[xRb, yL(xRb)], [xHb, yL(xHb)], [xHb, yHt], [xRb, yT(xRb)]] : [[x0, yL(x0)], [X0, yL(X0)], [X0, yPB], [xBi, yPB], [xHb, yL(xHb)], [xHb, yHt], [x0, yT(x0)]];
    var rafL = ceil2((xHb - (fit ? xRb : x0)) / cs);
    for (i = 0; i < bGrid.length; i++) {
      var rz = bGrid[i];
      poly('rafter', KP.JOIST, rafL, 'rafter-' + (i + 1), rafPts, 'xy', rz, jt);
      if (i > 0 && i < bGrid.length - 1) {
        hanger('hanger-r' + (i + 1), xHb, yHt, rz, -1, dV + 0.06 * tn, jt, 'rhanger');
        if (fit) hanger('hanger-r' + (i + 1) + '-k', xRb, yT(xRb), rz, 1, dV + 0.06 * tn, jt, 'rhanger');
      } else {
        for (k = 0; k < 2; k++) scr('screw-rend', KP.LONG_SCREW, X1, yHt - 0.045 - 0.015 * k, rz + (k ? 0.012 : -0.012), [-1, 0, 0], len160);   /* the end rafters lie on the raking plates: two 6x160 through the header into their ends */
        if (fit) for (k = 0; k < 2; k++) scr('screw-rend', KP.LONG_SCREW, X0, yHtK - 0.045 - 0.015 * k, rz + (k ? 0.012 : -0.012), [1, 0, 0], len160);   /* v409 the back header's the same */
      }
      if (!fit) scr('screw-seat', KP.SEAT_SCREW, X0 + sd / 2, yT(X0 + sd / 2), rz, [0, -1, 0], len200);
    }

    /* THE WALLS' SKIN: OSB from just over the base's top (the back wall's up under the rafters, the end walls' up over the end
       rafters' faces), the membrane on it (billed), battens over the framing, the cladding in rows; the back wall's skin runs
       past the end walls' edges */
    var sheathA = 0;
    var bTop = yL(X0 - P.ow) - 0.003, Ub = [0, 0, 1], Vb = [0, 1, 0], Nb = [-1, 0, 0];
    var xEf = X1 + fw, xEb = fit ? -(X1 + fw) : X0;   /* v411 the end walls' skin on to the corner boards: over the cleats in front (the fitness: at the back too) */
    if (!fit) sheathA += sheet('sheath', KP.WALL_OSB, 'sheath-b', [[-(Z1 + P.ow), ySk0], [Z1 + P.ow, ySk0], [Z1 + P.ow, bTop], [-(Z1 + P.ow), bTop]], null, [X0, 0, 0], Ub, Vb, Nb, P.ow);   /* v409 the fitness: no back wall */
    for (sz = -1; sz <= 1; sz += 2) {
      var pe = [[sz * xEb, ySk0], [sz * xEf, ySk0], [sz * xEf, yT(xEf)], [sz * xEb, yT(xEb)]];
      sheathA += sheet('sheath', KP.WALL_OSB, 'sheath-' + (sz < 0 ? 'l' : 'r'), pe, null, [0, 0, sz * Z1], [sz, 0, 0], [0, 1, 0], [0, 0, sz], P.ow);
    }
    /* the end walls' cladding goes up under the rake board, whose top the roof's OSB overhangs */
    function eTop(x) { return yT(x) - wbV + 0.02; }
    /* the battens: on the back wall over every stud, on the end walls over the back corner, the studs and the post; 6x80 into the framing
       (v405 vertical boards: the battens laid across instead, rows at <= 60 cm, a 6x80 at every framing member they cross) */
    var bt0 = X0 - P.ow - bt, nBat = 0, batL = 0, cTopB = yL(X0 - ext) - 0.005;
    var eBat = [xEb + bwd / 2].concat(fit ? eStuds : eStuds.slice(1)).concat([xEf - bwd / 2]);   /* v409 the fitness: the first on the back post (v411 the end ones on the cleats) */
    var nClad = 0, xcB = X0 - ext + tc / 2, zcB = Z1 + ext, qE = eTop(0);   /* eTop(x) = tn x + qE */
    var batRows = [];
    /* v413 THE PANELS on the walls: the kitchen's back wall (round its corner line, up under the rafters), the end walls (up under the
       rake, cut on the slope); fibre cement / corten in rows, the joints open and over the battens; the corrugated sheet whole a wall */
    function pWalls(supB, supE) {
      var rowsOf = function (y0, y1) { return PCm.across ? [[y0, y1]] : pSpans(y0, y1, [], pH); };
      var cut = function (sp2, q, nq) { return [sp2[0] + (q > 0 ? pG / 2 : 0), sp2[1] - (q < nq - 1 ? pG / 2 : 0)]; };
      if (!fit) {
        var spB = PCm.across ? [[-zcB, zcB]] : pSpans(-zcB, zcB, supB, pW), rwB = rowsOf(ySk0, cTopB);
        rwB.forEach(function (rw, r) {
          var yy = cut(rw, r, rwB.length);
          spB.forEach(function (sp2, q) {
            var zz = cut(sp2, q, spB.length);
            box(PCm.kind, PCm.code, 0, 'pclad-b' + (r + 1) + '-' + (q + 1), xcB, (yy[0] + yy[1]) / 2, (zz[0] + zz[1]) / 2, tc, yy[1] - yy[0], zz[1] - zz[0]);
            nClad++;
          });
        });
      }
      for (var sp3 = -1; sp3 <= 1; sp3 += 2) {
        var zcP = sp3 * (Z1 + ext - tc / 2), spE = PCm.across ? [[xEb, xEf]] : pSpans(xEb, xEf, supE, pW), rwE = rowsOf(ySk0, Math.max(eTop(xEb), eTop(xEf)));
        rwE.forEach(function (rw, r) {
          var yy = cut(rw, r, rwE.length);
          spE.forEach(function (sp2, q) {
            var xx = cut(sp2, q, spE.length), rp = _gzClip([[xx[0], yy[0]], [xx[1], yy[0]], [xx[1], yy[1]], [xx[0], yy[1]]], tn, -1, qE);
            if (rp.length < 3 || _phArea(rp) < 1e-4) return;
            if (_gzArea(rp) < 0) rp.reverse();
            poly(PCm.kind, PCm.code, 0, 'pclad-' + (sp3 < 0 ? 'l' : 'r') + (r + 1) + '-' + (q + 1), rp, 'xy', zcP, tc);
            nClad++;
          });
        });
      }
    }
    if (upB) {   /* v413 + the upright-batten panels */
      for (i = 0; i < (fit ? 0 : bGrid.length); i++) {   /* v409 the fitness: no back wall */
        var bz = Math.max(-(Z1 - bwd / 2), Math.min(Z1 - bwd / 2, bGrid[i]));
        box('batten', KP.BATTEN, ceil2(cTopB - ySk0), 'batten-b' + (i + 1), bt0 + bt / 2, (ySk0 + cTopB) / 2, bz, bt, cTopB - ySk0, bwd);
        nBat++; batL += cTopB - ySk0;
        fixPts(yF + st + 0.13, Math.min(cTopB, yPB) - st - 0.13, fixSp).forEach(function (yy) { scr('screw-batten', KP.TOE, bt0, yy, bz, [1, 0, 0], len80); });   /* clear of the studs' screws at both ends */
      }
      for (sz = -1; sz <= 1; sz += 2) {
        var zb0 = sz * (Z1 + P.ow + bt / 2);
        for (k = 0; k < eBat.length; k++) {
          var bxa = eBat[k] - bwd / 2, bxb = eBat[k] + bwd / 2;
          poly('batten', KP.BATTEN, ceil2(eTop(bxb) - ySk0), 'batten-' + (sz < 0 ? 'l' : 'r') + (k + 1), [[bxa, ySk0], [bxb, ySk0], [bxb, eTop(bxb)], [bxa, eTop(bxa)]], 'xy', zb0, bt);
          nBat++; batL += eTop(eBat[k]) - ySk0;
          var bxs = eBat[k], bTopS = (k === 0) ? (fit ? SK.yB0 - 0.04 : yPB - 0.055) : (k === eBat.length - 1) ? yB0 - 0.04 : yL(bxs) - stV - 0.04;   /* v411 the cleats' tops */   /* v409 the fitness's back post: up to its header (v410 the kitchen's off the back battens' top screw at 2 deg) */
          fixPts(yF + st + 0.20, bTopS - st - 0.10, fixSp).forEach(function (yy) { scrClear('screw-batten', KP.TOE, [0, 0.03, -0.03, 0.05].map(function (dy) { return [bxs, yy + dy, sz * (Z1 + P.ow + bt)]; }), [0, 0, -sz], len80); });   /* v411 off the cleats' screws */   /* clear of the studs' screws, off the back battens' rows */
        }
      }

      /* the cladding rows: the back wall's up under the rafters, the end walls' up under the rake (the top rows cut on the slope) */
      if (PCm) pWalls(bGrid.map(function (zq) { return Math.max(-(Z1 - bwd / 2), Math.min(Z1 - bwd / 2, zq)); }), eBat);   /* v413 the panels */
      for (k = 0; !PCm && !fit && ySk0 + k * cw < cTopB - 0.01; k++) {
        var ya = ySk0 + k * cw, yb = Math.min(ya + cw - 0.002, cTopB);
        box('clad', KP.CLAD, 0, 'clad-b' + (k + 1), xcB, (ya + yb) / 2, 0, tc, yb - ya, 2 * zcB);
        nClad++;
      }
      for (sz = -1; sz <= 1 && !PCm; sz += 2) {
        var zc = sz * (Z1 + ext - tc / 2);
        for (k = 0; ySk0 + k * cw < eTop(X1) - 0.01; k++) {
          var y0r = ySk0 + k * cw, y1r = y0r + cw - 0.002;
          var rp = _gzClip([[xEb, y0r], [xEf, y0r], [xEf, y1r], [xEb, y1r]], tn, -1, qE);
          if (rp.length < 3 || _phArea(rp) < 1e-4) continue;
          if (_gzArea(rp) < 0) rp.reverse();
          poly('clad', KP.CLAD, 0, 'clad-' + (sz < 0 ? 'l' : 'r') + (k + 1), rp, 'xy', zc, tc);
          nClad++;
        }
      }
    } else {
      /* v405 the rows: the lowest over the back plate, the top one on the top plate, between them on the studs */
      batRows = fixPts(yF + bwd / 2 + 0.003, cTopB - bwd / 2 - 0.012, 0.60);
      var plateZ = [];   /* the back wall's plates: between the studs */
      for (i = 0; i + 1 < bGrid.length; i++) plateZ.push((bGrid[i] + bGrid[i + 1]) / 2);
      if (!fit) batRows.forEach(function (yb, r) {   /* v409 the fitness: no back wall */
        var rowL = 2 * (Z1 + P.ow), onPlate = (r === 0);   /* the lowest on the bottom plate between the studs; the others on the studs (the top one into their heads / the top plate) */
        box('batten', KP.BATTEN, ceil2(rowL), 'batten-bh' + (r + 1), bt0 + bt / 2, yb, 0, bt, bwd, rowL);
        nBat++; batL += rowL;
        (onPlate ? plateZ : bGrid).forEach(function (zq) {
          var zz = Math.max(-(Z1 - st / 2), Math.min(Z1 - st / 2, zq)), dzs = onPlate ? [0, 0.03, -0.03, 0.06, -0.06] : [0, 0.012, -0.012, 0.02, -0.02];
          scrClear('screw-batten', KP.TOE, dzs.map(function (dz) { return [bt0, yb, zz + dz]; }), [1, 0, 0], len80);
        });
      });
      for (sz = -1; sz <= 1; sz += 2) {
        var zb1 = sz * (Z1 + P.ow + bt / 2);
        batRows.forEach(function (yb, r) {
          var xs = Math.max(xEb, (yb + 1.5 * bwd + 0.008 - qE) / tn);   /* the row stops under the raking batten (the wall's top rises to the front) */
          if (xs > xEf - 0.20) return;
          poly('batten', KP.BATTEN, ceil2(xEf - xs), 'batten-' + (sz < 0 ? 'l' : 'r') + 'h' + (r + 1), [[xs, yb - bwd / 2], [xEf, yb - bwd / 2], [xEf, yb + bwd / 2], [xs, yb + bwd / 2]], 'xy', zb1, bt);
          nBat++; batL += xEf - xs;
          eBat.forEach(function (xq) {
            if (xq < xs + 0.02) return;
            var low = (yb < yF + st + 0.01), dxs = low ? [0, 0.02, -0.02, 0.035, -0.035] : [0, 0.012, -0.012], cands = [];
            [0, 0.014, -0.014].forEach(function (dy) { dxs.forEach(function (dx) { var xx = xq + dx; if (xx > xEb + 0.006 && xx < xEf - 0.006) cands.push([xx, yb + dy, sz * (Z1 + P.ow + bt)]); }); });   /* off the back wall's screw at the corner: a little up or down the batten */
            if (cands.length) scrClear('screw-batten', KP.TOE, cands, [0, 0, -sz], len80);
          });
        });
      }
      /* the raking batten under the rake board on each end wall (the boards' tops, the rake's screws), 6x80 into the end rafter */
      for (sz = -1; sz <= 1; sz += 2) {
        var zb3 = sz * (Z1 + P.ow + bt / 2), rbx0 = xEb, rbx1 = xEf;
        poly('batten', KP.BATTEN, ceil2((rbx1 - rbx0) / cs), 'batten-' + (sz < 0 ? 'l' : 'r') + 'rake', [[rbx0, eTop(rbx0) - bwd - 0.002], [rbx1, eTop(rbx1) - bwd - 0.002], [rbx1, eTop(rbx1) - 0.002], [rbx0, eTop(rbx0) - 0.002]], 'xy', zb3, bt);
        nBat++; batL += (rbx1 - rbx0) / cs;
        eBat.forEach(function (xq) {
          var yq = eTop(xq) - bwd / 2 - 0.002;
          scrClear('screw-batten', KP.TOE, [0, 0.012, -0.012].map(function (dx) { return [Math.max(xEb + 0.006, Math.min(xEf - 0.006, xq + dx)), yq - 0.008, sz * (Z1 + P.ow + bt)]; }), [0, 0, -sz], len80);
        });
      }
      /* the boards upright: the back wall's from the corner trims' line round, the end walls' from the back to the posts, each up
         under the rafters / the rake (cut on the slope) */
      if (PCm) pWalls(null, null);   /* v413 the corrugated sheet on the battens laid across */
      for (k = 0; !PCm && !fit && -zcB + k * cw < zcB - 0.01; k++) {
        var za = -zcB + k * cw, zb2 = Math.min(za + cw - 0.002, zcB);
        box('clad', KP.CLAD, 0, 'clad-bv' + (k + 1), xcB, (ySk0 + cTopB) / 2, (za + zb2) / 2, tc, cTopB - ySk0, zb2 - za);
        nClad++;
      }
      for (sz = -1; sz <= 1 && !PCm; sz += 2) {
        var zcv = sz * (Z1 + ext - tc / 2);
        for (k = 0; xEb + k * cw < xEf - 0.01; k++) {
          var xa2 = xEb + k * cw, xb2 = Math.min(xa2 + cw - 0.002, xEf);
          poly('clad', KP.CLAD, 0, 'clad-' + (sz < 0 ? 'l' : 'r') + 'v' + (k + 1), [[xa2, ySk0], [xb2, ySk0], [xb2, eTop(xb2)], [xa2, eTop(xa2)]], 'xy', zcv, tc);
          nClad++;
        }
      }
    }
    var wallA = (fit ? 0 : 2 * zcB * (cTopB - ySk0)) + 2 * (xEf - xEb) * ((eTop(xEb) + eTop(xEf)) / 2 - ySk0);
    if (PCm && PCm.tape) pTapeL += batL;
    if (PCm) cladP += wallA; else cladA += wallA;   /* v413 the panels' area apart */
    /* v405 board & batten: a 1x3 strip over every joint of the upright boards (clear of the corner trims and under the rake), a finish
       nail through it into the board at every batten row */
    var nStrip = 0, stripL = 0;
    if (clad === 'bb') {
      var sT = P.tt, sW = P.tw, xsB = X0 - ext - sT / 2;
      for (k = 1; !fit && -zcB + k * cw < zcB - sW - 0.01; k++) {
        var zj = -zcB + k * cw - 0.001;
        if (Math.abs(zj) + sW / 2 > zcB - sW - 0.004) continue;   /* clear of the back corner trims */
        var yS1 = yL(X0 - ext - sT) - 0.006;
        box('bstrip', KP.TRIM, ceil2(yS1 - ySk0), 'bstrip-b' + k, xsB, (ySk0 + yS1) / 2, zj, sT, yS1 - ySk0, sW);
        nStrip++; stripL += yS1 - ySk0;
        batRows.forEach(function (yb) { scr('nail-bstrip', KP.TRIM_NAIL, X0 - ext - sT, yb + 0.007, zj + 0.012, [1, 0, 0], len32, 0.0012); });   /* into the board right of the joint */
      }
      for (sz = -1; sz <= 1; sz += 2) {
        var zsE = sz * (Z1 + ext + sT / 2);
        for (k = 1; xEb + k * cw < xEf - sW - 0.012; k++) {
          var xj = xEb + k * cw - 0.001, yS2 = yT(xj) - wbV - 0.006;
          if (xj - sW / 2 < (fit ? xEb + 0.01 : X0 - ext + sW + 0.004) || xj + sW / 2 > xEf - 0.01) continue;   /* clear of the kitchen's back corner trims (v411 the corner boards on the front edge: none on the face) */
          box('bstrip', KP.TRIM, ceil2(yS2 - ySk0), 'bstrip-' + (sz < 0 ? 'l' : 'r') + k, xj, (ySk0 + yS2) / 2, zsE, sW, yS2 - ySk0, sT);
          nStrip++; stripL += yS2 - ySk0;
          batRows.forEach(function (yb) { if (yb < yS2 - 0.02) scr('nail-bstrip', KP.TRIM_NAIL, xj + 0.012, yb + 0.007, sz * (Z1 + ext + sT), [0, 0, -sz], len32, 0.0012); });
        }
      }
    }
    /* the corner trims: two at each back corner (the kitchen's), finish nails into the cladding (v411: the front edges and the fitness's
       back ones have their corner boards -- THE CORNERS) */
    var trims = 0, trimL = 0, tt2 = P.tt, tw2 = P.tw;
    function offJ(y) { if (clad !== 'h') return y; var r = (y - ySk0) % cw; return (r > cw - 0.008) ? y - 0.01 : (r < 0.006) ? y + 0.01 : y; }   /* v410 a finish nail off the cladding rows' joints */
    for (sz = -1; sz <= 1 && !fit; sz += 2) {
      var trK = PCm ? PCm.kind : 'trim', trC = PCm ? PCm.code : KP.TRIM, trL = PCm ? 0 : ceil2(cTopB - ySk0);   /* v413 a panel cladding: the corner folded of the panel */
      box(trK, trC, trL, 'trim-b' + sz, X0 - ext - tt2 / 2, (ySk0 + cTopB) / 2, sz * (Z1 + ext - tw2 / 2), tt2, cTopB - ySk0, tw2);
      box(trK, trC, trL, 'trim-e' + sz, X0 - ext + tw2 / 2, (ySk0 + cTopB) / 2, sz * (Z1 + ext + tt2 / 2), tw2, cTopB - ySk0, tt2);
      if (PCm) cladP += (tw2 + tt2) * (cTopB - ySk0); else { trims += 2; trimL += 2 * (cTopB - ySk0); }
      fixPts(ySk0 + 0.08, cTopB - 0.08, fixSp).forEach(function (yy) {
        scr(PCm ? 'screw-ptrim' : 'nail-trim', PCm ? pFixC : KP.TRIM_NAIL, X0 - ext - tt2, offJ(yy), sz * (Z1 + ext - tw2 / 2), [1, 0, 0], PCm ? pLen : len32, PCm ? 0.0025 : 0.0012);
        scr(PCm ? 'screw-ptrim' : 'nail-trim', PCm ? pFixC : KP.TRIM_NAIL, X0 - ext + tc / 2, offJ(yy), sz * (Z1 + ext + tt2), [0, 0, -sz], PCm ? pLen : len32, PCm ? 0.0025 : 0.0012);
      });
    }

    /* THE ROOF'S LAYERS: the OSB from the back fascia's face to the band's rail, over the rake boards; the metal over the underlay
       (one surface) with a standing seam every pan; the drip edge round it; the 1x6 fascia on the tails, a rake board each end */
    var xa = fit ? X0 - fw : x0 - tb, xb = X1 + fw, zR = Z1 + ext + tb, roofLen = 2 * zR, slope = (xb - xa) / cs;   /* v409 the fitness: from the back band's rail */
    poly('roofosb', KP.ROOF_OSB, 0, 'roofosb', [[xa, yT(xa)], [xb, yT(xb)], [xb, yT(xb) + oV], [xa, yT(xa) + oV]], 'xy', 0, roofLen);
    var roofCov = _kpRoof(s), seamOn = (roofCov === 'seam');   /* v405 the covering on its disc */
    var mT = (seamOn ? KP.SEAM_T : KP.EPDM_T) / cs, sH = seamOn ? KP.SEAM_H / cs : 0, xs0 = fit ? X0 - fw - tc - 0.005 : xa - 0.01, xs1 = X1 + fw + tc + 0.005, nPan = 1;   /* v409 the fitness: over its back band as over the front one */
    function yC(x) { return yT(x) + oV + 0.001; }
    var roofA = slope * roofLen, roofTop = yC(xs1) + mT + sH, green = null;
    if (seamOn) {
      poly('cover', KP.SEAM, 0, 'cover', [[xs0, yC(xs0)], [xs1, yC(xs1)], [xs1, yC(xs1) + mT], [xs0, yC(xs0) + mT]], 'xy', 0, roofLen + 0.02);
      var pan = _kpU(s, 'SEAM_PAN');
      nPan = Math.max(1, Math.ceil((roofLen + 0.02) / pan - 1e-9));
      for (k = 1; k < nPan; k++) poly('seam', null, 0, 'seam-' + k, [[xs0, yC(xs0) + mT], [xs1, yC(xs1) + mT], [xs1, yC(xs1) + mT + sH], [xs0, yC(xs0) + mT + sH]], 'xy', -zR - 0.01 + (roofLen + 0.02) * k / nPan, KP.SEAM_W);
    } else {
      /* the membrane in one piece over the OSB (turned down under the drip edge: its area + the edges' 6 cm) */
      poly('epdm', null, 0, 'epdm', [[xs0, yC(xs0)], [xs1, yC(xs1)], [xs1, yC(xs1) + mT], [xs0, yC(xs0) + mT]], 'xy', 0, roofLen + 0.02);
      var mbA = (roofLen + 0.02) * (xs1 - xs0) / cs + 0.06 * (2 * roofLen + 2 * slope);
      if (roofCov === 'epdm') missing.push(us ? { name: KP.EPDM_NAME, qty: Math.round(mbA * KP.WASTE * 10.7639 * 100) / 100, unit: 'ft2' } : { name: KP.EPDM_NAME, qty: Math.round(mbA * KP.WASTE * 100) / 100, unit: 'm2' });
      else {
        /* v412 (Marek 23:46 "zelena strecha ma vypadat realisticky a pres celou sirku"): THE GREEN ROOF THE ROOF'S FULL WIDTH -- no timber
           kerbs; a perforated aluminium edge angle round the roof's edge (its foot screwed through the membrane into the OSB, the membrane
           turned up its face), the gravel strip at the low eave behind the same angle; the drainage mat, the substrate and the sedum from
           the strip to the angles (was: 2x4 kerbs over the end rafters and the header, the sedum between them) */
        var yK = function (x) { return yC(x) + mT; }, gvW = _kpU(s, 'GR_GRAVEL'), gH = _kpU(s, 'GR_H'), xg = xs0 + gvW, eT = 0.002, hE = gH + 0.015;
        var xE0 = xs0 + 0.002, xE1 = xs1 - 0.005, zE = zR, gzW = 2 * (zE - eT) - 0.002, gvT = gH * 0.6;
        for (sz = -1; sz <= 1; sz += 2) poly('gstop', null, 0, 'green-edge-' + (sz < 0 ? 'l' : 'r'), [[xE0, yK(xE0)], [xE1, yK(xE1)], [xE1, yK(xE1) + hE], [xE0, yK(xE0) + hE]], 'xy', sz * (zE - eT / 2), eT);
        poly('gstop', null, 0, 'green-edge-f', [[xE1 - eT, yK(xE1 - eT)], [xE1, yK(xE1)], [xE1, yK(xE1) + hE], [xE1 - eT, yK(xE1 - eT) + hE]], 'xy', 0, 2 * zE);
        poly('rgravel', null, 0, 'roof-gravel', [[xs0 + 0.005, yK(xs0 + 0.005)], [xg, yK(xg)], [xg, yK(xg) + gvT], [xs0 + 0.005, yK(xs0 + 0.005) + gvT]], 'xy', 0, gzW);
        poly('gstop', null, 0, 'gravel-stop', [[xE0, yK(xE0)], [xE0 + 0.003, yK(xE0 + 0.003)], [xE0 + 0.003, yK(xE0 + 0.003) + gvT], [xE0, yK(xE0) + gvT]], 'xy', 0, gzW);
        var xsd0 = xg + 0.003, xsd1 = xE1 - eT - 0.002;
        poly('sedum', null, 0, 'sedum', [[xsd0, yK(xsd0)], [xsd1, yK(xsd1)], [xsd1, yK(xsd1) + gH], [xsd0, yK(xsd0) + gH]], 'xy', 0, gzW - 0.004);
        var perim = 2 * (xE1 - xE0) / cs + 2 * (2 * zE);
        var gA = (xsd1 - xsd0) / cs * gzW, gvA = gvW / cs * gzW, upA = perim * KP.GR_UP;
        var m2 = function (v) { return us ? Math.round(v * 10.7639 * 100) / 100 : Math.round(v * 100) / 100; }, u2 = us ? 'ft2' : 'm2';
        missing.push({ name: KP.GR_MEMB_NAME, qty: m2((mbA + upA) * KP.WASTE), unit: u2 });
        missing.push({ name: KP.GR_MAT_NAME, qty: m2((gA + gvA) * KP.WASTE), unit: u2 });
        missing.push(us ? { name: KP.GR_SUB_NAME, qty: Math.round(gA * _kpU(s, 'GR_SUB') * KP.WASTE * 1.30795 * 100) / 100, unit: 'yd3' } : { name: KP.GR_SUB_NAME, qty: Math.round(gA * KP.GR_SUB * KP.WASTE * 100) / 100, unit: 'm3' });
        missing.push({ name: KP.GR_SEDUM_NAME, qty: m2(gA * KP.WASTE), unit: u2 });
        missing.push(us ? { name: KP.GR_STOP_NAME, qty: Math.round(perim * KP.WASTE * 3.28084 * 100) / 100, unit: 'ft' } : { name: KP.GR_STOP_NAME, qty: Math.round(perim * KP.WASTE * 100) / 100, unit: 'm' });
        green = { area: gA, gravelM3: Math.round(gvA * gvT * 1000) / 1000, kerbL: 0, screws: 0, x0: xsd0, x1: xsd1, zW: gzW / 2 - 0.004, y0: yK(xsd0) + gH, y1: yK(xsd1) + gH, gx0: xs0 + 0.005, gx1: xg, gy0: yK(xs0 + 0.005) + gvT, gy1: yK(xg) + gvT };   /* v412 + the sedum's and the gravel's top faces (the plants drawn on them) */
        roofTop = Math.max(yK(xE1) + hE, yK(xsd1) + gH + 0.03);
      }
    }
    /* its + disc on the roof near the front edge, facing up and a little to the front (pushed with the counter's discs) */
    var roofDisc = { id: 'kp-roof', state: !seamOn, cyc: true, at: [X1 - 0.30, (green ? yK(X1 - 0.30) + gH + 0.04 : yC(X1 - 0.30) + mT + sH + 0.03), 0], r: KP.DISC_R };   /* v412 over the sedum's plants (v415 level, not on the roof's slope: Marek 09:44 "Cykler buttons maji byt na vodorovne nebo svisle rovine, urcite ne sikme (strecha)") */
    /* the back fascia on the tails, under the OSB's edge, two screws a tail */
    var yFt0 = yT(xa) - 0.001;
    if (!fit) {   /* v409 the fitness: no tails (its back band instead) */
    box('fascia', KP.BOARD, ceil2(roofLen), 'fascia-b', x0 - tb / 2, yFt0 - wb / 2, 0, tb, wb, roofLen);
    for (i = 0; i < bGrid.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', KP.FASCIA_SCREW, x0 - tb, yFt0 - wb * (0.3 + 0.35 * k), bGrid[i], [1, 0, 0], len50);
    }
    /* the rake boards on the end walls' cladding under the OSB, from the back fascia to the band; 4.5x70 through the cladding into the battens */
    var xRk = fit ? X0 - fw : x0, rkL = ceil2((X1 + fw - xRk) / cs);   /* v409 the fitness: from its back band (v412 the rakes end behind the bands, which run over their ends) */
    for (sz = -1; sz <= 1; sz += 2) {
      var xq0 = xRk, xq1 = X1 + fw;
      poly('rake', KP.BOARD, rkL, 'rake-' + (sz < 0 ? 'l' : 'r'), [[xq0, yT(xq0) - wbV], [xq1, yT(xq1) - wbV], [xq1, yT(xq1) - 0.001], [xq0, yT(xq0) - 0.001]], 'xy', sz * (Z1 + ext + tb / 2), tb);
      for (k = 0; k < eBat.length; k++) scr('screw-rake', KP.RAKE_SCREW, eBat[k], yT(eBat[k]) - wbV + 0.012, sz * (Z1 + ext + tb), [0, 0, -sz], len70);
    }
    /* the drip edge: along the back eave, the front band, both rakes */
    var dripL = 2 * roofLen + 2 * slope, dripNails = Math.ceil(dripL / KP.DRIP_FIX);
    var xdB = fit ? xs0 : xa;   /* v409 the fitness: the back's the front's mirror */
    box('drip', KP.DRIP, 0, 'drip-b', xdB - 0.0015, yC(xdB) - 0.0275, 0, 0.003, 0.055, roofLen + 0.01);
    box('drip', KP.DRIP, 0, 'drip-f', xs1 + 0.0015, yC(xs1) - 0.0275, 0, 0.003, 0.055, roofLen + 0.01);
    for (sz = -1; sz <= 1; sz += 2) poly('drip', KP.DRIP, 0, 'drip-' + (sz < 0 ? 'l' : 'r'), [[xdB, yC(xdB) - 0.055], [xs1, yC(xs1) - 0.055], [xs1, yC(xs1)], [xdB, yC(xdB)]], 'xy', sz * (zR + 0.0015), 0.003);

    /* THE COUNTER along the back wall: the top's back edge on the wall's studs, the modules' face set back from its front */
    var fin = _kpFin(s), topT = (fin === 'acacia') ? P.topT : _kpU(s, 'SLAB_T'), topD = P.topD, yWt = yF + _kpU(s, 'TOP_H'), yWb = yWt - topT, xWf = xBi + topD;   /* v405 the finish on its disc: a 3 cm slab or the acacia */
    /* v406 the frame's section on its switch: 2x4s (st x sd) | the steel studs (cst x csd); every steel joint cut and folded, four
       4.8x19 framing screws a joint (billed: sJoints), into the deck / the wall's studs a 4.8x19 from inside the profile (drawn) */
    var fst = cst, fsd = csd, FK = steelF ? 'sframe' : 'cframe', FC = steelF ? KP.MSTUD : KP.STUD, sJoints = 0, sLen = us ? 0.01905 : 0.019;
    var xMb = xBi + _kpU(s, 'MOD_GAP'), xFace = xMb + _kpU(s, 'MOD_D'), xFr = xFace - P.pt, yM0 = yF + fst, mH = _kpU(s, 'MOD_H'), yM1 = yM0 + mH;
    var upW = fst;
    var bays = _kpBays(s, Li, upW), ups = [], zc0 = -Zi, mods = [], cuts = [], discs = [], grillBay = null, sinkBay = null, i2;
    var gH = _kpU(s, 'GRILL_H'), yFrT = yWb - 0.015, kCut = _kpKamCut();
    ups.push(zc0 + upW / 2);
    for (i = 0; i < bays.length; i++) {
      var bi = bays[i];
      bi.z0 = ups[ups.length - 1] + upW / 2; bi.z1 = bi.z0 + bi.w; bi.zc = (bi.z0 + bi.z1) / 2;
      ups.push(bi.z1 + upW / 2);
      if (bi.front) {
        mods.push({ front: bi.front, code: bi.code, w: bi.mw, zc: bi.zc, key: bi.key, bay: i });
        cuts.push([[bi.zc - bi.mw / 2, yM0], [bi.zc + bi.mw / 2, yM0], [bi.zc + bi.mw / 2, yM1], [bi.zc - bi.mw / 2, yM1]]);
      }
      if (bi.fridge) cuts.push([[bi.zc - bi.mw / 2, yM0], [bi.zc + bi.mw / 2, yM0], [bi.zc + bi.mw / 2, yFrT], [bi.zc - bi.mw / 2, yFrT]]);   /* the fridge's opening up under the top */
      /* the header under a drop-in's body (its top 5 mm under it); none over the fridge; the rail under the top otherwise */
      bi.hdr = (bi.top === 'grill') ? yWb - gH - 0.005 : (bi.top === 'kamado') ? yWt + KP.KAM_UP - KP.KAM_RY - 0.005 : (bi.top === 'burner') ? yWt - KP.BURN_H - 0.005 : null;
      if (bi.top === 'grill' && !grillBay) grillBay = bi;
      if (bi.top === 'sink' && !sinkBay) sinkBay = bi;
      var dT = KP.DISC_TILT * Math.PI / 180;
      discs.push({ id: 'bay-' + i, state: false, cyc: true, at: [xWf + KP.DISC_R + 0.015, yWt + 0.012, bi.zc], r: KP.DISC_R });   /* the + disc just in front of the worktop's edge over the bay (v415 level, its face up: no slanted discs) */
    }
    /* steel on the deck: a 4.8x19 down from inside the profile (through the folded tab / the web), over a board, off the deck's screws */
    function sDown(x0, x1, zq, dzs) {
      var cands = [];
      dzs.forEach(function (dz) { [0, 0.012, -0.012, 0.024, -0.024].forEach(function (dx) {
        var xq = Math.max(x0 + 0.008, Math.min(x1 - 0.008, deckX((x0 + x1) / 2) + dx));
        if (Math.abs(deckX(xq) - xq) < 1e-6) cands.push([xq, yF + 0.0012, zq + dz]);
      }); });
      if (cands.length) scrClear('screw-sframe', KP.MS_SCREW, cands, [0, -1, 0], sLen, 0.0024);
    }
    if (!fit) {   /* v407 the fitness: no counter */
    for (i = 0; i < ups.length; i++) {
      box(FK, FC, ceil2(yWb - yF), 'upright-' + (i + 1), xFr - fsd / 2, (yF + yWb) / 2, ups[i], fsd, yWb - yF, fst);
      if (steelF) {
        var cxs = xBi + fst, cxe = xFr - fsd;
        box(FK, FC, ceil2(cxe - cxs), 'cross-' + (i + 1), (cxs + cxe) / 2, yWb - fsd / 2, ups[i], cxe - cxs, fsd, fst);
        for (k = -1; k <= 1; k += 2) sDown(xFr - fsd, xFr, ups[i], [k * fst / 4, k * fst / 8]);   /* the web's tab on the deck */
        sJoints += 2;   /* the cross member: into the upright, into the ledger */
        continue;
      }
      for (k = -1; k <= 1; k += 2) scrClear('screw-ctoe', KP.TOE, [[xFr, yF + 0.045, ups[i] + k * st / 4], [xFr, yF + 0.045, ups[i] + k * st / 8], [xFr, yF + 0.045, ups[i] + k * 3 * st / 8], [xFr, yF + 0.040, ups[i] + k * 0.42 * st], [xFr, yF + 0.050, ups[i] + k * 0.05 * st]], [-0.8, -0.6, 0], len80);   /* toed down into the deck from its front face */
      /* the cross member behind it under the top, 6x160 through the upright, two toe screws into the ledger */
      var cxa = xBi + st, cxb = xFr - sd, cL = cxb - cxa;
      box('cframe', KP.STUD, ceil2(cL), 'cross-' + (i + 1), (cxa + cxb) / 2, yWb - sd / 2, ups[i], cL, sd, st);
      for (k = 0; k < 2; k++) scr('screw-cframe', KP.LONG_SCREW, xFr, yWb - sd * (0.25 + 0.5 * k), ups[i], [-1, 0, 0], len160);
      for (k = -1; k <= 1; k += 2) scr('screw-ctoe', KP.TOE, cxa + 0.04, yWb - sd / 2 + k * sd / 4, ups[i] + k * st / 2, [-0.8, 0, -0.6 * k], len80);
    }
    /* the rails between the uprights under the top (a drop-in's bay: a 2x4 laid flat under its body; the fridge's: none), the sills on the deck under the modules */
    for (i = 0; i < bays.length; i++) {
      var bz0 = bays[i].z0, bz1 = bays[i].z1, bwL = bz1 - bz0, isH = (bays[i].hdr != null);
      if (!bays[i].fridge) {
        var ry1 = isH ? bays[i].hdr : yWb, ry0 = ry1 - (isH ? fst : fsd), rxd = isH ? fsd : fst;
        box(FK, FC, ceil2(bwL), (isH ? 'gheader-' : 'crail-') + (i + 1), xFr - rxd / 2, (ry0 + ry1) / 2, (bz0 + bz1) / 2, rxd, ry1 - ry0, bwL);
        if (steelF) sJoints += 2;
        else for (k = -1; k <= 1; k += 2) {
          scr('screw-ctoe', KP.TOE, xFr, (ry0 + ry1) / 2 - k * (ry1 - ry0) * 0.1, (k < 0) ? bz0 + 0.03 : bz1 - 0.03, [-0.55, 0, 0.83 * k], len80);   /* the two rails' screws into one upright at different heights */
        }
      }
      box(FK, FC, ceil2(bwL), 'sill-' + (i + 1), xFr - fsd / 2, yF + fst / 2, (bz0 + bz1) / 2, fsd, fst, bwL);
      if (steelF) { sJoints += 2; for (k = -1; k <= 1; k += 2) sDown(xFr - fsd, xFr, (bz0 + bz1) / 2 + k * bwL / 4, [0, 0.03, -0.03]); continue; }
      for (k = -1; k <= 1; k += 2) scrClear('screw-csill', us ? KP.DECK_SCREW : KP.TOE, [[deckX(xFr - sd / 2), yF + st, (bz0 + bz1) / 2 + k * bwL / 4], [deckX(xFr - sd / 2), yF + st, (bz0 + bz1) / 2 + k * bwL / 4 + 0.03]], [0, -1, 0], us ? len50 : len80);
    }
    /* the ledger on the back wall's studs under the top, the sleeper on the deck under the modules' backs */
    box(FK, FC, ceil2(Li), 'ledger', xBi + fst / 2, yWb - fsd / 2, 0, fst, fsd, Li);   /* v406 steel: its web on the studs */
    for (i = 0; i < bGrid.length; i++) if (Math.abs(bGrid[i]) < Zi - 0.02) {
      var zl = bGrid[i];
      if (steelF) { for (k = 0; k < 2; k++) { var ysl = yWb - fsd * (0.3 + 0.4 * k); scrClear('screw-sframe', KP.MS_SCREW, [[xBi + 0.0012, ysl, zl], [xBi + 0.0012, ysl, zl + 0.012], [xBi + 0.0012, ysl, zl - 0.012]], [-1, 0, 0], sLen, 0.0024); } continue; }
      for (k = 0; k < 2; k++) { var yl = yWb - sd * (0.3 + 0.4 * k); scrClear('screw-ledger', KP.STUD_SCREW, [[xBi + st, yl, zl], [xBi + st, yl, zl + 0.016], [xBi + st, yl, zl - 0.016], [xBi + st, yl + 0.012, zl + 0.016], [xBi + st, yl - 0.012, zl - 0.016]], [-1, 0, 0], len120); }   /* off the cross members' toe screws, still in the stud */
    }
    box(FK, FC, ceil2(Li), 'sleeper', xBi + fsd / 2, yF + fst / 2, 0, fsd, fst, Li);
    var xSl = deckX(xBi + sd / 2), sillCode = us ? KP.DECK_SCREW : KP.TOE, sillLen = us ? len50 : len80;
    if (steelF) jGrid.forEach(function (zz) { sDown(xBi, xBi + fsd, zz, [0.02, -0.03, 0.05]); });
    else jGrid.forEach(function (zz) { scrClear('screw-csill', sillCode, [[xSl, yF + st, zz + 0.02], [xSl, yF + st, zz - 0.03], [xSl, yF + st, zz + 0.05]], [0, -1, 0], sillLen); });   /* over a deck board, beside the joists' deck screws */
    }   /* v407 !fit */
    /* the face: panel siding from the deck up under the top with the modules' (and the fridge's) cutouts */
    var Up = [0, 0, 1], Vp = [0, 1, 0], Np = [1, 0, 0];
    var faceRect = [[-Zi, yF], [Zi, yF], [Zi, yWb], [-Zi, yWb]], panelA = 0, cboardA = 0, stoneA = 0, wfaceA = 0, inoxA = 0, fM = KP.FLANGE_M;
    /* v405 the cutouts grown by the modules' flange for a face standing proud of the modules' (the flange sits in the recess) */
    var cutsW = cuts.map(function (c) { var z0 = c[0][0] - fM, z1 = c[1][0] + fM, y0 = c[0][1] - fM, y1 = Math.min(c[2][1] + fM, yWb - 0.004); return [[z0, y0], [z1, y0], [z1, y1], [z0, y1]]; });
    if (fit) panelA = 0;   /* v407 the fitness: no counter face */
    else if (fin === 'acacia') panelA = sheet('panel', KP.PANEL, 'panel', faceRect, cuts, [xFr, 0, 0], Up, Vp, Np, P.pt);
    else if (fin === 'concrete') {
      cboardA = sheet('cboard', KP.CBOARD, 'cboard', faceRect, cuts, [xFr, 0, 0], Up, Vp, Np, P.pt);   /* the cement board (its 12.5 mm drawn as the panel's) */
      stoneA = sheet('stone', KP.STONE, 'stone', faceRect, cutsW, [xFr + P.pt, 0, 0], Up, Vp, Np, _kpU(s, 'STONE_T'));
    } else if (fin === 'inox') {   /* v412 the cement board, the stainless bonded on (the modules' flanges over it) */
      cboardA = sheet('cboard', KP.CBOARD, 'cboard', faceRect, cuts, [xFr, 0, 0], Up, Vp, Np, P.pt);
      inoxA = sheet('inox', KP.INOX, 'inox', faceRect, cuts, [xFr + P.pt, 0, 0], Up, Vp, Np, _kpU(s, 'INOX_T'));
    } else wfaceA = sheet('wface', KP.CLAD, 'wface', faceRect, cutsW, [xFr, 0, 0], Up, Vp, Np, tc);   /* the wood boards on the counter frame */
    var faceX = xFr + ((fin === 'concrete') ? P.pt + _kpU(s, 'STONE_T') : (fin === 'inox') ? P.pt + _kpU(s, 'INOX_T') : (fin === 'granite') ? tc : P.pt);   /* the face's front plane (v412 no disc on it: the look is on the bar's switch) */
    if (!fit && fin === 'granite') missing.push(us ? { name: KP.GRANITE_NAME, qty: Math.round(Li * topD * KP.WASTE * 10.7639 * 100) / 100, unit: 'ft2' } : { name: KP.GRANITE_NAME, qty: Math.round(Li * topD * KP.WASTE * 100) / 100, unit: 'm2' });
    /* the top: one acacia block the inner length, the drop-ins' cutouts (grill, burner: at the front; sink: at the back; kamado: round, centred) */
    var gW = _kpU(s, 'GRILL_W'), gD = _kpU(s, 'GRILL_D'), gx1 = xFr - 0.005, gx0 = gx1 - gD;
    var skW = _kpU(s, 'SINK_W'), skx0 = xBi + fst + 0.035, skx1 = skx0 + skW, tops = [];
    var bnx1 = gx1, bnx0 = bnx1 - KP.BURN_D, kxc = (xBi + xWf) / 2;
    for (i = 0; i < bays.length; i++) {
      var tb2 = bays[i], zq = tb2.zc;
      if (tb2.top === 'grill') tops.push([[zq - gW / 2 - 0.005, gx0 - 0.005], [zq + gW / 2 + 0.005, gx0 - 0.005], [zq + gW / 2 + 0.005, gx1 + 0.005], [zq - gW / 2 - 0.005, gx1 + 0.005]]);
      else if (tb2.top === 'sink') tops.push([[zq - skW / 2, skx0], [zq + skW / 2, skx0], [zq + skW / 2, skx1], [zq - skW / 2, skx1]]);
      else if (tb2.top === 'burner') tops.push([[zq - KP.BURN_W / 2 - 0.005, bnx0 - 0.005], [zq + KP.BURN_W / 2 + 0.005, bnx0 - 0.005], [zq + KP.BURN_W / 2 + 0.005, bnx1 + 0.005], [zq - KP.BURN_W / 2 - 0.005, bnx1 + 0.005]]);
      else if (tb2.top === 'kamado') { var cp = []; for (i2 = 0; i2 < 32; i2++) cp.push([zq + kCut * Math.cos(i2 * Math.PI / 16), kxc + kCut * Math.sin(i2 * Math.PI / 16)]); tops.push(cp); }
    }
    /* v382 THE SERVICES (Marek 2026-10-30, question panel: LPG in a cabinet; water, waste and power drawn and billed inside the pod
       up to its connection points -- the house's side not billed). Pipes and cables are polylines (runs), the boxes on the walls
       pieces (their screws into the wood). */
    var runs = [], gas = null, sinksS = [], devs = [], led = null, clipsP = 0, clipsC = 0, stopsW = 0;
    function d3(a, b) { return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]) + (a[2] - b[2]) * (a[2] - b[2])); }
    /* a run: its length, its corners (a change of direction between two legs), its clips (pipes: one a 50 cm of every leg over 10 cm;
       cables: one a 30 cm of every leg not threaded through the studs) */
    function run(kind, code, id, pts, r, thru) {
      var Lr = 0, q, corners = 0;
      for (q = 1; q < pts.length; q++) {
        var lq = d3(pts[q], pts[q - 1]);
        Lr += lq;
        if (kind === 'cable') { if (!(thru && thru[q - 1])) clipsC += Math.ceil(lq / 0.30 - 1e-9); }
        else if (kind === 'gasline' || kind === 'pex' || kind === 'drain') { if (lq > 0.10) clipsP += Math.ceil(lq / 0.50 - 1e-9); }
        if (q >= 2) {
          var a = [pts[q - 1][0] - pts[q - 2][0], pts[q - 1][1] - pts[q - 2][1], pts[q - 1][2] - pts[q - 2][2]], b = [pts[q][0] - pts[q - 1][0], pts[q][1] - pts[q - 1][1], pts[q][2] - pts[q - 1][2]];
          var la = Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]), lb = Math.sqrt(b[0] * b[0] + b[1] * b[1] + b[2] * b[2]);
          if (la > 1e-6 && lb > 1e-6 && (a[0] * b[0] + a[1] * b[1] + a[2] * b[2]) / (la * lb) < 0.9) corners++;
        }
      }
      runs.push({ kind: kind, code: code, id: id, pts: pts, r: r, len: Lr, corners: corners });
      return Lr;
    }
    function hole(zq, xq, rq) { var cp = [], q; for (q = 0; q < 20; q++) cp.push([zq + rq * Math.cos(q * Math.PI / 10), xq + rq * Math.sin(q * Math.PI / 10)]); tops.push(cp); }
    /* a z near zt inside [lo, hi] clear of the joists (and their hangers) by 10 cm and of the avoided spots by 8 cm */
    function clearZ(zt, lo, hi, avoid) {
      var q, dz, zq;
      for (dz = 0; dz <= 0.6; dz += 0.01) for (q = -1; q <= 1; q += 2) {
        zq = zt + q * dz;
        if (zq < lo || zq > hi) continue;
        if (jGrid.some(function (jz) { return Math.abs(jz - zq) < 0.10; })) continue;
        if ((avoid || []).some(function (az) { return Math.abs(az - zq) < 0.08; })) continue;
        return zq;
      }
      return Math.max(lo, Math.min(hi, zt));
    }
    var yUnder = yBB + 0.03;   /* the supply's and the waste's open ends under the deck: the connection points */
    /* GAS: the bottle in the cabinet of the first gas appliance with a door (else the nearest door cabinet, not a sink's), its
       regulator, the pigtail hose (400 mm) through the cabinet's back to a 3-way manifold in the gap behind it (held by its pipes),
       a line a gas appliance up the back gap and along it over the modules (at most three: the bay rule), its elbows, a ball
       valve under the appliance and a hose up to it */
    var GASK = { grill: 1, burner: 1, pizza: 1 }, DOORF = { combo: 1, ddoor: 1, sdoor: 1 }, gBays = [], gi;
    for (gi = 0; gi < bays.length; gi++) if (GASK[bays[gi].kind]) gBays.push(gi);
    if (gBays.length) {
      var cab = -1, bestD = 1e9;
      for (gi = 0; gi < gBays.length && cab < 0; gi++) if (DOORF[bays[gBays[gi]].front]) cab = gBays[gi];
      if (cab < 0) for (gi = 0; gi < bays.length; gi++) if (DOORF[bays[gi].front] && bays[gi].top !== 'sink' && Math.abs(gi - gBays[0]) < bestD) { bestD = Math.abs(gi - gBays[0]); cab = gi; }
      var cb = bays[(cab >= 0) ? cab : gBays[0]], gza = cb.zc - cb.mw / 2 + 0.003, gzb = cb.zc + cb.mw / 2 - 0.003;
      var bzc = (cab < 0) ? cb.zc : (cb.front === 'combo') ? (gza + (gza + (gzb - gza) * 0.55)) / 2 : (cb.front === 'ddoor') ? (gza + cb.zc) / 2 : cb.zc;
      var bR = KP.BOTTLE_R, bH = KP.BOTTLE_H, bxc = (cab >= 0) ? (xMb + xFace) / 2 : (xBi + fsd + xFr - fsd) / 2, by0 = (cab >= 0) ? yM0 + 0.006 : yF + 0.001;
      gas = { cab: cab, bay: (cab >= 0) ? cab : gBays[0], x: bxc, y0: by0, z: bzc, r: bR, h: bH, front: (cab >= 0) ? cb.front : null, za: gza, zb: gzb, zc: cb.zc, mw: cb.mw, lines: [] };
      var yRg = by0 + bH, yRgT = yRg + KP.REG_H;
      var mz = bzc, mx0 = xBi + 0.003, mx1 = xBi + KP.MAN_D, ymc = ((cab >= 0) ? yM0 : yF) + 0.37, my0 = ymc - KP.MAN_H / 2, my1 = ymc + KP.MAN_H / 2;
      box('manifold', KP.MANIFOLD, 0, 'manifold', (mx0 + mx1) / 2, ymc, mz, mx1 - mx0, my1 - my0, KP.MAN_W);
      /* the pigtail hose: off the regulator, back behind the bottle, down, through the cabinet's back to the manifold's face */
      var hx = (cab >= 0) ? xMb + 0.03 : xBi + fsd + 0.03;
      run('gashose', KP.GASHOSE, 'gas-pigtail', [[bxc, yRgT - 0.015, bzc], [hx, yRgT - 0.015, bzc], [hx, ymc, bzc], [mx1 + 0.002, ymc, mz]], 0.006);
      /* the lines' places: their targets first; the risers side by side on the manifold, those going left on its left; the riser
         nearest the manifold's middle goes highest, so no leg crosses another line's riser */
      var nG = gBays.length, GL = [];
      for (k = 0; k < nG; k++) {
        var tbg = bays[gBays[k]], xv, zl, hTop;
        if (tbg.top === 'grill') { xv = gx0 + 0.07; zl = tbg.zc + 0.15; hTop = yWb - _kpU(s, 'GRILL_H') - 0.002; }
        else if (tbg.top === 'burner') { xv = bnx0 + 0.07; zl = tbg.zc - 0.07; hTop = yWt - KP.BURN_H - 0.002; }
        else { xv = xBi + 0.12; zl = tbg.zc + 0.15; hTop = yWt + 0.012; hole(zl, xv, 0.012); }   /* the pizza oven: up through the top under its base */
        GL.push({ bay: gBays[k], top: tbg.top, xv: xv, zl: zl, hTop: hTop });
      }
      GL.sort(function (a, b) { return a.zl - b.zl; });
      var nLft = GL.filter(function (q) { return q.zl < mz; }).length;
      GL.forEach(function (q, n2) {
        q.zr = mz + (n2 - (nG - 1) / 2) * 0.022;
        q.yk = yM1 + 0.02 + 0.02 * ((n2 < nLft) ? n2 : (nG - 1 - n2));   /* left: the rightmost riser highest; right: the leftmost */
      });
      GL.forEach(function (q, n2) {
        var lpts = [[xBi + 0.02, my1 + 0.002, q.zr], [xBi + 0.02, q.yk, q.zr], [xBi + 0.02, q.yk, q.zl], [q.xv - KP.VALVE_L / 2, q.yk, q.zl]];
        if (Math.abs(q.zr - q.zl) < 0.002) lpts.splice(2, 1);
        run('gasline', KP.GASLINE, 'gas-line-' + (n2 + 1), lpts, 0.0065);
        gas.lines.push({ bay: q.bay, x: q.xv, y: q.yk, z: q.zl, top: q.top });
        run('gashose', KP.GASHOSE, 'gas-hose-' + (n2 + 1), [[q.xv, q.yk + 0.017, q.zl], [q.xv, q.hTop, q.zl]], 0.006);
      });
    }
    /* WATER AND WASTE, a sink at a time, inside its cabinet: the supply (PEX 16) from under the deck up through the sleeper and the
       cabinet to a drop ear on the ledger's face (two 5x40), a braided hose over to the tap's tail; the waste: the siphon under the
       basin, a 32 mm pipe down through the cabinet and the deck (a jog clear of the joists: two 45 deg bends a turn) */
    for (gi = 0; gi < bays.length; gi++) if (bays[gi].top === 'sink') {
      var sbw = bays[gi], zcw = sbw.zc, hw2 = (sbw.mw || 0.405) / 2 - 0.035, zd = clearZ(zcw, zcw - hw2, zcw + hw2, []);
      if (Math.abs(zd - zcw) < 0.005) zd = zcw;
      var zw = clearZ(zd + ((zd < zcw - 1e-6) ? -0.10 : 0.10), zcw - hw2, zcw + hw2, [zd, zcw]);
      var skc = (skx0 + skx1) / 2, yT1 = yWt - _kpU(s, 'SINK_H'), xTail = xBi + fst + 0.009, yDE = yWb - sd / 2, xPx = Math.max(xMb + 0.02, xBi + st + 0.008), yJg = yM0 + 0.25;
      run('drain', KP.DRAIN, 'drain-' + (gi + 1), (zd === zcw) ? [[skc, yT1 - 0.11, zcw], [skc, yUnder, zcw]] : [[skc, yT1 - 0.11, zcw], [skc, yJg, zcw], [skc, yJg, zd], [skc, yUnder, zd]], 0.016);
      if (steelF) {
        /* v406 steel: the drop ear under the ledger's lower flange (its web is on the studs, its open side to the front), two 4.8x19 up into it */
        var yLb = yWb - fsd, xDE = xBi + 0.025;
        run('pex', KP.PEX, 'pex-' + (gi + 1), [[xDE, yUnder, zw], [xDE, yLb - 0.027, zw]], 0.008);
        box('dropear', KP.DROPEAR, 0, 'dropear-' + (gi + 1), xDE, yLb - 0.0125, zw, 0.04, 0.025, 0.04);
        for (k = -1; k <= 1; k += 2) scr('screw-dropear', KP.MS_SCREW, xDE, yLb - 0.012, zw + k * 0.013, [0, 1, 0], sLen, 0.0024);
        run('flexi', KP.FLEXI, 'flexi-' + (gi + 1), [[xDE + 0.027, yLb - 0.0125, zw], [xTail, yWb - 0.054, zcw]], 0.006);
      } else {
      run('pex', KP.PEX, 'pex-' + (gi + 1), [[xPx, yUnder, zw], [xPx, yDE - 0.022, zw]], 0.008);
      box('dropear', KP.DROPEAR, 0, 'dropear-' + (gi + 1), xBi + st + 0.0125, yDE, zw, 0.025, 0.04, 0.04);
      for (k = -1; k <= 1; k += 2) scr('screw-dropear', KP.BRACKET_SCREW, xBi + st + 0.006, yDE, zw + k * 0.013, [-1, 0, 0], len40, 0.0025);
      run('flexi', KP.FLEXI, 'flexi-' + (gi + 1), [[xBi + st + 0.032, yDE, zw], [xTail, yWb - 0.054, zcw]], 0.006);
      }
      hole(zcw, xTail, 0.011);   /* the tap's tail through the top, in front of the ledger */
      sinksS.push({ bay: gi, zc: zcw, zd: zd, zw: zw, skc: skc, yT1: yT1, xTail: xTail });
      stopsW++;
    }
    /* POWER: a junction box on the back wall (the house's cable ends there), a cable along the wall's cavity through the studs,
       down / up beside a stud to each box: an outdoor socket + a switch over the worktop, a socket behind each fridge, two wall
       lights; up through the top plate and along a rafter to the LED driver on the header's back face, the LED strip under the
       header (the switch's); every box on a stud's face, two 5x40 into it */
    var nBg = bGrid.length, zSide = st / 2 + 0.008, xCav = xBi - 0.02, yE = yWt + 0.46;
    function studNear(zq, bad) { var bq = -1, bd = 1e9, q; for (q = 1; q <= nBg - 2; q++) if (!(bad && bad(bGrid[q])) && Math.abs(bGrid[q] - zq) < bd) { bd = Math.abs(bGrid[q] - zq); bq = q; } return bq; }
    function dev(kind, code, id, q, yq, w, h, dd) {
      var zq = bGrid[q];
      box(kind, code, 0, id, xBi + dd / 2, yq, zq, dd, h, w);
      for (var e4 = -1; e4 <= 1; e4 += 2) scrClear('screw-' + ((kind === 'socket' || kind === 'switch') ? 'ebox' : kind), KP.BRACKET_SCREW, [0, 0.012, -0.012].map(function (dz) { return [xBi + 0.006, yq + e4 * (h / 2 - 0.015), zq + dz]; }), [-1, 0, 0], len40, 0.0025);   /* v405 off the plates' screws */
      devs.push({ kind: kind, q: q, y: yq, z: zq, id: id, h: h, w: w });
    }
    if (nBg >= 3 && !fit) {
      var qJ = 1, qR = nBg - 2;
      while (qJ < nBg - 2 && bGrid[qJ] < -Zi + 0.075) qJ++;   /* v405 a short pod (from 1.50 m): the boxes' studs clear of the end walls */
      while (qR > qJ && bGrid[qR] > Zi - 0.075) qR--;
      dev('jbox', KP.JBOX, 'jbox', qJ, yE, 0.10, 0.10, 0.06);
      /* the socket + switch: over a drawer / door / trash / fridge bay, not behind a grill, kamado, pizza oven, burner or tap */
      var NEAR = { grill: 0.46, kamado: 0.30, pizza: 0.32, burner: 0.22, sink: 0.12 }, OK = { drawer: 1, door: 1, ddoor: 1, trash: 1, fridge: 1 };
      var badS = function (zq) { return bays.some(function (b) { return NEAR[b.kind] && Math.abs(b.zc - zq) < NEAR[b.kind]; }); };
      var zPref = 0; for (gi = 0; gi < bays.length; gi++) if (OK[bays[gi].kind]) { zPref = bays[gi].zc; break; }
      var qS = studNear(zPref, badS); if (qS < 0) qS = studNear(zPref);
      dev('socket', KP.SOCKET, 'socket', qS, yWt + 0.20, 0.08, 0.08, 0.045);
      dev('switch', KP.SWITCH, 'switch', qS, yWt + 0.31, 0.08, 0.08, 0.045);
      for (gi = 0; gi < bays.length; gi++) if (bays[gi].fridge) dev('socket', KP.SOCKET, 'socket-fridge-' + (gi + 1), studNear(bays[gi].zc), yM0 + 0.30, 0.08, 0.08, 0.035);
      var yWl = _kpShelf(s) ? yWt + _kpU(s, 'SHELF_UP') + 0.085 : yWt + 0.62;   /* v405 over the shelf when it is on */
      dev('wlight', KP.WLIGHT, 'wlight-l', qJ, yWl, 0.10, 0.12, 0.07);   /* clear of the top plate's screws */
      dev('wlight', KP.WLIGHT, 'wlight-r', qR, yWl, 0.10, 0.12, 0.07);
      /* the cable: the run along the cavity (through the studs) from the junction box; beside each stud a drop up / down to its
         boxes, one after the other (the nearest to the run first) */
      var zA = bGrid[qJ] + zSide, zB = zA, byQ = {};
      devs.forEach(function (dv) { zB = Math.max(zB, dv.z + zSide); if (dv.kind !== 'jbox') (byQ[dv.q] = byQ[dv.q] || []).push(dv); });
      if (zB > zA + 0.01) run('cable', KP.CABLE, 'cable-run', [[xCav, yE, zA], [xCav, yE, zB]], 0.004, [true]);
      Object.keys(byQ).forEach(function (qk) {
        var zq = bGrid[+qk] + zSide;
        [1, -1].forEach(function (dir) {
          var yPrev = yE;
          byQ[qk].filter(function (dv) { return (dv.y - yE) * dir > 0; }).sort(function (a, b) { return (a.y - b.y) * dir; }).forEach(function (dv) {
            run('cable', KP.CABLE, 'cable-' + dv.id, [[xCav, yPrev, zq], [xCav, dv.y, zq]], 0.004);
            yPrev = dv.y;
          });
        });
      });
      /* the LED driver between the end rafter and the first one on the header's back face; its feed up the cavity on the junction
         box's other side, through the top plate, along the rafter's side, over to the driver */
      var zL = bGrid[qJ] - zSide, zP = (bGrid[0] + bGrid[1]) / 2, xR = xHb - 0.06, yR = yL(xR) + 0.04;
      box('psu', KP.PSU, 0, 'psu', xHb - 0.02, yHb + 0.05, zP, 0.04, 0.05, 0.16);
      for (k = -1; k <= 1; k += 2) scr('screw-psu', KP.BRACKET_SCREW, xHb - 0.004, yHb + 0.05, zP + k * 0.065, [1, 0, 0], len40, 0.0025);
      run('cable', KP.CABLE, 'cable-led', [[xCav, yE, zL], [xCav, yPB + 0.04, zL], [xR, yR, zL], [xR, yR, zP], [xHb - 0.042, yHb + 0.05, zP]], 0.004);
      run('cable', KP.CABLE, 'cable-led-lead', [[xHb - 0.02, yHb + 0.023, zP + 0.05], [xHb - 0.02, yHb - 0.005, zP + 0.05], [xHb + 0.019, yHb - 0.005, zP + 0.05]], 0.003);
      led = { x: xHb + 0.025, y: yHb - 0.0015, z0: -Zi + 0.05, z1: Zi - 0.05, len: 2 * Zi - 0.10 };
    }
    /* v409 THE FITNESS'S POWER (no back wall): on the back left post's inner face the outdoor socket + the switch (under the strut's
       block), the junction box (over it), a wall light; the other wall light on the back right post; the cable up the post, along under
       the back header to the right post; the LED driver on the back header's inner face, the LED strip under it (the switch's) */
    if (fit) (function () {
      var zPL = -(Z1 - p / 2), zPR = Z1 - p / 2, xCf = xBi + 0.006, dzC = p / 2 - 0.005;
      var blk0 = SK.ySB - st / 2 - 0.05, blk1 = SK.ySB + st / 2 + 0.05, yTopP = yL(xBi) - stV - 0.07;   /* the strut's block on the post's face; the raking plate */
      function devP(kind, code, id, zq, yq, w, h, dd) {
        box(kind, code, 0, id, xBi + dd / 2, yq, zq, dd, h, w);
        for (var e4 = -1; e4 <= 1; e4 += 2) scrClear('screw-' + ((kind === 'socket' || kind === 'switch') ? 'ebox' : kind), KP.BRACKET_SCREW, [0, 0.012, -0.012].map(function (dz) { return [xBi + 0.006, yq + e4 * (h / 2 - 0.015), zq + dz]; }), [-1, 0, 0], len40, 0.0025);
        devs.push({ kind: kind, q: -1, y: yq, z: zq, id: id, h: h, w: w });
      }
      var ySw = Math.min(yF + 1.06, blk0 - 0.04), ySo = ySw - 0.11, yJb = Math.max(yF + 1.32, blk1 + 0.05), yWl = Math.min(yF + 1.72, yTopP - 0.06);
      devP('socket', KP.SOCKET, 'socket', zPL, ySo, 0.08, 0.08, 0.045);
      devP('switch', KP.SWITCH, 'switch', zPL, ySw, 0.08, 0.08, 0.045);
      devP('jbox', KP.JBOX, 'jbox', zPL, yJb, 0.09, 0.10, 0.06);
      devP('wlight', KP.WLIGHT, 'wlight-l', zPL, yWl, 0.09, 0.12, 0.07);
      devP('wlight', KP.WLIGHT, 'wlight-r', zPR, yWl, 0.09, 0.12, 0.07);
      var zC = zPL + dzC, yU = yHbK - 0.008;
      run('cable', KP.CABLE, 'cable-socket', [[xCf, yJb, zC], [xCf, ySo, zC]], 0.004);
      run('cable', KP.CABLE, 'cable-wlight-l', [[xCf, yJb, zC], [xCf, yWl, zC]], 0.004);
      run('cable', KP.CABLE, 'cable-wlight-r', [[xCf, yWl, zC], [xCf, yU, zC], [xCf, yU, zPR - dzC], [xCf, yWl, zPR - dzC]], 0.004);
      /* v415 the TV's socket on the back header's inner face beside the middle, teed off the run under the header */
      var zTs = KP.TV_SOCK_Z, yTs = yHbK + Math.min(0.08, bh / 2);
      devP('socket', KP.SOCKET, 'socket-tv', zTs, yTs, 0.08, 0.08, 0.045);
      run('cable', KP.CABLE, 'cable-socket-tv', [[xCf, yU, zTs], [xCf, yTs - 0.04, zTs]], 0.004);
      /* the LED driver between the end rafter and the first one on the back header's inner face, the strip under the header */
      var zP = (bGrid[0] + bGrid[1]) / 2;
      box('psu', KP.PSU, 0, 'psu', xBi + 0.02, yHbK + 0.05, zP, 0.04, 0.05, 0.16);
      for (k = -1; k <= 1; k += 2) scr('screw-psu', KP.BRACKET_SCREW, xBi + 0.004, yHbK + 0.05, zP + k * 0.065, [-1, 0, 0], len40, 0.0025);
      run('cable', KP.CABLE, 'cable-led', [[xCf, yWl, zC], [xCf, yU, zC], [xCf, yU, zP], [xBi + 0.042, yHbK + 0.05, zP]], 0.004);
      run('cable', KP.CABLE, 'cable-led-lead', [[xBi + 0.02, yHbK + 0.023, zP + 0.05], [xBi + 0.02, yHbK - 0.005, zP + 0.05], [xBi - 0.019, yHbK - 0.005, zP + 0.05]], 0.003);
      led = { x: xBi - 0.025, y: yHbK - 0.0015, z0: -Zi + 0.05, z1: Zi - 0.05, len: 2 * Zi - 0.10 };
    })();
    if (clipsP) missing.push({ name: 'PIPE CLIP WITH SCREW, 13-32 MM (1/2 - 1 1/4 IN.)', qty: clipsP, unit: 'pcs' });
    if (clipsC) missing.push({ name: 'CABLE CLIP WITH NAIL', qty: clipsC, unit: 'pcs' });
    if (stopsW) missing.push({ name: 'BALL VALVE 1/2 IN. FOR PEX 16 MM (THE WATER CONNECTION POINT)', qty: stopsW, unit: 'pcs' });
    if (!fit) sheet((fin === 'acacia') ? 'top' : (fin === 'concrete' || fin === 'inox') ? 'ctop' : 'gtop', (fin === 'acacia') ? KP.TOP : (fin === 'concrete' || fin === 'inox') ? KP.WORKTOP : null, 'top', [[-Zi, xBi], [Zi, xBi], [Zi, xWf], [-Zi, xWf]], tops, [0, yWb, 0], [0, 0, 1], [1, 0, 0], [0, 1, 0], topT);   /* v405 the acacia, the concrete slab (FOU00027), the granite (missing) */
    /* v405 THE SHELF over the counter (its + disc on the back wall), its top KP.SHELF_UP over the worktop (the wall lights over it): a 2x6
       laid flat on 6x6 in. angle brackets on the studs (two 5x40 into each), two 4.8x19 up into it; none over a grill, kamado, pizza
       oven or burner (their heat), no bracket on a stud whose box is in its way; a run needs two brackets */
    /* v406 THE HEAT SHIELD behind a grill, kamado, pizza oven or side burner (both frames): cement board on the back wall's studs from
       the worktop up KP.SHIELD_H, KP.SHIELD_IN past the bay each side (as the shelf keeps off); a box in it: a hole round it, else the
       shield stops short of it (its side, or under it) */
    var shieldA = 0, nShield = 0;
    (function () {
      var hz = [], tS = _kpU(s, 'SHIELD_T');
      bays.forEach(function (b) { if (b.top === 'grill' || b.top === 'kamado' || b.top === 'pizza' || b.top === 'burner') hz.push([Math.max(-Zi, b.z0 - KP.SHIELD_IN), Math.min(Zi, b.z1 + KP.SHIELD_IN), b.z0, b.z1]); });
      hz.sort(function (a, b) { return a[0] - b[0]; });
      var mg = [];
      hz.forEach(function (h) { var l = mg[mg.length - 1]; if (l && h[0] <= l[1] + 0.02) { l[1] = Math.max(l[1], h[1]); l[3] = Math.max(l[3], h[3]); } else mg.push(h.slice()); });
      mg.forEach(function (h) {
        var z0 = h[0], z1 = h[1], y0 = yWt, y1 = yWt + _kpU(s, 'SHIELD_H'), holes = [], it, ch = true;
        for (it = 0; it < 6 && ch; it++) {
          ch = false; holes = [];
          devs.forEach(function (dv) {
            var a0 = dv.z - dv.w / 2 - 0.005, a1 = dv.z + dv.w / 2 + 0.005, b0 = dv.y - dv.h / 2 - 0.005, b1 = dv.y + dv.h / 2 + 0.005;
            if (a1 <= z0 || a0 >= z1 || b1 <= y0 || b0 >= y1) return;
            if (a0 >= z0 + 0.01 && a1 <= z1 - 0.01 && b0 >= y0 + 0.01 && b1 <= y1 - 0.03) { holes.push([[a0, b0], [a1, b0], [a1, b1], [a0, b1]]); return; }
            if (dv.z > h[3] && a0 >= h[3]) { z1 = a0; ch = true; return; }   /* past the bay's right end: stop short of it */
            if (dv.z < h[2] && a1 <= h[2]) { z0 = a1; ch = true; return; }
            y1 = b0; ch = true;   /* over it */
          });
        }
        if (y1 - y0 < 0.15 || z1 - z0 < 0.10) return;
        shieldA += sheet('shield', KP.CBOARD, 'shield-' + (++nShield), [[z0, y0], [z1, y0], [z1, y1], [z0, y1]], holes, [xBi, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], tS);
      });
    })();
    /* v406 the wood frame: the grill's and the side burner's insulated jacket (their makers' -- no catalogue row yet) */
    if (!steelF && !fit) {
      var nJg = 0, nJb = 0;
      bays.forEach(function (b) { if (b.top === 'grill') nJg++; else if (b.top === 'burner') nJb++; });
      if (nJg) missing.push({ name: KP.JACKET_NAME, qty: nJg, unit: 'pcs' });
      if (nJb) missing.push({ name: KP.BJACKET_NAME, qty: nJb, unit: 'pcs' });
    }
    var shelf = { on: _kpShelf(s), runs: [], boards: 0, brackets: 0, y: yWt + _kpU(s, 'SHELF_UP') - jt };
    (function () {
      if (fit) { discs.push(roofDisc); return; }   /* v407 the fitness: no shelf (the roof's disc kept) */
      var yS = shelf.y, brS = _kpU(s, 'SHELF_BRS'), hot = [], q;
      bays.forEach(function (b) { if (b.top === 'grill' || b.top === 'kamado' || b.top === 'pizza' || b.top === 'burner') hot.push([b.z0 - KP.SHELF_HOT, b.z1 + KP.SHELF_HOT]); });
      var runs = [[-Zi + 0.01, Zi - 0.01]];
      hot.forEach(function (h) { var nr = []; runs.forEach(function (rn) { if (h[1] <= rn[0] || h[0] >= rn[1]) nr.push(rn); else { if (h[0] - rn[0] > 0.02) nr.push([rn[0], h[0]]); if (rn[1] - h[1] > 0.02) nr.push([h[1], rn[1]]); } }); runs = nr; });
      var busy = {}; devs.forEach(function (dv) { if (dv.y - dv.h / 2 < yS + jt + 0.01 && dv.y + dv.h / 2 > yS - brS - 0.01) busy[dv.q] = 1; });
      runs.forEach(function (rn) {
        var brz = [];
        for (q = 0; q < bGrid.length; q++) if (!busy[q] && bGrid[q] > rn[0] + 0.04 && bGrid[q] < rn[1] - 0.04) brz.push(bGrid[q]);
        if (brz.length < 2 || rn[1] - rn[0] < 0.40) return;
        shelf.runs.push({ z0: rn[0], z1: rn[1], brz: brz });
      });
      /* its disc: under the longest run (else the middle), in front of the wall */
      var best = null; shelf.runs.forEach(function (rn) { if (!best || rn.z1 - rn.z0 > best.z1 - best.z0) best = rn; });
      discs.push(roofDisc);
      if (best) discs.push({ id: 'kp-shelf', state: shelf.on, cyc: true, at: [xBi + 0.20, yS - 0.10, (best.z0 + best.z1) / 2], r: KP.DISC_R * 0.8, tilt: Math.PI / 2 });   /* no disc where no shelf fits */
      if (!shelf.on) return;
      shelf.runs.forEach(function (rn, ri) {
        var Ls = rn.z1 - rn.z0, zc = (rn.z0 + rn.z1) / 2;
        box('shelf', KP.JOIST, ceil2(Ls), 'shelf-' + (ri + 1), xBi + 0.003 + jh / 2, yS + jt / 2, zc, jh, jt, Ls);
        shelf.boards++;
        rn.brz.forEach(function (zq, bi) {
          var id = 'shelfbr-' + (ri + 1) + '-' + (bi + 1);
          box('shelfbr', KP.SHELF_BR, 0, id, xBi + 0.0015, yS - brS / 2, zq, 0.003, brS, 0.04);
          box('shelfbr', null, 0, id + '-h', xBi + 0.003 + brS / 2, yS - 0.0015, zq, brS, 0.003, 0.04);
          shelf.brackets++;
          for (var e5 = 0; e5 < 2; e5++) scrClear('screw-shelfbr', KP.BRACKET_SCREW, [0, 0.01, -0.01].map(function (dz) { return [xBi + 0.003, yS - 0.03 - e5 * 0.07, zq + dz]; }), [-1, 0, 0], len40, 0.0025);
          [0.045, 0.115].forEach(function (dx, r3) { scr('screw-shelf', KP.SHELF_SCREW, xBi + 0.003 + dx, yS - 0.003, zq + ((r3 === 0) ? 0.01 : -0.01), [0, 1, 0], us ? 0.01905 : 0.019, 0.0024); });
        });
      });
    })();

    /* v409 GARDEN POD -- THE FITNESS 2 (type 53; Marek 2026-11-03 20:01 "U fitness varianty bys mohl udelat oboustranne otviratelne
       dvere, pytel zavesit dovnitr na stred. Na jeden bok dovnitr pripevnit kladkostroj. Na vnejsi kratke strane dat multifunkcni
       zebrik, na ktery se da umistit do ruzne vysky hrazda / s bradly a na stridacku take vylozniky na velkou osu (drepy bench).
       Dovnitr by se mela vlezt take multifunkcni fitness lavicka (u kladkostroje)"; 20:08 "On pak slouzi spise pro uskladneni veci
       ... Pri otevreni pocitam, ze by se lavicka premistila k hrazde, vyloznikum, cvicilo by se i mimo, pytel samozrejme na miste"):
       rubber tiles on the deck; the heavy bag in the middle on a 2x6 blocking between two rafters; the cable pulley (FMC00016) on the
       left end wall's middle stud, its attachments on it; along the right end wall the plate tree (+ the plates), the dumbbells' stand
       (FMC00021), the kettlebells; the barbell (FMC00027) on two hooks (FMC00028) under the rafters at the back; the bench at the
       pulley; the battle rope coiled. Open (from 45 deg): the bench out at the wall bars, the kettlebells out in the front zone, the
       battle rope out from its anchor on the back base beam, the bands on the wall bars, the barbell on the J-hooks (their disc).
       Outside always: the wall bars on the right end wall (four brackets, two 6x120 each through the cladding into the studs under the
       stiles) with the pull-up + dip bars (the rings from the pull-up bar) or the J-hooks on its + disc; the tyre + the sledgehammer
       in the front zone. The equipment is drawn by _buildKitchenPod (fitL); its bounding box a 'fitbox' piece for the harness (not
       drawn) */
    var fitL = [], fitQ = {}, matA = 0, fpZmax = 0, fpXmax = -1e9, fpXmin = 1e9, galInfo = null;   /* v417 galInfo: the gallows' numbers for its PDF sheet */
    if (fit) (function () {
      var yM = yF + KP.MAT_T, lad = _kpLad(s), ladW = _kpU(s, 'LAD_W'), ladH = _kpU(s, 'LAD_H'), sLad = ladW / 2 - KP.LAD_SW / 2, q;
      /* v415 THE SLIDER'S SECOND HALF on the fitness too (Marek 2026-11-04 09:44 "do poloviny se oteviraji dvere, od poloviny se vyklapi
         prave boxovaci pytel a mirne natoci televize. Ostatni vybaveni se objevi v pracovni pozici / venku az na konci posuvniku"): the
         flaps over the first half; then the bag's gallows swings out and the TV turns a little (swg 0 .. 1 over 90 % of the half); the
         rest of the equipment goes out to its working place only at the slider's end (out) */
      var kpE = _kpExt(s), swg = Math.max(0, Math.min(1, kpE / 0.9)), out = open && kpE >= 0.999;
      swg = swg * swg * (3 - 2 * swg);
      function qn(code, n) { if (code) fitQ[code] = (fitQ[code] || 0) + (n || 1); }
      function item(kind, code, id, x0, x1, y0, y1, z0, z1, o) {
        var it = { kind: kind, code: code, id: id, x0: x0, x1: x1, y0: y0, y1: y1, z0: z0, z1: z1 }, k2;
        for (k2 in (o || {})) if (o.hasOwnProperty(k2)) it[k2] = o[k2];
        fitL.push(it); qn(code);
        if (!(o && o.noBox)) box('fitbox', null, 0, 'fb-' + id, (x0 + x1) / 2, (y0 + y1) / 2, (z0 + z1) / 2, x1 - x0, y1 - y0, z1 - z0);
        fpXmax = Math.max(fpXmax, x1); fpXmin = Math.min(fpXmin, x0); fpZmax = Math.max(fpZmax, z1);
      }
      function miss(name, n, unit) { missing.push({ name: name, qty: n, unit: unit || 'pcs' }); }
      matA = sheet('mat', null, 'mat', [[-Zi, X0 + 0.003], [Zi, X0 + 0.003], [Zi, X1 - 0.003], [-Zi, X1 - 0.003]], null, [0, yF, 0], [0, 0, 1], [1, 0, 0], [0, 1, 0], KP.MAT_T);
      missing.push({ name: KP.MAT_NAME, qty: us ? Math.round(matA * KP.WASTE * 10.7639 * 100) / 100 : Math.round(matA * KP.WASTE * 100) / 100, unit: us ? 'ft2' : 'm2' });

      /* v415 THE TV IN THE MIDDLE (Marek 2026-11-04 09:44 "Uprostred ze stredu muze byt pridelana televize (muze byt na drzaku a otacet
         se 360 stupnu)"): the 2x6 blocking between the two rafters round z 0 (the bag's until v413; now in the front half, off the stored
         barbell), four 6x80 toe screws into them; under it a 360 deg swivel ceiling mount (its plate four 6x80 up into the blocking), the
         TV on it facing the front, turned a little toward the bag as it swings out */
      var rB = KP.BAG_D / 2, ka;
      /* its centre in the middle, or (a short pod) far enough off the stowed bag: the bay of rafters holding that point, the pole never
         moved back toward the bag */
      var zFr0 = -Zi + KP.PUL[1] + 0.06 + KP.BAG_D + 0.03, zFr1 = Zi - KP.WRACK[1] - 0.05 - KP.BENCH[2] - 0.03 - 0.03;   /* between the stowed bag and the stored bench */
      var tvW = Math.min(KP.TV[0], zFr1 - zFr0), tvH = KP.TV[1] * tvW / KP.TV[0], zTw = Math.min(Math.max(0, zFr0 + tvW / 2), zFr1 - tvW / 2);   /* a short pod (a saved 2.70 m): a smaller TV */
      for (ka = 0; ka < bGrid.length - 2; ka++) if (bGrid[ka + 1] > zTw + 0.001) break;
      var za0 = bGrid[ka] + jt / 2, za1 = bGrid[ka + 1] - jt / 2, zb0 = Math.max(zTw, za0 + 0.06);
      if (zb0 > za1 - 0.06 && ka < bGrid.length - 2) { ka++; za0 = bGrid[ka] + jt / 2; za1 = bGrid[ka + 1] - jt / 2; zb0 = za0 + 0.06; }
      var xbg = Math.min(KP.TV_X, X1 - 0.16), ybT = yT(xbg - jt / 2) - 0.001, ybB = ybT - jh;
      box('fblock', KP.JOIST, ceil2(za1 - za0), 'tvblock', xbg, (ybT + ybB) / 2, (za0 + za1) / 2, jt, jh, za1 - za0);
      for (var e6 = 0; e6 < 2; e6++) for (var sg = -1; sg <= 1; sg += 2) scr('screw-fblock', KP.TOE, xbg + jt / 2, ybB + jh * (0.35 + 0.3 * e6), ((sg < 0) ? za0 : za1) - sg * 0.035, [-0.45, 0, 0.89 * sg], len80);
      /* its top under the stored barbell's hooks (it turns toward them), at most KP.TV_DROP under the mount */
      var yCupH = yL(Math.min(xBi + 0.25, -0.05) - 0.03) - 0.001 - 0.006 - 0.07 - KP.BAR_R - 0.01;
      var TV = [tvW, tvH, KP.TV[2]], aT = KP.TV_TURN * swg * Math.PI / 180, nTx = Math.cos(aT), nTz = -Math.sin(aT), yTp = ybB - 0.008, yTc = Math.min(yTp - KP.TV_DROP, yCupH - 0.025) - TV[1] / 2;
      box('tvmount', null, 0, 'tvmount-plate', xbg, yTp + 0.004, zb0, Math.min(jt, 0.06), 0.008, 0.10);
      [-1, 1].forEach(function (e) { [-1, 1].forEach(function (e2) { scrClear('screw-tvmount', KP.TOE, [0.035, 0.025, 0.045, 0.015].map(function (dz) { return [xbg + e * Math.min(jt, 0.06) * 0.25, yTp, zb0 + e2 * dz]; }), [0, 1, 0], len80); }); });
      box('fitbox', null, 0, 'fb-tvpole', xbg, (yTp + yTc) / 2, zb0, 0.04, yTp - yTc, 0.04);
      obox('fitbox', null, 0, 'fb-tv', [xbg + KP.TV_OFF * nTx, yTc, zb0 + KP.TV_OFF * nTz], [nTz, 0, -nTx], [0, 1, 0], [nTx, 0, nTz], TV[0], TV[1], TV[2]);
      fitL.push({ kind: 'tv', code: null, id: 'tv', x0: xbg - 0.02, x1: xbg + 0.02, y0: yTc - TV[1] / 2, y1: yTp, z0: zb0 - 0.02, z1: zb0 + 0.02, xc: xbg, zc: zb0, yTop: yTp, yC: yTc, nx: nTx, nz: nTz, tw: TV[0], th: TV[1] });
      var tvIn = Math.round(43 * tvW / KP.TV[0]);
      miss(KP.TV_NAME.replace('43 IN. (109 CM)', tvIn + ' IN. (' + Math.round(tvIn * 2.54) + ' CM)'), 1); miss(KP.TVMOUNT_NAME, 1);

      /* v415 THE HEAVY BAG ON A SWING-OUT GALLOWS (Marek 09:44 "Boxovaci pytel - i kvuli stabilite bych udelal konstrukci. Kreta by se
         otacela - pytel by se z vnitrni casti natocil o 90 stupnu ven ... ocelova sibenice, jekl masivni prurez ctvercovy, se dvema
         masivnimi svislymi panty. Pridelany na jednom rohovem svislem profilu z vnitrni strany (schovany by smeroval mirne dovnitr podle
         sirky pytle). Uzivatel by konstrukci otocil, aby byl horni vodorovny profil sibenice pak kolmo na osu stavby. Sibenice by mela
         mit vzperu."): a square steel tube mast on two heavy pin hinges whose plates sit on the front left corner post's inner face (four
         6x80 each into the post), the arm on its top, a brace under the arm; stowed, the arm runs along the pod a little inward so the bag
         hangs inside past the pulley (the battle rope coiled under it); the slider's second half turns it on the hinges' pin until the
         arm stands square to the pod's axis and the bag hangs out in front. The pin off the post's face and the arm under the open flap's
         struts' brackets (the mast clear of the strut's foot in every position) */
      var GA = us ? KP.GAL_A_US : KP.GAL_A, GB = us ? KP.GAL_B_US : KP.GAL_B, rK = KP.GAL_KR, PUd = KP.PUL[1];
      var xPc = X1 - p / 2, zPF = -(Z1 - p), xP = xPc + 0.015, zP = zPF + 0.085, dM = rK + GA / 2;
      var zBag = -Zi + PUd + 0.06 + rB, xBag = Math.min(0.05, X1 - rB - 0.02);
      var gbx = xBag - xP, gbz = zBag - zP, Lb = Math.sqrt(gbx * gbx + gbz * gbz), phS = Math.atan2(gbz, gbx), phG = phS * (1 - swg);
      var gux = Math.cos(phG), guz = Math.sin(phG), U3 = [gux, 0, guz], V3 = [0, 1, 0], N3 = [-guz, 0, gux];
      var yG0 = yM + 0.03, yA1 = yHb - 0.12, yA0 = yA1 - GA,   /* v420 30 mm lower (was yHb - 0.09): swung out, its end ran 19 mm into the open flap's blocking (the claddings on battens laid across: v / bb / corr) */ xbB = xP + Lb * gux, zbB = zP + Lb * guz;
      function gP(u, y) { return [xP + u * gux, y, zP + u * guz]; }
      obox('gallows', null, 0, 'gal-mast', gP(dM, (yG0 + yA0) / 2), U3, V3, N3, GA, yA0 - yG0, GA);
      var uA0 = dM - GA / 2, uA1 = Lb + 0.08;
      obox('gallows', null, 0, 'gal-arm', gP((uA0 + uA1) / 2, (yA0 + yA1) / 2), U3, V3, N3, uA1 - uA0, GA, GA);
      /* the brace at 45 deg from the mast's face up to the arm's underside (v417 Marek 10:58 "Vzpera u sibenice nesedi presne na plochy
         vertikalniho a horizontalniho profilu": mitred, one end flat on the mast's face, the other flat on the arm's underside -- a
         parallelogram in the gallows' plane pushed through the tube's width, centred on the frame) */
      var gR = KP.GAL_BR, cs4 = Math.SQRT1_2, bU0 = dM + GA / 2, bY0 = yA0 - gR, gc = GB * cs4;
      var brP = [[bU0, bY0 - gc], [bU0 + gR + gc, yA0], [bU0 + gR - gc, yA0], [bU0, bY0 + gc]];
      sheet('gallows', null, 'gal-brace', brP, null, [xP - N3[0] * GB / 2, 0, zP - N3[2] * GB / 2], U3, V3, N3, GB);
      /* the bag's hook plate under the arm (its hole for the shackle) */
      var hpH = KP.GAL_HP[1], hpW = KP.GAL_HP[0], hpT = KP.GAL_HP[2];
      obox('gallows', null, 0, 'gal-hook', gP(Lb, yA0 - hpH / 2), U3, V3, N3, hpW, hpH, hpT);
      var yHookG = yA0 - hpH + KP.GAL_HP[3];
      /* the two hinges: a plate on the post (four 6x80 into it), a strap out to the knuckle round the pin */
      galInfo = { us: us, GA: GA, GB: GB, rK: rK, kH: KP.GAL_KH, dM: dM, Hm: yA0 - yG0, uA0: uA0, uA1: uA1, Lb: Lb, gR: gR, hp: KP.GAL_HP.slice(),
        pivOff: zP - zPF, pivX: xP - xPc, post: p, plate: [0.08, 0.16, 0.008], strapW: 0.03, strapH: 0.05, hinges: [], phS: phS, scrLen: len80, scrCode: KP.TOE };
      [yG0 + 0.16, Math.min(yA0 - 0.14, ySB - 0.13)].forEach(function (yH, hn) {   /* the upper one under the strut's foot (the shut strut runs up the post) */
        var hid = 'ghinge-' + (hn + 1), zKn = zP - rK * 0.7, hI = { y: yH - yG0, scr: [] }, nF0 = fas.length;
        box('ghinge', null, 0, hid + '-plate', xPc, yH, zPF + 0.004, 0.08, 0.16, 0.008);
        box('ghinge', null, 0, hid + '-strap', xP, yH - KP.GAL_KH / 2 + 0.0225, (zPF + 0.008 + zKn) / 2, 0.03, 0.045, zKn - zPF - 0.008);   /* v417 on the knuckle's lower half (the pin's), the mast's sleeve over it */
        box('fitbox', null, 0, 'fb-' + hid + '-knuckle', xP, yH, zP, 2 * rK * 0.7, KP.GAL_KH, 2 * rK * 0.7);
        [-1, 1].forEach(function (e) { [-1, 1].forEach(function (e2) { scrClear('screw-ghinge', KP.TOE, [[xPc + e * 0.025, yH + e2 * 0.065, zPF + 0.008], [xPc + e * 0.02, yH + e2 * 0.065, zPF + 0.008], [xPc + e * 0.025, yH + e2 * 0.055, zPF + 0.008]], [0, 0, -1], len80);   /* v417 15 mm from the plate's ends first: the driver clear of the knuckle */ }); });
        for (var fq2 = nF0; fq2 < fas.length; fq2++) hI.scr.push([fas[fq2].x - xPc, fas[fq2].y - yH]);   /* where the four went on the plate (for the sheet) */
        galInfo.hinges.push(hI);
        fitL.push({ kind: 'gknuckle', code: null, id: hid + '-knuckle', x0: xP - rK, x1: xP + rK, y0: yH - KP.GAL_KH / 2, y1: yH + KP.GAL_KH / 2, z0: zP - rK, z1: zP + rK, xc: xP, zc: zP });
      });
      miss(KP.GALLOWS_NAME, 1); miss(KP.GHINGE_NAME, 2);
      item('bag', KP.BAG, 'bag', xbB - rB, xbB + rB, yF + KP.BAG_UP, yF + KP.BAG_UP + KP.BAG_H, zbB - rB, zbB + rB, { xc: xbB, zc: zbB, yHook: yHookG });
      miss(KP.BAGHANG_NAME, 1);

      /* THE CABLE PULLEY on the left end wall's middle stud: its plate on the stud's face, four 6x80 into it; the attachments on it */
      var PU = KP.PUL, zw0 = -Zi;
      item('pulley', KP.PULLEY, 'pulley', -PU[0] / 2, PU[0] / 2, yM, yM + PU[2], zw0 + 0.001, zw0 + PU[1], { noBox: true });
      /* v415 its two boxes for the harness: the column (plate, frames, rods) the full height, the carriage, handles and loading pin lower
         down the full depth (the bag's gallows' brace passes over them stowed) */
      box('fitbox', null, 0, 'fb-pulley', 0, yM + PU[2] / 2, zw0 + 0.001 + 0.08, 0.30, PU[2], 0.16);
      box('fitbox', null, 0, 'fb-pulley-lo', 0, yM + 0.70, zw0 + 0.162 + (PU[1] - 0.161) / 2, 0.30, 1.40, PU[1] - 0.161);
      [0.30, 0.80, 1.30, 1.72].forEach(function (yq, r) { var o2 = (r % 2) ? 0.01 : -0.01; scrClear('screw-pulley', KP.TOE, [0, 0.008, -0.008].map(function (dx) { return [o2 + dx, yM + yq, zw0 + 0.012]; }), [0, 0, -1], len80); });
      miss(KP.CATT_NAME, 1, 'set');

      /* v410 THE WALL RACK on the right end wall (Marek 2026-11-03 21:41 "Jednorucky, kettlebelly na drzaku na stene (na druhe nez je
         kladka)"): two uprights on the studs under the wall bars' stiles (three 6x80 each into the stud), the kettlebells' shelf, the
         dumbbells' shelf over it, two plate pegs low with the plates on them */
      var WR = KP.WRACK, zR0 = Zi, zRf = Zi - WR[1], yKs = yM + KP.WR_KB, yDs = yM + KP.WR_DB;
      var xUp = (X1 - p / 2 > 0.60) ? sLad : X1 - p / 2;   /* v411 its uprights on the posts (the 0.50 m pod) */
      item('wrack', null, 'wrack', -WR[0] / 2, WR[0] / 2, yM, yM + WR[2], zRf, zR0 - 0.001, { sx: xUp, yK: yKs, yD: yDs, yP: yM + KP.WR_PEG });
      [-1, 1].forEach(function (e) { [0.15, 0.60, 1.05].forEach(function (yq) { scrClear('screw-wrack', KP.TOE, [0, 0.01, -0.01].map(function (dx) { return [e * xUp + dx, yM + yq, zR0 - 0.04]; }), [0, 0, 1], len80); }); });
      miss(KP.WRACK_NAME, 1); miss(KP.PLATES_NAME, 1, 'set');
      item('dumbbell', KP.DUMBBELLS, 'dumbbells', -0.20, 0.20, yDs, yDs + 0.20, zRf + 0.02, zR0 - 0.02, { noBox: true });   /* v411 the two side by side front to back */

      /* THE KETTLEBELLS: shut on their shelf, open out in the front zone */
      KP.KB_R.forEach(function (r, n) {
        var xc = out ? X1 + 0.75 : [0, 0.115, -0.11][n], zc = out ? -0.85 + 0.30 * n : zR0 - [0.33, 0.16, 0.16][n], y0 = out ? 0 : yKs;   /* v411 on the narrow shelf: two at the back, the small one in front */
        item('kbell', null, 'kbell-' + (n + 1), xc - r, xc + r, y0, y0 + 2.6 * r, zc - r, zc + r, { r: r, noBox: !out });
      });
      miss(KP.KB_NAME, 1, 'set');

      /* THE BARBELL: on two hooks (FMC00028) under two rafters at the back, inside its collars (each a plate under the rafter, two 6x80
         up into it); open with the J-hooks on the wall bars: on them (two plates on it) */
      var rr = KP.BAR_R, half = _kpU(s, 'BAR_L') / 2, xBar = Math.min(xBi + 0.25, -0.05), cand = [];   /* v411 between the hangers, off the bag's chain */
      for (q = 1; q < bGrid.length - 1; q++) if (Math.abs(bGrid[q]) <= 0.62) cand.push(bGrid[q]);
      if (cand.length < 2) cand = bGrid.slice(1, -1).sort(function (a, b) { return Math.abs(a) - Math.abs(b); }).slice(0, 2);
      var zhs = [Math.min.apply(null, cand), Math.max.apply(null, cand)], yRf = yL(xBar - 0.03) - 0.001, yBarS = yRf - 0.006 - 0.07, yCup = yBarS - rr;
      zhs.forEach(function (zq, hi) {
        var hid = 'bhook-' + (hi + 1), yA0 = yCup - 0.01, yA1 = yRf - 0.006;
        box('bhook', null, 0, hid, xBar, yRf - 0.003, zq, 0.06, 0.006, 0.05);
        box('bhook', null, 0, hid + '-arm', xBar - 0.025, (yA0 + yA1) / 2, zq, 0.01, yA1 - yA0, 0.04);
        box('bhook', null, 0, hid + '-cup', xBar + 0.005, yCup - 0.005, zq, 0.05, 0.01, 0.04);
        box('bhook', null, 0, hid + '-lip', xBar + 0.025, yCup + 0.01, zq, 0.01, 0.02, 0.04);
        [-1, 1].forEach(function (e) { scrClear('screw-bhook', KP.TOE, [0, 0.01, -0.01].map(function (dz) { return [xBar + e * 0.016, yRf - 0.006, zq + dz]; }), [0, 1, 0], len80); });
      });
      qn(KP.BAR_RACK);
      var zL0 = Z1 + ext + KP.LAD_OFF, zL1 = zL0 + KP.LAD_SD, yJ = KP.JH_Y, zJ = zL1 + KP.JH_L - 0.04;
      if (out && lad === 'hooks') item('barbell', KP.BARBELL, 'barbell', -half, half, yJ, yJ + 2 * rr, zJ - rr, zJ + rr, { ax: 'x', plates: true });
      else item('barbell', KP.BARBELL, 'barbell', xBar - rr, xBar + rr, yBarS - rr, yBarS + rr, -half, half, { ax: 'z' });

      /* THE BENCH (its back adjustable): shut flat across the pod at the pulley; open out at the wall bars -- flat under the bar on the
         J-hooks (the bench press), else along them with its back raised */
      var BN = KP.BENCH, zBn = zRf - 0.05 - (BN[2] + 0.03), tB = KP.BENCH_TILT, yBt1 = 0.42 + 0.80 * Math.sin(tB * Math.PI / 180) + 0.06;
      if (!out) item('bench', null, 'bench', -BN[1] / 2, BN[1] / 2, yM, yM + BN[0] + 0.02, zBn, zBn + BN[2] + 0.03, { up: true, tilt: 0 });   /* v411 stored standing on its wheels (v415 in front of the wall rack: the bag stows by the pulley) */
      else if (lad === 'hooks') item('bench', null, 'bench', -BN[1] / 2, BN[1] / 2, 0, BN[2], zL1 + 0.05, zL1 + 0.05 + BN[0], { ax: 'z', tilt: 0 });
      else item('bench', null, 'bench', -BN[0] / 2, BN[0] / 2, 0, yBt1, zL1 + 0.95, zL1 + 0.95 + BN[1], { ax: 'x', tilt: tB });
      miss(KP.BENCH_NAME, 1);

      /* THE WALL BARS (steel) on the right end wall outside: two stiles on the ground, the rungs; four brackets (two a stile) on the
         cladding (on the board & batten's strips) over the studs under the stiles, two 6x120 each through it into the stud; the
         pull-up bar on top; on the + disc the J-hooks low (the barbell on them when open) or the dip bars (the rings from the pull-up
         bar) -- both billed */
      item('ladder', null, 'ladder', -ladW / 2, ladW / 2, 0, ladH, zL0, zL1, { sx: sLad });
      miss(KP.LADDER_NAME, 1);
      /* v411 its two wall rails (steel, the ladder's width) on the cladding, two 6x120 through each into every post / stud under it */
      var zBk0 = Z1 + ext + ((clad === 'bb') ? P.tt : 0) + 0.0005, nLb = 0, mem = [-(X1 - p / 2), X1 - p / 2].concat(eStuds).filter(function (xm) { return Math.abs(xm) <= ladW / 2 - 0.02; });
      KP.LAD_BRY.forEach(function (yq, bi) {
        box('lbrk', null, 0, 'lbrk-' + (bi + 1), 0, yq, (zBk0 + zL0 - 0.0005) / 2, ladW, 0.08, zL0 - 0.0005 - zBk0);
        nLb++;
        mem.forEach(function (xq) { [-1, 1].forEach(function (e2) { scrClear('screw-lbrk', KP.STUD_SCREW, [[xq, yq + e2 * 0.02], [xq + 0.01, yq + e2 * 0.02], [xq - 0.01, yq + e2 * 0.02], [xq + 0.01, yq + e2 * 0.012], [xq - 0.01, yq + e2 * 0.012]].map(function (c) { return [c[0], c[1], zBk0 + 0.008]; }), [0, 0, -1], len120); }); });
      });
      var yPu = KP.PU_Y, zPb = zL1 + KP.PU_OUT;
      item('pubar', null, 'pubar', -ladW / 2 - 0.05, ladW / 2 + 0.05, yPu - 0.05, yPu + 0.03, zL1, zPb + KP.PB_R, { yBar: yPu, zBar: zPb - KP.PB_R, sx: sLad });
      if (lad === 'hooks') [-1, 1].forEach(function (e) { item('jhook', null, 'jhook-' + ((e < 0) ? 'k' : 'f'), e * sLad - 0.03, e * sLad + 0.03, yJ - 0.10, yJ, zL1, zL1 + KP.JH_L, { lipY: yJ + 0.05 }); });
      else item('dip', null, 'dip', -ladW / 2, ladW / 2, KP.DIP_Y - 0.06, KP.DIP_Y + 0.03, zL1, zL1 + KP.DIP_L, { sp: KP.DIP_SP / 2, yBar: KP.DIP_Y, sx: sLad });
      miss(KP.PUDIP_NAME, 1, 'set'); miss(KP.JHOOK_NAME, 1, 'pair');
      /* the rings: from the pull-up bar by the dip bars (stored with the J-hooks on) */
      if (lad !== 'hooks') item('rings', KP.RINGS, 'rings', -KP.RING_SP - KP.RING_R, KP.RING_SP + KP.RING_R, 1.55 - KP.RING_R, KP.PU_Y, zL1 + KP.PU_OUT - KP.PB_R - 0.02, zL1 + KP.PU_OUT - KP.PB_R + 0.02, { noBox: true, xc: 0, yBar: KP.PU_Y, zc: zL1 + KP.PU_OUT - KP.PB_R });
      else qn(KP.RINGS);
      /* the bands: open on a rung of the wall bars */
      if (out) [-1, 1].forEach(function (e) { var yR0 = 0.15 + KP.RUNG_SP * Math.round((1.65 - 0.15) / KP.RUNG_SP); item('bands', null, 'bands-' + ((e < 0) ? 'k' : 'f'), e * 0.25 - 0.03, e * 0.25 + 0.03, yR0 - 0.55, yR0, zL0 + KP.LAD_SD / 2 - 0.01, zL0 + KP.LAD_SD / 2 + 0.01, { noBox: true }); });
      miss(KP.BANDS_NAME, 1, 'set');
      discs.push({ id: 'kp-lad', state: lad === 'dip', cyc: true, at: [0, 1.95, zL1 + 0.02], r: KP.DISC_R, face: [0, 0, 1] });

      /* THE BATTLE ROPE (manila / hemp, black grips): its anchor plate on the back base beam's outer face (off the U heads), two 6x80 into
         the beam; shut coiled on the floor in front of the wall rack, open its two ends out in the back zone in waves */
      var zA = 0;
      uheads.forEach(function (u) { if (u.x < 0 && Math.abs(u.z - zA) < 0.16) zA = u.z + ((u.z > 0) ? -0.22 : 0.22); });
      var yAn = yBB + 0.08;
      box('ranchor', null, 0, 'ranchor', X0 - 0.003, yAn, zA, 0.006, 0.10, 0.08);
      [-1, 1].forEach(function (e) { scr('screw-ranchor', KP.TOE, X0 - 0.006, yAn + e * 0.03, zA + e * 0.02, [1, 0, 0], len80); });
      if (out) {
        var xr0 = X0 - 0.02, xr1 = X0 - 0.30 - KP.ROPE_OUT, rR = KP.ROPE_R;
        item('rope', null, 'rope', xr1 - 0.55, xr0, 0, yAn, zA - KP.ROPE_SP / 2 - 0.20, zA + KP.ROPE_SP / 2 + 0.20, { noBox: true, xa: X0 - 0.012, ya: yAn, za: zA, xe: xr1, sp: KP.ROPE_SP / 2, r: rR });
      } else {
        var xcR = 0, zcR = zBag;   /* v415 under the stowed bag (was in front of the wall rack: the bench stands there now) */
        item('rope', null, 'rope', xcR - 0.22, xcR + 0.22, yM, yM + 0.16, zcR - 0.22, zcR + 0.22, { coil: true, r: KP.ROPE_R });
      }
      miss(KP.ROPE_NAME, 1); miss(KP.RANCH_NAME, 1);

      /* THE TYRE + THE SLEDGEHAMMER outside in the front zone (always) */
      var Rt = KP.TYRE_R, xT = X1 + 0.65 + Rt, zT = Math.min(0.55, Zi - Rt + 0.30);
      item('tyre', null, 'tyre', xT - Rt, xT + Rt, 0, KP.TYRE_H, zT - Rt, zT + Rt, { xc: xT, zc: zT });
      /* v415 the hammer on the ground beside the tyre (Marek 09:44 "Kladivo lezi na zemi vedle pneumatiky"; was on the tyre), its handle a
         little askew, the head's face on the ground */
      var hB = 8 * Math.PI / 180, hx0 = xT + Rt + 0.10, hz0 = zT - KP.HAM_L / 2, hdx = Math.sin(hB), hdz = Math.cos(hB), hHx = hx0 + hdx * KP.HAM_L, hHz = hz0 + hdz * KP.HAM_L;
      item('hammer', null, 'hammer', Math.min(hx0 - 0.02, hHx - 0.11), Math.max(hx0 + 0.02, hHx + 0.11), 0, KP.HAM_HD, hz0 - 0.02, hHz + 0.05, { hx0: hx0, hz0: hz0, hdx: hdx, hdz: hdz });
      miss(KP.TYRE_NAME, 1); miss(KP.HAMMER_NAME, 1);
    })();
    /* THE FLAP: framed and clad flat in front of the posts, then turned about the hinge line by a (open: KP.OPEN) */
    var aF = ang * Math.PI / 180, ca = Math.cos(aF), sa = Math.sin(aF);   /* v406 the slider's angle */
    var FU = [ca, sa, 0], FV = [-sa, ca, 0], FN = [0, 0, 1];
    var struts = [], nStrut = 0, nFClad = 0, nHinge = 0;
    function flapSide(xp, yp, yB0, yFt, yFb, Hf, Wf, ySB) {   /* v409 the fitness's back flap the same (mirrored; its band's levels) */
    function rot(x, y) { var dx = x - xp, dy = y - yp; return [xp + dx * ca - dy * sa, yp + dx * sa + dy * ca]; }
    function fbox(kind, code, len, id, x, y, z, dx, dy, dz) {
      if (!aF) { box(kind, code, len, id, x, y, z, dx, dy, dz); return; }
      var c2 = rot(x, y);
      obox(kind, code, len, id, [c2[0], c2[1], z], FU, FV, FN, dx, dy, dz);
    }
    function fscr(kind, code, x, y, z, d, ln, r) {
      var c2 = rot(x, y), dd = [d[0] * ca - d[1] * sa, d[0] * sa + d[1] * ca, d[2]];
      scr(kind, code, c2[0], c2[1], z, dd, ln, r);
    }
    var xFi = X1, xFo = X1 + fw, yr0 = yFb + ft, yr1 = yFt - ft;
    fbox('fframe', KP.FRAME, ceil2(Wf), 'flap-rail-b', xFi + fw / 2, yFb + ft / 2, 0, fw, ft, Wf);
    fbox('fframe', KP.FRAME, ceil2(Wf), 'flap-rail-t', xFi + fw / 2, yFt - ft / 2, 0, fw, ft, Wf);
    var stU = [-(Wf / 2 - ft / 2), -zS, zS, Wf / 2 - ft / 2], nIn = Math.max(1, Math.ceil(2 * zS / sp - 1e-9)), hingeU = [-zS, zS];
    for (k = 1; k < nIn; k++) { var uu = -zS + 2 * zS * k / nIn; stU.push(uu); hingeU.push(uu); }
    stU.sort(function (a, b) { return a - b; }); hingeU.sort(function (a, b) { return a - b; });
    for (k = 0; k < stU.length; k++) {
      fbox('fframe', KP.FRAME, ceil2(yr1 - yr0), 'flap-stile-' + (k + 1), xFi + fw / 2, (yr0 + yr1) / 2, stU[k], fw, yr1 - yr0, ft);
      for (var e3 = -1; e3 <= 1; e3 += 2) {
        fscr('screw-fframe', KP.FRAME_SCREW, xFi + fw / 2 + e3 * fw / 4, yFb, stU[k], [0, 1, 0], len100);
        fscr('screw-fframe', KP.FRAME_SCREW, xFi + fw / 2 + e3 * fw / 4, yFt, stU[k], [0, -1, 0], len100);
      }
    }
    var fBlockY = [];
    if (PCm && !PCm.across) {   /* v413 the panels on the flap's frame: rows, the joints open over the stiles */
      var fSp = pSpans(-Wf / 2, Wf / 2, stU, pW), fRw = pSpans(yFb, yFt, [], pH);
      if (PCm.tape) pTapeL += stU.length * (yr1 - yr0);
      fRw.forEach(function (rw, r) {
        var y0p = rw[0] + (r > 0 ? pG / 2 : 0), y1p = rw[1] - (r < fRw.length - 1 ? pG / 2 : 0);
        fSp.forEach(function (sp2, q) {
          var u0p = sp2[0] + (q > 0 ? pG / 2 : 0), u1p = sp2[1] - (q < fSp.length - 1 ? pG / 2 : 0);
          fbox('f' + PCm.kind, PCm.code, 0, 'flap-pclad-' + (r + 1) + '-' + (q + 1), xFo + tc / 2, (y0p + y1p) / 2, (u0p + u1p) / 2, tc, y1p - y0p, u1p - u0p);
          nFClad++;
        });
      });
    } else if (clad === 'h') {
      for (k = 0; yFb + k * cw < yFt - 0.01; k++) {
        var fy0 = yFb + k * cw, fy1 = Math.min(fy0 + cw - 0.002, yFt);
        fbox('fclad', KP.CLAD, 0, 'flap-clad-' + (k + 1), xFo + tc / 2, (fy0 + fy1) / 2, 0, tc, fy1 - fy0, Wf);
        nFClad++;
      }
    } else {
      /* v405 upright boards on the flap: 2x3 blocking between the stiles at <= 60 cm carries them; a 6x100 through the stile into
         each block's end (the two into one stile off each other in height) */
      fBlockY = fixPts(yr0, yr1, 0.60).slice(1, -1);
      fBlockY.forEach(function (yq, r) {
        for (k = 0; k + 1 < stU.length; k++) {
          var u0 = stU[k] + ft / 2, u1 = stU[k + 1] - ft / 2;
          if (u1 - u0 < 0.05) continue;
          fbox('fframe', KP.FRAME, ceil2(u1 - u0), 'flap-block-' + (r + 1) + '-' + (k + 1), xFi + fw / 2, yq, (u0 + u1) / 2, fw, ft, u1 - u0);
          fscr('screw-fframe', KP.FRAME_SCREW, xFi + fw / 2, yq + 0.008, stU[k] - ft / 2, [0, 0, 1], len100);
          fscr('screw-fframe', KP.FRAME_SCREW, xFi + fw / 2, yq - 0.008, stU[k + 1] + ft / 2, [0, 0, -1], len100);
        }
      });
      if (PCm) { fbox('f' + PCm.kind, PCm.code, 0, 'flap-pclad', xFo + tc / 2, (yFb + yFt) / 2, 0, tc, Hf, Wf); nFClad++; }   /* v413 the corrugated sheet on the blocking */
      for (k = 0; !PCm && -Wf / 2 + k * cw < Wf / 2 - 0.01; k++) {
        var ua = -Wf / 2 + k * cw, ub = Math.min(ua + cw - 0.002, Wf / 2);
        fbox('fclad', KP.CLAD, 0, 'flap-clad-v' + (k + 1), xFo + tc / 2, (yFb + yFt) / 2, (ua + ub) / 2, tc, Hf, ub - ua);
        nFClad++;
      }
    }
    if (PCm) cladP += Wf * Hf; else cladA += Wf * Hf;   /* v413 */
    /* the strap hinges: the leaf on the band, the strap down the flap over a stile; 3 screws each into the rail / the stile */
    var hW = KP.HINGE_W, hTk = KP.HINGE_T, hLeaf = KP.HINGE_LEAF, hStrap = KP.HINGE_STRAP;
    for (k = 0; k < hingeU.length; k++) {
      var hu = hingeU[k];
      box('hinge', null, 0, 'hinge-leaf-' + (k + 1), xp + hTk / 2, yB0 + 0.006 + hLeaf / 2, hu, hTk, hLeaf, hW * 1.6);
      fbox('hinge', KP.HINGE, 0, 'hinge-' + (k + 1), xp + hTk / 2, yFt - hStrap / 2 + 0.004, hu, hTk, hStrap, hW);
      for (j = -1; j <= 1; j++) {
        scrClear('screw-hinge', KP.HINGE_SCREW, [[xp + hTk, yB0 + ft * 0.75, hu + j * hW * 0.5], [xp + hTk, yB0 + ft * 0.75, hu + j * hW * 0.25]], [-1, 0, 0], len50, 0.0025);
        fscr('screw-hinge', KP.HINGE_SCREW, xp + hTk, yFt - 0.13 - (j + 1) * 0.07, hu, [-1, 0, 0], len50, 0.0025);   /* under the frame's screws down into the stile */
      }
    }
    /* v405 board & batten on the flap: a strip over every joint, short of the hinge straps and the knobs; a finish nail into the board
       at the rails and the blocking */
    if (clad === 'bb') {
      var fsT = P.tt, fsW = P.tw, kU = Wf / 2 - 0.30;
      for (k = 1; -Wf / 2 + k * cw < Wf / 2 - fsW - 0.01; k++) {
        var uj = -Wf / 2 + k * cw - 0.001, fs0 = yFb + 0.004, fs1 = yFt - 0.004;
        if (Math.abs(uj) > Wf / 2 - fsW - 0.012) continue;
        if (hingeU.some(function (hu) { return Math.abs(uj - hu) < KP.HINGE_W / 2 + fsW / 2 + 0.004; })) fs1 = yFt - KP.HINGE_STRAP - 0.012;
        if (Math.abs(Math.abs(uj) - kU) < 0.015 + fsW / 2 + 0.004) fs0 = yFb + ft + 0.02;
        fbox('fstrip', KP.TRIM, ceil2(fs1 - fs0), 'flap-bstrip-' + k, xFo + tc + fsT / 2, (fs0 + fs1) / 2, uj, fsT, fs1 - fs0, fsW);
        nStrip++; stripL += fs1 - fs0;
        [yFb + ft / 2, yFt - ft / 2].concat(fBlockY).forEach(function (yq) { if (yq > fs0 + 0.02 && yq < fs1 - 0.02) fscr('nail-fstrip', KP.TRIM_NAIL, xFo + tc + fsT, yq, uj + 0.012, [-1, 0, 0], len32, 0.0012); });
      }
    }
    /* the gas struts: the body's bracket on the end wall's block, the rod's on the strut stile; drawn, NOT BILLED */
    var fLoc = [xFi - KP.STRUT_BR, yp - KP.STRUT_FY];
    for (sz = -1; sz <= 1; sz += 2) {
      var zSt = sz * zS, B = [xSB, ySB, zSt], Fp = rot(fLoc[0], fLoc[1]), F = [Fp[0], Fp[1], zSt];
      var dvx = F[0] - B[0], dvy = F[1] - B[1], dl = Math.sqrt(dvx * dvx + dvy * dvy), ux = dvx / dl, uy = dvy / dl;
      var bodyL = Math.min(KP.STRUT_BODY, dl - 0.03), rodL = dl - bodyL;
      var SU = [ux, uy, 0], SV = [-uy, ux, 0];
      obox('strut', KP.STRUT, 0, 'strut-body-' + (sz < 0 ? 'l' : 'r'), [B[0] + ux * bodyL / 2, B[1] + uy * bodyL / 2, zSt], SU, SV, [0, 0, 1], bodyL, 0.022, 0.022);
      obox('strut', null, 0, 'strut-rod-' + (sz < 0 ? 'l' : 'r'), [B[0] + ux * (bodyL + rodL / 2), B[1] + uy * (bodyL + rodL / 2), zSt], SU, SV, [0, 0, 1], rodL, 0.010, 0.010);
      /* the brackets: on the block's inner face (z) and on the stile's inner face (x of the flap) */
      box('sbracket', null, 0, 'strut-bb-' + (sz < 0 ? 'l' : 'r'), xSB, ySB, sz * (Zi - 0.0015), 0.05, 0.05, 0.003);
      fbox('sbracket', null, 0, 'strut-bf-' + (sz < 0 ? 'l' : 'r'), xFi - 0.0015, yp - KP.STRUT_FY, zSt, 0.003, 0.05, 0.05);
      for (k = -1; k <= 1; k += 2) {
        scr('screw-bracket', KP.BRACKET_SCREW, xSB + k * 0.015, ySB, sz * (Zi - 0.003), [0, 0, sz], len40, 0.0025);
        fscr('screw-bracket', KP.BRACKET_SCREW, xFi - 0.003, yp - KP.STRUT_FY + k * 0.015, zSt, [1, 0, 0], len40, 0.0025);
      }
      struts.push({ len: dl, body: bodyL });
      nStrut++;
    }
    /* v405 the struts billed: FAT00025 GAS STRUT 1200 N (the row the KIOSK thread added, 2026-10-30) */
    /* the knobs on the bottom rail outside, the ball catches inside it into the base beam */
    for (sz = -1; sz <= 1; sz += 2) {
      fbox('knob', KP.KNOB, 0, 'knob-' + (sz < 0 ? 'l' : 'r'), xFo + tc + 0.025, yFb + ft / 2, sz * (Wf / 2 - 0.30), 0.05, 0.03, 0.03);
      fbox('catch', KP.CATCH, 0, 'catch-' + (sz < 0 ? 'l' : 'r'), xFi + 0.007, yFb + ft / 2, sz * (Wf / 2 - 0.025), 0.012, 0.016, 0.016);   /* mortised into the rail, its striker on the post (v411 inside the flap's narrower rail) */
    }
    nHinge += hingeU.length;
    return rot(xFi, yFb)[0];   /* the open flap's reach */
    }
    var fReach = flapSide(xp, yp, yB0, yFt, yFb, Hf, Wf, ySB), kReach = null;
    if (fit) { MX = -1; mid = '-k'; kReach = flapSide(SK.xp, SK.yp, SK.yB0, SK.yFt, SK.yFb, SK.Hf, SK.Wf, SK.ySB); MX = 1; mid = ''; }

    /* the bill's quantities: timber and boards by code, the coating over every wooden face */
    if (PCm && PCm.tape) missing.push(us ? { name: KP.UVMEMB_NAME, qty: Math.round(sheathA * KP.WASTE * 10.7639 * 100) / 100, unit: 'ft2' } : { name: KP.UVMEMB_NAME, qty: Math.round(sheathA * KP.WASTE * 100) / 100, unit: 'm2' });   /* v413 in place of INS00002 */
    if (PCm && PCm.tape && pTapeL > 0) missing.push(us ? { name: KP.PTAPE_NAME, qty: Math.round(pTapeL * KP.WASTE * 3.28084 * 100) / 100, unit: 'ft' } : { name: KP.PTAPE_NAME, qty: Math.round(pTapeL * KP.WASTE * 100) / 100, unit: 'm' });   /* v413 */
    var m3 = {}, coat = cladA + panelA + wfaceA;   /* v405 + the counter's wood face (v413 not the panels) */
    var per = {}; per[KP.STUD] = 2 * (st + sd); per[KP.BASE] = 2 * (bw + bh); per[KP.JOIST] = 2 * (jt + jh); per[KP.POST] = 4 * p; per[KP.FRAME] = 2 * (ft + fw);
    per[KP.BATTEN] = 2 * (bt + bwd); per[KP.DECK] = 2 * (tb + wb); per[KP.TRIM] = 2 * (P.tt + P.tw); per[KP.TOP] = 2 * (topT + topD);
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
      if (per[pc.code]) coat += per[pc.code] * pc.len;
    }
    if (!fit && fin === 'acacia') coat += per[KP.TOP] * Li;   /* v405 the slabs: sealed, not oiled */
    var floorA = (D - 2 * bw) * (L - 2 * bw);
    /* v405 the foundation's quantities (the greenhouses'): the pads' gravel beds; the footings' concrete (proud + down to FD_PIER_D), 4 bars, gravel, geotextile, their holes */
    var bkW = _kpU(s, 'FD_BLK'), gvB = _kpU(s, 'FD_GRAVEL'), pW = _kpU(s, 'FD_PIER_W'), pD = _kpU(s, 'FD_PIER_D'), pG = _kpU(s, 'FD_PIER_GRAVEL'), yHp = _kpU(s, 'FD_PIER_UP');
    var nBk = blocks.length, nPo = pours.length, r3f = function (v) { return Math.round(v * 1000) / 1000; };
    var fq = { blockN: nBk, pourN: nPo, gravel: r3f(nBk * bkW * bkW * gvB + nPo * pW * pW * pG), dig: r3f(nBk * bkW * bkW * gvB + nPo * pW * pW * (pD + pG)), concrete: r3f(nPo * pW * pW * (pD + yHp)),
               rebar: Math.round(nPo * 4 * (pD + yHp - 2 * KP.FD_BAR_COVER) * 100) / 100, geotex: Math.round(nPo * pW * pW * 100) / 100 };
    return {
      P: P, us: us, open: open, L: L, D: D, W: D, pieces: pieces, fas: fas, sheets: sheets, gscrews: gscrews, uheads: uheads, missing: missing,
      found: found, blocks: blocks, pours: pours, fq: fq,
      meters: m3, coat: coat, sheathA: sheathA, cladA: cladA, cladP: cladP, pclad: PCm ? clad : null, pTape: !!(PCm && PCm.tape), panelA: panelA, fin: fin, cboardA: cboardA, stoneA: stoneA, wfaceA: wfaceA, inoxA: inoxA, topA: Li * topD, roofA: roofA, dripL: dripL, dripNails: dripNails, topL: Li, hangers: nHang,
      shelf: shelf,
      bays: bays, mods: mods, grillBay: grillBay, sinkBay: sinkBay, discs: discs, runs: runs, gas: gas, sinkSvc: sinksS, devs: devs, led: led, clipsP: clipsP, clipsC: clipsC, hinges: nHinge, struts: struts, nBat: nBat, batL: batL, nClad: nClad + nFClad,
      xFace: xFace, xFr: xFr, xMb: xMb, xBi: xBi, xWf: xWf, yWt: yWt, yWb: yWb, yM0: yM0, yM1: yM1, yFrT: yFrT, gx0: gx0, gx1: gx1, skx0: skx0, skx1: skx1, bnx0: bnx0, bnx1: bnx1, kxc: kxc, kCut: kCut, Zi: Zi,
      yBB: yBB, yBt: yBt, yF: yF, yHt: yHt, yHb: yHb, yPB: yPB, yB0: yB0, yB1: yB1, xp: xp, yp: yp, Hf: Hf, Wf: Wf, aF: aF, pitch: KP.PITCH, rafL: rafL,
      rafters: bGrid.length, joists: jGrid.length, eStuds: eStuds.length, seams: nPan - 1, floorA: floorA,
      top: roofTop, height: roofTop, depth: D, length: L, roofCov: roofCov, green: green,
      ang: ang, frame: steelF ? 'steel' : 'wood', sJoints: sJoints, shieldA: shieldA,
      fp: fit, fitL: fitL, fitQ: fitQ, matA: matA, gal: galInfo, lad: fit ? _kpLad(s) : null, yHtK: yHtK, kp: SK,   /* v409 the fitness: its wall bars' attachment, its back header, its back band's levels */
      extX: Math.max(xs1, (ang > 0.5) ? fReach : xs1, fit ? fpXmax : -1e9) + 0.02, extZ: Math.max(zR + 0.01, fpZmax), extXb: fit ? Math.max(-(xs0 - 0.01), (ang > 0.5) ? kReach + 0.02 : 0, -fpXmin + 0.02) : -(xa - 0.01)
    };
  }
  /* its staged assembly: one catalogue item a step, the screws that fix it
     the step after (the membrane, staples, underlay and clips named with
     the sheet they go with) */
  var _kpStepsC = null;
  function _kpSteps(s) {
    if (_kpStepsC) return _kpStepsC;
    return (_kpStepsC = [
      { parts: [], codes: [] },
      { parts: ['kp-block'], codes: [KP.DIG, KP.GRAVEL, KP.FD_BLOCK] },                                                  /* v405 precast pads */
      { parts: ['kp-pour'], codes: [KP.DIG, KP.GRAVEL, KP.FD_GEOTEX, KP.FD_FORMWORK, KP.FD_REBAR, KP.FD_CONCRETE] },     /* v405 poured footings */
      { parts: ['kp-gscrew'], codes: [KP.GSCREW] },
      { parts: ['kp-uhead'], codes: [KP.UHEAD] },
      { parts: ['kp-uanchor'], codes: [KP.FD_UANCHOR] },   /* v405 the footings' wet-set anchors */
      { parts: ['kp-base'], codes: [KP.BASE] },
      { parts: ['kp-hw-screw-base'], codes: [KP.BASE_SCREW] },
      { parts: ['kp-hw-nail-uhead'], codes: [KP.UNAIL] },
      { parts: ['kp-hanger'], codes: [KP.HANGER] },
      { parts: ['kp-joist'], codes: [KP.JOIST] },
      { parts: ['kp-hw-nail-hanger'], codes: [KP.UNAIL] },
      { parts: ['kp-deck'], codes: [KP.DECK] },
      { parts: ['kp-hw-screw-deck'], codes: [KP.DECK_SCREW] },
      { parts: ['kp-post'], codes: [KP.POST] },
      { parts: ['kp-hw-screw-post'], codes: [KP.FRAME_SCREW] },
      { parts: ['kp-plate', 'kp-stud', 'kp-estud', 'kp-tplate', 'kp-rplate'], codes: [KP.STUD] },
      { parts: ['kp-hw-screw-stud', 'kp-hw-screw-tplate', 'kp-hw-screw-plate'], codes: [KP.STUD_SCREW] },
      { parts: ['kp-hw-screw-corner', 'kp-hw-screw-post-wall'], codes: [KP.FRAME_SCREW, KP.LONG_SCREW] },
      { parts: ['kp-sblock'], codes: [KP.STUD] },
      { parts: ['kp-hw-screw-toe'], codes: [KP.TOE] },
      { parts: ['kp-header'], codes: [KP.BASE] },
      { parts: ['kp-hw-screw-header'], codes: [KP.BASE_SCREW] },
      { parts: ['kp-rhanger'], codes: [KP.HANGER] },
      { parts: ['kp-rafter'], codes: [KP.JOIST] },
      { parts: ['kp-hw-nail-rhanger'], codes: [KP.UNAIL] },
      { parts: ['kp-hw-screw-seat', 'kp-hw-screw-rend'], codes: [KP.SEAT_SCREW, KP.LONG_SCREW] },
      { parts: ['kp-sheath'], codes: [KP.WALL_OSB, KP.SHEATH_SCREW] },
      { parts: ['kp-batten'], codes: [KP.MEMB, KP.STAPLE, KP.BATTEN] },
      { parts: ['kp-hw-screw-batten'], codes: [KP.TOE] },
      { parts: ['kp-brail'], codes: [KP.FRAME] },
      { parts: ['kp-hw-screw-brail'], codes: [KP.FRAME_SCREW] },
      { parts: ['kp-ecleat'], codes: [KP.FRAME] },                     /* v411 the corners' cleats on the posts */
      { parts: ['kp-hw-screw-ecleat'], codes: [KP.FRAME_SCREW] },
      { parts: ['kp-roofosb'], codes: [KP.ROOF_OSB, KP.SHEATH_SCREW] },
      { parts: ['kp-fascia'], codes: [KP.BOARD] },
      { parts: ['kp-hw-screw-fascia'], codes: [KP.FASCIA_SCREW] },
      { parts: ['kp-cover', 'kp-seam'], codes: [KP.UNDERLAY, KP.STAPLE, KP.SEAM, KP.CLIP_SCREW] },
      { parts: ['kp-kerb'], codes: [KP.STUD] },                         /* v405 the green roof's kerbs */
      { parts: ['kp-epdm'], codes: [] },                                /* v405 the EPDM (no catalogue row yet) */
      { parts: ['kp-hw-screw-kerb'], codes: [KP.LONG_SCREW] },
      { parts: ['kp-gstop', 'kp-rgravel'], codes: [KP.RGRAVEL] },
      { parts: ['kp-sedum'], codes: [] },
      { parts: ['kp-drip'], codes: [KP.DRIP, KP.ROOF_NAIL] },
      { parts: ['kp-clad', 'kp-band'], codes: [KP.CLAD, KP.CLAD_SCREW] },
      { parts: ['kp-hw-nail-cclad'], codes: [KP.TRIM_NAIL] },          /* v411 the corner boards' nails */
      { parts: ['kp-pfc'], codes: [KP_PCLAD.fc.code, KP_PCLAD.fc.fix] },            /* v413 the panel claddings: fibre cement, */
      { parts: ['kp-pcor'], codes: [KP_PCLAD.corten.code, KP_PCLAD.corten.fix] },   /* -- corten, */
      { parts: ['kp-pcorr'], codes: [KP_PCLAD.corr.code, KP_PCLAD.corr.fix] },      /* -- corrugated */
      { parts: ['kp-hw-screw-pcorner', 'kp-hw-screw-ptrim'], codes: ['FAS00225'] },   /* -- their folded corners' sealing screws (drawn, billed as drawn) */
      { parts: ['kp-rake'], codes: [KP.BOARD] },
      { parts: ['kp-hw-screw-rake'], codes: [KP.RAKE_SCREW] },
      { parts: ['kp-trim'], codes: [KP.TRIM] },
      { parts: ['kp-hw-nail-trim'], codes: [KP.TRIM_NAIL] },
      { parts: ['kp-bstrip'], codes: [KP.TRIM] },                     /* v405 board & batten: the strips over the joints */
      { parts: ['kp-hw-nail-bstrip'], codes: [KP.TRIM_NAIL] },
      { parts: ['kp-cframe'], codes: [KP.STUD] },
      { parts: ['kp-hw-screw-cframe', 'kp-hw-screw-ctoe', 'kp-hw-screw-csill', 'kp-hw-screw-ledger'], codes: [KP.LONG_SCREW, KP.TOE, KP.STUD_SCREW] },
      { parts: ['kp-sframe'], codes: [KP.MSTUD, KP.MS_SCREW] },          /* v406 the steel frame: the studs cut, folded and screwed */
      { parts: ['kp-hw-screw-sframe'], codes: [KP.MS_SCREW] },
      { parts: ['kp-jbox'], codes: [KP.JBOX] },                       /* v382 the services' rough-in */
      { parts: ['kp-hw-screw-jbox'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-cable'], codes: [KP.CABLE] },
      { parts: ['kp-pex'], codes: [KP.PEX] },
      { parts: ['kp-drain'], codes: [KP.DRAIN] },
      { parts: ['kp-dbend'], codes: [KP.DBEND] },
      { parts: ['kp-manifold'], codes: [KP.MANIFOLD] },
      { parts: ['kp-gasline'], codes: [KP.GASLINE] },
      { parts: ['kp-gaselbow'], codes: [KP.GASELBOW] },
      { parts: ['kp-panel'], codes: [KP.PANEL, KP.CLAD_SCREW, KP.WING_SCREW] },
      { parts: ['kp-cboard'], codes: [KP.CBOARD, KP.CB_SCREW] },       /* v405 the concrete finish: cement board, then the veneer */
      { parts: ['kp-stone'], codes: [KP.STONE, KP.STONE_ADH] },
      { parts: ['kp-inox'], codes: [KP.INOX, KP.INOX_GLUE] },        /* v412 the inox look's stainless, bonded */
      { parts: ['kp-wface'], codes: [KP.CLAD, KP.CLAD_SCREW, KP.WING_SCREW] },        /* v405 the granite finish's wood face */
      { parts: ['kp-module'], codes: [KP.COMBO, KP.DDOOR, KP.DRAWER, KP.TRASH, KP.SDOOR] },
      { parts: ['kp-fridge'], codes: [KP.FRIDGE] },                  /* v379 the equipment: a step drops out when nothing of it is drawn */
      { parts: ['kp-top'], codes: [KP.TOP] },
      { parts: ['kp-ctop'], codes: [KP.WORKTOP] },                     /* v405 the concrete slab */
      { parts: ['kp-gtop'], codes: [] },                               /* v405 the granite (no catalogue row yet) */
      { parts: ['kp-shield'], codes: [KP.CBOARD, KP.CB_SCREW] },       /* v406 the heat shield behind the hot bays */
      { parts: ['kp-grill'], codes: [KP.GRILL] },
      { parts: ['kp-burner'], codes: [KP.BURNER] },
      { parts: ['kp-kamado'], codes: [KP.KAMADO] },
      { parts: ['kp-sink', 'kp-tap'], codes: [KP.SINK, KP.TAP] },
      { parts: ['kp-pizza'], codes: [KP.PIZZA] },
      { parts: ['kp-siphon'], codes: [KP.SIPHON] },                   /* v382 the services' connections and fittings */
      { parts: ['kp-dropear'], codes: [KP.DROPEAR] },
      { parts: ['kp-hw-screw-dropear'], codes: [KP.BRACKET_SCREW, KP.MS_SCREW] },
      { parts: ['kp-flexi'], codes: [KP.FLEXI] },
      { parts: ['kp-gasvalve'], codes: [KP.GASVALVE] },
      { parts: ['kp-bottle'], codes: [KP.BOTTLE] },
      { parts: ['kp-regulator'], codes: [KP.REGULATOR] },
      { parts: ['kp-gashose'], codes: [KP.GASHOSE] },
      { parts: ['kp-socket'], codes: [KP.SOCKET] },
      { parts: ['kp-switch'], codes: [KP.SWITCH] },
      { parts: ['kp-hw-screw-ebox'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-wlight'], codes: [KP.WLIGHT] },
      { parts: ['kp-hw-screw-wlight'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-psu'], codes: [KP.PSU] },
      { parts: ['kp-hw-screw-psu'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-led'], codes: [KP.LED] },
      { parts: ['kp-shelfbr'], codes: [KP.SHELF_BR] },                 /* v405 the shelf: its brackets, the 2x6 */
      { parts: ['kp-hw-screw-shelfbr'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-shelf'], codes: [KP.JOIST] },
      { parts: ['kp-hw-screw-shelf'], codes: [KP.SHELF_SCREW] },
      { parts: ['kp-mat'], codes: [] },                                /* v407 the fitness: the rubber tiles (no catalogue row yet) */
      { parts: ['kp-fblock'], codes: [KP.JOIST] },                     /* -- the TV mount's blocking (v415; the heavy bag's until v413) */
      { parts: ['kp-hw-screw-fblock'], codes: [KP.TOE] },
      { parts: ['kp-tvmount'], codes: [] },                            /* v415 the TV's swivel ceiling mount, the TV (no catalogue rows yet) */
      { parts: ['kp-hw-screw-tvmount'], codes: [KP.TOE] },
      { parts: ['kp-tv'], codes: [] },
      { parts: ['kp-ghinge'], codes: [] },                             /* v415 the bag's gallows: its hinges on the corner post, the gallows (no catalogue rows yet) */
      { parts: ['kp-hw-screw-ghinge'], codes: [KP.TOE] },
      { parts: ['kp-gallows', 'kp-gknuckle'], codes: [] },
      { parts: ['kp-bag'], codes: [KP.BAG] },
      { parts: ['kp-pulley'], codes: [KP.PULLEY] },                    /* v409 the cable pulley on the left end wall */
      { parts: ['kp-hw-screw-pulley'], codes: [KP.TOE] },
      { parts: ['kp-bhook'], codes: [KP.BAR_RACK] },                   /* -- the barbell's hooks (v409 under the rafters) */
      { parts: ['kp-hw-screw-bhook'], codes: [KP.TOE] },
      { parts: ['kp-barbell'], codes: [KP.BARBELL] },
      { parts: ['kp-wrack'], codes: [] },                              /* v410 the wall rack + the plates (no catalogue rows yet) */
      { parts: ['kp-hw-screw-wrack'], codes: [KP.TOE] },
      { parts: ['kp-dumbbell'], codes: [KP.DUMBBELLS] },
      { parts: ['kp-kbell'], codes: [] },                              /* v409 the kettlebells, the bench (no catalogue rows yet) */
      { parts: ['kp-bench'], codes: [] },
      { parts: ['kp-lbrk'], codes: [] },                               /* v409 the wall bars: the brackets (v411 rails), the ladder, its attachments (no catalogue rows yet) */
      { parts: ['kp-hw-screw-lbrk'], codes: [KP.STUD_SCREW] },
      { parts: ['kp-ladder'], codes: [] },
      { parts: ['kp-pubar', 'kp-dip'], codes: [] },
      { parts: ['kp-jhook'], codes: [] },
      { parts: ['kp-rings'], codes: [KP.RINGS] },
      { parts: ['kp-bands'], codes: [] },
      { parts: ['kp-ranchor'], codes: [] },                            /* v409 the battle rope's anchor, the rope (no catalogue rows yet) */
      { parts: ['kp-hw-screw-ranchor'], codes: [KP.TOE] },
      { parts: ['kp-rope'], codes: [] },
      { parts: ['kp-tyre', 'kp-hammer'], codes: [] },                  /* v409 the tyre + the sledgehammer (no catalogue rows yet) */
      { parts: ['kp-fframe'], codes: [KP.FRAME] },
      { parts: ['kp-hw-screw-fframe'], codes: [KP.FRAME_SCREW] },
      { parts: ['kp-fclad'], codes: [KP.CLAD, KP.CLAD_SCREW] },
      { parts: ['kp-fpfc', 'kp-fpcor', 'kp-fpcorr'], codes: [] },   /* v413 the flap's panels (billed with the walls') */
      { parts: ['kp-fstrip'], codes: [KP.TRIM] },                     /* v405 board & batten on the flap */
      { parts: ['kp-hw-nail-fstrip'], codes: [KP.TRIM_NAIL] },
      { parts: ['kp-hinge'], codes: [KP.HINGE] },
      { parts: ['kp-hw-screw-hinge'], codes: [KP.HINGE_SCREW] },
      { parts: ['kp-strut', 'kp-sbracket'], codes: [KP.STRUT] },
      { parts: ['kp-hw-screw-bracket'], codes: [KP.BRACKET_SCREW] },
      { parts: ['kp-knob'], codes: [KP.KNOB] },
      { parts: ['kp-catch'], codes: [KP.CATCH] }
    ]);
  }
  var _kpLogKey = '';
  /* ------------------------------------------------------------------
     v364 TYPE 28 -- PLAYHOUSES, variant 3: THE A-FRAME HUT (Marek
     2026-10-29 16:39 "Dalsi krok" -- slot 3 of the plan). The cottage's
     floor on deck blocks and a 60 deg A-frame whose roof runs down to it:
       - FLOOR: the cottage's -- deck blocks, 2x6 rims + joists at <= 40 cm
         (US 16 in.), the OSB between the sills;
       - SILLS: a 2x6 KVH60160 laid flat on each rim, flush outside, two
         6x120 FAS60120 down into the rim between every two joists;
       - RAFTERS: 2x4 KVH10060 pairs at <= 60 cm (US 24 in.), each foot cut
         level on its sill (two 6x80 FAS60080 toe screws), plumb against a
         2x6 ridge board (four toe screws a pair, the cottage's); 2x4 collar
         ties beside every pair but the gables', their underside >= 1.15 m
         (US 45 in.) over the floor, their ends cut to the rafters' slope,
         two 6x80 into each rafter; fly rafters 15 cm (US 6 in.) past each
         gable (past the porch's front pair with the porch);
       - ROOF: OSB25001 from the ridge to just past the skirt, underlay
         ROR00008, asphalt shingles ROR00001 + caps, drip edge ROM02401
         along the foot and the rakes, 1x4 rake boards on the fly rafters;
       - GABLES: 2x4 studs at <= 40 cm (US 16 in.) from the middle on a 2x4
         bottom plate, each cut to the end rafter's underside (a toe screw
         up into it); the front with the cottage's ledge-and-brace door (60
         wide, as high as the rafters let its header -- 1.30 m / US 52 in.
         at most), the back with a 46 x 46 window (sill 50 cm / US 20 in.,
         lower where the rafters ask), no shutters (no room on the slope);
         panel siding FCP00009 up to the rafters' top, casings;
       - SKIRT: panel siding over the rims and sills along both sides, under
         the roof's foot; corner boards at the house's corners;
       - PORCH (the info bar's toggle, on): the floor and the whole A-frame
         run on 90 cm (US 3 ft) past the front gable over a deck of
         TST00001 -- a sheltered entrance, open at the front.
     W 2.10-3.00 m (US 7-10 ft) across the A's foot (the door needs the
     width), L as the cottage. X across, Y up, Z along (+Z the front). */
  var AF = {
    W: [2.10, 3.00], W_US: [2.1336, 3.048], W0: 2.40, W0_US: 2.4384,
    PITCH: 60, COLLAR_Y: 1.15, COLLAR_Y_US: 1.143, GSTUD_SP: 0.40, GSTUD_SP_US: 0.4064,
    WIN_SILL: 0.50, WIN_SILL_US: 0.508, WIN_SILL_MIN: 0.30, DOOR_MAX: 1.30, DOOR_MAX_US: 1.3208,
    SILL: 'KVH60160', SILL_SCREW: 'FAS60120', TOE: 'FAS60080'
  };
  function _afU(s, k) { return ((s || STATE).isMetric === false && AF[k + '_US'] != null) ? AF[k + '_US'] : AF[k]; }
  function _phIsAf(s) { return ((s || STATE).variant | 0) === 28; }
  /* the playhouse types' one source: the A-frame its own, the cottage / stilt house theirs */
  /* v369 THE TREE FORT'S TREE IS THE CONFIGURATORS' OWN TREE (Marek 2026-10-29 22:29: strom pouzij ten co mame z shopify content,
     pouzivame v exterierech na konfiguratorech, treba u bunker). The low-poly tree without leaves from the store's Files -- the scenery
     tree 'a' of configurator-ui.js and the bunker's context tree. Its loading is the kit's _treeLoad copied (every mesh merged into one
     position buffer, height 1, the base at y = 0); adapted for the fort: the trunk's axis is found from the lowest vertices, the trunk's
     radius at the foot (rb) and where the first branch leaves it (yFork). Each build then makes it as tall as the branches need to clear
     the fort's walls (4.5-10 m), and widens or slims the trunk only (up to the fork, eased into the crown) so its diameter at the deck
     is the slider's. Until it has loaded -- or when the store cannot be reached -- the drawn trunk stands in. */
  var PH_TREE_GLB = 'https://cdn.shopify.com/3d/models/302bf12dc2946fa5/tree_without_leaves_low_poly.glb';
  var _phTreeC = null, _phTreeP = null, _phTreeFail = false;
  function _phTreeLoad() {
    if (_phTreeC || _phTreeP || _phTreeFail) return _phTreeP;
    _phTreeP = _ensureGLTFLoader().then(function () {
      return new Promise(function (res, rej) { new global.GLTFLoader().load(PH_TREE_GLB, res, undefined, rej); });
    }).then(function (gltf) {
      var T = global.THREE, pos = [], k, parts = [], hMax = 0, nDrop = 0;
      gltf.scene.updateMatrixWorld(true);
      gltf.scene.traverse(function (o) {
        if (!o.isMesh || !o.geometry) return;
        var gq = o.geometry.clone();
        if (gq.index) gq = gq.toNonIndexed();
        gq.applyMatrix4(o.matrixWorld);
        var a = gq.getAttribute('position').array, py0 = 1e9, py1 = -1e9;
        for (k = 1; k < a.length; k += 3) { py0 = Math.min(py0, a[k]); py1 = Math.max(py1, a[k]); }
        parts.push({ a: a, h: py1 - py0, name: o.name || '' });
        hMax = Math.max(hMax, py1 - py0);
      });
      /* v372 the tree only: the GLB also holds a small plant and a twig lying on the ground ~0.6 of the tree's height to its side
         (tree_plamatisate_0, tree_twig_0) -- merged in, they were the lowest vertices, so the trunk's axis was taken there (the tree
         stood ~3 m off the fort's opening) and they lifted the trunk's foot ~3 % off the ground. Every mesh under a quarter of the
         tallest one's height is left out. */
      parts.forEach(function (pt) {
        if (pt.h < 0.25 * hMax) { nDrop++; return; }
        for (k = 0; k < pt.a.length; k++) pos.push(pt.a[k]);
      });
      if (!pos.length) throw new Error('no mesh in the tree glb');
      var y0 = 1e9, y1 = -1e9, n = pos.length / 3;
      for (k = 0; k < n; k++) { y0 = Math.min(y0, pos[3 * k + 1]); y1 = Math.max(y1, pos[3 * k + 1]); }
      var h = Math.max(1e-6, y1 - y0);
      for (k = 0; k < n; k++) { pos[3 * k] /= h; pos[3 * k + 1] = (pos[3 * k + 1] - y0) / h; pos[3 * k + 2] /= h; }
      /* the trunk's axis: the middle of the lowest vertices */
      var low = [], sx = 0, sz = 0;
      for (k = 0; k < n; k++) if (pos[3 * k + 1] < 0.04) low.push(k);
      if (low.length < 3) { var ord = []; for (k = 0; k < n; k++) ord.push(k); ord.sort(function (a2, b2) { return pos[3 * a2 + 1] - pos[3 * b2 + 1]; }); low = ord.slice(0, Math.max(3, Math.round(n * 0.03))); }
      low.forEach(function (q) { sx += pos[3 * q]; sz += pos[3 * q + 2]; });
      var ax = sx / low.length, az = sz / low.length;
      function rad(q) { var dx = pos[3 * q] - ax, dz = pos[3 * q + 2] - az; return Math.sqrt(dx * dx + dz * dz); }
      var rl = low.map(rad).sort(function (a2, b2) { return a2 - b2; }), rb = rl[Math.floor(rl.length / 2)] || 0.02;
      /* the fork: the lowest vertex well off the trunk (above the root flare) */
      var yFork = 0.5;
      for (k = 0; k < n; k++) { var yq = pos[3 * k + 1]; if (yq > 0.06 && yq < yFork && rad(k) > Math.max(2.5 * rb, 0.05)) yFork = yq; }
      var rf = [];
      for (k = 0; k < n; k++) { var yv = pos[3 * k + 1]; if (yv >= yFork - 0.06 && yv < yFork && rad(k) < 2 * rb) rf.push(rad(k)); }
      rf.sort(function (a2, b2) { return a2 - b2; });
      var rF = rf.length ? rf[Math.floor(rf.length / 2)] : rb * 0.8;
      _phTreeC = { pos: new Float32Array(pos), ax: ax, az: az, rb: rb, rF: rF, yFork: yFork, n: n };
      _dbg('[ph] tree model loaded: ' + n + ' vertices (' + nDrop + ' small mesh(es) beside it left out), trunk axis ' + ax.toFixed(4) + ' / ' + az.toFixed(4) + ', r ' + rb.toFixed(4) + ' at the foot / ' + rF.toFixed(4) + ' under the first branch at ' + Math.round(yFork * 100) + ' % of its height (v372)');
      try { if (_phIsTf(STATE)) _peRebuild(false); } catch (eR) {}
    }).catch(function (e) {
      _phTreeP = null; _phTreeFail = true;
      _dbg('[ph] tree model NOT LOADED (' + ((e && e.message) || e) + ') -- the drawn trunk stands in');
    });
    return _phTreeP;
  }
  /* the tree for a trunk of diameter d at the deck's height yDk: a geometry with the trunk's axis at x = z = 0 */
  function _phTreeGeo(d, yDk) {
    var C = _phTreeC, T = global.THREE;
    if (!C || !T) return null;
    var H = Math.max(4.5, Math.min(10, Math.max(5.5, 2.7 / C.yFork)));        /* its first branch over the walls (2.7 m) */
    var tD = Math.max(0, Math.min(1, (yDk / H - 0.03) / Math.max(0.01, C.yFork - 0.03)));
    var rN = C.rb + (C.rF - C.rb) * tD;                                       /* its trunk's radius at the deck, as modelled */
    var kT = Math.max(0.2, Math.min(8, (d / 2) / Math.max(1e-4, rN * H)));    /* the trunk's widening to the slider's */
    var kC = Math.max(0.7, Math.min(1.6, Math.sqrt(kT)));                     /* the crown's, gentler */
    var yF = C.yFork * H, y0b = yF * 0.85, y1b = yF + 0.9;
    var src = C.pos, out = new Float32Array(src.length), q;
    for (q = 0; q < C.n; q++) {
      var y = src[3 * q + 1] * H, f;
      if (y <= y0b) f = kT; else if (y >= y1b) f = kC; else { var u = (y - y0b) / (y1b - y0b); u = u * u * (3 - 2 * u); f = kT + (kC - kT) * u; }
      out[3 * q] = (src[3 * q] - C.ax) * H * f;
      out[3 * q + 1] = y;
      out[3 * q + 2] = (src[3 * q + 2] - C.az) * H * f;
    }
    var g = new T.BufferGeometry();
    g.setAttribute('position', new T.Float32BufferAttribute(out, 3));
    g.computeVertexNormals();
    g.userData = { H: H, kT: kT, kC: kC, yFork: yF };
    return g;
  }
  /* v369 THE LEAVES (Marek 2026-10-29 22:29: okenice udelej mirne zavrene, kazda muze byt jinak at to vypada dynamicky, dvere mirne
     pootevrene; pri prochazeni ve VR animovane). The layouts draw every door shut and every shutter open flat on the siding -- that
     geometry stays the single source of the bill, the cut lists and the harness. This pass only finds each leaf (its boards, ledges and
     braces by id, the strap hinges, knob and catch on it, and the nails / hinge screws whose heads sit on it) and the line it turns on
     (the strap hinges' edge, at the leaf's outer face); _buildPlayhouse turns the drawn meshes about that line: a door 22 deg ajar
     outward (the barn's leaves 22 / 12 / 30), each shutter 10-42 deg off the wall towards its window (no two alike). The AR file carries every leaf as a node of its
     own on its hinge (extras.leaf, the house line's core-v629 contract) -- the walk-through on the AR page shuts the doors and opens
     them, folds the shutters back flat, as you come near. */
  var PH_SHUT_DEG = [18, 34, 10, 42, 26, 14, 38, 22], PH_DOOR_DEG = [22, 12, 30];   /* the barn's two leaves and its hayloft door not alike either */
  function _phLeaves(g) {
    var list = [], byKey = {}, i, k, m;
    function leafOf(key, kind) {
      if (!byKey[key]) { byKey[key] = { key: key, kind: kind, b: [1e9, -1e9, 1e9, -1e9, 1e9, -1e9], pieces: [], hw: [], fas: [], straps: [] }; list.push(byKey[key]); }
      return byKey[key];
    }
    function grow(L, x0, x1, y0, y1, z0, z1) { var b = L.b; b[0] = Math.min(b[0], x0); b[1] = Math.max(b[1], x1); b[2] = Math.min(b[2], y0); b[3] = Math.max(b[3], y1); b[4] = Math.min(b[4], z0); b[5] = Math.max(b[5], z1); }
    for (i = 0; i < g.pieces.length; i++) {
      var pc = g.pieces[i], id = pc.id || '', L = null;
      if ((m = /^(door(?:-[lr])?|hayloft)-(board|ledge|brace)-\d+$/.exec(id))) L = leafOf(m[1], 'door');
      else if ((m = /^shutter-(?:ledge-)?(.+)-\d+$/.exec(id)) && !/^shutter-hinge-/.test(id)) L = leafOf('sh-' + m[1], 'shutter');
      if (!L) continue;
      L.pieces.push(i);
      if (pc.box) { var bx = pc.box; grow(L, bx[0] - bx[3] / 2, bx[0] + bx[3] / 2, bx[1] - bx[4] / 2, bx[1] + bx[4] / 2, bx[2] - bx[5] / 2, bx[2] + bx[5] / 2); }
      else if (pc.poly && pc.plane === 'xy') {
        var xs = pc.poly.map(function (q) { return q[0]; }), ys = pc.poly.map(function (q) { return q[1]; });
        grow(L, Math.min.apply(null, xs), Math.max.apply(null, xs), Math.min.apply(null, ys), Math.max.apply(null, ys), pc.c - pc.t / 2, pc.c + pc.t / 2);
      }
    }
    if (!list.length) return { list: [], piece: {}, hw: {}, fas: {} };
    for (i = 0; i < g.hw.length; i++) {
      var h = g.hw[i], hid = h.id || '', key = null;
      if ((m = /^(door(?:-[lr])?|hayloft)-(?:hinge-\d+|knob|catch)$/.exec(hid))) key = m[1];
      else if ((m = /^shutter-hinge-(?!leaf-)(.+)\d$/.exec(hid))) key = 'sh-' + m[1];
      if (!key || !byKey[key]) continue;
      byKey[key].hw.push(i);
      if (/hinge/.test(hid) && h.box) byKey[key].straps.push(h.box);
    }
    var FK = { door: { 'nail-door': 1, 'screw-hinge': 1 }, shutter: { 'nail-shutter': 1, 'screw-shinge': 1 } };
    for (i = 0; i < g.fas.length; i++) {
      var f = g.fas[i];
      for (k = 0; k < list.length; k++) {
        var Lf = list[k], b2 = Lf.b, e = 0.007;
        if (!FK[Lf.kind][f.kind]) continue;
        if (f.x >= b2[0] - e && f.x <= b2[1] + e && f.y >= b2[2] - e && f.y <= b2[3] + e && f.z >= b2[4] - e && f.z <= b2[5] + e) { Lf.fas.push(i); break; }
      }
    }
    var out = { list: [], piece: {}, hw: {}, fas: {} }, nSh = 0, nDr = 0;
    for (k = 0; k < list.length; k++) {
      var Q = list[k], b = Q.b, cx = (b[0] + b[1]) / 2, cz = (b[4] + b[5]) / 2;
      var nAx = ((b[1] - b[0]) < (b[5] - b[4])) ? 'x' : 'z';               /* the leaf's thickness: the wall's normal */
      var nS = ((nAx === 'x') ? cx : cz) >= 0 ? 1 : -1;                     /* outward: the side of the house it is on */
      var su = 0;                                                           /* the hinge edge: where the straps are */
      Q.straps.forEach(function (sb) { su += (nAx === 'x') ? (sb[2] - cz) : (sb[0] - cx); });
      var hS = (su < 0) ? -1 : 1;
      var px, pz;
      if (nAx === 'z') { px = (hS < 0) ? b[0] : b[1]; pz = (nS > 0) ? b[5] : b[4]; }
      else { pz = (hS < 0) ? b[4] : b[5]; px = (nS > 0) ? b[1] : b[0]; }
      /* the turn that sends the leaf's middle outward: d/dang of R(ang)(v) at 0 is (vz, -vx) */
      var vx = cx - px, vz = cz - pz, ox = (nAx === 'x') ? nS : 0, oz = (nAx === 'z') ? nS : 0;
      var sg = ((vz * ox - vx * oz) >= 0) ? 1 : -1;
      var deg = (Q.kind === 'door') ? PH_DOOR_DEG[(nDr++) % PH_DOOR_DEG.length] : PH_SHUT_DEG[(nSh++) % PH_SHUT_DEG.length], ang = sg * deg * Math.PI / 180;
      var X = (Q.kind === 'door')
        ? { leaf: 'swing', dir: sg, ajar: Math.abs(ang), max: 1.45, ext: 1, ox: ox, oz: oz }   /* shut in the walk, opens outward as you come */
        : { leaf: 'swing', dir: -sg, ajar: 0, max: Math.abs(ang), ext: 1 };                  /* a shutter folds back flat on the wall as you come (no path to it) */
      var idx = out.list.length;
      out.list.push({ key: Q.key, kind: Q.kind, px: px, pz: pz, ang: ang, c: Math.cos(ang), s: Math.sin(ang), walk: X, n: Q.pieces.length + Q.hw.length + Q.fas.length });
      Q.pieces.forEach(function (pi) { out.piece[pi] = idx; });
      Q.hw.forEach(function (hi) { out.hw[hi] = idx; });
      Q.fas.forEach(function (fi) { out.fas[fi] = idx; });
    }
    return out;
  }
  /* a point / a direction turned about the leaf's hinge line */
  function _phLeafPt(Lf, x, z) { var dx = x - Lf.px, dz = z - Lf.pz; return [Lf.px + dx * Lf.c + dz * Lf.s, Lf.pz - dx * Lf.s + dz * Lf.c]; }
  function _phLeafMesh(Lf, m) {
    var T = global.THREE, q = _phLeafPt(Lf, m.position.x, m.position.z);
    m.position.x = q[0]; m.position.z = q[1];
    m.quaternion.premultiply(new T.Quaternion().setFromAxisAngle(new T.Vector3(0, 1, 0), Lf.ang));
    m.userData.phLeaf = Lf.key;
    return m;
  }
  function _phAnyLayout(s) { return _phFoundPass(s, _phAnyLayout0(s)); }   /* v402 every playhouse through the foundation switch */
  function _phAnyLayout0(s) { return _phIsCs(s) ? _csLayout(s) : _phIsCt(s) ? _ctLayout(s) : _phIsCo(s) ? _coLayout(s) : _phIsAf(s) ? _afLayout(s) : _phIsPf(s) ? _pfLayout(s) : _phIsMd(s) ? _mdLayout(s) : _phIsBr(s) ? _brLayout(s) : _phIsTf(s) ? _tfLayout(s) : _phLayout(s); }   /* v368 + the tree fort */   /* v367 + the little barn */   /* v366 + the modern house */   /* v365 + the play fort */
  function _afLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), porch = _phPorch(s), L = _phL(s), W = _phW(s), i, j, k, sx, sz, q;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, sg = P.sg, tt = P.tt, cw = P.cw, tw = P.tw;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], blocks = [], hw = [], coat = 0, hinges = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    /* THE HEIGHTS: the blocks' top, the joists' top, the floor, the sills' top (the rafters' feet), the plates' top */
    var yB = _phU(s, 'BLK_UP'), yJ1 = yB + jh, yF = yJ1 + P.fl, ySl = yJ1 + jt, yP0 = yF + st;
    var PD = porch ? _phU(s, 'PORCH') : 0, zF = L / 2 + PD, zEnd = porch ? zF : L / 2;
    /* the A: the rafters' top edge yT(x) through the sill's outer top corner, their underside yR(x) a plumb depth lower */
    var th = AF.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = sd / cs;
    function yT(x) { return ySl + (W / 2 - Math.abs(x)) * tn; }
    function yR(x) { return yT(x) - dV; }
    function xTop(y) { return W / 2 - (y - ySl) / tn; }   /* where the top edge is at height y */
    var xr = P.rgt / 2, xf = W / 2 - dV / tn, rgTop = yT(xr), rgBot = rgTop - P.rgd;

    /* THE FOUNDATION: deck blocks under each rim from the back to the front (the porch's front too) */
    var bl = _phU(s, 'BLK'), blT = _phU(s, 'BLK_TOP'), blH = _phU(s, 'BLK_H'), gv = _phU(s, 'GRAVEL');
    for (sx = -1; sx <= 1; sx += 2) {
      var zb0 = -L / 2 + bl / 2, zb1 = zEnd - bl / 2, nb = Math.max(1, Math.ceil((zb1 - zb0) / _phU(s, 'BLK_SP') - 1e-9));
      for (i = 0; i <= nb; i++) blocks.push({ x: sx * (W / 2 - jt / 2), z: zb0 + (zb1 - zb0) * i / nb, w: bl, wt: blT, y0: yB - blH, y1: yB, a: 0, id: (sx < 0 ? 'l' : 'r') + (i + 1), post: false });
    }
    /* THE FLOOR FRAME: the rims, the joists across (the house's, the porch's -- its last the front rim) */
    for (sx = -1; sx <= 1; sx += 2) box('rim', PH.RIM, ceil2(zEnd + L / 2), 'rim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, (zEnd - L / 2) / 2, jt, jh, zEnd + L / 2);
    var joists = [], jz0 = -L / 2 + jt / 2, jz1 = L / 2 - jt / 2, nj = Math.max(1, Math.ceil((jz1 - jz0) / _phU(s, 'JOIST_SP') - 1e-9));
    for (i = 0; i <= nj; i++) joists.push({ z: jz0 + (jz1 - jz0) * i / nj, w: W - 2 * jt, porch: false });
    if (porch) {
      var pz0 = L / 2 + jt / 2, pz1 = zF - jt / 2, np = Math.max(1, Math.ceil((pz1 - pz0) / _phU(s, 'JOIST_SP') - 1e-9));
      for (i = 0; i <= np; i++) joists.push({ z: pz0 + (pz1 - pz0) * i / np, w: W - 2 * jt, porch: true, front: i === np });
    }
    for (i = 0; i < joists.length; i++) {
      q = joists[i];
      box('joist', PH.JOIST, ceil2(q.w), 'joist-' + (i + 1), 0, yB + jh / 2, q.z, q.w, jh, jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), q.z, [-sx, 0, 0], len160);
    }
    /* the floor's OSB between the sills (billed by area) */
    var fw = W - 2 * jh;
    pieces.push({ kind: 'floor', code: PH.FLOOR, len: 0, id: 'floor', box: [0, yJ1 + P.fl / 2, 0, fw, P.fl, L] });
    var floorA = fw * L;
    /* THE PORCH'S DECKING between the sills, from the front gable's siding to the porch's edge */
    var deckBoards = 0;
    if (porch) {
      var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((fw + dg) / (P.dw + dg) - 1e-9)), dz0 = L / 2 + sg;
      for (i = 0; i < nd; i++) {
        var dx0 = -fw / 2 + i * (P.dw + dg), dx1 = Math.min(fw / 2, dx0 + P.dw);
        if (dx1 - dx0 < 0.02) continue;
        box('deck', PH.DECK, ceil2(zF - dz0), 'deck-' + (i + 1), (dx0 + dx1) / 2, yJ1 + P.dk / 2, (dz0 + zF) / 2, dx1 - dx0, P.dk, zF - dz0);
        coat += (2 * (dx1 - dx0) + 2 * P.dk) * (zF - dz0);
        deckBoards++;
        for (j = 0; j < joists.length; j++) {
          if (!joists[j].porch || joists[j].z < dz0) continue;
          for (k = -1; k <= 1; k += 2) scr('screw-deck', PH.DECK_SCREW, (dx0 + dx1) / 2 + k * (dx1 - dx0) / 4, yJ1 + P.dk, joists[j].z, [0, -1, 0], len50);
        }
      }
    }
    /* THE SILLS: a 2x6 flat on each rim, flush outside; two 6x120 down into the rim between every two joists */
    for (sx = -1; sx <= 1; sx += 2) {
      box('sill', AF.SILL, ceil2(zEnd + L / 2), 'sill-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jh / 2), yJ1 + jt / 2, (zEnd - L / 2) / 2, jh, jt, zEnd + L / 2);
      coat += 2 * (jt + jh) * (zEnd + L / 2);
      for (i = 0; i + 1 < joists.length; i++) {
        var zm = (joists[i].z + joists[i + 1].z) / 2;
        if (joists[i + 1].z - joists[i].z < 0.12) continue;
        scr('screw-sill', AF.SILL_SCREW, sx * (W / 2 - jt / 2), ySl, zm, [0, -1, 0], len120);
      }
    }

    /* THE A-FRAME: the rafter pairs at <= 60 cm from the back gable to the
       front one (and on over the porch to its front), a fly rafter past
       each end, the ridge board */
    var zA = -L / 2 + st / 2, zB = L / 2 - st / 2, nr = Math.max(1, Math.ceil((zB - zA) / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
    for (i = 0; i <= nr; i++) zr.push({ z: zA + (zB - zA) * i / nr, gable: (i === 0 || i === nr) });
    if (porch) {
      var zC = zF - st / 2, nrp = Math.max(1, Math.ceil((zC - zB) / _phU(s, 'RAF_SP') - 1e-9));
      for (i = 1; i <= nrp; i++) zr.push({ z: zB + (zC - zB) * i / nrp, gable: false });
    }
    var rk = _phU(s, 'RAKE'), zFb = -(L / 2 + sg + rk) + st / 2, zFf = (porch ? zF : L / 2 + sg) + rk - st / 2;
    var rafL = ceil2((W / 2 - xr) / cs);
    function rafPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [W / 2, ySl], [xf, ySl]].map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.02, yTm = rgTop - P.rgd / 2;
    function ridgeToes(kind, zq) {
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr(kind, PH.RIDGE_TOE, s3 * xtq, yTm + k3 * s3 * 0.02, zq + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
    }
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', PH.RAFTER, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', zr[i].z, st);
        /* the foot: a toe screw from each face down into the sill (apart, so they do not meet) */
        for (k = -1; k <= 1; k += 2) scr('screw-seat', AF.TOE, sx * (W / 2 - ((k > 0) ? 0.045 : 0.08)), ySl + 0.035, zr[i].z + k * st / 2, [0, -0.87, -k * 0.5], len80);
      }
      ridgeToes('screw-rtoe', zr[i].z);
    }
    var flies = [zFb, zFf];
    for (i = 0; i < 2; i++) {
      for (sx = -1; sx <= 1; sx += 2) poly('fly', PH.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rafPts(sx), 'xy', flies[i], st);
      ridgeToes('screw-fly', flies[i]);
    }
    coat += 2 * (zr.length + 2) * 2 * (st + sd) * rafL;
    var zR0 = zFb - st / 2, zR1 = zFf + st / 2, roofLen = zR1 - zR0;
    box('ridge', PH.RIDGE, ceil2(roofLen), 'ridge', 0, rgTop - P.rgd / 2, (zR0 + zR1) / 2, P.rgt, P.rgd, roofLen);
    coat += 2 * (P.rgt + P.rgd) * roofLen;
    /* THE COLLAR TIES: a 2x4 on edge beside every pair but the gables',
       toward the middle, its ends cut to the rafters' top edge; two 6x80
       through it into each rafter */
    var yC = Math.max(yF + _afU(s, 'COLLAR_Y'), yF + 0.62 * (rgBot - yF));
    if (yC + sd > rgBot - 0.03) yC = rgBot - 0.03 - sd;
    var nTies = 0;
    for (i = 0; i < zr.length; i++) {
      if (zr[i].gable) continue;
      var tz = zr[i].z - ((zr[i].z > 0) ? 1 : -1) * st, tToR = (zr[i].z > tz) ? 1 : -1;
      var tpts = [[-xTop(yC), yC], [xTop(yC), yC], [xTop(yC + sd), yC + sd], [-xTop(yC + sd), yC + sd]];
      poly('tie', PH.STUD, ceil2(2 * xTop(yC)), 'tie-' + (i + 1), tpts, 'xy', tz, st);
      coat += 2 * (st + sd) * 2 * xTop(yC);
      nTies++;
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) {
        var yq = yC + sd * (0.3 + 0.4 * k);
        scr('screw-tie', PH.TIE_SCREW, sx * (xTop(yq) - 0.05), yq, tz - tToR * st / 2, [0, 0, tToR], len80);
      }
    }

    /* THE GABLES: a bottom plate between the sills (cut out under the
       door), studs at <= 40 cm from the middle up to the end rafter's
       underside (a toe screw up into it, two screws up through the plate);
       the door's kings + jacks + a 2x6 header + cripples over it, the
       window's kings + header + sill + cripples */
    var gl = W / 2 - jh, gsp = _afU(s, 'GSTUD_SP'), RO = _phU(s, 'DOOR_W') + 2 * _phU(s, 'DOOR_CLR'), win = _phU(s, 'WIN'), hW = win / 2, gStuds = 0;
    var dHalf = RO / 2, yHd = Math.min(yF + _afU(s, 'DOOR_MAX'), yR(dHalf + st) - jh - 0.01);
    var wHalf = win / 2, yWS = Math.max(yF + AF.WIN_SILL_MIN, Math.min(yF + _afU(s, 'WIN_SILL'), yR(wHalf + st) - 0.03 - sd - win)), yWT = yWS + win;
    function gableWall(sz2) {
      var gid = (sz2 < 0) ? 'back' : 'front', door = (sz2 > 0), c = sz2 * (L / 2 - sd / 2), half = door ? dHalf : wHalf, m;
      function at(u, y, n) { return [u, y, c + sz2 * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n); scr(kind, code, Pt[0], Pt[1], Pt[2], [du, dy, sz2 * dn], ln); }
      function gst(sid, u, y0) {   /* a stud from y0 up to the end rafter's underside (its top cut to the slope) */
        var a = u - st / 2, b = u + st / 2, pts = [[a, y0], [b, y0], [b, yR(b)], [a, yR(a)]];
        poly('gstud', PH.STUD, ceil2(Math.max(yR(a), yR(b)) - y0), gid + '-' + sid, pts, 'xy', c, sd);
        coat += 2 * (st + sd) * (Math.max(yR(a), yR(b)) - y0);
        gStuds++;
        scr('screw-gstud', PH.FRAME_SCREW, u, yR(u) - 0.035, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);   /* toe from the outside up into the end rafter */
      }
      var oL = door ? half + 2 * st : half + st;   /* the kings' outer faces */
      /* the grid: from the middle outward, as long as a stud still stands 10 cm on the plate */
      var grid = [0];
      for (k = 1; k * gsp + st / 2 <= gl - 0.005 && yR(k * gsp + st / 2) - yP0 >= 0.10; k++) grid.push(k * gsp, -k * gsp);
      var keep = grid.filter(function (u) { return Math.abs(u) > oL + st / 2 - 1e-6; });
      var full = keep.concat([-(oL - st / 2), oL - st / 2]).sort(function (a, b) { return a - b; });
      /* the bottom plate(s) + screws down into the end joist between the studs */
      var plates = door ? [[-gl, -half], [half, gl]] : [[-gl, gl]];
      plates.forEach(function (pl, pi) {
        bx('plate', PH.STUD, ceil2(pl[1] - pl[0]), gid + '-plate-' + (pi + 1), (pl[0] + pl[1]) / 2, yF + st / 2, 0, pl[1] - pl[0], st, sd);
        coat += 2 * (st + sd) * (pl[1] - pl[0]);
      });
      var pts2 = full.concat(door ? [-gl, gl] : [-gl, 0, gl]).sort(function (a, b) { return a - b; });   /* (the window's cripple under its sill stands on the plate too) */
      for (m = 0; m + 1 < pts2.length; m++) {
        var um = (pts2[m] + pts2[m + 1]) / 2, onPl = plates.some(function (pl) { return um > pl[0] + 0.03 && um < pl[1] - 0.03; });
        if (onPl && pts2[m + 1] - pts2[m] > 0.15) sc('screw-plate', PH.PLATE_SCREW, um, yP0, sd / 2 - jt / 2, 0, -1, 0, len160);
      }
      /* the full-height studs + kings */
      for (m = 0; m < full.length; m++) {
        gst('stud-' + (m + 1), full[m], yP0);
        for (var e = -1; e <= 1; e += 2) sc('screw-stud', PH.STUD_SCREW, full[m], yF, e * sd / 4, 0, 1, 0, len120);
      }
      if (door) {
        for (e = -1; e <= 1; e += 2) {
          var uj = e * (half + st / 2);
          bx('stud', PH.STUD, ceil2(yHd - yP0), gid + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          coat += 2 * (st + sd) * (yHd - yP0);
          for (var e2 = -1; e2 <= 1; e2 += 2) sc('screw-stud', PH.STUD_SCREW, uj, yF, e2 * sd / 4, 0, 1, 0, len120);
          for (var f2 = 0; f2 < 3; f2++) sc('screw-frame', PH.FRAME_SCREW, e * (half + 2 * st), yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, len100);
          for (f2 = 0; f2 < 2; f2++) sc('screw-frame', PH.STUD_SCREW, e * oL, yHd + jh * (0.3 + 0.4 * f2), sd / 2 - jt / 2, -e, 0, 0, len120);
        }
        bx('header', PH.HEADER, ceil2(2 * (half + st)), gid + '-header', 0, yHd + jh / 2, sd / 2 - jt / 2, 2 * (half + st), jh, jt);
        coat += 2 * (jt + jh) * 2 * (half + st);
        /* a cripple in the middle over the header, up to the rafter, where there is room */
        if (rgBot - (yHd + jh) > 0.06) {   /* (in the middle it stands under the ridge board, not a rafter: up to its underside) */
          var cpts = [[-st / 2, yHd + jh], [st / 2, yHd + jh], [st / 2, rgBot], [-st / 2, rgBot]];
          poly('cstud', PH.STUD, ceil2(rgBot - yHd - jh), gid + '-cripple-hi', cpts, 'xy', c, sd);   /* v369 its own step, after the header it stands on */
          coat += 2 * (st + sd) * (rgBot - yHd - jh);
          gStuds++;
          for (e = -1; e <= 1; e += 2) sc('screw-cstud', PH.FRAME_SCREW, e * st / 2, yHd + jh + 0.04, sd / 2 - jt / 2 + e * 0.01, -e * 0.5, -0.87, 0, len100);   /* toe down into the header (at the wall's outer face), the two apart */
          scr('screw-cstud', PH.FRAME_SCREW, 0, rgBot - 0.06, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);   /* toe up into the ridge board (under the rafters' toe screws) */
        }
      } else {
        /* the window: a 2x4 header on edge at the outer face, a flat 2x4 sill, a cripple under it (and over the header where there is room) */
        var hdT = yWT + sd;
        bx('stud', PH.STUD, ceil2(2 * half), gid + '-whead', 0, yWT + sd / 2, sd / 2 - st / 2, 2 * half, sd, st);
        bx('stud', PH.STUD, ceil2(2 * half), gid + '-wsill', 0, yWS - st / 2, 0, 2 * half, st, sd);
        coat += 2 * 2 * (st + sd) * 2 * half;
        for (e = -1; e <= 1; e += 2) for (f2 = 0; f2 < 2; f2++) {
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWT + sd * (0.3 + 0.4 * f2), sd / 2 - st / 2, -e, 0, 0, len120);
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWS - st / 2, (f2 ? 1 : -1) * sd / 4, -e, 0, 0, len120);
        }
        bx('stud', PH.STUD, ceil2(yWS - st - yP0), gid + '-cripple-lo', 0, (yP0 + yWS - st) / 2, 0, st, yWS - st - yP0, sd);
        coat += 2 * (st + sd) * (yWS - st - yP0);
        for (e = -1; e <= 1; e += 2) {
          sc('screw-stud', PH.STUD_SCREW, 0, yF, e * sd / 4, 0, 1, 0, len120);
          sc('screw-frame', PH.STUD_SCREW, 0, yWS, e * sd / 4, 0, -1, 0, len120);
        }
        if (rgBot - hdT > 0.06) {
          var wpts = [[-st / 2, hdT], [st / 2, hdT], [st / 2, rgBot], [-st / 2, rgBot]];
          poly('cstud', PH.STUD, ceil2(rgBot - hdT), gid + '-cripple-hi', wpts, 'xy', c, sd);   /* v369 its own step, after the window's header */
          coat += 2 * (st + sd) * (rgBot - hdT);
          gStuds++;
          for (e = -1; e <= 1; e += 2) sc('screw-cstud', PH.FRAME_SCREW, e * st / 2, hdT + 0.04, sd / 2 - st / 2 + e * 0.01, -e * 0.5, -0.87, 0, len100);   /* toe down into the window's header (at the outer face), the two apart */
          scr('screw-cstud', PH.FRAME_SCREW, 0, rgBot - 0.06, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);   /* toe up into the ridge board (under the rafters' toe screws) */
        }
      }
    }
    gableWall(-1);
    gableWall(1);

    /* THE ROOF'S LAYERS: the OSB from the ridge line down to just past the
       skirt (cut plumb), the shingles over the underlay (drawn as one
       surface), the drip edge along the foot and the rakes; a rake board
       on each fly rafter */
    var rs = P.rs, rsV = rs / cs, xe = W / 2 + sg + 0.002, slope = xe / cs, ze0 = zR0 - tt, ze1 = zR1 + tt, eLen = ze1 - ze0;
    for (sx = -1; sx <= 1; sx += 2) {
      var sp = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) + rsV], [0, yT(0) + rsV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) sp.reverse();
      poly('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), sp, 'xy', (ze0 + ze1) / 2, eLen);
      var xs1 = xe + 0.01, ysh = rsV + 0.003;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r'),
        quad: [[0, yT(0) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze1 + 0.01], [0, yT(0) + ysh, ze1 + 0.01]],
        uv: [[(ze0 - 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)]] });
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      for (i = 0; i < 2; i++) {
        var zc2 = (i === 0) ? zR0 - tt / 2 : zR1 + tt / 2, cwV = cw / cs;
        var rpb = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) - cwV], [0, yT(0) - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) rpb.reverse();
        poly('fascia', PH.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rpb, 'xy', zc2, tt);
        coat += 2 * (tt + cw) * slope;
        var fx = fixPts(0.08, W / 2 - 0.10, _phU(s, 'FIX_SP'));
        for (k = 0; k < fx.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * fx[k], yT(fx[k]) - cwV / 2, (i === 0) ? zR0 - tt : zR1 + tt, [0, 0, (i === 0) ? 1 : -1], len50);
        var dpb = [[0, yT(0) + rsV], [xe, yT(xe) + rsV], [xe, yT(xe) + rsV - 0.055], [0, yT(0) + rsV - 0.055]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) dpb.reverse();
        poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), dpb, 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
      }
    }
    var capH = PH.CAP_W / 2;
    for (sx = -1; sx <= 1; sx += 2) {
      var cx1 = capH * cs, ycap = rsV + 0.008;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
        quad: [[0, yT(0) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT(0) + ycap, ze1]],
        uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
    }
    var roofA = 2 * slope * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
    var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);

    /* THE SIDING: the gables from the rims' underside up to the rafters'
       top (a notch for the ridge board; the window / the door cut out),
       a skirt over each side's rim + sill under the roof's foot */
    var y0 = yB, xa = W / 2 + sg, ySk = yT(xa) - 0.003, sidingA = 0, y0f = porch ? yJ1 + P.dk : y0;
    for (sx = -1; sx <= 1; sx += 2) {
      var so = [[-L / 2, y0], [zEnd, y0], [zEnd, ySk], [-L / 2, ySk]];
      poly('siding', PH.SIDING, 0, 'skirt-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg);
      sidingA += _phArea(so);
    }
    for (sz = -1; sz <= 1; sz += 2) {
      var front = (sz > 0), xa2 = (front && porch) ? W / 2 : xa, yb2 = front ? y0f : y0, xr2 = P.rgt / 2 + 0.002, go, gh = null;
      var gTop = [[xa2, yT(xa2)], [xr2, yT(xr2)], [xr2, rgBot], [-xr2, rgBot], [-xr2, yT(xr2)], [-xa2, yT(xa2)]];
      if (!front) { go = [[-xa2, yb2], [xa2, yb2]].concat(gTop); gh = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]]; }
      else if (porch) go = [[-gl, yb2], [-RO / 2, yb2], [-RO / 2, yHd], [RO / 2, yHd], [RO / 2, yb2], [gl, yb2], [gl, ySl]].concat(gTop, [[-gl, ySl]]);   /* on the decking between the sills (stepped over them), the door a notch */
      else { go = [[-xa2, yb2], [xa2, yb2]].concat(gTop); gh = [[-RO / 2, yF], [RO / 2, yF], [RO / 2, yHd], [-RO / 2, yHd]]; }
      poly('siding', PH.SIDING, 0, 'siding-' + (front ? 'f' : 'b'), go, 'xy', sz * (L / 2 + sg / 2), sg, gh ? [gh] : null);
      sidingA += _phArea(go) - (gh ? _phArea(gh) : 0);
    }
    coat += sidingA;
    /* the corner boards at the house's corners (not at the front with the porch -- the skirt runs on), as high as the skirt */
    var nTrim = 0, cH = ySk - y0;
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      if (sz > 0 && porch) continue;
      box('trim', PH.TRIM, ceil2(cH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), y0 + cH / 2, sz * (L / 2 + sg + tt / 2), tw, cH, tt);
      box('trim', PH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), y0 + cH / 2, sz * (L / 2 + sg - tw / 2), tt, cH, tw);
      nTrim += 2;
      coat += 4 * (tt + tw) * cH;
      var ty = fixPts(y0 + 0.07, ySk - 0.025, _phU(s, 'FIX_SP'));   /* (between the joist screws through the rim) */
      for (k = 0; k < ty.length; k++) {
        scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt - tw / 2), ty[k], sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
        scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt), ty[k], sz * (L / 2 + sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
      }
    }
    /* THE CASINGS round the door and the window */
    function casing(id, cN, o, u0, u1, v0, v1, sillToo) {
      var n0 = cN + o * tt / 2, list = [['jamb-a', u0 - cw / 2, v0, v1, cw], ['jamb-b', u1 + cw / 2, v0, v1, cw], ['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]];
      if (sillToo) list.push(['sill', (u0 + u1) / 2, v0 - cw, v0, u1 - u0 + 2 * cw]);
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head' || c4[0] === 'sill'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts3 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));
        pts3.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) scr('nail-trim', PH.TRIM_NAIL, horiz ? w2 : c4[1] + e4 * cw / 4, horiz ? yc + e4 * dy / 4 : w2, cN + o * tt, [0, 0, -o], len32, 0.0012);
        });
      });
    }
    casing('casing-b', -(L / 2 + sg), -1, -hW, hW, yWS, yWT, true);
    casing('casing-d', L / 2 + sg, 1, -RO / 2, RO / 2, porch ? y0f : yF, yHd, false);

    /* THE DOOR: the cottage's -- T&G boards on three ledges + two braces,
       two strap hinges onto the casing, a knob, a ball catch */
    var gw = P.gw, gc = P.gc, gb = P.gb, dW = _phU(s, 'DOOR_W'), nDb = Math.max(2, Math.round(dW / gc)), lw = nDb * gc + (gw - gc);
    var dy0 = yF + _phU(s, 'DOOR_CLR'), dy1 = yHd - _phU(s, 'DOOR_CLR'), dH = dy1 - dy0, zD1 = L / 2 + sg, zD0 = zD1 - gb, zL0 = zD0 - tt;
    for (i = 0; i < nDb; i++) box('door', PH.TG, ceil2(dH), 'door-board-' + (i + 1), -lw / 2 + gw / 2 + i * gc - (gw - gc) / 2, (dy0 + dy1) / 2, (zD0 + zD1) / 2, gc, dH, gb);
    coat += 2 * (gb + gw) * dH * nDb;
    var ledY = [dy0 + 0.12, (dy0 + dy1) / 2, dy1 - 0.12], ledW = lw - 0.04;
    for (k = 0; k < 3; k++) {
      box('ledge', PH.BOARD, ceil2(ledW), 'door-ledge-' + (k + 1), 0, ledY[k], (zD0 + zL0) / 2, ledW, cw, tt);
      coat += 2 * (tt + cw) * ledW;
      for (i = 0; i < nDb; i++) for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-door', PH.TRIM_NAIL, -lw / 2 + gw / 2 + i * gc, ledY[k] + e5 * cw / 4, zL0, [0, 0, 1], len32, 0.0012);
    }
    function braceBetween(idB, xA, yA, xB, yB2) {
      var dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
      var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
      pb = _gzClip(pb, 1, 0, ledW / 2); pb = _gzClip(pb, -1, 0, ledW / 2);   /* and to the ledges' width (a low door's braces lie flatter) */
      if (_gzArea(pb) < 0) pb.reverse();
      poly('ledge', PH.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zD0 + zL0) / 2, tt);
      coat += 2 * (tt + cw) * dl;
      for (var m2 = 0; m2 < nDb; m2++) {
        var xq = -lw / 2 + gw / 2 + m2 * gc, tq = (xq - xA) / dx;
        if (tq > 0.05 && tq < 0.95) scr('nail-door', PH.TRIM_NAIL, xq, yA + dy * tq, zL0, [0, 0, 1], len32, 0.0012);
      }
    }
    braceBetween('door-brace-1', -ledW / 2 + 0.06, ledY[0] + cw / 2, ledW / 2 - 0.06, ledY[1] - cw / 2);
    braceBetween('door-brace-2', -ledW / 2 + 0.06, ledY[1] + cw / 2, ledW / 2 - 0.06, ledY[2] - cw / 2);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k += 2) {
      var hy = ledY[k];
      hw.push({ kind: 'hinge', code: PH.HINGE, box: [-lw / 2 + hingeLen / 2, hy, zD1 + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-RO / 2 - cw / 2, hy, zD1 + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', PH.HINGE_SCREW, -lw / 2 + 0.04 + i * 0.10, hy, zD1 + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', PH.HINGE_SCREW, -RO / 2 - cw / 2, hy + (i - 1) * hingeW * 0.5, zD1 + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: PH.KNOB, cyl: [lw / 2 - 0.07, Math.min(yF + _phU(s, 'KNOB_Y'), dy1 - 0.15), zD1, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: PH.CATCH, box: [lw / 2 - 0.03, dy1 - 0.03, zD0 - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* the bill's quantities: timber by code (+ the boards, trims, decking by length) */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var bury = blH - yB;
    return {
      P: P, us: us, porch: porch, L: L, W: W, PD: PD, zF: zF, pieces: pieces, fas: fas, blocks: blocks, hw: hw, posts: [], joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: floorA, roofA: roofA, sidingA: sidingA, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: r3(blocks.length * bl * bl * gv), digM3: r3(blocks.length * bl * bl * (bury + gv)), hinges: hinges, shutters: 0, deckBoards: deckBoards,
      ties: nTies, gStuds: gStuds, trims: nTrim, doorBoards: nDb, doorW: lw, doorH: dH, RO: RO, win: win,
      yB: yB, yF: yF, yPT: ySl, yBm: ySl, yHd: yHd, yWS: yWS, ridgeTop: rgTop, pitch: AF.PITCH, rafL: rafL, roofLen: eLen, slope: slope, yC: yC,
      top: yT(0) + rsV + 0.01, height: yT(0) + rsV + 0.01, depth: W, length: L + PD,
      aframe: true, stilt: false, slide: false, gscrews: [], uheads: [], missing: [], yD: yJ1 + P.dk, extX: xe, extZ: zF, sPosts: 0, xBraces: 0, balusters: 0, treads: 0, rails: 0
    };
  }
  /* ------------------------------------------------------------------
     v365 TYPE 29 -- PLAYHOUSES, variant 4: THE PLAY FORT (Marek 2026-10-29
     17:37 "Dalsi krok" -- slot 4 of the plan). An open lookout tower in
     the US backyard-fort manner, every piece a catalogue item:
       - FOUNDATION: a ground screw FGR00001 + U head FGR00002 under each of
         the four 4x4 KVH10100 corner posts (12 nails FAS38038 each, the
         stilt house's pier); each post one piece up to the roof beams;
       - DECK 1.22 m (US 4 ft) up: 2x6 KVH60160 rims round the posts' outer
         faces (the front / back ones the full width, the sides between
         them), two M16 rods FAT16010 from the post's inner face through
         post + rim at every rim and corner (counterbored in the rim, the
         front / back pair and the side pair at other heights), two 6x160
         through the front / back rim into each side rim's end; 2x6 joists
         across at <= 40 cm (US 16 in.), the first / last against the posts'
         inner faces, two 6x160 through the side rim into each end; decking
         TST00001 along the length, cut between the posts where it meets
         them, two stainless screws at every joist / rim;
       - FORT WALLS 90 cm (US 3 ft) high: 2x4 rails on edge on the posts'
         outer faces (a middle and a top one, flush with the rims' faces),
         1x6 KVR14024 boards upright outside them from the rims' underside
         to the top, a pointed head each, <= 2 cm (US 3/4 in.) apart, two
         stainless screws into the rim and into each rail; the front open
         between two 4x4 ladder posts bolted to the front rim (the stilt
         house's), the right side open for the slide under the top rail;
       - ROOF: a 4x6 KVH10160 beam on each side's two posts (two 8x260
         FAS80260 down into each post), the cottage's 40 deg gable over the
         deck -- 2x4 rafters at <= 60 cm (US 24 in.) with birdsmouths, a 2x6
         ridge board, fly rafters, a 2x4 tie on edge beside every pair
         (outside the gable pairs: the gables stay open), OSB, underlay,
         shingles + caps, drip edge, 1x4 fascia and rake boards; a 2x4 knee
         brace from every post under its beam and under its gable tie;
       - LADDER (front) and SLIDE (right side) as the stilt house's -- the
         slide is no catalogue row yet (MISSING, the stilt house's row);
       - SWINGS (the info bar's toggle, on): a 4x8 KVH10200 beam on the
         ties under the ridge (two M16 rods down through it and each gable
         tie), out through the back gable to one A-frame of the kids' swing
         set (2x6 legs at 19 deg clamping it, collar + spreader on M16
         rods, 2x4 knee braces) 2.50 m (US 8 ft) past the back wall; two
         board seats TIM45120 on chains from swing hangers.
     X across (W, the side grips), Y up, Z along (L, the front / back
     grips; +Z the front with the ladder, the swings behind). W / L = the
     deck's outer faces (the rims'). _pfLayout(STATE) is the single source. */
  var PF = {
    W: [1.20, 2.40], W_US: [1.2192, 2.4384], W0: 1.50, W0_US: 1.524,
    L: [1.20, 2.40], L_US: [1.2192, 2.4384], L0: 1.50, L0_US: 1.524,
    HEAD: 1.22, HEAD_US: 1.2192,                     /* the deck's top to the roof beams' underside (4 ft) */
    RAIL_MID: 0.45, RAIL_MID_US: 0.4572,             /* the middle rail's centre over the deck (18 in.) */
    BOARD_GAP: 0.02, BOARD_GAP_US: 0.0191,           /* the fort boards' gaps, at most (3/4 in.) */
    SLIDE_OPEN: 0.69, SLIDE_OPEN_US: 0.6858,         /* the right wall's opening for the slide (27 in.) */
    KB_SIDE: 0.30, KB_SIDE_US: 0.3048, KB_GABLE: 0.42, KB_GABLE_US: 0.4191,   /* the knee braces' run (at most) */
    SPAN: 2.50, SPAN_US: 2.4384,                     /* the back wall's face to the A-frame (8 ft) */
    SEATS: 2,
    BOARD: 'KVR14024', BOARD_SCREW: 'FAS55050', SBEAM: 'KVH10200'
  };
  function _pfU(s, k) { return ((s || STATE).isMetric === false && PF[k + '_US'] != null) ? PF[k + '_US'] : PF[k]; }
  function _phIsPf(s) { return ((s || STATE).variant | 0) === 29; }
  function _pfSwings(s) { return _phIsPf(s) && (s || STATE).phSwings !== false; }
  /* the 1x6 board (metric / US actual) */
  function _pfBoard(s) { return ((s || STATE).isMetric === false) ? { w: 0.1397, t: 0.01905 } : { w: 0.140, t: 0.024 }; }
  /* the shortest distance between two segments (the screws placed in rows keep off the fasteners already there) */
  function _pfSegDist(p1, q1, p2, q2) {
    var d1 = [q1[0] - p1[0], q1[1] - p1[1], q1[2] - p1[2]], d2 = [q2[0] - p2[0], q2[1] - p2[1], q2[2] - p2[2]], r = [p1[0] - p2[0], p1[1] - p2[1], p1[2] - p2[2]];
    function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
    var a = dot(d1, d1), e = dot(d2, d2), f = dot(d2, r), sN, tN;
    if (a < 1e-12 && e < 1e-12) return Math.sqrt(dot(r, r));
    if (a < 1e-12) { sN = 0; tN = Math.max(0, Math.min(1, f / e)); }
    else {
      var c = dot(d1, r);
      if (e < 1e-12) { tN = 0; sN = Math.max(0, Math.min(1, -c / a)); }
      else {
        var b = dot(d1, d2), den = a * e - b * b;
        sN = (den > 1e-12) ? Math.max(0, Math.min(1, (b * f - c * e) / den)) : 0;
        tN = (b * sN + f) / e;
        if (tN < 0) { tN = 0; sN = Math.max(0, Math.min(1, -c / a)); }
        else if (tN > 1) { tN = 1; sN = Math.max(0, Math.min(1, (b - c) / a)); }
      }
    }
    var dx = r[0] + d1[0] * sN - d2[0] * tN, dy = r[1] + d1[1] * sN - d2[1] * tN, dz = r[2] + d1[2] * sN - d2[2] * tN;
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
  }
  /* the swing beam's A-frame behind the tower (z = zf < 0): the kids' swing
     set's frame (_kfFrame) for one end -- the legs in the frame's plane
     clamping the beam, the collar on the tower side, the spreader outside,
     the knee braces from the collar up to the beam toward the tower */
  function _pfSwingFrame(s, zf, yBB, Q) {
    var t = Q.t, w = Q.w, b = Q.b, bh = Q.bh, tb = Q.bt, wb = Q.bw, us = ((s || STATE).isMetric === false), k, sx, j;
    var th = KF.ANG * Math.PI / 180, tn = Math.tan(th), wc = w / Math.cos(th), hb = b / 2, ov = KF.ROD_OVER;
    var yBT = yBB + bh;
    function xIn(y) { return hb + (yBB - y) * tn; }
    function xOut(y) { return xIn(y) + wc; }
    function xMid(y) { return xIn(y) + wc / 2; }
    var pieces = [], fas = [], coat = 0;
    function rod(kind, x, y, z, d, len) { fas.push({ kind: kind, code: PH.ROD, x: x, y: y, z: z, dir: d, len: len, r: 0.008, rod: true }); }
    function scr(kind, x, y, z, d, len) { fas.push({ kind: kind, code: KF.SCREW, x: x, y: y, z: z, dir: d, len: len, r: 0.004 }); }
    var yC1 = yBB - KF.COLLAR_DROP, yC0 = yC1 - w, yS0 = KF.SPREAD_Y, yS1 = yS0 + w;
    var legLen = Math.ceil(yBT / Math.cos(th) * 100) / 100, collarL = 2 * xOut(yC0), spreadL = 2 * xOut(yS0);
    var zA = -zf, sz = -1;
    for (sx = -1; sx <= 1; sx += 2) {
      var pts = [[sx * xOut(0), 0], [sx * xIn(0), 0], [sx * hb, yBB], [sx * hb, yBT], [sx * xOut(yBT), yBT]];
      pieces.push({ kind: 'sleg', code: KF.LEG, len: legLen, id: 'sleg-' + (sx < 0 ? 'l' : 'r'), poly: pts, plane: 'xy', c: zf, t: t });
      coat += 2 * (t + w) * legLen;
      for (k = 0; k < 2; k++) {
        var yc = yC0 + w * (k ? 0.75 : 0.25), ys = yS0 + w * (k ? 0.75 : 0.25);
        rod('bolt-scollar', sx * xMid(yc), yc, sz * (zA - 1.5 * t - ov), [0, 0, sz], 2 * t + 2 * ov);       /* collar + leg, from the tower side */
        rod('bolt-sspread', sx * xMid(ys), ys, sz * (zA + 1.5 * t + ov), [0, 0, -sz], 2 * t + 2 * ov);   /* spreader + leg, from the outside */
      }
    }
    pieces.push({ kind: 'scollar', code: KF.LEG, len: Math.ceil(collarL * 100) / 100, id: 'scollar', plane: 'xy', c: sz * (zA - t), t: t,
                  poly: [[-xOut(yC0), yC0], [xOut(yC0), yC0], [xOut(yC1), yC1], [-xOut(yC1), yC1]] });
    pieces.push({ kind: 'sspread', code: KF.LEG, len: Math.ceil(spreadL * 100) / 100, id: 'sspread', plane: 'xy', c: sz * (zA + t), t: t,
                  poly: [[-xOut(yS0), yS0], [xOut(yS0), yS0], [xOut(yS1), yS1], [-xOut(yS1), yS1]] });
    coat += 2 * (t + w) * (collarL + spreadL);
    for (k = 1; k <= 2; k++) { var ya = yBB + bh * k / 3, xa = xOut(ya) + ov; rod('bolt-sapex', -xa, ya, zf, [1, 0, 0], 2 * xa); }   /* leg - beam - leg */
    var yL = yBB + bh / 2, k2 = wb / 2 * Math.SQRT2, a = yL - (yC0 + yC1) / 2, u0 = sz * (zA - 1.5 * t), dI = -sz;
    var screwLen = us ? 0.1016 : 0.10, toe = screwLen - (t - 0.006);
    function Wf(u, v) { return [u0 + dI * u, yL + v]; }
    for (sx = -1; sx <= 1; sx += 2) {
      var c = sx * (hb + tb / 2), bl = Math.ceil((a + k2) * Math.SQRT2 * 100) / 100;
      pieces.push({ kind: 'sbrace', code: KF.BRACE, len: bl, id: 'sbrace-' + (sx < 0 ? 'l' : 'r'), poly: [Wf(0, -(a + k2)), Wf(0, -(a - k2)), Wf(a - k2, 0), Wf(a + k2, 0)], plane: 'zy', c: c, t: tb });
      coat += 2 * (tb + wb) * bl;
      for (j = -1; j <= 1; j += 2) {
        var pt = Wf(a - 0.05 + j * k2 / 2 + sx * 0.015, -0.05);                                          /* into the beam's side (the two braces' screws apart: in US sizes they reach past the middle) */
        scr('screw-sbrace', sx * (hb + tb), pt[1], pt[0], [-sx, 0, 0], screwLen);
        var pq = Wf(toe, toe - (a + k2));                                                                /* a toe screw into the collar */
        scr('screw-sbrace', c + j * tb / 4, pq[1], pq[0], [0, 0, -dI], screwLen);
      }
    }
    return { pieces: pieces, fas: fas, coat: coat, legLen: legLen, depth: 2 * xOut(0), yBB: yBB, yBT: yBT, ang: KF.ANG };
  }
  function _pfLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), L = _phL(s), W = _phW(s), B = _pfBoard(s), swings = _pfSwings(s), i, j, k, e, sx, sz;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, p = P.p, tt = P.tt, cw = P.cw, tb = B.t, bwd = B.w;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], gscrews = [], uheads = [], missing = [], coat = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function ccw(pts) { var a = 0, n = pts.length, q; for (q = 0; q < n; q++) { var A = pts[q], C = pts[(q + 1) % n]; a += A[0] * C[1] - C[0] * A[1]; } return (a < 0) ? pts.slice().reverse() : pts; }
    function rod(kind, x, y, z, d, ln) { fas.push({ kind: kind, code: PH.ROD, x: x, y: y, z: z, dir: d, len: ln, r: 0.008, rod: true }); }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: ccw(pts), plane: plane, c: c, t: t, holes: null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    /* a screw of a row (a board's, a deck board's): the first of its spots whose shank keeps 3 mm off every fastener placed so far */
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, m, q;
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q = 0; q < fas.length && ok; q++) {
          var f = fas[q], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* THE HEIGHTS: the ground screw's head and the posts' feet, the deck's
       top (its frame under the decking), the roof beams' underside / top,
       the fort walls' top and middle rail */
    var yH = _phU(s, 'FOOT_UP'), yPB = yH + PH.U_UP;
    var yD = _phU(s, 'DECK_H'), yJ1 = yD - P.dk, yB = yJ1 - jh;
    var yBm = yD + _pfU(s, 'HEAD'), yPT = yBm + bh;
    var yG1 = yD + _phU(s, 'GUARD'), yRc = [yD + _pfU(s, 'RAIL_MID'), yG1 - sd / 2];
    var xP = W / 2 - jt - p / 2, zP = L / 2 - jt - p / 2, xPI = W / 2 - jt - p, zPI = L / 2 - jt - p;   /* the posts' centres, their inner faces */
    var ov = KF.ROD_OVER, zF = L / 2;
    /* v370 THE MONO-PITCH ROOF ON THE SWITCH (Marek 2026-10-29 22:29 / 23:38): the modern house's -- 14 deg falling from the left side
       to the right, the left posts and their beam up by the rise, one-piece 2x6 rafters with a birdsmouth on each beam, the beams on
       past both gables under the fly rafters, the standing seam; no ridge, no rafter ties -- a 2x4 gable tie between each gable's posts
       carries the gable knee braces and the swings' beam instead */
    var mono = _phRoofMono(s), xbo = W / 2 - jt;
    var thM = MD.PITCH * Math.PI / 180, tnM = Math.tan(thM), seatM = Math.min(bw, (jh / Math.cos(thM)) / (3 * tnM)), xhM = xbo - seatM, xiLM = -xbo + bw, xL0M = xiLM - seatM;
    var yPTL = mono ? yPT + (xhM - xL0M) * tnM : yPT;
    function yPTs(sx2) { return (mono && sx2 < 0) ? yPTL : yPT; }   /* each side beam's top */
    function yBms(sx2) { return yPTs(sx2) - bh; }                     /* -- and underside */
    var zFlE = L / 2 + tb + _phU(s, 'RAKE') - st / 2;                 /* the fly rafters (mono: the beams run on under them) */

    /* THE POSTS on their piers (the stilt house's: a ground screw + U head, 12 nails through its flanges) */
    function pier(x, z, id) {
      gscrews.push({ x: x, z: z, r: _phU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yPB, w: p, id: id });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr('nail-uhead', PH.UNAIL, x + sd2 * (p / 2 + PH.U_T), yPB + 0.02 + rI * 0.025, z + cI * ((sd2 < 0) ? 0.022 : 0.034), [-sd2, 0, 0], len38, 0.0019);
    }
    var posts = [];
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var pid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
      posts.push({ x: sx * xP, z: sz * zP, sx: sx, sz: sz, id: pid });
      pier(sx * xP, sz * zP, 'post-' + pid);
      box('post', PH.POST, ceil2(yBms(sx) - yPB), 'post-' + pid, sx * xP, (yPB + yBms(sx)) / 2, sz * zP, p, yBms(sx) - yPB, p);   /* v370 mono: the left ones the taller */
      coat += 4 * p * (yBms(sx) - yPB);
    }

    /* THE DECK FRAME: the front / back rims the full width on the posts'
       outer faces, the side rims between them; two M16 rods from the
       post's inner face through post + rim (counterbored 5 mm short of the
       rim's face, the boards cover it), the front / back pair lower than
       the side pair so they pass each other in the post; two 6x160 through
       the front / back rim into each side rim's end */
    var rodF = [0.30, 0.62], rodS = [0.46, 0.78], rodLen = p + ov + jt - 0.005;
    for (sz = -1; sz <= 1; sz += 2) {
      box('frim', PH.RIM, ceil2(W), 'frim-' + (sz < 0 ? 'b' : 'f'), 0, yB + jh / 2, sz * (L / 2 - jt / 2), W, jh, jt);
      coat += 2 * (jt + jh) * W;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) scr('screw-frim', PH.JOIST_SCREW, sx * (W / 2 - jt / 2), yB + jh * (k ? 0.62 : 0.18), sz * L / 2, [0, 0, -sz], len160);
        for (k = 0; k < 2; k++) rod('bolt-frim', sx * xP, yB + jh * rodF[k], sz * (zPI - ov), [0, 0, sz], rodLen);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      box('frim', PH.RIM, ceil2(L - 2 * jt), 'frim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, 0, jt, jh, L - 2 * jt);
      coat += 2 * (jt + jh) * (L - 2 * jt);
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) rod('bolt-frim', sx * (xPI - ov), yB + jh * rodS[k], sz * zP, [sx, 0, 0], rodLen);
    }
    /* the joists across between the side rims: the first / last just inside the posts (clear of the rods' nuts on their inner faces), the rest at <= 40 cm (US 16 in.) */
    var zj1 = zPI - ov - 0.01 - jt / 2, nj = Math.max(1, Math.ceil(2 * zj1 / _phU(s, 'JOIST_SP') - 1e-9)), joists = [];
    for (i = 0; i <= nj; i++) {
      var zj = -zj1 + 2 * zj1 * i / nj;
      joists.push(zj);
      box('joist', PH.JOIST, ceil2(W - 2 * jt), 'joist-' + (i + 1), 0, yB + jh / 2, zj, W - 2 * jt, jh, jt);
      coat += 2 * (jt + jh) * (W - 2 * jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), zj, [-sx, 0, 0], len160);
    }
    /* THE DECKING along the length; a board that meets the posts runs between them (its ends on the end joists) */
    var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((W + dg) / (P.dw + dg) - 1e-9)), deckBoards = 0;
    for (i = 0; i < nd; i++) {
      var dx0 = -W / 2 + i * (P.dw + dg), dx1 = Math.min(W / 2, dx0 + P.dw);
      if (dx1 - dx0 < 0.02) continue;
      var atPost = (dx0 < -xPI - 1e-6 && dx1 > -(W / 2 - jt) + 1e-6) || (dx1 > xPI + 1e-6 && dx0 < (W / 2 - jt) - 1e-6), dz = atPost ? zPI : L / 2;
      box('deck', PH.DECK, ceil2(2 * dz), 'deck-' + (i + 1), (dx0 + dx1) / 2, yJ1 + P.dk / 2, 0, dx1 - dx0, P.dk, 2 * dz);
      coat += (2 * (dx1 - dx0) + 2 * P.dk) * 2 * dz;
      deckBoards++;
      var dzs = joists.slice();
      if (!atPost) dzs.push(-(L / 2 - jt / 2), L / 2 - jt / 2);
      dzs.forEach(function (zq) {
        for (var k4 = -1; k4 <= 1; k4 += 2) {
          var xq = (dx0 + dx1) / 2 + k4 * (dx1 - dx0) / 4;
          scrClear('screw-deck', PH.DECK_SCREW, [[xq, yD, zq], [xq, yD, zq + 0.012], [xq, yD, zq - 0.012], [xq + k4 * 0.012, yD, zq]], [0, -1, 0], len50);
        }
      });
    }

    /* THE ROOF BEAMS: a 4x6 on each side's two posts, flush with their outer faces, two 8x260 down into each post */
    for (sx = -1; sx <= 1; sx += 2) {
      var tbL = mono ? 2 * zFlE + st : L - 2 * jt;   /* v370 mono: on past the gables under the fly rafters */
      box('tbeam', PH.BEAM, ceil2(tbL), 'tbeam-' + (sx < 0 ? 'l' : 'r'), sx * xP, yBms(sx) + bh / 2, 0, bw, bh, tbL);
      coat += 2 * (bw + bh) * tbL;
      for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2) scr('screw-tbeam', PH.FBEAM_SCREW, sx * xP + k * p / 4.5, yPTs(sx), sz * zP, [0, -1, 0], len260);
    }

    /* THE ROOF FRAME: the cottage's 40 deg gable -- the rafters' seat on the
       beams, the eaves 20 cm (US 8 in.) past the fort walls' boards, the
       rafter pairs at <= 60 cm between the gable pairs (just inside the
       posts' outer faces), fly rafters 15 cm (US 6 in.) past the boards */
    var th = (mono ? MD.PITCH : PH.PITCH) * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = (mono ? jh : sd) / cs;
    var seat = Math.min(bw, dV / (3 * tn)), xh = xbo - seat, xr = P.rgt / 2;
    var xa = W / 2 + tb, xo = xa + _phU(s, 'EAVE'), xe = xo + (mono ? tb : tt);   /* v370 mono: the 1x6 fascia (the fort boards') */
    var yR = mono ? function (x) { return yPT + (xh - x) * tn; } : function (x) { return yPT + (xh - Math.abs(x)) * tn; };
    var yT = function (x) { return yR(x) + dV; };
    var rgTop = mono ? yT(-xe) : yT(xr), rgBot = rgTop - P.rgd;
    if (!mono) {
      var zG = L / 2 - jt - 1.5 * st, nr = Math.max(1, Math.ceil(2 * zG / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
      for (i = 0; i <= nr; i++) zr.push({ z: -zG + 2 * zG * i / nr, gable: (i === 0 || i === nr) });
      var rk = _phU(s, 'RAKE'), zFl = L / 2 + tb + rk - st / 2, flies = [-zFl, zFl];
      var rafL = ceil2((xo - xr) / cs);
      function rafPts(sxx, notch) {
        var pts = notch ? [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [xbo, yR(xbo)], [xbo, yPT], [xh, yPT]]
                        : [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)]];
        return pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      }
      var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2;
      function ridgeToes(kind, code, zq) {
        for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr(kind, code, s3 * xtq, yTm + k3 * s3 * 0.025, zq + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
      }
      for (i = 0; i < zr.length; i++) {
        for (sx = -1; sx <= 1; sx += 2) {
          poly('rafter', PH.RAFTER, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx, true), 'xy', zr[i].z, st);
          var xm = (xh + xbo) / 2;
          scr('screw-seat', PH.SEAT_SCREW, sx * xm, yT(xm), zr[i].z, [0, -1, 0], len200);
        }
        ridgeToes('screw-rtoe', PH.RIDGE_TOE, zr[i].z);
      }
      for (i = 0; i < 2; i++) {
        for (sx = -1; sx <= 1; sx += 2) poly('fly', PH.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rafPts(sx, false), 'xy', flies[i], st);
        ridgeToes('screw-fly', PH.RIDGE_TOE, flies[i]);
      }
      coat += (zr.length + 2) * 2 * 2 * (st + sd) * rafL;
      var zR0 = -zFl - st / 2, zR1 = zFl + st / 2, roofLen = zR1 - zR0;
      box('ridge', PH.RIDGE, ceil2(roofLen), 'ridge', 0, rgTop - P.rgd / 2, 0, P.rgt, P.rgd, roofLen);
      coat += 2 * (P.rgt + P.rgd) * roofLen;
      /* THE TIES: 2x4 on edge on the beams beside every pair -- toward the
         middle, the gable pairs' outside them (over the posts) */
      var xt = xh + (dV - sd - 0.01) / tn, nTies = 0, gTieZ = L / 2 - jt - st / 2;
      for (i = 0; i < zr.length; i++) {
        var sg2 = (zr[i].z > 0) ? 1 : -1, zt = zr[i].gable ? zr[i].z + sg2 * st : zr[i].z - sg2 * st, toR = (zr[i].z > zt) ? 1 : -1;
        box('tie', PH.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
        coat += 2 * (st + sd) * 2 * xt;
        nTies++;
        for (sx = -1; sx <= 1; sx += 2) {
          for (k = 0; k < 2; k++) {
            var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
            scr('screw-tie', PH.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt - toR * st / 2, [0, 0, toR], len80);
          }
          scr('screw-tie', PH.TIE_DOWN, sx * Math.max(xbo - bw + 0.012, xt - 0.04), yPT + sd, zt, [0, -1, 0], len120);   /* between its two toe screws, over the beam */
        }
      }
      /* THE KNEE BRACES (2x4): from each post's inner face up at 45 deg --
         under its beam (in the beam's plane) and under its gable tie (in the
         tie's plane, its top on the tie's underside); a 6x160 into the post,
         one up into the beam / tie */
      var kbk = sd / 2 * Math.SQRT2, nKb = 0;
      var aS = Math.min(_pfU(s, 'KB_SIDE'), zPI - 0.02 - kbk), aG = Math.max(bh + kbk + 0.02, Math.min(_pfU(s, 'KB_GABLE'), xPI - 0.07 - kbk));
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var bid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
        var wbS = (function (sz2) { return function (u, v) { return [sz2 * (zPI - u), yBm + v]; }; })(sz);
        poly('tbrace', PH.STUD, ceil2((aS + kbk) * Math.SQRT2), 'tbrace-s' + bid, [wbS(0, -(aS + kbk)), wbS(0, -(aS - kbk)), wbS(aS - kbk, 0), wbS(aS + kbk, 0)], 'zy', sx * xP, st);
        var sA = wbS(0.06, 0.06 - aS - kbk), sB = wbS(aS + kbk - 0.06, -0.06);
        scr('screw-tbrace', PH.BRACE_SCREW, sx * xP, sA[1], sA[0], [0, 0, sz], len160);
        scr('screw-tbrace', PH.BRACE_SCREW, sx * xP, sB[1], sB[0], [0, 1, 0], len160);
        var wbG = (function (sx2) { return function (u, v) { return [sx2 * (xPI - u), yPT + v]; }; })(sx);
        poly('tbrace', PH.STUD, ceil2((aG + kbk) * Math.SQRT2), 'tbrace-g' + bid, [wbG(0, -(aG + kbk)), wbG(0, -(aG - kbk)), wbG(aG - kbk, 0), wbG(aG + kbk, 0)], 'xy', sz * gTieZ, st);
        var gA = wbG(0.06, 0.06 - aG - kbk), gB = wbG(aG + kbk - 0.06, -0.06);
        scr('screw-tbrace', PH.BRACE_SCREW, gA[0], gA[1], sz * gTieZ, [sx, 0, 0], len160);
        scr('screw-tbrace', PH.BRACE_SCREW, gB[0], gB[1], sz * gTieZ, [0, 1, 0], len160);
        coat += 2 * (st + sd) * (aS + aG + 2 * kbk) * Math.SQRT2;
        nKb += 2;
      }

      /* THE ROOF'S LAYERS: the cottage's -- OSB from the ridge line to past
         the fascia, the shingles over the underlay, the eave fascia on the
         tails, the drip edge, a rake board on each fly rafter, the caps */
      var rs = P.rs, rsV = rs / cs, slope = xe / cs, ze0 = zR0 - tt, ze1 = zR1 + tt, eLen = ze1 - ze0;
      for (sx = -1; sx <= 1; sx += 2) {
        poly('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) + rsV], [0, yT(0) + rsV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; }), 'xy', (ze0 + ze1) / 2, eLen);
        var xs1 = xe + 0.01, ysh = rsV + 0.003;
        pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r'),
          quad: [[0, yT(0) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze1 + 0.01], [0, yT(0) + ysh, ze1 + 0.01]],
          uv: [[(ze0 - 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)]] });
        box('fascia', PH.BOARD, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, 0, tt, cw, roofLen);
        coat += 2 * (tt + cw) * roofLen;
        for (i = 0; i < zr.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), zr[i].z, [-sx, 0, 0], len50);
        for (i = 0; i < 2; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), flies[i], [-sx, 0, 0], len50);
        pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
        for (i = 0; i < 2; i++) {
          var zc2 = (i === 0) ? zR0 - tt / 2 : zR1 + tt / 2, cwV = cw / cs;
          poly('fascia', PH.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) - cwV], [0, yT(0) - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; }), 'xy', zc2, tt);
          coat += 2 * (tt + cw) * slope;
          var fx = fixPts(0.08, xo - 0.04, _phU(s, 'FIX_SP'));
          for (k = 0; k < fx.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * fx[k], yT(fx[k]) - cwV / 2, (i === 0) ? zR0 - tt : zR1 + tt, [0, 0, (i === 0) ? 1 : -1], len50);
          poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), [[0, yT(0) + rsV], [xe, yT(xe) + rsV], [xe, yT(xe) + rsV - 0.055], [0, yT(0) + rsV - 0.055]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; }), 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
        }
      }
      var capH = PH.CAP_W / 2;
      for (sx = -1; sx <= 1; sx += 2) {
        var cx1 = capH * cs, ycap = rsV + 0.008;
        pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
          quad: [[0, yT(0) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT(0) + ycap, ze1]],
          uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
      }
      var roofA = 2 * slope * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
      var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);
    } else {
      /* v370 THE MONO-PITCH ROOF (the modern house's): the rafters at the gable pairs' places and between, one-piece 2x6 with a
         birdsmouth on each beam (one 8x200 down into each), a fly rafter on each beam end, all the same piece */
      var zG = L / 2 - jt - 1.5 * st, nr = Math.max(1, Math.ceil(2 * zG / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
      for (i = 0; i <= nr; i++) zr.push({ z: -zG + 2 * zG * i / nr, gable: (i === 0 || i === nr) });
      var flies = [-zFlE, zFlE];
      var rafL = ceil2(2 * xo / cs + jh * tn);
      var rafPtsM = [[-xo, yR(-xo)], [xL0M, yPTL], [xiLM, yPTL], [xiLM, yR(xiLM)], [xh, yPT], [xbo, yPT], [xbo, yR(xbo)], [xo, yR(xo)], [xo, yT(xo)], [-xo, yT(-xo)]];
      var xmR = xbo - 0.28 * seat, xmL = xL0M + 0.28 * seat;
      var seatScrews = function (kind, zq) {
        scr(kind, PH.SEAT_SCREW, xmR, yT(xmR), zq, [0, -1, 0], len200);
        scr(kind, PH.SEAT_SCREW, xmL, yT(xmL), zq, [0, -1, 0], len200);
      };
      for (i = 0; i < zr.length; i++) { poly('mrafter', MD.RAFTER, rafL, 'rafter-' + (i + 1), rafPtsM, 'xy', zr[i].z, st); seatScrews('screw-seat', zr[i].z); }
      for (i = 0; i < 2; i++) { poly('mfly', MD.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b'), rafPtsM, 'xy', flies[i], st); seatScrews('screw-mfly', flies[i]); }
      coat += (zr.length + 2) * 2 * (st + jh) * rafL;
      var zR0 = -zFlE - st / 2, zR1 = zFlE + st / 2, roofLen = zR1 - zR0;
      /* THE GABLE TIES: a 2x4 on edge between each gable's posts (their inner faces), its top at the low beam's underside, two 6x160
         through each post into its end -- the gable knee braces under it, the swings' beam on it */
      var gTieZ = L / 2 - jt - st / 2, nTies = 0, yTie = yBm;
      for (sz = -1; sz <= 1; sz += 2) {
        box('tie', PH.STUD, ceil2(2 * xPI), 'tie-' + (sz < 0 ? 'b' : 'f'), 0, yTie - sd / 2, sz * gTieZ, 2 * xPI, sd, st);
        coat += 2 * (st + sd) * 2 * xPI;
        nTies++;
      }
      /* THE KNEE BRACES (2x4): from each post's inner face up at 45 deg -- under its beam (at the beam's own height) and under its
         gable tie; a 6x160 into the post, one up into the beam / tie */
      var kbk = sd / 2 * Math.SQRT2, nKb = 0;
      var aS = Math.min(_pfU(s, 'KB_SIDE'), zPI - 0.02 - kbk), aG = Math.max(bh + kbk + 0.02, Math.min(_pfU(s, 'KB_GABLE'), xPI - 0.07 - kbk));
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var bid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
        var wbS = (function (sz2, yb0) { return function (u, v) { return [sz2 * (zPI - u), yb0 + v]; }; })(sz, yBms(sx));
        poly('tbrace', PH.STUD, ceil2((aS + kbk) * Math.SQRT2), 'tbrace-s' + bid, [wbS(0, -(aS + kbk)), wbS(0, -(aS - kbk)), wbS(aS - kbk, 0), wbS(aS + kbk, 0)], 'zy', sx * xP, st);
        var sA = wbS(0.06, 0.06 - aS - kbk), sB = wbS(aS + kbk - 0.06, -0.06);
        scr('screw-tbrace', PH.BRACE_SCREW, sx * xP, sA[1], sA[0], [0, 0, sz], len160);
        scr('screw-tbrace', PH.BRACE_SCREW, sx * xP, sB[1], sB[0], [0, 1, 0], len160);
        var wbG = (function (sx2) { return function (u, v) { return [sx2 * (xPI - u), yTie - sd + v]; }; })(sx);
        poly('tbrace', PH.STUD, ceil2((aG + kbk) * Math.SQRT2), 'tbrace-g' + bid, [wbG(0, -(aG + kbk)), wbG(0, -(aG - kbk)), wbG(aG - kbk, 0), wbG(aG + kbk, 0)], 'xy', sz * gTieZ, st);
        var gA = wbG(0.06, 0.06 - aG - kbk), gB = wbG(aG + kbk - 0.06, -0.06);
        scr('screw-tbrace', PH.BRACE_SCREW, gA[0], gA[1], sz * gTieZ, [sx, 0, 0], len160);
        scr('screw-tbrace', PH.BRACE_SCREW, gB[0], gB[1], sz * gTieZ, [0, 1, 0], len160);
        coat += 2 * (st + sd) * (aS + aG + 2 * kbk) * Math.SQRT2;
        nKb += 2;
      }
      /* the gable ties' screws through the posts, clear of the side braces' screws into the same posts */
      for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) {
        var tyC = (k === 0) ? [0.3, 0.2, 0.4, 0.15] : [0.7, 0.8, 0.6, 0.85];
        scrClear('screw-mtie', PH.JOIST_SCREW, tyC.map(function (fy) { return [sx * (xP + p / 2), yTie - sd * fy, sz * gTieZ]; }), [-sx, 0, 0], len160);
      }
      /* THE ROOF'S LAYERS: the modern house's -- the OSB to past the fascia, the metal sheet over the underlay with a standing seam every
         pan, the drip edge round it, the 1x6 fascia on both eaves and a rake board on each fly rafter */
      var rs = P.rs, rsV = rs / cs, slope = 2 * xe / cs, ze0 = zR0 - tb, ze1 = zR1 + tb, eLen = ze1 - ze0;
      poly('sheath', PH.ROOF, 0, 'sheath', [[-xe, yT(-xe)], [xe, yT(xe)], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (ze0 + ze1) / 2, eLen);
      var mT = MD.SEAM_T / cs, sH = MD.SEAM_H / cs, xsM = xe + 0.01;
      var yC = function (x) { return yT(x) + rsV + 0.002; };
      poly('mcover', MD.SEAM, 0, 'cover', [[-xsM, yC(-xsM)], [xsM, yC(xsM)], [xsM, yC(xsM) + mT], [-xsM, yC(-xsM) + mT]], 'xy', (ze0 + ze1) / 2, eLen + 0.02);
      var pan = _mdU(s, 'SEAM_PAN'), nPan = Math.max(1, Math.ceil((eLen + 0.02) / pan - 1e-9));
      for (k = 1; k < nPan; k++) poly('seam', null, 0, 'seam-' + k, [[-xsM, yC(-xsM) + mT], [xsM, yC(xsM) + mT], [xsM, yC(xsM) + mT + sH], [-xsM, yC(-xsM) + mT + sH]], 'xy', ze0 - 0.01 + (eLen + 0.02) * k / nPan, MD.SEAM_W);
      var tails = zr.map(function (r2) { return r2.z; }).concat(flies);
      for (sx = -1; sx <= 1; sx += 2) {
        var yFt = (sx > 0) ? yT(xe) : yT(-xo);
        box('mfascia', MD.FASCIA, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tb / 2), yFt - bwd / 2, 0, tb, bwd, roofLen);
        coat += 2 * (tb + bwd) * roofLen;
        for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yFt - bwd * (0.25 + 0.35 * k), tails[i], [-sx, 0, 0], len50);
        pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(sx * xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      }
      var fbV = bwd / cs;
      for (i = 0; i < 2; i++) {
        var zc2 = (i === 0) ? zR0 - tb / 2 : zR1 + tb / 2;
        poly('mfascia', MD.FASCIA, ceil2(slope + bwd * tn), 'rake-' + (i ? 'f' : 'b'), [[-xe, yT(-xe) - fbV], [xe, yT(xe) - fbV], [xe, yT(xe)], [-xe, yT(-xe)]], 'xy', zc2, tb);
        coat += 2 * (tb + bwd) * slope;
        var fx = fixPts(-xo + 0.06, xo - 0.06, _phU(s, 'FIX_SP'));
        for (k = 0; k < fx.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, fx[k], yT(fx[k]) - fbV / 2, (i === 0) ? zR0 - tb : zR1 + tb, [0, 0, (i === 0) ? 1 : -1], len50);
        poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b'), [[-xe, yT(-xe) + rsV - 0.055], [xe, yT(xe) + rsV - 0.055], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
      }
      var roofA = slope * eLen, capA = 0, capNails = 0, dripL = 2 * eLen + 2 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);
      var topM = yC(-xsM) + mT + sH + 0.005;
    }
    /* THE LADDER POSTS: two 4x4 on the front rim's outer face either side
       of the opening, two M16 rods each through post + rim (the stilt
       house's) */
    var ow = _phU(s, 'LAD_W'), so = _pfU(s, 'SLIDE_OPEN');
    for (sx = -1; sx <= 1; sx += 2) {
      var rpx = sx * (ow / 2 + p / 2);
      box('rpost', PH.POST, ceil2(yG1 - yB), 'rpost-' + (sx < 0 ? 'l' : 'r'), rpx, (yB + yG1) / 2, zF + p / 2, p, yG1 - yB, p);
      coat += 4 * p * (yG1 - yB);
      for (k = 0; k < 2; k++) rod('bolt-rpost', rpx, yB + jh * (0.3 + 0.4 * k), zF + p + ov, [0, 0, -1], p + jt + 2 * ov);
    }
    /* THE FORT WALLS' RAILS: 2x4 on edge on the posts' outer faces, flush
       with the rims' faces -- the front / back ones the full width (the
       front's two halves end on the ladder posts), the sides' between
       them (the right side's middle rail open for the slide, its top rail
       over it); into each post two 6x120 (the front / back ones level
       with the rail's middle, the sides' above and below it: they pass in
       the post), the front halves two more from inside into the ladder post */
    var nRail = 0;
    function railBox(id, x, y, z, dx, dz) { box('rail', PH.STUD, ceil2(Math.max(dx, dz)), id, x, y, z, dx, sd, dz); coat += 2 * (st + sd) * Math.max(dx, dz); nRail++; }
    for (k = 0; k < 2; k++) {
      for (sz = -1; sz <= 1; sz += 2) {
        var zcr = sz * (L / 2 - jt + st / 2);
        if (sz > 0) for (sx = -1; sx <= 1; sx += 2) {
          railBox('rail-f' + (sx < 0 ? 'l' : 'r') + (k + 1), sx * (ow / 2 + W / 2) / 2, yRc[k], zcr, W / 2 - ow / 2, st);
          for (e = 0; e < 2; e++) scr('screw-rail', PH.RAIL_SCREW, sx * (ow / 2 + 0.03 + 0.04 * e), yRc[k], L / 2 - jt, [0, 0, 1], len120);   /* from inside into the ladder post */
        } else railBox('rail-b' + (k + 1), 0, yRc[k], zcr, W, st);
        for (sx = -1; sx <= 1; sx += 2) for (e = -1; e <= 1; e += 2) scr('screw-rail', PH.RAIL_SCREW, sx * xP + e * 0.025, yRc[k], sz * L / 2, [0, 0, -sz], len120);
      }
      for (sx = -1; sx <= 1; sx += 2) {
        var xcr = sx * (W / 2 - jt + st / 2), zr0 = L / 2 - jt;
        if (sx > 0 && k === 0) {
          railBox('rail-r1a', xcr, yRc[k], -(zr0 + so / 2) / 2, st, zr0 - so / 2);
          railBox('rail-r1b', xcr, yRc[k], (zr0 + so / 2) / 2, st, zr0 - so / 2);
        } else railBox('rail-' + (sx < 0 ? 'l' : 'r') + (k + 1), xcr, yRc[k], 0, st, 2 * zr0);
        for (sz = -1; sz <= 1; sz += 2) for (e = -1; e <= 1; e += 2) scr('screw-rail', PH.RAIL_SCREW, sx * W / 2, yRc[k] + e * 0.03, sz * zP, [-sx, 0, 0], len120);
      }
    }
    /* THE FORT BOARDS: 1x6 upright outside the rails and rims, from the
       rims' underside to the walls' top + a pointed head (half the board's
       width), each run's boards at most 2 cm (US 3/4 in.) apart (ripped a
       little where the run asks), two stainless screws into the rim and
       into each rail; the sides' runs from the front to the back face,
       the front / back runs over their ends */
    var gMax = _pfU(s, 'BOARD_GAP'), nBoards = 0;
    function boardRun(id, ax, o, u0, u1) {
      var span = u1 - u0, n = Math.max(1, Math.ceil((span + gMax) / (bwd + gMax) - 1e-9)), g = (n > 1) ? Math.max(0.005, (span - n * bwd) / (n - 1)) : 0;
      var wB = Math.min(bwd, (span - (n - 1) * g) / n), m;
      if (n > 1) g = (span - n * wB) / (n - 1);
      var cpl = (ax === 'z') ? o * (W / 2 + tb / 2) : o * (L / 2 + tb / 2), cOut = (ax === 'z') ? o * (W / 2 + tb) : o * (L / 2 + tb);
      for (m = 0; m < n; m++) {
        var ua = u0 + m * (wB + g), ub = ua + wB, uc = (ua + ub) / 2, hd = wB / 2;
        poly('fboard', PF.BOARD, ceil2(yG1 + hd - yB), id + '-' + (m + 1), [[ua, yB], [ub, yB], [ub, yG1], [uc, yG1 + hd], [ua, yG1]], (ax === 'z') ? 'zy' : 'xy', cpl, tb);
        coat += 2 * (tb + wB) * (yG1 + hd - yB);
        nBoards++;
        [yB + jh / 2, yRc[0], yRc[1]].forEach(function (yq) {
          for (var e2 = -1; e2 <= 1; e2 += 2) {
            var cands = [], du = [0, 0.012, -0.012, 0.022, -0.022];
            du.forEach(function (dd) {
              var uq = uc + e2 * wB / 4 + dd;
              if (Math.abs(uq - uc) > wB / 2 - 0.012) return;
              cands.push((ax === 'z') ? [cOut, yq, uq] : [uq, yq, cOut]);
            });
            [0.012, -0.012].forEach(function (dy) { cands.push((ax === 'z') ? [cOut, yq + dy, uc + e2 * wB / 4] : [uc + e2 * wB / 4, yq + dy, cOut]); });
            scrClear('screw-fboard', PF.BOARD_SCREW, cands, (ax === 'z') ? [-o, 0, 0] : [0, 0, -o], len50, 0.0025);
          }
        });
      }
    }
    boardRun('fboard-l', 'z', -1, -L / 2, L / 2);
    boardRun('fboard-ra', 'z', 1, -L / 2, -so / 2);
    boardRun('fboard-rb', 'z', 1, so / 2, L / 2);
    boardRun('fboard-b', 'x', -1, -(W / 2 + tb), W / 2 + tb);
    boardRun('fboard-fl', 'x', 1, -(W / 2 + tb), -(ow / 2 + p));
    boardRun('fboard-fr', 'x', 1, ow / 2 + p, W / 2 + tb);

    /* THE LADDER (the stilt house's): 2x6 rails at 75 deg lapped on the ladder posts, 2x4 treads <= 28 cm (US 11 in.) apart */
    var lAng = PH.LAD_ANG * Math.PI / 180, lct = 1 / Math.tan(lAng), lhw = jh / Math.sin(lAng), nTread = 0;
    var lz = function (y) { return zF + (yD - y) * lct; };
    for (sx = -1; sx <= 1; sx += 2) {
      poly('lrail', PH.RIM, ceil2(yD / Math.sin(lAng) + jh * lct), 'lrail-' + (sx < 0 ? 'l' : 'r'), [[lz(yD), yD], [lz(yD) + lhw, yD], [lz(0) + lhw, 0], [lz(0), 0]], 'zy', sx * (ow / 2 - jt / 2), jt);
      coat += 2 * (jt + jh) * yD / Math.sin(lAng);
      [yD - 0.03, yB + 0.07].forEach(function (yq) {
        var zq0 = Math.max(zF, lz(yq)), zq1 = Math.min(zF + p, lz(yq) + lhw);
        scr('screw-lrail', PH.RAIL_SCREW, sx * (ow / 2 - jt), yq, (zq0 + zq1) / 2, [sx, 0, 0], len120);
      });
    }
    var nT = Math.max(2, Math.ceil(yD / _phU(s, 'LAD_RISE') - 1e-9)), rise = yD / nT, twd = ow - 2 * jt;
    for (k = 1; k < nT; k++) {
      var ytc = yD - k * rise - st / 2, ztc = lz(ytc) + lhw / 2;
      box('tread', PH.STUD, ceil2(twd), 'tread-' + k, 0, ytc, ztc, twd, st, sd);
      coat += 2 * (st + sd) * twd;
      nTread++;
      for (sx = -1; sx <= 1; sx += 2) for (e = -1; e <= 1; e += 2) scr('screw-tread', PH.RAIL_SCREW, sx * ow / 2, ytc, ztc + e * sd / 4, [-sx, 0, 0], len120);
    }
    var extZ = lz(0) + lhw;
    /* THE SLIDE off the right side, centred in its opening (the stilt house's; MISSING) */
    var wsl = _phU(s, 'SLIDE_W'), sbd = PH.SLIDE_BED, swh = PH.SLIDE_WALL, swt = PH.SLIDE_WT;
    var sAng = PH.SLIDE_ANG * Math.PI / 180, sx0 = W / 2 - PH.SLIDE_LIP, sx1 = W / 2 + _phU(s, 'SLIDE_TOP'), syE = _phU(s, 'SLIDE_EXIT'), syT = yD + sbd;
    var sx2 = sx1 + (syT - syE) / Math.tan(sAng), sx3 = sx2 + _phU(s, 'SLIDE_RUN');
    poly('slide', null, 0, 'slide-bed', [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx3, syE - sbd], [sx3, syE], [sx2, syE], [sx1, syT], [sx0, syT]], 'xy', 0, wsl - 2 * swt);
    for (k = -1; k <= 1; k += 2)
      poly('slide', null, 0, 'slide-wall-' + (k < 0 ? 'b' : 'f'), [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx2, 0], [sx3, 0], [sx3, syE + swh], [sx2, syE + swh], [sx1, syT + swh], [sx0, syT + swh]], 'xy', k * (wsl / 2 - swt / 2), swt);
    missing.push({ name: PH.SLIDE_NAME, qty: 1, unit: 'pcs' });
    var extX = sx3;

    /* THE SWINGS (the toggle): the beam on the ties, its A-frame, the seats on their chains */
    var swing = null;
    if (swings) {
      var Q = _kfProf(s), b2 = Q.b, bh2 = Q.bh, t2 = Q.t;
      var ySB = mono ? yTie : yPT + sd, yST = ySB + bh2,   /* v370 mono: on the gable ties */ zBack = -(L / 2 + tb), span2 = _pfU(s, 'SPAN'), zf = zBack - span2;
      var fr = _pfSwingFrame(s, zf, ySB, Q);
      fr.pieces.forEach(function (pc2) { pieces.push(pc2); });
      fr.fas.forEach(function (f2) { fas.push(f2); });
      coat += fr.coat;
      /* the beam: from the front gable tie's outer face back over every tie,
         out through the back gable to past the A-frame's legs (the kids'
         set's scroll at that end) */
      var bOver = us ? KF.BEAM_OVER_US : KF.BEAM_OVER, zEb = zf - t2 / 2 - bOver, z1 = L / 2 - jt, lt = bOver - KF.END_CLR, NO = 12, bp = [[z1, yST], [zEb, yST]];
      for (j = 0; j <= NO; j++) { var uo = j / NO; bp.push([zEb + uo * lt, yST - bh2 * (KF.END_TIP + (1 - KF.END_TIP) * (1 - Math.cos(Math.PI * uo)) / 2)]); }
      bp.push([z1, ySB]);
      var sbL = ceil2(z1 - zEb);
      poly('sbeam', PF.SBEAM, sbL, 'sbeam', bp, 'zy', 0, b2);
      coat += 2 * (b2 + bh2) * (z1 - zEb);
      for (sz = -1; sz <= 1; sz += 2) rod('bolt-sbeam', 0, yST + ov, sz * gTieZ, [0, -1, 0], bh2 + sd + 2 * ov);   /* down through the beam and the gable tie */
      /* the seats: centred in the span, each on two chains from swing hangers under the beam (the kids' set's) */
      var Pw = _swingProf(s), nS = PF.SEATS, hy = ySB - SWING.HANGER_DROP, sy = KIDS.SEAT_Y, seats = [], hangers = [], eyeF = [], eyeR = [], chains = [];
      for (i = 0; i < nS; i++) {
        var zcS = zBack - span2 * (i + 0.5) / nS;
        seats.push({ z: zcS, y: sy - Pw.slatT / 2 });
        for (e = -1; e <= 1; e += 2) {
          var zeS = zcS + e * KIDS.CHAIN_SPREAD / 2, eyS = { x: 0, y: sy + 0.02, z: zeS, face: sy, vert: true };
          (e < 0 ? eyeF : eyeR).push(eyS);
          hangers.push({ x: 0, y: hy, z: zeS });
          chains.push({ a: { x: 0, y: eyS.y, z: zeS }, b: { x: 0, y: hy, z: zeS }, len: hy - eyS.y });
        }
      }
      swing = { H: ySB, hangers: hangers, eyeF: eyeF, eyeR: eyeR, chains: chains, seats: seats, seatT: Pw.slatT, seatW: Pw.slatW, N: nS,
                yBB: ySB, beamL: sbL, zf: zf, zEnd: zEb, legLen: fr.legLen, depth: fr.depth, span: span2 };
      extZ = Math.max(extZ, -zEb);
      extX = Math.max(extX, fr.depth / 2);
    }

    /* the bill's quantities: timber, boards and decking by length */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    return {
      P: P, us: us, porch: false, L: L, W: W, PD: 0, zF: zF, pieces: pieces, fas: fas, blocks: [], hw: [], posts: posts, joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: 0, roofA: roofA, sidingA: 0, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: 0, digM3: 0, hinges: 0, shutters: 0, deckBoards: deckBoards,
      ties: nTies, gStuds: 0, trims: 0, doorBoards: 0, doorW: 0, doorH: 0, RO: 0, win: 0,
      yB: yB, yF: yD, yPT: yPT, yBm: yBm, yHd: 0, yWS: 0, ridgeTop: rgTop, pitch: mono ? MD.PITCH : PH.PITCH, rafL: rafL, roofLen: eLen, slope: slope,
      top: mono ? topM : yT(0) + rsV + 0.01, height: mono ? topM : yT(0) + rsV + 0.01, depth: W, length: L,
      mono: mono, roofCov: mono ? 'seam' : 'shingle', yPTL: yPTL, seams: mono ? nPan - 1 : 0,   /* v370 the roof on the switch */
      fort: true, stilt: false, slide: true, gscrews: gscrews, uheads: uheads, missing: missing, yD: yD, extX: extX, extZ: extZ, sPosts: posts.length, xBraces: 0,
      balusters: 0, treads: nTread, rails: nRail, fboards: nBoards, kbraces: nKb, swings: swings, swing: swing, yG1: yG1
    };
  }
  /* ------------------------------------------------------------------
     v366 TYPE 30 -- PLAYHOUSES, variant 5: THE MODERN HOUSE (Marek
     2026-10-29 18:38 "Dalsi krok" -- slot 5 of the plan). The cottage's
     body under a mono-pitch roof:
       - FLOOR, WALLS, DOOR, PORCH: the cottage's -- deck blocks, 2x6 rims +
         joists, OSB; 2x4 walls; the T&G ledge-and-brace door (no lock);
         the porch on the info bar's toggle (two 4x4 posts in the front
         blocks, knee braces, decking);
       - ROOF: 14 deg one way, falling from the left wall (seen from the
         porch) to the right one. The side walls carry 4x6 KVH10160 beams
         at their own heights -- the right one at the cottage's plates
         (1.52 m / US 5 ft over the floor), the left one up by the roof's
         rise -- running on past both gables (and over the porch to its
         posts) to carry the fly rafters. 2x6 KVH60160 rafters at <= 60 cm
         (US 24 in.) with a birdsmouth on each beam (the low one's heel at
         the wall's outer face, the high one's plumb cut at its inner face)
         and one 8x200 down into each; no ridge, no ties (a shed roof has
         no thrust); gable studs over the gables' top plates up to the end
         rafters; roof OSB25001, underlay ROR00008, the metal sheet
         ROR12003 as standing seam (530 pans / US 16 in., clips 5 a m2),
         drip edge ROM02401 round it; 1x6 KVR14024 fascia + rake boards;
       - OPENINGS: a wide window 91 x 46 (US 36 x 18 in.) in the high left
         wall, a 46 square one in the back gable, none in the low wall; no
         shutters, no glass;
       - SKIN: the cottage's panel siding FCP00009, corner boards and
         casings -- drawn charcoal with the fascia, the door in wood.
     The cottage's axes: X across (W, +X the right side seen from the
     porch), Y up, Z along (L, +Z the front with the door). */
  var MD = {
    PITCH: 14, WIN_W: 0.91, WIN_W_US: 0.9144,
    RAFTER: 'KVH60160', FASCIA: 'KVR14024', SEAM: 'ROR12003', SEAM_CLIP: 'FAS60100', SEAM_CLIPS_M2: 5,
    SEAM_PAN: 0.53, SEAM_PAN_US: 0.4064, SEAM_W: 0.022, SEAM_H: 0.025, SEAM_T: 0.002
  };
  function _mdU(s, k) { return ((s || STATE).isMetric === false && MD[k + '_US'] != null) ? MD[k + '_US'] : MD[k]; }
  function _phIsMd(s) { return ((s || STATE).variant | 0) === 30; }
  function _mdLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), porch = _phPorch(s), L = _phL(s), W = _phW(s), i, j, k, sx, sz, q;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, p = P.p, sg = P.sg, tt = P.tt, cw = P.cw, tw = P.tw;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], blocks = [], hw = [], coat = 0, hinges = 0;
    var FB = _pfBoard(s), fbT = FB.t, fbW = FB.w;   /* the fascia / rake boards: 1x6 */
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    /* a screw at the first of its spots whose shank keeps 3 mm off every fastener placed so far (the play fort's) */
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, m, q2;
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var f = fas[q2], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* THE HEIGHTS: the blocks' top, the joists' top, the floor, the low
       (right) beam's top = the gables' top plates' top */
    var yB = _phU(s, 'BLK_UP'), yJ1 = yB + jh, yF = yJ1 + P.fl, yPT = yF + _phU(s, 'WALL_H');
    var yP0 = yF + st, yGT = yPT - st;
    var PD = porch ? _phU(s, 'PORCH') : 0, zF = L / 2 + PD;
    /* THE ROOF'S LINE: the rafters' underside yR(x) = yPT + (xh - x) tan,
       falling to the right; the low seat from xh to the right beam's outer
       face, the high one on the left beam from xL0 to its inner face
       (each at most the beam's width, its depth a third of the rafter's
       plumb depth at most) -- the left beam's top follows */
    var th = MD.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), rd = jh, dV = rd / cs;
    var seat = Math.min(bw, dV / (3 * tn)), xh = W / 2 - seat, xiL = -W / 2 + bw, xL0 = xiL - seat;
    function yR(x) { return yPT + (xh - x) * tn; }
    function yT(x) { return yR(x) + dV; }
    var yPTL = yR(xL0);
    function yPTs(sx2) { return (sx2 < 0) ? yPTL : yPT; }
    function yBms(sx2) { return yPTs(sx2) - bh; }
    var xa = W / 2 + sg, xo = xa + _phU(s, 'EAVE'), xe = xo + fbT;
    var rk = _phU(s, 'RAKE'), zFb = -(L / 2 + sg + rk) + st / 2, zFf = (porch ? zF : L / 2 + sg) + rk - st / 2;
    var zBb = zFb - st / 2, zBf = zFf + st / 2;   /* the beams' ends: under the fly rafters' outer faces */

    /* THE FOUNDATION: the cottage's deck blocks under each side rim (with
       the porch the last one under its post) */
    var bl = _phU(s, 'BLK'), blT = _phU(s, 'BLK_TOP'), blH = _phU(s, 'BLK_H'), sock = _phU(s, 'SOCK'), gv = _phU(s, 'GRAVEL');
    var zRimEnd = porch ? zF - p : L / 2;
    for (sx = -1; sx <= 1; sx += 2) {
      var zb0 = -L / 2 + bl / 2, zb1 = porch ? zF - p / 2 : L / 2 - bl / 2, nb = Math.max(1, Math.ceil((zb1 - zb0) / _phU(s, 'BLK_SP') - 1e-9));
      for (i = 0; i <= nb; i++) {
        var post = porch && i === nb, zbk = zb0 + (zb1 - zb0) * i / nb;
        blocks.push({ x: sx * (W / 2 - (post ? p : jt) / 2), z: zbk, w: bl, wt: blT, y0: yB - blH, y1: yB, a: 0, id: (sx < 0 ? 'l' : 'r') + (i + 1), post: post });
      }
    }
    /* THE PORCH POSTS in the front blocks' sockets, up to their beams (the left one the taller) */
    var posts = [];
    if (porch) for (sx = -1; sx <= 1; sx += 2) {
      var pX = sx * (W / 2 - p / 2), pZ = zF - p / 2, pY0 = yB - sock;
      posts.push({ x: pX, z: pZ, sx: sx });
      box('post', PH.POST, ceil2(yBms(sx) - pY0), 'post-' + (sx < 0 ? 'l' : 'r'), pX, (pY0 + yBms(sx)) / 2, pZ, p, yBms(sx) - pY0, p);
    }
    /* THE FLOOR FRAME: the cottage's -- side rims on through the porch to
       its posts, joists across at <= 40 cm (US 16 in.) */
    for (sx = -1; sx <= 1; sx += 2) {
      box('rim', PH.RIM, ceil2(zRimEnd + L / 2), 'rim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, (zRimEnd - L / 2) / 2, jt, jh, zRimEnd + L / 2);
      if (porch) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * (W / 2 - jt / 2), yB + jh * (0.2 + 0.6 * k), zF, [0, 0, -1], len160);   /* through the post into the rim's end (over / under the front joist's own two) */
    }
    var jw = W - 2 * jt;
    var joists = [], jz0 = -L / 2 + jt / 2, jz1 = L / 2 - jt / 2, nj = Math.max(1, Math.ceil((jz1 - jz0) / _phU(s, 'JOIST_SP') - 1e-9));
    for (i = 0; i <= nj; i++) joists.push({ z: jz0 + (jz1 - jz0) * i / nj, w: jw, porch: false });
    if (porch) {
      var pz0 = L / 2 + jt / 2, pz1 = zF - jt / 2, np = Math.max(1, Math.ceil((pz1 - pz0) / _phU(s, 'JOIST_SP') - 1e-9));
      for (i = 0; i <= np; i++) joists.push({ z: pz0 + (pz1 - pz0) * i / np, w: (i === np) ? W - 2 * p : jw, porch: true, front: i === np });
    }
    for (i = 0; i < joists.length; i++) {
      q = joists[i];
      box('joist', PH.JOIST, ceil2(q.w), 'joist-' + (i + 1), 0, yB + jh / 2, q.z, q.w, jh, jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), q.z, [-sx, 0, 0], len160);
    }
    /* the floor's OSB over the house's frame (billed by area) */
    pieces.push({ kind: 'floor', code: PH.FLOOR, len: 0, id: 'floor', box: [0, yJ1 + P.fl / 2, 0, W, P.fl, L] });
    var floorA = W * L;
    /* THE PORCH'S DECKING along the length (the boards at the posts end against them) */
    var deckBoards = 0;
    if (porch) {
      var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((W + dg) / (P.dw + dg) - 1e-9)), dz0 = L / 2 + sg;
      for (i = 0; i < nd; i++) {
        var dx0 = -W / 2 + i * (P.dw + dg), dx1 = Math.min(W / 2, dx0 + P.dw);
        if (dx1 - dx0 < 0.02) continue;
        var atPost = (dx0 < -W / 2 + p - 1e-6) || (dx1 > W / 2 - p + 1e-6), dz1 = atPost ? zF - p : zF;
        box('deck', PH.DECK, ceil2(dz1 - dz0), 'deck-' + (i + 1), (dx0 + dx1) / 2, yJ1 + P.dk / 2, (dz0 + dz1) / 2, dx1 - dx0, P.dk, dz1 - dz0);
        coat += (2 * (dx1 - dx0) + 2 * P.dk) * (dz1 - dz0);
        deckBoards++;
        for (j = 0; j < joists.length; j++) {
          if (!joists[j].porch || joists[j].z < dz0 || joists[j].z > dz1) continue;
          for (k = -1; k <= 1; k += 2) scr('screw-deck', PH.DECK_SCREW, (dx0 + dx1) / 2 + k * (dx1 - dx0) / 4, yJ1 + P.dk, joists[j].z, [0, -1, 0], len50);
        }
      }
    }

    /* THE WALLS: the cottage's framing (yPl = the top member's top, where
       the screws down into the studs start) */
    var stuff = { win: _phU(s, 'WIN'), sill: _phU(s, 'WIN_SILL') }, winW = _mdU(s, 'WIN_W');
    var yWS = yF + stuff.sill, yWT = yWS + stuff.win, RO = _phU(s, 'DOOR_W') + 2 * _phU(s, 'DOOR_CLR'), yHd = yGT - jh;
    function wall(id, side, u0, u1, yTop, opening, topKind, yPl) {
      var hs = (side.ax === 'z'), plates = [], studs = _phGrid(u0, u1, _phU(s, 'STUD_SP'), st), keep = [], m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var half = opening ? opening.w / 2 : 0, door = opening && opening.door;
      var oL = opening ? (door ? half + 2 * st : half + st) : 0;   /* the kings' outer faces */
      for (m = 0; m < studs.length; m++) if (!opening || Math.abs(studs[m]) > oL + st / 2 - 1e-6) keep.push(studs[m]);
      var stTop = yTop;
      if (door) plates.push([u0, -half], [half, u1]); else plates.push([u0, u1]);
      var plateHalf = [];
      for (m = 0; m < plates.length; m++) {
        var pa = plates[m][0], pb = plates[m][1];
        bx('plate', PH.STUD, ceil2(pb - pa), id + '-plate-' + (m + 1), (pa + pb) / 2, yF + st / 2, 0, pb - pa, st, sd);
        plateHalf.push([pa, pb]);
      }
      var full = keep.slice();
      if (opening) { full.push(-(oL - st / 2), oL - st / 2); }
      full.sort(function (a, b) { return a - b; });
      for (m = 0; m < full.length; m++) {
        var u = full[m];
        bx('stud', PH.STUD, ceil2(stTop - yP0), id + '-stud-' + (m + 1), u, (yP0 + stTop) / 2, 0, st, stTop - yP0, sd);
        for (e = -1; e <= 1; e += 2) sc('screw-stud', PH.STUD_SCREW, u, yF, e * sd / 4, 0, 1, 0, len120);
        if (topKind === 'beam') sc('screw-beam', PH.BEAM_SCREW, u, yPl, 0, 0, -1, 0, len200);
        else for (e = -1; e <= 1; e += 2) sc('screw-tplate', PH.STUD_SCREW, u, yPl, e * 0.4 * sd, 0, -1, 0, len120);   /* near the faces: clear of a header's screws through the kings */
      }
      /* the plate's screws between its members (the studs, a window's lower cripples), clear of the floor's own screws */
      var crLo = (opening && !door) ? studs.filter(function (u2) { return Math.abs(u2) < half - st / 2; }) : [];
      if (opening && !door && !crLo.length) crLo = [0];
      var mem = full.concat(crLo).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < mem.length; m++) {
        var um = (mem[m] + mem[m + 1]) / 2, onPl = plateHalf.some(function (h2) { return um > h2[0] + 0.03 && um < h2[1] - 0.03; });
        if (!(onPl && mem[m + 1] - mem[m] > 0.15)) continue;
        var pc0 = [um, um + 0.02, um - 0.02, um + 0.04, um - 0.04].map(function (u3) { return at(u3, yP0, sd / 2 - jt / 2); });
        scrClear('screw-plate', PH.PLATE_SCREW, pc0, [0, -1, 0], len160);
      }
      if (opening && !door) {
        /* THE WINDOW: a 2x4 header on edge at the outer face, a flat 2x4 sill, cripples under / over at the grid (or one in the middle) */
        var hdT = yWT + sd, cr = studs.filter(function (u2) { return Math.abs(u2) < half - st / 2; });
        if (!cr.length) cr = [0];
        bx('stud', PH.STUD, ceil2(2 * half), id + '-whead', 0, yWT + sd / 2, sd / 2 - st / 2, 2 * half, sd, st);
        bx('stud', PH.STUD, ceil2(2 * half), id + '-wsill', 0, yWS - st / 2, 0, 2 * half, st, sd);
        for (e = -1; e <= 1; e += 2) for (f2 = 0; f2 < 2; f2++) {
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWT + sd * (0.3 + 0.4 * f2), sd / 2 - st / 2, -e, 0, 0, len120);
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWS - st / 2, (f2 ? 1 : -1) * sd / 4, -e, 0, 0, len120);
        }
        for (m = 0; m < cr.length; m++) {
          bx('stud', PH.STUD, ceil2(yWS - st - yP0), id + '-cripple-lo-' + (m + 1), cr[m], (yP0 + yWS - st) / 2, 0, st, yWS - st - yP0, sd);
          if (stTop - hdT > 0.03) bx('stud', PH.STUD, ceil2(stTop - hdT), id + '-cripple-hi-' + (m + 1), cr[m], (hdT + stTop) / 2, 0, st, stTop - hdT, sd);
          for (e = -1; e <= 1; e += 2) {
            sc('screw-stud', PH.STUD_SCREW, cr[m], yF, e * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', PH.STUD_SCREW, cr[m], yWS, ((e < 0) ? -0.4 : 0.1) * sd, 0, -1, 0, len120);   /* v367 near the faces: clear of the sill's screws through the kings */
          }
          if (stTop - hdT > 0.03) {
            if (topKind === 'beam') sc('screw-beam', PH.BEAM_SCREW, cr[m], yPl, 0, 0, -1, 0, len200);
            else for (e = -1; e <= 1; e += 2) sc('screw-tplate', PH.STUD_SCREW, cr[m], yPl, e * 0.4 * sd, 0, -1, 0, len120);
          }
        }
      }
      if (door) {
        /* THE DOOR: jacks under a 2x6 header (on edge, the outer face) that fills up to the top plate */
        for (e = -1; e <= 1; e += 2) {
          var uj = e * (half + st / 2);
          bx('stud', PH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (var e2 = -1; e2 <= 1; e2 += 2) sc('screw-stud', PH.STUD_SCREW, uj, yF, e2 * sd / 4, 0, 1, 0, len120);
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', PH.FRAME_SCREW, e * (half + 2 * st), yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, len100);
          for (f2 = 0; f2 < 2; f2++) sc('screw-frame', PH.STUD_SCREW, e * oL, yHd + jh * (0.3 + 0.4 * f2), sd / 2 - jt / 2, -e, 0, 0, len120);
        }
        bx('header', PH.HEADER, ceil2(2 * (half + st)), id + '-header', 0, yHd + jh / 2, sd / 2 - jt / 2, 2 * (half + st), jh, jt);
      }
      return { studs: studs };
    }
    /* the side walls (x = +- W/2, full length, a beam on top at the wall's
       own height): the left (high) one with the wide window, the right
       (low) one closed; the beams from the back fly rafter to the front one */
    for (sx = -1; sx <= 1; sx += 2) {
      var sid = 'side-' + (sx < 0 ? 'l' : 'r'), yBmS = yBms(sx), yPS = yPTs(sx);
      wall(sid, { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx }, -L / 2, L / 2, yBmS, (sx < 0) ? { w: winW } : null, 'beam', yPS);
      box('beam', PH.BEAM, ceil2(zBf - zBb), 'beam-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), yBmS + bh / 2, (zBb + zBf) / 2, bw, bh, zBf - zBb);
      coat += 2 * (bw + bh) * ((zBf - L / 2) + (-L / 2 - zBb));   /* its ends out in the open */
      if (porch) {
        /* the beam down into its post, two 8x200 */
        for (k = -1; k <= 1; k += 2) scr('screw-beam', PH.BEAM_SCREW, sx * (W / 2 - p / 2) + k * p / 5, yPS, zF - p / 2, [0, -1, 0], len200);
        /* a 2x4 knee brace from the post's back face up under the beam at 45 deg (toward the house) */
        var ba = _phU(s, 'BRACE'), bk = sd / 2 * Math.SQRT2, zP = zF - p;
        var wb = (function (yb0) { return function (u2, v2) { return [zP - u2, yb0 + v2]; }; })(yBmS);
        poly('brace', PH.STUD, ceil2((ba + bk) * Math.SQRT2), 'brace-' + (sx < 0 ? 'l' : 'r'),
          [wb(0, -(ba + bk)), wb(0, -(ba - bk)), wb(ba - bk, 0), wb(ba + bk, 0)], 'zy', sx * (W / 2 - bw / 2), st);
        coat += 2 * (st + sd) * (ba + bk) * Math.SQRT2;
        var tA = wb(0.06, 0.06 - ba - bk), tB = wb(ba + bk - 0.06, -0.06);
        scr('screw-brace', PH.BRACE_SCREW, sx * (W / 2 - bw / 2), tA[1], tA[0], [0, 0, 1], len160);
        scr('screw-brace', PH.BRACE_SCREW, sx * (W / 2 - bw / 2), tB[1], tB[0], [0, 1, 0], len160);
        coat += 4 * p * (yBmS - yB);   /* the post */
      }
    }
    /* the gable walls (between the side walls, a 2x4 top plate at the low
       beam's top): the back with a window, the front with the door */
    var gl = W / 2 - sd;
    for (sz = -1; sz <= 1; sz += 2) {
      var gid = (sz < 0) ? 'back' : 'front';
      wall(gid, { ax: 'x', c: sz * (L / 2 - sd / 2), o: sz }, -gl, gl, yGT, (sz < 0) ? { w: stuff.win } : { w: RO, door: true }, 'tplate', yPT);
      box('tplate', PH.STUD, ceil2(2 * gl), gid + '-tplate', 0, yPT - st / 2, sz * (L / 2 - sd / 2), 2 * gl, st, sd);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) scr('screw-frame', PH.FRAME_SCREW, sx * (gl - st), yP0 + (yGT - yP0) * (0.2 + 0.3 * k), sz * (L / 2 - st / 2), [sx, 0, 0], len100);
    }

    /* THE ROOF FRAME: one-piece 2x6 rafters at <= 60 cm from the back gable
       to the front one (and on over the porch to its front), a fly rafter
       on each beam end -- all the same piece: the tails cut plumb, a
       birdsmouth on each beam, one 8x200 down into each beam (beside the
       beam's own screws into the studs) */
    var zA = -L / 2 + st / 2, zB = L / 2 - st / 2, nr = Math.max(1, Math.ceil((zB - zA) / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
    for (i = 0; i <= nr; i++) zr.push({ z: zA + (zB - zA) * i / nr, gable: (i === 0 || i === nr) });
    if (porch) {
      var zC = zF - st / 2, nrp = Math.max(1, Math.ceil((zC - zB) / _phU(s, 'RAF_SP') - 1e-9));
      for (i = 1; i <= nrp; i++) zr.push({ z: zB + (zC - zB) * i / nrp, gable: false });
    }
    var rafL = ceil2(2 * xo / cs + rd * tn);
    var rafPts = [[-xo, yR(-xo)], [xL0, yPTL], [xiL, yPTL], [xiL, yR(xiL)], [xh, yPT], [W / 2, yPT], [W / 2, yR(W / 2)], [xo, yR(xo)], [xo, yT(xo)], [-xo, yT(-xo)]];
    var xmR = W / 2 - 0.28 * seat, xmL = xL0 + 0.28 * seat;
    function seatScrews(kind, zq) {
      scr(kind, PH.SEAT_SCREW, xmR, yT(xmR), zq, [0, -1, 0], len200);
      scr(kind, PH.SEAT_SCREW, xmL, yT(xmL), zq, [0, -1, 0], len200);
    }
    for (i = 0; i < zr.length; i++) {
      poly('mrafter', MD.RAFTER, rafL, 'rafter-' + (i + 1), rafPts, 'xy', zr[i].z, st);
      seatScrews('screw-seat', zr[i].z);
    }
    var flies = [zFb, zFf];
    for (i = 0; i < 2; i++) {
      poly('mfly', MD.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b'), rafPts, 'xy', flies[i], st);
      seatScrews('screw-mfly', flies[i]);
    }
    coat += 2 * 2 * (st + rd) * rafL;   /* the fly rafters */
    /* THE GABLE STUDS over each gable's top plate (every 30 cm, US 12 in.,
       from the low side), up to the end rafter's underside; a toe screw each
       side at the foot, one up into the end rafter at the head */
    var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0;
    for (sz = -1; sz <= 1; sz += 2) {
      for (k = 1; ; k++) {
        var gx = xh - k * gsp, gx0 = gx - st / 2, gx1 = gx + st / 2;
        if (gx0 < -gl + 0.005) break;
        if (yR(gx1) - yPT < 0.06) continue;
        poly('gstud', PH.STUD, ceil2(yR(gx0) - yPT), 'gstud-' + (sz < 0 ? 'b' : 'f') + k, [[gx0, yPT], [gx1, yPT], [gx1, yR(gx1)], [gx0, yR(gx0)]], 'xy', sz * (L / 2 - sd / 2), sd);
        gStuds++;
        for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', PH.FRAME_SCREW, gx + e3 * st / 2, yPT + 0.04, sz * (L / 2 - sd / 2) + e3 * sd / 4, [-e3 * 0.5, -0.87, 0], len100);   /* the two toes one in front of the other (they would cross) */
        scr('screw-gstud', PH.FRAME_SCREW, gx, yR(gx) - 0.035, sz * (L / 2 - 0.005), [0, 0.95, -sz * 0.31], len100);   /* toe from the outside up into the end rafter */
      }
    }

    /* THE ROOF'S LAYERS: the OSB to past the fascia, the metal sheet over
       the underlay (one surface) with a standing seam every pan, the drip
       edge round it; the 1x6 fascia on the tails, a rake board on each fly
       rafter (and the beam's end under it) */
    var rs = P.rs, rsV = rs / cs, slope = 2 * xe / cs, zR0 = zBb, zR1 = zBf, roofLen = zR1 - zR0, ze0 = zR0 - fbT, ze1 = zR1 + fbT, eLen = ze1 - ze0;
    poly('sheath', PH.ROOF, 0, 'sheath', [[-xe, yT(-xe)], [xe, yT(xe)], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (ze0 + ze1) / 2, eLen);
    var mT = MD.SEAM_T / cs, sH = MD.SEAM_H / cs, xs = xe + 0.01;
    function yC(x) { return yT(x) + rsV + 0.002; }
    poly('mcover', MD.SEAM, 0, 'cover', [[-xs, yC(-xs)], [xs, yC(xs)], [xs, yC(xs) + mT], [-xs, yC(-xs) + mT]], 'xy', (ze0 + ze1) / 2, eLen + 0.02);
    var pan = _mdU(s, 'SEAM_PAN'), nPan = Math.max(1, Math.ceil((eLen + 0.02) / pan - 1e-9));
    for (k = 1; k < nPan; k++) {
      poly('seam', null, 0, 'seam-' + k, [[-xs, yC(-xs) + mT], [xs, yC(xs) + mT], [xs, yC(xs) + mT + sH], [-xs, yC(-xs) + mT + sH]], 'xy', ze0 - 0.01 + (eLen + 0.02) * k / nPan, MD.SEAM_W);
    }
    var tails = zr.map(function (r2) { return r2.z; }).concat(flies);
    for (sx = -1; sx <= 1; sx += 2) {
      /* the fascia: flush with the rafters' top at the tails (the high side's under the OSB's edge) */
      var yFt = (sx > 0) ? yT(xe) : yT(-xo);
      box('mfascia', MD.FASCIA, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + fbT / 2), yFt - fbW / 2, (zR0 + zR1) / 2, fbT, fbW, roofLen);
      coat += 2 * (fbT + fbW) * roofLen;
      for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yFt - fbW * (0.25 + 0.35 * k), tails[i], [-sx, 0, 0], len50);
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(sx * xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
    }
    var fbV = fbW / cs;
    for (i = 0; i < 2; i++) {
      var zc2 = (i === 0) ? zR0 - fbT / 2 : zR1 + fbT / 2;
      poly('mfascia', MD.FASCIA, ceil2(slope + fbW * tn), 'rake-' + (i ? 'f' : 'b'), [[-xe, yT(-xe) - fbV], [xe, yT(xe) - fbV], [xe, yT(xe)], [-xe, yT(-xe)]], 'xy', zc2, fbT);
      coat += 2 * (fbT + fbW) * slope;
      var fx = fixPts(-xo + 0.06, xo - 0.06, _phU(s, 'FIX_SP'));
      for (k = 0; k < fx.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, fx[k], yT(fx[k]) - fbV / 2, (i === 0) ? zR0 - fbT : zR1 + fbT, [0, 0, (i === 0) ? 1 : -1], len50);
      poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b'), [[-xe, yT(-xe) + rsV - 0.055], [xe, yT(xe) + rsV - 0.055], [xe, yT(xe) + rsV], [-xe, yT(-xe) + rsV]], 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
    }
    var roofA = slope * eLen, dripL = 2 * eLen + 2 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);

    /* THE SIDING straight on the studs, from the rims' underside up to the
       rafters' underside on the side walls, to their top on the gables
       (notched round the beams); the openings cut out */
    var y0 = yB, sidingA = 0, hW = stuff.win / 2, hWs = winW / 2;
    function ySideAt(xx) { return Math.min(yR(xx), yR((xx > 0) ? W / 2 : -W / 2)) - 0.005; }   /* under the lowest rafter underside over that face */
    for (sx = -1; sx <= 1; sx += 2) {
      var ySd = ySideAt(sx * xa), so = [[-L / 2, y0], [L / 2, y0], [L / 2, ySd], [-L / 2, ySd]], sh1 = (sx < 0) ? [[-hWs, yWS], [hWs, yWS], [hWs, yWT], [-hWs, yWT]] : null;
      poly('siding', PH.SIDING, 0, 'siding-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg, sh1 ? [sh1] : null);
      sidingA += _phArea(so) - (sh1 ? _phArea(sh1) : 0);
    }
    var y0f = porch ? yJ1 + P.dk : y0;
    for (sz = -1; sz <= 1; sz += 2) {
      var yb2 = (sz > 0) ? y0f : y0, go = [[-xa, yb2]], gh = null;
      if (sz > 0 && porch) go.push([-RO / 2, yb2], [-RO / 2, yHd], [RO / 2, yHd], [RO / 2, yb2]);   /* the door a notch over the decking */
      go.push([xa, yb2], [xa, yBms(1)], [W / 2 - bw, yBms(1)], [W / 2 - bw, yPT], [xa, yPT], [xa, yT(xa)], [-xa, yT(-xa)],
              [-xa, yPTL], [-(W / 2 - bw), yPTL], [-(W / 2 - bw), yBms(-1)], [-xa, yBms(-1)]);
      if (sz < 0) gh = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]];
      else if (!porch) gh = [[-RO / 2, yF], [RO / 2, yF], [RO / 2, yHd], [-RO / 2, yHd]];
      poly('siding', PH.SIDING, 0, 'siding-' + (sz < 0 ? 'b' : 'f'), go, 'xy', sz * (L / 2 + sg / 2), sg, gh ? [gh] : null);
      sidingA += _phArea(go) - (gh ? _phArea(gh) : 0);
    }
    coat += sidingA;
    /* THE CORNER BOARDS: two a corner -- the gable's up to under the beam
       running past it, the side's up to the side siding's top */
    var nTrim = 0;
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      var gy0 = (sz > 0) ? y0f : y0, gH = yBms(sx) - gy0, yTr = ySideAt(sx * (xa + tt)), cH = yTr - y0;
      box('trim', PH.TRIM, ceil2(gH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), gy0 + gH / 2, sz * (L / 2 + sg + tt / 2), tw, gH, tt);
      box('trim', PH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), y0 + cH / 2, sz * (L / 2 + sg - tw / 2), tt, cH, tw);
      nTrim += 2;
      coat += 2 * (tt + tw) * (cH + gH);
      var ty = fixPts(y0 + 0.08, yTr - 0.08, _phU(s, 'FIX_SP')), tyg = fixPts(gy0 + 0.08, gy0 + gH - 0.08, _phU(s, 'FIX_SP'));
      for (k = 0; k < tyg.length; k++) scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt - tw / 2), tyg[k], sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
      for (k = 0; k < ty.length; k++) scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt), ty[k], sz * (L / 2 + sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
    }
    /* THE CASINGS: 1x4 round each opening on the siding (jambs, a head, a
       sill under a window); two finish nails every 40 cm */
    function casing(id, ax, cN, o, u0, u1, v0, v1, sillToo) {
      var n0 = cN + o * tt / 2, list = [];
      list.push(['jamb-a', u0 - cw / 2, v0, v1, cw]); list.push(['jamb-b', u1 + cw / 2, v0, v1, cw]);
      list.push(['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]);
      if (sillToo) list.push(['sill', (u0 + u1) / 2, v0 - cw, v0, u1 - u0 + 2 * cw]);
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head' || c4[0] === 'sill'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        if (ax === 'x') box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        else box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], n0, yc, c4[1], tt, dy, du);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));
        pts2.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) {
            var uu = horiz ? w2 : c4[1] + e4 * cw / 4, yy = horiz ? yc + e4 * dy / 4 : w2;
            if (ax === 'x') scr('nail-trim', PH.TRIM_NAIL, uu, yy, cN + o * tt, [0, 0, -o], len32, 0.0012);
            else scr('nail-trim', PH.TRIM_NAIL, cN + o * tt, yy, uu, [-o, 0, 0], len32, 0.0012);
          }
        });
      });
    }
    casing('casing-l', 'z', -xa, -1, -hWs, hWs, yWS, yWT, true);
    casing('casing-b', 'x', -(L / 2 + sg), -1, -hW, hW, yWS, yWT, true);
    casing('casing-d', 'x', L / 2 + sg, 1, -RO / 2, RO / 2, porch ? y0f : yF, yHd, false);

    /* THE DOOR: the cottage's -- T&G boards upright on three 1x4 ledges +
       two braces inside, two strap hinges on the left, a knob, a ball catch */
    var gw = P.gw, gc = P.gc, gb = P.gb, dW = _phU(s, 'DOOR_W'), nDb = Math.max(2, Math.round(dW / gc)), lw = nDb * gc + (gw - gc);
    var dy0 = yF + _phU(s, 'DOOR_CLR'), dy1 = yHd - _phU(s, 'DOOR_CLR'), dH = dy1 - dy0, zD1 = L / 2 + sg, zD0 = zD1 - gb, zL0 = zD0 - tt;
    for (i = 0; i < nDb; i++) {
      var bxc = -lw / 2 + gw / 2 + i * gc;
      box('door', PH.TG, ceil2(dH), 'door-board-' + (i + 1), bxc - (gw - gc) / 2, (dy0 + dy1) / 2, (zD0 + zD1) / 2, gc, dH, gb);
    }
    coat += 2 * (gb + gw) * dH * nDb;
    var ledY = [dy0 + 0.12, (dy0 + dy1) / 2, dy1 - 0.12], ledW = lw - 0.04;
    for (k = 0; k < 3; k++) {
      box('ledge', PH.BOARD, ceil2(ledW), 'door-ledge-' + (k + 1), 0, ledY[k], (zD0 + zL0) / 2, ledW, cw, tt);
      coat += 2 * (tt + cw) * ledW;
      for (i = 0; i < nDb; i++) for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-door', PH.TRIM_NAIL, -lw / 2 + gw / 2 + i * gc, ledY[k] + e5 * cw / 4, zL0, [0, 0, 1], len32, 0.0012);
    }
    function braceBetween(idB, xA, yA, xB, yB2) {
      var dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
      var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('ledge', PH.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zD0 + zL0) / 2, tt);
      coat += 2 * (tt + cw) * dl;
      for (var m2 = 0; m2 < nDb; m2++) {
        var xq = -lw / 2 + gw / 2 + m2 * gc, tq = (xq - xA) / dx;
        if (tq > 0.05 && tq < 0.95) scr('nail-door', PH.TRIM_NAIL, xq, yA + dy * tq, zL0, [0, 0, 1], len32, 0.0012);
      }
    }
    braceBetween('door-brace-1', -ledW / 2 + 0.06, ledY[0] + cw / 2, ledW / 2 - 0.06, ledY[1] - cw / 2);
    braceBetween('door-brace-2', -ledW / 2 + 0.06, ledY[1] + cw / 2, ledW / 2 - 0.06, ledY[2] - cw / 2);
    var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
    for (k = 0; k < 3; k += 2) {
      var hy = ledY[k];
      hw.push({ kind: 'hinge', code: PH.HINGE, box: [-lw / 2 + hingeLen / 2, hy, zD1 + hT / 2, hingeLen, hingeW, hT], id: 'door-hinge-' + k });
      hw.push({ kind: 'hinge', code: null, box: [-RO / 2 - cw / 2, hy, zD1 + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 'door-hinge-leaf-' + k });
      hinges++;
      for (i = 0; i < 3; i++) {
        scr('screw-hinge', PH.HINGE_SCREW, -lw / 2 + 0.04 + i * 0.10, hy, zD1 + hT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', PH.HINGE_SCREW, -RO / 2 - cw / 2, hy + (i - 1) * hingeW * 0.5, zD1 + tt + hT, [0, 0, -1], len40, 0.0022);
      }
    }
    hw.push({ kind: 'knob', code: PH.KNOB, cyl: [lw / 2 - 0.07, yF + _phU(s, 'KNOB_Y'), zD1, 0.025, 0.05], id: 'door-knob' });
    hw.push({ kind: 'catch', code: PH.CATCH, box: [lw / 2 - 0.03, dy1 - 0.03, zD0 - 0.008, 0.03, 0.02, 0.016], id: 'door-catch' });

    /* the bill's quantities: timber by code (+ the boards, trims, decking by length) */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var bury = blH - yB, topY = yC(-xs) + mT + sH + 0.005;
    return {
      P: P, us: us, porch: porch, L: L, W: W, PD: PD, zF: zF, pieces: pieces, fas: fas, blocks: blocks, hw: hw, posts: posts, joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: floorA, roofA: roofA, sidingA: sidingA, capA: 0, capNails: 0, dripL: dripL, dripNails: dripNails,
      gravelM3: r3(blocks.length * bl * bl * gv), digM3: r3(blocks.length * bl * bl * (bury + gv)), hinges: hinges, shutters: 0, deckBoards: deckBoards,
      ties: 0, gStuds: gStuds, trims: nTrim, doorBoards: nDb, doorW: lw, doorH: dH, RO: RO, win: stuff.win, winW: winW,
      yB: yB, yF: yF, yPT: yPT, yPTL: yPTL, yBm: yPT - bh, yHd: yHd, yWS: yWS, ridgeTop: yT(-xe), pitch: MD.PITCH, rafL: rafL, roofLen: eLen, slope: slope,
      top: topY, height: topY, depth: W, length: L + PD,
      stilt: false, slide: false, gscrews: [], uheads: [], missing: [], yD: yJ1 + P.dk, extX: W / 2, extZ: zF,
      modern: true, roofCov: 'seam', seams: nPan - 1
    };
  }
  /* ------------------------------------------------------------------
     v367 TYPE 31 -- PLAYHOUSES, variant 6: THE LITTLE BARN (Marek
     2026-10-29 19:18 "Dalsi krok" -- slot 6 of the plan). A red barn on
     the cottage's floor and walls under a gambrel roof:
       - FLOOR, WALLS: the cottage's (deck blocks, 2x6 rims + joists, OSB;
         2x4 walls 1.52 m / US 5 ft) -- the side walls with a 2x4 top plate
         (no porch, no beams);
       - ROOF: gambrel trusses at <= 60 cm (US 24 in.) -- four 2x4 segments
         each, the lower ones at 67.5 deg, the upper at 22.5 deg (the
         classic half-circle barn), joined by OSB gussets on one face
         (screwed 5x40 into each segment), the feet on the plates with a
         birdsmouth and two toe screws; gable studs under the end trusses;
         roof OSB, underlay, asphalt shingles + caps, drip edge; 1x4 fascia
         on the tails, 1x4 rake trims on the gables;
       - FRONT: double doors (two T&G leaves on strap hinges, a knob + a
         ball catch each) and over them a hayloft door (one small leaf,
         two hinges, knob, catch) in the gable;
       - BACK: a window in the gable; a window in each side wall;
       - LOFT (the info bar's toggle, on): over the front part, at the
         plates -- 2x6 joists beside the trusses (screwed into them), one
         behind the front gable's studs, OSB floor, a 2x4 guard rail each
         side of the ladder on 2x4 posts, the ladder (2x6 rails, 2x4 treads);
       - SKIN: the cottage's panel siding drawn barn red with the doors,
         white corner boards, casings, fascia and rake trims.
     The cottage's axes: X across (W), Y up, Z along (L, +Z the front). */
  var BR = {
    LEAF_BOARDS: 4, HL: 0.40, HL_US: 0.4064, EAVE: 0.10, EAVE_US: 0.1016,
    LOFT_D: 0.90, LOFT_D_US: 0.9144, LAD_W: 0.40, LAD_W_US: 0.4064, GUARD: 0.45, GUARD_US: 0.4572,
    KX: 0.62, KY: 0.85, RY: 1.10,   /* the inner knee / the peak's underside as fractions of the half span (a tall barn: 66 / 22 deg) */
    GUS_SCREW: 'FAS50040'
  };
  function _brU(s, k) { return ((s || STATE).isMetric === false && BR[k + '_US'] != null) ? BR[k + '_US'] : BR[k]; }
  function _phIsBr(s) { return ((s || STATE).variant | 0) === 31; }
  function _brLoft(s) { return _phIsBr(s) && (s || STATE).phLoft !== false; }
  function _brLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), porch = false, loft = _brLoft(s), L = _phL(s), W = _phW(s), i, j, k, sx, sz, q;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, sg = P.sg, tt = P.tt, cw = P.cw, tw = P.tw, rs = P.rs;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08,
        len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], blocks = [], hw = [], coat = 0, hinges = 0, missing = [];
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function ccw(p) { return (_gzArea(p) < 0) ? p.slice().reverse() : p; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: holes ? pts : ccw(pts), plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], m; for (m = 0; m <= n; m++) out.push(a + (b - a) * m / n); return out; }
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, m, q2;
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var f = fas[q2], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* THE HEIGHTS (the cottage's): the blocks' top, the joists' top, the floor, the plates' top */
    var yB = _phU(s, 'BLK_UP'), yJ1 = yB + jh, yF = yJ1 + P.fl, yPT = yF + _phU(s, 'WALL_H');
    var yP0 = yF + st, yGT = yPT - st, zF = L / 2;
    /* THE GAMBREL: the trusses' underside -- the lower segments from the
       seat on the plate (xh) steeply up to the inner knee K (0.62 / 0.85 of
       the half span), the upper ones gently up to the peak (1.10 of it);
       the top line the segments' depth (2x4) above, the outer knee Kt where
       the two top lines meet */
    var tn1 = BR.KY / (1 - BR.KX), tn2 = (BR.RY - BR.KY) / BR.KX, a1 = Math.atan(tn1), a2 = Math.atan(tn2), cs1 = Math.cos(a1), cs2 = Math.cos(a2);
    var dV1 = sd / cs1, dV2 = sd / cs2, seat = Math.min(sd, dV1 / (3 * tn1)), xh = W / 2 - seat;
    var xk = xh * BR.KX, yk = yPT + xh * BR.KY;
    function yU(x) { var a = Math.abs(x); return (a >= xk) ? yPT + (xh - a) * tn1 : yk + (xk - a) * tn2; }
    function xU(y) { return (y <= yk) ? xh - (y - yPT) / tn1 : xk - (y - yk) / tn2; }   /* the underside's half width at a height */
    var xkt = (xh * tn1 - xk * tn2 - (yk - yPT) - dV2 + dV1) / (tn1 - tn2);
    function yTop(x) { var a = Math.abs(x); return (a >= xkt) ? yPT + (xh - a) * tn1 + dV1 : yk + (xk - a) * tn2 + dV2; }
    var yU0 = yU(0), yT0 = yTop(0), yKt = yTop(xkt);
    var xa = W / 2 + sg, xo = xa + _brU(s, 'EAVE'), xe = xo + tt;

    /* THE FOUNDATION + FLOOR FRAME: the cottage's (no porch) */
    var bl = _phU(s, 'BLK'), blT = _phU(s, 'BLK_TOP'), blH = _phU(s, 'BLK_H'), gv = _phU(s, 'GRAVEL');
    for (sx = -1; sx <= 1; sx += 2) {
      var zb0 = -L / 2 + bl / 2, zb1 = L / 2 - bl / 2, nb = Math.max(1, Math.ceil((zb1 - zb0) / _phU(s, 'BLK_SP') - 1e-9));
      for (i = 0; i <= nb; i++) blocks.push({ x: sx * (W / 2 - jt / 2), z: zb0 + (zb1 - zb0) * i / nb, w: bl, wt: blT, y0: yB - blH, y1: yB, a: 0, id: (sx < 0 ? 'l' : 'r') + (i + 1), post: false });
      box('rim', PH.RIM, ceil2(L), 'rim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, 0, jt, jh, L);
    }
    var jw = W - 2 * jt, joists = [], jz0 = -L / 2 + jt / 2, jz1 = L / 2 - jt / 2, nj = Math.max(1, Math.ceil((jz1 - jz0) / _phU(s, 'JOIST_SP') - 1e-9));
    for (i = 0; i <= nj; i++) joists.push({ z: jz0 + (jz1 - jz0) * i / nj, w: jw, porch: false });
    for (i = 0; i < joists.length; i++) {
      q = joists[i];
      box('joist', PH.JOIST, ceil2(q.w), 'joist-' + (i + 1), 0, yB + jh / 2, q.z, q.w, jh, jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), q.z, [-sx, 0, 0], len160);
    }
    pieces.push({ kind: 'floor', code: PH.FLOOR, len: 0, id: 'floor', box: [0, yJ1 + P.fl / 2, 0, W, P.fl, L] });
    var floorA = W * L;

    /* THE WALLS: the cottage's framing; every wall a 2x4 top plate */
    var stuff = { win: _phU(s, 'WIN'), sill: _phU(s, 'WIN_SILL') }, gc = P.gc, gw = P.gw, gb = P.gb, dClr = _phU(s, 'DOOR_CLR');
    var leafW = BR.LEAF_BOARDS * gc + (gw - gc), RO = 2 * leafW + 3 * dClr;
    var yWS = yF + stuff.sill, yWT = yWS + stuff.win, yHd = yGT - jh;
    function wall(id, side, u0, u1, yTop2, opening, yPl, tpn) {   /* tpn: the top plate's two screws' offsets (n) */
      var hs = (side.ax === 'z'), plates = [], studs = _phGrid(u0, u1, _phU(s, 'STUD_SP'), st), keep = [], m, e, f2;
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var half = opening ? opening.w / 2 : 0, door = opening && opening.door;
      var oL = opening ? (door ? half + 2 * st : half + st) : 0;
      for (m = 0; m < studs.length; m++) if (!opening || Math.abs(studs[m]) > oL + st / 2 - 1e-6) keep.push(studs[m]);
      var stTop = yTop2;
      if (door) plates.push([u0, -half], [half, u1]); else plates.push([u0, u1]);
      var plateHalf = [];
      for (m = 0; m < plates.length; m++) {
        var pa = plates[m][0], pb = plates[m][1];
        bx('plate', PH.STUD, ceil2(pb - pa), id + '-plate-' + (m + 1), (pa + pb) / 2, yF + st / 2, 0, pb - pa, st, sd);
        plateHalf.push([pa, pb]);
      }
      var full = keep.slice();
      if (opening) { full.push(-(oL - st / 2), oL - st / 2); }
      full.sort(function (a, b) { return a - b; });
      for (m = 0; m < full.length; m++) {
        var u = full[m];
        bx('stud', PH.STUD, ceil2(stTop - yP0), id + '-stud-' + (m + 1), u, (yP0 + stTop) / 2, 0, st, stTop - yP0, sd);
        for (e = -1; e <= 1; e += 2) sc('screw-stud', PH.STUD_SCREW, u, yF, e * sd / 4, 0, 1, 0, len120);
        for (e = 0; e < 2; e++) sc('screw-tplate', PH.STUD_SCREW, u, yPl, tpn[e], 0, -1, 0, len120);
      }
      var crLo = (opening && !door) ? studs.filter(function (u2) { return Math.abs(u2) < half - st / 2; }) : [];
      if (opening && !door && !crLo.length) crLo = [0];
      var mem = full.concat(crLo).sort(function (a, b) { return a - b; });
      for (m = 0; m + 1 < mem.length; m++) {
        var um = (mem[m] + mem[m + 1]) / 2, onPl = plateHalf.some(function (h2) { return um > h2[0] + 0.03 && um < h2[1] - 0.03; });
        if (!(onPl && mem[m + 1] - mem[m] > 0.15)) continue;
        scrClear('screw-plate', PH.PLATE_SCREW, [um, um + 0.02, um - 0.02, um + 0.04, um - 0.04].map(function (u3) { return at(u3, yP0, sd / 2 - jt / 2); }), [0, -1, 0], len160);
      }
      if (opening && !door) {
        var hdT = yWT + sd, cr = crLo;
        bx('stud', PH.STUD, ceil2(2 * half), id + '-whead', 0, yWT + sd / 2, sd / 2 - st / 2, 2 * half, sd, st);
        bx('stud', PH.STUD, ceil2(2 * half), id + '-wsill', 0, yWS - st / 2, 0, 2 * half, st, sd);
        for (e = -1; e <= 1; e += 2) for (f2 = 0; f2 < 2; f2++) {
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWT + sd * (0.3 + 0.4 * f2), sd / 2 - st / 2, -e, 0, 0, len120);
          sc('screw-frame', PH.STUD_SCREW, e * oL, yWS - st / 2, (f2 ? 1 : -1) * sd / 4, -e, 0, 0, len120);
        }
        for (m = 0; m < cr.length; m++) {
          bx('stud', PH.STUD, ceil2(yWS - st - yP0), id + '-cripple-lo-' + (m + 1), cr[m], (yP0 + yWS - st) / 2, 0, st, yWS - st - yP0, sd);
          if (stTop - hdT > 0.03) bx('stud', PH.STUD, ceil2(stTop - hdT), id + '-cripple-hi-' + (m + 1), cr[m], (hdT + stTop) / 2, 0, st, stTop - hdT, sd);
          for (e = -1; e <= 1; e += 2) {
            sc('screw-stud', PH.STUD_SCREW, cr[m], yF, e * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', PH.STUD_SCREW, cr[m], yWS, ((e < 0) ? -0.4 : 0.1) * sd, 0, -1, 0, len120);   /* near the faces: clear of the sill's screws through the kings */
          }
          if (stTop - hdT > 0.03) for (e = 0; e < 2; e++) sc('screw-tplate', PH.STUD_SCREW, cr[m], yPl, tpn[e], 0, -1, 0, len120);
        }
      }
      if (door) {
        for (e = -1; e <= 1; e += 2) {
          var uj = e * (half + st / 2);
          bx('stud', PH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (var e2 = -1; e2 <= 1; e2 += 2) sc('screw-stud', PH.STUD_SCREW, uj, yF, e2 * sd / 4, 0, 1, 0, len120);
          for (f2 = 0; f2 < 3; f2++) sc('screw-frame', PH.FRAME_SCREW, e * (half + 2 * st), yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, len100);
          for (f2 = 0; f2 < 2; f2++) sc('screw-frame', PH.STUD_SCREW, e * oL, yHd + jh * (0.3 + 0.4 * f2), sd / 2 - jt / 2, -e, 0, 0, len120);
        }
        bx('header', PH.HEADER, ceil2(2 * (half + st)), id + '-header', 0, yHd + jh / 2, sd / 2 - jt / 2, 2 * (half + st), jh, jt);
      }
      return { studs: studs };
    }
    /* the side walls (full length, a window each, a 2x4 top plate), the gables between them (the back with a window, the front with the double door) */
    for (sx = -1; sx <= 1; sx += 2) {
      var sid = 'side-' + (sx < 0 ? 'l' : 'r');
      wall(sid, { ax: 'z', c: sx * (W / 2 - sd / 2), o: sx }, -L / 2, L / 2, yGT, { w: stuff.win }, yPT, [-0.4 * sd, -0.1 * sd]);   /* the top plate's screws on its inner half: the trusses' toe screws on the outer */
      box('tplate', PH.STUD, ceil2(L), sid + '-tplate', sx * (W / 2 - sd / 2), yPT - st / 2, 0, sd, st, L);
    }
    var gl = W / 2 - sd;
    for (sz = -1; sz <= 1; sz += 2) {
      var gid = (sz < 0) ? 'back' : 'front';
      wall(gid, { ax: 'x', c: sz * (L / 2 - sd / 2), o: sz }, -gl, gl, yGT, (sz < 0) ? { w: stuff.win } : { w: RO, door: true }, yPT, [-0.4 * sd, 0.4 * sd]);
      box('tplate', PH.STUD, ceil2(2 * gl), gid + '-tplate', 0, yPT - st / 2, sz * (L / 2 - sd / 2), 2 * gl, st, sd);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 3; k++) scr('screw-frame', PH.FRAME_SCREW, sx * (gl - st), yP0 + (yGT - yP0) * (0.2 + 0.3 * k), sz * (L / 2 - st / 2), [sx, 0, 0], len100);
    }

    /* THE TRUSSES at <= 60 cm from the back gable to the front one: the
       four segments (the tails cut plumb past the walls, a birdsmouth on
       the plate), OSB gussets at the knees and the peak on the inner face
       of the end trusses / the +Z face of the rest (the loft's joists and
       rails go on the -Z faces), two toe screws at each foot */
    var zA = -L / 2 + st / 2, zB = L / 2 - st / 2, nr = Math.max(1, Math.ceil((zB - zA) / _phU(s, 'RAF_SP') - 1e-9)), zr = [];
    for (i = 0; i <= nr; i++) zr.push({ z: zA + (zB - zA) * i / nr, gable: (i === 0 || i === nr), front: i === nr });
    function mir(pts, sx2) { var o = pts.map(function (p2) { return [sx2 * p2[0], p2[1]]; }); return (sx2 < 0) ? o.reverse() : o; }
    var lowPts = [[xk, yk], [xh, yPT], [W / 2, yPT], [W / 2, yU(W / 2)], [xo, yU(xo)], [xo, yTop(xo)], [xkt, yKt]];
    var upPts = [[0, yU0], [xk, yk], [xkt, yKt], [0, yT0]];
    function extent(pts, ang) { var ux = Math.cos(ang), uy = -Math.sin(ang), lo = 1e9, hi = -1e9; pts.forEach(function (p2) { var v = p2[0] * ux + p2[1] * uy; lo = Math.min(lo, v); hi = Math.max(hi, v); }); return hi - lo; }
    var lowL = ceil2(extent(lowPts, a1)), upL = ceil2(extent(upPts, a2));
    /* the gussets: around the knee (arms along both segments' undersides) and over the peak */
    var g1 = Math.max(0.20, (xkt - xk) / cs1 + 0.08), g2 = 0.20, gx2 = 0.18 * cs2;
    var Au = [xk + g1 * cs1, yU(xk + g1 * cs1)], At = [Au[0], Au[1] + dV1], Bu = [xk - g2 * cs2, yU(xk - g2 * cs2)], Bt = [Bu[0], Bu[1] + dV2];
    var kneeG = [Au, [xk, yk], Bu, Bt, [xkt, yKt], At], peakG = [[-gx2, yU(-gx2)], [0, yU0], [gx2, yU(gx2)], [gx2, yU(gx2) + dV2], [0, yT0], [-gx2, yU(-gx2) + dV2]];
    var gussetA = 0;
    for (i = 0; i < zr.length; i++) {
      var zt = zr[i].z, gz = zr[i].front ? -1 : 1, zg = zt + gz * (st / 2 + rs / 2), zgf = zt + gz * (st / 2 + rs);
      for (sx = -1; sx <= 1; sx += 2) {
        var sfx = (sx < 0 ? '-l' : '-r');
        poly('rafter', PH.RAFTER, lowL, 'truss-' + (i + 1) + '-low' + sfx, mir(lowPts, sx), 'xy', zt, st);
        poly('rafter', PH.RAFTER, upL, 'truss-' + (i + 1) + '-up' + sfx, mir(upPts, sx), 'xy', zt, st);
        poly('gusset', PH.ROOF, 0, 'gusset-' + (i + 1) + '-knee' + sfx, mir(kneeG, sx), 'xy', zg, rs);
        gussetA += _phArea(kneeG);
        /* the knee gusset's screws: two into each segment */
        [0.35, 0.75].forEach(function (f, fi) {
          var xl = xkt + (Au[0] - xkt) * f, xu = Bu[0] + (xk - Bu[0]) * (0.25 + 0.4 * fi);
          scr('screw-gusset', BR.GUS_SCREW, sx * xl, yU(xl) + dV1 * (0.3 + 0.4 * fi), zgf, [0, 0, -gz], len40, 0.0022);
          scr('screw-gusset', BR.GUS_SCREW, sx * xu, yU(xu) + dV2 * (0.3 + 0.4 * fi), zgf, [0, 0, -gz], len40, 0.0022);
        });
        /* the foot: a toe screw from each face down into the plate (apart, so they do not meet) */
        for (k = -1; k <= 1; k += 2) scr('screw-seat', AF.TOE, sx * (W / 2 - ((k > 0) ? 0.012 : 0.032)), yPT + 0.035, zt + k * st / 2, [0, -0.87, -k * 0.5], len80);
        [0.3, 0.7].forEach(function (f, fi) { var xp = gx2 * f; scr('screw-gusset', BR.GUS_SCREW, sx * xp, yU(xp) + dV2 * (0.35 + 0.3 * fi), zgf, [0, 0, -gz], len40, 0.0022); });
      }
      poly('gusset', PH.ROOF, 0, 'gusset-' + (i + 1) + '-peak', peakG, 'xy', zg, rs);
      gussetA += _phArea(peakG);
    }
    /* THE GABLE STUDS under each end truss (every 30 cm, US 12 in., from
       the middle); the front's hayloft opening framed between two kings
       with a flat 2x4 header and a cripple over it */
    var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0, HL = _brU(s, 'HL');
    function gstud(id, xc, zc, y0g, sz2) {
      var x0 = xc - st / 2, x1 = xc + st / 2, top = [[x1, yU(x1)]];
      if (x0 < xk && x1 > xk) top.push([xk, yU(xk)]); else if (x0 < -xk && x1 > -xk) top.push([-xk, yU(-xk)]);
      if (x0 < 0 && x1 > 0) top.push([0, yU0]);
      top.push([x0, yU(x0)]);
      top.sort(function (a, b) { return b[0] - a[0]; });
      poly('gstud', PH.STUD, ceil2(Math.max(yU(x0), yU(x1), (x0 < 0 && x1 > 0) ? yU0 : 0) - y0g), id, [[x0, y0g], [x1, y0g]].concat(top), 'xy', zc, sd);
      gStuds++;
      for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', PH.FRAME_SCREW, xc + e3 * st / 2, y0g + 0.04, zc + e3 * sd / 4, [-e3 * 0.5, -0.87, 0], len100);
      scr('screw-gstud', PH.FRAME_SCREW, xc, yU(xc) - 0.035, sz2 * (L / 2 - 0.005), [0, 0.95, -sz2 * 0.31], len100);
    }
    var hlK = HL / 2 + st / 2, yHLb = yPT + sd, yHLt = yHLb + HL;   /* the opening over a 2x4 sill on edge (near the loft floor's level) */
    for (sz = -1; sz <= 1; sz += 2) {
      var zc = sz * (L / 2 - sd / 2), tag = (sz < 0 ? 'b' : 'f');
      for (k = 1; ; k++) {
        var gx = k * gsp;
        if (gx + st / 2 > gl - st - 0.005 || yU(gx + st / 2) - yPT < 0.06) break;
        if (sz > 0 && gx - st / 2 < hlK + st / 2 + 0.01) continue;
        for (sx = -1; sx <= 1; sx += 2) gstud('gstud-' + tag + (sx < 0 ? 'l' : 'r') + k, sx * gx, zc, yPT, sz);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) gstud('gstud-hl-king-' + (sx < 0 ? 'l' : 'r'), sx * hlK, L / 2 - sd / 2, yPT, 1);
    box('gstud', PH.STUD, ceil2(HL), 'gstud-hl-sill', 0, yPT + sd / 2, L / 2 - st / 2, HL, sd, st);
    for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-gstud', PH.FRAME_SCREW, sx * (HL / 2 + st), yPT + sd * (0.55 + 0.3 * k), L / 2 - st / 2, [-sx, 0, 0], len100);
    box('gstud', PH.STUD, ceil2(HL), 'gstud-hl-header', 0, yHLt + st / 2, L / 2 - sd / 2, HL, st, sd);
    for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-gstud', PH.FRAME_SCREW, sx * (HL / 2 + st), yHLt + st / 2, L / 2 - sd / 2 + (k ? 1 : -1) * sd / 4, [-sx, 0, 0], len100);
    if (yU0 - (yHLt + st) > 0.06) gstud('gstud-hl-cripple', 0, L / 2 - sd / 2, yHLt + st, 1);

    /* THE LOFT (the toggle): at the plates over the front part -- a 2x6
       joist beside (behind) each truss there and one behind the front
       gable's studs, the OSB floor, the guard rails each side of the
       ladder on 2x4 posts, the ladder down to the floor */
    var loftA = 0, ljoists = 0, nTread = 0, yLF = yPT + jh + P.fl, zEdge = null;
    if (loft) {
      /* the edge truss: the one nearest the loft's depth whose ladder (75 deg, from the edge down to the floor) still lands 10 cm off the back wall */
      var lz0 = L / 2 - _brU(s, 'LOFT_D'), edgeI = -1, best = 1e9, ladRun = (yPT + jh + P.fl - yF) / Math.tan(PH.LAD_ANG * Math.PI / 180) + jh / Math.sin(PH.LAD_ANG * Math.PI / 180);
      for (i = 1; i < zr.length - 1; i++) {
        var dd = Math.abs(zr[i].z - lz0), zFoot = zr[i].z - st - jt / 2 - ladRun;
        if (zFoot > -L / 2 + sd + 0.10 && dd < best) { best = dd; edgeI = i; }
      }
      if (edgeI < 0) edgeI = Math.max(1, zr.length - 2);
      var lj = [{ z: L / 2 - sd - jt / 2, truss: false }];
      for (i = edgeI; i < zr.length - 1; i++) lj.push({ z: zr[i].z - st, truss: true });
      zEdge = zr[edgeI].z - st;
      lj.forEach(function (q3, qi) {
        box('ljoist', PH.JOIST, ceil2(W), 'ljoist-' + (qi + 1), 0, yPT + jh / 2, q3.z, W, jh, jt);
        ljoists++;
        for (var s4 = -1; s4 <= 1; s4 += 2) {
          if (q3.truss) for (var k4 = 0; k4 < 2; k4++) scrClear('screw-ljoist', PH.FRAME_SCREW, [[s4 * (W / 2 - 0.05), yPT + 0.07 + 0.05 * k4, q3.z - jt / 2], [s4 * (W / 2 - 0.065), yPT + 0.07 + 0.05 * k4, q3.z - jt / 2]], [0, 0, 1], len100);
          else for (var k5 = -1; k5 <= 1; k5 += 2) scr('screw-ljoist', AF.TOE, s4 * (W / 2 - ((k5 > 0) ? 0.03 : 0.065)), yPT + 0.035, q3.z + k5 * jt / 2, [0, -0.87, -k5 * 0.5], len80);
        }
      });
      /* the floor: from the edge joist's back face to the gable studs, as wide as the lower segments let it */
      var xLF = xh - (yLF - yPT) / tn1 - 0.005, zLb = zEdge - jt / 2, zLf = L / 2 - sd;
      pieces.push({ kind: 'lfloor', code: PH.FLOOR, len: 0, id: 'loft-floor', box: [0, yPT + jh + P.fl / 2, (zLb + zLf) / 2, 2 * xLF, P.fl, zLf - zLb] });
      loftA = 2 * xLF * (zLf - zLb);
      /* the guard: a post each side of the ladder behind the edge joist (two 6x160 into it), a 2x4 rail on edge from the post to the edge truss's lower segment (6x120 into both) */
      var lw = _brU(s, 'LAD_W'), yG = yLF + _brU(s, 'GUARD'), yRc = yG - sd / 2, zPo = zLb - sd / 2;
      for (sx = -1; sx <= 1; sx += 2) {
        var xp0 = sx * (lw / 2 + st / 2), tg = (sx < 0 ? 'l' : 'r');
        box('lpost', PH.STUD, ceil2(yG - yPT), 'loft-post-' + tg, xp0, (yPT + yG) / 2, zPo, st, yG - yPT, sd);
        for (k = 0; k < 2; k++) scr('screw-lpost', PH.JOIST_SCREW, xp0, yPT + 0.045 + 0.07 * k, zLb - sd, [0, 0, 1], len160);
        var xu1 = xU(yRc), xr1 = xu1 + 0.05, xr0 = lw / 2;
        box('grail', PH.STUD, ceil2(xr1 - xr0), 'loft-rail-' + tg, sx * (xr0 + xr1) / 2, yRc, zEdge, xr1 - xr0, sd, st);
        coat += 2 * (st + sd) * (xr1 - xr0) + 4 * st * (yG - yPT);
        for (k = -1; k <= 1; k += 2) {
          scr('screw-grail', PH.RAIL_SCREW, sx * (lw / 2 + st / 2), yRc + k * 0.025, zEdge + st / 2, [0, 0, -1], len120);
          scr('screw-grail', us ? PH.WPOST_SCREW_US : PH.RAIL_SCREW, sx * (xu1 + 0.025), yRc + k * 0.02, zEdge - st / 2, [0, 0, 1], us ? len80 : len120);   /* through the rail into the segment (US 6x80: two 2x4s) */
        }
      }
      /* the ladder: 2x6 rails between the posts at 75 deg from the floor up against the edge joist, 2x4 treads <= 28 cm (US 11 in.) apart, the rails screwed to the posts */
      var lAng = PH.LAD_ANG * Math.PI / 180, lct = 1 / Math.tan(lAng), lhw = jh / Math.sin(lAng), lzb = zLb;
      var lzf = function (y) { return lzb - (yLF - y) * lct; };
      for (sx = -1; sx <= 1; sx += 2) {
        poly('lrail', PH.RIM, ceil2((yLF - yF) / Math.sin(lAng) + jh * lct), 'loft-ladder-' + (sx < 0 ? 'l' : 'r'), [[lzf(yLF), yLF], [lzf(yF), yF], [lzf(yF) - lhw, yF], [lzf(yLF) - lhw, yLF]], 'zy', sx * (lw / 2 - jt / 2), jt);
        coat += 2 * (jt + jh) * (yLF - yF) / Math.sin(lAng);
        [yLF - 0.03, yPT + 0.08].forEach(function (yq) {   /* between the post's own two screws */
          var zq0 = Math.max(lzb - sd, lzf(yq) - lhw), zq1 = Math.min(lzb, lzf(yq));
          scr('screw-blrail', us ? PH.WPOST_SCREW_US : PH.RAIL_SCREW, sx * (lw / 2 - jt), yq, (zq0 + zq1) / 2, [sx, 0, 0], us ? len80 : len120);   /* through the rail into the post (US 6x80) */
        });
      }
      var nT = Math.max(2, Math.ceil((yLF - yF) / _phU(s, 'LAD_RISE') - 1e-9)), rise = (yLF - yF) / nT, twd = lw - 2 * jt;
      for (k = 1; k < nT; k++) {
        var ytc = yLF - k * rise - st / 2, ztc = lzf(ytc) - lhw / 2;
        box('tread', PH.STUD, ceil2(twd), 'loft-tread-' + k, 0, ytc, ztc, twd, st, sd);
        coat += 2 * (st + sd) * twd;
        nTread++;
        for (sx = -1; sx <= 1; sx += 2) for (var e8 = -1; e8 <= 1; e8 += 2) scr('screw-tread', PH.RAIL_SCREW, sx * lw / 2, ytc, ztc + e8 * sd / 4, [-sx, 0, 0], len120);
      }
    }

    /* THE ROOF'S LAYERS: the OSB on the top line (mitred at the knee) out
       past the rake trims, the shingles (one surface a plane, the course
       bands along the eave) + the caps over the peak, the drip edge round
       the eaves and rakes, the 1x4 fascia on the tails */
    var ze1 = L / 2 + sg + tt + 0.005, ze0 = -ze1, eLen = ze1 - ze0, rsV1 = rs / cs1, rsV2 = rs / cs2;
    var xSk = xkt + (rsV1 - rsV2) / (tn1 - tn2);   /* the OSB's outer knee */
    function ySo(x) { var a = Math.abs(x); return (a >= xSk) ? yPT + (xh - a) * tn1 + dV1 + rsV1 : yk + (xk - a) * tn2 + dV2 + rsV2; }   /* the OSB's top (the two planes meet at its outer knee) */
    for (sx = -1; sx <= 1; sx += 2) {
      var sh = [[xe, yTop(xe)], [xkt, yKt], [0, yT0], [0, yT0 + rsV2], [xSk, ySo(xSk)], [xe, yTop(xe) + rsV1]];
      poly('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), mir(sh, sx), 'xy', 0, eLen);
      /* the shingles: two quads a side (lower / upper plane), 3 mm over the OSB, the lower 1 cm past it */
      var y3 = 0.003, xs1 = xe + 0.01, pl = [[xs1, xSk, rsV1, cs1], [xSk, 0, rsV2, cs2]];
      pl.forEach(function (pp, pi) {
        var xA0 = pp[0], xA1 = pp[1], yA0 = ySo(xA0) + y3, yA1 = ySo(xA1) + y3, sl = Math.hypot(xA0 - xA1, yA0 - yA1);
        pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r') + pi,
          quad: [[sx * xA1, yA1, ze0 - 0.01], [sx * xA0, yA0, ze0 - 0.01], [sx * xA0, yA0, ze1 + 0.01], [sx * xA1, yA1, ze1 + 0.01]],
          uv: [[(ze0 - 0.01) / (8 * PH.TAB), sl / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), sl / (8 * PH.EXPO)]] });
      });
      /* the eave fascia on the tails (flush with their top) */
      var fzL = L + 2 * sg;
      box('fascia', PH.BOARD, ceil2(fzL), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yTop(xe) - cw / 2, 0, tt, cw, fzL);
      coat += 2 * (tt + cw) * fzL;
      for (i = 0; i < zr.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yTop(xe) - cw * (0.25 + 0.35 * k), zr[i].z, [-sx, 0, 0], len50);
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yTop(xe) + rsV1 - 0.0275, 0, 0.003, 0.055, eLen + 0.01] });
    }
    /* the caps over the peak (two strips) */
    for (sx = -1; sx <= 1; sx += 2) {
      var cx1 = PH.CAP_W / 2 * cs2, ycap = rsV2 + 0.008;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
        quad: [[0, yT0 + ycap, ze0], [sx * cx1, yTop(cx1) + ycap, ze0], [sx * cx1, yTop(cx1) + ycap, ze1], [0, yT0 + ycap, ze1]],
        uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
    }
    /* the rake trims (1x4 on the gables' siding under the OSB's edge, mitred at the knee) and the rake drip edge */
    var cwV1 = cw / cs1, cwV2 = cw / cs2, xTk = xkt - (cwV1 - cwV2) / (tn1 - tn2);
    var rakeL = ceil2(Math.hypot(xe - xkt, yTop(xe) - yKt) + Math.hypot(xkt, yT0 - yKt) + cw);
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var rk = [[xe, yTop(xe)], [xkt, yKt], [0, yT0], [0, yT0 - cwV2], [xTk, yk + (xk - xTk) * tn2 + dV2 - cwV2], [xe, yTop(xe) - cwV1]];
      poly('fascia', PH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), mir(rk, sx), 'xy', sz * (L / 2 + sg + tt / 2), tt);
      coat += 2 * (tt + cw) * rakeL;
      fixPts(0.10, xa - 0.03, _phU(s, 'FIX_SP')).forEach(function (xq) {
        var yq = yTop(xq) - ((xq >= xkt) ? cwV1 : cwV2) / 2;
        scr('nail-trim', PH.TRIM_NAIL, sx * xq, yq, sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
      });
      var dr = [[xe, yTop(xe) + rsV1], [xSk, ySo(xSk)], [0, yT0 + rsV2], [0, yT0 + rsV2 - 0.055], [xSk - 0.0, ySo(xSk) - 0.055], [xe, yTop(xe) + rsV1 - 0.055]];
      poly('drip', PH.DRIP, 0, 'drip-r' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), mir(dr, sx), 'xy', sz * (ze1 + 0.0015), 0.003);
    }
    var slopeL = Math.hypot(xe - xSk, yTop(xe) + rsV1 - ySo(xSk)), slopeU = Math.hypot(xSk, ySo(xSk) - (yT0 + rsV2));
    var roofA = 2 * (slopeL + slopeU) * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
    var dripL = 2 * eLen + 4 * (slopeL + slopeU), dripNails = Math.ceil(dripL / PH.DRIP_FIX);

    /* THE SIDING: the side walls up to the tails' underside (a window each),
       the gables up to the trusses' top line (the back's window, the
       front's door + hayloft openings cut out) */
    var y0 = yB, sidingA = 0, hW = stuff.win / 2, ySd = yU(xa) - 0.005;
    for (sx = -1; sx <= 1; sx += 2) {
      var so = [[-L / 2, y0], [L / 2, y0], [L / 2, ySd], [-L / 2, ySd]], sh1 = [[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]];
      poly('siding', PH.SIDING, 0, 'siding-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg, [sh1]);
      sidingA += _phArea(so) - _phArea(sh1);
    }
    for (sz = -1; sz <= 1; sz += 2) {
      var go = [[-xa, y0], [xa, y0], [xa, yTop(xa)], [xkt, yKt], [0, yT0], [-xkt, yKt], [-xa, yTop(xa)]], gh;
      if (sz < 0) gh = [[[-hW, yWS], [hW, yWS], [hW, yWT], [-hW, yWT]]];
      else gh = [[[-RO / 2, yF], [RO / 2, yF], [RO / 2, yHd], [-RO / 2, yHd]], [[-HL / 2, yHLb], [HL / 2, yHLb], [HL / 2, yHLt], [-HL / 2, yHLt]]];
      poly('siding', PH.SIDING, 0, 'siding-' + (sz < 0 ? 'b' : 'f'), go, 'xy', sz * (L / 2 + sg / 2), sg, gh);
      sidingA += _phArea(go) - gh.reduce(function (a, h3) { return a + _phArea(h3); }, 0);
    }
    coat += sidingA;
    /* THE CORNER BOARDS: two a corner, up to under the tails */
    var yTr = yU(xa + tt) - 0.005, cH = yTr - y0, nTrim = 0;
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      box('trim', PH.TRIM, ceil2(cH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), y0 + cH / 2, sz * (L / 2 + sg + tt / 2), tw, cH, tt);
      box('trim', PH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), y0 + cH / 2, sz * (L / 2 + sg - tw / 2), tt, cH, tw);
      nTrim += 2;
      coat += 4 * (tt + tw) * cH;
      var ty = fixPts(y0 + 0.08, yTr - 0.08, _phU(s, 'FIX_SP'));
      for (k = 0; k < ty.length; k++) {
        scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt - tw / 2), ty[k], sz * (L / 2 + sg + tt), [0, 0, -sz], len32, 0.0012);
        scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt), ty[k], sz * (L / 2 + sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
      }
    }
    /* THE CASINGS round each opening (1x4, two finish nails every 40 cm) */
    function casing(id, ax, cN, o, u0, u1, v0, v1, sillToo) {
      var n0 = cN + o * tt / 2, list = [];
      list.push(['jamb-a', u0 - cw / 2, v0, v1, cw]); list.push(['jamb-b', u1 + cw / 2, v0, v1, cw]);
      list.push(['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]);
      if (sillToo) list.push(['sill', (u0 + u1) / 2, v0 - cw, v0, u1 - u0 + 2 * cw]);
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head' || c4[0] === 'sill'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        if (ax === 'x') box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        else box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], n0, yc, c4[1], tt, dy, du);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));
        pts2.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) {
            var uu = horiz ? w2 : c4[1] + e4 * cw / 4, yy = horiz ? yc + e4 * dy / 4 : w2;
            if (ax === 'x') scr('nail-trim', PH.TRIM_NAIL, uu, yy, cN + o * tt, [0, 0, -o], len32, 0.0012);
            else scr('nail-trim', PH.TRIM_NAIL, cN + o * tt, yy, uu, [-o, 0, 0], len32, 0.0012);
          }
        });
      });
    }
    for (sx = -1; sx <= 1; sx += 2) casing('casing-' + (sx < 0 ? 'l' : 'r'), 'z', sx * xa, sx, -hW, hW, yWS, yWT, true);
    casing('casing-b', 'x', -(L / 2 + sg), -1, -hW, hW, yWS, yWT, true);
    casing('casing-d', 'x', L / 2 + sg, 1, -RO / 2, RO / 2, yF, yHd, false);
    casing('casing-hl', 'x', L / 2 + sg, 1, -HL / 2, HL / 2, yHLb, yHLt, true);

    /* THE DOORS: a leaf = T&G boards upright on 1x4 ledges + braces on the
       inside, two strap hinges outside (a strap on the boards, a leaf on
       the casing), a knob, a ball catch at the top; the double door's
       leaves hinge on the outer jambs, the hayloft door's on the left */
    var nDb = 0, knobs = 0, catches = 0, zD1 = L / 2 + sg, zD0 = zD1 - gb, zL0 = zD0 - tt;
    function braceBetween(idB, xA, yA, xB, yB2) {
      var dx = xB - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
      var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB + ux * ext, by0 = yB2 + uy * ext;
      var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
      pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
      if (_gzArea(pb) < 0) pb.reverse();
      poly('ledge', PH.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zD0 + zL0) / 2, tt);
      coat += 2 * (tt + cw) * dl;
      return { xA: xA, yA: yA, dx: dx, dy: dy };
    }
    function leaf(id, xc, nb2, y0d, y1d, hingeSide, nLedge, jamb, hOff) {   /* jamb: the hinge jamb's inner edge (x) -- the hinge's leaf on its casing's middle */
      /* xc the leaf's middle, hingeSide -1 / +1 (its hinges on that edge) */
      var lw2 = nb2 * gc + (gw - gc), dH2 = y1d - y0d, bx0 = xc - lw2 / 2, m;
      for (m = 0; m < nb2; m++) box('door', PH.TG, ceil2(dH2), id + '-board-' + (m + 1), bx0 + m * gc + gc / 2, (y0d + y1d) / 2, (zD0 + zD1) / 2, gc, dH2, gb);
      nDb += nb2;
      coat += 2 * (gb + gw) * dH2 * nb2;
      var ledY = (nLedge === 3) ? [y0d + 0.12, (y0d + y1d) / 2, y1d - 0.12] : [y0d + 0.09, y1d - 0.09], ledW = lw2 - 0.04;
      ledY.forEach(function (ly, li) {
        box('ledge', PH.BOARD, ceil2(ledW), id + '-ledge-' + (li + 1), xc, ly, (zD0 + zL0) / 2, ledW, cw, tt);
        coat += 2 * (tt + cw) * ledW;
        for (m = 0; m < nb2; m++) for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-door', PH.TRIM_NAIL, bx0 + m * gc + gc / 2, ly + e5 * cw / 4, zL0, [0, 0, 1], len32, 0.0012);
      });
      for (var bI = 0; nLedge === 3 && bI + 1 < ledY.length; bI++) {   /* braces on the tall leaves (the hayloft door's two ledges do) */
        /* the brace rises from the hinge side */
        var xb0 = xc + hingeSide * (ledW / 2 - 0.05), xb1 = xc - hingeSide * (ledW / 2 - 0.05);
        var br = braceBetween(id + '-brace-' + (bI + 1), xb0, ledY[bI] + cw / 2, xb1, ledY[bI + 1] - cw / 2);
        for (m = 0; m < nb2; m++) {
          var xq = bx0 + m * gc + gc / 2, tq = (xq - br.xA) / br.dx;
          if (tq > 0.08 && tq < 0.92) scr('nail-door', PH.TRIM_NAIL, xq, br.yA + br.dy * tq, zL0, [0, 0, 1], len32, 0.0012);
        }
      }
      /* the strap hinges at the outer ledges: a strap over the boards, a leaf on the casing */
      var hingeLen = Math.min(0.30, lw2 * 0.75), hingeW = 0.035, hT = 0.003, xe0 = xc + hingeSide * lw2 / 2, xcs = jamb + hingeSide * hOff;
      [ledY[0], ledY[ledY.length - 1]].forEach(function (hy, hi) {
        hw.push({ kind: 'hinge', code: PH.HINGE, box: [xe0 - hingeSide * hingeLen / 2, hy, zD1 + hT / 2, hingeLen, hingeW, hT], id: id + '-hinge-' + hi });
        hw.push({ kind: 'hinge', code: null, box: [xcs, hy, zD1 + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: id + '-hinge-leaf-' + hi });
        hinges++;
        for (var h6 = 0; h6 < 3; h6++) {
          scr('screw-hinge', PH.HINGE_SCREW, xe0 - hingeSide * (0.04 + h6 * (hingeLen - 0.06) / 2), hy, zD1 + hT, [0, 0, -1], len40, 0.0022);
          scr('screw-hinge', PH.HINGE_SCREW, xcs, hy + (h6 - 1) * hingeW * 0.5, zD1 + tt + hT, [0, 0, -1], len40, 0.0022);
        }
      });
      hw.push({ kind: 'knob', code: PH.KNOB, cyl: [xc - hingeSide * (lw2 / 2 - 0.05), Math.min(yF + _phU(s, 'KNOB_Y'), (y0d + y1d) / 2), zD1, 0.02, 0.045], id: id + '-knob' });
      hw.push({ kind: 'catch', code: PH.CATCH, box: [xc - hingeSide * (lw2 / 2 - 0.03), y1d - 0.03, zD0 - 0.008, 0.03, 0.02, 0.016], id: id + '-catch' });
      knobs++; catches++;
      return lw2;
    }
    var dy0 = yF + dClr, dy1 = yHd - dClr;
    for (sx = -1; sx <= 1; sx += 2) leaf('door-' + (sx < 0 ? 'l' : 'r'), sx * (dClr / 2 + leafW / 2), BR.LEAF_BOARDS, dy0, dy1, sx, 3, sx * RO / 2, cw / 2);   /* the hinges' leaves between the casing's nail rows (over the jack + king) */
    var nH = Math.max(2, Math.floor((HL - 2 * dClr - (gw - gc)) / gc + 1e-9));
    leaf('hayloft', 0, nH, yHLb + dClr, yHLt - dClr, -1, 2, -HL / 2, st / 2);   /* -- over the king (its ledges off the casing's nails) */

    /* the bill's quantities: timber by code (+ the boards, trims by length) */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var bury = blH - yB, topY = yT0 + rsV2 + 0.012;
    return {
      P: P, us: us, porch: false, L: L, W: W, PD: 0, zF: zF, pieces: pieces, fas: fas, blocks: blocks, hw: hw, posts: [], joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: floorA + loftA, roofA: roofA, sidingA: sidingA, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: r3(blocks.length * bl * bl * gv), digM3: r3(blocks.length * bl * bl * (bury + gv)), hinges: hinges, shutters: 0, deckBoards: 0,
      ties: 0, gStuds: gStuds, trims: nTrim, doorBoards: nDb, doorW: leafW, doorH: dy1 - dy0, RO: RO, win: stuff.win, knobs: knobs, catches: catches,
      yB: yB, yF: yF, yPT: yPT, yBm: yPT, yHd: yHd, yWS: yWS, ridgeTop: yT0, pitch: Math.round(a1 * 180 / Math.PI), rafL: lowL, roofLen: eLen, slope: slopeL + slopeU,
      top: topY, height: topY, depth: W, length: L,
      stilt: false, slide: false, gscrews: [], uheads: [], missing: missing, yD: yF, extX: W / 2, extZ: L / 2,
      barn: true, loft: loft, loftA: loftA, ljoists: ljoists, treads: nTread, gussetA: gussetA, knee: [xk, yk - yF], hl: HL, roofCov: 'shingle'
    };
  }
  /* ------------------------------------------------------------------
     v368 TYPE 32 -- PLAYHOUSES, variant 7: THE TREE FORT (Marek
     2026-10-29 20:25 "Dalsi krok" -- slot 7, the last of the plan). The
     play fort's open deck round a living tree, on posts of its own --
     nothing is fixed to the tree (it grows and sways):
       - POSTS: four 4x4 KVH10100 on ground screws in U heads (the play
         fort's), up to the fort walls' top;
       - DECK FRAME: the play fort's -- 2x6 rims bolted through the posts
         (M16 rods), 2x6 joists at <= 40 cm (US 16 in.) between the side
         rims. THE TRUNK'S OPENING in the middle, framed as an octagon round
         a circle 5 cm (US 2 in.) clear of the trunk: a trimmer joist either
         side of it, a 2x6 header between the trimmers at each edge (two
         6x160 through the trimmer into each end), a 2x6 block across each
         corner (two 6x80 toe screws at each end; a corner triangle where
         the circle is small), and where the trimmers stand wider
         apart than the joists' spacing a tail joist from each header to its
         side rim. The deck boards over the circle scribed to it -- one
         notched where 6 cm (US 2 3/8 in.) of it stays beside the circle,
         else cut through in two (the tip of a cut kept 2.5 cm / 1 in. wide)
         -- so the gap round the trunk stays 5 cm, well under the 9 cm
         (3.5 in.) a child's foot or head could go through;
       - KNEE BRACES: no roof frame stiffens the deck, so a 2x4 is lapped on
         each post's two outer faces and runs up at 45 deg under the rims
         -- two screws through it into the post, one up into the rim;
       - FORT WALLS, LADDER, SLIDE: the play fort's -- 2x4 rails, pointed
         1x6 boards, the 2x6 / 2x4 ladder at the front, the slide off the
         right side on the info bar's toggle (MISSING in the catalogue, as
         the stilt house's / the play fort's);
       - THE TREE: drawn only (the customer's own, not billed) -- its
         diameter at the deck on the slider, 15-45 cm (US 6-18 in.).
     W / L 1.80-2.40 m (US 6-8 ft), 2.10 m (US 7 ft) by default. X across
     (W), Y up, Z along (L, +Z the front with the ladder). _tfLayout(STATE)
     is the single source of the model and the bill. */
  var TF = {
    W: [1.80, 2.40], W_US: [1.8288, 2.4384], W0: 2.10, W0_US: 2.1336,
    L: [1.80, 2.40], L_US: [1.8288, 2.4384], L0: 2.10, L0_US: 2.1336,
    TRUNK: [0.15, 0.45], TRUNK_US: [0.1524, 0.4572], TRUNK0: 0.30, TRUNK0_US: 0.3048,   /* the trunk's diameter at the deck */
    CLR: 0.05, CLR_US: 0.0508,                       /* the decking's clearance round the trunk (2 in.) */
    NOTCH: 0.06, NOTCH_US: 0.0603,                   /* a board keeps its notch (one piece) with this much beside the circle (2 3/8 in.) */
    TIP: 0.025, TIP_US: 0.0254,                      /* a cut board's tip at least this wide (1 in.) */
    SLOT: 0.02, SLOT_US: 0.0191,                     /* a cut-through board's two ends this far off the middle beside the circle (3/4 in.) */
    BLOCK_MIN: 0.03,                                 /* a corner block's outer face at least 3 cm long, else a corner triangle */
    KB: 0.30, KB_US: 0.3048,                         /* the knee braces' run past the post's inner face (1 ft) */
    TREE_UP: 1.90                                    /* the trunk drawn up past the walls' top */
  };
  function _tfU(s, k) { return ((s || STATE).isMetric === false && TF[k + '_US'] != null) ? TF[k + '_US'] : TF[k]; }
  function _phIsTf(s) { return ((s || STATE).variant | 0) === 32; }
  /* the trunk's diameter: clamped to the range, on whole cm (US whole inches) */
  function _tfTrunk(s) {
    s = s || STATE;
    var R = _tfU(s, 'TRUNK'), v = +s.tfTrunk;
    if (!(isFinite(v) && v > 0)) v = _tfU(s, 'TRUNK0');
    v = Math.max(R[0], Math.min(R[1], v));
    return (s.isMetric === false) ? Math.round(v / 0.0254) * 0.0254 : Math.round(v * 100) / 100;
  }
  function _tfLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), L = _phL(s), W = _phW(s), B = _pfBoard(s), slide = _phSlide(s), i, k, e, sx, sz;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, p = P.p, tb = B.t, bwd = B.w;
    var len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len50 = us ? 0.0508 : 0.05, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], gscrews = [], uheads = [], missing = [], coat = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function ccw(pts) { var a = 0, n = pts.length, q; for (q = 0; q < n; q++) { var A = pts[q], C = pts[(q + 1) % n]; a += A[0] * C[1] - C[0] * A[1]; } return (a < 0) ? pts.slice().reverse() : pts; }
    function rod(kind, x, y, z, d, ln) { fas.push({ kind: kind, code: PH.ROD, x: x, y: y, z: z, dir: d, len: ln, r: 0.008, rod: true }); }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: ccw(pts), plane: plane, c: c, t: t, holes: null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    /* a screw at the first of its spots whose shank keeps 3 mm off every fastener placed so far (the play fort's) */
    function scrClear(kind, code, cands, d, ln, r) {
      var rr2 = r || 0.003, m, q;
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q = 0; q < fas.length && ok; q++) {
          var f = fas[q], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr2 + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* THE HEIGHTS (the play fort's): the ground screw's head and the posts'
       feet, the deck's top (its frame under the decking), the fort walls'
       top and middle rail */
    var yH = _phU(s, 'FOOT_UP'), yPB = yH + PH.U_UP;
    var yD = _phU(s, 'DECK_H'), yJ1 = yD - P.dk, yB = yJ1 - jh;
    var yG1 = yD + _phU(s, 'GUARD'), yRc = [yD + _pfU(s, 'RAIL_MID'), yG1 - sd / 2];
    var xP = W / 2 - jt - p / 2, zP = L / 2 - jt - p / 2, xPI = W / 2 - jt - p, zPI = L / 2 - jt - p;   /* the posts' centres, their inner faces */
    var ov = KF.ROD_OVER, zF = L / 2;
    var Dt = _tfTrunk(s), clr = _tfU(s, 'CLR'), rr = Dt / 2 + clr;   /* the trunk, its clearance: the opening's half length along Z */

    /* THE POSTS on their piers (the play fort's), up to the walls' top */
    function pier(x, z, id) {
      gscrews.push({ x: x, z: z, r: _phU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yPB, w: p, id: id });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr('nail-uhead', PH.UNAIL, x + sd2 * (p / 2 + PH.U_T), yPB + 0.02 + rI * 0.025, z + cI * ((sd2 < 0) ? 0.022 : 0.034), [-sd2, 0, 0], len38, 0.0019);
    }
    var posts = [];
    for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var pid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
      posts.push({ x: sx * xP, z: sz * zP, sx: sx, sz: sz, id: pid });
      pier(sx * xP, sz * zP, 'post-' + pid);
      box('post', PH.POST, ceil2(yG1 - yPB), 'post-' + pid, sx * xP, (yPB + yG1) / 2, sz * zP, p, yG1 - yPB, p);
      coat += 4 * p * (yG1 - yPB);
    }

    /* THE DECK FRAME (the play fort's): the front / back rims the full width
       on the posts' outer faces, the side rims between them, two M16 rods
       through post + rim, two 6x160 through the front / back rim into each
       side rim's end */
    var rodF = [0.30, 0.62], rodS = [0.46, 0.78], rodLen = p + ov + jt - 0.005;
    for (sz = -1; sz <= 1; sz += 2) {
      box('frim', PH.RIM, ceil2(W), 'frim-' + (sz < 0 ? 'b' : 'f'), 0, yB + jh / 2, sz * (L / 2 - jt / 2), W, jh, jt);
      coat += 2 * (jt + jh) * W;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) scr('screw-frim', PH.JOIST_SCREW, sx * (W / 2 - jt / 2), yB + jh * (k ? 0.62 : 0.18), sz * L / 2, [0, 0, -sz], len160);
        for (k = 0; k < 2; k++) rod('bolt-frim', sx * xP, yB + jh * rodF[k], sz * (zPI - ov), [0, 0, sz], rodLen);
      }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      box('frim', PH.RIM, ceil2(L - 2 * jt), 'frim-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - jt / 2), yB + jh / 2, 0, jt, jh, L - 2 * jt);
      coat += 2 * (jt + jh) * (L - 2 * jt);
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) rod('bolt-frim', sx * (xPI - ov), yB + jh * rodS[k], sz * zP, [sx, 0, 0], rodLen);
    }
    /* THE JOISTS across between the side rims: the end ones just inside the
       posts (the play fort's), the trimmers either side of the trunk's
       opening, the rest evenly between at <= 40 cm (US 16 in.) */
    var JS = _phU(s, 'JOIST_SP'), zj1 = zPI - ov - 0.01 - jt / 2, zo = rr, zT = zo + jt / 2;
    var nJ = Math.max(1, Math.ceil((zj1 - zT) / JS - 1e-9)), joists = [];
    for (i = 0; i <= nJ; i++) joists.push(-zj1 + (zj1 - zT) * i / nJ);
    for (i = nJ; i >= 0; i--) joists.push(zj1 - (zj1 - zT) * i / nJ);
    for (i = 0; i < joists.length; i++) {
      box('joist', PH.JOIST, ceil2(W - 2 * jt), 'joist-' + (i + 1), 0, yB + jh / 2, joists[i], W - 2 * jt, jh, jt);
      coat += 2 * (jt + jh) * (W - 2 * jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), joists[i], [-sx, 0, 0], len160);
    }
    /* THE OPENING'S HEADERS (2x6) between the trimmers, their inner faces
       on the circle's sides; two 6x160 through each trimmer into its ends.
       And where the trimmers stand wider apart than the joists' spacing, a
       TAIL JOIST at the middle from each header to its side rim (two 6x160
       through the rim into its end, two through the header from the
       opening) */
    var tails = (2 * zT > JS + 1e-9), nHead = 0, nTail = 0, nBlock = 0;
    for (sx = -1; sx <= 1; sx += 2) {
      var xh = sx * (rr + jt / 2), xIn = sx * rr;
      box('joist', PH.JOIST, ceil2(2 * zo), 'header-' + (sx < 0 ? 'l' : 'r'), xh, yB + jh / 2, 0, jt, jh, 2 * zo);
      coat += 2 * (jt + jh) * 2 * zo;
      nHead++;
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, xh, yB + jh * (0.3 + 0.4 * k), sz * (zo + jt), [0, 0, -sz], len160);
      if (tails) {
        var xt0 = xIn + sx * jt, xt1 = sx * (W / 2 - jt), tln = Math.abs(xt1 - xt0);
        box('joist', PH.JOIST, ceil2(tln), 'tail-' + (sx < 0 ? 'l' : 'r'), (xt0 + xt1) / 2, yB + jh / 2, 0, tln, jh, jt);
        coat += 2 * (jt + jh) * tln;
        nTail++;
        for (k = 0; k < 2; k++) {
          scr('screw-joist', PH.JOIST_SCREW, sx * W / 2, yB + jh * (0.3 + 0.4 * k), 0, [-sx, 0, 0], len160);   /* through the side rim */
          scr('screw-joist', PH.JOIST_SCREW, xIn, yB + jh * (0.3 + 0.4 * k), 0, [sx, 0, 0], len160);          /* through the header, from the opening */
        }
      }
    }
    /* THE CORNER BLOCKS (2x6 on edge) across the square's corners, their
       inner faces tangent to the circle at 45 deg (the frame an octagon:
       the scribed boards' ends lie on it), the ends cut to the trimmer and
       the header (a small circle: a triangle filling the corner); two 6x80
       toe screws at each end from the inner face (heights apart from the
       header's screws) */
    var oA = rr * (Math.SQRT2 - 1), oB = oA + jt * Math.SQRT2, blkL = ceil2((rr - oA) * Math.SQRT2), len80 = us ? 0.0762 : 0.08;
    var tri = (rr - oB < TF.BLOCK_MIN);
    {
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var cbid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
        poly('tblock', PH.JOIST, blkL, 'tblock-' + cbid, tri ? [[sx * oA, sz * rr], [sx * rr, sz * rr], [sx * rr, sz * oA]] : [[sx * oA, sz * rr], [sx * oB, sz * rr], [sx * rr, sz * oB], [sx * rr, sz * oA]], 'xz', yB + jh / 2, jh);
        coat += 2 * (jt + jh) * blkL;
        nBlock++;
        for (k = 0; k < 2; k++) {
          var yTo = yB + jh * (k ? 0.55 : 0.2);
          scr('screw-tblock', AF.TOE, sx * (oA + 0.025), yTo, sz * (rr - 0.025), [0, 0, sz], len80);   /* into the trimmer */
          scr('screw-tblock', AF.TOE, sx * (rr - 0.025), yTo, sz * (oA + 0.025), [sx, 0, 0], len80);   /* into the header */
        }
      }
    }
    /* THE DECKING's boards across the width (along the length, the play
       fort's); a board that meets the posts runs between them (its ends on
       the end joists). The boards over the circle scribed to it: with
       NOTCH or more of the board beside the circle one notched piece (two
       more screws into the header beside the notch), else two pieces
       whose ends follow the circle -- beside it (a narrow rest over the
       header) SLOT off the middle, a tip by the circle's side kept TIP
       wide; two stainless screws at every joist (the trimmer, the tail)
       under each piece */
    var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((W + dg) / (P.dw + dg) - 1e-9)), deckBoards = 0, nNotch = 0, nCut = 0;
    var notchMin = _tfU(s, 'NOTCH'), tipW = _tfU(s, 'TIP'), slot = _tfU(s, 'SLOT');
    function arcZ(x) { var q = rr * rr - x * x; return (q > 0) ? Math.sqrt(q) : 0; }
    function deckScrews(cxb, w, zs, onPiece) {
      for (var zi = 0; zi < zs.length; zi++) {
        var zq = zs[zi];
        for (var k4 = -1; k4 <= 1; k4 += 2) {
          var xq = cxb + k4 * w / 4;
          if (onPiece && !onPiece(xq, zq)) continue;
          scrClear('screw-deck', PH.DECK_SCREW, [[xq, yD, zq], [xq, yD, zq + 0.012], [xq, yD, zq - 0.012], [xq + k4 * 0.012, yD, zq]], [0, -1, 0], len50);
        }
      }
    }
    for (i = 0; i < nd; i++) {
      var dx0 = -W / 2 + i * (P.dw + dg), dx1 = Math.min(W / 2, dx0 + P.dw), cxb = (dx0 + dx1) / 2, bw2 = dx1 - dx0;
      if (bw2 < 0.02) continue;
      var atPost = (dx0 < -xPI - 1e-6 && dx1 > -(W / 2 - jt) + 1e-6) || (dx1 > xPI + 1e-6 && dx0 < (W / 2 - jt) - 1e-6), dz = atPost ? zPI : L / 2;
      var zsAll = [];
      for (k = 0; k < joists.length; k++) if (joists[k] > -dz + jt / 2 - 1e-6 && joists[k] < dz - jt / 2 + 1e-6) zsAll.push(joists[k]);
      if (!atPost) { zsAll.push(-(L / 2 - jt / 2)); zsAll.push(L / 2 - jt / 2); }
      var over = (dx1 > -rr + 1e-6 && dx0 < rr - 1e-6);
      if (!over) {
        box('deck', PH.DECK, ceil2(2 * dz), 'deck-' + (i + 1), cxb, yJ1 + P.dk / 2, 0, bw2, P.dk, 2 * dz);
        coat += (2 * bw2 + 2 * P.dk) * 2 * dz;
        deckBoards++;
        if (tails && Math.abs(cxb) > rr + jt / 2 && Math.abs(cxb) < W / 2 - jt) zsAll.push(0);   /* over the tail */
        deckScrews(cxb, bw2, zsAll, null);
        continue;
      }
      var rem = Math.max(dx1 - rr, -rr - dx0, 0), side = (dx1 - rr > -rr - dx0) ? 1 : -1, NS = 24, m2, xs = [];
      if (rem >= notchMin) {
        /* one piece, notched from its inner edge to the circle's side */
        var xe = (side > 0) ? dx0 : dx1, zE = arcZ(xe), pts = [[dx0, -dz], [dx1, -dz], [dx1, dz], [dx0, dz]];
        var up = [];
        for (m2 = 0; m2 <= NS; m2++) { var xa = xe + (side * rr - xe) * m2 / NS; up.push([xa, arcZ(xa)]); }
        var notch = [[xe, zE]].concat(up.slice(1, NS)).concat([[side * rr, 0]]).concat(up.slice(1, NS).reverse().map(function (q) { return [q[0], -q[1]]; })).concat([[xe, -zE]]);
        if (side > 0) pts = [[dx0, -dz], [dx1, -dz], [dx1, dz], [dx0, dz]].concat(notch);
        else pts = [[dx1, dz], [dx0, dz], [dx0, -dz], [dx1, -dz]].concat(notch.map(function (q) { return [q[0], -q[1]]; }));
        poly('deck', PH.DECK, ceil2(2 * dz), 'deck-' + (i + 1), pts, 'xz', yJ1 + P.dk / 2, P.dk);
        coat += (2 * bw2 + 2 * P.dk) * 2 * dz;
        deckBoards++;
        nNotch++;
        deckScrews(cxb, bw2, zsAll, function (xq, zq) { return Math.abs(zq) > arcZ(xq) + 0.012; });
        for (k = -1; k <= 1; k++) scrClear('screw-deck', PH.DECK_SCREW, [[side * (rr + jt / 2), yD, k * rr / 2], [side * (rr + jt / 2), yD, k * rr / 2 + 0.012], [side * (rr + jt / 2), yD, k * rr / 2 - 0.012]], [0, -1, 0], len50);   /* into the header beside the notch */
        continue;
      }
      /* two pieces: each end on the circle (SLOT off the middle beside it),
         the tip by the circle's side kept TIP wide */
      for (m2 = 0; m2 <= NS; m2++) xs.push(dx0 + bw2 * m2 / NS);
      var tipR = (dx1 > 0.8 * rr && dx1 < rr + tipW) ? dx1 - tipW : null, tipL = (dx0 < -0.8 * rr && dx0 > -rr - tipW) ? dx0 + tipW : null;
      var zEnd = function (x) {
        var xx = x;
        if (tipR != null && x > tipR) xx = tipR;
        if (tipL != null && x < tipL) xx = tipL;
        return Math.max(slot, arcZ(xx));
      };
      var endPts = xs.map(function (x) { return [x, zEnd(x)]; }), zMin = Math.min.apply(null, endPts.map(function (q) { return q[1]; }));
      for (var sg = -1; sg <= 1; sg += 2) {
        var ptsC = [[dx0, sg * dz], [dx1, sg * dz]].concat(endPts.slice().reverse().map(function (q) { return [q[0], sg * q[1]]; }));
        poly('deck', PH.DECK, ceil2(dz - zMin), 'deck-' + (i + 1) + (sg < 0 ? 'b' : 'f'), ptsC, 'xz', yJ1 + P.dk / 2, P.dk);
        coat += (2 * bw2 + 2 * P.dk) * (dz - zMin);
        deckBoards++;
      }
      nCut++;
      deckScrews(cxb, bw2, zsAll, function (xq, zq) { return Math.abs(zq) > zEnd(xq) + 0.012; });
    }

    /* THE KNEE BRACES (2x4): one lapped on each of a post's two outer faces
       (its corner's side and its front / back), its foot cut plumb at the
       post's outer edge, up at 45 deg toward the middle to the rim's
       underside in the rim's plane; two screws through it into the post
       (6x120, US 6x100 -- the 2x4 is thinner there), a 6x160 up into the
       rim from inside its top */
    var kbk = sd / 2 * Math.SQRT2, ka = p + _tfU(s, 'KB'), kbL = ceil2((ka + kbk) * Math.SQRT2), nKb = 0;
    var lapLen = us ? len100 : len120, lapCode = us ? PH.FRAME_SCREW : PH.STUD_SCREW;
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      var bid = (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r');
      /* in the side's plane: on the post's X face, toward the middle along Z */
      var cS = sx * (W / 2 - jt + st / 2);
      var wS = (function (sz2) { return function (u, v) { return [sz2 * (L / 2 - jt) - sz2 * u, yB + v]; }; })(sz);
      poly('kbrace', PH.STUD, kbL, 'kbrace-s' + bid, [wS(0, -(ka + kbk)), wS(0, -(ka - kbk)), wS(ka - kbk, 0), wS(ka + kbk, 0)], 'zy', cS, st);
      for (k = 0; k < 2; k++) { var uS = p * (k ? 0.72 : 0.28), qS = wS(uS, uS - ka + 0.025); scr('screw-tkbrace', lapCode, sx * (W / 2 - jt + st), qS[1], qS[0], [-sx, 0, 0], lapLen); }
      var tS = wS(ka + kbk - 0.06, -0.06);
      scrClear('screw-kbrace', PH.BRACE_SCREW, [[cS, tS[1], tS[0]], [cS, tS[1], tS[0] + sz * 0.012], [cS, tS[1], tS[0] - sz * 0.012], [cS, tS[1], tS[0] + sz * 0.024]], [0, 1, 0], len160);
      /* in the front's / back's plane: on the post's Z face, toward the middle along X */
      var cF = sz * (L / 2 - jt + st / 2);
      var wF = (function (sx2) { return function (u, v) { return [sx2 * (W / 2 - jt) - sx2 * u, yB + v]; }; })(sx);
      poly('kbrace', PH.STUD, kbL, 'kbrace-f' + bid, [wF(0, -(ka + kbk)), wF(0, -(ka - kbk)), wF(ka - kbk, 0), wF(ka + kbk, 0)], 'xy', cF, st);
      for (k = 0; k < 2; k++) { var uF = p * (k ? 0.72 : 0.28), qF = wF(uF, uF - ka - 0.025); scr('screw-tkbrace', lapCode, qF[0], qF[1], sz * (L / 2 - jt + st), [0, 0, -sz], lapLen); }
      var tF = wF(ka + kbk - 0.06, -0.06);
      scrClear('screw-kbrace', PH.BRACE_SCREW, [[tF[0], tF[1], cF], [tF[0] + sx * 0.012, tF[1], cF], [tF[0] - sx * 0.012, tF[1], cF], [tF[0] + sx * 0.024, tF[1], cF]], [0, 1, 0], len160);
      coat += 2 * 2 * (st + sd) * (ka + kbk) * Math.SQRT2;
      nKb += 2;
    }

    /* THE LADDER POSTS: two 4x4 on the front rim's outer face either side
       of the opening, two M16 rods each through post + rim (the play
       fort's) */
    var ow = _phU(s, 'LAD_W'), so = _pfU(s, 'SLIDE_OPEN');
    for (sx = -1; sx <= 1; sx += 2) {
      var rpx = sx * (ow / 2 + p / 2);
      box('rpost', PH.POST, ceil2(yG1 - yB), 'rpost-' + (sx < 0 ? 'l' : 'r'), rpx, (yB + yG1) / 2, zF + p / 2, p, yG1 - yB, p);
      coat += 4 * p * (yG1 - yB);
      for (k = 0; k < 2; k++) rod('bolt-rpost', rpx, yB + jh * (0.3 + 0.4 * k), zF + p + ov, [0, 0, -1], p + jt + 2 * ov);
    }
    /* THE FORT WALLS' RAILS (the play fort's): 2x4 on edge on the posts'
       outer faces, flush with the rims' faces; the right side's middle rail
       open for the slide while it is on */
    var nRail = 0;
    function railBox(id, x, y, z, dx, dz) { box('rail', PH.STUD, ceil2(Math.max(dx, dz)), id, x, y, z, dx, sd, dz); coat += 2 * (st + sd) * Math.max(dx, dz); nRail++; }
    for (k = 0; k < 2; k++) {
      for (sz = -1; sz <= 1; sz += 2) {
        var zcr = sz * (L / 2 - jt + st / 2);
        if (sz > 0) for (sx = -1; sx <= 1; sx += 2) {
          railBox('rail-f' + (sx < 0 ? 'l' : 'r') + (k + 1), sx * (ow / 2 + W / 2) / 2, yRc[k], zcr, W / 2 - ow / 2, st);
          for (e = 0; e < 2; e++) scr('screw-rail', PH.RAIL_SCREW, sx * (ow / 2 + 0.03 + 0.04 * e), yRc[k], L / 2 - jt, [0, 0, 1], len120);   /* from inside into the ladder post */
        } else railBox('rail-b' + (k + 1), 0, yRc[k], zcr, W, st);
        for (sx = -1; sx <= 1; sx += 2) for (e = -1; e <= 1; e += 2) scr('screw-rail', PH.RAIL_SCREW, sx * xP + e * 0.025, yRc[k], sz * L / 2, [0, 0, -sz], len120);
      }
      for (sx = -1; sx <= 1; sx += 2) {
        var xcr = sx * (W / 2 - jt + st / 2), zr0 = L / 2 - jt;
        if (sx > 0 && k === 0 && slide) {
          railBox('rail-r1a', xcr, yRc[k], -(zr0 + so / 2) / 2, st, zr0 - so / 2);
          railBox('rail-r1b', xcr, yRc[k], (zr0 + so / 2) / 2, st, zr0 - so / 2);
        } else railBox('rail-' + (sx < 0 ? 'l' : 'r') + (k + 1), xcr, yRc[k], 0, st, 2 * zr0);
        for (sz = -1; sz <= 1; sz += 2) for (e = -1; e <= 1; e += 2) scr('screw-rail', PH.RAIL_SCREW, sx * W / 2, yRc[k] + e * 0.03, sz * zP, [-sx, 0, 0], len120);
      }
    }
    /* THE FORT BOARDS (the play fort's): 1x6 upright outside the rails and
       rims with a pointed head, at most 2 cm (US 3/4 in.) apart, two
       stainless screws into the rim and into each rail */
    var gMax = _pfU(s, 'BOARD_GAP'), nBoards = 0;
    function boardRun(id, ax, o, u0, u1) {
      var span = u1 - u0, n = Math.max(1, Math.ceil((span + gMax) / (bwd + gMax) - 1e-9)), g = (n > 1) ? Math.max(0.005, (span - n * bwd) / (n - 1)) : 0;
      var wB = Math.min(bwd, (span - (n - 1) * g) / n), m;
      if (n > 1) g = (span - n * wB) / (n - 1);
      var cpl = (ax === 'z') ? o * (W / 2 + tb / 2) : o * (L / 2 + tb / 2), cOut = (ax === 'z') ? o * (W / 2 + tb) : o * (L / 2 + tb);
      for (m = 0; m < n; m++) {
        var ua = u0 + m * (wB + g), ub = ua + wB, uc = (ua + ub) / 2, hd = wB / 2;
        poly('fboard', PF.BOARD, ceil2(yG1 + hd - yB), id + '-' + (m + 1), [[ua, yB], [ub, yB], [ub, yG1], [uc, yG1 + hd], [ua, yG1]], (ax === 'z') ? 'zy' : 'xy', cpl, tb);
        coat += 2 * (tb + wB) * (yG1 + hd - yB);
        nBoards++;
        [yB + jh / 2, yRc[0], yRc[1]].forEach(function (yq) {
          for (var e2 = -1; e2 <= 1; e2 += 2) {
            var cands = [], du = [0, 0.012, -0.012, 0.022, -0.022];
            du.forEach(function (dd) {
              var uq = uc + e2 * wB / 4 + dd;
              if (Math.abs(uq - uc) > wB / 2 - 0.012) return;
              cands.push((ax === 'z') ? [cOut, yq, uq] : [uq, yq, cOut]);
            });
            [0.012, -0.012].forEach(function (dy) { cands.push((ax === 'z') ? [cOut, yq + dy, uc + e2 * wB / 4] : [uc + e2 * wB / 4, yq + dy, cOut]); });
            scrClear('screw-fboard', PF.BOARD_SCREW, cands, (ax === 'z') ? [-o, 0, 0] : [0, 0, -o], len50, 0.0025);
          }
        });
      }
    }
    boardRun('fboard-l', 'z', -1, -L / 2, L / 2);
    if (slide) { boardRun('fboard-ra', 'z', 1, -L / 2, -so / 2); boardRun('fboard-rb', 'z', 1, so / 2, L / 2); }
    else boardRun('fboard-r', 'z', 1, -L / 2, L / 2);
    boardRun('fboard-b', 'x', -1, -(W / 2 + tb), W / 2 + tb);
    boardRun('fboard-fl', 'x', 1, -(W / 2 + tb), -(ow / 2 + p));
    boardRun('fboard-fr', 'x', 1, ow / 2 + p, W / 2 + tb);

    /* THE LADDER (the play fort's): 2x6 rails at 75 deg lapped on the ladder posts, 2x4 treads <= 28 cm (US 11 in.) apart */
    var lAng = PH.LAD_ANG * Math.PI / 180, lct = 1 / Math.tan(lAng), lhw = jh / Math.sin(lAng), nTread = 0;
    var lz = function (y) { return zF + (yD - y) * lct; };
    for (sx = -1; sx <= 1; sx += 2) {
      poly('lrail', PH.RIM, ceil2(yD / Math.sin(lAng) + jh * lct), 'lrail-' + (sx < 0 ? 'l' : 'r'), [[lz(yD), yD], [lz(yD) + lhw, yD], [lz(0) + lhw, 0], [lz(0), 0]], 'zy', sx * (ow / 2 - jt / 2), jt);
      coat += 2 * (jt + jh) * yD / Math.sin(lAng);
      [yD - 0.03, yB + 0.07].forEach(function (yq) {
        var zq0 = Math.max(zF, lz(yq)), zq1 = Math.min(zF + p, lz(yq) + lhw);
        scr('screw-lrail', PH.RAIL_SCREW, sx * (ow / 2 - jt), yq, (zq0 + zq1) / 2, [sx, 0, 0], len120);
      });
    }
    var nT = Math.max(2, Math.ceil(yD / _phU(s, 'LAD_RISE') - 1e-9)), rise = yD / nT, twd = ow - 2 * jt;
    for (k = 1; k < nT; k++) {
      var ytc = yD - k * rise - st / 2, ztc = lz(ytc) + lhw / 2;
      box('tread', PH.STUD, ceil2(twd), 'tread-' + k, 0, ytc, ztc, twd, st, sd);
      coat += 2 * (st + sd) * twd;
      nTread++;
      for (sx = -1; sx <= 1; sx += 2) for (e = -1; e <= 1; e += 2) scr('screw-tread', PH.RAIL_SCREW, sx * ow / 2, ytc, ztc + e * sd / 4, [-sx, 0, 0], len120);
    }
    var extZ = lz(0) + lhw, extX = W / 2 + tb;
    /* THE SLIDE (the toggle) off the right side, centred in its opening (the play fort's; MISSING) */
    if (slide) {
      var wsl = _phU(s, 'SLIDE_W'), sbd = PH.SLIDE_BED, swh = PH.SLIDE_WALL, swt = PH.SLIDE_WT;
      var sAng = PH.SLIDE_ANG * Math.PI / 180, sx0 = W / 2 - PH.SLIDE_LIP, sx1 = W / 2 + _phU(s, 'SLIDE_TOP'), syE = _phU(s, 'SLIDE_EXIT'), syT = yD + sbd;
      var sx2 = sx1 + (syT - syE) / Math.tan(sAng), sx3 = sx2 + _phU(s, 'SLIDE_RUN');
      poly('slide', null, 0, 'slide-bed', [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx3, syE - sbd], [sx3, syE], [sx2, syE], [sx1, syT], [sx0, syT]], 'xy', 0, wsl - 2 * swt);
      for (k = -1; k <= 1; k += 2)
        poly('slide', null, 0, 'slide-wall-' + (k < 0 ? 'b' : 'f'), [[sx0, yD], [sx1, yD], [sx2, syE - sbd], [sx2, 0], [sx3, 0], [sx3, syE + swh], [sx2, syE + swh], [sx1, syT + swh], [sx0, syT + swh]], 'xy', k * (wsl / 2 - swt / 2), swt);
      missing.push({ name: PH.SLIDE_NAME, qty: 1, unit: 'pcs' });
      extX = sx3;
    }

    /* the bill's quantities: timber, boards and decking by length */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    var topB = yG1 + bwd / 2;
    return {
      P: P, us: us, porch: false, L: L, W: W, PD: 0, zF: zF, pieces: pieces, fas: fas, blocks: [], hw: [], posts: posts, joists: joists, rafters: [],
      meters: m3, coat: coat, floorA: 0, roofA: 0, sidingA: 0, capA: 0, capNails: 0, dripL: 0, dripNails: 0,
      gravelM3: 0, digM3: 0, hinges: 0, shutters: 0, deckBoards: deckBoards,
      ties: 0, gStuds: 0, trims: 0, doorBoards: 0, doorW: 0, doorH: 0, RO: 0, win: 0,
      yB: yB, yF: yD, yPT: yG1, yBm: yG1, yHd: 0, yWS: 0, ridgeTop: topB, pitch: 0, rafL: 0, roofLen: 0, slope: 0,
      top: topB, height: topB, depth: W, length: L,
      treefort: true, fort: false, stilt: false, slide: slide, gscrews: gscrews, uheads: uheads, missing: missing, yD: yD, extX: extX, extZ: extZ, sPosts: posts.length, xBraces: 0,
      balusters: 0, treads: nTread, rails: nRail, fboards: nBoards, kbraces: nKb, swings: false, swing: null, yG1: yG1,
      tree: { d: Dt, clr: clr, rr: rr, x0: -rr, x1: rr, z0: -zo, z1: zo, yTop: yG1 + TF.TREE_UP, headers: nHead, tails: nTail, blocks: nBlock, notched: nNotch, cut: nCut }
    };
  }
  /* ------------------------------------------------------------------
     v389 TYPE 50 -- PLAYHOUSES 8: THE CASTLE (Marek 2026-10-30 14:42 / 14:43: "Slo by
     udelat neco jako castle? Muze byt jednoduchy tvar ale veze s hernimi
     prvky"; in the question panel: two towers + a bridge, a slide, a
     climbing wall, monkey bars). One long fort deck on eight posts:
       - TOWERS at both ends, T x T (the footprint's front / back grips,
         1.20-1.80 m, US 4-6 ft, 1.50 / 5 ft by default); the BRIDGE between
         them (the side grips: W = 2 T + the bridge, 1.20-2.40 m, US 4-8 ft,
         1.80 / 6 ft) -- the castle's wall walk; the GATE under it, open
         front to back, framed by a knee brace off each inner post;
       - POSTS (4x4) on ground screws + U heads at the towers' corners; the
         deck 1.22 m (US 4 ft) up: 2x6 rims the full length front and back
         and across both ends, M16 rods through post + rim; 2x6 joists
         across at <= 40 cm (US 16 in.) between the front and back rims (one
         beside each post on its open side), two 6x160 through the rim into
         each end; 1x6 decking along the length (the full rows in three
         pieces, butted on the joists by the inner posts; the rows at the
         posts cut between them); 2x4 knee braces lapped on the posts (the
         tree fort's) -- the outer posts' toward the tower's middle and
         along the end, the inner posts' toward the bridge (the gate);
       - WALLS: 2x4 rails on edge on the posts' faces, 1x6 boards upright
         outside them with flat heads in a crenellated line (two up, one
         down): on the bridge the crenels at the guard's height (0.90 m /
         3 ft over the deck) and the merlons 20 cm (8 in.) higher; the towers
         a crown rail and 20 cm higher (crenels 1.10 m / 3 ft 8 in.);
       - THE KEEP (the left tower): its posts on up to a 2x6 ring 1.52 m
         (US 5 ft) over the deck (screwed into the posts and each other), a
         50 deg pyramid roof -- four 2x4 common rafters, a birdsmouth on the
         ring (an 8x200 down into it), toe-screwed to a 4x4 hub at the apex;
         OSB, underlay, shingles, hip caps, drip edge on the eaves;
       - PLAY: the play fort's ladder at the keep's front, the slide off its
         left side (on the info bar's toggle, MISSING in the catalogue as
         the stilt house's); a climbing wall at the right tower's front --
         2x6 stringers at 65 deg lapped on two 4x4 posts at the opening, 1x6
         boards across them, bolt-on holds (MISSING); monkey bars off its
         right side -- the catalogue's MONKEY BAR (FMC00032, 1.50 m) from a
         2x6 header bolted across two 4x4 posts at the opening to a frame of
         two 4x4 posts on ground screws with a 2x6 header between them, its
         knee braces and 2x4 rungs to climb.
     v394 SIX CASTLES (Marek 2026-10-30 16:30): the plan on the info bar's
     top switch -- 2 TOWERS (as above) > 3 TOWERS in a row (the keep at the
     left end, two bridges of one length on the side grips, a gate under
     each) > L SHAPE (three towers: the keep at the corner, one bridge
     along X to the right tower, one along Z to the front tower; each
     arm's bridge on its own grip, the towers keep their size); the
     monkey bars on their own switch (off: the right tower's side walled
     like the rest). The rims, joists and decking run per arm: in the L
     the Z arm's joists span X between its rims, the Z rims butt the X
     arm's back rim with inside screws (no hangers -- the boards cover
     them); the ladder on the front tower's front in the L, the climbing
     wall and monkey bars always on the last tower along X.
     v398 THE TOWERS' LOOK on the second switch (Marek 2026-10-30 18:10:
     "kdyz jsem mluvil o towers, tak jsem myslel primo se strechou ...
     vysoke veze bez strechy, ale trosku rozmanitejsi vizual"): ROOF
     (every tower the keep's pyramid roof on its ring; the default) > TALL
     (no roof: the walls up to 1.60 m / US 5 ft 3 in. over the deck with
     25 cm merlons, a head rail at 1.30 m and a top rail on the posts, a
     window in each free wall -- its boards cut between the guard rail's
     top and the head rail, two boards or one (a slit) -- boards over each
     opening from its head up, toward each bridge a door: the two rails on
     the inner posts and boards over it; a 1x6 band round the top in the
     doors' accent, a 6x80 / US 5x60 through it and every other board
     into the top rail) > MIX (the keep roofed, the last tower along X
     tall, the third low) > LOW (the crown rail, no roof). The play on the
     toggle: slide > monkey bars > both > none.
     X along the castle (-X the keep), Y up, Z across (+Z the front with
     the ladder and the climbing wall). _csLayout(STATE) is the single
     source of the model and the bill. */
  var CS_TYPE = 50;   /* the castle's type (BENCH-T50): 45-49 left for the threads adding types in parallel (2026-10-30) */
  var CS = {
    T: [1.20, 1.80], T_US: [1.2192, 1.8288], T0: 1.50, T0_US: 1.524,     /* a tower's size (the footprint's L) */
    BR: [1.20, 2.40], BR_US: [1.2192, 2.4384], BR0: 1.80, BR0_US: 1.8288, /* the bridge's length between the towers */
    MERLON: 0.20, MERLON_US: 0.2032,                                     /* the merlons over the crenels */
    TOWER_UP: 0.20, TOWER_UP_US: 0.2032,                                 /* the towers' crenels over the bridge's (their crown rail's top) */
    RING: 1.52, RING_US: 1.524,                                          /* the deck's top to the keep's ring's underside */
    PITCH: 50, EAVE: 0.15, EAVE_US: 0.1524,                              /* the keep's roof */
    CW_ANG: 65, CW_FOOT: 0.10, CW_FOOT_US: 0.1016, CW_GAP: 0.02, CW_GAP_US: 0.0191, HOLD_X: 0.14, HOLD_X_US: 0.1397,   /* the climbing wall */
    MB: 1.50, MB_CODE: 'FMC00032', MB_W: 0.42, MB_W_US: 0.4191, MB_RUNG: 0.30, MB_UP: 1.00, MB_UP_US: 1.016, MB_TUBE: 0.035,   /* the monkey bars (the catalogue's 1500 mm), their top over the deck */
    MB_BRACE: 0.20, MB_BRACE_US: 0.2032, MRUNG0: 0.30, MRUNG0_US: 0.3048,
    TALL_UP: 1.60, TALL_UP_US: 1.6002, TALL_MER: 0.25, TALL_MER_US: 0.254,  /* v398 a tall tower's crenels over the deck (US 5 ft 3 in.), its merlons */
    HEAD_UP: 1.30, HEAD_UP_US: 1.2954,                                       /* -- its doors' / windows' head (the head rail's underside) over the deck (US 4 ft 3 in.) */
    HOLD_NAME: 'CLIMBING HOLD, BOLT-ON, WITH ITS T-NUT AND BOLT'
  };
  PH_TYPES.push(CS_TYPE);
  function _csU(s, k) { return ((s || STATE).isMetric === false && CS[k + '_US'] != null) ? CS[k + '_US'] : CS[k]; }
  function _phIsCs(s) { return ((s || STATE).variant | 0) === CS_TYPE; }
  /* v394 the castle's plan on the info bar's top switch (Marek 2026-10-30 16:30 "Varianta castle, udelej prepinanim dole ruzne
     varianty. 2 veze / 3 veze do L, bez ruckovaci nastavby. Celkem treba 6 variant. Nechame na tobe"): 'i2' two towers and a
     bridge (as v389), 'i3' three towers in a row (two bridges), 'l' three towers in an L (the keep at the corner, a bridge along
     X, a bridge along Z) -- and the monkey bars on their own switch: 3 x 2 = 6 castles. In the L the towers keep their size
     (STATE.csT) and each arm's bridge is on its own grip (X: phW, Z: L) */
  function _csShape(s) { var v = (s || STATE).csShape; return (v === 'i3' || v === 'l') ? v : 'i2'; }
  function _csMb(s) { return (s || STATE).csMb !== false; }
  /* v398 (Marek 2026-10-30 18:10) the towers' look on the second switch -- 'low' (the crown rail, no roof), 'roof' (every tower
     the keep's pyramid roof; the default), 'tall' (no roof: the walls up to 1.60 m over the deck, bigger merlons, a window in
     each free wall, a door head toward the bridges, a band under the crenels), 'mix' (the keep roofed, the last tower along X
     tall, the third one low) -- and the play on the toggle: 'slide' > 'mb' > 'both' > 'none' (the slide and the monkey bars) */
  function _csLook(s) { var v = (s || STATE).csLook; return (v === 'low' || v === 'tall' || v === 'mix') ? v : 'roof'; }
  function _csPlay(s) { var sl = _phSlide(s), mb = _csMb(s); return sl ? (mb ? 'both' : 'slide') : (mb ? 'mb' : 'none'); }
  function _csN(s) { return (_csShape(s) === 'i3') ? 3 : 2; }   /* the towers along X */
  function _csR4(v) { return Math.round(v * 10000) / 10000; }
  function _csT(s) { s = s || STATE; if (_csShape(s) !== 'l') return _phL(s); var R = _csU(s, 'T'), v = +s.csT; return Math.max(R[0], Math.min(R[1], (isFinite(v) && v > 0) ? v : _csU(s, 'T0'))); }
  function _csRange(s) { s = s || STATE; var R = _csU(s, 'T'); if (_csShape(s) !== 'l') return { min: R[0], max: R[1] }; var T = _csT(s), B = _csU(s, 'BR'); return { min: _csR4(2 * T + B[0]), max: _csR4(2 * T + B[1]) }; }
  function _csWRange(s) { var T = _csT(s), R = _csU(s, 'BR'), n = _csN(s); return { min: _csR4(n * T + (n - 1) * R[0]), max: _csR4(n * T + (n - 1) * R[1]) }; }
  function _csW0(s) { var n = _csN(s); return _csR4(n * _csT(s) + (n - 1) * _csU(s, 'BR0')); }
  function _csL0(s) { return (_csShape(s) === 'l') ? _csR4(2 * _csT(s) + _csU(s, 'BR0')) : _csU(s, 'T0'); }
  function _csBR(s) { s = s || STATE; var R = _csU(s, 'BR'), n = _csN(s); return Math.max(R[0], Math.min(R[1], (_phW(s) - n * _csT(s)) / (n - 1))); }
  function _csBR2(s) { s = s || STATE; if (_csShape(s) !== 'l') return _csBR(s); var R = _csU(s, 'BR'); return Math.max(R[0], Math.min(R[1], _phL(s) - 2 * _csT(s))); }
  function _csLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), shape = _csShape(s), look = _csLook(s), mbOn = _csMb(s), T = _csT(s), BR = _csBR(s), BR2 = _csBR2(s), B = _pfBoard(s), slide = _phSlide(s), i, k, sx, sz, t;
    var jt = P.jt, jh = P.jh, st = P.st, sd = P.sd, p = P.p, tb = B.t, bwd = B.w;
    var len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08, len50 = us ? 0.0508 : 0.05, len38 = us ? 0.0381 : 0.038;
    var pieces = [], fas = [], gscrews = [], uheads = [], missing = [], coat = 0, extra = {};
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function ccw(pts) { var a = 0, n = pts.length, q; for (q = 0; q < n; q++) { var A = pts[q], C = pts[(q + 1) % n]; a += A[0] * C[1] - C[0] * A[1]; } return (a < 0) ? pts.slice().reverse() : pts; }
    function rod(kind, x, y, z, d, ln) { fas.push({ kind: kind, code: PH.ROD, x: x, y: y, z: z, dir: d, len: ln, r: 0.008, rod: true }); }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t2) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: ccw(pts), plane: plane, c: c, t: t2, holes: null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fly(d) { pieces[pieces.length - 1].fly = d; }   /* the exploded view's direction of the piece just made */
    /* a screw at the first of its spots whose shank keeps 3 mm off every fastener placed so far (the play fort's) */
    function scrClear(kind, code, cands, d, ln, r) {
      var rr2 = r || 0.003, m, q, n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1, dn = [d[0] / n, d[1] / n, d[2] / n];
      for (m = 0; m < cands.length; m++) {
        var c0 = cands[m], c1 = [c0[0] + dn[0] * ln, c0[1] + dn[1] * ln, c0[2] + dn[2] * ln], ok = true;
        for (q = 0; q < fas.length && ok; q++) {
          var f = fas[q], f0 = [f.x, f.y, f.z], f1 = [f.x + f.dir[0] * f.len, f.y + f.dir[1] * f.len, f.z + f.dir[2] * f.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr2 + (f.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], dn, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], dn, ln, r);
      return false;
    }
    /* THE HEIGHTS: the ground screw's head and the posts' feet, the deck's
       top (its frame under the decking), the bridges' guard (their crenels),
       the towers' crenels a crown rail higher, the rails' centres, the
       keep's ring */
    var yH = _phU(s, 'FOOT_UP'), yPB = yH + PH.U_UP;
    var yD = _phU(s, 'DECK_H'), yJ1 = yD - P.dk, yB = yJ1 - jh;
    var yG1 = yD + _phU(s, 'GUARD'), mer = _csU(s, 'MERLON'), yC1 = yG1 + _csU(s, 'TOWER_UP');
    var yT1 = yD + _csU(s, 'TALL_UP'), tmer = _csU(s, 'TALL_MER'), yH0 = yD + _csU(s, 'HEAD_UP');   /* v398 the tall towers' crenels, merlons, heads */
    var railY = [yD + _pfU(s, 'RAIL_MID'), yG1 - sd / 2, yC1 - sd / 2, yH0 + sd / 2, yT1 - sd / 2];   /* -- + their head rail, top rail */
    var yRb = yD + _csU(s, 'RING'), yRT = yRb + jh;
    var ov = KF.ROD_OVER;
    /* THE PLAN: the extents (X the length, Z the depth), the towers' centres
       -- in a row along X (the keep the left one), or the L's keep at the
       back left corner, a tower at the end of the X arm (B) and of the Z
       arm (C) */
    var nX = _csN(s), Xe, Ze;
    if (shape === 'l') { Xe = 2 * T + BR; Ze = 2 * T + BR2; } else { Xe = nX * T + (nX - 1) * BR; Ze = T; }
    var x0 = -Xe / 2, x1 = Xe / 2, z0 = -Ze / 2, z1 = Ze / 2, W = Xe;
    var hp = T / 2 - jt - p / 2, zPI = T / 2 - jt - p;   /* a post's centre off its tower's centre, the posts' inner faces */
    var TW = [];
    if (shape === 'l') TW = [{ x: x0 + T / 2, z: z0 + T / 2, roof: true }, { x: x1 - T / 2, z: z0 + T / 2, roof: false }, { x: x0 + T / 2, z: z1 - T / 2, roof: false }];
    else for (t = 0; t < nX; t++) TW.push({ x: x0 + T / 2 + t * (T + BR), z: 0, roof: t === 0 });
    var KT = TW[0], TB = TW[nX - 1], TC = TW[2] || null;   /* the keep, the last tower along X, the L's Z arm's tower */
    for (t = 0; t < TW.length; t++) { TW[t].look = (look === 'mix') ? ((t === 0) ? 'roof' : (TW[t] === TB) ? 'tall' : 'low') : look; TW[t].roof = (TW[t].look === 'roof'); TW[t].t = t; }   /* v398 each tower's look */

    /* THE POSTS on their piers (the stilt house's: a ground screw + U head,
       12 nails through its flanges) -- the keep's up to its ring, the other
       towers' to their crown rail */
    function pier(x, z, id, nk) {
      gscrews.push({ x: x, z: z, r: _phU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yPB, w: p, id: id });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr(nk || 'nail-uhead', PH.UNAIL, x + sd2 * (p / 2 + PH.U_T), yPB + 0.02 + rI * 0.025, z + cI * ((sd2 < 0) ? 0.022 : 0.034), [-sd2, 0, 0], len38, 0.0019);
    }
    var posts = [];
    for (t = 0; t < TW.length; t++) for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
      var tw = TW[t], px = tw.x + sx * hp, pz = tw.z + sz * hp, pid = (t + 1) + (sz < 0 ? 'b' : 'f') + (sx < 0 ? 'l' : 'r'), yTop = tw.roof ? yRT : (tw.look === 'tall') ? yT1 : yC1;   /* v398 a tall tower's to its top rail */
      posts.push({ x: px, z: pz, sx: sx, sz: sz, t: t, inner: (shape !== 'l') && ((sx > 0 && t < nX - 1) || (sx < 0 && t > 0)), id: pid });
      pier(px, pz, 'post-' + pid);
      box('post', PH.POST, ceil2(yTop - yPB), 'post-' + pid, px, (yPB + yTop) / 2, pz, p, yTop - yPB, p);
      coat += 4 * p * (yTop - yPB);
    }

    /* THE DECK FRAME: 2x6 rims on the posts' outer faces -- two M16 rods
       through post + rim at every post a rim crosses (along X at 0.30 /
       0.62 of its depth, along Z at 0.46 / 0.78: clear of each other in a
       corner post), two 6x160 through a rim into the end of each rim
       butting it. In a row: the front / back rims the full length, the end
       rims between them. In the L: the back rim the full length (the left
       rim and the X arm's end rim butting it), the front rim from the left
       rim to the X arm's end (across the keep's front: the Z arm's bridge
       starts there), the left rim from the back rim to the Z arm's end,
       the Z arm's right rim from the front rim (two 6x160 from inside
       through the front rim into its end) to the Z arm's end, the two
       arms' end rims between their side rims */
    var rodF = [0.30, 0.62], rodS = [0.46, 0.78], rodLen = p + ov + jt - 0.005, RIMS;
    if (shape === 'l') RIMS = [
      { id: 'frim-b', ax: 'x', f: z0, o: -1, a0: x0, a1: x1, joints: [x0 + jt / 2, x1 - jt / 2] },
      { id: 'frim-f', ax: 'x', f: KT.z + T / 2, o: 1, a0: x0 + jt, a1: x1, joints: [x1 - jt / 2], inJ: [KT.x + T / 2 - jt / 2] },
      { id: 'frim-l', ax: 'z', f: x0, o: -1, a0: z0 + jt, a1: z1, joints: [KT.z + T / 2 - jt / 2, z1 - jt / 2] },
      { id: 'frim-r', ax: 'z', f: x1, o: 1, a0: z0 + jt, a1: KT.z + T / 2 - jt, joints: [] },
      { id: 'frim-g', ax: 'z', f: KT.x + T / 2, o: 1, a0: KT.z + T / 2, a1: z1, joints: [z1 - jt / 2] },
      { id: 'frim-e', ax: 'x', f: z1, o: 1, a0: x0 + jt, a1: KT.x + T / 2 - jt, joints: [] }
    ];
    else RIMS = [
      { id: 'frim-b', ax: 'x', f: -T / 2, o: -1, a0: x0, a1: x1, joints: [x0 + jt / 2, x1 - jt / 2] },
      { id: 'frim-f', ax: 'x', f: T / 2, o: 1, a0: x0, a1: x1, joints: [x0 + jt / 2, x1 - jt / 2] },
      { id: 'frim-l', ax: 'z', f: x0, o: -1, a0: -T / 2 + jt, a1: T / 2 - jt, joints: [] },
      { id: 'frim-r', ax: 'z', f: x1, o: 1, a0: -T / 2 + jt, a1: T / 2 - jt, joints: [] }
    ];
    function onPlane(q, ax, f, o, a0, a1) {   /* a post whose outer face carries a rim / rail on this line */
      var pc = f - o * (jt + p / 2), alongP = (ax === 'x') ? q.x : q.z, perpP = (ax === 'x') ? q.z : q.x;
      return Math.abs(perpP - pc) < 1e-6 && alongP > a0 - 1e-6 && alongP < a1 + 1e-6;
    }
    RIMS.forEach(function (R) {
      var ln = R.a1 - R.a0, am = (R.a0 + R.a1) / 2, pc = R.f - R.o * jt / 2, q, kk;
      if (R.ax === 'x') box('frim', PH.RIM, ceil2(ln), R.id, am, yB + jh / 2, pc, ln, jh, jt);
      else box('frim', PH.RIM, ceil2(ln), R.id, pc, yB + jh / 2, am, jt, jh, ln);
      coat += 2 * (jt + jh) * ln;
      R.joints.forEach(function (a) {
        for (kk = 0; kk < 2; kk++) {
          var yj = yB + jh * ((R.ax === 'x') ? (kk ? 0.62 : 0.18) : (kk ? 0.40 : 0.14));   /* clear of the butting rim's rods (an X rim's at 0.30 / 0.62, a Z rim's at 0.46 / 0.78) */
          if (R.ax === 'x') scr('screw-frim', PH.JOIST_SCREW, a, yj, R.f, [0, 0, -R.o], len160);
          else scr('screw-frim', PH.JOIST_SCREW, R.f, yj, a, [-R.o, 0, 0], len160);
        }
      });
      (R.inJ || []).forEach(function (a) {
        for (kk = 0; kk < 2; kk++) {
          var yj = yB + jh * (kk ? 0.62 : 0.18);
          if (R.ax === 'x') scr('screw-frim', PH.JOIST_SCREW, a, yj, R.f - R.o * jt, [0, 0, R.o], len160);
          else scr('screw-frim', PH.JOIST_SCREW, R.f - R.o * jt, yj, a, [R.o, 0, 0], len160);
        }
      });
      for (q = 0; q < posts.length; q++) if (onPlane(posts[q], R.ax, R.f, R.o, R.a0, R.a1))
        for (kk = 0; kk < 2; kk++) {
          var r0 = R.f - R.o * (jt + p + ov);
          if (R.ax === 'x') rod('bolt-frim', posts[q].x, yB + jh * rodF[kk], r0, [0, 0, R.o], rodLen);
          else rod('bolt-frim', r0, yB + jh * rodS[kk], posts[q].z, [R.o, 0, 0], rodLen);
        }
    });
    /* THE JOISTS (2x6) across each arm between its side rims: one beside
       each post on its open side, the rest evenly between at <= 40 cm (US
       16 in.) -- in each tower and along each bridge; two 6x160 through the
       rim into each end. In the L the X arm's bridge starts clear of the
       screws into the Z arm's right rim, the Z arm's bridge against the
       front rim */
    var JS = _phU(s, 'JOIST_SP'), gapJ = p / 2 + 0.01 + jt / 2, jx = [], jzB = [], splitsA = [], splitsB = [];
    function fillA(arr, a, b) { var n = Math.max(1, Math.ceil((b - a) / JS - 1e-9)); for (var q = 0; q <= n; q++) arr.push(a + (b - a) * q / n); }
    if (shape === 'l') {
      var xjb = KT.x + T / 2 + jt / 2 + 0.01;
      fillA(jx, KT.x - hp + gapJ, KT.x + hp - gapJ);
      fillA(jx, xjb, TB.x - hp - gapJ);
      fillA(jx, TB.x - hp + gapJ, TB.x + hp - gapJ);
      splitsA = [xjb, TB.x - hp - gapJ];
      var zjb = KT.z + T / 2 + jt / 2 + 0.005;
      fillA(jzB, zjb, TC.z - hp - gapJ);
      fillA(jzB, TC.z - hp + gapJ, TC.z + hp - gapJ);
      splitsB = [TC.z - hp - gapJ];
    } else {
      for (t = 0; t < nX; t++) {
        fillA(jx, TW[t].x - hp + gapJ, TW[t].x + hp - gapJ);
        if (t < nX - 1) { fillA(jx, TW[t].x + hp + gapJ, TW[t + 1].x - hp - gapJ); splitsA.push(TW[t].x + hp + gapJ, TW[t + 1].x - hp - gapJ); }
      }
    }
    var zA = KT.z;   /* the X arm's centre line */
    for (i = 0; i < jx.length; i++) {
      box('joist', PH.JOIST, ceil2(T - 2 * jt), 'joist-' + (i + 1), jx[i], yB + jh / 2, zA, jt, jh, T - 2 * jt);
      coat += 2 * (jt + jh) * (T - 2 * jt);
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, jx[i], yB + jh * (0.3 + 0.4 * k), zA + sz * T / 2, [0, 0, -sz], len160);
    }
    for (i = 0; i < jzB.length; i++) {
      box('joist', PH.JOIST, ceil2(T - 2 * jt), 'joistb-' + (i + 1), KT.x, yB + jh / 2, jzB[i], T - 2 * jt, jh, jt);
      coat += 2 * (jt + jh) * (T - 2 * jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.JOIST_SCREW, KT.x + sx * T / 2, yB + jh * (0.3 + 0.4 * k), jzB[i], [-sx, 0, 0], len160);
    }
    /* THE DECKING along each arm: the full rows in pieces butted on the
       joists by the inner posts (toward the bridges), the rows at the posts
       cut between them; two stainless screws at every joist (and the end
       rims) under each piece */
    var dg = _phU(s, 'DECK_GAP'), nd = Math.max(1, Math.ceil((T + dg) / (P.dw + dg) - 1e-9)), deckBoards = 0;
    function deckRun(tag, ax, cc, a0, a1, jl, splits, pa, sup0, sup1) {
      var M = (ax === 'x') ? function (a, b) { return [a, cc + b]; } : function (a, b) { return [cc + b, a]; };
      function deckPiece(id, u0, u1, b0, b1) {
        var ln = u1 - u0, wq = b1 - b0, bc = (b0 + b1) / 2, sup = [], q, mc = M((u0 + u1) / 2, bc);
        if (ln < 0.10) return;
        if (ax === 'x') box('deck', PH.DECK, ceil2(ln), id, mc[0], yJ1 + P.dk / 2, mc[1], ln, P.dk, wq);
        else box('deck', PH.DECK, ceil2(ln), id, mc[0], yJ1 + P.dk / 2, mc[1], wq, P.dk, ln);
        coat += (2 * wq + 2 * P.dk) * ln;
        deckBoards++;
        for (q = 0; q < jl.length; q++) {
          if (Math.abs(jl[q] - u0) < 1e-6) sup.push(u0 + 0.015);
          else if (Math.abs(jl[q] - u1) < 1e-6) sup.push(u1 - 0.015);
          else if (jl[q] > u0 + jt / 2 - 1e-6 && jl[q] < u1 - jt / 2 + 1e-6) sup.push(jl[q]);
        }
        if (sup0 != null && u0 <= a0 + 1e-6) sup.push(sup0);
        if (sup1 != null && u1 >= a1 - 1e-6) sup.push(sup1);
        for (q = 0; q < sup.length; q++) for (var k4 = -1; k4 <= 1; k4 += 2) {
          var aq = sup[q], bq = bc + k4 * wq / 4, C0 = M(aq, bq), C1 = M(aq + 0.012, bq), C2 = M(aq - 0.012, bq), C3 = M(aq, bq + k4 * 0.012);
          scrClear('screw-deck', PH.DECK_SCREW, [[C0[0], yD, C0[1]], [C1[0], yD, C1[1]], [C2[0], yD, C2[1]], [C3[0], yD, C3[1]]], [0, -1, 0], len50);
        }
      }
      for (var ir = 0; ir < nd; ir++) {
        var db0 = -T / 2 + ir * (P.dw + dg), db1 = Math.min(T / 2, db0 + P.dw), kk;
        if (db1 - db0 < 0.02) continue;
        var atPost = (db0 < -zPI - 1e-6 && db1 > -(T / 2 - jt) + 1e-6) || (db1 > zPI + 1e-6 && db0 < (T / 2 - jt) - 1e-6);
        if (atPost) {
          var cuts = [a0];
          for (kk = 0; kk < pa.length; kk++) { cuts.push(pa[kk] - p / 2); cuts.push(pa[kk] + p / 2); }
          cuts.push(a1);
          for (kk = 0; kk < cuts.length; kk += 2) deckPiece(tag + '-' + (ir + 1) + '-' + (kk / 2 + 1), cuts[kk], cuts[kk + 1], db0, db1);
        } else {
          var cs2 = [a0].concat(splits, [a1]);
          for (kk = 0; kk < cs2.length - 1; kk++) deckPiece(tag + '-' + (ir + 1) + 'abcdefg'.charAt(kk), cs2[kk], cs2[kk + 1], db0, db1);
        }
      }
    }
    var paA = [];
    for (i = 0; i < posts.length; i++) if (posts[i].sz > 0 && Math.abs(posts[i].z - (zA + hp)) < 1e-6) paA.push(posts[i].x);
    paA.sort(function (a, b) { return a - b; });
    deckRun('deck', 'x', zA, x0, x1, jx, splitsA, paA, x0 + jt / 2, x1 - jt / 2);
    if (shape === 'l') deckRun('deckb', 'z', KT.x, KT.z + T / 2, z1, jzB, splitsB, [TC.z - hp, TC.z + hp], null, z1 - jt / 2);

    /* THE PLAY on the towers' sides: a side's frame -- u along the face, w
       out of it, y up */
    function side(tw, nx, nz) {
      var n = nx || nz, face = (nx ? tw.x : tw.z) + n * T / 2, uc = nx ? tw.z : tw.x;
      return {
        tw: tw, n: n, nx: nx, nz: nz, face: face, uc: uc, out: [nx, 0, nz],
        P: function (u, y, w) { return nx ? [face + n * w, y, uc + u] : [uc + u, y, face + n * w]; },
        D: function (du, dy, dw) { return nx ? [n * dw, dy, du] : [du, dy, n * dw]; },
        dims: function (du, dy, dw) { return nx ? [dw, dy, du] : [du, dy, dw]; },
        pN: function (w, y) { return [face + n * w, y]; }, planeN: nx ? 'xy' : 'zy', cN: function (u) { return uc + u; },
        pT: function (u, y) { return [uc + u, y]; }, planeT: nx ? 'zy' : 'xy', cT: function (w) { return face + n * w; }
      };
    }
    var FL = (shape === 'l') ? side(TC, 0, 1) : side(KT, 0, 1);   /* the ladder: the keep's front (the L: the Z arm's end) */
    var FC = side(TB, 0, 1);                                        /* the climbing wall: the last tower's front */
    var FM = mbOn ? side(TB, 1, 0) : null;                          /* the monkey bars: off its right side */
    var FS = slide ? side(KT, -1, 0) : null;                        /* the slide: off the keep's left side */
    var ow = _phU(s, 'LAD_W'), so = _pfU(s, 'SLIDE_OPEN');

    /* THE OPENINGS' POSTS: two 4x4 on the rim's outer face either side of
       the ladder, of the climbing wall and of the monkey bars' opening --
       two M16 rods each through post + rim (clear of the joists' screws), up
       to the towers' crown rail -- set before the knee braces, whose top
       screws keep off their rods */
    function rpost(S, u, id) {
      var Q = S.P(u, (yB + yC1) / 2, p / 2), dm = S.dims(p, yC1 - yB, p), kk;
      box('rpost', PH.POST, ceil2(yC1 - yB), id, Q[0], Q[1], Q[2], dm[0], dm[1], dm[2]);
      fly(S.out);
      coat += 4 * p * (yC1 - yB);
      for (kk = 0; kk < 2; kk++) { var R0 = S.P(u, yB + jh * (kk ? 0.62 : 0.15), p + ov); rod('bolt-rpost', R0[0], R0[1], R0[2], S.D(0, 0, -1), p + jt + 2 * ov); }
    }
    for (sx = -1; sx <= 1; sx += 2) {
      rpost(FL, sx * (ow / 2 + p / 2), 'rpost-l' + (sx < 0 ? 'l' : 'r'));
      rpost(FC, sx * (ow / 2 + p / 2), 'rpost-c' + (sx < 0 ? 'l' : 'r'));
    }
    if (FM) for (sz = -1; sz <= 1; sz += 2) rpost(FM, sz * (ow / 2 + p / 2), 'rpost-m' + (sz < 0 ? 'b' : 'f'));
    /* THE KNEE BRACES (2x4, the tree fort's): lapped on a post's face (two
       screws through it into the post, 6x120 / US 6x100), up at 45 deg to
       the rim's underside in the rim's plane (a 6x160 up into the rim) --
       an outer post's along its end and along its side toward the tower's
       middle, an inner post's toward its bridge (the gate); in the L the
       keep's posts by the bridges: one toward each bridge from the back
       right and front left, the inner corner's under the Z arm's right rim */
    var kbk = sd / 2 * Math.SQRT2, ka = p + _tfU(s, 'KB'), kbL = ceil2((ka + kbk) * Math.SQRT2), nKb = 0;
    var lapLen = us ? len100 : len120, lapCode = us ? PH.FRAME_SCREW : PH.STUD_SCREW;
    function kbSide(q, xs, zd) {   /* in the Z rim's plane on the post's xs face, toward zd */
      var cS = q.x + xs * (p / 2 + st / 2), k3;
      var wS = function (u, v) { return [q.z - zd * p / 2 + zd * u, yB + v]; };
      poly('kbrace', PH.STUD, kbL, 'kbrace-s' + q.id, [wS(0, -(ka + kbk)), wS(0, -(ka - kbk)), wS(ka - kbk, 0), wS(ka + kbk, 0)], 'zy', cS, st);
      for (k3 = 0; k3 < 2; k3++) { var uS = p * (k3 ? 0.72 : 0.28), qS = wS(uS, uS - ka + 0.025); scr('screw-tkbrace', lapCode, q.x + xs * (p / 2 + st), qS[1], qS[0], [-xs, 0, 0], lapLen); }
      var tS = wS(ka + kbk - 0.06, -0.06);
      scrClear('screw-kbrace', PH.BRACE_SCREW, [[cS, tS[1], tS[0]], [cS, tS[1], tS[0] - zd * 0.012], [cS, tS[1], tS[0] + zd * 0.012], [cS, tS[1], tS[0] - zd * 0.024]], [0, 1, 0], len160);
      coat += 2 * (st + sd) * (ka + kbk) * Math.SQRT2;
      nKb++;
    }
    function kbFront(q, dir, tag, zs) {   /* in the X rim's plane on the post's zs face, toward dir */
      var cF = q.z + zs * (p / 2 + st / 2), xf = q.x - dir * p / 2, k3;
      var wF = function (u, v) { return [xf + dir * u, yB + v]; };
      poly('kbrace', PH.STUD, kbL, 'kbrace-' + tag + q.id, [wF(0, -(ka + kbk)), wF(0, -(ka - kbk)), wF(ka - kbk, 0), wF(ka + kbk, 0)], 'xy', cF, st);
      for (k3 = 0; k3 < 2; k3++) { var uF = p * (k3 ? 0.72 : 0.28), qF = wF(uF, uF - ka - 0.025); scr('screw-tkbrace', lapCode, qF[0], qF[1], q.z + zs * (p / 2 + st), [0, 0, -zs], lapLen); }
      var tF = wF(ka + kbk - 0.06, -0.06);
      scrClear('screw-kbrace', PH.BRACE_SCREW, [[tF[0], tF[1], cF], [tF[0] + dir * 0.012, tF[1], cF], [tF[0] - dir * 0.012, tF[1], cF], [tF[0] + dir * 0.024, tF[1], cF]], [0, 1, 0], len160);
      coat += 2 * (st + sd) * (ka + kbk) * Math.SQRT2;
      nKb++;
    }
    for (i = 0; i < posts.length; i++) {
      var qp = posts[i];
      if (shape === 'l') {
        if (qp.t === 0) {
          if (qp.sx < 0 && qp.sz < 0) { kbSide(qp, -1, 1); kbFront(qp, 1, 'f', -1); }
          else if (qp.sx > 0 && qp.sz < 0) kbFront(qp, 1, 'g', -1);
          else kbSide(qp, qp.sx, 1);
        } else if (qp.t === 1) {
          if (qp.sx < 0) kbFront(qp, -1, 'g', qp.sz);
          else { kbSide(qp, 1, -qp.sz); kbFront(qp, -1, 'f', qp.sz); }
        } else {
          if (qp.sz < 0) kbSide(qp, qp.sx, -1);
          else { kbSide(qp, qp.sx, -1); kbFront(qp, -qp.sx, 'f', 1); }
        }
      } else if (qp.inner) kbFront(qp, qp.sx, 'g', qp.sz);
      else { kbSide(qp, qp.sx, -qp.sz); kbFront(qp, -qp.sx, 'f', qp.sz); }
    }

    /* THE WALLS round the deck's outline, each edge with its tower lengths
       (the crown rail, the taller merlons) and its openings: the rails
       (2x4 on edge on the posts' outer faces flush with the rims' -- the
       middle one, the guard's at the bridges' crenels, the towers' crown
       rail), two 6x120 into every post they cross, two from inside into an
       opening's post at their ends; the slide's opening cuts only the
       middle rail (the play fort's). In the L the X arm's front rails end
       at the Z arm's right rails (two 6x120 from inside through them) */
    var EDGES, xE1 = KT.x + T / 2;
    function twX(list) { return list.map(function (q) { return [q.x - T / 2, q.x + T / 2, q]; }); }   /* v398 + the tower (its look) */
    function twZ(list) { return list.map(function (q) { return [q.z - T / 2, q.z + T / 2, q]; }); }
    if (shape === 'l') EDGES = {
      b: { tag: 'b', ax: 'x', f: z0, o: -1, r: [x0, x1], b: [x0 - tb, x1 + tb], tw: twX([KT, TB]), op: [] },
      f: { tag: 'f', ax: 'x', f: KT.z + T / 2, o: 1, r: [xE1 - jt + st, x1], b: [xE1 + tb, x1 + tb], tw: twX([TB]), op: [{ c: TB.x, w: ow, k: 'cw' }], cs0: true },
      r: { tag: 'r', ax: 'z', f: x1, o: 1, r: [z0 + jt, KT.z + T / 2 - jt], b: [z0, KT.z + T / 2], tw: twZ([TB]), op: FM ? [{ c: TB.z, w: ow, k: 'mb' }] : [] },
      l: { tag: 'l', ax: 'z', f: x0, o: -1, r: [z0 + jt, z1], b: [z0, z1 + tb], tw: twZ([KT, TC]), op: FS ? [{ c: KT.z, w: so, k: 'sl' }] : [] },
      g: { tag: 'g', ax: 'z', f: xE1, o: 1, r: [KT.z + T / 2 - jt - p, z1], b: [KT.z + T / 2, z1 + tb], tw: twZ([TC]), op: [] },
      e: { tag: 'e', ax: 'x', f: z1, o: 1, r: [x0 + jt, xE1 - jt], b: [x0, xE1], tw: twX([TC]), op: [{ c: TC.x, w: ow, k: 'lad' }] }
    };
    else EDGES = {
      f: { tag: 'f', ax: 'x', f: T / 2, o: 1, r: [x0, x1], b: [x0 - tb, x1 + tb], tw: twX(TW), op: [{ c: KT.x, w: ow, k: 'lad' }, { c: TB.x, w: ow, k: 'cw' }] },
      b: { tag: 'b', ax: 'x', f: -T / 2, o: -1, r: [x0, x1], b: [x0 - tb, x1 + tb], tw: twX(TW), op: [] },
      l: { tag: 'l', ax: 'z', f: x0, o: -1, r: [-(T / 2 - jt), T / 2 - jt], b: [-T / 2, T / 2], tw: [[-T / 2, T / 2, KT]], op: FS ? [{ c: 0, w: so, k: 'sl' }] : [] },
      r: { tag: 'r', ax: 'z', f: x1, o: 1, r: [-(T / 2 - jt), T / 2 - jt], b: [-T / 2, T / 2], tw: [[-T / 2, T / 2, TB]], op: FM ? [{ c: 0, w: ow, k: 'mb' }] : [] }
    };
    var RAIL_ORDER = (shape === 'l') ? ['b', 'f', 'r', 'l', 'g', 'e'] : ['f', 'b', 'l', 'r'];
    var BOARD_ORDER = (shape === 'l') ? ['l', 'r', 'f', 'b', 'g', 'e'] : ['l', 'r', 'f', 'b'];
    var nRail = 0;
    function railBox(id, x, y, z, dx, dz) { box('rail', PH.STUD, ceil2(Math.max(dx, dz)), id, x, y, z, dx, sd, dz); coat += 2 * (st + sd) * Math.max(dx, dz); nRail++; }
    function railPiece(E, id, k2, a0, a1, endA, endB, cs0) {
      var q, e2, rc = E.f - E.o * (jt - st / 2);
      if (E.ax === 'x') railBox(id, (a0 + a1) / 2, railY[k2], rc, a1 - a0, st);
      else railBox(id, rc, railY[k2], (a0 + a1) / 2, st, a1 - a0);
      for (q = 0; q < posts.length; q++) if (onPlane(posts[q], E.ax, E.f, E.o, a0, a1))
        for (e2 = -1; e2 <= 1; e2 += 2) {
          if (E.ax === 'x') scr('screw-rail', PH.RAIL_SCREW, posts[q].x + e2 * 0.025, railY[k2], E.f, [0, 0, -E.o], len120);
          else scr('screw-rail', PH.RAIL_SCREW, E.f, railY[k2] + e2 * 0.03, posts[q].z, [-E.o, 0, 0], len120);
        }
      if (endA) for (e2 = 0; e2 < 2; e2++) { if (E.ax === 'x') scr('screw-rail', PH.RAIL_SCREW, a0 + 0.03 + 0.04 * e2, railY[k2], E.f - E.o * jt, [0, 0, E.o], len120); else scr('screw-rail', PH.RAIL_SCREW, E.f - E.o * jt, railY[k2], a0 + 0.03 + 0.04 * e2, [E.o, 0, 0], len120); }
      if (endB) for (e2 = 0; e2 < 2; e2++) { if (E.ax === 'x') scr('screw-rail', PH.RAIL_SCREW, a1 - 0.03 - 0.04 * e2, railY[k2], E.f - E.o * jt, [0, 0, E.o], len120); else scr('screw-rail', PH.RAIL_SCREW, E.f - E.o * jt, railY[k2], a1 - 0.03 - 0.04 * e2, [E.o, 0, 0], len120); }
      if (cs0) for (e2 = -1; e2 <= 1; e2 += 2) scr('screw-rail', PH.RAIL_SCREW, a0 - st, railY[k2] + e2 * 0.025, rc, [1, 0, 0], len120);   /* the L's inner corner: through the Z arm's rail into this one's end */
    }
    function railsOf(E, k2) {
      /* v398 the crown rail (k2 2) on the low / roofed towers, the head and top rails (3, 4) on the tall ones -- over their openings (the doors' heads) */
      var ivs = (k2 < 2) ? [[E.r[0], E.r[1]]] : E.tw.filter(function (v) { var tl = !!v[2] && v[2].look === 'tall'; return (k2 === 2) ? !tl : tl; }).map(function (v) { return [Math.max(v[0], E.r[0]), Math.min(v[1], E.r[1])]; }).filter(function (v) { return v[1] - v[0] > 0.02; });
      var out = [];
      ivs.forEach(function (v) {
        var segs = [{ a: v[0], b: v[1], eA: false, eB: false }];
        E.op.forEach(function (O) {
          if (k2 >= 3) return;
          if (O.k === 'sl' && k2 !== 0) return;
          var oa = O.c - O.w / 2, ob = O.c + O.w / 2, nx2 = [];
          segs.forEach(function (sg) {
            if (ob <= sg.a + 1e-6 || oa >= sg.b - 1e-6) { nx2.push(sg); return; }
            if (oa > sg.a + 1e-6) nx2.push({ a: sg.a, b: oa, eA: sg.eA, eB: O.k !== 'sl' });
            if (ob < sg.b - 1e-6) nx2.push({ a: ob, b: sg.b, eA: O.k !== 'sl', eB: sg.eB });
          });
          segs = nx2;
        });
        out = out.concat(segs);
      });
      out.forEach(function (sg, j) { railPiece(E, 'rail-' + E.tag + (k2 + 1) + ((out.length > 1) ? 'abcdefgh'.charAt(j) : ''), k2, sg.a, sg.b, sg.eA, sg.eB, !!E.cs0 && Math.abs(sg.a - E.r[0]) < 1e-6); });
    }
    for (k = 0; k < 2; k++) RAIL_ORDER.forEach(function (key) { railsOf(EDGES[key], k); });
    RAIL_ORDER.forEach(function (key) { railsOf(EDGES[key], 2); });
    /* v398 THE TALL TOWERS: their head rail and top rail round the outer walls; toward each bridge a door -- the same two rails
       on the inner posts' faces (two 6x120 into each post), 1x6 boards over the door from its head up to the crenels */
    var DW = [];
    function dwOf(tw, nx, nz, tag) { var c = nx ? tw.z : tw.x; return { tag: tag, ax: nx ? 'z' : 'x', f: nx ? tw.x + nx * T / 2 : tw.z + nz * T / 2, o: nx || nz, r: [c - (T / 2 - jt) + 0.002, c + (T / 2 - jt) - 0.002], tw: tw }; }
    for (t = 0; t < TW.length; t++) {
      var twd = TW[t];
      if (twd.look !== 'tall') continue;
      if (shape === 'l') { if (t === 0) { DW.push(dwOf(twd, 1, 0, '1r')); DW.push(dwOf(twd, 0, 1, '1f')); } else if (t === 1) DW.push(dwOf(twd, -1, 0, '2l')); else DW.push(dwOf(twd, 0, -1, '3b')); }
      else { if (t > 0) DW.push(dwOf(twd, -1, 0, (t + 1) + 'l')); if (t < nX - 1) DW.push(dwOf(twd, 1, 0, (t + 1) + 'r')); }
    }
    for (k = 3; k < 5; k++) {
      RAIL_ORDER.forEach(function (key) { railsOf(EDGES[key], k); });
      DW.forEach(function (D) { railPiece(D, 'rail-d' + D.tag + (k + 1), k, D.r[0], D.r[1], false, false, false); });
    }
    /* THE CRENELLATED WALLS: 1x6 upright outside the rails and rims, at most
       2 cm (US 3/4 in.) apart, flat heads -- two boards up (the merlon), one
       down (the crenel), a merlon at both ends of a run; two stainless
       screws into the rim and into each rail behind */
    var gMax = _pfU(s, 'BOARD_GAP'), nBoards = 0, nWin = 0;
    /* v398 opt.y0: the boards' foot (over a door: its head), opt.win: a window in the run's middle (the tall towers' free walls)
       -- its boards cut at the guard rail's top and from the head rail's underside up (two boards; one in an odd run -- a slit);
       returns the boards' centres (the band's screws) */
    function boardRun(id, E, u0, u1, yS, yT2, ys, opt) {
      var span = u1 - u0, m, ax = (E.ax === 'z') ? 'z' : 'x', o = E.o, y0 = (opt && opt.y0 != null) ? opt.y0 : yB, ctr = [];
      if (span < 0.03) return ctr;
      var n = Math.max(1, Math.ceil((span + gMax) / (bwd + gMax) - 1e-9)), g = (n > 1) ? Math.max(0.005, (span - n * bwd) / (n - 1)) : 0;
      var wB = Math.min(bwd, (span - (n - 1) * g) / n);
      if (n > 1) g = (span - n * wB) / (n - 1);
      var cpl = E.f + o * tb / 2, cOut = E.f + o * tb, wA = -1, wZ = -1;
      if (opt && opt.win && n >= 4) { if (n % 2) { wA = wZ = (n - 1) / 2; } else { wA = n / 2 - 1; wZ = n / 2; } nWin++; }
      for (m = 0; m < n; m++) {
        var tall = (n <= 2) || ((n % 3 === 0) ? (m % 3 !== 1) : (m % 3 !== 2));
        var ua = u0 + m * (wB + g), ub = ua + wB, uc = (ua + ub) / 2, yt = tall ? yT2 : yS;
        ctr.push(uc);
        var segs = (wA >= 0 && m >= wA && m <= wZ) ? [[y0, yG1, 'a'], [yH0, yt, 'b']] : [[y0, yt, '']];
        segs.forEach(function (sg) {
        var yb0 = sg[0], yt0 = sg[1];
        poly('fboard', PF.BOARD, ceil2(yt0 - yb0), id + '-' + (m + 1) + sg[2], [[ua, yb0], [ub, yb0], [ub, yt0], [ua, yt0]], (ax === 'z') ? 'zy' : 'xy', cpl, tb);
        coat += 2 * (tb + wB) * (yt0 - yb0);
        nBoards++;
        ys.filter(function (yq) { return yq > yb0 + 0.02 && yq < yt0 - 0.02; }).forEach(function (yq) {
          for (var e2 = -1; e2 <= 1; e2 += 2) {
            var cands = [];
            [0, 0.012, -0.012, 0.022, -0.022].forEach(function (dd) {
              var uq = uc + e2 * wB / 4 + dd;
              if (Math.abs(uq - uc) > wB / 2 - 0.012) return;
              cands.push((ax === 'z') ? [cOut, yq, uq] : [uq, yq, cOut]);
            });
            [0.012, -0.012].forEach(function (dy) { cands.push((ax === 'z') ? [cOut, yq + dy, uc + e2 * wB / 4] : [uc + e2 * wB / 4, yq + dy, cOut]); });
            scrClear('screw-fboard', PF.BOARD_SCREW, cands, (ax === 'z') ? [-o, 0, 0] : [0, 0, -o], len50, 0.0025);
          }
        });
        });
      }
      return ctr;
    }
    var ysT = [yB + jh / 2, railY[0], railY[1], railY[2]], ysB = [yB + jh / 2, railY[0], railY[1]];
    var ysH = [yB + jh / 2, railY[0], railY[1], railY[3], railY[4]], ysU = [railY[3], railY[4]], BANDS = [];   /* v398 the tall towers' */
    function towerAt(E, u) { for (var q = 0; q < E.tw.length; q++) if (u > E.tw[q][0] - 1e-6 && u < E.tw[q][1] + 1e-6) return E.tw[q][2] || null; return null; }
    BOARD_ORDER.forEach(function (key) {
      var E = EDGES[key], cut = [E.b[0], E.b[1]], runs = [], j;
      E.tw.forEach(function (v) { [v[0], v[1]].forEach(function (a) { if (a > E.b[0] + 0.03 && a < E.b[1] - 0.03) cut.push(a); }); });
      cut.sort(function (a, b) { return a - b; });
      for (j = 0; j < cut.length - 1; j++) if (cut[j + 1] - cut[j] > 1e-6) runs.push({ a: cut[j], b: cut[j + 1], tw: towerAt(E, (cut[j] + cut[j + 1]) / 2), op: false });
      var runs0 = runs.slice();
      E.op.forEach(function (O) {
        var ex = (O.k === 'sl') ? O.w / 2 : O.w / 2 + p, oa = O.c - ex, ob = O.c + ex, nx2 = [];
        runs.forEach(function (rn) {
          if (ob <= rn.a + 1e-6 || oa >= rn.b - 1e-6) { nx2.push(rn); return; }
          if (oa > rn.a + 1e-6) nx2.push({ a: rn.a, b: oa, tw: rn.tw, op: true });
          if (ob < rn.b - 1e-6) nx2.push({ a: ob, b: rn.b, tw: rn.tw, op: true });
        });
        runs = nx2;
      });
      var cU = {};
      runs.forEach(function (rn, jj) {
        var tl = !!rn.tw && rn.tw.look === 'tall', yS0 = tl ? yT1 : rn.tw ? yC1 : yG1;
        var ctr = boardRun('fboard-' + E.tag + ((runs.length > 1) ? (jj + 1) : ''), E, rn.a, rn.b, yS0, yS0 + (tl ? tmer : mer), tl ? ysH : rn.tw ? ysT : ysB, (tl && !rn.op) ? { win: true } : null);
        if (tl) cU[rn.tw.t] = (cU[rn.tw.t] || []).concat(ctr);
      });
      /* v398 a tall tower's opening: boards from its head (the head rail) up to the crenels across it */
      E.op.forEach(function (O, jo) {
        var tw = towerAt(E, O.c);
        if (!tw || tw.look !== 'tall') return;
        var ex = (O.k === 'sl') ? O.w / 2 : O.w / 2 + p;
        cU[tw.t] = (cU[tw.t] || []).concat(boardRun('fboard-' + E.tag + 'h' + (jo + 1), E, O.c - ex, O.c + ex, yT1, yT1 + tmer, ysU, { y0: yH0 }));
      });
      runs0.forEach(function (rn) {
        if (!rn.tw || rn.tw.look !== 'tall') return;
        BANDS.push({ E: E, a: rn.a - ((rn.a <= E.b[0] + 1e-6) ? tb : 0), b: rn.b + ((rn.b >= E.b[1] - 1e-6) ? tb : 0), ctr: cU[rn.tw.t] || [], tw: rn.tw });
      });
    });
    DW.forEach(function (D) { boardRun('fboard-d' + D.tag, D, D.r[0], D.r[1], yT1, yT1 + tmer, ysU, { y0: yH0 }); });
    /* v398 THE BAND under a tall tower's crenels: a 1x6 on edge round its outer walls (past the corners over the next wall's
       band), a 6x80 through it and every other board into the top rail behind */
    var nBand = 0;
    BANDS.forEach(function (Bd, jb) {
      var E = Bd.E, o = E.o, ln = Bd.b - Bd.a, uc = (Bd.a + Bd.b) / 2, wc = E.f + o * 1.5 * tb, yc = yT1 - bwd / 2, q;
      if (E.ax === 'x') box('cband', PF.BOARD, ceil2(ln), 'cband-' + E.tag + (jb + 1), uc, yc, wc, ln, bwd, tb);
      else box('cband', PF.BOARD, ceil2(ln), 'cband-' + E.tag + (jb + 1), wc, yc, uc, tb, bwd, ln);
      fly((E.ax === 'x') ? [0, 0, o] : [o, 0, 0]);
      coat += 2 * (tb + bwd) * ln;
      nBand++;
      var rv = [Math.max(Bd.tw[(E.ax === 'x') ? 'x' : 'z'] - T / 2, E.r[0]) + 0.03, Math.min(Bd.tw[(E.ax === 'x') ? 'x' : 'z'] + T / 2, E.r[1]) - 0.03];
      var us2 = Bd.ctr.filter(function (u) { return u > Math.max(Bd.a, rv[0]) && u < Math.min(Bd.b, rv[1]); }).sort(function (a2, b2) { return a2 - b2; });
      for (q = 0; q < us2.length; q += 2) {
        var cands = [], c0 = E.f + o * 2 * tb;
        [0, 0.012, -0.012, 0.024, -0.024].forEach(function (dd) { cands.push((E.ax === 'z') ? [c0, railY[4], us2[q] + dd] : [us2[q] + dd, railY[4], c0]); });
        [0.015, -0.015].forEach(function (dy) { cands.push((E.ax === 'z') ? [c0, railY[4] + dy, us2[q]] : [us2[q], railY[4] + dy, c0]); });
        scrClear('screw-cband', us ? PH.SHEATH_SCREW : PH.RIDGE_TOE, cands, (E.ax === 'z') ? [-o, 0, 0] : [0, 0, -o], us ? 0.06 : len80);   /* US 5x60 (its thinner boards and rail) */
      }
    });

    /* THE KEEP'S ROOF: a 2x6 ring on its posts' outer faces flush with the
       rims below (the front / back ones the tower's width, the sides
       between them): two 6x120 through it into each post, two 6x160 through
       the front / back ring into each side ring's end. Four 2x4 common
       rafters at 50 deg on the axes, a birdsmouth on the ring (one 8x200
       down through the seat), their heads cut plumb against a 4x4 hub at
       the apex (two 6x80 toe screws each), the eaves 15 cm (US 6 in.) past
       the ring; OSB over them, underlay, shingles, a cap on each hip, the
       drip edge round the eaves */
    /* v398 a roof on every roofed tower (the look: all, or the keep in the mix) -- the keep's ids as before, the others' + '-t2' / '-t3' */
    var roofA = 0, dripL = 0, dripNails = 0, capA = 0, capNails = 0, topB = 0, rafL = 0, slant = 0, nRoof = 0;
    function roofOn(tw, sfx) {
      var X1 = tw.x, Z1 = tw.z, i, k, sx, sz;
      for (sz = -1; sz <= 1; sz += 2) {
        box('ring', PH.RIM, ceil2(T), 'ring-' + (sz < 0 ? 'b' : 'f') + sfx, X1, yRb + jh / 2, Z1 + sz * (T / 2 - jt / 2), T, jh, jt);
        coat += 2 * (jt + jh) * T;
        for (sx = -1; sx <= 1; sx += 2) {
          for (k = 0; k < 2; k++) scr('screw-ring', PH.JOIST_SCREW, X1 + sx * (T / 2 - jt / 2), yRb + jh * (k ? 0.62 : 0.18), Z1 + sz * T / 2, [0, 0, -sz], len160);
          for (k = 0; k < 2; k++) scr('screw-ring', PH.RAIL_SCREW, X1 + sx * hp, yRb + jh * (k ? 0.65 : 0.25), Z1 + sz * T / 2, [0, 0, -sz], len120);
        }
      }
      for (sx = -1; sx <= 1; sx += 2) {
        box('ring', PH.RIM, ceil2(T - 2 * jt), 'ring-' + (sx < 0 ? 'l' : 'r') + sfx, X1 + sx * (T / 2 - jt / 2), yRb + jh / 2, Z1, jt, jh, T - 2 * jt);
        coat += 2 * (jt + jh) * (T - 2 * jt);
        for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) scr('screw-ring', PH.RAIL_SCREW, X1 + sx * T / 2, yRb + jh * (k ? 0.85 : 0.45), Z1 + sz * hp, [-sx, 0, 0], len120);
      }
      var th = CS.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = sd / cs;
      var uo = T / 2, seat = Math.min(jt, dV / (3 * tn)), uh = uo - seat, ue = uo + _csU(s, 'EAVE'), ur = p / 2;
      var yR = function (u) { return yRT + (uh - u) * tn; }, yT = function (u) { return yR(u) + dV; };
      rafL = ceil2((ue - ur) / cs);
      var rp = [[ur, yR(ur)], [ur, yT(ur)], [ue, yT(ue)], [ue, yR(ue)], [uo, yR(uo)], [uo, yRT], [uh, yRT]];
      var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn);
      var DIRS = [[1, 0, 'r'], [-1, 0, 'l'], [0, 1, 'f'], [0, -1, 'b']];
      function at(dd, u, y, w) { return dd[0] ? [X1 + dd[0] * u, y, Z1 + w] : [X1 + w, y, Z1 + dd[1] * u]; }
      for (i = 0; i < 4; i++) {
        var dd = DIRS[i];
        if (dd[0]) poly('crafter', PH.RAFTER, rafL, 'crafter-' + dd[2] + sfx, rp.map(function (q) { return [X1 + dd[0] * q[0], q[1]]; }), 'xy', Z1, st);
        else poly('crafter', PH.RAFTER, rafL, 'crafter-' + dd[2] + sfx, rp.map(function (q) { return [Z1 + dd[1] * q[0], q[1]]; }), 'zy', X1, st);
        coat += 2 * (st + sd) * rafL;
        var um = (uh + uo) / 2, sp = at(dd, um, yT(um), 0);
        scr('screw-seat', PH.SEAT_SCREW, sp[0], sp[1], sp[2], [0, -1, 0], len200);
        var yTm = yR(ur + 0.0175) + dV / 2 + (dd[0] ? 0 : 0.01);
        for (k = -1; k <= 1; k += 2) {
          var tp = at(dd, ur + 0.035, yTm + k * 0.025, k * st / 2);
          var tdir = dd[0] ? [-dd[0] * tCo, 0, -k * tSi] : [-k * tSi, 0, -dd[1] * tCo];
          scr('screw-hub', PH.RIDGE_TOE, tp[0], tp[1], tp[2], tdir, len80);
        }
      }
      var hy0 = yR(ur) - 0.03, hy1 = yT(ur) - 0.003;
      box('hub', PH.POST, ceil2(hy1 - hy0), 'hub' + sfx, X1, (hy0 + hy1) / 2, Z1, p, hy1 - hy0, p);
      coat += 4 * p * (hy1 - hy0);
      var rs = P.rs, rsV = rs / cs, ye = yT(ue), yA = yT(0);
      slant = ue / cs;
      var CORN = [[1, -1], [1, 1], [-1, 1], [-1, -1]];
      function quadUp(Q) {   /* the winding that faces out / up */
        var a = [Q[1][0] - Q[0][0], Q[1][1] - Q[0][1], Q[1][2] - Q[0][2]], b = [Q[2][0] - Q[0][0], Q[2][1] - Q[0][1], Q[2][2] - Q[0][2]];
        return (a[2] * b[0] - a[0] * b[2] > 0);
      }
      var cornerAt = function (c, lift) { return [X1 + c[0] * ue, ye + lift, Z1 + c[1] * ue]; };
      for (i = 0; i < 4; i++) {
        var ca = CORN[i], cb = CORN[(i + 1) % 4], fid = ['r', 'f', 'l', 'b'][i];
        var along = (ca[0] === cb[0]) ? 'z' : 'x';   /* the face's eave runs along Z (the +-X faces) or X */
        var A0 = cornerAt(ca, rsV / 2), B0 = cornerAt(cb, rsV / 2), AP = [X1, yA + rsV / 2, Z1], Qs = [A0, B0, AP, AP];
        if (!quadUp(Qs)) Qs = [B0, A0, AP, AP];
        pieces.push({ kind: 'sheath', code: PH.ROOF, len: 0, id: 'sheath-' + fid + sfx, quad: Qs, uv: [[0, 0], [1, 0], [0.5, 1], [0.5, 1]] });
        var lc = rsV + 0.003, A1 = cornerAt(ca, lc), B1 = cornerAt(cb, lc), AP1 = [X1, yA + lc, Z1];
        var uA = (along === 'z') ? A1[2] - Z1 : A1[0] - X1, uB = (along === 'z') ? B1[2] - Z1 : B1[0] - X1;
        var Qc = [A1, B1, AP1, AP1], Uc = [[uA / (8 * PH.TAB), 0], [uB / (8 * PH.TAB), 0], [0, slant / (8 * PH.EXPO)], [0, slant / (8 * PH.EXPO)]];
        if (!quadUp(Qc)) { Qc = [B1, A1, AP1, AP1]; Uc = [Uc[1], Uc[0], Uc[2], Uc[3]]; }
        pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + fid + sfx, quad: Qc, uv: Uc });
      }
      var capH = PH.CAP_W / 2, ycap = rsV + 0.008, hipLen = Math.sqrt(2 * ue * ue + (yA - ye) * (yA - ye));
      for (i = 0; i < 4; i++) {
        var cc = CORN[i], C0 = [X1 + cc[0] * ue, ye + ycap, Z1 + cc[1] * ue], AQ = [X1, yA + ycap, Z1];
        var CX = [X1 + cc[0] * ue, ye + ycap, Z1 + cc[1] * (ue - capH)], CZ = [X1 + cc[0] * (ue - capH), ye + ycap, Z1 + cc[1] * ue];
        [CX, CZ].forEach(function (Cq, h2) {
          var Qh = [C0, AQ, AQ, Cq], Uh = [[0, 0], [hipLen / (8 * PH.CAP_EXPO), 0], [hipLen / (8 * PH.CAP_EXPO), 0], [0, 0.12]];
          if (!quadUp([C0, Cq, AQ])) { Qh = [Cq, AQ, AQ, C0]; Uh = [[0, 0.12], [hipLen / (8 * PH.CAP_EXPO), 0], [hipLen / (8 * PH.CAP_EXPO), 0], [0, 0]]; }
          pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + i + (h2 ? 'z' : 'x') + sfx, cap: true, quad: Qh, uv: Uh });
        });
        capA += hipLen * PH.CAP_W;
        capNails += Math.ceil(hipLen / PH.CAP_EXPO) * PH.CAP_NAILS;
      }
      for (sx = -1; sx <= 1; sx += 2) {
        pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-' + (sx < 0 ? 'l' : 'r') + sfx, box: [X1 + sx * (ue + 0.0015), ye + rsV - 0.0275, Z1, 0.003, 0.055, 2 * ue + 0.01] });
        pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-' + (sx < 0 ? 'b' : 'f') + sfx, box: [X1, ye + rsV - 0.0275, Z1 + sx * (ue + 0.0015), 2 * ue - 0.004, 0.055, 0.003] });
      }
      roofA += 4 * ue * ue / cs; dripL += 8 * ue; dripNails += Math.ceil(8 * ue / PH.DRIP_FIX); topB = Math.max(topB, yA + rsV + 0.01); nRoof++;
    }
    for (t = 0; t < TW.length; t++) if (TW[t].roof) roofOn(TW[t], t ? '-t' + (t + 1) : '');
    for (t = 0; t < TW.length; t++) topB = Math.max(topB, (TW[t].look === 'tall') ? yT1 + tmer : yC1 + mer);   /* v398 the model's top with no roof */

    /* the model's reach past the deck (the camera's fit) */
    var bb = [x0 - tb, x1 + tb, z0 - tb, z1 + tb];
    function reach(S, w) { var Q = S.P(0, 0, w); bb[0] = Math.min(bb[0], Q[0]); bb[1] = Math.max(bb[1], Q[0]); bb[2] = Math.min(bb[2], Q[2]); bb[3] = Math.max(bb[3], Q[2]); }

    /* THE LADDER (the play fort's): 2x6 rails at 75 deg lapped on its
       posts, 2x4 treads <= 28 cm (US 11 in.) apart */
    var lAng = PH.LAD_ANG * Math.PI / 180, lct = 1 / Math.tan(lAng), lhw = jh / Math.sin(lAng), nTread = 0, e;
    var lw = function (y) { return (yD - y) * lct; };
    for (sx = -1; sx <= 1; sx += 2) {
      poly('lrail', PH.RIM, ceil2(yD / Math.sin(lAng) + jh * lct), 'lrail-' + (sx < 0 ? 'l' : 'r'), [FL.pN(lw(yD), yD), FL.pN(lw(yD) + lhw, yD), FL.pN(lw(0) + lhw, 0), FL.pN(lw(0), 0)], FL.planeN, FL.cN(sx * (ow / 2 - jt / 2)), jt);
      fly(FL.out);
      coat += 2 * (jt + jh) * yD / Math.sin(lAng);
      [yD - 0.03, yB + 0.07].forEach(function (yq) {
        var w0 = Math.max(0, lw(yq)), w1 = Math.min(p, lw(yq) + lhw), Q = FL.P(sx * (ow / 2 - jt), yq, (w0 + w1) / 2);
        scr('screw-lrail', PH.RAIL_SCREW, Q[0], Q[1], Q[2], FL.D(sx, 0, 0), len120);
      });
    }
    var nT = Math.max(2, Math.ceil(yD / _phU(s, 'LAD_RISE') - 1e-9)), rise = yD / nT, twd = ow - 2 * jt;
    for (k = 1; k < nT; k++) {
      var ytc = yD - k * rise - st / 2, wtc = lw(ytc) + lhw / 2, Qt = FL.P(0, ytc, wtc), dmt = FL.dims(twd, st, sd);
      box('tread', PH.STUD, ceil2(twd), 'tread-' + k, Qt[0], Qt[1], Qt[2], dmt[0], dmt[1], dmt[2]);
      fly(FL.out);
      coat += 2 * (st + sd) * twd;
      nTread++;
      for (sx = -1; sx <= 1; sx += 2) for (e = -1; e <= 1; e += 2) { var Qs2 = FL.P(sx * ow / 2, ytc, wtc + e * sd / 4); scr('screw-tread', PH.RAIL_SCREW, Qs2[0], Qs2[1], Qs2[2], FL.D(-sx, 0, 0), len120); }
    }
    reach(FL, lw(0) + lhw);

    /* THE CLIMBING WALL: two 2x6 stringers at 65 deg lapped on its posts
       (two 6x120 each, the ladder's way), 1x6 boards across their outer
       edges from 10 cm (US 4 in.) up to the deck (two stainless screws into
       each stringer), a bolt-on hold on every board but the lowest, left
       and right in turn (MISSING) */
    var cAng = CS.CW_ANG * Math.PI / 180, cct = 1 / Math.tan(cAng), chw = jh / Math.sin(cAng), nCb = 0, nHold = 0;
    var cwf = function (y) { return (yD - y) * cct; };
    for (sx = -1; sx <= 1; sx += 2) {
      poly('cstr', PH.RIM, ceil2(yD / Math.sin(cAng) + jh * cct), 'cstr-' + (sx < 0 ? 'l' : 'r'), [FC.pN(cwf(yD), yD), FC.pN(cwf(yD) + chw, yD), FC.pN(cwf(0) + chw, 0), FC.pN(cwf(0), 0)], FC.planeN, FC.cN(sx * (ow / 2 - jt / 2)), jt);
      fly(FC.out);
      coat += 2 * (jt + jh) * yD / Math.sin(cAng);
      [yD - 0.03, yB + 0.07].forEach(function (yq) {
        var w0 = Math.max(0, cwf(yq)), w1 = Math.min(p, cwf(yq) + chw), Q = FC.P(sx * (ow / 2 - jt), yq, (w0 + w1) / 2);
        scr('screw-cstr', PH.RAIL_SCREW, Q[0], Q[1], Q[2], FC.D(sx, 0, 0), len120);
      });
    }
    var cO = [cwf(0) + chw, 0], cDz = -Math.cos(cAng), cDy = Math.sin(cAng), cNz = Math.sin(cAng), cNy = Math.cos(cAng);
    var cS = yD / Math.sin(cAng), cB = _csU(s, 'CW_FOOT') / Math.sin(cAng), cG = _csU(s, 'CW_GAP'), hX = _csU(s, 'HOLD_X');
    function cPt(sA, nA) { return [cO[0] + cDz * sA + cNz * nA, cO[1] + cDy * sA + cNy * nA]; }
    function cPN(sA, nA) { var q = cPt(sA, nA); return FC.pN(q[0], q[1]); }
    for (var sTop = cS; sTop - bwd >= cB - 1e-6; sTop -= bwd + cG) {
      var s0 = sTop - bwd, sC = (s0 + sTop) / 2;
      poly('cboard', PF.BOARD, ceil2(ow), 'cboard-' + (nCb + 1), [cPN(s0, 0), cPN(sTop, 0), cPN(sTop, tb), cPN(s0, tb)], FC.planeN, FC.cN(0), ow);
      fly(FC.out);
      coat += 2 * (tb + bwd) * ow;
      for (sx = -1; sx <= 1; sx += 2) { var qb = cPt(sC, tb), Qb = FC.P(sx * (ow / 2 - jt / 2), qb[1], qb[0]); scr('screw-cboard', PF.BOARD_SCREW, Qb[0], Qb[1], Qb[2], FC.D(0, -cNy, -cNz), len50, 0.0025); }
      nCb++;
    }
    for (k = 0; k < nCb - 1; k++) {
      var sH = cS - k * (bwd + cG) - bwd / 2, qh = cPt(sH, tb + 0.04), Qh2 = FC.P((k % 2) ? -hX : hX, qh[1], qh[0]), dmh = FC.dims(0.08, 0.06, 0.05);
      box('hold', null, 0, 'hold-' + (k + 1), Qh2[0], Qh2[1], Qh2[2], dmh[0], dmh[1], dmh[2]);
      fly(FC.out);
      nHold++;
    }
    if (nHold) missing.push({ name: CS.HOLD_NAME, qty: nHold, unit: 'pcs' });
    reach(FC, cwf(0) + chw + tb);

    /* THE SLIDE off the keep's left side, centred in its opening (the stilt house's, mirrored; MISSING) */
    if (FS) {
      var wsl = _phU(s, 'SLIDE_W'), sbd = PH.SLIDE_BED, swh = PH.SLIDE_WALL, swt = PH.SLIDE_WT;
      var sAng = PH.SLIDE_ANG * Math.PI / 180, sw0 = -PH.SLIDE_LIP, sw1 = _phU(s, 'SLIDE_TOP'), syE = _phU(s, 'SLIDE_EXIT'), syT = yD + sbd;
      var sw2 = sw1 + (syT - syE) / Math.tan(sAng), sw3 = sw2 + _phU(s, 'SLIDE_RUN');
      var sm = function (pts) { return pts.map(function (q) { return FS.pN(q[0], q[1]); }); };
      poly('slide', null, 0, 'slide-bed', sm([[sw0, yD], [sw1, yD], [sw2, syE - sbd], [sw3, syE - sbd], [sw3, syE], [sw2, syE], [sw1, syT], [sw0, syT]]), FS.planeN, FS.cN(0), wsl - 2 * swt);
      fly(FS.out);
      for (k = -1; k <= 1; k += 2) {
        poly('slide', null, 0, 'slide-wall-' + (k < 0 ? 'b' : 'f'), sm([[sw0, yD], [sw1, yD], [sw2, syE - sbd], [sw2, 0], [sw3, 0], [sw3, syE + swh], [sw2, syE + swh], [sw1, syT + swh], [sw0, syT + swh]]), FS.planeN, FS.cN(k * (wsl / 2 - swt / 2)), swt);
        fly(FS.out);
      }
      missing.push({ name: PH.SLIDE_NAME, qty: 1, unit: 'pcs' });
      reach(FS, sw3);
    }

    /* THE MONKEY BARS off the last tower's right side: the near 2x6 header
       across its opening's posts (two M16 rods through header + post), the
       catalogue's MONKEY BAR from it to the far 2x6 header between two 4x4
       posts on ground screws (two 6x160 through each post into its end),
       2x4 knee braces under it in the posts' plane, 2x4 rungs between the
       posts to climb up (two 6x160 through each post); the bar's brackets
       two 6x80 at each end of each side into the headers */
    var yMB = yD + _csU(s, 'MB_UP'), nMr = 0, nMbr = 0, mbL = CS.MB;
    if (FM) {
      var mbw = _csU(s, 'MB_W'), tube = CS.MB_TUBE;
      var wn0 = p, wn1 = wn0 + jt, wb1 = wn0 + mbL, wfp = wb1 - jt / 2, mzp = ow / 2 + p / 2;
      var Qm = FM.P(0, yMB - jh / 2, (wn0 + wn1) / 2), dmm = FM.dims(ow + 2 * p, jh, jt);
      box('mhead', PH.RIM, ceil2(ow + 2 * p), 'mhead-n', Qm[0], Qm[1], Qm[2], dmm[0], dmm[1], dmm[2]);
      fly(FM.out);
      coat += 2 * (jt + jh) * (ow + 2 * p);
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) { var Rm = FM.P(sz * mzp, yMB - jh * (k ? 0.35 : 0.15), wn1 + ov); rod('bolt-mhead', Rm[0], Rm[1], Rm[2], FM.D(0, 0, -1), jt + p + 2 * ov); }
      for (sz = -1; sz <= 1; sz += 2) {
        var mpid = 'mpost-' + (sz < 0 ? 'b' : 'f'), Qp = FM.P(sz * mzp, (yPB + yMB) / 2, wfp), dmp = FM.dims(p, yMB - yPB, p);
        pier(Qp[0], Qp[2], mpid, 'nail-muhead');
        box('mpost', PH.POST, ceil2(yMB - yPB), mpid, Qp[0], Qp[1], Qp[2], dmp[0], dmp[1], dmp[2]);
        fly(FM.out);
        coat += 4 * p * (yMB - yPB);
      }
      var Qf = FM.P(0, yMB - jh / 2, wfp), dmf = FM.dims(ow, jh, jt);
      box('mhead', PH.RIM, ceil2(ow), 'mhead-f', Qf[0], Qf[1], Qf[2], dmf[0], dmf[1], dmf[2]);
      fly(FM.out);
      coat += 2 * (jt + jh) * ow;
      for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) { var Sm = FM.P(sz * (ow / 2 + p), yMB - jh * (k ? 0.7 : 0.3), wfp); scr('screw-mhead', PH.JOIST_SCREW, Sm[0], Sm[1], Sm[2], FM.D(-sz, 0, 0), len160); }
      var mba = Math.min(_csU(s, 'MB_BRACE'), ow / 2 - kbk - 0.03);
      for (sz = -1; sz <= 1; sz += 2) {
        var wM = (function (sz2) { return function (u, v) { return [sz2 * (ow / 2) - sz2 * u, yMB - jh + v]; }; })(sz);
        poly('mbrace', PH.STUD, ceil2((mba + kbk) * Math.SQRT2), 'mbrace-' + (sz < 0 ? 'b' : 'f'), [wM(0, -(mba + kbk)), wM(0, -(mba - kbk)), wM(mba - kbk, 0), wM(mba + kbk, 0)].map(function (q) { return FM.pT(q[0], q[1]); }), FM.planeT, FM.cT(wfp), st);
        fly(FM.out);
        coat += 2 * (st + sd) * (mba + kbk) * Math.SQRT2;
        nMbr++;
        var mbF = wM(0, -mba), SF = FM.P(sz * (ow / 2 + p), mbF[1], wfp);
        scr('screw-mbrace', PH.BRACE_SCREW, SF[0], SF[1], SF[2], FM.D(-sz, 0, 0), len160);
        var mbT = wM(mba + kbk - 0.06, -0.06), ST = FM.P(mbT[0], mbT[1], wfp);
        scr('screw-mbrace', PH.BRACE_SCREW, ST[0], ST[1], ST[2], [0, 1, 0], len160);
      }
      var yMr = _csU(s, 'MRUNG0'), yMrMax = yMB - jh - mba - kbk - 0.10;
      for (; yMr <= yMrMax + 1e-6; yMr += _phU(s, 'LAD_RISE')) {
        var Qr = FM.P(0, yMr, wfp), dmr = FM.dims(ow, st, sd);
        box('mrung', PH.STUD, ceil2(ow), 'mrung-' + (nMr + 1), Qr[0], Qr[1], Qr[2], dmr[0], dmr[1], dmr[2]);
        fly(FM.out);
        coat += 2 * (st + sd) * ow;
        nMr++;
        for (sz = -1; sz <= 1; sz += 2) for (e = -1; e <= 1; e += 2) { var Sr = FM.P(sz * (ow / 2 + p), yMr, wfp + e * 0.025); scr('screw-mrung', PH.JOIST_SCREW, Sr[0], Sr[1], Sr[2], FM.D(-sz, 0, 0), len160); }
      }
      var yBar = yMB + tube / 2, nMrg = Math.max(2, Math.floor((mbL - 0.20) / CS.MB_RUNG + 1e-6) + 1), wr0 = wn0 + (mbL - (nMrg - 1) * CS.MB_RUNG) / 2;
      for (sz = -1; sz <= 1; sz += 2) { var Qb2 = FM.P(sz * mbw / 2, yBar, (wn0 + wb1) / 2), dmb = FM.dims(tube, tube, wb1 - wn0); box('mbar', CS.MB_CODE, 0, 'mbar-side-' + (sz < 0 ? 'b' : 'f'), Qb2[0], Qb2[1], Qb2[2], dmb[0], dmb[1], dmb[2]); fly(FM.out); }
      for (k = 0; k < nMrg; k++) { var Qg = FM.P(0, yBar, wr0 + k * CS.MB_RUNG), dmg = FM.dims(mbw - tube, tube * 0.8, tube * 0.8); box('mbar', CS.MB_CODE, 0, 'mbar-rung-' + (k + 1), Qg[0], Qg[1], Qg[2], dmg[0], dmg[1], dmg[2]); fly(FM.out); }
      extra[CS.MB_CODE] = 1;
      [wn0 + jt / 2, wfp].forEach(function (wq) {
        for (var sz3 = -1; sz3 <= 1; sz3 += 2) for (var k5 = -1; k5 <= 1; k5 += 2) { var Sb = FM.P(sz3 * (mbw / 2 + tube / 2 + 0.012), yMB, wq + k5 * 0.012); scr('screw-mbar', PH.RIDGE_TOE, Sb[0], Sb[1], Sb[2], [0, -1, 0], len80); }
      });
      reach(FM, wfp + p / 2);
    }

    for (i = 0; i < pieces.length; i++) if (!pieces[i].fly && /^(rail-d|fboard-d)/.test(pieces[i].id)) pieces[i].fly = [0, 1, 0];   /* v398 the doors' heads come down from above */
    /* the bill's quantities: timber, boards and decking by length */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (!(pc.len > 0) || !pc.code) continue;
      m3[pc.code] = (m3[pc.code] || 0) + pc.len;
    }
    return {
      P: P, us: us, porch: false, L: Ze, W: Xe, PD: 0, zF: Ze / 2, pieces: pieces, fas: fas, blocks: [], hw: [], posts: posts, joists: jx.concat(jzB), rafters: [],
      meters: m3, coat: coat, floorA: 0, roofA: roofA, sidingA: 0, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: 0, digM3: 0, hinges: 0, shutters: 0, deckBoards: deckBoards, knobs: 0, catches: 0,
      ties: 0, gStuds: 0, trims: 0, doorBoards: 0, doorW: 0, doorH: 0, RO: 0, win: 0,
      yB: yB, yF: yD, yPT: yG1, yBm: yG1, yHd: 0, yWS: 0, ridgeTop: topB, pitch: CS.PITCH, rafL: rafL, roofLen: 0, slope: slant,
      top: topB, height: topB, depth: Xe, length: Ze,
      castle: true, treefort: false, fort: false, stilt: false, slide: slide, gscrews: gscrews, uheads: uheads, missing: missing, extra: extra, yD: yD,
      extX: Math.max(-bb[0], bb[1]), extZ: Math.max(-bb[2], bb[3]), sPosts: posts.length, xBraces: 0,
      balusters: 0, treads: nTread, rails: nRail, fboards: nBoards, kbraces: nKb, swings: false, swing: null, yG1: yG1, yC1: yC1, yRb: yRb,
      bridge: BR, bridge2: BR2, tower: T, shape: shape, mb: !!FM, towers: TW.length, cboards: nCb, holds: nHold, mrungs: nMr, mbraces: nMbr, mbarL: mbL, yMB: yMB,
      look: look, looks: TW.map(function (q) { return q.look; }), play: _csPlay(s), roofs: nRoof, windows: nWin, bands: nBand, doors: DW.length, yT1: yT1
    };
  }
  /* the castle's assembly: the deck, its walls, the keep's roof, the ladder, the climbing wall, the slide, the monkey bars */
  function _csSteps() {
    var K = PH;
    return [
      { parts: [], codes: [] },
      { parts: ['ph-gscrew'], codes: [K.GSCREW] },
      { parts: ['ph-uhead'], codes: [K.UHEAD] },
      { parts: ['ph-post'], codes: [K.POST] },
      { parts: ['ph-hw-nail-uhead'], codes: [K.UNAIL] },
      { parts: ['ph-frim'], codes: [K.RIM] },
      { parts: ['ph-hw-bolt-frim'], codes: [K.ROD, K.WASHER, K.CAPNUT] },
      { parts: ['ph-hw-screw-frim'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-joist'], codes: [K.JOIST] },
      { parts: ['ph-hw-screw-joist'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-kbrace'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-tkbrace'], codes: [K.STUD_SCREW, K.FRAME_SCREW] },
      { parts: ['ph-hw-screw-kbrace'], codes: [K.BRACE_SCREW] },
      { parts: ['ph-deck'], codes: [K.DECK] },
      { parts: ['ph-hw-screw-deck'], codes: [K.DECK_SCREW] },
      { parts: ['ph-rpost'], codes: [K.POST] },
      { parts: ['ph-hw-bolt-rpost'], codes: [K.ROD, K.WASHER, K.CAPNUT] },
      { parts: ['ph-rail'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-rail'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-fboard'], codes: [PF.BOARD] },
      { parts: ['ph-hw-screw-fboard'], codes: [PF.BOARD_SCREW] },
      { parts: ['ph-cband'], codes: [PF.BOARD] },                                     /* v398 the tall towers' bands */
      { parts: ['ph-hw-screw-cband'], codes: [K.RIDGE_TOE, K.SHEATH_SCREW] },
      { parts: ['ph-ring'], codes: [K.RIM] },
      { parts: ['ph-hw-screw-ring'], codes: [K.JOIST_SCREW, K.RAIL_SCREW] },
      { parts: ['ph-crafter', 'ph-hub'], codes: [K.RAFTER, K.POST] },
      { parts: ['ph-hw-screw-seat'], codes: [K.SEAT_SCREW] },
      { parts: ['ph-hw-screw-hub'], codes: [K.RIDGE_TOE] },
      { parts: ['ph-sheath'], codes: [K.ROOF, K.SHEATH_SCREW] },
      { parts: ['ph-drip'], codes: [K.DRIP, K.ROOF_NAIL] },
      { parts: ['ph-cover'], codes: [K.UNDERLAY, K.UL_STAPLE, K.SHINGLE, K.ROOF_NAIL] },
      { parts: ['ph-lrail'], codes: [K.RIM] },
      { parts: ['ph-hw-screw-lrail'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-tread'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-tread'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-cstr'], codes: [K.RIM] },
      { parts: ['ph-hw-screw-cstr'], codes: [K.RAIL_SCREW] },
      { parts: ['ph-cboard'], codes: [PF.BOARD] },
      { parts: ['ph-hw-screw-cboard'], codes: [PF.BOARD_SCREW] },
      { parts: ['ph-hold'], codes: [] },                                              /* -- the holds (MISSING in the catalogue) */
      { parts: ['ph-slide'], codes: [] },                                             /* -- the slide (MISSING) */
      { parts: ['ph-mpost'], codes: [K.POST] },                                       /* the monkey bars' far posts (on the ground screws set with the others), */
      { parts: ['ph-hw-nail-muhead'], codes: [K.UNAIL] },
      { parts: ['ph-mhead'], codes: [K.RIM] },                                        /* -- the two headers */
      { parts: ['ph-hw-bolt-mhead', 'ph-hw-screw-mhead'], codes: [K.ROD, K.WASHER, K.CAPNUT, K.JOIST_SCREW] },
      { parts: ['ph-mbrace'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-mbrace'], codes: [K.BRACE_SCREW] },
      { parts: ['ph-mrung'], codes: [K.STUD] },
      { parts: ['ph-hw-screw-mrung'], codes: [K.JOIST_SCREW] },
      { parts: ['ph-mbar'], codes: [CS.MB_CODE] },                                    /* -- the catalogue's monkey bar */
      { parts: ['ph-hw-screw-mbar'], codes: [K.RIDGE_TOE] }
    ];
  }
  /* the castle's materials by role: the climbing wall's boards in the walls' colour, the holds in the three accents, the monkey bar steel */
  function _csMat(pc, mats, mat) {
    if (pc.kind === 'cboard') return mats.phWall || mat;
    if (pc.kind === 'cband') return mats.phDoor || mat;   /* v398 the tall towers' band in the door's accent */
    if (pc.kind === 'hold') { var n = (+String(pc.id).replace(/\D+/g, '')) || 0, A = [mats.phDoor, mats.phShut, mats.phSlide]; return A[n % 3] || mat; }
    if (pc.kind === 'mbar') return mats.phDrip || mat;
    return mat;
  }
  /* the castle's exploded directions */
  function _csFly(pc, g) {
    if (pc.fly) return pc.fly;   /* v394 the play's pieces carry their side's outward direction */
    var cx = pc.box ? pc.box[0] : (pc.plane === 'zy' ? pc.c : 0), cz = pc.box ? pc.box[2] : (pc.plane === 'xy' ? pc.c : 0);
    if (pc.kind === 'ring' || pc.kind === 'crafter' || pc.kind === 'hub' || pc.kind === 'sheath' || pc.kind === 'drip') return [0, 1, 0];
    if (pc.kind === 'rpost') return (cx > g.W / 2) ? [1, 0, 0] : [0, 0, 1];
    if (pc.kind === 'mhead' || pc.kind === 'mpost' || pc.kind === 'mbrace' || pc.kind === 'mrung' || pc.kind === 'mbar') return [1, 0, 0];
    if (pc.kind === 'cstr' || pc.kind === 'cboard' || pc.kind === 'hold' || pc.kind === 'lrail' || pc.kind === 'tread') return [0, 0, 1];
    if (pc.kind === 'slide') return [-1, 0, 0];
    if (pc.kind === 'joist') return [0, -1, 0];
    return null;
  }
  /* its line in the debug log and the NOT BILLED lines */
  function _csLog(g, bq) {
    _dbg('[cs] castle ' + (g.shape || 'i2') + ' (' + (g.towers || 2) + ' towers ' + (g.looks || []).join(' / ') + ' [' + g.look + '], play ' + g.play + ', ' + g.roofs + ' roofs, ' + g.windows + ' windows, ' + g.bands + ' bands, ' + g.doors + ' doors) ' + g.W.toFixed(3) + ' x ' + g.L.toFixed(3) + ' m (towers ' + g.tower.toFixed(3) + ', bridge ' + g.bridge.toFixed(3) + ((g.shape === 'l') ? ' / ' + g.bridge2.toFixed(3) : '') + '), ' + g.gscrews.length + ' ground screws + U heads, deck ' + g.yD.toFixed(3) + ' (' + g.joists.length + ' joists, ' +
         g.deckBoards + ' deck boards), ' + g.kbraces + ' knee braces, walls ' + g.yG1.toFixed(3) + ' / towers ' + g.yC1.toFixed(3) + ' (' + g.rails + ' rails, ' + g.fboards + ' boards), rings ' + g.yRb.toFixed(3) + ', tall ' + g.yT1.toFixed(3) + ', roofs ' + g.pitch + ' deg ' +
         g.roofA.toFixed(2) + ' m2 (rafters ' + g.rafL.toFixed(2) + ', top ' + g.top.toFixed(3) + '), ladder ' + g.treads + ' treads, climbing wall ' + g.cboards + ' boards + ' + g.holds + ' holds, slide ' + (g.slide ? 'on' : 'off') +
         (g.mb ? ', monkey bars ' + g.mbarL.toFixed(2) + ' at ' + g.yMB.toFixed(3) + ' (' + g.mrungs + ' rungs, ' + g.mbraces + ' braces)' : '') + ', ' + g.fas.length + ' fasteners; ' +
         Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
    if (!(bq.missing || []).length) _dbg('[cs] NOT BILLED: none');
    for (var i = 0; i < (bq.missing || []).length; i++) _dbg('[cs] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
  }
  /* ------------------------------------------------------------------
     v402 THE PLAYHOUSES' FOUNDATION ON A SWITCH (Marek 2026-10-30 20:27:
     "Stavby udelej variantni zalozeni, i na vrutech. Prepinani dole v
     banneru"): every PLAYHOUSES type (26-32, the castle) on the info bar's
     last switch -- Ground screws > Precast pads > Concrete pads (the
     gazebo's three, its labels). Each layout still builds its own
     foundation (the houses on deck blocks under the side rims and the
     porch posts, the stilt house / play fort / tree fort / castle on ground
     screws + U heads under the posts); _phFoundPass turns it into the
     chosen one at the same heights:
       - a post on a ground screw -> on a deck block: the post down into
         the block's socket (its U head and nails gone); -> on a poured
         footing: the footing's top where the screw's head was, a wet-set
         U anchor (FCO00004) for the U head, the same nails;
       - a house on deck blocks -> on ground screws (or footings): the
         siding covers the rims, so a U head under the nearest joist just
         inside each rim for every block (its flanges on the joist's faces,
         slid inward clear of anything there), the screw's head (the
         footing's top) a U head lower, 12 nails through the flanges once
         the joists lie in them; a porch post up out of its socket, its foot
         flush with the frame (screwed to the rim's end and the front joist
         as before).
     The footings: 40 x 40 cm, 80 cm deep (the gazebo's), 4 bars, gravel,
     geotextile, one formwork lump; the blocks: their gravel and beds. */
  Object.assign(PH, {
    PIER_W: 0.40, PIER_W_US: 0.4064, PIER_D: 0.80, PIER_D_US: 0.8128, PIER_GRAVEL: 0.15, PIER_GRAVEL_US: 0.1524, BAR_COVER: 0.05,
    CONCRETE: 'FCO00002', REBAR: 'FCO00003', FORMWORK: 'FCO00007', GEOTEX: 'FEC00003', UANCHOR: 'FCO00004'
  });
  var PH_FOUND_TYPES = [26, 27, 28, 29, 30, 31, 32, CS_TYPE];
  function _phFoundOn(s) { return PH_FOUND_TYPES.indexOf(((s || STATE).variant | 0)) >= 0; }
  function _phFoundDef(s) { var v = ((s || STATE).variant | 0); return (v === 27 || v === 29 || v === 32 || v === CS_TYPE) ? 'screw' : 'block'; }
  function _phFound(s) { s = s || STATE; if (!_phFoundOn(s)) return null; var f = s.phFound; return (f === 'screw' || f === 'block' || f === 'pier') ? f : _phFoundDef(s); }
  function _phFoundPass(s, g) {
    s = s || STATE;
    var f = _phFound(s);
    if (!f || !g || !g.P) return g;
    var us = (s.isMetric === false), p = g.P.p, i, q, k;
    var len38 = us ? 0.0381 : 0.038, uT = PH.U_T, uUp = PH.U_UP, uFl = PH.U_FL;
    var bl = _phU(s, 'BLK'), blT = _phU(s, 'BLK_TOP'), blH = _phU(s, 'BLK_H'), blUp = _phU(s, 'BLK_UP'), sock = _phU(s, 'SOCK'), gv = _phU(s, 'GRAVEL');
    var pW = _phU(s, 'PIER_W'), pD = _phU(s, 'PIER_D'), pG = _phU(s, 'PIER_GRAVEL');
    g.found = f;
    g.pours = g.pours || [];
    var native = (g.blocks && g.blocks.length) ? 'block' : 'screw';
    function r3(v) { return Math.round(v * 1000) / 1000; }
    function postAt(x, z, yb) {
      for (var m = 0; m < g.pieces.length; m++) { var b = g.pieces[m].box; if (b && Math.abs(b[0] - x) < 1e-4 && Math.abs(b[2] - z) < 1e-4 && Math.abs(b[1] - b[4] / 2 - yb) < 1e-4) return g.pieces[m]; }
      return null;
    }
    function setFoot(pc, y) {   /* a post's foot to y: its length, the bill's metres, the coating */
      var top = pc.box[1] + pc.box[4] / 2, old = pc.box[1] - pc.box[4] / 2, oldLen = pc.len || 0;
      pc.box[1] = (top + y) / 2; pc.box[4] = top - y; pc.len = Math.ceil((top - y) * 100 - 1e-6) / 100;
      if (g.meters && pc.code) g.meters[pc.code] = (g.meters[pc.code] || 0) + pc.len - oldLen;
      g.coat += 4 * p * (old - y);
    }
    function nails(x, z, y1, w, kind, az) {   /* 12 through the U head's flanges (on the member's X faces, or Z faces: az), the columns staggered (the stilt house's) -- each at the first spot clear of the fasteners already there */
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
        var n0 = (az ? z : x) + sd2 * (w / 2 + uT), d = az ? [0, 0, -sd2] : [-sd2, 0, 0], a0 = (az ? x : z) + cI * ((sd2 < 0) ? 0.022 : 0.034), y0 = y1 + 0.02 + rI * 0.025, best = null;
        [[0, 0], [0, 0.012], [0, -0.008], [0.009, 0], [-0.009, 0], [0, 0.024], [0.009, 0.012], [-0.009, 0.012], [0, 0.036], [0.009, 0.024], [-0.009, 0.024], [0, 0.048]].some(function (o) {
          var ac = a0 + cI * o[0], yc = y0 + o[1];
          if (Math.abs(ac - (az ? x : z)) > p / 2 - 0.008 || yc < y1 + 0.012 || yc > y1 + uFl - 0.03) return false;
          var c0 = az ? [ac, yc, n0] : [n0, yc, ac], c1 = [c0[0] + d[0] * len38, yc, c0[2] + d[2] * len38];
          for (var m = 0; m < g.fas.length; m++) { var fq = g.fas[m]; if (_pfSegDist(c0, c1, [fq.x, fq.y, fq.z], [fq.x + fq.dir[0] * fq.len, fq.y + fq.dir[1] * fq.len, fq.z + fq.dir[2] * fq.len]) < 0.0019 + (fq.r || 0.003) + 0.003) return false; }
          best = c0; return true;
        });
        if (!best) best = az ? [a0, y0, n0] : [n0, y0, a0];
        g.fas.push({ kind: kind, code: PH.UNAIL, x: best[0], y: best[1], z: best[2], dir: d, len: len38, r: 0.0019 });
      }
    }
    function aabb(pc) {
      var b = pc.box, t2;
      if (b) return [b[0] - b[3] / 2, b[0] + b[3] / 2, b[1] - b[4] / 2, b[1] + b[4] / 2, b[2] - b[5] / 2, b[2] + b[5] / 2];
      if (!pc.poly || (pc.plane !== 'xy' && pc.plane !== 'zy')) return null;
      var u0 = 1e9, u1 = -1e9, v0 = 1e9, v1 = -1e9;
      pc.poly.forEach(function (pt) { u0 = Math.min(u0, pt[0]); u1 = Math.max(u1, pt[0]); v0 = Math.min(v0, pt[1]); v1 = Math.max(v1, pt[1]); });
      t2 = (pc.t || 0) / 2;
      return (pc.plane === 'xy') ? [u0, u1, v0, v1, pc.c - t2, pc.c + t2] : [pc.c - t2, pc.c + t2, v0, v1, u0, u1];
    }
    function hits(A) {   /* does anything drawn overlap the box A (touching faces do not count) */
      for (var m = 0; m < g.pieces.length; m++) {
        var B = aabb(g.pieces[m]);
        if (B && A[0] < B[1] - 1e-4 && B[0] < A[1] - 1e-4 && A[2] < B[3] - 1e-4 && B[2] < A[3] - 1e-4 && A[4] < B[5] - 1e-4 && B[4] < A[5] - 1e-4) return true;
      }
      return false;
    }
    if (native === 'screw' && f === 'pier') {
      g.gscrews.forEach(function (gs) { g.pours.push({ x: gs.x, z: gs.z, w: pW, y1: gs.y1, a: 0, id: gs.id }); });
      g.uheads.forEach(function (uh) { uh.wet = true; });
      g.gscrews = [];
    } else if (native === 'screw' && f === 'block') {
      var drop = [];
      g.gscrews.forEach(function (gs) {
        var uh = null;
        for (q = 0; q < g.uheads.length; q++) if (g.uheads[q].id === gs.id) uh = g.uheads[q];
        var yPB = uh ? uh.y1 : gs.y1 + uUp, pc = postAt(gs.x, gs.z, yPB);
        if (pc) setFoot(pc, blUp - sock); else _dbg('[found] no post on ' + gs.id);
        g.blocks.push({ x: gs.x, z: gs.z, w: bl, wt: blT, y0: blUp - blH, y1: blUp, a: 0, id: gs.id, post: true });
        drop.push([gs.x, gs.z, yPB]);
      });
      g.fas = g.fas.filter(function (fq) {
        if (fq.code !== PH.UNAIL || !/^nail-/.test(fq.kind)) return true;
        return !drop.some(function (d) { return Math.abs(fq.x - d[0]) < p / 2 + 0.02 && Math.abs(fq.z - d[1]) < p / 2 + 0.02 && fq.y > d[2] - 1e-6 && fq.y < d[2] + uFl; });
      });
      g.gscrews = []; g.uheads = [];
    } else if (native === 'block' && f !== 'block') {
      /* the houses: the siding covers the rims' outer faces, so the U heads go under the joists just inside each rim -- along
         each side the usable joists (a U head fits under them, slid inward clear of anything there) nearest the first and the
         last block, then nearest each block between where it keeps 60 cm (US 2 ft) off the others; a porch post up out of its
         socket, its foot flush with the frame (screwed to the rim's end and the front joist as before) */
      var jt2 = g.P.jt, minSep = us ? 0.6096 : 0.60, J = g.pieces.filter(function (pc) { return pc.kind === 'joist' && pc.box && pc.box[3] > pc.box[5]; });
      g.blocks.forEach(function (bk) { if (bk.post) { var pc = postAt(bk.x, bk.z, bk.y1 - sock); if (pc) setFoot(pc, bk.y1); else _dbg('[found] no porch post on ' + bk.id); } });
      [-1, 1].forEach(function (sx) {
        var bs = g.blocks.filter(function (bk) { return ((bk.x < 0) ? -1 : 1) === sx; }).sort(function (a2, b2) { return a2.z - b2.z; });
        if (!bs.length) return;
        var y1u = bs[0].y1, yH = y1u - uUp, yb0 = y1u - uT, yb1 = y1u - uT + uFl, U = [];
        J.forEach(function (jq) {
          var jb = jq.box, jz = jb[2], xEnd = jb[0] + sx * jb[3] / 2;
          for (var dx = 0; dx <= 0.30 + 1e-9; dx += 0.02) {
            var xs = xEnd - sx * (p / 2 + 0.03 + dx);
            if (hits([xs - p / 2, xs + p / 2, yb0, yb1, jz - jt2 / 2 - uT, jz - jt2 / 2]) || hits([xs - p / 2, xs + p / 2, yb0, yb1, jz + jt2 / 2, jz + jt2 / 2 + uT])) continue;
            U.push({ x: xs, z: jz }); return;
          }
        });
        if (!U.length) { _dbg('[found] no joist for a U head on side ' + sx); return; }
        var pick = [];
        function nearest(z0, sep) { var best = null; U.forEach(function (u) { if (pick.indexOf(u) >= 0) return; if (sep && pick.some(function (q2) { return Math.abs(q2.z - u.z) < sep - 1e-6; })) return; if (!best || Math.abs(u.z - z0) < Math.abs(best.z - z0)) best = u; }); return best; }
        var uA = nearest(bs[0].z, 0); if (uA) { uA.id = bs[0].id; pick.push(uA); }
        var uB = nearest(bs[bs.length - 1].z, minSep); if (uB) { uB.id = bs[bs.length - 1].id; pick.push(uB); }
        for (q = 1; q < bs.length - 1; q++) { var uM = nearest(bs[q].z, minSep); if (uM) { uM.id = bs[q].id; pick.push(uM); } }
        pick.sort(function (a2, b2) { return a2.z - b2.z; }).forEach(function (u) {
          if (f === 'screw') g.gscrews.push({ x: u.x, z: u.z, r: _phU(s, 'GS_R'), y1: yH, id: u.id });
          else g.pours.push({ x: u.x, z: u.z, w: pW, y1: yH, a: 0, id: u.id });
          g.uheads.push({ x: u.x, z: u.z, y0: yH, y1: y1u, w: jt2, az: true, id: u.id, wet: (f === 'pier') });
          nails(u.x, u.z, y1u, jt2, 'nail-ujoist', true);
        });
      });
      g.blocks = [];
    }
    /* the quantities: the blocks' gravel + beds, the footings' gravel + holes, concrete (down to PIER_D and its top), bars, geotextile */
    var nB = g.blocks.length, nP = g.pours.length, conc = 0, bars = 0;
    g.pours.forEach(function (po) { conc += pW * pW * (pD + po.y1); bars += 4 * (pD + po.y1 - 2 * PH.BAR_COVER); });
    g.gravelM3 = r3(nB * bl * bl * gv + nP * pW * pW * pG);
    g.digM3 = r3(nB * bl * bl * (blH - blUp + gv) + nP * pW * pW * (pD + pG));
    g.pourQ = { n: nP, concrete: r3(conc), rebar: Math.round(bars * 100) / 100, geotex: Math.round(nP * pW * pW * 100) / 100 };
    return g;
  }

  /* ------------------------------------------------------------------
     v375 TYPE 34 -- COOP 1: THE BACKYARD COOP (Marek 2026-10-29 14:24 /
     2026-10-30 09:10: COOP the way of PLAYHOUSES and SWINGS -- one product,
     its variants on this engine, no floorplans; the Backyard Coop first).
     A hen house raised 2 ft over the ground at the back of a run, one gable
     roof over both. The flock sets the sizes:
       - HENS on the slider, 2-12 (6). The house 4 ft2 (0.37 m2) a hen, the
         run 10 ft2 (0.93 m2) a hen with the ground under the house counted.
         W 1.20-2.40 m (US 4-8 ft) on the footprint's side grips, never
         narrower than the flock needs; L (the whole run) on its front /
         back grips from what the flock needs up to 4.80 m (US 16 ft); the
         slider fits L to the flock again. The run on the info bar's toggle
         (off: the house alone on its legs, the hens free range).
       - FRAME: 4x4 posts in U heads on ground screws (the stilt house's)
         at the corners, at the house's front and <= 1.22 m (US 4 ft) apart
         along the run; a 4x6 beam on their tops the whole length a side.
       - HOUSE: its floor 0.61 m (US 2 ft) up -- 4x6 floor beams between
         the posts, 2x6 joists at <= 40 cm (US 16 in.), OSB; 2x4 walls
         between the posts (the posts are their corner studs): the sides
         under the beams, the back wall and the partition to the run under
         2x4 top plates; panel siding, corner boards, casings.
       - OPENINGS: the access door in the back wall (ledge and brace, strap
         hinges, a pull, a barrel bolt); the pop door in the partition
         (strap hinges, a ball catch) and its ramp down into the run (two
         1x6 planks on 1x4 ledges, 20 x 40 cleats); a window in the left
         wall with hardware cloth inside (no glass); the nest boxes off the
         right wall -- one for 4 hens, 12 in. OSB cubes under a lid on strap
         hinges with a barrel bolt, on a 2x4 ledger and two knee braces.
       - INSIDE: the roosts, 2x4 flat, 25 cm (10 in.) of bar a hen, their
         top 55 cm (22 in.) over the floor -- higher than the nests --, 25
         cm off the back wall and 35 cm apart, on 2x4 cleats screwed to a
         stud of their own in each side wall.
       - ROOF: the cottage's gable at 30 deg over the house and the run --
         2x4 rafters at <= 60 cm (a pair over the partition), a 2x6 ridge
         board, ties, fly rafters, OSB, underlay, shingles + caps, drip
         edge, 1x4 fascia and rake boards; the back gable is the house's
         vent (hardware cloth), the partition's gable closed.
       - RUN: 2x4 bottom rails laid flat between the posts over the U
         heads' flanges; the front framed with a 2x4 stud and top plate and
         a door of 2x4 on strap hinges with a barrel bolt; knee braces at
         the front corners; 1/2 in. 19 ga hardware cloth on every open face,
         the door and the vents, a 30 cm (12 in.) apron buried round the
         run, stapled every 7.5 cm (3 in.).
     Hardware cloth and the barrel bolt have no catalogue row yet: MISSING
     (by area / by the piece). X across, Y up, Z along (+Z the run's front);
     L = the whole run, the house from -L/2 to zH = -L/2 + Lh. */
  var CO = {
    W: [1.20, 2.40], W_US: [1.2192, 2.4384], W0: 1.80, W0_US: 1.8288,
    L_MAX: 4.80, L_MAX_US: 4.8768, HENS: [2, 12], HENS0: 6,
    HOUSE_M2: 0.37, HOUSE_M2_US: 0.37161, RUN_M2: 0.93, RUN_M2_US: 0.92903,
    LH: [1.20, 2.40], LH_US: [1.2192, 2.4384], RUN_MIN: 1.20, RUN_MIN_US: 1.2192, STEP: 0.10, STEP_US: 0.3048,
    FLOOR_H: 0.61, FLOOR_H_US: 0.6096, EAVE_H: 1.52, EAVE_H_US: 1.524, PITCH: 30, POST_SP: 1.22, POST_SP_US: 1.2192,
    NEST: 0.30, NEST_US: 0.3048, NEST_SILL: 0.20, NEST_SILL_US: 0.2032, HENS_NEST: 4, NEST_GAP: 0.02, NEST_POST: 0.01,
    ROOST_Y: 0.55, ROOST_Y_US: 0.5588, ROOST_HEN: 0.25, ROOST_HEN_US: 0.254, ROOST_WALL: 0.25, ROOST_WALL_US: 0.254, ROOST_GAP: 0.35, ROOST_GAP_US: 0.3556, RCLEAT: 0.25, RCLEAT_US: 0.254,
    POP_W: 0.30, POP_W_US: 0.3048, POP_H: 0.36, POP_H_US: 0.3556,
    DOOR_W: 0.60, DOOR_W_US: 0.6096, WIN_W: 0.46, WIN_W_US: 0.4572, WIN_H: 0.30, WIN_H_US: 0.3048, WIN_SILL: 0.30, WIN_SILL_US: 0.3048,
    RDOOR: 0.60, RDOOR_US: 0.6096, RAMP_ANG: 35, CLEAT_SP: 0.15, CLEAT_SP_US: 0.1524, CL_T: 0.020, CL_T_US: 0.01905, CL_W: 0.040, CL_W_US: 0.0381,
    APRON: 0.30, APRON_US: 0.3048, APRON_DIG: 0.05, APRON_DIG_US: 0.0508, STAPLE_SP: 0.075, STAPLE_SP_US: 0.0762, MESH_OFF: 0.006, MESH_T: 0.002,
    PLANK: 'KVR14024', CLEAT: 'KVL20040', STAPLE: 'FAS10000',
    MESH_NAME: 'HARDWARE CLOTH 1/2 IN. 19 GA, GALVANIZED WELDED WIRE', BOLT_NAME: 'BARREL BOLT 4 IN., GALVANIZED, WITH ITS SCREWS'
  };
  /* ------------------------------------------------------------------
     v383 TYPE 39 -- COOP 3: THE WALK-IN COOP (Marek 2026-10-30 12:04
     "Dalsi krok", chose it in the question panel: a tall run a person walks
     into, the hen house a small shed with a door, 6-20 hens). The backyard
     coop's build (_coLayout) with these constants over CO (_coU looks here
     first for type 39):
       - WALLS 8 ft (2.44 m) to the side beams' top: the posts are whole
         8 ft 4x4s, the run door a person door (its 2x4 frame 2.07 m), the
         house a walk-in shed under the 30 deg gable (3.2 m to the ridge at
         8 ft wide).
       - THE HOUSE'S FLOOR 16 in. (0.42 m) up -- as low as the U heads'
         flanges let its beams sit; the run's bottom rails stop at the house
         (its floor beams are there).
       - THE ACCESS DOOR 30 in. (76 cm) wide in the back wall under a 2x4
         header (a gable end: the rafters bear on the side beams), 1.84 m
         tall, three ledges, three strap hinges.
       - HENS 6-20 (10) on the slider: 4 ft2 (0.37 m2) a hen in the house,
         10 ft2 (0.93 m2) a hen over the whole footprint; W 1.80-3.00 m (US
         6-10 ft), the house 1.20-2.60 m (US 4-9 ft), L to 7.20 m (US 24
         ft), the run at least 1.80 m (US 6 ft) to walk into.
       - A 24 x 18 in. (61 x 46 cm) window 36 in. (91 cm) over the floor;
         knee braces at every run post; the front's 2x4 studs <= 1.22 m
         (US 4 ft) apart. Everything else is the backyard coop's. */
  var WI = {
    W: [1.80, 3.00], W_US: [1.8288, 3.048], W0: 2.40, W0_US: 2.4384,
    L_MAX: 7.20, L_MAX_US: 7.3152, HENS: [6, 20], HENS0: 10,
    LH: [1.20, 2.60], LH_US: [1.2192, 2.7432], RUN_MIN: 1.80, RUN_MIN_US: 1.8288,
    FLOOR_H: 0.42, FLOOR_H_US: 0.4064, EAVE_H: 2.44, EAVE_H_US: 2.4384,
    DOOR_W: 0.76, DOOR_W_US: 0.762, RDOOR: 0.76, RDOOR_US: 0.762,
    WIN_W: 0.61, WIN_W_US: 0.6096, WIN_H: 0.46, WIN_H_US: 0.4572, WIN_SILL: 0.91, WIN_SILL_US: 0.9144
  };
  function _phIsWi(s) { return ((s || STATE).variant | 0) === 39; }   /* v383 the walk-in coop */
  /* ------------------------------------------------------------------
     v386 TYPE 42 -- COOP 4: THE LEAN-TO COOP (Marek 2026-10-30 13:27
     "Dalsi krok", chose it in the question panel: a coop against the
     wall of a house or a garage, the roof falling away from it, tied to
     it by a flashing and angle brackets -- the lean-to greenhouse's way).
     The backyard coop's build (_coLayout, its CO sizes: 2-12 hens, the
     house 4 ft2 / 0.37 m2 a hen, the footprint 10 ft2 / 0.93 m2 a hen,
     the run on the toggle) with:
       - ONE 20 deg SLOPE (the modern house's mono roof): one-piece
         rafters from 1 cm off the house wall to past the eave, a
         birdsmouth on each side beam (the high one's seat on its inner
         part), an 8x200 down through each seat; a fly rafter of the same
         piece on each end -- the side beams run on past both end walls
         under them; no ridge, no ties, no caps. The left (house) posts,
         beam and wall reach up to the roof's line; the right ones stay
         at the eave (1.52 m / US 5 ft).
       - AT THE HOUSE: its own posts on ground screws, their outer faces
         GAP (5 cm, US 2 in.) off the house wall (self-supporting); an
         endwall flashing ROR00013 (its roof leg over the shingles' top
         edge, its leg up the wall under the house's cladding), a roofing
         nail through it into each rafter; reinforced angle brackets
         FAT00005 under the high beam (its ends past the walls and every
         run bay; three 5x40 up into the beam, two concrete screw anchors
         FAS10075 into the wall); a 1x4 closer over the gap at the back
         (and at the front without the run); no side corner boards and
         no apron on the house side.
       - NO WINDOW (that wall is against the house): the back's raked
         vent under the high rafters is the air. The nest boxes, the
         doors, the roosts, the ramp, the run as the backyard coop's.
     The house wall is drawn as context only (see-through, not billed,
     not in AR). X across (-X the house), Y up, Z along. */
  var LN = { PITCH: 20, GAP: 0.05, GAP_US: 0.0508, HOUSE_T: 0.25 };
  function _phIsLn(s) { return ((s || STATE).variant | 0) === 42; }   /* v386 the lean-to coop */
  /* ------------------------------------------------------------------
     v391 TYPE 46 -- COOP 5: THE CUPOLA COOP (Marek 2026-10-30 14:30 "Udelej i
     variantu jakou mame na main product picture"; 14:45 question panel: the
     run's top in hardware cloth, the name Cupola Coop). The product picture's
     coop: a tall hen house under a steep gable with a cupola and a
     weathervane on its ridge, a window with shutters over a small door in its
     gable, the nest boxes off its side, a lower run joined to its other side
     with a flat top of hardware cloth, the ground under the house the run's.
     The backyard coop's house alone (_coLayout with the run off) with:
       - SIZES: the flock (2-10, 4) sets the house's width (the square root
         of its 4 ft2 / 0.37 m2 a hen, 1.20-1.80 m / US 4-6 ft) and its least
         depth (the backyard coop's house length: the area, the roosts, the
         nests); L, the depth of house and run alike, on the front / back
         grips up to 2.40 m (US 8 ft); W, the whole width, on the side grips
         -- the run's length -- from what the flock needs (10 ft2 / 0.93 m2 a
         hen over the footprint, the run >= 1.20 m / US 4 ft) up to 4.80 m
         (US 16 ft); the slider fits L and W to the flock again.
       - THE HOUSE: 7 ft (2.13 m) to the beams' top, a 40 deg gable (the
         backyard coop's roof); the back gable closed with siding over gable
         studs (the cupola is the vent); in the back wall an access door 18 x
         22 in. (46 x 56 cm) under a 2x4 header, a window of its width and 16
         in. (41 cm) over it under a 2x4 header of its own on short jacks
         (hardware cloth inside), one casing round both with a board over
         the door's header, a shutter of two T&G boards each side screwed
         into a stud of its own; the pop door in the left wall, its ramp
         down into the run; the partition (the front gable) closed; the nest
         boxes, the roosts and the floor the backyard coop's.
       - THE CUPOLA on the ridge's middle: two 2x4 saddles cut to the roof
         (an 8x200 down through each into the ridge board), panel siding
         round them, four 2x4 corner posts toed onto them, three 1x4 louvers
         a face (5x60 into the posts), a 2x4 frame on top, a 45 deg pyramid
         roof (OSB, underlay, shingles, hip caps, drip edge -- by area); the
         hardware cloth on the saddles under it (over the vent hole cut in
         the roof's OSB at the ridge); the weathervane on its top (MISSING).
       - THE RUN on the left: its own 4x4 posts on ground screws (5 mm off
         the house's corner boards, <= 1.22 m / US 4 ft apart), 4x6 beams
         along its sides (white, the picture's rim), the top just under the
         house's eave -- 2x4 joists across at <= 60 cm (US 24 in.) and a 2x4
         plate at its end, hardware cloth over it; bottom rails and mid
         rails, knee braces at the end's corners; the run door in its front
         side next to the house (a 2x4 frame clothed, strap hinges on the
         post, a 2x4 latch stud); hardware cloth on its sides and end and
         round the house's floor on its other three sides (the ground under
         the house the run's), the apron buried round all.
     X across (-X the run), Y up, Z along; the house is built centred on X =
     0 and moved to its end of the footprint at the last (the footprint's
     grips stay centred). */
  var CU = {
    HENS: [2, 10], HENS0: 4, WH: [1.20, 1.80], WH_US: [1.2192, 1.8288], W_MAX: 4.80, W_MAX_US: 4.8768,
    EAVE_H: 2.13, EAVE_H_US: 2.1336, PITCH: 40,
    DOOR_W: 0.46, DOOR_W_US: 0.4572, DOOR_H: 0.56, DOOR_H_US: 0.5588, WIN_H: 0.41, WIN_H_US: 0.4064,
    CUP: 0.40, CUP_US: 0.4064, CUP_H: 0.30, CUP_H_US: 0.3048, CUP_OV: 0.05, CUP_OV_US: 0.0508, VANE_H: 0.50, VANE_H_US: 0.508,
    MID_H: 0.95, MID_H_US: 0.9144, RJ_SP: 0.60, RJ_SP_US: 0.6096,
    VANE_NAME: 'WEATHERVANE, ROOSTER, ALUMINUM, WITH ITS ROOF MOUNT'
  };
  function _phIsCu(s) { return ((s || STATE).variant | 0) === 46; }   /* v391 the cupola coop */
  function _phIsBn(s) { return ((s || STATE).variant | 0) === 49; }   /* v397 the barn coop */
  /* v401 THE HOOP COOP (type 52): the run's width W (the hoop house's 3.00-4.20 m, US 10-14 ft), the house's width WH (a square-ish
     house, 4 ft2 a hen), the walkway behind the house GAP_B (its access door opens into it), beside it WALK, the run clear in front of
     the ramp's foot RUN_FRONT; the tarp over the house's end TARP_OV past its front; the hog rings HOG_SP apart on the hoops */
  var HP = {
    W: [3.00, 4.20], W_US: [3.048, 4.2672], W0: 3.00, W0_US: 3.048, L_MAX: 7.20, L_MAX_US: 7.3152,
    WH: [1.20, 2.10], WH_US: [1.2192, 2.1336], GAP_B: 0.70, GAP_B_US: 0.7112, WALK: 0.75, WALK_US: 0.762, RUN_FRONT: 1.00, RUN_FRONT_US: 0.9144,
    TARP_OV: 0.30, TARP_OV_US: 0.3048, TARP_T: 0.0006, HOG_SP: 0.15, HOG_SP_US: 0.1524,
    TARP_NAME: 'HEAVY-DUTY POLY TARP, UV-RESISTANT, WITH BUNGEE CORDS -- OVER THE HOOPS AT THE HOUSE',
    HOG_NAME: 'HOG RINGS 3/4 IN., GALVANIZED, WITH THE PLIERS -- THE HARDWARE CLOTH TO THE HOOPS'
  };
  function _phIsHp(s) { return ((s || STATE).variant | 0) === 52; }   /* v401 the hoop coop */
  function _hpWh(s) { var R = _coU(s, 'WH'); return Math.max(R[0], Math.min(R[1], _coUp(s, Math.sqrt(_coHens(s) * _coU(s, 'HOUSE_M2'))))); }
  function _hpRampRun(s) { return _coU(s, 'FLOOR_H') / Math.tan(CO.RAMP_ANG * Math.PI / 180) + 0.10; }
  function _hpWRange(s) {
    var Wh = _hpWh(s);
    if (!_coRun(s)) return { min: Wh, max: Wh };
    var R = _coU(s, 'W'), need = _coUp(s, Wh + 2 * _coU(s, 'WALK'));
    return { min: Math.min(R[1], Math.max(R[0], need)), max: R[1] };
  }
  function _hpRange(s) {
    var Lh = _coLh(s, _hpWh(s));
    if (!_coRun(s)) return { min: Lh, max: Lh };
    var mx = _coU(s, 'L_MAX'), need = Math.max(_coUp(s, 2 * _ghProf(s).sd + _coU(s, 'GAP_B') + Lh + _hpRampRun(s) + _coU(s, 'RUN_FRONT')), _coUp(s, _coHens(s) * _coU(s, 'RUN_M2') / _phW(s)));
    return { min: Math.min(mx, need), max: mx };
  }
  /* the layout's return with the run's footprint (the house's shifted to the back inside it) */
  function _hpRet(o, h) {
    if (!h) return o;
    o.L = o.length = h.L; o.W = o.depth = h.W; o.zF = h.L / 2;
    o.top = o.height = Math.max(o.top, h.top);
    o.extX = Math.max(o.extX, h.extX); o.extZ = h.extZ;
    o.run = true; o.hcz = h.hcz; o.tunnel = h;
    return o;
  }
  /* v397 THE BARN COOP'S GAMBREL: the little barn's profile (_brLayout, BR.KX / KY / RY) on the coop's seat -- the trusses' underside
     from the seat (xh) steeply up to the inner knee, gently up to the peak; the top line a 2x4's depth above, the outer knee where the
     two top lines meet */
  function _coGambrel(xh, yPT, sd) {
    var tn1 = BR.KY / (1 - BR.KX), tn2 = (BR.RY - BR.KY) / BR.KX, a1 = Math.atan(tn1), a2 = Math.atan(tn2), cs1 = Math.cos(a1), cs2 = Math.cos(a2);
    var dV1 = sd / cs1, dV2 = sd / cs2, xk = xh * BR.KX, yk = yPT + xh * BR.KY;
    function yU(x) { var a = Math.abs(x); return (a >= xk) ? yPT + (xh - a) * tn1 : yk + (xk - a) * tn2; }
    var xkt = (xh * tn1 - xk * tn2 - (yk - yPT) - dV2 + dV1) / (tn1 - tn2);
    function yTop(x) { var a = Math.abs(x); return (a >= xkt) ? yPT + (xh - a) * tn1 + dV1 : yk + (xk - a) * tn2 + dV2; }
    return { tn1: tn1, tn2: tn2, a1: a1, a2: a2, cs1: cs1, cs2: cs2, dV1: dV1, dV2: dV2, xk: xk, yk: yk, xkt: xkt, yKt: yTop(xkt), yU0: yU(0), yT0: yTop(0), yU: yU, yTop: yTop };
  }
  function _cuJg(s) { var P = _phProf(s); return P.sg + P.tt + 0.005; }   /* the house's frame face to the run posts' face (the corner boards + 5 mm) */
  function _cuWh(s) { var R = _coU(s, 'WH'); return Math.max(R[0], Math.min(R[1], _coUp(s, Math.sqrt(_coHens(s) * _coU(s, 'HOUSE_M2'))))); }
  function _cuRange(s) { var mx = _coU(s, 'LH')[1]; return { min: Math.min(mx, _coLh(s, _cuWh(s))), max: mx }; }
  function _cuWRange(s) {
    var Wh = _cuWh(s);
    if (!_coRun(s)) return { min: Wh, max: Wh };
    var need = _coUp(s, Math.max(Wh + _cuJg(s) + _coU(s, 'RUN_MIN'), _coHens(s) * _coU(s, 'RUN_M2') / _phL(s))), mx = _coU(s, 'W_MAX');
    return { min: Math.min(mx, need), max: mx };
  }
  function _coU(s, k) { s = s || STATE; var Tb = (_phIsWi(s) && WI[k] != null) ? WI : (_phIsCu(s) && CU[k] != null) ? CU : (_phIsHp(s) && HP[k] != null) ? HP : CO;   /* v401 the hoop coop's own first */   /* v391 the cupola coop's own first too */ return (s.isMetric === false && Tb[k + '_US'] != null) ? Tb[k + '_US'] : Tb[k]; }   /* v383 the walk-in's own first */
  function _phIsCo(s) { var v = ((s || STATE).variant | 0); return v === 34 || v === 39 || v === 42 || v === 46 || v === 49 || v === 52; }   /* v401 + the hoop coop */   /* v397 + the barn coop */   /* v391 + the cupola coop */   /* v386 + the lean-to coop */   /* v383 + the walk-in coop (the backyard coop's layout) */
  function _coHens(s) { s = s || STATE; var v = Math.round(+s.coHens), H = _coU(s, 'HENS'); return Math.max(H[0], Math.min(H[1], (isFinite(v) && v > 0) ? v : _coU(s, 'HENS0'))); }
  function _coRun(s) { return (s || STATE).coRun !== false; }
  function _coUp(s, v) { var q = _coU(s, 'STEP'); return Math.round(Math.ceil(v / q - 1e-6) * q * 10000) / 10000; }
  function _coNests(s) { return Math.max(1, Math.ceil(_coHens(s) / CO.HENS_NEST - 1e-9)); }
  function _coRoosts(s, W) { return Math.max(1, Math.ceil(_coHens(s) * _coU(s, 'ROOST_HEN') / (W - 2 * _phProf(s).p) - 1e-9)); }
  /* the house: 4 ft2 a hen -- and room for the roosts at the back and the nest boxes in front of them on the right wall */
  function _coFitLh(s, W, n) {
    var P = _phProf(s), nR = _coRoosts(s, W), NB = _coU(s, 'NEST');
    var roostEnd = P.sd + _coU(s, 'ROOST_WALL') + (nR - 1) * _coU(s, 'ROOST_GAP') + P.sd / 2;
    return roostEnd + CO.NEST_GAP + n * NB + (n - 1) * P.fl + 2 * P.st + CO.NEST_POST + P.p;
  }
  function _coLh(s, W) {
    var LH = _coU(s, 'LH'), a = _coUp(s, _coHens(s) * _coU(s, 'HOUSE_M2') / W), f = _coUp(s, _coFitLh(s, W, _coNests(s)));
    return Math.max(LH[0], Math.min(LH[1], Math.max(a, f)));
  }
  function _coWRange(s) {
    if (_phIsHp(s)) return _hpWRange(s);   /* v401 the hoop coop: the run's width (run off: the house's) */
    if (_phIsCu(s)) return _cuWRange(s);   /* v391 the cupola coop: the whole width (house + run) */
    var R = _coU(s, 'W'), N = _coHens(s), need = _coUp(s, N * _coU(s, 'HOUSE_M2') / _coU(s, 'LH')[1]);
    if (_coRun(s)) need = Math.max(need, _coUp(s, N * _coU(s, 'RUN_M2') / _coU(s, 'L_MAX')));
    return { min: Math.min(R[1], Math.max(R[0], need)), max: R[1] };
  }
  function _coRange(s) {
    if (_phIsHp(s)) return _hpRange(s);   /* v401 the hoop coop: the run's length (run off: the house's) */
    if (_phIsCu(s)) return _cuRange(s);   /* v391 the cupola coop: the depth (house and run alike) */
    var W = _phW(s), Lh = _coLh(s, W);
    if (!_coRun(s)) return { min: Lh, max: Lh };
    var mx = _coU(s, 'L_MAX'), need = Math.max(_coUp(s, Lh + _coU(s, 'RUN_MIN')), _coUp(s, _coHens(s) * _coU(s, 'RUN_M2') / W));
    return { min: Math.min(mx, need), max: mx };
  }
  function _coLayout(s) {
    s = s || STATE;
    var bn = _phIsBn(s);   /* v397 the barn coop: the backyard coop under the little barn's gambrel */
    var hp = _phIsHp(s), hpRun = hp && _coRun(s);   /* v401 the hoop coop: the backyard coop's house alone, the hoop house's run round it (hpRun) */
    var cu = _phIsCu(s), cuRun = cu && _coRun(s), Wt = _phW(s);   /* v391 cu: the cupola coop -- the backyard coop's house alone (run off) W wide, its own run on the left (cuRun), Wt the whole width */
    var P = _phProf(s), us = (s.isMetric === false), run = _coRun(s) && !cu && !hp, N = _coHens(s), W = cu ? _cuWh(s) : hp ? _hpWh(s) : Wt, Lh = cu ? _phL(s) : _coLh(s, W), L = run ? _phL(s) : Lh, wi = _phIsWi(s), ln = _phIsLn(s);   /* v383 wi: the walk-in coop */   /* v386 ln: the lean-to coop */
    var i, k, m, sx, sz, e, f;
    var jh = P.jh, jt = P.jt, st = P.st, sd = P.sd, bw = P.bw, bh = P.bh, p = P.p, sg = P.sg, tt = P.tt, cw = P.cw, tw = P.tw, nt = P.fl;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10,
        len80 = us ? 0.0762 : 0.08, len60 = us ? 0.0635 : 0.06, len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], blocks = [], hw = [], gscrews = [], uheads = [], missing = [], coat = 0, hinges = 0, knobs = 0, catches = 0, bolts = 0;
    var meshA = 0, apronA = 0, stapleL = 0, nestA = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], q; for (q = 0; q <= n; q++) out.push(a + (b - a) * q / n); return out; }
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, q, q2;
      for (q = 0; q < cands.length; q++) {
        var c0 = cands[q], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var fq = fas[q2], f0 = [fq.x, fq.y, fq.z], f1 = [fq.x + fq.dir[0] * fq.len, fq.y + fq.dir[1] * fq.len, fq.z + fq.dir[2] * fq.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (fq.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    /* v391 the cupola coop: what a step built in the backyard coop's frame (the partition's pop door, its ramp) turned onto the left wall --
       (x, z) to (-z, x + tz), a quarter turn about Y; and everything moved along X at the last (the house to its end of the footprint) */
    function cuMap(i0, tz) {
      var q, ptm = function (a2) { return [-a2[2], a2[1], a2[0] + tz]; };
      for (q = i0[0]; q < pieces.length; q++) {
        var pq = pieces[q];
        if (pq.box) { var b2 = pq.box; pq.box = [-b2[2], b2[1], b2[0] + tz, b2[5], b2[4], b2[3]]; }
        else if (pq.quad) pq.quad = pq.quad.map(ptm);
        else if (pq.plane === 'xy') { pq.plane = 'zy'; pq.poly = pq.poly.map(function (a2) { return [a2[0] + tz, a2[1]]; }); if (pq.holes) pq.holes = pq.holes.map(function (h2) { return h2.map(function (a2) { return [a2[0] + tz, a2[1]]; }); }); pq.c = -pq.c; }
        else if (pq.plane === 'zy') { pq.plane = 'xy'; pq.poly = pq.poly.map(function (a2) { return [-a2[0], a2[1]]; }); if (pq.holes) pq.holes = pq.holes.map(function (h2) { return h2.map(function (a2) { return [-a2[0], a2[1]]; }); }); pq.c = pq.c + tz; }
        else if (pq.plane === 'xz') pq.poly = pq.poly.map(function (a2) { return [-a2[1], a2[0] + tz]; });
      }
      for (q = i0[1]; q < fas.length; q++) { var fq = fas[q], dq = fq.dir, nx2 = -fq.z, nz2 = fq.x + tz; fq.x = nx2; fq.z = nz2; fq.dir = [-dq[2], dq[1], dq[0]]; }
      for (q = i0[2]; q < hw.length; q++) { var hq = hw[q]; if (hq.box) { var hb2 = hq.box; hq.box = [-hb2[2], hb2[1], hb2[0] + tz, hb2[5], hb2[4], hb2[3]]; } }
    }
    function cuShift(dx) {
      pieces.forEach(function (pq) {
        if (pq.box) pq.box[0] += dx;
        else if (pq.quad) pq.quad = pq.quad.map(function (a2) { return [a2[0] + dx, a2[1], a2[2]]; });
        else if (pq.plane === 'zy') pq.c += dx;
        else { pq.poly = pq.poly.map(function (a2) { return [a2[0] + dx, a2[1]]; }); if (pq.holes) pq.holes = pq.holes.map(function (h2) { return h2.map(function (a2) { return [a2[0] + dx, a2[1]]; }); }); }
      });
      fas.forEach(function (fq) { fq.x += dx; });
      hw.forEach(function (hq) { if (hq.box) hq.box[0] += dx; if (hq.cyl) hq.cyl[0] += dx; if (hq.cylX) hq.cylX[0] += dx; });
      gscrews.forEach(function (g2) { g2.x += dx; });
      uheads.forEach(function (u2) { u2.x += dx; });
      posts.forEach(function (q2) { q2.x += dx; });
    }
    function perim(pts) { var a = 0, q; for (q = 0; q < pts.length; q++) { var A = pts[q], B = pts[(q + 1) % pts.length]; a += Math.sqrt((B[0] - A[0]) * (B[0] - A[0]) + (B[1] - A[1]) * (B[1] - A[1])); } return a; }
    /* a sheet of hardware cloth (drawn as its wire, billed by area: MISSING); its edges stapled */
    function mesh(id, pts, plane, c, holes, apron) {
      pieces.push({ kind: 'mesh', code: null, len: 0, id: id, poly: pts, plane: plane, c: c, t: CO.MESH_T, holes: holes || null });
      var a = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) { a -= _phArea(holes[q]); stapleL += perim(holes[q]); }
      if (apron) apronA += a; else { meshA += a; stapleL += perim(pts); }
      return a;
    }
    var clr = _phU(s, 'DOOR_CLR'), mo = CO.MESH_OFF;
    /* THE HEIGHTS: a post's foot in its U head, the house's floor (its beams' top / underside), the side beams (= the
       rafters' seat), the across walls' top plates, the bottom rails laid flat over the U heads' flanges */
    var yH = _phU(s, 'FOOT_UP'), yPB = yH + PH.U_UP;
    var yF = _coU(s, 'FLOOR_H'), yJ1 = yF - nt, yFB = yJ1 - bh, yP0 = yF + st;
    var yPT = _coU(s, 'EAVE_H'), yBm = yPT - bh, yGT = yPT - st;
    var yRl0 = yPB + PH.U_FL + 0.01, yRl1 = yRl0 + st;
    var zH = -L / 2 + Lh, xB = W / 2 - p, xa = W / 2 + sg;
    /* v386 THE LEAN-TO: the house wall's face xHw (GAP off the posts' / beams' outer faces); the roof falls from it to the right,
       so the left posts, beam and side wall reach up to its line, the right ones stay at the eave (yPTs / yBms by side); the
       side beams run on past both ends under the fly rafters (zBb..zBf) */
    var gapH = ln ? (us ? LN.GAP_US : LN.GAP) : 0, xHw = -(W / 2 + gapH), rkE = _phU(s, 'RAKE'), len75 = us ? 0.0762 : 0.075;
    var yPTL = ln ? yPT + (W - bw) * Math.tan(LN.PITCH * Math.PI / 180) : yPT, yBmL = yPTL - bh;
    function yPTs(sx2) { return (sx2 < 0) ? yPTL : yPT; }
    function yBms(sx2) { return yPTs(sx2) - bh; }
    var zBb = ln ? -(L / 2 + sg + rkE) : -L / 2, zBf = ln ? L / 2 + sg + rkE : L / 2;

    /* THE POSTS: back corners, the house's front, then <= 1.22 m (US 4 ft) apart to the run's front corners;
       each in a U head on a ground screw (the stilt house's pier: 12 connector nails, the flanges on its X faces) */
    var posts = [], zb = -L / 2 + p / 2, zh = zH - p / 2, zf = L / 2 - p / 2, zList = [zb, zh];
    if (run) { var nRp = Math.max(1, Math.ceil((zf - zh) / _coU(s, 'POST_SP') - 1e-9)); for (i = 1; i <= nRp; i++) zList.push(zh + (zf - zh) * i / nRp); }
    function pier(x, z, id) {
      gscrews.push({ x: x, z: z, r: _phU(s, 'GS_R'), y1: yH, id: id });
      uheads.push({ x: x, z: z, y0: yH, y1: yPB, w: p, id: id });
      for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++)
        scr('nail-uhead', PH.UNAIL, x + sd2 * (p / 2 + PH.U_T), yPB + 0.02 + rI * 0.025, z + cI * ((sd2 < 0) ? 0.022 : 0.034), [-sd2, 0, 0], len38, 0.0019);
    }
    for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < zList.length; i++) {
      var pid = (sx < 0 ? 'l' : 'r') + (i + 1), pxx = sx * (W / 2 - p / 2);
      posts.push({ x: pxx, z: zList[i], sx: sx, id: pid, i: i });
      pier(pxx, zList[i], 'post-' + pid);
      box('post', PH.POST, ceil2(yBms(sx) - yPB), 'post-' + pid, pxx, (yPB + yBms(sx)) / 2, zList[i], p, yBms(sx) - yPB, p);   /* v386 the lean-to's left ones up to the high beam */
      coat += 4 * p * (yBms(sx) - yPB);
    }
    /* THE SIDE BEAMS: a 4x6 on the posts' tops the whole length, two 8x260 down into each post */
    for (sx = -1; sx <= 1; sx += 2) {
      box('beam', PH.BEAM, ceil2(zBf - zBb), 'beam-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), yBms(sx) + bh / 2, (zBb + zBf) / 2, bw, bh, zBf - zBb);   /* v386 the lean-to's past both ends, the left one high */
      coat += 2 * (bw + bh) * (zBf - zBb);
    }
    posts.forEach(function (q2) { for (var e1 = -1; e1 <= 1; e1 += 2) scr('screw-cbeam', PH.FBEAM_SCREW, q2.x + e1 * p / 4.5, yPTs(q2.sx), q2.z, [0, -1, 0], len260); });

    /* THE HOUSE'S FLOOR: 4x6 floor beams in the posts' planes (the sides between the back post and the house's front
       one, the ends between the side posts), two 8x200 through the post into each end at heights of their own (the
       side beams' along Z and the ends' along X cross inside a corner post); 2x6 joists between the side beams at <=
       40 cm (US 16 in.), two 8x200 through the side beam into each end; OSB over all, notched round the posts */
    var zB0 = -L / 2 + p, zB1 = zH - p;
    for (sx = -1; sx <= 1; sx += 2) {
      var fx = sx * (W / 2 - p / 2);
      box('fbeam', PH.BEAM, ceil2(zB1 - zB0), 'fbeam-' + (sx < 0 ? 'l' : 'r'), fx, yFB + bh / 2, (zB0 + zB1) / 2, bw, bh, zB1 - zB0);
      coat += 2 * (bw + bh) * (zB1 - zB0);
      for (k = 0; k < 2; k++) {
        scr('screw-fbeam', PH.BEAM_SCREW, fx + (k ? 0.02 : -0.02), yFB + bh * (0.2 + 0.35 * k), -L / 2, [0, 0, 1], len200);
        scr('screw-fbeam', PH.BEAM_SCREW, fx + (k ? -0.02 : 0.02), yFB + bh * (wi ? 0.6 + 0.3 * k : 0.2 + 0.35 * k), zH, [0, 0, -1], len200);   /* v383 the walk-in: over its run rail's end */
      }
    }
    [[zb, 'b'], [zh, 'f']].forEach(function (e2) {
      box('fbeam', PH.BEAM, ceil2(2 * xB), 'ebeam-' + e2[1], 0, yFB + bh / 2, e2[0], 2 * xB, bh, bw);
      coat += 2 * (bw + bh) * 2 * xB;
      for (var s2 = -1; s2 <= 1; s2 += 2) for (var k2 = 0; k2 < 2; k2++) scr('screw-fbeam', PH.BEAM_SCREW, s2 * W / 2, yFB + bh * (0.4 + 0.4 * k2), e2[0] + (k2 ? 0.02 : -0.02), [-s2, 0, 0], len200);
    });
    var joists = [], nJ = Math.max(1, Math.ceil((zB1 - zB0) / _phU(s, 'JOIST_SP') - 1e-9));
    for (i = 1; i < nJ; i++) {
      var zq = zB0 + (zB1 - zB0) * i / nJ;
      joists.push({ z: zq });
      box('joist', PH.JOIST, ceil2(2 * xB), 'joist-' + i, 0, yJ1 - jh / 2, zq, 2 * xB, jh, jt);
      for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-joist', PH.BEAM_SCREW, sx * W / 2, yJ1 - jh * (0.3 + 0.4 * k), zq, [-sx, 0, 0], len200);
    }
    var fpts = [[-xB, -L / 2], [xB, -L / 2], [xB, -L / 2 + p], [W / 2, -L / 2 + p], [W / 2, zH - p], [xB, zH - p], [xB, zH], [-xB, zH], [-xB, zH - p], [-W / 2, zH - p], [-W / 2, -L / 2 + p], [-xB, -L / 2 + p]];
    pieces.push({ kind: 'floor', code: PH.FLOOR, len: 0, id: 'floor', poly: fpts, plane: 'xz', c: yJ1 + nt / 2, t: nt });
    var floorA = _phArea(fpts);

    /* THE WALLS, framed in the posts' planes between them along their own axis u (z on the sides, x on the back wall and
       the partition): a 2x4 bottom plate on the floor (cut under a door), the studs at <= 60 cm from the first post (and a
       stud of its own under each roost's cleat), an opening's kings + header + sill + cripples (a window, the nest boxes) or
       kings + jacks + header (a door) -- the playhouses' framing; the side walls' studs under the beam (an 8x200 down
       through it), the across walls' under a 2x4 top plate (two 6x120 down through it) */
    var spS = _phU(s, 'STUD_SP');
    function coWall(id, side, u0, u1, yTop, topKind, yPl, op, extra) {
      var hs = (side.ax === 'z');
      function at(u, y, n) { return hs ? [side.c + side.o * n, y, u] : [u, y, side.c + side.o * n]; }
      function bx(kind, code, len, sid, u, y, n, du, dy, dn) { var Pt = at(u, y, n); if (hs) box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], dn, dy, du); else box(kind, code, len, sid, Pt[0], Pt[1], Pt[2], du, dy, dn); }
      function sc(kind, code, u, y, n, du, dy, dn, ln) { var Pt = at(u, y, n), dd = hs ? [side.o * dn, dy, du] : [du, dy, side.o * dn]; scr(kind, code, Pt[0], Pt[1], Pt[2], dd, ln); }
      var uc = op ? op.u : 0, half = op ? op.w / 2 : 0, door = !!(op && op.kind === 'door'), oL = op ? (door ? half + 2 * st : half + st) : 0, m2, e3, f3;
      var grid = [], cand = [];
      for (m2 = 1; u0 + m2 * spS < u1 - st / 2 - 0.04; m2++) grid.push(u0 + m2 * spS);
      grid.forEach(function (u) { cand.push({ u: u, x: false }); });
      (extra || []).forEach(function (u) { cand.push({ u: u, x: true }); });
      cand = cand.filter(function (c2) { return (!op || Math.abs(c2.u - uc) > oL + st / 2 - 1e-6) && c2.u > u0 + st / 2 + 0.01 && c2.u < u1 - st / 2 - 0.01; });
      cand.sort(function (a, b) { return a.u - b.u; });
      var keep = [];
      cand.forEach(function (c2) {   /* a stud too near the one before it: the roost's stays */
        var prv = keep[keep.length - 1];
        if (!prv || c2.u - prv.u > st + 0.02) keep.push(c2); else if (c2.x && !prv.x) keep[keep.length - 1] = c2;
      });
      var full = keep.map(function (c2) { return c2.u; });
      if (op) full.push(uc - oL + st / 2, uc + oL - st / 2);
      full.sort(function (a, b) { return a - b; });
      var plates = door ? [[u0, uc - half], [uc + half, u1]] : [[u0, u1]];
      plates.forEach(function (pl, pi) { bx('plate', PH.STUD, ceil2(pl[1] - pl[0]), id + '-plate-' + (pi + 1), (pl[0] + pl[1]) / 2, yF + st / 2, 0, pl[1] - pl[0], st, sd); });
      full.forEach(function (u, si) {
        bx('stud', PH.STUD, ceil2(yTop - yP0), id + '-stud-' + (si + 1), u, (yP0 + yTop) / 2, 0, st, yTop - yP0, sd);
        for (var e4 = -1; e4 <= 1; e4 += 2) sc('screw-stud', PH.STUD_SCREW, u, yF, e4 * sd / 4, 0, 1, 0, len120);
        if (topKind === 'beam') sc('screw-beam', PH.BEAM_SCREW, u, yPl, 0, 0, -1, 0, len200);
        else for (e4 = -1; e4 <= 1; e4 += 2) sc('screw-tplate', PH.STUD_SCREW, u, yPl, e4 * 0.4 * sd, 0, -1, 0, len120);
      });
      /* the cripples under a window: the grid's studs inside it (or one in its middle) */
      var cr = [];
      if (op && !door) { grid.forEach(function (u) { if (Math.abs(u - uc) < half - st / 2) cr.push(u); }); if (!cr.length) cr = [uc]; }
      /* the plate's screws: between every two members (the posts' faces too), clear of the floor's own screws */
      var mem = [u0 - st / 2, u1 + st / 2].concat(full, cr).sort(function (a, b) { return a - b; });
      for (m2 = 0; m2 + 1 < mem.length; m2++) {
        var um = (mem[m2] + mem[m2 + 1]) / 2, onPl = plates.some(function (h2) { return um > h2[0] + 0.03 && um < h2[1] - 0.03; });
        if (onPl && mem[m2 + 1] - mem[m2] > 0.15) scrClear('screw-plate', PH.PLATE_SCREW, [um, um + 0.02, um - 0.02, um + 0.04, um - 0.04].map(function (u3) { return at(u3, yP0, 0); }), [0, -1, 0], len160);
      }
      if (op && !door) {
        /* a WINDOW / the NEST BOXES' opening: a 2x4 header on edge at the outer face, a flat 2x4 sill, the cripples */
        var yWS = op.y0, yWT = op.y1, hdT = yWT + sd;
        bx('stud', PH.STUD, ceil2(2 * half), id + '-whead', uc, yWT + sd / 2, sd / 2 - st / 2, 2 * half, sd, st);
        bx('stud', PH.STUD, ceil2(2 * half), id + '-wsill', uc, yWS - st / 2, 0, 2 * half, st, sd);
        for (e3 = -1; e3 <= 1; e3 += 2) for (f3 = 0; f3 < 2; f3++) {
          sc('screw-frame', PH.STUD_SCREW, uc + e3 * oL, yWT + sd * (0.3 + 0.4 * f3), sd / 2 - st / 2, -e3, 0, 0, len120);
          sc('screw-frame', PH.STUD_SCREW, uc + e3 * oL, yWS - st / 2, (f3 ? 1 : -1) * sd / 4, -e3, 0, 0, len120);
        }
        cr.forEach(function (u, ci) {
          bx('stud', PH.STUD, ceil2(yWS - st - yP0), id + '-cripple-lo-' + (ci + 1), u, (yP0 + yWS - st) / 2, 0, st, yWS - st - yP0, sd);
          if (yTop - hdT > 0.03) bx('stud', PH.STUD, ceil2(yTop - hdT), id + '-cripple-hi-' + (ci + 1), u, (hdT + yTop) / 2, 0, st, yTop - hdT, sd);
          for (var e5 = -1; e5 <= 1; e5 += 2) {
            sc('screw-stud', PH.STUD_SCREW, u, yF, e5 * sd / 4, 0, 1, 0, len120);
            sc('screw-frame', PH.STUD_SCREW, u, yWS, ((e5 < 0) ? -0.4 : 0.1) * sd, 0, -1, 0, len120);
          }
          if (yTop - hdT > 0.03) {
            if (topKind === 'beam') sc('screw-beam', PH.BEAM_SCREW, u, yPl, 0, 0, -1, 0, len200);
            else for (e5 = -1; e5 <= 1; e5 += 2) sc('screw-tplate', PH.STUD_SCREW, u, yPl, e5 * 0.4 * sd, 0, -1, 0, len120);
          }
        });
      }
      if (door) {
        /* a DOOR: jacks under a header on edge at the outer face -- a 2x6 under the top plate (the access door) or a 2x4
           with cripples over it to the top plate (the pop door) */
        var yHd = op.y1, hh = op.hdr, hT = (hh === jh) ? jt : st;
        for (e3 = -1; e3 <= 1; e3 += 2) {
          var uj = uc + e3 * (half + st / 2);
          bx('stud', PH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e3 < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, 0, st, yHd - yP0, sd);
          for (var e6 = -1; e6 <= 1; e6 += 2) sc('screw-stud', PH.STUD_SCREW, uj, yF, e6 * sd / 4, 0, 1, 0, len120);
          for (f3 = 0; f3 < 3; f3++) sc('screw-frame', us ? PH.TIE_SCREW : PH.FRAME_SCREW, uc + e3 * (half + 2 * st), yP0 + (yHd - yP0) * (0.2 + 0.3 * f3), 0, -e3, 0, 0, us ? len80 : len100);   /* the king into the jack (US 6x80: two 2x4s are 3 in.) */
          for (f3 = 0; f3 < 2; f3++) sc('screw-frame', PH.STUD_SCREW, uc + e3 * oL, yHd + hh * (0.3 + 0.4 * f3), sd / 2 - hT / 2, -e3, 0, 0, len120);
        }
        bx('header', (hh === jh) ? PH.HEADER : PH.STUD, ceil2(2 * (half + st)), id + '-header', uc, yHd + hh / 2, sd / 2 - hT / 2, 2 * (half + st), hh, hT);
        var yc0 = yHd + hh, hTc = hT;
        if (op.win) {
          /* v391 the cupola coop: a window over the door -- short jacks on the door's header up to a 2x4 header on edge of its own (op.win its
             underside), the kings screwed into both; the cripple over that one */
          var yW1 = op.win;
          for (e3 = -1; e3 <= 1; e3 += 2) {
            bx('stud', PH.STUD, ceil2(yW1 - yc0), id + '-wjack-' + (e3 < 0 ? 'l' : 'r'), uc + e3 * (half + st / 2), (yc0 + yW1) / 2, 0, st, yW1 - yc0, sd);
            for (f3 = 0; f3 < 2; f3++) sc('screw-frame', us ? PH.TIE_SCREW : PH.FRAME_SCREW, uc + e3 * (half + 2 * st), yc0 + (yW1 - yc0) * (0.3 + 0.4 * f3), 0, -e3, 0, 0, us ? len80 : len100);
            for (f3 = 0; f3 < 2; f3++) sc('screw-frame', PH.STUD_SCREW, uc + e3 * oL, yW1 + sd * (0.3 + 0.4 * f3), sd / 2 - st / 2, -e3, 0, 0, len120);
          }
          bx('header', PH.STUD, ceil2(2 * (half + st)), id + '-wheader', uc, yW1 + sd / 2, sd / 2 - st / 2, 2 * (half + st), sd, st);
          yc0 = yW1 + sd; hTc = st;
        }
        if (yTop - yc0 > 0.03) {
          bx('stud', PH.STUD, ceil2(yTop - yc0), id + '-cripple-1', uc, (yc0 + yTop) / 2, 0, st, yTop - yc0, sd);
          for (var e7 = -1; e7 <= 1; e7 += 2) {
            sc('screw-frame', PH.FRAME_SCREW, uc + e7 * st / 2, yc0 + 0.04, sd / 2 - hTc / 2 + e7 * hTc / 4, -e7 * 0.5, -0.87, 0, len100);   /* toed down into the header (on the wall's outer face), one in front of the other */
            if (topKind === 'beam') { if (e7 < 0) sc('screw-beam', PH.BEAM_SCREW, uc, yPl, 0, 0, -1, 0, len200); }   /* v391 under a beam (the cupola coop's pop door in its side wall): one down through it */
            else sc('screw-tplate', PH.STUD_SCREW, uc, yPl, e7 * 0.4 * sd, 0, -1, 0, len120);
          }
        }
      }
    }
    /* where the openings go: the roosts at the back, the nest boxes as far forward on the right wall as the house lets
       them, the window across from them on the left wall, the doors in the middle of the back wall / the partition */
    var nR = _coRoosts(s, W), NB = _coU(s, 'NEST'), nN = _coNests(s), rw = _coU(s, 'ROOST_WALL'), rgp = _coU(s, 'ROOST_GAP');
    var uS0 = -L / 2 + p, uS1 = zH - p, zRo = [];
    for (k = 0; k < nR; k++) zRo.push(-L / 2 + sd + rw + k * rgp);
    var nestMin = zRo[nR - 1] + sd / 2 + CO.NEST_GAP, nestMax = uS1 - CO.NEST_POST, nWant = nN;
    while (nN > 1 && nN * NB + (nN - 1) * nt + 2 * st > nestMax - nestMin + 1e-6) nN--;
    var nWi = nN * NB + (nN - 1) * nt, zcN = nestMax - st - nWi / 2;
    var woF = Math.min(nestMax - st, zH + sg - tw - cw - 0.005);   /* the window's front edge: inside its bay, its casing clear of the corner board */
    var winW = Math.max(0.20, Math.min(_coU(s, 'WIN_W'), woF - nestMin - st)), zcW = woF - winW / 2;
    var ySN = yF + _coU(s, 'NEST_SILL'), yTN = ySN + NB, ySW = yF + _coU(s, 'WIN_SILL'), yTW = ySW + _coU(s, 'WIN_H');
    function roFor(wNom) { var nB0 = Math.max(2, Math.round((wNom - (P.gw - P.gc)) / P.gc)); return nB0 * P.gc + (P.gw - P.gc) + 2 * clr; }   /* whole T&G boards + the clearances */
    var aHd = wi ? sd : jh, ROa = roFor(_coU(s, 'DOOR_W')), yHa = yGT - aHd, ROp = roFor(_coU(s, 'POP_W')), yHp = yF + _coU(s, 'POP_H') + 2 * clr;
    /* v391 the cupola coop: the access door 22 in. (56 cm) under a 2x4 header, the window over it under its own (yWT its top); a shutter
       of two T&G boards each side on a stud of its own (uSh); the pop door forward in the left wall, clear of the roosts' cleat studs */
    var yDT = yF + _coU(s, 'DOOR_H') + 2 * clr, yWT = yDT + sd + _coU(s, 'WIN_H'), shW = 2 * P.gc, uSh = ROa / 2 + cw + 0.01 + shW / 2, zcPop = uS1 - ROp / 2 - 2 * st - 0.02;   /* v383 the walk-in's access door under a 2x4 on edge */
    coWall('side-r', { ax: 'z', c: W / 2 - sd / 2, o: 1 }, uS0, uS1, yBm, 'beam', yPT, { kind: 'win', u: zcN, w: nWi, y0: ySN, y1: yTN }, zRo);
    coWall('side-l', { ax: 'z', c: -(W / 2 - sd / 2), o: -1 }, uS0, uS1, yBmL, 'beam', yPTL, ln ? null : cu ? { kind: 'door', u: zcPop, w: ROp, y1: yHp, hdr: sd } : { kind: 'win', u: zcW, w: winW, y0: ySW, y1: yTW }, zRo);   /* v386 the lean-to: up to its high beam, no window (against the house) */
    coWall('back', { ax: 'x', c: -L / 2 + sd / 2, o: -1 }, -xB, xB, yGT, 'tplate', yPT, cu ? { kind: 'door', u: 0, w: ROa, y1: yDT, hdr: sd, win: yWT } : { kind: 'door', u: 0, w: ROa, y1: yHa, hdr: aHd }, cu ? [-uSh, uSh] : null);   /* v391 the cupola coop's: a window over its door, the shutters' studs */
    coWall('part', { ax: 'x', c: zH - sd / 2, o: 1 }, -xB, xB, yGT, 'tplate', yPT, cu ? null : { kind: 'door', u: 0, w: ROp, y1: yHp, hdr: sd }, null);   /* v391 the cupola coop's front gable closed (its pop door in the left wall) */
    /* the across walls' top plates between the side beams, two 6x160 through the beam into each end */
    [[-L / 2 + sd / 2, 'back'], [zH - sd / 2, 'part']].forEach(function (e8) {
      box('tplate', PH.STUD, ceil2(2 * xB), e8[1] + '-tplate', 0, yPT - st / 2, e8[0], 2 * xB, st, sd);
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) scr('screw-tpend', PH.JOIST_SCREW, s3 * W / 2, yPT - st / 2, e8[0] + k3 * sd / 4, [-s3, 0, 0], len160);
    });

    /* THE ROOF FRAME (the cottage's at 30 deg): rafter pairs at <= 60 cm from the back gable to the partition (a pair over
       it) and on to the run's front gable, the 2x6 ridge board, a fly rafter past each gable, the ties beside every pair but
       the gables' and the partition's, the partition's gable studs (its triangle closed; the back one is the vent) */
    var th = bn ? Math.atan(BR.KY / (1 - BR.KX)) : (ln ? LN.PITCH : cu ? CU.PITCH : CO.PITCH) * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = sd / cs;   /* v397 the barn coop: its lower segments' slope */
    var seat = Math.min(bw, dV / (3 * tn)), xh = W / 2 - seat, xr = P.rgt / 2;
    var xo = xa + (bn ? _brU(s, 'EAVE') : _phU(s, 'EAVE')), xe = xo + tt, GB = bn ? _coGambrel(xh, yPT, sd) : null;   /* v397 the barn coop: the little barn's eave and gambrel */
    function yR(x) { if (GB) return GB.yU(x); return yPT + (xh - (ln ? x : Math.abs(x))) * tn; }   /* v386 the lean-to: one slope falling to the right */   /* v397 the barn coop: the trusses' underside */
    function yT(x) { if (GB) return GB.yTop(x); return yR(x) + dV; }
    function polyC(kind, code, len, id, pts, plane, c, t) { poly(kind, code, len, id, (_gzArea(pts) < 0) ? pts.slice().reverse() : pts, plane, c, t); }   /* v397 the little barn's pieces, wound one way */
    var xLe = xHw + 0.01, rgTop = ln ? yT(xLe) : yT(xr), rgBot = rgTop - P.rgd;   /* v386 the lean-to's rafters end 1 cm off the house wall: its top edge there */
    var zA = -L / 2 + st / 2, zPt = zH - sd / 2, zC = L / 2 - st / 2, zr = [], nr1 = Math.max(1, Math.ceil((zPt - zA) / _phU(s, 'RAF_SP') - 1e-9));
    for (i = 0; i <= nr1; i++) zr.push({ z: zA + (zPt - zA) * i / nr1, gable: (i === 0), part: (i === nr1) });
    if (run) { var nr2 = Math.max(1, Math.ceil((zC - zPt) / _phU(s, 'RAF_SP') - 1e-9)); for (i = 1; i <= nr2; i++) zr.push({ z: zPt + (zC - zPt) * i / nr2, gable: (i === nr2) }); }
    var rk = _phU(s, 'RAKE'), zFb = -(L / 2 + sg + rk) + st / 2, zFf = L / 2 + sg + rk - st / 2;
    if (ln) {
      /* v386 THE LEAN-TO'S FRAME (the modern house's mono roof): one-piece rafters at <= 60 cm from the back wall to the
         partition (one over it) and on to the run's front, from the house wall to past the eave, plumb cuts at both ends, a
         birdsmouth on each beam (the high one's seat on its inner part), an 8x200 down through each seat (clear of the posts'
         and studs' screws); a fly rafter of the same piece on each beam's end past the walls; the partition's gable studs up to
         its rafter; no ridge, no ties (the beams carry both ends) */
      var xiL = -W / 2 + bw, xL0 = xiL - seat;
      var rafL = ceil2((xo - xLe) / cs + sd * tn), lnPts = [[xLe, yR(xLe)], [xL0, yPTL], [xiL, yPTL], [xiL, yR(xiL)], [xh, yPT], [W / 2, yPT], [W / 2, yR(W / 2)], [xo, yR(xo)], [xo, yT(xo)], [xLe, yT(xLe)]];
      var lnSeat = function (kind, zq) {
        var dz3 = st / 2 - 0.012;
        [xh, xL0].forEach(function (x5) {
          var cand3 = [];
          [0.5, 0.25, 0.75, 0.15, 0.85].forEach(function (fx3) { [0, 0.012, -0.012, dz3, -dz3].forEach(function (dz4) { cand3.push([x5 + seat * fx3, dz4]); }); });
          scrClear(kind, PH.SEAT_SCREW, cand3.map(function (c5) { return [c5[0], yT(c5[0]), zq + c5[1]]; }), [0, -1, 0], len200);
        });
      };
      for (i = 0; i < zr.length; i++) { poly('rafter', PH.RAFTER, rafL, 'rafter-' + (i + 1), lnPts, 'xy', zr[i].z, st); lnSeat('screw-seat', zr[i].z); }
      var flies = [zFb, zFf];
      for (i = 0; i < 2; i++) { poly('fly', PH.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b'), lnPts, 'xy', flies[i], st); lnSeat('screw-fseat', flies[i]); }
      coat += 2 * 2 * (st + sd) * rafL;
      var zR0 = zFb - st / 2, zR1 = zFf + st / 2, roofLen = zR1 - zR0, nTies = 0, gStuds = 0, gspL = _phU(s, 'GSTUD_SP');
      for (k = 1; ; k++) {
        var gxL = xh - k * gspL, gxa = gxL - st / 2, gxb = gxL + st / 2;
        if (gxa < -xB + 0.005) break;
        if (yR(gxb) - yPT < 0.06) continue;
        poly('gstud', PH.STUD, ceil2(yR(gxa) - yPT), 'gstud-' + k, [[gxa, yPT], [gxb, yPT], [gxb, yR(gxb)], [gxa, yR(gxa)]], 'xy', zPt, sd);
        gStuds++;
        for (var e9l = -1; e9l <= 1; e9l += 2) scr('screw-gstud', PH.FRAME_SCREW, gxL + e9l * st / 2, yPT + (us ? 0.055 : 0.04), zPt + e9l * sd / 4, [-e9l * 0.5, -0.87, 0], len100);
        scr('screw-gstud', PH.FRAME_SCREW, gxL, yR(gxL) - 0.035, zH - 0.005, [0, 0.95, -0.31], len100);
      }
    } else if (bn) {
      /* v397 THE BARN COOP'S GAMBREL (the little barn's trusses, _brLayout, on the coop's side beams): at the rafter pairs' places (the
         back gable, <= 60 cm, the partition, on to the run's front gable) a truss of four 2x4 segments -- the lower ones from a birdsmouth
         on the beam steeply up to the inner knee, the tails cut plumb past the walls, the upper ones gently up to the peak -- with OSB
         gussets at the knees and the peak on the +Z face (the run's front truss on its -Z face), two 5x40 into each segment, two toe
         screws at each foot down into the beam (an 8x200 through the seat would not reach it: the steep segment is 22 cm deep there);
         no ridge board, no ties, no fly rafters (the rake trims on the end trusses); the partition's gable studs up to its truss */
      var tn1 = GB.tn1, tn2 = GB.tn2, cs1 = GB.cs1, cs2 = GB.cs2, dV1 = GB.dV1, dV2 = GB.dV2, xk = GB.xk, yk = GB.yk, xkt = GB.xkt, yKt = GB.yKt, yU0 = GB.yU0, yT0 = GB.yT0;
      var mirB = function (pts, sx2) { var o = pts.map(function (p2) { return [sx2 * p2[0], p2[1]]; }); return (sx2 < 0) ? o.reverse() : o; };
      var extB = function (pts, ang) { var ux = Math.cos(ang), uy = -Math.sin(ang), lo = 1e9, hi = -1e9; pts.forEach(function (p2) { var v = p2[0] * ux + p2[1] * uy; lo = Math.min(lo, v); hi = Math.max(hi, v); }); return hi - lo; };
      var lowPts = [[xk, yk], [xh, yPT], [W / 2, yPT], [W / 2, yR(W / 2)], [xo, yR(xo)], [xo, yT(xo)], [xkt, yKt]];
      var upPts = [[0, yU0], [xk, yk], [xkt, yKt], [0, yT0]];
      var rafL = ceil2(extB(lowPts, GB.a1)), upL = ceil2(extB(upPts, GB.a2));
      var g1 = Math.max(0.20, (xkt - xk) / cs1 + 0.08), g2 = 0.20, gx2 = 0.18 * cs2;
      var Au = [xk + g1 * cs1, yR(xk + g1 * cs1)], At = [Au[0], Au[1] + dV1], Bu = [xk - g2 * cs2, yR(xk - g2 * cs2)], Bt = [Bu[0], Bu[1] + dV2];
      var kneeG = [Au, [xk, yk], Bu, Bt, [xkt, yKt], At], peakG = [[-gx2, yR(-gx2)], [0, yU0], [gx2, yR(gx2)], [gx2, yR(gx2) + dV2], [0, yT0], [-gx2, yR(-gx2) + dV2]];
      var rsG = P.rs, gussetA = 0, flies = [];
      for (i = 0; i < zr.length; i++) {
        var zt = zr[i].z, gz = (run && i === zr.length - 1) ? -1 : 1, zg = zt + gz * (st / 2 + rsG / 2), zgf = zt + gz * (st / 2 + rsG);
        for (sx = -1; sx <= 1; sx += 2) {
          var sfx = (sx < 0 ? '-l' : '-r');
          polyC('rafter', PH.RAFTER, rafL, 'truss-' + (i + 1) + '-low' + sfx, mirB(lowPts, sx), 'xy', zt, st);
          polyC('rafter', PH.RAFTER, upL, 'truss-' + (i + 1) + '-up' + sfx, mirB(upPts, sx), 'xy', zt, st);
          polyC('gusset', PH.ROOF, 0, 'gusset-' + (i + 1) + '-knee' + sfx, mirB(kneeG, sx), 'xy', zg, rsG);
          gussetA += _phArea(kneeG);
          [0.35, 0.75].forEach(function (f, fi) {
            var xl = xkt + (Au[0] - xkt) * f, xu = Bu[0] + (xk - Bu[0]) * (0.25 + 0.4 * fi);
            scr('screw-gusset', BR.GUS_SCREW, sx * xl, yR(xl) + dV1 * (0.3 + 0.4 * fi), zgf, [0, 0, -gz], len40, 0.0022);
            scr('screw-gusset', BR.GUS_SCREW, sx * xu, yR(xu) + dV2 * (0.3 + 0.4 * fi), zgf, [0, 0, -gz], len40, 0.0022);
          });
          [0.3, 0.7].forEach(function (f, fi) { var xp = gx2 * f; scr('screw-gusset', BR.GUS_SCREW, sx * xp, yR(xp) + dV2 * (0.35 + 0.3 * fi), zgf, [0, 0, -gz], len40, 0.0022); });
          for (k = -1; k <= 1; k += 2) {   /* clear of the posts' screws into the beam and the plates' end screws: the first place and angle that is */
            var cT = [], dT = [[0, -0.87, -k * 0.5], [0, -0.94, -k * 0.34], [-sx * 0.3, -0.87, -k * 0.39], [sx * 0.25, -0.9, -k * 0.36]], hit = null;
            [(k > 0) ? 0.012 : 0.032, (k > 0) ? 0.018 : 0.026, (k > 0) ? 0.008 : 0.038, 0.022].forEach(function (dx5) { [0.035, 0.045, 0.028, 0.055].forEach(function (dy5) { if (W / 2 - dx5 > xh + 0.004) cT.push([sx * (W / 2 - dx5), yPT + dy5, zt + k * st / 2]); }); });
            for (var dq = 0; dq < dT.length && !hit; dq++) for (var cq = 0; cq < cT.length && !hit; cq++) {
              var dn5 = Math.sqrt(dT[dq][0] * dT[dq][0] + dT[dq][1] * dT[dq][1] + dT[dq][2] * dT[dq][2]), d5 = [dT[dq][0] / dn5, dT[dq][1] / dn5, dT[dq][2] / dn5];
              var c0 = cT[cq], c1 = [c0[0] + d5[0] * len80, c0[1] + d5[1] * len80, c0[2] + d5[2] * len80], ok5 = true;
              for (var q6 = 0; q6 < fas.length && ok5; q6++) { var f6 = fas[q6]; if (_pfSegDist(c0, c1, [f6.x, f6.y, f6.z], [f6.x + f6.dir[0] * f6.len, f6.y + f6.dir[1] * f6.len, f6.z + f6.dir[2] * f6.len]) < 0.003 + (f6.r || 0.003) + 0.003) ok5 = false; }
              if (ok5) hit = [c0, d5];
            }
            if (!hit) hit = [cT[0], dT[0]];
            scr('screw-toe', AF.TOE, hit[0][0], hit[0][1], hit[0][2], hit[1], len80);
          }
        }
        polyC('gusset', PH.ROOF, 0, 'gusset-' + (i + 1) + '-peak', peakG, 'xy', zg, rsG);
        gussetA += _phArea(peakG);
      }
      coat += 4 * zr.length * (st + sd) * (rafL + upL) / 2;
      var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0, gl = xB, nTies = 0;
      var gstudB = function (id, xc, zc) {
        var x0 = xc - st / 2, x1 = xc + st / 2, top = [[x1, yR(x1)]];
        if (x0 < xk && x1 > xk) top.push([xk, yR(xk)]); else if (x0 < -xk && x1 > -xk) top.push([-xk, yR(-xk)]);
        if (x0 < 0 && x1 > 0) top.push([0, yU0]);
        top.push([x0, yR(x0)]);
        top.sort(function (a, b) { return b[0] - a[0]; });
        polyC('gstud', PH.STUD, ceil2(Math.max(yR(x0), yR(x1), (x0 < 0 && x1 > 0) ? yU0 : 0) - yPT), id, [[x0, yPT], [x1, yPT]].concat(top), 'xy', zc, sd);
        gStuds++;
        for (var e3 = -1; e3 <= 1; e3 += 2) scr('screw-gstud', PH.FRAME_SCREW, xc + e3 * st / 2, yPT + (us ? 0.055 : 0.04), zc + e3 * sd / 4, [-e3 * 0.5, -0.87, 0], len100);
        scr('screw-gstud', PH.FRAME_SCREW, xc, yR(xc) - 0.035, zH - 0.005, [0, 0.95, -0.31], len100);
      };
      for (k = 1; ; k++) {
        var gxB = k * gsp;
        if (gxB + st / 2 > gl - st - 0.005 || gxB + st / 2 + 0.02 > W / 2 - len160 || yR(gxB + st / 2) - yPT < 0.06) break;   /* (the steep gambrel: none in reach of the plate's end screws) */
        for (sx = -1; sx <= 1; sx += 2) gstudB('gstud-' + (sx < 0 ? 'l' : 'r') + k, sx * gxB, zPt);
      }
      var zR0 = -(L / 2 + sg + tt), zR1 = L / 2 + sg + tt, roofLen = zR1 - zR0;
    } else {
    var rafL = ceil2((xo - xr) / cs);
    function rafPts(sxx, notch) {
      var pts = notch ? [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)], [W / 2, yR(W / 2)], [W / 2, yPT], [xh, yPT]]
                      : [[xr, yR(xr)], [xr, yT(xr)], [xo, yT(xo)], [xo, yR(xo)]];
      pts = pts.map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035, yTm = yR(xr + 0.0175) + dV / 2;
    function ridgeToes(kind, code, zq) {
      var fly = (kind === 'screw-fly'), ko = (zq < 0) ? -1 : 1;   /* v383 a fly rafter: both from its outer face (the ridge ends there) */
      for (var s3 = -1; s3 <= 1; s3 += 2) for (var k3 = -1; k3 <= 1; k3 += 2) {
        if (fly) scr(kind, code, s3 * xtq, yTm + s3 * 0.025 * ((k3 < 0) ? 1 : 1 / 3), zq + ko * st / 2, [-s3 * tCo, 0, -ko * tSi], len80);
        else scr(kind, code, s3 * xtq, yTm + k3 * s3 * 0.025, zq + k3 * st / 2, [-s3 * tCo, 0, -k3 * tSi], len80);
      }
    }
    for (i = 0; i < zr.length; i++) {
      for (sx = -1; sx <= 1; sx += 2) {
        poly('rafter', PH.RAFTER, rafL, 'rafter-' + (i + 1) + (sx < 0 ? '-l' : '-r'), rafPts(sx, true), 'xy', zr[i].z, st);
        var zq3 = zr[i].z, dz3 = st / 2 - 0.012, cand3 = [];
        [0.5, 0.25, 0.75, 0.15, 0.85].forEach(function (fx3) { [0, 0.012, -0.012, dz3, -dz3].forEach(function (dz4) { cand3.push([xh + seat * fx3, dz4]); }); });
        scrClear('screw-seat', PH.SEAT_SCREW, cand3.map(function (c5) { return [sx * c5[0], yT(c5[0]), zq3 + c5[1]]; }), [0, -1, 0], len200);   /* over the seat, clear of the post's / top plate's screws in the beam */
      }
      ridgeToes('screw-rtoe', PH.RIDGE_TOE, zr[i].z);
    }
    var flies = [zFb, zFf];
    for (i = 0; i < 2; i++) {
      for (sx = -1; sx <= 1; sx += 2) poly('fly', PH.RAFTER, rafL, 'fly-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rafPts(sx, false), 'xy', flies[i], st);
      ridgeToes('screw-fly', PH.RIDGE_TOE, flies[i]);
    }
    coat += 4 * 2 * (st + sd) * rafL;
    var zR0 = zFb - st / 2, zR1 = zFf + st / 2, roofLen = zR1 - zR0;
    box('ridge', PH.RIDGE, ceil2(roofLen), 'ridge', 0, rgTop - P.rgd / 2, (zR0 + zR1) / 2, P.rgt, P.rgd, roofLen);
    var xt = xh + (dV - sd - 0.01) / tn, nTies = 0;
    for (i = 0; i < zr.length; i++) {
      if (zr[i].gable || zr[i].part) continue;
      var zt = zr[i].z - ((zr[i].z > (zA + zC) / 2) ? 1 : -1) * st;
      box('tie', PH.STUD, ceil2(2 * xt), 'tie-' + (i + 1), 0, yPT + sd / 2, zt, 2 * xt, sd, st);
      nTies++;
      for (sx = -1; sx <= 1; sx += 2) {
        for (k = 0; k < 2; k++) {
          var xq2 = xt - 0.025 - 0.03 * k, yq0 = Math.max(yPT, yR(xq2)), yq1 = Math.min(yPT + sd, yT(xq2));
          scr('screw-tie', PH.TIE_SCREW, sx * xq2, (yq0 + yq1) / 2, zt + ((zr[i].z > zt) ? -1 : 1) * st / 2, [0, 0, (zr[i].z > zt) ? 1 : -1], len80);
        }
        var xd0 = Math.max(W / 2 - bw + 0.012, xt - 0.04), xd1 = W / 2 - bw + 0.006, xd2 = xt - 0.006;
        scrClear('screw-tie', PH.TIE_DOWN, [xd0, xt - 0.012, xd2, xd1, xd0 + 0.012, xd0 - 0.012].filter(function (x5) { return x5 >= xd1 - 1e-6 && x5 <= xd2 + 1e-6; }).map(function (x5) { return [sx * x5, yPT + sd, zt]; }), [0, -1, 0], len120);
      }
    }
    /* the partition's gable studs (every 30 cm, US 12 in., from the middle) up to its rafter pair's underside */
    var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0, gl = xB;
    for (k = 1; ; k++) {
      var gx = k * gsp;
      if (gx + st / 2 > gl - st - 0.005 || yR(gx + st / 2) - yPT < 0.06) break;
      for (sx = -1; sx <= 1; sx += 2) {
        var gx0 = sx * (gx - st / 2), gx1 = sx * (gx + st / 2), gpts = [[gx0, yPT], [gx1, yPT], [gx1, yR(gx1)], [gx0, yR(gx0)]];
        if (sx < 0) gpts.reverse();
        poly('gstud', PH.STUD, ceil2(yR(gx - st / 2) - yPT), 'gstud-' + (sx < 0 ? 'l' : 'r') + k, gpts, 'xy', zPt, sd);
        gStuds++;
        for (var e9 = -1; e9 <= 1; e9 += 2) scr('screw-gstud', PH.FRAME_SCREW, sx * gx + e9 * st / 2, yPT + (us ? 0.055 : 0.04), zPt + e9 * sd / 4, [-e9 * 0.5, -0.87, 0], len100);   /* v383 US: its tip in the plate */
        scr('screw-gstud', PH.FRAME_SCREW, sx * gx, yR(gx) - 0.035, zH - 0.005, [0, 0.95, -0.31], len100);
      }
    }
    if (cu) {
      /* v391 the cupola coop's back gable closed too (the cupola is the vent): its gable studs the partition's, the top screw from the
         stud's inner part up and out into the gable's rafter pair */
      var zGb = -L / 2 + sd / 2, zGs = -L / 2 + st / 2 + 0.31 * len100;
      for (k = 1; ; k++) {
        var gxb = k * gsp;
        if (gxb + st / 2 > gl - st - 0.005 || yR(gxb + st / 2) - yPT < 0.06) break;
        for (sx = -1; sx <= 1; sx += 2) {
          var gb0 = sx * (gxb - st / 2), gb1 = sx * (gxb + st / 2), gbp = [[gb0, yPT], [gb1, yPT], [gb1, yR(gb1)], [gb0, yR(gb0)]];
          if (sx < 0) gbp.reverse();
          poly('gstud', PH.STUD, ceil2(yR(gxb - st / 2) - yPT), 'gstud-b' + (sx < 0 ? 'l' : 'r') + k, gbp, 'xy', zGb, sd);
          gStuds++;
          for (var e9b = -1; e9b <= 1; e9b += 2) scr('screw-gstud', PH.FRAME_SCREW, sx * gxb + e9b * st / 2, yPT + (us ? 0.055 : 0.04), zGb + e9b * sd / 4, [-e9b * 0.5, -0.87, 0], len100);
          scr('screw-gstud', PH.FRAME_SCREW, sx * gxb, yR(gxb) - 0.035, zGs, [0, 0.95, -0.31], len100);
        }
      }
    }
    }   /* v386 the gable's frame */

    if (ln) {
      /* v386 THE LEAN-TO'S ROOF LAYERS: OSB from the house wall's edge past the fascia, the shingles over the underlay, the fascia on
         the tails at the eave, a rake board on each fly rafter, the drip edge along the eave and the rakes; at the house the
         endwall flashing ROR00013 (its roof leg over the shingles' top edge, its leg up the house wall under its cladding), a
         roofing nail through the roof leg into each rafter */
      var rs = P.rs, rsV = rs / cs, slope = (xe - xLe) / cs, ze0 = zR0 - tt, ze1 = zR1 + tt, eLen = ze1 - ze0;
      var tails = zr.map(function (r2) { return r2.z; });
      poly('sheath', PH.ROOF, 0, 'sheath', [[xLe, yT(xLe)], [xe, yT(xe)], [xe, yT(xe) + rsV], [xLe, yT(xLe) + rsV]], 'xy', (ze0 + ze1) / 2, eLen);
      var xs1 = xe + 0.01, ysh = rsV + 0.003, vS = (xs1 - xLe) / cs / (8 * PH.EXPO);
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover',
        quad: [[xLe, yT(xLe) + ysh, ze0 - 0.01], [xs1, yT(xs1) + ysh, ze0 - 0.01], [xs1, yT(xs1) + ysh, ze1 + 0.01], [xLe, yT(xLe) + ysh, ze1 + 0.01]],
        uv: [[(ze0 - 0.01) / (8 * PH.TAB), vS], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), vS]] });
      box('fascia', PH.BOARD, ceil2(roofLen), 'fascia-r', xo + tt / 2, yT(xe) - cw / 2, (zR0 + zR1) / 2, tt, cw, roofLen);
      coat += 2 * (tt + cw) * roofLen;
      tails.concat(flies).forEach(function (zq) { for (var k5 = 0; k5 < 2; k5++) scr('screw-fascia', PH.FASCIA_SCREW, xe, yT(xe) - cw * (0.25 + 0.35 * k5), zq, [-1, 0, 0], len50); });
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-r', box: [xe + 0.0015, yT(xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      var cwV = cw / cs;
      for (i = 0; i < 2; i++) {
        var zc2 = (i === 0) ? zR0 - tt / 2 : zR1 + tt / 2;
        poly('fascia', PH.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b'), [[xLe, yT(xLe)], [xe, yT(xe)], [xe, yT(xe) - cwV], [xLe, yT(xLe) - cwV]], 'xy', zc2, tt);
        coat += 2 * (tt + cw) * slope;
        var fxs = fixPts(xLe + 0.06, xo - 0.04, _phU(s, 'FIX_SP'));
        for (k = 0; k < fxs.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, fxs[k], yT(fxs[k]) - cwV / 2, (i === 0) ? zR0 - tt : zR1 + tt, [0, 0, (i === 0) ? 1 : -1], len50);
        poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b'), [[xLe, yT(xLe) + rsV], [xe, yT(xe) + rsV], [xe, yT(xe) + rsV - 0.055], [xLe, yT(xLe) + rsV - 0.055]], 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
      }
      var flW = _ghU(s, 'FLASH_W'), flUp = _ghU(s, 'FLASH_UP'), fT = 0.002 / cs, sn = Math.sin(th);
      var yFl = function (x) { return yT(x) + rsV + 0.004; };
      poly('flash', GH.FLASH, ceil2(eLen), 'flash-roof', [[xHw + 0.002, yFl(xHw + 0.002)], [xHw + flW, yFl(xHw + flW)], [xHw + flW, yFl(xHw + flW) + fT], [xHw + 0.002, yFl(xHw + 0.002) + fT]], 'xy', (ze0 + ze1) / 2, eLen);
      box('flash', null, 0, 'flash-wall', xHw + 0.001, yFl(xHw) + flUp / 2, (ze0 + ze1) / 2, 0.002, flUp, eLen);
      var xFn = xHw + 0.6 * flW;
      tails.concat(flies).forEach(function (zq) { scr('nail-flash', PH.ROOF_NAIL, xFn, yFl(xFn) + fT / 2, zq, [-sn, -cs, 0], len32, 0.0015); });
      var roofA = slope * eLen, capA = 0, capNails = 0;
      var dripL = eLen + 2 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);
    } else if (bn) {
    /* v397 THE BARN COOP'S ROOF LAYERS (the little barn's): the OSB on the top line (mitred at the knee) out past the rake trims, the
       shingles (two planes a side, the course bands along the eave) + the caps over the peak, the drip edge round the eaves and rakes,
       the 1x4 fascia on the tails, the 1x4 rake trims (mitred at the knee) on the gables */
      var rs = P.rs, ze1 = L / 2 + sg + tt + 0.005, ze0 = -ze1, eLen = ze1 - ze0, rsV1 = rs / cs1, rsV2 = rs / cs2, rsV = rsV2;
      var tails = zr.map(function (r2) { return r2.z; });
      var xSk = xkt + (rsV1 - rsV2) / (tn1 - tn2);
      var ySo = function (x) { var a = Math.abs(x); return (a >= xSk) ? yPT + (xh - a) * tn1 + dV1 + rsV1 : yk + (xk - a) * tn2 + dV2 + rsV2; };
      for (sx = -1; sx <= 1; sx += 2) {
        polyC('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), mirB([[xe, yT(xe)], [xkt, yKt], [0, yT0], [0, yT0 + rsV2], [xSk, ySo(xSk)], [xe, yT(xe) + rsV1]], sx), 'xy', 0, eLen);
        [[xe + 0.01, xSk], [xSk, 0]].forEach(function (pp, pi) {
          var xA0 = pp[0], xA1 = pp[1], yA0 = ySo(xA0) + 0.003, yA1 = ySo(xA1) + 0.003, sl = Math.hypot(xA0 - xA1, yA0 - yA1);
          pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r') + pi,
            quad: [[sx * xA1, yA1, ze0 - 0.01], [sx * xA0, yA0, ze0 - 0.01], [sx * xA0, yA0, ze1 + 0.01], [sx * xA1, yA1, ze1 + 0.01]],
            uv: [[(ze0 - 0.01) / (8 * PH.TAB), sl / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), sl / (8 * PH.EXPO)]] });
        });
        var fzL = L + 2 * sg;
        box('fascia', PH.BOARD, ceil2(fzL), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, 0, tt, cw, fzL);
        coat += 2 * (tt + cw) * fzL;
        for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), tails[i], [-sx, 0, 0], len50);
        pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(xe) + rsV1 - 0.0275, 0, 0.003, 0.055, eLen + 0.01] });
      }
      for (sx = -1; sx <= 1; sx += 2) {
        var cx1 = PH.CAP_W / 2 * cs2, ycap = rsV2 + 0.008;
        pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
          quad: [[0, yT0 + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT0 + ycap, ze1]],
          uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
      }
      var cwV1 = cw / cs1, cwV2 = cw / cs2, xTk = xkt - (cwV1 - cwV2) / (tn1 - tn2);
      var rakeL = ceil2(Math.hypot(xe - xkt, yT(xe) - yKt) + Math.hypot(xkt, yT0 - yKt) + cw);
      for (sz = -1; sz <= 1; sz += 2) for (sx = -1; sx <= 1; sx += 2) {
        polyC('fascia', PH.BOARD, rakeL, 'rake-' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), mirB([[xe, yT(xe)], [xkt, yKt], [0, yT0], [0, yT0 - cwV2], [xTk, yk + (xk - xTk) * tn2 + dV2 - cwV2], [xe, yT(xe) - cwV1]], sx), 'xy', sz * (L / 2 + sg + tt / 2), tt);
        coat += 2 * (tt + cw) * rakeL;
        fixPts(0.10, xa - 0.03, _phU(s, 'FIX_SP')).forEach(function (xq) {
          var yq = yT(xq) - ((xq >= xkt) ? cwV1 : cwV2) / 2;
          scr('nail-trim', PH.TRIM_NAIL, sx * xq, yq, sz * (L / 2 + sg + tt - 0.003), [0, 0, -sz], len32, 0.0012);   /* set 3 mm (a finish nail): its tip in the truss over the vent / the run's front, where no siding is behind the trim */
        });
        polyC('drip', PH.DRIP, 0, 'drip-r' + (sz < 0 ? 'b' : 'f') + (sx < 0 ? '-l' : '-r'), mirB([[xe, yT(xe) + rsV1], [xSk, ySo(xSk)], [0, yT0 + rsV2], [0, yT0 + rsV2 - 0.055], [xSk, ySo(xSk) - 0.055], [xe, yT(xe) + rsV1 - 0.055]], sx), 'xy', sz * (ze1 + 0.0015), 0.003);
      }
      var slopeL = Math.hypot(xe - xSk, yT(xe) + rsV1 - ySo(xSk)), slopeU = Math.hypot(xSk, ySo(xSk) - (yT0 + rsV2)), slope = slopeL + slopeU;
      var roofA = 2 * slope * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
      var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);
    } else {
    /* THE ROOF'S LAYERS (the cottage's): OSB from the ridge line past the fascia, the shingles over the underlay, the drip
       edge, the eave fascia on the tails, a rake board on each fly rafter, the cap shingles along the ridge */
    var rs = P.rs, rsV = rs / cs, slope = xe / cs, ze0 = zR0 - tt, ze1 = zR1 + tt, eLen = ze1 - ze0;
    var tails = zr.map(function (r2) { return r2.z; });
    for (sx = -1; sx <= 1; sx += 2) {
      var spp = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) + rsV], [0, yT(0) + rsV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) spp.reverse();
      poly('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), spp, 'xy', (ze0 + ze1) / 2, eLen);
      var xs1 = xe + 0.01, ysh = rsV + 0.003;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r'),
        quad: [[0, yT(0) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze1 + 0.01], [0, yT(0) + ysh, ze1 + 0.01]],
        uv: [[(ze0 - 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)]] });
      box('fascia', PH.BOARD, ceil2(roofLen), 'fascia-' + (sx < 0 ? 'l' : 'r'), sx * (xo + tt / 2), yT(xe) - cw / 2, (zR0 + zR1) / 2, tt, cw, roofLen);
      coat += 2 * (tt + cw) * roofLen;
      for (i = 0; i < tails.length; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), tails[i], [-sx, 0, 0], len50);
      for (i = 0; i < 2; i++) for (k = 0; k < 2; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * xe, yT(xe) - cw * (0.25 + 0.35 * k), flies[i], [-sx, 0, 0], len50);
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xe + 0.0015), yT(xe) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      for (i = 0; i < 2; i++) {
        var zc2 = (i === 0) ? zR0 - tt / 2 : zR1 + tt / 2, cwV = cw / cs;
        var rpb = [[0, yT(0)], [xe, yT(xe)], [xe, yT(xe) - cwV], [0, yT(0) - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) rpb.reverse();
        poly('fascia', PH.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rpb, 'xy', zc2, tt);
        coat += 2 * (tt + cw) * slope;
        var fxs = fixPts(0.08, xo - 0.04, _phU(s, 'FIX_SP'));
        for (k = 0; k < fxs.length; k++) scr('screw-fascia', PH.FASCIA_SCREW, sx * fxs[k], yT(fxs[k]) - cwV / 2, (i === 0) ? zR0 - tt : zR1 + tt, [0, 0, (i === 0) ? 1 : -1], len50);
        var dpb = [[0, yT(0) + rsV], [xe, yT(xe) + rsV], [xe, yT(xe) + rsV - 0.055], [0, yT(0) + rsV - 0.055]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) dpb.reverse();
        poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), dpb, 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
      }
    }
    var capH = PH.CAP_W / 2;
    for (sx = -1; sx <= 1; sx += 2) {
      var cx1 = capH * cs, ycap = rsV + 0.008;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
        quad: [[0, yT(0) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT(0) + ycap, ze1]],
        uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
    }
    var roofA = 2 * slope * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
    var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);
    }   /* v386 the gable's roof layers */

    /* THE SIDING straight on the studs and posts, from the floor beams' underside: the side walls up to under the rafters
       (the nest boxes' opening and the window cut out); the back wall up to its top plate (the gable over it is the
       vent); the partition up to its rafters' top round the ridge board, notched round the side beams running on over the
       run (with the run off it is the front gable: no notch), the pop door cut out */
    var ySide = yR(xa) - 0.005, yTrim = yR(xa + tt) - 0.005, sidingA = 0;
    for (sx = -1; sx <= 1; sx += 2) {
      var ySd = (ln && sx < 0) ? yR(-W / 2) - 0.005 : ySide, so = [[-L / 2, yFB], [zH, yFB], [zH, ySd], [-L / 2, ySd]], oc = (sx > 0) ? zcN : cu ? zcPop : zcW, ow2 = ((sx > 0) ? nWi : cu ? ROp : winW) / 2;   /* v386 the lean-to's left side under its high rafters */
      var oy0 = (sx > 0) ? ySN : cu ? yF : ySW, oy1 = (sx > 0) ? yTN : cu ? yHp : yTW, sh1 = [[oc - ow2, oy0], [oc + ow2, oy0], [oc + ow2, oy1], [oc - ow2, oy1]];
      var noH = (ln && sx < 0);   /* v386 no window there */
      poly('siding', PH.SIDING, 0, 'siding-' + (sx < 0 ? 'l' : 'r'), so, 'zy', sx * (W / 2 + sg / 2), sg, noH ? null : [sh1]);
      sidingA += _phArea(so) - (noH ? 0 : _phArea(sh1));
    }
    var gob = ln ? [[-xa, yFB], [xa, yFB], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [-W / 2 + bw, yPT], [-W / 2 + bw, yBmL], [-xa, yBmL]]   /* v386 the lean-to: round the right beam running on, over the left post's end */
            : [[-xa, yFB], [xa, yFB], [xa, yPT], [-xa, yPT]], ghb = [[-ROa / 2, yF], [ROa / 2, yF], [ROa / 2, yHa], [-ROa / 2, yHa]];
    if (!cu) {   /* v391 the cupola coop's after the gable's line */
    poly('siding', PH.SIDING, 0, 'siding-b', gob, 'xy', -(L / 2 + sg / 2), sg, [ghb]);
    sidingA += _phArea(gob) - _phArea(ghb);
    }
    var xr2 = P.rgt / 2 + 0.002, gTop = bn ? [[xa, yT(xa)], [GB.xkt, GB.yKt], [0, GB.yT0], [-GB.xkt, GB.yKt], [-xa, yT(xa)]]   /* v397 the barn coop: up to its truss's top line */
                                       : [[xa, yT(xa)], [xr2, yT(xr2)], [xr2, rgBot], [-xr2, rgBot], [-xr2, yT(xr2)], [-xa, yT(xa)]];
    if (cu) {
      /* v391 the cupola coop's back gable closed: up to its rafters round the ridge board, the door and the window cut out (the door's
         header between them sided) */
      var gobC = [[-xa, yFB], [xa, yFB]].concat(gTop), ghC = [[-ROa / 2, yF], [ROa / 2, yF], [ROa / 2, yDT], [-ROa / 2, yDT]], gwC = [[-ROa / 2, yDT + sd], [ROa / 2, yDT + sd], [ROa / 2, yWT], [-ROa / 2, yWT]];
      poly('siding', PH.SIDING, 0, 'siding-b', gobC, 'xy', -(L / 2 + sg / 2), sg, [ghC, gwC]);
      sidingA += _phArea(gobC) - _phArea(ghC) - _phArea(gwC);
    }
    var xRn = W / 2 - sd - 0.002, yRn = yRl1 + 0.002;   /* v383 the walk-in: notched over its run rails */
    var gof = ln ? [[-xa, yFB], [xa, yFB], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [xa, yPT], [xa, yT(xa)], [-xa, yT(-xa)], [-xa, yPTL], [-(W / 2 - bw), yPTL], [-(W / 2 - bw), yBmL], [-xa, yBmL]]   /* v386 the lean-to: up to its rafter, round both beams (they run on) */
            : (run && wi) ? [[-xRn, yFB], [xRn, yFB], [xRn, yRn], [xa, yRn], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [xa, yPT]].concat(gTop, [[-xa, yPT], [-(W / 2 - bw), yPT], [-(W / 2 - bw), yBm], [-xa, yBm], [-xa, yRn], [-xRn, yRn]])
            : run ? [[-xa, yFB], [xa, yFB], [xa, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yPT], [xa, yPT]].concat(gTop, [[-xa, yPT], [-(W / 2 - bw), yPT], [-(W / 2 - bw), yBm], [-xa, yBm]])
                  : [[-xa, yFB], [xa, yFB]].concat(gTop);
    var ghf = [[-ROp / 2, yF], [ROp / 2, yF], [ROp / 2, yHp], [-ROp / 2, yHp]];
    poly('siding', PH.SIDING, 0, 'siding-f', gof, 'xy', zH + sg / 2, sg, cu ? null : [ghf]);   /* v391 the cupola coop's closed */
    sidingA += _phArea(gof) - (cu ? 0 : _phArea(ghf));
    coat += sidingA;
    /* THE CORNER BOARDS: two a corner of the house -- the across wall's lapping the side's edge, up to the side siding's top
       (the partition's to under the beam running on past it) */
    var nTrim = 0, nClose = 0;
    for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
      var yG0 = (wi && run && sz > 0) ? yRl1 + 0.002 : yFB;   /* v383 the walk-in: the partition's corner boards over its run rails */
      var zEd = (sz < 0) ? -L / 2 : zH, gH = ((sz > 0 && run) ? yBm : ((sz < 0 && !cu) ? yPT : yTrim)) - yG0, cH = yTrim - yFB;
      if (ln) {
        /* v386 the lean-to: the end boards up under the beams running on; on the house side no side board, and at the back (and a
           front without the run) a 1x4 closer from the house wall over the gap in place of the end's board, nailed into the post */
        var gHl = yBms(sx) - yG0;
        if (sx < 0 && (sz < 0 || !run)) {
          box('closer', PH.BOARD, ceil2(gHl), 'closer-' + (sz < 0 ? 'b' : 'f'), xHw + cw / 2, yG0 + gHl / 2, zEd + sz * (sg + tt / 2), cw, gHl, tt);
          nClose++;
          coat += 2 * (tt + cw) * gHl;
          fixPts(yG0 + 0.08, yG0 + gHl - 0.08, _phU(s, 'FIX_SP')).forEach(function (yn) { scr('nail-trim', PH.TRIM_NAIL, xHw + cw - 0.025, yn, zEd + sz * (sg + tt), [0, 0, -sz], len32, 0.0012); });
        } else {
          box('trim', PH.TRIM, ceil2(gHl), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), yG0 + gHl / 2, zEd + sz * (sg + tt / 2), tw, gHl, tt);
          nTrim++;
          coat += 2 * (tt + tw) * gHl;
          fixPts(yG0 + 0.08, yG0 + gHl - 0.08, _phU(s, 'FIX_SP')).forEach(function (yn) { scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt - tw / 2), yn, zEd + sz * (sg + tt), [0, 0, -sz], len32, 0.0012); });
        }
        if (sx > 0) {
          box('trim', PH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), yFB + cH / 2, zEd + sz * (sg - tw / 2), tt, cH, tw);
          nTrim++;
          coat += 2 * (tt + tw) * cH;
          fixPts(yFB + 0.08, yTrim - 0.08, _phU(s, 'FIX_SP')).forEach(function (yn) { scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt), yn, zEd + sz * (sg - tw / 2), [-sx, 0, 0], len32, 0.0012); });
        }
        continue;
      }
      box('trim', PH.TRIM, ceil2(gH), 'trim-g-' + sx + sz, sx * (xa + tt - tw / 2), yG0 + gH / 2, zEd + sz * (sg + tt / 2), tw, gH, tt);
      box('trim', PH.TRIM, ceil2(cH), 'trim-s-' + sx + sz, sx * (xa + tt / 2), yFB + cH / 2, zEd + sz * (sg - tw / 2), tt, cH, tw);
      nTrim += 2;
      coat += 2 * (tt + tw) * (cH + gH);
      var ty = fixPts(yFB + 0.08, yTrim - 0.08, _phU(s, 'FIX_SP')), tyg = fixPts(yG0 + 0.08, yG0 + gH - 0.08, _phU(s, 'FIX_SP'));
      for (k = 0; k < tyg.length; k++) scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt - tw / 2), tyg[k], zEd + sz * (sg + tt), [0, 0, -sz], len32, 0.0012);
      for (k = 0; k < ty.length; k++) scr('nail-trim', PH.TRIM_NAIL, sx * (xa + tt), ty[k], zEd + sz * (sg - tw / 2), [-sx, 0, 0], len32, 0.0012);
    }
    /* THE CASINGS: 1x4 round the access door, the window and the pop door (the cottage's casing) */
    function casing(id, ax, cN, o, u0, u1, v0, v1, sillToo) {
      var n0 = cN + o * tt / 2, list = [['jamb-a', u0 - cw / 2, v0, v1, cw], ['jamb-b', u1 + cw / 2, v0, v1, cw], ['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]];
      if (sillToo) list.push(['sill', (u0 + u1) / 2, v0 - cw, v0, u1 - u0 + 2 * cw]);
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head' || c4[0] === 'sill'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        if (ax === 'x') box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        else box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], n0, yc, c4[1], tt, dy, du);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));
        pts2.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) {
            var uu = horiz ? w2 : c4[1] + e4 * cw / 4, yy = horiz ? yc + e4 * dy / 4 : w2;
            if (ax === 'x') scr('nail-trim', PH.TRIM_NAIL, uu, yy, cN + o * tt, [0, 0, -o], len32, 0.0012);
            else scr('nail-trim', PH.TRIM_NAIL, cN + o * tt, yy, uu, [-o, 0, 0], len32, 0.0012);
          }
        });
      });
    }
    casing('casing-d', 'x', -(L / 2 + sg), -1, -ROa / 2, ROa / 2, yF, cu ? yWT : yHa, false);   /* v391 the cupola coop's round its door and window */
    if (!ln && !cu) casing('casing-w', 'z', -xa, -1, zcW - winW / 2, zcW + winW / 2, ySW, yTW, true);   /* v386 the lean-to has no window */
    if (cu) casing('casing-p', 'z', -xa, -1, zcPop - ROp / 2, zcPop + ROp / 2, yF, yHp, false); else casing('casing-p', 'x', zH + sg, 1, -ROp / 2, ROp / 2, yF, yHp, false);   /* v391 the cupola coop's pop door in the left wall */
    /* the window's hardware cloth inside, lapped onto its frame */
    if (!ln && !cu) mesh('mesh-win', [[zcW - winW / 2 - 0.03, ySW - 0.03], [zcW + winW / 2 + 0.03, ySW - 0.03], [zcW + winW / 2 + 0.03, yTW + 0.03], [zcW - winW / 2 - 0.03, yTW + 0.03]], 'zy', -xB + 0.002, null);
    /* the back gable's vent: hardware cloth outside its rafter pair, over the top plate */
    if (!cu) mesh('mesh-vent', ln ? [[-W / 2 + bw, yPT], [xh, yPT], [-W / 2 + bw, yR(-W / 2 + bw)]] : bn ? [[-xh, yPT], [xh, yPT], [GB.xk, GB.yk], [0, GB.yU0], [-GB.xk, GB.yk]] : [[-xh, yPT], [xh, yPT], [0, yR(0)]], 'xy', -(L / 2 + 0.003), null);   /* v397 the barn coop's: under its truss */   /* v386 the lean-to's: the raked triangle under its slope */
    if (cu) {
      /* v391 THE CUPOLA COOP'S BACK: a board over the door's header between the casing's jambs (nailed into it), the window's hardware cloth
         inside, a shutter of two T&G boards each side on the siding, two 5x60 through each board into its stud at two heights */
      box('casing', PH.BOARD, ceil2(ROa), 'casing-d-mid', 0, yDT + sd / 2, -(L / 2 + sg + tt / 2), ROa, sd, tt);
      coat += 2 * (tt + cw) * ROa;
      fixPts(-ROa / 2 + 0.05, ROa / 2 - 0.05, _phU(s, 'FIX_SP')).forEach(function (uq) { for (var e15 = -1; e15 <= 1; e15 += 2) scr('nail-trim', PH.TRIM_NAIL, uq, yDT + sd / 2 + e15 * sd / 4, -(L / 2 + sg + tt), [0, 0, 1], len32, 0.0012); });
      mesh('mesh-win', [[-ROa / 2 - 0.03, yDT + sd - 0.03], [ROa / 2 + 0.03, yDT + sd - 0.03], [ROa / 2 + 0.03, yWT + 0.03], [-ROa / 2 - 0.03, yWT + 0.03]], 'xy', -L / 2 + sd + 0.002, null);
      var shY0 = yDT + sd - 0.02, shY1 = yWT + 0.02, shH = shY1 - shY0, zSh = -(L / 2 + sg + P.gb / 2);
      for (sx = -1; sx <= 1; sx += 2) {
        for (var qb = 0; qb < 2; qb++) {
          var xSb = sx * uSh + (qb - 0.5) * P.gc;
          box('shutter', PH.TG, ceil2(shH), 'shut-' + (sx < 0 ? 'l' : 'r') + '-board-' + (qb + 1), xSb, (shY0 + shY1) / 2, zSh, P.gc, shH, P.gb);
          coat += 2 * (P.gb + P.gw) * shH;
          for (var e16 = 0; e16 < 2; e16++) scr('screw-shutter', PH.SHEATH_SCREW, sx * uSh + (qb - 0.5) * st / 2, e16 ? shY1 - 0.06 : shY0 + 0.06, -(L / 2 + sg + P.gb), [0, 0, 1], len60);
        }
      }
    }

    /* THE LEDGED DOORS (the cottage's): T&G boards on 1x4 ledges with braces rising from the hinge side, finish nails from
       the ledges, two strap hinges onto the casing; the access door a pull + a barrel bolt (MISSING), the pop door a ball
       catch. pre: the access door is 'door' (a leaf that swings in the 3D / AR walk-through), the pop door 'pop'. */
    var nDb = 0, doorW = 0, doorH = 0;
    function ledgedDoor(pre, o, zO, ro, y0d, y1d, nLed, pull, latch) {
      var gw = P.gw, gc = P.gc, gb = P.gb, dW = ro - 2 * clr, nB = Math.max(2, Math.round((dW - (gw - gc)) / gc)), lw = nB * gc + (gw - gc);
      var dy0 = y0d + clr, dy1 = y1d - clr, dH = dy1 - dy0, zB1 = zO, zB0 = zO - o * gb, zL0 = zB0 - o * tt, q;
      for (q = 0; q < nB; q++) {
        var bxc = -lw / 2 + gw / 2 + q * gc;
        box('door', PH.TG, ceil2(dH), pre + '-board-' + (q + 1), bxc - (gw - gc) / 2, (dy0 + dy1) / 2, (zB0 + zB1) / 2, gc, dH, gb);
      }
      coat += 2 * (gb + gw) * dH * nB;
      var lo = (nLed > 2) ? 0.12 : 0.06, ledY = [], ledW = lw - 0.04;
      for (q = 0; q < nLed; q++) ledY.push(dy0 + lo + (dH - 2 * lo) * q / (nLed - 1));
      for (q = 0; q < nLed; q++) {
        box('ledge', PH.BOARD, ceil2(ledW), pre + '-ledge-' + (q + 1), 0, ledY[q], (zB0 + zL0) / 2, ledW, cw, tt);
        coat += 2 * (tt + cw) * ledW;
        for (var b2 = 0; b2 < nB; b2++) for (var e4 = -1; e4 <= 1; e4 += 2) scr('nail-door', PH.TRIM_NAIL, -lw / 2 + gw / 2 + b2 * gc, ledY[q] + e4 * cw / 4, zL0, [0, 0, o], len32, 0.0012);
      }
      function braceBetween(idB, xA, yA, xB2, yB2) {
        var dx = xB2 - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
        var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB2 + ux * ext, by0 = yB2 + uy * ext;
        var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
        pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
        if (_gzArea(pb) < 0) pb.reverse();
        poly('ledge', PH.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zB0 + zL0) / 2, tt);
        coat += 2 * (tt + cw) * dl;
        for (var m3 = 0; m3 < nB; m3++) {
          var xq = -lw / 2 + gw / 2 + m3 * gc, tq = (xq - xA) / dx;
          if (tq > 0.05 && tq < 0.95) scr('nail-door', PH.TRIM_NAIL, xq, yA + dy * tq, zL0, [0, 0, o], len32, 0.0012);
        }
      }
      for (q = 0; q + 1 < nLed; q++) braceBetween(pre + '-brace-' + (q + 1), -ledW / 2 + 0.06, ledY[q] + cw / 2, ledW / 2 - 0.06, ledY[q + 1] - cw / 2);
      /* the strap hinges on the outside at the top and bottom ledge (a strap over the boards, its leaf on the casing) */
      var hingeLen = Math.min(0.30, lw - 0.04), hingeW = 0.035, hT = 0.003;
      ((nLed > 2) ? ledY.map(function (v9, q9) { return q9; }) : [0, nLed - 1]).forEach(function (q2) {   /* v383 a hinge on every ledge of a tall door */
        var hy = ledY[q2];
        hw.push({ kind: 'hinge', code: PH.HINGE, box: [-lw / 2 + hingeLen / 2, hy, zB1 + o * hT / 2, hingeLen, hingeW, hT], id: pre + '-hinge-' + q2 });
        hw.push({ kind: 'hinge', code: null, box: [-ro / 2 - cw / 2, hy, zB1 + o * (tt + hT / 2), cw * 0.8, hingeW * 1.6, hT], id: pre + '-hinge-leaf-' + q2 });
        hinges++;
        for (var h3 = 0; h3 < 3; h3++) {
          scr('screw-hinge', PH.HINGE_SCREW, -lw / 2 + 0.03 + h3 * (hingeLen - 0.05) / 2, hy, zB1 + o * hT, [0, 0, -o], len40, 0.0022);
          scr('screw-hinge', PH.HINGE_SCREW, -ro / 2 - cw / 2, hy + (h3 - 1) * hingeW * 0.5, zB1 + o * (tt + hT), [0, 0, -o], len40, 0.0022);
        }
      });
      if (pull) { hw.push({ kind: 'knob', code: PH.KNOB, cyl: [lw / 2 - 0.07, (dy0 + dy1) / 2, (o < 0) ? zB1 - 0.05 : zB1, 0.025, 0.05], id: pre + '-knob' }); knobs++; }
      if (latch === 'catch') { hw.push({ kind: 'catch', code: PH.CATCH, box: [lw / 2 - 0.03, dy1 - 0.03, zB0 - o * 0.008, 0.03, 0.02, 0.016], id: pre + '-catch' }); catches++; }
      if (latch === 'bolt') { hw.push({ kind: 'bolt', code: null, box: [lw / 2, (dy0 + dy1) / 2 + 0.08, zB1 + o * 0.007, 0.11, 0.03, 0.014], id: pre + '-catch' }); bolts++; }
      return { n: nB, w: lw, h: dH };
    }
    var dA = ledgedDoor('door', -1, -(L / 2 + sg), ROa, yF, cu ? yDT : yHa, wi ? 3 : 2, true, 'bolt');   /* v391 the cupola coop's under its window */
    nDb += dA.n; doorW = dA.w; doorH = dA.h;
    var cuP0 = [pieces.length, fas.length, hw.length], dP = ledgedDoor('pop', 1, (cu ? W / 2 : zH) + sg, ROp, yF, yHp, 2, false, 'catch');
    if (cu) cuMap(cuP0, zcPop);   /* v391 the cupola coop's pop door: built as the partition's, turned onto the left wall */
    nDb += dP.n;

    /* THE NEST BOXES off the right wall: an OSB box as wide as the opening (n nests, dividers between), its bottom level
       with the opening's sill, a lid of panel siding sloping to the front on two strap hinges (each over a 1x4 ledge under
       the lid; the leaves on the siding over the opening's header) with a barrel bolt at the front; under it a 2x4 ledger
       through the siding into the kings and two 2x4 knee braces from the kings; OSB joined with 5x60 screws */
    var nb0 = xa, nb1 = xa + NB + nt, nz0 = zcN - nWi / 2 - nt, nz1 = zcN + nWi / 2 + nt, yLw = yTN + 0.02, yLf = ySN + NB - 0.05;
    var lSl = (yLw - yLf) / (nb1 - nb0), lCos = 1 / Math.sqrt(1 + lSl * lSl);
    function yLid(x) { return yLw - (x - nb0) * lSl; }
    box('nest', PH.FLOOR, 0, 'nest-bottom', (nb0 + nb1) / 2, ySN - nt / 2, zcN, nb1 - nb0, nt, nz1 - nz0 - 2 * nt);
    nestA += (nb1 - nb0) * (nz1 - nz0 - 2 * nt);
    var endPts = [[nb0, ySN - nt], [nb1, ySN - nt], [nb1, yLid(nb1)], [nb0, yLid(nb0)]];
    [nz0 + nt / 2, nz1 - nt / 2].forEach(function (zq, qi) { poly('nest', PH.FLOOR, 0, 'nest-end-' + (qi + 1), endPts, 'xy', zq, nt); nestA += _phArea(endPts); });
    var divPts = [[nb0, ySN], [nb1 - nt, ySN], [nb1 - nt, yLid(nb1 - nt)], [nb0, yLid(nb0)]];
    for (k = 1; k < nN; k++) { var zdv = zcN - nWi / 2 + k * (NB + nt) - nt / 2; poly('nest', PH.FLOOR, 0, 'nest-div-' + k, divPts, 'xy', zdv, nt); nestA += _phArea(divPts); }
    box('nest', PH.FLOOR, 0, 'nest-front', nb1 - nt / 2, (ySN + yLid(nb1)) / 2, zcN, nt, yLid(nb1) - ySN, nz1 - nz0 - 2 * nt);
    nestA += (yLid(nb1) - ySN) * (nz1 - nz0 - 2 * nt);
    /* its screws: through each end into the bottom's and the front's edges, through the bottom up into each divider and the
       front, through the front into each divider */
    [[nz0, 1], [nz1, -1]].forEach(function (e14) {
      fixPts(nb0 + 0.05, nb1 - 0.05, 0.12).forEach(function (xq) { scr('screw-nest', PH.SHEATH_SCREW, xq, ySN - nt / 2, e14[0], [0, 0, e14[1]], len60); });
      fixPts(ySN + 0.04, yLid(nb1) - 0.03, 0.12).forEach(function (yq) { scr('screw-nest', PH.SHEATH_SCREW, nb1 - nt / 2, yq, e14[0], [0, 0, e14[1]], len60); });
    });
    for (k = 1; k < nN; k++) {
      var zdq = zcN - nWi / 2 + k * (NB + nt) - nt / 2;
      fixPts(nb0 + 0.05, nb1 - nt - 0.09, 0.12).forEach(function (xq) { scr('screw-nest', PH.SHEATH_SCREW, xq, ySN - nt, zdq, [0, 1, 0], len60); });
      fixPts(ySN + 0.04, yLid(nb1) - 0.03, 0.12).forEach(function (yq) { scr('screw-nest', PH.SHEATH_SCREW, nb1, yq, zdq, [-1, 0, 0], len60); });
    }
    fixPts(nz0 + nt + 0.06, nz1 - nt - 0.06, 0.15).forEach(function (zq) { scrClear('screw-nest', PH.SHEATH_SCREW, [0, 0.03, -0.03, 0.05, -0.05].map(function (dz5) { return [nb1 - nt / 2, ySN - nt, zq + dz5]; }), [0, 1, 0], len60); });
    var ov = 0.03, lx1 = nb1 + ov, lidT = nt / lCos, lidZ = nz1 - nz0 + 2 * ov;
    poly('nlid', PH.FLOOR, 0, 'nest-lid', [[nb0, yLid(nb0)], [lx1, yLid(lx1)], [lx1, yLid(lx1) + lidT], [nb0, yLid(nb0) + lidT]], 'xy', zcN, lidZ);
    var lidA = (lx1 - nb0) / lCos * lidZ;
    nestA += lidA;
    var lzs = [nz0 + nt + 0.11, nz1 - nt - 0.11];
    lzs.forEach(function (zq, qi) {
      var lc = cw / 2;
      poly('nledge', PH.BOARD, ceil2((nb1 - nt - nb0 - 0.01) / lCos), 'nest-ledge-' + (qi + 1), [[nb0 + 0.005, yLid(nb0 + 0.005) - tt / lCos], [nb1 - nt - 0.005, yLid(nb1 - nt - 0.005) - tt / lCos], [nb1 - nt - 0.005, yLid(nb1 - nt - 0.005)], [nb0 + 0.005, yLid(nb0 + 0.005)]], 'xy', zq, cw);
      fixPts(nb0 + 0.04, nb1 - nt - 0.04, 0.10).forEach(function (xq) { scr('nail-nest', PH.TRIM_NAIL, xq, yLid(xq) - tt / lCos, zq + (qi ? -1 : 1) * lc / 2, [0, 1, 0], len32, 0.0012); });
      /* the strap over the ledge on the lid's top, its leaf on the siding over the header */
      var hl = Math.min(0.28, nb1 - nb0 - 0.04), hx0 = nb0 + 0.01, hx1 = hx0 + hl;
      poly('nhinge', PH.HINGE, 0, 'nest-hinge-' + (qi + 1), [[hx0, yLid(hx0) + lidT], [hx1, yLid(hx1) + lidT], [hx1, yLid(hx1) + lidT + 0.003], [hx0, yLid(hx0) + lidT + 0.003]], 'xy', zq, 0.035);
      hw.push({ kind: 'nhinge', code: null, box: [xa + 0.0015, yLw + lidT + 0.035, zq, 0.003, 0.05, 0.035], id: 'nest-hinge-leaf-' + (qi + 1) });
      hinges++;
      for (var h4 = 0; h4 < 3; h4++) {
        var hxq = hx0 + 0.02 + h4 * (hl - 0.04) / 2;
        scr('screw-nhinge', PH.HINGE_SCREW, hxq, yLid(hxq) + lidT + 0.003, zq, [-lSl * lCos, -lCos, 0], len40, 0.0022);
        scr('screw-nhinge', PH.HINGE_SCREW, xa + 0.003, yLw + lidT + 0.022 + h4 * 0.013, zq, [-1, 0, 0], len40, 0.0022);
      }
    });
    hw.push({ kind: 'bolt', code: null, box: [nb1 + 0.007, yLid(nb1) - 0.03, zcN, 0.014, 0.10, 0.03], id: 'nest-bolt' });
    bolts++;
    coat += 2 * nestA;
    var ngz0 = zcN - nWi / 2 - st - 0.02, ngz1 = zcN + nWi / 2 + st + 0.02, yNg1 = ySN - nt, yNg0 = yNg1 - sd;
    box('nledger', PH.STUD, ceil2(ngz1 - ngz0), 'nest-ledger', xa + st / 2, (yNg0 + yNg1) / 2, (ngz0 + ngz1) / 2, st, sd, ngz1 - ngz0);
    coat += 2 * (st + sd) * (ngz1 - ngz0);
    for (e = -1; e <= 1; e += 2) scr('screw-nledger', PH.STUD_SCREW, xa + st, (yNg0 + yNg1) / 2, zcN + e * (nWi / 2 + st / 2), [-1, 0, 0], len120);
    var kba = 0.22, kbk = sd / 2 * Math.SQRT2;
    for (e = -1; e <= 1; e += 2) {
      var kz = zcN + e * (nWi / 2 + nt / 2), kpts = [[xa, yNg1 - (kba + kbk)], [xa, yNg1 - (kba - kbk)], [xa + kba - kbk, yNg1], [xa + kba + kbk, yNg1]];
      poly('nbrace', PH.STUD, ceil2((kba + kbk) * Math.SQRT2), 'nest-brace-' + (e < 0 ? 'b' : 'f'), kpts, 'xy', kz, st);
      coat += 2 * (st + sd) * (kba + kbk) * Math.SQRT2;
      scr('screw-nbrace', PH.STUD_SCREW, xa + 0.05, yNg1 - kba - kbk + 0.05, kz, [-1, 0, 0], len120);
      scr('screw-nbrace', PH.SHEATH_SCREW, xa + kba + kbk - 0.05, yNg1 - 0.05, kz, [0, 1, 0], len60);
    }

    /* THE ROOSTS: 2x4 flat across the house between the side walls, on a 2x4 cleat each end screwed to its stud */
    var yRo = yF + _coU(s, 'ROOST_Y'), cH0 = _coU(s, 'RCLEAT');
    zRo.forEach(function (zq, qi) {
      box('roost', PH.STUD, ceil2(2 * xB), 'roost-' + (qi + 1), 0, yRo - st / 2, zq, 2 * xB, st, sd);
      for (sx = -1; sx <= 1; sx += 2) {
        box('rcleat', PH.STUD, ceil2(cH0), 'roost-cleat-' + (qi + 1) + (sx < 0 ? 'l' : 'r'), sx * (xB - st / 2), yRo - st - cH0 / 2, zq, st, cH0, sd);
        for (e = -1; e <= 1; e += 2) {
          scr('screw-rcleat', PH.FRAME_SCREW, sx * (xB - st), yRo - st - cH0 * (0.5 + e * 0.3), zq, [sx, 0, 0], len100);
          scr('screw-roost', PH.FRAME_SCREW, sx * (xB - st / 2), yRo, zq + e * sd / 4, [0, -1, 0], len100);
        }
      }
    });

    /* THE RAMP from the pop door's sill down to the ground at 35 deg: two 1x6 planks, two 1x4 ledges nailed up under them,
       20 x 40 cleats nailed on every 15 cm (US 6 in.), its head on a 2x4 ledger screwed through the siding into the floor
       beam (a stainless 5.5x50 down through each plank) */
    var cuR0 = [pieces.length, fas.length, hw.length];   /* v391 the cupola coop's turned onto the left wall below */
    var PBd = _pfBoard(s), pkT = PBd.t, pkW = PBd.w, ra = CO.RAMP_ANG * Math.PI / 180, rCs = Math.cos(ra), rSn = Math.sin(ra), rTn = Math.tan(ra);
    var rz0 = (cu ? W / 2 : zH) + sg + 0.003, rY0 = yF, rdz = rCs, rdy = -rSn, rnz = rSn, rny = rCs;   /* along the slope (down and out), its normal (up) */
    var rzt = rz0 + rY0 / rTn, ryb = rY0 - pkT / rCs, rzb = rz0 + ryb / rTn, rLen = rY0 / rSn;
    function rAt(sl, nn) { return [rz0 + rdz * sl + rnz * nn, rY0 + rdy * sl + rny * nn]; }
    for (e = -1; e <= 1; e += 2) {
      poly('ramp', CO.PLANK, ceil2(rLen), 'ramp-plank-' + (e < 0 ? 'l' : 'r'), [[rz0, rY0], [rz0, ryb], [rzb, 0], [rzt, 0]], 'zy', e * (pkW / 2 + 0.002), pkW);
      coat += 2 * (pkW + pkT) * rLen;
    }
    var rWd = 2 * pkW + 0.004, ctT = _coU(s, 'CL_T'), ctW = _coU(s, 'CL_W'), nCl = 0, ledgS = [0.12, rLen - 0.30];
    ledgS.forEach(function (sl, qi) {
      var pts = [rAt(sl - cw / 2, -pkT), rAt(sl + cw / 2, -pkT), rAt(sl + cw / 2, -pkT - tt), rAt(sl - cw / 2, -pkT - tt)];
      poly('rledge', PH.BOARD, ceil2(rWd), 'ramp-ledge-' + (qi + 1), pts, 'zy', 0, rWd);
      coat += 2 * (cw + tt) * rWd;
      var cq = rAt(sl, -pkT - tt);
      for (e = -1; e <= 1; e += 2) for (var e10 = -1; e10 <= 1; e10 += 2) scr('nail-ramp', PH.TRIM_NAIL, e * (pkW / 2 + 0.002) + e10 * pkW / 4, cq[1], cq[0], [0, rny, rnz], len32, 0.0012);
    });
    for (var sl2 = 0.10; sl2 < rLen - 0.12; sl2 += _coU(s, 'CLEAT_SP')) {
      nCl++;
      poly('rcl', CO.CLEAT, ceil2(rWd), 'ramp-cleat-' + nCl, [rAt(sl2 - ctW / 2, 0), rAt(sl2 + ctW / 2, 0), rAt(sl2 + ctW / 2, ctT), rAt(sl2 - ctW / 2, ctT)], 'zy', 0, rWd);
      coat += 2 * (ctW + ctT) * rWd;
      var cq2 = rAt(sl2, ctT);
      for (e = -1; e <= 1; e += 2) for (var e11 = -1; e11 <= 1; e11 += 2) scr('nail-ramp', PH.TRIM_NAIL, e * (pkW / 2 + 0.002) + e11 * pkW / 4, cq2[1], cq2[0], [0, -rny, -rnz], len32, 0.0012);
    }
    var yLgT = ryb - st * rTn, yLgB = yLgT - sd;
    box('rledger', PH.STUD, ceil2(0.40), 'ramp-ledger', 0, (yLgT + yLgB) / 2, rz0 + st / 2, 0.40, sd, st);
    coat += 2 * (st + sd) * 0.40;
    for (e = -1; e <= 1; e += 2) scr('screw-rledger', PH.STUD_SCREW, e * 0.13, (yLgT + yLgB) / 2, rz0 + st, [0, 0, -1], len120);
    for (e = -1; e <= 1; e += 2) { var rq = rAt(st / rCs - 0.006, 0); scr('screw-ramp', PH.DECK_SCREW, e * (pkW / 2 + 0.002), rq[1], rq[0], [0, -rny, -rnz], len50); }   /* v379 where the plank bears on the ledger's front edge (was over the gap above it) */
    if (cu) cuMap(cuR0, zcPop);

    /* THE RUN */
    var nRail = 0, nKb = 0, xD0 = -xB, xD1 = -xB + _coU(s, 'RDOOR') + 2 * clr, extZ = cu ? L / 2 + (cuRun ? 0.31 : 0.05) : run ? L / 2 + 0.31 : Math.max(L / 2, rzt + 0.05);
    if (run) {
      /* the bottom rails, 2x4 laid flat between the posts (over the U heads' flanges): along both sides, across the back and
         the front; two 6x80 toe screws an end down into the post */
      var rail = function (id, x, z, dx, dz, along) {
        box('crail', PH.STUD, ceil2(along ? dz : dx), id, x, (yRl0 + yRl1) / 2, z, dx, st, dz);
        coat += 2 * (st + sd) * (along ? dz : dx);
        nRail++;
        for (var e12 = -1; e12 <= 1; e12 += 2) for (var k4 = -1; k4 <= 1; k4 += 2) {
          if (along) scr('screw-crail', PH.TIE_SCREW, x + k4 * sd / 4, yRl1, z + e12 * (dz / 2 - 0.04), [0, -0.5, e12 * 0.87], len80);
          else scrClear('screw-crail', PH.TIE_SCREW, [[0.04, 0.25], [0.04, 0.4], [0.03, 0.4], [0.05, 0.1], [0.03, 0.1], [0.05, 0.4]].map(function (c7) { return [x + e12 * (dx / 2 - c7[0]), yRl1, z + k4 * sd * c7[1]]; }), [e12 * 0.87, -0.5, 0], len80);   /* clear of the side rails' in the corner post */
        }
      };
      for (sx = -1; sx <= 1; sx += 2) {
        var sp2 = posts.filter(function (q3) { return q3.sx === sx; }).sort(function (a, b) { return a.z - b.z; });
        for (i = 0; i + 1 < sp2.length; i++) { if (wi && sp2[i + 1].z < zH) continue; var z0r = sp2[i].z + p / 2, z1r = sp2[i + 1].z - p / 2; rail('rail-' + (sx < 0 ? 'l' : 'r') + (i + 1), sx * (W / 2 - sd / 2), (z0r + z1r) / 2, sd, z1r - z0r, true); }
      }
      if (!wi) rail('rail-b', 0, zb, 2 * xB, sd, false);   /* v383 the walk-in: its house's floor beams there */
      rail('rail-f', 0, zf, 2 * xB, sd, false);
      /* the front: a 2x4 top plate between the side beams (two 6x160 through the beam into each end), the door's 2x4 stud
         from the rail to the plate (two 6x120 up through the rail, two down through the plate) */
      box('tplate', PH.STUD, ceil2(2 * xB), 'front-tplate', 0, yPT - st / 2, zf, 2 * xB, st, sd);
      for (sx = -1; sx <= 1; sx += 2) for (k = -1; k <= 1; k += 2) scrClear('screw-tpend', PH.JOIST_SCREW, [0.25, 0.35, 0.15, 0.4].map(function (f6) { return [sx * W / 2, yPT - st / 2, zf + k * sd * f6]; }), [-sx, 0, 0], len160);   /* clear of the front rafters' seat screws */
      var xSt = xD1 + st / 2;
      box('stud', PH.STUD, ceil2(yGT - yRl1), 'front-stud', xSt, (yRl1 + yGT) / 2, zf, st, yGT - yRl1, sd);
      coat += 2 * (st + sd) * (yGT - yRl1);
      for (k = -1; k <= 1; k += 2) {
        scr('screw-fstud', PH.STUD_SCREW, xSt, yRl0, zf + k * sd / 4, [0, 1, 0], len120);
        scr('screw-tplate', PH.STUD_SCREW, xSt, yPT, zf + k * 0.4 * sd, [0, -1, 0], len120);   /* down through the plate (after it) */
      }
      /* v383 the walk-in's wide front: more 2x4 studs between the door's and the right post, <= 1.22 m (US 4 ft) apart */
      var nFs = 0;
      if (wi) {
        var fsA = xSt + st / 2, fsB = xB, nFg = Math.max(1, Math.ceil((fsB - fsA) / _coU(s, 'POST_SP') - 1e-9));
        for (k = 1; k < nFg; k++) {
          var xFs = fsA + (fsB - fsA) * k / nFg;
          nFs++;
          box('stud', PH.STUD, ceil2(yGT - yRl1), 'front-stud-' + (nFs + 1), xFs, (yRl1 + yGT) / 2, zf, st, yGT - yRl1, sd);
          coat += 2 * (st + sd) * (yGT - yRl1);
          stapleL += yGT - yRl1;
          for (var k8 = -1; k8 <= 1; k8 += 2) {
            scr('screw-fstud', PH.STUD_SCREW, xFs, yRl0, zf + k8 * sd / 4, [0, 1, 0], len120);
            scr('screw-tplate', PH.STUD_SCREW, xFs, yPT, zf + k8 * 0.4 * sd, [0, -1, 0], len120);
          }
        }
      }
      /* knee braces at the front corners: a 2x4 from the post's back face up under its side beam (the porch's) */
      var ba = _phU(s, 'BRACE'), bk = sd / 2 * Math.SQRT2, zP = L / 2 - p;
      for (sx = -1; sx <= 1; sx += 2) {
        var wb = function (u, v) { return [zP - u, yBms(sx) + v]; };
        poly('kbrace', PH.STUD, ceil2((ba + bk) * Math.SQRT2), 'kbrace-' + (sx < 0 ? 'l' : 'r'), [wb(0, -(ba + bk)), wb(0, -(ba - bk)), wb(ba - bk, 0), wb(ba + bk, 0)], 'zy', sx * (W / 2 - bw / 2), st);
        coat += 2 * (st + sd) * (ba + bk) * Math.SQRT2;
        nKb++;
        var tA = wb(0.06, 0.06 - ba - bk), tB = wb(ba + bk - 0.06, -0.06);
        scr('screw-kbrace', PH.BRACE_SCREW, sx * (W / 2 - bw / 2), tA[1], tA[0], [0, 0, 1], len160);
        scr('screw-kbrace', PH.BRACE_SCREW, sx * (W / 2 - bw / 2), tB[1], tB[0], [0, 1, 0], len160);
      }
      /* v383 the walk-in's tall run: a knee brace at every run post between the house's and the front corner, from its back face up under
         the side beam (the corner's), where the post before it leaves room */
      if (wi) posts.forEach(function (q5) {
        if (!(q5.z > zh + 1e-6 && q5.z < zf - 1e-6)) return;
        var prv = posts.filter(function (q6) { return q6.sx === q5.sx && q6.z < q5.z - 1e-6; }).sort(function (a6, b6) { return b6.z - a6.z; })[0];
        if (prv && (q5.z - p / 2) - (prv.z + p / 2) < ba + bk + 0.10) return;
        var zP5 = q5.z - p / 2, wb5 = function (u, v) { return [zP5 - u, yBm + v]; }, xk = q5.sx * (W / 2 - bw / 2);
        poly('kbrace', PH.STUD, ceil2((ba + bk) * Math.SQRT2), 'kbrace-' + q5.id, [wb5(0, -(ba + bk)), wb5(0, -(ba - bk)), wb5(ba - bk, 0), wb5(ba + bk, 0)], 'zy', xk, st);
        coat += 2 * (st + sd) * (ba + bk) * Math.SQRT2;
        nKb++;
        var tA5 = wb5(0.06, 0.06 - ba - bk), tB5 = wb5(ba + bk - 0.06, -0.06);
        scr('screw-kbrace', PH.BRACE_SCREW, xk, tA5[1], tA5[0], [0, 0, 1], len160);
        scrClear('screw-kbrace', PH.BRACE_SCREW, [0, -0.015, 0.015, -0.03, 0.03].map(function (dz7) { return [xk, tB5[1], tB5[0] + dz7]; }), [0, 1, 0], len160);   /* clear of the rafters' seat screws in the beam */
      });
      /* THE RUN DOOR: a frame of 2x4 laid flat in the opening (stiles, top + bottom rail, a brace rising from the hinge
         side), two 6x160 through each stile into each rail's end, the brace toed in, hardware cloth stapled on its face; two
         strap hinges onto the left post's face, a barrel bolt onto the stud (MISSING) -- a leaf of its own ('door-r') */
      var lx0 = xD0 + clr, lx1 = xD1 - clr, ly0 = yRl1 + clr, ly1 = yGT - clr, lz = L / 2 - st / 2;
      box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-1', lx0 + sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
      box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-2', lx1 - sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
      box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-3', (lx0 + lx1) / 2, ly0 + sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
      box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-4', (lx0 + lx1) / 2, ly1 - sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
      coat += 2 * (st + sd) * (2 * (ly1 - ly0) + 2 * (lx1 - lx0 - 2 * sd));
      [ly0 + sd / 2, ly1 - sd / 2].forEach(function (yq) {
        for (var e13 = -1; e13 <= 1; e13 += 2) {
          scr('nail-door', PH.JOIST_SCREW, lx0, yq + e13 * sd / 4, lz, [1, 0, 0], len160);
          scr('nail-door', PH.JOIST_SCREW, lx1, yq + e13 * sd / 4, lz, [-1, 0, 0], len160);
        }
      });
      var bA = [lx0 + sd, ly0 + sd], bB = [lx1 - sd, ly1 - sd], bdx = bB[0] - bA[0], bdy = bB[1] - bA[1], bdl = Math.sqrt(bdx * bdx + bdy * bdy);
      var bnx = -bdy / bdl * sd / 2, bny = bdx / bdl * sd / 2, bex = bdx / bdl * sd, bey = bdy / bdl * sd;
      var bpb = [[bA[0] - bex + bnx, bA[1] - bey + bny], [bA[0] - bex - bnx, bA[1] - bey - bny], [bB[0] + bex - bnx, bB[1] + bey - bny], [bB[0] + bex + bnx, bB[1] + bey + bny]];
      bpb = _gzClip(bpb, 1, 0, -(lx0 + sd)); bpb = _gzClip(bpb, -1, 0, lx1 - sd); bpb = _gzClip(bpb, 0, 1, -(ly0 + sd)); bpb = _gzClip(bpb, 0, -1, ly1 - sd);
      if (_gzArea(bpb) < 0) bpb.reverse();
      poly('dframe', PH.STUD, ceil2(bdl + sd), 'door-r-brace-1', bpb, 'xy', lz, st);
      coat += 2 * (st + sd) * bdl;
      var hV = sd / 2 * bdl / bdx, yBa = bA[1] + 0.07 * bdy / bdx, yBb = bB[1] - 0.07 * bdy / bdx;   /* v379 from inside the brace (US: it started under it) */
      scr('nail-door', wi ? PH.STUD_SCREW : PH.TIE_SCREW, bA[0] + 0.07, Math.max(ly0 + sd + 0.005, yBa - hV + 0.012), lz, [0, -1, 0], wi ? len120 : len80);   /* v383 the walk-in's steep brace: a longer screw */   /* down through the brace's foot into the bottom rail, past the stile's screws */
      scr('nail-door', wi ? PH.STUD_SCREW : PH.TIE_SCREW, bB[0] - 0.07, Math.min(ly1 - sd - 0.005, yBb + hV - 0.012), lz, [0, 1, 0], wi ? len120 : len80);
      mesh('door-r-board-1', [[lx0, ly0], [lx1, ly0], [lx1, ly1], [lx0, ly1]], 'xy', L / 2 + mo, null);
      var rhl = 0.30, rhw = 0.035, rhT = 0.003;
      [ly0 + sd / 2, ly1 - sd / 2].forEach(function (hy, qi) {
        hw.push({ kind: 'hinge', code: PH.HINGE, box: [lx0 + rhl / 2 - 0.02, hy, L / 2 + mo + 0.002 + rhT / 2, rhl, rhw, rhT], id: 'door-r-hinge-' + (qi * 2) });
        hw.push({ kind: 'hinge', code: null, box: [-W / 2 + p / 2, hy, L / 2 + mo + 0.002 + rhT / 2, p * 0.8, rhw * 1.6, rhT], id: 'door-r-hinge-leaf-' + (qi * 2) });
        hinges++;
        for (var h5 = 0; h5 < 3; h5++) {
          scr('screw-hinge', PH.HINGE_SCREW, lx0 + 0.01 + h5 * 0.11, hy, L / 2 + mo + 0.002 + rhT, [0, 0, -1], len40, 0.0022);
          var hx5 = -W / 2 + p / 2 + (h5 - 1) * 0.02, hy5 = hy + (h5 - 1) * 0.012;
          scrClear('screw-hinge', PH.HINGE_SCREW, [[hx5, hy5], [hx5, hy5 - 0.006], [hx5 + 0.008, hy5], [hx5 - 0.008, hy5]].map(function (c6) { return [c6[0], c6[1], L / 2 + mo + 0.002 + rhT]; }), [0, 0, -1], len40, 0.0022);
        }
      });
      hw.push({ kind: 'bolt', code: null, box: [lx1, (ly0 + ly1) / 2, L / 2 + mo + 0.009, 0.11, 0.03, 0.014], id: 'door-r-catch' });
      bolts++;
      /* THE HARDWARE CLOTH round the run: each side from the ground to under the beam (under the house to the floor beams;
         clear of the house's corner boards), under the house at the back, the front with its gable (the door cut out);
         the apron flat round the run outside the posts, 30 cm (US 12 in.) out, buried 5 cm (US 2 in.) */
      var zM = zH + sg + tt + 0.002, apr = _coU(s, 'APRON');
      for (sx = -1; sx <= 1; sx += 2) mesh('mesh-s' + (sx < 0 ? 'l' : 'r'), [[-L / 2 - mo, 0], [L / 2 + mo, 0], [L / 2 + mo, yBms(sx)], [zM, yBms(sx)], [zM, yFB], [-L / 2 - mo, yFB]], 'zy', sx * (W / 2 + mo + CO.MESH_T / 2), null);
      mesh('mesh-b', [[-W / 2 - mo, 0], [W / 2 + mo, 0], [W / 2 + mo, yFB], [-W / 2 - mo, yFB]], 'xy', -(L / 2 + mo + CO.MESH_T / 2), null);
      mesh('mesh-f', ln ? [[-W / 2 - mo, 0], [W / 2 + mo, 0], [W / 2 + mo, yBm], [W / 2 - bw, yBm], [W / 2 - bw, yR(W / 2 - bw)], [-W / 2 + bw, yR(-W / 2 + bw)], [-W / 2 + bw, yBmL], [-W / 2 - mo, yBmL]]   /* v386 the lean-to's: under its slope, round the beams running on */
                         : bn ? [[-W / 2 - mo, 0], [W / 2 + mo, 0], [W / 2 + mo, yPT], [xh, yPT], [GB.xk, GB.yk], [0, GB.yU0], [-GB.xk, GB.yk], [-xh, yPT], [-W / 2 - mo, yPT]]   /* v397 the barn coop's: under its truss */
                         : [[-W / 2 - mo, 0], [W / 2 + mo, 0], [W / 2 + mo, yPT], [xh, yPT], [0, yR(0)], [-xh, yPT], [-W / 2 - mo, yPT]], 'xy', L / 2 + mo + CO.MESH_T / 2,
           [[[xD0, yRl1], [xD1, yRl1], [xD1, yGT], [xD0, yGT]]]);
      /* the staples' lines inside the sheets: every post between the sheet's ends, the rails, the front stud and plate */
      posts.forEach(function (q4) { if (q4.i > 0 && q4.z < L / 2 - p) stapleL += (q4.z > zH) ? yBm : yFB; });
      stapleL += 2 * L + 2 * (2 * xB) + (yGT - yRl1) + 2 * xB;
      var ax0 = W / 2 + mo + CO.MESH_T + 0.001, az0 = L / 2 + mo + CO.MESH_T + 0.001;
      var axL = ln ? xHw + 0.005 : -ax0;   /* v386 the lean-to: no apron on the house side, the ends' from the house wall */
      for (sx = (ln ? 1 : -1); sx <= 1; sx += 2) mesh('apron-' + (sx < 0 ? 'l' : 'r'), (sx < 0) ? [[-ax0 - apr, -az0 - apr], [-ax0, -az0 - apr], [-ax0, az0 + apr], [-ax0 - apr, az0 + apr]] : [[ax0, -az0 - apr], [ax0 + apr, -az0 - apr], [ax0 + apr, az0 + apr], [ax0, az0 + apr]], 'xz', CO.MESH_T / 2 + 0.001, null, true);
      for (sz = -1; sz <= 1; sz += 2) mesh('apron-' + (sz < 0 ? 'b' : 'f'), (sz < 0) ? [[axL, -az0 - apr], [ax0, -az0 - apr], [ax0, -az0], [axL, -az0]] : [[axL, az0], [ax0, az0], [ax0, az0 + apr], [axL, az0 + apr]], 'xz', CO.MESH_T / 2 + 0.001, null, true);
    }

    /* v391 THE CUPOLA COOP'S CUPOLA and RUN (see CU), in the house's frame (the house centred on X = 0; moved at the last) */
    var cupTop = 0, cupH = 0, cuWr = 0, nMr = 0, nRj = 0;
    if (cu) {
      /* THE CUPOLA on the ridge's middle: two 2x4 saddles on edge across the ridge, their underside 1 cm over the roof's OSB, an 8x200 down
         through each into the ridge board; panel siding round them (by area); four 2x4 corner posts on the saddles, one toe screw each;
         three 1x4 louvers a face at 45 deg on the posts' outer faces (a 5x60 through each into each post, near its upper edge); a 2x4
         frame on the posts (6x100 down into them, the sides between with a 6x160 through each end); the hardware cloth on the saddles
         round the posts; a 45 deg pyramid roof -- its OSB, underlay, shingles, hip caps and drip edge by area (drawn as its shingles); the
         weathervane (MISSING) on its top */
      var cc = _coU(s, 'CUP'), cHt = _coU(s, 'CUP_H'), cOv = _coU(s, 'CUP_OV'), vH = _coU(s, 'VANE_H'), hc = cc / 2;
      var ysC = function (x) { return yT(Math.abs(x)) + rsV + 0.01; };
      var ySdl = ysC(0) + sd, yPo1 = ySdl + cHt, yCt = yPo1 + st;
      var sdlP = [[-hc, ysC(hc)], [0, ysC(0)], [hc, ysC(hc)], [hc, ySdl], [-hc, ySdl]];
      for (sz = -1; sz <= 1; sz += 2) {
        var zSdl = sz * (hc - st / 2), cSd = [];
        poly('csaddle', PH.STUD, ceil2(cc), 'cup-saddle-' + (sz < 0 ? 'b' : 'f'), sdlP, 'xy', zSdl, st);
        coat += 2 * (st + sd) * cc;
        [0.012, -0.012, 0.02, -0.02].forEach(function (xq) { [0, 0.012, -0.012, 0.02, -0.02].forEach(function (dz) { cSd.push([xq, ySdl, zSdl + dz * Math.min(1, st / 0.06)]); }); });
        scrClear('screw-csaddle', PH.SEAT_SCREW, cSd, [0, -1, 0], len200);
      }
      var cpF = [[-hc - sg, ysC(hc + sg)], [0, ysC(0)], [hc + sg, ysC(hc + sg)], [hc + sg, ySdl], [-hc - sg, ySdl]], cpS = [[-hc, ysC(hc)], [hc, ysC(hc)], [hc, ySdl], [-hc, ySdl]], cpA = 0;
      for (sz = -1; sz <= 1; sz += 2) { poly('cpanel', PH.SIDING, 0, 'cup-panel-' + (sz < 0 ? 'b' : 'f'), cpF, 'xy', sz * (hc + sg / 2), sg); cpA += _phArea(cpF); }
      for (sx = -1; sx <= 1; sx += 2) { poly('cpanel', PH.SIDING, 0, 'cup-panel-' + (sx < 0 ? 'l' : 'r'), cpS, 'zy', sx * (hc + sg / 2), sg); cpA += _phArea(cpS); }
      sidingA += cpA; coat += cpA;
      for (sx = -1; sx <= 1; sx += 2) for (sz = -1; sz <= 1; sz += 2) {
        var cpx = sx * (hc - sd / 2), cpz = sz * (hc - st / 2);
        box('cpost', PH.STUD, ceil2(cHt), 'cup-post-' + (sx < 0 ? 'l' : 'r') + (sz < 0 ? 'b' : 'f'), cpx, (ySdl + yPo1) / 2, cpz, sd, cHt, st);
        coat += 2 * (st + sd) * cHt;
        scr('screw-cpost', PH.FRAME_SCREW, sx * (hc - sd), ySdl + 0.045, cpz, [sx * 0.5, -0.87, 0], len100);   /* toed from its inner face down into the saddle */
      }
      /* the louvers: a 1x4 at 45 deg, its upper inner edge on the posts' outer faces (Z-Y for the front / back, X-Y for the sides) */
      var lvW = cw, lvT = tt, lr = Math.SQRT1_2, oLv = lr * (lvW + lvT) / 2, nLv = 3, sLv = -lvW / 2 + 0.015;
      for (var lv = 0; lv < nLv; lv++) {
        var yLv = ySdl + cHt * (lv + 0.5) / nLv;
        for (var fo = -1; fo <= 1; fo += 2) {
          var c0 = hc + oLv, u0x = lr, u0y = -lr, n0x = lr, n0y = lr;   /* in the face's own (out, up): along the board down-out, its normal up-out */
          var lvP = [[c0 - u0x * lvW / 2 - n0x * lvT / 2, yLv - u0y * lvW / 2 - n0y * lvT / 2], [c0 + u0x * lvW / 2 - n0x * lvT / 2, yLv + u0y * lvW / 2 - n0y * lvT / 2],
                     [c0 + u0x * lvW / 2 + n0x * lvT / 2, yLv + u0y * lvW / 2 + n0y * lvT / 2], [c0 - u0x * lvW / 2 + n0x * lvT / 2, yLv - u0y * lvW / 2 + n0y * lvT / 2]];
          var oS = c0 + u0x * sLv + n0x * lvT / 2, yS = yLv + u0y * sLv + n0y * lvT / 2;   /* a screw's head: on its outer face near the upper edge */
          var lvF = lvP.map(function (a3) { return [fo * a3[0], a3[1]]; });
          if (fo < 0) lvF.reverse();
          poly('louver', PH.BOARD, ceil2(cc), 'cup-louver-' + (fo < 0 ? 'b' : 'f') + (lv + 1), lvF, 'zy', 0, cc);
          for (sx = -1; sx <= 1; sx += 2) scr('screw-louver', PH.SHEATH_SCREW, sx * (hc - sd / 2), yS, fo * oS, [0, -n0y, -fo * n0x], len60);
          var lvS = lvP.map(function (a3) { return [fo * a3[0], a3[1]]; });
          if (fo < 0) lvS.reverse();
          poly('louver', PH.BOARD, ceil2(cc), 'cup-louver-' + (fo < 0 ? 'l' : 'r') + (lv + 1), lvS, 'xy', 0, cc);
          for (sz = -1; sz <= 1; sz += 2) scr('screw-louver', PH.SHEATH_SCREW, fo * oS, yS, sz * (hc - st / 2), [-fo * n0x, -n0y, 0], len60);
          coat += 2 * 2 * (lvW + lvT) * cc;
        }
      }
      /* the frame on top */
      for (sz = -1; sz <= 1; sz += 2) {
        box('ctop', PH.STUD, ceil2(cc), 'cup-top-' + (sz < 0 ? 'b' : 'f'), 0, yPo1 + st / 2, sz * (hc - sd / 2), cc, st, sd);
        coat += 2 * (st + sd) * cc;
        for (sx = -1; sx <= 1; sx += 2) scr('screw-ctop', PH.FRAME_SCREW, sx * (hc - sd / 2 - 0.02), yPo1 + st, sz * (hc - st / 2), [0, -1, 0], len100);
      }
      for (sx = -1; sx <= 1; sx += 2) {
        box('ctop', PH.STUD, ceil2(cc - 2 * sd), 'cup-top-' + (sx < 0 ? 'l' : 'r'), sx * (hc - sd / 2), yPo1 + st / 2, 0, sd, st, cc - 2 * sd);
        coat += 2 * (st + sd) * (cc - 2 * sd);
        for (sz = -1; sz <= 1; sz += 2) scr('screw-ctop', PH.JOIST_SCREW, sx * (hc - sd / 2 + 0.02), yPo1 + st / 2, sz * hc, [0, 0, -sz], len160);
      }
      /* the hardware cloth on the saddles, round the posts */
      var cmP = [[-hc + sd, -hc], [hc - sd, -hc], [hc - sd, -hc + st], [hc, -hc + st], [hc, hc - st], [hc - sd, hc - st], [hc - sd, hc], [-hc + sd, hc], [-hc + sd, hc - st], [-hc, hc - st], [-hc, -hc + st], [-hc + sd, -hc + st]];
      pieces.push({ kind: 'cmesh', code: null, len: 0, id: 'cup-mesh', poly: cmP, plane: 'xz', c: ySdl + CO.MESH_T / 2 + 0.0005, t: CO.MESH_T, holes: null });
      meshA += _phArea(cmP); stapleL += perim(cmP);
      /* the pyramid roof (drawn as its shingles; billed with the roof's OSB, underlay, shingles, the hips' caps, the drip edge) */
      var hR = hc + cOv, yAp = yCt + hR, c4 = [[-hR, hR], [hR, hR], [hR, -hR], [-hR, -hR]], vS4 = hR * Math.SQRT2 / (8 * PH.EXPO), uS4 = 2 * hR / (8 * PH.TAB);
      for (k = 0; k < 4; k++) {
        var A4 = c4[k], B4 = c4[(k + 1) % 4];
        pieces.push({ kind: 'croof', code: null, len: 0, id: 'cup-roof-' + (k + 1), quad: [[A4[0], yCt, A4[1]], [B4[0], yCt, B4[1]], [0, yAp, 0], [0, yAp, 0]], uv: [[0, 0], [uS4, 0], [uS4 / 2, vS4], [uS4 / 2, vS4]] });
      }
      var slC = hR * Math.SQRT2, hipC = Math.sqrt(3) * hR;
      roofA += 4 * hR * slC;
      capA += 4 * hipC * PH.CAP_W;
      capNails += 4 * Math.ceil(hipC / PH.CAP_EXPO) * PH.CAP_NAILS;
      dripL += 8 * hR;
      dripNails = Math.ceil(dripL / PH.DRIP_FIX);
      /* the weathervane (MISSING): its rod, the cardinal arms, the arrow, the rooster */
      hw.push({ kind: 'vane', code: null, box: [0, yAp + vH / 2, 0, 0.012, vH, 0.012], id: 'vane-rod' });
      hw.push({ kind: 'vane', code: null, box: [0, yAp + 0.55 * vH, 0, 0.30, 0.008, 0.008], id: 'vane-ew' });
      hw.push({ kind: 'vane', code: null, box: [0, yAp + 0.55 * vH, 0, 0.008, 0.008, 0.30], id: 'vane-ns' });
      hw.push({ kind: 'vane', code: null, box: [0, yAp + 0.80 * vH, 0, 0.42, 0.014, 0.004], id: 'vane-arrow' });
      hw.push({ kind: 'vane', code: null, box: [0.03, yAp + 0.93 * vH, 0, 0.16, 0.13, 0.004], id: 'vane-rooster' });
      cupTop = yAp + vH + 0.01; cupH = yAp - ySdl;
    }
    if (cuRun) {
      /* THE RUN on the left (-X): its own 4x4 posts on ground screws (their house faces 5 mm off the house's corner boards, <= 1.22 m / US
         4 ft apart) along both sides, 4x6 beams on them (two 8x260 down into each post), its top just under the house's eave fascia */
      var jg = _cuJg(s), xR1 = -(W / 2 + jg);
      cuWr = Wt - W - jg;
      var xR0 = xR1 - cuWr, yRT = yT(xe) - cw - 0.02, yRB = yRT - bh, zRl = L / 2 - p / 2, xRa = xR1 - p / 2, xRz = xR0 + p / 2;
      var nRb = Math.max(1, Math.ceil((xRa - xRz) / _coU(s, 'POST_SP') - 1e-9)), xRp = [];
      for (i = 0; i <= nRb; i++) xRp.push(xRa - (xRa - xRz) * i / nRb);
      for (sz = -1; sz <= 1; sz += 2) for (i = 0; i < xRp.length; i++) {
        var rpid = 'u' + (sz < 0 ? 'b' : 'f') + (i + 1);
        posts.push({ x: xRp[i], z: sz * zRl, sx: -2, sz: sz, id: rpid, i: i, run: true });
        pier(xRp[i], sz * zRl, 'post-' + rpid);
        box('post', PH.POST, ceil2(yRB - yPB), 'post-' + rpid, xRp[i], (yPB + yRB) / 2, sz * zRl, p, yRB - yPB, p);
        coat += 4 * p * (yRB - yPB);
        for (var e17 = -1; e17 <= 1; e17 += 2) scr('screw-cbeam', PH.FBEAM_SCREW, xRp[i] + e17 * p / 4.5, yRT, sz * zRl, [0, -1, 0], len260);
      }
      for (sz = -1; sz <= 1; sz += 2) {
        box('rbeam', PH.BEAM, ceil2(cuWr), 'rbeam-' + (sz < 0 ? 'b' : 'f'), (xR0 + xR1) / 2, yRB + bh / 2, sz * (L / 2 - bw / 2), cuWr, bh, bw);
        coat += 2 * (bw + bh) * cuWr;
      }
      /* the bottom rails, 2x4 laid flat between the posts (over the U heads' flanges), two 6x80 toe screws an end down into the post: the
         run's sides and end, and round the house's floor on its three other sides (the ground under it the run's); the mid rails the
         same, 0.95 m (US 3 ft) up along the run's sides (not across its door) and end */
      var cuRail = function (kind, id, x, z, dx, dz, alongZ, y0) {
        var y1 = y0 + st;
        box(kind, PH.STUD, ceil2(alongZ ? dz : dx), id, x, (y0 + y1) / 2, z, dx, st, dz);
        coat += 2 * (st + sd) * (alongZ ? dz : dx);
        if (kind === 'crail') nRail++; else nMr++;
        var skind = (kind === 'crail') ? 'screw-crail' : 'screw-mrail';
        for (var e12 = -1; e12 <= 1; e12 += 2) for (var k4 = -1; k4 <= 1; k4 += 2) {
          if (alongZ) scr(skind, PH.TIE_SCREW, x + k4 * sd / 4, y1, z + e12 * (dz / 2 - 0.04), [0, -0.5, e12 * 0.87], len80);
          else scrClear(skind, PH.TIE_SCREW, [[0.04, 0.25], [0.04, 0.4], [0.03, 0.4], [0.05, 0.1], [0.03, 0.1], [0.05, 0.4]].map(function (c7) { return [x + e12 * (dx / 2 - c7[0]), y1, z + k4 * sd * c7[1]]; }), [e12 * 0.87, -0.5, 0], len80);
        }
      };
      /* the run door (the front side, -Z, next to the house) and its latch stud: where the rails stop */
      var rdw = _coU(s, 'RDOOR') + 2 * clr, xDo1 = xR1 - p, xDo0 = xDo1 - rdw, xNx = xRp[1] + p / 2, hasSt = (xDo0 - xNx > st + 0.02);
      if (!hasSt) xDo0 = xNx;
      var xLs = xDo0 - st / 2, zDs = -zRl, yMd = _coU(s, 'MID_H');
      cuRail('crail', 'rail-ue', xRz, 0, sd, L - 2 * p, true, yRl0);   /* the rails along Z first: the ones along X clear of their screws in the corner posts */
      cuRail('mrail', 'mrail-ue', xRz, 0, sd, L - 2 * p, true, yMd);
      cuRail('crail', 'rail-hr', W / 2 - sd / 2, 0, sd, L - 2 * p, true, yRl0);
      for (sz = -1; sz <= 1; sz += 2) for (i = 0; i + 1 < xRp.length; i++) {
        var xa6 = xRp[i + 1] + p / 2, xb6 = xRp[i] - p / 2, sid = (sz < 0 ? 'b' : 'f') + (i + 1);
        cuRail('crail', 'rail-u' + sid, (xa6 + xb6) / 2, sz * (L / 2 - sd / 2), xb6 - xa6, sd, false, yRl0);
        var xm1 = (sz < 0 && i === 0) ? (hasSt ? xDo0 - st : null) : xb6;
        if (xm1 != null && xm1 - xa6 > 0.10) cuRail('mrail', 'mrail-u' + sid, (xa6 + xm1) / 2, sz * (L / 2 - sd / 2), xm1 - xa6, sd, false, yMd);
      }
      for (sz = -1; sz <= 1; sz += 2) cuRail('crail', 'rail-h' + (sz < 0 ? 'b' : 'f'), 0, sz * (L / 2 - sd / 2), 2 * xB, sd, false, yRl0);
      if (hasSt) {
        box('stud', PH.STUD, ceil2(yRB - yRl1), 'run-stud', xLs, (yRl1 + yRB) / 2, zDs, st, yRB - yRl1, sd);
        coat += 2 * (st + sd) * (yRB - yRl1);
        for (k = -1; k <= 1; k += 2) scr('screw-fstud', PH.STUD_SCREW, xLs, yRl0, zDs + k * sd / 4, [0, 1, 0], len120);
        scr('screw-beam', PH.BEAM_SCREW, xLs, yRT, zDs, [0, -1, 0], len200);
      }
      /* knee braces at the end's corners: a 2x4 from the end post's inner face up under its beam */
      var baU = _phU(s, 'BRACE'), bkU = sd / 2 * Math.SQRT2, xP0 = xR0 + p;
      for (sz = -1; sz <= 1; sz += 2) {
        var zKb = sz * (L / 2 - bw / 2), wbU = function (u, v) { return [xP0 + u, yRB + v]; };
        poly('kbrace', PH.STUD, ceil2((baU + bkU) * Math.SQRT2), 'kbrace-u' + (sz < 0 ? 'b' : 'f'), [wbU(0, -(baU + bkU)), wbU(0, -(baU - bkU)), wbU(baU - bkU, 0), wbU(baU + bkU, 0)], 'xy', zKb, st);
        coat += 2 * (st + sd) * (baU + bkU) * Math.SQRT2;
        nKb++;
        var tAu = wbU(0.06, 0.06 - baU - bkU), tBu = wbU(baU + bkU - 0.06, -0.06);
        scr('screw-kbrace', PH.BRACE_SCREW, tAu[0], tAu[1], zKb, [-1, 0, 0], len160);
        scr('screw-kbrace', PH.BRACE_SCREW, tBu[0], tBu[1], zKb, [0, 1, 0], len160);
      }
      /* THE TOP: a 2x4 plate laid flat between the beams' ends (two 6x160 through the beam into each end), 2x4 joists on edge between the
         beams at <= 60 cm (US 24 in.) from the house's end (two 8x200 through the beam into each end) -- off the posts' and the latch
         stud's lines (their screws down through the beam) */
      var xEp = xR0 + sd / 2, lJ = L - 2 * bw;
      box('rjoist', PH.STUD, ceil2(lJ), 'rjoist-end', xEp, yRT - st / 2, 0, sd, st, lJ);
      coat += 2 * (st + sd) * lJ;
      nRj++;
      for (sz = -1; sz <= 1; sz += 2) for (k = -1; k <= 1; k += 2) scrClear('screw-rjoist', PH.JOIST_SCREW, [0.25, 0.35, 0.15, 0.4, 0.05].map(function (f6) { return [xEp + k * sd * f6, yRT - st / 2, sz * L / 2]; }), [0, 0, -sz], len160);
      var xJ0 = xR1 - p - st / 2 - 0.005, xJ1 = xEp + sd / 2, nJr = Math.max(1, Math.ceil((xJ0 - xJ1) / _coU(s, 'RJ_SP') - 1e-9)), avoid = xRp.slice();
      if (hasSt) avoid.push(xLs);
      for (i = 0; i < nJr; i++) {
        var xq6 = xJ0 - (xJ0 - xJ1) * i / nJr;
        avoid.forEach(function (px6) { if (Math.abs(xq6 - px6) < p / 2 + st / 2 + 0.004) xq6 = px6 + ((xq6 > px6) ? 1 : -1) * (p / 2 + st / 2 + 0.005); });
        box('rjoist', PH.STUD, ceil2(lJ), 'rjoist-' + (i + 1), xq6, yRT - sd / 2, 0, st, sd, lJ);
        coat += 2 * (st + sd) * lJ;
        nRj++;
        for (sz = -1; sz <= 1; sz += 2) for (k = 0; k < 2; k++) {
          var fy = [[0.3, 0.25, 0.35, 0.2], [0.7, 0.75, 0.65, 0.8]][k];
          scrClear('screw-rjoist', PH.BEAM_SCREW, fy.map(function (f7) { return [xq6, yRT - sd * f7, sz * L / 2]; }), [0, 0, -sz], len200);
        }
      }
      /* THE RUN DOOR: a frame of 2x4 laid flat in the opening (stiles, top + bottom rail, a brace rising from the hinge side), two 6x160
         through each stile into each rail's end, the brace screwed in, hardware cloth stapled on its face; two strap hinges onto the
         house-side post's face, a barrel bolt onto the latch stud (MISSING) -- a leaf of its own ('door-r') */
      var lx0 = xDo0 + clr, lx1 = xDo1 - clr, ly0 = yRl1 + clr, ly1 = yRB - clr, lz = -(L / 2 - st / 2);
      box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-1', lx1 - sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
      box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-2', lx0 + sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
      box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-3', (lx0 + lx1) / 2, ly0 + sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
      box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-4', (lx0 + lx1) / 2, ly1 - sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
      coat += 2 * (st + sd) * (2 * (ly1 - ly0) + 2 * (lx1 - lx0 - 2 * sd));
      [ly0 + sd / 2, ly1 - sd / 2].forEach(function (yq) {
        for (var e13 = -1; e13 <= 1; e13 += 2) {
          scr('nail-door', PH.JOIST_SCREW, lx0, yq + e13 * sd / 4, lz, [1, 0, 0], len160);
          scr('nail-door', PH.JOIST_SCREW, lx1, yq + e13 * sd / 4, lz, [-1, 0, 0], len160);
        }
      });
      var bAu = [lx1 - sd, ly0 + sd], bBu = [lx0 + sd, ly1 - sd], bdxU = bBu[0] - bAu[0], bdyU = bBu[1] - bAu[1], bdlU = Math.sqrt(bdxU * bdxU + bdyU * bdyU);
      var bnxU = -bdyU / bdlU * sd / 2, bnyU = bdxU / bdlU * sd / 2, bexU = bdxU / bdlU * sd, beyU = bdyU / bdlU * sd;
      var bpU = [[bAu[0] - bexU + bnxU, bAu[1] - beyU + bnyU], [bAu[0] - bexU - bnxU, bAu[1] - beyU - bnyU], [bBu[0] + bexU - bnxU, bBu[1] + beyU - bnyU], [bBu[0] + bexU + bnxU, bBu[1] + beyU + bnyU]];
      bpU = _gzClip(bpU, 1, 0, -(lx0 + sd)); bpU = _gzClip(bpU, -1, 0, lx1 - sd); bpU = _gzClip(bpU, 0, 1, -(ly0 + sd)); bpU = _gzClip(bpU, 0, -1, ly1 - sd);
      if (_gzArea(bpU) < 0) bpU.reverse();
      poly('dframe', PH.STUD, ceil2(bdlU + sd), 'door-r-brace-1', bpU, 'xy', lz, st);
      coat += 2 * (st + sd) * bdlU;
      var adx = Math.abs(bdxU), hVu = sd / 2 * bdlU / adx, yBau = bAu[1] + 0.07 * bdyU / adx, yBbu = bBu[1] - 0.07 * bdyU / adx;
      scr('nail-door', PH.STUD_SCREW, bAu[0] - 0.07, Math.max(ly0 + sd + 0.005, yBau - hVu + 0.012), lz, [0, -1, 0], len120);   /* down through the brace's foot into the bottom rail */
      scr('nail-door', PH.STUD_SCREW, bBu[0] + 0.07, Math.min(ly1 - sd - 0.005, yBbu + hVu - 0.012), lz, [0, 1, 0], len120);   /* up through its head into the top rail */
      mesh('door-r-board-1', [[lx0, ly0], [lx1, ly0], [lx1, ly1], [lx0, ly1]], 'xy', -(L / 2 + mo), null);
      var rhl = 0.30, rhw = 0.035, rhT = 0.003, zHg = -(L / 2 + mo + 0.002);
      [ly0 + sd / 2, ly1 - sd / 2].forEach(function (hy, qi) {
        hw.push({ kind: 'hinge', code: PH.HINGE, box: [lx1 - rhl / 2 + 0.02, hy, zHg - rhT / 2, rhl, rhw, rhT], id: 'door-r-hinge-' + (qi * 2) });
        hw.push({ kind: 'hinge', code: null, box: [xR1 - p / 2, hy, zHg - rhT / 2, p * 0.8, rhw * 1.6, rhT], id: 'door-r-hinge-leaf-' + (qi * 2) });
        hinges++;
        for (var h5 = 0; h5 < 3; h5++) {
          scr('screw-hinge', PH.HINGE_SCREW, lx1 - 0.01 - h5 * 0.11, hy, zHg - rhT, [0, 0, 1], len40, 0.0022);
          var hx5 = xR1 - p / 2 + (h5 - 1) * 0.02, hy5 = hy + (h5 - 1) * 0.012;
          scrClear('screw-hinge', PH.HINGE_SCREW, [[hx5, hy5], [hx5, hy5 - 0.006], [hx5 + 0.008, hy5], [hx5 - 0.008, hy5]].map(function (c6) { return [c6[0], c6[1], zHg - rhT]; }), [0, 0, 1], len40, 0.0022);
        }
      });
      hw.push({ kind: 'bolt', code: null, box: [lx0, (ly0 + ly1) / 2, zHg - 0.007, 0.11, 0.03, 0.014], id: 'door-r-catch' });
      bolts++;
      /* THE HARDWARE CLOTH: each side from the ground up onto its beam (round the house's floor to its beams' underside), the door cut out;
         the end up to its plate; under the house's right side; the top over the joists to the house's siding (round its corner boards);
         the apron flat round all, 30 cm (US 12 in.) out, buried 5 cm (US 2 in.) */
      var MT = CO.MESH_T, xLo = xR0 - mo, xHi = W / 2 + mo, aprU = _coU(s, 'APRON'), ySt = yRB + 0.03;
      for (sz = -1; sz <= 1; sz += 2) mesh('mesh-s' + (sz < 0 ? 'b' : 'f'), [[xLo, 0], [xHi, 0], [xHi, yFB], [xR1, yFB], [xR1, ySt], [xLo, ySt]], 'xy', sz * (L / 2 + mo + MT / 2),
        (sz < 0) ? [[[xDo0, yRl1], [xDo1, yRl1], [xDo1, yRB], [xDo0, yRB]]] : null);
      mesh('mesh-e', [[-(L / 2 + mo), 0], [L / 2 + mo, 0], [L / 2 + mo, yRT], [-(L / 2 + mo), yRT]], 'zy', xLo - MT / 2, null);
      mesh('mesh-r', [[-(L / 2 + mo), 0], [L / 2 + mo, 0], [L / 2 + mo, yFB], [-(L / 2 + mo), yFB]], 'zy', xHi + MT / 2, null);
      var xIn = -(xa + 0.002), xCr = -(xa + tt + 0.002), zCb = L / 2 + sg - P.tw - 0.003, zOt = L / 2 + mo;
      mesh('mesh-t', [[xLo, -zOt], [xCr, -zOt], [xCr, -zCb], [xIn, -zCb], [xIn, zCb], [xCr, zCb], [xCr, zOt], [xLo, zOt]], 'xz', yRT + mo + MT / 2, null);
      stapleL += xRp.length * 2 * ySt + 4 * yFB + 2 * (cuWr + W) + 2 * L + (nRj + 1) * L + (hasSt ? yRB - yRl1 : 0) + 2 * cuWr + L;
      var ax0u = xLo - MT - 0.001, ax1u = xHi + MT + 0.001, az0u = L / 2 + mo + MT + 0.001;
      mesh('apron-l', [[ax0u - aprU, -az0u - aprU], [ax0u, -az0u - aprU], [ax0u, az0u + aprU], [ax0u - aprU, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
      mesh('apron-r', [[ax1u, -az0u - aprU], [ax1u + aprU, -az0u - aprU], [ax1u + aprU, az0u + aprU], [ax1u, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
      mesh('apron-b', [[ax0u, -az0u - aprU], [ax1u, -az0u - aprU], [ax1u, -az0u], [ax0u, -az0u]], 'xz', MT / 2 + 0.001, null, true);
      mesh('apron-f', [[ax0u, az0u], [ax1u, az0u], [ax1u, az0u + aprU], [ax0u, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
    }

    /* v401 THE HOOP COOP (type 52): the backyard coop's house alone (run off: its posts, floor, walls, gable roof, nest boxes, roosts,
       pop door and ramp, the access door at its back) stood inside a walk-in run COPIED from the hoop house (_ghHoopLayout, type 38):
       the ground screws + U heads, the 4x6 base, the 35 mm (US 1 3/8 in.) galvanized tube hoops <= 1.20 m (US 4 ft) apart up the base's
       outer faces, the hold-down strap pieces round their legs, the 2x6 hip boards, the ridge purlin + cross connectors, the end walls
       framed flat under the end hoops (studs / kings / cripples cut to the arc, girts, a strap over the hoop onto each), the door (a 2x3
       frame, braces, three strap hinges, a knob, a ball catch) in the front one. ADAPTED: hardware cloth instead of the film -- over the
       arc (hog-ringed to the hoops), on each hip board's top and down its outer face to the ground, on the end walls from the ground up
       to the arc (the door cut out) and on the door's frame; the coop's apron round it all (30 cm / US 12 in., buried); a tarp over the
       hoops from the back end past the house's front; no lock channel, wiggle wire or roll-up sides. The house GAP_B in from the back end
       wall (the keeper walks round it to the access door), centred across (WALK either side). */
    function hpShiftZ(dz) {
      pieces.forEach(function (pq) {
        if (pq.box) pq.box[2] += dz;
        else if (pq.quad) pq.quad = pq.quad.map(function (a2) { return [a2[0], a2[1], a2[2] + dz]; });
        else if (pq.plane === 'xy') pq.c += dz;
        else if (pq.plane === 'zy') { pq.poly = pq.poly.map(function (a2) { return [a2[0] + dz, a2[1]]; }); if (pq.holes) pq.holes = pq.holes.map(function (h2) { return h2.map(function (a2) { return [a2[0] + dz, a2[1]]; }); }); }
        else if (pq.plane === 'xz') { pq.poly = pq.poly.map(function (a2) { return [a2[0], a2[1] + dz]; }); if (pq.holes) pq.holes = pq.holes.map(function (h2) { return h2.map(function (a2) { return [a2[0], a2[1] + dz]; }); }); }
      });
      fas.forEach(function (fq) { fq.z += dz; });
      hw.forEach(function (hq) { if (hq.box) hq.box[2] += dz; if (hq.cyl) hq.cyl[2] += dz; if (hq.cylX) hq.cylX[2] += dz; });
      gscrews.forEach(function (g2) { g2.z += dz; });
      uheads.forEach(function (u2) { u2.z += dz; });
      posts.forEach(function (q2) { q2.z += dz; });
      blocks.forEach(function (b3) { b3.z += dz; });
    }
    function hpTunnel(L, W, zTarp) {
      var GP = _ghProf(s), st = GP.st, sd = GP.sd, bw = GP.bw, bh = GP.bh, tt = GP.tt, cw = GP.cw, ft = GP.ft, fw = GP.fw, ht = GP.rgt, hb = GP.rgd;
      var i, k, sx, sz, n0, MT = CO.MESH_T, nStart = pieces.length;
      var len200 = us ? 0.2032 : 0.20, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10, len80 = us ? 0.0762 : 0.08, len40 = us ? 0.0381 : 0.04, len38 = us ? 0.0381 : 0.038, len32 = us ? 0.0318 : 0.032;
      function cross(A, B) { return [A[1] * B[2] - A[2] * B[1], A[2] * B[0] - A[0] * B[2], A[0] * B[1] - A[1] * B[0]]; }
      function flyFrom(q0, f) { for (var q = q0; q < pieces.length; q++) pieces[q].hfly = f; }
      /* a tube along a polyline (no catalogue row: no code, its length to the missing list) */
      function tube(kind, id, pts, rad, fly) {
        var l = 0, q;
        for (q = 1; q < pts.length; q++) l += Math.sqrt(Math.pow(pts[q][0] - pts[q - 1][0], 2) + Math.pow(pts[q][1] - pts[q - 1][1], 2) + Math.pow(pts[q][2] - pts[q - 1][2], 2));
        pieces.push({ kind: kind, code: null, len: 0, id: id, tube: { pts: pts, r: rad }, tl: l, hfly: fly || [0, 1, 0] });
        return l;
      }
      /* an arc of a cylinder about (0, yS) along z (the cloth over the hoops, the tarp): drawn as an open cylinder, billed by area */
      function cylS(kind, id, rad, a0, a1, z0, z1, t) {
        pieces.push({ kind: kind, code: null, len: 0, id: id, cyl: { c: [0, yS], R: rad, a0: a0, a1: a1, z0: z0, z1: z1 }, t: t, hfly: [0, 1, 0] });
        return rad * (a1 - a0) * (z1 - z0);
      }
      /* THE HEIGHTS: the base's underside and top, the studs' foot, the arc's spring line yS (the legs' top) */
      var d = _ghU(s, 'TUBE_D'), r = d / 2, T2 = GH.STRAP_T, TB = _ghU(s, 'STRAP_TAB'), SW = GH.STRAP_W;
      var yBB = _ghU(s, 'FOOT_UP'), yBt = yBB + bh, yP0 = yBt + st, yS = yBt + _ghU(s, 'SIDE_H');
      var R = W / 2 + r, Ro = W / 2 + d, Ri = W / 2;   /* the hoops' centre line, outer and inner faces about (0, yS) */
      function yArc(x, rad) { return yS + Math.sqrt(Math.max(0, rad * rad - x * x)); }
      /* THE HOOPS' PLACES: the end ones in the end walls' plane, the inner ones evenly between */
      var zE = L / 2 - sd / 2, nb = Math.max(1, Math.ceil(2 * zE / _ghU(s, 'HOOP_SP') - 1e-9)), zs = [];
      for (i = 0; i <= nb; i++) zs.push(-zE + 2 * zE * i / nb);

      /* THE FOUNDATION: ground screws + U heads; the side ones at the ends and in the hoops' bays (<= 1.80 m, US 6 ft), the end beams' middles */
      var yHt = yBB - GH.U_UP, nPier = 0;
      function pier(x, z, alongZ, id) {
        gscrews.push({ x: x, z: z, r: _ghU(s, 'GS_R'), y1: yHt, id: id });
        uheads.push({ x: x, z: z, y0: yHt, y1: yBB, w: bw, a: alongZ ? 0 : Math.PI / 2, id: id });
        nPier++;
        for (var sd2 = -1; sd2 <= 1; sd2 += 2) for (var cI = -1; cI <= 1; cI += 2) for (var rI = 0; rI < 3; rI++) {
          var off = cI * ((sd2 < 0) ? 0.022 : 0.034), yy = yBB + 0.02 + rI * 0.025;
          if (alongZ) scr('nail-uhead', GH.UNAIL, x + sd2 * (bw / 2 + GH.U_T), yy, z + off, [-sd2, 0, 0], len38, 0.0019);
          else scr('nail-uhead', GH.UNAIL, x + off, yy, z + sd2 * (bw / 2 + GH.U_T), [0, 0, -sd2], len38, 0.0019);
        }
      }
      var pin = _ghU(s, 'PIER_IN'), psp = _ghU(s, 'PIER_SP'), zp0 = -L / 2 + pin, zp1 = L / 2 - pin, pz = [zp0], cur = zp0, mids = [];
      for (i = 0; i < nb; i++) mids.push((zs[i] + zs[i + 1]) / 2);
      while (zp1 - cur > psp + 1e-9) {
        var nxt = null;
        for (i = 0; i < mids.length; i++) if (mids[i] > cur + 0.30 && mids[i] < zp1 - 0.30 && mids[i] - cur <= psp + 1e-9) nxt = mids[i];
        if (nxt == null) break;
        pz.push(nxt); cur = nxt;
      }
      pz.push(zp1);
      for (sx = -1; sx <= 1; sx += 2) for (i = 0; i < pz.length; i++) pier(sx * (W / 2 - bw / 2), pz[i], true, 't' + (sx < 0 ? 'l' : 'r') + (i + 1));
      if (W > _ghU(s, 'MID_PIER_W') - 1e-6) for (sz = -1; sz <= 1; sz += 2) pier(0, sz * (L / 2 - bw / 2), false, 't' + (sz < 0 ? 'b' : 'f') + 'm');
      /* THE BASE: the side beams the full length, the end beams between them; two 8x200 at each corner, beside the end hoop's leg, between its straps */
      n0 = pieces.length;
      for (sx = -1; sx <= 1; sx += 2) box('hpbase', GH.BASE, ceil2(L), 't-base-' + (sx < 0 ? 'l' : 'r'), sx * (W / 2 - bw / 2), (yBB + yBt) / 2, 0, bw, bh, L);
      var ebL = W - 2 * bw;
      for (sz = -1; sz <= 1; sz += 2) {
        box('hpbase', GH.BASE, ceil2(ebL), 't-base-' + (sz < 0 ? 'b' : 'f'), 0, (yBB + yBt) / 2, sz * (L / 2 - bw / 2), ebL, bh, bw);
        for (sx = -1; sx <= 1; sx += 2) for (k = 0; k < 2; k++) scr('screw-hpbase', GH.BASE_SCREW, sx * W / 2, (yBB + yBt) / 2, sz * (L / 2 - ((k === 0) ? bw - 0.012 : 0.012)), [-sx, 0, 0], len200);
      }
      flyFrom(n0, [0, -1, 0]);

      /* THE HOOPS: the legs straight up the base's outer faces, the round arc over the width (one bent tube) */
      var nA = 72, tubeL = 0, hoopL = 0;   /* 2.5 deg chords: < 0.5 mm off the round */
      function arcPts(rad, zc, a0, a1) { var out = [], q; for (q = 0; q <= nA; q++) { var a = a0 + (a1 - a0) * q / nA; out.push([rad * Math.cos(a), yS + rad * Math.sin(a), zc]); } return out; }
      var yL0 = yBB + 0.005;
      for (i = 0; i <= nb; i++) {
        hoopL = tube('hphoop', 't-hoop-' + (i + 1), [[R, yL0, zs[i]]].concat(arcPts(R, zs[i], 0, Math.PI)).concat([[-R, yL0, zs[i]]]), r, [0, 1, 0]);
        tubeL += hoopL;
      }
      /* THE STRAPS: a cut piece of the hold-down strap round a tube, its loop over the tube, a 5x40 through each tab into the face it
         lies on. C the tube's centre at the strap, A its axis, Nn the face's normal (towards the tube); dn: the screws' way in */
      var nStrap = 0;
      function hat(kind, id, C, A, Nn, dn) {
        var Tt = cross(Nn, A), O = [C[0] - Nn[0] * r, C[1] - Nn[1] * r, C[2] - Nn[2] * r], e = r + TB;
        var pts = [[-e, 0], [-r, 0], [-r, d], [r, d], [r, 0], [e, 0], [e, T2], [r + T2, T2], [r + T2, d + T2], [-(r + T2), d + T2], [-(r + T2), T2], [-e, T2]];
        hw.push({ kind: kind, code: GH.HSTRAP, hat: { o: O, t: Tt, n: Nn, a: A, pts: pts, w: SW }, id: id, fly: [Nn[0], Nn[1], Nn[2]] });
        nStrap++;
        for (var e2 = -1; e2 <= 1; e2 += 2) {
          var tc = e2 * (r + T2 + (TB - T2) / 2), P2 = [O[0] + Tt[0] * tc + Nn[0] * T2, O[1] + Tt[1] * tc + Nn[1] * T2, O[2] + Tt[2] * tc + Nn[2] * T2];
          scr('screw-' + kind, GH.HSTRAP_SCREW, P2[0], P2[1], P2[2], dn || [-Nn[0], -Nn[1], -Nn[2]], len40, 0.0025);
        }
      }
      var yHipM = yS - hb / 2;
      for (i = 0; i <= nb; i++) for (sx = -1; sx <= 1; sx += 2) {
        var hid = 't-hoop-' + (i + 1) + (sx < 0 ? 'l' : 'r');
        hat('hpstrap', hid + '-base-1', [sx * R, yBB + 0.04, zs[i]], [0, 1, 0], [sx, 0, 0]);
        hat('hpstrap', hid + '-base-2', [sx * R, yBt - 0.04, zs[i]], [0, 1, 0], [sx, 0, 0]);
        hat('hpstrap', hid + '-hip', [sx * R, yHipM, zs[i]], [0, 1, 0], [-sx, 0, 0]);
      }
      /* THE HIP BOARDS: a 2x6 on each side outside the legs, its top on the arc's spring line */
      for (sx = -1; sx <= 1; sx += 2) {
        n0 = pieces.length;
        box('hphip', GH.RIDGE, ceil2(L), 't-hip-' + (sx < 0 ? 'l' : 'r'), sx * (Ro + ht / 2), yS - hb / 2, 0, ht, hb, L);
        flyFrom(n0, [sx, 0, 0]);
      }
      /* THE RIDGE PURLIN under the crowns, a cross connector at every hoop */
      var yPu = yS + R - d;
      tubeL += tube('hppurlin', 't-ridge-purlin', [[0, yPu, -zE - r], [0, yPu, zE + r]], r, [0, -1, 0]);
      for (i = 0; i <= nb; i++) hw.push({ kind: 'hpxconn', code: null, box: [0, yS + R - r, zs[i], 0.055, d + 0.03, 0.05], id: 't-xconn-' + (i + 1), fly: [0, 1, 0] });

      /* THE END WALLS, framed flat and stood up on the end beams under the end hoop (4 mm in from the legs): the studs, kings and
         cripples cut to the hoop's underside, a strap over the hoop onto each top (the corner studs' tops under its steep side: none);
         no stud in the middle (the purlin's end); the door in the front one */
      var g0 = 0.004, u0 = -(W / 2 - g0), u1 = W / 2 - g0;
      var half = (_ghU(s, 'DOOR_W') + 2 * _ghU(s, 'DOOR_CLR')) / 2, oL = half + 2 * st;
      var yD0 = yBt + _ghU(s, 'DOOR_CLR'), dHmax = yArc(oL, Ri) - 0.10 - st - _ghU(s, 'DOOR_CLR') - yD0;
      var dH = Math.min(_ghU(s, 'DOOR_H'), dHmax), yD1 = yD0 + dH, yHd = yD1 + _ghU(s, 'DOOR_CLR'), yHtp = yHd + st;
      var gsp = _ghU(s, 'STUD_SP'), sym = [];
      for (k = 0; gsp / 2 + k * gsp < u1 - 1.5 * st - 0.10; k++) sym.push(gsp / 2 + k * gsp);
      var grid = sym.map(function (u) { return -u; }).reverse().concat(sym);
      grid = [u0 + st / 2].concat(grid).concat([u1 - st / 2]);
      var yGa = (yP0 + yS) / 2, yGb = yS + 0.60, nGirt = 0, nStud = 0, nSad = 0;
      function topPoly(xa, xb, y0) { var pts = [[xa, y0], [xb, y0]], q, nq = 6; for (q = 0; q <= nq; q++) { var x = xb + (xa - xb) * q / nq; pts.push([x, yArc(x, Ri)]); } return pts; }
      function endWall(sz2, door) {
        var id = 't-end-' + (sz2 < 0 ? 'b' : 'f'), zc = sz2 * (L / 2 - sd / 2), m, e, f2, q0 = pieces.length;
        function bxW(kind, code, len, sid, u, y, du, dy) { box(kind, code, len, sid, u, y, zc, du, dy, sd); }
        function scW(kind, code, u, y, n, du, dy, dn, ln) { scr(kind, code, u, y, zc + sz2 * n, [du, dy, sz2 * dn], ln); }
        function member(kind, sid, u, y0) {
          var pts = topPoly(u - st / 2, u + st / 2, y0), yTop = Math.max(yArc(u - st / 2, Ri), yArc(u + st / 2, Ri));
          poly(kind, GH.STUD, ceil2(yTop - y0), sid, pts, 'xy', zc, sd);
          return pts;
        }
        /* a strap over the hoop onto a member's top: the hoop's point above its middle, the screws straight down */
        function saddle(sid, u) {
          var cth = Math.max(-1, Math.min(1, u / R)), th = Math.acos(cth), sth = Math.sin(th);
          hat('hpsstrap', sid, [R * cth, yS + R * sth, sz2 * zE], [-sth, cth, 0], [cth, sth, 0], [0, -1, 0]);
          nSad++;
        }
        var plates = door ? [[u0, -half], [half, u1]] : [[u0, u1]];
        for (m = 0; m < plates.length; m++) bxW('hpplate', GH.STUD, ceil2(plates[m][1] - plates[m][0]), id + '-plate-' + (m + 1), (plates[m][0] + plates[m][1]) / 2, yBt + st / 2, plates[m][1] - plates[m][0], st);
        var studs = grid.filter(function (u) { return !door || Math.abs(u) > oL + st / 2 + 0.10; });
        var kings = door ? [-(oL - st / 2), oL - st / 2] : [];
        for (m = 0; m < studs.length; m++) {
          member('hpstud', id + '-stud-' + (m + 1), studs[m], yP0);
          nStud++;
          for (e = -1; e <= 1; e += 2) scW('screw-hpstud', GH.STUD_SCREW, studs[m], yBt, e * sd / 4, 0, 1, 0, len120);
          if (m > 0 && m < studs.length - 1) saddle(id + '-stud-' + (m + 1) + '-strap', studs[m]);
        }
        if (door) {
          /* THE DOOR: the kings up to the hoop, the jacks, the flat header, two cripples over it (clear of the purlin's end) */
          for (e = -1; e <= 1; e += 2) {
            var uk = kings[(e < 0) ? 0 : 1], uj = e * (half + st / 2);
            member('hpking', id + '-king-' + (e < 0 ? 'l' : 'r'), uk, yP0);
            saddle(id + '-king-' + (e < 0 ? 'l' : 'r') + '-strap', uk);
            bxW('hpjack', GH.STUD, ceil2(yHd - yP0), id + '-jack-' + (e < 0 ? 'l' : 'r'), uj, (yP0 + yHd) / 2, st, yHd - yP0);
            for (f2 = -1; f2 <= 1; f2 += 2) {
              scW('screw-hpstud', GH.STUD_SCREW, uk, yBt, f2 * sd / 4, 0, 1, 0, len120);
              scW('screw-hpstud', GH.STUD_SCREW, uj, yBt, f2 * sd / 4, 0, 1, 0, len120);
              scW('screw-hpframe', GH.STUD_SCREW, e * oL, yHd + st / 2, f2 * sd / 4, -e, 0, 0, len120);   /* through the king into the header's end */
            }
            for (f2 = 0; f2 < 3; f2++) scW('screw-hpframe', us ? GH.TOE : GH.FRAME_SCREW, e * oL, yP0 + (yHd - yP0) * (0.2 + 0.3 * f2), 0, -e, 0, 0, us ? len80 : len100);   /* the king into the jack */
            nStud += 2;
            var uc = e * (half / 2 + 0.02);
            member('hpcripple', id + '-cripple-' + (e < 0 ? 'l' : 'r'), uc, yHtp);
            saddle(id + '-cripple-' + (e < 0 ? 'l' : 'r') + '-strap', uc);
            for (f2 = -1; f2 <= 1; f2 += 2) scW('screw-hpcripple', GH.STUD_SCREW, uc, yHd, f2 * sd / 4, 0, 1, 0, len120);   /* up through the header */
          }
          bxW('hpheader', GH.STUD, ceil2(2 * (half + st)), id + '-header', 0, yHd + st / 2, 2 * (half + st), st);
        }
        /* the bottom plate's screws between the members, the girts across the bays (under both members' tops) */
        var full = studs.concat(kings).sort(function (a, b) { return a - b; });
        for (m = 0; m + 1 < full.length; m++) {
          var a = full[m], b = full[m + 1], um = (a + b) / 2, clr2 = b - a - st, isDoor = door && a < -half && b > half;
          if (!isDoor && clr2 > 0.12) scW('screw-hpplate', GH.STUD_SCREW, um, yP0, 0, 0, -1, 0, len120);
          if (isDoor || clr2 < 0.05) continue;
          var yLow = Math.min(yArc(a + st / 2, Ri), yArc(b - st / 2, Ri));
          [yGa, yGb].forEach(function (yc, gy) {
            if (yc + st / 2 + 0.03 > yLow) return;
            bxW('hpgirt', GH.STUD, ceil2(clr2), id + '-girt-' + (m + 1) + '-' + (gy + 1), um, yc, clr2, st);
            nGirt++;
            for (var e3 = -1; e3 <= 1; e3 += 2) {
              var ue = (e3 < 0) ? a + st / 2 + Math.min(0.035, clr2 / 4) : b - st / 2 - Math.min(0.035, clr2 / 4), du2 = (e3 < 0) ? -0.8 : 0.8;
              scW('screw-hpgirt', GH.TOE, ue, yc + st / 2, e3 * sd / 4, du2, -0.6, 0, len80);   /* from the girt's top face */
              scW('screw-hpgirt', GH.TOE, ue, yc + e3 * st / 4, -e3 * sd / 2, du2, 0, e3 * 0.6, len80);   /* from its inner face (the left end: its outer face, clear of the top one) */
            }
          });
        }
        flyFrom(q0, [0, 0, sz2]);
        return { studs: studs, kings: kings, full: full };
      }
      var ewB = endWall(-1, false), ewF = endWall(1, true);

      /* THE HARDWARE CLOTH (the coop's, MISSING by area): over the arc to the hip boards' inner edges (hog rings to every hoop and the
         purlin, HOG_SP apart), each hip board's top, down its outer face to the ground; the end walls from the ground up to the arc's
         outside (the door's opening cut out); the door's frame */
      var hogSp = _coU(s, 'HOG_SP'), hogs = 0, nArc = 48, aprU = _coU(s, 'APRON');
      meshA += cylS('mesh', 't-mesh-arc', Ro + MT / 2, 0, Math.PI, -L / 2, L / 2, MT);
      stapleL += 2 * L;
      hogs += (nb + 1) * Math.ceil(Math.PI * Ro / hogSp - 1e-9) + Math.ceil(L / (2 * hogSp) - 1e-9);
      for (sx = -1; sx <= 1; sx += 2) {
        var xs0 = sx * Ro, xs1 = sx * (Ro + ht);
        n0 = pieces.length;
        mesh('t-mesh-hip-' + (sx < 0 ? 'l' : 'r'), [[Math.min(xs0, xs1), -L / 2], [Math.max(xs0, xs1), -L / 2], [Math.max(xs0, xs1), L / 2], [Math.min(xs0, xs1), L / 2]], 'xz', yS + MT / 2, null);
        mesh('t-mesh-side-' + (sx < 0 ? 'l' : 'r'), [[-L / 2, 0], [L / 2, 0], [L / 2, yS + MT], [-L / 2, yS + MT]], 'zy', sx * (Ro + ht + MT / 2), null);
        flyFrom(n0, [sx, 0, 0]);
        hogs += 2 * (nb + 1) * Math.ceil((yS - yBB) / hogSp - 1e-9);   /* the side's cloth to the legs */
      }
      for (sz = -1; sz <= 1; sz += 2) {
        var arcO = [];
        for (k = 0; k <= nArc; k++) { var aE = Math.PI * k / nArc; arcO.push([Ro * Math.cos(aE), yS + Ro * Math.sin(aE)]); }
        var ePts = [[-Ro, 0], [Ro, 0]].concat(arcO);
        n0 = pieces.length;
        mesh('t-mesh-end-' + (sz < 0 ? 'b' : 'f'), ePts, 'xy', sz * (L / 2 + MT / 2), (sz > 0) ? [[[-half, yBt + 0.002], [half, yBt + 0.002], [half, yHd], [-half, yHd]]] : null);
        flyFrom(n0, [0, 0, sz]);
      }
      /* THE CASINGS round the door (jambs + head) over the cloth's cut edges */
      var zC = L / 2 + MT;
      n0 = pieces.length;
      [['jamb-l', -half - cw / 2, yBt, yHd, cw], ['jamb-r', half + cw / 2, yBt, yHd, cw], ['head', 0, yHd, yHd + cw, 2 * half + 2 * cw]].forEach(function (c4) {
        var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc2 = (c4[2] + c4[3]) / 2;
        box('hpcasing', GH.BOARD, ceil2(horiz ? du : dy), 't-casing-' + c4[0], c4[1], yc2, zC + tt / 2, du, dy, tt);
        var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _ghU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _ghU(s, 'FIX_SP'));
        pts2.forEach(function (w2) {
          for (var e5 = -1; e5 <= 1; e5 += 2) scr('nail-hptrim', GH.TRIM_NAIL, horiz ? w2 + e5 * 0.012 : c4[1] + e5 * cw / 4, horiz ? yHd + st / 2 + e5 * st / 4 : w2, zC + tt, [0, 0, -1], len32, 0.0012);
        });
      });
      flyFrom(n0, [0, 0, 1]);
      /* THE DOOR: the hoop house's 2x3 frame in the opening, the cloth stapled on its face; three strap hinges onto the casing, a knob, a ball catch */
      var dW = _ghU(s, 'DOOR_W'), zD1 = L / 2, zDc = zD1 - ft / 2;
      var railY = [yD0 + fw / 2, yD0 + Math.min(_ghU(s, 'DOOR_MID'), dH * 0.55), yD1 - fw / 2], rW = dW - 2 * fw;
      n0 = pieces.length;
      for (sx = -1; sx <= 1; sx += 2) box('hpdframe', GH.FRAME, ceil2(dH), 't-door-stile-' + (sx < 0 ? 'l' : 'r'), sx * (dW / 2 - fw / 2), (yD0 + yD1) / 2, zDc, fw, dH, ft);
      for (k = 0; k < 3; k++) {
        box('hpdframe', GH.FRAME, ceil2(rW), 't-door-rail-' + (k + 1), 0, railY[k], zDc, rW, fw, ft);
        for (sx = -1; sx <= 1; sx += 2) for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-hpdoor', GH.STUD_SCREW, sx * dW / 2, railY[k] + e7 * fw / 4, zDc + e7 * ft / 4, [-sx, 0, 0], len120);   /* staggered across the frame's thickness, clear of the brace's screw */
      }
      function dbrace(idB, yA, yB2) {
        var xA = dW / 2 - fw, xZ = -dW / 2 + fw, dx = xZ - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * fw / 2, ny = ux * fw / 2;
        var ext = fw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xZ + ux * ext, by0 = yB2 + uy * ext;
        var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
        pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2); pb = _gzClip(pb, 1, 0, -xZ); pb = _gzClip(pb, -1, 0, xA);
        if (_gzArea(pb) < 0) pb.reverse();
        poly('hpdbrace', GH.FRAME, ceil2(dl + fw), idB, pb, 'xy', zDc, ft);
        var xLo = pb.reduce(function (m5, Pt) { return (Pt[1] < yA + 0.002) ? m5.concat([Pt[0]]) : m5; }, []), xHi = pb.reduce(function (m5, Pt) { return (Pt[1] > yB2 - 0.002) ? m5.concat([Pt[0]]) : m5; }, []);
        if (xLo.length) scr('screw-hpdoor', GH.STUD_SCREW, (Math.min.apply(null, xLo) + Math.max.apply(null, xLo)) / 2, yA - fw, zDc, [0, 1, 0], len120);
        if (xHi.length) scr('screw-hpdoor', GH.STUD_SCREW, (Math.min.apply(null, xHi) + Math.max.apply(null, xHi)) / 2, yB2 + fw, zDc, [0, -1, 0], len120);
      }
      dbrace('t-door-brace-1', railY[0] + fw / 2, railY[1] - fw / 2);
      dbrace('t-door-brace-2', railY[1] + fw / 2, railY[2] - fw / 2);
      mesh('t-mesh-door', [[-dW / 2, yD0], [dW / 2, yD0], [dW / 2, yD1], [-dW / 2, yD1]], 'xy', zD1 + MT / 2, null);
      stapleL += 3 * rW;   /* along the rails too */
      flyFrom(n0, [0, 0, 1]);
      var hingeLen = 0.30, hingeW = 0.035, hT = 0.003;
      for (k = 0; k < 3; k++) {
        var hy = railY[k];
        hw.push({ kind: 'hphinge', code: GH.HINGE, box: [dW / 2 - hingeLen / 2, hy, zD1 + MT + hT / 2, hingeLen, hingeW, hT], id: 't-door-hinge-' + k, fly: [0, 0, 1] });
        hw.push({ kind: 'hphinge', code: null, box: [half + cw / 2, hy, zC + tt + hT / 2, cw * 0.8, hingeW * 1.6, hT], id: 't-door-hinge-leaf-' + k, fly: [0, 0, 1] });
        hinges++;
        for (i = 0; i < 3; i++) {
          scr('screw-hphinge', GH.HINGE_SCREW, dW / 2 - 0.035 - i * 0.10, hy, zD1 + MT + hT, [0, 0, -1], len40, 0.0022);
          scr('screw-hphinge', GH.HINGE_SCREW, half + cw / 2, hy + (i - 1) * hingeW * 0.5, zC + tt + hT, [0, 0, -1], len40, 0.0022);
        }
      }
      hw.push({ kind: 'hpknob', code: GH.KNOB, cyl: [-dW / 2 + fw / 2, yBt + _ghU(s, 'KNOB_Y'), zD1 + MT, 0.025, 0.05], id: 't-door-knob', fly: [0, 0, 1] });
      hw.push({ kind: 'hpcatch', code: GH.CATCH, box: [-dW / 2 + 0.03, yD1 - 0.03, zD1 - ft - 0.008, 0.03, 0.02, 0.016], id: 't-door-catch', fly: [0, 0, 1] });
      knobs++; catches++;
      /* THE APRON round it all: flat on the ground 30 cm (US 12 in.) out from the cloth, buried 5 cm (US 2 in.) -- the coop's */
      var ax0u = -(Ro + ht + MT) - 0.001, ax1u = Ro + ht + MT + 0.001, az0u = L / 2 + MT + 0.001;
      n0 = pieces.length;
      mesh('t-apron-l', [[ax0u - aprU, -az0u - aprU], [ax0u, -az0u - aprU], [ax0u, az0u + aprU], [ax0u - aprU, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
      mesh('t-apron-r', [[ax1u, -az0u - aprU], [ax1u + aprU, -az0u - aprU], [ax1u + aprU, az0u + aprU], [ax1u, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
      mesh('t-apron-b', [[ax0u, -az0u - aprU], [ax1u, -az0u - aprU], [ax1u, -az0u], [ax0u, -az0u]], 'xz', MT / 2 + 0.001, null, true);
      mesh('t-apron-f', [[ax0u, az0u], [ax1u, az0u], [ax1u, az0u + aprU], [ax0u, az0u + aprU]], 'xz', MT / 2 + 0.001, null, true);
      flyFrom(n0, [0, -1, 0]);
      /* THE TARP over the hoops (on the cloth) from the back end to past the house's front (MISSING, by area) */
      var tT = HP.TARP_T, tarpA = cylS('hptarp', 't-tarp', Ro + MT + tT / 2 + 0.002, 0, Math.PI, -L / 2, Math.min(L / 2, zTarp), tT);
      /* the coating over the tunnel's wood (the hoop house's rates) */
      var per = {}; per[GH.STUD] = 2 * (st + sd); per[GH.BASE] = 2 * (bw + bh); per[GH.RIDGE] = 2 * (ht + hb); per[GH.FRAME] = 2 * (ft + fw); per[GH.BOARD] = 2 * (tt + cw);
      for (i = nStart; i < pieces.length; i++) { var pq = pieces[i]; if (pq.len > 0 && per[pq.code]) coat += per[pq.code] * pq.len; }
      return {
        L: L, W: W, top: yS + Ro + MT + tT + 0.002, extX: Ro + ht + MT + aprU + 0.01, extZ: L / 2 + MT + aprU + 0.01, yS: yS, Ro: Ro, yBt: yBt,
        hoops: nb + 1, hoopSp: 2 * zE / nb, hoopL: hoopL, tubeL: tubeL, xconn: nb + 1, straps: nStrap, saddles: nSad, strapBuy: Math.ceil(nStrap / 3), hogs: hogs,
        tarpA: tarpA, piers: nPier, studs: nStud, girts: nGirt, doorW: dW, doorH: dH, studsB: ewB.full.length, studsF: ewF.full.length
      };
    }
    var hpInfo = null;
    if (hpRun) {
      var hpLt = _phL(s), hpWt = _phW(s), hpDz = -hpLt / 2 + _ghProf(s).sd + _coU(s, 'GAP_B') + L / 2;
      hpShiftZ(hpDz);
      zH += hpDz;
      hpInfo = hpTunnel(hpLt, hpWt, zH + _coU(s, 'TARP_OV'));
      hpInfo.hcz = hpDz;
    }

    /* v386 THE LEAN-TO AT THE HOUSE: reinforced angle brackets FAT00005 under the high beam -- one under each end where it runs
       on past the walls, one in every run bay (clear of the front corner's knee brace) -- a leg up under the beam (three 5x40 up
       into it), the other down the house wall (two concrete screw anchors FAS10075); the house wall drawn as context (see-through,
       not billed, not in AR) */
    var nBrk = 0;
    if (ln) {
      var brkL = _ghU(s, 'BRK_L'), brkW = GH.BRK_W, brkT = GH.BRK_T, bzs = [];
      var zFr0 = run ? L / 2 + mo + 0.01 : zH + sg + tt + 0.005;
      [[zBb + 0.005, -(L / 2 + sg + tt) - 0.005], [zFr0, zBf - 0.005]].forEach(function (zn) { if (zn[1] - zn[0] >= brkW) bzs.push((zn[0] + zn[1]) / 2); });
      if (run) {
        var lp = posts.filter(function (q7) { return q7.sx < 0; }).sort(function (a7, b7) { return a7.z - b7.z; });
        for (i = 0; i + 1 < lp.length; i++) {
          var zba = lp[i].z + p / 2, zbb = lp[i + 1].z - p / 2;
          if (zbb < zH + 0.01) continue;   /* the house's bay */
          zba = Math.max(zba, zH + sg + tt + 0.01);
          if (lp[i + 1].z > zf - 1e-6) zbb = Math.min(zbb, zP - ba - bk - 0.01);   /* clear of the front corner's knee brace */
          if (zbb - zba >= brkW + 0.02) bzs.splice(bzs.length - 1, 0, (zba + zbb) / 2);
        }
      }
      bzs.sort(function (a8, b8) { return a8 - b8; }).forEach(function (zq) {
        var bid = 'bracket-' + (nBrk + 1);
        hw.push({ kind: 'bracket', code: GH.BRACKET, box: [xHw + brkL / 2, yBmL - brkT / 2, zq, brkL, brkT, brkW], id: bid });
        hw.push({ kind: 'bracket', code: null, box: [xHw + brkT / 2, yBmL - brkL / 2, zq, brkT, brkL, brkW], id: bid + '-wall' });
        for (var q8 = 0; q8 < 3; q8++) scr('screw-bracket', GH.BRK_SCREW, -W / 2 + 0.02 + 0.025 * q8, yBmL - brkT, zq + ((q8 % 2) ? 0.012 : -0.012), [0, 1, 0], len40, 0.0022);
        for (q8 = 0; q8 < 2; q8++) scr('screw-anchor', GH.ANCHOR, xHw + brkT, yBmL - 0.05 - 0.055 * q8, zq, [-1, 0, 0], len75, 0.005);
        nBrk++;
      });
      var hTop = yT(xLe) + 0.9, hZ = Math.max(L / 2, zBf) + 0.9;
      pieces.push({ kind: 'house', code: null, len: 0, id: 'house-wall', box: [xHw - LN.HOUSE_T / 2, (hTop - 0.1) / 2, 0, LN.HOUSE_T, hTop + 0.1, 2 * hZ] });
    }

    /* the bill's quantities: timber by code; the hardware cloth (MISSING, by area), the barrel bolts (MISSING), the
       staples by the length of the lines they hold, the nest boxes' OSB, the apron's trench */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) { var pc = pieces[i]; if (pc.len > 0 && pc.code) m3[pc.code] = (m3[pc.code] || 0) + pc.len; }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; }, r2 = function (v) { return Math.round(v * 100) / 100; };
    var meshAll = (meshA + apronA) * PH.WASTE, staples = Math.ceil(stapleL / _coU(s, 'STAPLE_SP') - 1e-9);
    missing.push(us ? { name: CO.MESH_NAME, qty: r2(meshAll * 10.7639), unit: 'ft2' } : { name: CO.MESH_NAME, qty: r2(meshAll), unit: 'm2' });
    missing.push({ name: CO.BOLT_NAME, qty: bolts, unit: 'pcs' });
    if (cu) missing.push({ name: CU.VANE_NAME, qty: 1, unit: 'pcs' });   /* v391 the cupola's weathervane */
    if (hpInfo) {   /* v401 the hoop coop's run: the tube, the cross connectors, the hog rings, the tarp (no catalogue rows) */
      missing.push({ name: GH.TUBE_NAME, qty: r2(Math.ceil(hpInfo.tubeL * 100 - 1e-6) / 100), unit: 'm' });
      missing.push({ name: GH.XCONN_NAME, qty: hpInfo.xconn, unit: 'pcs' });
      missing.push({ name: HP.HOG_NAME, qty: hpInfo.hogs, unit: 'pcs' });
      missing.push(us ? { name: HP.TARP_NAME, qty: r2(hpInfo.tarpA * PH.WASTE * 10.7639), unit: 'ft2' } : { name: HP.TARP_NAME, qty: r2(hpInfo.tarpA * PH.WASTE), unit: 'm2' });
    }
    var extra = {};
    extra[PH.FLOOR] = r2(nestA * PH.WASTE);
    extra[CO.STAPLE] = staples;
    if (apronA > 0) extra[PH.DIG] = r3(apronA * _coU(s, 'APRON_DIG'));
    if (nBrk) extra[GH.BRACKET] = nBrk;   /* v386 the lean-to's brackets */
    if (hpInfo) extra[GH.HSTRAP] = hpInfo.strapBuy;   /* v401 the hoop coop: the hold-down strap bought whole, cut in three */
    var top = cu ? cupTop : (ln ? yT(xLe) : yT(0)) + rsV + 0.01;
    var cuDx = cu ? Wt / 2 - W / 2 : 0, cuExtX = 0;
    if (cu) { cuShift(cuDx); cuExtX = Math.max(Wt / 2 + (cuRun ? 0.31 : 0), nb1 + ov + cuDx, W / 2 + _phU(s, 'EAVE') + 0.05 + cuDx); }   /* v391 the house to its end of the footprint */
    return _hpRet({
      P: P, us: us, porch: false, L: L, W: cu ? Wt : W, PD: 0, zF: L / 2, pieces: pieces, fas: fas, blocks: blocks, hw: hw, posts: posts, joists: joists, rafters: zr,
      meters: m3, coat: coat, floorA: floorA, roofA: roofA, sidingA: sidingA, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: 0, digM3: 0, hinges: hinges, knobs: knobs, catches: catches, shutters: 0, deckBoards: 0,
      ties: nTies, gStuds: gStuds, trims: nTrim, doorBoards: nDb, doorW: doorW, doorH: doorH, RO: ROa, win: ln ? 0 : cu ? ROa : winW,
      yB: yFB, yF: yF, yPT: yPT, yBm: yBm, yHd: yHa, yWS: ySW, ridgeTop: rgTop, pitch: bn ? Math.round(th * 180 / Math.PI) : ln ? LN.PITCH : cu ? CU.PITCH : CO.PITCH, rafL: rafL, roofLen: eLen, slope: slope,
      top: top, height: top, depth: cu ? Wt : W, length: L, mono: false, roofCov: 'shingle', yPTL: yPTL, seams: 0,
      stilt: false, slide: false, gscrews: gscrews, uheads: uheads, missing: missing, yD: yF, extX: cu ? cuExtX : Math.max(W / 2 + (run ? 0.31 : 0), nb1 + ov, ln ? W / 2 + gapH + LN.HOUSE_T : 0), extZ: extZ,
      sPosts: posts.length, xBraces: 0, balusters: 0, treads: 0, rails: nRail,
      coop: true, hoopCoop: hp, barnCoop: bn, gussetA: bn ? gussetA : 0, walkin: wi, lean: ln, brackets: nBrk, closers: nClose, run: cu ? cuRun : run, cupola: cu, houseW: W, runW: cuWr, hx: cuDx, midRails: nMr, rJoists: nRj, cupolaH: cupH, hens: N, Lh: Lh, zH: zH, nests: nN, nestsWanted: nWant, roosts: nR, roostLen: 2 * xB, kbraces: nKb, ramp: { len: rLen, cleats: nCl, foot: rzt },
      meshA: r2(meshA), apronA: r2(apronA), meshAll: r2(meshAll), staples: staples, bolts: bolts, nestA: r2(nestA), extra: extra
    }, hpInfo);   /* v401 the hoop coop: the run's footprint */
  }

  /* its staged assembly (the playhouses' step engine, a table of its own): one catalogue item a step, the screws that fix it
     the step after; the frame on its piers, the floor, the beams, the walls, the roof, the skin, the doors, the nest boxes,
     the roosts, the ramp, then the hardware cloth and the barrel bolts (MISSING) */
  function _coSteps() {
    return ([
      { parts: [], codes: [] },
      { parts: ['ph-gscrew'], codes: [PH.GSCREW] },
      { parts: ['ph-uhead'], codes: [PH.UHEAD] },
      { parts: ['ph-post'], codes: [PH.POST] },
      { parts: ['ph-hpbase'], codes: [GH.BASE] },   /* v401 the hoop coop's run: its base */
      { parts: ['ph-hw-screw-hpbase'], codes: [GH.BASE_SCREW] },
      { parts: ['ph-hw-nail-uhead'], codes: [PH.UNAIL] },
      { parts: ['ph-fbeam'], codes: [PH.BEAM] },
      { parts: ['ph-hw-screw-fbeam'], codes: [PH.BEAM_SCREW] },
      { parts: ['ph-joist'], codes: [PH.JOIST] },
      { parts: ['ph-hw-screw-joist'], codes: [PH.BEAM_SCREW] },
      { parts: ['ph-beam', 'ph-rbeam'], codes: [PH.BEAM] },   /* v391 + the cupola coop's run beams */
      { parts: ['ph-hw-screw-cbeam'], codes: [PH.FBEAM_SCREW] },
      { parts: ['ph-rjoist'], codes: [PH.STUD] },   /* v391 the cupola coop's run top: its joists and end plate */
      { parts: ['ph-hw-screw-rjoist'], codes: [PH.BEAM_SCREW, PH.JOIST_SCREW] },
      { parts: ['ph-bracket'], codes: [GH.BRACKET] },   /* v386 the lean-to's brackets to the house */
      { parts: ['ph-hw-screw-bracket', 'ph-hw-screw-anchor'], codes: [GH.BRK_SCREW, GH.ANCHOR] },
      { parts: ['ph-floor'], codes: [PH.FLOOR, PH.SHEATH_SCREW] },
      { parts: ['ph-crail'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-crail'], codes: [PH.TIE_SCREW] },
      { parts: ['ph-mrail'], codes: [PH.STUD] },   /* v391 the cupola coop's run: its mid rails */
      { parts: ['ph-hw-screw-mrail'], codes: [PH.TIE_SCREW] },
      { parts: ['ph-kbrace'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-kbrace'], codes: [PH.BRACE_SCREW] },
      { parts: ['ph-plate'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-plate'], codes: [PH.PLATE_SCREW] },
      { parts: ['ph-stud'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-stud', 'ph-hw-screw-fstud'], codes: [PH.STUD_SCREW] },
      { parts: ['ph-header'], codes: [PH.HEADER] },
      { parts: ['ph-hw-screw-frame'], codes: [PH.FRAME_SCREW, PH.STUD_SCREW, PH.TIE_SCREW] },
      { parts: ['ph-tplate'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-tplate', 'ph-hw-screw-tpend', 'ph-hw-screw-beam'], codes: [PH.STUD_SCREW, PH.JOIST_SCREW, PH.BEAM_SCREW] },
      { parts: ['ph-rafter'], codes: [PH.RAFTER] },
      { parts: ['ph-gusset'], codes: [PH.ROOF] },   /* v397 the barn coop's truss gussets */
      { parts: ['ph-hw-screw-gusset'], codes: [BR.GUS_SCREW] },
      { parts: ['ph-hw-screw-toe'], codes: [AF.TOE] },   /* v397 -- its trusses' feet on the beams */
      { parts: ['ph-ridge'], codes: [PH.RIDGE] },
      { parts: ['ph-hw-screw-seat'], codes: [PH.SEAT_SCREW] },
      { parts: ['ph-hw-screw-rtoe'], codes: [PH.RIDGE_TOE] },
      { parts: ['ph-fly'], codes: [PH.RAFTER] },
      { parts: ['ph-hw-screw-fly'], codes: [PH.RIDGE_TOE] },
      { parts: ['ph-hw-screw-fseat'], codes: [PH.SEAT_SCREW] },   /* v386 the lean-to's fly rafters seated on the beams */
      { parts: ['ph-tie'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-tie'], codes: [PH.TIE_SCREW, PH.TIE_DOWN] },
      { parts: ['ph-gstud'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-gstud'], codes: [PH.FRAME_SCREW] },
      { parts: ['ph-sheath'], codes: [PH.ROOF, PH.SHEATH_SCREW] },
      { parts: ['ph-fascia'], codes: [PH.BOARD] },
      { parts: ['ph-hw-screw-fascia'], codes: [PH.FASCIA_SCREW] },
      { parts: ['ph-drip'], codes: [PH.DRIP, PH.ROOF_NAIL] },
      { parts: ['ph-cover'], codes: [PH.UNDERLAY, PH.UL_STAPLE, PH.SHINGLE, PH.ROOF_NAIL] },
      { parts: ['ph-flash'], codes: [GH.FLASH] },   /* v386 the lean-to's endwall flashing */
      { parts: ['ph-hw-nail-flash'], codes: [PH.ROOF_NAIL] },
      { parts: ['ph-csaddle'], codes: [PH.STUD] },   /* v391 the cupola coop's cupola */
      { parts: ['ph-hw-screw-csaddle'], codes: [PH.SEAT_SCREW] },
      { parts: ['ph-cpanel'], codes: [PH.SIDING, PH.SIDING_SCREW] },
      { parts: ['ph-cmesh'], codes: [CO.STAPLE] },
      { parts: ['ph-cpost'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-cpost'], codes: [PH.FRAME_SCREW] },
      { parts: ['ph-louver'], codes: [PH.BOARD] },
      { parts: ['ph-hw-screw-louver'], codes: [PH.SHEATH_SCREW] },
      { parts: ['ph-ctop'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-ctop'], codes: [PH.FRAME_SCREW, PH.JOIST_SCREW] },
      { parts: ['ph-croof'], codes: [PH.ROOF, PH.UNDERLAY, PH.SHINGLE, PH.ROOF_NAIL, PH.DRIP] },
      { parts: ['ph-vane'], codes: [] },
      { parts: ['ph-siding'], codes: [PH.SIDING, PH.SIDING_SCREW] },
      { parts: ['ph-trim'], codes: [PH.TRIM] },
      { parts: ['ph-closer'], codes: [PH.BOARD] },   /* v386 the lean-to's closer boards */
      { parts: ['ph-casing'], codes: [PH.BOARD] },
      { parts: ['ph-hw-nail-trim'], codes: [PH.TRIM_NAIL] },
      { parts: ['ph-shutter'], codes: [PH.TG] },   /* v391 the cupola coop's shutters */
      { parts: ['ph-hw-screw-shutter'], codes: [PH.SHEATH_SCREW] },
      { parts: ['ph-door'], codes: [PH.TG] },
      { parts: ['ph-ledge'], codes: [PH.BOARD] },
      { parts: ['ph-dframe'], codes: [PH.STUD] },
      { parts: ['ph-hw-nail-door'], codes: [PH.TRIM_NAIL, PH.JOIST_SCREW, PH.TIE_SCREW] },
      { parts: ['ph-hinge'], codes: [PH.HINGE] },
      { parts: ['ph-hw-screw-hinge'], codes: [PH.HINGE_SCREW] },
      { parts: ['ph-knob'], codes: [PH.KNOB] },
      { parts: ['ph-catch'], codes: [PH.CATCH] },
      { parts: ['ph-nledger'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-nledger'], codes: [PH.STUD_SCREW] },
      { parts: ['ph-nbrace'], codes: [PH.STUD] },
      { parts: ['ph-nest'], codes: [PH.FLOOR] },   /* v383 the box before the braces' screws: they go up into its bottom */
      { parts: ['ph-hw-screw-nbrace'], codes: [PH.STUD_SCREW, PH.SHEATH_SCREW] },
      { parts: ['ph-hw-screw-nest'], codes: [PH.SHEATH_SCREW] },
      { parts: ['ph-nlid', 'ph-nledge'], codes: [PH.FLOOR, PH.BOARD] },
      { parts: ['ph-hw-nail-nest'], codes: [PH.TRIM_NAIL] },
      { parts: ['ph-nhinge'], codes: [PH.HINGE] },
      { parts: ['ph-hw-screw-nhinge'], codes: [PH.HINGE_SCREW] },
      { parts: ['ph-rcleat'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-rcleat'], codes: [PH.FRAME_SCREW] },
      { parts: ['ph-roost'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-roost'], codes: [PH.FRAME_SCREW] },
      { parts: ['ph-rledger'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-rledger'], codes: [PH.STUD_SCREW] },
      { parts: ['ph-ramp'], codes: [CO.PLANK] },
      { parts: ['ph-rledge'], codes: [PH.BOARD] },
      { parts: ['ph-rcl'], codes: [CO.CLEAT] },
      { parts: ['ph-hw-nail-ramp'], codes: [PH.TRIM_NAIL] },
      { parts: ['ph-hw-screw-ramp'], codes: [PH.DECK_SCREW] },
      { parts: ['ph-hphoop'], codes: [], lk: ['bench_gh_hoops'] },   /* v401 the hoop coop's run (the hoop house's steps): the tube, no catalogue row */
      { parts: ['ph-hphip'], codes: [GH.RIDGE] },
      { parts: ['ph-hpstrap'], codes: [GH.HSTRAP] },
      { parts: ['ph-hw-screw-hpstrap'], codes: [GH.HSTRAP_SCREW] },
      { parts: ['ph-hppurlin', 'ph-hpxconn'], codes: [], lk: ['roof_ridge'] },
      { parts: ['ph-hpplate'], codes: [GH.STUD] },
      { parts: ['ph-hpstud', 'ph-hpking', 'ph-hpjack'], codes: [GH.STUD] },
      { parts: ['ph-hw-screw-hpstud'], codes: [GH.STUD_SCREW] },
      { parts: ['ph-hpheader'], codes: [GH.STUD] },
      { parts: ['ph-hw-screw-hpframe'], codes: [GH.FRAME_SCREW, GH.STUD_SCREW] },
      { parts: ['ph-hpcripple'], codes: [GH.STUD] },
      { parts: ['ph-hw-screw-hpcripple'], codes: [GH.STUD_SCREW] },
      { parts: ['ph-hw-screw-hpplate'], codes: [GH.STUD_SCREW] },
      { parts: ['ph-hpgirt'], codes: [GH.STUD] },
      { parts: ['ph-hw-screw-hpgirt'], codes: [GH.TOE] },
      { parts: ['ph-hpsstrap'], codes: [GH.HSTRAP] },
      { parts: ['ph-hw-screw-hpsstrap'], codes: [GH.HSTRAP_SCREW] },
      { parts: ['ph-hpcasing'], codes: [GH.BOARD] },
      { parts: ['ph-hw-nail-hptrim'], codes: [GH.TRIM_NAIL] },
      { parts: ['ph-hpdframe'], codes: [GH.FRAME] },
      { parts: ['ph-hpdbrace'], codes: [GH.FRAME] },
      { parts: ['ph-hw-screw-hpdoor'], codes: [GH.STUD_SCREW] },
      { parts: ['ph-mesh'], codes: [CO.STAPLE] },
      { parts: ['ph-hptarp'], codes: [], lk: ['bench_co_tarp'] },   /* v401 the tarp: no catalogue row */
      { parts: ['ph-hphinge'], codes: [GH.HINGE] },
      { parts: ['ph-hw-screw-hphinge'], codes: [GH.HINGE_SCREW] },
      { parts: ['ph-hpknob'], codes: [GH.KNOB] },
      { parts: ['ph-hpcatch'], codes: [GH.CATCH] },
      { parts: ['ph-bolt'], codes: [] }
    ]);
  }
  /* the coop's own colours a brush scheme -- farmhouse, not the playhouses' pastels: the siding (and the nest boxes), the
     trims (corner boards, casings, fascia and rake boards), the doors (boards and ledges), the shingles; the frame keeps
     the scheme's wood. The hardware cloth: a galvanized 1/2 in. grid (a canvas texture repeated by the metre; the poly
     pieces' faces carry their plan coordinates as UVs), see-through. */
  var CO_PALETTES = {
    pine:  { wall: 0x9b3a2e, trim: 0xf2eee5, door: 0xf2eee5, roof: 0x3e4044 },   /* barn red, white trims and doors, charcoal shingles (the classic) */
    birch: { wall: 0xf2eee5, trim: 0x3d6b4b, door: 0x3d6b4b, roof: 0x4a4e53 },   /* white, green trims and doors */
    oak:   { wall: 0xa8754a, trim: 0xf2eee5, door: 0x7a5332, roof: 0x3e4044 },   /* cedar stain, white trims, a darker door */
    khaki: { wall: 0x8e9b77, trim: 0xf2eee5, door: 0xf2eee5, roof: 0x4f5357 },   /* sage green, white trims */
    white: { wall: 0xf4f1ea, trim: 0x9b3a2e, door: 0x9b3a2e, roof: 0x8a3027 },   /* white, red trims and doors, red roof */
    grey:  { wall: 0x7d858e, trim: 0xf2eee5, door: 0x2f3236, roof: 0x2f3236 }    /* grey, white trims, black door and roof */
  };
  function _coPalette() { return CO_PALETTES[_colorScheme()] || CO_PALETTES.pine; }
  /* v395 (Marek 2026-10-30 16:32: jednu variantu coop white, a jednu svetle drevo) the cupola coop in the default scheme: its siding,
     nest boxes, cupola and doors in natural light wood (the playhouses' beech, PH_BEECH), the trims white; the brush's other schemes paint
     it as before. The backyard coop is white by default (VARIANT_DEFAULTS: the 'white' scheme). */
  var CO_WOOD_TYPES = { 46: 1 };
  var DM_CEDAR = 0xb07a4f, DM_CHARCOAL = 0x33363a;   /* v403 the modern dog house's default look */
  var _coMeshTx = null;
  function _coMeshTex() {
    if (_coMeshTx) return _coMeshTx;
    var T = global.THREE;
    if (!T || typeof document === 'undefined') return null;
    try {
      var c = document.createElement('canvas'), n = 64, cells = 4, ctx, i;
      c.width = c.height = n;
      ctx = c.getContext('2d');
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, n, n);
      ctx.strokeStyle = '#fff';   /* an alpha map: the wires white, the holes black (the mip levels average to a light see-through film, never a dark one) */
      ctx.lineWidth = 2;
      for (i = 0; i <= cells; i++) {
        var q = i * n / cells;
        ctx.beginPath(); ctx.moveTo(q, 0); ctx.lineTo(q, n); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(0, q); ctx.lineTo(n, q); ctx.stroke();
      }
      var tx = new T.CanvasTexture(c), rep = 1 / (cells * 0.0127);
      tx.wrapS = tx.wrapT = T.RepeatWrapping;
      tx.repeat.set(rep, rep);
      tx.anisotropy = 4;
      _coMeshTx = tx;
    } catch (e) { _coMeshTx = null; }
    return _coMeshTx;
  }
  /* v392 the kennel's run: welded wire 2 x 4 in. (50 x 100 mm) -- an alpha map of one 4 in. square (two openings side by side,
     the wires 2 px of 64: about 3 mm, a little thicker than the 14 ga wire so it still reads from a step back), repeated by the metre */
  var _krMeshTx;
  function _krMeshTex() {
    if (_krMeshTx !== undefined) return _krMeshTx;
    try {
      var T = global.THREE, c = document.createElement('canvas'), n = 64, ctx, i;
      c.width = c.height = n;
      ctx = c.getContext('2d');
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, n, n);
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 2;
      for (i = 0; i <= 2; i++) { var q = i * n / 2; ctx.beginPath(); ctx.moveTo(q, 0); ctx.lineTo(q, n); ctx.stroke(); }   /* the uprights every 2 in. */
      for (i = 0; i <= 1; i++) { var q2 = i * n; ctx.beginPath(); ctx.moveTo(0, q2); ctx.lineTo(n, q2); ctx.stroke(); }   /* the line wires every 4 in. */
      var tx = new T.CanvasTexture(c), rep = 1 / 0.1016;
      tx.wrapS = tx.wrapT = T.RepeatWrapping;
      tx.repeat.set(rep, rep);
      tx.anisotropy = 4;
      _krMeshTx = tx;
    } catch (e) { _krMeshTx = null; }
    return _krMeshTx;
  }
  function _coMats(mats) {
    var T = global.THREE;
    if (!mats.coWall) {
      mats.coWall = new T.MeshStandardMaterial({ color: 0x9b3a2e, roughness: 0.85 });
      mats.coTrim = new T.MeshStandardMaterial({ color: 0xf2eee5, roughness: 0.8 });
      mats.coDoor = new T.MeshStandardMaterial({ color: 0xf2eee5, roughness: 0.8 });
      mats.phTyre = new T.MeshStandardMaterial({ color: 0x262626, roughness: 0.92 });   /* v379 the chicken tractor's tyres */
      mats.diXps = new T.MeshStandardMaterial({ color: 0x9cc7e4, roughness: 0.9 });                                          /* v388 the insulated dog house's XPS (light blue boards) */
      mats.diFlap = new T.MeshStandardMaterial({ color: 0x8e979e, roughness: 0.35, transparent: true, opacity: 0.55, depthWrite: false, side: T.DoubleSide });   /* -- its clear PVC flap */
      mats.dmEpdm = new T.MeshStandardMaterial({ color: 0x232426, roughness: 0.92 });                                         /* v403 the modern dog house's EPDM (black rubber) */
      var txK = _krMeshTex();   /* v392 the kennel's run: 2 x 4 in. welded wire, heavier than the coop's cloth */
      mats.krMesh = txK ? new T.MeshStandardMaterial({ color: 0xb4b9be, alphaMap: txK, transparent: true, alphaTest: 0.01, depthWrite: false, side: T.DoubleSide, metalness: 0.55, roughness: 0.4 })
                        : new T.MeshStandardMaterial({ color: 0xb4b9be, transparent: true, opacity: 0.22, depthWrite: false, side: T.DoubleSide, metalness: 0.55, roughness: 0.4 });
      var tx = _coMeshTex();
      mats.coMesh = tx ? new T.MeshStandardMaterial({ color: 0xc9cdd1, alphaMap: tx, transparent: true, alphaTest: 0.01, depthWrite: false, side: T.DoubleSide, metalness: 0.5, roughness: 0.45 })
                       : new T.MeshStandardMaterial({ color: 0xb9bec3, transparent: true, opacity: 0.28, depthWrite: false, side: T.DoubleSide, metalness: 0.5, roughness: 0.45 });
    }
    _coPaint(mats);
  }
  function _coPaint(mats) {
    if (!mats || !mats.coWall) return;
    var C = _coPalette(), map = { coWall: C.wall, coTrim: C.trim, coDoor: C.door }, k;
    if (_colorScheme() === 'pine' && CO_WOOD_TYPES[STATE.variant | 0]) { map.coWall = PH_BEECH; map.coDoor = PH_BEECH; }   /* v395 light wood */
    var dmLook = _phIsDm(STATE) && _colorScheme() === 'pine';   /* v403 the modern dog house in the default scheme: cedar boards, charcoal trims and roof */
    if (dmLook) { map.coWall = DM_CEDAR; map.coTrim = DM_CHARCOAL; map.coDoor = DM_CHARCOAL; }
    for (k in map) if (map.hasOwnProperty(k)) {
      mats[k].color.setHex(map[k]);
      var lumC = (((map[k] >> 16) & 255) * 0.299 + ((map[k] >> 8) & 255) * 0.587 + (map[k] & 255) * 0.114) / 255;
      if (mats[k].emissive) { mats[k].emissive.setHex(map[k]); mats[k].emissiveIntensity = (lumC > 0.92) ? 0.3 : 0; }   /* v395 a white coop reads white, not grey (the playhouses' lift, v377); the colours as they were */
      mats[k].needsUpdate = true;
    }
    if (mats.phSeam && _phIsDm(STATE)) { mats.phSeam.color.setHex(dmLook ? DM_CHARCOAL : C.roof); if (mats.phSeam.emissive) mats.phSeam.emissive.setHex(0x000000); mats.phSeam.needsUpdate = true; }   /* v403 its standing seam in the scheme's roof colour */
    if (mats.phShingle) {
      var tx = _gzShingleTex(C.roof);
      if (tx) { mats.phShingle.map = tx; mats.phShingle.color.setHex(0xffffff); } else mats.phShingle.color.setHex(C.roof);
      mats.phShingle.needsUpdate = true;
    }
  }
  function _coMat(kind, mats, mat) {
    if (kind === 'siding' || kind === 'nest' || kind === 'nlid' || kind === 'cpanel' || kind === 'louver') return mats.coWall;   /* v391 + the cupola */
    if (kind === 'rbeam') return mats.coTrim;   /* v391 the cupola coop's run beams white (the picture's rim) */
    if (kind === 'trim' || kind === 'casing' || kind === 'fascia' || kind === 'closer') return mats.coTrim;   /* v386 + the lean-to's closers */
    if (kind === 'flash') return mats.phDrip || mat;   /* v386 its flashing */
    if (kind === 'door' || kind === 'ledge' || kind === 'shutter') return mats.coDoor;   /* v391 + the cupola coop's shutters */
    if (kind === 'mesh' || kind === 'cmesh') return mats.coMesh;
    if (kind === 'nhinge') return mats.phIron || mat;
    if (kind === 'finsul' || kind === 'winsul' || kind === 'cinsul' || kind === 'pinsul') return mats.diXps || mat;   /* v388 the insulated dog house: the XPS, */
    if (kind === 'clining' || kind === 'wlining' || kind === 'plining' || kind === 'mlining') return mats.phOsb || mat;   /* v396 + the double's partition OSB */                         /* -- the OSB lining, */
    if (kind === 'flap') return mats.diFlap || mat;                                                                          /* -- the flap */
    if (kind === 'epdm') return mats.dmEpdm || mat;                                                                          /* v403 the modern dog house: the EPDM, */
    if (kind === 'erim' || kind === 'gbal' || kind === 'trail' || kind === 'mfascia') return mats.coTrim;                                          /* -- the eave rims and the guard in the trims' colour, */
    if (kind === 'rhanger') return mats.phDrip || mat;                                                                       /* -- the ramp's hangers galvanized */
    return mat;
  }
  /* the exploded view: each part away from the house the way it goes on */
  var CO_OUT = { siding: 1, trim: 1, casing: 1, door: 1, ledge: 1, closer: 1 };   /* v386 + the lean-to's closers */
  function _coFly(pc, g) {
    var k = pc.kind, cx = pc.box ? pc.box[0] : (pc.plane === 'zy' ? pc.c : 0), cz = pc.box ? pc.box[2] : (pc.plane === 'xy' ? pc.c : 0);
    if (g.cupola) {   /* v391 the cupola coop: the cupola and the run's top up, its rails down, the shutters back, the ramp and the run door to the left / front */
      if (/^(csaddle|cpanel|cmesh|cpost|louver|ctop|croof|rjoist|rbeam)$/.test(k)) return [0, 1, 0];
      if (k === 'mrail') return [0, -1, 0];
      if (k === 'mesh' && pc.id === 'mesh-t') return [0, 1, 0];   /* v395 the run's top laid on its joists from above (it came up through them) */
      if (k === 'shutter') return [0, 0, -1];
      if (k === 'ramp' || k === 'rledge' || k === 'rcl' || k === 'rledger') return [-1, 0, 0];
      if (k === 'dframe') return [0, 0, -1];
      if (k === 'kbrace') return [-1, 0, 0];
      cx -= (g.hx || 0);
    }
    if (k === 'mesh' && pc.quad) return [pc.side || 1, 0.6, 0];   /* v379 the tractor's slopes */
    if (k === 'skid' || k === 'xbase') return [0, -1, 0];
    if (k === 'mesh') return (pc.plane === 'xz') ? [0, -1, 0] : (pc.plane === 'zy') ? [(pc.c < 0) ? -1 : 1, 0, 0] : [0, 0, (pc.c < 0) ? -1 : 1];
    if (k === 'crail' || k === 'fbeam' || k === 'joist') return [0, -1, 0];
    if (k === 'nest' || k === 'nlid' || k === 'nledge' || k === 'nhinge' || k === 'nledger' || k === 'nbrace') return [1, 0, 0];
    if (k === 'roost' || k === 'rcleat') return [0, 1, 0];
    if (k === 'ramp' || k === 'rledge' || k === 'rcl' || k === 'rledger' || k === 'dframe') return [0, 0, 1];
    if (k === 'kbrace') return [(cx < 0) ? -1 : 1, 0, 0];
    if (k === 'flash') return [0, 1, 0];   /* v386 the lean-to's flashing up */
    if (CO_OUT[k]) {
      var hc = (g.hcz != null) ? g.hcz : (-g.L / 2 + g.zH) / 2, isX = pc.box ? (pc.box[3] < pc.box[5]) : (pc.plane === 'zy');
      return isX ? [(cx < 0) ? -1 : 1, 0, 0] : [0, 0, (cz < hc) ? -1 : 1];
    }
    return null;
  }
  /* its line in the debug log (what the flock got) and the NOT BILLED lines */
  function _coLog(g, bq) {
    if (g.tractor) return _ctLog(g, bq);   /* v379 the chicken tractor's own line */
    _dbg('[co] ' + (g.walkin ? 'walk-in' : g.lean ? 'lean-to' : g.cupola ? 'cupola' : g.barnCoop ? 'barn (gambrel ' + g.pitch + ' deg, gussets ' + (g.gussetA || 0).toFixed(2) + ' m2)' : g.hoopCoop ? 'hoop (' + (g.tunnel ? 'the run ' + g.tunnel.L.toFixed(3) + ' x ' + g.tunnel.W.toFixed(3) + ', ' + g.tunnel.hoops + ' hoops at ' + g.tunnel.hoopSp.toFixed(3) + ', tube ' + g.tunnel.tubeL.toFixed(2) + ' m, ' + g.tunnel.straps + ' strap pieces (' + g.tunnel.strapBuy + ' straps), ' + g.tunnel.piers + ' piers, ' + g.tunnel.hogs + ' hog rings, tarp ' + g.tunnel.tarpA.toFixed(2) + ' m2, the house ' + g.houseW.toFixed(3) + ' x ' + g.Lh.toFixed(3) + ' at z ' + g.hcz.toFixed(3) : 'run off: the house alone') + ')' : 'backyard') + ' coop: ' + g.hens + ' hens, run ' + (g.run ? 'ON' : 'OFF') + ', ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (house ' + (g.cupola ? g.houseW.toFixed(3) + ' x ' : '') + g.Lh.toFixed(3) + ' = ' + (g.Lh * (g.houseW || g.W) / g.hens).toFixed(2) + ' m2 a hen, run ' + (g.L * g.W / g.hens).toFixed(2) +
         ' m2 a hen; floor ' + g.yF.toFixed(3) + ', beams ' + g.yPT.toFixed(3) + ', ridge ' + g.ridgeTop.toFixed(3) + '), ' + g.sPosts + ' posts on ground screws, ' + g.joists.length + ' joists, ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) +
         ' at ' + g.pitch + ' deg, ' + g.ties + ' ties, ' + g.gStuds + ' gable studs, ' + g.nests + ' nests' + ((g.nests < g.nestsWanted) ? ' (' + g.nestsWanted + ' wanted, no room)' : '') + ', ' + g.roosts + ' roosts ' + g.roostLen.toFixed(2) +
         ' (' + (g.roosts * g.roostLen / g.hens).toFixed(2) + ' m a hen), ramp ' + g.ramp.len.toFixed(2) + ' (' + g.ramp.cleats + ' cleats), ' + (g.run ? g.rails + ' rails, ' + g.kbraces + ' knee braces, ' : '') +
         (g.lean ? 'at the house ' + g.brackets + ' brackets, ' + g.closers + ' closers, high beam ' + g.yPTL.toFixed(3) + ', ' : '') + (g.cupola ? 'the run ' + g.runW.toFixed(3) + ' long (' + g.midRails + ' mid rails, ' + g.rJoists + ' top joists), cupola ' + g.cupolaH.toFixed(3) + ' over the roof, ' : '') + 'hardware cloth ' + g.meshA.toFixed(2) + ' + apron ' + g.apronA.toFixed(2) + ' m2 (' + g.staples + ' staples), ' + g.bolts + ' barrel bolts, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners; ' +
         Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
    for (var i = 0; i < (bq.missing || []).length; i++) _dbg('[co] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
  }
  /* ------------------------------------------------------------------
     v379 TYPE 37 -- COOP 2: THE CHICKEN TRACTOR (Marek 2026-10-30 10:42
     "Dalsi krok" -- the next slot of the COOP plan). A movable A-frame
     coop, wheeled or dragged to fresh grass every day or two: the hen
     house up in the A at the back, the run in hardware cloth under it and
     in front of it, no floor in the run (the hens on the grass).
       - HENS on the slider 2-6 (4): the whole footprint 10 ft2 (0.93 m2)
         a hen (they live in it), the house's floor 2 ft2 (0.19 m2) a hen,
         a nest for every 4 hens, the roosts 8 in. (20 cm) a hen where a
         hen keeps 8 in. (20 cm) of headroom over the bar. W 1.80-2.10 m
         (US 6-7 ft) on the side grips, L 2.40-3.60 m (US 8-12 ft) from
         what the flock needs on the front / back grips.
       - BASE: two 2x8 skids on edge the whole length, their ends
         chamfered, running on 30 cm (US 12 in.) past the front as the
         handles (nothing across them: the run door swings out over them); 2x4 cross members
         on edge between them at the back, under the partition and at the
         front (the run door's sill), two 6x160 through the skid each end.
       - FRAME: A-frames of 2x4 legs at 60 deg, a birdsmouth on the skid
         and an 8x260 down into it, at <= 40 cm (US 16 in.) under the house
         and <= 60 cm (US 24 in.) over the run, a 2x6 ridge board the whole
         length (the legs toed into it). Each frame tied between its legs
         (two 8x200 through each leg into each end): a 2x4 floor tie on
         edge under the house, the roosts (2x4 flat) across the house's
         inner frames, a 2x4 collar tie on edge over the run.
       - HOUSE: its floor 0.55 m (US 22 in.) up, OSB on the floor ties; the
         back gable framed round the access door (kings, a 2x4 header, a
         cripple up to the ridge), panel siding, the vent over it in
         hardware cloth; the partition to the run framed round the pop
         door, sided on its run face, the ramp from the pop door down into
         the run; the nest boxes inside on the floor in the back right
         corner (OSB, open to the middle behind a lip, screwed through
         their back to the access door's king); both slopes OSB + underlay
         + shingles + caps down past the floor, rake boards, drip edge.
       - RUN: hardware cloth on both slopes from the skids to the ridge
         (under the house up to the roof's edge), the back under the house,
         the front gable round the run door (a 2x4 frame clothed, two
         strap hinges, a barrel bolt) between two 2x4 jambs.
       - WHEELS on the info bar's toggle (on): two 10 in. wheels outside
         the skids at the back on an M16 (US 5/8 in.) threaded rod through
         both skids, 1.5 cm (US 5/8 in.) off the ground while it stands on
         the skids -- lift the handles and wheel it; off, it is dragged.
     The hardware cloth, the barrel bolts and the wheels have no catalogue
     row yet: MISSING. X across, Y up, Z along (+Z the front with the
     handles); L = the A-frame's length, the house from -L/2 to zH. */
  var CT = {
    W: [1.80, 2.10], W_US: [1.8288, 2.1336], W0: 1.80, W0_US: 1.8288,
    L: [2.40, 3.60], L_US: [2.4384, 3.6576], HENS: [2, 6], HENS0: 4,
    FOOT_M2: 0.93, FOOT_M2_US: 0.92903, HOUSE_M2: 0.19, HOUSE_M2_US: 0.18581,
    LH: [0.90, 1.50], LH_US: [0.9144, 1.524], RUN_MIN: 1.20, RUN_MIN_US: 1.2192, STEP: 0.10, STEP_US: 0.3048,
    PITCH: 60, FLOOR_H: 0.55, FLOOR_H_US: 0.5588, HOUSE_SP: 0.40, HOUSE_SP_US: 0.4064,
    ROOST_Y: 0.40, ROOST_Y_US: 0.4064, ROOST_HEN: 0.20, ROOST_HEN_US: 0.2032, ROOST_HEAD: 0.20, ROOST_HEAD_US: 0.2032,
    COLLAR: 0.30, COLLAR_US: 0.3048, VENT: 0.55, VENT_US: 0.5588,
    DOOR_W: 0.40, DOOR_W_US: 0.4064, DOOR_H: 0.60, DOOR_H_US: 0.6096, RDOOR: 0.50, RDOOR_US: 0.508, LIP: 0.10, LIP_US: 0.1016,
    HANDLE: 0.30, HANDLE_US: 0.3048, NOSE: 0.08, NOSE_US: 0.0762,
    SKID: 'KVH60200', SK_T: 0.060, SK_T_US: 0.0381, SK_H: 0.200, SK_H_US: 0.1842,
    WHEEL_D: 0.25, WHEEL_D_US: 0.254, WHEEL_W: 0.08, WHEEL_W_US: 0.0762, WHEEL_UP: 0.015, WHEEL_UP_US: 0.0159, AXLE_Z: 0.22, AXLE_Z_US: 0.2286,
    WHEEL_NAME: 'WHEEL 10 IN. PNEUMATIC, 5/8 IN. AXLE BORE'
  };
  function _ctU(s, k) { return ((s || STATE).isMetric === false && CT[k + '_US'] != null) ? CT[k + '_US'] : CT[k]; }
  function _phIsCt(s) { return ((s || STATE).variant | 0) === 37; }
  function _ctHens(s) { s = s || STATE; var v = Math.round(+s.coHens); return Math.max(CT.HENS[0], Math.min(CT.HENS[1], (isFinite(v) && v > 0) ? v : CT.HENS0)); }
  function _ctWheels(s) { return (s || STATE).ctWheels !== false; }
  function _ctUp(s, v) { var q = _ctU(s, 'STEP'); return Math.round(Math.ceil(v / q - 1e-6) * q * 10000) / 10000; }
  /* the A for a width: the legs' underside yR / top yT over x, and back to x at a height (xI the underside, xO the top) */
  function _ctA(s, W) {
    var P = _phProf(s), th = CT.PITCH * Math.PI / 180, tn = Math.tan(th), cs = Math.cos(th), dV = P.sd / cs;
    var yPT = _ctU(s, 'SK_H'), seat = Math.min(_ctU(s, 'SK_T'), dV / (3 * tn)), xh = W / 2 - seat;
    return { tn: tn, cs: cs, sn: Math.sin(th), dV: dV, yPT: yPT, seat: seat, xh: xh,
      yR: function (x) { return yPT + (xh - Math.abs(x)) * tn; }, yT: function (x) { return yPT + (xh - Math.abs(x)) * tn + dV; },
      xI: function (y) { return xh - (y - yPT) / tn; }, xO: function (y) { return xh + (yPT + dV - y) / tn; } };
  }
  /* the hens a roost holds: the bar across an inner frame of the house, a hen where 8 in. (20 cm) stays over it */
  function _ctPerBar(s, W) { var A = _ctA(s, W), yRo = _ctU(s, 'FLOOR_H') + _ctU(s, 'ROOST_Y'); return Math.max(1, Math.floor(2 * A.xI(yRo + _ctU(s, 'ROOST_HEAD')) / _ctU(s, 'ROOST_HEN') + 1e-6)); }
  /* the house's length: its floor 2 ft2 a hen, and enough inner frames for the roosts the flock needs */
  function _ctLh(s, W) {
    var P = _phProf(s), A = _ctA(s, W), N = _ctHens(s), yF = _ctU(s, 'FLOOR_H');
    var a = N * _ctU(s, 'HOUSE_M2') / (2 * (A.xI(yF) - 0.003));
    var nB = Math.ceil(N / _ctPerBar(s, W) - 1e-9), r = nB * _ctU(s, 'HOUSE_SP') + P.st + 0.01;
    var LH = _ctU(s, 'LH');
    return Math.max(LH[0], Math.min(LH[1], _ctUp(s, Math.max(a, r))));
  }
  function _ctWRange(s) { var R = _ctU(s, 'W'); return { min: R[0], max: R[1] }; }
  function _ctRange(s) {
    var W = _phW(s), R = _ctU(s, 'L'), need = Math.max(R[0], _ctUp(s, _ctLh(s, W) + _ctU(s, 'RUN_MIN')), _ctUp(s, _ctHens(s) * _ctU(s, 'FOOT_M2') / W));
    return { min: Math.min(R[1], need), max: R[1] };
  }
  function _ctLayout(s) {
    s = s || STATE;
    var P = _phProf(s), us = (s.isMetric === false), N = _ctHens(s), W = _phW(s), L = _phL(s), Lh = _ctLh(s, W), wheels = _ctWheels(s), A = _ctA(s, W);
    var i, k, sx, e;
    var st = P.st, sd = P.sd, nt = P.fl, sg = P.sg, tt = P.tt, cw = P.cw;
    var len260 = us ? 0.254 : 0.26, len200 = us ? 0.2032 : 0.20, len160 = us ? 0.127 : 0.16, len120 = us ? 0.127 : 0.12, len100 = us ? 0.1016 : 0.10,
        len80 = us ? 0.0762 : 0.08, len60 = us ? 0.0635 : 0.06, len50 = us ? 0.0508 : 0.05, len40 = us ? 0.0381 : 0.04, len32 = us ? 0.0318 : 0.032;
    var pieces = [], fas = [], hw = [], missing = [], coat = 0, hinges = 0, knobs = 0, catches = 0, bolts = 0, meshA = 0, stapleL = 0, nestA = 0;
    function ceil2(v) { return Math.ceil(v * 100 - 1e-6) / 100; }
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function poly(kind, code, len, id, pts, plane, c, t, holes) { pieces.push({ kind: kind, code: code, len: len, id: id, poly: pts, plane: plane, c: c, t: t, holes: holes || null }); }
    function scr(kind, code, x, y, z, d, ln, r) { var n = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]) || 1; fas.push({ kind: kind, code: code, x: x, y: y, z: z, dir: [d[0] / n, d[1] / n, d[2] / n], len: ln, r: r || 0.003 }); }
    function fixPts(a, b, sp) { var n = Math.max(1, Math.ceil((b - a) / sp - 1e-9)), out = [], q; for (q = 0; q <= n; q++) out.push(a + (b - a) * q / n); return out; }
    function scrClear(kind, code, cands, d, ln, r) {
      var rr = r || 0.003, q, q2;
      for (q = 0; q < cands.length; q++) {
        var c0 = cands[q], c1 = [c0[0] + d[0] * ln, c0[1] + d[1] * ln, c0[2] + d[2] * ln], ok = true;
        for (q2 = 0; q2 < fas.length && ok; q2++) {
          var fq = fas[q2], f0 = [fq.x, fq.y, fq.z], f1 = [fq.x + fq.dir[0] * fq.len, fq.y + fq.dir[1] * fq.len, fq.z + fq.dir[2] * fq.len];
          if (_pfSegDist(c0, c1, f0, f1) < rr + (fq.r || 0.003) + 0.003) ok = false;
        }
        if (ok) { scr(kind, code, c0[0], c0[1], c0[2], d, ln, r); return true; }
      }
      scr(kind, code, cands[0][0], cands[0][1], cands[0][2], d, ln, r);
      return false;
    }
    function perim(pts) { var a = 0, q; for (q = 0; q < pts.length; q++) { var A0 = pts[q], B0 = pts[(q + 1) % pts.length]; a += Math.sqrt((B0[0] - A0[0]) * (B0[0] - A0[0]) + (B0[1] - A0[1]) * (B0[1] - A0[1])); } return a; }
    function d3(a, b) { return Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1]) + (b[2] - a[2]) * (b[2] - a[2])); }
    /* a sheet of hardware cloth in a plane (its wire, billed by area: MISSING), its edges stapled */
    function mesh(id, pts, plane, c, holes) {
      pieces.push({ kind: 'mesh', code: null, len: 0, id: id, poly: pts, plane: plane, c: c, t: CO.MESH_T, holes: holes || null });
      var a = _phArea(pts), q;
      for (q = 0; q < (holes || []).length; q++) { a -= _phArea(holes[q]); stapleL += perim(holes[q]); }
      meshA += a; stapleL += perim(pts);
    }
    /* -- on a slope: its four corners (Q0-Q1 along Z, Q1-Q2 up the slope), UVs in metres (the wire's grid) */
    function meshQuad(id, Q, side) {
      var w = d3(Q[0], Q[1]), h = d3(Q[1], Q[2]);
      pieces.push({ kind: 'mesh', code: null, len: 0, id: id, quad: Q, uv: [[Q[0][2], 0], [Q[1][2], 0], [Q[1][2], h], [Q[0][2], h]], side: side });
      meshA += w * h; stapleL += 2 * (w + h);
    }
    var clr = _phU(s, 'DOOR_CLR'), mo = CO.MESH_OFF, tn = A.tn, cs = A.cs, sn = A.sn, dV = A.dV, yPT = A.yPT, xh = A.xh, seat = A.seat, yR = A.yR, yT = A.yT, xI = A.xI, xO = A.xO;
    var skT = _ctU(s, 'SK_T'), skH = _ctU(s, 'SK_H'), hdl = _ctU(s, 'HANDLE'), nose = _ctU(s, 'NOSE');
    var xr = P.rgt / 2, rgTop = yT(xr), rgBot = rgTop - P.rgd;
    var yF = _ctU(s, 'FLOOR_H'), yFt = yF - nt, yFb = yFt - sd, yRo = yF + _ctU(s, 'ROOST_Y'), yC1 = yF + _ctU(s, 'COLLAR'), yC0 = yC1 - sd;
    var zH = -L / 2 + Lh, zA = -L / 2 + st / 2, zPt = zH - st / 2, zC = L / 2 - st / 2;

    /* THE FRAMES: the back gable, the house's inner frames at <= 40 cm (US 16 in.), the partition; the run's at <= 60 cm
       (US 24 in.) to the front gable */
    var frames = [], nr1 = Math.max(2, Math.ceil((zPt - zA) / _ctU(s, 'HOUSE_SP') - 1e-9)), nr2 = Math.max(1, Math.ceil((zC - zPt) / _phU(s, 'RAF_SP') - 1e-9));
    for (i = 0; i <= nr1; i++) frames.push({ z: zA + (zPt - zA) * i / nr1, kind: (i === 0) ? 'back' : (i === nr1) ? 'part' : 'house' });
    for (i = 1; i <= nr2; i++) frames.push({ z: zPt + (zC - zPt) * i / nr2, kind: (i === nr2) ? 'front' : 'run' });

    /* THE SKIDS: 2x8 on edge, the ends chamfered underneath, on past the front as the handles */
    var zS0 = -L / 2, zS1 = L / 2 + hdl;
    for (sx = -1; sx <= 1; sx += 2) {
      poly('skid', CT.SKID, ceil2(zS1 - zS0), 'skid-' + (sx < 0 ? 'l' : 'r'), [[zS0 + nose, 0], [zS1 - nose, 0], [zS1, nose], [zS1, skH], [zS0, skH], [zS0, nose]], 'zy', sx * (W / 2 - skT / 2), skT);
      coat += 2 * (skT + skH) * (zS1 - zS0);
    }
    /* the cross members, 2x4 on edge between the skids (back, partition, front), two 6x160 through the skid into each end */
    var xbL = W - 2 * skT;
    [[-L / 2 + nose + st / 2, 'b'], [zPt, 'm'], [zC, 'f']].forEach(function (q) {
      box('xbase', PH.STUD, ceil2(xbL), 'xbase-' + q[1], 0, sd / 2, q[0], xbL, sd, st);
      coat += 2 * (st + sd) * xbL;
      for (var s2 = -1; s2 <= 1; s2 += 2) for (var k2 = -1; k2 <= 1; k2 += 2) scr('screw-xbase', PH.JOIST_SCREW, s2 * W / 2, sd / 2 + k2 * sd / 4, q[0] + k2 * st / 5, [-s2, 0, 0], len160);
    });

    /* THE LEGS: a 2x4 pair a frame, the birdsmouth's seat on the skid (an 8x260 down into it), plumb against the ridge board
       and at the skid's outer face; the ridge board 2x6 on edge the whole length, each leg toed into it (two 6x80) */
    var legL = ceil2((W / 2 - xr) / cs);
    function legPts(sxx) {
      var pts = [[xr, yR(xr)], [xr, yT(xr)], [W / 2, yT(W / 2)], [W / 2, yPT], [xh, yPT]].map(function (Pt) { return [sxx * Pt[0], Pt[1]]; });
      if (sxx < 0) pts.reverse();
      return pts;
    }
    var tAn = 37 * Math.PI / 180, tCo = Math.cos(tAn), tSi = Math.sin(tAn), xtq = xr + 0.035;
    var yTa = Math.max(yR(xtq), rgBot), yTb = Math.min(yT(xtq), rgTop), yTm = (yTa + yTb) / 2, yTd = Math.min(0.025, (yTb - yTa) / 2 - 0.012);   /* the toes' height: where the leg overlaps the ridge board (at 60 deg it sits low on the board) */
    frames.forEach(function (f, fi) {
      for (var s4 = -1; s4 <= 1; s4 += 2) {
        poly('rafter', PH.RAFTER, legL, 'leg-' + (fi + 1) + (s4 < 0 ? '-l' : '-r'), legPts(s4), 'xy', f.z, st);
        var xs = W / 2 - seat / 2;
        scr('screw-seat', PH.FBEAM_SCREW, s4 * xs, yT(xs), f.z, [0, -1, 0], len260);
        for (var k4 = -1; k4 <= 1; k4 += 2) {
          /* from both side faces, angled in -- at a gable both from its outer face, angled in (the ridge board ends there) */
          var gab = (f.kind === 'back' || f.kind === 'front'), kf = (f.kind === 'back') ? -1 : (f.kind === 'front') ? 1 : k4;
          var yk = gab ? yTm + s4 * yTd * ((k4 < 0) ? 1 : 1 / 3) : yTm + k4 * s4 * yTd;   /* (a gable's four at four heights: the legs' meet in the middle) */
          scr('screw-rtoe', PH.RIDGE_TOE, s4 * xtq, yk, f.z + kf * st / 2, [-s4 * tCo, 0, -kf * tSi], len80);
        }
      }
    });
    coat += frames.length * 2 * 2 * (st + sd) * legL;
    box('ridge', PH.RIDGE, ceil2(L), 'ridge', 0, rgTop - P.rgd / 2, 0, P.rgt, P.rgd, L);
    coat += 2 * (P.rgt + P.rgd) * L;

    /* THE TIES between each frame's legs, cut to their slope: two 8x200 through each leg into each end */
    var nTies = 0, nBars = 0, barLen = 0;
    function tie(kind, id, z, y0, y1, th) {
      var a0 = xI(y0) - 0.001, a1 = xI(y1) - 0.001;
      poly(kind, PH.STUD, ceil2(2 * a0), id, [[-a0, y0], [a0, y0], [a1, y1], [-a1, y1]], 'xy', z, th);
      coat += 2 * (th + (y1 - y0)) * 2 * a0;
      for (var s5 = -1; s5 <= 1; s5 += 2) for (var k5 = -1; k5 <= 1; k5 += 2) {
        var yq = (y0 + y1) / 2 + k5 * (y1 - y0) / 4;
        scr((kind === 'roost') ? 'screw-roost' : 'screw-tie', PH.BEAM_SCREW, s5 * xO(yq), yq, z + k5 * st / 5, [-s5, 0, 0], len200);
      }
      return 2 * a1;
    }
    frames.forEach(function (f, fi) {
      if (f.kind === 'back' || f.kind === 'house' || f.kind === 'part') { tie('tie', 'ftie-' + (fi + 1), f.z, yFb, yFt, st); nTies++; }
      if (f.kind === 'house') { barLen += tie('roost', 'roost-' + (fi + 1), f.z, yRo - st, yRo, sd); nBars++; }
      if (f.kind === 'run' || f.kind === 'front') { tie('tie', 'ctie-' + (fi + 1), f.z, yC0, yC1, st); nTies++; }
    });
    var perBar = _ctPerBar(s, W);

    /* THE HOUSE'S FLOOR: OSB on the floor ties from the back gable to the partition's face, inside the legs */
    var xF = xI(yF) - 0.003;
    pieces.push({ kind: 'floor', code: PH.FLOOR, len: 0, id: 'floor', poly: [[-xF, -L / 2], [xF, -L / 2], [xF, zH], [-xF, zH]], plane: 'xz', c: yFt + nt / 2, t: nt });
    var floorA = 2 * xF * Lh;

    /* THE GABLES' FRAMING (the back's and the partition's), flush with their outer face: the kings either side of the door
       from the floor to the legs, a 2x4 header on edge between them at the outer face, a cripple up to the ridge board, the
       gable studs at 30 cm (US 12 in.) beyond the kings while they stand 6 cm; toed down into the floor tie (two 6x100), up
       into the leg over them (one 6x100), the header through the kings (two 6x120 a side) */
    function roFor(wNom) { var nB0 = Math.max(2, Math.round((wNom - (P.gw - P.gc)) / P.gc)); return nB0 * P.gc + (P.gw - P.gc) + 2 * clr; }
    var ROa = roFor(_ctU(s, 'DOOR_W')), ROp = roFor(_coU(s, 'POP_W'));
    var yHa = Math.min(yF + _ctU(s, 'DOOR_H'), yR(ROa / 2 + st) - sd - 0.01), yHp = yF + _coU(s, 'POP_H') + 2 * clr;
    var gsp = _phU(s, 'GSTUD_SP'), gStuds = 0, backMembers = [];
    /* (the nest boxes' place first: the back gable gets a stud of its own behind them when no king / stud stands there) */
    var NB = _coU(s, 'NEST'), nWant = Math.max(1, Math.ceil(N / CO.HENS_NEST - 1e-9)), nN = nWant, yNt = yF + NB + nt, lipH = _ctU(s, 'LIP');
    var xb1 = xI(yNt) - 0.005, xb0 = xb1 - NB - nt;
    function gable(id, zFace, o, zTie, half, yHd) {
      var zc = zFace - o * sd / 2, zHd = zFace - o * st / 2;
      function stud(sid, u0, u1, yTop, flat) {
        var pts = flat ? [[u0, yF], [u1, yF], [u1, yTop], [u0, yTop]] : [[u0, yF], [u1, yF], [u1, yR(u1)], [u0, yR(u0)]];
        if (!flat && u0 < 0) pts = [[u0, yF], [u1, yF], [u1, yR(u1)], [u0, yR(u0)]];
        var hTop = flat ? yTop : Math.max(yR(u0), yR(u1));
        poly('gstud', PH.STUD, ceil2(hTop - yF), sid, pts, 'xy', zc, sd);
        coat += 2 * (st + sd) * (hTop - yF);
        gStuds++;
        var uc = (u0 + u1) / 2;
        for (var e2 = -1; e2 <= 1; e2 += 2) {
          /* toed down into the floor tie from its side face -- or, where the tie's own screws come through the leg there, from
             its inner face towards the outer one (the tie lies against the outer face) */
          var tc = [[0.04, st / 4], [0.04, -st / 4], [0.05, st / 8], [0.03, st / 8]].map(function (c8) { return [[uc + e2 * st / 2, yF + c8[0], zTie + e2 * c8[1]], [-e2 * 0.5, -0.87, 0]]; })
                   .concat([[0.04, 0.25], [0.05, 0.4], [0.03, 0.1]].map(function (c8) { return [[uc + e2 * c8[1] * st, yF + c8[0], zFace - o * (sd - 0.004)], [0, -0.87, o * 0.5]]; }));
          var done = false;
          for (var t8 = 0; t8 < tc.length && !done; t8++) {
            var c0 = tc[t8][0], dd = tc[t8][1], c1 = [c0[0] + dd[0] * len100, c0[1] + dd[1] * len100, c0[2] + dd[2] * len100], ok = true;
            for (var q8 = 0; q8 < fas.length && ok; q8++) { var fq = fas[q8]; if (_pfSegDist(c0, c1, [fq.x, fq.y, fq.z], [fq.x + fq.dir[0] * fq.len, fq.y + fq.dir[1] * fq.len, fq.z + fq.dir[2] * fq.len]) < 0.009) ok = false; }
            if (ok) { scr('screw-gstud', PH.FRAME_SCREW, c0[0], c0[1], c0[2], dd, len100); done = true; }
          }
          if (!done) scr('screw-gstud', PH.FRAME_SCREW, tc[0][0][0], tc[0][0][1], tc[0][0][2], tc[0][1], len100);
        }
        if (!flat) scr('screw-gstud', PH.FRAME_SCREW, uc, yR(Math.max(Math.abs(u0), Math.abs(u1))) - 0.035, zFace - o * 0.005, [0, 0.95, -o * 0.31], len100);
        if (o < 0) backMembers.push([u0, u1, flat ? yTop : yR(Math.max(Math.abs(u0), Math.abs(u1)))]);
      }
      var placed = [];
      for (var s6 = -1; s6 <= 1; s6 += 2) {
        var ka = half, kb = half + st;
        placed.push(s6 * (half + st / 2));
        stud(id + '-king-' + (s6 < 0 ? 'l' : 'r'), (s6 < 0) ? -kb : ka, (s6 < 0) ? -ka : kb, 0, false);
        for (var f6 = 0; f6 < 2; f6++) scr('screw-frame', PH.STUD_SCREW, s6 * kb, yHd + sd * (0.3 + 0.4 * f6), zHd, [-s6, 0, 0], len120);
        for (var g6 = 1; ; g6++) {
          var gx = g6 * gsp;
          if (gx - st / 2 < kb + 0.02) continue;
          if (yR(gx + st / 2) - yF < 0.06) break;
          stud(id + '-stud-' + (s6 < 0 ? 'l' : 'r') + g6, (s6 < 0) ? -(gx + st / 2) : gx - st / 2, (s6 < 0) ? -(gx - st / 2) : gx + st / 2, 0, false);
          placed.push(s6 * gx);
        }
      }
      if (o < 0) {   /* the back gable */
        var nx0 = xb0 + 0.03, nx1 = xb1 - nt - 0.03, xn = (xb0 + xb1 - nt) / 2;
        if (!placed.some(function (u) { return u > nx0 && u < nx1; }) && !placed.some(function (u) { return Math.abs(u - xn) < st + 0.02; }) && yR(xn + st / 2) - yF > 0.06)
          stud(id + '-stud-nest', xn - st / 2, xn + st / 2, 0, false);   /* the nest boxes' stud */
      }
      box('header', PH.STUD, ceil2(2 * half), id + '-header', 0, yHd + sd / 2, zHd, 2 * half, sd, st);
      coat += 2 * (st + sd) * 2 * half;
      var yc0 = yHd + sd;
      if (rgBot - yc0 > 0.03) {
        box('gstud', PH.STUD, ceil2(rgBot - yc0), id + '-cripple', 0, (yc0 + rgBot) / 2, zc, st, rgBot - yc0, sd);
        coat += 2 * (st + sd) * (rgBot - yc0);
        gStuds++;
        for (var e7 = -1; e7 <= 1; e7 += 2) scr('screw-frame', PH.FRAME_SCREW, e7 * st / 2, yc0 + 0.04, zHd + e7 * st / 5, [-e7 * 0.5, -0.87, 0], len100);
        scr('screw-frame', PH.RIDGE_TOE, st / 2, rgBot - 0.04, zFace - o * (sd - 0.012), [-0.5, 0.87, 0], len80);   /* on its far side, clear of the legs' toes */
      }
    }
    gable('back', -L / 2, -1, zA, ROa / 2, yHa);
    gable('part', zH, 1, zPt, ROp / 2, yHp);

    /* THE SIDING: the back gable from the floor tie's underside up to the vent (the access door cut out), the partition on
       its run face up to the roof round the ridge board (the pop door cut out); the vent above the back's in hardware cloth */
    var yV = Math.max(yF + _ctU(s, 'VENT'), yHa + sd + 0.02), sidingA = 0, xr2 = P.rgt / 2 + 0.002;
    var gb = [[-xO(yFb) + 0.002, yFb], [xO(yFb) - 0.002, yFb], [xO(yV) - 0.002, yV], [-xO(yV) + 0.002, yV]], hb = [[-ROa / 2, yF], [ROa / 2, yF], [ROa / 2, yHa], [-ROa / 2, yHa]];
    poly('siding', PH.SIDING, 0, 'siding-b', gb, 'xy', -(L / 2 + sg / 2), sg, [hb]);
    sidingA += _phArea(gb) - _phArea(hb);
    var gp = [[-xO(yFb) + 0.002, yFb], [xO(yFb) - 0.002, yFb], [xr2, yT(xr2) - 0.002], [xr2, rgBot], [-xr2, rgBot], [-xr2, yT(xr2) - 0.002]];
    var hp = [[-ROp / 2, yF], [ROp / 2, yF], [ROp / 2, yHp], [-ROp / 2, yHp]];
    poly('siding', PH.SIDING, 0, 'siding-f', gp, 'xy', zH + sg / 2, sg, [hp]);
    sidingA += _phArea(gp) - _phArea(hp);
    coat += sidingA;
    mesh('mesh-vent', [[-xO(yV), yV], [xO(yV), yV], [xr2, yT(xr2)], [-xr2, yT(xr2)]], 'xy', -(L / 2 + mo + CO.MESH_T / 2), null);

    /* THE HOUSE'S ROOF: OSB on the legs from the ridge line down past the floor tie, the shingles over the underlay, the cap
       shingles along the ridge, a 1x4 rake board over each gable's edge (5.5x50 into the legs), the drip edge round it */
    var yE = yFb - 0.03, xE = xO(yE), rs = P.rs, rsV = rs / cs, ze0 = -L / 2 - sg - tt, ze1 = zH + sg + tt, eLen = ze1 - ze0, slope = (xE - 0) / cs;
    for (sx = -1; sx <= 1; sx += 2) {
      var spp = [[0, yT(0)], [xE, yT(xE)], [xE, yT(xE) + rsV], [0, yT(0) + rsV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
      if (sx < 0) spp.reverse();
      poly('sheath', PH.ROOF, 0, 'sheath-' + (sx < 0 ? 'l' : 'r'), spp, 'xy', (ze0 + ze1) / 2, eLen);
      var xs1 = xE + 0.01, ysh = rsV + 0.003;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cover-' + (sx < 0 ? 'l' : 'r'),
        quad: [[0, yT(0) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze0 - 0.01], [sx * xs1, yT(xs1) + ysh, ze1 + 0.01], [0, yT(0) + ysh, ze1 + 0.01]],
        uv: [[(ze0 - 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)], [(ze0 - 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), 0], [(ze1 + 0.01) / (8 * PH.TAB), xs1 / cs / (8 * PH.EXPO)]] });
      pieces.push({ kind: 'drip', code: PH.DRIP, len: 0, id: 'drip-e-' + (sx < 0 ? 'l' : 'r'), box: [sx * (xE + 0.0015), yT(xE) + rsV - 0.0275, (ze0 + ze1) / 2, 0.003, 0.055, eLen + 0.01] });
      for (i = 0; i < 2; i++) {
        var cwV = cw / cs, zc2 = (i === 0) ? ze0 + tt / 2 : ze1 - tt / 2;
        var rpb = [[0, yT(0)], [xE, yT(xE)], [xE, yT(xE) - cwV], [0, yT(0) - cwV]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) rpb.reverse();
        poly('fascia', PH.BOARD, ceil2(slope), 'rake-' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), rpb, 'xy', zc2, tt);
        coat += 2 * (tt + cw) * slope;
        fixPts(0.10, xE - 0.08, _phU(s, 'FIX_SP')).forEach(function (xq) { scrClear('screw-fascia', PH.FASCIA_SCREW, [0, 0.03, -0.03, 0.06, -0.06].map(function (dx) { return [sx * (xq + dx), yT(xq + dx) - cwV / 2, (i === 0) ? ze0 : ze1]; }), [0, 0, (i === 0) ? 1 : -1], len50); });   /* clear of the ties' screws in the gable's legs */
        var dpb = [[0, yT(0) + rsV], [xE, yT(xE) + rsV], [xE, yT(xE) + rsV - 0.055], [0, yT(0) + rsV - 0.055]].map(function (Pt) { return [sx * Pt[0], Pt[1]]; });
        if (sx < 0) dpb.reverse();
        poly('drip', PH.DRIP, 0, 'drip-r' + (i ? 'f' : 'b') + (sx < 0 ? '-l' : '-r'), dpb, 'xy', (i === 0) ? ze0 - 0.0015 : ze1 + 0.0015, 0.003);
      }
    }
    var capH = PH.CAP_W / 2;
    for (sx = -1; sx <= 1; sx += 2) {
      var cx1 = capH * cs, ycap = rsV + 0.008;
      pieces.push({ kind: 'cover', code: PH.SHINGLE, len: 0, id: 'cap-' + (sx < 0 ? 'l' : 'r'), cap: true,
        quad: [[0, yT(0) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze0], [sx * cx1, yT(cx1) + ycap, ze1], [0, yT(0) + ycap, ze1]],
        uv: [[ze0 / PH.CAP_EXPO / 8, 0.12], [ze0 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0], [ze1 / PH.CAP_EXPO / 8, 0.12]] });
    }
    var roofA = 2 * slope * eLen, capA = eLen * PH.CAP_W, capNails = Math.ceil(eLen / PH.CAP_EXPO) * PH.CAP_NAILS;
    var dripL = 2 * eLen + 4 * slope, dripNails = Math.ceil(dripL / PH.DRIP_FIX);

    /* THE CASINGS: 1x4 round the access door and the pop door (the cottage's) */
    function casing(id, cN, o, u0, u1, v0, v1) {
      var n0 = cN + o * tt / 2, list = [['jamb-a', u0 - cw / 2, v0, v1, cw], ['jamb-b', u1 + cw / 2, v0, v1, cw], ['head', (u0 + u1) / 2, v1, v1 + cw, u1 - u0 + 2 * cw]];
      list.forEach(function (c4) {
        var horiz = (c4[0] === 'head'), du = horiz ? c4[4] : cw, dy = c4[3] - c4[2], yc = (c4[2] + c4[3]) / 2;
        box('casing', PH.BOARD, ceil2(horiz ? du : dy), id + '-' + c4[0], c4[1], yc, n0, du, dy, tt);
        coat += 2 * (tt + cw) * (horiz ? du : dy);
        var pts2 = horiz ? fixPts(c4[1] - du / 2 + 0.05, c4[1] + du / 2 - 0.05, _phU(s, 'FIX_SP')) : fixPts(c4[2] + 0.05, c4[3] - 0.05, _phU(s, 'FIX_SP'));
        pts2.forEach(function (w2) {
          for (var e4 = -1; e4 <= 1; e4 += 2) {
            var uu = horiz ? w2 : c4[1] + e4 * cw / 4, yy = horiz ? yc + e4 * dy / 4 : w2;
            scr('nail-trim', PH.TRIM_NAIL, uu, yy, cN + o * tt, [0, 0, -o], len32, 0.0012);
          }
        });
      });
    }
    casing('casing-d', -(L / 2 + sg), -1, -ROa / 2, ROa / 2, yF, yHa);
    casing('casing-p', zH + sg, 1, -ROp / 2, ROp / 2, yF, yHp);

    /* THE LEDGED DOORS (the cottage's): T&G boards on 1x4 ledges with a brace, finish nails from the ledges, two strap
       hinges onto the casing; the access door a pull + a barrel bolt (MISSING), the pop door a ball catch. The access door
       is 'door' (a leaf that swings in the 3D / AR walk-through) */
    var nDb = 0, doorW = 0, doorH = 0;
    function ledgedDoor(pre, o, zO, ro, y0d, y1d, nLed, pull, latch) {
      var gw = P.gw, gc = P.gc, gb2 = P.gb, dW = ro - 2 * clr, nB = Math.max(2, Math.round((dW - (gw - gc)) / gc)), lw = nB * gc + (gw - gc);
      var dy0 = y0d + clr, dy1 = y1d - clr, dH = dy1 - dy0, zB1 = zO, zB0 = zO - o * gb2, zL0 = zB0 - o * tt, q;
      for (q = 0; q < nB; q++) {
        var bxc = -lw / 2 + gw / 2 + q * gc;
        box('door', PH.TG, ceil2(dH), pre + '-board-' + (q + 1), bxc - (gw - gc) / 2, (dy0 + dy1) / 2, (zB0 + zB1) / 2, gc, dH, gb2);
      }
      coat += 2 * (gb2 + gw) * dH * nB;
      var lo = (nLed > 2) ? 0.12 : 0.06, ledY = [], ledW = lw - 0.04;
      for (q = 0; q < nLed; q++) ledY.push(dy0 + lo + (dH - 2 * lo) * q / (nLed - 1));
      for (q = 0; q < nLed; q++) {
        box('ledge', PH.BOARD, ceil2(ledW), pre + '-ledge-' + (q + 1), 0, ledY[q], (zB0 + zL0) / 2, ledW, cw, tt);
        coat += 2 * (tt + cw) * ledW;
        for (var b2 = 0; b2 < nB; b2++) for (var e4 = -1; e4 <= 1; e4 += 2) scr('nail-door', PH.TRIM_NAIL, -lw / 2 + gw / 2 + b2 * gc, ledY[q] + e4 * cw / 4, zL0, [0, 0, o], len32, 0.0012);
      }
      function braceBetween(idB, xA, yA, xB2, yB2) {
        var dx = xB2 - xA, dy = yB2 - yA, dl = Math.sqrt(dx * dx + dy * dy), ux = dx / dl, uy = dy / dl, nx = -uy * cw / 2, ny = ux * cw / 2;
        var ext = cw * 1.5, ax0 = xA - ux * ext, ay0 = yA - uy * ext, bx0 = xB2 + ux * ext, by0 = yB2 + uy * ext;
        var pb = [[ax0 + nx, ay0 + ny], [ax0 - nx, ay0 - ny], [bx0 - nx, by0 - ny], [bx0 + nx, by0 + ny]];
        pb = _gzClip(pb, 0, 1, -yA); pb = _gzClip(pb, 0, -1, yB2);
        if (_gzArea(pb) < 0) pb.reverse();
        poly('ledge', PH.BOARD, ceil2(dl + cw), idB, pb, 'xy', (zB0 + zL0) / 2, tt);
        coat += 2 * (tt + cw) * dl;
        for (var m3 = 0; m3 < nB; m3++) {
          var xq = -lw / 2 + gw / 2 + m3 * gc, tq = (xq - xA) / dx;
          if (tq > 0.05 && tq < 0.95) scr('nail-door', PH.TRIM_NAIL, xq, yA + dy * tq, zL0, [0, 0, o], len32, 0.0012);
        }
      }
      for (q = 0; q + 1 < nLed; q++) braceBetween(pre + '-brace-' + (q + 1), -ledW / 2 + 0.06, ledY[q] + cw / 2, ledW / 2 - 0.06, ledY[q + 1] - cw / 2);
      var hingeLen = Math.min(0.30, lw - 0.04), hingeW = 0.035, hT = 0.003;
      [0, nLed - 1].forEach(function (q2) {
        var hy = ledY[q2];
        hw.push({ kind: 'hinge', code: PH.HINGE, box: [-lw / 2 + hingeLen / 2, hy, zB1 + o * hT / 2, hingeLen, hingeW, hT], id: pre + '-hinge-' + q2 });
        var xLf = -ro / 2 - Math.min(cw / 2, st * 0.45);   /* the leaf on the casing over the king (no jack here) */
        hw.push({ kind: 'hinge', code: null, box: [xLf, hy, zB1 + o * (tt + hT / 2), Math.min(cw * 0.8, 2 * st * 0.45 + 0.01), hingeW * 1.6, hT], id: pre + '-hinge-leaf-' + q2 });
        hinges++;
        for (var h3 = 0; h3 < 3; h3++) {
          scr('screw-hinge', PH.HINGE_SCREW, -lw / 2 + 0.03 + h3 * (hingeLen - 0.05) / 2, hy, zB1 + o * hT, [0, 0, -o], len40, 0.0022);
          scrClear('screw-hinge', PH.HINGE_SCREW, [0, 0.008, -0.008, 0.012, -0.012].map(function (dy3) { return [xLf, hy + (h3 - 1) * hingeW * 0.5 + dy3, zB1 + o * (tt + hT)]; }), [0, 0, -o], len40, 0.0022);   /* clear of the casing's nails */
        }
      });
      if (pull) { hw.push({ kind: 'knob', code: PH.KNOB, cyl: [lw / 2 - 0.07, (dy0 + dy1) / 2, (o < 0) ? zB1 - 0.05 : zB1, 0.025, 0.05], id: pre + '-knob' }); knobs++; }
      if (latch === 'catch') { hw.push({ kind: 'catch', code: PH.CATCH, box: [lw / 2 - 0.03, dy1 - 0.03, zB0 - o * 0.008, 0.03, 0.02, 0.016], id: pre + '-catch' }); catches++; }
      if (latch === 'bolt') { hw.push({ kind: 'bolt', code: null, box: [lw / 2, (dy0 + dy1) / 2 + 0.08, zB1 + o * 0.007, 0.11, 0.03, 0.014], id: pre + '-catch' }); bolts++; }
      return { n: nB, w: lw, h: dH };
    }
    var dA = ledgedDoor('door', -1, -(L / 2 + sg), ROa, yF, yHa, 2, true, 'bolt');
    nDb += dA.n; doorW = dA.w; doorH = dA.h;
    var dP = ledgedDoor('pop', 1, zH + sg, ROp, yF, yHp, 2, false, 'catch');
    nDb += dP.n;

    /* THE NEST BOXES inside on the floor in the back right corner: an OSB box under the slope (its outer wall where the box's
       top clears the legs), the nests in a row from the back gable, open to the middle behind a 10 cm (US 4 in.) lip, a top
       over them (a shelf the roosts above drop onto); 5x60 screws joining the panels, and through its back into the access
       door's king */
    var zN0 = -L / 2 + sd + 0.003;
    while (nN > 1 && zN0 + nN * (NB + nt) + nt > zH - sd - 0.03) nN--;
    var zN1 = zN0 + nN * (NB + nt) + nt;
    box('nest', PH.FLOOR, 0, 'nest-wall', xb1 - nt / 2, yF + NB / 2, (zN0 + zN1) / 2, nt, NB, zN1 - zN0);
    nestA += NB * (zN1 - zN0);
    for (k = 0; k <= nN; k++) {
      var zq = zN0 + nt / 2 + k * (NB + nt), endP = (k === 0 || k === nN), px0 = endP ? xb0 : xb0 + nt;
      box('nest', PH.FLOOR, 0, (k === 0) ? 'nest-end-1' : (k === nN) ? 'nest-end-2' : 'nest-div-' + k, (px0 + xb1 - nt) / 2, yF + NB / 2, zq, xb1 - nt - px0, NB, nt);
      nestA += (xb1 - nt - px0) * NB;
      /* through the outer wall into its edge, through the top down into it */
      for (e = 0; e < 2; e++) scr('screw-nest', PH.SHEATH_SCREW, xb1, yF + NB * (0.3 + 0.4 * e), zq, [-1, 0, 0], len60);
      fixPts(px0 + 0.05, xb1 - nt - 0.05, 0.12).forEach(function (xq) { scr('screw-nest', PH.SHEATH_SCREW, xq, yNt, zq, [0, -1, 0], len60); });
    }
    box('nest', PH.FLOOR, 0, 'nest-top', (xb0 + xb1) / 2, yNt - nt / 2, (zN0 + zN1) / 2, xb1 - xb0, nt, zN1 - zN0);
    nestA += (xb1 - xb0) * (zN1 - zN0);
    box('nest', PH.FLOOR, 0, 'nest-lip', xb0 + nt / 2, yF + lipH / 2, (zN0 + zN1) / 2, nt, lipH, zN1 - zN0 - 2 * nt);
    nestA += lipH * (zN1 - zN0 - 2 * nt);
    for (e = -1; e <= 1; e += 2) scr('screw-nest', PH.SHEATH_SCREW, xb0 + nt / 2, yF + lipH / 2, (e < 0) ? zN0 : zN1, [0, 0, -e], len60);
    fixPts(zN0 + 0.06, zN1 - 0.06, 0.15).forEach(function (zq2) { scr('screw-nest', PH.SHEATH_SCREW, xb1 - nt / 2, yNt, zq2 + 0.02, [0, -1, 0], len60); });
    var nestFix = 0;
    backMembers.forEach(function (bm) {
      var um = (bm[0] + bm[1]) / 2;
      if (um < xb0 + 0.03 || um > xb1 - nt - 0.03) return;
      [yF + 0.08, Math.min(yF + NB - 0.06, bm[2] - 0.04)].forEach(function (yq) { scr('screw-nest', PH.SHEATH_SCREW, um, yq, zN0 + nt, [0, 0, -1], len60); nestFix++; });
    });
    coat += 2 * nestA;

    /* THE RAMP from the pop door's sill down to the ground at 35 deg (the backyard coop's): two 1x6 planks, two 1x4 ledges
       under them, 20 x 40 cleats every 15 cm (US 6 in.), its head on a 2x4 ledger screwed through the siding into the
       partition's floor tie */
    var PBd = _pfBoard(s), pkT = PBd.t, pkW = PBd.w, ra = CO.RAMP_ANG * Math.PI / 180, rCs = Math.cos(ra), rSn = Math.sin(ra), rTn = Math.tan(ra);
    var rz0 = zH + sg + 0.003, rY0 = yF, rdz = rCs, rdy = -rSn, rnz = rSn, rny = rCs;
    var rzt = rz0 + rY0 / rTn, ryb = rY0 - pkT / rCs, rzb = rz0 + ryb / rTn, rLen = rY0 / rSn;
    function rAt(sl, nn) { return [rz0 + rdz * sl + rnz * nn, rY0 + rdy * sl + rny * nn]; }
    for (e = -1; e <= 1; e += 2) {
      poly('ramp', CO.PLANK, ceil2(rLen), 'ramp-plank-' + (e < 0 ? 'l' : 'r'), [[rz0, rY0], [rz0, ryb], [rzb, 0], [rzt, 0]], 'zy', e * (pkW / 2 + 0.002), pkW);
      coat += 2 * (pkW + pkT) * rLen;
    }
    var rWd = 2 * pkW + 0.004, ctT = _coU(s, 'CL_T'), ctW = _coU(s, 'CL_W'), nCl = 0;
    [0.12, rLen - 0.30].forEach(function (sl, qi) {
      var pts = [rAt(sl - cw / 2, -pkT), rAt(sl + cw / 2, -pkT), rAt(sl + cw / 2, -pkT - tt), rAt(sl - cw / 2, -pkT - tt)];
      poly('rledge', PH.BOARD, ceil2(rWd), 'ramp-ledge-' + (qi + 1), pts, 'zy', 0, rWd);
      coat += 2 * (cw + tt) * rWd;
      var cq = rAt(sl, -pkT - tt);
      for (var e9 = -1; e9 <= 1; e9 += 2) for (var e10 = -1; e10 <= 1; e10 += 2) scr('nail-ramp', PH.TRIM_NAIL, e9 * (pkW / 2 + 0.002) + e10 * pkW / 4, cq[1], cq[0], [0, rny, rnz], len32, 0.0012);
    });
    for (var sl2 = 0.10; sl2 < rLen - 0.12; sl2 += _coU(s, 'CLEAT_SP')) {
      nCl++;
      poly('rcl', CO.CLEAT, ceil2(rWd), 'ramp-cleat-' + nCl, [rAt(sl2 - ctW / 2, 0), rAt(sl2 + ctW / 2, 0), rAt(sl2 + ctW / 2, ctT), rAt(sl2 - ctW / 2, ctT)], 'zy', 0, rWd);
      coat += 2 * (ctW + ctT) * rWd;
      var cq2 = rAt(sl2, ctT);
      for (e = -1; e <= 1; e += 2) for (var e11 = -1; e11 <= 1; e11 += 2) scr('nail-ramp', PH.TRIM_NAIL, e * (pkW / 2 + 0.002) + e11 * pkW / 4, cq2[1], cq2[0], [0, -rny, -rnz], len32, 0.0012);
    }
    var yLgT = ryb - st * rTn, yLgB = yLgT - sd, yLs = (Math.max(yLgB, yFb) + Math.min(yLgT, yFt)) / 2;
    box('rledger', PH.STUD, ceil2(0.40), 'ramp-ledger', 0, (yLgT + yLgB) / 2, rz0 + st / 2, 0.40, sd, st);
    coat += 2 * (st + sd) * 0.40;
    for (e = -1; e <= 1; e += 2) scr('screw-rledger', us ? PH.TIE_SCREW : PH.STUD_SCREW, e * 0.13, yLs, rz0 + st, [0, 0, -1], us ? len80 : len120);   /* (US 6x80: the tie is 1 1/2 in.) */
    for (e = -1; e <= 1; e += 2) { var rq = rAt(st / rCs - 0.006, 0); scr('screw-ramp', PH.DECK_SCREW, e * (pkW / 2 + 0.002), rq[1], rq[0], [0, -rny, -rnz], len50); }   /* where the plank bears on the ledger's front edge */

    /* THE RUN DOOR in the front gable: two 2x4 jambs from the cross member up to the collar tie (two 6x160 up through the
       member, two down through the tie), the door a frame of 2x4 laid flat (stiles, rails, a brace) clothed, two strap
       hinges onto the left jamb, a barrel bolt onto the right one (MISSING) -- a leaf of its own ('door-r') */
    var DW = _ctU(s, 'RDOOR'), xD0 = -DW / 2 - clr, xD1 = DW / 2 + clr, jx = DW / 2 + clr + sd / 2;
    for (sx = -1; sx <= 1; sx += 2) {
      box('stud', PH.STUD, ceil2(yC0 - sd), 'jamb-' + (sx < 0 ? 'l' : 'r'), sx * jx, (sd + yC0) / 2, zC, sd, yC0 - sd, st);
      coat += 2 * (st + sd) * (yC0 - sd);
      for (k = -1; k <= 1; k += 2) {
        scr('screw-jamb', PH.JOIST_SCREW, sx * jx + k * sd * 0.35, 0, zC, [0, 1, 0], len160);   /* (wide of the hinge leaves' screws) */
        scr('screw-jamb', PH.JOIST_SCREW, sx * jx + k * sd * 0.35, yC1, zC, [0, -1, 0], len160);
      }
    }
    var lx0 = xD0 + clr, lx1 = xD1 - clr, ly0 = sd + clr, ly1 = yC0 - clr, lz = zC;
    box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-1', lx0 + sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
    box('dframe', PH.STUD, ceil2(ly1 - ly0), 'door-r-ledge-2', lx1 - sd / 2, (ly0 + ly1) / 2, lz, sd, ly1 - ly0, st);
    box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-3', (lx0 + lx1) / 2, ly0 + sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
    box('dframe', PH.STUD, ceil2(lx1 - lx0 - 2 * sd), 'door-r-ledge-4', (lx0 + lx1) / 2, ly1 - sd / 2, lz, lx1 - lx0 - 2 * sd, sd, st);
    coat += 2 * (st + sd) * (2 * (ly1 - ly0) + 2 * (lx1 - lx0 - 2 * sd));
    [ly0 + sd / 2, ly1 - sd / 2].forEach(function (yq) {
      for (var e13 = -1; e13 <= 1; e13 += 2) {
        scr('nail-door', PH.JOIST_SCREW, lx0, yq + e13 * sd / 4, lz, [1, 0, 0], len160);
        scr('nail-door', PH.JOIST_SCREW, lx1, yq + e13 * sd / 4, lz, [-1, 0, 0], len160);
      }
    });
    var bA = [lx0 + sd, ly0 + sd], bB = [lx1 - sd, ly1 - sd], bdx = bB[0] - bA[0], bdy = bB[1] - bA[1], bdl = Math.sqrt(bdx * bdx + bdy * bdy);
    var bnx = -bdy / bdl * sd / 2, bny = bdx / bdl * sd / 2, bex = bdx / bdl * sd, bey = bdy / bdl * sd;
    var bpb = [[bA[0] - bex + bnx, bA[1] - bey + bny], [bA[0] - bex - bnx, bA[1] - bey - bny], [bB[0] + bex - bnx, bB[1] + bey - bny], [bB[0] + bex + bnx, bB[1] + bey + bny]];
    bpb = _gzClip(bpb, 1, 0, -(lx0 + sd)); bpb = _gzClip(bpb, -1, 0, lx1 - sd); bpb = _gzClip(bpb, 0, 1, -(ly0 + sd)); bpb = _gzClip(bpb, 0, -1, ly1 - sd);
    if (_gzArea(bpb) < 0) bpb.reverse();
    poly('dframe', PH.STUD, ceil2(bdl + sd), 'door-r-brace-1', bpb, 'xy', lz, st);
    coat += 2 * (st + sd) * bdl;
    var hV = sd / 2 * bdl / bdx, yBa = bA[1] + 0.07 * bdy / bdx, yBb = bB[1] - 0.07 * bdy / bdx;   /* down / up from inside the brace into the rail */
    scr('nail-door', PH.TIE_SCREW, bA[0] + 0.07, Math.max(ly0 + sd + 0.005, yBa - hV + 0.012), lz, [0, -1, 0], len80);
    scr('nail-door', PH.TIE_SCREW, bB[0] - 0.07, Math.min(ly1 - sd - 0.005, yBb + hV - 0.012), lz, [0, 1, 0], len80);
    mesh('door-r-board-1', [[lx0, ly0], [lx1, ly0], [lx1, ly1], [lx0, ly1]], 'xy', L / 2 + mo, null);
    var rhl = Math.min(0.30, lx1 - lx0 - 0.04), rhw = 0.035, rhT = 0.003;
    [ly0 + sd / 2, ly1 - sd / 2].forEach(function (hy, qi) {
      hw.push({ kind: 'hinge', code: PH.HINGE, box: [lx0 + rhl / 2 - 0.02, hy, L / 2 + mo + 0.002 + rhT / 2, rhl, rhw, rhT], id: 'door-r-hinge-' + (qi * 2) });
      hw.push({ kind: 'hinge', code: null, box: [-jx, hy, L / 2 + mo + 0.002 + rhT / 2, sd * 0.8, rhw * 1.6, rhT], id: 'door-r-hinge-leaf-' + (qi * 2) });
      hinges++;
      for (var h5 = 0; h5 < 3; h5++) {
        scr('screw-hinge', PH.HINGE_SCREW, lx0 + 0.01 + h5 * (rhl - 0.04) / 2, hy, L / 2 + mo + 0.002 + rhT, [0, 0, -1], len40, 0.0022);
        scr('screw-hinge', PH.HINGE_SCREW, -jx + (h5 - 1) * 0.012, hy + (h5 - 1) * 0.012, L / 2 + mo + 0.002 + rhT, [0, 0, -1], len40, 0.0022);
      }
    });
    hw.push({ kind: 'bolt', code: null, box: [lx1, (ly0 + ly1) / 2, L / 2 + mo + 0.009, 0.11, 0.03, 0.014], id: 'door-r-catch' });
    bolts++;

    /* THE HARDWARE CLOTH: each side a strip on the skid's inner face up to the slope's cloth, both slopes on the
       legs (over the run up to the ridge, under the house up to the roof's edge), the back under the house, the front gable
       round the run door; the staples' lines: the sheets' edges, every leg it lies on, the skids, the jambs */
    var xSi = W / 2 - skT - mo - CO.MESH_T / 2;   /* the strips on the skids' inner faces (the wheels outside them), up to the slopes' cloth */
    for (sx = -1; sx <= 1; sx += 2) mesh('mesh-s' + (sx < 0 ? 'l' : 'r'), [[-L / 2 - mo, skH - 0.05], [L / 2 + mo, skH - 0.05], [L / 2 + mo, yT(xSi) + 0.01], [-L / 2 - mo, yT(xSi) + 0.01]], 'zy', sx * xSi, null);
    var mO = mo + CO.MESH_T;
    for (sx = -1; sx <= 1; sx += 2) {
      var ox = sx * sn * mO, oy = cs * mO, p0 = [sx * W / 2 + ox, yT(W / 2) + oy], pR = [sx * xr + ox, yT(xr) + oy], pE = [sx * xE + ox, yE + oy];
      meshQuad('mesh-run-' + (sx < 0 ? 'l' : 'r'), [[p0[0], p0[1], zH], [p0[0], p0[1], L / 2 + mo], [pR[0], pR[1], L / 2 + mo], [pR[0], pR[1], zH]], sx);
      meshQuad('mesh-hs-' + (sx < 0 ? 'l' : 'r'), [[p0[0], p0[1], -L / 2 - mo], [p0[0], p0[1], zH], [pE[0], pE[1], zH], [pE[0], pE[1], -L / 2 - mo]], sx);
    }
    mesh('mesh-b', [[-W / 2, 0], [W / 2, 0], [W / 2, yT(W / 2)], [xO(yFb), yFb], [-xO(yFb), yFb], [-W / 2, yT(W / 2)]], 'xy', -(L / 2 + mo + CO.MESH_T / 2), null);
    mesh('mesh-f', [[-W / 2, 0], [W / 2, 0], [W / 2, yT(W / 2)], [xr2, yT(xr2)], [-xr2, yT(xr2)], [-W / 2, yT(W / 2)]], 'xy', L / 2 + mo + CO.MESH_T / 2, [[[xD0, sd], [xD1, sd], [xD1, yC0], [xD0, yC0]]]);
    frames.forEach(function (f) { stapleL += 2 * ((f.kind === 'run' || f.kind === 'front') ? (W / 2 - xr) : (W / 2 - xE)) / cs; });
    stapleL += 2 * L + 2 * (yC0 - sd) + xbL;

    /* THE WHEELS (the toggle): two 10 in. wheels outside the skids at the back, a washer each side of each, on an M16 (US
       5/8 in.) threaded rod through both skids with a cap nut at each end; 1.5 cm (US 5/8 in.) off the ground on the skids */
    var wR = _ctU(s, 'WHEEL_D') / 2, wW = _ctU(s, 'WHEEL_W'), yAx = wR + _ctU(s, 'WHEEL_UP'), zAx = -L / 2 + _ctU(s, 'AXLE_Z'), wash = 0.004;
    if (wheels) {
      var xw = W / 2 + wash + wW / 2, rodL = W + 2 * (2 * wash + wW + 0.02);
      for (sx = -1; sx <= 1; sx += 2) {
        hw.push({ kind: 'wheel', code: null, cylX: [sx * xw, yAx, zAx, wR, wW], id: 'wheel-' + (sx < 0 ? 'l' : 'r') });
        hw.push({ kind: 'wheel', code: null, cylX: [sx * xw, yAx, zAx, wR * 0.42, wW + 0.008], id: 'wheel-hub-' + (sx < 0 ? 'l' : 'r'), hub: true });
      }
      fas.push({ kind: 'bolt-axle', code: PH.ROD, x: -rodL / 2, y: yAx, z: zAx, dir: [1, 0, 0], len: rodL, r: 0.008, rod: true });
    }

    /* the bill's quantities: timber by code; the hardware cloth (MISSING, by area), the barrel bolts (MISSING), the wheels
       (MISSING), the staples by the length of the lines they hold, the nest boxes' OSB, the wheels' inner washers */
    var m3 = {};
    for (i = 0; i < pieces.length; i++) { var pc = pieces[i]; if (pc.len > 0 && pc.code) m3[pc.code] = (m3[pc.code] || 0) + pc.len; }
    var r2 = function (v) { return Math.round(v * 100) / 100; };
    var meshAll = meshA * PH.WASTE, staples = Math.ceil(stapleL / _coU(s, 'STAPLE_SP') - 1e-9);
    missing.push(us ? { name: CO.MESH_NAME, qty: r2(meshAll * 10.7639), unit: 'ft2' } : { name: CO.MESH_NAME, qty: r2(meshAll), unit: 'm2' });
    missing.push({ name: CO.BOLT_NAME, qty: bolts, unit: 'pcs' });
    if (wheels) missing.push({ name: CT.WHEEL_NAME, qty: 2, unit: 'pcs' });
    var extra = {};
    extra[PH.FLOOR] = r2(nestA * PH.WASTE);
    extra[CO.STAPLE] = staples;
    if (wheels) extra[PH.WASHER] = 2;
    var top = yT(0) + rsV + 0.01;
    return {
      P: P, us: us, porch: false, L: L, W: W, PD: 0, zF: L / 2, pieces: pieces, fas: fas, blocks: [], hw: hw, posts: [], joists: [], rafters: frames,
      meters: m3, coat: coat, floorA: floorA, roofA: roofA, sidingA: sidingA, capA: capA, capNails: capNails, dripL: dripL, dripNails: dripNails,
      gravelM3: 0, digM3: 0, hinges: hinges, knobs: knobs, catches: catches, shutters: 0, deckBoards: 0,
      ties: nTies, gStuds: gStuds, trims: 0, doorBoards: nDb, doorW: doorW, doorH: doorH, RO: ROa, win: 0,
      yB: yFb, yF: yF, yPT: yPT, yBm: yPT, yHd: yHa, yWS: 0, ridgeTop: rgTop, pitch: CT.PITCH, rafL: legL, roofLen: eLen, slope: slope,
      top: top, height: top, depth: W, length: L, mono: false, roofCov: 'shingle', yPTL: yPT, seams: 0,
      stilt: false, slide: false, gscrews: [], uheads: [], missing: missing, yD: yF, extX: W / 2 + (wheels ? 2 * wash + wW : 0), extZ: L / 2 + hdl,
      sPosts: 0, xBraces: 0, balusters: 0, treads: 0, rails: 0,
      coop: true, tractor: true, run: wheels, wheels: wheels, hens: N, Lh: Lh, zH: zH, nests: nN, nestsWanted: nWant, nestFix: nestFix, roosts: nBars, perBar: perBar, roostLen: barLen,
      frames: frames.length, houseFrames: nr1 + 1, kbraces: 0, ramp: { len: rLen, cleats: nCl, foot: rzt }, wheel: wheels ? { d: 2 * wR, y: yAx, z: zAx } : null,
      meshA: r2(meshA), apronA: 0, meshAll: r2(meshAll), staples: staples, bolts: bolts, nestA: r2(nestA), extra: extra
    };
  }
  /* its staged assembly (a table of its own): one catalogue item a step, the screws that fix it the step after -- the base,
     the A-frames and the ridge, the ties and the roosts, the floor, the gables' framing, the roof, the siding, the doors,
     the nest boxes, the ramp, the hardware cloth, the barrel bolts (MISSING), the wheels (MISSING) */
  function _ctSteps() {
    return ([
      { parts: [], codes: [] },
      { parts: ['ph-skid'], codes: [CT.SKID] },
      { parts: ['ph-xbase'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-xbase'], codes: [PH.JOIST_SCREW] },
      { parts: ['ph-rafter'], codes: [PH.RAFTER] },
      { parts: ['ph-ridge'], codes: [PH.RIDGE] },
      { parts: ['ph-hw-screw-seat'], codes: [PH.FBEAM_SCREW] },
      { parts: ['ph-hw-screw-rtoe'], codes: [PH.RIDGE_TOE] },
      { parts: ['ph-tie'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-tie'], codes: [PH.BEAM_SCREW] },
      { parts: ['ph-roost'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-roost'], codes: [PH.BEAM_SCREW] },
      { parts: ['ph-floor'], codes: [PH.FLOOR, PH.SHEATH_SCREW] },
      { parts: ['ph-gstud'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-gstud'], codes: [PH.FRAME_SCREW] },
      { parts: ['ph-header'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-frame'], codes: [PH.STUD_SCREW, PH.FRAME_SCREW, PH.RIDGE_TOE] },
      { parts: ['ph-stud'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-jamb'], codes: [PH.JOIST_SCREW] },
      { parts: ['ph-sheath'], codes: [PH.ROOF, PH.SHEATH_SCREW] },
      { parts: ['ph-siding'], codes: [PH.SIDING, PH.SIDING_SCREW] },   /* the siding before the rake boards: their screws pass it at the back gable */
      { parts: ['ph-fascia'], codes: [PH.BOARD] },
      { parts: ['ph-hw-screw-fascia'], codes: [PH.FASCIA_SCREW] },
      { parts: ['ph-drip'], codes: [PH.DRIP, PH.ROOF_NAIL] },
      { parts: ['ph-cover'], codes: [PH.UNDERLAY, PH.UL_STAPLE, PH.SHINGLE, PH.ROOF_NAIL] },
      { parts: ['ph-casing'], codes: [PH.BOARD] },
      { parts: ['ph-hw-nail-trim'], codes: [PH.TRIM_NAIL] },
      { parts: ['ph-door'], codes: [PH.TG] },
      { parts: ['ph-ledge'], codes: [PH.BOARD] },
      { parts: ['ph-dframe'], codes: [PH.STUD] },
      { parts: ['ph-hw-nail-door'], codes: [PH.TRIM_NAIL, PH.JOIST_SCREW, PH.TIE_SCREW] },
      { parts: ['ph-hinge'], codes: [PH.HINGE] },
      { parts: ['ph-hw-screw-hinge'], codes: [PH.HINGE_SCREW] },
      { parts: ['ph-knob'], codes: [PH.KNOB] },
      { parts: ['ph-catch'], codes: [PH.CATCH] },
      { parts: ['ph-nest'], codes: [PH.FLOOR] },
      { parts: ['ph-hw-screw-nest'], codes: [PH.SHEATH_SCREW] },
      { parts: ['ph-rledger'], codes: [PH.STUD] },
      { parts: ['ph-hw-screw-rledger'], codes: [PH.STUD_SCREW, PH.TIE_SCREW] },
      { parts: ['ph-ramp'], codes: [CO.PLANK] },
      { parts: ['ph-rledge'], codes: [PH.BOARD] },
      { parts: ['ph-rcl'], codes: [CO.CLEAT] },
      { parts: ['ph-hw-nail-ramp'], codes: [PH.TRIM_NAIL] },
      { parts: ['ph-hw-screw-ramp'], codes: [PH.DECK_SCREW] },
      { parts: ['ph-mesh'], codes: [CO.STAPLE] },
      { parts: ['ph-bolt'], codes: [] },
      { parts: ['ph-wheel', 'ph-hw-bolt-axle'], codes: [PH.ROD, PH.WASHER, PH.CAPNUT] }
    ]);
  }
  /* its line in the debug log (what the flock got) */
  function _ctLog(g, bq) {
    _dbg('[co] chicken tractor: ' + g.hens + ' hens, wheels ' + (g.wheels ? 'ON (' + g.wheel.d.toFixed(3) + ' at ' + g.wheel.y.toFixed(3) + ')' : 'OFF') + ', ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (' + (g.L * g.W / g.hens).toFixed(2) + ' m2 a hen; house ' + g.Lh.toFixed(3) +
         ', its floor ' + g.floorA.toFixed(2) + ' m2 = ' + (g.floorA / g.hens).toFixed(2) + ' a hen at ' + g.yF.toFixed(3) + '), ' + g.frames + ' A-frames at ' + g.pitch + ' deg (' + g.houseFrames + ' in the house), legs ' + g.rafL.toFixed(2) + ', ridge top ' + g.ridgeTop.toFixed(3) +
         ', ' + g.ties + ' ties, ' + g.roosts + ' roosts ' + g.roostLen.toFixed(2) + ' (' + g.perBar + ' hens a bar), ' + g.nests + ' nests' + ((g.nests < g.nestsWanted) ? ' (' + g.nestsWanted + ' wanted, no room)' : '') + ' (' + g.nestFix + ' screws into the gable' + (g.nestFix ? '' : ' -- NONE') + '), ' +
         g.gStuds + ' gable studs, ramp ' + g.ramp.len.toFixed(2) + ' (' + g.ramp.cleats + ' cleats), hardware cloth ' + g.meshA.toFixed(2) + ' m2 (' + g.staples + ' staples), ' + g.bolts + ' barrel bolts, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners; ' +
         Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
    for (var i = 0; i < (bq.missing || []).length; i++) _dbg('[co] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
  }
  /* ------------------------------------------------------------------
     v301 TYPE 18 -- THE MODERN SWING (Marek 2026-10-20 20:02, three shots of
     the ogrodowe_flow reel: "Zalozeni stavby - vyber variant na vruty /
     betonove patky, ukotveni U, sedaci cast pro 2-3. Tri paralelni
     konstrukce se vzperami. Default take seda barva." Asked: the seat on
     the middle frame on a chain V per side; the frames tied between their
     beams -- 20:07 "Ty vzpery jsou mezi frames, nejsou nad nebo pod", 20:10
     "2 (kratke spalky), a udelat to tak, ze nebudou v ose, ale kousek od
     sebe. Udelej i prepnuti varianty ze jich bude vice mensich, a mezi nimi
     bude provlecena pruh latky cik cak"):
       - THREE PORTALS 45 cm apart (centres; US 18 in.): each 2 posts 6x6
         KVH16160 2.20 (US 7 ft 2 in.) and a 6x6 beam on their tops, flush
         with their outer faces, 2 x 8x260 FAS80260 down into each post;
       - FOUNDATIONS on the info-bar toggle: GROUND SCREWS FGR00004 (102 x
         1500, US 4 in. x 5 ft) with a U head FGR00002, or CONCRETE FOOTINGS
         30 x 30 cm, 80 deep (US 12 x 12 x 32 in.) on 10 cm of gravel with a
         wet-set U anchor FCO00004; the post 30 mm up in the U, 12 connector
         nails FAS38038 through its flanges;
       - BETWEEN THE BEAMS (the beams' depth, nothing over or under them):
         BLOCKS -- a 6x6 block in each gap at both ends, the back gap's
         24 cm (US 9 1/2 in.) further in than the front gap's so the screws
         through the middle beam never meet; or on the level button the
         WEAVE -- 2x4 slats KVH10060 on edge at most 30 cm apart in each gap
         (the back gap's half a pitch off) with a strip of shade cloth
         TST00003 woven under / over them. Each block / slat end 2 x 8x260
         FAS80260 through its beam (the middle beam's from the other gap:
         the top is put together on the ground, then lifted on the posts);
       - THE SEAT = the sofa-style porch swing (_porchSofaLayout, 3x3 box
         frame, cushions; its length 1.00 .. 2.10 on the handle, default
         1.80) on a chain V per side from a swing hanger under the middle
         beam (2 x 6x100 FAS60100 -- the beam is 160 deep); the portals'
         width follows it (25 cm from an eye bolt to a post).
     X = depth (front +), Y = up, Z = along the seat; centred on 0.
     _mfLayout(STATE) is the single source: the renderer draws it, the bill
     sums it. */
  var MF = {
    POST_H: 2.20, POST_H_US: 2.1844,           /* 7 ft 2 in. */
    SP: 0.45, SP_US: 0.4572,                   /* the portals' centres (18 in.) */
    SEAT_CLR: 0.25, SEAT_CLR_US: 0.254,        /* an eye bolt to a post's inner face */
    STAGGER: 0.24, STAGGER_US: 0.2413,         /* the back gap's blocks further in than the front gap's */
    SLAT_SP: 0.30, SLAT_SP_US: 0.3048,         /* the weave's slats at most this far apart */
    FOOT_UP: 0.05, FOOT_UP_US: 0.0508,         /* the footing's / the screw's head above the ground */
    BASE_UP: 0.030, BASE_T: 0.004, BASE_FLANGE: 0.15,
    FOOT: 0.30, FOOT_US: 0.3048, FOOT_D: 0.80, FOOT_D_US: 0.8128, GRAVEL: 0.10, GRAVEL_US: 0.1016,
    GS_R: 0.051, GS_R_US: 0.0508,              /* FGR00004 102 (US 4 in.) */
    FAB_T: 0.003, FAB_CLR: 0.015, FAB_TIE: 0.15,   /* the strip: thickness, clear of each beam, tied off at each end */
    SCREW_OFF: 0.04, SLAT_OFF: 0.025, TOE_SCREW: 'FAS50060',   /* v304 the weave's 40x60 slats: toe screws 5x60 (v302: 6x100 into the 2x4) */
    TOE_IN: 0.020, FAB_OP: 0.70,               /* v304 a toe screw's start from the beam face; the cloth 70 % opaque */
    CANT_MISS: 1,                              /* v308 the LED top: the front portal has no post at +z, the back one none at -z */
    ROD_DZ: 0.04,                              /* v308 a block's 2 M16 rods side by side, +-4 cm off its middle (the beam screws pass between) */
    LED_GW: 0.020, LED_GW_US: 0.0191, LED_GD: 0.012, LED_GD_US: 0.0127,   /* v308 the LED groove: 20 x 12 (US 3/4 x 1/2 in.) */
    LED: 'EEC00006', LED_PSU: 'EEC00007', PSU_SCREW: 'FAS45070', PSU_Y: 0.35,   /* v308 the 24 V strip (m), its power supply on the outer post 35 cm up */
    L_DEF: 1.80,
    POST: 'KVH16160', SLAT: 'KVH40060', SCREW: 'FAS80260', BASE_NAIL: 'FAS38038',
    GSCREW: 'FGR00004', UHEAD: 'FGR00002', UANCHOR: 'FCO00004', FABRIC: 'TST00003', HANGER_SCREW: 'FAS60100',
    CONCRETE: 'FCO00002', DIG: 'FEE00001', GRAVEL_CODE: 'FCO00001'
  };
  /* the sections: the 6x6, the weave's 40x60 on edge (metric / US actual
     2x3); v304 smaller than the 2x4 of v302 */
  function _mfProf(s) {
    if ((s || STATE).isMetric === false) return { p: 0.1397, sw: 0.0381, sh: 0.0635 };
    return { p: 0.160, sw: 0.040, sh: 0.060 };
  }
  function _mfU(s, k) { return ((s || STATE).isMetric === false && MF[k + '_US'] != null) ? MF[k + '_US'] : MF[k]; }
  function _mfFound(s) { return ((s || STATE).mfFound === 'concrete') ? 'concrete' : 'screw'; }
  function _mfWeave(s) { return (s || STATE).mfWeave === true; }
  function _mfCant(s) { return !_mfWeave(s) && (s || STATE).mfCant === true; }   /* v308 */
  function _mfTop(s) { return _mfWeave(s) ? 'weave' : (_mfCant(s) ? 'led' : 'blocks'); }
  function _mfLayout(s) {
    s = s || STATE;
    var Pr = _mfProf(s), p = Pr.p, hp = p / 2, sw = Pr.sw, sh = Pr.sh, us = (s.isMetric === false), i, j, k, q;
    var len260 = us ? 0.254 : 0.26, len100 = us ? 0.1016 : 0.10, nailLen = us ? 0.0381 : 0.038;
    var found = _mfFound(s), weave = _mfWeave(s), cant = _mfCant(s), bt = MF.BASE_T;
    /* the heights: the footing's / the screw's top, the post's foot (in its
       U), its top = the beams' underside (the hanging height), the beams' middle and top */
    var yF = _mfU(s, 'FOOT_UP'), yPB = yF + MF.BASE_UP, postH = _mfU(s, 'POST_H'), yPT = yPB + postH, yBM = yPT + hp, yBT = yPT + p;
    var seat = _porchSofaLayout(s, { H: yPT, hangerScrew: { code: MF.HANGER_SCREW, len: len100 } });
    var d = _mfU(s, 'SP'), gapL = d - p, gapLb = Math.ceil(gapL * 1000) / 1000;
    var zP = seat.L / 2 + PORCH.EYE_OUT + 0.022 + _mfU(s, 'SEAT_CLR') + hp, beamL = 2 * (zP + hp);
    /* v302 (Marek 20:36: u teto druhe varianty muzes udelat, ze misto 3
       frames jich bude 5): the weave on 5 portals, the blocks on 3 */
    var nFr = weave ? 5 : 3, frames = [];
    for (i = 0; i < nFr; i++) { var fo = (nFr - 1) / 2 - i; frames.push({ x: fo * d, n: (fo === 0) ? 'mid' : (fo > 0 ? 'front' : 'back') + (Math.abs(fo) > 1 ? '2' : '') }); }
    var pieces = [], screws = [], posts = [], feet = [], gscrews = [], bases = [], sz;
    function box(kind, code, len, id, x, y, z, bx, by, bz) { pieces.push({ kind: kind, code: code, len: len, id: id, box: [x, y, z, bx, by, bz] }); }
    function scr(kind, code, x, y, z, dd, len, r) { screws.push({ kind: kind, code: code, x: x, y: y, z: z, dir: dd, len: len, r: r }); }
    /* v308 the LED top: the outer portals one post short -- the front
       without its +z post, the back without its -z one (CANT_MISS) */
    for (i = 0; i < frames.length; i++) for (sz = -1; sz <= 1; sz += 2) {
      if (cant && frames[i].x !== 0 && sz === ((frames[i].x > 0) ? MF.CANT_MISS : -MF.CANT_MISS)) continue;
      posts.push({ x: frames[i].x, z: sz * zP, sz: sz, id: frames[i].n + (sz < 0 ? '-l' : '-r'), led: cant && frames[i].x !== 0 });
    }
    var gw = us ? MF.LED_GW_US : MF.LED_GW, gd = us ? MF.LED_GD_US : MF.LED_GD, leds = [], psus = [];
    function rod(kind, x, y, z, dd, len) { screws.push({ kind: kind, code: SWING.ROD_CODE, x: x, y: y, z: z, dir: dd, len: len, r: 0.008, rod: true }); }
    /* THE GROUND WORKS + the U under every post, its nails */
    var fw = _mfU(s, 'FOOT'), fd = _mfU(s, 'FOOT_D'), gv = _mfU(s, 'GRAVEL'), gr = _mfU(s, 'GS_R');
    for (i = 0; i < posts.length; i++) {
      q = posts[i];
      if (found === 'concrete') feet.push({ x: q.x, z: q.z, w: fw, y0: -fd, y1: yF, id: q.id });
      else gscrews.push({ x: q.x, z: q.z, r: gr, y1: yF, id: q.id });
      bases.push({ x: q.x, z: q.z, y0: yF, y1: yPB, id: q.id, code: (found === 'concrete') ? MF.UANCHOR : MF.UHEAD });
      for (k = -1; k <= 1; k += 2) for (var nz = -1; nz <= 1; nz += 2) for (var ny = 0; ny < 3; ny++)
        scr('basenail', MF.BASE_NAIL, q.x + k * (hp + bt), yPB + 0.03 + ny * 0.045, q.z + nz * MF.SCREW_OFF, [-k, 0, 0], nailLen, 0.0019);   /* 6 a flange, through it into the post */
      if (!q.led) { box('post', MF.POST, postH, 'post-' + q.id, q.x, yPB + postH / 2, q.z, p, postH, p); continue; }
      /* v308 an outer post of the LED top: the groove up the middle of its
         inner face (the one towards the seat), full height; its outline in
         (x, z), extruded up */
      var sIn = (q.z > 0) ? -1 : 1, zf = q.z + sIn * hp;
      pieces.push({ kind: 'post', code: MF.POST, len: postH, id: 'post-' + q.id, plane: 'xz', c: yPB + postH / 2, t: postH, notch: true,
        poly: [[q.x - hp, q.z - sIn * hp], [q.x + hp, q.z - sIn * hp], [q.x + hp, zf], [q.x + gw / 2, zf], [q.x + gw / 2, zf - sIn * gd], [q.x - gw / 2, zf - sIn * gd], [q.x - gw / 2, zf], [q.x - hp, zf]] });
      leds.push({ axis: 'y', x: q.x, z: zf, s: sIn, y0: yPB, y1: yPT, len: postH, id: 'led-post-' + q.id });
      /* its 24 V power supply on the post's outward face, 2 screws through its tabs */
      var so = (q.x > 0) ? 1 : -1, yPs = yPB + MF.PSU_Y;
      psus.push({ x: q.x + so * (hp + 0.001 + 0.015), y: yPs, z: q.z, s: so, id: 'psu-' + q.id });
      for (k = -1; k <= 1; k += 2) scr('psu', MF.PSU_SCREW, q.x + so * (hp + 0.001), yPs + k * 0.088, q.z, [-so, 0, 0], 0.07, 0.00225);
    }
    /* THE BEAMS on the posts' tops, flush with their outer faces; 2 screws down into each post */
    for (i = 0; i < frames.length; i++) {
      var fx = frames[i].x;
      if (!(cant && fx !== 0)) { box(fx === 0 ? 'beam-mid' : 'beam-out', MF.POST, beamL, 'beam-' + frames[i].n, fx, yBM, 0, p, p, beamL); continue; }
      /* v308 an outer beam of the LED top: the groove along the middle of
         its underside, end to end; the strip from the post's inner face to
         the free end */
      pieces.push({ kind: 'beam-out', code: MF.POST, len: beamL, id: 'beam-' + frames[i].n, plane: 'xy', c: 0, t: beamL, notch: true,
        poly: [[fx - hp, yPT], [fx - gw / 2, yPT], [fx - gw / 2, yPT + gd], [fx + gw / 2, yPT + gd], [fx + gw / 2, yPT], [fx + hp, yPT], [fx + hp, yBT], [fx - hp, yBT]] });
      var sF = (fx > 0) ? MF.CANT_MISS : -MF.CANT_MISS;
      leds.push({ axis: 'z', x: fx, y: yPT, z0: -sF * (zP - hp), z1: sF * (zP + hp), len: 2 * zP, id: 'led-beam-' + frames[i].n });
    }
    for (i = 0; i < posts.length; i++) { q = posts[i]; for (k = -1; k <= 1; k += 2) scr('beam', MF.SCREW, q.x + k * MF.SCREW_OFF, yBT, q.z, [0, -1, 0], len260); }
    /* BETWEEN THE BEAMS, gap by gap from the front: in each the members
       alternate between two patterns (A, B) so neighbouring gaps never put
       two members -- or two screw heads -- on one line.
       BLOCKS (3 portals): a 6x6 block at both ends, pattern A at the post
       line, B 24 cm further in; each end 2 screws through its beam from the
       beam's far face (the middle beam's from the other gap: the top is put
       together on the ground, then lifted on the posts).
       WEAVE (5 portals): 40x60 slats on edge (v304; 2x4 before) at most
       30 cm apart, pattern B half a pitch off A; each end 2 toe screws 5x60
       (one from the top, one from below, 45 deg into the beam, side by side
       a quarter of the slat's width off its middle so they never cross) --
       with 5 beams the gaps are closed before a screw could go through a
       beam, so they are fixed in place. */
    var gaps = [], gi;
    for (i = 0; i + 1 < frames.length; i++) {
      var xa = frames[i].x, xb = frames[i + 1].x, xin = (Math.abs(xa) < Math.abs(xb)) ? xa : xb, xout = (xin === xa) ? xb : xa;
      gaps.push({ x: (xa + xb) / 2, xin: xin, xout: xout, sg: ((xa + xb) > 0) ? 1 : -1, pat: i % 2, n: 'gap' + (i + 1) });
    }
    var slatZ = [];
    if (!weave) {
      var st = _mfU(s, 'STAGGER');
      for (gi = 0; gi < gaps.length; gi++) {
        var gq = gaps[gi];
        if (cant) {
          /* v308 THE LED TOP (Marek: vzpery ted budou hrat i roli statickou;
             chose: M16 rods): each gap's block at the outer beam's FREE end
             right over the middle post (the outer beam's end rests on the
             middle frame through it), the one at its post end 24 cm in; 2
             M16 rods each, side by side, through the outer beam, the block
             and the middle beam (a washer + cap nut each end) -- the two
             gaps' rods meet the middle beam at different places */
          var sFg = (gq.xout > 0) ? MF.CANT_MISS : -MF.CANT_MISS, zbs = [sFg * zP, -sFg * (zP - st)], ovR = KF.ROD_OVER, rodL = 2 * p + gapL + 2 * ovR;
          for (k = 0; k < 2; k++) {
            box('block', MF.POST, gapLb, 'block-' + gq.n + (k ? '-post' : '-free'), gq.x, yBM, zbs[k], gapL, p, p);
            for (var m4 = -1; m4 <= 1; m4 += 2) rod('block', gq.xout + gq.sg * (hp + ovR), yBM, zbs[k] + m4 * MF.ROD_DZ, [-gq.sg, 0, 0], rodL);
          }
          slatZ.push([]);
          continue;
        }
        for (sz = -1; sz <= 1; sz += 2) {
          var zb0 = sz * (gq.pat ? zP - st : zP);
          box('block', MF.POST, gapLb, 'block-' + gq.n + (sz < 0 ? '-l' : '-r'), gq.x, yBM, zb0, gapL, p, p);
          for (var m2 = -1; m2 <= 1; m2 += 2) {
            scr('blockout', MF.SCREW, gq.xout + gq.sg * hp, yBM + m2 * MF.SCREW_OFF, zb0, [-gq.sg, 0, 0], len260);   /* through the outer beam */
            scr('blockmid', MF.SCREW, gq.xin - gq.sg * hp, yBM + m2 * MF.SCREW_OFF, zb0, [gq.sg, 0, 0], len260);    /* through the middle beam, from the other gap */
          }
        }
        slatZ.push([]);
      }
    } else {
      var nS = Math.max(2, Math.ceil(2 * zP / _mfU(s, 'SLAT_SP') - 1e-6) + 1), pitch = 2 * zP / (nS - 1);
      var lenToe = us ? 0.0635 : 0.060, ti = MF.TOE_IN, c45 = Math.SQRT1_2, tz = sw / 4;
      for (gi = 0; gi < gaps.length; gi++) {
        var gw = gaps[gi], zl = [];
        if (!gw.pat) for (j = 0; j < nS; j++) zl.push(-zP + j * pitch);
        else for (j = 0; j < nS - 1; j++) zl.push(-zP + (j + 0.5) * pitch);
        slatZ.push(zl);
        for (j = 0; j < zl.length; j++) {
          box('slat', MF.SLAT, gapLb, 'slat-' + gw.n + '-' + (j + 1), gw.x, yBM, zl[j], gapL, sh, sw);
          /* each end: the beam face it butts on (xf) and the way into the slat (si) */
          var ends = [[gw.x + gapL / 2, -1], [gw.x - gapL / 2, 1]], e2;
          for (e2 = 0; e2 < 2; e2++) {
            var xf = ends[e2][0], si = ends[e2][1];
            scr('slattoe', MF.TOE_SCREW, xf + si * ti, yBM + sh / 2, zl[j] - tz, [-si * c45, -c45, 0], lenToe, 0.0025);   /* from the top, down into the beam */
            scr('slattoe', MF.TOE_SCREW, xf + si * ti, yBM - sh / 2, zl[j] + tz, [-si * c45, c45, 0], lenToe, 0.0025);    /* from below, up into the beam, beside the first */
          }
        }
      }
    }
    /* THE WEAVE: a strip of shade cloth in each gap along Z, under the
       first slat, over the next ... (flat over a slat's width, a smooth turn
       between two); its outline in (z, y), extruded across the gap */
    var fabricM2 = 0, ft = MF.FAB_T, fwid = gapL - 2 * MF.FAB_CLR;
    if (weave) {
      var yOv = yBM + sh / 2 + ft / 2, yUn = yBM - sh / 2 - ft / 2, fl = sw / 2 + 0.004;
      for (gi = 0; gi < gaps.length; gi++) {
        var zz = slatZ[gi], pth = [], lenP = 0;
        for (j = 0; j < zz.length; j++) {
          var yj = (j % 2) ? yOv : yUn;
          if (j > 0) {
            var za = zz[j - 1] + fl, zb = zz[j] - fl, ya = ((j - 1) % 2) ? yOv : yUn;
            for (k = 1; k < 10; k++) { var tt = k / 10; pth.push([za + (zb - za) * tt, ya + (yj - ya) * (1 - Math.cos(Math.PI * tt)) / 2]); }
          }
          pth.push([zz[j] - fl, yj], [zz[j] + fl, yj]);
        }
        for (k = 1; k < pth.length; k++) lenP += Math.hypot(pth[k][0] - pth[k - 1][0], pth[k][1] - pth[k - 1][1]);
        var poly = [], m3;
        for (m3 = 0; m3 < pth.length; m3++) poly.push([pth[m3][0], pth[m3][1] + ft / 2]);
        for (m3 = pth.length - 1; m3 >= 0; m3--) poly.push([pth[m3][0], pth[m3][1] - ft / 2]);
        var area = fwid * (lenP + 2 * MF.FAB_TIE);
        fabricM2 += area;
        pieces.push({ kind: 'fabric', code: MF.FABRIC, len: 0, area: area, id: 'fabric-' + gaps[gi].n, poly: poly, plane: 'zy', c: gaps[gi].x, t: fwid });
      }
    }
    /* the bill's quantities: timber by code, the coating (every piece's long faces) */
    var mt = {}, coat = 0;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (pc.kind === 'fabric') continue;
      mt[pc.code] = (mt[pc.code] || 0) + pc.len;
      coat += (pc.kind === 'slat') ? 2 * (sw + sh) * pc.len : 4 * p * pc.len;
    }
    var r3 = function (v) { return Math.round(v * 1000) / 1000; };
    var nF = feet.length;
    return {
      P: Pr, us: us, seat: seat, L: seat.L, found: found, weave: weave, pieces: pieces, screws: screws, posts: posts, feet: feet, gscrews: gscrews, bases: bases,
      meters: mt, coat: coat, fabricM2: Math.round(fabricM2 * 100) / 100,
      cant: cant, leds: leds, psus: psus, ledM: Math.round(leds.reduce(function (a, l) { return a + l.len; }, 0) * 1000) / 1000, gw: gw, gd: gd,
      concreteM3: r3(nF * fw * fw * (fd + yF)), gravelM3: r3(nF * fw * fw * gv), digM3: r3(nF * fw * fw * (fd + gv)),
      d: d, gapL: gapL, zP: zP, beamL: beamL, postH: postH, slatZ: slatZ,
      yF: yF, yPB: yPB, yPT: yPT, yBM: yBM, yBT: yBT,
      nFr: nFr, height: yBT, depth: (nFr - 1) * d + p, length: beamL
    };
  }
  /* its staged assembly: the ground works, the U's, the posts, their nails;
     the top on the ground -- the middle beam, the blocks / slats with their
     screws through it, the front + back beams with theirs -- lifted on the
     posts and screwed down; the weave; then the sofa seat, its joints, its
     platform, its cushions and its hanging */
  var MF_SEAT_PARTS = ['post', 'rail-seat', 'rail-lower', 'rail-arm', 'rail-top-end', 'top-end-a', 'top-end-b', 'seat-rail-a', 'seat-rail-b', 'lower-side-a', 'lower-side-b', 'arm-side-a', 'arm-side-b', 'rail-mid', 'rail-mid-end', 'rail-back', 'rail-back-mid'];
  var MF_SEAT_STEPS = [
    { parts: MF_SEAT_PARTS, codes: ['KVH08080'] },
    { parts: ['dowel', 'dowel-hole', 'pocket-marker', 'screw-pocket'], codes: ['FAT00006', 'FAS50060'] },
    { parts: ['ledger', 'rost', 'screw-wood'], codes: ['KVH03838', 'TIM20100', 'FAS50060'] },
    { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-shank', 'swing-hw-eye', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: ['FAT00002', 'FAT00003', 'FAT00004', 'FAS60100'] },
    { parts: ['cushion', 'pillow'], codes: ['FOU00016'] }
  ];
  var MF_GROUND = [
    { parts: [], codes: [] },
    { parts: ['mf-footing', 'mf-gscrew'], codes: ['FEE00001', 'FCO00001', 'FCO00002', 'FGR00004'] },   /* the footings (their top drawn) or the ground screws */
    { parts: ['mf-base'], codes: ['FCO00004', 'FGR00002'] },
    { parts: ['mf-post'], codes: ['KVH16160'] },
    { parts: ['mf-hw-screw-basenail'], codes: ['FAS38038'] }
  ];
  /* the blocks: the top on the ground (the middle beam, the blocks and their
     screws through it, the outer beams and theirs), lifted, screwed down */
  var MF_STEPS = MF_GROUND.concat([
    { parts: ['mf-beam-mid'], codes: ['KVH16160'] },
    { parts: ['mf-block'], codes: ['KVH16160'] },
    { parts: ['mf-hw-screw-blockmid'], codes: ['FAS80260'] },
    { parts: ['mf-beam-out'], codes: ['KVH16160'] },
    { parts: ['mf-hw-screw-blockout'], codes: ['FAS80260'] },
    { parts: ['mf-hw-screw-beam'], codes: ['FAS80260'] }
  ]).concat(MF_SEAT_STEPS);
  /* v308 the LED top (3 portals, the outer ones one post short): the middle
     beam on its posts, the blocks against it, the outer beams on their post
     and the blocks, the M16 rods through, the screws down into the posts;
     then the LED profiles + strips in the grooves (routed before), the
     power supplies */
  var MF_STEPS_C = MF_GROUND.concat([
    { parts: ['mf-beam-mid'], codes: ['KVH16160'] },
    { parts: ['mf-block'], codes: ['KVH16160'] },
    { parts: ['mf-beam-out'], codes: ['KVH16160'] },
    { parts: ['mf-hw-bolt-block'], codes: ['FAT16010', 'FAT16001', 'FAT16002'] },
    { parts: ['mf-hw-screw-beam'], codes: ['FAS80260'] },
    { parts: ['mf-hw-ledprofile', 'mf-hw-led'], codes: ['EEC00006'] },
    { parts: ['mf-hw-ledpsu', 'mf-hw-screw-psu'], codes: ['EEC00007', 'FAS45070'] }
  ]).concat(MF_SEAT_STEPS);
  /* v302 the weave (5 portals): the beams on the posts and screwed down, the
     slats set in between with their toe screws, the cloth woven through */
  var MF_STEPS_W = MF_GROUND.concat([
    { parts: ['mf-beam-mid', 'mf-beam-out'], codes: ['KVH16160'] },
    { parts: ['mf-hw-screw-beam'], codes: ['FAS80260'] },
    { parts: ['mf-slat'], codes: ['KVH40060'] },
    { parts: ['mf-hw-screw-slattoe'], codes: ['FAS50060'] },
    { parts: ['mf-fabric'], codes: ['TST00003'] }
  ]).concat(MF_SEAT_STEPS);
  /* v269: the types on the sofa's assembly (exploded, pocket holes, the
     side frames, the top ends, the long rails, ledgers, platform): the
     sofa and the porch swing in the sofa style (+ chains, eyes, the beam) */
  function _isSofaAsm(s) { var v = ((s || STATE).variant | 0); return v === 2 || v === 14 || (v === 7 && PORCH.STYLE7 === 'sofa'); }   /* v273: + the bed */
  /* the porch swing's hanging parts in that assembly: chains, then the
     eyes (eye bolts in the posts, the hangers in the beam), then the beam */
  function _sofaHangGroup(pt) {
    if (pt === 'swing-hw-chain') return 'p-chain';
    if (pt === 'swing-hw-shank' || pt === 'swing-hw-eye' || pt === 'swing-hw-plate' || pt === 'swing-hw-rod' || pt === 'swing-hw-hanger' || pt === 'swing-hw-screw-hanger') return 'p-eye';
    if (pt === 'porch-context') return 'p-beam';
    if (pt === 'bed-mattress') return 'p-matt';   /* v273: the bed's mattress, last, from above */
    return '';
  }

  /* ------------------------------------------------------------------
     TYPE 14 -- BED (v273, Marek 2026-10-15: "udelej jeste 14 variantu,
     podobny konstrukce a spoje jako sofa, masivni profil ctvercoveho
     prurezu - postel; nastavit on / off celo postele, editace vysky cela,
     sirky postele; pevny lamelovy rost vsazeny v ramu, bila masivni
     matrace; krokovani sirky podle beznych sirek matrace"): the sofa's
     frame (_sofaFrame, its corner joints: 3 dowels + 2 pocket screws) in
     the sofa's 4x4 (KVH10100, US 3 1/2 in.): 4 legs, the side rails and
     the end rails; the headboard at the head (end A, -Z): the head posts
     up under its top rail, middle rails as it rises (v274: every opening
     over the mattress at most 30 cm, the rails evenly spaced, to 2.00 m);
     the slats screwed down on 2x2 ledgers inside the
     side rails a little below the rails' top (wide beds: + a centre rail
     on a centre leg, its top flush with the ledgers); a white mattress on
     the slats. The width steps through the common mattress widths
     (metric 80..200 x 200 cm, US Twin / Full / Queen / Cal King / King)
     on the drag point at the mattress's foot corner (v274), the drag point
     on the headboard sets its height. */
  var BED = {
    CODE: 'KVH10100', LEDGER_CODE: 'KVH03838', ROST_CODE: 'TIM20100',
    SCREW: 'FAS50060', DOWEL: 'FAT00006', MATT_CODE: 'FOU00016',
    MW: [0.80, 0.90, 1.00, 1.20, 1.40, 1.60, 1.80, 2.00], ML: 2.00, MW_DEF: 1.60,
    US: [[38, 75, 'Twin'], [54, 75, 'Full'], [60, 80, 'Queen'], [72, 84, 'Cal King'], [76, 80, 'King']], US_DEF: 2,
    CLEAR: 0.02,          /* the frame's inside over the mattress (1 cm a side) */
    RAIL: 0.35,           /* the side / end rails' top above the floor */
    OPEN_MIN: 0.10,       /* the headboard's lowest top rail: this much over the mattress */
    HEAD_DEF: 1.10, HEAD_MAX: 2.00,   /* v274: was 1.40 (Marek: celo i vyssi) */
    MID_FROM: 0.30,       /* the largest opening over the mattress: past it a middle rail more comes in (v274: any number) */
    CENTER_FROM: 1.05,    /* the inside width beyond which the slats get a centre rail + leg */
    /* v275 the headboard's infill (the info-bar toggle: rails > slats >
       crossed boards > off). Both thin, inside the 4x4's faces, on its
       axis, dowelled into the frame (1 dowel FAT00006 a piece end) */
    STYLES: ['rails', 'slats', 'cross'],
    SLAT_CODE: 'KVH03838', SLAT_GAP: 0.038,   /* 2x2 slats upright, a gap of about one slat (the sofa's slats) */
    CROSS_CODE: 'TIM20100',                   /* 1x4 boards, two layers (front leaning one way, back the other) */
    CROSS_ANG: [40, 60],                      /* the boards' angle off level, degrees -- each board its own */
    CROSS_GAP: [0.02, 0.09]                   /* the clear gap between neighbours of a layer, random in this band */
  };
  /* v275: the headboard's style -- 'off' without a headboard */
  function _bedStyle(s) {
    s = s || STATE;
    if (s.backrestVisible === false) return 'off';
    return (BED.STYLES.indexOf(s.bedHeadStyle) >= 0) ? s.bedHeadStyle : 'rails';
  }
  /* v275: the infill between the head posts, over the end rail, under the
     top rail (x -a..a, y y0..y1, z on the profile's axis zA):
       slats -- 2x2 upright, even gaps of about one slat;
       cross -- 1x4 boards in two layers either side of the axis, the front
       (+z, the mattress side) rising to +x, the back to -x; each board at
       its own angle in CROSS_ANG (a seeded walk, the same pattern every
       build), its neighbours spaced so no two boards of a layer touch over
       the opening's height; each board is the 100 band cut to the opening
       (a polygon), its length the long point; its centre line's two ends
       on the frame = its two dowels (axis x into a post, y into a rail). */
  function _bedInfill(style, a, y0, y1, zA, Pr) {
    var out = { style: style, slats: [], planks: [], slatM: 0, plankM: 0, dowels: 0, coat: 0 }, h = y1 - y0, i;
    if (h <= 0.02 || a <= 0.05) return out;
    if (style === 'slats') {
      var sw = Pr.ld, n = Math.max(2, Math.round((2 * a - BED.SLAT_GAP) / (sw + BED.SLAT_GAP)));
      var g = (2 * a - n * sw) / (n + 1);
      for (i = 0; i < n; i++) out.slats.push({ x: -a + g + sw / 2 + i * (sw + g), y0: y0, y1: y1, len: h, w: sw });
      out.slatM = n * h; out.dowels = 2 * n; out.coat = out.slatM * 4 * sw;
      return out;
    }
    if (style !== 'cross') return out;
    var rw = Pr.rw, rt = Pr.rt, ym = (y0 + y1) / 2, D2R = Math.PI / 180;
    var maxDc = Math.max(0.06, 0.20 / Math.max(h, 0.2));   /* the cot change neighbours may have: their extra spacing over the height stays <= 0.10 */
    function rng(seed) { var st = seed >>> 0; return function () { st = (st * 1664525 + 1013904223) >>> 0; return st / 4294967296; }; }
    function clipStrip(cxs, th) {   /* the rectangle cut by the band |n.(p - c)| <= rw / 2 */
      var nx = -Math.sin(th), ny = Math.cos(th), poly = [[-a, y0], [a, y0], [a, y1], [-a, y1]], k, sgn;
      for (k = 0; k < 2; k++) {
        sgn = k ? -1 : 1;
        var nxt = [], q;
        for (q = 0; q < poly.length; q++) {
          var P0 = poly[q], P1 = poly[(q + 1) % poly.length];
          var d0 = sgn * (nx * (P0[0] - cxs) + ny * (P0[1] - ym)) - rw / 2, d1 = sgn * (nx * (P1[0] - cxs) + ny * (P1[1] - ym)) - rw / 2;
          if (d0 <= 0) nxt.push(P0);
          if ((d0 < 0) !== (d1 < 0) && d0 !== d1) { var t = d0 / (d0 - d1); nxt.push([P0[0] + t * (P1[0] - P0[0]), P0[1] + t * (P1[1] - P0[1])]); }
        }
        poly = nxt;
        if (poly.length < 3) return null;
      }
      return poly;
    }
    for (var layer = 0; layer < 2; layer++) {
      var R = rng(layer ? 40961 : 7919), th = (BED.CROSS_ANG[0] + BED.CROSS_ANG[1]) / 2 * D2R, guard = 0;
      var lo = BED.CROSS_ANG[0] * D2R, hi = BED.CROSS_ANG[1] * D2R;
      var w = rw / Math.sin(th), x = -a - (h / 2) / Math.tan(th) - w / 2 - BED.CROSS_GAP[0];
      var zL = zA + (layer ? -1 : 1) * rt / 2, mir = layer ? -1 : 1;
      while (guard++ < 200) {
        /* the next board's angle: a step either way, the cot change capped */
        var lim = maxDc * Math.sin(th) * Math.sin(th), stp = (0.45 + 0.55 * R()) * lim * (R() < 0.5 ? -1 : 1);
        var th2 = th + stp; if (th2 < lo || th2 > hi) th2 = th - stp;
        th2 = Math.max(lo, Math.min(hi, th2));
        var w2 = rw / Math.sin(th2), dc = Math.abs(1 / Math.tan(th2) - 1 / Math.tan(th));
        var gap = BED.CROSS_GAP[0] + R() * (BED.CROSS_GAP[1] - BED.CROSS_GAP[0]);
        x += (w + w2) / 2 + (h / 2) * dc + gap; th = th2; w = w2;
        if (x - (h / 2) / Math.tan(th) - w / 2 > a) break;   /* past the opening at its foot: done */
        var poly = clipStrip(x, th);
        if (!poly) continue;
        var area = 0, q2;
        for (q2 = 0; q2 < poly.length; q2++) { var A0 = poly[q2], A1 = poly[(q2 + 1) % poly.length]; area += A0[0] * A1[1] - A1[0] * A0[1]; }
        if (Math.abs(area) / 2 < 0.003) continue;   /* a sliver at a corner: left out */
        /* the centre line through (x, ym) at th inside the rectangle: its ends */
        var dx = Math.cos(th), dy = Math.sin(th), tA = -1e9, tB = 1e9;
        var tx0 = (-a - x) / dx, tx1 = (a - x) / dx, ty0 = (y0 - ym) / dy, ty1 = (y1 - ym) / dy;
        tA = Math.max(Math.min(tx0, tx1), Math.min(ty0, ty1)); tB = Math.min(Math.max(tx0, tx1), Math.max(ty0, ty1));
        if (!(tB - tA > 0.08)) continue;
        var ends = [tA, tB].map(function (t) {
          var px = x + t * dx, py = ym + t * dy, ax = (Math.abs(Math.abs(px) - a) < 1e-6) ? 'x' : 'y';
          return { x: mir * px, y: py, axis: ax };
        });
        var pmin = 1e9, pmax = -1e9;
        for (q2 = 0; q2 < poly.length; q2++) { var pr = poly[q2][0] * dx + poly[q2][1] * dy; if (pr < pmin) pmin = pr; if (pr > pmax) pmax = pr; }
        var len = pmax - pmin;
        out.planks.push({ poly: poly.map(function (pp) { return [mir * pp[0], pp[1]]; }), z: zL, t: rt, len: len, ang: Math.round((layer ? 180 - th / D2R : th / D2R) * 10) / 10, ends: ends, layer: layer });
        out.plankM += len; out.dowels += 2; out.coat += len * 2 * (rt + rw);
      }
    }
    return out;
  }
  /* the profile (square post / rail), the 2x2 ledger, the 1x4 slat, how
     far the slats sit below the rails' top, the mattress */
  function _bedProf(s) {
    if ((s || STATE).isMetric === false) return { P: 0.0889, ld: 0.0381, rt: 0.01905, rw: 0.0889, rc: 0.0254, mt: 0.254 };
    return { P: 0.100, ld: 0.038, rt: 0.020, rw: 0.100, rc: 0.030, mt: 0.25 };
  }
  /* the mattress sizes of the units, narrow to wide: { w, l, n } in metres */
  function _bedSizes(s) {
    var out = [], i, IN = 0.0254;
    if ((s || STATE).isMetric === false) {
      for (i = 0; i < BED.US.length; i++) out.push({ w: BED.US[i][0] * IN, l: BED.US[i][1] * IN, n: BED.US[i][2] + ' ' + BED.US[i][0] + ' x ' + BED.US[i][1] + ' in' });
    } else {
      for (i = 0; i < BED.MW.length; i++) out.push({ w: BED.MW[i], l: BED.ML, n: Math.round(BED.MW[i] * 100) + ' x ' + Math.round(BED.ML * 100) + ' cm' });
    }
    return out;
  }
  /* the active mattress: the size nearest STATE.bedMW (switching the units
     lands on the nearest size of the other system) */
  function _bedSize(s) {
    s = s || STATE;
    var sz = _bedSizes(s), w = +s.bedMW, best = 0, i;
    if (!isFinite(w) || w <= 0) w = (s.isMetric === false) ? sz[BED.US_DEF].w : BED.MW_DEF;
    for (i = 1; i < sz.length; i++) if (Math.abs(sz[i].w - w) < Math.abs(sz[best].w - w) - 1e-9) best = i;
    sz[best].i = best;
    return sz[best];
  }
  function _bedLayout(s) {
    s = s || STATE;
    var Pr = _bedProf(s), P = Pr.P, ms = _bedSize(s);
    var hb = (s.backrestVisible !== false);
    var innerW = ms.w + BED.CLEAR, innerL = ms.l + BED.CLEAR, W = innerW + 2 * P, L = innerL + 2 * P;
    var seatTop = BED.RAIL, ledTop = seatTop - Pr.rc - Pr.rt;   /* the slats' underside */
    var mattBot = ledTop + Pr.rt, mattTop = mattBot + Pr.mt;
    var headMin = mattTop + BED.OPEN_MIN + P;
    var hv = +s.bedHead; if (!isFinite(hv) || hv <= 0) hv = BED.HEAD_DEF;
    var top = hb ? Math.max(headMin, Math.min(BED.HEAD_MAX, hv)) : seatTop;
    var open = hb ? (top - P - mattTop) : 0;
    /* v274: the headboard's openings -- as few as keep each at most MID_FROM
       (one more each time the drag passes MID_FROM + P of rise), the middle
       rails' tops evenly spaced between the mattress and the top rail, so
       the openings are equal (2 openings = the v273 middle rail exactly) */
    var style = _bedStyle(s);   /* v275: rails (middle rails as below), slats, cross; the infill styles have no middle rails */
    var nOpen = (style === 'rails') ? Math.max(1, Math.ceil((top - mattTop) / (BED.MID_FROM + P) - 1e-6)) : (hb ? 1 : 0);
    var mids = [], mk;
    for (mk = 1; mk < nOpen; mk++) mids.push(mattTop + mk * (top - mattTop) / nOpen);
    var nMid = mids.length, lvl2 = nMid > 0;
    var mid = lvl2 ? mids[0] : null;               /* the lowest middle rail's top (the sofa frame's single-row hook) */
    var centerRail = innerW > BED.CENTER_FROM;
    var crCY = ledTop - P / 2;                     /* the centre rail: its top flush with the ledgers' */
    var crDY = (seatTop - P + ledTop) / 2;         /* its dowels: in the band it shares with the end rails */
    var clH = centerRail ? (ledTop - P) : 0;       /* the centre leg: the floor to the centre rail */
    var postA = hb ? (top - P) : seatTop, postB = seatTop;
    var ledN = Math.max(2, Math.floor(innerL / 0.30) + 1);
    var rcc = Pr.rw + SOFA.ROST_GAP, rSpan = Math.max(Pr.rw, innerL - Pr.rw), rN = Math.max(2, Math.floor(rSpan / rcc) + 1);
    /* the corner joints, 3 dowels + 2 pocket screws each (as the sofa):
       the end rails 4, the side rails 4, the headboard's top rail 2, each
       middle rail 2; the centre rail and the centre leg: dowels only (the
       leg carries it) */
    var frameJoints = 8 + (hb ? 2 : 0) + 2 * nMid;
    var frameM = 2 * postA + 2 * postB + 2 * innerL + 2 * innerW + (hb ? W : 0) + nMid * innerW + (centerRail ? innerL + clH : 0);
    var dowels = frameJoints * SOFA.DOWEL_PER_JOINT + (centerRail ? 3 * SOFA.DOWEL_PER_JOINT : 0);
    var ledM = 2 * innerL, rostM = rN * innerW, slatScrews = rN * 2 * (centerRail ? 3 : 2);
    var coat = frameM * 4 * P + ledM * 4 * Pr.ld + rostM * 2 * (Pr.rt + Pr.rw);
    /* v275: the headboard's infill, between the head posts' inner faces,
       from the end rail's top to the top rail's underside, on the axis */
    var fill = _bedInfill(style, innerW / 2, seatTop, top - P, -L / 2 + P / 2, Pr);
    dowels += fill.dowels; coat += fill.coat;
    return {
      bed: true, style: 'bed', headboard: hb, Pr: Pr, P: P, code: BED.CODE, rostCode: BED.ROST_CODE, SCREW: BED.SCREW,
      size: ms, L: L, W: W, H: top, yB: 0, seatTop: seatTop, top: top, lvl2: lvl2, mid: mid, mids: mids, nOpen: nOpen, open: open,
      headStyle: style, fill: fill, slatM: fill.slatM, plankM: fill.plankM, fillDowels: fill.dowels,
      headMin: headMin, innerL: innerL, innerW: innerW, postA: postA, postB: postB,
      ledTop: ledTop, ledN: ledN, ledM: ledM, rN: rN, rostM: rostM,
      centerRail: centerRail, centerLeg: centerRail, crCY: crCY, crDY: crDY, clH: clH,
      frameJoints: frameJoints, frameM: frameM, dowels: dowels, pocketScrews: frameJoints * 2,
      ledgerScrews: 2 * ledN, slatScrews: slatScrews,
      matt: { w: ms.w, l: ms.l, t: Pr.mt, y: mattBot }, mattTop: mattTop,
      cushion: false, matN: 0, pillowN: 0, coat: coat,
      depth: W, xMin: -W / 2, xMax: W / 2
    };
  }

  /* ------------------------------------------------------------------
     TYPE 8 -- A-FRAME SWING (Marek 2026-10-13: "B bude fork Hollywood
     swing"): the Hollywood swing's stand and roof (_swingStand: X-frames,
     beam, rails, knee braces, gable / mono roof, pitch slider) with the
     porch swing's seat (_porchLayout, hangers at x = 0 under the beam,
     the back tilting down to a bed). The renderer and the bill are the
     swing's (_buildSwing / _computeSwing) with the seat swapped. */
  function _frameLayout(s) {
    s = s || STATE;
    var P = _swingProf(s);
    var seat = _porchLayout(s, { H: SWING.BEAM_BOT, ringAt0: true });
    var roofRun = Math.max(SWING.ROOF_RUN, Math.max(-seat.xMin, seat.xMax) + 0.06 - 0.05);
    var stand = _swingStand(s, P, seat.L / 2 + seat.sec.t + SWING.SIDE_GAP + P.leg / 2, roofRun);
    return {
      P: P, L: seat.L, seat: seat, beta: seat.beta, cushion: seat.cushion,
      beamBot: stand.beamBot, beamTop: stand.beamTop, beamLen: stand.beamLen, zA: stand.zA, wh: stand.wh, legs: stand.legs, yX: stand.yX,
      rails: stand.rails, braces: stand.braces, roof: stand.roof,
      hangers: seat.hangers, eyes: seat.eyeF.concat(seat.eyeR), chains: seat.chains,
      seatTopY: seat.armTop, seatXMin: seat.xMin, seatXMax: seat.xMax,
      depth: stand.depth, height: stand.height
    };
  }
  /* the A-frame swing's build order: the stand and the roof as the
     Hollywood swing, then the porch seat, then it is hung */
  var FRAME_STEPS = [
    { parts: [], codes: [] },
    SW_STAND[0], SW_STAND[1], SW_STAND[2], SW_STAND[3], SW_ROOF[0], SW_ROOF[1], SW_ROOF[2],
  ].concat(PORCH_SEAT_STEPS).concat([   /* v300 the seat's 12 steps */
    { parts: ['cushion'], codes: ['FOU00016'] }
  ]);
  /* the stand's share of a bill (types 4, 8, 13): legs + rails, beam,
     knee braces, the crossing rods with nuts / washers / cap nuts, screws */
  function _swingStandBoQ(g, add) {
    var i, legMeters = 0, railMeters = 0, braceMeters = 0;
    for (i = 0; i < g.legs.length; i++)   legMeters += g.legs[i].len;
    for (i = 0; i < g.rails.length; i++)  railMeters += g.rails[i].len;
    for (i = 0; i < g.braces.length; i++) braceMeters += g.braces[i].len;
    add(SWING.LEG_CODE, legMeters + railMeters);                         /* KVH10100 */
    add(SWING.BEAM_CODE, g.beamLen);                                     /* KVH10200 */
    add(SWING.BRACE_CODE, braceMeters);                                  /* KVH40060 */
    var nX = g.legs.length / 2;                                          /* the crossings */
    add(SWING.ROD_CODE, nX * SWING.ROD_LEN);                             /* FAT16010 M16 rod */
    add(SWING.NUT_CODE, nX * 2);                                         /* FAT16011 */
    add(SWING.WASHER_CODE, nX * 4);                                      /* FAT16001 */
    add(SWING.CAPNUT_CODE, nX * 4);                                      /* FAT16002 */
    add(SWING.BEAM_SCREW, nX * 2);                                       /* FAS80260 beam into the crossings */
    add(SWING.LEG_SCREW, g.rails.length * 4);                            /* FAS80180: rail ends, 2 each */
    add(SWING.KNEE_SCREW, g.braces.length * 2);                          /* FAS80160 knee braces to the legs */
    add(SWING.KNEE_SCREW2, g.braces.length);                             /* FAS60080 knee braces to the beam */
    return { legMeters: legMeters, railMeters: railMeters, braceMeters: braceMeters, nX: nX };
  }
  /* the porch seat's share of a bill (types 7 and 8): timber, screws,
     bolts, eye bolts, hangers, chains, the mattress, the coating */
  function _porchSeatBoQ(g, add) {
    var i, nJ = g.nJ;
    add(PORCH.FRAME_CODE, g.frameM + g.plankM);                        /* KVH10060: frame, arms, back frame, all planks */
    /* v300: the screws = the drawn list (g.screws): FAS50060 2 a plank a
       bearer, FAS80100 2 a rail / joist / stretcher end, FAS60100 2 a post top */
    var sc = {}, deck;
    for (i = 0; i < g.screws.length; i++) sc[g.screws[i].code] = (sc[g.screws[i].code] || 0) + 1;
    deck = sc[PORCH.DECK_SCREW] || 0;
    add(PORCH.DECK_SCREW, deck);                                       /* FAS50060 */
    add(PORCH.FRAME_SCREW, sc[PORCH.FRAME_SCREW] || 0);                /* FAS80100 */
    add(PORCH.ARM_SCREW, sc[PORCH.ARM_SCREW] || 0);                    /* FAS60100 */
    add(PORCH.ARM_BACK_SCREW, sc[PORCH.ARM_BACK_SCREW] || 0);          /* FAS45070 v307 the armrests into the back stiles */
    add(PORCH.BOLT_CODE, g.bolts.length);                              /* FAT10002: arm posts to the side rails */
    add(SWING.EYE_CODE, g.eyeF.length + g.eyeR.length);                /* FAT00003 */
    add(SWING.HANGER_CODE, g.hangers.length);                          /* FAT00002 */
    add(SWING.HANGER_SCREW, g.hangers.length * 2);                     /* FAS60160 */
    var chainM = 0;
    for (i = 0; i < g.chains.length; i++) chainM += g.chains[i].len + PORCH.CHAIN_SPARE;
    add(SWING.CHAIN_CODE, chainM);                                     /* FAT00004 */
    if (g.cushion) add('FOU00016', 1);                                 /* the mattress */
    var coat = (g.frameM + g.plankM) * 2 * (g.sec.t + g.sec.w);
    add(SWING.COAT_CODE, coat);                                        /* MFP00002, every timber face */
    add(CAT_NEW.STRAP_HINGE, g.hinges.length);                         /* FAT00022 strap hinges: the back to the seat (v258) */
    return { deck: deck, bolts: g.bolts.length, coat: coat, missing: [] };
  }

  /* ------------------------------------------------------------------
     TYPE 9 -- ADIRONDACK (chair / loveseat / 3-seater; width = persons).
     The classic Westport shape in US lumber:
       - per seat two 2x6 seat stringers (KVH60120) sloping 14 deg down to
         the back, the rear end cut flat on the ground, the front end
         bolted (FAT10002, 2 per joint) to a 2x6 front leg outside it
         that rises to the arm; a 2x4 apron (KVH10060) across the front
       - 1x4 seat slats (TIM20100) on the stringers, 1x4 back slats
         leaning back (the tilt slider, 15..35 deg from vertical, default
         25) against a 2x4 lower back support between the stringers and a
         2x4 upper back support across the whole width at the arms; the
         slat tops cut to an arc per seat
       - arms (TIM45120, flat) from 60 past the front leg to the upper
         support, a 2x4 arm brace under each outer arm on the leg
       - 2 or 3 seats share the middle legs and arms (a seat each side)
     Sections follow the units (US actual sizes in imperial, as the swing).
     The level button = the kids' size (x 0.75, the same lumber).
     X = depth (front +), Y = up, Z = width. _adiLayout(STATE) is the
     single source: the renderer draws its pieces, the BoQ sums them. */
  var ADI = {
    SEAT_W: 0.56,          /* slat length per person */
    L_MIN: 0.50, L_MAX: 1.80, L_DEFAULT: 0.56,
    BACK_MIN: 15, BACK_MAX: 35, BACK_DEF: 25,
    STR_LEN: 0.90, ALPHA: 14,
    SEAT_D: 0.50, SLAT_GAP: 0.008, BACK_GAP: 0.012,
    BACK_MID: 0.92, BACK_EDGE: 0.80,
    ARM_TOP: 0.58, ARM_OVER: 0.09,
    BRACE_H: 0.16,
    KID: 0.75,
    STR_CODE: 'KVH60120', FRAME_CODE: 'KVH10060', SLAT_CODE: 'TIM20100', ARM_CODE: 'TIM45120',
    BOLT: 'FAT10002', SLAT_SCREW: 'FAS50060', SCREW: 'FAS60100', MID_SCREW: 'FAS80100'
  };
  function _adiBack(s) {
    var b = +((s || STATE).adiBack);
    if (!isFinite(b)) b = ADI.BACK_DEF;
    return Math.max(ADI.BACK_MIN, Math.min(ADI.BACK_MAX, b));
  }
  function _adiRange(s) {
    var k = ((s || STATE).lvl === 2) ? ADI.KID : 1;
    return { min: Math.round(ADI.L_MIN * k * 100) / 100, max: Math.round(ADI.L_MAX * k * 100) / 100 };
  }
  function _adiProf(s) {
    if ((s || STATE).isMetric === false) {
      return { st: 0.0381, sh: 0.1397, ft: 0.0381, fh: 0.0889, bt: 0.01905, bw: 0.0889, at: 0.0381, aw: 0.1397 };
    }
    return { st: 0.060, sh: 0.120, ft: 0.060, fh: 0.100, bt: 0.020, bw: 0.100, at: 0.045, aw: 0.120 };
  }
  function _adiLayout(s) {
    s = s || STATE;
    var P = _adiProf(s), k = (s.lvl === 2) ? ADI.KID : 1, i, j, q;
    var R = _adiRange(s), L = Math.max(R.min, Math.min(R.max, (+s.L) || ADI.L_DEFAULT * k));
    var N = Math.max(1, Math.min(3, Math.round(L / (ADI.SEAT_W * k)))), Ws = L / N;
    var D2R = Math.PI / 180, al = ADI.ALPHA * D2R, sa = Math.sin(al), ca = Math.cos(al);
    var gam = _adiBack(s) * D2R, sg = Math.sin(gam), cg = Math.cos(gam), tg = Math.tan(gam);
    var len = ADI.STR_LEN * k, armTop = ADI.ARM_TOP * k, armBot = armTop - P.at;
    var pieces = [];
    function box(kind, code, cut, id, x, y, z, sx, sy, sz, rz) { pieces.push({ kind: kind, code: code, len: cut, id: id, box: [x, y, z, sx, sy, sz, rz || 0] }); }
    function poly(kind, code, cut, id, pts, z, d) { pieces.push({ kind: kind, code: code, len: cut, id: id, poly: pts, z: z, d: d }); }
    /* the stringer's top front corner F; its bottom-rear corner on the ground */
    var F = { x: 0, y: len * sa + P.sh * ca };
    var dX = -ca, dY = -sa;                     /* down the stringer, to the back */
    var nUx = -sa, nUy = ca;                    /* its up normal */
    function onTop(t, h) { return { x: F.x + t * dX + h * nUx, y: F.y + t * dY + h * nUy }; }
    var B2 = { x: F.x + P.sh * sa, y: F.y - P.sh * ca };            /* bottom front */
    var T = { x: F.x - len * ca, y: F.y - len * sa };                /* top rear */
    var xg = B2.x - B2.y / Math.tan(al);                             /* the bottom edge meets the ground */
    var strPts = [[F.x, F.y], [B2.x, B2.y], [xg, 0], [T.x, 0], [T.x, T.y]];
    /* along z: legs and seats alternate, legs at both ends */
    var Wt = N * Ws + (N + 1) * P.st, legZ = [], seatZ = [];
    for (i = 0; i <= N; i++) legZ.push(-Wt / 2 + P.st / 2 + i * (Ws + P.st));
    for (i = 0; i < N; i++) seatZ.push(-Wt / 2 + P.st + Ws / 2 + i * (Ws + P.st));
    var xLF = F.x;                              /* the legs' front face = the stringers' front end */
    var bolts = [], nBolt = 0, nMidScrew = 0;
    for (i = 0; i < N; i++) {
      for (j = -1; j <= 1; j += 2) {
        var zs = seatZ[i] + j * (Ws / 2 - P.st / 2);
        poly('stringer', ADI.STR_CODE, len + 0.03, 'stringer-' + (i + 1) + (j < 0 ? 'l' : 'r'), strPts, zs, P.st);
        var outerSide = (j < 0 && i === 0) || (j > 0 && i === N - 1);
        if (outerSide) {
          nBolt += 2;
          for (q = 0; q < 2; q++) bolts.push({ x: xLF - P.sh / 2 + (q ? 0.025 : -0.025), y: F.y - P.sh / 2 + (q ? 0.02 : -0.02), z: zs + j * (P.st / 2 + P.st) });
        } else nMidScrew += 2;                  /* a middle leg: 2 x 8x100 from each stringer */
      }
    }
    /* the apron across the front of the legs, under the front slat */
    box('apron', ADI.FRAME_CODE, Wt, 'apron', F.x + P.ft / 2, F.y - 0.02 - P.fh / 2, 0, P.ft, P.fh, Wt);
    for (i = 0; i <= N; i++) box('leg', ADI.STR_CODE, armBot, 'front-leg-' + (i + 1), xLF - P.sh / 2, armBot / 2, legZ[i], P.sh, armBot, P.st);
    /* seat slats along the stringer top from the front */
    var nS = Math.max(3, Math.floor((ADI.SEAT_D * k + ADI.SLAT_GAP) / (P.bw + ADI.SLAT_GAP))), sEnd = 0;
    for (i = 0; i < N; i++) {
      for (j = 0; j < nS; j++) {
        var tc = 0.01 + P.bw / 2 + j * (P.bw + ADI.SLAT_GAP), c = onTop(tc, P.bt / 2);
        box('seat', ADI.SLAT_CODE, Ws, 'seat-slat-' + (i + 1) + '-' + (j + 1), c.x, c.y, seatZ[i], P.bw, P.bt, Ws, al);   /* local x along the stringer top (up to the front) */
        sEnd = tc + P.bw / 2;
      }
    }
    /* the back slats' front face starts on the stringer top behind the seat */
    var B0 = onTop(sEnd + 0.012, 0);
    function xFront(y) { return B0.x - (y - B0.y) * tg; }
    function xBackF(y) { return xFront(y) - P.bt / cg; }
    /* v261 (Marek: the rear supports were not structurally right, the back
       slats not anchored at the bottom). Along the back plane: u up from
       B0, FF(u) on the slats' front face, nB = behind the slats.
       LOWER SUPPORT: a 2x4 BETWEEN the stringers, tilted to the back plane,
       its front face flush with the slats' back, as high as fits inside the
       stringers' depth; screwed through each stringer into its ends. The
       back slats run DOWN between the stringers to its bottom edge and are
       screwed into it -- that is where they are anchored.
       UPPER SUPPORT: a 2x4 tilted to the back plane too (flush with the
       slats, not touching them on one edge), its top bevel-ripped level so
       the arms sit flat on it; the slats screwed into its face, the arms
       screwed down into it. */
    var aUx = -sg, aUy = cg, nBx = -cg, nBy = -sg;
    function FF(u, v) { v = v || 0; return { x: B0.x + u * aUx + v * nBx, y: B0.y + u * aUy + v * nBy }; }
    function yStrTop(x) { return F.y + (x - F.x) * (sa / ca); }
    var yStrDepth = P.sh / ca, mIn = 0.006, uT = -0.004, bestU = -0.004, bestM = -1e9, uq;
    for (uq = -0.004; uq > -0.30; uq -= 0.002) {
      var cs4 = [FF(uq, P.bt), FF(uq - P.fh, P.bt), FF(uq, P.bt + P.ft), FF(uq - P.fh, P.bt + P.ft)], mm = 1e9, c4;
      for (c4 = 0; c4 < 4; c4++) {
        var yt4 = yStrTop(cs4[c4].x);
        mm = Math.min(mm, (yt4 - cs4[c4].y) - mIn, (cs4[c4].y - (yt4 - yStrDepth)) - mIn);
      }
      if (mm >= 0) { uT = uq; bestM = mm; break; }
      if (mm > bestM) { bestM = mm; bestU = uq; }
    }
    if (bestM < 0) uT = bestU;
    var uB = uT - P.fh, uLc = uT - P.fh / 2;                              /* the slats' bottom = the support's bottom */
    var cL = FF(uLc, P.bt + P.ft / 2), lowLen = Ws - 2 * P.st;
    for (i = 0; i < N; i++) box('support-low', ADI.FRAME_CODE, lowLen, 'lower-back-support-' + (i + 1), cL.x, cL.y, seatZ[i], P.ft, P.fh, lowLen, gam);
    /* the upper support: front-top A on the slats' back at the arms'
       underside, the level top back to the rear face, P.fh down the front */
    var uA = (armBot - B0.y + P.bt * sg) / cg;                           /* FF(uA, bt).y = armBot */
    var usA = FF(uA, P.bt), usB = { x: usA.x - P.ft / cg, y: armBot };
    var usC = FF(uA - P.fh, P.bt), usD = FF(uA - P.fh, P.bt + P.ft);
    var Wo = Wt + 2 * (P.aw - P.st);           /* over the outer arms */
    poly('support-up', ADI.FRAME_CODE, Wo, 'upper-back-support', [[usA.x, usA.y], [usC.x, usC.y], [usD.x, usD.y], [usB.x, usB.y]], 0, Wo);
    var uUc = uA - P.fh / 2 - P.ft * tg / 2;                              /* the middle of its front face below the bevel */
    var xUS = (usA.x + usB.x) / 2;
    /* back slats per seat: BETWEEN the stringers (they run down to the lower
       support), the tops on an arc */
    var backTop = 0, nBack = 0, slatIn = P.st + 0.004, bz0 = [], bz1 = [];
    for (i = 0; i < N; i++) {
      var z0 = seatZ[i] - Ws / 2 + slatIn, z1 = seatZ[i] + Ws / 2 - slatIn, wz = z1 - z0;
      bz0.push(z0); bz1.push(z1);
      var nb = Math.max(3, Math.round((wz + ADI.BACK_GAP) / (P.bw + ADI.BACK_GAP))), zc = (z0 + z1) / 2;
      for (j = 0; j < nb; j++) {
        var zz = z0 + P.bw / 2 + (nb > 1 ? j * (wz - P.bw) / (nb - 1) : (wz - P.bw) / 2);
        var r = (zz - zc) / (wz / 2), lb = (ADI.BACK_EDGE + (ADI.BACK_MID - ADI.BACK_EDGE) * (1 - r * r)) * k;
        var cB = FF((lb + uB) / 2, P.bt / 2);
        box('back', ADI.SLAT_CODE, lb - uB, 'back-slat-' + (i + 1) + '-' + (j + 1), cB.x, cB.y, zz, P.bt, lb - uB, P.bw, gam);
        if (B0.y + lb * cg > backTop) backTop = B0.y + lb * cg;
        nBack++;
      }
    }
    /* arms: flat, from ARM_OVER past the leg front to just behind the upper support */
    var xArmF = xLF + ADI.ARM_OVER * k, xArmB = usB.x - 0.02, armL = xArmF - xArmB;
    for (i = 0; i <= N; i++) {
      var outer = (i === 0 || i === N), sgn = (i === 0) ? -1 : 1;
      var za = outer ? (legZ[i] + sgn * (P.aw / 2 - P.st / 2)) : legZ[i];   /* outer arms flush with the leg inside, out past it */
      box('arm', ADI.ARM_CODE, armL, 'arm-' + (i + 1), (xArmF + xArmB) / 2, armTop - P.at / 2, za, armL, P.at, P.aw);
      if (outer) {
        var zb = legZ[i] + sgn * (P.st / 2 + P.ft / 2), bh = ADI.BRACE_H * k;
        poly('brace', ADI.FRAME_CODE, 0.20 * k, 'arm-brace-' + (i === 0 ? 'l' : 'r'),
             [[xLF, armBot], [xLF - P.fh, armBot], [xLF - 0.03, armBot - bh], [xLF, armBot - bh]], zb, P.ft);
      }
    }
    /* v260 THE SCREWS, drawn and counted (as the picnic set): head point on
       the face, dir into the wood; kind = its assembly step + code */
    var screws = [];
    function scr(kind, x, y, z, dx, dy, dz, ln) { screws.push({ kind: kind, x: x, y: y, z: z, dir: [dx, dy, dz], len: ln || 0.10 }); }
    for (i = 0; i < N; i++) for (j = -1; j <= 1; j += 2) {
      var zsI = seatZ[i] + j * (Ws / 2 - P.st / 2);
      if ((j < 0 && i === 0) || (j > 0 && i === N - 1)) continue;
      for (q = 0; q < 2; q++) scr('mid', xLF - P.sh / 2 + (q ? 0.025 : -0.025), F.y - P.sh / 2 + (q ? -0.02 : 0.02), zsI - j * P.st / 2, 0, 0, j);   /* 8x100 through the stringer into the middle leg */
    }
    for (i = 0; i <= N; i++) for (q = -1; q <= 1; q += 2) scr('apron', F.x + P.ft, F.y - 0.02 - P.fh / 2 + q * 0.025, legZ[i], -1, 0, 0);   /* the apron into each leg */
    var nUp = [nUx, nUy], alongS = [ca, sa];
    for (i = 0; i < N; i++) for (j = 0; j < nS; j++) {
      var tcS = 0.01 + P.bw / 2 + j * (P.bw + ADI.SLAT_GAP), cS = onTop(tcS, P.bt);
      for (var e2 = -1; e2 <= 1; e2 += 2) for (q = -1; q <= 1; q += 2)
        scr('seat', cS.x + q * (P.bw / 4) * alongS[0], cS.y + q * (P.bw / 4) * alongS[1], seatZ[i] + e2 * (Ws / 2 - P.st / 2), -nUp[0], -nUp[1], 0, 0.06);
    }
    for (i = 0; i < N; i++) for (e2 = -1; e2 <= 1; e2 += 2) for (q = -1; q <= 1; q += 2) {
      var pLs = FF(uLc + q * 0.025, P.bt + P.ft / 2);
      scr('lowsup', pLs.x, pLs.y, seatZ[i] + e2 * Ws / 2, 0, 0, -e2);    /* v261: through the stringer into the lower support's end */
    }
    for (i = 0; i <= N; i++) {
      var zaS = (i === 0) ? (legZ[0] - (P.aw / 2 - P.st / 2)) : (i === N ? (legZ[N] + (P.aw / 2 - P.st / 2)) : legZ[i]);
      for (q = -1; q <= 1; q += 2) {
        scr('arm', xLF - P.sh / 2 + q * 0.03, armTop, legZ[i], 0, -1, 0);   /* the arm into the leg top */
        scr('arm', xUS + q * 0.015, armTop, zaS, 0, -1, 0);                  /* the arm into the upper support */
      }
      if (i === 0 || i === N) {
        var sgnB = (i === 0) ? -1 : 1, zbS = legZ[i] + sgnB * (P.st / 2 + P.ft / 2), bhS = ADI.BRACE_H * k;
        for (q = -1; q <= 1; q += 2) {
          scr('arm', xLF - 0.035 + q * 0.015, armTop, zbS, 0, -1, 0);                 /* the arm into the brace */
          scr('arm', xLF - 0.03, armBot - bhS * 0.45 + q * 0.03, zbS + sgnB * P.ft / 2, 0, 0, -sgnB);   /* the brace into the leg */
        }
      }
    }
    for (i = 0; i < N; i++) {
      var z0S = bz0[i], z1S = bz1[i], wzS = z1S - z0S;
      var nbS = Math.max(3, Math.round((wzS + ADI.BACK_GAP) / (P.bw + ADI.BACK_GAP)));
      for (j = 0; j < nbS; j++) {
        var zzS = z0S + P.bw / 2 + (nbS > 1 ? j * (wzS - P.bw) / (nbS - 1) : (wzS - P.bw) / 2);
        var us2 = [uLc, uUc];   /* v261: into the lower and the upper support, mid face */
        for (var yk = 0; yk < 2; yk++) for (q = -1; q <= 1; q += 2) { var pBs = FF(us2[yk], 0); scr('back', pBs.x, pBs.y, zzS + q * P.bw / 4, -cg, -sg, 0, 0.06); }
      }
    }
    /* centre the footprint on x = 0 */
    var xMax = Math.max(xArmF, F.x + P.ft), xMin = Math.min(T.x, usD.x, usB.x, xArmB, B0.x - (ADI.BACK_MID * k) * sg - P.bt * cg);
    var off = -(xMin + xMax) / 2;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      if (pc.box) pc.box[0] += off;
      else pc.poly = pc.poly.map(function (pp) { return [pp[0] + off, pp[1]]; });
    }
    for (i = 0; i < bolts.length; i++) bolts[i].x += off;
    for (i = 0; i < screws.length; i++) screws[i].x += off;
    var nArms = N + 1, nBraces = 2;
    /* v263: a throw pillow per seat, on the slats against the back */
    var pillows = [];
    for (i = 0; i < N; i++) pillows.push({ n: 1, z0: bz0[i] + 0.02, z1: bz1[i] - 0.02, seatY: B0.y + P.bt + 0.004, backX: B0.x - P.bt * tg + off, beta: gam });
    return {
      P: P, k: k, L: L, N: N, Ws: Ws, Wt: Wt, outerW: Wt + 2 * (P.aw - P.st), gamma: _adiBack(s), pieces: pieces, bolts: bolts, screws: screws, pillows: pillows,
      nBolt: nBolt, nMidScrew: nMidScrew, nS: nS, nBack: nBack, nArms: nArms, nBraces: nBraces,
      seatFront: F.x + P.ft + off, seatY: F.y, armTop: armTop,
      depth: xMax - xMin, height: Math.max(backTop, armTop)
    };
  }
  /* v260: as the park bench -- each group, then its fasteners */
  var ADI_STEPS = [
    { parts: [], codes: [] },
    { parts: ['adi-stringer', 'adi-leg'], codes: ['KVH60120'] },
    { parts: ['adi-hw-bolt', 'adi-hw-screw-mid'], codes: ['FAT10002', 'FAS80100'] },
    { parts: ['adi-apron'], codes: ['KVH10060'] },
    { parts: ['adi-hw-screw-apron'], codes: ['FAS60100'] },
    { parts: ['adi-seat'], codes: ['TIM20100'] },
    { parts: ['adi-hw-screw-seat'], codes: ['FAS50060'] },
    { parts: ['adi-support-low'], codes: ['KVH10060'] },
    { parts: ['adi-hw-screw-lowsup'], codes: ['FAS60100'] },
    { parts: ['adi-arm', 'adi-brace', 'adi-support-up'], codes: ['TIM45120', 'KVH10060'] },
    { parts: ['adi-hw-screw-arm'], codes: ['FAS60100'] },
    { parts: ['adi-back'], codes: ['TIM20100'] },
    { parts: ['adi-hw-screw-back'], codes: ['FAS50060'] }
  ];
  var _adiLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 10 -- PLANTER BENCH: a seat between two planter boxes.
       - each planter: 4 corner posts KVH03838 (2x2), 1x4 cladding
         TIM20100 all round (2 x 5x60 FAS50060 per board end), a raised
         slatted bottom on 2x2 cleats, a 1x4 cap frame on top; inside
         dimpled foil PFN00001 on the walls, geotextile PFG00001 on the
         bottom (stapled, FAS63000); the soil is the owner's (drawn,
         NOT BILLED -- no catalogue row)
       - the seat: 2x6 boards KVH60120 flat, the ends on 2x4 cleats
         KVH10060 screwed to the planters' faces (FAS60100); a 2x4 middle
         support with two legs over 1.60 m
       - the back (info-bar toggle, on by default): two 2x6 boards on 2x4
         cleats tilted by the slider (0-20 deg), the planters taller
     Width handle = the seat length 0.90-2.40 (1-3 persons); level button
     = the planter size (0.50 / 0.62 square). Sections follow the units.
     X = depth (front +), Y = up, Z = width; the planters at both ends.
     _planterLayout(STATE) is the single source (a piece list). */
  var PLANTER = {
    L_MIN: 0.90, L_MAX: 2.40, L_DEFAULT: 1.50,
    PB: [0.50, 0.62], PH_LOW: 0.60, PH_BACK: 0.92,
    SEAT_TOP: 0.45, SEAT_BOARDS: 3, SEAT_GAP: 0.010,
    BACK_TOP: 0.86, BACK_BOARDS: 2,
    CLAD_GAP: 0.004, BOTTOM_Y: 0.12, CAP_OVER: 0.015,
    MID_OVER: 1.60,
    STAPLES_M2: 12,
    POST: 'KVH03838', CLAD: 'TIM20100', BOARD: 'KVH60120', CLEAT: 'KVH10060',
    FOIL: 'PFN00001', GEO: 'PFG00001', STAPLE: 'FAS63000', CLAD_SCREW: 'FAS50060', SCREW: 'FAS60100'
  };
  function _planterProf(s) {
    if ((s || STATE).isMetric === false) return { ps: 0.0381, ct: 0.01905, cw: 0.0889, bt: 0.0381, bw: 0.1397, lt: 0.0381, lw: 0.0889 };
    return { ps: 0.038, ct: 0.020, cw: 0.100, bt: 0.060, bw: 0.120, lt: 0.060, lw: 0.100 };
  }
  function _planterLayout(s) {
    s = s || STATE;
    var P = _planterProf(s), i, j, k2, i2, q;
    var L = Math.max(PLANTER.L_MIN, Math.min(PLANTER.L_MAX, (+s.L) || PLANTER.L_DEFAULT));
    var back = (s.backrestVisible !== false);
    var PB = PLANTER.PB[(s.lvl === 2) ? 1 : 0], PH = back ? PLANTER.PH_BACK : PLANTER.PH_LOW;
    var pieces = [], clad = 0, screws = [];
    function box(kind, code, cut, id, x, y, z, sx, sy, sz, rz, mat) { pieces.push({ kind: kind, code: code, len: cut, id: id, box: [x, y, z, sx, sy, sz, rz || 0], mat: mat }); }
    /* v261: every screw drawn (head on the face, dir into the wood) and the
       bill counts the list; the 5x60s countersunk 4 mm */
    function scr(kind, x, y, z, dx, dy, dz, ln) {
      var sink = ln ? 0 : 0.004;
      screws.push({ kind: kind, x: x + dx * sink, y: y + dy * sink, z: z + dz * sink, dir: [dx, dy, dz], len: ln || 0.06 });
    }
    var inner = PB - 2 * P.ct;                                     /* inside the cladding */
    var postH = PH - P.ct, nRow = Math.max(3, Math.floor((postH - 0.01 + PLANTER.CLAD_GAP) / (P.cw + PLANTER.CLAD_GAP)));
    var rowP = (postH - 0.01 - P.cw) / Math.max(1, nRow - 1);       /* row pitch so the top row meets the cap */
    var foilA = 0, geoA = 0, soilV = 0;
    for (k2 = -1; k2 <= 1; k2 += 2) {
      var zc = k2 * (L / 2 + PB / 2), tag = (k2 < 0) ? 'l' : 'r';
      /* posts in the corners, inside the cladding */
      var po = PB / 2 - P.ct - P.ps / 2;
      for (i = -1; i <= 1; i += 2) for (j = -1; j <= 1; j += 2)
        box('post', PLANTER.POST, postH, 'planter-' + tag + '-post', i * po, postH / 2, zc + j * po, P.ps, postH, P.ps);
      /* cladding rows: front / back full width, the sides between them */
      for (i = 0; i < nRow; i++) {
        var yr = 0.01 + P.cw / 2 + i * rowP;
        box('clad', PLANTER.CLAD, PB, 'planter-' + tag + '-clad', PB / 2 - P.ct / 2, yr, zc, P.ct, P.cw, PB);
        box('clad', PLANTER.CLAD, PB, 'planter-' + tag + '-clad', -PB / 2 + P.ct / 2, yr, zc, P.ct, P.cw, PB);
        box('clad', PLANTER.CLAD, inner, 'planter-' + tag + '-clad', 0, yr, zc + PB / 2 - P.ct / 2, inner, P.cw, P.ct);
        box('clad', PLANTER.CLAD, inner, 'planter-' + tag + '-clad', 0, yr, zc - PB / 2 + P.ct / 2, inner, P.cw, P.ct);
        clad += 4;
        for (i2 = -1; i2 <= 1; i2 += 2) for (j = -1; j <= 1; j += 2) for (var q = -1; q <= 1; q += 2) {
          scr('clad', i2 * PB / 2, yr + q * P.cw / 4, zc + j * po, -i2, 0, 0);          /* front / back boards into the posts */
          scr('clad', i2 * po, yr + q * P.cw / 4, zc + j * PB / 2, 0, 0, -j);           /* side boards into the posts */
        }
      }
      /* the raised slatted bottom on two 2x2 cleats */
      var cl = inner - 2 * P.ps, yb = PLANTER.BOTTOM_Y;
      for (j = -1; j <= 1; j += 2) {
        box('bcleat', PLANTER.POST, cl, 'planter-' + tag + '-cleat', 0, yb - P.ps / 2, zc + j * po, cl, P.ps, P.ps);
        for (i = -1; i <= 1; i++) scr('bcleat', i * cl / 3, yb - P.ps / 2, zc + j * PB / 2, 0, 0, -j);   /* v261: through the side cladding into the cleat (billed) */
      }
      /* v261: the slats NOTCHED round the corner posts (they ran through
         them) -- the outer two get a post-sized cut-out at both ends */
      var nb = Math.max(3, Math.floor(inner / (P.cw + 0.012))), nw = P.ps + 0.003;
      for (i = 0; i < nb; i++) {
        var xb = -inner / 2 + P.cw / 2 + i * (inner - P.cw) / (nb - 1), x0b = xb - P.cw / 2, x1b = xb + P.cw / 2;
        var hit = (x1b > inner / 2 - nw) ? 1 : (x0b < -inner / 2 + nw) ? -1 : 0, zi = inner / 2;
        if (!hit) box('bottom', PLANTER.CLAD, inner, 'planter-' + tag + '-bottom', xb, yb + P.ct / 2, zc, P.cw, P.ct, inner);
        else {
          var xn = hit * (inner / 2 - nw);                                    /* the notch's inner edge */
          var xa = (hit > 0) ? x0b : xn, xc2 = (hit > 0) ? xn : x1b;          /* the full-length part */
          var pts = (hit > 0)
            ? [[x0b, zc - zi], [xn, zc - zi], [xn, zc - zi + nw], [x1b, zc - zi + nw], [x1b, zc + zi - nw], [xn, zc + zi - nw], [xn, zc + zi], [x0b, zc + zi]]
            : [[x0b, zc - zi + nw], [xn, zc - zi + nw], [xn, zc - zi], [x1b, zc - zi], [x1b, zc + zi], [xn, zc + zi], [xn, zc + zi - nw], [x0b, zc + zi - nw]];
          pieces.push({ kind: 'bottom', code: PLANTER.CLAD, len: inner, id: 'planter-' + tag + '-bottom', poly: pts, y0: yb, h: P.ct });
        }
        for (j = -1; j <= 1; j += 2) for (q = -1; q <= 1; q += 2) {
          var xs = hit ? ((hit > 0) ? (x0b + (q < 0 ? 0.015 : (P.cw - nw) - 0.015)) : (x1b - (q < 0 ? 0.015 : (P.cw - nw) - 0.015))) : (xb + q * P.cw / 4);
          scr('bottom', xs, yb + P.ct, zc + j * po, 0, -1, 0);             /* into the cleats */
        }
      }
      /* the cap frame */
      var cf = PB + 2 * PLANTER.CAP_OVER, yc = PH - P.ct / 2;
      box('cap', PLANTER.CLAD, cf, 'planter-' + tag + '-cap', cf / 2 - P.cw / 2, yc, zc, P.cw, P.ct, cf);
      box('cap', PLANTER.CLAD, cf, 'planter-' + tag + '-cap', -cf / 2 + P.cw / 2, yc, zc, P.cw, P.ct, cf);
      box('cap', PLANTER.CLAD, cf - 2 * P.cw, 'planter-' + tag + '-cap', 0, yc, zc + cf / 2 - P.cw / 2, cf - 2 * P.cw, P.ct, P.cw);
      box('cap', PLANTER.CLAD, cf - 2 * P.cw, 'planter-' + tag + '-cap', 0, yc, zc - cf / 2 + P.cw / 2, cf - 2 * P.cw, P.ct, P.cw);
      for (j = -1; j <= 1; j += 2) for (i2 = -1; i2 <= 1; i2 += 2) {
        scr('cap', i2 * po + (i2 * 0.0), PH, zc + j * (po - 0.012), 0, -1, 0);          /* the front / back cap into the post tops */
        scr('cap', i2 * po, PH, zc + j * (po + 0.012), 0, -1, 0);
        scr('cap', i2 * (cf / 2 - P.cw - 0.03), PH, zc + j * (PB / 2 - P.ct / 2), 0, -1, 0);   /* the side caps into the cladding's top edge */
        scr('cap', i2 * (cf / 2 - P.cw - 0.09), PH, zc + j * (PB / 2 - P.ct / 2), 0, -1, 0);
      }
      /* the lining (drawn thin inside the walls) and the soil */
      var hl = PH - P.ct - yb - P.ct, yl = yb + P.ct + hl / 2, fo = inner / 2 - 0.0015, nL0 = pieces.length;
      box('liner', PLANTER.FOIL, 0, 'planter-' + tag + '-foil', fo, yl, zc, 0.003, hl, inner, 0, 'foil');
      box('liner', PLANTER.FOIL, 0, 'planter-' + tag + '-foil', -fo, yl, zc, 0.003, hl, inner, 0, 'foil');
      box('liner', PLANTER.FOIL, 0, 'planter-' + tag + '-foil', 0, yl, zc + fo, inner - 0.006, hl, 0.003, 0, 'foil');
      box('liner', PLANTER.FOIL, 0, 'planter-' + tag + '-foil', 0, yl, zc - fo, inner - 0.006, hl, 0.003, 0, 'foil');
      /* v277 (Marek: the black liner from the inside, crossing, inside all the
         time): each sheet's assembly start = the opposite wall, so it crosses
         the box's inside to its own wall (the planter is centred on x = 0) */
      for (var lf = nL0; lf < pieces.length; lf++) { var lb = pieces[lf].box; pieces[lf].fly = [-lb[0], lb[1], 2 * zc - lb[2]]; }
      var hs = hl - 0.06;
      box('soil', null, 0, 'planter-' + tag + '-soil', 0, yb + P.ct + hs / 2, zc, inner - 0.008, hs, inner - 0.008, 0, 'soil');
      foilA += 4 * inner * hl; geoA += inner * inner * 1.2; soilV += (inner - 0.008) * (inner - 0.008) * hs;
    }
    /* THE SEAT: boards on cleats on the planters' faces (z = +-L/2) */
    var nS = PLANTER.SEAT_BOARDS, D = nS * P.bw + (nS - 1) * PLANTER.SEAT_GAP, yS = PLANTER.SEAT_TOP;
    var rake = back ? (+s.backRakeDeg || 0) * Math.PI / 180 : 0;
    var backLen = back ? (PLANTER.BACK_TOP - (yS - P.bt)) / Math.cos(rake) : 0;
    /* with the back the seat moves forward until the tilted back cleats
       stay inside the planter's depth */
    var xSb = back ? Math.max(-PB / 2 + P.lt + P.bt + 0.01, -PB / 2 + 0.005 + P.lw * Math.cos(rake) + backLen * Math.sin(rake)) : -D / 2;
    var xSf = xSb + D;   /* the seat's back / front edge */
    var clL = Math.min(D, PB / 2 - xSb), clX = xSb + clL / 2;
    var yCl = yS - P.bt - P.lw / 2;
    for (k2 = -1; k2 <= 1; k2 += 2) {
      box('seatcleat', PLANTER.CLEAT, clL, 'seat-cleat-' + (k2 < 0 ? 'l' : 'r'), clX, yCl, k2 * (L / 2 - P.lt / 2), clL, P.lw, P.lt);
      for (i = -1; i <= 1; i++) scr('seatcleat', clX + i * clL / 3, yCl + (i === 0 ? -0.02 : 0.02), k2 * (L / 2 - P.lt), 0, 0, k2, 0.10);   /* through the cleat into the planter */
    }
    for (i = 0; i < nS; i++) {
      var xsb = xSb + P.bw / 2 + i * (P.bw + PLANTER.SEAT_GAP);
      box('seat', PLANTER.BOARD, L, 'seat-board-' + (i + 1), xsb, yS - P.bt / 2, 0, P.bw, P.bt, L);
      for (k2 = -1; k2 <= 1; k2 += 2) for (q = -1; q <= 1; q += 2) scr('seat', xsb + q * P.bw / 4, yS, k2 * (L / 2 - P.lt / 2), 0, -1, 0, 0.10);
    }
    var mid = (L > PLANTER.MID_OVER), legH = yS - P.bt - P.lw;
    if (mid) {
      box('mid', PLANTER.CLEAT, D, 'middle-support', (xSb + xSf) / 2, yCl, 0, D, P.lw, P.lt);
      box('mid', PLANTER.CLEAT, legH, 'middle-leg-front', xSf - P.lw / 2 - 0.02, legH / 2, P.lt, P.lw, legH, P.lt);
      box('mid', PLANTER.CLEAT, legH, 'middle-leg-back', xSb + P.lw / 2 + 0.02, legH / 2, P.lt, P.lw, legH, P.lt);
      for (i = 0; i < nS; i++) for (q = -1; q <= 1; q += 2) scr('seatmid', xSb + P.bw / 2 + i * (P.bw + PLANTER.SEAT_GAP) + q * P.bw / 4, yS, 0, 0, -1, 0, 0.10);
      var xLg = [xSf - P.lw / 2 - 0.02, xSb + P.lw / 2 + 0.02];
      for (i = 0; i < 2; i++) for (q = -1; q <= 1; q += 2) scr('mid', xLg[i] + q * 0.02, yCl, 1.5 * P.lt, 0, 0, -1, 0.10);   /* the leg into the support */
    }
    /* THE BACK: two boards on tilted cleats behind the seat */
    if (back) {
      var bx0 = xSb - 0.005, by0 = yS - P.bt;                     /* the cleats' front bottom corner */
      var su = Math.sin(rake), cu = Math.cos(rake);
      for (k2 = -1; k2 <= 1; k2 += 2) {
        var cc = { x: bx0 - (backLen / 2) * su - (P.lw / 2) * cu, y: by0 + (backLen / 2) * cu - (P.lw / 2) * su };
        box('backcleat', PLANTER.CLEAT, backLen, 'back-cleat-' + (k2 < 0 ? 'l' : 'r'), cc.x, cc.y, k2 * (L / 2 - P.lt / 2), P.lw, backLen, P.lt, rake);
        for (i = 0; i < 3; i++) {
          var uq = 0.08 + i * (backLen - 0.16) / 2, cq = { x: bx0 - uq * su - (P.lw / 2) * cu, y: by0 + uq * cu - (P.lw / 2) * su };
          scr('backcleat', cq.x, cq.y, k2 * (L / 2 - P.lt), 0, 0, k2, 0.10);   /* through the cleat into the planter */
        }
      }
      for (i = 0; i < PLANTER.BACK_BOARDS; i++) {
        var u = backLen - P.bw / 2 - 0.02 - i * (P.bw + 0.06);    /* from the top down */
        var bc = { x: bx0 - u * su + (P.bt / 2) * cu, y: by0 + u * cu + (P.bt / 2) * su };
        box('back', PLANTER.BOARD, L, 'back-board-' + (i + 1), bc.x, bc.y, 0, P.bt, P.bw, L - 2 * 0.002, rake);
        for (k2 = -1; k2 <= 1; k2 += 2) for (q = -1; q <= 1; q += 2) {
          var ub = u + q * P.bw / 4;
          scr('back', bx0 - ub * su + P.bt * cu, by0 + ub * cu + P.bt * su, k2 * (L / 2 - P.lt / 2), -cu, -su, 0, 0.10);   /* the board into the cleat */
        }
      }
    }
    var timber = {};
    var coat = 0, sec = {}; sec[PLANTER.POST] = [P.ps, P.ps]; sec[PLANTER.CLAD] = [P.ct, P.cw]; sec[PLANTER.BOARD] = [P.bt, P.bw]; sec[PLANTER.CLEAT] = [P.lt, P.lw];
    for (i = 0; i < pieces.length; i++) { var pc = pieces[i]; if (sec[pc.code] && pc.len) coat += pc.len * 2 * (sec[pc.code][0] + sec[pc.code][1]); }
    var xMin = Math.min(-PB / 2 - PLANTER.CAP_OVER, back ? (xSb - 0.005 - (backLen) * Math.sin(rake) - P.lw) : xSb);
    var xMax = Math.max(PB / 2 + PLANTER.CAP_OVER, xSf);
    return {
      P: P, L: L, PB: PB, PH: PH, back: back, rake: rake, pieces: pieces, mid: mid,
      screws: screws,
      cladScrew: screws.filter(function (x) { return x.len < 0.08; }).length,      /* FAS50060: cladding, bottom cleats + slats, cap */
      screw: screws.filter(function (x) { return x.len >= 0.08; }).length,         /* FAS60100: cleats, seat / back boards, middle support */
      foilA: foilA, geoA: geoA, soilV: soilV, coat: coat,
      seatFront: xSf, seatY: yS, outerL: L + 2 * PB, depth: xMax - xMin, height: back ? Math.max(PH, PLANTER.BACK_TOP) : PH,
      /* v263: throw pillows against the back boards */
      pillows: back ? { n: Math.max(1, Math.round((L - 0.2) / 0.62)), z0: -L / 2 + P.lt + 0.06, z1: L / 2 - P.lt - 0.06, seatY: yS,
                        backX: xSb - 0.005 + P.bt * Math.cos(rake) - (P.bt * Math.sin(rake)) * Math.tan(rake) + 0.004, beta: rake } : null
    };
  }
  /* v261: as the park bench -- each group, then its fasteners; the liner
     before the cap (Marek), the soil last in the planters */
  var PLANTER_STEPS = [
    { parts: [], codes: [] },
    { parts: ['planter-post', 'planter-bcleat'], codes: ['KVH03838'] },
    { parts: ['planter-clad'], codes: ['TIM20100'] },
    { parts: ['planter-hw-screw-clad', 'planter-hw-screw-bcleat'], codes: ['FAS50060'] },
    { parts: ['planter-bottom'], codes: ['TIM20100'] },
    { parts: ['planter-hw-screw-bottom'], codes: ['FAS50060'] },
    { parts: ['planter-liner'], codes: ['PFN00001', 'PFG00001', 'FAS63000'] },
    { parts: ['planter-cap'], codes: ['TIM20100'] },
    { parts: ['planter-hw-screw-cap'], codes: ['FAS50060'] },
    { parts: ['planter-soil'], codes: ['SFF00004'] },
    { parts: ['planter-seatcleat', 'planter-mid'], codes: ['KVH10060'] },
    { parts: ['planter-hw-screw-seatcleat', 'planter-hw-screw-mid'], codes: ['FAS60100'] },
    { parts: ['planter-seat'], codes: ['KVH60120'] },
    { parts: ['planter-hw-screw-seat', 'planter-hw-screw-seatmid'], codes: ['FAS60100'] },
    { parts: ['planter-backcleat'], codes: ['KVH10060'] },
    { parts: ['planter-hw-screw-backcleat'], codes: ['FAS60100'] },
    { parts: ['planter-back'], codes: ['KVH60120'] },
    { parts: ['planter-hw-screw-back'], codes: ['FAS60100'] }
  ];
  var _planterLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 11 -- TREE BENCH: a hexagon (level button: octagon) round a
     tree, the sitters facing out.
       - per side 3 x 2x6 seat boards KVH60120 cut as trapezoids (the
         miters on the corner lines), screwed FAS60100 2 per end
       - under each corner line a 2x4 radial joist KVH10060 on edge, two
         2x4 legs bolted to it (FAT10002 x 2 each); a 2x4 apron along each
         side at the inner and the outer edge (FAS60100 2 per end)
       - the back (info-bar toggle, off by default): a 2x4 post at each
         corner inside the opening, tilted toward the tree by the slider
         (0-20 deg), two 2x6 back boards per side on the posts
     Width handle = the opening across the flats 0.50-1.60 (tree +
     clearance). Sections follow the units. _treeLayout(STATE) is the single
     source; pieces carry a local box + the rotation about y (radial
     frame) and the tilt about the local z. */
  var TREE = {
    L_MIN: 0.50, L_MAX: 1.60, L_DEFAULT: 0.80,
    SEAT_TOP: 0.45, BOARDS: 3, GAP: 0.010, MITER_GAP: 0.002,
    BACK_TOP: 0.86, BACK_BOARDS: 2,
    BOARD: 'KVH60120', FRAME: 'KVH10060', BOLT: 'FAT10002', SCREW: 'FAS60100'
  };
  function _treeProf(s) {
    if ((s || STATE).isMetric === false) return { bt: 0.0381, bw: 0.1397, lt: 0.0381, lw: 0.0889 };
    return { bt: 0.060, bw: 0.120, lt: 0.060, lw: 0.100 };
  }
  function _treeLayout(s) {
    s = s || STATE;
    var P = _treeProf(s), n = (s.lvl === 2) ? 8 : 6, half = Math.PI / n, th = Math.tan(half), ch = Math.cos(half), hs = Math.sin(half);
    var L = Math.max(TREE.L_MIN, Math.min(TREE.L_MAX, (+s.L) || TREE.L_DEFAULT));
    var back = (s.backrestVisible === true);
    var ai = L / 2, D = TREE.BOARDS * P.bw + (TREE.BOARDS - 1) * TREE.GAP, ao = ai + D;
    var yS = TREE.SEAT_TOP, yJ = yS - P.bt - P.lw / 2, legH = yS - P.bt;
    var pieces = [], bolts = [], screws = [], i, b, k, nBolt = 0;
    function piece(kind, code, cut, id, box, ry, rz) { pieces.push({ kind: kind, code: code, len: cut, id: id, box: box, ry: ry, rz: rz || 0 }); }
    /* corner frame (u along the corner line, t across it, toward the next
       side) -> world x / z */
    function W2(u, t, ph) { return [u * Math.cos(ph) - t * Math.sin(ph), u * Math.sin(ph) + t * Math.cos(ph)]; }
    /* v261 (Marek: the aprons flush with the legs, no collisions, every
       fastener drawn; the back posts clear of the frame).
       Each corner: the joist on the corner line (t -lt/2..lt/2), the two
       legs bolted to its +t face (t lt/2..3lt/2). The aprons are CUT TO FIT
       between the corners: the left end square against the leg's +t face,
       the right end against the joist's -t face (miter-cut to the corner
       line's angle), so every apron end sits flat and flush. The legs and
       the joist are placed where the apron ends land. */
    var cL = 1.5 * P.lt + 0.001, cR = -0.5 * P.lt - 0.001;
    var rO1 = ao - 0.012, rO0 = rO1 - P.lt;
    /* the back posts: centred on the corner line, inside the opening clear
       of both seats' boards, tilted toward the tree about the boards'
       underside; they cross the joist's inner end in a half lap (zamek) */
    var rake = back ? (+s.backRakeDeg || 0) * Math.PI / 180 : 0, sr = Math.sin(rake), cr = Math.cos(rake), tr = Math.tan(rake);
    var yPv = yS - P.bt, yB0 = yJ - P.lw / 2, tP = P.lt / 2 - 0.002;
    var uPmax = (ai - 0.006 - tP * hs) / ch;                         /* the post's outer face at the pivot */
    var rI0 = ai + 0.015, rI1 = rI0 + P.lt;
    /* the outer leg's outer end flush with the outer apron's outer face, the
       inner leg's inner end flush with the inner apron's inner face */
    var uLegO = rO1 / ch - cL * th - P.lw / 2, uLegI = rI0 / ch - cL * th + P.lw / 2;
    var uJ0 = Math.min(rI0 / ch + cR * th, uLegI - P.lw / 2);   /* flush with the inner leg's end */
    var uJ1 = Math.max(rO1 / ch + cR * th, uLegO + P.lw / 2);   /* its corners on the outer aprons' faces */
    if (back) uJ0 = Math.min(uJ0, uPmax - P.lw / cr + (yPv - (yJ + P.lw / 2)) * tr - 0.004);
    var jl = uJ1 - uJ0;
    function sL(r) { return (cL - r * hs) / ch; }   /* an apron's left end at depth r (on the leg's face) */
    function sR(r) { return (cR + r * hs) / ch; }   /* its right end (on the joist's face) */
    for (k = 0; k < n; k++) {
      var phS = k * 2 * half, phV = phS + half;     /* the side's normal, the corner line after it */
      /* seat boards: trapezoids between the corner lines */
      var en = [Math.cos(phS), Math.sin(phS)], et = [-Math.sin(phS), Math.cos(phS)];
      for (b = 0; b < TREE.BOARDS; b++) {
        var ri = ai + b * (P.bw + TREE.GAP), ro = ri + P.bw, mi = TREE.MITER_GAP / ch;
        var ti = ri * th - mi, to = ro * th - mi;
        pieces.push({ kind: 'seat', code: TREE.BOARD, len: 2 * ro * th, id: 'seat-' + (k + 1) + '-' + (b + 1), y0: yS - P.bt, h: P.bt,
          poly: [[ri * en[0] - ti * et[0], ri * en[1] - ti * et[1]], [ro * en[0] - to * et[0], ro * en[1] - to * et[1]],
                 [ro * en[0] + to * et[0], ro * en[1] + to * et[1]], [ri * en[0] + ti * et[0], ri * en[1] + ti * et[1]]] });
        /* 2 screws a board end, down into the joist, the board's half of it */
        var rc = (ri + ro) / 2;
        for (var e = -1; e <= 1; e += 2) {
          var phC = phS + e * half, tC = -e * 0.016;                   /* the board's side of the corner line */
          for (var q = -1; q <= 1; q += 2) {
            var rn = rc + q * P.bw / 4, uC = (rn + Math.abs(tC) * hs) / ch, pw = W2(uC, tC, phC);
            screws.push({ kind: 'seat', x: pw[0], y: yS, z: pw[1], dir: [0, -1, 0], len: 0.10 });
          }
        }
      }
      /* the corner joist and its two legs (on the +t side) */
      piece('joist', TREE.FRAME, jl, 'joist-' + (k + 1), [(uJ0 + uJ1) / 2, yJ, 0, jl, P.lw, P.lt], -phV);
      var ul = [uLegI, uLegO];
      for (i = 0; i < 2; i++) {
        piece('leg', TREE.FRAME, legH, 'leg-' + (k + 1) + (i ? '-outer' : '-inner'), [ul[i], legH / 2, P.lt, P.lw, legH, P.lt], -phV);
        bolts.push({ kind: 'leg', r: ul[i] - 0.025, y: yJ + 0.02, t: 1.5 * P.lt + 0.004, ph: phV }, { kind: 'leg', r: ul[i] + 0.025, y: yJ - 0.02, t: 1.5 * P.lt + 0.004, ph: phV });
        nBolt += 2;
      }
      /* the aprons of this side, cut to fit: left end on the previous
         corner's leg face, right end on this corner's joist face */
      var rr = [[rO0, rO1, 'outer'], [rI0, rI1, 'inner']];
      for (i = 0; i < 2; i++) {
        var r0 = rr[i][0], r1 = rr[i][1];
        var poly = [[r0, sL(r0)], [r0, sR(r0)], [r1, sR(r1)], [r1, sL(r1)]].map(function (p) { return [p[0] * en[0] + p[1] * et[0], p[0] * en[1] + p[1] * et[1]]; });
        var apLong = Math.max(sR(r0) - sL(r0), sR(r1) - sL(r1));
        pieces.push({ kind: 'apron', code: TREE.FRAME, len: apLong, id: 'apron-' + rr[i][2] + '-' + (k + 1), y0: yJ - P.lw / 2, h: P.lw, poly: poly });
        /* 2 toe screws a end: on the apron's face 4 cm from the end, in at
           45 deg through the end into the leg / the joist */
        var rM = (r0 + r1) / 2, rF = (i === 0) ? r1 : r0, nOut = (i === 0) ? 1 : -1;
        var ends = [[sL(rF) + 0.045, -1], [sR(rF) - 0.045, 1]];
        for (var ee = 0; ee < 2; ee++) {
          var sE = ends[ee][0], dS = ends[ee][1];
          var dx = (-nOut * en[0] + dS * et[0]) / Math.SQRT2, dz = (-nOut * en[1] + dS * et[1]) / Math.SQRT2;
          for (q = -1; q <= 1; q += 2)
            screws.push({ kind: 'apron', x: rF * en[0] + sE * et[0], y: yJ + q * P.lw / 4, z: rF * en[1] + sE * et[1], dir: [dx, 0, dz], len: 0.10 });
        }
      }
    }
    /* the back: a post at each corner, two boards per side on them */
    var backLen = 0, rakeS = Math.atan(tr * ch);
    if (back) {
      backLen = (TREE.BACK_TOP - yB0) / cr;
      for (k = 0; k < n; k++) {
        var phV2 = k * 2 * half + half;
        var yC = (yB0 + TREE.BACK_TOP) / 2, uFace = uPmax - (yC - yPv) * tr, uCen = uFace - (P.lw / 2) / cr;
        piece('post', TREE.FRAME, backLen, 'back-post-' + (k + 1), [uCen, yC, 0, P.lw, backLen, 2 * tP], -phV2, rake);
        var yBl = yJ, uBl = uPmax - (yBl - yPv) * tr - (P.lw / 2) / cr;   /* the lap: 2 bolts through post + joist */
        bolts.push({ kind: 'post', r: uBl - 0.02, y: yBl + 0.02, t: 0.5 * P.lt + 0.004, ph: phV2 }, { kind: 'post', r: uBl + 0.02, y: yBl - 0.02, t: 0.5 * P.lt + 0.004, ph: phV2 });
        nBolt += 2;
      }
      for (k = 0; k < n; k++) {
        var phS2 = k * 2 * half, en2 = [Math.cos(phS2), Math.sin(phS2)], et2 = [-Math.sin(phS2), Math.cos(phS2)];
        for (b = 0; b < TREE.BACK_BOARDS; b++) {
          var yb = yS + (0.20 + b * (P.bw + 0.05)) * Math.cos(rakeS);           /* the board's middle, on its inner face */
          var rIn = (uPmax - (yb - yPv) * tr) * ch + tP * hs;                   /* the posts' outer corners there */
          var Li = 2 * rIn * th - 0.004, Lo = 2 * (rIn + P.bt / Math.cos(rakeS)) * th - 0.004;
          pieces.push({ kind: 'back', code: TREE.BOARD, len: Lo, id: 'back-' + (k + 1) + '-' + (b + 1), trap: [Li, Lo, P.bt, P.bw],
                        box: [rIn + (P.bt / 2) * Math.cos(rakeS), yb + (P.bt / 2) * Math.sin(rakeS), 0], ry: -phS2, rz: rakeS });
          /* 2 screws a board end into the post */
          for (var e2 = -1; e2 <= 1; e2 += 2) for (q = -1; q <= 1; q += 2) {
            var sB = e2 * (rIn * th - 0.022), hB = q * P.bw / 4;
            var rB = rIn + P.bt / Math.cos(rakeS) - hB * Math.sin(rakeS), yBs = yb + hB * Math.cos(rakeS);
            screws.push({ kind: 'back', x: rB * en2[0] + sB * et2[0], y: yBs, z: rB * en2[1] + sB * et2[1],
                          dir: [-Math.cos(rakeS) * en2[0], -Math.sin(rakeS), -Math.cos(rakeS) * en2[1]], len: 0.10 });
          }
        }
      }
    }
    var rv = ao / ch, zx = 0, xx = 0;
    for (k = 0; k < n; k++) { var a = k * 2 * half + half; zx = Math.max(zx, Math.abs(rv * Math.sin(a))); xx = Math.max(xx, Math.abs(rv * Math.cos(a))); }
    var perim = n * 2 * (ai + D / 2) * th;
    return {
      P: P, n: n, L: L, ai: ai, ao: ao, D: D, back: back, rake: rake, pieces: pieces, bolts: bolts, nBolt: nBolt, screws: screws, nScrew: screws.length,
      seats: Math.max(n, Math.floor(perim / 0.60)), seatY: yS, outerZ: 2 * zx, outerX: 2 * xx,
      depth: 2 * xx, height: back ? TREE.BACK_TOP : yS
    };
  }
  /* v261: as the park bench -- each group, then its fasteners */
  var TREE_STEPS = [
    { parts: [], codes: [] },
    { parts: ['tree-joist', 'tree-leg'], codes: ['KVH10060'] },
    { parts: ['tree-hw-bolt-leg'], codes: ['FAT10002'] },
    { parts: ['tree-apron'], codes: ['KVH10060'] },
    { parts: ['tree-hw-screw-apron'], codes: ['FAS60100'] },
    { parts: ['tree-seat'], codes: ['KVH60120'] },
    { parts: ['tree-hw-screw-seat'], codes: ['FAS60100'] },
    { parts: ['tree-post'], codes: ['KVH10060'] },
    { parts: ['tree-hw-bolt-post'], codes: ['FAT10002'] },
    { parts: ['tree-back'], codes: ['KVH60120'] },
    { parts: ['tree-hw-screw-back'], codes: ['FAS60100'] }
  ];
  var _treeLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 12 -- STORAGE BENCH: a clad box with a hinged lid you sit on.
       - 4 corner posts KVH03838 (2x2), 1x4 cladding TIM20100 all round
         (FAS50060 2 per board end per post), a raised slatted floor on
         2x2 cleats (drains)
       - the lid: 1x4 boards lengthwise on 2x2 battens underneath, hinged
         at the back (door hinges ODD00005, 2 -- 3 over 1.20 m), lid stays
         NOT BILLED (no catalogue row); the level button opens the lid
       - the back (info-bar toggle, off by default): two 2x4 uprights
         KVH10060 on the end walls at the rear, tilted by the slider
         (0-20 deg), two 2x6 back boards KVH60120
     Width handle = the length 0.90-1.80 (1-3 seats); depth 0.50, seat
     top 0.45. Sections follow the units. _storageLayout(STATE) = a piece
     list (boxes; the lid's pieces turned about the hinge axis). */
  var STORE = {
    L_MIN: 0.90, L_MAX: 1.80, L_DEFAULT: 1.20,
    DEPTH: 0.50, SEAT_TOP: 0.45, FLOOR_Y: 0.06, CLAD_GAP: 0.004, LID_GAP: 0.006,
    BACK_TOP: 0.86, LID_OPEN: 80,
    POST: 'KVH03838', CLAD: 'TIM20100', CLEAT: 'KVH10060', BOARD: 'KVH60120',
    HINGE: 'ODD00005', CLAD_SCREW: 'FAS50060', SCREW: 'FAS60100'
  };
  function _storageProf(s) {
    if ((s || STATE).isMetric === false) return { ps: 0.0381, ct: 0.01905, cw: 0.0889, lt: 0.0381, lw: 0.0889, bt: 0.0381, bw: 0.1397 };
    return { ps: 0.038, ct: 0.020, cw: 0.100, lt: 0.060, lw: 0.100, bt: 0.060, bw: 0.120 };
  }
  function _storageLayout(s) {
    s = s || STATE;
    var P = _storageProf(s), i, k;
    var L = Math.max(STORE.L_MIN, Math.min(STORE.L_MAX, (+s.L) || STORE.L_DEFAULT));
    var W = STORE.DEPTH, hL = L / 2, hW = W / 2, back = (s.backrestVisible === true), open = (s.lvl === 2);
    var pieces = [], cladScrew = 0, screw = 0, screws = [];
    function box(kind, code, cut, id, x, y, z, sx, sy, sz, rz, mat) { pieces.push({ kind: kind, code: code, len: cut, id: id, box: [x, y, z, sx, sy, sz, rz || 0], mat: mat }); }
    /* v260: every screw drawn (head on the face, dir into the wood) and the
       bill counts the list */
    function scr(kind, x, y, z, dx, dy, dz, ln) {
      var sink = (ln ? 0 : 0.004);   /* the 5x60s countersunk 4 mm: board + 38 batten = 58, no tip through */
      screws.push({ kind: kind, x: x + dx * sink, y: y + dy * sink, z: z + dz * sink, dir: [dx, dy, dz], len: ln || 0.06 });
    }
    var boxTop = STORE.SEAT_TOP - P.ct, postH = boxTop;
    var po = { x: hW - P.ct - P.ps / 2, z: hL - P.ct - P.ps / 2 };
    for (i = -1; i <= 1; i += 2) for (k = -1; k <= 1; k += 2) box('post', STORE.POST, postH, 'post', i * po.x, postH / 2, k * po.z, P.ps, postH, P.ps);
    /* cladding rows fitted to the height */
    var nRow = Math.max(3, Math.floor((boxTop - 0.01 + STORE.CLAD_GAP) / (P.cw + STORE.CLAD_GAP)));
    var rowP = (boxTop - 0.01 - P.cw) / Math.max(1, nRow - 1), innerW = W - 2 * P.ct, innerL = L - 2 * P.ct;
    for (i = 0; i < nRow; i++) {
      var yr = 0.01 + P.cw / 2 + i * rowP;
      box('clad', STORE.CLAD, L, 'clad-front', hW - P.ct / 2, yr, 0, P.ct, P.cw, L);
      box('clad', STORE.CLAD, L, 'clad-back', -hW + P.ct / 2, yr, 0, P.ct, P.cw, L);
      box('clad', STORE.CLAD, innerW, 'clad-end', 0, yr, hL - P.ct / 2, innerW, P.cw, P.ct);
      box('clad', STORE.CLAD, innerW, 'clad-end', 0, yr, -hL + P.ct / 2, innerW, P.cw, P.ct);
      for (k = -1; k <= 1; k += 2) for (var q = -1; q <= 1; q += 2) {
        scr('clad', hW, yr + q * P.cw / 4, k * po.z, -1, 0, 0);            /* front boards into the posts */
        scr('clad', -hW, yr + q * P.cw / 4, k * po.z, 1, 0, 0);            /* back boards */
        scr('clad', k * po.x, yr + q * P.cw / 4, hL, 0, 0, -1);            /* end boards */
        scr('clad', k * po.x, yr + q * P.cw / 4, -hL, 0, 0, 1);
      }
    }
    /* the raised slatted floor on two 2x2 cleats along the length */
    var clL = innerL - 2 * P.ps, yF = STORE.FLOOR_Y + P.ps;
    for (i = -1; i <= 1; i += 2) {
      box('floorcleat', STORE.POST, clL, 'floor-cleat', i * po.x, STORE.FLOOR_Y + P.ps / 2, 0, P.ps, P.ps, clL);
      for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2)
        scr('cleat', i * po.x + q * P.ps / 4, STORE.FLOOR_Y + P.ps / 2, k * hL, 0, 0, -k, 0.06);   /* through the end cladding into the cleat end (v260: billed) */
    }
    var nF = Math.max(3, Math.floor(innerL / (P.cw + 0.012)));
    for (i = 0; i < nF; i++) {
      var zf = -innerL / 2 + P.cw / 2 + i * (innerL - P.cw) / (nF - 1);
      box('floor', STORE.CLAD, innerW, 'floor-slat', 0, yF + P.ct / 2, zf, innerW, P.ct, P.cw);
      for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) scr('floor', k * po.x, yF + P.ct, zf + q * P.cw / 4, 0, -1, 0);
    }
    /* THE LID: boards lengthwise on battens, hinged at the back top edge
       (with the back on: behind a fixed rear board the back stands over);
       open = turned 80 deg about the hinge axis */
    var lidL = L - STORE.LID_GAP, ang = open ? STORE.LID_OPEN * Math.PI / 180 : 0;
    var nLB = Math.max(3, Math.floor((W + 0.004) / (P.cw + 0.004))), lbGap = (W - nLB * P.cw) / Math.max(1, nLB - 1);
    var hx = back ? (-hW + P.cw + lbGap / 2) : -hW, hy = boxTop;
    function lidBox(kind, code, cut, id, x, y, z, sx, sy, sz, fixed) {
      if (fixed) { box(kind, code, cut, id, x, y, z, sx, sy, sz); return; }
      var dx = x - hx, dy = y - hy, ca = Math.cos(ang), sa = Math.sin(ang);
      box(kind, code, cut, id, hx + dx * ca - dy * sa, hy + dx * sa + dy * ca, z, sx, sy, sz, ang);
    }
    for (i = 0; i < nLB; i++) lidBox('lid', STORE.CLAD, lidL, 'lid-board-' + (i + 1), -hW + P.cw / 2 + i * (P.cw + lbGap), boxTop + P.ct / 2, 0, P.cw, P.ct, lidL, back && i === 0);
    var nBat = (L > 1.20) ? 4 : 3;
    var bx0 = back ? (hx + 0.005) : (-hW + P.ct + P.ps + 0.005), bx1 = hW - P.ct - P.ps - 0.005, batL = bx1 - bx0;
    /* a lid screw: the point and dir turned about the hinge axis with the lid */
    function lidScr(x, y, z, fixed) {
      if (fixed) { scr('lid', x, y, z, 0, -1, 0); return; }
      var dx = x - hx, dy = y - hy, ca2 = Math.cos(ang), sa2 = Math.sin(ang);
      scr('lid', hx + dx * ca2 - dy * sa2, hy + dx * sa2 + dy * ca2, z, sa2, -ca2, 0);
    }
    for (i = 0; i < nBat; i++) {
      var zb = -(innerL - 3 * P.ps) / 2 + i * (innerL - 3 * P.ps) / (nBat - 1);
      lidBox('lidbatten', STORE.POST, batL, 'lid-batten-' + (i + 1), (bx0 + bx1) / 2, boxTop - P.ps / 2, zb, batL, P.ps, P.ps, false);   /* v261: its own step, before the boards */
      for (k = 0; k < nLB; k++) {
        var xb2 = -hW + P.cw / 2 + k * (P.cw + lbGap);
        if (back && k === 0) continue;                                       /* the fixed board is not on the battens */
        for (q = -1; q <= 1; q += 2) lidScr(xb2 + q * P.cw / 4, boxTop + P.ct, zb, false);
      }
    }
    if (back) for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) lidScr(-po.x + q * 0.008, boxTop + P.ct, k * po.z, true);   /* the fixed rear board into the back posts */
    var nHinge = (L > 1.20) ? 3 : 2, hinges = [];
    for (i = 0; i < nHinge; i++) hinges.push({ x: hx, y: hy + P.ct, z: -hL + 0.15 + i * (L - 0.30) / (nHinge - 1) });
    /* v261: the two soft-close lid stays (FAT00023), drawn: a bar from the
       inside of each end wall to the lid's underside, turning with it */
    var stays = [], caS = Math.cos(ang), saS = Math.sin(ang);
    for (k = -1; k <= 1; k += 2) {
      var zS = k * (hL - P.ct - 0.012), lpx = 0.10;
      stays.push({ a: { x: hx + 0.03, y: boxTop - 0.17, z: zS }, b: { x: hx + lpx * caS, y: hy + lpx * saS, z: zS } });
    }
    /* THE BACK: two 2x4 uprights behind the back wall, screwed to it, tilted
       about the rear top edge; two 2x6 boards on their front faces over
       the fixed rear lid board */
    var rake = back ? (+s.backRakeDeg || 0) * Math.PI / 180 : 0, upLen = 0;
    if (back) {
      var y0 = 0.10, sr = Math.sin(rake), cr = Math.cos(rake), pvY = STORE.SEAT_TOP;
      upLen = (pvY - y0) + (STORE.BACK_TOP - pvY) / cr;
      var uc = upLen / 2 - (pvY - y0);
      /* v260 THE UPRIGHTS TAPER-CUT: the straight 2x4 leans back by the rake
         about the box's rear top edge; below it the stock would run into the
         back wall, so its front is ripped on a taper flush with the wall
         (the tilted rectangle clipped at x = -hW). Screwed from behind
         through the upright and the back wall into the corner post, where
         at least 42 mm of wood stays behind the wall. */
      var ucx = -hW - uc * sr - (P.lw / 2) * cr, ucy = pvY + uc * cr - (P.lw / 2) * sr;
      var ax = [cr, sr], ay = [-sr, cr], rect = [], cc, upPts;
      for (cc = 0; cc < 4; cc++) {
        var fx = (cc === 0 || cc === 3) ? -1 : 1, fy = (cc < 2) ? -1 : 1;
        rect.push([ucx + fx * (P.lw / 2) * ax[0] + fy * (upLen / 2) * ay[0], ucy + fx * (P.lw / 2) * ax[1] + fy * (upLen / 2) * ay[1]]);
      }
      upPts = [];
      for (cc = 0; cc < 4; cc++) {
        var A = rect[cc], B = rect[(cc + 1) % 4], fa = -hW - A[0], fb = -hW - B[0];
        if (fa >= 0) upPts.push(A);
        if ((fa >= 0) !== (fb >= 0)) { var tt = fa / (fa - fb); upPts.push([A[0] + tt * (B[0] - A[0]), A[1] + tt * (B[1] - A[1])]); }
      }
      var depthAt = function (y) { return (y >= pvY) ? P.lw / cr : (P.lw / cr - (pvY - y) * (sr / cr)); };
      var yMinS = Math.max(0.15, (rake > 0.001) ? (pvY - (P.lw / cr - 0.042) / (sr / cr) + 0.01) : 0.15), yMaxS = boxTop - 0.04;
      if (yMinS > yMaxS - 0.06) yMinS = yMaxS - 0.06;
      for (k = -1; k <= 1; k += 2) {
        pieces.push({ kind: 'upright', code: STORE.CLEAT, len: upLen, id: 'back-upright-' + (k < 0 ? 'l' : 'r'), poly: upPts, z: k * (hL - P.lt / 2 - 0.02), d: P.lt });
        for (q = 0; q < 3; q++) {
          var yU = yMinS + q * (yMaxS - yMinS) / 2;
          /* counterbored where the upright is thicker than 55 mm, so the
             6x100 always bites 45 mm into the wall board and the post */
          scr('upright', -hW - Math.min(depthAt(yU), 0.055), yU, k * (hL - 0.04), 1, 0, 0, 0.10);   /* from behind: the upright, the back wall, into the corner post */
        }
      }
      for (i = 0; i < 2; i++) {
        var u = (STORE.BACK_TOP - pvY) / cr - P.bw / 2 - 0.02 - i * (P.bw + 0.06);
        box('back', STORE.BOARD, L, 'back-board-' + (i + 1), -hW - u * sr + (P.bt / 2) * cr, pvY + u * cr + (P.bt / 2) * sr, 0, P.bt, P.bw, L, rake);
        for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) {
          var uq = u + q * P.bw / 4;
          scr('back', -hW - uq * sr + P.bt * cr, pvY + uq * cr + P.bt * sr, k * (hL - P.lt / 2 - 0.02), -cr, -sr, 0, 0.10);   /* the board into the upright */
        }
      }
    }
    var coat = 0, sec = {}; sec[STORE.POST] = [P.ps, P.ps]; sec[STORE.CLAD] = [P.ct, P.cw]; sec[STORE.CLEAT] = [P.lt, P.lw]; sec[STORE.BOARD] = [P.bt, P.bw];
    for (i = 0; i < pieces.length; i++) coat += pieces[i].len * 2 * (sec[pieces[i].code][0] + sec[pieces[i].code][1]);
    var xMin = back ? (-hW - P.lw * Math.cos(rake) - (STORE.BACK_TOP - STORE.SEAT_TOP) * Math.tan(rake)) : -hW;
    return {
      P: P, L: L, W: W, back: back, open: open, rake: rake, pieces: pieces, hinges: hinges, nHinge: nHinge, stays: stays,
      screws: screws,
      cladScrew: screws.filter(function (x) { return x.kind !== 'upright' && x.kind !== 'back'; }).length,
      screw: screws.filter(function (x) { return x.kind === 'upright' || x.kind === 'back'; }).length,
      coat: coat, volume: innerL * innerW * (boxTop - yF - P.ct),
      seatFront: hW, seatY: STORE.SEAT_TOP, depth: hW - xMin, height: back ? STORE.BACK_TOP : STORE.SEAT_TOP,
      outerL: L,
      /* v263: throw pillows on the lid against the back boards */
      pillows: back ? { n: Math.max(1, Math.round((L - 0.2) / 0.62)), z0: -hL + 0.10, z1: hL - 0.10, seatY: STORE.SEAT_TOP, backX: -hW + P.bt * Math.cos(rake) + 0.004, beta: rake } : null
    };
  }
  /* v260: as the park bench -- each group, then its fasteners */
  var STORE_STEPS = [
    { parts: [], codes: [] },
    { parts: ['store-post'], codes: ['KVH03838'] },
    { parts: ['store-clad'], codes: ['TIM20100'] },
    { parts: ['store-hw-screw-clad'], codes: ['FAS50060'] },
    { parts: ['store-floorcleat'], codes: ['KVH03838'] },
    { parts: ['store-hw-screw-cleat'], codes: ['FAS50060'] },
    { parts: ['store-floor'], codes: ['TIM20100'] },
    { parts: ['store-hw-screw-floor'], codes: ['FAS50060'] },
    { parts: ['store-lidbatten'], codes: ['KVH03838'] },
    { parts: ['store-lid'], codes: ['TIM20100'] },
    { parts: ['store-hw-screw-lid'], codes: ['FAS50060'] },
    { parts: ['store-hw-hinge'], codes: ['ODD00005'] },
    { parts: ['store-hw-stay'], codes: ['FAT00023'] },
    { parts: ['store-upright'], codes: ['KVH10060'] },
    { parts: ['store-hw-screw-upright'], codes: ['FAS60100'] },
    { parts: ['store-back'], codes: ['KVH60120'] },
    { parts: ['store-hw-screw-back'], codes: ['FAS60100'] }
  ];
  var _storeLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 6 -- BLOCK BENCH (the "cinder block bench"): hollow concrete
     blocks WWB03003 (two-core stretchers, 390 x 190 x 190; US 8x8x16 =
     15 5/8 x 7 5/8 x 7 5/8 in.) laid on their sides so both cores run
     along the bench, 4x4 timbers KVH10100 slid through the cores.
       - each end: two blocks stacked; the seat = two 4x4s through the
         upper block's cores, lying on the core floor
       - the back (info-bar toggle, off by default): a third block standing
         on end on the rear half of each seat block, its cores one over the
         other, two more 4x4s through them
       - construction adhesive FEC00031: a bead pair in every bed joint and
         a bead under each timber in every core it lies in
       - level button = the block colour: 1 natural (unpainted), 2 red,
         3 green, 4 blue; painted = concrete primer FEC00020 + masonry
         paint MFP00006 on the faces left in view (names: the container
         colour keys)
     Width handle = the timbers' length 1.00-2.44 (2.44 = an uncut 8 ft
     4x4; the stacks stand 0.05 in from the timber ends). No slider.
     Sections follow the units. _blockLayout(STATE) is the single source. */
  var BLOCK = {
    L_MIN: 1.00, L_MAX: 2.44, L_DEFAULT: 2.44, OVER: 0.05,
    CODE: 'WWB03003', TIMBER: 'KVH10100', GLUE: 'FEC00031', PRIMER: 'FEC00020', PAINT: 'MFP00006',
    GLUE_M: 10,    /* metres of a 6 mm bead out of one 10 oz cartridge (~300 ml) */
    COLORS: [0xbdbab3, 0xc0563d, 0x7a9a6c, 0x6688a8], GLOW: 0.22,   /* glow = emissive lift, as the wood's */
    COLOR_KEYS: ['container_c4', 'container_c2', 'container_c3', 'container_c1']
  };
  /* bl = the block's length, bw = across the face shells, bh = along the
     cores, sh = face shell, wb = web, t = the 4x4 */
  function _blockProf(s) {
    if ((s || STATE).isMetric === false) return { bl: 0.3969, bw: 0.1937, bh: 0.1937, sh: 0.0318, wb: 0.0254, t: 0.0889 };
    return { bl: 0.390, bw: 0.190, bh: 0.190, sh: 0.030, wb: 0.030, t: 0.100 };
  }
  function _blockColor(s) { var c = ((s || STATE).lvl | 0) || 1; return Math.max(1, Math.min(4, c)); }
  function _blockLayout(s) {
    s = s || STATE;
    var P = _blockProf(s), i, k;
    var L = Math.max(BLOCK.L_MIN, Math.min(BLOCK.L_MAX, (+s.L) || BLOCK.L_DEFAULT));
    var back = (s.backrestVisible === true), color = _blockColor(s);
    var cl = (P.bl - 3 * P.wb) / 2, xc = P.wb / 2 + cl / 2;    /* a core's length, its centre off the block's */
    var zE = L / 2 - BLOCK.OVER - P.bh / 2;                     /* the end stacks */
    /* v261 (Marek: the back left a narrow seat): the back is its own column
       BEHIND the seat column -- two blocks lying as the seat's, a third on
       end on their front half, against the seat column -- so the seat keeps
       both timbers; the whole set centred on x = 0 */
    var xo = back ? P.bl / 2 : 0, xR = -P.bl + xo, xB = -P.bl / 2 - P.bw / 2 + xo;
    var blocks = [], timbers = [];
    for (k = -1; k <= 1; k += 2) {
      var sd = (k < 0) ? 'l' : 'r';
      blocks.push({ id: 'base-' + sd, kind: 'base', x: xo, y: P.bw / 2, z: k * zE, up: false });
      blocks.push({ id: 'seat-' + sd, kind: 'seat', x: xo, y: 1.5 * P.bw, z: k * zE, up: false });
      if (back) {
        blocks.push({ id: 'rear-base-' + sd, kind: 'base', x: xR, y: P.bw / 2, z: k * zE, up: false });
        blocks.push({ id: 'rear-seat-' + sd, kind: 'seat', x: xR, y: 1.5 * P.bw, z: k * zE, up: false });
        blocks.push({ id: 'back-' + sd, kind: 'back', x: xB, y: 2 * P.bw + P.bl / 2, z: k * zE, up: true });
      }
    }
    var seatY = P.bw + P.sh + P.t / 2;
    for (i = -1; i <= 1; i += 2) timbers.push({ id: 'seat-' + (i < 0 ? 'rear' : 'front'), kind: 'seat', x: i * xc + xo, y: seatY, z: 0, len: L });
    if (back) for (i = 0; i < 2; i++) timbers.push({ id: 'back-' + (i ? 'top' : 'low'), kind: 'back', x: xB, y: 2 * P.bw + P.wb + i * (cl + P.wb) + P.t / 2, z: 0, len: L });
    /* the adhesive: two beads on every bed joint, one under each timber in each core */
    var nStack = 2, glueM = nStack * 2 * P.bl * (back ? 2 : 1) + (back ? nStack * 2 * P.bw : 0) + timbers.length * nStack * P.bh;
    /* the paint: the blocks' faces left in view (no cores, no bed joints, not the ground face, not where the columns touch) */
    var aBlock = 2 * (P.bl * P.bw + P.bl * P.bh + P.bw * P.bh) - 4 * cl * (P.bw - 2 * P.sh);
    var paint = 0, nLie = nStack * (back ? 4 : 2);
    if (color > 1) {
      paint = blocks.length * aBlock - (nLie / 2) * P.bl * P.bh - (nLie / 2) * 2 * P.bl * P.bh - (back ? nStack * 2 * P.bw * P.bh + nStack * 2 * 2 * P.bw * P.bh : 0);
      paint = Math.round(paint * 100) / 100;
    }
    var timberM = 0, seatM = 0;
    for (i = 0; i < timbers.length; i++) { timberM += timbers[i].len; if (timbers[i].kind === 'seat') seatM += timbers[i].len; }
    return {
      P: P, L: L, back: back, color: color, cl: cl, xc: xc, zE: zE, blocks: blocks, timbers: timbers,
      glueM: glueM, glue: Math.max(1, Math.ceil(glueM / BLOCK.GLUE_M)), paint: paint,
      coat: timberM * 4 * P.t, timberM: timberM, seatM: seatM,
      seatTop: seatY + P.t / 2, blockTop: 2 * P.bw, seatFront: xc + P.t / 2 + xo,
      clear: 2 * (zE - P.bh / 2), depth: back ? 2 * P.bl : P.bl, height: back ? 2 * P.bw + P.bl : 2 * P.bw, outerL: L,
      /* v263: throw pillows on the seat timbers against the back timbers */
      pillows: back ? { n: Math.max(1, Math.round((2 * (zE - P.bh / 2) - 0.1) / 0.65)), z0: -(zE - P.bh / 2) + 0.06, z1: (zE - P.bh / 2) - 0.06,
                        seatY: seatY + P.t / 2, backX: xB + P.t / 2 + 0.004, beta: 0 } : null
    };
  }
  var BLOCK_STEPS = [
    { parts: [], codes: [] },
    { parts: ['block-base'], codes: ['WWB03003'] },
    { parts: ['block-seat'], codes: ['WWB03003', 'FEC00031'] },
    { parts: ['block-timber-seat'], codes: ['KVH10100', 'FEC00031'] },
    { parts: ['block-back'], codes: ['WWB03003', 'FEC00031'] },
    { parts: ['block-timber-back'], codes: ['KVH10100', 'FEC00031'] }
  ];
  var _blockLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 15 -- THE 2x4 BENCH (bench-v284, Marek 2026-10-20 00:09 with a
     reel: jednoducha, ciste lepena lavicka; user muze editovat delku,
     sirka a vyska sedaci casti ne -- standardni rozmery). Nothing but
     2x4s, glue and brads:
       - the seat: 6 boards on edge the full length, a board's thickness
         apart (11 layers = 418 mm / 16 1/2 in. deep), its top at 450 mm /
         18 in.;
       - a leg at each end, flush with the seat's ends, one board wide
         along the bench: in every gap a full-height board (floor to the
         seat's top), under every seat board a short one (floor to its
         underside) -- a solid glued block of 11 layers;
       - built layer by layer from the back: each layer glued face to face
         to the one behind (FEC00043) and pinned with 4 brads a leg while
         the glue sets (18 ga x 50 mm / 2 in.: 38 through the layer, 12
         into the one behind) -- no catalogue row: drawn, NOT BILLED;
       - every face left in view coated (MFP00002), the glued ones not.
     Length handle 0.91-2.44 (3-8 ft; 2.44 = an uncut 8 ft board for the
     seat). No slider, no toggle, no level button. _gbLayout(STATE) is the
     single source: the renderer draws it, the BoQ sums it. */
  var GB = {
    L_MIN: 0.91, L_MAX: 2.44, L_DEFAULT: 1.52,
    N_SEAT: 6, SEAT_TOP: 0.45, SEAT_TOP_US: 0.4572,
    CODE: 'KVH10060',
    BRAD_LEN: 0.050, BRAD_LEN_US: 0.0508, BRAD_R: 0.0006,
    BRAD: 'BRAD NAIL, 18 GA x 50 MM (US 2 IN.)',   /* no catalogue row: NOT BILLED, logged (status MISSING) */
    /* v285 (Marek 2026-10-20 09:15: varianta v banneru -- plne bocni strany
       vyssi, na vrcholu jakoby podrucka; vysku tahnout v rozumnem rozmezi):
       the ARMRESTS on the info-bar toggle; its top on the height handle,
       0.15 .. 0.30 over the seat.
       v286 (Marek 2026-10-20 11:19: ne plne, jen prubezne profily; stejne
       siroky profil; pocket holes; konce licovat s lavici): only the 5
       full-height boards of each leg rise over the seat (open slots of a
       board's thickness between them, no fillers); the cap is the same 2x4
       flat, as wide as the leg (89 mm), its ends flush with the bench's
       front and back (11 layers, 418 mm); glued on the posts' tops and
       held by one pocket screw a post (FAS50060 5x60, US 2 1/2 in.),
       drilled 15 deg in the post's INNER face before the post goes in,
       driven up into the cap's underside (no screw head on top) */
    ARM_MIN: 0.15, ARM_MAX: 0.30, ARM_DEF: 0.22, ARM_SCREW: 'FAS50060',
    PKT_LEN: 0.060, PKT_LEN_US: 0.0635, PKT_ANG: 15, PKT_EXIT: 0.022, PKT_IN: 0.025, PKT_MARK: 0.075
  };
  function _gbSeatTop(s) { return ((s || STATE).isMetric === false) ? GB.SEAT_TOP_US : GB.SEAT_TOP; }
  function _gbArmsOn(s) { return (s || STATE).gbArms === true; }
  function _gbArmTop(s) {
    s = s || STATE;
    var H = _gbSeatTop(s), a = +s.gbArmH;
    if (!(a > 0)) a = H + GB.ARM_DEF;
    return Math.max(H + GB.ARM_MIN, Math.min(H + GB.ARM_MAX, a));
  }
  function _gbProf(s) { return ((s || STATE).isMetric === false) ? { t: 0.0381, w: 0.0889 } : { t: 0.038, w: 0.089 }; }
  function _gbLayout(s) {
    s = s || STATE;
    var P = _gbProf(s), t = P.t, w = P.w, i, k, q, r;
    var L = Math.max(GB.L_MIN, Math.min(GB.L_MAX, (+s.L) || GB.L_DEFAULT));
    var H = _gbSeatTop(s);
    var nL = 2 * GB.N_SEAT - 1, D = nL * t, zE = L / 2 - w / 2;
    var bradL = (s.isMetric === false) ? GB.BRAD_LEN_US : GB.BRAD_LEN;
    /* v285 the armrests: the stack rises to the cap's underside */
    var arms = _gbArmsOn(s), armTop = arms ? _gbArmTop(s) : H, top = arms ? armTop - t : H, hF = top - H, capL = D;   /* v286 flush with the front and back */
    var pieces = [], brads = [], screws = [], pockets = [];
    var pkL = (s.isMetric === false) ? GB.PKT_LEN_US : GB.PKT_LEN, pkA = GB.PKT_ANG * Math.PI / 180, pkC = Math.cos(pkA), pkS = Math.sin(pkA);
    var pkBelow = pkL - GB.PKT_IN / pkC;   /* the screw's length under the post's top */
    function box(kind, layer, len, id, x, y, z, sx, sy, sz) { pieces.push({ kind: kind, layer: layer, code: GB.CODE, len: len, id: id, box: [x, y, z, sx, sy, sz, 0] }); }
    for (i = 0; i < nL; i++) {
      var x = -D / 2 + t / 2 + i * t, seat = (i % 2 === 0);
      if (seat) box('seat', i, L, 'seat-board-' + (i / 2 + 1), x, H - w / 2, 0, t, w, L);
      for (k = -1; k <= 1; k += 2) {
        var sd = (k < 0) ? 'l' : 'r';
        if (seat) {
          box('leg', i, H - w, 'leg-short-' + sd + '-' + (i + 1), x, (H - w) / 2, k * zE, t, H - w, w);
        } else {
          box('leg', i, top, 'leg-full-' + sd + '-' + (i + 1), x, top / 2, k * zE, t, top, w);
          if (arms) {
            /* v286 the pocket screw: head in the pocket under the inner face,
               15 deg off the vertical towards the outside, through the post's
               top (PKT_EXIT in from the inner face) and PKT_IN into the cap */
            var zIn = k * (zE - w / 2);
            screws.push({ layer: i, x: x, y: top - pkBelow * pkC, z: zIn + k * (GB.PKT_EXIT - pkBelow * pkS), dir: [0, pkC, k * pkS], len: pkL, r: 0.0025 });
            pockets.push({ layer: i, x: x, y: top - GB.PKT_MARK, z: zIn - k * 0.001 });
          }
        }
        /* pinned to the layer behind: two at the seat's height, two lower down */
        if (i > 0) for (q = -1; q <= 1; q += 2) {
          for (r = 0; r < 2; r++) brads.push({ layer: i, x: x + t / 2, y: r ? H - w / 2 : (H - w) / 2, z: k * zE + q * w / 4, dir: [-1, 0, 0], len: bradL, r: GB.BRAD_R });
        }
      }
    }
    if (arms) for (k = -1; k <= 1; k += 2) {
      pieces.push({ kind: 'arm', layer: -1, code: GB.CODE, len: capL, id: 'armrest-' + ((k < 0) ? 'l' : 'r'), box: [0, armTop - t / 2, k * zE, capL, t, w, 0] });
    }
    /* the glue: every layer face to face over the leg up to the seat's top
       (w x H), the seat boards on their short legs (t x w) and (arms, v286)
       the caps on the posts' tops (t x w a post); the coating: every face
       but those (the posts' faces over the seat stay in view) */
    var m = 0, surf = 0;
    for (i = 0; i < pieces.length; i++) { var b = pieces[i].box; m += pieces[i].len; surf += 2 * (b[3] * b[4] + b[4] * b[5] + b[5] * b[3]); }
    var glueA = 2 * (nL - 1) * w * H + 2 * GB.N_SEAT * t * w + (arms ? 2 * (GB.N_SEAT - 1) * t * w : 0);
    return {
      P: P, L: L, H: H, D: D, nLayers: nL, zE: zE, pieces: pieces, brads: brads, screws: screws, pockets: pockets,
      arms: arms, armTop: armTop, capL: capL, postH: top, overSeat: hF,
      meters: m, seatM: GB.N_SEAT * L, glueA: glueA, glueL: Math.max(0.01, Math.ceil(glueA * CAT_NEW.GLUE_L_M2 * 100) / 100),
      coat: surf - 2 * glueA, seatTop: H, seatFront: D / 2, depth: D, height: arms ? armTop : H
    };
  }
  /* its build: layer after layer from the back, each with its brads */
  var GB_STEPS = (function () {
    var a = [{ parts: [], codes: [] }], i;
    for (i = 0; i < 2 * GB.N_SEAT - 1; i++) a.push({ parts: ['gb-layer-' + (i + 1), 'gb-hw-brad-' + (i + 1), 'gb-hw-pocket-' + (i + 1)], codes: i ? ['KVH10060', 'FEC00043'] : ['KVH10060'] });   /* v286 + the posts' pockets */
    a.push({ parts: ['gb-arm', 'gb-hw-screw-arm'], codes: ['KVH10060', 'FEC00043', 'FAS50060'] });   /* v285 the armrest caps (only with the armrests); v286 pocket screws */
    return a;
  })();
  var _gbLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 54 -- THE TWIST BENCH (bench-v414, Marek 2026-11-04 09:48 with a
     reel "This Bench Transforms With a Simple Twist"; he chose the layout
     switch and slats of an edge-glued 40 mm panel). A row of identical
     profiled slats (one template) threaded on ONE M16 rod under the seat,
     three M16 washers between every two (v419: the thrust bearings were
     too dear); every slat turns on its own.
       - THE PROFILE (RTB): an L -- a seat block 2h deep with an arch cut
         from below (two feet) and the back column at its rear up to the
         backrest's top; the rod's hole in the seat block, h over the floor
         and in the middle of the block's depth. Its three resting faces --
         the bottom, the front face, the back face -- are all h from the
         hole, so a slat turned by 90 deg stands on the floor again with the
         rod at the same height:
           SEAT  (0)       on its feet: the seat at 0.43, the back to 0.85;
           ARM   (-90 deg, the back tipped forward) on its front face: the
                 back column a level armrest 2h high (0.60) reaching 0.25
                 past the seat's front;
           TABLE (+90 deg, the back laid down behind) on its back face: the
                 front face a level top 2h high (0.60), 0.43 deep, the back
                 lying on the floor 0.25 behind the bench.
         (Each slat stands on a flat face, so the bench is lifted at an end
         to turn a group. No profile avoids it: a slat that turns forward
         freely would turn forward under a person on the seat's front edge
         too -- the front foot that holds the seat is what sweeps through
         the floor. The animation (v419) turns them in place regardless.)
       - THE LAYOUT on the info-bar switch (rtbMode): bench (all seats) >
         chairs (3 slats as an armrest at each end and between the seats)
         > chairs + table (a 10-slat table in the middle, chairs on both
         sides); the length handle sets the number of slats.
       - THE ROD: M16 threaded rod FAT16010 (US 5/8 in.) through an 18 mm
         hole; between every two slats 3 washers FAT16001 (9 mm, US 3/8
         in.); at each end a washer, a nut FAT16011 and a cap nut FAT16002
         over it (the end nuts clamp the stack; loosened to turn slats).
       - THE PANEL (v419): EGP04001 EDGE-GLUED SOLID WOOD PANEL 40 mm (US
         1 1/2 in.), m2 of the cutting plan (_rtbNest): the grain along the
         back column, two slats head to toe interlocked a pair.
       - every face coated (MFP00002).
     X = depth (front +), Y = up, Z = along the bench. _rtbLayout(STATE)
     is the single source: the renderer draws it, the BoQ sums it. */
  var RTB = {
    L_MIN: 1.50, L_MAX: 3.60, L_DEF: 1.80,
    H: 0.30, H_US: 0.3048,             /* the rod over the floor = half the seat block's depth (US 12 in.) */
    SEAT: 0.43, SEAT_US: 0.4318,       /* the seat's top (US 17 in.) */
    BACK: 0.85, BACK_US: 0.8636,       /* the back's top (US 34 in.) */
    BW: 0.10, BW_US: 0.1016,           /* the back column's depth (US 4 in.) */
    FOOT: 0.09, FOOT_US: 0.0889,       /* the front foot (US 3 1/2 in.) */
    ARCH: 0.15, ARCH_US: 0.1524,       /* the arch under the seat (US 6 in.) */
    T: 0.040, T_US: 0.0381,            /* the slat (US 1 1/2 in. butcher block) */
    GAP: 0.009, GAP_US: 0.009525,      /* v419 3 M16 washers between two slats, 3 x 3 mm (US 3 x 1/8 in. on 5/8 in.); was a thrust bearing 5 mm */
    HOLE_R: 0.009, HOLE_R_US: 0.0087,  /* 18 mm (US 11/16 in.) for the M16 (US 5/8 in.) rod */
    R_FRONT: 0.025, R_FRONT_US: 0.0254, R_ARCH: 0.04, R_ARCH_US: 0.0381,   /* v419 whole inches in US: R 1 in., R 1 1/2 in. */
    N_ARM: 3, N_TABLE: 10, N_TABLE_MIN: 8, SEAT_W: 0.55, SEAT_MIN_W: 0.45,   /* an armrest 3 slats, the table 10 (8 at the least); a chair's seat about 0.55, never under 0.45 */
    WASHER_T: 0.003, WASHER_T_US: 0.003175, WASHER_R: 0.015, WASHER_R_US: 0.0167, N_SPACER: 3,   /* v419 DIN 125 M16 30 mm (US SAE 5/8 in. 1 5/16 in.) */
    NUT_T: 0.013, CAP_T: 0.016, CAP_IN: 0.012,
    KERF: 0.006, KERF_US: 0.00635,     /* v419 the cutting plan: 6 mm (US 1/4 in.) between the parts -- a router bit / a jigsaw's allowance */
    ROD: 'FAT16010', WASHER: 'FAT16001', CAPNUT: 'FAT16002', NUT: 'FAT16011',
    PANEL: 'EGP04001',                 /* v419 EDGE-GLUED SOLID WOOD PANEL 40 mm / 1 1/2 in., m2 (catalogue row written 2026-11-04 with his OK) */
    MODES: ['bench', 'chairs', 'table']
  };
  function _rtbU(s, k) { return ((s || STATE).isMetric === false && RTB[k + '_US'] != null) ? RTB[k + '_US'] : RTB[k]; }
  function _rtbMode(s) { var m = (s || STATE).rtbMode; return (RTB.MODES.indexOf(m) >= 0) ? m : 'bench'; }
  /* the profile in its SEAT position: (x, y), the hole at (0, h) */
  function _rtbProfile(s) {
    var h = _rtbU(s, 'H'), S = _rtbU(s, 'SEAT'), B = _rtbU(s, 'BACK'), bw = _rtbU(s, 'BW'), f = _rtbU(s, 'FOOT'), A = _rtbU(s, 'ARCH');
    var r1 = _rtbU(s, 'R_FRONT'), ra = _rtbU(s, 'R_ARCH'), p = [], k, n = 6;
    function arc(cx, cy, r, a0, a1) { for (k = 0; k <= n; k++) { var a = a0 + (a1 - a0) * k / n; p.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]); } }
    p.push([-h, 0], [-h + bw, 0]);
    arc(-h + bw + ra, A - ra, ra, Math.PI, Math.PI / 2);            /* the arch: up the back foot's inner face, across, down the front foot's */
    arc(h - f - ra, A - ra, ra, Math.PI / 2, 0);
    p.push([h - f, 0], [h, 0]);
    arc(h - r1, S - r1, r1, 0, Math.PI / 2);                         /* the seat's front edge rounded */
    p.push([-h + bw, S]);
    arc(-h + bw / 2, B - bw / 2, bw / 2, 0, Math.PI);                /* the back's top round */
    return { pts: p, h: h, seat: S, back: B, bw: bw };
  }
  function _rtbRot(pts, ang, h) {
    var c = Math.round(Math.cos(ang) * 1e9) / 1e9, sn = Math.round(Math.sin(ang) * 1e9) / 1e9;
    return pts.map(function (q) { var dy = q[1] - h; return [c * q[0] - sn * dy, h + sn * q[0] + c * dy]; });
  }
  /* v419 THE PROFILE AS IT IS CUT: lines + true arcs, (x, y) in the seat
     position with the hole at (0, h) -- the part sheet and the DXF draw it */
  function _rtbSegs(s) {
    var h = _rtbU(s, 'H'), S = _rtbU(s, 'SEAT'), B = _rtbU(s, 'BACK'), bw = _rtbU(s, 'BW'), f = _rtbU(s, 'FOOT'), A = _rtbU(s, 'ARCH');
    var r1 = _rtbU(s, 'R_FRONT'), ra = _rtbU(s, 'R_ARCH');
    var L = function (x0, y0, x1, y1) { return { t: 'L', a: [x0, y0], b: [x1, y1] }; };
    var C = function (cx, cy, r, a0, a1) { return { t: 'A', c: [cx, cy], r: r, a0: a0, a1: a1 }; };   /* from a0 to a1 (deg), the way the outline runs */
    return {
      segs: [
        L(-h, 0, -h + bw, 0),                          /* the back foot */
        L(-h + bw, 0, -h + bw, A - ra),
        C(-h + bw + ra, A - ra, ra, 180, 90),          /* the arch */
        L(-h + bw + ra, A, h - f - ra, A),
        C(h - f - ra, A - ra, ra, 90, 0),
        L(h - f, A - ra, h - f, 0),
        L(h - f, 0, h, 0),                             /* the front foot */
        L(h, 0, h, S - r1),                            /* the front face (the armrest's foot) */
        C(h - r1, S - r1, r1, 0, 90),                  /* the seat's front edge */
        L(h - r1, S, -h + bw, S),                      /* the seat */
        L(-h + bw, S, -h + bw, B - bw / 2),            /* the back column's front */
        C(-h + bw / 2, B - bw / 2, bw / 2, 0, 180),    /* its round top */
        L(-h, B - bw / 2, -h, 0)                       /* the back face (the table's foot) */
      ],
      hole: { c: [0, h], r: _rtbU(s, 'HOLE_R') },
      h: h, S: S, B: B, bw: bw, f: f, A: A, r1: r1, ra: ra
    };
  }
  function _rtbSegPts(G, n) {
    var p = [];
    G.segs.forEach(function (q) {
      if (q.t === 'L') { p.push(q.a); return; }
      for (var k = 0; k < n; k++) { var a = (q.a0 + (q.a1 - q.a0) * k / n) * Math.PI / 180; p.push([q.c[0] + q.r * Math.cos(a), q.c[1] + q.r * Math.sin(a)]); }
    });
    return p;
  }
  /* v422 (Marek 13:08: Ano, bocni cela) THE END CHEEK: a quarter disc of
     the same panel, R = 2h round the back's foot -- its floor edge the
     slat's depth (2h), its back edge 2h up, the arc from the back's top
     down to the seat's front corner on the floor; the rod's hole where the
     slats' is (h from the back, h up). Two of them, one at each end of the
     rod, 3 washers from the end slat, the end washer + nut + cap nut
     outside. A cheek stands on its flat edge (both sides of the rod), so it
     never turns: the nut is tightened against a part that stays put, and
     every slat between still turns. (x, y) as the slat's, the hole at
     (0, h). */
  function _rtbCheek(s) {
    var h = _rtbU(s, 'H'), R = 2 * h;
    var L = function (x0, y0, x1, y1) { return { t: 'L', a: [x0, y0], b: [x1, y1] }; };
    return {
      segs: [
        L(-h, 0, h, 0),                                          /* the floor edge */
        { t: 'A', c: [-h, 0], r: R, a0: 0, a1: 90 },             /* the arc round the back's foot */
        L(-h, R, -h, 0)                                          /* the back edge */
      ],
      hole: { c: [0, h], r: _rtbU(s, 'HOLE_R') },
      h: h, R: R
    };
  }
  /* v419 (Marek 11:04: v rozpoctu chybi vhodny deskovy material, idealne
     realne mnozstvi v ft2 / m2 s co nejmensim prorezem) THE CUTTING PLAN.
     The grain runs along the back column (it carries the back and the
     armrest), so on the panel a slat is only ever turned by 180 deg. Two
     slats head to toe, interlocked: the second's column down beside the
     first's seat block, its seat block over the first's column -- a pair
     takes (2h + back column + 2 kerf) x (max(2 seat + kerf, back) + kerf);
     the pairs one after another along a strip that wide, an odd slat at
     its end. Billed: the strips' m2, cut to size; the offcut is the arches
     and the roundings. */
  function _rtbNest(s) {
    var G = _rtbSegs(s), k = _rtbU(s, 'KERF'), h = G.h, N = _rtbN(s), hr = G.hole.r;
    var pw = 2 * h + G.bw + 2 * k, hh = Math.max(2 * G.S + k, G.B), ph = hh + k, oneL = G.B + k;
    var pairs = Math.floor(N / 2), single = N % 2;
    /* v422 the two end cheeks at the strip's end, interlocked: one upright in
       the corner, the other turned 180 deg in the far corner, their arcs a
       kerf apart (the centres 2R + kerf apart) -- 712 x 984 mm (US 28 1/2 x
       39 3/8 in.) for the two, the grain along the strip as the slats' */
    var C = _rtbCheek(s), R = C.R, wc = pw - k;
    var cy = Math.max(R, Math.sqrt(Math.max(0, (2 * R + k) * (2 * R + k) - wc * wc))), cL = cy + k;
    var m2 = pairs * pw * ph + single * pw * oneL + pw * cL;
    var a1 = _rtbArea(_rtbSegPts(G, 24)) - Math.PI * hr * hr;
    var ac = Math.PI * R * R / 4 - Math.PI * hr * hr;
    return {
      k: k, pw: pw, ph: ph, hh: hh, pairs: pairs, single: single, N: N,
      stripL: pairs * ph + single * oneL + cL, cL: cL, cy: cy, cR: R, ac: ac,
      m2: Math.round(m2 * 100) / 100, a1: a1,
      off: Math.max(0, 1 - (N * a1 + 2 * ac) / Math.max(1e-9, m2))
    };
  }
  function _rtbArea(pts) { var a = 0, i, j; for (i = 0, j = pts.length - 1; i < pts.length; j = i++) a += (pts[j][0] + pts[i][0]) * (pts[j][1] - pts[i][1]); return Math.abs(a) / 2; }
  function _rtbPerim(pts) { var l = 0, i, j; for (i = 0, j = pts.length - 1; i < pts.length; j = i++) l += Math.hypot(pts[i][0] - pts[j][0], pts[i][1] - pts[j][1]); return l; }
  /* the slats' count from the length (v422 the bench overall: the two cheeks
     and their washers taken off first; the nuts apart) */
  function _rtbSeatN(s) { var p = _rtbU(s, 'T') + _rtbU(s, 'GAP'); return { min: Math.ceil(RTB.SEAT_MIN_W / p - 1e-6), def: Math.round(RTB.SEAT_W / p) }; }
  /* the fewest slats a layout takes: chairs + table -- an armrest and a
     chair each side of the smallest table */
  function _rtbNMin(s) { return (_rtbMode(s) === 'table') ? 2 * (RTB.N_ARM + _rtbSeatN(s).min) + RTB.N_TABLE_MIN : 2 * RTB.N_ARM + _rtbSeatN(s).min; }
  function _rtbN(s) {
    var t = _rtbU(s, 'T'), g = _rtbU(s, 'GAP');
    var L = Math.max(RTB.L_MIN, Math.min(RTB.L_MAX, (+(s || STATE).L) || RTB.L_DEF));
    /* v422 the nearest count (1.80 -> 35 slats, 1.804 overall), never past the longest */
    var x = (L - 2 * (t + g) + g) / (t + g), n = Math.round(x);
    if (n * (t + g) - g + 2 * (t + g) > RTB.L_MAX + 1e-6) n = Math.floor(x + 1e-6);
    return Math.max(_rtbNMin(s), n);
  }
  function _rtbRange(s) {
    var t = _rtbU(s, 'T'), g = _rtbU(s, 'GAP'), nm = _rtbNMin(s);
    return { min: Math.max(RTB.L_MIN, Math.ceil((nm * t + (nm - 1) * g + 2 * (t + g)) * 1000) / 1000), max: RTB.L_MAX };
  }
  /* the groups along the bench: [{ m: 'S'|'A'|'T', n }] */
  function _rtbGroups(s, N) {
    var mode = _rtbMode(s), nA = RTB.N_ARM, SN = _rtbSeatN(s), out = [], i, c, S;
    function seats(total, k) { var base = Math.floor(total / k), rem = total - base * k, a = [], j; for (j = 0; j < k; j++) a.push(base); for (j = 0; j < rem; j++) a[Math.floor((k - rem) / 2) + j]++; return a; }
    if (mode === 'chairs') {
      c = Math.max(1, Math.round((N - nA) / (SN.def + nA)));
      while (c > 1 && (N - (c + 1) * nA) / c < SN.min) c--;
      S = seats(N - (c + 1) * nA, c);
      out.push({ m: 'A', n: nA });
      for (i = 0; i < c; i++) { out.push({ m: 'S', n: S[i] }); out.push({ m: 'A', n: nA }); }
      return out;
    }
    if (mode === 'table') {
      var nT = RTB.N_TABLE;
      if (Math.floor((N - nT) / 2) - nA < SN.min) nT = RTB.N_TABLE_MIN;
      var left = Math.floor((N - nT) / 2), right = N - nT - left;
      if (left - nA < SN.min) return [{ m: 'S', n: N }];   /* too short for a table (the length's minimum prevents it): the bench */
      var half = function (sideN, mirror) {
        var k = Math.max(1, Math.round(sideN / (SN.def + nA)));
        while (k > 1 && (sideN - k * nA) / k < SN.min) k--;
        var sv = seats(sideN - k * nA, k), a = [], j;
        for (j = 0; j < k; j++) { a.push({ m: 'A', n: nA }); a.push({ m: 'S', n: sv[j] }); }   /* the outer armrest first; the seat next to the table has none */
        return mirror ? a.reverse() : a;
      };
      return half(left, false).concat([{ m: 'T', n: nT }]).concat(half(right, true));
    }
    return [{ m: 'S', n: N }];
  }
  function _rtbLayout(s) {
    s = s || STATE;
    var t = _rtbU(s, 'T'), g = _rtbU(s, 'GAP'), hr = _rtbU(s, 'HOLE_R'), us = (s.isMetric === false);
    var P = _rtbProfile(s), h = P.h, N = _rtbN(s), groups = _rtbGroups(s, N), i, k;
    var Ls = N * t + (N - 1) * g, z0 = -Ls / 2;
    var ANG = { S: 0, A: -Math.PI / 2, T: Math.PI / 2 };
    var slats = [], spacers = [], gi, idx = 0, wT = _rtbU(s, 'WASHER_T'), nSp = RTB.N_SPACER;
    var area1 = _rtbArea(P.pts) - Math.PI * hr * hr, per1 = _rtbPerim(P.pts) + 2 * Math.PI * hr;
    for (gi = 0; gi < groups.length; gi++) {
      var G = groups[gi];
      G.i0 = idx; G.k = gi + 1;
      for (k = 0; k < G.n; k++, idx++) {
        var zc = z0 + t / 2 + idx * (t + g);
        slats.push({ i: idx, g: gi + 1, m: G.m, ang: ANG[G.m], z: zc, poly: _rtbRot(P.pts, ANG[G.m], h), id: 'slat-' + (idx + 1) });
        /* v419 the 3 washers on its far side (between this slat and the next) go with it */
        if (idx < N - 1) spacers.push({ g: gi + 1, z0: zc + t / 2, n: nSp, wt: wT });
      }
    }
    /* v422 the end cheeks, 3 washers off the end slats (those go with the cheek) */
    var CK = _rtbCheek(s), cPts = _rtbSegPts(CK, 24), Lt = Ls + 2 * (g + t);
    spacers.unshift({ g: 'a', z0: -Ls / 2 - g, n: nSp, wt: wT });
    spacers.push({ g: 'b', z0: Ls / 2, n: nSp, wt: wT });
    var cheeks = [{ e: 'a', z: -(Ls / 2 + g + t / 2), poly: cPts }, { e: 'b', z: Ls / 2 + g + t / 2, poly: cPts }];
    var areaC = _rtbArea(cPts) - Math.PI * hr * hr, perC = _rtbPerim(cPts) + 2 * Math.PI * hr;
    /* the ends: a washer on the cheek (v422; was the end slat), a nut, the cap nut */
    var endA = [], endB = [], o = Lt / 2;
    [-1, 1].forEach(function (sz) {
      var L = (sz < 0) ? endA : endB, zz = sz * o;
      L.push({ kind: 'washer', z: zz + sz * (wT / 2), h: wT });
      L.push({ kind: 'nut', z: zz + sz * (wT + RTB.NUT_T / 2), h: RTB.NUT_T });
      L.push({ kind: 'cap', z: zz + sz * (wT + RTB.NUT_T + RTB.CAP_T / 2), h: RTB.CAP_T });
    });
    var over = wT + RTB.NUT_T + RTB.CAP_IN, rodL = Math.round((Lt + 2 * over) * 1000) / 1000;   /* v422 through the cheeks */
    /* the extents: the seat block's depth, + the armrests' reach in front, + the
       backs laid down behind */
    var hasA = groups.some(function (q) { return q.m === 'A'; }), hasT = groups.some(function (q) { return q.m === 'T'; });
    var reach = P.back - 2 * h;
    var xMax = h + (hasA ? reach : 0), xMin = -h - (hasT ? reach : 0);
    var nest = _rtbNest(s);   /* v419 the panel by the cutting plan */
    var cnt = { S: 0, A: 0, T: 0 };
    slats.forEach(function (q) { cnt[q.m]++; });
    return {
      us: us, P: P, h: h, t: t, g: g, holeR: hr, N: N, groups: groups, slats: slats, spacers: spacers, endA: endA, endB: endB,
      cheeks: cheeks, cheekR: CK.R, areaC: areaC,                                                    /* v422 */
      Ls: Ls, rodL: rodL, rodR: 0.008, nWasher: nSp * spacers.length + 2, washerR: _rtbU(s, 'WASHER_R'), nest: nest, panelM2: nest.m2,
      coat: Math.round((N * (2 * area1 + per1 * t) + 2 * (2 * areaC + perC * t)) * 100) / 100,   /* v422 + the cheeks */
      area1: area1, count: cnt, mode: _rtbMode(s),
      L: Lt, depth: xMax - xMin, xMin: xMin, xMax: xMax, height: P.back, seatTop: P.seat, seatFront: h   /* v422 L = the bench overall */
    };
  }
  /* its build: the rod with one end's hardware and cheek (v422, + its 3
     washers), the slats group by group (each with the washers on its far
     side), the other cheek with its washers and that end's hardware */
  function _rtbSteps(s) {
    var g = _rtbLayout(s || STATE), a = [{ parts: [], codes: [] }], i;
    a.push({ parts: ['rtb-hw-bolt-rod', 'rtb-hw-end-a', 'rtb-cheek-a', 'rtb-hw-spacer-a'], codes: [RTB.ROD, RTB.WASHER, RTB.NUT, RTB.CAPNUT, RTB.PANEL] });
    for (i = 0; i < g.groups.length; i++) a.push({ parts: ['rtb-slat-' + (i + 1), 'rtb-hw-spacer-' + (i + 1)], codes: [RTB.PANEL, RTB.WASHER] });   /* v419 the panel + the washers (catalogue names) */
    a.push({ parts: ['rtb-hw-spacer-b', 'rtb-cheek-b', 'rtb-hw-end-b'], codes: [RTB.PANEL, RTB.WASHER, RTB.NUT, RTB.CAPNUT] });
    return a;
  }
  var _rtbLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 16 -- THE DOUBLE SUNBED (bench-v288, Marek 2026-10-20 00:09 with
     a reel "Build your own double sunbed?", 11:35-11:41: ram profil na
     vysku, 2x6 + uprostred 2x4, opera hlavy jedna pres celou sirku,
     editovat sirka, i detska varianta; v290 13:19-13:21: uhel vzpery
     lepe, zkus to jinak -> he chose the positions 0/30/45/60/75; nohy
     ctvercovy profil z vnitrni strany ramu, ram par cm nad zemi, pocet
     noh podle zatizeni): a low open box on legs --
       - the frame: 2x6 on edge (KVH60160, US 1 1/2 x 5 1/2), the long
         sides the full length, the end boards between them, 3 screws
         FAS60160 a corner through the side into the end board; its
         bottom H0 (5 cm, US 2 in.) over the ground;
       - v290 THE LEGS: 4x4 (KVH10100, US 3 1/2) inside the frame, on the
         ground, 2 screws FAS80100 through each frame board they touch:
         the 4 inside corners (at the foot up to the slats, at the head up
         to the backrest's battens, which lie on them when flat), and on
         the adult size 2 more on the long sides (under the ledgers) and
         1 by the middle 2x4 (under the slats), all at the middle of the
         fixed part -- 7 legs adult (2 people), 4 kids;
       - a 2x4 on edge in the middle (KVH10060), the full inside length,
         2 x FAS60160 through each end board;
       - 2x2 ledgers (KVH03838) on the long sides' inner faces, the hinge
         to the foot legs, their top flush with the 2x4's, FAS50060 every
         30 cm; the slats 1x4 (TIM20100) across the width on them, 2
         stainless screws FAS55050 a support, their top flush with the
         frame's top (v292, was ~4 cm under it);
       - THE BACKREST, one over the whole width: the slats on three 2x2
         battens (two by the sides, one by the middle 2x4), hinged on an
         M10 bolt FAT10002 through the side / the 2x4 into each batten's
         foot end; three 2x2 props, each on an M10 bolt low on the side /
         the 2x4 in its batten's plane, folded towards the head under the
         battens when flat, swung up into 6 mm notches CUT in the batten's
         underside (v290: real cut-outs, no dark marks): 0 / 30 / 45 / 60
         / 75 deg (the slider; v292 no drag point); the props stand 46-100 deg -- their bolts / lengths found
         by search (the steepest props with the support at least a third
         of the backrest from the hinge; 15 deg would lay any prop of this
         box at ~30 deg);
       - the width on the drag point (the lying surface 0.70-2.00 m, 5 cm
         steps; US 28-78 in., 2 in.; v293 up to 1.00 m / 40 in. a single
         of ONE bay -- no middle 2x4 and nothing on it), the length fixed
         (2.00 m / 78 in.);
         the level button = the kids' size (1.40 m / 55 in. long, the
         backrest 55 cm, 0.70-1.20 m wide).
     No mattress (the reel has none). _sbLayout(STATE) is the single
     source: the renderer draws it, the BoQ sums it. */
  var SB = {
    FRAME: 'KVH60160', JOIST: 'KVH10060', BATTEN: 'KVH03838', SLAT: 'TIM20100', LEG: 'KVH10100', RACK: 'KVH10060',
    CORNER_SCREW: 'FAS60160', LEDGER_SCREW: 'FAS50060', SLAT_SCREW: 'FAS55050', BOLT: 'FAT10002', LEG_SCREW: 'FAS80100',
    LOCKNUT: 'NYLON INSERT LOCK NUT, M10 (US 3/8 IN.)',   /* v289 one a pivot bolt instead of the set's plain nut; no catalogue row: NOT BILLED, logged (status MISSING) */
    IL: 2.00, IL_KID: 1.40, IL_US: 78 * 0.0254, IL_KID_US: 55 * 0.0254,     /* the lying surface's length */
    BL: 0.80, BL_KID: 0.55, BL_US: 32 * 0.0254, BL_KID_US: 22 * 0.0254,     /* the backrest's length */
    WR: { min: 0.70, max: 2.00, def: 1.60, step: 0.05 },   /* v293 from 0.70 (a single), was 1.20 */
    WR_KID: { min: 0.70, max: 1.20, def: 0.90, step: 0.05 },
    WR_US: { min: 28 * 0.0254, max: 78 * 0.0254, def: 64 * 0.0254, step: 2 * 0.0254 },   /* v293 from 28 in., was 48 */
    ONE_BAY: 1.00, ONE_BAY_US: 40 * 0.0254,   /* v293 (Marek 15:11: i single, sirka 0,7, jedno pole): up to this lying width ONE bay -- no middle 2x4 / batten / prop / rack / leg */
    WR_KID_US: { min: 28 * 0.0254, max: 48 * 0.0254, def: 36 * 0.0254, step: 2 * 0.0254 },
    ANG: [0, 30, 45, 60, 75], ANG_DEF: 30,   /* v290 (was 0/15/30/45/60) */
    H0: 0.05, H0_US: 2 * 0.0254,             /* v290 the frame's bottom over the ground */
    GAP: 0.012,          /* between the slats (evened out over the run) */
    END_GAP: 0.010,      /* the slats off the end boards */
    SIDE_CLR: 0.002,     /* the fixed slats off the sides */
    PANEL_CLR: 0.006,    /* the backrest's slats off the sides (it swings between them) */
    PANEL_E: 0.016,      /* its first slat this far past the hinge's axis: its bottom edge never dips under the middle 2x4's top (>= b/2 tan 37.5 deg) */
    WASH: 0.003,         /* a washer between a batten / prop and the face it is bolted to */
    LEDGER_PITCH: 0.30,
    NOTCH_D: 0.006,      /* v290 the notches' depth (v291: in the racks' top) */
    /* v291 (Marek 14:21: kloub ve vrchni casti, v profilu hlavove casti kde
       jsou ted zarezy; vzperu otocit k ramu u hlavy): each prop hangs on an
       M10 bolt through its backrest batten, [0] x Lb from the hinge (3 mm
       under the batten's axis, the prop's top end rounded), cut length
       [1] x Lb, its foot towards the head in a notch of a 2x4 rack laid
       flat low in the frame (by the sides from the head legs, by the
       middle 2x4); searched per size: the props stand 30-80 deg */
    PROP: { m: [0.36, 0.41], mk: [0.39, 0.47], us: [0.36, 0.41], usk: [0.40, 0.48] }, PROP_V: -0.003,
    RACK_U0: 0.08,       /* v291 the racks start this far from the hinge towards the head */
    /* the catalogue's lengths (US = the imperial column) */
    LEN: { FAS60160: [0.160, 0.127], FAS50060: [0.060, 0.0635], FAS55050: [0.050, 0.0508], FAT10002: [0.130, 0.127], FAS80100: [0.100, 0.1016] }
  };
  function _sbKid(s) { return (s || STATE).lvl === 2; }
  function _sbProf(s) {
    if ((s || STATE).isMetric === false) return { ft: 0.0381, fh: 0.1397, jw: 0.0381, jh: 0.0889, b: 0.0381, st: 0.01905, sw: 0.0889, lg: 0.0889 };
    return { ft: 0.060, fh: 0.160, jw: 0.060, jh: 0.100, b: 0.038, st: 0.020, sw: 0.100, lg: 0.100 };
  }
  function _sbWR(s) {
    s = s || STATE;
    var us = (s.isMetric === false), kid = _sbKid(s);
    return us ? (kid ? SB.WR_KID_US : SB.WR_US) : (kid ? SB.WR_KID : SB.WR);
  }
  /* the lying surface's width: STATE.sbW snapped into the size's range (null = its default) */
  function _sbW(s) {
    s = s || STATE;
    var R = _sbWR(s), w = +s.sbW;
    if (!(w > 0)) w = R.def;
    w = Math.max(R.min, Math.min(R.max, w));
    return Math.round((R.min + Math.round((w - R.min) / R.step) * R.step) * 10000) / 10000;
  }
  /* the backrest's angle: the nearest notch (a tie goes up: 15 -> 30) */
  function _sbAng(s) {
    s = s || STATE;
    var v = +s.sbAng, i, best = SB.ANG_DEF;
    if (!isFinite(v) || s.sbAng === null || s.sbAng === undefined) return SB.ANG_DEF;
    for (i = 0; i < SB.ANG.length; i++) {
      var dA = Math.abs(SB.ANG[i] - v), dB = Math.abs(best - v);
      if (dA < dB - 1e-9 || (Math.abs(dA - dB) < 1e-9 && SB.ANG[i] > best)) best = SB.ANG[i];
    }
    return best;
  }
  function _sbLen(code, s) { var l = SB.LEN[code]; return l ? l[((s || STATE).isMetric === false) ? 1 : 0] : 0.05; }
  /* v291 a prop hung on its bolt T (on the batten, d from the hinge, vP off
     its axis) at the angle a: its foot towards the head, swung down until
     the lower corner of its end meets the bottom of a notch nd deep in the
     rack's top yR; returns psi (its angle under the level), the bolt and
     the notch's extent along u (the part of the prop under the rack's top,
     +1.5 mm a side) */
  function _sbFootAt(a, d, lp, b, yP, vP, yR, nd) {
    var ca = Math.cos(a), sa = Math.sin(a), Tu = d * ca - vP * sa, Ty = yP + d * sa + vP * ca, Lf = lp - b / 2;
    function f(ps) { return Ty - Lf * Math.sin(ps) - (b / 2) * Math.cos(ps) - (yR - nd); }
    if (f(0) < 0 || f(Math.PI / 2) > 0) return null;
    var lo = 0, hi = Math.PI / 2, k;
    for (k = 0; k < 50; k++) { var m = (lo + hi) / 2; if (f(m) > 0) lo = m; else hi = m; }
    var ps = lo, e = [Math.cos(ps), -Math.sin(ps)], ep = [Math.sin(ps), Math.cos(ps)];
    var E1 = [Tu + Lf * e[0], Ty + Lf * e[1]];
    var c1 = [E1[0] + b / 2 * ep[0], E1[1] + b / 2 * ep[1]], c2 = [E1[0] - b / 2 * ep[0], E1[1] - b / 2 * ep[1]];
    var s1 = [Tu + b / 2 * ep[0], Ty + b / 2 * ep[1]], s2 = [Tu - b / 2 * ep[0], Ty - b / 2 * ep[1]];
    var pts = [], segs = [[s1, c1], [s2, c2], [c1, c2]], i;
    if (c1[1] < yR) pts.push(c1[0]);
    if (c2[1] < yR) pts.push(c2[0]);
    for (i = 0; i < segs.length; i++) {
      var A = segs[i][0], B = segs[i][1];
      if ((A[1] - yR) * (B[1] - yR) < 0) { var t = (yR - A[1]) / (B[1] - A[1]); pts.push(A[0] + t * (B[0] - A[0])); }
    }
    if (!pts.length) return null;
    return { psi: ps, T: [Tu, Ty], n0: Math.min.apply(null, pts) - 0.0015, n1: Math.max.apply(null, pts) + 0.0015 };
  }
  function _sbLayout(s) {
    s = s || STATE;
    var P = _sbProf(s), us = (s.isMetric === false), kid = _sbKid(s), i, k, q;
    var ft = P.ft, fh = P.fh, b = P.b, st = P.st, sw = P.sw, lg = P.lg;
    var iW = _sbW(s), iL = us ? (kid ? SB.IL_KID_US : SB.IL_US) : (kid ? SB.IL_KID : SB.IL);
    var Lb = us ? (kid ? SB.BL_KID_US : SB.BL_US) : (kid ? SB.BL_KID : SB.BL);
    var ang = _sbAng(s), a = ang * Math.PI / 180, ca = Math.cos(a), sa = Math.sin(a);
    var dbl = iW > (us ? SB.ONE_BAY_US : SB.ONE_BAY) + 1e-6;       /* v293 two bays (the middle 2x4) or one */
    var KS = dbl ? [0, 1, 2] : [0, 2];                              /* the battens / props / racks: left, (middle,) right */
    var Y0 = us ? SB.H0_US : SB.H0;                                 /* v290 the frame on its legs */
    var W = iW + 2 * ft, L = iL + 2 * ft;
    /* v292 (Marek 14:31: vrchni plocha planks musi licovat s vrchni plochou
       ramu): the slats' top = the frame's top; everything inside (the middle
       2x4, the ledgers, the backrest, the legs, the racks, the props) rides
       up with them -- the middle 2x4 now hangs off the ground between the end
       boards (+ its leg); y from the frame's bottom (Y0 added on output) */
    var yT = fh, yS = yT - st, jy0 = yS - P.jh, zHead = -iL / 2, zFoot = iL / 2;
    var zP = zHead + SB.END_GAP + Lb, yP = yS - b / 2;            /* the hinge: under the backrest's foot edge, on the battens' axis */
    var aMax = SB.ANG[SB.ANG.length - 1] * Math.PI / 180;
    var hingeGap = (b / 2 + st) * Math.sin(aMax) - SB.PANEL_E * Math.cos(aMax) + 0.006;   /* the first back slat's top edge sweeps this far towards the foot at the top angle (+6 mm) */
    var ledZ0 = zP + b * Math.SQRT2 / 2 + 0.006;                   /* the ledgers start past the battens' swinging foot ends */
    var pieces = [], fas = [];
    function piece(kind, code, len, id, x, y, z, sx, sy, sz, rot, extra) { var pc = { kind: kind, code: code, len: Math.round(len * 1000) / 1000, id: id, box: [x, y + Y0, z, sx, sy, sz], rot: rot || 0 }; if (extra) for (var e in extra) pc[e] = extra[e]; pieces.push(pc); return pc; }
    function fa(kind, code, id, x, y, z, dir, r) { fas.push({ kind: kind, code: code, id: id, x: x, y: y + Y0, z: z, dir: dir, len: _sbLen(code, s), r: r || 0.003 }); }
    /* the backrest's frame: u towards the head from the hinge, v up from its axis */
    function pw(u, v) { return { z: zP - (u * ca - v * sa), y: yP + (u * sa + v * ca) }; }
    /* THE FRAME */
    for (k = -1; k <= 1; k += 2) piece('frame', SB.FRAME, L, 'side-' + ((k < 0) ? 'l' : 'r'), k * (iW / 2 + ft / 2), fh / 2, 0, ft, fh, L);
    piece('frame', SB.FRAME, iW, 'end-head', 0, fh / 2, -(iL / 2 + ft / 2), iW, fh, ft);
    piece('frame', SB.FRAME, iW, 'end-foot', 0, fh / 2, iL / 2 + ft / 2, iW, fh, ft);
    for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) for (i = 1; i <= 3; i++)
      fa('screw-corner', SB.CORNER_SCREW, 'corner-' + k + q + i, k * (iW / 2 + ft), fh * i / 4, q * (iL / 2 + ft / 2), [-k, 0, 0]);
    /* THE MIDDLE 2x4 */
    if (dbl) {
      piece('joist', SB.JOIST, iL, 'middle', 0, jy0 + P.jh / 2, 0, P.jw, P.jh, iL);
      for (q = -1; q <= 1; q += 2) for (i = 1; i <= 2; i++) fa('screw-joist', SB.CORNER_SCREW, 'middle-' + q + i, 0, jy0 + P.jh * i / 3, q * (iL / 2 + ft), [0, 0, -q]);
    }
    /* v290 THE LEGS (y from the ground: -Y0 .. top), 2 screws through each frame board they touch */
    var zMid = (zP + zFoot) / 2, nLeg = 0;
    function leg(id, x, z, top) {
      var h = top + Y0;
      piece('leg', SB.LEG, h, id, x, top - h / 2, z, lg, h, lg);
      nLeg++;
      return top;   /* the frame's bottom (0) .. top: where screws go */
    }
    for (k = -1; k <= 1; k += 2) for (q = -1; q <= 1; q += 2) {
      var foot = (q > 0), tp = foot ? yS : (yS - b), xl = k * (iW / 2 - lg / 2), zl = q * (iL / 2 - lg / 2), sdq = ((k < 0) ? 'l' : 'r') + (foot ? 'f' : 'h');
      leg('leg-' + sdq, xl, zl, tp);
      for (i = 1; i <= 2; i++) {
        fa('screw-leg', SB.LEG_SCREW, 'leg-' + sdq + '-s' + i, k * (iW / 2 + ft), tp * i / 3, zl, [-k, 0, 0]);
        fa('screw-leg', SB.LEG_SCREW, 'leg-' + sdq + '-e' + i, xl, tp * i / 3, q * (iL / 2 + ft), [0, 0, -q]);
      }
    }
    if (!kid) {
      for (k = -1; k <= 1; k += 2) {
        var sdm = (k < 0) ? 'l' : 'r', tpm = yS - b;
        leg('leg-' + sdm + 'm', k * (iW / 2 - lg / 2), zMid, tpm);
        for (i = 1; i <= 2; i++) fa('screw-leg', SB.LEG_SCREW, 'leg-' + sdm + 'm-s' + i, k * (iW / 2 + ft), tpm * i / 3, zMid, [-k, 0, 0]);
      }
      if (dbl) {
        leg('leg-middle', -(P.jw / 2 + lg / 2), zMid, yS);
        for (i = 1; i <= 2; i++) fa('screw-leg', SB.LEG_SCREW, 'leg-middle-s' + i, P.jw / 2, jy0 + P.jh * i / 3, zMid, [-1, 0, 0]);
      }
    }
    /* THE LEDGERS (the fixed part, from the hinge to the foot legs) */
    var ledZ1 = zFoot - lg, ledL = ledZ1 - ledZ0;
    for (k = -1; k <= 1; k += 2) {
      var sd = (k < 0) ? 'l' : 'r', xL = k * (iW / 2 - b / 2);
      piece('ledger', SB.BATTEN, ledL, 'ledger-' + sd, xL, yS - b / 2, (ledZ0 + ledZ1) / 2, b, b, ledL);
      var nLs = Math.max(2, Math.floor(ledL / SB.LEDGER_PITCH) + 1);
      for (i = 0; i < nLs; i++) fa('screw-ledger', SB.LEDGER_SCREW, 'ledger-' + sd + (i + 1), k * (iW / 2 - b), yS - b / 2, ledZ0 + 0.05 + i * (ledL - 0.10) / (nLs - 1), [k, 0, 0]);
    }
    /* THE FIXED SLATS: from the hinge gap to the foot, evenly spaced */
    var zF0 = zP + hingeGap, zF1 = zFoot - SB.END_GAP, availF = zF1 - zF0;
    var nF = Math.max(1, Math.floor((availF + SB.GAP) / (sw + SB.GAP))), gF = (nF > 1) ? (availF - nF * sw) / (nF - 1) : 0;
    var slatLen = iW - 2 * SB.SIDE_CLR, xSup = [-(iW / 2 - b / 2), 0, iW / 2 - b / 2];
    for (i = 0; i < nF; i++) {
      var zc = zF0 + i * (sw + gF) + sw / 2;
      piece('slat', SB.SLAT, slatLen, 'slat-' + (i + 1), 0, yS + st / 2, zc, slatLen, st, sw);
      for (k = 0; k < 3; k++) { if (k === 1 && !dbl) continue; for (q = -1; q <= 1; q += 2) fa('screw-slat', SB.SLAT_SCREW, 'slat-' + (i + 1) + '-' + k + q, xSup[k] + ((k === 1) ? q * P.jw / 4 : 0), yT, zc + ((k === 1) ? 0 : q * sw / 4), [0, -1, 0]); }
    }
    /* v291 THE PROPS hung from the battens, their feet towards the head in
       the racks' notches (one notch per angle); the racks 2x4 laid flat low
       in the frame -- by each side from the head leg, by the middle 2x4
       (its +X face) from the head board -- their top 2 mm under a folded
       prop; 3 x FAS80100 each through the side / the 2x4 */
    var u0 = -b / 2, u1 = Lb - 0.010;
    var pf = SB.PROP[(us ? 'us' : 'm') + (kid ? 'k' : '')], dP = Math.round(pf[0] * Lb * 1000) / 1000, lp = Math.round(pf[1] * Lb * 1000) / 1000, Lf = lp - b / 2;
    var rw = us ? 0.0889 : 0.100, rt = us ? 0.0381 : 0.060, yR = yP + SB.PROP_V - b / 2 - 0.002;
    var psi = 0, T = [dP, yP + SB.PROP_V], notchS = {}, nList = [], nOk = true;   /* at 0 deg folded towards the head along the battens */
    for (q = 1; q < SB.ANG.length; q++) {
      var sol = _sbFootAt(SB.ANG[q] * Math.PI / 180, dP, lp, b, yP, SB.PROP_V, yR, SB.NOTCH_D);
      if (!sol || sol.n0 < SB.RACK_U0 + 0.01 || sol.n1 > Lb + SB.END_GAP - lg - 0.01) { nOk = false; continue; }
      notchS[SB.ANG[q]] = (sol.n0 + sol.n1) / 2;
      nList.push([sol.n0, sol.n1]);
      if (SB.ANG[q] === ang) { psi = sol.psi; T = sol.T; }
    }
    nList.sort(function (x, y) { return x[0] - y[0]; });
    for (i = 1; i < nList.length; i++) if (nList[i][0] - nList[i - 1][1] < 0.012) nOk = false;   /* a tooth of at least 12 mm between them */
    if (dP + Lf > Lb + SB.END_GAP - lg - 0.005) nOk = false;   /* folded, it ends before the head legs */
    function rackPc(id, x, zA, zB) {
      var zc = (zA + zB) / 2, nz = nList.map(function (n) { return [zP - n[1] - zc, zP - n[0] - zc]; });
      piece('rack', SB.RACK, zA - zB, id, x, yR - rt / 2, zc, rw, rt, zA - zB, 0, { nz: nz, nd: SB.NOTCH_D, nTop: true });
      for (var r = 0; r < 3; r++) {
        var zr = zB + 0.06 + r * (zA - zB - 0.12) / 2;
        if (x > P.jw) fa('screw-rack', SB.LEG_SCREW, id + '-' + r, iW / 2 + ft, yR - rt / 2, zr, [-1, 0, 0]);
        else if (x < -P.jw) fa('screw-rack', SB.LEG_SCREW, id + '-' + r, -(iW / 2 + ft), yR - rt / 2, zr, [1, 0, 0]);
        else fa('screw-rack', SB.LEG_SCREW, id + '-' + r, -P.jw / 2, yR - rt / 2, zr, [1, 0, 0]);
      }
    }
    var zRa = zP - SB.RACK_U0;
    rackPc('rack-l', -(iW / 2 - rw / 2), zRa, zHead + lg);
    rackPc('rack-r', iW / 2 - rw / 2, zRa, zHead + lg);
    if (dbl) rackPc('rack-m', P.jw / 2 + rw / 2, zRa, zHead);
    /* THE BACKREST: the battens (u from -b/2 past the hinge to Lb - 1 cm), the slats over them */
    var xB = [-(iW / 2 - SB.WASH - b / 2), P.jw / 2 + SB.WASH + b / 2, iW / 2 - SB.WASH - b / 2], bNm = ['l', 'm', 'r'];
    var lbat = u1 - u0, cB = pw((u0 + u1) / 2, 0);
    KS.forEach(function (kk) { piece('batten', SB.BATTEN, lbat, 'back-batten-' + bNm[kk], xB[kk], cB.y, cB.z, b, b, lbat, a); });
    var LbS = Lb - SB.PANEL_E, nB = Math.max(1, Math.floor((LbS + SB.GAP) / (sw + SB.GAP))), gB = (nB > 1) ? (LbS - nB * sw) / (nB - 1) : 0;
    var pLen = iW - 2 * SB.PANEL_CLR, dDown = [0, -ca, -sa];
    for (i = 0; i < nB; i++) {
      var uc = SB.PANEL_E + i * (sw + gB) + sw / 2, cS = pw(uc, b / 2 + st / 2);
      piece('pslat', SB.SLAT, pLen, 'back-slat-' + (i + 1), 0, cS.y, cS.z, pLen, st, sw, a);
      for (k = 0; k < 3; k++) { if (k === 1 && !dbl) continue; for (q = -1; q <= 1; q += 2) { var sp = pw(uc + q * sw / 4, b / 2 + st); fa('screw-pslat', SB.SLAT_SCREW, 'back-slat-' + (i + 1) + '-' + k + q, xB[k], sp.y, sp.z, dDown); } }
    }
    /* the hinge bolts: through the sides / the 2x4 into the battens' foot ends */
    fa('bolt-pivot', SB.BOLT, 'hinge-l', -(iW / 2 + ft), yP, zP, [1, 0, 0], 0.005);
    fa('bolt-pivot', SB.BOLT, 'hinge-r', iW / 2 + ft, yP, zP, [-1, 0, 0], 0.005);
    if (dbl) fa('bolt-pivot', SB.BOLT, 'hinge-m', -P.jw / 2, yP, zP, [1, 0, 0], 0.005);
    /* the props: beside their battens (inwards; the middle one on its +X
       face), each on an M10 bolt through the batten (the head let into the
       batten's face), the top end rounded about the bolt */
    var xPr = [xB[0] + b + SB.WASH, xB[1] + b + SB.WASH, xB[2] - b - SB.WASH];
    var bF = [-(iW / 2 - SB.WASH), P.jw / 2 + SB.WASH, iW / 2 - SB.WASH], bD = [[1, 0, 0], [1, 0, 0], [-1, 0, 0]];
    KS.forEach(function (kk) {
      piece('prop', SB.BATTEN, lp, 'prop-' + bNm[kk], xPr[kk], T[1], zP - T[0], b, b, Lf, Math.PI - psi, { roundTop: true, Lf: Lf });
      fa('bolt-prop', SB.BOLT, 'prop-' + bNm[kk], bF[kk], T[1], zP - T[0], bD[kk], 0.005);
    });
    /* the sums */
    var by = {}, surf = 0;
    for (i = 0; i < pieces.length; i++) { var bx = pieces[i].box; by[pieces[i].code] = (by[pieces[i].code] || 0) + pieces[i].len; surf += 2 * (bx[3] * bx[4] + bx[4] * bx[5] + bx[5] * bx[3]); }
    var cnt = {};
    for (i = 0; i < fas.length; i++) cnt[fas[i].code] = (cnt[fas[i].code] || 0) + 1;
    var headTop = pw(Lb, b / 2 + st).y + Y0;
    return {
      P: P, kid: kid, dbl: dbl, iW: iW, iL: iL, Lb: Lb, ang: ang, a: a, W: W, L: L, H: fh + Y0, Y0: Y0,
      yS: yS + Y0, yT: yT + Y0, zP: zP, yP: yP + Y0, hingeGap: hingeGap, nF: nF, nB: nB, lp: lp, dP: dP, psi: psi, notchS: notchS, notches: nList, notchesOk: nOk, nLeg: nLeg,
      pieces: pieces, fas: fas, meters: by, counts: cnt,
      slatM: (by[SB.SLAT] || 0), coat: surf,
      headTop: headTop, headZ: pw(Lb, b / 2 + st).z, height: Math.max(fh + Y0, headTop), depth: W, xMin: -W / 2, xMax: W / 2
    };
  }
  /* its build: the box, the middle, the legs, the ledgers, the slats, the props, the backrest, hinged */
  var SB_STEPS = [
    { parts: [], codes: [] },
    { parts: ['sb-frame', 'sb-hw-screw-corner'], codes: ['KVH60160', 'FAS60160'] },
    { parts: ['sb-joist', 'sb-hw-screw-joist'], codes: ['KVH10060', 'FAS60160'] },
    { parts: ['sb-leg', 'sb-hw-screw-leg'], codes: ['KVH10100', 'FAS80100'] },
    { parts: ['sb-ledger', 'sb-hw-screw-ledger'], codes: ['KVH03838', 'FAS50060'] },
    { parts: ['sb-slat', 'sb-hw-screw-slat'], codes: ['TIM20100', 'FAS55050'] },
    { parts: ['sb-rack', 'sb-hw-screw-rack'], codes: ['KVH10060', 'FAS80100'] },   /* v291 the notched racks */
    { parts: ['sb-batten'], codes: ['KVH03838'] },
    { parts: ['sb-pslat', 'sb-hw-screw-pslat'], codes: ['TIM20100', 'FAS55050'] },
    { parts: ['sb-hw-bolt-pivot'], codes: ['FAT10002'] },
    { parts: ['sb-prop', 'sb-hw-bolt-prop'], codes: ['KVH03838', 'FAT10002'] }   /* v291 the props hung on the battens, last */
  ];
  var _sbLogKey = '';

  /* ------------------------------------------------------------------
     TYPE 13 -- KIDS' SWING SET (SWINGS slot 4), and since v299 its BENCH:
     the info-bar toggle switches between 1-3 board seats for children
     (TIM45120, 0.45, two chains each from swing hangers FAT00002 in the
     beam to eye bolts FAT00003 standing in the seat) and the porch bench
     of the A-frame swing (_porchLayout: a slatted seat, a back of
     horizontal planks on its tilt slider, armrests, chain V's; the level
     button its mattress) -- Marek 2026-10-20 17:48.
     v299 THE NEW A-FRAMES (his nongdikpok render, "nosnou konstrukci
     varianty 4 podle detailu -- konstrukcni reseni, prijde mi lepsi nez co
     mame ted"; he chose the beam clamped between the legs), _kfFrame:
       - per frame two 2x6 legs KVH60160 splayed 19 deg from plumb, their
         tops cut plumb against the 4x8 beam's sides and level with its
         top; 2 M16 rods FAT16010 through leg - beam - leg;
       - a 2x6 collar across the legs' inner faces 35 cm under the beam and
         a 2x6 spreader across their outer faces 30 cm off the ground, 2 M16
         rods a leg each (a washer FAT16001 + cap nut FAT16002 at each end
         of every rod);
       - a 2x4 knee brace KVH10060 on each side face of the beam, cut level
         at the beam's mid-height and plumb on the collar: 2 x 8x100
         FAS80100 into the beam, 2 toe screws into the collar.
     Width handle: the kids' span between the frames 1.50-3.60 (1 seat up
     to 2.49, 2 up to 3.49, 3 from 3.50), the bench's length 0.90-1.80
     (the frames follow it). _kidsLayout(STATE) is the single source. */
  var KIDS = {
    L_MIN: 1.50, L_MAX: 3.60, L_DEFAULT: 2.50,
    SEAT_W: 0.45, SEAT_Y: 0.40, CHAIN_SPREAD: 0.38, PER_SEAT: 1.00,
    SEAT_CODE: 'TIM45120', SEAT_SCREW: 'FAS60100'
  };
  var KF = {
    ANG: 19,              /* the legs from plumb */
    BEAM_OVER: 0.10, BEAM_OVER_US: 0.1016,   /* v305 the beam past the legs' outer faces (v299: 0.20 past the spreader's) */
    END_CLR: 0.005,       /* v305 full depth this far past the leg, then the end's ogee */
    END_TIP: 0.43,        /* v305 the depth left at the tip (of the beam's) */
    COLLAR_DROP: 0.35,    /* the collar's top under the beam */
    SPREAD_Y: 0.30,       /* the spreader's underside off the ground */
    ROD_OVER: 0.018,      /* a rod past each face (washer + cap nut) */
    LEG: 'KVH60160', BEAM: 'KVH10200', BRACE: 'KVH10060', SCREW: 'FAS80100'
  };
  /* the sections: the 2x6 legs / collar / spreader, the 4x8 beam, the 2x4 brace (metric / US actual) */
  function _kfProf(s) {
    if ((s || STATE).isMetric === false) return { t: 0.0381, w: 0.1397, b: 0.0889, bh: 0.1842, bt: 0.0381, bw: 0.0889 };
    return { t: 0.060, w: 0.160, b: 0.100, bh: 0.200, bt: 0.060, bw: 0.100 };
  }
  function _kidsBench(s) { return (s || STATE).kidsBench === true; }
  /* the two A-frames at z = +-zA and the beam over them */
  function _kfFrame(s, zA) {
    var Q = _kfProf(s), t = Q.t, w = Q.w, b = Q.b, bh = Q.bh, tb = Q.bt, wb = Q.bw, us = ((s || STATE).isMetric === false), k, sz, sx, j;
    var th = KF.ANG * Math.PI / 180, tn = Math.tan(th), wc = w / Math.cos(th), hb = b / 2, ov = KF.ROD_OVER;
    var yBB = SWING.BEAM_BOT, yBT = yBB + bh;
    function xIn(y) { return hb + (yBB - y) * tn; }            /* the leg's inner edge line (above the beam's underside the plumb cut is at hb) */
    function xOut(y) { return xIn(y) + wc; }
    function xMid(y) { return xIn(y) + wc / 2; }
    var pieces = [], fas = [];
    function rod(kind, x, y, z, d, len) { fas.push({ kind: kind, code: SWING.ROD_CODE, x: x, y: y, z: z, dir: d, len: len, r: 0.008, rod: true }); }
    function scr(kind, x, y, z, d, len) { fas.push({ kind: kind, code: KF.SCREW, x: x, y: y, z: z, dir: d, len: len, r: 0.004 }); }
    var yC1 = yBB - KF.COLLAR_DROP, yC0 = yC1 - w, yS0 = KF.SPREAD_Y, yS1 = yS0 + w;
    var legLen = Math.ceil(yBT / Math.cos(th) * 100) / 100;
    /* v305 the collar and the spreader cut flush along the legs' outer
       edges (Marek: seriznute podle vnejsi hrany noznych A profilu), their
       long edge = the length to buy; the beam 10 cm past the legs' outer
       faces with a scroll at each end (the Hollywood roof's rafter tail,
       squeezed into the overhang) */
    var collarL = 2 * xOut(yC0), spreadL = 2 * xOut(yS0);
    var bOver = us ? KF.BEAM_OVER_US : KF.BEAM_OVER, zE = zA + t / 2 + bOver, beamL = 2 * zE;
    /* the knee brace: the band +-wb/2 about a 45 deg axis in the y-z plane,
       from the collar's inner face (u = 0) to the beam's side (v = 0, the
       level cut at the beam's mid-height); a = the axis's run, chosen so
       the plumb end sits in the middle of the collar */
    var yL = yBB + bh / 2, k2 = wb / 2 * Math.SQRT2, a = yL - (yC0 + yC1) / 2;
    var screwLen = us ? 0.1016 : 0.10, toe = screwLen - (t - 0.006);
    for (sz = -1; sz <= 1; sz += 2) {
      var zf = sz * zA, nm = (sz < 0 ? 'l' : 'r');
      for (sx = -1; sx <= 1; sx += 2) {
        var pts = [[sx * xOut(0), 0], [sx * xIn(0), 0], [sx * hb, yBB], [sx * hb, yBT], [sx * xOut(yBT), yBT]];
        pieces.push({ kind: 'leg', code: KF.LEG, len: legLen, id: 'leg-' + nm + (sx < 0 ? '-back' : '-front'), poly: pts, plane: 'xy', c: zf, t: t });
        for (k = 0; k < 2; k++) {
          var yc = yC0 + w * (k ? 0.75 : 0.25), ys = yS0 + w * (k ? 0.75 : 0.25);
          rod('collar', sx * xMid(yc), yc, sz * (zA - 1.5 * t - ov), [0, 0, sz], 2 * t + 2 * ov);       /* collar + leg, from the inside */
          rod('spreader', sx * xMid(ys), ys, sz * (zA + 1.5 * t + ov), [0, 0, -sz], 2 * t + 2 * ov);   /* spreader + leg, from the outside */
        }
      }
      pieces.push({ kind: 'collar', code: KF.LEG, len: Math.ceil(collarL * 100) / 100, id: 'collar-' + nm, plane: 'xy', c: sz * (zA - t), t: t,
                    poly: [[-xOut(yC0), yC0], [xOut(yC0), yC0], [xOut(yC1), yC1], [-xOut(yC1), yC1]] });
      pieces.push({ kind: 'spreader', code: KF.LEG, len: Math.ceil(spreadL * 100) / 100, id: 'spreader-' + nm, plane: 'xy', c: sz * (zA + t), t: t,
                    poly: [[-xOut(yS0), yS0], [xOut(yS0), yS0], [xOut(yS1), yS1], [-xOut(yS1), yS1]] });
      for (k = 1; k <= 2; k++) { var ya = yBB + bh * k / 3, xa = xOut(ya) + ov; rod('apex', -xa, ya, zf, [1, 0, 0], 2 * xa); }   /* leg - beam - leg */
      var u0 = sz * (zA - 1.5 * t), dI = -sz;
      for (sx = -1; sx <= 1; sx += 2) {
        var c = sx * (hb + tb / 2);
        var W = function (u, v) { return [u0 + dI * u, yL + v]; };
        var bp = [W(0, -(a + k2)), W(0, -(a - k2)), W(a - k2, 0), W(a + k2, 0)];
        pieces.push({ kind: 'brace', code: KF.BRACE, len: Math.ceil((a + k2) * Math.SQRT2 * 100) / 100, id: 'brace-' + nm + (sx < 0 ? '-back' : '-front'), poly: bp, plane: 'zy', c: c, t: tb });
        for (j = -1; j <= 1; j += 2) {
          var pt = W(a - 0.05 + j * k2 / 2, -0.05);                                                        /* into the beam's side */
          scr('brace', sx * (hb + tb), pt[1], pt[0], [-sx, 0, 0], screwLen);
          var pq = W(toe, toe - (a + k2));                                                                 /* a toe screw into the collar */
          scr('brace', c + j * tb / 4, pq[1], pq[0], [0, 0, -dI], screwLen);
        }
      }
    }
    /* the beam: its outline in (z, y) -- the top straight end to end, the
       underside an ogee (an S, tangent at both ends) from the full depth
       just past the leg up to 43 % of the depth at each tip (the Hollywood
       rafter tail's depth at its tip; its scroll needs 19 cm) */
    var lt = bOver - KF.END_CLR, bpo = [[-zE, yBT], [zE, yBT]], og = [], NO = 12;
    for (j = 0; j <= NO; j++) { var uo = j / NO; og.push([uo * lt, KF.END_TIP + (1 - KF.END_TIP) * (1 - Math.cos(Math.PI * uo)) / 2]); }
    for (j = 0; j < og.length; j++) bpo.push([zE - og[j][0], yBT - bh * og[j][1]]);
    for (j = og.length - 1; j >= 0; j--) bpo.push([-zE + og[j][0], yBT - bh * og[j][1]]);
    pieces.push({ kind: 'beam', code: KF.BEAM, len: Math.ceil(beamL * 100) / 100, id: 'beam', poly: bpo, plane: 'zy', c: 0, t: b });
    var m = {}, coat = 0, i;
    for (i = 0; i < pieces.length; i++) {
      var pc = pieces[i];
      m[pc.code] = (m[pc.code] || 0) + pc.len;
      coat += pc.len * ((pc.kind === 'beam') ? 2 * (b + bh) : (pc.kind === 'brace') ? 2 * (tb + wb) : 2 * (t + w));
    }
    return { Q: Q, pieces: pieces, fas: fas, meters: m, coat: coat, yBB: yBB, yBT: yBT, beamL: beamL, zA: zA,
             depth: 2 * xOut(0), height: yBT, legLen: legLen, ang: KF.ANG };
  }
  function _kidsLayout(s) {
    s = s || STATE;
    var P = _swingProf(s), i;
    if (_kidsBench(s)) {
      /* v299 THE BENCH: the A-frame swing's porch seat under the beam; the
         frames 34 cm (SIDE_GAP) past the seat's sides */
      var seat = _porchLayout(s, { H: SWING.BEAM_BOT, ringAt0: true }), Qb = _kfProf(s);
      var zAb = seat.L / 2 + seat.sec.t + SWING.SIDE_GAP + Qb.t / 2, frb = _kfFrame(s, zAb);
      return {
        bench: true, P: P, Q: Qb, L: seat.L, N: 0, seat: seat, frame: frb, H: frb.yBB, cushion: seat.cushion,
        beamBot: frb.yBB, beamTop: frb.yBT, beamLen: frb.beamL, zA: zAb,
        eyeF: seat.eyeF, eyeR: seat.eyeR, hangers: seat.hangers, chains: seat.chains,
        seatXMax: seat.xMax, seatXMin: seat.xMin, seatTopY: seat.armTop, depth: frb.depth, height: frb.height
      };
    }
    var L = Math.max(KIDS.L_MIN, Math.min(KIDS.L_MAX, (+s.L) || KIDS.L_DEFAULT));
    var N = Math.max(1, Math.min(3, Math.floor((L - 0.50 + 0.001) / KIDS.PER_SEAT)));
    var fr = _kfFrame(s, L / 2);
    var H = fr.yBB, hy = H - SWING.HANGER_DROP, seats = [], eyeF = [], eyeR = [], hangers = [], chains = [];
    var seatT = P.slatT, seatW = P.slatW, sy = KIDS.SEAT_Y;
    for (i = 0; i < N; i++) {
      var zc = -L / 2 + L * (i + 0.5) / N;
      seats.push({ z: zc, y: sy - seatT / 2 });
      for (var e = -1; e <= 1; e += 2) {
        var ze = zc + e * KIDS.CHAIN_SPREAD / 2, ey = { x: 0, y: sy + 0.02, z: ze, face: sy, vert: true };
        (e < 0 ? eyeF : eyeR).push(ey);
        var hg = { x: 0, y: hy, z: ze };
        hangers.push(hg);
        chains.push({ a: { x: 0, y: ey.y, z: ze }, b: { x: 0, y: hy, z: ze }, len: hy - ey.y });
      }
    }
    return {
      bench: false, P: P, Q: fr.Q, L: L, N: N, H: H, seats: seats, seatT: seatT, seatW: seatW, frame: fr,
      beamBot: fr.yBB, beamTop: fr.yBT, beamLen: fr.beamL, zA: L / 2,
      eyeF: eyeF, eyeR: eyeR, hangers: hangers, chains: chains,
      seatXMax: seatW / 2, depth: fr.depth, height: fr.height
    };
  }
  /* the build order: the frames (legs, collar + spreader with their rods,
     the beam + its rods, the braces, their screws), then the seats and
     their hanging -- or the bench's own steps */
  var KF_STAND = [
    { parts: ['kf-leg'], codes: ['KVH60160'] },
    { parts: ['kf-collar', 'kf-spreader', 'kf-hw-bolt-collar', 'kf-hw-bolt-spreader'], codes: ['KVH60160', 'FAT16010', 'FAT16001', 'FAT16002'] },
    { parts: ['kf-beam', 'kf-hw-bolt-apex'], codes: ['KVH10200', 'FAT16010'] },
    { parts: ['kf-brace'], codes: ['KVH10060'] },
    { parts: ['kf-hw-screw-brace'], codes: ['FAS80100'] }
  ];
  var KIDS_STEPS = [{ parts: [], codes: [] }].concat(KF_STAND).concat([
    { parts: ['swing-hw-plate', 'swing-hw-rod', 'swing-hw-hanger', 'swing-hw-chain', 'swing-hw-screw-hanger'], codes: ['FAT00002', 'FAT00004'] },
    { parts: ['kids-seat', 'swing-hw-shank', 'swing-hw-eye'], codes: ['TIM45120', 'FAT00003'] }
  ]);
  var KIDS_BENCH_STEPS = [{ parts: [], codes: [] }].concat(KF_STAND).concat(PORCH_SEAT_STEPS).concat([{ parts: ['cushion'], codes: ['FOU00016'] }]);   /* v300 the seat's steps (13 since v307) */

  /* COLOUR SCHEMES (the brush button under the eye): the wood tone, the
     swing's shingles and deck. 1 birch / beech (light, the default), 2 oak
     (the old warm tone), 3 khaki wood with a brown roof, 4 white (the
     print-like preview). An old saved 'default' reads as birch. */
  var COLOR_SCHEMES = {
    pine:  { wood: 0xe9cc9c, glow: 0.16, shingleA: 0x45474b, shingleB: 0x3b3d40, deck: 0xe9cc9c, seat: 0x3f6b55 },   /* v285 the default light wood (Marek: birch too pale) */
    birch: { wood: 0xf6ead2, glow: 0.38, shingleA: 0x45474b, shingleB: 0x3b3d40, deck: 0xf6ead2, seat: 0x8c3b2e },   /* pale spruce, as the real swing (Marek's photo); glow = emissive lift so the shading does not grey it */
    oak:   { wood: 0xb98c5e, glow: 0, shingleA: 0x45474b, shingleB: 0x3b3d40, deck: 0xcfae78, seat: 0x23384d },
    khaki: { wood: 0xa89a6a, glow: 0, shingleA: 0x6e4c33, shingleB: 0x5c3e29, deck: 0xb3a676, seat: 0x2f3133 },   /* darker khaki */
    white: { wood: 0xffffff, glow: 0.55, shingleA: 0x9b2f2a, shingleB: 0x86251f, deck: 0xf2f2f2, seat: 0x1f5f8b },   /* white wood, red shingles (Marek) */
    grey:  { wood: 0x8a9098, glow: 0.04, shingleA: 0x45474b, shingleB: 0x3b3d40, deck: 0x969ca4, seat: 0xc06a2b },   /* v301 anthracite-grey painted wood (the modern swing's default, the ogrodowe_flow reel) */
    ssb:   { wood: 0xe9cc9c, glow: 0.16, shingleA: 0x45474b, shingleB: 0x3b3d40, deck: 0xe9cc9c, seat: 0x3f6b55, clad: 0x2b2826, charred: true }   /* v412 SHOU SUGI BAN (Marek 23:46 "barvu udelej i shou sugi ban"), the garden pods only: the cladding charred (clad), the frame natural */
  };
  /* v312 seat = the cinema bar's stool seats (Marek 00:09: v jine barve nez drevo, pro kazdou barevnou variantu): pine green, birch brick red, oak navy, khaki charcoal, white blue, grey amber */
  var COLOR_ORDER = ['pine', 'birch', 'oak', 'khaki', 'white', 'grey'];   /* v301 + grey */   /* v285 pine first (the default) */
  function _colorOrder() { return _isKpType(STATE.variant) ? COLOR_ORDER.concat(['ssb']) : COLOR_ORDER; }   /* v412 the garden pods: + shou sugi ban */
  /* v369 THE PLAYHOUSES' KIDS' COLOURS (Marek 2026-10-29 22:29: vesele, detske barvy, jak v defaultu tak ve variantach barevnosti). Every
     colour scheme of the brush button has its own cheerful set for the painted skin; the frame keeps the scheme's wood. wall = the
     siding and the fort boards, trim = corner boards, casings, fascia and rake boards, door = the door's boards and ledges, shut = the
     shutters, roof = the shingles (their texture tinted) and the standing seam (v372: PH_ROOF, light grey on all), slide = the HDPE slide, barn / modern = the little
     barn's and the modern house's own walls (the barn's door in its wall colour with braces in the trim colour). */
  var PH_PALETTES = {   /* v371 PASTELS (Marek 2026-10-30 00:53: spise v pastelovych tonech, jemnejsich -- kombinace bile, ruzove, zelene a modre): only white / pink / green / blue, soft; the roofs light grey on every scheme: PH_ROOF (v372) */
    pine:  { wall: 0xffffff, trim: 0xfdfcf8, door: 0xf2b8c6, shut: 0xaed8b9, slide: 0xa9c9e6, barn: 0xf8f0dc, barnDoor: 0xadcde9, modern: 0xffffff },   /* v374 THE DEFAULT (Marek 2026-10-30 10:10: vetsinu konstrukci ivory / white, ruzova, zelena, modra jako doplnkova): pink door, green shutters, blue slide -- v377 (10:41: 3 ze 4 ivory jako ciste bile, je to moc sede) the cottage / stilt house / A-frame / modern house pure white, the barn alone ivory (lighter, warmer) with blue doors */
    birch: { wall: 0xf6cbd5, trim: 0xfbf8f3, door: 0xadcde9, shut: 0xbfe3cb, slide: 0xadcde9, barn: 0xf3c0cc, modern: 0xf3d3dc },   /* blush pink, blue door, mint shutters */
    oak:   { wall: 0xc6e6cf, trim: 0xfbf8f3, door: 0xf2b8c6, shut: 0xb7d4ec, slide: 0xf2b8c6, barn: 0xc6e6cf, modern: 0xc6e6cf },   /* mint, pink door, blue shutters */
    khaki: { wall: 0xfbf8f3, trim: 0xb7d4ec, door: 0xf2b8c6, shut: 0xb9e0c6, slide: 0xf2b8c6, barn: 0xb9e0c6, modern: 0xb7d4ec },   /* white, blue trims, pink door, mint shutters */
    white: { wall: 0xfbf8f3, trim: 0xf2b8c6, door: 0xadcde9, shut: 0xf2b8c6, slide: 0xadcde9, barn: 0xf3c0cc, modern: 0xf3d3dc },   /* white, pink trims + shutters, blue door */
    grey:  { wall: 0xcfe0ee, trim: 0xfbf8f3, door: 0xb9e0c6, shut: 0xf2b8c6, slide: 0xb9e0c6, barn: 0xadcde9, modern: 0xcfe0ee }    /* pale blue, mint door, pink shutters */
  };
  /* v374 (Marek 2026-10-30 10:10: vybrane dve stavby udelej ve variante svetle drevo - buk) the play fort and the tree fort in the default
     scheme: their fort boards natural light beech instead of the painted wall colour (the brush's other schemes paint them as before) */
  var PH_BEECH = 0xe0bb92, PH_BEECH_TYPES = { 29: 1, 32: 1 };
  var PH_ROOF = 0xc5c9ce;   /* v372 (Marek 2026-10-30 09:19: Strechy na stavbach udelej svetle sede. U vsech.) every playhouse's roof light grey -- the shingles' texture tinted from it, the standing seam */
  function _phPalette() { return PH_PALETTES[_colorScheme()] || PH_PALETTES.pine; }
  /* paint the playhouses' materials with the scheme's set (at a build and at every brush tap -- the colours change without a rebuild) */
  function _phPaint(mats) {
    if (!mats || !mats.phWall) return;
    var C = _phPalette(), k;
    var roof = PH_ROOF;   /* v372 light grey on every type and scheme (was the scheme's roof, the barn's barnRoof) */
    var wall = (_colorScheme() === 'pine' && PH_BEECH_TYPES[STATE.variant | 0]) ? PH_BEECH : C.wall;   /* v374 the two forts in beech by default */
    var map = { phWall: wall, phTrim: C.trim, phDoor: C.door, phShut: C.shut, phSlide: C.slide, phBarn: C.barn, phBarnDoor: (C.barnDoor != null ? C.barnDoor : C.barn), phModern: C.modern, phSeam: roof };   /* v374 + the barn's doors (their own colour where the scheme gives one, else its walls') */
    for (k in map) if (map.hasOwnProperty(k) && mats[k]) {
      mats[k].color.setHex(map[k]);
      var lum = (((map[k] >> 16) & 255) * 0.299 + ((map[k] >> 8) & 255) * 0.587 + (map[k] & 255) * 0.114) / 255;
      if (mats[k].emissive) { mats[k].emissive.setHex(map[k]); mats[k].emissiveIntensity = (k === 'phSeam') ? 0.04 : (lum > 0.92 ? 0.3 : 0.12); }   /* a little lift so the shading does not grey them -- v377 white / ivory more (they read grey at 0.12; the white wood scheme lifts 0.55) */
      mats[k].needsUpdate = true;
    }
    if (mats.phShingle) {
      var tx = _gzShingleTex(roof);
      if (tx) { mats.phShingle.map = tx; mats.phShingle.color.setHex(0xffffff); } else mats.phShingle.color.setHex(roof);
      mats.phShingle.needsUpdate = true;
    }
    if (_phIsCo(STATE) || _phIsCt(STATE) || _phIsDh(STATE)) _coPaint(mats);   /* v385 + the dog house */   /* v379 + the chicken tractor */   /* v375 the coop: its own colours over the playhouses' */
  }
  function _colorScheme() { var k = STATE.colorMode; return (COLOR_SCHEMES[k] && (k !== 'ssb' || _isKpType(STATE.variant))) ? k : 'pine'; }   /* v412 shou sugi ban on the garden pods only */

  /* Per-variant default dimensions applied on switch (selectVariant).
     Variant 1 (bench) keeps the global DEFAULTS; variant 2 (sofa) gets
     its own footprint so the two don't share L/W/H awkwardly. Variant 3
     (wave bench) starts as the upright bench preset (lvl 1). */
  var VARIANT_DEFAULTS = {
    2: { L: SOFA.L_DEFAULT, W: SOFA.DEPTH, H: SOFA.H_DEF_L2, lvl: 2 },
    3: { L: WAVE.L_DEFAULT, W: _waveLayout({ waveBack: WAVE.BACK_DEF, L: WAVE.L_DEFAULT }).depth, H: _waveLayout({ waveBack: WAVE.BACK_DEF, L: WAVE.L_DEFAULT }).height, lvl: 3, waveBack: WAVE.BACK_DEF, slatGap: WAVE.GAP_DEF },
    /* Hollywood swing: W and H are the stand footprint + beam top, set
       from the layout on every build (_syncHeightFromGeometry). */
    4: { L: SWING.L_DEFAULT, W: 2 * SWING.FOOT_HALF, H: SWING.LEG_TOP },
    5: { L: PICNIC.L_DEFAULT, W: 1.44, H: PICNIC.TOP_Y, lvl: 1 },
    /* porch swing: H = the beam underside (STATE.porchH), W from the layout */
    7: { L: (PORCH.STYLE7 === 'classic') ? PCL.L_DEFAULT : (PORCH.STYLE7 === 'sofa') ? PSOFA.L_DEFAULT : PORCH.L_DEFAULT, W: 1.0, H: PORCH.H_DEF, swingBack: PORCH.BACK_DEF },
    /* A-frame swing: the porch seat on the Hollywood stand; W / H from the stand */
    8: { L: PORCH.L_DEFAULT, W: 2 * SWING.FOOT_HALF, H: SWING.LEG_TOP, swingBack: PORCH.BACK_DEF },
    /* Adirondack: one chair; W / H from the layout */
    9: { L: ADI.L_DEFAULT, W: 0.9, H: 0.95, lvl: 1 },
    /* planter bench: the seat length between the planters; W / H from the layout */
    10: { L: PLANTER.L_DEFAULT, W: 0.6, H: PLANTER.PH_BACK, lvl: 1 },
    /* tree bench: L = the opening across the flats; no back by default */
    11: { L: TREE.L_DEFAULT, W: 1.6, H: TREE.SEAT_TOP, lvl: 1, backrestVisible: false },
    /* storage bench: lid shut (lvl 1), no back by default */
    12: { L: STORE.L_DEFAULT, W: STORE.DEPTH, H: STORE.SEAT_TOP, lvl: 1, backrestVisible: false },
    /* kids' swing set: the span between the frames; W / H from the stand */
    13: { L: KIDS.L_DEFAULT, W: 2 * SWING.FOOT_HALF, H: SWING.LEG_TOP, lvl: 1, swingBack: PORCH.BACK_DEF },   /* v299 + the bench's back tilt */
    /* block bench: an uncut 8 ft 4x4, natural blocks (lvl 1), no back */
    6: { L: BLOCK.L_DEFAULT, W: 0.39, H: 0.38, lvl: 1, backrestVisible: false },
    /* v273 the bed: L / W / H from the mattress and the headboard (_bedLayout); the headboard on */
    14: { L: BED.ML + BED.CLEAR + 0.2, W: BED.MW_DEF + BED.CLEAR + 0.2, H: BED.HEAD_DEF, lvl: 1, backrestVisible: true },
    /* v284 the 2x4 bench: only the length; W / H fixed (_gbLayout) */
    15: { L: GB.L_DEFAULT, W: 0.418, H: GB.SEAT_TOP, lvl: 1, backrestVisible: false },
    /* v414 the twist bench: L = the slats' stack (the handle sets their count); W / H from _rtbLayout */
    54: { L: RTB.L_DEF, W: 0.60, H: 0.85, lvl: 1, backrestVisible: true },
    /* v288 the sunbed: L / W / H from _sbLayout (the width on its handle, the kids' size on the level button) */
    16: { L: SB.IL + 0.12, W: SB.WR.def + 0.12, H: 0.75, lvl: 1, backrestVisible: true },
    /* v296 the pergola swing: L = the seat's length (the pergola follows); W / H from _pgLayout */
    17: { L: PG.L_DEF, W: PG.RAF_L, H: 2.50, colorMode: 'white' },   /* v298 white by default (Marek) */
    18: { L: MF.L_DEF, W: 2 * MF.SP + 0.16, H: 2.44, colorMode: 'grey' },   /* v301 the modern swing: grey by default (Marek) */
    /* v303 the cinema bar: L = the beams (the posts 2 x OVER inside); W / H from _gsLayout */
    19: { L: GS.S_DEF + 2 * GS.OVER, W: 2.46, H: 3.74 },
    /* v314 the raised bed: L = the walls (its mode's default), W / H from _rbLayout */
    20: { L: RB.BASIC.L0, W: RB.BASIC.W0, H: 0.46 },
    /* v318 the floating bed: L / W / H from _fbLayout (180 x 200) */
    21: { L: 2.12, W: 3.00, H: 1.10 },
    /* v320 the garden arbor: L / W = the posts' outer faces; H from _gaLayout */
    22: { L: GA.L0, W: GA.W0, H: 2.46 },
    /* v328 the gazebo: L = the width across the flats (the units' default set in selectVariant); W / H from _gzLayout */
    23: { L: GZ.S0, W: 3.46, H: 3.60 },
    /* v334 the pergola: L / W = the posts' outer faces (the units' default set in selectVariant); H from _peLayout */
    24: { L: PE.S0, W: PE.S0, H: 2.96 },
    /* v355 the bar: L = the purlins (the roof); W / H from _mbLayout */
    25: { L: MB.L0, W: 3.55, H: 2.97 },
    /* v362 the cottage: L / W = the house's framing (the units' default set in selectVariant); H from _phLayout */
    26: { L: PH.L0, W: PH.W0, H: 3.00 },
    27: { L: PH.L0, W: PH.W0, H: 4.25 },   /* v363 the stilt house (the same house, 1.22 m / US 4 ft up) */
    28: { L: PH.L0, W: 2.40, H: 2.40 },    /* v364 the A-frame hut (W 2.40 m / US 8 ft unless dragged) */
    29: { L: PF.L0, W: PF.W0, H: 3.30 },   /* v365 the play fort (1.50 x 1.50 m / US 5 x 5 ft) */
    30: { L: PH.L0, W: PH.W0, H: 2.40 },   /* v366 the modern house (the cottage's 1.80 x 1.80 m / US 6 x 6 ft) */
    31: { L: PH.L0, W: PH.W0, H: 2.90 },   /* v367 the little barn (the cottage's 1.80 x 1.80 m / US 6 x 6 ft) */
    33: { L: GH.L0, W: GH.W0, H: 2.82 },   /* v373 the gable greenhouse: L / W = the base (the units' default set in selectVariant); H from _ghLayout */
    36: { L: GH.L0, W: GH.LW0, H: 3.05 },  /* v378 the lean-to greenhouse: L along the house, W off it (the units' default set in selectVariant); H from _ghLeanLayout */
    38: { L: GH.HL0, W: GH.HW0, H: 2.55 },  /* v381 the hoop house: L / W = the base (the units' default set in selectVariant); H from _ghHoopLayout */
    40: { L: GH.AL0, W: GH.AW0, H: 3.40 },  /* v384 the A-frame greenhouse: L / W = the base (the units' default set in selectVariant); H from _ghAframeLayout */
    43: { L: GH.VL0, W: GH.VW0, H: 2.98 },  /* v387 the Victorian greenhouse: L (incl. the bay) / W = the base (the units' default set in selectVariant); H from _ghVictLayout */
    45: { L: GH.OL0, W: GH.OW0, H: 2.85 },  /* v390 the old-window greenhouse: L / W = the base, snapped to whole sashes (the units' default set in selectVariant); H from _ghOldLayout */
    53: { L: KP.L0, W: KP.D, H: 2.40 },   /* v407 GARDEN POD Fitness: as the kitchen's */
    35: { L: KP.L0, W: KP.D, H: 2.40 },   /* v376 the kitchen pod: L = the framing (the units' default set in selectVariant), W its fixed depth; H from _kpLayout */
    32: { L: TF.L0, W: TF.W0, H: 2.20 },
    [CS_TYPE]: { L: CS.T0, W: 2 * CS.T0 + CS.BR0, H: 4.00 },   /* v389 the castle (towers 1.50, the bridge 1.80 -> 4.80 x 1.50 m / US 5 + 6 ft) */   /* v368 the tree fort (2.10 x 2.10 m / US 7 x 7 ft; the tree not counted) */
    37: { L: 2.40, W: CT.W0, H: 1.90, colorMode: 'pine' },    /* v379 the chicken tractor (4 hens: 1.80 x 2.40 m / US 6 x 8 ft; the flock sets it in selectVariant) */
    46: { L: 1.20, W: 3.10, H: 3.95, colorMode: 'pine' },   /* v395 light wood (CO_WOOD_TYPES) */    /* v391 the cupola coop (4 hens: the house 1.30 x 1.20, the whole 3.10 m / US 10 x 4 ft; the flock sets it in selectVariant) */
    49: { L: 3.10, W: CO.W0, H: 2.60, colorMode: 'pine' },   /* v397 the barn coop (6 hens: 1.80 x 3.10 m / US 6 x 10 ft, the backyard coop's; barn red with white trims) */
    52: { L: 4.80, W: 3.00, H: 2.70, colorMode: 'khaki' },   /* v401 the hoop coop (6 hens: the run 4.80 x 3.00 m / US 16 x 10 ft; the house sage green with white trims) */
    42: { L: 3.10, W: CO.W0, H: 2.30, colorMode: 'pine' },    /* v386 the lean-to coop (6 hens: 1.80 x 3.10 m / US 6 x 10 ft; the flock sets it in selectVariant) */
    39: { L: 3.90, W: WI.W0, H: 3.25, colorMode: 'pine' },    /* v383 the walk-in coop (10 hens: 2.40 x 3.90 m / US 8 x 13 ft; the flock sets it in selectVariant) */
    44: { L: 1.55, W: 1.20, H: 1.40 },     /* v388 the insulated dog house (a 55 cm / US 22 in. dog: 1.55 x 1.20 m; the dog sets it in selectVariant) */
    51: { L: 1.20, W: 0.95, H: 1.75, colorMode: 'pine' },   /* v403 the modern dog house (a 55 cm / US 22 in. dog: 1.20 x 0.95 m, the roof deck's guard on top; cedar, charcoal trims and roof in the default scheme; the dog sets it in selectVariant) */
    48: { L: 1.20, W: 1.80, H: 1.55 },     /* v396 the double dog house (two 55 cm / US 22 in. dogs: 1.20 x 1.80 m; the dog sets it in selectVariant) */
    47: { L: 1.20, W: 0.95, H: 1.45 },     /* v392 the kennel with run (a 55 cm / US 22 in. dog: the house 1.20 x 0.95 m, the run 1.40 m in front; the dog sets it in selectVariant) */
    41: { L: 1.20, W: 0.95, H: 1.30 },     /* v385 the classic dog house (a 55 cm / US 22 in. dog: 1.20 x 0.95 m; the dog sets it in selectVariant) */
    34: { L: 3.10, W: CO.W0, H: 2.30, colorMode: 'white' }   /* v395 white by default (Marek); the other coops their own on a switch */     /* v375 the backyard coop (6 hens: 1.80 x 3.10 m / US 6 x 10 ft; the flock sets it in selectVariant) */
  };

  /* Length range depends on the active variant (sofa is longer + chunkier
     than the bench). Returns {min,max} in metres. */
  function _lengthRange(state) {
    var v = ((state || STATE).variant | 0) || 1;
    if (v === 20) return _rbRange(state || STATE);   /* v314 the raised bed: its mode's walls */
    if (v === 21) { var fbl = _fbLayout(state || STATE).L; return { min: fbl, max: fbl }; }
    if (v === 22) return _gaRange(state || STATE);   /* v320 the garden arbor: the posts' outer faces along the path */   /* v318 the floating bed: the mattress sets it */
    if (v === 19) return _gsRange(state || STATE);   /* v303 the cinema bar: the beams' length */
    if (v === 23) return _gzRange(state || STATE);   /* v328 the gazebo: its width across the flats */
    if (v === 24) return _peRange(state || STATE);   /* v334 the pergola: its length (the square: its side) */
    if (v === 25) return _mbRange(state || STATE);
    if (_isGhType(v)) return _ghRange(state || STATE);   /* v373 the gable greenhouse: its base's length */
    if (_isKpType(v)) return _kpRange(state || STATE);   /* v376 the kitchen pod: its length */
    if (_isPhType(v)) return _phRange(state || STATE);   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 the cottage: the house's length (the porch apart) */   /* v355 the bar: the purlins' length */
    if (v === 18) return { min: PSOFA.L_MIN, max: PSOFA.L_MAX };   /* v301 the modern swing: its sofa seat for 2-3 */
    if (v === 2) return { min: SOFA.L_MIN, max: SOFA.L_MAX };
    if (v === 3) return { min: WAVE.L_MIN, max: WAVE.L_MAX };
    if (v === 4) return { min: SWING.L_MIN, max: SWING.L_MAX };
    if (v === 5) return _picnicRange(state);
    if (v === 7 && _porchStyle(state || STATE) === 'sofa') return { min: PSOFA.L_MIN, max: PSOFA.L_MAX };
    if (v === 17) return ((state || STATE).isMetric === false) ? { min: 1.2192, max: 2.4384 } : { min: 1.22, max: 2.44 };   /* v298 the pergola swing's longer seat */
    if (v === 7 && _porchStyle(state || STATE) === 'classic') return { min: PCL.L_MIN, max: PCL.L_MAX };   /* v278 */
    if (v === 7 || v === 8) return { min: PORCH.L_MIN, max: PORCH.L_MAX };
    if (v === 9) return _adiRange(state);
    if (v === 10) return { min: PLANTER.L_MIN, max: PLANTER.L_MAX };
    if (v === 11) return { min: TREE.L_MIN, max: TREE.L_MAX };
    if (v === 12) return { min: STORE.L_MIN, max: STORE.L_MAX };
    if (v === 13) return _kidsBench(state || STATE) ? { min: PORCH.L_MIN, max: PORCH.L_MAX } : { min: KIDS.L_MIN, max: KIDS.L_MAX };   /* v299 the bench: its own length */
    if (v === 6) return { min: BLOCK.L_MIN, max: BLOCK.L_MAX };
    if (v === 14) { var bl14 = _bedLayout(state || STATE).L; return { min: bl14, max: bl14 }; }   /* v273: the bed's length = its mattress */
    if (v === 15) return { min: GB.L_MIN, max: GB.L_MAX };   /* v284 the 2x4 bench */
    if (v === 54) return _rtbRange(state || STATE);   /* v414 the twist bench: the table layout needs a little more */
    if (v === 16) { var sb16 = _sbLayout(state || STATE).L; return { min: sb16, max: sb16 }; }   /* v288 the sunbed: its length is fixed */
    return RANGES.L;
  }

  /* Fixed lumber cross-sections (nominal US / 2x4 plan convention,
     converted to metric for geometry; BoQ rounds to mm cuts):
       2x4: actual 38 x 89 mm
       4x4: actual 89 x 89 mm */
  var DIMS = {
    twoByFour: { t: 0.038, w: 0.089 },
    fourByFour:{ t: 0.089, w: 0.089 },
    plankGap:  0.006,
    seatPlankCount: 8,
    postHeight:0.597    /* 23.5" corner post height */
  };

  /* Active lumber profile + BoQ codes by level. Children (lvl 2) use the
     smaller standard profiles 3×3 (KVH08080, 80×80) for legs and 3×2
     (KVH08060, 80×60) for framing; adults use 4×4 (KVH10100) and 2×4
     (KVH10060). No prices here — they live in the central BoQ sheet, which
     the user edits per project. */
  function _lumber(s) {
    s = s || STATE;
    var kid = (s.lvl === 2);
    return {
      post:      kid ? 0.080 : DIMS.fourByFour.t,
      t:         kid ? 0.060 : DIMS.twoByFour.t,
      w:         kid ? 0.080 : DIMS.twoByFour.w,
      seatTop:   kid ? 0.30  : 0.45,
      postCode:  kid ? 'KVH08080' : 'KVH10100',
      frameCode: kid ? 'KVH08060' : 'KVH10060',
      /* Seat + backrest PLANKS. Adults reuse the framing profile (2×4);
         kids get a thin 1×4 planed board (TIM20100, 20×100) so the seat
         surface looks like a board rather than a chunky 60 mm-thick
         framing member. plankT = thickness (vertical), plankW = board
         width. */
      plankT:    kid ? 0.020 : DIMS.twoByFour.t,
      plankW:    kid ? 0.100 : DIMS.twoByFour.w,
      plankCode: kid ? 'TIM20100' : 'KVH10060'
    };
  }

  /* ----------------------------------------------------------
     BENCH VARIANTS — top switcher cycles 1..6.
     Each key drives BenchRenderer.build() dispatch + BenchBoQ.compute()
     dispatch. Default lumber assumes pressure-treated softwood unless
     overridden by per-variant DEFAULTS at a later point.
     ---------------------------------------------------------- */
  var VARIANT_KEYS = [
    'park_bench',
    'sofa',
    'wave_bench',
    'hollywood_swing',   /* slot 4 was the Heavy Timber placeholder (no code) */
    'picnic_set',        /* slot 5 was the Gabion placeholder */
    'block_bench',
    /* 2026-10-13, Marek: build them all -- placeholders until each is done */
    'porch_swing',       /* 7  hung under a beam: the park bench seat on chains */
    'frame_swing',       /* 8  the same seat on the Hollywood swing's stand (a fork) */
    'adirondack',        /* 9  chair / loveseat / 3 */
    'planter_bench',     /* 10 between two planters */
    'tree_bench',        /* 11 hexagonal, round a tree */
    'storage_bench',     /* 12 with a lidded box */
    'kids_swing_set',    /* 13 A-frames + beam, 1-3 swings */
    'bed',               /* 14 v273: the sofa's frame as a bed, headboard on / off */
    'glued_bench',       /* 15 v284: the 2x4 bench, glued + brads, only the length */
    'sunbed',            /* 16 v288: the double sunbed, 2x6 box, slats, the backrest on props */
    'pergola_swing',     /* 17 v296: the classic porch seat hung in a 6x6 pergola */
    'modern_swing',       /* 18 v301: the sofa seat on three 6x6 portals tied between their beams */
    'cinema_bar',        /* 19 v303: GARDEN STRUCTURE 1, the bar with the movie screen */
    'raised_bed',        /* 20 v314: GARDEN STRUCTURE 2, the raised bed (basic / pyramid / cold frame) */
    'floating_bed',      /* 21 v318: BENCHES & LOUNGE, the floating bed (ash + spruce, nightstands, LED) */
    'garden_arbor',      /* 22 v320: GARDEN STRUCTURE 3, the arbor (flat / gable roof, laths, the path's tiles) */
    'garden_gazebo',     /* 23 v328: GARDEN STRUCTURE 4, the gazebo (hexagon / square, deck, hipped roof, railing) */
    'garden_pergola',    /* 24 v334: GARDEN STRUCTURE 5, the pergola (rectangle / square, flat / gable / hip, covering, infill fields) */
    'mancave_bar',       /* 25 v355: GARDEN STRUCTURE, the bar (Adam's author project: slab, frames, corrugated roof, back wall, the L counter in stone and tiles) */
    'playhouse_cottage', /* 26 v362: PLAYHOUSES 1, the cottage (deck blocks, framed walls, gable roof, siding, door, shutters, the porch on the toggle) */
    'playhouse_stilt',   /* 27 v363: PLAYHOUSES 2, the stilt house (the cottage on posts + ground screws, a guarded porch, the ladder, the slide on the toggle) */
    'playhouse_aframe',  /* 28 v364: PLAYHOUSES 3, the A-frame hut (the cottage's floor, a 60 deg A-frame down to the sills, framed gables, the porch on the toggle under the roof) */
    'playhouse_fort',    /* 29 v365: PLAYHOUSES 4, the play fort (an open tower on ground screws, fort walls, ladder, slide, the swings on the toggle) */
    'playhouse_modern',  /* 30 v366: PLAYHOUSES 5, the modern house (the cottage's body under a mono-pitch standing-seam roof, a wide window, the porch on the toggle) */
    'playhouse_barn',    /* 31 v367: PLAYHOUSES 6, the little barn (the cottage's floor and walls, a gambrel of gusseted trusses, double doors + a hayloft door, the loft on the toggle) */
    'playhouse_treefort',/* 32 v368: PLAYHOUSES 7, the tree fort (the play fort's open deck round a living tree on posts of its own, the trunk's opening framed, knee braces, fort walls, ladder, the slide on the toggle) */
    'greenhouse_gable', /* 33 v373: GREENHOUSES 1, the gable greenhouse (ground screws, 4x6 base, 2x4 walls, a gable roof, twinwall polycarbonate, door, roof vents, the knee wall on the toggle) */
    'coop_backyard',     /* 34 v375: COOP 1, the backyard coop (a hen house 2 ft up at the back of a hardware-cloth run under one gable roof; the hens size it) */
    'kitchen_pod',       /* 35 v376: KITCHEN POD 1, the kitchen pod (a timber box on ground screws, the front lifting on gas struts into a roof over the counter: grill, sink, drawers) */
    'greenhouse_lean',   /* 36 v378: GREENHOUSES 2, the lean-to greenhouse (against a house wall: its own back wall, one slope, the endwall flashing, brackets to the house, the door in an end wall, the knee wall on the toggle) */
    'coop_tractor',      /* 37 v379: COOP 2, the chicken tractor (a movable A-frame on skids, the hen house up in it at the back, the run in hardware cloth, wheels on the toggle) */
    'greenhouse_hoop',   /* 38 v381: GREENHOUSES 3, the hoop house (galvanized tube hoops, film, roll-up sides, framed end walls) */
    'coop_walkin',       /* 39 v383: COOP 3, the walk-in coop (the backyard coop's build with 8 ft walls: a run a person walks into, the house a walk-in shed, 6-20 hens) */
    'greenhouse_aframe', /* 40 v384: GREENHOUSES 4, the A-frame greenhouse (60 deg slopes to the base, twinwall, triangular end walls, the door in the front) */
    'kennel_classic',    /* 41 v385: KENNEL 1, the classic dog house (the cottage at a dog's scale: deck blocks, a 2x4 floor, framed walls, a gable roof, the doorway in the gable; the porch on the toggle; the dog's height sizes it) */
    'coop_leanto',       /* 42 v386: COOP 4, the lean-to coop (the backyard coop's build against a house wall: one slope falling away from it, a flashing and angle brackets to it) */
    'greenhouse_victorian', /* 43 v387: GREENHOUSES 5, the Victorian greenhouse (the gable's front, a half-octagon bay at the back under hips, the knee wall on) */
    'kennel_insulated', /* 44 v388: KENNEL 2, the insulated dog house (the classic's build with two rooms -- a windbreak entry and the sleeping room behind a framed partition, the openings at opposite ends --, XPS in the floor, walls, partition and a flat ceiling, OSB lining; the flap on the toggle) */
    'greenhouse_oldwindow', /* 45 v390: GREENHOUSES 6, the old-window greenhouse (the gable's frame, its walls of reclaimed sashes, the size on the slider) */
    'coop_cupola',       /* 46 v391: COOP 5, the cupola coop (the product picture's: a tall house with a cupola, a window with shutters over its door, a lower run joined to its side with a top of hardware cloth) */
    'kennel_run',        /* 47 v392: KENNEL 3, the dog kennel with run (the classic's build, its porch a welded-wire run under the roof: studs, a front rail, a gate) */
    'kennel_double',     /* 48 v396: KENNEL 4, the double dog house (two rooms side by side under one gable, a partition under the ridge carrying it, a doorway each) */
    'coop_barn'          /* 49 v397: COOP 6, the barn coop (the backyard coop's house and run under the little barn's gambrel of gusseted trusses) */
  ];
  /* SHOPIFY ORDER != TYPE NUMBER. The variant's SKU carries its type
     (BENCH-T<n>) so the storefront can order the variants freely (benches
     and swings alternating, Marek); STATE.variant is always the TYPE. */
  var SLOT_TYPES = null;   /* the storefront order as types, set by the snippet */
  function setSlotTypes(arr) { if (arr && arr.length) SLOT_TYPES = arr.slice(0); }
  function typeFromSku(sku, pos) {
    var m = /BENCH-T(\d+)/i.exec(String(sku || ''));
    return m ? (+m[1]) : (pos | 0);
  }
  /* No hardcoded display names. Variant labels come exclusively from
     BOOT.i18n.variant_vN, populated by Shopify's `| t` filter against
     translation key configurator.bench_vN (see locale files). The lib
     exposes only the internal keys (used as i18n fallbacks). */
  /* ----------------------------------------------------------
     MATERIALS — hardcoded material catalog (matches the BoQ database).
     Each entry is the source of truth for BoQ output, display, and
     (optionally) Three.js material color/finish.
     ---------------------------------------------------------- */
  var MATERIALS = {
    /* ── LUMBER PROFILES ────────────────────────────────────── */
    KVH10060: {
      id: 'KVH10060',
      name: '2×4 KVH lumber',
      category: 'lumber',
      profile: { w: 0.050, h: 0.100 },
      unit: 'm',
      unitPrice: 8.50,
      selectable: true,
      color: 0xb98c5e,
      roughness: 0.85
    },
    KVL20040: {
      id: 'KVL20040',
      name: '1×2 timber batten',
      category: 'lumber',
      /* Physical 25×50mm (planed 1×2) — geometry unchanged across imperial/metric */
      profile: { w: 0.025, h: 0.050 },
      unit: 'm',
      unitPrice: 2.20,
      selectable: true,
      color: 0xd9b07e,
      roughness: 0.80
    },
    /* ── DECKING ────────────────────────────────────────────── */
    TST00001: {
      id: 'TST00001',
      name: '1×6 decking',
      category: 'decking',
      profile: { w: 0.025, h: 0.152 },
      unit: 'm',
      unitPrice: 5.40,
      selectable: true,
      color: 0x8c5d3a,
      roughness: 0.95
    },
    /* ── ROOFING ────────────────────────────────────────────── */
    ROR12004: {
      id: 'ROR12004',
      name: 'Corrugated roofing',
      category: 'roofing',
      unit: 'm²',
      unitPrice: 18.00,
      selectable: true,
      color: 0xc4c8cc,
      roughness: 0.45,
      metalness: 0.85
    },
    /* ── FASTENERS — calculated, NOT individually selectable ─ */
    FAT00006: { id: 'FAT00006', name: '12×76mm dowel pin', category: 'fastener', unit: 'pcs', unitPrice: 0.09, selectable: false },
    FAS80100: { id: 'FAS80100', name: '8×100mm wood screw', category: 'fastener', unit: 'pcs', unitPrice: 0.18, selectable: false },
    FAS80060: { id: 'FAS80060', name: '8×60mm pocket-hole screw', category: 'fastener', unit: 'pcs', unitPrice: 0.14, selectable: false },
    FAS60160: { id: 'FAS60160', name: '6×160mm wood screw', category: 'fastener', unit: 'pcs', unitPrice: 0.22, selectable: false },
    FAS60080: { id: 'FAS60080', name: '6×80mm wood screw',  category: 'fastener', unit: 'pcs', unitPrice: 0.12, selectable: false },
    FAS50060: { id: 'FAS50060', name: '5×60mm wood screw',  category: 'fastener', unit: 'pcs', unitPrice: 0.08, selectable: false },
    FAS00225: { id: 'FAS00225', name: 'EPDM sealing screw 25mm', category: 'fastener', unit: 'pcs', unitPrice: 0.35, selectable: false },
    /* ── FURNITURE / OUTDOOR ────────────────────────────────── */
    /* Mattress (sofa seat cushion). Always 1 pc in the BoQ — the buyer
       fits whatever size they like, so we don't encode dimensions here.
       Name/price come from the central sheet (FOU00016); this local entry
       is just the cold-start fallback so the unit shows as pcs. */
    FOU00016: { id: 'FOU00016', name: 'Mattress', category: 'furniture', unit: 'pcs', unitPrice: 0, selectable: false },
    /* 4×4 corner post (100×100 mm), used as the 4 bench legs. The
       central BoQ sheet is the source of truth; this entry is just
       the local fallback for assembly-label resolution. */
    KVH10100: {
      id: 'KVH10100',
      name: '4×4 KVH corner post',
      category: 'lumber',
      profile: { w: 0.100, h: 0.100 },
      unit: 'm',
      unitPrice: 14.20,
      selectable: true,
      color: 0xa97a4e,
      roughness: 0.85
    },
    /* Children profiles — standard 3×3 / 3×2 (smaller, cheaper). Price is
       supplied by the central BoQ sheet, not hardcoded here. */
    KVH08080: {
      id: 'KVH08080',
      name: '3×3 KVH corner post',
      category: 'lumber',
      profile: { w: 0.080, h: 0.080 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0xa97a4e,
      roughness: 0.85
    },
    KVH08060: {
      id: 'KVH08060',
      name: '3×2 KVH lumber',
      category: 'lumber',
      profile: { w: 0.060, h: 0.080 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0xb98c5e,
      roughness: 0.85
    },
    /* Thin planed board for kids seat / backrest planks (1×4, 20×100).
       Price comes from the central BoQ sheet. */
    TIM20100: {
      id: 'TIM20100',
      name: '1×4 planed timber board',
      category: 'lumber',
      profile: { w: 0.100, h: 0.020 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0xc9a06a,
      roughness: 0.80
    },
    KVH16160: {
      id: 'KVH16160',
      name: '6×6 structural post',
      category: 'lumber',
      profile: { w: 0.160, h: 0.160 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0x9a7048,
      roughness: 0.85
    },
    KVH03838: {
      id: 'KVH03838',
      name: '38×38 timber batten',
      category: 'lumber',
      profile: { w: 0.038, h: 0.038 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0xb08a5e,
      roughness: 0.82
    },
    KVH03030: {
      id: 'KVH03030',
      name: '30×30 timber batten',
      category: 'lumber',
      profile: { w: 0.030, h: 0.030 },
      unit: 'm',
      unitPrice: 0,
      selectable: true,
      color: 0xbe9568,
      roughness: 0.82
    },
    /* Hollywood swing (variant 4). Cold-start fallbacks only: name, price
       and translations come from the central sheet; the unit decides how
       the quantity is published (m -> ft, pcs stays integer). */
    KVH10160: { id: 'KVH10160', name: '4x6 beam', category: 'lumber', profile: { w: 0.100, h: 0.160 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xa97a4e, roughness: 0.85 },
    FAT00002: { id: 'FAT00002', name: 'Swing hanger', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT00003: { id: 'FAT00003', name: 'Eye bolt', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT00004: { id: 'FAT00004', name: 'Chain', category: 'fastener', unit: 'm', unitPrice: 0, selectable: false },
    FAT10002: { id: 'FAT10002', name: 'Hex bolt M10x130 with nut and washers', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT16010: { id: 'FAT16010', name: 'Steel threaded rod M16', category: 'fastener', unit: 'm', unitPrice: 0, selectable: false },
    FAT16011: { id: 'FAT16011', name: 'Nut M16', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT16001: { id: 'FAT16001', name: 'Steel washer M16', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT16002: { id: 'FAT16002', name: 'Steel cap nut M16', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS60120: { id: 'FAS60120', name: 'Wood screw 6x120', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS60160: { id: 'FAS60160', name: 'Wood screw 6x160', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS80160: { id: 'FAS80160', name: 'Wood screw 8x160', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS60080: { id: 'FAS60080', name: 'Wood screw 6x80', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS70000: { id: 'FAS70000', name: 'Nails 70', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS55050: { id: 'FAS55050', name: 'Stainless screw A2 5.5x50', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    ROD00050: { id: 'ROD00050', name: 'Drip edge 50', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },
    ROD06030: { id: 'ROD06030', name: 'Gable flashing 60x30', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },
    MFP00002: { id: 'MFP00002', name: 'Exposed wood coating', category: 'finish', unit: 'm2', unitPrice: 0, selectable: false },
    FOU00027: { id: 'FOU00027', name: 'Worktop', category: 'furniture', unit: 'm2', unitPrice: 0, selectable: false },
    FOU00034: { id: 'FOU00034', name: 'Butcher block countertop', category: 'furniture', unit: 'm', unitPrice: 0, selectable: false },   /* v354 the cinema bar's acacia top, by the metre */   /* v309 the cinema bar's slab: published in m2 with decimals */
    SFF00004: { id: 'SFF00004', name: 'Potting soil', category: 'foundation', unit: 'm3', unitPrice: 0, selectable: false },   /* v314 the raised bed's + the planter's soil: m3 with decimals (whole m3 before) */
    PFG00001: { id: 'PFG00001', name: 'Geotextile', category: 'foundation', unit: 'm2', unitPrice: 0, selectable: false },   /* v314 */
    OEB00001: { id: 'OEB00001', name: 'Clear vinyl roll 140 cm', category: 'finish', unit: 'm', unitPrice: 0, selectable: false },   /* v314 the cold frame's vinyl */
    FAS80260: { id: 'FAS80260', name: 'Washer head screw 8x260', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    EEC00006: { id: 'EEC00006', name: 'LED strips 24V', category: 'electrical', unit: 'm', unitPrice: 0, selectable: false },
    EEE00001: { id: 'EEE00001', name: 'Electric cable 3 x 2.5', category: 'electrical', unit: 'm', unitPrice: 0, selectable: false },   /* v318 the floating bed's sockets / switches */
    FEC00043: { id: 'FEC00043', name: 'Exterior wood glue', category: 'consumable', unit: 'l', unitPrice: 0, selectable: false },   /* v318 litres with decimals (was whole) */
    FMA00002: { id: 'FMA00002', name: 'Mattress', category: 'furniture', unit: 'pcs', unitPrice: 0, selectable: false },        /* v308 the modern swing's LED top */
    EEC00007: { id: 'EEC00007', name: 'LED power supply 24V', category: 'electrical', unit: 'pcs', unitPrice: 0, selectable: false },
    KVH60120: { id: 'KVH60120', name: '60x120 member', category: 'lumber', profile: { w: 0.060, h: 0.120 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xb98f60, roughness: 0.82 },
    KVH60200: { id: 'KVH60200', name: '60x200 member', category: 'lumber', profile: { w: 0.060, h: 0.200 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xa97a4e, roughness: 0.85 },
    KVH16240: { id: 'KVH16240', name: '160x240 member', category: 'lumber', profile: { w: 0.160, h: 0.240 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xa97a4e, roughness: 0.85 },   /* v312 the cinema bar's ridge (published in m with decimals) */
    KVH60160: { id: 'KVH60160', name: '60x160 member', category: 'lumber', profile: { w: 0.060, h: 0.160 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xa97a4e, roughness: 0.85 },   /* v303 (the pergola swing's rafters published as whole metres before) */
    FEE00001: { id: 'FEE00001', name: 'Excavations', category: 'foundation', unit: 'm\u00b3', unitPrice: 0, selectable: false },   /* v303 the footings: published with decimals (rounded to 0 before) */
    FCO00001: { id: 'FCO00001', name: 'Gravel base', category: 'foundation', unit: 'm\u00b3', unitPrice: 0, selectable: false },
    FCO00002: { id: 'FCO00002', name: 'Structural concrete', category: 'foundation', unit: 'm\u00b3', unitPrice: 0, selectable: false },
    TIM45120: { id: 'TIM45120', name: '45x120 planed timber', category: 'lumber', profile: { w: 0.045, h: 0.120 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xc9a06a, roughness: 0.80 },
    KVH10200: { id: 'KVH10200', name: '100x200 beam', category: 'lumber', profile: { w: 0.100, h: 0.200 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xa97a4e, roughness: 0.85 },
    KVH40060: { id: 'KVH40060', name: '40x60 batten', category: 'lumber', profile: { w: 0.040, h: 0.060 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xb08a5e, roughness: 0.82 },
    KVH10080: { id: 'KVH10080', name: '100x80 rafter', category: 'lumber', profile: { w: 0.080, h: 0.100 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xb98c5e, roughness: 0.85 },
    KVH16080: { id: 'KVH16080', name: '160x80 bracket', category: 'lumber', profile: { w: 0.080, h: 0.160 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xb98c5e, roughness: 0.85 },
    KVH16040: { id: 'KVH16040', name: '160x40 bracket', category: 'lumber', profile: { w: 0.040, h: 0.160 }, unit: 'm', unitPrice: 0, selectable: true, color: 0xb98c5e, roughness: 0.85 },
    FAS60100: { id: 'FAS60100', name: 'Wood screw 6x100', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAT00001: { id: 'FAT00001', name: 'Carpentry connector plate', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    ROT00005: { id: 'ROT00005', name: 'Truss connector plate', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS38038: { id: 'FAS38038', name: 'Structural connector nail', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS80180: { id: 'FAS80180', name: 'Wood screw 8x180', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS70000: { id: 'FAS70000', name: 'Nails 70', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS63000: { id: 'FAS63000', name: 'Staples 63', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FAS00318: { id: 'FAS00318', name: 'Roofing nails', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    FEC00038: { id: 'FEC00038', name: 'PU construction sealant', category: 'fastener', unit: 'pcs', unitPrice: 0, selectable: false },
    OSB25002: { id: 'OSB25002', name: 'OSB board 18', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    ROR00008: { id: 'ROR00008', name: 'Breathable roof underlay', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    ROR00001: { id: 'ROR00001', name: 'Asphalt shingle', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    ROM02401: { id: 'ROM02401', name: 'Drip edge flashing', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },
    ROR00006: { id: 'ROR00006', name: 'Gable flashing', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },
    /* v362 the cottage's sheets / boards (the unit sets the budget's rounding); KVR14619 + ROR00009 had none: their m2 / m went out as whole numbers */
    OSB25001: { id: 'OSB25001', name: 'OSB board 15', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    EGP04001: { id: 'EGP04001', name: 'Edge-glued solid wood panel', category: 'sheet', unit: 'm\u00b2', unitPrice: 0, selectable: false },   /* v419 the twist bench's slats */
    FCP00009: { id: 'FCP00009', name: 'Panel siding', category: 'facade', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    FVW09619: { id: 'FVW09619', name: 'T&G board', category: 'lumber', unit: 'm', unitPrice: 0, selectable: false },
    FVW02660: { id: 'FVW02660', name: 'Wood corner trim', category: 'lumber', unit: 'm', unitPrice: 0, selectable: false },
    KVR14619: { id: 'KVR14619', name: 'Planed T&G timber plank', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    ROR00009: { id: 'ROR00009', name: 'Ridge cap flashing', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },
    ROR00013: { id: 'ROR00013', name: 'Endwall flashing', category: 'roofing', unit: 'm', unitPrice: 0, selectable: false },   /* v378 the lean-to greenhouse at the house wall (m, with decimals) */
    FEC00033: { id: 'FEC00033', name: 'Aluminium foil tape', category: 'fastener', unit: 'm', unitPrice: 0, selectable: false },
    FVW01351: { id: 'FVW01351', name: 'Wood facade cladding', category: 'facade', unit: 'm\u00b2', unitPrice: 0, selectable: false },
    SMR00121: { id: 'SMR00121', name: 'PEX/AL/PEX pipe 16 blue', category: 'plumbing', unit: 'm', unitPrice: 0, selectable: false },   /* v382 the kitchen pod's water supply */
    SMR00321: { id: 'SMR00321', name: 'PP HT waste pipe 32', category: 'plumbing', unit: 'm', unitPrice: 0, selectable: false },       /* v382 its waste */
    GAP00004: { id: 'GAP00004', name: 'Gas line pipe 1/2 in.', category: 'gas', unit: 'm', unitPrice: 0, selectable: false },           /* v382 its gas lines */   /* v376 the kitchen pod's cladding (m2, decimals) */
    INS00002: { id: 'INS00002', name: 'Breathable membrane', category: 'facade', unit: 'm\u00b2', unitPrice: 0, selectable: false },   /* v376 its walls' membrane */
    FVF00301: { id: 'FVF00301', name: 'Timber batten 30x50', category: 'lumber', unit: 'm', unitPrice: 0, selectable: false },   /* v376 its cladding's battens */   /* v373 the greenhouse's glazing tape (m, with decimals) */
    KVR14024: { id: 'KVR14024', name: 'Timber plank 1x6', category: 'lumber', unit: 'm', unitPrice: 0, selectable: false },   /* v365 the play fort's boards (by the metre) */
    ROR12003: { id: 'ROR12003', name: 'Lightweight roof covering', category: 'roofing', unit: 'm\u00b2', unitPrice: 0, selectable: false }   /* v366 the modern house's standing seam (the gazebo's / pergola's went out as whole m2 before) */
  };

  /* Map screw-tag → material ID (which physical fastener is used at each joint). */
  var SCREW_MATERIAL = {
    'screw-frame':       'FAS80100',
    'screw-decking':     'FAS60080',
    'screw-post-bottom': 'FAS80100',
    'screw-rail-side':   'FAS80100',
    'screw-rail-long':   'FAS60080',
    'screw-rafter':      'FAS60160',
    'screw-batten':      'FAS50060',
    'screw-roof':        'FAS00225',
    'screw-brace':       'FAS80100'
  };

  /* Map lumber-part-tag → material ID. */
  var PART_MATERIAL = {
    'frame':     'KVH10060',
    'post':      'KVH10060',
    'rail-long': 'KVH10060',
    'rail-side': 'KVH10060',
    'rafter':    'KVH10060',
    'brace':     'KVH10060',
    'batten':    'KVL20040',
    'decking':   'TST00001',
    'roof':      'ROR12004'
  };

  /* ----------------------------------------------------------
     RACK INSTANCES — single source of truth for clickable parts.

     Each mesh that the user can pick in 3D stage 1 (default full
     build view) gets
     registered here during BenchRenderer.build(). The registry is
     queried by:
       • BenchRaycaster — picks instance from raycast hit mesh
       • ConfiguratorAssetDrawer — paints BoQ + per-instance data
       • BenchHighlight — applies hover/select rendering

     Instance shape (MINIMAL — bridge provides rich data on demand):
       {
         id          — stable string ('rack-post-high-back-l', …)
         partType    — internal rack tag ('post', 'decking', …) used by
                       the renderer for opacity / highlight rules
         boqCode     — material ID ('KVH10060', 'TST00001', …) — links
                       to central BoQ Google Sheet (name, category,
                       unit, translations) and to user_prices
                       (per-customer affiliate product assignment)
         length      — this piece's contribution (m for lumber, m² for roof)
         position    — { x, y, z } world coords (snapshot at build time)
         mesh        — Three.js mesh reference
       }

     NAME, CATEGORY, UNIT, etc. are NOT stored here. They are looked
     up at drawer-open time via ConfiguratorBudgetBridge.getBoqItem,
     which fetches from the central BoQ Google Sheet — single source
     of truth, localized across 20 languages.

     Rebuilt fresh on every BenchRenderer.build() — STATE changes
     reset the registry, so instance IDs aren't stable across L/W/H
     edits. That's deliberate: the drawer closes on any rebuild, and
     IDs only need to last for the lifetime of a single configuration.
     ---------------------------------------------------------- */
  global.BenchInstances = {
    _list:    {},     /* id → instance */
    _meshes:  [],     /* parallel array of meshes for raycaster */
    _counter: {},     /* partType → next index */

    clear: function () {
      this._list = {};
      this._meshes = [];
      this._counter = {};
    },

    /* Add one instance. Returns the assigned ID (caller may stash). */
    add: function (instance) {
      if (!instance || !instance.id) return null;
      this._list[instance.id] = instance;
      if (instance.mesh) this._meshes.push(instance.mesh);
      return instance.id;
    },

    /* Generate an auto-id from partType + counter. Use idHint to inject
       a meaningful suffix ('post-high-back-l', 'decking-3') when the
       caller can be specific; otherwise falls back to numeric index. */
    nextId: function (partType, idHint) {
      if (this._counter[partType] === undefined) this._counter[partType] = 0;
      var idx = this._counter[partType]++;
      var suffix = idHint || String(idx).padStart(2, '0');
      return 'rack-' + partType + '-' + suffix;
    },

    get: function (id) {
      return this._list[id] || null;
    },

    all: function () {
      var out = [];
      for (var k in this._list) {
        if (this._list.hasOwnProperty(k)) out.push(this._list[k]);
      }
      return out;
    },

    meshes: function () {
      return this._meshes.slice();
    },

    /* Reverse lookup: find instance by mesh reference (used by raycaster
       to translate a hit Object3D back to an instance). */
    findByMesh: function (mesh) {
      if (!mesh) return null;
      for (var k in this._list) {
        if (this._list.hasOwnProperty(k) && this._list[k].mesh === mesh) {
          return this._list[k];
        }
      }
      return null;
    },

    /* Helper used by drawer to enrich an instance with project-level
       quantities, BoQ master data, and any per-customer affiliate
       product assignment.

       Single source of truth (in priority order):
         1. ConfiguratorBudgetBridge — Central BoQ Google Sheet (name,
            category, unit, dimensions, translations) +
            per-customer user_prices (assigned product, price, URL,
            image, vendor). Both shared with budget-prd-cat-selector.
         2. MATERIALS (this file) — geometric profile data only
            (width/height of timber profile, color, roughness). These
            are intrinsic configurator-renderer concerns, NOT BoQ data.
         3. BenchBoQ.compute() — project quantity for this code (the
            configurator OWNS amount calculations per Marek's design).

       The drawer doesn't care about MATERIALS at all; it sees the
       enriched shape below. Bridge calls are null-safe — if the bridge
       hasn't loaded yet (slow Sheets fetch), the drawer falls back to
       the partType / category we tagged at build() time, so the user
       sees something meaningful immediately and the rich BoQ name
       fills in once the sheet finishes loading. */
    enrichForDrawer: function (instance) {
      if (!instance) return null;
      var bridge = global.ConfiguratorBudgetBridge || null;

      /* Bridge: BoQ master data (localized name/category/unit from
         the central Google Sheet's per-locale columns). If the bridge
         hasn't loaded yet (slow Sheets fetch on first visit), we fall
         back to the BoQ code itself so the user sees something stable
         while the rich data fills in once the sheet finishes loading. */
      var boqItem = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(instance.boqCode) : null;
      var name     = (boqItem && boqItem.name)     || instance.boqCode;
      var category = (boqItem && boqItem.category) || null;

      /* Pick metric/imperial unit based on STATE.
         Resolution order:
           1. Localized unit from the central Google Sheet (best —
              respects locale, e.g. CS "ks" vs EN "pcs").
           2. Local MATERIALS catalog unit (always available, never
              localized — used while the sheet is still loading or
              when an item isn't in the sheet yet).
           3. null — drawer renders "—" rather than guess.
         The fallback to MATERIALS guarantees the user never sees a
         bare number without a unit, even on a cold first visit
         when the sheet fetch is still in flight. */
      var unit = boqItem
        ? (STATE.isMetric ? boqItem.unitMetric : boqItem.unitImperial)
        : null;
      if (!unit) {
        var localMat = MATERIALS[instance.boqCode];
        if (localMat && localMat.unit) {
          /* Local catalog stores metric units. For imperial mode we
             map area/linear unit names so the user sees a consistent
             system (no "ft × 18 m²" mixups). */
          if (STATE.isMetric) {
            unit = localMat.unit;
          } else {
            var lm = String(localMat.unit).toLowerCase();
            if (lm === 'm' || lm === 'meter')          unit = 'ft';
            else if (lm === 'm²' || lm === 'm2')       unit = 'ft²';
            else if (lm === 'm³' || lm === 'm3')       unit = 'ft³';
            else                                        unit = localMat.unit; /* pcs / kg — unchanged */
          }
        }
      }

      /* `type` shown in the drawer's Instance section. We use the BoQ
         name (already localized via the sheet) — no hardcoded English
         text. The technical identifier (idHint) is already visible as
         the Instance ID, so the type field stays purely descriptive
         of WHAT the part is, not WHERE it is. */
      var type = name;

      /* Bridge: user_prices assignment (if any).
         userPrice.price is ALREADY converted to current unit by the
         bridge (e.g. $7/FT in imperial mode), and userPrice.priceMetric
         keeps the raw storage value ($22.97/m) for any consumer that
         needs it. */
      var userPrice = (bridge && bridge.getUserPrice) ? bridge.getUserPrice(instance.boqCode) : null;
      var product = userPrice ? {
        title:    userPrice.title,
        url:      userPrice.url,
        image:    userPrice.image,
        source:   userPrice.source,
        price:    userPrice.price,
        currency: userPrice.currency,
        unit:     unit
      } : null;

      /* Project quantity. BenchBoQ.byMaterial holds METRIC values
         (e.g. 46.32 m for KVH lumber). For the drawer's "Project
         quantity" and "Project total" lines we want CURRENT-unit
         numbers, so the math user sees matches the unit label next
         to it (151.93 FT × $7/FT = $1063 in imperial). */
      var boq = global.BenchBoQ ? global.BenchBoQ.compute() : null;
      var metricQty = (boq && boq.byMaterial) ? boq.byMaterial[instance.boqCode] : null;

      /* Convert qty to current unit via the same coefficient logic
         the bridge uses for prices. Keeps math symmetric: if qty is
         multiplied by 3.281 going metric→imperial, price is divided
         by 3.281 the other way → total stays invariant. */
      var qty = metricQty;
      if (metricQty != null && !STATE.isMetric && boqItem) {
        var label = String(boqItem.unitMetric || '').trim().toUpperCase();
        if (label === 'M')        qty = metricQty * 3.281;
        else if (label === 'M2')  qty = metricQty * 10.764;
        else if (label === 'M3')  qty = metricQty * (String(boqItem.unitImperial || '').trim().toUpperCase() === 'YD3' ? 1.30795 : 35.315);
        /* PCS/KG/unknown — keep metric value (already correct). */
      }

      /* Project totals — uses per-customer price when available.
         Both unitPrice and qty are now in the same unit system, so
         the multiplication is meaningful. */
      var unitPrice = (userPrice && typeof userPrice.price === 'number') ? userPrice.price : null;
      var currency  = (userPrice && userPrice.currency) || null;
      var totalPrice = (qty != null && unitPrice != null) ? (qty * unitPrice) : null;

      return {
        id:                 instance.id,
        name:               name,
        type:               type,
        boqCode:            instance.boqCode,
        category:           category,
        unit:               unit,
        position:           instance.position,
        length:             instance.length,
        /* 2D extent for plate-like pieces (roof, decking). If set,
           the asset drawer shows "L × W m" and hides the linear
           length cell. Lumber leaves this null. */
        dimensions:         instance.dimensions || null,
        projectQuantity:    qty,
        projectUnitPrice:   unitPrice,
        projectTotalPrice:  totalPrice,
        currency:           currency,
        product:            product
      };
    }
  };

  /* ----------------------------------------------------------
     BENCH BOQ
     ---------------------------------------------------------- */
  global.BenchBoQ = {
    /* Dispatcher: each variant has its own _compute. All return a uniform
       shape with byMaterial map + flat fields (kvh/tst/ror) for the
       legacy refreshUI bindings (info-bar). */
    compute: function (s) {
      s = s || STATE;
      var v = (s.variant | 0) || 1;
      switch (v) {
        case 1: return this._computeParkBench(s);
        case 2: return this._computeSofa(s);
        case 3: return this._computeWaveBench(s);
        case 4: return this._computeSwing(s);
        case 5: return this._computePicnic(s);
        case 6: return this._computeBlock(s);
        case 7: return this._computePorch(s);
        case 8: return this._computeSwing(s);   /* the A-frame swing: the Hollywood stand + the porch seat */
        case 9: return this._computeAdi(s);
        case 10: return this._computePlanter(s);
        case 11: return this._computeTree(s);
        case 12: return this._computeStorage(s);
        case 13: return this._computeKids(s);
        case 14: return this._computeBed(s);
        case 15: return this._computeGlued(s);   /* v284 */
        case 54: return this._computeRotBench(s);   /* v414 the twist bench */
        case 16: return this._computeSunbed(s);  /* v288 */
        case 17: return this._computePergola(s); /* v296 */
        case 18: return this._computeModernSwing(s); /* v301 */
        case 19: return this._computeGarden(s);  /* v303 */
        case 20: return this._computeRaisedBed(s);  /* v314 */
        case 21: return this._computeFloatingBed(s);  /* v318 */
        case 22: return this._computeArbor(s);        /* v320 */
        case 23: return this._computeGazebo(s);       /* v328 */
        case 24: return this._computeGardenPergola(s);   /* v334 (the pergola swing has _computePergola) */
        case 25: return this._computeManCaveBar(s);
        case 26: case 27: case 28: case 29: case 30: case 31: case 32: case 34: case 37: case 39: case 41: case 42: case 44: case CS_TYPE: case 46: case 47: case 48: case 49: case 52: case 51: return this._computePlayhouse(s);   /* v403 + the modern dog house */   /* v392 + the kennel with run */   /* v388 + the insulated dog house */   /* v379 + the chicken tractor */   /* v375 + the backyard coop */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */       /* v362 the cottage */      /* v355 the bar */
        case 33: case 36: case 38: case 40: case 43: case 45: return this._computeGreenhouse(s);      /* v373 the gable greenhouse; v378 + the lean-to; v381 + the hoop house */
        case 35: case 53: return this._computeKitchenPod(s);      /* v376 the kitchen pod (v407 + GARDEN POD Fitness) */
        default: return (v >= 7) ? this._stub(VARIANT_KEYS[v - 1] || 'bench') : this._computeParkBench(s);
      }
    },

    _stub: function (kind) {
      return {
        byMaterial: {},
        kvh: 0, tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: 0, lag_screws: 0,
        variant_kind: kind
      };
    },

    /* Sofa (variant 2) — massive 6×6 frame only (this increment). All
       members are KVH16160; metres sum the 4 posts + 2 arm rails + back
       top rail + 4 lower seat-box rails. 4 pocket screws per frame joint. */
    _computeSofa: function (s) {
      s = s || STATE;
      /* At viz stage 5 the scene is an assembly: the current sofa plus two
         single-cushion chairs. Price/quantity reflect the whole set. */
      if (s.vizStage === 5 && s.view === '3d') {
        var chairL = SOFA.CUSHION + SOFA.POST * 2;
        var sofa  = this._sofaUnitBoQ(s.L  || SOFA.L_DEFAULT, s);
        /* chairs are default-depth (basic chairs), not the stretched sofa */
        var chairState = {}; for (var k in s) { if (s.hasOwnProperty(k)) chairState[k] = s[k]; }
        chairState.W = SOFA.DEPTH;
        var chair = this._sofaUnitBoQ(chairL, chairState);
        var code = SOFA.RAIL_CODE;
        var meters = sofa.meters + 2 * chair.meters;
        var dowels = sofa.dowels + 2 * chair.dowels;
        var bm = {}; bm[code] = meters;
        /* slats (same profile across the set) */
        if (sofa.slatCode) {
          bm[sofa.slatCode] = (bm[sofa.slatCode] || 0) + sofa.slatMeters + 2 * chair.slatMeters;
        }
        if (sofa.ledgerCode) {
          bm[sofa.ledgerCode] = (bm[sofa.ledgerCode] || 0) + sofa.ledgerMeters + 2 * chair.ledgerMeters;
        }
        if (sofa.rostCode) {
          bm[sofa.rostCode] = (bm[sofa.rostCode] || 0) + sofa.rostMeters + 2 * chair.rostMeters;
        }
        /* Fasteners (whole set = sofa + 2 chairs). */
        var setDowels       = sofa.dowels       + 2 * chair.dowels;
        var setPocket       = sofa.pocketScrews + 2 * chair.pocketScrews;
        var setLedgerScrews = sofa.ledgerScrews + 2 * chair.ledgerScrews;
        var setSlatScrews   = sofa.slatScrews   + 2 * chair.slatScrews;
        if (setDowels)       bm.FAT00006 = (bm.FAT00006 || 0) + setDowels;        /* 12×76 dowel pins */
        if (setPocket)       bm.FAS50060 = (bm.FAS50060 || 0) + setPocket;        /* 5×60 #10 pocket-hole screws */
        var setFas50 = setLedgerScrews + setSlatScrews;
        if (setFas50)        bm.FAS50060 = (bm.FAS50060 || 0) + setFas50;         /* 5×60 ledger + slat screws */
        bm.FOU00016 = 1;   /* mattress — always 1 pc (user fits any size) */
        return {
          byMaterial: bm, kvh: meters, tst: 0, ror: 0,
          pocket_screws: setPocket, deck_screws: 0, lag_screws: 0, dowels: dowels,
          variant_kind: 'sofa-assembly'
        };
      }
      var u = this._sofaUnitBoQ(s.L || SOFA.L_DEFAULT, s);
      var c2 = SOFA.RAIL_CODE;
      var bm2 = {}; bm2[c2] = u.meters;
      if (u.slatCode) bm2[u.slatCode] = (bm2[u.slatCode] || 0) + u.slatMeters;
      if (u.ledgerCode) bm2[u.ledgerCode] = (bm2[u.ledgerCode] || 0) + u.ledgerMeters;
      if (u.rostCode) bm2[u.rostCode] = (bm2[u.rostCode] || 0) + u.rostMeters;
      /* Fasteners. */
      if (u.dowels)       bm2.FAT00006 = (bm2.FAT00006 || 0) + u.dowels;          /* 12×76 dowel pins */
      if (u.pocketScrews) bm2.FAS50060 = (bm2.FAS50060 || 0) + u.pocketScrews;    /* 5×60 #10 pocket-hole screws */
      var uFas50 = (u.ledgerScrews || 0) + (u.slatScrews || 0);
      if (uFas50)         bm2.FAS50060 = (bm2.FAS50060 || 0) + uFas50;            /* 5×60 ledger + slat screws */
      bm2.FOU00016 = 1;   /* mattress — always 1 pc; the user fits any size, so no dimension in BoQ */
      return {
        byMaterial: bm2, kvh: u.meters, tst: 0, ror: 0,
        pocket_screws: u.pocketScrews, deck_screws: 0, lag_screws: 0, dowels: u.dowels,
        variant_kind: 'sofa'
      };
    },

    /* Wave bench (variant 3) — 3 laminated ribs + spruce slats following
       the body-contour profile + 2 cross-connectors. Board metres for the
       ribs come from the glued-up plate area (area / board-width × layers ×
       ribs); slats from the contour arc length. All wood is 1" TIM20100
       except the 2×4 connectors (KVH10060). */
    _computeWaveBench: function (s) {
      s = s || STATE;
      var g = _waveLayout(s), L = g.L, ribN = g.ribN, i;

      /* v295 the panels: every board of both layers at its stock length
         (laid 20 mm over, cut to the outline after) -- drawn = billed */
      var wangeMeters = g.rb.stockM * ribN;

      /* Slats: the ones drawn (v257: the same list as the renderer). */
      var slatN = g.slats.length;
      var slatMeters = slatN * L;

      /* Cross-connectors: cut to fit between the ribs (v257). */
      var connMeters = g.conns.reduce(function (a, c) { return a + c.len; }, 0);

      var bm = {}, nF = { nail: 0, slat: 0, conn: 0 };
      for (i = 0; i < g.screws.length; i++) { bm[g.screws[i].code] = (bm[g.screws[i].code] || 0) + 1; nF[g.screws[i].kind]++; }   /* v295 FAS18032 nails, FAS50060 slat screws, FAS80100 connector screws -- as drawn */
      var slatScrews = nF.slat, structScrews = nF.conn;
      bm[WAVE.WANGE_CODE] = (bm[WAVE.WANGE_CODE] || 0) + wangeMeters + slatMeters; /* TIM20100 */
      bm[WAVE.CONNECT_CODE] = (bm[WAVE.CONNECT_CODE] || 0) + connMeters;           /* KVH10060 */
      /* v257: the exposed-wood coating -- both rib faces + their outline
         edge, every slat and connector face, m2 */
      bm[SWING.COAT_CODE] = (bm[SWING.COAT_CODE] || 0) +
        ribN * (2 * g.area + g.perim * g.wt) +
        slatMeters * 2 * (WAVE.SLAT_T + WAVE.SLAT_W) + connMeters * 2 * (WAVE.CONNECT_T + WAVE.CONNECT_W);
      /* v295 the lamination glue: ONE glue line a panel (2 layers) at ~0.2
         l/m2 (FEC00043 exterior wood glue) */
      var glueL = Math.round(g.area * ribN * CAT_NEW.GLUE_L_M2 * 100) / 100;
      bm[CAT_NEW.GLUE] = (bm[CAT_NEW.GLUE] || 0) + glueL;
      if (g.cushion) bm.FOU00016 = (bm.FOU00016 || 0) + 1;                       /* v263: the mattress, 1 pc */

      return {
        byMaterial: bm,                  /* full quantities drive price + BoQ drawer */
        missing: [],
        kvh: connMeters,                 /* headline "lumber" = 2×4 connectors */
        tst: slatMeters,                 /* headline "seat planks" = spruce slats only */
        ror: 0,
        pocket_screws: 0, deck_screws: slatScrews, lag_screws: structScrews,
        variant_kind: 'wave_bench'
      };
    },

    /* Hollywood swing (variant 4). Every quantity comes from _swingLayout,
       the same object the renderer draws. Cheeks: the outline area over
       the 200 member width, per cheek (KVH60200 metres); lumber in metres,
       covering in m2, hardware in pcs, chain and flashing in metres. The
       glue for the cheeks has no catalog row: listed in `missing`. */
    /* Picnic set (variant 5): every quantity from _picnicLayout. */
    _computePicnic: function (s) {
      s = s || STATE;
      var g = _picnicLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(g.P.boardCode, g.boardM);                     /* 2x6 (kids 2x4): top, seats, seat braces, legs */
      add(g.P.cleatCode, g.cleatM);                     /* 2x4: cleats + diagonal braces */
      add(PICNIC.BOLT_CODE, g.boltN);                   /* M10x130 with nut + washers */
      add(PICNIC.SCREW_CODE, g.screwN);                 /* 6x100 */
      add(SWING.COAT_CODE, g.coat);                     /* MFP00002 exposed wood coating, m2 (v255) */
      return {
        byMaterial: bm,
        kvh: g.cleatM + (g.boardM - g.seatM - g.tops.length * g.L),
        tst: g.seatM + g.tops.length * g.L,             /* headline "seat planks" = top + seat boards */
        ror: 0,
        pocket_screws: 0, deck_screws: g.screwN, lag_screws: g.boltN,
        variant_kind: 'picnic_set'
      };
    },

    /* Kids' swing set (type 13): the stand + the seats on chains. */
    _computeKids: function (s) {
      s = s || STATE;
      var g = _kidsLayout(s), P = g.P, F = g.frame, bm = {}, i, c, missing = [];
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      /* v299 the new A-frames: timber by code, the rods by length (a washer +
         cap nut at each end), the brace screws as drawn, the coating */
      for (c in F.meters) if (F.meters.hasOwnProperty(c)) add(c, F.meters[c]);   /* KVH60160 legs / collars / spreaders, KVH10200 beam, KVH10060 braces */
      var rodM = 0, nRod = 0;
      for (i = 0; i < F.fas.length; i++) { if (F.fas[i].rod) { rodM += F.fas[i].len; nRod++; } else add(F.fas[i].code, 1); }
      add(SWING.ROD_CODE, Math.round(rodM * 1000) / 1000);                 /* FAT16010 M16 rod, m */
      add(SWING.WASHER_CODE, 2 * nRod);                                    /* FAT16001 */
      add(SWING.CAPNUT_CODE, 2 * nRod);                                    /* FAT16002 */
      add(SWING.COAT_CODE, F.coat);                                        /* MFP00002 the frames */
      var deck = 0, lag = nRod;
      if (g.bench) {
        var r = _porchSeatBoQ(g.seat, add);                                /* the bench: timber, screws, bolts, eyes, hangers, chains, hinges, mattress, its coating */
        deck = r.deck; lag += r.bolts; missing = r.missing || [];
      } else {
        add(KIDS.SEAT_CODE, g.N * KIDS.SEAT_W);                            /* TIM45120 seat boards */
        add(SWING.HANGER_CODE, g.hangers.length);                          /* FAT00002 */
        add(SWING.HANGER_SCREW, g.hangers.length * 2);                     /* FAS60160 */
        add(SWING.EYE_CODE, g.eyeF.length + g.eyeR.length);                /* FAT00003 through the seats */
        var chainM = 0;
        for (i = 0; i < g.chains.length; i++) chainM += g.chains[i].len + PORCH.CHAIN_SPARE;
        add(SWING.CHAIN_CODE, chainM);                                     /* FAT00004 */
        add(SWING.COAT_CODE, g.N * KIDS.SEAT_W * 2 * (g.seatW + g.seatT)); /* MFP00002 the seats */
      }
      return {
        byMaterial: bm, kvh: (F.meters[KF.LEG] || 0) + (F.meters[KF.BEAM] || 0) + (F.meters[KF.BRACE] || 0), tst: g.bench ? (g.seat.plankM || 0) : g.N * KIDS.SEAT_W, ror: 0,
        pocket_screws: 0, deck_screws: deck, lag_screws: lag,
        missing: missing,
        variant_kind: g.bench ? 'kids_swing_bench' : 'kids_swing_set'
      };
    },

    /* Block bench (type 6): everything from _blockLayout. */
    /* v284 the 2x4 bench (type 15): everything from _gbLayout */
    /* v414 the twist bench (type 54): everything from _rtbLayout -- the rod
       by length, a washer + nut + cap nut at each end, the coating; the
       panel EGP04001 by the cutting plan (v419; the bearings gone) */
    _computeRotBench: function (s) {
      s = s || STATE;
      var g = _rtbLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(RTB.PANEL, g.panelM2);                                           /* v419 EGP04001 the panel, m2 of the cutting plan (v422 + the 2 end cheeks) */
      add(RTB.ROD, g.rodL);                                                /* FAT16010 the M16 rod, m */
      add(RTB.WASHER, g.nWasher);                                          /* FAT16001 v419 3 between every two slats (v422 + 3 at each cheek) + 1 at each end */
      add(RTB.NUT, 2);                                                     /* FAT16011 */
      add(RTB.CAPNUT, 2);                                                  /* FAT16002 */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 every face of every slat, m2 */
      return {
        byMaterial: bm, kvh: 0, tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: 0, lag_screws: 1,
        missing: [],
        variant_kind: 'twist_bench'
      };
    },
    _computeGlued: function (s) {
      s = s || STATE;
      var g = _gbLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(GB.CODE, g.meters);                                              /* KVH10060 the seat boards and the legs' layers, m */
      add(CAT_NEW.GLUE, g.glueL);                                          /* FEC00043 the layers glued face to face, l */
      add(GB.ARM_SCREW, g.screws.length);                                  /* v286 FAS50060 the armrest caps, 1 pocket screw a post */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 the faces left in view, m2 */
      return {
        byMaterial: bm, kvh: g.meters, tst: g.seatM, ror: 0,
        pocket_screws: g.screws.length, deck_screws: 0, lag_screws: 0,
        missing: [{ name: GB.BRAD, qty: g.brads.length, unit: 'pcs' }],
        variant_kind: 'glued_bench'
      };
    },
    /* v288 the sunbed (type 16): everything from _sbLayout */
    _computeSunbed: function (s) {
      s = s || STATE;
      var g = _sbLayout(s), bm = {}, c;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, g.meters[c]);   /* KVH60160 frame, KVH10060 middle, KVH03838 ledgers / stops / battens / props, TIM20100 slats, m */
      for (c in g.counts) if (g.counts.hasOwnProperty(c)) add(c, g.counts[c]);   /* FAS60160 corners + middle, FAS50060 ledgers + stops, FAS55050 slats, FAT10002 hinges + props */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 every face, m2 */
      var kv = 0; for (c in g.meters) if (g.meters.hasOwnProperty(c) && c.indexOf('KV') === 0) kv += g.meters[c];
      return {
        byMaterial: bm, kvh: kv, tst: g.slatM, ror: 0,
        pocket_screws: 0, deck_screws: (g.counts[SB.SLAT_SCREW] || 0), lag_screws: (g.counts[SB.BOLT] || 0),
        missing: [{ name: SB.LOCKNUT, qty: (g.counts[SB.BOLT] || 0), unit: 'pcs' }],   /* v289 the pivots' lock nuts */
        variant_kind: 'sunbed'
      };
    },
    _computeBlock: function (s) {
      s = s || STATE;
      var g = _blockLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(BLOCK.CODE, g.blocks.length);                                    /* WWB03003 concrete masonry units, pcs */
      add(BLOCK.TIMBER, g.timberM);                                        /* KVH10100 the 4x4s, m */
      add(BLOCK.GLUE, g.glue);                                             /* FEC00031 construction adhesive, cartridges */
      add(BLOCK.PRIMER, g.paint);                                          /* FEC00020 concrete primer (painted blocks), m2 */
      add(BLOCK.PAINT, g.paint);                                           /* MFP00006 masonry paint (painted blocks), m2 */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 the timbers */
      return {
        byMaterial: bm, kvh: g.timberM, tst: g.seatM, ror: 0,
        pocket_screws: 0, deck_screws: 0, lag_screws: 0,
        variant_kind: 'block_bench'
      };
    },

    /* Storage bench (type 12): everything from _storageLayout. */
    _computeStorage: function (s) {
      s = s || STATE;
      var g = _storageLayout(s), bm = {}, i, tim = 0, frame = 0;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i];
        add(pc.code, pc.len);                                              /* KVH03838 posts / cleats / battens, TIM20100 cladding / floor / lid, KVH10060 + KVH60120 the back */
        if (pc.code === STORE.CLAD) tim += pc.len; else frame += pc.len;
      }
      add(STORE.CLAD_SCREW, g.cladScrew);                                  /* FAS50060 */
      add(STORE.SCREW, g.screw);                                           /* FAS60100: the back */
      add(STORE.HINGE, g.nHinge);                                          /* ODD00005 door hinges for the lid */
      add(CAT_NEW.LID_STAY, 2);                                            /* FAT00023 soft-close lid stays, one each end (v258) */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 */
      return {
        byMaterial: bm, kvh: frame, tst: tim, ror: 0,
        pocket_screws: 0, deck_screws: g.cladScrew, lag_screws: 0,
        missing: [],
        variant_kind: 'storage_bench'
      };
    },

    /* Tree bench (type 11): everything from _treeLayout. */
    _computeTree: function (s) {
      s = s || STATE;
      var g = _treeLayout(s), P = g.P, bm = {}, i, seatM = 0, frameM = 0, coat = 0;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i];
        add(pc.code, pc.len);                                              /* KVH60120 seat + back boards (long point), KVH10060 joists / legs / aprons / posts */
        if (pc.code === TREE.BOARD) { seatM += pc.len; coat += pc.len * 2 * (P.bt + P.bw); }
        else { frameM += pc.len; coat += pc.len * 2 * (P.lt + P.lw); }
      }
      add(TREE.BOLT, g.nBolt);                                             /* FAT10002: legs + back posts to the joists, 2 each */
      add(TREE.SCREW, g.nScrew);                                           /* FAS60100: boards 2 per end, aprons 2 per end */
      add(SWING.COAT_CODE, coat);                                          /* MFP00002 */
      return {
        byMaterial: bm, kvh: frameM, tst: seatM, ror: 0,
        pocket_screws: 0, deck_screws: g.nScrew, lag_screws: g.nBolt,
        variant_kind: 'tree_bench'
      };
    },

    /* Planter bench (type 10): everything from _planterLayout. */
    _computePlanter: function (s) {
      s = s || STATE;
      var g = _planterLayout(s), bm = {}, i, tim = 0, frame = 0;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i];
        if (!pc.code || !(pc.len > 0)) continue;                           /* the liner (by area) and the soil */
        add(pc.code, pc.len);                                              /* KVH03838 posts + cleats, TIM20100 cladding / bottom / cap, KVH60120 seat + back, KVH10060 cleats */
        if (pc.code === PLANTER.CLAD) tim += pc.len; else frame += pc.len;
      }
      add(PLANTER.CLAD_SCREW, g.cladScrew);                                /* FAS50060: cladding, bottom slats, cap */
      add(PLANTER.SCREW, g.screw);                                         /* FAS60100: cleats, seat / back boards, middle support */
      add(PLANTER.FOIL, g.foilA);                                          /* PFN00001 dimpled foil on the inner walls, m2 */
      add(PLANTER.GEO, g.geoA);                                            /* PFG00001 geotextile over the bottom (+20 % lap), m2 */
      add(PLANTER.STAPLE, Math.ceil((g.foilA + g.geoA) * PLANTER.STAPLES_M2));   /* FAS63000 */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002, every timber face */
      add(CAT_NEW.SOIL, Math.round(g.soilV * 1000) / 1000);                /* SFF00004 potting soil, the two planters, m3 (v258) */
      return {
        byMaterial: bm, kvh: frame, tst: tim, ror: 0,
        pocket_screws: 0, deck_screws: g.cladScrew, lag_screws: 0,
        missing: [],
        variant_kind: 'planter_bench'
      };
    },

    /* Adirondack (type 9): everything from _adiLayout. */
    _computeAdi: function (s) {
      s = s || STATE;
      var g = _adiLayout(s), P = g.P, bm = {}, i;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      var sec = {}; sec[ADI.STR_CODE] = [P.st, P.sh]; sec[ADI.FRAME_CODE] = [P.ft, P.fh]; sec[ADI.SLAT_CODE] = [P.bt, P.bw]; sec[ADI.ARM_CODE] = [P.at, P.aw];
      var coat = 0, slatM = 0, frameM = 0;
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i];
        add(pc.code, pc.len);                                              /* KVH60120 stringers + legs, KVH10060 apron / supports / braces, TIM20100 slats, TIM45120 arms */
        var sc = sec[pc.code]; if (sc) coat += pc.len * 2 * (sc[0] + sc[1]);
        if (pc.code === ADI.SLAT_CODE) slatM += pc.len; else frameM += pc.len;
      }
      add(ADI.BOLT, g.nBolt);                                              /* FAT10002: outer legs to the stringers, 2 per joint */
      /* v260: the screws from the drawn list (the same rules as before) */
      var nk = {};
      for (i = 0; i < g.screws.length; i++) nk[g.screws[i].kind] = (nk[g.screws[i].kind] || 0) + 1;
      add(ADI.MID_SCREW, nk.mid || 0);                                     /* FAS80100: stringers to a middle leg */
      var slatScrews = (nk.seat || 0) + (nk.back || 0);                    /* 2 per slat end / 2 per support */
      add(ADI.SLAT_SCREW, slatScrews);                                     /* FAS50060 */
      add(ADI.SCREW, (nk.apron || 0) + (nk.lowsup || 0) + (nk.arm || 0));  /* FAS60100: apron, lower supports, arms to the upper support + legs, braces */
      add(SWING.COAT_CODE, coat);                                          /* MFP00002, every timber face */
      return {
        byMaterial: bm, kvh: frameM, tst: slatM, ror: 0,
        pocket_screws: 0, deck_screws: slatScrews, lag_screws: g.nBolt,
        variant_kind: 'adirondack'
      };
    },

    /* Porch swing, sofa style (type 7): everything from _porchSofaLayout.
       v269: the sofa's frame in 3x3 -- the members, the dowels and pocket
       screws of every corner joint, the ledgers with their screws, the
       loose platform boards (as _sofaFrame draws them) + the hanging. */
    _computePorchSofa: function (s, gIn) {   /* v301 gIn: the modern swing's seat */
      s = s || STATE;
      var g = gIn || _porchSofaLayout(s), bm = {}, i;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(PSOFA.CODE, g.frameM);                                           /* KVH08080: posts, rails, top ends */
      add(PSOFA.LEDGER_CODE, g.ledM);                                      /* KVH03838: the 2 ledgers */
      add(PSOFA.ROST_CODE, g.rostM);                                       /* TIM20100: the platform boards (loose, as the sofa's) */
      add(PSOFA.DOWEL, g.dowels);                                          /* FAT00006: 3 a corner joint */
      add(PSOFA.SCREW, g.pocketScrews + g.ledgerScrews);                   /* FAS50060: 2 pocket screws a joint + the ledger screws */
      add(SWING.EYE_CODE, g.eyeF.length + g.eyeR.length);                  /* FAT00003 */
      add(SWING.HANGER_CODE, g.hangers.length);                            /* FAT00002 */
      add((g.hangerScrew && g.hangerScrew.code) || SWING.HANGER_SCREW, g.hangers.length * 2);   /* FAS60160 (v301 the modern swing's 160 beam: FAS60100) */
      var chainM = 0;
      for (i = 0; i < g.chains.length; i++) chainM += g.chains[i].len + PORCH.CHAIN_SPARE;
      add(SWING.CHAIN_CODE, chainM);                                       /* FAT00004 */
      if (g.cushion) add('FOU00016', g.matN);                              /* the cushions (the sofa's mattress pieces) */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 */
      return {
        byMaterial: bm, kvh: g.frameM, tst: 0, ror: 0,
        pocket_screws: g.pocketScrews, deck_screws: g.ledgerScrews, lag_screws: 0, dowels: g.dowels,
        missing: g.pillowN ? [{ name: 'THROW PILLOW (decor, as the sofa)', qty: g.pillowN, unit: 'pcs' }] : [],
        variant_kind: 'porch_swing_sofa'
      };
    },

    /* v273 the bed (type 14): everything from _bedLayout, as _sofaFrame
       draws it -- the 4x4 members, the dowels and pocket screws of the
       corner joints, the ledgers with their screws, the slats screwed down,
       the mattress. */
    _computeBed: function (s) {
      s = s || STATE;
      var g = _bedLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      add(BED.CODE, g.frameM);                                             /* KVH10100: legs, rails, the headboard, the centre rail + leg */
      add(BED.LEDGER_CODE, g.ledM);                                        /* KVH03838: the 2 ledgers */
      add(BED.ROST_CODE, g.rostM);                                         /* TIM20100: the slats */
      add(BED.SLAT_CODE, g.slatM);                                         /* v275 KVH03838: the headboard's upright slats */
      add(BED.CROSS_CODE, g.plankM);                                       /* v275 TIM20100: the headboard's crossed boards (long point) */
      add(BED.DOWEL, g.dowels);                                            /* FAT00006: 3 a joint; v275 + 1 a headboard slat / board end */
      add(BED.SCREW, g.pocketScrews + g.ledgerScrews + g.slatScrews);      /* FAS50060: pocket screws, ledger screws, slat screws */
      add(BED.MATT_CODE, 1);                                               /* FOU00016: the mattress */
      add(SWING.COAT_CODE, g.coat);                                        /* MFP00002 */
      return {
        byMaterial: bm, kvh: g.frameM, tst: g.rostM, ror: 0,
        pocket_screws: g.pocketScrews, deck_screws: g.ledgerScrews + g.slatScrews, lag_screws: 0, dowels: g.dowels,
        missing: [],
        variant_kind: 'bed'
      };
    },

    /* Porch swing (type 7): everything from _porchLayout. */
    /* v278 the classic porch swing: every piece and drawn fastener of
       _porchClassicLayout, the hanging, the cushion, the coating */
    _computePorchClassic: function (s, gIn) {
      s = s || STATE;
      var g = gIn || _porchClassicLayout(s), bm = {}, i, c;   /* v296 gIn: the pergola swing's seat */
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, g.meters[c]);   /* KVH10060 frame, posts, stiles, back rails, armrests; TIM20100 seat planks, back slats, the fillets' board (v279) */
      add(CAT_NEW.GLUE, g.glueL);                                                /* FEC00043 the fillets glued in the grooves (v279) */
      for (i = 0; i < g.screws.length; i++) add(g.screws[i].code, 1);            /* FAS80100, FAS50060, FAS60100, FAS60160 -- as drawn */
      if (g.rod) {   /* v298 the pergola swing's 2x6 side frames: M16 rods, a washer + cap nut at each end */
        var rodM = 0;
        for (i = 0; i < g.bolts.length; i++) rodM += g.bolts[i].len;
        add(SWING.ROD_CODE, Math.round(rodM * 1000) / 1000);                      /* FAT16010 M16 rod, m */
        add(SWING.WASHER_CODE, 2 * g.bolts.length);                              /* FAT16001 */
        add(SWING.CAPNUT_CODE, 2 * g.bolts.length);                              /* FAT16002 */
      } else add(PCL.BOLT, g.bolts.length);                                      /* FAT10002: posts + stiles to the side rails */
      add(SWING.EYE_CODE, g.eyeF.length + g.eyeR.length);                        /* FAT00003 */
      add(SWING.HANGER_CODE, g.hangers.length);                                  /* FAT00002 */
      add((g.hangerScrew && g.hangerScrew.code) || SWING.HANGER_SCREW, g.hangers.length * 2);   /* FAS60160 into the porch beam (v296: FAS60100 into the pergola's rafter) */
      var chainM = 0;
      for (i = 0; i < g.chains.length; i++) chainM += g.chains[i].len + PORCH.CHAIN_SPARE;
      add(SWING.CHAIN_CODE, chainM);                                             /* FAT00004 */
      if (g.cushion) add('FOU00016', 1);                                         /* the seat cushion */
      add(SWING.COAT_CODE, g.coat);                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: g.meters[PCL.FRAME_CODE] || 0, tst: g.seatM || 0, ror: 0,   /* v279 the seat planks alone (TIM20100 also carries the back) */
        pocket_screws: 0, deck_screws: g.screws.length, lag_screws: g.bolts.length,
        missing: [{ name: PCL.BRAD, qty: g.brads.length, unit: 'pcs' }, { name: PCL.PILLOW, qty: g.pillows.n, unit: 'pcs' }],   /* v282 + the fillets' brads */
        variant_kind: 'porch_swing'
      };
    },
    /* v301 the modern swing (type 18): the frames from _mfLayout -- the
       timber, the drawn screws / nails, the U's, the ground screws or the
       footings, the shade cloth, the coating -- plus the sofa seat's own bill */
    _computeModernSwing: function (s) {
      s = s || STATE;
      var g = _mfLayout(s), sb = this._computePorchSofa(s, g.seat), bm = {}, i, c;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in sb.byMaterial) if (sb.byMaterial.hasOwnProperty(c)) add(c, sb.byMaterial[c]);
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, g.meters[c]);   /* KVH16160 posts, beams, blocks; KVH40060 the weave's slats */
      var rodM = 0, nRod = 0;
      for (i = 0; i < g.screws.length; i++) { if (g.screws[i].rod) { rodM += g.screws[i].len; nRod++; } else add(g.screws[i].code, 1); }   /* FAS80260, FAS38038, FAS45070 -- as drawn */
      if (nRod) {                                                                /* v308 the LED top's blocks on M16 rods */
        add(SWING.ROD_CODE, Math.round(rodM * 1000) / 1000);                     /* FAT16010, m */
        add(SWING.WASHER_CODE, 2 * nRod);                                        /* FAT16001 */
        add(SWING.CAPNUT_CODE, 2 * nRod);                                        /* FAT16002 */
      }
      var missing = (sb.missing || []).slice();
      if (g.ledM > 0) {
        add(MF.LED, g.ledM);                                                     /* EEC00006 the 24 V strips, m */
        add(MF.LED_PSU, g.psus.length);                                          /* EEC00007 a power supply each outer portal */
        missing.push({ name: 'LED ALUMINIUM PROFILE, RECESSED, OPAL DIFFUSER (with end caps + clips)', qty: g.ledM, unit: 'm' });   /* v308 no catalogue row yet */
      }
      if (g.found === 'concrete') {
        add(MF.UANCHOR, g.bases.length);                                         /* FCO00004 wet-set U anchors */
        add(MF.DIG, g.digM3);                                                    /* FEE00001 the footings' holes */
        add(MF.GRAVEL_CODE, g.gravelM3);                                         /* FCO00001 under them */
        add(MF.CONCRETE, g.concreteM3);                                          /* FCO00002 */
      } else {
        add(MF.GSCREW, g.gscrews.length);                                        /* FGR00004 ground screws */
        add(MF.UHEAD, g.bases.length);                                           /* FGR00002 their U heads */
      }
      add(MF.FABRIC, g.fabricM2);                                                /* TST00003 the woven strips (m2, with the tie-offs) */
      add(SWING.COAT_CODE, g.coat);                                              /* MFP00002 the frames' timber */
      return {
        byMaterial: bm, kvh: (g.meters[MF.POST] || 0) + (g.meters[MF.SLAT] || 0) + (sb.kvh || 0), tst: 0, ror: 0,
        pocket_screws: sb.pocket_screws, deck_screws: sb.deck_screws, lag_screws: g.screws.length, dowels: sb.dowels,
        missing: missing,
        variant_kind: 'modern_swing'
      };
    },
    /* v296 the pergola swing (type 17): the pergola from _pgLayout -- its
       timber, the drawn screws / nails / anchors, the bases, the ground
       works, the coating -- plus the classic seat's own bill */
    _computePergola: function (s) {
      s = s || STATE;
      var g = _pgLayout(s), sb = this._computePorchClassic(s, g.seat), bm = {}, i, c;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in sb.byMaterial) if (sb.byMaterial.hasOwnProperty(c)) add(c, sb.byMaterial[c]);
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, g.meters[c]);   /* KVH16160 posts, heads, beams, braces; KVH60160 rafters */
      for (i = 0; i < g.screws.length; i++) add(g.screws[i].code, 1);            /* FAS80260, FAS80200, FAS10075, FAS38038 -- as drawn */
      add(PG.BASE, g.bases.length);                                              /* FAT00017 */
      add(PG.DIG, g.digM3);                                                      /* FEE00001 the footings' holes */
      add(PG.GRAVEL_CODE, g.gravelM3);                                           /* FCO00001 under them */
      add(PG.CONCRETE, g.concreteM3);                                            /* FCO00002 */
      add(SWING.COAT_CODE, g.coat);                                              /* MFP00002 the pergola's timber */
      return {
        byMaterial: bm, kvh: (g.meters[PG.POST] || 0) + (g.meters[PG.RAFTER] || 0), tst: sb.tst, ror: 0,
        pocket_screws: 0, deck_screws: sb.deck_screws, lag_screws: sb.lag_screws + g.screws.length,
        missing: sb.missing,
        variant_kind: 'pergola_swing'
      };
    },
    /* v314 GARDEN STRUCTURE 2, the raised bed (type 20): everything from
       _rbLayout -- timber by code, every drawn screw, the geotextile (m2),
       the soil (m3), the vinyl off the roll (m), the hinges, the coating */
    _computeRaisedBed: function (s) {
      s = s || STATE;
      var g = _rbLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, Math.round(g.meters[c] * 100) / 100);   /* KVH60200 boards, KVH10100 posts, KVH60160 cap; the cold frame's KVH08080 (US KVH10100) posts / rafters / ridge, KVH03030 (US KVH03838) sashes, KVL20040 battens */
      for (i = 0; i < g.fas.length; i++) { add(g.fas[i].code, 1); nScr++; }                          /* FAS60100, FAS60160, FAS60120, FAS45070, FAS50040, FAS55050 (US) -- as drawn */
      add(RB.GEO, g.geoA);                                                                           /* PFG00001 geotextile, m2 */
      add(RB.SOIL, g.soilV);                                                                         /* SFF00004 potting soil, m3 */
      add(RB.VINYL, g.vinylM);                                                                       /* OEB00001 clear vinyl, m of the roll */
      add(RB.HINGE, g.hinges.length);                                                                /* ODD00005 */
      add(RB.STAY, g.stays.length);                                                                  /* FAT00023 lid supports (v315), their screws in the pack */
      add(RB.STAPLE_CODE, g.nStaple || 0);                                                           /* v345 FAS10000 the vinyl's staples, as drawn */
      add(SWING.COAT_CODE, Math.round(g.coat * 100) / 100);                                          /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[RB.BOARD] || 0) + (g.meters[RB.POST] || 0) + (g.meters[RB.CAP] || 0), tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: [],                                                                                   /* v345 the vinyl's staples billed (FAS10000) */
        variant_kind: 'garden_bed'
      };
    },
    /* v320 GARDEN STRUCTURE 3, the garden arbor (type 22): everything from
       _gaLayout -- timber by code, every drawn screw and nail, v321 a paver
       + its gravel and digging + a post base a post (their concrete screws
       on missing), the coating */
    /* v362 PLAYHOUSES 1, the cottage (type 26): everything from _phLayout --
       timber, boards, trims and decking by length, every drawn screw and
       nail, the blocks + their gravel and digging, the floor / roof OSB and
       the siding by area (+10 %) with their screws by rate, the underlay,
       shingles (+ the cap shingles) and their nails / staples, the drip
       edge, the hinges, knob and catch, the coating */
    _computePlayhouse: function (s) {
      s = s || STATE;
      var g = _phAnyLayout(s), bm = {}, i, c, nScr = 0;   /* v364 the A-frame its own */
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH60160 rims / joists / header / ridge, KVH10060 plates / studs / rafters / ties / gable studs / braces, KVH10160 beams, KVH10100 posts, TIM20100, FVW09619, FVW02660, TST00001 */
      var rodM = 0, nRod = 0;
      for (i = 0; i < g.fas.length; i++) {
        if (!g.fas[i].code) continue;
        if (g.fas[i].rod) { rodM += g.fas[i].len; nRod++; continue; }                               /* v363 the ladder posts' M16 rods: by the metre */
        add(g.fas[i].code, 1); nScr++;                                                                /* FAS60160, FAS60120, FAS60100, FAS80200, FAS60080, FAS55050, FAS18032, FAS50040 (v363 + FAS80260, FAS38038, FAS50060) -- as drawn */
      }
      if (nRod) { add(PH.ROD, Math.round(rodM * 1000) / 1000); add(PH.WASHER, 2 * nRod); add(PH.CAPNUT, 2 * nRod); }   /* FAT16010 m, FAT16001 + FAT16002 at both ends */
      add(PH.GSCREW, g.gscrews.length);                                                              /* v363 FGR00001 under the stilt house's posts */
      var nWet = g.uheads.filter(function (u) { return u.wet; }).length;
      add(PH.UHEAD, g.uheads.length - nWet);                                                         /* v363 FGR00002 their U heads */
      add(PH.UANCHOR, nWet);                                                                         /* v402 FCO00004 wet-set in the poured footings */
      if (g.pourQ && g.pourQ.n) {                                                                    /* v402 the poured footings (the gazebo's) */
        add(PH.CONCRETE, g.pourQ.concrete);                                                          /* FCO00002 m3 */
        add(PH.REBAR, g.pourQ.rebar);                                                                /* FCO00003 4 bars a footing, m */
        add(PH.GEOTEX, g.pourQ.geotex);                                                              /* FEC00003 under the gravel, m2 */
        add(PH.FORMWORK, 1);                                                                         /* FCO00007 one lump */
      }
      add(PH.BLOCK, g.blocks.length);                                                                /* FCO00012 */
      add(PH.GRAVEL_CODE, g.gravelM3);                                                               /* FCO00001 under them, m3 */
      add(PH.DIG, g.digM3);                                                                          /* FEE00001 their beds, m3 */
      add(PH.FLOOR, r2(g.floorA * PH.WASTE));                                                        /* OSB25002 +10 %, m2 */
      add(PH.ROOF, r2((g.roofA + (g.gussetA || 0)) * PH.WASTE));                                     /* OSB25001 +10 %, m2 (v367 + the barn's truss gussets) */
      add(PH.SHEATH_SCREW, Math.ceil((g.floorA + g.roofA) * PH.SHEATH_SCR_M2));                      /* FAS50060 15 a m2 */
      add(PH.SIDING, r2(g.sidingA * PH.WASTE));                                                      /* FCP00009 +10 %, m2 */
      add(PH.SIDING_SCREW, Math.ceil(g.sidingA * PH.SIDING_SCR_M2));                                 /* FAS55050 20 a m2 */
      if (g.roofCov !== 'epdm') {                                                                    /* v403 (the modern dog house's roof deck: the EPDM on the OSB, MISSING) */
      add(PH.UNDERLAY, r2(g.roofA * PH.WASTE));                                                      /* ROR00008 +10 %, m2 */
      add(PH.UL_STAPLE, Math.ceil(g.roofA * PH.UL_STAPLES_M2));                                      /* FAS63000 6 a m2 */
      }
      if (g.roofCov === 'epdm') add(PH.ROOF_NAIL, g.dripNails);                                      /* v403 FAS00318 the drip edge's (over the membrane's turn-down) */
      else if (g.roofCov === 'seam') {                                                                    /* v366 the modern house: the metal sheet as standing seam */
        add(MD.SEAM, r2(g.roofA * PH.WASTE));                                                        /* ROR12003 +10 %, m2 */
        add(MD.SEAM_CLIP, Math.ceil(g.roofA * PH.WASTE * MD.SEAM_CLIPS_M2));                         /* FAS60100 its clips' screws, 5 a m2 */
        add(PH.ROOF_NAIL, g.dripNails);                                                              /* FAS00318 the drip edge's */
      } else {
      add(PH.SHINGLE, r2(g.roofA * PH.WASTE + g.capA));                                              /* ROR00001 +10 % + the cap shingles, m2 */
      add(PH.ROOF_NAIL, Math.ceil(g.roofA * PH.SHINGLE_NAILS_M2) + g.capNails + g.dripNails);        /* FAS00318 */
      }
      add(PH.DRIP, r2(g.dripL));                                                                     /* ROM02401 eaves + rakes, m */
      add(PH.HINGE, g.hinges);                                                                       /* FAT00022 the door's 2 + 2 a shutter */
      add(PH.KNOB, (g.knobs != null) ? g.knobs : (g.doorBoards ? 1 : 0));                            /* ODD00016 (v365 the play fort has no door; v367 the barn's three leaves) */
      add(PH.CATCH, (g.catches != null) ? g.catches : (g.doorBoards ? 1 : 0));                       /* ODD00017 */
      if (g.swing) {                                                                                 /* v365 the play fort's swings (the kids' set's) */
        var sw = g.swing, chainM = 0;
        add(KIDS.SEAT_CODE, r2(sw.N * KIDS.SEAT_W));                                                 /* TIM45120 seat boards */
        add(SWING.HANGER_CODE, sw.hangers.length);                                                   /* FAT00002 */
        add(SWING.HANGER_SCREW, sw.hangers.length * 2);                                              /* FAS60160 their plates' screws */
        add(SWING.EYE_CODE, sw.eyeF.length + sw.eyeR.length);                                        /* FAT00003 through the seats */
        for (i = 0; i < sw.chains.length; i++) chainM += sw.chains[i].len + PORCH.CHAIN_SPARE;
        add(SWING.CHAIN_CODE, r2(chainM));                                                           /* FAT00004 */
        g.coat += sw.N * KIDS.SEAT_W * 2 * (sw.seatW + sw.seatT);                                    /* the seats' coating */
      }
      if (g.extra) for (c in g.extra) if (g.extra.hasOwnProperty(c)) add(c, g.extra[c]);           /* v375 the coop's: the nest boxes' OSB, the staples, the apron's trench */
      add(SWING.COAT_CODE, r2(g.coat));                                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[PH.STUD] || 0) + (g.meters[PH.JOIST] || 0), tst: 0, ror: 0,   /* tst 0: the info bar shows the lumber (the porch's decking is in the bill) */
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing.slice(),                                                                  /* v363 the slide (no catalogue row yet) */
        variant_kind: g.castle ? 'playhouse_castle' : g.dog ? (g.insul ? 'kennel_insulated' : _phIsKr(s) ? 'kennel_run' : _phIsDd(s) ? 'kennel_double' : _phIsDm(s) ? 'kennel_modern' : 'kennel_classic') : g.coop ? (g.tractor ? 'coop_tractor' : g.walkin ? 'coop_walkin' : g.lean ? 'coop_leanto' : g.cupola ? 'coop_cupola' : g.barnCoop ? 'coop_barn' : g.hoopCoop ? 'coop_hoop' : 'coop_backyard') : g.treefort ? 'playhouse_treefort' : g.stilt ? 'playhouse_stilt' : g.aframe ? 'playhouse_aframe' : g.fort ? 'playhouse_fort' : g.modern ? 'playhouse_modern' : g.barn ? 'playhouse_barn' : 'playhouse_cottage'
      };
    },
    /* v373 GREENHOUSES 1, the gable greenhouse (type 33): everything from
       _ghLayout -- timber, frames and boards by length, every drawn screw
       and nail, the ground screws + U heads, the gravel and its digging,
       the knee wall's siding by area (+10 %) with its screws by rate, the
       glazing's sealing screws by rate + the ridge cap's, the cap, the
       solid tape, the hinges, knob and catch, the coating; the sheet, the
       vented tape and the openers on missing (no catalogue row yet) */
    _computeGreenhouse: function (s) {
      s = s || STATE;
      var g = _ghLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH10160 base, KVH10060 plates / studs / girts / rafters / ties / blocks / purlins, KVH60160 ridge, KVH40060 door + vent frames, TIM20100 boards, FVW02660 corner boards */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS38038, FAS80200, FAS60120, FAS60100, FAS60080, FAS55050, FAS18032, FAS50040 -- as drawn */
      add(GH.GSCREW, g.gscrews.length);                                                              /* FGR00001 */
      add((g.found === 'pier') ? GH.FD_UANCHOR : GH.UHEAD, g.uheads.length);                         /* FGR00002 / v399 FCO00004 wet-set in the footings */
      add(GH.FD_BLOCK, g.fq.blockN);                                                                 /* v399 FCO00012 precast pads ('block') */
      add(GH.GRAVEL, g.fq.gravel);                                                                   /* FCO00001 under the pads / footings, m3 */
      add(GH.DIG, g.fq.dig);                                                                         /* FEE00001 the footings' holes, m3 */
      add(GH.FD_CONCRETE, g.fq.concrete);                                                            /* FCO00002 the footings ('pier'), m3 */
      add(GH.FD_REBAR, g.fq.rebar);                                                                  /* FCO00003 4 bars a footing, m */
      add(GH.FD_GEOTEX, g.fq.geotex);                                                                /* FEC00003 under their gravel, m2 */
      if (g.fq.pourN) add(GH.FD_FORMWORK, 1);                                                        /* FCO00007 the footings' formwork, one lump (as the gazebo's) */
      add(GH.DIG, g.digM3);                                                                          /* FEE00001 the floor dug, m3 */
      add(GH.GRAVEL, g.gravelM3);                                                                    /* FCO00001 -- filled with gravel, m3 */
      add(GH.SIDING, r2(g.sidingA * GH.WASTE));                                                      /* FCP00009 the knee wall +10 %, m2 */
      add(GH.SIDING_SCREW, Math.ceil(g.sidingA * GH.SIDING_SCR_M2));                                 /* FAS55050 20 a m2 */
      add(GH.GL_SCREW, Math.ceil(g.polyA * GH.GL_SCR_M2) + g.capScrews);                             /* FAS00225 8 a m2 of glazing + the ridge cap's (v378 the flashing's) */
      add(g.lean ? GH.FLASH : GH.CAP, r2(g.capL));                                                   /* ROR00009 the ridge cap / v378 ROR00013 the lean-to's endwall flashing, m */
      add(GH.BRACKET, g.brackets || 0);                                                              /* v378 FAT00005 the lean-to's brackets to the house */
      add(GH.HSTRAP, g.strapBuy || 0);                                                               /* v381 FAT00012 the hoop house's strap pieces, three a strap */
      add(GH.STAPLE, g.staples || 0);                                                                /* v381 FAS10000 its door's film */
      add(GH.TAPE, r2(g.tapeSolid));                                                                 /* FEC00033 the upper edges, m */
      add(GH.HINGE, g.hinges);                                                                       /* FAT00022 the door's 3 + 2 a vent */
      add(GH.KNOB, 1);                                                                               /* ODD00016 */
      add(GH.CATCH, 1);                                                                              /* ODD00017 */
      add(SWING.COAT_CODE, r2(g.coat));                                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[GH.STUD] || 0) + (g.meters[GH.BASE] || 0) + (g.meters[GH.RIDGE] || 0), tst: 0, ror: 0,   /* tst 0: the info bar shows the lumber */
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing.slice(),                                                                  /* the polycarbonate, the vented tape, the openers */
        variant_kind: g.oldwin ? 'greenhouse_oldwindow' : g.victorian ? 'greenhouse_victorian' : g.aframe ? 'greenhouse_aframe' : g.hoop ? 'greenhouse_hoop' : g.lean ? 'greenhouse_lean' : 'greenhouse_gable'
      };
    },
    /* v376 KITCHEN POD (type 35): everything from _kpLayout -- timber and
       boards by length, every drawn screw and nail, the ground screws + U
       heads, the hangers, hinges, knobs and catches as drawn, the sheets by
       area (+10 %) with their fixings by rate, the acacia top by the metre,
       the modules, grill, sink and tap, the coating; the gas struts on
       missing (no catalogue row yet) */
    _computeKitchenPod: function (s) {
      s = s || STATE;
      var g = _kpLayout(s), bm = {}, i, c, nScr = 0, W = KP.WASTE, us0 = (s.isMetric === false);
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH10160 base + header, KVH60160 joists + rafters, KVH10100 posts, KVH10060 walls + blocks + counter frame, KVH40060 band rails + flap frame, FVF00301 battens, KVR14024 deck + fascia + rakes, FVW02660 trims */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS38038, FAS80200, FAS55050, FAS60120, FAS60100, FAS60160, FAS60080, FAS45070, FAS18032, FAS50040 -- as drawn */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i];
        if (pc.code && !(pc.len > 0) && (pc.code === KP.HANGER || pc.code === KP.HINGE || pc.code === KP.KNOB || pc.code === KP.CATCH || pc.code === KP.SHELF_BR || KP_SVC_BOX[pc.kind])) add(pc.code, 1);   /* v405 + FAT00005 the shelf's brackets */   /* FAT00009, FAT00022, ODD00016, ODD00017 -- as drawn; v382 GAP00002, SMW00201, EEJ00001, EES00005, EEL00002, EEW00001, EEC00007 */
      }
      add(KP.GSCREW, g.gscrews.length);                                                              /* FGR00001 */
      add((g.found === 'pier') ? KP.FD_UANCHOR : KP.UHEAD, g.uheads.length);                         /* FGR00002 / v405 FCO00004 wet-set in the footings */
      add(KP.FD_BLOCK, g.fq.blockN);                                                                 /* v405 FCO00012 precast pads ('block') */
      add(KP.GRAVEL, g.fq.gravel);                                                                   /* FCO00001 under the pads / footings, m3 */
      add(KP.DIG, g.fq.dig);                                                                         /* FEE00001 their beds / holes, m3 */
      add(KP.FD_CONCRETE, g.fq.concrete);                                                            /* FCO00002 the footings ('pier'), m3 */
      add(KP.FD_REBAR, g.fq.rebar);                                                                  /* FCO00003 4 bars a footing, m */
      add(KP.FD_GEOTEX, g.fq.geotex);                                                                /* FEC00003 under their gravel, m2 */
      if (g.fq.pourN) add(KP.FD_FORMWORK, 1);                                                        /* FCO00007 the footings' formwork, one lump (as the gazebo's) */
      add(KP.WALL_OSB, r2(g.sheathA * W));                                                           /* OSB25001 +10 %, m2 */
      if (!g.pTape) add(KP.MEMB, r2(g.sheathA * W));                                                 /* INS00002 over it, m2 (v413 open-joint panels: a UV-stable black one, missing) */
      add(KP.ROOF_OSB, r2(g.roofA * W));                                                             /* OSB25002 +10 %, m2 */
      add(KP.SHEATH_SCREW, Math.ceil((g.sheathA + g.roofA) * KP.SHEATH_SCR_M2));                     /* FAS50060 15 a m2 */
      var seamR = (g.roofCov === 'seam');                                                             /* v405 the roof's covering on its disc */
      add(KP.STAPLE, Math.ceil((g.sheathA + (seamR ? g.roofA : 0)) * KP.STAPLES_M2));                /* FAS63000 the membrane's and the underlay's, 6 a m2 */
      if (seamR) {
      add(KP.UNDERLAY, r2(g.roofA * W));                                                             /* ROR00008 +10 %, m2 */
      add(KP.SEAM, r2(g.roofA * W));                                                                 /* ROR12003 +10 %, m2 */
      add(KP.CLIP_SCREW, Math.ceil(g.roofA * W * KP.SEAM_CLIPS_M2));                                 /* FAS60100 its clips' screws, 5 a m2 */
      }
      if (g.green) add(KP.RGRAVEL, g.green.gravelM3);                                                 /* v405 ROR00004 the green roof's gravel strip, m3 (the membrane, mat, substrate, sedum, stop: missing) */
      add(KP.DRIP, r2(g.dripL));                                                                     /* ROM02401 eave, front, rakes, m */
      add(KP.ROOF_NAIL, g.dripNails);                                                                /* FAS00318 */
      add(KP.CLAD, r2(g.cladA * W));                                                                 /* FVW01351 walls, band, flap +10 %, m2 */
      if (g.pclad && g.cladP > 0) { var PCb = KP_PCLAD[g.pclad]; add(PCb.code, r2(g.cladP * PCb.waste)); add(PCb.fix, Math.ceil(g.cladP * PCb.fixM2)); }   /* v413 the panel cladding (+10 % / the corrugated +15 % laps) and its fixings by the area */
      var stF = (g.frame === 'steel');                                                                /* v406 the counter's frame on its switch */
      add(KP.CLAD_SCREW, Math.ceil(g.cladA * KP.CLAD_SCR_M2) + (stF ? 0 : Math.ceil(g.panelA * KP.PANEL_SCR_M2)));   /* FAS55050 28 a m2 of cladding, 20 a m2 of the face */
      if (stF) add(KP.WING_SCREW, Math.ceil(g.panelA * KP.PANEL_SCR_M2));                             /* v406 FAS55038 the face on the steel, 20 a m2 */
      add(KP.MS_SCREW, (g.sJoints || 0) * KP.MS_JOINT_SCR);                                           /* v406 FAS48019 the steel joints' framing screws, 4 a joint (the drawn ones: as drawn) */
      add(KP.PANEL, r2(g.panelA * W));                                                               /* (v405 the acacia finish's) */
      add(KP.CBOARD, r2((g.cboardA + (g.shieldA || 0)) * W));                                        /* v405 FCB00013 the concrete finish's cement board (v406 + the heat shield behind the hot bays) +10 %, m2 */
      add(KP.CB_SCREW, Math.ceil(g.cboardA * KP.CB_SCR_M2) + Math.ceil((g.shieldA || 0) * KP.CB_SCR_M2));   /* FAT16012 20 a m2 */
      add(KP.STONE_ADH, us0 ? r2(g.stoneA * KP.STONE_ADH_M2 * W * 2.20462) : r2(g.stoneA * KP.STONE_ADH_M2 * W));   /* FEC00018 the veneer's adhesive, 6 kg a m2 (lb in US) */
      add(KP.CLAD, r2(g.wfaceA * W));                                                                /* FVW01351 the granite finish's wood face +10 %, m2 */
      add(stF ? KP.WING_SCREW : KP.CLAD_SCREW, Math.ceil(g.wfaceA * KP.CLAD_SCR_M2));                /* FAS55050 28 a m2 (v406 steel: FAS55038) */
      if (!g.fp && (g.fin === 'concrete' || g.fin === 'inox')) add(KP.WORKTOP, r2(g.topA * W));               /* FOU00027 the concrete worktop slab +10 %, m2 (v412 + the inox look's) */
      if (g.inoxA) { add(KP.INOX, r2(g.inoxA * W)); add(KP.INOX_GLUE, Math.ceil(g.inoxA * KP.INOX_GLUE_M2)); }   /* v412 FVS00101 the stainless face +10 %, m2; FEC00031 its adhesive */
      add(KP.STONE, r2(g.stoneA * W));                                                               /* v405 FCP00010 the natural stone veneer panels +10 %, m2 */
      add(KP.STRUT, g.struts.length);
      for (c in (g.fitQ || {})) if (g.fitQ.hasOwnProperty(c)) add(c, g.fitQ[c]);                      /* v407 the fitness's equipment: FMC00021 / 27 / 28 / 22 / 19 / 20 / 24 / 26 */                                                                /* v405 FAT00025 the flap's gas struts */                                                               /* FCP00009 the counter's face +10 %, m2 */
      if (!g.fp && g.fin === 'acacia') add(KP.TOP, r2(g.topL));                                                                       /* FOU00034 the acacia top, m */
      for (i = 0; i < g.mods.length; i++) add(g.mods[i].code, 1);                                    /* FOU00031, FOU00029, FOU00030, FOU00033, FOU00032 */
      for (i = 0; i < g.bays.length; i++) {                                                          /* v379 each bay's equipment */
        var bk = g.bays[i].kind;
        if (bk === 'grill') add(KP.GRILL, 1);                                                        /* FOU00017 */
        else if (bk === 'sink') { add(KP.SINK, 1); add(KP.TAP, 1); }                                 /* FOU00022 + FOU00025 */
        else if (bk === 'kamado') add(KP.KAMADO, 1);                                                 /* FOU00018 */
        else if (bk === 'burner') add(KP.BURNER, 1);                                                 /* FOU00021 */
        else if (bk === 'pizza') add(KP.PIZZA, 1);                                                   /* FOU00020 */
        else if (bk === 'fridge') add(KP.FRIDGE, 1);                                                 /* FOU00024 */
      }
      /* v382 the services: pipes and cable by the drawn length +10 % (the cable + 30 cm a box), their corners, hoses, fittings */
      var rl = {}, nBox = 0;
      for (i = 0; i < (g.runs || []).length; i++) {
        var rn = g.runs[i];
        rl[rn.kind] = (rl[rn.kind] || 0) + rn.len;
        if (rn.kind === 'gasline') add(KP.GASELBOW, rn.corners);                                     /* GAP00005 */
        else if (rn.kind === 'drain') add(KP.DBEND, 2 * rn.corners);                                 /* SMP00321 two 45 deg a turn */
        else if (rn.kind === 'gashose') add(KP.GASHOSE, 1);                                          /* GAP00006 the pigtail + one a gas appliance */
        else if (rn.kind === 'flexi') add(KP.FLEXI, 1);                                              /* SMN00202 */
      }
      for (i = 0; i < g.pieces.length; i++) if (KP_SVC_BOX[g.pieces[i].kind] && g.pieces[i].kind !== 'manifold' && g.pieces[i].kind !== 'dropear') nBox++;
      add(KP.GASLINE, r2((rl.gasline || 0) * W));                                                    /* GAP00004 m */
      add(KP.PEX, r2((rl.pex || 0) * W));                                                            /* SMR00121 m */
      add(KP.DRAIN, r2((rl.drain || 0) * W));                                                        /* SMR00321 m */
      if (rl.cable) add(KP.CABLE, r2((rl.cable + 0.30 * nBox) * W));                                 /* EEE00001 m */
      if (g.gas) { add(KP.BOTTLE, 1); add(KP.REGULATOR, 1); add(KP.GASVALVE, g.gas.lines.length); }   /* FOU00026, GAP00001, GAP00003 */
      add(KP.SIPHON, (g.sinkSvc || []).length);                                                      /* SMH00322 */
      if (g.led) add(KP.LED, r2(g.led.len));                                                         /* EEC00006 m */
      add(SWING.COAT_CODE, r2(g.coat));                                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[KP.STUD] || 0) + (g.meters[KP.JOIST] || 0) + (g.meters[KP.BASE] || 0), tst: 0, ror: 0,   /* tst 0: the info bar shows the lumber */
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing.slice(),                                                                  /* the gas struts */
        variant_kind: g.fp ? 'garden_pod_fitness' : 'kitchen_pod'
      };
    },
    _computeArbor: function (s) {
      s = s || STATE;
      var g = _gaLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, Math.round(g.meters[c] * 100) / 100);   /* KVH10100 posts, heads, braces (+ the wall plates), KVH10060 the slats, KVH60160 the rafters, KVH40060 laths (+ the battens, v333 + the trellis' uprights), KVH60200 the ridge, v331 KVH16040 the arches' blanks */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS38038, FAS80260, FAS60160, FAS65090, FAS80160, FAS80200 (US), FAS60080, FAS60100 -- as drawn */
      add(GA.TILE_CODE, g.tileN);                                                                    /* SFF00002 a paver under each post ('tile') */
      add(GA.BLOCK, g.blockN);                                                                       /* v322 FCO00012 a deck block under each post ('block') */
      add(GA.GRAVEL_CODE, g.gravelM3);                                                               /* FCO00001 under them, m3 */
      add(GA.DIG, g.digM3);                                                                          /* FEE00001 their beds, m3 */
      add(GA.GSCREW, g.gscrews.length);                                                              /* v322 FGR00001 the ground screws ('screw') */
      add((g.found === 'screw') ? GA.UHEAD : GA.BASE, g.bases.length);                               /* FFP01001 the post bases / v322 FGR00002 the U heads */
      add(SWING.COAT_CODE, Math.round(g.coat * 100) / 100);                                          /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[GA.POST] || 0) + (g.meters[GA.HEAD] || 0), tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing,                                                                          /* the bases' concrete screws: no catalogue row short enough */
        variant_kind: 'garden_arbor'
      };
    },
    /* v334 GARDEN STRUCTURE 5, the pergola (type 24): everything from
       _peLayout -- timber by code, every drawn screw and nail, the
       foundation (ground screws + U heads | precast footings + post bases
       + their concrete screws | poured footings + H anchors, their
       concrete, bars, gravel, geotextile, formwork, the beds), the covering
       by its area (boards + their nails, underlay + staples, standing seam
       + clips, the caps + sealing screws, the drip edge + nails), the
       coating */
    _computeGardenPergola: function (s) {
      s = s || STATE;
      var g = _peLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH16160 posts / beams / ties, KVH10100 braces, KVH60200 flat rafters + ridge, KVH60160 rafters + hips, KVH40060 the infill, KVH10060 its rails (v337) */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS38038, FAS10075, FAS80260, FAS80200 (US), FAS60160, FAS60100, FAS80160, FAS60120, FAS65090, FAS45070 -- as drawn */
      add(PE.GSCREW, g.gscrews.length);                                                              /* FGR00004 ('screw') */
      add((g.found === 'block') ? PE.PBASE : (g.found === 'pier') ? PE.HANCHOR : PE.UHEAD, g.bases.length);   /* FFP01601 / FFP01002 / FGR00002 */
      add(PE.FOOTING, g.fq.blockN);                                                                  /* FCO00009 ('block') */
      add(PE.GRAVEL_CODE, g.fq.gravel);                                                              /* FCO00001, m3 */
      add(PE.DIG, g.fq.dig);                                                                         /* FEE00001, m3 */
      add(PE.CONCRETE, g.fq.concrete);                                                               /* FCO00002 ('pier'), m3 */
      add(PE.REBAR, g.fq.rebar);                                                                     /* FCO00003, m */
      add(PE.GEOTEX, g.fq.geotex);                                                                   /* FEC00003, m2 */
      if (g.fq.pourN) add(PE.FORMWORK, 1);                                                           /* FCO00007, one lump */
      if (g.cov) {
        var ra = g.roofA, ru = ra * PE.WASTE, rbW = _peU(s, 'RB_W');
        add(PE.RBOARD, r2(ra));                                                                      /* KVR14619 T&G roof boards, m2 */
        add(PE.RB_NAIL, Math.ceil(ra * 2 / (Math.max(0.2, g.rafSp) * rbW) - 1e-9));                  /* FAS70000 2 at every rafter crossing */
        add(PE.UNDERLAY, r2(ru));                                                                    /* ROR00008 +10 % laps, m2 */
        add(PE.UL_STAPLE, Math.ceil(ru * PE.UL_STAPLES_M2));                                         /* FAS63000 */
        add(PE.SEAM, r2(ru));                                                                        /* ROR12003 standing seam +10 %, m2 */
        add(PE.SEAM_CLIP, Math.ceil(ru * PE.SEAM_CLIPS_M2));                                         /* FAS60100 its clips' screws, 5 a m2 */
        add(PE.CAP, r2(g.capL));                                                                     /* ROR00009 ridge / hip caps, m */
        add(PE.SEAM_SCREW, g.capScrews);                                                             /* FAS00225 their sealing screws */
        add(PE.DRIP, r2(g.dripL));                                                                   /* ROM02401 round the eaves / rakes, m */
        add(PE.ROOF_NAIL, g.dripFix);                                                                /* FAS00318 a nail every 30 cm */
      }
      add(SWING.COAT_CODE, r2(g.coat));                                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[PE.POST] || 0) + (g.meters[PE.BRACE_CODE] || 0), tst: 0, ror: g.cov ? r2(g.roofA) : 0,
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing,
        variant_kind: 'garden_pergola'
      };
    },
    /* v328 GARDEN STRUCTURE 4, the gazebo (type 23): everything from
       _gzLayout -- timber by code (the decking by the board), every drawn
       screw and nail, the ground screws + U heads, the joist hangers, the
       roof by its area: T&G boards + their nails, the underlay (+10 %) +
       staples, the shingles (+10 %) + roofing nails (and the drip edge's),
       the hip caps, the drip edge, the coating */
    _computeGazebo: function (s) {
      s = s || STATE;
      var g = _gzLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH10100 posts, KVH10160 plates + beam, KVH60160 rims / joists / hips / jacks, KVH16160 the hub, KVH10060 rails, KVH03838 balusters, TST00001 the decking */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS38038, FAS60100, FAS80160, FAS55050, FAS80260, FAS80200 (US), FAS60120, FAS50060 -- as drawn */
      add(GZ.GSCREW, g.gscrews.length);                                                              /* FGR00001 ('screw') */
      add((g.found === 'pier') ? GZ.UANCHOR : GZ.UHEAD, g.uheads.length);                            /* FGR00002 on the screws / v329 FCO00004 wet-set in the footings */
      add(GZ.BLOCK, g.fq.blockN);                                                                    /* v329 FCO00012 deck blocks ('block') */
      add(GZ.GRAVEL_CODE, g.fq.gravel);                                                              /* FCO00001 under the blocks / footings, m3 */
      add(GZ.DIG, g.fq.dig);                                                                         /* FEE00001 their beds, m3 */
      add(GZ.CONCRETE, g.fq.concrete);                                                               /* FCO00002 the footings ('pier'), m3 */
      add(GZ.REBAR, g.fq.rebar);                                                                     /* FCO00003 4 bars a footing, m */
      add(GZ.GEOTEX, g.fq.geotex);                                                                   /* FEC00003 under the gravel, m2 */
      if (g.fq.pourN) add(GZ.FORMWORK, 1);                                                           /* FCO00007 the footings' formwork, one lump (as the ADU's piers) */
      add(GZ.HANGER, g.hangers.length);                                                              /* FAT00009 */
      var ra = g.roofA, ru = ra * GZ.WASTE;
      add(GZ.RBOARD, r2(ra));                                                                        /* KVR14619 T&G roof boards, m2 */
      add(GZ.RB_NAIL, g.rbNails);                                                                    /* FAS70000 2 at every rafter crossing */
      add(GZ.UNDERLAY, r2(ru));                                                                      /* ROR00008 +10 % laps, m2 */
      add(GZ.UL_STAPLE, Math.ceil(ru * GZ.UL_STAPLES_M2));                                           /* FAS63000 */
      if (g.cov === 'seam') {
        add(GZ.SEAM, r2(ru));                                                                        /* v329 ROR12003 standing seam +10 %, m2 */
        add(GZ.SEAM_CLIP, Math.ceil(ru * GZ.SEAM_CLIPS_M2));                                         /* FAS60100 its clips' screws, 5 a m2 (the house line's COV_SEAM) */
        add(GZ.SEAM_SCREW, g.capScrews);                                                             /* FAS00225 the hip caps' sealing screws */
        add(GZ.ROOF_NAIL, g.dripFix);                                                                /* FAS00318 the drip edge's */
      } else {
        add(GZ.SHINGLE, r2(ru));                                                                     /* ROR00001 +10 %, m2 */
        add(GZ.ROOF_NAIL, Math.ceil(ru * GZ.SHINGLE_NAILS_M2) + g.dripFix + g.capNails);             /* FAS00318 20 a m2 + the drip edge's + v329 2 a cap shingle */
      }
      if (g.cov === 'seam') add(GZ.HIP_CAP, r2(g.capL));                                             /* ROR00009 the metal caps along the hips, m */
      else add(GZ.SHINGLE, g.capShA);                                                                /* v330 the shingle caps: pieces of the same shingle, m2 */
      add(GZ.DRIP, r2(g.eaveL));                                                                     /* ROM02401 along the eaves, m */
      add(SWING.COAT_CODE, r2(g.coat));                                                              /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[GZ.POST] || 0) + (g.meters[GZ.PLATE] || 0) + (g.meters[GZ.RIM] || 0), tst: 0, ror: r2(ra),   /* tst 0: the info bar's middle column shows the LUMBER (no seat planks) */
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing,
        variant_kind: 'garden_gazebo'
      };
    },
    /* v318 BENCHES & LOUNGE, the floating bed (type 21): everything from
       _fbLayout -- the spruce by length, every drawn screw + the wall
       anchors' plugs, the glue, the LED strip + supply, the electrics, the
       mattress, the coating; what has no catalogue row on missing */
    _computeFloatingBed: function (s) {
      s = s || STATE;
      var g = _fbLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, Math.round(g.meters[c] * 100) / 100);   /* KVH10100 the frame + legs, KVH40060 the laths */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS80180, FAS50040, FAS60120 (US FAS60100), FAS45070, FAS80260, FAS80160, FAS50060, FAS55050 -- as drawn */
      add(FB.PLUG, g.anchors);                                                                        /* FAS80060 a wall plug for each anchor */
      add(CAT_NEW.GLUE, g.glueL);                                                                     /* FEC00043 D3 glue on the panels' faces against the frame, l */
      add(FB.LED, g.ledM);                                                                            /* EEC00006 the strip, m */
      add(FB.PSU, 1);                                                                                 /* EEC00007 */
      add(FB.SOCKET, g.plates.length); add(FB.SWITCH, g.plates.length); add(FB.BOX, 2 * g.plates.length);   /* EES00001, EEL00001, EEJ00001 */
      add(FB.CABLE_CODE, g.cableM);                                                                   /* EEE00001, m */
      add(FB.MATT, 1);                                                                                /* FMA00002 */
      add(SWING.COAT_CODE, Math.round(g.coat * 100) / 100);                                           /* MFP00002 */
      return {
        byMaterial: bm, kvh: (g.meters[FB.FRAME] || 0), tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing,
        variant_kind: 'floating_bed'
      };
    },
    /* v355 GARDEN STRUCTURE, the bar (type 25): everything from _mbLayout --
       timber by code, every drawn screw / nail / anchor (the sole plates'
       concrete screws drawn, MISSING), the post bases, the slab (concrete,
       mesh sheets + spacers, gravel, geotextile, formwork, the dig), the
       sheets (+15 % laps), the sill seal, the boards, the cement board,
       the ply, the membrane, the adhesive (tiles + stone), the tiles, the
       grout, the LED strip + supply, the stools, the bulbs, the coating;
       the stone, the edge trim and the hedge panels have no catalogue row
       (missing) */
    _computeManCaveBar: function (s) {
      s = s || STATE;
      var g = _mbLayout(s), bm = {}, i, c, nScr = 0;
      function add(code, q) { if (code && q > 0) bm[code] = (bm[code] || 0) + q; }
      function r2(v) { return Math.round(v * 100) / 100; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, r2(g.meters[c]));   /* KVH10100 posts, KVH10200 beams (the gable's ties), KVH60160 purlins, KVH10060 the back wall's and the counter's frame, v357 KVH60200 the gable's rafters */
      for (i = 0; i < g.fas.length; i++) if (g.fas[i].code) { add(g.fas[i].code, 1); nScr++; }        /* FAS10075, FAS50040, FAS80260, FAS00225, FAS60100, FAS70000, FAT16012, FAS50060 -- as drawn */
      add(MB.PBASE, g.bases.length);                                       /* FAT00017 */
      add(MB.CONCRETE, g.concM3);                                          /* FFM00001 +5 %, m3 */
      add(MB.MESH, g.meshN);                                               /* PBF30001 3 x 2 m sheets, +15 % laps */
      add(MB.SPACER, g.spacerN);                                           /* FFM00004 2 a m2 */
      add(MB.GRAVEL_CODE, g.gravelM3);                                     /* FCO00001 15 cm, m3 */
      add(MB.GEOTEX, g.geoA);                                              /* FEC00003 under it and up its edges, m2 */
      add(MB.FORMWORK, 1);                                                 /* FFF00002 the slab's edge, one lump */
      add(MB.DIG, g.digM3);                                                /* FEE00001 m3 */
      add(MB.SHEET, r2(g.roofA * MB.WASTE_SH));                            /* ROR12004 +15 %, m2 */
      add(MB.SEAL, g.sealM);                                               /* INS01003 under every sole plate, m */
      add(MB.BOARD, r2(g.boardA * MB.WASTE));                              /* KVR14619 +10 %, m2 */
      add(MB.CB, r2((g.cbSideA + g.topA) * MB.WASTE));                     /* FCB00013 the counter's outer faces + its top, +10 %, m2 */
      add(MB.PLY, r2(g.topA * MB.WASTE));                                  /* FFW00003 +10 %, m2 */
      add(MB.MEMBRANE, r2(g.topA * MB.MEM_KG));                            /* FEC00025 1.5 kg a m2 */
      add(MB.ADHESIVE, r2(g.topA * MB.ADH_TILE + g.stoneA * MB.ADH_STONE)); /* FEC00018 4 kg a m2 of tiles, 6 of stone */
      add(MB.TILES, r2(g.topA * MB.WASTE));                                /* FFC00003 +10 %, m2 */
      add(MB.GROUT_CODE, r2(g.topA * MB.GROUT));                           /* SBG00001 0.5 kg a m2 */
      add(MB.LED, r2(g.ledM));                                             /* EEC00006 m */
      add(MB.STONE, r2(g.stoneA * MB.WASTE));                              /* v357 FCP00010 the stone veneer, +10 %, m2 */
      add(MB.TRIM, r2(g.trimL * MB.WASTE));                                /* v357 FFC00008 the top's edge trim, +10 %, m */
      add(MB.HEDGE, r2(g.hedgeA * MB.WASTE));                              /* v357 FEC00047 the hedge panels, +10 %, m2 (FAS75100 the plates' concrete screws: as drawn, above) */
      add(MB.RIDGE, r2(g.ridgeL * MB.WASTE));                              /* v357 ROR00009 the gable's ridge cap, +10 % laps, m (KVH60200 its rafters: in g.meters) */
      add(MB.PSU, 1);                                                      /* EEC00007 */
      add(MB.STOOL, g.stools.length);                                      /* FMC00013 */
      add(MB.LIGHTS, g.lightN);                                            /* EEC00008 */
      add(SWING.COAT_CODE, r2(g.coat));                                    /* MFP00002 */
      return {
        byMaterial: bm, kvh: r2((g.meters[MB.POST] || 0) + (g.meters[MB.BEAM] || 0) + (g.meters[MB.PURLIN] || 0) + (g.meters[MB.STUD] || 0) + (g.meters[MB.RAFTER] || 0)), tst: 0, ror: r2(g.roofA),   /* tst 0: the info bar's middle column shows the LUMBER */
        pocket_screws: 0, deck_screws: nScr, lag_screws: 0,
        missing: g.missing,
        variant_kind: 'mancave_bar'
      };
    },
    /* v303 GARDEN STRUCTURE 1, the cinema bar (type 19): everything from
       _gsLayout -- timber by code, the rods by length (a washer + cap nut
       at each end), every drawn screw and nail, the straps, hangers, DPC
       strips, the tiles and their gravel bed, the coating, the screen, the
       projector, the stools, the light strings (v305 the tiles in place of
       the cast footings; v309 the bar's rails, footrests and braces, the
       worktop slab in m2, the adhesive in cartridges) */
    _computeGarden: function (s) {
      s = s || STATE;
      var g = _gsLayout(s), bm = {}, i, c, nScr = 0, nRod = 0;
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      for (c in g.meters) if (g.meters.hasOwnProperty(c)) add(c, Math.round(g.meters[c] * 100) / 100);   /* KVH16160 sills, posts, kickers, struts, eave beams; KVH16240 the ridge; KVH60200 ties, the bar's rails + footrests; KVH60160 rafters, the ridge braces, the bar's braces */
      var rodM = 0;
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        if (f.rod) { rodM += f.len; nRod++; }
        else { add(f.code, 1); nScr++; }                                         /* FAS80200, FAS80260, FAS80320, FAS60100, FAS60080, FAS38038 -- as drawn */
      }
      add(GS.ROD, Math.round(rodM * 1000) / 1000);                               /* FAT16010 M16 rod, m */
      add(GS.WASHER, 2 * nRod);                                                  /* FAT16001 */
      add(GS.CAPNUT, 2 * nRod);                                                  /* FAT16002 */
      add(GS.STRAP, g.straps.length);                                            /* FAT00012 */
      /* v353 no slab FOU00027, no adhesive FEC00031: the top's 2x6 boards are in g.meters (KVH60160), their FAS60100 in g.fas */
      add(GS.DPC, g.dpc.length);                                                 /* FFM00007 */
      add(GS.TILE, g.tiles);                                                     /* SFF00002 500 x 500 */
      add(GS.DIG, g.digM3);                                                      /* FEE00001 -- v354 0: no excavation under the tiles */
      add(GS.GRAVEL_CODE, g.gravelM3);                                           /* FCO00001 */
      add(SWING.COAT_CODE, Math.round(g.coat * 100) / 100);                      /* MFP00002 */
      add(GS.SCREEN, 1);                                                         /* FMC00009 */
      add(GS.PROJECTOR, 1);                                                      /* FMC00008 */
      add(GS.PROJ_MOUNT_CODE, 1);                                                /* v345 FMC00043 its ceiling mount */
      add(GS.STOOL, g.stools.length);                                            /* FMC00013 */
      add(GS.LIGHTS, g.lightN);                                                  /* EEC00008 */
      return {
        byMaterial: bm, kvh: (g.meters[GS.POST] || 0) + (g.meters[GS.TIE] || 0) + (g.meters[GS.RAFTER] || 0), tst: 0, ror: 0,
        pocket_screws: 0, deck_screws: nScr, lag_screws: nRod,
        missing: g.missing || [],                                                /* v324 the projector's ceiling mount: no catalogue row */
        variant_kind: 'garden_bar'
      };
    },
    _computePorch: function (s) {
      s = s || STATE;
      if (_porchStyle(s) === 'classic') return this._computePorchClassic(s);   /* v278 */
      if (_porchStyle(s) === 'sofa') return this._computePorchSofa(s);
      var g = _porchLayout(s), bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }
      var r = _porchSeatBoQ(g, add);
      return {
        byMaterial: bm,
        kvh: g.frameM,
        tst: g.plankM,
        ror: 0,
        pocket_screws: 0, deck_screws: r.deck, lag_screws: r.bolts,
        missing: r.missing,
        variant_kind: 'porch_swing'
      };
    },

    _computeSwing: function (s) {
      s = s || STATE;
      var fr = ((s.variant | 0) === 8);                                   /* the A-frame swing: this stand + the porch seat */
      var g = fr ? _frameLayout(s) : _swingLayout(s);
      var P = g.P, i;
      var bm = {};
      function add(code, q) { if (q > 0) bm[code] = (bm[code] || 0) + q; }

      /* seat */
      var cheekMeters = 0, slatMeters = 0, seatR = null;
      if (fr) {
        seatR = _porchSeatBoQ(g.seat, add);                                /* timber, screws, bolts, eyes, hangers, chains, mattress, its coating */
      } else {
        /* v264: the laminated cheeks -- 4 layers of 1x4 segments a cheek (the
           outline's area over the board's width, + 25 % for the segments),
           the middle support 3 layers; the screws from the drawn list */
        cheekMeters = (2 * SWING.CHEEK_LAYERS * g.cheekArea + SWING.SUP_LAYERS * g.supArea) / P.boardW * SWING.CHEEK_WASTE;
        slatMeters  = g.slats.length * g.slatLen;
        add(SWING.CHEEK_CODE, cheekMeters);                                  /* TIM20100 */
        add(SWING.SLAT_CODE, slatMeters);                                    /* TIM45120 */
        var nSc = { lam: 0, slat: 0, mid: 0 };
        for (i = 0; i < g.seatScrews.length; i++) nSc[g.seatScrews[i].kind]++;
        add(SWING.SLAT_SCREW, nSc.slat + nSc.mid);                           /* FAS60100: the slats' ends, the middle support */
        add(SWING.LAM_SCREW, nSc.lam);                                       /* FAS50060: the core layers */
        if (g.cushion) add('FOU00016', 1);                                   /* mattress, 1 pc */
      }

      /* stand */
      var sb = _swingStandBoQ(g, add), legMeters = sb.legMeters, railMeters = sb.railMeters, braceMeters = sb.braceMeters, nX = sb.nX;

      /* hanging (the porch seat bills its own) */
      if (!fr) {
        var chainMeters = 0;
        for (i = 0; i < g.chains.length; i++) chainMeters += g.chains[i].len;
        add(SWING.HANGER_CODE, g.hangers.length);                            /* FAT00002 */
        add(SWING.HANGER_SCREW, g.hangers.length * 2);                       /* FAS60160 */
        add(SWING.EYE_CODE, g.eyes.length);                                  /* FAT00003 */
        add(SWING.CHAIN_CODE, chainMeters);                                  /* FAT00004 */
      }

      /* roof */
      var R = g.roof;
      if (R) {
        var nF = R.frameZ.length, nRaf = (R.type === 'gable') ? 2 : 1;
        add(SWING.RAFTER_CODE, R.rafterLen * nRaf * nF);                   /* KVH10080 */
        add(SWING.BRACKET_CODE, R.bracketLen * Math.max(0, nF - 2));       /* KVH16080: not at the end frames */
        add(SWING.ENDBR_CODE, SWING.ENDBR_LEN * R.endBr.length);           /* KVH16040 */
        add(SWING.LEG_SCREW, 2 * Math.max(0, nF - 2));                     /* FAS80180: brackets to the beam */
        add(SWING.BEAM_SCREW, Math.max(0, nF - 2));                        /* FAS80260: one through each bracket */
        add(SWING.STRUT_SCREW, 2 * R.endBr.length);                        /* FAS60120: struts to the legs */
        add(SWING.RAFTER_SCREW, 2 * nRaf * nF);                            /* FAS80100 */
        var boardsPerPlane = Math.ceil(R.planes[0].len / SWING.BOARD_GAUGE);
        var boardMeters = boardsPerPlane * R.planes.length * R.RL;
        var fasciaMeters = R.rakeM;
        add(SWING.BOARD_CODE, boardMeters + fasciaMeters);                 /* TIM20100 */
        add(SWING.BOARD_NAIL, boardsPerPlane * R.planes.length * nF * 2 + Math.ceil(fasciaMeters / 0.30));  /* FAS70000 */
        var ulA = R.deckA * SWING.UL_LAP + (R.ridge ? R.ridgeM * SWING.RIDGE_STRIP_W : 0);   /* + the ridge strip */
        add(SWING.UL_CODE, ulA);                                           /* ROR00008 */
        var capA = R.ridge ? R.ridgeM * 0.333 : 0;
        add(SWING.SHINGLE_CODE, (R.deckA + capA) * SWING.WASTE);           /* ROR00001 */
        add(SWING.SHINGLE_NAIL, Math.ceil(R.deckA * SWING.SHINGLE_NAIL_M2) + Math.ceil(ulA * SWING.UL_NAIL_M2) +
                                (R.ridge ? Math.ceil(R.ridgeM / SWING.SHINGLE_EXP) * 2 : 0));  /* FAS00318 */
        add(SWING.DRIP_CODE, R.eaveM);                                     /* ROD00050 */
        add(SWING.VERGE_CODE, R.rakeM);                                    /* ROD06030 */
        var flashM = R.eaveM + R.rakeM;
        add(SWING.EDGE_FIX, Math.ceil(flashM / SWING.EDGE_FIX_SP));        /* FAS55050 */
        add(SWING.SEALANT, Math.max(1, Math.ceil(flashM / SWING.SEALANT_PER_M)));  /* FEC00038 */
      }

      /* the coating: every timber face (m2), from the sections and lengths
         (cheeks: both faces + the edge band) */
      var coat = 0;
      function per(w, h) { return 2 * (w + h); }
      coat += (legMeters + railMeters) * per(P.leg, P.leg) + g.beamLen * per(P.beamW, P.beamH) + braceMeters * per(P.braceT, P.braceW);
      if (!fr) coat += 2 * (2 * g.cheekArea + g.cheekPerim * P.cheekT) + (g.midSup ? 2 * g.supArea : 0) + slatMeters * per(P.slatW, P.slatT);   /* the porch seat coated its own */
      if (R) {
        coat += R.rafterLen * nRaf * nF * per(P.rafD, P.rafW) + R.bracketLen * Math.max(0, nF - 2) * per(P.brD, P.brW) +
                SWING.ENDBR_LEN * R.endBr.length * per(P.ebD, P.ebW) + (boardMeters + fasciaMeters) * per(P.boardW, P.boardT);
      }
      add(SWING.COAT_CODE, coat);                                          /* MFP00002 */
      /* the cheeks glued up from the stacked 60x200 blanks: a glue line
         between neighbouring blanks (the shorter one's length x the cheek
         thickness), ~0.2 l/m2 -- FEC00043 (v258) */
      if (!fr) {   /* v264: 3 glue lines a cheek (the cover's too), 2 in the middle support */
        var glueA = 2 * (SWING.CHEEK_LAYERS - 1) * g.cheekArea + (SWING.SUP_LAYERS - 1) * g.supArea;
        add(CAT_NEW.GLUE, Math.round(glueA * CAT_NEW.GLUE_L_M2 * 100) / 100);
      }

      return {
        byMaterial: bm,
        kvh: legMeters + railMeters + braceMeters + g.beamLen + (fr ? g.seat.frameM : 0) + (R ? R.rafterLen * (R.type === 'gable' ? 2 : 1) * R.frameZ.length + R.bracketLen * R.frameZ.length : 0),
        tst: fr ? g.seat.plankM : slatMeters,
        ror: R ? R.deckA : 0,
        pocket_screws: 0,
        deck_screws: fr ? seatR.deck : g.slats.length * g.ribN * 2,
        lag_screws: nX * 2 + (fr ? seatR.bolts : 0),
        missing: fr ? seatR.missing : [],
        variant_kind: fr ? 'frame_swing' : 'hollywood_swing'
      };
    },

    /* Lumber metres + pocket screws for ONE sofa frame of length L. */
    _sofaUnitBoQ: function (L, s) {
      s = s || STATE;
      var P = SOFA.POST;
      var W = s.W || SOFA.DEPTH;
      var armTop = s.H || SOFA.ARM_TOP;
      var lvl2   = ((s.variant | 0) === 2) && (s.lvl === 2);
      /* STATE.H is the TOP rail height (both levels). Posts reach it. */
      var postH  = armTop - P;
      var innerW = W - P * 2;
      var innerL = L - P * 2;
      var posts    = 4 * postH;
      /* When the lvl-2 assembly is taller than 6 ft we add a FRONT top long
         rail (mirror of the back top rail) for rigidity. It is a full copy
         of the other long rails: +1 innerL of lumber and +2 corner joints. */
      var hasTopFront = lvl2 && (armTop > 1.8288);
      var armrests = (hasTopFront ? 2 : 1) * innerL;   /* back top rail (+ front top rail when tall) */
      var topEnds  = 2 * W;               /* 2 top end rails, full width (to outer legs) */
      /* Seat row (lvl 1 + the lower row): 2 long rails (innerL) + 2 end
         rails (innerW). The lvl-2 MIDDLE row omits the front long rail
         (backrest, open front): 1 long + 2 end. */
      var lowSides = innerL * (lvl2 ? 3 : 2);   /* lower 2 long + middle 1 long */
      var rowEnds  = innerW * (lvl2 ? 4 : 2);   /* 2 end rails per row */
      var meters = posts + armrests + topEnds + lowSides + rowEnds;
      /* Joints: back top (2) + 2 top ends (4) + lower row 4 rails (8) +
         middle row 3 rails (6 when lvl2) + front top rail (2 when tall). */
      var frameJoints = 2 + 4 + 8 + (lvl2 ? 6 : 0) + (hasTopFront ? 2 : 0);
      var joints = frameJoints;
      /* Dowel joinery: 3 wooden dowels per frame corner joint (FAT00006). */
      var dowels = frameJoints * SOFA.DOWEL_PER_JOINT;
      /* Pocket-hole screws: 2 per frame corner joint (FAS50060, 5×60 #10). */
      var pocketScrews = frameJoints * 2;

      /* Center support legs (long sofas, L > 2.8 m): 2 vertical 4×4 legs
         (front + back) from ground to the lower long-rail underside, each
         dowelled up with 3 dowels (no pocket holes). */
      if ((s.variant | 0) === 2 && L > 2.8) {
        var clH2 = Math.max(0.05, SOFA.SEAT_TOP - P);   /* ground → rail underside */
        meters += 2 * clH2;
        var centerJoints = 2;                            /* one per leg */
        joints += centerJoints;
        dowels += centerJoints * SOFA.DOWEL_PER_JOINT;   /* +6 dowels, no pocket screws */
      }

      /* Inner ledger battens (rošt support): 2 × innerL of 38×38, front +
         back. Always present on the sofa. */
      var ledgerCode = null, ledgerMeters = 0;
      var rostCode = null, rostMeters = 0;
      var ledgerScrews = 0;
      if ((s.variant | 0) === 2) {
        ledgerCode = SOFA.LEDGER_CODE;
        ledgerMeters = 2 * innerL;
        /* Ledger fixings (FAS50060): ~1 per 30 cm along each ledger, ×2. */
        var ledN0 = Math.max(2, Math.floor(innerL / 0.30) + 1);
        ledgerScrews = 2 * ledN0;
        joints += 6;   /* ~3 fixings per ledger into the rail */
        /* Rošt: 2×4 cross boards (span innerW), spread along Z with ~2 inch
           gaps. LOOSE-LAID → no fixings. */
        var rcc0  = SOFA.ROST_WIDTH + SOFA.ROST_GAP;
        var rSpan0 = Math.max(SOFA.ROST_WIDTH, innerL - SOFA.ROST_WIDTH);
        var rN0    = Math.max(2, Math.floor(rSpan0 / rcc0) + 1);
        rostCode = SOFA.ROST_CODE;
        rostMeters = rN0 * innerW;
      }

      /* Vertical slats (variant 2, when enabled). Their own profile code. */
      var slatCode = null, slatMeters = 0;
      var slatScrews = 0;
      if ((s.variant | 0) === 2 && (s.slats | 0) > 0) {
        var stt = SOFA.slatState(s.slats, SOFA.isTall(s));
        if (stt.bits && stt.profile) {
          slatCode = stt.profile;
          var smp = MATERIALS[stt.profile];
          var smw = smp ? smp.profile.w : 0.038;
          var sgap = (s.slatGap != null) ? s.slatGap : SOFA.GAP_DEF;
          if ((stt.bits & SOFA.SLAT_TOP) && (stt.bits & SOFA.SLAT_BACK)) {
            sgap = Math.max(sgap, smw);
          }
          var scc = smw + sgap;
          var sH  = Math.max(0.05, armTop - SOFA.SLAT_GROUND);
          var hasBackS = !!(stt.bits & SOFA.SLAT_BACK);
          var cntBack = (stt.bits & SOFA.SLAT_BACK)  ? Math.max(2, Math.floor((L - smw) / scc) + 1) : 0;
          var cntLeft = (stt.bits & SOFA.SLAT_LEFT)  ? Math.max(2, Math.floor((W - smw) / scc) + 1) : 0;
          var cntRight= (stt.bits & SOFA.SLAT_RIGHT) ? Math.max(2, Math.floor((W - smw) / scc) + 1) : 0;
          /* vertical slats (back/left/right): full height sH each */
          var vSlatCount = cntBack + cntLeft + cntRight;
          /* TOP slats: horizontal, span the depth (W, +sw when interlocking
             with back slats); count = gaps between back slats, else even. */
          var topLenS = W + (hasBackS ? smw : 0);
          var topCount = 0;
          if (stt.bits & SOFA.SLAT_TOP) {
            var tzN0 = Math.max(2, Math.floor((L - smw) / scc) + 1);
            topCount = hasBackS ? (tzN0 - 1) : tzN0;
          }
          var hasTopS = !!(stt.bits & SOFA.SLAT_TOP);
          /* back slats grow by one slat thickness when top slats interlock */
          var backH = sH + ((hasTopS && hasBackS) ? smw : 0);
          slatCode = stt.profile;
          slatMeters = cntBack * backH + (cntLeft + cntRight) * sH + topCount * topLenS;
          /* Screws: vertical slats cross 2 rails (3 when lvl2); top slats
             use 2 each (front + back top rail). */
          var slatRails = lvl2 ? 3 : 2;
          slatScrews = vSlatCount * slatRails + topCount * 2;
          joints += vSlatCount + topCount;
        }
      }

      return { meters: meters, screws: joints * 4, dowels: dowels,
               pocketScrews: pocketScrews, ledgerScrews: ledgerScrews,
               slatScrews: slatScrews,
               slatCode: slatCode, slatMeters: slatMeters,
               ledgerCode: ledgerCode, ledgerMeters: ledgerMeters,
               rostCode: rostCode, rostMeters: rostMeters };
    },

    /* Park Bench (variant 1) — lumber meters scale with seat length L,
       optionally without backrest when STATE.backrestVisible === false. */
    _computeParkBench: function (s) {
      /* Frame-only skeleton:
           4x  4x4 corner posts (full bench height)         → KVH10100
           2x  2x4 seat-level side rails (along W)          → KVH10060
           2x  2x4 backrest-level side rails (along W)      → KVH10060 (when backrest on) */
      var L = s.L;
      var W = s.W;
      var prof = _lumber(s);
      var post = prof.post;
      var t = prof.t;
      var w = prof.w;
      var hasBack = (s.backrestVisible !== false);

      var seatY = prof.seatTop - w / 2;    /* seat-top target: 0.45 adult / 0.30 kids */
      var backH = s.backH || 0.55;         /* user-draggable backrest height */
      var postH = seatY + backH - t / 2;

      var sideRailLenBottom = W - 2 * post;     /* between inner faces of posts */
      var sideRailLenTop    = W;                /* caps over posts, flush with outer faces */
      var longRailLenZ      = L - 2 * post;     /* long rails between INNER faces of posts */
      var joistLenX         = W - 2 * t;        /* cross-joists between inner faces of long rails */
      var joistZSpan        = L - 2 * t;        /* clear Z between inner faces of side rails */
      var nJoists           = Math.max(0, Math.round(joistZSpan / 0.40) - 1);

      /* Seat planks: edge planks shorter (L - 2*post), inner planks full L.
         Spacing is driven by the PLANK width (prof.plankW), matching the
         renderer — using the framing w here would miscount kids planks,
         whose board (100) is wider than the framing member (80). */
      var minGap            = 0.004;
      var plankWb           = prof.plankW;
      var nPlanks           = Math.max(2, Math.floor((W + minGap) / (plankWb + minGap)));
      var planksMeters      = 2 * (L - 2 * post) + Math.max(0, nPlanks - 2) * L;

      var kvh4x4Meters = 4 * postH;
      /* Framing (rails + joists + top rails). Seat planks are billed
         separately under prof.plankCode below — for adults plankCode
         equals frameCode so they merge back into one line; for kids the
         planks are the thin TIM20100 board and get their own line. */
      var framingMeters = 2 * sideRailLenBottom + 2 * longRailLenZ +
                         nJoists * joistLenX +
                         (hasBack ? 2 * sideRailLenTop : 0);
      var kvh2x4Meters = framingMeters + planksMeters;  /* total 2× material (back-compat for .kvh) */

      /* Pocket-hole screws (FAS50060):
           frame side rails ↔ posts (8) +
           frame long rails ↔ posts (8) +
           joists ↔ long rails (4 per joist) +
           armrest ↔ corner posts (8, ALWAYS — armrests are core) +
           backrest frame post ↔ rails (8 if hasBack) +
           backrest stretchers ↔ top + bottom rails (4 per stretcher, if hasBack). */
      var nPocketHole = 24 + nJoists * 4 + (hasBack ? (8 + nJoists * 4) : 0);

      /* Visible deck screws (FAS50060): 2 per plank crossing.
         Seat: 2 × nPlanks × (2 side rails + nJoists).
         Backrest: nBackPlanks × (4 corners + nJoists) attachments.
         Adults use 5 backrest planks, kids (lvl 2) use 4 (one
         profile lower) — must match the renderer's bfNumPlanks. */
      var nBackPlanks = (s.lvl === 2) ? 4 : 5;
      var nSeatScrews = 2 * nPlanks * (2 + nJoists);
      var nBackScrews = hasBack ? (nBackPlanks * (4 + nJoists) * 2) : 0;  /* 2 per crossing */
      var nDeckScrew  = nSeatScrews + nBackScrews;

      var nLagScrew = (hasBack ? (2 * (nJoists + 1) + (backH >= 0.2438 ? 4 : 2)) : 0);

      return {
        byMaterial: (function () {
          var bm = {};
          bm[prof.frameCode] = framingMeters;            /* rails + joists + top rails */
          /* Planks: own line for kids (TIM20100); for adults plankCode
             === frameCode, so accumulate onto the framing line. */
          bm[prof.plankCode] = (bm[prof.plankCode] || 0) + planksMeters;
          bm[prof.postCode]  = (bm[prof.postCode]  || 0) + kvh4x4Meters;   /* corner posts */
          bm.FAS50060 = nPocketHole + nDeckScrew;   /* 5×60 #10 — pocket-hole + visible deck screws */
          bm.FAS80100 = nLagScrew;             /* 8x100 lag bolts */
          return bm;
        })(),
        kvh: kvh2x4Meters + kvh4x4Meters,
        tst: planksMeters,            /* seat planks reported separately too */
        ror: 0,
        pocket_screws: nPocketHole,
        deck_screws: nDeckScrew,
        lag_screws: nLagScrew
      };
    }
  };

  /* ----------------------------------------------------------
     Debug logging helper (used throughout this lib).
     ---------------------------------------------------------- */
  function _dbg(msg) {
    if (global.Configurator && global.Configurator.log && global.Configurator.log.log) {
      global.Configurator.log.log('[bench] ' + msg);
    }
  }

  /* ----------------------------------------------------------
     ENGINE  (scene / camera / renderer / controls)
     ---------------------------------------------------------- */
  global.BenchEngine = {
    scene: null,
    camera: null,           /* perspective — used in 3D */
    orthoCamera: null,      /* orthographic — used in 2D top-down (no perspective distortion) */
    renderer: null,
    controls: null,         /* OrbitControls bound to perspective camera */
    orthoControls: null,    /* OrbitControls bound to ortho camera (rotate disabled) */
    benchGroup: null,
    _orthoHalfW: 2.5,       /* ortho frustum half-width in world units (≈ 5m wide view by default) */
    _syncingPan: false,     /* re-entrancy guard for the pan-sync handlers */

    init: function () {
      var T = global.THREE;
      var root = document.getElementById('cf-root');
      var canvas = document.getElementById('cf-canvas');
      if (!T || !root || !canvas) return false;

      this.scene = new T.Scene();
      /* No background colour: canvas is transparent so the page background
         (or map-manager mapbox layer) shows through. Page bg is #f5f5f5. */

      var W = root.clientWidth, H = root.clientHeight;
      var ratio = W / H;

      /* ── Perspective camera (3D mode) ───────────────────────────────── */
      this.camera = new T.PerspectiveCamera(40, ratio, 0.1, 100);
      this.camera.position.set(3.5, 2.2, 3.5);
      this.camera.lookAt(0, 0.9, 0);

      /* ── Orthographic camera (2D top-down mode) ──────────────────────
         Position high above the origin looking straight down (-Y). The
         actual frustum (left/right/top/bottom) is set by _applyOrthoZoom
         so it adapts to the canvas aspect on resize. */
      var hw = this._orthoHalfW;
      this.orthoCamera = new T.OrthographicCamera(-hw, hw, hw / ratio, -hw / ratio, 0.01, 200);
      this.orthoCamera.position.set(0, 50, 0);
      this.orthoCamera.lookAt(0, 0, 0);

      /* ── Elevation cameras (2D stage 2 — nárys + bokorys CAD drawings) ──
         Two more ortho cameras used ONLY when STATE.vizStage === 2 in 2D.
         The render loop draws each into one half of the canvas via
         setViewport. Position them far enough from the rack to clear any
         model size; the frustum is recomputed per-frame to fit STATE.L/W/H
         with a small margin so the drawings look like proper elevation
         views (filling each half).
           • orthoCameraFront — looks DOWN +Z (south → north), shows L × H
           • orthoCameraSide  — looks DOWN +X (east → west), shows W × H
         Both are children of `this` rather than the scene, so no orbit
         controls are attached — the views are static, fitted per frame. */
      this.orthoCameraFront = new T.OrthographicCamera(-1, 1, 1, -1, 0.01, 200);
      this.orthoCameraFront.position.set(0, 0, 50);
      this.orthoCameraFront.up.set(0, 1, 0);
      this.orthoCameraFront.lookAt(0, 0, 0);

      this.orthoCameraSide = new T.OrthographicCamera(-1, 1, 1, -1, 0.01, 200);
      this.orthoCameraSide.position.set(50, 0, 0);
      this.orthoCameraSide.up.set(0, 1, 0);
      this.orthoCameraSide.lookAt(0, 0, 0);

      /* preserveDrawingBuffer: true is REQUIRED so we can call
         canvas.toDataURL() for PDF export (and other snapshot use
         cases). Without it Three.js clears the WebGL backbuffer
         right after present, and toDataURL returns a transparent
         image — that's the bug Marek hit in the first PDF where
         the 3D / 2D pages came out empty.
         Small perf cost (browser can't recycle the backbuffer) but
         the rack scene is interaction-driven, not 60fps animated,
         so it's invisible in practice. */
      this.renderer = new T.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true,
        stencil: true,           /* required for section-cut cap stencil passes */
        preserveDrawingBuffer: true
      });
      this.renderer.setClearColor(0x000000, 0);  /* fully transparent */
      /* bench-v349: a lost WebGL context (the GPU out of memory, the GPU
         process restarted) leaves a white stage -- three stops its loop and
         takes the context back on restore; both written to the log */
      try {
        var selfR = this;
        canvas.addEventListener('webglcontextlost', function () {
          var mi = (selfR.renderer && selfR.renderer.info && selfR.renderer.info.memory) || {};
          _dbg('WebGL context LOST -- the 3D stage is white until it comes back (GPU geometries ' + mi.geometries + ', textures ' + mi.textures + ')');
        }, false);
        canvas.addEventListener('webglcontextrestored', function () {
          _dbg('WebGL context restored -- the model built again');
          try { global.BenchRenderer.build(); } catch (eB) { _dbg('rebuild after the restore THREW ' + ((eB && eB.message) || eB)); }
        }, false);
      } catch (eCL) {}
      this.renderer.localClippingEnabled = true;  /* needed for the section-cut viz stage */
      this.renderer.setSize(W, H, false);
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      this.renderer.toneMapping = T.ACESFilmicToneMapping;

      /* ── Perspective controls (3D) ─────────────────────────────────── */
      this.controls = new global.OrbitControls(this.camera, canvas);
      this.controls.target.set(0, 0.9, 0);
      this.controls.enableDamping = true;
      this.controls.dampingFactor = 0.08;
      this.controls.minDistance = 1.5;
      this.controls.maxDistance = 15;
      this.controls.maxPolarAngle = Math.PI * 0.49;
      this.controls.update();

      /* ── Ortho controls (2D) ───────────────────────────────────────────
         Mirrors the pool configurator's pattern: rotation disabled (we
         must stay top-down), LEFT mouse button DISABLED so it doesn't
         steal events from drag handles, MIDDLE = dolly (zoom),
         RIGHT = pan. Single touch is freed for handles too; pinch
         = dolly + pan. */
      this.orthoControls = new global.OrbitControls(this.orthoCamera, canvas);
      this.orthoControls.enableRotate = false;
      this.orthoControls.enableDamping = false;
      this.orthoControls.mouseButtons = { LEFT: null, MIDDLE: T.MOUSE.DOLLY, RIGHT: T.MOUSE.PAN };
      this.orthoControls.touches = { ONE: null, TWO: T.TOUCH.DOLLY_PAN };
      this.orthoControls.minZoom = 0.3;
      this.orthoControls.maxZoom = 6;
      this.orthoControls.enabled = false;

      /* ── Pan synchronisation ───────────────────────────────────────────
         When the user pans in one view, mirror the pan in the other so
         that switching 2D ↔ 3D keeps the same world point under the
         camera. Only the X/Z components are synchronised (Y differs —
         perspective camera looks at rack mid-height, ortho looks at
         ground). The _syncingPan guard prevents infinite ping-pong. */
      var self = this;
      this._lastOrthoT = { x: 0, z: 0 };
      this._lastPerspT = { x: this.controls.target.x, z: this.controls.target.z };

      function syncFromOrtho() {
        var tx = self.orthoControls.target.x;
        var tz = self.orthoControls.target.z;
        if (!self._syncingPan) {
          var dx = tx - self._lastOrthoT.x;
          var dz = tz - self._lastOrthoT.z;
          if (Math.abs(dx) > 1e-5 || Math.abs(dz) > 1e-5) {
            self._syncingPan = true;
            self.controls.target.x += dx;
            self.controls.target.z += dz;
            self.camera.position.x += dx;
            self.camera.position.z += dz;
            self._lastPerspT.x = self.controls.target.x;
            self._lastPerspT.z = self.controls.target.z;
            self._syncingPan = false;
          }
        }
        self._lastOrthoT.x = tx; self._lastOrthoT.z = tz;
      }
      function syncFromPersp() {
        var tx = self.controls.target.x;
        var tz = self.controls.target.z;
        if (!self._syncingPan) {
          var dx = tx - self._lastPerspT.x;
          var dz = tz - self._lastPerspT.z;
          if (Math.abs(dx) > 1e-5 || Math.abs(dz) > 1e-5) {
            self._syncingPan = true;
            self.orthoControls.target.x += dx;
            self.orthoControls.target.z += dz;
            self.orthoCamera.position.x += dx;
            self.orthoCamera.position.z += dz;
            self._lastOrthoT.x = self.orthoControls.target.x;
            self._lastOrthoT.z = self.orthoControls.target.z;
            self._syncingPan = false;
          }
        }
        self._lastPerspT.x = tx; self._lastPerspT.z = tz;
      }
      this.orthoControls.addEventListener('change', syncFromOrtho);
      this.controls.addEventListener('change', syncFromPersp);

      /* ── Lights ─────────────────────────────────────────────────────── */
      this.scene.add(new T.AmbientLight(0xffffff, 0.65));
      var sun = new T.DirectionalLight(0xffffff, 0.85);
      sun.position.set(3, 6, 4);
      this.scene.add(sun);
      var fill = new T.DirectionalLight(0xffffff, 0.25);
      fill.position.set(-3, 4, -2);
      this.scene.add(fill);

      this.benchGroup = new T.Group();
      this.scene.add(this.benchGroup);

      /* ── Animation loop ────────────────────────────────────────────────
         Renders with whichever camera is "active" per STATE.view +
         STATE.vizStage:
           • 3D any stage:  perspective camera, full canvas
           • 2D stage 1:    top-down ortho, full canvas (plan)
           • 2D stage 2:    split screen — front elevation (L × H) on the
                             left half, side elevation (W × H) on the right
                             half. Both cameras' frusta are re-fitted per
                             frame to STATE.L/W/H with a small margin so
                             the drawings always fill their half. */
      this.renderer.setAnimationLoop(function () {
        if (self._renderPathLogCount === undefined) self._renderPathLogCount = 0;
        if (self._renderPathLogCount < 5) {
          self._renderPathLogCount++;
          var L_ = global.Configurator && global.Configurator.log;
          if (L_) L_.log('[render-path] frame=' + self._renderPathLogCount +
                         ' view=' + STATE.view + ' stage=' + STATE.vizStage +
                         ' branch=' + (STATE.view === '2d'
                            ? (STATE.vizStage === 2 ? 'side-elevation' : 'plan')
                            : '3d'));
        }

        if (STATE.view === '2d') {
          /* Both stages use orthoCamera + orthoControls. Difference is
             camera position (set in applyVizStage): stage 1 top-down,
             stage 2 side view. Render path identical. */
          self.orthoControls.update();
          if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition();
          self.renderer.setClearColor(0x000000, 0);
          self.renderer.render(self.scene, self.orthoCamera);
        } else {
          self.controls.update();
          if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition();
          self.renderer.setClearColor(0x000000, 0);
          self.renderer.render(self.scene, self.camera);
        }
      });

      function onResize() {
        var w = root.clientWidth, h = root.clientHeight;
        self.renderer.setSize(w, h, false);
        self.camera.aspect = w / h;
        self.camera.updateProjectionMatrix();
        self._applyOrthoZoom();
      }
      window.addEventListener('resize', onResize);
      if (window.ResizeObserver) new ResizeObserver(onResize).observe(root);

      /* ── Stage 2 elevation zoom — wheel + pinch ─────────────────────
         OrbitControls only works on top-down orthoCamera (which is the
         renderer's plan camera, not elevation cameras). For stage 2 we
         add a custom zoom handler that adjusts `_elevZoomFactor`; the
         next _fitElevationCameras call picks up the new factor.
         Bounds: 0.5× (zoomed out) .. 3.0× (zoomed in). */
      self._elevZoomFactor = 1.0;
      function adjustElevZoom(delta) {
        if (STATE.view !== '2d' || STATE.vizStage !== 2) return;
        var z = self._elevZoomFactor * Math.exp(delta);
        if (z < 0.4) z = 0.4;
        if (z > 3.5) z = 3.5;
        self._elevZoomFactor = z;
      }
      canvas.addEventListener('wheel', function (e) {
        if (STATE.view !== '2d' || STATE.vizStage !== 2) return;
        e.preventDefault();
        adjustElevZoom(-e.deltaY * 0.001);
      }, { passive: false });

      var _pinchPrev = 0;
      canvas.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          var dx = e.touches[0].clientX - e.touches[1].clientX;
          var dy = e.touches[0].clientY - e.touches[1].clientY;
          _pinchPrev = Math.sqrt(dx*dx + dy*dy);
        }
      }, { passive: true });
      canvas.addEventListener('touchmove', function (e) {
        if (STATE.view !== '2d' || STATE.vizStage !== 2) return;
        if (e.touches.length !== 2) return;
        e.preventDefault();
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        var dist = Math.sqrt(dx*dx + dy*dy);
        if (_pinchPrev > 0) {
          var ratio = dist / _pinchPrev;
          adjustElevZoom(Math.log(ratio));
        }
        _pinchPrev = dist;
      }, { passive: false });

      return true;
    },

    /* Recompute ortho camera frustum from current canvas aspect.
       Called on resize and from init. _orthoHalfW controls the "zoom"
       level (smaller value = more zoomed in). */
    /* The plan / side frustum half-width: the fixed 2.5 m, widened for the
       Hollywood swing so its roof (up to ~4 m) and height fit the view in
       every 2D stage (plan: Z runs vertically; side: Z across, Y up). */
    _orthoHalfWFor: function (ratio) {
      var hw = this._orthoHalfW || 2.5;
      if ((STATE.variant | 0) === 20 || (STATE.variant | 0) === 22 || (STATE.variant | 0) === 23 || (STATE.variant | 0) === 24) {   /* v334 + the pergola; v328 + the gazebo; v314 the raised bed: up to 4.8 x 1.8 (a pyramid 3 x 3) m; v320 + the garden arbor (up to 4.8 x 2.4, 3.5 high) */
        var rbN2 = (STATE.vizStage === 1) ? Math.max(STATE.L / 2 * 1.15 * ratio, STATE.W / 2 * 1.2) : Math.max(STATE.L / 2 * 1.15, STATE.H / 2 * 1.25 * ratio);
        if (rbN2 > hw) hw = rbN2;
      }
      if (_isGhType(STATE.variant)) {   /* v373 the gable greenhouse: the roof's eaves and gables past the base */
        try {
          var ghO = _ghLayout(STATE), ghZ = ghO.extZ + 0.25, ghX = ghO.extX + 0.30;
          var ghN = (STATE.vizStage === 1) ? Math.max(ghZ * 1.1 * ratio, ghX * 1.2) : Math.max(ghZ * 1.1, ghO.height / 2 * 1.25 * ratio);
          if (ghN > hw) hw = ghN;
        } catch (eGh) {}
      }
      if (_isKpType(STATE.variant)) {   /* v376 the kitchen pod: the open flap far past the front, the roof past the back */
        try {
          var kpO = _kpLayout(STATE), kpZ = kpO.extZ + 0.25, kpX = Math.max(kpO.extX, kpO.extXb) + 0.30;
          var kpN = (STATE.vizStage === 1) ? Math.max(kpZ * 1.1 * ratio, kpX * 1.2) : Math.max(kpZ * 1.1, kpX * 0.9, kpO.height / 2 * 1.25 * ratio);
          if (kpN > hw) hw = kpN;
        } catch (eKp) {}
      }
      if (_isPhType(STATE.variant)) {   /* v365 + the play fort (its swings behind) */   /* v362 the cottage: the roof's reach -- the porch runs past +L/2 and the plan stays centred on the house; v363 the stilt house: + the ladder's foot, the slide */
        try {
          var phO = _phAnyLayout(STATE), phZ = Math.max(phO.L / 2, phO.zF, phO.extZ || 0) + 0.25, phX = Math.max(phO.W / 2, phO.extX || 0) + 0.30;
          var phN = (STATE.vizStage === 1) ? Math.max(phZ * 1.1 * ratio, phX * 1.2) : Math.max(phZ * 1.1, phO.height / 2 * 1.25 * ratio);
          if (phN > hw) hw = phN;
        } catch (ePh) {}
      }
      if ((STATE.variant | 0) === 19 || (STATE.variant | 0) === 25) {   /* v303 the cinema bar: up to 5.4 x 2.5 x 3.7 m; v355 + the bar (6.0 x 3.6 x 3.0) */
        var gsN = (STATE.vizStage === 1) ? Math.max(STATE.L / 2 * 1.15 * ratio, STATE.W / 2 * 1.2) : Math.max(STATE.L / 2 * 1.15, STATE.H / 2 * 1.25 * ratio);
        if (gsN > hw) hw = gsN;
      }
      if (_isStandType(STATE.variant)) {
        try {
          var sg = _standLayout(STATE), zl = (sg.roof ? sg.roof.RL : sg.beamLen) / 2 * 1.15;
          var need = (STATE.vizStage === 1) ? Math.max(zl * ratio, sg.depth / 2 * 1.15)
                   : (STATE.vizStage === 2) ? Math.max(zl, sg.height / 2 * 1.25 * ratio)
                   : Math.max(sg.depth / 2 * 1.2, sg.height / 2 * 1.25 * ratio);
          if (need > hw) hw = need;
        } catch (e) {}
      }
      return hw;
    },
    _applyOrthoZoom: function () {
      if (!this.orthoCamera) return;
      var root = document.getElementById('cf-root');
      if (!root) return;
      var W = root.clientWidth, H = root.clientHeight;
      var ratio = W / H;
      var hw = this._orthoHalfWFor(ratio);
      this.orthoCamera.left = -hw;
      this.orthoCamera.right = hw;
      this.orthoCamera.top = hw / ratio;
      this.orthoCamera.bottom = -hw / ratio;
      this.orthoCamera.updateProjectionMatrix();
    },

    /* Stage 2 — side elevation (bokorys) camera fit.
       Clone of _applyOrthoZoom but for orthoCameraSide which looks at the
       rack from +X axis (so we see W horizontally, H vertically).
       Uses same _orthoHalfW value as plan camera so visual scale matches.
       Camera centred at rack mid-height for nicer framing. */
    _fitSideElevationCamera: function () {
      if (!this.orthoCameraSide) return;
      var root = document.getElementById('cf-root');
      if (!root) return;
      var W = root.clientWidth, H = root.clientHeight;
      var ratio = W / H;
      var hw = this._orthoHalfWFor(ratio);
      var Hg = STATE.H;
      var cS = this.orthoCameraSide;
      cS.left   = -hw;
      cS.right  =  hw;
      cS.top    =  hw / ratio;
      cS.bottom = -hw / ratio;
      cS.position.set(50, Hg / 2, 0);
      cS.up.set(0, 1, 0);
      cS.lookAt(0, Hg / 2, 0);
      cS.updateMatrixWorld(true);
      cS.updateProjectionMatrix();
    },

    /* ─── _renderElevations ─────────────────────────────────────────────
       Renders 2D stage 2 (nárys + bokorys as a CAD-style drawing):
       split-screen with the front elevation on the LEFT half and the
       side elevation on the RIGHT half.

       Each elevation:
         • Frustum is fitted PER FRAME to STATE.L/W/H × MARGIN_FACTOR so
           the drawing always fills its half regardless of how the user
           resized the rack with drag handles.
         • Camera looks ORTHOGONALLY at the rack — front along +Z axis
           (so we see L horizontally, H vertically), side along +X axis
           (so we see W horizontally, H vertically).
         • Renderer's clear color is set to WHITE for elevations only;
           reset to transparent for stages that need the page bg.
         • Edge color (set on materials in applyVizStage) makes the
           drawing read like a CAD print: dark thin contours on white.

       Why per-frame fit instead of once on stage entry: the user can
       drag dimension handles WHILE in stage 2 (we keep handles visible
       per the design); on each frame we re-measure STATE and re-derive
       the frustum so the drawing scales smoothly to fit. */
    /* Configure orthoCameraFront and orthoCameraSide frusta + positions so
       both elevations fit their viewport half with UNIFORM SCALE.

       Fitting strategy: take the SMALLER scale (= rack fills the more-
       constrained axis exactly, may overshoot the other). This is the
       opposite of "object-fit: contain" — it's "object-fit: cover" without
       cropping. In practice for an upright rack (taller than wide) inside
       a tall viewport half, this means the rack fills the vertical extent
       with horizontal padding; for a wide rack inside the same viewport,
       it fills horizontally with vertical padding.

       Why this works better than "contain" (max scale): with contain, an
       upright rack inside a tall viewport ended up tiny because the
       frustum had to grow vertically to match the viewport aspect, leaving
       2/3 of the canvas empty around the rack. With cover-style fit the
       rack visually dominates the canvas (with light padding from MARGIN).

         scaleX = rack_W / halfW    meters/pixel needed for full width
         scaleY = rack_H / canvasH  meters/pixel needed for full height
         pickedScale = MIN(scaleX, scaleY)  ← the LOOSER axis wins
         frustumW = halfW × pickedScale     ← may be > rack width (padding)
         frustumH = canvasH × pickedScale   ← may be > rack height (padding)

       Called from animation loop BEFORE handle reposition (so projections
       use up-to-date frustum) and from _renderElevations. Idempotent. */
    _fitElevationCameras: function () {
      var T = global.THREE;
      if (!T) return;
      var canvas = this.renderer.domElement;
      var canvasW = canvas.width;
      var canvasH = canvas.height;
      var halfW = canvasW / 2;
      var L = STATE.L, Wd = STATE.W, Hg = STATE.H;

      /* Use a FIXED pixels-per-meter scale, modulated by user zoom.
         At base (zoom=1.0): 1 meter = ~200px in device space, so a 1.5m
         rack renders ~300px wide. With pixelRatio 1.75, that's ~170px
         CSS width. Reasonable rack size, with room for dim chips around.

         The user zoom factor lets them pinch/wheel to make rack bigger
         or smaller without changing world coordinates. Each elevation
         camera gets a frustum sized exactly to its viewport half so
         pixels-per-meter is uniform across both views. */
      var BASE_PX_PER_M = 200;
      var zoom = this._elevZoomFactor || 1.0;
      var pxPerM = BASE_PX_PER_M * zoom;

      /* Frustum width/height in METERS = pixels / pxPerM.
         Same for both elevations — uniform scale guarantees rack-front
         and rack-side appear at the same scale relative to each other. */
      var frustumW = halfW   / pxPerM;
      var frustumH = canvasH / pxPerM;

      var cF = this.orthoCameraFront;
      cF.left   = -frustumW / 2;
      cF.right  =  frustumW / 2;
      cF.top    =  frustumH / 2;
      cF.bottom = -frustumH / 2;
      cF.position.set(0, Hg / 2, 50);
      cF.up.set(0, 1, 0);
      cF.lookAt(0, Hg / 2, 0);
      cF.updateMatrixWorld(true);
      cF.updateProjectionMatrix();

      var cS = this.orthoCameraSide;
      cS.left   = -frustumW / 2;
      cS.right  =  frustumW / 2;
      cS.top    =  frustumH / 2;
      cS.bottom = -frustumH / 2;
      cS.position.set(50, Hg / 2, 0);
      cS.up.set(0, 1, 0);
      cS.lookAt(0, Hg / 2, 0);
      cS.updateMatrixWorld(true);
      cS.updateProjectionMatrix();

      this._lastFrontFW = frustumW;
      this._lastFrontFH = frustumH;
      this._lastSideSW  = frustumW;
      this._lastSideSH  = frustumH;
    },

    _renderElevations: function () {
      var T = global.THREE;
      if (!T) return;
      var canvas = this.renderer.domElement;
      var W = canvas.width;
      var H = canvas.height;
      var halfW = W / 2;

      /* Configure both elevation cameras for current canvas + STATE.
         (Idempotent — also called from animation loop before reposition.) */
      this._fitElevationCameras();
      var cF = this.orthoCameraFront;
      var cS = this.orthoCameraSide;

      /* One-shot diagnostic dump. */
      if (!this._elevDiagLogged) {
        this._elevDiagLogged = true;
        var L_ = global.Configurator && global.Configurator.log;
        if (L_) {
          var rect = canvas.getBoundingClientRect();
          L_.log('[elev-diag] canvas: device=' + W + 'x' + H +
                 ' css=' + Math.round(rect.width) + 'x' + Math.round(rect.height) +
                 ' pixelRatio=' + window.devicePixelRatio);
          L_.log('[elev-diag] STATE: L=' + STATE.L.toFixed(3) +
                 ' W=' + STATE.W.toFixed(3) +
                 ' H=' + STATE.H.toFixed(3) +
                 ' view=' + STATE.view + ' stage=' + STATE.vizStage);
          L_.log('[elev-diag] halfW(device)=' + halfW + ' aspect=' + (halfW / H).toFixed(3));
          L_.log('[elev-diag] FRONT frustum: L/R=±' + (this._lastFrontFW / 2).toFixed(2) +
                 ' T/B=±' + (this._lastFrontFH / 2).toFixed(2) +
                 ' pos=(0,' + (STATE.H / 2).toFixed(2) + ',50)');
          L_.log('[elev-diag] SIDE  frustum: L/R=±' + (this._lastSideSW / 2).toFixed(2) +
                 ' T/B=±' + (this._lastSideSH / 2).toFixed(2) +
                 ' pos=(50,' + (STATE.H / 2).toFixed(2) + ',0)');
        }
      }

      /* Two-pass render with scissor + viewport. Clear once white at the
         start, then render each elevation into its half. */
      this.renderer.setScissorTest(true);
      this.renderer.setClearColor(0xffffff, 1);

      /* Left half — front elevation */
      this.renderer.setViewport(0, 0, halfW, H);
      this.renderer.setScissor(0, 0, halfW, H);
      this.renderer.render(this.scene, cF);

      /* Right half — side elevation */
      this.renderer.setViewport(halfW, 0, halfW, H);
      this.renderer.setScissor(halfW, 0, halfW, H);
      this.renderer.render(this.scene, cS);

      /* Per-frame diagnostic (first 3 frames) — log viewport state
         right after each render to verify split-screen is happening. */
      if (!this._splitRenderLogCount) this._splitRenderLogCount = 0;
      if (this._splitRenderLogCount < 3) {
        this._splitRenderLogCount++;
        var DL = global.Configurator && global.Configurator.log;
        if (DL) {
          DL.log('[split-render] frame=' + this._splitRenderLogCount +
                 ' halfW=' + halfW + ' canvasH=' + H +
                 ' cF.pos=(' + cF.position.x.toFixed(0) + ',' + cF.position.y.toFixed(2) + ',' + cF.position.z.toFixed(0) +
                 ') cF.frust=(' + cF.left.toFixed(2) + ',' + cF.right.toFixed(2) + ',' + cF.top.toFixed(2) + ',' + cF.bottom.toFixed(2) +
                 ') cS.pos=(' + cS.position.x.toFixed(0) + ',' + cS.position.y.toFixed(2) + ',' + cS.position.z.toFixed(0) + ')');
        }
      }

      /* CRITICAL: restore the full-canvas viewport AND scissor so that
         when STATE.vizStage changes back to 1 (or view switches to 3D),
         the next render() call uses the entire canvas. */
      this.renderer.setScissorTest(false);
      this.renderer.setViewport(0, 0, W, H);
      this.renderer.setScissor(0, 0, W, H);
      this.renderer.setClearColor(0x000000, 0);
    },

    /* ─── VIEW + VIZ STAGE ──────────────────────────────────────────────
       Architecture:
         view      — '3d' or '2d'. Set via toggleView() or applyView().
         vizStage  — 1, 2 or 3 (3D only). Set via cycleVizStage() or applyVizStage().
         Switching view always resets vizStage to 1 in the new view.

       applyView()       — enables/disables the correct camera + controls
                           and updates the 2D/3D icon. Does NOT reset
                           camera position so user-zoom/pan persists
                           across toggles.
       applyVizStage()   — applies visual changes for current view+stage:
                           material opacities, background, mapbox visibility,
                           handle visibility, dimension overlay.
       toggleView()      — flips STATE.view, resets stage to 1, applies both.
       cycleVizStage()   — cycles vizStage within the current view.
    */
    applyView: function () {
      if (!this.camera || !this.controls || !this.orthoCamera || !this.orthoControls) return;
      /* Switch enabled state — animation loop reads STATE.view to pick
         which camera to render with, so flipping enabled here is enough.
         No camera position resets: persisted pan/zoom survive toggling. */
      if (STATE.view === '2d') {
        this.controls.enabled = false;
        this.orthoControls.enabled = true;
        this.orthoControls.update();
      } else {
        this.controls.enabled = true;
        this.orthoControls.enabled = false;
        this.controls.update();
      }

      /* Swap the 2D/3D toggle icon to reflect the TARGET state (clicking
         shows the view it would switch to). Uses the same Shopify-hosted
         PNGs as the pool configurator so visual style matches across
         configurators. */
      var iconEl = document.getElementById('cf-view-icon');
      if (iconEl) {
        if (STATE.view === '2d') {
          iconEl.src = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/3d.png?v=1772625064';
          iconEl.alt = '3D';
        } else {
          iconEl.src = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/2d.png?v=1772625064';
          iconEl.alt = '2D';
        }
      }
    },

    toggleView: function () {
      this._logCameraState('BEFORE toggleView (current view=' + STATE.view + ')');
      STATE.view = (STATE.view === '3d') ? '2d' : '3d';
      if (STATE.view === '2d') _benchCutOff('the plan');   /* v369 */
      STATE.vizStage = 1;                 /* reset stage on every view switch */
      /* Reset elevation diagnostic flags so re-entering stage 2 re-logs. */
      this._elevDiagLogged = false;
      this._elevFrustumLogged = false;
      this._renderPathLogCount = 0;
      this._splitRenderLogCount = 0;
      if (global.BenchHandles) {
        global.BenchHandles._diagLogged = false;
        global.BenchHandles._elevHandlesLogged = false;
      }
      if (global.BenchDimensions) global.BenchDimensions._dimDiagLogged = false;
      this.applyView();
      this.applyVizStage();
      this._logCameraState('AFTER  toggleView (new view=' + STATE.view + ')');
      if (global.BenchLib && global.BenchLib.savePref)   global.BenchLib.savePref();
      if (global.BenchLib && global.BenchLib.refreshUI)  global.BenchLib.refreshUI();
    },

    cycleVizStage: function () {
      /* 3D has 3 stages — stage 1 doubles as the asset-select mode
         (clickable, hover + outline), so users get the full-build view
         AND can inspect any piece at the same time. No separate
         "Select" stage; the raycaster is active whenever stage 1 is
         visible in 3D.
           • stage 1 = full build + asset picking (default)
           • stage 2 = inspection (everything 30 %, fasteners 100 %)
           • stage 3 = profiles (colour-coded by lumber profile)
           • stage 4 = section cut (vertical slice with solid caps)
         2D has 3 stages:
           • stage 1 = top-down plan (půdorys) with L/W handles + grid
           • stage 2 = side elevation (bokorys) with W/H handles
           • stage 3 = front elevation (nárys) with L/H handles
         Cycle wraps within current view. */
      this._logCameraState('BEFORE cycleVizStage (current=' + STATE.view + ':' + STATE.vizStage + ')');
      var isSofa = ((STATE.variant | 0) === 2);
      var maxStage = (STATE.view === '3d') ? (isSofa ? 5 : 3) : 3;   /* v369 the playhouses cut with the rail's section tool; v413 every type (the old stage-4 slice off the eye) */
      var prevStage = STATE.vizStage;
      STATE.vizStage = (STATE.vizStage >= maxStage) ? 1 : (STATE.vizStage + 1);
      if (STATE.view === '3d' && STATE.vizStage === 4) STATE.vizStage = isSofa ? 5 : 1;   /* v413 the sofa: 3 > its seating set */
      /* Stage 5 (sofa assembly) and leaving it both change which geometry
         is built, so a full rebuild is required — applyVizStage alone only
         tweaks materials on the existing meshes. */
      var crossesAssembly = (prevStage === 5 || STATE.vizStage === 5);
      if (crossesAssembly && global.BenchRenderer && global.BenchRenderer.build) {
        global.BenchRenderer.build();
      }
      /* Reset elev diag flags whenever we enter stage 2 from somewhere. */
      this._elevDiagLogged = false;
      this._elevFrustumLogged = false;
      this._renderPathLogCount = 0;
      this._splitRenderLogCount = 0;
      if (global.BenchHandles) {
        global.BenchHandles._diagLogged = false;
        global.BenchHandles._elevHandlesLogged = false;
      }
      if (global.BenchDimensions) global.BenchDimensions._dimDiagLogged = false;
      this.applyVizStage();
      this._logCameraState('AFTER  cycleVizStage (new=' + STATE.view + ':' + STATE.vizStage + ')');
      if (global.BenchLib && global.BenchLib.savePref)   global.BenchLib.savePref();
      if (global.BenchLib && global.BenchLib.refreshUI)  global.BenchLib.refreshUI();
    },

    /* Colour mode — independent of vizStage. Cycles the lumber tone
       between the natural wood default and a flat white (handy for a
       clean, print-like preview). Re-applies via applyVizStage so it
       cooperates with the stage logic. */
    cycleColorMode: function () {
      var CO = _colorOrder(), i = CO.indexOf(_colorScheme());   /* v412 the pods' order + shou sugi ban */
      STATE.colorMode = CO[(i + 1) % CO.length];
      this.applyVizStage();
      if (global.BenchLib && global.BenchLib.savePref) global.BenchLib.savePref();
      if (global.BenchLib && global.BenchLib._syncColorModeDisplay) global.BenchLib._syncColorModeDisplay();
    },

    /* Diagnostic helper: dumps key camera state so we can spot when
       something gets mutated across view/stage transitions. Logs:
         • perspective camera position + controls.target + distance + fov
         • top-down ortho camera position + zoom + frustum
       The previously seen "rack enlarged and shifted after returning from
       2D stage 2" symptom would show up here as a delta in controls.target
       or orthoCamera.position between BEFORE/AFTER snapshots. */
    _logCameraState: function (label) {
      var L = global.Configurator && global.Configurator.log;
      if (!L) return;
      var c  = this.camera, t = this.controls && this.controls.target;
      var oc = this.orthoCamera;
      if (c && t) {
        L.log('[cam-state] ' + label + ' persp pos=(' +
              c.position.x.toFixed(2) + ',' + c.position.y.toFixed(2) + ',' + c.position.z.toFixed(2) +
              ') target=(' + t.x.toFixed(2) + ',' + t.y.toFixed(2) + ',' + t.z.toFixed(2) +
              ') dist=' + this.controls.getDistance().toFixed(2) + ' fov=' + c.fov);
      }
      if (oc) {
        L.log('[cam-state] ' + label + ' ortho pos=(' +
              oc.position.x.toFixed(2) + ',' + oc.position.y.toFixed(2) + ',' + oc.position.z.toFixed(2) +
              ') frustum L/R=' + oc.left.toFixed(2) + '/' + oc.right.toFixed(2) +
              ' T/B=' + oc.top.toFixed(2) + '/' + oc.bottom.toFixed(2) +
              ' zoom=' + oc.zoom.toFixed(2));
      }
      /* Rack group state: position, scale, child count, mesh material status. */
      var rg = this.benchGroup;
      if (rg) {
        var meshCount = 0, edgeCount = 0;
        var minOp = 1, maxOp = 0, sampleColors = [];
        rg.traverse(function (n) {
          if (n.isMesh && n.material) {
            meshCount++;
            if (n.material.opacity < minOp) minOp = n.material.opacity;
            if (n.material.opacity > maxOp) maxOp = n.material.opacity;
            if (sampleColors.length < 3 && n.material.color) {
              sampleColors.push('#' + n.material.color.getHexString());
            }
          } else if (n.userData && n.userData.isEdgeLine) {
            edgeCount++;
          }
        });
        L.log('[rack-state] ' + label + ' group pos=(' +
              rg.position.x.toFixed(3) + ',' + rg.position.y.toFixed(3) + ',' + rg.position.z.toFixed(3) +
              ') scale=(' + rg.scale.x.toFixed(3) + ',' + rg.scale.y.toFixed(3) + ',' + rg.scale.z.toFixed(3) +
              ') children=' + rg.children.length);
        L.log('[rack-state] ' + label + ' meshes=' + meshCount + ' edges=' + edgeCount +
              ' opacity=[' + minOp.toFixed(2) + '..' + maxOp.toFixed(2) + '] colors=' + sampleColors.join(','));
      }
      /* Renderer state: viewport, scissor, clear color. */
      if (this.renderer) {
        var vp = new (global.THREE.Vector4)();
        this.renderer.getViewport(vp);
        var sc = new (global.THREE.Vector4)();
        this.renderer.getScissor(sc);
        var cc = this.renderer.getClearColor(new (global.THREE.Color)());
        L.log('[renderer-state] ' + label +
              ' viewport=(' + Math.round(vp.x) + ',' + Math.round(vp.y) + ',' + Math.round(vp.z) + ',' + Math.round(vp.w) +
              ') scissor=(' + Math.round(sc.x) + ',' + Math.round(sc.y) + ',' + Math.round(sc.z) + ',' + Math.round(sc.w) +
              ') scissorTest=' + this.renderer.getScissorTest() +
              ' clear=#' + cc.getHexString());
      }
    },

    /* applyVizStage —— pure visual application of STATE.view + STATE.vizStage.
       Walks the benchGroup once and sets per-part opacity based on a rule
       function, plus handles edge-line styling, renderer background,
       mapbox visibility, drag handles, and dimension overlay.

       Opacity rules:
         3D stage 1: everything 1.0, edges 0.55 (classic look)
         3D stage 2: structural 0.30, fasteners 1.0, edges 0.55 (inspection)
         2D stage 1: everything 1.0, edges 0.55 (top view, drag enabled)
         2D stage 2: everything 0.20, edges 1.0 black (drawing, no drag)

       Person is hidden in 2D always (per user request — person has its own
       toggle that we only honour in 3D). */
    applyVizStage: function () {
      var rg = this.benchGroup;
      if (!rg) return;

      var view = STATE.view, stage = STATE.vizStage;

      /* View class on cf-root for CSS targeting (e.g. smaller drag
         handles in 2D). */
      var root = document.getElementById('cf-root');
      if (root) {
        root.classList.toggle('cf-view-2d', view === '2d');
        root.classList.toggle('cf-view-3d', view === '3d');
      }

      /* Control state per stage:
           • 2D any stage → orthoControls enabled (pan/zoom)
           • 3D any stage → perspective controls (handled in applyView) */
      if (this.orthoControls) {
        this.orthoControls.enabled = (view === '2d');
      }

      /* Camera position per 2D stage. Same orthoCamera object, just
         repositioned — animation loop renders with it identically.
         CONVENTION (matches STATE: L along Z, W along X):
           stage 1 (plan/půdorys)   → (0, 50, 0)   lookAt (0, 0, 0)
                                       top-down, sees X×Z = W×L
           stage 2 (side/bokorys)   → (0, H/2, 50) lookAt (0, H/2, 0)
                                       camera at +Z looks -Z, sees X×Y = W×H
           stage 3 (front/nárys)    → (50, H/2, 0) lookAt (0, H/2, 0)
                                       camera at +X looks -X, sees Z×Y = L×H
         updateProjectionMatrix not needed (no frustum change), but
         orthoControls.target must move to lookAt point or pan/zoom
         feels weird. */
      if (view === '2d' && this.orthoCamera) {
        var Hg = STATE.H;
        this._applyOrthoZoom();   /* the frustum follows the model (swing: roof + height) */
        if (stage === 2) {
          /* Bokorys — camera at (50, H/2, 0) looks -X. Sees Z (length L)
             horizontally, Y (height H) vertically. Chip shows L + H. */
          this.orthoCamera.position.set(50, Hg / 2, 0);
          this.orthoCamera.up.set(0, 1, 0);
          this.orthoCamera.lookAt(0, Hg / 2, 0);
          if (this.orthoControls) this.orthoControls.target.set(0, Hg / 2, 0);
        } else if (stage === 3) {
          /* Nárys — camera at (0, H/2, 50) looks -Z. Sees X (width W)
             horizontally, Y (height H) vertically. Chip shows W + H. */
          this.orthoCamera.position.set(0, Hg / 2, 50);
          this.orthoCamera.up.set(0, 1, 0);
          this.orthoCamera.lookAt(0, Hg / 2, 0);
          if (this.orthoControls) this.orthoControls.target.set(0, Hg / 2, 0);
        } else {
          this.orthoCamera.position.set(0, 50, 0);
          this.orthoCamera.up.set(0, 0, -1);  /* +X right, -Z up in screen */
          this.orthoCamera.lookAt(0, 0, 0);
          if (this.orthoControls) this.orthoControls.target.set(0, 0, 0);
        }
        this.orthoCamera.updateMatrixWorld(true);
        if (this.orthoControls) this.orthoControls.update();
      }

      function isScrew(pt) { return pt && pt.indexOf('screw-') === 0; }

      /* ── Shared TIMBER-PROFILE colour scale ───────────────────────────
         Stage-3 "profile view" colours, keyed by the lumber profile CODE
         so every distinct cross-section reads as its own colour — and so
         the kids profiles (3×3 / 3×2) differ from the adult ones (4×4 /
         2×4). Keep this map identical across configurators (bench, rack,
         base, fence) so a given profile is always the same colour project
         to project. Add new codes here as new profiles are introduced. */
      var PROFILE_COLORS = {
        'KVH10100': 0x9c6b3f,  /* 4×4 (89×89) corner post   → deep walnut   */
        'KVH10060': 0x7a9968,  /* 2×4 (38×89) framing        → sage oak      */
        'KVH08080': 0xc28b3e,  /* 3×3 (64×64) kids post      → amber         */
        'KVH08060': 0x5f8aa6,  /* 3×2 (38×64) kids framing   → slate blue    */
        'TIM20100': 0xcaa46a,  /* 1×4 kids plank             → light board    */
        'TST00001': 0xa66042,  /* 1×6 decking                → terracotta    */
        'KVL20040': 0x6f8195,  /* 1×2 batten                 → weathered     */
        'ROR12004': 0xb0b4b8,  /* roof sheet                 → metal grey    */
        'KVH16160': 0x6e4a2b,  /* 6×6 (160×160) massive post → dark timber   */
        'KVH03838': 0xb08a5e,  /* 38×38 batten               → warm batten    */
        'KVH03030': 0xbe9568   /* 30×30 batten               → light batten    */
      };
      var PROFILE_FALLBACK = 0x8c8c8c;
      function _stage3ColorFor(code) {
        return (code && PROFILE_COLORS[code] != null) ? PROFILE_COLORS[code] : PROFILE_FALLBACK;
      }
      /* Default material colors — mirror values in _ensureMaterials.
         Reset to these whenever NOT in stage 3 so material colors are
         restored after leaving the profile view. */
      var DEFAULT_LUMBER  = COLOR_SCHEMES.birch.wood;   /* (unused since v236: the scheme sets it) */

      var partOpacityFor, edgeOpacity, edgeColor, bgColor, bgAlpha, kpFrameSt = false;
      var hidePart;   /* function(pt) → bool : part hidden by stage rule (rendered with opacity 0 so assembly visibility stays intact) */

      if (view === '3d' && stage === 1) {
        partOpacityFor = function () { return 1.0; };
        edgeOpacity = 0.55; edgeColor = 0x4a3320;
        bgColor = 0x000000; bgAlpha = 0;
      } else if (view === '3d' && stage === 2 && _isKpType(STATE.variant)) {
        /* v412 (Marek 23:46 "prvni stage view nechat jen ramovou konstrukci vcetne spojovaciho materialu (i ram dveri, ktere porad reaguji
           na posuvnik)") the garden pods: the frame only, solid -- the timber / steel frame, the foundation, the flap's frame (on its
           slider), its hinges and struts, every screw and nail of the frame; the skins, roof, counter, services and equipment hidden */
        partOpacityFor = function () { return 1.0; };
        edgeOpacity = 0.55; edgeColor = 0x4a3320;
        bgColor = 0x000000; bgAlpha = 0;
        hidePart = function (pt) { return !_kpFrameKeep(pt); };
        kpFrameSt = true;
      } else if (view === '3d' && stage === 2) {
        /* Inspection — whole body semi-transparent, fasteners stay solid
           so the screw layout is readable through the timber. (No rack
           STRUCTURAL whitelist here — that map listed rack-only part
           types and left every bench part at 1.0, so nothing dimmed.) */
        partOpacityFor = function (pt) {
          return isScrew(pt) ? 1.0 : 0.30;
        };
        edgeOpacity = 0.55; edgeColor = 0x4a3320;
        bgColor = 0x000000; bgAlpha = 0;
      } else if (view === '3d' && stage === 3) {
        /* Profile view — lumber shown and colour-coded by profile size;
           only fasteners are hidden (bench has no roof / logs). */
        partOpacityFor = function () { return 1.0; };
        edgeOpacity = 0.45; edgeColor = 0x222222;
        bgColor = 0x000000; bgAlpha = 0;
        hidePart = function (pt) {
          return isScrew(pt);
        };
      } else if (view === '2d' && stage === 2) {
        /* 2D stage 2 — SIDE ELEVATION (bokorys). Dimmed body fills +
           stronger edges to emphasize the outline. Body opacity comes
           from STATE.opacity2D (slider-controlled, 0..0.80). */
        var op2 = STATE.opacity2D;
        partOpacityFor = function (pt) {
          if (pt === 'roof') return op2 * 0.45;
          return op2;
        };
        edgeOpacity = 0.85; edgeColor = 0x2a1f12;
        bgColor = 0x000000; bgAlpha = 0;
      } else if (view === '2d' && stage === 3) {
        /* 2D stage 3 — FRONT ELEVATION (nárys). Same dimmed look as
           stage 2. Body opacity slider-controlled. */
        var op3 = STATE.opacity2D;
        partOpacityFor = function (pt) {
          if (pt === 'roof') return op3 * 0.45;
          return op3;
        };
        edgeOpacity = 0.85; edgeColor = 0x2a1f12;
        bgColor = 0x000000; bgAlpha = 0;
      } else if (view === '2d') {
        /* 2D stage 1 — orthographic top-down plan with L/W drag
           handles. Body opacity slider-controlled. */
        var op1 = STATE.opacity2D;
        partOpacityFor = function (pt) {
          if (pt === 'roof') return op1 * 0.45;
          return op1;
        };
        edgeOpacity = 0.85; edgeColor = 0x2a1f12;
        bgColor = 0x000000; bgAlpha = 0;
      } else {
        /* Defensive fallback — unknown view/stage combo → 3D stage 1 look. */
        partOpacityFor = function () { return 1.0; };
        edgeOpacity = 0.55; edgeColor = 0x4a3320;
        bgColor = 0x000000; bgAlpha = 0;
      }

      /* Reset the shared lumber material to its default tone. Stage-3
         profile colours are applied PER-PART in the walk loop below
         (the lumber material instance is shared across parts, so a single
         setHex can't show two profile colours at once — each stage-3 mesh
         gets a cloned, recoloured material instead). */
      var mats = global.BenchRenderer && global.BenchRenderer.materials;
      var inStage3 = (view === '3d' && stage === 3);
      var scheme = COLOR_SCHEMES[_colorScheme()], whiteMode = (_colorScheme() === 'white');
      if (mats && mats.lumber) {
        mats.lumber.color.setHex(scheme.wood);
        /* MeshStandardMaterial darkens with lighting, so a plain white
           reads as grey. Lift it with an emissive white in white mode so
           the surfaces stay genuinely white; clear emissive otherwise. */
        if (mats.lumber.emissive) {
          mats.lumber.emissive.setHex(scheme.glow ? scheme.wood : 0x000000);
          mats.lumber.emissiveIntensity = scheme.glow || 0;
        }
        mats.lumber.needsUpdate = true;
      }
      /* the swing roof: shingle shades and the deck boards per scheme */
      if (mats && mats.shingleA && mats.shingleB) {
        mats.shingleA.color.setHex(scheme.shingleA); mats.shingleB.color.setHex(scheme.shingleB);
        mats.shingleA.needsUpdate = true; mats.shingleB.needsUpdate = true;
      }
      if (mats && mats.osb) { mats.osb.color.setHex(scheme.deck); mats.osb.needsUpdate = true; }
      if (mats && mats.kpClad) {   /* v412 the garden pods' cladding: the scheme's wood, charred on shou sugi ban */
        var chr = !!scheme.charred;
        var chT = chr ? _kpCharTex() : null;
        mats.kpClad.color.setHex(chT ? 0xffffff : chr ? scheme.clad : scheme.wood);   /* the charred map carries its own tones */
        mats.kpClad.roughness = chr ? 0.92 : (mats.lumber ? mats.lumber.roughness : 0.85);
        mats.kpClad.map = chT;
        if (mats.kpClad.emissive) { mats.kpClad.emissive.setHex(chr ? 0x000000 : (scheme.glow ? scheme.wood : 0x000000)); mats.kpClad.emissiveIntensity = chr ? 0 : (scheme.glow || 0); }
        mats.kpClad.needsUpdate = true;
      }
      if (mats && mats.gsSeat && scheme.seat != null) { mats.gsSeat.color.setHex(scheme.seat); mats.gsSeat.needsUpdate = true; }   /* v312 the cinema bar's stool seats */
      if (mats && mats.phWall) _phPaint(mats);   /* v369 the playhouses' kids' colours follow the brush */
      /* Mattress fabric: sandy beige in the default colour stage; a very
         light, near-white green in the white stage. A faint emissive keeps
         the matte fabric from reading grey under the shading. */
      if (mats && mats.fabric) {
        mats.fabric.color.setHex(whiteMode ? 0x9aab86 : 0xd2bd97);
        if (mats.fabric.emissive) {
          mats.fabric.emissive.setHex(0x000000);
          mats.fabric.emissiveIntensity = 0;
        }
        mats.fabric.needsUpdate = true;
      }
      /* Throw pillows: mustard tones in the default stage; darker greens in
         the white stage (so they stand out against the light-green mattress).
         Two alternating colours. */
      if (mats && mats.pillowA && mats.pillowB) {
        if (whiteMode) {
          mats.pillowA.color.setHex(0x6f9159);   /* medium green */
          mats.pillowB.color.setHex(0x52733f);   /* darker green */
        } else {
          mats.pillowA.color.setHex(0xd1a23a);   /* mustard */
          mats.pillowB.color.setHex(0xa9822e);   /* darker mustard / ochre */
        }
        [mats.pillowA, mats.pillowB].forEach(function (pm) {
          if (pm.emissive) { pm.emissive.setHex(0x000000); pm.emissiveIntensity = 0; }
          pm.needsUpdate = true;
        });
        /* Lay the geometric-pattern texture (in this stage's palette) over
           the pillow materials; this carries the colour, so the tint above
           is reset to white inside. */
        try { _applyPillowTextures(mats, whiteMode); } catch (e) {}
      }

      /* Walk benchGroup; per child, set material opacity for meshes and
         edges. Hidden parts (stage 3 fasteners/roof/logs) get opacity 0
         on BOTH meshes and edge lines — preserves assembly-step .visible
         attribute so toggling stages doesn't fight the assembly sequence. */
      rg.children.forEach(function (c) {
        var pt = c.userData && c.userData.partType;
        if (!pt || pt === 'person') return;

        var partHidden = hidePart && hidePart(pt);
        var op = partHidden ? 0 : partOpacityFor(pt);
        var edgeOp = partHidden ? 0 : edgeOpacity;
        var isContext = (pt === 'porch-context');   /* the porch swing's beam: always see-through (v368 + the tree fort's tree; v369 the tree opaque -- the store's model) */
        if (isContext) op = Math.min(op, 0.35);
        var isCloth = (pt === 'mf-fabric');          /* v304 the modern swing's woven cloth: 70 % opaque */
        if (isCloth) op = Math.min(op, MF.FAB_OP);
        if (pt === 'rb-hw-vinyl' || pt === 'rb-hw-gvinyl') { op = Math.min(op, RB.VINYL_OP); isCloth = true; }   /* v325 the cold frame's vinyl 10 % (the stage set it opaque before); no depth write, as the cloth */
        if (/^gh-glaze-/.test(pt)) { op = Math.min(op, GH.GLAZE_OP); isCloth = true; }
        if (pt === 'ph-tree') { op = Math.min(op, 0.3); isCloth = true; }   /* v374 the tree fort's tree a reference only: 30 %, no depth write (Marek 2026-10-30 10:11: nemusi byt 100% opacity, staci 30%) */   /* v373 the greenhouse's twinwall: see-through (the stage set it opaque), no depth write */
        if (pt === 'ph-mesh') { op = Math.min(op, 0.99); isCloth = true; }   /* v375 the coop's hardware cloth: see-through (its wires an alpha map), no depth write -- the stage set it opaque */

        var isLumberPart = !isScrew(pt);   /* screws keep their metal look */

        c.traverse(function (node) {
          if (node.isMesh && node.material) {
            /* Stage-3 profile colouring, keyed by the mesh's own boqCode
               so each profile size gets its own colour (kids 3×3/3×2 differ
               from adult 4×4/2×4). Bench shares one lumber material across
               parts, so we give each lumber mesh a cloned, recoloured
               material here and restore the shared original when leaving
               stage 3 (stash on the node → reversible without a rebuild). */
            if (inStage3 && isLumberPart && !isContext) {
              var code = node.userData.boqCode || (c.userData && c.userData.boqCode);
              if (!node.userData._origMat) node.userData._origMat = node.material;
              if (!node.userData._stage3Mat) node.userData._stage3Mat = node.userData._origMat.clone();
              node.userData._stage3Mat.color.setHex(_stage3ColorFor(code));
              if (node.userData._stage3Mat.map) { node.userData._stage3Mat.map = null; node.userData._stage3Mat.emissiveIntensity = 0; }   /* v412 the charred cladding's map off */
              node.material = node.userData._stage3Mat;
            } else if (kpFrameSt && partHidden && !Array.isArray(node.material)) {
              /* v412 the pods' frame stage: a hidden part on its own clone (the lumber material is shared with the frame) */
              if (!node.userData._origMat) node.userData._origMat = node.material;
              if (!node.userData._hideMat) node.userData._hideMat = node.userData._origMat.clone();
              node.material = node.userData._hideMat;
            } else if (node.userData._origMat) {
              node.material = node.userData._origMat;   /* restore shared material */
            }
            node.material.transparent = op < 1;
            node.material.opacity = op;
            node.material.depthWrite = (op > 0) && !isContext && !isCloth;
            node.material.needsUpdate = true;
          } else if (node.userData && node.userData.isEdgeLine && node.material) {
            if (kpFrameSt && partHidden) { node.visible = false; node.userData._kpHid = 1; return; }   /* v412 (the edge material is shared) */
            if (node.userData._kpHid) { node.visible = true; node.userData._kpHid = 0; }
            var eoK = node.userData.seamK ? edgeOp * node.userData.seamK : edgeOp;   /* v297 the wave's panel seams: a faint hint */
            node.material.opacity = eoK;
            node.material.color.setHex(edgeColor);
            node.material.transparent = eoK < 1;
            node.material.needsUpdate = true;
          }
        });
      });

      /* Person — hidden in 2D, hidden in the section-cut stage (a scale
         figure makes no sense inside a slice), honours STATE.bodyVisible
         otherwise in 3D. */
      var personAllowed = (view === '3d' && stage !== 4 && stage !== 5 && STATE.bodyVisible !== false);
      rg.children.forEach(function (c) {
        if (c.userData && c.userData.partType === 'person') {
          c.visible = personAllowed;
        }
      });

      /* Body drag handle — hide whenever person is hidden. */
      var bh = document.getElementById('cf-body-handle');
      if (bh) {
        bh.style.display = personAllowed ? '' : 'none';
      }

      /* Renderer background */
      if (this.renderer) this.renderer.setClearColor(bgColor, bgAlpha);

      /* Grid overlay — shown in BOTH 2D stages (stage 1 = plan,
         stage 2 = side elevation). Same "graph paper" look provides
         visual scale reference. */
      var grid = document.getElementById('cf-grid-overlay');
      if (grid) {
        grid.classList.toggle('cf-grid-active', view === '2d');
      }

      /* Mapbox layer — visible in all stages (same behaviour as stage 1). */
      var mapbox = document.getElementById('cf-mapbox');
      if (mapbox) {
        mapbox.style.display = '';
      }

      /* 2D fill-opacity slider — shown in all 2D stages, hidden in 3D. */
      var op2dWrap = document.getElementById('cf-2d-opacity-slider-wrap');
      if (op2dWrap) {
        op2dWrap.classList.toggle('cf-2d-visible', view === '2d');
        /* One-shot diagnostic on first applyVizStage in 2D. */
        if (view === '2d' && !this._op2dWrapLogged) {
          this._op2dWrapLogged = true;
          var DLop = global.Configurator && global.Configurator.log;
          if (DLop) {
            var cs = window.getComputedStyle(op2dWrap);
            DLop.log('[opacity-slider] wrap found, view=' + view +
                     ' classList=' + op2dWrap.className +
                     ' display=' + cs.display +
                     ' right=' + cs.right + ' top=' + cs.top);
          }
        }
      } else {
        var DLop2 = global.Configurator && global.Configurator.log;
        if (DLop2 && !this._op2dWrapMissingLogged) {
          this._op2dWrapMissingLogged = true;
          DLop2.log('[opacity-slider] ELEMENT NOT FOUND — snippet markup not deployed?');
        }
      }


      /* Asset raycaster — active ONLY in 3D stage 1 (full build view).
         Toggling here removes hover/select highlight and closes the
         drawer when the user moves to inspection or profile stages.
         Drag handles coexist on stage 1; they catch their own pointer
         events with stopPropagation, so the raycaster never sees them. */
      if (global.BenchRaycaster && global.BenchRaycaster.setActive) {
        global.BenchRaycaster.setActive(view === '3d' && stage === 1);
      }

      /* Drag handles — visibility depends on view+stage+assembly. */
      if (typeof _refreshHandlesVisibility === 'function') _refreshHandlesVisibility();

      /* Dimension overlay (SVG) */
      if (global.BenchDimensions && global.BenchDimensions.refresh) {
        global.BenchDimensions.refresh();
      }

      /* Section cut (3D stage 4) — apply or clear the slice. */
      if (_BenchSectionCut) _BenchSectionCut.refresh();
    }
  };

  /* v369 CUTS ON THE PLAYHOUSES (Marek 2026-10-29 22:29: CUTS udelejme u vsech produktu tohoto typu jak to mame u adu atd -- ikona
     nuzek v pravem baneru, prepinani os x / y / z a tazeni sipkou). The house line's section tool is copied here AS IT IS from
     configurator-ui.js (cutPlanes, ui-v377 -- that 3 MB file is not on the bench page): the rail button, the X / Y / Z buttons and the
     side switch at the top of the canvas, the distance from the edge on the label, the arrow in the model to drag the plane, every body
     capped in its own colour. Adapted only around it: the stage is BenchEngine with benchGroup as the group, the button is the rail's
     own cf-btn-cut (shown on the playhouses), lengths in the page's unit (fmtLen), and the old viz stage 4 slice is off the eye's cycle
     on these types (the two cut the same materials). */
  function _benchCutKit(opts) {
    opts = opts || {};
    opts.log = opts.log || function () {};
    opts.fmtLen = opts.fmtLen || function (m) { return Math.round(m * 1000) + ' mm'; };
  /* --------------------------------------------------------------------------
       CUT PLANES -- shared. A product calls api.cutPlanes({ stage, rootId, buttonId,
       unitBtnId, fmtLen, log, controls, view }) once and gets { toggle, on,
       apply, planes }. The rail's colours button becomes the section tool: tapping it
       puts three buttons at the bottom of the canvas -- X, Y, Z -- a slider that
       moves the cut across the whole building along the chosen axis, and a
       flip that keeps the other side. The cut is the renderer's own clipping
       plane, so every layer is cut at once and the bodies show hollow where the
       plane passes through them; nothing is rebuilt and nothing is billed
       differently. Tap the rail button again and the cut is gone (Marek: cut
       planes in the right rail in place of the colours, three icons x / y / z
       at the bottom centre with the section and a handle to drag it).
       -------------------------------------------------------------------------- */
    var _cut = { on: false, axis: 'x', t: 0.5, flip: false, panel: null, timer: 0, box: null,
                 mesh: null, handle: null, plane: null, stencil: null, stencilKey: '' };

    function _cutBounds() {
      var T = global.THREE, st = opts.stage();
      if (!T || !st || !st.group) return null;
      try {
        var bx = new T.Box3().setFromObject(st.group);
        if (!isFinite(bx.min.x) || !isFinite(bx.max.x)) return null;
        return bx;
      } catch (e) { return null; }
    }

    /* the plane of the cut, drawn: a light grey translucent sheet across the
       building at the cut, on the kept side by a millimetre so it is not cut
       itself; sized to the building's own extent across the axis */
    /* THE CUT IS CAPPED. A body cut open is a body with one wall missing, and
       through the hole you see its inside -- a wool batt reads full because it
       is thin, an attic full of blown fill reads as a room. So the section gets
       a lid: every body the plane passes through is counted into the stencil
       (its back faces add, its front faces take away -- inside a body the count
       is not zero), and one plane at the cut is painted, opaque, wherever the
       count says there is a body. Every cut solid shows a flat grey section
       face, the way a drawing hatches it; where nothing is cut the plane is a
       faint tint (Marek: a volume must read solid on the cut). */
    function _cutMesh(bx, c) {
      var T = global.THREE, st = opts.stage();
      if (!T || !st || !st.scene) return;
      if (_cut.mesh) { try { st.scene.remove(_cut.mesh); } catch (e0) {} _cut.mesh = null; }
      if (!_cut.on || !bx) return;
      var ax = _cut.axis, sz = new T.Vector3().subVectors(bx.max, bx.min);
      var mid = new T.Vector3().addVectors(bx.min, bx.max).multiplyScalar(0.5);
      var w = ax === 'x' ? sz.z : sz.x, h = ax === 'y' ? sz.z : sz.y;
      var G = new T.Group();
      /* the faint tint over the whole section, for the eye to find the plane */
      var tint = new T.Mesh(new T.PlaneGeometry(w * 1.05, h * 1.05),
        new T.MeshBasicMaterial({ color: 0x777777, transparent: true, opacity: 0.10,
                                  side: T.DoubleSide, depthWrite: false }));
      tint.renderOrder = 30;
      G.add(tint);
      /* ONE CAP PER COLOUR, IN THAT COLOUR. The stencil is counted one colour
         group at a time and its cap painted in the group's own colour before
         the next group counts -- so wood is capped in wood, wool in wool, the
         blown fill in its own beige, and the section reads as the bodies it
         cuts, not as one grey (Marek). The cap also resets the stencil where it
         draws, so the next group starts clean. */
      var groups = _cut.capGroups || [], gq;
      for (gq = 0; gq < groups.length; gq++) {
        var capM = new T.MeshStandardMaterial({ color: groups[gq].col, roughness: 0.95, metalness: 0.0, side: T.DoubleSide });
        capM.stencilWrite = true;
        capM.stencilRef = 0;
        capM.stencilFunc = T.NotEqualStencilFunc;
        capM.stencilFail = T.ReplaceStencilOp;
        capM.stencilZFail = T.ReplaceStencilOp;
        capM.stencilZPass = T.ReplaceStencilOp;
        var cap = new T.Mesh(new T.PlaneGeometry(w * 1.05, h * 1.05), capM);
        cap.renderOrder = groups[gq].order + 1;   /* right after this group's stencil pass */
        G.add(cap);
      }
      var keepDir = _cut.flip ? 1 : -1;   /* the kept side is below c unless flipped */
      if (ax === 'x') { G.rotation.y = Math.PI / 2; G.position.set(c + keepDir * 0.0005, mid.y, mid.z); }
      else if (ax === 'y') { G.rotation.x = -Math.PI / 2; G.position.set(mid.x, c + keepDir * 0.0005, mid.z); }
      else { G.position.set(mid.x, mid.y, c + keepDir * 0.0005); }
      G.userData.arSkip = true;
      st.scene.add(G);
      _cut.mesh = G;
      if (_cut.showPlane === false) G.visible = false;
    }

    /* THE STENCIL PASSES: for every mesh of the house a back-face clone that
       adds to the stencil and a front-face clone that subtracts, both clipped by
       the same plane and drawing no colour. Built once per model (rebuilt when
       the group changes), sharing the originals' geometry and world transform,
       so moving the plane costs nothing. */
    /* OPEN SHEETS ARE LEFT OUT OF THE SECTION'S FILL (core-v504, moved from
       the A-frame lib, aframe-v52/v53, Marek: pri rezu je videt seda plocha,
       ktera se natacela). The cap fills a body by a stencil count of its
       faces, and only a body that is closed and wound one way round closes
       the count: a sheet with no thickness (a board drawn as a plane, a film,
       a folded flashing, a skin piece cut round a window) or a box with faces
       wound some in, some out, left the stencil odd and the fill spread over
       the cut plane wherever the eye looked through it. Every mesh is checked
       here, for every product: each directed edge must be walked exactly once
       and its reverse exactly once; anything else is skipped as if it were
       flagged isEdge. The answer is kept per geometry. */
    var _openMemo = {};
    function _cutIsOpen(geo) {
      if (!geo || !geo.attributes || !geo.attributes.position) return true;
      if (_openMemo[geo.uuid] != null) return _openMemo[geo.uuid];
      var pos = geo.attributes.position, idx = geo.index, n = idx ? idx.count : pos.count, E = {}, i, k;
      var key = function (j) { return Math.round(pos.getX(j) * 1e4) + ',' + Math.round(pos.getY(j) * 1e4) + ',' + Math.round(pos.getZ(j) * 1e4); };
      for (i = 0; i + 2 < n; i += 3) {
        var a = key(idx ? idx.getX(i) : i), b = key(idx ? idx.getX(i + 1) : i + 1), c = key(idx ? idx.getX(i + 2) : i + 2);
        if (a === b || b === c || c === a) continue;          /* a sliver of no area closes nothing */
        var es = [[a, b], [b, c], [c, a]];
        for (k = 0; k < 3; k++) { var e = es[k][0] + '>' + es[k][1]; E[e] = (E[e] || 0) + 1; }
      }
      var open = false, ek;
      for (ek in E) {
        if (!E.hasOwnProperty(ek)) continue;
        var pr = ek.split('>'), back = pr[1] + '>' + pr[0];
        if (E[ek] !== 1 || E[back] !== 1) { open = true; break; }
      }
      _openMemo[geo.uuid] = open;
      return open;
    }
    function _cutStencil(st, planes) {
      var T = global.THREE;
      if (!T || !st || !st.scene) return;
      if (_cut.stencil) { try { st.scene.remove(_cut.stencil); } catch (e0) {} _cut.stencil = null; }
      if (!planes || !st.group) return;
      var G = new T.Group(), n = 0, nOpen = 0;
      _openMemo = {};
      var byCol = {}, order = [];
      st.group.updateMatrixWorld(true);
      st.group.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        if (node.isInstancedMesh) return;   /* v413 a clone would be one body at the origin (the sedum's plants, the swings' chain links): clipped, not capped */
        if (node.userData && node.userData.isEdge) return;
        var opn = true; try { opn = _cutIsOpen(node.geometry); } catch (eOp) { opn = true; }
        if (opn) { nOpen++; return; }
        /* only what is on screen: a body hidden by its layer (the drawings
           page) or by itself has no cap -- walk the parents */
        var pv = node, shown = true;
        while (pv) { if (pv.visible === false) { shown = false; break; } pv = pv.parent; }
        if (!shown) return;
        var m0 = Array.isArray(node.material) ? node.material[0] : node.material;
        if (!m0 || m0.visible === false || m0.transparent && m0.opacity < 0.5) return;
        /* the group's colour: the material's own, or a mid tone for a textured
           one (a print or a tile shows white as its colour); a body drawn in
           ink (the drawings page, emissive white) caps white */
        var inked = m0.emissive && m0.emissive.r > 0.6 && m0.emissive.g > 0.6 && m0.emissive.b > 0.6;
        var col = inked ? 0xFFFFFF
                : (m0.userData && m0.userData.capCol != null) ? m0.userData.capCol
                : (m0.map ? 0xC2B49A : (m0.color ? m0.color.getHex() : 0xC9C7C2));
        var key = String(col);
        if (!byCol[key]) { byCol[key] = { col: col, nodes: [] }; order.push(key); }
        byCol[key].nodes.push(node);
      });
      var capGroups = [], gq, ro = 900;
      for (gq = 0; gq < order.length; gq++) {
        var grp = byCol[order[gq]], q;
        for (q = 0; q < grp.nodes.length; q++) {
          var node = grp.nodes[q];
          var base = { depthWrite: false, depthTest: false, colorWrite: false,
                       stencilWrite: true, stencilFunc: T.AlwaysStencilFunc, clippingPlanes: planes };
          var mb = new T.MeshBasicMaterial(base);
          mb.side = T.BackSide;
          mb.stencilFail = T.IncrementWrapStencilOp; mb.stencilZFail = T.IncrementWrapStencilOp; mb.stencilZPass = T.IncrementWrapStencilOp;
          var mf = new T.MeshBasicMaterial(base);
          mf.side = T.FrontSide;
          mf.stencilFail = T.DecrementWrapStencilOp; mf.stencilZFail = T.DecrementWrapStencilOp; mf.stencilZPass = T.DecrementWrapStencilOp;
          var a = new T.Mesh(node.geometry, mb), b = new T.Mesh(node.geometry, mf);
          a.matrixAutoUpdate = false; b.matrixAutoUpdate = false;
          a.matrix.copy(node.matrixWorld); b.matrix.copy(node.matrixWorld);
          a.renderOrder = ro; b.renderOrder = ro;
          a.userData.arSkip = true; b.userData.arSkip = true;
          G.add(a); G.add(b);
          n++;
        }
        capGroups.push({ col: grp.col, order: ro });
        ro += 2;
      }
      G.userData.arSkip = true;
      st.scene.add(G);
      _cut.stencil = G;
      _cut.nStencil = n;
      _cut.capGroups = capGroups;
      _cut.nOpen = nOpen;
      opts.log('section  ' + n + ' bod(ies) filled when cut, ' + nOpen + ' open sheet(s) left unfilled (core check, every product)');
    }

    /* THE CUT IS ON THE LAYERS' MATERIALS, NOT ON THE RENDERER. A global plane
       cuts everything drawn, the handle and the arrow included -- the arrow
       points into the removed side and was simply clipped away. So the plane
       goes onto every material of the building group (local clipping), and
       the overlay, the cross and the arrow stay whole. The planes are also
       kept on the renderer under a name of their own for the AR export. */
    /* AND THE BODIES STAY BODIES. A cut box is a box with one side open: the
       renderer drops the faces that look away, so through the cut you saw out
       the back of every wool batt, joist and fill and read them as planes with
       nothing inside (Marek). While the cut is on every material of the house
       is drawn double-sided, so the inside walls of a cut body show in the
       body's own colour and the batt is full, the joist is full, the blown fill
       is full. Off, the sides go back to what each material had. */
    function _cutMaterials(st, planes) {
      if (!st || !st.group) return 0;
      var T = global.THREE, n = 0;
      st.group.traverse(function (node) {
        if (!(node.isMesh || node.isLineSegments || node.isLine) || !node.material) return;   /* bench: the edge lines are cut with their bodies */
        var mats = Array.isArray(node.material) ? node.material : [node.material], k;
        for (k = 0; k < mats.length; k++) {
          var m = mats[k];
          if (!m) continue;
          if (planes) {
            if (m.userData.__side === undefined) m.userData.__side = m.side;
            m.side = T.DoubleSide;
          } else if (m.userData.__side !== undefined) {
            m.side = m.userData.__side;
            delete m.userData.__side;
          }
          m.clippingPlanes = planes;
          m.needsUpdate = true;
          n++;
        }
      });
      return n;
    }

    function _cutApply() {
      var T = global.THREE, st = opts.stage();
      if (!T || !st || !st.renderer) return;
      if (!_cut.on) {
        st.renderer.clippingPlanes = [];
        st.renderer.__sectionPlanes = [];
        _cutMaterials(st, null);
        _cutStencil(st, null);
        _cut.stencilKey = '';
        _cut.capGroups = null;
        _cutMesh(null, 0);
        _cutHandle(null, 0);
        return;
      }
      var bx = _cutBounds();
      if (!bx) return;
      _cut.box = bx;
      var ax = _cut.axis, lo = bx.min[ax], hi = bx.max[ax];
      var c = lo + (hi - lo) * _cut.t;
      /* keep the side BELOW c on the axis: n.p + d >= 0 with n = -e, d = c */
      var n = new T.Vector3(ax === 'x' ? -1 : 0, ax === 'y' ? -1 : 0, ax === 'z' ? -1 : 0);
      var d = c;
      if (_cut.flip) { n.multiplyScalar(-1); d = -c; }
      if (!_cut.plane) _cut.plane = new T.Plane(n, d);
      else _cut.plane.set(n, d);
      var planes = [_cut.plane];
      st.renderer.localClippingEnabled = true;
      st.renderer.clippingPlanes = [];
      st.renderer.__sectionPlanes = planes;
      _cut.nMat = _cutMaterials(st, planes);
      /* the stencil clones follow the model, not the plane: rebuilt only when
         the group's make-up changes */
      var key = String(st.group ? st.group.children.length : 0) + ':' + (_cut.nMat | 0);
      if (!_cut.stencil || key !== _cut.stencilKey) { _cutStencil(st, planes); _cut.stencilKey = key; }
      _cutMesh(bx, c);   /* builds one cap per colour group the stencil found */
      _cutHandle(bx, c);
      _cutLabel(c - lo);
    }

    function _cutLabel(dist) {
      var el = document.getElementById('cf-house-cut-val');
      if (!el) return;
      el.textContent = opts.fmtLen(Math.max(0, dist));
    }

    function _cutButtonsSync() {
      var p = _cut.panel;
      if (p) {
        var k, b = p.querySelectorAll('[data-cut-axis]');
        for (k = 0; k < b.length; k++) {
          var on = b[k].getAttribute('data-cut-axis') === _cut.axis;
          b[k].style.background = on ? '#E8442A' : '#EEF0F2';
          b[k].style.color = on ? '#fff' : '#1A1C1D';
        }
      }
    }

    /* THE CONTROLS: round buttons like the floating menu at the bottom -- X, Y,
       Z and the side switch, the active one red, the others grey -- standing at
       about 15 percent from the top of the canvas so they never meet the edit
       button, and the shared slider under them, the same one the roof pitch
       uses, with the cut's distance from the building's edge riding on its
       thumb in the project's units (Marek). */
    function _cutPanel(show) {
      var root = document.getElementById(opts.rootId || 'cf-root');
      if (!root || opts.noPanel) return;
      if (!show) {
        if (_cut.panel && _cut.panel.parentNode) _cut.panel.parentNode.removeChild(_cut.panel);
        _cut.panel = null;
        var un = document.getElementById('cf-house-cut-under');
        if (un && un.parentNode) un.parentNode.removeChild(un);
        return;
      }
      if (!_cut.panel) {
        /* the look of the right rail, laid on its side: a white rounded
           rectangle, rounded-square buttons of the rail's size, the active
           axis red and the others light grey (Marek) */
        var p = document.createElement('div');
        p.id = 'cf-cut-panel';
        p.style.cssText = 'position:absolute;left:50%;top:12%;transform:translateX(-50%);' +
          'display:flex;align-items:center;gap:6px;padding:6px;' +
          'background:#fff;border-radius:14px;' +
          'box-shadow:0 2px 10px rgba(0,0,0,0.16);z-index:40;';
        /* the buttons say what the world says: Z is up. three.js has y up, so
           the button Y drives the scene's z and the button Z the scene's y */
        var keys = ['x', 'z', 'y'], names = ['X', 'Y', 'Z'], k;
        for (k = 0; k < 3; k++) {
          var bt = document.createElement('button');
          bt.type = 'button';
          bt.setAttribute('data-cut-axis', keys[k]);
          bt.textContent = names[k];
          bt.style.cssText = 'width:36px;height:36px;border-radius:10px;border:0;' +
            'font:700 13px/1 Montserrat,sans-serif;cursor:pointer;background:#EEF0F2;color:#1A1C1D;';
          bt.addEventListener('click', function (ev) {
            _cut.axis = ev.currentTarget.getAttribute('data-cut-axis');
            _cutButtonsSync(); _cutApply();
            opts.log('cut plane axis -> ' + _cut.axis);
          });
          p.appendChild(bt);
        }
        root.appendChild(p);
        _cut.panel = p;
      }
      _cutButtonsSync();

      /* under the panel: the distance of the cut from the building's edge, and
         under that the side switch -- the rail's own unit-switch glyph, no
         background, static (Marek) */
      if (!document.getElementById('cf-house-cut-under')) {
        var under = document.createElement('div');
        under.id = 'cf-house-cut-under';
        under.style.cssText = 'position:absolute;left:50%;top:calc(12% + 56px);transform:translateX(-50%);' +
          'display:flex;flex-direction:column;align-items:center;gap:4px;white-space:nowrap;z-index:40;';
        var lab = document.createElement('div');
        lab.id = 'cf-house-cut-val';
        lab.style.cssText = 'padding:2px 8px;border-radius:6px;' +
          'background:rgba(255,255,255,0.96);box-shadow:0 1px 4px rgba(0,0,0,0.12);' +
          'font:700 12px/1.35 Montserrat,sans-serif;color:#1A1C1D;';
        var fl = document.createElement('button');
        fl.type = 'button';
        fl.id = 'cf-house-cut-flip';
        fl.style.cssText = 'width:34px;height:28px;border:0;background:transparent;' +
          'color:#1A1C1D;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;';
        var unitBtn = document.getElementById(opts.unitBtnId || 'cf-btn-unit');
        if (unitBtn && unitBtn.innerHTML) fl.innerHTML = unitBtn.innerHTML;
        else fl.textContent = '<->';
        fl.addEventListener('click', function () {
          _cut.flip = !_cut.flip;
          _cutButtonsSync(); _cutApply();
          opts.log('cut plane side flipped');
        });
        under.appendChild(lab);
        under.appendChild(fl);
        root.appendChild(under);
      }
      _cutBindDrag();
    }

    /* THE HANDLE IN THE MODEL: a thin cross at the middle of the cut plane with
       an arrow along the axis, drawn light; take it and drag, and the plane
       follows the finger along the axis. The pointer delta is turned into a
       movement along the axis by projecting the axis into screen space. */
    function _cutHandle(bx, c) {
      var T = global.THREE, st = opts.stage();
      if (!T || !st || !st.scene) return;
      if (_cut.handle) { try { st.scene.remove(_cut.handle); } catch (e0) {} _cut.handle = null; }
      if (!_cut.on || !bx) return;
      var ax = _cut.axis, mid = new T.Vector3().addVectors(bx.min, bx.max).multiplyScalar(0.5);
      var pos = mid.clone(); pos[ax] = c;
      var G = new T.Group();
      var mat = new T.LineBasicMaterial({ color: 0x2b2b2b, transparent: true, opacity: 0.85, depthTest: false });
      var arm = 0.35;
      function seg(a, b) {
        var g2 = new T.BufferGeometry().setFromPoints([a, b]);
        var l = new T.Line(g2, mat); l.renderOrder = 50; G.add(l);
      }
      /* the cross lies in the plane: the two axes that are not the cut's */
      var others = ['x', 'y', 'z'].filter(function (k) { return k !== ax; });
      others.forEach(function (k) {
        var a = new T.Vector3(), b = new T.Vector3(); a[k] = -arm; b[k] = arm; seg(a, b);
      });
      /* THE ARROW ALONG THE AXIS, BOTH WAYS, TWICE AS LONG AS THE CROSS ARMS
         and with heads at both ends -- the shape that was on screen first and
         read best (Marek). Nothing here is clipped any more: the cut sits on
         the building's materials, not on the renderer. */
      var e = new T.Vector3(); e[ax] = 1;
      var tip = arm * 2.6, hd = 0.09;
      seg(e.clone().multiplyScalar(-tip), e.clone().multiplyScalar(tip));
      others.forEach(function (k) {
        var s1 = new T.Vector3(); s1[k] = hd;
        seg(e.clone().multiplyScalar(tip), e.clone().multiplyScalar(tip - hd * 1.4).add(s1));
        seg(e.clone().multiplyScalar(tip), e.clone().multiplyScalar(tip - hd * 1.4).sub(s1));
        seg(e.clone().multiplyScalar(-tip), e.clone().multiplyScalar(-tip + hd * 1.4).add(s1));
        seg(e.clone().multiplyScalar(-tip), e.clone().multiplyScalar(-tip + hd * 1.4).sub(s1));
      });
      /* an invisible ball to grab */
      var grab = new T.Mesh(new T.SphereGeometry(0.45, 12, 8), new T.MeshBasicMaterial({ visible: false }));
      grab.userData.cutGrab = true;
      G.add(grab);
      G.position.copy(pos);
      G.userData.arSkip = true;
      st.scene.add(G);
      _cut.handle = G;
      if (_cut.showHandle === false) G.visible = false;
    }

    function _cutBindDrag() {
      var st = opts.stage(), T = global.THREE;
      if (!st || !st.renderer || !st.renderer.domElement || !T) return;
      var cv = st.renderer.domElement;
      if (cv.__cutDrag) return;
      cv.__cutDrag = true;
      var drag = null, ray = new T.Raycaster(), ndc = new T.Vector2();
      function cam() { return ((opts.view ? opts.view() : '3d') === '2d' && st.orthoCam) ? st.orthoCam : st.camera; }
      function toNdc(ev) {
        var r = cv.getBoundingClientRect();
        ndc.set(((ev.clientX - r.left) / r.width) * 2 - 1, -((ev.clientY - r.top) / r.height) * 2 + 1);
        return r;
      }
      cv.addEventListener('pointerdown', function (ev) {
        if (!_cut.on || !_cut.handle || !_cut.box) return;
        var r = toNdc(ev);
        ray.setFromCamera(ndc, cam());
        var hits = ray.intersectObject(_cut.handle, true);
        if (!hits.length) return;
        ev.preventDefault(); ev.stopPropagation();
        var ctl = (opts.controls ? opts.controls() : null); if (ctl) ctl.enabled = false;
        try { cv.setPointerCapture(ev.pointerId); } catch (eP) {}
        /* the axis on screen: where the handle projects and where one metre
           along the axis projects */
        var C = cam(), p0 = _cut.handle.position.clone(), p1 = p0.clone(); p1[_cut.axis] += 1;
        var s0 = p0.project(C), s1 = p1.project(C);
        var vx = (s1.x - s0.x) * r.width / 2, vy = -(s1.y - s0.y) * r.height / 2;
        drag = { id: ev.pointerId, x: ev.clientX, y: ev.clientY, t0: _cut.t, vx: vx, vy: vy,
                 range: _cut.box.max[_cut.axis] - _cut.box.min[_cut.axis] };
      }, true);
      cv.addEventListener('pointermove', function (ev) {
        if (!drag || ev.pointerId !== drag.id) return;
        ev.preventDefault(); ev.stopPropagation();
        var dx = ev.clientX - drag.x, dy = ev.clientY - drag.y;
        var vv = drag.vx * drag.vx + drag.vy * drag.vy;
        if (!(vv > 1e-6) || !(drag.range > 0)) return;
        var metres = (dx * drag.vx + dy * drag.vy) / vv;   /* pointer travel along the axis, in metres */
        _cut.t = Math.max(0, Math.min(1, drag.t0 + metres / drag.range));
        _cutApply();
      }, true);
      function end(ev) {
        if (!drag || (ev && ev.pointerId !== drag.id)) return;
        drag = null;
        var ctl = (opts.controls ? opts.controls() : null); if (ctl) ctl.enabled = true;
        opts.log('cut plane at ' + Math.round(_cut.t * 100) + '% along ' + _cut.axis);
      }
      cv.addEventListener('pointerup', end, true);
      cv.addEventListener('pointercancel', end, true);
    }


    /* the rail button's glyph and its black-when-pressed are the liquid's
       (house-liquid-v39): the lib only sets aria-pressed */
    function _cutIcon() {
      try {
        var elC = document.getElementById(opts.buttonId || 'cf-btn-colors');
        if (elC) elC.setAttribute('aria-pressed', _cut.on ? 'true' : 'false');
      } catch (eI) {}
    }

    function cutPlanesToggle() {
      _cut.on = !_cut.on;
      _cutIcon();
      _cutPanel(_cut.on);
      _cutApply();
      /* the model is rebuilt under the tool all the time -- a step change, a
         drag -- so while it is on the plane is re-measured against the fresh
         group a couple of times a second; off, nothing runs */
      if (_cut.timer) { try { global.clearInterval(_cut.timer); } catch (e2) {} _cut.timer = 0; }
      if (_cut.on) _cut.timer = global.setInterval(function () { try { _cutApply(); } catch (e3) {} }, 500);
      opts.log('cut planes ' + (_cut.on ? 'ON  axis=' + _cut.axis : 'off'));
    }


    return {
      toggle: cutPlanesToggle,
      on: function () { return _cut.on; },
      apply: _cutApply,
      /* set the cut from outside -- the drawings page's section views */
      set: function (o) {
        o = o || {};
        if (o.rebuild) { _cut.stencilKey = ''; }
        if (typeof o.handle === 'boolean') { _cut.showHandle = o.handle; if (_cut.handle) _cut.handle.visible = o.handle; }
        /* the grey plane itself, off for a drawing */
        if (typeof o.plane === 'boolean') { _cut.showPlane = o.plane; if (_cut.mesh) _cut.mesh.visible = o.plane; }
        if (o.axis) _cut.axis = o.axis;
        if (typeof o.t === 'number') _cut.t = Math.max(0, Math.min(1, o.t));
        if (typeof o.flip === 'boolean') _cut.flip = o.flip;
        if (o.on === true && !_cut.on) cutPlanesToggle();
        else if (o.on === false && _cut.on) cutPlanesToggle();
        else { _cutButtonsSync(); _cutApply(); }
      },
      planes: function () { var st = opts.stage(); return (st && st.renderer && st.renderer.__sectionPlanes) || []; },
      state: function () { return { on: _cut.on, axis: _cut.axis, t: _cut.t, flip: _cut.flip, nMat: _cut.nMat | 0, nStencil: _cut.nStencil | 0, caps: (_cut.capGroups || []).length, box: _cut.box }; }
    };
  }

  var _benchCut = null, _cutVar = 0;   /* v413 the type the section was opened on (another type: off) */
  function _benchCutStage() { var E = global.BenchEngine; return E ? { renderer: E.renderer, scene: E.scene, group: E.benchGroup, camera: E.camera, orthoCam: E.orthoCamera } : null; }
  function _benchCutInit() {
    if (_benchCut) return _benchCut;
    _benchCut = _benchCutKit({
      stage: _benchCutStage, rootId: 'cf-root', buttonId: 'cf-btn-cut', unitBtnId: 'cf-btn-unit',
      fmtLen: function (m) { return fmtLen(m) + (STATE.isMetric === false ? ' ft' : ' m'); },
      log: function (t) { _dbg('[cut] ' + t); },
      controls: function () { return global.BenchEngine ? global.BenchEngine.controls : null; },
      view: function () { return STATE.view; }
    });
    return _benchCut;
  }
  function _benchCutOn() { try { return !!(_benchCut && _benchCut.on()); } catch (e) { return false; } }
  function _benchCutOff(why) { try { if (_benchCutOn()) { _benchCut.toggle(); _dbg('[cut] section off -- ' + why); } } catch (e) {} }
  /* v413 (Marek 2026-11-03 23:46 "pro vsechny konfiguratory na tomto principu musime zmenit cut a to podle house konfiguratoru -- ikona,
     zobrazi se banner s prepinacem os a smeru a uzivatel taha za stredovou sipku"): THE SECTION TOOL ON EVERY TYPE of the bench engine
     (was the playhouses' only, v369); the eye's old stage-4 slice gone from its cycle */
  function toggleCut() {
    if (!global.BenchEngine) return;
    if (STATE.view === '2d' && global.BenchEngine && global.BenchEngine.toggleView) global.BenchEngine.toggleView();   /* the section is a 3D view */
    if ((STATE.vizStage | 0) === 4) { STATE.vizStage = 1; try { global.BenchEngine.applyVizStage(); } catch (e) {} }
    var t = _benchCutInit();
    if (t) t.toggle();
    try { if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition(); } catch (eR) {}   /* v413 the + discs off / back */
  }

  /* ───────────────────────── Section cut (viz stage 4) ────────────────
     Vertical slice through the 3D bench with solid coloured caps, so the
     cut surface reads as filled timber instead of a hollow shell. Ported
     from the foundations (base) _SectionCutManager — same stencil-buffer
     per-material cap technique — adapted for the bench:
       • no polygon/variants: the plane is derived from the bench bounding
         box, cutting perpendicular to the LONGER horizontal extent and
         passing through its centre (a crosswise slice shows the seat,
         backrest and a leg profile at once);
       • solid parts = every lumber/screw mesh (everything except the
         scale person and the section-cut aux geometry).
     Requires renderer.localClippingEnabled = true (set in BenchEngine). */
  var _BenchSectionCut = {
    _capsGroup: null,
    _outlineGroup: null,
    _activePlane: null,
    _activeOffset: 0,
    _activeCutAlongX: false,

    /* World-space bounding box of the real bench geometry (honours
       Object3D.visible — Box3.setFromObject ignores it, so we walk
       and union per-mesh). Excludes the person and aux geometry. */
    /* True if the node is inside the scale-figure subtree (the person GLB
       nests many meshes, so checking only the immediate parent misses
       them — walk up to the bench group). */
    _isPerson: function (node) {
      var n = node;
      while (n && n !== null) {
        if (n.userData && n.userData.partType === 'person') return true;
        n = n.parent;
      }
      return false;
    },

    /* True if the node is inside the section-cut aux geometry (caps,
       stencil meshes, outline, hit plane). Walks ancestors because the
       cap/stencil child meshes are not individually tagged — without this
       a refresh re-captured them as "solid" and the cap pass exploded
       (10k+ meshes per frame). */
    _isAux: function (node) {
      var n = node;
      while (n && n !== null) {
        if (n.userData && n.userData.assetType === 'section-cut-aux') return true;
        n = n.parent;
      }
      return false;
    },

    _bbox: function (eng) {
      var T = global.THREE;
      var box = new T.Box3();
      var tmp = new T.Box3();
      var any = false;
      var self = this;
      eng.benchGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry) return;
        if (!node.visible) return;
        var pt = node.userData && node.userData.partType;
        if (self._isPerson(node)) return;
        if (pt === 'pocket-marker') return;
        if (self._isAux(node)) return;
        node.updateMatrixWorld(true);
        tmp.setFromObject(node);
        if (!tmp.isEmpty()) { box.union(tmp); any = true; }
      });
      return any ? box : null;
    },

    compute: function (eng) {
      var T = global.THREE;
      if (!T || !eng || !eng.benchGroup) { _dbg('[cut] compute: THREE/benchGroup missing'); return null; }
      var box = this._bbox(eng);
      if (!box) { _dbg('[cut] compute: bbox NULL (no visible meshes matched)'); return null; }
      _dbg('[cut] bbox min=(' + box.min.x.toFixed(2) + ',' + box.min.y.toFixed(2) + ',' + box.min.z.toFixed(2) +
           ') max=(' + box.max.x.toFixed(2) + ',' + box.max.y.toFixed(2) + ',' + box.max.z.toFixed(2) + ')');
      var cx = (box.min.x + box.max.x) / 2;
      var cz = (box.min.z + box.max.z) / 2;
      var extX = box.max.x - box.min.x;
      var extZ = box.max.z - box.min.z;

      /* Cut perpendicular to the longer horizontal extent. Bench length
         runs along Z, so extZ is usually larger → cut across Z (normal
         +Z), slicing through the middle of the length. */
      /* Cut CROSSWISE through the bench length (L runs along Z) so the
         slice reveals the seat + backrest + a leg in profile — the most
         informative section. Plane normal = +Z, positioned at the centre
         of the length. (Earlier this keyed off the longer extent, which on
         a bench is the length, so it sliced along the depth and looked
         "rotated".) */
      /* Axis is LOCKED to the bench length (Z) → crosswise slice. This is
         deterministic and never flips, so dragging only moves the plane
         along Z and can't 'leak' onto another axis. */
      var cutAlongX = true;
      var normal = new T.Vector3(0, 0, 1);

      /* Position: centre of the cut axis by default, or the user-dragged
         offset (absolute world coord on that axis) clamped inside the
         bench so the plane always cuts something. */
      var axisMin = cutAlongX ? box.min.z : box.min.x;
      var axisMax = cutAlongX ? box.max.z : box.max.x;
      var planeCoord = (axisMin + axisMax) / 2;
      if (typeof STATE.cutOffset === 'number') {
        var pad = (axisMax - axisMin) * 0.04;
        planeCoord = Math.max(axisMin + pad, Math.min(axisMax - pad, STATE.cutOffset));
      }
      this._activeAxisMin = axisMin;
      this._activeAxisMax = axisMax;
      this._activeCentreX = (box.min.x + box.max.x) / 2;
      this._activeCentreZ = (box.min.z + box.max.z) / 2;
      this._activeTopY    = box.max.y;

      /* Hide the near half so the cut surface faces the default camera. */
      var plane = new T.Plane(normal.clone().negate(), planeCoord);
      this._activePlane = plane;
      this._activeOffset = planeCoord;
      this._activeCutAlongX = cutAlongX;
      this._activeBox = box;
      return plane;
    },

    apply: function (plane) {
      var eng = global.BenchEngine;
      if (!eng || !eng.benchGroup || !plane) return 0;
      var n = 0;
      var self = this;
      eng.benchGroup.traverse(function (node) {
        if (!node.material) return;
        if (self._isAux(node)) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var i = 0; i < mats.length; i++) {
          var m = mats[i];
          if (!m) continue;
          m.clippingPlanes = [plane];
          m.clipShadows = false;
          m.needsUpdate = true;
          n++;
        }
      });
      return n;
    },

    clear: function () {
      var eng = global.BenchEngine;
      var self = this;
      if (eng && eng.benchGroup) {
        eng.benchGroup.traverse(function (node) {
          if (!node.material) return;
          if (self._isAux(node)) return;
          var mats = Array.isArray(node.material) ? node.material : [node.material];
          for (var i = 0; i < mats.length; i++) {
            if (mats[i]) { mats[i].clippingPlanes = null; mats[i].needsUpdate = true; }
          }
        });
      }
      this._removeAux();
      this._activePlane = null;
    },

    _removeAux: function () {
      var eng = global.BenchEngine;
      if (!eng || !eng.benchGroup) return;
      if (this._capsGroup) {
        eng.benchGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
        this._capsGroup = null;
      }
      if (this._outlineGroup) {
        eng.benchGroup.remove(this._outlineGroup);
        this._disposeGroup(this._outlineGroup);
        this._outlineGroup = null;
      }
    },

    _disposeGroup: function (group) {
      group.traverse(function (n) {
        if (n.geometry) n.geometry.dispose();
        if (n.material) {
          var ms = Array.isArray(n.material) ? n.material : [n.material];
          ms.forEach(function (m) { m && m.dispose && m.dispose(); });
        }
      });
    },

    /* Highlighted line tracing the cut plane so the slice location is
       obvious in 3D. */
    addOutline: function (plane, eng) {
      var T = global.THREE;
      if (!T || !plane || !eng || !this._activeBox) return;
      /* Remove any previous outline + hit plane so they don't pile up. */
      if (this._outlineGroup) {
        eng.benchGroup.remove(this._outlineGroup);
        this._disposeGroup(this._outlineGroup);
        this._outlineGroup = null;
      }
      var box = this._activeBox;
      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      var coord = this._activeOffset;
      var yTop = box.max.y + 0.05;
      var yBot = box.min.y - 0.05;
      var a, b;
      if (this._activeCutAlongX) {
        a = new T.Vector3(box.min.x - 0.05, yBot, coord);
        b = new T.Vector3(box.max.x + 0.05, yBot, coord);
      } else {
        a = new T.Vector3(coord, yBot, box.min.z - 0.05);
        b = new T.Vector3(coord, yBot, box.max.z + 0.05);
      }
      var top = a.clone(); top.y = yTop;
      var top2 = b.clone(); top2.y = yTop;
      var lineGeo = new T.BufferGeometry().setFromPoints([a, b, top2, top, a]);
      var lineMat = new T.LineBasicMaterial({ color: 0xd2a878, linewidth: 2 });
      grp.add(new T.Line(lineGeo, lineMat));

      /* Invisible, raycastable quad covering the whole cut plane so the
         user can grab the slice ANYWHERE on it (no separate drag point).
         Generous margin so it's easy to hit. */
      var spanW = (box.max.x - box.min.x) + 0.4;
      var spanH = (box.max.y - box.min.y) + 0.4;
      var hitGeo = new T.PlaneGeometry(spanW, spanH);
      var hitMat = new T.MeshBasicMaterial({ visible: false, side: T.DoubleSide, depthWrite: false });
      var hitMesh = new T.Mesh(hitGeo, hitMat);
      hitMesh.userData.assetType = 'section-cut-aux';
      hitMesh.userData.cutHit = true;
      var midY = (box.min.y + box.max.y) / 2;
      if (this._activeCutAlongX) {
        hitMesh.position.set((box.min.x + box.max.x) / 2, midY, coord);
      } else {
        hitMesh.rotation.y = Math.PI / 2;
        hitMesh.position.set(coord, midY, (box.min.z + box.max.z) / 2);
      }
      grp.add(hitMesh);
      this._hitMesh = hitMesh;

      eng.benchGroup.add(grp);
      this._outlineGroup = grp;
    },

    /* Stencil-buffer solid caps, per source material — identical
       technique to the foundations cut. Solid bodies = all bench meshes
       except the person and aux geometry; each material group gets its
       own coloured cap drawn on the cut plane. */
    addCaps: function (plane, eng) {
      var T = global.THREE;
      if (!T || !plane || !eng || !this._activeBox) return;
      var box = this._activeBox;

      var grp = new T.Group();
      grp.userData.assetType = 'section-cut-aux';

      var CAP_BRIGHTNESS = 0.7;
      var groups = {};
      var self = this;
      function isScrew(pt) { return pt && pt.indexOf('screw-') === 0; }
      eng.benchGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        if (self._isAux(node)) return;
        if (!node.visible) return;
        var pt = node.userData && node.userData.partType;
        if (self._isPerson(node)) return;
        if (pt === 'pocket-marker') return;
        /* Only SOLID lumber gets a stencil cap. Screws + edge-line helpers
           are skipped — capping every tiny mesh ballooned the pass to
           hundreds of geometry clones and froze the tab during slider
           drags. Screws still read fine as plain clipped geometry. */
        if (isScrew(pt)) return;
        if (node.userData && node.userData.isEdgeLine) return;
        var mats = Array.isArray(node.material) ? node.material : [node.material];
        for (var mi = 0; mi < mats.length; mi++) {
          var m = mats[mi];
          if (!m || !m.color) continue;
          var key = m.uuid;
          if (!groups[key]) {
            groups[key] = { color: m.color.clone().multiplyScalar(CAP_BRIGHTNESS), meshes: [] };
          }
          groups[key].meshes.push(node);
        }
      });

      var groupKeys = Object.keys(groups);
      _dbg('[cut] addCaps: ' + groupKeys.length + ' material groups, ' +
           groupKeys.reduce(function (a, k) { return a + groups[k].meshes.length; }, 0) + ' solid meshes');

      var capH = Math.max(box.max.y - box.min.y, 0.1) + 0.5;
      var capW = (this._activeCutAlongX ? (box.max.x - box.min.x) : (box.max.z - box.min.z)) + 0.5;
      var capCenterX = this._activeCutAlongX ? (box.min.x + box.max.x) / 2 : this._activeOffset;
      var capCenterZ = this._activeCutAlongX ? this._activeOffset : (box.min.z + box.max.z) / 2;
      var capY = (box.min.y + box.max.y) / 2;
      var self = this;

      function makeStencilMat(faceSide, op) {
        return new T.MeshBasicMaterial({
          side: faceSide,
          clippingPlanes: [plane],
          colorWrite: false,
          depthWrite: false,
          depthTest: true,
          stencilWrite: true,
          stencilFunc: T.AlwaysStencilFunc,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFail: T.KeepStencilOp,
          stencilZFail: op,
          stencilZPass: op
        });
      }

      function buildCapMesh(color, renderOrder) {
        var capMat = new T.MeshBasicMaterial({
          color: color,
          side: T.DoubleSide,
          clippingPlanes: null,
          stencilWrite: true,
          stencilRef: 0,
          stencilMask: 0xff,
          stencilFunc: T.NotEqualStencilFunc,
          stencilFail: T.ZeroStencilOp,
          stencilZFail: T.ZeroStencilOp,
          stencilZPass: T.ZeroStencilOp
        });
        var capGeo = new T.PlaneGeometry(capW, capH);
        var cap = new T.Mesh(capGeo, capMat);
        cap.renderOrder = renderOrder;
        if (self._activeCutAlongX) {
          cap.position.set(capCenterX, capY, self._activeOffset);
        } else {
          cap.rotation.y = Math.PI / 2;
          cap.position.set(self._activeOffset, capY, capCenterZ);
        }
        return cap;
      }

      for (var gi = 0; gi < groupKeys.length; gi++) {
        var g = groups[groupKeys[gi]];
        var baseRO = 10 + gi * 10;
        var matBack  = makeStencilMat(T.BackSide,  T.IncrementWrapStencilOp);
        var matFront = makeStencilMat(T.FrontSide, T.DecrementWrapStencilOp);
        for (var i = 0; i < g.meshes.length; i++) {
          var src = g.meshes[i];
          src.updateMatrixWorld(true);
          var geom = src.geometry.clone();
          geom.applyMatrix4(src.matrixWorld);
          var mB = new T.Mesh(geom, matBack);
          var mF = new T.Mesh(geom, matFront);
          mB.renderOrder = baseRO;
          mF.renderOrder = baseRO + 1;
          grp.add(mB);
          grp.add(mF);
        }
        grp.add(buildCapMesh(g.color, baseRO + 2));
      }

      eng.benchGroup.add(grp);
      if (this._capsGroup) {
        eng.benchGroup.remove(this._capsGroup);
        this._disposeGroup(this._capsGroup);
      }
      this._capsGroup = grp;
    },

    /* Re-run the pipeline for the current state. Called from
       applyVizStage / after build so the cut survives edits. */
    refresh: function () {
      var eng = global.BenchEngine;
      _dbg('[cut] refresh: vizStage=' + STATE.vizStage + ' view=' + STATE.view + ' eng=' + !!eng);
      if (!eng) { _dbg('[cut] no engine, abort'); return; }
      /* Safety net: ensure local clipping is on (init order / renderer
         re-creation could otherwise leave it off, which silently disables
         material.clippingPlanes). */
      if (eng.renderer && !eng.renderer.localClippingEnabled) {
        eng.renderer.localClippingEnabled = true;
        _dbg('[cut] localClippingEnabled was FALSE → forced true');
      }
      _dbg('[cut] localClippingEnabled=' + (eng.renderer ? eng.renderer.localClippingEnabled : 'no-renderer'));
      var inSection = (STATE.vizStage === 4 && STATE.view === '3d');
      if (!inSection && _benchCutOn()) { try { _benchCut.apply(); } catch (eK) {} return; }   /* v369 the playhouses' section tool owns the planes */
      if (!inSection) { _dbg('[cut] not in section mode → clear'); this.clear(); return; }
      var plane = this.compute(eng);
      if (!plane) { _dbg('[cut] compute returned NULL → clear (no bbox? THREE missing?)'); this.clear(); return; }
      _dbg('[cut] plane normal=(' + plane.normal.x + ',' + plane.normal.y + ',' + plane.normal.z +
           ') constant=' + plane.constant.toFixed(3) + ' offset=' + this._activeOffset.toFixed(3) +
           ' cutAlongX=' + this._activeCutAlongX);
      var matCount = this.apply(plane);
      _dbg('[cut] applied clipping to ' + matCount + ' materials');
      this.addCaps(plane, eng);
      this.addOutline(plane, eng);
      _dbg('[cut] done — caps=' + (this._capsGroup ? this._capsGroup.children.length : 0) +
           ' outline=' + (this._outlineGroup ? 'yes' : 'no'));
    }
  };

  /* ----------------------------------------------------------
     RENDERER  (rebuilds bench mesh from STATE)
     ---------------------------------------------------------- */
  global.BenchRenderer = {
    materials: null,

    _ensureMaterials: function () {
      if (this.materials) return;
      var T = global.THREE;
      this.materials = {
        /* 2×4 lumber (KVH10060) — posts, bottom frame, top rails, rafters: warm tan */
        lumber:  new T.MeshStandardMaterial({ color: 0xf6ead2, roughness: 0.85, emissive: 0xf6ead2, emissiveIntensity: 0.38 }),   /* birch, the default scheme */
        /* Mattress / seat cushion — sandy beige, matte fabric look (no texture) */
        fabric:  new T.MeshStandardMaterial({ color: 0xd2bd97, roughness: 0.97, metalness: 0.0 }),
        /* Wooden joinery dowel — pale natural wood, matte */
        dowel:   new T.MeshStandardMaterial({ color: 0xd8c39a, roughness: 0.9, metalness: 0.0 }),
        dowelHole: new T.MeshStandardMaterial({ color: 0x2a2118, roughness: 1.0, metalness: 0.0 }),
        /* Two throw-pillow fabrics (colours set per colour-stage) */
        pillowA: new T.MeshStandardMaterial({ color: 0xb5896b, roughness: 0.95, metalness: 0.0 }),
        pillowB: new T.MeshStandardMaterial({ color: 0x97a07a, roughness: 0.95, metalness: 0.0 }),
        /* Screw fasteners */
        screwHead:    new T.MeshStandardMaterial({ color: 0x333333, roughness: 0.4, metalness: 0.85 }),
        screwCap:     new T.MeshStandardMaterial({ color: 0x222222, roughness: 0.7, metalness: 0.05 }),
        /* Pocket-hole entry marker — same orange as the park bench */
        pocketMarker: new T.MeshStandardMaterial({
          color: 0xff7733, roughness: 0.45, metalness: 0.0,
          emissive: 0xff7733, emissiveIntensity: 0.45
        }),
        /* Edge line material — slightly darker than wood */
        edge:    new T.LineBasicMaterial({ color: 0x4a3320, linewidth: 1, transparent: true, opacity: 0.55 }),
        /* Swing hardware (chain, hangers, eye bolts, bolt heads): galvanised steel */
        metal:   new T.MeshStandardMaterial({ color: 0x8a8f94, roughness: 0.35, metalness: 0.9 }),
        /* Swing roof: OSB deck and two shades of asphalt shingle */
        osb:      new T.MeshStandardMaterial({ color: 0xcfae78, roughness: 0.9 }),
        shingleA: new T.MeshStandardMaterial({ color: 0x45474b, roughness: 0.95 }),
        shingleB: new T.MeshStandardMaterial({ color: 0x3b3d40, roughness: 0.95 }),
        /* context that is not part of the build (the porch swing's beam): pale see-through grey */
        context:  new T.MeshStandardMaterial({ color: 0x9ea3a8, roughness: 0.9, transparent: true, opacity: 0.35, depthWrite: false }),
        /* planter bench: the dimpled foil lining and the soil */
        foil:     new T.MeshStandardMaterial({ color: 0x2e2f31, roughness: 0.8 }),
        soil:     new T.MeshStandardMaterial({ color: 0x4a3526, roughness: 1.0 })
      };
    },

    /* Attach edge-highlight lines as a child of a mesh (auto-inherits its transform). */
    _addEdges: function (mesh, thresholdDeg) {
      var T = global.THREE;
      try {
        var edgesGeom = new T.EdgesGeometry(mesh.geometry, thresholdDeg || 25);
        var edges = new T.LineSegments(edgesGeom, this.materials.edge);
        edges.userData.isEdgeLine = true;
        mesh.add(edges);
      } catch (e) { /* ignore */ }
      return mesh;
    },

    /* Wood screw 6 × 60 mm — pan head + tapered shaft.
       Built as a Group, axis along Y by default (head at +Y, tip at -Y).
       Use opts.rotZ for rotation around Z (e.g., screw entering along X).
       (x,y,z) = position of the HEAD center. */
    _mkScrew: function (x, y, z, opts) {
      var T = global.THREE;
      opts = opts || {};
      var headR = opts.headRadius || 0.0050;     /* 10mm dia */
      var headH = opts.headHeight || 0.0025;     /* 2.5mm tall */
      var shaftR = opts.shaftRadius || 0.0026;   /* 5mm dia */
      var shaftL = opts.shaftLen   || 0.040;     /* 40mm visible shaft */
      var tipR   = shaftR * 0.15;

      var g = new T.Group();

      /* HEAD — pan head: short cylinder, slight taper for visual */
      var headGeo = new T.CylinderGeometry(headR, headR * 0.95, headH, 16);
      var head = new T.Mesh(headGeo, this.materials.screwHead);
      head.position.y = 0;
      g.add(head);

      /* SHAFT — long cylinder tapering to tip */
      var shaftGeo = new T.CylinderGeometry(shaftR, tipR, shaftL, 10);
      var shaft = new T.Mesh(shaftGeo, this.materials.screwHead);
      shaft.position.y = -(headH/2 + shaftL/2);
      g.add(shaft);

      g.position.set(x, y, z);
      if (opts.rotX) g.rotation.x = opts.rotX;
      if (opts.rotZ) g.rotation.z = opts.rotZ;
      if (opts.rotY) g.rotation.y = opts.rotY;
      return g;
    },

    /* Corrugated-roof screw — heavy-duty with EPDM cap, hex head, pointed shaft.
       Axis along Y (cap up, shaft down). Use tilt = rotation.z to match roof slope.
       (x,y,z) = position of the CAP TOP center. */
    _mkRoofScrew: function (x, y, z, tilt) {
      var T = global.THREE;
      var capR  = 0.009;     /* 18mm dia rubber EPDM cap */
      var capH  = 0.004;     /* 4mm tall */
      var hexR  = 0.005;     /* 10mm hex head */
      var hexH  = 0.0045;    /* 4.5mm tall */
      var shaftR = 0.0030;   /* 6mm dia */
      var shaftL = 0.025;    /* 25mm visible (rest is in the wood) */
      var tipR   = shaftR * 0.2;

      var g = new T.Group();

      /* EPDM cap: domed top (low metalness, black rubber look) */
      var capGeo = new T.CylinderGeometry(capR * 0.85, capR, capH, 14);
      var cap = new T.Mesh(capGeo, this.materials.screwCap);
      cap.position.y = 0;
      g.add(cap);

      /* HEX head: 6-sided cylinder approximation */
      var hexGeo = new T.CylinderGeometry(hexR, hexR, hexH, 6);
      var hex = new T.Mesh(hexGeo, this.materials.screwHead);
      hex.position.y = -(capH/2 + hexH/2);
      g.add(hex);

      /* Shaft with pointed tip */
      var shaftGeo = new T.CylinderGeometry(shaftR, tipR, shaftL, 10);
      var shaft = new T.Mesh(shaftGeo, this.materials.screwHead);
      shaft.position.y = -(capH/2 + hexH + shaftL/2);
      g.add(shaft);

      g.position.set(x, y, z);
      if (tilt) g.rotation.z = tilt;
      return g;
    },

    _mkBox: function (w, h, d, mat, x, y, z) {
      var T = global.THREE;
      var m = new T.Mesh(new T.BoxGeometry(w, h, d), mat);
      m.position.set(x, y, z);
      return m;
    },

    /* A classic rectangular throw pillow (w × h face, t thick) with softly
       rounded corners and puffed edges — plump but clearly rectangular.
       Oriented: width w → Z, height h → Y, thickness t → X. */
    _mkPillow: function (w, h, t, mat, seed) {
      /* v263 (Marek: the pillows more natural): a sewn, stuffed throw
         pillow -- two faces meeting in the seam all round, plump in the
         middle and thin at the edges, the edges drawn in between the
         corners (the "dog ears" stand out), the back face a little flatter,
         a soft sag forward, flattened where it sits and a faint lumpiness
         (seeded, so every pillow differs but stays the same between
         rebuilds). Width w along Z, height h along Y, thickness t along X
         (+X = the front); centred on the origin. */
      var T = global.THREE, N = 22, i, j, sd = (typeof seed === 'number') ? seed : 0.37;
      var pos = [], uv = [], idx = [];
      for (var side = 0; side < 2; side++) {
        var sg = side ? -1 : 1, base = pos.length / 3;
        for (j = 0; j <= N; j++) for (i = 0; i <= N; i++) {
          var u = -1 + 2 * i / N, v = -1 + 2 * j / N;
          var z = (w / 2) * u * (1 - 0.10 * (1 - v * v));
          var y = (h / 2) * v * (1 - 0.10 * (1 - u * u));
          var f = Math.pow(Math.max(0, (1 - u * u) * (1 - v * v)), 0.42);
          var lump = 1 + 0.07 * Math.sin(3.1 * u + 5.3 * sd) * Math.sin(2.3 * v + 2.9 * sd) + 0.04 * Math.sin(5.7 * u * v + sd * 11.0);
          var sq = (v < -0.55) ? (1 - 0.38 * Math.min(1, (-0.55 - v) / 0.45)) : 1;   /* flatter where it sits */
          var x = sg * (t / 2) * f * lump * sq * (side ? 0.82 : 1) + 0.025 * t * 4 * (1 - v * v) * f;   /* + the sag forward */
          pos.push(x, y, z);
          uv.push(side ? 1 - (u + 1) / 2 : (u + 1) / 2, (v + 1) / 2);
        }
        for (j = 0; j < N; j++) for (i = 0; i < N; i++) {
          var a = base + j * (N + 1) + i, b = a + 1, d = a + (N + 1), c = d + 1;
          if (!side) idx.push(a, c, b, a, d, c);
          else       idx.push(a, b, c, a, c, d);
        }
      }
      var geo = new T.BufferGeometry();
      geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
      geo.setAttribute('uv', new T.Float32BufferAttribute(uv, 2));
      geo.setIndex(idx);
      geo.computeVertexNormals();
      return new T.Mesh(geo, mat || this.materials.pillowA);
    },

    /* v263: throw pillows against a back, for any type (x = depth, front +,
       the back behind at -x, z = length). rig: n, z0..z1 (the run), seatY
       (what they sit on), backX (the back's face at the seat), beta (the
       back's tilt from vertical, rad), w / h / t, tag. Up to ~50 deg they
       lean on the back a little more reclined than it, their foot forward
       on the seat; flatter backs (lounge, bed) they lie on. Built view
       only (step 0); decor, not billed. */
    _addPillows: function (rig) {
      var T = global.THREE, mats = this.materials, self = this, k;
      var n = Math.max(1, rig.n | 0), w = rig.w || 0.45, h = rig.h || 0.45, t = rig.t || 0.17, beta = rig.beta || 0;
      function rnd(q) { var x = Math.sin(q * 127.1 + (rig.tag || '').length * 13.7 + 3.1) * 43758.5453; return x - Math.floor(x); }
      for (k = 0; k < n; k++) {
        var r1 = rnd(k * 2 + 1), r2 = rnd(k * 2 + 2), r3 = rnd(k * 3 + 5);
        var zc = rig.z0 + (rig.z1 - rig.z0) * (k + 0.5) / n + (r1 - 0.5) * Math.min(0.10, (rig.z1 - rig.z0) / n * 0.25);
        var th, cx, cy;
        if (beta < 0.87) {
          th = beta + 0.10 + r2 * 0.14;                                     /* a little more reclined than the back */
          var q = h * Math.cos(th) / Math.cos(beta), bx = rig.backX - q * Math.sin(beta) + h * Math.sin(th);
          cx = bx - (h / 2) * Math.sin(th) + (t * 0.32) * Math.cos(th);
          cy = rig.seatY + (h / 2) * Math.cos(th) + (t * 0.32) * Math.sin(th) - 0.012;
        } else {
          th = beta + (r2 - 0.5) * 0.06;                                    /* lying on the back / the bed */
          cx = rig.backX - (h / 2 + 0.03) * Math.sin(beta) + (t * 0.36) * Math.cos(beta);
          cy = rig.seatY + (h / 2 + 0.03) * Math.cos(beta) + (t * 0.36) * Math.sin(beta) - 0.010;
        }
        var pil = self._mkPillow(w, h, t, (k % 2 === 0) ? mats.pillowA : mats.pillowB, r3 * 7 + k);
        pil.position.set(cx, cy, zc);
        pil.quaternion.setFromEuler(new T.Euler(0, (r3 - 0.5) * 0.22, th, 'YXZ'));
        self._addToScene(pil, 'pillow', { boqCode: null, idHint: 'pillow-' + (rig.tag || '') + (k + 1) });
      }
    },

    /* A soft cushion: rounded rectangle (w × d footprint) extruded to
       thickness h, with bevelled top/bottom edges → rounded corners + a
       pillowy look. Centred at the origin; thickness runs along Y. */
    _mkCushion: function (w, d, h, mat) {
      var T = global.THREE;
      var r = Math.min(0.06, Math.min(w, d) * 0.18);   /* plan corner radius */
      var bevel = Math.min(0.018, h * 0.35);            /* edge softening */
      var hw = w / 2, hd = d / 2;
      var s = new T.Shape();
      s.moveTo(-hw + r, -hd);
      s.lineTo(hw - r, -hd);
      s.quadraticCurveTo(hw, -hd, hw, -hd + r);
      s.lineTo(hw, hd - r);
      s.quadraticCurveTo(hw, hd, hw - r, hd);
      s.lineTo(-hw + r, hd);
      s.quadraticCurveTo(-hw, hd, -hw, hd - r);
      s.lineTo(-hw, -hd + r);
      s.quadraticCurveTo(-hw, -hd, -hw + r, -hd);
      var geo = new T.ExtrudeGeometry(s, {
        depth: Math.max(0.001, h - 2 * bevel),
        bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel,
        bevelSegments: 3, steps: 1, curveSegments: 8
      });
      geo.center();                 /* centre on all axes */
      geo.rotateX(-Math.PI / 2);    /* stand it up: thickness along Y */
      /* Guarantee the footprint maps w→X (depth) and d→Z (length),
         regardless of the extrude/rotate axis convention. */
      geo.computeBoundingBox();
      var bb = geo.boundingBox;
      var xs = bb.max.x - bb.min.x, zs = bb.max.z - bb.min.z;
      if (Math.abs(xs - w) > Math.abs(xs - d)) { geo.rotateY(Math.PI / 2); }
      return new T.Mesh(geo, mat || this.materials.fabric);
    },

    _mkAngledCornerPost: function (w, h, t, mat, x, y, z, rake, extraDrop) {
      var T = global.THREE;
      if (!rake) return this._mkBox(w, h, t, mat, x, y, z);
      var baselineDrop = (typeof extraDrop === 'number') ? extraDrop : t * (1 / Math.cos(rake) - 1);
      var shape = new T.Shape();
      shape.moveTo(-w / 2,  h / 2);
      shape.lineTo( w / 2,  h / 2);
      shape.lineTo( w / 2, -h / 2 - baselineDrop);
      shape.lineTo(-w / 2, -h / 2 - baselineDrop + w * Math.tan(rake));
      shape.closePath();
      var geom = new T.ExtrudeGeometry(shape, { depth: t, bevelEnabled: false });
      geom.translate(0, 0, -t / 2);
      var m = new T.Mesh(geom, mat);
      m.position.set(x, y, z);
      return m;
    },

    /* Tag a mesh with a part type for assembly-step visibility & explode logic. */
    _tag: function (mesh, partType) {
      mesh.userData.partType = partType;
      /* Save initial position for explode/restore */
      mesh.userData.basePos = mesh.position.clone();
      return mesh;
    },

    /* ----------------------------------------------------------
       BUILD — variant dispatcher. Each variant has its own builder
       function; only variant 1 (2x4 Park Bench) is fully implemented
       in this drop. Variants 2..6 render a placeholder bay so the
       UI stays functional during incremental rollout.
       ---------------------------------------------------------- */
    build: function () {
      var eng = global.BenchEngine;
      if (!eng || !eng.benchGroup) return;
      this._ensureMaterials();

      /* Wipe previous scene + instance registry. bench-v349: every removed
         part disposed DOWN TO ITS LAST CHILD (the edge lines and the parts
         inside a group stayed on the GPU before -- ~120 a rebuild on the
         raised bed, a rebuild a frame while dragging); the shared materials
         are kept (disposing them would recompile the shaders every build) */
      while (eng.benchGroup.children.length) {
        var c = eng.benchGroup.children.pop();
        c.parent = null;
        try {
          c.traverse(function (n) {
            if (n.geometry && n.geometry.dispose) n.geometry.dispose();
            if (n.isInstancedMesh && n.dispose) { try { n.dispose(); } catch (eI) {} }
          });
        } catch (eD) { if (c.geometry) c.geometry.dispose(); }
      }
      if (global.BenchInstances && global.BenchInstances.clear) {
        global.BenchInstances.clear();
      }
      if (global.BenchHighlight && global.BenchHighlight._reset) {
        global.BenchHighlight._reset();
      }
      if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.isOpen &&
          global.ConfiguratorAssetDrawer.isOpen()) {
        global.ConfiguratorAssetDrawer.close();
      }

      var v = (STATE.variant | 0) || 1;
      switch (v) {
        case 1: this._buildParkBench();      break;
        case 2:
          if (STATE.vizStage === 5 && STATE.view === '3d') this._buildSofaAssembly();
          else                                             this._buildSofa();
          break;
        case 3: this._buildWaveBench();      break;
        case 4: this._buildSwing();          break;
        case 5: this._buildPicnic();         break;
        case 6: this._buildBlockBench();     break;
        case 7: this._buildPorch();          break;
        case 8: this._buildSwing();          break;
        case 9: this._buildAdi();            break;
        case 10: this._buildPlanter();       break;
        case 11: this._buildTree();          break;
        case 12: this._buildStorage();       break;
        case 13: this._buildKids();          break;
        case 14: this._buildBed();           break;
        case 15: this._buildGluedBench();    break;   /* v284 */
        case 54: this._buildRotBench();      break;   /* v414 the twist bench */
        case 16: this._buildSunbed();        break;   /* v288 */
        case 17: this._buildPergola();       break;   /* v296 */
        case 18: this._buildModernSwing();   break;   /* v301 */
        case 19: this._buildGarden();        break;   /* v303 */
        case 20: this._buildRaisedBed();     break;   /* v314 */
        case 21: this._buildFloatingBed();   break;   /* v318 */
        case 22: this._buildArbor();         break;   /* v320 */
        case 23: this._buildGazebo();        break;   /* v328 */
        case 24: this._buildGardenPergola(); break;   /* v334 (the pergola swing has _buildPergola) */
        case 25: this._buildManCaveBar();    break;
        case 26: case 27: case 28: case 29: case 30: case 31: case 32: case 34: case 37: case 39: case 41: case 42: case 44: case CS_TYPE: case 46: case 47: case 48: case 49: case 52: case 51: this._buildPlayhouse(); break;   /* v403 + the modern dog house */   /* v392 + the kennel with run */   /* v388 + the insulated dog house */   /* v379 + the chicken tractor */   /* v375 + the backyard coop */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 */   /* v355 */
        case 33: case 36: case 38: case 40: case 43: case 45: this._buildGreenhouse(); break;   /* v373; v378 + the lean-to; v381 + the hoop house */
        case 35: case 53: this._buildKitchenPod(); break;   /* v376 (v407 + 53) */
        default:
          if (v >= 7) this._buildPlaceholder(VARIANT_KEYS[v - 1] || 'bench');
          else this._buildParkBench();
      }

      this._syncHeightFromGeometry();

      /* Scale figure — attach ONCE here, centrally, so every variant
         (park bench, sofa, and future builds) gets the person without its
         own code. Shared module lives in Configurator.person. */
      if (global.Configurator && global.Configurator.person && global.Configurator.person.attach) {
        global.Configurator.person.attach();
      }

      if (global.BenchDimensions && global.BenchDimensions.refresh) {
        global.BenchDimensions.refresh();
      }
      this._applyAssemblyStep(eng.benchGroup, STATE.assemblyStep | 0);

      /* Re-apply viz stage AFTER build so person visibility + material
         opacities pick up current STATE.bodyVisible and stage rules.
         Without this, toggling the body off doesn't hide the freshly
         re-created person mesh (build re-spawns it every time). */
      if (global.BenchEngine && global.BenchEngine.applyVizStage) {
        global.BenchEngine.applyVizStage();
      }
    },

    /* Total H is derived from variant geometry. Updates STATE.H so the
       dimensions overlay + person scaling stay correct. */
    _syncHeightFromGeometry: function () {
      /* Mirrors _buildParkBench post-height math:
           seatY + (hasBack ? backH + w/2 : w/2)
         Children level scales w + seatY + backH proportionally. */
      var v = (STATE.variant | 0) || 1;
      var prof = _lumber(STATE);
      var t = prof.t;
      var w = prof.w;
      var seatTopTarget = prof.seatTop;
      var seatY = seatTopTarget - w / 2;
      var backH = (STATE.lvl === 2)
        ? Math.min(0.40, STATE.backH)
        : (STATE.backH || 0.55);
      var hasBack = (STATE.backrestVisible !== false);
      if (v === 1) {
        /* Top rails are always present; total bench height = top
           face of the top rail = seatY + backH + t/2. */
        STATE.H = seatY + backH + t / 2;
      } else if (v === 2) {
        /* Sofa: overall height = top of the arms. Honour the user/H value
           if set, else fall back to the sofa default. */
        STATE.H = STATE.H || SOFA.ARM_TOP;
      } else if (v === 3) {
        /* Wave bench: height = highest contour point (+ slat thickness).
           Depth is fixed by the profile. */
        var wgS = _waveLayout(STATE);
        STATE.H = wgS.height;
        STATE.W = wgS.depth;
      } else if (v === 4 || v === 8) {
        /* Hollywood / A-frame swing: H = beam top, W = stand depth at the feet. */
        var sg = _standLayout(STATE);
        STATE.H = sg.height;
        STATE.W = sg.depth;
      } else if (v === 5) {
        /* Picnic set: H = table top, W = the seat braces' length. */
        var pg = _picnicLayout(STATE);
        STATE.H = pg.height;
        STATE.W = pg.width;
      } else if (v === 6) {
        /* Block bench: H = the blocks (or the back block), W = a block's length */
        var bg6 = _blockLayout(STATE);
        STATE.H = bg6.height;
        STATE.W = bg6.depth;
      } else if (v === 13) {
        /* Kids' swing set: H = the leg tops, W = the stand's foot depth */
        var kg = _kidsLayout(STATE);
        STATE.H = kg.height;
        STATE.W = kg.depth;
      } else if (v === 12) {
        /* Storage bench: H = the lid (or the back), W = the depth */
        var sg2 = _storageLayout(STATE);
        STATE.H = sg2.height;
        STATE.W = sg2.depth;
      } else if (v === 11) {
        /* Tree bench: H = the seat (or the back), W = across the outer flats / corners in x */
        var tg = _treeLayout(STATE);
        STATE.H = tg.height;
        STATE.W = tg.depth;
      } else if (v === 10) {
        /* Planter bench: H = the planters' (or the back's) top, W = the depth */
        var plg = _planterLayout(STATE);
        STATE.H = plg.height;
        STATE.W = plg.depth;
      } else if (v === 9) {
        /* Adirondack: H = the back's top, W = front of the arms to the back */
        var ag = _adiLayout(STATE);
        STATE.H = ag.height;
        STATE.W = ag.depth;
      } else if (v === 7) {
        /* Porch swing: H = the beam underside (the hanging height), W =
           the seat + back depth for the back's tilt. */
        var ph = _porchAny(STATE);
        STATE.H = ph.H;
        STATE.W = ph.depth;
      } else if (v === 17) {
        /* v296 the pergola swing: L = the seat (the handle), W = the rafters,
           H = the rafters' top */
        var pgD = _pgLayout(STATE);
        STATE.L = pgD.L;
        STATE.W = pgD.depth;
        STATE.H = pgD.height;
      } else if (v === 18) {
        /* v301 the modern swing: L = the seat (the handle), W = the three
           portals' depth, H = the beams' top */
        var mfD = _mfLayout(STATE);
        STATE.L = mfD.L;
        STATE.W = mfD.depth;
        STATE.H = mfD.height;
      } else if (v === 19) {
        /* v303 the cinema bar: L = the beams, W = the rafters' tails, H = the rafters' top */
        var gsD = _gsLayout(STATE);
        STATE.L = gsD.L;
        STATE.W = gsD.depth;
        STATE.H = gsD.height;
      } else if (v === 20) {
        /* v314 the raised bed: L / W = the walls, H = its top (the cap, the top tier, the ridge) */
        var rbD = _rbLayout(STATE);
        STATE.L = rbD.L;
        STATE.W = rbD.W;
        STATE.H = rbD.height;
      } else if (v === 21) {
        /* v318 the floating bed: L = the wall laths' back to the foot panel, W = the headboard, H = its top */
        var fbD = _fbLayout(STATE);
        STATE.L = fbD.L;
        STATE.W = fbD.W;
        STATE.H = fbD.height;
      } else if (v === 22) {
        /* v320 the garden arbor: L / W = the posts' outer faces, H = the roof's top */
        var gaD = _gaLayout(STATE);
        STATE.L = gaD.L;
        STATE.W = gaD.W;
        STATE.H = gaD.height;
      } else if (v === 23) {
        /* v328 the gazebo: L = the width across the flats (along Z), W = its X extent, H = the roof's top */
        var gzD = _gzLayout(STATE);
        STATE.L = gzD.S;
        STATE.W = gzD.W;
        STATE.H = gzD.height;
      } else if (v === 24) {
        /* v334 the pergola: L / W = the posts' outer faces, H = the roof's top */
        var peD = _peLayout(STATE);
        STATE.L = peD.L;
        STATE.W = peD.W;
        STATE.H = peD.height;
      } else if (_isGhType(v)) {
        /* v373 the gable greenhouse: L / W = the base, H = the roof's top */
        var ghD = _ghLayout(STATE);
        STATE.L = ghD.L;
        STATE.W = ghD.W;
        STATE.H = ghD.height;
      } else if (_isKpType(v)) {
        /* v376 the kitchen pod: L / W = the framing, H = the roof's top */
        var kpD = _kpLayout(STATE);
        STATE.L = kpD.L;
        STATE.W = kpD.D;
        STATE.H = kpD.height;
      } else if (_isPhType(v)) {   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */
        /* v362 the cottage: L = the house (the porch apart), W = its width, H = the roof's top */
        var phD = _phAnyLayout(STATE);
        STATE.L = phD.L;
        STATE.W = phD.W;
        STATE.H = phD.height;
      } else if (v === 25) {
        /* v355 the bar: L = the purlins, W = the slab / the beams across, H = the roof's front edge */
        var mbD = _mbLayout(STATE);
        STATE.L = mbD.L;
        STATE.W = mbD.depth;
        STATE.H = mbD.height;
      } else if (v === 54) {
        /* v414 the twist bench: L = the slats' stack, W = its depth (armrests / tables reach out), H = the back's top */
        var rtbD = _rtbLayout(STATE);
        STATE.L = rtbD.L;
        STATE.W = rtbD.depth;
        STATE.H = rtbD.height;
      } else if (v === 15) {
        /* v284 the 2x4 bench: H = the seat's top, W = its depth (both fixed) */
        var gbS = _gbLayout(STATE);
        STATE.H = gbS.height;
        STATE.W = gbS.depth;
      } else if (v === 16) {
        /* v288 the sunbed: L / W = the frame, H = the backrest's head (or the frame) */
        var sbS = _sbLayout(STATE);
        STATE.L = sbS.L;
        STATE.W = sbS.W;
        STATE.H = sbS.height;
      } else if (v === 14) {
        /* v273 the bed: L / W = the frame over the mattress, H = the headboard (or the rails) */
        var bdS = _bedLayout(STATE);
        STATE.L = bdS.L;
        STATE.W = bdS.W;
        STATE.H = bdS.top;
      } else {
        STATE.H = seatY + 0.5;
      }
      /* STATE.W is user-controlled via the W drag handle now;
         level toggle handles its own snap (see cycleLvl). */
    },

    /* Tagged-add helper (closure-free version of rack's pattern). */
    _addToScene: function (mesh, partType, opts) {
      var eng = global.BenchEngine;
      this._tag(mesh, partType);
      if (opts && opts.boqCode) mesh.userData.boqCode = opts.boqCode;
      if (opts && opts.idHint)  mesh.userData.idHint  = opts.idHint;
      /* Edge lines on wood parts for visual definition. */
      if (partType !== 'pocket-hole' && partType !== 'lag-screw' && partType !== 'screw' &&
          partType !== 'screw-deck' && partType !== 'screw-pocket' && partType !== 'screw-lag' &&
          partType !== 'cushion' && partType !== 'pillow' && partType !== 'dowel' && partType !== 'dowel-hole' && partType !== 'bed-mattress' &&
          String(partType).indexOf('-hw-') < 0 && String(partType).indexOf('swing-hw') !== 0 && String(partType).indexOf('porch-hw') !== 0 && String(partType).indexOf('adi-hw') !== 0 && String(partType).indexOf('tree-hw') !== 0 && String(partType).indexOf('store-hw') !== 0 && partType !== 'porch-context' && partType !== 'ph-tree' && partType !== 'planter-liner' && partType !== 'planter-soil' && partType !== 'rb-soil' && partType !== 'rb-geo') {
        this._addEdges(mesh);
      }
      eng.benchGroup.add(mesh);
      /* Register as a selectable instance if BoQ-mapped. */
      if (global.BenchInstances && opts && opts.boqCode) {
        var id = global.BenchInstances.nextId(partType, opts.idHint);
        global.BenchInstances.add({
          id: id, partType: partType, boqCode: opts.boqCode,
          length: (typeof opts.length === 'number') ? opts.length : null,
          dimensions: opts.dimensions || null,
          position: { x: mesh.position.x, y: mesh.position.y, z: mesh.position.z },
          mesh: mesh
        });
      }
      return mesh;
    },

    /* ----------------------------------------------------------
       VARIANT 1 — 2x4 Park Bench (Modern Easy Plans).
       Geometry per the cut list:
         4 corner posts 4x4 x 597 mm
         seat frame: 2x front+back rails (L - 2*post), 2x side rails (W - 2*post),
                     N cross joists (auto from L)
         8 seat planks 2x4 spanning L, flat orientation
         backrest frame on rear side, tilted by STATE.backRakeDeg
         2 armrests over front+back post pairs
       Pocket-hole + lag markers are added in assembly step >= 1.
       ---------------------------------------------------------- */
    /* ----------------------------------------------------------
       VARIANT 1 — Park Bench (frame-only skeleton, variant A).
       Geometry:
         - 4 corner posts (4x4 profile, full height)
         - 2 seat-height rails (2x4 along Z): front (+W/2) and back (-W/2),
           span between the corner posts. These define seat level — boards
           added later by the user or implied; not modelled in this variant.
         - 2 backrest-height rails (2x4 along Z): same two sides, at
           backrest top level. Tilted by STATE.backRakeDeg via a Group.
       Optional via STATE.backrestVisible: the upper pair of rails + the
       additional post extension above seat level is skipped when off.
       Pocket-hole + lag markers are added in assembly step >= 1.

       Coord convention (camera at +X,+Z):
         FRONT (user-facing, seat side) = +W/2
         BACK  (with backrest)         = -W/2
         X = depth, Y = up, Z = length
       ---------------------------------------------------------- */

    _buildParkBench: function () {

      var T = global.THREE;
      var mats = this.materials;
      var mk = this._mkBox.bind(this);

      /* Profile scaling per level. Children (lvl 2) get ~75% lumber
         cross-sections + lower seat so the bench is proportional. */
      var prof = _lumber(STATE);
      var L = STATE.L;
      var W = STATE.W;
      var post = prof.post;
      var t = prof.t;
      var w = prof.w;
      /* Target TOP-of-seat-rail height (ergonomic): 0.45 m for adults,
         0.35 m for children. Rail centerline sits half its height below. */
      var seatTopTarget = prof.seatTop;
      var seatY = seatTopTarget - w / 2;
      /* Backrest height is user-draggable via the H handle (STATE.backH).
         Children (lvl 2) capped at 0.40 m for proportion. */
      var backH = (STATE.lvl === 2)
        ? Math.min(0.40, STATE.backH)
        : (STATE.backH || 0.55);
      var rake = (STATE.backRakeDeg || 0) * Math.PI / 180;

      var hasBack = (STATE.backrestVisible !== false);

      /* Post height:
         - With backrest: posts end RIGHT UNDER the top rail's bottom face,
           so the rail sits like a cap (no 4x4 sticking up above the cap).
           topY = seatY + backH  (top rail centerline); bottom face = topY - t/2.
         - Without backrest: posts end flush with the seat-rail top face. */
      var postH = seatY + backH - t / 2;

      var halfL = L / 2, halfW = W / 2;

      /* 4 corner posts (4x4). Centered at the corners of the bench footprint. */
      var postCorners = [
        { x:  halfW - post / 2, z: -halfL + post / 2, role: 'front-left'  },
        { x: -halfW + post / 2, z: -halfL + post / 2, role: 'back-left'   },
        { x:  halfW - post / 2, z:  halfL - post / 2, role: 'front-right' },
        { x: -halfW + post / 2, z:  halfL - post / 2, role: 'back-right'  }
      ];
      for (var pi = 0; pi < postCorners.length; pi++) {
        var p = postCorners[pi];
        var pmesh = mk(post, postH, post, mats.lumber, p.x, postH / 2, p.z);
        this._addToScene(pmesh, 'post', { boqCode: prof.postCode, length: postH, idHint: p.role });
        /* Explode: corner posts spread OUT to the bench ends in Z and
           slightly outward in X (away from the long-rail axis).
           Front posts (x>0) go +X; back posts (x<0) go -X. */
        pmesh.userData.explodeOffset = [
          p.x > 0 ?  0.10 : -0.10,
          0.08,
          p.z > 0 ?  0.18 : -0.18
        ];
      }

      /* Side rails (2x4 laid FLAT, spanning W between the front+back
         posts of each Z side). Both bottom (seat) and top (backrest-
         support) pairs share these rules:
           - Length = post-centerline to post-centerline = (W - post).
             This makes the rail's X faces line up with the OUTER X faces
             of the posts (i.e. rail and post are flush from the front
             and from the back).
           - Z position = same as the posts on that side (±halfL ∓ post/2),
             so the rail's outer Z face is flush with the post's outer Z face.
           - Profile laid flat: box dims (railLenX, t, w) — thin (t=38mm)
             along Y, wide (w=89mm) along Z. Width matches the post's Z
             extent (post=89mm) so the side faces are coplanar.
         The TOP pair is the upper structural support — it stays
         HORIZONTAL regardless of STATE.backRakeDeg. The tilt slider is
         reserved for the future backrest panel (added on top of these
         rails), not for these support members themselves. */
      /* Two different lengths now:
           - BOTTOM side rail = clear span BETWEEN posts (inner-to-inner),
             so its ends sit FLUSH with the INSIDE faces of the corner
             posts. Length = W - 2*post.
           - TOP side rail   = caps OVER the posts, ends flush with their
             OUTER X faces. Length = W.
         Difference = 2*post = 200 mm = 8" (= 2 × 4" post width). */
      var sideRailLenBottom = W - 2 * post;
      var sideRailLenTop    = W;
      var sideZL            = -halfL + post / 2;
      var sideZR            =  halfL - post / 2;

      /* BOTTOM pair — on-edge (89 mm tall, 38 mm thin), outer Z face
         flush with the OUTER Z face of the posts. */
      var seatRailZL = -halfL + t / 2;
      var seatRailZR =  halfL - t / 2;

      var leftSeatRail = mk(sideRailLenBottom, w, t, mats.lumber, 0, seatY, seatRailZL);
      this._addToScene(leftSeatRail, 'rail-seat-left',
        { boqCode: prof.frameCode, length: sideRailLenBottom, idHint: 'seat-left' });

      var rightSeatRail = mk(sideRailLenBottom, w, t, mats.lumber, 0, seatY, seatRailZR);
      this._addToScene(rightSeatRail, 'rail-seat-right',
        { boqCode: prof.frameCode, length: sideRailLenBottom, idHint: 'seat-right' });

      /* LONG seat rails — run along Z, sit BETWEEN the corner posts at
         the front and back of the bench, at seat height. They terminate
         at the INNER Z faces of the corner posts (no run-through into
         the post wood). Outer X face flush with the OUTER X face of the
         posts on that side (front = +X, back = -X). On-edge orientation
         (89 mm tall, 38 mm thin). Length = clear span between the inner
         Z faces of the corner posts = L - 2*post. */
      var longRailLenZ = L - 2 * post;
      var longRailXF   =  halfW - t / 2;       /* front (positive X) */
      var longRailXB   = -halfW + t / 2;       /* back  (negative X) */

      var frontSeatRail = mk(t, w, longRailLenZ, mats.lumber, longRailXF, seatY, 0);
      this._addToScene(frontSeatRail, 'rail-seat-front',
        { boqCode: prof.frameCode, length: longRailLenZ, idHint: 'seat-front' });

      var backSeatRail = mk(t, w, longRailLenZ, mats.lumber, longRailXB, seatY, 0);
      this._addToScene(backSeatRail, 'rail-seat-back',
        { boqCode: prof.frameCode, length: longRailLenZ, idHint: 'seat-back' });

      /* CROSS-JOISTS — short 2x4s between the FRONT and BACK long rails,
         spaced ~40 cm on-center (16" rule of thumb for 2x4 decking joists).
         Same orientation as the side rails: on-edge (89 mm tall, 38 mm thin),
         span along X. Length = clear distance between the inner X faces of
         the two long rails (= W - 2*t since long rails are at the very
         outside edge). Count auto-derived from L:
           L < 0.80 m  →  0 joists (rim frame is enough)
           L = 0.80 → 1 joist
           L = 1.20 → 2 joists
           L = 1.40 → 3 joists
         Joists are distributed evenly inside the clear Z span between
         the inner faces of the side rails. */
      var joistLenX     = W - 2 * t;
      var joistClearZ   = L - 2 * t;                       /* clear span between long rails... wait, this is along X. Z clear span between side rails: */
      var joistZSpan    = L - 2 * t;                       /* between inner Z faces of the side rails */
      var targetSpacing = 0.40;                            /* 40 cm on-center */
      var nJoists       = Math.max(0, Math.round(joistZSpan / targetSpacing) - 1);
      if (nJoists > 0) {
        var step = joistZSpan / (nJoists + 1);
        var zStart = -joistZSpan / 2;                      /* inner face of left side rail */
        for (var ji = 0; ji < nJoists; ji++) {
          var jz = zStart + step * (ji + 1);
          var joist = mk(joistLenX, w, t, mats.lumber, 0, seatY, jz);
          this._addToScene(joist, 'joist',
            { boqCode: prof.frameCode, length: joistLenX, idHint: 'joist-' + (ji + 1) });
        }
      }

      /* SEAT PLANKS — 2x4 boards laid FLAT (89 mm wide face up, 38 mm
         thick), running along Z. Edge planks line up with the OUTER X
         faces of the corner posts (±halfW). Inner planks fit between
         them with even gaps. Edge planks are SHORTER (L - 2*post) so
         they sit BETWEEN the front and back corner posts on each side,
         not clashing with them. Inner planks span the full L.
         Boards sit ON TOP of the seat frame (bottom face at seatY + w/2). */
      var plankW       = prof.plankW;
      var plankT       = prof.plankT;
      var plankCY      = seatY + w / 2 + plankT / 2;

      /* Spacing is FIXED — plankW + minGap, centerline-to-centerline.
         W is snapped to exact plank counts by the drag handler, so the
         builder just rounds to recover N (defensive vs FP slop in W).
         This way the seat plank spacing AND the backrest plank spacing
         (which derives from stepCC) stay constant as W changes — only
         the count of seat planks changes. */
      var minGap       = 0.004;
      var stepCC       = plankW + minGap;
      var nPlanks      = Math.max(4, Math.min(15,
                          Math.round((W + minGap) / stepCC)));
      var edgeLenZ     = L - 2 * post;                            /* shorter — between posts */
      var innerLenZ    = L;                                       /* full — over the frame */

      for (var pk = 0; pk < nPlanks; pk++) {
        var px = -W / 2 + plankW / 2 + pk * stepCC;
        var isEdge = (pk === 0 || pk === nPlanks - 1);
        var pLen   = isEdge ? edgeLenZ : innerLenZ;
        var plank = mk(plankW, plankT, pLen, mats.lumber, px, plankCY, 0);
        this._addToScene(plank, 'seat-plank',
          { boqCode: prof.plankCode, length: pLen, idHint: 'plank-' + (pk + 1) });
        /* Explode: all seat planks fly to the SAME height, with an
           X spread perpendicular to their length so they separate
           cleanly. */
        var nMidS = (nPlanks - 1) / 2;
        var dx = (pk - nMidS) * 0.025;
        plank.userData.explodeOffset = [dx, 0.40, 0];
      }

      /* TOP side rails — armrests on the bench ends. Part of CORE
         structure: drawn ALWAYS (including "without backrest" stage).
         Height driven by user-draggable STATE.backH (H drag handle). */
      var topY = seatY + backH;

      var leftTopRail = mk(sideRailLenTop, t, w, mats.lumber, 0, topY, sideZL);
      this._addToScene(leftTopRail, 'rail-back-left',
        { boqCode: prof.frameCode, length: sideRailLenTop, idHint: 'back-left' });

      var rightTopRail = mk(sideRailLenTop, t, w, mats.lumber, 0, topY, sideZR);
      this._addToScene(rightTopRail, 'rail-back-right',
        { boqCode: prof.frameCode, length: sideRailLenTop, idHint: 'back-right' });

      /* BACKREST FRAME — only present when backrest is ON. Sits on
         the deck planks at the rear (-X side). */
      if (hasBack) {
        /* ─────────────────────────────────────────────────────────
           BACKREST FRAME — additional rectangular frame sitting on
           the BACK long seat rail (-X side of the bench). Built as a
           THREE.Group so the whole thing tilts as one unit via
           STATE.backRakeDeg (0..20°).

           Default (rake = 0°): frame stands VERTICAL on the back
           long rail, perpendicular to the seat.

           Skladba (vše 2x4 KVH10060):
             - Bottom rail FLAT (89 wide along X = seat depth dir,
               38 thick along Y). Length = longRailLenZ. Sits with
               its bottom face on the top face of the back seat rail.
             - Top rail FLAT — identical, raised by backH.
             - Side posts ×2 ON EDGE (89 along X, 38 along Z).
               Height = backH - 2t (clear span between rails).
             - Internal stretchers — same count + Z positions as
               cross-joists below the seat (sync).

           Tilt: rotate the whole group around its bottom inner edge
           (the edge at X = longRailXB + t/2 (the +X face of the back
           seat rail's top corner, where the bottom rail's +X bottom
           edge sits). Positive backRakeDeg tips the top -X (away
           from user, the "back" direction). */
        /* The bottom rail is STATIC on the deck. Everything else
           (top rail + posts + stretchers) is built in a Group whose
           ORIGIN sits on the TOP face of the bottom rail at its
           inner edge (the +X seat-facing edge). The whole group is
           rotated around Z by +rake — this rotates the slanted-board
           assembly as a rigid unit. Pieces inside the group are
           positioned relative to that pivot:
             - posts/stretchers: rectangular profile, axis along Y,
               sit with their bottom face at y=0 (= top of bottom
               rail). When the group rotates, their bottom face
               naturally becomes parallel to the bottom rail's top
               face (= sliced at angle rake relative to the post
               itself), which is what we want.
             - top rail: same profile + length as bottom rail, at
               local Y = clearH + t/2 → ends up tilted parallel to
               the posts (since the whole group is tilted). */

        /* Backrest is filled with horizontal planks mirroring the
           seat decking (same profile, same spacing). Frame height is
           computed FROM that: the planks span ((n-1)*stepCC) between
           outer centerlines, plus plankW for the edge planks
           themselves, plus 2*t for the bottom + top rails.
           Adults: 5 planks. Kids (lvl 2): 4 planks — one profile
           lower, since the full-height backrest is too tall for the
           reduced kids proportions. */
        var bfNumPlanks  = (STATE.lvl === 2) ? 4 : 5;
        var bfPlankSpan  = (bfNumPlanks - 1) * stepCC + plankW;   /* between outer faces of edge planks */
        var bfFrameH     = bfPlankSpan;                          /* planks span full frame height (overlap rails) */
        var bfBotX       = -halfW + w / 2;
        var bfDeckTop    = seatY + w / 2 + t;
        var bfBotY0      = bfDeckTop + t / 2;             /* bottom-rail CL (static) */
        var bfBotLen     = longRailLenZ;                  /* full span between corner-post inner faces */
        var bfClearH     = bfFrameH - 2 * t;              /* clear gap between top of bot rail and bottom of top rail */
        var bfShortLen   = bfBotLen - 2 * t;              /* rails shortened — corner posts sit at the Z ends INSTEAD */

        /* Z positions of corner posts: at the ENDS of bfBotLen span.
           Their CL Z = ±(bfBotLen/2 - t/2) so their outer Z face is
           flush with the original rail end. */
        var bfPostZL = -bfBotLen / 2 + t / 2;
        var bfPostZR =  bfBotLen / 2 - t / 2;

        /* BOTTOM RAIL — STATIC, no rotation. Lies flat on the rear
           deck plank. Shortened so its ends butt against the inner
           faces of the corner posts (which run full height). */
        var bfBotRail = mk(w, t, bfShortLen, mats.lumber, bfBotX, bfBotY0, 0);
        this._addToScene(bfBotRail, 'rail-backrest-bottom',
          { boqCode: prof.frameCode, length: bfShortLen, idHint: 'backrest-bot' });

        /* GROUP — pivot at the INNER (+X, seat-facing) TOP edge of
           the static bottom rail. Everything else (top rail, corner
           posts, internal stretchers) is in this group and tilts as
           a rigid unit around that edge. */
        var bf = new T.Group();
        bf.position.set(bfBotX + w / 2, bfBotY0 + t / 2, 0);
        bf.rotation.z = rake;
        bf.userData.partType = 'backrest-group';
        bf.userData.basePos  = bf.position.clone();

        var self = this;
        function addToFrame(mesh, partType, boqOpts) {
          self._tag(mesh, partType);
          if (boqOpts && boqOpts.boqCode) mesh.userData.boqCode = boqOpts.boqCode;
          self._addEdges(mesh);
          bf.add(mesh);
          if (global.BenchInstances && global.BenchInstances.add && boqOpts && boqOpts.boqCode) {
            var pid = global.BenchInstances.nextId(partType, boqOpts.idHint);
            global.BenchInstances.add({
              id: pid, partType: partType, boqCode: boqOpts.boqCode,
              length: (typeof boqOpts.length === 'number') ? boqOpts.length : null,
              dimensions: null,
              position: { x: mesh.position.x, y: mesh.position.y, z: mesh.position.z },
              mesh: mesh
            });
          }
        }

        /* Local frame: pivot is at the inner-top edge of the bottom
           rail. +X points outward (away from seat), +Y points up. */
        var bfLocalX = -w / 2;

        /* CORNER POSTS — FULL FRAME HEIGHT. They wrap around BOTH
           rails on the outside: bottom face = bottom face of bottom
           rail (local Y = -t), top face = top face of top rail
           (local Y = bfClearH + t). Length = bfFrameH.
           In local frame, bottom-rail bottom face is at Y = -t (because
           pivot is at TOP of bottom rail). */
        var bfCornerLocalY = -t + bfFrameH / 2;       /* = bfClearH/2 - t/2 + t/2 = bfClearH/2 */
        function addCornerPost(zPos, idHint) {
          var m = self._mkAngledCornerPost(w, bfFrameH, t, mats.lumber, bfLocalX, bfCornerLocalY, zPos, rake);
          addToFrame(m, 'post-backrest', { boqCode: prof.frameCode, length: bfFrameH, idHint: idHint });
        }
        function addCornerPostExploded(zPos, idHint, expZ) {
          var m = self._mkAngledCornerPost(w, bfFrameH, t, mats.lumber, bfLocalX, bfCornerLocalY, zPos, rake);
          addToFrame(m, 'post-backrest', { boqCode: prof.frameCode, length: bfFrameH, idHint: idHint });
          m.userData.explodeOffset = [0, 0, expZ];
        }
        addCornerPostExploded(bfPostZL, 'backrest-post-L', -0.05);
        addCornerPostExploded(bfPostZR, 'backrest-post-R',  0.05);

        /* TOP RAIL — shortened (between corner posts). FLAT. Local
           Y = bfClearH + t/2 (bottom face flush with top of clear
           gap). */
        var bfTopRail = mk(w, t, bfShortLen, mats.lumber, bfLocalX, bfClearH + t / 2, 0);
        addToFrame(bfTopRail, 'rail-backrest-top',
          { boqCode: prof.frameCode, length: bfShortLen, idHint: 'backrest-top' });
        bfTopRail.userData.explodeOffset = [0, 0.06, 0];   /* slight up in local frame */

        /* INTERNAL STRETCHERS — between the two rails (clear span
           bfClearH high). Sync Z with cross-joists. */
        var bfStretcherLocalY = bfClearH / 2;
        var bfStretcherLen    = bfClearH;   /* long point: square top + raked bottom */
        if (nJoists > 0) {
          var bfStep   = joistZSpan / (nJoists + 1);
          var bfZStart = -joistZSpan / 2;
          for (var bj = 0; bj < nJoists; bj++) {
            var bfJZ = bfZStart + bfStep * (bj + 1);
            var sm = self._mkAngledCornerPost(w, bfClearH, t, mats.lumber, bfLocalX, bfStretcherLocalY, bfJZ, rake, 0);
            addToFrame(sm, 'stretcher-backrest',
              { boqCode: prof.frameCode, length: bfStretcherLen, idHint: 'backrest-stretcher-' + (bj + 1) });
            sm.userData.explodeOffset = [0, 0.03, 0];   /* tiny lift in local frame */
          }
        }

        /* BACKREST DECKING — 5 horizontal planks, same profile + spacing
           as seat planks. Mounted on the FRONT (+X, user-facing) face
           of the frame, like a panel. Each plank's local position:
              X = +t/2  (plank's -X face sits flush with the front face
                         of the rails/stretchers at local X = 0)
              Y = goes from t + plankW/2 (lowest, just above bottom rail)
                  up by stepCC for each successive plank
              Z = 0, centered
           Plank LENGTH (Z) is per-plank: if the plank's WORLD Y after
           tilt is below the top face of the bench's TOP SIDE RAILS
           (armrests at Y = seatY + backH + t/2), it collides with the
           bench corner posts and must be SHORTENED to fit between them
           (L - 2*post). Otherwise full L. */
        var bfPlankFrontX  = t / 2;                       /* local X centerline of planks */
        var bfPlankY0      = -t + plankW / 2;             /* local Y of lowest plank's centerline = bottom of frame + plankW/2 */
        var bfBenchArmTop  = seatY + backH + t / 2;       /* world Y of top face of bench's armrest top rail */
        var bfPivotY       = bfBotY0 + t / 2;             /* world Y of group's pivot */
        var bfPivotX       = bfBotX + w / 2;              /* world X of group's pivot */
        var bfPlankLenFull = L;
        var bfPlankLenShort= L - 2 * post;

        for (var bp = 0; bp < bfNumPlanks; bp++) {
          var bpLocalY = bfPlankY0 + bp * stepCC;
          /* World Y of this plank's centerline AFTER the group's
             rotation around Z by 'rake' (around the pivot).
             local point (bfPlankFrontX, bpLocalY) → world:
                wx = pivotX + bfPlankFrontX*cos(rake) - bpLocalY*sin(rake)
                wy = pivotY + bfPlankFrontX*sin(rake) + bpLocalY*cos(rake)
          */
          var bpWorldY = bfPivotY + bfPlankFrontX * Math.sin(rake) + bpLocalY * Math.cos(rake);
          var bpCollides = (bpWorldY - plankW / 2) < bfBenchArmTop;
          var bpLen = bpCollides ? bfPlankLenShort : bfPlankLenFull;
          /* Plank dimensions: w (=plankW=89) along Y (vertical face up),
             t (=plankT=38) along X (depth), bpLen along Z. The plank's
             "front face" is its +X face — at local X = bfPlankFrontX + t/2.
             Actually we want the plank to read like a deck plank: its
             89-mm wide face visible from the front of the bench.
             So box dims (X, Y, Z) = (plankT, plankW, bpLen) — thin in X,
             wide in Y, long in Z. */
          var bpMesh = mk(plankT, plankW, bpLen, mats.lumber,
                          bfPlankFrontX, bpLocalY, 0);
          addToFrame(bpMesh, 'backrest-plank',
            { boqCode: prof.plankCode, length: bpLen, idHint: 'backrest-plank-' + (bp + 1) });
          /* Explode: shift OUT of frame in local +X (toward viewer, away
             from backrest frame face) + small vertical Y spread from the
             middle plank. After bf's rake rotation this lands as mostly
             horizontal pull away from the frame with a small lift. */
          var nMidB = (bfNumPlanks - 1) / 2;
          var bpDy  = (bp - nMidB) * 0.020;
          bpMesh.userData.explodeOffset = [0.12, bpDy, 0];
        }

        global.BenchEngine.benchGroup.add(bf);
        /* v263: throw pillows on the deck against the back planks (built view
           only -- the park bench's assembly hides 'pillow' past step 0) */
        try {
          var deckTopP = plankCY + plankT / 2, f0 = t / 2 + plankT / 2;
          var bx0P = bfPivotX + f0 * Math.cos(rake), by0P = bfPivotY + f0 * Math.sin(rake);
          var backXP = bx0P - ((deckTopP - by0P) / Math.cos(rake)) * Math.sin(rake);
          var kidP = (STATE.lvl === 2) ? 0.8 : 1;
          this._addPillows({ n: Math.max(1, Math.round((L - 2 * post) / 0.62)), z0: -L / 2 + post + 0.06, z1: L / 2 - post - 0.06, seatY: deckTopP, backX: backXP + 0.004,
                             beta: rake, w: 0.44 * kidP, h: 0.42 * kidP, t: 0.16 * kidP, tag: 'park-' });
        } catch (ePil) {}
      }

      /* Scale figure is attached centrally in build() (shared module),
         so no per-build person code here. */

      /* Realistic screw models: pocket-hole screws for frame joinery,
         visible wood-screw heads on every deck plank, lag bolts on heavy
         armrest connections. Counts mirror BoQ; positions match geometry. */
      this._addParkBenchFasteners({
        L: L, W: W, post: post, t: t, w: w,
        halfL: halfL, halfW: halfW,
        seatY: seatY, backH: backH, hasBack: hasBack,
        plankCY: plankCY, plankT: plankT, plankW: plankW,
        nPlanks: nPlanks, stepCC: stepCC,
        nJoists: nJoists, joistZSpan: joistZSpan,
        bfBotX: bfBotX, bfBotY0: bfBotY0, bfFrameH: bfFrameH,
        bfNumPlanks: hasBack ? bfNumPlanks : 0,
        bfPlankY0: hasBack ? bfPlankY0 : 0,
        rake: rake
      });
    },

    _addParkBenchFasteners: function (ctx) {
      var T = global.THREE;
      var L=ctx.L, W=ctx.W, post=ctx.post, t=ctx.t, w=ctx.w;
      var halfL=ctx.halfL, halfW=ctx.halfW;
      var seatY=ctx.seatY, backH=ctx.backH, hasBack=ctx.hasBack;
      var plankCY=ctx.plankCY, plankT=ctx.plankT, plankW=ctx.plankW;
      var nPlanks=ctx.nPlanks, stepCC=ctx.stepCC;
      var nJoists=ctx.nJoists, joistZSpan=ctx.joistZSpan;
      var bfBotX=ctx.bfBotX, bfBotY0=ctx.bfBotY0, bfFrameH=ctx.bfFrameH;
      var bfNumPlanks=ctx.bfNumPlanks, bfPlankY0=ctx.bfPlankY0;
      var rake=ctx.rake;

      /* Materials: dark steel for visible deck-screw heads, slightly
         brighter galvanized look for lag bolts, near-black for pocket-
         hole entry plugs (which sit recessed in the wood). */
      var deckScrewMat = new T.MeshStandardMaterial({ color: 0x2a2a2a, roughness: 0.45, metalness: 0.75 });
      var lagMat       = new T.MeshStandardMaterial({ color: 0x6a6a6a, roughness: 0.35, metalness: 0.90 });
      var pocketMat    = new T.MeshStandardMaterial({ color: 0x161616, roughness: 0.65, metalness: 0.30 });
      /* Bright accent material for pocket-hole DRILL location markers
         (step 2 view). Unlit-looking emissive orange so it pops against
         the wood under any lighting. */
      var pocketMarkerMat = new T.MeshStandardMaterial({
        color: 0xff7733, roughness: 0.45, metalness: 0.0,
        emissive: 0xff7733, emissiveIntensity: 0.45
      });

      var eng = global.BenchEngine;
      var benchGroup = eng.benchGroup;

      /* ─── Helpers ────────────────────────────────────────────────── */

      /* Visible wood-screw head: a flat round disc 8 mm diameter, 1.5 mm
         thick, sitting flush with the wood surface. 'axis' is the screw's
         shank direction: 'y' = vertical (head on top), 'x' = head facing
         in +X (front of backrest plank), 'xneg' = head in -X. */
      function addDeckScrew(x, y, z, axis, group, off, firstStep, installOff) {
        var headR = 0.004, headH = 0.0015;
        var shankR = 0.0026;       /* thread crest Ø 5.2 mm */
        var rootR  = 0.0018;       /* thread root  Ø 3.6 mm */
        var shankL = 0.055;        /* 55 mm visible shank   */
        var g = new T.Group();
        var headMesh = new T.Mesh(new T.CylinderGeometry(headR, headR, headH, 16), deckScrewMat);
        headMesh.position.y = headH / 2;
        g.add(headMesh);
        /* Threaded shank: lathed sawtooth profile (smooth shank under the
           head, a realistic length of thread ridges, tapered tip). Spans
           y=0 (head) to y=-shankL (tip). Identical for every deck screw,
           so built once and shared. */
        if (!addDeckScrew._shankGeom) {
          var pitch   = 0.0033;
          var smoothL = 0.010;
          var threadL = 0.035;
          var yEnd    = -(smoothL + threadL);
          var pts = [];
          pts.push(new T.Vector2(shankR, 0));
          pts.push(new T.Vector2(shankR, -smoothL));
          var yy = -smoothL;
          while (yy - pitch >= yEnd) {
            pts.push(new T.Vector2(rootR,  yy));
            pts.push(new T.Vector2(shankR, yy - pitch / 2));
            pts.push(new T.Vector2(rootR,  yy - pitch));
            yy -= pitch;
          }
          pts.push(new T.Vector2(rootR,  yEnd));
          pts.push(new T.Vector2(0.0006, -shankL));
          addDeckScrew._shankGeom = new T.LatheGeometry(pts, 16);
        }
        g.add(new T.Mesh(addDeckScrew._shankGeom, deckScrewMat));
        /* Local +Y = head OUT of wood, shank -Y INTO wood. */
        if (axis === 'x')         { g.rotation.z = -Math.PI / 2; }   /* head +X */
        else if (axis === 'xneg') { g.rotation.z =  Math.PI / 2; }   /* head -X */
        g.position.set(x, y, z);
        g.userData.partType = 'screw-deck';
        g.userData.boqCode  = 'FAS50060';
        g.userData.basePos  = g.position.clone();
        if (off) g.userData.explodeOffset = off.slice();
        if (installOff) g.userData.installOffset = installOff.slice();
        if (typeof firstStep === 'number') g.userData.firstStep = firstStep;
        (group || benchGroup).add(g);
      }

      /* Pocket-hole screw: a slim angled cylinder representing the screw
         buried inside a Kreg-jig pocket. Visible only in assembly mode.
         (cx, cy, cz) is the rail-side pocket entry (face of the rail
         being joined); axis is the joinery direction ('x','-x','z','-z'
         = which way the screw drives INTO the mating post). */
      /* Distance every fastener slides in its INSERTION direction
         during explode — small enough to read as "near the joint",
         large enough that the head/shank reads as separated from the
         wood. 60 mm matches the comfortable scale of the 25 mm marker
         setback used for pocket holes. */
      var INSERT_SHIFT = 0.06;

      /* Marker oval scale per axis. The oval is squashed flat against
         the wood face (small in face-normal dim) and elongated along
         the screw direction (the way the screw EXITS the wood). Base
         radius is multiplied by these factors. */
      var MARKER_SCALE = {
        'x':       [1.6, 0.9, 0.30],   /* on ±Z face, elongated in +X */
        '-x':      [1.6, 0.9, 0.30],   /* on ±Z face, elongated in -X */
        'z':       [0.30, 0.9, 1.6],   /* on ±X face, elongated in +Z */
        '-z':      [0.30, 0.9, 1.6],   /* on ±X face, elongated in -Z */
        'up-x':    [0.30, 1.6, 0.9],   /* on inner ±X face of post, elongated UP */
        'up-negx': [0.30, 1.6, 0.9],
        'up-z':    [0.9, 1.6, 0.30],   /* on inner ±Z face, elongated UP */
        'up-negz': [0.9, 1.6, 0.30]
      };

      /* addPocketHole(cx, cy, cz, axis, hostOff, markerPos, cylOff, markerScale, firstStep, bfTracked)
           bfTracked = true for backrest-frame fasteners — both cylinder
                       and marker get userData.bfOffBenchTrack so they
                       ride the off-bench translation during steps 14..18. */
      function addPocketHole(cx, cy, cz, axis, hostOff, markerPos, cylOff, markerScale, firstStep, bfTracked) {
        var shankR = 0.0022, shankL = 0.040;
        var g = new T.CylinderGeometry(shankR, shankR, shankL, 8);
        var m = new T.Mesh(g, pocketMat);
        var pocketAngle = 15 * Math.PI / 180;
        if (axis === 'x' || axis === '-x') {
          m.rotation.z = Math.PI / 2;
          m.rotation.y = pocketAngle * (axis === 'x' ? -1 : 1);
        } else if (axis === 'z' || axis === '-z') {
          m.rotation.x = Math.PI / 2;
          m.rotation.y = pocketAngle * (axis === 'z' ? 1 : -1);
        } else if (axis === 'up-x' || axis === 'up-negx') {
          m.rotation.z = pocketAngle * (axis === 'up-x' ? 1 : -1);
        } else if (axis === 'up-z' || axis === 'up-negz') {
          m.rotation.x = pocketAngle * (axis === 'up-z' ? 1 : -1);
        }
        m.position.set(cx, cy, cz);
        m.visible = false;
        m.userData.partType = 'screw-pocket';
        m.userData.boqCode  = 'FAS50060';
        m.userData.basePos  = m.position.clone();
        var cOff = cylOff || hostOff;
        if (cOff) m.userData.explodeOffset = cOff.slice();
        if (typeof firstStep === 'number') m.userData.firstStep = firstStep;
        if (bfTracked) m.userData.bfOffBenchTrack = true;
        benchGroup.add(m);

        /* SURFACE MARKER — flat OVAL on the host's drilled face, scaled
           per axis to look like a real Kreg pocket-hole entry. */
        var markerR = 0.011;
        var sg = new T.SphereGeometry(markerR, 16, 10);
        var sphere = new T.Mesh(sg, pocketMarkerMat);
        var sc = markerScale || MARKER_SCALE[axis] || [1, 1, 1];
        sphere.scale.set(sc[0], sc[1], sc[2]);
        var mp = markerPos || [cx, cy, cz];
        sphere.position.set(mp[0], mp[1], mp[2]);
        sphere.visible = false;
        sphere.userData.partType = 'pocket-marker';
        sphere.userData.basePos  = sphere.position.clone();
        if (hostOff) sphere.userData.explodeOffset = hostOff.slice();
        if (typeof firstStep === 'number') sphere.userData.jointStep = firstStep;
        if (bfTracked) sphere.userData.bfOffBenchTrack = true;
        benchGroup.add(sphere);
      }

      /* Structural 8×100 wood screw (FAS80100): flat HEAD on the wood
         surface + long tapered SHANK driving INTO the wood. Group local:
         +Y = OUT of wood (head at +Y, shank -Y). 'axis' = head OUTWARD
         direction (y/-y/x/-x/z/-z); the group rotates so +Y aligns. */
      function addLag(x, y, z, axis, off, firstStep) {
        var headR  = 0.0070;
        var headH  = 0.0040;
        var shankR = 0.0040;
        var tipR   = 0.0018;
        var shankL = 0.090;
        var g = new T.Group();
        var headMesh = new T.Mesh(new T.CylinderGeometry(headR, headR, headH, 18), lagMat);
        headMesh.position.y = headH / 2;
        g.add(headMesh);
        var shankMesh = new T.Mesh(new T.CylinderGeometry(shankR, tipR, shankL, 16), lagMat);
        shankMesh.position.y = -shankL / 2;
        g.add(shankMesh);
        if (axis === '-y') { g.rotation.x = Math.PI; }
        else if (axis === 'x') { g.rotation.z = -Math.PI / 2; }
        else if (axis === '-x') { g.rotation.z = Math.PI / 2; }
        else if (axis === 'z') { g.rotation.x = Math.PI / 2; }
        else if (axis === '-z') { g.rotation.x = -Math.PI / 2; }
        g.position.set(x, y, z);
        g.userData.partType = 'screw-lag';
        g.userData.boqCode  = 'FAS80100';
        g.userData.basePos  = g.position.clone();
        if (off) g.userData.explodeOffset = off.slice();
        if (typeof firstStep === 'number') g.userData.firstStep = firstStep;
        benchGroup.add(g);
      }

      /* ─── 1) SEAT DECK SCREWS — visible on top of every plank. ─────
         Each plank crosses 2 side rails (at z = ±halfL ∓ post/2) plus
         N cross joists (at intermediate Z). Two screws per crossing —
         one near each long edge of the plank — for anti-twist. */
      var plankTopY = plankCY + plankT / 2;
      var crossZ = [];
      crossZ.push(-halfL + post + t / 2);
      crossZ.push( halfL - post - t / 2);
      if (nJoists > 0) {
        var jStep = joistZSpan / (nJoists + 1);
        for (var jj = 0; jj < nJoists; jj++) {
          crossZ.push(-joistZSpan / 2 + jStep * (jj + 1));
        }
      }
      var nMidPlank = (nPlanks - 1) / 2;
      for (var pk = 0; pk < nPlanks; pk++) {
        var px   = -W / 2 + plankW / 2 + pk * stepCC;
        /* Match the plank's per-instance explode offset PLUS a small
           +Y shift so the screw head appears just above its plank
           during explode (approaching from where the screwdriver was). */
        var plkDx   = (pk - nMidPlank) * 0.025;
        var dsOff   = [plkDx, 0.40 + INSERT_SHIFT, 0];
        for (var ci = 0; ci < crossZ.length; ci++) {
          addDeckScrew(px - plankW * 0.30, plankTopY, crossZ[ci], 'y', null, dsOff, BENCH_JOINT_SEAT_DECK);
          addDeckScrew(px + plankW * 0.30, plankTopY, crossZ[ci], 'y', null, dsOff, BENCH_JOINT_SEAT_DECK);
        }
      }

      /* ─── 2) POCKET HOLES — frame joinery hidden inside the wood. ──
         Side rails ↔ corner posts: 2 holes per joint, drilled into the
         SIDE RAIL's end face, screwing into the post along ±X. The
         host (drilled piece) is the side rail, so pockets ride that
         rail's explode offset and end up on its end face after explode. */
      var sideRailY = seatY;
      var pocketSetback   = 0.025;    /* 25 mm back from the end face */
      var pocketProtrude  = 0.000;    /* marker AT surface (no float-off) */
      var pocketYSpread   = w / 4;    /* ±22 mm → 44 mm between centers */
      /* Two side rails laid on edge. The rail's WIDE 89 mm faces are at
         ±Z (since the rail extends in X with 38 mm thickness in Z). The
         drilled face is the INSIDE one (toward bench center) — that's
         where a Kreg jig clamps and where the pocket entry oval shows. */
      var sideRailPlan = [
        { z: -halfL + t / 2,
          markerZ: -halfL + t + pocketProtrude,
          off:    [0, 0.18, -0.30],
          /* drilled face = +Z; screwdriver approaches from +Z */
          insZ:    1 },
        { z:  halfL - t / 2,
          markerZ:  halfL - t - pocketProtrude,
          off:    [0, 0.18,  0.30],
          insZ:   -1 }
      ];
      sideRailPlan.forEach(function (rail) {
        var cylOff = [rail.off[0], rail.off[1], rail.off[2] + rail.insZ * INSERT_SHIFT];
        [-pocketYSpread, pocketYSpread].forEach(function (yOff) {
          var cy = sideRailY + yOff;
          addPocketHole(
            -halfW + post, cy, rail.z, 'x', rail.off,
            [-halfW + post + pocketSetback, cy, rail.markerZ],
            cylOff, null, BENCH_JOINT_SIDE
          );
          addPocketHole(
             halfW - post, cy, rail.z, '-x', rail.off,
            [ halfW - post - pocketSetback, cy, rail.markerZ],
            cylOff, null, BENCH_JOINT_SIDE
          );
        });
      });

      /* Long rails ↔ corner posts: drilled in the LONG rail's wide
         INSIDE face. Long rail at X=±halfW∓t/2 with 38 mm thickness in
         X → its wide face is at ±X (face normal). Inside (toward bench
         center) is opposite the bench end. STAY → hostOff = [0,0,0]. */
      var longRailHostOff = [0, 0, 0];
      var longRailPlan = [
        { x: -halfW + t / 2,
          markerX: -halfW + t + pocketProtrude,
          insX:    1 },   /* BACK rail drilled on +X face */
        { x:  halfW - t / 2,
          markerX:  halfW - t - pocketProtrude,
          insX:   -1 }    /* FRONT rail drilled on -X face */
      ];
      longRailPlan.forEach(function (rail) {
        var cylOff = [rail.insX * INSERT_SHIFT, 0, 0];
        [-pocketYSpread, pocketYSpread].forEach(function (yOff) {
          var cy = sideRailY + yOff;
          addPocketHole(
            rail.x, cy, -halfL + post, 'z', longRailHostOff,
            [rail.markerX, cy, -halfL + post + pocketSetback],
            cylOff, null, BENCH_JOINT_LONG
          );
          addPocketHole(
            rail.x, cy,  halfL - post, '-z', longRailHostOff,
            [rail.markerX, cy,  halfL - post - pocketSetback],
            cylOff, null, BENCH_JOINT_LONG
          );
        });
      });

      /* Cross joists ↔ long rails: 2 holes per joist end. The joist
         is laid on edge (89 mm tall in Y, 38 mm thick in Z) so its
         wide drillable face is ±Z. Drill on the +Z face (toward bench
         front) — hidden by seat planks once assembled. */
      var joistHostOff = [0, 0.28, 0];
      /* Drilled on the joist's +Z face → insertion direction +Z. */
      var joistCylOff  = [0, 0.28, INSERT_SHIFT];
      if (nJoists > 0) {
        var jStep2 = joistZSpan / (nJoists + 1);
        for (var ji = 0; ji < nJoists; ji++) {
          var jz = -joistZSpan / 2 + jStep2 * (ji + 1);
          var jMarkerZ = jz + t / 2 + pocketProtrude;
          addPocketHole(
            -halfW + t, seatY - pocketYSpread, jz, 'x', joistHostOff,
            [-halfW + t + pocketSetback, seatY - pocketYSpread, jMarkerZ],
            joistCylOff, null, BENCH_JOINT_JOIST
          );
          addPocketHole(
            -halfW + t, seatY + pocketYSpread, jz, 'x', joistHostOff,
            [-halfW + t + pocketSetback, seatY + pocketYSpread, jMarkerZ],
            joistCylOff, null, BENCH_JOINT_JOIST
          );
          addPocketHole(
             halfW - t, seatY - pocketYSpread, jz, '-x', joistHostOff,
            [ halfW - t - pocketSetback, seatY - pocketYSpread, jMarkerZ],
            joistCylOff, null, BENCH_JOINT_JOIST
          );
          addPocketHole(
             halfW - t, seatY + pocketYSpread, jz, '-x', joistHostOff,
            [ halfW - t - pocketSetback, seatY + pocketYSpread, jMarkerZ],
            joistCylOff, null, BENCH_JOINT_JOIST
          );
        }
      }

      /* ─── 3) ARMREST → CORNER POST: pocket holes from BELOW. ──────
         Standard 2×4 furniture joinery: armrest sits on top of corner
         posts, attached via pocket-hole screws driven UP from the
         post's INNER face into the armrest underside. Clean armrest
         top surface — no visible fasteners. 2 pockets per post = 8 total. */
      var armrestUnderY = seatY + backH - t / 2;     /* armrest BOTTOM face */
      var pocketY = armrestUnderY - 0.050;           /* 50 mm below armrest —
                                                        well clear of the
                                                        top edge of the 4×4 post */
      [-halfL + post / 2, halfL - post / 2].forEach(function (zPost) {
        var zSign         = (zPost > 0 ?  0.18 : -0.18);
        var leftPostOff   = [-0.10, 0.08, zSign];
        var rightPostOff  = [ 0.10, 0.08, zSign];
        /* Cylinder slides in INSERTION direction: LEFT post drilled on
           its +X face → drill approaches from +X. RIGHT post drilled on
           its -X face → drill from -X. */
        var leftCylOff   = [leftPostOff[0]  + INSERT_SHIFT, leftPostOff[1],  leftPostOff[2]];
        var rightCylOff  = [rightPostOff[0] - INSERT_SHIFT, rightPostOff[1], rightPostOff[2]];
        var xLcyl    = -halfW + post;
        var xLmark   = xLcyl + pocketProtrude;
        var xRcyl    =  halfW - post;
        var xRmark   = xRcyl - pocketProtrude;
        addPocketHole(xLcyl, pocketY, zPost - w / 3, 'up-x', leftPostOff,
                      [xLmark, pocketY, zPost - w / 3], leftCylOff, null, BENCH_JOINT_ARMREST);
        addPocketHole(xLcyl, pocketY, zPost + w / 3, 'up-x', leftPostOff,
                      [xLmark, pocketY, zPost + w / 3], leftCylOff, null, BENCH_JOINT_ARMREST);
        addPocketHole(xRcyl, pocketY, zPost - w / 3, 'up-negx', rightPostOff,
                      [xRmark, pocketY, zPost - w / 3], rightCylOff, null, BENCH_JOINT_ARMREST);
        addPocketHole(xRcyl, pocketY, zPost + w / 3, 'up-negx', rightPostOff,
                      [xRmark, pocketY, zPost + w / 3], rightCylOff, null, BENCH_JOINT_ARMREST);
      });

      /* ─── 4) BACKREST DECK SCREWS — visible on front (+X) face of
         every backrest plank. Each plank attaches to: top rail + bottom
         rail + 2 corner posts of the backrest frame + N stretchers.
         All these are at backrest local X = 0, so plank's local +X face
         (at local X = +t) is the front. Apply rake rotation to get
         world coordinates. */
      if (hasBack && bfNumPlanks > 0) {
        var bfPivotX = bfBotX + w / 2;
        var bfPivotY = bfBotY0 + t / 2;
        var bfCorners = [
          -halfL + post + t / 2,                          /* near left post */
           halfL - post - t / 2                           /* near right post */
        ];
        var bfStretcherZ = [];
        if (nJoists > 0) {
          var bfStep = joistZSpan / (nJoists + 1);
          for (var bs = 0; bs < nJoists; bs++) {
            bfStretcherZ.push(-joistZSpan / 2 + bfStep * (bs + 1));
          }
        }
        var bfAttachZ = bfCorners.concat(bfStretcherZ);

        var sinR = Math.sin(rake), cosR = Math.cos(rake);
        var screwLocalX = t + 0.0001;  /* just outside the plank's +X face */

        var nMidBp = (bfNumPlanks - 1) / 2;
        for (var bp = 0; bp < bfNumPlanks; bp++) {
          var localY  = bfPlankY0 + bp * stepCC;
          var localY_a = localY - plankW * 0.30;
          var localY_b = localY + plankW * 0.30;
          var wx_a = bfPivotX + screwLocalX * cosR - localY_a * sinR;
          var wy_a = bfPivotY + screwLocalX * sinR + localY_a * cosR;
          var wx_b = bfPivotX + screwLocalX * cosR - localY_b * sinR;
          var wy_b = bfPivotY + screwLocalX * sinR + localY_b * cosR;
          /* This plank's local explode offset (matches the plank mesh):
                 [0.12 (insertion shift baked into +X local) + INSERT_SHIFT,
                  (bp - nMidBp) * 0.020,
                  0]
             converted to world via the rake rotation, then add the bf
             group offset [-0.25, 0.55, 0]. */
          var bpDy        = (bp - nMidBp) * 0.020;
          var localExX    = 0.12 + INSERT_SHIFT;
          var worldExX    = localExX * cosR - bpDy * sinR + (-0.25);
          var worldExY    = localExX * sinR + bpDy * cosR + 0.55;
          var bdsOff      = [worldExX, worldExY, 0];
          var bdsInstall  = [localExX * cosR - bpDy * sinR, localExX * sinR + bpDy * cosR, 0];
          for (var az = 0; az < bfAttachZ.length; az++) {
            addDeckScrew(wx_a, wy_a, bfAttachZ[az], 'x', null, bdsOff, BENCH_JOINT_BR_DECK, bdsInstall);
            addDeckScrew(wx_b, wy_b, bfAttachZ[az], 'x', null, bdsOff, BENCH_JOINT_BR_DECK, bdsInstall);
          }
        }

        /* Backrest frame joinery: corner posts ↔ top + bottom rails.
           Drilled on the rail's wide face (+X face in bf local frame,
           = the face that ends up behind the backrest planks). 2 holes
           per joint × 4 joints = 8. */
        var bfHostOff   = [-0.25, 0.55, 0];
        var bfMarkSetbk = 0.025;        /* stretcher Y setback (small) */
        var bfRailSetbk = 0.060;        /* backrest rails Z setback —
                                           60 mm from the post joint
                                           toward the rail's center, so
                                           the markers sit cleanly on
                                           the wide face and aren't
                                           crowded against the corner
                                           post or hanging off the rail
                                           end. */
        var bfProtrude  = 0.003;
        var bfClearH    = bfFrameH - 2 * t;
        var bfLocalX    = -w / 2;
        var bfXSpread   = w / 4;

        var bfRailMarkScale = [0.9, 0.30, 1.6];

        /* The TOP RAIL and the STRETCHERS each have their OWN local
           explode offset (+Y) applied inside bf — top rail moves +0.06
           local, stretchers +0.03 local. Both extra shifts must be
           composed onto the bf-group offset, ROTATED by rake, so the
           markers and cylinders end up exactly on/around the wood after
           the bench is exploded. Local +Y rotates to (-sinR, cosR, 0)
           in world. */
        var TOP_RAIL_LOCAL_Y  = 0.06;
        var STRETCHER_LOCAL_Y = 0.03;
        var bfTopHostOff = [
          bfHostOff[0] - TOP_RAIL_LOCAL_Y * sinR,
          bfHostOff[1] + TOP_RAIL_LOCAL_Y * cosR,
          bfHostOff[2]
        ];
        var bfStrHostOff = [
          bfHostOff[0] - STRETCHER_LOCAL_Y * sinR,
          bfHostOff[1] + STRETCHER_LOCAL_Y * cosR,
          bfHostOff[2]
        ];

        /* Insertion shifts:
           - BOTTOM rail (world frame, drilled from +Y top face)
                shift = +Y_world
           - TOP rail (bf local, drilled from -Y local → (sinR, -cosR, 0))
                shift = (sinR, -cosR, 0)            applied on bfTopHostOff
           - STRETCHERS (drilled from +Z local face, +Z world)
                shift = (0, 0, +1)                  applied on bfStrHostOff
        */
        var bfBotCylOff = [bfHostOff[0],
                           bfHostOff[1] + INSERT_SHIFT,
                           bfHostOff[2]];
        var bfTopCylOff = [bfTopHostOff[0] + INSERT_SHIFT * sinR,
                           bfTopHostOff[1] - INSERT_SHIFT * cosR,
                           bfTopHostOff[2]];

        /* Helper: bf local (lx, ly) → world (wx, wy). lz passes through
           unchanged (rake is around Z axis). */
        function bfL2W_X(lx, ly) { return bfPivotX + lx * cosR - ly * sinR; }
        function bfL2W_Y(lx, ly) { return bfPivotY + lx * sinR + ly * cosR; }

        for (var bc = 0; bc < bfCorners.length; bc++) {
          var cz = bfCorners[bc];
          var setbackZ = (cz > 0 ? -bfRailSetbk : bfRailSetbk);

          /* ── BOTTOM RAIL (laid flat, in world coords) ──────────
             Cylinders spaced in X at the joint Z, on the rail's
             centerline Y. Markers on the +Y top face.            */
          /* Marker pegged AT the bottom rail's top face (no
             protrude — half-decal stuck to wood). */
          var botMarkY = bfBotY0 + t / 2;
          [-bfXSpread, bfXSpread].forEach(function (dx) {
            addPocketHole(
              bfBotX + dx, bfBotY0, cz, '-z', bfHostOff,
              [bfBotX + dx, botMarkY, cz + setbackZ],
              bfBotCylOff, bfRailMarkScale, BENCH_JOINT_BR_FRAME, true
            );
          });

          /* ── TOP RAIL (laid flat inside bf, RAKED) ────────────
             Top rail center local = (bfLocalX, bfClearH + t/2, 0).
             Cylinders spread in local X, markers on local -Y face
             (bottom face, hidden by backrest planks above).      */
          var topCenterY_local = bfClearH + t / 2;
          /* Marker pegged exactly ON the bottom face (-Y) of the top
             rail. Half-oval inside the wood, half outside. With Y-scale
             of 0.30 × radius 0.011 = 3.3 mm total Y extent, the marker
             reads as a flat decal stuck to the surface, not a sphere
             floating below it. */
          var topBotY_local    = bfClearH;
          [-bfXSpread, bfXSpread].forEach(function (dx) {
            var cylLX  = bfLocalX + dx;
            var markLX = bfLocalX + dx;
            var cylWx  = bfL2W_X(cylLX, topCenterY_local);
            var cylWy  = bfL2W_Y(cylLX, topCenterY_local);
            var markWx = bfL2W_X(markLX, topBotY_local);
            var markWy = bfL2W_Y(markLX, topBotY_local);
            addPocketHole(
              cylWx, cylWy, cz, '-z', bfTopHostOff,
              [markWx, markWy, cz + setbackZ],
              bfTopCylOff, bfRailMarkScale, BENCH_JOINT_BR_FRAME, true
            );
          });
        }

        /* ── STRETCHERS (vzpěry) ↔ top + bottom rails ──────────
           Each internal stretcher takes 4 pocket holes: 2 at its
           TOP end (joining top rail above) and 2 at its BOTTOM
           end (joining bottom rail below). All drilled on the
           stretcher's +Z wide face. Screws drive along ±Y (axis
           'up-z' for both ends; the cylinder orientation is the
           same and the position tells the user which end). */
        if (nJoists > 0) {
          var bfStretcherCylOff = [bfStrHostOff[0],
                                   bfStrHostOff[1],
                                   bfStrHostOff[2] + INSERT_SHIFT];
          /* Marker on stretcher's +Z wide face, AT the surface
             (no protrude — sphere half-sinks into the wood). */
          var stretMarkFaceZ_localOff = t / 2;
          for (var bs = 0; bs < bfStretcherZ.length; bs++) {
            var sZ = bfStretcherZ[bs];
            [-bfXSpread, bfXSpread].forEach(function (dx) {
              var lx = bfLocalX + dx;
              var ly_cyl  = bfClearH;
              var ly_mark = bfClearH - bfMarkSetbk;
              var lz_mark = sZ + stretMarkFaceZ_localOff;
              addPocketHole(
                bfL2W_X(lx, ly_cyl), bfL2W_Y(lx, ly_cyl), sZ,
                'up-z', bfStrHostOff,
                [bfL2W_X(lx, ly_mark), bfL2W_Y(lx, ly_mark), lz_mark],
                bfStretcherCylOff, null, BENCH_JOINT_BR_STR, true
              );
            });
            [-bfXSpread, bfXSpread].forEach(function (dx) {
              var lx = bfLocalX + dx;
              var ly_cyl  = 0;
              var ly_mark = bfMarkSetbk;
              var lz_mark = sZ + stretMarkFaceZ_localOff;
              addPocketHole(
                bfL2W_X(lx, ly_cyl), bfL2W_Y(lx, ly_cyl), sZ,
                'up-z', bfStrHostOff,
                [bfL2W_X(lx, ly_mark), bfL2W_Y(lx, ly_mark), lz_mark],
                bfStretcherCylOff, null, BENCH_JOINT_BR_STR, true
              );
            });
          }
        }

        /* Backrest bottom rail ↔ rear long rail of seat frame.
           Lag bolts from BELOW the seat plane up through the back long
           rail into the backrest bottom rail. 2 lags per L direction. */
        var rearRailX = -halfW + w / 2;
        var lagTopY = bfBotY0 + t / 2;
        var lagUpOff = [0, INSERT_SHIFT, 0];
        var lagDividers = [bfCorners[0]].concat(bfStretcherZ, [bfCorners[1]]);
        lagDividers.sort(function (a, b) { return a - b; });
        for (var bi = 0; bi < lagDividers.length - 1; bi++) {
          var z0 = lagDividers[bi], z1 = lagDividers[bi + 1];
          addLag(rearRailX, lagTopY, z0 + 0.25 * (z1 - z0), 'y', lagUpOff, 20);
          addLag(rearRailX, lagTopY, z0 + 0.75 * (z1 - z0), 'y', lagUpOff, 20);
        }
        /* Both lags sit on the side-profile (corner-post) centreline, so
           they lean with the backrest tilt instead of stacking vertically.
           Express them in bf-local (constant X = post centreline, two Y
           heights) and convert to world via bfL2W — auto-follows rake. */
        var lagLocalX  = (-halfW + post / 2) - bfPivotX;
        var lagLocalY1 = 0.040;
        var lagLocalY2 = 0.120;
        var lagWX1 = bfL2W_X(lagLocalX, lagLocalY1), lagWY1 = bfL2W_Y(lagLocalX, lagLocalY1);
        var lagInZL = bfCorners[0] + t / 2;
        var lagInZR = bfCorners[1] - t / 2;
        addLag(lagWX1, lagWY1, lagInZL, 'z',  [0, 0,  INSERT_SHIFT], 20);
        addLag(lagWX1, lagWY1, lagInZR, '-z', [0, 0, -INSERT_SHIFT], 20);
        /* Second (upper) lag per side only when the backrest is tall enough
           (>= 0.8 ft); on a low backrest the upper lag would sit above the
           side structure and would not bite — then one lag per side. */
        if (backH >= 0.2438) {            /* ~0.8 ft */
          var lagWX2 = bfL2W_X(lagLocalX, lagLocalY2), lagWY2 = bfL2W_Y(lagLocalX, lagLocalY2);
          addLag(lagWX2, lagWY2, lagInZL, 'z',  [0, 0,  INSERT_SHIFT], 20);
          addLag(lagWX2, lagWY2, lagInZR, '-z', [0, 0, -INSERT_SHIFT], 20);
        }
      }
    },


    /* Placeholder builders. Each will be implemented like _buildParkBench
       in upcoming iterations once the renderer harness is verified. */
    _buildSofa: function () {
      /* Single sofa at the origin, full editable length. */
      this._sofaFrame({ L: STATE.L, cx: 0, cz: 0, rotY: 0, tagSuffix: '' });
    },

    /* Builds one sofa frame. opts:
         L         overall length (Z before rotation)
         cx, cz    centre of this unit in world space
         rotY      rotation about Y (radians) applied to the whole unit
         tagSuffix appended to idHints so assembly units don't collide
       Clean BUTT joints throughout — no member passes through another. */
    _sofaFrame: function (opts) {
      var T = global.THREE;
      var mats = this.materials;
      var self = this;
      var L = opts.L;
      var W = opts.W || STATE.W || SOFA.DEPTH;
      var cx = opts.cx || 0, cz = opts.cz || 0;
      var rotY = opts.rotY || 0;
      var sfx = opts.tagSuffix || '';
      /* v269: the porch swing (type 7, sofa style) passes its frame spec
         (_porchSofaLayout): its profile, the seat box, the back's rows, the
         platform -- the posts then start at the seat box underside (hung) */
      var PS = opts.spec || null;
      var BED_ = !!(PS && PS.bed);   /* v273: the bed -- no back rails, the top rail and rows only at the head (end A) */
      var armTop = PS ? PS.top : (STATE.H || SOFA.ARM_TOP);

      var P = PS ? PS.P : SOFA.POST;
      var CODE_POST = PS ? PS.code : SOFA.POST_CODE, CODE_RAIL = PS ? PS.code : SOFA.RAIL_CODE;
      var yFoot = PS ? PS.yB : 0;
      var SEAT_TOP = PS ? PS.seatTop : SOFA.SEAT_TOP;
      /* Level 2 (sofa): two-row backrest with telescoping height. STATE.H
         is the TOP rail height. The MIDDLE rail follows at half that height
         above the seat, clamped to 0.6–1.0 ft — so both rise together until
         the middle caps at 1.0 ft, after which only the top keeps rising. */
      var lvl2   = PS ? PS.lvl2 : (((STATE.variant | 0) === 2) && (STATE.lvl === 2));
      var topFrameH = armTop;                  /* STATE.H: lvl1 single frame, lvl2 top rail */
      var midFrameH = null;
      if (lvl2) {
        var midAbove = Math.max(SOFA.ABOVE_MIN,
                       Math.min(SOFA.ABOVE_MAX, (topFrameH - SOFA.SEAT_TOP) / 2));
        midFrameH = PS ? PS.mid : (SOFA.SEAT_TOP + midAbove);
      }
      var postH  = topFrameH - P - yFoot;
      var halfL = L / 2, halfW = W / 2;
      var SIDE_A_X =  halfW - P / 2;
      var SIDE_B_X = -halfW + P / 2;
      var END_A_Z  = -halfL + P / 2;
      var END_B_Z  =  halfL - P / 2;
      var innerW   = W - P * 2;
      var innerL   = L - P * 2;

      var cosR = Math.cos(rotY), sinR = Math.sin(rotY);
      /* place a member: (lx,ly,lz) is its centre in unit-local coords;
         we rotate around Y and translate to the unit centre. */
      var addPart = function (w, h, d, lx, ly, lz, partType, code, idHint, ex) {
        var wx = cx + (lx * cosR + lz * sinR);
        var wz = cz + (-lx * sinR + lz * cosR);
        var m = self._mkBox(w, h, d, mats.lumber, wx, ly, wz);
        if (rotY) m.rotation.y = rotY;
        self._addToScene(m, partType, { boqCode: code, length: Math.max(w, h, d), idHint: idHint + sfx });
        if (ex) m.userData.explodeOffset = ex;
        return m;
      };

      /* Place a wooden joinery dowel (cylinder) at unit-local (lx,ly,lz)
         with its axis along a local direction ('x','y','z'), rotated +
         translated like addPart. Visible pegs in the corner joints. */
      var addDowel = function (lx, ly, lz, axis, idHint, exOverride, holeRoles, holeFaces) {
        var r = SOFA.DOWEL_DIA / 2, len = SOFA.DOWEL_LEN;
        var geo = new T.CylinderGeometry(r, r, len, 12);
        if (axis === 'x') geo.rotateZ(Math.PI / 2);   /* axis → local X */
        else if (axis === 'z') geo.rotateX(Math.PI / 2); /* axis → local Z */
        /* axis === 'y' → cylinder already along Y */
        var m = new T.Mesh(geo, mats.dowel);
        var wx = cx + (lx * cosR + lz * sinR);
        var wz = cz + (-lx * sinR + lz * cosR);
        m.position.set(wx, ly, wz);
        if (rotY) m.rotation.y = rotY;
        /* Explode: pull out along the dowel axis (or a supplied override),
           rotated into world space. */
        var lex = exOverride || (
            (axis === 'y') ? [0, 0.18, 0]
          : (axis === 'x') ? [0.18, 0, 0]
          :                  [0, 0, 0.18]);
        m.userData.explodeOffset = [
          lex[0] * cosR + lex[2] * sinR,
          lex[1],
          -lex[0] * sinR + lex[2] * cosR
        ];
        self._addToScene(m, 'dowel', { boqCode: null, idHint: idHint + sfx });

        /* Drill-hole MOUTHS: a flat dark disc on each joined profile's
           face, on the dowel axis, where the dowel enters. Reads as the
           opening of a 12 mm bore. Each disc rides the profile it sits on
           (holeRoles[hh]) so it travels with that member during assembly. */
        var FACE_OFF = (SOFA.DOWEL_LEN / 2);   /* default: dowel half-length each side */
        var dr = SOFA.DOWEL_DIA / 2;
        var au = (axis === 'x') ? [1, 0, 0] : (axis === 'z') ? [0, 0, 1] : [0, 1, 0];
        /* axisCoord = the dowel's coordinate along its own axis */
        var axisCoord = (axis === 'x') ? lx : (axis === 'z') ? lz : ly;
        for (var hh = 0; hh < 2; hh++) {
          var sgn = hh ? 1 : -1;
          /* face position along the axis: explicit holeFaces[hh] if given,
             else dowel coord ± half its length. */
          var facePos = (holeFaces && typeof holeFaces[hh] === 'number')
                        ? holeFaces[hh]
                        : axisCoord + sgn * FACE_OFF;
          var dgeo = new T.CylinderGeometry(dr, dr, 0.004, 16);
          if (axis === 'x') dgeo.rotateZ(Math.PI / 2);   /* disc faces ±X */
          else if (axis === 'z') dgeo.rotateX(Math.PI / 2); /* disc faces ±Z */
          /* axis 'y' → disc already faces ±Y */
          var dm = new T.Mesh(dgeo, mats.dowelHole);
          var hlx = (axis === 'x') ? facePos : lx;
          var hly = (axis === 'y') ? facePos : ly;
          var hlz = (axis === 'z') ? facePos : lz;
          dm.position.set(cx + (hlx * cosR + hlz * sinR), hly, cz + (-hlx * sinR + hlz * cosR));
          if (rotY) dm.rotation.y = rotY;
          if (holeRoles && holeRoles[hh]) dm.userData.sofaRoleHint = holeRoles[hh];
          self._addToScene(dm, 'dowel-hole', { boqCode: null, idHint: idHint + '-hole' + hh + sfx });
        }
        return m;
      };

      /* Flat oval pocket-hole entry marker on a drilled face. faceAxis is
         the surface normal direction ('y' top/bottom, 'x' side, 'z' end).
         Hidden by default; assembly-step logic reveals it. */
      var addPocketMark = function (lx, ly, lz, faceAxis, idHint, exOverride) {
        var sg = new T.SphereGeometry(0.011, 14, 9);
        var m = new T.Mesh(sg, self.materials.pocketMarker || self.materials.screwCap);
        if (faceAxis === 'y')      m.scale.set(1.6, 0.4, 1.0);
        else if (faceAxis === 'x') m.scale.set(0.4, 1.6, 1.0);
        else                       m.scale.set(1.0, 1.6, 0.4);
        var wx = cx + (lx * cosR + lz * sinR);
        var wz = cz + (-lx * sinR + lz * cosR);
        m.position.set(wx, ly, wz);
        if (rotY) m.rotation.y = rotY;
        if (exOverride) {
          m.userData.explodeOffset = [
            exOverride[0] * cosR + exOverride[2] * sinR,
            exOverride[1],
            -exOverride[0] * sinR + exOverride[2] * cosR
          ];
        }
        m.userData.partType = 'pocket-marker';
        m.userData.basePos = m.position.clone();
        self._addToScene(m, 'pocket-marker', { idHint: idHint + sfx });
        return m;
      };

      /* Pocket-hole screw driven from a face into the mating member. dir
         is the drive direction ('up','down','+x','-x','+z','-z'). */
      var addPocketScrew = function (lx, ly, lz, dir, idHint, exOverride) {
        var wx = cx + (lx * cosR + lz * sinR);
        var wz = cz + (-lx * sinR + lz * cosR);
        var opts = { headRadius: 0.006, headHeight: 0.003, shaftRadius: 0.0028, shaftLen: 0.050 };
        var KREG = 0.30;    /* gentle lean for face-mounted screws */
        var PKT  = 1.15;    /* ~65° pocket-hole lean (shaft runs along the rail toward the joined profile) */
        /* _mkScrew: head +Y, shaft −Y. The head stays at the pocket (mark);
           the shaft leans steeply toward the profile being joined.
             pkXpos → shaft leans toward +X · pkXneg → toward −X
             pkZpos → toward +Z · pkZneg → toward −Z                       */
        if (dir === 'up' || dir === 'upXpos') { opts.rotX = Math.PI; opts.rotZ = -KREG; }
        else if (dir === 'upXneg') { opts.rotX = Math.PI; opts.rotZ = KREG; }
        else if (dir === 'upZpos') { opts.rotX = Math.PI - KREG; }
        else if (dir === 'upZneg') { opts.rotX = Math.PI + KREG; }
        else if (dir === 'pkXpos') { opts.rotZ =  PKT; }    /* shaft toward +X, tip down */
        else if (dir === 'pkXneg') { opts.rotZ = -PKT; }    /* shaft toward −X, tip down */
        else if (dir === 'pkZpos') { opts.rotX = -PKT; }    /* shaft toward +Z, tip down */
        else if (dir === 'pkZneg') { opts.rotX =  PKT; }    /* shaft toward −Z, tip down */
        else if (dir === 'pkXposU') { opts.rotX = Math.PI; opts.rotZ = -PKT; }  /* toward +X, tip up */
        else if (dir === 'pkXnegU') { opts.rotX = Math.PI; opts.rotZ =  PKT; }  /* toward −X, tip up */
        else if (dir === 'pkZposU') { opts.rotX = Math.PI + PKT; }              /* toward +Z, tip up */
        else if (dir === 'pkZnegU') { opts.rotX = Math.PI - PKT; }              /* toward −Z, tip up */
        else if (dir === 'downXpos') { opts.rotX = 0; opts.rotZ = KREG; }   /* shaft down, lean +X */
        else if (dir === 'downXneg') { opts.rotX = 0; opts.rotZ = -KREG; }  /* shaft down, lean −X */
        else if (dir === 'downZpos') { opts.rotX = KREG; }    /* shaft down, lean +Z */
        else if (dir === 'downZneg') { opts.rotX = -KREG; }   /* shaft down, lean −Z */
        else if (dir === 'down') opts.rotX = 0;
        else if (dir === '+x') opts.rotZ = -Math.PI / 2;
        else if (dir === '-x') opts.rotZ = Math.PI / 2;
        else if (dir === '+z') opts.rotX = -Math.PI / 2;
        else if (dir === '-z') opts.rotX = Math.PI / 2;
        if (rotY) opts.rotY = rotY;
        var g = self._mkScrew(wx, ly, wz, opts);
        g.userData.partType = 'screw-pocket';
        g.userData.basePos = g.position.clone();
        g.userData.screwDriveLen = (opts.shaftLen || 0.050) + (opts.headHeight || 0.003);
        self._addToScene(g, 'screw-pocket', { idHint: idHint + sfx });
        return g;
      };

      /* Plain wood screw (visible fastener) for slats + ledger. dir sets
         the drive direction the same way addPocketScrew does, but the head
         carries a BoQ code so it counts in the bill of materials. */
      var addWoodScrew = function (lx, ly, lz, dir, idHint, code, headOut) {
        var wx = cx + (lx * cosR + lz * sinR);
        var wz = cz + (-lx * sinR + lz * cosR);
        var opts = { headRadius: 0.006, headHeight: 0.003, shaftRadius: 0.0026, shaftLen: 0.050 };
        if (dir === 'up')        opts.rotX = Math.PI;
        else if (dir === 'down') opts.rotX = 0;
        else if (dir === '+x')   opts.rotZ = -Math.PI / 2;
        else if (dir === '-x')   opts.rotZ = Math.PI / 2;
        else if (dir === '+z')   opts.rotX = -Math.PI / 2;
        else if (dir === '-z')   opts.rotX = Math.PI / 2;
        if (rotY) opts.rotY = rotY;
        var g = self._mkScrew(wx, ly, wz, opts);
        /* Push the whole screw OUT along its head axis so the head sits on
           (just proud of) the surface rather than buried in the timber. */
        if (headOut) {
          var T = global.THREE;
          var hd = new T.Vector3(0, 1, 0).applyEuler(g.rotation).normalize();
          g.position.addScaledVector(hd, headOut);
        }
        g.userData.partType = 'screw-wood';
        g.userData.basePos = g.position.clone();
        g.userData.screwDriveLen = (opts.shaftLen || 0.050) + (opts.headHeight || 0.003);
        self._addToScene(g, 'screw-wood', { boqCode: code || null, idHint: idHint + sfx });
        return g;
      };

      /* One seat-box row (long rails innerL + 2 end rails innerW) at
         centreline Y. Reused for the lower seat and the lvl-2 middle row.
         skipFront omits the front long rail (used for the middle backrest
         row, which like the top frame stays open at the front). */
      var addSeatRow = function (cy, tag, skipFront) {
        if (!skipFront) {
          addPart(P, P, innerL, SIDE_A_X, cy, 0, 'rail-lower', CODE_RAIL, 'lower-side-a' + tag, [ 0.14, -0.10, 0]);
        }
        addPart(P, P, innerL, SIDE_B_X, cy, 0, 'rail-lower', CODE_RAIL, 'lower-side-b' + tag, [-0.14, -0.10, 0]);
        addPart(innerW, P, P, 0, cy, END_A_Z, 'rail-seat', CODE_RAIL, 'seat-rail-a' + tag, [0, -0.10, -0.20]);
        addPart(innerW, P, P, 0, cy, END_B_Z, 'rail-seat', CODE_RAIL, 'seat-rail-b' + tag, [0, -0.10,  0.20]);
      };

      var corners = [
        { x: SIDE_A_X, z: END_A_Z, role: 'post-a1' },
        { x: SIDE_B_X, z: END_A_Z, role: 'post-b1' },
        { x: SIDE_A_X, z: END_B_Z, role: 'post-a2' },
        { x: SIDE_B_X, z: END_B_Z, role: 'post-b2' }
      ];
      for (var i = 0; i < corners.length; i++) {
        var c = corners[i];
        /* Explode the WHOLE bočnice (each short end) outward along Z, so
           legs travel together with their end rails + dowels. */
        /* v273 the bed (type 14): the head posts (end A) reach under the
           headboard's top rail, the foot posts (and the head ones without a
           headboard) end flush with the rail tops */
        var pTopC = BED_ ? ((c.z < 0 && PS.headboard) ? (PS.top - P) : SEAT_TOP) : (topFrameH - P);
        var pHC = pTopC - yFoot;
        addPart(P, pHC, P, c.x, yFoot + pHC / 2, c.z, 'post', CODE_POST, c.role,
                [ 0, 0.06, c.z > 0 ? 0.20 : -0.20 ]);
      }

      var topY = topFrameH - P / 2;
      /* TOP back long rail — fits BETWEEN the end rails (innerL) so the
         full-width end rails own the corners; front stays open. */
      if (!BED_) addPart(P, P, innerL, SIDE_B_X, topY, 0, 'rail-arm', CODE_RAIL, 'arm-side-b', [-0.14, 0.12, 0]);
      /* FRONT top long rail — added for tall lvl-2 assemblies (> 6 ft) to
         brace the front posts; a mirror of the back top rail. */
      var hasTopFront = lvl2 && !BED_ && (armTop > 1.8288);   /* v274: never on the bed (its tall headboard has no long rails up there) */
      if (hasTopFront) {
        addPart(P, P, innerL, SIDE_A_X, topY, 0, 'rail-arm', CODE_RAIL, 'arm-side-a', [0.14, 0.12, 0]);
      }
      /* TOP end rails — span the FULL width W, reaching the outer face of
         the legs on both sides (they sit on top of the leg tops at each
         short end). */
      if (!BED_ || PS.headboard) addPart(W, P, P, 0, topY, END_A_Z, 'rail-top-end', CODE_RAIL, 'top-end-a', [0, 0.12, -0.20]);
      if (!BED_) addPart(W, P, P, 0, topY, END_B_Z, 'rail-top-end', CODE_RAIL, 'top-end-b', [0, 0.12,  0.20]);

      /* ── BOČNICE JOINTS (assembled first) ─────────────────────────────
         Front posts are at +X (SIDE_A_X), back posts at −X (SIDE_B_X).
         End rails run along X at each short end (±Z). Two joint types:

         Joint 1 — SEAT-END ↔ POST (lower end rail into leg):
           • 3 dowels, half in POST / half in SEAT-END, horizontal along Z
           • pocket marks on the UNDERSIDE of SEAT-END; screws drive up
             from SEAT-END into POST.
         Joint 2 — TOP-END ↔ POST (top end rail onto leg top):
           • 3 dowels vertical (down into the leg top)
           • FRONT post: marks on the INNER face, screws drive upward
           • BACK post:  marks on the BACK face,  screws drive upward     */
      var seatCY = SEAT_TOP - P / 2;          /* lower end-rail centre height */

      /* ── CENTER SUPPORT LEGS (long sofas, L > 2.8 m) ────────────────────
         Two vertical 4×4 legs at the middle of the length (z = 0): one
         under the FRONT lower long rail (SIDE_A_X), one under the BACK
         (SIDE_B_X). Each rises from the ground to the underside of the
         lower long rails and is dowelled UP into the rail (3 dowels, no
         pocket holes — this joint only carries vertical load). They join
         the long rails, so in the assembly they arrive with them (step 7).
         variant 2 only. */
      if ((!PS && (STATE.variant | 0) === 2 && L > 2.8) || (BED_ && PS.centerLeg)) {
        var clTopY  = BED_ ? (PS.crCY - P / 2) : (seatCY - P / 2);   /* underside of the lower long rails (the bed: of its centre rail) */
        var clH     = Math.max(0.05, clTopY);         /* ground -> rail underside */
        var clSides = BED_ ? [ { x: 0, t: 'c' } ] : [ { x: SIDE_A_X, t: 'a' }, { x: SIDE_B_X, t: 'b' } ];
        for (var cli = 0; cli < clSides.length; cli++) {
          var clx = clSides[cli].x, clt = clSides[cli].t;
          addPart(P, clH, P, clx, clH / 2, 0, 'post', CODE_POST,
                  'center-leg-' + clt, [0, -0.20, 0]);
          /* 3 dowels at the leg top, UP into the rail (axis y), spread
             across the rail width (X). */
          for (var cd = 0; cd < SOFA.DOWEL_PER_JOINT; cd++) {
            var cdx = (cd - (SOFA.DOWEL_PER_JOINT - 1) / 2) * (P * 0.28);
            /* hole0 = −Y (down into the leg top) rides the leg; hole1 = +Y
               (up into the rail) rides the long rail. Both discs sit at the
               leg/rail interface (clTopY). */
            addDowel(clx + cdx, clTopY, 0, 'y', 'dowel-center-' + clt + '-' + cd,
                     undefined, ['center-leg-' + clt, 'long'],
                     [clTopY, clTopY + 0.001]);
          }
        }
      }
      var postsJ = [
        { x: SIDE_A_X, side: 'front' },
        { x: SIDE_B_X, side: 'back' }
      ];
      var endsJ = [ { z: END_A_Z }, { z: END_B_Z } ];
      var nD = SOFA.DOWEL_PER_JOINT;
      for (var pj = 0; pj < postsJ.length; pj++) {
        for (var ej = 0; ej < endsJ.length; ej++) {
          var px = postsJ[pj].x, isFront = (postsJ[pj].side === 'front');
          var ez = endsJ[ej].z;
          var tag = '-' + postsJ[pj].side + (ez < 0 ? 'L' : 'R');

          /* Joint 1: SEAT-END ↔ POST. End rail runs along X and butts into
             the leg here. The 3 dowels enter along X (half rail / half
             leg) and sit INSIDE the P×P joint cross-section (spread in
             Z and Y). In the exploded view the WHOLE bočnice (this end's
             rails + legs + dowels + screws) slides out along Z, so the
             dowels share the SEAT-END rail's explode offset — they stay on
             the rail axis and travel with it, then animate back to base. */
          var jointX1 = px + (isFront ? -1 : 1) * (P / 2);   /* rail-end / leg interface */
          var dowelX1 = jointX1 + (isFront ? 1 : -1) * (P * 0.30); /* nudge into the leg so the dowel sits fully exposed */
          var endZdir = (ez < 0) ? -1 : 1;                   /* which short end */
          var sideExplode = [0, -0.10, endZdir * 0.20];      /* == SEAT-END rail */
          /* 3 dowels in a ROW across the rail width (Z), centred on the
             joint — matches a 3-hole doweling jig. */
          for (var d1 = 0; d1 < nD; d1++) {
            var dz1 = (d1 - (nD - 1) / 2) * (P * 0.28);
            var endTag1 = (ez < 0) ? 'A' : 'B';
            /* hole0 = −X side, hole1 = +X side. Front post sits at +X →
               +X bore rides the post, −X bore rides the SEAT-END rail. */
            var hr1 = isFront
              ? ['seatend-' + endTag1, 'post-' + endTag1]
              : ['post-' + endTag1, 'seatend-' + endTag1];
            /* face positions along X: rail end (railEndX) + leg inner face
               (jointX1), assigned to −X / +X holes by which side each is. */
            var hf1 = isFront ? [railEndX, jointX1] : [jointX1, railEndX];
            addDowel(dowelX1, seatCY, ez + dz1, 'x',
                     'dowel-seatend' + tag + '-' + d1, sideExplode, hr1, hf1);
          }
          /* Pocket marks on the UNDERSIDE of the SEAT-END rail, near the
             rail end (where it meets the leg). The rail spans x∈[−(W/2−P),
             +(W/2−P)] centred at 0; place the pair just inboard of the
             rail end on this side. The 2 holes sit SIDE BY SIDE across the
             rail width (Z). Screws tilt toward the leg (front leg at +X →
             tilt +X; back leg at −X → tilt −X). */
          var railEndX = (isFront ? 1 : -1) * (W / 2 - P);   /* this rail end */
          var markX1   = railEndX + (isFront ? -1 : 1) * (P * 0.30); /* a bit inboard */
          var underY1  = seatCY - P / 2 - 0.002;            /* mark + screw head on the face */
          var tiltDir1 = isFront ? 'pkXnegU' : 'pkXposU';   /* tips toward the post */
          for (var s1 = 0; s1 < 2; s1++) {
            var sdz1 = (s1 ? 1 : -1) * (P * 0.22);           /* across rail width (Z) */
            addPocketMark(markX1, underY1, ez + sdz1, 'y', 'pm-seatend' + tag + '-' + s1, sideExplode);
            addPocketScrew(markX1, underY1, ez + sdz1, tiltDir1, 'ps-seatend' + tag + '-' + s1, sideExplode);
          }

          /* Joint 2: TOP-END ↔ POST — 3 vertical dowels (axis Y) down into
             the leg top, spread across the post width (X). */
          if (BED_ && !(ez < 0 && PS.headboard)) continue;   /* v273: the bed's top rail only at the head */
          for (var d2 = 0; d2 < nD; d2++) {
            var ox2 = (d2 - (nD - 1) / 2) * (P * 0.28);
            var endTag2 = (ez < 0) ? 'A' : 'B';
            var postRole2 = (px < 0) ? 'post-B' : 'post-A';
            /* hole0 = −Y (down into the leg top) rides the post;
               hole1 = +Y (up into the TOP-END rail) rides the rail.
               Both discs sit at the rail/leg interface (topY − P/2). */
            var hr2 = [postRole2, 'topend-' + endTag2];
            var face2 = topY - P / 2;
            var hf2 = [face2, face2 + 0.001];
            addDowel(px + ox2, topY, ez, 'y', 'dowel-topend' + tag + '-' + d2, undefined, hr2, hf2);
          }
          /* Pocket marks ON the post's vertical face, just below the top
             end rail; 2 marks spread along Z. Front post → INNER face
             (toward −X). Back post → BACK face (toward −X, the outer back).
             Both screw upward into the rail. */
          var faceX2 = px - P / 2 - 0.001;             /* −X face of the post */
          var markY2 = topY - P / 2 - 0.02;            /* on the post, just under the rail */
          for (var s2 = 0; s2 < 2; s2++) {
            var dz2 = (s2 ? 1 : -1) * (P * 0.22);
            addPocketMark(faceX2, markY2, ez + dz2, 'x', 'pm-topend' + tag + '-' + s2);
            /* mark sits on the post's −X face; the screw drives UP and
               leans toward +X (into the post body / up to the rail). */
            addPocketScrew(faceX2, markY2, ez + dz2, 'upXneg', 'ps-topend' + tag + '-' + s2);
          }
        }
      }

      /* ── MID SHORT-RAIL JOINTS (lvl2 sofa only) ───────────────────────
         The lvl-2 middle row adds a second SEAT-style short end rail on
         each bočnice. It gets the SAME joint as the lower SEAT-END rail:
         3 dowels in a row into the post + 2 pocket marks/screws driving
         up toward the post. Only for the sofa (variant 2) at lvl 2; never
         affects the park bench or lvl-1 sofa. */
      /* v274: the bed's headboard carries any number of middle rails
         (PS.mids, their tops); ids '-mid-', '-mid2-', '-mid3-' ... */
      var midTopsJ = (BED_ && PS.mids) ? PS.mids : ((lvl2 && midFrameH != null) ? [midFrameH] : []);
      for (var mjr = 0; mjr < midTopsJ.length; mjr++) {
        var midCY = midTopsJ[mjr] - P / 2, midTg = '-mid' + (mjr ? String(mjr + 1) : '') + '-';
        for (var pjm = 0; pjm < postsJ.length; pjm++) {
          for (var ejm = 0; ejm < endsJ.length; ejm++) {
            var pxm = postsJ[pjm].x, isFrontM = (postsJ[pjm].side === 'front');
            var ezm = endsJ[ejm].z;
            if (BED_ && ezm > 0) continue;   /* v273: the bed's middle rail only in the headboard */
            var tagM = midTg + postsJ[pjm].side + (ezm < 0 ? 'L' : 'R');
            var jointXm  = pxm + (isFrontM ? -1 : 1) * (P / 2);
            var dowelXm  = jointXm + (isFrontM ? 1 : -1) * (P * 0.30);
            var endZdirM = (ezm < 0) ? -1 : 1;
            var sideExplodeM = [0, -0.10, endZdirM * 0.20];
            for (var dm = 0; dm < nD; dm++) {
              var dzm = (dm - (nD - 1) / 2) * (P * 0.28);
              var endTagM = (ezm < 0) ? 'A' : 'B';
              var hrm = isFrontM
                ? ['seatend-' + endTagM, 'post-' + endTagM]
                : ['post-' + endTagM, 'seatend-' + endTagM];
              var railEndXm2 = (isFrontM ? 1 : -1) * (W / 2 - P);
              var hfm = isFrontM ? [railEndXm2, jointXm] : [jointXm, railEndXm2];
              addDowel(dowelXm, midCY, ezm + dzm, 'x',
                       'dowel-seatend' + tagM + '-' + dm, sideExplodeM, hrm, hfm);
            }
            var railEndXm = (isFrontM ? 1 : -1) * (W / 2 - P);
            var markXm    = railEndXm + (isFrontM ? -1 : 1) * (P * 0.30);
            var underYm   = midCY - P / 2 - 0.002;
            var tiltDirM  = isFrontM ? 'pkXnegU' : 'pkXposU';
            for (var sm = 0; sm < 2; sm++) {
              var sdzm = (sm ? 1 : -1) * (P * 0.22);
              addPocketMark(markXm, underYm, ezm + sdzm, 'y', 'pm-seatend' + tagM + '-' + sm, sideExplodeM);
              addPocketScrew(markXm, underYm, ezm + sdzm, tiltDirM, 'ps-seatend' + tagM + '-' + sm, sideExplodeM);
            }
          }
        }
      }

      /* ── LONG-RAIL JOINTS (front/back/top into the bočnice posts) ─────
         The long rails run along Z and meet the legs at both short ends.
         Dowels enter along Z (out of the rail end into the leg). They sit
         in the rail cross-section and DON'T ride the bočnice — so when the
         bočnice slides out in step 1 the dowels stay put, floating midway
         between the rail end and the leg. Pocket marks + screws too.
         Long-rail definitions:
           SEAT-FRONT  x=SIDE_A_X  y=seatCY
           SEAT-BACK   x=SIDE_B_X  y=seatCY
           TOP-BACK    x=SIDE_B_X  y=topY                                  */
      (function () {
        var longRails = [
          { x: SIDE_A_X, y: seatCY, key: 'seatfront' },
          { x: SIDE_B_X, y: seatCY, key: 'seatback' }
        ];
        if (!BED_) longRails.push({ x: SIDE_B_X, y: topY,   key: 'topback' });
        /* v273: the bed's centre rail into the end rails -- its top flush with
           the ledgers, so it sits lower than the end rails: the dowels in the
           band the two share, no pocket screws (the centre leg carries it) */
        if (BED_ && PS.centerRail) longRails.push({ x: 0, y: PS.crDY, key: 'centerrail', noPkt: true });
        /* tall lvl-2: add the FRONT top long rail joint (mirror of topback). */
        if (hasTopFront) {
          longRails.push({ x: SIDE_A_X, y: topY, key: 'topfront' });
        }
        /* lvl-2 sofa adds a MID back long rail (lower-side-b-mid) at the
           middle height — give it the SAME joint as SEAT-BACK. */
        if (lvl2 && midFrameH != null && !BED_) {
          longRails.push({ x: SIDE_B_X, y: midFrameH - P / 2, key: 'midback' });
        }
        var endZ = [ { z: END_A_Z, s: -1 }, { z: END_B_Z, s: 1 } ];
        var railHalf = innerL / 2;     /* long rail runs to ±innerL/2 in Z */
        for (var li = 0; li < longRails.length; li++) {
          var lr = longRails[li];
          for (var ei2 = 0; ei2 < endZ.length; ei2++) {
            var zc = endZ[ei2].z, zs = endZ[ei2].s;
            var rtag = '-' + lr.key + (zs < 0 ? 'A' : 'B');
            /* Joint sits between the rail end (z = zs*railHalf) and the leg
               face. Push the dowels OUT past the rail end so they sit in
               open space (fully exposed) toward the post. */
            var jz = zs * railHalf + zs * (P * 0.45);
            var postRoleL = (lr.x < 0) ? 'post-B' : 'post-A';
            /* The TOP-BACK rail joins at the very top of the posts, level
               with the TOP-END short rails. Its post-side bore must ride
               the TOP-END rail (same explode lift + step-5 animation), NOT
               the post — otherwise it floats away in the exploded view.
               Other long rails (seat level) keep the post role. */
            var endTagL = (zs < 0) ? 'A' : 'B';
            var postSideRole = (lr.key === 'topback' || lr.key === 'topfront') ? ('topend-' + endTagL) : (lr.key === 'centerrail') ? ('seatend-' + endTagL) : postRoleL;
            /* hole0 = −Z, hole1 = +Z. End A (zs<0): rail extends +Z (inward)
               → +Z bore in the rail (static 'long'), −Z bore in the post.
               End B (zs>0): reversed. */
            var hrL = (zs < 0) ? [postSideRole, 'long'] : ['long', postSideRole];
            var railFaceZ = zs * railHalf;          /* rail end face */
            var postFaceZ = zc - zs * (P / 2);       /* leg inner face */
            /* End A (zs<0): −Z=post, +Z=rail. End B (zs>0): −Z=rail, +Z=post. */
            var hfL = (zs < 0) ? [postFaceZ, railFaceZ] : [railFaceZ, postFaceZ];
            for (var dd = 0; dd < nD; dd++) {
              var ddx = (dd - (nD - 1) / 2) * (P * 0.28);   /* row across rail width (X) */
              addDowel(lr.x + ddx, lr.y, jz, 'z', 'dowel-' + lr.key + rtag + '-' + dd, undefined, hrL, hfL);
            }
            if (lr.noPkt) continue;   /* v273: the bed's centre rail -- dowels only */
            /* Pocket marks on the UNDERSIDE of the rail near its end; the
               2 holes sit side by side across the rail width (X). Screws
               drive up and lean along Z toward the post (bočnice). Applies
               to all long rails including the top ones. */
            var mz = zs * railHalf - zs * (P * 0.15);   /* just inboard of the rail end */
            var markYL = lr.y - P / 2 - 0.002;          /* UNDER face */
            var tiltL = (zs < 0) ? 'pkZnegU' : 'pkZposU';  /* shaft to the post, tip up */
            for (var ss = 0; ss < 2; ss++) {
              var moff = (ss ? 1 : -1) * (P * 0.22);     /* across rail width (X) */
              addPocketMark(lr.x + moff, markYL, mz, 'y', 'pm-' + lr.key + rtag + '-' + ss);
              addPocketScrew(lr.x + moff, markYL, mz, tiltL, 'ps-' + lr.key + rtag + '-' + ss);
            }
          }
        }
      })();

      /* Level 2 middle row — seat-box row (no front rail) at the derived
         middle height. */
      if (lvl2 && !BED_) {
        addSeatRow(midFrameH - P / 2, '-mid', true);
      } else if (lvl2 && BED_) {
        for (var mrb = 0; mrb < PS.mids.length; mrb++)   /* v273: the headboard's middle rail; v274: every one of them */
          addPart(innerW, P, P, 0, PS.mids[mrb] - P / 2, END_A_Z, 'rail-seat', CODE_RAIL, 'seat-rail-a-mid' + (mrb ? String(mrb + 1) : ''), [0, -0.10, -0.20]);
      }
      /* v275: the bed headboard's infill (PS.fill, _bedInfill) -- upright
         2x2 slats on the profile's axis, or the crossed 1x4 boards in two
         layers either side of it; a dowel at every piece end into the
         frame (ids 'dowel-infill-...', no screws). It comes with the head
         side frame in the assembly (role seatend-A, group 'side'). */
      if (BED_ && PS.fill && (PS.fill.slats.length || PS.fill.planks.length)) {
        var FL = PS.fill, fi, pq;
        var infDowel = function (lx, ly, lz, axis, id, face) {
          addDowel(lx, ly, lz, axis, 'dowel-infill-' + id, undefined, ['seatend-A', 'seatend-A'], [face, face + 0.001]);
        };
        for (fi = 0; fi < FL.slats.length; fi++) {
          var sl = FL.slats[fi];
          addPart(sl.w, sl.len, sl.w, sl.x, (sl.y0 + sl.y1) / 2, END_A_Z, 'bed-infill', BED.SLAT_CODE, 'bed-slat-' + fi);
          infDowel(sl.x, sl.y0, END_A_Z, 'y', 's' + fi + 'b', sl.y0);
          infDowel(sl.x, sl.y1, END_A_Z, 'y', 's' + fi + 't', sl.y1);
        }
        for (fi = 0; fi < FL.planks.length; fi++) {
          var pk = FL.planks[fi], pcx = 0, pcy = 0;
          for (pq = 0; pq < pk.poly.length; pq++) { pcx += pk.poly[pq][0]; pcy += pk.poly[pq][1]; }
          pcx /= pk.poly.length; pcy /= pk.poly.length;
          var psh = new T.Shape();
          psh.moveTo(pk.poly[0][0] - pcx, pk.poly[0][1] - pcy);
          for (pq = 1; pq < pk.poly.length; pq++) psh.lineTo(pk.poly[pq][0] - pcx, pk.poly[pq][1] - pcy);
          var pgeo = new T.ExtrudeGeometry(psh, { depth: pk.t, bevelEnabled: false, curveSegments: 1 });
          pgeo.translate(0, 0, -pk.t / 2);
          var pmh = new T.Mesh(pgeo, mats.lumber);
          pmh.position.set(cx + pcx, pcy, cz + pk.z);
          self._addToScene(pmh, 'bed-infill', { boqCode: BED.CROSS_CODE, length: pk.len, idHint: 'bed-board-' + fi + sfx });
          for (pq = 0; pq < 2; pq++) { var pe = pk.ends[pq]; infDowel(pe.x, pe.y, pk.z, pe.axis, 'b' + fi + (pq ? 't' : 'b'), (pe.axis === 'x') ? pe.x : pe.y); }
        }
      }
      /* v273: the bed's centre rail (wide beds): head rail to foot rail at
         mid width, its top flush with the ledgers' top under the slats */
      if (BED_ && PS.centerRail) addPart(P, P, innerL, 0, PS.crCY, 0, 'rail-lower', CODE_RAIL, 'lower-centerrail', [0, -0.10, 0]);

      /* LOWER seat box — between the legs. */
      var lowY = SEAT_TOP - P / 2;
      addSeatRow(lowY, '', false);

      /* ── Inner LEDGER battens (rošt support) ─────────────────────────
         38×38 on the INSIDE face of the front + back lower long rails.
         Their top sits one rošt-thickness + 1 inch below the rail top, so
         a 2×4 rošt laid on them finishes ~1 inch below the seat-box top
         face (recess that helps hold the mattress). variant 2 only. */
      if ((STATE.variant | 0) === 2 || PS) {
        var lw = PS ? PS.Pr.ld : SOFA.LEDGER_W;
        var ledgerTopY = PS ? PS.ledTop : (SOFA.SEAT_TOP - SOFA.ROST_CLEARANCE - SOFA.ROST_THICK);
        var rT = PS ? PS.Pr.rt : SOFA.ROST_THICK, rCode = PS ? PS.rostCode : SOFA.ROST_CODE;
        var ledgerCY   = ledgerTopY - lw / 2;
        var backLX  = SIDE_B_X + P / 2 + lw / 2;   /* inside face of back rail (toward +X) */
        var frontLX = SIDE_A_X - P / 2 - lw / 2;   /* inside face of front rail (toward −X) */
        addPart(lw, lw, innerL, backLX,  ledgerCY, 0, 'ledger', SOFA.LEDGER_CODE, 'ledger-back',  [-0.10, -0.06, 0]);
        addPart(lw, lw, innerL, frontLX, ledgerCY, 0, 'ledger', SOFA.LEDGER_CODE, 'ledger-front', [ 0.10, -0.06, 0]);

        /* Ledger screws (FAS50060): driven horizontally from the ledger
           INTO the long rail, ~1 per 30 cm along the length. The head sits
           on the ledger's inner face (toward the seat interior) and points
           inward, so in the exploded view they read clearly. Back ledger
           is at +X → screw heads face +X (inward); front at −X → −X. */
        var ledSpacing = 0.30;
        var ledN = Math.max(2, Math.floor(innerL / ledSpacing) + 1);
        for (var lsi = 0; lsi < ledN; lsi++) {
          var lsz = -innerL / 2 + (ledN > 1 ? lsi * (innerL / (ledN - 1)) : innerL / 2);
          /* back ledger: head on its +X (inner) face, screw drives −X into rail */
          addWoodScrew(backLX + lw / 2 + 0.001, ledgerCY, lsz, '+x',
                       'ws-ledger-back-' + lsi, SOFA.LEDGER_SCREW_CODE);
          /* front ledger: head on its −X (inner) face, screw drives +X into rail */
          addWoodScrew(frontLX - lw / 2 - 0.001, ledgerCY, lsz, '-x',
                       'ws-ledger-front-' + lsi, SOFA.LEDGER_SCREW_CODE);
        }

        /* Rošt: 2×4 boards laid flat across X (front↔back), resting ON the
           ledgers, spread along Z with ~2 inch gaps. Span the interior
           width between the rail inner faces. */
        var rw   = PS ? PS.Pr.rw : SOFA.ROST_WIDTH;
        var rTop = ledgerTopY;                         /* boards sit on ledger top */
        var rCY  = rTop + rT / 2;
        var rLen = innerW;                             /* back rail face → front rail face */
        var rcc  = rw + SOFA.ROST_GAP;
        var rSpan = Math.max(rw, innerL - rw);
        var rN    = Math.max(2, Math.floor(rSpan / rcc) + 1);
        for (var ri2 = 0; ri2 < rN; ri2++) {
          var rz = -rSpan / 2 + (rN > 1 ? ri2 * (rSpan / (rN - 1)) : 0);
          addPart(rLen, rT, rw, 0, rCY, rz, 'rost', rCode, 'rost-' + ri2, [0, -0.04, 0]);
          /* v273: the bed's slats are FIXED -- 2 screws a slat end down into
             the ledger (+ 2 into the centre rail of a wide bed) */
          if (BED_) {
            var sxs = [backLX, frontLX].concat(PS.centerRail ? [0] : []), sxi, sdz;
            for (sxi = 0; sxi < sxs.length; sxi++) for (sdz = -1; sdz <= 1; sdz += 2)
              addWoodScrew(sxs[sxi], rTop + rT, rz + sdz * rw * 0.25, 'down', 'ws-slat-bed-' + ri2 + '-' + sxi + (sdz < 0 ? 'a' : 'b'), PS.SCREW || 'FAS50060', 0.002);
          }
        }

        /* Mattress cushions sit ON TOP of the seat box: bottom flush with
           the rail top face, spanning the FULL sofa depth (back edge →
           front edge). Split along the length: 1 up to 159 cm, +1 per
           80 cm beyond. A small gap separates split cushions. */
        var matBottom = SEAT_TOP;                 /* flush with rail top face */
        var matCY  = matBottom + SOFA.MAT_THICK / 2;
        var matW   = W;                           /* full depth: back → front edge */
        var matN   = Math.max(1, Math.floor((L * 100) / (SOFA.MAT_SPLIT * 100)));
        var matSpanZ = innerL - SOFA.MAT_INSET * 2;
        var matLen = (matSpanZ - (matN - 1) * SOFA.MAT_GAP) / matN;
        for (var mi = 0; mi < ((PS && !PS.cushion) ? 0 : matN); mi++) {   /* v269: the porch swing's cushions follow its button */
          var mz = -matSpanZ / 2 + matLen / 2 + mi * (matLen + SOFA.MAT_GAP);
          var cu = self._mkCushion(matW, matLen, SOFA.MAT_THICK, mats.fabric);
          cu.position.set(cx + (0 * cosR + mz * sinR), matCY, cz + (-0 * sinR + mz * cosR));
          if (rotY) cu.rotation.y = rotY;
          self._addToScene(cu, 'cushion', { boqCode: null, idHint: 'cushion-' + mi + sfx });
          cu.userData.explodeOffset = [0, 0.10, 0];
        }

        /* Throw pillows against the back: one per 85 cm, plump 60×40
           ellipsoids (no flat faces), two alternating colours. Placed
           casually — uneven spacing, varied lean (some stand more upright,
           some recline more) and a slight askew yaw. Deterministic per
           index so it stays stable across rebuilds. */
        var pillowN = PS ? PS.pillowN : Math.max(1, Math.round(L / SOFA.PILLOW_PER));
        /* Actual pillow thickness (X) + height (Y): from the loaded model
           (real scale × uniform scale, oriented thickness→X, height→Y,
           length→Z) when available, else the fallback box dims. */
        var pdimT = SOFA.PILLOW_T, pdimH = SOFA.PILLOW_H;   /* v263: the procedural pillow, no GLB */
        var pBackX  = -W / 2 + P + pdimT / 2 + 0.01;   /* flush against the back, leaning on it */
        var pBaseY  = SEAT_TOP + SOFA.MAT_THICK;
        /* Don't draw the procedural fallback pillows at all: they would
           flash for a frame before the GLB arrives. If the model isn't
           ready yet, kick off the load (rebuild once it lands) and skip
           the pillow loop entirely this pass — the sofa simply renders
           without pillows until the real model is in. */
        if (false) {
        } else {
        var prand = function (k) { var x = Math.sin(k * 127.1 + (sfx ? sfx.length : 0) * 13.7) * 43758.5453; return x - Math.floor(x); };
        for (var pi = 0; pi < pillowN; pi++) {
          var r1 = prand(pi * 2 + 1), r2 = prand(pi * 2 + 2), r3 = prand(pi * 3 + 5);
          var slot = -innerL / 2 + innerL * (pi + 0.5) / pillowN;
          var plz  = slot + (r1 - 0.5) * 0.14;        /* ±7 cm jitter — uneven */
          var lean = 0.08 + r2 * 0.16;                /* ~5°–14° lean back (upright against the rail) */
          var yaw  = (r3 - 0.5) * 0.18;               /* slight askew */
          var pmat = (pi % 2 === 0) ? mats.pillowA : mats.pillowB;
          var pil  = self._mkPillow(SOFA.PILLOW_W, SOFA.PILLOW_H, SOFA.PILLOW_T, pmat, r3 * 7 + pi);
          pil.geometry.rotateZ(lean);                 /* top tips toward the back (−X) */
          /* Seat the leaned pillow so its lowest edge rests on the mattress
             (account for both the height and the tilted thickness). */
          var pY = pBaseY + (pdimH / 2) * Math.cos(lean) + (pdimT / 2) * Math.sin(lean) - 0.03;
          pil.position.set(cx + (pBackX * cosR + plz * sinR), pY, cz + (-pBackX * sinR + plz * cosR));
          pil.rotation.y = rotY + yaw;
          self._addToScene(pil, 'pillow', { boqCode: null, idHint: 'pillow-' + pi + sfx });
          pil.userData.explodeOffset = [-0.05, 0.20, 0];
        }
        }
      }

      /* ── Vertical SLATS (shading / decoration) ────────────────────────
         On the selected outer faces, from 15 cm above ground up to the top
         rail underside. Spacing is driven by the batten width (centre-to-
         centre ≈ 2× width → a gap of about one batten). variant 2 only. */
      if ((STATE.variant | 0) === 2 && (STATE.slats | 0) > 0) {
        var st = SOFA.slatState(STATE.slats, SOFA.isTall(STATE));
        if (st.bits && st.profile) {
          var sp = MATERIALS[st.profile];
          var sw = sp ? sp.profile.w : 0.038;
          var slatBottom = SOFA.SLAT_GROUND;
          var slatTop    = topFrameH;              /* up to the very top edge */
          var slatH      = Math.max(0.05, slatTop - slatBottom);
          var slatCY     = slatBottom + slatH / 2;
          var slatGap    = (STATE.slatGap != null) ? STATE.slatGap : SOFA.GAP_DEF;
          /* When TOP slats interlock with BACK slats, the gap between back
             slats must be at least one profile width so a top slat drops
             into each gap without the corner profiles crossing/colliding. */
          if ((st.bits & SOFA.SLAT_TOP) && (st.bits & SOFA.SLAT_BACK)) {
            slatGap = Math.max(slatGap, sw);
          }
          var cc         = sw + slatGap;            /* centre-to-centre = width + gap */

          /* place one vertical slat; extraTop extends it upward (back slats
             grow by one top-slat thickness so they reach the top slats). */
          var addSlat = function (lx, lz, idHint, extraTop) {
            extraTop = extraTop || 0;
            var h = slatH + extraTop;
            var m = self._mkBox(sw, h, sw,
                                mats.lumber,
                                cx + (lx * cosR + lz * sinR),
                                slatCY + extraTop / 2,
                                cz + (-lx * sinR + lz * cosR));
            if (rotY) m.rotation.y = rotY;
            self._addToScene(m, 'slat', { boqCode: st.profile, length: h, idHint: idHint });
          };

          /* Slat screws (FAS50060): one at each rail the slat crosses,
             driven along the slat's own axis into the rail — head on the
             OUTER edge (furthest from centre) so it shows in the exploded
             view. Crossing rails: top rail (topY) and the lower long rail
             (seatCY). 'face' is the slat's outward face axis/sign. */
          var slatRailYs = [topY, seatCY];
          if (lvl2 && midFrameH != null) slatRailYs.push(midFrameH - P / 2);
          var addSlatScrews = function (lx, lz, dir, idHint) {
            for (var sri = 0; sri < slatRailYs.length; sri++) {
              addWoodScrew(lx, slatRailYs[sri], lz, dir,
                           idHint + '-' + sri, SOFA.SLAT_SCREW_CODE, sw / 2);
            }
          };

          /* BACK face (−X long side): slats spread along Z, just outside −X.
             When TOP slats are also present, extend each back slat up by one
             slat thickness so the top slats sit in the gaps and interlock. */
          if (st.bits & SOFA.SLAT_BACK) {
            var backExtra = (st.bits & SOFA.SLAT_TOP) ? sw : 0;
            var bx = SIDE_B_X - P / 2 - sw / 2;
            var zSpan = L - sw, zN = Math.max(2, Math.floor(zSpan / cc) + 1);
            for (var bi = 0; bi < zN; bi++) {
              var bz = -L / 2 + sw / 2 + (zN > 1 ? bi * (zSpan / (zN - 1)) : zSpan / 2);
              addSlat(bx, bz, 'slat-back-' + bi, backExtra);
              addSlatScrews(bx, bz, '-x', 'ws-slat-back-' + bi);
            }
          }
          /* LEFT end (−Z short side): slats spread along X, just outside −Z. */
          if (st.bits & SOFA.SLAT_LEFT) {
            var lz0 = END_A_Z - P / 2 - sw / 2;
            var xSpanL = W - sw, xNL = Math.max(2, Math.floor(xSpanL / cc) + 1);
            for (var li = 0; li < xNL; li++) {
              var lx0 = -W / 2 + sw / 2 + (xNL > 1 ? li * (xSpanL / (xNL - 1)) : xSpanL / 2);
              addSlat(lx0, lz0, 'slat-left-' + li);
              addSlatScrews(lx0, lz0, '+z', 'ws-slat-left-' + li);
            }
          }
          /* RIGHT end (+Z short side): slats spread along X, just outside +Z. */
          if (st.bits & SOFA.SLAT_RIGHT) {
            var rz0 = END_B_Z + P / 2 + sw / 2;
            var xSpanR = W - sw, xNR = Math.max(2, Math.floor(xSpanR / cc) + 1);
            for (var ri = 0; ri < xNR; ri++) {
              var rx0 = -W / 2 + sw / 2 + (xNR > 1 ? ri * (xSpanR / (xNR - 1)) : xSpanR / 2);
              addSlat(rx0, rz0, 'slat-right-' + ri);
              addSlatScrews(rx0, rz0, '-z', 'ws-slat-right-' + ri);
            }
          }
          /* TOP slats — horizontal, lying ACROSS the depth (X) on top of the
             two top rails (front + back), spread along the length (Z). Only
             on tall assemblies (top front rail exists).
               • no back slats → span the full sofa depth (W).
               • with back slats → extend at the BACK by one slat thickness
                 (sw) and sit in the GAPS between the back slats, creating an
                 interlocked, solid top-back edge. */
          if (st.bits & SOFA.SLAT_TOP) {
            var hasBackSlats = !!(st.bits & SOFA.SLAT_BACK);
            var topSlatY = topY + P / 2 + sw / 2;        /* resting on the rail top faces */
            var topLen   = W + (hasBackSlats ? sw : 0);  /* extend over the back when interlocking */
            var topCX    = hasBackSlats ? (-sw / 2) : 0; /* shift the extension to the −X (back) side */
            /* place one horizontal top slat (spans X), at length-position lz */
            var addTopSlat = function (lz, idHint) {
              var m = self._mkBox(topLen, sw, sw, mats.lumber,
                                  cx + (topCX * cosR + lz * sinR),
                                  topSlatY,
                                  cz + (-topCX * sinR + lz * cosR));
              if (rotY) m.rotation.y = rotY;
              self._addToScene(m, 'slat', { boqCode: st.profile, length: topLen, idHint: idHint });
              /* 2 screws driven DOWN into the front + back top rails */
              addWoodScrew(SIDE_A_X, topSlatY, lz, 'down', 'ws-' + idHint + '-sf', SOFA.SLAT_SCREW_CODE, sw / 2);
              addWoodScrew(SIDE_B_X, topSlatY, lz, 'down', 'ws-' + idHint + '-sb', SOFA.SLAT_SCREW_CODE, sw / 2);
            };
            if (hasBackSlats) {
              /* interleave: drop a top slat into each GAP between back slats */
              var bzSpan = L - sw, bzN = Math.max(2, Math.floor(bzSpan / cc) + 1);
              for (var ti = 0; ti < bzN - 1; ti++) {
                var z0 = -L / 2 + sw / 2 + ti * (bzSpan / (bzN - 1));
                var z1 = -L / 2 + sw / 2 + (ti + 1) * (bzSpan / (bzN - 1));
                addTopSlat((z0 + z1) / 2, 'slat-top-' + ti);
              }
            } else {
              /* no back slats → even spacing along the length */
              var tzSpan = L - sw, tzN = Math.max(2, Math.floor(tzSpan / cc) + 1);
              for (var tj = 0; tj < tzN; tj++) {
                var tz = -L / 2 + sw / 2 + (tzN > 1 ? tj * (tzSpan / (tzN - 1)) : tzSpan / 2);
                addTopSlat(tz, 'slat-top-' + tj);
              }
            }
          }
        }
      }

      /* ── Teardown-role tagging (sofa) ─────────────────────────────────
         Classify every part for the 3-phase teardown:
           sofaRole: 'side-end-A'/'side-end-B' (bočnice end groups: posts,
                     SEAT-END, TOP-END + their dowels/screws),
                     'long' (front/back/top long rails + their joinery),
                     'top-end-A'/'top-end-B' (the TOP-END rail itself, lifts
                     in phase 2), 'post-A'/'post-B' (split in phase 3).
         The end (A = −Z, B = +Z) is read from each part's Z sign. */
      (function () {
        var grp = global.BenchEngine && global.BenchEngine.benchGroup;
        if (!grp) return;
        grp.children.forEach(function (c) {
          var ud = c.userData || {};
          if (ud.sofaRole) return;
          var pt = ud.partType, id = (ud.idHint || '') + '';
          var endA = (c.position.z < 0);   /* −Z end = A */
          if (pt === 'post') {
            ud.sofaRole = endA ? 'post-A' : 'post-B';
          } else if (pt === 'bed-infill' || (pt === 'dowel' && id.indexOf('dowel-infill') === 0)) {
            ud.sofaRole = 'seatend-A';                /* v275: the bed headboard's infill rides its end rail */
          } else if (pt === 'rail-seat') {            /* SEAT-END */
            ud.sofaRole = endA ? 'seatend-A' : 'seatend-B';
          } else if (pt === 'rail-top-end') {         /* TOP-END */
            ud.sofaRole = endA ? 'topend-A' : 'topend-B';
          } else if (pt === 'dowel' && id.indexOf('dowel-seatend') === 0) {
            /* SEAT-END↔POST dowel: rides the bočnice in step 1 (with both
               members), then the joint opens in step 3 (post splits X) →
               dowel goes HALF the split, then holds. */
            ud.sofaRole = endA ? 'dwl-seatend-A' : 'dwl-seatend-B';
          } else if (pt === 'screw-pocket' && id.indexOf('ps-seatend') === 0) {
            ud.sofaRole = endA ? 'seatend-A' : 'seatend-B';
          } else if (pt === 'pocket-marker' && id.indexOf('pm-seatend') === 0) {
            ud.sofaRole = endA ? 'seatend-A' : 'seatend-B';
          } else if (pt === 'dowel' && id.indexOf('dowel-topend') === 0) {
            /* TOP-END↔POST dowel: rides the bočnice in step 1, then the
               joint opens in step 2 (TOP-END lifts Y) → dowel goes HALF
               the lift, then holds. */
            ud.sofaRole = endA ? 'dwl-topend-A' : 'dwl-topend-B';
          } else if (pt === 'screw-pocket' && id.indexOf('ps-topend') === 0) {
            /* TOP-END screws drive INTO the post (pocket on the post face),
               so they ride the post — same as their marks — not the rail. */
            ud.sofaRole = (c.position.x < 0) ? 'post-B' : 'post-A';
          } else if (pt === 'pocket-marker' && id.indexOf('pm-topend') === 0) {
            /* TOP-END pocket holes are drilled INTO the post face, so the
               marker stays on the post (does not ride the lifting rail). */
            ud.sofaRole = (c.position.x < 0) ? 'post-B' : 'post-A';
          } else if (pt === 'dowel' && id.indexOf('dowel-') === 0) {
            /* Long-rail dowel (seatfront/seatback/topback): joint opens in
               step 1 (bočnice slides Z, rail stays) → dowel goes HALF the
               slide, then holds. */
            ud.sofaRole = endA ? 'dwl-long-A' : 'dwl-long-B';
          } else if (pt === 'dowel-hole') {
            /* Each bore rides the profile it is drilled into — role set at
               build time via sofaRoleHint. Falls back to 'long' (static). */
            ud.sofaRole = ud.sofaRoleHint || 'long';
          } else {
            ud.sofaRole = 'long';   /* long rails, ledger, rošt, slats, soft */
          }
        });
      })();

      /* Scale figure attached centrally in build(). */
    },

    /* Assembly preview (sofa viz stage 5): the current sofa in the middle
       with two single-cushion "armchairs" angled inwards. Non-editable. */
    _buildSofaAssembly: function () {
      var W = STATE.W || SOFA.DEPTH;
      var chairL = SOFA.CUSHION + SOFA.POST * 2;   /* 1-module chair (default length) */
      var chairW = SOFA.DEPTH;                     /* default depth — a basic chair, not the stretched sofa */
      var sofaL  = STATE.L;
      var HALF = Math.PI / 2;

      /* Conversational U-set. The sofa stays where the user configured it
         (length along Z, open front facing +X). Two DEFAULT-size chairs sit
         in FRONT of the sofa (+X), spread apart near/just beyond the sofa
         ends, each turned 90° and faced INWARD so their fronts look across
         an open centre (room for a coffee table). */
      var fwd  = W / 2 + chairL / 2 + 0.45;        /* clear of the sofa front */
      /* Spread the chairs so each chair's FRONT (inner) face lines up with
         the sofa's side (end) rail plane at Z = ±sofaL/2. The chair faces
         inward and its depth is chairW, so its centre sits half a chair
         beyond the sofa end. */
      var side = sofaL / 2 + chairW / 2;
      this._sofaFrame({ L: sofaL,  cx: 0,   cz: 0,     rotY: 0,      tagSuffix: '-sofa'  });
      this._sofaFrame({ L: chairL, W: chairW, cx: fwd, cz: -side, rotY: -HALF, tagSuffix: '-chairL' });
      this._sofaFrame({ L: chairL, W: chairW, cx: fwd, cz:  side, rotY:  HALF, tagSuffix: '-chairR' });
    },

    _buildPicnicSet:     function () { this._buildPlaceholder('Picnic Set (coming soon)'); },
    _buildHeavyTimber:   function () { this._buildPlaceholder('Heavy Timber (coming soon)'); },
    /* PICNIC SET (variant 5) -- everything from _picnicLayout. */
    _buildPicnic: function () {
      var T = global.THREE, self = this, mats = this.materials, i;
      var g = _picnicLayout(STATE), P = g.P, L = g.L;
      function poly(pts, depth, mat) {
        var sh = new T.Shape();
        sh.moveTo(pts[0][0], pts[0][1]);
        for (var k = 1; k < pts.length; k++) sh.lineTo(pts[k][0], pts[k][1]);
        var geo = new T.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: false, curveSegments: 2 });
        geo.translate(0, 0, -depth / 2);
        return new T.Mesh(geo, mat);
      }
      for (i = 0; i < g.tops.length; i++) {
        var tb = self._mkBox(P.bW, P.bT, L, mats.lumber, g.tops[i].x, g.tops[i].y, 0);
        self._addToScene(tb, 'picnic-top', { boqCode: P.boardCode, length: L, idHint: 'top-' + (i + 1) });
      }
      for (i = 0; i < g.cleats.length; i++) {
        var cl = g.cleats[i];
        var cm = self._mkBox(cl.len, P.cW, P.cT, mats.lumber, 0, cl.y, cl.z);
        self._addToScene(cm, cl.mid ? 'picnic-cleat-mid' : 'picnic-cleat', { boqCode: P.cleatCode, length: cl.len, idHint: 'cleat-' + (i + 1) });   /* the middle one goes in with the diagonals */
      }
      for (i = 0; i < g.legs.length; i++) {
        var lg = g.legs[i], leg = poly(lg.pts, P.bT, mats.lumber);
        leg.position.set(0, 0, lg.z);
        self._addToScene(leg, 'picnic-leg', { boqCode: P.boardCode, length: lg.len, idHint: 'leg-' + (i + 1) });
      }
      for (i = 0; i < g.braces.length; i++) {
        var br = g.braces[i];
        var bm = self._mkBox(br.len, P.bW, P.bT, mats.lumber, 0, br.y, br.z);
        self._addToScene(bm, 'picnic-brace', { boqCode: P.boardCode, length: br.len, idHint: 'seat-brace-' + (i + 1) });
      }
      for (i = 0; i < g.seats.length; i++) {
        var sb = self._mkBox(P.bW, P.bT, L, mats.lumber, g.seats[i].x, g.seats[i].y, 0);
        self._addToScene(sb, 'picnic-seat', { boqCode: P.boardCode, length: L, idHint: 'seat-' + (i + 1) });
      }
      for (i = 0; i < g.diags.length; i++) {
        /* the cut outline (z, y) extruded across x (as the swings' knee braces) */
        var d = g.diags[i], dsh = new T.Shape(), k2;
        dsh.moveTo(d.pts[0][0], d.pts[0][1]);
        for (k2 = 1; k2 < d.pts.length; k2++) dsh.lineTo(d.pts[k2][0], d.pts[k2][1]);
        var dgeo = new T.ExtrudeGeometry(dsh, { depth: P.cT, bevelEnabled: false, curveSegments: 1 });
        dgeo.translate(0, 0, -P.cT / 2);
        dgeo.rotateY(-Math.PI / 2);                                   /* shape x -> world z, extrusion -> world x */
        var dm = new T.Mesh(dgeo, mats.lumber);
        self._addToScene(dm, 'picnic-diag', { boqCode: P.cleatCode, length: d.len, idHint: 'diagonal-' + (i + 1) });
      }
      /* SEPARATE BENCHES: the A-frames, the cleats, the rails, the diagonals */
      var bn = g.bench;
      for (i = 0; i < bn.legs.length; i++) {
        var blg = bn.legs[i], bleg = poly(blg.pts, P.cT, mats.lumber);
        bleg.position.set(0, 0, blg.z);
        self._addToScene(bleg, 'picnic-bench-leg', { boqCode: P.cleatCode, length: blg.len, idHint: 'bench-leg-' + (i + 1) });
      }
      for (i = 0; i < bn.cleats.length; i++) {
        var bc = bn.cleats[i];
        var bcm = self._mkBox(bc.len, P.cW, P.cT, mats.lumber, bc.x, bc.y, bc.z);
        self._addToScene(bcm, bc.mid ? 'picnic-bench-cleat-mid' : 'picnic-bench-cleat', { boqCode: P.cleatCode, length: bc.len, idHint: 'bench-cleat-' + (i + 1) });
      }
      for (i = 0; i < bn.rails.length; i++) {
        var brl = bn.rails[i];
        var brm = self._mkBox(brl.len, P.cW, P.cT, mats.lumber, brl.x, brl.y, brl.z);
        self._addToScene(brm, 'picnic-bench-rail', { boqCode: P.cleatCode, length: brl.len, idHint: 'bench-rail-' + (i + 1) });
      }
      for (i = 0; i < bn.diags.length; i++) {
        var bd = bn.diags[i], bsh = new T.Shape(), kb;
        bsh.moveTo(bd.pts[0][0], bd.pts[0][1]);
        for (kb = 1; kb < bd.pts.length; kb++) bsh.lineTo(bd.pts[kb][0], bd.pts[kb][1]);
        var bgeo = new T.ExtrudeGeometry(bsh, { depth: P.cT, bevelEnabled: false, curveSegments: 1 });
        bgeo.translate(0, 0, -P.cT / 2);
        bgeo.rotateY(-Math.PI / 2);
        var bdm = new T.Mesh(bgeo, mats.lumber);
        bdm.position.x = bd.x;
        self._addToScene(bdm, 'picnic-bench-diag', { boqCode: P.cleatCode, length: bd.len, idHint: 'bench-diagonal-' + (i + 1) });
      }
      /* bolt heads on the legs' outer faces (the washers + nuts are inside the frame) */
      var hexMat = mats.metal || mats.lumber;
      for (i = 0; i < bn.bolts.length; i++) {
        var bb2 = bn.bolts[i];
        var bhd = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.007, 6), hexMat);
        bhd.rotation.x = Math.PI / 2;
        bhd.position.set(bb2.x, bb2.y, bb2.z + (bb2.z < 0 ? -0.0035 : 0.0035));
        bhd.userData.driveDir = [0, 0, (bb2.z < 0 ? -1 : 1)]; bhd.userData.driveLen = 0.12;
        self._addToScene(bhd, 'picnic-hw-bench-bolt', { boqCode: PICNIC.BOLT_CODE, idHint: 'bench-bolt-' + (i + 1) });
      }
      /* v259: the screws, each kind its own step */
      for (i = 0; i < g.screws.length; i++) {
        var sw = g.screws[i];
        self._addFastener(sw, 'picnic-hw-screw-' + sw.kind, PICNIC.SCREW_CODE, 'screw-' + sw.kind + '-' + (i + 1));
      }
      try {
        var keyP = Math.round(L * 100) + '|' + (P.kid ? 2 : 1) + '|' + g.sep + '|' + (STATE.isMetric === false);
        if (keyP !== _picnicLogKey) {
          _picnicLogKey = keyP;
          var bqP = global.BenchBoQ._computePicnic(STATE);
          _dbg('[picnic] ' + L.toFixed(2) + ' m, ' + (P.kid ? 'kids' : 'adult') + ', benches ' + (g.sep ? 'separate' : 'attached') + ', width ' + g.width.toFixed(3) + ' m; ' +
               Object.keys(bqP.byMaterial).sort().map(function (c) { var v = bqP.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
        }
      } catch (eP) {}
      for (i = 0; i < g.bolts.length; i++) {
        var b = g.bolts[i];
        var head = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.007, 6), hexMat);
        head.rotation.x = Math.PI / 2;
        head.position.set(b.x, b.y, b.z + (b.z < 0 ? -0.0035 : 0.0035));
        head.userData.driveDir = [0, 0, (b.z < 0 ? -1 : 1)]; head.userData.driveLen = 0.14;   /* v259: driven in from outside */
        self._addToScene(head, 'picnic-hw-bolt', { boqCode: PICNIC.BOLT_CODE, idHint: 'bolt-' + (i + 1) });
      }
      /* v261: the separate benches set down loose -- each turned about its
         own centre and shifted along the table (every part of it, the
         screws' drive axes too) */
      if (g.sep && g.bench.place.length === 2) {
        var BSET = { 'picnic-seat': 1, 'picnic-bench-leg': 1, 'picnic-bench-cleat': 1, 'picnic-bench-cleat-mid': 1, 'picnic-bench-rail': 1, 'picnic-bench-diag': 1,
                     'picnic-hw-bench-bolt': 1, 'picnic-hw-screw-seat': 1, 'picnic-hw-screw-rail': 1, 'picnic-hw-screw-bdiag': 1 };
        global.BenchEngine.benchGroup.children.forEach(function (c) {
          var ud = c.userData || {};
          if (!BSET[ud.partType]) return;
          var bbS = new T.Box3().setFromObject(c);                         /* the side from where it is drawn (some geometry sits in world x) */
          var pl = g.bench.place[((bbS.min.x + bbS.max.x) < 0) ? 0 : 1], a = pl.yaw * Math.PI / 180, ca2 = Math.cos(a), sa2 = Math.sin(a);
          var qY = new T.Quaternion().setFromAxisAngle(new T.Vector3(0, 1, 0), a);
          var dx = c.position.x - pl.x, dz = c.position.z;
          c.position.set(pl.x + dx * ca2 + dz * sa2, c.position.y, -dx * sa2 + dz * ca2 + pl.dz);
          c.quaternion.premultiply(qY);
          if (ud.driveDir) { var d0 = ud.driveDir; ud.driveDir = [d0[0] * ca2 + d0[2] * sa2, d0[1], -d0[0] * sa2 + d0[2] * ca2]; }
          ud.basePos = c.position.clone();
        });
      }
    },
    /* ----------------------------------------------------------
       TYPE 7 - Porch swing. Draws _porchLayout(STATE); the BoQ sums the
       same layout. X = depth (front +), Y = up, Z = width.
       ---------------------------------------------------------- */
    _buildPorch: function () {
      var mats = this.materials, self = this, i;
      if (_porchStyle(STATE) === 'classic') { self._buildPorchClassic(); return; }   /* v278 */
      if (_porchStyle(STATE) === 'sofa') { self._buildPorchSofa(); return; }
      var g = _porchLayout(STATE);
      self._drawPorchSeat(g);
      /* the porch beam: context only, not billed */
      var bmM = self._mkBox(g.beam.sx, g.beam.sy, g.beam.sz, mats.context || mats.lumber, g.beam.x, g.beam.y, 0);
      self._addToScene(bmM, 'porch-context', { idHint: 'porch-beam' });
      /* log once per change of width / back / height / mattress */
      try {
        var key = Math.round(g.L * 100) + '|' + Math.round(g.beta) + '|' + Math.round(g.H * 100) + '|' + g.cushion;
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computePorch(STATE);
          _dbg('[porch] width ' + g.L.toFixed(3) + ' m, depth ' + g.depth.toFixed(3) + ' m, back ' + Math.round(g.beta) + ' deg, beam ' + g.H.toFixed(2) +
               ' m, joists ' + g.nJ + ', KVH10060 ' + (bq.byMaterial.KVH10060 || 0).toFixed(2) + ' m, chain ' + (bq.byMaterial.FAT00004 || 0).toFixed(2) +
               ' m (' + g.chains.map(function (c) { return c.len.toFixed(2); }).join(' / ') + '), mattress ' + (g.cushion ? 'on' : 'off'));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[porch] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* The porch seat of a _porchLayout (types 7 and 8): frame, planks,
       arms, the hinged back, the hangers, eye bolts and chains, the
       mattress. */
    /* v278 TYPE 7, CLASSIC: the pieces and fasteners of _porchClassicLayout,
       the hanging, the cushion, the pillow, the beam (context) */
    _buildPorchClassic: function (gIn) {
      var mats = this.materials, self = this, i;
      var g = gIn || _porchClassicLayout(STATE);   /* v296 gIn: the pergola swing's seat (no porch beam, its own log) */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], b = pc.box;
        var m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        if (b[6]) m.rotation.z = b[6];
        self._addToScene(m, 'pcl-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.screws.length; i++) {
        var f = g.screws[i];
        self._addFastener(f, 'pcl-hw-screw-' + f.kind, f.code, 'screw-' + f.kind + '-' + (i + 1));
      }
      for (i = 0; i < g.bolts.length; i++) self._addFastener(g.bolts[i], 'pcl-hw-bolt', g.rod ? SWING.ROD_CODE : PCL.BOLT, 'bolt-' + (i + 1));   /* v298 rods on the pergola swing */
      for (i = 0; i < g.brads.length; i++) self._addFastener(g.brads[i], 'pcl-hw-brad-' + g.brads[i].kind, null, 'brad-' + g.brads[i].kind + '-' + (i + 1));   /* v282 no catalogue row */
      self._drawHanging(g);
      if (g.pad) {
        var cu = self._mkCushion(g.pad.sx, g.pad.sz, g.pad.sy, mats.fabric);
        cu.position.set(g.pad.x, g.pad.y, 0);
        self._addToScene(cu, 'cushion', { boqCode: 'FOU00016', idHint: 'cushion-seat' });
      }
      var pl = g.pillows; pl.w = 0.44; pl.h = 0.42; pl.t = 0.16; pl.tag = 'porch-';
      self._addPillows(pl);
      if (gIn) return;
      var bmM = self._mkBox(g.beam.sx, g.beam.sy, g.beam.sz, mats.context || mats.lumber, g.beam.x, g.beam.y, 0);
      self._addToScene(bmM, 'porch-context', { idHint: 'porch-beam' });
      try {
        var key = 'classic|' + Math.round(g.L * 100) + '|' + Math.round(g.H * 100) + '|' + g.cushion + '|' + (STATE.isMetric === false) + '|' + g.fill + '|' + Math.round(g.gapT * 1000);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computePorchClassic(STATE);
          _dbg('[porch] classic ' + g.L.toFixed(3) + ' x ' + g.depth.toFixed(3) + ' m, seat ' + g.nSlats + ' x ' + PCL.SLAT_CODE + ' planks front to back (gap ' + Math.round(g.gapSeat * 1000) + ' mm), back ' + g.nBack + ' ' + g.fill + ' ' + Math.round(g.backW * 1000) + ' mm of ' + PCL.BSLAT_CODE + ' (gap ' + Math.round(g.gapBack * 1000) + ' mm, slider ' + Math.round(g.gapT * 1000) + ')' +
               ' in the rails\' grooves (' + Math.round(g.groove * 1000) + ' mm deep, ' + g.nFillet + ' fillets ' + Math.round(g.fillGap * 1000) + ' mm, ' + g.nStrip + ' strips a 1x4 = ' + g.fillBoardM.toFixed(2) + ' m, glue ' + g.glueL + ' l, ' + g.brads.length + ' brads, play ' + Math.round(g.endClr * 1000) + ' mm a end, ends + fillet faces coated ' + g.coatEnds.toFixed(3) + ' m2), ' + PCL.RECLINE + ' deg, beam ' + g.H.toFixed(2) + ' m, chain ' + g.chains.map(function (c) { return c.len.toFixed(2); }).join(' / ') + ', cushion ' + (g.cushion ? 'on' : 'off') + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[porch] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* TYPE 7, SOFA STYLE: the sofa's box frame (lighter profile) with its
       cushions and pillows, hung on a chain V per end under the beam. */
    _buildPorchSofa: function () {
      var mats = this.materials, self = this, i;
      var g = _porchSofaLayout(STATE);
      /* v269: the sofa's own frame builder -- its members, corner joints
         (dowels + pocket screws), ledgers, platform, cushions and pillows --
         in the 3x3, hung (the posts start at the seat box underside) */
      self._sofaFrame({ L: g.L, W: g.W, spec: g });
      self._drawHanging(g);
      var bmM = self._mkBox(g.beam.sx, g.beam.sy, g.beam.sz, mats.context || mats.lumber, g.beam.x, g.beam.y, 0);
      self._addToScene(bmM, 'porch-context', { idHint: 'porch-beam' });
      try {
        var key = 'sofa|' + Math.round(g.L * 100) + '|' + Math.round(g.H * 100) + '|' + Math.round(g.back * 1000) + '|' + g.cushion + '|' + (STATE.isMetric === false);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computePorchSofa(STATE);
          _dbg('[porch] sofa frame ' + PSOFA.CODE + ' ' + Math.round(g.P * 1000) + ' mm: ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(2) + ' m, back ' + Math.round(g.back * 100) + ' cm above the seat box (' + (g.lvl2 ? 'two rows' : 'one rail') + '), beam ' + g.H.toFixed(2) +
               ' m, joints ' + g.frameJoints + ', cushions ' + (g.cushion ? g.matN : 0) + ', pillows ' + g.pillowN + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[porch] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v273 TYPE 14 -- BED: the sofa's frame with the bed's spec (the
       headboard, the slats screwed down, the centre rail and leg of a wide
       bed), the white mattress on the slats. */
    _buildBed: function () {
      var mats = this.materials, self = this, i;
      var g = _bedLayout(STATE);
      self._sofaFrame({ L: g.L, W: g.W, spec: g });
      if (!mats.mattWhite) mats.mattWhite = new global.THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.96, metalness: 0.0, emissive: 0xffffff, emissiveIntensity: 0.55 });   /* white: the emissive keeps it from going grey in the shade */
      var mt = self._mkCushion(g.matt.w, g.matt.l, g.matt.t, mats.mattWhite);
      mt.position.set(0, g.matt.y + g.matt.t / 2, 0);
      self._addToScene(mt, 'bed-mattress', { boqCode: BED.MATT_CODE, idHint: 'bed-mattress' });
      try {
        var key = 'bed|' + g.size.n + '|' + Math.round(g.top * 1000) + '|' + g.headboard + '|' + g.headStyle + '|' + (STATE.isMetric === false);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeBed(STATE);
          _dbg('[bed] ' + g.size.n + ', frame ' + BED.CODE + ' ' + Math.round(g.P * 1000) + ' mm: ' + g.W.toFixed(3) + ' x ' + g.L.toFixed(3) + ' m, rails ' + g.seatTop.toFixed(2) +
               ' m, headboard ' + (g.headboard ? (g.top.toFixed(2) + ' m ' + g.headStyle + (g.headStyle === 'slats' ? ' ' + g.fill.slats.length + ' x ' + BED.SLAT_CODE : g.headStyle === 'cross' ? ' ' + g.fill.planks.length + ' boards (' + g.fill.planks.map(function (b) { return Math.round(b.ang); }).join('/') + ' deg)' : '') + ' (' + (g.mids.length + 1) + (g.mids.length ? ' rails' : ' rail') + ', openings ' + Math.round((g.mids.length ? ((g.top - g.mattTop) / g.nOpen - g.P) : g.open) * 1000) + ' mm)') : 'off') + ', slats ' + g.rN + (g.centerRail ? ' on a centre rail + leg' : '') +
               ', joints ' + g.frameJoints + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
        }
      } catch (eL) {}
    },
    /* The hanging of a porch-type layout g (types 7, 8): swing hangers in
       the beam (plate at g.H), the eye bolts g.eyeF + g.eyeR (shank from
       .face out to the eye), the chains g.chains link by link. */
    _drawHanging: function (g) {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      /* hangers in the beam */
      for (i = 0; i < g.hangers.length; i++) {
        var hg = g.hangers[i];
        var alX = !!g.pergola;   /* v296 under a rafter (60 wide): the plate and its screws along the rafter */
        var plate = alX ? self._mkBox(0.10, 0.008, 0.05, mats.metal, hg.x, g.H - 0.004, hg.z) : self._mkBox(0.05, 0.008, 0.10, mats.metal, hg.x, g.H - 0.004, hg.z);
        self._addToScene(plate, 'swing-hw-plate', { boqCode: SWING.HANGER_CODE });
        var rod = new T.Mesh(new T.CylinderGeometry(0.005, 0.005, SWING.HANGER_DROP - 0.02, 8), mats.metal);
        rod.position.set(hg.x, g.H - (SWING.HANGER_DROP - 0.02) / 2 - 0.008, hg.z);
        self._addToScene(rod, 'swing-hw-rod', { boqCode: SWING.HANGER_CODE });
        var ring = new T.Mesh(new T.TorusGeometry(0.022, 0.005, 8, 20), mats.metal);
        ring.position.set(hg.x, hg.y, hg.z);
        self._addToScene(ring, 'swing-hw-hanger', { boqCode: SWING.HANGER_CODE, idHint: 'hanger-' + (i + 1) });
        var hsc = g.hangerScrew || { code: SWING.HANGER_SCREW, len: 0.16 };   /* v296 the pergola's rafter: 6x100 */
        for (var hq = -1; hq <= 1; hq += 2)   /* v264: the plate's 2 x 6x160 up into the beam, drawn */
          self._addFastener({ x: hg.x + (alX ? hq * 0.035 : 0), y: g.H - 0.008, z: hg.z + (alX ? 0 : hq * 0.035), dir: [0, 1, 0], len: hsc.len }, 'swing-hw-screw-hanger', hsc.code, 'hanger-screw');
      }
      /* eye bolts: the front ones in the arm posts, the rear ones in the back stiles */
      var eyes = g.eyeF.concat(g.eyeR);
      for (i = 0; i < eyes.length; i++) {
        var ey = eyes[i], sgn = (ey.z > 0) ? 1 : -1, out = ey.vert ? Math.abs(ey.y - ey.face) : Math.abs(ey.z - ey.face);
        var shank = new T.Mesh(new T.CylinderGeometry(0.005, 0.005, out, 8), mats.metal);
        if (ey.vert) shank.position.set(ey.x, ey.face + out / 2, ey.z);   /* an eye standing up out of a seat (type 13) */
        else { shank.rotation.x = Math.PI / 2; shank.position.set(ey.x, ey.y, ey.face + sgn * out / 2); }
        self._addToScene(shank, 'swing-hw-shank', { boqCode: SWING.EYE_CODE });
        var eye = new T.Mesh(new T.TorusGeometry(0.018, 0.004, 8, 18), mats.metal);
        eye.rotation.y = Math.PI / 2;
        eye.position.set(ey.x, ey.y, ey.z);
        self._addToScene(eye, 'swing-hw-eye', { boqCode: SWING.EYE_CODE, idHint: 'eye-' + (i + 1) });
      }
      /* chains link by link along their 3D direction */
      var linkGeo = new T.TorusGeometry(SWING.LINK_PITCH * 0.42, 0.0026, 6, 14);
      linkGeo.scale(1, 1.7, 1);
      var qa = new T.Quaternion(), qb = new T.Quaternion(), mtx = new T.Matrix4();
      var vy = new T.Vector3(0, 1, 0), one = new T.Vector3(1, 1, 1), pos = new T.Vector3(), dir = new T.Vector3();
      for (i = 0; i < g.chains.length; i++) {
        var ch = g.chains[i];
        dir.set(ch.b.x - ch.a.x, ch.b.y - ch.a.y, ch.b.z - ch.a.z).normalize();
        var nL = Math.max(2, Math.floor(ch.len / SWING.LINK_PITCH));
        var im = new T.InstancedMesh(linkGeo, mats.metal, nL);
        qa.setFromUnitVectors(vy, dir);
        for (k = 0; k < nL; k++) {
          var tt = (k + 0.5) / nL;
          qb.setFromAxisAngle(vy, (k % 2) ? Math.PI / 2 : 0);
          pos.set(ch.a.x + (ch.b.x - ch.a.x) * tt, ch.a.y + (ch.b.y - ch.a.y) * tt, ch.a.z + (ch.b.z - ch.a.z) * tt);
          mtx.compose(pos, qa.clone().multiply(qb), one);
          im.setMatrixAt(k, mtx);
        }
        im.instanceMatrix.needsUpdate = true;
        self._addToScene(im, 'swing-hw-chain', { boqCode: SWING.CHAIN_CODE, length: ch.len, idHint: 'chain-' + (i + 1) + (ch.rear ? '-rear' : '-front') });
      }
    },
    _drawPorchSeat: function (g) {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var CODE = PORCH.FRAME_CODE;
      for (i = 0; i < g.boxes.length; i++) {
        var b = g.boxes[i];
        var m = self._mkBox(b.sx, b.sy, b.sz, mats.lumber, b.x, b.y, b.z);
        self._addToScene(m, 'porch-' + b.kind, { boqCode: CODE, length: b.len, idHint: b.id });
      }
      /* v307 the braced armrests: one notched board each -- the inner part
         to the back's plank face, the outer part on along the stile (two
         extrusions in the seat's side plane, one piece) */
      for (i = 0; i < (g.armPolys || []).length; i++) {
        var ap = g.armPolys[i], ag = new T.Group();
        ap.parts.forEach(function (pp) {
          var ash = new T.Shape(), aq;
          ash.moveTo(pp.poly[0][0], pp.poly[0][1]);
          for (aq = 1; aq < pp.poly.length; aq++) ash.lineTo(pp.poly[aq][0], pp.poly[aq][1]);
          var age = new T.ExtrudeGeometry(ash, { depth: pp.t, bevelEnabled: false, curveSegments: 2 });
          age.translate(0, 0, pp.c - pp.t / 2);
          var am = new T.Mesh(age, mats.lumber);
          am.userData.pgPoly = { pts: pp.poly, plane: 'xy', c: pp.c, t: pp.t };   /* the harness's in-wood test */
          self._addEdges(am);
          ag.add(am);
        });
        self._addToScene(ag, 'porch-' + ap.kind, { boqCode: CODE, length: ap.len, idHint: ap.id });
      }
      /* the back: local x = its normal v, local y = up the back u */
      for (i = 0; i < g.tilted.length; i++) {
        var q = g.tilted[i];
        var tm = self._mkBox(q.sv, q.su, q.sz, mats.lumber, q.x, q.y, q.z);
        tm.rotation.z = g.betaRad;
        self._addToScene(tm, 'porch-' + q.kind, { boqCode: CODE, length: q.len, idHint: q.id });
      }
      /* M10 bolt heads on the arm posts */
      for (i = 0; i < g.bolts.length; i++) {
        var bo = g.bolts[i];
        var head = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.007, 6), mats.metal);
        head.rotation.x = Math.PI / 2;
        head.position.set(bo.x, bo.y, bo.z + (bo.z < 0 ? -0.0035 : 0.0035));
        self._addToScene(head, 'porch-hw-bolt', { boqCode: PORCH.BOLT_CODE, idHint: 'bolt-' + (i + 1) });
      }
      /* hinges at the seat's back edge: the knuckle on the plank face line
         (strap hinge FAT00022, billed since v258, its code on it since v300) */
      for (i = 0; i < g.hinges.length; i++) {
        var hn = g.hinges[i];
        var kn = new T.Mesh(new T.CylinderGeometry(0.005, 0.005, 0.08, 10), mats.metal);
        kn.rotation.x = Math.PI / 2;
        kn.position.set(hn.x, hn.y, hn.z);
        self._addToScene(kn, 'swing-hw-hinge', { boqCode: CAT_NEW.STRAP_HINGE, idHint: 'hinge-' + (i + 1) });
      }
      /* v300 the seat's screws (g.screws = the bill) */
      for (i = 0; i < (g.screws || []).length; i++) { var fs = g.screws[i]; self._addFastener(fs, fs.part, fs.code, fs.id); }
      self._drawHanging(g);   /* hangers, eye bolts, chains */
      /* the mattress: seat pad + back pad (flat, they make the bed) -- ONE
         folding mattress, so one piece (v300: was 2 pieces for 1 billed) */
      if (g.pads) {
        var ps = g.pads.seat, pb = g.pads.back, mg = new T.Group();
        var cs = self._mkBox(ps.sx, ps.sy, ps.sz, mats.fabric, ps.x, ps.y, 0);
        var cbk = self._mkBox(pb.sv, pb.su, pb.sz, mats.fabric, pb.x, pb.y, 0);
        cbk.rotation.z = g.betaRad;
        cs.userData.partType = cbk.userData.partType = 'cushion';
        mg.add(cs); mg.add(cbk);
        self._addToScene(mg, 'cushion', { boqCode: 'FOU00016', idHint: 'mattress' });
      }
      /* v263: throw pillows against the back (on the mattress if it is on) */
      var cTp = g.pads ? PORCH.CUSHION_T : 0;
      self._addPillows({ n: Math.max(1, Math.round((g.L - 0.12) / 0.60)), z0: -g.L / 2 + 0.12, z1: g.L / 2 - 0.12, seatY: g.seatTop + cTp,
                         backX: g.hingeX + cTp * Math.cos(g.betaRad), beta: g.betaRad, w: 0.44, h: 0.42, t: 0.16, tag: 'porch-' });
    },
    /* ----------------------------------------------------------
       TYPE 9 - Adirondack: draws the pieces of _adiLayout(STATE).
       ---------------------------------------------------------- */
    _buildAdi: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _adiLayout(STATE);
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
          if (b[6]) m.rotation.z = b[6];
        } else {
          var sh = new T.Shape();
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (var q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var geo = new T.ExtrudeGeometry(sh, { depth: pc.d, bevelEnabled: false, curveSegments: 2 });
          geo.translate(0, 0, -pc.d / 2);
          m = new T.Mesh(geo, mats.lumber);
          m.position.z = pc.z;
        }
        self._addToScene(m, 'adi-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.bolts.length; i++) {
        var bo = g.bolts[i];
        var head = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.007, 6), mats.metal);
        head.rotation.x = Math.PI / 2;
        head.position.set(bo.x, bo.y, bo.z + (bo.z < 0 ? -0.0035 : 0.0035));
        head.userData.driveDir = [0, 0, (bo.z < 0 ? -1 : 1)]; head.userData.driveLen = 0.14;
        self._addToScene(head, 'adi-hw-bolt', { boqCode: ADI.BOLT, idHint: 'bolt-' + (i + 1) });
      }
      /* v260: the screws, each kind its own step */
      for (i = 0; i < (g.pillows || []).length; i++) {
        var rgA = g.pillows[i]; rgA.w = 0.42 * g.k; rgA.h = 0.42 * g.k; rgA.t = 0.16 * g.k; rgA.tag = 'adi-' + i + '-';
        self._addPillows(rgA);                                             /* v263 */
      }
      var ADI_SCR_CODE = { mid: ADI.MID_SCREW, apron: ADI.SCREW, seat: ADI.SLAT_SCREW, lowsup: ADI.SCREW, arm: ADI.SCREW, back: ADI.SLAT_SCREW };
      for (i = 0; i < g.screws.length; i++) {
        var swA = g.screws[i];
        self._addFastener(swA, 'adi-hw-screw-' + swA.kind, ADI_SCR_CODE[swA.kind], 'screw-' + swA.kind + '-' + (i + 1));
      }
      try {
        var key = Math.round(g.L * 100) + '|' + Math.round(g.gamma) + '|' + g.k + '|' + (STATE.isMetric === false);
        if (key !== _adiLogKey) {
          _adiLogKey = key;
          var bq = global.BenchBoQ._computeAdi(STATE);
          _dbg('[adirondack] ' + g.N + ' seat(s) x ' + g.Ws.toFixed(3) + ' m, overall ' + g.Wt.toFixed(3) + ' x ' + g.depth.toFixed(3) + ' x ' + g.height.toFixed(3) +
               ' m, back ' + Math.round(g.gamma) + ' deg, ' + (g.k < 1 ? 'kids' : 'adult') + ', ' + (STATE.isMetric === false ? 'US' : 'metric') + ' sections; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
        }
      } catch (eA) {}
    },
    /* ----------------------------------------------------------
       TYPE 10 - Planter bench: draws the pieces of _planterLayout(STATE).
       ---------------------------------------------------------- */
    _buildPlanter: function () {
      var mats = this.materials, self = this, i;
      var g = _planterLayout(STATE), T = global.THREE;
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], b = pc.box, m;
        if (pc.poly) {   /* v261: the notched bottom slats (x / z outline, up y) */
          var shP = new T.Shape();
          shP.moveTo(pc.poly[0][0], -pc.poly[0][1]);
          for (var qP = 1; qP < pc.poly.length; qP++) shP.lineTo(pc.poly[qP][0], -pc.poly[qP][1]);
          var geoP = new T.ExtrudeGeometry(shP, { depth: pc.h, bevelEnabled: false, curveSegments: 1 });
          geoP.rotateX(-Math.PI / 2); geoP.translate(0, pc.y0, 0);
          m = new T.Mesh(geoP, mats.lumber);
        } else {
          m = self._mkBox(b[3], b[4], b[5], (pc.mat && mats[pc.mat]) || mats.lumber, b[0], b[1], b[2]);
          if (b[6]) m.rotation.z = b[6];
        }
        self._addToScene(m, 'planter-' + pc.kind, { boqCode: pc.code || null, length: pc.len || null, idHint: pc.id });
        if (pc.fly) m.userData.flyFrom = pc.fly.slice(0);   /* v277: the liner's assembly start, inside the box */
      }
      if (g.pillows) { g.pillows.w = 0.44; g.pillows.h = 0.42; g.pillows.t = 0.16; g.pillows.tag = 'planter-'; self._addPillows(g.pillows); }   /* v263 */
      for (i = 0; i < (g.screws || []).length; i++) {
        var swP = g.screws[i];
        self._addFastener(swP, 'planter-hw-screw-' + swP.kind, (swP.len < 0.08) ? PLANTER.CLAD_SCREW : PLANTER.SCREW, 'screw-' + swP.kind + '-' + (i + 1));
      }
      try {
        var key = Math.round(g.L * 100) + '|' + g.back + '|' + Math.round(g.rake * 100) + '|' + g.PB + '|' + (STATE.isMetric === false);
        if (key !== _planterLogKey) {
          _planterLogKey = key;
          var bq = global.BenchBoQ._computePlanter(STATE);
          _dbg('[planter] seat ' + g.L.toFixed(3) + ' m between 2 planters ' + g.PB.toFixed(2) + ' x ' + g.PH.toFixed(2) + ' m, back ' + (g.back ? Math.round(g.rake * 180 / Math.PI) + ' deg' : 'off') +
               (g.mid ? ', middle support' : '') + '; ' + Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[planter] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eP) {}
    },
    /* ----------------------------------------------------------
       TYPE 11 - Tree bench: the pieces of _treeLayout(STATE); a box piece
       is local (radial x, up y, tangential z), turned about y by ry and
       tilted about its local z by rz.
       ---------------------------------------------------------- */
    _buildTree: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _treeLayout(STATE);
      function place(m, lx, ly, lz, ry, rz) {
        var c = Math.cos(ry), sn = Math.sin(ry);
        m.position.set(lx * c + lz * sn, ly, -lx * sn + lz * c);
        m.rotation.order = 'YXZ';
        m.rotation.set(0, ry, rz || 0);
      }
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.poly) {
          var sh = new T.Shape();
          sh.moveTo(pc.poly[0][0], -pc.poly[0][1]);
          for (var q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], -pc.poly[q][1]);
          var geo = new T.ExtrudeGeometry(sh, { depth: pc.h, bevelEnabled: false, curveSegments: 1 });
          geo.rotateX(-Math.PI / 2);                                         /* the shape in x / z, the extrusion up */
          geo.translate(0, pc.y0, 0);
          m = new T.Mesh(geo, mats.lumber);
        } else if (pc.trap) {
          /* v261: a back board mitered at both ends (inner face Li, outer Lo) */
          var tp = pc.trap, shB = new T.Shape();
          shB.moveTo(-tp[2] / 2, tp[0] / 2); shB.lineTo(tp[2] / 2, tp[1] / 2); shB.lineTo(tp[2] / 2, -tp[1] / 2); shB.lineTo(-tp[2] / 2, -tp[0] / 2);
          var geoB = new T.ExtrudeGeometry(shB, { depth: tp[3], bevelEnabled: false, curveSegments: 1 });
          geoB.rotateX(-Math.PI / 2); geoB.translate(0, -tp[3] / 2, 0);
          m = new T.Mesh(geoB, mats.lumber);
          place(m, pc.box[0], pc.box[1], pc.box[2], pc.ry, pc.rz);
        } else {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, 0, 0, 0);
          place(m, b[0], b[1], b[2], pc.ry, pc.rz);
        }
        self._addToScene(m, 'tree-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.bolts.length; i++) {
        var bo = g.bolts[i];
        var head = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.007, 6), mats.metal);
        var c2 = Math.cos(-bo.ph), s2 = Math.sin(-bo.ph);
        head.position.set(bo.r * c2 + bo.t * s2, bo.y, -bo.r * s2 + bo.t * c2);
        head.rotation.order = 'YXZ';
        head.rotation.set(Math.PI / 2, -bo.ph, 0);
        head.userData.driveDir = [-Math.sin(bo.ph), 0, Math.cos(bo.ph)];   /* the head on the +t face: driven in from outside it */
        head.userData.driveLen = 0.14;
        self._addToScene(head, 'tree-hw-bolt-' + (bo.kind || 'leg'), { boqCode: TREE.BOLT, idHint: 'bolt-' + (i + 1) });
      }
      for (i = 0; i < (g.screws || []).length; i++) {
        var swT = g.screws[i];
        self._addFastener(swT, 'tree-hw-screw-' + swT.kind, TREE.SCREW, 'screw-' + swT.kind + '-' + (i + 1));
      }
      try {
        var key = Math.round(g.L * 100) + '|' + g.n + '|' + g.back + '|' + Math.round(g.rake * 100) + '|' + (STATE.isMetric === false);
        if (key !== _treeLogKey) {
          _treeLogKey = key;
          var bq = global.BenchBoQ._computeTree(STATE);
          _dbg('[tree] ' + g.n + ' sides, opening ' + g.L.toFixed(2) + ' m across the flats, outer ' + g.outerX.toFixed(2) + ' x ' + g.outerZ.toFixed(2) + ' m, about ' + g.seats + ' seats, back ' +
               (g.back ? Math.round(g.rake * 180 / Math.PI) + ' deg' : 'off') + '; ' + Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
        }
      } catch (eT) {}
    },
    /* ----------------------------------------------------------
       TYPE 12 - Storage bench: the pieces of _storageLayout(STATE).
       ---------------------------------------------------------- */
    _buildStorage: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _storageLayout(STATE);
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], b = pc.box, m;
        if (pc.poly) {   /* v260: the taper-cut uprights */
          var shU = new T.Shape(), qU;
          shU.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (qU = 1; qU < pc.poly.length; qU++) shU.lineTo(pc.poly[qU][0], pc.poly[qU][1]);
          var geoU = new T.ExtrudeGeometry(shU, { depth: pc.d, bevelEnabled: false, curveSegments: 1 });
          geoU.translate(0, 0, -pc.d / 2);
          m = new T.Mesh(geoU, mats.lumber);
          m.position.z = pc.z;
        } else {
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
          if (b[6]) m.rotation.z = b[6];
        }
        self._addToScene(m, 'store-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.hinges.length; i++) {
        var hn = g.hinges[i];
        var kn = new T.Mesh(new T.CylinderGeometry(0.006, 0.006, 0.09, 10), mats.metal);
        kn.rotation.x = Math.PI / 2;
        kn.position.set(hn.x, hn.y, hn.z);
        self._addToScene(kn, 'store-hw-hinge', { boqCode: STORE.HINGE, idHint: 'hinge-' + (i + 1) });
        var lf = self._mkBox(0.004, 0.002, 0.07, mats.metal, hn.x - 0.02, hn.y + 0.002, hn.z);   /* the leaves on the boards */
        self._addToScene(lf, 'store-hw-hinge', { idHint: 'hinge-leaf-' + (i + 1) });
      }
      if (g.pillows && !g.open) { g.pillows.w = 0.44; g.pillows.h = 0.42; g.pillows.t = 0.16; g.pillows.tag = 'store-'; self._addPillows(g.pillows); }   /* v263: not with the lid open */
      for (i = 0; i < (g.stays || []).length; i++) {
        var sy = g.stays[i], dxS = sy.b.x - sy.a.x, dyS = sy.b.y - sy.a.y, lS = Math.sqrt(dxS * dxS + dyS * dyS);
        var bar = self._mkBox(0.012, lS, 0.004, mats.metal, (sy.a.x + sy.b.x) / 2, (sy.a.y + sy.b.y) / 2, sy.a.z);
        bar.rotation.z = Math.atan2(-dxS, dyS);
        self._addToScene(bar, 'store-hw-stay', { boqCode: CAT_NEW.LID_STAY, idHint: 'lid-stay-' + (i + 1) });
      }
      /* v260: the screws, each kind its own step */
      for (i = 0; i < g.screws.length; i++) {
        var swS = g.screws[i];
        self._addFastener(swS, 'store-hw-screw-' + swS.kind, (swS.kind === 'upright' || swS.kind === 'back') ? STORE.SCREW : STORE.CLAD_SCREW, 'screw-' + swS.kind + '-' + (i + 1));
      }
      try {
        var key = Math.round(g.L * 100) + '|' + g.back + '|' + Math.round(g.rake * 100) + '|' + g.open + '|' + (STATE.isMetric === false);
        if (key !== _storeLogKey) {
          _storeLogKey = key;
          var bq = global.BenchBoQ._computeStorage(STATE);
          _dbg('[storage] ' + g.L.toFixed(2) + ' x ' + g.W.toFixed(2) + ' m, about ' + Math.round(g.volume * 1000) + ' l inside, lid ' + (g.open ? 'open' : 'shut') + ', back ' +
               (g.back ? Math.round(g.rake * 180 / Math.PI) + ' deg' : 'off') + '; ' + Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[storage] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eS) {}
    },
    /* ----------------------------------------------------------
       TYPE 13 - Kids' swing set: the stand (no roof), the seats, the hanging.
       ---------------------------------------------------------- */
    _buildKids: function () {
      var mats = this.materials, self = this, i;
      var g = _kidsLayout(STATE);
      self._drawKfFrame(g.frame);                                          /* v299 the new A-frames */
      if (g.bench) self._drawPorchSeat(g.seat);                            /* the bench, its hangers, eye bolts, chains, mattress */
      else {
        for (i = 0; i < g.seats.length; i++) {
          var st = g.seats[i];
          var m = self._mkBox(g.seatW, g.seatT, KIDS.SEAT_W, mats.lumber, 0, st.y, st.z);
          self._addToScene(m, 'kids-seat', { boqCode: KIDS.SEAT_CODE, length: KIDS.SEAT_W, idHint: 'seat-' + (i + 1) });
        }
        self._drawHanging(g);
      }
      try {
        var key = Math.round(g.L * 100) + '|' + (STATE.isMetric === false) + '|' + g.bench + '|' + (g.bench ? Math.round(g.seat.beta) + '|' + g.cushion : '');
        if (key !== _swingLogKey) {
          _swingLogKey = key;
          var bq = global.BenchBoQ._computeKids(STATE), F = g.frame;
          _dbg('[kids] ' + (g.bench ? 'BENCH ' + g.L.toFixed(2) + ' m (back ' + Math.round(g.seat.beta) + ' deg, mattress ' + (g.cushion ? 'on' : 'off') + ')' : 'span ' + g.L.toFixed(2) + ' m, ' + g.N + ' seat(s)') +
               ', A-frames 2x6 ' + F.legLen.toFixed(2) + ' at ' + F.ang + ' deg, ' + F.depth.toFixed(2) + ' m at the feet, beam ' + F.beamL.toFixed(2) + ' m, ' + F.fas.filter(function (f) { return f.rod; }).length + ' M16 rods; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[kids] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + (bq.missing[i].unit || 'pcs'));
        }
      } catch (eK) {}
    },
    /* v299 the kids' set's A-frames (_kfFrame): boxes, the legs in the
       frame's plane, the braces in the beam's plane, the rods and screws */
    _drawKfFrame: function (F) {
      var T = global.THREE, mats = this.materials, self = this, i;
      for (i = 0; i < F.pieces.length; i++) {
        var pc = F.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mats.lumber);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }   /* the shape in (z, y), extruded across x */
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
          if (pc.kind === 'brace') m.userData.flyDir = [0, -1, 0];
        }
        if (pc.kind === 'beam') m.userData.flyDir = [0, 1, 0];
        self._addToScene(m, 'kf-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < F.fas.length; i++) {
        var f = F.fas[i];
        self._addFastener(f, f.rod ? 'kf-hw-bolt-' + f.kind : 'kf-hw-screw-' + f.kind, f.code, f.kind + '-' + (i + 1));
      }
    },
    _buildGabionBench:   function () { this._buildPlaceholder('Gabion Bench (coming soon)'); },
    /* ----------------------------------------------------------
       TYPE 6 - Block bench: the hollow blocks (extruded with their two
       cores) and the 4x4s through them.
       ---------------------------------------------------------- */
    _buildBlockBench: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _blockLayout(STATE), P = g.P;
      if (!mats.block) mats.block = new T.MeshStandardMaterial({ color: BLOCK.COLORS[0], roughness: 0.95, emissive: BLOCK.COLORS[0], emissiveIntensity: BLOCK.GLOW });
      mats.block.color.setHex(BLOCK.COLORS[g.color - 1]);
      mats.block.emissive.setHex(BLOCK.COLORS[g.color - 1]);
      mats.block.needsUpdate = true;
      /* a block in the x-y plane (w wide, h high), the cores through z;
         up = standing on end (the cores one over the other) */
      function blockGeo(up) {
        var w = up ? P.bw : P.bl, h = up ? P.bl : P.bw, sh = new T.Shape();
        sh.moveTo(-w / 2, -h / 2); sh.lineTo(w / 2, -h / 2); sh.lineTo(w / 2, h / 2); sh.lineTo(-w / 2, h / 2); sh.lineTo(-w / 2, -h / 2);
        for (var c = -1; c <= 1; c += 2) {
          var x0, x1, y0, y1, hole = new T.Path();
          if (up) { x0 = -w / 2 + P.sh; x1 = w / 2 - P.sh; y0 = (c < 0) ? (-h / 2 + P.wb) : (P.wb / 2); y1 = (c < 0) ? (-P.wb / 2) : (h / 2 - P.wb); }
          else    { y0 = -h / 2 + P.sh; y1 = h / 2 - P.sh; x0 = (c < 0) ? (-w / 2 + P.wb) : (P.wb / 2); x1 = (c < 0) ? (-P.wb / 2) : (w / 2 - P.wb); }
          hole.moveTo(x0, y0); hole.lineTo(x0, y1); hole.lineTo(x1, y1); hole.lineTo(x1, y0); hole.lineTo(x0, y0);
          sh.holes.push(hole);
        }
        var geo = new T.ExtrudeGeometry(sh, { depth: P.bh, bevelEnabled: false });
        geo.translate(0, 0, -P.bh / 2);
        return geo;
      }
      var geoFlat = blockGeo(false), geoUp = g.back ? blockGeo(true) : null;
      for (i = 0; i < g.blocks.length; i++) {
        var b = g.blocks[i];
        var m = new T.Mesh(b.up ? geoUp : geoFlat, mats.block);
        m.position.set(b.x, b.y, b.z);
        self._addToScene(m, 'block-' + b.kind, { boqCode: BLOCK.CODE, idHint: 'block-' + b.id });
      }
      for (i = 0; i < g.timbers.length; i++) {
        var tb = g.timbers[i];
        var mt = self._mkBox(P.t, P.t, tb.len, mats.lumber, tb.x, tb.y, tb.z);
        self._addToScene(mt, 'block-timber-' + tb.kind, { boqCode: BLOCK.TIMBER, length: tb.len, idHint: 'timber-' + tb.id });
      }
      if (g.pillows) { g.pillows.w = 0.44; g.pillows.h = 0.42; g.pillows.t = 0.16; g.pillows.tag = 'block-'; self._addPillows(g.pillows); }   /* v263 */
      try {
        var key = Math.round(g.L * 100) + '|' + g.back + '|' + g.color + '|' + (STATE.isMetric === false);
        if (key !== _blockLogKey) {
          _blockLogKey = key;
          var bq = global.BenchBoQ._computeBlock(STATE);
          _dbg('[block] ' + g.L.toFixed(2) + ' m timbers, ' + g.blocks.length + ' blocks, seat ' + g.seatTop.toFixed(3) + ' m, clear between the stacks ' + g.clear.toFixed(2) +
               ' m, back ' + (g.back ? 'on' : 'off') + ', colour ' + g.color + ', adhesive bead ' + g.glueM.toFixed(2) + ' m; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
        }
      } catch (eB) {}
    },

    /* v284 TYPE 15 -- THE 2x4 BENCH: the boards of _gbLayout, each layer
       its own part type (the build goes layer by layer), and its brads */
    /* v414 TYPE 54 -- THE TWIST BENCH: the slats of _rtbLayout (each its
       profile turned to its group's position, the rod's hole cut, extruded
       along the bench), the washers between them (v419), the rod, the ends'
       washer + nut + cap nut */
    _buildRotBench: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _rtbLayout(STATE);
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      for (i = 0; i < g.slats.length; i++) {
        var sl = g.slats[i], sh = new T.Shape(), q;
        sh.moveTo(sl.poly[0][0], sl.poly[0][1]);
        for (q = 1; q < sl.poly.length; q++) sh.lineTo(sl.poly[q][0], sl.poly[q][1]);
        var hole = new T.Path();
        hole.absarc(0, g.h, g.holeR, 0, Math.PI * 2, true);
        sh.holes.push(hole);
        var ge = new T.ExtrudeGeometry(sh, { depth: g.t, bevelEnabled: false, curveSegments: 10 });
        ge.translate(0, 0, sl.z - g.t / 2);
        var m = new T.Mesh(ge, mats.lumber);
        m.userData.pgPoly = { pts: sl.poly, plane: 'xy', c: sl.z, t: g.t };   /* the harness's in-wood test */
        m.userData.flyDir = [0, 0, 1];
        self._addToScene(m, 'rtb-slat-' + sl.g, { boqCode: RTB.PANEL, idHint: sl.id });   /* v419 a tap shows the panel */
      }
      /* v422 the end cheeks: the quarter disc with the rod's hole, never turned */
      g.cheeks.forEach(function (ck) {
        var cs = new T.Shape(), q;
        cs.moveTo(ck.poly[0][0], ck.poly[0][1]);
        for (q = 1; q < ck.poly.length; q++) cs.lineTo(ck.poly[q][0], ck.poly[q][1]);
        var ch = new T.Path();
        ch.absarc(0, g.h, g.holeR, 0, Math.PI * 2, true);
        cs.holes.push(ch);
        var cg = new T.ExtrudeGeometry(cs, { depth: g.t, bevelEnabled: false, curveSegments: 10 });
        cg.translate(0, 0, ck.z - g.t / 2);
        var cm = new T.Mesh(cg, mats.lumber);
        cm.userData.pgPoly = { pts: ck.poly, plane: 'xy', c: ck.z, t: g.t };
        cm.userData.flyDir = [0, 0, (ck.e === 'a') ? -1 : 1];
        self._addToScene(cm, 'rtb-cheek-' + ck.e, { boqCode: RTB.PANEL, idHint: 'cheek-' + ck.e });
      });
      /* v419 the washers: 3 round the rod in every gap */
      var wG = new T.CylinderGeometry(g.washerR, g.washerR, 1, 20);
      for (i = 0; i < g.spacers.length; i++) {
        var sp = g.spacers[i], j;
        for (j = 0; j < sp.n; j++) {
          var wm = new T.Mesh(wG, mats.galv);
          wm.scale.y = sp.wt * 0.96;
          wm.rotation.x = Math.PI / 2;
          wm.position.set(0, g.h, sp.z0 + sp.wt * (j + 0.5));
          self._addToScene(wm, 'rtb-hw-spacer-' + sp.g, { boqCode: RTB.WASHER, idHint: 'spacer-' + (i + 1) + '-' + (j + 1) });
        }
      }
      /* the rod (its 'head' is the end A washer) and the ends' hardware */
      self._addFastener({ x: 0, y: g.h, z: -g.rodL / 2, dir: [0, 0, 1], len: g.rodL, r: g.rodR }, 'rtb-hw-bolt-rod', RTB.ROD, 'rod');
      [['a', g.endA], ['b', g.endB]].forEach(function (E) {
        E[1].forEach(function (it, j) {
          var mm;
          if (it.kind === 'washer') mm = new T.Mesh(new T.CylinderGeometry(g.washerR, g.washerR, it.h, 20), mats.galv);
          else if (it.kind === 'nut') mm = new T.Mesh(new T.CylinderGeometry(0.0138, 0.0138, it.h, 6), mats.galv);
          else {
            mm = new T.Group();
            var hx = new T.Mesh(new T.CylinderGeometry(0.0138, 0.0138, it.h * 0.6, 6), mats.galv);
            hx.position.y = -it.h * 0.2;
            var dome = new T.Mesh(new T.SphereGeometry(0.0118, 14, 8, 0, Math.PI * 2, 0, Math.PI / 2), mats.galv);
            dome.position.y = it.h * 0.1;
            mm.add(hx); mm.add(dome);
          }
          mm.rotation.x = (E[0] === 'a') ? -Math.PI / 2 : Math.PI / 2;   /* the cap nut's dome outwards */
          mm.position.set(0, g.h, it.z);
          self._addToScene(mm, 'rtb-hw-end-' + E[0], { boqCode: (it.kind === 'nut') ? RTB.NUT : null, idHint: 'end-' + E[0] + '-' + it.kind + '-' + j });
        });
      });
      try {
        var key = g.N + '|' + g.mode + '|' + (STATE.isMetric === false);
        if (key !== _rtbLogKey) {
          _rtbLogKey = key;
          var bq = global.BenchBoQ._computeRotBench(STATE);
          _dbg('[rtb] twist bench ' + g.L.toFixed(3) + ' m overall: 2 end cheeks R ' + Math.round(g.cheekR * 1000) + ' + ' + g.N + ' slats ' + Math.round(g.t * 1000) + ' mm (' + g.Ls.toFixed(3) + ' m) + ' + (g.N + 1) + ' x ' + RTB.N_SPACER + ' washers, layout ' + g.mode + ' (' + g.groups.map(function (q) { return q.m + q.n; }).join(' ') + '), rod M16 ' + g.rodL.toFixed(3) + ' at ' + g.h.toFixed(3) + ', ' +
               g.depth.toFixed(3) + ' deep, seat ' + g.seatTop.toFixed(3) + ', back ' + g.height.toFixed(3) + ', a slat ' + g.area1.toFixed(4) + ' m2; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          var ns = g.nest;
          _dbg('[rtb] panel ' + RTB.PANEL + ': ' + ns.pairs + ' pairs ' + Math.round(ns.pw * 1000) + ' x ' + Math.round(ns.ph * 1000) + ' mm' + (ns.single ? ' + 1 alone' : '') + ' + the 2 cheeks ' + Math.round(ns.pw * 1000) + ' x ' + Math.round(ns.cL * 1000) + ' mm, a strip ' + ns.stripL.toFixed(3) + ' m = ' + ns.m2.toFixed(2) + ' m2 for ' + (ns.N * ns.a1 + 2 * ns.ac).toFixed(2) + ' m2 of parts, offcut ' + Math.round(ns.off * 100) + ' %');
          _dbg('[rtb] billed in full: ' + ((bq.missing || []).length ? 'NO -- NOT BILLED ' + bq.missing.map(function (q) { return q.name; }).join(', ') : 'yes, nothing NOT BILLED'));
        }
      } catch (eL) {}
    },
    _buildGluedBench: function () {
      var mats = this.materials, self = this, i;
      var g = _gbLayout(STATE);
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], b = pc.box;
        var m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        self._addToScene(m, (pc.kind === 'arm') ? 'gb-arm' : 'gb-layer-' + (pc.layer + 1), { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.brads.length; i++) self._addFastener(g.brads[i], 'gb-hw-brad-' + (g.brads[i].layer + 1), null, 'brad-' + (i + 1));   /* no catalogue row */
      for (i = 0; i < g.screws.length; i++) self._addFastener(g.screws[i], 'gb-hw-screw-arm', GB.ARM_SCREW, 'arm-pocket-screw-' + (i + 1));   /* v286 pocket screws */
      /* v286 the pockets' entries on the posts' inner faces: drilled before the
         post goes in, so they come with its layer step; the assembly only
         (hidden in the built view and out of AR, as the sofa's); no catalogue row */
      for (i = 0; i < g.pockets.length; i++) {
        var pk = g.pockets[i], pm = new global.THREE.Mesh(new global.THREE.SphereGeometry(0.011, 14, 9), mats.pocketMarker || mats.screwCap);
        pm.scale.set(0.9, 1.6, 0.35);   /* an oval slot along the post, on a face normal to Z */
        pm.position.set(pk.x, pk.y, pk.z);
        pm.userData.gbPocket = true;
        self._addToScene(pm, 'gb-hw-pocket-' + (pk.layer + 1), { boqCode: null, idHint: 'arm-pocket-' + (i + 1) });
      }
      try {
        var key = Math.round(g.L * 1000) + '|' + (STATE.isMetric === false) + '|' + g.arms + '|' + Math.round(g.armTop * 1000);
        if (key !== _gbLogKey) {
          _gbLogKey = key;
          var bq = global.BenchBoQ._computeGlued(STATE), nFull = 0, nShort = 0;
          g.pieces.forEach(function (pp) { if (pp.kind === 'leg') { if (pp.layer % 2) nFull++; else nShort++; } });
          _dbg('[gb] 2x4 bench ' + g.L.toFixed(3) + ' x ' + g.D.toFixed(3) + ' x ' + g.H.toFixed(3) + ' m, armrests ' + (g.arms ? 'on, top ' + g.armTop.toFixed(3) + ' (' + Math.round((g.armTop - g.H) * 1000) + ' over the seat; posts ' + g.postH.toFixed(3) + ', ' + Math.round(g.overSeat * 1000) + ' over the seat; caps ' + g.capL.toFixed(3) + ' flush; ' + g.screws.length + ' pocket screws)' : 'off') + ': ' + GB.N_SEAT + ' seat boards on edge, legs ' + g.nLayers + ' layers each (' +
               nFull + ' full ' + (g.arms ? g.armTop - g.P.t : g.H).toFixed(3) + ' + ' + nShort + ' short ' + (g.H - g.P.w).toFixed(3) + '), glue ' + g.glueA.toFixed(2) + ' m2 = ' + g.glueL + ' l, ' + g.brads.length + ' brads, coat ' + g.coat.toFixed(2) + ' m2; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[gb] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eG) {}
    },

    /* v288 TYPE 16 -- THE SUNBED: the pieces of _sbLayout (the backrest's
       and the props' turned about X), their screws and bolts; v290 the
       backrest's battens drawn with their notches cut out (an extruded
       side profile -- no dark marks) */
    /* v296 TYPE 17, THE PERGOLA SWING: the footings (gravel + concrete),
       the post bases, the posts, heads, beams, knee braces and rafters
       (_pgLayout), every screw / nail / anchor, then the classic seat on its
       chains from the two rafters */
    _buildPergola: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _pgLayout(STATE), p = g.P.p, hp = p / 2, bt = PG.BASE_T, fl = PG.BASE_FLANGE;
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });   /* the post bases: hot-dip galvanised, lighter than the black hardware */
      for (i = 0; i < g.feet.length; i++) {
        /* the footing's top only (its 5 cm above the ground): the hole, the
           gravel and the 80 cm below the ground are in the bill, not drawn
           (they would stand in the picture as concrete pillars) */
        var ft = g.feet[i];
        var cm = self._mkBox(ft.w, ft.y1, ft.w, mats.concrete, ft.x, ft.y1 / 2, ft.z);
        cm.userData.flyDir = [0, -1, 0];
        cm.userData.pgFoot = { x: ft.x, z: ft.z, w: ft.w, y0: ft.y0, y1: ft.y1 };   /* the harness: the whole footing is solid */
        self._addToScene(cm, 'pg-footing', { boqCode: PG.CONCRETE, idHint: 'footing-' + ft.id });
      }
      for (i = 0; i < g.bases.length; i++) {
        var bs = g.bases[i];
        /* the plate on the footing (the item), the stand-off, the saddle, the two flanges on the post */
        self._addToScene(self._mkBox(p + 0.08, bt, p, mats.galv, bs.x, bs.y0 + bt / 2, bs.z), 'pg-base', { boqCode: PG.BASE, idHint: 'base-' + bs.id });
        var so = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, bs.y1 - bs.y0 - 2 * bt, 10), mats.galv);
        so.position.set(bs.x, (bs.y0 + bs.y1) / 2, bs.z);
        self._addToScene(so, 'pg-base', { idHint: 'base-stem-' + bs.id });
        self._addToScene(self._mkBox(p + 2 * bt, bt, p, mats.galv, bs.x, bs.y1 - bt / 2, bs.z), 'pg-base', { idHint: 'base-saddle-' + bs.id });
        for (k = -1; k <= 1; k += 2) self._addToScene(self._mkBox(bt, fl, p, mats.galv, bs.x + k * (hp + bt / 2), bs.y1 + fl / 2 - bt, bs.z), 'pg-base', { idHint: 'base-flange-' + bs.id });
      }
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 3 });
          m = new T.Mesh(ge, mats.lumber);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }   /* the shape in (z, y), extruded across x */
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
          if (pc.kind === 'rafter') m.userData.flyDir = [0, 1, 0];
        }
        self._addToScene(m, 'pg-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.screws.length; i++) {
        var f = g.screws[i];
        self._addFastener(f, 'pg-hw-screw-' + f.kind, f.code, f.kind + '-' + (i + 1));
      }
      self._buildPorchClassic(g.seat);
      try {
        var sd = g.seat, key = 'pg|' + Math.round(g.L * 100) + '|' + (STATE.isMetric === false) + '|' + sd.cushion + '|' + sd.fill + '|' + Math.round(sd.gapT * 1000);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computePergola(STATE);
          _dbg('[pergola] swing ' + g.L.toFixed(3) + ' m seat, pergola ' + g.beamL.toFixed(3) + ' x ' + g.headL.toFixed(3) + ' x ' + g.height.toFixed(3) + ' m: posts ' + PG.POST + ' ' + g.postH.toFixed(3) + ' at ' + (2 * g.xP).toFixed(3) + ' x ' + (2 * g.zP).toFixed(3) + ' (centres), ' + g.zr.length + ' rafters ' + PG.RAFTER + ' ' + g.rafL.toFixed(3) + ' at ' + g.zr.map(function (z) { return z.toFixed(2); }).join('/') + ', hung from the two at +-' + g.zh.toFixed(3) + ', rafters underside ' + g.yRB.toFixed(3) + ', chains ' + sd.chains.map(function (c) { return c.len.toFixed(2); }).join(' / ') + ', footings ' + g.concreteM3 + ' m3; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[pergola] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v301 TYPE 18 -- THE MODERN SWING: the ground screws or the footings'
       tops, the U's, the posts, the three beams, the blocks / the weave's
       slats + its shade cloth, every screw and nail (_mfLayout), then the
       sofa seat on its chain V's from the middle beam */
    _buildModernSwing: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _mfLayout(STATE), p = g.P.p, hp = p / 2, bt = MF.BASE_T, fl = MF.BASE_FLANGE;
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.shadeCloth) mats.shadeCloth = new T.MeshStandardMaterial({ color: 0xd8cdb6, roughness: 0.9, metalness: 0, side: T.DoubleSide, transparent: true, opacity: MF.FAB_OP, depthWrite: false });   /* TST00003: beige HDPE shade cloth, v304 70 % opaque */
      for (i = 0; i < g.feet.length; i++) {
        /* the footing's top only (5 cm above the ground), as the pergola's */
        var ft = g.feet[i];
        var cm = self._mkBox(ft.w, ft.y1, ft.w, mats.concrete, ft.x, ft.y1 / 2, ft.z);
        cm.userData.flyDir = [0, -1, 0];
        cm.userData.pgFoot = { x: ft.x, z: ft.z, w: ft.w, y0: ft.y0, y1: ft.y1 };
        self._addToScene(cm, 'mf-footing', { boqCode: MF.CONCRETE, idHint: 'footing-' + ft.id });
      }
      for (i = 0; i < g.gscrews.length; i++) {
        /* the ground screw's head out of the ground (its 1.5 m below: in the
           bill, not drawn) and its flange plate */
        var gs = g.gscrews[i];
        var tube = new T.Mesh(new T.CylinderGeometry(gs.r, gs.r, gs.y1 - 0.006, 16), mats.galv);
        tube.position.set(gs.x, (gs.y1 - 0.006) / 2, gs.z);
        tube.userData.flyDir = [0, -1, 0];
        self._addToScene(tube, 'mf-gscrew', { boqCode: MF.GSCREW, idHint: 'gscrew-' + gs.id });
        self._addToScene(self._mkBox(0.15, 0.006, 0.15, mats.galv, gs.x, gs.y1 - 0.003, gs.z), 'mf-gscrew', { idHint: 'gscrew-flange-' + gs.id });
      }
      for (i = 0; i < g.bases.length; i++) {
        /* the U: its plate (on the screw's flange / cast in the footing), the
           stand-off, the saddle under the post, the two flanges up its faces */
        var bs = g.bases[i];
        self._addToScene(self._mkBox(p + 2 * bt, bt, p, mats.galv, bs.x, bs.y1 - bt / 2, bs.z), 'mf-base', { boqCode: bs.code, idHint: 'base-' + bs.id });
        var so = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, bs.y1 - bs.y0 - bt, 10), mats.galv);
        so.position.set(bs.x, (bs.y0 + bs.y1 - bt) / 2, bs.z);
        self._addToScene(so, 'mf-base', { idHint: 'base-stem-' + bs.id });
        for (k = -1; k <= 1; k += 2) self._addToScene(self._mkBox(bt, fl, p, mats.galv, bs.x + k * (hp + bt / 2), bs.y1 + fl / 2 - bt, bs.z), 'mf-base', { idHint: 'base-flange-' + bs.id });
      }
      if (!mats.alu) mats.alu = new T.MeshStandardMaterial({ color: 0xc8cbcf, roughness: 0.35, metalness: 0.6 });   /* v308 the LED profiles */
      if (!mats.ledGlow) mats.ledGlow = new T.MeshStandardMaterial({ color: 0xfff3dc, roughness: 0.4, metalness: 0, emissive: 0xffd49a, emissiveIntensity: 1.1 });
      if (!mats.psu) mats.psu = new T.MeshStandardMaterial({ color: 0x3a3d42, roughness: 0.6, metalness: 0.2 });
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
          if (pc.kind === 'beam-mid' || pc.kind === 'beam-out') m.userData.flyDir = [0, 1, 0];
          self._addToScene(m, 'mf-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
        } else if (pc.notch) {
          /* v308 a grooved post (outline in (x, z), extruded up) or beam
             (outline in (x, y), extruded along z) of the LED top */
          var nsh = new T.Shape(), nq;
          nsh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (nq = 1; nq < pc.poly.length; nq++) nsh.lineTo(pc.poly[nq][0], pc.poly[nq][1]);
          var nge = new T.ExtrudeGeometry(nsh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          if (pc.plane === 'xz') { nge.rotateX(Math.PI / 2); nge.translate(0, pc.c + pc.t / 2, 0); }
          else nge.translate(0, 0, pc.c - pc.t / 2);
          m = new T.Mesh(nge, mats.lumber);
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
          if (pc.kind === 'beam-out') m.userData.flyDir = [0, 1, 0];
          self._addToScene(m, 'mf-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
        } else {
          /* the shade cloth: its outline in (z, y), extruded across the gap */
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 3 });
          ge.rotateY(-Math.PI / 2);
          m = new T.Mesh(ge, mats.shadeCloth);
          m.position.set(pc.c + pc.t / 2, 0, 0);
          m.userData.flyDir = [0, 1, 0];
          self._addToScene(m, 'mf-fabric', { boqCode: pc.code, idHint: pc.id });
        }
      }
      for (i = 0; i < g.screws.length; i++) {
        var f = g.screws[i];
        self._addFastener(f, (f.rod ? 'mf-hw-bolt-' : 'mf-hw-screw-') + f.kind, f.code, f.kind + '-' + (i + 1));
      }
      /* v308 the LED runs: the aluminium profile in the groove (2 mm under
         the face; no catalogue row yet -- NOT BILLED, logged) and its opal
         diffuser over the strip (the strip's code and length on it) */
      var gw2 = g.gw, gd2 = g.gd;
      for (i = 0; i < g.leds.length; i++) {
        var ld = g.leds[i], pm, dm;
        if (ld.axis === 'y') {
          var zc = ld.z - ld.s * (gd2 + 0.002) / 2, zd = ld.z - ld.s * 0.00125, hy = ld.y1 - ld.y0, cy = (ld.y0 + ld.y1) / 2;
          pm = self._mkBox(gw2 - 0.001, hy, gd2 - 0.002, mats.alu, ld.x, cy, zc);
          dm = self._mkBox(gw2 - 0.003, hy, 0.0015, mats.ledGlow, ld.x, cy, zd);
        } else {
          var lz = Math.abs(ld.z1 - ld.z0), cz = (ld.z0 + ld.z1) / 2;
          pm = self._mkBox(gw2 - 0.001, gd2 - 0.002, lz, mats.alu, ld.x, ld.y + (gd2 + 0.002) / 2, cz);
          dm = self._mkBox(gw2 - 0.003, 0.0015, lz, mats.ledGlow, ld.x, ld.y + 0.00125, cz);
        }
        self._addToScene(pm, 'mf-hw-ledprofile', { idHint: 'profile-' + ld.id });
        self._addToScene(dm, 'mf-hw-led', { boqCode: MF.LED, length: Math.round(ld.len * 1000) / 1000, idHint: ld.id });
      }
      for (i = 0; i < g.psus.length; i++) {
        var ps = g.psus[i], pg = new T.Group();
        pg.add(self._mkBox(0.030, 0.160, 0.045, mats.psu, ps.x, ps.y, ps.z));
        for (k = -1; k <= 1; k += 2) pg.add(self._mkBox(0.001, 0.020, 0.030, mats.galv, ps.x - ps.s * 0.015 - ps.s * 0.0005, ps.y + k * 0.088, ps.z));   /* its tabs */
        self._addToScene(pg, 'mf-hw-ledpsu', { boqCode: MF.LED_PSU, idHint: ps.id });
      }
      /* the seat: the sofa's frame builder with the seat's spec, its hanging */
      self._sofaFrame({ L: g.seat.L, W: g.seat.W, spec: g.seat });
      self._drawHanging(g.seat);
      try {
        var key = 'mf|' + Math.round(g.L * 100) + '|' + (STATE.isMetric === false) + '|' + g.found + '|' + g.weave + '|' + g.cant;
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeModernSwing(STATE);
          _dbg('[modern] swing ' + g.L.toFixed(3) + ' m sofa seat, ' + g.nFr + ' portals ' + g.beamL.toFixed(3) + ' x ' + g.depth.toFixed(3) + ' x ' + g.height.toFixed(3) + ' m: posts ' + MF.POST + ' ' + g.postH.toFixed(3) + ' at ' + (2 * g.zP).toFixed(3) + ' (centres), portals ' + g.d.toFixed(3) + ' apart, ' +
               (g.found === 'concrete' ? 'footings ' + g.concreteM3 + ' m3 + U anchors' : 'ground screws + U heads') + ', ' +
               (g.weave ? 'weave on ' + g.nFr + ' portals: slats ' + g.slatZ.map(function (z) { return z.length; }).join(' + ') + ', cloth ' + g.fabricM2 + ' m2' : 'blocks ' + g.pieces.filter(function (q) { return q.kind === 'block'; }).length + ' on ' + g.nFr + ' portals' + (g.cant ? ' (LED top: ' + g.posts.length + ' posts, the blocks on ' + g.screws.filter(function (q) { return q.rod; }).length + ' M16 rods, LED ' + g.ledM + ' m in ' + g.leds.length + ' grooves, ' + g.psus.length + ' power supplies)' : '')) + ', chains ' + g.seat.chains.map(function (c) { return c.len.toFixed(2); }).join(' / ') + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[modern] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v303 TYPE 19, GARDEN STRUCTURE 1 -- THE CINEMA BAR (_gsLayout): the
       footings' tops, the DPC strips, the straps, the timber (boxes, the
       planes' polygons), the worktop slab and its adhesive beads (v309),
       every rod / screw / nail, the screen (cassette, brackets, fabric or rolled up), the
       projector, the stools and the string of bulbs */
    _buildGarden: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _gsLayout(STATE), p = g.P.p, hp = p / 2;
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.gsDpc) mats.gsDpc = new T.MeshStandardMaterial({ color: 0x1d1d1d, roughness: 0.9 });
      if (!mats.gsAlu) mats.gsAlu = new T.MeshStandardMaterial({ color: 0xd9dbde, roughness: 0.35, metalness: 0.45 });
      if (!mats.gsWhite) mats.gsWhite = new T.MeshStandardMaterial({ color: 0xf7f7f4, roughness: 0.9, emissive: 0xffffff, emissiveIntensity: 0.35, side: T.DoubleSide });
      if (!mats.gsBlack) mats.gsBlack = new T.MeshStandardMaterial({ color: 0x151515, roughness: 0.85, side: T.DoubleSide });
      if (!mats.gsDark) mats.gsDark = new T.MeshStandardMaterial({ color: 0x2b2d30, roughness: 0.6, metalness: 0.2 });
      if (!mats.gsBulb) mats.gsBulb = new T.MeshStandardMaterial({ color: 0xffe2a8, emissive: 0xffc46b, emissiveIntensity: 0.9, roughness: 0.3 });
      if (!mats.gsSeat) mats.gsSeat = new T.MeshStandardMaterial({ color: COLOR_SCHEMES[_colorScheme()].seat || 0x2f3133, roughness: 0.7 });   /* v312 the stools' seats (recoloured per scheme in applyVizStage) */
      if (!mats.gsStone) mats.gsStone = new T.MeshStandardMaterial({ color: 0x8d8a85, roughness: 0.6 });   /* v309 the worktop slab (the BBQ's worktop) */
      if (!mats.gsGlue) mats.gsGlue = new T.MeshStandardMaterial({ color: 0xe9e5dc, roughness: 0.9 });
      if (!mats.gsTop) mats.gsTop = new T.MeshStandardMaterial({ color: 0x9a6a3c, roughness: 0.55 });   /* v354 the oiled acacia top */
      function hw(m, pt, code, id) { self._addToScene(m, pt, code ? { boqCode: code, idHint: id } : { idHint: id }); return m; }
      /* v305 the four concrete tiles 500 x 500 (their gravel bed is in the bill, not drawn) */
      for (i = 0; i < g.feet.length; i++) {
        var ft = g.feet[i];
        var cm = self._mkBox(ft.w, ft.y1 - ft.y0, ft.w, mats.concrete, ft.x, (ft.y0 + ft.y1) / 2, ft.z);
        cm.userData.flyDir = [0, -1, 0];
        cm.userData.pgFoot = { x: ft.x, z: ft.z, w: ft.w, y0: ft.y0, y1: ft.y1 };   /* the harness */
        self._addToScene(cm, 'gs-footing', { boqCode: GS.TILE, idHint: 'tile-' + ft.id });
      }
      for (i = 0; i < g.dpc.length; i++) {
        var dp = g.dpc[i];
        hw(self._mkBox(GS.DPC_L, GS.DPC_T, p + 0.02, mats.gsDpc, dp.x, g.yF + GS.DPC_T / 2, dp.z), 'gs-hw-dpc', GS.DPC, 'dpc-' + dp.id);
      }
      for (i = 0; i < g.straps.length; i++) {
        var st = g.straps[i];
        hw(self._mkBox(GS.STRAP_W, st.y1 - st.y0, GS.STRAP_T, mats.galv, st.x, (st.y0 + st.y1) / 2, st.z), 'gs-hw-strap', GS.STRAP, 'strap-' + st.id);
      }
      /* the timber */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], pc.kind === 'worktop' ? mats.gsStone : pc.kind === 'top' ? mats.gsTop : mats.lumber, b[0], b[1], b[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mats.lumber);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }   /* the shape in (z, y), extruded across x */
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        if (pc.kind === 'rafter' || pc.kind === 'ridge' || pc.kind === 'eave') m.userData.flyDir = [0, 1, 0];
        if (pc.kind === 'worktop' || pc.kind === 'top') m.userData.flyDir = [0, 1, 0];
        self._addToScene(m, 'gs-' + pc.kind, pc.area ? { boqCode: pc.code, idHint: pc.id } : (pc.sub || !(pc.len > 0)) ? { idHint: pc.id } : { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'gs-hw-' + (f.rod ? 'bolt-' : '') + f.kind, f.code, f.kind + '-' + (i + 1));
      }
      /* v309 the adhesive beads under the slab (along the rails, on the braces' heads) */
      for (i = 0; i < g.glue.length; i++) {
        var gb = g.glue[i];
        hw(self._mkBox(GS.GLUE_W, GS.GLUE_T, gb.z1 - gb.z0, mats.gsGlue, gb.x, gb.y, (gb.z0 + gb.z1) / 2), 'gs-hw-glue', GS.GLUE, 'adhesive-' + gb.id);
      }
      /* THE SCREEN (v305 on the back eave beam's outer face): the cassette on
         two brackets (a plate screwed to the beam, an arm under the
         cassette); the fabric down to the slider's height (black borders,
         the white image) or rolled up (only its bottom bar shows) */
      var sc = g.screen, cy = (sc.yCas0 + sc.yCas1) / 2 - 0.005;
      var cas = new T.Mesh(new T.CylinderGeometry(GS.CASSETTE / 2 - 0.005, GS.CASSETTE / 2 - 0.005, sc.casL, 20), mats.gsAlu);
      cas.rotation.x = Math.PI / 2;
      cas.position.set(sc.x, cy, 0);
      hw(cas, 'gs-hw-cassette', GS.SCREEN, 'screen-cassette');
      for (k = 0; k < sc.brackets.length; k++) {
        var bz = sc.brackets[k].z, pTop = sc.yCas1 + 0.12, pBot = sc.yCas0 - 0.006;
        hw(self._mkBox(GS.BR_T, pTop - pBot, 0.05, mats.gsDark, sc.face - GS.BR_T / 2, (pTop + pBot) / 2, bz), 'gs-hw-cassette', null, 'screen-bracket-plate-' + (k + 1));
        hw(self._mkBox(0.12, 0.006, 0.05, mats.gsDark, sc.face - 0.06, sc.yCas0 - 0.003, bz), 'gs-hw-cassette', null, 'screen-bracket-arm-' + (k + 1));
      }
      /* v311 (Marek 23:41: "pri screen on / off by byla lepsi pomala
         animace dolu / nahoru"): the fabric, the image and the bottom bar
         always drawn, set to the roll (the bar's height): down = the
         fabric's bottom, up = just under the cassette; a switch of the
         toggle (or undo / a reference design) rolls it over 1 - 4 s */
      var fh = sc.yFab1 - sc.yFab0;
      var rl = {
        fab: hw(self._mkBox(0.002, fh, sc.fabW, mats.gsBlack, sc.x, (sc.yFab0 + sc.yFab1) / 2, 0), 'gs-hw-fabric', null, 'screen-fabric'),
        img: hw(self._mkBox(0.002, sc.h, sc.w, mats.gsWhite, sc.x + 0.0025, sc.yI0 + sc.h / 2, 0), 'gs-hw-fabric', null, 'screen-image'),
        bar: hw(self._mkBox(0.025, 0.03, sc.fabW + 0.02, mats.gsDark, sc.x, sc.yFab0, 0), 'gs-hw-fabric', null, 'screen-bar'),
        top: sc.yFab1, fh: fh, ih: sc.h, bord: GS.FAB_BORDER
      };
      var yUp = sc.yCas0 - 0.015, yDn = sc.yFab0, yTo = sc.on ? yDn : yUp, rPrev = self._gsRoll;
      if (self._gsRollRaf) { try { global.cancelAnimationFrame(self._gsRollRaf); } catch (eRc) {} self._gsRollRaf = null; }
      self._gsRoll = { on: sc.on, cur: yTo };
      if (rPrev && rPrev.on !== sc.on && typeof global.requestAnimationFrame === 'function') {
        var yFr = Math.max(yDn, Math.min(yUp, (typeof rPrev.cur === 'number') ? rPrev.cur : (sc.on ? yUp : yDn)));
        var rDur = Math.min(4000, 1000 + 1500 * Math.abs(yTo - yFr)), rT0 = null, rSt = self._gsRoll;
        _gsSetRoll(rl, yFr); rSt.cur = yFr;
        var rStep = function (ts) {
          if (rT0 === null) rT0 = ts;
          var f = Math.min(1, (ts - rT0) / rDur), e = (f < 0.5) ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
          rSt.cur = yFr + (yTo - yFr) * e;
          _gsSetRoll(rl, rSt.cur);
          self._gsRollRaf = (f < 1) ? global.requestAnimationFrame(rStep) : null;
        };
        self._gsRollRaf = global.requestAnimationFrame(rStep);
      } else _gsSetRoll(rl, yTo);
      /* v324 the projector upside down under the front eave beam: the
         mount's plate on the beam's underside, its drop, the cradle on the
         projector (the mount: NOT BILLED), the body, the lens to the screen */
      var pj = g.proj, pmo = pj.mount;
      hw(self._mkBox(pmo.plate, pmo.t, pmo.plate, mats.gsBlack, pmo.x, pmo.y1 - pmo.t / 2, pj.z), 'gs-hw-projmount', null, 'projector-mount-plate');
      var pmPole = new T.Mesh(new T.CylinderGeometry(0.018, 0.018, pmo.drop, 12), mats.gsBlack);
      pmPole.position.set(pmo.x, pmo.y1 - pmo.t - pmo.drop / 2, pj.z);
      hw(pmPole, 'gs-hw-projmount', null, 'projector-mount-drop');
      hw(self._mkBox(Math.min(pj.d, 0.26), pmo.t, Math.min(pj.w, 0.30), mats.gsBlack, pj.x, pj.y + pj.h / 2 + pmo.t / 2, pj.z), 'gs-hw-projmount', null, 'projector-mount-cradle');
      var pm = self._mkBox(pj.d, pj.h, pj.w, mats.gsDark, pj.x, pj.y, pj.z);
      hw(pm, 'gs-hw-projector', GS.PROJECTOR, 'projector');
      var lens = new T.Mesh(new T.CylinderGeometry(0.034, 0.038, 0.025, 20), mats.gsBlack);
      lens.rotation.z = Math.PI / 2;
      lens.position.set(pj.x - pj.d / 2 - 0.0125, pj.y + 0.012, pj.z);
      hw(lens, 'gs-hw-projector', null, 'projector-lens');
      /* the stools: a round wooden seat, four black legs splayed a little, a foot ring */
      for (i = 0; i < g.stools.length; i++) {
        var so = g.stools[i], grp = new T.Group();
        var seat = new T.Mesh(new T.CylinderGeometry(so.r, so.r, 0.035, 24), mats.gsSeat);   /* v312 its own colour per scheme */
        seat.position.y = so.y - 0.0175;
        grp.add(seat);
        for (k = 0; k < 4; k++) {
          var an2 = Math.PI / 4 + k * Math.PI / 2, rt = so.r * 0.72, rb = so.r * 1.05;
          var A = new T.Vector3(Math.cos(an2) * rt, so.y - 0.035, Math.sin(an2) * rt), B = new T.Vector3(Math.cos(an2) * rb, 0, Math.sin(an2) * rb);
          var leg = new T.Mesh(new T.CylinderGeometry(0.011, 0.011, A.distanceTo(B), 8), mats.gsDark);
          leg.position.copy(A).add(B).multiplyScalar(0.5);
          leg.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), A.clone().sub(B).normalize());
          grp.add(leg);
        }
        var ring = new T.Mesh(new T.TorusGeometry(so.r * 0.93, 0.008, 6, 28), mats.gsDark);
        ring.rotation.x = Math.PI / 2;
        ring.position.y = 0.30;
        grp.add(ring);
        grp.position.set(so.x, 0, so.z);
        hw(grp, 'gs-hw-stool', GS.STOOL, 'stool-' + (i + 1));
      }
      /* the string of bulbs */
      if (g.cable.length > 1) {
        var pts = g.cable.map(function (P) { return new T.Vector3(P[0], P[1], P[2]); });
        var tube = new T.Mesh(new T.TubeGeometry(new T.CatmullRomCurve3(pts), pts.length * 2, 0.004, 5, false), mats.gsBlack);
        hw(tube, 'gs-hw-lights', GS.LIGHTS, 'light-string');
        for (i = 0; i < g.bulbs.length; i++) {
          var bl = new T.Mesh(new T.SphereGeometry(0.022, 10, 8), mats.gsBulb);
          bl.position.set(g.bulbs[i][0], g.bulbs[i][1], g.bulbs[i][2]);
          hw(bl, 'gs-hw-lights', null, 'bulb-' + (i + 1));
        }
      }
      try {
        var key = 'gs|' + Math.round(g.L * 100) + '|' + (STATE.isMetric === false) + '|' + sc.on + '|' + Math.round(sc.yI0 * 100);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeGarden(STATE);
          _dbg('[gs] cinema bar ' + g.L.toFixed(3) + ' m (posts ' + g.S.toFixed(3) + ' at the centres), ' + g.depth.toFixed(3) + ' x ' + g.height.toFixed(3) + ' m: sills ' + g.sillL.toFixed(2) + ', posts ' + g.postH.toFixed(3) + ', kickers ' + g.kLen.toFixed(2) + ' (foot ' + g.kFoot.toFixed(2) + ' out, top ' + g.kTop.toFixed(2) + ' up), ties at ' + g.yT0.toFixed(3) + '..' + g.yT1.toFixed(3) + ', ridge ' + g.yR1.toFixed(3) + ', pitch ' + g.pitch + ' deg, ' + g.zr.length + ' rafter pairs ' + g.rafL.toFixed(2) +
               '; screen ' + sc.diag + ' in. 2.35:1 ' + sc.w.toFixed(3) + ' x ' + sc.h.toFixed(3) + ' (custom, as wide as the ties let it) on the back eave beam (' + (sc.on ? 'down' : 'rolled up') + ', image ' + sc.yI0.toFixed(2) + '..' + sc.yI1.toFixed(2) + ', fabric down to ' + sc.yFab0.toFixed(2) + ')' +
               '; ridge 6x10 ' + g.yR0.toFixed(3) + '..' + g.yR1.toFixed(3) + ' (2 cm over the rafters), rafters ' + g.rafL.toFixed(2) + ' plumb on its faces' +
               '; top acacia FOU00034 ' + g.topN + ' piece(s) of ' + g.topLen.toFixed(3) + ' m, ' + g.D.toFixed(3) + ' deep, ' + (g.topT * 1000).toFixed(1) + ' mm (' + g.counterBack.toFixed(3) + '..' + g.counterFront.toFixed(3) + '), ' + g.pockets + ' pocket screws FAS50060 from below; braces screwed ' + g.braceScrews + ' x top ' + g.yC.toFixed(3) + ' on 2 rails ' + g.railL.toFixed(2) + ' at ' + g.yRb.toFixed(3) + '..' + g.yRt.toFixed(3) + ' (sag ' + g.deflR.toFixed(2) + ' mm at 1 kN/m over ' + g.panel.toFixed(2) + '), footrests ' + g.yS1.toFixed(3) + '..' + g.yFt.toFixed(3) + ', ' + g.braceN + ' braces ' + g.braceL.toFixed(2) + ' m (' + g.braceHeads + ' heads, a run ' + g.braceRun.toFixed(3) + ', ' + g.braceRods + ' rods), adhesive ' + g.glueM + ' m = ' + g.glueN + ' cartridges, ' + g.stools.length + ' stools, lights ' + g.cableL.toFixed(1) + ' m (' + g.bulbs.length + ' bulbs); ' + g.tiles + ' tiles on ' + g.gravelM3 + ' m3 gravel; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[gs] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v355 TYPE 25, GARDEN STRUCTURE -- THE BAR (_mbLayout): the slab, the
       post bases, the timber (posts, beams, purlins, the back wall's and the
       counter's frame), the corrugated sheets, the boards and hedge, the
       cement board, the stone, the top's layers (ply, cement board, tiles),
       the trim, the LED strip, every screw / nail / anchor, the stools and
       the string of bulbs */
    _mbTex: function (kind) {
      var T = global.THREE, c = this._mbTexC || (this._mbTexC = {});
      if (c[kind]) return c[kind];
      var doc = global.document;
      if (!doc || !doc.createElement) return null;
      var cv = doc.createElement('canvas');
      cv.width = 256; cv.height = 256;
      var x = cv.getContext ? cv.getContext('2d') : null;
      if (!x) return null;
      var sd = 12345;
      function rnd() { sd = (sd * 16807) % 2147483647; return (sd - 1) / 2147483646; }
      var i, j, a;
      if (kind === 'stone') {
        /* split-face ledgestone: courses of long thin stones in warm sand / grey */
        x.fillStyle = '#5b5148'; x.fillRect(0, 0, 256, 256);
        var pal = ['#c9b79a', '#b9a07e', '#a88f6f', '#d4c3a5', '#8f7d66', '#c2a582', '#9d8a76', '#bfae94', '#a0866a', '#cdbb9b'];
        var yy = 0;
        while (yy < 256) {
          var h = 12 + Math.floor(rnd() * 14), xx = -Math.floor(rnd() * 40);
          while (xx < 256) {
            var w = 24 + Math.floor(rnd() * 64);
            x.fillStyle = pal[Math.floor(rnd() * pal.length)];
            x.fillRect(xx + 1, yy + 1, w - 2, h - 2);
            x.fillStyle = 'rgba(255,255,255,0.10)'; x.fillRect(xx + 1, yy + 1, w - 2, 2);
            x.fillStyle = 'rgba(0,0,0,0.12)'; x.fillRect(xx + 1, yy + h - 3, w - 2, 2);
            xx += w;
          }
          yy += h;
        }
      } else if (kind === 'tile') {
        /* 20 x 20 cm tiles (4 x 4 on the texture), light grout, a faint star */
        x.fillStyle = '#c9c4bb'; x.fillRect(0, 0, 256, 256);
        for (i = 0; i < 4; i++) for (j = 0; j < 4; j++) {
          x.fillStyle = '#eceae4'; x.fillRect(i * 64 + 1.5, j * 64 + 1.5, 61, 61);
          var cx = i * 64 + 32, cy = j * 64 + 32;
          x.strokeStyle = '#bdb5a8'; x.lineWidth = 1.4;
          x.beginPath();
          for (a = 0; a < 16; a++) { var r = (a % 2) ? 7 : 26, an = a * Math.PI / 8; if (a) x.lineTo(cx + Math.cos(an) * r, cy + Math.sin(an) * r); else x.moveTo(cx + r, cy); }
          x.closePath(); x.stroke();
        }
      } else if (kind === 'hedge') {
        /* the artificial hedge: dense small leaves in four greens */
        x.fillStyle = '#2c5527'; x.fillRect(0, 0, 256, 256);
        var gr = ['#3f7a35', '#55913f', '#2a4d24', '#6aa64c', '#1f3d1c'];
        for (i = 0; i < 1600; i++) {
          x.fillStyle = gr[i % gr.length];
          var px = rnd() * 256, py = rnd() * 256, rr = 2 + rnd() * 4;
          x.beginPath();
          if (x.ellipse) x.ellipse(px, py, rr, rr * 0.55, rnd() * 3.1416, 0, 6.2832); else x.arc(px, py, rr, 0, 6.2832);
          x.fill();
        }
      } else return null;
      var tx = new T.CanvasTexture(cv);
      try { tx.colorSpace = T.SRGBColorSpace; } catch (eC) {}
      tx.wrapS = tx.wrapT = T.RepeatWrapping;
      tx.anisotropy = 4;
      c[kind] = tx;
      return tx;
    },
    /* a textured copy of the base material for one box: the texture's tile (m) over the box's two largest sides;
       a flat box (the tiles) keyed to the world so the joints run on from piece to piece round the posts */
    _mbMat: function (kind, base, b, tile) {
      var tx = this._mbTex(kind);
      if (!tx) return base;
      var m = base.clone(), t = tx.clone(), dims = [b[3], b[4], b[5]], thin = dims.indexOf(Math.min.apply(null, dims));
      var u = (thin === 0) ? b[5] : b[3], v = (thin === 1) ? b[5] : b[4];
      t.needsUpdate = true;
      t.repeat.set(Math.max(0.2, u / tile), Math.max(0.2, v / tile));
      if (thin === 1) {
        var fr = function (a) { return a - Math.floor(a); };
        t.offset.set(fr((b[0] - b[3] / 2) / tile), fr(-(b[2] + b[5] / 2) / tile));   /* the top face: u along +X from its -X edge, v along -Z from its +Z edge */
      }
      m.map = t;
      return m;
    },
    _buildManCaveBar: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _mbLayout(STATE), P = g.P;
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.mbGravel) mats.mbGravel = new T.MeshStandardMaterial({ color: 0x6f6c66, roughness: 1.0 });
      if (!mats.mbBase) mats.mbBase = new T.MeshStandardMaterial({ color: 0x1f1f21, roughness: 0.5, metalness: 0.35 });
      if (!mats.mbSheet) mats.mbSheet = new T.MeshStandardMaterial({ color: 0x1c1c1e, roughness: 0.55, metalness: 0.25, side: T.DoubleSide });
      if (!mats.mbSeal) mats.mbSeal = new T.MeshStandardMaterial({ color: 0x2a2a2a, roughness: 0.9 });
      if (!mats.mbCb) mats.mbCb = new T.MeshStandardMaterial({ color: 0xb9b5ad, roughness: 0.95 });
      if (!mats.mbPly) mats.mbPly = new T.MeshStandardMaterial({ color: 0xc9a06a, roughness: 0.8 });
      if (!mats.mbTrim) mats.mbTrim = new T.MeshStandardMaterial({ color: 0xf2f2ef, roughness: 0.35, metalness: 0.45 });
      if (!mats.mbLed) mats.mbLed = new T.MeshStandardMaterial({ color: 0xffe6c4, emissive: 0xffc98a, emissiveIntensity: 1.0, roughness: 0.4 });
      if (!mats.mbStone) mats.mbStone = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.9 });
      if (!mats.mbTile) mats.mbTile = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.4 });
      if (!mats.mbHedge) mats.mbHedge = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 1.0 });
      /* v357 the slab's making, the adhesive, the membrane, the grout, the LED's supply */
      if (!mats.mbDig) mats.mbDig = new T.MeshStandardMaterial({ color: 0x6b4a2f, roughness: 1.0, transparent: true, opacity: 0.55, depthWrite: false });
      if (!mats.mbGeo) mats.mbGeo = new T.MeshStandardMaterial({ color: 0xe9e7e1, roughness: 1.0, side: T.DoubleSide });
      if (!mats.mbForm) mats.mbForm = new T.MeshStandardMaterial({ color: 0xb08d5e, roughness: 0.85 });
      if (!mats.mbSpacer) mats.mbSpacer = new T.MeshStandardMaterial({ color: 0x8d8d8a, roughness: 0.8 });
      if (!mats.mbMesh) mats.mbMesh = new T.MeshStandardMaterial({ color: 0x5c4a3d, roughness: 0.6, metalness: 0.5 });
      if (!mats.mbAdh) mats.mbAdh = new T.MeshStandardMaterial({ color: 0x9d9a94, roughness: 0.95 });
      if (!mats.mbMem) mats.mbMem = new T.MeshStandardMaterial({ color: 0x5d7fa6, roughness: 0.7 });
      if (!mats.mbGrout) mats.mbGrout = new T.MeshStandardMaterial({ color: 0x9e978c, roughness: 0.9 });
      if (!mats.mbPsu) mats.mbPsu = new T.MeshStandardMaterial({ color: 0x2c2d30, roughness: 0.5, metalness: 0.4 });
      if (!mats.gsBlack) mats.gsBlack = new T.MeshStandardMaterial({ color: 0x151515, roughness: 0.85, side: T.DoubleSide });
      if (!mats.gsDark) mats.gsDark = new T.MeshStandardMaterial({ color: 0x2b2d30, roughness: 0.6, metalness: 0.2 });
      if (!mats.gsBulb) mats.gsBulb = new T.MeshStandardMaterial({ color: 0xffe2a8, emissive: 0xffc46b, emissiveIntensity: 0.9, roughness: 0.3 });
      if (!mats.gsSeat) mats.gsSeat = new T.MeshStandardMaterial({ color: COLOR_SCHEMES[_colorScheme()].seat || 0x2f3133, roughness: 0.7 });
      function hw(m, pt, code, id) { self._addToScene(m, pt, code ? { boqCode: code, idHint: id } : { idHint: id }); return m; }
      /* v357 (Marek 18:35: lepe rozvrhnout pohyb komponentu -- obklad se ma animovat z boku na steny konstrukce) every part its own way in:
         a face's layer (the cement board, the stone's adhesive, the stone, the trim, the LED) from outside along the face's normal, the
         counter's studs from their wall's outer side, the back wall's members from the bar side, the braces from the bartender's side,
         the slab's beds, plates, the top's layers and the roof from above, the stools from the garden */
      function fd(n) { return [n[0], 0, n[1]]; }
      /* the slab's making (_benchVisibleAtStep: drawn only while it is made -- MB_PROC), no catalogue tag: the step's caption names it */
      for (i = 0; i < g.proc.length; i++) {
        var pr = g.proc[i], pb = pr.box, pm = (pr.kind === 'dig') ? mats.mbDig : (pr.kind === 'geo') ? mats.mbGeo : (pr.kind === 'form') ? mats.mbForm : mats.mbSpacer;
        var prM = self._mkBox(pb[3], pb[4], pb[5], pm, pb[0], pb[1], pb[2]);
        prM.userData.flyDir = (pr.kind === 'dig') ? [0, -1, 0] : (pr.kind === 'form') ? fd(pr.n) : [0, 1, 0];
        prM.userData.mbProc = MB_PROC['mb-' + pr.kind];
        self._addToScene(prM, 'mb-' + pr.kind, { idHint: pr.id });
      }
      if (g.mesh.length) {
        var mg = new T.Group();
        for (i = 0; i < g.mesh.length; i++) { var mb = g.mesh[i]; mg.add(self._mkBox(mb[3], mb[4], mb[5], mats.mbMesh, mb[0], mb[1], mb[2])); }
        mg.userData.flyDir = [0, 1, 0];
        mg.userData.mbProc = MB_PROC['mb-mesh'];
        self._addToScene(mg, 'mb-mesh', { idHint: 'mesh' });
      }
      /* the slab on its gravel bed, tipped in and poured from above */
      var sl = g.slab;
      var gb = self._mkBox(sl.x1 - sl.x0 + 2 * sl.bo, sl.y0 - sl.g0, sl.z1 - sl.z0 + 2 * sl.bo, mats.mbGravel, (sl.x0 + sl.x1) / 2, (sl.g0 + sl.y0) / 2, (sl.z0 + sl.z1) / 2);
      gb.userData.flyDir = [0, 1, 0];
      self._addToScene(gb, 'mb-gravel', { boqCode: MB.GRAVEL_CODE, idHint: 'gravel-bed' });
      var sb = self._mkBox(sl.x1 - sl.x0, sl.y1 - sl.y0, sl.z1 - sl.z0, mats.concrete, (sl.x0 + sl.x1) / 2, (sl.y0 + sl.y1) / 2, (sl.z0 + sl.z1) / 2);
      sb.userData.flyDir = [0, 1, 0];
      self._addToScene(sb, 'mb-slab', { boqCode: MB.CONCRETE, idHint: 'slab' });
      /* the post bases: a plate on the slab, the sleeve's two cheeks */
      for (i = 0; i < g.bases.length; i++) {
        var bs = g.bases[i], grp = new T.Group(), pt = P.p / 2 + 0.002;
        grp.add(self._mkBox(bs.w, 0.004, bs.w, mats.mbBase, 0, 0.002, 0));
        grp.add(self._mkBox(0.004, bs.y1 - bs.y0, bs.w * 0.6, mats.mbBase, 0, (bs.y1 - bs.y0) / 2, 0));
        for (k = -1; k <= 1; k += 2) grp.add(self._mkBox(0.004, bs.h, P.p * 0.8, mats.mbBase, k * pt, bs.y1 - bs.y0 + bs.h / 2 - 0.02, 0));
        grp.position.set(bs.x, bs.y0, bs.z);
        grp.userData.flyDir = [0, 1, 0];
        hw(grp, 'mb-base', MB.PBASE, 'post-base-' + bs.id);
      }
      /* the timber */
      var FLY = { post: [0, 1, 0], beam: [0, 1, 0], rafter: [0, 1, 0], purlin: [0, 1, 0], wsole: [1, 0, 0], wstud: [1, 0, 0], wtop: [1, 0, 0], csole: [0, 1, 0], ctop: [0, 1, 0], joist: [0, 1, 0], cbrace: [-1, 0, 0] };
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var b = pc.box;
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mats.lumber);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t, 0, 0); }   /* the shape in (z, y), extruded across x from c to c + t */
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };
        }
        m.userData.flyDir = (pc.kind === 'cstud' && pc.n) ? fd(pc.n) : (FLY[pc.kind] || [0, 1, 0]);
        self._addToScene(m, 'mb-' + pc.kind, (pc.len > 0) ? { boqCode: pc.code, length: pc.len, idHint: pc.id } : { idHint: pc.id });
      }
      /* the sheets: a corrugated band, the waves across Z, down the slope (the gable's front slope its mirror over the ridge) */
      for (var si = 0; si < g.sheets.length; si++) {
        var shS = g.sheets[si], run = (shS.x1 - shS.x0) / Math.cos(shS.al), wv = shS.wave, amp = shS.t / 2, zs0 = shS.z0, zs1 = shS.z1, nW = Math.max(8, Math.ceil((zs1 - zs0) / (wv / 8))), shp = new T.Shape(), u;
        for (u = 0; u <= nW; u++) { var zw = zs0 + (zs1 - zs0) * u / nW, yw = amp * Math.sin(2 * Math.PI * (zw - zs0) / wv); if (u) shp.lineTo(zw, yw); else shp.moveTo(zw, yw); }
        for (u = nW; u >= 0; u--) { var zw2 = zs0 + (zs1 - zs0) * u / nW; shp.lineTo(zw2, amp * Math.sin(2 * Math.PI * (zw2 - zs0) / wv) - 0.0012); }
        var sg = new T.ExtrudeGeometry(shp, { depth: run, bevelEnabled: false, curveSegments: 1 });
        sg.rotateY(Math.PI / 2);   /* the shape's X -> -Z, the extrusion -> +X */
        sg.rotateZ(shS.al);        /* up towards the front (the gable: towards the ridge) */
        var shM = new T.Mesh(sg, mats.mbSheet);
        shM.position.set(shS.x0, shS.y0 + amp, 0);
        shM.userData.flyDir = [0, 1, 0];
        self._addToScene(shM, 'mb-sheet', { boqCode: MB.SHEET, idHint: 'roof-sheets-' + (si + 1) });
        if (shS.mirror) {
          var shM2 = new T.Mesh(sg, mats.mbSheet);
          shM2.scale.x = -1;
          shM2.position.set(-shS.x0, shS.y0 + amp, 0);
          shM2.userData.flyDir = [0, 1, 0];
          self._addToScene(shM2, 'mb-sheet', { boqCode: MB.SHEET, idHint: 'roof-sheets-' + (si + 1) + 'f' });
        }
      }
      /* v357 the gable's ridge cap: a bent strip over both slopes' sheets */
      if (g.ridge) {
        var rg = g.ridge, rw = rg.w, rt = Math.tan(rg.al), ry = rg.y, rk = 0.0015, rs = new T.Shape();
        rs.moveTo(-rw, ry - rw * rt); rs.lineTo(0, ry); rs.lineTo(rw, ry - rw * rt); rs.lineTo(rw, ry - rw * rt - rk); rs.lineTo(0, ry - rk); rs.lineTo(-rw, ry - rw * rt - rk);
        var rge = new T.ExtrudeGeometry(rs, { depth: rg.z1 - rg.z0, bevelEnabled: false, curveSegments: 1 });
        rge.translate(0, 0, rg.z0);
        var rM = new T.Mesh(rge, mats.mbSheet);
        rM.userData.flyDir = [0, 1, 0];
        self._addToScene(rM, 'mb-ridge', { boqCode: MB.RIDGE, idHint: 'ridge-cap' });
      }
      /* the layers: seal, boards, hedge, cement board, the stone's adhesive, stone, ply, membrane, the tiles' adhesive, tiles, trim, LED, its supply */
      var LFLY = { seal: [1, 0, 0], board: [1, 0, 0], hedge: [1, 0, 0], cseal: [0, 1, 0], ply: [0, 1, 0], cbtop: [0, 1, 0], mem: [0, 1, 0], tadh: [0, 1, 0], tile: [0, 1, 0], psu: [-1, 0, 0] };
      for (i = 0; i < g.layers.length; i++) {
        var ly = g.layers[i], bb = ly.box, mt = mats.lumber;
        if (ly.kind === 'seal' || ly.kind === 'cseal') mt = mats.mbSeal;
        else if (ly.kind === 'cb' || ly.kind === 'cbtop') mt = mats.mbCb;
        else if (ly.kind === 'ply') mt = mats.mbPly;
        else if (ly.kind === 'trim') mt = mats.mbTrim;
        else if (ly.kind === 'led') mt = mats.mbLed;
        else if (ly.kind === 'sadh' || ly.kind === 'tadh') mt = mats.mbAdh;
        else if (ly.kind === 'mem') mt = mats.mbMem;
        else if (ly.kind === 'psu') mt = mats.mbPsu;
        else if (ly.kind === 'stone') mt = self._mbMat('stone', mats.mbStone, bb, 0.60);
        else if (ly.kind === 'tile') mt = self._mbMat('tile', mats.mbTile, bb, 0.80);
        else if (ly.kind === 'hedge') mt = self._mbMat('hedge', mats.mbHedge, bb, 0.50);
        var lm = self._mkBox(bb[3], bb[4], bb[5], mt, bb[0], bb[1], bb[2]);
        lm.userData.flyDir = LFLY[ly.kind] || (ly.n ? fd(ly.n) : [0, 1, 0]);
        self._addToScene(lm, 'mb-' + ly.kind, ly.code ? { boqCode: ly.code, idHint: ly.id } : { idHint: ly.id });
      }
      /* v357 the grout: the joints filled flush, one group */
      if (g.grout.length) {
        var gg = new T.Group();
        for (i = 0; i < g.grout.length; i++) { var gr = g.grout[i]; gg.add(self._mkBox(gr[3], gr[4], gr[5], mats.mbGrout, gr[0], gr[1], gr[2])); }
        gg.userData.flyDir = [0, 1, 0];
        self._addToScene(gg, 'mb-grout', { boqCode: MB.GROUT_CODE, idHint: 'grout' });
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'mb-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      /* the stools: a round seat, four legs splayed a little, a foot ring (the cinema bar's); carried in from the garden */
      for (i = 0; i < g.stools.length; i++) {
        var so = g.stools[i], sgp = new T.Group();
        var seat = new T.Mesh(new T.CylinderGeometry(so.r, so.r, 0.035, 24), mats.gsSeat);
        seat.position.y = so.y - 0.0175;
        sgp.add(seat);
        for (k = 0; k < 4; k++) {
          var an2 = Math.PI / 4 + k * Math.PI / 2, rt2 = so.r * 0.72, rb = so.r * 1.05;
          var A = new T.Vector3(Math.cos(an2) * rt2, so.y - 0.035, Math.sin(an2) * rt2), B = new T.Vector3(Math.cos(an2) * rb, 0, Math.sin(an2) * rb);
          var leg = new T.Mesh(new T.CylinderGeometry(0.011, 0.011, A.distanceTo(B), 8), mats.gsDark);
          leg.position.copy(A).add(B).multiplyScalar(0.5);
          leg.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), A.clone().sub(B).normalize());
          sgp.add(leg);
        }
        var ring = new T.Mesh(new T.TorusGeometry(so.r * 0.93, 0.008, 6, 28), mats.gsDark);
        ring.rotation.x = Math.PI / 2;
        ring.position.y = 0.30;
        sgp.add(ring);
        sgp.position.set(so.x, g.ySl, so.z);
        sgp.userData.flyDir = [1, 0, 0];
        hw(sgp, 'mb-hw-stool', MB.STOOL, 'stool-' + (i + 1));
      }
      /* the string of bulbs */
      if (g.cable.length > 1) {
        var pts = g.cable.map(function (Pt) { return new T.Vector3(Pt[0], Pt[1], Pt[2]); });
        var tube = new T.Mesh(new T.TubeGeometry(new T.CatmullRomCurve3(pts), pts.length * 2, 0.004, 5, false), mats.gsBlack);
        hw(tube, 'mb-hw-lights', MB.LIGHTS, 'light-string');
        for (i = 0; i < g.bulbs.length; i++) {
          var bl = new T.Mesh(new T.SphereGeometry(0.022, 10, 8), mats.gsBulb);
          bl.position.set(g.bulbs[i][0], g.bulbs[i][1], g.bulbs[i][2]);
          hw(bl, 'mb-hw-lights', null, 'bulb-' + (i + 1));
        }
      }
      try {
        var key = 'mb|' + Math.round(g.L * 100) + '|' + (STATE.isMetric === false) + '|' + g.shape + '|' + g.roof + '|' + g.pitch + '|' + Math.round(g.hgt * 1000) + '|' + g.cov;
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeManCaveBar(STATE);
          _dbg('[mb] the bar ' + g.L.toFixed(3) + ' m, ' + g.nFr + ' frames (' + g.zFr.map(function (z) { return z.toFixed(2); }).join(' / ') + '), ' + g.nP + ' purlins, ' + g.roof + ' roof ' + g.pitch + ' deg, ' + (g.cov ? 'sheets ' + g.roofA.toFixed(2) + ' m2' : 'open') + (g.ridge ? ', ridge cap ' + g.ridgeL.toFixed(2) + ' m' : '') + ', height ' + g.hgt.toFixed(3) + ' (top ' + g.height.toFixed(3) + ' m); counter ' + g.shape +
               ' ' + (g.zB - g.zA).toFixed(2) + ' m, top ' + g.ySt.toFixed(3) + ' m, ' + g.topA.toFixed(2) + ' m2 tiles (' + g.grout.length + ' joints), stone ' + g.stoneA.toFixed(2) + ' m2, cement board ' + g.cbSideA.toFixed(2) + ' + ' + g.topA.toFixed(2) + ' m2, trim ' + g.trimL.toFixed(2) + ' m, LED ' + g.ledM.toFixed(2) + ' m; back wall boards ' + g.boardA.toFixed(2) + ' m2, hedge ' + g.hedgeA.toFixed(2) + ' m2; slab ' + g.slabA.toFixed(2) + ' m2 (' + g.concM3 + ' m3, ' + g.spacerN + ' spacers, ' + g.mesh.length + ' bars drawn); ' +
               g.stools.length + ' stools, ' + g.bulbs.length + ' bulbs; ' + _swingActiveSteps(STATE).length + ' steps; ' + Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[mb] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v314 TYPE 20, GARDEN STRUCTURE 2 -- THE RAISED BED (_rbLayout): the
       geotextile, the soil, the timber (boxes, the frame's / wings'
       polygons), every screw, the vinyl (the gables', the wings'), the
       staples, the hinges, the lid supports (v315); the wings turned about
       their hinges' axis when open, swung slowly when the toggle (or undo /
       a reference design) changes it, the lid supports' rods running out
       of their bodies with them */
    _buildRaisedBed: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _rbLayout(STATE);
      if (!mats.soil) mats.soil = new T.MeshStandardMaterial({ color: 0x4a3526, roughness: 1.0 });
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.rbGeo) mats.rbGeo = new T.MeshStandardMaterial({ color: 0x2b2b2b, roughness: 1.0 });
      if (!mats.rbVinyl) mats.rbVinyl = new T.MeshStandardMaterial({ color: 0xe6f2f7, roughness: 0.1, transparent: true, opacity: RB.VINYL_OP, depthWrite: false, side: T.DoubleSide });   /* v325 10 % (Marek: at je pruhledna; was 30 % -- and the viz stage made it opaque, see VINYL_OP there) */
      if (!mats.rbStay) mats.rbStay = new T.MeshStandardMaterial({ color: 0x2f3236, roughness: 0.35, metalness: 0.5 });
      function hw(m, pt, code, id) { self._addToScene(m, pt, code ? { boqCode: code, idHint: id } : { idHint: id }); return m; }
      var wingParts = [];
      /* the geotextile under the soil, the soil (a box a tier) */
      var ge = g.geo;
      hw(self._mkBox(ge.x1 - ge.x0, 0.002, ge.z1 - ge.z0, mats.rbGeo, 0, 0.001, 0), 'rb-geo', RB.GEO, 'geotextile');
      for (i = 0; i < g.soil.length; i++) {
        var so = g.soil[i], sy0 = so.y0 + 0.002, sm = self._mkBox(so.x1 - so.x0, so.y1 - sy0, so.z1 - so.z0, mats.soil, (so.x0 + so.x1) / 2, (sy0 + so.y1) / 2, (so.z0 + so.z1) / 2);
        sm.userData.flyDir = [0, 1, 0];
        hw(sm, 'rb-soil', RB.SOIL, 'soil-' + (i + 1));
      }
      /* the timber */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var bx = pc.box;
          m = self._mkBox(bx[3], bx[4], bx[5], mats.lumber, bx[0], bx[1], bx[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var gx = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          gx.translate(0, 0, -pc.t / 2);
          m = new T.Mesh(gx, mats.lumber);
          m.position.set(0, 0, pc.c);
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        if (/^(cap|ridge|rafter|eave|sash|batten|tbeam|tbrace)$/.test(pc.kind)) m.userData.flyDir = [0, 1, 0];
        self._addToScene(m, 'rb-' + pc.kind, (pc.len > 0) ? { boqCode: pc.code, length: pc.len, idHint: pc.id } : { idHint: pc.id });
        if (pc.wing) wingParts.push({ m: m, w: pc.wing });
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i], fm = self._addFastener(f, 'rb-hw-' + f.kind, f.code, f.kind + '-' + (i + 1));
        if (f.wing) wingParts.push({ m: fm, w: f.wing });
      }
      /* the vinyl: the gables' and the long sides' on the frame's outer
         faces (the foot folded onto the cap), the wings' on their sashes
         (under the battens) */
      for (i = 0; i < g.vinyl.length; i++) {
        var v = g.vinyl[i], vm;
        if (v.kind === 'gable') {
          var vs = new T.Shape();
          vs.moveTo(v.pts[0][0], v.pts[0][1]);
          for (k = 1; k < v.pts.length; k++) vs.lineTo(v.pts[k][0], v.pts[k][1]);
          vm = new T.Mesh(new T.ExtrudeGeometry(vs, { depth: 0.0008, bevelEnabled: false, curveSegments: 1 }), mats.rbVinyl);
          vm.position.set(0, 0, v.z + ((v.gs > 0) ? 0.0002 : -0.001));
          hw(vm, 'rb-hw-gvinyl', RB.VINYL, 'vinyl-gable-' + ((v.gs < 0) ? 'l' : 'r'));
          hw(self._mkBox(v.w, 0.0008, v.fold, mats.rbVinyl, 0, v.y0 + 0.0004, v.z + v.gs * v.fold / 2), 'rb-hw-gvinyl', null, 'vinyl-gable-fold-' + ((v.gs < 0) ? 'l' : 'r'));
        } else if (v.kind === 'side') {   /* v315 the long sides under the eaves */
          hw(self._mkBox(0.0008, v.y1 - v.y0, v.z1 - v.z0, mats.rbVinyl, v.x + v.sx * 0.0006, (v.y0 + v.y1) / 2, (v.z0 + v.z1) / 2), 'rb-hw-gvinyl', RB.VINYL, 'vinyl-side-' + ((v.sx < 0) ? 'b' : 'f'));
          hw(self._mkBox(v.fold, 0.0008, v.z1 - v.z0, mats.rbVinyl, v.x + v.sx * v.fold / 2, v.y0 + 0.0004, (v.z0 + v.z1) / 2), 'rb-hw-gvinyl', null, 'vinyl-side-fold-' + ((v.sx < 0) ? 'b' : 'f'));
        } else {
          vm = self._mkBox(v.sl, 0.0008, v.wl, mats.rbVinyl, v.sx * v.xm, v.ym + 0.0004, (v.za + v.zb) / 2);
          vm.rotation.z = -v.sx * v.phi;
          hw(vm, 'rb-hw-vinyl', RB.VINYL, 'vinyl-' + v.wing);
          wingParts.push({ m: vm, w: v.wing });
        }
      }
      /* v316 the trellis' strings + the wire they are tied to (drawn, not billed) */
      if (!mats.rbTwine) mats.rbTwine = new T.MeshStandardMaterial({ color: 0xd8c49a, roughness: 0.9 });
      for (i = 0; i < g.strings.length; i++) {
        var sgS = g.strings[i], slS = new T.Mesh(new T.CylinderGeometry(0.0015, 0.0015, sgS.y1 - sgS.y0, 5), mats.rbTwine);
        slS.position.set(sgS.x, (sgS.y0 + sgS.y1) / 2, sgS.z);
        hw(slS, 'rb-hw-string', null, 'string-' + (i + 1));
      }
      for (i = 0; i < g.wires.length; i++) {
        var wrS = g.wires[i], wmS = new T.Mesh(new T.CylinderGeometry(0.0012, 0.0012, wrS.z1 - wrS.z0, 5), mats.galv);
        wmS.rotation.x = Math.PI / 2;
        wmS.position.set(wrS.x, wrS.y, (wrS.z0 + wrS.z1) / 2);
        hw(wmS, 'rb-hw-string', null, 'wire-' + (i + 1));
      }
      /* the staples (no catalogue row -- drawn, NOT BILLED) */
      for (i = 0; i < g.staples.length; i++) {
        var stq = g.staples[i], sq = self._mkBox(stq.d[0], stq.d[1], stq.d[2], mats.galv, stq.x, stq.y, stq.z);
        sq.rotation.z = stq.rz;
        hw(sq, stq.wing ? 'rb-hw-staple' : 'rb-hw-gstaple', null, 'staple-' + (i + 1));
        if (stq.wing) wingParts.push({ m: sq, w: stq.wing });
      }
      /* the hinges: a leaf on the ridge's top, a leaf on the wing's top batten (it swings), the knuckle on the axis */
      for (i = 0; i < g.hinges.length; i++) {
        var h = g.hinges[i], lw = h.hr - 0.003;
        hw(self._mkBox(lw, RB.HLEAF_T, RB.HLEAF_L, mats.galv, h.sx * (0.003 + lw / 2), h.y + RB.HLEAF_T / 2, h.z), 'rb-hw-hinge', RB.HINGE, 'hinge-' + h.wing + '-' + (i + 1));
        var lb = self._mkBox(RB.HLEAF_W, RB.HLEAF_T, RB.HLEAF_L, mats.galv, h.sx * (h.hr + RB.HLEAF_W / 2 * Math.cos(h.phi)), h.y - RB.HLEAF_W / 2 * Math.sin(h.phi) + RB.HLEAF_T / 2, h.z);
        lb.rotation.z = -h.sx * h.phi;
        hw(lb, 'rb-hw-hinge', null, 'hinge-leaf-' + h.wing + '-' + (i + 1));
        wingParts.push({ m: lb, w: h.wing });
        var kn = new T.Mesh(new T.CylinderGeometry(0.004, 0.004, RB.HLEAF_L, 10), mats.galv);
        kn.rotation.x = Math.PI / 2;
        kn.position.set(h.sx * h.hr, h.y + 0.002, h.z);
        hw(kn, 'rb-hw-hinge', null, 'hinge-knuckle-' + h.wing + '-' + (i + 1));
      }
      /* the lid supports (v315): the body's bracket on the rafter's inner
         face, the rod's under the wing's stile (it swings); the body from
         its pivot towards the rod's pivot, the rod from there back into it */
      var stayParts = [], Yup = new T.Vector3(0, 1, 0);
      for (i = 0; i < g.stays.length; i++) {
        var sy = g.stays[i], sid = sy.wing + '-' + (i + 1);
        var body = hw(new T.Mesh(new T.CylinderGeometry(0.011, 0.011, sy.lb, 12), mats.rbStay), 'rb-hw-stay', RB.STAY, 'stay-' + sid);
        var rod = hw(new T.Mesh(new T.CylinderGeometry(0.004, 0.004, sy.lr, 8), mats.galv), 'rb-hw-stay', null, 'stay-rod-' + sid);
        hw(self._mkBox(0.035, 0.035, 0.004, mats.galv, sy.a[0], sy.a[1], sy.zr - sy.gs * 0.002), 'rb-hw-stay', null, 'stay-bracket-' + sid);
        var brB = self._mkBox(0.035, 0.004, 0.022, mats.galv, sy.bb[0], sy.bb[1], sy.z);
        brB.rotation.z = -sy.sx * sy.phi;
        hw(brB, 'rb-hw-stay', null, 'stay-bracket-w-' + sid);
        wingParts.push({ m: brB, w: sy.wing });
        stayParts.push({ s: sy, body: body, rod: rod });
      }
      /* THE WINGS' POSE: every part of a wing turned about its axis (f 0 =
         closed .. 1 = open); basePos kept (build()'s assembly step puts
         each part back to it); a switch of the toggle swings them */
      var byId = {}, Zax = new T.Vector3(0, 0, 1);
      for (i = 0; i < g.wings.length; i++) byId[g.wings[i].id] = g.wings[i];
      wingParts.forEach(function (e) { e.p0 = e.m.position.clone(); e.q0 = e.m.quaternion.clone(); });
      function pose(fo) {
        wingParts.forEach(function (e) {
          var w = byId[e.w];
          if (!w) return;
          var th = w.th * fo, c = Math.cos(th), sn = Math.sin(th), dx = e.p0.x - w.ax, dy = e.p0.y - w.ay;
          e.m.position.set(w.ax + dx * c - dy * sn, w.ay + dx * sn + dy * c, e.p0.z);
          e.m.quaternion.setFromAxisAngle(Zax, th).multiply(e.q0);
          if (e.m.userData) e.m.userData.basePos = e.m.position.clone();
        });
        stayParts.forEach(function (e) {
          var w = byId[e.s.wing];
          if (!w) return;
          var th = w.th * fo, c = Math.cos(th), sn = Math.sin(th), dx = e.s.b[0] - w.ax, dy = e.s.b[1] - w.ay;
          var bx2 = w.ax + dx * c - dy * sn, by2 = w.ay + dx * sn + dy * c, ax2 = e.s.a[0], ay2 = e.s.a[1];
          var vx = bx2 - ax2, vy = by2 - ay2, ln = Math.sqrt(vx * vx + vy * vy) || 1, ux = vx / ln, uy = vy / ln;
          e.body.quaternion.setFromUnitVectors(Yup, new T.Vector3(ux, uy, 0));
          e.rod.quaternion.copy(e.body.quaternion);
          e.body.position.set(ax2 + ux * e.s.lb / 2, ay2 + uy * e.s.lb / 2, e.s.z);
          e.rod.position.set(bx2 - ux * e.s.lr / 2, by2 - uy * e.s.lr / 2, e.s.z);
          e.body.userData.basePos = e.body.position.clone();
          e.rod.userData.basePos = e.rod.position.clone();
        });
      }
      var to = g.open ? 1 : 0, prev = self._rbPose;
      if (self._rbPoseRaf) { try { global.cancelAnimationFrame(self._rbPoseRaf); } catch (eC) {} self._rbPoseRaf = null; }
      self._rbPose = { open: g.open, cur: to };
      if (wingParts.length && prev && prev.open !== g.open && typeof global.requestAnimationFrame === 'function') {
        var fr = Math.max(0, Math.min(1, (typeof prev.cur === 'number') ? prev.cur : 1 - to)), dur = 1800 * Math.max(0.3, Math.abs(to - fr)), t0 = null, st = self._rbPose;
        pose(fr); st.cur = fr;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var u = Math.min(1, (ts - t0) / dur), e2 = (u < 0.5) ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
          st.cur = fr + (to - fr) * e2;
          pose(st.cur);
          self._rbPoseRaf = (u < 1) ? global.requestAnimationFrame(step) : null;
          if (u >= 1 && !_fitMoved && !(_T && _T.on)) { try { _fitView(); } catch (eF) {} }   /* v325 framed again once the wings stand open / shut */
        };
        self._rbPoseRaf = global.requestAnimationFrame(step);
      } else pose(to);
      try {
        var key = 'rb|' + g.mode + '|' + Math.round(g.L * 1000) + '|' + Math.round(g.W * 1000) + '|' + g.N + '|' + (STATE.isMetric === false) + '|' + g.open + '|' + !!g.trellis;
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeRaisedBed(STATE);
          _dbg('[rb] raised bed ' + g.mode + ' ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + g.N + ((g.mode === 'pyramid') ? ' tiers' : ' courses') + ' (' + g.nRange.min + '..' + g.nRange.max + '), walls to ' + g.yWall.toFixed(3) + ', top ' + g.top.toFixed(3) + ', ' + g.posts.length + ' posts, soil ' + g.soilV + ' m3, geotextile ' + g.geoA + ' m2' +
               (g.frame ? '; cold frame ' + (g.twoW ? '2 + 2' : '1 + 1') + ' wings ' + (g.open ? 'open (' + g.wings.filter(function (w) { return w.lift; }).map(function (w) { return w.id; }).join(', ') + ' raised)' : 'closed') + ' (' + Math.round(g.frame.thOpen * 180 / Math.PI) + ' of ' + Math.round(g.frame.thFull * 180 / Math.PI) + ' deg), frame ' + Math.round(g.frame.f * 1000) + ' mm, ridge top ' + g.frame.yAx.toFixed(3) + ', rafters ' + g.frame.rafL.toFixed(2) + ', vinyl ' + g.vinylM + ' m, ' + g.hinges.length + ' hinges, ' + g.stays.length + ' lid supports (' + (g.stays.length ? g.stays[0].lc.toFixed(3) + ' -> ' + g.stays[0].lo.toFixed(3) + ' m' : '-') + '), ' + g.nStaple + ' staples' : '') + (g.trellis ? '; trellis ' + g.trellis.posts + ' posts, beam top ' + g.trellis.top.toFixed(3) + ', braces ' + g.trellis.braceL.toFixed(2) + ' at ' + Math.round(g.trellis.deg) + ' deg, ' + g.strings.length + ' strings + ' + g.wires.length + ' wire (drawn, not billed)' : '') + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[rb] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v320 TYPE 22, GARDEN STRUCTURE 3 -- THE GARDEN ARBOR (_gaLayout): v321
       the pavers under the posts + their post bases (the concrete screws
       drawn, not billed), the posts, heads, braces, laths, the roof (slats /
       wall plates + rafters + ridge + battens), every screw and nail */
    /* v362 TYPE 26, PLAYHOUSES 1 -- THE COTTAGE (_phLayout): the deck
       blocks, every timber / board as a box or a polygon pushed through
       its thickness (the siding with its openings cut out), the shingles
       as a textured surface (the gazebo's texture), the hinges, knob and
       catch, every screw and nail */
    _buildPlayhouse: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _phAnyLayout(STATE);   /* v364 the A-frame its own */
      var LV = _phLeaves(g);         /* v369 the doors ajar, the shutters off the wall (drawn only -- the bill keeps the layout's) */
      try { global.BenchEngine.benchGroup.userData.phLeaves = LV.list; } catch (eLV) {}
      try { global.BenchEngine.benchGroup.userData.xpLv = g.coop ? { yF: g.yF, yP: g.yPT, W: g.W, L: g.L, aframe: !!g.tractor } : null; } catch (eXl) {}   /* v395 the exploded view's floor, plate and footprint */
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      if (!mats.phShingle) {
        mats.phShingle = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.92, side: T.DoubleSide });
        var phTx = _gzShingleTex(0x6a6e74);
        if (phTx) mats.phShingle.map = phTx; else mats.phShingle.color.setHex(0x4a4d52);
      }
      if (!mats.phOsb) mats.phOsb = new T.MeshStandardMaterial({ color: 0xc9a66b, roughness: 0.9 });
      if (!mats.phDrip) mats.phDrip = new T.MeshStandardMaterial({ color: 0x5f6368, roughness: 0.5, metalness: 0.4 });
      if (!mats.phIron) mats.phIron = new T.MeshStandardMaterial({ color: 0x2b2b2b, roughness: 0.55, metalness: 0.5 });
      if (!mats.phSeam) mats.phSeam = new T.MeshStandardMaterial({ color: 0x59606a, roughness: 0.45, metalness: 0.25 });   /* v366 the modern house's metal roof (v369 in the roof colour) */
      if (!mats.phBarn) mats.phBarn = new T.MeshStandardMaterial({ color: 0x9a3328, roughness: 0.85 });                      /* v367 the little barn's walls (v369 the scheme's) */
      if (!mats.phBarnDoor) mats.phBarnDoor = new T.MeshStandardMaterial({ color: 0x9a3328, roughness: 0.85 });              /* v374 the little barn's doors (painted by _phPaint) */
      if (!mats.phWall) {   /* v369 the kids' colours: one material a role, painted by _phPaint */
        mats.phWall = new T.MeshStandardMaterial({ color: 0x86cbe8, roughness: 0.85 });
        mats.phTrim = new T.MeshStandardMaterial({ color: 0xfaf7f0, roughness: 0.8 });
        mats.phDoor = new T.MeshStandardMaterial({ color: 0xf7c948, roughness: 0.8 });
        mats.phShut = new T.MeshStandardMaterial({ color: 0xf26b5b, roughness: 0.8 });
        mats.phModern = new T.MeshStandardMaterial({ color: 0x5fb3a5, roughness: 0.85 });
      }
      if (!mats.phBark) mats.phBark = new T.MeshStandardMaterial({ color: 0x75644f, roughness: 0.95, transparent: true, opacity: 0.3, depthWrite: false });   /* v368 the tree fort's tree -- v374 a reference only, 30 % (Marek 2026-10-30 10:11: udelej ho jako referencni, staci 30%) */
      var OUT = { siding: 1, trim: 1, casing: 1, door: 1, ledge: 1, shutter: 1, sledge: 1 };
      function put(m, pt, code, id, len, fly) {
        var o = { idHint: id };
        if (code) { o.boqCode = code; if (len > 0) o.length = len; }
        if (fly) m.userData.flyDir = fly;
        self._addToScene(m, pt, o);
        return m;
      }
      /* the deck blocks: a square frustum each (the gazebo's) */
      for (i = 0; i < g.blocks.length; i++) {
        var bk = g.blocks[i], bkG = new T.CylinderGeometry(bk.wt / Math.SQRT2, bk.w / Math.SQRT2, bk.y1 - bk.y0, 4, 1);
        bkG.rotateY(Math.PI / 4 - bk.a);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bk.x, (bk.y0 + bk.y1) / 2, bk.z);
        put(bkM, 'ph-block', PH.BLOCK, 'block-' + bk.id, 0, [0, -1, 0]);
      }
      /* v363 the stilt house: each ground screw's head out of the ground + its
         flange plate, the U head on it (plate, stem, the two flanges up the
         post's X faces) -- the modern swing's */
      if (g.gscrews.length) {
        if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
        var ubt = PH.U_T, ufl = PH.U_FL, up = g.P.p;
        for (i = 0; i < g.gscrews.length; i++) {
          var gsq = g.gscrews[i];
          var gtube = new T.Mesh(new T.CylinderGeometry(gsq.r, gsq.r, gsq.y1 - 0.006, 16), mats.galv);
          gtube.position.set(gsq.x, (gsq.y1 - 0.006) / 2, gsq.z);
          put(gtube, 'ph-gscrew', PH.GSCREW, 'gscrew-' + gsq.id, 0, [0, -1, 0]);
          put(self._mkBox(0.15, 0.006, 0.15, mats.galv, gsq.x, gsq.y1 - 0.003, gsq.z), 'ph-gscrew', null, 'gscrew-flange-' + gsq.id, 0, [0, -1, 0]);
        }
      }
      /* v402 the poured footings' tops (the rest below: billed, not drawn -- the gazebo's) */
      if ((g.pours || []).length && !mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      for (i = 0; i < (g.pours || []).length; i++) {
        var po = g.pours[i], poM = new T.Mesh(new T.BoxGeometry(po.w, po.y1 + 0.02, po.w), mats.concrete);
        poM.position.set(po.x, (po.y1 - 0.02) / 2, po.z);
        put(poM, 'ph-pour', PH.CONCRETE, 'footing-' + po.id, 0, [0, -1, 0]);
      }
      /* the U heads (v402 also on the footings: the wet-set U anchors; their flanges on the member's faces -- a post's or a rim's) */
      if (g.uheads.length) {
        if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
        var ubt = PH.U_T, ufl = PH.U_FL, up = g.P.p;
        for (i = 0; i < g.uheads.length; i++) {
          var uq = g.uheads[i], uw = uq.w || up, uqa = !!(uq.a || uq.az);   /* v401 the hoop coop's run: an end beam's U heads turned a quarter (their flanges on its Z faces); v402 + a house's under its joists */
          put(self._mkBox(uqa ? up : uw + 2 * ubt, ubt, uqa ? uw + 2 * ubt : up, mats.galv, uq.x, uq.y1 - ubt / 2, uq.z), 'ph-uhead', uq.wet ? PH.UANCHOR : PH.UHEAD, 'uhead-' + uq.id, 0, [0, -1, 0]);
          var ustem = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, uq.y1 - uq.y0 - ubt, 10), mats.galv);
          ustem.position.set(uq.x, (uq.y0 + uq.y1 - ubt) / 2, uq.z);
          put(ustem, 'ph-uhead', null, 'uhead-stem-' + uq.id, 0, [0, -1, 0]);
          for (var uk = -1; uk <= 1; uk += 2) put(uqa ? self._mkBox(up, ufl, ubt, mats.galv, uq.x, uq.y1 + ufl / 2 - ubt, uq.z + uk * (uw / 2 + ubt / 2)) : self._mkBox(ubt, ufl, up, mats.galv, uq.x + uk * (uw / 2 + ubt / 2), uq.y1 + ufl / 2 - ubt, uq.z), 'ph-uhead', null, 'uhead-flange-' + uq.id + uk, 0, [0, -1, 0]);
        }
      }
      if (!mats.phSlide) mats.phSlide = new T.MeshStandardMaterial({ color: 0x3f9b4f, roughness: 0.45, metalness: 0 });   /* v363 the slide's HDPE */
      _phPaint(mats);   /* v369 the scheme's kids' colours */
      if (g.coop || g.dog) _coMats(mats);   /* v385 + the dog house */   /* v375 the coop's farmhouse colours + the hardware cloth */
      /* the timber, boards and sheets */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m = null, mat = mats.lumber;
        if (pc.tube) {   /* v401 the hoop coop's tubes (the hoop house's: the hoops, the ridge purlin): no catalogue row, no code */
          if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
          var tpv = pc.tube.pts.map(function (q3) { return new T.Vector3(q3[0], q3[1], q3[2]); }), tcp = new T.CurvePath();
          for (var q4 = 1; q4 < tpv.length; q4++) tcp.add(new T.LineCurve3(tpv[q4 - 1], tpv[q4]));
          var tm = new T.Mesh(new T.TubeGeometry(tcp, Math.max(4, Math.ceil(pc.tl / 0.05)), pc.tube.r, 14, false), mats.galv);
          tm.userData.ghTube = pc.tube;   /* the harness's in-steel test */
          put(tm, 'ph-' + pc.kind, null, pc.id, 0, pc.hfly || [0, 1, 0]);
          continue;
        }
        if (pc.cyl) {   /* v401 the hoop coop's cloth over the arc and its tarp: an open cylinder's arc along z (the hoop house's film), the cloth's UVs in metres */
          var cy = pc.cyl, cg = new T.CylinderGeometry(cy.R, cy.R, cy.z1 - cy.z0, Math.max(8, Math.round(64 * (cy.a1 - cy.a0) / Math.PI)), 1, true, Math.PI / 2 - cy.a1, cy.a1 - cy.a0);
          var uvA = cg.attributes.uv;
          for (var u5 = 0; u5 < uvA.count; u5++) uvA.setXY(u5, uvA.getX(u5) * cy.R * (cy.a1 - cy.a0), uvA.getY(u5) * (cy.z1 - cy.z0));
          cg.rotateX(-Math.PI / 2);
          cg.translate(cy.c[0], cy.c[1], (cy.z0 + cy.z1) / 2);
          if (!mats.coTarp) mats.coTarp = new T.MeshStandardMaterial({ color: 0x55624b, roughness: 0.9, side: T.DoubleSide });
          put(new T.Mesh(cg, (pc.kind === 'mesh') ? (mats.coMesh || mats.lumber) : mats.coTarp), 'ph-' + pc.kind, null, pc.id, 0, pc.hfly || [0, 1, 0]);
          continue;
        }
        if (pc.kind === 'house') {   /* v386 the lean-to coop's house wall: context (see-through, no code, not in AR) -- the lean-to greenhouse's */
          put(self._mkBox(pc.box[3], pc.box[4], pc.box[5], mats.context || mats.lumber, pc.box[0], pc.box[1], pc.box[2]), 'porch-context', null, pc.id, 0, null);
          continue;
        }
        if (pc.kind === 'floor' || pc.kind === 'sheath') mat = mats.phOsb;
        else if (pc.kind === 'drip') mat = mats.phDrip;
        else if (pc.kind === 'slide') mat = mats.phSlide;
        else if (pc.kind === 'mcover' || pc.kind === 'seam') mat = mats.phSeam;   /* v366 the modern house: the metal roof (v369 in the roof colour), */
        /* v369 the kids' colours by role: the walls, the trims, the doors, the shutters (the frame stays in the scheme's wood) */
        else if (pc.kind === 'siding') mat = g.barn ? mats.phBarn : g.modern ? mats.phModern : mats.phWall;
        else if (pc.kind === 'fboard') mat = mats.phWall;
        else if (pc.kind === 'trim' || pc.kind === 'casing' || pc.kind === 'fascia' || pc.kind === 'mfascia') mat = mats.phTrim;
        else if (pc.kind === 'door') mat = g.barn ? mats.phBarnDoor : mats.phDoor;   /* v374 the barn's doors their own material */
        else if (pc.kind === 'ledge') mat = g.barn ? mats.phTrim : mats.phDoor;
        else if (pc.kind === 'shutter' || pc.kind === 'sledge') mat = mats.phShut;
        else if (pc.kind === 'gusset' || pc.kind === 'lfloor') mat = mats.phOsb;                                               /* -- its OSB gussets + loft floor */
        if (g.coop || g.dog) mat = _coMat(pc.kind, mats, mat);
        if (g.krun && pc.kind === 'mesh' && mats.krMesh) mat = mats.krMesh;   /* v392 the kennel's run: 2 x 4 in. welded wire */
        if (g.krun && pc.kind === 'gframe') mat = mats.coDoor || mat;        /* -- its gate the doors' colour */
        if (g.castle) mat = _csMat(pc, mats, mat);   /* v389 the castle's roles */   /* v385 + the dog house */   /* v375 the coop's roles */
        if (pc.quad && pc.kind === 'sheath') {   /* v389 the castle keep's OSB on its pyramid's faces (a quad, both sides drawn) */
          var geS = new T.BufferGeometry(), QS = pc.quad;
          geS.setAttribute('position', new T.Float32BufferAttribute([].concat(QS[0], QS[1], QS[2], QS[0], QS[2], QS[3]), 3));
          geS.computeVertexNormals();
          if (!mats.csOsb) { mats.csOsb = mats.phOsb.clone(); mats.csOsb.side = T.DoubleSide; }
          put(new T.Mesh(geS, mats.csOsb), 'ph-sheath', pc.code, pc.id, 0, [0, 1, 0]);
          continue;
        }
        if (pc.quad) {
          /* the shingles: two triangles, their UVs in courses along the eave */
          var ge0 = new T.BufferGeometry(), Q = pc.quad, U = pc.uv;
          ge0.setAttribute('position', new T.Float32BufferAttribute([].concat(Q[0], Q[1], Q[2], Q[0], Q[2], Q[3]), 3));
          ge0.setAttribute('uv', new T.Float32BufferAttribute([].concat(U[0], U[1], U[2], U[0], U[2], U[3]), 2));
          ge0.computeVertexNormals();
          var qMesh = (pc.kind === 'mesh');   /* v379 the chicken tractor's hardware cloth on its slopes (a quad in the cloth, UVs in metres) */
          m = new T.Mesh(ge0, qMesh ? (mats.coMesh || mats.phShingle) : mats.phShingle);
          put(m, qMesh ? 'ph-mesh' : (pc.kind === 'croof') ? 'ph-croof' : 'ph-cover', (pc.cap || qMesh) ? null : pc.code, pc.id, 0, qMesh ? [pc.side || 1, 0.6, 0] : [0, 1, 0]);   /* v391 the cupola's roof its own step */
          continue;
        }
        if (pc.box) {
          var bx = pc.box;
          m = self._mkBox(bx[3], bx[4], bx[5], mat, bx[0], bx[1], bx[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          (pc.holes || []).forEach(function (hl) {
            var hp = new T.Path();
            hp.moveTo(hl[0][0], hl[0][1]);
            for (var h2 = 1; h2 < hl.length; h2++) hp.lineTo(hl[h2][0], hl[h2][1]);
            sh.holes.push(hp);
          });
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mat);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else if (pc.plane === 'xz') { ge.rotateX(Math.PI / 2); ge.translate(0, pc.t / 2, 0); m.position.set(0, pc.c, 0); }   /* v368 the tree fort's scribed deck boards, corner blocks: (x, z) up along Y */
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }
          if (!pc.holes) m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        var fly = null, pcx = pc.box ? pc.box[0] : (pc.plane === 'zy' ? pc.c : 0), pcz = pc.box ? pc.box[2] : (pc.plane === 'xy' ? pc.c : 0);
        /* v363 the stilt house's parts: the guard / ladder / slide out from the porch, the diagonals off their faces */
        var coF = pc.hfly || (g.coop ? _coFly(pc, g) : g.castle ? _csFly(pc, g) : null);   /* v401 the hoop coop's run: its own */   /* v389 + the castle's */   /* v375 the coop's own directions */
        if (coF) fly = coF;
        else if (pc.kind === 'rail') fly = (pc.box[3] > pc.box[5]) ? [0, 0, (pcz < -0.05) ? -1 : 1] : [(pcx < 0) ? -1 : 1, 0, 0];   /* v365 the play fort's back rails backward */
        else if (pc.kind === 'fboard') fly = (pc.plane === 'zy') ? [(pcx < 0) ? -1 : 1, 0, 0] : [0, 0, (pcz < 0) ? -1 : 1];   /* v365 the play fort: its boards out from their wall, */
        else if (pc.kind === 'frim' || pc.kind === 'tbrace') fly = [0, -1, 0];
        else if (pc.kind === 'tbeam' || pc.kind === 'sbeam') fly = [0, 1, 0];
        else if (pc.kind === 'sleg' || pc.kind === 'scollar' || pc.kind === 'sspread' || pc.kind === 'sbrace') fly = [0, 0, -1];   /* -- the swing frame away from the tower */
        else if (pc.kind === 'baluster') fly = (Math.abs(pcz - g.zF) < 0.25) ? [0, 0, 1] : [(pcx < 0) ? -1 : 1, 0, 0];
        else if (pc.kind === 'wpost') fly = [(pcx < 0) ? -1 : 1, 0, 0];
        else if (pc.kind === 'rpost' || pc.kind === 'lrail' || pc.kind === 'tread') fly = [0, 0, 1];
        else if (pc.kind === 'slide') fly = [1, 0, 0];
        else if (pc.kind === 'xbrace') fly = (pc.plane === 'zy') ? [(pcx < 0) ? -1 : 1, 0, 0] : [0, 0, -1];
        else if (pc.kind === 'kbrace') fly = [0, -1, 0];
        else if (pc.kind === 'fbeam') fly = [0, 1, 0];
        else if (pc.kind === 'finsul' || pc.kind === 'cinsul' || pc.kind === 'clining') fly = [0, -1, 0];   /* v388 the insulated dog house: the floor's XPS down, the ceiling's in from below, */
        else if (pc.kind === 'winsul' || pc.kind === 'wlining') fly = (pc.poly || (pc.box && pc.box[5] < pc.box[3])) ? [0, 0, (pcz < 0) ? 1 : -1] : [(pcx < 0) ? 1 : -1, 0, 0];   /* -- the walls' into the room, */
        else if (/^(pplate|pstud|pheader|ptplate|pinsul|plining)$/.test(pc.kind)) fly = [0, 0, 1];          /* -- the partition out through the entry, */
        else if (pc.kind === 'fbatten' || pc.kind === 'flap') fly = [0, 0, -1];                            /* -- the flap into the entry */
        else if (pc.kind === 'mplate' || pc.kind === 'mstud' || pc.kind === 'mtplate') fly = [0, 1, 0];       /* v396 the double's partition up out of the house, */
        else if (pc.kind === 'mlining') fly = [-1, 0, 0];                                                    /* -- its OSB off its face */
        else if (/^(epdm|sleeper|rdeck|trail)$/.test(pc.kind)) fly = [0, 1, 0];                              /* v403 the modern dog house's roof deck up, */
        else if (pc.kind === 'gbal') fly = (pc.box && Math.abs(pc.box[0]) > g.W / 2 + 0.05) ? [(pc.box[0] < 0) ? -1 : 1, 0, 0] : [0, 0, (pcz < 0) ? -1 : 1];   /* -- the guard's balusters off their face, */
        else if (pc.kind === 'erim') fly = [(pcx < 0) ? -1 : 1, 0, 0];                                      /* -- the eave rims off the tails, */
        else if (/^(rhanger|rstr|rboard|rcleat)$/.test(pc.kind)) fly = [1, 0, 0];                           /* -- the ramp out to the right */
        else if (pc.kind === 'kstud') fly = [(pcx < 0) ? -1 : 1, 0, 0];                                     /* v392 the kennel's run: its studs out sideways, */
        else if (pc.kind === 'krail' || pc.kind === 'gframe') fly = [0, 0, 1];                              /* -- the front rail and the gate forward, */
        else if (pc.kind === 'mesh') fly = (pc.plane === 'zy') ? [(pc.c < 0) ? -1 : 1, 0, 0] : [0, 0, 1];   /* -- the welded wire off its face */
        else if (OUT[pc.kind]) {
          /* the skin: out from its wall */
          var cx = pc.box ? pc.box[0] : (pc.plane === 'zy' ? pc.c : 0), cz = pc.box ? pc.box[2] : (pc.plane === 'xy' ? pc.c : 0);
          fly = (Math.abs(cz) > g.L / 2 - 0.05 && Math.abs(cz) >= Math.abs(cx) * 0.5) ? [0, 0, (cz < 0) ? -1 : 1] : [(cx < 0) ? -1 : 1, 0, 0];
        } else if (/^(ridge|rafter|fly|tie|gstud|cstud|sheath|fascia|drip|beam|tplate|header|deck|floor|sill|mrafter|mfly|mcover|seam|mfascia|gusset|ljoist|lfloor|lpost|grail)$/.test(pc.kind)) fly = [0, 1, 0];   /* v367 + the barn's gussets + loft */   /* v366 + the modern house's roof */   /* v364 + the A-frame's sills */
        else if (pc.kind === 'post') fly = [0, -1, 0];
        var area = (pc.kind === 'floor' || pc.kind === 'sheath' || pc.kind === 'siding' || pc.kind === 'drip' || pc.kind === 'gusset' || pc.kind === 'lfloor' || pc.kind === 'nest' || pc.kind === 'nlid' || pc.kind === 'nhinge');   /* v375 + the coop's nest boxes (by area) */   /* v367 + the gussets, the loft floor (by area) */
        if (LV.piece[i] != null) _phLeafMesh(LV.list[LV.piece[i]], m);   /* v369 on its leaf */
        put(m, 'ph-' + pc.kind, pc.code, pc.id, area ? 0 : pc.len, fly);
      }
      function hpBasis(ge, U, V, N, o) {   /* v401 the greenhouse builder's basis() */
        var m4 = new T.Matrix4().makeBasis(new T.Vector3(U[0], U[1], U[2]), new T.Vector3(V[0], V[1], V[2]), new T.Vector3(N[0], N[1], N[2]));
        m4.setPosition(o[0], o[1], o[2]);
        ge.applyMatrix4(m4);
        return ge;
      }
      /* the hinges (straps on the leaves, leaves on the casings), the knob, the ball catch */
      for (i = 0; i < g.hw.length; i++) {
        var h = g.hw[i], hm;
        if (h.hat) {   /* v401 the hoop coop's strap pieces (the hoop house's): the loop's profile pushed along the tube */
          var hsh = new T.Shape(), hq;
          hsh.moveTo(h.hat.pts[0][0], h.hat.pts[0][1]);
          for (hq = 1; hq < h.hat.pts.length; hq++) hsh.lineTo(h.hat.pts[hq][0], h.hat.pts[hq][1]);
          var hge = new T.ExtrudeGeometry(hsh, { depth: h.hat.w, bevelEnabled: false, curveSegments: 2 });
          hge.translate(0, 0, -h.hat.w / 2);
          hm = new T.Mesh(hpBasis(hge, h.hat.t, h.hat.n, h.hat.a, h.hat.o), mats.galv || mats.phIron);
        } else if (h.cyl) {
          hm = new T.Mesh(new T.CylinderGeometry(h.cyl[3], h.cyl[3], h.cyl[4], 16), mats.phIron);
          hm.rotation.x = Math.PI / 2;
          hm.position.set(h.cyl[0], h.cyl[1], h.cyl[2] + h.cyl[4] / 2);
        } else if (h.cylX) {   /* v379 the chicken tractor's wheels: a cylinder across X (the tyre, its hub) */
          hm = new T.Mesh(new T.CylinderGeometry(h.cylX[3], h.cylX[3], h.cylX[4], 28), (h.kind === 'wheel' && !h.hub) ? (mats.phTyre || mats.phIron) : (mats.galv || mats.phIron));
          hm.rotation.z = Math.PI / 2;
          hm.position.set(h.cylX[0], h.cylX[1], h.cylX[2]);
        } else hm = self._mkBox(h.box[3], h.box[4], h.box[5], (h.kind === 'hpxconn') ? (mats.galv || mats.phIron) : mats.phIron, h.box[0], h.box[1], h.box[2]);
        if (LV.hw[i] != null) _phLeafMesh(LV.list[LV.hw[i]], hm);   /* v369 the strap, knob, catch on its leaf */
        put(hm, 'ph-' + h.kind, h.code, h.id, 0, h.fly || null);   /* v401 the hoop coop's run hardware its own */
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        if (LV.fas[i] != null) {   /* v369 the nails / hinge screws on a leaf turn with it */
          var Lq = LV.list[LV.fas[i]], fq = _phLeafPt(Lq, f.x, f.z), fd = f.dir;
          f = Object.assign({}, f, { x: fq[0], z: fq[1], dir: [fd[0] * Lq.c + fd[2] * Lq.s, fd[1], -fd[0] * Lq.s + fd[2] * Lq.c] });
        }
        var fm = self._addFastener(f, 'ph-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
        if (LV.fas[i] != null && fm) fm.userData.phLeaf = LV.list[LV.fas[i]].key;
      }
      /* v368 the tree fort's tree (the customer's own -- no code, no step, see-through like the porch swing's beam): its trunk from the
         ground past the walls' top, a flare at its foot, three limbs forking up out of the view */
      /* v369 the store's tree model once it has loaded (_phTreeGeo: its trunk the slider's diameter at the deck), v374 30 % (a reference); the drawn
         trunk below until then or without the store */
      var tGeo = g.tree ? (_phTreeLoad(), _phTreeGeo(g.tree.d, g.yD)) : null;
      if (tGeo) {
        var tMesh = new T.Mesh(tGeo, mats.phBark);
        put(tMesh, 'ph-tree', null, 'tree-model', 0, null);
        _dbg('[ph] tree model at trunk ' + g.tree.d.toFixed(3) + ': ' + tGeo.userData.H.toFixed(2) + ' m tall, first branch at ' + tGeo.userData.yFork.toFixed(2) + ' m, trunk x ' + tGeo.userData.kT.toFixed(2) + ', crown x ' + tGeo.userData.kC.toFixed(2));
      } else if (g.tree) {
        var tr = g.tree, tR = tr.d / 2, tH = tr.yTop;
        var trunk = new T.Mesh(new T.CylinderGeometry(tR * 0.86, tR, tH, 24, 1), mats.phBark);
        trunk.position.set(0, tH / 2, 0);
        put(trunk, 'ph-tree', null, 'tree-trunk', 0, null);
        var flare = new T.Mesh(new T.CylinderGeometry(tR, tR * 1.4, 0.22, 24, 1), mats.phBark);
        flare.position.set(0, 0.11, 0);
        put(flare, 'ph-tree', null, 'tree-flare', 0, null);
        for (var lb = 0; lb < 3; lb++) {
          var la = (lb * 120 + 30) * Math.PI / 180, lt = 0.62, ll = 1.1, lr = tR * 0.5;
          var limb = new T.Mesh(new T.CylinderGeometry(lr * 0.55, lr, ll, 14, 1), mats.phBark);
          limb.geometry.translate(0, ll / 2, 0);
          limb.rotation.set(0, la, lt, 'YXZ');
          limb.position.set(0, tH - 0.35, 0);
          put(limb, 'ph-tree', null, 'tree-limb-' + (lb + 1), 0, null);
        }
      }
      /* v365 the play fort's swings: the seats (the kids' set's boards), the hangers, eye bolts and chains (_drawHanging) */
      if (g.swing) {
        for (i = 0; i < g.swing.seats.length; i++) {
          var sst = g.swing.seats[i];
          put(self._mkBox(g.swing.seatW, g.swing.seatT, KIDS.SEAT_W, mats.lumber, 0, sst.y, sst.z), 'kids-seat', KIDS.SEAT_CODE, 'seat-' + (i + 1), KIDS.SEAT_W, [0, -1, 0]);
        }
        self._drawHanging(g.swing);
      }
      try {
        var key = 'ph|' + (STATE.variant | 0) + '|' + (g.coop ? g.hens + '|' + g.run + '|' : '') + (g.dog ? g.dogH + '|' + g.flap + '|' + g.krun + '|' : '') + Math.round(g.L * 1000) + '|' + Math.round(g.W * 1000) + '|' + (STATE.isMetric === false) + '|' + g.porch + '|' + g.stilt + '|' + g.slide + '|' + !!g.fort + '|' + !!g.swings + '|' + !!g.loft + '|' + (g.tree ? Math.round(g.tree.d * 1000) : 0) + '|' + !!g.mono;   /* v370 + the roof on the switch */   /* v368 + the tree fort's trunk */   /* v367 + the barn's loft */   /* v366 + the type (the cottage and the modern house share sizes) */
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computePlayhouse(STATE);
          if (g.coop) _coLog(g, bq);   /* v375 the backyard coop's own line */
          else if (g.dog) _dhLog(g, bq);
          else if (g.castle) _csLog(g, bq);   /* v389 the castle's own line */   /* v385 the dog house's own line */
          else if (g.treefort) {   /* v368 the tree fort's own line */
            _dbg('[ph] tree fort ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m round a ' + g.tree.d.toFixed(3) + ' trunk (opening ' + (g.tree.x1 - g.tree.x0).toFixed(3) + ' x ' + (g.tree.z1 - g.tree.z0).toFixed(3) + ', clear ' + g.tree.clr.toFixed(3) +
                 ', ' + g.tree.headers + ' headers, ' + g.tree.blocks + ' corner blocks, ' + g.tree.tails + ' tails, ' + g.tree.notched + ' notched + ' + g.tree.cut + ' cut-through boards), ' + g.gscrews.length + ' ground screws + U heads, deck ' + g.yD.toFixed(3) + ' (' + g.joists.length + ' joists, ' + g.deckBoards + ' deck boards), ' + g.kbraces + ' knee braces, fort walls ' + g.yG1.toFixed(3) +
                 ' (' + g.rails + ' rails, ' + g.fboards + ' boards), ladder ' + g.treads + ' treads, slide ' + (g.slide ? 'on (MISSING)' : 'off') + ', ' + g.fas.length + ' fasteners; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else if (g.fort) {   /* v365 the play fort's own line */
            _dbg('[ph] play fort ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + (g.mono ? 'MONO-PITCH roof (high beam ' + (g.yPTL - g.yD).toFixed(3) + ' over the deck, ' + g.seams + ' seams, 2 gable ties between the posts), ' : '') + g.gscrews.length + ' ground screws + U heads, deck ' + g.yD.toFixed(3) + ' (' + g.joists.length + ' joists, ' + g.deckBoards + ' deck boards), beams ' + g.yBm.toFixed(3) + '..' + g.yPT.toFixed(3) +
                 ', ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.ties + ' ties, ' + g.kbraces + ' knee braces, ridge top ' + g.ridgeTop.toFixed(3) + ', roof ' + g.roofA.toFixed(2) + ' m2, fort walls ' + g.yG1.toFixed(3) + ' (' + g.rails + ' rails, ' + g.fboards + ' boards), ladder ' + g.treads + ' treads, slide on (MISSING)' +
                 (g.swing ? ', swings ' + g.swing.N + ' seats on a ' + g.swing.beamL.toFixed(2) + ' m beam (underside ' + g.swing.yBB.toFixed(3) + '), A-frame legs ' + g.swing.legLen.toFixed(2) + ' (' + g.swing.depth.toFixed(2) + ' at the feet) ' + g.swing.span.toFixed(2) + ' past the back wall' : ', swings off') + ', ' + g.fas.length + ' fasteners; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else
          _dbg('[ph] ' + (g.stilt ? (g.mono ? 'stilt house, MONO-PITCH roof (high beam ' + (g.yPTL - g.yF).toFixed(3) + ' over the floor, ' + g.seams + ' seams)' : 'stilt house') : g.aframe ? 'A-frame hut (collars at ' + (g.yC - g.yF).toFixed(3) + ' over the floor)' : g.modern ? 'modern house (high beam ' + (g.yPTL - g.yF).toFixed(3) + ' over the floor, wide window ' + g.winW.toFixed(3) + ', ' + g.seams + ' seams)' : g.barn ? 'little barn (gambrel ' + g.pitch + ' deg, knee ' + g.knee[0].toFixed(3) + ' / ' + g.knee[1].toFixed(3) + ' over the floor, gussets ' + g.gussetA.toFixed(3) + ' m2, hayloft ' + g.hl.toFixed(3) + ', loft ' + (g.loft ? g.ljoists + ' joists ' + g.loftA.toFixed(2) + ' m2, ladder ' + g.treads + ' treads' : 'off') + ')' : 'cottage') + ' ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m' + (g.porch ? ' + porch ' + g.PD.toFixed(3) : '') + ', ' +
               (g.stilt ? g.gscrews.length + ' ground screws + U heads, ' + g.xBraces + ' diagonals, deck ' + g.yD.toFixed(3) + ', guard ' + g.rails + ' rails + ' + g.balusters + ' balusters, ladder ' + g.treads + ' treads, slide ' + (g.slide ? 'on (MISSING)' : 'off') + ', ' : g.blocks.length + ' deck blocks, ') + g.joists.length + ' joists, floor ' + g.yF.toFixed(3) +
               ', plates ' + g.yPT.toFixed(3) + ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' (' + g.doorBoards + ' boards, RO ' + g.RO.toFixed(3) + '), windows ' + g.win.toFixed(3) + ' sill ' + (g.yWS - g.yF).toFixed(3) +
               ', ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.ties + ' ties, ' + g.gStuds + ' gable studs, ridge top ' + g.ridgeTop.toFixed(3) + ', roof ' + g.roofA.toFixed(2) + ' m2 (' + g.roofLen.toFixed(2) + ' long)' +
               ', siding ' + g.sidingA.toFixed(2) + ' m2, ' + g.trims + ' corner boards, ' + g.shutters + ' shutters, ' + g.hinges + ' hinges' + (g.porch ? ', ' + g.deckBoards + ' deck boards' : '') + ', ' + g.fas.length + ' fasteners; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
        }
      } catch (eL) { _dbg('[ph] log THREW ' + ((eL && eL.message) || eL)); }
    },
    /* v373 TYPE 33, GREENHOUSES 1 -- THE GABLE GREENHOUSE (_ghLayout): the
       ground screws + U heads, the gravel, every timber / board as a box,
       a polygon pushed through its thickness or an oriented box, the
       sheets (glazing, siding, cap) as outlines pushed out of their plane,
       the hinges, knob and catch, every screw and nail */
    _buildGreenhouse: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _ghLayout(STATE);
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.phIron) mats.phIron = new T.MeshStandardMaterial({ color: 0x2b2b2b, roughness: 0.55, metalness: 0.5 });
      if (!mats.ghPoly) {
        /* the twinwall: milky see-through, its flutes as faint lines (the texture runs along u, the sheet's coordinates in metres) */
        mats.ghPoly = new T.MeshStandardMaterial({ color: 0xf4f9fb, roughness: 0.25, metalness: 0, transparent: true, opacity: 0.2, depthWrite: false, side: T.FrontSide });   /* one face a sheet (the extrusion's outer cap): one layer, not two */
        var ghTx = _ghFluteTex();
        if (ghTx) mats.ghPoly.map = ghTx;
      }
      if (!mats.ghSiding) mats.ghSiding = new T.MeshStandardMaterial({ color: 0xc49c6e, roughness: 0.85 });
      if (!mats.ghGravel) mats.ghGravel = new T.MeshStandardMaterial({ color: 0xbab3a6, roughness: 1 });
      if (!mats.ghCap) mats.ghCap = new T.MeshStandardMaterial({ color: 0x7d838a, roughness: 0.45, metalness: 0.45, side: T.DoubleSide });
      if (!mats.ghSash) mats.ghSash = new T.MeshStandardMaterial({ color: 0xece7dd, roughness: 0.75 });   /* v390 the old-window greenhouse: the sashes' paint, */
      if (!mats.ghGlass) mats.ghGlass = new T.MeshStandardMaterial({ color: 0xdcecee, roughness: 0.05, metalness: 0, transparent: true, opacity: 0.16, depthWrite: false, side: T.DoubleSide });   /* -- their glass */
      if (!mats.ghOpener) mats.ghOpener = new T.MeshStandardMaterial({ color: 0x3d6f9a, roughness: 0.4, metalness: 0.4 });
      if (!mats.ghFilm) {   /* v381 the hoop house's film: clearer than the twinwall; flat ones one face (as the glazing), the arc over the hoops both */
        mats.ghFilm = new T.MeshStandardMaterial({ color: 0xf2f7f5, roughness: 0.2, metalness: 0, transparent: true, opacity: 0.16, depthWrite: false, side: T.FrontSide });
        mats.ghFilmC = new T.MeshStandardMaterial({ color: 0xf2f7f5, roughness: 0.2, metalness: 0, transparent: true, opacity: 0.16, depthWrite: false, side: T.DoubleSide });
      }
      function put(m, pt, code, id, len, fly) {
        var o = { idHint: id };
        if (code) { o.boqCode = code; if (len > 0) o.length = len; }
        if (fly) m.userData.flyDir = fly;
        self._addToScene(m, pt, o);
        return m;
      }
      function basis(ge, U, V, N, o) {
        var m4 = new T.Matrix4().makeBasis(new T.Vector3(U[0], U[1], U[2]), new T.Vector3(V[0], V[1], V[2]), new T.Vector3(N[0], N[1], N[2]));
        m4.setPosition(o[0], o[1], o[2]);
        ge.applyMatrix4(m4);
        return ge;
      }
      /* v387 the Victorian's mitred / cheek-cut members: the gazebo's lofts (face A at nA, face B at nB, the sides between them) */
      function ghLoftMesh(pc, mat) {
        var pos = [], A = pc.A, B = pc.B, nn = A.length, j, U = pc.U, V = pc.V, N = pc.N, o = pc.o;
        function W(Pt, nv) { return [o[0] + U[0] * Pt[0] + V[0] * Pt[1] + N[0] * nv, o[1] + U[1] * Pt[0] + V[1] * Pt[1] + N[1] * nv, o[2] + U[2] * Pt[0] + V[2] * Pt[1] + N[2] * nv]; }
        function tri(a, b, c) { pos.push(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]); }
        var WA = A.map(function (Pt) { return W(Pt, pc.nA); }), WB = B.map(function (Pt) { return W(Pt, pc.nB); });
        var tris = T.ShapeUtils.triangulateShape(A.map(function (Pt) { return new T.Vector2(Pt[0], Pt[1]); }), []);
        tris.forEach(function (t3) {
          var a = A[t3[0]], b = A[t3[1]], c = A[t3[2]], ar = (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
          var i0 = t3[0], i1 = (ar >= 0) ? t3[1] : t3[2], i2 = (ar >= 0) ? t3[2] : t3[1];
          tri(WA[i0], WA[i2], WA[i1]);
          tri(WB[i0], WB[i1], WB[i2]);
        });
        for (j = 0; j < nn; j++) { var j2 = (j + 1) % nn; tri(WA[j], WA[j2], WB[j2]); tri(WA[j], WB[j2], WB[j]); }
        var ge = new T.BufferGeometry();
        ge.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
        ge.computeVertexNormals();
        var m = new T.Mesh(ge, mat);
        m.userData.gzLoft = { o: o, U: U, V: V, N: N, nA: pc.nA, nB: pc.nB, A: A, B: B };   /* the harness's in-wood test */
        return m;
      }
      /* the ground screws (head + flange out of the ground) and their U heads (plate, stem, the two flanges up the beam's faces) */
      var ubt = GH.U_T, ufl = GH.U_FL, up = g.P.bw;
      for (i = 0; i < g.gscrews.length; i++) {
        var gsq = g.gscrews[i];
        var gtube = new T.Mesh(new T.CylinderGeometry(gsq.r, gsq.r, gsq.y1 - 0.006, 16), mats.galv);
        gtube.position.set(gsq.x, (gsq.y1 - 0.006) / 2, gsq.z);
        put(gtube, 'gh-gscrew', GH.GSCREW, 'gscrew-' + gsq.id, 0, [0, -1, 0]);
        put(self._mkBox(0.15, 0.006, 0.15, mats.galv, gsq.x, gsq.y1 - 0.003, gsq.z), 'gh-gscrew', null, 'gscrew-flange-' + gsq.id, 0, [0, -1, 0]);
      }
      /* v399 the precast pads (the arbor's frustum, turned to the beam) and the poured footings' tops (10 cm up; the rest below: billed, not drawn) */
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      for (i = 0; i < (g.blocks || []).length; i++) {
        var bkI = g.blocks[i], bkG = new T.CylinderGeometry(bkI.wt / Math.SQRT2, bkI.w / Math.SQRT2, bkI.y1 - bkI.y0, 4, 1);
        bkG.rotateY(Math.PI / 4 - bkI.a);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bkI.x, (bkI.y0 + bkI.y1) / 2, bkI.z);
        put(bkM, 'gh-block', GH.FD_BLOCK, 'block-' + bkI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < (g.pours || []).length; i++) {
        var poI = g.pours[i], poM = new T.Mesh(new T.BoxGeometry(poI.w, poI.y1 + 0.02, poI.w), mats.concrete);
        poM.rotation.y = -poI.a;
        poM.position.set(poI.x, (poI.y1 - 0.02) / 2, poI.z);
        put(poM, 'gh-pour', GH.FD_CONCRETE, 'footing-' + poI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < g.uheads.length; i++) {
        var uq = g.uheads[i], rot = !!uq.a, uPt = uq.wet ? 'gh-uanchor' : 'gh-uhead';   /* v399 the footings' wet-set anchors: their own part */
        put(self._mkBox(rot ? up : up + 2 * ubt, ubt, rot ? up + 2 * ubt : up, mats.galv, uq.x, uq.y1 - ubt / 2, uq.z), uPt, uq.wet ? GH.FD_UANCHOR : GH.UHEAD, 'uhead-' + uq.id, 0, [0, -1, 0]);
        var ustem = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, uq.y1 - uq.y0 - ubt, 10), mats.galv);
        ustem.position.set(uq.x, (uq.y0 + uq.y1 - ubt) / 2, uq.z);
        put(ustem, uPt, null, 'uhead-stem-' + uq.id, 0, [0, -1, 0]);
        for (var uk = -1; uk <= 1; uk += 2) {
          var fx = rot ? uq.x : uq.x + uk * (up / 2 + ubt / 2), fz = rot ? uq.z + uk * (up / 2 + ubt / 2) : uq.z;
          put(self._mkBox(rot ? up : ubt, ufl, rot ? ubt : up, mats.galv, fx, uq.y1 + ufl / 2 - ubt, fz), uPt, null, 'uhead-flange-' + uq.id + uk, 0, [0, -1, 0]);
        }
      }
      /* the timber, the frames, the boards, the gravel */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m = null, mat = mats.lumber;
        if (pc.tube) {   /* v381 the hoop house's tubes (the hoops, the ridge purlin, the roll bars + the film rolled on them, the end hoops' lock channel): no catalogue row, no code */
          var tpv = pc.tube.pts.map(function (q3) { return new T.Vector3(q3[0], q3[1], q3[2]); }), tcp = new T.CurvePath();
          for (var q4 = 1; q4 < tpv.length; q4++) tcp.add(new T.LineCurve3(tpv[q4 - 1], tpv[q4]));
          var tmat = (pc.kind === 'roll') ? mats.ghFilmC : (pc.kind === 'channel') ? mats.ghCap : mats.galv;
          var tm = new T.Mesh(new T.TubeGeometry(tcp, Math.max(4, Math.ceil(pc.tl / 0.05)), pc.tube.r, (pc.kind === 'channel') ? 6 : 14, false), tmat);
          if (tmat === mats.ghFilmC) tm.renderOrder = 2;
          tm.userData.ghTube = pc.tube;   /* the harness's in-steel test */
          put(tm, 'gh-' + pc.kind, null, pc.id, 0, pc.fly || [0, 1, 0]);
          continue;
        }
        if (pc.kind === 'house') {   /* v378 the lean-to's house wall: context (see-through, no code, not in AR) */
          put(self._mkBox(pc.box[3], pc.box[4], pc.box[5], mats.context || mats.lumber, pc.box[0], pc.box[1], pc.box[2]), 'porch-context', null, pc.id, 0, null);
          continue;
        }
        if (pc.kind === 'gravel') mat = mats.ghGravel;
        else if (pc.kind === 'vhinge') mat = mats.phIron;
        else if (pc.kind === 'opener') mat = mats.ghOpener;
        else if (pc.kind === 'sash' || pc.kind === 'muntin') mat = mats.ghSash;   /* v390 the old-window greenhouse's sashes */
        if (pc.box) {
          var bx = pc.box;
          m = self._mkBox(bx[3], bx[4], bx[5], mat, bx[0], bx[1], bx[2]);
        } else if (pc.obox) {
          var ob = pc.obox;
          m = new T.Mesh(basis(new T.BoxGeometry(ob.d[0], ob.d[1], ob.d[2]), ob.u, ob.v, ob.n, ob.c), mat);
          m.userData.ghObox = ob;   /* the harness's in-wood test */
        } else if (pc.A && pc.B) {   /* v387 the Victorian's lofts */
          m = ghLoftMesh(pc, mat);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mat);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        var fly = null, pcx = pc.box ? pc.box[0] : pc.obox ? pc.obox.c[0] : 0, pcz = pc.box ? pc.box[2] : pc.obox ? pc.obox.c[2] : (pc.plane === 'xy' ? pc.c : 0);
        if (pc.kind === 'base' || pc.kind === 'gravel') fly = [0, -1, 0];
        else if (/^(ridge|rafter|tie|eblock|gstud|cripple|purlin|vhead|fascia|rake|hip|hjack|hub|bleg|brail|bslat)$/.test(pc.kind)) fly = [0, 1, 0];   /* v392 + the benches */   /* v387 + the Victorian's hips, jacks, hub */
        else if (/^(trim|casing|belt|closer|head|batten|sash|muntin)$/.test(pc.kind)) fly = (Math.abs(pcz) > g.L / 2 - 0.05 && Math.abs(pcz) >= Math.abs(pcx) * 0.5) ? [0, 0, (pcz < 0) ? -1 : 1] : [(pcx < 0) ? -1 : 1, 0, 0];
        else if (pc.kind === 'hipb' || pc.kind === 'channel') fly = (Math.abs(pcz) > g.L / 2 - 0.02) ? [0, 0, (pcz < 0) ? -1 : 1] : [(pcx < 0) ? -1 : 1, 0, 0];   /* v381 the hoop house */
        else if (pc.kind === 'dframe' || pc.kind === 'dbrace') fly = [0, 0, 1];
        else if (pc.obox && /^(vframe|vhinge|opener)$/.test(pc.kind)) fly = [pc.obox.n[0], pc.obox.n[1], pc.obox.n[2]];
        put(m, 'gh-' + pc.kind, pc.code, pc.id, pc.len, fly);
      }
      /* the sheets: the glazing (its own material), the knee wall's siding, the ridge cap; v381 the hoop house's film */
      for (i = 0; i < g.sheets.length; i++) {
        var sq = g.sheets[i], shp, q2;
        if (sq.cyl) {   /* v381 the hoop house's film over the hoops: an open cylinder's arc along z (CylinderGeometry's y turned to z, its angle from +x up) */
          var cy = sq.cyl, cg = new T.CylinderGeometry(cy.R, cy.R, cy.z1 - cy.z0, Math.max(8, Math.round(64 * (cy.a1 - cy.a0) / Math.PI)), 1, true, Math.PI / 2 - cy.a1, cy.a1 - cy.a0);
          cg.rotateX(-Math.PI / 2);
          cg.translate(cy.c[0], cy.c[1], (cy.z0 + cy.z1) / 2);
          var cm = new T.Mesh(cg, mats.ghFilmC);
          cm.renderOrder = 2;
          put(cm, 'gh-' + sq.kind, null, sq.id, 0, [0, 1, 0]);
          continue;
        }
        shp = new T.Shape();
        shp.moveTo(sq.pts[0][0], sq.pts[0][1]);
        for (q2 = 1; q2 < sq.pts.length; q2++) shp.lineTo(sq.pts[q2][0], sq.pts[q2][1]);
        (sq.holes || []).forEach(function (hl) {
          var hp = new T.Path();
          hp.moveTo(hl[0][0], hl[0][1]);
          for (var h2 = 1; h2 < hl.length; h2++) hp.lineTo(hl[h2][0], hl[h2][1]);
          shp.holes.push(hp);
        });
        var sge = basis(new T.ExtrudeGeometry(shp, { depth: sq.t, bevelEnabled: false, curveSegments: 2 }), sq.U, sq.V, sq.N, sq.o);
        var smat = (sq.kind === 'glass') ? mats.ghGlass : (sq.kind === 'siding') ? mats.ghSiding : (sq.kind === 'cap' || sq.kind === 'flash') ? mats.ghCap : /^(film|curtain)/.test(sq.kind) ? mats.ghFilm : mats.ghPoly;   /* v378 + the lean-to's flashing; v381 + the hoop house's film */
        var sm = new T.Mesh(sge, smat);
        if (smat === mats.ghPoly || smat === mats.ghFilm || smat === mats.ghGlass) sm.renderOrder = 2;
        /* the cap and the glazing carry no code (the cap is billed by the ridge's length, the glazing has no catalogue row yet) */
        put(sm, 'gh-' + sq.kind, (sq.kind === 'siding') ? sq.code : null, sq.id, 0, [sq.N[0], sq.N[1], sq.N[2]]);
      }
      /* the hinges (straps on the leaf, leaves on the casing), the knob, the ball catch */
      for (i = 0; i < g.hw.length; i++) {
        var h = g.hw[i], hm;
        if (h.hat) {   /* v381 the hoop house's strap pieces: the loop's profile pushed along the tube */
          var hsh = new T.Shape(), hq;
          hsh.moveTo(h.hat.pts[0][0], h.hat.pts[0][1]);
          for (hq = 1; hq < h.hat.pts.length; hq++) hsh.lineTo(h.hat.pts[hq][0], h.hat.pts[hq][1]);
          var hge = new T.ExtrudeGeometry(hsh, { depth: h.hat.w, bevelEnabled: false, curveSegments: 2 });
          hge.translate(0, 0, -h.hat.w / 2);
          hm = new T.Mesh(basis(hge, h.hat.t, h.hat.n, h.hat.a, h.hat.o), mats.galv);
        } else if (h.cyl) {
          hm = new T.Mesh(new T.CylinderGeometry(h.cyl[3], h.cyl[3], h.cyl[4], 16), mats.phIron);
          hm.rotation.x = Math.PI / 2;
          hm.position.set(h.cyl[0], h.cyl[1], h.cyl[2] + h.cyl[4] / 2);
        } else hm = self._mkBox(h.box[3], h.box[4], h.box[5], (h.kind === 'xconn') ? mats.galv : mats.phIron, h.box[0], h.box[1], h.box[2]);
        put(hm, 'gh-' + h.kind, h.code, h.id, 0, h.fly || ((h.kind === 'bracket') ? [-1, 0, 0] : [0, 0, 1]));   /* v381 + the hoop house's own */
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'gh-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      try {
        var key = 'gh|' + (STATE.variant | 0) + '|' + Math.round(g.L * 1000) + '|' + Math.round(g.W * 1000) + '|' + (STATE.isMetric === false) + '|' + g.knee + '|' + (g.roll === true) + '|' + (g.winI != null ? g.winI : '') + '|' + (g.benches || 0) + '|' + Math.round((g.benchL || 0) * 1000) + '|' + g.found;   /* v390 + the old-window greenhouse's sashes; v392 + the benches */
        if (key !== _ghLogKey) {
          _ghLogKey = key;
          var bq = global.BenchBoQ._computeGreenhouse(STATE);
          if (g.oldwin) {   /* v390 the old-window greenhouse */
            _dbg('[gh] old-window greenhouse ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, sashes ' + Math.round(g.winW * 1000) + ' x ' + Math.round(g.winH * 1000) + ' mm (slider ' + g.winI + '): ' + g.nSide + ' a side, ' + g.nBack + ' at the back, ' + g.nFront + ' in front = ' + g.windows + ', band ' + g.yWb.toFixed(3) + '-' + g.yWt.toFixed(3) +
                 ', ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) + ', plates ' + g.yPT.toFixed(3) + ', ' + g.studs + ' studs (' + g.dbl + ' doubles), ' + g.girts + ' girts' +
                 ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' (RO ' + g.RO.toFixed(3) + (g.hdUp ? ', header over the plate line' : '') + ')' +
                 ', ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg + ' + g.mids + ' mid pairs (' + g.midsShort + ' to the purlin under a vent), ' + g.ties + ' ties, ' + g.eBlocks + ' eave blocks, ' + g.purlins + ' purlins, ' + g.gStuds + ' gable studs + cripples, ridge top ' + g.ridgeTop.toFixed(3) +
                 ', ' + g.vents + ' roof vents (' + g.ventA.toFixed(2) + ' m2 = ' + Math.round(100 * g.ventA / g.floorA) + ' % of the floor ' + g.floorA.toFixed(2) + ' m2)' +
                 ', glazing ' + g.polyA.toFixed(2) + ' m2 (tape ' + g.tapeSolid.toFixed(2) + ' m solid, ' + g.tapeVent.toFixed(2) + ' m vented), siding ' + g.sidingA.toFixed(2) + ' m2, ' + g.trims + ' corner boards, ' + g.belts + ' sill boards, ' + g.heads + ' head boards, ' + g.battens + ' battens, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners, top ' + g.top.toFixed(3) + '; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else
          if (g.victorian) {   /* v387 the Victorian */
            _dbg('[gh] Victorian greenhouse ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (bay ' + g.bayDepth.toFixed(3) + ' deep, facets ' + g.bayFacet.toFixed(3) + ', centre z ' + g.apexZ.toFixed(3) + '), ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) +
                 ', walls to ' + g.yPT.toFixed(3) + (g.knee ? ' (knee wall to ' + g.yK.toFixed(3) + ')' : '') + ', ' + g.studs + ' studs, ' + g.girts + ' girts, ' + g.rafters.length + ' common pairs ' + g.rafL.toFixed(2) + ', ridge ' + g.roofLen.toFixed(2) + ' top ' + g.ridgeTop.toFixed(3) + ', hub top ' + g.hubTop.toFixed(3) + ', ' + g.hips + ' hips, ' + g.jacks + ' jacks, ' + g.ties + ' ties, ' + g.eBlocks + ' eave blocks, ' + g.purlins + ' purlins' +
                 ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ', ' + g.vents + ' roof vents (' + g.ventA.toFixed(2) + ' m2 = ' + Math.round(100 * g.ventA / g.floorA) + ' % of the floor ' + g.floorA.toFixed(2) + ' m2)' +
                 ', glazing ' + g.polyA.toFixed(2) + ' m2 (tape ' + g.tapeSolid.toFixed(2) + ' m solid, ' + g.tapeVent.toFixed(2) + ' m vented), siding ' + g.sidingA.toFixed(2) + ' m2, caps ' + g.capL.toFixed(2) + ' m, ' + g.trims + ' corner boards, ' + g.belts + ' belts, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners, top ' + g.top.toFixed(3) + '; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else
          if (g.aframe) {   /* v384 the A-frame */
            _dbg('[gh] A-frame greenhouse ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) +
                 ', ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ridge top ' + g.ridgeTop.toFixed(3) + ', ' + g.purlins + ' purlins (' + g.purlinRows + ' rows a slope), end walls ' + g.gStuds + ' studs / kings / cripples, ' + g.girts + ' girts' +
                 ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' (RO ' + g.RO.toFixed(3) + ')' +
                 ', ' + g.vents + ' roof vents (' + g.ventA.toFixed(2) + ' m2 = ' + Math.round(100 * g.ventA / g.floorA) + ' % of the floor ' + g.floorA.toFixed(2) + ' m2)' +
                 ', glazing ' + g.polyA.toFixed(2) + ' m2 (tape ' + g.tapeSolid.toFixed(2) + ' m solid, ' + g.tapeVent.toFixed(2) + ' m vented), ridge cap ' + g.capL.toFixed(2) + ' m, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners, top ' + g.top.toFixed(3) + '; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else
          if (g.hoop) {   /* v381 the hoop house */
            _dbg('[gh] hoop house ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + g.piers * 2 + ' + 2 ground screws + U heads (the side ones in the hoops\' bays), base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) +
                 ', ' + g.hoops + ' hoops R ' + g.R.toFixed(3) + ' at ' + g.hoopSp.toFixed(3) + ' (one ' + g.hoopL.toFixed(2) + ' m of tube), legs to ' + g.yS.toFixed(3) + ', top ' + g.top.toFixed(3) + ', ' + g.straps + ' strap pieces (' + g.saddles + ' over the end hoops; ' + g.strapBuy + ' straps)' +
                 ', end walls ' + g.studs + ' studs + kings, ' + g.girts + ' girts, door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' (RO ' + g.RO.toFixed(3) + ', ' + g.staples + ' staples)' +
                 ', SIDES ' + (g.roll ? 'ROLLED UP' : 'DOWN') + '; film ' + g.filmA.toFixed(2) + ' m2, tube ' + g.tubeL.toFixed(2) + ' m, channel ' + g.chL.toFixed(2) + ' m, wire ' + g.wireL.toFixed(2) + ' m, ' + g.xconn + ' cross connectors, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          } else
          if (g.lean) {   /* v378 the lean-to */
            _dbg('[gh] lean-to greenhouse ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + g.gapH.toFixed(3) + ' off the house' + (g.knee ? ', KNEE WALL to ' + (g.yK - g.yBt).toFixed(3) + ' (siding ' + g.sidingA.toFixed(2) + ' m2, ' + g.belts + ' belt boards)' : '') +
                 ', ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) + ', front plate ' + g.yPT.toFixed(3) + ', back plate ' + g.yPB.toFixed(3) + ', ' + g.studs + ' studs, ' + g.girts + ' girts' +
                 ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' at x ' + g.xD.toFixed(3) + ' (RO ' + g.RO.toFixed(3) + (g.hdUp ? ', header over the plate line' : '') + ')' +
                 ', ' + g.rafters.length + ' rafters ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.eBlocks + ' blocks, ' + g.purlins + ' purlins, ' + g.gStuds + ' end studs + cripples, top ' + g.top.toFixed(3) +
                 ', ' + g.vents + ' roof vents (' + g.ventA.toFixed(2) + ' m2 = ' + Math.round(100 * g.ventA / g.floorA) + ' % of the floor ' + g.floorA.toFixed(2) + ' m2)' +
                 ', glazing ' + g.polyA.toFixed(2) + ' m2 (tape ' + g.tapeSolid.toFixed(2) + ' m solid, ' + g.tapeVent.toFixed(2) + ' m vented), flashing ' + g.capL.toFixed(2) + ' m (' + g.capScrews + ' sealing screws), ' + g.brackets + ' brackets, ' + g.closers + ' closer boards, ' + g.trims + ' corner boards, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners; ' +
                 Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
            _dbg('[gh] context: the house wall (see-through, not billed, not in AR)');
          } else
          _dbg('[gh] gable greenhouse ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m' + (g.knee ? ', KNEE WALL to ' + (g.yK - g.yBt).toFixed(3) + ' (siding ' + g.sidingA.toFixed(2) + ' m2, ' + g.belts + ' belt boards)' : '') +
               ', ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) + ', plates ' + g.yPT.toFixed(3) + ', ' + g.studs + ' studs, ' + g.girts + ' girts' +
               ', door ' + g.doorW.toFixed(3) + ' x ' + g.doorH.toFixed(3) + ' (RO ' + g.RO.toFixed(3) + (g.hdUp ? ', header over the plate line' : '') + ')' +
               ', ' + g.rafters.length + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.ties + ' ties, ' + g.eBlocks + ' eave blocks, ' + g.purlins + ' purlins, ' + g.gStuds + ' gable studs + cripples, ridge top ' + g.ridgeTop.toFixed(3) +
               ', ' + g.vents + ' roof vents (' + g.ventA.toFixed(2) + ' m2 = ' + Math.round(100 * g.ventA / g.floorA) + ' % of the floor ' + g.floorA.toFixed(2) + ' m2)' +
               ', glazing ' + g.polyA.toFixed(2) + ' m2 (tape ' + g.tapeSolid.toFixed(2) + ' m solid, ' + g.tapeVent.toFixed(2) + ' m vented), ' + g.trims + ' corner boards, ' + g.hinges + ' hinges, ' + g.fas.length + ' fasteners; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          if (g.benchLog) _dbg('[gh] ' + g.benchLog);   /* v392 */
          _dbg('[gh] foundation ' + g.found + ': ' + ((g.found === 'block') ? g.blocks.length + ' precast pads' : (g.found === 'pier') ? g.pours.length + ' poured footings + wet-set U anchors' : g.gscrews.length + ' ground screws + U heads') +
               ', the base\'s underside ' + g.yBB.toFixed(3) + (g.fq.pourN ? ', concrete ' + g.fq.concrete + ' m3, rebar ' + g.fq.rebar + ' m' : '') + (g.fq.gravel ? ', gravel beds ' + g.fq.gravel + ' m3' : ''));   /* v399 */
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[gh] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) { _dbg('[gh] log THREW ' + ((eL && eL.message) || eL)); }
    },
    /* v376 TYPE 35, KITCHEN POD (_kpLayout): the ground screws + U heads,
       every timber / board as a box, a polygon pushed through its thickness
       or an oriented box (the flap's parts turned about the hinge line),
       the sheets (OSB, the counter's face, the acacia top), the stainless
       modules, the grill head, the sink and tap, the hinges, struts, knobs
       and catches, every screw and nail */
    _buildKitchenPod: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _kpLayout(STATE);
      STATE.L = g.L;   /* v405 the length the bays give (the size bar, the saved design, the share) */
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.phIron) mats.phIron = new T.MeshStandardMaterial({ color: 0x2b2b2b, roughness: 0.55, metalness: 0.5 });
      if (!mats.gsTop) mats.gsTop = new T.MeshStandardMaterial({ color: 0x9a6a3c, roughness: 0.55 });   /* the oiled acacia (the cinema bar's) */
      if (!mats.kpTrim) mats.kpTrim = new T.MeshStandardMaterial({ color: 0x24272b, roughness: 0.6 });                     /* the black band, fascia, rakes, corner trims */
      if (!mats.kpMetal) mats.kpMetal = new T.MeshStandardMaterial({ color: 0x3e4247, roughness: 0.5, metalness: 0.45, side: T.DoubleSide });   /* the roof's metal, the drip edge */
      if (!mats.kpOsb) mats.kpOsb = new T.MeshStandardMaterial({ color: 0xc9a66b, roughness: 0.95 });
      if (!mats.kpPanel) mats.kpPanel = new T.MeshStandardMaterial({ color: 0x5b6168, roughness: 0.8, side: T.DoubleSide });   /* the counter's painted face; v400 both sides: its sheet's basis (z, y, x) is left-handed, the extrusion's faces came out turned in and the back cap z-fought with the counter frame (a hatched face) */
      if (!mats.kpInox) mats.kpInox = new T.MeshStandardMaterial({ color: 0xd3d7db, roughness: 0.38, metalness: 0.22 });   /* brushed stainless (no env map here: a low metalness keeps it light) */
      if (!mats.kpDark) mats.kpDark = new T.MeshStandardMaterial({ color: 0x2c2f33, roughness: 0.45, metalness: 0.4 });
      if (!mats.kpStrut) mats.kpStrut = new T.MeshStandardMaterial({ color: 0x1d1f22, roughness: 0.4, metalness: 0.6 });
      function put(m, pt, code, id, len, fly) {
        var o = { idHint: id };
        if (code) { o.boqCode = code; if (len > 0) o.length = len; }
        if (fly) m.userData.flyDir = fly;
        self._addToScene(m, pt, o);
        return m;
      }
      function basis(ge, U, V, N, o) {
        var m4 = new T.Matrix4().makeBasis(new T.Vector3(U[0], U[1], U[2]), new T.Vector3(V[0], V[1], V[2]), new T.Vector3(N[0], N[1], N[2]));
        m4.setPosition(o[0], o[1], o[2]);
        ge.applyMatrix4(m4);
        return ge;
      }
      var mk = function (w, h, d, mat, x, y, z) { return self._mkBox(w, h, d, mat, x, y, z); };
      /* the ground screws and their U heads (the greenhouse's) */
      var ubt = KP.U_T, ufl = Math.min(KP.U_FL, g.P.bh - 0.004), up = g.P.bw;
      for (i = 0; i < g.gscrews.length; i++) {
        var gsq = g.gscrews[i];
        var gtube = new T.Mesh(new T.CylinderGeometry(gsq.r, gsq.r, gsq.y1 - 0.006, 16), mats.galv);
        gtube.position.set(gsq.x, (gsq.y1 - 0.006) / 2, gsq.z);
        put(gtube, 'kp-gscrew', KP.GSCREW, 'gscrew-' + gsq.id, 0, [0, -1, 0]);
        put(mk(0.15, 0.006, 0.15, mats.galv, gsq.x, gsq.y1 - 0.003, gsq.z), 'kp-gscrew', null, 'gscrew-flange-' + gsq.id, 0, [0, -1, 0]);
      }
      /* v405 the precast pads (the arbor's frustum) and the poured footings' tops (10 cm up; the rest below: billed, not drawn) -- the greenhouses' */
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      for (i = 0; i < g.blocks.length; i++) {
        var bkI = g.blocks[i], bkG = new T.CylinderGeometry(bkI.wt / Math.SQRT2, bkI.w / Math.SQRT2, bkI.y1 - bkI.y0, 4, 1);
        bkG.rotateY(Math.PI / 4 - bkI.a);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bkI.x, (bkI.y0 + bkI.y1) / 2, bkI.z);
        put(bkM, 'kp-block', KP.FD_BLOCK, 'block-' + bkI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < g.pours.length; i++) {
        var poI = g.pours[i], poM = new T.Mesh(new T.BoxGeometry(poI.w, poI.y1 + 0.02, poI.w), mats.concrete);
        poM.position.set(poI.x, (poI.y1 - 0.02) / 2, poI.z);
        put(poM, 'kp-pour', KP.FD_CONCRETE, 'footing-' + poI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < g.uheads.length; i++) {
        var uq = g.uheads[i], uPt = uq.wet ? 'kp-uanchor' : 'kp-uhead';   /* v405 the footings' wet-set anchors: their own part */
        put(mk(up + 2 * ubt, ubt, up, mats.galv, uq.x, uq.y1 - ubt / 2, uq.z), uPt, uq.wet ? KP.FD_UANCHOR : KP.UHEAD, 'uhead-' + uq.id, 0, [0, -1, 0]);
        var ustem = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, uq.y1 - uq.y0 - ubt, 10), mats.galv);
        ustem.position.set(uq.x, (uq.y0 + uq.y1 - ubt) / 2, uq.z);
        put(ustem, uPt, null, 'uhead-stem-' + uq.id, 0, [0, -1, 0]);
        for (k = -1; k <= 1; k += 2) put(mk(ubt, ufl, up, mats.galv, uq.x + k * (up / 2 + ubt / 2), uq.y1 + ufl / 2 - ubt, uq.z), uPt, null, 'uhead-flange-' + uq.id + k, 0, [0, -1, 0]);
      }
      /* the timber, boards, metal and hardware pieces */
      var BLACK = { fascia: 1, rake: 1, band: 1 }, METAL = { drip: 1, cover: 1, seam: 1, gstop: 1 }, IRON = { hinge: 1, knob: 1, catch: 1, sbracket: 1, shelfbr: 1, bhook: 1, lbrk: 1, ranchor: 1 };   /* v407 + the barbell's hooks (v409 + the wall bars' brackets, the battle rope's anchor) */
      if (!mats.kpEpdm) mats.kpEpdm = new T.MeshStandardMaterial({ color: 0x1c1d1f, roughness: 0.85 });      /* v405 the EPDM */
      if (!mats.kpSedum) mats.kpSedum = new T.MeshStandardMaterial({ color: 0x4f6a2c, roughness: 0.95 });    /* -- the sedum (v412 its mat darker under the plants) */
      var CLADK = { clad: 1, fclad: 1, bstrip: 1, fstrip: 1, trim: 1 };
      if (!mats.kpPfc) mats.kpPfc = new T.MeshStandardMaterial({ color: 0x9b9fa2, roughness: 0.85 });                          /* v413 the fibre cement, natural grey */
      if (!mats.kpPcor) mats.kpPcor = new T.MeshStandardMaterial({ color: 0xffffff, map: _kpCorTex(), roughness: 0.9 });         /* -- the corten */
      if (!mats.kpPcorr) mats.kpPcorr = new T.MeshStandardMaterial({ color: 0xffffff, map: _kpCorrTex(), roughness: 0.55, metalness: 0.15 });   /* -- the corrugated sheet, anthracite */
      if (!mats.kpTape) mats.kpTape = new T.MeshStandardMaterial({ color: 0x1a1b1d, roughness: 0.9 });   /* v412 the cladding on its own material (shou sugi ban: charred, the frame natural) */
      if (!mats.kpClad) { var scC = COLOR_SCHEMES[_colorScheme()]; mats.kpClad = new T.MeshStandardMaterial({ color: scC.wood, roughness: 0.85, emissive: scC.wood, emissiveIntensity: scC.glow || 0 }); }
      if (!mats.kpPebble) mats.kpPebble = new T.MeshStandardMaterial({ color: 0x9c968c, roughness: 0.95 });   /* -- the gravel strip */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m = null, mat = mats.lumber;
        if (KP_SVC_BOX[pc.kind] || pc.kind === 'fitbox') continue;   /* v382 drawn with the services (v407 the fitness's boxes: its equipment drawn below) */
        if (BLACK[pc.kind]) mat = mats.kpTrim;
        else if (CLADK[pc.kind]) mat = mats.kpClad;
        else if (pc.kind === 'pfc' || pc.kind === 'fpfc') mat = mats.kpPfc;      /* v413 the panel claddings */
        else if (pc.kind === 'pcor' || pc.kind === 'fpcor') mat = mats.kpPcor;
        else if (pc.kind === 'pcorr' || pc.kind === 'fpcorr') mat = mats.kpPcorr;
        else if (pc.kind === 'batten' && g.pTape) mat = mats.kpTape;             /* -- the battens taped black behind open joints */
        else if (METAL[pc.kind]) mat = mats.kpMetal;
        else if (pc.kind === 'hanger' || pc.kind === 'rhanger' || pc.kind === 'sframe') mat = mats.galv;   /* v406 + the steel frame */
        else if (IRON[pc.kind]) mat = mats.phIron;
        else if (pc.kind === 'strut') mat = mats.kpStrut;
        else if (pc.kind === 'gallows' || pc.kind === 'ghinge' || pc.kind === 'tvmount') mat = mats.kpSteel || (mats.kpSteel = new T.MeshStandardMaterial({ color: 0x232527, roughness: 0.45, metalness: 0.45 }));   /* v415 the bag's gallows, its hinges, the TV's mount plate */
        else if (pc.kind === 'roofosb') mat = mats.kpOsb;
        else if (pc.kind === 'epdm') mat = mats.kpEpdm;
        else if (pc.kind === 'sedum') mat = mats.kpSedum;
        else if (pc.kind === 'rgravel') mat = mats.kpPebble;
        if (pc.box) {
          var bx = pc.box;
          m = mk(bx[3], bx[4], bx[5], mat, bx[0], bx[1], bx[2]);
        } else if (pc.obox) {
          var ob = pc.obox;
          m = new T.Mesh(basis(new T.BoxGeometry(ob.d[0], ob.d[1], ob.d[2]), ob.u, ob.v, ob.n, ob.c), mat);
          m.userData.ghObox = ob;   /* the harness's in-wood test */
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          ge.translate(0, 0, -pc.t / 2);
          m = new T.Mesh(ge, mat);
          m.position.set(0, 0, pc.c);
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        if (/^f?pcor$/.test(pc.kind)) _kpUvM(m.geometry, 1, 1);                     /* v413 the corten: a 1 m tile */
        else if (/^f?pcorr$/.test(pc.kind)) _kpUvM(m.geometry, KP_PCLAD.corr.rib, 1);   /* -- a rib a unit (76 mm / 3 in.) */
        var cx = pc.box ? pc.box[0] : pc.obox ? pc.obox.c[0] : 0, cz = pc.box ? pc.box[2] : pc.obox ? pc.obox.c[2] : pc.c, fly = null;
        if (pc.kind === 'base' || pc.kind === 'joist' || (pc.kind === 'hanger' && cx < g.D / 2 - g.P.bw + 0.001 && cx > -g.D / 2)) fly = [0, -1, 0];
        else if (/^(rafter|roofosb|cover|seam|drip|fascia|header|brail|band|epdm|kerb|sedum|rgravel|gstop)$/.test(pc.kind) || pc.kind === 'rhanger') fly = [0, 1, 0];
        else if (pc.kind === 'shelf' || pc.kind === 'shelfbr' || pc.kind === 'sledger') fly = [1, 0, 0];
        else if (pc.kind === 'fblock' || pc.kind === 'bhook') fly = [0, -1, 0];   /* v409 the barbell's hooks under the rafters */
        else if (pc.kind === 'lbrk') fly = [0, 0, 1];
        else if (pc.kind === 'ecleat') fly = [1, 0, 0];
        else if (pc.kind === 'ranchor') fly = [-1, 0, 0];
        else if (pc.kind === 'gallows' || pc.kind === 'ghinge') fly = [0, 0, 1];   /* v415 */
        else if (pc.kind === 'tvmount') fly = [0, -1, 0];
        else if (/^(fframe|fclad|fstrip|hinge|strut|sbracket|knob|catch|fpfc|fpcor|fpcorr)$/.test(pc.kind)) fly = [1, 0.3, 0];
        else if (/^(clad|batten|trim|rake|bstrip|pfc|pcor|pcorr)$/.test(pc.kind)) fly = (Math.abs(cz) > g.L / 2 + 0.01) ? [0, 0, (cz < 0) ? -1 : 1] : [(cx < 0) ? -1 : 1, 0, 0];
        else if (pc.kind === 'cframe' || pc.kind === 'sframe') fly = [1, 0, 0];
        put(m, 'kp-' + pc.kind, pc.code, pc.id, pc.len, fly);
        if (/^f?(pfc|pcor|pcorr)$/.test(pc.kind)) for (var eC = m.children.length - 1; eC >= 0; eC--) if (m.children[eC].userData && m.children[eC].userData.isEdgeLine) m.remove(m.children[eC]);   /* v413 the panels: their open joints draw the lines */
      }
      /* v412 THE GREEN ROOF'S PLANTS (Marek 23:46 "zelena strecha ma vypadat realisticky"): sedum rosettes and cushions -- an instanced
         low-poly blob each in the sedum's greens, olive and red-bronze, a few yellow and pink flower heads -- on the mat's top face, and
         the gravel strip's stones; drawn, not billed (the pre-grown mat and the gravel are) */
      if (g.green && g.green.x1 > g.green.x0) (function () {
        var G = g.green, seed = 4121, rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
        var M4 = new T.Matrix4(), Q = new T.Quaternion(), V = new T.Vector3(), S = new T.Vector3(), C = new T.Color(), AY = new T.Vector3(0, 1, 0), q;
        var ico = self._kpIco || (self._kpIco = new T.IcosahedronGeometry(1, 0));
        if (!mats.kpPlant) mats.kpPlant = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.92, flatShading: true });
        var nP = Math.min(3200, Math.round((G.x1 - G.x0) * 2 * G.zW * 420)), PAL = [0x5e7f2f, 0x6f8f35, 0x7d9a3a, 0x4f6e2a, 0x8a9a3e, 0x9b6a3a, 0x86503a, 0xa3a84a, 0x6b8a4a, 0x587a36];
        var im = new T.InstancedMesh(ico, mats.kpPlant, nP);
        for (q = 0; q < nP; q++) {
          var px = G.x0 + 0.01 + rnd() * (G.x1 - G.x0 - 0.02), pz = -G.zW + 0.01 + rnd() * (2 * G.zW - 0.02), yb = G.y0 + (G.y1 - G.y0) * (px - G.x0) / (G.x1 - G.x0);
          var r = 0.016 + rnd() * 0.026, fl = rnd() < 0.07;
          if (fl) r *= 0.4;
          V.set(px, yb + r * (fl ? 1.8 : 0.2), pz); S.set(r * (0.8 + rnd() * 0.4), r * (fl ? 0.7 : 0.5 + rnd() * 0.4), r * (0.8 + rnd() * 0.4));
          Q.setFromAxisAngle(AY, rnd() * Math.PI * 2);
          M4.compose(V, Q, S); im.setMatrixAt(q, M4);
          im.setColorAt(q, C.setHex(fl ? ((rnd() < 0.6) ? 0xe2c341 : 0xd98aa8) : PAL[Math.floor(rnd() * PAL.length)]));
        }
        im.instanceMatrix.needsUpdate = true; if (im.instanceColor) im.instanceColor.needsUpdate = true;
        self._tag(im, 'kp-sedum'); im.userData.idHint = 'sedum-plants'; im.userData.flyDir = [0, 1, 0];
        global.BenchEngine.benchGroup.add(im);
        if (G.gx1 > G.gx0) {
          var nS = Math.min(2400, Math.round((G.gx1 - G.gx0) * 2 * G.zW * 2600)), GP = [0x9c968c, 0x8a857c, 0xb1aba0, 0x7d786f, 0xa8a196];
          var ims = new T.InstancedMesh(ico, mats.kpPlant, nS);
          for (q = 0; q < nS; q++) {
            var sx = G.gx0 + 0.006 + rnd() * (G.gx1 - G.gx0 - 0.012), sz2 = -G.zW + 0.006 + rnd() * (2 * G.zW - 0.012), sy = G.gy0 + (G.gy1 - G.gy0) * (sx - G.gx0) / (G.gx1 - G.gx0), rs = 0.006 + rnd() * 0.008;
            V.set(sx, sy - rs * 0.2, sz2); S.set(rs * (0.9 + rnd() * 0.5), rs * 0.6, rs * (0.9 + rnd() * 0.5)); Q.setFromAxisAngle(AY, rnd() * Math.PI * 2);
            M4.compose(V, Q, S); ims.setMatrixAt(q, M4); ims.setColorAt(q, C.setHex(GP[Math.floor(rnd() * GP.length)]));
          }
          ims.instanceMatrix.needsUpdate = true; if (ims.instanceColor) ims.instanceColor.needsUpdate = true;
          self._tag(ims, 'kp-rgravel'); ims.userData.idHint = 'gravel-stones'; ims.userData.flyDir = [0, 1, 0];
          global.BenchEngine.benchGroup.add(ims);
        }
      })();
      /* the sheets: the walls' OSB, the counter's face, the acacia top */
      for (i = 0; i < g.sheets.length; i++) {
        var sq = g.sheets[i], shp = new T.Shape(), q2;
        shp.moveTo(sq.pts[0][0], sq.pts[0][1]);
        for (q2 = 1; q2 < sq.pts.length; q2++) shp.lineTo(sq.pts[q2][0], sq.pts[q2][1]);
        (sq.holes || []).forEach(function (hl) {
          var hp = new T.Path();
          hp.moveTo(hl[0][0], hl[0][1]);
          for (var h2 = 1; h2 < hl.length; h2++) hp.lineTo(hl[h2][0], hl[h2][1]);
          shp.holes.push(hp);
        });
        var sge = basis(new T.ExtrudeGeometry(shp, { depth: sq.t, bevelEnabled: false, curveSegments: 2 }), sq.U, sq.V, sq.N, sq.o);
        if (!mats.kpCboard) mats.kpCboard = new T.MeshStandardMaterial({ color: 0xb4b1aa, roughness: 0.95, side: T.DoubleSide });
        if (!mats.kpVeneer) mats.kpVeneer = new T.MeshStandardMaterial({ color: 0x9d9385, roughness: 0.95, side: T.DoubleSide });
        if (!mats.kpConc) mats.kpConc = new T.MeshStandardMaterial({ color: 0xa6a29b, roughness: 0.8 });
        if (!mats.kpGranite) mats.kpGranite = new T.MeshStandardMaterial({ color: 0x3b3c3f, roughness: 0.28, metalness: 0.1 });
        if (!mats.kpRubber) mats.kpRubber = new T.MeshStandardMaterial({ color: 0x1b1c1e, roughness: 0.95 });   /* v407 the fitness's rubber tiles */
        if (!mats.kpInoxF) mats.kpInoxF = new T.MeshStandardMaterial({ color: 0xd6dadd, roughness: 0.4, metalness: 0.12 });   /* v412 the inox look's brushed face (a shade under the modules' doors) */
        if (sq.kind === 'gallows' && !mats.kpSteel) mats.kpSteel = new T.MeshStandardMaterial({ color: 0x232527, roughness: 0.45, metalness: 0.45 });   /* v417 the gallows' brace (a mitred solid) */
        var smat = (sq.kind === 'gallows') ? mats.kpSteel : (sq.kind === 'sheath' && g.pTape) ? mats.kpTape : (sq.kind === 'inox') ? mats.kpInoxF : (sq.kind === 'mat') ? mats.kpRubber : (sq.kind === 'panel') ? mats.kpPanel : (sq.kind === 'top') ? mats.gsTop : (sq.kind === 'ctop') ? mats.kpConc : (sq.kind === 'gtop') ? mats.kpGranite :
                   (sq.kind === 'cboard' || sq.kind === 'shield') ? mats.kpCboard : (sq.kind === 'stone') ? mats.kpVeneer : (sq.kind === 'wface') ? mats.lumber : mats.kpOsb;   /* v405 the finishes */
        var sfly = /^(top|ctop|gtop)$/.test(sq.kind) ? [0, 1, 0] : /^(panel|cboard|stone|wface|inox)$/.test(sq.kind) ? [1, 0, 0] : [sq.N[0], sq.N[1], sq.N[2]];
        /* billed by area / length in the bill (the sheet carries its code for the item card, no length) */
        put(new T.Mesh(sge, smat), 'kp-' + sq.kind, sq.code, sq.id, 0, sfly);
      }
      if (!mats.kpCeram) mats.kpCeram = new T.MeshStandardMaterial({ color: 0x1f2326, roughness: 0.32, metalness: 0.08 });   /* v379 the kamado's glazed ceramic */
      if (!mats.kpOven) mats.kpOven = new T.MeshStandardMaterial({ color: 0x35383c, roughness: 0.55, metalness: 0.25 });     /* the pizza oven's shell */
      if (!mats.kpHole) mats.kpHole = new T.MeshStandardMaterial({ color: 0x0b0b0c, roughness: 0.9 });                        /* the oven's mouth */
      if (!mats.kpStone) mats.kpStone = new T.MeshStandardMaterial({ color: 0xc9b9a0, roughness: 0.9 });
      if (!mats.kpGlass) mats.kpGlass = new T.MeshStandardMaterial({ color: 0x27323b, roughness: 0.12, metalness: 0.3 });     /* the fridge door's glass */
      /* v407 THE FITNESS'S EQUIPMENT (g.fitL) -- v409 / v410: the heavy bag (its real shape, brown-red, four chains to a swivel), the cable
         pulley, the wall rack (its shelves, the plates on its pegs), the dumbbells, the kettlebells, the barbell (stored along z, on the
         J-hooks along x with two plates), the adjustable bench (its back flat or raised), the steel wall bars with the pull-up bar, the
         J-hooks or the dip bars, the rings, the bands, the battle rope (manila, black grips: coiled / out in waves), the tyre + hammer */
      if (g.fp) (function () {
        if (!mats.kpGym) mats.kpGym = new T.MeshStandardMaterial({ color: 0x2a2c30, roughness: 0.5, metalness: 0.3 });
        if (!mats.kpGymRed) mats.kpGymRed = new T.MeshStandardMaterial({ color: 0x8e2a26, roughness: 0.7 });
        if (!mats.kpChrome) mats.kpChrome = new T.MeshStandardMaterial({ color: 0xc8ccd0, roughness: 0.25, metalness: 0.7 });
        if (!mats.kpRubber) mats.kpRubber = new T.MeshStandardMaterial({ color: 0x1b1c1e, roughness: 0.95 });
        if (!mats.kpPad) mats.kpPad = new T.MeshStandardMaterial({ color: 0x17181a, roughness: 0.6 });
        if (!mats.kpBandA) mats.kpBandA = new T.MeshStandardMaterial({ color: 0xc8392f, roughness: 0.6 });
        if (!mats.kpBandB) mats.kpBandB = new T.MeshStandardMaterial({ color: 0x2f6bc8, roughness: 0.6 });
        if (!mats.kpHard) mats.kpHard = new T.MeshStandardMaterial({ color: 0xc9a173, roughness: 0.7 });   /* the hammer's handle */
        if (!mats.kpBagL) mats.kpBagL = new T.MeshStandardMaterial({ color: 0x6b2a20, roughness: 0.72 });   /* v410 the bag's brown-red leather */
        if (!mats.kpBagS) mats.kpBagS = new T.MeshStandardMaterial({ color: 0x3e1912, roughness: 0.8 });   /* -- its seams and top */
        if (!mats.kpRope) mats.kpRope = new T.MeshStandardMaterial({ color: 0xc8b48a, roughness: 0.95 });   /* v410 the manila / hemp rope */
        if (!mats.kpSteel) mats.kpSteel = new T.MeshStandardMaterial({ color: 0x232527, roughness: 0.45, metalness: 0.45 });   /* v410 the powder-coated steel */
        function cyl(r, h, mat, x, y, z, ax) {   /* ax: the axis ('x' | 'y' | 'z') */
          var m = new T.Mesh(new T.CylinderGeometry(r, r, h, 20), mat);
          if (ax === 'x') m.rotation.z = Math.PI / 2; else if (ax === 'z') m.rotation.x = Math.PI / 2;
          m.position.set(x, y, z); return m;
        }
        function seg(a, b, r, mat) {   /* a rod from a to b */
          var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], ln = Math.sqrt(dx * dx + dy * dy + dz * dz) || 1e-6;
          var me = new T.Mesh(new T.CylinderGeometry(r, r, ln, 10), mat);
          me.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
          me.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / ln, dy / ln, dz / ln));
          return me;
        }
        function tube(pts, r, mat) { return new T.Mesh(new T.TubeGeometry(new T.CatmullRomCurve3(pts.map(function (q) { return new T.Vector3(q[0], q[1], q[2]); })), Math.max(24, pts.length * 6), r, 8, false), mat); }
        g.fitL.forEach(function (it) {
          var pt = 'kp-' + it.kind, xc = (it.x0 + it.x1) / 2, yc = (it.y0 + it.y1) / 2, zc = (it.z0 + it.z1) / 2, dx = it.x1 - it.x0, dy = it.y1 - it.y0, dz = it.z1 - it.z0, fly = [1, 0, 0], nP = 0;
          function P(m, f) { put(m, pt, nP ? null : it.code, nP ? it.id + '-' + nP : it.id, 0, f || fly); nP++; }
          /* the item's own frame: u along its axis (it.ax), v across, y up from its foot; a box turned (deg, about v) round a hinge */
          var zAx = (it.ax === 'z'), Lup = (it.kind === 'bench') ? KP.BENCH[0] : 0;
          /* the frame's matrix: along x | along z | (v411) standing up on its front end, its width along x, its depth along z */
          var MF = new T.Matrix4().makeTranslation(xc, it.y0, zc);
          if (it.up) MF.multiply(new T.Matrix4().makeRotationY(Math.PI / 2)).multiply(new T.Matrix4().makeTranslation(-0.235, Lup / 2 + 0.01, 0)).multiply(new T.Matrix4().makeRotationZ(-Math.PI / 2));
          else if (zAx) MF.multiply(new T.Matrix4().makeRotationY(-Math.PI / 2));
          function lbox(du, h, dv, mat, cu, cy, cv, tilt, hu, hy) {
            var ge = new T.BoxGeometry(du, h, dv);
            if (tilt) { ge.translate(cu - hu, cy - hy, cv); ge.rotateZ(-tilt * Math.PI / 180); ge.translate(hu, hy, 0); } else ge.translate(cu, cy, cv);
            ge.applyMatrix4(MF);
            return new T.Mesh(ge, mat);
          }
          function lpt(u, y, v) { var q5 = new T.Vector3(u, y, v).applyMatrix4(MF); return [q5.x, q5.y, q5.z]; }
          if (it.kind === 'wrack') {
            /* v410 the wall rack: two uprights on the studs, the kettlebells' and the dumbbells' shelves on arms, two plate pegs + the plates */
            var zW = it.z1, dS = dz - 0.02;
            for (var s1 = -1; s1 <= 1; s1 += 2) P(mk(0.05, dy - 0.05, 0.05, mats.kpSteel, s1 * it.sx, it.y0 + 0.05 + (dy - 0.05) / 2, zW - 0.025), [0, 0, -1]);
            [it.yK, it.yD].forEach(function (ys) {
              P(mk(dx, 0.025, dS - 0.05, mats.kpSteel, xc, ys - 0.0125, zW - 0.05 - (dS - 0.05) / 2), [0, 0, -1]);
              P(mk(dx, 0.05, 0.02, mats.kpSteel, xc, ys + 0.025, zW - dS + 0.01), [0, 0, -1]);   /* the lip at the front */
            });
            P(mk(Math.min(0.75, 2 * it.sx + 0.05), 0.06, 0.02, mats.kpSteel, xc, it.yP, zW - 0.06), [0, 0, -1]);
            var pegX = KP.WR_PX ? [-KP.WR_PX, KP.WR_PX] : [0], pl = KP.WR_PX ? [0.225, 0.225, 0.16] : [0.225, 0.225, 0.225, 0.225, 0.16, 0.16];   /* v411 one peg: the six plates on it */
            pegX.forEach(function (xg) {
              P(cyl(0.025, dS - 0.07, mats.kpChrome, xg, it.yP, zW - 0.07 - (dS - 0.07) / 2, 'z'), [0, 0, -1]);
              pl.forEach(function (rp, n2) { P(cyl(rp, 0.045, mats.kpRubber, xg, it.yP, zW - 0.095 - 0.05 * n2, 'z'), [0, 0, -1]); });
            });
          } else if (it.kind === 'dumbbell') {
            /* v410 on the rack's shelf: two adjustable dumbbells side by side, the handles along the wall */
            var dbs = (dx > 0.6) ? [[xc - dx / 4, zc], [xc + dx / 4, zc]] : [[xc, it.z1 - 0.10], [xc, it.z0 + 0.10]];   /* v411 front to back on the narrow rack */
            dbs.forEach(function (q4) {
              var xd = q4[0], zd = q4[1], yd = it.y0 + 0.10;
              P(cyl(0.016, 0.16, mats.kpChrome, xd, yd, zd, 'x'), [0, 0, -1]);
              for (var d3 = -1; d3 <= 1; d3 += 2) { P(cyl(0.095, 0.12, mats.kpGym, xd + d3 * 0.14, yd, zd, 'x'), [0, 0, -1]); P(cyl(0.06, 0.02, mats.kpGymRed, xd + d3 * 0.07, yd, zd, 'x'), [0, 0, -1]); }
            });
          } else if (it.kind === 'bag') {
            /* v410 the real shape: a leather cylinder rounded at both ends, two seams, the top cap; four chains to a swivel, one up to the hook */
            var rB = (it.x1 - it.x0) / 2, hB = dy, rc = 0.05, prof = [], a3;
            prof.push(new T.Vector2(0.0001, 0));
            for (a3 = 0; a3 <= 6; a3++) { var t3 = a3 / 6 * Math.PI / 2; prof.push(new T.Vector2(rB - rc + rc * Math.sin(t3), rc - rc * Math.cos(t3))); }
            for (a3 = 0; a3 <= 6; a3++) { var t4 = a3 / 6 * Math.PI / 2; prof.push(new T.Vector2(rB - rc + rc * Math.cos(t4), hB - rc + rc * Math.sin(t4))); }
            prof.push(new T.Vector2(0.0001, hB));
            var bagM = new T.Mesh(new T.LatheGeometry(prof, 36), mats.kpBagL);
            bagM.position.set(it.xc, it.y0, it.zc); P(bagM, [0, -1, 0]);
            [hB / 3, 2 * hB / 3].forEach(function (yq) { var sm = new T.Mesh(new T.TorusGeometry(rB + 0.001, 0.004, 6, 36), mats.kpBagS); sm.rotation.x = Math.PI / 2; sm.position.set(it.xc, it.y0 + yq, it.zc); P(sm, [0, -1, 0]); });
            P(cyl(rB * 0.55, 0.012, mats.kpBagS, it.xc, it.y1 + 0.004, it.zc, 'y'), [0, -1, 0]);
            var ySw = it.y1 + Math.min(0.26, (it.yHook - it.y1) * 0.6);
            for (var a4 = 0; a4 < 4; a4++) { var an = a4 * Math.PI / 2 + Math.PI / 4, xr4 = it.xc + Math.cos(an) * rB * 0.72, zr4 = it.zc + Math.sin(an) * rB * 0.72; P(seg([xr4, it.y1 - 0.01, zr4], [it.xc, ySw, it.zc], 0.004, mats.kpChrome), [0, -1, 0]); }
            P(cyl(0.012, 0.05, mats.kpChrome, it.xc, ySw + 0.025, it.zc, 'y'), [0, -1, 0]);
            P(cyl(0.004, Math.max(0.01, it.yHook - ySw - 0.05), mats.kpChrome, it.xc, (it.yHook + ySw + 0.05) / 2, it.zc, 'y'), [0, -1, 0]);
          } else if (it.kind === 'pulley') {
            /* its plate on the stud, two guide rods, the frames, the carriage + its pulley, the cable, the triceps rope; the loading pin with two plates */
            var zw = it.z0;
            P(mk(0.30, dy, 0.012, mats.kpGym, xc, yc, zw + 0.006), [0, 0, 1]);
            P(mk(0.30, 0.06, 0.16, mats.kpGym, xc, it.y1 - 0.03, zw + 0.08), [0, 0, 1]);
            P(mk(0.30, 0.05, 0.16, mats.kpGym, xc, it.y0 + 0.025, zw + 0.08), [0, 0, 1]);
            for (var e1 = -1; e1 <= 1; e1 += 2) P(cyl(0.012, dy - 0.11, mats.kpChrome, xc + e1 * 0.08, it.y0 + 0.05 + (dy - 0.11) / 2, zw + 0.11, 'y'), [0, 0, 1]);
            var yCar = it.y0 + 1.25;
            P(mk(0.22, 0.12, 0.08, mats.kpGymRed, xc, yCar, zw + 0.11), [0, 0, 1]);
            P(cyl(0.045, 0.03, mats.kpChrome, xc, yCar - 0.02, zw + 0.19, 'x'), [0, 0, 1]);
            P(cyl(0.003, 0.33, mats.kpDark, xc, yCar - 0.065 - 0.165, zw + 0.235, 'y'), [0, 0, 1]);
            for (var e2 = -1; e2 <= 1; e2 += 2) P(seg([xc, yCar - 0.40, zw + 0.235], [xc + e2 * 0.05, yCar - 0.68, zw + 0.25], 0.013, mats.kpPad), [0, 0, 1]);
            P(cyl(0.022, 0.42, mats.kpChrome, xc, it.y0 + 0.21, zw + 0.24, 'y'), [0, 0, 1]);
            for (var e3 = 0; e3 < 2; e3++) P(cyl(0.165, 0.05, mats.kpRubber, xc, it.y0 + 0.03 + e3 * 0.055, zw + 0.24, 'y'), [0, 0, 1]);
          } else if (it.kind === 'kbell') {
            var rk = it.r, ball = new T.Mesh(new T.SphereGeometry(rk, 18, 12), mats.kpGym);
            ball.scale.set(1, 0.94, 1); ball.position.set(xc, it.y0 + rk * 0.94, zc); P(ball);
            var hdl = new T.Mesh(new T.TorusGeometry(rk * 0.62, rk * 0.13, 8, 18, Math.PI), mats.kpGym);
            hdl.position.set(xc, it.y0 + rk * 1.58, zc); P(hdl);
          } else if (it.kind === 'barbell') {
            var ax = it.ax || 'z', bl = (ax === 'x') ? dx : dz, ex = (ax === 'x') ? 1 : 0, ez = 1 - ex;
            P(cyl(KP.BAR_R, bl, mats.kpChrome, xc, yc, zc, ax));
            for (var s3 = -1; s3 <= 1; s3 += 2) {
              P(cyl(0.025, 0.40, mats.kpChrome, xc + ex * s3 * (bl / 2 - 0.20), yc, zc + ez * s3 * (bl / 2 - 0.20), ax));
              if (it.plates) P(cyl(0.225, 0.05, mats.kpRubber, xc + s3 * (bl / 2 - 0.36), yc, zc, 'x'));   /* on the J-hooks: two plates */
            }
          } else if (it.kind === 'bench') {
            /* v410 the adjustable bench: a steel spine on a front and a rear foot (wheels at the front, a handle at the rear), the seat on
               its post, the back hinged at the seat on its ladder bracket (flat or raised it.tilt deg) */
            var Lb = it.up ? KP.BENCH[0] : zAx ? dz : dx, Wb = it.up ? KP.BENCH[1] : zAx ? dx : dz, uF = Lb / 2 - 0.06, tl = it.tilt || 0, hu0 = 0.14, hy0 = 0.38;
            P(lbox(Lb - 0.20, 0.06, 0.08, mats.kpSteel, 0, 0.17, 0));
            for (var s4 = -1; s4 <= 1; s4 += 2) {
              P(lbox(0.06, 0.05, Wb, mats.kpSteel, s4 * uF, 0.025, 0));
              P(lbox(0.06, 0.15, 0.06, mats.kpSteel, s4 * (uF - 0.02), 0.115, 0));
              P(lbox(0.05, 0.05, 0.03, mats.kpRubber, s4 * uF, 0.025, s4 * (Wb / 2 - 0.015)));
            }
            for (var s5 = -1; s5 <= 1; s5 += 2) { var whg = new T.CylinderGeometry(0.035, 0.035, 0.025, 16); whg.rotateX(Math.PI / 2); whg.translate(uF + 0.01, 0.035, s5 * (Wb / 2 - 0.0125)); whg.applyMatrix4(MF); P(new T.Mesh(whg, mats.kpRubber)); }   /* the wheels at the front foot's ends */
            P(lbox(0.04, 0.04, 0.24, mats.kpSteel, -uF - 0.05, 0.20, 0));   /* the handle */
            P(lbox(0.40, 0.07, 0.27, mats.kpPad, hu0 + 0.215, hy0 + 0.035, 0, 0, 0, 0));   /* the seat */
            P(lbox(0.06, hy0 - 0.20, 0.06, mats.kpSteel, hu0 + 0.22, 0.20 + (hy0 - 0.20) / 2, 0));
            P(lbox(0.80, 0.07, 0.26, mats.kpPad, hu0 - 0.40 - 0.005, hy0 + 0.035, 0, tl, hu0, hy0));   /* the back */
            P(lbox(0.78, 0.03, 0.08, mats.kpSteel, hu0 - 0.40, hy0 - 0.015, 0, tl, hu0, hy0));         /* its frame */
            var bt = tl * Math.PI / 180, pu = hu0 - 0.45 * Math.cos(bt), py = hy0 - 0.03 + 0.45 * Math.sin(bt);
            P(seg(lpt(-0.30, 0.20, 0), lpt(pu, py, 0), 0.015, mats.kpSteel));   /* the ladder bracket's strut */
          } else if (it.kind === 'ladder') {
            /* v410 steel: rectangular tube stiles, round rungs */
            for (var s6 = -1; s6 <= 1; s6 += 2) P(mk(0.04, dy, 0.06, mats.kpSteel, s6 * it.sx, yc, zc), [0, 0, 1]);
            for (var yr = 0.15; yr < dy - 0.06; yr += KP.RUNG_SP) P(cyl(KP.RUNG_R, 2 * it.sx - 0.04, mats.kpSteel, xc, it.y0 + yr, zc, 'x'), [0, 0, 1]);
            for (var s7 = -1; s7 <= 1; s7 += 2) P(mk(0.05, 0.012, 0.07, mats.kpRubber, s7 * it.sx, 0.006, zc), [0, 0, 1]);
          } else if (it.kind === 'jhook') {
            P(mk(0.05, 0.14, 0.008, mats.kpGymRed, xc, it.y1 - 0.06, it.z0 + 0.004), [0, 0, 1]);
            P(mk(0.04, 0.03, dz, mats.kpGymRed, xc, it.y1 - 0.015, zc), [0, 0, 1]);
            P(mk(0.04, it.lipY - it.y1, 0.012, mats.kpGymRed, xc, (it.y1 + it.lipY) / 2, it.z1 - 0.006), [0, 0, 1]);
          } else if (it.kind === 'pubar') {
            for (var s8 = -1; s8 <= 1; s8 += 2) {
              P(mk(0.05, 0.12, 0.03, mats.kpSteel, s8 * it.sx, it.yBar - 0.06, it.z0 + 0.015), [0, 0, 1]);
              P(mk(0.04, 0.04, it.zBar - it.z0, mats.kpSteel, s8 * it.sx, it.yBar, (it.z0 + it.zBar) / 2), [0, 0, 1]);
            }
            P(cyl(KP.PB_R, dx, mats.kpChrome, xc, it.yBar, it.zBar, 'x'), [0, 0, 1]);
          } else if (it.kind === 'dip') {
            P(mk(2 * it.sx + 0.04, 0.04, 0.04, mats.kpSteel, xc, it.yBar - 0.03, it.z0 + 0.02), [0, 0, 1]);
            for (var s9 = -1; s9 <= 1; s9 += 2) {
              P(cyl(0.02, dz - 0.04, mats.kpSteel, s9 * it.sp, it.yBar, it.z0 + 0.04 + (dz - 0.04) / 2, 'z'), [0, 0, 1]);
              P(cyl(0.023, 0.24, mats.kpPad, s9 * it.sp, it.yBar, it.z1 - 0.13, 'z'), [0, 0, 1]);
            }
          } else if (it.kind === 'rings') {
            for (var sg4 = -1; sg4 <= 1; sg4 += 2) {
              var xr = it.xc + sg4 * KP.RING_SP, yRc = it.y0 + KP.RING_R, yS0 = yRc + KP.RING_R, yS1 = it.yBar;
              P(mk(0.038, yS1 - yS0, 0.004, mats.kpGym, xr, (yS0 + yS1) / 2, it.zc + KP.PB_R + 0.003), [0, 0, 1]);
              var ring = new T.Mesh(new T.TorusGeometry(KP.RING_R - KP.RING_T, KP.RING_T, 10, 32), mats.kpDark);
              ring.position.set(xr, yRc, it.zc + KP.PB_R + 0.003);
              P(ring, [0, 0, 1]);
            }
          } else if (it.kind === 'bands') {
            var bm = (it.x0 < 0) ? mats.kpBandA : mats.kpBandB;
            for (var sa = -1; sa <= 1; sa += 2) P(mk(0.014, dy, 0.004, bm, xc + sa * 0.016, yc, it.z1 + 0.004), [0, 0, 1]);
          } else if (it.kind === 'rope') {
            /* v410 manila / hemp, black grips: coiled (a helix) or its two ends out from the anchor in waves on the ground */
            var rR = it.r;
            if (it.coil) {
              var hp = [], R0 = 0.17, nT = 5;
              for (var c2 = 0; c2 <= nT * 24; c2++) { var ang = c2 / 24 * Math.PI * 2, Rr = R0 - 0.004 * c2 / 24; hp.push([xc + Rr * Math.cos(ang), it.y0 + rR + c2 / 24 * 2 * rR * 0.95, zc + Rr * Math.sin(ang)]); }
              P(tube(hp, rR, mats.kpRope), [0, 1, 0]);
              for (var gq = -1; gq <= 1; gq += 2) P(cyl(0.024, 0.20, mats.kpPad, xc + gq * 0.05, it.y0 + 2 * rR * nT * 0.95 + 0.026, zc, 'z'), [0, 1, 0]);
            } else {
              var eye = new T.Mesh(new T.TorusGeometry(0.025, 0.006, 8, 16), mats.galv);
              eye.rotation.y = Math.PI / 2; eye.position.set(it.xa - 0.002, it.ya, it.za); P(eye, [-1, 0, 0]);
              /* v415 each end waved its own way (Marek 09:44 "Lana - kazde zvlnene jinak (muze byt jedno mirne rovnejsi = delsi)"): one in
                 tighter, larger waves, the other flatter and reaching further; a second, slower wave over each so no two crests repeat */
              var RW = [{ n: 4.6, a: 0.12, ph: 0.4, n2: 1.3, a2: 0.035, ex: 0, dr: 0.05 }, { n: 2.7, a: 0.055, ph: 2.1, n2: 0.8, a2: 0.025, ex: -0.30, dr: 0.12 }];
              for (var sb = -1; sb <= 1; sb += 2) {
                var rw2 = RW[sb < 0 ? 0 : 1], xEe = it.xe + rw2.ex;
                var wp = [[it.xa - 0.02, it.ya, it.za + sb * 0.02], [it.xa - 0.14, Math.max(rR, it.ya * 0.5), it.za + sb * 0.035]], xB = it.xa - 0.30, NS = 48;
                for (var k3 = 0; k3 <= NS; k3++) { var tq = k3 / NS, env = Math.min(1, tq * 4) * (0.75 + 0.45 * tq), zq3 = it.za + sb * (0.05 + (it.sp - 0.05 + rw2.dr * tq) * tq) + env * (rw2.a * Math.sin(tq * rw2.n * 2 * Math.PI + rw2.ph) + rw2.a2 * Math.sin(tq * rw2.n2 * 2 * Math.PI + rw2.ph * 1.7)); wp.push([xB + (xEe - xB) * tq, rR, zq3]); }
                P(tube(wp, rR, mats.kpRope), [-1, 0, 0]);
                var lp = wp[wp.length - 1], lq = wp[wp.length - 2], gx = lp[0] - lq[0], gz = lp[2] - lq[2], gl = Math.sqrt(gx * gx + gz * gz) || 1;
                P(seg([lp[0], rR + 0.004, lp[2]], [lp[0] + gx / gl * 0.22, rR + 0.004, lp[2] + gz / gl * 0.22], 0.025, mats.kpPad), [-1, 0, 0]);
              }
            }
          } else if (it.kind === 'tyre') {
            /* v415 a real tractor tyre lying flat (Marek 09:44 "Pneumatika realistictejsi tvar, vzorek"): the section turned round its axis --
               the beads at the hole, the sidewalls bulging a little, round shoulders, a flat tread -- and the tread's chevron lugs round it,
               in two rows meeting in a V (one geometry), a rim line on the top sidewall */
            var RO = KP.TYRE_R - 0.022, RI = KP.TYRE_RI, Ht = dy, sec = [], th, LG = 0.024;
            sec.push([RI + 0.012, 0.03], [RI + 0.035, 0.004], [RI + 0.09, 0.0]);
            for (th = 0; th <= 6; th++) { var aS = th / 6 * Math.PI / 2; sec.push([RO - 0.06 + 0.06 * Math.sin(aS) + 0.004 * Math.sin(aS * 2), 0.06 - 0.06 * Math.cos(aS)]); }
            for (th = 0; th <= 6; th++) { var aS2 = th / 6 * Math.PI / 2; sec.push([RO - 0.06 + 0.06 * Math.cos(aS2), Ht - 0.06 + 0.06 * Math.sin(aS2)]); }
            sec.push([RI + 0.09, Ht], [RI + 0.035, Ht - 0.004], [RI + 0.012, Ht - 0.03], [RI, Ht - 0.06], [RI, 0.06], [RI + 0.012, 0.03]);
            var tyG = new T.LatheGeometry(sec.map(function (q) { return new T.Vector2(q[0], q[1]); }), 64);
            var tyM = new T.Mesh(tyG, mats.kpRubber); tyM.position.set(it.xc, it.y0, it.zc); P(tyM, [1, 0, 0]);
            /* the lugs: boxes on the tread, each row leaning the other way; built into one geometry */
            var nL = 38, lugP = [], lugN = [], Mq = new T.Matrix4(), Rq = new T.Matrix4();
            for (var lg = 0; lg < nL; lg++) for (var rw = -1; rw <= 1; rw += 2) {
              var aL = (lg + (rw > 0 ? 0.5 : 0)) / nL * 2 * Math.PI, hl = Ht / 2 - 0.03, bg = new T.BoxGeometry(LG, hl, 0.038).toNonIndexed();
              Mq.makeTranslation(RO + LG / 2 - 0.004, it.y0 + Ht / 2 + rw * (hl / 2 + 0.006), 0);
              Rq.makeRotationX(rw * 0.55); Mq.multiply(Rq);
              Rq.makeRotationY(-aL); Mq.premultiply(Rq);
              bg.applyMatrix4(Mq);
              var bp = bg.attributes.position.array, bn = bg.attributes.normal.array, qq;
              for (qq = 0; qq < bp.length; qq++) { lugP.push(bp[qq]); lugN.push(bn[qq]); }
              bg.dispose();
            }
            var lugG = new T.BufferGeometry();
            lugG.setAttribute('position', new T.Float32BufferAttribute(lugP, 3)); lugG.setAttribute('normal', new T.Float32BufferAttribute(lugN, 3));
            var lugM = new T.Mesh(lugG, mats.kpRubber); lugM.position.set(it.xc, 0, it.zc); P(lugM, [1, 0, 0]);
            var rimL = new T.Mesh(new T.TorusGeometry(RI + 0.07, 0.005, 6, 64), mats.kpPad); rimL.rotation.x = Math.PI / 2; rimL.position.set(it.xc, it.y0 + Ht + 0.002, it.zc); P(rimL, [1, 0, 0]);
          } else if (it.kind === 'hammer') {
            /* v415 on the ground beside the tyre: the head's face down, the handle from it to the ground */
            var hX = it.hx0 + it.hdx * KP.HAM_L, hZ = it.hz0 + it.hdz * KP.HAM_L, hh = KP.HAM_HD;
            P(seg([it.hx0, 0.018, it.hz0], [hX - it.hdx * 0.03, hh / 2, hZ - it.hdz * 0.03], 0.017, mats.kpHard));
            var hdG = new T.BoxGeometry(0.20, hh, hh); hdG.rotateY(Math.atan2(it.hdx, it.hdz)); hdG.translate(hX, hh / 2, hZ);
            P(new T.Mesh(hdG, mats.kpGym));
          } else if (it.kind === 'gknuckle') {
            /* v415 the gallows' hinge knuckle round its pin (v417 two parts: the pin's lower one on the strap, the mast's sleeve over it) */
            var kLo = KP.GAL_KH * 0.45;
            P(cyl(KP.GAL_KR, kLo - 0.001, mats.kpSteel, it.xc, it.y0 + kLo / 2, it.zc, 'y'), [0, 0, 1]);
            P(cyl(KP.GAL_KR, dy - kLo - 0.001, mats.kpSteel, it.xc, it.y0 + kLo + (dy - kLo) / 2, it.zc, 'y'), [0, 0, 1]);
            P(cyl(KP.GAL_PIN, 0.012, mats.kpChrome, it.xc, it.y1 + 0.006, it.zc, 'y'), [0, 0, 1]);
          } else if (it.kind === 'tv') {
            /* v415 the TV on its swivel ceiling mount: the pole down from the plate, the swivel, the VESA arm, the TV (its screen dark glass) */
            var aTv = Math.atan2(-it.nz, it.nx), TVs = [it.tw || KP.TV[0], it.th || KP.TV[1], KP.TV[2]];
            P(cyl(0.02, it.yTop - it.yC, mats.kpSteel, it.xc, (it.yTop + it.yC) / 2, it.zc, 'y'), [0, -1, 0]);
            P(cyl(0.032, 0.05, mats.kpSteel, it.xc, it.yC, it.zc, 'y'), [0, -1, 0]);
            function tvBox(du, dh, dn, mat, off) { var bgT = new T.BoxGeometry(dn, dh, du); bgT.translate(off, 0, 0); bgT.rotateY(aTv); bgT.translate(it.xc, it.yC, it.zc); return new T.Mesh(bgT, mat); }
            P(tvBox(0.20, 0.20, 0.03, mats.kpSteel, KP.TV_OFF - TVs[2] / 2 - 0.015), [0, -1, 0]);
            P(tvBox(TVs[0], TVs[1], TVs[2] - 0.006, mats.kpGym, KP.TV_OFF - 0.003), [0, -1, 0]);
            P(tvBox(TVs[0] - 0.02, TVs[1] - 0.02, 0.006, mats.kpGlass, KP.TV_OFF + TVs[2] / 2 - 0.003), [0, -1, 0]);
          }
        });
      })();
      /* THE MODULES: the stainless body in its cutout, the flange on the face, the fronts and their handles */
      var xF = g.xFace, xB = g.xMb, y0 = g.yM0, y1 = g.yM1, mh = y1 - y0, fz = 0.015, gap = 0.003;
      /* v412 THE SLIDER'S SECOND HALF (ext 0 .. 1): each drawer out its own way -- the top one furthest and first, the lower ones less and
         later, every other module a little less -- and every door open to 95 deg after them; a module with a door drawn as a shell
         (a shelf in a store cupboard) so the inside shows, a drawer's box and its opening dark behind it */
      var ext = _kpExt(STATE), cl01 = function (v) { return Math.max(0, Math.min(1, v)); }, ease = function (v) { v = cl01(v); return v * v * (3 - 2 * v); };
      var dX = xF - xB, tMax = Math.min(0.34, dX * 0.75), nDoorAll = 0;
      for (i = 0; i < g.mods.length; i++) {
        var md = g.mods[i], w = md.w, zc = md.zc, id = 'module-' + (md.bay + 1) + '-' + md.front;
        var za = zc - w / 2 + gap, zb = zc + w / 2 - gap, ya = y0 + gap, yb = y1 - gap, isGC = !!(g.gas && g.gas.cab === md.bay);
        var hasDoor = (md.front === 'sdoor' || md.front === 'ddoor' || md.front === 'combo'), shellM = isGC || g.bays[md.bay].top === 'sink' || (hasDoor && ext > 0);   /* v412 + any open door's */
        if (shellM) {   /* v382 + the sinks' (their supply and waste inside) */
          /* v382 the gas bottle's cabinet: a shell (back, floor, roof, sides; the combo's divider) so the bottle shows through its open door */
          var sT = 0.006, zs0 = zc - (w - 0.004) / 2, zs1 = zc + (w - 0.004) / 2;
          put(mk(sT, mh, w - 0.004, mats.kpInox, xB + sT / 2, (y0 + y1) / 2, zc), 'kp-module', md.code, id, 0, [1, 0, 0]);
          put(mk(xF - xB - sT, sT, w - 0.004, mats.kpInox, (xB + sT + xF) / 2, y0 + sT / 2, zc), 'kp-module', null, id + '-floor', 0, [1, 0, 0]);
          put(mk(xF - xB - sT, sT, w - 0.004, mats.kpInox, (xB + sT + xF) / 2, y1 - sT / 2, zc), 'kp-module', null, id + '-roof', 0, [1, 0, 0]);
          put(mk(xF - xB - sT, mh - 2 * sT, sT, mats.kpInox, (xB + sT + xF) / 2, (y0 + y1) / 2, zs0 + sT / 2), 'kp-module', null, id + '-side-l', 0, [1, 0, 0]);
          put(mk(xF - xB - sT, mh - 2 * sT, sT, mats.kpInox, (xB + sT + xF) / 2, (y0 + y1) / 2, zs1 - sT / 2), 'kp-module', null, id + '-side-r', 0, [1, 0, 0]);
          if (md.front === 'combo') put(mk(xF - xB - sT, mh - 2 * sT, sT, mats.kpInox, (xB + sT + xF) / 2, (y0 + y1) / 2, za + (zb - za) * 0.55), 'kp-module', null, id + '-divider', 0, [1, 0, 0]);
          if (!isGC && g.bays[md.bay].top !== 'sink' && md.front !== 'combo') put(mk(xF - xB - sT - 0.01, sT, w - 0.004 - 2 * sT, mats.kpInox, (xB + sT + xF - 0.01) / 2, (y0 + y1) / 2, zc), 'kp-module', null, id + '-shelf', 0, [1, 0, 0]);   /* v412 a store cupboard's shelf */
        } else put(mk(xF - xB, mh, w - 0.004, mats.kpInox, (xF + xB) / 2, (y0 + y1) / 2, zc), 'kp-module', md.code, id, 0, [1, 0, 0]);
        if (shellM) {   /* v382 a shell's flange: a frame round its opening (the inside shows through an open door) */
          put(mk(0.004, 0.016, w + 0.02, mats.kpInox, xF + 0.002, y1 + 0.002, zc), 'kp-module', null, id + '-flange', 0, [1, 0, 0]);
          put(mk(0.004, 0.016, w + 0.02, mats.kpInox, xF + 0.002, y0 - 0.002, zc), 'kp-module', null, id + '-flange-b', 0, [1, 0, 0]);
          for (k = -1; k <= 1; k += 2) put(mk(0.004, mh - 0.012, 0.016, mats.kpInox, xF + 0.002, (y0 + y1) / 2, zc + k * (w / 2 + 0.002)), 'kp-module', null, id + '-flange-s' + k, 0, [1, 0, 0]);
        } else put(mk(0.004, mh + 0.02, w + 0.02, mats.kpInox, xF + 0.002, (y0 + y1) / 2, zc), 'kp-module', null, id + '-flange', 0, [1, 0, 0]);
        var fr = [];   /* fronts: [z0, z1, y0, y1, handle 'h' / 'v'] in the cutout */
        if (md.front === 'drawer') { for (k = 0; k < 3; k++) fr.push([za, zb, ya + (yb - ya) * k / 3 + gap / 2, ya + (yb - ya) * (k + 1) / 3 - gap / 2, 'h']); }
        else if (md.front === 'trash') fr.push([za, zb, ya, yb, 'h']);
        else if (md.front === 'sdoor') fr.push([za, zb, ya, yb, 'v']);
        else if (md.front === 'ddoor') { fr.push([za, zc - gap / 2, ya, yb, 'v']); fr.push([zc + gap / 2, zb, ya, yb, 'v']); }
        else if (md.front === 'combo') { var zm = za + (zb - za) * 0.55; fr.push([za, zm - gap / 2, ya, yb, 'v']); fr.push([zm + gap / 2, zb, ya, (ya + yb) / 2 - gap / 2, 'h']); fr.push([zm + gap / 2, zb, (ya + yb) / 2 + gap / 2, yb, 'h']); }
        for (k = 0; k < fr.length; k++) {
          var f0 = fr[k], fzc = (f0[0] + f0[1]) / 2, fyc = (f0[2] + f0[3]) / 2;
          var dA = (f0[4] === 'v' && ext > 0) ? 95 * ease((ext - 0.30 - 0.08 * (nDoorAll % 4)) / 0.5) : 0;
          if (f0[4] === 'v') nDoorAll++;
          if (f0[4] === 'h' && ext > 0) {
            /* v412 a drawer out: the row from the top (r 0) furthest and first; every other module 85 % */
            var rTop = (md.front === 'drawer') ? (2 - k) : (md.front === 'combo') ? (2 - k) : 0, amp = [1, 0.62, 0.38][Math.min(2, rTop)] * ((i % 2) ? 0.85 : 1);
            var dOut = tMax * amp * ease((ext - 0.12 * rTop - 0.05 * (i % 3)) / 0.55);
            if (dOut > 0.002) {
              var fw0 = f0[1] - f0[0], fh0 = f0[3] - f0[2], xFr0 = xF + 0.004 + dOut, dDr = dX * 0.85, bT = 0.006, sH0 = Math.max(0.06, fh0 * (md.front === 'trash' ? 0.8 : 0.6));
              put(mk(fz, fh0, fw0, mats.kpInox, xFr0 + fz / 2, fyc, fzc), 'kp-module', null, id + '-front-' + k, 0, [1, 0, 0]);
              put(mk(0.012, 0.012, Math.min(0.30, fw0 * 0.6), mats.kpDark, xFr0 + fz + 0.012, f0[3] - 0.04, fzc), 'kp-module', null, id + '-handle-' + k, 0, [1, 0, 0]);
              put(mk(0.002, fh0 - 0.004, fw0 - 0.004, mats.kpHole, xF + 0.0045, fyc, fzc), 'kp-module', null, id + '-opening-' + k, 0, [1, 0, 0]);   /* its opening, dark */
              var xbx = xFr0 - dDr / 2, yb0 = f0[2] + 0.012;
              put(mk(dDr, bT, fw0 - 0.03, mats.kpInox, xbx, yb0 + bT / 2, fzc), 'kp-module', null, id + '-dbox-b-' + k, 0, [1, 0, 0]);
              for (var sd2 = -1; sd2 <= 1; sd2 += 2) put(mk(dDr, sH0, bT, mats.kpInox, xbx, yb0 + sH0 / 2, fzc + sd2 * (fw0 / 2 - 0.015 - bT / 2)), 'kp-module', null, id + '-dbox-s' + sd2 + '-' + k, 0, [1, 0, 0]);
              put(mk(bT, sH0, fw0 - 0.03, mats.kpInox, xFr0 - dDr + bT / 2, yb0 + sH0 / 2, fzc), 'kp-module', null, id + '-dbox-k-' + k, 0, [1, 0, 0]);
              if (md.front === 'trash') for (var tb2 = -1; tb2 <= 1; tb2 += 2) put(mk(dDr * 0.42, sH0 * 0.95, (fw0 - 0.06) / 2 - 0.01, mats.kpDark, xFr0 - dDr / 2 + tb2 * dDr * 0.24, yb0 + bT + sH0 * 0.475, fzc), 'kp-module', null, id + '-bin' + tb2, 0, [1, 0, 0]);   /* its two bins */
              continue;
            }
          }
          if (dA > 0.5) {
            /* v382 the bottle's door open 95 deg on its hinge (the combo's / double door's left one on its left edge, a single door on its right)
               v412 every door, on the slider's second half (the double door's right one on its right edge) */
            var hL = (md.front === 'sdoor') ? false : (md.front === 'ddoor') ? (k === 0) : true, zh = hL ? f0[0] : f0[1], wd = f0[1] - f0[0], thD = (hL ? 1 : -1) * dA * Math.PI / 180, sgD = hL ? 1 : -1;
            var placeD = function (mesh, ox, oz) { var cD = Math.cos(thD), sD = Math.sin(thD); mesh.position.x = xF + 0.004 + ox * cD + oz * sD; mesh.position.z = zh - ox * sD + oz * cD; mesh.rotation.y = thD; return mesh; };
            put(placeD(mk(fz, f0[3] - f0[2], wd, mats.kpInox, 0, fyc, 0), fz / 2, sgD * wd / 2), 'kp-module', null, id + '-front-' + k, 0, [1, 0, 0]);
            put(placeD(mk(0.012, Math.min(0.30, (f0[3] - f0[2]) * 0.5), 0.012, mats.kpDark, 0, fyc, 0), fz + 0.012, sgD * (wd - 0.04)), 'kp-module', null, id + '-handle-' + k, 0, [1, 0, 0]);
            continue;
          }
          put(mk(fz, f0[3] - f0[2], f0[1] - f0[0], mats.kpInox, xF + 0.004 + fz / 2, fyc, fzc), 'kp-module', null, id + '-front-' + k, 0, [1, 0, 0]);
          if (f0[4] === 'h') put(mk(0.012, 0.012, Math.min(0.30, (f0[1] - f0[0]) * 0.6), mats.kpDark, xF + 0.004 + fz + 0.012, f0[3] - 0.04, fzc), 'kp-module', null, id + '-handle-' + k, 0, [1, 0, 0]);
          else put(mk(0.012, Math.min(0.30, (f0[3] - f0[2]) * 0.5), 0.012, mats.kpDark, xF + 0.004 + fz + 0.012, fyc, (fr.length > 1 && k === 0) ? f0[1] - 0.04 : f0[0] + 0.04), 'kp-module', null, id + '-handle-' + k, 0, [1, 0, 0]);
        }
      }
      var ybT = g.yWt;
      for (i = 0; i < g.bays.length; i++) {
        var bay = g.bays[i], bzc = bay.zc, bid = '-' + (i + 1);
        /* v379 THE FRIDGE: the stainless cabinet in its opening (behind the ledger's face), the flange, the door with its glass, the handle, the grille under it */
        if (bay.fridge) {
          var frW = bay.mw, fxB = g.xMb + 0.03, fy0 = g.yM0, fy1 = g.yFrT, fdT = KP.FRIDGE_DOOR, gr = 0.07;   /* v382 its back 7 cm off the wall: the socket and the gas lines behind it */
          put(mk(xF - fxB, fy1 - fy0, frW - 0.004, mats.kpInox, (xF + fxB) / 2, (fy0 + fy1) / 2, bzc), 'kp-fridge', KP.FRIDGE, 'fridge' + bid, 0, [1, 0, 0]);
          put(mk(0.004, fy1 - fy0 + 0.02, frW + 0.02, mats.kpInox, xF + 0.002, (fy0 + fy1) / 2, bzc), 'kp-fridge', null, 'fridge-flange' + bid, 0, [1, 0, 0]);
          put(mk(0.006, gr - 0.006, frW - 0.03, mats.kpDark, xF + 0.004 + 0.003, fy0 + gr / 2, bzc), 'kp-fridge', null, 'fridge-grille' + bid, 0, [1, 0, 0]);
          put(mk(fdT, fy1 - fy0 - gr - 0.006, frW - 0.008, mats.kpInox, xF + 0.004 + fdT / 2, (fy0 + gr + fy1 - 0.006) / 2 + 0.003, bzc), 'kp-fridge', null, 'fridge-door' + bid, 0, [1, 0, 0]);
          put(mk(0.004, fy1 - fy0 - gr - 0.13, frW - 0.10, mats.kpGlass, xF + 0.004 + fdT + 0.002, (fy0 + gr + fy1) / 2, bzc), 'kp-fridge', null, 'fridge-glass' + bid, 0, [1, 0, 0]);
          put(mk(0.016, (fy1 - fy0) * 0.55, 0.016, mats.kpDark, xF + 0.004 + fdT + 0.024, (fy0 + gr + fy1) / 2, bzc + frW / 2 - 0.035), 'kp-fridge', null, 'fridge-handle' + bid, 0, [1, 0, 0]);
          for (k = -1; k <= 1; k += 2) put(mk(0.02, 0.012, 0.012, mats.kpDark, xF + 0.004 + fdT + 0.01, (fy0 + gr + fy1) / 2 + k * (fy1 - fy0) * 0.25, bzc + frW / 2 - 0.035), 'kp-fridge', null, 'fridge-hpost' + k + bid, 0, [1, 0, 0]);
        }
        /* THE GRILL HEAD: the body in the top's cutout, its plate on the top, the hood, the control strip with four knobs */
        if (bay.top === 'grill') {
          var gw = _kpU(STATE, 'GRILL_W'), gH = _kpU(STATE, 'GRILL_H'), lW = _kpU(STATE, 'LID_W'), lD = _kpU(STATE, 'LID_D'), lH = _kpU(STATE, 'LID_H');
          var gxc = (g.gx0 + g.gx1) / 2;
          put(mk(g.gx1 - g.gx0, gH + (g.yWt - g.yWb) - 0.002, gw, mats.kpInox, gxc, ybT - (gH + (g.yWt - g.yWb)) / 2 - 0.001, bzc), 'kp-grill', null, 'grill-body' + bid, 0, [0, 1, 0]);
          put(mk(g.gx1 - g.gx0 + 0.06, 0.008, lW, mats.kpInox, gxc, ybT + 0.004, bzc), 'kp-grill', null, 'grill-plate' + bid, 0, [0, 1, 0]);
          /* v412 (Marek 23:46 "gril vlky udelat take vice realisticky"): THE HOOD -- a rounded stainless lid (its profile extruded across:
             the back low and upright, the front a big round), dark end caps, a tube handle on two standoffs, a thermometer in the round;
             THE CONTROL PANEL a sloped stainless fascia at the front with four skirted knobs (was: a box lid, a dark strip) */
          var hd = Math.min(lD, g.gx1 - g.gx0 + 0.04) - 0.06, hx0 = gxc - 0.02 - hd / 2, hx1 = hx0 + hd, hy0 = ybT + 0.008, hW = lW - 0.02;
          var hSh = new T.Shape();
          hSh.moveTo(hx0, hy0); hSh.lineTo(hx1, hy0); hSh.lineTo(hx1, hy0 + lH * 0.32);
          hSh.bezierCurveTo(hx1, hy0 + lH * 0.92, hx1 - hd * 0.22, hy0 + lH, hx1 - hd * 0.5, hy0 + lH);
          hSh.bezierCurveTo(hx0 + hd * 0.18, hy0 + lH, hx0, hy0 + lH * 0.9, hx0, hy0 + lH * 0.6);
          hSh.lineTo(hx0, hy0);
          var hGeo = new T.ExtrudeGeometry(hSh, { depth: hW, bevelEnabled: false, curveSegments: 16 });
          hGeo.translate(0, 0, bzc - hW / 2);
          put(new T.Mesh(hGeo, mats.kpInox), 'kp-grill', KP.GRILL, 'grill-hood' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) {
            var capG = new T.ExtrudeGeometry(hSh, { depth: 0.012, bevelEnabled: false, curveSegments: 16 });
            capG.translate(0, 0, (k < 0) ? bzc - hW / 2 - 0.012 : bzc + hW / 2);
            put(new T.Mesh(capG, mats.kpDark), 'kp-grill', null, 'grill-cap' + k + bid, 0, [0, 1, 0]);
          }
          var hyH = hy0 + lH * 0.5, hxH = hx1 + 0.045;
          var hTube = new T.Mesh(new T.CylinderGeometry(0.011, 0.011, hW * 0.72, 16), mats.kpInox);
          hTube.rotation.x = Math.PI / 2; hTube.position.set(hxH, hyH, bzc);
          put(hTube, 'kp-grill', null, 'grill-handle' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) {
            var hSt = new T.Mesh(new T.CylinderGeometry(0.008, 0.009, 0.046, 12), mats.kpInox);
            hSt.rotation.z = Math.PI / 2; hSt.position.set(hx1 + 0.022, hyH, bzc + k * hW * 0.33);
            put(hSt, 'kp-grill', null, 'grill-hstand' + k + bid, 0, [0, 1, 0]);
          }
          if (!mats.kpDial) mats.kpDial = new T.MeshStandardMaterial({ color: 0xf1efe9, roughness: 0.5 });
          var thA = 0.95, thN = new T.Vector3(Math.cos(thA), Math.sin(thA), 0), thP = new T.Vector3(hx1 - hd * 0.16, hy0 + lH * 0.9, bzc);
          var thB = new T.Mesh(new T.CylinderGeometry(0.027, 0.027, 0.012, 20), mats.kpInox), thF = new T.Mesh(new T.CylinderGeometry(0.021, 0.021, 0.004, 20), mats.kpDial);
          thB.rotation.z = thA - Math.PI / 2; thB.position.copy(thP).addScaledVector(thN, 0.002);
          thF.rotation.z = thA - Math.PI / 2; thF.position.copy(thP).addScaledVector(thN, 0.008);
          put(thB, 'kp-grill', null, 'grill-thermo' + bid, 0, [0, 1, 0]); put(thF, 'kp-grill', null, 'grill-thermo-face' + bid, 0, [0, 1, 0]);
          var pA = 0.42, pN = new T.Vector3(Math.cos(pA), Math.sin(pA), 0), pc0 = new T.Vector3(g.gx1 + 0.022, hy0 + 0.042, bzc);
          var pnl = mk(0.012, 0.09, lW - 0.04, mats.kpInox, pc0.x, pc0.y, bzc); pnl.rotation.z = pA;
          put(pnl, 'kp-grill', null, 'grill-controls' + bid, 0, [0, 1, 0]);
          var pBk = mk(0.03, 0.05, lW - 0.04, mats.kpDark, g.gx1 + 0.002, hy0 + 0.025, bzc);
          put(pBk, 'kp-grill', null, 'grill-controls-back' + bid, 0, [0, 1, 0]);
          for (k = 0; k < 4; k++) {
            var kz = bzc + (k - 1.5) * (lW - 0.14) / 4, kBase = pc0.clone().addScaledVector(pN, 0.006); kBase.z = kz;
            var ksk = new T.Mesh(new T.CylinderGeometry(0.026, 0.028, 0.005, 20), mats.kpDark);
            ksk.rotation.z = pA - Math.PI / 2; ksk.position.copy(kBase).addScaledVector(pN, 0.0025);
            var kn = new T.Mesh(new T.CylinderGeometry(0.017, 0.019, 0.024, 18), mats.kpInox);
            kn.rotation.z = pA - Math.PI / 2; kn.position.copy(kBase).addScaledVector(pN, 0.005 + 0.012);
            var kgr = mk(0.02, 0.006, 0.03, mats.kpInox, 0, 0, 0); kgr.rotation.z = pA; kgr.position.copy(kBase).addScaledVector(pN, 0.005 + 0.024 + 0.006);
            put(ksk, 'kp-grill', null, 'grill-knob-skirt-' + k + bid, 0, [0, 1, 0]);
            put(kn, 'kp-grill', null, 'grill-knob-' + k + bid, 0, [0, 1, 0]);
            put(kgr, 'kp-grill', null, 'grill-knob-grip-' + k + bid, 0, [0, 1, 0]);
          }
        }
        /* v379 THE SIDE BURNER: the body in its cutout, the plate on the top, the grate and the ring, a control strip with one knob */
        if (bay.top === 'burner') {
          var bxc = (g.bnx0 + g.bnx1) / 2, bH = KP.BURN_H;
          put(mk(g.bnx1 - g.bnx0, bH - 0.002, KP.BURN_W, mats.kpInox, bxc, ybT - bH / 2 - 0.001, bzc), 'kp-burner', null, 'burner-body' + bid, 0, [0, 1, 0]);
          put(mk(KP.BURN_PD, 0.008, KP.BURN_PW, mats.kpInox, bxc, ybT + 0.004, bzc), 'kp-burner', KP.BURNER, 'burner-plate' + bid, 0, [0, 1, 0]);
          put(mk(0.30, 0.012, 0.26, mats.kpDark, bxc - 0.03, ybT + 0.008 + 0.022, bzc), 'kp-burner', null, 'burner-grate' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) {
            put(mk(0.012, 0.016, 0.26, mats.kpDark, bxc - 0.03 + k * 0.144, ybT + 0.008 + 0.008, bzc), 'kp-burner', null, 'burner-foot' + k + bid, 0, [0, 1, 0]);
          }
          var ring = new T.Mesh(new T.CylinderGeometry(0.055, 0.06, 0.012, 24), mats.kpDark);
          ring.position.set(bxc - 0.03, ybT + 0.008 + 0.006, bzc);
          put(ring, 'kp-burner', null, 'burner-ring' + bid, 0, [0, 1, 0]);
          put(mk(0.05, 0.06, KP.BURN_PW - 0.06, mats.kpDark, g.bnx1 + 0.005, ybT + 0.008 + 0.03, bzc), 'kp-burner', null, 'burner-controls' + bid, 0, [0, 1, 0]);
          var bkn = new T.Mesh(new T.CylinderGeometry(0.018, 0.018, 0.022, 14), mats.kpInox);
          bkn.rotation.z = Math.PI / 2;
          bkn.position.set(g.bnx1 + 0.03 + 0.011, ybT + 0.008 + 0.03, bzc);
          put(bkn, 'kp-burner', null, 'burner-knob' + bid, 0, [0, 1, 0]);
        }
        /* v379 THE KAMADO: the glazed egg through its round cutout, the hinge band at the lid's seam, the top vent, the front handle */
        if (bay.top === 'kamado') {
          var ky = ybT + KP.KAM_UP, krx = KP.KAM_RX, kry = KP.KAM_RY, kxc = g.kxc;
          var egg = new T.Mesh(new T.SphereGeometry(1, 36, 24), mats.kpCeram);
          egg.scale.set(krx, kry, krx);
          egg.position.set(kxc, ky, bzc);
          put(egg, 'kp-kamado', KP.KAMADO, 'kamado' + bid, 0, [0, 1, 0]);
          var ys = ky + 0.04, rs = krx * Math.sqrt(1 - (0.04 / kry) * (0.04 / kry));
          var band = new T.Mesh(new T.TorusGeometry(rs + 0.004, 0.009, 8, 48), mats.kpInox);
          band.rotation.x = Math.PI / 2;
          band.position.set(kxc, ys, bzc);
          put(band, 'kp-kamado', null, 'kamado-band' + bid, 0, [0, 1, 0]);
          var vent = new T.Mesh(new T.CylinderGeometry(0.05, 0.06, 0.04, 20), mats.phIron);
          vent.position.set(kxc, ky + kry + 0.008, bzc);
          put(vent, 'kp-kamado', null, 'kamado-vent' + bid, 0, [0, 1, 0]);
          var yh = ys + 0.05, rh = krx * Math.sqrt(1 - ((yh - ky) / kry) * ((yh - ky) / kry));
          put(mk(0.03, 0.03, 0.17, mats.gsTop, kxc + rh + 0.05, yh, bzc), 'kp-kamado', null, 'kamado-handle' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) put(mk(0.06, 0.012, 0.012, mats.kpInox, kxc + rh + 0.022, yh, bzc + k * 0.06), 'kp-kamado', null, 'kamado-hpost' + k + bid, 0, [0, 1, 0]);
        }
        /* THE SINK: the rim on the top, the basin in the cutout (bottom + four walls); THE TAP behind it */
        if (bay.top === 'sink') {
          var skw = _kpU(STATE, 'SINK_W'), skh = _kpU(STATE, 'SINK_H'), x0s = g.skx0, x1s = g.skx1, yts = g.yWt, wt = 0.0015, skc = (x0s + x1s) / 2;
          put(mk(x1s - x0s + 0.04, 0.004, skw + 0.04, mats.kpInox, skc, yts + 0.002, bzc), 'kp-sink', KP.SINK, 'sink-rim' + bid, 0, [0, 1, 0]);
          put(mk(x1s - x0s - 0.004, wt, skw - 0.004, mats.kpInox, skc, yts - skh + wt / 2, bzc), 'kp-sink', null, 'sink-bottom' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) {
            put(mk(wt, skh - wt, skw - 0.004, mats.kpInox, skc + k * ((x1s - x0s) / 2 - 0.002 - wt / 2), yts - (skh - wt) / 2, bzc), 'kp-sink', null, 'sink-wall-x' + k + bid, 0, [0, 1, 0]);
            put(mk(x1s - x0s - 0.004 - 2 * wt, skh - wt, wt, mats.kpInox, skc, yts - (skh - wt) / 2, bzc + k * (skw / 2 - 0.002 - wt / 2)), 'kp-sink', null, 'sink-wall-z' + k + bid, 0, [0, 1, 0]);
          }
          var txc = x0s - 0.045, col = new T.Mesh(new T.CylinderGeometry(0.018, 0.022, 0.30, 16), mats.kpInox);
          col.position.set(txc, yts + 0.15, bzc);
          put(col, 'kp-tap', KP.TAP, 'tap' + bid, 0, [0, 1, 0]);
          put(mk(0.20, 0.022, 0.022, mats.kpInox, txc + 0.10, yts + 0.29, bzc), 'kp-tap', null, 'tap-spout' + bid, 0, [0, 1, 0]);
          put(mk(0.012, 0.05, 0.012, mats.kpInox, txc + 0.195, yts + 0.255, bzc), 'kp-tap', null, 'tap-nozzle' + bid, 0, [0, 1, 0]);
        }
        /* v379 THE PIZZA OVEN on the top: four feet, the shell, the mouth to the front with its stone, the gas knob on the side */
        if (bay.top === 'pizza') {
          var pW = KP.PIZZA_W, pD = KP.PIZZA_D, pH = KP.PIZZA_H, pxc = g.kxc, pfy = 0.025, py0 = ybT + pfy, pmH = 0.09, pmW = pW - 0.16;
          for (k = 0; k < 4; k++) put(mk(0.04, pfy, 0.04, mats.kpDark, pxc + ((k & 1) ? 1 : -1) * (pD / 2 - 0.05), ybT + pfy / 2, bzc + ((k & 2) ? 1 : -1) * (pW / 2 - 0.05)), 'kp-pizza', null, 'pizza-foot-' + k + bid, 0, [0, 1, 0]);
          put(mk(pD, 0.07, pW, mats.kpOven, pxc, py0 + 0.035, bzc), 'kp-pizza', KP.PIZZA, 'pizza' + bid, 0, [0, 1, 0]);
          var dome = new T.Mesh(new T.CylinderGeometry(pW / 2, pW / 2, pD, 32, 1, false, 0, Math.PI), mats.kpOven);   /* the rounded top: a half cylinder front to back, flattened */
          dome.rotation.set(0, 0, Math.PI / 2);   /* the axis along X, the half up */
          dome.scale.set((pH - 0.07 - pmH) / (pW / 2), 1, 1);
          dome.position.set(pxc, py0 + 0.07 + pmH, bzc);
          put(dome, 'kp-pizza', null, 'pizza-dome' + bid, 0, [0, 1, 0]);
          for (k = -1; k <= 1; k += 2) put(mk(pD, pmH, (pW - pmW) / 2, mats.kpOven, pxc, py0 + 0.07 + pmH / 2, bzc + k * (pW / 2 - (pW - pmW) / 4)), 'kp-pizza', null, 'pizza-cheek' + k + bid, 0, [0, 1, 0]);
          put(mk(pD - 0.04, 0.012, pmW, mats.kpStone, pxc - 0.02, py0 + 0.07 + 0.006, bzc), 'kp-pizza', null, 'pizza-stone' + bid, 0, [0, 1, 0]);   /* the stone, the dark cavity over it 4 cm in */
          put(mk(pD - 0.04, pmH - 0.012, pmW, mats.kpHole, pxc - 0.02, py0 + 0.082 + (pmH - 0.012) / 2, bzc), 'kp-pizza', null, 'pizza-mouth' + bid, 0, [0, 1, 0]);
          var pkn = new T.Mesh(new T.CylinderGeometry(0.02, 0.02, 0.025, 14), mats.kpDark);
          pkn.rotation.x = Math.PI / 2;
          pkn.position.set(pxc - pD / 2 + 0.08, py0 + 0.12, bzc + pW / 2 + 0.0125);
          put(pkn, 'kp-pizza', null, 'pizza-knob' + bid, 0, [0, 1, 0]);
        }
      }
      /* v382 THE SERVICES: the boxes on the walls, the pipes and cables (a cylinder a leg, a ball at a pipe's corner), the gas valves,
         the bottle + regulator, the siphons, the taps' tails, the LED strip */
      if (!mats.kpBrass) mats.kpBrass = new T.MeshStandardMaterial({ color: 0xb8924f, roughness: 0.4, metalness: 0.55 });
      if (!mats.kpBoxG) mats.kpBoxG = new T.MeshStandardMaterial({ color: 0x8b9095, roughness: 0.6 });
      if (!mats.kpTank) mats.kpTank = new T.MeshStandardMaterial({ color: 0xe9e9e4, roughness: 0.45, metalness: 0.15 });
      if (!mats.kpLens) mats.kpLens = new T.MeshStandardMaterial({ color: 0xfff1d0, emissive: 0xffd99a, emissiveIntensity: 0.6, roughness: 0.3 });
      if (!mats.kpLed) mats.kpLed = new T.MeshStandardMaterial({ color: 0xfff6e0, emissive: 0xffe6b0, emissiveIntensity: 0.9, roughness: 0.4 });
      var RUNM = {
        gasline: mats.kpGasP || (mats.kpGasP = new T.MeshStandardMaterial({ color: 0xd8b13a, roughness: 0.5, metalness: 0.3 })),
        pex: mats.kpPex || (mats.kpPex = new T.MeshStandardMaterial({ color: 0x2f6fd6, roughness: 0.5 })),
        drain: mats.kpDrainM || (mats.kpDrainM = new T.MeshStandardMaterial({ color: 0x9aa0a6, roughness: 0.6 })),
        cable: mats.kpCable || (mats.kpCable = new T.MeshStandardMaterial({ color: 0x1b1c1e, roughness: 0.7 })),
        gashose: mats.kpHoseB || (mats.kpHoseB = new T.MeshStandardMaterial({ color: 0x2b2c2e, roughness: 0.6 })),
        flexi: mats.kpFlexi || (mats.kpFlexi = new T.MeshStandardMaterial({ color: 0xc3c7cb, roughness: 0.35, metalness: 0.5 }))
      };
      var SVC_FLY = { gasline: [0, 1, 0], pex: [0, -1, 0], drain: [0, -1, 0], cable: [-1, 0, 0], gashose: [1, 0, 0], flexi: [1, 0, 0] };
      function seg(a, b, r, mat) {
        var dx = b[0] - a[0], dy = b[1] - a[1], dz = b[2] - a[2], ln = Math.sqrt(dx * dx + dy * dy + dz * dz);
        var me = new T.Mesh(new T.CylinderGeometry(r, r, ln, 10), mat);
        me.position.set((a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2);
        me.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), new T.Vector3(dx / ln, dy / ln, dz / ln));
        return me;
      }
      (g.runs || []).forEach(function (rn) {
        for (var q = 1; q < rn.pts.length; q++) {
          if (Math.abs(rn.pts[q][0] - rn.pts[q - 1][0]) + Math.abs(rn.pts[q][1] - rn.pts[q - 1][1]) + Math.abs(rn.pts[q][2] - rn.pts[q - 1][2]) < 1e-6) continue;
          put(seg(rn.pts[q - 1], rn.pts[q], rn.r, RUNM[rn.kind]), 'kp-' + rn.kind, (q === 1) ? rn.code : null, rn.id + '-' + q, 0, SVC_FLY[rn.kind]);
        }
        if (rn.kind === 'gasline' || rn.kind === 'drain') for (var q2 = 1; q2 < rn.pts.length - 1; q2++) {
          var A = rn.pts[q2 - 1], B = rn.pts[q2], C = rn.pts[q2 + 1], u1 = [B[0] - A[0], B[1] - A[1], B[2] - A[2]], u2 = [C[0] - B[0], C[1] - B[1], C[2] - B[2]];
          var l1 = Math.sqrt(u1[0] * u1[0] + u1[1] * u1[1] + u1[2] * u1[2]), l2 = Math.sqrt(u2[0] * u2[0] + u2[1] * u2[1] + u2[2] * u2[2]);
          if (!(l1 > 1e-6 && l2 > 1e-6) || (u1[0] * u2[0] + u1[1] * u2[1] + u1[2] * u2[2]) / (l1 * l2) >= 0.9) continue;
          var ball = new T.Mesh(new T.SphereGeometry(rn.r * 1.45, 12, 8), (rn.kind === 'gasline') ? mats.kpBrass : RUNM.drain);
          ball.position.set(B[0], B[1], B[2]);
          put(ball, (rn.kind === 'gasline') ? 'kp-gaselbow' : 'kp-dbend', (rn.kind === 'gasline') ? KP.GASELBOW : KP.DBEND, rn.id + '-bend-' + q2, 0, SVC_FLY[rn.kind]);
        }
      });
      /* the boxes (pieces of the layout, drawn here) */
      g.pieces.forEach(function (pc) {
        if (!KP_SVC_BOX[pc.kind]) return;
        var b = pc.box, x0 = b[0] - b[3] / 2, x1 = b[0] + b[3] / 2;
        if (pc.kind === 'manifold') {
          put(mk(b[3], b[4], b[5], mats.kpBrass, b[0], b[1], b[2]), 'kp-manifold', pc.code, pc.id, 0, [0, 1, 0]);
        } else if (pc.kind === 'dropear') {
          put(mk(b[3], b[4], b[5], mats.kpBrass, b[0], b[1], b[2]), 'kp-dropear', pc.code, pc.id, 0, [1, 0, 0]);
        } else if (pc.kind === 'psu') {
          put(mk(b[3], b[4], b[5], mats.kpBoxG, b[0], b[1], b[2]), 'kp-psu', pc.code, pc.id, 0, [-1, 0, 0]);
        } else if (pc.kind === 'wlight') {
          put(mk(b[3] - 0.02, b[4], b[5], mats.phIron, b[0] - 0.01, b[1], b[2]), 'kp-wlight', pc.code, pc.id, 0, [1, 0, 0]);
          put(mk(0.02, b[4] - 0.03, b[5] - 0.03, mats.kpLens, x1 - 0.01, b[1], b[2]), 'kp-wlight', null, pc.id + '-lens', 0, [1, 0, 0]);
        } else {
          /* the junction box, the sockets, the switch: a grey body, the face a shade darker, a lid / rocker on it */
          put(mk(b[3] - 0.008, b[4], b[5], mats.kpBoxG, b[0] - 0.004, b[1], b[2]), 'kp-' + pc.kind, pc.code, pc.id, 0, [1, 0, 0]);
          put(mk(0.008, b[4] - 0.014, b[5] - 0.014, mats.kpDark, x1 - 0.004, b[1], b[2]), 'kp-' + pc.kind, null, pc.id + '-face', 0, [1, 0, 0]);
        }
      });
      /* the gas: a ball valve (lever) at each line's end, the bottle (body, shoulder, collar, foot) and its regulator */
      if (g.gas) {
        g.gas.lines.forEach(function (ln, n2) {
          put(mk(KP.VALVE_L, 0.028, 0.028, mats.kpBrass, ln.x, ln.y, ln.z), 'kp-gasvalve', KP.GASVALVE, 'gas-valve-' + (n2 + 1), 0, [0, 1, 0]);
          put(mk(0.012, 0.008, 0.06, mats.kpTrim, ln.x, ln.y + 0.018, ln.z + 0.04), 'kp-gasvalve', null, 'gas-valve-lever-' + (n2 + 1), 0, [0, 1, 0]);
        });
        var gb2 = g.gas, bod = gb2.h * 0.72;
        var tank = new T.Mesh(new T.CylinderGeometry(gb2.r, gb2.r, bod, 28), mats.kpTank);
        tank.position.set(gb2.x, gb2.y0 + 0.03 + bod / 2, gb2.z);
        put(tank, 'kp-bottle', KP.BOTTLE, 'gas-bottle', 0, [1, 0, 0]);
        var dome2 = new T.Mesh(new T.SphereGeometry(gb2.r, 28, 12, 0, Math.PI * 2, 0, Math.PI / 2), mats.kpTank);
        dome2.scale.set(1, 0.42, 1);
        dome2.position.set(gb2.x, gb2.y0 + 0.03 + bod, gb2.z);
        put(dome2, 'kp-bottle', null, 'gas-bottle-top', 0, [1, 0, 0]);
        var foot = new T.Mesh(new T.CylinderGeometry(gb2.r * 0.92, gb2.r * 0.92, 0.03, 28, 1, true), mats.kpTank);
        foot.position.set(gb2.x, gb2.y0 + 0.015, gb2.z);
        put(foot, 'kp-bottle', null, 'gas-bottle-foot', 0, [1, 0, 0]);
        var col = new T.Mesh(new T.CylinderGeometry(gb2.r * 0.55, gb2.r * 0.55, gb2.h - (0.03 + bod + gb2.r * 0.42) + 0.02, 24, 1, true), mats.kpTank);
        col.position.set(gb2.x, gb2.y0 + (0.03 + bod + gb2.r * 0.42 - 0.02 + gb2.h) / 2, gb2.z);
        put(col, 'kp-bottle', null, 'gas-bottle-collar', 0, [1, 0, 0]);
        var reg = new T.Mesh(new T.CylinderGeometry(0.03, 0.03, 0.02, 16), mats.kpDark);
        reg.position.set(gb2.x, gb2.y0 + gb2.h + 0.015, gb2.z);
        put(reg, 'kp-regulator', KP.REGULATOR, 'gas-regulator', 0, [1, 0, 0]);
        put(mk(0.03, 0.025, 0.03, mats.kpBrass, gb2.x, gb2.y0 + gb2.h - 0.0075, gb2.z), 'kp-regulator', null, 'gas-regulator-valve', 0, [1, 0, 0]);
      }
      /* the sinks' siphons (tailpiece + trap) and the taps' tails through the top */
      (g.sinkSvc || []).forEach(function (sv) {
        var tp = new T.Mesh(new T.CylinderGeometry(0.016, 0.016, 0.03, 14), RUNM.drain);
        tp.position.set(sv.skc, sv.yT1 - 0.015, sv.zc);
        put(tp, 'kp-siphon', KP.SIPHON, 'siphon-' + (sv.bay + 1), 0, [0, -1, 0]);
        var trap = new T.Mesh(new T.CylinderGeometry(0.035, 0.035, 0.08, 18), RUNM.drain);
        trap.position.set(sv.skc, sv.yT1 - 0.07, sv.zc);
        put(trap, 'kp-siphon', null, 'siphon-trap-' + (sv.bay + 1), 0, [0, -1, 0]);
        var tail = new T.Mesh(new T.CylinderGeometry(0.008, 0.008, g.yWt - (g.yWb - 0.054), 10), mats.kpInox);
        tail.position.set(sv.xTail, (g.yWt + g.yWb - 0.054) / 2, sv.zc);
        put(tail, 'kp-tap', null, 'tap-tail-' + (sv.bay + 1), 0, [0, 1, 0]);
      });
      if (g.led) put(mk(0.012, 0.003, g.led.len, mats.kpLed, g.led.x, g.led.y, (g.led.z0 + g.led.z1) / 2), 'kp-led', KP.LED, 'led-strip', 0, [0, -1, 0]);
      _peFieldsLast = g.discs;   /* v379 the bays' + discs on the worktop (BenchHandles._peDots) */
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'kp-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      try {
        var key = 'kp|' + Math.round(g.L * 1000) + '|' + (STATE.isMetric === false) + '|' + Math.round(g.ang / 5) + '|' + g.frame + '|' + g.bays.map(function (b) { return b.kind; }).join(',');
        if (key !== _kpLogKey) {
          _kpLogKey = key;
          var bq = global.BenchBoQ._computeKitchenPod(STATE);
          _dbg('[kp] kitchen pod ' + g.L.toFixed(3) + ' x ' + g.D.toFixed(3) + ' m, flap ' + ((g.ang > 0.5) ? 'OPEN ' + Math.round(g.ang) + ' deg' : 'shut') + ', counter frame ' + g.frame + ' (' + g.Wf.toFixed(3) + ' x ' + g.Hf.toFixed(3) + ', hinge line ' + g.xp.toFixed(3) + ' / ' + g.yp.toFixed(3) + ', ' + g.hinges + ' hinges, struts ' + g.struts.map(function (sv) { return sv.len.toFixed(3); }).join(' / ') + ' m)' +
               ', ' + g.gscrews.length + ' ground screws + U heads, base ' + g.yBB.toFixed(3) + '-' + g.yBt.toFixed(3) + ', ' + g.joists + ' joists, ' + g.hangers + ' hangers, deck ' + g.yF.toFixed(3) +
               ', header ' + g.yHb.toFixed(3) + '-' + g.yHt.toFixed(3) + ', back plate ' + g.yPB.toFixed(3) + ', ' + g.rafters + ' rafters ' + g.rafL.toFixed(2) + ' at ' + g.pitch + ' deg, ' + g.eStuds + ' end studs a wall' +
               ', OSB walls ' + g.sheathA.toFixed(2) + ' m2, cladding ' + g.cladA.toFixed(2) + ' m2 (' + g.nClad + ' rows), roof ' + g.roofA.toFixed(2) + ' m2 (' + g.seams + ' seams), drip ' + g.dripL.toFixed(2) + ' m' +
               ', counter top ' + g.yWt.toFixed(3) + ' (' + g.topL.toFixed(3) + ' m acacia), face ' + g.xFace.toFixed(3) + ', bays ' + g.bays.map(function (b) { return b.kind + (b.front ? ' (' + b.front + ')' : '') + ' ' + b.w.toFixed(3); }).join(', ') +
               ', services: gas ' + (g.gas ? g.gas.lines.length + ' line(s), bottle in bay ' + (g.gas.bay + 1) + (g.gas.cab < 0 ? ' (no cabinet)' : '') : 'none') + ', sinks ' + (g.sinkSvc || []).length + ', boxes ' + (g.devs || []).length + ', runs ' + (g.runs || []).map(function (rn) { return rn.id + ' ' + rn.len.toFixed(2); }).join(' / ') +
               ', ' + g.fas.length + ' fasteners; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[kp] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) { _dbg('[kp] log THREW ' + ((eL && eL.message) || eL)); }
    },
    _buildArbor: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _gaLayout(STATE), p = g.P.p, hp = p / 2, bt = GA.BASE_T, fl = GA.BASE_FLANGE;
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      /* v322 the ground screws' heads out of the ground (the rest below: billed, not drawn) and their flange plates (as v320) */
      for (i = 0; i < g.gscrews.length; i++) {
        var gs = g.gscrews[i];
        var tube = new T.Mesh(new T.CylinderGeometry(gs.r, gs.r, gs.y1 - 0.006, 16), mats.galv);
        tube.position.set(gs.x, (gs.y1 - 0.006) / 2, gs.z);
        tube.userData.flyDir = [0, -1, 0];
        self._addToScene(tube, 'ga-gscrew', { boqCode: GA.GSCREW, idHint: 'gscrew-' + gs.id });
        self._addToScene(self._mkBox(0.12, 0.006, 0.12, mats.galv, gs.x, gs.y1 - 0.003, gs.z), 'ga-gscrew', { idHint: 'gscrew-flange-' + gs.id });
      }
      /* v322 the deck blocks: a square frustum (a 4-sided cylinder turned 45 deg), the post standing in its socket */
      for (i = 0; i < g.blocks.length; i++) {
        var bkI = g.blocks[i], bkG = new T.CylinderGeometry(bkI.wt / Math.SQRT2, bkI.w / Math.SQRT2, bkI.y1 - bkI.y0, 4, 1);
        bkG.rotateY(Math.PI / 4);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bkI.x, (bkI.y0 + bkI.y1) / 2, bkI.z);
        bkM.userData.flyDir = [0, -1, 0];
        self._addToScene(bkM, 'ga-block', { boqCode: GA.BLOCK, idHint: bkI.id });
      }
      /* the pavers, their top just over the ground (the gravel under them: billed, not drawn) */
      for (i = 0; i < g.tiles.length; i++) {
        var tl = g.tiles[i], tm = self._mkBox(tl.w, tl.y1 - tl.y0, tl.w, mats.concrete, tl.x, (tl.y0 + tl.y1) / 2, tl.z);
        tm.userData.flyDir = [0, -1, 0];
        self._addToScene(tm, 'ga-tile', { boqCode: GA.TILE_CODE, idHint: tl.id });
      }
      /* the post bases: the foot plate on the paver, the stand-off, the saddle under the post, the two flanges up its faces
         (v322 a U head on a ground screw: no foot plate -- the stem in the screw's head) */
      for (i = 0; i < g.bases.length; i++) {
        var bs = g.bases[i];
        if (!bs.u) self._addToScene(self._mkBox(p, bt, GA.BASE_PL, mats.galv, bs.x, bs.y0 + bt / 2, bs.z), 'ga-base', { boqCode: GA.BASE, idHint: 'base-' + bs.id });
        var so = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, bs.y1 - bs.y0 - 2 * bt, 10), mats.galv);
        so.position.set(bs.x, (bs.y0 + bs.y1) / 2, bs.z);
        self._addToScene(so, 'ga-base', { idHint: 'base-stem-' + bs.id });
        self._addToScene(self._mkBox(p + 2 * bt, bt, p, mats.galv, bs.x, bs.y1 - bt / 2, bs.z), 'ga-base', bs.u ? { boqCode: GA.UHEAD, idHint: 'base-' + bs.id } : { idHint: 'base-saddle-' + bs.id });
        for (k = -1; k <= 1; k += 2) self._addToScene(self._mkBox(bt, fl, p, mats.galv, bs.x + k * (hp + bt / 2), bs.y1 + fl / 2 - bt, bs.z), 'ga-base', { idHint: 'base-flange-' + bs.id });
      }
      /* the timber: boxes, the polygons in their plane (xy: extruded along
         Z about c; zy: the shape in (z, y), extruded across X about c) */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m;
        if (pc.box) {
          var bx = pc.box;
          m = self._mkBox(bx[3], bx[4], bx[5], mats.lumber, bx[0], bx[1], bx[2]);
        } else {
          var sh = new T.Shape(), q;
          sh.moveTo(pc.poly[0][0], pc.poly[0][1]);
          for (q = 1; q < pc.poly.length; q++) sh.lineTo(pc.poly[q][0], pc.poly[q][1]);
          var ge = new T.ExtrudeGeometry(sh, { depth: pc.t, bevelEnabled: false, curveSegments: 2 });
          m = new T.Mesh(ge, mats.lumber);
          if (pc.plane === 'xy') { ge.translate(0, 0, -pc.t / 2); m.position.set(0, 0, pc.c); }
          else { ge.rotateY(-Math.PI / 2); m.position.set(pc.c + pc.t / 2, 0, 0); }
          m.userData.pgPoly = { pts: pc.poly, plane: pc.plane, c: pc.c, t: pc.t };   /* the harness's in-wood test */
        }
        if (/^(head|slat|plate|rafter|ridge|batten|arch)$/.test(pc.kind)) m.userData.flyDir = [0, 1, 0];   /* v331 + the arch */
        else if (pc.kind === 'lath' || pc.kind === 'grid') m.userData.flyDir = pc.box ? [(pc.box[0] < 0) ? -1 : 1, 0, 0] : [0, 1, 0];   /* v332 + the laths over the arch, v333 + the trellis */
        self._addToScene(m, 'ga-' + pc.kind, (pc.len > 0) ? { boqCode: pc.code, length: pc.len, idHint: pc.id } : { idHint: pc.id });
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'ga-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      try {
        var key = 'ga|' + g.mode + '|' + g.found + '|' + (g.grid ? 'grid|' : '') + Math.round(g.L * 1000) + '|' + Math.round(g.W * 1000) + '|' + (STATE.isMetric === false);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeArbor(STATE);
          _dbg('[ga] arbor ' + g.mode + ' ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (clear ' + g.clear.toFixed(3) + '), ' + g.zP.length + ' portals / ' + g.posts.length + ' posts on ' + ((g.found === 'screw') ? 'ground screws + U heads' : (g.found === 'block') ? 'deck blocks (in their sockets)' : 'pavers + post bases') + ', posts to ' + g.yPT.toFixed(3) + ', heads ' + g.headL.toFixed(2) + ' to ' + g.yHT.toFixed(3) + ', braces ' + g.brace.toFixed(3) + ' run, ' + g.laths + ' laths a side' +
               ((g.mode === 'gable') ? ', wall plates, ' + g.rafters + ' rafter pairs ' + g.rafL.toFixed(2) + ' at ' + g.deg + ' deg, ridge top ' + g.ridge.top.toFixed(3) + ', ' + g.battens + ' battens' : '') +
               (g.arch ? ', ' + g.zP.length + ' arches (semicircles r ' + g.arch.ri.toFixed(3) + '..' + g.arch.re.toFixed(3) + ' on the posts, laps ' + g.arch.lap.toFixed(3) + ') of ' + g.arch.n + ' + ' + (g.arch.n + 1) + ' pieces, blanks ' + g.arch.blankM.toFixed(2) + ' m an arch (the arc ' + g.arch.arcM.toFixed(2) + ' m, widest ' + Math.round(g.arch.maxW * 1000) + ' mm), ' + g.arch.lam + ' screws between the layers, ' + g.arch.laths + ' laths up, over and down' : '') + (g.grid ? ', trellis ' + g.grid.uprights + ' uprights ' + g.grid.len.toFixed(2) + ' + ' + g.grid.screws + ' screws' : '') + ', top ' + g.top.toFixed(3) + ', ' + g.fas.length + ' fasteners; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[ga] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v334 TYPE 24, GARDEN STRUCTURE 5 -- THE PERGOLA (_peLayout): the
       ground screws / footings, the bases, every timber piece lofted from
       its two faces, the covering, every screw and nail */
    _buildGardenPergola: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _peLayout(STATE), ut = PE.U_T, ufl = PE.U_FL;
      _peFieldsLast = g.fields;   /* the + buttons' places */
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      if (!mats.gzSeam) mats.gzSeam = new T.MeshStandardMaterial({ color: 0x5e646b, roughness: 0.5, metalness: 0.25 });
      if (!mats.gzCap) mats.gzCap = new T.MeshStandardMaterial({ color: 0x3a3d41, roughness: 0.9 });
      if (!mats.gzDrip) mats.gzDrip = new T.MeshStandardMaterial({ color: 0x5f6368, roughness: 0.5, metalness: 0.4 });
      function put(m, pt, code, id, len, fly) {
        var o = { idHint: id };
        if (code) { o.boqCode = code; if (len > 0) o.length = len; }
        if (fly) m.userData.flyDir = fly;
        self._addToScene(m, pt, o);
        return m;
      }
      /* a lofted piece: face A at nA, face B at nB (the same corners in order), the sides between them; flat-shaded */
      function loftMesh(pc, mat) {
        var pos = [], A = pc.A, B = pc.B, nn = A.length, j, U = pc.U, V = pc.V, N = pc.N, o = pc.o;
        function W(Pt, nv) { return [o[0] + U[0] * Pt[0] + V[0] * Pt[1] + N[0] * nv, o[1] + U[1] * Pt[0] + V[1] * Pt[1] + N[1] * nv, o[2] + U[2] * Pt[0] + V[2] * Pt[1] + N[2] * nv]; }
        function tri(a, b, c) { pos.push(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]); }
        var WA = A.map(function (Pt) { return W(Pt, pc.nA); }), WB = B.map(function (Pt) { return W(Pt, pc.nB); });
        var tris = T.ShapeUtils.triangulateShape(A.map(function (Pt) { return new T.Vector2(Pt[0], Pt[1]); }), []);
        tris.forEach(function (t3) {
          var a = A[t3[0]], b = A[t3[1]], c = A[t3[2]], ar = (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
          var i0 = t3[0], i1 = (ar >= 0) ? t3[1] : t3[2], i2 = (ar >= 0) ? t3[2] : t3[1];
          tri(WA[i0], WA[i2], WA[i1]);
          tri(WB[i0], WB[i1], WB[i2]);
        });
        for (j = 0; j < nn; j++) { var j2 = (j + 1) % nn; tri(WA[j], WA[j2], WB[j2]); tri(WA[j], WB[j2], WB[j]); }
        var ge = new T.BufferGeometry();
        ge.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
        ge.computeVertexNormals();
        var m = new T.Mesh(ge, mat);
        m.userData.gzLoft = { o: o, U: U, V: V, N: N, nA: pc.nA, nB: pc.nB, A: A, B: B };   /* the harness's in-wood test */
        return m;
      }
      /* the ground screws' heads out of the ground (the rest below: billed, not drawn) and their flange plates */
      for (i = 0; i < g.gscrews.length; i++) {
        var gs = g.gscrews[i], tube = new T.Mesh(new T.CylinderGeometry(gs.r, gs.r, gs.y1 - 0.006, 16), mats.galv);
        tube.position.set(gs.x, (gs.y1 - 0.006) / 2, gs.z);
        put(tube, 'pe-gscrew', PE.GSCREW, 'gscrew-' + gs.id, 0, [0, -1, 0]);
        put(self._mkBox(0.14, 0.006, 0.14, mats.galv, gs.x, gs.y1 - 0.003, gs.z), 'pe-gscrew', null, 'gscrew-flange-' + gs.id);
      }
      /* the precast footings (a frustum) and the poured footings' tops (10 cm up; the rest below: billed, not drawn) */
      for (i = 0; i < g.blocks.length; i++) {
        var bkI = g.blocks[i], bkG = new T.CylinderGeometry(bkI.wt / Math.SQRT2, bkI.w / Math.SQRT2, bkI.y1 - bkI.y0, 4, 1);
        bkG.rotateY(Math.PI / 4);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bkI.x, (bkI.y0 + bkI.y1) / 2, bkI.z);
        put(bkM, 'pe-block', PE.FOOTING, 'footing-' + bkI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < g.pours.length; i++) {
        var po = g.pours[i], poM = new T.Mesh(new T.BoxGeometry(po.w, po.y1 + 0.02, po.w), mats.concrete);
        poM.position.set(po.x, (po.y1 - 0.02) / 2, po.z);
        put(poM, 'pe-pour', PE.CONCRETE, 'footing-' + po.id, 0, [0, -1, 0]);
      }
      /* the bases: the saddle under the post, a flange up each X face, the stem (the precast footing's base: a foot plate) */
      for (i = 0; i < g.bases.length; i++) {
        var bs = g.bases[i], bw = bs.w, code = (bs.kind === 'block') ? PE.PBASE : (bs.kind === 'pier') ? PE.HANCHOR : PE.UHEAD;
        put(self._mkBox(bw + 2 * ut, ut, bw, mats.galv, bs.x, bs.y1 - ut / 2, bs.z), 'pe-base', code, 'base-' + bs.id);
        for (var sd = -1; sd <= 1; sd += 2) put(self._mkBox(ut, ufl, bw, mats.galv, bs.x + sd * (bw / 2 + ut / 2), bs.y1 - ut + ufl / 2, bs.z), 'pe-base', null, 'base-flange-' + bs.id);
        var stem = new T.Mesh(new T.CylinderGeometry(0.014, 0.014, bs.y1 - bs.y0 - ut, 10), mats.galv);
        stem.position.set(bs.x, (bs.y0 + bs.y1 - ut) / 2, bs.z);
        put(stem, 'pe-base', null, 'base-stem-' + bs.id);
        if (bs.kind === 'block') put(self._mkBox(bw + 0.02, ut, bw + 0.14, mats.galv, bs.x, bs.y0 + ut / 2, bs.z), 'pe-base', null, 'base-foot-' + bs.id);
      }
      /* the timber, the roof's layers */
      var MAT = { cover: mats.gzSeam, seam: mats.gzSeam, cap: mats.gzSeam, drip: mats.gzDrip };
      var AREA_CODE = { rboard: PE.RBOARD, cover: PE.SEAM, seam: null, cap: PE.CAP, drip: PE.DRIP };
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m = loftMesh(pc, MAT[pc.kind] || mats.lumber);
        var fly = (/^(beam|tie|frafter|ridge|hip|rafter|rboard|cover|seam|cap|drip)$/.test(pc.kind)) ? [0, 1, 0] : null;
        if (pc.roof) put(m, 'pe-' + pc.kind, AREA_CODE[pc.kind], pc.id, 0, fly);   /* billed by area / length in the bill */
        else put(m, 'pe-' + pc.kind, (pc.len > 0) ? pc.code : null, pc.id, pc.len, fly);
      }
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'pe-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      try {
        var fs = Object.keys(_peFields(STATE)).sort().map(function (k) { return k + _peFields(STATE)[k]; }).join('');
        var key = 'pe|' + g.roof + '|' + g.cov + '|' + g.fillT + '|' + g.found + '|' + Math.round(g.L * 1000) + '|' + Math.round(g.W * 1000) + '|' + (STATE.isMetric === false) + '|' + fs;
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeGardenPergola(STATE);
          var filled = g.fields.filter(function (F) { return F.state; }).map(function (F) { return F.id; });
          _dbg('[pe] pergola ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m, ' + g.posts.length + ' posts (' + (g.xs.length - 1) + ' x ' + (g.zs.length - 1) + ' bays) on ' +
               ((g.found === 'block') ? 'precast footings + post bases' : (g.found === 'pier') ? 'poured footings + H anchors' : 'ground screws + U heads') + ', beams ' + g.yPT.toFixed(3) + '..' + g.yBT.toFixed(3) + ', ' + g.braces + ' braces (' + g.braceRun.toFixed(2) + ' run), ' + g.ties + ' ties, roof ' + g.roof +
               (g.cov ? ' covered (' + g.roofA + ' m2, ' + g.seams + ' seams, caps ' + g.capL + ' m, drip ' + g.dripL + ' m' + (g.fall ? ', falls ' + g.fall + ' deg to the back' : '') + ')' : ' open') + ', ' + g.rafters + ' rafters at ' + g.rafSp.toFixed(3) + (g.hips ? ', ' + g.hips + ' hips, ridge ' + g.ridgeL.toFixed(2) : '') +
               ', infill ' + g.fillT + ' gap ' + Math.round(g.gap * 1000) + ' mm ' + (filled.length ? filled.join(' ') : 'none') + ' (' + g.stiles + ' stiles, ' + g.rails + ' rails, ' + g.fillPcs + ' members), top ' + g.top.toFixed(3) + ', ' + g.fas.length + ' fasteners drawn; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[pe] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v328 TYPE 23, GARDEN STRUCTURE 4 -- THE GAZEBO (_gzLayout): the ground
       screws' heads, the U heads, the joist hangers, every timber piece
       lofted from its two faces, the roof boards / shingles / hip caps /
       drip edge, every screw and nail */
    _buildGazebo: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _gzLayout(STATE), ut = GZ.U_T, ufl = GZ.U_FL;
      _peFieldsLast = g.fields;   /* v350 the sides' + / - discs (the pergola's) */
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.gzShingle) {
        /* v329 the shingles' texture: tiny's _shingleTex copied (the course bands + brick-offset tabs), its repeat 1:1 -- the UVs carry the real size */
        mats.gzShingle = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.92 });
        var gzTx = _gzShingleTex(0x6a6e74);
        if (gzTx) mats.gzShingle.map = gzTx; else mats.gzShingle.color.setHex(0x4a4d52);
      }
      if (!mats.gzSeam) mats.gzSeam = new T.MeshStandardMaterial({ color: 0x5e646b, roughness: 0.5, metalness: 0.25 });   /* v329 the standing seam (anthracite; no environment map, so little metalness) */
      if (!mats.concrete) mats.concrete = new T.MeshStandardMaterial({ color: 0xbdb9b2, roughness: 0.95 });
      if (!mats.gaBlock) mats.gaBlock = new T.MeshStandardMaterial({ color: 0xa8a49c, roughness: 0.95, flatShading: true });
      if (!mats.gzCap) mats.gzCap = new T.MeshStandardMaterial({ color: 0x3a3d41, roughness: 0.9 });
      if (!mats.gzDrip) mats.gzDrip = new T.MeshStandardMaterial({ color: 0x5f6368, roughness: 0.5, metalness: 0.4 });
      function put(m, pt, code, id, len, fly) {
        var o = { idHint: id };
        if (code) { o.boqCode = code; if (len > 0) o.length = len; }
        if (fly) m.userData.flyDir = fly;
        self._addToScene(m, pt, o);
        return m;
      }
      /* a lofted piece: face A at nA, face B at nB (the same corners in
         order), the sides between them; flat-shaded */
      function loftMesh(pc, mat) {
        var pos = [], A = pc.A, B = pc.B, nn = A.length, j, U = pc.U, V = pc.V, N = pc.N, o = pc.o;
        function W(Pt, nv) { return [o[0] + U[0] * Pt[0] + V[0] * Pt[1] + N[0] * nv, o[1] + U[1] * Pt[0] + V[1] * Pt[1] + N[1] * nv, o[2] + U[2] * Pt[0] + V[2] * Pt[1] + N[2] * nv]; }
        function tri(a, b, c) { pos.push(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]); }
        var WA = A.map(function (Pt) { return W(Pt, pc.nA); }), WB = B.map(function (Pt) { return W(Pt, pc.nB); });
        var tris = T.ShapeUtils.triangulateShape(A.map(function (Pt) { return new T.Vector2(Pt[0], Pt[1]); }), []);
        tris.forEach(function (t3) {
          var a = A[t3[0]], b = A[t3[1]], c = A[t3[2]], ar = (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
          var i0 = t3[0], i1 = (ar >= 0) ? t3[1] : t3[2], i2 = (ar >= 0) ? t3[2] : t3[1];
          tri(WA[i0], WA[i2], WA[i1]);   /* face A looks along -N */
          tri(WB[i0], WB[i1], WB[i2]);   /* face B along +N */
        });
        for (j = 0; j < nn; j++) { var j2 = (j + 1) % nn; tri(WA[j], WA[j2], WB[j2]); tri(WA[j], WB[j2], WB[j]); }
        var ge = new T.BufferGeometry();
        ge.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
        if (pc.uvS) {
          /* v329 a textured face: its (u, v) in metres times the texture's scale (the sides get 0, 0) */
          var uvs = [], k2;
          tris.forEach(function (t3) {
            var a = A[t3[0]], b = A[t3[1]], c = A[t3[2]], ar = (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
            var ix = [t3[0], (ar >= 0) ? t3[2] : t3[1], (ar >= 0) ? t3[1] : t3[2]], iy = [t3[0], (ar >= 0) ? t3[1] : t3[2], (ar >= 0) ? t3[2] : t3[1]];
            ix.forEach(function (q2) { uvs.push(A[q2][0] * pc.uvS[0], A[q2][1] * pc.uvS[1]); });
            iy.forEach(function (q2) { uvs.push(B[q2][0] * pc.uvS[0], B[q2][1] * pc.uvS[1]); });
          });
          for (k2 = 0; k2 < nn * 6; k2++) uvs.push(0, 0);
          ge.setAttribute('uv', new T.Float32BufferAttribute(uvs, 2));
        }
        ge.computeVertexNormals();
        var m = new T.Mesh(ge, mat);
        m.userData.gzLoft = { o: o, U: U, V: V, N: N, nA: pc.nA, nB: pc.nB, A: A, B: B };   /* the harness's in-wood test */
        return m;
      }
      /* a box in a frame (U, V, N about o): u0..u1, v0..v1, n0..n1 */
      function boxF(o, U, V, N, u0, u1, v0, v1, n0, n1, mat) {
        var m = new T.Mesh(new T.BoxGeometry(Math.abs(u1 - u0), Math.abs(v1 - v0), Math.abs(n1 - n0)), mat);
        var M4 = new T.Matrix4().makeBasis(new T.Vector3(U[0], U[1], U[2]), new T.Vector3(V[0], V[1], V[2]), new T.Vector3(N[0], N[1], N[2]));
        m.quaternion.setFromRotationMatrix(M4);
        var uc = (u0 + u1) / 2, vc = (v0 + v1) / 2, nc = (n0 + n1) / 2;
        m.position.set(o[0] + U[0] * uc + V[0] * vc + N[0] * nc, o[1] + U[1] * uc + V[1] * vc + N[1] * nc, o[2] + U[2] * uc + V[2] * vc + N[2] * nc);
        return m;
      }
      /* the ground screws' heads out of the ground (the rest below: billed, not drawn) and their flange plates */
      for (i = 0; i < g.gscrews.length; i++) {
        var gs = g.gscrews[i];
        var tube = new T.Mesh(new T.CylinderGeometry(gs.r, gs.r, gs.y1 - 0.006, 16), mats.galv);
        tube.position.set(gs.x, (gs.y1 - 0.006) / 2, gs.z);
        put(tube, 'gz-gscrew', GZ.GSCREW, 'gscrew-' + gs.id, 0, [0, -1, 0]);
        put(self._mkBox(0.12, 0.006, 0.12, mats.galv, gs.x, gs.y1 - 0.003, gs.z), 'gz-gscrew', null, 'gscrew-flange-' + gs.id);
      }
      /* v329 the deck blocks (the arbor's frustum, turned to the member) and the poured footings' tops (10 cm up; the rest below: billed, not drawn) */
      for (i = 0; i < g.blocks.length; i++) {
        var bkI = g.blocks[i], bkG = new T.CylinderGeometry(bkI.wt / Math.SQRT2, bkI.w / Math.SQRT2, bkI.y1 - bkI.y0, 4, 1);
        bkG.rotateY(Math.PI / 4 - bkI.a);
        var bkM = new T.Mesh(bkG, mats.gaBlock);
        bkM.position.set(bkI.x, (bkI.y0 + bkI.y1) / 2, bkI.z);
        put(bkM, 'gz-block', GZ.BLOCK, 'block-' + bkI.id, 0, [0, -1, 0]);
      }
      for (i = 0; i < g.pours.length; i++) {
        var po = g.pours[i], poM = new T.Mesh(new T.BoxGeometry(po.w, po.y1 + 0.02, po.w), mats.concrete);
        poM.rotation.y = -po.a;
        poM.position.set(po.x, (po.y1 - 0.02) / 2, po.z);
        put(poM, 'gz-pour', GZ.CONCRETE, 'footing-' + po.id, 0, [0, -1, 0]);
      }
      /* the U heads: the saddle under the member, the stem, a flange up each face (v329 or the footing's wet-set U anchor) */
      for (i = 0; i < g.uheads.length; i++) {
        var uh = g.uheads[i], nf = [Math.cos(uh.a), 0, Math.sin(uh.a)], na = [-Math.sin(uh.a), 0, Math.cos(uh.a)], oU = [uh.x, 0, uh.z], UPv = [0, 1, 0];
        var hl = 0.05;
        put(boxF(oU, nf, UPv, na, -(uh.w / 2 + ut), uh.w / 2 + ut, uh.y1 - ut, uh.y1, -hl, hl, mats.galv), 'gz-uhead', uh.wet ? GZ.UANCHOR : GZ.UHEAD, 'uhead-' + uh.id);
        var stem = new T.Mesh(new T.CylinderGeometry(0.012, 0.012, uh.y1 - uh.y0 - ut, 10), mats.galv);
        stem.position.set(uh.x, (uh.y0 + uh.y1 - ut) / 2, uh.z);
        put(stem, 'gz-uhead', null, 'uhead-stem-' + uh.id);
        for (var sd = -1; sd <= 1; sd += 2) {
          var x0 = sd * (uh.w / 2), x1 = sd * (uh.w / 2 + ut);
          put(boxF(oU, nf, UPv, na, Math.min(x0, x1), Math.max(x0, x1), uh.y1 - ut, uh.y1 - ut + ufl, -hl, hl, mats.galv), 'gz-uhead', null, 'uhead-flange-' + uh.id);
        }
      }
      /* the joist hangers: the seat under the joist, a side up each face, a flange on the header each side */
      var hT = GZ.HANG_T, hL = GZ.HANG_L;
      for (i = 0; i < g.hangers.length; i++) {
        var hg = g.hangers[i], u0 = hg.u - hg.sg * hL, u1 = hg.u, ua = Math.min(u0, u1), ub = Math.max(u0, u1), hw2 = hg.w / 2;
        put(boxF(hg.o, hg.U, hg.V, hg.N, ua, ub, hg.y0 - hT, hg.y0, -(hw2 + hT), hw2 + hT, mats.galv), 'gz-hanger', GZ.HANGER, 'hanger-' + hg.id);
        for (var s2 = -1; s2 <= 1; s2 += 2) {
          put(boxF(hg.o, hg.U, hg.V, hg.N, ua, ub, hg.y0, hg.y0 + hg.h, s2 * hw2, s2 * (hw2 + hT), mats.galv), 'gz-hanger', null, 'hanger-side-' + hg.id);
          var uf0 = hg.u - hg.sg * hT;
          put(boxF(hg.o, hg.U, hg.V, hg.N, Math.min(uf0, hg.u), Math.max(uf0, hg.u), hg.y0, hg.y0 + hg.h, s2 * (hw2 + hT), s2 * (hw2 + 0.035), mats.galv), 'gz-hanger', null, 'hanger-flange-' + hg.id);
        }
      }
      /* the timber, the roof's layers */
      var seamC = (g.cov === 'seam');
      var MAT = { cover: seamC ? mats.gzSeam : mats.gzShingle, seam: mats.gzSeam, cap: seamC ? mats.gzSeam : mats.gzShingle, drip: mats.gzDrip };   /* v330 the shingle caps in the shingles' texture */
      var AREA_CODE = { rboard: GZ.RBOARD, cover: seamC ? GZ.SEAM : GZ.SHINGLE, seam: null, cap: seamC ? GZ.HIP_CAP : GZ.SHINGLE, drip: GZ.DRIP };
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], m = loftMesh(pc, MAT[pc.kind] || mats.lumber);
        var fly = (/^(plate|hip|jack|hub|rboard|cover|seam|cap|drip)$/.test(pc.kind)) ? [0, 1, 0] : null;
        if (pc.roof) put(m, 'gz-' + pc.kind, AREA_CODE[pc.kind], pc.id, 0, fly);   /* billed by area / length in the bill */
        else put(m, 'gz-' + pc.kind, (pc.len > 0) ? pc.code : null, pc.id, pc.len, fly);
      }
      /* the apex cap: a low pyramid over the hips' meeting (its edges on the hips) */
      var rCp = 0.14, aTa = Math.tan(GZ.PITCH * Math.PI / 180), hCp = rCp * Math.tan(36 * Math.PI / 180);   /* v330 wider: over the caps' meeting */
      var cone = new T.Mesh(new T.CylinderGeometry(0.004, rCp, hCp, g.n, 1, false, Math.PI / 2 - g.th0), seamC ? mats.gzSeam : mats.gzShingle);   /* v330 the shingle roof's in shingle */
      cone.position.set(0, g.apexTop - rCp * Math.cos(Math.PI / g.n) * aTa + hCp / 2 + 0.003 + (seamC ? GZ.SEAM_H : 0), 0);
      put(cone, 'gz-cap', null, 'apex-cap', 0, [0, 1, 0]);
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'gz-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      try {
        var key = 'gz|' + g.n + '|' + Math.round(g.S * 1000) + '|' + (STATE.isMetric === false) + '|' + g.found + '|' + g.cov + '|' + g.fill + '|' + Math.round(g.gap * 1000) + '|' + g.fields.map(function (F) { return F.state; }).join('');
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeGazebo(STATE);
          _dbg('[gz] gazebo ' + g.n + ' sides ' + g.S.toFixed(3) + ' m across the flats (x ' + g.W.toFixed(3) + '), ' + g.posts.length + ' posts + ' + (g.piers.length - g.posts.length) + ' piers on ' + ((g.found === 'block') ? 'precast pads (deck blocks)' : (g.found === 'pier') ? 'poured footings + wet-set U anchors' : 'ground screws + U heads') + ', deck top ' + g.yD.toFixed(3) +
               ', ' + ((g.cov === 'seam') ? 'standing seam (' + g.seams + ' seams)' : 'asphalt shingle') + ', infill ' + ((g.fill === 'board') ? '1x4 boards' : '2x2 slats') + ' gap ' + Math.round(g.gap * 1000) + ' (' + Math.round(g.gapReal * 1000) + ' real)' +
               ', ' + g.joists + ' joists in ' + g.hangers.length + ' hangers, ' + g.boards + ' boards / ' + g.deckScrews + ' screws, plates ' + g.yPT.toFixed(3) + '..' + g.yT.toFixed(3) +
               ', ' + g.hips + ' hips + ' + g.jacks + ' jacks at ' + g.jackSp.toFixed(3) + ', ' + g.pitch + ' deg, apex ' + g.apex.toFixed(3) + ', roof ' + g.roofA + ' m2, ' + g.rails + ' rails, ' + g.balusters + ' balusters, full height ' + (g.fields.filter(function (F) { return F.state; }).map(function (F) { return F.id; }).join(' ') || 'none') + ' (entrance gz1 ' + (g.fields[0].state ? 'closed' : 'open') + '), top ' + g.top.toFixed(3) + ', ' + g.fas.length + ' fasteners drawn; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[gz] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    /* v318 TYPE 21, BENCHES & LOUNGE -- THE FLOATING BED (_fbLayout): the
       frame + legs (black), the ash panels + headboard, the laths, the
       nightstands + drawers, every screw + anchor, the brackets / slides /
       LED / supply / plates, the slatted bases, the mattress */
    _buildFloatingBed: function () {
      var T = global.THREE, mats = this.materials, self = this, i, k;
      var g = _fbLayout(STATE);
      if (!mats.galv) mats.galv = new T.MeshStandardMaterial({ color: 0xa9adb2, roughness: 0.45, metalness: 0.35 });
      if (!mats.fbBlack) mats.fbBlack = new T.MeshStandardMaterial({ color: 0x1c1c1c, roughness: 0.6 });
      if (!mats.fbPly) mats.fbPly = new T.MeshStandardMaterial({ color: 0xe2cfa4, roughness: 0.8 });
      if (!mats.fbHdf) mats.fbHdf = new T.MeshStandardMaterial({ color: 0x8a6a4a, roughness: 0.9 });
      if (!mats.fbBase) mats.fbBase = new T.MeshStandardMaterial({ color: 0xd9c08c, roughness: 0.75 });
      if (!mats.fbAlu) mats.fbAlu = new T.MeshStandardMaterial({ color: 0xc9ccd0, roughness: 0.35, metalness: 0.6 });
      if (!mats.fbLed) mats.fbLed = new T.MeshStandardMaterial({ color: 0xfff1d6, emissive: 0xffd9a0, emissiveIntensity: 0.9, roughness: 0.4 });
      if (!mats.fbPlate) mats.fbPlate = new T.MeshStandardMaterial({ color: 0xf4f4f2, roughness: 0.5 });
      if (!mats.fbDark) mats.fbDark = new T.MeshStandardMaterial({ color: 0x55585c, roughness: 0.5 });
      if (!mats.mattWhite) mats.mattWhite = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.96, metalness: 0.0, emissive: 0xffffff, emissiveIntensity: 0.55 });
      function put(m, pt, code, id, len) { var o = { idHint: id }; if (code) { o.boqCode = code; if (len > 0) o.length = len; } self._addToScene(m, pt, o); return m; }
      /* the timber */
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], bx = pc.box;
        var mat = pc.black ? mats.fbBlack : (pc.kind === 'drawer') ? mats.fbPly : (pc.kind === 'hdf') ? mats.fbHdf : mats.lumber;
        var m = self._mkBox(bx[3], bx[4], bx[5], mat, bx[0], bx[1], bx[2]);
        if (/^(panel|head|ns|front|lath)$/.test(pc.kind)) m.userData.flyDir = (pc.kind === 'lath' || pc.kind === 'head') ? [0, 0, -1] : [0, 1, 0];
        put(m, 'fb-' + pc.kind, (pc.len > 0) ? pc.code : null, pc.id, pc.len);
      }
      /* the fasteners (confirmats + the wall anchors' heads included) */
      for (i = 0; i < g.fas.length; i++) {
        var f = g.fas[i];
        self._addFastener(f, 'fb-hw-' + f.kind, f.code || null, f.kind + '-' + (i + 1));
      }
      /* the hardware drawn as boxes */
      for (i = 0; i < g.hwb.length; i++) {
        var hb = g.hwb[i], hx = hb.box;
        var hm = (hb.kind === 'led') ? mats.fbAlu : (hb.kind === 'psu') ? mats.fbDark : mats.galv;
        put(self._mkBox(hx[3], hx[4], hx[5], hm, hx[0], hx[1], hx[2]), 'fb-hw-' + hb.kind, (hb.kind === 'psu') ? FB.PSU : null, hb.id);
        if (hb.kind === 'led') {   /* the strip's glow along the profile's open face */
          var gl = self._mkBox(Math.max(0.002, hx[3] - 0.004), Math.max(0.002, hx[4] - 0.004), 0.001, mats.fbLed, hx[0], hx[1], hx[2] - hx[5] / 2 - 0.0006);
          put(gl, 'fb-hw-led', FB.LED, hb.id + '-strip');
        }
      }
      /* the 2-gang plates: a socket + a switch over each nightstand */
      for (i = 0; i < g.plates.length; i++) {
        var pt = g.plates[i];
        put(self._mkBox(FB.PLATE_W, FB.PLATE_H, 0.008, mats.fbPlate, pt.x, pt.y, pt.z + 0.004), 'fb-hw-plate', null, 'plate-' + pt.sd);
        put(self._mkBox(0.05, 0.05, 0.004, mats.fbPlate, pt.x - 0.036, pt.y, pt.z + 0.010), 'fb-hw-plate', FB.SOCKET, 'socket-' + pt.sd);
        put(self._mkBox(0.05, 0.05, 0.004, mats.fbPlate, pt.x + 0.036, pt.y, pt.z + 0.010), 'fb-hw-plate', FB.SWITCH, 'switch-' + pt.sd);
        for (k = -1; k <= 1; k += 2) {   /* the socket's pins, the rocker */
          put(self._mkBox(0.004, 0.004, 0.002, mats.fbDark, pt.x - 0.036 + k * 0.01, pt.y, pt.z + 0.013), 'fb-hw-plate', null, 'socket-pin-' + pt.sd + k);
        }
        put(self._mkBox(0.02, 0.03, 0.003, mats.fbPlate, pt.x + 0.036, pt.y, pt.z + 0.0135), 'fb-hw-plate', null, 'switch-rocker-' + pt.sd);
      }
      /* the slatted bases: a frame of 4 rails + the slats across */
      for (i = 0; i < g.bases.length; i++) {
        var bs = g.bases[i], bw = bs.x1 - bs.x0, bc = (bs.x0 + bs.x1) / 2, bh = g.yB - g.yF, rl = g.zF - g.zH, zc = (g.zH + g.zF) / 2, rw = 0.035;
        for (k = -1; k <= 1; k += 2) {
          put(self._mkBox(rw, bh, rl, mats.fbBase, bc + k * (bw / 2 - rw / 2), g.yF + bh / 2, zc), 'fb-hw-base', null, 'base-' + i + '-rail' + k);
          put(self._mkBox(bw - 2 * rw, bh, rw, mats.fbBase, bc, g.yF + bh / 2, zc + k * (rl / 2 - rw / 2)), 'fb-hw-base', null, 'base-' + i + '-end' + k);
        }
        var nS = Math.max(8, Math.round((rl - 2 * rw) / 0.075));
        for (k = 0; k < nS; k++) put(self._mkBox(bw - 2 * rw, 0.008, 0.05, mats.fbBase, bc, g.yB - 0.004, g.zH + rw + (rl - 2 * rw) * (k + 0.5) / nS), 'fb-hw-base', null, 'base-' + i + '-slat' + k);
      }
      /* the mattress */
      var mt = self._mkCushion(g.matt.w, g.matt.l, g.matt.t, mats.mattWhite);
      mt.position.set(0, g.matt.y + g.matt.t / 2, (g.zH + g.zF) / 2);
      self._addToScene(mt, 'fb-mattress', { boqCode: FB.MATT, idHint: 'fb-mattress' });
      try {
        var key = 'fb|' + Math.round(g.Wm * 1000) + '|' + (STATE.isMetric === false);
        if (key !== _porchLogKey) {
          _porchLogKey = key;
          var bq = global.BenchBoQ._computeFloatingBed(STATE);
          _dbg('[fb] floating bed ' + g.size.n + ': ' + g.W.toFixed(3) + ' x ' + g.L.toFixed(3) + ' x ' + g.top.toFixed(3) + ' m, frame top ' + g.yF.toFixed(3) + ', panels to ' + g.ySide.toFixed(3) + ', mattress top ' + g.yM.toFixed(3) + ', ' + g.fas.length + ' fasteners drawn, ' + g.anchors + ' wall anchors, LED ' + g.ledM + ' m; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var bv = bq.byMaterial[c]; return c + ' ' + (bv % 1 ? bv.toFixed(2) : bv); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[fb] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eL) {}
    },
    _buildSunbed: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _sbLayout(STATE);
      for (i = 0; i < g.pieces.length; i++) {
        var pc = g.pieces[i], b = pc.box, m;
        if (pc.nz && pc.nz.length) {
          /* v291 a notched piece (the racks): its side profile in (local z =
             along, y = up), the notches cut in its top edge (nTop) or its
             bottom; extruded across (local x), centred */
          var Lh = b[5] / 2, hb = b[4] / 2, nd = pc.nd, sh = new T.Shape(), zs = pc.nz.slice().sort(function (x, y) { return x[0] - y[0]; }), q;
          if (pc.nTop) {
            sh.moveTo(-Lh, -hb); sh.lineTo(Lh, -hb); sh.lineTo(Lh, hb);
            for (q = zs.length - 1; q >= 0; q--) { sh.lineTo(zs[q][1], hb); sh.lineTo(zs[q][1], hb - nd); sh.lineTo(zs[q][0], hb - nd); sh.lineTo(zs[q][0], hb); }
            sh.lineTo(-Lh, hb); sh.lineTo(-Lh, -hb);
          } else {
            sh.moveTo(-Lh, -hb);
            for (q = 0; q < zs.length; q++) { sh.lineTo(zs[q][0], -hb); sh.lineTo(zs[q][0], -hb + nd); sh.lineTo(zs[q][1], -hb + nd); sh.lineTo(zs[q][1], -hb); }
            sh.lineTo(Lh, -hb); sh.lineTo(Lh, hb); sh.lineTo(-Lh, hb); sh.lineTo(-Lh, -hb);
          }
          var geo = new T.ExtrudeGeometry(sh, { depth: b[3], bevelEnabled: false, curveSegments: 1 });
          geo.translate(0, 0, -b[3] / 2);
          geo.rotateY(-Math.PI / 2);   /* shape x -> local z, the extrusion -> local x */
          m = new T.Mesh(geo, mats.lumber);
          m.position.set(b[0], b[1], b[2]);
          m.userData.sbNotched = { L: b[5], h: b[4], w: b[3], nz: zs, nd: nd, top: !!pc.nTop };
        } else if (pc.roundTop) {
          /* v291 a prop: from its bolt (local 0) along local +z to its foot
             (Lf), the top end a half round about the bolt; extruded across */
          var hp = b[4] / 2, shp = new T.Shape();
          shp.moveTo(0, -hp); shp.lineTo(pc.Lf, -hp); shp.lineTo(pc.Lf, hp); shp.lineTo(0, hp);
          shp.absarc(0, 0, hp, Math.PI / 2, 3 * Math.PI / 2, false);
          var gp = new T.ExtrudeGeometry(shp, { depth: b[3], bevelEnabled: false, curveSegments: 10 });
          gp.translate(0, 0, -b[3] / 2);
          gp.rotateY(-Math.PI / 2);
          m = new T.Mesh(gp, mats.lumber);
          m.position.set(b[0], b[1], b[2]);
          m.userData.sbProp = { Lf: pc.Lf, w: b[3], h: b[4] };
        } else {
          m = self._mkBox(b[3], b[4], b[5], mats.lumber, b[0], b[1], b[2]);
        }
        if (pc.rot) m.rotation.x = pc.rot;
        self._addToScene(m, 'sb-' + pc.kind, { boqCode: pc.code, length: pc.len, idHint: pc.id });
      }
      for (i = 0; i < g.fas.length; i++) self._addFastener(g.fas[i], 'sb-hw-' + g.fas[i].kind, g.fas[i].code, g.fas[i].id);
      try {
        var key = Math.round(g.iW * 1000) + '|' + g.ang + '|' + g.kid + '|' + (STATE.isMetric === false);
        if (key !== _sbLogKey) {
          _sbLogKey = key;
          var bq = global.BenchBoQ._computeSunbed(STATE);
          _dbg('[sb] sunbed ' + (g.kid ? 'kids' : 'adult') + (g.dbl ? ' two bays' : ' ONE bay') + ' ' + g.L.toFixed(3) + ' x ' + g.W.toFixed(3) + ' m (lying ' + g.iL.toFixed(3) + ' x ' + g.iW.toFixed(3) + '), backrest ' + g.ang + ' deg (' + g.Lb.toFixed(3) + ' long, head ' + g.headTop.toFixed(3) + ' up), ' +
               g.nF + ' + ' + g.nB + ' slats, ' + g.nLeg + ' legs (frame ' + Math.round(g.Y0 * 1000) + ' mm up), props ' + g.lp.toFixed(3) + ' hung ' + g.dP.toFixed(3) + ' from the hinge, ' + Math.round(g.psi * 180 / Math.PI) + ' deg under the level, rack notches ' + Object.keys(g.notchS).map(function (k) { return k + '@' + g.notchS[k].toFixed(3); }).join(' ') + (g.notchesOk ? '' : ' (A NOTCH OFF THE RACK / NO TOOTH / FOLDED PROP TOO LONG)') + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[sb] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eS) {}
    },

    /* THE STAND of a _swingStand layout g (types 4, 8, 13): the X-frame
       legs as their lapped pieces, the beam with its end cuts, the crossing
       bolt heads, the rails, the knee braces cut to the legs and the beam. */
    _drawSwingStand: function (g) {
      var T = global.THREE, mats = this.materials, self = this, P = g.P, i, k;
      function poly(pts, depth, mat) {
        var sh = new T.Shape();
        sh.moveTo(pts[0][0], pts[0][1]);
        for (var q = 1; q < pts.length; q++) sh.lineTo(pts[q][0], pts[q][1]);
        var geo = new T.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: false, curveSegments: 2 });
        geo.translate(0, 0, -depth / 2);
        return new T.Mesh(geo, mat);
      }
      /* STAND -- legs 2.02 (X-frames), the beam let into the crossing. */
      for (i = 0; i < g.legs.length; i++) {
        var lg = g.legs[i], pc;
        /* one leg = its pieces (the half-lap halves, the rail pocket cut in);
           the first piece carries the instance, the rest are tagged only */
        for (pc = 0; pc < lg.pieces.length; pc++) {
          var pce = lg.pieces[pc];
          var leg = poly(pce.pts, pce.z1 - pce.z0, mats.lumber);
          leg.position.set(0, 0, lg.z + (pce.z0 + pce.z1) / 2);
          if (pc === 0) self._addToScene(leg, 'swing-leg', { boqCode: SWING.LEG_CODE, length: lg.len, idHint: 'leg-' + (i + 1) });
          else { self._tag(leg, 'swing-leg'); leg.userData.boqCode = SWING.LEG_CODE; self._addEdges(leg); global.BenchEngine.benchGroup.add(leg); }
        }
      }
      /* beam 2.01 with the decorative end cuts of the GLB (SWING_BEAM_END):
         the leaning end face, the cove, the shoulder back to full depth */
      var bl2 = g.beamLen / 2, yb0 = g.beamBot, yb1 = g.beamBot + P.beamH, bpts = [], bq, be;
      bpts.push([-bl2, yb1], [bl2, yb1]);
      for (bq = 0; bq < SWING_BEAM_END.length; bq++) { be = SWING_BEAM_END[bq]; bpts.push([bl2 - be[0], yb0 + P.beamH * be[1]]); }
      for (bq = SWING_BEAM_END.length - 1; bq >= 0; bq--) { be = SWING_BEAM_END[bq]; bpts.push([-bl2 + be[0], yb0 + P.beamH * be[1]]); }
      var bsh = new T.Shape();
      bsh.moveTo(bpts[0][0], bpts[0][1]);
      for (bq = 1; bq < bpts.length; bq++) bsh.lineTo(bpts[bq][0], bpts[bq][1]);
      var bgeo = new T.ExtrudeGeometry(bsh, { depth: P.beamW, bevelEnabled: false, curveSegments: 2 });
      bgeo.translate(0, 0, -P.beamW / 2);
      bgeo.rotateY(Math.PI / 2);   /* the profile runs along Z */
      var beam = new T.Mesh(bgeo, mats.lumber);
      self._addToScene(beam, 'swing-beam', { boqCode: SWING.BEAM_CODE, length: g.beamLen, idHint: 'beam' });
      /* the crossing bolt heads, both faces */
      for (i = 0; i < g.legs.length; i += 2) {
        for (var f0 = -1; f0 <= 1; f0 += 2) {
          var bh = new T.Mesh(new T.CylinderGeometry(0.009, 0.009, 0.008, 6), mats.metal);
          bh.rotation.x = Math.PI / 2;
          bh.position.set(0, g.yX, g.legs[i].z + f0 * (P.leg / 2 + 0.004));
          self._addToScene(bh, 'swing-hw-bolt', { boqCode: SWING.CAPNUT_CODE });   /* the M16 rod's cap nuts */
        }
      }
      /* cross rails 2.03 between the legs */
      for (i = 0; i < g.rails.length; i++) {
        var rl = g.rails[i];
        var rail = self._mkBox(rl.len, P.leg, P.leg, mats.lumber, 0, rl.y, rl.z);
        self._addToScene(rail, 'swing-rail', { boqCode: SWING.RAIL_CODE, length: rl.len, idHint: 'rail-' + (i + 1) });
      }
      /* knee braces 2.04 along the beam: the cut polygon (z, y) extruded
         across x, on the beam's face */
      for (i = 0; i < g.braces.length; i++) {
        var br = g.braces[i], bsh2 = new T.Shape();
        bsh2.moveTo(br.pts[0][0], br.pts[0][1]);
        for (k = 1; k < br.pts.length; k++) bsh2.lineTo(br.pts[k][0], br.pts[k][1]);
        var bgeo2 = new T.ExtrudeGeometry(bsh2, { depth: P.braceT, bevelEnabled: false, curveSegments: 1 });
        bgeo2.translate(0, 0, -P.braceT / 2);
        bgeo2.rotateY(-Math.PI / 2);                                   /* shape x -> world z, extrusion -> world x */
        var bx = new T.Mesh(bgeo2, mats.lumber);
        bx.position.x = br.x;
        bx.userData.flyDir = [0, -1, 0];                                   /* v264: the knee braces up from below */
        self._addToScene(bx, 'swing-brace', { boqCode: SWING.BRACE_CODE, length: br.len, idHint: 'brace-' + (i + 1) });
      }
      /* v264 THE STAND'S SCREWS, drawn (the bill counts the same rules,
         _swingStandBoQ): the beam into each crossing 8x260 (2), the rails
         through the legs' outer edges into their ends 8x180 (2 an end), the
         knee braces 8x160 into the leg (2) + 6x80 into the beam (1) */
      var thS = SWING.LEG_ANGLE * Math.PI / 180, ctS = 1 / Math.tan(thS);
      for (i = 0; i < g.legs.length; i += 2) for (k = -1; k <= 1; k += 2)
        self._addFastener({ x: k * 0.025, y: g.beamTop, z: g.legs[i].z, dir: [0, -1, 0], len: 0.26, r: 0.004 }, 'swing-hw-screw-beam', SWING.BEAM_SCREW, 'beam-screw');
      for (i = 0; i < g.rails.length; i++) {
        var rlS = g.rails[i];
        for (k = -1; k <= 1; k += 2) {
          var xO = k * (SWING.FOOT_HALF - ctS * rlS.y + g.wh / 2);
          for (var q2 = -1; q2 <= 1; q2 += 2)
            self._addFastener({ x: xO, y: rlS.y + q2 * 0.025, z: rlS.z, dir: [-k, 0, 0], len: 0.18, r: 0.004 }, 'swing-hw-screw-rail', SWING.LEG_SCREW, 'rail-screw');
        }
      }
      for (i = 0; i < g.braces.length; i++) {
        var brS = g.braces[i], dzS = (brS.z1 - brS.z0) / brS.axisLen, dyS = (brS.y1 - brS.y0) / brS.axisLen, sgz = (brS.z0 < 0) ? -1 : 1;
        var dK = [0, 0.30, sgz * -0.95], lK = Math.sqrt(dK[1] * dK[1] + dK[2] * dK[2]);
        for (k = -1; k <= 1; k += 2)
          self._addFastener({ x: brS.x + k * 0.012, y: brS.y0 + dyS * 0.09 - 0.012, z: brS.z0 + dzS * 0.09, dir: [0, -dK[1] / lK, -dK[2] / lK], len: 0.16, r: 0.004 }, 'swing-hw-screw-knee', SWING.KNEE_SCREW, 'knee-screw');
        var sxB = (brS.x < 0) ? -1 : 1;
        self._addFastener({ x: brS.x + sxB * P.braceT / 2, y: g.beamBot + P.beamH * 0.3, z: brS.z1 - dzS * 0.05, dir: [-sxB, 0, 0], len: 0.08 }, 'swing-hw-screw-knee', SWING.KNEE_SCREW2, 'knee-screw-beam');
      }
    },
    /* ----------------------------------------------------------
       VARIANT 4 - Hollywood swing. Draws _swingLayout(STATE) as it is;
       the BoQ sums the same layout. Coordinates as the wave bench:
       X = depth (back -, front +), Y = up, Z = width.
       ---------------------------------------------------------- */
    _buildSwing: function () {
      var T = global.THREE, mats = this.materials, self = this;
      var fr = ((STATE.variant | 0) === 8);   /* the A-frame swing: this stand + roof, the porch seat */
      var g = fr ? _frameLayout(STATE) : _swingLayout(STATE), P = g.P, L = g.L, i, k;
      function poly(pts, depth, mat) {
        var sh = new T.Shape();
        sh.moveTo(pts[0][0], pts[0][1]);
        for (var q = 1; q < pts.length; q++) sh.lineTo(pts[q][0], pts[q][1]);
        var geo = new T.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: false, curveSegments: 2 });
        geo.translate(0, 0, -depth / 2);
        return new T.Mesh(geo, mat);
      }

      if (fr) self._drawPorchSeat(g.seat);   /* the porch seat with its hangers, eye bolts and chains */
      else {
      /* SEAT -- cheeks 3.02, v264 LAMINATED: four layers each (L1 inner with
         the groove, L2 + L3 core, L4 the cover), every layer its own piece;
         the left cheek flies in from the left, the right from the right */
      function shapeOf(pts, hole) {
        var sh0 = new T.Shape();
        sh0.moveTo(pts[0].x, pts[0].y);
        for (var q0 = 1; q0 < pts.length; q0++) sh0.lineTo(pts[q0].x, pts[q0].y);
        if (hole) {
          var hp0 = new T.Path();
          hp0.moveTo(hole[hole.length - 1].x, hole[hole.length - 1].y);
          for (var q1 = hole.length - 2; q1 >= 0; q1--) hp0.lineTo(hole[q1].x, hole[q1].y);
          sh0.holes.push(hp0);
        }
        return sh0;
      }
      var lt = g.layerT, Lh = g.L / 2;
      var geoFull = new T.ExtrudeGeometry(shapeOf(g.outline), { depth: lt, bevelEnabled: false, curveSegments: 3 });
      geoFull.translate(0, 0, -lt / 2);
      var geoGroove = new T.ExtrudeGeometry(shapeOf(g.outline, g.grooveHole), { depth: lt, bevelEnabled: false, curveSegments: 3 });
      geoGroove.translate(0, 0, -lt / 2);
      for (var sgc = -1; sgc <= 1; sgc += 2) {
        var side = (sgc < 0) ? 'l' : 'r';
        var LAY = [[3.5, geoGroove, 'swing-rib', 'cheek-' + side + '-L1-groove'], [2.5, geoFull, 'swing-rib', 'cheek-' + side + '-L2'],
                   [1.5, geoFull, 'swing-rib', 'cheek-' + side + '-L3'], [0.5, geoFull, 'swing-rib-cover', 'cheek-' + side + '-L4-cover']];
        for (var li = 0; li < LAY.length; li++) {
          var ly = new T.Mesh(LAY[li][1].clone(), mats.lumber);
          ly.position.set(0, 0, sgc * (Lh - LAY[li][0] * lt));
          ly.userData.flyDir = [0, 0, sgc];
          self._addToScene(ly, LAY[li][2], { boqCode: SWING.CHEEK_CODE, idHint: LAY[li][3] });
        }
      }
      geoFull.dispose(); geoGroove.dispose();
      if (g.midSup && g.supOutline) {
        var geoSup = new T.ExtrudeGeometry(shapeOf(g.supOutline), { depth: SWING.SUP_LAYERS * lt, bevelEnabled: false, curveSegments: 3 });
        geoSup.translate(0, 0, -SWING.SUP_LAYERS * lt / 2);
        var sup = new T.Mesh(geoSup, mats.lumber);
        sup.userData.flyDir = [0, -1, 0];
        self._addToScene(sup, 'swing-rib', { boqCode: SWING.CHEEK_CODE, idHint: 'middle-support' });
      }
      /* slats 3.01 between the cheeks, their ends in the grooves */
      for (i = 0; i < g.slats.length; i++) {
        var sl = g.slats[i];
        var slat = self._mkBox(P.slatW, P.slatT, g.slatLen, mats.lumber, sl.x, sl.y, 0);
        slat.rotation.z = sl.ang;
        self._addToScene(slat, 'swing-slat', { boqCode: SWING.SLAT_CODE, length: g.slatLen, idHint: 'slat-' + (i + 1) });
      }
      for (i = 0; i < g.seatScrews.length; i++) {
        var ssw = g.seatScrews[i];
        self._addFastener(ssw, 'swing-hw-screw-' + ssw.kind, (ssw.kind === 'lam') ? SWING.LAM_SCREW : SWING.SLAT_SCREW, 'screw-' + ssw.kind + '-' + (i + 1));
      }

      /* mattress: a pad following the seat line over the slats, from the
         toe node to where the head roll starts (one piece, FOU00016) */
      if (g.cushion) {
        var cu = new T.Shape(), cT = g.cushionT, ci;
        /* from the toe to the head along the axis: 4 % to 96 % of its length */
        var cA = g.arc * 0.04, cB = g.arc * 0.96, cpts = [];
        for (ci = 0; ci < g.dense.length; ci++) if (g.cum[ci] >= cA && g.cum[ci] <= cB) cpts.push(ci);
        if (cpts.length > 3) {
          var nrmC = _swingNormals(g.dense), base = P.slatT / 2 + 0.002;
          cu.moveTo(g.dense[cpts[0]].x + nrmC[cpts[0]].x * base, g.dense[cpts[0]].y + nrmC[cpts[0]].y * base);
          for (ci = 1; ci < cpts.length; ci++) cu.lineTo(g.dense[cpts[ci]].x + nrmC[cpts[ci]].x * base, g.dense[cpts[ci]].y + nrmC[cpts[ci]].y * base);
          for (ci = cpts.length - 1; ci >= 0; ci--) cu.lineTo(g.dense[cpts[ci]].x + nrmC[cpts[ci]].x * (base + cT), g.dense[cpts[ci]].y + nrmC[cpts[ci]].y * (base + cT));
          var cgeo = new T.ExtrudeGeometry(cu, { depth: g.slatSpan - 0.02, bevelEnabled: true, bevelThickness: 0.015, bevelSize: 0.015, bevelSegments: 2, curveSegments: 2 });
          cgeo.translate(0, 0, -(g.slatSpan - 0.02) / 2);
          var cush = new T.Mesh(cgeo, mats.fabric);
          self._addToScene(cush, 'cushion', { boqCode: 'FOU00016', idHint: 'mattress' });
          /* v263: throw pillows on the mattress against the back */
          var e3 = g.elems[3], offH = P.slatT / 2 + 0.002 + cT, nUh = { x: Math.sin(e3.phi1), y: -Math.cos(e3.phi1) };
          self._addPillows({ n: Math.max(1, Math.round(g.slatSpan / 0.62)), z0: -g.slatSpan / 2 + 0.10, z1: g.slatSpan / 2 - 0.10, seatY: e3.y1 + offH * nUh.y, backX: e3.x1 + offH * nUh.x,
                             beta: e3.phi1 - Math.PI / 2, w: 0.48, h: 0.46, t: 0.17, tag: 'swing-' });
        }
      }
      }

      self._drawSwingStand(g);   /* legs, beam, crossing bolts, rails, knee braces */

      if (!fr) {
      /* HANGING -- hangers, eye bolts, chains link by link. */
      for (i = 0; i < g.hangers.length; i++) {
        var hg = g.hangers[i];
        var plate = self._mkBox(0.05, 0.008, 0.10, mats.metal, 0, g.beamBot - 0.004, hg.z);
        self._addToScene(plate, 'swing-hw-plate', { boqCode: SWING.HANGER_CODE });
        var rod = new T.Mesh(new T.CylinderGeometry(0.005, 0.005, SWING.HANGER_DROP - 0.02, 8), mats.metal);
        rod.position.set(0, g.beamBot - (SWING.HANGER_DROP - 0.02) / 2 - 0.008, hg.z);
        self._addToScene(rod, 'swing-hw-rod', { boqCode: SWING.HANGER_CODE });
        var ring = new T.Mesh(new T.TorusGeometry(0.022, 0.005, 8, 20), mats.metal);
        ring.position.set(hg.x, hg.y, hg.z);
        self._addToScene(ring, 'swing-hw-hanger', { boqCode: SWING.HANGER_CODE, idHint: 'hanger-' + (i + 1) });
        for (var hq = -1; hq <= 1; hq += 2)   /* v264: the plate's 2 x 6x160 up into the beam, drawn */
          self._addFastener({ x: 0, y: g.beamBot - 0.008, z: hg.z + hq * 0.035, dir: [0, 1, 0], len: 0.16 }, 'swing-hw-screw-hanger', SWING.HANGER_SCREW, 'hanger-screw');
      }
      for (i = 0; i < g.eyes.length; i++) {
        var ey = g.eyes[i];
        var sgn = ey.z > 0 ? 1 : -1;
        var shank = new T.Mesh(new T.CylinderGeometry(0.005, 0.005, SWING.EYE_OUT, 8), mats.metal);
        shank.rotation.x = Math.PI / 2;
        shank.position.set(ey.x, ey.y, sgn * (L / 2 + SWING.EYE_OUT / 2));
        self._addToScene(shank, 'swing-hw-shank', { boqCode: SWING.EYE_CODE });
        var eye = new T.Mesh(new T.TorusGeometry(0.018, 0.004, 8, 18), mats.metal);
        eye.position.set(ey.x, ey.y, ey.z);
        self._addToScene(eye, 'swing-hw-eye', { boqCode: SWING.EYE_CODE, idHint: 'eye-' + (i + 1) });
      }
      var linkGeo = new T.TorusGeometry(SWING.LINK_PITCH * 0.42, 0.0026, 6, 14);
      linkGeo.scale(1, 1.7, 1);
      var qa = new T.Quaternion(), qb = new T.Quaternion(), mtx = new T.Matrix4();
      var vz = new T.Vector3(0, 0, 1), vy = new T.Vector3(0, 1, 0), one = new T.Vector3(1, 1, 1), pos = new T.Vector3();
      for (i = 0; i < g.chains.length; i++) {
        var ch = g.chains[i];
        var dxc = ch.b.x - ch.a.x, dyc = ch.b.y - ch.a.y;
        var nL = Math.max(2, Math.floor(ch.len / SWING.LINK_PITCH));
        var im = new T.InstancedMesh(linkGeo, mats.metal, nL);
        qa.setFromAxisAngle(vz, Math.atan2(-dxc, dyc));
        for (k = 0; k < nL; k++) {
          var tt = (k + 0.5) / nL;
          qb.setFromAxisAngle(vy, (k % 2) ? Math.PI / 2 : 0);
          var qq = qa.clone().multiply(qb);
          pos.set(ch.a.x + dxc * tt, ch.a.y + dyc * tt, ch.a.z);
          mtx.compose(pos, qq, one);
          im.setMatrixAt(k, mtx);
        }
        im.instanceMatrix.needsUpdate = true;
        self._addToScene(im, 'swing-hw-chain', { boqCode: SWING.CHAIN_CODE, length: ch.len, idHint: 'chain-' + (i + 1) });
      }
      }

      /* ROOF -- frames on the beam, boards along the roof, the skin. */
      var R = g.roof;
      if (R) {
        for (k = 0; k < R.frameZ.length; k++) {
          var zt = R.frameZ[k];
          for (i = 0; i < R.members.length; i++) {
            var mb = R.members[i];
            if (mb.kind === 'bracket' && (k === 0 || k === R.frameZ.length - 1)) continue;   /* end frames ride on the end brackets */
            var mm = poly(mb.pts, mb.w, mats.lumber);
            mm.position.set(0, 0, zt);
            if (mb.kind === 'bracket') mm.userData.flyDir = [0, -1, 0];   /* v264 (Marek): the struts from below, the rafters from above */
            self._addToScene(mm, 'swing-roof-' + mb.kind, { boqCode: mb.code, length: mb.len, idHint: 'frame-' + (k + 1) + '-' + mb.kind + '-' + (i + 1) });
          }
        }
        for (i = 0; i < R.endBr.length; i++) {
          var eb = R.endBr[i];
          var em = poly(eb.pts, P.ebW, mats.lumber);
          em.position.set(0, 0, eb.z);
          em.userData.flyDir = [0, -1, 0];                                 /* v264: from below */
          self._addToScene(em, 'swing-roof-endbracket', { boqCode: SWING.ENDBR_CODE, length: SWING.ENDBR_LEN, idHint: 'end-bracket-' + (i + 1) });
        }
        var BT = P.boardT, ST = SWING.SHINGLE_T, hz = R.RL / 2;
        for (i = 0; i < R.planes.length; i++) {
          var pln = R.planes[i];
          var eaveAtStart = (R.type === 'mono');
          /* boards 1.04 along the roof at the gauge */
          var nB = Math.ceil(pln.len / SWING.BOARD_GAUGE);
          for (k = 0; k < nB; k++) {
            var b0 = k * SWING.BOARD_GAUGE, b1 = Math.min(pln.len, b0 + P.boardW);
            if (b1 - b0 < 0.01) continue;
            var bd0 = self._swingPlaneBox(pln, b0, b1, 0, BT, -hz, hz, mats.osb);
            self._addToScene(bd0, 'swing-roof-board', { boqCode: SWING.BOARD_CODE, length: R.RL, idHint: 'board-' + (i + 1) + '-' + (k + 1) });
          }
          /* fascia battens 1.05 on both rakes */
          for (var sz2 = -1; sz2 <= 1; sz2 += 2) {
            var fa = self._swingPlaneBox(pln, 0, pln.len, -P.boardW + BT, BT, sz2 * hz, sz2 * (hz + BT), mats.lumber);
            self._addToScene(fa, 'swing-roof-fascia', { boqCode: SWING.FASCIA_CODE, length: pln.len, idHint: 'fascia-' + (i + 1) + (sz2 > 0 ? 'a' : 'b') });
          }
          /* shingle courses from the eave up, two shades */
          var nC = Math.ceil(pln.len / SWING.SHINGLE_EXP);
          for (k = 0; k < nC; k++) {
            var u0, u1;
            if (eaveAtStart) { u0 = k * SWING.SHINGLE_EXP; u1 = Math.min(pln.len, u0 + SWING.SHINGLE_EXP); }
            else { u1 = pln.len - k * SWING.SHINGLE_EXP; u0 = Math.max(0, u1 - SWING.SHINGLE_EXP); }
            if (u1 - u0 < 0.005) continue;
            var crs = self._swingPlaneBox(pln, u0, u1, BT + 0.002, BT + 0.002 + ST, -hz, hz, (k % 2) ? mats.shingleB : mats.shingleA);
            self._addToScene(crs, 'swing-roof-shingle', { boqCode: SWING.SHINGLE_CODE, idHint: 'shingle-' + (i + 1) + '-' + (k + 1) });
          }
          if (R.ridge && i === 0) {
            /* the ridge: one bent strip over both planes (the underlay strip
               under it, the shingle caps on it), mitred at the ridge line */
            var ca2 = Math.cos(R.a), sa2 = Math.sin(R.a), vb = BT + ST + 0.002, vt = vb + ST, O2 = pln.O;
            var capPts = [[-(SWING.CAP_W * ca2 + vb * sa2), O2.y - SWING.CAP_W * sa2 + vb * ca2], [0, O2.y + vb / ca2],
                          [SWING.CAP_W * ca2 + vb * sa2, O2.y - SWING.CAP_W * sa2 + vb * ca2],
                          [SWING.CAP_W * ca2 + vt * sa2, O2.y - SWING.CAP_W * sa2 + vt * ca2], [0, O2.y + vt / ca2],
                          [-(SWING.CAP_W * ca2 + vt * sa2), O2.y - SWING.CAP_W * sa2 + vt * ca2]];
            var cap = poly(capPts, R.RL, mats.shingleA);
            self._addToScene(cap, 'swing-roof-ridge', { boqCode: SWING.SHINGLE_CODE, idHint: 'ridge-cap' });
          }
          /* drip edge on the eave(s), verges on both rakes (detail A) */
          var eaves = (R.type === 'mono') ? [0, pln.len] : [pln.len];
          for (k = 0; k < eaves.length; k++) {
            /* drip edge 50: the face just OUTSIDE the board end (no fight
               with the board's end face), its flange on the boards under
               the first course */
            var ue = eaves[k], atStart = (ue === 0);
            var ua = atStart ? -0.002 : ue, fa0 = atStart ? 0 : ue - 0.05, fa1 = atStart ? 0.05 : ue;
            var dr = self._swingPlaneBox(pln, ua, ua + 0.002, -0.05, BT + 0.002, -hz, hz, mats.metal);
            self._addToScene(dr, 'swing-hw-drip', { boqCode: SWING.DRIP_CODE, length: R.RL, idHint: 'drip-' + (i + 1) + '-' + (k + 1) });
            var drf = self._swingPlaneBox(pln, fa0, fa1, BT, BT + 0.002, -hz, hz, mats.metal);
            self._addToScene(drf, 'swing-hw-drip-flange', { boqCode: SWING.DRIP_CODE });
          }
          for (var sz3 = -1; sz3 <= 1; sz3 += 2) {
            var vf = self._swingPlaneBox(pln, 0, pln.len, -0.03, BT + ST + 0.004, sz3 * (hz + BT), sz3 * (hz + BT + 0.002), mats.metal);
            self._addToScene(vf, 'swing-hw-verge', { boqCode: SWING.VERGE_CODE, length: pln.len, idHint: 'verge-' + (i + 1) + (sz3 > 0 ? 'a' : 'b') });
            var vt = self._swingPlaneBox(pln, 0, pln.len, BT + ST + 0.002, BT + ST + 0.004, sz3 * (hz - 0.05), sz3 * (hz + BT), mats.metal);
            self._addToScene(vt, 'swing-hw-verge-top', { boqCode: SWING.VERGE_CODE });
          }
        }
      }

      /* Log lines (once per change of shape / roof / cheeks / units). */
      if (fr) {
        try {
          var fKey = Math.round(g.L * 100) + '|' + Math.round(g.beta) + '|' + (R ? R.type + Math.round(R.pitch) : 'none') + '|' + g.cushion + '|' + (STATE.isMetric === false);
          if (fKey !== _swingLogKey) {
            _swingLogKey = fKey;
            var fq = global.BenchBoQ._computeSwing(STATE);
            _dbg('[frame] width ' + g.L.toFixed(3) + ' m, back ' + Math.round(g.beta) + ' deg, stand ' + g.beamLen.toFixed(2) + ' m beam, ' +
                 (R ? ('roof ' + R.type + ' ' + Math.round(R.pitch) + ' deg, ' + R.frameZ.length + ' frames') : 'no roof') + ', seat KVH10060 ' +
                 (fq.byMaterial.KVH10060 || 0).toFixed(2) + ' m, chain ' + (fq.byMaterial.FAT00004 || 0).toFixed(2) + ' m, mattress ' + (g.cushion ? 'on' : 'off'));
            for (i = 0; i < (fq.missing || []).length; i++) _dbg('[frame] NOT BILLED: ' + fq.missing[i].name + ' x ' + fq.missing[i].qty + ' ' + fq.missing[i].unit);
          }
        } catch (eF) {}
        return;
      }
      try {
        var logKey = Math.round(g.beta / 5) + '|' + (R ? R.type + Math.round(R.pitch) : 'none') + '|' + g.ribN + '|' + (STATE.isMetric === false) + '|' + Math.round(L * 10);
        if (logKey !== _swingLogKey) {
          _swingLogKey = logKey;
          var bq = global.BenchBoQ._computeSwing(STATE);
          _dbg('[swing] backrest ' + Math.round(g.beta) + ' deg, width ' + L.toFixed(3) + ' m, cheeks ' + g.ribN +
               ', slats ' + g.slats.length + ', chain ' + (bq.byMaterial[SWING.CHAIN_CODE] || 0).toFixed(2) + ' m, ' +
               (R ? ('roof ' + R.type + ' ' + Math.round(R.pitch) + ' deg, ' + R.frameZ.length + ' frames, ' + R.deckA.toFixed(2) + ' m2') : 'no roof') + ', ' +
               (STATE.isMetric === false ? 'US sections' : 'metric sections'));
          /* the seat line's elements (toe rise, seat, dip, crease, back): length / radius, 0 = a straight */
          _dbg('[swing] line ' + g.axisLen.toFixed(3) + ' m: ' + g.elems.map(function (e) { return e.len.toFixed(2) + (e.R ? '/R' + e.R.toFixed(2) : '/str'); }).join(' '));
          for (i = 0; i < (bq.missing || []).length; i++) {
            _dbg('[swing] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
          }
        }
      } catch (e) {}
    },

    /* A box lying in a roof plane: u along the slope from the plane origin,
       v along the up normal, z across. */
    _swingPlaneBox: function (pl, u0, u1, v0, v1, z0, z1, mat) {
      var T = global.THREE;
      var d = pl.d, n = (d.x >= 0) ? { x: -d.y, y: d.x } : { x: d.y, y: -d.x };
      var m = new T.Mesh(new T.BoxGeometry(Math.max(0.0005, u1 - u0), Math.max(0.0005, v1 - v0), Math.max(0.0005, Math.abs(z1 - z0))), mat);
      var uc = (u0 + u1) / 2, vc = (v0 + v1) / 2;
      m.position.set(pl.O.x + d.x * uc + n.x * vc, pl.O.y + d.y * uc + n.y * vc, (z0 + z1) / 2);
      m.rotation.z = Math.atan2(d.y, d.x);
      return m;
    },

    /* ----------------------------------------------------------
       VARIANT 3 - Wave lounger: the solid laminated side ribs (Wangen),
       the slats tangent to the contour, the two 2x4 connectors at the feet.
       v257: restored -- the builder was lost in v221 (the wave drew
       nothing since); now draws _waveLayout(STATE), the bill's own list.
       ---------------------------------------------------------- */
    _buildWaveBench: function () {
      var T = global.THREE, mats = this.materials, self = this, i;
      var g = _waveLayout(STATE), L = g.L, bt = g.bt, rb = g.rb, k;
      /* v295 THE PANELS: each board of the two layers its own piece, cut to
         the outline (the inner layer upright, the outer one across, on the
         side away from the middle) */
      function boardGeo(poly) {
        var sh = new T.Shape(), q;
        sh.moveTo(poly[0][0], poly[0][1]);
        for (q = 1; q < poly.length; q++) sh.lineTo(poly[q][0], poly[q][1]);
        var ge = new T.ExtrudeGeometry(sh, { depth: bt, bevelEnabled: false, curveSegments: 3 });
        ge.translate(0, 0, -bt / 2);
        return ge;
      }
      var geoV = rb.vert.map(function (p) { return boardGeo(p.poly); }), geoH = rb.hor.map(function (p) { return boardGeo(p.poly); });
      /* v297 (Marek 17:26: mensi spary na bocnicich, at to neni tak videt --
         spise naznak toho, jak se bocnice tvori): the boards' own edge lines
         faint (WAVE.SEAM_K of the normal ones), the panel's outline crisp on
         both faces */
      if (!mats.edgeSeam) mats.edgeSeam = new T.LineBasicMaterial({ color: 0x4a3320, linewidth: 1, transparent: true, opacity: 0.55 * WAVE.SEAM_K });
      function seam(m) { m.children.forEach(function (c) { if (c.userData && c.userData.isEdgeLine) { c.material = mats.edgeSeam; c.userData.seamK = WAVE.SEAM_K; } }); }
      var olPts = [];
      for (k = 0; k < g.dense.length; k++) { var dA = g.dense[k], dB = g.dense[(k + 1) % g.dense.length]; olPts.push(dA.x, dA.y, 0, dB.x, dB.y, 0); }   /* closed: the last segment is the ground line */
      function outline(pt, z, sg) {
        var gl = new T.BufferGeometry();
        gl.setAttribute('position', new T.Float32BufferAttribute(olPts, 3));
        var ln = new T.LineSegments(gl, mats.edge);
        ln.position.set(0, 0, z + sg * 0.0004);   /* a hair off the face */
        ln.userData.isEdgeLine = true;
        self._tag(ln, pt);
        if (sg) ln.userData.flyDir = [0, 0, sg];
        global.BenchEngine.benchGroup.add(ln);
      }
      for (i = 0; i < g.ribs.length; i++) {
        var zr = g.ribs[i], sgr = (zr < -1e-6) ? -1 : 1, outer = (i === 0 || i === g.ribs.length - 1);
        for (k = 0; k < rb.vert.length; k++) {
          var mv = new T.Mesh(geoV[k].clone(), mats.lumber);
          mv.position.set(0, 0, zr - sgr * bt / 2);
          if (outer) mv.userData.flyDir = [0, 0, sgr];   /* v264: the outer panels from their own side */
          self._addToScene(mv, 'wave-rib-v', { boqCode: WAVE.WANGE_CODE, length: rb.vert[k].stock, idHint: 'panel-' + (i + 1) + '-v' + rb.vert[k].n });
          seam(mv);
        }
        outline('wave-rib-v', zr - sgr * bt, -sgr);   /* the inner layer's free face */
        for (k = 0; k < rb.hor.length; k++) {
          var mh = new T.Mesh(geoH[k].clone(), mats.lumber);
          mh.position.set(0, 0, zr + sgr * bt / 2);
          if (outer) mh.userData.flyDir = [0, 0, sgr];
          self._addToScene(mh, 'wave-rib-h', { boqCode: WAVE.WANGE_CODE, length: rb.hor[k].stock, idHint: 'panel-' + (i + 1) + '-h' + rb.hor[k].n });
          seam(mh);
        }
        outline('wave-rib-h', zr + sgr * bt, sgr);    /* the outer layer's free face */
      }
      geoV.forEach(function (ge) { ge.dispose(); }); geoH.forEach(function (ge) { ge.dispose(); });
      for (i = 0; i < g.screws.length; i++) {
        var fw = g.screws[i];
        self._addFastener(fw, 'wave-hw-screw-' + fw.kind, fw.code, fw.kind + '-' + (i + 1));
      }
      for (i = 0; i < g.slats.length; i++) {
        var sl = g.slats[i];
        var slat = self._mkBox(WAVE.SLAT_W, WAVE.SLAT_T, L, mats.lumber, sl.x, sl.y, 0);
        slat.rotation.z = sl.ang;
        self._addToScene(slat, 'wave-slat', { boqCode: WAVE.SLAT_CODE, length: L, idHint: 'slat-' + (i + 1) });
      }
      for (i = 0; i < g.conns.length; i++) {
        var cn = g.conns[i];
        var con = self._mkBox(WAVE.CONNECT_W, WAVE.CONNECT_T, cn.len, mats.lumber, cn.x, cn.y, cn.z);
        self._addToScene(con, 'wave-connector', { boqCode: WAVE.CONNECT_CODE, length: cn.len, idHint: 'connector-' + (i + 1) });
      }
      /* v263: the mattress on the slats, head to toe (as the Hollywood's) */
      if (g.cushion) {
        var cu = new T.Shape(), cT = WAVE.MAT_T, cA = g.matA, cB = g.matB, cpts = [], ci;
        for (ci = 0; ci < g.dense.length; ci++) if (g.cum[ci] >= cA && g.cum[ci] <= cB) cpts.push(ci);
        if (cpts.length > 3) {
          var nrmW = [], last = g.dense.length - 1;
          for (ci = 0; ci <= last; ci++) {
            var pa = g.dense[Math.max(0, ci - 1)], pb = g.dense[Math.min(last, ci + 1)], ddx = pb.x - pa.x, ddy = pb.y - pa.y, dl = Math.sqrt(ddx * ddx + ddy * ddy) || 1;
            nrmW.push({ x: -ddy / dl, y: ddx / dl });                     /* up / toward the sitter (dense runs head -> toe) */
          }
          var baseW = WAVE.SLAT_T + 0.002;
          cu.moveTo(g.dense[cpts[0]].x + nrmW[cpts[0]].x * baseW, g.dense[cpts[0]].y + nrmW[cpts[0]].y * baseW);
          for (ci = 1; ci < cpts.length; ci++) cu.lineTo(g.dense[cpts[ci]].x + nrmW[cpts[ci]].x * baseW, g.dense[cpts[ci]].y + nrmW[cpts[ci]].y * baseW);
          for (ci = cpts.length - 1; ci >= 0; ci--) cu.lineTo(g.dense[cpts[ci]].x + nrmW[cpts[ci]].x * (baseW + cT), g.dense[cpts[ci]].y + nrmW[cpts[ci]].y * (baseW + cT));
          var spanW = L - 0.06;
          var cgW = new T.ExtrudeGeometry(cu, { depth: spanW - 0.03, bevelEnabled: true, bevelThickness: 0.015, bevelSize: 0.015, bevelSegments: 2, curveSegments: 2 });
          cgW.translate(0, 0, -(spanW - 0.03) / 2);
          self._addToScene(new T.Mesh(cgW, mats.fabric), 'cushion', { boqCode: 'FOU00016', idHint: 'mattress' });
        }
        /* v263: throw pillows on the mattress against the back */
        var offW = WAVE.SLAT_T + 0.002 + WAVE.MAT_T, nUw = { x: Math.sin(g.jphi), y: -Math.cos(g.jphi) };
        self._addPillows({ n: Math.max(1, Math.round(L / 0.65)), z0: -L / 2 + 0.10, z1: L / 2 - 0.10, seatY: g.jy + offW * nUw.y, backX: g.jx + offW * nUw.x,
                           beta: g.jphi - Math.PI / 2, w: 0.48, h: 0.46, t: 0.17, tag: 'wave-' });
      }
      try {
        if (typeof STATE._waveBetaAnim === 'number') throw 0;               /* no log line mid-morph */
        var key = Math.round(L * 100) + '|' + g.idx + '|' + Math.round(g.beta) + '|' + Math.round(g.gap * 1000) + '|' + g.cushion + '|' + (STATE.isMetric === false);
        if (key !== _waveLogKey) {
          _waveLogKey = key;
          var bq = global.BenchBoQ._computeWaveBench(STATE);
          var nN = g.screws.filter(function (f) { return f.kind === 'nail'; }).length;
          _dbg('[wave] width ' + L.toFixed(2) + ' m, posture ' + g.idx + '/' + WAVE.PRESETS + ' (' + g.beta + ' deg), ' + g.depth.toFixed(2) + ' x ' + g.height.toFixed(2) + ' m, ' + g.ribN + ' panels ' + Math.round(g.wt * 1000) + ' mm (inset ' + Math.round(g.inset * 1000) + ' mm from the slat ends; ' +
               rb.vert.length + ' upright + ' + rb.hor.length + ' across = ' + rb.stockM.toFixed(2) + ' m of 1x4 a panel, ' + (nN / g.ribN) + ' nails a panel), slats ' + g.slats.length + ' (gap ' + Math.round(g.gap * 1000) + ' mm), mattress ' + (g.cushion ? 'on' : 'off') + '; ' +
               Object.keys(bq.byMaterial).sort().map(function (c) { var v = bq.byMaterial[c]; return c + ' ' + (v % 1 ? v.toFixed(2) : v); }).join(', '));
          for (i = 0; i < (bq.missing || []).length; i++) _dbg('[wave] NOT BILLED: ' + bq.missing[i].name + ' x ' + bq.missing[i].qty + ' ' + bq.missing[i].unit);
        }
      } catch (eW) {}
    },

    /* Closed 2D outline of one rib -- a SOLID side cheek (Wange) as in
       Marek's drawing: the reclining surface on top, vertical edges down to
       the ground at both ends, a flat base on the ground. */
    _waveWangeShape: function (dense) {
      var T = global.THREE, shape = new T.Shape(), last = dense.length - 1, k;
      shape.moveTo(dense[0].x, 0);
      shape.lineTo(dense[0].x, dense[0].y);
      for (k = 1; k <= last; k++) shape.lineTo(dense[k].x, dense[k].y);
      shape.lineTo(dense[last].x, 0);
      return shape;
    },

    /* v259: a screw drawn for the staged assembly (as the park bench):
       f = { x, y, z: the head on the wood's face, dir: into the wood, len,
       r }. Group: head at the origin, shank along local -y, turned onto
       dir. driveDir / driveLen: the drive-in animation starts that far out. */
    _addFastener: function (f, partType, code, idHint) {
      var T = global.THREE, mats = this.materials;
      var len = f.len || 0.10, r = f.r || 0.003, hr = r * 2.3, ht = 0.003;
      var g = new T.Group();
      var shank = new T.Mesh(new T.CylinderGeometry(r, r * 0.6, len, 8), mats.screwHead || mats.metal);
      shank.position.y = -len / 2;
      var head = new T.Mesh(new T.CylinderGeometry(hr, hr, ht, 12), mats.screwHead || mats.metal);
      head.position.y = ht / 2;
      g.add(shank); g.add(head);
      var d = new T.Vector3(f.dir[0], f.dir[1], f.dir[2]).normalize();
      g.quaternion.setFromUnitVectors(new T.Vector3(0, -1, 0), d);
      g.position.set(f.x, f.y, f.z);
      g.userData.driveDir = [-d.x, -d.y, -d.z];
      g.userData.driveLen = len;
      this._addToScene(g, partType, { boqCode: code, idHint: idHint });
      return g;
    },

    _buildPlaceholder: function (label) {
      /* Empty bay with a small marker plinth so the scene is not blank
         and the controls/handles still have a target. */
      var mk = this._mkBox.bind(this);
      var mats = this.materials;
      var plinth = mk(0.6, 0.05, 0.6, mats.lumber, 0, 0.025, 0);
      this._addToScene(plinth, 'placeholder', { boqCode: null });
    },

    /* Assembly step visibility + explode. Bench MVP uses 2 steps:
         0 = built (everything visible)
         1 = inspect (fasteners revealed)
       Future versions can expand to a multi-step staged build. */
    _applyAssemblyStep: function (G, step) {
      /* Default explode offsets per part type. Applied in steps 1
         (hardware view) AND 2 (pocket-hole drill markers view) so the
         user can rotate under the bench and inspect joint faces.
         Long bottom rails (rail-seat-front + rail-seat-back) stay put;
         everything else moves modestly outward / upward from them.
         Backrest interior parts have their own per-instance offsets
         in the bf group's LOCAL frame (rake-rotated when rendered). */
      var EXPLODE = {
        'rail-seat-front':       [0,    0,    0],     /* STAY */
        'rail-seat-back':        [0,    0,    0],     /* STAY */
        'rail-seat-left':        [0,    0.18, -0.30],
        'rail-seat-right':       [0,    0.18,  0.30],
        'joist':                 [0,    0.28,  0],
        'rail-back-left':        [0,    0.32, -0.25],
        'rail-back-right':       [0,    0.32,  0.25],
        /* Backrest moves as a UNIT — back (-X) and up. Its static
           bottom rail (outside bf group) gets the SAME offset so the
           whole backrest assembly stays together visually. Internal
           parts (planks, posts, top rail, stretchers) have their own
           SMALL local offsets on top of this to separate from each
           other. */
        'rail-backrest-bottom':  [-0.25, 0.55, 0],
        'backrest-group':        [-0.25, 0.55, 0],
        /* Fasteners: visible AND lifted slightly to follow their host
           parts. Pocket holes stay at base (they're inside the wood
           and reveal the joint location when the host moves away). */
        'screw-deck':            [0,    0.22, 0],
        'screw-pocket':          [0,    0,    0],
        'screw-lag':             [0,    0.15, 0]
      };

      /* Walk the FULL tree — backrest parts live inside the bf sub-group
         with rake rotation; their explode offsets are stored in bf-LOCAL
         frame and compose correctly with bf's rotation when applied to
         their .position. */
      G.traverse(function (child) {
        var pt = child.userData && child.userData.partType;
        if (!pt) return;

        /* Visibility: see _benchVisibleAtStep for the full rule set.
           Covers special view steps (0/1/2) AND the progressive build
           sequence (3..21). */
        child.visible = _benchVisibleAtStep(child, step);

        /* Person is anchored — never repositioned by the assembly
           pipeline. */
        if (pt === 'person') {
          if (child.userData.basePos) child.position.copy(child.userData.basePos);
          return;
        }

        /* Position. Steps 1 + 2 = exploded view. Step 0 = built. Steps
           3..21 = progressive build (parts at base, parts appear one
           at a time as the user steps through). */
        var base = child.userData.basePos;
        if (!base) return;

        /* ── SOFA 3-phase teardown ────────────────────────────────────
             phase 1: whole bočnice (posts + SEAT-END + TOP-END + their
                      joinery) slides OUT along Z; long rails stay.
             phase 2: + TOP-END (and its dowels/screws) lifts UP (Y).
             phase 3: + posts split fwd/back (X), revealing SEAT-END
                      dowels.  Offsets are cumulative. */
        if (_isSofaAsm(STATE)) {
          var so = _sofaPhaseOffset(child, step);
          child.position.set(base.x + so[0], base.y + so[1], base.z + so[2]);
          return;
        }

        var off = child.userData.explodeOffset || EXPLODE[pt];
        if ((step === 1 || step === 2) && off) {
          child.position.set(base.x + off[0], base.y + off[1], base.z + off[2]);
        } else {
          child.position.copy(base);
        }

        /* OFF-BENCH translation for the backrest frame during sub-
           assembly steps 14..18. Cleared from step 19 onward so the
           frame appears installed on the bench. Children of the bf
           group inherit the translation automatically via bf.position;
           markers + cylinders tagged bfOffBenchTrack get it explicitly
           since they live in benchGroup, not bf. */
        var offBench = _benchOffBenchOffset(child, step);
        if (offBench) {
          child.position.x += offBench[0];
          child.position.y += offBench[1];
          child.position.z += offBench[2];
        }
      });

      try { _xpAfterStep(G, step); } catch (eXp) { _dbg('[xp] THREW ' + ((eXp && eXp.message) || eXp)); }   /* v395 the coops' exploded view */

      /* Camera tilt lock: only step 0 forces an above-horizon camera.
         All other steps (explode views + every build step) unlock the
         polar angle so the user can rotate under the bench and look up
         at joinery from below. */
      var eng = global.BenchEngine;
      if (eng && eng.controls) {
        eng.controls.maxPolarAngle = (step === 0)
          ? Math.PI * 0.49
          : Math.PI;
      }
    }
  };


  /* ----------------------------------------------------------
     DIMENSIONS OVERLAY (SVG) — drawn over the canvas in 2D stage 2.
     Hybrid CAD/brand style: thin gray dim lines (#888), sand-gold
     rounded chips with dark text. Re-projects from world to screen
     each refresh so live-resize during drag would still work
     (drag itself is disabled in stage 2, but resize events still fire).

     Public API:
       BenchDimensions.init()    — create SVG once, attach to #cf-root.
       BenchDimensions.refresh() — re-project and re-draw. Hides itself
                                  when NOT in 2D stage 2.
     ---------------------------------------------------------- */
  var SVG_NS = 'http://www.w3.org/2000/svg';

  global.BenchDimensions = {
    svgEl: null,
    chipLayer: null,
    chipEls: [],

    init: function () {
      var root = document.getElementById('cf-root');
      if (!root) return;

      /* SVG layer for dim lines + extension lines + arrows. */
      if (!this.svgEl) {
        var svg = document.createElementNS(SVG_NS, 'svg');
        svg.id = 'cf-dims-svg';
        svg.style.cssText = [
          'position:absolute', 'top:0', 'left:0',
          'width:100%', 'height:100%',
          'pointer-events:none',
          'display:none',
          'z-index:6'
        ].join(';');
        root.appendChild(svg);
        this.svgEl = svg;

        var self = this;
        window.addEventListener('resize', function () { self.refresh(); });
      }

      /* Separate HTML layer for clickable/draggable dim chips. Lives
         above the SVG layer so chip pointer events aren't blocked by
         the SVG's pointer-events:none. Checked independently so
         hot-reload of lib.js after svgEl was created still gets a chip
         layer. */
      if (!this.chipLayer) {
        var existing = document.getElementById('cf-dim-chips');
        if (existing) {
          this.chipLayer = existing;
        } else {
          var layer = document.createElement('div');
          layer.id = 'cf-dim-chips';
          layer.style.cssText = [
            'position:absolute', 'top:0', 'left:0',
            'width:100%', 'height:100%',
            'pointer-events:none',
            'z-index:7'
          ].join(';');
          root.appendChild(layer);
          this.chipLayer = layer;
        }
      }
    },

    refresh: function () {
      /* Always call init — it now checks svgEl and chipLayer
         independently, so this handles the case where svgEl exists from
         an older session but chipLayer needs to be created (hot-reload). */
      this.init();
      if (!this.svgEl) return;

      var view = STATE.view, stage = STATE.vizStage;
      /* Dimensions visible in any 2D view (both plan and elevations). */
      var shouldShow = (view === '2d');
      if (!shouldShow) {
        this.svgEl.style.display = 'none';
        this.svgEl.innerHTML = '';
        if (this.chipLayer) this.chipLayer.style.display = 'none';
        this._clearChips();
        return;
      }

      this.svgEl.style.display = '';
      this.svgEl.innerHTML = '';
      if (this.chipLayer) this.chipLayer.style.display = '';
      this._clearChips();

      var eng = global.BenchEngine;
      if (!eng || !eng.camera || !eng.renderer) return;
      var T = global.THREE;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var w = rect.width, h = rect.height;
      if (w < 10 || h < 10) return;
      this.svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + h);

      var GRAY = '#888';
      var DARK = '#1a1a1a';
      var GOLD = '#D2A878';
      var DIM_OFFSET = 36;     /* dim line distance from rack edge */
      var EXT_GAP = 4, EXT_OVER = 6, ARROW = 6;
      var L = STATE.L, Wd = STATE.W, Hg = STATE.H;
      var unit = STATE.isMetric ? 'm' : 'ft';
      /* Hollywood swing: the outer dimension along Z is the roof (or the
         beam), the seat width goes on a second, inner dim line. */
      var swingSeatL = null;
      if (_isStandType(STATE.variant)) {
        try { var sgD = _standLayout(STATE); swingSeatL = sgD.L; L = sgD.roof ? sgD.roof.RL : sgD.beamLen; } catch (eD) {}
      } else if ((STATE.variant | 0) === 9) {
        try { var agD = _adiLayout(STATE); swingSeatL = agD.L; L = agD.outerW; } catch (eA) {}   /* Adirondack: overall over the arms, the seats inside */
      } else if ((STATE.variant | 0) === 10) {
        try { var plD = _planterLayout(STATE); swingSeatL = plD.L; L = plD.outerL; } catch (eP) {}   /* planter bench: over the planters, the seat between */
      } else if ((STATE.variant | 0) === 11) {
        try { var trD = _treeLayout(STATE); swingSeatL = trD.L; L = trD.outerZ; } catch (eT) {}   /* tree bench: the outside in z, the opening inside */
      } else if ((STATE.variant | 0) === 13) {
        try { var kgD = _kidsLayout(STATE); swingSeatL = kgD.L; L = kgD.beamLen; } catch (eK) {}   /* kids' set: the beam, the span between the frames inside */
      }
      var seatLabel = (swingSeatL != null) ? (fmtLen(swingSeatL) + ' ' + unit) : null;
      var lLabel = fmtLen(L)  + ' ' + unit;
      var wLabel = fmtLen(Wd) + ' ' + unit;
      var hLabel = fmtLen(Hg) + ' ' + unit;

      function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

      /* ──────────────────────────────────────────────────────────────
         Stage 2 — BOKORYS (side elevation). Camera at (50, H/2, 0)
         looks along -X. Sees Z × Y plane = L × H. Project rack at
         side face (x=0) so we see the L-length × H-height profile.
         ────────────────────────────────────────────────────────────── */
      if (stage === 2) {
        var cameraS = eng.orthoCamera;
        if (!cameraS) return;

        function projS(x, y, z) {
          var v = new T.Vector3(x, y, z).project(cameraS);
          return {
            x: (v.x * 0.5 + 0.5) * w,
            y: (1 - (v.y * 0.5 + 0.5)) * h
          };
        }

        var halfLs = L / 2;
        /* Bokorys rack corners: project at x=0, rack base spans
           z=-L/2..+L/2 at y=0; rack top at y=H. */
        var s_blB = projS(0, 0,  -halfLs);    /* bottom -Z corner */
        var s_brB = projS(0, 0,   halfLs);    /* bottom +Z corner */
        var s_brT = projS(0, Hg,  halfLs);    /* top +Z corner */
        var s_blT = projS(0, Hg, -halfLs);    /* top -Z corner */

        /* Outer bbox across all rack parts in bokorys view. */
        var worldBoxS = new T.Box3();
        var tmpBoxS = new T.Box3();
        eng.benchGroup.children.forEach(function (c) {
          if (c.userData && (c.userData.partType === 'person' || c.userData.partType === 'ph-tree')) return;   /* v368 the tree fort's tree */
          tmpBoxS.makeEmpty();
          tmpBoxS.setFromObject(c);
          if (!tmpBoxS.isEmpty()) worldBoxS.union(tmpBoxS);
        });

        var bb_minX_S = Infinity, bb_maxX_S = -Infinity;
        var bb_minY_S = Infinity, bb_maxY_S = -Infinity;
        if (!worldBoxS.isEmpty()) {
          [
            projS(0, worldBoxS.min.y, worldBoxS.min.z),
            projS(0, worldBoxS.min.y, worldBoxS.max.z),
            projS(0, worldBoxS.max.y, worldBoxS.min.z),
            projS(0, worldBoxS.max.y, worldBoxS.max.z)
          ].forEach(function (p) {
            if (p.x < bb_minX_S) bb_minX_S = p.x;
            if (p.x > bb_maxX_S) bb_maxX_S = p.x;
            if (p.y < bb_minY_S) bb_minY_S = p.y;
            if (p.y > bb_maxY_S) bb_maxY_S = p.y;
          });
        } else {
          bb_minX_S = Math.min(s_blB.x, s_brB.x, s_brT.x, s_blT.x);
          bb_maxX_S = Math.max(s_blB.x, s_brB.x, s_brT.x, s_blT.x);
          bb_minY_S = Math.min(s_blB.y, s_brB.y, s_brT.y, s_blT.y);
          bb_maxY_S = Math.max(s_blB.y, s_brB.y, s_brT.y, s_blT.y);
        }

        /* ── L dimension (horizontal, BELOW rack) ── */
        var wDimY_S = bb_maxY_S + DIM_OFFSET;
        this._drawDim(s_blB.x, s_blB.y, s_brB.x, s_brB.y, wDimY_S, 'horizontal',
                      lLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'length');
        if (seatLabel) {
          var sS0 = projS(0, 0, -swingSeatL / 2), sS1 = projS(0, 0, swingSeatL / 2);
          this._drawDim(sS0.x, sS0.y, sS1.x, sS1.y, wDimY_S + 30, 'horizontal',
                        seatLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'seat');
        }

        /* ── H dimension (vertical, LEFT of rack) ── */
        var hDimX_S = bb_minX_S - DIM_OFFSET;
        this._drawDim(s_blB.x, s_blB.y, s_blT.x, s_blT.y, hDimX_S, 'vertical',
                      hLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'height');

        return;
      }

      /* ──────────────────────────────────────────────────────────────
         Stage 3 — NÁRYS (front elevation). Camera at (0, H/2, 50)
         looks along -Z. Sees X × Y plane = W × H. Project rack at
         front face (z=0) so we see the W-width × H-height profile.
         ────────────────────────────────────────────────────────────── */
      if (stage === 3) {
        var cameraF = eng.orthoCamera;
        if (!cameraF) return;

        function projF(x, y, z) {
          var v = new T.Vector3(x, y, z).project(cameraF);
          return {
            x: (v.x * 0.5 + 0.5) * w,
            y: (1 - (v.y * 0.5 + 0.5)) * h
          };
        }

        var halfWf = STATE.W / 2;
        /* Nárys rack corners: project at z=0, rack base spans
           x=-W/2..+W/2 at y=0; rack top at y=H. */
        var f_blL = projF(-halfWf, 0,  0);    /* bottom -X corner */
        var f_brL = projF( halfWf, 0,  0);    /* bottom +X corner */
        var f_brT = projF( halfWf, Hg, 0);    /* top +X corner */
        var f_blT = projF(-halfWf, Hg, 0);    /* top -X corner */

        /* Outer bbox across all rack parts in nárys view. */
        var worldBoxF = new T.Box3();
        var tmpBoxF = new T.Box3();
        eng.benchGroup.children.forEach(function (c) {
          if (c.userData && (c.userData.partType === 'person' || c.userData.partType === 'ph-tree')) return;   /* v368 the tree fort's tree */
          tmpBoxF.makeEmpty();
          tmpBoxF.setFromObject(c);
          if (!tmpBoxF.isEmpty()) worldBoxF.union(tmpBoxF);
        });

        var bb_minX_F = Infinity, bb_maxX_F = -Infinity;
        var bb_minY_F = Infinity, bb_maxY_F = -Infinity;
        if (!worldBoxF.isEmpty()) {
          [
            projF(worldBoxF.min.x, worldBoxF.min.y, 0),
            projF(worldBoxF.max.x, worldBoxF.min.y, 0),
            projF(worldBoxF.min.x, worldBoxF.max.y, 0),
            projF(worldBoxF.max.x, worldBoxF.max.y, 0)
          ].forEach(function (p) {
            if (p.x < bb_minX_F) bb_minX_F = p.x;
            if (p.x > bb_maxX_F) bb_maxX_F = p.x;
            if (p.y < bb_minY_F) bb_minY_F = p.y;
            if (p.y > bb_maxY_F) bb_maxY_F = p.y;
          });
        } else {
          bb_minX_F = Math.min(f_blL.x, f_brL.x, f_brT.x, f_blT.x);
          bb_maxX_F = Math.max(f_blL.x, f_brL.x, f_brT.x, f_blT.x);
          bb_minY_F = Math.min(f_blL.y, f_brL.y, f_brT.y, f_blT.y);
          bb_maxY_F = Math.max(f_blL.y, f_brL.y, f_brT.y, f_blT.y);
        }

        /* ── W dimension (horizontal, BELOW rack) ──
           v260: a bench not centred in x (the storage bench's back leans
           out behind the box) -- the line follows the drawn parts when
           their extent is the W shown */
        var lDimY_F = bb_maxY_F + DIM_OFFSET, fW0 = f_blL, fW1 = f_brL;
        if (!worldBoxF.isEmpty() && Math.abs((worldBoxF.max.x - worldBoxF.min.x) - STATE.W) < 0.03 &&
            Math.abs(worldBoxF.min.x + halfWf) > 0.005) {
          fW0 = projF(worldBoxF.min.x, 0, 0); fW1 = projF(worldBoxF.max.x, 0, 0);
        }
        this._drawDim(fW0.x, fW0.y, fW1.x, fW1.y, lDimY_F, 'horizontal',
                      wLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'width');

        /* ── H dimension (vertical, LEFT of rack) ── */
        var hDimX_F = bb_minX_F - DIM_OFFSET;
        this._drawDim(f_blL.x, f_blL.y, f_blT.x, f_blT.y, hDimX_F, 'vertical',
                      hLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'height');

        return;
      }

      /* ──────────────────────────────────────────────────────────────
         Stage 1 — top-down plan. Project rack footprint + bbox through
         the top-down ortho camera and place L + W dim lines around the
         outer screen extent. Person GLB excluded from bbox so its
         async load doesn't shift dim placement.
         ────────────────────────────────────────────────────────────── */
      var camera = eng.orthoCamera;
      function project(x, y, z) {
        var v = new T.Vector3(x, y, z).project(camera);
        return {
          x: (v.x * 0.5 + 0.5) * w,
          y: (1 - (v.y * 0.5 + 0.5)) * h
        };
      }

      var halfL = L / 2, halfWf = STATE.W / 2;
      /* Footprint corners (y = 0) projected to screen. These are still
         used as the dim-line endpoints — the dim line measures the rack
         BASE (W, L), not the roof overhang. */
      var c_mWmZ = project(-halfWf, 0, -halfL);  /* -X -Z */
      var c_pWmZ = project( halfWf, 0, -halfL);  /* +X -Z */
      var c_pWpZ = project( halfWf, 0,  halfL);  /* +X +Z */
      var c_mWpZ = project(-halfWf, 0,  halfL);  /* -X +Z */

      /* Compute the OUTER screen extent of every visible rack part
         (frame, decking, posts, rails, rafters, battens, roof — including
         its overhangs — fasteners, etc).

         IMPORTANT: Box3.setFromObject does NOT honour Object3D.visible
         (it expands by every descendant's geometry regardless). The
         scale-reference person sits at +X of the rack and is hidden in
         2D, but its bbox would otherwise push the L dim line out into
         nowhere. The fix: iterate the direct children of benchGroup and
         skip the person partType, then union the remaining boxes. */
      var worldBox = new T.Box3();
      var tmpBox = new T.Box3();
      eng.benchGroup.children.forEach(function (c) {
        if (c.userData && (c.userData.partType === 'person' || c.userData.partType === 'ph-tree')) return;   /* v368 the tree fort's tree */
        tmpBox.makeEmpty();
        tmpBox.setFromObject(c);
        if (!tmpBox.isEmpty()) worldBox.union(tmpBox);
      });

      var bb_minX = Infinity, bb_maxX = -Infinity;
      var bb_minY = Infinity, bb_maxY = -Infinity;
      if (!worldBox.isEmpty()) {
        [
          project(worldBox.min.x, 0, worldBox.min.z),
          project(worldBox.max.x, 0, worldBox.min.z),
          project(worldBox.max.x, 0, worldBox.max.z),
          project(worldBox.min.x, 0, worldBox.max.z)
        ].forEach(function (p) {
          if (p.x < bb_minX) bb_minX = p.x;
          if (p.x > bb_maxX) bb_maxX = p.x;
          if (p.y < bb_minY) bb_minY = p.y;
          if (p.y > bb_maxY) bb_maxY = p.y;
        });
      } else {
        bb_minX = Math.min(c_mWmZ.x, c_pWmZ.x, c_pWpZ.x, c_mWpZ.x);
        bb_maxX = Math.max(c_mWmZ.x, c_pWmZ.x, c_pWpZ.x, c_mWpZ.x);
        bb_minY = Math.min(c_mWmZ.y, c_pWmZ.y, c_pWpZ.y, c_mWpZ.y);
        bb_maxY = Math.max(c_mWmZ.y, c_pWmZ.y, c_pWpZ.y, c_mWpZ.y);
      }

      /* ── W dimension (along world X) ── */
      var avgYBack  = (c_mWmZ.y + c_pWmZ.y) / 2;
      var avgYFront = (c_mWpZ.y + c_pWpZ.y) / 2;
      var topEdge = (avgYBack < avgYFront) ? [c_mWmZ, c_pWmZ] : [c_mWpZ, c_pWpZ];
      var wDimY = bb_minY - DIM_OFFSET;
      /* v255: the size bar sits over the top of the stage; a W line that
         would land under it goes below the plan instead (the picnic set's
         plan fills the height) */
      try {
        var barEl = document.querySelector('.cf-size-bar'), svgR = this.svgEl.getBoundingClientRect();
        if (barEl && svgR && svgR.height > 0) {
          var barR = barEl.getBoundingClientRect();
          if (barR.height > 0 && (wDimY - 14) < (barR.bottom - svgR.top + 4)) {
            wDimY = bb_maxY + DIM_OFFSET;
            topEdge = (avgYBack < avgYFront) ? [c_mWpZ, c_pWpZ] : [c_mWmZ, c_pWmZ];
          }
        }
      } catch (eBar) {}
      this._drawDim(topEdge[0].x, topEdge[0].y, topEdge[1].x, topEdge[1].y, wDimY, 'horizontal',
                    wLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'width');

      /* ── L dimension (along world Z) ── */
      var avgXLeft  = (c_mWmZ.x + c_mWpZ.x) / 2;
      var avgXRight = (c_pWmZ.x + c_pWpZ.x) / 2;
      var rightEdge = (avgXRight > avgXLeft) ? [c_pWmZ, c_pWpZ] : [c_mWmZ, c_mWpZ];
      var lDimX = bb_maxX + DIM_OFFSET;
      this._drawDim(rightEdge[0].x, rightEdge[0].y, rightEdge[1].x, rightEdge[1].y, lDimX, 'vertical',
                    lLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'length');
      if (seatLabel) {
        var leftEdge = (rightEdge[0] === c_pWmZ) ? [c_mWmZ, c_mWpZ] : [c_pWmZ, c_pWpZ];
        var xSeat = (leftEdge[0] === c_mWmZ) ? -halfWf : halfWf;
        var pS0 = project(xSeat, 0, -swingSeatL / 2), pS1 = project(xSeat, 0, swingSeatL / 2);
        this._drawDim(pS0.x, pS0.y, pS1.x, pS1.y, bb_minX - DIM_OFFSET, 'vertical',
                      seatLabel, GRAY, DARK, GOLD, EXT_GAP, EXT_OVER, ARROW, 'seat');
      }
    },

    /* Draw one dimension: two extension lines + dim line with arrows +
       gold chip with label. Generic for horizontal/vertical orientation.
         (cx1, cy1)–(cx2, cy2): corner anchor points
         offsetCoord: the screen Y (horizontal dim) or X (vertical dim)
                      where the dim line is placed
    */
    _drawDim: function (cx1, cy1, cx2, cy2, offsetCoord, orient,
                        label, lineColor, textColor, chipColor,
                        extGap, extOver, arrow, axis) {
      var svg = this.svgEl;
      var ns = SVG_NS;

      function add(tag, attrs) {
        var e = document.createElementNS(ns, tag);
        for (var k in attrs) e.setAttribute(k, attrs[k]);
        svg.appendChild(e);
        return e;
      }

      var p1, p2;   /* dim line endpoints */
      var e1a, e1b, e2a, e2b; /* extension line endpoints */
      var labelX, labelY;

      if (orient === 'horizontal') {
        var dimY = offsetCoord;
        p1 = { x: cx1, y: dimY };
        p2 = { x: cx2, y: dimY };
        /* extension lines: from a bit away from corner, past the dim line */
        var extDir = (dimY < cy1) ? -1 : 1;  /* up or down */
        e1a = { x: cx1, y: cy1 + extDir * extGap };
        e1b = { x: cx1, y: dimY + extDir * extOver };
        e2a = { x: cx2, y: cy2 + extDir * extGap };
        e2b = { x: cx2, y: dimY + extDir * extOver };
        labelX = (p1.x + p2.x) / 2;
        labelY = dimY;
      } else {
        var dimX = offsetCoord;
        p1 = { x: dimX, y: cy1 };
        p2 = { x: dimX, y: cy2 };
        var extDirX = (dimX > cx1) ? 1 : -1;
        e1a = { x: cx1 + extDirX * extGap, y: cy1 };
        e1b = { x: dimX + extDirX * extOver, y: cy1 };
        e2a = { x: cx2 + extDirX * extGap, y: cy2 };
        e2b = { x: dimX + extDirX * extOver, y: cy2 };
        labelX = dimX;
        labelY = (p1.y + p2.y) / 2;
      }

      function line(x1, y1, x2, y2, stroke, width, dash) {
        add('line', {
          x1: x1, y1: y1, x2: x2, y2: y2,
          stroke: stroke || lineColor,
          'stroke-width': width || 1,
          'stroke-linecap': 'round',
          'stroke-dasharray': dash || ''
        });
      }

      /* Extension lines (dashed) */
      line(e1a.x, e1a.y, e1b.x, e1b.y, lineColor, 1, '3 2');
      line(e2a.x, e2a.y, e2b.x, e2b.y, lineColor, 1, '3 2');
      /* Main dim line */
      line(p1.x, p1.y, p2.x, p2.y, lineColor, 1.2);

      /* Arrows at endpoints — both point OUTWARD (away from each other)
         like Czech architectural dim convention: ⇦ ··· ⇨
           horizontal: p1 (left)  → point LEFT  = -1
                       p2 (right) → point RIGHT = +1
           vertical:   p1 (top)   → point UP    = -1
                       p2 (bot)   → point DOWN  = +1 */
      function arrowTri(at, dir) {
        var a = arrow;
        var tri;
        if (orient === 'horizontal') {
          tri = at.x + ',' + at.y + ' ' + (at.x - dir * a) + ',' + (at.y - a * 0.5) +
                ' ' + (at.x - dir * a) + ',' + (at.y + a * 0.5);
        } else {
          tri = at.x + ',' + at.y + ' ' + (at.x - a * 0.5) + ',' + (at.y - dir * a) +
                ' ' + (at.x + a * 0.5) + ',' + (at.y - dir * a);
        }
        add('polygon', { points: tri, fill: lineColor, stroke: 'none' });
      }
      if (orient === 'horizontal') {
        arrowTri(p1, p1.x < p2.x ? -1 :  1);   /* p1 left → point left (outward) */
        arrowTri(p2, p2.x > p1.x ?  1 : -1);   /* p2 right → point right (outward) */
      } else {
        arrowTri(p1, p1.y < p2.y ? -1 :  1);   /* p1 top → point up (outward) */
        arrowTri(p2, p2.y > p1.y ?  1 : -1);   /* p2 bot → point down (outward) */
      }

      /* Chip — pool-style HTML dim label sitting next to each cote.
         Pure label only: no drag behaviour, no 6-dot grip icon. The
         round corner handles (cf-handle-l/w/h on the canvas overlay)
         remain the sole drag affordance.

         Why: on mobile the chips often overlap each other and the
         corner handles, and the user kept missing the round handles
         and grabbing chips instead. Chips show the value being
         displayed; the user touches the corner dot to resize.
         Removing chip drag also kills accidental pinch-to-zoom
         hijacks on touch screens. */
      if (axis && this.chipLayer) {
        var chip = document.createElement('div');
        chip.className = 'cf-dim-chip cf-dim-chip--label-only';
        chip.setAttribute('data-axis', axis);
        chip.textContent = label;
        chip.style.left = labelX + 'px';
        chip.style.top  = labelY + 'px';
        /* Make sure the chip can't intercept a drag meant for the
           round handle underneath if positions overlap. */
        chip.style.pointerEvents = 'none';
        this.chipLayer.appendChild(chip);
        this.chipEls.push(chip);
      }
    },

    _clearChips: function () {
      if (!this.chipEls) return;
      this.chipEls.forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
      this.chipEls = [];
    }
  };

  /* ----------------------------------------------------------
     RACK RAYCASTER — pointer → instance picking

     Active only in 3D stage 1 (the default full-build view). On
     pointermove we ray-test
     against the registered instance meshes and update hover; on
     click we update selection and open the asset drawer.

     Hover and select have DIFFERENT visuals (see BenchHighlight):
       • hover  = subtle emissive glow
       • select = strong outline overlay + accent emissive

     Click on empty space deselects + closes drawer. Re-click on
     the same instance is a no-op (selection unchanged, drawer
     stays open). Click on a different instance auto-switches
     the drawer content (Marek's explicit UX choice).
     ---------------------------------------------------------- */
  global.BenchRaycaster = {
    _raycaster: null,
    _ndc:       null,
    _hovered:   null,    /* instance currently under cursor */
    _selected:  null,    /* instance currently selected (drawer open) */
    _initialized: false,

    init: function () {
      var T = global.THREE;
      var eng = global.BenchEngine;
      if (!T || !eng || !eng.renderer || this._initialized) return;
      this._raycaster = new T.Raycaster();
      this._ndc       = new T.Vector2();
      var canvas      = eng.renderer.domElement;
      var self        = this;
      canvas.addEventListener('pointermove', function (e) { self._onMove(e); });
      canvas.addEventListener('pointerleave', function () { self._clearHover(); });
      canvas.addEventListener('click',       function (e) { self._onClick(e); });
      this._initialized = true;
      if (global.Configurator && global.Configurator.log) {
        global.Configurator.log.log('[raycaster] initialized');
      }
    },

    /* Stage 1 in 3D doubles as the asset-select mode — clicking any
       piece opens the drawer. Stages 2 (inspection) and 3 (profiles)
       are visualisation-only and disable picking so the user can
       study the build without accidentally triggering selects. */
    _isActive: function () {
      return STATE.view === '3d' && STATE.vizStage === 1;
    },

    _pick: function (e) {
      var eng = global.BenchEngine;
      if (!eng || !eng.renderer || !eng.camera) return null;
      var canvas = eng.renderer.domElement;
      var rect   = canvas.getBoundingClientRect();
      this._ndc.x =  ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      this._ndc.y = -((e.clientY - rect.top)  / rect.height) * 2 + 1;
      this._raycaster.setFromCamera(this._ndc, eng.camera);
      var meshes = global.BenchInstances ? global.BenchInstances.meshes() : [];
      if (!meshes.length) return null;
      /* recursive=false: hit only registered top-level meshes, not their
         edge-line children. */
      var hits = this._raycaster.intersectObjects(meshes, false);
      if (!hits.length) return null;
      /* Iterate hits in distance order; pick the first instance whose
         mesh is visible (assembly-step .visible respects intent). */
      for (var i = 0; i < hits.length; i++) {
        var m = hits[i].object;
        if (m.visible === false) continue;
        var inst = global.BenchInstances.findByMesh(m);
        if (inst) return inst;
      }
      return null;
    },

    _onMove: function (e) {
      if (!this._isActive()) { this._clearHover(); return; }
      var inst = this._pick(e);
      var newHover = inst;
      if (this._hovered && this._hovered.id === (inst && inst.id)) return;
      /* leave previous hover */
      if (this._hovered) {
        if (!this._selected || this._selected.id !== this._hovered.id) {
          global.BenchHighlight.unhover(this._hovered);
        }
        this._hovered = null;
      }
      /* enter new hover (skip if it's the already-selected instance) */
      if (newHover) {
        this._hovered = newHover;
        if (!this._selected || this._selected.id !== newHover.id) {
          global.BenchHighlight.hover(newHover);
        }
      }
      /* canvas cursor hint */
      var canvas = global.BenchEngine.renderer.domElement;
      canvas.classList.toggle('cf-asset-hover', !!newHover);
    },

    _clearHover: function () {
      if (this._hovered) {
        if (!this._selected || this._selected.id !== this._hovered.id) {
          global.BenchHighlight.unhover(this._hovered);
        }
        this._hovered = null;
      }
      var eng = global.BenchEngine;
      if (eng && eng.renderer) {
        eng.renderer.domElement.classList.remove('cf-asset-hover');
      }
    },

    _onClick: function (e) {
      if (!this._isActive()) return;
      /* v337 a footprint grip's press is no pick; a + / - disc on the ground fills / empties its field */
      var BHc = global.BenchHandles;
      if (BHc && BHc._fpEat > Date.now()) return;
      var fidC = (BHc && BHc._peDotAt) ? BHc._peDotAt(e.clientX, e.clientY) : '';
      if (fidC) {
        if ((STATE.variant | 0) === 23) { if (global.BenchLib && global.BenchLib.cycleGzField) global.BenchLib.cycleGzField(fidC); }   /* v350 the gazebo's side */
        else if (_isKpType(STATE.variant)) { if (global.BenchLib && global.BenchLib.cycleKpBay) global.BenchLib.cycleKpBay(fidC); }   /* v379 the kitchen pod's bay */
        else if (global.BenchLib && global.BenchLib.cyclePeField) global.BenchLib.cyclePeField(fidC);
        return;
      }
      var inst = this._pick(e);
      if (inst) {
        /* Auto-switch: clear previous selection highlight, set new. */
        if (this._selected && this._selected.id !== inst.id) {
          global.BenchHighlight.deselect(this._selected);
        }
        /* Demote hover on the newly-selected instance so its hover
           emissive doesn't clash with the select outline. */
        if (this._hovered && this._hovered.id === inst.id) {
          global.BenchHighlight.unhover(inst);
          this._hovered = null;
        }
        this._selected = inst;
        global.BenchHighlight.select(inst);
        if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.open) {
          global.ConfiguratorAssetDrawer.open(inst.id);
        }
      } else {
        /* Click on empty space — deselect and close drawer. */
        this._clearSelection();
      }
    },

    /* External clear (called by drawer's onClose so the highlight
       follows the drawer's close button / ESC / outside-click). */
    _clearSelection: function () {
      if (this._selected) {
        global.BenchHighlight.deselect(this._selected);
        this._selected = null;
      }
      if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.isOpen &&
          global.ConfiguratorAssetDrawer.isOpen()) {
        global.ConfiguratorAssetDrawer.close();
      }
    },

    /* Called from BenchRenderer.build() — geometry is gone, so any
       hovered/selected instance reference is now stale. */
    _reset: function () {
      this._hovered  = null;
      this._selected = null;
    },

    /* Stage transition hook — called by BenchEngine.applyVizStage().
       When leaving stage 1, drop hover/select and close drawer. */
    setActive: function (active) {
      var canvas = global.BenchEngine && global.BenchEngine.renderer
                 ? global.BenchEngine.renderer.domElement : null;
      if (canvas) {
        canvas.classList.toggle('cf-asset-pickable', !!active);
        if (!active) canvas.classList.remove('cf-asset-hover');
      }
      if (!active) this._clearSelection();
    }
  };

  /* ----------------------------------------------------------
     RACK HIGHLIGHT — visual marking for hover & select

     Hover: subtle warm emissive glow (#554433 @ 0.35). The mesh
            material is CLONED for the duration of the hover so
            that the shared lumber material (used by multiple
            instances) isn't globally tinted.

     Select: strong sand-gold outline overlay + emissive boost on
             the picked mesh. The outline is a BackSide-rendered
             clone of the mesh geometry, scaled 1.04× — gives a
             clean silhouette even on overlapping pieces and
             respects the depth buffer so it can't be over-drawn
             by nearby meshes.

     Hover and select never coexist on the same mesh: if a hovered
     mesh is then selected, hover is removed first.
     ---------------------------------------------------------- */
  var HOVER_EMISSIVE        = 0x554433;
  var HOVER_INTENSITY       = 0.35;
  var SELECT_EMISSIVE       = 0xff8a00;
  var SELECT_INTENSITY      = 0.45;
  var SELECT_OUTLINE_COLOR  = 0xff8a00;
  var SELECT_OUTLINE_SCALE  = 1.04;

  global.BenchHighlight = {
    hover: function (instance) {
      if (!instance || !instance.mesh || !instance.mesh.material) return;
      if (instance._hoverActive || instance._selectActive) return;
      var mesh = instance.mesh;
      /* Stash the shared material reference, then swap in a clone so
         emissive tinting doesn't bleed to sibling instances. */
      instance._sharedMat = mesh.material;
      mesh.material = mesh.material.clone();
      if (mesh.material.emissive) {
        instance._hoverPrevEmissive  = mesh.material.emissive.getHex();
        instance._hoverPrevIntensity = mesh.material.emissiveIntensity || 0;
        mesh.material.emissive.setHex(HOVER_EMISSIVE);
        mesh.material.emissiveIntensity = HOVER_INTENSITY;
        mesh.material.needsUpdate = true;
      }
      instance._hoverActive = true;
    },

    unhover: function (instance) {
      if (!instance || !instance._hoverActive) return;
      var mesh = instance.mesh;
      if (mesh && mesh.material) {
        try { mesh.material.dispose(); } catch (e) {}
        if (instance._sharedMat) {
          mesh.material = instance._sharedMat;
          delete instance._sharedMat;
        }
      }
      delete instance._hoverPrevEmissive;
      delete instance._hoverPrevIntensity;
      instance._hoverActive = false;
    },

    select: function (instance) {
      if (!instance || !instance.mesh || instance._selectActive) return;
      var T = global.THREE;
      if (!T) return;
      var mesh = instance.mesh;

      /* Emissive boost — same clone-and-replace pattern as hover so
         we don't tint other meshes sharing the same material. */
      instance._sharedMatSel = mesh.material;
      mesh.material = mesh.material.clone();
      if (mesh.material.emissive) {
        mesh.material.emissive.setHex(SELECT_EMISSIVE);
        mesh.material.emissiveIntensity = SELECT_INTENSITY;
        mesh.material.needsUpdate = true;
      }

      /* Outline overlay — BackSide-rendered clone, scaled up slightly.
         Added as a sibling in the same parent (benchGroup) so it inherits
         transforms automatically. */
      if (mesh.geometry) {
        var outlineGeom = mesh.geometry;   /* share geometry — no clone needed */
        var outlineMat  = new T.MeshBasicMaterial({
          color:        SELECT_OUTLINE_COLOR,
          side:         T.BackSide,
          transparent:  false,
          depthWrite:   false,
          polygonOffset: true,
          polygonOffsetFactor: -1,
          polygonOffsetUnits:  -1
        });
        var outline = new T.Mesh(outlineGeom, outlineMat);
        outline.position.copy(mesh.position);
        outline.rotation.copy(mesh.rotation);
        outline.scale.copy(mesh.scale).multiplyScalar(SELECT_OUTLINE_SCALE);
        outline.renderOrder = (mesh.renderOrder || 0) - 1;
        outline.userData.isSelectOutline = true;
        if (mesh.parent) mesh.parent.add(outline);
        instance._outlineMesh = outline;
      }

      instance._selectActive = true;
    },

    deselect: function (instance) {
      if (!instance || !instance._selectActive) return;
      var mesh = instance.mesh;
      /* Remove outline overlay. */
      if (instance._outlineMesh) {
        if (instance._outlineMesh.parent) {
          instance._outlineMesh.parent.remove(instance._outlineMesh);
        }
        if (instance._outlineMesh.material) {
          try { instance._outlineMesh.material.dispose(); } catch (e) {}
        }
        /* Geometry was SHARED — do not dispose. */
        delete instance._outlineMesh;
      }
      /* Restore shared material on the mesh. */
      if (mesh && mesh.material) {
        try { mesh.material.dispose(); } catch (e) {}
        if (instance._sharedMatSel) {
          mesh.material = instance._sharedMatSel;
          delete instance._sharedMatSel;
        }
      }
      instance._selectActive = false;
    },

    /* Called by BenchRenderer.build() right before clearing the group —
       state machine reset for the cases where the user rebuilt while
       a hover/select was active. */
    _reset: function () {
      /* BenchInstances are wiped right after this, so we can't restore
         materials. Just drop our cached references so the upcoming
         clean instances start fresh. */
      if (global.BenchRaycaster && global.BenchRaycaster._reset) {
        global.BenchRaycaster._reset();
      }
    }
  };

  /* ----------------------------------------------------------
     DRAG HANDLES  (DOM positioning + drag logic)
     ---------------------------------------------------------- */
  /* ------------------------------------------------------------------
     v337 THE KIT'S HANDLES, COPIED (Marek 2026-10-21 22:56: Footprint
     points neodpovidaji tomu jak to mame treba u shelters (velikost a
     umisteni points - mame tam i inverzni points v rozich. Musime udrzet
     jednotne ui napric produkty ! Nejak to zapasat a sahat tam v techto
     pripadech). configurator-ui.js handles() -- the ghost rectangle with
     corner and edge grips that IS the shelter's footprint -- is not loaded
     on this page (the bench runs its own engine), so what a footprint uses
     is copied below as it stands in ui-v348: fmtDim, the kota (dimLabel),
     _grips and handles() (renamed _fp*). Changed: the stage is the bench's
     (_fpStage: its scene, the camera and controls of the view -- the kit
     reads one ConfiguratorStage), the view's controls switched off / on by
     the press, opts.blocked (a press the host keeps) and opts.onUp. The
     styles, the hit radius and the logger are the kit's / the bench's.
     ------------------------------------------------------------------ */
  var FP_HIT_PX = 30;
  var FP_STYLES = {
    primary: {
      fill: 0xC49A4A, opacity: 0.03, xray: 0.015, xrayEdge: 24,   /* v341 gold as the kit's ui-v352 (was olive 50 %) */
      edge: 0xC49A4A, corner: 0xC49A4A, mid: 0xffffff, order: 14
    },
    secondary: {
      fill: 0xC49A4A, opacity: 0.03, xray: 0.015, xrayEdge: 24,   /* v341 3 % as the kit's ui-v352 */
      edge: 0xC49A4A, corner: 0xC49A4A, mid: 0xffffff, order: 12
    }
  };
  function _fpGreater() { var T = global.THREE; return (T && T.GreaterDepth != null) ? T.GreaterDepth : 6; }
  function _fpXray(st) { return (st.xray != null) ? st.xray : 0.05; }
  function _fpXrayEdge(st) { return _fpXray(st) * ((st.xrayEdge != null) ? st.xrayEdge : 4); }
  function _fpLog(m) { if (!/^grip/.test(String(m))) _dbg('[fp] ' + m); }
  function _fpStage() {
    var E = global.BenchEngine;
    if (!E || !E.scene || !E.renderer) return null;
    var d2 = (STATE.view === '2d');
    return { scene: E.scene, renderer: E.renderer, camera: (d2 && E.orthoCamera) ? E.orthoCamera : E.camera, controls: d2 ? E.orthoControls : E.controls };
  }
  /* the shelter's + / - dot texture (configurator-ui.js _plusTexture, copied): a near-black disc, a white ring, a white plus -- a minus on a filled bay */
  var _pePlusTexC = {};
  /* v412 SHOU SUGI BAN: a charred board's face -- near black, the fine grain, the 'alligator' cracks with a silvery ridge (a fixed seed) */
  var _kpCharTexC = null;
  function _kpCharTex() {
    if (_kpCharTexC) return _kpCharTexC;
    var T = global.THREE;
    if (!T || !global.document) return null;
    try {
      var c = global.document.createElement('canvas'); c.width = 512; c.height = 512;
      var x = c.getContext('2d'), seed = 412;
      var rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
      x.fillStyle = '#433e3a'; x.fillRect(0, 0, 512, 512);
      var i, y, px;
      for (i = 0; i < 160; i++) {   /* the grain */
        y = rnd() * 512; x.strokeStyle = (rnd() < 0.5) ? 'rgba(18,16,15,0.6)' : 'rgba(110,103,96,0.4)'; x.lineWidth = 0.6 + rnd() * 1.4;
        x.beginPath(); x.moveTo(0, y); for (px = 0; px <= 512; px += 64) x.lineTo(px, y + Math.sin(px / 80 + i) * 2.5); x.stroke();
      }
      for (y = 0; y < 512; ) {   /* the cracks: rows of blocks */
        var hR = 18 + rnd() * 14, x0 = -rnd() * 60;
        for (px = x0; px < 512; ) {
          var wB = 34 + rnd() * 46, j = function () { return (rnd() - 0.5) * 3; };
          x.strokeStyle = 'rgba(8,7,6,1)'; x.lineWidth = 3;
          x.beginPath(); x.moveTo(px + j(), y + j()); x.lineTo(px + wB + j(), y + j()); x.lineTo(px + wB + j(), y + hR + j()); x.stroke();
          x.strokeStyle = 'rgba(160,154,146,0.55)'; x.lineWidth = 1.4;
          x.beginPath(); x.moveTo(px + 2, y + 2); x.lineTo(px + wB - 2, y + 2); x.stroke();
          px += wB;
        }
        y += hR;
      }
      var tex = new T.CanvasTexture(c);
      tex.wrapS = tex.wrapT = T.RepeatWrapping; tex.repeat.set(4, 4);   /* a tile 25 cm on the end walls (their UVs in metres): the cracks 1 - 4 cm; on a board's box face the fine streaks along it */
      try { tex.colorSpace = T.SRGBColorSpace; } catch (e) {}
      tex.anisotropy = 4;
      _kpCharTexC = tex;
      return tex;
    } catch (eC) { return null; }
  }
  /* v413 THE PANEL CLADDINGS' FACES: the corten's weathered rust (mottled, a 1 m tile) and the corrugated sheet's ribs (one rib a texture
     unit, its light and shade baked across); the faces' UVs put in metres along the wall (_kpUvM) so a box and a polygon read the same */
  var _kpCorTexC = null, _kpCorrTexC = null;
  function _kpCorTex() {
    if (_kpCorTexC) return _kpCorTexC;
    var T = global.THREE; if (!T || !global.document) return null;
    try {
      var c = global.document.createElement('canvas'); c.width = 256; c.height = 256;
      var x = c.getContext('2d'), seed = 413, i, rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
      x.fillStyle = '#a8592e'; x.fillRect(0, 0, 256, 256);
      var COL = ['rgba(128,62,32,0.18)', 'rgba(184,104,58,0.18)', 'rgba(112,54,28,0.14)', 'rgba(196,122,70,0.14)', 'rgba(92,46,26,0.12)'];
      for (i = 0; i < 1600; i++) { var r0 = 1 + rnd() * 7, px = rnd() * 256, py = rnd() * 256; x.fillStyle = COL[i % COL.length]; x.beginPath(); x.ellipse(px, py, r0, r0 * (0.5 + rnd() * 0.8), rnd() * 3, 0, Math.PI * 2); x.fill(); }
      for (i = 0; i < 40; i++) { var sx = rnd() * 256; x.strokeStyle = 'rgba(80,38,20,0.18)'; x.lineWidth = 1 + rnd() * 2; x.beginPath(); x.moveTo(sx, rnd() * 100); x.lineTo(sx + (rnd() - 0.5) * 6, 120 + rnd() * 136); x.stroke(); }   /* the run-down streaks */
      var t = new T.CanvasTexture(c); t.wrapS = t.wrapT = T.RepeatWrapping; try { t.colorSpace = T.SRGBColorSpace; } catch (e) {} t.anisotropy = 4;
      return (_kpCorTexC = t);
    } catch (eC) { return null; }
  }
  function _kpCorrTex() {
    if (_kpCorrTexC) return _kpCorrTexC;
    var T = global.THREE; if (!T || !global.document) return null;
    try {
      var c = global.document.createElement('canvas'); c.width = 64; c.height = 4;
      var x = c.getContext('2d'), i;
      for (i = 0; i < 64; i++) { var v = 0.5 + 0.5 * Math.cos(2 * Math.PI * (i + 0.5) / 64 - 0.6), k = Math.round(78 + 62 * v); x.fillStyle = 'rgb(' + k + ',' + (k + 4) + ',' + (k + 8) + ')'; x.fillRect(i, 0, 1, 4); }
      var t = new T.CanvasTexture(c); t.wrapS = t.wrapT = T.RepeatWrapping; try { t.colorSpace = T.SRGBColorSpace; } catch (e) {}
      t.magFilter = T.LinearFilter; t.anisotropy = 8;
      return (_kpCorrTexC = t);
    } catch (eC) { return null; }
  }
  /* a face's UVs in metres along the wall: a face looking along z (an end wall) u = x, any other u = z; v = y, or x on a face looking up
     (the flap open); su / sv the metres a texture unit */
  function _kpUvM(geo, su, sv) {
    try {
      var pos = geo.attributes.position, nor = geo.attributes.normal, uv = geo.attributes.uv, i;
      if (!pos || !nor || !uv) return geo;
      for (i = 0; i < pos.count; i++) {
        var nx = Math.abs(nor.getX(i)), ny = Math.abs(nor.getY(i)), nz = Math.abs(nor.getZ(i));
        var u = (nz >= nx && nz >= ny) ? pos.getX(i) : pos.getZ(i), v = (ny > nx && ny > nz) ? pos.getX(i) : pos.getY(i);
        uv.setXY(i, u / su, v / sv);
      }
      uv.needsUpdate = true;
    } catch (e) {}
    return geo;
  }
  function _pePlusTex(T, filled, cyc) {
    var key = cyc ? 'cyc' : filled ? 'minus' : 'plus';   /* v412 cyc: the core's cycler glyph (two turning arrows, ui core-v503) */
    if (_pePlusTexC[key]) return _pePlusTexC[key];
    var c = document.createElement('canvas');
    c.width = 256; c.height = 256;
    var x = c.getContext('2d');
    x.clearRect(0, 0, 256, 256);
    x.beginPath();
    x.arc(128, 128, 118, 0, Math.PI * 2);
    x.fillStyle = 'rgba(20,21,24,0.92)';
    x.fill();
    x.lineWidth = 12;
    x.strokeStyle = '#ffffff';
    x.stroke();
    x.strokeStyle = '#ffffff';
    x.lineWidth = 16;
    x.lineCap = 'round';
    if (cyc) {   /* v412 (Marek 23:46 "tlacitko plus na zebriku udelej jako cykler", "i na kuchyni udelat tlacitka spise cyklery") */
      var CYC = ['M4 12a8 8 0 0 1 13.66-5.66L20 8.5', 'M20 3.5v5h-5', 'M20 12a8 8 0 0 1-13.66 5.66L4 15.5', 'M4 20.5v-5h5'], sc = 6.2;
      x.save(); x.translate(128 - 12 * sc, 128 - 12 * sc); x.scale(sc, sc); x.lineWidth = 2.3; x.lineJoin = 'round';
      try { CYC.forEach(function (d) { x.stroke(new Path2D(d)); }); }
      catch (eP) { x.beginPath(); x.arc(12, 12, 8, 0.2, Math.PI - 0.2); x.stroke(); x.beginPath(); x.arc(12, 12, 8, Math.PI + 0.2, 2 * Math.PI - 0.2); x.stroke(); }
      x.restore();
    } else {
    x.beginPath(); x.moveTo(66, 128); x.lineTo(190, 128); x.stroke();
    if (!filled) { x.beginPath(); x.moveTo(128, 66); x.lineTo(128, 190); x.stroke(); }
    }
    var tex = new T.CanvasTexture(c);
    try { tex.colorSpace = T.SRGBColorSpace; } catch (e) {}
    tex.anisotropy = 4;
    _pePlusTexC[key] = tex;
    return tex;
  }
  var FP_IN = 0.0254;
  function _fpFmtDim(m, metric) {
    if (metric) return Math.round(m * 1000) + ' mm';
    var sx = m < 0 ? '-' : '';
    var sixteenths = Math.round(Math.abs(m) / FP_IN * 16);
    var ft = Math.floor(sixteenths / 192);
    var rest = sixteenths - ft * 192;
    var inch = Math.floor(rest / 16);
    var frac = rest - inch * 16;

    var fs = '';
    if (frac) {
      var den = 16, num = frac;
      while (num % 2 === 0 && den > 1) { num /= 2; den /= 2; }
      fs = ' ' + num + '/' + den;
    }
    var out = (ft > 0) ? (ft + '\u2032-' + inch + fs) : (inch + fs);
    return sx + out + '\u2033';
  }
  var FP_K_BODY = 8;
  var _fpDimCache = { map: {}, n: 0 };
  function _fpDimLabel(text, cfg) {
    var T = global.THREE, st = _fpStage();
    if (!T) return null;
    /* THE COLOUR IS PART OF THE KEY, OR THE CACHE HANDS BACK THE WRONG ONE.

       The cache is keyed on the string. A number at its limit and the same
       number below it are the same string, so whichever was drawn first would
       be served to both and the red would either never appear or never go
       away. */
    var hot = !!(cfg && cfg.max);
    var ck = (hot ? '!' : '') + text;
    var tex = _fpDimCache.map[ck];
    if (!tex) {
      /* An unbounded cache keyed on every distinct string is a leak with a
         friendly face: a drag produces a new number every few millimetres, each
         one a fresh canvas and a fresh GPU upload that nothing ever frees. */
      if (_fpDimCache.n >= 96) {
        for (var k in _fpDimCache.map) if (_fpDimCache.map.hasOwnProperty(k)) _fpDimCache.map[k].dispose();
        _fpDimCache = { map: {}, n: 0 };
      }
      /* THE HOUSE KOTA, AS THE UX SHEET DRAWS IT.

         White pill, dark number, Montserrat 600, fully rounded. Nothing else --
         no line, no leaders, no heads; those belong to the PDF kota, which is
         read slowly and can afford them. I had it inverted: a dark pill with
         white text, which is a different mark from the one the rest of the site
         uses, and this has to match across the web.

         THE PILL IS SIZED TO THE NUMBER. A fixed canvas gave every label the
         same width, so a short one floated in a wide empty box and the digits
         inside it shrank to fit the longest string the box was built for. The
         text is measured first and the pill is drawn round it, which is what
         makes it a pill rather than a plate -- and it is why the drawn size can
         grow without the number going soft.

         Twice the pixel height it was, so the extra size is extra detail rather
         than a bigger blur. */
      var PAD = 56, H = 160, FS = 88;
      var c = document.createElement('canvas');
      var mctx = c.getContext('2d');
      mctx.font = '600 ' + FS + 'px Montserrat, Arial';
      var tw = Math.ceil(mctx.measureText(text).width);
      c.width = Math.max(H * 1.6, tw + PAD * 2);
      c.height = H;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(0, 0, c.width, H, H / 2); ctx.fill(); }
      else ctx.fillRect(0, 0, c.width, H);
      /* AT THE LIMIT THE NUMBER GOES RED, AND ONLY THE NUMBER.

         The pill stays white. Inverting it would make a different mark from
         the one the rest of the site uses, and the point is not to shout -- it
         is to say which of the two dimensions is the one that stopped. */
      ctx.fillStyle = hot ? '#C8102E' : '#1A1C1D';
      ctx.font = '600 ' + FS + 'px Montserrat, Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, c.width / 2, H / 2 + 2);
      tex = new T.CanvasTexture(c);
      /* the sprite has to know how wide this particular number came out */
      tex.__aspect = c.width / c.height;
      tex.minFilter = T.LinearFilter;
      if (T.SRGBColorSpace) tex.colorSpace = T.SRGBColorSpace;
      _fpDimCache.map[ck] = tex;
      _fpDimCache.n++;
    }
    var cam = st && st.camera;
    var ortho = !!(cam && cam.isOrthographicCamera);
    var sp = new T.Sprite(new T.SpriteMaterial({
      map: tex, transparent: true, depthTest: false, sizeAttenuation: !ortho
    }));
    /* PURE WHITE HAS TO BE EXEMPT FROM TONE MAPPING.

       The pill is drawn #FFFFFF and still came out a soft grey, which is why it
       never quite matched the sheet. Everything in the scene goes through the
       renderer's tone curve on the way to the screen, and that curve pulls the
       top end down so that bright timber does not clip -- exactly what you want
       for a building and exactly what you do not want for a label, which is not
       lit by anything and is supposed to be paper.

       toneMapped false takes this one sprite out of that and hands the canvas
       to the screen as drawn. */
    sp.material.toneMapped = false;
    /* HEIGHT IS THE SIZE; WIDTH FOLLOWS THE NUMBER. Setting both from a fixed
       pair stretched a short label and squashed a long one, which is how the
       digits ended up different sizes from one drag to the next. */
    var asp = tex.__aspect || 3;

    /* THE KOTA IS A SCREEN ELEMENT, IN PLAN TOO.

       The UX sheet draws it as a pill about twenty pixels tall -- a thing that
       sits ON the drawing, not IN it. I had it as a size in metres, which made
       it grow with the building and shrink with the zoom: a metre-tall number
       on a small plan, unreadable on a large one. Sized to the viewport it is
       the same pill everywhere, which is what "must match across the web"
       means.

       AND AN ORTHOGRAPHIC CAMERA DOES NOT HAVE SIZE ATTENUATION. Turning it
       off there does nothing at all: an ortho sprite is always measured in
       world units, so asking for 0.043 asked for a pill four centimetres wide
       standing next to a ten-metre building -- the kota did not shrink, it
       disappeared.

       In plan the same fraction is worked out against the camera's own visible
       height, which is the world size that fills that share of the screen. It
       is read on every redraw, so it tracks the zoom instead of being fixed at
       whatever the zoom happened to be when the label was made. */
    if (cfg && cfg.screen) {
      var hh;
      if (ortho) {
        var vis = ((cam.top - cam.bottom) / (cam.zoom || 1));
        hh = vis * cfg.screen;
      } else {
        hh = cfg.screen;
        sp.material.sizeAttenuation = false;
      }
      sp.scale.set(hh * asp, hh, 1);
      return sp;
    }

    if (ortho) {
      /* Metres, fixed. Taking a share of the ortho span was the obvious thing
         and the wrong one: onResize re-runs setView('2d') with no focus, so the
         span is recomputed from the group's bounding box and the framing jumps.
         Anything scaled off that camera jumps too, and a dimension that changes
         size when you switch windows is not a dimension.

         opts.dimPlan is a product saying how big it wants its plan dimensions,
         as a multiple. Absent, this is the size it always was. */
      var k = (cfg && cfg.plan) ? cfg.plan : 1;
      var h = 0.36 * k;
      sp.scale.set(h * asp, h, 1);
    } else if (false) {
      /* SCREEN-SIZED, WHICH IS WHAT A DIMENSION WANTS TO BE.

         The default below is a world size -- 85 mm wide -- and that is fine on
         a garden bench a metre away. On a house seen from twenty metres it is a
         speck, and the number you are dragging is the one thing that has to
         stay readable at every zoom.

         Turning size attenuation off makes the scale a fraction of the
         viewport instead, so the label is the same size on screen however far
         out you are. Opt in per product: nothing that has not asked changes.
         The canvas is 3:1, so the width follows the height. */
      var hs = cfg.screen;
      sp.material.sizeAttenuation = false;
      sp.scale.set(hs * asp, hs, 1);
    } else {
      sp.scale.set(0.028 * asp, 0.028, 1);
    }
    sp.renderOrder = 40;
    return sp;
  }

  function _fpGrips(r) {
    var mx = (r.x0 + r.x1) / 2, mz = (r.z0 + r.z1) / 2;
    /* A SIDE'S GRIP CAN BE LEFT OUT (core-v448): noGrip = ['z0', ...] on a rect
       drops that side's grip -- the wing's side on the bar, the bar's side
       under the wing */
    var no = r.noGrip || [];
    var gx0 = mx, gx1 = mx, gz0 = mz, gz1 = mz;
    var out = [
      { k: 0, edge: false, x: r.x0, z: r.z0, px: r.x1, pz: r.z1 },
      { k: 1, edge: false, x: r.x1, z: r.z0, px: r.x0, pz: r.z1 },
      { k: 2, edge: false, x: r.x1, z: r.z1, px: r.x0, pz: r.z0 },
      { k: 3, edge: false, x: r.x0, z: r.z1, px: r.x1, pz: r.z0 },
      { k: 4, edge: true, x: gx0, z: r.z0, px: null, pz: r.z1, side: 'z0' },
      { k: 5, edge: true, x: r.x1, z: gz1, px: r.x0, pz: null, side: 'x1' },
      { k: 6, edge: true, x: gx1, z: r.z1, px: null, pz: r.z0, side: 'z1' },
      { k: 7, edge: true, x: r.x0, z: gz0, px: r.x1, pz: null, side: 'x0' }
    ];
    if (no.length) out = out.filter(function (g) { return !g.side || no.indexOf(g.side) < 0; });
    /* edge grips only (core-v507): a corner would drag a side that must not move */
    if (r.edgeOnly) out = out.filter(function (g) { return g.edge; });
    return out;
  }

  function _fpHandles(opts) {
    if (!opts || typeof opts.rects !== 'function') { _fpLog('handles() needs rects()'); return null; }

    var api = {
      _grp: null, _plane: null, _drag: null, _bound: false,
      _y: (opts.y != null) ? opts.y : 0.04,
      /* A RECTANGLE AT ITS OWN HEIGHT (ui-v179, RANCH: the cross gables' ghosts
         lay on the ground under the house -- hidden by the roof, their grips
         specks in odd places, and a tap on the gable seen on the roof landed on
         the ground behind it and turned the camera). A rect with y is drawn,
         hit and dragged on the level plane at that height; without y it stays
         on the set's own level, exactly as before. */
      _yOf: function (r) { return (r && r.y != null && isFinite(r.y)) ? +r.y : this._y; },

      _rects: function () { return opts.rects() || []; },
      _active: function () { return opts.active ? !!opts.active() : true; },

      _ensureGrp: function () {
        var T = global.THREE, st = _fpStage();
        if (!T || !st || !st.scene) return null;
        if (!this._grp) {
          this._grp = new T.Group();
          this._grp.userData.arSkip = true;
          st.scene.add(this._grp);
        }
        return this._grp;
      },
      _clear: function () {
        if (!this._grp) return;
        for (var i = this._grp.children.length - 1; i >= 0; i--) {
          var c = this._grp.children[i];
          if (c.geometry) c.geometry.dispose();
          this._grp.remove(c);
        }
      },

      _rect3: function (r, st) {
        var T = global.THREE;
        var w = Math.abs(r.x1 - r.x0), l = Math.abs(r.z1 - r.z0);
        var cx = (r.x0 + r.x1) / 2, cz = (r.z0 + r.z1) / 2;
        var self = this;
        function pass(op, behind) {
          var g = new T.Mesh(
            new T.PlaneGeometry(w, l),
            new T.MeshBasicMaterial({
              color: st.fill, transparent: true, opacity: op, side: T.DoubleSide,
              depthTest: true, depthWrite: false,
              depthFunc: behind ? _fpGreater() : undefined
            })
          );
          g.rotation.x = -Math.PI / 2;
          g.position.set(cx, self._yOf(r), cz);
          g.renderOrder = st.order + (behind ? 0 : 1);
          self._grp.add(g);
        }
        /* NO FILL WHEN THE CALLER SAYS SO: the tinted plane lies over whatever
           is drawn under it -- on a house plan the rooms -- and changes their
           colours. fill: false keeps the outline and the pucks and draws no
           plane at all (ADU, ui-v105). */
        /* core-v726 (TAURUS, Marek: zvyraznit v pudorysu lepe i pristavbu,
           je tam jen tenky ramecek): a rect may ask for its fill (r.fill) and
           its strength (r.fillOp) where the page draws none */
        if (opts.fill === false && !r.fill) return;
        pass((r.fillOp != null) ? r.fillOp : st.opacity, false);
        pass(_fpXray(st), true);
      },
      _outline3: function (r, st) {
        var T = global.THREE, y = this._yOf(r), self = this;
        /* ONE OUTLINE FOR TWO RECTANGLES THAT TOUCH (core-v430, Marek: ma mit
           tvar stavby, T, ne dva obdelniky). Where an edge of this rect lies
           inside another rect of the same style -- the wing's roof on the bar's
           -- that edge is left out, so the two ghosts read as one T. The grips
           and the fills stay as they are. */
        var others = (this._rects() || []).filter(function (o) { return o !== r && o.key !== r.key && !o.bare && (FP_STYLES[o.style] || FP_STYLES.primary) === st; });
        function hidden(ax, az, bx, bz) {
          var mx = (ax + bx) / 2, mz = (az + bz) / 2, q;
          for (q = 0; q < others.length; q++) {
            var o = others[q];
            if (mx > o.x0 + 0.01 && mx < o.x1 - 0.01 && mz > o.z0 + 0.01 && mz < o.z1 - 0.01) return true;
          }
          return false;
        }
        var edges = [[r.x0, r.z0, r.x1, r.z0], [r.x1, r.z0, r.x1, r.z1], [r.x1, r.z1, r.x0, r.z1], [r.x0, r.z1, r.x0, r.z0]], pts = [], qe;
        for (qe = 0; qe < edges.length; qe++) {
          var e = edges[qe];
          if (hidden(e[0], e[1], e[2], e[3])) continue;
          pts.push(new T.Vector3(e[0], y, e[1]), new T.Vector3(e[2], y, e[3]));
        }
        if (!pts.length) return;
        function pass(op, behind) {
          var l = new T.LineSegments(new T.BufferGeometry().setFromPoints(pts),
            new T.LineBasicMaterial({
              color: st.edge, transparent: true, opacity: op,
              depthTest: true, depthWrite: false,
              depthFunc: behind ? _fpGreater() : undefined
            }));
          l.renderOrder = st.order + (behind ? 2 : 3);
          self._grp.add(l);
        }
        pass(0.95, false);
        /* core-v726: a rect that asks for it (r.band, metres) gets its edges
           as flat bands too -- a line is a hair on a tablet */
        if (r.band > 0) {
          for (qe = 0; qe < edges.length; qe++) {
            var eb = edges[qe];
            if (hidden(eb[0], eb[1], eb[2], eb[3])) continue;
            var lenB = Math.hypot(eb[2] - eb[0], eb[3] - eb[1]);
            if (!(lenB > 0.01)) continue;
            var qb = new T.Mesh(new T.PlaneGeometry(lenB + r.band, r.band),
              new T.MeshBasicMaterial({ color: st.edge, transparent: true, opacity: 0.85, side: T.DoubleSide, depthTest: true, depthWrite: false }));
            qb.rotation.x = -Math.PI / 2;
            qb.rotation.z = -Math.atan2(eb[3] - eb[1], eb[2] - eb[0]);
            qb.position.set((eb[0] + eb[2]) / 2, y + 0.002, (eb[1] + eb[3]) / 2);
            qb.renderOrder = st.order + 3;
            self._grp.add(qb);
          }
        }
        pass(_fpXrayEdge(st), true);
      },
      _icons: function (L) {
        var T = global.THREE, q;
        if (!T || !T.Sprite) return;
        this._icoMat = this._icoMat || {};
        for (q = 0; q < L.length; q++) {
          var ic = L[q];
          if (!ic || !ic.map || !ic.at) continue;
          var id = ic.map.uuid || String(q), sm = this._icoMat[id];
          if (!sm) sm = this._icoMat[id] = new T.SpriteMaterial({ map: ic.map, transparent: true, depthTest: false, depthWrite: false, sizeAttenuation: false });
          var sp = new T.Sprite(sm), dd = ic.d || 0.04;
          sp.scale.set(dd, dd, 1); sp.renderOrder = 60;
          sp.position.set(ic.at[0], ic.at[1], ic.at[2]);
          if (ic.cx != null && sp.center && sp.center.set) sp.center.set(ic.cx, 0.5);
          this._grp.add(sp);
        }
      },
      _puck: function (x, z, rad, color, order, y) {
        var T = global.THREE;
        var m = new T.Mesh(new T.CircleGeometry(rad, 24),
          new T.MeshBasicMaterial({ color: color, transparent: true, opacity: 0.95, depthTest: false }));
        m.rotation.x = -Math.PI / 2;
        m.position.set(x, ((y != null) ? y : this._y) + 0.02, z);
        m.renderOrder = order + 6;
        this._grp.add(m);
      },
      _label: function (lab, x, z) {
        /* THE WHOLE LABEL, NOT JUST ITS TEXT.

           dims() has been returning max: true on the dimension that has
           stopped for some time and this took only the string, so the flag
           arrived and was dropped on the floor. */
        var text = (lab && lab.text != null) ? lab.text : lab;
        var hot = !!(lab && lab.max);
        /* opts.dimScreen is the product saying how big it wants its dimensions
           on screen. Absent, everything behaves exactly as it did. */
        var cfg = (opts.dimScreen || opts.dimPlan || hot)
          ? { screen: opts.dimScreen, plan: opts.dimPlan, max: hot } : null;
        var sp = _fpDimLabel(text, cfg);
        if (!sp) return;
        /* ui-v179: a label may say its own height, as its rect does */
        var ly = (lab && lab.y != null && isFinite(lab.y)) ? +lab.y : this._y;
        sp.position.set(x, ly + 0.5, z);
        this._grp.add(sp);
        if (!hot) return;

        /* AND THE WORD UNDERNEATH, IN SCREEN SPACE.

           Offsetting it in the world would put it below the number in a plan
           view and beside it, or behind it, from anywhere else -- the model
           turns and the word wanders off. A sprite's centre is the point that
           lands on its position, so pushing the centre past its own height
           hangs the word under the number on the SCREEN, whatever the camera
           is doing.

           Same size and same face as the number: it is the second half of the
           same message, not a footnote to it. */
        var mx = _fpDimLabel('MAX', cfg);
        if (!mx) return;
        mx.position.set(x, ly + 0.5, z);
        if (mx.center && mx.center.set) mx.center.set(0.5, 1.75);
        this._grp.add(mx);
      },

      /* Scales with the object so it reads right on a 3 m pergola and on a 12 m
         stack alike. The hit area stays FP_HIT_PX either way -- that is what makes
         it usable on a tablet. Override per configurator with opts.puck. */
      _radius: function (r) {
        var p = opts.puck || {};
        var mn = Math.min(Math.abs(r.x1 - r.x0), Math.abs(r.z1 - r.z0));
        var lo = (p.min != null) ? p.min : 0.05;    /* v341 as the kit's ui-v352 smaller pucks (Marek: mensi drag pointy): 0.075 / 0.15 / 2.6 % -> 0.05 / 0.10 / 1.8 % */
        var hi = (p.max != null) ? p.max : 0.10;
        var fr = (p.frac != null) ? p.frac : 0.018;
        return Math.max(lo, Math.min(hi, mn * fr));
      },

      _screenOf: function (x, z, y) {
        var T = global.THREE, st = _fpStage();
        if (!T || !st || !st.camera || !st.renderer) return null;
        var v = new T.Vector3(x, (y != null) ? y : this._y, z);
        v.project(st.camera);
        if (v.z > 1) return null;
        var b = st.renderer.domElement.getBoundingClientRect();
        return { x: b.left + (v.x + 1) / 2 * b.width, y: b.top + (1 - v.y) / 2 * b.height };
      },

      _groundHit: function (cx, cy, y) {
        var T = global.THREE, st = _fpStage();
        if (!T || !st || !st.camera || !st.renderer) return null;
        var b = st.renderer.domElement.getBoundingClientRect();
        var ndc = new T.Vector2(((cx - b.left) / b.width) * 2 - 1, -((cy - b.top) / b.height) * 2 + 1);
        var rc = new T.Raycaster();
        rc.setFromCamera(ndc, st.camera);
        if (!this._plane) this._plane = new T.Plane(new T.Vector3(0, 1, 0), 0);
        /* ui-v179: the level plane of a rect with its own height */
        var pl = (y != null && isFinite(y)) ? new T.Plane(new T.Vector3(0, 1, 0), -y) : this._plane;
        var hit = new T.Vector3();
        return rc.ray.intersectPlane(pl, hit) ? hit : null;
      },

      /* nearest grip across every rectangle, within its pixel radius */
      _hitAt: function (cx, cy) {
        if (opts.blocked && opts.blocked(cx, cy)) return null;   /* bench-v337: a + / - disc under the finger is its own */
        var rs = this._rects(), best = null, bd = 1e9, i, j, gs, s, dx, dy, d2;
        /* core-v623: A RECT'S OWN ICONS BEFORE ANY GRIP (RANCH: a cross
           gable's icons near the roof ghost's grips lost the press to a grip
           within 30 px) -- the icons are drawn on top, so they answer first.
           hitScreen may answer 'tap': a press there is a tap only (an on / off
           icon), never a drag, however far the finger slides */
        for (i = rs.length - 1; i >= 0; i--) {
          var rI = rs[i], ownI = false;
          if (rI.movable === false || typeof rI.hitScreen !== 'function') continue;
          try { ownI = rI.hitScreen(cx, cy); } catch (eHI) { ownI = false; }
          if (!ownI) continue;
          var gI = (rI.y != null && isFinite(rI.y)) ? this._groundHit(cx, cy, +rI.y) : this._groundHit(cx, cy);
          if (!gI) gI = { x: (rI.x0 + rI.x1) / 2, z: (rI.z0 + rI.z1) / 2 };
          return { rect: rI, grip: { k: FP_K_BODY, edge: false, body: true, x: gI.x, z: gI.z, tapOnly: ownI === 'tap' } };
        }
        for (i = 0; i < rs.length; i++) {
          gs = _fpGrips(rs[i]);
          for (j = 0; j < gs.length; j++) {
            s = this._screenOf(gs[j].x, gs[j].z, rs[i].y);
            if (!s) continue;
            dx = cx - s.x; dy = cy - s.y;
            d2 = dx * dx + dy * dy;
            if (d2 <= FP_HIT_PX * FP_HIT_PX && d2 < bd) {
              bd = d2;
              best = { rect: rs[i], grip: gs[j] };
            }
          }
        }
        if (best) return best;

        /* Nothing under the thumb, so fall back to the footprint: grabbing the
           body moves the whole thing. Grips are tested first, otherwise a
           corner sitting inside its own rect could never be picked. Last rect
           wins, matching the draw order.

           movable:false opts a rect out. The base building of a configurator
           has nowhere to move to -- it IS the project origin -- and swallowing
           the press there costs the host every tap on the model, because this
           listener runs in the capture phase. Fitouts placed around the build
           (a pergola, a shed) leave it at the default and stay grabbable. */
        /* ui-v179: each rect on its own level -- the ground's hit for the rest */
        var g0 = this._groundHit(cx, cy), g;
        /* A RECT MAY CLAIM A PRESS BY ITS OWN SCREEN TEST (core-v588, RANCH:
           the cross gables' round icons stand side by side on the lid and,
           zoomed out, past its footprint). hitScreen(cx, cy) true = a body
           press on that rect; tested before the footprints, icons draw on top.
           Such a rect is hit ONLY by its own test, never by its footprint, so a
           press on the roof around it still turns the camera. A rect without
           it is hit exactly as before. */
        for (i = rs.length - 1; i >= 0; i--) {
          var rS = rs[i], own = false;
          if (rS.movable === false || typeof rS.hitScreen !== 'function') continue;
          try { own = !!rS.hitScreen(cx, cy); } catch (eHS) { own = false; }
          if (!own) continue;
          g = (rS.y != null && isFinite(rS.y)) ? this._groundHit(cx, cy, +rS.y) : g0;
          if (!g) g = { x: (rS.x0 + rS.x1) / 2, z: (rS.z0 + rS.z1) / 2 };
          return { rect: rS, grip: { k: FP_K_BODY, edge: false, body: true, x: g.x, z: g.z } };
        }
        for (i = rs.length - 1; i >= 0; i--) {
          var r = rs[i];
          if (r.movable === false || typeof r.hitScreen === 'function') continue;
          g = (r.y != null && isFinite(r.y)) ? this._groundHit(cx, cy, +r.y) : g0;
          if (!g) continue;
          if (g.x >= Math.min(r.x0, r.x1) && g.x <= Math.max(r.x0, r.x1) &&
              g.z >= Math.min(r.z0, r.z1) && g.z <= Math.max(r.z0, r.z1)) {
            return { rect: r, grip: { k: FP_K_BODY, edge: false, body: true, x: g.x, z: g.z } };
          }
        }
        return null;
      },

      refresh: function () {
        if (!this._ensureGrp()) return;
        this._clear();
        if (!this._active()) return;
        var rs = this._rects(), i, j, gs, st, rad, r, on;
        for (i = 0; i < rs.length; i++) {
          r = rs[i];
          st = FP_STYLES[r.style] || FP_STYLES.primary;
          /* bare (core-v588): no fill and no outline -- the product draws its
             own marks (RANCH cross gables: the line over the gable is gone) */
          if (!r.bare) {
            this._rect3(r, st);
            this._outline3(r, st);
          }
          rad = this._radius(r);
          gs = _fpGrips(r);
          for (j = 0; j < gs.length; j++) {
            on = this._drag && this._drag.key === r.key && this._drag.k === gs[j].k;
            this._puck(gs[j].x, gs[j].z, rad * (on ? 1.25 : 1),
                       gs[j].edge ? st.mid : st.corner, st.order, this._yOf(r));
          }
          /* A RECT'S OWN ICONS (core-v623, RANCH: the cross gables' move /
             project / on-off icons were drawn by the build -- on screen while
             the handles were off (the strip on the covering or the base), so a
             tap fell through to the camera). Drawn here they are on screen
             exactly when the rect takes presses: r.icons = [{ at: [x, y, z],
             map: texture, d: diameter as a share of the view, cx: the sprite's
             centre x (pushes it across the screen) }], facing the camera */
          if (r.icons && r.icons.length) this._icons(r.icons);
        }
        var d = this._drag;
        if (d && d.moved && opts.dims) {
          var labels = opts.dims(d.key, d.k) || [];
          for (i = 0; i < labels.length; i++) this._label(labels[i], labels[i].x, labels[i].z);
        } else if (opts.dims && opts.dimsHold && opts.dimsHold()) {
          /* A DIMENSION AT ITS LIMIT STAYS ON SCREEN. The labels are drawn
             while a grip moves and cleared when it is let go, so a size dragged
             to its maximum and released showed nothing red and nothing that
             said MAX. When the product says a limit is standing (dimsHold),
             its maxed labels are kept up between drags, over whatever the
             plan draws there itself (ADU, ui-v106). */
          var held = opts.dims(null, -1) || [];
          for (i = 0; i < held.length; i++) {
            if (held[i] && held[i].max) this._label(held[i], held[i].x, held[i].z);
          }
        }
      },

      bind: function () {
        if (this._bound) return api;
        var st = _fpStage();
        if (!st || !st.renderer || !st.renderer.domElement) return api;
        this._bound = true;
        var self = this;

        st.renderer.domElement.addEventListener('pointerdown', function (e) {
          if (!self._active()) return;
          var h = self._hitAt(e.clientX, e.clientY);
          if (!h) return;
          e.preventDefault(); e.stopPropagation();
          var ctlD = (_fpStage() || {}).controls;   /* bench-v337: the view's own controls (the bench has two) */
          if (ctlD) ctlD.enabled = false;
          self._drag = { key: h.rect.key, k: h.grip.k, edge: h.grip.edge,
                         px: h.grip.px, pz: h.grip.pz, snap: h.rect.snap || 0.1, moved: false,
                         /* core-v623: a press on a tap-only icon never drags */
                         tapOnly: !!h.grip.tapOnly,
                         /* ui-v184: where the press landed, for a tap */
                         tap: { x: h.grip.x, z: h.grip.z, y: (h.rect.y != null && isFinite(h.rect.y)) ? +h.rect.y : self._y, cx: e.clientX, cy: e.clientY },
                         /* ui-v179: dragged on its own level */
                         y: (h.rect.y != null && isFinite(h.rect.y)) ? +h.rect.y : null };
          self._drag.ctl = ctlD;
          if (h.grip.body) {
            /* remember the grab point and the size, so the rect slides under the
               thumb instead of jumping its corner to the cursor */
            self._drag.body = true;
            self._drag.w = h.rect.x1 - h.rect.x0;
            self._drag.l = h.rect.z1 - h.rect.z0;
            self._drag.ox = h.grip.x - h.rect.x0;
            self._drag.oz = h.grip.z - h.rect.z0;
          }
          self.refresh();
        }, true);

        global.addEventListener('pointermove', function (e) {
          var d = self._drag;
          if (!d || !self._active()) return;
          /* A FINGER THAT WOBBLES IS STILL A TAP (ui-v224, Marek: the cross
             gables' on / off on the RANCH mostly did nothing). Any pointermove
             made the press a drag, and a finger on a tablet always sends a
             few -- so the tap on the icon went out as a body drag of a few
             millimetres and the icon never heard it. A press is a drag only
             once it has gone 10 px (touch) / 5 px (mouse, pen) from where it
             landed. */
          if (!d.moved && d.tapOnly) return;   /* core-v623: an on / off icon is a tap however the finger slides */
          if (!d.moved && d.tap) {
            var lim = (e.pointerType === 'touch') ? 10 : 5, ddx = e.clientX - d.tap.cx, ddy = e.clientY - d.tap.cy;
            if (ddx * ddx + ddy * ddy <= lim * lim) return;
          }
          var g = self._groundHit(e.clientX, e.clientY, d.y);
          if (!g) return;
          d.moved = true;
          var sn = d.snap;
          var prop = {};
          if (d.body) {
            /* whole-rect move: size is fixed, both edges travel together */
            var bx = Math.round((g.x - d.ox) / sn) * sn;
            var bz = Math.round((g.z - d.oz) / sn) * sn;
            prop.x0 = bx; prop.x1 = bx + d.w;
            prop.z0 = bz; prop.z1 = bz + d.l;
            try { _fpLog('grip     ' + d.key + ' grip ' + d.k + ' -> ' + ['x0', 'x1', 'z0', 'z1'].filter(function (kk) { return prop && prop[kk] != null; }).map(function (kk) { return kk + ' ' + Math.round(prop[kk] * 1000); }).join(', ')); } catch (eGL) {}
          if (opts.apply) opts.apply(d.key, prop, d.k);
            self.refresh();
            return;
          }
          /* pin the far side, snap the moving side; a null pin means that axis
             is not this grip's business and stays untouched */
          if (d.px != null) {
            var nx = Math.round(g.x / sn) * sn;
            prop.x0 = Math.min(d.px, nx); prop.x1 = Math.max(d.px, nx);
          }
          if (d.pz != null) {
            var nz = Math.round(g.z / sn) * sn;
            prop.z0 = Math.min(d.pz, nz); prop.z1 = Math.max(d.pz, nz);
          }
          try { _fpLog('grip     ' + d.key + ' grip ' + d.k + ' -> ' + ['x0', 'x1', 'z0', 'z1'].filter(function (kk) { return prop && prop[kk] != null; }).map(function (kk) { return kk + ' ' + Math.round(prop[kk] * 1000); }).join(', ')); } catch (eGL) {}
          if (opts.apply) opts.apply(d.key, prop, d.k);
          self.refresh();
        }, true);

        global.addEventListener('pointerup', function () {
          var d = self._drag;
          if (!d) return;
          self._drag = null;
          if (d.ctl) d.ctl.enabled = true;
          if (opts.onUp) opts.onUp(d);   /* bench-v337: the click after it is no pick */
          if (d.moved && opts.onCommit) opts.onCommit();
          /* A press that never moved is a tap, not a drag. Without this the
             host loses the gesture entirely once the body becomes grabbable. */
          if (!d.moved && opts.onTap) opts.onTap(d.key, d.k, d.tap);
          self.refresh();
        }, true);

        _fpLog('handles ' + (opts.id || '?') + ' bound');
        return api;
      },

      destroy: function () {
        this._clear();
        var st = _fpStage();
        if (this._grp && st && st.scene) st.scene.remove(this._grp);
        this._grp = null;
      }
    };
    return api;
  }

  global.BenchHandles = {
    el: { L: null, W: null, H: null, label: null },
    dragging: null,
    dragStart: { x: 0, y: 0, value: 0 },

    init: function () {
      this.el.L     = document.getElementById('cf-handle-l');
      this.el.W     = document.getElementById('cf-handle-w');
      this.el.H     = document.getElementById('cf-handle-h');
      this.el.label = document.getElementById('cf-handle-label');
      /* Stage 2 elevation-specific handles — pure DOM references for now,
         positioning is added in repositionElevations(). Drag listeners
         come in a later refactor step. */
      this.el.elevFrontL = document.getElementById('cf-handle-elev-front-l');
      this.el.elevFrontH = document.getElementById('cf-handle-elev-front-h');
      this.el.elevSideW  = document.getElementById('cf-handle-elev-side-w');
      this.el.elevSideH  = document.getElementById('cf-handle-elev-side-h');
      if (!this.el.L) return;

      var self = this;
      ['L', 'W', 'H'].forEach(function (k) {
        var el = self.el[k];
        var axis = k === 'L' ? 'length' : k === 'W' ? 'width' : 'height';
        if (!el) return;
        el.addEventListener('mousedown',  function (e) { self._start(axis, e); });
        el.addEventListener('touchstart', function (e) { self._start(axis, e); }, { passive: false });
      });

      /* Drag listeners on elevation handles. Each handle has a data-axis
         attribute mapping to length/width/height; we reuse the same
         _start / _move / _end pipeline so STATE.L/W/H updates flow
         through the existing render+refresh logic identically.
         _start branches on STATE.view + vizStage to pick the right
         camera for screen-axis projection — that branch already exists
         in this file, so no duplication needed. */
      [
        ['elevFrontL', 'length'],
        ['elevFrontH', 'height'],
        ['elevSideW',  'width'],
        ['elevSideH',  'height']
      ].forEach(function (pair) {
        var el = self.el[pair[0]];
        var axis = pair[1];
        if (!el) return;
        el.addEventListener('mousedown',  function (e) { self._start(axis, e); });
        el.addEventListener('touchstart', function (e) { self._start(axis, e); }, { passive: false });
      });

      window.addEventListener('mousemove', function (e) { self._move(e); });
      window.addEventListener('touchmove', function (e) { self._move(e); }, { passive: false });
      window.addEventListener('mouseup',   function ()  { self._end(); });
      window.addEventListener('touchend',  function ()  { self._end(); });
    },

    /* Position the elevation handles for 2D stage 2 (side view / bokorys).
       Single camera (orthoCameraSide), full canvas — no viewport halving.
       Only W + H handles are used; front-L and front-H stay hidden until
       stage 3 (front elevation) is added.
         side-w : world (0, 0, -W/2)      → bottom-right corner of side rack
         side-h : world (0, H/2, -W/2)    → middle-right edge of side rack
       Called every frame in stage 2 by the animation loop AFTER
       _fitSideElevationCamera so projection uses up-to-date frustum. */
    repositionElevations: function () {
      var eng = global.BenchEngine;
      if (!eng || !eng.orthoCameraSide) return;
      if (!this.el.elevSideW) return;
      var T = global.THREE;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var W_ = rect.width;
      var H_ = rect.height;

      function project(cam, x, y, z) {
        var v = new T.Vector3(x, y, z).project(cam);
        return {
          x: (v.x * 0.5 + 0.5) * W_,
          y: (1 - (v.y * 0.5 + 0.5)) * H_
        };
      }

      var Wd = STATE.W, Hg = STATE.H;
      var cS = eng.orthoCameraSide;

      var pSW = project(cS, 0, 0,        -Wd / 2);
      var pSH = project(cS, 0, Hg / 2,   -Wd / 2);

      this.el.elevSideW.style.left = pSW.x + 'px'; this.el.elevSideW.style.top = pSW.y + 'px';
      this.el.elevSideH.style.left = pSH.x + 'px'; this.el.elevSideH.style.top = pSH.y + 'px';

      /* Front handles unused in single-view side elevation — hide them. */
      if (this.el.elevFrontL) this.el.elevFrontL.classList.remove('cf-elev-visible');
      if (this.el.elevFrontH) this.el.elevFrontH.classList.remove('cf-elev-visible');

      /* One-shot diagnostic. */
      if (!this._elevHandlesLogged) {
        this._elevHandlesLogged = true;
        var DL = global.Configurator && global.Configurator.log;
        if (DL) {
          DL.log('[elev-handles] (single side view) canvas=' + Math.round(W_) + 'x' + Math.round(H_) +
                 ' side-W=(' + Math.round(pSW.x) + ',' + Math.round(pSW.y) +
                 ') side-H=(' + Math.round(pSH.x) + ',' + Math.round(pSH.y) + ')');
        }
      }
    },

    /* Position the LEGACY handles (cf-handle-l/w/h). Used only in 3D and
       2D stage 1 — in 2D stage 2 they are hidden and repositionElevations()
       handles the stage-specific elevation handle set instead.

       Camera: perspective (3D) or top-down ortho (2D plan). Single camera,
       full canvas — no viewport halving, no multi-camera switching. */
    reposition: function () {
      var eng = global.BenchEngine;
      if (!eng || !eng.camera || !this.el.L) return;

      /* Drag handles MUST stay hidden in (a) assembly mode (step ≠ 0) and
         (b) any 3D viz stage other than 1 — inspection / profiles / section
         cut. The visibility refresh hides them, but this reposition runs
         every frame on the controls 'change' event and would otherwise
         reset display='' on the row below. Bail out early in those modes. */
      if ((STATE.assemblyStep | 0) !== 0 ||
          (STATE.view === '3d' && STATE.vizStage !== 1)) {
        if (this.el.L) this.el.L.style.display = 'none';
        if (this.el.W) this.el.W.style.display = 'none';
        if (this.el.H) this.el.H.style.display = 'none';
        this._fpSync();       /* v337 the footprint (off here) */
        this._peDots(false);  /* -- and the + / - discs */
        return;
      }

      var T = global.THREE;
      var canvas = eng.renderer.domElement;
      var rect = canvas.getBoundingClientRect();
      var camera = (STATE.view === '2d' && eng.orthoCamera) ? eng.orthoCamera : eng.camera;

      function project(x, y, z) {
        var v = new T.Vector3(x, y, z).project(camera);
        return {
          x: (v.x * 0.5 + 0.5) * rect.width,
          y: (1 - (v.y * 0.5 + 0.5)) * rect.height
        };
      }

      /* v337 THE GARDEN ARBOR AND THE PERGOLA: the shelter's footprint (the
         kit's handles, _fpHandles) instead of the DOM handles; the pergola's
         + / - discs on the ground (3D) */
      var vFp = STATE.variant | 0;
      this._fpSync();
      if (vFp === 22 || vFp === 24 || _isPhType(vFp) || _isGhType(vFp) || _isKpType(vFp)) {   /* v376 + the kitchen pod */   /* v373 + the greenhouse */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 + the cottage */
        if (this.el.L) this.el.L.style.display = 'none';
        if (this.el.W) this.el.W.style.display = 'none';
        if (this.el.H) this.el.H.style.display = 'none';
        this._peDots(STATE.view !== '2d');
        return;
      }

      var W = STATE.W, L = STATE.L, H = STATE.H;
      var pL, pW, pH;
      var hideH = false;
      var hideW = false;
      var hideL = false;

      if (STATE.view === '2d' && STATE.vizStage === 1) {
        /* Plan — W dim on TOP edge, L dim on RIGHT edge → shared corner
           is TOP-RIGHT. Move W handle to TOP-LEFT (only W dim) and L
           handle to BOTTOM-RIGHT (only L dim). H is hidden — pointless
           in plan AND it overlaps L (DOM order would steal clicks). */
        pW = project(-W / 2, 0, -L / 2);
        pL = project( W / 2, 0,  L / 2);
        pH = null; hideH = true;
      } else if (STATE.view === '2d' && STATE.vizStage === 2) {
        /* Bokorys (side elevation) — sees L × H. H dim on LEFT, L dim on
           BOTTOM. H handle on top-left, L handle on bottom-right. W is
           hidden (degenerate from this view) so it can't steal clicks
           from L which would otherwise sit on the same corner. */
        pH = project(0,  H,     L / 2);
        pL = project(0,  0,    -L / 2);
        pW = null; hideW = true;
      } else if (STATE.view === '2d' && STATE.vizStage === 3) {
        /* Nárys (front elevation) — sees W × H. H dim on LEFT, W dim on
           BOTTOM. H handle on top-left, W handle on bottom-right. L is
           hidden (degenerate from this view). */
        pH = project(-W / 2,  H,   0);
        pW = project( W / 2,  0,   0);
        pL = null; hideL = true;
      } else if (_isStandType(STATE.variant)) {
        /* 3D HOLLYWOOD / A-FRAME SWING: only the width (L) handle, at the
           front end of the seat on the +Z side. Depth and height come from
           the stand, the back from the slider. */
        var sgH = _standLayout(STATE);
        pL = project(sgH.seatXMax + 0.06, 0.45, L / 2 + (((STATE.variant | 0) === 8) ? 0.10 : 0.06));
        pW = null;
        pH = null;   /* v235: the pitch is on the slider, no ridge handle (Marek) */
      } else if ((STATE.variant | 0) === 14) {
        /* v273 3D BED: the width handle (it steps through the mattress
           widths) -- v274: on the mattress's front foot corner (+X, +Z),
           was the middle of the +X side rail; the headboard's height on the
           +X end of its top rail; no length (the mattress sets it) */
        var bdH = _bedLayout(STATE);
        pW = project(bdH.matt.w / 2, bdH.mattTop, bdH.matt.l / 2);
        pH = bdH.headboard ? project(bdH.W / 2 + 0.05, bdH.top - bdH.P / 2, -bdH.L / 2 + bdH.P / 2) : null;
        pL = null;
      } else if ((STATE.variant | 0) === 21) {
        /* v318 the floating bed: only the width (the mattress sizes), its dot
           on the mattress's front foot corner (as the bed's) */
        var fbH = _fbLayout(STATE);
        pW = project(fbH.matt.w / 2, fbH.yM, fbH.zF);
        pL = null;
        pH = null;
      } else if ((STATE.variant | 0) === 7) {
        /* 3D PORCH SWING: the width (L) handle at the seat's front end,
           +Z side; the height handle under the beam's +Z end (the beam
           underside = the hanging height). */
        var pgH = _porchAny(STATE);
        pL = project(pgH.seatFront + 0.08, pgH.seatTop, Math.min(L, pgH.L) / 2 + 0.10);
        pH = project(pgH.ringX, pgH.H, pgH.beam.sz / 2);
        /* v269: the sofa style's back height on the depth handle's dot, on
           the top back rail (drag up: one rail, then the second row) */
        pW = (pgH.style === 'sofa') ? project(pgH.backX, pgH.top + 0.02, 0) : null;
      } else if ((STATE.variant | 0) === 17) {
        /* v296 3D PERGOLA SWING: only the seat's length handle, at the
           seat's front end on the +Z side (the pergola follows it) */
        var pgS = _pgLayout(STATE).seat;
        pL = project(pgS.seatFront + 0.08, pgS.seatTop, pgS.L / 2 + 0.10);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 18) {
        /* v301 3D MODERN SWING: the seat's length handle at its front end on
           the +Z side (the portals follow it) */
        var mfS = _mfLayout(STATE).seat;
        pL = project(mfS.seatFront + 0.08, mfS.seatTop, mfS.L / 2 + 0.10);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 19) {
        /* v303 3D CINEMA BAR: only the length handle, at the counter's +Z end, on its front edge */
        var gsH = _gsLayout(STATE);
        pL = project(gsH.counterFront - 0.03, gsH.yC + 0.03, gsH.Lc / 2 + 0.05);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 25) {
        /* v355 3D BAR: only the length handle, on the counter's top at its +Z end, at the front */
        var mbH = _mbLayout(STATE);
        pL = project(mbH.xTop - 0.05, mbH.ySt + 0.03, mbH.zB + mbH.cl + 0.05);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 20) {
        /* v314 3D RAISED BED: the length at the +Z end's front corner (the
           base tier's on a pyramid), the width on the front wall's middle,
           the height (courses / tiers) at the -Z end's front corner of the
           top (the top tier's on a pyramid) */
        var rbH = _rbLayout(STATE), rbYL = (rbH.mode === 'pyramid') ? rbH.courseH : rbH.yWall + rbH.P.ct, rbOff = (rbH.mode === 'pyramid') ? (rbH.N - 1) * _rbU(STATE, 'STEP') : 0;
        pL = project(rbH.W / 2 + 0.04, rbYL - 0.04, rbH.L / 2 + 0.06);
        pW = project(rbH.W / 2 + 0.06, rbH.courseH * 0.5, 0);
        pH = project(rbH.W / 2 - rbOff + 0.04, ((rbH.mode === 'pyramid') ? rbH.top : rbYL) + 0.03, -rbH.L / 2 + rbOff - 0.04);
      } else if ((STATE.variant | 0) === 23) {
        /* v328 3D GAZEBO: its width across the flats on the +Z flat's deck
           edge (both shapes have a flat there); no other handle */
        var gzH = _gzLayout(STATE);
        pL = project(0, gzH.yD + 0.05, gzH.S / 2 + 0.06);
        pW = null;
        pH = null;
      } else if ((STATE.variant | 0) === 54) {
        /* v414 3D TWIST BENCH: the length handle at the seat's front of the +Z end */
        var rtbH = _rtbLayout(STATE);
        pL = project(rtbH.seatFront + 0.03, rtbH.seatTop, rtbH.L / 2 + 0.05);
        pW = null;
        pH = null;
      } else if ((STATE.variant | 0) === 15) {
        /* v284 3D 2x4 BENCH: the length handle at the front of the +Z end, seat height */
        var gbH = _gbLayout(STATE);
        pL = project(gbH.seatFront + 0.04, gbH.seatTop, gbH.L / 2 + 0.05);
        pW = null;
        pH = gbH.arms ? project(gbH.seatFront, gbH.armTop + 0.02, gbH.zE) : null;   /* v285 the armrest's top (v286 flush front) */
      } else if ((STATE.variant | 0) === 16) {
        /* v288 3D SUNBED: the width on the slats' foot corner (+X, +Z); no
           length; v292 (Marek 14:31: druhy dragpoint u hlavove casti je
           zbytecny) no backrest point -- its angle is on the slider */
        var sbH = _sbLayout(STATE);
        pW = project(sbH.iW / 2 - 0.03, sbH.yT, sbH.iL / 2 - 0.06);
        pH = null;
        pL = null;
      } else if ((STATE.variant | 0) === 6) {
        /* 3D BLOCK BENCH: the length handle at the +Z end of the front timber */
        var blH = _blockLayout(STATE);
        pL = project(blH.seatFront + 0.03, blH.seatTop, blH.L / 2 + 0.06);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 13) {
        /* 3D KIDS' SWING SET: the span handle just outside the +Z A-frame
           at 1 m (v261: it sat at the foot by the info bar); 1 / 2 / 3 swings */
        var kgH = _kidsLayout(STATE);
        pL = kgH.bench ? project(kgH.seatXMax + 0.06, 0.45, kgH.L / 2 + 0.10)   /* v299 the bench: at its front end, as the A-frame swing's */
                       : project(0, 1.0, (kgH.zA != null ? kgH.zA : kgH.L / 2) + 0.14);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 12) {
        /* 3D STORAGE BENCH: the length handle at the front top corner, +Z */
        var stH = _storageLayout(STATE);
        pL = project(stH.seatFront + 0.04, stH.seatY, L / 2 + 0.05);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 11) {
        /* 3D TREE BENCH: the opening handle at the +Z outer edge */
        var trH = _treeLayout(STATE);
        pL = project(0.05, trH.seatY, trH.outerZ / 2 + 0.06);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 10) {
        /* 3D PLANTER BENCH: the seat-length handle at the seat's front end, +Z side */
        var plH = _planterLayout(STATE);
        pL = project(plH.seatFront + 0.05, plH.seatY, L / 2 - 0.06);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 9) {
        /* 3D ADIRONDACK: the width handle at the front of the +Z arm */
        var agH = _adiLayout(STATE);
        pL = project(agH.seatFront + 0.06, agH.seatY, agH.Wt / 2 + 0.08);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 5) {
        /* 3D PICNIC SET: the length handle at a seat's end, +Z side */
        pL = project(W / 2 - 0.1, 0.45, L / 2 + 0.06);
        pW = null; pH = null;
      } else if ((STATE.variant | 0) === 2) {
        /* 3D SOFA: three handles — L (length) at a front corner foot,
           H (top frame height) on that corner column, and W (depth) on the
           front edge at the seat level. */
        pL = project( W/2 * 1.05, 0.18,  L/2 * 1.05);
        var sofaP    = SOFA.POST;
        var sofaTopY = STATE.H || SOFA.ARM_TOP;   /* top frame height (lvl2: telescoped) */
        pH = project( W/2 + 0.05, sofaTopY - sofaP / 2, L/2 + 0.05);
        /* W handle: front edge (+X) at the seat-box top, near the −Z end. */
        pW = project( W/2 + 0.05, SOFA.SEAT_TOP, -L/2 - 0.05);
      } else {
        var seatTop3D = _lumber(STATE).seatTop;
        var bH3D      = STATE.backH || 0.55;
        var tH3D      = _lumber(STATE).t;
        /* L handle: front-right corner foot, slightly above ground and
           floated off the wood. */
        pL = project( W/2 * 1.05, 0.18,  L/2 * 1.05);
        pH = project( W/2 + 0.05, seatTop3D + bH3D - tH3D / 2, L/2 + 0.05);
        /* W handle: FRONT side of the bench (+W/2, toward viewer),
           at the TOP of the seat plane near the LEFT end (-L/2) — by
           the front-left leg / far armrest. Offset slightly OUT
           (+0.05 in X, -0.05 in Z) so it floats off the wood. */
        var wPlankT3D = _lumber(STATE).t;
        var wSeatTop3D = _lumber(STATE).seatTop + wPlankT3D;
        pW = project(W/2 + 0.05, wSeatTop3D, -L/2 - 0.05);
      }

      /* Hollywood swing: no depth handle; the pitch handle only in 3D. */
      if (_isStandType(STATE.variant)) { pW = null; if (STATE.view === '2d') pH = null; }
      /* Picnic set: only the length handle; width and height follow the frame */
      if ((STATE.variant | 0) === 5) { pW = null; pH = null; }
      /* Porch swing: no depth handle (the back's tilt sets it); the beam
         height handle only in 3D */
      if ((STATE.variant | 0) === 7 && STATE.view === '2d') { pW = null; pH = null; }   /* v269: in 3D the sofa style keeps its back handle */
      if ((STATE.variant | 0) === 17 || (STATE.variant | 0) === 18 || (STATE.variant | 0) === 19 || (STATE.variant | 0) === 25) { pW = null; pH = null; }   /* v355 + the bar */
      if ((STATE.variant | 0) === 20 && STATE.view === '2d') { pW = null; pH = null; }   /* v314 the raised bed: width / height in 3D */   /* v296 the pergola swing / v301 the modern swing: the seat's length only */
      /* Adirondack: the width (seats) handle only */
      if (((STATE.variant | 0) >= 9 && (STATE.variant | 0) <= 13) || (STATE.variant | 0) === 6) { pW = null; pH = null; }
      /* v285 the 2x4 bench: the height handle = the armrests' top, 3D only, with the armrests */
      if ((STATE.variant | 0) === 15) { pW = null; if (!_gbArmsOn(STATE) || STATE.view === '2d') pH = null; }
      if ((STATE.variant | 0) === 54) { pW = null; pH = null; }   /* v414 the twist bench: the length only */
      /* v288 the sunbed: no length handle in any view; the backrest's angle in 3D only */
      if ((STATE.variant | 0) === 16) { pL = null; pH = null; }   /* v292 the angle on the slider only */
      /* v273: the bed -- no length handle; the height only with the headboard */
      if ((STATE.variant | 0) === 14) { pL = null; if (STATE.backrestVisible === false) pH = null; }
      if ((STATE.variant | 0) === 21) { pL = null; pH = null; }   /* v318 the floating bed: the width only */
      if ((STATE.variant | 0) === 23) { pW = null; pH = null; }   /* v328 the gazebo: its width (L) only */
      /* v263: the wave lounger -- depth and height follow the posture (only the width handle) */
      if ((STATE.variant | 0) === 3 && STATE.view !== '2d') { pW = null; pH = null; }

      if (pL) { this.el.L.style.display = ''; this.el.L.style.left = pL.x + 'px'; this.el.L.style.top = pL.y + 'px'; }
      else    { this.el.L.style.display = 'none'; }

      /* W shown — positioned on the BACK side of the bench (-X), at
         the back-right corner of the seat frame so it's clearly visible
         from the default 3D angle. */
      if (this.el.W && pW) {
        this.el.W.style.display = '';
        this.el.W.style.left = pW.x + 'px';
        this.el.W.style.top  = pW.y + 'px';
      } else if (this.el.W) {
        this.el.W.style.display = 'none';
      }
      if (this.el.H) {
        if (pH) {
          this.el.H.style.display = '';
          this.el.H.style.left = pH.x + 'px';
          this.el.H.style.top  = pH.y + 'px';
        } else {
          this.el.H.style.display = 'none';
        }
      }
      this._peDots(vFp === 23 && STATE.view !== '2d');   /* v337 the pergola's discs (above); v350 the gazebo's sides here */
    },

    /* v337 THE FOOTPRINT = THE SHELTER'S (Marek 2026-10-21 22:56, see
       _fpHandles): the kit's handles with the shelter's build rect -- style
       'primary' (olive ghost 50 %, olive corner pucks, white edge pucks),
       no body move -- on the posts' outer faces at the foot. The host's
       part here: apply -- the grip's side goes to the finger and the
       opposite side mirrors it (the bench keeps its model centred; the
       shelter moves its cabin instead), corners both ways, 5 cm steps
       (US 2 in.); the kota while a grip moves as the shelter's (the width
       past the back edge, the length past the right one). On in 3D and the
       2D plan (stage 1), never in assembly; the DOM handles stay hidden. */
    _fpRect: function () {
      var v = STATE.variant | 0, L = (v === 24) ? _peL(STATE) : _isPhType(v) ? _phL(STATE) : _isGhType(v) ? _ghL(STATE) : _isKpType(v) ? _kpL(STATE) : _gaL(STATE), W = (v === 24) ? _peW(STATE) : _isPhType(v) ? _phW(STATE) : _isGhType(v) ? _ghW(STATE) : _isKpType(v) ? _kpW(STATE) : _gaW(STATE);   /* v373 + the greenhouse (its base) */   /* v362 + the cottage (its house; the porch past it) */
      return { L: L, W: W, x0: -W / 2, x1: W / 2, z0: -L / 2, z1: L / 2 };
    },
    _fpH: null, _fpKey: '', _fpEat: 0,
    _fpActive: function () {
      var v = STATE.variant | 0;
      return (v === 22 || v === 24 || _isPhType(v) || _isGhType(v)) && (STATE.assemblyStep | 0) === 0 && (STATE.vizStage | 0) === 1;   /* v405 the kitchen pod: no grips (its length the bays') */
    },
    _fpSync: function () {
      var self = this;
      if (!this._fpH) {
        if (!_fpStage()) return;
        this._fpH = _fpHandles({
          id: 'bench-footprint',
          y: 0.04,
          active: function () { return self._fpActive(); },
          rects: function () {
            if (!self._fpActive()) return [];
            var R = self._fpRect();
            return [{ key: 'build', style: 'primary', snap: (STATE.isMetric === false) ? 0.0254 : 0.025, movable: false, x0: R.x0, z0: R.z0, x1: R.x1, z1: R.z1 }];
          },
          blocked: function (cx, cy) { return !!self._peDotAt(cx, cy); },
          apply: function (key, r, k) { self._fpApply(r, k); },
          dims: function () {
            var R = self._fpRect(), met = (STATE.isMetric !== false);
            return [{ text: _fpFmtDim(R.W, met), x: 0, z: R.z0 - 0.4 }, { text: _fpFmtDim(R.L, met), x: R.x1 + 0.4, z: 0 }];
          },
          dimScreen: 22 / 728,
          onUp: function () { self._fpEat = Date.now() + 400; },
          onCommit: function () {
            var R = self._fpRect();
            _dbg('[fp] ' + ((STATE.variant | 0) === 24 ? 'pergola' : (STATE.variant | 0) === 26 ? 'cottage' : (STATE.variant | 0) === 27 ? 'stilt house' : (STATE.variant | 0) === 28 ? 'A-frame hut' : (STATE.variant | 0) === 29 ? 'play fort' : (STATE.variant | 0) === 30 ? 'modern house' : (STATE.variant | 0) === 31 ? 'little barn' : (STATE.variant | 0) === 32 ? 'tree fort' : (STATE.variant | 0) === 33 ? 'gable greenhouse' : (STATE.variant | 0) === 34 ? 'backyard coop' : (STATE.variant | 0) === 35 ? 'kitchen pod' : (STATE.variant | 0) === 37 ? 'chicken tractor' : (STATE.variant | 0) === 39 ? 'walk-in coop' : (STATE.variant | 0) === 42 ? 'lean-to coop' : (STATE.variant | 0) === 46 ? 'cupola coop' : (STATE.variant | 0) === 49 ? 'barn coop' : (STATE.variant | 0) === 52 ? 'hoop coop' : (STATE.variant | 0) === 41 ? 'dog house' : (STATE.variant | 0) === 44 ? 'insulated dog house' : (STATE.variant | 0) === 47 ? 'dog kennel with run' : (STATE.variant | 0) === 48 ? 'double dog house' : (STATE.variant | 0) === 51 ? 'modern dog house' : 'garden arbor') + ' footprint -> L ' + R.L.toFixed(3) + ' x W ' + R.W.toFixed(3));
            if (global.BenchLib && global.BenchLib.savePref) global.BenchLib.savePref();
          }
        });
        if (this._fpH) this._fpH.bind();
      }
      var H = this._fpH;
      if (!H) return;
      var on = this._fpActive(), R = on ? this._fpRect() : null;
      var key = on ? [STATE.variant | 0, R.L, R.W, STATE.view, STATE.isMetric].join('|') : 'off';
      if (key === this._fpKey) return;
      this._fpKey = key;
      if (!H._drag) H.refresh();
    },
    _fpApply: function (r, k) {
      var v = STATE.variant | 0, R = this._fpRect();
      var rL = (v === 24) ? _peRange(STATE) : _isPhType(v) ? _phRange(STATE) : _isGhType(v) ? _ghRange(STATE) : _isKpType(v) ? _kpRange(STATE) : _gaRange(STATE), rW = (v === 24) ? _peRange(STATE) : _isPhType(v) ? _phWRange(STATE) : _isGhType(v) ? _ghWRange(STATE) : _isKpType(v) ? _kpWRange(STATE) : _gaWRange(STATE);
      var sx = (k === 1 || k === 2 || k === 5) ? 1 : (k === 0 || k === 3 || k === 7) ? -1 : 0;
      var sz = (k === 2 || k === 3 || k === 6) ? 1 : (k === 0 || k === 1 || k === 4) ? -1 : 0;
      function cl(q, rg) { return Math.round(Math.max(rg.min, Math.min(rg.max, q)) * 200) / 200; }
      var nW = R.W, nL = R.L;
      if (sx && r.x0 != null) nW = cl((sx > 0) ? 2 * r.x1 : -2 * r.x0, rW);
      if (sz && r.z0 != null) nL = cl((sz > 0) ? 2 * r.z1 : -2 * r.z0, rL);
      if (Math.abs(nW - R.W) < 1e-6 && Math.abs(nL - R.L) < 1e-6) return;
      STATE.L = nL;
      if (v === 24) STATE.peW = nW; else if (_isPhType(v)) STATE.phW = nW; else if (_isGhType(v)) STATE.ghW = nW; else if (_isKpType(v)) { /* v376 the kitchen pod: the depth is fixed */ } else STATE.gaW = nW;
      try {
        global.BenchRenderer.build();
        if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
      } catch (eFp) { console.warn('Bench footprint rebuild failed:', eFp && eFp.message); }
    },

    /* v334 THE PERGOLA'S + BUTTONS, v337 THE SHELTER'S DOTS (Marek 22:56:
       Ale terciky plus nechat na podlaze, jako u shelters. Udelat prepinani
       plus minus): one disc lying on the ground per field between two posts
       -- configurator-ui.js _plusMesh / PW_DOT as they are (360 across, 400
       out from the posts' outer faces, a white plus on near-black, a minus
       on a filled field); a tap (BenchRaycaster._onClick) fills the whole
       field or empties it. 3D only, as the shelter's. Their places come from
       the last build (_peFieldsLast). */
    _peDotGrp: null, _peDotKey: '',
    _peDots: function (on) {
      var T = global.THREE, E = global.BenchEngine, i;
      if (!T || !E || !E.scene) return;
      on = !!on && ((STATE.variant | 0) === 24 || (STATE.variant | 0) === 23 || (_isKpType(STATE.variant) && _kpOpen(STATE))) && (STATE.assemblyStep | 0) === 0 && STATE.view !== '2d' && STATE.vizStage === 1 && !_benchCutOn();   /* v350 + the gazebo's sides */   /* v413 none while the section is on */   /* v379 + the kitchen pod's bays (with the flap open) */
      if (!this._peDotGrp) {
        if (!on) return;
        this._peDotGrp = new T.Group();
        this._peDotGrp.name = 'pe-plus';
        this._peDotGrp.userData.arSkip = true;
        E.scene.add(this._peDotGrp);
      }
      var G = this._peDotGrp;
      G.visible = on;
      if (!on) return;
      var F = _peFieldsLast || [];
      var key = F.map(function (f) { return f.id + ':' + f.state + ':' + (f.cyc ? 'c' : '') + (f.r || 0) + ':' + f.at.map(function (q) { return Math.round(q * 1000); }).join(','); }).join('|');
      if (key === this._peDotKey) return;
      this._peDotKey = key;
      for (i = G.children.length - 1; i >= 0; i--) {
        var ch = G.children[i];
        if (ch.geometry) ch.geometry.dispose();
        if (ch.material) ch.material.dispose();
        G.remove(ch);
      }
      F.forEach(function (f) {
        var disc = new T.Mesh(new T.CircleGeometry(f.r || PE.DOT_R, 28),
          new T.MeshBasicMaterial({ map: _pePlusTex(T, !!f.state, !!f.cyc), transparent: true, depthWrite: false }));   /* v379 + the pod's (f.r: smaller); v412 f.cyc: a cycler */
        disc.renderOrder = 6;
        disc.position.set(f.at[0], f.at[1], f.at[2]);
        if (f.face) disc.lookAt(f.at[0] + f.face[0], f.at[1] + f.face[1], f.at[2] + f.face[2]);   /* v409 a disc facing along f.face (the fitness's wall bars: +Z) */
        else if (f.tilt) disc.lookAt(f.at[0] + Math.sin(f.tilt), f.at[1] + Math.cos(f.tilt), f.at[2]);   /* v379 its face up and to the front (+X) */
        else disc.rotation.x = -Math.PI / 2;
        disc.userData.peField = f.id;
        G.add(disc);
      });
    },
    /* the field whose disc is under a screen point ('' none) */
    _peDotAt: function (cx, cy) {
      var G = this._peDotGrp, T = global.THREE, E = global.BenchEngine;
      if (!G || !G.visible || !G.children.length || !T || !E || !E.renderer) return '';
      var b = E.renderer.domElement.getBoundingClientRect(), cam = (STATE.view === '2d' && E.orthoCamera) ? E.orthoCamera : E.camera;
      var rc = new T.Raycaster();
      G.updateMatrixWorld(true);   /* discs made since the last frame */
      rc.setFromCamera(new T.Vector2(((cx - b.left) / b.width) * 2 - 1, -((cy - b.top) / b.height) * 2 + 1), cam);
      var hs = rc.intersectObjects(G.children, false);
      return (hs && hs.length) ? (hs[0].object.userData.peField || '') : '';
    },

    _start: function (axis, ev) {
      ev.preventDefault();
      /* v337 the garden arbor / the pergola: sized on the footprint's grips (_fpHandles), no DOM handle */
      if ((STATE.variant | 0) === 22 || (STATE.variant | 0) === 24 || _isPhType(STATE.variant) || _isGhType(STATE.variant) || _isKpType(STATE.variant)) return;
      /* v269: on the porch swing (sofa style, 3D) the depth handle's dot is
         the back height (the top rail above the seat box) */
      if (axis === 'width' && _porchStyle(STATE) === 'sofa' && STATE.view !== '2d') axis = 'pback';
      /* v273 the bed: no length; the height only with the headboard */
      var bedD = ((STATE.variant | 0) === 14);
      if (bedD && (axis === 'length' || (axis === 'height' && STATE.backrestVisible === false))) return;
      if ((STATE.variant | 0) === 21 && axis !== 'width') return;   /* v318 the floating bed: the width only */
      if ((STATE.variant | 0) === 23 && axis !== 'length') return;   /* v328 the gazebo: its width across the flats only */
      var sbD = ((STATE.variant | 0) === 16);   /* v288 the sunbed: no length; the angle in 3D only */
      if (sbD && (axis === 'length' || axis === 'height')) return;   /* v292 no height point */
      this.dragging = axis;
      var pt = ev.touches ? ev.touches[0] : ev;
      this.dragStart.x = pt.clientX;
      this.dragStart.y = pt.clientY;
      /* Height handle: on the Park Bench it edits STATE.backH (backrest
         height above seat); on the Sofa it edits STATE.H directly (the
         top-frame height). */
      var isSofa = ((STATE.variant | 0) === 2);
      var swR = (_isStandType(STATE.variant) && axis === 'height') ? _standLayout(STATE).roof : null;
      this.dragStart.value = swR ? swR.rise
        : (bedD && axis === 'width') ? _bedSize(STATE).w     /* v273: the mattress width */
        : ((STATE.variant | 0) === 21 && axis === 'width') ? _fbSize(STATE).w   /* v318 the floating bed's mattress */
        : (bedD && axis === 'height') ? _bedLayout(STATE).top   /* the headboard's top */
        : (sbD && axis === 'width') ? _sbW(STATE)               /* v288 the sunbed's lying width */
        : (sbD && axis === 'height') ? (_sbLayout(STATE).Lb * Math.sin(_sbAng(STATE) * Math.PI / 180))   /* the backrest head's rise */
        : ((STATE.variant | 0) === 20 && axis === 'width') ? _rbW(STATE)                       /* v314 the raised bed's width */
        : ((STATE.variant | 0) === 20 && axis === 'height') ? _rbN(STATE) * _rbProf(STATE).bh   /* its courses / tiers */
        : (axis === 'pback') ? _psofaBack(STATE)
        : ((STATE.variant | 0) === 7 && axis === 'height') ? _porchH(STATE)
        : ((STATE.variant | 0) === 15 && axis === 'height') ? _gbArmTop(STATE)   /* v285 */
        : (axis === 'height')
        ? (isSofa ? (STATE.H || SOFA.ARM_TOP) : (STATE.backH || 0.55))
        : STATE[axis === 'length' ? 'L' : 'W'];

      /* Capture the screen-space projection of the world axis we're dragging.
         The drag math projects two world points (handle + 0.5m offset along
         the drag axis) to screen, then computes a screen-direction vector.
         _move converts mouse/touch drag delta into world units via dot
         product with this direction.

         Branch on view + stage to pick the correct camera. In stage 2 each
         axis maps to a different elevation camera (length → front, width →
         side, height → either). The elevation handles call this same
         pipeline via their drag listeners. */
      if (axis === 'length' || axis === 'width' || axis === 'height') {
        var T = global.THREE;
        var eng = global.BenchEngine;
        var W = STATE.W, L = STATE.L, H = STATE.H;
        var p0, p1, camera;
        var canvas = eng.renderer.domElement;
        var rect = canvas.getBoundingClientRect();
        var halfW = rect.width / 2;
        var viewportW = rect.width;

        /* Sample point convention: p0 is the corner the user is
           grabbing, p1 is the position the SAME corner would move to
           if STATE.{key} grew by 0.5 m. The drag's screen delta is
           then dot-projected onto (p1 - p0) in screen space, so
           moving the pointer in the direction the corner expands
           always increases the dimension — regardless of camera
           orientation or which side of the rack the handle sits on.
           This was previously broken in 2D plan view: the W handle
           lives on -W/2 corner, but the sample p0/p1 used +W/2, so
           the screen-direction vector pointed the wrong way and
           drag-left shrank W (user expected drag-left to grow W
           because the -W/2 corner moves left when W increases). */
        if (STATE.view === '2d' && STATE.vizStage === 1) {
          /* Plan — W handle is at top-left corner (-W/2, -L/2),
             L handle at bottom-right (+W/2, +L/2). */
          camera = eng.orthoCamera;
          viewportW = rect.width;
          if (axis === 'width') {
            /* -W/2 corner moves further in -X when W grows. */
            p0 = new T.Vector3(-W / 2,        0, -L / 2);
            p1 = new T.Vector3(-W / 2 - 0.5,  0, -L / 2);
          } else {
            /* +L/2 corner moves further in +Z when L grows. */
            p0 = new T.Vector3( W / 2, 0,  L / 2);
            p1 = new T.Vector3( W / 2, 0,  L / 2 + 0.5);
          }
        } else if (STATE.view === '2d' && STATE.vizStage === 2) {
          /* Bokorys (side) — H handle on left corner of L/2 line,
             L handle on right. Camera looks along +X. */
          camera = eng.orthoCamera;
          viewportW = rect.width;
          if (axis === 'length') {
            /* -L/2 corner moves further in -Z when L grows. */
            p0 = new T.Vector3(0, 0, -L / 2);
            p1 = new T.Vector3(0, 0, -L / 2 - 0.5);
          } else {
            /* W handle co-located with L on this stage (degenerate
               from front view). Default to +X growth direction. */
            p0 = new T.Vector3(0, 0, 0);
            p1 = new T.Vector3(-0.5, 0, 0);
          }
        } else if (STATE.view === '2d' && STATE.vizStage === 3) {
          /* Nárys (front) — H handle top-left, W handle bottom-right.
             Camera looks along -Z. */
          camera = eng.orthoCamera;
          viewportW = rect.width;
          if (axis === 'width') {
            /* +W/2 corner moves further in +X when W grows. */
            p0 = new T.Vector3( W / 2,       0, 0);
            p1 = new T.Vector3( W / 2 + 0.5, 0, 0);
          } else {
            /* L handle co-located on stage 3 (degenerate). */
            p0 = new T.Vector3(0, 0, 0);
            p1 = new T.Vector3(0.5, 0, 0);
          }
        } else {
          /* 3D bench: front-right corner. For 'length' sample along +Z;
             for 'height' (= backH) sample along +Y above the seat. */
          if (axis === 'length') {
            p0 = new T.Vector3( W/2, 0.18,  L/2);
            p1 = new T.Vector3( W/2, 0.18,  L/2 + 0.5);
          } else if (axis === 'height') {
            var seatTopS = _lumber(STATE).seatTop;
            p0 = new T.Vector3( W/2, seatTopS,        L/2);
            p1 = new T.Vector3( W/2, seatTopS + 0.5,  L/2);
          } else if (axis === 'width' && sbD) {
            /* v288 the sunbed: the dot on the slats' foot corner moves +X */
            var gsW = _sbLayout(STATE);
            p0 = new T.Vector3(gsW.iW / 2,       gsW.yT, gsW.iL / 2);
            p1 = new T.Vector3(gsW.iW / 2 + 0.5, gsW.yT, gsW.iL / 2);
          } else if (axis === 'width' && bedD) {
            /* v274 the bed: the dot on the mattress's foot corner moves +X */
            var gbW = _bedLayout(STATE);
            p0 = new T.Vector3(gbW.matt.w / 2,       gbW.mattTop, gbW.matt.l / 2);
            p1 = new T.Vector3(gbW.matt.w / 2 + 0.5, gbW.mattTop, gbW.matt.l / 2);
          } else if (axis === 'width') {
            /* W handle is on +W/2 (front), at -L/2 (left end / front-
               left leg). Growing W moves the +W/2 corner further in +X
               (toward viewer). Sample at the handle's actual world
               position so the screen-direction vector matches. */
            var seatTopW = _lumber(STATE).seatTop + _lumber(STATE).t;
            p0 = new T.Vector3( W/2,        seatTopW, -L/2);
            p1 = new T.Vector3( W/2 + 0.5,  seatTopW, -L/2);
          } else {
            p0 = new T.Vector3( W/2, 0.18,  L/2);
            p1 = new T.Vector3( W/2, 0.18,  L/2);
          }
          camera = eng.camera;
        }

        function proj(p) {
          var v = p.clone().project(camera);
          return { x: (v.x * 0.5 + 0.5) * viewportW, y: (1 - (v.y * 0.5 + 0.5)) * rect.height };
        }
        var s0 = proj(p0), s1 = proj(p1);
        var dx = s1.x - s0.x, dy = s1.y - s0.y;
        this.dragStart.screenDirX = dx;
        this.dragStart.screenDirY = dy;
        this.dragStart.screenLenSq = dx * dx + dy * dy;
        this.dragStart.worldStep = 0.5;
      }

      if (bedD && axis === 'height') {
        /* v273: the headboard's top rail, its screen direction for +0.5 m up */
        var Th = global.THREE, engH = global.BenchEngine, rectH = engH.renderer.domElement.getBoundingClientRect(), gH = _bedLayout(STATE);
        var camH = (STATE.view === '2d') ? (((STATE.vizStage === 2) && engH.orthoCameraSide) ? engH.orthoCameraSide : engH.orthoCamera) : engH.camera;
        var h0 = new Th.Vector3(gH.W / 2, gH.top, -gH.L / 2).project(camH), h1 = new Th.Vector3(gH.W / 2, gH.top + 0.5, -gH.L / 2).project(camH);
        var hx = (h1.x - h0.x) * 0.5 * rectH.width, hy = -(h1.y - h0.y) * 0.5 * rectH.height;
        this.dragStart.screenDirX = hx; this.dragStart.screenDirY = hy;
        this.dragStart.screenLenSq = hx * hx + hy * hy; this.dragStart.worldStep = 0.5;
      }
      if (sbD && axis === 'height') {
        /* v288 the sunbed: the backrest's head edge, its screen direction for +0.5 m up */
        var Ts = global.THREE, engS = global.BenchEngine, rectS = engS.renderer.domElement.getBoundingClientRect(), gS = _sbLayout(STATE);
        var s0 = new Ts.Vector3(gS.iW / 2, gS.headTop, gS.headZ).project(engS.camera), s1 = new Ts.Vector3(gS.iW / 2, gS.headTop + 0.5, gS.headZ).project(engS.camera);
        var sx = (s1.x - s0.x) * 0.5 * rectS.width, sy = -(s1.y - s0.y) * 0.5 * rectS.height;
        this.dragStart.screenDirX = sx; this.dragStart.screenDirY = sy;
        this.dragStart.screenLenSq = sx * sx + sy * sy; this.dragStart.worldStep = 0.5;
      }
      if (axis === 'pback') {
        /* the top back rail's screen direction for +0.5 m of back */
        var Tb = global.THREE, engB = global.BenchEngine, rectB = engB.renderer.domElement.getBoundingClientRect(), gB = _porchSofaLayout(STATE);
        var q0 = new Tb.Vector3(gB.backX, gB.top, 0).project(engB.camera), q1 = new Tb.Vector3(gB.backX, gB.top + 0.5, 0).project(engB.camera);
        var bx = (q1.x - q0.x) * 0.5 * rectB.width, by = -(q1.y - q0.y) * 0.5 * rectB.height;
        this.dragStart.screenDirX = bx; this.dragStart.screenDirY = by;
        this.dragStart.screenLenSq = bx * bx + by * by; this.dragStart.worldStep = 0.5;
      }
      if (global.BenchEngine && global.BenchEngine.controls) global.BenchEngine.controls.enabled = false;
      this.el.label.classList.add('active');
      this._updateLabel(axis);
      this._positionLabel(ev);
    },

    _move: function (ev) {
      if (!this.dragging) return;
      var pt = ev.touches ? ev.touches[0] : ev;

      /* Screen-space projection for L, W, and backH. _start sampled two
         world points along the growth axis; project them, compute screen
         direction, dot the drag delta. */
      var dragDx = pt.clientX - this.dragStart.x;
      var dragDy = pt.clientY - this.dragStart.y;
      var dot = dragDx * this.dragStart.screenDirX + dragDy * this.dragStart.screenDirY;
      var delta = (this.dragStart.screenLenSq > 0)
        ? (dot * this.dragStart.worldStep / this.dragStart.screenLenSq)
        : 0;

      var isSofaH = (this.dragging === 'height') && ((STATE.variant | 0) === 2);
      var sofaL2  = isSofaH && (STATE.lvl === 2);
      /* Hollywood swing: the height handle drags the roof rise, read back
         as the pitch (whole degrees, within the roof type's range). */
      if ((this.dragging === 'height') && _isStandType(STATE.variant)) {
        var rt = _swingRoof(STATE);
        if (rt === 'none') return;
        var runE = (rt === 'gable') ? SWING.ROOF_RUN : 2 * SWING.ROOF_RUN, PR = SWING.PITCH[rt];
        var rLo = runE * Math.tan(PR.min * Math.PI / 180), rHi = runE * Math.tan(PR.max * Math.PI / 180);
        var rise = Math.max(rLo, Math.min(rHi, this.dragStart.value + delta));
        STATE.swingPitch = Math.round(Math.atan(rise / runE) * 180 / Math.PI);
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errS) {}
        return;
      }
      /* v269: the porch swing's back height -- one rail up to BACK_ONE, then
         the second row; the drag ends at BACK_MAX (5 mm steps) */
      if (this.dragging === 'pback') {
        var pbR = Math.max(PSOFA.BACK_MIN, Math.min(PSOFA.BACK_MAX, this.dragStart.value + delta));
        STATE.psofaBack = Math.round(pbR * 200) / 200;
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errB) {}
        return;
      }
      /* Porch swing: the height handle = the beam underside (hanging height) */
      if ((this.dragging === 'height') && ((STATE.variant | 0) === 7)) {
        var phR = Math.max(PORCH.H_MIN, Math.min(PORCH.H_MAX, this.dragStart.value + delta));
        STATE.porchH = Math.round(phR * 200) / 200;
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errP) {}
        return;
      }
      /* v285 the 2x4 bench: the armrests' top, 0.15 .. 0.30 over the seat, 5 mm steps */
      if ((this.dragging === 'height') && ((STATE.variant | 0) === 15)) {
        var gsT = _gbSeatTop(STATE);
        var gaR = Math.max(gsT + GB.ARM_MIN, Math.min(gsT + GB.ARM_MAX, this.dragStart.value + delta));
        STATE.gbArmH = Math.round(gaR * 200) / 200;
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errG) {}
        return;
      }
      /* v314 the raised bed: the width in 5 mm (the side moves half the
         change), the height in whole courses / tiers within its mode's range */
      if ((STATE.variant | 0) === 20 && (this.dragging === 'width' || this.dragging === 'height')) {
        if (this.dragging === 'width') {
          var rbWR = _rbWRange(STATE), nrw = Math.round(Math.max(rbWR.min, Math.min(rbWR.max, this.dragStart.value + 2 * delta)) * 200) / 200;
          if (Math.abs(nrw - _rbW(STATE)) < 1e-6) { this._positionLabel(ev); return; }
          STATE.rbW = nrw;
        } else {
          var rbNR = _rbNRange(STATE), nrn = Math.max(rbNR.min, Math.min(rbNR.max, Math.round((this.dragStart.value + delta) / _rbProf(STATE).bh)));
          if (nrn === _rbN(STATE)) { this._positionLabel(ev); return; }
          STATE.rbN = nrn;
        }
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errRb) {}
        return;
      }
      /* v328 the gazebo: its width across the flats in 5 mm (the +Z flat moves half the change) */
      if ((STATE.variant | 0) === 23 && this.dragging === 'length') {
        var gzR = _gzRange(STATE), ngz = Math.round(Math.max(gzR.min, Math.min(gzR.max, this.dragStart.value + 2 * delta)) * 200) / 200;
        if (Math.abs(ngz - _gzS(STATE)) < 1e-6) { this._positionLabel(ev); return; }
        STATE.L = ngz;
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errGz) {}
        return;
      }
      /* v288 the sunbed: the width in the size's steps (the side moves half the
         change); the backrest's angle = the nearest notch for the head's rise */
      if ((STATE.variant | 0) === 16 && (this.dragging === 'width' || this.dragging === 'height')) {
        if (this.dragging === 'width') {
          var sbR = _sbWR(STATE), nsw = Math.max(sbR.min, Math.min(sbR.max, this.dragStart.value + 2 * delta));
          var oldW = _sbW(STATE); STATE.sbW = nsw; STATE.sbW = _sbW(STATE);
          if (Math.abs(STATE.sbW - oldW) < 1e-6) { this._positionLabel(ev); return; }
        } else {
          var sbLb = _sbLayout(STATE).Lb, rise = Math.max(0, Math.min(sbLb, this.dragStart.value + delta));
          var nAng = Math.asin(rise / sbLb) * 180 / Math.PI, oldA = _sbAng(STATE);
          STATE.sbAng = nAng; STATE.sbAng = _sbAng(STATE);
          if (STATE.sbAng === oldA) { this._positionLabel(ev); return; }
        }
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errSb) {}
        return;
      }
      /* v273 the bed: the width steps through the mattress widths (the side
         rail moves half the width change), the height = the headboard's top
         (5 mm steps, from just over the mattress to HEAD_MAX) */
      if ((STATE.variant | 0) === 21 && this.dragging === 'width') {
        /* v318 the floating bed: the width steps through its mattress sizes */
        var fzs = _fbSizes(STATE), fwant = this.dragStart.value + 2 * delta, fk = 0, fzi;
        for (fzi = 1; fzi < fzs.length; fzi++) if (Math.abs(fzs[fzi].w - fwant) < Math.abs(fzs[fk].w - fwant)) fk = fzi;
        if (Math.abs(fzs[fk].w - _fbSize(STATE).w) < 1e-6) { this._positionLabel(ev); return; }
        STATE.bedMW = fzs[fk].w;
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errFb) {}
        return;
      }
      if ((STATE.variant | 0) === 14 && (this.dragging === 'width' || this.dragging === 'height')) {
        if (this.dragging === 'width') {
          var bzs = _bedSizes(STATE), want = this.dragStart.value + 2 * delta, bk = 0, bzi;
          for (bzi = 1; bzi < bzs.length; bzi++) if (Math.abs(bzs[bzi].w - want) < Math.abs(bzs[bk].w - want)) bk = bzi;
          if (Math.abs(bzs[bk].w - _bedSize(STATE).w) < 1e-6) { this._positionLabel(ev); return; }
          STATE.bedMW = bzs[bk].w;
        } else {
          var gbH = _bedLayout(STATE);
          var nbh = Math.round(Math.max(gbH.headMin, Math.min(BED.HEAD_MAX, this.dragStart.value + delta)) * 200) / 200;
          if (Math.abs(nbh - gbH.top) < 1e-6) { this._positionLabel(ev); return; }
          STATE.bedHead = nbh;
        }
        try {
          global.BenchRenderer.build();
          if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
          this._positionLabel(ev);
          this._updateLabel(this.dragging);
        } catch (errBd) {}
        return;
      }
      var rangeKey = (this.dragging === 'height') ? 'backH'
                   : (this.dragging === 'width')  ? 'W'
                   : 'L';
      var r = sofaL2 ? { min: SOFA.H_MIN_L2, max: SOFA.H_MAX_L2 }
            : isSofaH ? { min: SOFA.H_MIN, max: SOFA.H_MAX }
            : (rangeKey === 'L') ? _lengthRange(STATE)
            : (RANGES && RANGES[rangeKey]);
      if (!r) { console.warn('Bench drag: RANGES[' + rangeKey + '] is missing'); return; }
      var raw = Math.max(r.min, Math.min(r.max, this.dragStart.value + delta));
      if (this.dragging === 'width' && ((STATE.variant | 0) !== 2)) {
        /* Snap W to integer plank counts (4..15). step CC = plankW + minGap.
           Use the PLANK board width (prof.plankW) so the snap matches the
           renderer + BoQ — kids planks (TIM20100, 100 wide) differ from the
           framing member width. */
        var snapPlankW = _lumber(STATE).plankW;
        var snapGap    = 0.004;
        var snapStep   = snapPlankW + snapGap;
        var snapN      = Math.round((raw + snapGap) / snapStep);
        if (snapN < 4)  snapN = 4;
        if (snapN > 15) snapN = 15;
        raw = snapN * snapStep - snapGap;
      } else {
        raw = Math.round(raw * 200) / 200;     /* snap to 5 mm */
      }
      if (this.dragging === 'length') {
        STATE.L = raw;
      } else if (this.dragging === 'width') {
        STATE.W = raw;
      } else if (isSofaH) {
        STATE.H = raw;        /* sofa: top-frame height */
      } else {
        STATE.backH = raw;    /* park bench: backrest height */
      }
      try {
        global.BenchRenderer.build();
        if (global.BenchLib && global.BenchLib.refreshUI) global.BenchLib.refreshUI();
        this._positionLabel(ev);
        this._updateLabel(this.dragging);
      } catch (err) {
        console.warn('Bench drag rebuild failed:', err && err.message, err && err.stack);
      }
    },

    _end: function () {
      this.dragging = null;
      if (global.BenchEngine && global.BenchEngine.controls) global.BenchEngine.controls.enabled = true;
      this.el.label.classList.remove('active');
      /* Persist dimensions on drag end so user's L/W/H survive reload. */
      if (global.BenchLib && global.BenchLib.savePref) global.BenchLib.savePref();
    },

    _updateLabel: function (axis) {
      var T   = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      if (axis === 'height' && _isStandType(STATE.variant)) {
        /* Hollywood / A-frame swing: the roof pitch in degrees. */
        this.el.label.textContent = (T.roof_pitch || 'roof_pitch') + ': ' + Math.round(_swingPitch(STATE)) + '\u00b0';
        return;
      }
      if ((STATE.variant | 0) === 23 && axis === 'length') {   /* v328 the gazebo's width across the flats */
        this.el.label.textContent = (T.widthLabel || 'WIDTH') + ': ' + global.BenchLib.fmtLen(_gzS(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if ((STATE.variant | 0) === 24 && axis === 'width') {   /* v334 the pergola's width */
        this.el.label.textContent = (T.widthLabel || 'WIDTH') + ': ' + global.BenchLib.fmtLen(_peW(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if ((STATE.variant | 0) === 22 && axis === 'width') {   /* v320 the garden arbor's width */
        this.el.label.textContent = (T.widthLabel || 'WIDTH') + ': ' + global.BenchLib.fmtLen(_gaW(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if ((STATE.variant | 0) === 21 && axis === 'width') {   /* v318 the floating bed: its mattress */
        this.el.label.textContent = (T.widthLabel || 'WIDTH') + ': ' + _fbSize(STATE).n;
        return;
      }
      if ((STATE.variant | 0) === 14 && (axis === 'width' || axis === 'height')) {
        /* v273 the bed: the mattress size / the headboard's top above the floor */
        var gbL = _bedLayout(STATE);
        this.el.label.textContent = (axis === 'width')
          ? ((T.widthLabel || 'WIDTH') + ': ' + gbL.size.n)
          : (_tt('bench_headboard_on', 'Headboard') + ': ' + global.BenchLib.fmtLen(gbL.top) + ' ' + (STATE.isMetric ? 'm' : 'ft'));
        return;
      }
      if ((STATE.variant | 0) === 20 && (axis === 'width' || axis === 'height')) {
        /* v314 the raised bed: its width / its top over the ground */
        var rbLb = _rbLayout(STATE);
        this.el.label.textContent = ((axis === 'width') ? (T.widthLabel || 'WIDTH') : (T.heightLabel || 'HEIGHT')) + ': ' + global.BenchLib.fmtLen((axis === 'width') ? rbLb.W : rbLb.top) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if ((STATE.variant | 0) === 16 && (axis === 'width' || axis === 'height')) {
        /* v288 the sunbed: the lying width / the backrest's angle */
        this.el.label.textContent = (axis === 'width')
          ? ((T.widthLabel || 'WIDTH') + ': ' + global.BenchLib.fmtLen(_sbW(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft'))
          : (_tt('bench_rake_label', 'Backrest tilt') + ': ' + _sbAng(STATE) + '\u00b0');
        return;
      }
      if (axis === 'height' && (STATE.variant | 0) === 15) {
        /* v285 the 2x4 bench: the armrests' top above the floor */
        this.el.label.textContent = _tt('bench_armrests', 'Armrests') + ': ' + global.BenchLib.fmtLen(_gbArmTop(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if (axis === 'pback') {
        /* v269: the porch swing's back: its top above the seat box */
        this.el.label.textContent = _tt('bench_backrest_on', 'Backrest') + ': ' + global.BenchLib.fmtLen(_psofaBack(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      if (axis === 'height' && (STATE.variant | 0) === 7) {
        /* Porch swing: the beam underside above the floor. */
        this.el.label.textContent = (T.heightLabel || 'HEIGHT') + ': ' + global.BenchLib.fmtLen(_porchH(STATE)) + ' ' + (STATE.isMetric ? 'm' : 'ft');
        return;
      }
      var nm  = axis === 'length' ? (T.lengthLabel || 'LENGTH')
              : axis === 'width'  ? (T.widthLabel  || 'WIDTH')
              :                     (T.backrestHeightLabel || T.heightLabel || 'BACKREST');
      var isSofa = ((STATE.variant | 0) === 2);
      /* For the sofa, the height handle (top or lvl-2 middle) should always
         read the TOTAL height from the ground (= STATE.H, the top face),
         not the local rail-above-seat delta. */
      var val = (axis === 'length') ? STATE.L
              : (axis === 'width')  ? STATE.W
              : isSofa              ? (STATE.H || SOFA.ARM_TOP)
              :                       (STATE.backH || 0.55);
      var u   = STATE.isMetric ? 'm' : 'ft';
      this.el.label.textContent = nm + ': ' + global.BenchLib.fmtLen(val) + ' ' + u;
    },

    _positionLabel: function (ev) {
      var pt = ev.touches ? ev.touches[0] : ev;
      var root = document.getElementById('cf-root');
      var rect = root.getBoundingClientRect();
      this.el.label.style.left = (pt.clientX - rect.left) + 'px';
      this.el.label.style.top  = (pt.clientY - rect.top - 30) + 'px';
    }
  };

  /* ----------------------------------------------------------
     LIB CONTROLLER  (boot, formatters, handlers)
     ---------------------------------------------------------- */
  function detectUnits() {
    try {
      if (global.Shopify && Shopify.currency && Shopify.currency.active === 'USD') return false;
    } catch (e) {}
    return true;
  }

  function fmtLen(meters) {
    if (STATE.isMetric) return meters.toFixed(2);
    return (meters * 3.28084).toFixed(1);
  }
  function fmtArea(m2) {
    if (STATE.isMetric) return m2.toFixed(2);
    return (m2 * 10.7639).toFixed(1);
  }

  /* ----------------------------------------------------------
     BUDGET INTEGRATION — publish current BoQ to window.ConfiguratorBoQ.
     budget-prd-cat-selector.liquid reads this and renders accordingly.
     The variantData shape mirrors the Google Sheet rows the budget app expects:
       [emptyHeaderRow, emptyHeaderRow, [id, metricQty, imperialQty], ...]
     (budget skips i=0,1 — they are headers).

     We ALSO publish via ConfiguratorBudgetBridge (when loaded) so the
     asset drawer can read byMaterial for project-quantity display in
     the Product section without recomputing — same source of truth.
     ---------------------------------------------------------- */
  var _budgetRefreshTimer = null;
  function publishBoQToBudget() {
    var b = global.BenchBoQ.compute();
    var rows = [[], []];   /* 2 header rows skipped by budget loadCSV */
    var M_TO_FT  = 3.2808;
    var M2_TO_FT2 = 10.7639;
    function round2(n) { return Math.round(n * 100) / 100; }
    Object.keys(b.byMaterial).forEach(function (id) {
      var mat = MATERIALS[id];
      var qty = b.byMaterial[id];
      var metric, imperial;
      if (mat && mat.unit === 'm') {
        /* Linear meters: 2 decimals (cm precision is plenty for BoQ). */
        metric   = round2(qty);
        imperial = round2(qty * M_TO_FT);
      } else if (mat && (mat.unit === 'm\u00b2' || mat.unit === 'm2')) {   /* v303 + 'm2' (the coating MFP00002 went out as whole m2) */
        /* Area: 2 decimals. */
        metric   = round2(qty);
        imperial = round2(qty * M2_TO_FT2);
      } else if (mat && (mat.unit === 'm\u00b3' || mat.unit === 'm3')) {   /* v303 volumes (footings: M3 / FT3), 3 decimals */
        metric   = Math.round(qty * 1000) / 1000;
        imperial = round2(qty * 35.3147);
      } else if (mat && mat.unit === 'l') {   /* v318 litres (the glue): 2 decimals, US gallons */
        metric   = round2(qty);
        imperial = round2(qty * 0.26417);
      } else {
        /* Pieces (fasteners): integer. */
        metric   = Math.round(qty);
        imperial = Math.round(qty);
      }
      rows.push([id, metric, imperial]);
    });

    /* Prefer the bridge publisher (sets variantData AND byMaterial AND
       fires the shared event). Fall back to direct global assignment
       so legacy budget integration still works without the bridge. */
    if (global.ConfiguratorBudgetBridge && global.ConfiguratorBudgetBridge.publishVariantData) {
      global.ConfiguratorBudgetBridge.publishVariantData(b.byMaterial);
      /* Bridge sets variantData via Object.keys order; we want the
         metric/imperial rounding logic above to be authoritative.
         Overwrite variantData with the rounded version. */
      global.ConfiguratorBoQ.variantData = rows;
      global.ConfiguratorBoQ.source      = 'rack';
    } else {
      global.ConfiguratorBoQ = {
        source:      'rack',
        variantData: rows,
        byMaterial:  b.byMaterial
      };
    }

    /* Debounce the (potentially expensive) budget re-render. 600ms is enough
       for a user to stop dragging before we trigger a render. */
    if (_budgetRefreshTimer) clearTimeout(_budgetRefreshTimer);
    _budgetRefreshTimer = setTimeout(function () {
      if (typeof global.loadVariantCSV === 'function') {
        try { global.loadVariantCSV(); } catch (e) { /* budget not loaded yet */ }
      }
    }, 600);
  }

  function refreshUI(skipPublish) {
    var $ = function (id) { return document.getElementById(id); };
    /* v261: the drag handles follow the assembly step on EVERY type. The
       class used to be set only by the park bench / sofa assembly, so
       leaving one of them mid-assembly for another type kept every handle
       hidden (Marek: no length handles); the staged types showed them
       during their steps. */
    try { var rootH = $('cf-root'); if (rootH) rootH.classList.toggle('cf-assembly-active', (STATE.assemblyStep | 0) !== 0); } catch (eH) {}
    try {   /* v369 the section tool on the playhouses' rail (v413 on every type's) */
      var cutB = $('cf-btn-cut');
      if (cutB) cutB.style.display = '';
      if (STATE.view === '2d') _benchCutOff('the plan');
      if (_benchCutOn() && _cutVar !== (STATE.variant | 0)) _benchCutOff('another type');
      _cutVar = STATE.variant | 0;
    } catch (eCt) {}
    if ($('cf-stat-l')) $('cf-stat-l').textContent = fmtLen(STATE.L);
    if ($('cf-stat-w')) $('cf-stat-w').textContent = fmtLen(STATE.W);
    if ($('cf-stat-h')) $('cf-stat-h').textContent = fmtLen(STATE.H);
    if ($('cf-stat-size-unit')) $('cf-stat-size-unit').textContent = STATE.isMetric ? 'm' : 'ft';

    var b = global.BenchBoQ.compute();
    /* "Lumber" total in the info banner: sum of EVERY linear-meter
       lumber profile (currently KVH 60×100 + KVL battens). If new
       profiles are ever added to BenchBoQ.byMaterial that are also
       measured in linear m (codes starting with KV*), they're
       picked up automatically. Roof (ROR) is m² and decking (TST)
       has its own row — both stay separate.
       Defensive: wrap in try/catch so any unexpected shape from
       BenchBoQ doesn't blow up the whole refreshUI pipeline (which
       would freeze the model load). */
    var lumberTotal = 0;
    try {
      if (b && b.byMaterial && typeof b.byMaterial === 'object') {
        var keys = Object.keys(b.byMaterial);
        for (var i = 0; i < keys.length; i++) {
          var code = keys[i];
          if (code && code.indexOf('KV') === 0) {
            var v = +b.byMaterial[code];
            if (isFinite(v)) lumberTotal += v;
          }
        }
      } else if (b && typeof b.kvh === 'number') {
        lumberTotal = b.kvh;
      }
    } catch (e) {
      lumberTotal = (b && +b.kvh) || 0;
    }
    if ($('cf-stat-kvh'))      $('cf-stat-kvh').textContent      = fmtLen(lumberTotal);
    if ($('cf-stat-tst'))      $('cf-stat-tst').textContent      = fmtLen(b.tst);
    if ($('cf-stat-ror'))      $('cf-stat-ror').textContent      = fmtArea(b.ror);
    if ($('cf-stat-kvh-unit')) $('cf-stat-kvh-unit').textContent = STATE.isMetric ? 'm' : 'ft';
    if ($('cf-stat-tst-unit')) $('cf-stat-tst-unit').textContent = STATE.isMetric ? 'm' : 'ft';
    if ($('cf-stat-ror-unit')) $('cf-stat-ror-unit').textContent = STATE.isMetric ? 'm²' : 'ft²';

    /* v303 the size bar's label: the cinema bar (GARDEN STRUCTURE) shows its
       own name, the benches and swings keep the theme's BENCH */
    (function () {
      var szl = global.document && global.document.querySelector('.cf-size-bar .cf-size-label');
      if (!szl) return;
      if (szl.getAttribute('data-orig') == null) szl.setAttribute('data-orig', szl.textContent);
      var T4 = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      var vN4 = STATE.variant | 0, nm4 = (vN4 === 19 || vN4 === 20 || vN4 === 21 || vN4 === 22 || vN4 === 23 || vN4 === 24 || vN4 === 25 || vN4 === 26 || vN4 === 27 || vN4 === 28 || vN4 === 29 || vN4 === 30 || vN4 === 31 || vN4 === 32 || vN4 === 33 || vN4 === 34 || vN4 === 35 || vN4 === 53 || vN4 === 36 || vN4 === 37 || vN4 === 38 || vN4 === 39 || vN4 === 40 || vN4 === 41 || vN4 === 42 || vN4 === 43 || vN4 === 44 || vN4 === CS_TYPE || vN4 === 45 || vN4 === 46 || vN4 === 49 || vN4 === 52 || vN4 === 47 || vN4 === 48 || vN4 === 51) ? T4['variant_v' + vN4] : null;   /* v403 + the modern dog house */   /* v396 + the double dog house */   /* v392 + the kennel with run */   /* v391 + the cupola coop */   /* v388 + the insulated dog house */   /* v386 + the lean-to coop */   /* v385 + the dog house */   /* v383 + the walk-in coop */   /* v379 + the chicken tractor */   /* v376 + the kitchen pod */   /* v375 + the backyard coop */   /* v373 + the gable greenhouse */   /* v368 + the tree fort */   /* v367 + the little barn */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v355 + the bar */   /* v314 + the raised bed */
      szl.textContent = (typeof nm4 === 'string' && nm4) ? nm4 : szl.getAttribute('data-orig');
    })();

    /* Sofa (variant 2): the "seat planks" info item becomes the MATTRESS —
       label + an "L × W" footprint in the active unit (no thickness). For
       every other variant the item stays "seat planks" (linear m of decking)
       as built by the static markup above. */
    (function () {
      var tstLabelEl = $('cf-stat-tst-label');
      var tstValEl   = $('cf-stat-tst');
      var tstUnitEl  = $('cf-stat-tst-unit');
      if (!tstLabelEl || !tstValEl) return;
      var T3 = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      if ((STATE.variant | 0) === 2) {
        tstLabelEl.textContent = T3.bench_info_mattress || 'Mattress';
        var f = STATE.isMetric ? 1 : 3.281;
        var lv = (STATE.L * f), wv = (STATE.W * f);
        tstValEl.textContent = lv.toFixed(2) + ' × ' + wv.toFixed(2);
        if (tstUnitEl) tstUnitEl.textContent = STATE.isMetric ? 'm' : 'ft';
      } else if ((STATE.variant | 0) === 14 || (STATE.variant | 0) === 21) {
        /* v273 the bed: the mattress size (cm / in.); v318 + the floating bed */
        var msI = ((STATE.variant | 0) === 21) ? _fbSize(STATE) : _bedSize(STATE), fI = STATE.isMetric ? 100 : (1 / 0.0254);
        tstLabelEl.textContent = T3.bench_info_mattress || 'Mattress';
        tstValEl.textContent = Math.round(msI.w * fI) + ' \u00d7 ' + Math.round(msI.l * fI);
        if (tstUnitEl) tstUnitEl.textContent = STATE.isMetric ? 'cm' : 'in';
      } else if ((STATE.variant | 0) === 19) {
        /* v303 the cinema bar: the screen's size (its diagonal, cm / in.) */
        var gsI = _gsLayout(STATE).screen;
        tstLabelEl.textContent = T3.bench_size || 'Size';
        tstValEl.textContent = STATE.isMetric ? String(Math.round(gsI.diag * 2.54)) : String(gsI.diag);
        if (tstUnitEl) tstUnitEl.textContent = STATE.isMetric ? 'cm' : 'in';
      } else if ((STATE.variant | 0) === 54) {
        /* v414 the twist bench: its slats (the length sets them) */
        tstLabelEl.textContent = T3.post_wall_slats || 'Slats';
        tstValEl.textContent = String(_rtbN(STATE));
        if (tstUnitEl) tstUnitEl.textContent = T3.pcs || 'pcs';
      } else if ((STATE.variant | 0) === 20) {
        /* v314 the raised bed: its soil (m3 / ft3) */
        var rbI = _rbLayout(STATE);
        tstLabelEl.textContent = T3.volume || 'Volume';
        tstValEl.textContent = STATE.isMetric ? rbI.soilV.toFixed(2) : String(Math.round(rbI.soilV * 35.3147));
        if (tstUnitEl) tstUnitEl.textContent = STATE.isMetric ? 'm\u00b3' : 'ft\u00b3';
      } else {
        /* Restore the seat-planks rendering for non-sofa variants (in case
           the user switched away from sofa within the same session). */
        /* v309 (Marek: kde nejsou planks tak odstranit, dat tam treba
           delku profilu): a type without seat planks shows its LUMBER --
           the timber's running length (every KV.. code) */
        var noPl = !((+b.tst) > 0.0005);
        tstLabelEl.textContent = noPl ? (T3.bench_info_lumber || 'Lumber') : (T3.bench_info_seat || 'Seat planks');
        tstValEl.textContent = fmtLen(noPl ? lumberTotal : b.tst);
        if (tstUnitEl) tstUnitEl.textContent = STATE.isMetric ? 'm' : 'ft';
      }
    })();

    /* Assembly step label. Each step is mapped to the BoQ code of the
       component being added, then resolved through the central BoQ
       bridge (ConfiguratorBudgetBridge.getBoqItem) so the user sees
       the same localized item name they see everywhere else on the
       site (cart, BoQ drawer, PDF export). Two non-component slots
       fall back to the i18n bag: "Built", "Exploded view", "Pocket
       holes", "Install on bench". */
    if ($('cf-stat-assembly')) {
      var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      var bridge = global.ConfiguratorBudgetBridge || null;
      function boqName(code) {
        var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
        if (item && item.name) return item.name;
        var local = MATERIALS && MATERIALS[code];
        return (local && local.name) ? local.name : code;
      }
      /* Step → BoQ code (or null for view/animation slots that don't
         add a component). Order MUST match the assembly sequence. */
      var _pf = _lumber(STATE);
      var _PC = _pf.postCode, _FC = _pf.frameCode, _PL = _pf.plankCode;
      var STEP_CODES = [
        null,           /* 0  Built              */
        null,           /* 1  Exploded view      */
        null,           /* 2  Pocket holes view  */
        _PC,            /* 3  Corner posts       */
        _FC,            /* 4  Side rails         */
        'FAS50060',     /* 5  Pocket-hole screws */
        _FC,            /* 6  Long rails         */
        'FAS50060',     /* 7  Pocket-hole screws */
        _FC,            /* 8  Joists             */
        'FAS50060',     /* 9  Pocket-hole screws */
        _PL,            /* 10 Seat planks        */
        'FAS50060',     /* 11 Deck screws        */
        _FC,            /* 12 Armrests           */
        'FAS50060',     /* 13 Pocket-hole screws */
        _FC,            /* 14 Backrest rails     */
        _FC,            /* 15 Backrest posts     */
        'FAS50060',     /* 16 Pocket-hole screws */
        _FC,            /* 17 Stretchers         */
        'FAS50060',     /* 18 Pocket-hole screws */
        null,           /* 19 Install (action)   */
        'FAS80100',     /* 20 Lag bolts          */
        _PL,            /* 21 Backrest planks    */
        'FAS50060'      /* 22 Deck screws        */
      ];
      var VIEW_LABELS = [
        T.bench_assembly_built        || 'Built',
        T.bench_assembly_exploded     || 'Exploded view',
        T.bench_assembly_pocket_holes || 'Pocket holes'
      ];
      var hasBack = (STATE.backrestVisible !== false);
      var isSofaCnt = _isSofaAsm(STATE);   /* v269: + the porch swing in the sofa style */
      var isWaveCnt = false;   /* v257: the wave has its staged steps too (WAVE_STEPS) */
      var isSwingCnt = _isStagedType(STATE.variant);   /* Hollywood, porch, A-frame swing, Adirondack: their step tables */
      var maxStep = isWaveCnt ? 0
                  : isSwingCnt ? _swingLastStep(STATE)
                  : (isSofaCnt ? _sofaStepMap(STATE).last : (hasBack ? 22 : 13));
      if (isSwingCnt) {
        var actC = _swingActiveSteps(STATE), posC = Math.max(0, actC.indexOf(STATE.assemblyStep | 0));
        $('cf-stat-assembly').textContent = posC + '/' + (actC.length - 1);
        /* the roof column: type + pitch, and the pitch slider's value (the
           ridge handle drags the pitch too) */
        if (_isStandType(STATE.variant)) try {
          var rlEl = document.getElementById('cf-bench-back-toggle-label');
          if (rlEl) rlEl.textContent = swingRoofLabel();
          var piEl = document.getElementById('cf-bench-pitch');
          if (piEl && document.activeElement !== piEl) piEl.value = String(_swingPitch(STATE));
        } catch (ePi) {}
      } else {
        $('cf-stat-assembly').textContent = STATE.assemblyStep + '/' + maxStep;
      }
      try { _xpSliderSync(); } catch (eXs) {}   /* v395 the exploded view's slider on the coops' step 1 */
      try { _kpFlapSliderSync(); } catch (eKf) {}   /* v406 the kitchen pod's flap slider */
      var titleEl = $('cf-btn-assembly');
      if (titleEl) {
        var s = STATE.assemblyStep;
        var label;
        if (isWaveCnt) {
          label = (T.bench_assembly_built || 'Built');
        } else if (isSwingCnt) {
          var swSt = _swingStepTable(STATE)[s];
          label = (s > 0 && swSt && (swSt.codes.length || (swSt.lk && swSt.lk.length))) ? swSt.codes.map(function (c) { return String(boqName(c)).replace(/\s*\u03c0\s*/g, ' ').trim(); }).concat((swSt.lk || []).map(function (kL) { return T[kL] || kL; })).join(' + ') : VIEW_LABELS[0];   /* v381 + lk: the locale keys naming a step's items with no catalogue row (the hoop house) */   /* v357 a placeholder the sheet has no size for: out */
        } else if (isSofaCnt) {
          /* ── SOFA (variant 2) step → BoQ items it installs ──────────
             Independent of the park-bench map. Each entry lists the codes
             relevant to that step; the label joins their localized names. */
          var slatCodeS = null;
          if ((STATE.slats | 0) > 0) {
            var stS = SOFA.slatState(STATE.slats, SOFA.isTall(STATE));
            if (stS && stS.profile) slatCodeS = stS.profile;
          }
          var DOWEL = 'FAT00006', PKT = 'FAS50060';
          var isPorchS = ((STATE.variant | 0) === 7);
          var isBedS = ((STATE.variant | 0) === 14);   /* v273: the bed */
          var KVH4 = isPorchS ? PSOFA.CODE : isBedS ? BED.CODE : SOFA.RAIL_CODE;   /* 4x4 frame (the porch swing: 3x3) */
          var SOFA_STEPS = [
            [],                       /* 0  Built */
            [],                       /* 1  Exploded view */
            [KVH4, DOWEL],            /* 2  Pocket holes (4×4 frame + dowels) */
            [KVH4, DOWEL],            /* 3  Side panels: posts + seat-end rails + dowels */
            [PKT],                    /* 4  Side panel pocket-hole screws */
            [KVH4, DOWEL],            /* 5  Top-end rails + dowels */
            [PKT],                    /* 6  Top-end pocket-hole screws */
            [KVH4, DOWEL],            /* 7  Long rails + dowels (shown) */
            [KVH4],                   /* 8  Long rails joined (slide together) */
            [PKT],                    /* 9  Long-rail pocket-hole screws */
            [SOFA.LEDGER_CODE],       /* 10 Ledger battens (shown) */
            [SOFA.LEDGER_CODE, PKT]   /* 11 Ledger fixed (batten + screws) */
          ];
          /* Center support legs (long sofas) add a step (12) before the
             rošt, then the rošt / slats / slat-screw steps follow. */
          if (_sofaStepMap(STATE).hasLegs) {
            SOFA_STEPS.push([KVH4, DOWEL]);   /* 12 Center support legs + dowels */
          }
          SOFA_STEPS.push([isPorchS ? PSOFA.ROST_CODE : isBedS ? BED.ROST_CODE : SOFA.ROST_CODE]);  /* the platform boards: sofa 2x4, porch swing 1x4, the bed's slats 1x4 */
          if (isBedS) {
            SOFA_STEPS.push([BED.SCREW]);       /* v273: the slats screwed down */
            SOFA_STEPS.push([BED.MATT_CODE]);   /* the mattress */
          } else if (isPorchS) {
            SOFA_STEPS.push([SWING.CHAIN_CODE]);                   /* v269: chains */
            SOFA_STEPS.push([SWING.EYE_CODE, SWING.HANGER_CODE]);  /* eye bolts + hangers */
            SOFA_STEPS.push([]);                                   /* the beam (context): the built view's name */
          } else {
          SOFA_STEPS.push([slatCodeS]);       /* slats */
          SOFA_STEPS.push([PKT]);             /* slat screws */
          }
          if (s <= 2) {
            label = VIEW_LABELS[s] || VIEW_LABELS[0];   /* 0 Built · 1 Exploded · 2 Pocket holes */
          } else {
            var codes = (SOFA_STEPS[s] || []).filter(function (c) { return !!c; });
            label = codes.length
              ? codes.map(function (c) { return boqName(c); }).join(' + ')
              : VIEW_LABELS[0];
          }
        } else {
          if (s <= 2)         label = VIEW_LABELS[s] || VIEW_LABELS[0];
          else if (s === 19)  label = (T.bench_assembly_install || 'Install on bench');
          else if (STEP_CODES[s]) label = boqName(STEP_CODES[s]);
          else                label = VIEW_LABELS[0];
        }
        titleEl.title = label;
      }
    }

    /* View + viz stage labels */
    if ($('cf-stat-viz')) {
      $('cf-stat-viz').textContent = STATE.vizStage;
    }
    var vizBtn = $('cf-btn-viz');
    if (vizBtn) {
      var T2 = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      /* Helper: treat "Translation missing: ..." strings as missing too.
         Shopify's `t` filter returns this string (not empty) when the key
         is absent, so a plain `|| fallback` in Liquid wouldn't trigger.
         We catch that here so the UI shows a clean fallback instead of the
         raw missing-translation marker. */
      function tt(val, fallback) {
        if (!val) return fallback;
        if (typeof val === 'string' && val.indexOf('Translation missing') === 0) return fallback;
        return val;
      }
      var STAGE_LABELS = {
        '3d:1': tt(T2.viz_3d_1, 'Full build'),
        '3d:2': _isKpType(STATE.variant) ? tt(T2.viz_frame, 'Structure only') : tt(T2.viz_3d_2, 'Inspection (structure 30 %)'),   /* v412 the pods: the frame only */
        '3d:3': tt(T2.viz_3d_3, 'Profiles (color-coded)'),
        '3d:4': tt(T2.viz_3d_4, 'Section cut'),
        '3d:5': tt(T2.viz_3d_5, 'Seating set (sofa + 2 chairs)'),
        '2d:1': tt(T2.viz_2d_1, 'Top view (plan)'),
        '2d:2': tt(T2.viz_2d_2, 'Side elevation (bokorys)'),
        '2d:3': tt(T2.viz_2d_3, 'Front elevation (nárys)')
      };
      var key = STATE.view + ':' + STATE.vizStage;
      var vizFullTitle = tt(T2.vizPrefix, 'Visualisation:') + ' ' +
                         (STAGE_LABELS[key] || ('Stage ' + STATE.vizStage));
      vizBtn.title = vizFullTitle;
      vizBtn.setAttribute('aria-pressed', STATE.vizStage !== 1 ? 'true' : 'false');
      vizBtn.style.opacity = '';
      vizBtn.style.pointerEvents = '';
    }
    var viewBtn = $('cf-btn-view');
    if (viewBtn) {
      var viewT = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      viewBtn.title = STATE.view === '3d'
        ? (viewT.toggleTo2D || 'Switch to 2D top view')
        : (viewT.toggleTo3D || 'Switch to 3D view');
      viewBtn.setAttribute('aria-pressed', STATE.view === '2d' ? 'true' : 'false');
    }

    /* Refresh dimension overlay — fires on every state change that goes
       through refreshUI (drag, unit toggle, view switch). The refresh
       internally exits cheaply when not in 2D, so the cost in 3D is just
       a single function call + early return. */
    if (global.BenchDimensions && global.BenchDimensions.refresh) {
      global.BenchDimensions.refresh();
    }

    /* Publish to budget on every refresh (debounced inside).
       Skip when only unit changed — published data is unchanged (always contains
       both metric AND imperial values), and budget handles unit switching
       internally via the unitChange event. Skipping avoids a costly
       processSheetLines pass on every unit toggle. */
    if (!skipPublish) {
      publishBoQToBudget();
    }
  }

  /* ───────────────────────── Undo (session history) ──────────────
     The sidebar's former Reset button becomes an Undo button: each click
     steps back through the DESIGN changes made this session (length,
     variant, backrest, level, rake, back-rail height). When the session
     history is exhausted, the next click resets the bench to factory
     defaults.

     Only design fields are tracked — view, visualisation stage, unit,
     scale-figure and assembly-step toggles are deliberately excluded so
     Undo walks back the actual configuration, not view changes.
     Recording hooks BenchRenderer.build() (debounced) so a continuous
     length drag collapses into a single undo entry. ─────────────────── */
  var _UndoHistory = {
    _stack: [],
    _committed: null,
    _timer: null,

    _snap: function () {
      return {
        L: STATE.L, W: STATE.W, H: STATE.H,
        variant: STATE.variant, lvl: STATE.lvl,
        backRakeDeg: STATE.backRakeDeg,
        backrestVisible: STATE.backrestVisible,
        picnicSeparate: STATE.picnicSeparate === true,
        backH: STATE.backH,
        psofaBack: STATE.psofaBack,
        bedMW: STATE.bedMW, bedHead: STATE.bedHead,   /* v273: the bed */
        bedHeadStyle: STATE.bedHeadStyle,             /* v275: its headboard's infill */
        porchFill: STATE.porchFill, porchGap: STATE.porchGap,   /* v281 */
        gbArms: STATE.gbArms === true, gbArmH: STATE.gbArmH,   /* v285 */
        sbW: STATE.sbW, sbAng: STATE.sbAng,                    /* v288 the sunbed */
        kidsBench: STATE.kidsBench === true,                   /* v299 the kids' set: swings / bench */
        mfFound: STATE.mfFound, mfWeave: STATE.mfWeave === true,  /* v301 the modern swing */
        mfCant: STATE.mfCant === true,                         /* v308 its LED top */
        rtbMode: _rtbMode(STATE),                              /* v414 the twist bench */
        gsScreen: STATE.gsScreen !== false,                    /* v303 the cinema bar's screen */
        gsDrop: STATE.gsDrop,                                  /* v305 its drop */
        rbMode: STATE.rbMode, rbW: STATE.rbW, rbN: STATE.rbN, rbOpen: STATE.rbOpen === true, rbTrellis: STATE.rbTrellis !== false,   /* v314 the raised bed, v316 its trellis (v325 on by default) */
        gaMode: STATE.gaMode, gaW: STATE.gaW, gaFound: _gaFound(STATE), gaGrid: _gaGrid(STATE),  /* v320 the garden arbor, v322 its foundation, v333 its trellis */
        gzN: _gzN(STATE),                                      /* v328 the gazebo's shape */
        gzFound: _gzFound(STATE), gzCov: _gzCov(STATE), gzFill: _gzFill(STATE), gzGap: STATE.gzGap, gzFields: JSON.stringify(_gzFields(STATE)),   /* v329 its foundation, covering, infill, gap; v350 the full sides */
        peW: STATE.peW, peGap: STATE.peGap, peRoof: _peRoof(STATE), peCov: _peCov(STATE), peFillT: _peFillT(STATE), peFound: _peFound(STATE), peFields: JSON.stringify(_peFields(STATE)),   /* v334 the pergola */
        phW: STATE.phW, phPorch: _phPorch(STATE), phSlide: (STATE.phSlide !== false), phSwings: (STATE.phSwings !== false), phLoft: (STATE.phLoft !== false), tfTrunk: STATE.tfTrunk, phRoof: STATE.phRoof || null, coHens: STATE.coHens || null, coRun: (STATE.coRun !== false), ctWheels: (STATE.ctWheels !== false), knDog: STATE.knDog || null, knFlap: (STATE.knFlap !== false), knDeck: (STATE.knDeck !== false),   /* v403 the modern dog house's roof deck */   /* v388 the insulated dog house's flap */
        csShape: STATE.csShape || null, csMb: (STATE.csMb !== false), csT: STATE.csT || null, csLook: STATE.csLook || null, phFound: STATE.phFound || null,   /* v402 the castle's plan / monkey bars / towers' size + look, the playhouses' foundation (Undo) */   /* v385 the dog house's dog */   /* v375 the coop */   /* v368 the tree fort's trunk */   /* v367 the barn's loft */   /* v365 the play fort's swings */   /* v362 the cottage; v363 the stilt house's slide */
        ghW: STATE.ghW, ghKnee: (STATE.ghKnee === true), ghBench: (STATE.ghBench === true), ghFound: _ghFound(STATE), ghWin: (STATE.ghWin != null) ? STATE.ghWin : null,   /* v373 the gable greenhouse */
        kpOpen: (STATE.kpOpen !== false), kpAng: _kpAng(STATE), kpFrame: _kpFrame(STATE),   /* v376 the kitchen pod's flap (v406 its angle, the counter's frame) */
        kpKinds: JSON.stringify(Array.isArray(STATE.kpKinds) ? STATE.kpKinds : null),   /* v379 its bays' equipment */
        kpN: _kpN(STATE), kpFound: _kpFound(STATE), kpClad: _kpClad(STATE), kpShelf: _kpShelf(STATE), kpRoof: _kpRoof(STATE), kpFin: _kpFin(STATE), kpLad: _kpLad(STATE),   /* v405 its bays' number, foundation, cladding, shelf, roof, counter finish */
        mbRet: _mbRet(STATE),                                  /* v355 the bar's return */
        mbShape: _mbShape(STATE), mbRoof: _mbRoof(STATE), mbPitch: STATE.mbPitch, mbH: STATE.mbH, mbCov: _mbCov(STATE)   /* v357 its options */
      };
    },
    _same: function (a, b) {
      if (!a || !b) return false;
      return a.L === b.L && a.W === b.W && a.H === b.H &&
             a.variant === b.variant && a.lvl === b.lvl &&
             a.backRakeDeg === b.backRakeDeg &&
             a.backrestVisible === b.backrestVisible &&
             a.picnicSeparate === b.picnicSeparate &&
             a.backH === b.backH && a.psofaBack === b.psofaBack &&
             a.bedMW === b.bedMW && a.bedHead === b.bedHead && a.bedHeadStyle === b.bedHeadStyle &&
             a.porchFill === b.porchFill && a.porchGap === b.porchGap &&
             a.gbArms === b.gbArms && a.gbArmH === b.gbArmH &&
             a.sbW === b.sbW && a.sbAng === b.sbAng && a.kidsBench === b.kidsBench &&
             a.mfFound === b.mfFound && a.mfWeave === b.mfWeave && a.mfCant === b.mfCant && a.rtbMode === b.rtbMode && a.gsScreen === b.gsScreen && a.gsDrop === b.gsDrop && a.rbMode === b.rbMode && a.rbW === b.rbW && a.rbN === b.rbN && a.rbOpen === b.rbOpen && a.rbTrellis === b.rbTrellis && a.gaMode === b.gaMode && a.gaW === b.gaW && a.gaFound === b.gaFound && a.gaGrid === b.gaGrid && a.gzN === b.gzN && a.gzFound === b.gzFound && a.gzCov === b.gzCov && a.gzFill === b.gzFill && a.gzGap === b.gzGap && a.gzFields === b.gzFields && a.peW === b.peW && a.peGap === b.peGap && a.peRoof === b.peRoof && a.peCov === b.peCov && a.peFillT === b.peFillT && a.peFound === b.peFound && a.peFields === b.peFields && a.mbRet === b.mbRet && a.mbShape === b.mbShape && a.mbRoof === b.mbRoof && a.mbPitch === b.mbPitch && a.mbH === b.mbH && a.mbCov === b.mbCov && a.phW === b.phW && a.phPorch === b.phPorch && a.phSlide === b.phSlide && a.phSwings === b.phSwings && a.phLoft === b.phLoft && a.tfTrunk === b.tfTrunk && (a.phRoof || null) === (b.phRoof || null) && a.ghW === b.ghW && a.ghKnee === b.ghKnee && a.ghBench === b.ghBench && a.ghFound === b.ghFound && a.ghWin === b.ghWin && a.kpOpen === b.kpOpen && a.kpAng === b.kpAng && a.kpFrame === b.kpFrame && a.kpKinds === b.kpKinds && a.kpN === b.kpN && a.kpFound === b.kpFound && a.kpClad === b.kpClad && a.kpShelf === b.kpShelf && a.kpRoof === b.kpRoof && a.kpFin === b.kpFin && a.kpLad === b.kpLad && (a.coHens || null) === (b.coHens || null) && a.coRun === b.coRun && a.ctWheels === b.ctWheels && (a.knDog || null) === (b.knDog || null) && a.knFlap === b.knFlap && a.knDeck === b.knDeck && (a.csShape || null) === (b.csShape || null) && a.csMb === b.csMb && (a.csT || null) === (b.csT || null) && (a.csLook || null) === (b.csLook || null) && (a.phFound || null) === (b.phFound || null);   /* v402 */   /* v388 */   /* v385 */   /* v379 */   /* v375 */   /* v368 */   /* v367 */   /* v362 + the cottage */   /* v357 the bar's options */   /* v355 + the bar */   /* v334 + the pergola */   /* v328 + the gazebo, v329 its options */   /* v322 + the arbor */
    },
    /* Establish the baseline without recording (initial load and after a
       programmatic restore — re-baselining makes the build()'s pending
       debounced note() a no-op, so no phantom entry is pushed). */
    baseline: function () {
      this._committed = this._snap();
      if (this._timer) { clearTimeout(this._timer); this._timer = null; }
      this._updateButton();
    },
    /* Called after every BenchRenderer.build(); debounced so drag bursts
       coalesce into one entry. Pushes the previously committed design
       state when the current design differs from it. */
    note: function () {
      var self = this;
      if (_holdWrites()) return;   /* v265: the voice tour / REF are not edits */
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        self._timer = null;
        var cur = self._snap();
        if (!self._committed) { self._committed = cur; return; }
        if (!self._same(cur, self._committed)) {
          self._stack.push(self._committed);
          if (self._stack.length > 100) self._stack.shift();
          self._committed = cur;
          self._updateButton();
        }
      }, 350);
    },
    _updateButton: function () {
      var btn = document.getElementById('cf-btn-reset');
      if (!btn) return;
      var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      var label = this._stack.length > 0
        ? (T.undo || 'Undo')
        : (T.reset_defaults || 'Reset to defaults');
      btn.setAttribute('title', label);
      btn.setAttribute('aria-label', label);
    }
  };

  function _applyConfig(c) {
    STATE.L = c.L; STATE.W = c.W; STATE.H = c.H;
    STATE.variant = c.variant; STATE.lvl = c.lvl;
    STATE.backRakeDeg = c.backRakeDeg;
    STATE.backrestVisible = c.backrestVisible;
    STATE.picnicSeparate = (c.picnicSeparate === true);
    STATE.backH = c.backH;
    STATE.psofaBack = c.psofaBack;
    STATE.bedMW = c.bedMW; STATE.bedHead = c.bedHead;   /* v273 */
    STATE.bedHeadStyle = c.bedHeadStyle;                /* v275 */
    STATE.porchFill = c.porchFill; STATE.porchGap = c.porchGap;   /* v281 */
    STATE.gbArms = (c.gbArms === true); STATE.gbArmH = c.gbArmH;   /* v285 */
    STATE.sbW = c.sbW; STATE.sbAng = c.sbAng;                      /* v288 */
    STATE.kidsBench = (c.kidsBench === true);                       /* v299 */
    STATE.mfFound = (c.mfFound === 'concrete') ? 'concrete' : 'screw'; STATE.mfWeave = (c.mfWeave === true);   /* v301 */
    STATE.mfCant = (c.mfCant === true);                              /* v308 */
    STATE.rtbMode = _rtbMode(c);                                     /* v414 */
    STATE.gsScreen = (c.gsScreen !== false);                        /* v303 */
    STATE.mbRet = (c.mbRet !== false);                              /* v355 the bar's return */
    STATE.mbShape = (MB_SHAPES.indexOf(c.mbShape) >= 0) ? c.mbShape : (STATE.mbRet ? 'Lr' : 'I'); STATE.mbRoof = (c.mbRoof === 'gable') ? 'gable' : 'mono'; STATE.mbPitch = c.mbPitch; STATE.mbH = c.mbH; STATE.mbCov = (c.mbCov !== false);   /* v357 */
    STATE.gsDrop = c.gsDrop;                                         /* v305 */
    STATE.rbMode = c.rbMode; STATE.rbW = c.rbW; STATE.rbN = c.rbN; STATE.rbOpen = (c.rbOpen === true); STATE.rbTrellis = (c.rbTrellis === true);   /* v314, v316 */
    STATE.gaMode = c.gaMode; STATE.gaW = c.gaW; STATE.gaFound = c.gaFound; STATE.gaGrid = (c.gaGrid === true);   /* v320, v322, v333 */
    STATE.gzN = (c.gzN === 4) ? 4 : 6;                                  /* v328 */
    STATE.gzFound = c.gzFound; STATE.gzCov = c.gzCov; STATE.gzFill = c.gzFill; STATE.gzGap = c.gzGap;   /* v329 */
    try { STATE.gzFields = JSON.parse(c.gzFields || '{}'); } catch (eGf) { STATE.gzFields = {}; }   /* v350 */
    STATE.phW = c.phW; STATE.phPorch = (c.phPorch !== false); STATE.phSlide = (c.phSlide !== false); STATE.phSwings = (c.phSwings !== false); STATE.phLoft = (c.phLoft !== false); STATE.tfTrunk = c.tfTrunk; STATE.phRoof = c.phRoof || null; STATE.coHens = c.coHens || null; STATE.coRun = (c.coRun !== false); STATE.ctWheels = (c.ctWheels !== false); STATE.knDog = c.knDog || null; STATE.knFlap = (c.knFlap !== false); STATE.knDeck = (c.knDeck !== false); STATE.csShape = c.csShape || null; STATE.csMb = (c.csMb !== false); STATE.csT = c.csT || null; STATE.csLook = c.csLook || null; STATE.phFound = c.phFound || null;   /* v402 */   /* v388 */   /* v385 */   /* v375 */   /* v368 */   /* v367 */   /* v365 */   /* v362; v363 */
    STATE.ghW = c.ghW; STATE.ghKnee = (c.ghKnee === true); STATE.ghBench = (c.ghBench === true); STATE.ghFound = c.ghFound; STATE.ghWin = (c.ghWin != null) ? c.ghWin : null;   /* v373 */
    STATE.kpOpen = (c.kpOpen !== false); STATE.kpAng = (typeof c.kpAng === 'number') ? c.kpAng : null; STATE.kpFrame = c.kpFrame;   /* v376, v406 */
    try { var kkU = JSON.parse(c.kpKinds || 'null'); STATE.kpKinds = Array.isArray(kkU) ? kkU : null; } catch (eKk) { STATE.kpKinds = null; }   /* v379 */
    STATE.kpN = (c.kpN === 3 || c.kpN === 5) ? c.kpN : 4; STATE.kpFound = c.kpFound; STATE.kpClad = c.kpClad; STATE.kpShelf = (c.kpShelf === true); STATE.kpRoof = c.kpRoof; STATE.kpFin = c.kpFin; STATE.kpLad = c.kpLad;   /* v405 */
    STATE.peW = c.peW; STATE.peGap = c.peGap; STATE.peRoof = c.peRoof; STATE.peCov = (c.peCov === true); STATE.peFillT = c.peFillT; STATE.peFound = c.peFound;   /* v334 */
    try { STATE.peFields = JSON.parse(c.peFields || '{}'); } catch (ePf) { STATE.peFields = {}; }
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
    _UndoHistory.baseline();   /* restored state becomes the new committed baseline */
  }

  function undo() {
    if (_UndoHistory._stack.length > 0) {
      _applyConfig(_UndoHistory._stack.pop());
    } else {
      /* End of session history → factory defaults. */
      reset();
      _UndoHistory.baseline();
    }
  }

  /* Turn the former Reset button into an Undo button: swap icon + label,
     bind undo, hook build() for recording, set the baseline. */
  function _initUndo() {
    if (global.BenchRenderer && typeof global.BenchRenderer.build === 'function' &&
        !global.BenchRenderer.__undoWrapped) {
      var _origBuild = global.BenchRenderer.build;
      global.BenchRenderer.build = function () {
        var r = _origBuild.apply(this, arguments);
        try { _UndoHistory.note(); } catch (e) {}
        return r;
      };
      global.BenchRenderer.__undoWrapped = true;
    }

    var btn = document.getElementById('cf-btn-reset');
    if (btn) {
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" style="width:22px;height:22px;display:block;margin:auto;pointer-events:none;">' +
        '<path d="M9 14 4 9l5-5"></path>' +
        '<path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11"></path>' +
        '</svg>';
      btn.addEventListener('click', function (e) {
        if (e) e.preventDefault();
        undo();
      });
    }

    _UndoHistory.baseline();
  }

  function reset() {
    /* Full reset to initial page-load state. Returns dimensions,
       view (3D), visualisation stage (1), assembly step (0 = composed),
       2D fill opacity, body-visible toggle, and visualisation cycle
       label all to defaults. Matches what a user sees on a fresh page
       load with no prior saved preferences. */
    STATE.L = DEFAULTS.L;
    STATE.W = DEFAULTS.W;
    STATE.H = DEFAULTS.H;
    STATE.variant      = DEFAULTS.variant;
    STATE.lvl          = DEFAULTS.lvl;
    STATE.backRakeDeg  = DEFAULTS.backRakeDeg;
    STATE.backrestVisible = DEFAULTS.backrestVisible;
    STATE.picnicSeparate = false;
    STATE.backH        = DEFAULTS.backH;
    STATE.view         = '3d';
    STATE.vizStage     = 1;
    STATE.assemblyStep = 0;
    STATE.opacity2D    = 0.45;
    STATE.bodyVisible  = false;
    STATE.bodyX        = null;
    STATE.bodyZ        = null;

    /* Reflect on opacity slider DOM if present. */
    var opSlider = document.getElementById('cf-2d-opacity-slider');
    if (opSlider) {
      opSlider.value = Math.round(STATE.opacity2D * 100);
      var maxV = parseInt(opSlider.max, 10) || 100;
      opSlider.style.setProperty('--cfg-fill',
        (100 - (STATE.opacity2D * 100 / maxV * 100)) + '%');
    }
    var opVal = document.getElementById('cf-2d-opacity-value');
    if (opVal) opVal.textContent = Math.round(STATE.opacity2D * 100) + '%';

    /* Rebuild scene with new dims + assembly step. */
    global.BenchRenderer.build();

    /* Re-apply view + viz stage (camera reposition, controls, dim chips,
       handle visibility, cf-view-2d class, opacity slider visibility). */
    if (global.BenchEngine) {
      if (global.BenchEngine.applyView)     global.BenchEngine.applyView();
      if (global.BenchEngine.applyVizStage) global.BenchEngine.applyVizStage();
    }

    refreshUI();

    /* Persist the reset so reload keeps it (matches initial state). */
    if (global.BenchLib && global.BenchLib.savePref) global.BenchLib.savePref();
  }

  /* ----------------------------------------------------------
     UNIT SYNC — bidirectional binding between configurator and budget.
     The page has two unit toggles: configurator's own (calls toggleUnits)
     and budget's #unitSelector (clickUnitSelector fires 'unitChange' event).
     We make them stay in lockstep:
       - Configurator toggle  → updates #unitSelector + fires 'unitChange'
       - Budget toggle        → updates STATE.isMetric + refreshUI
     ---------------------------------------------------------- */
  function _broadcastUnitToBudget(isMetric) {
    var unitSel = document.getElementById('unitSelector');
    if (!unitSel) return;
    var newUnit = isMetric ? 'metric' : 'imperial';
    if (unitSel.getAttribute('data-current-unit') === newUnit) return;
    unitSel.setAttribute('data-current-unit', newUnit);
    var display = document.getElementById('currentUnitDisplay');
    if (display) display.textContent = newUnit.charAt(0).toUpperCase() + newUnit.slice(1);
    /* Fire the same event budget-prd-cat-selector.liquid uses. budget.liquid
       listens for this and calls renderItems() to re-render with new units. */
    try {
      window.dispatchEvent(new CustomEvent('unitChange', { detail: { unit: newUnit } }));
    } catch (e) {}
  }

  function _syncFromBudgetUnit() {
    var unitSel = document.getElementById('unitSelector');
    if (!unitSel) return;
    var unit = unitSel.getAttribute('data-current-unit') || 'metric';
    var shouldBeMetric = (unit === 'metric');
    if (STATE.isMetric !== shouldBeMetric) {
      STATE.isMetric = shouldBeMetric;
      refreshUI(true);   /* skipPublish — data already has both units */
    }
  }

  function toggleUnits() {
    STATE.isMetric = !STATE.isMetric;
    if (_isKpType(STATE.variant)) STATE.L = _kpL(STATE);   /* v405 the kitchen pod: its length the bays' in the new units */
    if (_isGhType(STATE.variant)) {
      /* v373 the gable greenhouse: its size snaps to whole feet in US (8 ft, not 7.9), 10 cm in metric */
      var ghSn = function (v, R) { if (!(v > 0)) return v; var q = STATE.isMetric ? Math.round(v * 10) / 10 : Math.round(v / 0.3048) * 0.3048; return Math.max(R.min, Math.min(R.max, Math.round(q * 10000) / 10000)); };
      STATE.L = ghSn(STATE.L, _ghRange(STATE));
      if (STATE.ghW > 0) STATE.ghW = ghSn(STATE.ghW, _ghWRange(STATE));
    }
    if (_isPhType(STATE.variant)) {   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */
      /* v362 the cottage: its size snaps to the units' own step -- whole feet in US (6 ft, not 5.9), 10 cm in metric */
      if (_phIsDh(STATE) && STATE.knDog > 0) STATE.knDog = _dhDog(STATE);   /* v385 the dog house: the dog in whole cm / whole inches first (the house's range follows it) */
      var phSn = function (v, R) { if (!(v > 0)) return v; var dq = _phIsDh(STATE) ? _phU(STATE, 'STEP') : 0, q = dq ? Math.round(v / dq) * dq : STATE.isMetric ? Math.round(v * 10) / 10 : Math.round(v / 0.3048) * 0.3048; return Math.max(R.min, Math.min(R.max, Math.round(q * 10000) / 10000)); };   /* v385 the dog house: 5 cm / US 2 in. */
      if (_phIsCs(STATE) && STATE.csT > 0) { var csTR = _csU(STATE, 'T'); STATE.csT = phSn(STATE.csT, { min: csTR[0], max: csTR[1] }); }   /* v394 the L castle's towers first (its ranges follow them) */
      STATE.L = phSn(STATE.L, _phRange(STATE));
      if (STATE.phW > 0) STATE.phW = phSn(STATE.phW, _phWRange(STATE));
      if (STATE.tfTrunk > 0) STATE.tfTrunk = _tfTrunk(STATE);   /* v368 the tree fort's trunk: whole cm / whole inches */
    }
    if (_isStandType(STATE.variant) || (STATE.variant | 0) >= 9 || (STATE.variant | 0) === 6) {   /* sections follow the units */
      /* Hollywood swing: sections follow the unit system (US actual sizes
         in imperial), so the model is rebuilt and the bill republished. */
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
    } else {
      refreshUI(true);   /* skipPublish - data unchanged, budget gets event */
    }
    _broadcastUnitToBudget(STATE.isMetric);
  }

  /* HOLLYWOOD SWING CONTROLS. The info-bar toggle swaps the roof (gable <>
     mono-pitch), the pitch slider above it (and the ridge handle) sets the
     pitch, the tilt slider sets the backrest. Words from the locales
     (roof_v1, roof_v4, roof_pitch), never hard-coded. */
  function swingRoofLabel() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var r = _swingRoof(STATE);
    var key = (r === 'gable') ? 'roof_v1' : 'roof_v4';
    var v = T[key];
    return ((typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : key) + ' ' + _swingPitch(STATE) + '\u00b0';
  }
  /* v299 the kids' set (type 13): the info-bar toggle = its swings / its
     bench; each mode its own length (its default on the switch). The label:
     the existing type names (Kids Swing Set / Porch Swing) */
  /* v301 the modern swing (type 18): the info-bar toggle = its foundation
     (ground screws / concrete footings, the house line's names base_v5 /
     base_v3), the level button = the weave (slats + shade cloth) / blocks */
  function cycleMfFound() {
    if ((STATE.variant | 0) !== 18) return;
    STATE.mfFound = (_mfFound(STATE) === 'screw') ? 'concrete' : 'screw';
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function toggleMfWeave() {
    if ((STATE.variant | 0) !== 18) return;
    /* v308 three tops in turn: blocks > the woven fabric > the LED top */
    var tp = _mfTop(STATE);
    STATE.mfWeave = (tp === 'blocks');
    STATE.mfCant = (tp === 'weave');
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function mfFoundLabel(found) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var f = (found === 'screw' || found === 'concrete') ? found : _mfFound(STATE), v = (f === 'concrete') ? T.base_v3 : T.base_v5;
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : (f === 'concrete' ? 'Concrete pads' : 'Ground screws');
  }
  function toggleKidsBench() {
    if ((STATE.variant | 0) !== 13) return;
    STATE.kidsBench = !_kidsBench(STATE);
    STATE.L = STATE.kidsBench ? PORCH.L_DEFAULT : KIDS.L_DEFAULT;
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function kidsModeLabel(bench) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var b = (typeof bench === 'boolean') ? bench : _kidsBench(STATE), v = b ? T.variant_v7 : T.variant_v13;
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : (b ? 'Porch Swing' : 'Kids Swing Set');
  }
  function cycleSwingRoof() {
    if (!_isStandType(STATE.variant)) return;
    var order = SWING.ROOF_ORDER, cur = _swingRoof(STATE), i = order.indexOf(cur);
    STATE.swingRoof = order[(i + 1) % order.length];
    STATE.swingPitch = _swingPitch(STATE);            /* the pitch kept, clamped to the new type's range */
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* the pitch slider: its range for the roof type and the current value */
  function swingPitchRange() {
    var R = SWING.PITCH[_swingRoof(STATE)];
    return { min: R.min, max: R.max, value: _swingPitch(STATE) };
  }
  function setSwingPitch(deg) {
    if (!_isStandType(STATE.variant)) return;
    deg = +deg;
    if (!isFinite(deg)) return;
    var R = SWING.PITCH[_swingRoof(STATE)];
    STATE.swingPitch = Math.max(R.min, Math.min(R.max, Math.round(deg)));
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* The backrest tilt is continuous, but read back as the name of its band
     (Marek: posuvnik, ale nazvy jsou vypovidajici): Upright < 24 deg <
     Relaxed < 37 < Recline < 52 < Lounge < 75 < Bed. Keys
     configurator.bench_swing_line_1..5; the degrees alone if one is missing. */
  var SWING_BACK_BANDS = [20, 37, 52, 75];
  function swingBackLabel() {
    var b = _swingBack(STATE), n = 1, i;
    for (i = 0; i < SWING_BACK_BANDS.length; i++) if (b >= SWING_BACK_BANDS[i]) n = i + 2;
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var v = T['bench_swing_line_' + n];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : String(Math.round(b));
  }
  /* Adirondack: the back slats' tilt from vertical (the tilt slider) */
  function setAdiBack(deg) {
    if ((STATE.variant | 0) !== 9) return;
    deg = +deg;
    if (!isFinite(deg)) return;
    STATE.adiBack = Math.max(ADI.BACK_MIN, Math.min(ADI.BACK_MAX, Math.round(deg)));
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* v264: the wave lounger's posture on the slider (15 upright .. 90 bed),
     the band names as the Hollywood's; the slat spacing on the toggle */
  function setWaveBack(deg) {
    if ((STATE.variant | 0) !== 3) return;
    deg = +deg;
    if (!isFinite(deg)) return;
    STATE.waveBack = Math.max(15, Math.min(90, Math.round(deg)));
    delete STATE._waveBetaAnim;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function waveBackLabel() {
    var b = _waveBeta(STATE), n = 1, i;
    for (i = 0; i < SWING_BACK_BANDS.length; i++) if (b >= SWING_BACK_BANDS[i]) n = i + 2;
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var v = T['bench_swing_line_' + n];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : String(Math.round(b));
  }
  function cycleWaveGap() {
    if ((STATE.variant | 0) !== 3) return;
    var gp = (STATE.slatGap != null) ? STATE.slatGap : WAVE.GAP_DEF, k = 0, i;
    for (i = 0; i < WAVE.GAPS.length; i++) if (Math.abs(WAVE.GAPS[i] - gp) < Math.abs(WAVE.GAPS[k] - gp)) k = i;
    STATE.slatGap = WAVE.GAPS[(k + 1) % WAVE.GAPS.length];
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function waveGapLabel() {
    var gp = (STATE.slatGap != null) ? STATE.slatGap : WAVE.GAP_DEF;
    return STATE.isMetric === false ? (gp / 0.0254).toFixed(2) + ' in' : Math.round(gp * 1000) + ' mm';
  }
  function setSwingBack(deg) {
    if (!_isSwingBackType(STATE.variant)) return;
    deg = +deg;
    if (!isFinite(deg)) return;
    STATE.swingBack = Math.max(SWING.BACK_MIN, Math.min(_swingBackMax(STATE), Math.round(deg)));
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }


  function share() {
    /* Universal share flow: if configurator-share.js is loaded (the
       snippet adds it via <script src>), open the rich share modal —
       image card with totals, WhatsApp / Download / Copy-Link actions.
       The modal reads window.ConfiguratorShareLabels (i18n) and
       window.ConfiguratorShareGetTotals (data callback) set by the
       snippet's inline IIFE.

       If the share module isn't loaded yet, fall back to
       navigator.share / clipboard so the button never feels broken.
       Fallback strings come from BENCH_BOOT.i18n.share.* (which
       configurator-locales.liquid populates) — no hardcoded labels. */
    var T  = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var SH = T.share || {};

    if (global.ConfiguratorShare && typeof global.ConfiguratorShare.open === 'function') {
      try { global.ConfiguratorShare.open(); return; }
      catch (err) {
        _dbg('ConfiguratorShare.open threw: ' + (err && err.message ? err.message : err));
      }
    }

    /* Fallback for browsers without the share modal loaded. Builds a
       plain-text summary using the product title; no hardcoded
       "Lumber:/Decking:/Roof:" labels — the dimensions and totals
       speak for themselves cross-language. */
    var b = global.BenchBoQ.compute();
    var unit = STATE.isMetric ? ' m' : ' ft';
    var txt = (BOOT.productTitle || 'Bench') + '\n' +
              fmtLen(STATE.L) + ' × ' + fmtLen(STATE.W) + ' × ' + fmtLen(STATE.H) +
              ' ' + (STATE.isMetric ? 'm' : 'ft') + '\n' +
              fmtLen(b.kvh) + unit + ' lumber';

    if (navigator.share) {
      navigator.share({ title: BOOT.productTitle || 'Bench', text: txt })
        .catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(txt);
      alert(T.copiedToClipboard || 'Copied to clipboard');
    }
  }

  /* ─────────────────────────────────────────────────────────────
     PDF EXPORT — assembles all data the universal PDF exporter
     needs (cover totals, 3D snapshots, 2D snapshots, cut list, BoQ)
     and hands them off to ConfiguratorPdfExporter.export().

     The exporter knows NOTHING about rack — every shape it draws is
     described by the args object below. Clone this for new
     configurators by replacing only the data-collection helpers.
     ───────────────────────────────────────────────────────────── */
  /* ─────────────────────────────────────────────────────────────
     PDF EXPORT — assembles all data the universal PDF exporter
     needs (cover totals, iso + 3 ortho snapshots with vector dim
     overlays, cut list, BoQ) and hands them off to
     ConfiguratorPdfExporter.export().

     The exporter knows NOTHING about rack — every shape it draws is
     described by the args object below. Clone this for new
     configurators by replacing only the data-collection helpers.
     ───────────────────────────────────────────────────────────── */
  /* Fetch an image URL and return a JPEG data-URL (jsPDF needs data,
     not a remote URL). Resolves null on any failure (CORS taint etc.). */
  /* THE SHAPED PARTS FOR THE PDF (Marek: komplikovany bocni profil na
     samostatnou stranku, okotovat kruznice a rozteci). Each sheet: the
     outline(s) in metres, the arcs' circles with their centres, the
     dimensions to read off. Lengths in the unit system: mm / inches. */
  function _partFmt(m) {
    if (STATE.isMetric === false) return (Math.round(m / 0.0254 * 10) / 10) + ' in';
    return Math.round(m * 1000) + ' mm';
  }
  function _partSheetFromPoly(title, qty, pts, note) {
    /* an outline (array of [x,y]) with its overall length and height dimensioned */
    var xMin = 1e9, xMax = -1e9, yMin = 1e9, yMax = -1e9, i;
    for (i = 0; i < pts.length; i++) { xMin = Math.min(xMin, pts[i][0]); xMax = Math.max(xMax, pts[i][0]); yMin = Math.min(yMin, pts[i][1]); yMax = Math.max(yMax, pts[i][1]); }
    return {
      title: title, qty: qty, note: note || '', polylines: [pts], circles: [], points: [],
      dims: [{ x0: xMin, y0: yMin, x1: xMax, y1: yMin, text: _partFmt(xMax - xMin), off: -0.08 },
             { x0: xMax, y0: yMin, x1: xMax, y1: yMax, text: _partFmt(yMax - yMin), off: -0.08 }],
      texts: [], box: { xMin: xMin, xMax: xMax, yMin: yMin, yMax: yMax }
    };
  }
  /* v295 (Marek: bocnice nejak rozvest i v PDF) THE WAVE LOUNGER'S SIDE
     PANEL: the outline dimensioned, then each layer with its boards
     numbered and their cut lengths (the stock, laid 20 mm over) */
  function _waveRibSheets() {
    var g = _waveLayout(STATE), rb = g.rb, T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, i;
    var bridge = global.ConfiguratorBudgetBridge || null;
    function nm(code, fb) {
      var item = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(code) : null;
      return (item && item.name) ? String(item.name).replace(/\s*\u03c0\s*$/, '') : (MATERIALS[code] && MATERIALS[code].name) || fb;
    }
    var outline = g.dense.map(function (q) { return [q.x, q.y]; });
    var ttl = T.bench_wave_rib || 'Side panel', nN = 0, x0 = rb.x0, x1 = rb.x1;
    for (i = 0; i < g.screws.length; i++) if (g.screws[i].kind === 'nail') nN++;
    nN = Math.round(nN / g.ribN);
    var board = nm(WAVE.WANGE_CODE, '1x4') + ' ' + _partFmt(g.bt) + ' x ' + _partFmt(g.bw);
    var glueP = Math.round(g.area * CAT_NEW.GLUE_L_M2 * 100) / 100;
    /* 1. the outline: overall, the head's top, the seat's lowest point, the
       ordinates at every upright board's joint */
    var s1 = _partSheetFromPoly(ttl, g.ribN, outline,
      '2 x ' + board + ' (' + _partFmt(g.wt) + '). ' + nm(CAT_NEW.GLUE, 'glue') + ' ' + glueP + ' l, ' + nm(WAVE.NAIL, 'nail') + ' x ' + nN + '.');
    var hi = 0, hix = x0, lo = 1e9, lox = x0;
    for (i = 0; i < g.dense.length; i++) { var dq = g.dense[i]; if (dq.y > hi) { hi = dq.y; hix = dq.x; } }
    for (i = 0; i < g.dense.length; i++) { var dl = g.dense[i]; if (dl.x > hix + 0.05 && dl.x < x1 - 0.25 && dl.y < lo) { lo = dl.y; lox = dl.x; } }
    s1.dims.push({ x0: hix, y0: 0, x1: hix, y1: hi, text: _partFmt(hi), off: 0.06 });
    if (lo < 1e8) { s1.dims.push({ x0: lox, y0: 0, x1: lox, y1: lo, text: _partFmt(lo), off: 0.06 }); s1.points.push({ x: lox, y: lo, label: '' }); }
    s1.points.push({ x: hix, y: hi, label: '' });
    for (i = 0; i < rb.vert.length; i++) {
      var xv = rb.vert[i].xb;
      if (xv >= x1 - 1e-6) continue;
      var yv = rb.Yat(xv);
      s1.texts.push({ x: xv - 0.012, y: yv + 0.03, text: (STATE.isMetric === false) ? String(Math.round(yv / 0.0254 * 10) / 10) : String(Math.round(yv * 1000)) });   /* the height at each joint, mm / in */
    }
    /* 2. the inner layer: the upright boards, numbered, with their lengths */
    var s2 = _partSheetFromPoly(T.bench_wave_rib_v || (ttl + ', upright boards'), g.ribN, outline,
      board + ' x ' + rb.vert.length + ': ' + rb.vert.map(function (b) { return b.n + ' = ' + _partFmt(b.stock); }).join(', '));
    for (i = 0; i < rb.vert.length; i++) {
      var bv = rb.vert[i];
      s2.polylines.push(bv.poly);
      s2.texts.push({ x: (bv.xa + bv.xb) / 2 - 0.012, y: Math.min(bv.len * 0.5, 0.25), text: String(bv.n) });
    }
    /* 3. the outer layer: the boards across, numbered, with their lengths */
    var s3 = _partSheetFromPoly(T.bench_wave_rib_h || (ttl + ', boards across'), g.ribN, outline,
      board + ' x ' + rb.hor.length + ': ' + rb.hor.map(function (b) { return b.n + ' = ' + _partFmt(b.stock); }).join(', '));
    for (i = 0; i < rb.hor.length; i++) {
      var bh = rb.hor[i];
      s3.polylines.push(bh.poly);
      s3.texts.push({ x: (bh.xl + bh.xr) / 2 - 0.02, y: bh.ya + Math.min(g.bw, bh.yb - bh.ya) * 0.3, text: bh.n + ' (' + _partFmt(bh.stock) + ')' });
    }
    return [s1, s2, s3];
  }
  /* v343 (Marek 2026-10-22 09:27: Ano, pokracuj -- the PDF part sheets of
     the pergola and the gazebo) EVERY SHAPED TIMBER ONCE PER SHAPE: the
     layout's lofted pieces of the listed kinds whose outline is not a plain
     rectangle (a cut not square: a birdsmouth, a plumb / seat cut, a 45 deg
     brace, a mitre seen from above, the hub's hexagon). The outline laid
     with its longest edge at the bottom; one sheet per distinct shape (a
     mirror image counts with it, "n mirrored"); every edge's length outside
     it, the angle at every corner that is not 90 deg; the note: the piece's
     thickness (t). The cut list keeps the plain sticks. */
  var _LOFT_SHEETS = {
    24: ['rafter', 'frafter', 'hip', 'ridge', 'beam', 'post', 'brace', 'xbrace'],
    23: ['hip', 'jack', 'hub', 'plate', 'rim', 'rail']
  };
  /* v350 (Marek 2026-10-22 14:54: Muzes dodelat co chybi -- the part
     sheets of the cinema bar, the raised bed and the garden arbor): their
     shaped pieces are flat outlines (poly) pushed through their thickness,
     the same cut on both faces -- taken as lofted pieces (A = B = the
     outline, t = the thickness) and drawn the same way; an outline that is
     the piece's cross-section (longer through than across: the cold frame's
     eave rails, its sashes' and battens' cross pieces, drawn sheared on the
     slope) gets no sheet -- the cut list has its length; the arbor's arch segments drawn as they sit in the arch, their radii and
     blank noted */
  var _POLY_SHEETS = {
    19: ['rafter', 'strut', 'kicker', 'brace', 'rbrace'],
    20: ['fpost', 'rafter', 'eave', 'sash', 'batten', 'tbrace'],
    22: ['arch', 'rafter', 'post', 'head', 'brace', 'slat', 'batten', 'lath'],
    25: ['beam', 'purlin', 'post', 'cbrace', 'rafter'],
    33: ['rafter', 'gstud', 'king', 'cripple', 'dbrace', 'rake'],   /* v373 the gable greenhouse: the rafters (birdsmouth, plumb cuts), the gable studs' / kings' / cripple's slopes, the door's braces, the rake boards */
    36: ['rafter', 'gstud', 'king', 'cripple', 'dbrace', 'rake', 'closer'],   /* v378 the lean-to greenhouse: the rafters (two birdsmouths, plumb cuts), the end studs' / kings' / cripple's slopes, the door's braces, the rake and closer boards */
    38: ['gstud', 'king', 'cripple', 'dbrace'],   /* v381 the hoop house: the end walls' studs / kings / cripples cut to the arc, the door's braces */
    40: ['rafter', 'gstud', 'king', 'cripple', 'dbrace', 'rake'],   /* v384 the A-frame greenhouse: the rafters (seat, plumb cut), the end studs' / kings' / cripple's slopes, the door's braces, the rake boards */
    43: ['rafter', 'hip', 'hjack', 'gstud', 'king', 'cripple', 'dbrace', 'rake'],   /* v387 the Victorian greenhouse: the common rafters, the hips (seat, cheek cuts), the jacks' family, the front gable's studs / kings / cripple, the door's braces, the rake boards */
    45: ['rafter', 'gstud', 'king', 'cripple', 'dbrace', 'rake'],   /* v390 the old-window greenhouse: as the gable's (the rafters, the gable studs' / kings' / cripple's slopes, the door's braces, the rake boards) */
    53: ['rafter', 'rplate', 'estud', 'rake'],   /* v407 GARDEN POD Fitness: the kitchen's shell */
    35: ['rafter', 'rplate', 'estud', 'rake'],   /* v376 the kitchen pod: the rafters (birdsmouth, plumb tails), the end walls' raking plates and studs, the rake boards */
    37: ['rafter', 'tie', 'roost', 'gstud', 'skid', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl'],   /* v379 the chicken tractor: its legs (birdsmouth, plumb cuts), the ties' / roosts' cut ends, the gable studs' slopes, the skids' chamfers, the rake boards, the doors' braces, the ramp */
    52: ['rafter', 'fly', 'gstud', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl', 'hpstud', 'hpking', 'hpcripple', 'hpdbrace'],   /* v401 the hoop coop: the backyard coop's house + the run's end walls (the hoop house's) */
    49: ['rafter', 'gstud', 'kbrace', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl'],   /* v397 the barn coop: the truss segments (mitres, birdsmouth, plumb tails), the gable studs, the rake trims, the backyard coop's rest */
    46: ['rafter', 'fly', 'gstud', 'kbrace', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl', 'csaddle', 'louver'],   /* v391 the cupola coop: the backyard coop's + the cupola's saddles and louvers */
    42: ['rafter', 'fly', 'gstud', 'kbrace', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl'],   /* v386 the lean-to coop: its one-piece rafters, the rest the backyard coop's */
    39: ['rafter', 'fly', 'gstud', 'kbrace', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl'],   /* v383 the walk-in coop: the backyard coop's */
    34: ['rafter', 'fly', 'gstud', 'kbrace', 'nbrace', 'fascia', 'ledge', 'dframe', 'ramp', 'rledge', 'rcl'],   /* v375 the backyard coop: the rafters, the partition's gable studs, the knee braces, the rake boards, the doors' braces, the ramp */
    32: ['kbrace', 'fboard', 'lrail'],
    [CS_TYPE]: ['kbrace', 'fboard', 'lrail', 'crafter', 'cstr', 'cboard', 'mbrace'],   /* v389 the castle: the braces, the walls' boards, the ladder's rails, the keep's rafters, the climbing wall */   /* v368 the tree fort: the knee braces, the pointed fort boards, the ladder's rails */
    31: ['rafter', 'gstud', 'fascia', 'ledge', 'lrail'],   /* v367 the little barn: the truss segments (mitres, birdsmouth, plumb tails), the gable studs' slopes, the rake trims, the doors' braces, the ladder's rails */
    30: ['mrafter', 'mfly', 'gstud', 'brace', 'mfascia', 'ledge'],   /* v366 the modern house: the one-piece rafters (two birdsmouths, plumb tails), the gable studs' slopes, the porch braces, the rake boards, the door's braces */
    29: ['rafter', 'fly', 'mrafter', 'mfly', 'mfascia', 'tbrace', 'fascia', 'fboard', 'lrail', 'sleg', 'scollar', 'sspread', 'sbrace', 'sbeam'],   /* v370 + the mono-pitch roof's */   /* v365 the play fort: the rafters, the knee braces, the rake boards, the fort boards' points, the ladder's rails, the swing frame's legs / collar / spreader / braces, the swing beam's scroll */
    28: ['rafter', 'fly', 'gstud', 'tie', 'fascia', 'ledge'],   /* v364 the A-frame: its rafters (level foot, plumb top), the gable studs' slopes, the collar ties' cut ends, the rake boards, the door's braces */
    27: ['rafter', 'fly', 'mrafter', 'mfly', 'mfascia', 'gstud', 'brace', 'fascia', 'ledge', 'xbrace', 'kbrace', 'lrail'],   /* v370 + the mono-pitch roof's */   /* v363 the stilt house: + the diagonals' plumb cuts, the front's knee braces, the ladder's rails (75 deg level cuts) */
    41: ['rafter', 'fly', 'gstud', 'brace', 'fascia'],   /* v385 the classic dog house: the cottage's without the door's braces */
    48: ['rafter', 'fly', 'gstud', 'brace', 'fascia'],   /* v396 the double dog house: the classic's */
    51: ['mrafter', 'mfly', 'gstud', 'mfascia', 'rstr', 'trail'],   /* v403 the modern dog house: the one-piece 2x4 rafters (two birdsmouths, plumb tails), the gable studs' slopes, the rake boards, the ramp's stringers (plumb head, level foot), the rakes' cap rails on the deck's fall */
    47: ['rafter', 'fly', 'gstud', 'brace', 'fascia', 'gframe'],   /* v392 the kennel with run: the classic's + the gate's brace */
    44: ['rafter', 'fly', 'gstud', 'fascia'],            /* v388 the insulated dog house: the classic's without the porch's braces */
    26: ['rafter', 'fly', 'gstud', 'brace', 'fascia', 'ledge']   /* v362 the cottage: the rafters' birdsmouth + plumb cuts, the gable studs' slopes, the porch braces, the rake boards, the door's braces */   /* v357 + the gable's rafters; v355 the bar: the beams' and purlins' cut ends, the posts' tops to the pitch, the counter's braces */
  };
  function _polyAsLoft(L) {
    var arc = L.arch ? { ri: L.arch.ri, re: L.arch.re } : null;
    return { pieces: (L.pieces || []).filter(function (pc) { return pc && pc.poly && pc.poly.length >= 3 && pc.code && pc.t > 0; }).map(function (pc) {
      return { kind: pc.kind, code: pc.code, id: pc.id, A: pc.poly, B: pc.poly, nA: 0, nB: pc.t, arc: (pc.kind === 'arch') ? arc : null, blank: pc.blank || null, fromPoly: true };
    }) };
  }
  function _loftKindLabel(kind, T) {
    if (kind === 'rafter' || kind === 'frafter' || kind === 'jack' || kind === 'hjack') return T.pdf_part_rafter || 'Rafter';   /* v387 + the Victorian's jacks */
    if (kind === 'hip') return T.pdf_part_hip_rafter || 'Hip rafter';
    if (kind === 'ridge') return T.roof_ridge || 'Ridge';
    if (kind === 'brace') return T.assembly_18 || 'Brace';
    if (kind === 'xbrace') return (T.assembly_18 || 'Brace') + ' X';
    if (kind === 'post') return T.pdf_part_post || 'Post';
    if (kind === 'beam') return T.pdf_part_beam || 'Beam';
    if (kind === 'hub') return T.pdf_part_hub || 'Hub';
    if (kind === 'plate') return T.pdf_part_top_plate || 'Top plate';
    if (kind === 'rim') return T.pdf_part_rim_joist || 'Rim joist';
    if (kind === 'rail') return T.pdf_part_rail || 'Rail';
    /* v350 the cinema bar, the raised bed, the garden arbor */
    if (kind === 'rbrace' || kind === 'tbrace' || kind === 'kicker' || kind === 'strut' || kind === 'cbrace') return T.assembly_18 || 'Brace';
    if (kind === 'purlin') return T.pdf_part_beam || 'Beam';   /* v355 the bar's purlins */
    if (kind === 'fpost') return T.pdf_part_post || 'Post';
    if (kind === 'eave') return T.pdf_part_rail || 'Rail';
    if (kind === 'head') return T.pdf_part_beam || 'Beam';
    if (kind === 'sash') return T.assembly_2 || 'Frame';
    if (kind === 'batten' || kind === 'lath') return T.pdf_part_batten || 'Batten';
    if (kind === 'slat') return T.post_wall_slats || 'Slats';
    if (kind === 'arch') return T.pdf_part_arch || 'Arch segment';
    /* v362 the cottage */
    if (kind === 'fly') return T.pdf_part_rafter || 'Rafter';
    if (kind === 'csaddle') return T.pdf_part_saddle || 'Saddle';   /* v391 the cupola coop's cupola saddles */
    if (kind === 'gstud') return T.pdf_part_stud || 'Stud';
    if (kind === 'fascia') return T.pdf_part_fascia || 'Fascia';
    if (kind === 'ledge') return T.assembly_18 || 'Brace';   /* the door's braces (its ledges are plain boards) */
    /* v363 the stilt house */
    if (kind === 'kbrace') return T.assembly_18 || 'Brace';   /* (its diagonals 'xbrace': the pergola's 'Brace X' above) */
    if (kind === 'tie') return T.pdf_part_beam || 'Beam';   /* v364 the A-frame's collar ties (no key of their own: the beam's) */
    if (kind === 'lrail') return T.pdf_part_rail || 'Rail';
    /* v365 the play fort */
    if (kind === 'fboard') return T.shelter_fill_boards || 'Boards';
    if (kind === 'sleg') return T.pdf_part_post || 'Post';
    if (kind === 'scollar' || kind === 'sspread') return T.pdf_part_rail || 'Rail';
    if (kind === 'sbrace') return T.assembly_18 || 'Brace';
    if (kind === 'sbeam') return T.pdf_part_beam || 'Beam';
    /* v366 the modern house */
    if (kind === 'mrafter' || kind === 'mfly') return T.pdf_part_rafter || 'Rafter';
    if (kind === 'mfascia') return T.pdf_part_fascia || 'Fascia';
    /* v373 the gable greenhouse */
    if (kind === 'king' || kind === 'cripple' || kind === 'hpstud' || kind === 'hpking' || kind === 'hpcripple') return T.pdf_part_stud || 'Stud';   /* v401 + the hoop coop's end walls */
    if (kind === 'dbrace' || kind === 'hpdbrace') return T.assembly_18 || 'Brace';
    if (kind === 'rake' || kind === 'closer') return T.pdf_part_fascia || 'Fascia';   /* v378 + the lean-to's closer board (the same 1x4) */
    /* v376 the kitchen pod */
    if (kind === 'rplate') return T.pdf_part_top_plate || 'Top plate';
    if (kind === 'estud') return T.pdf_part_stud || 'Stud';
    /* v375 the backyard coop: the nest boxes' braces, the run door's brace, the ramp's planks, ledges and cleats */
    if (kind === 'nbrace' || kind === 'dframe') return T.assembly_18 || 'Brace';
    if (kind === 'ramp') return T.shelter_fill_boards || 'Boards';
    if (kind === 'rledge' || kind === 'rcl') return T.pdf_part_batten || 'Batten';
    /* v379 the chicken tractor: its skids, its roosts (no key of their own: the beam's / the rail's) */
    if (kind === 'skid') return T.pdf_part_beam || 'Beam';
    if (kind === 'roost') return T.pdf_part_rail || 'Rail';
    /* v389 the castle: the keep's common rafters, the climbing wall's stringers (the ladder's rails' key) and boards, the monkey bars' braces */
    if (kind === 'crafter') return T.pdf_part_rafter || 'Rafter';
    if (kind === 'rstr') return T.pdf_part_beam || 'Beam';   /* v403 the modern dog house's ramp stringers (no key of their own: the beam's) */
    if (kind === 'trail') return T.pdf_part_rail || 'Rail';   /* -- its cap rails */
    if (kind === 'cstr') return T.pdf_part_rail || 'Rail';
    if (kind === 'cboard') return T.shelter_fill_boards || 'Boards';
    if (kind === 'mbrace') return T.assembly_18 || 'Brace';
    return kind;
  }
  /* an outline (CCW, near-duplicate / straight-through points out) in its
     own frame: the longest edge along +x at the bottom, the corner nearest
     the origin first; key = its corners in mm (the smallest of the
     placements of every longest edge), mkey = the mirror image's */
  function _shapeNorm(A) {
    var P = A.map(function (q) { return [q[0], q[1]]; }), i, area = 0;
    for (i = 0; i < P.length; i++) { var a0 = P[i], b0 = P[(i + 1) % P.length]; area += a0[0] * b0[1] - b0[0] * a0[1]; }
    if (area < 0) P.reverse();
    var Q = [];
    for (i = 0; i < P.length; i++) {
      var pr = Q.length ? Q[Q.length - 1] : P[P.length - 1], c = P[i], nx = P[(i + 1) % P.length];
      var l1 = Math.hypot(c[0] - pr[0], c[1] - pr[1]), l2 = Math.hypot(nx[0] - c[0], nx[1] - c[1]);
      if (l1 < 0.0005) continue;
      if (l2 > 1e-9) {
        var cr = (c[0] - pr[0]) * (nx[1] - c[1]) - (c[1] - pr[1]) * (nx[0] - c[0]), dt = (c[0] - pr[0]) * (nx[0] - c[0]) + (c[1] - pr[1]) * (nx[1] - c[1]);
        if (Math.abs(cr) / (l1 * l2) < 0.002 && dt > 0) continue;
      }
      Q.push(c);
    }
    if (Q.length < 3) return null;
    function lens(R) { return R.map(function (q, j) { var r2 = R[(j + 1) % R.length]; return Math.hypot(r2[0] - q[0], r2[1] - q[1]); }); }
    function canon(R) {
      var Ls = lens(R), mx = Math.max.apply(null, Ls), best = null, j, k;
      for (j = 0; j < R.length; j++) {
        if (Ls[j] < mx - 0.0005) continue;
        var a = R[j], b = R[(j + 1) % R.length], th = Math.atan2(b[1] - a[1], b[0] - a[0]), cs = Math.cos(-th), sn = Math.sin(-th);
        var pts = R.map(function (q) { var dx = q[0] - a[0], dy = q[1] - a[1]; return [dx * cs - dy * sn, dx * sn + dy * cs]; });
        var x0 = Math.min.apply(null, pts.map(function (q) { return q[0]; })), y0 = Math.min.apply(null, pts.map(function (q) { return q[1]; }));
        pts = pts.map(function (q) { return [q[0] - x0, q[1] - y0]; });
        var r = pts.map(function (q) { return Math.round(q[0] * 1000) + ',' + Math.round(q[1] * 1000); }), kb = null, kj = 0;
        for (k = 0; k < r.length; k++) { var kk = r.slice(k).concat(r.slice(0, k)).join(';'); if (kb === null || kk < kb) { kb = kk; kj = k; } }
        if (!best || kb < best.key) best = { key: kb, pts: pts.slice(kj).concat(pts.slice(0, kj)) };
      }
      return best;
    }
    var C = canon(Q), M = canon(Q.map(function (q) { return [-q[0], q[1]]; }).reverse());
    var w = Math.max.apply(null, C.pts.map(function (q) { return q[0]; })), h = Math.max.apply(null, C.pts.map(function (q) { return q[1]; }));
    var rect = (C.pts.length === 4) && C.pts.every(function (q) { return (Math.abs(q[0]) < 0.0005 || Math.abs(q[0] - w) < 0.0005) && (Math.abs(q[1]) < 0.0005 || Math.abs(q[1] - h) < 0.0005); });
    return { pts: C.pts, key: C.key, mkey: M.key, shaped: !rect, w: w, h: h };
  }
  function _loftPartSheets(L, kinds, T, nm) {
    var G = [], i;
    (L.pieces || []).forEach(function (pc) {
      if (!pc || !pc.A || !pc.code || kinds.indexOf(pc.kind) < 0) return;
      var A = pc.A, B = pc.B || pc.A, same = (A.length === B.length) && A.every(function (q, j) { return Math.abs(q[0] - B[j][0]) < 0.0005 && Math.abs(q[1] - B[j][1]) < 0.0005; });
      var S = _shapeNorm(A), t = Math.abs(pc.nB - pc.nA), plan = false;
      if ((!S || !S.shaped) && !same) {
        /* a square side but the two faces cut differently: the cut seen across the piece (a mitre in plan) */
        var uA = A.map(function (q) { return q[0]; }), uB = B.map(function (q) { return q[0]; }), vA = A.map(function (q) { return q[1]; });
        S = _shapeNorm([[Math.min.apply(null, uA), pc.nA], [Math.max.apply(null, uA), pc.nA], [Math.max.apply(null, uB), pc.nB], [Math.min.apply(null, uB), pc.nB]]);
        t = Math.max.apply(null, vA) - Math.min.apply(null, vA);
        plan = true;
      }
      if (!S || !S.shaped) return;
      if (pc.fromPoly && t > Math.max(S.w, S.h) + 0.001) return;   /* v350 a flat outline that is the piece's cross-section (a member lying on a slope drawn sheared): the cut list has its length (a lofted piece's -- the gazebo's hub -- stays) */
      var key = pc.kind + '|' + pc.code + '|' + Math.round(t * 1000) + '|' + (plan ? 'p' : 's') + '|';
      for (i = 0; i < G.length; i++) {
        if (G[i].k === key + S.key) { G[i].n++; return; }
        if (G[i].k === key + S.mkey) { G[i].n++; G[i].mir++; return; }
      }
      G.push({ k: key + S.key, kind: pc.kind, code: pc.code, t: t, S: S, n: 1, mir: 0, two: !same && !plan, raw: A, arc: pc.arc || null, blank: pc.blank || null });   /* v350 + the outline as it sits (the arch), its radii, its blank */
    });
    /* rafters of one family (the same cuts, the same depth, only longer or
       shorter -- a hip roof's jacks) on one sheet: the longest drawn, every
       length listed with how many */
    function angSig(Pp) {
      var n2 = Pp.length, a2 = [], j2;
      for (j2 = 0; j2 < n2; j2++) {
        var p0 = Pp[(j2 + n2 - 1) % n2], p1 = Pp[j2], p2 = Pp[(j2 + 1) % n2], e1 = [p1[0] - p0[0], p1[1] - p0[1]], e2 = [p2[0] - p1[0], p2[1] - p1[1]];
        a2.push(Math.round((180 - Math.atan2(e1[0] * e2[1] - e1[1] * e2[0], e1[0] * e2[0] + e1[1] * e2[1]) * 180 / Math.PI) * 2) / 2);
      }
      return a2.sort(function (x, y) { return x - y; }).join(',');
    }
    var F = [];
    G.forEach(function (g) {
      if (['rafter', 'jack', 'frafter'].indexOf(g.kind) < 0) { F.push(g); return; }
      var sg = g.kind + '|' + g.code + '|' + Math.round(g.t * 1000) + '|' + Math.round(g.S.h * 500) + '|' + angSig(g.S.pts);
      for (var q = 0; q < F.length; q++) if (F[q].sg === sg) {
        var f = F[q];
        f.lens.push({ w: g.S.w, n: g.n });
        if (g.S.w > f.S.w) f.S = g.S;
        f.n += g.n; f.mir += g.mir;
        return;
      }
      g.sg = sg; g.lens = [{ w: g.S.w, n: g.n }];
      F.push(g);
    });
    G = F;
    G.sort(function (a, b) { return (kinds.indexOf(a.kind) - kinds.indexOf(b.kind)) || (b.S.w - a.S.w); });
    var cnt = {}, per = {};   /* v350 numbered by the label (several kinds share one: Brace, Post, Batten ...) */
    G.forEach(function (g) { var lb = _loftKindLabel(g.kind, T); per[lb] = (per[lb] || 0) + 1; });
    return G.slice(0, 14).map(function (g) {
      var lbl = _loftKindLabel(g.kind, T);
      cnt[lbl] = (cnt[lbl] || 0) + 1;
      var title = lbl + ((per[lbl] > 1) ? (' ' + cnt[lbl]) : '') + ' -- ' + nm(g.code, g.code);
      var note = 't = ' + _partFmt(g.t) + (g.mir ? ('; ' + String(T.pdf_part_mirrored || '{n} mirrored').replace('{n}', String(g.mir))) : '');
      if (g.kind === 'arch' && g.raw) {
        /* v350 an arch segment as it sits in the arch: the box it fills, its two end cuts, the radii, the blank it is cut from */
        var xa = Math.min.apply(null, g.raw.map(function (q) { return q[0]; })), ya = Math.min.apply(null, g.raw.map(function (q) { return q[1]; }));
        var RW = g.raw.map(function (q) { return [q[0] - xa, q[1] - ya]; }), nR = RW.length, jr, arA = 0;
        for (jr = 0; jr < nR; jr++) arA += RW[jr][0] * RW[(jr + 1) % nR][1] - RW[(jr + 1) % nR][0] * RW[jr][1];
        if (arA < 0) RW.reverse();   /* CCW: the dimensions outside */
        if (g.arc) note += '; R ' + _partFmt(g.arc.ri) + ' / ' + _partFmt(g.arc.re);
        if (g.blank) note += '; ' + _partFmt(g.blank.len) + ' x ' + _partFmt(g.blank.w);
        var shA = _partSheetFromPoly(title, g.n, RW, note);
        var turnAt = function (k) {   /* the turn at RW[k], degrees (0 = straight on, an arc's facets turn a few) */
          var p0 = RW[(k - 1 + nR) % nR], p1 = RW[k], p2 = RW[(k + 1) % nR], e1 = [p1[0] - p0[0], p1[1] - p0[1]], e2 = [p2[0] - p1[0], p2[1] - p1[1]];
          return Math.abs(Math.atan2(e1[0] * e2[1] - e1[1] * e2[0], e1[0] * e2[0] + e1[1] * e2[1]) * 180 / Math.PI);
        };
        for (jr = 0; jr < nR; jr++) {
          var a = RW[jr], b = RW[(jr + 1) % nR], el = Math.hypot(b[0] - a[0], b[1] - a[1]);
          /* the end cuts (a corner at both ends) and the long straights (the leg into the post's lap); not an arc's facets */
          if ((turnAt(jr) > 10 && turnAt((jr + 1) % nR) > 10 && el >= 0.015) || el >= 0.10) shA.dims.push({ x0: a[0], y0: a[1], x1: b[0], y1: b[1], text: _partFmt(el), off: -0.035 });
        }
        return shA;
      }
      if (g.lens && g.lens.length > 1) note += '; L = ' + g.lens.sort(function (a, b) { return b.w - a.w; }).map(function (e) { return _partFmt(e.w) + ' x' + e.n; }).join(', ');
      var P = g.S.pts, n = P.length, cx = 0, cy = 0, j;
      var sh = _partSheetFromPoly(title, g.n, P, note);
      P.forEach(function (q) { cx += q[0] / n; cy += q[1] / n; });
      /* v343 a notch's short edges (the birdsmouth: 60 / 35 mm on a 2 m rafter) get no dimension lines of their own -- they crowded into one blot --
         but one "a x b" label above them; no angles at their corners; an overall length equal to an edge's is not dimensioned twice */
      var span = Math.max(g.S.w, g.S.h), EL = [], dupW = false, dupH = false, bw = sh.box.xMax - sh.box.xMin, bh = sh.box.yMax - sh.box.yMin;
      for (j = 0; j < n; j++) EL.push(Math.hypot(P[(j + 1) % n][0] - P[j][0], P[(j + 1) % n][1] - P[j][1]));
      var inAt = function (k) {   /* the inner angle at P[k] (> 180: a notch's inner corner) */
        var p0 = P[(k - 1 + n) % n], p1 = P[(k + n) % n], p2 = P[(k + 1) % n], e1 = [p1[0] - p0[0], p1[1] - p0[1]], e2 = [p2[0] - p1[0], p2[1] - p1[1]];
        return 180 - Math.atan2(e1[0] * e2[1] - e1[1] * e2[0], e1[0] * e2[0] + e1[1] * e2[1]) * 180 / Math.PI;
      };
      var isS = function (k) { k = (k + n) % n; return EL[k] < 0.015 || (EL[k] < 0.07 * span && (inAt(k) > 180.5 || inAt(k + 1) > 180.5)); };
      for (j = 0; j < n; j++) {
        var a = P[j], b = P[(j + 1) % n], c2 = P[(j + 2) % n], el = EL[j];
        if (!isS(j)) {
          sh.dims.push({ x0: a[0], y0: a[1], x1: b[0], y1: b[1], text: _partFmt(el), off: -0.035 });
          if (Math.abs(b[1] - a[1]) < 1e-6 && Math.abs(el - bw) < 0.0005) dupW = true;
          if (Math.abs(b[0] - a[0]) < 1e-6 && Math.abs(el - bh) < 0.0005) dupH = true;
        } else if (!isS(j - 1)) {
          var run = [], k = j;
          while (isS(k) && run.length < n) { if (EL[k % n] >= 0.015) run.push(_partFmt(EL[k % n])); k++; }
          var pS = P[j], pE = P[k % n], pB = P[(j - 1 + n) % n], ux = pS[1] - pB[1], uy = pB[0] - pS[0], ul = Math.hypot(ux, uy) || 1;   /* out of the edge before it (CCW) */
          if (run.length) sh.texts.push({ x: (pS[0] + pE[0]) / 2 + ux / ul * 0.07, y: (pS[1] + pE[1]) / 2 + uy / ul * 0.07, text: run.join(' x '), c: 1 });
        }
        var d1 = [b[0] - a[0], b[1] - a[1]], d2 = [c2[0] - b[0], c2[1] - b[1]];
        var inner = 180 - Math.atan2(d1[0] * d2[1] - d1[1] * d2[0], d1[0] * d2[0] + d1[1] * d2[1]) * 180 / Math.PI;
        if (Math.abs(inner - 90) > 0.6 && Math.abs(inner - 270) > 0.6 && !isS(j) && !isS(j + 1)) {
          var vx = cx - b[0], vy = cy - b[1], vl = Math.hypot(vx, vy) || 1, oo = Math.min(0.05, 0.25 * Math.min(g.S.w, g.S.h) + 0.01);
          sh.texts.push({ x: b[0] + vx / vl * oo, y: b[1] + vy / vl * oo, text: (Math.round(inner * 2) / 2) + '\u00b0' });
        }
      }
      if (dupW || dupH) sh.dims = sh.dims.filter(function (d, i) { return !((i === 0 && dupW) || (i === 1 && dupH)); });
      return sh;
    });
  }
  /* v417 (Marek 2026-11-04 10:58 "Udelat do blueprints samostatny vykres teto konstrukce vcetne kloubu a upinaci patky (kazda na 4
     vruty)"): THE GARDEN POD FITNESS'S BAG GALLOWS, ONE SHOP SHEET -- the welded frame's side elevation at its true scale (the mast,
     the arm, the mitred 45 deg brace, the hook plate with its hole, the hinges' knuckles on the pin's axis; the lengths, the hinges'
     heights, the hook's reach from the pin), and to its right two details at 5:1 -- A the hinge from above (the post dashed, the post
     plate, the strap, the knuckle round its pin, the mast out and (dashed) stowed with the swing between, the screws into the post),
     B the post plate from the front (the details drawn 5 x the elevation's scale, marked (x5)) (its four holes for the 6x80 screws, the strap and the knuckle on it). Everything from the layout's
     own numbers (g.gal), the text's numbers in the unit system (mm / in) */
  function _gallowsSheets(L, T, nm) {
    var G = L && L.gal;
    if (!G || !G.hinges || !G.hinges.length) return null;
    var us = !!G.us, F = _partFmt, GA = G.GA, GB = G.GB, rK = G.rK, Hm = G.Hm, uA1 = G.uA1, Lb = G.Lb, gR = G.gR, c4 = Math.SQRT1_2, gc = GB * c4;
    var hpW = G.hp[0], hpH = G.hp[1], hpT = G.hp[2], hpY = G.hp[3], hpR = G.hp[4], pin = KP.GAL_PIN, kH = G.kH;
    var secA = us ? KP.GAL_SEC_US[0] : KP.GAL_SEC[0], secB = us ? KP.GAL_SEC_US[1] : KP.GAL_SEC[1];
    function rect(x0, y0, x1, y1, dash) { var r = [[x0, y0], [x1, y0], [x1, y1], [x0, y1]]; if (dash) r.dash = dash; return r; }
    function circ(cx, cy, r, n, dash) { var o = [], k; for (k = 0; k < (n || 28); k++) { var a = k / (n || 28) * 2 * Math.PI; o.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]); } if (dash) o.dash = dash; return o; }
    function line(a, b, dash) { var o = [a, b]; o.open = true; if (dash) o.dash = dash; return o; }
    var sh = { title: (T.pdf_part_gallows || 'Heavy bag gallows'), qty: 1, note: '', polylines: [], circles: [], points: [], dims: [], texts: [] };
    var PL = sh.polylines, D = sh.dims, TX = sh.texts;
    /* 1. THE SIDE ELEVATION: u from the pin's axis, y from the mast's foot */
    var uM0 = rK, uM1 = rK + GA, bU0 = uM1, bY0 = Hm - gR;
    PL.push(rect(uM0, 0, uM1, Hm));                                   /* the mast */
    PL.push(rect(uM0, Hm, uA1, Hm + GA));                             /* the arm on it */
    PL.push([[bU0, bY0 - gc], [bU0 + gR + gc, Hm], [bU0 + gR - gc, Hm], [bU0, bY0 + gc]]);   /* the brace, mitred onto both faces */
    PL.push(rect(Lb - hpW / 2, Hm - hpH, Lb + hpW / 2, Hm));          /* the hook plate */
    PL.push(circ(Lb, Hm - hpH + hpY, hpR, 20));
    sh.circles.push({ cx: Lb, cy: Hm - hpH + hpY, r: 0 });
    PL.push(line([0, -0.05], [0, Hm + GA + 0.05], 'axis'));           /* the pin's axis */
    G.hinges.forEach(function (h, i) {
      var y0 = h.y - kH / 2, yS = y0 + kH * 0.45;
      PL.push(rect(-rK, y0, rK, y0 + kH));
      PL.push(line([-rK, yS], [rK, yS]));                             /* the joint: the pin's part under, the mast's sleeve over */
      TX.push({ x: rK + GA + 0.02, y: h.y - 0.012, text: 'A', b: true, fs: 9 });
    });
    /* its dimensions: the hinges' chain and the mast on the left, the arm and the hook's reach over it, the brace's legs */
    var hy = [0].concat(G.hinges.map(function (h) { return h.y; })).concat([Hm]);
    for (var i = 1; i < hy.length; i++) D.push({ x0: uM0, y0: hy[i - 1], x1: uM0, y1: hy[i], text: F(hy[i] - hy[i - 1]), off: uM0 + rK + 0.07 });
    D.push({ x0: uM0, y0: 0, x1: uM0, y1: Hm, text: F(Hm), off: uM0 + rK + 0.17 });
    D.push({ x0: uM0, y0: 0, x1: uM0, y1: Hm + GA, text: F(Hm + GA), off: uM0 + rK + 0.27 });
    D.push({ x0: uM0, y0: Hm + GA, x1: uA1, y1: Hm + GA, text: F(uA1 - uM0), off: 0.11 });
    D.push({ x0: 0, y0: Hm + GA, x1: Lb, y1: Hm + GA, text: F(Lb), off: 0.18 });
    D.push({ x0: uM1, y0: Hm + GA, x1: bU0 + gR + gc, y1: Hm + GA, text: F(gR + gc), off: 0.04 });
    D.push({ x0: uM1, y0: bY0 - gc, x1: uM1, y1: Hm, text: F(gR + gc), off: -(uA1 + 0.07 - uM1) });
    var bL1 = Math.SQRT2 * (gR + gc), bL2 = Math.SQRT2 * (gR - gc);
    TX.push({ x: uM1 + 0.03, y: bY0 - gc - 0.07, text: secB + ', ' + F(bL1) + ' / ' + F(bL2) + ', 45\u00b0 / 45\u00b0' });
    TX.push({ x: uM1 + 0.03, y: Hm * 0.55, text: secA + ' (2x)' });
    TX.push({ x: Lb - hpW / 2, y: Hm - hpH - 0.06, text: F(hpW) + ' x ' + F(hpH) + ' x ' + F(hpT) + ', \u00d8' + F(2 * hpR) });
    TX.push({ x: -0.30, y: Hm + GA + 0.33, text: (T.elevation_side || 'Side elevation'), b: true, fs: 9 });
    /* 2. DETAIL A -- THE HINGE FROM ABOVE, 5:1: p across the post (from its middle), q out of the post's face into the pod */
    var S = 5, ox = uA1 + 0.95, oy = Hm * 0.50;
    function P2(p, q) { return [ox + p * S, oy + q * S]; }
    function rect2(p0, q0, p1, q1, dash) { var r = [P2(p0, q0), P2(p1, q0), P2(p1, q1), P2(p0, q1)]; if (dash) r.dash = dash; return r; }
    var post = G.post, pX = G.pivX, pQ = G.pivOff, pl = G.plate;
    PL.push(rect2(-post / 2, -post, post / 2, 0, 'hid'));            /* the post (context) */
    PL.push(line(P2(0, -post - 0.012), P2(0, 0.02), 'axis'));         /* its middle */
    PL.push(rect2(-pl[0] / 2, 0, pl[0] / 2, pl[2]));                 /* the post plate */
    PL.push(rect2(pX - G.strapW / 2, pl[2], pX + G.strapW / 2, pQ - rK * 0.7));   /* the strap */
    PL.push(circ(ox + pX * S, oy + pQ * S, rK * S, 36));              /* the knuckle */
    PL.push(circ(ox + pX * S, oy + pQ * S, pin * S, 20, 'hid'));      /* its pin */
    sh.circles.push({ cx: ox + pX * S, cy: oy + pQ * S, r: 0 });
    function sq(cp, cq, a, dash) { var ca = Math.cos(a), sa = Math.sin(a), h = GA / 2, o = [[-h, -h], [h, -h], [h, h], [-h, h]].map(function (v) { return P2(cp + v[0] * ca - v[1] * sa, cq + v[0] * sa + v[1] * ca); }); if (dash) o.dash = dash; return o; }
    PL.push(sq(pX + G.dM, pQ, 0));                                     /* the mast out (the arm square to the pod) */
    PL.push(sq(pX + G.dM * Math.cos(G.phS), pQ + G.dM * Math.sin(G.phS), G.phS, 'hid'));   /* stowed */
    var arc = [], k2; for (k2 = 0; k2 <= 24; k2++) { var a2 = G.phS * k2 / 24; arc.push(P2(pX + (G.dM + GA / 2 + 0.012) * Math.cos(a2), pQ + (G.dM + GA / 2 + 0.012) * Math.sin(a2))); }
    arc.open = true; arc.dash = 'hid'; PL.push(arc);
    var aM = G.phS / 2, rT = G.dM + GA / 2 + 0.03;
    TX.push({ x: ox + (pX + rT * Math.cos(aM)) * S, y: oy + (pQ + rT * Math.sin(aM)) * S, text: Math.round(G.phS * 180 / Math.PI) + '\u00b0', c: true });
    var xs = {}; G.hinges[0].scr.forEach(function (q) { xs[Math.round(q[0] * 1000)] = q[0]; });
    Object.keys(xs).forEach(function (kx) { var px = xs[kx]; PL.push(line(P2(px, pl[2]), P2(px, pl[2] - G.scrLen), 'hid')); });   /* the screws into the post */
    D.push({ x0: ox - pl[0] / 2 * S, y0: oy + pl[2] * S, x1: ox + pl[0] / 2 * S, y1: oy + pl[2] * S, text: F(pl[0]), off: -(pl[2] + post + 0.03) * S });
    D.push({ x0: ox + (pX + rK) * S, y0: oy, x1: ox + (pX + rK) * S, y1: oy + pQ * S, text: F(pQ), off: -(G.dM + GA) * S - 0.05 });
    D.push({ x0: ox, y0: oy - post * S, x1: ox + pX * S, y1: oy - post * S, text: F(pX), off: -0.06 });
    TX.push({ x: ox + (pX - rK) * S - 0.05, y: oy + pQ * S - 0.01, text: '\u00d8' + F(2 * rK) + ' x ' + F(kH) + ', \u00d8' + F(2 * pin), r: true });
    TX.push({ x: ox - post / 2 * S, y: oy + (pQ + G.dM + GA) * S + 0.12, text: 'A  ' + (T.pdf_part_hinge || 'Hinge') + ' 2x -- ' + (T.pdfOrthoTop || 'Top view') + '  (x5)', b: true, fs: 9 });
    /* 3. DETAIL B -- THE POST PLATE FROM THE FRONT, 5:1 */
    var oxB = ox + (G.dM + GA + post) * S + 0.75, oyB = oy + 0.25;
    function P3(p, v) { return [oxB + p * S, oyB + v * S]; }
    PL.push([P3(-pl[0] / 2, -pl[1] / 2), P3(pl[0] / 2, -pl[1] / 2), P3(pl[0] / 2, pl[1] / 2), P3(-pl[0] / 2, pl[1] / 2)]);
    var kLoH = kH * 0.45, sV0 = -kH / 2, sV1 = sV0 + 0.045, kn = [P3(pX - rK, -kH / 2), P3(pX + rK, -kH / 2), P3(pX + rK, kH / 2), P3(pX - rK, kH / 2)];
    PL.push(kn);                                                       /* the knuckle in front */
    PL.push(line(P3(pX - rK, -kH / 2 + kLoH), P3(pX + rK, -kH / 2 + kLoH)));
    var stp = [P3(pX - G.strapW / 2, sV0), P3(pX + G.strapW / 2, sV0), P3(pX + G.strapW / 2, sV1), P3(pX - G.strapW / 2, sV1)]; stp.dash = 'hid'; PL.push(stp);   /* the strap behind it */
    var hr = 0.0035;
    G.hinges[0].scr.forEach(function (q) { PL.push(circ(oxB + q[0] * S, oyB + q[1] * S, hr * S, 16)); sh.circles.push({ cx: oxB + q[0] * S, cy: oyB + q[1] * S, r: 0 }); });
    var sc = G.hinges[0].scr.slice().sort(function (a, b) { return (a[0] - b[0]) || (a[1] - b[1]); });
    if (sc.length === 4) {
      D.push({ x0: oxB - pl[0] / 2 * S, y0: oyB - pl[1] / 2 * S, x1: oxB + sc[0][0] * S, y1: oyB - pl[1] / 2 * S, text: F(sc[0][0] + pl[0] / 2), off: -0.06 });
      D.push({ x0: oxB + sc[0][0] * S, y0: oyB - pl[1] / 2 * S, x1: oxB + sc[3][0] * S, y1: oyB - pl[1] / 2 * S, text: F(sc[3][0] - sc[0][0]), off: -0.06 });
      D.push({ x0: oxB + pl[0] / 2 * S, y0: oyB + sc[2][1] * S, x1: oxB + pl[0] / 2 * S, y1: oyB + sc[3][1] * S, text: F(sc[3][1] - sc[2][1]), off: -0.08 });
      D.push({ x0: oxB + pl[0] / 2 * S, y0: oyB + sc[3][1] * S, x1: oxB + pl[0] / 2 * S, y1: oyB + pl[1] / 2 * S, text: F(pl[1] / 2 - sc[3][1]), off: -0.08 });
    }
    D.push({ x0: oxB - pl[0] / 2 * S, y0: oyB - pl[1] / 2 * S, x1: oxB + pl[0] / 2 * S, y1: oyB - pl[1] / 2 * S, text: F(pl[0]), off: -0.16 });
    D.push({ x0: oxB - pl[0] / 2 * S, y0: oyB - pl[1] / 2 * S, x1: oxB - pl[0] / 2 * S, y1: oyB + pl[1] / 2 * S, text: F(pl[1]), off: 0.08 });
    var yTB = oyB - pl[1] / 2 * S - 0.30;   /* under its dimensions (the page is fitted on the lines, not on the texts) */
    TX.push({ x: oxB - pl[0] / 2 * S, y: yTB, text: F(pl[0]) + ' x ' + F(pl[1]) + ' x ' + F(pl[2]) });
    TX.push({ x: oxB - pl[0] / 2 * S, y: yTB - 0.055, text: '4 x \u00d8' + F(2 * hr) + ': ' + nm(G.scrCode, 'screw') + ' x 4' });
    TX.push({ x: oxB - pl[0] / 2 * S - 0.30, y: oyB + pl[1] / 2 * S + 0.08, text: 'B  ' + (T.pdf_part_post_plate || 'Post plate') + ' 2x -- ' + (T.pdfOrthoFront || 'Front view') + '  (x5)', b: true, fs: 9 });
    sh.note = KP.GALLOWS_NAME + '. ' + KP.GHINGE_NAME + ' x 2.';
    var hIso = null; try { hIso = _hingeIsoSheet(G, T, nm); } catch (eHi) { _dbg('[pdf] hinge iso: ' + (eHi && eHi.message)); }   /* v418 the hinge on its own, isometric */
    return hIso ? [sh, hIso] : [sh];
  }
  /* v418 (Marek 2026-11-04 11:24 "Nejsem si tedy jisty tim tvarem / nakresem pantu. Mohl bys tam udelat i izometricky pohled na samostatny
     pant?"): THE HINGE ON ITS OWN, ISOMETRIC -- one hinge as built (left) and pulled apart along its pin (right): the post (dashed), the
     mounting plate with its four holes, the lug welded to it, the lower knuckle with the pin standing up out of it, the sleeve over the
     pin welded to the mast (a stub of the mast drawn). Seen from the front, right and above (the plate's face, the lug's side, the
     tops); every body's faces filled white back to front, so a nearer part hides what is behind it. A few sizes on it. */
  function _hingeIsoSheet(G, T, nm) {
    if (!G || !G.hinges || !G.hinges.length) return null;
    var F = _partFmt, rK = G.rK, kH = G.kH, pin = KP.GAL_PIN, pX = G.pivX, pQ = G.pivOff, pl = G.plate, GA = G.GA, post = G.post;
    var kLo = kH * 0.45, h0 = -kH / 2, hS = h0 + kLo + 0.002, s2 = Math.SQRT2, s6 = Math.sqrt(6);
    var sh = { title: (T.pdf_part_hinge || 'Hinge') + ' 2x -- ' + (T.view_iso || 'Isometric'), qty: 2, note: '', polylines: [], faces: [], circles: [], points: [], dims: [], texts: [] };
    function view(E, ox, oy, S, label) {
      var ext = [1e9, -1e9, 1e9, -1e9];   /* the view's own extents: its caption over it, the plate's note under it */
      function pr(p, h, q) {   /* seen from the front, the LEFT (the knuckle's side, the mast behind it) and above */
        var o = [ox + S * (p + q) / s2, oy + S * (p + 2 * h - q) / s6];
        ext[0] = Math.min(ext[0], o[0]); ext[1] = Math.max(ext[1], o[0]); ext[2] = Math.min(ext[2], o[1]); ext[3] = Math.max(ext[3], o[1]);
        return o;
      }
      var parts = [];
      function box(p0, p1, h0b, h1b, q0, q1, dash) { parts.push({ t: 'box', p0: p0, p1: p1, h0: h0b, h1: h1b, q0: q0, q1: q1, dash: dash }); }
      function cyl(cp, cq, r, h0c, h1c, bore) { parts.push({ t: 'cyl', cp: cp, cq: cq, r: r, h0: h0c, h1: h1c, bore: bore }); }
      /* drawn in this order, far to near (the post behind the plate, the lug into the knuckle, the pin inside the sleeve, the mast in
         front of the sleeve); built that way rather than sorted */
      box(-post / 2, post / 2, -pl[1] / 2 - 0.05, pl[1] / 2 + 0.05, -post * 0.6, 0, true);                    /* the post (a piece of it) */
      box(-pl[0] / 2, pl[0] / 2, -pl[1] / 2, pl[1] / 2, 0, pl[2]);                                              /* the mounting plate */
      box(pX - G.strapW / 2, pX + G.strapW / 2, h0, h0 + 0.045, pl[2], pQ - rK * 0.7);                          /* the lug */
      box(pX + rK, pX + rK + GA, hS + E - 0.015, kH / 2 + E + 0.025, pQ - GA / 2, pQ + GA / 2);                 /* the mast (a stub), behind the knuckle */
      cyl(pX, pQ, rK, h0, h0 + kLo);                                                                             /* the lower knuckle */
      cyl(pX, pQ, pin, h0 + kLo, kH / 2 + 0.010);                                                                /* the pin */
      cyl(pX, pQ, rK, hS + E, kH / 2 + E, pin + 0.0005);                                                         /* the sleeve (its bore on top) */
      if (!E) cyl(pX, pQ, pin, kH / 2, kH / 2 + 0.010);                                                          /* the pin's end over it */
      parts.forEach(function (pt) {
        if (pt.t === 'box') {
          var a = pt;
          [[[a.p0, a.h0, a.q1], [a.p1, a.h0, a.q1], [a.p1, a.h1, a.q1], [a.p0, a.h1, a.q1]],     /* the face to the front (+q) */
           [[a.p0, a.h0, a.q0], [a.p0, a.h0, a.q1], [a.p0, a.h1, a.q1], [a.p0, a.h1, a.q0]],     /* the left side (-p) */
           [[a.p0, a.h1, a.q0], [a.p1, a.h1, a.q0], [a.p1, a.h1, a.q1], [a.p0, a.h1, a.q1]]]     /* the top */
            .forEach(function (fc) { sh.faces.push({ pts: fc.map(function (v) { return pr(v[0], v[1], v[2]); }), dash: !!a.dash }); });
          if (a.q1 === pl[2] && a.p1 === pl[0] / 2) G.hinges[0].scr.forEach(function (sc) {   /* the plate's holes */
            var el = [], k; for (k = 0; k < 20; k++) { var t2 = k / 20 * 2 * Math.PI; el.push(pr(sc[0] + 0.0035 * Math.cos(t2), sc[1] + 0.0035 * Math.sin(t2), pl[2])); }
            sh.faces.push({ pts: el, fill: false, thin: true });
          });
        } else {
          var c = pt, lat = [], top = [], k2, n = 24;
          for (k2 = 0; k2 <= n; k2++) { var t3 = (45 + 180 * k2 / n) * Math.PI / 180; lat.push(pr(c.cp + c.r * Math.cos(t3), c.h0, c.cq + c.r * Math.sin(t3))); }   /* the half toward the eye */
          for (k2 = n; k2 >= 0; k2--) { var t4 = (45 + 180 * k2 / n) * Math.PI / 180; lat.push(pr(c.cp + c.r * Math.cos(t4), c.h1, c.cq + c.r * Math.sin(t4))); }
          for (k2 = 0; k2 < 32; k2++) { var t5 = k2 / 32 * 2 * Math.PI; top.push(pr(c.cp + c.r * Math.cos(t5), c.h1, c.cq + c.r * Math.sin(t5))); }
          sh.faces.push({ pts: lat }); sh.faces.push({ pts: top });
          if (c.bore) { var bo = []; for (k2 = 0; k2 < 24; k2++) { var t6 = k2 / 24 * 2 * Math.PI; bo.push(pr(c.cp + c.bore * Math.cos(t6), c.h1, c.cq + c.bore * Math.sin(t6))); } sh.faces.push({ pts: bo, fill: false, thin: true }); }
        }
      });
      if (E > 0) { var ax = [pr(pX, h0 - 0.02, pQ), pr(pX, kH / 2 + E + 0.08, pQ)]; ax.open = true; ax.dash = 'axis'; sh.polylines.push(ax); }   /* the pin's axis */
      sh.texts.push({ x: ext[0], y: ext[3] + 0.10, text: label, b: true, fs: 9 });
      pr.ext = ext;
      return pr;
    }
    var S = 6, pA = view(0, 0, 0, S, (T.pdf_part_hinge || 'Hinge')), pB = view(0.10, 1.70, 0, S, (T.exploded_view || 'Exploded view'));
    /* the sizes on the exploded one: the plate, how far the pin stands off the plate, the knuckle, the pin, the holes */
    var pa = pB(-pl[0] / 2, -pl[1] / 2, pl[2]), pb = pB(-pl[0] / 2, pl[1] / 2, pl[2]), pc = pB(pl[0] / 2, -pl[1] / 2, pl[2]);
    sh.dims.push({ x0: pa[0], y0: pa[1], x1: pb[0], y1: pb[1], text: F(pl[1]), off: 0.10 });
    var pd = pB(pX, h0, pl[2]), pe = pB(pX, h0, pQ);
    sh.dims.push({ x0: pd[0], y0: pd[1], x1: pe[0], y1: pe[1], text: F(pQ - pl[2]), off: -0.15 });
    var pf = pB(pX, kH / 2 + 0.10, pQ), pg = pB(pX + pin, kH / 2 + 0.010, pQ), ph = pB(pX, h0 + kLo * 0.5, pQ);
    sh.texts.push({ x: pf[0] - rK * S - 0.04, y: pf[1] + 0.02, text: '\u00d8' + F(2 * rK) + ' x ' + F(kH - kLo - 0.002), r: true });   /* the sleeve */
    sh.texts.push({ x: pg[0] + 0.06, y: pg[1] - 0.02, text: '\u00d8' + F(2 * pin) });                                                   /* the pin */
    sh.texts.push({ x: ph[0] + rK * S + 0.05, y: ph[1] - 0.02, text: '\u00d8' + F(2 * rK) + ' x ' + F(kLo) });                       /* the lower knuckle */
    var pj = pB(pX - G.strapW / 2, h0 + 0.045, (pl[2] + pQ - rK * 0.7) / 2);
    sh.texts.push({ x: pj[0] - 0.02, y: pj[1] + 0.15, text: F(G.strapW) + ' x ' + F(0.045) + ' x ' + F(pQ - rK * 0.7 - pl[2]), r: true });   /* the lug */
    var eB = pB.ext;
    sh.texts.push({ x: eB[0], y: eB[3] + 0.035, text: (T.pdf_part_post_plate || 'Mounting plate') + ' ' + F(pl[0]) + ' x ' + F(pl[1]) + ' x ' + F(pl[2]) + ', 4 x \u00d8' + F(0.007) });   /* under the caption */
    sh.note = KP.GHINGE_NAME + '. ' + nm(G.scrCode, 'screw') + ' x 4 / ' + (T.pdf_part_hinge || 'hinge') + '.';
    return sh;
  }
  /* v419 (Marek 11:01: do blueprints musi jit presne okotovany tvar, do
     vsech detailu + QR kod na stazeni dxf) THE TWIST BENCH'S SHEETS: the
     slat -- every edge, the arch, the radii, the hole from the back face
     and the floor, the grain along the column, a QR to its DXF; the
     cutting plan -- a pair interlocked, its strip, the m2 billed and the
     offcut. Lengths in mm / inches to the 1/16. */
  function _rtbLen(m, us) {
    if (!us) return Math.round(m * 1000) + ' mm';
    var x = Math.round(m / 0.0254 * 16), w = Math.floor(x / 16), r = x - w * 16, d = 16;
    while (r && r % 2 === 0) { r /= 2; d /= 2; }
    return (w ? String(w) : '') + (r ? (w ? ' ' : '') + r + '/' + d : (w ? '' : '0')) + ' in';
  }
  function _rtbPartSheets() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, us = (STATE.isMetric === false), br = global.ConfiguratorBudgetBridge || null;
    var nm = function (code, fb) { var it = (br && br.getBoqItem) ? br.getBoqItem(code) : null; return (it && it.name) ? String(it.name).replace(/\s*\u03c0\s*/g, ' ').trim() : (MATERIALS[code] && MATERIALS[code].name) || fb; };
    var G = _rtbSegs(STATE), g = _rtbLayout(STATE), ns = g.nest, h = G.h, S = G.S, B = G.B, bw = G.bw, f = G.f, A = G.A, hr = G.hole.r, k;
    var F = function (m) { return _rtbLen(m, us); };
    var D = function (x0, y0, x1, y1, off) { return { x0: x0, y0: y0, x1: x1, y1: y1, text: F(Math.hypot(x1 - x0, y1 - y0)), off: off }; };
    var rodN = nm(RTB.ROD, 'Steel threaded rod'); if (!/M16|5\/8/.test(rodN)) rodN += us ? ' 5/8 in' : ' M16';   /* v422 the size once */
    var outline = _rtbSegPts(G, 24), holeP = [];
    for (k = 0; k < 40; k++) holeP.push([hr * Math.cos(k / 40 * 2 * Math.PI), h + hr * Math.sin(k / 40 * 2 * Math.PI)]);
    /* the radii, their labels off the outline: the arch's two inside it, the seat's edge above the seat, the top beside the column */
    var LB = { 2: [-h + bw + 0.005, 0.035], 4: [h - f - 0.12, 0.035], 8: [h - 0.13, S + 0.012], 11: [-h + bw + 0.01, B - 0.02] };   /* by the arc's index in segs */
    var circles = [];
    G.segs.forEach(function (q, iq) { if (q.t === 'A') circles.push({ cx: q.c[0], cy: q.c[1], r: q.r, label: 'R ' + F(q.r), lx: LB[iq] ? LB[iq][0] : null, ly: LB[iq] ? LB[iq][1] : null }); });
    circles.push({ cx: 0, cy: h, r: hr, label: '\u00d8 ' + F(2 * hr), lx: 0.004, ly: h + 0.045 });
    var grain = T.bench_rtb_grain || 'Grain', gx = -h + bw / 2, gy0 = S + 0.05, gy1 = B - bw / 2 - 0.04, ah = 0.018;
    var arrow = function (x, y0, y1) { return [{ pts: [[x, y0], [x, y1]] }, { pts: [[x - ah / 2, y1 - ah], [x, y1], [x + ah / 2, y1 - ah]] }, { pts: [[x - ah / 2, y0 + ah], [x, y0], [x + ah / 2, y0 + ah]] }]; };
    var slat = {
      title: T.post_wall_slats || 'Slats', qty: g.N,
      note: nm(RTB.PANEL, 'Edge-glued solid wood panel') + ' ' + F(g.t) + ' \u00b7 ' + (T.op_hole || 'Hole') + ' \u00d8 ' + F(2 * hr) + ' \u00b7 ' + rodN,
      polylines: [outline, holeP], circles: circles, points: [],
      dims: [
        D(-h, 0, -h + bw, 0, -0.05), D(-h + bw, 0, h - f, 0, -0.05), D(h - f, 0, h, 0, -0.05),   /* the feet and the arch */
        D(-h, h, 0, h, 0), D(0, h, h, h, 0),                                                   /* the hole from either face, on its centre line */
        D(-h, 0, h, 0, -0.11),                                                                 /* the depth */
        D(h, 0, h, h, -0.05), D(h, h, h, S, -0.05), D(h, 0, h, S, -0.11),                       /* the hole's height, the seat */
        D(-h, 0, -h, S, 0.05), D(-h, S, -h, B, 0.05), D(-h, 0, -h, B, 0.11),                   /* the back */
        D(-h, B, -h + bw, B, 0.05), D(-h + bw, S, h, S, 0.05),                                 /* the column, the seat's depth */
        D(0.06, 0, 0.06, A, 0)                                                                 /* the arch's height */
      ],
      texts: [{ x: gx + bw / 2 + 0.015, y: (gy0 + gy1) / 2, text: grain }], dimAbove: true,
      thin: [
        { pts: [[h, h], [h + 0.03, h]], dash: true }, { pts: [[0, h - 0.04], [0, h + 0.04]], dash: true }   /* the hole's centre lines (across: the dimension line) */
      ].concat(arrow(gx, gy0, gy1)),
      qr: _rtbDxfLink ? { url: _rtbDxfLink, tag: T.bench_rtb_dxf || 'DXF for download', sub: us ? 'in' : 'mm' } : null   /* v421 the stored link only (exportPdf made it) */
    };
    /* v422 the end cheek: the quarter disc, its edges, the radius, the hole from the back and the floor */
    var CK = _rtbCheek(STATE), R = CK.R, cOut = _rtbSegPts(CK, 48), q45 = Math.SQRT1_2;
    var ckSheet = {
      title: T.bench_wave_rib || 'Side panel', qty: 2,
      note: nm(RTB.PANEL, 'Edge-glued solid wood panel') + ' ' + F(g.t) + ' \u00b7 R ' + F(R) + ' \u00b7 ' + (T.op_hole || 'Hole') + ' \u00d8 ' + F(2 * hr) + ' \u00b7 ' + rodN,
      polylines: [cOut, holeP], points: [],
      circles: [{ cx: 0, cy: h, r: hr, label: '\u00d8 ' + F(2 * hr), lx: 0.004, ly: h + 0.045 }],
      dims: [
        D(-h, 0, h, 0, -0.06),                       /* the floor edge = the slat's depth */
        D(-h, 0, -h, R, 0.06),                       /* the back edge */
        D(-h, h, 0, h, 0), D(0, 0, 0, h, 0)          /* the hole from the back, from the floor (on its centre lines) */
      ],
      texts: [
        { x: -h + R * q45 * 0.3 + 0.015, y: R * q45 * 0.3 - 0.035, text: 'R ' + F(R) },
        { x: -h + 0.065, y: 0.45, text: grain }
      ], dimAbove: true,
      thin: [
        { pts: [[-h, 0], [-h + R * q45, R * q45]] },                                        /* the radius from its centre (the back's foot) */
        { pts: [[0, h], [0.04, h]], dash: true }, { pts: [[-0.04, h], [0, h]], dash: true }, { pts: [[0, h], [0, h + 0.04]], dash: true }
      ].concat(arrow(-h + 0.05, 0.36, 0.54)),
      qr: _rtbDxfLink ? { url: _rtbDxfLink, tag: T.bench_rtb_dxf || 'DXF for download', sub: us ? 'in' : 'mm' } : null
    };
    /* the cutting plan: a pair, the first at the strip's corner, the second turned 180 deg about the pair's middle */
    var kk = ns.k, pw = ns.pw, ph = ns.ph, L1 = outline.map(function (q) { return [q[0] + h + kk / 2, q[1] + kk / 2]; });
    var H1 = holeP.map(function (q) { return [q[0] + h + kk / 2, q[1] + kk / 2]; });
    var rot = function (q) { return [pw - q[0], ph - q[1]]; };
    var area = us ? (ns.m2 / 0.09290304).toFixed(1) + ' ft2' : ns.m2.toFixed(2) + ' m2';   /* the catalogue's own units */
    var stripL = us ? (ns.stripL / 0.3048).toFixed(1) + ' ft' : ns.stripL.toFixed(2) + ' m';
    /* v422 the two cheeks' block beside the pair: one upright in its corner, the other turned 180 deg */
    var X0 = pw + 0.24, cL = ns.cL, C1 = cOut.map(function (q) { return [q[0] + h + kk / 2 + X0, q[1] + kk / 2]; });
    var CH1 = holeP.map(function (q) { return [q[0] + h + kk / 2 + X0, q[1] + kk / 2]; });
    var rotC = function (q) { return [2 * X0 + pw - q[0], cL - q[1]]; };
    var sideN = T.bench_wave_rib || 'Side panel';
    var plan = {
      title: T.bench_rtb_nest || 'Cutting plan', qty: 0,
      note: nm(RTB.PANEL, 'Edge-glued solid wood panel') + ' ' + F(g.t) + ': ' + ns.pairs + ' \u00d7 ' + F(pw) + ' \u00d7 ' + F(ph) +
            (ns.single ? ' + 1 \u00d7 ' + F(pw) + ' \u00d7 ' + F(B + kk) : '') + ' + ' + F(pw) + ' \u00d7 ' + F(cL) + ' (' + sideN + ' \u00d7 2)' +
            ' = ' + F(pw) + ' \u00d7 ' + stripL + ' = ' + area +
            ' \u00b7 ' + g.N + ' + 2 ' + (T.pcs || 'pcs') + ' \u00b7 ' + (T.pdf_shopping_offcut || 'offcut') + ' ' + Math.round(ns.off * 100) + ' %',
      polylines: [L1, L1.map(rot), H1, H1.map(rot), C1, C1.map(rotC), CH1, CH1.map(rotC)], circles: [], points: [],
      dims: [{ x0: 0, y0: 0, x1: pw, y1: 0, text: F(pw), off: -0.05 }, { x0: 0, y0: 0, x1: 0, y1: ph, text: F(ph), off: 0.05 },
             { x0: X0, y0: 0, x1: X0 + pw, y1: 0, text: F(pw), off: -0.05 }, { x0: X0 + pw, y0: 0, x1: X0 + pw, y1: cL, text: F(cL), off: -0.05 }],
      texts: [{ x: pw + 0.03, y: ph / 2, text: grain },
              { x: 0.01, y: ph + 0.03, text: (T.post_wall_slats || 'Slats') + ' \u00d7 2' }, { x: X0 + 0.01, y: cL + 0.03, text: sideN + ' \u00d7 2' }], dimAbove: true,
      thin: [{ pts: [[0, 0], [pw, 0], [pw, ph], [0, ph], [0, 0]], dash: true },
             { pts: [[X0, 0], [X0 + pw, 0], [X0 + pw, cL], [X0, cL], [X0, 0]], dash: true }].concat(arrow(pw + 0.015, ph * 0.3, ph * 0.7))
    };
    return [slat, ckSheet, plan];
  }
  function buildPartSheets() {
    if ((STATE.variant | 0) === 54) return _rtbPartSheets();   /* v419 the twist bench */
    if ((STATE.variant | 0) === 3) return _waveRibSheets();   /* v295 */
    if (_LOFT_SHEETS[STATE.variant | 0]) {   /* v343 the pergola / the gazebo */
      var Tl = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, brl = global.ConfiguratorBudgetBridge || null;
      var nml = function (code, fb) {
        var item = (brl && brl.getBoqItem) ? brl.getBoqItem(code) : null;
        return (item && item.name) ? String(item.name).replace(/\s*\u03c0\s*$/, '') : (MATERIALS[code] && MATERIALS[code].name) || fb;
      };
      var Ll = ((STATE.variant | 0) === 24) ? _peLayout(STATE) : _gzLayout(STATE);
      return _loftPartSheets(Ll, _LOFT_SHEETS[STATE.variant | 0], Tl, nml);
    }
    if (_POLY_SHEETS[STATE.variant | 0]) {   /* v350 the cinema bar / the raised bed / the garden arbor */
      var Tq = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, brq = global.ConfiguratorBudgetBridge || null, vq = STATE.variant | 0;
      var nmq = function (code, fb) {
        var item = (brq && brq.getBoqItem) ? brq.getBoqItem(code) : null;
        return (item && item.name) ? String(item.name).replace(/\s*\u03c0\s*$/, '') : (MATERIALS[code] && MATERIALS[code].name) || fb;
      };
      var Lq = _isPhType(vq) ? _phAnyLayout(STATE) : _isGhType(vq) ? _ghLayout(STATE) : _isKpType(vq) ? _kpLayout(STATE) : (vq === 19) ? _gsLayout(STATE) : (vq === 20) ? _rbLayout(STATE) : (vq === 25) ? _mbLayout(STATE) : _gaLayout(STATE);
      var Lpq = _polyAsLoft(Lq);
      if (vq === 43) Lpq.pieces = Lpq.pieces.concat(Lq.pieces.filter(function (pc) { return pc && pc.A && pc.B && pc.code && (pc.kind === 'hip' || pc.kind === 'hjack'); }));   /* v387 the Victorian's hips and jacks (lofts) */
      var outPq = _loftPartSheets(Lpq, _POLY_SHEETS[vq], Tq, nmq);
      if (vq === 53) { try { var gSh = _gallowsSheets(Lq, Tq, nmq); if (gSh) outPq = (outPq || []).concat(gSh); } catch (eGs) { _dbg('[pdf] gallows sheet: ' + (eGs && eGs.message)); } }   /* v417 the bag's gallows */
      return outPq;
    }
    if (!_isStandType(STATE.variant)) return null;
    var fr = ((STATE.variant | 0) === 8);   /* the A-frame swing: the stand + roof sheets, no cheek */
    var g = _standLayout(STATE), P = g.P, T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, sheets = [], i;
    var bridge = global.ConfiguratorBudgetBridge || null;
    function nm(code, fb) {
      var item = (bridge && bridge.getBoqItem) ? bridge.getBoqItem(code) : null;
      return (item && item.name) ? String(item.name).replace(/\s*\u03c0\s*$/, '') : (MATERIALS[code] && MATERIALS[code].name) || fb;
    }
    if (!fr) {
    /* 1. THE CHEEK: outline, the axis, every arc's circle + centre, the
       tangent points, the centre spacings, the band, the caps, the eyes */
    var ck = _swingCheek(g.beta, P.band), H = P.band / 2;
    var outline = ck.outline.map(function (q) { return [q.x, q.y]; });
    var sh = _partSheetFromPoly('Cheek 3.02 (4 x ' + nm(SWING.CHEEK_CODE, '1x4') + ', laminated)', 2, outline,
      (T.bench_rake_label || 'Backrest tilt') + ' ' + Math.round(g.beta) + '\u00b0. ' +
      'R = ' + (STATE.isMetric === false ? 'radius (in)' : 'radius (mm)') + ' of the axis; the edges run ' + _partFmt(H) + ' either side. Circle centres crossed, tangent points marked.');
    var axis = ck.dense.slice().reverse().map(function (q) { return [q.x, q.y]; });   /* toe -> head */
    axis.open = true;
    sh.polylines.push(axis);
    var centres = [];
    for (i = 0; i < ck.elems.length; i++) {
      var e = ck.elems[i];
      sh.points.push({ x: e.x0, y: e.y0, label: 'T' + (i + 1) });
      if (e.R) {
        /* the arc's midpoint, for the radius line of a flat arc */
        var phm = e.phi0 + (e.turn * Math.PI / 180) / 2, sgn = (e.turn > 0) ? 1 : -1;
        sh.circles.push({ cx: e.cx, cy: e.cy, r: e.R, ax: e.cx + sgn * e.R * Math.sin(phm), ay: e.cy - sgn * e.R * Math.cos(phm),
                          label: 'R' + _partFmt(e.R) + ' (' + Math.round(Math.abs(e.turn)) + '\u00b0)' });
        centres.push({ x: e.cx, y: e.cy });
      } else {
        sh.texts.push({ x: (e.x0 + e.x1) / 2, y: (e.y0 + e.y1) / 2 + 0.03, text: _partFmt(e.len) });
      }
      if (i === ck.elems.length - 1) sh.points.push({ x: e.x1, y: e.y1, label: 'T' + (i + 2) });
    }
    /* the centre spacings, consecutive */
    for (i = 1; i < centres.length; i++) {
      var c0 = centres[i - 1], c1 = centres[i];
      sh.dims.push({ x0: c0.x, y0: c0.y, x1: c1.x, y1: c1.y, text: _partFmt(Math.hypot(c1.x - c0.x, c1.y - c0.y)), off: 0.04 });
    }
    /* the caps: R band/2 about the axis ends */
    var a0 = axis[0], a1 = axis[axis.length - 1];
    sh.circles.push({ cx: a0[0], cy: a0[1], r: H, label: 'R' + _partFmt(H) }, { cx: a1[0], cy: a1[1], r: H, label: 'R' + _partFmt(H) });
    /* the band, across the toe end */
    var e0 = ck.elems[0], nx0 = Math.sin(e0.phi0), ny0 = -Math.cos(e0.phi0);
    sh.dims.push({ x0: a0[0] - nx0 * H, y0: a0[1] - ny0 * H, x1: a0[0] + nx0 * H, y1: a0[1] + ny0 * H, text: _partFmt(P.band), off: 0.12 });
    /* the eye bolts */
    sh.points.push({ x: ck.eyeToe.x, y: ck.eyeToe.y, label: nm(SWING.EYE_CODE, 'eye bolt') }, { x: ck.eyeHead.x, y: ck.eyeHead.y, label: nm(SWING.EYE_CODE, 'eye bolt') });
    sh.dims.push({ x0: a0[0], y0: a0[1], x1: ck.eyeToe.x, y1: ck.eyeToe.y, text: _partFmt(Math.hypot(ck.eyeToe.x - a0[0], ck.eyeToe.y - a0[1])), off: 0.16 });
    sh.dims.push({ x0: ck.eyeHead.x, y0: ck.eyeHead.y, x1: a1[0], y1: a1[1], text: _partFmt(Math.hypot(a1[0] - ck.eyeHead.x, a1[1] - ck.eyeHead.y)), off: 0.16 });
    sheets.push(sh);
    }
    /* 2. the roof shapes at this pitch: the bracket 1.02 and the two struts 1.03 */
    var R = g.roof;
    if (R) {
      var br = null;
      for (i = 0; i < R.members.length; i++) if (R.members[i].kind === 'bracket') br = R.members[i];
      if (br && R.frameZ.length > 2) {
        var bs = _partSheetFromPoly(nm(SWING.BRACKET_CODE, 'Bracket') + ' 1.02', R.frameZ.length - 2, br.pts, (T.roof_pitch || 'Roof pitch') + ' ' + Math.round(R.pitch) + '\u00b0');
        bs.dims.push({ x0: -0.05, y0: bs.box.yMin, x1: 0.05, y1: bs.box.yMin, text: _partFmt(0.10), off: -0.16 });   /* the notch over the beam */
        sheets.push(bs);
      }
      if (R.endBr.length) {
        var e1 = R.endBr[0], e2 = null;
        for (i = 1; i < R.endBr.length; i++) if (R.endBr[i].sx !== e1.sx) { e2 = R.endBr[i]; break; }
        var ss = _partSheetFromPoly(nm(SWING.ENDBR_CODE, 'Strut') + ' 1.03', R.endBr.length, e1.pts, (T.roof_pitch || 'Roof pitch') + ' ' + Math.round(R.pitch) + '\u00b0' + (e2 ? '; the other hand mirrored' : ''));
        sheets.push(ss);
      }
      /* 3. the rafter tail: the end of the rafter with the scroll */
      var raf = null;
      for (i = 0; i < R.members.length; i++) if (R.members[i].kind === 'rafter') { raf = R.members[i]; break; }
      if (raf) {
        var rs = _partSheetFromPoly(nm(SWING.RAFTER_CODE, 'Rafter') + ' 1.01', R.frameZ.length * (R.type === 'gable' ? 2 : 1), raf.pts,
          _partFmt(raf.len) + ' along the top; the tail scroll ' + _partFmt(0.19) + ' from the tip, ' + Math.round(SWING_RAFTER_TAIL[0][1] * 100) + ' % deep at the tip');
        sheets.push(rs);
      }
    }
    /* 4. the beam end: the last 0.35 of the beam, dimensioned */
    var bl2 = g.beamLen / 2, bpts = [[bl2 - 0.35, g.beamBot + P.beamH], [bl2, g.beamBot + P.beamH]], be;
    for (i = 0; i < SWING_BEAM_END.length; i++) { be = SWING_BEAM_END[i]; bpts.push([bl2 - be[0], g.beamBot + P.beamH * be[1]]); }
    bpts.push([bl2 - 0.35, g.beamBot]);
    var bms = _partSheetFromPoly(nm(SWING.BEAM_CODE, 'Beam') + ' 2.01 (end)', 2, bpts, 'both ends; ' + _partFmt(g.beamLen) + ' overall');
    bms.dims = [{ x0: bl2 - 0.205, y0: g.beamBot, x1: bl2, y1: g.beamBot, text: _partFmt(0.205), off: -0.06 },
                { x0: bl2, y0: g.beamBot + P.beamH * 0.55, x1: bl2, y1: g.beamBot + P.beamH, text: _partFmt(P.beamH * 0.45), off: -0.06 },
                { x0: bl2 - 0.098, y0: g.beamBot, x1: bl2 - 0.098, y1: g.beamBot + P.beamH * 0.30, text: _partFmt(P.beamH * 0.30), off: 0.06 },
                { x0: bl2 - 0.35, y0: g.beamBot, x1: bl2 - 0.35, y1: g.beamBot + P.beamH, text: _partFmt(P.beamH), off: 0.06 }];
    sheets.push(bms);
    /* 5. a leg with its joints: the whole piece (the half-lap diamond and the rail pocket are on the other pieces) */
    if (g.legs.length) {
      var lg = g.legs[0], lp = lg.pieces[0].pts;
      var ls = _partSheetFromPoly(nm(SWING.LEG_CODE, 'Leg') + ' 2.02', g.legs.length, lp,
        'stock ' + _partFmt(lg.len) + ', ' + SWING.LEG_ANGLE + '\u00b0; half-lapped at the crossing (' + _partFmt(P.leg / 2) + ' off one face), the rail housed ' + _partFmt(0.045) + ' deep at ' + _partFmt(SWING.RAIL_Y) + '; the top cut on the roof deck');
      ls.polylines.push(lg.pieces[1].pts, lg.pieces[2].pts);
      ls.dims.push({ x0: lp[0][0], y0: 0, x1: lp[0][0], y1: SWING.RAIL_Y, text: _partFmt(SWING.RAIL_Y), off: 0.10 });
      sheets.push(ls);
    }
    return sheets;
  }

  /* THE PART SHEET DRAWING (the exporter gives the page + header, this draws):
       P = { title, qty, note, polylines: [[[x,y],...]] (closed; .open = true for an open one),
             circles: [{cx,cy,r,ax,ay,label}] (whole under R 600, else a radius line to ax,ay),
             points: [{x,y,label}], dims: [{x0,y0,x1,y1,text,off}], texts: [{x,y,text}] } in metres, y up */
  function _drawPartSheet(doc, XP, ctx, P) {
    if (!P || ((!P.polylines || !P.polylines.length) && (!P.faces || !P.faces.length))) return;   /* v418 or an isometric's faces only */
    P.polylines = P.polylines || [];
    const W = XP.L_PAGE_W, H = XP.L_PAGE_H, M = XP.L_MARGIN;
    const TOP = 36, BOT = H - 24;
    /* extents over everything drawn (dims included, with their offsets) */
    let xMin = 1e9, xMax = -1e9, yMin = 1e9, yMax = -1e9;
    const grow = (x, y) => { if (!isFinite(x) || !isFinite(y)) return; xMin = Math.min(xMin, x); xMax = Math.max(xMax, x); yMin = Math.min(yMin, y); yMax = Math.max(yMax, y); };
    P.polylines.forEach((pl) => pl.forEach((q) => grow(q[0], q[1])));
    (P.faces || []).forEach((f) => f.pts.forEach((q) => grow(q[0], q[1])));   /* v418 an isometric's faces */
    /* a small circle is drawn whole; a big one (a flat arc) only as its centre
       and a radius line to the arc, so the page is sized on the piece */
    (P.circles || []).forEach((c) => { grow(c.cx, c.cy); if (c.r <= 0.6) { grow(c.cx - c.r, c.cy - c.r); grow(c.cx + c.r, c.cy + c.r); } });
    (P.dims || []).forEach((d) => {
      const dx = d.x1 - d.x0, dy = d.y1 - d.y0, L = Math.hypot(dx, dy) || 1, nx = -dy / L, ny = dx / L, o = (d.off || 0) + (d.off >= 0 ? 0.06 : -0.06);
      grow(d.x0 + nx * o, d.y0 + ny * o); grow(d.x1 + nx * o, d.y1 + ny * o);
    });
    const spanX = Math.max(0.01, xMax - xMin), spanY = Math.max(0.01, yMax - yMin);
    const drawW = W - 2 * M - 10 - (P.qr ? 38 : 0), drawH = BOT - TOP;   /* v419 a QR keeps its column on the right */
    const k = Math.min(drawW / spanX, drawH / spanY);
    const ox = M + 5 + (drawW - spanX * k) / 2, oy = TOP + (drawH + spanY * k) / 2;
    const X = (x) => ox + (x - xMin) * k, Y = (y) => oy - (y - yMin) * k;
    /* the arcs' circles, dashed, with a cross on the centre and the radius */
    doc.setLineWidth(0.25);
    (P.circles || []).forEach((c) => {
      doc.setDrawColor(150, 150, 160);
      try { doc.setLineDashPattern([1.2, 1.0], 0); } catch (e) {}
      if (c.r <= 0.6) doc.circle(X(c.cx), Y(c.cy), c.r * k, 'S');
      else if (isFinite(c.ax) && isFinite(c.ay)) doc.line(X(c.cx), Y(c.cy), X(c.ax), Y(c.ay));
      try { doc.setLineDashPattern([], 0); } catch (e) {}
      doc.setDrawColor(90, 90, 100);
      doc.line(X(c.cx) - 2, Y(c.cy), X(c.cx) + 2, Y(c.cy));
      doc.line(X(c.cx), Y(c.cy) - 2, X(c.cx), Y(c.cy) + 2);
      if (c.label) {
        doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(7); doc.setTextColor(90, 90, 100);
        doc.text(String(c.label), X(c.lx != null ? c.lx : c.cx) + 2.5, Y(c.ly != null ? c.ly : c.cy) - 1.5);   /* v419 lx, ly: the label elsewhere */
      }
    });
    /* v418 THE FACES of an isometric view, in their (back-to-front) order: each filled white over what is behind it and outlined (f.fill
       false: an outline only, e.g. a hole on a face; f.dash: thin, grey, dashed -- a context body), so the hidden edges vanish */
    (P.faces || []).forEach((f) => {
      if (!f.pts || f.pts.length < 2) return;
      if (f.dash) { doc.setDrawColor(120, 120, 130); doc.setLineWidth(0.22); try { doc.setLineDashPattern([1.4, 0.9], 0); } catch (e) {} }
      else { doc.setDrawColor(40, 30, 20); doc.setLineWidth(f.thin ? 0.3 : 0.45); }
      const pts = f.pts.map((q) => [X(q[0]), Y(q[1])]), rel = [];
      for (let i = 1; i < pts.length; i++) rel.push([pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]]);
      if (f.fill !== false) doc.setFillColor(255, 255, 255);
      doc.lines(rel, pts[0][0], pts[0][1], [1, 1], (f.fill !== false) ? 'FD' : 'S', !f.open);
      if (f.dash) { try { doc.setLineDashPattern([], 0); } catch (e) {} }
    });
    /* the outline(s) (v417 pl.dash: a hidden / context line, thin and dashed -- the post behind a hinge, a pin's axis, a screw) */
    P.polylines.forEach((pl) => {
      if (pl.dash) { doc.setDrawColor(120, 120, 130); doc.setLineWidth(0.22); try { doc.setLineDashPattern(pl.dash === 'axis' ? [3, 0.8, 0.6, 0.8] : [1.4, 0.9], 0); } catch (e) {} }
      else { doc.setDrawColor(40, 30, 20); doc.setLineWidth(0.5); }
      for (let i = 0; i < pl.length; i++) {
        const a = pl[i], b = pl[(i + 1) % pl.length];
        if (i === pl.length - 1 && pl.open) break;
        doc.line(X(a[0]), Y(a[1]), X(b[0]), Y(b[1]));
      }
      if (pl.dash) { try { doc.setLineDashPattern([], 0); } catch (e) {} }
    });
    /* v419 thin lines: centre lines (dash-dot), arrows */
    (P.thin || []).forEach((tl) => {
      doc.setDrawColor(110, 110, 120); doc.setLineWidth(0.2);
      try { doc.setLineDashPattern(tl.dash ? [3, 1, 0.6, 1] : [], 0); } catch (e) {}
      for (let i = 0; i + 1 < tl.pts.length; i++) doc.line(X(tl.pts[i][0]), Y(tl.pts[i][1]), X(tl.pts[i + 1][0]), Y(tl.pts[i + 1][1]));
      try { doc.setLineDashPattern([], 0); } catch (e) {}
    });
    /* marked points */
    (P.points || []).forEach((p) => {
      doc.setFillColor(200, 120, 40);
      doc.circle(X(p.x), Y(p.y), 0.9, 'F');
      if (p.label) {
        doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(6.5); doc.setTextColor(140, 80, 20);
        doc.text(String(p.label), X(p.x) + 1.5, Y(p.y) + 2.5);
      }
    });
    /* the dimensions: a line offset off the piece, ticks at the ends, the text
       on it, extension lines back to the measured points */
    (P.dims || []).forEach((d) => {
      const dx = d.x1 - d.x0, dy = d.y1 - d.y0, L = Math.hypot(dx, dy) || 1;
      const nx = -dy / L, ny = dx / L, o = d.off || 0;
      const ax = d.x0 + nx * o, ay = d.y0 + ny * o, bx = d.x1 + nx * o, by = d.y1 + ny * o;
      doc.setDrawColor(70, 70, 80); doc.setLineWidth(0.25);
      doc.line(X(d.x0), Y(d.y0), X(ax + nx * 0.02 * Math.sign(o || 1)), Y(ay + ny * 0.02 * Math.sign(o || 1)));
      doc.line(X(d.x1), Y(d.y1), X(bx + nx * 0.02 * Math.sign(o || 1)), Y(by + ny * 0.02 * Math.sign(o || 1)));
      doc.line(X(ax), Y(ay), X(bx), Y(by));
      const tx = (nx * 0.7 + dx / L * 0.7), ty = (ny * 0.7 + dy / L * 0.7);   /* 45 deg ticks */
      [[ax, ay], [bx, by]].forEach((e) => { doc.line(X(e[0]) - tx, Y(e[1]) + ty, X(e[0]) + tx, Y(e[1]) - ty); });
      const mx = X((ax + bx) / 2), my = Y((ay + by) / 2);
      let ang = Math.atan2(-(Y(by) - Y(ay)), X(bx) - X(ax)) * 180 / Math.PI;
      if (ang > 90 || ang < -90) ang += 180;
      doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(7.5); doc.setTextColor(30, 26, 22);
      const tw = doc.getTextWidth(String(d.text || ''));
      const ca = Math.cos(ang * Math.PI / 180), sa = Math.sin(ang * Math.PI / 180);
      const tg = P.dimAbove ? -0.9 : 1.0;   /* v419 dimAbove: the number clear above its line */
      doc.text(String(d.text || ''), mx - ca * tw / 2 + sa * tg, my + sa * tw / 2 + ca * tg, { angle: ang });
    });
    (P.texts || []).forEach((t) => {
      doc.setFont(ctx.fontFamily, t.b ? 'bold' : 'normal'); doc.setFontSize(t.fs || 7.5); doc.setTextColor(30, 26, 22);   /* v417 t.b bold, t.fs a size (a view's caption) */
      doc.text(String(t.text || ''), X(t.x) - (t.c ? doc.getTextWidth(String(t.text || '')) / 2 : t.r ? doc.getTextWidth(String(t.text || '')) : 0), Y(t.y) + (t.c ? 1.0 : 0));   /* v343 c: centred (v417 r: ending at x) */
    });
    if (P.note) {
      doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(8); doc.setTextColor(120, 110, 100);
      const lines = doc.splitTextToSize(String(P.note), W - 2 * M);
      doc.text(lines.slice(0, 3), M, BOT + 5);
    }
    /* v419 a QR in the top right corner (the share module's generator, else the qrcode lib), its caption under it */
    if (P.qr && P.qr.url) {
      let dark = null, n = 0;
      try {
        const SQ = global.ConfiguratorShare && global.ConfiguratorShare._qr;
        if (SQ && SQ.build) { const q = SQ.build(String(P.qr.url)); n = q.moduleCount; dark = (r, c) => q.isDark(r, c); }
        else if (global.QRCode && global.QRCode.create) { const q2 = global.QRCode.create(String(P.qr.url), { errorCorrectionLevel: 'M' }); n = q2.modules.size; dark = (r, c) => !!q2.modules.data[r * n + c]; }
      } catch (eQ) { dark = null; }
      if (dark && n > 0) {
        const sz = 30, cell = sz / n, qx = W - M - sz, qy = TOP;   /* v421 the sheet's top right corner */
        doc.setFillColor(255, 255, 255); doc.rect(qx - 2, qy - 2, sz + 4, sz + 4, 'F');
        doc.setFillColor(20, 16, 12);
        for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (dark(r, c)) doc.rect(qx + c * cell, qy + r * cell, cell * 1.03, cell * 1.03, 'F');
        if (P.qr.tag) {
          /* v421 the tag: a dark brown pill under the code, the words white (+ the units after it) */
          doc.setFont(ctx.fontFamily, 'bold'); doc.setFontSize(7.5);
          const tw = Math.min(sz + 2, doc.getTextWidth(String(P.qr.tag)) + 5);
          doc.setFillColor(75, 54, 33);
          try { doc.roundedRect(qx + sz - tw, qy + sz + 2.2, tw, 5.2, 2.6, 2.6, 'F'); } catch (eR) { doc.rect(qx + sz - tw, qy + sz + 2.2, tw, 5.2, 'F'); }
          doc.setTextColor(255, 255, 255);
          doc.text(String(P.qr.tag), qx + sz - tw + 2.5, qy + sz + 5.9);
          if (P.qr.sub) { doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(7); doc.setTextColor(120, 110, 100); doc.text(String(P.qr.sub), qx + sz - doc.getTextWidth(String(P.qr.sub)), qy + sz + 11); }
        } else if (P.qr.label) {
          doc.setFont(ctx.fontFamily, 'normal'); doc.setFontSize(7.5); doc.setTextColor(60, 50, 40);
          doc.text(doc.splitTextToSize(String(P.qr.label), sz + 4).slice(0, 3), qx, qy + sz + 5);
        }
      } else if (typeof _dbg === 'function') _dbg('[pdf] part sheet QR: no QR generator on the page');
    }
  }

  async function exportPdf() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    if (!window.ConfiguratorPdfExporter || !window.ConfiguratorPdfExporter.export) {
      alert(T.pdfLibLoading || 'PDF library not yet loaded — try again in a moment.');
      return;
    }
    var BOOT = global.BENCH_BOOT || {};
    var bridge = global.ConfiguratorBudgetBridge || null;
    var btn = document.getElementById('cf-btn-pdf');
    if (btn) btn.classList.add('active');

    /* ── GATE: wait for central BoQ to load ───────────────────
       Without `bridge.isReady()` true, every BoQ row in the PDF
       falls back to the bare ID (e.g. "KVH10060") instead of the
       human name ("KVH 60×100 dimensional lumber"). The bridge
       loads asynchronously from a Google Sheets cloud function, so
       on a cold open the export button can fire before the data
       lands.

       Strategy: poll bridge.isReady() at 100 ms intervals for up to
       5 s. If it's still not ready, show an error and abort — the
       user can retry. If onReady() fires before the timeout we exit
       the poll immediately. */
    if (bridge && typeof bridge.isReady === 'function' && !bridge.isReady()) {
      var waited = 0;
      var pollMs = 100;
      var timeoutMs = 5000;
      while (!bridge.isReady() && waited < timeoutMs) {
        await new Promise(function (res) { setTimeout(res, pollMs); });
        waited += pollMs;
      }
      if (!bridge.isReady()) {
        if (btn) btn.classList.remove('active');
        alert(T.pdfWaitingForData ||
              'Configuration data is still loading. Please wait a moment and try again.');
        return;
      }
    }

    try {
      /* ── 1. SNAPSHOTS ──────────────────────────────────────────
         Way 3 approach: live WebGL renderer has preserveDrawingBuffer
         on, so we can render the scene with a temporary camera and
         then call toDataURL() without touching STATE or applyVizStage.
         The user's working view is preserved end-to-end — no
         flicker. After we're done we re-render the user's view so
         the canvas reflects their original camera again.

         Output: 4 views = 1 iso (game-style 30°/45°) + 3 ortho
         (top / front / side). Each includes the camera frustum so
         the PDF exporter can project rack corners back to image
         coordinates and overlay vector dimension lines on top. */
      var snapshots = await captureForPdf();
      /* v421 the twist bench: the slat's DXF stored, its link on the slat sheet's QR */
      _rtbDxfLink = null;
      if ((STATE.variant | 0) === 54) { try { _rtbDxfLink = await _rtbDxfStore(STATE.isMetric === false); } catch (eDl) { _rtbDxfLink = null; } }

      /* ── 2. INSTANCE PAYLOAD ───────────────────────────────────
         Sent so the PDF exporter can draw dim overlays — it needs
         to know where rack corners and key parts (posts, decking)
         sit in world coordinates to label them correctly. */
      var instances = buildInstancePayload();
      var boqNames  = buildBoqNamesMap(bridge);

      /* ── 3. CUT LIST (lumber only — KVH, KVL, TST) ────────────
         Per Marek: drop roof + fasteners from cut list. They're
         still in the BoQ summary, but the cut list is a workshop
         document for the timber. */
      var cutList = buildCutList(bridge);

      /* ── 4. BoQ ────────────────────────────────────────────────
         Per-material totals from BenchBoQ + user prices. Includes
         fasteners and roof — the cover totals and Bill of Quantities
         table both need them for accurate cost. */
      var boq = buildBoq(bridge);

      /* ── 5. TOTALS for cover ──────────────────────────────────
         Same shape as share modal (materials count + value,
         execution count + value + hours, grand total). */
      var totals = buildTotals(boq);

      /* ── 6. RACK DIMENSIONS for dim overlays ──────────────────
         The PDF exporter draws vector dim lines for the rack's
         outer L/W/H plus post heights (front + back) and decking
         board count — that's the "medium" dim density Marek asked
         for: enough for fabrication, not so many the page is busy. */
      var benchDims = buildBenchDimensions();

      /* ── 7. CALL THE EXPORTER ─────────────────────────────────
         Universal — same call shape for every configurator. */
      window.ConfiguratorPdfExporter.export({
        productTitle: BOOT.productTitle || 'Bench',
        customerName: BOOT.customerName || null,
        coverImage:   BOOT.coverImage   || null,
        shareUrl:     buildShareUrl(),
        totals:       totals,
        /* Snapshots with overlay info — exporter pages 2/3 use these
           instead of legacy view3d / view2d arrays. */
        snapshots:    snapshots,
        benchDims:     benchDims,
        instances:    instances,
        boqNames:     boqNames,
        cutList:      cutList,
        boq:          boq,
        customPages:  (function () {
          try {
            var sh = buildPartSheets() || [];
            return sh.map(function (P) { return { title: (P.title || 'Part') + (P.qty ? ('  x' + P.qty) : ''), draw: function (doc, XP, ctx) { _drawPartSheet(doc, XP, ctx, P); } }; });
          } catch (ePS) { _dbg('[pdf] part sheets: ' + (ePS && ePS.message)); return null; }
        })(),
        meta: {
          locale:        BOOT.locale         || 'en',
          productHandle: BOOT.productHandle  || 'firewood-rack',
          date:          new Date(),
          i18n:          {
            pageIsoTitle:    T.pdfPageIsoTitle    || (T.viz_3d_1 || '3D visualisation'),
            pageOrthosTitle: T.pdfPageOrthosTitle || (T.viz_2d_1 || 'Engineering views'),
            pageCutListTitle:T.pdfPageCutListTitle|| 'Cut list',
            pageBoqTitle:    T.pdfPageBoqTitle    || 'Bill of quantities',
            continued:       T.pdfContinued      || 'continued',
            totalsTitle:     T.pdfTotalsTitle    || 'Project totals',
            materialsLabel:  T.pdfMaterials      || 'Materials',
            executionLabel:  T.pdfExecution      || 'Execution',
            grandTotalLabel: T.pdfGrandTotal     || 'Grand total',
            orthoTop:        T.pdfOrthoTop       || 'Top view',
            orthoFront:      T.pdfOrthoFront     || 'Front view',
            orthoSide:       T.pdfOrthoSide      || 'Side view',
            isoLabel:        T.pdfIsoLabel       || 'Isometric',
            pcs:             T.pcs               || 'pcs',
            postsLabel:      T.pdfPosts          || 'Posts',
            deckingLabel:    T.pdfDecking        || 'Decking',
            noModelData:     T.pdfNoModelData    || 'No model data',
            /* Live-totals widget mirrored from on-page popup.
               Reuses Shopify locale keys budget.* and configurator.* —
               same strings the running configurator already shows. */
            widget: {
              total:        T.widgetTotal    || T.total       || 'Total',
              material:     T.widgetMaterial || T.material    || 'Material',
              execution:    T.widgetExecution|| T.execution   || 'Execution',
              capacity:     T.rackWoodCapacity|| 'Wood capacity',
              capacityNote: T.rackWoodFillNote|| 'at 80% fill'
            },
            cutList: {
              headerPart:   T.pdfCutListPart   || 'Part',
              headerLength: T.pdfCutListLength || 'Length',
              headerQty:    T.pdfCutListQty    || 'Qty',
              /* Legacy keys kept so older PDF exporter versions
                 still render something sensible during deploy
                 transition. */
              headerId:     T.pdfCutListId     || 'ID',
              headerDesc:   T.pdfCutListDesc   || 'Description'
            },
            boq: {
              headerCode:      T.pdfBoqCode      || 'Code',
              headerName:      T.pdfBoqName      || 'Name',
              headerQty:       T.pdfBoqQty       || 'Quantity',
              headerUnitPrice: T.pdfBoqUnitPrice || 'Unit price',
              headerTotal:     T.pdfBoqTotal     || 'Total',
              grandTotal:      T.pdfGrandTotal   || 'Grand total'
            }
          }
        }
      });
    } catch (e) {
      console.error('[exportPdf] failed', e);
      alert((T.pdfFailed || 'PDF export failed') + ': ' + (e && e.message ? e.message : e));
    } finally {
      if (btn) btn.classList.remove('active');
    }
  }

  /* Render the rack scene from 4 dedicated PDF cameras and snapshot
     each. Does NOT touch STATE or applyVizStage — the live canvas
     gets temporarily repurposed (rendered into with custom cameras)
     but no DOM mutations happen, so the user sees at most a brief
     flicker that lasts ~200 ms while we cycle through the 4 views.

     Each snapshot includes the camera params used to render it, so
     the PDF exporter can project world-space rack corners back to
     pixel coordinates to draw dim lines on top.

     ISO uses the same WebGL renderer as the live view (with
     preserveDrawingBuffer: true). ORTHO uses temporary cameras
     fitted to the rack bbox for clean elevation drawings. */
  /* Render the rack scene through Three.js SVGRenderer from 4 fixed
     cameras and serialize each rendered <svg> element to an SVG
     markup string. Pure vector output: small file size, infinite
     zoom sharpness, no canvas / WebGL involvement at all.

     The live WebGL renderer is NOT touched — we instantiate a
     separate SVGRenderer just for the export, run it, dispose of
     its DOM. No flicker, no STATE mutation.

     If SVGRenderer fails to load (window.SVGRenderer not exposed
     from the boot module) we return an empty array — the PDF
     exporter then falls back to its instances-based vector
     reconstruction. */
  var _pdfBBox = null;

  async function captureForPdf() {
    var T = global.THREE;
    var eng = global.BenchEngine;
    if (!eng || !eng.scene) return [];
    if (!global.SVGRenderer) {
      console.warn('[exportPdf] SVGRenderer not loaded — skipping snapshots');
      return [];
    }

    var W = STATE.W, L = STATE.L, H = STATE.H;

    /* Real rendered bounding box. The raked backrest extends ABOVE
       STATE.H, so framing on STATE.H (the rack's approach) clipped the
       top. Measure the actual meshes (same set buildFlatScene draws),
       frame THAT, and report the true extents so the PDF sizes its
       boxes + dim lines to what is really on screen. */
    var bbMin = null, bbMax = null;
    try {
      eng.scene.traverse(function (obj) {
        if (!obj.isMesh || !obj.geometry || !obj.visible) return;
        if (!obj.userData || !obj.userData.partType) return;
        if (obj.userData.partType === 'logs') return;
        obj.updateMatrixWorld(true);
        if (!obj.geometry.boundingBox) obj.geometry.computeBoundingBox();
        var bb = obj.geometry.boundingBox.clone().applyMatrix4(obj.matrixWorld);
        if (!bbMin) { bbMin = bb.min.clone(); bbMax = bb.max.clone(); }
        else { bbMin.min(bb.min); bbMax.max(bb.max); }
      });
    } catch (e) { bbMin = null; }

    var vL, vW, vH, cX, cY, cZ;
    if (bbMin && bbMax) {
      vW = Math.max(0.01, bbMax.x - bbMin.x);   /* depth  (side horizontal)  */
      vH = Math.max(0.01, bbMax.y - bbMin.y);   /* height (vertical)         */
      vL = Math.max(0.01, bbMax.z - bbMin.z);   /* length (front horizontal) */
      cX = (bbMin.x + bbMax.x) / 2;
      cY = (bbMin.y + bbMax.y) / 2;
      cZ = (bbMin.z + bbMax.z) / 2;
    } else {
      vL = L; vW = W; vH = H; cX = 0; cY = H / 2; cZ = 0;
    }
    _pdfBBox = { L: vL, W: vW, H: vH };

    /* Small uniform margin (same on every axis → aspect preserved). */
    var bbMargin = 1.08;
    var bbW = vW * bbMargin;
    var bbH = vH * bbMargin;
    var bbL = vL * bbMargin;

    /* Two ortho captures only (front + side). The 3D iso page was
       dropped from the PDF — full-quality 3D lives on the product
       page (linked from PDF via QR code) and the rasterised
       snapshot was always clipping at edges due to overhangs,
       multi-mesh geometry, and renderer-canvas size mismatches. */
    var captures = [
      {
        /* FRONT VIEW (nárys) in LEVA convention — looking ALONG the
           rack's short axis (X), so we see L × H. Camera sits on
           the +X side. */
        key:   'front',
        label: 'Front view',
        aspect: bbL / bbH,
        /* World dimensions the snapshot encodes — PDF uses these
           for the dynamic-layout sizing (cells proportional to
           world widths). */
        worldW: vL,
        worldH: vH,
        camera: function () {
          var cam = new T.OrthographicCamera(-bbL/2, bbL/2, bbH/2, -bbH/2, 0.1, 200);
          cam.position.set(50, cY, cZ);
          cam.lookAt(cX, cY, cZ);
          cam.updateProjectionMatrix();
          return cam;
        }
      },
      {
        /* SIDE VIEW (bokorys) in LEVA convention — looking ALONG
           the rack's long axis (Z), so we see W × H. Camera sits
           on the +Z side. */
        key:   'side',
        label: 'Side view',
        aspect: bbW / bbH,
        worldW: vW,
        worldH: vH,
        camera: function () {
          var cam = new T.OrthographicCamera(-bbW/2, bbW/2, bbH/2, -bbH/2, 0.1, 200);
          cam.position.set(cX, cY, 50);
          cam.lookAt(cX, cY, cZ);
          cam.updateProjectionMatrix();
          return cam;
        }
      }
    ];

    /* Build a parallel "engineering drawing" scene from the live
       rack scene's meshes. For each mesh we add:
         • A white-filled clone (same geometry, MeshBasicMaterial
           white) — paints over anything behind in the painter's
           order, hiding back-side edges.
         • A black EdgesGeometry overlay (LineSegments) with
           thresholdAngle ~20° so only sharp silhouette + corner
           edges remain. Triangulation noise inside flat panels is
           filtered out.
       Result is a clean technical drawing: front-side outlines on
       white, no fill colours, no fragmented triangle edges. */
    /* Per-capture HLR scenes. ISO uses the original mesh materials
       (colored wood, dark roof) plus black edge overlays — gives a
       readable 3D feel while still drawing crisp outlines. ORTHO
       views use pure white fills + black edges (classic engineering
       drawing where colour would just be noise). */

    /* Shared edge material — thin black lines. */
    var hlrLine = new T.LineBasicMaterial({ color: 0x1a1a1a });
    /* Shared white material for ortho fills. */
    var hlrWhite = new T.MeshBasicMaterial({
      color:    0xffffff,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits:  1
    });

    /* Build the HLR scene used by ortho captures only — iso now
       uses the live WebGL renderer directly with full materials &
       lighting, so we don't need a colored variant any more. */
    function buildFlatScene() {
      var s = new T.Scene();
      s.background = new T.Color(0xffffff);
      eng.scene.traverse(function (obj) {
        if (!obj.isMesh || !obj.geometry || !obj.visible) return;
        if (!obj.userData || !obj.userData.partType) return;
        if (obj.userData.partType === 'logs') return;

        /* White fill — hides back-side geometry via painter's order. */
        var fillMesh = new T.Mesh(obj.geometry, hlrWhite);
        obj.updateMatrixWorld(true);
        fillMesh.matrixAutoUpdate = false;
        fillMesh.matrix.copy(obj.matrixWorld);
        s.add(fillMesh);

        /* Black edge overlay (sharp edges only). */
        try {
          var edges = new T.EdgesGeometry(obj.geometry, 20);
          var lines = new T.LineSegments(edges, hlrLine);
          lines.matrixAutoUpdate = false;
          lines.matrix.copy(obj.matrixWorld);
          s.add(lines);
        } catch (e) {}
      });
      return s;
    }

    var hlrSceneFlat = buildFlatScene();

    /* One SVG renderer, reused per capture. setSize controls the
       viewBox dimensions on its <svg> domElement. */
    var svgRenderer = new global.SVGRenderer();
    svgRenderer.setQuality('high');
    /* Use the SVG element off-DOM — never attached, no layout
       interaction with the live page. */
    var out = [];
    for (var i = 0; i < captures.length; i++) {
      var c = captures[i];
      /* Render each view at a generous logical size — SVG is
         resolution-independent, so this only affects coordinate
         precision, not file size. Keep ratio sensible per camera. */
      /* Render each ortho at A4-page-level resolution. SVG is
         resolution-independent in principle but jsPDF rasterises
         it during embed, so the underlying viewBox size affects
         line crispness at print. 2400 px ≈ 8.4 inches at 280 DPI,
         which prints sharp on A4 landscape. */
      var longEdge = 2400;
      var w, h;
      if (c.aspect >= 1) { w = longEdge; h = Math.round(longEdge / c.aspect); }
      else                { h = longEdge; w = Math.round(longEdge * c.aspect); }

      try {
        /* All captures are ortho line drawings. */
        svgRenderer.setSize(w, h, false);
        var cam = c.camera();
        svgRenderer.render(hlrSceneFlat, cam);

        /* Serialize the rendered <svg> element to a markup string.
           SVGRenderer paints into its own DOM element (svgRenderer.domElement),
           which is a real <svg> we can serialize directly. */
        var svgEl = svgRenderer.domElement;
        var svgMarkup = new XMLSerializer().serializeToString(svgEl);

        /* Ensure xmlns is present — XMLSerializer sometimes drops it
           on documents that were never attached. */
        if (svgMarkup.indexOf('xmlns="http://www.w3.org/2000/svg"') === -1) {
          svgMarkup = svgMarkup.replace('<svg ',
            '<svg xmlns="http://www.w3.org/2000/svg" ');
        }

        /* White fills + black edges line-art post-process. */
        svgMarkup = postProcessSvgToLineArt(svgMarkup, 'flat');

        out.push({
          key:    c.key,
          label:  c.label,
          svg:    svgMarkup,
          width:  w,
          height: h,
          /* Camera matrices for vector dim overlays in the PDF
             (same projection PDF exporter will use). */
          projectionMatrix: Array.from(cam.projectionMatrix.elements),
          viewMatrix:       Array.from(cam.matrixWorldInverse.elements)
        });
      } catch (e) {
        console.warn('[exportPdf] snapshot failed for', c.key, e);
        out.push({ key: c.key, label: c.label, svg: null });
      }
    }

    return out;
  }

  /* Convert SVGRenderer output into a clean technical drawing:
     • Strip all fills (no solid wood colours)
     • Force every path to a thin black stroke
     • Remove any colour-coded inline styles that conflict
     This is purely a string transform — no DOM, no parser. */
  /* Post-process the SVG produced by Three.js SVGRenderer into a
     clean technical drawing:

       • <path style="fill:rgb(255,255,255)..."> — white mesh fills
         from the HLR scene. Keep the white fill (it overpaints
         hidden geometry behind it) but force stroke:none so no
         outline appears around each triangle (those edges come
         from the separate EdgesGeometry layer).

       • <line> / <path> with `stroke:rgb(...)` and no fill — edge
         segments emitted by SVGRenderer for LineSegments objects.
         Force stroke to thin black.

     Goal: triangles inside flat panels disappear into white fills,
     and only the EdgesGeometry-derived sharp edges show through
     as crisp black lines. */
  /* Post-process SVG output from Three.js SVGRenderer into a clean
     drawing. Two modes:

     `mode === 'flat'`  (ortho engineering views):
        – Mesh fills → solid white (overpaints hidden geom behind).
        – Mesh strokes → none (no triangulation outlines).
        – LineSegments → thin black stroke.

     `mode === 'colored'` (iso view):
        – Mesh fills → preserved (original wood / roof colours).
        – Mesh strokes → none.
        – LineSegments → thin black stroke (overlay outlines on top
          of the colored fill).
  */

  function postProcessSvgToLineArt(svg, mode) {
    var coloured = (mode === 'colored');

    if (!coloured) {
      /* Flat / white mode — flatten every mesh fill to white. */
      svg = svg.replace(/fill\s*:\s*rgb\(\s*255\s*,\s*255\s*,\s*255\s*\)/gi, 'fill:#ffffff');
      svg = svg.replace(/fill\s*:\s*rgb\([^)]+\)/g, 'fill:#ffffff');
      svg = svg.replace(/fill="rgb\([^)]+\)"/g, 'fill="#ffffff"');
    }
    /* In colored mode we keep `fill:rgb(...)` as-is. */

    /* For all <path>/<polygon> with a fill, kill stroke so we don't
       outline each individual triangle of a flat panel. The crisp
       outlines come from the separate EdgesGeometry layer. */
    svg = svg.replace(/(<(?:path|polygon)[^>]*?style=")([^"]*)"/g,
      function (m, prefix, style) {
        if (/fill\s*:\s*(?!none)/.test(style)) {
          style = style.replace(/stroke\s*:\s*[^;"]+;?/g, '');
          style = style.replace(/stroke-width\s*:\s*[^;"]+;?/g, '');
          style = style.replace(/stroke-opacity\s*:\s*[^;"]+;?/g, '');
          if (!style.endsWith(';') && style.length) style += ';';
          style += 'stroke:none';
        } else {
          /* No fill → line. Force thin black. */
          style = style.replace(/stroke\s*:\s*[^;"]+/g, 'stroke:#1a1a1a');
          style = style.replace(/stroke-width\s*:\s*[^;"]+/g, 'stroke-width:1');
          if (!/stroke\s*:/.test(style)) {
            if (style.length && !style.endsWith(';')) style += ';';
            style += 'stroke:#1a1a1a;stroke-width:1;fill:none';
          }
        }
        return prefix + style + '"';
      });

    /* Bare <line> elements from LineSegments — thin black. */
    svg = svg.replace(/<line\b([^>]*?)\/>/g, function (m, attrs) {
      attrs = attrs.replace(/\sstroke="[^"]*"/g, '');
      attrs = attrs.replace(/\sstroke-width="[^"]*"/g, '');
      return '<line' + attrs + ' stroke="#1a1a1a" stroke-width="1.2"/>';
    });

    return svg;
  }

  /* Collect dimension annotations the PDF exporter overlays on
     the snapshots. Medium density:
       • Outer L, W, H
       • Post heights (front + back) — useful for fabrication
       • Decking board count
     Values stay in metres internally; the PDF formats with the unit
     system the user chose (STATE.isMetric). */
  function buildBenchDimensions() {
    /* Bench is roofless: the 2D page needs only the overall bounding
       box. flat:true tells the PDF front-view overlay to draw a single
       overall height dim (no front/back post split like the rack). */
    var bb = _pdfBBox;
    return {
      L: bb ? bb.L : STATE.L,
      W: bb ? bb.W : STATE.W,
      H: bb ? bb.H : STATE.H,
      isMetric: STATE.isMetric,
      flat: true
    };
  }

  /* Build the instances payload the PDF exporter needs. We pull the
     real box geometry (width/height/depth) and world-space rotation
     from each tracked mesh, so the PDF renderer can draw oriented
     bounding boxes instead of guessing axis-aligned ones (which
     produced the garbled iso view on Marek's first PDF). */
  function buildInstancePayload() {
    if (!global.BenchInstances || typeof global.BenchInstances.all !== 'function') return [];
    var THREE = global.THREE;
    return global.BenchInstances.all().map(function (inst) {
      var mesh = inst.mesh;
      var dims = null;
      var matrix = null;

      if (mesh && mesh.geometry && mesh.geometry.parameters) {
        var p = mesh.geometry.parameters;
        if (typeof p.width === 'number') {
          /* BoxGeometry case — the rack uses BoxGeometry exclusively. */
          dims = { w: p.width, h: p.height, d: p.depth };
        }
      }

      if (mesh && THREE) {
        /* Ensure world matrix is up to date (parent benchGroup may have
           had transforms applied). */
        try { mesh.updateMatrixWorld(true); } catch (e) {}
        /* Send the world matrix as a 16-float array. The exporter
           reconstructs the orientation by applying it to the 8
           corners of a unit cube scaled by (w, h, d). */
        if (mesh.matrixWorld && mesh.matrixWorld.elements) {
          matrix = Array.from(mesh.matrixWorld.elements);
        }
      }

      var worldPos = inst.position;
      if (mesh && mesh.getWorldPosition && THREE) {
        try {
          var v = new THREE.Vector3();
          mesh.getWorldPosition(v);
          worldPos = { x: v.x, y: v.y, z: v.z };
        } catch (e) {}
      }

      return {
        id:       inst.id,
        partType: inst.partType,
        boqCode:  inst.boqCode,
        length:   inst.length,
        position: worldPos
                  ? { x: worldPos.x, y: worldPos.y, z: worldPos.z }
                  : null,
        /* Real geometry box dims (m). null if mesh isn't a BoxGeometry. */
        dims:     dims,
        /* 4×4 world transform as flat array (column-major, Three.js
           native order). Lets the exporter rotate corners exactly
           the way they sit in the scene. */
        matrix:   matrix
      };
    }).filter(function (i) { return i.position; });
  }

  /* Pre-resolve every BoQ code in the model to a localized name so
     the PDF doesn't need to re-call the bridge per instance. */
  function buildBoqNamesMap(bridge) {
    var map = {};
    if (!global.BenchInstances || typeof global.BenchInstances.all !== 'function') return map;
    var seen = {};
    var missing = [];
    global.BenchInstances.all().forEach(function (inst) {
      if (!inst.boqCode || seen[inst.boqCode]) return;
      seen[inst.boqCode] = true;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(inst.boqCode) : null;
      if (!item || !item.name) {
        /* Track unresolved codes so we can surface them in the
           console — easier than asking the user "why does the PDF
           show KVH10060 instead of '2×4 Lumber'". The export still
           proceeds with the bare code as a fallback, but at least
           Marek sees what's missing in the central BoQ sheet. */
        missing.push(inst.boqCode);
      }
      map[inst.boqCode] = (item && item.name) || inst.boqCode;
    });
    if (missing.length && global.console && global.console.warn) {
      console.warn('[exportPdf] BoQ codes without resolved names (will show as IDs):',
        missing.join(', '));
    }
    return map;
  }

  /* Group all selectable BenchInstances by BoQ code. Within each
     group, AGGREGATE pieces by length: identical-length cuts of the
     same profile collapse to one row with a qty count. A typical
     rack has 8 identical rafters → one "1.17 m × 8 ks" row instead
     of eight separate rows.

     CUT LIST is a workshop document — only lumber profiles belong here.
     Roofing (ROR*) and fasteners (FAS*) are excluded; they still
     appear in the BoQ totals on the last page. */
  /* Nominal cross-sections for each profile family used in the rack.
     Mesh geometries don't reliably expose box dims for tracking, so
     for the visual cut list we hardcode the canonical product
     dimensions. width × thickness in METRES (always). The visual PDF
     page draws each piece as a rectangle whose proportions match
     these dimensions (so a 60×100 KVH chunky piece visually differs
     from a 20×40 KVL batten). */
  var CUT_LIST_PROFILES = {
    'KVH10060':  { width: 0.060, thickness: 0.100, family: 'lumber' },  /* 2x4 */
    'KVH10100':  { width: 0.100, thickness: 0.100, family: 'lumber' },  /* 4x4 */
    'KVH08060':  { width: 0.060, thickness: 0.080, family: 'lumber' },  /* 3x2 kids */
    'KVH08080':  { width: 0.080, thickness: 0.080, family: 'lumber' },  /* 3x3 kids */
    'TIM20100':  { width: 0.100, thickness: 0.020, family: 'lumber' },  /* 1x4 kids plank */
    'KVH16160':  { width: 0.160, thickness: 0.160, family: 'lumber' },  /* 6x6 massive post */
    'KVH03838':  { width: 0.038, thickness: 0.038, family: 'lumber' },  /* 38x38 batten */
    'KVH03030':  { width: 0.030, thickness: 0.030, family: 'lumber' },  /* 30x30 batten */
    /* Picnic set */
    'KVH60120':  { width: 0.120, thickness: 0.060, family: 'lumber' },
    /* Hollywood swing */
    'KVH60200':  { width: 0.200, thickness: 0.060, family: 'lumber' },
    'TIM45120':  { width: 0.120, thickness: 0.045, family: 'lumber' },
    'KVH10200':  { width: 0.200, thickness: 0.100, family: 'lumber' },
    'KVH40060':  { width: 0.060, thickness: 0.040, family: 'lumber' },
    'KVH10080':  { width: 0.100, thickness: 0.080, family: 'lumber' },
    'KVH16080':  { width: 0.160, thickness: 0.080, family: 'lumber' },
    'KVH16040':  { width: 0.160, thickness: 0.040, family: 'lumber' },
    'KVH60160':  { width: 0.160, thickness: 0.060, family: 'lumber' },  /* v303 2x6 (rafters, the bar) */
    'KVH16240':  { width: 0.240, thickness: 0.160, family: 'lumber' },  /* v312 6x10 (the cinema bar's ridge) */
    'KVL20040':  { width: 0.040, thickness: 0.020, family: 'lumber' }   /* v314 1x2 batten (the cold frame) */
  };

  /* Metric→imperial dimension tokens per timber code. When the BoQ name
     carries the metric cross-section and units are imperial, swap it for
     the imperial size so the cut list never shows mm on an imperial doc.
     Pure ASCII ("in.") — jsPDF base fonts render the ″ prime as "?". */
  var CUT_LIST_DIM = {
    'KVH10060': { metric: '60 × 100',  imperial: '2 in. x 4 in.' },
    'KVH10100': { metric: '100 × 100', imperial: '4 in. x 4 in.' },
    'KVH08060': { metric: '60 × 80',   imperial: '3 in. x 2 in.' },
    'KVH08080': { metric: '80 × 80',   imperial: '3 in. x 3 in.' },
    'TIM20100': { metric: '20 × 100',  imperial: '1 in. x 4 in.' },
    'KVH16160': { metric: '160 × 160', imperial: '6 in. x 6 in.' },
    'KVH03838': { metric: '38 × 38',   imperial: '1 1/2 in. x 1 1/2 in.' },
    'KVH03030': { metric: '30 × 30',   imperial: '1 1/4 in. x 1 1/4 in.' },
    'KVH10160': { metric: '100 x 160', imperial: '4 in. x 6 in.' },
    'KVH60120': { metric: '60 x 120',  imperial: '2 in. x 6 in.' },
    'KVH60200': { metric: '60 x 200',  imperial: '2 in. x 8 in.' },
    'TIM45120': { metric: '45 x 120',  imperial: '2 in. x 6 in.' },
    'KVH10200': { metric: '100 x 200', imperial: '4 in. x 8 in.' },
    'KVH40060': { metric: '40 x 60',   imperial: '2 in. x 3 in.' },
    'KVH10080': { metric: '100 x 80',  imperial: '2 in. x 4 in.' },
    'KVH16080': { metric: '160 x 80',  imperial: '2 in. x 6 in.' },
    'KVH16040': { metric: '160 x 40',  imperial: '2 in. x 6 in.' },
    'KVH60160': { metric: '60 x 160',  imperial: '2 in. x 6 in.' },  /* v303 */
    'KVH16240': { metric: '160 x 240', imperial: '6 in. x 10 in.' },  /* v312 */
    'KVL20040': { metric: '20 x 40', imperial: '1 in. x 2 in.' }   /* v314 */
  };

  function _swapDimToken(name, metricDim, imperialDim) {
    if (!name) return name;
    var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var core = String(metricDim).replace(/\s*(mm|cm|m)\s*$/i, '').trim();
    var pat = esc(core).replace(/[×x]/gi, '[×x]').replace(/\s+/g, '\\s*');
    var re = new RegExp(pat + '(\\s*(?:mm|cm|m))?', 'i');
    if (re.test(name)) {
      /* Name carries the metric size (e.g. "60 × 100") — swap it in place. */
      return name.replace(re, imperialDim).replace(/\s+/g, ' ').trim();
    }
    /* Name already carries its own size (e.g. "2In. x 4In.") — leave it as
       is. Appending imperialDim here duplicated the dimension in the header. */
    return name;
  }

  function _cutListProfileName(code, rawName) {
    var name = rawName || code;
    var dm = CUT_LIST_DIM[code];
    if (!STATE.isMetric && dm) name = _swapDimToken(name, dm.metric, dm.imperial);
    return name;
  }

  function buildCutList(bridge) {
    if (!global.BenchInstances || typeof global.BenchInstances.all !== 'function') return [];
    var all = global.BenchInstances.all() || [];
    var groups = {};
    var order  = [];

    function ensureGroup(code) {
      if (groups[code]) return groups[code];
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      var prof = CUT_LIST_PROFILES[code] || {};
      groups[code] = {
        profile:       _cutListProfileName(code, item && item.name),
        profileCode:   code,
        unit:          STATE.isMetric ? 'm' : 'ft',
        profileWidth:  prof.width || null,        /* metres, narrow dim */
        profileHeight: prof.thickness || null,    /* metres, deep dim   */
        family:        prof.family || 'lumber',   /* lumber | decking | roof */
        pieces:      [],
        _byLen:      {}
      };
      order.push(code);
      return groups[code];
    }

    /* Aggregate every lumber instance by rounded length. Screws /
       fasteners (FAS*) are excluded — they aren't cut to length. */
    /* Hollywood swing: the cheeks are cut from stacked 60x200 blanks, so
       the cut list carries the blanks (3.02A/B/C), not the S shape. */
    var swingCheekDone = false, pclFilletDone = false, pclSlatDone = false;
    all.forEach(function (inst) {
      if (!inst || !inst.boqCode) return;
      if (/^FAS/i.test(inst.boqCode)) return;
      if (/screw|fastener|nail/i.test(inst.partType || '')) return;
      if (_isStagedType(STATE.variant) || (STATE.variant | 0) === 7 || (STATE.variant | 0) === 14) {   /* v269: the sofa-style porch swing too (its hanging hardware); v273 the bed (its mattress) */
        if (/^(FAT|FOU|FMC|EEC|FFM|FCO|FEE|SFF|FEC|OEB|ODD|PFG|FMA|EES|EEL|EEJ|EEE|FGR|OSB|FCP|ROM)/i.test(inst.boqCode) || inst.boqCode === 'ROR00001') return;   /* hardware, mattress, shingles: nothing to cut; v303 + the screen, projector, stools, lights, DPC, footings; v309 + the worktop, the adhesive */
        if (inst.partType === 'pcl-backslat' && _pclFill(STATE) === 'slats') {
          /* v281 the back slats ripped two from a 1x4: the boards to cut */
          if (pclSlatDone) return;
          pclSlatDone = true;
          var gS2 = ensureGroup(inst.boqCode), pg2 = _porchClassicLayout(STATE), sl = pg2.pieces.filter(function (pp) { return pp.kind === 'backslat'; });
          var bl = sl.length ? sl[0].box[4] : 0;
          gS2.pieces.push({ length: STATE.isMetric ? bl : bl * 3.281, width: null, qty: Math.ceil(sl.length / 2), label: 'pcl-backslat', angle: 0 });
          return;
        }
        if (/^pcl-fillet/.test(inst.partType || '')) {
          /* v279 the classic porch swing's groove fillets: ONE piece of 1x4
             as long as the board they take, ripped into strips, then cut
             to the gap -- not a row of tiny pieces */
          if (pclFilletDone) return;
          pclFilletDone = true;
          var gF = ensureGroup(inst.boqCode), pg = _porchClassicLayout(STATE), fm = pg.fillBoardM;
          gF.pieces.push({ length: STATE.isMetric ? fm : fm * 3.281, width: null, qty: 1, label: 'pcl-fillet', angle: 0 });
          return;
        }
        if (inst.partType === 'swing-rib') {
          if (swingCheekDone) return;
          swingCheekDone = true;
          var gC = ensureGroup(inst.boqCode), sg = _swingLayout(STATE), si;
          /* v264: the laminated cheek -- board metres a layer (segments cut
             to the outline, joints staggered layer to layer) */
          var perLayer = sg.cheekArea / sg.P.boardW * SWING.CHEEK_WASTE;
          var lbls = ['cheek layer L1 (with the groove)', 'cheek layer L2', 'cheek layer L3', 'cheek layer L4 (cover)'];
          for (si = 0; si < lbls.length; si++) gC.pieces.push({ length: STATE.isMetric ? perLayer : perLayer * 3.281, width: null, qty: 2, label: lbls[si], angle: 0 });
          if (sg.midSup) {
            var perSup = sg.supArea / sg.P.boardW * SWING.CHEEK_WASTE;
            gC.pieces.push({ length: STATE.isMetric ? perSup : perSup * 3.281, width: null, qty: SWING.SUP_LAYERS, label: 'middle support layer', angle: 0 });
          }
          return;
        }
        if (typeof inst.length !== 'number' || inst.length <= 0) return;
      }

      var g = ensureGroup(inst.boqCode);
      var lenMetric = (typeof inst.length === 'number') ? inst.length : 0;
      var lenDisplay = STATE.isMetric ? lenMetric : (lenMetric * 3.281);
      /* Mitered backrest members (raked frame) carry a bottom-cut angle.
         They must NOT merge with SQUARE pieces of the same length, or the
         row would be mislabelled and lose its angle — so the bucket key
         includes the angled flag (and width, for decking, is per-group). */
      var isAngled = ((inst.partType === 'post-backrest' || inst.partType === 'stretcher-backrest') && (STATE.backRakeDeg || 0) > 0);
      var roundLen = Math.round(lenDisplay * 100) / 100;
      var roundKey = roundLen + (isAngled ? '|a' : '|s');
      var bucket = g._byLen[roundKey];
      if (!bucket) {
        bucket = {
          length: lenDisplay,
          width:  null,
          qty:    0,
          label:  inst.partType || '',
          angle:  isAngled ? Math.round(STATE.backRakeDeg) : 0
        };
        g._byLen[roundKey] = bucket;
        g.pieces.push(bucket);
      }
      bucket.qty += 1;
    });

    /* For DECKING: collapse all rows into one. Decking boards are all
       the same length (W - 2*tw) and we want "1 outline × N pcs"
       on the visual page per Marek's spec. Same applies if future
       roof products end up with multi-length cuts. */
    order.forEach(function (k) {
      var g = groups[k];
      if (g.family === 'decking' && g.pieces.length > 1) {
        var totalQty = 0;
        var longest  = 0;
        g.pieces.forEach(function (p) {
          totalQty += (p.qty || 1);
          if (p.length > longest) longest = p.length;
        });
        g.pieces = [{
          length: longest,
          width:  STATE.isMetric ? g.profileWidth : g.profileWidth * 3.281,
          qty:    totalQty,
          label:  'decking'
        }];
      } else if (g.family === 'decking' && g.pieces.length === 1) {
        /* Attach board width so visual page can draw the second axis. */
        g.pieces[0].width = STATE.isMetric ? g.profileWidth : g.profileWidth * 3.281;
      }
      /* Give EVERY piece its cross-section width in the SAME display units
         as the lengths (m or ft). Without this, lumber pieces kept width
         null → the PDF fell back to the metres value while lengths were in
         feet, so width×scale was tiny and every bar clamped to the same
         minimum height (4×4 looked identical to a 2×4 / batten). */
      if (g.profileWidth) {
        var wDisp = STATE.isMetric ? g.profileWidth : g.profileWidth * 3.281;
        g.pieces.forEach(function (p) { if (p.width == null) p.width = wDisp; });
      }
      /* Sort pieces by length DESC inside each group. */
      g.pieces.sort(function (a, b) { return b.length - a.length; });
      delete g._byLen;
    });

    return order.map(function (k) { return groups[k]; });
  }

  /* Per-material BoQ totals — exactly what BenchBoQ.compute().byMaterial
     contains, enriched with localized names and pricing from the bridge. */
  function buildBoq(bridge) {
    var b = global.BenchBoQ.compute();
    var out = [];
    Object.keys(b.byMaterial).forEach(function (code) {
      var qty = b.byMaterial[code];
      if (qty == null) return;
      var item = bridge && bridge.getBoqItem ? bridge.getBoqItem(code) : null;
      var localUnit = item ? (STATE.isMetric ? item.unitMetric : item.unitImperial) : null;
      /* Convert qty for display if needed. BenchBoQ.byMaterial holds
         metric values; convert linear/area to imperial when STATE
         says so. PCS stays as-is. */
      var displayQty = qty;
      if (item && !STATE.isMetric) {
        var lbl = String(item.unitMetric || '').trim().toUpperCase();
        if      (lbl === 'M')  displayQty = qty * 3.281;
        else if (lbl === 'M2') displayQty = qty * 10.764;
        else if (lbl === 'M3') displayQty = qty * (String(item.unitImperial || '').trim().toUpperCase() === 'YD3' ? 1.30795 : 35.315);
      }
      var userPrice = bridge && bridge.getUserPrice ? bridge.getUserPrice(code) : null;
      var unitPrice = userPrice && typeof userPrice.price === 'number' ? userPrice.price : null;
      var total = (unitPrice != null) ? unitPrice * displayQty : null;
      out.push({
        code:      code,
        name:      (item && item.name) || code,
        qty:       displayQty,
        unit:      localUnit || (STATE.isMetric ? 'm' : 'ft'),
        unitPrice: unitPrice,
        total:     total
      });
    });
    return out;
  }

  /* Build the totals payload for the PDF cover. Strategy: read the
     exact formatted strings the live on-page budget widget is
     showing right now. Those values come from
     `[data-budget-total-*]` elements (populated by budget.liquid)
     OR fall back to the configurator's numerical globals
     (window.lastMaterialsTotal / lastDeliveryTotal). The PDF
     widget renders these strings verbatim, so what the user sees
     on-page is what they see in the PDF — no parsing, no rounding
     drift, no localisation mismatch.

     Wood capacity is computed locally (same logic as
     cf-bw-capacity refresh in rack-liquid). */
  function buildTotals(boqRows) {
    /* Pre-formatted strings — the cover-page widget consumes these
       directly as Strings, not numbers. */
    function $domText(selector) {
      var el = document.querySelector(selector);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    function $idText(id) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return '';
      var t = el.textContent.trim();
      if (!t || t === '—' || t === '-') return '';
      return t;
    }
    var fmtPrice = (typeof window.formatPrice === 'function')
      ? window.formatPrice
      : function (n) { return Math.round(+n || 0).toLocaleString() + ' ' +
            ((window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'); };

    /* Primary source: live widget cells (same as on-page popup
       Marek wants mirrored). Two possible widget IDs depending on
       which template painted them. */
    var totalText    = $idText('cf-bw-total');
    var materialText = $idText('cf-bw-material');
    var execText     = $idText('cf-bw-execution');
    var timeText     = $idText('cf-bw-time');
    var capacityText = $idText('cf-bw-capacity');

    /* Secondary source: budget.liquid raw output elements. */
    if (!totalText)    totalText    = $domText('[data-budget-total-cost]');
    if (!materialText) materialText = $domText('[data-budget-total-material]');
    if (!execText)     execText     = $domText('[data-budget-total-execution]');
    if (!timeText)     timeText     = $domText('[data-budget-total-time]');

    /* Tertiary source: window globals (incognito / anonymous flow
       where the DOM elements aren't populated). */
    if (!materialText && typeof window.lastMaterialsTotal === 'number') {
      materialText = fmtPrice(window.lastMaterialsTotal);
    }
    if (!execText && typeof window.lastDeliveryTotal === 'number') {
      execText = fmtPrice(window.lastDeliveryTotal);
    }
    if (!totalText) {
      var mNum = (typeof window.lastMaterialsTotal === 'number') ? window.lastMaterialsTotal : 0;
      var eNum = (typeof window.lastDeliveryTotal  === 'number') ? window.lastDeliveryTotal  : 0;
      if (mNum || eNum) totalText = fmtPrice(mNum + eNum);
    }
    if (!timeText && typeof window.lastDurationTotal === 'number') {
      var mins = window.lastDurationTotal;
      timeText = (mins >= 60)
        ? (Math.round(mins / 60 * 10) / 10) + ' h'
        : Math.round(mins) + ' min';
    }

    /* Last-resort: synthesise materials from boqRows we just built
       (PDF always has these even if widget isn't visible yet). */
    if (!materialText) {
      var matSum = 0;
      boqRows.forEach(function (r) { if (r.total != null) matSum += r.total; });
      if (matSum) materialText = fmtPrice(matSum);
    }
    if (!totalText && materialText) totalText = materialText;

    /* Wood capacity — local computation matching the widget
       (cf-bw-capacity refresh in rack-liquid). Configurator-only
       metric specific to firewood racks. */
    if (!capacityText) {
      try {
        var usefulH = STATE.H - (DIMS.deckHeight || 0.20);
        if (usefulH > 0) {
          var gross_m3 = STATE.W * STATE.L * usefulH;
          var wood_m3  = 0.80 * gross_m3;   /* 80% fill rate, stacked firewood */
          capacityText = STATE.isMetric
            ? wood_m3.toFixed(2) + ' m³'
            : (wood_m3 * 35.3147).toFixed(1) + ' ft³';
        }
      } catch (e) {}
    }

    return {
      /* Live text snapshot — preferred by PDF widget renderer. */
      texts: {
        total:    totalText    || '',
        material: materialText || '',
        execution: execText    || '',
        time:     timeText     || '',
        capacity: capacityText || ''
      },
      /* Legacy numeric shape kept for backward compat with any other
         consumers (other configurators / older PDF code paths). */
      materials: { count: 0, value: 0 },
      execution: { count: 0, value: 0, hours: 0 },
      total:     0,
      currency:  (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    };
  }

  /* Build a URL that re-opens the configurator with the current STATE
     pre-loaded. Falls back to current page URL if the share helper
     isn't available yet (e.g. configurator-share hasn't loaded). */
  function buildShareUrl() {
    if (global.ConfiguratorShare && typeof global.ConfiguratorShare.getShareUrl === 'function') {
      try { return global.ConfiguratorShare.getShareUrl(); } catch (e) {}
    }
    return window.location.href;
  }

  function saveConfig() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    try {
      localStorage.setItem('rack_config', JSON.stringify({
        L: STATE.L, W: STATE.W, H: STATE.H,
        isMetric: STATE.isMetric,
        view: STATE.view, vizStage: STATE.vizStage,
        ts: Date.now()
      }));
      alert(T.saveOk || 'Configuration saved.');
    } catch (e) {
      alert((T.saveFail || 'Failed to save configuration.') + ' ' + e.message);
    }
  }

  /* savePref — quiet auto-save for preferences that should persist across
     sessions: dimensions, units, view, viz stage. Merges into the existing
     rack_config payload so manual saveConfig() still works. */
  /* THE DESIGN, NOT THE VIEW (bench-v219-pdfkey): the key the PDF is paid for, so the
     same design downloads again for free for 30 days (configurator-pdf.liquid
     pdf-pay-v4, worker leva-ai) */
  function _pdfKey() {
    try { return 'bench|' + (STATE.variant | 0) + '|' + JSON.stringify(global.BenchBoQ.compute().byMaterial || {}); } catch (e) { return ''; }
  }
  function savePref() {
    if (_holdWrites()) return;   /* v265: the voice tour / REF write nothing */
    try {
      var existing = {};
      try {
        var raw = localStorage.getItem('rack_config');
        if (raw) existing = JSON.parse(raw) || {};
      } catch (e) {}
      existing.L = STATE.L;
      existing.W = STATE.W;
      existing.H = STATE.H;
      existing.backH = STATE.backH;
      existing.isMetric = STATE.isMetric;
      existing.view = STATE.view;
      existing.vizStage = STATE.vizStage;
      existing.opacity2D = STATE.opacity2D;
      existing.swingBack = STATE.swingBack;
      existing.waveBack = STATE.waveBack;
      existing.porchH = STATE.porchH;
      existing.psofaBack = STATE.psofaBack;   /* v269: the porch swing's back height */
      existing.bedMW = STATE.bedMW; existing.bedHead = STATE.bedHead;   /* v273: the bed's mattress width, headboard */
      existing.bedHeadStyle = STATE.bedHeadStyle;                         /* v275: its infill */
      existing.adiBack = STATE.adiBack;
      existing.swingRoof = STATE.swingRoof;
      existing.swingPitch = STATE.swingPitch;
      existing.colorMode = STATE.colorMode;
      existing.swingCushion = (STATE.swingCushion === true || STATE.swingCushion === false) ? STATE.swingCushion : null;
      existing.porchFill = STATE.porchFill; existing.porchGap = STATE.porchGap;   /* v281 */
      existing.gbArms = (STATE.gbArms === true); existing.gbArmH = STATE.gbArmH;   /* v285 */
      existing.sbW = STATE.sbW; existing.sbAng = STATE.sbAng;                      /* v288 the sunbed */
      existing.kidsBench = STATE.kidsBench === true;                                /* v299 */
      existing.mfFound = _mfFound(STATE); existing.mfWeave = STATE.mfWeave === true;   /* v301 */
      existing.mfCant = STATE.mfCant === true;                                      /* v308 */
      existing.rtbMode = _rtbMode(STATE);                                           /* v414 */
      existing.gsScreen = STATE.gsScreen !== false;                                 /* v303 */
      existing.mbRet = _mbRet(STATE);                                               /* v355 */
      existing.mbShape = _mbShape(STATE); existing.mbRoof = _mbRoof(STATE); existing.mbPitch = (typeof STATE.mbPitch === 'number') ? STATE.mbPitch : null; existing.mbH = (typeof STATE.mbH === 'number') ? STATE.mbH : null; existing.mbCov = _mbCov(STATE);   /* v357 */
      existing.gsDrop = STATE.gsDrop;                                               /* v305 */
      existing.rbMode = STATE.rbMode; existing.rbW = STATE.rbW; existing.rbN = STATE.rbN; existing.rbOpen = STATE.rbOpen === true; existing.rbTrellis = STATE.rbTrellis !== false; existing.rbTrV = 1;   /* v314, v316 (v325 rbTrV: written since the trellis is on by default) */
      existing.gaMode = STATE.gaMode; existing.gaW = STATE.gaW; existing.gaFound = _gaFound(STATE); existing.gaGrid = _gaGrid(STATE);   /* v320, v322, v333 */
      existing.gzN = _gzN(STATE);                                                   /* v328 the gazebo's shape */
      existing.gzFound = _gzFound(STATE); existing.gzCov = _gzCov(STATE); existing.gzFill = _gzFill(STATE); existing.gzGap = STATE.gzGap; existing.gzFields = _gzFields(STATE);   /* v329; v350 the full sides */
      existing.phW = STATE.phW; existing.phPorch = _phPorch(STATE); existing.phSlide = (STATE.phSlide !== false); existing.phSwings = (STATE.phSwings !== false); existing.phLoft = (STATE.phLoft !== false); existing.tfTrunk = STATE.tfTrunk; existing.phRoof = STATE.phRoof || null; existing.coHens = STATE.coHens || null; existing.coRun = (STATE.coRun !== false); existing.ctWheels = (STATE.ctWheels !== false); existing.knDog = STATE.knDog || null; existing.knFlap = (STATE.knFlap !== false); existing.knDeck = (STATE.knDeck !== false); existing.csShape = _csShape(STATE); existing.csMb = _csMb(STATE); existing.csT = STATE.csT || null; existing.csLook = _csLook(STATE); existing.phFound = STATE.phFound || null;   /* v402 */   /* v388 */   /* v385 */   /* v375 */   /* v368 */   /* v367 */   /* v365 */   /* v362 the cottage; v363 the stilt house's slide */
      existing.ghW = STATE.ghW; existing.ghKnee = (STATE.ghKnee === true); existing.ghBench = (STATE.ghBench === true); existing.ghFound = _ghFound(STATE); existing.ghWin = (STATE.ghWin != null) ? STATE.ghWin : null;   /* v373 the gable greenhouse */
      existing.kpOpen = (STATE.kpOpen !== false); existing.kpAng = _kpAng(STATE); existing.kpFrame = _kpFrame(STATE);   /* v376 the kitchen pod (v406 the flap's angle, the counter's frame) */
      existing.kpKinds = Array.isArray(STATE.kpKinds) ? STATE.kpKinds.slice() : null;   /* v379 its bays' equipment */
      existing.kpN = _kpN(STATE); existing.kpFound = _kpFound(STATE); existing.kpClad = _kpClad(STATE); existing.kpShelf = _kpShelf(STATE); existing.kpRoof = _kpRoof(STATE); existing.kpFin = _kpFin(STATE); existing.kpLad = _kpLad(STATE);   /* v405 its bays' number, foundation, cladding, shelf, roof, finish */
      existing.peW = STATE.peW; existing.peGap = STATE.peGap; existing.peRoof = _peRoof(STATE); existing.peCov = _peCov(STATE); existing.peFillT = _peFillT(STATE); existing.peFound = _peFound(STATE); existing.peFields = _peFields(STATE);   /* v334 the pergola */
      existing.colorV = 2;   /* v285: written since pine became the default (an older 'birch' = the old default) */
      existing.ts = Date.now();
      localStorage.setItem('rack_config', JSON.stringify(existing));
    } catch (e) { /* localStorage quota / disabled — silent */ }
  }

  function loadSaved() {
    try {
      var raw = localStorage.getItem('rack_config');
      if (!raw) return;
      var d = JSON.parse(raw);
      if (typeof d.L === 'number' && typeof d.W === 'number' && typeof d.H === 'number') {
        STATE.L = d.L;
        /* Clamp W to current range — old localStorage values (e.g. 0.55
           from a kids session) might fall outside the new 4–15 plank
           range. Clamp to nearest valid boundary. */
        STATE.W = Math.max(RANGES.W.min, Math.min(RANGES.W.max, d.W));
        STATE.H = d.H;
      }
      /* isMetric: respect saved value UNLESS the shop is hard-locked to a
         specific unit system (USD-priced stores must be imperial, since
         all prices in the catalog are expressed per imperial unit).
         detectUnits() already returned the shop-mandated value into
         STATE.isMetric at boot — if it's false (USD/imperial), keep it
         and don't let a stale localStorage flip it. */
      var shopForcesImperial = (typeof global.Shopify !== 'undefined') &&
                               global.Shopify.currency &&
                               global.Shopify.currency.active === 'USD';
      if (typeof d.isMetric === 'boolean' && !shopForcesImperial) {
        STATE.isMetric = d.isMetric;
      }
      if (d.view === '3d' || d.view === '2d') STATE.view = d.view;
      if (d.vizStage === 1 || d.vizStage === 2 || d.vizStage === 3) STATE.vizStage = d.vizStage;
      if (typeof d.opacity2D === 'number' && d.opacity2D >= 0 && d.opacity2D <= 0.80) {
        STATE.opacity2D = d.opacity2D;
      }
      if (typeof d.backH === 'number' && d.backH >= 0.18288 && d.backH <= 0.55) {
        STATE.backH = d.backH;
      }
      /* Clamp to valid range — both 2D and 3D now have up to 3 stages. */
      if (STATE.vizStage > 3) STATE.vizStage = 1;
      /* Hollywood swing: backrest tilt, roof and pitch (clamped on use). */
      if (typeof d.swingBack === 'number') STATE.swingBack = d.swingBack;
      if (typeof d.waveBack === 'number') STATE.waveBack = d.waveBack;
      if (typeof d.porchH === 'number') STATE.porchH = d.porchH;   /* clamped on use */
      if (typeof d.psofaBack === 'number') STATE.psofaBack = d.psofaBack;   /* v269, clamped on use */
      if (typeof d.bedMW === 'number') STATE.bedMW = d.bedMW;       /* v273, snapped on use */
      if (typeof d.bedHead === 'number') STATE.bedHead = d.bedHead; /* v273, clamped on use */
      if (typeof d.bedHeadStyle === 'string') STATE.bedHeadStyle = d.bedHeadStyle;   /* v275, checked on use */
      if (typeof d.adiBack === 'number') STATE.adiBack = d.adiBack;
      if (d.swingRoof === 'none' || d.swingRoof === 'gable' || d.swingRoof === 'mono') STATE.swingRoof = d.swingRoof;
      if (typeof d.swingPitch === 'number') STATE.swingPitch = d.swingPitch;
      if (typeof d.colorMode === 'string') STATE.colorMode = (d.colorMode === 'birch' && d.colorV !== 2) ? 'pine' : d.colorMode;   /* v285: the old default birch saved before pine -> pine */
      if (typeof d.swingCushion === 'boolean' || d.swingCushion === null) STATE.swingCushion = d.swingCushion;
      if (d.porchFill === 'planks' || d.porchFill === 'slats') STATE.porchFill = d.porchFill;   /* v281 */
      if (typeof d.gbArms === 'boolean') STATE.gbArms = d.gbArms;   /* v285 */
      if (typeof d.gbArmH === 'number') STATE.gbArmH = d.gbArmH;
      if (typeof d.sbW === 'number') STATE.sbW = d.sbW;       /* v288, snapped on use */
      if (typeof d.sbAng === 'number') STATE.sbAng = d.sbAng; /* v288, the nearest notch on use */
      if (typeof d.kidsBench === 'boolean') STATE.kidsBench = d.kidsBench;   /* v299 */
      if (d.mfFound === 'screw' || d.mfFound === 'concrete') STATE.mfFound = d.mfFound;   /* v301 */
      if (typeof d.mfWeave === 'boolean') STATE.mfWeave = d.mfWeave;
      if (typeof d.mfCant === 'boolean') STATE.mfCant = d.mfCant;           /* v308 */
      if (RTB.MODES.indexOf(d.rtbMode) >= 0) STATE.rtbMode = d.rtbMode;     /* v414 */
      if (typeof d.gsScreen === 'boolean') STATE.gsScreen = d.gsScreen;      /* v303 */
      if (typeof d.mbRet === 'boolean') { STATE.mbRet = d.mbRet; if (MB_SHAPES.indexOf(d.mbShape) < 0) STATE.mbShape = d.mbRet ? 'Lr' : 'I'; }   /* v355 (v357 a save before the shapes) */
      if (MB_SHAPES.indexOf(d.mbShape) >= 0) STATE.mbShape = d.mbShape;    /* v357 the bar's options */
      if (d.mbRoof === 'mono' || d.mbRoof === 'gable') STATE.mbRoof = d.mbRoof;
      if (typeof d.mbPitch === 'number' || d.mbPitch === null) STATE.mbPitch = d.mbPitch;
      if (typeof d.mbH === 'number' || d.mbH === null) STATE.mbH = d.mbH;
      if (typeof d.mbCov === 'boolean') STATE.mbCov = d.mbCov;
      if (typeof d.gsDrop === 'number') STATE.gsDrop = d.gsDrop;            /* v305, clamped on use */
      if (typeof d.rbMode === 'string') STATE.rbMode = d.rbMode;            /* v314 the raised bed */
      if (typeof d.rbW === 'number') STATE.rbW = d.rbW;
      if (typeof d.rbN === 'number') STATE.rbN = d.rbN;
      if (typeof d.rbOpen === 'boolean') STATE.rbOpen = d.rbOpen;
      if (typeof d.rbTrellis === 'boolean' && d.rbTrV === 1) STATE.rbTrellis = d.rbTrellis;   /* v316; v325 an older save's 'off' was the old default -- not kept */
      if (d.gaMode === 'flat' || d.gaMode === 'gable' || d.gaMode === 'arch') STATE.gaMode = d.gaMode;   /* v320 the garden arbor, v331 + 'arch' */
      if (typeof d.gaW === 'number') STATE.gaW = d.gaW;
      if (d.gaFound === 'tile' || d.gaFound === 'screw' || d.gaFound === 'block') STATE.gaFound = d.gaFound;   /* v322 */
      if (typeof d.gaGrid === 'boolean') STATE.gaGrid = d.gaGrid;   /* v333 the trellis */
      if (d.gzN === 4 || d.gzN === 6) STATE.gzN = d.gzN;                                        /* v328 the gazebo */
      if (d.gzFound === 'screw' || d.gzFound === 'block' || d.gzFound === 'pier') STATE.gzFound = d.gzFound;   /* v329 */
      if (typeof d.peW === 'number') STATE.peW = d.peW;
      if (typeof d.peGap === 'number') STATE.peGap = d.peGap;   /* v337 clamped on use */                                                 /* v334 the pergola (v336 no shape) */
      if (d.peRoof === 'flat' || d.peRoof === 'gable' || d.peRoof === 'hip') STATE.peRoof = d.peRoof;
      if (typeof d.peCov === 'boolean') STATE.peCov = d.peCov;
      if (d.peFillT === 'h' || d.peFillT === 'v' || d.peFillT === 'lat') STATE.peFillT = d.peFillT;
      if (d.peFound === 'screw' || d.peFound === 'block' || d.peFound === 'pier') STATE.peFound = d.peFound;
      if (typeof d.phW === 'number') STATE.phW = d.phW;            /* v362 the cottage */
      if (typeof d.ghW === 'number') STATE.ghW = d.ghW;            /* v373 the gable greenhouse */
      if (typeof d.ghKnee === 'boolean') STATE.ghKnee = d.ghKnee;
      if (typeof d.ghBench === 'boolean') STATE.ghBench = d.ghBench;   /* v392 */
      if (d.ghFound === 'screw' || d.ghFound === 'block' || d.ghFound === 'pier') STATE.ghFound = d.ghFound;   /* v399 */
      if (typeof d.ghWin === 'number') STATE.ghWin = d.ghWin;   /* v390 the old-window greenhouse's sashes (clamped on use) */
      if (typeof d.kpOpen === 'boolean') STATE.kpOpen = d.kpOpen;   /* v376 the kitchen pod */
      if (typeof d.kpAng === 'number') STATE.kpAng = d.kpAng;   /* v406 */
      if (d.kpFrame === 'wood' || d.kpFrame === 'steel') STATE.kpFrame = d.kpFrame;
      if (Array.isArray(d.kpKinds)) STATE.kpKinds = d.kpKinds.slice();   /* v379 (checked on use) */
      if (d.kpFound === 'screw' || d.kpFound === 'block' || d.kpFound === 'pier') STATE.kpFound = d.kpFound;   /* v405 */
      if (KP_CLAD_ORDER.indexOf(d.kpClad) >= 0) STATE.kpClad = d.kpClad;   /* v405 (v413 + the panels) */
      if (typeof d.kpShelf === 'boolean') STATE.kpShelf = d.kpShelf;
      if (d.kpLad === 'dip' || d.kpLad === 'hooks') STATE.kpLad = d.kpLad;   /* v409 (v410 'dip') */
      if (d.kpRoof === 'seam' || d.kpRoof === 'epdm' || d.kpRoof === 'green') STATE.kpRoof = d.kpRoof;
      if (d.kpFin === 'acacia' || d.kpFin === 'concrete' || d.kpFin === 'granite' || d.kpFin === 'inox') STATE.kpFin = d.kpFin;
      if (d.kpN === 3 || d.kpN === 4 || d.kpN === 5) STATE.kpN = d.kpN;   /* v405 */
      else if (typeof d.L === 'number') STATE.kpN = _kpNFromLen(STATE, d.L);   /* v405 a design saved before: its number from its length (read by the kitchen pod only) */
      if (typeof d.phPorch === 'boolean') STATE.phPorch = d.phPorch;
      if (typeof d.phSlide === 'boolean') STATE.phSlide = d.phSlide;   /* v363 */
      if (typeof d.phSwings === 'boolean') STATE.phSwings = d.phSwings;   /* v365 */
      if (typeof d.phLoft === 'boolean') STATE.phLoft = d.phLoft;         /* v367 the barn's loft */
      if (typeof d.tfTrunk === 'number') STATE.tfTrunk = d.tfTrunk;       /* v368 the tree fort's trunk (clamped on use) */
      if (typeof d.coHens === 'number') STATE.coHens = d.coHens;          /* v375 the coop's hens (clamped on use), */
      if (typeof d.knDog === 'number') STATE.knDog = d.knDog;             /* v385 the dog house's dog (clamped on use), */
      if (typeof d.knFlap === 'boolean') STATE.knFlap = d.knFlap;         /* v388 the insulated dog house's flap, */
      if (typeof d.knDeck === 'boolean') STATE.knDeck = d.knDeck;         /* v403 the modern dog house's roof deck, */
      if (typeof d.coRun === 'boolean') STATE.coRun = d.coRun;
      if (typeof d.ctWheels === 'boolean') STATE.ctWheels = d.ctWheels;   /* v379 the chicken tractor's wheels */            /* -- its run */
      if (d.phRoof === 'mono' || d.phRoof === 'gable') STATE.phRoof = d.phRoof;   /* v370 the roof on the switch */
      if (d.csShape === 'i2' || d.csShape === 'i3' || d.csShape === 'l') STATE.csShape = d.csShape;   /* v402 the castle's plan, */
      if (typeof d.csMb === 'boolean') STATE.csMb = d.csMb;                                           /* -- its monkey bars, */
      if (typeof d.csT === 'number') STATE.csT = d.csT;                                               /* -- its towers in the L, */
      if (d.csLook === 'low' || d.csLook === 'roof' || d.csLook === 'tall' || d.csLook === 'mix') STATE.csLook = d.csLook;   /* -- their look */
      if (d.phFound === 'screw' || d.phFound === 'block' || d.phFound === 'pier') STATE.phFound = d.phFound;   /* v402 the playhouses' foundation */
      if (d.peFields && typeof d.peFields === 'object') STATE.peFields = d.peFields;
      if (d.gzCov === 'shingle' || d.gzCov === 'seam') STATE.gzCov = d.gzCov;
      if (d.gzFill === 'bal' || d.gzFill === 'board') STATE.gzFill = d.gzFill;
      if (typeof d.gzGap === 'number') STATE.gzGap = d.gzGap;                                   /* clamped on use */
      if (d.gzFields && typeof d.gzFields === 'object') STATE.gzFields = d.gzFields;           /* v350 */
      if (typeof d.porchGap === 'number') STATE.porchGap = d.porchGap;                          /* clamped on use */
    } catch (e) {}
  }

  /* PDF is the primary deliverable. Until the central BoQ data has loaded
     (names + prices), an export would be incomplete — so the button stays
     visually disabled (greyed, non-clickable). Once data is ready it is
     promoted to the single RED primary action (white icon) so it stands out. */
  var PDF_BTN_RED = '#D8232A';   /* LEVA red */

  function _initPdfButtonState() {
    var btn = document.getElementById('cf-btn-pdf');
    if (!btn) return;

    if (!document.getElementById('cf-pdf-btn-style')) {
      var st = document.createElement('style');
      st.id = 'cf-pdf-btn-style';
      st.textContent =
        '#cf-btn-pdf.cf-pdf-loading{opacity:.4;pointer-events:none;cursor:default;filter:grayscale(1);}' +
        '#cf-btn-pdf.cf-pdf-ready{background:' + PDF_BTN_RED + ' !important;border-color:' + PDF_BTN_RED + ' !important;color:#fff !important;}' +
        /* White icon regardless of how it is rendered (inline SVG,
           <img>, or a CSS mask / background-image child): a
           brightness(0)+invert(1) filter turns any opaque icon
           pixels into solid white. Applied to the button's children
           so the red background itself is not affected. */
        '#cf-btn-pdf.cf-pdf-ready > *{filter:brightness(0) invert(1) !important;}';
      document.head.appendChild(st);
    }

    var bridge = global.ConfiguratorBudgetBridge || null;
    function isReady() {
      return !(bridge && typeof bridge.isReady === 'function') || bridge.isReady();
    }
    function promote() {
      btn.classList.remove('cf-pdf-loading');
      btn.classList.add('cf-pdf-ready');
    }

    if (isReady()) { promote(); return; }

    btn.classList.add('cf-pdf-loading');
    if (bridge && typeof bridge.onReady === 'function') {
      try { bridge.onReady(promote); } catch (e) {}
    }
    var waited = 0;
    var iv = setInterval(function () {
      if (isReady()) { clearInterval(iv); promote(); }
      else if ((waited += 300) >= 30000) { clearInterval(iv); promote(); }  /* fail-open after 30 s */
    }, 300);
  }

  /* ───────────────────────── AR (View in your space) ──────────────
     Ported from the foundations (base) configurator. Click → export the
     current bench Three.js model as a GLB → upload to R2 via the
     Cloudflare Worker → show a QR pointing at the <model-viewer> page.
     Phone scans QR → "View in AR" drops the bench into the room.

     Flow:
       1. GET  {worker}/upload-url   → { uuid, uploadUrl, viewerUrl }
       2. GLTFExporter.parse(bench)  → ArrayBuffer (GLB binary)
       3. PUT  {uploadUrl} body=glb  → R2 stores {uuid}.glb
       4. render QR(viewerUrl)

     SECTION PREREQUISITES (same three the base section already has):
       • BENCH_BOOT.arWorkerUrl  — the Worker base URL (copy the value
         from the foundations section; identical worker).
       • the GLTFExporter script must be loaded (window.GLTFExporter).
       • the QRCode script (already loaded for the PDF export).
     If any are missing the modal shows a clear error instead of failing
     silently. The AR button + modal markup are injected by THIS lib, so
     no section HTML change is needed. ───────────────────────────────── */
  function _setArStatus(msg) {
    var el = document.getElementById('cf-ar-modal-status');
    if (el) el.textContent = msg || '';
  }

  function _setArQR(dataUrl) {
    var el = document.getElementById('cf-ar-modal-qr');
    if (!el) return;
    el.innerHTML = '';
    if (!dataUrl) return;
    var img = document.createElement('img');
    img.src = dataUrl;
    img.alt = 'AR QR code';
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.borderRadius = '8px';
    img.style.background = '#fff';
    img.style.padding = '8px';
    el.appendChild(img);
  }

  function _setArLink(viewerUrl) {
    var el = document.getElementById('cf-ar-modal-link');
    if (!el) return;
    if (viewerUrl) {
      el.style.display = 'block';
      el.innerHTML = '<a href="' + viewerUrl + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">' + viewerUrl + '</a>';
    } else {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  function _arExportScene() {
    /* Build a clean GLB from the current bench model. Export the meshes
       in BenchEngine.benchGroup, skipping the scale person and the
       pocket-hole viz markers. Each mesh gets its OWN geometry clone —
       Mesh.clone() is shallow and keeps the geometry reference, so
       without a deep clone applyMatrix4 would mutate the shared buffer
       and every instance would collapse onto the last transform.
       Returns Promise<ArrayBuffer> of the GLB bytes. */
    return new Promise(function (resolve, reject) {
      var T = global.THREE;
      var Exporter = global.GLTFExporter;
      var eng = global.BenchEngine;
      if (!T || !eng || !eng.benchGroup) {
        reject(new Error('THREE / bench scene not ready'));
        return;
      }
      if (!Exporter) {
        reject(new Error('GLTFExporter not available'));
        return;
      }

      /* The configurator lights the scene with a soft Ambient(0.65) +
         Directional(0.85) rig, while model-viewer shows the model under a
         bright neutral environment — so the same baseColor reads LIGHTER
         in AR. Bake a darkening factor into the exported materials so AR
         matches the darker on-screen wood. Relative tones are preserved.
         Materials are cloned (never mutate the live scene) and de-duped by
         uuid so the GLB keeps one material per original. Tune AR_TONE if
         needed (lower = darker). */
      var AR_TONE = 0.7;
      var matCache = {};
      function _toneMat(mat) {
        if (!mat) return mat;
        if (matCache[mat.uuid]) return matCache[mat.uuid];
        var c = new T.MeshStandardMaterial({
          color: (mat.color ? mat.color.clone() : new T.Color(0xcccccc)).multiplyScalar(AR_TONE),
          metalness: (typeof mat.metalness === 'number') ? mat.metalness : 0,
          roughness: (typeof mat.roughness === 'number') ? mat.roughness : 0.85,
          map: mat.map || null,
          side: mat.side
        });
        matCache[mat.uuid] = c;
        return c;
      }

      /* SCENE VIEWER (Android AR) REFUSES A FILE WITH ANY EXTENSION it does
         not know ("Couldn't load object"): only KHR_materials_unlit and
         KHR_texture_transform pass. So the export is made PLAIN (v242):
         - the scale figure and its loaded children are skipped (only its
           anchor carried the 'person' tag; the human model's meshes went
           into the AR file with their own, possibly quantised, data),
           and so is anything under a hidden parent;
         - every geometry is rebuilt as float position / normal / uv (+ its
           index and groups) -- no quantised or extra attributes;
         - every material becomes a plain MeshStandardMaterial: colour (x
           AR_TONE), metalness, roughness, its map -- no emissive, no
           transparency;
         - and after the export any extension left is cut from the JSON
           and logged. */
      function _arHidden(node) {
        for (var n = node; n && n !== eng.benchGroup; n = n.parent) {
          if (n.visible === false) return true;
          var ptn = n.userData && n.userData.partType;
          if (ptn === 'person' || ptn === 'pocket-marker' || ptn === 'porch-context' || ptn === 'ph-tree') return true;   /* v368 the tree fort's tree: the customer's own */
          if (n.userData && n.userData.gbPocket) return true;   /* v286 the 2x4 bench's pocket marks */
          if (typeof ptn === 'string' && ptn.indexOf('-hw-screw') >= 0) return true;   /* v262: the drawn screws stay out of AR (in the wood, hundreds of them) */
          if (n.userData && n.userData.assetType === 'section-cut-aux') return true;
        }
        return false;
      }
      function _arPlainGeom(g) {
        var out = new T.BufferGeometry(), names = ['position', 'normal', 'uv'], k, i;
        for (k = 0; k < names.length; k++) {
          var a = g.getAttribute(names[k]);
          if (!a || !a.count) continue;
          var sz = a.itemSize, arr = new Float32Array(a.count * sz);
          for (i = 0; i < a.count; i++) {
            arr[i * sz] = a.getX(i);
            if (sz > 1) arr[i * sz + 1] = a.getY(i);
            if (sz > 2) arr[i * sz + 2] = a.getZ(i);
            if (sz > 3) arr[i * sz + 3] = a.getW(i);
          }
          out.setAttribute(names[k], new T.BufferAttribute(arr, sz));
        }
        if (g.index) out.setIndex(new T.BufferAttribute(g.index.array.slice(0), 1));
        for (i = 0; i < (g.groups || []).length; i++) out.addGroup(g.groups[i].start, g.groups[i].count, g.groups[i].materialIndex);
        if (!out.getAttribute('normal') && out.getAttribute('position')) out.computeVertexNormals();
        return out;
      }
      var exportRoot = new T.Group();
      var leafDefs = {}, leafNodes = {}, nLeafM = 0;
      ((eng.benchGroup.userData && eng.benchGroup.userData.phLeaves) || []).forEach(function (Lf) { leafDefs[Lf.key] = Lf; });
      eng.benchGroup.updateMatrixWorld(true);
      function _arLeafNode(key) {
        if (leafNodes[key]) { nLeafM++; return leafNodes[key]; }
        var Lf = leafDefs[key];
        if (!Lf) return null;
        var nd = new T.Group();
        nd.name = 'leaf_' + key;
        nd.position.copy(new T.Vector3(Lf.px, 0, Lf.pz).applyMatrix4(eng.benchGroup.matrixWorld));
        nd.userData = Object.assign({}, Lf.walk);
        exportRoot.add(nd);
        leafNodes[key] = nd; nLeafM++;
        return nd;
      }
      eng.benchGroup.traverse(function (node) {
        if (!node.isMesh || !node.geometry || !node.material) return;
        var pt = node.userData && node.userData.partType;
        if (_arHidden(node)) return;          /* the scale figure, viz-only markers, hidden parts */
        var pos0 = node.geometry.getAttribute && node.geometry.getAttribute('position');
        if (!pos0 || !pos0.count) return;
        node.updateMatrixWorld(true);
        var geom = _arPlainGeom(node.geometry);
        /* The mattress cushion is ExtrudeGeometry, which the GLTF exporter
           silently drops (bevel UVs / version mismatch). It is solid-colour,
           so for AR we substitute a plain box matching its local bounding
           box. The PILLOWS are now real merged GLB geometry (BufferGeometry)
           — they export reliably, so they are NOT substituted (the actual
           model + its pattern texture carry through to AR). */
        if (pt === 'cushion') {
          geom.computeBoundingBox();
          var bb = geom.boundingBox;
          var sx = Math.max(0.001, bb.max.x - bb.min.x);
          var sy = Math.max(0.001, bb.max.y - bb.min.y);
          var sz = Math.max(0.001, bb.max.z - bb.min.z);
          var bcx = (bb.max.x + bb.min.x) / 2;
          var bcy = (bb.max.y + bb.min.y) / 2;
          var bcz = (bb.max.z + bb.min.z) / 2;
          geom = new T.BoxGeometry(sx, sy, sz);
          geom.translate(bcx, bcy, bcz);
        }
        geom.applyMatrix4(node.matrixWorld);
        var mat = Array.isArray(node.material) ? node.material.map(_toneMat) : _toneMat(node.material);
        var cloned = new T.Mesh(geom, mat);
        cloned.name = node.name || (pt || 'mesh') + '_' + exportRoot.children.length;
        cloned.userData = Object.assign({}, node.userData || {});
        /* v369 a playhouse's door / shutter: a node of its own on its hinge line (extras.leaf -- the AR page's walk-through turns it) */
        var lk = node.userData && node.userData.phLeaf, LN = lk ? _arLeafNode(lk) : null;
        if (LN) { geom.translate(-LN.position.x, -LN.position.y, -LN.position.z); LN.add(cloned); return; }
        exportRoot.add(cloned);
      });

      if (exportRoot.children.length === 0) {
        reject(new Error('No exportable meshes in scene'));
        return;
      }
      if (Object.keys(leafNodes).length) _dbg('[ar] ' + Object.keys(leafNodes).length + ' leaf node(s) on their hinges (' + nLeafM + ' meshes): ' + Object.keys(leafNodes).join(', ') + ' -- the walk-through shuts the doors and opens them, folds the shutters flat, as you come near (v369)');

      var exporter = new Exporter();
      exporter.parse(
        exportRoot,
        function (glb) {
          if (glb instanceof ArrayBuffer) {
            try { glb = _arCleanGlb(glb); } catch (eCl) { _dbg('[ar] clean failed: ' + (eCl && eCl.message)); }
            resolve(glb);
          } else {
            reject(new Error('Expected GLB ArrayBuffer, got JSON'));
          }
        },
        function (err) { reject(err); },
        { binary: true }
      );
    });
  }

  /* Read the GLB's JSON chunk, log what Scene Viewer will see, and cut any
     extension it does not accept (it rejects the whole file otherwise). */
  function _arCleanGlb(buf) {
    var dv = new DataView(buf), jsonLen = dv.getUint32(12, true);
    var jsonTxt = new TextDecoder().decode(new Uint8Array(buf, 20, jsonLen));
    var j = JSON.parse(jsonTxt), OK = { KHR_materials_unlit: 1, KHR_texture_transform: 1 };
    var used = (j.extensionsUsed || []).slice(), cut = [], i;
    function strip(o) { if (o && o.extensions) { for (var k in o.extensions) if (!OK[k]) { delete o.extensions[k]; if (cut.indexOf(k) < 0) cut.push(k); } if (!Object.keys(o.extensions).length) delete o.extensions; } }
    (j.materials || []).forEach(strip); (j.meshes || []).forEach(strip); (j.nodes || []).forEach(strip); (j.textures || []).forEach(strip); strip(j);
    if (j.extensionsUsed) { j.extensionsUsed = j.extensionsUsed.filter(function (e) { return OK[e]; }); if (!j.extensionsUsed.length) delete j.extensionsUsed; }
    if (j.extensionsRequired) { j.extensionsRequired = j.extensionsRequired.filter(function (e) { return OK[e]; }); if (!j.extensionsRequired.length) delete j.extensionsRequired; }
    var types = {};
    (j.accessors || []).forEach(function (a) { types[a.componentType] = (types[a.componentType] || 0) + 1; });
    _dbg('[ar] glb: meshes ' + (j.meshes || []).length + ', materials ' + (j.materials || []).length + ', accessor types ' + JSON.stringify(types) +
         ', extensions used ' + (used.length ? used.join(',') : 'none') + (cut.length ? (' -> CUT ' + cut.join(',')) : ''));
    if (!cut.length) return buf;
    /* rebuild the GLB with the cleaned JSON (padded to 4 with spaces) */
    var enc = new TextEncoder().encode(JSON.stringify(j)), pad = (4 - enc.length % 4) % 4;
    var jl = enc.length + pad, binStart = 20 + jsonLen, rest = buf.byteLength - binStart;
    var out = new ArrayBuffer(12 + 8 + jl + rest), o = new DataView(out), u8 = new Uint8Array(out);
    o.setUint32(0, 0x46546C67, true); o.setUint32(4, 2, true); o.setUint32(8, out.byteLength, true);
    o.setUint32(12, jl, true); o.setUint32(16, 0x4E4F534A, true);
    u8.set(enc, 20); for (i = 0; i < pad; i++) u8[20 + enc.length + i] = 0x20;
    u8.set(new Uint8Array(buf, binStart, rest), 20 + jl);
    return out;
  }

  async function _arUpload(glbBuffer) {
    var BOOT = global.BENCH_BOOT || {};
    var T = BOOT.i18n || {};
    /* Same Cloudflare Worker the foundations configurator uses (its
       ALLOWED_ORIGIN already covers www.theleva.com, so CORS is fine).
       BENCH_BOOT.arWorkerUrl overrides this if the section sets it. */
    var AR_WORKER_FALLBACK = 'https://soft-art-55b9.long-cloud-d006.workers.dev';
    var workerUrl = BOOT.arWorkerUrl || (T.arWorkerUrl) || AR_WORKER_FALLBACK;
    if (!workerUrl) throw new Error('Worker URL missing');
    _dbg('[ar] worker URL = ' + workerUrl);

    _dbg('[ar] GET ' + workerUrl + '/upload-url');
    var r1;
    try {
      r1 = await fetch(workerUrl + '/upload-url');
    } catch (netErr) {
      _dbg('[ar] network error on /upload-url: ' + netErr);
      throw new Error('Network error: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] /upload-url response status=' + r1.status + ' ok=' + r1.ok);
    if (!r1.ok) throw new Error('upload-url failed: HTTP ' + r1.status);
    var info = await r1.json();
    _dbg('[ar] /upload-url payload: ' + JSON.stringify(info));
    if (!info || !info.uploadUrl) throw new Error('upload-url response invalid');

    _dbg('[ar] PUT ' + info.uploadUrl + ' (' + (glbBuffer.byteLength / 1024).toFixed(1) + ' KB)');
    var r2;
    try {
      r2 = await fetch(info.uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'model/gltf-binary' },
        body: glbBuffer
      });
    } catch (netErr) {
      _dbg('[ar] network error on PUT: ' + netErr);
      throw new Error('Network error on PUT: ' + (netErr && netErr.message ? netErr.message : netErr));
    }
    _dbg('[ar] PUT response status=' + r2.status + ' ok=' + r2.ok);
    if (!r2.ok) {
      var errBody = '';
      try { errBody = await r2.text(); } catch (_) {}
      _dbg('[ar] PUT error body: ' + errBody);
      throw new Error('PUT failed: HTTP ' + r2.status + ' ' + errBody);
    }

    return info;  /* { uuid, uploadUrl, publicUrl, viewerUrl } */
  }

  function _arGenerateQR(url) {
    return new Promise(function (resolve) {
      function tryLib() {
        if (global.QRCode && global.QRCode.toDataURL) {
          global.QRCode.toDataURL(url, { width: 400, margin: 1, errorCorrectionLevel: 'M' }, function (err, dataUrl) {
            if (err || !dataUrl) {
              resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
            } else {
              resolve(dataUrl);
            }
          });
          return true;
        }
        return false;
      }
      if (tryLib()) return;
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (tryLib()) { clearInterval(iv); return; }
        if (attempts > 20) {
          clearInterval(iv);
          resolve('https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=' + encodeURIComponent(url));
        }
      }, 100);
    });
  }

  /* Self-contained AR modal — injected once so the bench section needs
     no extra HTML. Mirrors the foundations modal structure / ids so the
     ported _setAr* helpers target the same nodes. */
  /* The bench section loads THREE + OrbitControls but NOT the
     GLTFExporter (foundations does). Rather than require a section
     edit, pull the matching exporter build straight from esm.sh — the
     SAME three@0.160.0 the section already imports, so it is binary
     compatible. Dynamic import() works fine inside this classic script. */
  /* ── GLB throw-pillow model + geometric pattern textures ─────────────
     The pillow is a real GLB model (hosted on Shopify CDN). We load it
     once, merge its sub-meshes into a single normalized geometry (centred,
     scaled into a unit cube) and cache it, so each pillow is one Mesh that
     plugs into the existing partType / explode / AR-export pipeline. The
     surface is a procedural geometric-pattern CanvasTexture in our pillow
     colour variants (re-generated when the colour stage changes). */
  var PILLOW_GLB_URL = 'https://cdn.shopify.com/3d/models/08e121eda7214d4e/Pillow.glb';
  var _pillowGeo = null, _pillowGeoPromise = null;
  var _pillowLoaderPromise = null, _pillowUtilsPromise = null;

  function _ensureGLTFLoader() {
    if (global.GLTFLoader) return Promise.resolve();
    if (_pillowLoaderPromise) return _pillowLoaderPromise;
    _pillowLoaderPromise = import('https://esm.sh/three@0.160.0/examples/jsm/loaders/GLTFLoader.js')
      .then(function (mod) {
        global.GLTFLoader = mod.GLTFLoader || (mod.default && mod.default.GLTFLoader) || mod.default;
        if (!global.GLTFLoader) throw new Error('GLTFLoader import returned no export');
      })
      .catch(function (e) { _pillowLoaderPromise = null; throw e; });
    return _pillowLoaderPromise;
  }
  function _ensureBufferUtils() {
    if (global.BufferGeometryUtils && global.BufferGeometryUtils.mergeGeometries) return Promise.resolve();
    if (_pillowUtilsPromise) return _pillowUtilsPromise;
    _pillowUtilsPromise = import('https://esm.sh/three@0.160.0/examples/jsm/utils/BufferGeometryUtils.js')
      .then(function (mod) { global.BufferGeometryUtils = mod; })
      .catch(function (e) { _pillowUtilsPromise = null; throw e; });
    return _pillowUtilsPromise;
  }

  /* Load + merge + normalize the pillow GLB into a single unit-cube geometry
     (centred at origin, longest axis = 1). Resolves with the geometry. */
  function _ensurePillowGeo() {
    if (_pillowGeo) return Promise.resolve(_pillowGeo);
    if (_pillowGeoPromise) return _pillowGeoPromise;
    _pillowGeoPromise = Promise.all([_ensureGLTFLoader(), _ensureBufferUtils()]).then(function () {
      return new Promise(function (resolve, reject) {
        var T = global.THREE;
        new global.GLTFLoader().load(PILLOW_GLB_URL, function (gltf) {
          try {
            var root = gltf.scene || (gltf.scenes && gltf.scenes[0]);
            root.updateMatrixWorld(true);
            var geos = [];
            root.traverse(function (o) {
              if (o.isMesh && o.geometry) {
                var g = o.geometry.clone();
                /* keep only position / normal / uv so all merge cleanly */
                var keep = ['position', 'normal', 'uv'];
                Object.keys(g.attributes).forEach(function (a) {
                  if (keep.indexOf(a) < 0) g.deleteAttribute(a);
                });
                if (!g.attributes.uv && g.attributes.position) {
                  var n = g.attributes.position.count;
                  g.setAttribute('uv', new T.BufferAttribute(new Float32Array(n * 2), 2));
                }
                if (!g.attributes.normal) g.computeVertexNormals();
                g.applyMatrix4(o.matrixWorld);
                geos.push(g);
              }
            });
            if (!geos.length) { reject(new Error('pillow GLB has no meshes')); return; }
            var merged = global.BufferGeometryUtils.mergeGeometries(geos, false) || geos[0];
            /* The model is already authored at real-world scale. Just centre
               it, then rotate so its LONGEST axis runs along Z (the sofa
               length) — so pillows sit in a row against the back. Keep the
               natural proportions (no squashing). */
            merged.computeBoundingBox();
            var bb = merged.boundingBox, sz = new T.Vector3(), ctr = new T.Vector3();
            bb.getSize(sz); bb.getCenter(ctr);
            merged.translate(-ctr.x, -ctr.y, -ctr.z);
            if (sz.x >= sz.y && sz.x >= sz.z) {
              merged.rotateY(Math.PI / 2);             /* longest = X → bring it onto Z */
            } else if (sz.y > sz.x && sz.y > sz.z) {
              merged.rotateX(Math.PI / 2);             /* longest = Y → lay it down onto Z */
            } /* else longest already Z — leave it */
            merged.computeBoundingBox();
            var sz2 = new T.Vector3(); merged.boundingBox.getSize(sz2);
            merged.computeVertexNormals();
            merged.userData = { size: [sz2.x, sz2.y, sz2.z] };
            _pillowGeo = merged;
            resolve(merged);
          } catch (err) { reject(err); }
        }, undefined, function (err) { _pillowGeoPromise = null; reject(err); });
      });
    }).catch(function (e) { _pillowGeoPromise = null; throw e; });
    return _pillowGeoPromise;
  }

  /* Draw a tiling geometric pattern (two tones) onto a 256² canvas. */
  function _pillowPatternCanvas(bg, fg, type) {
    var c = document.createElement('canvas');
    c.width = c.height = 256;
    var g = c.getContext('2d');
    g.fillStyle = bg; g.fillRect(0, 0, 256, 256);
    g.strokeStyle = fg; g.fillStyle = fg; g.lineJoin = 'round';
    if (type === 'diamonds') {
      g.lineWidth = 7;
      var n = 4, s = 256 / n;
      for (var i = -1; i <= n; i++) {
        for (var j = -1; j <= n + 1; j++) {
          var px = i * s + (j % 2 ? s / 2 : 0), py = j * (s / 2);
          g.beginPath();
          g.moveTo(px, py - s * 0.40); g.lineTo(px + s * 0.40, py);
          g.lineTo(px, py + s * 0.40); g.lineTo(px - s * 0.40, py);
          g.closePath(); g.stroke();
        }
      }
    } else {   /* chevron */
      g.lineWidth = 11;
      var rows = 6, h = 256 / rows;
      for (var r = -1; r <= rows; r++) {
        var y = r * h;
        g.beginPath();
        for (var x = -h; x <= 256 + h; x += h) {
          g.moveTo(x, y + h * 0.9); g.lineTo(x + h / 2, y + h * 0.1); g.lineTo(x + h, y + h * 0.9);
        }
        g.stroke();
      }
    }
    return c;
  }
  function _pillowTexture(bg, fg, type) {
    var T = global.THREE;
    var tex = new T.CanvasTexture(_pillowPatternCanvas(bg, fg, type));
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    tex.repeat.set(2, 2);
    tex.anisotropy = 4;
    tex.needsUpdate = true;
    return tex;
  }
  /* Pattern palettes per colour stage: [bg, fg] for variant A and B. */
  function _pillowPalette(whiteMode) {
    return whiteMode
      ? { A: ['#6f9159', '#3f5a30', 'diamonds'], B: ['#52733f', '#88a86f', 'chevron'] }
      : { A: ['#d1a23a', '#7a5a16', 'diamonds'], B: ['#a9822e', '#e3cf94', 'chevron'] };
  }
  /* (Re)build the pattern textures onto the pillow materials for a stage. */
  function _applyPillowTextures(mats, whiteMode) {
    if (!mats || !mats.pillowA || !mats.pillowB) return;
    var pal = _pillowPalette(whiteMode);
    [['A', mats.pillowA], ['B', mats.pillowB]].forEach(function (pair) {
      var def = pal[pair[0]], m = pair[1];
      if (m.map && m.map.dispose) m.map.dispose();
      m.map = _pillowTexture(def[0], def[1], def[2]);
      m.color.setHex(0xffffff);   /* let the texture carry the colour */
      m.needsUpdate = true;
    });
  }

  var _arExporterPromise = null;
  function _ensureGLTFExporter() {
    if (global.GLTFExporter) return Promise.resolve();
    if (_arExporterPromise) return _arExporterPromise;
    _arExporterPromise = import('https://esm.sh/three@0.160.0/examples/jsm/exporters/GLTFExporter.js')
      .then(function (mod) {
        global.GLTFExporter = mod.GLTFExporter || (mod.default && mod.default.GLTFExporter) || mod.default;
        if (!global.GLTFExporter) throw new Error('GLTFExporter import returned no export');
        _dbg('[ar] GLTFExporter loaded dynamically');
      })
      .catch(function (e) {
        _arExporterPromise = null;   /* allow retry on next AR open */
        throw new Error('Could not load GLTFExporter: ' + (e && e.message ? e.message : e));
      });
    return _arExporterPromise;
  }

  /* Self-contained AR modal — injected once, styled to match the
     foundations modal (cube badge, title, status, QR, bottom Close).
     The bench section has no .cf-onboard-modal CSS, so we ship our own
     scoped styles under #cf-ar-modal. Visibility is driven by the
     [hidden] attribute (the !important rule beats the base display:flex). */
  function _ensureArModal() {
    if (document.getElementById('cf-ar-modal')) return;
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var title    = T.arModalTitle    || 'Scan to view in AR';
    var subtitle = T.arModalSubtitle || 'Point your phone camera at the QR code to place this model in your space.';
    var closeTxt = T.arClose         || 'Close';

    if (!document.getElementById('cf-ar-modal-style')) {
      var st = document.createElement('style');
      st.id = 'cf-ar-modal-style';
      st.textContent =
        '#cf-ar-modal{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:100000;}' +
        '#cf-ar-modal[hidden]{display:none !important;}' +
        '#cf-ar-modal .cf-arm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55);backdrop-filter:blur(2px);}' +
        '#cf-ar-modal .cf-arm-card{position:relative;background:#fff;border-radius:16px;padding:32px 28px 24px;max-width:380px;width:calc(100% - 32px);box-shadow:0 20px 60px rgba(0,0,0,.25);text-align:center;animation:cfArModalIn .25s cubic-bezier(.16,1,.3,1);}' +
        '@keyframes cfArModalIn{from{opacity:0;transform:translateY(8px) scale(.98);}to{opacity:1;transform:none;}}' +
        '#cf-ar-modal .cf-arm-close{position:absolute;top:12px;right:12px;width:32px;height:32px;border:none;background:transparent;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;color:#888;border-radius:8px;transition:background .15s ease,color .15s ease;}' +
        '#cf-ar-modal .cf-arm-close:hover{background:#f4f4f4;color:#222;}' +
        '#cf-ar-modal .cf-arm-icon{width:56px;height:56px;margin:0 auto 14px;border-radius:50%;background:linear-gradient(135deg,#d2a878 0%,#b88752 100%);display:flex;align-items:center;justify-content:center;color:#fff;}' +
        '#cf-ar-modal .cf-arm-title{font:700 18px/1.3 var(--cf-font-display,sans-serif);color:#1a1a1a;margin:0 24px 6px;letter-spacing:-.01em;}' +
        '#cf-ar-modal .cf-arm-subtitle{font:500 13px/1.5 var(--cf-font-display,sans-serif);color:#555;margin:0 0 20px;}' +
        '#cf-ar-modal #cf-ar-modal-status{font:500 12px/1.4 var(--cf-font-display,sans-serif);color:#888;margin-bottom:12px;min-height:16px;}' +
        '#cf-ar-modal #cf-ar-modal-qr{display:flex;justify-content:center;align-items:center;min-height:200px;margin:8px 0 14px;}' +
        '#cf-ar-modal #cf-ar-modal-link{font:500 11px/1.4 var(--cf-font-display,sans-serif);color:#b88752;word-break:break-all;margin-bottom:14px;display:none;}' +
        '#cf-ar-modal .cf-arm-actions{display:flex;gap:10px;justify-content:center;margin-top:6px;}' +
        '#cf-ar-modal .cf-arm-btn{border:none;border-radius:10px;padding:12px 18px;font:600 13px/1.2 var(--cf-font-display,sans-serif);cursor:pointer;transition:background .15s ease,transform .1s ease;min-width:110px;background:#f4f4f4;color:#333;}' +
        '#cf-ar-modal .cf-arm-btn:hover{background:#e8e8e8;}' +
        '#cf-ar-modal .cf-arm-btn:active{transform:translateY(1px);}';
      document.head.appendChild(st);
    }

    var wrap = document.createElement('div');
    wrap.id = 'cf-ar-modal';
    wrap.hidden = true;
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML =
      '<div class="cf-arm-backdrop" data-cf-ar-close></div>' +
      '<div class="cf-arm-card">' +
        '<button class="cf-arm-close" type="button" data-cf-ar-close aria-label="' + closeTxt + '">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '<div class="cf-arm-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>' +
          '<polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>' +
          '<line x1="12" y1="22.08" x2="12" y2="12"></line></svg>' +
        '</div>' +
        '<h3 class="cf-arm-title">' + title + '</h3>' +
        '<p class="cf-arm-subtitle">' + subtitle + '</p>' +
        '<div id="cf-ar-modal-status"></div>' +
        '<div id="cf-ar-modal-qr"></div>' +
        '<div id="cf-ar-modal-link"></div>' +
        '<div class="cf-arm-actions">' +
          '<button class="cf-arm-btn" type="button" data-cf-ar-close>' + closeTxt + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
  }

  async function _openArModal() {
    _ensureArModal();
    var modal = document.getElementById('cf-ar-modal');
    if (!modal) return;
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};

    _setArQR(null);
    _setArLink(null);
    _setArStatus(T.arPreparing || 'Preparing scene…');
    modal.hidden = false;

    function close() {
      modal.hidden = true;
      modal.removeEventListener('click', onClick);
    }
    function onClick(e) {
      if (e.target.closest('[data-cf-ar-close]')) {
        e.preventDefault();
        close();
      }
    }
    modal.addEventListener('click', onClick);

    try {
      await _ensureGLTFExporter();
      var glb = await _arExportScene();
      _dbg('[ar] GLB size = ' + (glb.byteLength / 1024).toFixed(1) + ' KB');
      _setArStatus(T.arUploading || 'Uploading to cloud…');

      var info = await _arUpload(glb);
      _dbg('[ar] uploaded uuid=' + info.uuid + ' viewer=' + info.viewerUrl);

      var qrDataUrl = await _arGenerateQR(info.viewerUrl);
      _setArQR(qrDataUrl);
      _setArLink(info.viewerUrl);
      _setArStatus(T.arReady || 'Ready — scan with your phone');
    } catch (e) {
      console.error('[ar] export failed', e);
      _setArStatus((T.arError || 'AR export failed: ') + (e && e.message ? e.message : e));
    }
  }

  /* AR button. If the bench section already exposes #cf-btn-ar we just
     bind it; otherwise we clone an existing sidebar button (cf-btn-share)
     so the new one inherits the section's button styling, swap in an AR
     cube icon, and drop it in next to Share. */
  function _initArButton() {
    var openAr = function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      _openArModal();
    };

    var existing = document.getElementById('cf-btn-ar');
    if (existing) {
      existing.addEventListener('click', openAr);
      return;
    }

    var tmpl = document.getElementById('cf-btn-share') ||
               document.getElementById('cf-btn-pdf')   ||
               document.getElementById('cf-btn-view');
    /* Preferred slot: directly ABOVE the assembly-steps button (kept
       consistent across all configurators). Fall back to next to Share. */
    var anchor = document.getElementById('cf-btn-assembly');
    var styleSrc = tmpl || anchor;
    var parent = (anchor && anchor.parentNode) || (styleSrc && styleSrc.parentNode);
    if (!parent) return;   /* no sidebar to attach to */

    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var label = T.arButton || 'View in AR';

    /* Build a FRESH element rather than cloning a template: a clone
       carries inline onclick / data-* attributes (cloning Share made the
       AR button fire Share). We set only the generic icon-button class so
       it inherits sidebar styling but nothing behavioural. The click
       handler also stops propagation in case the sidebar uses a delegated
       (class-based) click router. */
    var btn = document.createElement((styleSrc || { tagName: 'BUTTON' }).tagName);
    btn.id = 'cf-btn-ar';
    /* ONLY the generic icon-button class — never cf-share-btn. The share
       module attaches a DELEGATED click listener that matches .cf-share-btn,
       so inheriting that class made the AR button fire Share. */
    btn.className = 'cf-icon-btn';
    if (btn.tagName === 'BUTTON') btn.type = 'button';
    btn.setAttribute('title', label);
    btn.setAttribute('aria-label', label);
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" style="width:22px;height:22px;display:block;margin:auto;pointer-events:none;">' +
      '<path d="M12 2 3 7v10l9 5 9-5V7z"></path>' +
      '<path d="M12 22V12"></path>' +
      '<path d="M3 7l9 5 9-5"></path>' +
      '</svg>';

    if (anchor && anchor.parentNode === parent) {
      parent.insertBefore(btn, anchor);                    /* directly above Assembly */
    } else if (tmpl && tmpl.parentNode) {
      tmpl.parentNode.insertBefore(btn, tmpl.nextSibling); /* fallback: next to Share */
    } else {
      parent.appendChild(btn);
    }
    btn.addEventListener('click', openAr);
  }

  /* Register the SHARED scale-figure module (Configurator.person) so the
     person GLB + anchor logic lives in core and is reused by every
     configurator. Bench supplies only: the engine, its state, where the
     figure stands, and when it may show. Safe to call more than once. */
  function _registerSharedPerson() {
    if (global.Configurator && global.Configurator.person && global.Configurator.person.init) {
      global.Configurator.person.init({
        name: 'bench',
        getEngine: function () { return global.BenchEngine; },
        getState:  function () { return STATE; },
        frontOf:   function () {
          var W = STATE.W || 0.6;
          return { x: (W / 2) + 0.60, z: 0 };
        },
        visibleAt: function (stage, view) {
          return (view === '3d' && stage !== 4 && stage !== 5 && STATE.bodyVisible !== false);
        },
        onToggle:  function () { global.BenchRenderer.build(); }
      });
    }
  }

  /* v356 the product's vendor when it is not LEVA (an author's royalty product, e.g. GARDEN BAR), else '' */
  function _royaltyProduct() {
    var v = String((global.BENCH_BOOT && global.BENCH_BOOT.vendor) || '').trim().toUpperCase();
    return (v && v !== 'LEVA') ? v : '';
  }
  function wireSidebar() {
    var on = function (id, fn) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', fn);
    };
    on('cf-btn-view',     function () { global.BenchEngine.toggleView(); });
    on('cf-btn-viz',      function () { global.BenchEngine.cycleVizStage(); });
    on('cf-btn-colors',   function () { global.BenchEngine.cycleColorMode(); });
    on('cf-btn-cut',      toggleCut);   /* v369 the playhouses' section tool */
    /* cf-btn-reset is repurposed as Undo — bound in _initUndo(). */
    on('cf-btn-unit',     toggleUnits);
    on('cf-btn-budget',   openBudgetDrawer);
    on('cf-btn-share',    share);
    on('cf-btn-pdf',      function () {
      /* v356 a royalty product (the vendor is the author): no token step -- the purchase gate decides */
      if (_royaltyProduct()) {
        _dbg('[pdf] royalty product (vendor ' + _royaltyProduct() + ') -- no tokens, the purchase gate decides');
        exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
        return;
      }
      if (window.ConfiguratorPdfExporter && ConfiguratorPdfExporter.socialGate) {
        ConfiguratorPdfExporter.socialGate({ key: _pdfKey() }).then(function () {
          exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
        });
      } else {
        exportPdf().catch(function (e) { console.error('[exportPdf]', e); });
      }
    });
    on('cf-btn-body',     toggleBody);
    on('cf-btn-assembly', cycleAssembly);

    /* Idempotent: ensure shared person hooks are registered (also done
       before first build). */
    _registerSharedPerson();

    /* PDF button: disabled until data loads, then promoted to red primary. */
    _initPdfButtonState();

    /* AR: inject + bind the "View in AR" button (and its modal on demand). */
    _initArButton();

    /* Undo button (was Reset): step back through session, then reset. */
    _initUndo();

    /* 2D fill-opacity slider — updates STATE.opacity2D and re-applies
       stage so material opacities pick up the new value. Pointer events
       are 'input' (live update during drag) for instant feedback.
       Drives --cfg-fill CSS var so the gradient track shows colored
       fill below the thumb (pool-style). Slider max is 80, so the
       fill is normalised against that for a 0–100% visual range. */
    var op2dSlider = document.getElementById('cf-2d-opacity-slider');
    var op2dValue  = document.getElementById('cf-2d-opacity-value');
    if (op2dSlider) {
      var op2dMax = parseInt(op2dSlider.max, 10) || 100;
      var updateFill = function (pct) {
        /* Slider is writing-mode tb-lr → thumb at BOTTOM = max value.
           Fill grows from the thumb downward; the gradient (to top:
           accent..gray) means accent fills 0..--cfg-fill from bottom.
           So fill must be SMALL when value is HIGH (thumb low) — invert. */
        var fillPct = 100 - (pct / op2dMax) * 100;
        op2dSlider.style.setProperty('--cfg-fill', fillPct + '%');
      };
      var onOp2dChange = function () {
        var pct = parseInt(op2dSlider.value, 10) || 0;
        STATE.opacity2D = pct / 100;
        if (op2dValue) op2dValue.textContent = pct + '%';
        updateFill(pct);
        if (global.BenchEngine && global.BenchEngine.applyVizStage) {
          global.BenchEngine.applyVizStage();
        }
        if (global.BenchLib && global.BenchLib.savePref) global.BenchLib.savePref();
      };
      op2dSlider.addEventListener('input', onOp2dChange);
      op2dSlider.addEventListener('change', onOp2dChange);
      /* Initialize from STATE (loadSaved may have set non-default). */
      var initPct = Math.round(STATE.opacity2D * 100);
      op2dSlider.value = initPct;
      if (op2dValue) op2dValue.textContent = initPct + '%';
      updateFill(initPct);
    }


    _initBodyDragHandle();
    _startBodyHandleTracker();
    _initCutDragHandle();
  }

  /* ── Open the budget "Share / Your data / Available budgets" drawer
        from the configurator's money icon. budget-sharing.liquid exposes
        window.openShareBudgetDrawer(initialTab) — on product pages the
        'data' tab is the relevant one (becomes "Available budgets"). */
  function openBudgetDrawer() {
    if (typeof global.openShareBudgetDrawer === 'function') {
      global.openShareBudgetDrawer('data');
    } else if (typeof global.openRefreshDrawer === 'function') {
      global.openRefreshDrawer();
    } else {
      _dbg('no budget drawer opener on window — budget-sharing.liquid may not be loaded yet');
    }
  }

  /* ── Body (scale-figure) toggle & drag ───────────────────────────── */
  function toggleBody() {
    STATE.bodyVisible = !STATE.bodyVisible;
    var btn = document.getElementById('cf-btn-body');
    if (btn) {
      btn.setAttribute('aria-pressed', STATE.bodyVisible ? 'true' : 'false');
      btn.style.opacity = STATE.bodyVisible ? '' : '0.45';
    }
    var handle = document.getElementById('cf-body-handle');
    if (handle) {
      handle.classList.toggle('active', STATE.bodyVisible);
      /* Inline display also — belt-and-suspenders so the tracker's per-
         frame override doesn't have to be the only path. */
      handle.style.display = STATE.bodyVisible ? 'block' : 'none';
    }
    global.BenchRenderer.build();
  }

  function _initBodyDragHandle() {
    var handle = document.getElementById('cf-body-handle');
    if (!handle) return;
    var dragging = false;
    var T = global.THREE;
    var plane = null, raycaster = null, ndc = null, hit = null;

    function getCanvasRect() {
      var cnv = global.BenchEngine && global.BenchEngine.renderer
                ? global.BenchEngine.renderer.domElement : null;
      return cnv ? cnv.getBoundingClientRect() : null;
    }

    function pointerToWorld(clientX, clientY) {
      var eng = global.BenchEngine;
      if (!eng || !eng.camera || !eng.renderer) return null;
      var rect = getCanvasRect(); if (!rect) return null;
      if (!plane) plane = new T.Plane(new T.Vector3(0, 1, 0), 0);  /* Y=0 ground */
      if (!raycaster) raycaster = new T.Raycaster();
      if (!ndc) ndc = new T.Vector2();
      if (!hit) hit = new T.Vector3();
      ndc.x =  ((clientX - rect.left) / rect.width)  * 2 - 1;
      ndc.y = -((clientY - rect.top)  / rect.height) * 2 + 1;
      raycaster.setFromCamera(ndc, eng.camera);
      var p = raycaster.ray.intersectPlane(plane, hit);
      return p;  /* world Vector3 with y=0 */
    }

    function onDown(e) {
      if (!STATE.bodyVisible) return;
      e.preventDefault();
      dragging = true;
      handle.setPointerCapture && handle.setPointerCapture(e.pointerId);
      /* Disable orbit controls during drag so the camera doesn't move. */
      if (global.BenchEngine && global.BenchEngine.controls) {
        global.BenchEngine.controls.enabled = false;
      }
    }
    function onMove(e) {
      if (!dragging) return;
      var p = pointerToWorld(e.clientX, e.clientY);
      if (!p) return;
      STATE.bodyX = p.x;
      STATE.bodyZ = p.z;
      /* Move person live without full rebuild — fast & smooth. */
      var rg = global.BenchEngine && global.BenchEngine.benchGroup;
      if (rg) {
        for (var i = 0; i < rg.children.length; i++) {
          var c = rg.children[i];
          if (c.userData && c.userData.partType === 'person') {
            c.position.set(STATE.bodyX, 0, STATE.bodyZ);
            if (c.userData.basePos) c.userData.basePos.set(STATE.bodyX, 0, STATE.bodyZ);
            break;
          }
        }
      }
    }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      try { handle.releasePointerCapture && handle.releasePointerCapture(e.pointerId); } catch (_) {}
      if (global.BenchEngine && global.BenchEngine.controls) {
        global.BenchEngine.controls.enabled = true;
      }
    }
    handle.addEventListener('pointerdown',   onDown);
    handle.addEventListener('pointermove',   onMove);
    handle.addEventListener('pointerup',     onUp);
    handle.addEventListener('pointercancel', onUp);
  }

  function _startBodyHandleTracker() {
    /* Project the person's torso (Y ≈ 1.20 m above ground) to screen,
       then write the absolute CSS left/top onto the handle each frame.
       Uses the canvas's bounding rect directly — no offsetParent math. */
    var T = global.THREE;
    var v3 = new T.Vector3();
    function tick() {
      var handle = document.getElementById('cf-body-handle');
      var eng = global.BenchEngine;
      if (handle && eng && eng.camera && eng.renderer) {
        /* Hide the body drag handle in assembly mode (step ≠ 0) AND in
           the section-cut viz stage (stage 4 in 3D) — the figure is gone
           there, so its handle must be too. This tick runs every frame, so
           it must honour the same rule applyVizStage uses or it re-shows
           the handle. */
        var assemblyActive = ((STATE.assemblyStep | 0) !== 0) ||
                             (STATE.view === '3d' && (STATE.vizStage === 4 || STATE.vizStage === 5));
        if (STATE.bodyVisible && !assemblyActive) {
          var bx = (STATE.bodyX != null) ? STATE.bodyX
                 : (((STATE.W || 0.7) / 2) + 0.60);
          var bz = (STATE.bodyZ != null) ? STATE.bodyZ : 0;
          v3.set(bx, 1.20, bz);
          v3.project(eng.camera);
          var cnv = eng.renderer.domElement;
          var rect = cnv.getBoundingClientRect();
          /* Handle is positioned inside its offsetParent. Compute
             coordinates RELATIVE to that parent so it lands on the
             right pixel regardless of where the configurator is on
             the page. */
          var parent = handle.offsetParent || document.body;
          var pRect  = parent.getBoundingClientRect();
          var x = rect.left - pRect.left + (v3.x + 1) * 0.5 * rect.width;
          var y = rect.top  - pRect.top  + (1 - (v3.y + 1) * 0.5) * rect.height;
          handle.style.left = x + 'px';
          handle.style.top  = y + 'px';
          /* Force inline display:block so the .active CSS class isn't
             a single point of failure. Also clear opacity unless the
             handle is genuinely behind the camera. */
          handle.style.display = 'block';
          var clipped = (v3.z <= -1 || v3.z >= 1);
          handle.style.opacity = clipped ? '0' : '1';
        } else {
          /* Body hidden: force the handle off. */
          handle.style.display = 'none';
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Section-cut drag handle — a DOM grip that sits on the cut plane in
     viz stage 4. Dragging it slides the plane along its axis. Mirrors the
     body-drag-handle pattern (proven to work): a tracker projects the
     plane-centre to screen each frame; the drag raycasts the pointer onto
     the ground plane and reads the axis coordinate as the new offset. */
  /* Section-cut grab — drag the cut PLANE itself anywhere (no separate
     drag point). On pointerdown in viz stage 4 we raycast only the
     invisible hit-quad sitting on the cut plane; a hit starts a drag
     (orbit disabled), otherwise the press falls through to OrbitControls
     so the model can still be rotated. Dragging moves the plane along its
     locked axis (the bench length, Z). */
  function _initCutDragHandle() {
    var eng0 = global.BenchEngine;
    var canvas = eng0 && eng0.renderer ? eng0.renderer.domElement : null;
    if (!canvas) { setTimeout(_initCutDragHandle, 200); return; }
    var T = global.THREE;
    var dragging = false;
    var rc = new T.Raycaster();
    var ndc = new T.Vector2();
    var gplane = new T.Plane(new T.Vector3(0, 1, 0), 0);
    var hit = new T.Vector3();

    function inCut() { return STATE.view === '3d' && STATE.vizStage === 4; }
    function rect() { return canvas.getBoundingClientRect(); }

    function axisCoordAt(clientX, clientY) {
      var eng = global.BenchEngine;
      if (!eng || !eng.camera) return null;
      var r = rect();
      ndc.x =  ((clientX - r.left) / r.width)  * 2 - 1;
      ndc.y = -((clientY - r.top)  / r.height) * 2 + 1;
      rc.setFromCamera(ndc, eng.camera);
      var p = rc.ray.intersectPlane(gplane, hit);
      if (!p) return null;
      return _BenchSectionCut._activeCutAlongX ? p.z : p.x;   /* locked axis */
    }

    canvas.addEventListener('pointerdown', function (e) {
      if (!inCut()) return;
      var eng = global.BenchEngine;
      var hm = _BenchSectionCut && _BenchSectionCut._hitMesh;
      if (!eng || !eng.camera || !hm) return;
      var r = rect();
      ndc.x =  ((e.clientX - r.left) / r.width)  * 2 - 1;
      ndc.y = -((e.clientY - r.top)  / r.height) * 2 + 1;
      rc.setFromCamera(ndc, eng.camera);
      var hits = rc.intersectObject(hm, false);
      if (!hits.length) return;     /* missed the plane → let orbit handle it */
      dragging = true;
      try { canvas.setPointerCapture(e.pointerId); } catch (_) {}
      if (eng.controls) eng.controls.enabled = false;
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var c = axisCoordAt(e.clientX, e.clientY);
      if (c == null) return;
      STATE.cutOffset = c;
      if (global.BenchEngine && global.BenchEngine.applyVizStage) {
        global.BenchEngine.applyVizStage();
      }
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { canvas.releasePointerCapture(e.pointerId); } catch (_) {}
      if (global.BenchEngine && global.BenchEngine.controls) {
        global.BenchEngine.controls.enabled = true;
      }
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
  }

  /* ── BENCH ASSEMBLY SEQUENCE ────────────────────────────────────────
     Step 0  Built (no pockets, deck+lag heads visible)
     Step 1  Exploded view — every fastener visible
     Step 2  Pocket-hole locations — exploded + bright markers
     Step 3  4×4 corner posts
     Step 4  + 2×4 side rails
     Step 5  + Pocket-hole screws (side rail joints)
     Step 6  + 2×4 long rails
     Step 7  + Pocket-hole screws (long rail joints)
     Step 8  + 2×4 cross joists
     Step 9  + Pocket-hole screws (joist joints)
     Step 10 + 2×4 seat planks
     Step 11 + Deck screws (seat planks)
     Step 12 + 2×4 armrests
     Step 13 + Pocket-hole screws (armrest joints)

     Backrest sub-assembly (built OFF the bench in steps 14..18,
     then animated into place at step 19):
     Step 14 + 2×4 backrest top + bottom rails        ┐
     Step 15 + 2×4 backrest corner posts               │ OFF-BENCH —
     Step 16 + Pocket-hole screws (frame joints)       │ frame floats
     Step 17 + 2×4 backrest stretchers                 │ to the side
     Step 18 + Pocket-hole screws (stretcher joints)   ┘

     Step 19 Animate the assembled frame from its off-bench position
             onto the bench.
     Step 20 + Lag bolts (attach bottom rail to rear seat plank)
     Step 21 + 2×4 backrest planks
     Step 22 + Deck screws (backrest planks)
     Returns to 0 after the last allowed step. */
  var BENCH_FIRST_STEP = {
    'post':                  3,
    'rail-seat-left':        4,
    'rail-seat-right':       4,
    'rail-seat-front':       6,
    'rail-seat-back':        6,
    'joist':                 8,
    'seat-plank':            10,
    'rail-back-left':       12,
    'rail-back-right':      12,
    'rail-backrest-bottom': 14,
    'rail-backrest-top':    14,
    'backrest-group':       14,    /* bf container must be visible from
                                      step 14 so its children render. */
    'post-backrest':        15,
    'stretcher-backrest':   17,
    'backrest-plank':       21
  };
  var BENCH_LAST_STEP             = 22;
  var BENCH_LAST_STEP_NO_BACKREST = 13;

  /* Off-bench window: bf group + rail-backrest-bottom + any fastener
     tagged userData.bfOffBenchTrack get an additional translation
     during steps 14..18. The offset clears at step 19 — that's the
     "install on bench" moment, animated as a slide-in. */
  var BENCH_BR_OFFBENCH_FIRST   = 14;
  var BENCH_BR_OFFBENCH_LAST    = 18;
  var BENCH_BR_OFFBENCH_OFFSET  = [-0.30, 0.15, 0.30];

  /* Joint-step assignments. */
  var BENCH_JOINT_SIDE      = 5;
  var BENCH_JOINT_LONG      = 7;
  var BENCH_JOINT_JOIST     = 9;
  var BENCH_JOINT_SEAT_DECK = 11;
  var BENCH_JOINT_ARMREST   = 13;
  var BENCH_JOINT_BR_FRAME  = 16;   /* rails ↔ posts pockets        */
  var BENCH_JOINT_BR_STR    = 18;   /* stretcher ↔ rails pockets    */
  var BENCH_JOINT_BR_LAG    = 20;   /* lag bolts → attach to bench  */
  var BENCH_JOINT_BR_DECK   = 22;   /* backrest plank deck screws   */

  /* Resolve a part's off-bench offset for a given step, or null if it
     stays at base. Centralized so _applyAssemblyStep AND the animation
     pipeline agree. */
  function _benchOffBenchOffset(child, step) {
    if (step < BENCH_BR_OFFBENCH_FIRST || step > BENCH_BR_OFFBENCH_LAST) return null;
    var ud = child.userData || {};
    var pt = ud.partType;
    if (pt === 'backrest-group')        return BENCH_BR_OFFBENCH_OFFSET;
    if (pt === 'rail-backrest-bottom')  return BENCH_BR_OFFBENCH_OFFSET;
    if (ud.bfOffBenchTrack)             return BENCH_BR_OFFBENCH_OFFSET;
    return null;
  }

  /* Resolve a mesh's first-visible build step. Per-instance userData
     wins over the partType lookup. Falls back to 0 (always visible). */
  function _benchFirstStep(child) {
    var ud = child.userData || {};
    if (typeof ud.firstStep === 'number') return ud.firstStep;
    var pt = ud.partType;
    var s  = BENCH_FIRST_STEP[pt];
    return (typeof s === 'number') ? s : 0;
  }

  /* Visibility decision for a single mesh at a given step. Returns
     true/false. Drives both _applyAssemblyStep AND the animation
     pipeline in cycleAssembly (so they agree on which parts are
     "newly visible" at a transition). */
  /* Sofa 3-phase teardown offset for a part at a given step (relative to
     its base position). Cumulative:
       phase 1: bočnice (posts + SEAT-END + TOP-END + joinery) slide out Z
       phase 2: + TOP-END group lifts up (Y)
       phase 3: + posts split fwd/back (X). */
  /* Classify a sofa part for the staged (step 3+) assembly. Returns:
       'side'      = bočnice: posts + SEAT-END (+ MID short) rails + their
                     dowels/holes/pocket-marks/screws (the SEAT-END↔post joint)
       'side-hw'   = the pocket-marks + screws of that same side joint
                     (revealed one step AFTER the side frame mates)
       'other'     = everything else (TOP-END, long rails, slats, rošt,
                     ledger, soft, and their hardware) — assembled later
     Read mainly from idHint so TOP-END hardware (which carries a 'post'
     role) is NOT mistaken for the bočnice joint. */
  /* Dynamic sofa assembly step numbers. Center support legs (long sofas,
     L > 2 m) insert a dedicated step (12) just before the rošt, shifting
     the rošt / slats / slat-screw steps up by one. */
  function _sofaStepMap(s) {
    s = s || STATE;
    var porch    = ((s.variant | 0) === 7);   /* v269: the porch swing hangs after its platform */
    /* v273 the bed: its centre leg (wide beds) before the slats, the slat
       screws, the mattress last; no top end rails without the headboard */
    var bed      = ((s.variant | 0) === 14);
    var hasLegs  = (((s.variant | 0) === 2) && ((s.L || 0) > 2.8)) || (bed && (_bedSize(s).w + BED.CLEAR > BED.CENTER_FROM));
    var hasSlats = !porch && !bed && ((s.slats | 0) > 0);
    var rost = hasLegs ? 13 : 12;
    return {
      hasLegs:   hasLegs,
      legs:      hasLegs ? 12 : -1,
      rost:      rost,
      slats:     (porch || bed) ? 99 : rost + 1,
      slatScrew: porch ? 99 : bed ? rost + 1 : rost + 2,
      matt:      bed ? rost + 2 : 99,
      noTop:     bed && (s.backrestVisible === false),
      chains:    porch ? rost + 1 : 99,       /* v269: the chains drop in from above */
      eyes:      porch ? rost + 2 : 99,       /* the eye bolts screw into the posts, the hangers come down */
      beam:      porch ? rost + 3 : 99,       /* the beam last, from above */
      last:      porch ? (rost + 3) : bed ? (rost + 2) : (hasSlats ? (rost + 2) : rost)
    };
  }

  function _sofaPartGroup(ud) {
    var pt = ud.partType, id = (ud.idHint || '') + '', role = ud.sofaRole || '';
    var hgp = _sofaHangGroup(pt);                     /* v269: the porch swing's hanging */
    if (hgp) return hgp;
    /* CENTER support legs (long sofas) + their dowels are their own group:
       they install as a dedicated step (just before the rošt). */
    if (pt === 'post'       && id.indexOf('center-leg')  === 0) return 'centerleg';
    if (pt === 'dowel'      && id.indexOf('dowel-center') === 0) return 'centerleg';
    if (pt === 'dowel-hole' && id.indexOf('dowel-center') === 0) return 'centerleg';
    if (pt === 'post') return 'side';
    if (pt === 'rail-seat') return 'side';
    if (pt === 'bed-infill') return 'side';   /* v275: the bed headboard's slats / boards + their dowels, with the head side frame */
    if ((pt === 'dowel' || pt === 'dowel-hole') && id.indexOf('dowel-infill') === 0) return 'side';
    if (pt === 'dowel'        && id.indexOf('dowel-seatend') === 0) return 'side';
    if (pt === 'dowel-hole'   && id.indexOf('dowel-seatend') === 0) return 'side';
    if (pt === 'pocket-marker' && id.indexOf('pm-seatend') === 0) return 'side-hw';
    if (pt === 'screw-pocket'  && id.indexOf('ps-seatend') === 0) return 'side-hw';
    /* TOP-END (upper short rails on the posts) + their joinery.
       IMPORTANT: parts physically drilled into / fastened to the POST
       (the pocket marks, the pocket screws, and the lower dowel-hole)
       belong to the post — they must ride with the posts in step 3 and
       stay put. Only the rail itself, its dowel, and the rail-side bore
       arrive from above in step 5.
         post-side TOP-END hardware → 'side' / 'side-hw' (with the posts)
         rail-side TOP-END parts     → 'topend' (step 5)              */
    if (pt === 'rail-top-end') return 'topend';
    if (pt === 'dowel'        && id.indexOf('dowel-topend') === 0) return 'topend';
    if (pt === 'dowel-hole'   && id.indexOf('dowel-topend') === 0) {
      /* hole0 (idHint …-hole0) is the post-side bore; hole1 is rail-side */
      return (id.indexOf('-hole0') >= 0) ? 'side' : 'topend';
    }
    if (pt === 'pocket-marker' && id.indexOf('pm-topend') === 0) return 'side-hw-topend';
    if (pt === 'screw-pocket'  && id.indexOf('ps-topend') === 0) return 'side-hw-topend';

    /* LONG rails (front/back seat rails, top-back arm, lvl2 mid-back) +
       their joinery. The two bočnice slide together along Z in step 7.
         long rails + their dowels + rail-side bores + pocket marks → 'long'
         the post-side bore of a long-rail dowel → 'side' (rides the post)
         long-rail pocket screws → 'long-hw' (driven in step 8)          */
    var isLongKey = (id.indexOf('seatfront') >= 0 || id.indexOf('seatback') >= 0 ||
                     id.indexOf('topback') >= 0   || id.indexOf('midback') >= 0 ||
                     id.indexOf('topfront') >= 0  || id.indexOf('centerrail') >= 0);   /* v273: + the bed's centre rail */
    if (pt === 'rail-lower' || pt === 'rail-arm') return 'long';
    if (pt === 'dowel'      && id.indexOf('dowel-') === 0 && isLongKey) return 'long';
    if (pt === 'dowel-hole' && isLongKey) {
      /* hole role: 'long' = rail-side bore (step 7); 'post-…' = seat-level
         post bore (rides bočnice, step 3); 'topend-…' = the TOP-BACK rail's
         post-side bore, which rides the TOP-END rail (step 5). */
      if (role.indexOf('topend') === 0) return 'topend';
      if (role.indexOf('post')   === 0) return 'side';
      if (role.indexOf('seatend') === 0) return 'side';   /* v273: the bed's centre rail bore in the end rail */
      return 'long';
    }
    if (pt === 'pocket-marker' && id.indexOf('pm-') === 0 && isLongKey) return 'long';
    if (pt === 'screw-pocket'  && id.indexOf('ps-') === 0 && isLongKey) return 'long-hw';

    /* LEDGER battens (38×38 rošt supports) on the front + back long rails,
       and their wood screws (driven horizontally into the rail). */
    if (pt === 'ledger') return 'ledger';
    if (pt === 'screw-wood' && id.indexOf('ws-ledger') === 0) return 'ledger-hw';

    /* ROŠT 2×4 boards (loose-laid on the ledgers, no fasteners) → step 12.
       SLATS (back/side infill) + their screws → step 13. */
    if (pt === 'rost') return 'rost';
    if (pt === 'slat') return 'slat';
    if (pt === 'screw-wood' && id.indexOf('ws-slat') === 0) return 'slat-hw';

    return 'other';
  }

  /* The fully-exploded offset for a part = its phase offset at step 1.
     Safe to call from the step-3 branch since step 1 < 3 (no recursion). */
  function _sofaExplodedOffset(child) {
    return _sofaPhaseOffset(child, 1);
  }

  function _sofaPhaseOffset(child, step) {
    var ud = child.userData || {};
    var base = ud.basePos;
    if (!base) return [0, 0, 0];
    var role = ud.sofaRole || 'long';
    var pt = ud.partType;
    var zEnd = (base.z < 0) ? -1 : 1;
    var xEnd = (base.x > 0) ? 1 : -1;
    var SLIDE = 0.32, LIFT = 0.42, SPLIT = 0.34;
    var ROST_UP = 0.55, LEDGER_UP = 0.22;
    var ox = 0, oy = 0, oz = 0;

    /* Assembly is built in the EXPLODED→ASSEMBLED direction:
         step 0 = composed (finished sofa)
         step 1 = fully exploded (every part at its teardown position)
       Later steps (2+) will progressively bring parts together; for now
       only step 1 (full explode) is wired. */
    var exploded = (step >= 1);
    if (!exploded) return [0, 0, 0];

    /* v269: the porch swing's hanging -- above / outside until its step
       (hidden there anyway), so its step animates it in: the chains and
       the hangers drop from above, the eye bolts screw in along their
       axis from outside the post, the beam comes down last */
    var hgo = _sofaHangGroup(pt);
    if (hgo) {
      var smH = _sofaStepMap(STATE), atH = (hgo === 'p-chain') ? smH.chains : (hgo === 'p-eye') ? smH.eyes : (hgo === 'p-matt') ? smH.matt : smH.beam;
      if (step >= atH) return [0, 0, 0];
      if (pt === 'swing-hw-shank' || pt === 'swing-hw-eye') return [0, 0, zEnd * 0.22];
      return [0, (hgo === 'p-beam') ? 1.4 : 1.0, 0];
    }

    /* Center support legs (long sofas) + their dowels drop below in the
       exploded / frame views; they install at their dedicated step (just
       before the rošt) and rest at final position afterward. */
    var idCL = (ud.idHint || '') + '';
    if (idCL.indexOf('center-leg') === 0 || idCL.indexOf('dowel-center') === 0) {
      var smCL = _sofaStepMap(STATE);
      if (smCL.legs > 0 && step >= smCL.legs) return [0, 0, 0];
      return [0, -0.30, 0];
    }

    /* ── Staged assembly (step 3+) ────────────────────────────────────
       step 3 = posts join the SEAT-END/MID rails along X only. The short
       rails stay put (their exploded Z slide is kept), and BOTH bočnice
       stay slid apart along Z — leaving the gap where the long rails will
       later drop in. So we take the exploded offset and zero ONLY its X
       component; the Z slide (and any Y) is preserved.
       'other' parts stay parked at their exploded spot (hidden anyway). */
    if (step >= 3) {
      var grp3 = _sofaPartGroup(ud);
      /* step 7 = long rails appear at their final position (bočnice still
         apart); step 8 = the two bočnice slide together along Z, closing
         onto the long rails. So the Z slide is dropped from step 8 on. */
      var zClosed = (step >= 8);
      if (grp3 === 'side' || grp3 === 'side-hw' || grp3 === 'side-hw-topend') {
        var ex3 = _sofaExplodedOffset(child);
        return [0, ex3[1], zClosed ? 0 : ex3[2]];   /* drop X split; drop Z too from step 7 */
      }
      /* step 5+: TOP-END rails settle DOWN onto the posts — drop the Y
         lift AND the X split; keep the Z slide until step 7. */
      if (step >= 5 && (grp3 === 'topend')) {
        var ex5 = _sofaExplodedOffset(child);
        return [0, 0, zClosed ? 0 : ex5[2]];   /* drop Y + X; drop Z from step 7 */
      }
      /* long rails + their joinery are static at their final position
         (visible from step 7 onward). */
      if (step >= 7 && (grp3 === 'long' || grp3 === 'long-hw')) {
        return [0, 0, 0];
      }
      /* step 10 = ledger battens + their screws appear at their exploded
         spot; step 11 = they settle to base (batten first, then screws —
         the two-phase timing is handled in the animation loop). */
      if (grp3 === 'ledger' || grp3 === 'ledger-hw') {
        if (step >= 11) return [0, 0, 0];
        if (step >= 10) return _sofaExplodedOffset(child);   /* shown, exploded */
      }
      /* step 12 = rošt 2×4 boards drop in from above (settled at base).
         When center legs exist they take step 12, shifting rošt to 13. */
      var smP = _sofaStepMap(STATE);
      if (grp3 === 'rost') {
        if (step >= smP.rost) return [0, 0, 0];
      }
      /* slats fly into place (settled at base). */
      if (grp3 === 'slat' || grp3 === 'slat-hw') {
        if (step >= smP.slats) return [0, 0, 0];
        if (grp3 === 'slat-hw' && smP.slats === 99 && step >= smP.rost) return [0, 0, 0];   /* v273: the bed's slat screws (hidden until theirs, then driven in) */
      }
      /* 'other' parts stay parked at their exploded spot (hidden anyway). */
    }

    if (pt === 'rost')   { return [0, ROST_UP, 0]; }
    if (pt === 'ledger') { return [0, LEDGER_UP, 0]; }

    /* Wood screws for slats + ledger (visible fasteners). */
    if (pt === 'screw-wood') {
      var idw = (ud.idHint || '') + '';
      if (!exploded) return [0, 0, 0];
      var SLAT_OUT2 = 0.62, LED_IN = 0.16;   /* screws go further out than the slats (0.45) */
      /* slat screws ride their slat wall outward (same as the slats) */
      if (idw.indexOf('ws-slat-bed')   === 0) return [0,  ROST_UP + 0.10, 0];   /* v273: the bed's slat screws over their slats */
      if (idw.indexOf('ws-slat-top')   === 0) return [0,  SLAT_OUT2, 0];  /* top slat screws lift higher than the slats */
      if (idw.indexOf('ws-slat-back')  === 0) return [-SLAT_OUT2, 0, 0];
      if (idw.indexOf('ws-slat-left')  === 0) return [0, 0, -SLAT_OUT2];
      if (idw.indexOf('ws-slat-right') === 0) return [0, 0,  SLAT_OUT2];
      /* ledger screws move toward the inside of the seat box (visualised
         pulling inward off the rail) + rise with the ledger */
      if (idw.indexOf('ws-ledger-back')  === 0) return [ LED_IN, LEDGER_UP, 0];
      if (idw.indexOf('ws-ledger-front') === 0) return [-LED_IN, LEDGER_UP, 0];
      return [0, 0, 0];
    }

    /* Slats — fly outward off their face so they read as separate parts.
       Each side moves in one direction (gaps between slats stay the same).
         back  (−X long side) → −X · left (−Z end) → −Z · right (+Z end) → +Z */
    if (pt === 'slat') {
      var SLAT_OUT = 0.45;
      var id = (ud.idHint || '') + '';
      if (id.indexOf('slat-top')   === 0) return [0,  SLAT_OUT, 0];   /* top slats lift up */
      if (id.indexOf('slat-back')  === 0) return [-SLAT_OUT, 0, 0];
      if (id.indexOf('slat-left')  === 0) return [0, 0, -SLAT_OUT];
      if (id.indexOf('slat-right') === 0) return [0, 0,  SLAT_OUT];
      return [0, 0, 0];
    }

    /* Solid bočnice members (posts, SEAT-END, TOP-END) and their screws. */
    var isSide = (role.indexOf('seatend') === 0 ||
                  role.indexOf('topend')  === 0 ||
                  role.indexOf('post')    === 0);
    if (isSide) {
      oz = zEnd * SLIDE;
      if (role.indexOf('topend') === 0) oy = LIFT;
      if (role.indexOf('post') === 0) ox = xEnd * SPLIT;
      return [ox, oy, oz];
    }

    /* Joining dowels sit midway in the open joint. */
    if (role.indexOf('dwl-long') === 0)    { return [0, 0, zEnd * (SLIDE / 2)]; }
    if (role.indexOf('dwl-seatend') === 0) { return [xEnd * (SPLIT / 2), 0, zEnd * SLIDE]; }
    if (role.indexOf('dwl-topend') === 0)  { return [0, LIFT / 2, zEnd * SLIDE]; }

    return [0, 0, 0];   /* 'long' static parts (long rails, slats, etc.) */
  }

  function _benchVisibleAtStep(child, step) {
    var ud = child.userData || {};
    var pt = ud.partType;
    if (!pt) return true;
    if (pt === 'person') return (STATE.bodyVisible !== false);

    /* ── HOLLYWOOD SWING (variant 4) / PORCH (7) / A-FRAME (8) / ADIRONDACK (9): the build order, nothing exploded ── */
    if (_isStagedType(STATE.variant)) {
      if (step > 0 && step <= 2 && _xpHeadStep(step)) step = 0;   /* v395 the coops' exploded view and back together: the whole coop */
      if (step <= 0) return ud.gbPocket !== true && !ud.mbProc;     /* v286 the 2x4 bench's pocket marks: the assembly only; v357 the bar's slab making too */
      if (ud.mbProc) { var psP = _swingPartStep(pt); return (ud.mbProc === 'own') ? (step === psP) : (step >= psP && step <= _swingPartStep('mb-slab')); }   /* v357 the dig its own step only; the geotextile, formwork, spacers, mesh till the concrete is in */
      if (pt === 'pillow') return false;                              /* v263: decor, the built view only */
      return _swingPartStep(pt) <= step;
    }

    /* ── SOFA assembly (variant 2) — exploded→assembled build ─────────
         step 0 = composed · step 1 = fully exploded (no marks) ·
         step 2 = only the 4×4 profiles + their joinery, with markers.
         • mattress (cushion) + pillows only show when composed (step 0)
         • pocket-hole markers appear from step 2 onward
         • at step 2 the non-4×4 parts (slats, rošt 2×4, ledger 38×38) are
           hidden so only the 4×4 frame + pocket-hole hardware shows */
    if (_isSofaAsm(STATE)) {
      if (pt === 'cushion' || pt === 'pillow') return (step < 1);
      /* v269: the porch swing's hanging + beam: the built view, then their own steps */
      var hgv = _sofaHangGroup(pt);
      if (hgv) {
        if (step < 1) return true;
        var smHv = _sofaStepMap(STATE);
        return step >= ((hgv === 'p-chain') ? smHv.chains : (hgv === 'p-eye') ? smHv.eyes : (hgv === 'p-matt') ? smHv.matt : smHv.beam);
      }

      /* ── Staged assembly (step 3+) ──────────────────────────────────
         step 3 = only the two bočnice (posts + SEAT-END/MID rails + their
                  dowels & holes); pocket marks/screws NOT yet shown.
         step 4 = same + the SEAT-END↔post pocket marks & screws appear. */
      if (step >= 3) {
        var grp = _sofaPartGroup(ud);
        var smV = _sofaStepMap(STATE);
        if (grp === 'side')    return true;
        if (grp === 'side-hw') return (step >= 4);
        if (grp === 'topend')    return (step >= 5);
        if (grp === 'side-hw-topend') return (step >= 6);
        if (grp === 'long')      return (step >= 7);
        if (grp === 'long-hw')   return (step >= 9);
        if (grp === 'ledger')    return (step >= 10);
        if (grp === 'ledger-hw') return (step >= 10);
        if (grp === 'centerleg') return (step >= smV.legs);
        if (grp === 'rost')      return (step >= smV.rost);
        if (grp === 'slat')      return (step >= smV.slats);
        if (grp === 'slat-hw')   return (step >= smV.slatScrew);
        return false;   /* everything else hidden until its own step */
      }

      if (pt === 'pocket-marker') return (step >= 2);
      if (pt === 'screw-wood') return (step !== 2);   /* shown in default + exploded; hidden at the 4×4-only step 2 */
      if (step >= 2 && (pt === 'slat' || pt === 'rost' || pt === 'ledger' || pt === 'bed-infill')) return false;   /* v275: + the bed headboard's infill */
      return true;
    }

    if (pt === 'pillow') return (step <= 0);   /* v263: the park bench's pillows, built view only */
    /* Special views (0/1/2): step 0 = clean built look, step 1 =
       all hardware visible, step 2 = ONLY pocket markers (cylinders
       hidden so the bright orange ovals are the only fastener cue). */
    if (step <= 2) {
      if (pt === 'screw-pocket')   return (step === 1);
      if (pt === 'pocket-marker')  return (step === 2);
      return true;
    }

    /* Build progression (3+). Marker only at its own joint step.
       Everything else: visible from firstStep onwards. */
    if (pt === 'pocket-marker') {
      return (typeof ud.jointStep === 'number') ? (ud.jointStep === step) : false;
    }
    return _benchFirstStep(child) <= step;
  }

  /* Animation helper: returns the array of parts whose visibility
     turned on between prevStep and newStep. */
  function _diffNewParts(prevStep, newStep) {
    var eng = global.BenchEngine;
    if (!eng || !eng.benchGroup) return [];
    var out = [];
    eng.benchGroup.traverse(function (c) {
      if (!c.userData || !c.userData.partType) return;
      var wasV = _benchVisibleAtStep(c, prevStep);
      var isV  = _benchVisibleAtStep(c, newStep);
      if (isV && !wasV) out.push(c);
    });
    return out;
  }

  /* Pocket-hole tool demo image — shown centred in the canvas block on
     the assembly step where the pocket-hole drill markers appear
     (step 2). Self-contained (injected once into #cf-root), 60% width on
     desktop / 80% on mobile, rounded corners, close ✕. Closing it just
     hides it; advancing past / leaving step 2 also hides it. */
  var POCKET_IMG_URL = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/Pocket_hole.jpg?v=1780126385';
  function _ensurePocketHoleModal() {
    if (document.getElementById('cf-pocket-modal')) return;
    if (!document.getElementById('cf-pocket-modal-style')) {
      var st = document.createElement('style');
      st.id = 'cf-pocket-modal-style';
      st.textContent =
        '#cf-pocket-modal{position:absolute;inset:0;z-index:30;display:flex;align-items:center;justify-content:center;pointer-events:none;opacity:0;visibility:hidden;transition:opacity .5s ease,visibility 0s linear .5s;}' +
        '#cf-pocket-modal.cf-pocket-visible{opacity:1;visibility:visible;transition:opacity 1s ease,visibility 0s;}' +
        '#cf-pocket-modal .cf-pocket-card{position:relative;pointer-events:auto;width:45%;max-width:480px;border-radius:16px;overflow:hidden;box-shadow:0 18px 50px rgba(0,0,0,.28);background:#fff;}' +
        '#cf-pocket-modal .cf-pocket-card img{display:block;width:100%;height:auto;}' +
        '#cf-pocket-modal .cf-pocket-close{position:absolute;top:10px;right:10px;width:34px;height:34px;border:none;border-radius:50%;background:rgba(255,255,255,.92);color:#333;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.2);}' +
        '#cf-pocket-modal .cf-pocket-close:hover{background:#fff;color:#000;}' +
        '@media (max-width:768px){#cf-pocket-modal .cf-pocket-card{width:60%;}}';
      document.head.appendChild(st);
    }
    var root = document.getElementById('cf-root') ||
               (global.BenchEngine && global.BenchEngine.renderer &&
                global.BenchEngine.renderer.domElement &&
                global.BenchEngine.renderer.domElement.parentNode);
    if (!root) return;
    var wrap = document.createElement('div');
    wrap.id = 'cf-pocket-modal';
    wrap.innerHTML =
      '<div class="cf-pocket-card">' +
        '<button class="cf-pocket-close" type="button" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '<img src="' + POCKET_IMG_URL + '" alt="Pocket hole tool">' +
      '</div>';
    root.appendChild(wrap);
    wrap.querySelector('.cf-pocket-close').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      wrap.classList.remove('cf-pocket-visible');
      _pocketDismissed = true;   /* don't reopen until the step is left + re-entered */
    });
  }
  var _pocketDismissed = false;
  function _updatePocketHoleImage() {
    _ensurePocketHoleModal();
    var m = document.getElementById('cf-pocket-modal');
    if (!m) return;
    /* Show the pocket-hole tool demo at the "pocket holes" assembly step
       (step 2) for BOTH the sofa (variant 2) and the park bench. */
    if (STATE.assemblyStep === 2) {
      m.classList.add('cf-pocket-visible');
    } else {
      m.classList.remove('cf-pocket-visible');
    }
  }

  /* =====================================================================
     v395 THE EXPLODED VIEW ON THE COOPS' ASSEMBLY WALK (Marek 2026-10-30
     16:32: "Udelej i exploded view, stejne pravidla jako u ADU"). The walk
     starts as the house line's does (configurator-ui.js core-v479 /
     core-v658): step 1 the exploded view with its slider (0 assembled .. 4,
     2 by default), rolled apart slowly while the camera backs off to keep
     it all in the frame; step 2 back together, the camera home again; the
     items from step 3 (N = items + 2).
     COPIED from the house line -- _xpGrid, _xpPut, _xpFinal, _xpOver,
     _xpRaster, _xpDag, _xpMags, _xpLatF, _xpLateF and setExplode as they
     are; _asmSpread step by step (classes, riders, the plan and the face
     grids, the votes, split items, the order, the distances, what waits
     for the walls, what is lifted to clear them first, a group kept with
     the wall it is built into, an item kept together) -- the rules:
       - the centre: the middle of the floor (the coop's footprint) at the
         floor's level;
       - a wall's piece goes out square to its wall, what is above the floor
         up, the floor and what is under it down, each further the further
         it stands, and at least 200 mm past anything it lies on, so a
         build-up comes apart layer by layer;
       - up and down first, the walls slide out from k 0.8 (40 percent of
         the slider's default), what has a wall's piece over it after them;
       - nothing passes through anything.
     ADAPTED to a coop's own data (not invented -- each from the build):
       - the bodies are the build's pieces (benchGroup's children), an item
         is its step in the table; the screws, nails, hinges, knobs, catches
         and bolts ride with the piece they are driven into first (the house
         line draws none);
       - a wall's piece is one the build sends in from the side (flyDir
         sideways) and it goes out THAT way -- the coop's own faces instead
         of the outline's segments; a piece with no direction between the
         floor and the plate takes the face of the footprint it lies along
         (facesOf on the footprint's rectangle), none -> it stays inside (the
         house's front wall in the run; the roosts and their cleats, the
         coop's fitout);
       - the roof's kind: what the build lays on from above (flyDir up); the
         chicken tractor's A-frame: its slopes are its walls (out to their
         side), only what lies on no slope (the ridge) goes up;
       - the grid's cell 75 mm (a coop is a quarter of a house);
       - no windows between the layers (a coop's doors hang on its face), no
         upper storey, no A-frame clamp of the plate (a coop's wall is under
         a metre).
     ===================================================================== */
  var XP = { gap: 0.20, min0: 0.25, band: 0.45, deep: 0.80, near: 0.25, kL: 0.8, kL2: 1.2, cell: 0.075, tol: 0.004, rawTol: 0.008, clear: 0.08, rest: 0.30, def: 2, max: 4 };
  var EXPLODE_GAIN = 0.35;   /* the share of its distance a body travels at k = 1 */
  var XP_TYPES = { 34: 1, 37: 1, 39: 1, 42: 1, 46: 1, 49: 1, 52: 1 };   /* v401 + the hoop coop */   /* v397 + the barn coop */   /* the coops */
  var XP_RIDE = { 'ph-hinge': 1, 'ph-knob': 1, 'ph-catch': 1, 'ph-bolt': 1, 'ph-nhinge': 1, 'ph-bracket': 1 };   /* hardware with no direction of its own: rides with its piece */
  var XP_FIT = { 'ph-roost': 1, 'ph-rcleat': 1 };   /* the coop's fitout: stays inside */
  var XP_RIDE_ALL = { 'ph-nhinge': 1 };   /* the nest lid's strap hinges ride with their lid even with a direction of their own */
  var XP_FRAME = { 'ph-header': 1, 'ph-beam': 1, 'ph-rbeam': 1, 'ph-tplate': 1, 'ph-gstud': 1 };   /* the walls' framing -- headers, top plates, the beams on the posts, the gable studs: the house line's wall
     layer (out with their wall, the face they lie along), though the build lays them on from above */
  var XP_NEST = { 'ph-nest': 1, 'ph-nlid': 1, 'ph-nledge': 1, 'ph-nbrace': 1, 'ph-nledger': 1 };   /* the nest box: one item (built as a box, hung on its ledger) */
  var XP_FIXED = { 'person': 1, 'porch-context': 1, 'ph-tree': 1 };   /* the scale figure, the house the lean-to stands at: never moved */
  var _XP = { plan: null, shown: 0, k: 0, anim: 0, camHome: null, info: '', wired: false };
  function _xpType(v) { return !!XP_TYPES[((v == null) ? STATE.variant : v) | 0]; }
  /* the walk's head steps in a coop's table: 1 the exploded view, 2 back together */
  function _xpHead() { return [{ parts: [], codes: [], xp: 1, lk: ['exploded_view'] }, { parts: [], codes: [], xp: 2, lk: ['viz_full'] }]; }
  function _xpHeadStep(step) {
    if (!_xpType() || !(step > 0)) return 0;
    var st = _swingStepTable(STATE)[step | 0];
    return (st && st.xp) ? st.xp : 0;
  }
  function _xpLatF(k) { return (k <= XP.kL) ? 0 : (k <= 2 ? (k - XP.kL) * 2 / (2 - XP.kL) : k); }
  /* ...and what waits for the walls moves once they are well out */
  function _xpLateF(k) { return (k <= XP.kL2) ? 0 : (k <= 2 ? (k - XP.kL2) * 2 / (2 - XP.kL2) : k); }
  /* A GRID THAT HOLDS, PER CELL, EACH BODY'S RANGE ALONG ONE AXIS. */
  function _xpGrid() { return { m: new Map() }; }
  /* while it is drawn a cell holds [body, centre lo, centre hi, raw lo, raw hi]
     per body; _xpFinal leaves [body, lo, hi] -- the centre's reading where
     the body has one, its raw points only where it has nothing else */
  function _xpPut(G, ku, kv, bi, w, raw, cover) {
    var key = (ku + 40000) * 80000 + (kv + 40000), c = G.m.get(key), o = raw ? 3 : 1;
    if (!c) { c = []; G.m.set(key, c); }
    var n = c.length, q = -1;
    if (n && c[n - 6] === bi) q = n - 6;
    else for (var t = 0; t < n; t += 6) if (c[t] === bi) { q = t; break; }
    if (q < 0) { c.push(bi, Infinity, -Infinity, Infinity, -Infinity, 0); q = n; }
    if (w < c[q + o]) c[q + o] = w; if (w > c[q + o + 1]) c[q + o + 1] = w;
    if (cover) c[q + 5] = 1;
  }
  /* ...and the final cell is [body, lo, hi, raw] per body (raw: 1 when only
     its own points were read there) */
  function _xpFinal(G) {
    G.m.forEach(function (c, key) {
      var d = [], q;
      for (q = 0; q < c.length; q += 6) {
        if (isFinite(c[q + 1])) d.push(c[q], c[q + 1], c[q + 2], c[q + 5] ? 0 : 2); else d.push(c[q], c[q + 3], c[q + 4], 1);
      }
      G.m.set(key, d);
    });
  }
  /* q wholly above (outward of) r in this cell, and its middle higher */
  function _xpOver(c, q, r) {
    var t = (c[q + 3] === 1 || c[r + 3] === 1) ? XP.rawTol : -XP.tol;
    return c[q + 1] >= c[r + 2] + t && c[q + 1] + c[q + 2] > c[r + 1] + c[r + 2];
  }
  /* triangles (flat world xyz) drawn into G: u, v the grid's coordinates and
     w the depth; every body read at the cell's centre, a triangle too thin for
     a centre by its corners and edge points (the house line's, unchanged) */
  function _xpRaster(G, tris, bi, U, V, W, H) {
    var q, A = tris;
    for (q = 0; q + 8 < A.length; q += 9) {
      var u0 = U(A, q), v0 = V(A, q), w0 = W(A, q), u1 = U(A, q + 3), v1 = V(A, q + 3), w1 = W(A, q + 3), u2 = U(A, q + 6), v2 = V(A, q + 6), w2 = W(A, q + 6);
      var den = (v1 - v2) * (u0 - u2) + (u2 - u1) * (v0 - v2), flat = Math.abs(den) < 1e-10, steep = flat, level = false;
      if (!flat) {
        var gu = ((v1 - v2) * w0 + (v2 - v0) * w1 + (v0 - v1) * w2) / den, gv = ((u2 - u1) * w0 + (u0 - u2) * w1 + (u1 - u0) * w2) / den;
        steep = Math.abs(gu) + Math.abs(gv) > 3;
        level = (Math.abs(gu) + Math.abs(gv)) * H * 0.5 <= 0.002;
      }
      var pts = [[u0, v0, w0], [u1, v1, w1], [u2, v2, w2]], e, t;
      for (e = 0; e < 3; e++) {
        var P = pts[e], Q = pts[(e + 1) % 3], L2 = Math.max(Math.abs(Q[0] - P[0]), Math.abs(Q[1] - P[1])), n = Math.floor(L2 / (H * 0.5));
        if (n > 4000) n = 4000;
        for (t = 0; t < Math.max(1, n); t++) {
          var f = t / Math.max(1, n), pu = P[0] + (Q[0] - P[0]) * f, pv = P[1] + (Q[1] - P[1]) * f, pw = P[2] + (Q[2] - P[2]) * f;
          var cu = Math.round(pu / H), cv = Math.round(pv / H);
          var rawP = steep, bMin = -1;
          if (!steep) {
            var cu2 = cu * H, cv2 = cv * H;
            var m0 = ((v1 - v2) * (cu2 - u2) + (u2 - u1) * (cv2 - v2)) / den, m1 = ((v2 - v0) * (cu2 - u2) + (u0 - u2) * (cv2 - v2)) / den;
            bMin = Math.min(m0, m1, 1 - m0 - m1);
            if (level || bMin >= -0.3) pw = m0 * w0 + m1 * w1 + (1 - m0 - m1) * w2; else rawP = true;
          }
          _xpPut(G, cu, cv, bi, pw, rawP, !rawP && bMin >= -0.05);   /* the body is there only if the centre is on it */
        }
      }
      if (flat) continue;
      var cu0 = Math.ceil(Math.min(u0, u1, u2) / H), cu1 = Math.floor(Math.max(u0, u1, u2) / H);
      var cv0 = Math.ceil(Math.min(v0, v1, v2) / H), cv1 = Math.floor(Math.max(v0, v1, v2) / H);
      if (cu1 < cu0 || cv1 < cv0 || (cu1 - cu0 + 1) * (cv1 - cv0 + 1) > 250000) continue;
      for (var cuu = cu0; cuu <= cu1; cuu++) for (var cvv = cv0; cvv <= cv1; cvv++) {
        var qu = cuu * H, qv = cvv * H;
        var l0 = ((v1 - v2) * (qu - u2) + (u2 - u1) * (qv - v2)) / den, l1 = ((v2 - v0) * (qu - u2) + (u0 - u2) * (qv - v2)) / den, l2 = 1 - l0 - l1;
        if (l0 < -1e-6 || l1 < -1e-6 || l2 < -1e-6) continue;
        _xpPut(G, cuu, cvv, bi, l0 * w0 + l1 * w1 + l2 * w2, false, true);   /* inside the triangle: its true depth at the centre */
      }
    }
  }
  /* the order a direction's groups must keep: votes 'a below b' from the
     cells, the stronger direction of each pair, then the strongest first,
     an edge left out where it would close a loop (the house line's) */
  function _xpDag(votes, nodes, small) {
    var par = {}, k, i, ord = [], inter = [], seen = {};
    for (i = 0; i < nodes.length; i++) par[nodes[i]] = nodes[i];
    function rt(x) { if (par[x] === undefined) par[x] = x; while (par[x] !== x) { par[x] = par[par[x]]; x = par[x]; } return x; }
    for (k in votes) {
      if (!votes.hasOwnProperty(k)) continue;
      var ab = k.split('>'), a = ab[0], b = ab[1];
      if (seen[b + '>' + a] || seen[k]) continue;
      seen[k] = true;
      var va = votes[k], vb = votes[b + '>' + a] || 0;
      var vMin = Math.min(va, vb), vMax = Math.max(va, vb);
      if (va >= 3 && vb >= 3 && (vMin >= 0.25 * vMax || (vMin >= 40 && vMin >= 0.1 * vMax))) { inter.push({ a: a, b: b, w: vMin }); continue; }
      var sm = small && (small[a] || small[b]);
      if (va > vb && (va - vb >= 2 || va >= 3 || (sm && !vb))) ord.push({ a: a, b: b, w: va - vb });
      else if (vb > va && (vb - va >= 2 || vb >= 3 || (sm && !va))) ord.push({ a: b, b: a, w: vb - va });
    }
    ord.sort(function (p, q) { return q.w - p.w; });
    inter.sort(function (p, q) { return q.w - p.w; });
    var out = {}, kept = 0, dropped = 0;
    function reach(from, to) {
      var st = [from], vis = {}, x, j;
      while (st.length) { x = st.pop(); if (x === to) return true; if (vis[x]) continue; vis[x] = true; var o = out[x] || []; for (j = 0; j < o.length; j++) st.push(o[j]); }
      return false;
    }
    var comp = {};
    function reachIn(from, to, cc) {
      var st = [from], vis = {}, x, j;
      while (st.length) { x = st.pop(); if (x === to) return true; if (vis[x]) continue; vis[x] = true; var o = out[x] || []; for (j = 0; j < o.length; j++) if (comp[o[j]] === cc) st.push(o[j]); }
      return false;
    }
    function build() {
      out = {}; kept = 0; dropped = 0; comp = {};
      var all = {}, E = [], seenE = {}, v;
      for (i = 0; i < nodes.length; i++) all[rt(nodes[i])] = all[rt(nodes[i])] || [];
      for (i = 0; i < ord.length; i++) {
        var ra = rt(ord[i].a), rb = rt(ord[i].b), ke = ra + '|' + rb;
        if (ra === rb || seenE[ke]) continue;
        seenE[ke] = 1;
        if (!all[ra]) all[ra] = []; if (!all[rb]) all[rb] = [];
        all[ra].push(rb); E.push([ra, rb]);
      }
      /* Tarjan, without recursion */
      var idx = {}, low = {}, onS = {}, S9 = [], cnt = 0, nc = 0;
      for (v in all) {
        if (!all.hasOwnProperty(v) || idx[v] !== undefined) continue;
        var stk = [[v, 0]]; idx[v] = low[v] = cnt++; S9.push(v); onS[v] = true;
        while (stk.length) {
          var tp = stk[stk.length - 1], x = tp[0], ch = all[x];
          if (tp[1] < ch.length) {
            var w = ch[tp[1]++];
            if (idx[w] === undefined) { idx[w] = low[w] = cnt++; S9.push(w); onS[w] = true; stk.push([w, 0]); }
            else if (onS[w] && idx[w] < low[x]) low[x] = idx[w];
          } else {
            stk.pop();
            if (stk.length) { var pr = stk[stk.length - 1][0]; if (low[x] < low[pr]) low[pr] = low[x]; }
            if (low[x] === idx[x]) { var wq; do { wq = S9.pop(); onS[wq] = false; comp[wq] = nc; } while (wq !== x); nc++; }
          }
        }
      }
      for (v in all) if (all.hasOwnProperty(v)) out[v] = [];
      for (i = 0; i < E.length; i++) {
        var a9 = E[i][0], b9 = E[i][1];
        if (comp[a9] !== comp[b9]) { out[a9].push(b9); kept++; continue; }
        if (reachIn(b9, a9, comp[a9])) { dropped++; continue; }
        out[a9].push(b9); kept++;
      }
    }
    build();
    var tied = 0, late = [];
    for (i = 0; i < inter.length; i++) {
      var ta = rt(inter[i].a), tb = rt(inter[i].b);
      if (ta === tb) continue;
      if (reach(ta, tb) || reach(tb, ta)) {
        var vA = votes[inter[i].a + '>' + inter[i].b] || 0, vB = votes[inter[i].b + '>' + inter[i].a] || 0;
        late.push(vA >= vB ? { a: inter[i].a, b: inter[i].b, w: 0 } : { a: inter[i].b, b: inter[i].a, w: 0 });
        continue;
      }
      par[ta] = tb; tied++;
      build();
    }
    for (i = 0; i < late.length; i++) {
      var la = rt(late[i].a), lb = rt(late[i].b);
      if (la === lb || out[la].indexOf(lb) >= 0 || reach(lb, la)) continue;
      out[la].push(lb); kept++;
    }
    return { out: out, kept: kept, dropped: dropped, root: rt, tied: tied };
  }
  /* the distances along a dag: each at least its base, and gap past every
     group it lies on */
  function _xpMags(D, base0, gap) {
    var indeg = {}, k, j, mag = {}, Q = [], done = 0, base = {};
    for (k in base0) if (base0.hasOwnProperty(k)) { var r0 = D.root(k); base[r0] = Math.max(base[r0] || 0, base0[k]); }
    for (k in D.out) if (D.out.hasOwnProperty(k)) { indeg[k] = indeg[k] || 0; for (j = 0; j < D.out[k].length; j++) indeg[D.out[k][j]] = (indeg[D.out[k][j]] || 0) + 1; }
    for (k in indeg) if (indeg.hasOwnProperty(k)) { mag[k] = base[k] || 0; if (!indeg[k]) Q.push(k); }
    while (Q.length) {
      var x = Q.shift(); done++;
      var o = D.out[x] || [];
      for (j = 0; j < o.length; j++) {
        if (mag[o[j]] < mag[x] + gap) mag[o[j]] = mag[x] + gap;
        if (--indeg[o[j]] === 0) Q.push(o[j]);
      }
    }
    for (k in base0) if (base0.hasOwnProperty(k)) mag[k] = mag[D.root(k)] !== undefined ? mag[D.root(k)] : base0[k];
    return mag;
  }
  /* THE PLAN: per body its place at rest, the way it goes and how far at
     k = 1 -- once per build (the house line's _asmSpread, for a coop) */
  function _xpPlan(G) {
    var T = global.THREE, i, j, k, out = [];
    if (!T || !G) return out;
    var P0 = _XP.plan;
    if (P0 && P0.G === G && P0.n === G.children.length && P0.c0 === G.children[0]) return P0.out;
    var now = function () { return (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(); }, t0 = now();
    var lv = G.userData.xpLv || {}, yFloor = isFinite(lv.yF) ? lv.yF : 0.35, yPlate = isFinite(lv.yP) ? lv.yP : yFloor + 1.0;
    var W2 = (lv.W || 2) / 2, L2 = (lv.L || 2) / 2, C = { x: 0, z: 0 }, aframe = !!lv.aframe;
    /* the footprint's four faces, the coop's outline: x-, x+, z-, z+ (the build's flyDir picks among them) */
    var SG = [
      { x0: -W2, z0: L2, x1: -W2, z1: -L2, len: 2 * L2, nx: -1, nz: 0 },
      { x0: W2, z0: -L2, x1: W2, z1: L2, len: 2 * L2, nx: 1, nz: 0 },
      { x0: -W2, z0: -L2, x1: W2, z1: -L2, len: 2 * W2, nx: 0, nz: -1 },
      { x0: W2, z0: L2, x1: -W2, z1: L2, len: 2 * W2, nx: 0, nz: 1 }
    ];
    var H = XP.cell, EPS = 0.02;
    /* ---- 1. every body: its place at rest, its triangles, its kind ---- */
    var B = [], RD = [], v3 = new T.Vector3(), nTri = 0, kept0 = [], ctx = [];
    G.children.forEach(function (m) {
      var ud = m.userData || {}, pt = ud.partType;
      if (pt && XP_FIXED[pt] && pt !== 'person') ctx.push(m);
      if (!pt || !ud.basePos || XP_FIXED[pt]) return;
      if (!_benchVisibleAtStep(m, 0)) return;
      kept0.push({ m: m, x: m.position.x, y: m.position.y, z: m.position.z });
      m.position.copy(ud.basePos);
    });
    G.updateMatrixWorld(true);
    kept0.forEach(function (it) {
      var m = it.m, ud = m.userData, pt = ud.partType, p = ud.basePos;
      var tris = [], lo = Infinity, hi = -Infinity, mnx = Infinity, mxx = -Infinity, mnz = Infinity, mxz = -Infinity;
      m.traverse(function (o) {
        if (!o.isMesh || o.isInstancedMesh || !o.geometry || !o.geometry.attributes || !o.geometry.attributes.position) return;
        var pa = o.geometry.attributes.position, ix = o.geometry.index, n = ix ? ix.count : pa.count, mw = o.matrixWorld, q;
        if (n > 180000) n = 180000 - (180000 % 3);
        var arr = new Float32Array(n * 3);
        for (q = 0; q < n; q++) {
          v3.fromBufferAttribute(pa, ix ? ix.getX(q) : q).applyMatrix4(mw);
          arr[q * 3] = v3.x; arr[q * 3 + 1] = v3.y; arr[q * 3 + 2] = v3.z;
          if (v3.y < lo) lo = v3.y; if (v3.y > hi) hi = v3.y;
          if (v3.x < mnx) mnx = v3.x; if (v3.x > mxx) mxx = v3.x; if (v3.z < mnz) mnz = v3.z; if (v3.z > mxz) mxz = v3.z;
        }
        tris.push(arr); nTri += n / 3;
      });
      if (!tris.length || !isFinite(lo)) { out.push({ m: m, p: p, v: { x: 0, y: 0, z: 0 }, l: { x: 0, y: 0, z: 0 } }); return; }
      /* the hardware rides with its piece: decided once the pieces are known */
      if (ud.driveDir || pt.indexOf('-hw-') >= 0 || (!ud.flyDir && XP_RIDE[pt]) || XP_RIDE_ALL[pt]) {
        RD.push({ m: m, p: p, ud: ud, x0: mnx, x1: mxx, y0: lo, y1: hi, z0: mnz, z1: mxz });
        return;
      }
      var fd = ud.flyDir, ax = fd ? Math.abs(fd[0]) : 0, ay = fd ? fd[1] : 0, az = fd ? Math.abs(fd[2]) : 0;
      var kind = { wall: !!fd && Math.max(ax, az) > 0.5 && Math.max(ax, az) >= Math.abs(ay), roof: !!fd && ay > 0.5 && ay > Math.max(ax, az) && !XP_FRAME[pt], fit: !!XP_FIT[pt], frame: !!XP_FRAME[pt] };
      var b = { m: m, p: p, st: XP_NEST[pt] ? -1 : _swingPartStep(pt), kind: kind, near: false, tris: tris, lo: lo, hi: hi, x0: mnx, x1: mxx, z0: mnz, z1: mxz,
                cx: (mnx + mxx) / 2, cz: (mnz + mxz) / 2, cls: '', faces: [], pt: pt };
      /* which way: a wall's piece out the way the build sends it in; the floor and under it down; the roof up */
      if (kind.wall) { b.cls = 'lat'; b.faces = [(ax >= az) ? ((fd[0] < 0) ? 0 : 1) : ((fd[2] < 0) ? 2 : 3)]; if (aframe && Math.abs(ay) > 0.3) b.roofLat = true; }   /* the tractor's hardware cloth on its slopes: a slope */
      else if (kind.frame) b.cls = 'lat';   /* the walls' framing: the face it lies along (below), none -> inside */
      else if (kind.roof && aframe && Math.abs(b.cx) > 0.12) { b.cls = 'lat'; b.faces = [(b.cx < 0) ? 0 : 1]; b.roofLat = true; }   /* the tractor: its slopes are its walls, down to the eave */
      else if (hi <= yFloor + EPS) b.cls = 'down';
      else if (kind.fit) b.cls = 'in';
      else if (kind.roof) b.cls = 'up';
      else if (lo >= yPlate - EPS) b.cls = 'up';
      else b.cls = 'lat';
      B.push(b);
    });
    /* the faces a lateral body with no direction of its own belongs to: the
       footprint's sides it lies along, not deep inside the plan */
    function riseFrom(b, g, dOut, dIn) {
      var span = dOut - dIn, yS = 0, nS = 0, yD = 0, nD = 0, t3, q3;
      if (b.hi - b.lo < 0.5 * span) return false;
      for (t3 = 0; t3 < b.tris.length; t3++) {
        var A3 = b.tris[t3];
        for (q3 = 0; q3 + 2 < A3.length; q3 += 3) {
          var d3 = (A3[q3] - g.x0) * g.nx + (A3[q3 + 2] - g.z0) * g.nz;
          if (d3 > dOut - 0.25 * span) { yS += A3[q3 + 1]; nS++; } else if (d3 < dIn + 0.25 * span) { yD += A3[q3 + 1]; nD++; }
        }
      }
      return nS > 0 && nD > 0 && (yD / nD - yS / nS) > 0.5 * span;
    }
    function facesOf(b) {
      var cand = [], s, k2;
      var corners = [[b.x0, b.z0], [b.x1, b.z0], [b.x0, b.z1], [b.x1, b.z1]];
      for (s = 0; s < SG.length; s++) {
        var g = SG[s], ux = (g.x1 - g.x0) / g.len, uz = (g.z1 - g.z0) / g.len, dOut = -Infinity, dIn = Infinity, a0 = Infinity, a1 = -Infinity;
        for (k2 = 0; k2 < 4; k2++) {
          var dx = corners[k2][0] - g.x0, dz = corners[k2][1] - g.z0, d = dx * g.nx + dz * g.nz, al = dx * ux + dz * uz;
          if (d > dOut) dOut = d; if (d < dIn) dIn = d; if (al < a0) a0 = al; if (al > a1) a1 = al;
        }
        if (a1 < -XP.band || a0 > g.len + XP.band) continue;
        if (dOut < -XP.band) continue;
        if (dIn < -XP.deep && !riseFrom(b, g, dOut, dIn)) continue;
        cand.push({ s: s, dOut: dOut, asp: (a1 - a0) / Math.max(0.01, dOut - dIn) });
      }
      cand.sort(function (p1, p2) { return Math.abs(p1.dOut) / Math.min(10, Math.max(0.1, p1.asp)) - Math.abs(p2.dOut) / Math.min(10, Math.max(0.1, p2.asp)); });
      var keep = [];
      for (k2 = 0; k2 < cand.length && keep.length < 2; k2++) {
        var gk = SG[cand[k2].s], par2 = false;
        for (var k3 = 0; k3 < keep.length; k3++) if (gk.nx * SG[keep[k3]].nx + gk.nz * SG[keep[k3]].nz > 0.5) par2 = true;
        if (keep.length && cand[0].asp >= 3) continue;
        if (!par2) keep.push(cand[k2].s);
      }
      return keep;
    }
    for (i = 0; i < B.length; i++) {
      var bb = B[i];
      if (bb.cls !== 'lat' || bb.faces.length) continue;
      bb.faces = facesOf(bb);
      if (!bb.faces.length) bb.cls = 'in';
    }
    var tm = [now()];
    /* ---- 2. the plan grid: up and down groups, and what rests on what ---- */
    var GP = _xpGrid(), Ux = function (A, q) { return A[q]; }, Vz = function (A, q) { return A[q + 2]; }, Wy = function (A, q) { return A[q + 1]; };
    for (i = 0; i < B.length; i++) for (j = 0; j < B[i].tris.length; j++) _xpRaster(GP, B[i].tris[j], i, Ux, Vz, Wy, H);
    _xpFinal(GP);
    /* riders: a body that is not going up but rests on one that is, rides
       up with it (iterated); a wall's own piece never rides (one storey) */
    var riders = 0, pass;
    for (pass = 0; pass < 4; pass++) {
      var on = {}, tot = {}, changed = false;
      GP.m.forEach(function (c) {
        var q, r;
        for (q = 0; q < c.length; q += 4) {
          var bq = B[c[q]];
          if (bq.cls === 'up' || bq.cls === 'down') continue;
          tot[c[q]] = (tot[c[q]] || 0) + 1;
          for (r = 0; r < c.length; r += 4) {
            var br = B[c[r]];
            if (br.cls !== 'up') continue;
            if (c[q + 1] >= c[r + 2] - 0.02 && c[q + 1] + c[q + 2] > c[r + 1] + c[r + 2] && c[q + 1] - c[r + 2] <= XP.rest) { on[c[q]] = (on[c[q]] || 0) + 1; break; }
          }
        }
      });
      for (i = 0; i < B.length; i++) {
        if (B[i].cls === 'up' || B[i].cls === 'down' || !tot[i] || B[i].kind.wall || B[i].kind.frame || B[i].roofLat) continue;
        if ((on[i] || 0) >= 0.5 * tot[i] && B[i].lo > yFloor + 0.5) {
          B[i].rider = true; B[i].latCls = B[i].cls; B[i].cls = 'up'; B[i].faces = []; riders++; changed = true;
        }
      }
      if (!changed) break;
    }
    var bvU = {}, bvD = {}, bvL = {}, bvLf = {};
    function vote(bv, a, b) { var kv2 = a + '>' + b; bv[kv2] = (bv[kv2] || 0) + 1; }
    /* the votes: in every cell, a group wholly above (up) or below (down)
       another must travel further; one thin thing round another -- the
       smaller sits on the other */
    GP.m.forEach(function (c) {
      var q, r;
      for (q = 0; q < c.length; q += 4) {
        var bq = B[c[q]], top = -1, encl = [];
        if (bq.cls !== 'up' && bq.cls !== 'down') continue;
        for (r = 0; r < c.length; r += 4) {
          if (q === r) continue;
          var br = B[c[r]];
          if (bq.st === br.st || bq.cls !== br.cls) continue;
          if (c[q + 2] - c[q + 1] <= 0.12 && c[q + 1] < c[r + 1] - XP.tol && c[q + 2] > c[r + 2] + XP.tol) {
            encl.push(r);
            if (top < 0 || (bq.cls === 'up' ? c[r + 2] > c[top + 2] : c[r + 1] < c[top + 1])) top = r;
            continue;
          }
          if (!_xpOver(c, q, r)) continue;
          if (bq.cls === 'up') vote(bvU, c[r], c[q]); else vote(bvD, c[q], c[r]);
        }
        for (r = 0; r < encl.length; r++) {
          var e5 = encl[r], bv5 = (bq.cls === 'up') ? bvU : bvD, be5 = B[c[e5]];
          var qSmall = (bq.x1 - bq.x0) * (bq.z1 - bq.z0) <= (be5.x1 - be5.x0) * (be5.z1 - be5.z0);
          if (bq.cls === 'up') { if (qSmall) vote(bv5, c[e5], c[q]); else vote(bv5, c[q], c[e5]); }
          else { if (qSmall) vote(bv5, c[q], c[e5]); else vote(bv5, c[e5], c[q]); }
        }
      }
    });
    tm.push(now());
    /* ---- 3. the faces: out groups along each side, and what an up or down
       group must clear before the walls move ---- */
    var GF = [], colX = {}, crossM = {}, blockF = {};
    for (k = 0; k < SG.length; k++) GF.push(_xpGrid());
    for (k = 0; k < SG.length; k++) {
      (function (g, G2, fI) {
        var ux = (g.x1 - g.x0) / g.len, uz = (g.z1 - g.z0) / g.len;
        var U = function (A, q) { return (A[q] - g.x0) * ux + (A[q + 2] - g.z0) * uz; };
        var V = function (A, q) { return A[q + 1]; };
        var W = function (A, q) { return (A[q] - g.x0) * g.nx + (A[q + 2] - g.z0) * g.nz; };
        var cornerBx = [];
        for (i = 0; i < B.length; i++) { var bc = B[i]; if (bc.faces.length > 1 && bc.faces.indexOf(fI) >= 0) cornerBx.push(bc); }
        var nearCorner = function (b) {
          for (var t = 0; t < cornerBx.length; t++) { var cb = cornerBx[t]; if (b.x0 <= cb.x1 + 0.5 && b.x1 >= cb.x0 - 0.5 && b.z0 <= cb.z1 + 0.5 && b.z1 >= cb.z0 - 0.5 && b.lo <= cb.hi && b.hi >= cb.lo) return true; }
          return false;
        };
        for (i = 0; i < B.length; i++) {
          var b4 = B[i], mine = b4.faces.indexOf(fI) >= 0;
          /* an up or down body: what the walls must clear -- every one (a coop's
             wall can stand inside its outline: the house's front in the run,
             with the run's roof outward of it); another wall's body near a
             corner piece going this way */
          if (!mine && b4.cls !== 'up' && b4.cls !== 'down' && !(b4.cls === 'lat' && b4.faces.length && nearCorner(b4))) continue;
          for (j = 0; j < b4.tris.length; j++) _xpRaster(G2, b4.tris[j], i, U, V, W, H);
        }
        _xpFinal(G2);
        G2.m.forEach(function (c, key) {
          var ku = Math.floor(key / 80000) - 40000, kv = (key % 80000) - 40000, q, r;
          for (q = 0; q < c.length; q += 4) {
            var ck = fI + ':' + c[q] + ':' + ku, e = colX[ck];
            if (!e) colX[ck] = [kv, kv]; else { if (kv < e[0]) e[0] = kv; if (kv > e[1]) e[1] = kv; }
          }
          for (q = 0; q < c.length; q += 4) {
            for (r = 0; r < c.length; r += 4) {
              if (q === r) continue;
              var bq = B[c[q]], br = B[c[r]];
              if (bq.st === br.st) continue;
              var qLat = bq.faces.indexOf(fI) >= 0 && (bq.cls === 'lat' || bq.rider), rLat = br.faces.indexOf(fI) >= 0 && (br.cls === 'lat' || br.rider);
              if (!_xpOver(c, q, r)) continue;   /* q wholly outward of r in this cell */
              if (rLat && br.faces.length > 1 && !br.near && bq.cls === 'lat' && bq.faces.length && bq.faces.indexOf(fI) < 0 && !bq.near) { var bk = blockF[c[r]] || (blockF[c[r]] = {}); bk[fI] = (bk[fI] || 0) + 1; continue; }
              if (qLat && rLat) { vote(bvL, c[r], c[q]); var kf = c[r] + '>' + c[q] + '@' + fI; bvLf[kf] = (bvLf[kf] || 0) + 1; }
              /* an up / down body outward of a wall body at the same height:
                 it has to be out of the wall's way before the wall moves */
              else if (rLat && (bq.cls === 'up' || bq.cls === 'down') && !bq.rider) crossM[c[r] + ',' + c[q] + ',' + fI + ':' + ku] = 1;
            }
          }
        });
      })(SG[k], GF[k], k);
    }
    tm.push(now());
    var bf;
    for (bf in blockF) {
      if (!blockF.hasOwnProperty(bf)) continue;
      var bB = B[+bf], keepF = bB.faces.filter(function (f2) { return !((blockF[bf][f2] || 0) >= 2); });
      if (keepF.length < bB.faces.length) bB.faces = keepF.length ? keepF : [bB.faces[0]];
    }
    /* ---- 4. the groups that move as one: an item, unless its bodies lie on
       both sides of another item ---- */
    var split = {}, nSplit = 0;
    function conflicts(bv) {
      var side = {}, kk3;
      for (kk3 in bv) {
        if (!bv.hasOwnProperty(kk3) || bv[kk3] < 3) continue;
        var ab3 = kk3.split('>'), a3 = +ab3[0], b3 = +ab3[1];
        var ka = a3 + ':' + B[b3].st, kb = b3 + ':' + B[a3].st;
        side[ka] = (side[ka] || 0) + bv[kk3];
        side[kb] = (side[kb] || 0) - bv[kk3];
      }
      var seen = {}, kk4;
      for (kk4 in side) {
        if (!side.hasOwnProperty(kk4) || Math.abs(side[kk4]) < 3) continue;
        var p4 = kk4.split(':'), st4 = B[+p4[0]].st, key4 = st4 + ':' + p4[1], sg4 = side[kk4] > 0 ? 1 : 2;
        seen[key4] = (seen[key4] || 0) | sg4;
        if (seen[key4] === 3 && !split[st4]) { split[st4] = true; nSplit++; }
      }
    }
    conflicts(bvU); conflicts(bvD); conflicts(bvL);
    var vU = {}, vD = {}, vL = {}, baseU = {}, baseD = {}, baseL = {}, nodesU = [], nodesD = [], nodesL = [];
    for (i = 0; i < B.length; i++) {
      var bn2 = B[i], tag2 = split[bn2.st] ? ('b' + i) : ('s' + bn2.st);
      bn2.nU = 'u' + tag2; bn2.nD = 'd' + tag2;
      bn2.nL = 'l' + ((split[bn2.st] || bn2.faces.length > 1) ? ('b' + i) : (tag2 + ':' + bn2.faces.join('/')));
      bn2.nLf = {};
      if (bn2.cls === 'up') { if (baseU[bn2.nU] === undefined) { baseU[bn2.nU] = Infinity; nodesU.push(bn2.nU); } baseU[bn2.nU] = Math.min(baseU[bn2.nU], bn2.lo); }
      if (bn2.cls === 'down') { if (baseD[bn2.nD] === undefined) { baseD[bn2.nD] = -Infinity; nodesD.push(bn2.nD); } baseD[bn2.nD] = Math.max(baseD[bn2.nD], bn2.hi); }
      if (bn2.cls === 'lat' || (bn2.rider && bn2.faces.length)) {
        for (j = 0; j < bn2.faces.length; j++) {
          var nf2 = bn2.nL + '@' + bn2.faces[j];
          bn2.nLf[bn2.faces[j]] = nf2;
          if (baseL[nf2] === undefined) { baseL[nf2] = Infinity; nodesL.push(nf2); }
          var g2 = SG[bn2.faces[j]], dIn3 = Math.min(
            (bn2.x0 - C.x) * g2.nx + (bn2.z0 - C.z) * g2.nz, (bn2.x1 - C.x) * g2.nx + (bn2.z0 - C.z) * g2.nz,
            (bn2.x0 - C.x) * g2.nx + (bn2.z1 - C.z) * g2.nz, (bn2.x1 - C.x) * g2.nx + (bn2.z1 - C.z) * g2.nz);
          baseL[nf2] = Math.min(baseL[nf2], Math.max(0, dIn3));
        }
      }
    }
    for (k = 0; k < nodesU.length; k++) baseU[nodesU[k]] = XP.min0 + EXPLODE_GAIN * Math.max(0, baseU[nodesU[k]] - yFloor);
    for (k = 0; k < nodesD.length; k++) baseD[nodesD[k]] = XP.min0 + EXPLODE_GAIN * Math.max(0, yFloor - baseD[nodesD[k]]);
    for (k = 0; k < nodesL.length; k++) baseL[nodesL[k]] = XP.min0 + EXPLODE_GAIN * (isFinite(baseL[nodesL[k]]) ? baseL[nodesL[k]] : 0);
    function nodeVotes(bv, V, f) {
      var kk5;
      for (kk5 in bv) {
        if (!bv.hasOwnProperty(kk5)) continue;
        var ab5 = kk5.split('>'), na = B[+ab5[0]][f], nb = B[+ab5[1]][f];
        if (na === nb) continue;
        V[na + '>' + nb] = (V[na + '>' + nb] || 0) + bv[kk5];
      }
    }
    nodeVotes(bvU, vU, 'nU'); nodeVotes(bvD, vD, 'nD');
    var kk9;
    for (kk9 in bvLf) {
      if (!bvLf.hasOwnProperty(kk9)) continue;
      var m8 = kk9.split(/[>@]/), na8 = B[+m8[0]].nLf[m8[2]], nb8 = B[+m8[1]].nLf[m8[2]];
      if (!na8 || !nb8 || na8 === nb8) continue;
      vL[na8 + '>' + nb8] = (vL[na8 + '>' + nb8] || 0) + bvLf[kk9];
    }
    /* ---- 5. the distances ---- */
    var cellsU = {}, cellsL = {}, smallU = {}, smallL = {};
    GP.m.forEach(function (c) { for (var q = 0; q < c.length; q += 4) { var bq = B[c[q]]; cellsU[bq.nU] = (cellsU[bq.nU] || 0) + 1; cellsU[bq.nD] = (cellsU[bq.nD] || 0) + 1; } });
    for (k = 0; k < SG.length; k++) GF[k].m.forEach(function (c) { for (var q = 0; q < c.length; q += 4) { var nq = B[c[q]].nLf && B[c[q]].nLf[k]; if (nq) cellsL[nq] = (cellsL[nq] || 0) + 1; } });
    for (k in cellsU) if (cellsU.hasOwnProperty(k) && cellsU[k] <= 4) smallU[k] = true;
    for (k in cellsL) if (cellsL.hasOwnProperty(k) && cellsL[k] <= 4) smallL[k] = true;
    var DU = _xpDag(vU, nodesU, smallU), DD = _xpDag(vD, nodesD, smallU), DL = _xpDag(vL, nodesL, smallL);
    var magU = _xpMags(DU, baseU, XP.gap), magD = _xpMags(DD, baseD, XP.gap), magL = _xpMags(DL, baseL, XP.gap);
    /* WHAT WAITS FOR THE WALLS: a body going up with a wall's body over it
       waits until the walls are out (k = XP.kL2), and so does everything
       under it in the order; the wall body over it goes out far enough by
       then to be off it. Down the same way, under a wall body. */
    var lateU = {}, lateD = {}, needLate = {}, nLate = 0, fL2 = _xpLatF(XP.kL2), lateC = {}, lateP = {}, needy = {}, cr0;
    for (cr0 in crossM) if (crossM.hasOwnProperty(cr0)) { var vb0 = B[+cr0.split(',')[1]]; needy[vb0.cls === 'up' ? DU.root(vb0.nU) : DD.root(vb0.nD)] = true; }
    GP.m.forEach(function (c) {
      var q, r;
      for (q = 0; q < c.length; q += 4) {
        var bq = B[c[q]];
        if (bq.cls !== 'up' && bq.cls !== 'down') continue;
        for (r = 0; r < c.length; r += 4) {
          var br = B[c[r]];
          if (br.cls !== 'lat' || br.near || !br.faces.length || br.st === bq.st || c[r + 3] || c[q + 3]) continue;
          if (br.x1 - br.x0 < 0.03 || br.z1 - br.z0 < 0.03) continue;
          if (bq.cls === 'up' ? !_xpOver(c, r, q) : !_xpOver(c, q, r)) continue;
          var nq9 = bq.cls === 'up' ? bq.nU : bq.nD;
          if (needy[bq.cls === 'up' ? DU.root(nq9) : DD.root(nq9)]) continue;
          lateC[nq9] = (lateC[nq9] || 0) + 1;
          (lateP[nq9] = lateP[nq9] || {})[c[r]] = c[q];
        }
      }
    });
    var nq8, rb8, f9;
    for (nq8 in lateC) {
      if (!lateC.hasOwnProperty(nq8) || lateC[nq8] < 3) continue;
      for (rb8 in lateP[nq8]) {
        if (!lateP[nq8].hasOwnProperty(rb8)) continue;
        var br8 = B[+rb8], bq8 = B[lateP[nq8][rb8]];
        if (nq8.charAt(0) === 'u') { if (!lateU[nq8]) lateU[nq8] = rb8 + ' over ' + lateP[nq8][rb8]; } else if (!lateD[nq8]) lateD[nq8] = rb8 + ' under ' + lateP[nq8][rb8];
        for (f9 = 0; f9 < br8.faces.length; f9++) {
          var g9 = SG[br8.faces[f9]], nm9 = br8.nLf[br8.faces[f9]];
          var dq9 = function (x, z) { return (x - g9.x0) * g9.nx + (z - g9.z0) * g9.nz; };
          var qMax = Math.max(dq9(bq8.x0, bq8.z0), dq9(bq8.x1, bq8.z0), dq9(bq8.x0, bq8.z1), dq9(bq8.x1, bq8.z1));
          var rMin = Math.min(dq9(br8.x0, br8.z0), dq9(br8.x1, br8.z0), dq9(br8.x0, br8.z1), dq9(br8.x1, br8.z1));
          var nl = (qMax - rMin + XP.clear) / fL2;
          if (nl > (needLate[nm9] || 0)) needLate[nm9] = nl;
        }
      }
    }
    var nLateOff = 0;
    function lateDown(D, late) {
      var preds = {}, a9, Q9 = [], seen9 = {};
      for (a9 in D.out) if (D.out.hasOwnProperty(a9)) D.out[a9].forEach(function (b9) { (preds[b9] = preds[b9] || []).push(a9); });
      /* (a coop's own) a group with one that must clear the walls first on
         its near side in the order does not wait: it would wait in that
         one's way (the ground screws under the U heads round the posts) */
      function needyBefore(r9) {
        var st9 = [r9], vis9 = {}, x9;
        while (st9.length) { x9 = st9.pop(); if (vis9[x9]) continue; vis9[x9] = true; if (x9 !== r9 && needy[x9]) return true; (preds[x9] || []).forEach(function (p9) { st9.push(p9); }); }
        return false;
      }
      for (a9 in late) if (late.hasOwnProperty(a9)) { var r9 = D.root(a9); if (!seen9[r9] && needyBefore(r9)) { nLateOff++; continue; } if (!seen9[r9]) { seen9[r9] = true; Q9.push(r9); } }
      while (Q9.length) { var x9 = Q9.pop(); (preds[x9] || []).forEach(function (p9) { if (!seen9[p9] && !needy[p9]) { seen9[p9] = true; Q9.push(p9); } }); }
      return seen9;
    }
    var lateRU = lateDown(DU, lateU), lateRD = lateDown(DD, lateD);
    for (k in needLate) if (needLate.hasOwnProperty(k) && needLate[k] > (baseL[k] || 0)) baseL[k] = needLate[k];
    magL = _xpMags(DL, baseL, XP.gap);
    for (i = 0; i < B.length; i++) {
      var bL = B[i];
      bL.late = (bL.cls === 'up' && !!lateRU[DU.root(bL.nU)]) || (bL.cls === 'down' && !!lateRD[DD.root(bL.nD)]);
      if (bL.late) nLate++;
    }
    /* what has to be cleared before the walls move (at k = XP.kL) */
    var raised = 0, cr, needU = {}, needD = {};
    for (cr in crossM) {
      if (!crossM.hasOwnProperty(cr)) continue;
      var cx3 = cr.split(','), sB = B[+cx3[0]], vB = B[+cx3[1]], col = cx3[2].split(':');
      var es = colX[col[0] + ':' + cx3[0] + ':' + col[1]], ev = colX[col[0] + ':' + cx3[1] + ':' + col[1]];
      if (!es || !ev) continue;
      if (sB.rider || vB.late) continue;
      if (vB.cls === 'up') {
        var nu = (es[1] * H - ev[0] * H + XP.clear) / XP.kL;
        if (nu > (needU[vB.nU] || 0)) needU[vB.nU] = nu;
      } else {
        var nd = (ev[1] * H - es[0] * H + XP.clear) / XP.kL;
        if (nd > (needD[vB.nD] || 0)) needD[vB.nD] = nd;
      }
    }
    for (k in needU) if (needU.hasOwnProperty(k) && needU[k] > (baseU[k] || 0)) { baseU[k] = needU[k]; raised++; }
    for (k in needD) if (needD.hasOwnProperty(k) && needD[k] > (baseD[k] || 0)) { baseD[k] = needD[k]; raised++; }
    if (raised) { magU = _xpMags(DU, baseU, XP.gap); magD = _xpMags(DD, baseD, XP.gap); }
    /* A GROUP WITH NO ORDER OF ITS OWN GOES WITH WHAT IT IS BUILT INTO: it
       takes the furthest of the wall's layers it shares its depth with */
    var linked = {}, kk2;
    for (kk2 in vL) if (vL.hasOwnProperty(kk2)) { var ab2 = kk2.split('>'); linked[ab2[0]] = linked[ab2[1]] = true; }
    var hostL = {};
    for (k = 0; k < SG.length; k++) {
      GF[k].m.forEach(function (c) {
        var q, r;
        for (q = 0; q < c.length; q += 4) {
          var bq = B[c[q]], nq = bq.nLf && bq.nLf[k];
          if (!nq || linked[nq] || bq.near || bq.cls !== 'lat' || !bq.faces.length) continue;
          for (r = 0; r < c.length; r += 4) {
            var br = B[c[r]], nr = br.nLf && br.nLf[k];
            if (!nr || r === q || br.st === bq.st || br.near || br.cls !== 'lat' || !br.faces.length || !linked[nr]) continue;
            if (c[r + 2] < c[q + 1] - XP.tol || c[r + 1] > c[q + 2] + XP.tol) continue;
            if ((magL[nr] || 0) > (hostL[nq] || 0)) hostL[nq] = magL[nr];
          }
        }
      });
    }
    var hosted = 0;
    for (kk2 in hostL) if (hostL.hasOwnProperty(kk2) && hostL[kk2] > (magL[kk2] || 0) - 1e-6) { magL[kk2] = hostL[kk2]; hosted++; }
    /* AN ITEM TAKEN APART STAYS TOGETHER WHERE IT CAN */
    var joined = 0;
    function together(cls, D, mag, nodeOf) {
      var st6, ids, pr6, top6;
      var rt6 = function (x) { while (pr6[x] !== x) { pr6[x] = pr6[pr6[x]]; x = pr6[x]; } return x; };
      for (st6 in split) {
        if (!split.hasOwnProperty(st6)) continue;
        ids = []; pr6 = {}; top6 = {};
        for (i = 0; i < B.length; i++) if (B[i].st === +st6 && B[i].cls === cls && !B[i].near && nodeOf(B[i])) { ids.push(i); pr6[i] = i; }
        if (ids.length < 2 || ids.length > 400) continue;
        for (i = 0; i < ids.length; i++) for (j = i + 1; j < ids.length; j++) {
          var p6 = B[ids[i]], q6 = B[ids[j]], t6 = 0.02;
          if (p6.x0 > q6.x1 + t6 || q6.x0 > p6.x1 + t6 || p6.z0 > q6.z1 + t6 || q6.z0 > p6.z1 + t6 || p6.lo > q6.hi + t6 || q6.lo > p6.hi + t6) continue;
          if (cls === 'lat' && p6.faces.join() !== q6.faces.join()) continue;
          pr6[rt6(ids[i])] = rt6(ids[j]);
        }
        for (i = 0; i < ids.length; i++) { var r6 = rt6(ids[i]), mv = mag[nodeOf(B[ids[i]])] || 0; if (!(top6[r6] >= mv)) top6[r6] = mv; }
        for (i = 0; i < ids.length; i++) {
          var n6 = nodeOf(B[ids[i]]), want = top6[rt6(ids[i])], cur = mag[n6] || 0;
          if (want <= cur + 1e-6 || D.root(n6) !== n6) continue;
          var o6 = D.out[n6] || [], lim = want;
          for (j = 0; j < o6.length; j++) lim = Math.min(lim, (mag[o6[j]] || 0) - XP.gap);
          if (lim > cur + 1e-6) { mag[n6] = lim; joined++; }
        }
      }
    }
    together('up', DU, magU, function (b) { return b.nU; }); together('down', DD, magD, function (b) { return b.nD; });
    for (k = 0; k < SG.length; k++) together('lat', DL, magL, function (b) { return (b.nLf && b.nLf[k]) || null; });
    /* ---- 6. the vectors ---- */
    var nUp = 0, nDown = 0, nLat = 0, nIn = 0;
    for (i = 0; i < B.length; i++) {
      var b5 = B[i], v = { x: 0, y: 0, z: 0 }, l = { x: 0, y: 0, z: 0 }, f;
      if (b5.cls === 'up') { v.y = magU[b5.nU] || XP.min0; nUp++; }
      else if (b5.cls === 'down') { v.y = -(magD[b5.nD] || XP.min0); nDown++; }
      if ((b5.cls === 'lat' || b5.rider) && b5.faces.length) {
        for (f = 0; f < b5.faces.length; f++) { var mL = magL[b5.nLf[b5.faces[f]]] || XP.min0; l.x += SG[b5.faces[f]].nx * mL; l.z += SG[b5.faces[f]].nz * mL; }
        /* (a coop's own) the tractor's slopes go out from the start, as a roof
           goes up: moving out they rise over what is under them (its collar
           ties going up, the nests going out after them) */
        if (b5.roofLat) { v.x = l.x; v.z = l.z; l = { x: 0, y: 0, z: 0 }; }
        nLat++;
      } else if (b5.cls === 'in') nIn++;
      b5.e = { m: b5.m, p: b5.p, v: v, l: l, late: !!b5.late };
      out.push(b5.e);
    }
    /* ---- 7. THE HARDWARE RIDES WITH ITS PIECE (the coop's own: the house
       line draws no screws): a screw or a nail with the piece its head sits
       in -- the first one along its shank --, a hinge, knob, catch or bolt
       with the smallest piece round its middle ---- */
    var ray = new T.Raycaster(), nRide = 0, nLoose = 0, d3 = new T.Vector3(), o3 = new T.Vector3();
    try { ray.params.Line.threshold = 0.0001; if (ray.params.Points) ray.params.Points.threshold = 0.0001; } catch (eRp) {}   /* the edge lines are not the wood */
    function inBox(b, x, y, z, e) { return x >= b.x0 - e && x <= b.x1 + e && y >= b.lo - e && y <= b.hi + e && z >= b.z0 - e && z <= b.z1 + e; }
    function vol(b) { return Math.max(1e-6, b.x1 - b.x0) * Math.max(1e-6, b.hi - b.lo) * Math.max(1e-6, b.z1 - b.z0); }
    for (i = 0; i < RD.length; i++) {
      var r1 = RD[i], dd = r1.ud.driveDir, host = null, cand = [], px, py, pz;
      if (dd) { px = r1.p.x - dd[0] * 0.006; py = r1.p.y - dd[1] * 0.006; pz = r1.p.z - dd[2] * 0.006; }
      else { px = (r1.x0 + r1.x1) / 2; py = (r1.y0 + r1.y1) / 2; pz = (r1.z0 + r1.z1) / 2; }
      for (j = 0; j < B.length; j++) if (inBox(B[j], px, py, pz, dd ? 0.002 : 0.012)) cand.push(B[j]);
      if (cand.length > 1 && dd) {
        try {
          o3.set(r1.p.x + dd[0] * 0.004, r1.p.y + dd[1] * 0.004, r1.p.z + dd[2] * 0.004); d3.set(-dd[0], -dd[1], -dd[2]);
          ray.set(o3, d3); ray.far = (r1.ud.driveLen || 0.1) + 0.01;
          var hits = ray.intersectObjects(cand.map(function (cb) { return cb.m; }), true);
          for (j = 0; j < hits.length && !host; j++) {
            if (!hits[j].object || !hits[j].object.isMesh) continue;
            var ho = hits[j].object; while (ho && ho.parent !== G) ho = ho.parent;
            for (k = 0; k < cand.length; k++) if (cand[k].m === ho) { host = cand[k]; break; }
          }
        } catch (eR) { host = null; }
      }
      if (!host && cand.length) { host = cand[0]; for (j = 1; j < cand.length; j++) if (vol(cand[j]) < vol(host)) host = cand[j]; }
      if (!host) {
        var bd = 0.05;
        for (j = 0; j < B.length; j++) {
          var bj = B[j], ddx = Math.max(bj.x0 - px, 0, px - bj.x1), ddy = Math.max(bj.lo - py, 0, py - bj.hi), ddz = Math.max(bj.z0 - pz, 0, pz - bj.z1), dist = Math.sqrt(ddx * ddx + ddy * ddy + ddz * ddz);
          if (dist < bd) { bd = dist; host = bj; }
        }
      }
      if (host) { out.push({ m: r1.m, p: r1.p, v: host.e.v, l: host.e.l, late: host.e.late, host: host.pt }); nRide++; }
      else { out.push({ m: r1.m, p: r1.p, v: { x: 0, y: 0, z: 0 }, l: { x: 0, y: 0, z: 0 } }); nLoose++; }
    }
    kept0.forEach(function (it) { it.m.position.set(it.x, it.y, it.z); });
    G.updateMatrixWorld(true);
    var t1 = now();
    _XP.info = 'explode  ' + B.length + ' bodies (' + Math.round(nTri / 1000) + 'k triangles) from the floor centroid ' + C.x.toFixed(2) + ',' + C.z.toFixed(2) +
               ' at +' + yFloor.toFixed(2) + ': ' + nUp + ' up (' + riders + ' riding on what goes up, ' + nLate + ' waiting for the walls), ' + nDown + ' down, ' + nLat + ' out square to their wall, ' + nIn + ' inside stay; ' +
               nRide + ' screws / nails / hinges riding with their piece' + (nLoose ? ' (' + nLoose + ' with none, stay)' : '') + '; ' + (nLateOff ? nLateOff + ' not waiting (what clears the walls first is before them); ' : '') +
               nSplit + ' item(s) placed piece by piece (' + joined + ' piece(s) kept with the rest of the item), order kept up ' + DU.kept + ' / down ' + DD.kept + ' / out ' + DL.kept + ' (left out to break loops ' + (DU.dropped + DD.dropped + DL.dropped) + ', tied together ' + (DU.tied + DD.tied + DL.tied) + ', ' + hosted + ' with the wall they are built into), ' + raised + ' lifted to clear the walls first; ' +
               Math.round(t1 - t0) + ' ms (bodies ' + Math.round(tm[0] - t0) + ', plan ' + Math.round(tm[1] - tm[0]) + ', walls ' + Math.round(tm[2] - tm[1]) + ', order ' + Math.round(t1 - tm[2]) + ') (' + VERSION + ')';
    _dbg('[xp] ' + _XP.info);
    out.ctx = ctx;   /* the house the lean-to stands at: out of the way while the coop is apart (the pieces of its wall side go through it) */
    _XP.plan = { G: G, n: G.children.length, c0: G.children[0], out: out };
    if (global.__XPDBG) global.__XPDBG = { B: B, SG: SG, magU: magU, magD: magD, magL: magL, DU: DU, DD: DD, DL: DL, crossM: crossM, out: out, lateU: lateU, lateD: lateD, needy: needy };
    return out;
  }
  /* the bodies at k (the house line's put) */
  function _xpPutK(sp, kk) {
    _XP.shown = kk;
    var fl = _xpLatF(kk), fw = _xpLateF(kk), i;
    for (i = 0; i < sp.length; i++) { var e = sp[i], fv = e.late ? fw : kk; e.m.position.set(e.p.x + e.v.x * fv + e.l.x * fl, e.p.y + e.v.y * fv + e.l.y * fl, e.p.z + e.v.z * fv + e.l.z * fl); }
    if (sp.ctx) for (i = 0; i < sp.ctx.length; i++) sp.ctx[i].visible = (kk < 0.005);
  }
  function _xpStop() {
    if (_XP.anim) { try { global.cancelAnimationFrame(_XP.anim); } catch (e) {} _XP.anim = 0; }
  }
  /* THE EXPLODED VIEW AT k (the house line's setExplode): from where it is
     shown, eased in and out over 2.6 s; the camera backs off along its own
     line of sight so the whole exploded coop is in the frame, or slides back
     to the pose handed in (step 2). A coop's own: the fit is the exploded
     box's corners in the view (the house line's 70 percent of a sphere cut
     the cupola's stack off at the top), and the target moves to the box's
     middle with it */
  function _xpSet(k, animate, camHome) {
    var T = global.THREE, eng = global.BenchEngine, G = eng && eng.benchGroup;
    if (!T || !G) return 0;
    _xpStop();
    var from = _XP.shown;
    _XP.k = Math.max(0, Math.min(XP.max, Number(k) || 0));
    var sp = _xpPlan(G);
    if (!animate) { _xpPutK(sp, _XP.k); _xpSliderShow(_XP.k); return _XP.k; }
    var to = _XP.k, camA = null, camB = null, cam = eng.camera, ctl = eng.controls;
    try {
      if (camHome && cam && ctl && ctl.target && camHome.pos && camHome.tg) {
        camB = { cam: cam, ctl: ctl, p0: cam.position.clone(), p1: camHome.pos.clone(), t0: ctl.target.clone(), t1: camHome.tg.clone() };
      }
    } catch (eH) { camB = null; }
    try {
      if (!camB && cam && ctl && ctl.target && cam.isPerspectiveCamera && STATE.view !== '2d') {
        var tg = ctl.target, d0 = cam.position.distanceTo(tg);
        _xpPutK(sp, to);
        G.updateMatrixWorld(true);
        var bx = new T.Box3();
        sp.forEach(function (e) { if (e.m.visible) bx.expandByObject(e.m); });
        _xpPutK(sp, from);
        var dirC = new T.Vector3().subVectors(cam.position, tg).normalize(), tg1 = tg.clone(), need = d0;
        if (!bx.isEmpty() && to > 0) {
          bx.getCenter(tg1);
          var tv = Math.tan((cam.fov || 45) * Math.PI / 360) * 0.86, th = tv * (cam.aspect || 1);
          var rgt = new T.Vector3().crossVectors(dirC, new T.Vector3(0, 1, 0)).negate().normalize(), upv = new T.Vector3().crossVectors(rgt, dirC).negate().normalize(), q4 = new T.Vector3(), ix, iy, iz;
          if (rgt.lengthSq() < 0.5) rgt.set(1, 0, 0);
          for (ix = 0; ix < 2; ix++) for (iy = 0; iy < 2; iy++) for (iz = 0; iz < 2; iz++) {
            q4.set(ix ? bx.max.x : bx.min.x, iy ? bx.max.y : bx.min.y, iz ? bx.max.z : bx.min.z).sub(tg1);
            var zb = q4.dot(dirC);
            need = Math.max(need, zb + Math.abs(q4.dot(upv)) / tv, zb + Math.abs(q4.dot(rgt)) / th);
          }
        }
        camA = { dir: dirC, d0: d0, d1: Math.max(d0, need), tg: tg.clone(), tg1: tg1, cam: cam, ctl: ctl };
        if (ctl.maxDistance < camA.d1 * 1.2) ctl.maxDistance = camA.d1 * 1.2;   /* the orbit's limit (15 m) would hold the camera in */
        if (cam.far < camA.d1 * 3) { cam.far = camA.d1 * 3; cam.updateProjectionMatrix(); }
      }
    } catch (eC) { camA = null; }
    var t0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(), DUR = 2600 * _tourAsmSpeed();
    function tick() {
      var nw = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      var u = Math.min(1, (nw - t0) / DUR), e2 = (u < 0.5) ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;   /* ease in and out */
      var kk = from + (to - from) * e2;
      _xpPutK(sp, kk);
      if (camA) { var dd = camA.d0 + (camA.d1 - camA.d0) * e2; camA.ctl.target.lerpVectors(camA.tg, camA.tg1, e2); camA.cam.position.copy(camA.ctl.target).addScaledVector(camA.dir, dd); camA.cam.lookAt(camA.ctl.target); }
      if (camB) { camB.cam.position.lerpVectors(camB.p0, camB.p1, e2); camB.ctl.target.lerpVectors(camB.t0, camB.t1, e2); camB.cam.lookAt(camB.ctl.target); }
      _xpSliderShow(kk);
      if (u < 1) _XP.anim = global.requestAnimationFrame(tick); else _XP.anim = 0;
    }
    _XP.anim = global.requestAnimationFrame(tick);
    return _XP.k;
  }
  /* the slider: on the walk's step 1 only, the value follows the animation */
  var _xpGuard = false;
  function _xpSliderEl() { return (typeof document !== 'undefined') ? document.getElementById('cf-bench-explode') : null; }
  function _xpPaint(r, v) {
    var mn = parseFloat(r.min) || 0, mx = parseFloat(r.max) || 4, pct = ((v - mn) / Math.max(1e-6, mx - mn)) * 100;
    r.style.background = 'linear-gradient(to right, #c79a4a 0%, #c79a4a ' + pct + '%, rgba(0,0,0,0.10) ' + pct + '%, rgba(0,0,0,0.10) 100%)';
  }
  function _xpSliderShow(v) {
    var r = _xpSliderEl();
    if (!r) return;
    _xpGuard = true;
    r.value = String(Math.round(v * 20) / 20);
    _xpPaint(r, v);
    _xpGuard = false;
  }
  function _xpSliderSync() {
    var r = _xpSliderEl(), row = (typeof document !== 'undefined') ? document.getElementById('cf-bench-explode-row') : null;
    if (!r || !row) return;
    if (!_XP.wired) {
      _XP.wired = true;
      r.addEventListener('input', function () {
        if (_xpGuard) return;   /* our own set, not the user's hand */
        var v = parseFloat(this.value);
        if (!isFinite(v) || _xpHeadStep(STATE.assemblyStep) !== 1) return;
        _xpSet(v, false);
      });
      r.addEventListener('change', function () { _dbg('[xp] explode -> ' + _XP.k.toFixed(2)); });
    }
    var on = _isStagedType(STATE.variant) && _xpHeadStep(STATE.assemblyStep) === 1 && STATE.view !== '2d';
    row.classList.toggle('cf-visible', on);
    if (on) _xpSliderShow(_XP.shown);
  }
  /* after a step is applied (the build's, the walk's): at the exploded step
     the bodies stay where they are shown (a rebuild re-plans them), back
     together on the next; anywhere else the explosion is off */
  function _xpAfterStep(G, step) {
    var xs = _isStagedType(STATE.variant) ? _xpHeadStep(step) : 0;
    _xpStop();
    if (!xs) { _XP.shown = 0; return; }
    _xpPutK(_xpPlan(G), _XP.shown);
  }
  /* the walk: step 1 rolls apart to the slider's value (the default the
     first time), the camera's pose kept for step 2; step 2 back together
     and the camera home */
  function _xpWalk(prev, nxt) {
    var xs = _xpHeadStep(nxt), eng = global.BenchEngine;
    if (xs === 1) {
      try { _XP.camHome = (eng && eng.camera && eng.controls && eng.controls.target) ? { pos: eng.camera.position.clone(), tg: eng.controls.target.clone() } : null; } catch (eC) { _XP.camHome = null; }
      _xpSet(XP.def, true);
      _dbg('[xp] walk 1/' + (_swingActiveSteps(STATE).length - 1) + ': the exploded view (k ' + XP.def + ', the slider 0..' + XP.max + ')');
    } else if (xs === 2) {
      _xpSet(0, true, _XP.camHome);
      _dbg('[xp] walk 2: back together, the camera home');
    }
  }
  function _xpWithHead(B) { Array.prototype.splice.apply(B, [1, 0].concat(_xpHead())); return B; }

  /* v259 THE STAGED ASSEMBLY ANIMATION (every type but the park bench and
     the sofa, which keep their own): the parts a step adds fly in from
     above / outside, staggered; a step that adds only fasteners fades the
     parts already built and drives each screw or bolt in along its own
     axis (userData.driveDir / driveLen), as the park bench does. */
  var _stagedAnimTok = 0;
  function _stagedAnimate(prevStep, newStep) {
    var T = global.THREE, eng = global.BenchEngine;
    if (!T || !eng || !eng.benchGroup || !(newStep > 0)) return;
    var fresh = [], built = [], tok = ++_stagedAnimTok;
    /* v261: a fade still running from the step before (quick clicks) is
       put back first -- its see-through copy was taken for the original
       and the wood stayed see-through */
    eng.benchGroup.traverse(function (n) {
      if (n.userData && n.userData._fadeOrig) { n.material = n.userData._fadeOrig; delete n.userData._fadeOrig; }
    });
    eng.benchGroup.children.forEach(function (c) {
      var ud = c.userData || {}, pt = ud.partType;
      if (!pt || pt === 'person' || !c.visible || !ud.basePos) return;
      var st = _swingPartStep(pt);
      if (st === newStep) fresh.push(c); else built.push(c);
    });
    var asm = _asmOn(), pops = [];   /* v408 ?ig2=asm: no fade, no glow; the fasteners stand in place (pops: shown when the wood has landed) */
    if (!fresh.length) {
      var stH = _swingStepTable(STATE)[newStep];
      if (stH && stH.highlight && !asm) _stagedHighlight(stH.highlight, built, tok);   /* v357 the bar's coating */
      return 0;
    }
    function isHw(c) { var pt = c.userData.partType; return !!c.userData.driveDir || pt.indexOf('-hw') >= 0 || (asm && _asmFastenerPt(pt)); }
    var hwOnly = fresh.every(isHw), moves = [], fades = [];
    if (asm && hwOnly) { fresh.forEach(function (c) { c.position.copy(c.userData.basePos); }); return 0; }
    /* v261 (Marek: the braces under the table, the hangers / chains under
       the beam come FROM BELOW -- every set): a new part with built wood
       above its footprint rises from below instead of dropping through it */
    var roofs = [];
    built.forEach(function (c) {
      if (isHw(c)) return;
      var bb = new T.Box3().setFromObject(c);
      if (!bb.isEmpty()) roofs.push({ bb: bb, pt: null });
    });
    /* v264 (Marek: the roof's struts from below, the rafters from above):
       the step's own wood of another kind counts as well */
    fresh.forEach(function (c) {
      if (isHw(c)) return;
      var bb = new T.Box3().setFromObject(c);
      if (!bb.isEmpty()) roofs.push({ bb: bb, pt: c.userData.partType });
    });
    function covered(c) {
      var bb = new T.Box3().setFromObject(c), r;
      if (bb.isEmpty()) return false;
      var cx = (bb.min.x + bb.max.x) / 2, cz = (bb.min.z + bb.max.z) / 2;   /* its middle under the wood (a rim over the edge does not count) */
      for (r = 0; r < roofs.length; r++) {
        var R = roofs[r].bb;
        if (roofs[r].pt && roofs[r].pt === c.userData.partType) continue;
        if (R.min.y >= bb.max.y - 0.02 && cx > R.min.x && cx < R.max.x && cz > R.min.z && cz < R.max.z) return true;
      }
      return false;
    }
    fresh.forEach(function (c, i) {
      if (asm && isHw(c)) { c.position.copy(c.userData.basePos); c.visible = false; pops.push(c); return; }   /* v408 in place, shown as the wood lands */
      var ud = c.userData, b = ud.basePos, from, under = !ud.driveDir && !ud.flyDir && covered(c);
      if (ud.flyFrom) {                                                 /* v277: a start of its own -- the planter's liner from the opposite wall, inside the box */
        from = new T.Vector3(ud.flyFrom[0], ud.flyFrom[1], ud.flyFrom[2]);
      } else if (ud.flyDir) {                                           /* v264: a side cheek flies in from its own side */
        from = new T.Vector3(b.x + ud.flyDir[0] * 0.7, b.y + ud.flyDir[1] * 0.6, b.z + ud.flyDir[2] * 0.7);
      } else if (ud.driveDir) {
        var dl = ud.driveLen || 0.10;
        from = new T.Vector3(b.x + ud.driveDir[0] * dl, b.y + ud.driveDir[1] * dl, b.z + ud.driveDir[2] * dl);
      } else if (isHw(c)) {
        from = new T.Vector3(b.x, b.y + (under ? -0.30 : 0.15), b.z);
      } else {
        var ox = (Math.abs(b.x) > 0.05) ? (b.x > 0 ? 0.12 : -0.12) : 0, oz = (Math.abs(b.z) > 0.05) ? (b.z > 0 ? 0.12 : -0.12) : 0;
        from = new T.Vector3(b.x + ox, b.y + (under ? -0.45 : 0.45), b.z + oz);
      }
      c.position.copy(from);
      moves.push({ obj: c, from: from, to: b.clone(), delay: (fresh.length > 1) ? (i / (fresh.length - 1)) : 0 });
    });
    if (hwOnly && !asm) {
      built.forEach(function (c) {
        if (isHw(c)) return;
        c.traverse(function (n) {
          if (!n.isMesh || !n.material) return;
          var orig = n.material, cl = orig.clone();
          var top = (orig.transparent && orig.opacity < 1) ? orig.opacity : 1;   /* v304 never above the part's own (the cloth, a hidden part) */
          cl.transparent = true; cl.opacity = Math.min(0.30, top); cl.depthWrite = false;
          n.material = cl; n.userData._fadeOrig = orig;
          fades.push({ obj: n, shared: orig, clone: cl, top: top });
        });
      });
    }
    var t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    var SPD = _tourAsmSpeed();   /* v277: the voice tour's assembly at 60 % of the time */
    var PIECE = (hwOnly ? 900 : 800) * SPD, SLACK = (hwOnly ? 1100 : 900) * SPD, TOTAL = PIECE + SLACK, FADE = TOTAL + 900 * SPD;
    function finish() {
      moves.forEach(function (m) { m.obj.position.copy(m.to); });
      fades.forEach(function (f) {
        if (f.obj.material === f.clone) { f.obj.material = f.shared; delete f.obj.userData._fadeOrig; }
        if (f.clone && f.clone.dispose) f.clone.dispose();
      });
      fades = [];
      pops.forEach(function (c) { c.visible = true; }); pops = [];
    }
    (function tick() {
      if (tok !== _stagedAnimTok) { finish(); return; }
      var now = (typeof performance !== 'undefined' ? performance.now() : Date.now()), el = now - t0;
      moves.forEach(function (m) {
        var k = Math.min(1, Math.max(0, (el - m.delay * SLACK) / PIECE)), e = 1 - Math.pow(1 - k, 3);
        m.obj.position.lerpVectors(m.from, m.to, e);
      });
      if (fades.length) {
        var kf = Math.min(1, el / FADE), op = (kf < 0.6) ? 0.30 : (0.30 + (kf - 0.6) / 0.4 * 0.70);
        fades.forEach(function (f) { f.obj.material.opacity = Math.min(op, f.top); });
      }
      if (pops.length && el >= TOTAL) { pops.forEach(function (c) { c.visible = true; }); pops = []; }   /* v408 */
      if (eng.renderer && eng.scene && eng.camera) eng.renderer.render(eng.scene, eng.camera);
      if (el < FADE) requestAnimationFrame(tick); else finish();
    })();
    return TOTAL;   /* v408 the fly-in's length (ms) -- the ?ig2=asm walk waits for it */
  }

  /* v357 a step that adds nothing but treats what stands (the bar's coating): those parts glow warm for a moment, the rest fade and come back */
  function _stagedHighlight(list, built, tok) {
    var T = global.THREE, eng = global.BenchEngine, hl = [], fades = [];
    built.forEach(function (c) {
      var on = list.indexOf(c.userData.partType) >= 0;
      c.traverse(function (n) {
        if (!n.isMesh || !n.material) return;
        var orig = n.material, cl = orig.clone(), top = (orig.transparent && orig.opacity < 1) ? orig.opacity : 1;
        if (on) { if (!cl.emissive) return; cl.emissive = new T.Color(0xc0741e); cl.emissiveIntensity = 0; hl.push({ obj: n, shared: orig, clone: cl }); }
        else { cl.transparent = true; cl.opacity = Math.min(0.25, top); cl.depthWrite = false; fades.push({ obj: n, shared: orig, clone: cl, top: top }); }
        n.material = cl; n.userData._fadeOrig = orig;
      });
    });
    if (!hl.length) { fades.forEach(function (f) { f.obj.material = f.shared; delete f.obj.userData._fadeOrig; if (f.clone.dispose) f.clone.dispose(); }); return; }
    var t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now()), DUR = 2600 * _tourAsmSpeed();
    function finish() {
      hl.concat(fades).forEach(function (f) {
        if (f.obj.material === f.clone) { f.obj.material = f.shared; delete f.obj.userData._fadeOrig; }
        if (f.clone && f.clone.dispose) f.clone.dispose();
      });
      hl = []; fades = [];
    }
    (function tick() {
      if (tok !== _stagedAnimTok) { finish(); return; }
      var el = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - t0, k = Math.min(1, el / DUR);
      hl.forEach(function (h) { h.clone.emissiveIntensity = 0.55 * Math.sin(Math.PI * k); });
      var op = (k < 0.7) ? 0.25 : (0.25 + (k - 0.7) / 0.3 * 0.75);
      fades.forEach(function (f) { f.clone.opacity = Math.min(op, f.top); });
      if (eng.renderer && eng.scene && eng.camera) eng.renderer.render(eng.scene, eng.camera);
      if (k < 1) requestAnimationFrame(tick); else finish();
    })();
  }

  function cycleAssembly() {
    if (_isStagedType(STATE.variant)) {
      /* Hollywood swing: walk the build order; the roof steps are skipped
         without a roof, the mattress step without a mattress. */
      var actSw = _swingActiveSteps(STATE), posSw = actSw.indexOf(STATE.assemblyStep | 0);
      var prevSw = STATE.assemblyStep | 0;
      var nxt = actSw[(posSw + 1) % actSw.length];
      STATE.assemblyStep = nxt;
      try { global.BenchRenderer._applyAssemblyStep(global.BenchEngine.benchGroup, nxt); } catch (e) {}
      try { _stagedAnimate(prevSw, nxt); } catch (eA) { _dbg('[assembly] animation: ' + eA.message); }
      try { _xpWalk(prevSw, nxt); } catch (eX) { _dbg('[xp] walk THREW ' + ((eX && eX.message) || eX)); }   /* v395 the coops: 1 exploded, 2 back together */
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    var prevStep = STATE.assemblyStep;
    var isSofa = _isSofaAsm(STATE);   /* v269: + the porch swing in the sofa style */
    var hasBack  = (STATE.backrestVisible !== false);
    /* Sofa assembly = 3-phase teardown:
         0 composed · 1 detach bočnice (slide out along Z, with their
           TOP-END + dowels + screws) · 2 lift TOP-END up off the posts ·
         3 split posts fwd/back off the SEAT-END rails. */
    var lastStep = isSofa ? _sofaStepMap(STATE).last : (hasBack ? BENCH_LAST_STEP : BENCH_LAST_STEP_NO_BACKREST);
    var newStep  = prevStep + 1;
    if (newStep > lastStep) newStep = 0;
    if (isSofa && (newStep === 5 || newStep === 6) && _sofaStepMap(STATE).noTop) newStep = 7;   /* v273: the bed without its headboard -- no top rail steps */
    STATE.assemblyStep = newStep;
    _updatePocketHoleImage();   /* show/hide pocket-hole tool demo on step 2 */

    /* ── SOFA teardown animation ──────────────────────────────────────
       Animate each part from its prevStep phase position to its newStep
       phase position. Only the parts whose offset changes actually move,
       so e.g. step 2→3 moves ONLY the posts (dowels emerge) and leaves
       the already-detached bočnice + lifted TOP-END where they are. */
    if (isSofa) {
      var T2 = global.THREE;
      var eng2 = global.BenchEngine;
      global.BenchRenderer.build();   /* rebuild geometry, parts at base/new */
      var moves = [];
      var ledgerScrewMoves = [];   /* step 11: driven AFTER battens settle */
      var centerLegMoves = [];     /* center-leg step: dowels (phase 1) then legs (phase 2) */
      var staggerMoves = [];       /* step 12/13: randomized fly-in per part */
      /* deterministic pseudo-random in [0,1) from an integer (stable across
         rebuilds so the stagger order doesn't jump around). */
      var _rand = function (n) { var x = Math.sin((n + 1) * 12.9898) * 43758.5453; return x - Math.floor(x); };
      eng2.benchGroup.traverse(function (c) {
        var b = c.userData && c.userData.basePos;
        if (!b || !c.userData.partType || c.userData.partType === 'person') return;
        c.visible = _benchVisibleAtStep(c, newStep);   /* enforce step visibility */
        var o0 = _sofaPhaseOffset(c, prevStep);
        var o1 = _sofaPhaseOffset(c, newStep);
        /* step 12 (rošt) + step 13 (slats): randomized, staggered fly-in
           regardless of whether the static offset changed. */
        var gpS = _sofaPartGroup(c.userData);
        var smA = _sofaStepMap(STATE);
        if ((newStep === smA.legs  && gpS === 'centerleg') ||
            (newStep === smA.rost  && gpS === 'rost') ||
            (newStep === smA.slats && gpS === 'slat')) {
          var idS = (c.userData.idHint || '') + '';
          var idx = parseInt((idS.match(/(\d+)/) || [0, 0])[1], 10) || 0;
          var seated = new T2.Vector3(b.x + o1[0], b.y + o1[1], b.z + o1[2]);
          /* Center-leg step: two phases. Phase 1 — the dowels drive UP into
             the long-rail holes. Phase 2 — the legs rise from below onto the
             seated dowels. */
          if (newStep === smA.legs) {
            if (idS.indexOf('dowel-center') === 0) {
              var dFrom = seated.clone(); dFrom.y -= 0.14;   /* dowel comes from just below, drives up into the rail */
              centerLegMoves.push({ obj: c, from: dFrom, to: seated, phase: 1 });
              c.position.copy(dFrom);
            } else {
              var lFrom = seated.clone(); lFrom.y -= 0.34;   /* leg rises from below */
              centerLegMoves.push({ obj: c, from: lFrom, to: seated, phase: 2 });
              c.position.copy(lFrom);
            }
            return;
          }
          var src;
          if (newStep === smA.rost) {
            /* rošt drops straight down from above */
            src = seated.clone(); src.y += 0.55 + _rand(idx) * 0.20;
          } else {
            /* slats fly in: back slats from −X, side slats from ±Z, all
               from slightly above too */
            var off = (gpS === 'slat-hw') ? 0.62 : 0.50;
            var dir = new T2.Vector3(0, 0, 0);
            if (idS.indexOf('top') >= 0) { /* top slats just drop from above */ }
            else if (idS.indexOf('back')  >= 0) dir.x = -1;
            else if (idS.indexOf('left')  >= 0) dir.z = -1;
            else if (idS.indexOf('right') >= 0) dir.z =  1;
            src = seated.clone().addScaledVector(dir, off);
            src.y += (idS.indexOf('top') >= 0) ? 0.45 : 0.18;
          }
          c.position.copy(src);
          staggerMoves.push({ obj: c, from: src, to: seated, delay: _rand(idx * 7 + 3) });
          return;
        }
        if (o0[0] === o1[0] && o0[1] === o1[1] && o0[2] === o1[2]) {
          c.position.set(b.x + o1[0], b.y + o1[1], b.z + o1[2]);
          return;   /* unchanged — snap to final, no animation */
        }
        var from = new T2.Vector3(b.x + o0[0], b.y + o0[1], b.z + o0[2]);
        var to   = new T2.Vector3(b.x + o1[0], b.y + o1[1], b.z + o1[2]);
        c.position.copy(from);
        /* step 11: ledger screws move in TWO phases —
             phase 1: drop DOWN with the batten (keep the horizontal X
                      offset, just lose the Y lift) → 'mid'
             phase 2: drive IN horizontally along X into the rail → 'to'   */
        if (newStep === 11 && _sofaPartGroup(c.userData) === 'ledger-hw') {
          var mid = new T2.Vector3(b.x + o0[0], b.y + 0, b.z + o0[2]);
          ledgerScrewMoves.push({ obj: c, from: from, mid: mid, to: to });
          return;
        }
        moves.push({ obj: c, from: from, to: to });
      });
      refreshUI();
      _toggleHandlesForStep(newStep);

      /* ── Step 2 see-through: at step 2 (the 4×4 frame + pocket-hole
         markers) make ALL 4×4 profiles semi-transparent so the pocket
         holes / dowel holes inside are visible. Stays translucent for the
         whole step; the next step's build() rebuilds with the shared
         opaque material, so no manual restore is needed. */
      if (newStep === 2) {
        eng2.benchGroup.traverse(function (c) {
          if (!c.visible || !c.material) return;
          var pt2 = c.userData && c.userData.partType;
          if (pt2 === 'post' || pt2 === 'rail-seat' || pt2 === 'rail-top-end' ||
              pt2 === 'rail-lower' || pt2 === 'rail-arm') {
            c.material = c.material.clone();
            c.material.transparent = true;
            c.material.opacity = 0.35;
            c.material.depthWrite = false;
          }
        });
      }

      /* ── Hardware reveal steps: make the relevant 4×4 profiles semi-
         transparent so the pocket holes + screws inside are visible, then
         fade back to solid. Pocket screws drive in along their own axis.
           step 4 → SEAT-END (side) joint · step 6 → TOP-END joint. */
      var fadeProfiles = [];
      var screwDrives = [];
      var revealStep = (newStep === 4) ? 'side' : (newStep === 6) ? 'topend' : (newStep === 9) ? 'long' : null;
      if (revealStep) {
        /* which hardware group drives in, and which 4×4 profiles fade so
           the holes/screws inside are visible. */
        var hwGroup = (revealStep === 'side') ? 'side-hw'
                    : (revealStep === 'topend') ? 'side-hw-topend'
                    : 'long-hw';
        /* fade the profiles the screws are seated into:
             step 4 → posts + SEAT-END rails
             step 6 → posts + TOP-END rails
             step 8 → posts + long rails (rail-lower / rail-arm)            */
        var fadePtsByStep = (revealStep === 'side')
                        ? { post: 'side', 'rail-seat': 'side' }
                      : (revealStep === 'topend')
                        ? { post: 'side', 'rail-top-end': 'topend' }
                        : { post: 'side', 'rail-lower': 'long', 'rail-arm': 'long' };
        eng2.benchGroup.traverse(function (c) {
          if (!c.visible || !c.material) return;
          var grp4 = _sofaPartGroup(c.userData || {});
          var pt4 = c.userData && c.userData.partType;
          if (fadePtsByStep[pt4] && fadePtsByStep[pt4] === grp4) {
            /* clone the shared lumber material so only these meshes fade */
            var orig = c.material;
            c.material = orig.clone();
            c.material.transparent = true;
            c.material.opacity = 0.30;
            c.material.depthWrite = false;
            fadeProfiles.push({ obj: c, shared: orig });
          }
        });
        /* Pocket screws of this joint: start pushed OUT along the screw's
           own head direction by its drive length, then animate IN to the
           seated position — reads as driving the screw. */
        eng2.benchGroup.traverse(function (c) {
          if (c.userData && c.userData.partType === 'screw-pocket' &&
              _sofaPartGroup(c.userData) === hwGroup && c.visible) {
            var L = c.userData.screwDriveLen || 0.053;
            /* head direction = local +Y rotated into world by the screw's Euler */
            var headDir = new T2.Vector3(0, 1, 0).applyEuler(c.rotation).normalize();
            var bb = c.userData.basePos;
            var off4 = _sofaPhaseOffset(c, newStep);
            /* seated = the screw's correct position at this step */
            var seated = bb
              ? new T2.Vector3(bb.x + off4[0], bb.y + off4[1], bb.z + off4[2])
              : c.position.clone();
            var out = seated.clone().addScaledVector(headDir, L);
            c.position.copy(out);
            screwDrives.push({ obj: c, from: out, to: seated });
          }
        });
      }

      /* ── Slat-screw step: slat screws all drive in at once (after the
         slats have settled). Same drive-in motion as pocket screws, but no
         profile fade — just the screws sinking into the slats. The step
         number shifts up by one when center legs add a step. */
      if (newStep === _sofaStepMap(STATE).slatScrew) {
        eng2.benchGroup.traverse(function (c) {
          if (c.userData && c.userData.partType === 'screw-wood' &&
              _sofaPartGroup(c.userData) === 'slat-hw' && c.visible) {
            var Lw = c.userData.screwDriveLen || 0.053;
            var hd = new T2.Vector3(0, 1, 0).applyEuler(c.rotation).normalize();
            var bbw = c.userData.basePos;
            var offw = _sofaPhaseOffset(c, newStep);
            var seatedw = bbw
              ? new T2.Vector3(bbw.x + offw[0], bbw.y + offw[1], bbw.z + offw[2])
              : c.position.clone();
            var outw = seatedw.clone().addScaledVector(hd, Lw);
            c.position.copy(outw);
            screwDrives.push({ obj: c, from: outw, to: seatedw });
          }
        });
      }

      /* step 11: park the ledger screws at their start (exploded) until the
         battens have settled, then drive them in over the second phase. */
      for (var lz0 = 0; lz0 < ledgerScrewMoves.length; lz0++) {
        ledgerScrewMoves[lz0].obj.position.copy(ledgerScrewMoves[lz0].from);
      }

      if (!moves.length && !fadeProfiles.length && !screwDrives.length && !ledgerScrewMoves.length && !staggerMoves.length && !centerLegMoves.length) { if (eng2.requestRender) eng2.requestRender(); return; }
      var t0 = (typeof performance !== 'undefined' ? performance.now() : Date.now());
      var DUR = 1800;
      /* The fade should linger semi-transparent, then close near the end. */
      var FADE_DUR = fadeProfiles.length ? 3000 : DUR;
      var SCREW_DUR = screwDrives.length ? 2200 : DUR;
      /* ledger screws: hold for the first ~55% (battens settling), then
         drive in over the remaining time. */
      var LEDGER_HOLD = 0.55, LEDGER_TOTAL = ledgerScrewMoves.length ? 2600 : DUR;
      /* staggered fly-in: total window long enough that delayed parts still
         get a full ~900 ms move. */
      var STAGGER_PIECE = 900, STAGGER_TOTAL = staggerMoves.length ? 2600 : DUR;
      /* center legs: dowels drive in for the first ~50% (CENTER_HOLD), then
         the legs rise for the rest. */
      var CENTER_HOLD = 0.5, CENTER_TOTAL = centerLegMoves.length ? 2400 : DUR;
      /* v277: the voice tour's assembly runs at 60 % of the time (Marek: assembly rychlejsi) */
      var TSPD = _tourAsmSpeed();
      if (TSPD !== 1) { DUR *= TSPD; FADE_DUR *= TSPD; SCREW_DUR *= TSPD; LEDGER_TOTAL *= TSPD; STAGGER_PIECE *= TSPD; STAGGER_TOTAL *= TSPD; CENTER_TOTAL *= TSPD; }
      var maxDur = Math.max(DUR, FADE_DUR, SCREW_DUR, LEDGER_TOTAL, STAGGER_TOTAL, CENTER_TOTAL);
      (function tick() {
        var now = (typeof performance !== 'undefined' ? performance.now() : Date.now());
        var k = Math.min(1, (now - t0) / DUR);
        var e = 1 - Math.pow(1 - k, 3);   /* ease-out cubic */
        for (var i = 0; i < moves.length; i++) {
          var m = moves[i];
          m.obj.position.lerpVectors(m.from, m.to, e);
        }
        /* staggered, randomized fly-in (rošt / slats) */
        if (staggerMoves.length) {
          var elapsed = now - t0;
          var slack = Math.max(0, STAGGER_TOTAL - STAGGER_PIECE);
          for (var sm = 0; sm < staggerMoves.length; sm++) {
            var mv = staggerMoves[sm];
            var start = mv.delay * slack;
            var kp = Math.min(1, Math.max(0, (elapsed - start) / STAGGER_PIECE));
            var ep = 1 - Math.pow(1 - kp, 3);
            mv.obj.position.lerpVectors(mv.from, mv.to, ep);
          }
        }
        /* two-phase ledger screws: drop with the batten, then drive in */
        if (ledgerScrewMoves.length) {
          var kl = Math.min(1, (now - t0) / LEDGER_TOTAL);
          for (var li2 = 0; li2 < ledgerScrewMoves.length; li2++) {
            var ls = ledgerScrewMoves[li2];
            if (kl <= LEDGER_HOLD) {
              /* phase 1: drop down with the batten (ease-out) */
              var k1 = kl / LEDGER_HOLD;
              var e1 = 1 - Math.pow(1 - k1, 3);
              ls.obj.position.lerpVectors(ls.from, ls.mid, e1);
            } else {
              /* phase 2: drive in horizontally along X (ease-out) */
              var k2 = (kl - LEDGER_HOLD) / (1 - LEDGER_HOLD);
              var e2 = 1 - Math.pow(1 - k2, 3);
              ls.obj.position.lerpVectors(ls.mid, ls.to, e2);
            }
          }
        }
        /* two-phase center legs: dowels drive into the rail holes first,
           then the legs rise up onto them */
        if (centerLegMoves.length) {
          var kc = Math.min(1, (now - t0) / CENTER_TOTAL);
          for (var ci = 0; ci < centerLegMoves.length; ci++) {
            var cm = centerLegMoves[ci];
            if (cm.phase === 1) {
              /* dowels: drive in over the first phase, then stay seated */
              var kc1 = Math.min(1, kc / CENTER_HOLD);
              var ec1 = 1 - Math.pow(1 - kc1, 3);
              cm.obj.position.lerpVectors(cm.from, cm.to, ec1);
            } else {
              /* legs: wait below, then rise over the second phase */
              if (kc <= CENTER_HOLD) {
                cm.obj.position.copy(cm.from);
              } else {
                var kc2 = (kc - CENTER_HOLD) / (1 - CENTER_HOLD);
                var ec2 = 1 - Math.pow(1 - kc2, 3);
                cm.obj.position.lerpVectors(cm.from, cm.to, ec2);
              }
            }
          }
        }
        /* drive the pocket screws in (ease-out so they settle into the hole) */
        if (screwDrives.length) {
          var ks = Math.min(1, (now - t0) / SCREW_DUR);
          var es = 1 - Math.pow(1 - ks, 3);
          for (var s = 0; s < screwDrives.length; s++) {
            screwDrives[s].obj.position.lerpVectors(screwDrives[s].from, screwDrives[s].to, es);
          }
        }
        /* fade 4×4 profiles from 0.30 → 1.0; stay translucent for the first
           half, then close up over the second half so the reveal reads. */
        if (fadeProfiles.length) {
          var kf = Math.min(1, (now - t0) / FADE_DUR);
          var op = (kf < 0.5) ? 0.30 : (0.30 + (kf - 0.5) / 0.5 * 0.70);
          for (var j = 0; j < fadeProfiles.length; j++) {
            fadeProfiles[j].obj.material.opacity = op;
          }
          if (kf >= 1) {
            /* restore the shared opaque lumber material + free the clones */
            for (var n = 0; n < fadeProfiles.length; n++) {
              var fp = fadeProfiles[n];
              if (fp.obj.material && fp.obj.material.dispose) fp.obj.material.dispose();
              fp.obj.material = fp.shared;
            }
            fadeProfiles = [];
          }
        }
        if (eng2.renderer && eng2.scene && eng2.camera) eng2.renderer.render(eng2.scene, eng2.camera);
        if ((now - t0) < maxDur) requestAnimationFrame(tick);
      })();
      return;
    }

    /* "Exploded" = step 1 or 2. Everything else has parts at base. */
    var prevExploded = (prevStep === 1 || prevStep === 2);
    var newExploded  = (newStep  === 1 || newStep  === 2);
    var isExplodeIn  = !prevExploded && newExploded;
    var isExplodeOut = prevExploded && !newExploded;
    var newParts = _diffNewParts(prevStep, newStep);
    var hasNewParts = newParts.length > 0;
    /* Off-bench → on-bench transition: prevStep had backrest frame in
       off-bench window, newStep does not. Triggers a slide animation. */
    var isOffBenchInstall = (prevStep >= BENCH_BR_OFFBENCH_FIRST &&
                             prevStep <= BENCH_BR_OFFBENCH_LAST &&
                             (newStep < BENCH_BR_OFFBENCH_FIRST ||
                              newStep > BENCH_BR_OFFBENCH_LAST));
    var doAnimate = isExplodeIn || isExplodeOut || hasNewParts || isOffBenchInstall;

    if (!doAnimate) {
      global.BenchRenderer.build();
      refreshUI();
      _toggleHandlesForStep(newStep);
      return;
    }

    var eng = global.BenchEngine;
    if (!eng || !eng.benchGroup) {
      global.BenchRenderer.build();
      refreshUI();
      _toggleHandlesForStep(newStep);
      return;
    }

    /* Rebuild — children get repopulated, _applyAssemblyStep sets positions at end. */
    global.BenchRenderer.build();
    refreshUI();
    _toggleHandlesForStep(newStep);

    var T = global.THREE;
    /* Default explode offsets — kept in sync with _applyAssemblyStep's
       EXPLODE table. Per-instance userData.explodeOffset overrides
       these (corner posts, seat planks, backrest interior parts). */
    var DEFAULT_OFFSET = {
      'rail-seat-front':       [0,    0,    0],
      'rail-seat-back':        [0,    0,    0],
      'rail-seat-left':        [0,    0.18, -0.30],
      'rail-seat-right':       [0,    0.18,  0.30],
      'joist':                 [0,    0.28,  0],
      'rail-back-left':        [0,    0.32, -0.25],
      'rail-back-right':       [0,    0.32,  0.25],
      'rail-backrest-bottom':  [-0.25, 0.55, 0],
      'backrest-group':        [-0.25, 0.55, 0],
      'screw-deck':            [0,    0.22, 0],
      'screw-pocket':          [0,    0,    0],
      'screw-lag':             [0,    0.15, 0]
    };

    var targets = [];
    /* Traverse FULL tree — backrest interior lives in bf sub-group
       and must be animated too. */
    eng.benchGroup.traverse(function (c) {
      var base = c.userData.basePos;
      var pt = c.userData.partType;
      if (!base || !pt || !c.visible) return;
      if (pt === 'person') return;

      var off = c.userData.explodeOffset || DEFAULT_OFFSET[pt] || [0,0,0];
      var basePos = base.clone();
      var explodedPos = new T.Vector3(base.x + off[0], base.y + off[1], base.z + off[2]);
      var endPos = c.position.clone();
      var wasVisible = _benchVisibleAtStep(c, prevStep);
      /* Off-bench offset that WAS applied at prevStep (if any). When
         the part was off-bench then but is not now, we need to animate
         it from off-bench to its base position — the "install on bench"
         slide. */
      var prevOffBench = _benchOffBenchOffset(c, prevStep);
      var newOffBench  = _benchOffBenchOffset(c, newStep);

      var startPos;
      if (isExplodeIn) {
        startPos = basePos;
      } else if (isExplodeOut) {
        startPos = explodedPos;
      } else if (!wasVisible) {
        /* Newly visible — screws with an installOffset fly in PERPENDICULAR
           to their host profile (real driving direction); everything else
           flies in from the exploded position. */
        var installOff = c.userData.installOffset;
        startPos = installOff
          ? new T.Vector3(endPos.x + installOff[0], endPos.y + installOff[1], endPos.z + installOff[2])
          : explodedPos;
      } else if (prevOffBench && !newOffBench) {
        /* "Install on bench" transition: this part rode the off-bench
           offset at prevStep but rests on the bench at newStep. Slide
           from off-bench position to endPos (= base). */
        startPos = new T.Vector3(
          endPos.x + prevOffBench[0],
          endPos.y + prevOffBench[1],
          endPos.z + prevOffBench[2]
        );
      } else {
        startPos = endPos;   /* no movement needed */
      }

      c.position.copy(startPos);
      targets.push({ obj: c, from: startPos, to: endPos, staggerDelay: 0 });
    });

    /* ── Logs animation: MATRIX-STYLE drop. Each log falls independently
          from a tall start position, with a randomized delay so they don't
          fall in a wave but appear one-by-one as scattered raindrops. */
    var logTargets = targets.filter(function (t) {
      return t.obj.userData && t.obj.userData.partType === 'logs';
    });
    /* Deterministic pseudo-random ordering based on log index/position so
       it looks scattered but is reproducible across runs. */
    logTargets.forEach(function (t, i) {
      var seed = (i * 9301 + 49297) % 233280;
      t.staggerDelay = (seed / 233280) * 1400;   /* spread across 1.4s */
    });
    var maxStagger = logTargets.length > 0
      ? Math.max.apply(null, logTargets.map(function (t) { return t.staggerDelay; }))
      : 0;

    /* requestAnimationFrame animation loop */
    var DURATION = 900;
    var LOG_DURATION = 280;  /* per-log fall time (snappy matrix drop) */
    var startTime = performance.now();
    function easeInOutCubic(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
    /* Logs use gravity-like ease-in (slow start, accelerating) for a
       satisfying matrix-rain drop. */
    function easeInQuad(t) { return t * t; }
    function tick() {
      var elapsed = performance.now() - startTime;
      var allDone = true;
      targets.forEach(function (tg) {
        var isLog = (tg.obj.userData && tg.obj.userData.partType === 'logs');
        var delay = tg.staggerDelay || 0;
        var dur = isLog ? LOG_DURATION : DURATION;
        var local = elapsed - delay;
        var t;
        if (local < 0) { t = 0; allDone = false; }
        else if (local >= dur) { t = 1; }
        else { t = local / dur; allDone = false; }
        var k = isLog ? easeInQuad(t) : easeInOutCubic(t);
        tg.obj.position.set(
          tg.from.x + (tg.to.x - tg.from.x) * k,
          tg.from.y + (tg.to.y - tg.from.y) * k,
          tg.from.z + (tg.to.z - tg.from.z) * k
        );
      });
      if (!allDone) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Refresh drag-handle visibility based on combined state.

     There are TWO sets of handles:
       LEGACY set (cf-handle-l/w/h): used in 3D and 2D stage 1.
       ELEVATION set (cf-handle-elev-front-l/h, cf-handle-elev-side-w/h):
         used ONLY in 2D stage 2. Visible via `.cf-elev-visible` class
         (toggles `display: block`).

     Visibility matrix:
       assemblyStep != 0    → ALL hidden (no editing during assembly anim)
       3D stage 1           → legacy L, W, H visible; elev all hidden
       3D stage 2, 3        → ALL hidden (inspection/profile views)
       2D stage 1 (plan)    → legacy L, W visible (H hidden — can't edit height
                              from top-down); elev all hidden
       2D stage 2 (elev)    → legacy ALL hidden; elev all visible

     Called from cycleAssembly, applyVizStage, toggleView. */
  function _refreshHandlesVisibility() {
    var l = document.getElementById('cf-handle-l');
    var w = document.getElementById('cf-handle-w');
    var h = document.getElementById('cf-handle-h');
    var efL = document.getElementById('cf-handle-elev-front-l');
    var efH = document.getElementById('cf-handle-elev-front-h');
    var esW = document.getElementById('cf-handle-elev-side-w');
    var esH = document.getElementById('cf-handle-elev-side-h');
    var elevSet = [efL, efH, esW, esH];

    function hideLegacy() {
      if (l) l.style.display = 'none';
      if (w) w.style.display = 'none';
      if (h) h.style.display = 'none';
    }
    function showLegacy(showH_) {
      /* Bench in 3D: L, W, and H are all draggable. reposition() handles
         per-frame positioning + visibility based on view + state. */
      if (l) l.style.display = '';
      if (w) w.style.display = '';
      if (h) h.style.display = '';
    }
    function hideElev() {
      elevSet.forEach(function (el) { if (el) el.classList.remove('cf-elev-visible'); });
    }
    function showElev() {
      elevSet.forEach(function (el) { if (el) el.classList.add('cf-elev-visible'); });
    }

    var hideAll = (STATE.assemblyStep !== 0)
                  || (STATE.view === '3d' && STATE.vizStage !== 1);

    if (hideAll) {
      hideLegacy();
      hideElev();
      return;
    }

    if (STATE.view === '2d') {
      /* In 2D, show BOTH chips and round corner handles. Chips show
         dim values; round handles mark the rack corners that can be
         dragged. Both pipe to the same _start/_move pipeline.
           stage 1 (plan)   → L + W handles
           stage 2 (bokorys)→ L + H handles (only L,H editable from side)
           stage 3 (nárys)  → W + H handles (only W,H editable from front) */
      hideElev();
      var s = STATE.vizStage;
      if (l) l.style.display = (s === 1 || s === 2) ? '' : 'none';
      if (w) w.style.display = (s === 1 || s === 3) ? '' : 'none';
      if (h) h.style.display = (s === 2 || s === 3) ? '' : 'none';
    } else {
      /* 3D — legacy round handles. */
      hideElev();
      showLegacy(true);
    }
  }

  /* Backward-compat alias — existing call sites in cycleAssembly. */
  function _toggleHandlesForStep(step) {
    /* CSS-driven hard hide for ALL handles (L, W, H, body, elevations)
       — robust against any frame-loop reposition() that might overwrite
       inline display style. The .cf-assembly-active class on #cf-root
       maps to !important display:none on every handle (see liquid CSS). */
    var root = document.getElementById('cf-root');
    if (root) {
      var active = ((step | 0) !== 0);
      if (active) root.classList.add('cf-assembly-active');
      else        root.classList.remove('cf-assembly-active');
    }
    _refreshHandlesVisibility();
  }

  /* ----------------------------------------------------------
     ICON TOOLTIPS — touch flash + diagnostic
     Tooltips themselves are pure CSS (::after reads attr(title))
     so they appear instantly on desktop hover with no JS needed.
     On touch devices `:hover` and `:active` don't behave the same,
     so we briefly toggle `.show-tip` on touchstart for ~1.5 s so a
     tap reveals the label. Mirror of the pool-lib pattern.

     The function also dumps a one-time diagnostic snapshot of the
     first three icon buttons to the debug panel — exposes their
     title attribute, ::after computed content/opacity/position, and
     bounding-box. Lets us identify why tooltips might be invisible
     (missing title, clipped by overflow, opacity:0 stuck, etc.)
     without DevTools console access on tablet.
     ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     ICON TOOLTIPS — runtime CSS injection + touch flash + diagnostic

     IMPORTANT: a previous diagnostic showed that the snippet's <style>
     block had its `.cf-icon-btn::after` rules silently dropped (sheet
     scan found only the base .cf-icon-btn rule, not the ::after). We
     don't know exactly why — Shopify Theme Editor minifier, or some
     storefront preprocessing step. As a workaround, this function
     injects the same CSS at runtime via document.head, which bypasses
     whatever was stripping it from the rendered snippet.

     The function also dumps a stylesheet-scan + computed-style
     snapshot to the debug panel so we can verify injection succeeded.
     ---------------------------------------------------------- */
  function _injectTooltipCSS() {
    if (document.getElementById('cf-tooltip-runtime-css')) return;
    var css = [
      '#cf-root .cf-icon-btn { position: relative !important; overflow: visible !important; }',
      '#cf-root .cf-sidebar { overflow: visible !important; }',
      '#cf-root .cf-icon-btn::after {',
      '  content: attr(title) !important;',
      '  position: absolute !important;',
      '  right: calc(100% + 8px) !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  background: rgba(20, 20, 20, 0.92) !important;',
      '  color: #fff !important;',
      '  padding: 6px 10px !important;',
      '  border-radius: 6px !important;',
      '  font: 600 11px/1.2 Montserrat, -apple-system, sans-serif !important;',
      '  letter-spacing: 0.02em !important;',
      '  white-space: nowrap !important;',
      '  pointer-events: none !important;',
      '  opacity: 0 !important;',
      '  transition: opacity 0.15s ease !important;',
      '  z-index: 9999 !important;',
      '  display: block !important;',
      '  visibility: visible !important;',
      '  width: auto !important;',
      '  height: auto !important;',
      '}',
      '#cf-root .cf-icon-btn:hover::after,',
      '#cf-root .cf-icon-btn:active::after,',
      '#cf-root .cf-icon-btn.show-tip::after { opacity: 1 !important; }',
      /* v323 none on the info bar's switches: their caption is over them (Marek: ten tooltip tam nemusi vubec byt) */
      '#cf-root .cf-icon-btn.cf-bench-back-toggle::after { content: none !important; display: none !important; }'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'cf-tooltip-runtime-css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function _bindIconTooltips() {
    /* STEP 1: inject CSS from JS (bypass Liquid/Shopify minifier). */
    _injectTooltipCSS();

    var btns = document.querySelectorAll('.cf-icon-btn');
    var L = (global.Configurator && global.Configurator.log) || null;

    if (L) {
      L.log('[tooltip-debug] found ' + btns.length + ' .cf-icon-btn elements');
      L.log('[tooltip-debug] runtime-CSS injected = ' +
            (!!document.getElementById('cf-tooltip-runtime-css')));
    }

    /* Scan all stylesheets for ::after rules touching cf-icon-btn.
       Reveals which sheet/selector is winning the cascade. */
    if (L) {
      var rulesFound = [];
      var sheetsBlocked = 0;
      for (var s = 0; s < document.styleSheets.length; s++) {
        var sheet = document.styleSheets[s];
        try {
          var rules = sheet.cssRules || sheet.rules;
          if (!rules) continue;
          for (var r = 0; r < rules.length; r++) {
            var rule = rules[r];
            if (!rule.selectorText) continue;
            if (rule.selectorText.indexOf('cf-icon-btn') === -1) continue;
            rulesFound.push(
              'sheet[' + s + ']: ' + rule.selectorText +
              ' { ' + rule.style.cssText.slice(0, 120) + ' }'
            );
          }
        } catch (e) { sheetsBlocked++; }
      }
      L.log('[tooltip-debug] scanned ' + document.styleSheets.length +
            ' stylesheets, blocked=' + sheetsBlocked +
            ', cf-icon-btn rules found=' + rulesFound.length);
      for (var i2 = 0; i2 < Math.min(rulesFound.length, 5); i2++) {
        L.log('[tooltip-rule] ' + rulesFound[i2]);
      }
    }

    /* Diagnostic dump of first 2 buttons. */
    for (var i = 0; i < Math.min(btns.length, 2); i++) {
      var btn = btns[i];
      if (!L) break;
      var title  = btn.getAttribute('title') || '(none)';
      var id     = btn.id || '(no-id)';
      var after  = window.getComputedStyle(btn, '::after');
      L.log('[tooltip-debug] btn #' + id +
            ' title="' + title + '"' +
            ' ::after content=' + (after.content || '(empty)') +
            ' position=' + after.position +
            ' right=' + after.right +
            ' opacity=' + after.opacity);
    }

    var tipTimer = null;
    btns.forEach(function (btn) {
      btn.addEventListener('touchstart', function () {
        if (tipTimer) clearTimeout(tipTimer);
        document.querySelectorAll('.cf-icon-btn.show-tip').forEach(function (b) {
          b.classList.remove('show-tip');
        });
        btn.classList.add('show-tip');
        if (L) L.log('[tooltip-debug] touch flash on #' + (btn.id || '?'));
        tipTimer = setTimeout(function () { btn.classList.remove('show-tip'); }, 1500);
      }, { passive: true });
    });
  }

  function boot() {
    STATE.isMetric = detectUnits();
    loadSaved();

    if (!global.BenchEngine.init()) {
      if (global.Configurator && global.Configurator.log) {
        global.Configurator.log.log('[bench-lib] BenchEngine.init failed');
      }
      return;
    }
    /* Register the shared scale-figure hooks BEFORE the first build, so
       the very first sofa build can attach the person (build runs before
       wireSidebar). */
    _registerSharedPerson();
    global.BenchRenderer.build();
    global.BenchHandles.init();
    if (global.BenchDimensions && global.BenchDimensions.init) global.BenchDimensions.init();
    wireSidebar();

    /* Stage 4 (Select) raycaster — initialise canvas listeners ONCE,
       after the renderer's canvas exists. setActive() inside
       applyVizStage() then toggles its picking behaviour per stage. */
    if (global.BenchRaycaster && global.BenchRaycaster.init) {
      global.BenchRaycaster.init();
    }

    /* Asset drawer (shared module) — mount DOM and wire callbacks.
       Registry returns the enriched instance (BoQ totals + product
       info from BENCH_BOOT.boqProducts). onClose drops the selection
       highlight so the visual state always matches the drawer. */
    if (global.ConfiguratorAssetDrawer && global.ConfiguratorAssetDrawer.init) {
      var BOOT_I18N = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
      var drawerLabels = {};
      /* Pass through any asset-drawer labels supplied by the snippet
         under BENCH_BOOT.i18n.assetDrawer.{key}. Keys not provided fall
         back to defaults inside the module. */
      var ad = BOOT_I18N.assetDrawer || {};
      for (var k in ad) { if (ad.hasOwnProperty(k)) drawerLabels[k] = ad[k]; }
      global.ConfiguratorAssetDrawer.init({
        registry: function (id) {
          if (!global.BenchInstances) return null;
          var raw = global.BenchInstances.get(id);
          return raw ? global.BenchInstances.enrichForDrawer(raw) : null;
        },
        onClose: function () {
          if (global.BenchRaycaster && global.BenchRaycaster._selected) {
            global.BenchHighlight.deselect(global.BenchRaycaster._selected);
            global.BenchRaycaster._selected = null;
          }
        },
        labels: drawerLabels,
        drawerScopeClass: 'rack-asset-drawer'
      });
    }

    /* Apply restored view + vizStage from localStorage. Engine.init left the
       camera in default 3D position; if user had 2D saved, reposition it. */
    global.BenchEngine.applyView();
    global.BenchEngine.applyVizStage();

    refreshUI();
    _fitSoon(true);   /* v309 the first piece framed whole */

    /* Bind icon tooltips (CSS ::after reads data-tip; on touch we toggle
       .show-tip for ~1.5 s so taps reveal the label). Pattern mirrors
       pool-lib so behaviour is consistent across configurators. */
    _bindIconTooltips();

    /* Listen for budget-side unit toggles and follow them.
       Budget fires this event from clickUnitSelector(). */
    global.addEventListener('unitChange', _syncFromBudgetUnit);
    /* Initial sync: if budget already has a unit set (e.g. via currency
       detection on DOMContentLoaded), adopt it. */
    _syncFromBudgetUnit();

    /* v265: the voice tour's PLAY, its subtitles, a ?cfg= design link */
    try { _tourMount(); } catch (eTm) { _dbg('tour     mount THREW ' + ((eTm && eTm.message) || eTm)); }
    try { _tourSubInit(); } catch (eTs) { _dbg('tour     subtitles THREW ' + ((eTs && eTs.message) || eTs)); }
    try { _cfgBoot(); } catch (eCb) { _dbg('[cfg] boot THREW ' + ((eCb && eCb.message) || eCb)); }

    if (global.Configurator && global.Configurator.log) {
      global.Configurator.log.log('[bench-lib] boot OK, version=' + VERSION +
                                  ', view=' + STATE.view + ', vizStage=' + STATE.vizStage);


      /* ── BOOT diagnostic: dump full state so we can see if something is
         restored wrong from localStorage. Includes camera positions,
         canvas size, and STATE dimensions. */
      var eng = global.BenchEngine;
      if (eng && eng.camera && eng.renderer) {
        var canvas = eng.renderer.domElement;
        var rect = canvas.getBoundingClientRect();
        global.Configurator.log.log('[boot-diag] STATE.L=' + STATE.L.toFixed(3) +
                                    ' W=' + STATE.W.toFixed(3) +
                                    ' H=' + STATE.H.toFixed(3) +
                                    ' assemblyStep=' + STATE.assemblyStep);
        global.Configurator.log.log('[boot-diag] canvas device=' + canvas.width + 'x' + canvas.height +
                                    ' css=' + Math.round(rect.width) + 'x' + Math.round(rect.height));
        global.Configurator.log.log('[boot-diag] persp camera: pos=(' +
                                    eng.camera.position.x.toFixed(2) + ',' +
                                    eng.camera.position.y.toFixed(2) + ',' +
                                    eng.camera.position.z.toFixed(2) + ')' +
                                    ' fov=' + eng.camera.fov +
                                    ' aspect=' + eng.camera.aspect.toFixed(3));
        global.Configurator.log.log('[boot-diag] controls.target=(' +
                                    eng.controls.target.x.toFixed(2) + ',' +
                                    eng.controls.target.y.toFixed(2) + ',' +
                                    eng.controls.target.z.toFixed(2) + ')' +
                                    ' dist=' + eng.controls.getDistance().toFixed(2));
        global.Configurator.log.log('[boot-diag] ortho frustum L/R=' +
                                    eng.orthoCamera.left.toFixed(2) + '/' +
                                    eng.orthoCamera.right.toFixed(2) +
                                    ' T/B=' + eng.orthoCamera.top.toFixed(2) + '/' +
                                    eng.orthoCamera.bottom.toFixed(2) +
                                    ' zoom=' + eng.orthoCamera.zoom.toFixed(2));
      }
    }
  }

  /* ----------------------------------------------------------
     VARIANT + RAKE CONTROLLERS
     ---------------------------------------------------------- */
  VARIANT_KEYS[DM_TYPE - 1] = 'kennel_modern';   /* v403 51: KENNEL 5, the modern dog house (the classic's build on legs under a mono-pitch roof, wood cladding, the roof deck with its guard and ramp on the toggle) -- set apart from the list, as the castle's / the hoop coop's */
  VARIANT_KEYS[54 - 1] = 'twist_bench';   /* 54 v414: BENCHES & LOUNGE, the twist bench (L-profiled slats on one rod, each turning to a seat, an armrest or a table) */
  VARIANT_KEYS[53 - 1] = 'garden_pod_fitness';   /* 53 v407: GARDEN POD 2, the fitness (the kitchen pod's shell, stations along the back wall, a pull-up bar + rings on the end wall) */
  VARIANT_KEYS[52 - 1] = 'coop_hoop';   /* 52 v401: COOP 7, the hoop coop (the backyard coop's house inside the hoop house's run of tube hoops and hardware cloth) -- set apart from the list, as the castle's (51: KENNEL 5) */
  VARIANT_KEYS[CS_TYPE - 1] = 'playhouse_castle';   /* v389 50: PLAYHOUSES 8, the castle (two towers + the bridge, the keep's pyramid roof, a ladder, a climbing wall, the slide, monkey bars) -- set here, apart from the list, so 45-49 stay free for the threads adding types in parallel */
  function selectVariant(n, silent) {
    var nClamped = Math.max(1, Math.min(VARIANT_KEYS.length, n | 0));
    if (nClamped === STATE.variant && !silent) return;
    var prevVariant = STATE.variant | 0;
    STATE.variant = nClamped;
    /* The Hollywood swing stands 2.2-3.3 m with its roof: entering it frames
       the whole thing, leaving it goes back to the bench framing. Other
       switches keep the camera where the user left it. */
    var tallN = _isSwingBackType(nClamped) || nClamped === 13 || nClamped === 17 || nClamped === 18 || nClamped === 19, tallP = _isSwingBackType(prevVariant) || prevVariant === 13 || prevVariant === 17 || prevVariant === 18 || prevVariant === 19;   /* v303 + the cinema bar */   /* v296 + the pergola swing */   /* the swings: 2.2-3.6 m */
    /* v309 the fixed presets (bench / swing / cinema bar) gave way to
       _fitView at the end: every piece framed whole on its load */
    void tallN; void tallP;

    /* Switching variant resets the whole scene to defaults — dimensions,
       level, backrest, assembly, viz stage, colour, view, scale figure,
       section cut. Only the user's display preferences (units, 2D fill
       opacity) are preserved. */
    STATE.vizStage       = 1;
    STATE.assemblyStep   = 0;
    STATE.view           = '3d';
    STATE.lvl            = DEFAULTS.lvl;
    STATE.backRakeDeg    = DEFAULTS.backRakeDeg;
    STATE.backrestVisible = DEFAULTS.backrestVisible;
    STATE.picnicSeparate = false;
    STATE.backH          = DEFAULTS.backH;
    STATE.bodyVisible    = false;
    STATE.cutOffset      = null;
    STATE.colorMode      = 'pine';          /* v285 the light wood (was birch) */
    STATE.slats          = 0;
    STATE.slatGap        = SOFA.GAP_DEF;
    STATE.swingBack      = SWING.BACK_DEF;
    STATE.swingRoof      = SWING.ROOF_DEF;
    STATE.swingPitch     = SWING.PITCH[SWING.ROOF_DEF].def;
    STATE.swingCushion   = null;
    STATE.porchH         = PORCH.H_DEF;
    STATE.psofaBack      = PSOFA.BACK_DEF;
    STATE.adiBack        = ADI.BACK_DEF;
    STATE.bedMW          = null;            /* v273: the default mattress of the units */
    STATE.bedHead        = BED.HEAD_DEF;
    STATE.bedHeadStyle   = 'rails';         /* v275 */
    STATE.porchFill      = 'planks';        /* v281 the classic porch swing's back fill */
    STATE.porchGap       = PCL.GAP_DEF;
    STATE.gbArms         = false;           /* v285 the 2x4 bench's armrests */
    STATE.gbArmH         = null;
    STATE.sbW            = null;            /* v288 the sunbed: the size's default width */
    STATE.sbAng          = SB.ANG_DEF;
    STATE.kidsBench      = false;           /* v299 the kids' set opens on its swings */
    STATE.mfFound        = 'screw';         /* v301 the modern swing opens on ground screws, */
    STATE.mfWeave        = false;           /* with the blocks between its beams */
    STATE.mfCant         = false;           /* v308 on all its posts */
    STATE.rtbMode        = 'bench';         /* v414 the twist bench opens as one bench */
    STATE.gsScreen       = true;            /* v303 the cinema bar's screen down */
    STATE.mbRet          = true;            /* v355 the bar opens L-shaped */
    STATE.mbShape        = 'Lr';            /* v357 Adam's: the return at the garden end, */
    STATE.mbRoof         = 'mono';          /* the mono-pitch roof */
    STATE.mbPitch        = null;            /* at 10 deg, */
    STATE.mbH            = null;            /* 2.40 m (US 8 ft) at the front, */
    STATE.mbCov          = true;            /* the corrugated sheets on */
    STATE.gsDrop         = null;            /* v305 its image's bottom: the units' default */
    STATE.rbMode         = 'basic';         /* v314 the raised bed: its mode, width, courses, wings */
    STATE.rbW            = null;
    STATE.rbN            = null;
    STATE.rbOpen         = false;
    STATE.rbTrellis      = true;    /* v316; v325 the raised bed opens with its trellis (Marek 17:27) */
    STATE.gaMode         = 'flat';          /* v320 the garden arbor: its roof, its width */
    STATE.gaW            = null;
    STATE.gaFound        = 'tile';          /* v322 -- its foundation: the pavers */
    STATE.gaGrid         = false;           /* v333 -- its infill: the laths only */
    STATE.gzN            = 6;               /* v328 the gazebo opens as the hexagon */
    STATE.gzFound        = 'screw';         /* v329 -- on ground screws, */
    STATE.peGap          = null;            /* v337 the infill's gap: 40 mm (US 1 1/2 in.) */
    STATE.peW            = null;            /* v334 the pergola: its width (v336 3.00 m / US 10 ft unless dragged), */
    STATE.peRoof         = 'flat';          /* -- a flat roof, */
    STATE.peCov          = false;           /* -- open, */
    STATE.peFillT        = 'h';             /* -- horizontal slats */
    STATE.peFound        = 'screw';         /* -- on ground screws, */
    STATE.peFields       = {};              /* -- every field empty */
    STATE.gzCov          = 'shingle';       /* asphalt shingle, */
    STATE.gzFill         = 'bal';           /* 2x2 slats */
    STATE.gzGap          = null;            /* at the units' default gap */
    STATE.gzFields       = {};
    STATE.ghW            = null;            /* v373 the gable greenhouse: 2.40 m / US 8 ft unless dragged, */
    STATE.ghKnee         = false;           /* -- glazed down to its base */
    STATE.ghBench        = false;           /* v392 -- no benches inside */
    STATE.ghFound        = 'screw';         /* v399 -- on ground screws */
    STATE.ghWin          = null;            /* v390 the old-window greenhouse: 75 x 120 cm (US 30 x 48 in.) sashes unless set */
    STATE.kpOpen         = true;            /* v376 the kitchen pod: its flap open */
    STATE.kpAng          = null;            /* v406 -- its angle: KP.OPEN */
    STATE.kpFrame        = 'wood';          /* v406 -- the counter on 2x4s */
    STATE.kpKinds        = null;            /* v379 -- each bay's default equipment */
    STATE.kpN            = 4;               /* v405 -- four bays (trash, grill, drawer, sink) */
    STATE.kpFound        = 'screw';         /* v405 -- on ground screws */
    STATE.kpClad         = 'h';             /* v405 -- horizontal boards */
    STATE.kpShelf        = false;           /* v405 -- no shelf */
    STATE.kpLad          = 'hooks';         /* v410 -- the fitness's wall bars: the J-hooks low with the barbell */
    STATE.kpRoof         = 'seam';          /* v405 -- standing seam */
    STATE.kpFin          = 'acacia';        /* v405 -- acacia top, painted panel face */
    STATE.phW            = null;            /* v362 the cottage: 1.80 m / US 6 ft unless dragged, */
    STATE.phPorch        = true;            /* -- with its porch */
    STATE.phSlide        = true;            /* v363 the stilt house: with its slide */
    STATE.phSwings       = true;            /* v365 the play fort: with its swings */
    STATE.phLoft         = true;            /* v367 the little barn: with its loft */
    STATE.tfTrunk        = null;            /* v368 the tree fort: a 30 cm / US 12 in. trunk unless set */
    STATE.coHens         = null;            /* v375 the backyard coop: 6 hens unless set, */
    STATE.knDog          = null;            /* v385 the dog house: a 55 cm / US 22 in. dog unless set, */
    if (nClamped === DH_TYPE || nClamped === DI_TYPE || nClamped === DD_TYPE || nClamped === DM_TYPE) STATE.phPorch = false;   /* v403 + the modern (no porch) */   /* -- without its porch (the classic look) */
    STATE.knFlap         = null;            /* v388 the insulated dog house: its flap on unless set */
    STATE.knDeck         = null;            /* v403 the modern dog house: its roof deck on unless set */
    STATE.coRun          = true;            /* -- with its run */
    STATE.ctWheels       = true;            /* v379 the chicken tractor: on its wheels */
    STATE.phRoof         = null;            /* v370 the stilt house / play fort: gable unless 'mono' */              /* v350 -- the railing on every side, the entrance open */
    STATE.csShape        = 'i2';            /* v394 the castle: two towers and a bridge, */
    STATE.csMb           = true;            /* -- with its monkey bars, */
    STATE.csT            = null;            /* -- its towers 1.50 m / US 5 ft in the L unless set */
    STATE.csLook         = 'roof';          /* v398 -- every tower roofed */
    STATE.phFound        = null;            /* v402 the playhouses' foundation: each type's own (the houses on deck blocks, the forts on ground screws) */

    /* Apply this variant's default footprint. */
    var vd = VARIANT_DEFAULTS[nClamped];
    if (vd && typeof vd.lvl === 'number') STATE.lvl = vd.lvl;   /* sofa defaults to lvl 2 */
    if (vd) {
      STATE.L = (typeof vd.L === 'number') ? vd.L : DEFAULTS.L;
      STATE.W = (typeof vd.W === 'number') ? vd.W : DEFAULTS.W;
      STATE.H = (typeof vd.H === 'number') ? vd.H : DEFAULTS.H;
      if (typeof vd.slatGap === 'number') STATE.slatGap = vd.slatGap;   /* wave: slat spacing */
      if (typeof vd.swingBack === 'number') STATE.swingBack = vd.swingBack;   /* porch swing: its own default tilt */
      if (typeof vd.backrestVisible === 'boolean') STATE.backrestVisible = vd.backrestVisible;   /* tree bench: no back by default */
      if (typeof vd.colorMode === 'string' && COLOR_SCHEMES[vd.colorMode] && nClamped !== prevVariant) STATE.colorMode = vd.colorMode;   /* v298 the pergola swing white (a design / the tour set their own after) */
    } else {
      STATE.L = DEFAULTS.L; STATE.W = DEFAULTS.W; STATE.H = DEFAULTS.H;
    }
    if (nClamped === 23) STATE.L = _gzU(STATE, 'S0');   /* v328 the gazebo: 3.00 m / US 10 ft */
    if (nClamped === 24) STATE.L = _peU(STATE, 'S0');   /* v334 the pergola: 3.00 m / US 10 ft */
    if (nClamped === 25) STATE.L = _mbU(STATE, 'L0');
    if (_isGhType(nClamped)) STATE.L = _ghU(STATE, (nClamped === 38) ? 'HL0' : (nClamped === 40) ? 'AL0' : (nClamped === 43) ? 'VL0' : (nClamped === 45) ? 'OL0' : 'L0');   /* v381 the hoop house: 3.60 m / US 12 ft */
    if (nClamped === 43) STATE.ghKnee = true;   /* v387 the Victorian: its knee wall on unless switched off */
    if (_isKpType(nClamped)) STATE.L = _kpU(STATE, 'L0');   /* v376 the kitchen pod: 3.00 m / US 10 ft */   /* v373 the gable greenhouse: 3.00 m / US 10 ft */
    if (_isPhType(nClamped)) STATE.L = _phL0(STATE);   /* v365 + the play fort (1.50 m / US 5 ft) */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 the cottage: 1.80 m / US 6 ft */   /* v355 the bar: 4.80 m / US 16 ft */

    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    try { _syncColorModeDisplay(); } catch (e) {}
    _emitVariantChange();
    if (!silent && typeof savePref === 'function') savePref();
    _fitSoon(true);   /* v309 a new piece on the stage: framed whole */
  }
  /* v309 FIT TO CANVAS (Marek 22:05: pri loadingu musi byt vsechny lavicky
     fit to canvas, nektere mame prilis zoom in, neni videt cela). The
     piece's box (every mesh on show but the scale figure, _tourBox) seen
     from the bench line's view direction (front-right, 15 deg from
     above): its 8 corners on the camera's own axes give the distance at
     which all of them fall inside the FREE part of the canvas -- under
     the size bar, over the info bar and the sliders above it, left of
     the rail -- with a margin; the target is the box's middle moved so
     the piece sits in the middle of that free part. Runs on the page's
     first build and on every variant / design switch, and again once the
     layout has settled, but never after the user has moved the camera
     (until the next switch). Only the 3D view. */
  var FIT = { DIR: [3.5, 1.3, 3.5], MARGIN: 0.90, MIN: 1.2,
              TYPE: { 20: { margin: 0.70, minH: 1.30 } } };   /* v325 the raised bed: more air, framed as if at least 1.30 m tall (a low bed no longer fills the stage) */
  var _fitMoved = false, _fitHooked = false, _fitTimer = null;
  function _fitFree(cv) {
    /* the free rect in NDC (-1..1): [xl, xr, yb, yt] */
    var out = [-1, 1, -1, 1];
    try {
      var R = cv.getBoundingClientRect(), root = document.getElementById('cf-root');
      if (!R || !(R.width > 0) || !(R.height > 0) || !root) return out;
      var top = R.top, bot = R.bottom, right = R.right;
      var sb = root.querySelector('.cf-size-bar'), ib = root.querySelector('.cf-info-bar'), rl = root.querySelector('.cf-sidebar');
      var rows = [ib, document.getElementById('cf-bench-rake-row'), document.getElementById('cf-bench-pitch-row')];
      if (sb && sb.offsetParent !== null) { var rs = sb.getBoundingClientRect(); if (rs.height > 0 && rs.bottom < R.top + R.height * 0.4) top = Math.max(top, rs.bottom + 6); }
      rows.forEach(function (el) {
        if (!el || el.offsetParent === null) return;
        var re = el.getBoundingClientRect();
        if (re.height > 0 && re.top > R.top + R.height * 0.5) bot = Math.min(bot, re.top - 6);
      });
      if (rl && rl.offsetParent !== null) { var rr = rl.getBoundingClientRect(); if (rr.width > 0 && rr.left > R.left + R.width * 0.5) right = Math.min(right, rr.left - 8); }
      if (bot - top < R.height * 0.35 || right - R.left < R.width * 0.5) return out;
      out = [-1, 2 * (right - R.left) / R.width - 1, 1 - 2 * (bot - R.top) / R.height, 1 - 2 * (top - R.top) / R.height];
    } catch (eF) {}
    return out;
  }
  function _fitPts() {
    var E = global.BenchEngine, T = global.THREE, out = [];
    if (!E || !E.benchGroup || !T) return out;
    E.benchGroup.updateMatrixWorld(true);
    E.benchGroup.traverse(function (o) {
      if (!o.isMesh || !o.visible || !o.geometry || !o.geometry.attributes || !o.geometry.attributes.position) return;
      var p = o;
      while (p && p !== E.benchGroup) { if (!p.visible || (p.userData && (p.userData.partType === 'person' || p.userData.partType === 'ph-tree'))) return; p = p.parent; }   /* v368 the tree fort's tree out of the framing */
      var pa = o.geometry.attributes.position, n = pa.count, st = Math.max(1, Math.floor(n / 400)), k;
      for (k = 0; k < n; k += st) out.push(new T.Vector3(pa.getX(k), pa.getY(k), pa.getZ(k)).applyMatrix4(o.matrixWorld));
    });
    return out;
  }
  function _fitView() {
    var E = global.BenchEngine, T = global.THREE;
    if (!E || !E.camera || !E.controls || !T || STATE.view !== '3d') return false;
    var box = _tourBox();
    if (!box) return false;
    var cam = E.camera, ctl = E.controls, asp = cam.aspect || 1.4, i, ft = FIT.TYPE[STATE.variant | 0] || null, mrg = ft ? ft.margin : FIT.MARGIN;
    var tanV = Math.tan(cam.fov * Math.PI / 360), tanH = tanV * asp;
    var fr = _fitFree(E.renderer && E.renderer.domElement), xc = (fr[0] + fr[1]) / 2, yc = (fr[2] + fr[3]) / 2;
    var hx = (fr[1] - fr[0]) / 2 * mrg, hy = (fr[3] - fr[2]) / 2 * mrg;
    var D = new T.Vector3(FIT.DIR[0], FIT.DIR[1], FIT.DIR[2]).normalize(), f = D.clone().negate();
    var r = new T.Vector3().crossVectors(f, new T.Vector3(0, 1, 0)).normalize(), u = new T.Vector3().crossVectors(r, f);
    var c = box.getCenter(new T.Vector3()), dist = FIT.MIN;
    for (i = 0; i < 8; i++) {
      var v = new T.Vector3((i & 1) ? box.max.x : box.min.x, (i & 2) ? box.max.y : box.min.y, (i & 4) ? box.max.z : box.min.z).sub(c);
      var x = v.dot(r), y = v.dot(u), z = v.dot(f);
      dist = Math.max(dist, Math.abs(x) / (tanH * hx) - z, Math.abs(y) / (tanV * hy) - z);
    }
    var tg = c.clone().addScaledVector(r, -xc * dist * tanH).addScaledVector(u, -yc * dist * tanV);
    /* the box's corners overshoot the silhouette (seen from the corner a
       box is wider than the bench in it): refine on the meshes' own
       vertices (sampled, ~400 a mesh) -- project them from the camera
       found, scale the distance to the free rect, recentre; 3 rounds */
    var pts = _fitPts(), it, q = new T.Vector3(), M = new T.Matrix4();
    for (it = 0; it < 3 && pts.length; it++) {
      var cp = tg.clone().addScaledVector(D, dist);
      M.lookAt(cp, tg, new T.Vector3(0, 1, 0)); M.setPosition(cp); M.invert();
      var x0 = 9, x1 = -9, y0 = 9, y1 = -9;
      for (i = 0; i < pts.length; i++) {
        q.copy(pts[i]).applyMatrix4(M);
        if (q.z > -0.05) continue;
        var nx = (q.x / -q.z) / tanH, ny = (q.y / -q.z) / tanV;
        if (nx < x0) x0 = nx; if (nx > x1) x1 = nx; if (ny < y0) y0 = ny; if (ny > y1) y1 = ny;
      }
      if (!(x1 > x0) || !(y1 > y0)) break;
      var sc = Math.max((x1 - x0) / 2 / hx, (y1 - y0) / 2 / hy);
      tg.addScaledVector(r, ((x0 + x1) / 2 - xc) * dist * tanH).addScaledVector(u, ((y0 + y1) / 2 - yc) * dist * tanV);
      dist = Math.max(FIT.MIN, dist * sc);
    }
    if (ft && ft.minH) dist = Math.max(dist, ft.minH * Math.abs(u.y) / (2 * tanV * hy));   /* v325 at least this tall a height on the stage: a low piece no longer blown up */
    if (ctl.maxDistance < dist * 1.6) ctl.maxDistance = dist * 1.6;
    if (ctl.minDistance > dist * 0.5) ctl.minDistance = Math.max(0.5, dist * 0.5);
    if (cam.far < dist * 6) { cam.far = dist * 6; cam.updateProjectionMatrix(); }
    ctl.target.copy(tg);
    cam.position.copy(tg).addScaledVector(D, dist);
    ctl.update();
    _dbg('[fit] type ' + (STATE.variant | 0) + ' box ' + (box.max.x - box.min.x).toFixed(2) + ' x ' + (box.max.y - box.min.y).toFixed(2) + ' x ' + (box.max.z - box.min.z).toFixed(2) +
         ' m, aspect ' + asp.toFixed(2) + ', free x ' + fr[0].toFixed(2) + '..' + fr[1].toFixed(2) + ' y ' + fr[2].toFixed(2) + '..' + fr[3].toFixed(2) + ', distance ' + dist.toFixed(2));
    return true;
  }
  /* now, and once more when the layout has settled (the bars, the sliders,
     the canvas size) -- unless the user has taken the camera meanwhile */
  function _fitSoon(reset) {
    var E = global.BenchEngine;
    if (E && E.controls && !_fitHooked && E.controls.addEventListener) {
      _fitHooked = true;
      E.controls.addEventListener('start', function () { _fitMoved = true; });
      /* the canvas resized (the tablet turned, the layout settled): framed
         again while the user has not taken the camera */
      var rz = null, onRz = function () { if (rz) clearTimeout(rz); rz = setTimeout(function () { rz = null; if (!_fitMoved && !(_T && _T.on)) { try { _fitView(); } catch (eR) {} } }, 250); };
      try { global.addEventListener('resize', onRz); } catch (eW) {}
      try { var cvz = E.renderer && E.renderer.domElement; if (global.ResizeObserver && cvz) new global.ResizeObserver(onRz).observe(cvz); } catch (eO) {}
    }
    if (reset) _fitMoved = false;
    if (_T && _T.on) return;   /* the voice tour frames its own */
    try { _fitView(); } catch (eV) {}
    if (_fitTimer) clearTimeout(_fitTimer);
    _fitTimer = setTimeout(function () { _fitTimer = null; if (!_fitMoved && !(_T && _T.on)) { try { _fitView(); } catch (eV2) {} } }, 450);
  }
  /* next / previous walk the STOREFRONT order when the snippet gave it */
  function nextVariant() {
    if (SLOT_TYPES) { var i = SLOT_TYPES.indexOf(STATE.variant | 0); selectVariant(SLOT_TYPES[(i + 1) % SLOT_TYPES.length]); return; }
    selectVariant((STATE.variant % VARIANT_KEYS.length) + 1);
  }
  function previousVariant() {
    if (SLOT_TYPES) { var j = SLOT_TYPES.indexOf(STATE.variant | 0); selectVariant(SLOT_TYPES[(j - 1 + SLOT_TYPES.length) % SLOT_TYPES.length]); return; }
    var n = STATE.variant - 1;
    if (n < 1) n = VARIANT_KEYS.length;
    selectVariant(n);
  }
  /* Picnic set (type 5): the benches attached to the frames / separate */
  function togglePicnicSeparate() {
    if ((STATE.variant | 0) !== 5) return;
    STATE.picnicSeparate = !_picnicSep(STATE);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function picnicSeparateLabel() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var k = _picnicSep(STATE) ? 'bench_picnic_separate' : 'bench_picnic_attached', v = T[k];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : k;
  }

  /* v275 the bed (type 14): the info-bar toggle walks the headboard --
     rails > slats > crossed boards > no headboard > rails */
  function cycleBedHead() {
    if ((STATE.variant | 0) !== 14) return;
    var cur = _bedStyle(STATE), ord = BED.STYLES.concat(['off']), nx = ord[(ord.indexOf(cur) + 1) % ord.length];
    if (nx === 'off') { STATE.backrestVisible = false; }
    else { STATE.backrestVisible = true; STATE.bedHeadStyle = nx; }
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* the toggle's label for a style (default: the current one) -- existing
     keys: Headboard / Slats (post_wall_slats) / No headboard, + the crossed
     boards' own (bench_headboard_cross) */
  function bedHeadLabel(st) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    st = st || _bedStyle(STATE);
    var k = (st === 'slats') ? 'post_wall_slats' : (st === 'cross') ? 'bench_headboard_cross' : (st === 'off') ? 'bench_headboard_off' : 'bench_headboard_on';
    var fb = { post_wall_slats: 'Slats', bench_headboard_cross: 'Crossed boards', bench_headboard_off: 'No headboard', bench_headboard_on: 'Headboard' };
    var v = T[k];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : fb[k];
  }

  /* v281 the classic porch swing (type 7): the back fill on the toggle
     (planks > slats), its gap on the slider over it (the seat's follows,
     denser); the label = the fill's name (existing keys shelter_fill_boards
     / post_wall_slats) + the gap */
  function cyclePorchFill() {
    if (((STATE.variant | 0) !== 7 && (STATE.variant | 0) !== 17) || _porchStyle(STATE) !== 'classic') return;   /* v296 + the pergola swing's seat */
    STATE.porchFill = (_pclFill(STATE) === 'slats') ? 'planks' : 'slats';
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function porchFillLabel(f, noGap) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    f = f || _pclFill(STATE);
    var k = (f === 'slats') ? 'post_wall_slats' : 'shelter_fill_boards', v = T[k];
    var name = (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : ((f === 'slats') ? 'Slats' : 'Boards');
    if (noGap) return name;
    var g = _pclGap(STATE);
    return name + ' ' + (STATE.isMetric === false ? (g / 0.0254).toFixed(2) + ' in' : Math.round(g * 1000) + ' mm');
  }
  function setPorchGap(m) {
    if (((STATE.variant | 0) !== 7 && (STATE.variant | 0) !== 17) || typeof m !== 'number' || isNaN(m)) return;   /* v296 + the pergola swing */
    STATE.porchGap = Math.max(PCL.GAP_MIN, Math.min(PCL.GAP_MAX, m));
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }

  /* v285 the 2x4 bench (type 15): the armrests on the info-bar toggle */
  function toggleGbArms() {
    if ((STATE.variant | 0) !== 15) return;
    STATE.gbArms = !_gbArmsOn(STATE);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function gbArmsOn() { return _gbArmsOn(STATE); }
  /* v414 the twist bench (type 54): the layout on the info-bar toggle --
     bench > chairs (armrests) > chairs + table */
  function cycleRtbMode() {
    if ((STATE.variant | 0) !== 54) return;
    var M = RTB.MODES, k = M.indexOf(_rtbMode(STATE)), prev = null;
    try { prev = _rtbLayout(STATE).slats.map(function (q) { return q.ang; }); } catch (eP) { prev = null; }
    /* a switch while a turn is on: the next turn starts where the slats are now */
    var from = _rtbAnimNow();
    if (prev && from) prev = prev.map(function (a, i) { var c = from.angs['slat-' + (i + 1)]; return (c != null) ? c : a; });
    _rtbAnimStop();
    STATE.rtbMode = M[(k + 1) % M.length];
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
    if (prev) { try { _rtbAnimate(prev); } catch (eA) { _dbg('[rtb] the turn THREW ' + ((eA && eA.message) || eA)); } }
  }
  /* v416 (Marek: pri prepinani tvaru udelej vzdy pomalou animaci prechodu)
     THE TURN: the new layout is built, then shown coming from the old one --
     each slat whose position changed turned slowly about the rod from its
     old angle to its new one. v419 (Marek 11:01: animace bez zdvihani) the
     bench stays down: the corners sweep through the floor on the way (no
     profile avoids it, status/bench.md). The slats are drawn at their new
     angle, so a slat's mesh is rotated about the rod's axis by (old - new)
     easing to 0. */
  var _rtbAnim = null;
  function _rtbAnimStop() {
    if (!_rtbAnim) return;
    var A = _rtbAnim; _rtbAnim = null;
    A.items.forEach(function (it) { it.m.rotation.z = it.r0; it.m.position.copy(it.p0); });
  }
  /* where a running turn is: each turning slat's angle now */
  function _rtbAnimNow() {
    if (!_rtbAnim) return null;
    var o = { angs: {} };
    _rtbAnim.items.forEach(function (it) { o.angs[it.m.userData.idHint] = it.a1 + (it.th || 0); });
    return o;
  }
  function _rtbAnimate(prev) {
    var E = global.BenchEngine, grp = E && E.benchGroup;
    if (!grp) return;
    var g = _rtbLayout(STATE), h = g.h, items = [], byId = {}, i;
    for (i = 0; i < g.slats.length; i++) if (prev[i] != null && Math.abs(prev[i] - g.slats[i].ang) > 1e-6) byId[g.slats[i].id] = { a0: prev[i], a1: g.slats[i].ang };
    grp.children.forEach(function (c) {
      var pt = (c.userData && c.userData.partType) || '';
      if (pt.indexOf('rtb-slat-') !== 0) return;
      var q = byId[c.userData.idHint];
      if (q) items.push({ m: c, d: q.a0 - q.a1, a0: q.a0, a1: q.a1, p0: c.position.clone(), r0: c.rotation.z });
    });
    if (!items.length) return;
    var MS = 2400, t0 = (global.performance ? global.performance.now() : Date.now()), tok = {};
    _rtbAnim = { items: items, tok: tok };
    var ease = function (u) { u = Math.max(0, Math.min(1, u)); return u < 0.5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2; };
    var place = function (f) {
      var r = 1 - ease(f);
      items.forEach(function (it) {
        var th = it.d * r;
        it.th = th;
        it.m.rotation.z = it.r0 + th;
        it.m.position.set(it.p0.x + h * Math.sin(th), it.p0.y + h - h * Math.cos(th), it.p0.z);
      });
    };
    place(0);
    _dbg('[rtb] the turn: ' + items.length + ' slat(s) to their new position in place, ' + (MS / 1000) + ' s');
    var step = function () {
      if (!_rtbAnim || _rtbAnim.tok !== tok) return;
      /* rebuilt, another type, or the assembly steps took over: stop here */
      if (!items[0].m.parent || (STATE.variant | 0) !== 54 || (STATE.assemblyStep | 0) !== 0) { _rtbAnim = null; items.forEach(function (it) { it.m.rotation.z = it.r0; }); return; }
      var f = Math.min(1, ((global.performance ? global.performance.now() : Date.now()) - t0) / MS);
      place(f);
      if (f < 1) global.requestAnimationFrame(step);
      else _rtbAnimStop();
    };
    global.requestAnimationFrame(step);
  }

  /* v419 (Marek 11:01: do blueprints musi jit presne okotovany tvar, do
     vsech detailu; QR kod na stazeni dxf souboru tvaru) THE DXF of the
     slat: R12, lines + arcs + the hole's circle, in mm (metric) or inches
     (US), the back foot's corner at 0,0; layers OUTLINE and HOLE. */
  function _rtbDxf(us) {
    var G = _rtbSegs({ isMetric: !us }), C = _rtbCheek({ isMetric: !us }), u = us ? 1 / 0.0254 : 1000, h = G.h, o = [], dx = 0;
    var gap = us ? 0.1016 : 0.10, cx0 = 2 * h + gap;   /* v422 the cheek beside the slat, 100 mm (US 4 in.) apart */
    var N4 = function (v) { return String(Math.round(v * 10000) / 10000); };
    var X = function (x) { return N4((x + h + dx) * u); }, Y = function (y) { return N4(y * u); };
    var put = function () { for (var a = 0; a < arguments.length; a++) o.push(String(arguments[a])); };
    put(0, 'SECTION', 2, 'HEADER', 9, '$ACADVER', 1, 'AC1009', 9, '$INSUNITS', 70, us ? 1 : 4,
        9, '$EXTMIN', 10, 0, 20, 0, 30, 0, 9, '$EXTMAX', 10, N4((cx0 + 2 * h) * u), 20, Y(Math.max(G.B, C.R)), 30, 0, 0, 'ENDSEC');
    put(0, 'SECTION', 2, 'TABLES',
        0, 'TABLE', 2, 'LTYPE', 70, 1, 0, 'LTYPE', 2, 'CONTINUOUS', 70, 0, 3, 'Solid line', 72, 65, 73, 0, 40, '0.0', 0, 'ENDTAB',
        0, 'TABLE', 2, 'LAYER', 70, 2,
        0, 'LAYER', 2, 'OUTLINE', 70, 0, 62, 7, 6, 'CONTINUOUS',
        0, 'LAYER', 2, 'HOLE', 70, 0, 62, 1, 6, 'CONTINUOUS', 0, 'ENDTAB', 0, 'ENDSEC');
    put(0, 'SECTION', 2, 'ENTITIES');
    [[G, 0], [C, cx0]].forEach(function (part) {   /* v422 the slat at 0,0, the end cheek beside it */
      dx = part[1];
      part[0].segs.forEach(function (q) {
        if (q.t === 'L') put(0, 'LINE', 8, 'OUTLINE', 10, X(q.a[0]), 20, Y(q.a[1]), 30, 0, 11, X(q.b[0]), 21, Y(q.b[1]), 31, 0);
        else put(0, 'ARC', 8, 'OUTLINE', 10, X(q.c[0]), 20, Y(q.c[1]), 30, 0, 40, N4(q.r * u), 50, Math.min(q.a0, q.a1), 51, Math.max(q.a0, q.a1));   /* DXF arcs run counter-clockwise */
      });
      put(0, 'CIRCLE', 8, 'HOLE', 10, X(part[0].hole.c[0]), 20, Y(part[0].hole.c[1]), 30, 0, 40, N4(part[0].hole.r * u));
    });
    put(0, 'ENDSEC', 0, 'EOF');
    return o.join('\r\n') + '\r\n';
  }
  function _rtbDxfName(us) { return 'leva-twist-bench-' + (us ? 'inch' : 'mm') + '.dxf'; }   /* v422 the slat + the cheek (was -slat-) */
  /* v421 (Marek 12:08: DXF ma byt stazitelne jen pomoci QR na blueprints)
     THE QR'S LINK: made with the PDF -- the DXF stored in leva-share as
     { kind: 'file', name, text } and served by its /f/<id> as a download,
     so the id exists only on the sheet. The same file (units + text) keeps
     its link in this browser (300 days; the store keeps 400). No link
     (offline, refused): the sheet has no QR, the log says why. */
  var RTB_SHARE = 'https://leva-share.long-cloud-d006.workers.dev';
  var _rtbDxfLink = null;
  function _rtbHash(t) { var h = 5381, i; for (i = 0; i < t.length; i++) h = ((h * 33) ^ t.charCodeAt(i)) >>> 0; return h.toString(36) + '-' + t.length; }
  function _rtbDxfStore(us) {
    var text = _rtbDxf(!!us), key = 'leva-rtb-dxf-' + (us ? 'in' : 'mm'), hv = _rtbHash(text), c = null;
    try { c = JSON.parse(global.localStorage.getItem(key) || 'null'); } catch (eC) { c = null; }
    if (c && c.h === hv && c.id && (Date.now() - (c.t || 0)) < 300 * 86400000) {
      _dbg('[rtb] DXF link kept: ' + RTB_SHARE + '/f/' + c.id);
      _rtbDxfLink = RTB_SHARE + '/f/' + c.id;
      return Promise.resolve(_rtbDxfLink);
    }
    var body = JSON.stringify({ kind: 'file', name: _rtbDxfName(!!us), text: text, v: VERSION });
    var to = new Promise(function (res) { setTimeout(function () { res(null); }, 6000); });
    var go = global.fetch(RTB_SHARE + '/s', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !/^[a-z0-9]{6,12}$/.test(j.id || '')) { _dbg('[rtb] DXF link: the store said no'); return null; }
        try { global.localStorage.setItem(key, JSON.stringify({ h: hv, id: j.id, t: Date.now() })); } catch (eS) {}
        _dbg('[rtb] DXF link made: ' + RTB_SHARE + '/f/' + j.id + ' (' + text.length + ' bytes)');
        return RTB_SHARE + '/f/' + j.id;
      })
      .catch(function (eF) { _dbg('[rtb] DXF link THREW ' + ((eF && eF.message) || eF)); return null; });
    return Promise.race([go, to]).then(function (u) { if (!u) _dbg('[rtb] DXF link: none -- the slat sheet goes without its QR'); _rtbDxfLink = u || null; return u; });
  }
  function rtbModeLabel(m) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, mm = m || _rtbMode(STATE);
    var k = (mm === 'chairs') ? 'bench_armrests' : (mm === 'table') ? 'bench_rtb_table' : 'bench_rtb_bench', v = T[k];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : ((mm === 'chairs') ? 'Armrests' : (mm === 'table') ? 'Side table' : 'Bench');
  }

  /* v303 the cinema bar (type 19): the screen rolled up / down on the info-bar toggle */
  function toggleGsScreen() {
    if ((STATE.variant | 0) !== 19) return;
    STATE.gsScreen = !_gsScreenOn(STATE);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function gsScreenOn() { return _gsScreenOn(STATE); }
  /* v355 the bar (type 25): its counter L-shaped (the return at the garden end) / straight on the info-bar toggle */
  function toggleMbRet() {
    if ((STATE.variant | 0) !== 25) return;
    STATE.mbShape = _mbRet(STATE) ? 'I' : 'Lr';   /* v357 L right <> I */
    STATE.mbRet = (STATE.mbShape !== 'I');
    _mbRebuild(false);
  }
  function mbRetOn() { return _mbRet(STATE); }
  /* v357 (Marek 18:54) the bar's options on the info bar: the counter's shape on the toggle (L right > L left > U > I), the roof on the
     next switch (mono-pitch <> gable, its pitch on the slider over it), the sheets on / off, the height on the last column's slider */
  function _mbRebuild(fit) {
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    try { if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition(); } catch (eH) {}
    if (fit) _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  function cycleMbShape() {
    if ((STATE.variant | 0) !== 25) return;
    STATE.mbShape = MB_SHAPES[(MB_SHAPES.indexOf(_mbShape(STATE)) + 1) % MB_SHAPES.length];
    STATE.mbRet = (STATE.mbShape !== 'I');
    _mbRebuild(false);
  }
  function mbShapeLabel(sh) {
    sh = (MB_SHAPES.indexOf(sh) >= 0) ? sh : _mbShape(STATE);
    return (sh === 'Ll') ? _gzLbl('bench_mb_l_left', 'L left') : (sh === 'U') ? _gzLbl('base_shape_u', 'U shape') : (sh === 'I') ? _gzLbl('bench_mb_i', 'I shape') : _gzLbl('bench_mb_l_right', 'L right');
  }
  function cycleMbRoof() { if ((STATE.variant | 0) !== 25) return; STATE.mbRoof = (_mbRoof(STATE) === 'gable') ? 'mono' : 'gable'; STATE.mbPitch = null; _mbRebuild(true); }   /* each roof at its own pitch */
  function mbRoofLabel(r) { r = (r === 'mono' || r === 'gable') ? r : _mbRoof(STATE); return (r === 'gable') ? _gzLbl('roof_v1', 'Gable') : _gzLbl('roof_v4', 'Mono-pitch'); }
  function mbPitchRange() { var R = _mbPitchRange(STATE); return { min: R.min, max: R.max, value: _mbPitch(STATE) }; }
  function setMbPitch(d) { if ((STATE.variant | 0) !== 25 || typeof d !== 'number' || isNaN(d)) return; STATE.mbPitch = Math.round(d); _mbRebuild(false); }
  function toggleMbCov() { if ((STATE.variant | 0) !== 25) return; STATE.mbCov = !_mbCov(STATE); _mbRebuild(false); }
  function mbCovLabel(c) { c = (c === true || c === false) ? c : _mbCov(STATE); return c ? _gzLbl('mc_cov_corrugated', 'Corrugated sheet') : _gzLbl('taurus_open', 'Open'); }
  function mbHRange() { var R = _mbHRange(STATE); return { min: Math.round(R.min * 1000), max: Math.round(R.max * 1000), value: Math.round(_mbH(STATE) * 1000) }; }   /* mm */
  function setMbH(m) { if ((STATE.variant | 0) !== 25 || typeof m !== 'number' || isNaN(m)) return; STATE.mbH = m; _mbRebuild(false); }
  /* v314 the raised bed (type 20): its mode on the info bar's switch
     (basic > pyramid > cold frame; each starts at its own size), its
     wings open / closed on the toggle (the cold frame only) */
  function cycleRbMode() {
    if ((STATE.variant | 0) !== 20) return;
    var o = ['basic', 'pyramid', 'wings'];
    STATE.rbMode = o[(o.indexOf(_rbMode(STATE)) + 1) % o.length];
    var c = _rbCfg(STATE);
    STATE.L = c.L0; STATE.rbW = c.W0; STATE.rbN = c.N0; STATE.rbOpen = false; STATE.rbTrellis = true;   /* v325 back on the basic bed: with its trellis */
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  function toggleRbOpen() {
    if ((STATE.variant | 0) !== 20 || _rbMode(STATE) !== 'wings') return;
    STATE.rbOpen = !(STATE.rbOpen === true);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);   /* v325 the open wings framed too */
    if (typeof savePref === 'function') savePref();
  }
  /* v316 the basic bed's trellis on / off (the toggle) */
  function toggleRbTrellis() {
    if ((STATE.variant | 0) !== 20 || _rbMode(STATE) !== 'basic') return;
    STATE.rbTrellis = (STATE.rbTrellis === false);   /* v325 undefined = on */
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  /* v320 the garden arbor (type 22): its roof on the info bar's switch
     (flat <> gable -- only the roof changes, the size stays); v321 no
     toggle (the path's tiles gone: a paver under each post instead) */
  function cycleGaMode() {
    if ((STATE.variant | 0) !== 22) return;
    var gm0 = _gaMode(STATE);
    STATE.gaMode = (gm0 === 'flat') ? 'gable' : (gm0 === 'gable') ? 'arch' : 'flat';   /* v331 flat > gable > arch > flat */
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  /* v322 the garden arbor's foundation on the toggle: pavers > ground
     screws > deck blocks > pavers (the size and the roof stay) */
  function cycleGaFound() {
    if ((STATE.variant | 0) !== 22) return;
    var f = _gaFound(STATE);
    STATE.gaFound = (f === 'tile') ? 'screw' : (f === 'screw') ? 'block' : 'tile';
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  /* v333 the garden arbor's infill on the info bar's switch: the laths <> the trellis (an upright layer inside them) */
  function cycleGaGrid() {
    if ((STATE.variant | 0) !== 22) return;
    STATE.gaGrid = !_gaGrid(STATE);
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function gaGridLabel(g) { g = (g === true || g === false) ? g : _gaGrid(STATE); return g ? _gzLbl('bench_rb_trellis', 'Trellis') : _gzLbl('post_wall_slats', 'Slats'); }
  function gaFoundLabel(found) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var f = (found === 'tile' || found === 'screw' || found === 'block') ? found : _gaFound(STATE);
    var v = (f === 'screw') ? T.base_v5 : (f === 'block') ? T.base_count_precast : T.terrace_pavers;
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : (f === 'screw' ? 'Ground screws' : f === 'block' ? 'Precast pads' : 'Pavers');
  }
  /* v328 the gazebo (type 23): its shape on the info bar's switch --
     hexagon <> square (the width across the flats stays) */
  function cycleGzN() {
    if ((STATE.variant | 0) !== 23) return;
    STATE.gzN = (_gzN(STATE) === 6) ? 4 : 6;
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  /* v329 the gazebo's options: the foundation on the toggle (ground screws >
     precast pads > poured footings), the covering and the infill on their
     switches, the infill's clear gap on the slider (mm) */
  /* v334 the pergola (type 24): its options on the info bar -- the
     foundation (the toggle), the roof, the covering, the infill's kind
     (v336 no shape switch); each field on its + button */
  function _peRebuild(fit) {
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    try { if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition(); } catch (eH) {}   /* the + buttons' icons / places now */
    if (fit) _fitSoon(true);
    if (typeof savePref === 'function') savePref();
  }
  /* v362 the cottage (type 26): its porch on the info bar's toggle (the house's size stays; framed again: the model grows / shrinks by the porch) */
  function togglePhPorch() { if ((STATE.variant | 0) !== 26 && (STATE.variant | 0) !== 28 && (STATE.variant | 0) !== 30 && (STATE.variant | 0) !== DH_TYPE && (STATE.variant | 0) !== KR_TYPE && (STATE.variant | 0) !== DD_TYPE) return;   /* v392 + the kennel's run */   /* v385 + the dog house */   /* v366 + the modern house */   /* v364 + the A-frame (its porch under the roof) */
    STATE.phPorch = !_phPorch(STATE); _peRebuild(true); }
  /* v363 the stilt house (type 27): its slide on the info bar's toggle (the right side's guard back when it is off) */
  function togglePhSlide() { if ((STATE.variant | 0) !== 27 && (STATE.variant | 0) !== 32 && !_phIsCs(STATE)) return; STATE.phSlide = !_phSlide(STATE); _peRebuild(true); }   /* v368 + the tree fort */
  /* v394 the castle's plan on the top switch (two towers > three in a row > three in an L; the towers' size and the bridges kept), its monkey bars on their own switch */
  function csShape() { return _csShape(STATE); }
  function csShapeLabel(v) { v = (v === 'i2' || v === 'i3' || v === 'l') ? v : _csShape(STATE); return (v === 'l') ? _gzLbl('base_shape_l', 'L shape') : (v === 'i3') ? _gzLbl('bench_cs_3t', '3 Towers') : _gzLbl('bench_cs_2t', '2 Towers'); }
  function cycleCsShape() {
    if (!_phIsCs(STATE)) return;
    var T = _csT(STATE), ba = _csBR(STATE), bb = _csBR2(STATE), cur = _csShape(STATE), nx = (cur === 'i2') ? 'i3' : (cur === 'i3') ? 'l' : 'i2';
    STATE.csShape = nx;
    if (nx === 'l') { STATE.csT = T; STATE.phW = _csR4(2 * T + ba); STATE.L = _csR4(2 * T + ((cur === 'l') ? bb : ba)); }
    else { STATE.L = T; STATE.phW = _csR4(((nx === 'i3') ? 3 : 2) * T + ((nx === 'i3') ? 2 : 1) * ba); }
    _peRebuild(true);
  }
  function csMbOn() { return _csMb(STATE); }
  function toggleCsMb() { if (!_phIsCs(STATE)) return; STATE.csMb = !_csMb(STATE); _peRebuild(true); }
  /* v398 (Marek 2026-10-30 18:10: Prepinac monkey bar spojit se slides, bude se cyklovat slides / monkey bar / monkey bar+slide /
     nothing a misto monkey bar prepinac na tvar vezi - nizka / se strechou / vysoka / kombinace) the toggle = the play, the second
     switch = the towers' look */
  function csPlay() { return _csPlay(STATE); }
  function csPlayLabel(v) { v = (v === 'slide' || v === 'mb' || v === 'both' || v === 'none') ? v : _csPlay(STATE); return (v === 'slide') ? _gzLbl('bench_ph_slide', 'Slide') : (v === 'mb') ? _gzLbl('bench_cs_mb', 'Monkey Bars') : (v === 'both') ? _gzLbl('all', 'All') : _gzLbl('bench_cs_none', 'None'); }
  function cycleCsPlay() {
    if (!_phIsCs(STATE)) return;
    var cur = _csPlay(STATE), nx = (cur === 'slide') ? 'mb' : (cur === 'mb') ? 'both' : (cur === 'both') ? 'none' : 'slide';
    STATE.phSlide = (nx === 'slide' || nx === 'both'); STATE.csMb = (nx === 'mb' || nx === 'both');
    _peRebuild(true);
  }
  /* v402 (Marek 2026-10-30 20:27: Stavby udelej variantni zalozeni, i na vrutech. Prepinani dole v banneru) the playhouses' foundation
     on the info bar's last switch: ground screws > precast pads > concrete pads (the gazebo's order and labels) */
  function phFoundOn() { return _phFoundOn(STATE); }
  function phFound() { return _phFound(STATE); }
  function phFoundLabel(f) { f = (f === 'screw' || f === 'block' || f === 'pier') ? f : _phFound(STATE); return (f === 'block') ? _gzLbl('base_count_precast', 'Precast pads') : (f === 'pier') ? _gzLbl('base_v3', 'Concrete pads') : _gzLbl('base_v5', 'Ground screws'); }
  function cyclePhFound() {
    if (!_phFoundOn(STATE)) return;
    var f = _phFound(STATE);
    STATE.phFound = (f === 'screw') ? 'block' : (f === 'block') ? 'pier' : 'screw';
    _peRebuild(false);
  }
  function csLook() { return _csLook(STATE); }
  function csLookLabel(v) { v = (v === 'low' || v === 'roof' || v === 'tall' || v === 'mix') ? v : _csLook(STATE); return (v === 'low') ? _gzLbl('bench_cs_low', 'Low') : (v === 'tall') ? _gzLbl('bench_cs_tall', 'Tall') : (v === 'mix') ? _gzLbl('bench_cs_mix', 'Mixed') : _gzLbl('roof', 'Roof'); }
  function cycleCsLook() {
    if (!_phIsCs(STATE)) return;
    var cur = _csLook(STATE);
    STATE.csLook = (cur === 'low') ? 'roof' : (cur === 'roof') ? 'tall' : (cur === 'tall') ? 'mix' : 'low';
    _peRebuild(true);
  }
  /* v370 the stilt house's / play fort's roof on the info bar's top switch: gable <> mono-pitch (the house line's roof_v1 / roof_v4) */
  function phRoof() { return _phRoofMono(STATE) ? 'mono' : 'gable'; }
  function phRoofLabel(r) { r = (r === 'mono' || r === 'gable') ? r : phRoof(); return (r === 'mono') ? _gzLbl('roof_v4', 'Mono-pitch') : _gzLbl('roof_v1', 'Gable'); }
  function togglePhRoof() { var v = STATE.variant | 0; if (v !== 27 && v !== 29) return; STATE.phRoof = _phRoofMono(STATE) ? 'gable' : 'mono'; _peRebuild(true); }
  /* v368 the tree fort (type 32): the trunk's diameter on the slider (mm; whole cm, US whole inches) */
  function tfTrunkRange() { var R = _tfU(STATE, 'TRUNK'), us = (STATE.isMetric === false); return { min: Math.round(R[0] * 10000) / 10, max: Math.round(R[1] * 10000) / 10, step: us ? 25.4 : 10, value: Math.round(_tfTrunk(STATE) * 10000) / 10 }; }
  function setTfTrunk(m) { if ((STATE.variant | 0) !== 32 || typeof m !== 'number' || isNaN(m)) return; STATE.tfTrunk = _tfTrunk({ isMetric: STATE.isMetric, tfTrunk: m }); _peRebuild(false); }
  /* v385 the dog house: the dog's height at the withers on the slider (mm: whole cm, US whole inches); a change fits L / W to the dog again */
  function knDogRange() { var R = _phU(STATE, 'DOG'), us = (STATE.isMetric === false); return { min: Math.round(R[0] * 10000) / 10, max: Math.round(R[1] * 10000) / 10, step: us ? 25.4 : 10, value: Math.round(_dhDog(STATE) * 10000) / 10 }; }
  function setKnDog(m) {
    if (!_phIsDh(STATE) || typeof m !== 'number' || isNaN(m)) return;
    var v = _dhDog({ variant: STATE.variant | 0, isMetric: STATE.isMetric, knDog: m });   /* v388 either dog house */
    if (STATE.knDog != null && v === _dhDog(STATE)) return;
    STATE.knDog = v; STATE.L = _dhRange(STATE).min; STATE.phW = _dhWRange(STATE).min;
    _peRebuild(false);
  }
  /* v388 the insulated dog house (type 44): its flap on the info bar's toggle (on) */
  function knFlapOn() { return _dhFlap(STATE); }
  function toggleKnFlap() { if (!_phIsDi(STATE)) return; STATE.knFlap = !_dhFlap(STATE); _peRebuild(true); }
  function knDeckOn() { return _dmDeck(STATE); }   /* v403 the modern dog house: its roof deck on the toggle */
  function toggleKnDeck() { if (!_phIsDm(STATE)) return; STATE.knDeck = !_dmDeck(STATE); _peRebuild(true); }
  /* v375 the backyard coop (type 34): the hens on the slider (2-12; the run's length fits the flock again), the run on the info bar's toggle */
  function coHensRange() { var t = ((STATE.variant | 0) === 37), H = t ? CT.HENS : _coU(STATE, 'HENS'); return { min: H[0], max: H[1], step: 1, value: t ? _ctHens(STATE) : _coHens(STATE) }; }   /* v379 + the chicken tractor's (2-6) */
  function setCoHens(n) { var v = STATE.variant | 0; if ((v !== 34 && v !== 37 && v !== 39 && v !== 42 && v !== 46 && v !== 49 && v !== 52) || typeof n !== 'number' || isNaN(n)) return; var H = (v === 37) ? CT.HENS : _coU(STATE, 'HENS'), h = Math.max(H[0], Math.min(H[1], Math.round(n))); if (h === ((v === 37) ? _ctHens(STATE) : _coHens(STATE))) return; STATE.coHens = h; STATE.L = (v === 37) ? _ctRange(STATE).min : _coRange(STATE).min; if (v === 46) STATE.phW = _cuWRange(STATE).min; _peRebuild(false); }   /* v391 + the cupola coop's whole width */   /* v379 + the chicken tractor */
  function toggleCoRun() { if ((STATE.variant | 0) !== 34 && (STATE.variant | 0) !== 39 && (STATE.variant | 0) !== 42 && (STATE.variant | 0) !== 46 && (STATE.variant | 0) !== 49 && (STATE.variant | 0) !== 52) return; STATE.coRun = !_coRun(STATE); STATE.L = _coRange(STATE).min; if ((STATE.variant | 0) === 46) STATE.phW = _cuWRange(STATE).min; _peRebuild(true); }
  function toggleCtWheels() { if ((STATE.variant | 0) !== 37) return; STATE.ctWheels = !_ctWheels(STATE); _peRebuild(true); }   /* v379 the chicken tractor's wheels on the toggle */
  /* v365 the play fort (type 29): its swing beam, A-frame and swings on the info bar's toggle */
  function togglePhSwings() { if ((STATE.variant | 0) !== 29) return; STATE.phSwings = !_pfSwings(STATE); _peRebuild(true); }
  /* v367 the little barn (type 31): its loft (joists, floor, guard, ladder) on the info bar's toggle */
  /* v373 the gable greenhouse (type 33): its knee wall on the info bar's toggle (the size stays) */
  function cycleGhFound() { if (!_isGhType(STATE.variant)) return; var f = _ghFound(STATE); STATE.ghFound = (f === 'screw') ? 'block' : (f === 'block') ? 'pier' : 'screw'; _peRebuild(false); }   /* v399 the foundation's switch */
  function ghFoundLabel(f) { f = (f === 'screw' || f === 'block' || f === 'pier') ? f : _ghFound(STATE); return (f === 'block') ? _gzLbl('base_count_precast', 'Precast pads') : (f === 'pier') ? _gzLbl('base_v3', 'Concrete pads') : _gzLbl('base_v5', 'Ground screws'); }
  function toggleGhBench() { if (!_isGhType(STATE.variant)) return; STATE.ghBench = !(STATE.ghBench === true); _peRebuild(false); }   /* v392 the benches on the top switch */
  function toggleGhKnee() { if (!_isGhType(STATE.variant)) return; STATE.ghKnee = !(STATE.ghKnee === true); _peRebuild(false); }   /* v381 its key (the hoop house's roll-up sides too) */
  /* v390 the old-window greenhouse (type 45): its sashes' stock size on the slider (an index); the plan keeps its metres, snapped to whole sashes again */
  function ghWinRange() { var Wn = _ghWin(STATE); return { min: 0, max: Wn.n - 1, step: 1, value: Wn.i }; }
  function setGhWin(i) {
    if (!_ghOld(STATE) || typeof i !== 'number' || isNaN(i)) return;
    var Wn = _ghWin(STATE), v = Math.max(0, Math.min(Wn.n - 1, Math.round(i)));
    if (STATE.ghWin != null && v === Wn.i) return;
    STATE.ghWin = v;   /* the plan keeps its metres (dragged or the default) and snaps to the new sashes: no drift back and forth */
    _peRebuild(false);
  }
  function ghWinLabel() { var Wn = _ghWin(STATE); return (STATE.isMetric === false) ? { val: Math.round(Wn.w / 0.0254) + ' \u00d7 ' + Math.round(Wn.h / 0.0254), unit: 'in' } : { val: Math.round(Wn.w * 100) + ' \u00d7 ' + Math.round(Wn.h * 100), unit: 'cm' }; }
  /* v376 the kitchen pod (type 35): its flap open / shut on the info bar's toggle (framed again: the open flap reaches far out) */
  function toggleKpOpen() { if (!_isKpType(STATE.variant)) return; STATE.kpAng = (_kpAng(STATE) > 0.5) ? 0 : KP.OPEN; STATE.kpOpen = (STATE.kpAng > 0.5); _peRebuild(true); }
  /* v406 the flap's slider over the info bar: a rebuild while it moves, the UI / prefs / Undo when it is let go */
  function setKpAng(v, done) {
    if (!_isKpType(STATE.variant)) return;
    var v0 = Math.max(0, Math.min(2 * KP.OPEN, Math.round(+v || 0)));   /* v412 the kitchen: 0 .. 85 the flap, 85 .. 170 the drawers and doors (v415 the fitness: the bag's gallows + the TV, the equipment out at the end) */
    var a = Math.min(KP.OPEN, v0), e = Math.max(0, v0 - KP.OPEN) / KP.OPEN;
    if (a === _kpAng(STATE) && e === _kpExt(STATE) && !done) return;
    STATE.kpAng = a; STATE.kpExt = e; STATE.kpOpen = (a > 0.5);
    if (!done) { try { global.BenchRenderer.build(); } catch (eB) {} try { if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition(); } catch (eH) {} return; }
    _peRebuild(false);
  }
  var _kpFlapWired = false;
  function _kpFlapSliderSync() {
    var row = (typeof document !== 'undefined') ? document.getElementById('cf-bench-flap-row') : null, r = row ? document.getElementById('cf-bench-flap') : null;
    if (!row || !r) return;
    var paint = function () { var pct = (parseFloat(r.value) || 0) / (parseFloat(r.max) || KP.OPEN) * 100; r.style.background = 'linear-gradient(to right, #c79a4a 0%, #c79a4a ' + pct + '%, rgba(0,0,0,0.10) ' + pct + '%, rgba(0,0,0,0.10) 100%)'; };
    if (!_kpFlapWired) {
      _kpFlapWired = true;
      r.min = '0'; r.step = '1';
      r.addEventListener('input', function () { paint(); setKpAng(this.value, false); });
      r.addEventListener('change', function () { paint(); setKpAng(this.value, true); _dbg('[kp] flap -> ' + Math.round(_kpAng(STATE)) + ' deg, ' + (_kpIsFp(STATE) ? 'bag / TV / equipment' : 'drawers / doors') + ' ' + Math.round(_kpExt(STATE) * 100) + ' %'); });
    }
    var on = _isKpType(STATE.variant) && (STATE.assemblyStep | 0) === 0 && STATE.view !== '2d';
    row.classList.toggle('cf-visible', on);
    if (on) r.max = String(2 * KP.OPEN);   /* v412 the kitchen's two halves (v415 the fitness's too) */
    if (on && document.activeElement !== r) { r.value = String(Math.round(_kpAng(STATE) + _kpExt(STATE) * KP.OPEN)); paint(); }
  }
  function cycleKpFrame() {   /* v412 the counter's look (frame + finish): panels > timber > stone > inox */
    if (!_isKpType(STATE.variant)) return;
    var nx = KP_LOOKS[(_kpLookI(STATE) + 1) % KP_LOOKS.length];
    STATE.kpFrame = nx.frame; STATE.kpFin = nx.fin; _peRebuild(false);
    _dbg('[kp] look -> ' + nx.id + ' (' + nx.frame + ' frame, ' + nx.fin + ')');
  }
  function kpLookLabel(id) { var i = -1, k; for (k = 0; k < KP_LOOKS.length; k++) if (KP_LOOKS[k].id === id) i = k; var L0 = KP_LOOKS[i >= 0 ? i : _kpLookI(STATE)]; return _gzLbl(L0.key, L0.en); }
  function kpFrameLabel(f) { f = (f === 'wood' || f === 'steel') ? f : _kpFrame(STATE); return (f === 'steel') ? _gzLbl('structure_v4', 'Steel frame') : _gzLbl('structure_v2', 'Timber frame'); }
  /* v379 a bay's + disc: the next kind of KP_KINDS that fits the bay (grill, sink, kamado, side burner, pizza oven, fridge, drawers, door,
     double door, trash); only that bay's choice stored, by index (STATE.kpKinds; the others keep the length's default) */
  function cycleKpBay(id) {
    if (!_isKpType(STATE.variant) || !id) return;
    if (/^kp-/.test(String(id))) { cycleKpOpt(String(id)); return; }   /* v405 the shelf's / roof's / counter finish's discs */
    var i = parseInt(String(id).replace(/^bay-/, ''), 10), g = _kpLayout(STATE), b = g.bays[i], n;
    if (!b) return;
    var KL = KP_KINDS, j = KL.indexOf(b.kind), nx = b.kind, cur = g.bays.map(function (q) { return q.kind; });   /* the cap, the gas (_kpKindsOK) */
    for (n = 1; n <= KL.length; n++) { var c = KL[(j + n) % KL.length], tk = cur.slice(); tk[i] = c; if (_kpKindsOK(STATE, tk)) { nx = c; break; } }   /* the next kind whose own width the length still takes */
    var K = Array.isArray(STATE.kpKinds) ? STATE.kpKinds.slice() : [];
    while (K.length <= i) K.push(null);
    K[i] = nx;
    STATE.kpKinds = K;
    _gzRebuild();
  }
  /* v405 the top switch: 3 > 4 > 5 bays. Untouched bays: the number's defaults; chosen ones kept -- one more: a drawer at the end (a
     trash drawer if a drawer would pass the cap; a number that cannot fit skipped); one fewer: the last storage bay (drawer, door, double
     door, trash) goes, else the last bay */
  function cycleKpN() {
    if (!_isKpType(STATE.variant)) return;
    if (_kpIsFp(STATE)) { var nF = _kpN(STATE); STATE.kpN = (nF === 3) ? 4 : (nF === 4) ? 5 : 3; STATE.kpKinds = null; _gzRebuild(); return; }   /* v409 the fitness: its length 2.70 > 3.15 > 3.60 m (US 9 > 10 1/2 > 12 ft) */
    var cur = _kpKindsOf(STATE), n0 = cur.length, base0 = KP_N0[n0], touched = false, i, step, cutRe = /^(drawer|door|ddoor|trash)$/;   /* v407 the fitness: a dumbbells' / rower's bay goes, a dumbbells' comes */
    for (i = 0; i < n0; i++) if (cur[i] !== base0[i]) touched = true;
    for (step = 1; step <= 2; step++) {
      var n = [3, 4, 5][([3, 4, 5].indexOf(n0) + step) % 3];
      if (!touched) { STATE.kpN = n; STATE.kpKinds = null; break; }
      var K = cur.slice(0);
      while (K.length > n) {
        var cut = -1;
        for (i = K.length - 1; i >= 0 && cut < 0; i--) if (cutRe.test(K[i])) cut = i;
        K.splice(cut >= 0 ? cut : K.length - 1, 1);
      }
      while (K.length < n) K.push(_kpLOf(STATE, K.concat(['drawer'])) <= _kpLmax(STATE) + 1e-6 ? 'drawer' : 'trash');
      if (!_kpKindsOK(STATE, K)) continue;
      STATE.kpN = n; STATE.kpKinds = K;
      break;
    }
    _gzRebuild();
  }
  function kpN() { return _isKpType(STATE.variant) ? _kpN(STATE) : 0; }
  /* v405 the discs that are no bay: the shelf on / off, the roof's covering (standing seam > EPDM > green roof), the counter's finish
     (acacia top + painted panel > concrete top + stone veneer > granite top + wood slats) */
  function cycleKpOpt(id) {
    if (id === 'kp-shelf') STATE.kpShelf = !_kpShelf(STATE);
    else if (id === 'kp-roof') { var rf = _kpRoof(STATE); STATE.kpRoof = (rf === 'seam') ? 'epdm' : (rf === 'epdm') ? 'green' : 'seam'; }
    else if (id === 'kp-fin') { var nl = KP_LOOKS[(_kpLookI(STATE) + 1) % KP_LOOKS.length]; STATE.kpFrame = nl.frame; STATE.kpFin = nl.fin; }   /* v412 no disc any more (the bar's switch) */
    else if (id === 'kp-lad') STATE.kpLad = (_kpLad(STATE) === 'hooks') ? 'dip' : 'hooks';   /* v409 the fitness's wall bars (v410: J-hooks <> dip bars + rings) */
    else return;
    _gzRebuild();
  }
  /* v405 the third switch: ground screws > precast pads > concrete pads (the greenhouses' labels) */
  function cycleKpFound() { if (!_isKpType(STATE.variant)) return; var f = _kpFound(STATE); STATE.kpFound = (f === 'screw') ? 'block' : (f === 'block') ? 'pier' : 'screw'; _peRebuild(false); }
  /* v405 the fourth switch: horizontal > vertical > board & batten */
  function cycleKpClad() { if (!_isKpType(STATE.variant)) return; var c = _kpClad(STATE); STATE.kpClad = KP_CLAD_ORDER[(KP_CLAD_ORDER.indexOf(c) + 1) % KP_CLAD_ORDER.length]; _peRebuild(false); }   /* v413 + the panels */
  function kpCladLabel(c) { c = (KP_CLAD_ORDER.indexOf(c) >= 0) ? c : _kpClad(STATE); if (KP_PCLAD[c]) return _gzLbl(KP_PCLAD[c].key, KP_PCLAD[c].en); return (c === 'v') ? _gzLbl('cladding_vertical', 'Vertical') : (c === 'bb') ? _gzLbl('bench_kp_bnb', 'Board & batten') : _gzLbl('cladding_horizontal', 'Horizontal'); }
  function kpFoundLabel(f) { f = (f === 'screw' || f === 'block' || f === 'pier') ? f : _kpFound(STATE); return (f === 'block') ? _gzLbl('base_count_precast', 'Precast pads') : (f === 'pier') ? _gzLbl('base_v3', 'Concrete pads') : _gzLbl('base_v5', 'Ground screws'); }
  function kpBayKinds() { return _isKpType(STATE.variant) ? _kpLayout(STATE).bays.map(function (b) { return b.kind; }) : []; }
  function togglePhLoft() { if ((STATE.variant | 0) !== 31) return; STATE.phLoft = !_brLoft(STATE); _peRebuild(true); }
  function cyclePeFound() { if ((STATE.variant | 0) !== 24) return; var f = _peFound(STATE); STATE.peFound = (f === 'screw') ? 'block' : (f === 'block') ? 'pier' : 'screw'; _peRebuild(false); }
  function cyclePeRoof() { if ((STATE.variant | 0) !== 24) return; var r = _peRoof(STATE); STATE.peRoof = (r === 'flat') ? 'gable' : (r === 'gable') ? 'hip' : 'flat'; _peRebuild(true); }
  function cyclePeCov() { if ((STATE.variant | 0) !== 24) return; STATE.peCov = !_peCov(STATE); _peRebuild(false); }
  function cyclePeFill() { if ((STATE.variant | 0) !== 24) return; var f = _peFillT(STATE); STATE.peFillT = (f === 'h') ? 'v' : (f === 'v') ? 'lat' : (f === 'lat') ? 'hlat' : (f === 'hlat') ? 'xlat' : 'h'; _peRebuild(false); }   /* v338 + the two combined */
  /* v337 the infill's clear gap on the slider, mm (as the gazebo's) */
  function peGapRange() { var R = _peGapRange(STATE); return { min: Math.round(R.min * 1000), max: Math.round(R.max * 1000), value: Math.round(_peGap(STATE) * 1000) }; }
  function setPeGap(m) { if ((STATE.variant | 0) !== 24 || typeof m !== 'number' || isNaN(m)) return; STATE.peGap = m; _peRebuild(false); }
  function cyclePeField(id) {
    if ((STATE.variant | 0) !== 24 || !id) return;
    var F0 = _peFields(STATE), F = {}, k;
    for (k in F0) if (F0.hasOwnProperty(k)) F[k] = F0[k];
    F[id] = F[id] ? 0 : 1;   /* v336 empty <> full (the whole field) */
    if (!F[id]) delete F[id];
    STATE.peFields = F;
    _peRebuild(false);
  }
  function peFoundLabel(f) { f = (f === 'screw' || f === 'block' || f === 'pier') ? f : _peFound(STATE); return (f === 'block') ? _gzLbl('base_count_precast', 'Precast pads') : (f === 'pier') ? _gzLbl('base_v3', 'Concrete pads') : _gzLbl('base_v5', 'Ground screws'); }
  function peRoofLabel(r) { r = (r === 'flat' || r === 'gable' || r === 'hip') ? r : _peRoof(STATE); return (r === 'gable') ? _gzLbl('roof_v1', 'Gable') : (r === 'hip') ? _gzLbl('roof_v2', 'Hip') : _gzLbl('roof_v3', 'Flat'); }
  function peCovLabel(c) { c = (c === true || c === false) ? c : _peCov(STATE); return c ? _gzLbl('mc_cov_seam', 'Standing seam') : _gzLbl('taurus_open', 'Open'); }
  function peFillLabel(f) {
    f = (f === 'h' || f === 'v' || f === 'lat' || f === 'hlat' || f === 'xlat') ? f : _peFillT(STATE);
    var tr = _gzLbl('bench_rb_trellis', 'Trellis');
    if (f === 'hlat') return _gzLbl('post_wall_slats', 'Slats') + ' + ' + tr;   /* v338 the two combined: existing words, no new key (the X a letter, as the shelter's SLATS V / H) */
    if (f === 'xlat') return 'X + ' + tr;
    return (f === 'v') ? _gzLbl('cladding_vertical', 'Vertical') : (f === 'lat') ? tr : _gzLbl('cladding_horizontal', 'Horizontal');
  }
  function _gzRebuild() {
    STATE.assemblyStep = 0;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function cycleGzFound() { if ((STATE.variant | 0) !== 23) return; var f = _gzFound(STATE); STATE.gzFound = (f === 'screw') ? 'block' : (f === 'block') ? 'pier' : 'screw'; _gzRebuild(); }
  function cycleGzCov() { if ((STATE.variant | 0) !== 23) return; STATE.gzCov = (_gzCov(STATE) === 'shingle') ? 'seam' : 'shingle'; _gzRebuild(); }
  function cycleGzFill() { if ((STATE.variant | 0) !== 23) return; STATE.gzFill = (_gzFill(STATE) === 'bal') ? 'board' : 'bal'; _gzRebuild(); }
  function _gzLbl(key, fb) { var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, v = T[key]; return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : fb; }
  function gzFoundLabel(f) { f = (f === 'screw' || f === 'block' || f === 'pier') ? f : _gzFound(STATE); return (f === 'block') ? _gzLbl('base_count_precast', 'Precast pads') : (f === 'pier') ? _gzLbl('base_v3', 'Concrete pads') : _gzLbl('base_v5', 'Ground screws'); }
  function gzCovLabel(c) { c = (c === 'shingle' || c === 'seam') ? c : _gzCov(STATE); return (c === 'seam') ? _gzLbl('mc_cov_seam', 'Standing seam') : _gzLbl('mc_cov_shingle', 'Asphalt shingle'); }
  function gzFillLabel(f) { f = (f === 'bal' || f === 'board') ? f : _gzFill(STATE); return (f === 'board') ? _gzLbl('shelter_fill_boards', 'Boards') : _gzLbl('post_wall_slats', 'Slats'); }
  /* v350 a side's disc: the railing (the entrance: open) <> the infill over the whole height */
  function cycleGzField(id) {
    if ((STATE.variant | 0) !== 23 || !id) return;
    var F0 = _gzFields(STATE), F = {}, k;
    for (k in F0) if (F0.hasOwnProperty(k)) F[k] = F0[k];
    if (F[id]) delete F[id]; else F[id] = 1;
    STATE.gzFields = F;
    _gzRebuild();
  }
  function gzGapRange() { var R = _gzGapRange(STATE); return { min: Math.round(R.min * 1000), max: Math.round(R.max * 1000), value: Math.round(_gzGap(STATE) * 1000) }; }
  function setGzGap(m) {
    if ((STATE.variant | 0) !== 23 || typeof m !== 'number' || isNaN(m)) return;
    STATE.gzGap = m;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* v305 the screen's drop on the slider: the image's bottom over the ground, mm */
  function gsDropRange() { var sc = _gsLayout(STATE).screen; return { min: Math.ceil(sc.dMin * 1000), max: Math.floor(sc.dMax * 1000), value: Math.round(sc.yI0 * 1000), on: sc.on }; }
  function setGsDrop(m) {
    if ((STATE.variant | 0) !== 19 || typeof m !== 'number' || isNaN(m)) return;
    STATE.gsDrop = m;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }

  /* v288 the sunbed (type 16): the backrest's angle on the slider (the notches 0..60) */
  function sbAngRange() { return { min: SB.ANG[0], max: SB.ANG[SB.ANG.length - 1], step: 15, value: _sbAng(STATE) }; }   /* v290 0/30/45/60/75 on a 15 deg slider (15 snaps to 30) */
  function setSbAng(v) {
    if ((STATE.variant | 0) !== 16 || typeof v !== 'number' || isNaN(v)) return;
    STATE.sbAng = v; STATE.sbAng = _sbAng(STATE);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }

  function toggleBackrest() {
    STATE.backrestVisible = !STATE.backrestVisible;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }

  /* Sofa vertical slats — cycles 0..14: none → 7 side-configs with the
     38mm batten → the same 7 with the 30mm batten → none. Variant 2 only;
     never touches the Park Bench. */
  function cycleSlats() {
    if ((STATE.variant | 0) !== 2) return;
    STATE.slats = ((STATE.slats | 0) + 1) % (SOFA.slatCycleMax(SOFA.isTall(STATE)) + 1);
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  /* Button label: just "Slats" + the BoQ quantity for the current state,
     formatted in the active unit system (m / ft). No translation keys. */
  /* Sofa slat spacing (clear gap between slats, metres). Variant 2 only. */
  function setSlatGap(m) {
    var v = (STATE.variant | 0);
    if (v !== 2 && v !== 3 && v !== 4) return;
    if (typeof m !== 'number' || isNaN(m)) return;
    var lo = (v === 4) ? SWING.GAP_MIN : (v === 3) ? WAVE.GAP_MIN : SOFA.GAP_MIN;
    var hi = (v === 4) ? SWING.GAP_MAX : (v === 3) ? WAVE.GAP_MAX : SOFA.GAP_MAX;
    STATE.slatGap = Math.max(lo, Math.min(hi, m));
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
  }
  function slatLabel() {
    if ((STATE.variant | 0) !== 2 || (STATE.slats | 0) <= 0) return 'Slats: off';
    var st = SOFA.slatState(STATE.slats | 0, SOFA.isTall(STATE));
    var dim = st.profile && CUT_LIST_DIM[st.profile];
    if (!dim) return 'Slats';
    /* The size that replaces the π placeholder in the sheet NAME — a pure
       dimension, so no translation is needed. */
    var txt = STATE.isMetric ? (dim.metric + ' mm') : dim.imperial;
    return 'Slats: ' + txt;
  }

  /* Decorative kids overlay: when switching to the children level, this
     PNG slides up from the bottom, rests at the bottom edge BEHIND the
     bottom info-bar (z-index 5 < the bar's 10), holds ~2 s, then fades
     out and removes itself. Purely cosmetic, never blocks interaction. */
  var KIDS_IMG_URL = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/5930.png?v=1780318613';
  function _showKidsImage() {
    var root = document.getElementById('cf-root') ||
               (global.BenchEngine && global.BenchEngine.renderer &&
                global.BenchEngine.renderer.domElement &&
                global.BenchEngine.renderer.domElement.parentNode);
    if (!root) return;

    var old = document.getElementById('cf-kids-img');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var img = document.createElement('img');
    img.id = 'cf-kids-img';
    img.src = KIDS_IMG_URL;
    img.alt = '';
    img.style.cssText =
      'position:absolute;left:50%;bottom:0;z-index:5;' +
      'transform:translateX(-50%) translateY(100%);' +
      'width:auto;pointer-events:none;opacity:1;' +
      'transition:transform 1.2s cubic-bezier(.16,1,.3,1);' +
      'will-change:transform,opacity;';
    /* Size by an explicit HEIGHT measured from the container, set with
       !important so theme img rules can't shrink it. For a bottom-resting
       image, height is the visible lever (max-height only ever shrinks, so
       earlier max-* tweaks did nothing); width follows the aspect ratio. */
    try {
      var ch = root.clientHeight || root.offsetHeight || 0;
      if (ch > 0) img.style.setProperty('height', Math.round(ch * 0.55) + 'px', 'important');
    } catch (e) {}
    root.appendChild(img);

    /* Slide up next frame so the transition runs. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        img.style.transform = 'translateX(-50%) translateY(0)';
      });
    });

    /* Begin fade 3 s after it appears, then remove. */
    var FADE = 600;
    setTimeout(function () {
      img.style.transition = 'opacity ' + FADE + 'ms ease';
      img.style.opacity = '0';
      setTimeout(function () {
        if (img.parentNode) img.parentNode.removeChild(img);
      }, FADE + 60);
    }, 3000);
  }

  /* v263: the wave's posture toggle -- the next stop, Upright ... Bed, the
     line MORPHING there (Marek: the transition from upright to bed) */
  var _waveMorphTok = 0;
  function cycleWavePosture() {
    if ((STATE.variant | 0) !== 3) return;
    var b0 = _waveBeta(STATE);
    STATE.lvl = (_waveLvl(STATE) % WAVE.PRESETS) + 1;
    var b1 = WAVE.STOPS[STATE.lvl - 1], tok = ++_waveMorphTok, t0 = Date.now(), DUR = (b1 < b0) ? 1100 : 800;
    refreshUI();
    if (typeof savePref === 'function') savePref();
    (function step() {
      if (tok !== _waveMorphTok) return;
      var k = Math.min(1, (Date.now() - t0) / DUR), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      STATE._waveBetaAnim = (k < 1) ? b0 + (b1 - b0) * e : undefined;
      if (k >= 1) delete STATE._waveBetaAnim;
      try { global.BenchRenderer.build(); } catch (eM) {}
      if (k < 1) requestAnimationFrame(step); else refreshUI();
    })();
  }
  function cycleLvl() {
    /* v301 the modern swing (18): the level button = the woven shade cloth on the slats / the blocks */
    if ((STATE.variant | 0) === 18) { toggleMfWeave(); return; }
    /* Hollywood swing (variant 4) / porch swing (7): the level button puts the mattress on / off. */
    if (_isSwingBackType(STATE.variant) || (STATE.variant | 0) === 17 || ((STATE.variant | 0) === 13 && _kidsBench(STATE))) {   /* v296 + the pergola swing's cushion; v299 the kids' set's bench */
      STATE.swingCushion = !_swingCushionOn(STATE);   /* an explicit choice from now on */
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* Block bench (type 6): the level button = the block colour 1-4 */
    if ((STATE.variant | 0) === 6) {
      STATE.lvl = (_blockColor(STATE) % 4) + 1;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* Planter bench (type 10): the level button = the planter size;
       tree bench (11): a hexagon / an octagon */
    if ((STATE.variant | 0) === 10 || (STATE.variant | 0) === 11 || (STATE.variant | 0) === 12) {   /* 12: the lid open / shut */
      STATE.lvl = (STATE.lvl === 2) ? 1 : 2;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* Adirondack (type 9): the level button = the kids' size (x 0.75), the
       same number of seats */
    if ((STATE.variant | 0) === 9) {
      var nSeat = Math.max(1, Math.min(3, Math.round((STATE.L || ADI.L_DEFAULT) / (ADI.SEAT_W * ((STATE.lvl === 2) ? ADI.KID : 1)))));
      STATE.lvl = (STATE.lvl === 2) ? 1 : 2;
      STATE.L = Math.round(nSeat * ADI.SEAT_W * ((STATE.lvl === 2) ? ADI.KID : 1) * 1000) / 1000;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* v288 the sunbed (type 16): the level button = the kids' size; the
       width goes to the size's default */
    if ((STATE.variant | 0) === 16) {
      STATE.lvl = (STATE.lvl === 2) ? 1 : 2;
      STATE.sbW = null;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* Picnic set (variant 5): the level button = the kids' size (lvl 2);
       the length snaps into the size's range. */
    if ((STATE.variant | 0) === 5) {
      STATE.lvl = (STATE.lvl === 2) ? 1 : 2;
      STATE.L = (STATE.lvl === 2) ? PICNIC.KID_L_DEFAULT : PICNIC.L_DEFAULT;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }
    /* Wave bench (variant 3): the level button cycles the 3 posture presets
       (1 = upright bench, 2 = relax, 3 = recliner). Height + slat layout
       follow from the active profile on rebuild. */
    if ((STATE.variant | 0) === 3) {
      /* v263: the side level button = the mattress on / off (as the
         swings); the posture is the info-bar toggle (cycleWavePosture) */
      STATE.swingCushion = !_waveCushionOn(STATE);
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }

    STATE.lvl = (STATE.lvl === 1) ? 2 : 1;

    /* Sofa (variant 2): the level toggle switches between a single-row
       frame (lvl 1) and a two-row backrest frame (lvl 2). No kids snap or
       overlay — that behaviour is specific to the Park Bench. */
    if ((STATE.variant | 0) === 2) {
      /* Set the level's default top-frame height so the telescoping range
         makes sense (lvl 1 single frame ≈ 0.8 ft; lvl 2 top ≈ 1.6 ft with
         middle ≈ 0.8 ft). */
      STATE.H = (STATE.lvl === 2) ? SOFA.H_DEF_L2 : SOFA.H_DEF_L1;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI();
      if (typeof savePref === 'function') savePref();
      return;
    }

    /* Children level: snap to small-child defaults so the size difference
       is clearly visible — but only when the dimension still matches the
       OTHER level's canonical default (i.e. the user hasn't dragged it
       themselves). Adult defaults come from DEFAULTS; kids are smaller. */
    var KIDS_L = 1.46304;  /* seat length (m) = 4.8 ft — wider kids bench */
    var KIDS_W = 0.5182;   /* seat depth  (m) = 1.7 ft */
    if (STATE.lvl === 2) {
      if (Math.abs(STATE.L - DEFAULTS.L) < 0.001) STATE.L = KIDS_L;
      if (Math.abs(STATE.W - DEFAULTS.W) < 0.001) STATE.W = KIDS_W;
    } else {
      if (Math.abs(STATE.L - KIDS_L) < 0.001) STATE.L = DEFAULTS.L;
      if (Math.abs(STATE.W - KIDS_W) < 0.001) STATE.W = DEFAULTS.W;
    }
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI();
    if (typeof savePref === 'function') savePref();
    if (STATE.lvl === 2) _showKidsImage();   /* kids overlay slides up from the bottom */
  }

  function setBackRakeDeg(deg) {
    /* Tilt slider drives the backrest FRAME's rotation around its
       bottom edge (X axis). 0° = vertical, 20° = max tilt back.
       The top structural side rails stay horizontal regardless. */
    var d = parseFloat(deg);
    if (isNaN(d)) return;
    var r = RANGES.backRakeDeg;
    if (d < r.min) d = r.min;
    if (d > r.max) d = r.max;
    STATE.backRakeDeg = d;
    try { global.BenchRenderer.build(); } catch (e) {}
    if (typeof savePref === 'function') savePref();
  }

  function _emitVariantChange() {
    /* Broadcast the active configurator variant so variant-driven page
       sections (e.g. the IG-profile influencer card) can follow along.
       Payload carries the 1-based storefront position; listeners that read
       the current variant id straight from the URL / hidden id input can
       ignore the detail and just re-sync. */
    try {
      document.dispatchEvent(new CustomEvent('leva:variant', {
        detail: { position: STATE.variant | 0 }
      }));
    } catch (e) {}
  }

  /* the block bench's colour name (the container colour keys) */
  function _blockColorLabel() {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {};
    var k = BLOCK.COLOR_KEYS[_blockColor(STATE) - 1], v = T[k];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : String(_blockColor(STATE));
  }

  function _syncColorModeDisplay() {
    var btn = document.getElementById('cf-btn-colors');
    if (!btn) return;
    var key = _colorScheme(), i = _colorOrder().indexOf(key);
    btn.setAttribute('aria-pressed', (i > 0) ? 'true' : 'false');
    var lbl = document.getElementById('cf-stat-colors');
    if (lbl) lbl.textContent = String(i + 1);
  }


  /* ===== A DESIGN AS DATA, SHARE LINKS ?cfg=, REFERENCE DESIGNS (bench-v265) =====
     Marek 2026-10-14: do nasi mapy sdilenych projektu alespon 40 referencnich
     projektu (ruzne barevne provedeni, ruzne nastaveni sliders, delek), pocty
     podle mozne popularity -- nejvice hollywoodska houpacka.
     - designPayload(): every key that shapes the bench (the type, sizes,
       sliders, toggles, colour) -- never the view, units or figure.
     - applyDesign(p): the type's defaults first (selectVariant), then the
       keys, one build.
     - leva_configs/<id> holds a design { type: 'bench', ts, payload } (as the
       BBQ's ?cfg= links: Firestore SDK when the page has it, REST without);
       a ?cfg=<id> page opens it, BenchLib.applyConfigId(id) opens it in
       place (the map strip's USE MODEL) and the theme's variant picker
       follows (window.__benchShopifyTo, the snippet).
     - REF_SET: 48 reference designs (v276: + 3 beds) weighted by how popular each type is
       likely to be (Hollywood swing 9, porch swing 5, park bench /
       Adirondack / picnic set 4 each, A-frame swing / sofa / kids' swing
       set 3, the rest 2), each with its own colour, size and slider, and a
       list of US places where that type belongs. The admin's REF button
       (the snippet) publishes them; the voice tour's intro shows them. */
  var DESIGN_KEYS = ['mbRet', 'mbShape', 'mbRoof', 'mbPitch', 'mbH', 'mbCov', 'variant', 'L', 'W', 'H', 'lvl', 'backRakeDeg', 'backrestVisible', 'backH', 'picnicSeparate',
    'colorMode', 'slats', 'slatGap', 'swingBack', 'swingRoof', 'swingPitch', 'swingCushion', 'porchH', 'adiBack', 'waveBack', 'psofaBack', 'bedMW', 'bedHead', 'bedHeadStyle', 'porchFill', 'porchGap', 'gbArms', 'gbArmH', 'sbW', 'sbAng', 'kidsBench', 'mfFound', 'mfWeave', 'mfCant', 'rtbMode', 'gsScreen', 'gsDrop', 'rbMode', 'rbW', 'rbN', 'rbOpen', 'rbTrellis', 'gaMode', 'gaW', 'gaFound', 'gaGrid', 'gzN', 'gzFound', 'gzCov', 'gzFill', 'gzGap', 'gzFields', 'peW', 'peGap', 'peRoof', 'peCov', 'peFillT', 'peFound', 'peFields', 'phW', 'phPorch', 'phSlide', 'phSwings', 'phLoft', 'tfTrunk', 'phRoof', 'ghW', 'ghKnee', 'coHens', 'coRun', 'kpOpen', 'kpKinds', 'kpN', 'kpFound', 'kpClad', 'kpShelf', 'kpRoof', 'kpFin', 'kpAng', 'kpFrame', 'kpLad', 'ctWheels', 'knDog', 'knFlap', 'knDeck', 'ghWin', 'ghBench', 'ghFound', 'csShape', 'csMb', 'csT', 'csLook', 'phFound'];   /* v394 + the castle's plan, monkey bars, towers (the L) */   /* v388 + the insulated dog house's flap */   /* v385 + the dog house */   /* v379 + the chicken tractor */   /* v375 + the coop */   /* v362 + the cottage */   /* v334 + the pergola */   /* v329 + the gazebo's options */   /* v322 + the garden arbor's roof, width, foundation; v328 + the gazebo's shape */
  var _HOLD = 0;   /* > 0: no savePref, no Undo note (the tour, REF) */
  function _holdWrites() { return _HOLD > 0 || !!(_T && _T.on); }
  function designPayload() {
    var o = { v: 1, kind: 'bench' };
    DESIGN_KEYS.forEach(function (k) {
      var x = STATE[k];
      if (x === undefined) return;
      o[k] = (x && typeof x === 'object') ? JSON.parse(JSON.stringify(x)) : x;
    });
    return o;
  }
  function _designShow(noBill) {
    try { global.BenchRenderer.build(); } catch (e) { _dbg('[design] build THREW ' + ((e && e.message) || e)); }
    try { if (global.BenchEngine.applyView) global.BenchEngine.applyView(); } catch (eV) {}
    try { if (global.BenchEngine.applyVizStage) global.BenchEngine.applyVizStage(); } catch (eS) {}
    refreshUI(!!noBill);   /* noBill: the budget not repriced (the tour's fast cuts) */
    try { _syncColorModeDisplay(); } catch (eC) {}
    _emitVariantChange();
  }
  function applyDesign(p, opt) {
    opt = opt || {};
    if (!p || !((p.variant | 0) > 0)) return false;
    selectVariant(p.variant | 0, true);
    if ((p.variant | 0) === 25) { STATE.mbShape = (p.mbRet === false) ? 'I' : 'Lr'; STATE.mbRoof = 'mono'; STATE.mbPitch = null; STATE.mbH = null; STATE.mbCov = true; }   /* v357 a bar design from before its options: Adam's */
    DESIGN_KEYS.forEach(function (k) {
      if (k === 'variant' || !p.hasOwnProperty(k) || p[k] === undefined) return;
      STATE[k] = (p[k] && typeof p[k] === 'object') ? JSON.parse(JSON.stringify(p[k])) : p[k];
    });
    STATE.assemblyStep = 0;
    _designShow();
    if (opt.save) {
      savePref();
      try { _UndoHistory.baseline(); } catch (eU) {}
    }
    if (opt.shop && typeof global.__benchShopifyTo === 'function') {
      try { global.__benchShopifyTo(STATE.variant | 0); } catch (eSh) {}
    }
    return true;
  }

  /* ---- leva_configs (the BBQ's own cloud config, the same rules) ---------- */
  var _CFG_FS = { projectId: 'leva-791c5', apiKey: 'AIzaSyBoS6u5DLBF7ZYnB6egP9uvKLJ4lFHkNtI', col: 'leva_configs' };
  function _cfgNewId() { return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function _cfgRest() { return 'https://firestore.googleapis.com/v1/projects/' + _CFG_FS.projectId + '/databases/(default)/documents/' + _CFG_FS.col; }
  function _fsPlain(v) {
    if (!v || typeof v !== 'object') return v;
    if ('stringValue' in v) return v.stringValue;
    if ('integerValue' in v) return parseInt(v.integerValue, 10);
    if ('doubleValue' in v) return v.doubleValue;
    if ('booleanValue' in v) return v.booleanValue;
    if ('nullValue' in v) return null;
    if (v.mapValue) { var o = {}, f = v.mapValue.fields || {}; Object.keys(f).forEach(function (k) { o[k] = _fsPlain(f[k]); }); return o; }
    if (v.arrayValue) return (v.arrayValue.values || []).map(_fsPlain);
    return v;
  }
  function cfgSave(payload) {
    var id = _cfgNewId(), doc = { type: 'bench', ts: Date.now(), payload: JSON.stringify(payload || designPayload()) };
    try {
      if (global.db && global.db.collection) return global.db.collection(_CFG_FS.col).doc(id).set(doc).then(function () { return { id: id }; });
    } catch (eS) {}
    return fetch(_cfgRest() + '?documentId=' + id + '&key=' + _CFG_FS.apiKey, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields: { type: { stringValue: 'bench' }, ts: { integerValue: String(doc.ts) }, payload: { stringValue: doc.payload } } })
    }).then(function (r) { if (!r.ok) throw new Error('REST ' + r.status); return { id: id }; });
  }
  function _cfgLoad(id) {
    try {
      if (global.db && global.db.collection) return global.db.collection(_CFG_FS.col).doc(id).get().then(function (s) { return (s && s.exists) ? s.data() : null; });
    } catch (eL) {}
    return fetch(_cfgRest() + '/' + encodeURIComponent(id) + '?key=' + _CFG_FS.apiKey).then(function (r) {
      if (!r.ok) return null;
      return r.json().then(function (j) { return _fsPlain({ mapValue: { fields: j.fields || {} } }); });
    });
  }
  function _cfgPayload(doc) {
    if (!doc) return null;
    var p = doc.payload;
    if (p && typeof p === 'object' && p.bench) p = p.bench;
    if (typeof p === 'string') { try { p = JSON.parse(p); } catch (e) { return null; } }
    return (p && typeof p === 'object' && (p.variant | 0) > 0) ? p : null;
  }
  /* v283 (Marek 2026-10-20: oddelit houpacky a benches) BENCHES and SWINGS
     are two Shopify products on this one lib: the swing types are sold on
     SWINGS, the rest on BENCHES. A design of a type this page does not
     sell opens on the product that sells it (the ?cfg link carried over). */
  var PRODUCT_TYPES = { swings: [4, 7, 8, 13, 17, 18], 'garden-structure': [19, 20, 22, 23, 24], 'garden-bar': [25], playhouses: [26, 27, 28, 29, 30, 31, 32, CS_TYPE], greenhouse: [33, 36, 38, 40, 43, 45], coop: [34, 37, 39, 42, 46, 49, 52], 'kitchen-pod': [35, 53], 'garden-pod': [35, 53], kennel: [41, 44, 47, 48, 51] };   /* v403 + the modern dog house (kennel 51) */   /* v401 + the hoop coop (coop 52) */   /* v397 + the barn coop (coop 49) */   /* v396 + the double dog house (kennel 48) */   /* v392 + the kennel with run (kennel 47) */   /* v391 + the cupola coop (coop 46) */   /* v388 + the insulated dog house (kennel 44) */   /* v386 + the lean-to coop (coop 42) */   /* v385 KENNEL (the handle kennel) */   /* v383 + the walk-in coop */   /* v379 + the chicken tractor */   /* v376 KITCHEN POD (the handle kitchen-pod) */   /* v375 + COOP (the backyard coop) */   /* v373 GREENHOUSES (the handle greenhouse) */   /* v368 + the tree fort */   /* v367 + the little barn */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v356 the bar on its own product GARDEN BAR (Adam's author project) */   /* v355 + the bar */   /* v334 + the pergola */   /* v328 + the gazebo */   /* v320 + the garden arbor */   /* v314 + the raised bed */   /* v303 + GARDEN STRUCTURE (the cinema bar); the pergola and modern swings are sold on SWINGS */
  function productOfType(t) {
    t = t | 0;
    for (var h in PRODUCT_TYPES) if (PRODUCT_TYPES.hasOwnProperty(h) && PRODUCT_TYPES[h].indexOf(t) >= 0) return h;
    return 'benches';
  }
  function _pageHandle() { var m = /\/products\/([^\/?#]+)/.exec(String(global.location && global.location.pathname || '')); return m ? m[1] : ''; }
  function _openOnOwnProduct(t, id) {
    if (!SLOT_TYPES || SLOT_TYPES.indexOf(t | 0) >= 0) return false;
    var h = productOfType(t), here = _pageHandle();
    if (!here || h === here) return false;
    try {
      var u = new URL(global.location.href);
      u.pathname = u.pathname.replace(/\/products\/[^\/]+/, '/products/' + h);
      u.searchParams.delete('variant');
      u.searchParams.set('cfg', id);
      _dbg('[cfg] type ' + (t | 0) + ' is sold on /products/' + h + ' -- opening it there');
      global.location.replace(u.toString());
      return true;
    } catch (e) { return false; }
  }
  function applyConfigId(id, from) {
    id = String(id || '');
    if (!/^[A-Za-z0-9_-]{6,64}$/.test(id)) return Promise.resolve(false);
    return _cfgLoad(id).then(function (doc) {
      var p = _cfgPayload(doc);
      if (!p) { _dbg('[cfg] ' + id + ' is not a bench design (' + (from || 'applyConfigId') + ')'); return false; }
      if (_openOnOwnProduct(p.variant, id)) return false;
      if (_T.on) _tourStop('a design was opened');
      applyDesign(p, { save: true, shop: true });
      _dbg('[cfg] design ' + id + ' opened (' + (from || 'applyConfigId') + '): type ' + (p.variant | 0) + ', L ' + p.L + ', ' + (p.colorMode || 'birch'));
      return true;
    }, function (e) { _dbg('[cfg] ' + id + ' not loaded: ' + ((e && e.message) || e)); return false; });
  }
  /* a ?cfg=<id> page: opened once the page's own variant boot has run; the
     link taken out of the address bar (a reload keeps what was opened) */
  function _cfgBoot() {
    var m = /[?&]cfg=([A-Za-z0-9_-]{6,64})/.exec(String(global.location && global.location.search || ''));
    if (!m) return;
    var id = m[1];
    _dbg('[cfg] link ?cfg=' + id);
    setTimeout(function () {
      applyConfigId(id, 'link').then(function (ok) {
        if (!ok) return;
        try {
          var u = location.pathname + location.search.replace(/([?&])cfg=[^&]*&?/, '$1').replace(/[?&]$/, '') + location.hash;
          history.replaceState(history.state, '', u);
        } catch (eU) {}
      });
    }, 400);
  }

  /* ---- the reference designs ----------------------------------------------
     t type, L length (m; a sofa counts cushions in m), c colour scheme,
     b the type's slider (park: back rake; swings: back tilt; wave: posture;
     Adirondack: back), roof / pitch / cu(shion) for the swings, lvl, br
     (back on), sep (picnic benches apart), sl / gap (sofa slats), ph (porch
     beam height). P: places [name, state, lat, lon] where the type belongs,
     several per design so a taken place has a next one. */
  var REF_V = 'bref-v1';
  var REF_PLACES = {
    21: [['Seattle','WA',47.61,-122.33],['Brooklyn','NY',40.68,-73.94],['San Francisco','CA',37.77,-122.42],['Chicago','IL',41.88,-87.63],
         ['Austin','TX',30.27,-97.74],['Denver','CO',39.74,-104.99],['Charleston','SC',32.78,-79.93],['Minneapolis','MN',44.98,-93.27]],   /* v318 the floating bed */
    4: [['Scottsdale','AZ',33.49,-111.93],['Naples','FL',26.14,-81.79],['Boca Raton','FL',26.37,-80.13],['Plano','TX',33.02,-96.70],
        ['Sugar Land','TX',29.62,-95.63],['Irvine','CA',33.68,-117.83],['Alpharetta','GA',34.08,-84.29],['The Woodlands','TX',30.17,-95.46],
        ['Carlsbad','CA',33.16,-117.35],['Palm Desert','CA',33.72,-116.37],['Franklin','TN',35.93,-86.87],['Hilton Head Island','SC',32.22,-80.75],
        ['St. Augustine','FL',29.90,-81.31],['Fredericksburg','TX',30.27,-98.87],['Santa Barbara','CA',34.42,-119.70],['Lake Oswego','OR',45.42,-122.67],
        ['Highland Park','IL',42.18,-87.80],['Vero Beach','FL',27.64,-80.40],['Brentwood','TN',36.03,-86.78]],
    7: [['Lexington','KY',38.04,-84.50],['Asheville','NC',35.60,-82.55],['Natchez','MS',31.56,-91.40],['Athens','GA',33.96,-83.38],
        ['Beaufort','SC',32.43,-80.67],['Oxford','MS',34.37,-89.52],['Galveston','TX',29.30,-94.80],['Mobile','AL',30.69,-88.04],
        ['Bardstown','KY',37.81,-85.47],['Wilmington','NC',34.23,-77.94]],
    1: [['Providence','RI',41.82,-71.41],['Portland','ME',43.66,-70.26],['Annapolis','MD',38.98,-76.49],['Princeton','NJ',40.36,-74.67],
        ['Boulder','CO',40.01,-105.27],['Ann Arbor','MI',42.28,-83.74],['Pasadena','CA',34.15,-118.14],['Savannah','GA',32.08,-81.09]],
    9: [['Lake Placid','NY',44.28,-73.98],['Saratoga Springs','NY',43.08,-73.78],['Burlington','VT',44.48,-73.21],['Bar Harbor','ME',44.39,-68.20],
        ['Hyannis','MA',41.65,-70.29],['Traverse City','MI',44.76,-85.62],['Newport','RI',41.49,-71.31],['Kennebunkport','ME',43.36,-70.48],
        ['Lake George','NY',43.43,-73.71]],
    5: [['Madison','WI',43.07,-89.40],['Iowa City','IA',41.66,-91.53],['Rochester','MN',44.02,-92.47],['Columbia','MO',38.95,-92.33],
        ['Bloomington','IN',39.17,-86.53],['Lawrence','KS',38.97,-95.24],['Fort Collins','CO',40.59,-105.08],['Eau Claire','WI',44.81,-91.50]],
    8: [['Boerne','TX',29.79,-98.73],['Tyler','TX',32.35,-95.30],['Kalispell','MT',48.20,-114.31],['Bozeman','MT',45.68,-111.04],
        ['Coeur d\'Alene','ID',47.68,-116.78],['Prescott','AZ',34.54,-112.47]],
    2: [['Santa Monica','CA',34.02,-118.49],['Coral Gables','FL',25.72,-80.27],['Chandler','AZ',33.31,-111.84],['Decatur','GA',33.77,-84.30],
        ['Sausalito','CA',37.86,-122.49],['Silver Spring','MD',38.99,-77.03]],
    13: [['Naperville','IL',41.75,-88.15],['Carmel','IN',39.98,-86.12],['Olathe','KS',38.88,-94.82],['Cary','NC',35.79,-78.78],
         ['Plymouth','MN',45.01,-93.46],['Lehi','UT',40.39,-111.85],['McKinney','TX',33.20,-96.64]],
    12: [['Bellevue','WA',47.61,-122.20],['Olympia','WA',47.04,-122.90],['Salem','OR',44.94,-123.04],['Bellingham','WA',48.75,-122.48]],
    10: [['Santa Fe','NM',35.69,-105.94],['Napa','CA',38.30,-122.29],['Charlottesville','VA',38.03,-78.48],['Sedona','AZ',34.87,-111.76]],
    11: [['New Orleans','LA',29.95,-90.07],['Chapel Hill','NC',35.91,-79.06],['Tallahassee','FL',30.44,-84.28],['Lynchburg','VA',37.41,-79.14]],
    3: [['Palm Springs','CA',33.83,-116.55],['Key West','FL',24.56,-81.78],['Fort Lauderdale','FL',26.12,-80.14],['Lake Havasu City','AZ',34.48,-114.32]],
    6: [['Las Cruces','NM',32.32,-106.76],['Flagstaff','AZ',35.20,-111.65],['Yuma','AZ',32.69,-114.63],['Pueblo','CO',38.25,-104.61]],
    17: [['Sedona','AZ',34.87,-111.76],['Napa','CA',38.30,-122.29],['Fredericksburg','TX',30.27,-98.87],['Traverse City','MI',44.76,-85.62],
         ['Bend','OR',44.06,-121.31],['Annapolis','MD',38.98,-76.49]],   /* v296 the pergola swing */
    18: [['Boulder','CO',40.01,-105.27],['Austin','TX',30.27,-97.74],['Asheville','NC',35.60,-82.55],['Portland','OR',45.52,-122.68],
         ['Madison','WI',43.07,-89.40],['Santa Fe','NM',35.69,-105.94]],   /* v301 the modern swing */
    19: [['Austin','TX',30.27,-97.74],['San Diego','CA',32.72,-117.16],['Nashville','TN',36.16,-86.78],['Denver','CO',39.74,-104.99],
         ['Charlotte','NC',35.23,-80.84],['Scottsdale','AZ',33.49,-111.93],['Tampa','FL',27.95,-82.46],['Boise','ID',43.62,-116.20],
         ['Frisco','TX',33.15,-96.82],['Gilbert','AZ',33.35,-111.79],['Henderson','NV',36.04,-114.98],['Temecula','CA',33.49,-117.15],
         ['Katy','TX',29.79,-95.82],['Orlando','FL',28.54,-81.38],['Murfreesboro','TN',35.85,-86.39],['Fort Myers','FL',26.64,-81.87],['Peachtree City','GA',33.40,-84.60],
         ['Fayetteville','AR',36.06,-94.16],['Baton Rouge','LA',30.45,-91.19],['Birmingham','AL',33.52,-86.80],['Spartanburg','SC',34.95,-81.93],
         ['Wichita','KS',37.69,-97.34],['Omaha','NE',41.26,-95.94],['Des Moines','IA',41.59,-93.62],['Roanoke','VA',37.27,-79.94],
         ['Fort Wayne','IN',41.08,-85.14],['Albany','GA',31.58,-84.16]],   /* v303 the cinema bar */
    20: [['Portland','OR',45.52,-122.68],['Asheville','NC',35.60,-82.55],['Madison','WI',43.07,-89.40],['Burlington','VT',44.48,-73.21],
         ['Boulder','CO',40.01,-105.27],['Sacramento','CA',38.58,-121.49],['Raleigh','NC',35.78,-78.64],['Ann Arbor','MI',42.28,-83.74],
         ['Eugene','OR',44.05,-123.09],['Ithaca','NY',42.44,-76.50],['Missoula','MT',46.87,-113.99],['Duluth','MN',46.79,-92.10],
         ['Santa Cruz','CA',36.97,-122.03],['Durham','NH',43.13,-70.93],['Amherst','MA',42.37,-72.52],['Bloomington','IL',40.48,-88.99],
         ['Grand Rapids','MI',42.96,-85.67],['Kansas City','MO',39.10,-94.58],['Pittsburgh','PA',40.44,-80.00],['Louisville','KY',38.25,-85.76]],   /* v314 the raised bed */
    22: [['Savannah','GA',32.08,-81.09],['Charleston','SC',32.78,-79.93],['Pasadena','CA',34.15,-118.14],['Portland','OR',45.52,-122.68],
         ['Lexington','KY',38.04,-84.50],['Santa Fe','NM',35.69,-105.94],['Providence','RI',41.82,-71.41],['Ann Arbor','MI',42.28,-83.74],
         ['Williamsburg','VA',37.27,-76.71],['Greenwich','CT',41.03,-73.63],['Carmel-by-the-Sea','CA',36.56,-121.92],['Hendersonville','NC',35.32,-82.46],
         ['Mystic','CT',41.35,-71.97],['Lancaster','PA',40.04,-76.31],['Walla Walla','WA',46.06,-118.34],['Healdsburg','CA',38.61,-122.87]],   /* v320 the garden arbor */
    23: [['Charleston','SC',32.78,-79.93],['Savannah','GA',32.08,-81.09],['Napa','CA',38.30,-122.29],['Lake Geneva','WI',42.59,-88.43],
         ['Annapolis','MD',38.98,-76.49],['Greenville','SC',34.85,-82.40],['Fredericksburg','TX',30.27,-98.87],['Bend','OR',44.06,-121.31],
         ['Sturgeon Bay','WI',44.83,-87.38],['South Lake Tahoe','CA',38.94,-119.98],['Holland','MI',42.79,-86.11],['Hershey','PA',40.29,-76.65],
         ['Cape May','NJ',38.94,-74.91],['Stillwater','MN',45.06,-92.81],['Galena','IL',42.42,-90.43],['Eureka Springs','AR',36.40,-93.74],
         ['Greensboro','GA',33.58,-83.18],['Stowe','VT',44.47,-72.69]],   /* v328 the gazebo */
    24: [['Scottsdale','AZ',33.49,-111.93],['Austin','TX',30.27,-97.74],['San Diego','CA',32.72,-117.16],['Nashville','TN',36.16,-86.78],
         ['Boise','ID',43.62,-116.20],['Charlotte','NC',35.23,-80.84],['Santa Barbara','CA',34.42,-119.70],['Tampa','FL',27.95,-82.46],
         ['Las Vegas','NV',36.17,-115.14],['Tucson','AZ',32.22,-110.97],['St. George','UT',37.10,-113.58],['Sarasota','FL',27.34,-82.53],
         ['Houston','TX',29.76,-95.37],['San Antonio','TX',29.42,-98.49],['Newport Beach','CA',33.62,-117.93],['Jacksonville','FL',30.33,-81.66],
         ['Albuquerque','NM',35.08,-106.65],['Colorado Springs','CO',38.83,-104.82],['Dallas','TX',32.78,-96.80],['Fresno','CA',36.74,-119.79],
         ['Destin','FL',30.39,-86.50],['Tulsa','OK',36.15,-95.99],
         ['Port St. Lucie','FL',27.27,-80.35],['Gainesville','FL',29.65,-82.32],['Ocala','FL',29.19,-82.14],['Lafayette','LA',30.22,-92.02],
         ['Corpus Christi','TX',27.80,-97.40],['El Paso','TX',31.76,-106.49],['Midland','TX',31.99,-102.08],['Lubbock','TX',33.58,-101.86],
         ['Amarillo','TX',35.22,-101.83],['Oklahoma City','OK',35.47,-97.52],['Little Rock','AR',34.75,-92.29],['Bakersfield','CA',35.37,-119.02],
         ['Reno','NV',39.53,-119.81],['Grand Junction','CO',39.06,-108.55],['Kingman','AZ',35.19,-114.05],['Augusta','GA',33.47,-81.97],
         ['Columbia','SC',34.00,-81.03],['Chattanooga','TN',35.05,-85.31],['Huntsville','AL',34.73,-86.59],['Shreveport','LA',32.52,-93.75],
         ['Waco','TX',31.55,-97.15],['Palm Bay','FL',28.03,-80.59],['San Luis Obispo','CA',35.28,-120.66],['Redding','CA',40.59,-122.39]],   /* v334 the pergola */
    26: [['Plano','TX',33.02,-96.70],['Naperville','IL',41.75,-88.15],['Cary','NC',35.79,-78.78],['Overland Park','KS',38.98,-94.67],
         ['Carmel','IN',39.98,-86.12],['Frisco','TX',33.15,-96.82],['Alpharetta','GA',34.08,-84.29],['Irvine','CA',33.68,-117.83],
         ['Bellevue','WA',47.61,-122.20],['Franklin','TN',35.93,-86.87],['Lehi','UT',40.39,-111.85],['Chandler','AZ',33.31,-111.84],
         ['Woodbury','MN',44.92,-92.96],['Fishers','IN',39.96,-86.01],['Round Rock','TX',30.51,-97.68],['Ann Arbor','MI',42.28,-83.74]],   /* v362 the cottage playhouse: family suburbs */
    27: [['Alpharetta','GA',34.08,-84.29],['Folsom','CA',38.68,-121.18],['Boise','ID',43.62,-116.20],['Sugar Land','TX',29.62,-95.63],
         ['Mason','OH',39.36,-84.31],['Westfield','NJ',40.66,-74.35],['Kirkwood','MO',38.58,-90.41],['Lakewood Ranch','FL',27.42,-82.40]],   /* v363 the stilt house playhouse: family suburbs (other metros than the cottage's) */
    28: [['Bend','OR',44.06,-121.31],['Asheville','NC',35.60,-82.55],['Bozeman','MT',45.68,-111.04],['Flagstaff','AZ',35.20,-111.65],
         ['Burlington','VT',44.48,-73.21],['Traverse City','MI',44.76,-85.62],['Duluth','MN',46.79,-92.10],['Missoula','MT',46.87,-113.99]],   /* v364 the A-frame playhouse: mountain / lake towns */
    29: [['Katy','TX',29.79,-95.82],['Gilbert','AZ',33.35,-111.79],['Peachtree City','GA',33.40,-84.60],['Westerville','OH',40.13,-82.93],
         ['Olathe','KS',38.88,-94.82],['Mooresville','NC',35.58,-80.81],['Sammamish','WA',47.62,-122.04],['Eden Prairie','MN',44.85,-93.47]],   /* v365 the play fort: family suburbs (other metros) */
    30: [['Austin','TX',30.27,-97.74],['Portland','OR',45.52,-122.68],['Denver','CO',39.74,-104.99],['Raleigh','NC',35.78,-78.64],
         ['Palo Alto','CA',37.44,-122.14],['Madison','WI',43.07,-89.40],['Minneapolis','MN',44.98,-93.27],['Salt Lake City','UT',40.76,-111.89]],   /* v366 the modern house: design-minded cities */
    31: [['Lancaster','PA',40.04,-76.31],['Lexington','KY',38.04,-84.50],['Ames','IA',42.03,-93.62],['Stillwater','OK',36.12,-97.06],
         ['Woodstock','VT',43.62,-72.52],['Frederick','MD',39.41,-77.41],['Franklin','TN',35.93,-86.87],['Fort Collins','CO',40.59,-105.08]],   /* v367 the little barn: farm country and its towns */
    37: [['Asheville','NC',35.60,-82.55],['Ithaca','NY',42.44,-76.50],['Bozeman','MT',45.68,-111.04],['Lawrence','KS',38.97,-95.24],
         ['Eugene','OR',44.05,-123.09],['Athens','GA',33.96,-83.38],['Burlington','VT',44.48,-73.21],['Missoula','MT',46.87,-113.99]],   /* v379 the chicken tractor */
    52: [['Asheville','NC',35.60,-82.55],['Boulder','CO',40.01,-105.27],['Ithaca','NY',42.44,-76.50],['Missoula','MT',46.87,-113.99],
         ['Athens','GA',33.96,-83.38],['Burlington','VT',44.48,-73.21],['Eugene','OR',44.05,-123.09],['Austin','TX',30.27,-97.74]],   /* v401 the hoop coop: homesteads round college and mountain towns */
    49: [['Lancaster','PA',40.04,-76.31],['Lexington','KY',38.04,-84.50],['Ames','IA',42.03,-93.62],['Franklin','TN',35.93,-86.87],
         ['Woodstock','VT',43.62,-72.52],['Frederick','MD',39.41,-77.41],['Boise','ID',43.62,-116.21],['Madison','WI',43.07,-89.40]],   /* v397 the barn coop: farm country and its towns */
    46: [['Asheville','NC',35.60,-82.55],['Bozeman','MT',45.68,-111.04],['Burlington','VT',44.48,-73.21],['Madison','WI',43.07,-89.40],
         ['Eugene','OR',44.05,-123.09],['Fort Collins','CO',40.59,-105.08],['Lexington','KY',38.04,-84.50],['Savannah','GA',32.08,-81.09]],   /* v391 the cupola coop: garden towns with backyard flocks */
    42: [['Charleston','SC',32.78,-79.93],['Providence','RI',41.82,-71.41],['Ann Arbor','MI',42.28,-83.74],['Santa Fe','NM',35.69,-105.94],
         ['Sacramento','CA',38.58,-121.49],['Richmond','VA',37.54,-77.44],['Tacoma','WA',47.25,-122.44],['Albany','NY',42.65,-73.75]],   /* v386 the lean-to coop: town backyards against a house */
    39: [['Durham','NC',35.99,-78.90],['Bloomington','IN',39.17,-86.53],['Boulder','CO',40.01,-105.27],['Chattanooga','TN',35.05,-85.31],
         ['Spokane','WA',47.66,-117.43],['Lexington','KY',38.04,-84.50],['Flagstaff','AZ',35.20,-111.65],['Bellingham','WA',48.75,-122.48]],   /* v383 the walk-in coop: bigger-flock towns */
    41: [['Frisco','TX',33.15,-96.82],['Scottsdale','AZ',33.49,-111.93],['Knoxville','TN',35.96,-83.92],['Omaha','NE',41.26,-95.94],
         ['Tulsa','OK',36.15,-95.99],['Spokane','WA',47.66,-117.43],['Greenville','SC',34.85,-82.39],['Kansas City','MO',39.10,-94.58]],   /* v385 the classic dog house: dog-owning suburbs */
    44: [['Duluth','MN',46.79,-92.10],['Fargo','ND',46.88,-96.79],['Bozeman','MT',45.68,-111.04],['Burlington','VT',44.48,-73.21],
         ['Marquette','MI',46.54,-87.40],['Bismarck','ND',46.81,-100.78],['Missoula','MT',46.87,-113.99],['Anchorage','AK',61.22,-149.90]],   /* v388 the insulated dog house: cold-winter towns */
    47: [['Plano','TX',33.02,-96.70],['Mesa','AZ',33.42,-111.83],['Chattanooga','TN',35.05,-85.31],['Lincoln','NE',40.81,-96.70],
         ['Boise','ID',43.62,-116.21],['Columbia','SC',34.00,-81.03],['Wichita','KS',37.69,-97.34],['Asheville','NC',35.60,-82.55]],   /* v392 the kennel with run: big-yard dog towns */
    48: [['Overland Park','KS',38.98,-94.67],['Round Rock','TX',30.51,-97.68],['Franklin','TN',35.93,-86.87],['Fishers','IN',39.96,-86.01],
         ['Meridian','ID',43.61,-116.39],['Gilbert','AZ',33.35,-111.79],['Cary','NC',35.79,-78.78],['Sioux Falls','SD',43.55,-96.73]],   /* v396 the double dog house: two-dog family suburbs */
    51: [['Austin','TX',30.27,-97.74],['Denver','CO',39.74,-104.99],['Portland','OR',45.52,-122.68],['Scottsdale','AZ',33.49,-111.93],
         ['Asheville','NC',35.60,-82.55],['Santa Barbara','CA',34.42,-119.70],['Boulder','CO',40.01,-105.27],['Charleston','SC',32.78,-79.93]],   /* v403 the modern dog house: design-minded towns, sunny decks */
    34: [['Austin','TX',30.27,-97.74],['Boise','ID',43.62,-116.21],['Nashville','TN',36.16,-86.78],['Madison','WI',43.07,-89.40],
         ['Raleigh','NC',35.78,-78.64],['Fort Collins','CO',40.59,-105.08],['Lancaster','PA',40.04,-76.31],['Santa Rosa','CA',38.44,-122.71]],   /* v375 the backyard coop: backyard-flock towns */
    32: [['Portland','OR',45.52,-122.68],['Asheville','NC',35.60,-82.55],['Eugene','OR',44.05,-123.09],['Burlington','VT',44.48,-73.21],
         ['Duluth','MN',46.79,-92.10],['Ann Arbor','MI',42.28,-83.74],['Bend','OR',44.06,-121.32],['Athens','GA',33.96,-83.38]],   /* v368 the tree fort: leafy towns */
    33: [['Portland','OR',45.52,-122.68],['Boise','ID',43.62,-116.20],['Madison','WI',43.07,-89.40],['Burlington','VT',44.48,-73.21],
         ['Fort Collins','CO',40.59,-105.08],['Ann Arbor','MI',42.28,-83.74],['Asheville','NC',35.60,-82.55],['Spokane','WA',47.66,-117.43],
         ['Lancaster','PA',40.04,-76.31],['Bozeman','MT',45.68,-111.04],['Duluth','MN',46.79,-92.10],['Santa Fe','NM',35.69,-105.94]],   /* v373 the gable greenhouse: short seasons, keen gardeners */
    36: [['Minneapolis','MN',44.98,-93.27],['Milwaukee','WI',43.04,-87.91],['Rochester','NY',43.16,-77.61],['Pittsburgh','PA',40.44,-80.00],
         ['Cleveland','OH',41.50,-81.69],['Grand Rapids','MI',42.96,-85.67],['Des Moines','IA',41.59,-93.62],['Buffalo','NY',42.89,-78.88],
         ['Fargo','ND',46.88,-96.79],['Anchorage','AK',61.22,-149.90],['Missoula','MT',46.87,-113.99],['Syracuse','NY',43.05,-76.15]],   /* v378 the lean-to greenhouse: cold towns, a warm house wall */
    38: [['Asheville','NC',35.60,-82.55],['Burlington','VT',44.48,-73.21],['Madison','WI',43.07,-89.40],['Ithaca','NY',42.44,-76.50],
         ['Boise','ID',43.62,-116.20],['Spokane','WA',47.66,-117.43],['Fort Collins','CO',40.59,-105.08],['Lincoln','NE',40.81,-96.70],
         ['Ann Arbor','MI',42.28,-83.74],['Portland','ME',43.66,-70.26],['Bend','OR',44.06,-121.31],['Lexington','KY',38.04,-84.50]],   /* v381 the hoop house: market gardeners, long seasons stretched */
    40: [['Flagstaff','AZ',35.20,-111.65],['Park City','UT',40.65,-111.50],['Jackson','WY',43.48,-110.76],['Stowe','VT',44.47,-72.69],
         ['Boulder','CO',40.01,-105.27],['Taos','NM',36.41,-105.57],['Marquette','MI',46.54,-87.40],['Bar Harbor','ME',44.39,-68.20],
         ['Hood River','OR',45.71,-121.52],['Sandpoint','ID',48.28,-116.55],['Lake Placid','NY',44.28,-73.98],['Truckee','CA',39.33,-120.18]],   /* v384 the A-frame greenhouse: snow country, steep roofs */
    43: [['Cape May','NJ',38.94,-74.91],['Galveston','TX',29.30,-94.80],['Eureka Springs','AR',36.40,-93.74],['Port Townsend','WA',48.12,-122.76],
         ['Savannah','GA',32.08,-81.09],['Saratoga Springs','NY',43.08,-73.78],['Ferndale','CA',40.58,-124.26],['Oak Park','IL',41.89,-87.78],
         ['Newport','RI',41.49,-71.31],['Asheville','NC',35.60,-82.55],['Madison','IN',38.74,-85.38],['Cincinnati','OH',39.10,-84.51]],   /* v387 the Victorian greenhouse: Victorian towns */
    45: [['Bend','OR',44.06,-121.31],['Missoula','MT',46.87,-113.99],['Ithaca','NY',42.44,-76.50],['Taos','NM',36.41,-105.57],
         ['Bisbee','AZ',31.45,-109.93],['Olympia','WA',47.04,-122.90],['Athens','GA',33.96,-83.38],['Lawrence','KS',38.97,-95.24],
         ['Bellingham','WA',48.75,-122.48],['Marfa','TX',30.31,-104.02],['Bar Harbor','ME',44.39,-68.20],['Eugene','OR',44.05,-123.09]],   /* v390 the old-window greenhouse: makers' and garden towns */
    35: [['Austin','TX',30.27,-97.74],['Scottsdale','AZ',33.49,-111.93],['Charlotte','NC',35.23,-80.84],['Nashville','TN',36.16,-86.78],
         ['Denver','CO',39.74,-104.99],['Tampa','FL',27.95,-82.46],['Raleigh','NC',35.78,-78.64],['San Diego','CA',32.72,-117.16],
         ['Atlanta','GA',33.75,-84.39],['Boise','ID',43.62,-116.20],['Sacramento','CA',38.58,-121.49],['Kansas City','MO',39.10,-94.58],
         /* v420 (Marek 2026-11-04 11:48: 30 more GARDEN POD references, 20 of them in the US) */
         ['Frisco','TX',33.15,-96.82],['Orlando','FL',28.54,-81.38],['Naperville','IL',41.75,-88.15],['Henderson','NV',36.04,-114.98],
         ['Greenville','SC',34.85,-82.40],['Colorado Springs','CO',38.83,-104.82],['Omaha','NE',41.26,-95.93],['Santa Rosa','CA',38.44,-122.71],
         ['San Antonio','TX',29.42,-98.49],['Ann Arbor','MI',42.28,-83.74],['Chattanooga','TN',35.05,-85.31],['Albuquerque','NM',35.08,-106.65],
         ['Virginia Beach','VA',36.85,-75.98],['Tulsa','OK',36.15,-95.99],['Palm Springs','CA',33.83,-116.55],['Louisville','KY',38.25,-85.76],
         ['Jacksonville','FL',30.33,-81.66],['Madison','WI',43.07,-89.40],['St. George','UT',37.10,-113.58],['Pittsburgh','PA',40.44,-79.99],
         ['Houston','TX',29.76,-95.37],['Birmingham','AL',33.52,-86.80],['Fort Collins','CO',40.59,-105.08],['Carmel','IN',39.98,-86.13],
         ['Wilmington','NC',34.23,-77.94],['Oklahoma City','OK',35.47,-97.52],['Fresno','CA',36.74,-119.79],['Grand Rapids','MI',42.96,-85.67],
         ['Sarasota','FL',27.34,-82.53],['Baton Rouge','LA',30.45,-91.19],['Prescott','AZ',34.54,-112.47],['Lancaster','PA',40.04,-76.31],
         ['Little Rock','AR',34.75,-92.29],['Bozeman','MT',45.68,-111.04],['Huntsville','AL',34.73,-86.59],['Des Moines','IA',41.59,-93.62]],   /* v376 the kitchen pod: backyard grilling country */
    16: [['Naples','FL',26.14,-81.79],['Scottsdale','AZ',33.49,-111.93],['San Diego','CA',32.72,-117.16],['Myrtle Beach','SC',33.69,-78.89],
         ['Galveston','TX',29.30,-94.80],['Santa Barbara','CA',34.42,-119.70]],
    54: [['Austin','TX',30.27,-97.74],['Portland','OR',45.52,-122.68],['Asheville','NC',35.60,-82.55],['Boulder','CO',40.01,-105.27],
         ['Savannah','GA',32.08,-81.09],['Minneapolis','MN',44.98,-93.27]],
    15: [['Boise','ID',43.62,-116.20],['Spokane','WA',47.66,-117.43],['Tucson','AZ',32.22,-110.97],['Charleston','SC',32.78,-79.93],
         ['Richmond','VA',37.54,-77.44],['Knoxville','TN',35.96,-83.92]],
    14: [['Austin','TX',30.27,-97.74],['Portland','OR',45.52,-122.68],['Denver','CO',39.74,-104.99],['Nashville','TN',36.16,-86.78],
         ['Minneapolis','MN',44.98,-93.27],['Raleigh','NC',35.78,-78.64],['Columbus','OH',39.96,-83.00],['Salt Lake City','UT',40.76,-111.89]]
  };
  REF_PLACES[53] = REF_PLACES[35];   /* v407 GARDEN POD Fitness: the kitchen pod's places */
  /* v340 (Marek 2026-10-22 00:28: ... a 20 napric evropou) the European
     places of the GARDEN STRUCTURES types: [name, country, lat, lon, ISO
     code]; a design with eu: true takes its place here and is built metric */
  var REF_PLACES_EU = {
    19: [['Barcelona','Spain',41.39,2.17,'ES'],['Milan','Italy',45.46,9.19,'IT'],['Lisbon','Portugal',38.72,-9.14,'PT'],['Munich','Germany',48.14,11.58,'DE']],
    20: [['Utrecht','Netherlands',52.09,5.12,'NL'],['Freiburg','Germany',47.99,7.85,'DE'],['Copenhagen','Denmark',55.68,12.57,'DK'],['Oxford','United Kingdom',51.75,-1.26,'GB'],
         ['Uppsala','Sweden',59.86,17.64,'SE'],['Brno','Czech Republic',49.20,16.61,'CZ'],['Ghent','Belgium',51.05,3.72,'BE'],['Graz','Austria',47.07,15.44,'AT']],
    22: [['Bath','United Kingdom',51.38,-2.36,'GB'],['Rouen','France',49.44,1.10,'FR'],['Bruges','Belgium',51.21,3.22,'BE'],['Lucca','Italy',43.84,10.50,'IT'],
         ['Haarlem','Netherlands',52.38,4.64,'NL']],
    23: [['Salzburg','Austria',47.81,13.06,'AT'],['Krakow','Poland',50.06,19.94,'PL'],['Dresden','Germany',51.05,13.74,'DE'],['York','United Kingdom',53.96,-1.08,'GB'],
         ['Como','Italy',45.81,9.09,'IT'],['Bled','Slovenia',46.37,14.11,'SI']],
    24: [['Seville','Spain',37.39,-5.98,'ES'],['Florence','Italy',43.77,11.26,'IT'],['Nice','France',43.70,7.27,'FR'],['Faro','Portugal',37.02,-7.93,'PT'],
         ['Split','Croatia',43.51,16.44,'HR'],['Thessaloniki','Greece',40.64,22.94,'GR'],['Valencia','Spain',39.47,-0.38,'ES'],['Marseille','France',43.30,5.37,'FR'],
         ['Athens','Greece',37.98,23.73,'GR']],
    26: [['Leiden','Netherlands',52.16,4.49,'NL'],['Aarhus','Denmark',56.16,10.20,'DK'],['Cambridge','United Kingdom',52.21,0.12,'GB'],['Heidelberg','Germany',49.40,8.69,'DE'],
         ['Olomouc','Czech Republic',49.59,17.25,'CZ']],   /* v362 the cottage */
    27: [['Utrecht','Netherlands',52.09,5.12,'NL'],['Odense','Denmark',55.40,10.39,'DK'],['Oxford','United Kingdom',51.75,-1.26,'GB'],['Freiburg','Germany',47.99,7.84,'DE'],
         ['Hradec Kralove','Czech Republic',50.21,15.83,'CZ']],   /* v363 the stilt house */
    28: [['Bergen','Norway',60.39,5.32,'NO'],['Innsbruck','Austria',47.27,11.39,'AT'],['Annecy','France',45.90,6.13,'FR'],['Liberec','Czech Republic',50.77,15.06,'CZ'],
         ['Zakopane','Poland',49.30,19.95,'PL']],   /* v364 the A-frame */
    29: [['Delft','Netherlands',52.01,4.36,'NL'],['Aalborg','Denmark',57.05,9.92,'DK'],['Exeter','United Kingdom',50.72,-3.53,'GB'],['Regensburg','Germany',49.01,12.10,'DE'],
         ['Pardubice','Czech Republic',50.04,15.78,'CZ']],   /* v365 the play fort */
    30: [['Eindhoven','Netherlands',51.44,5.48,'NL'],['Copenhagen','Denmark',55.68,12.57,'DK'],['Bristol','United Kingdom',51.45,-2.59,'GB'],['Munich','Germany',48.14,11.58,'DE'],
         ['Brno','Czech Republic',49.20,16.61,'CZ']],   /* v366 the modern house */
    31: [['Zwolle','Netherlands',52.52,6.08,'NL'],['Viborg','Denmark',56.45,9.40,'DK'],['York','United Kingdom',53.96,-1.08,'GB'],['Lueneburg','Germany',53.25,10.41,'DE'],
         ['Telc','Czech Republic',49.18,15.45,'CZ']],   /* v367 the little barn */
    37: [['Groningen','Netherlands',53.22,6.57,'NL'],['Exeter','United Kingdom',50.72,-3.53,'GB'],['Ghent','Belgium',51.05,3.72,'BE'],['Angers','France',47.47,-0.55,'FR'],
         ['Ceske Budejovice','Czech Republic',48.97,14.47,'CZ']],   /* v379 the chicken tractor */
    52: [['Freiburg','Germany',47.99,7.84,'DE'],['Ghent','Belgium',51.05,3.72,'BE'],['Uppsala','Sweden',59.86,17.64,'SE'],['Exeter','United Kingdom',50.72,-3.53,'GB'],
         ['Brno','Czech Republic',49.20,16.61,'CZ']],   /* v401 the hoop coop */
    49: [['Zwolle','Netherlands',52.52,6.08,'NL'],['Viborg','Denmark',56.45,9.40,'DK'],['York','United Kingdom',53.96,-1.08,'GB'],['Lueneburg','Germany',53.25,10.41,'DE'],
         ['Telc','Czech Republic',49.18,15.45,'CZ']],   /* v397 the barn coop */
    46: [['Leuven','Belgium',50.88,4.70,'BE'],['York','United Kingdom',53.96,-1.08,'GB'],['Freiburg','Germany',47.99,7.85,'DE'],['Annecy','France',45.90,6.13,'FR'],
         ['Olomouc','Czech Republic',49.59,17.25,'CZ']],   /* v391 the cupola coop */
    42: [['Haarlem','Netherlands',52.38,4.64,'NL'],['Bath','United Kingdom',51.38,-2.36,'GB'],['Mechelen','Belgium',51.03,4.48,'BE'],['Nancy','France',48.69,6.18,'FR'],
         ['Zlin','Czech Republic',49.23,17.67,'CZ']],   /* v386 the lean-to coop */
    39: [['Kassel','Germany',51.31,9.48,'DE'],['York','United Kingdom',53.96,-1.08,'GB'],['Bruges','Belgium',51.21,3.22,'BE'],['Dijon','France',47.32,5.04,'FR'],
         ['Hradec Kralove','Czech Republic',50.21,15.83,'CZ']],   /* v383 the walk-in coop */
    41: [['Ghent','Belgium',51.05,3.72,'BE'],['Linz','Austria',48.31,14.29,'AT'],['Poznan','Poland',52.41,16.93,'PL'],['Lyon','France',45.76,4.84,'FR'],
         ['Aarhus','Denmark',56.16,10.20,'DK']],   /* v385 the classic dog house */
    44: [['Tampere','Finland',61.50,23.76,'FI'],['Trondheim','Norway',63.43,10.40,'NO'],['Umea','Sweden',63.83,20.26,'SE'],['Innsbruck','Austria',47.27,11.39,'AT'],
         ['Zakopane','Poland',49.30,19.95,'PL']],   /* v388 the insulated dog house: cold winters */
    47: [['Graz','Austria',47.07,15.44,'AT'],['Wroclaw','Poland',51.11,17.04,'PL'],['Odense','Denmark',55.40,10.39,'DK'],['Freiburg','Germany',47.99,7.84,'DE'],
         ['Brno','Czech Republic',49.20,16.61,'CZ']],   /* v392 the kennel with run */
    48: [['Salzburg','Austria',47.81,13.04,'AT'],['Gdansk','Poland',54.35,18.65,'PL'],['Aalborg','Denmark',57.05,9.92,'DK'],['Muenster','Germany',51.96,7.63,'DE'],
         ['Ceske Budejovice','Czech Republic',48.97,14.47,'CZ']],   /* v396 the double dog house */
    51: [['Copenhagen','Denmark',55.68,12.57,'DK'],['Rotterdam','Netherlands',51.92,4.48,'NL'],['Hamburg','Germany',53.55,9.99,'DE'],['Vienna','Austria',48.21,16.37,'AT'],
         ['Brno','Czech Republic',49.20,16.61,'CZ']],   /* v403 the modern dog house */
    34: [['Utrecht','Netherlands',52.09,5.12,'NL'],['Bristol','United Kingdom',51.45,-2.59,'GB'],['Leuven','Belgium',50.88,4.70,'BE'],['Tours','France',47.39,0.69,'FR'],
         ['Olomouc','Czech Republic',49.59,17.25,'CZ']],   /* v375 the backyard coop */
    32: [['Freiburg','Germany',47.99,7.85,'DE'],['Annecy','France',45.90,6.13,'FR'],['Tartu','Estonia',58.38,26.72,'EE'],['Ljubljana','Slovenia',46.06,14.51,'SI'],
         ['Cesky Krumlov','Czech Republic',48.81,14.32,'CZ']],   /* v368 the tree fort */
    33: [['Utrecht','Netherlands',52.09,5.12,'NL'],['Uppsala','Sweden',59.86,17.64,'SE'],['Brno','Czech Republic',49.20,16.61,'CZ'],['Graz','Austria',47.07,15.44,'AT'],
         ['Odense','Denmark',55.40,10.40,'DK']],   /* v373 the gable greenhouse */
    36: [['Tampere','Finland',61.50,23.79,'FI'],['Trondheim','Norway',63.43,10.40,'NO'],['Olomouc','Czech Republic',49.59,17.25,'CZ'],['Innsbruck','Austria',47.27,11.39,'AT'],
         ['Aberdeen','United Kingdom',57.15,-2.09,'GB']],   /* v378 the lean-to greenhouse */
    38: [['Wageningen','Netherlands',51.97,5.67,'NL'],['Freiburg','Germany',47.99,7.84,'DE'],['Brno','Czech Republic',49.20,16.61,'CZ'],['Uppsala','Sweden',59.86,17.64,'SE'],
         ['Cork','Ireland',51.90,-8.47,'IE']],   /* v381 the hoop house */
    40: [['Chamonix','France',45.92,6.87,'FR'],['Zakopane','Poland',49.30,19.95,'PL'],['Bergen','Norway',60.39,5.32,'NO'],['Liberec','Czech Republic',50.77,15.06,'CZ'],
         ['Garmisch-Partenkirchen','Germany',47.49,11.10,'DE']],   /* v384 the A-frame greenhouse */
    43: [['Harrogate','United Kingdom',53.99,-1.54,'GB'],['Brighton','United Kingdom',50.82,-0.14,'GB'],['Cheltenham','United Kingdom',51.90,-2.08,'GB'],['Baden-Baden','Germany',48.76,8.24,'DE'],
         ['Karlovy Vary','Czech Republic',50.23,12.87,'CZ']],   /* v387 the Victorian greenhouse */
    45: [['Ghent','Belgium',51.05,3.72,'BE'],['Tartu','Estonia',58.38,26.72,'EE'],['Olomouc','Czech Republic',49.59,17.25,'CZ'],['Freiburg','Germany',47.99,7.84,'DE'],
         ['Bristol','United Kingdom',51.45,-2.59,'GB']],   /* v390 the old-window greenhouse */
    35: [['Munich','Germany',48.14,11.58,'DE'],['Brno','Czech Republic',49.20,16.61,'CZ'],['Lyon','France',45.76,4.84,'FR'],['Rotterdam','Netherlands',51.92,4.48,'NL'],
         ['Krakow','Poland',50.06,19.94,'PL'],
         ['Ljubljana','Slovenia',46.06,14.51,'SI'],['Valencia','Spain',39.47,-0.38,'ES'],['Salzburg','Austria',47.81,13.04,'AT'],['Leuven','Belgium',50.88,4.70,'BE'],
         ['Wroclaw','Poland',51.11,17.04,'PL'],['Cork','Ireland',51.90,-8.47,'IE'],['Dresden','Germany',51.05,13.74,'DE'],['Tallinn','Estonia',59.44,24.75,'EE'],
         ['Ostrava','Czech Republic',49.82,18.26,'CZ'],['Treviso','Italy',45.67,12.24,'IT']]   /* v376 the kitchen pod (v420 + 10) */
  };
  REF_PLACES_EU[53] = REF_PLACES_EU[35];   /* v407 GARDEN POD Fitness: the kitchen pod's places */
  /* v420 (Marek 2026-11-04 11:48 "... 20 USA, 5 x canada 5 x EU"): THE CANADIAN places -- a design with ca: true takes its place
     here: [name, province, lat, lon, 'CA']; built in US lumber like the US ones (Canada's framing stock is the same: 2x lumber,
     4 x 8 ft sheets), its document's country CA; REF_POOL_CA when the list has nothing free */
  var REF_PLACES_CA = {
    35: [['Kelowna','BC',49.89,-119.50,'CA'],['Oakville','ON',43.47,-79.69,'CA'],['Calgary','AB',51.05,-114.07,'CA'],['Ottawa','ON',45.42,-75.70,'CA'],
         ['Halifax','NS',44.65,-63.58,'CA'],['Victoria','BC',48.43,-123.37,'CA'],['Edmonton','AB',53.55,-113.49,'CA'],['Winnipeg','MB',49.90,-97.14,'CA'],
         ['London','ON',42.98,-81.25,'CA'],['Quebec City','QC',46.81,-71.21,'CA'],['Saskatoon','SK',52.13,-106.67,'CA']]
  };
  REF_PLACES_CA[53] = REF_PLACES_CA[35];
  var REF_POOL_CA = [
    ['Nanaimo','BC',49.17,-123.94,'CA'],['Kamloops','BC',50.67,-120.33,'CA'],['Lethbridge','AB',49.69,-112.84,'CA'],['Red Deer','AB',52.27,-113.81,'CA'],
    ['Regina','SK',50.45,-104.61,'CA'],['Brandon','MB',49.85,-99.95,'CA'],['Thunder Bay','ON',48.38,-89.25,'CA'],['Sudbury','ON',46.49,-80.99,'CA'],
    ['Barrie','ON',44.39,-79.69,'CA'],['Kingston','ON',44.23,-76.49,'CA'],['Sherbrooke','QC',45.40,-71.89,'CA'],['Moncton','NB',46.09,-64.78,'CA'],
    ['Charlottetown','PE',46.24,-63.13,'CA'],['Fredericton','NB',45.96,-66.64,'CA']
  ];
  /* v344 the POOLS: when a design's own list has no town left that is free and 30 km from
     every pin, bref-v4 takes the town of its pool farthest from all pins (US / Europe) */
  var REF_POOL_US = [
    ['Concord','NH',43.21,-71.54],['Portsmouth','NH',43.07,-70.76],['Bangor','ME',44.80,-68.77],['Hartford','CT',41.76,-72.69],
    ['Springfield','MA',42.10,-72.59],['Worcester','MA',42.26,-71.80],['Albany','NY',42.65,-73.76],['Syracuse','NY',43.05,-76.15],
    ['Rochester','NY',43.16,-77.61],['Buffalo','NY',42.89,-78.88],['Binghamton','NY',42.10,-75.91],['Scranton','PA',41.41,-75.66],
    ['State College','PA',40.79,-77.86],['Erie','PA',42.13,-80.09],['Harrisburg','PA',40.27,-76.88],['Allentown','PA',40.60,-75.49],
    ['Wilmington','DE',39.74,-75.55],['Frederick','MD',39.41,-77.41],['Morgantown','WV',39.63,-79.96],['Charleston','WV',38.35,-81.63],
    ['Greenville','NC',35.61,-77.37],['Fayetteville','NC',35.05,-78.88],['Florence','SC',34.20,-79.76],['Macon','GA',32.84,-83.63],
    ['Valdosta','GA',30.83,-83.28],['Dothan','AL',31.22,-85.39],['Montgomery','AL',32.37,-86.30],['Tuscaloosa','AL',33.21,-87.57],
    ['Pensacola','FL',30.42,-87.22],['Panama City','FL',30.16,-85.66],['Lakeland','FL',28.04,-81.95],['Daytona Beach','FL',29.21,-81.02],
    ['Jackson','MS',32.30,-90.18],['Hattiesburg','MS',31.33,-89.29],['Johnson City','TN',36.31,-82.35],['Jackson','TN',35.61,-88.81],
    ['Clarksville','TN',36.53,-87.36],['Bowling Green','KY',36.99,-86.44],['Paducah','KY',37.08,-88.60],['Danville','VA',36.59,-79.40],
    ['Harrisonburg','VA',38.45,-78.87],['Toledo','OH',41.65,-83.54],['Dayton','OH',39.76,-84.19],['Akron','OH',41.08,-81.52],
    ['Lansing','MI',42.73,-84.56],['Kalamazoo','MI',42.29,-85.59],['Saginaw','MI',43.42,-83.95],['Marquette','MI',46.54,-87.40],
    ['South Bend','IN',41.68,-86.25],['Evansville','IN',37.97,-87.57],['Terre Haute','IN',39.47,-87.41],['Peoria','IL',40.69,-89.59],
    ['Springfield','IL',39.80,-89.64],['Champaign','IL',40.12,-88.24],['Rockford','IL',42.27,-89.09],['Green Bay','WI',44.51,-88.02],
    ['La Crosse','WI',43.80,-91.24],['Wausau','WI',44.96,-89.63],['St. Cloud','MN',45.56,-94.16],['Mankato','MN',44.16,-94.00],
    ['Cedar Rapids','IA',41.98,-91.67],['Sioux City','IA',42.50,-96.40],['Dubuque','IA',42.50,-90.66],['Springfield','MO',37.21,-93.29],
    ['Joplin','MO',37.08,-94.51],['Cape Girardeau','MO',37.31,-89.52],['Topeka','KS',39.05,-95.68],['Salina','KS',38.84,-97.61],
    ['Lincoln','NE',40.81,-96.70],['Grand Island','NE',40.92,-98.34],['Sioux Falls','SD',43.55,-96.73],['Rapid City','SD',44.08,-103.23],
    ['Fargo','ND',46.88,-96.79],['Bismarck','ND',46.81,-100.78],['Billings','MT',45.78,-108.50],['Great Falls','MT',47.50,-111.30],
    ['Casper','WY',42.87,-106.31],['Cheyenne','WY',41.14,-104.82],['Idaho Falls','ID',43.49,-112.03],['Twin Falls','ID',42.56,-114.46],
    ['Logan','UT',41.74,-111.83],['Elko','NV',40.83,-115.76],['Medford','OR',42.33,-122.87],['Klamath Falls','OR',42.22,-121.78],
    ['Yakima','WA',46.60,-120.51],['Wenatchee','WA',47.42,-120.31],['Kennewick','WA',46.21,-119.14],['Chico','CA',39.73,-121.84],
    ['Eureka','CA',40.80,-124.16],['Modesto','CA',37.64,-120.99],['Visalia','CA',36.33,-119.29],['Show Low','AZ',34.25,-110.03],
    ['Sierra Vista','AZ',31.55,-110.30],['Farmington','NM',36.73,-108.22],['Roswell','NM',33.39,-104.52],['Durango','CO',37.28,-107.88],
    ['Steamboat Springs','CO',40.48,-106.83],['San Angelo','TX',31.46,-100.44],['Laredo','TX',27.51,-99.51],['Brownsville','TX',25.90,-97.50],
    ['Victoria','TX',28.81,-97.00],['Texarkana','TX',33.43,-94.05],['Lawton','OK',34.61,-98.39],['Stillwater','OK',36.12,-97.06],
    ['Fort Smith','AR',35.39,-94.40],['Jonesboro','AR',35.84,-90.70],['Monroe','LA',32.51,-92.12],['Lake Charles','LA',30.23,-93.22]
  ];
  var REF_POOL_EU = [
    ['Porto','Portugal',41.15,-8.61,'PT'],['Coimbra','Portugal',40.21,-8.43,'PT'],['Bilbao','Spain',43.26,-2.93,'ES'],['Zaragoza','Spain',41.65,-0.89,'ES'],
    ['Malaga','Spain',36.72,-4.42,'ES'],['Granada','Spain',37.18,-3.60,'ES'],['Palma','Spain',39.57,2.65,'ES'],['Bordeaux','France',44.84,-0.58,'FR'],
    ['Toulouse','France',43.60,1.44,'FR'],['Montpellier','France',43.61,3.88,'FR'],['Lyon','France',45.76,4.84,'FR'],['Nantes','France',47.22,-1.55,'FR'],
    ['Annecy','France',45.90,6.13,'FR'],['Strasbourg','France',48.57,7.75,'FR'],['Lille','France',50.63,3.06,'FR'],['Reims','France',49.26,4.03,'FR'],
    ['Turin','Italy',45.07,7.69,'IT'],['Verona','Italy',45.44,10.99,'IT'],['Bologna','Italy',44.49,11.34,'IT'],['Perugia','Italy',43.11,12.39,'IT'],
    ['Bari','Italy',41.12,16.87,'IT'],['Cagliari','Italy',39.22,9.12,'IT'],['Innsbruck','Austria',47.27,11.39,'AT'],['Linz','Austria',48.31,14.29,'AT'],
    ['Bern','Switzerland',46.95,7.45,'CH'],['Lausanne','Switzerland',46.52,6.63,'CH'],['Nuremberg','Germany',49.45,11.08,'DE'],['Hamburg','Germany',53.55,9.99,'DE'],
    ['Bremen','Germany',53.08,8.80,'DE'],['Leipzig','Germany',51.34,12.37,'DE'],['Heidelberg','Germany',49.40,8.67,'DE'],['Hannover','Germany',52.37,9.73,'DE'],
    ['Groningen','Netherlands',53.22,6.57,'NL'],['Maastricht','Netherlands',50.85,5.69,'NL'],['Antwerp','Belgium',51.22,4.40,'BE'],['Aarhus','Denmark',56.16,10.20,'DK'],
    ['Gothenburg','Sweden',57.71,11.97,'SE'],['Bergen','Norway',60.39,5.32,'NO'],['Oslo','Norway',59.91,10.75,'NO'],['Tampere','Finland',61.50,23.76,'FI'],
    ['Edinburgh','United Kingdom',55.95,-3.19,'GB'],['Manchester','United Kingdom',53.48,-2.24,'GB'],['Cambridge','United Kingdom',52.21,0.12,'GB'],['Norwich','United Kingdom',52.63,1.30,'GB'],
    ['Galway','Ireland',53.27,-9.05,'IE'],['Cork','Ireland',51.90,-8.47,'IE'],['Wroclaw','Poland',51.11,17.04,'PL'],['Gdansk','Poland',54.35,18.65,'PL'],
    ['Bratislava','Slovakia',48.15,17.11,'SK'],['Zadar','Croatia',44.12,15.23,'HR'],['Debrecen','Hungary',47.53,21.63,'HU'],['Timisoara','Romania',45.75,21.23,'RO'],
    ['Plovdiv','Bulgaria',42.14,24.75,'BG'],['Heraklion','Greece',35.34,25.13,'GR']
  ];
  var REF_SET = [
    /* Hollywood swing (4) x 9: width, back tilt from upright to bed, roof, pitch, colour */
    { id: 'h1', t: 4, L: 1.96, c: 'birch', b: 23, roof: 'gable', pitch: 15 },
    { id: 'h2', t: 4, L: 1.80, c: 'oak', b: 35, roof: 'mono', pitch: 12 },
    { id: 'h3', t: 4, L: 2.24, c: 'white', b: 90, roof: 'gable', pitch: 20, cu: true },
    { id: 'h4', t: 4, L: 1.60, c: 'khaki', b: 28, roof: 'gable', pitch: 25 },
    { id: 'h5', t: 4, L: 2.40, c: 'birch', b: 62, roof: 'mono', pitch: 18, cu: true },
    { id: 'h6', t: 4, L: 1.40, c: 'oak', b: 18, roof: 'gable', pitch: 12 },
    { id: 'h7', t: 4, L: 2.10, c: 'white', b: 45, roof: 'gable', pitch: 30 },
    { id: 'h8', t: 4, L: 1.96, c: 'khaki', b: 78, roof: 'mono', pitch: 8 },
    { id: 'h9', t: 4, L: 1.70, c: 'oak', b: 30, roof: 'gable', pitch: 15, cu: true },
    /* porch swing (7) x 5: width, the beam's height, v269 pb the back (one rail / two rows) */
    { id: 'p1', t: 7, L: 1.22, c: 'white', ph: 2.44, pb: 0.48 },
    { id: 'p2', t: 7, L: 1.52, c: 'birch', ph: 2.60, pb: 0.28 },
    { id: 'p3', t: 7, L: 1.83, c: 'oak', ph: 2.74, pb: 0.48 },
    { id: 'p4', t: 7, L: 2.10, c: 'khaki', ph: 2.30, pb: 0.40 },
    { id: 'p5', t: 7, L: 1.37, c: 'white', ph: 2.90, pb: 0.24 },
    /* park bench (1) x 4: length, back rake, back off, kids' size */
    { id: 'b1', t: 1, L: 1.52, c: 'oak', b: 10 },
    { id: 'b2', t: 1, L: 1.83, c: 'khaki', b: 15 },
    { id: 'b3', t: 1, L: 1.22, c: 'white', b: 5, br: false },
    { id: 'b4', t: 1, L: 1.46304, c: 'birch', b: 12, lvl: 2 },
    /* Adirondack (9) x 4: chair, loveseat, three-seater, kids' chair */
    { id: 'a1', t: 9, n: 1, c: 'white', b: 25 },
    { id: 'a2', t: 9, n: 2, c: 'khaki', b: 20 },
    { id: 'a3', t: 9, n: 3, c: 'oak', b: 30 },
    { id: 'a4', t: 9, n: 1, c: 'birch', b: 22, lvl: 2 },
    /* picnic set (5) x 4: length, benches apart, kids' size */
    { id: 'n1', t: 5, L: 1.83, c: 'birch' },
    { id: 'n2', t: 5, L: 2.13, c: 'oak', sep: true },
    { id: 'n3', t: 5, L: 1.52, c: 'khaki' },
    { id: 'n4', t: 5, L: 1.20, c: 'white', lvl: 2 },
    /* A-frame swing (8) x 3: width, back tilt, roof */
    { id: 'f1', t: 8, L: 1.22, c: 'oak', b: 20, roof: 'gable', pitch: 15 },
    { id: 'f2', t: 8, L: 1.52, c: 'white', b: 35, roof: 'mono', pitch: 12 },
    { id: 'f3', t: 8, L: 1.83, c: 'khaki', b: 50, roof: 'gable', pitch: 22, cu: true },
    /* sofa (2) x 3: cushions, one or two frames, slats */
    { id: 's1', t: 2, mods: 2, c: 'birch', lvl: 2 },
    { id: 's2', t: 2, mods: 3, c: 'oak', lvl: 2, sl: 3 },
    { id: 's3', t: 2, mods: 4, c: 'white', lvl: 1 },
    /* kids' swing set (13) x 3: one, two, three swings */
    { id: 'k1', t: 13, L: 1.50, c: 'oak' },
    { id: 'k2', t: 13, L: 2.50, c: 'birch' },
    { id: 'k3', t: 13, L: 3.60, c: 'khaki' },
    { id: 'k4', t: 13, L: 1.52, c: 'oak', kb: true, b: 25 },   /* v299 the bench on the new frames */
    /* storage bench (12) x 2 */
    { id: 'r1', t: 12, L: 1.20, c: 'white', br: true },
    { id: 'r2', t: 12, L: 1.80, c: 'khaki', br: false },
    /* planter bench (10) x 2: length, planter size, back */
    { id: 'l1', t: 10, L: 1.50, c: 'oak', lvl: 1, br: true },
    { id: 'l2', t: 10, L: 2.10, c: 'birch', lvl: 2, br: false },
    /* tree bench (11) x 2: hexagon / octagon, back */
    { id: 't1', t: 11, L: 0.70, c: 'khaki', lvl: 1, br: false },
    { id: 't2', t: 11, L: 1.20, c: 'oak', lvl: 2, br: true },
    /* wave lounger (3) x 2: width, posture */
    { id: 'w1', t: 3, L: 1.30, c: 'birch', b: 44 },
    { id: 'w2', t: 3, L: 1.95, c: 'white', b: 90 },
    /* block bench (6) x 2: block colour, back */
    { id: 'c1', t: 6, L: 2.44, c: 'oak', lvl: 2, br: false },
    { id: 'c2', t: 6, L: 1.83, c: 'khaki', lvl: 4, br: true },
    /* v276 bed (14) x 3: mattress width (the nearest size of the units), the headboard's style and height */
    { id: 'd1', t: 14, c: 'birch', mw: 1.6, hs: 'rails', hh: 1.10 },
    { id: 'd2', t: 14, c: 'white', mw: 1.4, hs: 'slats', hh: 1.30 },
    { id: 'd3', t: 14, c: 'oak', mw: 1.8, hs: 'cross', hh: 1.50 },
    /* v284 the 2x4 bench (15) x 3: length, colour */
    { id: 'g1', t: 15, L: 1.22, c: 'birch' },
    { id: 'g2', t: 15, L: 1.83, c: 'oak', ar: true, ah: 0.67 },   /* v285 with the armrests */
    { id: 'g3', t: 15, L: 2.44, c: 'khaki' },
    /* v414 the twist bench (54) x 3: its length, the layout */
    { id: 'w1', t: 54, L: 1.80, c: 'pine', rm: 'bench' },
    { id: 'w2', t: 54, L: 2.10, c: 'oak', rm: 'chairs' },
    { id: 'w3', t: 54, L: 2.40, c: 'birch', rm: 'table' },
    /* v288 the sunbed (16) x 3: width, the backrest's angle, the kids' size */
    { id: 'o1', t: 16, c: 'pine', sw: 1.60, sa: 30 },
    { id: 'o2', t: 16, c: 'oak', sw: 1.90, sa: 45 },
    { id: 'o3', t: 16, c: 'white', lvl: 2, sw: 0.90, sa: 60 },
    { id: 's4', t: 16, c: 'khaki', sw: 0.70, sa: 45 },   /* v293 a single */
    /* v296 the pergola swing (17) x 3: the seat's length, the back fill, its gap, the cushion */
    { id: 'e1', t: 17, L: 2.00, c: 'white', fi: 'planks', gp: 0.032 },
    { id: 'e2', t: 17, L: 2.44, c: 'oak', fi: 'slats', gp: 0.020 },
    { id: 'e3', t: 17, L: 1.52, c: 'khaki', fi: 'planks', gp: 0.045, cu: false },
    /* v301 the modern swing (18) x 3: the seat's length, the colour, the foundation, the weave */
    { id: 'm1', t: 18, L: 1.80, c: 'grey', mf: 'screw', wv: false },
    { id: 'm2', t: 18, L: 2.10, c: 'white', mf: 'concrete', wv: true },
    { id: 'm3', t: 18, L: 1.40, c: 'oak', mf: 'screw', wv: true },
    { id: 'm4', t: 18, L: 1.80, c: 'grey', mf: 'concrete', wv: false, cn: true },   /* v308 the LED top */
    /* v303 the cinema bar (19) x 3: the beams' length, the screen down / rolled up */
    /* v340 GARDEN STRUCTURES (Marek 2026-10-22 00:28): 50 in the US -- pergola 14, raised bed 11,
       gazebo 10, arbor 8, cinema bar 7 -- and 20 in Europe (eu: true) -- pergola 6, raised bed 5,
       gazebo 4, arbor 3, cinema bar 2; each its own size, colour and options */
    /* the cinema bar (19): length, screen, its drop */
    { id: 'x1', t: 19, L: 4.10, c: 'pine', sc: true, dr: 0.85 },
    { id: 'x2', t: 19, L: 5.30, c: 'oak', sc: true, dr: 0.60 },
    { id: 'x3', t: 19, L: 3.20, c: 'khaki', sc: false },
    { id: 'x4', t: 19, L: 4.57, c: 'grey', sc: true, dr: 0.75 },
    { id: 'x5', t: 19, L: 3.66, c: 'white', sc: true, dr: 0.70 },
    { id: 'x6', t: 19, L: 4.88, c: 'birch', sc: true, dr: 0.80 },
    { id: 'x7', t: 19, L: 3.96, c: 'oak', sc: false },
    { id: 'x8', t: 19, eu: true, L: 4.40, c: 'pine', sc: true, dr: 0.70 },
    { id: 'x9', t: 19, eu: true, L: 3.80, c: 'grey', sc: true, dr: 0.80 },
    /* the raised bed (20): mode, length, width, courses, trellis / wings open */
    { id: 'y1', t: 20, rm: 'basic', L: 2.40, rw: 1.20, rn: 2, c: 'pine', rt: true },
    { id: 'y2', t: 20, rm: 'pyramid', L: 1.80, rw: 1.80, rn: 4, c: 'oak' },
    { id: 'y3', t: 20, rm: 'wings', L: 2.40, rw: 1.20, rn: 2, c: 'khaki', ro: true },
    { id: 'y4', t: 20, rm: 'basic', L: 3.66, rw: 0.91, rn: 3, c: 'grey' },
    { id: 'y5', t: 20, rm: 'basic', L: 2.44, rw: 1.22, rn: 2, c: 'white', rt: true },
    { id: 'y6', t: 20, rm: 'pyramid', L: 2.44, rw: 2.44, rn: 5, c: 'pine' },
    { id: 'y7', t: 20, rm: 'wings', L: 1.83, rw: 1.22, rn: 2, c: 'birch', ro: true },
    { id: 'y8', t: 20, rm: 'basic', L: 4.88, rw: 1.22, rn: 2, c: 'oak' },
    { id: 'y9', t: 20, rm: 'basic', L: 1.83, rw: 0.61, rn: 1, c: 'khaki', rt: true },
    { id: 'y10', t: 20, rm: 'pyramid', L: 1.22, rw: 1.22, rn: 3, c: 'white' },
    { id: 'y11', t: 20, rm: 'basic', L: 3.05, rw: 1.52, rn: 4, c: 'pine' },
    { id: 'y12', t: 20, eu: true, rm: 'basic', L: 2.00, rw: 1.00, rn: 3, c: 'pine', rt: true },
    { id: 'y13', t: 20, eu: true, rm: 'basic', L: 3.00, rw: 1.20, rn: 2, c: 'oak' },
    { id: 'y14', t: 20, eu: true, rm: 'pyramid', L: 2.00, rw: 2.00, rn: 4, c: 'khaki' },
    { id: 'y15', t: 20, eu: true, rm: 'wings', L: 2.40, rw: 1.30, rn: 2, c: 'white', ro: true },
    { id: 'y16', t: 20, eu: true, rm: 'basic', L: 1.60, rw: 0.80, rn: 4, c: 'grey' },
    /* the garden arbor (22): top, length, width, foundation, trellis */
    { id: 'u1', t: 22, gm: 'flat', L: 0.90, gw: 1.50, c: 'pine', gf: 'tile' },
    { id: 'u2', t: 22, gm: 'gable', L: 2.40, gw: 1.80, c: 'oak', gf: 'block', gl: true },   /* v333 + the trellis */
    { id: 'u3', t: 22, gm: 'arch', L: 3.60, gw: 1.20, c: 'white', gf: 'screw' },   /* v331 the arch (was flat) */
    { id: 'u4', t: 22, gm: 'arch', L: 0.91, gw: 1.22, c: 'white', gf: 'tile' },
    { id: 'u5', t: 22, gm: 'flat', L: 1.83, gw: 2.13, c: 'grey', gf: 'screw', gl: true },
    { id: 'u6', t: 22, gm: 'gable', L: 1.22, gw: 1.52, c: 'birch', gf: 'tile' },
    { id: 'u7', t: 22, gm: 'arch', L: 2.44, gw: 1.52, c: 'oak', gf: 'block', gl: true },
    { id: 'u8', t: 22, gm: 'flat', L: 4.27, gw: 1.83, c: 'khaki', gf: 'screw' },
    { id: 'u9', t: 22, eu: true, gm: 'arch', L: 1.00, gw: 1.20, c: 'white', gf: 'tile', gl: true },
    { id: 'u10', t: 22, eu: true, gm: 'gable', L: 2.00, gw: 1.50, c: 'oak', gf: 'screw' },
    { id: 'u11', t: 22, eu: true, gm: 'flat', L: 3.00, gw: 2.00, c: 'pine', gf: 'block' },
    /* the gazebo (23): hexagon / square, width, foundation, covering, infill, its gap */
    { id: 'q1', t: 23, gn: 6, L: 3.00, c: 'pine' },     /* v328 the gazebo: hexagon / square, its width across the flats */
    { id: 'q2', t: 23, gn: 4, L: 3.60, c: 'oak', gf: 'pier', gc: 'seam', gi: 'board', gg: 0.03 },   /* v329 + foundation, covering, infill, gap */
    { id: 'q3', t: 23, gn: 6, L: 4.20, c: 'white', gf: 'block', gg: 0.10 },
    { id: 'q4', t: 23, gn: 6, L: 3.66, c: 'grey', gf: 'screw', gc: 'seam' },
    { id: 'q5', t: 23, gn: 4, L: 3.05, c: 'khaki', gf: 'block' },
    { id: 'q6', t: 23, gn: 6, L: 2.44, c: 'birch', gf: 'screw', gi: 'board', gg: 0.02 },
    { id: 'q7', t: 23, gn: 4, L: 4.27, c: 'white', gf: 'pier', gc: 'seam', gg: 0.08 },
    { id: 'q8', t: 23, gn: 6, L: 4.27, c: 'oak', gf: 'pier' },
    { id: 'q9', t: 23, gn: 4, L: 2.74, c: 'pine', gf: 'screw', gc: 'seam', gi: 'board', gg: 0.04 },
    { id: 'q10', t: 23, gn: 6, L: 3.35, c: 'khaki', gf: 'block', gg: 0.06 },
    { id: 'q11', t: 23, eu: true, gn: 6, L: 3.00, c: 'pine', gf: 'screw' },
    { id: 'q12', t: 23, eu: true, gn: 4, L: 3.60, c: 'grey', gf: 'pier', gc: 'seam', gi: 'board', gg: 0.03 },
    { id: 'q13', t: 23, eu: true, gn: 6, L: 4.00, c: 'oak', gf: 'block', gg: 0.08 },
    { id: 'q14', t: 23, eu: true, gn: 4, L: 2.60, c: 'white', gf: 'screw', gc: 'seam' },
    /* the pergola (24): length, width, roof, covered, infill kind + gap, foundation, filled fields
       (v340 ids v.. -- e1..e3 are the pergola swing's (17) and shared its documents) */
    { id: 'v1', t: 24, L: 3.00, pw: 3.00, c: 'pine', pr: 'flat', pt: 'h', pg: 0.02, pfl: { l1: 1, b1: 1 } },   /* v334 the corner pergola (flat, slatted walls) */
    { id: 'v2', t: 24, L: 3.60, pw: 3.60, c: 'oak', pr: 'hip', pc: true, pf: 'block' },             /* -- the hot tub pergola (hipped, covered) */
    { id: 'v3', t: 24, L: 4.20, pw: 3.00, c: 'white', pr: 'gable', pc: true, pt: 'lat', pf: 'pier', pfl: { r1: 1, r2: 1 } },   /* -- gable, a trellis side */
    { id: 'v4', t: 24, L: 3.66, pw: 3.66, c: 'grey', pr: 'flat', pt: 'xlat', pg: 0.06, pf: 'screw', pfl: { b1: 1, b2: 1 } },
    { id: 'v5', t: 24, L: 4.27, pw: 3.05, c: 'white', pr: 'gable', pc: true, pt: 'hlat', pg: 0.03, pf: 'pier', pfl: { l1: 1, l2: 1 } },
    { id: 'v6', t: 24, L: 3.05, pw: 3.05, c: 'khaki', pr: 'hip', pt: 'v', pg: 0.04, pf: 'block', pfl: { r1: 1 } },
    { id: 'v7', t: 24, L: 4.88, pw: 3.66, c: 'oak', pr: 'flat', pt: 'h', pg: 0.02, pf: 'pier', pfl: { b1: 1, b2: 1, l1: 1, l2: 1 } },
    { id: 'v8', t: 24, L: 2.44, pw: 2.44, c: 'birch', pr: 'flat', pf: 'screw' },
    { id: 'v9', t: 24, L: 3.66, pw: 3.05, c: 'pine', pr: 'gable', pt: 'lat', pg: 0.08, pf: 'screw', pfl: { r1: 1, r2: 1 } },
    { id: 'v10', t: 24, L: 4.27, pw: 4.27, c: 'grey', pr: 'hip', pc: true, pf: 'pier' },
    { id: 'v11', t: 24, L: 3.05, pw: 2.44, c: 'white', pr: 'flat', pt: 'hlat', pg: 0.025, pf: 'block', pfl: { l1: 1 } },
    { id: 'v12', t: 24, L: 4.88, pw: 4.27, c: 'oak', pr: 'gable', pc: true, pt: 'v', pg: 0.03, pf: 'pier', pfl: { b1: 1, b2: 1 } },
    { id: 'v13', t: 24, L: 3.66, pw: 2.74, c: 'khaki', pr: 'flat', pt: 'xlat', pg: 0.07, pf: 'screw', pfl: { r1: 1, r2: 1, b1: 1 } },
    { id: 'v14', t: 24, L: 3.35, pw: 3.35, c: 'birch', pr: 'hip', pt: 'h', pg: 0.015, pf: 'screw', pfl: { l1: 1, l2: 1 } },
    { id: 'v15', t: 24, eu: true, L: 3.00, pw: 3.00, c: 'white', pr: 'flat', pt: 'lat', pg: 0.06, pf: 'screw', pfl: { b1: 1 } },
    { id: 'v16', t: 24, eu: true, L: 4.00, pw: 3.00, c: 'oak', pr: 'gable', pc: true, pt: 'h', pg: 0.02, pf: 'pier', pfl: { r1: 1, r2: 1 } },
    { id: 'v17', t: 24, eu: true, L: 3.50, pw: 3.50, c: 'grey', pr: 'flat', pt: 'xlat', pg: 0.05, pf: 'block', pfl: { l1: 1, l2: 1 } },
    { id: 'v18', t: 24, eu: true, L: 4.80, pw: 3.60, c: 'pine', pr: 'hip', pc: true, pf: 'pier' },
    { id: 'v19', t: 24, eu: true, L: 2.60, pw: 2.60, c: 'khaki', pr: 'flat', pt: 'v', pg: 0.03, pf: 'screw', pfl: { r1: 1 } },
    { id: 'v20', t: 24, eu: true, L: 3.60, pw: 3.00, c: 'birch', pr: 'gable', pt: 'hlat', pg: 0.03, pf: 'screw', pfl: { b1: 1 } },
    /* v362 the cottage playhouse (26): length, width (hw), porch (hp) -- ids j.. */
    { id: 'j1', t: 26, L: 1.83, hw: 1.83, c: 'white', hp: true },
    { id: 'j2', t: 26, L: 2.44, hw: 1.83, c: 'pine', hp: true },
    { id: 'j3', t: 26, L: 1.52, hw: 1.52, c: 'khaki', hp: false },
    { id: 'j4', t: 26, L: 2.44, hw: 2.44, c: 'grey', hp: true },
    { id: 'j5', t: 26, L: 1.83, hw: 2.13, c: 'oak', hp: false },
    { id: 'j6', t: 26, L: 3.05, hw: 2.44, c: 'white', hp: true },
    { id: 'j7', t: 26, eu: true, L: 1.80, hw: 1.80, c: 'birch', hp: true },
    { id: 'j8', t: 26, eu: true, L: 2.40, hw: 2.00, c: 'white', hp: false },
    /* v363 the stilt house playhouse (27): length, width (hw), slide (hs) -- ids k.. */
    { id: 'k1', t: 27, L: 1.83, hw: 1.83, c: 'pine', hs: true },
    { id: 'k2', t: 27, L: 2.44, hw: 1.83, c: 'white', hs: true },
    { id: 'k3', t: 27, L: 1.52, hw: 1.52, c: 'khaki', hs: true },
    { id: 'k4', t: 27, L: 2.44, hw: 2.44, c: 'grey', hs: false },
    { id: 'k5', t: 27, L: 1.83, hw: 2.13, c: 'oak', hs: true },
    { id: 'k6', t: 27, L: 3.05, hw: 2.44, c: 'white', hs: true },
    { id: 'k7', t: 27, eu: true, L: 1.80, hw: 1.80, c: 'birch', hs: true },
    { id: 'k8', t: 27, eu: true, L: 2.40, hw: 2.00, c: 'pine', hs: false },
    /* v364 the A-frame playhouse (28): length, width (hw), porch (hp) -- ids l.. */
    { id: 'l1', t: 28, L: 1.83, hw: 2.44, c: 'pine', hp: true },
    { id: 'l2', t: 28, L: 2.44, hw: 2.44, c: 'grey', hp: true },
    { id: 'l3', t: 28, L: 1.52, hw: 2.13, c: 'khaki', hp: false },
    { id: 'l4', t: 28, L: 3.05, hw: 3.05, c: 'oak', hp: true },
    { id: 'l5', t: 28, L: 1.83, hw: 2.74, c: 'white', hp: false },
    { id: 'l6', t: 28, L: 2.44, hw: 2.13, c: 'birch', hp: true },
    { id: 'l7', t: 28, eu: true, L: 1.80, hw: 2.40, c: 'pine', hp: true },
    { id: 'l8', t: 28, eu: true, L: 2.40, hw: 2.70, c: 'grey', hp: false },
    /* v365 the play fort (29): length, width (hw), swings (hg) -- ids m.. */
    { id: 'm1', t: 29, L: 1.52, hw: 1.52, c: 'pine', hg: true },
    { id: 'm2', t: 29, L: 1.83, hw: 1.83, c: 'khaki', hg: true },
    { id: 'm3', t: 29, L: 1.22, hw: 1.22, c: 'white', hg: true },
    { id: 'm4', t: 29, L: 2.44, hw: 1.83, c: 'grey', hg: true },
    { id: 'm5', t: 29, L: 1.52, hw: 1.83, c: 'oak', hg: false },
    { id: 'm6', t: 29, L: 2.13, hw: 2.13, c: 'birch', hg: true },
    { id: 'm7', t: 29, eu: true, L: 1.50, hw: 1.50, c: 'pine', hg: true },
    { id: 'm8', t: 29, eu: true, L: 2.00, hw: 1.80, c: 'white', hg: false },
    /* v366 the modern house (30): length, width (hw), porch (hp) -- ids z.. */
    { id: 'z1', t: 30, L: 1.83, hw: 1.83, c: 'pine', hp: true },
    { id: 'z2', t: 30, L: 2.44, hw: 1.83, c: 'oak', hp: true },
    { id: 'z3', t: 30, L: 1.52, hw: 1.52, c: 'birch', hp: false },
    { id: 'z4', t: 30, L: 2.44, hw: 2.44, c: 'grey', hp: true },
    { id: 'z5', t: 30, L: 1.83, hw: 2.13, c: 'white', hp: false },
    { id: 'z6', t: 30, L: 3.05, hw: 2.44, c: 'khaki', hp: true },
    { id: 'z7', t: 30, eu: true, L: 1.80, hw: 1.80, c: 'pine', hp: true },
    { id: 'z8', t: 30, eu: true, L: 2.40, hw: 2.10, c: 'oak', hp: false },
    /* v367 the little barn (31): length, width (hw), loft (hl) -- ids i.. */
    { id: 'i1', t: 31, L: 1.83, hw: 1.83, c: 'pine', hl: true },
    { id: 'i2', t: 31, L: 2.44, hw: 2.13, c: 'oak', hl: true },
    { id: 'i3', t: 31, L: 1.83, hw: 1.52, c: 'white', hl: false },
    { id: 'i4', t: 31, L: 3.05, hw: 2.44, c: 'khaki', hl: true },
    { id: 'i5', t: 31, L: 2.44, hw: 1.83, c: 'grey', hl: true },
    { id: 'i6', t: 31, L: 1.52, hw: 1.83, c: 'birch', hl: false },
    { id: 'i7', t: 31, eu: true, L: 1.80, hw: 1.80, c: 'pine', hl: true },
    { id: 'i8', t: 31, eu: true, L: 2.40, hw: 2.10, c: 'oak', hl: true },
    /* v368 the tree fort (32): length, width (hw), the trunk (tr, m), the slide (sl) -- ids tf.. (every single letter is taken) */
    { id: 'tf1', t: 32, L: 2.13, hw: 2.13, c: 'pine', tr: 0.3048, sl: true },
    { id: 'tf2', t: 32, L: 2.44, hw: 2.44, c: 'oak', tr: 0.4572, sl: true },
    { id: 'tf3', t: 32, L: 1.83, hw: 1.83, c: 'khaki', tr: 0.2032, sl: true },
    { id: 'tf4', t: 32, L: 2.44, hw: 2.13, c: 'grey', tr: 0.3556, sl: false },
    { id: 'tf5', t: 32, L: 2.13, hw: 2.44, c: 'white', tr: 0.254, sl: true },
    { id: 'tf6', t: 32, L: 1.83, hw: 2.13, c: 'birch', tr: 0.1524, sl: true },
    { id: 'tf7', t: 32, eu: true, L: 2.10, hw: 2.10, c: 'pine', tr: 0.30, sl: true },
    { id: 'tf8', t: 32, eu: true, L: 2.40, hw: 2.20, c: 'oak', tr: 0.40, sl: false },
    /* v373 the gable greenhouse (33): length, width (hw), knee wall (kn) -- ids g.. */
    { id: 'g1', t: 33, L: 3.05, hw: 2.44, c: 'pine', kn: false },
    { id: 'g2', t: 33, L: 3.66, hw: 2.44, c: 'white', kn: true },
    { id: 'g3', t: 33, L: 2.44, hw: 1.83, c: 'oak', kn: false },
    { id: 'g4', t: 33, L: 4.88, hw: 3.05, c: 'grey', kn: true },
    { id: 'g5', t: 33, L: 3.66, hw: 3.05, c: 'birch', kn: false },
    { id: 'g6', t: 33, L: 6.10, hw: 3.66, c: 'pine', kn: true },
    { id: 'g7', t: 33, eu: true, L: 3.00, hw: 2.40, c: 'birch', kn: false },
    { id: 'g8', t: 33, eu: true, L: 4.20, hw: 3.00, c: 'white', kn: true },
    /* v376 the kitchen pod (35): length, the flap open (op) -- ids k.. */
    { id: 'k1', t: 35, L: 2.6035, kn: 4, c: 'pine', op: true },   /* v405 the bays' number (kn); L the length they give */
    { id: 'k2', t: 35, L: 3.2552, kn: 5, c: 'grey', op: true, kk: ['trash', 'grill', 'fridge', 'sink', 'burner'] },   /* v379 + equipment */
    { id: 'k3', t: 35, L: 2.2098, kn: 3, c: 'oak', op: true, kk: [null, 'burner'] },
    { id: 'k4', t: 35, L: 2.6035, kn: 4, c: 'grey', op: false },
    { id: 'k5', t: 35, L: 3.2004, kn: 5, c: 'birch', op: true, kk: ['pizza'] },
    { id: 'k6', t: 35, L: 2.6035, kn: 4, c: 'white', op: true, kk: [null, 'kamado'] },
    { id: 'k7', t: 35, eu: true, L: 2.735, kn: 4, c: 'pine', op: true },
    { id: 'k8', t: 35, eu: true, L: 3.544, kn: 5, c: 'grey', op: true, kk: ['fridge', null, null, null, 'pizza'] },
    /* v420 (Marek 2026-11-04 11:48 "priprav opet expanzi referencnich projektu - alespon 30, z toho 24 x kitchen pod. V ruznych
       kombinacich, provedeni. 20 USA, 5 x canada 5 x EU"): 24 kitchen pods + 6 fitness pods more -- 20 in the US, 5 in Canada (ca: true,
       US lumber), 5 in Europe (eu: true, metric); the counter's look as its switch pairs them (panel: timber frame + acacia; timber: timber
       frame + granite, fn; stone: steel frame + concrete, fr + fn; inox: steel frame + inox), the cladding (cl), the roof (rc), the
       foundation (fd), the shelf (sh), the colour, the bays (kn) and their equipment (kk), a few shut (op: false) */
    { id: 'k9',  t: 35, L: 3.3252, kn: 5, c: 'grey',  op: true,  fr: 'steel', fn: 'concrete', cl: 'corten', rc: 'green', fd: 'pier',  sh: true, kk: ['fridge', 'grill', 'burner', 'sink', 'drawer'] },
    { id: 'k10', t: 35, L: 2.7211, kn: 4, c: 'white', op: true,  fr: 'steel', fn: 'inox',     cl: 'fc',     rc: 'epdm',  fd: 'block', kk: ['trash', 'grill', 'kamado', 'sink'] },
    { id: 'k11', t: 35, L: 1.9558, kn: 3, c: 'khaki', op: true,  cl: 'bb', rc: 'seam', fd: 'screw', kk: ['pizza', 'drawer', 'sink'] },
    { id: 'k12', t: 35, L: 2.6035, kn: 4, c: 'oak',   op: true,  fn: 'granite', cl: 'v', rc: 'green', fd: 'block', sh: true, kk: [null, 'grill', 'burner', 'sink'] },
    { id: 'k13', t: 35, L: 3.3568, kn: 5, c: 'ssb',   op: true,  cl: 'h', rc: 'seam', fd: 'screw', kk: ['trash', 'grill', 'pizza', 'sink', 'fridge'] },
    { id: 'k14', t: 35, L: 2.2226, kn: 3, c: 'grey',  op: false, fr: 'steel', fn: 'inox',     cl: 'corr',   rc: 'seam',  fd: 'pier' },
    { id: 'k15', t: 35, L: 2.8775, kn: 4, c: 'pine',  op: true,  fr: 'steel', fn: 'concrete', cl: 'h',      rc: 'epdm',  fd: 'block', kk: ['fridge', 'grill', 'drawer', 'sink'] },
    { id: 'k16', t: 35, L: 3.1496, kn: 5, c: 'white', op: true,  fn: 'granite', cl: 'bb', rc: 'green', fd: 'pier', sh: true, kk: ['trash', 'kamado', 'grill', 'sink', 'door'] },
    { id: 'k17', t: 35, L: 2.6543, kn: 4, c: 'birch', op: true,  cl: 'corten', rc: 'seam', fd: 'screw', kk: ['door', 'grill', 'drawer', 'sink'] },
    { id: 'k18', t: 35, L: 2.0066, kn: 3, c: 'ssb',   op: true,  fn: 'granite', cl: 'v', rc: 'epdm', fd: 'screw', kk: ['grill', 'door', 'kamado'] },
    { id: 'k19', t: 35, L: 3.2744, kn: 5, c: 'grey',  op: true,  fr: 'steel', fn: 'inox',     cl: 'fc',     rc: 'green', fd: 'block', sh: true, kk: ['trash', 'grill', 'burner', 'sink', 'fridge'] },
    { id: 'k20', t: 35, L: 2.6195, kn: 4, c: 'khaki', op: false, fr: 'steel', fn: 'concrete', cl: 'corr',   rc: 'seam',  fd: 'pier' },
    { id: 'k21', t: 35, L: 3.2552, kn: 5, c: 'oak',   op: true,  cl: 'v', rc: 'epdm', fd: 'screw', kk: ['fridge', 'grill', 'drawer', 'sink', 'trash'] },
    { id: 'k22', t: 35, L: 1.9686, kn: 3, c: 'birch', op: true,  fr: 'steel', fn: 'concrete', cl: 'bb',     rc: 'green', fd: 'block', kk: ['kamado', 'drawer', 'sink'] },
    { id: 'k23', t: 35, L: 2.7211, kn: 4, c: 'ssb',   op: true,  fr: 'steel', fn: 'inox',     cl: 'h',      rc: 'seam',  fd: 'screw', sh: true, kk: ['trash', 'grill', 'pizza', 'sink'] },
    { id: 'k24', t: 35, L: 3.048, kn: 5, c: 'pine',  op: true,  fn: 'granite', cl: 'corten', rc: 'epdm', fd: 'pier', kk: [null, 'grill', 'burner', 'sink', 'drawer'] },
    { id: 'k25', t: 35, ca: true, L: 2.6035, kn: 4, c: 'grey',  op: true,  fn: 'granite', cl: 'bb', rc: 'seam', fd: 'pier' },
    { id: 'k26', t: 35, ca: true, L: 3.3252, kn: 5, c: 'ssb',   op: true,  fr: 'steel', fn: 'concrete', cl: 'h',    rc: 'seam', fd: 'pier', sh: true, kk: ['fridge', 'grill', 'burner', 'sink', 'drawer'] },
    { id: 'k27', t: 35, ca: true, L: 2.2098, kn: 3, c: 'white', op: false, cl: 'v', rc: 'epdm', fd: 'block' },
    { id: 'k28', t: 35, ca: true, L: 2.7211, kn: 4, c: 'oak',   op: true,  fr: 'steel', fn: 'inox',     cl: 'corr', rc: 'seam', fd: 'pier', kk: [null, 'kamado', 'grill', 'sink'] },
    { id: 'k29', t: 35, eu: true, L: 2.78, kn: 4, c: 'white', op: true,  fr: 'steel', fn: 'concrete', cl: 'fc',     rc: 'green', fd: 'block', sh: true, kk: ['trash', 'grill', 'pizza', 'sink'] },
    { id: 'k30', t: 35, eu: true, L: 3.449, kn: 5, c: 'khaki', op: true,  cl: 'bb', rc: 'seam', fd: 'screw', kk: ['fridge', 'grill', 'drawer', 'sink', 'drawer'] },
    { id: 'k31', t: 35, eu: true, L: 2.28,  kn: 3, c: 'grey',  op: true,  fr: 'steel', fn: 'inox',     cl: 'corten', rc: 'epdm',  fd: 'pier' },
    { id: 'k32', t: 35, eu: true, L: 2.83, kn: 4, c: 'ssb',   op: true,  fn: 'granite', cl: 'v', rc: 'green', fd: 'screw', kk: [null, 'grill', 'kamado', 'sink'] },
    /* v407 GARDEN POD Fitness (53): the number (kn), L the length it gives -- ids gf.. (v409 its lengths; ld the wall bars' attachment) */
    { id: 'gf1', t: 53, L: 3.2004, kn: 4, c: 'pine', op: true },
    { id: 'gf2', t: 53, L: 2.7432, kn: 3, c: 'grey', op: true, ld: 'dip' },
    { id: 'gf3', t: 53, eu: true, L: 3.15, kn: 4, c: 'birch', op: true },
    { id: 'gf4', t: 53, eu: true, L: 3.60, kn: 5, c: 'grey', op: true, ld: 'dip' },
    { id: 'gf5',  t: 53, L: 3.6576, kn: 5, c: 'grey',  op: true, cl: 'corten', rc: 'green', fd: 'pier',  ld: 'dip' },   /* v420 + 6 */
    { id: 'gf6',  t: 53, L: 2.7432, kn: 3, c: 'oak',   op: true, cl: 'bb',     rc: 'seam',  fd: 'screw' },
    { id: 'gf7',  t: 53, L: 3.2004, kn: 4, c: 'white', op: true, cl: 'fc',     rc: 'epdm',  fd: 'block', ld: 'dip' },
    { id: 'gf8',  t: 53, L: 3.6576, kn: 5, c: 'ssb',   op: true, cl: 'h',      rc: 'seam',  fd: 'screw' },
    { id: 'gf9',  t: 53, ca: true, L: 3.2004, kn: 4, c: 'khaki', op: true, cl: 'corr', rc: 'seam',  fd: 'pier' },
    { id: 'gf10', t: 53, eu: true, L: 2.70,   kn: 3, c: 'birch', op: true, cl: 'v',    rc: 'green', fd: 'block', ld: 'dip' },
    /* v375 the backyard coop (34): length (the whole run), width (hw), hens (hn), the run (rn) -- ids ck.. */
    { id: 'ck1', t: 34, L: 3.048, hw: 1.8288, c: 'pine', hn: 6, rn: true },
    { id: 'ck2', t: 34, L: 3.048, hw: 1.2192, c: 'birch', hn: 4, rn: true },
    { id: 'ck3', t: 34, L: 4.2672, hw: 1.8288, c: 'oak', hn: 8, rn: true },
    { id: 'ck4', t: 34, L: 3.9624, hw: 2.4384, c: 'white', hn: 10, rn: true },
    { id: 'ck5', t: 34, L: 1.2192, hw: 1.2192, c: 'khaki', hn: 3, rn: false },
    { id: 'ck6', t: 34, L: 4.8768, hw: 2.4384, c: 'grey', hn: 12, rn: true },
    { id: 'ck7', t: 34, eu: true, L: 3.10, hw: 1.80, c: 'pine', hn: 6, rn: true },
    { id: 'ck8', t: 34, eu: true, L: 3.20, hw: 1.50, c: 'oak', hn: 5, rn: true },
    /* v383 the walk-in coop (39): length, width (hw), hens (hn), the run (rn) -- ids wk.. */
    { id: 'wk1', t: 39, L: 3.9624, hw: 2.4384, c: 'pine', hn: 10, rn: true },
    { id: 'wk2', t: 39, L: 3.048, hw: 1.8288, c: 'birch', hn: 6, rn: true },
    { id: 'wk3', t: 39, L: 4.572, hw: 2.4384, c: 'white', hn: 12, rn: true },
    { id: 'wk4', t: 39, L: 4.8768, hw: 3.048, c: 'oak', hn: 16, rn: true },
    { id: 'wk5', t: 39, L: 6.096, hw: 3.048, c: 'grey', hn: 20, rn: true },
    { id: 'wk6', t: 39, L: 1.2192, hw: 2.4384, c: 'khaki', hn: 8, rn: false },
    { id: 'wk7', t: 39, eu: true, L: 3.90, hw: 2.40, c: 'pine', hn: 10, rn: true },
    { id: 'wk8', t: 39, eu: true, L: 5.00, hw: 2.70, c: 'white', hn: 14, rn: true },
    /* v386 the lean-to coop (42): length, width (hw), hens (hn), the run (rn) -- ids lt.. */
    { id: 'lt1', t: 42, L: 3.048, hw: 1.8288, c: 'pine', hn: 6, rn: true },
    { id: 'lt2', t: 42, L: 2.4384, hw: 1.2192, c: 'birch', hn: 3, rn: true },
    { id: 'lt3', t: 42, L: 3.6576, hw: 2.1336, c: 'white', hn: 8, rn: true },
    { id: 'lt4', t: 42, L: 4.8768, hw: 2.4384, c: 'oak', hn: 12, rn: true },
    { id: 'lt5', t: 42, L: 1.524, hw: 1.8288, c: 'khaki', hn: 4, rn: false },
    { id: 'lt6', t: 42, L: 4.8768, hw: 1.8288, c: 'grey', hn: 9, rn: true },
    { id: 'lt7', t: 42, eu: true, L: 3.10, hw: 1.80, c: 'pine', hn: 6, rn: true },
    { id: 'lt8', t: 42, eu: true, L: 4.00, hw: 2.10, c: 'khaki', hn: 8, rn: true },
    /* v391 the cupola coop (46): the depth (L), the whole width (hw), hens (hn), the run (rn) -- ids cu.. */
    { id: 'cu1', t: 46, L: 1.2192, hw: 3.048, c: 'oak', hn: 4, rn: true },
    { id: 'cu2', t: 46, L: 1.2192, hw: 2.7432, c: 'pine', hn: 2, rn: true },
    { id: 'cu3', t: 46, L: 1.8288, hw: 3.6576, c: 'white', hn: 6, rn: true },
    { id: 'cu4', t: 46, L: 1.8288, hw: 4.2672, c: 'grey', hn: 8, rn: true },
    { id: 'cu5', t: 46, L: 1.2192, hw: 1.2192, c: 'khaki', hn: 3, rn: false },
    { id: 'cu6', t: 46, L: 2.1336, hw: 4.572, c: 'birch', hn: 10, rn: true },
    { id: 'cu7', t: 46, eu: true, L: 1.20, hw: 3.10, c: 'oak', hn: 4, rn: true },
    { id: 'cu8', t: 46, eu: true, L: 1.70, hw: 3.60, c: 'pine', hn: 6, rn: true },
    /* v397 the barn coop (49): the length (L), width (hw), hens (hn), the run (rn) -- ids bc.. */
    { id: 'bc1', t: 49, L: 3.048, hw: 1.8288, c: 'pine', hn: 6, rn: true },
    { id: 'bc2', t: 49, L: 3.048, hw: 1.2192, c: 'white', hn: 4, rn: true },
    { id: 'bc3', t: 49, L: 4.2672, hw: 1.8288, c: 'pine', hn: 8, rn: true },
    { id: 'bc4', t: 49, L: 3.9624, hw: 2.4384, c: 'grey', hn: 10, rn: true },
    { id: 'bc5', t: 49, L: 1.2192, hw: 1.2192, c: 'pine', hn: 3, rn: false },
    { id: 'bc6', t: 49, L: 4.8768, hw: 2.4384, c: 'oak', hn: 12, rn: true },
    { id: 'bc7', t: 49, eu: true, L: 3.10, hw: 1.80, c: 'pine', hn: 6, rn: true },
    { id: 'bc8', t: 49, eu: true, L: 3.70, hw: 2.10, c: 'white', hn: 8, rn: true },
    /* v401 the hoop coop (52): the run's length (L) and width (hw), hens (hn), the run (rn) -- ids hc.. */
    { id: 'hc1', t: 52, L: 4.8768, hw: 3.048, c: 'khaki', hn: 6, rn: true },
    { id: 'hc2', t: 52, L: 4.2672, hw: 3.048, c: 'white', hn: 4, rn: true },
    { id: 'hc3', t: 52, L: 6.096, hw: 3.6576, c: 'pine', hn: 10, rn: true },
    { id: 'hc4', t: 52, L: 7.3152, hw: 3.6576, c: 'grey', hn: 12, rn: true },
    { id: 'hc5', t: 52, L: 4.8768, hw: 3.3528, c: 'birch', hn: 8, rn: true },
    { id: 'hc6', t: 52, L: 5.4864, hw: 4.2672, c: 'oak', hn: 12, rn: true },
    { id: 'hc7', t: 52, eu: true, L: 4.80, hw: 3.00, c: 'khaki', hn: 6, rn: true },
    { id: 'hc8', t: 52, eu: true, L: 6.00, hw: 3.60, c: 'white', hn: 10, rn: true },
    /* v385 the classic dog house (41): length, width (hw), the dog's height (dg), the porch (hp) -- ids dg.. */
    { id: 'dg1', t: 41, L: 1.2192, hw: 1.016, c: 'pine', dg: 0.5842, hp: false },
    { id: 'dg2', t: 41, L: 0.8636, hw: 0.7112, c: 'white', dg: 0.381, hp: true },
    { id: 'dg3', t: 41, L: 1.4224, hw: 1.0668, c: 'grey', dg: 0.635, hp: true },
    { id: 'dg4', t: 41, L: 1.1176, hw: 0.9144, c: 'birch', dg: 0.5334, hp: false },
    { id: 'dg5', t: 41, L: 1.6256, hw: 1.3208, c: 'oak', dg: 0.8128, hp: true },
    { id: 'dg6', t: 41, L: 0.6604, hw: 0.5588, c: 'khaki', dg: 0.254, hp: false },
    { id: 'dg7', t: 41, eu: true, L: 1.20, hw: 0.95, c: 'pine', dg: 0.55, hp: false },
    { id: 'dg8', t: 41, eu: true, L: 1.00, hw: 0.85, c: 'white', dg: 0.45, hp: true },
    { id: 'di1', t: 44, L: 1.5748, hw: 1.1176, c: 'pine', dg: 0.5588, fl: true },    /* v388 the insulated dog house: its dog, width, flap */
    { id: 'di2', t: 44, L: 1.27, hw: 0.9144, c: 'white', dg: 0.381, fl: true },
    { id: 'di3', t: 44, L: 1.778, hw: 1.1684, c: 'grey', dg: 0.635, fl: true },
    { id: 'di4', t: 44, L: 1.9304, hw: 1.27, c: 'oak', dg: 0.7112, fl: false },
    { id: 'di5', t: 44, L: 1.4224, hw: 0.9652, c: 'birch', dg: 0.4572, fl: true },
    { id: 'di6', t: 44, L: 2.1336, hw: 1.4224, c: 'khaki', dg: 0.8128, fl: true },
    { id: 'di7', t: 44, eu: true, L: 1.55, hw: 1.20, c: 'pine', dg: 0.55, fl: true },
    { id: 'di8', t: 44, eu: true, L: 1.30, hw: 1.00, c: 'white', dg: 0.40, fl: false },
    { id: 'kr1', t: 47, L: 1.1684, hw: 0.9652, c: 'pine', dg: 0.5588, hp: true },     /* v392 the kennel with run: its dog, width, run (hp) */
    { id: 'kr2', t: 47, L: 0.8636, hw: 0.7112, c: 'white', dg: 0.381, hp: true },
    { id: 'kr3', t: 47, L: 1.3208, hw: 1.0668, c: 'grey', dg: 0.635, hp: true },
    { id: 'kr4', t: 47, L: 1.4732, hw: 1.2192, c: 'oak', dg: 0.7112, hp: true },
    { id: 'kr5', t: 47, L: 1.0668, hw: 0.9144, c: 'birch', dg: 0.4572, hp: false },
    { id: 'kr6', t: 47, L: 1.6256, hw: 1.3208, c: 'khaki', dg: 0.8128, hp: true },
    { id: 'kr7', t: 47, eu: true, L: 1.20, hw: 0.95, c: 'pine', dg: 0.55, hp: true },
    { id: 'kr8', t: 47, eu: true, L: 0.90, hw: 0.75, c: 'white', dg: 0.40, hp: true },
    { id: 'dd1', t: 48, L: 1.1684, hw: 1.778, c: 'pine', dg: 0.5588, hp: false },     /* v396 the double dog house: its dogs' height, width, porch (hp) */
    { id: 'dd2', t: 48, L: 0.8636, hw: 1.3208, c: 'white', dg: 0.381, hp: false },
    { id: 'dd3', t: 48, L: 1.3208, hw: 2.0828, c: 'grey', dg: 0.635, hp: true },
    { id: 'dd4', t: 48, L: 1.4732, hw: 2.286, c: 'oak', dg: 0.7112, hp: false },
    { id: 'dd5', t: 48, L: 1.0668, hw: 1.524, c: 'birch', dg: 0.4572, hp: true },
    { id: 'dd6', t: 48, L: 1.6256, hw: 2.4892, c: 'khaki', dg: 0.8128, hp: false },
    { id: 'dd7', t: 48, eu: true, L: 1.20, hw: 1.80, c: 'pine', dg: 0.55, hp: false },
    { id: 'dd8', t: 48, eu: true, L: 0.90, hw: 1.40, c: 'white', dg: 0.40, hp: true },
    { id: 'dm1', t: 51, L: 1.1684, hw: 0.9652, c: 'pine', dg: 0.5588, dk: true },      /* v403 the modern dog house: its dog's height, width, roof deck (dk) */
    { id: 'dm2', t: 51, L: 0.8636, hw: 0.7112, c: 'grey', dg: 0.381, dk: true },
    { id: 'dm3', t: 51, L: 1.3208, hw: 1.0668, c: 'oak', dg: 0.635, dk: false },
    { id: 'dm4', t: 51, L: 1.4732, hw: 1.1684, c: 'birch', dg: 0.7112, dk: true },
    { id: 'dm5', t: 51, L: 1.016, hw: 0.8128, c: 'khaki', dg: 0.4572, dk: true },
    { id: 'dm6', t: 51, L: 1.6256, hw: 1.3208, c: 'white', dg: 0.8128, dk: true },
    { id: 'dm7', t: 51, eu: true, L: 1.20, hw: 0.95, c: 'pine', dg: 0.55, dk: true },
    { id: 'dm8', t: 51, eu: true, L: 0.90, hw: 0.75, c: 'grey', dg: 0.40, dk: false },
    /* v378 the lean-to greenhouse (36): length along the house, depth (hw), knee wall (kn) -- ids gl.. */
    { id: 'gl1', t: 36, L: 3.05, hw: 2.44, c: 'pine', kn: true },
    { id: 'gl2', t: 36, L: 2.44, hw: 1.83, c: 'white', kn: false },
    { id: 'gl3', t: 36, L: 3.66, hw: 2.44, c: 'oak', kn: true },
    { id: 'gl4', t: 36, L: 4.88, hw: 3.05, c: 'grey', kn: false },
    { id: 'gl5', t: 36, L: 6.10, hw: 2.44, c: 'birch', kn: true },
    { id: 'gl6', t: 36, L: 3.05, hw: 1.83, c: 'pine', kn: false },
    { id: 'gl7', t: 36, eu: true, L: 3.00, hw: 2.00, c: 'birch', kn: true },
    { id: 'gl8', t: 36, eu: true, L: 4.00, hw: 2.40, c: 'white', kn: false },
    /* v379 the chicken tractor (37): length, width (hw), hens (hn), the wheels (wh) -- ids ct.. */
    { id: 'ct1', t: 37, L: 2.4384, hw: 1.8288, c: 'pine', hn: 4, wh: true },
    { id: 'ct2', t: 37, L: 3.048, hw: 1.8288, c: 'white', hn: 6, wh: true },
    { id: 'ct3', t: 37, L: 2.4384, hw: 1.8288, c: 'birch', hn: 2, wh: false },
    { id: 'ct4', t: 37, L: 3.3528, hw: 2.1336, c: 'oak', hn: 6, wh: true },
    { id: 'ct5', t: 37, L: 2.7432, hw: 2.1336, c: 'khaki', hn: 5, wh: false },
    { id: 'ct6', t: 37, L: 3.6576, hw: 1.8288, c: 'grey', hn: 6, wh: true },
    { id: 'ct7', t: 37, eu: true, L: 2.40, hw: 1.80, c: 'pine', hn: 4, wh: true },
    { id: 'ct8', t: 37, eu: true, L: 3.20, hw: 2.00, c: 'white', hn: 6, wh: false },
    /* v381 the hoop house (38): length, width (hw), the sides rolled up (kn) -- ids gt.. */
    { id: 'gt1', t: 38, L: 3.66, hw: 3.05, c: 'pine', kn: false },
    { id: 'gt2', t: 38, L: 4.88, hw: 3.05, c: 'pine', kn: true },
    { id: 'gt3', t: 38, L: 6.10, hw: 3.66, c: 'grey', kn: false },
    { id: 'gt4', t: 38, L: 7.32, hw: 4.27, c: 'oak', kn: true },
    { id: 'gt5', t: 38, L: 2.44, hw: 3.05, c: 'white', kn: false },
    { id: 'gt6', t: 38, L: 4.27, hw: 3.66, c: 'birch', kn: true },
    { id: 'gt7', t: 38, eu: true, L: 4.80, hw: 3.00, c: 'birch', kn: false },
    { id: 'gt8', t: 38, eu: true, L: 6.00, hw: 4.20, c: 'pine', kn: true },
    /* v384 the A-frame greenhouse (40): length, width (hw) -- ids ga.. */
    { id: 'ga1', t: 40, L: 3.66, hw: 3.66, c: 'pine' },
    { id: 'ga2', t: 40, L: 4.88, hw: 3.66, c: 'white' },
    { id: 'ga3', t: 40, L: 3.05, hw: 4.27, c: 'oak' },
    { id: 'ga4', t: 40, L: 6.10, hw: 4.88, c: 'grey' },
    { id: 'ga5', t: 40, L: 2.44, hw: 3.66, c: 'birch' },
    { id: 'ga6', t: 40, L: 4.27, hw: 4.27, c: 'pine' },
    { id: 'ga7', t: 40, eu: true, L: 3.60, hw: 3.60, c: 'birch' },
    { id: 'ga8', t: 40, eu: true, L: 4.80, hw: 4.20, c: 'white' },
    /* v387 the Victorian greenhouse (43): length incl. the bay, width (hw), the knee wall (kn) -- ids gv.. */
    { id: 'gv1', t: 43, L: 4.27, hw: 3.05, c: 'white', kn: true },
    { id: 'gv2', t: 43, L: 3.66, hw: 2.44, c: 'white', kn: true },
    { id: 'gv3', t: 43, L: 5.49, hw: 3.66, c: 'grey', kn: true },
    { id: 'gv4', t: 43, L: 3.05, hw: 3.05, c: 'pine' },
    { id: 'gv5', t: 43, L: 6.71, hw: 3.66, c: 'white', kn: true },
    { id: 'gv6', t: 43, L: 4.88, hw: 3.05, c: 'oak', kn: true },
    { id: 'gv7', t: 43, eu: true, L: 4.20, hw: 3.00, c: 'white', kn: true },
    { id: 'gv8', t: 43, eu: true, L: 5.40, hw: 3.60, c: 'grey', kn: true },
    /* v390 the old-window greenhouse (45): length, width (hw), the sashes' size (wn, the slider's index) -- ids gw.. */
    { id: 'gw1', t: 45, L: 3.07, hw: 2.30, c: 'white', wn: 2 },
    { id: 'gw2', t: 45, L: 2.44, hw: 1.83, c: 'pine', wn: 0 },
    { id: 'gw3', t: 45, L: 3.66, hw: 2.44, c: 'grey', wn: 1 },
    { id: 'gw4', t: 45, L: 4.61, hw: 2.77, c: 'white', wn: 3 },
    { id: 'gw5', t: 45, L: 5.38, hw: 3.07, c: 'oak', wn: 2 },
    { id: 'gw6', t: 45, L: 3.69, hw: 2.77, c: 'birch', wn: 4 },
    { id: 'gw7', t: 45, eu: true, L: 3.00, hw: 2.30, c: 'white', wn: 2 },
    { id: 'gw8', t: 45, eu: true, L: 4.50, hw: 3.00, c: 'pine', wn: 1 }
  ];
  /* the reference on the stage: the type's defaults, then its own keys
     (each clamped into the type's range), one build; no write anywhere */
  function refApply(r, quick) {
    if (!r || !(r.t > 0)) return false;
    var t = r.t | 0;
    selectVariant(t, true);
    if (r.c && COLOR_SCHEMES[r.c]) STATE.colorMode = r.c;
    if (typeof r.lvl === 'number') STATE.lvl = r.lvl;
    if (typeof r.br === 'boolean') STATE.backrestVisible = r.br;
    if (t === 2) {
      var mods = Math.max(SOFA.MODULES_MIN, Math.min(SOFA.MODULES_MAX, r.mods || SOFA.MODULES_DEFAULT));
      STATE.L = mods * SOFA.CUSHION + SOFA.POST * 2;
      STATE.H = (STATE.lvl === 2) ? SOFA.H_DEF_L2 : SOFA.H_DEF_L1;
      if (typeof r.sl === 'number') STATE.slats = r.sl;
    } else if (t === 9) {
      STATE.L = Math.round((r.n || 1) * ADI.SEAT_W * ((STATE.lvl === 2) ? ADI.KID : 1) * 1000) / 1000;
    } else if (typeof r.L === 'number') {
      if (typeof r.kb === 'boolean') STATE.kidsBench = r.kb;   /* v299 the kids' set: its bench (before its length range) */
      if (typeof r.rm === 'string') STATE.rbMode = r.rm;       /* v314 the raised bed: its mode (before its length range) */
      if (r.gm === 'flat' || r.gm === 'gable' || r.gm === 'arch') STATE.gaMode = r.gm;   /* v320 the garden arbor: its roof (v331 + 'arch') */
      if (r.gn === 4 || r.gn === 6) STATE.gzN = r.gn;                  /* v328 the gazebo: its shape */
      if (t === 24) {   /* v334 the pergola: width, roof, covering, infill kind, foundation, fields */
        STATE.peW = (typeof r.pw === 'number') ? r.pw : null; STATE.peGap = (typeof r.pg === 'number') ? r.pg : null;
        STATE.peRoof = r.pr || 'flat'; STATE.peCov = (r.pc === true); STATE.peFillT = r.pt || 'h'; STATE.peFound = r.pf || 'screw';
        STATE.peFields = (r.pfl && typeof r.pfl === 'object') ? JSON.parse(JSON.stringify(r.pfl)) : {};
      }
      if (t === 26) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp !== false); }
      if (t === 27) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phSlide = (r.hs !== false); STATE.phRoof = (r.rf === 'mono') ? 'mono' : null; }   /* v363 the stilt house: its width, its slide (v370 its roof, rf) */
      if (t === 29) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phSwings = (r.hg !== false); STATE.phRoof = (r.rf === 'mono') ? 'mono' : null; }   /* v365 the play fort: its width, its swings (v370 its roof, rf) */
      if (t === 30) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp !== false); }   /* v366 the modern house: its width, its porch */
      if (t === 31) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phLoft = (r.hl !== false); }    /* v367 the little barn: its width, its loft */
      if (t === 37) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.coHens = (typeof r.hn === 'number') ? r.hn : null; STATE.ctWheels = (r.wh !== false); }   /* v379 the chicken tractor: its width, hens, wheels */
      if (t === 34 || t === 39 || t === 42 || t === 46 || t === 49 || t === 52) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.coHens = (typeof r.hn === 'number') ? r.hn : null; STATE.coRun = (r.rn !== false); }
      if (t === DH_TYPE) { STATE.knDog = (typeof r.dg === 'number') ? r.dg : null; STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp === true); }   /* v385 the dog house: its dog (before its length range), width, porch */   /* v375 the backyard coop: its width, hens, run */
      if (t === DI_TYPE) { STATE.knDog = (typeof r.dg === 'number') ? r.dg : null; STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.knFlap = (r.fl !== false); }   /* v388 the insulated dog house: its dog, width, flap */
      if (t === DD_TYPE) { STATE.knDog = (typeof r.dg === 'number') ? r.dg : null; STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp === true); }
      if (t === DM_TYPE) { STATE.knDog = (typeof r.dg === 'number') ? r.dg : null; STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.knDeck = (r.dk !== false); }   /* v403 the modern dog house: its dog, width, roof deck */   /* v396 the double dog house: its dogs, width, porch */
      if (t === KR_TYPE) { STATE.knDog = (typeof r.dg === 'number') ? r.dg : null; STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp !== false); }   /* v392 the kennel with run: its dog, width, run */
      if (t === 32) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.tfTrunk = (typeof r.tr === 'number') ? r.tr : null; STATE.phSlide = (r.sl !== false); }   /* v368 the tree fort: its width, trunk, slide */
      if (t === 45) STATE.ghWin = (typeof r.wn === 'number') ? r.wn : null;   /* v390 the old-window greenhouse: its sashes (before its ranges) */
      if (t === 33 || t === 36 || t === 38 || t === 40 || t === 43 || t === 45) { STATE.ghW = (typeof r.hw === 'number') ? r.hw : null; STATE.ghKnee = (r.kn === true); STATE.ghBench = (r.bn === true); STATE.ghFound = (r.fd === 'block' || r.fd === 'pier') ? r.fd : 'screw'; }   /* v392 + its benches */   /* v373 the gable greenhouse: its width (clamped on use), its knee wall */
      if (t === 35 || t === 53) { STATE.kpOpen = (r.op !== false); STATE.kpAng = (typeof r.oa === 'number') ? r.oa : null; STATE.kpFrame = (r.fr === 'steel') ? 'steel' : 'wood'; STATE.kpKinds = Array.isArray(r.kk) ? r.kk.slice() : null; STATE.kpN = (r.kn === 3 || r.kn === 4 || r.kn === 5) ? r.kn : _kpNFromLen(STATE, r.L); STATE.kpFound = (r.fd === 'block' || r.fd === 'pier') ? r.fd : 'screw'; STATE.kpClad = (KP_CLAD_ORDER.indexOf(r.cl) >= 0) ? r.cl : 'h'; STATE.kpShelf = (r.sh === true); STATE.kpRoof = (r.rc === 'epdm' || r.rc === 'green') ? r.rc : 'seam'; STATE.kpFin = (r.fn === 'concrete' || r.fn === 'granite' || r.fn === 'inox') ? r.fn : 'acacia'; STATE.kpLad = (r.ld === 'dip') ? 'dip' : 'hooks'; STATE.kpExt = null; }   /* v405 its bays' number (kn); v420 the slider's second half all the way (a design does not save it) */   /* v376 the kitchen pod: its flap; v379 its bays' equipment */
      if (t === 28) { STATE.phW = (typeof r.hw === 'number') ? r.hw : null; STATE.phPorch = (r.hp !== false); }   /* v364 the A-frame: its width, its porch */   /* v362 the cottage: its width (clamped on use), its porch */
      if (t === 23) { STATE.gzFound = r.gf || 'screw'; STATE.gzCov = r.gc || 'shingle'; STATE.gzFill = r.gi || 'bal'; STATE.gzGap = (typeof r.gg === 'number') ? r.gg : null; STATE.gzFields = (r.gfl && typeof r.gfl === 'object') ? JSON.parse(JSON.stringify(r.gfl)) : {}; }   /* v329 its options; v350 its full sides */
      var R = _lengthRange(STATE);
      STATE.L = Math.max(R.min, Math.min(R.max, r.L));
    }
    if (t === 1 && STATE.lvl === 2) STATE.W = 0.5182;   /* the kids' bench (cycleLvl) */
    if (typeof r.b === 'number') {
      if (t === 1) STATE.backRakeDeg = Math.max(RANGES.backRakeDeg.min, Math.min(RANGES.backRakeDeg.max, r.b));
      else if (_isSwingBackType(t) || (t === 13 && STATE.kidsBench)) STATE.swingBack = Math.max(SWING.BACK_MIN, Math.min(_swingBackMax(STATE), r.b));
      else if (t === 3) STATE.waveBack = Math.max(15, Math.min(90, r.b));
      else if (t === 9) STATE.adiBack = Math.max(ADI.BACK_MIN, Math.min(ADI.BACK_MAX, r.b));
    }
    if (_isStandType(t)) {
      if (r.roof && SWING.ROOF_ORDER.indexOf(r.roof) >= 0) STATE.swingRoof = r.roof;
      if (typeof r.pitch === 'number') { var PR = SWING.PITCH[_swingRoof(STATE)]; STATE.swingPitch = Math.max(PR.min, Math.min(PR.max, r.pitch)); }
    }
    if (typeof r.cu === 'boolean') STATE.swingCushion = r.cu;
    if (r.mf === 'screw' || r.mf === 'concrete') STATE.mfFound = r.mf;   /* v301 the modern swing */
    if (typeof r.wv === 'boolean') STATE.mfWeave = r.wv;
    if (r.t === 18) STATE.mfCant = (r.cn === true);                                                   /* v308 the LED top */
    if (r.fi === 'planks' || r.fi === 'slats') STATE.porchFill = r.fi;                                 /* v296 the classic seat's back fill */
    if (typeof r.gp === 'number') STATE.porchGap = Math.max(PCL.GAP_MIN, Math.min(PCL.GAP_MAX, r.gp));
    if (typeof r.sep === 'boolean') STATE.picnicSeparate = r.sep;
    if (typeof r.dr === 'number') STATE.gsDrop = r.dr;                                                 /* v305 its drop (clamped on use) */
    if (typeof r.rw === 'number') STATE.rbW = r.rw;                                                    /* v314 the raised bed */
    if (typeof r.rn === 'number') STATE.rbN = r.rn;
    if (typeof r.ro === 'boolean') STATE.rbOpen = r.ro;
    STATE.rbTrellis = (r.t === 20 && r.rt === true);                                                   /* v316 its trellis */
    if (t === 22 && typeof r.gw === 'number') STATE.gaW = r.gw;   /* v320 the garden arbor: its width (clamped on use) */
    if (t === 22) STATE.gaFound = (r.gf === 'screw' || r.gf === 'block') ? r.gf : 'tile';   /* v322 its foundation */
    if (t === 22) STATE.gaGrid = (r.gl === true);                                                    /* v333 its trellis */
    if (typeof r.sc === 'boolean') STATE.gsScreen = r.sc;                                              /* v303 the cinema bar's screen */
    if (typeof r.ph === 'number') STATE.porchH = Math.max(PORCH.H_MIN, Math.min(PORCH.H_MAX, r.ph));
    if (typeof r.pb === 'number') STATE.psofaBack = Math.max(PSOFA.BACK_MIN, Math.min(PSOFA.BACK_MAX, r.pb));
    if (t === 21 && typeof r.mw === 'number') STATE.bedMW = r.mw;   /* v318 the floating bed: its mattress (snapped on use) */
    if (t === 14) {   /* v276 the bed: mattress width, the headboard's style and height (clamped on use) */
      if (typeof r.mw === 'number') STATE.bedMW = r.mw;
      if (typeof r.hh === 'number') STATE.bedHead = r.hh;
      if (r.hs && BED.STYLES.indexOf(r.hs) >= 0) { STATE.bedHeadStyle = r.hs; if (typeof r.br !== 'boolean') STATE.backrestVisible = true; }
    }
    if (t === 16) {   /* v288 the sunbed: width (snapped on use), the angle (the nearest notch) */
      if (typeof r.sw === 'number') STATE.sbW = r.sw;
      if (typeof r.sa === 'number') STATE.sbAng = r.sa;
    }
    if (t === 54 && RTB.MODES.indexOf(r.rm) >= 0) STATE.rtbMode = r.rm;   /* v414 the twist bench's layout */
    if (t === 15) {   /* v285 the 2x4 bench: the armrests and their top (clamped on use) */
      STATE.gbArms = (r.ar === true);
      if (typeof r.ah === 'number') STATE.gbArmH = r.ah;
    }
    STATE.assemblyStep = 0;
    _designShow(!!quick);
    return true;
  }
  /* the reference designs of the types this storefront sells */
  function refSet() {
    var L = REF_SET.filter(function (r) { return !SLOT_TYPES || SLOT_TYPES.indexOf(r.t) >= 0; });
    L = L.filter(function (r) { return !r.eu && !r.ca; }).concat(L.filter(function (r) { return !r.eu && !!r.ca; }), L.filter(function (r) { return !!r.eu; }));   /* v340 the US ones first, then Europe (the units switch once); v420 Canada between (US lumber) */
    return L.map(function (r) {
      var o = JSON.parse(JSON.stringify(r));
      o.places = ((r.eu ? REF_PLACES_EU : r.ca ? REF_PLACES_CA : REF_PLACES)[r.t] || []).slice();   /* v340 a European design: [name, country, lat, lon, ISO]; v420 a Canadian one: [name, province, lat, lon, 'CA'] */
      o.pool = (r.eu ? REF_POOL_EU : r.ca ? REF_POOL_CA : REF_POOL_US).slice();   /* v344 when its own list has none left */
      return o;
    });
  }
  /* the Shopify variant (id, title) of a type */
  function variantOfType(t) {
    var V = (global.BENCH_BOOT && global.BENCH_BOOT.variants) || [], i;
    for (i = 0; i < V.length; i++) if (typeFromSku(V[i] && V[i].sku, i + 1) === (t | 0)) return { id: String(V[i].id), title: String(V[i].title || '') };
    return null;
  }
  /* REF holds the page's writes while it runs (the snippet's admin button) */
  function holdWrites(on) { _HOLD = Math.max(0, _HOLD + (on ? 1 : -1)); }
  function stateSnap() {
    var o = {}, k;
    for (k in STATE) if (STATE.hasOwnProperty(k) && typeof STATE[k] !== 'function') {
      try { o[k] = (STATE[k] && typeof STATE[k] === 'object') ? JSON.parse(JSON.stringify(STATE[k])) : STATE[k]; } catch (e) {}
    }
    return o;
  }
  function stateBack(o) {
    if (!o) return;
    var k;
    for (k in STATE) if (STATE.hasOwnProperty(k) && !o.hasOwnProperty(k) && typeof STATE[k] !== 'function') delete STATE[k];
    for (k in o) if (o.hasOwnProperty(k)) STATE[k] = (o[k] && typeof o[k] === 'object') ? JSON.parse(JSON.stringify(o[k])) : o[k];
    _designShow();
    try { _UndoHistory.baseline(); } catch (eU) {}
  }

  /* ===== THE VOICE TOUR (bench-v265) ==========================================
     Marek 2026-10-14: voiceover pres tlacitko Play jako na jinych projektech,
     ktery by prosel vsechny varianty, sem tam ukazal montazni postup,
     barevnost, u 4 slider upright - bed, jinde QR kod pro AR; titulky ve
     spodni tretine, na zadost je pak vypnout; pro tvorbu obsahu na Instagram.
     The house line's tour (configurator-ui.js core-v631 .. v698) as the
     container copied it (container-v527 .. v535): the same PLAY / PAUSE on the
     rail's axis 12 px under the canvas top edge with the same entrance, the
     same runner (one audio stream, the voice ahead in the background, the
     phone's media controls, pause and play on from the step), the same lower
     third subtitles from the leva-voice worker (GET /texts/en). Clips
     bench-tour-* (leva-workers voice run 30, English, Roger); a language
     without its own clip plays the English one.
     The steps: the intro (one reference design of every type, then one turn),
     then the 13 types in the storefront's order, each with its own show --
     the park bench's length and back rake, the porch swing's assembly, the
     sofa's four colours, the Hollywood swing's slider Upright .. Bed and its
     assembly, the wave lounger's posture, the A-frame swing's AR window with
     the QR, the picnic set's assembly, the kids' swing set 1 .. 3 swings, the
     Adirondack chair .. three-seater and the kids' size, the tree bench
     hexagon / octagon and its back, the planter bench's assembly, the storage
     bench's lid and AR, the block bench's colours -- and the outro. Nothing
     the tour shows is written: savePref and the Undo notes are held while it
     runs, and the end puts the visitor's design, view and camera back. */
  function _tlog(m) { _dbg(String(m)); }
  function _tq(id) { return document.getElementById(id); }
  /* bench-v287 the budget button now = the floating icons' one (the rail's is gone); null when not on the page */
  function _tqBudget() { var el = document.querySelector('.leva-float-group .leva-act--budget'); return (el && el.offsetParent !== null) ? el : null; }
  function _tboot() { return global.BENCH_BOOT || {}; }
  function _tt(k, d) {
    var T = (global.BENCH_BOOT && global.BENCH_BOOT.i18n) || {}, v = T[k];
    return (typeof v === 'string' && v && v.indexOf('translation missing') < 0) ? v : (d || k);
  }
  var _TOUR_CDN = 'https://cdn.shopify.com/s/files/1/0803/9815/6119/files/';
  /* the languages with a voice, as the core lists them (core-v686) */
  var _TOUR_VOICES = { en: '', es: '-es', de: '', fr: '', cs: '', pt: '', zh: '', ar: '', ja: '', tr: '', ko: '', it: '', pl: '', ro: '', nl: '', el: '', hu: '', sv: '', he: '', fi: '', no: '' };   /* v347 + the six later voices */
  var _TOUR_WORKER = 'https://leva-voice.long-cloud-d006.workers.dev/v/';
  var _TOUR_GEN = { en: 1, es: 1, de: 1, fr: 1, cs: 1, pt: 1, zh: 1, ar: 1, ja: 1, tr: 1, ko: 1, it: 1, pl: 1, ro: 1, nl: 1, el: 1, hu: 1, sv: 1, he: 1, fi: 1, no: 1 };   /* v347 the 21 languages of the leva-voice worker */
  var _TOUR_SVG = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 5.5v13l10.5-6.5z" fill="currentColor"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6.5" y="5.5" width="4" height="13" rx="1.2" fill="currentColor"/><rect x="13.5" y="5.5" width="4" height="13" rx="1.2" fill="currentColor"/></svg>'
  };
  var _T = { btn: null, on: false, run: 0, i: -1, audio: null, voice: false, saved: null, cam: null, bub: null, hl: null, pl: [], tm: [], pass: 0 };
  function _tourNow() { try { return global.performance.now(); } catch (e) { return Date.now(); } }
  function _tourLang() {
    var L = '';
    try { L = String(_tboot().locale || global.document.documentElement.lang || ''); } catch (e) { L = ''; }
    var m = /^([a-z]{2})/i.exec(L);
    return m ? m[1].toLowerCase() : 'en';
  }
  /* bench: every language plays (English where the worker has no clip of its own) */
  function _tourVoiceLang() { return true; }
  /* the tour in the background and the phone's media controls, as core-v691
     (Marek: slo by to spustit i na pozadi?) */
  function _tourHidden() { try { return !!global.document.hidden; } catch (e) { return false; } }
  try {
    global.document.addEventListener('visibilitychange', function () {
      if (!_T.on) return;
      var at = ((_T.i >= 0 ? _T.i : _T.nextI) || 0) + 1;
      if (_tourHidden()) {
        if (_TS && _T.voice) _tourAheadGo('the page went to the background at step ' + at);
        else _tlog('tour     the page went to the background -- the voice goes on, each step ends with its voice');
      } else if (_T.ahead) _tourCatchUp();
      else _tlog('tour     the page is on screen again -- the shows go on from step ' + at);
    });
  } catch (eVis) {}
  /* THE VOICE AHEAD IN THE BACKGROUND, THE SHOWS CATCHING UP (as core-v697) */
  function _tourTickLoop() {
    if (!_TS) return;
    var r = _T.run;
    var tk = function () { if (r !== _T.run) return; _tourStreamTick(); _tourLater(tk, 250, r); };
    _tourLater(tk, 250, r);
  }
  function _tourAheadGo(why) {
    if (!_T.on || !_TS || !_T.voice || _T.ahead) return;
    var cur = _T.i, from = (cur >= 0) ? cur : (_T.nextI || 0), S0 = (cur >= 0) ? _TOUR_STEPS[cur] : null;
    /* the shows stop: their timers go with a new run */
    _T.run++;
    _T.tm.forEach(function (id) { global.clearTimeout(id); });
    _T.tm = [];
    var run = _T.run;
    _T.ahead = true; _T.aheadDone = false; _T.aheadNext = -1; _T.segWatch = null; _T.segNow = null;
    if (S0) {
      _tourHl(null); _tourBub(null); _tourPulse([]);
      try { S0.end(false); } catch (eE) { _tlog('tour     ' + S0.key + ' end THREW ' + ((eE && eE.message) || eE)); }
    }
    _T.i = -1;
    var list = [], passed = [], j, S;
    /* the step that was on screen: its voice is in the stream already (or
       on its way), else it is queued first */
    if (S0) { if (!_tourSegOf(cur)) list.push(cur); from = cur + 1; }
    _T.probe = true;
    for (j = from; j < _TOUR_STEPS.length; j++) {
      S = _TOUR_STEPS[j];
      _T.skip = '';
      if (S.has) { var okH = false; try { okH = !!S.has(); } catch (eH) { okH = false; } if (!okH) _T.skip = 'nothing for it'; }
      if (!_T.skip) { try { S.start(run); } catch (eS) { _tlog('tour     ' + S.key + ' start THREW ' + ((eS && eS.message) || eS) + ' (walked in the background)'); } }
      if (_T.skip) passed.push(S.key); else list.push(j);
      try { S.end(false); } catch (eE2) {}
    }
    _T.probe = false;
    _T.skip = '';
    _tourHl(null); _tourBub(null); _tourPulse([]);
    _T.nextI = list.length ? list[0] : _TOUR_STEPS.length;
    _tlog('tour     ' + (why || 'the page went to the background') + ' -- the shows stop; the voice of the ' + list.length + ' step(s) left goes into the stream at once: ' +
      list.map(function (x) { return _TOUR_STEPS[x].key; }).join(', ') + (passed.length ? ' (nothing on this product for: ' + passed.join(', ') + ')' : ''));
    _tourTickLoop();
    _tourAheadQueue(list, run);
  }
  function _tourAheadQueue(list, run) {
    /* four clips fetched at a time, put into the stream in their order */
    var k = 0, P = [], asked = 0;
    var pull = function () {
      while (asked < list.length && asked < k + 4) { P[asked] = _tourClipBytes(_tourSrcs(_TOUR_STEPS[list[asked]])); P[asked].catch(function () {}); asked++; }
    };
    var next = function () {
      if (run !== _T.run || !_T.ahead) return;
      if (k >= list.length) { _T.aheadDone = true; _T.aheadNext = -1; _tlog('tour     (background) the rest of the tour is in the stream'); return; }
      pull();
      var pk = P[k], j = list[k++], S = _TOUR_STEPS[j];
      _T.aheadNext = j;
      pk.then(function (c) {
        if (run !== _T.run || !_T.ahead) return;
        var g = _tourSegAdd(j, S, c);
        g.p.then(function () {
          if (run !== _T.run) return;
          _tlog('tour     (background) ' + S.key + ' voice ' + c.name + ' queued at ' + g.from.toFixed(1) + ' s, ' + (g.to - g.from).toFixed(1) + ' s long' + (c.ahead ? ' (fetched ahead)' : ' (from the network)'));
          try { if (_T.audio && _T.audio.paused) { var pr = _T.audio.play(); if (pr && pr.catch) pr.catch(function (eA) { if (run === _T.run) _tourPlayFail(eA, run); }); } } catch (eP) {}
          next();
        }, function () { next(); });
      }, function (e) {
        if (run !== _T.run) return;
        _tlog('tour     (background) no clip for ' + S.key + ' (' + ((e && e.message) || e) + ') -- left out');
        next();
      });
    };
    next();
  }
  /* the step whose voice plays: the panel says it, pause and previous go
     by it; after the last voice the tour ends */
  function _tourAheadTick(t) {
    var G = _T.segs || [], k, g = null;
    for (k = 0; k < G.length; k++) if (G[k].to != null && t < G[k].to) { g = G[k]; break; }
    if (g && g.from != null && t >= g.from - 0.05 && _T.segNow !== g) {
      _T.segNow = g;
      _T.played = _T.played || [];
      if (_T.played.indexOf(g.i) < 0) _T.played.push(g.i);
      _T.nextI = g.i;
      try { _tourMediaMeta(g.tip); } catch (eM) {}
      _tlog('tour     (background) step ' + (g.i + 1) + '/' + _TOUR_STEPS.length + ' ' + g.key + ' -- its voice plays');
    }
    if (!g && _T.aheadDone && G.length && t > G[G.length - 1].to + 0.3) {
      _tlog('tour     (background) the last voice has played');
      _tourStop('the end of the tour');
    }
  }
  /* THE PAGE IS BACK (core-v697): the voice queued after the one now
     playing is taken out, and the shows start again at that step -- the
     project put back as at play, that step's show from its beginning while
     its voice goes on; the steps after it add their voice as they come */
  function _tourCatchUp() {
    if (!_T.on || !_T.ahead) return;
    _T.ahead = false;
    var S = _TS, run = _T.run;
    if (S) {
      var keep = [];
      S.q.forEach(function (j) { if (j.buf) { try { j.no(new Error('the page came back')); } catch (eN) {} } else keep.push(j); });
      S.q = keep;
    }
    _tourStreamMark(function () {
      if (run !== _T.run || !_T.on) return;
      var a = _T.audio, t = (a && a.currentTime) || 0, G = (_T.segs || []).filter(function (g) { return g.to != null; }), k, at = -1;
      /* the step whose voice plays, if 2 s of it are left -- else the next
         one, whose voice comes within moments (a show started again for a
         voice about to end would run on in silence) */
      for (k = 0; k < G.length; k++) if (G[k].to > t + 0.6 && (G[k].from > t || G[k].to - t > 2)) { at = k; break; }
      if (at < 0) {
        if (_T.aheadDone) { _T.segs = G; _tlog('tour     the page is back after the last voice'); _tourStop('the end of the tour'); return; }
        var nx = G.length ? G[G.length - 1].i + 1 : (_T.aheadNext >= 0 ? _T.aheadNext : (_T.nextI || 0));
        _T.segs = G;
        _tourResync(nx, 'the page is back at ' + t.toFixed(1) + ' s, no voice queued past it -- the tour goes on at step ' + (nx + 1));
        return;
      }
      var cut = (at + 1 < G.length) ? G[at + 1].from : null;
      _T.segs = G.slice(0, at + 1);
      if (cut != null) _tourStreamTail(cut);
      _tourResync(G[at].i, 'the page is back at ' + t.toFixed(1) + ' s -- the voice plays step ' + (G[at].i + 1) + ' ' + G[at].key + ' (until ' + G[at].to.toFixed(1) + ' s), its show starts again there');
    });
  }
  function _tourResync(k, why) {
    _tlog('tour     ' + why);
    _T.keepAudio = true;
    try {
      _tourStop(why, true);
      _T.resumeAt = k;
      _tourStart();
    } finally { _T.keepAudio = false; }
  }
  function _tourMedia() {
    try {
      var ms = global.navigator && global.navigator.mediaSession;
      if (!ms) return;
      if (!_T.mediaSet) {
        _T.mediaSet = true;
        ms.setActionHandler('pause', function () { if (_T.on) _tourPause('the media controls'); });
        ms.setActionHandler('play', function () { if (!_T.on) _tourStart(); });
        try { ms.setActionHandler('nexttrack', function () { _tourSkip(1); }); } catch (eN) {}
        try { ms.setActionHandler('previoustrack', function () { _tourSkip(-1); }); } catch (eP) {}
        _tlog('tour     media controls on -- the notification / lock screen: the product picture and name, play, pause, next, previous; a tap on it brings the page back');
      }
      _tourMediaMeta('');
      try { ms.playbackState = 'playing'; } catch (eS) {}
    } catch (eMs) {}
  }
  /* the panel in the phone's notifications like a music app's (core-v694,
     Marek: v scroll mobil oznaceni banner s ovladanim prehravani jako
     Spotify, klikem se vratim na stranku): the product's picture (og:image)
     and name, LEVA and the step's own label under it */
  function _tourMediaArt() {
    if (typeof _T.mediaArt === 'string') return _T.mediaArt;
    var u = '';
    try { var m = global.document.querySelector('meta[property="og:image"]'); u = m ? String(m.getAttribute('content') || '') : ''; } catch (e) { u = ''; }
    if (u.indexOf('//') === 0) u = 'https:' + u;
    _T.mediaArt = u.replace(/^http:/, 'https:');
    return _T.mediaArt;
  }
  function _tourMediaMeta(step) {
    try {
      var ms = global.navigator && global.navigator.mediaSession;
      if (!ms || !global.MediaMetadata) return;
      var art = _tourMediaArt(), title = String(global.document.title || 'LEVA').split(/\s+[\u2013\u2014|-]\s+/)[0];
      ms.metadata = new global.MediaMetadata({ title: title, artist: 'LEVA' + (step ? ' \u00b7 ' + step : ''), album: 'LEVA', artwork: art ? [{ src: art, sizes: '512x512' }] : [] });
    } catch (e) {}
  }
  /* next / previous from the notification: the tour pauses and goes on from
     that step; previous goes to the last step that was shown, not to one
     this product has nothing for */
  function _tourSkip(d) {
    var n = _TOUR_STEPS.length, cur = _T.on ? ((_T.i >= 0) ? _T.i : (_T.nextI || 0)) : (_T.resumeAt || 0), to = cur + d;
    if (d < 0) { var P = (_T.played || []).filter(function (x) { return x < cur; }); to = P.length ? P[P.length - 1] : 0; }
    to = Math.max(0, Math.min(n - 1, to));
    _tlog('tour     media controls: ' + (d > 0 ? 'next' : 'previous') + ' -- on from step ' + (to + 1));
    if (_T.on) _tourPause('the media controls (' + (d > 0 ? 'next' : 'previous') + ')');
    _T.resumeAt = to;
    _tourStart();
  }
  /* clips fetched ahead (core-v681): blob URLs handed to the audio element */
  var _TOUR_PRE = {}, _TOUR_PRE_N = [], _TOUR_PRE_B = {};
  function _tourUrl(n) { n = String(n || ''); var p = _TOUR_PRE[n]; if (p && p !== 1) return p; return n.indexOf('voice:') === 0 ? _TOUR_WORKER + n.slice(6) : _TOUR_CDN + n; }
  function _tourPreTrim() {
    var cur = '';
    try { cur = String((_T.audio && _T.audio.src) || ''); } catch (e) { cur = ''; }
    for (var k = 0; _TOUR_PRE_N.length > 6 && k < _TOUR_PRE_N.length;) {
      var o = _TOUR_PRE_N[k];
      if (_TOUR_PRE[o] === cur) { k++; continue; }
      try { global.URL.revokeObjectURL(_TOUR_PRE[o]); } catch (eR) {}
      delete _TOUR_PRE[o];
      delete _TOUR_PRE_B[o];
      _TOUR_PRE_N.splice(k, 1);
    }
  }
  function _tourPreName(L, why) {
    var n = L.shift();
    if (!n || _TOUR_PRE[n]) return;
    if (!global.fetch || !global.URL || !global.URL.createObjectURL) return;
    _TOUR_PRE[n] = 1;
    var t0 = _tourNow();
    global.fetch(_TOUR_WORKER + n.slice(6), { mode: 'cors', credentials: 'omit' }).then(function (r) {
      if (!r.ok) { var eH = new Error('HTTP ' + r.status); eH.st = r.status; throw eH; }
      return r.blob();
    }).then(function (b) {
      if (_TOUR_PRE[n] !== 1) return;
      _TOUR_PRE[n] = global.URL.createObjectURL(b);
      _TOUR_PRE_B[n] = b;
      _TOUR_PRE_N.push(n);
      _tourPreTrim();
      _tlog('tour     voice ' + n + ' fetched ahead in ' + ((_tourNow() - t0) / 1000).toFixed(1) + ' s (' + Math.round(b.size / 1024) + ' kB, ' + why + ')');
    }).catch(function (e) {
      delete _TOUR_PRE[n];
      if (e && e.st === 404 && L.length) { _tourPreName(L, why); return; }
      _tlog('tour     voice ' + n + ' not fetched ahead (' + ((e && e.message) || e) + ') -- it plays from the network');
    });
  }
  function _tourPreStep(S, why) {
    if (!S || !_TOUR_GEN[_tourLang()]) return;
    var L = [];
    try { L = _tourSrcs(S).filter(function (x) { return String(x).indexOf('voice:') === 0; }); } catch (e) { L = []; }
    _tourPreName(L, why);
  }
  /* ONE STREAM, NOT A CLIP EACH (core-v695, Marek: tim ze jsou to
     samostatne stopy, tak se to vzdy po dojeti stopy zastavi a ze scroll
     oznameni to zmizi): a clip that ended let the phone end the playing --
     the panel in the notifications went and a page in the background was put
     to sleep before the next clip. Now one player plays the whole tour: the
     audio element plays a MediaSource, each step's clip is appended to it
     (sequence mode) and a step's voice has ended when the play head passes
     its clip's end. Between two clips the player only waits, it never ends;
     with the page in the background a 0.5 s silence (xx/silence-half) is
     appended whenever less than 0.35 s is left, so it keeps sounding. A
     browser without MediaSource for MP3 plays one clip at a time as before. */
  var _TS = null;
  function _tourStreamOk() {
    try { return !!(global.MediaSource && global.MediaSource.isTypeSupported('audio/mpeg') && global.fetch && global.URL && global.URL.createObjectURL); } catch (e) { return false; }
  }
  function _tourNet(n) { n = String(n || ''); return n.indexOf('voice:') === 0 ? _TOUR_WORKER + n.slice(6) : _TOUR_CDN + n; }
  function _tourStreamOpen(a) {
    if (_TS && _TS.url) { try { global.URL.revokeObjectURL(_TS.url); } catch (eRv) {} }
    var S = { ms: null, sb: null, q: [], busy: false, url: '', dead: false };
    try { S.ms = new global.MediaSource(); S.url = global.URL.createObjectURL(S.ms); } catch (e) { return null; }
    S.ms.addEventListener('sourceopen', function () {
      if (_TS !== S || S.sb) return;
      try { S.sb = S.ms.addSourceBuffer('audio/mpeg'); S.sb.mode = 'sequence'; }
      catch (eSb) { S.dead = true; _tlog('tour     stream: no source buffer (' + ((eSb && eSb.message) || eSb) + ') -- the clips play one at a time'); _tourStreamFail(S); return; }
      S.sb.addEventListener('updateend', function () { var j = S.job; S.job = null; S.busy = false; if (j) { try { j.ok(_tourStreamEnd(S)); } catch (eJ) {} } _tourStreamPump(S); });
      S.sb.addEventListener('error', function () { var j = S.job; S.job = null; S.busy = false; if (j) j.no(new Error('append failed')); _tourStreamPump(S); });
      _tourStreamPump(S);
    });
    a.src = S.url;
    if (!_T.silence && !_T.silenceAsked) {
      _T.silenceAsked = true;
      global.fetch(_TOUR_WORKER + 'xx/silence-half.mp3', { mode: 'cors', credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
        .then(function (b) { _T.silence = b; }).catch(function (e) { _tlog('tour     stream: no silence clip (' + ((e && e.message) || e) + ') -- the player waits between clips instead'); });
    }
    return S;
  }
  function _tourStreamEnd(S) { try { var B = S.sb.buffered; return B.length ? B.end(B.length - 1) : 0; } catch (e) { return 0; } }
  function _tourStreamPump(S) {
    if (_TS !== S || !S.sb || S.busy || !S.q.length) return;
    var j = S.q.shift();
    /* a mark: runs once all that was queued before it is in (core-v697) */
    if (j.fn) { try { j.fn(); } catch (eF) { _tlog('tour     stream mark THREW ' + ((eF && eF.message) || eF)); } _tourStreamPump(S); return; }
    if (j.tail != null && j.tail >= _tourStreamEnd(S) - 0.02) { try { j.ok(_tourStreamEnd(S)); } catch (eT) {} _tourStreamPump(S); return; }
    S.busy = true;
    S.job = j;
    try {
      if (j.cut) S.sb.remove(0, j.cut);
      else if (j.tail != null) S.sb.remove(j.tail, Infinity);
      else { j.from = _tourStreamEnd(S); S.sb.appendBuffer(j.buf); }
    } catch (e) { S.busy = false; S.job = null; j.no(e); _tourStreamPump(S); }
  }
  function _tourStreamAdd(buf) {
    var S = _TS;
    return new Promise(function (ok, no) {
      if (!S || S.dead) { no(new Error('no stream')); return; }
      var j = { buf: buf };
      j.ok = function (to) { ok({ from: j.from || 0, to: to }); };
      j.no = no;
      S.q.push(j);
      _tourStreamPump(S);
    });
  }
  function _tourStreamFail(S) {
    if (_TS !== S) return;
    _TS = null;
    var j;
    while ((j = S.q.shift())) { try { j.no(new Error('no stream')); } catch (e) {} }
  }
  /* as core-v697: a mark, the queue's tail taken out, a step's part of the stream */
  function _tourStreamMark(fn) {
    var S = _TS;
    if (!S || S.dead) { fn(); return; }
    S.q.push({ fn: fn, ok: function () {}, no: function () { try { fn(); } catch (e) {} } });
    _tourStreamPump(S);
  }
  function _tourStreamTail(at) {
    var S = _TS;
    if (!S || S.dead) return;
    S.q.push({ tail: at,
      ok: function (end) {
        try { S.sb.abort(); } catch (eA) {}
        try { S.sb.timestampOffset = end; } catch (eT) { _tlog('tour     stream: the next clip could not be set at ' + end.toFixed(1) + ' s (' + ((eT && eT.message) || eT) + ')'); }
        _tlog('tour     stream: the voice queued after ' + at.toFixed(1) + ' s taken out -- the next clip follows at ' + end.toFixed(1) + ' s');
      },
      no: function (e) { _tlog('tour     stream: the queued voice not taken out (' + ((e && e.message) || e) + ')'); } });
    _tourStreamPump(S);
  }
  function _tourSegAdd(i, S, c) {
    var G = (_T.segs = _T.segs || []);
    var g = { i: i, key: S.key, name: c.name, tip: '', from: null, to: null };
    try { g.tip = S.tip ? _tt(S.tip[0], S.tip[1]) : ''; } catch (eT) { g.tip = ''; }
    G.push(g);
    g.p = _tourStreamAdd(c.buf).then(function (r) { g.from = r.from; g.to = r.to; return g; });
    if (_T.silence) _tourStreamAdd(_T.silence.slice(0)).catch(function () {});
    g.p.catch(function () { var k = (_T.segs || []).indexOf(g); if (k >= 0) _T.segs.splice(k, 1); });
    return g;
  }
  function _tourSegOf(i) {
    var G = _T.segs || [], k;
    for (k = G.length - 1; k >= 0; k--) if (G[k].i === i) return G[k];
    return null;
  }
  /* the play head against the clip's end; the silence while the page is in
     the background; what was played long ago taken out of the buffer */
  function _tourStreamTick() {
    var S = _TS, a = _T.audio;
    if (!S || !a || !S.sb) return;
    var t = a.currentTime || 0, W = _T.segWatch;
    if (W) {
      var fire = t >= W.to - 0.06;
      if (!fire && W.to - t < 0.5) { if (W.lt === t) fire = (Date.now() - W.lts) > 400; else { W.lt = t; W.lts = Date.now(); } }
      if (fire) { _T.segWatch = null; try { W.fn(); } catch (eW) {} }
    }
    if (_T.ahead) _tourAheadTick(t);
    if (!_T.on || _TS !== S) return;
    /* v266, as core-v699 / container-v537 (Marek: pri nabehu nove stopy
       cinknuti a ztlumeni zvuku): the stream kept 1.5 s ahead on screen too
       (0.5 s in the background) -- a stream that ran dry between two clips
       stalled, and a phone restarts its audio after a stall */
    if (_T.silence && !S.busy && !S.q.length && _tourStreamEnd(S) - t < (_tourHidden() ? 0.5 : 1.5)) {
      _tourStreamAdd(_T.silence.slice(0)).catch(function () {});
    }
    try { var B = S.sb.buffered; if (!S.busy && !S.q.length && B.length && t - B.start(0) > 90) { S.q.push({ cut: t - 30, ok: function () {}, no: function () {} }); _tourStreamPump(S); } } catch (eC) {}
  }
  /* a step's clip as bytes: fetched ahead, else from the network, the names
     in their order (the product's intro, the shared one, Shopify's) */
  function _tourClipBytes(L) {
    var k = 0;
    var next = function () {
      if (k >= L.length) return Promise.reject(new Error('none of ' + L.length + ' name(s) came'));
      var n = L[k++], b = _TOUR_PRE_B[n];
      if (b && b.arrayBuffer) return b.arrayBuffer().then(function (x) { return { name: n, buf: x, ahead: true }; });
      return global.fetch(_tourNet(n), { mode: 'cors', credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.arrayBuffer();
      }).then(function (x) { return { name: n, buf: x, ahead: false }; }, function () { return next(); });
    };
    return next();
  }

  /* the names a step's voice is tried under: the page's language (when the
     voice worker has the language), then English */
  /* a ?ig page -- the link made for social posts (bench-v272, as core-v713) */
  function _tourIg() {
    try { if (global.LEVA_IG) return true; return new URL(global.location.href).searchParams.has('ig'); } catch (e) { return false; }
  }
  /* bench-v339 the hook of the page's product: GARDEN STRUCTURES its own (ig-intro-garden), BENCHES / SWINGS ig-intro-benches */
  function _tourHook() { var s = _tourSlots(), h = s.length ? productOfType(s[0]) : ''; return (h === 'garden-structure' || h === 'garden-bar') ? 'ig-intro-garden' : 'ig-intro-benches'; }   /* v356 + GARDEN BAR */
  function _tourSrcs(S) {
    var lg = _tourLang(), base = (S && S.mp3) || 'bench-tour-intro', L = [];
    /* the hook for a social post opens the tour on an English ?ig page; the
       usual intro stays the fallback (bench-v272, Marek: i pro benches & swings) */
    /* bench-v280: every English tour's first clip is the hook; v339 the product's own hook; v347 in every language -- its own hook, its own intro,
       then the English hook and intro (a language whose clip is missing plays the English one) */
    var names = (base === 'bench-tour-intro') ? [_tourHook(), base] : [base], i;
    if (_TOUR_GEN[lg]) for (i = 0; i < names.length; i++) L.push('voice:' + lg + '/' + names[i] + '.mp3');
    if (lg !== 'en') for (i = 0; i < names.length; i++) L.push('voice:en/' + names[i] + '.mp3');
    return L;
  }
  function _tourCss() {
    if (_tq('cf-tour-css')) return;
    var st = global.document.createElement('style');
    st.id = 'cf-tour-css';
    var M = "'Montserrat',sans-serif";
    st.textContent =
      '#cf-tour-btn{position:absolute;top:12px;right:20px;z-index:14;width:38px;height:38px;border-radius:50%;border:0;padding:0;margin:0;' +
      'display:inline-flex;align-items:center;justify-content:center;background:#141516;color:#ffffff;cursor:pointer;' +
      'box-shadow:0 4px 14px rgba(0,0,0,0.20);-webkit-tap-highlight-color:transparent;touch-action:manipulation;}' +
      '#cf-tour-btn svg{width:18px;height:18px;display:block;}' +
      '#cf-tour-btn.cf-ig-gone{opacity:0 !important;pointer-events:none !important;transition:opacity .2s;}' +   /* v359 */
      '#cf-tour-btn.cf-on{background:#D8232A;}' +
      '#cf-root.cf-tour-top .cf-sidebar{top:calc(50% + 23px);}' +
      '#cf-root.cf-tour-top #cf-sx-strip{top:calc(50% + 23px);max-height:calc(100% - 94px);max-height:min(470px,calc(100% - 94px));}' +
      '@media (max-width:640px){#cf-root.cf-tour-top #cf-sx-strip{top:calc(50% - 16px);max-height:calc(100% - 152px);max-height:min(470px,calc(100% - 152px));}}' +
      '#cf-tour-btn.cf-idle{animation:cf-tour-fade 1.6s ease-in-out infinite;}' +
      '@keyframes cf-tour-fade{0%,100%{opacity:1;}50%{opacity:0.5;}}' +
      '#cf-tour-btn.cf-intro-wait{transform:scale(0);opacity:0;}' +
      /* the entrance as core-v688 / core-v698 (voice tour thread, Marek:
         opacity od 10 % pri 200 % po 100 % pri 100 % velikosti): one move */
      '#cf-tour-btn.cf-intro{transform-origin:50% 0;animation:cf-tour-in 1.8s cubic-bezier(0.25,0.8,0.3,1) both;}' +
      '@keyframes cf-tour-in{0%{transform:scale(2);opacity:0.1;}100%{transform:scale(1);opacity:1;}}' +
      '@media (prefers-reduced-motion:reduce){#cf-tour-btn.cf-idle,#cf-tour-btn.cf-intro{animation:none;}#cf-tour-btn.cf-intro-wait{transform:none;opacity:1;}}' +
      /* bench-v294 as core-v724 (Marek 2026-10-20: jen jemne zvyrazneni, o
         neco tmavsi nez background f5f5f5, nikde cerveny nadech) */
      '.cf-tour-hl,.cf-tour-pulse{animation:cf-tour-soft 1.6s ease-in-out infinite !important;}' +
      '@keyframes cf-tour-soft{0%,100%{box-shadow:0 0 0 0 rgba(0,0,0,0.10);}50%{box-shadow:0 0 0 8px rgba(0,0,0,0.10);}}' +
      '#cf-sx-strip .cf-tour-hl,#cf-sx-strip .cf-tour-pulse,.cf-cmd-mini .cf-tour-hl,.cf-cmd-mini .cf-tour-pulse{animation:cf-tour-soft-d 1.6s ease-in-out infinite !important;}' +
      '@keyframes cf-tour-soft-d{0%,100%{box-shadow:0 0 0 0 rgba(255,255,255,0.18);}50%{box-shadow:0 0 0 6px rgba(255,255,255,0.18);}}' +
      '#cf-tour-bub{position:absolute;z-index:17;transform:translate(-50%,-100%);margin-top:-12px;background:#141516;color:#ffffff;' +
      'font:700 11px/1 ' + M + ';letter-spacing:0.06em;text-transform:uppercase;padding:8px 12px;border-radius:999px;white-space:nowrap;' +
      'pointer-events:none;display:none;box-shadow:0 6px 20px rgba(0,0,0,0.22);}' +
      '#cf-tour-bub.cf-on{display:block;}' +
      '#cf-tour-bub.cf-side{transform:translate(-100%,-50%);margin-top:0;}';
    global.document.head.appendChild(st);
  }
  /* ==== THE ?ig2 STORY (bench-v351) ==========================================
     Marek 2026-10-23 09:05: "Udelej mi prosim kratky exploded view on - pak
     off, a zaroven rotace cinema bar. Pak animace skladby - assembly mode.
     Pri spusteni play voice guide. Ale bez voice guide. Treba s kodem
     stranky ?ig2. Dam to jako 8 vterinove video na stories."
     A page opened with ?ig2 (a ?ig page as well -- layout/theme.liquid ig-v4:
     no admin buttons, logs, review bars) keeps the tour's PLAY, and the PLAY
     runs this instead of the tour, silent, 8 s:
       0.0 - 3.4 s  one turn round the cinema bar (eased in and out) while it
                    flies apart -- every part away from the middle (100 %)
                    and up by its height (85 %; v352, was 70 / 60) -- 0.2 -
                    1.3 s, holds to 1.65, and comes back together slowly
                    and smoothly by 3.25 s; the camera steps back with it
                    so all of it stays in view;
       3.45 - 3.8   taken down in a breath (the last-built parts first);
       3.85 - 7.6   ASSEMBLY: every part flies in in the order of the
                    assembly button's steps (a step of fasteners only gets a
                    shorter slot), wood from above (from below where built
                    wood already covers it), screws along their drive, the
                    assembly button lit; the camera drifts on slowly, moves
                    in a little, and ends on the three-quarter view of the
                    bar's side;
       7.6 - 8.0    built, held.
     The design on the page when it already is the cinema bar (else the
     cinema bar in oak, the page's defaults, when the page sells it; else the
     design on show). The PLAY fades out while it plays (out of the video);
     a tap on its place stops it. At the end the design stands built, the
     handles are back and the PLAY is there again. Nothing is saved. */
  var IG2_MS = 8000;
  var _IG2 = { on: false, tok: 0, P: null };
  var _IG2_PAGE = (function () {
    try { return new URL(global.location.href).searchParams.has('ig2'); }
    catch (e) { return /[?&]ig2(=|&|$)/.test(String((global.location && global.location.search) || '')); }
  })();
  /* bench-v358: ?ig2=8 (or ?ig2=story) keeps the 8-second story on GARDEN STRUCTURES too */
  var _IG2_STORY = (function () {
    try { var v = new URL(global.location.href).searchParams.get('ig2'); return v === '8' || v === 'story'; }
    catch (e) { return /[?&]ig2=(8|story)(&|$)/.test(String((global.location && global.location.search) || '')); }
  })();
  /* bench-v408: ?ig2=asm THE BUILD RECORDING (the section below _ig2Run) -- not the reel, not the story */
  var _IG2_ASM = (function () {
    try { return new URL(global.location.href).searchParams.get('ig2') === 'asm'; }
    catch (e) { return /[?&]ig2=asm(&|$)/.test(String((global.location && global.location.search) || '')); }
  })();
  /* bench-v358 THE ?ig2 CINEMA BAR REEL: GARDEN STRUCTURES' ?ig2 page (the cinema bar on sale), not ?ig2=8 */
  function _tourIg2Reel() { return _IG2_PAGE && !_IG2_STORY && !_IG2_ASM && (_tourSlots().indexOf(19) >= 0 || _tourSlots().indexOf(17) >= 0); }   /* v361 + SWINGS: the pergola swing reel; v408 not on ?ig2=asm */
  function _tourIg2Swing() { return _tourSlots().indexOf(19) < 0 && _tourSlots().indexOf(17) >= 0; }
  function _ig2Sm(x) { x = Math.max(0, Math.min(1, x)); return x * x * (3 - 2 * x); }
  function _ig2Ease(x) { x = Math.max(0, Math.min(1, x)); return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }
  /* v352 smootherstep: no jolt where it starts or where it lands */
  function _ig2Soft(x) { x = Math.max(0, Math.min(1, x)); return x * x * x * (x * (x * 6 - 15) + 10); }
  /* the exploded amount at t ms -- v352 (Marek: vice exploded, plynule vratit zpet): apart
     0.20 - 1.30 s, held to 1.65, back together slowly 1.65 - 3.25 s, built 0.2 s before it is taken down */
  function _ig2Ex(t) {
    if (t < 200) return 0;
    if (t < 1300) return _ig2Soft((t - 200) / 1100);
    if (t < 1650) return 1;
    if (t < 3250) return 1 - _ig2Soft((t - 1650) / 1600);
    return 0;
  }
  /* the parts on show: each top-level piece of the bench group, its box in the group's frame */
  function _ig2Parts(G) {
    var T = global.THREE, out = [], inv = new T.Matrix4();
    G.updateMatrixWorld(true);
    inv.copy(G.matrixWorld).invert();
    G.children.forEach(function (c) {
      var ud = c.userData || {};
      if (!ud.partType || ud.partType === 'person' || ud.partType === 'ph-tree' || !c.visible) return;   /* v368 the tree fort's tree */
      var bb = new T.Box3().setFromObject(c);
      if (bb.isEmpty() || !isFinite(bb.min.x) || !isFinite(bb.max.y)) return;
      bb.applyMatrix4(inv);
      out.push({ o: c, pt: String(ud.partType), base: c.position.clone(), bb: bb, c: bb.getCenter(new T.Vector3()) });
    });
    return out;
  }
  function _ig2Btn(on) {
    var b = _T.btn;
    if (!b) return;
    if (on) { b.classList.remove('cf-idle'); b.classList.remove('cf-intro'); b.classList.add('cf-on'); b.innerHTML = _TOUR_SVG.pause; b.style.opacity = '0'; }
    else { b.classList.remove('cf-on'); b.innerHTML = _TOUR_SVG.play; b.style.opacity = ''; }
  }
  /* the end, or a tap: every part where it belongs, the built view, the handles, the PLAY */
  function _ig2End(why, inTour) {   /* v358 inTour: the reel's hook -- the tour keeps its button */
    var was = _IG2.on;
    _IG2.hook = 0;
    _IG2.tok++;
    _IG2.on = false;
    var E = _tourEng(), ctl = _tourControls();
    try { (_IG2.P || []).forEach(function (p) { p.o.position.copy(p.base); p.o.visible = true; }); } catch (eP) {}
    _IG2.P = null;
    try { STATE.assemblyStep = 0; if (E && E.benchGroup) global.BenchRenderer._applyAssemblyStep(E.benchGroup, 0); } catch (eA) {}
    try { _toggleHandlesForStep(0); } catch (eH) {}
    try { _tourHl(null); } catch (eL) {}
    if (ctl && _IG2.ctl) { ctl.autoRotate = _IG2.ctl.ar; ctl.enableDamping = _IG2.ctl.dmp; _IG2.ctl = null; }
    if (!inTour) _ig2Btn(false);
    if (!inTour && _T.btn) _T.btn.classList.remove('cf-ig-gone');   /* v359 */
    if (was) _tlog('ig2      ' + why);
  }
  function _ig2Start() {
    if (_IG2.on) return;
    var E = _tourEng(), T = global.THREE;
    if (!E || !E.benchGroup || !E.camera || !_tourControls() || !T) { _tlog('ig2      no stage on the page -- nothing to play'); return; }
    _IG2.on = true;
    var tok = ++_IG2.tok;
    _ig2Btn(true);
    try { if (STATE.view === '2d' && E.toggleView) E.toggleView(); } catch (eV) {}
    try { _tourArClose(); } catch (eAr) {}
    var sw = ((STATE.variant | 0) !== 19 && _tourSlots().indexOf(19) >= 0);
    if (sw) {
      selectVariant(19, true);
      STATE.colorMode = 'oak';
      STATE.assemblyStep = 0;
      _designShow(true);
    } else if ((STATE.assemblyStep | 0) !== 0) {
      STATE.assemblyStep = 0;
      try { global.BenchRenderer._applyAssemblyStep(E.benchGroup, 0); } catch (eA) {}
      try { refreshUI(true); } catch (eR) {}
    }
    _tlog('ig2      the story -- ' + (_tourName(STATE.variant | 0) || ('type ' + (STATE.variant | 0))) + (sw ? ' put on (oak, the page\'s defaults)' : ' as it is on the page') + ', 8 s, no voice');
    global.setTimeout(function () { if (tok === _IG2.tok && _IG2.on) _ig2Run(tok); }, sw ? 500 : 60);
  }
  /* bench-v358 THE REEL'S HOOK: the story's first part only -- one turn while the bar flies apart and back
     together (3.4 s), then the camera drifts on and moves in slowly until the step ends (no take-down, no assembly) */
  function _ig2Hook(run) {
    if (run !== _T.run) return;
    var E = _tourEng();
    if (!E || !E.benchGroup || !E.camera || !_tourControls() || !global.THREE) { _tlog('ig2      hook: no stage on the page -- the step stands still'); return; }
    _IG2.on = true;
    _IG2.hook = _tourNow();
    _ig2Run(++_IG2.tok, true);
  }
  function _ig2Run(tok, hook) {
    var E = _tourEng(), T = global.THREE, cam = E.camera, ctl = _tourControls(), G = E.benchGroup;
    var P = _ig2Parts(G);
    if (!P.length) { _ig2End('nothing on the stage to show'); return; }
    _IG2.P = P;
    var B = new T.Box3(), i;
    P.forEach(function (p) { B.union(p.bb); });
    var C = B.getCenter(new T.Vector3()), H = Math.max(0.3, B.max.y - B.min.y), drop = Math.max(0.45, H * 0.22);
    var staged = _isStagedType(STATE.variant);
    P.forEach(function (p) {
      p.ex = new T.Vector3((p.c.x - C.x) * 1.0, (p.c.y - B.min.y) * 0.85, (p.c.z - C.z) * 1.0);   /* v352 wider (was 0.7 / 0.6 / 0.7) */
      p.hw = !!p.o.userData.driveDir || p.pt.indexOf('-hw') >= 0;
      p.st = staged ? (_swingPartStep(p.pt) | 0) : (1 + Math.min(7, Math.floor((p.bb.min.y - B.min.y) / H * 8)));
    });
    /* the steps in order; a step of fasteners only gets 0.4 of a slot */
    var S = {}, list = [], wsum = 0, acc = 0, TA = 3850, TL = 7000;
    P.forEach(function (p) {
      if (!(p.st > 0)) return;
      if (!S[p.st]) { S[p.st] = { hw: true, n: 0 }; list.push(p.st); }
      if (!p.hw) S[p.st].hw = false;
      p.k = S[p.st].n++;
    });
    list.sort(function (a, b) { return a - b; });
    list.forEach(function (s) { S[s].w = S[s].hw ? 0.4 : 1; wsum += S[s].w; });
    list.forEach(function (s) { S[s].t = TA + (wsum > 0 ? acc / wsum * (TL - TA) : 0); S[s].slot = (wsum > 0 ? S[s].w / wsum * (TL - TA) : 0); acc += S[s].w; });
    /* where each comes from (the assembly button's own rules, _stagedAnimate) */
    function covered(p) {
      for (var q = 0; q < P.length; q++) {
        var o = P[q];
        if (o === p || o.hw || !(o.st < p.st)) continue;
        if (o.bb.min.y >= p.bb.max.y - 0.02 && p.c.x > o.bb.min.x && p.c.x < o.bb.max.x && p.c.z > o.bb.min.z && p.c.z < o.bb.max.z) return true;
      }
      return false;
    }
    P.forEach(function (p) {
      var ud = p.o.userData, b = p.base;
      if (ud.flyFrom) p.from = new T.Vector3(ud.flyFrom[0], ud.flyFrom[1], ud.flyFrom[2]);
      else if (ud.flyDir) p.from = new T.Vector3(b.x + ud.flyDir[0] * 0.7, b.y + ud.flyDir[1] * 0.6, b.z + ud.flyDir[2] * 0.7);
      else if (ud.driveDir) { var dl = ud.driveLen || 0.10; p.from = new T.Vector3(b.x + ud.driveDir[0] * dl, b.y + ud.driveDir[1] * dl, b.z + ud.driveDir[2] * dl); }
      else if (p.hw) p.from = new T.Vector3(b.x, b.y + 0.15, b.z);
      else {
        var ox = (Math.abs(p.c.x - C.x) > 0.05) ? (p.c.x > C.x ? 0.12 : -0.12) : 0, oz = (Math.abs(p.c.z - C.z) > 0.05) ? (p.c.z > C.z ? 0.12 : -0.12) : 0;
        p.from = new T.Vector3(b.x + ox, b.y + (covered(p) ? -drop : drop), b.z + oz);
      }
      var St = S[p.st];
      p.t = St ? (St.t + (St.n > 1 ? p.k / (St.n - 1) * Math.min(250, St.slot * 0.6) : 0)) : 0;
      p.fly = p.hw ? 380 : 600;
    });
    /* taken down: the last-built first, all in 350 ms from 3.45 s */
    var maxT = 0;
    P.forEach(function (p) { if (p.t > maxT) maxT = p.t; });
    P.forEach(function (p) { p.down = 3450 + (maxT > TA ? (1 - Math.max(0, p.t - TA) / (maxT - TA)) : 0) * 150; });
    /* the camera: round the middle, from a three-quarter view, a little from above;
       stepped back with the exploded view; the bar kept off the rail as the tour frames it */
    var asp = cam.aspect || 1.4, vF = cam.fov * Math.PI / 180, hF = 2 * Math.atan(Math.tan(vF / 2) * asp);
    var sph = B.getBoundingSphere(new T.Sphere());
    var r0 = sph.radius / Math.sin(Math.min(vF, hF) / 2) * (asp < 0.9 ? 1.28 : 0.95) * 1.35;
    var el = 0.28, ty0 = B.min.y + H * 0.46, DRIFT = hook ? 0.35 : 0.7, a0 = (hook ? 0.62 : 0.80) - (hook ? 0 : DRIFT), ang = a0, shK = 0;   /* v358 the hook starts and ends its turn on the three-quarter view */   /* one turn + the drift: it ends on the bar's three-quarter view (0.80) */
    try {
      var root = _tq('cf-root'), rail = root && root.querySelector('.cf-sidebar'), Rr = root.getBoundingClientRect(), Ra = rail ? rail.getBoundingClientRect() : null;
      if (Ra && Ra.width > 0 && Rr.width > 0) shK = (Rr.right - Ra.left + 8) / 2 / Rr.width * 2 * Math.tan(hF / 2);
    } catch (eR) {}
    _IG2.ctl = { ar: ctl.autoRotate, dmp: ctl.enableDamping };
    ctl.autoRotate = false; ctl.enableDamping = false;
    ctl.minDistance = Math.min(ctl.minDistance || r0, r0 * 0.5);
    ctl.maxDistance = Math.max(ctl.maxDistance || r0, r0 * 2.2);
    cam.far = Math.max(cam.far || 0, r0 * 8); cam.updateProjectionMatrix();
    try { _toggleHandlesForStep(1); } catch (eH) {}
    var asmB = _tq('cf-btn-assembly'), lit = false;
    var t0 = _tourNow();
    if (hook) _tlog('ig2      hook: ' + P.length + ' part(s) apart and back together during one turn (3.4 s), then a slow drift; the camera ' + r0.toFixed(2) + ' m out');
    else _tlog('ig2      ' + P.length + ' part(s), ' + list.length + ' assembly step(s) from 3.85 s, the last settled by 7.6 s; the camera ' + r0.toFixed(2) + ' m out, one turn by 3.6 s');
    (function frame() {
      if (tok !== _IG2.tok) return;
      var now = _tourNow(), t = now - t0, ts = t / 1000;
      /* one turn by 3.6 s (eased), and a slow drift of DRIFT rad from 3.0 s to the end -- by the
         clock, not by the frames, so a slow device turns just as far */
      ang = a0 + 2 * Math.PI * _ig2Sm((ts - 0.2) / 3.4) + DRIFT * _ig2Sm((ts - 3.0) / 5.0);
      var e = _ig2Ex(t), r = r0 * (1 + 0.85 * e) * (1 - 0.12 * _ig2Sm((ts - 3.8) / 4.2));   /* stepped back for the exploded view, pushed in slowly through the assembly */
      var M = new T.Vector3(C.x, ty0 + H * 0.34 * e, C.z), sh = shK * r;
      var px = Math.cos(ang) * sh, pz = -Math.sin(ang) * sh;
      cam.position.set(M.x + px + r * Math.cos(el) * Math.sin(ang), M.y + r * Math.sin(el), M.z + pz + r * Math.cos(el) * Math.cos(ang));
      ctl.target.set(M.x + px, M.y, M.z + pz);
      try { ctl.update(); } catch (eU) {}
      /* the parts */
      for (i = 0; i < P.length; i++) {
        var p = P[i];
        if (t < 3450 || hook) {   /* v358 the hook: back together and left built */
          if (hook && t > 3600) continue;
          p.o.visible = true;
          p.o.position.set(p.base.x + p.ex.x * e, p.base.y + p.ex.y * e, p.base.z + p.ex.z * e);
        } else if (t < TA) {
          if (!(p.st > 0)) { p.o.visible = true; p.o.position.copy(p.base); continue; }
          var kd = Math.min(1, Math.max(0, (t - p.down) / 200));
          p.o.visible = kd < 1;
          p.o.position.lerpVectors(p.base, p.from, kd * kd);
        } else {
          if (!(p.st > 0)) { p.o.visible = true; p.o.position.copy(p.base); continue; }
          var k = (t - p.t) / p.fly;
          if (k < 0) { p.o.visible = false; continue; }
          p.o.visible = true;
          k = Math.min(1, k);
          p.o.position.lerpVectors(p.from, p.base, 1 - Math.pow(1 - k, 3));
        }
      }
      if (hook) {
        if (t >= 14000) { _tlog('ig2      hook: 14 s -- the camera left where it is'); return; }
        global.requestAnimationFrame(frame);
        return;
      }
      if (!lit && t >= TA && asmB) { lit = true; _tourHl(asmB); }
      if (lit && t >= 7600) { lit = false; asmB = null; _tourHl(null); }
      if (t >= IG2_MS) { _ig2End('the story played (' + (t / 1000).toFixed(1) + ' s) -- the design built, the PLAY back'); return; }
      global.requestAnimationFrame(frame);
    })();
  }

  /* ==== THE ?ig2=asm BUILD RECORDING (bench-v408) ==========================
     Marek 2026-11-03 18:28: "Nedelej mi animaci. Udelej mi odkaz, kde po
     zmacknuti play zmizi veskere jine UI prvky, nebude se menit pruhlednost,
     nebudou se animovat spojovaci prvky. Vsechno ostatni zustat tak jak v
     assembly steps. Obraz nahraju a upravim sam." 18:34: "Jeste udelej to,
     ze se po sestaveni bude mirne houpat, normalnim tempem."
     A ?ig2=asm page (a ?ig page -- theme ig-v4) has the PLAY bottom centre.
     The tap: every element of the page but the 3D stage is gone (display
     none: the header, the rail, the bars, the sliders, the handles, the
     captions, the drawers, the floating icons, any banner or toast -- and
     anything added later), the stage fills the screen with the page's own
     framing of the finished design, then shows only what stands before the
     first step. 2 s later the assembly steps run from the first to the last
     as the assembly button shows them -- their order, each part's fly-in
     (_stagedAnimate), the camera left where it is -- except: nothing turns
     see-through (no fade, no glow: what is not built yet is not drawn), the
     fasteners (the engine's hardware -- '-hw' parts and anything driven in)
     do not fly: they stand in place when the wood of their step has landed,
     and a step of fasteners alone comes at once with no pause of its own;
     the coops' exploded-view head steps are left out. A step = the fly-in
     (1.7 s, the button's own) + 0.5 s held. Then the built view; a swing
     (chains drawn) sways after 0.5 s -- the seat with its chains and cushion
     round the chains' tops, +-7 deg, the pendulum's own period for the
     length (2-3 s), from rest -- until the page is reloaded. The park bench,
     the sofa and the bed (their own old sequences) build step by step with
     no fly-in; any other type with no staged steps (53 so far) is held
     built. Nothing is saved; the bill and every other page unchanged. */
  var ASM = { HOLD: 500, END: 500, DEG: 7, LEGACY: 1200 };
  var _ASM = { on: false, tok: 0 };
  function _asmOn() { return !!(_ASM && _ASM.on); }
  /* the fasteners the old tables name without '-hw' (the modern swing's seat: screw-pocket, screw-wood) */
  function _asmFastenerPt(pt) { return /^(screw-|pocket-marker)/.test(String(pt || '')); }
  function _asmIsHw(c) { var ud = c.userData || {}, pt = String(ud.partType || ''); return !!ud.driveDir || pt.indexOf('-hw') >= 0 || _asmFastenerPt(pt); }
  /* what does not hang on a swing: the stands, the frames, the roofs, the hangers on the beam, the porch ceiling */
  var ASM_FIXED = /^(person|porch-context|ph-|pg-|mf-|kf-|swing-(leg|rail|beam|brace|roof-|hw-(bolt|drip|verge|plate|rod|hanger|screw-(rail|beam|knee|hanger))))/;
  /* the page away, the stage alone on the whole screen */
  function _asmHide() {
    var d = global.document, root = _tq('cf-root'), a;
    if (!root) return false;
    if (!_tq('cf-asm-css')) {
      var st = d.createElement('style');
      st.id = 'cf-asm-css';
      st.textContent =
        'html.cf-asm-rec,html.cf-asm-rec body{overflow:hidden!important;}' +
        'html.cf-asm-rec>:not(head):not(body),html.cf-asm-rec .cf-asm-anc>:not(.cf-asm-anc):not(#cf-root),html.cf-asm-rec #cf-root>:not(#cf-canvas){display:none!important;}' +
        'html.cf-asm-rec .cf-asm-anc{transform:none!important;translate:none!important;rotate:none!important;scale:none!important;filter:none!important;backdrop-filter:none!important;' +
        'perspective:none!important;contain:none!important;container-type:normal!important;will-change:auto!important;content-visibility:visible!important;}' +
        'html.cf-asm-rec #cf-root{position:fixed!important;left:0!important;top:0!important;right:0!important;bottom:0!important;width:auto!important;height:auto!important;' +
        'max-width:none!important;max-height:none!important;margin:0!important;border-radius:0!important;z-index:2147483647!important;}' +
        'html.cf-asm-rec #cf-canvas{display:block!important;visibility:visible!important;opacity:1!important;}';
      d.head.appendChild(st);
    }
    for (a = root.parentElement; a && a !== d.documentElement; a = a.parentElement) a.classList.add('cf-asm-anc');
    d.documentElement.classList.add('cf-asm-rec');
    return true;
  }
  function _asmSteps() {
    if (!_isStagedType(STATE.variant)) return null;
    return _swingActiveSteps(STATE).filter(function (s) { return s > 0 && !_xpHeadStep(s); });
  }
  function _asmLegacySteps() {
    var sofa = _isSofaAsm(STATE), sm = sofa ? _sofaStepMap(STATE) : null, out = [], s;
    var last = sofa ? sm.last : ((STATE.backrestVisible !== false) ? BENCH_LAST_STEP : BENCH_LAST_STEP_NO_BACKREST);
    for (s = 3; s <= last; s++) { if (sofa && (s === 5 || s === 6) && sm.noTop) continue; out.push(s); }
    return out;
  }
  function _asmParts(G) { return G.children.filter(function (c) { var pt = (c.userData || {}).partType; return !!pt && pt !== 'person'; }); }
  function _asmTap() {
    if (_ASM.on || _T.igWait) return;
    var E = _tourEng(), G = E && E.benchGroup;
    if (!G || !E.camera || !_tourControls() || !global.THREE) { _tlog('asm      no stage on the page -- nothing to play'); return; }
    _ASM.on = true;
    var tok = ++_ASM.tok, L = null, legacy = !_isStagedType(STATE.variant) && ((STATE.variant | 0) === 1 || _isSofaAsm(STATE));   /* the park bench, sofa, bed; another type with no staged steps is held built */
    try { if (STATE.view === '2d' && E.toggleView) E.toggleView(); } catch (eV) {}
    try { _tourArClose(); } catch (eAr) {}
    if ((STATE.assemblyStep | 0) !== 0) { STATE.assemblyStep = 0; try { if (legacy) global.BenchRenderer.build(); else global.BenchRenderer._applyAssemblyStep(G, 0); } catch (eA) {} }
    _asmHide();
    try { global.dispatchEvent(new global.Event('resize')); } catch (eR) {}   /* the renderer takes the screen's size now */
    /* the page's own framing of the finished design, kept (no refit on a later resize) */
    try { _fitView(); } catch (eF) {}
    _fitMoved = true;
    if (_fitTimer) { clearTimeout(_fitTimer); _fitTimer = null; }
    /* the stage cleared to what stands before the first step */
    try {
      L = legacy ? _asmLegacySteps() : _asmSteps();
      if (L && L.length) {
        STATE.assemblyStep = L[0];
        if (legacy) global.BenchRenderer.build(); else global.BenchRenderer._applyAssemblyStep(G, L[0]);
        _asmParts(_tourEng().benchGroup).forEach(function (c) { if (legacy || _swingPartStep(c.userData.partType) >= L[0]) c.visible = false; });
      }
    } catch (eC) { _tlog('asm      clearing the stage THREW ' + ((eC && eC.message) || eC)); }
    _tlog('asm      ' + (_tourName(STATE.variant | 0) || ('type ' + (STATE.variant | 0))) + ': the page hidden, the stage full screen, ' + (L ? L.length : 0) + ' step(s) from 2 s' + (legacy ? ' (its own old sequence: no fly-in)' : '') + ((L && L.length) ? '' : ' -- no staged assembly for this type: the finished model held'));
    _tourIgGo(function () { if (tok === _ASM.tok && L && L.length) { if (legacy) _asmLegacy(tok, L); else _asmRun(tok, L); } });
  }
  /* the walk: a step with wood flies in (the button's own animation) and is held; the fastener steps
     after it come at once as it lands; one of fasteners alone never waits */
  function _asmRun(tok, L) {
    var G = _tourEng().benchGroup, i = 0, prev = 0, nW = 0, t0 = _tourNow();
    function woodAt(s) {
      return _asmParts(G).some(function (c) { return c.userData.basePos && _swingPartStep(c.userData.partType) === s && !_asmIsHw(c) && _benchVisibleAtStep(c, s); });
    }
    function apply(s) {
      var ms = 0;
      STATE.assemblyStep = s;
      try { global.BenchRenderer._applyAssemblyStep(G, s); ms = _stagedAnimate(prev, s) || 0; }
      catch (eA) { _tlog('asm      step ' + s + ' THREW ' + ((eA && eA.message) || eA)); }
      prev = s;
      return ms;
    }
    function next() {
      if (tok !== _ASM.tok) return;
      if (i >= L.length) { _asmBuilt(tok, nW, t0); return; }
      var s = L[i++], ms = apply(s);
      if (!(ms > 0)) { next(); return; }
      nW++;
      global.setTimeout(function () {
        if (tok !== _ASM.tok) return;
        while (i < L.length && !woodAt(L[i])) apply(L[i++]);
        global.setTimeout(next, ASM.HOLD);
      }, ms);
    }
    next();
  }
  /* the park bench, the sofa, the bed: their build steps rebuilt one by one, the new parts in place */
  function _asmLegacy(tok, L) {
    var i = 0, nW = 0, t0 = _tourNow(), had = '';
    /* the wood on show (the backrest's pieces inside its group too) and where it stands: a step that changes neither added fasteners only */
    function woodSig() {
      var G = _tourEng().benchGroup, n = 0, s = 0, v = new global.THREE.Vector3();
      G.updateMatrixWorld(true);
      G.traverse(function (o) {
        var ud = o.userData || {}, p;
        if (!ud.partType || ud.partType === 'person' || _asmIsHw(o)) return;
        for (p = o; p && p !== G; p = p.parent) if (!p.visible) return;
        n++; v.setFromMatrixPosition(o.matrixWorld); s += v.x + 3 * v.y + 7 * v.z;
      });
      return n + ':' + s.toFixed(3);
    }
    function next() {
      if (tok !== _ASM.tok) return;
      if (i >= L.length) { _asmBuilt(tok, nW, t0, true); return; }
      STATE.assemblyStep = L[i++];
      try { global.BenchRenderer.build(); } catch (eB) { _tlog('asm      step ' + STATE.assemblyStep + ' THREW ' + ((eB && eB.message) || eB)); }
      var n = woodSig(), wood = (n !== had);
      had = n;
      if (!wood) { next(); return; }
      nW++;
      global.setTimeout(next, ASM.LEGACY);
    }
    next();
  }
  function _asmBuilt(tok, nW, t0, legacy) {
    var G = _tourEng().benchGroup;
    STATE.assemblyStep = 0;
    try { if (legacy) global.BenchRenderer.build(); else global.BenchRenderer._applyAssemblyStep(G, 0); } catch (eA) {}
    _tlog('asm      built: ' + nW + ' step(s) with wood, ' + ((_tourNow() - t0) / 1000).toFixed(1) + ' s from the first one');
    global.setTimeout(function () { if (tok === _ASM.tok) _asmSway(tok); }, ASM.END);
  }
  /* the swing sways: everything that hangs turns round the line through the chains' tops */
  function _asmSway(tok) {
    var T = global.THREE, G = _tourEng().benchGroup, chains = [], hang = [], tops = [];
    _asmParts(G).forEach(function (c) {
      var pt = String(c.userData.partType);
      if (!c.visible) return;
      if (/(^|-)chain$/.test(pt)) chains.push(c);
      if (!ASM_FIXED.test(pt)) hang.push(c);
    });
    if (!chains.length || !hang.length) { _tlog('asm      nothing hangs on this design -- the finished model held'); return; }
    G.updateMatrixWorld(true);
    var inv = new T.Matrix4().copy(G.matrixWorld).invert(), M = new T.Matrix4(), v = new T.Vector3();
    chains.forEach(function (c) {
      var bb = new T.Box3().setFromObject(c).applyMatrix4(inv), best = null, k;
      if (c.isInstancedMesh) {
        for (k = 0; k < c.count; k++) {
          c.getMatrixAt(k, M); v.setFromMatrixPosition(M).applyMatrix4(c.matrixWorld).applyMatrix4(inv);
          if (!best || v.y > best.y) best = v.clone();
        }
      }
      tops.push(new T.Vector3(best ? best.x : (bb.min.x + bb.max.x) / 2, bb.max.y, best ? best.z : (bb.min.z + bb.max.z) / 2));
    });
    var P = new T.Vector3(), x0 = 1e9, x1 = -1e9, z0 = 1e9, z1 = -1e9;
    tops.forEach(function (p) { P.add(p); x0 = Math.min(x0, p.x); x1 = Math.max(x1, p.x); z0 = Math.min(z0, p.z); z1 = Math.max(z1, p.z); });
    P.multiplyScalar(1 / tops.length);
    var axis = (x1 - x0 >= z1 - z0) ? new T.Vector3(1, 0, 0) : new T.Vector3(0, 0, 1);
    /* the pendulum: from the pivot to the middle of what hangs below the chains */
    var B = new T.Box3();
    hang.forEach(function (c) { if (chains.indexOf(c) < 0) B.union(new T.Box3().setFromObject(c).applyMatrix4(inv)); });
    var len = Math.max(0.3, P.y - (B.isEmpty() ? P.y - 1 : (B.min.y + B.max.y) / 2));
    var per = Math.max(1.8, Math.min(3.2, 2 * Math.PI * Math.sqrt(len / 9.81))), amp = ASM.DEG * Math.PI / 180;
    var S = hang.map(function (c) { return { o: c, p: c.position.clone(), q: c.quaternion.clone() }; });
    var q = new T.Quaternion(), t0 = _tourNow();
    _tlog('asm      the swing sways: ' + hang.length + ' part(s) round the chains\' tops (' + P.x.toFixed(2) + ', ' + P.y.toFixed(2) + ', ' + P.z.toFixed(2) + ' m, along ' + (axis.x ? 'X' : 'Z') + '), +-' + ASM.DEG + ' deg, ' + per.toFixed(2) + ' s a swing (' + len.toFixed(2) + ' m), up to full in ' + (2 * per).toFixed(1) + ' s');
    (function frame() {
      if (tok !== _ASM.tok || S[0].o.parent !== G) return;
      var ts = (_tourNow() - t0) / 1000, a = amp * _ig2Soft(ts / (2 * per)) * Math.sin(2 * Math.PI * ts / per);
      q.setFromAxisAngle(axis, a);
      S.forEach(function (s) {
        s.o.position.copy(s.p).sub(P).applyQuaternion(q).add(P);
        s.o.quaternion.copy(q).multiply(s.q);
      });
      global.requestAnimationFrame(frame);
    })();
  }

  function _tourMount() {
    if (_T.btn || false) return;
    if (!_tourVoiceLang()) { _tlog('tour     not shown -- no voice for the language ' + _tourLang()); return; }
    var root = _tq('cf-root');
    if (!root) return;
    _tourCss();
    var b = global.document.createElement('button');
    b.type = 'button';
    b.id = 'cf-tour-btn';
    b.className = 'cf-idle cf-intro-wait';
    b.innerHTML = _TOUR_SVG.play;
    b.setAttribute('aria-label', 'Tour');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      b.classList.remove('cf-intro');
      if (_IG2_ASM) { _asmTap(); return; }   /* bench-v408 ?ig2=asm: the build recording */
      /* bench-v351: a ?ig2 page plays its 8-second story, never the tour -- v358: GARDEN STRUCTURES' ?ig2 its cinema bar reel (?ig2=8 the story) */
      if (_IG2_PAGE && !_tourIg2Reel()) { if (_IG2.on) _ig2End('stopped by a tap'); else _tourIgGo(_ig2Start); return; }
      if (_T.on) _tourPause('the pause button'); else if (_tourIg()) _tourIgGo(_tourStart); else _tourStart();
    });
    root.appendChild(b);
    _T.btn = b;
    /* the entrance once the button is on screen (core-v685, core-v698: from
       200 % at 10 % opacity to its size at full opacity) */
    var intro = function () {
      if (_T.introDone) return;
      _T.introDone = true;
      b.classList.remove('cf-intro-wait');
      if (_T.on) return;
      b.classList.add('cf-intro');
      _tlog('tour     play button: the entrance -- from 200 % at 10 % opacity to its size at full opacity, then the soft pulse (core-v698)');
      global.setTimeout(function () { b.classList.remove('cf-intro'); }, 2000);
    };
    try {
      var io = new global.IntersectionObserver(function (E) {
        if (E.some(function (x) { return x.isIntersecting && x.intersectionRatio > 0.6; })) { io.disconnect(); global.setTimeout(intro, 300); }
      }, { threshold: [0, 0.6, 1] });
      io.observe(b);
    } catch (eIo) { global.setTimeout(intro, 1200); }
    global.setTimeout(intro, 6000);
    global.setTimeout(function () { if (!_T.on && (!_IG2_PAGE || _tourIg2Reel())) { _tourBuild(); _tourPreStep(_TOUR_STEPS[0], 'the first step, before play'); } }, 3000);   /* v351 no voice on a ?ig2 story page; v358 the reel's hook fetched ahead */
    _tourPlace();
    global.addEventListener('resize', _tourPlace);
    _T.placeT = global.setInterval(_tourPlace, 1000);
    global.addEventListener('pagehide', function () { if (_T.on) _tourStop('the page was left'); });
    _tlog('tour     play button over the rail, on its axis, 12 px under the top edge -- ' + _TOUR_STEPS.length + ' step(s) (' +
         _TOUR_STEPS.map(function (x) { return x.key; }).join(', ') + '), language ' + _tourLang() + ', paused only by its own button');
  }
  /* ONE PLACE ON EVERY PRODUCT (core-v645): the PLAY's middle on the rail's
     axis, the rail and the strip under it, a rail too tall drawn smaller */
  var TOUR_TOP = 12, TOUR_D = 38;
  /* EVERY ?ig POST (bench-v359, the core's core-v763, Marek 2026-10-27 10:38: "Tlacitko play dej na stred dolu, ale po zmacknuti, dve vteriny nic, pak spustit. Tlacitko mezitim schovat - plati pro vsechny prispevky pro ig, ktere budeme delat"): the PLAY
     in the middle of the canvas's bottom edge, above the command bar when
     there is one; a tap hides it and the reel starts 2 s later; it comes
     back when the reel ends. */
  function _tourIgGo(fn) {
    if (_T.igWait || !_T.btn) return;
    _T.igWait = true;
    _T.btn.classList.add('cf-ig-gone');
    _tlog('tour     ?ig: PLAY hidden, the reel starts in 2 s (bench-v359)');
    global.setTimeout(function () { _T.igWait = false; fn(); }, 2000);
  }
  /* bench-v360 (canvas-h-v1, Marek 2026-10-27: the canvas lower on an
     upright screen): the PLAY sits 12 px above whatever is under the middle
     of the canvas's lower half -- the command bar, the info bar (BACKREST /
     SEAT PLANKS ...), the backrest-tilt slider -- not over it */
  function _tourIgPlace(b, root) {
    var bt = 25;
    try {
      var rr = root.getBoundingClientRect(), mid = rr.left + rr.width / 2, hi = null;
      [_tq('cf-cmdbar'), root.querySelector('.cf-info-bar'), _tq('cf-bench-rake-row')].forEach(function (el) {
        if (!el) return;
        var r = el.getBoundingClientRect(), cs = global.getComputedStyle(el);
        if (!(r.width > 0 && r.height > 0) || cs.visibility === 'hidden' || +cs.opacity < 0.05) return;
        if (r.right < mid - TOUR_D / 2 - 6 || r.left > mid + TOUR_D / 2 + 6 || r.top < rr.top + rr.height / 2) return;
        if (hi === null || r.top < hi) hi = r.top;
      });
      if (hi !== null) bt = Math.max(12, Math.round(rr.bottom - hi + 12));
    } catch (eB) {}
    var want = { top: 'auto', right: 'auto', left: 'calc(50% - ' + (TOUR_D / 2) + 'px)', bottom: bt + 'px' };
    for (var kw in want) if (want.hasOwnProperty(kw) && b.style[kw] !== want[kw]) b.style[kw] = want[kw];
  }
  function _tourPlace() {
    var b = _T.btn, root = _tq('cf-root');
    if (!b || !root) return;
    if (_tourIg()) { _tourIgPlace(b, root); return; }
    if (!root.classList.contains('cf-tour-top')) root.classList.add('cf-tour-top');
    var rail = global.document.querySelector('#cf-root .cf-sidebar'), right = 21;
    try {
      var R = root.getBoundingClientRect(), a = rail ? rail.getBoundingClientRect() : null;
      if (!(a && a.width > 0)) { rail = null; a = null; var sx = _tq('cf-sx-strip'); if (sx) a = sx.getBoundingClientRect(); }
      if (a && a.width > 0) right = Math.round(R.right - (a.left + a.width / 2) - TOUR_D / 2);
      if (rail) {
        var h = rail.offsetHeight, H = root.clientHeight, k = 1;
        if (h > 0 && H > 0 && h > H - 70) k = Math.max(0.6, (H - 70) / h);
        var tf = (k < 0.999) ? ('translateY(-50%) scale(' + (Math.round(k * 1000) / 1000) + ')') : '';
        if (rail.style.transform !== tf) {
          rail.style.transform = tf;
          if (_T.railK !== k) { _T.railK = k; _tlog('tour     the rail drawn at ' + Math.round(k * 100) + ' % under the PLAY (' + h + ' px tall, ' + H + ' px of canvas)'); }
        }
      }
    } catch (e) {}
    if (b.style.top !== TOUR_TOP + 'px') b.style.top = TOUR_TOP + 'px';
    if (b.style.right !== right + 'px') b.style.right = right + 'px';
  }
  /* ---- small helpers, the core's ---------------------------------------- */
  function _tourLater(fn, ms, run) {
    if (_T.probe) return 0;
    var id = global.setTimeout(function () { if (run === _T.run) { try { fn(); } catch (e) { _tlog('tour     step THREW ' + ((e && e.message) || e)); _tourStop('an error in the step'); } } }, ms);
    _T.tm.push(id);
    return id;
  }
  function _tourSee(el) {
    try {
      var L = el && el.closest ? el.closest('.cf-sx-list') : null;
      if (!L) return;
      var top = el.offsetTop - L.offsetTop, h = el.offsetHeight || 40, st = L.scrollTop, vis = L.clientHeight;
      if (top >= st + 2 && top + h <= st + vis - 2) return;
      var to = Math.max(0, Math.min(L.scrollHeight - vis, Math.round(top - (vis - h) / 2)));
      try { L.scrollTo({ top: to, behavior: 'smooth' }); } catch (eS) { L.scrollTop = to; }
    } catch (e) {}
  }
  function _tourHl(el) {
    if (_T.hl && _T.hl !== el) { try { _T.hl.classList.remove('cf-tour-hl'); } catch (e) {} }
    _T.hl = el || null;
    if (el) { _tourSee(el); try { el.classList.add('cf-tour-hl'); } catch (e2) {} }
  }
  function _tourPulse(list) {
    _T.pl.forEach(function (el) { try { el.classList.remove('cf-tour-pulse'); } catch (e) {} });
    _T.pl = (list || []).filter(function (el) { return !!el; });
    _T.pl.forEach(function (el) { _tourSee(el); try { el.classList.add('cf-tour-pulse'); } catch (e) {} });
  }
  function _tourBub(el, text) {
    var root = _tq('cf-root');
    if (!root) return;
    if (!_T.bub) {
      _T.bub = global.document.createElement('div');
      _T.bub.id = 'cf-tour-bub';
      root.appendChild(_T.bub);
    }
    var B = _T.bub;
    if (!el || !text || _T.voice) { B.classList.remove('cf-on'); return; }
    var r = el.getBoundingClientRect(), R = root.getBoundingClientRect();
    if (!r.width && !r.height) { B.classList.remove('cf-on'); return; }
    B.textContent = text;
    var side = !!(el.closest && el.closest('#cf-sx-strip'));
    B.classList.toggle('cf-side', side);
    B.style.left = Math.round(side ? (r.left - R.left - 10) : (r.left - R.left + r.width / 2)) + 'px';
    B.style.top = Math.round(side ? (r.top - R.top + r.height / 2) : (r.top - R.top)) + 'px';
    B.classList.add('cf-on');
    try {
      var bb = B.getBoundingClientRect();
      if (bb.right > R.right - 6) B.style.left = Math.round(parseFloat(B.style.left) - (bb.right - R.right + 6)) + 'px';
      if (bb.left < R.left + 6) B.style.left = Math.round(parseFloat(B.style.left) + (R.left + 6 - bb.left)) + 'px';
    } catch (eB) {}
  }
  function _tourLabel(el) {
    if (!el) return '';
    return String(el.getAttribute('aria-label') || el.getAttribute('title') || '').trim();
  }

  /* ---- the bench's stage ---------------------------------------------- */
  var TOUR_ORDER = [1, 7, 2, 4, 3, 8, 5, 13, 9, 11, 10, 12, 6, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 52, 51, 53, 54];   /* v423 + the twist bench */   /* v403 + the modern dog house */   /* v396 + the double dog house */   /* v392 + the kennel with run */   /* v391 + the cupola coop */   /* v388 + the insulated dog house */   /* v386 + the lean-to coop */   /* v385 + the dog house */   /* v383 + the walk-in coop */   /* v379 + the chicken tractor */   /* v376 + the kitchen pod */   /* v375 + the backyard coop */   /* v373 + the gable greenhouse */   /* v368 + the tree fort */   /* v367 + the little barn */   /* v366 + the modern house */   /* v365 + the play fort */   /* v364 + the A-frame */   /* v363 + the stilt house */   /* v362 + the cottage */   /* v334 + the pergola */   /* v328 + the gazebo */   /* v320 + the garden arbor */   /* v318 + the floating bed */   /* v314 + the raised bed */   /* v303 + the cinema bar */   /* v301 + the modern swing */   /* v296 + the pergola swing */   /* v288 + the sunbed */   /* the storefront's order when the page gives none (v276: + the bed) */
  function _tourSlots() { return (SLOT_TYPES && SLOT_TYPES.length) ? SLOT_TYPES.slice(0) : TOUR_ORDER.slice(0); }
  function _tourEng() { return global.BenchEngine || null; }
  function _tourControls() { var E = _tourEng(); return (E && E.controls) || null; }
  function _tourName(t) { return _tt('variant_v' + t, ''); }
  /* the bench's own box: every mesh on show but the scale figure */
  function _tourBox() {
    var E = _tourEng(), T = global.THREE;
    if (!E || !E.benchGroup || !T) return null;
    var box = new T.Box3(), tmp = new T.Box3(), n = 0;
    E.benchGroup.updateMatrixWorld(true);
    E.benchGroup.traverse(function (o) {
      if (!o.isMesh || !o.visible) return;
      var p = o;
      while (p && p !== E.benchGroup) {
        if (!p.visible || (p.userData && (p.userData.partType === 'person' || p.userData.partType === 'ph-tree'))) return;   /* v368 the tree fort's tree */
        p = p.parent;
      }
      tmp.setFromObject(o);
      if (tmp.isEmpty() || !isFinite(tmp.min.x) || !isFinite(tmp.max.y)) return;
      box.union(tmp); n++;
    });
    return n ? box : null;
  }
  /* the camera eased to a pose; the turn on the spot waits for it */
  function _tourCamTo(p, t, ms, run, cb) {
    var E = _tourEng(), cam = E && E.camera, ctl = _tourControls();
    if (!cam || !ctl) { if (cb) cb(); return; }
    var p0 = cam.position.clone(), t0 = ctl.target.clone(), s0 = _tourNow(), rot = ctl.autoRotate;
    ctl.autoRotate = false;
    var step = function () {
      if (run !== _T.run) return;
      var f = (ms > 0) ? Math.min(1, (_tourNow() - s0) / ms) : 1, e = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
      cam.position.lerpVectors(p0, p, e);
      ctl.target.lerpVectors(t0, t, e);
      try { ctl.update(); } catch (eU) {}
      if (f < 1) global.requestAnimationFrame(step);
      else { ctl.autoRotate = rot || !!_T.spin; if (cb) cb(); }
    };
    step();
  }
  /* the bench in the frame: from its side (az, rad from +Z toward +X; the
     camera's own when not given), a little from above, all of it in view */
  function _tourFrame(o, run, cb) {
    o = o || {};
    var E = _tourEng(), T = global.THREE, cam = E && E.camera, ctl = _tourControls(), box = _tourBox();
    if (!cam || !ctl || !T || !box) { if (cb) cb(); return; }
    var sph = box.getBoundingSphere(new T.Sphere()), asp = cam.aspect || 1.4;
    var vF = cam.fov * Math.PI / 180, hF = 2 * Math.atan(Math.tan(vF / 2) * asp);
    /* a phone's tall canvas: a step back, and the bench moved off the rail */
    var d = sph.radius / Math.sin(Math.min(vF, hF) / 2) * (o.k || 1) * (asp < 0.9 ? 1.28 : 0.95);
    var az = (o.az != null) ? o.az : Math.atan2(cam.position.x - ctl.target.x, cam.position.z - ctl.target.z);
    var el = (o.el != null) ? o.el : 0.30;
    var tg = new T.Vector3(sph.center.x, box.min.y + (box.max.y - box.min.y) * 0.46, sph.center.z);
    try {
      var root = _tq('cf-root'), rail = root && root.querySelector('.cf-sidebar'), Rr = root.getBoundingClientRect(), Ra = rail ? rail.getBoundingClientRect() : null;
      if (Ra && Ra.width > 0 && Rr.width > 0) {
        var sh = (Rr.right - Ra.left + 8) / 2 / Rr.width * 2 * d * Math.tan(hF / 2);
        tg.x += Math.cos(az) * sh; tg.z -= Math.sin(az) * sh;
      }
    } catch (eR) {}
    var p = new T.Vector3(tg.x + d * Math.cos(el) * Math.sin(az), tg.y + d * Math.sin(el), tg.z + d * Math.cos(el) * Math.cos(az));
    ctl.minDistance = Math.min(ctl.minDistance || d, d * 0.5);
    ctl.maxDistance = Math.max(ctl.maxDistance || d, d * 1.8);
    cam.far = Math.max(cam.far || 0, d * 6); cam.updateProjectionMatrix();
    _tourCamTo(p, tg, (o.ms != null) ? o.ms : 900, run, cb);
  }
  /* the slow turn of every step (OrbitControls' own auto-rotate) */
  function _tourSpin(on) {
    var c = _tourControls();
    _T.spin = !!on;
    if (!c) return;
    if (on) { if (!_T.rot) _T.rot = { on: c.autoRotate, sp: c.autoRotateSpeed }; c.autoRotate = true; c.autoRotateSpeed = 0.55; }
    else if (_T.rot) { c.autoRotate = !!_T.rot.on; if (_T.rot.sp != null) c.autoRotateSpeed = _T.rot.sp; _T.rot = null; }
  }
  /* one full turn round the bench, eased in and out */
  function _tourTurn(ms, run, cb) {
    var E = _tourEng(), cam = E && E.camera, ctl = _tourControls();
    if (!cam || !ctl || STATE.view === '2d') { cb(); return; }
    var tg = ctl.target.clone(), off = cam.position.clone().sub(tg), rot = ctl.autoRotate;
    var r = Math.sqrt(off.x * off.x + off.z * off.z), a0 = Math.atan2(off.x, off.z), y = off.y, t0 = _tourNow();
    ctl.autoRotate = false;
    var step = function () {
      if (run !== _T.run) return;
      var f = Math.min(1, (_tourNow() - t0) / ms), e = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2, a = a0 + 2 * Math.PI * e;
      if (f > 0.08 && f < 1 && _tourHurry()) { ctl.autoRotate = rot; cb(); return; }   /* v277: the voice has ended -- no turn on in silence */
      cam.position.set(tg.x + r * Math.sin(a), tg.y + y, tg.z + r * Math.cos(a));
      cam.lookAt(tg);
      try { ctl.update(); } catch (eU) {}
      if (f < 1) global.requestAnimationFrame(step); else { ctl.autoRotate = rot; cb(); }
    };
    global.requestAnimationFrame(step);
  }
  function _tourCamPlay() {
    try {
      var E = _tourEng(), c = E && E.camera, ctl = _tourControls();
      if (!_T.cam || !c || !ctl) return;
      c.position.copy(_T.cam.p); ctl.target.copy(_T.cam.t);
      ctl.minDistance = _T.cam.mn; ctl.maxDistance = _T.cam.mx;
      c.far = _T.cam.f; c.updateProjectionMatrix();
      ctl.autoRotate = !!_T.cam.ar; if (_T.cam.as != null) ctl.autoRotateSpeed = _T.cam.as;
      /* no drift after it: one update without damping clears the turn the
         auto-rotate left in the controls */
      var dmp = ctl.enableDamping;
      ctl.enableDamping = false; ctl.update(); ctl.enableDamping = dmp;
      c.position.copy(_T.cam.p); ctl.target.copy(_T.cam.t); ctl.update();
    } catch (e) {}
  }
  /* a type on the stage: its defaults, the step's colour and keys, one
     build, the camera eased to it (no jump: selectVariant's own framing of
     the tall swings is undone first) */
  function _tourType(t, c, set, run, cam) {
    _tourArClose();
    var E = _tourEng(), cm = E && E.camera, ctl = _tourControls();
    var P0 = cm ? cm.position.clone() : null, T0 = ctl ? ctl.target.clone() : null;
    selectVariant(t, true);
    if (P0 && cm && ctl) { cm.position.copy(P0); ctl.target.copy(T0); try { ctl.update(); } catch (eU) {} }
    if (c && COLOR_SCHEMES[c]) STATE.colorMode = c;
    if (set) { try { set(); } catch (eS) { _tlog('tour     setting the ' + t + ' THREW ' + ((eS && eS.message) || eS)); } }
    STATE.assemblyStep = 0;
    _designShow();
    _T.dirty = true;
    _tourFrame(cam || {}, run);
  }
  /* shows in a row: each item calls its next when done */
  function _tourSeq(run, L, cb) {
    var i = 0;
    var go = function () {
      if (run !== _T.run) return;
      if (i >= L.length) { if (cb) cb(); return; }
      var f = L[i++];
      try { f(go); } catch (e) { _tlog('tour     show THREW ' + ((e && e.message) || e)); go(); }
    };
    go();
  }
  /* v277 (Marek: zkratit prazdne pauzy): once a step's voice has ended, its
     show hurries -- the waits to 120 ms, the sweeps (also one under way) to
     about 350 ms, a turn stops; and the tour's assembly animates at 60 % of
     the time */
  function _tourHurry() { return !!(_T && _T.on && _T.doneFn && _T.doneFn()); }
  function _tourAsmSpeed() { return (_T && _T.on) ? 0.6 : 1; }
  function _tw(ms, run) { return function (nx) { _tourLater(nx, _tourHurry() ? Math.min(ms, 120) : ms, run); }; }
  function _tdo(fn) { return function (nx) { fn(); nx(); }; }
  /* a value eased from a to b, set(v, last) on every frame */
  function _tourSweep(a, b, ms, set, run, cb) {
    var s0 = _tourNow(), hs = -1, f0 = 0;
    if (_tourHurry()) ms = Math.min(ms, 350);
    var step = function () {
      if (run !== _T.run) return;
      var now = _tourNow(), f = Math.min(1, (now - s0) / ms);
      if (hs < 0 && f < 1 && _tourHurry()) { hs = now; f0 = f; }          /* v277: the voice ended under way -- the rest in 350 ms */
      if (hs >= 0) f = Math.min(1, f0 + (1 - f0) * (now - hs) / 350);
      var e = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
      try { set(a + (b - a) * e, f >= 1); } catch (eS) { _tlog('tour     sweep THREW ' + ((eS && eS.message) || eS)); f = 1; }
      if (f < 1) global.requestAnimationFrame(step); else if (cb) cb();
    };
    step();
  }
  function _tsw(a, b, ms, set, run) {
    return function (nx) { _tourSweep((typeof a === 'function') ? a() : a, (typeof b === 'function') ? b() : b, ms, set, run, nx); };
  }
  /* the length as the handle drags it (the bill once, at the end) */
  function _tourLenSet(v, fin) {
    var R = _lengthRange(STATE), L = Math.max(R.min, Math.min(R.max, Math.round(v * 1000) / 1000));
    if (!fin && Math.abs(L - STATE.L) < 0.004) return;
    STATE.L = L;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI(!fin);
  }
  /* the tilt slider as a hand moves it: the type's value, the slider's
     thumb, fill, number and band name (the bill once, at the end) */
  function _tourSlideSet(v, fin) {
    var t = STATE.variant | 0, d = Math.round(v);
    if (t === 1) { d = Math.max(RANGES.backRakeDeg.min, Math.min(RANGES.backRakeDeg.max, d)); if (STATE.backRakeDeg === d && !fin) return; STATE.backRakeDeg = d; }
    else if (_isSwingBackType(t)) { d = Math.max(SWING.BACK_MIN, Math.min(_swingBackMax(STATE), d)); if (STATE.swingBack === d && !fin) return; STATE.swingBack = d; }
    else if (t === 3) { d = Math.max(15, Math.min(90, d)); if (STATE.waveBack === d && !fin) return; STATE.waveBack = d; delete STATE._waveBetaAnim; }
    else if (t === 9) { d = Math.max(ADI.BACK_MIN, Math.min(ADI.BACK_MAX, d)); if (STATE.adiBack === d && !fin) return; STATE.adiBack = d; }
    else return;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI(!fin);
    var r = _tq('cf-bench-rake'), val = _tq('cf-bench-rake-val'), lab = _tq('cf-bench-tilt-label');
    if (r) {
      r.value = String(d);
      var mn = parseFloat(r.min) || 0, mx = parseFloat(r.max) || 100, pct = ((d - mn) / Math.max(1e-6, mx - mn)) * 100;
      r.style.background = 'linear-gradient(to right, #c79a4a 0%, #c79a4a ' + pct + '%, rgba(0,0,0,0.10) ' + pct + '%, rgba(0,0,0,0.10) 100%)';
    }
    if (val) val.textContent = String(d);
    if (lab) { if (_isSwingBackType(t)) lab.textContent = swingBackLabel(); else if (t === 3) lab.textContent = waveBackLabel(); }
    if (fin) _emitVariantChange();   /* the mattress button and the rest follow */
  }
  /* v339 the pergola's infill gap as its slider moves it, mm (the bill once, at the end) */
  function _tourPeGapSet(v, fin) {
    var R = _peGapRange(STATE), g = Math.max(R.min, Math.min(R.max, Math.round(v) / 1000));
    if (!fin && Math.abs(g - _peGap(STATE)) < 0.0005) return;
    STATE.peGap = g;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI(!fin);
    try { if (global.BenchHandles && global.BenchHandles.reposition) global.BenchHandles.reposition(); } catch (eH) {}
    var r = _tq('cf-bench-rake'), mm = Math.round(g * 1000);
    if (r) {
      r.value = String(mm);
      var mn = parseFloat(r.min) || 0, mx = parseFloat(r.max) || 100, pct = ((mm - mn) / Math.max(1e-6, mx - mn)) * 100;
      r.style.background = 'linear-gradient(to right, #c79a4a 0%, #c79a4a ' + pct + '%, rgba(0,0,0,0.10) ' + pct + '%, rgba(0,0,0,0.10) 100%)';
    }
  }
  /* v361 the pergola swing's back fill gap as a hand moves its slider: the slider's own input event (the
     seat rebuilt, the slider painted, the toggle's label with the gap), mm */
  function _tourPorchGapSet(v, fin) {
    var r = _tq('cf-bench-pitch');
    if (!r) return;
    var mm = Math.round(v);
    if (!fin && String(mm) === r.value) return;
    r.value = String(mm);
    try { r.dispatchEvent(new global.Event('input', { bubbles: true })); } catch (e) { try { setPorchGap(mm / 1000); } catch (e2) {} }
  }
  /* v346 the raised bed's width as its handle drags it, 5 mm (the bill once, at the end) */
  function _tourRbWSet(v, fin) {
    var R = _rbWRange(STATE), w = Math.round(Math.max(R.min, Math.min(R.max, v)) * 200) / 200;
    if (!fin && Math.abs(w - _rbW(STATE)) < 1e-6) return;
    STATE.rbW = w;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI(!fin);
  }
  /* v339 a pergola field filled / emptied as its + disc's tap does */
  function _tpeField(id) { return function (nx) { try { cyclePeField(id); } catch (e) { _tlog('tour     pergola field ' + id + ' THREW ' + ((e && e.message) || e)); } nx(); }; }
  /* v276 the bed: the headboard's height as its handle drags it (5 mm), the
     width snapped to the nearest mattress of the units (the bill once, at
     the end) */
  function _tourBedHeadSet(v, fin) {
    var g = _bedLayout(STATE), h = Math.round(Math.max(g.headMin, Math.min(BED.HEAD_MAX, v)) * 200) / 200;
    if (!fin && Math.abs(h - g.top) < 1e-6) return;
    STATE.bedHead = h;
    try { global.BenchRenderer.build(); } catch (e) {}
    refreshUI(!fin);
  }
  function _tourBedSize(i) {
    return function (nx) {
      var sz = _bedSizes(STATE), k = (i === 'def') ? ((STATE.isMetric === false) ? BED.US_DEF : BED.MW.indexOf(BED.MW_DEF)) : (i < 0) ? sz.length + i : i;   /* 'def' = Queen / 160 */
      k = Math.max(0, Math.min(sz.length - 1, k));
      STATE.bedMW = sz[k].w;
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI(false);
      nx();
    };
  }
  function _tourBedStyle(st) {
    return function (nx) {
      if (st === 'off') STATE.backrestVisible = false;
      else { STATE.backrestVisible = true; STATE.bedHeadStyle = st; }
      try { global.BenchRenderer.build(); } catch (e) {}
      refreshUI(true);
      _emitVariantChange();   /* the snippet's toggle label follows */
      nx();
    };
  }
  function _tclick(id) { return function (nx) { var b = _tq(id); if (b && b.offsetParent !== null) { try { b.click(); } catch (e) {} } nx(); }; }
  function _tpulse(ids) { return function (nx) { _tourPulse((ids || []).map(function (id) { return _tq(id); })); nx(); }; }
  /* the build order, the assembly button's own clicks, back to the finished
     bench; the pace quickens once the voice has ended */
  function _tourAsm(cb, run, done, seq) {
    var b = _tq('cf-btn-assembly'), n = 0;
    if (!b) { _tourLater(cb, 600, run); return; }
    _tourHl(b);
    var next = function () {
      /* v269: seq = the steps to show (the porch swing's 15 in the sofa's
         assembly would be long): each one entered from the step before it,
         so it animates as the button would */
      if (seq && n < seq.length) STATE.assemblyStep = (seq[n] === 0) ? _sofaStepMap(STATE).last : seq[n] - 1;
      try { b.click(); } catch (e) {}
      n++;
      if ((STATE.assemblyStep | 0) === 0 || n > 40) { _tourHl(null); _tlog('tour     assembly: ' + n + ' step(s) shown, the bench finished again'); _tourLater(cb, done() ? 400 : 1300, run); return; }
      _tourLater(next, seq ? (done() ? 600 : 1150) : (done() ? 320 : 750), run);   /* v277: faster (the animation at 60 % in the tour) */
    };
    _tourLater(next, 300, run);
  }
  /* bench-v335 (Marek 21:59: exploded a par kroku assembly, jak je mame ted,
     u varianty 1): a chosen walk through the assembly -- [step, ms] pairs,
     each step entered from the one before it so it animates as the button
     does, 0 = built again; _T.asmBusy holds the tour's step until the walk
     is over (hold) */
  function _tourAsmPrev(s) {
    if (_isStagedType(STATE.variant)) {
      var a = _swingActiveSteps(STATE), k = a.indexOf(s);
      if (s === 0 || k < 0) return a[a.length - 1];
      return k > 0 ? a[k - 1] : a[a.length - 1];
    }
    if (s !== 0) return s - 1;
    if (_isSofaAsm(STATE)) return _sofaStepMap(STATE).last;
    return (STATE.backrestVisible !== false) ? 22 : 13;
  }
  function _tourAsmWalk() {
    /* the park bench: exploded, the pocket holes, the posts, the side and
       long rails, the joists, the seat, the arms, the backrest flying in,
       its planks, built */
    if ((STATE.variant | 0) === 1) return [[1, 2000], [2, 1200], [3, 750], [4, 700], [6, 700], [8, 700], [10, 800], [12, 700], [19, 1500], [21, 800], [0, 1000]];
    /* a staged type: its first steps, one from the middle, the last, built */
    if (_isStagedType(STATE.variant)) {
      var a = _swingActiveSteps(STATE).filter(function (x) { return x > 0; }), out = [], k;
      for (k = 0; k < Math.min(4, a.length); k++) out.push([a[k], 800]);
      if (a.length > 6) out.push([a[Math.floor(a.length * 0.6)], 900]);
      if (a.length > 4) out.push([a[a.length - 1], 1000]);
      out.push([0, 1000]);
      return out;
    }
    return null;
  }
  function _tourAsmList(cb, run, done, list) {
    var b = _tq('cf-btn-assembly'), n = 0;
    if (!b || !list || !list.length) { _T.asmBusy = false; _tourAsm(cb, run, done); return; }
    _T.asmBusy = true;
    _tourHl(b);
    var next = function () {
      if (run !== _T.run) { _T.asmBusy = false; return; }
      if (n >= list.length) {
        _T.asmBusy = false; _tourHl(null);
        _tlog('tour     assembly: ' + list.map(function (q) { return q[0]; }).join(' > ') + ' shown (bench-v335), the bench finished again');
        _tourLater(cb, 300, run);
        return;
      }
      STATE.assemblyStep = _tourAsmPrev(list[n][0]);
      try { b.click(); } catch (e) {}
      var ms = list[n][1];
      n++;
      _tourLater(next, ms, run);
    };
    _tourLater(next, 300, run);
  }
  /* ---- the AR window with its QR ---------------------------------------- */
  function _tourArShown() { var m = _tq('cf-ar-modal'); return !!(m && !m.hidden); }
  function _tourArOpen() {
    var b = _tq('cf-btn-ar');
    if (!b) { _tlog('tour     ar: no AR button on this page'); return false; }
    var sig = '';
    try { sig = JSON.stringify(designPayload()); } catch (e) { sig = ''; }
    var m = _tq('cf-ar-modal'), q = _tq('cf-ar-modal-qr');
    if (m && sig && _T.arSig === sig && q && q.querySelector('img')) { m.hidden = false; _tlog('tour     ar: the window with the QR this design got before -- no new upload'); }
    else { _T.arSig = sig; try { b.click(); } catch (eC) {} _tlog('tour     ar: the window opened, the model on its way to the AR viewer'); }
    _T.arOpened = true;
    return true;
  }
  function _tourArClose() {
    if (!_T.arOpened) return;
    _T.arOpened = false;
    var m = _tq('cf-ar-modal');
    if (m && !m.hidden) {
      var x = m.querySelector('[data-cf-ar-close]');
      if (x) { try { x.click(); } catch (e) {} }
      if (!m.hidden) m.hidden = true;
    }
  }
  function _tar(run) {
    return function (nx) { _tourPulse([_tq('cf-btn-ar')]); _tourLater(function () { _tourPulse([]); _tourArOpen(); nx(); }, 900, run); };
  }

  /* ---- the steps -----------------------------------------------------------
     A type's step: start puts the type on (its colour, its keys) and frames
     it; cycle is the show (called again while the voice goes on); has()
     leaves out a type the storefront does not sell. */
  function _tourTypeStep(key, t, sec, c, o) {
    o = o || {};
    return { key: key, mp3: o.mp3 || ('bench-tour-' + key), sec: sec, lead: o.lead || 1200, type: t,
      tip: o.tip ? o.tip : ['variant_v' + t, ''],
      target: function () { return o.target ? _tq(o.target) : null; },
      has: function () { return _tourSlots().indexOf(t) >= 0; },
      start: function (run) {
        _T.once = {};
        if (o.same && (STATE.variant | 0) === t) _tourFrame(o.cam || {}, run);
        else _tourType(t, c, o.set, run, o.cam);
        _tourSpin(true);
        _tlog('tour     ' + key + ': ' + (_tourName(t) || ('type ' + t)) + ', ' + (STATE.colorMode || 'birch') + ', L ' + (+STATE.L).toFixed(2));
      },
      cycle: function (cb, run, done) { o.show(cb, run, done); },
      end: function () { _tourPulse([]); _tourHl(null); if (o.end) { try { o.end(); } catch (e) {} } } };
  }
  /* once per step: a show's first part only on its first pass */
  function _tonce(k, L, run) {
    return function (nx) { if (_T.once[k]) { nx(); return; } _T.once[k] = 1; _tourSeq(run, L, nx); };
  }
  /* a step held while its assembly walk goes on (bench-v335) */
  function _tourAsmStep(S) { S.hold = function () { return !!_T.asmBusy; }; S.holdMax = 9000; var e0 = S.end; S.end = function (x) { _T.asmBusy = false; e0(x); }; return S; }
  function _tourTypeSteps() {
    var S = {};
    S[1] = [_tourTypeStep('park', 1, 8, 'oak', { cam: { az: 0.75 }, target: 'cf-handle-l',
      show: function (cb, run) {
        var L0 = STATE.L, r0 = STATE.backRakeDeg;
        _tourSeq(run, [_tpulse(['cf-handle-l']), _tsw(L0, 1.83, 1100, _tourLenSet, run), _tsw(1.83, 1.07, 1400, _tourLenSet, run), _tsw(1.07, L0, 900, _tourLenSet, run),
          _tpulse(['cf-bench-rake']), _tsw(r0, 20, 800, _tourSlideSet, run), _tsw(20, 0, 1100, _tourSlideSet, run), _tsw(0, r0, 700, _tourSlideSet, run), _tpulse([]), _tw(500, run)], cb);
      } }),
      /* bench-v335 (Marek: ... samozrejme i v beznem pruvodci): the park
         bench's assembly -- exploded, the pocket holes, the frame, the seat,
         the arms, the backrest flying in -- on the house line's clip */
      _tourAsmStep(_tourTypeStep('park-build', 1, 9, 'oak', { mp3: 'tour-assembly', same: true, cam: { az: 0.95, el: 0.30 }, target: 'cf-btn-assembly',
        show: function (cb, run, done) {
          if (_T.once.pbuild) { _tourLater(cb, 300, run); return; }
          _T.once.pbuild = 1;
          _tourAsmList(cb, run, done, _tourAsmWalk());
        } }))];
    S[7] = [_tourTypeStep('porch', 7, 8, 'white', { cam: { az: 0.95 }, target: 'cf-btn-assembly',
      show: function (cb, run, done) {
        var smT = _sofaStepMap(STATE);   /* v269: the sofa's assembly -- side frames, top ends, long rails, ledgers, platform, chains, eyes, beam */
        _tourAsm(cb, run, done, _isSofaAsm(STATE) ? [1, 3, 5, 8, 11, smT.rost, smT.chains, smT.eyes, smT.beam, 0] : null);
      } })];
    S[2] = [_tourTypeStep('sofa', 2, 5, 'birch', { cam: { az: 0.70 }, target: 'cf-btn-colors',
      show: function (cb, run) {
        _tourSeq(run, [_tpulse(['cf-btn-colors']), _tw(500, run), _tclick('cf-btn-colors'), _tw(1500, run), _tclick('cf-btn-colors'), _tw(1500, run),
          _tclick('cf-btn-colors'), _tw(1500, run), _tclick('cf-btn-colors'), _tpulse([]), _tw(900, run)], cb);
      } })];
    S[4] = [_tourTypeStep('hollywood', 4, 10, 'oak', { cam: { az: 0.85, el: 0.24 }, target: 'cf-bench-rake',
      show: function (cb, run) {
        var b0 = _swingBack(STATE);
        _tourSeq(run, [_tpulse(['cf-bench-rake']), _tsw(b0, 15, 700, _tourSlideSet, run), _tw(300, run), _tsw(15, 90, 4200, _tourSlideSet, run),
          _tpulse(['cf-btn-lvl']), _tw(1400, run), _tpulse(['cf-bench-rake']), _tsw(90, b0, 2200, _tourSlideSet, run), _tpulse([]), _tw(600, run)], cb);
      } }),
      _tourTypeStep('hollywood-build', 4, 7, 'oak', { same: true, cam: { az: 1.15, el: 0.30 }, target: 'cf-btn-assembly',
        show: function (cb, run, done) { _tourAsm(cb, run, done); } })];
    S[3] = [_tourTypeStep('wave', 3, 8, 'white', { cam: { az: 1.25, el: 0.26 }, target: 'cf-bench-rake',
      show: function (cb, run) {
        var b0 = _waveBeta(STATE);
        _tourSeq(run, [_tpulse(['cf-bench-rake']), _tsw(b0, 15, 900, _tourSlideSet, run), _tw(300, run), _tsw(15, 90, 3800, _tourSlideSet, run),
          _tw(1300, run), _tsw(90, b0, 1800, _tourSlideSet, run), _tpulse([]), _tw(600, run)], cb);
      } })];
    S[8] = [_tourTypeStep('aframe', 8, 8, 'khaki', { cam: { az: 0.80, el: 0.24 }, target: 'cf-btn-ar',
      show: function (cb, run) { _tourSeq(run, [_tonce('ar', [_tw(600, run), _tar(run)], run), _tw(1500, run)], cb); },
      end: function () { _tourArClose(); } })];
    S[5] = [_tourTypeStep('picnic', 5, 6, 'oak', { cam: { az: 0.65, el: 0.36 }, target: 'cf-btn-assembly',
      show: function (cb, run, done) { _tourAsm(cb, run, done); } })];
    S[13] = [_tourTypeStep('kids', 13, 4, 'birch', { cam: { az: 0.55, el: 0.22, k: 1.0 }, target: 'cf-handle-l',
      show: function (cb, run) {
        var L0 = STATE.L;
        _tourSeq(run, [_tpulse(['cf-handle-l']), _tsw(L0, 1.50, 800, _tourLenSet, run), _tw(600, run), _tsw(1.50, 2.50, 1100, _tourLenSet, run), _tw(600, run),
          _tsw(2.50, 3.60, 1100, _tourLenSet, run), _tw(900, run), _tsw(3.60, L0, 900, _tourLenSet, run), _tpulse([]), _tw(500, run)], cb);
      } })];
    S[9] = [_tourTypeStep('adirondack', 9, 6, 'white', { cam: { az: 0.70, el: 0.30 }, target: 'cf-handle-l',
      show: function (cb, run) {
        var L1 = ADI.SEAT_W;
        _tourSeq(run, [_tpulse(['cf-handle-l']), _tsw(L1, 2 * L1, 900, _tourLenSet, run), _tw(800, run), _tsw(2 * L1, 3 * L1, 900, _tourLenSet, run), _tw(900, run),
          _tpulse(['cf-btn-lvl']), _tclick('cf-btn-lvl'), _tw(1600, run), _tclick('cf-btn-lvl'), _tw(500, run), _tpulse(['cf-handle-l']),
          _tsw(function () { return STATE.L; }, L1, 900, _tourLenSet, run), _tpulse([]), _tw(500, run)], cb);
      } })];
    S[11] = [_tourTypeStep('tree', 11, 6, 'khaki', { cam: { az: 0.60, el: 0.42 }, target: 'cf-btn-lvl',
      show: function (cb, run) {
        _tourSeq(run, [_tw(500, run), _tpulse(['cf-btn-lvl']), _tclick('cf-btn-lvl'), _tw(1500, run), _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(1500, run),
          _tpulse(['cf-btn-lvl']), _tclick('cf-btn-lvl'), _tw(1300, run), _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tpulse([]), _tw(600, run)], cb);
      } })];
    S[10] = [_tourTypeStep('planter', 10, 7, 'oak', { cam: { az: 0.75, el: 0.30 }, target: 'cf-btn-assembly',
      show: function (cb, run, done) { _tourAsm(cb, run, done); } })];
    S[12] = [_tourTypeStep('storage', 12, 7, 'white', { cam: { az: 0.70, el: 0.30 }, target: 'cf-btn-lvl',
      show: function (cb, run) {
        _tourSeq(run, [_tonce('lid', [_tpulse(['cf-btn-lvl']), _tclick('cf-btn-lvl'), _tw(1500, run), _tclick('cf-btn-lvl'), _tpulse([]), _tw(500, run), _tar(run)], run), _tw(1500, run)], cb);
      },
      end: function () { _tourArClose(); } })];
    S[6] = [_tourTypeStep('block', 6, 6, 'birch', { cam: { az: 0.70, el: 0.30 }, target: 'cf-btn-lvl',
      show: function (cb, run) {
        _tourSeq(run, [_tpulse(['cf-btn-lvl']), _tw(400, run), _tclick('cf-btn-lvl'), _tw(1300, run), _tclick('cf-btn-lvl'), _tw(1300, run), _tclick('cf-btn-lvl'), _tw(1300, run),
          _tclick('cf-btn-lvl'), _tpulse([]), _tw(700, run)], cb);
      } })];
    /* v276 the bed: the headboard's three styles on its toggle, the height
       dragged up (the rails come in) and down, the width through the
       mattress sizes; framed tall so the drag stays in view */
    S[14] = [_tourTypeStep('bed', 14, 11, 'oak', { cam: { az: 0.70, el: 0.28 }, target: 'cf-bench-back-toggle',
      set: function () { STATE.backrestVisible = true; STATE.bedHeadStyle = 'rails'; STATE.bedHead = 1.80; },
      show: function (cb, run) {
        _tourSeq(run, [_tonce('bed', [_tourBedStyle('rails'), _tsw(function () { return _bedLayout(STATE).top; }, 1.10, 700, _tourBedHeadSet, run),
          _tpulse(['cf-bench-back-toggle']), _tw(600, run), _tclick('cf-bench-back-toggle'), _tw(1500, run), _tclick('cf-bench-back-toggle'), _tw(1500, run),
          _tpulse(['cf-handle-h']), _tsw(1.10, 1.80, 1500, _tourBedHeadSet, run), _tw(400, run), _tsw(1.80, 1.10, 900, _tourBedHeadSet, run),
          _tpulse(['cf-handle-w']), _tourBedSize(0), _tw(650, run), _tourBedSize(-1), _tw(650, run), _tourBedSize('def'), _tw(500, run),
          _tourBedStyle('rails'), _tpulse([])], run), _tw(400, run)], cb);   /* once a step, then short waits while the voice ends */
      } })];
    /* v423 the twist bench (Marek: dale hlasovy krok v pruvodci): framed from
       the front, its layout switch pulsed and tapped three times -- the
       armchairs, the chairs round the side table, the bench again (each tap
       its own 2.4 s turn of the slats); once a step, then short waits */
    S[54] = [_tourTypeStep('twist', 54, 11, 'oak', { cam: { az: 0.80, el: 0.30 }, target: 'cf-bench-back-toggle',
      set: function () { STATE.rtbMode = 'bench'; STATE.L = RTB.L_DEF; },
      show: function (cb, run) {
        _tourSeq(run, [_tonce('twist', [_tpulse(['cf-bench-back-toggle']), _tw(900, run),
          _tclick('cf-bench-back-toggle'), _tw(3100, run), _tclick('cf-bench-back-toggle'), _tw(3100, run),
          _tclick('cf-bench-back-toggle'), _tw(2700, run), _tpulse([])], run), _tw(400, run)], cb);
      } })];
    return S;
  }
  /* THE INTRO: one reference design of every type, a cut every 0.8 s, from
     a slightly different side each time; then one turn of the last */
  var _TOUR_INTRO = { key: 'intro', mp3: 'bench-tour-intro', sec: 9, lead: 300,
    start: function () {
      _tourSpin(false);
      var seen = {}, R = refSet(), order = _tourSlots(), L = [];
      order.forEach(function (t) { for (var i = 0; i < R.length; i++) if (R[i].t === t && !seen[t]) { seen[t] = 1; L.push(R[i]); } });
      _T.refs = L; _T.refAt = 0; _T.turned = false;
      _tlog('tour     intro: ' + L.length + ' reference design(s), one of every type (' + L.map(function (r) { return r.id; }).join(', ') + ')');
    },
    cycle: function (cb, run) {
      if (_T.refAt < (_T.refs || []).length) {
        var k = _T.refAt++, r = _T.refs[k];
        try { _tourArClose(); refApply(r, true); _T.dirty = true; _tourFrame({ ms: 0, az: 0.55 + 0.11 * (k % 6), el: 0.28 }, run); }
        catch (eR) { _tlog('tour     intro: reference ' + r.id + ' THREW ' + ((eR && eR.message) || eR)); }
        _tourLater(cb, 800, run);
        return;
      }
      if (!_T.turned) {
        _T.turned = true;
        _tourTurn(5200, run, function () { _tourSpin(true); _tourLater(cb, 200, run); });
        return;
      }
      _tourLater(cb, 600, run);
    },
    end: function () {} };
  /* THE OUTRO: the Hollywood swing as the bed (the reference h3), the PDF
     and the budget icons lit, one turn */
  var _TOUR_OUTRO = { key: 'outro', mp3: 'bench-tour-outro', sec: 8, lead: 900, tip: ['open_budget', ''],
    target: function () { return _tqBudget(); },
    start: function (run) {
      _tourArClose();
      var R = refSet(), h = null, i;
      for (i = 0; i < R.length; i++) if (R[i].id === 'h3') h = R[i];
      if (!h && R.length) h = R[0];
      if (h) { try { refApply(h); _T.dirty = true; } catch (e) {} }
      _tourFrame({ az: 0.85, el: 0.26 }, run);
      _tourSpin(true);
      _tourPulse([_tq('cf-btn-pdf'), _tqBudget()]);
      _T.turned = false;
    },
    cycle: function (cb, run) {
      if (!_T.turned) { _T.turned = true; _tourTurn(6500, run, function () { _tourSpin(true); _tourLater(cb, 300, run); }); return; }
      _tourLater(cb, 700, run);
    },
    end: function () { _tourPulse([]); } };
  /* v276 THE BED REEL (Marek 2026-10-16: s ?ig budu chtit udelat post pro
     socialni site, pruvodce tomu prizpusobit; jen EN): on an English ?ig
     page with the bed on the stage, PLAY runs the bed alone, about 45 s --
     the hook over quick cuts of beds, the headboard's three styles, the
     height dragged up with the rails coming in, the width through the
     mattress sizes, the assembly, the outro. US units for the run (the
     voice says twin .. king, six and a half feet); the visitor's design and
     units come back at the end like every tour. Clips ig-bed-* (leva-workers
     voice run 40). Any other page: the whole tour, the bed in it. */
  var BED_REEL_CUTS = [
    { id: 'bed-cut-1', t: 14, c: 'birch', mw: 1.6, hs: 'rails', hh: 1.10 }, { id: 'bed-cut-2', t: 14, c: 'white', mw: 1.4, hs: 'slats', hh: 1.30 },
    { id: 'bed-cut-3', t: 14, c: 'oak', mw: 1.8, hs: 'cross', hh: 1.50 }, { id: 'bed-cut-4', t: 14, c: 'khaki', mw: 2.0, hs: 'rails', hh: 1.75 },
    { id: 'bed-cut-5', t: 14, c: 'birch', mw: 1.2, hs: 'cross', hh: 1.95 }, { id: 'bed-cut-6', t: 14, c: 'white', mw: 0.9, hs: 'slats', hh: 1.00 }
  ];
  function _tourBedReel() { return _tourIg() && _tourLang() === 'en' && (STATE.variant | 0) === 14 && _tourSlots().indexOf(14) >= 0; }
  function _tourBedReelSteps() {
    var us = function () { STATE.isMetric = false; };
    var bedSet = function (hs, mw, hh) { return function () { us(); STATE.backrestVisible = true; STATE.bedHeadStyle = hs; STATE.bedMW = mw; STATE.bedHead = hh; }; };
    var intro = { key: 'bed-intro', mp3: 'ig-bed-intro', sec: 8, lead: 300, tip: ['variant_v14', ''],
      start: function () {
        _tourSpin(false); us();
        _T.refs = BED_REEL_CUTS.slice(0); _T.refAt = 0; _T.turned = false;
        _tlog('tour     bed reel (?ig, en): hook over ' + _T.refs.length + ' cuts of the bed, US units for the run');
      },
      cycle: _TOUR_INTRO.cycle,
      end: function () {} };
    var head = _tourTypeStep('bed-head', 14, 7, 'white', { mp3: 'ig-bed-head', cam: { az: 0.62, el: 0.26 }, target: 'cf-bench-back-toggle', set: bedSet('rails', 1.6, 1.30),
      show: function (cb, run) {
        _tourSeq(run, [_tonce('head', [_tourBedStyle('rails'), _tpulse(['cf-bench-back-toggle']), _tw(1000, run), _tclick('cf-bench-back-toggle'), _tw(2000, run),
          _tclick('cf-bench-back-toggle'), _tw(1800, run), _tpulse([])], run), _tw(400, run)], cb);
      } });
    var height = _tourTypeStep('bed-height', 14, 7, 'oak', { mp3: 'ig-bed-height', cam: { az: 0.80, el: 0.20 }, target: 'cf-handle-h', set: bedSet('rails', 1.6, 2.00),
      show: function (cb, run) {
        _tourSeq(run, [_tonce('height', [_tsw(function () { return _bedLayout(STATE).top; }, 0.80, 800, _tourBedHeadSet, run), _tpulse(['cf-handle-h']), _tw(300, run),
          _tsw(0.80, 2.00, 3800, _tourBedHeadSet, run), _tw(900, run), _tsw(2.00, 1.25, 1300, _tourBedHeadSet, run), _tpulse([])], run), _tw(400, run)], cb);
      } });
    var width = _tourTypeStep('bed-width', 14, 6, 'khaki', { mp3: 'ig-bed-width', cam: { az: 0.52, el: 0.42 }, target: 'cf-handle-w', set: bedSet('cross', 2.0, 1.20),
      show: function (cb, run) {
        _tourSeq(run, [_tonce('width', [_tpulse(['cf-handle-w']), _tourBedSize(-1), _tw(700, run), _tourBedSize(-2), _tw(700, run), _tourBedSize(2), _tw(700, run), _tourBedSize(1), _tw(700, run),
          _tourBedSize(0), _tw(1100, run), _tourBedSize(1), _tw(500, run), _tourBedSize('def'), _tw(600, run), _tpulse([])], run), _tw(400, run)], cb);
      } });
    var build = _tourTypeStep('bed-build', 14, 9, 'birch', { mp3: 'ig-bed-build', cam: { az: 1.00, el: 0.34 }, target: 'cf-btn-assembly', set: bedSet('slats', 1.6, 1.20),
      show: function (cb, run, done) {
        var sm = _sofaStepMap(STATE), seq = [1, 3, 5, 8, 11, sm.rost, sm.matt, 0];   /* exploded, the side frames, the top rail, closed, the ledgers, the slats, the mattress (~10 s) */
        _tourAsm(cb, run, done, seq);
      } });
    var outro = { key: 'bed-outro', mp3: 'ig-bed-outro', sec: 7, lead: 600, tip: ['open_budget', ''],
      target: function () { return _tqBudget(); },
      start: function (run) {
        _tourArClose();
        try { refApply({ t: 14, c: 'oak', mw: 1.6, hs: 'cross', hh: 1.40 }); us(); _designShow(); _T.dirty = true; } catch (e) {}
        _tourFrame({ az: 0.85, el: 0.26 }, run);
        _tourSpin(true);
        _tourPulse([_tq('cf-btn-pdf'), _tqBudget()]);
        _T.turned = false;
      },
      cycle: _TOUR_OUTRO.cycle,
      end: function () { _tourPulse([]); } };
    [head, height, width, build].forEach(function (x) { x.has = function () { return true; }; });
    return [intro, head, height, width, build, outro];
  }
  /* bench-v280 THE ?ig REEL (voice tour thread, as core-v720 -- Marek
     2026-10-19: ig prezentaci ve vsech projektech, highlights do 60 vterin;
     na zacatku rychle par designs i barevne varianty, rozpocet, AI agent;
     zacatek stejny na ig i na webu, catchy): an English ?ig page without the
     bed on the stage plays the highlights only, about 45 s -- the hook over
     a cut of every type every 0.55 s (no turn), the sofa's colours, the
     Hollywood's back from upright to day bed, the picnic table's assembly,
     the budget drawer run down, the assistant, the outro. Clips:
     ig-intro-benches, ig-bench-colors, ig-bench-shape (leva-workers voice
     run 42), ig-assembly, ig-budget, ig-ai, ig-outro (the core's reel). A
     type the storefront does not sell is passed by as before. */
  function _tourIgReel() { return (_tourIg() || _tourHook() === 'ig-intro-garden') && !_tourBedReel(); }   /* v347 every language; GARDEN STRUCTURES' web tour too (no per-type steps of its own) */
  var _TOUR_IG_INTRO = { key: 'intro', mp3: 'bench-tour-intro', sec: 8, lead: 300,
    start: function (run) { _TOUR_INTRO.start(run); },
    cycle: function (cb, run) {
      var R = _T.refs || [];
      if (!R.length) { _tourLater(cb, 300, run); return; }
      var k = _T.refAt++, r = R[k % R.length];   /* round again while the hook goes on */
      try { _tourArClose(); refApply(r, true); _T.dirty = true; _tourFrame({ ms: 0, az: 0.55 + 0.11 * (k % 6), el: 0.28 }, run); }
      catch (eR) { _tlog('tour     intro: reference ' + r.id + ' THREW ' + ((eR && eR.message) || eR)); }
      _tourLater(cb, 550, run);
    },
    end: function () {} };
  /* the budget drawer and the assistant, as the core's rail opens them */
  function _tourBudScroller() {
    var el = global.document.querySelector('#Budget-Drawer [data-budget-sections]') || global.document.querySelector('#Budget-Drawer .budget-drawer__body');
    while (el && el !== global.document.body) {
      var cs = global.getComputedStyle(el);
      if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 2) return el;
      el = el.parentElement;
    }
    return null;
  }
  function _tourBudOpen() {
    try {
      var d = global.document.getElementById('Budget-Drawer');
      if (d && d.classList.contains('active')) return;
      global.openBudgetMainDrawer();
      _T.budOpen = true;
      var sc = _tourBudScroller();
      _T.budY0 = sc ? sc.scrollTop : 0;
      _tlog('tour     budget: the drawer opened');
    } catch (e) { _tlog('tour     budget: the drawer did not open (' + ((e && e.message) || e) + ')'); }
  }
  /* the item the budget step opens (bench-v335, Marek: neotevira se drawer s
     item detail, interierove dvere vsude nejsou -- vzdy vybrat druhou polozku
     v rozpoctu): the budget's SECOND item with a price, else its first */
  function _tourBudRow(open) {
    var ALL = [].slice.call(global.document.querySelectorAll('#Budget-Drawer .budget-item[data-item-id]')).filter(function (el) {
      return String(el.getAttribute('data-mat-status') || '') !== 'empty';
    });
    var L = ALL.filter(function (el) { return el.offsetParent !== null; });
    /* bench-v347 (Marek 13:59: KVH16160 se neotevrel): budget-core shows only its FIRST section open, the rest collapsed (display none) -- the
       framing row is looked for in every section; with open set, its collapsed section is opened (its own header, as a tap) for the step
       and shut again at the step's end (_tourBudSecBack) */
    var frA = ALL.filter(function (el) { return /^KV[HRIPGL]\d/.test(String(el.getAttribute('data-item-id') || '')); });
    if (frA.length) {
      var row0 = frA[0];
      if (row0.offsetParent !== null) return row0;
      var blk = row0.closest ? row0.closest('.budget-section-block') : null, hd = blk ? blk.querySelector('.budget-section-header') : null;
      if (!open) return row0;   /* asked ahead (its offers warmed) -- not opened yet */
      if (blk && hd && blk.classList.contains('budget-section-block--collapsed')) {
        try { hd.click(); } catch (eH) {}
        if (!blk.classList.contains('budget-section-block--collapsed')) { _T.budSec = hd; _tlog('tour     budget: the section of ' + row0.getAttribute('data-item-id') + ' opened for the step'); }
      }
      if (row0.offsetParent !== null) return row0;
      _tlog('tour     budget: ' + row0.getAttribute('data-item-id') + ' not on screen even with its section open -- the item before');
    }
    /* bench-v346 (Marek 2026-10-22 13:21: otevrit nejaky framing item -- ty maji vzdy nejakou nabidku z eshops): dimensional lumber first
       (KVH / KVR / KVI / KVP / KVG / KVL codes), the first such row; else the second item as before */
    return L[1] || L[0] || null;
  }
  /* bench-v347 the section the step opened, shut again (as the visitor had it) */
  function _tourBudSecBack() {
    var hd = _T.budSec;
    _T.budSec = null;
    if (!hd) return;
    try { var blk = hd.closest ? hd.closest('.budget-section-block') : null; if (blk && !blk.classList.contains('budget-section-block--collapsed')) hd.click(); } catch (e) {}
  }
  /* the offers of the item the step will open, asked for ahead and their
     pictures fetched, so the card's own request finds them in the
     browser's cache (container-v560, bench-v335) */
  function _tourBudWarm(id) {
    if (!id || _T.budWarm === id) return;
    _T.budWarm = id;
    /* and the stores' table: the card waits for it behind a loader before it
       draws anything (container-v562) */
    try {
      if (typeof global.fetchVendorsCsv === 'function' && !(Array.isArray(global.vendorList) && global.vendorList.length)) {
        var tV = _tourNow();
        global.fetchVendorsCsv().then(function (L) { _tlog('tour     budget: the stores table asked ahead -- ' + ((L && L.length) || 0) + ' store(s) in ' + ((_tourNow() - tV) / 1000).toFixed(1) + ' s'); })['catch'](function () {});
      }
    } catch (eV) {}
    var cty = 'US';
    try { if (global.Shopify && global.Shopify.country && /^[A-Z]{2}$/.test(global.Shopify.country)) cty = global.Shopify.country; } catch (eC) {}
    try {
      global.fetch('https://leva-scrape.long-cloud-d006.workers.dev/price/offers?item=' + encodeURIComponent(id) + '&country=' + cty)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var L = (d && d.offers) || [], n = 0, i;
          for (i = 0; i < L.length && n < 12; i++) if (L[i] && L[i].image) { var im = new global.Image(); im.src = L[i].image; n++; }
          _tlog('tour     budget: ' + id + ' -- ' + L.length + ' offer(s) asked ahead, ' + n + ' picture(s) loading');
        })['catch'](function () {});
    } catch (eW) {}
  }
  /* has the opened card loaded (container-v562): the card drawn -- not its
     loader (the card shows a spinner while the stores' table comes, and
     with no list on screen yet the old test said 'loaded' at once, so the
     card was shut a moment after its content arrived) -- its offers' list
     past 'Searching...', and its pictures in */
  function _tourBudCardState() {
    var dr = global.document.getElementById('Custom-Drawer');
    if (!dr || !dr.classList.contains('active')) return { open: false, ready: false, say: 'card not open' };
    var vis = function (el) { return !!(el && el.offsetParent !== null); };
    var loader = dr.querySelector('.affiliate-immersive-loader');
    var detail = dr.querySelector('.leva-detail, .affiliate-product-card, .affiliate-empty-card');
    var panel = dr.querySelector('[data-search-panel][data-input-id]:not([data-input-id=""])');
    var res = panel ? panel.querySelector('[data-search-results]') : null, hint = res ? res.querySelector('.leva-search-hint') : null;
    var tiles = res ? res.children.length - (hint ? 1 : 0) : 0;
    var searching = !!(hint && /\u2026|\.\.\./.test(hint.textContent || ''));
    var imgs = [].slice.call(dr.querySelectorAll('img')), pend = imgs.filter(function (im) { return vis(im) && !im.complete; }).length;
    var ready = !vis(loader) && !!detail && !searching && pend === 0;
    return { open: true, ready: ready, tiles: tiles, panel: panel,
             say: (vis(loader) ? 'loader up, ' : '') + (detail ? '' : 'no detail yet, ') + tiles + ' offer tile(s), ' + pend + ' picture(s) pending' +
                  (hint ? (', hint "' + String(hint.textContent || '').slice(0, 24) + '"') : '') + (panel ? (panel.hidden ? ', offers panel shut' : ', offers panel open') : ', no offers panel') };
  }
  /* the card's own scroll: the offers -- the stores' chips and the products
     -- brought up under the item (container-v562, Marek: u detailu polozky
     sjet nize, at jsou videt nabidky vendors / jine produkty) */
  function _tourBudCardOffers() {
    var dr = global.document.getElementById('Custom-Drawer');
    if (!dr || !dr.classList.contains('active')) return false;
    var vis = function (el) { return !!(el && el.offsetParent !== null); };
    var panel = dr.querySelector('[data-search-panel][data-input-id]:not([data-input-id=""])');
    if (!vis(panel)) return false;
    var vend = panel.querySelector('[data-search-vendors]');
    var tgt = vis(vend) && vend.children.length ? vend : panel;
    try { tgt.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { try { tgt.scrollIntoView(); } catch (e2) {} }
    return true;
  }
  /* THE PRICE BAR IN THE TOUR (container-v563). Three stores of the bar --
     Home Depot, Lowe's and Walmart where the market has them, else the
     bar's first stores -- tapped on, then CHEAPEST: the bar's own preview
     of the whole budget at those stores' cheapest prices. Only on a bar the
     visitor has not touched (no store, no rule on); APPLY is never pressed;
     every tap is taken back at the end. Taps are made on the bar as it is
     at that moment -- it is drawn anew after each one. */
  function _tourBudBar() {
    var b = global.document.querySelector('#Budget-Drawer [data-leva-pricebar]') || global.document.querySelector('[data-leva-pricebar]');
    return (b && !b.hidden && b.offsetParent !== null) ? b : null;
  }
  function _tourBudFilterPlan() {
    _T.budFilt = null;
    var b = _tourBudBar();
    if (!b) { _tlog('tour     budget: no price bar on screen -- the filter is not shown'); return null; }
    if (b.querySelector('.leva-pricebar__vend.is-on, [data-leva-key].is-on, [data-leva-src].is-on')) {
      _tlog('tour     budget: the price bar is already set by the visitor -- left alone');
      return null;
    }
    var tiles = [].slice.call(b.querySelectorAll('[data-leva-vend]')).filter(function (el) {
      var k = String(el.getAttribute('data-leva-vend') || '');
      return el.offsetParent !== null && !el.querySelector('.leva-pricebar__tag') && !/^\d+$/.test(k);
    }).map(function (el) { return String(el.getAttribute('data-leva-vend') || ''); });
    var want = [/homedepot|home ?depot/i, /lowes/i, /walmart/i], out = [], i, k;
    for (i = 0; i < want.length; i++) for (k = 0; k < tiles.length; k++) if (want[i].test(tiles[k]) && out.indexOf(tiles[k]) < 0) { out.push(tiles[k]); break; }
    for (k = 0; k < tiles.length && out.length < 3; k++) if (out.indexOf(tiles[k]) < 0) out.push(tiles[k]);
    if (!out.length || !b.querySelector('[data-leva-key="cheap"]')) { _tlog('tour     budget: the price bar has no stores / no cheapest -- the filter is not shown'); return null; }
    _T.budFilt = { vend: out, on: [], key: false };
    _tlog('tour     budget: the price bar -- stores ' + out.join(', ') + ' then cheapest (a preview; APPLY not pressed)');
    return out;
  }
  function _tourBudBarShow(sc) {
    var b = _tourBudBar();
    if (!b || !sc) return;
    try {
      var y = sc.scrollTop + (b.getBoundingClientRect().top - sc.getBoundingClientRect().top) - 16;
      sc.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    } catch (e) {}
  }
  function _tourBudTap(sel, val) {
    var F = _T.budFilt, b = _tourBudBar();
    if (!F || !b) return false;
    var attr = (sel === '[data-leva-vend]') ? 'data-leva-vend' : 'data-leva-key';
    var el = [].slice.call(b.querySelectorAll(sel)).filter(function (x) { return x.getAttribute(attr) === val; })[0];
    if (!el) { _tlog('tour     budget: ' + val + ' not on the price bar any more'); return false; }
    try { el.click(); } catch (e) { return false; }
    if (attr === 'data-leva-vend') { if (F.on.indexOf(val) < 0) F.on.push(val); else F.on.splice(F.on.indexOf(val), 1); }
    else F.key = !F.key;
    return true;
  }
  function _tourBudFilterOff(why) {
    var F = _T.budFilt;
    if (!F) return;
    var vend = F.on.slice().reverse(), i;
    for (i = 0; i < vend.length; i++) _tourBudTap('[data-leva-vend]', vend[i]);
    var b = _tourBudBar(), chip = b ? b.querySelector('[data-leva-key="cheap"]') : null;
    if (chip && chip.classList.contains('is-on')) { try { chip.click(); } catch (e) {} }
    _T.budFilt = null;
    _tlog('tour     budget: the price bar put back (' + why + ')' + ((b && b.querySelector('.leva-pricebar__vend.is-on, [data-leva-key].is-on')) ? ' -- SOMETHING IS STILL ON' : ''));
  }
  /* bench-v348 THE ITEM CARD'S STORE FILTER (drawer.js: the tiles [data-search-vend] in [data-search-vendors]; a tap toggles its store in
     panel.dataset.vendors and the list is drawn anew): the first and the third tile turned on as a preview, put back after */
  function _tourBudVendPanel() {
    var dr = global.document.getElementById('Custom-Drawer');
    if (!dr || !dr.classList.contains('active')) return null;
    var p = dr.querySelector('[data-search-panel][data-input-id]:not([data-input-id=""])');
    return (p && p.offsetParent !== null) ? p : null;
  }
  function _tourBudVendOn(p) { return String((p && p.dataset.vendors) || '').split(',').filter(Boolean); }
  function _tourBudVendTile(p, k) { return [].slice.call(p.querySelectorAll('[data-search-vend]')).filter(function (x) { return x.getAttribute('data-search-vend') === k; })[0] || null; }
  function _tourBudVendPlan() {
    _T.budVend = null;
    var p = _tourBudVendPanel();
    if (!p) return null;
    var keys = [].slice.call(p.querySelectorAll('[data-search-vendors] [data-search-vend]')).filter(function (x) { return x.offsetParent !== null; })
      .map(function (x) { return x.getAttribute('data-search-vend'); });
    if (keys.length < 2) { _tlog('tour     budget: the card has ' + keys.length + ' store tile(s) -- no filter to show'); return null; }
    var tg = (keys.length >= 3) ? [keys[0], keys[2]] : [keys[0], keys[1]];
    _T.budVend = { p: p, on0: _tourBudVendOn(p), tg: tg };
    _tlog('tour     budget: the card\'s store filter -- ' + tg.join(' + ') + ' on (tiles: ' + keys.join(', ') + '; on before: ' + (_T.budVend.on0.join(', ') || 'none') + ')');
    return tg;
  }
  function _tourBudVendTap(k) {
    var F = _T.budVend;
    if (!F || !F.p || !F.p.isConnected) return;
    var b = _tourBudVendTile(F.p, k);
    if (!b) { _tlog('tour     budget: the tile ' + k + ' is gone'); return; }
    _tourPulse([b]);   /* pulsed even when it is on already (the card's Amazon preselection) */
    if (_tourBudVendOn(F.p).indexOf(k) >= 0) _tlog('tour     budget: ' + k + ' already on -- pulsed only');
    else { try { b.click(); } catch (e) {} }
    _tourLater(function () { _tourPulse([]); }, 700, _T.run);
  }
  function _tourBudVendBack() {
    var F = _T.budVend;
    _T.budVend = null;
    if (!F || !F.p || !F.p.isConnected) return;
    var cur = _tourBudVendOn(F.p), flip = [], i;
    for (i = 0; i < cur.length; i++) if (F.on0.indexOf(cur[i]) < 0) flip.push(cur[i]);
    for (i = 0; i < F.on0.length; i++) if (cur.indexOf(F.on0[i]) < 0) flip.push(F.on0[i]);
    flip.forEach(function (k) { var b = _tourBudVendTile(F.p, k); if (b) { try { b.click(); } catch (e) {} } });
    var now = _tourBudVendOn(F.p).slice().sort().join(','), was = F.on0.slice().sort().join(',');
    _tlog('tour     budget: the card\'s store filter put back' + (now === was ? '' : (' -- STILL DIFFERENT (' + now + ' / was ' + was + ')')));
  }
  function _tourBudItemClose() {
    if (!_T.budItem) return;
    _T.budItem = false;
    try {
      var dr = global.document.getElementById('Custom-Drawer');
      if (!dr || !dr.classList.contains('active')) return;
      var x = dr.querySelector('side-panel-close') || dr.querySelector('.side-panel-close');
      if (x) x.click();
    } catch (e) {}
  }
  function _tourBudClose() {
    if (!_T.budOpen) return;
    _T.budOpen = false;
    try { var sc = _tourBudScroller(); if (sc) sc.scrollTop = _T.budY0 || 0; } catch (eS) {}
    try { if (typeof global.closeBudgetMainDrawer === 'function') global.closeBudgetMainDrawer(); } catch (e) {}
  }
  function _tourAiClose() {
    if (!_T.aiOpen) return;
    _T.aiOpen = false;
    try {
      if (_T.aiDemo && global.LevaAI && typeof global.LevaAI.demoStop === 'function') global.LevaAI.demoStop();   /* v361 the demo's card shut, the drawer as it was */
      else if (global.LevaAI && typeof global.LevaAI.close === 'function') global.LevaAI.close();
    } catch (e) {}
    _T.aiDemo = false;
  }
  /* bench-v358 THE BUDGET STEP of the ?ig reels (was inside _tourIgSteps): the ?ig reel's as bench-v335..v348;
     the ?ig2 cinema bar reel's tighter -- shorter waits between the stores' taps, a quicker run down, the card
     held 2.8 s on its offers without the store filter's taps (about 15 s against 22 s) */
  function _tourBudgetStep() {
    return { key: 'budget', mp3: 'ig-budget', sec: 6, lead: 1200, holdMax: 30000,   /* v348 26 -> 30 s (+ the store filter) */
      hold: function () { return !!_T.budBusy; },
      start: function (run) {
        _tourArClose();
        var L = [global.document.querySelector('.leva-float-group .leva-act--budget'), global.document.querySelector('[data-bstrip-mine-total]')]
          .filter(function (el) { return el && el.offsetParent !== null; });
        var can = (typeof global.openBudgetMainDrawer === 'function');
        if (!L.length && !can) { _T.skip = 'no budget on the page'; return; }
        _T.budRan = false;
        _tourPulse(L);
        if (can) _tourLater(function () { _tourPulse([]); _tourBudOpen(); }, _tourIg() ? 700 : 1200, run);
      },
      cycle: function (cb, run) {
        if (_T.budRan || !_T.budOpen) { _T.budBusy = false; _tourLater(cb, 600, run); return; }
        _T.budRan = true;
        var sc = _tourBudScroller();
        if (!sc) { _T.budBusy = false; _tourLater(cb, 600, run); return; }
        _T.budBusy = true;
        var ig = _tourIg(), ig2 = (_T.reel === 'ig2'), d = global.document;   /* v358 the ?ig2 reel tighter */
        /* 1 the dashboard: the top of the drawer, its total and its cards */
        sc.scrollTop = 0;
        _tlog('tour     budget: the dashboard held');
        /* the item's offers asked for and their pictures loaded while the
           dashboard is held, so its card opens full (container-v560) */
        var rowW = _tourBudRow();
        if (rowW) _tourBudWarm(rowW.getAttribute('data-item-id'));
        /* 1b THE BUDGET SET ALL AT ONCE (container-v563, Marek: zapnout
           filtr v zahlavi budgetu, treba tri vendors Home Depot / Lowe's /
           Walmart, a zapnout cheapest): the price bar brought up, three
           stores tapped on one by one, then CHEAPEST -- the budget shows
           those stores' cheapest prices as a preview; APPLY is never pressed
           and the bar is put back at the end of the step */
        var tF = ig2 ? 1500 : (ig ? 2600 : 3400), STEP = ig2 ? 480 : (ig ? 650 : 900), plan = _tourBudFilterPlan();
        if (plan) {
          _tourLater(function () { _tourBudBarShow(sc); }, tF, run);
          plan.forEach(function (k, ix) {
            _tourLater(function () { _tourBudTap('[data-leva-vend]', k); }, tF + 700 + ix * STEP, run);
          });
          _tourLater(function () { _tourBudTap('[data-leva-key]', 'cheap'); }, tF + 700 + plan.length * STEP, run);
          tF += 700 + (plan.length + 1) * STEP + (ig2 ? 1100 : (ig ? 1600 : 2400));
        }
        _tourLater(function () {
          /* 2 down the items to the budget's second item (bench-v335) */
          var row = _tourBudRow(true), sr = sc.getBoundingClientRect(), y0 = sc.scrollTop, y1;   /* v347 its section opened if collapsed */
          if (row) y1 = Math.max(0, Math.min(sc.scrollHeight - sc.clientHeight, y0 + (row.getBoundingClientRect().top - sr.top) - sc.clientHeight * 0.4));
          else y1 = Math.max(0, Math.min(sc.scrollHeight - sc.clientHeight, Math.round((sc.scrollHeight - sc.clientHeight) * 0.6)));
          var MS = ig2 ? 1400 : (ig ? 2000 : 3200), t0 = _tourNow();
          var run2 = function () {
            if (run !== _T.run) return;
            var f = Math.min(1, (_tourNow() - t0) / MS), e = f < 0.5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
            sc.scrollTop = Math.round(y0 + (y1 - y0) * e);
            if (f < 1) { global.requestAnimationFrame(run2); return; }
            if (!row) { _tourBudFilterOff('no item to open'); _T.budBusy = false; _tourLater(cb, 400, run); return; }
            /* 3 the row opened, its card held and shut */
            var rid = row.getAttribute('data-item-id');
            _tlog('tour     budget: item ' + rid + ' (' + (row.getAttribute('data-mat-status') || '?') + ') opened');
            _tourLater(function () {
              try { row.click(); _T.budItem = true; } catch (eC) {}
              /* THE CARD SHOWN WHEN IT HAS LOADED (container-v560/v562,
                 Marek: cas na nacteni polozky je porad kratky, objevila se
                 jen na setinu sekundy): the card's loader gone, the item
                 drawn, its offers past 'Searching...' and the pictures in --
                 at most 10 s of waiting; a card that has not opened after
                 1.5 s is opened the budget's own way. Then the item held,
                 the card run down to the stores and their products, those
                 held, and only then shut. A card shut by anything else on
                 the way is said in the log. */
              var tOpen = _tourNow(), retried = false;
              var wait = function () {
                if (run !== _T.run) return;
                var st = _tourBudCardState(), waited = _tourNow() - tOpen;
                if (!st.open && !retried && waited > 1500) {
                  retried = true;
                  var okF = false;
                  try { okF = (typeof global.openItemDrawerFast === 'function') && !!global.openItemDrawerFast(rid); } catch (eF) { okF = false; }
                  _tlog('tour     budget: the card had not opened after ' + (waited / 1000).toFixed(1) + ' s -- asked again ' + (okF ? '(openItemDrawerFast)' : '(nothing to ask: no opener)'));
                }
                if (!st.ready && waited < 10000) { _tourLater(wait, 200, run); return; }
                _tlog('tour     budget: the item card ' + (st.ready ? 'loaded' : 'still loading') + ' after ' + (waited / 1000).toFixed(1) + ' s (' + st.say + ')');
                var tShown = _tourNow(), lost = false;
                var guard = function () {
                  if (run !== _T.run || !_T.budItem || lost) return;
                  var dr2 = global.document.getElementById('Custom-Drawer');
                  if (!dr2 || !dr2.classList.contains('active')) { lost = true; _tlog('tour     budget: the item card was shut by something else ' + ((_tourNow() - tShown) / 1000).toFixed(1) + ' s after it loaded'); return; }
                  _tourLater(guard, 250, run);
                };
                guard();
                _tourLater(function () {
                  var offs = _tourBudCardOffers();
                  _tlog(offs ? 'tour     budget: the card run down to its offers (the stores and their products)' : 'tour     budget: no offers on the card to show');
                  /* bench-v348 the store filter: the first tile on, then the third, the filtered offers held */
                  var vt = (offs && !ig2) ? _tourBudVendPlan() : null, vX = vt ? 2600 : 0;   /* v358 not on the ?ig2 reel */
                  if (vt) {
                    _tourLater(function () { _tourBudVendTap(vt[0]); }, ig ? 900 : 1200, run);
                    _tourLater(function () { _tourBudVendTap(vt[1]); }, ig ? 1800 : 2300, run);
                  }
                  _tourLater(function () {
                    _tlog('tour     budget: the item card shown ' + ((_tourNow() - tShown) / 1000).toFixed(1) + ' s in all, shut now');
                    _tourBudVendBack();   /* v348 */
                    _tourBudItemClose();
                    _tourLater(function () {
                      _tourBudFilterOff('the step is over');
                      _T.budBusy = false;
                      _tourLater(cb, 600, run);
                    }, 500, run);
                  }, offs ? ((ig2 ? 2800 : (ig ? 3500 : 4500)) + vX) : (ig ? 1500 : 2000), run);
                }, ig2 ? 1500 : (ig ? 2000 : 2600), run);
              };
              _tourLater(wait, 500, run);
            }, ig2 ? 450 : (ig ? 600 : 900), run);
          };
          global.requestAnimationFrame(run2);
        }, tF, run);
      },
      end: function () { _T.budBusy = false; _tourBudVendBack(); _tourBudItemClose(); _tourBudFilterOff('the step ended'); _tourBudSecBack(); _tourBudClose(); } };   /* v347 + the section shut again; v348 + the card's filter put back */
  }
  function _tourIgSteps() {
    var colors = _tourTypeStep('colors', 2, 4, 'birch', { mp3: 'ig-bench-colors', cam: { az: 0.70 }, target: 'cf-btn-colors',
      show: function (cb, run) {
        _tourSeq(run, [_tonce('col', [_tpulse(['cf-btn-colors']), _tw(300, run), _tclick('cf-btn-colors'), _tw(850, run), _tclick('cf-btn-colors'), _tw(850, run),
          _tclick('cf-btn-colors'), _tw(850, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    var shape = _tourTypeStep('shape', 4, 6, 'oak', { mp3: 'ig-bench-shape', cam: { az: 0.85, el: 0.24 }, target: 'cf-bench-rake',
      show: function (cb, run) {
        var b0 = _swingBack(STATE);
        _tourSeq(run, [_tonce('shape', [_tpulse(['cf-bench-rake']), _tsw(b0, 15, 500, _tourSlideSet, run), _tw(200, run), _tsw(15, 90, 3000, _tourSlideSet, run),
          _tw(700, run), _tsw(90, b0, 1200, _tourSlideSet, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    /* bench-v335 (Marek 21:59: doplnit i do IG pred otevrenim budgetu
       prezentaci exploded a par kroku assembly, ukazat u varianty 1): the
       product's FIRST variant (BENCHES: the park bench) -- exploded, a few
       steps, built (_tourAsmWalk); was the picnic set's whole assembly */
    var t1 = _tourSlots()[0] || 1;
    var build = _tourAsmStep(_tourTypeStep('build', t1, 6, (t1 === 1) ? 'oak' : null, { mp3: 'ig-assembly', same: (t1 === 19), cam: { az: 0.95, el: 0.30 }, target: 'cf-btn-assembly',   /* v346 GARDEN STRUCTURES: the cinema bar of the step before, as it was left */
      show: function (cb, run, done) {
        if (_T.once.asm) { _tourLater(cb, 300, run); return; }
        _T.once.asm = 1;
        _tourAsmList(cb, run, done, _tourAsmWalk());
      } }));
    /* bench-v335 THE BUDGET STEP AS THE CONTAINER'S (container-v559..v563):
       the dashboard held, the price bar's three stores + CHEAPEST as a
       preview (never APPLY, put back), a run down to the budget's second
       item, its card opened and held until loaded, run down to its offers,
       shut -- nothing pulsed inside the budget; held past the voice */
    var budget = _tourBudgetStep();   /* v358 shared with the ?ig2 reel */
    var ai = { key: 'ai', mp3: 'ig-ai', sec: 5, lead: 1200,
      start: function (run) {
        var el = global.document.querySelector('.leva-float-group .leva-act--ai');
        var can = !!(global.LevaAI && typeof global.LevaAI.open === 'function');
        if ((!el || el.offsetParent === null) && !can) { _T.skip = 'no assistant on the page'; return; }
        if (el && el.offsetParent !== null) _tourPulse([el]);
        if (can) _tourLater(function () { _tourPulse([]); try { global.LevaAI.open(); _T.aiOpen = true; } catch (eO) {} }, 700, run);
      },
      cycle: function (cb, run) { _tourLater(cb, 300, run); },
      end: function () { _tourAiClose(); } };
    /* bench-v339 GARDEN STRUCTURES (Marek 2026-10-21 23:43: A udelej i ?ig
       pruvodce): two steps of the pergola in place of the benches' colours
       and back (a type the page does not sell is passed by, so BENCHES and
       SWINGS keep their reel) -- its INFILL (ig-garden-infill): three fields
       filled on their + discs, the switch through the five kinds, the
       spacing opened and closed on the slider; its ROOF (ig-roof): the
       footprint dragged longer, flat > gable > hip on the switch, the
       covering on */
    var peInfill = _tourTypeStep('pe-infill', 24, 6, 'pine', { mp3: 'ig-garden-infill', cam: { az: 0.80, el: 0.26 }, target: 'cf-bench-fill-toggle',
      set: function () { STATE.L = (STATE.isMetric === false) ? 3.6576 : 3.60; STATE.peW = (STATE.isMetric === false) ? 3.048 : 3.00; STATE.peRoof = 'flat'; STATE.peCov = false; STATE.peFillT = 'h'; STATE.peGap = null; STATE.peFields = {}; STATE.peFound = 'screw'; },
      show: function (cb, run) {
        var g0 = function () { return Math.round(_peGap(STATE) * 1000); };
        _tourSeq(run, [_tonce('pein', [_tw(300, run), _tpeField('f1'), _tw(450, run), _tpeField('r1'), _tw(450, run), _tpeField('r2'), _tw(500, run),
          _tpulse(['cf-bench-fill-toggle']), _tclick('cf-bench-fill-toggle'), _tw(700, run), _tclick('cf-bench-fill-toggle'), _tw(700, run), _tclick('cf-bench-fill-toggle'), _tw(700, run),
          _tclick('cf-bench-fill-toggle'), _tw(700, run),   /* h > v > trellis > slats + trellis > X + trellis: it stays on the last */
          _tpulse(['cf-bench-rake']), _tsw(g0, 130, 900, _tourPeGapSet, run), _tw(250, run), _tsw(130, 90, 600, _tourPeGapSet, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    /* bench-v346 (Marek 13:21) THE PERGOLA'S ROOF AND FOUNDATION (ig-garden-roof): the footprint dragged longer, flat > gable > hip, the
       covering on, then the toggle through its foundations (ground screws > precast footings > poured footings) */
    var peRoof = _tourTypeStep('pe-roof', 24, 6, null, { mp3: 'ig-garden-roof', same: true, cam: { az: 0.70, el: 0.24 }, target: 'cf-bench-top-toggle',
      show: function (cb, run) {
        var L0 = function () { return STATE.L; };
        _tourSeq(run, [_tonce('peroof', [_tsw(L0, (STATE.isMetric === false) ? 4.2672 : 4.20, 800, _tourLenSet, run), _tw(200, run),
          _tpulse(['cf-bench-top-toggle']), _tclick('cf-bench-top-toggle'), _tw(800, run), _tclick('cf-bench-top-toggle'), _tw(800, run),
          _tpulse(['cf-bench-cov-toggle']), _tclick('cf-bench-cov-toggle'), _tw(900, run),
          _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(1100, run), _tclick('cf-bench-back-toggle'), _tw(1100, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    /* bench-v346 THE COLD FRAME (ig-garden-bed): the raised bed with wings from 1.80 x 0.90 dragged to 3.00 x 1.30 and back to 2.40, a wing lifted */
    var rbWings = _tourTypeStep('rb-wings', 20, 6, 'pine', { mp3: 'ig-garden-bed', cam: { az: 0.72, el: 0.30 }, target: 'cf-bench-back-toggle',
      set: function () { var us = (STATE.isMetric === false); STATE.rbMode = 'wings'; STATE.L = us ? 1.8288 : 1.80; STATE.rbW = us ? 0.9144 : 0.90; STATE.rbN = 2; STATE.rbOpen = false; STATE.rbTrellis = true; },
      show: function (cb, run) {
        var us = (STATE.isMetric === false), L0 = function () { return STATE.L; }, W0 = function () { return _rbW(STATE); };
        _tourSeq(run, [_tonce('rbw', [_tw(250, run), _tpulse(['cf-handle-l']), _tsw(L0, us ? 3.048 : 3.00, 1300, _tourLenSet, run), _tw(200, run), _tsw(us ? 3.048 : 3.00, us ? 2.4384 : 2.40, 700, _tourLenSet, run),
          _tpulse(['cf-handle-w']), _tsw(W0, us ? 1.2192 : 1.30, 900, _tourRbWSet, run), _tw(300, run),
          _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(1800, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    /* bench-v346 THE CINEMA BAR (ig-garden-bar): the beams dragged longer, the screen rolled down (its own roll, up to 4 s) */
    var gsBar = _tourTypeStep('gs-bar', 19, 6, 'oak', { mp3: 'ig-garden-bar', cam: { az: 0.80, el: 0.20 }, target: 'cf-bench-back-toggle',
      set: function () { var R = _gsRange(STATE); STATE.L = Math.round((R.min + 0.25 * (R.max - R.min)) * 1000) / 1000; STATE.gsScreen = false; },
      show: function (cb, run) {
        var L0 = function () { return STATE.L; }, L1 = function () { var R = _gsRange(STATE); return R.min + 0.85 * (R.max - R.min); };
        _tourSeq(run, [_tonce('gsbar', [_tw(250, run), _tpulse(['cf-handle-l']), _tsw(L0, L1, 1400, _tourLenSet, run), _tw(300, run),
          _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(3200, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    var outro = {}, k;
    for (k in _TOUR_OUTRO) if (_TOUR_OUTRO.hasOwnProperty(k)) outro[k] = _TOUR_OUTRO[k];
    outro.mp3 = 'ig-outro'; outro.sec = 5;
    _tlog('tour     ?ig reel (' + _tourLang() + (_tourIg() ? '' : ', the web tour of GARDEN STRUCTURES') + '): the highlights only -- intro (' + _tourHook() + '), colors, shape, GARDEN STRUCTURES: the cold frame, the pergola\'s infill + roof + foundation, the cinema bar, build, budget (a framing item), ai, outro -- a step whose type the page does not sell is passed by (bench-v280, v339, v346)');
    return [_TOUR_IG_INTRO, colors, shape, rbWings, peInfill, peRoof, gsBar, build, budget, ai, outro];
  }
  /* ==== THE ?ig2 CINEMA BAR REEL (bench-v358) ===============================
     Marek 2026-10-26 21:10: "Chci DNES publikovat reel na tema cinema garden
     bar. Udelej mi prosim max 60 sec ?ig2 na garden structure ktery ukaze
     editaci, assembly, AR i budget." 21:11: "Idealne pouzit stopy MP3 ktere
     uz mame, ale na zacatek urcite konkretne ke garden Cinema. Ale klidne
     udelej nove i jinde."
     GARDEN STRUCTURES' ?ig2 page (a ?ig page: no admin, large subtitles):
     the PLAY runs this reel, voiced, the cinema bar alone, the PLAY out of
     the video while it plays (a tap on its place pauses):
       hook      ig2-cinema-intro (new) -- the cinema bar, long, the screen
                 down, flies apart and back together during one turn (the
                 8-second story's first part), then drifts on;
       edit      ig-garden-bar -- from a short bar with the screen rolled up:
                 the beams dragged long, the screen rolled down;
       colours   ig-bench-colors -- the colour button twice;
       assembly  ig-assembly -- the assembly walk (its first steps, one from
                 the middle, the last, built);
       AR        ig2-cinema-ar (new) -- the AR window with its QR, shut;
       budget    ig-budget -- the stores + cheapest, a framing item's card
                 with its offers (tighter than the ?ig reel's);
       outro     ig-outro -- one turn round the finished bar.
     About 50 s with the voice. The visitor's design comes back at the end. */
  function _tourIg2Steps() {
    var us = function () { return STATE.isMetric === false; };
    var hook = { key: 'ig2-hook', mp3: 'ig2-cinema-intro', sec: 7, lead: 200, type: 19,
      tip: ['variant_v19', ''],
      target: function () { return null; },
      has: function () { return _tourSlots().indexOf(19) >= 0; },
      /* held until the turn is round, whatever the voice */
      hold: function () { return !!(_IG2.on && _IG2.hook && (_tourNow() - _IG2.hook) < 3500); }, holdMax: 4000,
      start: function (run) {
        _T.once = {};
        _tourSpin(false);
        _tourType(19, 'oak', function () {
          var R = _gsRange(STATE);
          STATE.L = Math.round((R.min + 0.85 * (R.max - R.min)) * 1000) / 1000;
          STATE.gsScreen = true;
        }, run, { ms: 0, az: 0.10, el: 0.28 });
        _tlog('tour     ig2-hook: the cinema bar, oak, L ' + (+STATE.L).toFixed(2) + ', the screen down -- apart and together during one turn');
        _tourLater(function () { _ig2Hook(run); }, 450, run);
      },
      cycle: function (cb, run) { _tourLater(cb, 300, run); },
      end: function () { _ig2End('the reel\'s hook is over', true); } };
    var edit = _tourTypeStep('ig2-edit', 19, 6, null, { mp3: 'ig-garden-bar', cam: { az: 0.80, el: 0.20 }, target: 'cf-bench-back-toggle',
      set: function () { var R = _gsRange(STATE); STATE.L = Math.round((R.min + 0.25 * (R.max - R.min)) * 1000) / 1000; STATE.gsScreen = false; },
      show: function (cb, run) {
        var L0 = function () { return STATE.L; }, L1 = function () { var R = _gsRange(STATE); return R.min + 0.85 * (R.max - R.min); };
        _tourSeq(run, [_tonce('gsbar', [_tw(200, run), _tpulse(['cf-handle-l']), _tsw(L0, L1, 1400, _tourLenSet, run), _tw(250, run),
          _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(3000, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    var colors = _tourTypeStep('ig2-colors', 19, 3, null, { mp3: 'ig-bench-colors', same: true, cam: { az: 0.55, el: 0.22, ms: 700 }, target: 'cf-btn-colors',
      show: function (cb, run) {
        _tourSeq(run, [_tonce('col', [_tpulse(['cf-btn-colors']), _tw(200, run), _tclick('cf-btn-colors'), _tw(800, run), _tclick('cf-btn-colors'), _tw(800, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    var build = _tourAsmStep(_tourTypeStep('ig2-build', 19, 6, null, { mp3: 'ig-assembly', same: true, cam: { az: 0.95, el: 0.30 }, target: 'cf-btn-assembly',
      show: function (cb, run, done) {
        if (_T.once.asm) { _tourLater(cb, 300, run); return; }
        _T.once.asm = 1;
        _tourAsmList(cb, run, done, _tourAsmWalk());
      } }));
    var ar = _tourTypeStep('ig2-ar', 19, 5, null, { mp3: 'ig2-cinema-ar', same: true, cam: { az: 0.70, el: 0.24 }, target: 'cf-btn-ar',
      show: function (cb, run) { _tourSeq(run, [_tonce('ar', [_tw(200, run), _tar(run)], run), _tw(1200, run)], cb); },
      end: function () { _tourArClose(); } });
    var budget = _tourBudgetStep();
    var outro = { key: 'outro', mp3: 'ig-outro', sec: 5, lead: 300, tip: ['open_budget', ''],
      target: function () { return null; },
      start: function (run) { _tourArClose(); _tourFrame({ az: 0.85, el: 0.24 }, run); _tourSpin(true); _T.turned = false; },
      cycle: function (cb, run) {
        if (!_T.turned) { _T.turned = true; _tourTurn(5200, run, function () { _tourSpin(true); _tourLater(cb, 300, run); }); return; }
        _tourLater(cb, 700, run);
      },
      end: function () { _tourPulse([]); } };
    _tlog('tour     ?ig2 cinema bar reel (bench-v358, ' + _tourLang() + ', ' + (us() ? 'US' : 'metric') + '): hook (ig2-cinema-intro, the exploded turn), edit (ig-garden-bar), colours (ig-bench-colors), assembly (ig-assembly), AR (ig2-cinema-ar), budget (ig-budget, tighter), outro (ig-outro) -- the aim under 60 s');
    return [hook, edit, colors, build, ar, budget, outro];
  }
  /* ==== THE ?ig2 PERGOLA SWING REEL (bench-v361) ============================
     Marek 2026-10-29 10:27: "Dalsi reel bude na tema swing, varianta 5 -
     lavice s pergolou nad. Priprav prosim reel vcetne voice over, muzes
     otevrit i agenta AI. Na ukazku boq."
     SWINGS' ?ig2 page (a ?ig page: no admin, large subtitles): the PLAY runs
     this reel, voiced, the pergola swing alone (type 17, SWINGS slot 5), the
     PLAY out of the video while it plays (a tap on its place pauses):
       hook      ig2-swing-intro (new) -- the pergola swing white, the seat
                 2.00 m (US 6 ft 6 in.), flies apart and back together during
                 one turn (the cinema bar reel's hook), then drifts on;
       edit      ig2-swing-edit (new) -- the seat dragged from 1.52 to 2.44 m
                 (US 5 > 8 ft), the beams and the rafters follow; the back
                 fill planks > slats, its gap opened on the slider and
                 eased back; the cushion put on (it starts off);
       assembly  ig-assembly -- the assembly walk: footings, posts, heads,
                 beams, rafters, the seat half built, the hanging, built (no
                 colours step: the reel is white, Marek's default for it --
                 the clips leave no room for one under 60 s);
       budget    ig-budget -- THE BoQ: the dashboard, the stores + cheapest,
                 an item's card with its offers (the cinema bar reel's tight
                 budget step);
       AI        ig2-swing-ai (new) -- the assistant's drawer in the AI reel's
                 look: "What will my swing cost?" typed, the project card from
                 the page's budget (items, material, labor, man-hours, the
                 biggest categories) -- ai.js v2.88 LevaAI.demo; an older
                 ai.js or another language: the drawer opened only;
       outro     ig-outro -- one turn round the finished swing.
     US units for the run on an English page (the voice is for the US), metric
     on any other (v404, the German reel); the budget told too.
     About 53-57 s with the voice. ?ig2=8 keeps the 8-second story. The
     visitor's design and units come back at the end. */
  function _tourIg2SwingSteps() {
    var us = function () { return STATE.isMetric === false; };
    var hook = { key: 'ig2-hook', mp3: 'ig2-swing-intro', sec: 6, lead: 200, type: 17,
      tip: ['variant_v17', ''],
      target: function () { return null; },
      has: function () { return _tourSlots().indexOf(17) >= 0; },
      /* held until the turn is round, whatever the voice */
      hold: function () { return !!(_IG2.on && _IG2.hook && (_tourNow() - _IG2.hook) < 3500); }, holdMax: 4000,
      start: function (run) {
        _T.once = {};
        _tourSpin(false);
        /* the units of the voice's market for the run, the budget told too; the page's units come back at the end (_tourStop):
           English = US (Marek: cilime na US), any other language = metric (v404, the German reel for Andreas) */
        var wantMetric = _tourLang() !== 'en';
        if ((STATE.isMetric !== false) !== wantMetric) { _T.unitsUs = true; STATE.isMetric = wantMetric; try { _broadcastUnitToBudget(wantMetric); } catch (eU) {} _tlog('tour     ig2-hook: ' + (wantMetric ? 'metric' : 'US') + ' units for the run (the page\'s units back at the end)'); }
        _tourType(17, 'white', function () {
          STATE.L = us() ? 1.9812 : 2.00;
          STATE.porchFill = 'planks'; STATE.porchGap = PCL.GAP_DEF; STATE.swingCushion = true;
        }, run, { ms: 0, az: 0.10, el: 0.28 });
        _tlog('tour     ig2-hook: the pergola swing, white, L ' + (+STATE.L).toFixed(2) + ' -- apart and together during one turn');
        _tourLater(function () { _ig2Hook(run); }, 450, run);
      },
      cycle: function (cb, run) { _tourLater(cb, 300, run); },
      end: function () { _ig2End('the reel\'s hook is over', true); } };
    var edit = _tourTypeStep('ig2-edit', 17, 6, 'white', { mp3: 'ig2-swing-edit', cam: { az: 0.78, el: 0.22, k: 1.12 }, target: 'cf-handle-l',
      set: function () { STATE.L = us() ? 1.524 : 1.52; STATE.porchFill = 'planks'; STATE.porchGap = PCL.GAP_DEF; STATE.swingCushion = false; },
      show: function (cb, run) {
        var L0 = function () { return STATE.L; }, g0 = function () { return Math.round(_pclGap(STATE) * 1000); };
        _tourSeq(run, [_tonce('pgedit', [_tw(200, run), _tpulse(['cf-handle-l']), _tsw(L0, us() ? 2.4384 : 2.44, 1600, _tourLenSet, run),
          _tdo(function () { _tourFrame({ az: 0.74, el: 0.22, k: 1.12, ms: 800 }, run); }), _tw(250, run),   /* the longer pergola framed whole again */
          _tpulse(['cf-bench-back-toggle']), _tclick('cf-bench-back-toggle'), _tw(650, run),
          _tpulse(['cf-bench-pitch']), _tsw(g0, 70, 800, _tourPorchGapSet, run), _tw(150, run), _tsw(70, 45, 450, _tourPorchGapSet, run),
          _tpulse(['cf-btn-lvl']), _tw(150, run), _tclick('cf-btn-lvl'), _tw(900, run), _tpulse([])], run), _tw(300, run)], cb);
      } });
    /* the assembly walk of the frame and the seat: footings, posts, heads, beams, rafters, the seat half built,
       the hanging, built (the steps the design has; was the staged walk's first four at ground level) */
    var build = _tourAsmStep(_tourTypeStep('ig2-build', 17, 6, null, { mp3: 'ig-assembly', same: true, cam: { az: 0.95, el: 0.30 }, target: 'cf-btn-assembly',
      show: function (cb, run, done) {
        if (_T.once.asm) { _tourLater(cb, 300, run); return; }
        _T.once.asm = 1;
        var act = _swingActiveSteps(STATE);
        var walk = [[1, 600], [3, 650], [5, 600], [9, 600], [13, 650], [20, 650], [29, 700], [0, 800]].filter(function (q) { return q[0] === 0 || act.indexOf(q[0]) >= 0; });
        _tourAsmList(cb, run, done, (walk.length > 3) ? walk : _tourAsmWalk());
      } }));
    var budget = _tourBudgetStep();
    /* THE ASSISTANT ON THE BoQ (ai.js v2.88): its drawer, a question, the project card from the budget */
    var ai = { key: 'ig2-ai', mp3: 'ig2-swing-ai', sec: 6, lead: 300, tip: ['open_budget', ''],
      target: function () { return null; },
      start: function (run) {
        var el = global.document.querySelector('.leva-float-group .leva-act--ai') || global.document.querySelector('.leva-act[data-leva-act="ai"]');
        var A = global.LevaAI, can = !!(A && typeof A.open === 'function');
        if (!can) { _T.skip = 'no assistant on the page'; return; }
        _tourArClose();
        _tourFrame({ az: 0.70, el: 0.24, ms: 600 }, run);
        if (el && el.offsetParent !== null) _tourPulse([el]);
        _tourLater(function () {
          _tourPulse([]);
          var ok = false;
          if (typeof A.demo === 'function') {
            /* v404 any other language: the live chip in the page's language (ai.js v3.00 o.live); English as before */
            var oD = (_tourLang() === 'en') ? { ask: 'What will my swing cost?', name: _tourName(17) || 'Pergola Swing', at: 350 } : { live: true, name: _tourName(17) || '', at: 350 };
            try { ok = !!A.demo('project', oD); } catch (eD) { ok = false; }
          }
          _T.aiDemo = ok;
          if (!ok) { try { A.open(); } catch (eO) {} }
          _T.aiOpen = true;
          _tlog('tour     ig2-ai: ' + (ok ? ('the assistant\'s project card from the budget (LevaAI.demo' + (_tourLang() === 'en' ? '' : ', live chip, ' + _tourLang()) + ')') : 'the assistant\'s drawer opened (no demo: ' + (typeof A.demo === 'function' ? 'no budget' : 'ai.js without demo') + ')'));
        }, 650, run);
      },
      cycle: function (cb, run) { _tourLater(cb, 300, run); },
      end: function () { _tourAiClose(); } };
    var outro = { key: 'outro', mp3: 'ig-outro', sec: 5, lead: 300, tip: ['open_budget', ''],
      target: function () { return null; },
      start: function (run) { _tourArClose(); _tourAiClose(); _tourFrame({ az: 0.85, el: 0.24, k: 1.1 }, run); _tourSpin(true); _T.turned = false; },
      cycle: function (cb, run) {
        if (!_T.turned) { _T.turned = true; _tourTurn(5200, run, function () { _tourSpin(true); _tourLater(cb, 300, run); }); return; }
        _tourLater(cb, 700, run);
      },
      end: function () { _tourPulse([]); } };
    _tlog('tour     ?ig2 pergola swing reel (bench-v361, ' + _tourLang() + ', ' + (us() ? 'US' : 'metric') + '): hook (ig2-swing-intro, the exploded turn), edit (ig2-swing-edit: seat, fill, gap, cushion), assembly (ig-assembly, the frame and the seat), BoQ (ig-budget, tight), AI (ig2-swing-ai, the project card), outro (ig-outro) -- the aim under 60 s');
    return [hook, edit, build, budget, ai, outro];
  }
  /* the tour's order: the intro, the types as the storefront sells them, the outro */
  var _TOUR_STEPS = [];
  function _tourBuild() {
    if (_tourIg2Reel()) { _TOUR_STEPS = _tourIg2Swing() ? _tourIg2SwingSteps() : _tourIg2Steps(); _T.reel = 'ig2'; return _TOUR_STEPS; }   /* v358; v361 SWINGS: the pergola swing reel */
    if (_tourBedReel()) { _TOUR_STEPS = _tourBedReelSteps(); _T.reel = 'bed'; return _TOUR_STEPS; }   /* v276 */
    if (_tourIgReel()) { _TOUR_STEPS = _tourIgSteps(); _T.reel = 'ig'; return _TOUR_STEPS; }   /* v280 */
    _T.reel = '';
    var S = _tourTypeSteps(), L = [_TOUR_INTRO];
    _tourSlots().forEach(function (t) { (S[t] || []).forEach(function (x) { L.push(x); }); });
    L.push(_TOUR_OUTRO);
    _TOUR_STEPS = L;
    return L;
  }
  _tourBuild();

  /* ---- the runner (the core's, as the container copied it) -------------- */
  function _tourStart() {
    if (_T.on || !_T.btn) return;
    _T.btn.classList.remove('cf-idle');
    if (!(_T.resumeAt > 0)) _tourBuild();   /* the storefront's order, now that the page has given it */
    var from = (_T.resumeAt > 0 && _T.resumeAt < _TOUR_STEPS.length) ? _T.resumeAt : 0;
    /* the visitor's design, view and camera, kept to be put back */
    _T.saved = stateSnap();
    _T.view0 = STATE.view;
    try {
      var E0 = _tourEng(), c0 = E0 && E0.camera, k0 = _tourControls();
      _T.cam = (c0 && k0) ? { p: c0.position.clone(), t: k0.target.clone(), mn: k0.minDistance, mx: k0.maxDistance, f: c0.far, ar: k0.autoRotate, as: k0.autoRotateSpeed } : null;
    } catch (eC) { _T.cam = null; }
    _T.on = true; _T.run++; _T.i = -1; _T.tm = []; _T.t0 = Date.now();
    _T.voice = true;
    _T.clipLost = -2;
    _T.dirty = false;
    /* from a quiet start: 3D, the AR window shut, the bench built */
    try { if (STATE.view === '2d' && _tourEng()) _tourEng().toggleView(); } catch (eV) {}
    try { var mA = _tq('cf-ar-modal'); if (mA && !mA.hidden) { var xA = mA.querySelector('[data-cf-ar-close]'); if (xA) xA.click(); mA.hidden = true; } } catch (eAr) {}
    try {
      if (!_T.audio) {
        _T.audio = new global.Audio(); _T.audio.preload = 'auto';
        _T.audio.addEventListener('timeupdate', function () { _tourStreamTick(); });
      }
      _T.segWatch = null; _T.clipPending = false; _T.ahead = false;
      if (_T.keepAudio && _TS && _T.audio) throw { keep: true };
      _T.segs = []; _T.segNow = null;
      _TS = _tourStreamOk() ? _tourStreamOpen(_T.audio) : null;
      if (_TS) _tlog('tour     one stream for the whole tour (MediaSource, audio/mpeg) -- the player does not stop between the clips');
      else _T.audio.src = _tourUrl(_tourSrcs(_TOUR_STEPS[from])[0]);
      var tTap = _tourNow(), runTap = _T.run;
      var firstSound = function () {
        _T.audio.removeEventListener('playing', firstSound);
        if (runTap !== _T.run) return;
        _tlog('tour     first sound ' + ((_tourNow() - tTap) / 1000).toFixed(1) + ' s after play');
      };
      _T.audio.addEventListener('playing', firstSound);
      var pr = _T.audio.play();
      if (pr && pr.catch) pr.catch(function (eA) { _tourPlayFail(eA, _T.run); });
    } catch (eA2) {
      if (eA2 && eA2.keep) _tlog('tour     the voice goes on -- the shows start again at step ' + (from + 1));
      else _tourNoVoice('could not start (' + ((eA2 && eA2.message) || eA2) + ')');
    }
    _T.btn.innerHTML = _TOUR_SVG.pause;
    _T.btn.classList.add('cf-on');
    if (_T.reel === 'ig2') _T.btn.style.opacity = '0';   /* v358 out of the video, as the story's; a tap on its place pauses */
    _tourMedia();
    _tourTickLoop();
    _tlog('tour     started -- the design, view and camera kept to be put back; savePref and Undo held');
    if (from) _tlog('tour     resumed at step ' + (from + 1) + ' ' + _TOUR_STEPS[from].key);
    _tourStep(from, _T.run);
  }
  function _tourNoVoice(why) {
    if (!_T.voice) return;
    _T.voice = false;
    _tlog('tour     the voice ' + why + ' -- the steps run on their own time, with the bubbles');
    try { if (_T.audio) _T.audio.pause(); } catch (e) {}
    if (_T.on && _T.stepVoiceLost) _T.stepVoiceLost();
  }
  function _tourClipLost(why, run) {
    if (run !== _T.run || !_T.voice) return;
    if (_T.clipLost === _T.i) return;
    _T.clipLost = _T.i;
    _tlog('tour     the voice ' + why + ' -- this step runs on its own time, the next one tries its voice again');
    if (_T.on && _T.stepVoiceLost) _T.stepVoiceLost();
  }
  function _tourPlayFail(eA, run) {
    var nm = String((eA && eA.name) || eA || '');
    if (/Abort|NotSupported/i.test(nm)) return;
    if (/NotAllowed/i.test(nm)) _tourNoVoice('refused (' + nm + ')');
    else _tourClipLost('did not play (' + nm + ')', run);
  }
  function _tourStep(i, run) {
    if (run !== _T.run) return;
    if (i >= _TOUR_STEPS.length) { _tourStop('the end of the tour'); return; }
    if (_TS && _T.voice && !_T.ahead && _tourHidden()) { _T.i = -1; _T.nextI = i; _tourAheadGo('the page is in the background at step ' + (i + 1)); return; }
    var S = _TOUR_STEPS[i];
    _T.i = i;
    _T.nextI = i;
    var spoken = false, t0 = Date.now();
    _T.pass = 0;
    var done = function () { return spoken; };
    _T.doneFn = done;   /* v277: the shows hurry once it is true */
    _tlog('tour     step ' + (i + 1) + '/' + _TOUR_STEPS.length + ' ' + S.key + (_T.voice ? (' -- ' + _tourSrcs(S)[0]) : (' -- ' + S.sec + ' s, no voice')));
    _T.skip = '';
    if (S.has) { var okH = false; try { okH = !!S.has(); } catch (eH) { okH = false; } if (!okH) _T.skip = 'nothing for it on this product'; }
    if (!_T.skip) { try { S.start(run); } catch (eS) { _tlog('tour     ' + S.key + ' start THREW ' + ((eS && eS.message) || eS)); } }
    if (_T.skip) {
      _tlog('tour     ' + S.key + ' skipped -- ' + _T.skip);
      _tourHl(null); _tourBub(null); _tourPulse([]);
      try { S.end(false); } catch (eSk) {}
      _T.i = -1;
      _T.nextI = i + 1;
      _tourLater(function () { _tourStep(i + 1, run); }, 40, run);
      return;
    }
    /* the steps shown, for previous; the step's label in the notification (core-v694) */
    _T.played = _T.played || [];
    if (_T.played.indexOf(i) < 0) _T.played.push(i);
    try { _tourMediaMeta(S.tip ? _tt(S.tip[0], S.tip[1]) : ''); } catch (eMm) {}
    var tgt = null;
    try { tgt = S.target ? S.target() : null; } catch (eT) { tgt = null; }
    if (S.tip && tgt) _tourBub(tgt, _tt(S.tip[0], S.tip[1]));
    var own = function () { _tourLater(function () { spoken = true; }, S.sec * 1000, run); };
    _T.stepVoiceLost = function () { own(); };
    if (_T.voice && _T.audio && _TS) {
      /* ONE STREAM (core-v695): the clip appended, its end watched */
      _tourPreStep(_TOUR_STEPS[i + 1], 'the next step');
      _tourPreStep(_TOUR_STEPS[i + 2], 'the step after');
      var have = _tourSegOf(i);
      if (have && have.to != null) {
        /* its voice plays already -- the page came back in this step (core-v697) */
        _tlog('tour     ' + S.key + ' voice ' + have.name + ' already in the stream (until ' + have.to.toFixed(1) + ' s) -- the show catches up with it');
        _T.segWatch = { to: have.to, fn: function () { if (run === _T.run) { spoken = true; _tlog('tour     ' + S.key + ' voice ' + have.name + ' ended after ' + ((Date.now() - t0) / 1000).toFixed(1) + ' s'); } } };
        _tourStreamTick();
      } else {
        var LS = _tourSrcs(S);
        _T.clipPending = true;
        _tourClipBytes(LS).then(function (c) {
          if (run !== _T.run || _T.i !== i) return null;
          var g = _tourSegAdd(i, S, c);
          return g.p.then(function (seg) {
            _T.clipPending = false;
            if (run !== _T.run) return;
            _tlog('tour     ' + S.key + ' voice ' + c.name + ' in the stream at ' + seg.from.toFixed(1) + ' s, ' + (seg.to - seg.from).toFixed(1) + ' s long' + (c.ahead ? ' (fetched ahead)' : ' (from the network)'));
            try { if (_T.audio.paused) { var pr2 = _T.audio.play(); if (pr2 && pr2.catch) pr2.catch(function (eA) { if (run === _T.run) _tourPlayFail(eA, run); }); } } catch (eP2) {}
            _T.segWatch = { to: seg.to, fn: function () { if (run === _T.run) { spoken = true; _tlog('tour     ' + S.key + ' voice ' + c.name + ' ended after ' + ((Date.now() - t0) / 1000).toFixed(1) + ' s'); } } };
            _tourStreamTick();
          });
        }).catch(function (e) { _T.clipPending = false; if (run === _T.run && _T.i === i) _tourClipLost('no clip for ' + S.key + ' (' + ((e && e.message) || e) + ')', run); });
      }
      _tourLater(function () { if (!spoken) { _tlog('tour     ' + S.key + ' voice still going after ' + (S.sec + 20) + ' s -- moving on'); spoken = true; } }, (S.sec + 20) * 1000, run);
    } else if (_T.voice && _T.audio) {
      _tourPreStep(_TOUR_STEPS[i + 1], 'the next step');
      _tourPreStep(_TOUR_STEPS[i + 2], 'the step after');
      var a = _T.audio, L = _tourSrcs(S), li = 0, src = _tourUrl(L[0]);
      var playIt = function () {
        try { var pr = a.play(); if (pr && pr.catch) pr.catch(function (eA) { if (run === _T.run) _tourPlayFail(eA, run); }); } catch (eP) { _tourClipLost('could not play', run); }
      };
      a.onended = function () { if (run === _T.run) { spoken = true; _tlog('tour     ' + S.key + ' voice ' + L[li] + ' ended after ' + ((Date.now() - t0) / 1000).toFixed(1) + ' s'); } };
      a.onerror = function () {
        if (run !== _T.run || _T.i !== i) return;
        if (li + 1 < L.length) {
          li++;
          _tlog('tour     ' + S.key + ': ' + L[li - 1] + ' not there -- ' + L[li]);
          a.src = _tourUrl(L[li]);
          playIt();
          return;
        }
        _tourClipLost('MP3 failed for ' + L[li], run);
      };
      if (String(a.src).indexOf(src) < 0) {
        a.src = src;
        playIt();
      }
      /* a voice that never ends does not hold the tour */
      _tourLater(function () { if (!spoken) { _tlog('tour     ' + S.key + ' voice still going after ' + (S.sec + 20) + ' s -- moving on'); spoken = true; } }, (S.sec + 20) * 1000, run);
    } else own();
    /* the step's end, once -- as core-v691: a page in the background skips
       the shows and the voice's end moves the tour on */
    var finished = false;
    var finish = function () {
      if (finished || run !== _T.run) return;
      finished = true;
      _tourHl(null); _tourBub(null); _tourPulse([]);
      try { S.end(false); } catch (eE) { _tlog('tour     ' + S.key + ' end THREW ' + ((eE && eE.message) || eE)); }
      _T.i = -1;
      _T.nextI = i + 1;
      _tlog('tour     ' + S.key + ' done in ' + ((Date.now() - t0) / 1000).toFixed(1) + ' s' + (_tourHidden() ? ' (the page in the background)' : ''));
      _tourLater(function () { _tourStep(i + 1, run); }, _tourIg() ? 250 : 600, run);   /* v280: the reel's gaps shorter */
    };
    var loop = function () {
      if (run !== _T.run || finished) return;
      if (spoken && !_tourHold(S)) { finish(); return; }
      if (_tourHidden()) { _tourLater(loop, 500, run); return; }
      try { S.cycle(loop, run, done); } catch (eCy) { _tlog('tour     ' + S.key + ' cycle THREW ' + ((eCy && eCy.message) || eCy)); _tourLater(loop, 600, run); }
    };
    _tourLater(loop, _tourIg() ? Math.min(S.lead || 600, 1200) : (S.lead || 600), run);
    var watch = function () {
      if (run !== _T.run || finished) return;
      if (spoken && _tourHidden()) { finish(); return; }
      _tourLater(watch, 700, run);
    };
    _tourLater(watch, 700, run);
  }
  /* A SHOW LONGER THAN ITS LINE (bench-v335, as container-v559): the
     voice's end ends a step, but the reel's assembly and budget have more to
     show than their short lines last -- a step with hold() is let finish
     its show, at most holdMax (6 s) past the voice */
  function _tourHold(S) {
    var on = false;
    try { on = !!(S && S.hold && S.hold()); } catch (eH) { on = false; }
    if (!on) { _T.holdT = 0; return false; }
    if (!_T.holdT) { _T.holdT = Date.now(); _tlog('tour     ' + S.key + ': the voice is done, the show is not -- held (bench-v335)'); }
    var mx = (S && S.holdMax) || 6000;
    if (Date.now() - _T.holdT > mx) { _tlog('tour     ' + S.key + ': held ' + (mx / 1000) + ' s -- moving on'); _T.holdT = 0; return false; }
    return true;
  }
  /* a pause is a stop that remembers the step it broke into */
  function _tourPause(why) {
    if (!_T.on) return;
    var at = (_T.nextI > 0) ? _T.nextI : 0;
    _tourStop(why, true);
    _T.resumeAt = at;
    _tlog('tour     paused at step ' + (at + 1) + ' ' + ((_TOUR_STEPS[at] || {}).key || '') + ' -- play goes on from there');
  }
  function _tourStop(why, paused) {
    if (!_T.on) return;
    if (_T.btn && !paused) _T.btn.classList.remove('cf-ig-gone');   /* v359 */
    if (_tourIg() && !paused) _tlog('tour     ?ig reel: ' + ((Date.now() - _T.t0) / 1000).toFixed(1) + ' s from play to ' + why + ' (bench-v280, the aim: under 60 s)');
    var keepA = !!(_T.keepAudio && paused);
    if (!keepA) { try { if (global.navigator.mediaSession) global.navigator.mediaSession.playbackState = 'paused'; } catch (eMp) {} }
    _T.ahead = false; _T.probe = false;
    if (!paused) _T.resumeAt = 0;
    var S = _TOUR_STEPS[_T.i];
    _T.on = false; _T.run++;
    _T.tm.forEach(function (id) { global.clearTimeout(id); });
    _T.tm = [];
    if (_T.audio) { try { _T.audio.onended = null; _T.audio.onerror = null; if (!keepA) _T.audio.pause(); } catch (eA) {} }
    _tourHl(null); _tourPulse([]);
    if (_T.bub) _T.bub.classList.remove('cf-on');
    try { if (S && S.end) S.end(true); } catch (eE) { _tlog('tour     ' + (S && S.key) + ' end THREW ' + ((eE && eE.message) || eE)); }
    _tourArClose();
    _tourSpin(false);
    /* the visitor's design as it was at play -- every key of STATE; the view
       first (2D comes back through the engine's own switch) */
    if (_T.saved) {
      _HOLD++;   /* the engine's own view switch saves the prefs: nothing of the tour's last type may land there */
      try {
        if (_T.view0 === '2d' && STATE.view !== '2d' && _tourEng()) _tourEng().toggleView();
        stateBack(_T.saved);
      } catch (eP) { _tlog('tour     putting the design back THREW ' + ((eP && eP.message) || eP)); }
      _HOLD--;
    }
    if (_T.unitsUs) { _T.unitsUs = false; try { _broadcastUnitToBudget(STATE.isMetric !== false); } catch (eUb) {} }   /* v361 the swing reel's US units: the budget back to the page's */
    _T.dirty = false;
    _tourCamPlay();
    if (_T.btn) { _T.btn.innerHTML = _TOUR_SVG.play; _T.btn.classList.remove('cf-on'); _T.btn.style.opacity = ''; }
    _tlog('tour     stopped -- ' + (why || '') + (S ? (' (at ' + S.key + ')') : '') + '; design, view, camera and Undo put back');
  }
  function tourState() {
    var a = _T.audio, G = (_T.segs || []).map(function (g) { return g.key + '@' + (g.from == null ? '?' : g.from.toFixed(1)) + '-' + (g.to == null ? '?' : g.to.toFixed(1)); });
    return { on: _T.on, step: _T.i, key: (_TOUR_STEPS[_T.i] || {}).key || '', voice: _T.voice, steps: _TOUR_STEPS.length, keys: _TOUR_STEPS.map(function (x) { return x.key; }), mounted: !!_T.btn,
      ahead: !!_T.ahead, vt: a ? Math.round((a.currentTime || 0) * 100) / 100 : null, paused: a ? !!a.paused : null, sub: (_TSUB && _TSUB.shown) || '', segs: G };
  }

  /* ===== THE TOUR'S SUBTITLES (bench-v265, as container-v535) ==================
     The clips' own words in English in the lower third (Marek: pro video /
     Instagram, na zadost vypnout -- TOUR_SUBS false; a page's ?subs=1 /
     ?subs=0 overrides it either way), one line of the sentence at a time,
     timed by the voice. Placed over the info bar and the sliders above it
     (never on them), and over the AR window while it is open. */
  /* v266, as container-v537 (Marek: hlasovy pruvodce jako container --
     odkaz s ?ig zobrazi titulky a skryje admin buttons / logs): shown by
     default; the small cross at the band's top right closes them for this
     visitor (kept in the browser, the same key as the container's), ?ig (or
     ?subs=1) brings them back on that page whatever was closed, ?subs=0
     hides them on that page. The admin buttons and logs of a ?ig page are
     hidden theme-wide (ig-v1, layout/theme.liquid). */
  var TOUR_SUBS = true;
  var TOUR_SUBS_LANG = 'en';
  var TOUR_SUBS_KEY = 'leva-tour-subs';
  var _TSUB = { el: null, txt: null, asked: false, iv: 0, key: '', chunks: null, shown: '', stepI: -2, stepT0: 0, said: '' };
  function _tourSubsOn() {
    var q = null, ig = false, kept = null;
    if (_TSUB.closed) return false;   /* the cross, on this page view (a ?ig page too) */
    try { var U = new URL(global.location.href); q = U.searchParams.get('subs'); ig = U.searchParams.has('ig'); } catch (e) { q = null; }
    if (q === '1' || ig || global.LEVA_IG) return true;
    if (q === '0') return false;
    try { kept = global.localStorage.getItem(TOUR_SUBS_KEY); } catch (eK) { kept = null; }
    if (kept === '0') return false;
    return TOUR_SUBS;
  }
  /* the cross: closed for this visitor, from now on and on the next visit */
  function _tourSubsClose(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    try { global.localStorage.setItem(TOUR_SUBS_KEY, '0'); } catch (eS) {}
    _TSUB.closed = true;
    _tourSubShow('');
    _tlog('tour     subtitles closed by the cross -- off for this visitor (?ig brings them back)');
  }
  function _tourSubsCss() {
    if (_tq('cf-tour-sub-css')) return;
    var st = global.document.createElement('style');
    st.id = 'cf-tour-sub-css';
    st.textContent =
      '#cf-tour-sub{position:absolute;left:50%;bottom:20%;transform:translateX(-50%);z-index:16;max-width:min(680px,calc(100% - 150px));' +
      'box-sizing:border-box;padding:9px 16px;border-radius:12px;background:rgba(20,21,22,0.80);color:#ffffff;text-align:center;' +
      "font:600 17px/1.35 'Montserrat',sans-serif;letter-spacing:0.01em;pointer-events:none;display:none;box-shadow:0 6px 20px rgba(0,0,0,0.20);}" +
      '#cf-tour-sub.cf-on{display:block;}' +
      '#cf-tour-sub.cf-over{position:fixed;z-index:100001;}' +
      '#cf-tour-sub .cf-tour-sub-x{position:absolute;top:-9px;right:-9px;width:22px;height:22px;border-radius:50%;border:0;padding:0;margin:0;' +
      'display:flex;align-items:center;justify-content:center;background:#ffffff;color:#141516;cursor:pointer;pointer-events:auto;' +
      'box-shadow:0 2px 8px rgba(0,0,0,0.25);-webkit-tap-highlight-color:transparent;touch-action:manipulation;}' +
      '#cf-tour-sub .cf-tour-sub-x svg{width:10px;height:10px;display:block;}' +
      '#cf-tour-sub .cf-tour-sub-t{display:block;}' +
      '@media (max-width:640px){#cf-tour-sub{font-size:14px;max-width:calc(100% - 96px);padding:7px 12px;}}' +
      /* bench-v313 as core-v730 (Marek 2026-10-21: zvetsit titulky u pruvodcu s ig, na ig nejsou skoro videt; bezny pruvodce nechat): on a ?ig page (html.leva-ig) the line is about 4 % of the page's width -- 46 px on a 1100 px stage, 24 px at the least, 56 px at the most; as wide as its words up to the page less 160 px, clear of the right-hand rail (left 50 % alone would cap it at half the page); 22 px on a phone; every other page as before */
      'html.leva-ig #cf-tour-sub{font-size:clamp(24px,4.2vw,56px);line-height:1.22;font-weight:700;padding:0.32em 0.7em;border-radius:0.38em;width:max-content;max-width:calc(100% - 160px);}' +
      '@media (max-width:640px){html.leva-ig #cf-tour-sub{font-size:22px;max-width:calc(100% - 128px);}}';
    global.document.head.appendChild(st);
  }
  function _tourSubsText() {
    if (_TSUB.txt || _TSUB.asked || !global.fetch) return;
    if (_TSUB.failAt && Date.now() - _TSUB.failAt < 20000) return;   /* not again within 20 s */
    _TSUB.asked = true;
    /* bench-v347 the page's language and English, keyed 'xx|name' -- a subtitle in the language of the clip that plays */
    var lg = _tourLang(), langs = (lg !== 'en' && _TOUR_GEN[lg]) ? ['en', lg] : ['en'];
    TOUR_SUBS_LANG = langs.join('+');
    var get = function (l) {
      return global.fetch(_TOUR_WORKER.replace(/\/v\/$/, '/texts/') + l, { mode: 'cors', credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error(l + ' HTTP ' + r.status);
        return r.json();
      }).then(function (j) { return { l: l, j: j || {} }; }, function (e) { if (l === 'en') throw e; return { l: l, j: {}, err: (e && e.message) || String(e) }; });
    };
    Promise.all(langs.map(get)).then(function (R) {
      var T = {}, n = 0, say = [];
      R.forEach(function (x) {
        var c = 0, k;
        for (k in x.j) if (x.j.hasOwnProperty(k)) { T[x.l + '|' + k] = x.j[k]; c++; if (k.indexOf('bench-tour-') === 0 || k.indexOf('ig-') === 0) n++; }
        say.push(x.l + ' ' + c + (x.err ? (' (' + x.err + ')') : ''));
      });
      _TSUB.txt = T;
      _tlog('tour     subtitles: ' + say.join(', ') + ' text(s) from the voice worker, ' + n + ' of the bench tour / reel');
    }).catch(function (e) {
      _TSUB.asked = false;
      _TSUB.failAt = Date.now();
      _tlog('tour     subtitles: the texts did not come (' + ((e && e.message) || e) + ') -- asked again in 20 s');
    });
  }
  function _tourSubKey(name) {
    var s = String(name || ''), lm = /^voice:([a-z]{2})(-[a-z]{2})?\//.exec(s), lg = lm ? lm[1] : 'en';   /* v347 the clip's own language */
    var n = s.replace(/^voice:[a-z]{2}(-[a-z]{2})?\//, '').replace(/^.*\//, '').replace(/(\.mp3)+$/, '');
    var T = _TSUB.txt || {};
    return T[lg + '|' + n] ? (lg + '|' + n) : (T['en|' + n] ? ('en|' + n) : '');
  }
  function _tourSubStepKey(S) {
    var T = _TSUB.txt || {}, lg = _tourLang(), names, i, j, L;
    if (!S) return '';
    names = (S.mp3 === 'bench-tour-intro') ? [_tourHook(), S.mp3] : [S.mp3];   /* v339 the product's own hook */
    L = (lg !== 'en') ? [lg, 'en'] : ['en'];   /* v347 the page's language, then English */
    for (j = 0; j < L.length; j++) for (i = 0; i < names.length; i++) if (T[L[j] + '|' + names[i]]) return L[j] + '|' + names[i];
    return '';
  }
  /* the sentence by sentence, a long one split at its comma or colon
     nearest the middle; each piece weighed by its letters */
  function _tourSubChunks(text) {
    var out = [];
    String(text || '').replace(/([.!?])\s+/g, '$1\n').split('\n').forEach(function (s) {
      s = s.trim();
      if (!s) return;
      var parts = [s];
      while (parts.some(function (x) { return x.length > 78; })) {
        var q = [], cut = false;
        parts.forEach(function (x) {
          if (x.length <= 78 || cut) { q.push(x); return; }
          var mid = x.length / 2, best = -1, re = /[,:;]\s/g, mm;
          while ((mm = re.exec(x))) if (best < 0 || Math.abs(mm.index - mid) < Math.abs(best - mid)) best = mm.index;
          if (best < 0) { var sp = x.lastIndexOf(' ', Math.round(mid)); best = (sp > 0) ? sp - 1 : -1; }
          if (best < 0) { q.push(x); return; }
          q.push(x.slice(0, best + 1).trim()); q.push(x.slice(best + 1).trim());
          cut = true;
        });
        if (!cut) break;
        parts = q;
      }
      out = out.concat(parts);
    });
    var tot = 0, acc = 0;
    out.forEach(function (x) { tot += x.length; });
    return out.map(function (x) { acc += x.length; return { t: x, end: tot ? acc / tot : 1 }; });
  }
  /* the lower third, lifted over the info bar and the sliders; over the AR
     window (fixed, above its backdrop) while it is open */
  function _tourSubPlace(el) {
    var root = _tq('cf-root');
    if (!root || !el) return;
    var R = root.getBoundingClientRect(), lift = Math.round(R.height * 0.20);
    ['.cf-info-bar', '#cf-bench-rake-row', '#cf-bench-pitch-row'].forEach(function (s) {
      var x = root.querySelector(s);
      if (!x || x.offsetParent === null) return;
      var r = x.getBoundingClientRect();
      if (!(r.height > 0) || r.top < R.top + R.height * 0.5) return;
      lift = Math.max(lift, Math.round(R.bottom - r.top + 12));
    });
    var ar = _tourArShown(), dw = !ar && _tourDrawerUp(), host = (ar || dw) ? global.document.body : root;
    /* over the AR window -- and since bench-v335 over any open drawer (the
       budget, an item's card, the assistant ...) -- it lives in the page's
       body: inside the canvas it stays under them whatever its z-index */
    if (el.parentNode !== host) host.appendChild(el);
    el.classList.toggle('cf-over', ar || dw);
    if (ar) { el.style.left = Math.round(R.left + R.width / 2) + 'px'; el.style.bottom = Math.round(global.innerHeight - R.bottom + lift) + 'px'; }
    else if (dw) { el.style.left = Math.round(global.innerWidth / 2) + 'px'; el.style.bottom = Math.round(global.innerHeight * 0.07) + 'px'; }
    else { el.style.left = ''; el.style.bottom = lift + 'px'; }
  }
  /* bench-v335 (Marek: titulky jsou schovane za drawers -- budgets atd.): is
     a drawer open over the page -- a side panel (the budget, an item's card,
     the shared budgets ...) or the assistant */
  function _tourDrawerUp() {
    try {
      var d = global.document, L = d.querySelectorAll('.side-panel.active'), i, w = global.innerWidth || 0;
      for (i = 0; i < L.length; i++) { var r = L[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0 && r.left < w - 4 && r.right > 4) return true; }
      var ai = d.getElementById('leva-ai-drawer');
      if (ai && !ai.hidden && ai.getAttribute('aria-hidden') !== 'true') { var ra = ai.getBoundingClientRect(); if (ra.width > 0 && ra.height > 0) return true; }
    } catch (e) {}
    return false;
  }
  function _tourSubShow(text) {
    var el = _TSUB.el;
    if (!el && !text) return;
    if (!el) {
      var root = _tq('cf-root');
      if (!root) return;
      _tourSubsCss();
      el = _TSUB.el = global.document.createElement('div');
      el.id = 'cf-tour-sub';
      var tx = global.document.createElement('span');
      tx.className = 'cf-tour-sub-t';
      el.appendChild(tx);
      var x = global.document.createElement('button');
      x.type = 'button';
      x.className = 'cf-tour-sub-x';
      x.setAttribute('aria-label', _tt('close', 'Close'));
      x.innerHTML = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
      x.addEventListener('click', _tourSubsClose);
      el.appendChild(x);
      _TSUB.tx = tx;
      root.appendChild(el);
    }
    if (text) _tourSubPlace(el);
    if (text === _TSUB.shown) return;
    _TSUB.shown = text;
    if (text) { _TSUB.tx.textContent = text; el.classList.add('cf-on'); }
    else el.classList.remove('cf-on');
  }
  /* where the voice is: { key, frac } or null */
  function _tourSubWhere() {
    var a = _T.audio, i = _T.i, S = (i >= 0) ? _TOUR_STEPS[i] : null;
    if (i !== _TSUB.stepI) { _TSUB.stepI = i; _TSUB.stepT0 = Date.now(); }
    if (_T.voice && a && _TS && _T.segs) {
      var t = a.currentTime || 0, G = _T.segs, k;
      for (k = G.length - 1; k >= 0; k--) {
        var g = G[k];
        if (g.from != null && g.to != null && t >= g.from && t < g.to) return { key: _tourSubKey(g.name), frac: (t - g.from) / Math.max(0.1, g.to - g.from) };
      }
      if (S && _T.clipLost === i) return { key: _tourSubStepKey(S), frac: (Date.now() - _TSUB.stepT0) / Math.max(1000, S.sec * 1000) };
      return null;
    }
    if (!S) return null;
    if (_T.voice && a && !_TS) {
      if (!(a.duration > 0) || a.paused || a.ended) return null;
      return { key: _tourSubStepKey(S), frac: a.currentTime / a.duration };
    }
    return { key: _tourSubStepKey(S), frac: (Date.now() - _TSUB.stepT0) / Math.max(1000, S.sec * 1000) };
  }
  function _tourSubTick() {
    if (!_T.on || !_tourSubsOn()) { _tourSubShow(''); return; }
    if (!_TSUB.txt) { _tourSubsText(); _tourSubShow(''); return; }
    var w = _tourSubWhere();
    if (!w || !w.key || !(w.frac >= 0) || w.frac >= 1) { _tourSubShow(''); return; }
    if (w.key !== _TSUB.key) {
      _TSUB.key = w.key;
      _TSUB.chunks = _tourSubChunks(_TSUB.txt[w.key]);
      var said = 'tour     subtitle ' + w.key + ': ' + _TSUB.chunks.length + ' line(s)';
      if (said !== _TSUB.said) { _TSUB.said = said; _tlog(said); }
    }
    var C = _TSUB.chunks || [], j;
    for (j = 0; j < C.length; j++) if (w.frac < C[j].end) break;
    _tourSubShow(C[Math.min(j, C.length - 1)] ? C[Math.min(j, C.length - 1)].t : '');
  }
  function _tourSubInit() {
    if (_TSUB.iv) return;
    if (_tourSubsOn()) _tourSubsText();
    _TSUB.iv = global.setInterval(_tourSubTick, 150);
    _tlog('tour     subtitles ' + (_tourSubsOn() ? ('ON, ' + TOUR_SUBS_LANG + ', the lower third, a cross to close them') : 'off') + ' (TOUR_SUBS ' + TOUR_SUBS + '; ?ig or ?subs=1 shows them on a page, ?subs=0 hides them, the cross closes them for this visitor)' + (global.LEVA_IG ? ' -- a ?ig page: no admin tools' : ''));
  }

  /* ----------------------------------------------------------
     EXPORT
     ---------------------------------------------------------- */
  global.BenchLib = {
    __version: VERSION,
    _swingLayout: _swingLayout,      /* harness: the swing layout for a state */
    _picnicLayout: _picnicLayout,
    _waveLayout: _waveLayout,        /* v295 harness: the wave's panels + fasteners */
    _pgLayout: _pgLayout,            /* v296 harness: the pergola swing */
    _kidsLayout: _kidsLayout,        /* v299 harness: the kids' set */
    _gsLayout: _gsLayout,            /* v303 harness: the cinema bar */
    _mbLayout: _mbLayout,            /* v355 harness: the bar */
    _rbLayout: _rbLayout,            /* v314 harness: the raised bed */
    _fbLayout: _fbLayout,            /* v318 harness: the floating bed */
    _gaLayout: _gaLayout,
    _ghLayout: _ghLayout, _ghSteps: _ghSteps,   /* v373 harness: the gable greenhouse (v378 + the lean-to, v381 + the hoop house through it) */
    _kpLayout: _kpLayout, _kpSteps: _kpSteps,   /* v376 harness: the kitchen pod */
    _phLayout: _phLayout, _afLayout: _afLayout, _phAnyLayout: _phAnyLayout, _phSteps: _phSteps, _swingPartStep: _swingPartStep,   /* v369 harness: the assembly order check */
    _xpPlan: _xpPlan, _xpSet: _xpSet, _xpInfo: function () { return _XP.info; },   /* v395 harness: the coops' exploded view (the overlap check at several k) */
    _pfLayout: _pfLayout, _mdLayout: _mdLayout, _brLayout: _brLayout, _tfLayout: _tfLayout, _csLayout: _csLayout, _coLayout: _coLayout, _ctLayout: _ctLayout,   /* v375 harness: the backyard coop */   /* v368 harness: the tree fort */   /* v367 harness: the little barn */   /* v366 harness: the modern house */   /* v365 harness: the play fort */   /* v364 harness: the A-frame */
               /* v362 harness: the cottage */            /* v320 harness: the garden arbor */
    _gzLayout: _gzLayout,            /* v328 harness: the gazebo */
    _peLayout: _peLayout,            /* v334 harness: the pergola */
    _buildPartSheets: buildPartSheets,
    _drawPartSheet: _drawPartSheet,
    _arExportScene: _arExportScene,
    STATE:     STATE,
    DEFAULTS:  DEFAULTS,
    RANGES:    RANGES,
    DIMS:      DIMS,
    MATERIALS:       MATERIALS,
    SCREW_MATERIAL:  SCREW_MATERIAL,
    PART_MATERIAL:   PART_MATERIAL,
    boot:      boot,
    reset:     reset,
    toggleUnits: toggleUnits,
    share:     share,
    exportPdf: exportPdf,
    saveConfig: saveConfig,
    savePref:   savePref,
    refreshUI: refreshUI,
    _syncColorModeDisplay: _syncColorModeDisplay,
    fmtLen:    fmtLen,
    fmtArea:   fmtArea,
    VARIANT_KEYS:    VARIANT_KEYS,
    setSlotTypes:    setSlotTypes,
    swingCushionOn:  function () { return _swingCushionOn(STATE); },
    toggleKidsBench: toggleKidsBench,  /* v299 the kids' set: swings / bench */
    cycleMfFound:    cycleMfFound,     /* v301 the modern swing: ground screws / concrete footings */
    toggleMfWeave:   toggleMfWeave,    /* v301 the modern swing: blocks / the woven shade cloth */
    mfFoundLabel:    mfFoundLabel,
    mfWeaveOn:       function () { return _mfWeave(STATE); },
    mfTopMode:       function () { return _mfTop(STATE); },   /* v308 'blocks' | 'weave' | 'led' */
    _mfLayout:       _mfLayout,
    kidsModeLabel:   kidsModeLabel,
    kidsBenchOn:     function () { return _kidsBench(STATE); },
    typeFromSku:     typeFromSku,
    selectVariant:   selectVariant,
    nextVariant:     nextVariant,
    previousVariant: previousVariant,
    cycleLvl:        cycleLvl,
    toggleBackrest:  toggleBackrest,
    cycleBedHead:    cycleBedHead,    /* v275 */
    cyclePorchFill:  cyclePorchFill,  /* v281 the classic porch swing's back fill */
    porchFillLabel:  porchFillLabel,
    setPorchGap:     setPorchGap,
    porchGapRange:   function () { return { min: Math.round(PCL.GAP_MIN * 1000), max: Math.round(PCL.GAP_MAX * 1000), value: Math.round(_pclGap(STATE) * 1000) }; },
    bedHeadLabel:    bedHeadLabel,
    blockColorLabel: _blockColorLabel,
    togglePicnicSeparate: togglePicnicSeparate,
    picnicSeparateLabel:  picnicSeparateLabel,
    cycleSlats:      cycleSlats,
    setSlatGap:      setSlatGap,
    slatLabel:       slatLabel,
    swingRoofLabel:  swingRoofLabel,
    cycleSwingRoof:  cycleSwingRoof,
    swingPitchRange: swingPitchRange,
    setSwingPitch:   setSwingPitch,
    setSwingBack:    setSwingBack,
    setAdiBack:      setAdiBack,
    porchStyle:      function () { return _porchStyle(STATE); },
    adiBackRange:    function () { return { min: ADI.BACK_MIN, max: ADI.BACK_MAX, value: _adiBack(STATE) }; },
    swingBackRange:  function () { return { min: SWING.BACK_MIN, max: _swingBackMax(STATE), value: _swingBack(STATE) }; },
    cycleWavePosture: cycleWavePosture,
    setWaveBack:     setWaveBack,
    waveBackLabel:   waveBackLabel,
    waveBackRange:   function () { return { min: 15, max: 90, value: _waveBeta(STATE) }; },
    cycleWaveGap:    cycleWaveGap,
    waveGapLabel:    waveGapLabel,
    waveGapRange:    function () { var gp = (STATE.slatGap != null) ? STATE.slatGap : WAVE.GAP_DEF; return { min: Math.round(WAVE.GAP_MIN * 1000), max: Math.round(WAVE.GAP_MAX * 1000), value: Math.round(gp * 1000) }; },
    waveCushionOn:   function () { return _waveCushionOn(STATE); },
    swingBackLabel:  swingBackLabel,
    buildCutList:    buildCutList,   /* debug: the PDF cut list rows */
    setBackRakeDeg:  setBackRakeDeg,
    /* v265: a design as data, ?cfg= links, the reference designs, the tour */
    designPayload:   designPayload,
    applyDesign:     applyDesign,
    applyConfigId:   applyConfigId,
    productOfType:   productOfType,   /* v283 'swings' | 'benches' */
    toggleGbArms:    toggleGbArms,    /* v285 the 2x4 bench's armrests */
    cycleRtbMode:    cycleRtbMode,    /* v414 the twist bench: bench > chairs > chairs + table */
    rtbModeLabel:    rtbModeLabel,
    rtbMode:         function () { return _rtbMode(STATE); },
    _rtbLayout:      _rtbLayout,      /* v414 harness */
    _rtbDxf:         _rtbDxf,         /* v419 harness: the DXF text */
    _rtbDxfStore:    _rtbDxfStore,    /* v421 harness: the QR's link */
    _rtbNest:        _rtbNest,
    gbArmsOn:        gbArmsOn,
    toggleGsScreen:  toggleGsScreen,  /* v303 the cinema bar's screen up / down */
    gsScreenOn:      gsScreenOn,
    toggleMbRet:     toggleMbRet,     /* v355 the bar's counter: L <> straight */
    mbRetOn:         mbRetOn,
    cycleMbShape:    cycleMbShape,    /* v357 the bar: its counter L right > L left > U > I */
    mbShape:         function () { return _mbShape(STATE); },
    mbShapeLabel:    mbShapeLabel,
    cycleMbRoof:     cycleMbRoof,     /* -- its roof mono-pitch <> gable */
    mbRoof:          function () { return _mbRoof(STATE); },
    mbRoofLabel:     mbRoofLabel,
    mbPitchRange:    mbPitchRange,    /* -- its pitch on the slider (deg) */
    setMbPitch:      setMbPitch,
    toggleMbCov:     toggleMbCov,     /* -- the sheets on <> off */
    mbCov:           function () { return _mbCov(STATE); },
    mbCovLabel:      mbCovLabel,
    mbHRange:        mbHRange,        /* -- its height on the slider (mm) */
    setMbH:          setMbH,
    gsDropRange:     gsDropRange,     /* v305 the screen's drop on the slider */
    cycleRbMode:     cycleRbMode,     /* v314 the raised bed: basic > pyramid > cold frame */
    toggleRbOpen:    toggleRbOpen,    /* v314 its wings open / closed */
    toggleRbTrellis: toggleRbTrellis, /* v316 the basic bed's trellis on / off */
    rbTrellisOn:     function () { return _rbTrellis(STATE); },
    rbMode:          function () { return _rbMode(STATE); },
    rbOpenOn:        function () { return _rbOpen(STATE); },
    cycleGzN:        cycleGzN,        /* v328 the gazebo: hexagon <> square */
    cyclePeFound:    cyclePeFound,    /* v334 the pergola: ground screws > precast footings > poured footings */
    peFound:         function () { return _peFound(STATE); },
    togglePhPorch:   togglePhPorch,   /* v362 the cottage: its porch on / off */
    phPorchOn:       function () { return _phPorch(STATE); },
    togglePhSlide:   togglePhSlide,
    phRoof:          phRoof,           /* v370 the stilt house / play fort roof: 'gable' | 'mono' */
    phRoofLabel:     phRoofLabel,
    togglePhRoof:    togglePhRoof,
    coHensRange:     coHensRange,      /* v375 the backyard coop: the hens on the slider */
    setCoHens:       setCoHens,
    toggleCoRun:     toggleCoRun,      /* -- the run on the toggle */
    coRunOn:         function () { return _coRun(STATE); },
    toggleCtWheels:  toggleCtWheels,   /* v379 the chicken tractor: its wheels on the toggle */
    ctWheelsOn:      function () { return _ctWheels(STATE); },
    tfTrunkRange:    tfTrunkRange,     /* v368 the tree fort: its trunk on the slider (mm) */
    knDogRange:      knDogRange,       /* v385 the dog house: the dog's height on the slider (mm) */
    setKnDog:        setKnDog,
    _dhDims:         _dhDims,          /* v385 harness: what the dog asks for */
    knFlapOn:        knFlapOn,         /* v388 the insulated dog house: its flap on the toggle */
    toggleKnFlap:    toggleKnFlap,
    knDeckOn:        knDeckOn,         /* v403 the modern dog house: its roof deck on the toggle */
    toggleKnDeck:    toggleKnDeck,
    setTfTrunk:      setTfTrunk,
    togglePhSwings:  togglePhSwings,   /* v365 the play fort: its swings on / off */
    toggleGhKnee:    toggleGhKnee,     /* v373 the gable greenhouse: its knee wall on / off */
    ghKneeOn:        function () { return _ghKnee(STATE); },
    ghBenchOn:       function () { return _ghBenchOn(STATE); },   /* v392 */
    toggleGhBench:   toggleGhBench,
    ghFound:         function () { return _ghFound(STATE); },   /* v399 */
    cycleGhFound:    cycleGhFound,
    ghFoundLabel:    ghFoundLabel,
    ghRollOn:        function () { return _ghRoll(STATE); },   /* v381 the hoop house: its sides rolled up */
    ghWinRange:      ghWinRange,       /* v390 the old-window greenhouse: its sashes' size on the slider (an index) */
    setGhWin:        setGhWin,
    ghWinLabel:      ghWinLabel,
    toggleKpOpen:    toggleKpOpen,     /* v376 the kitchen pod: its flap open / shut */
    cycleKpBay:      cycleKpBay,       /* v379 -- a bay's + disc: its equipment */
    kpBayKinds:      kpBayKinds,
    kpOpenOn:        function () { return _kpOpen(STATE); },
    kpAng: function () { return _kpAng(STATE); }, setKpAng: setKpAng,   /* v406 the flap's slider */
    kpFrame: function () { return _kpFrame(STATE); }, kpFrameLabel: kpFrameLabel, cycleKpFrame: cycleKpFrame,
    kpLook: function () { return KP_LOOKS[_kpLookI(STATE)].id; }, kpLookLabel: kpLookLabel, kpLookLabels: function () { return KP_LOOKS.map(function (l) { return kpLookLabel(l.id); }); },   /* v412 the counter's look on the first switch */   /* v406 the counter's frame on the freed toggle */
    kpFound: function () { return _kpFound(STATE); }, kpFoundLabel: kpFoundLabel, cycleKpFound: cycleKpFound,   /* v405 the kitchen pod's foundation on the third switch */
    kpClad: function () { return _kpClad(STATE); }, kpCladLabel: kpCladLabel, cycleKpClad: cycleKpClad,          /* v405 -- its cladding on the fourth */
    kpN: kpN, cycleKpN: cycleKpN, kpNLabel: function () { return _kpIsFp(STATE) ? _gzLbl('length', 'Length') : _gzLbl('bench_kp_bays', 'Modules'); },
    kpNVal: function () { return _kpIsFp(STATE) ? fmtLen(_kpL(STATE)) + (STATE.isMetric === false ? ' ft' : ' m') : String(_kpN(STATE)); },   /* v409 the fitness: its length on the button (the number cycles it) */
    kpLad: function () { return _kpLad(STATE); },   /* v406 the number apart (a tap on it changes it) */   /* v405 the kitchen pod: its bays' number on the top switch */
    togglePhLoft:    togglePhLoft,     /* v367 the little barn: its loft on / off */   /* v363 the stilt house: its slide on / off */
    phSlideOn:       function () { return _phSlide(STATE); },
    phIsCastle:      function () { return _phIsCs(STATE); },   /* v389 the snippet's slide toggle on the castle */
    csShape: csShape, csShapeLabel: csShapeLabel, cycleCsShape: cycleCsShape, csMbOn: csMbOn, toggleCsMb: toggleCsMb,   /* v394 the castle's plan + monkey bars switches */
    csPlay: csPlay, csPlayLabel: csPlayLabel, cycleCsPlay: cycleCsPlay, csLook: csLook, csLookLabel: csLookLabel, cycleCsLook: cycleCsLook,   /* v398 the play on the toggle, the towers' look on the second switch */
    phFoundOn: phFoundOn, phFound: phFound, phFoundLabel: phFoundLabel, cyclePhFound: cyclePhFound,   /* v402 the playhouses' foundation on the last switch */
    phSwingsOn:      function () { return _pfSwings(STATE); },   /* v365 the play fort */
    phLoftOn:        function () { return _brLoft(STATE); },     /* v367 the little barn */
    peFoundLabel:    peFoundLabel,
    cyclePeRoof:     cyclePeRoof,     /* -- flat > gable > hip */
    peRoof:          function () { return _peRoof(STATE); },
    peRoofLabel:     peRoofLabel,
    cyclePeCov:      cyclePeCov,      /* -- the covering on <> off */
    peCov:           function () { return _peCov(STATE); },
    peCovLabel:      peCovLabel,
    cyclePeFill:     cyclePeFill,     /* -- horizontal > vertical > trellis */
    peFillT:         function () { return _peFillT(STATE); },
    peFillLabel:     peFillLabel,
    peGapRange:      peGapRange,      /* v337 the infill's gap, mm */
    setPeGap:        setPeGap,
    cyclePeField:    cyclePeField,    /* -- a field's + button */
    cycleGzField:    cycleGzField,    /* v350 the gazebo's side: railing <> full height */
    cycleGzFound:    cycleGzFound,    /* v329 its foundation: ground screws > precast pads > poured footings */
    gzFound:         function () { return _gzFound(STATE); },
    gzFoundLabel:    gzFoundLabel,
    cycleGzCov:      cycleGzCov,      /* v329 its covering: asphalt shingle <> standing seam */
    gzCov:           function () { return _gzCov(STATE); },
    gzCovLabel:      gzCovLabel,
    cycleGzFill:     cycleGzFill,     /* v329 its infill: 2x2 slats <> 1x4 boards */
    gzFill:          function () { return _gzFill(STATE); },
    gzFillLabel:     gzFillLabel,
    gzGapRange:      gzGapRange,      /* v329 the infill's clear gap, mm */
    setGzGap:        setGzGap,
    gzN:             function () { return _gzN(STATE); },
    cycleGaMode:     cycleGaMode,     /* v320 the garden arbor: flat <> gable roof (v331 > arch) */
    gaMode:          function () { return _gaMode(STATE); },
    cycleGaFound:    cycleGaFound,    /* v322 the garden arbor: pavers > ground screws > deck blocks */
    gaFound:         function () { return _gaFound(STATE); },
    gaFoundLabel:    gaFoundLabel,
    cycleGaGrid:     cycleGaGrid,     /* v333 the garden arbor: laths <> trellis */
    gaGrid:          function () { return _gaGrid(STATE); },
    gaGridLabel:     gaGridLabel,
    setGsDrop:       setGsDrop,
    sbAngRange:      sbAngRange,       /* v288 the sunbed's backrest on the slider */
    setSbAng:        setSbAng,
    cfgSave:         cfgSave,
    refSet:          refSet,
    refApply:        refApply,
    refVersion:      REF_V,
    variantOfType:   variantOfType,
    holdWrites:      holdWrites,
    stateSnap:       stateSnap,
    stateBack:       stateBack,
    tourState:       tourState,
    tourPlay:        function () { if (!_T.on) _tourStart(); },
    tourStop:        function () { _tourStop('stopped from outside'); }
  };

})(window);